
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("86K1L", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $751c51fa7433be2b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $dLR8J = parcelRequire("dLR8J");

var $6OSA0 = parcelRequire("6OSA0");

var $fAZgY = parcelRequire("fAZgY");

var $joCvm = parcelRequire("joCvm");

var $lFXu9 = parcelRequire("lFXu9");

var $9MITi = parcelRequire("9MITi");

var $gCY1z = parcelRequire("gCY1z");

var $7jTnu = parcelRequire("7jTnu");

var $17w9g = parcelRequire("17w9g");
const $751c51fa7433be2b$var$SpaApp = ()=>{
    const isAgentViewMounted = (0, $eJOHy.useRef)(false);
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const [issueKeysDeprecated, setIssueKeysDeprecated] = (0, $eJOHy.useState)([]);
    const [issuesCountDeprecated, setIssuesCountDeprecated] = (0, $eJOHy.useState)(0);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const issueKeys = (0, $7jTnu.fg)('jsm_queues_issuelist_store') ? (0, $17w9g.useIssueKeys)() : issueKeysDeprecated;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const issuesCount = (0, $7jTnu.fg)('jsm_queues_issuelist_store') ? (0, $17w9g.useIssueCount)() : issuesCountDeprecated;
    const setIssueKeys = (0, $7jTnu.fg)('jsm_queues_issuelist_store') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $17w9g.useSetIssueKeys)() : setIssueKeysDeprecated;
    const setIssuesCount = (0, $7jTnu.fg)('jsm_queues_issuelist_store') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $17w9g.useSetIssueCount)() : setIssuesCountDeprecated;
    const pageId = match.params.issueKey ? 'queues-issue-view' : 'queues-agent-view';
    const onIssuesChanged = (0, $fAZgY.useCallbackWithCondition)((keys)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(keys, issueKeys)) setIssueKeys(keys);
    }, [
        issueKeys,
        setIssueKeys
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const onIssuesCountChanged = (0, $fAZgY.useCallbackWithCondition)((count)=>{
        setIssuesCount(count);
    }, [
        setIssuesCount
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'));
    const issueNavigatorData = (0, $eJOHy.useMemo)(()=>{
        const { issueKey: issueKey } = match.params;
        return issueKey ? {
            issueKey: issueKey,
            issueKeys: issueKeys,
            knownIssueKeys: issueKeys.filter((key)=>!!key),
            issuesCount: issuesCount
        } : undefined;
    }, [
        issueKeys,
        issuesCount,
        match.params
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $joCvm.default), {
        pageId: pageId
    }, ({ pageContext: pageContext, queuesData: queuesData, push: push, replace: replace })=>{
        if (!pageContext) return (0, $7jTnu.fg)('add_ufo_load_hold_to_custom_queue') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "queues-app-base"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null);
        const shouldRenderAgentView = isAgentViewMounted.current || !match.params.issueKey;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, match.params.issueKey && // todo: add_ufo_load_hold_to_custom_queue. This should no longer be relavant after the split
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9MITi.default), {
            pageContext: pageContext,
            issueNavigatorData: issueNavigatorData,
            // @ts-expect-error - TS2322 - Type 'QueuesPush' is not assignable to type '(url: string) => void'.
            push: push,
            match: match
        }), shouldRenderAgentView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lFXu9.default), {
            queuesData: queuesData,
            push: push,
            // @ts-expect-error - TS2322 - Type '((path: string) => void | Promise<void>) | undefined' is not assignable to type '(path: string) => void | Promise<void>'.
            replace: replace,
            queueId: match.params.queueId || '',
            pageContext: pageContext,
            isQueueVisible: !match.params.issueKey,
            isAgentViewMountedRef: isAgentViewMounted,
            onIssuesChanged: onIssuesChanged,
            onIssuesCountChanged: onIssuesCountChanged
        }));
    });
};
var $751c51fa7433be2b$export$2e2bcd8739ae039 = $751c51fa7433be2b$var$SpaApp;

});
parcelRegister("joCvm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b26d627df121e40d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2QUmO = parcelRequire("2QUmO");

var $9I5E1 = parcelRequire("9I5E1");

var $lbm8E = parcelRequire("lbm8E");

var $df3xt = parcelRequire("df3xt");

var $3fKYX = parcelRequire("3fKYX");

var $frEjU = parcelRequire("frEjU");

var $9OCJd = parcelRequire("9OCJd");

var $9aEyh = parcelRequire("9aEyh");

var $6OSA0 = parcelRequire("6OSA0");

var $anCpx = parcelRequire("anCpx");

var $k6qAI = parcelRequire("k6qAI");

var $ljej9 = parcelRequire("ljej9");

var $akiS9 = parcelRequire("akiS9");

var $gCY1z = parcelRequire("gCY1z");

var $7jTnu = parcelRequire("7jTnu");

var $lRxpy = parcelRequire("lRxpy");

var $hih5V = parcelRequire("hih5V");

var $l3Qgv = parcelRequire("l3Qgv");

var $5SFrC = parcelRequire("5SFrC");

var $iq8v9 = parcelRequire("iq8v9");

var $230Dj = parcelRequire("230Dj");
const $b26d627df121e40d$var$QueuesAppBase = (props)=>{
    const { QueuesPushProvider: QueuesPushProvider, pageId: pageId } = props;
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    const currentRoute = (0, $hih5V.useCurrentRoute)();
    const [{ data: pageContextData, error: error }] = (0, $9OCJd.usePageContext)();
    const { tenantContext: tenantContext, projectContext: projectContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
    const { projectName: projectName } = projectContext || {};
    const pageContextProps = (0, $eJOHy.useMemo)(()=>({
            ...tenantContext,
            ...projectContext,
            ...serviceDeskContext
        }), [
        projectContext,
        serviceDeskContext,
        tenantContext
    ]);
    const projectKey = (0, $ljej9.toProjectKey)(match.params.projectKey || '');
    const practice = (0, $k6qAI.toItsmPractice)(match.params.practiceType);
    const [categorizedQueues, categorizedQueuesLoading, categorizedError, methods] = (0, $3fKYX.useCategorizedQueues)(projectKey, practice);
    let selectedQueueName;
    if (categorizedQueues && match.params.queueId) {
        const selectedQueue = categorizedQueues.find((queue)=>queue.id === Number(match.params.queueId));
        selectedQueueName = selectedQueue ? selectedQueue.name : undefined;
    }
    (0, $iq8v9.useOnFavoritesChanged)(projectKey, practice, categorizedQueues, methods.editItemFavorite);
    const { shouldUseStylingPatch: shouldShowContainer } = (0, $lRxpy.useStylingPatch)();
    const isLoading = !pageContextData && !error || categorizedQueuesLoading;
    const isNewQueuePage = currentRoute.name === (0, $l3Qgv.servicedeskQueuesNewRoute).name || currentRoute.name === (0, $5SFrC.servicedeskPracticeNewRoute).name;
    let subSectionName = selectedQueueName;
    if (isNewQueuePage && (0, $7jTnu.fg)('jsm_queue_a11y_improvement_batch2')) subSectionName = 'New Queue';
    const queuesData = (0, $eJOHy.useMemo)(()=>({
            data: (0, $230Dj.pageToQueues)(categorizedQueues || []),
            error: categorizedError ? categorizedError.message : undefined,
            loading: categorizedQueuesLoading
        }), [
        categorizedError,
        categorizedQueues,
        categorizedQueuesLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akiS9.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9aEyh.SpaPageWrapper), {
        pageId: pageId,
        currentUrl: match.url,
        // @ts-expect-error - TS2322 - Type '{ projectId: number; projectKey: string; projectName: string; projectType: ProjectType; isAdmin: boolean; isProjectSimplified: boolean; } | undefined' is not assignable to type 'ProjectContext | null | undefined'.
        projectContext: projectContext,
        isLoading: (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? !shouldShowContainer && isLoading : isLoading,
        error: error
    }, isLoading && shouldShowContainer && (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRxpy.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(QueuesPushProvider, {
        projectKey: projectKey
    }, ({ push: push, replace: providerReplace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $frEjU.ServiceDeskDocumentTitle), {
            // @ts-expect-error - TS2322 - Type '{ projectName: string | undefined; section: string; }' is not assignable to type 'IntrinsicAttributes & Diff<(Diff<RefAttributes<any> | (RefAttributes<any> & { children?: ReactNode; }), Partial<RefAttributes<...> | (RefAttributes<...> & { ...; })>> & RefAttributes<...>) | (Diff<...> & ... 1 more ... & { ...; }), InjectIntlVoidProps> & { ...; }'.
            projectName: projectName,
            section: "queues",
            subsection: subSectionName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children({
            push: push,
            match: match,
            replace: providerReplace,
            queuesData: (0, $7jTnu.fg)('jfp_magma_jsm-perf-improvement-batch-1') ? queuesData : {
                data: (0, $230Dj.pageToQueues)(categorizedQueues || []),
                error: categorizedError ? categorizedError.message : undefined,
                loading: categorizedQueuesLoading
            },
            category: practice,
            // @ts-expect-error - TS2322 - Type '{ portalId?: number | undefined; canSeeNewIssueView?: boolean | undefined; userRole?: string | undefined; serviceDeskId?: number | undefined; projectId?: number | undefined; projectKey?: string | undefined; ... 11 more ...; isSiteAdmin?: boolean | undefined; }' is not assignable to type 'PageProps'.
            pageContext: pageContextProps
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9I5E1.JsdGettingStartedPanelShouldRender), null));
};
var $b26d627df121e40d$export$2e2bcd8739ae039 = (0, $2QUmO.default)($b26d627df121e40d$var$QueuesAppBase, {
    QueueProvider: (0, $df3xt.default),
    QueuesApiDataProvider: (0, $lbm8E.default),
    QueuesPushProvider: (0, $anCpx.default)
});

});
parcelRegister("9I5E1", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $9f17996c86676e6c$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $9f17996c86676e6c$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $9f17996c86676e6c$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $9f17996c86676e6c$export$c7732c55900cf0b9);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9f17996c86676e6c$var$AsyncGettingStartedPanelShouldRender = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("bLdKk")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9f17996c86676e6c$var$AsyncGettingStartedPanel = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("hCk03")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9f17996c86676e6c$var$AsyncGettingStartedPanelOpenButton = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("jLP9z")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9f17996c86676e6c$var$AsyncGettingStartedPanelReopenSpotlight = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("fC6T1")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $9f17996c86676e6c$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f17996c86676e6c$var$AsyncGettingStartedPanelShouldRender, null));
$9f17996c86676e6c$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $9f17996c86676e6c$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f17996c86676e6c$var$AsyncGettingStartedPanel, null));
$9f17996c86676e6c$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $9f17996c86676e6c$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f17996c86676e6c$var$AsyncGettingStartedPanelOpenButton, null));
$9f17996c86676e6c$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $9f17996c86676e6c$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9f17996c86676e6c$var$AsyncGettingStartedPanelReopenSpotlight, null));
$9f17996c86676e6c$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("bLdKk", function(module, exports) {

let $88febf395a7e8ddd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $88febf395a7e8ddd$var$load("kVX56"),
    $88febf395a7e8ddd$var$load("8OOe7")
]).then(()=>parcelRequire('5UcAl'));

});

parcelRegister("hCk03", function(module, exports) {

let $cd357fd1872e43f4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $cd357fd1872e43f4$var$load("kVX56"),
    $cd357fd1872e43f4$var$load("76n7a"),
    $cd357fd1872e43f4$var$load("l253H"),
    $cd357fd1872e43f4$var$load("8YM4r")
]).then(()=>parcelRequire('6tZJD'));

});

parcelRegister("jLP9z", function(module, exports) {

let $e64a1613f30ff439$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e64a1613f30ff439$var$load("kVX56"),
    $e64a1613f30ff439$var$load("76n7a"),
    $e64a1613f30ff439$var$load("l253H"),
    $e64a1613f30ff439$var$load("izzmP")
]).then(()=>parcelRequire('8IDjP'));

});

parcelRegister("fC6T1", function(module, exports) {

let $b5dfbf1e3bde3399$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $b5dfbf1e3bde3399$var$load("kVX56"),
    $b5dfbf1e3bde3399$var$load("76n7a"),
    $b5dfbf1e3bde3399$var$load("l253H"),
    $b5dfbf1e3bde3399$var$load("caLxL")
]).then(()=>parcelRequire('c2Xzs'));

});


parcelRegister("lbm8E", function(module, exports) {

$parcel$export(module.exports, "AvailableQueuesConsumer", () => $6494eb74026689da$export$dfebed0fc9519fcc);
$parcel$export(module.exports, "default", () => $6494eb74026689da$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $12DRg = parcelRequire("12DRg");

var $5SwkH = parcelRequire("5SwkH");

var $2IsS5 = parcelRequire("2IsS5");

var $eOMQr = parcelRequire("eOMQr");

var $eDWlr = parcelRequire("eDWlr");

var $3OuNJ = parcelRequire("3OuNJ");
const $6494eb74026689da$var$LAST_VISITED_QUEUE_KEY_PREFIX = 'last_visited_queue';
// @ts-expect-error - TS2322 - Type 'Context<{ setFavorite: (...args: any[]) => void; deleteNavItem: (...args: any[]) => void; updateIssueCount: (...args: any[]) => void; markNavItemsAsStale: (...args: any[]) => void; getQueueCount: (...args: any[]) => void; setLastVisitedQueueId: (...args: any[]) => void; getLastVisitedQueueId: (...args: any[]) => voi...' is not assignable to type 'Context<QueuesContextType>'.
const $6494eb74026689da$var$AvailableQueuesContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    setFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    deleteNavItem: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    updateIssueCount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    markNavItemsAsStale: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    getQueueCount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    setLastVisitedQueueId: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    getLastVisitedQueueId: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});
const { Provider: $6494eb74026689da$var$Provider, Consumer: $6494eb74026689da$export$dfebed0fc9519fcc } = $6494eb74026689da$var$AvailableQueuesContext;
class $6494eb74026689da$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            FavoriteSubscriber: (0, $eDWlr.default),
            queuesPrefetchData: [],
            push: undefined,
            onDeleteNavItem: undefined
        };
    }
    constructor(props){
        const { onNavUpdated: onNavUpdated, onIssueCountUpdated: onIssueCountUpdated, queuesPrefetchData: queuesPrefetchData, push: push } = props;
        super(props), this.getQueueCount = ()=>{
            const { data: data } = this.state;
            return data ? Object.keys(data).filter((queueId)=>!this.deletedQueueIds.has((0, $2IsS5.toQueueIdString)(queueId))).length : 0;
        }, this.getLastVisitedQueueId = (projectKey)=>{
            const { category: category } = this.props;
            if (!projectKey) return null;
            try {
                if (category) return (0, $eOMQr.getFromLocalStorage)(`${$6494eb74026689da$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`);
                return (0, $eOMQr.getFromLocalStorage)(`${$6494eb74026689da$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                return null;
            }
        }, this.setFavorite = (queueId, newValue)=>{
            const { FavoriteSubscriber: FavoriteSubscriber } = this.props;
            FavoriteSubscriber.setFavorite(queueId, newValue);
        }, this.setLastVisitedQueueId = (queueId, projectKey)=>{
            const lastVisitedQueueId = this.getLastVisitedQueueId(projectKey);
            const { category: category } = this.props;
            // @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'string | null | undefined' and 'number' have no overlap.
            if (projectKey && lastVisitedQueueId !== queueId) try {
                if (category) (0, $eOMQr.setInLocalStorage)(`${$6494eb74026689da$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`, (0, $2IsS5.fromQueueIdString)(queueId));
                else (0, $eOMQr.setInLocalStorage)(`${$6494eb74026689da$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}`, (0, $2IsS5.fromQueueIdString)(queueId));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
            // Don't care if it fails. Default behavior in QueuesRedirect will take users to first available queue.
            }
        };
        this.queuesContext = {
            deleteNavItem: this.deleteNavItem(push),
            updateIssueCount: onIssueCountUpdated,
            markNavItemsAsStale: ()=>onNavUpdated(false),
            setFavorite: this.setFavorite,
            getQueueCount: this.getQueueCount,
            setLastVisitedQueueId: this.setLastVisitedQueueId,
            getLastVisitedQueueId: this.getLastVisitedQueueId
        };
        this.deletedQueueIds = new Set();
        this.state = {
            loading: false,
            error: undefined,
            data: queuesPrefetchData.length ? (0, $3OuNJ.pageToQueues)(queuesPrefetchData) : undefined
        };
    }
    static getDerivedStateFromProps(props, state) {
        const { queuesPrefetchData: queuesPrefetchData } = props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))((0, $3OuNJ.pageToQueues)(queuesPrefetchData), state.data) && queuesPrefetchData.length) return {
            data: (0, $3OuNJ.pageToQueues)(queuesPrefetchData)
        };
        return null;
    }
    componentWillUnmount() {
        const { fetchSubscription: fetchSubscription, deleteItemSubscription: deleteItemSubscription } = this;
        fetchSubscription && fetchSubscription.unsubscribe();
        deleteItemSubscription && deleteItemSubscription.unsubscribe();
    }
    deleteNavItem(push) {
        return (queueId)=>{
            const { onDeleteNavItem: onDeleteNavItem } = this.props;
            onDeleteNavItem && onDeleteNavItem((0, $2IsS5.fromQueueIdString)(queueId));
            // update queue counts to reflect the deletion
            // note that deleteQueueFromSidebar is called after the delete endpoint returns success
            const updatedQueues = {
                ...this.state.data
            };
            delete updatedQueues[(0, $2IsS5.fromQueueIdString)(queueId)];
            const deletedLastQueue = Object.keys(updatedQueues).length === 0;
            if (deletedLastQueue) push && push(`${(0, $5SwkH.getQueueFragment)()}/custom/new`);
            else push && push((0, $5SwkH.getQueueFragment)());
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6494eb74026689da$var$Provider, {
            value: this.queuesContext
        }, this.props.children(this.state));
    }
}

});
parcelRegister("5SwkH", function(module, exports) {

$parcel$export(module.exports, "QUEUE_ROUTES", () => $f69cc1f14172fd66$export$410a6306dae101ca);
$parcel$export(module.exports, "navigate", () => $f69cc1f14172fd66$export$ff7962acd6052c28);
$parcel$export(module.exports, "getQueueFragment", () => $f69cc1f14172fd66$export$954f428fa284c7);
$parcel$export(module.exports, "getEditQueueFragment", () => $f69cc1f14172fd66$export$86f6a6d69e87f843);
$parcel$export(module.exports, "getCloneQueueFragment", () => $f69cc1f14172fd66$export$7a487d215c9c3f76);
$parcel$export(module.exports, "getQueueIssueFragment", () => $f69cc1f14172fd66$export$773cefb51b60b161);
$parcel$export(module.exports, "getIssueFragment", () => $f69cc1f14172fd66$export$a796bfaff67c9fae);
$parcel$export(module.exports, "getQueueUrl", () => $f69cc1f14172fd66$export$a29b42a005fecf0);
$parcel$export(module.exports, "getEditQueueUrlFromManageQueue", () => $f69cc1f14172fd66$export$91152835d12ca65f);

var $7kixv = parcelRequire("7kixv");
parcelRequire("1AyD5");
parcelRequire("cBiei");
parcelRequire("6cJUr");
parcelRequire("c1D7V");

var $87DsC = parcelRequire("87DsC");

var $jlJsl = parcelRequire("jlJsl");

var $3TivI = parcelRequire("3TivI");
const $f69cc1f14172fd66$var$LOCATION = 'servicedesk.common.navigation.queues';
let $f69cc1f14172fd66$var$navigatorPromise;
const $f69cc1f14172fd66$var$getPushStateNavigator = ()=>{
    if (!$f69cc1f14172fd66$var$navigatorPromise) $f69cc1f14172fd66$var$navigatorPromise = (0, $3TivI.createPushStateNavigator)();
    return $f69cc1f14172fd66$var$navigatorPromise;
};
const $f69cc1f14172fd66$export$410a6306dae101ca = {
    [(0, $jlJsl.INCIDENTS)]: 'section/incidents',
    [(0, $jlJsl.CHANGES)]: 'section/changes',
    [(0, $jlJsl.SERVICE_REQUEST)]: 'section/service-requests',
    [(0, $jlJsl.PROBLEMS)]: 'section/problems',
    [(0, $jlJsl.POST_INCIDENT_REVIEWS)]: 'section/post-incident-reviews',
    [(0, $jlJsl.NO_CATEGORY)]: 'queues'
};
const $f69cc1f14172fd66$var$fromCategory = (category)=>$f69cc1f14172fd66$export$410a6306dae101ca[category || (0, $jlJsl.NO_CATEGORY)];
const $f69cc1f14172fd66$export$ff7962acd6052c28 = (projectKey, fragment)=>{
    (0, $87DsC.emitSignal)($f69cc1f14172fd66$var$LOCATION, {
        projectKey: projectKey,
        fragment: fragment
    });
    return (0, $7kixv.Observable).fromPromise($f69cc1f14172fd66$var$getPushStateNavigator()).mergeMap((pushStateNavigator)=>{
        pushStateNavigator.navigateToFragment(fragment);
        return (0, $7kixv.Observable).empty();
    }).catch(()=>(0, $7kixv.Observable).empty());
};
const $f69cc1f14172fd66$export$954f428fa284c7 = (queueId, category)=>{
    const categoryString = $f69cc1f14172fd66$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/${queueId}` : `${categoryString}`;
};
const $f69cc1f14172fd66$export$86f6a6d69e87f843 = (queueId, category)=>`${$f69cc1f14172fd66$export$954f428fa284c7(queueId, category)}/edit`;
const $f69cc1f14172fd66$export$7a487d215c9c3f76 = (queueId, category)=>{
    const categoryString = $f69cc1f14172fd66$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/new?parentId=${queueId}` : `${categoryString}/custom/new`;
};
const $f69cc1f14172fd66$export$773cefb51b60b161 = (queueId, issueKey, category)=>`${$f69cc1f14172fd66$export$954f428fa284c7(queueId, category)}/${issueKey}`;
const $f69cc1f14172fd66$export$a796bfaff67c9fae = (issueKey)=>`${$f69cc1f14172fd66$export$954f428fa284c7()}/issue/${issueKey}`;
const $f69cc1f14172fd66$export$a29b42a005fecf0 = ({ projectKey: projectKey, category: category, queueId: queueId, queryParams: queryParams })=>{
    const urlSearchParams = new URLSearchParams();
    if (queryParams) Object.entries(queryParams).forEach(([key, value])=>{
        urlSearchParams.set(key, value);
    });
    const formattedQueryParams = urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '';
    return `/jira/servicedesk/projects/${projectKey}/${$f69cc1f14172fd66$export$954f428fa284c7(queueId, category)}${formattedQueryParams}`;
};
const $f69cc1f14172fd66$export$91152835d12ca65f = (queueId, projectKey, category)=>`/jira/servicedesk/projects/${projectKey}/${$f69cc1f14172fd66$export$86f6a6d69e87f843(queueId, category)}`;

});
parcelRegister("87DsC", function(module, exports) {

$parcel$export(module.exports, "emitSignal", () => $15578291190000bc$export$a8a72bca1918549c);
/**
 * A signalling mechanism for Cypress tests.
 *
 * This acts as a bridge between the storybook application and cypress for
 * checking behaviours which cannot be asserted on via the DOM or are
 * otherwise not reflected in application state.
 *
 * This is the 'emit' side of the story. It should be used by
 * production-facing code to emit a signal.
 */ const $15578291190000bc$var$isProduction = ()=>true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $15578291190000bc$var$registerSignal = (signal, meta)=>{
    window.cySignals.allSignals.push(signal);
    const signalsByName = window.cySignals.signalsByName;
    if (signalsByName[signal]) signalsByName[signal].push(meta);
    else signalsByName[signal] = [
        meta
    ];
};
const $15578291190000bc$var$initCySignals = ()=>{
    window.cySignals = {
        signalsByName: {},
        allSignals: []
    };
};
const $15578291190000bc$export$a8a72bca1918549c = (signal, meta = {})=>{
    if ($15578291190000bc$var$isProduction()) return;
    if (!window.cySignals) $15578291190000bc$var$initCySignals();
    $15578291190000bc$var$registerSignal(signal, meta);
};

});

parcelRegister("3TivI", function(module, exports) {

$parcel$export(module.exports, "createPushStateNavigator", () => $27fedfefc1b80d24$export$d3bf579f8e5cd838);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");
const $27fedfefc1b80d24$var$PUSH_STATE_NAVIGATOR_MODULE = 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator';
// Try to require push-state-navigator over 500ms, otherwise we'll fallback.
const $27fedfefc1b80d24$var$REQUIRE_TIMEOUT = 100;
const $27fedfefc1b80d24$var$REQUIRE_RETRIES = 5;
const $27fedfefc1b80d24$export$d3bf579f8e5cd838 = ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $gjeS9.loadBridge)({
        name: $27fedfefc1b80d24$var$PUSH_STATE_NAVIGATOR_MODULE,
        timeout: $27fedfefc1b80d24$var$REQUIRE_TIMEOUT,
        tentatives: $27fedfefc1b80d24$var$REQUIRE_RETRIES
    });

});


parcelRegister("2IsS5", function(module, exports) {

$parcel$export(module.exports, "toQueueId", () => $dec4cd22dbad474c$export$dae52b119ebf2444);
$parcel$export(module.exports, "fromQueueId", () => $dec4cd22dbad474c$export$999de35c9ca8105b);
$parcel$export(module.exports, "toQueueIdString", () => $dec4cd22dbad474c$export$cda0e35414946580);
$parcel$export(module.exports, "fromQueueIdString", () => $dec4cd22dbad474c$export$cde8da12f845d56f);
$parcel$export(module.exports, "LOCAL_STORAGE_SOURCE", () => $dec4cd22dbad474c$export$6e21137db7aec966);
$parcel$export(module.exports, "PREFETCHER_SOURCE", () => $dec4cd22dbad474c$export$ce13a6c409c4db7d);
$parcel$export(module.exports, "REST_SOURCE", () => $dec4cd22dbad474c$export$e85fb1a0846db30f);
$parcel$export(module.exports, "SSR_SOURCE", () => $dec4cd22dbad474c$export$c5c05bf31a872c73);
const $dec4cd22dbad474c$export$dae52b119ebf2444 = (queueId)=>queueId;
const $dec4cd22dbad474c$export$999de35c9ca8105b = (queueId)=>queueId;
const $dec4cd22dbad474c$export$cda0e35414946580 = (queueId)=>$dec4cd22dbad474c$export$dae52b119ebf2444(Number(queueId));
const $dec4cd22dbad474c$export$cde8da12f845d56f = (queueId)=>$dec4cd22dbad474c$export$999de35c9ca8105b(queueId).toString();
const $dec4cd22dbad474c$export$6e21137db7aec966 = 'LOCAL_STORAGE';
const $dec4cd22dbad474c$export$ce13a6c409c4db7d = 'PREFETCHER';
const $dec4cd22dbad474c$export$e85fb1a0846db30f = 'REST';
const $dec4cd22dbad474c$export$c5c05bf31a872c73 = 'SSR';

});

parcelRegister("eOMQr", function(module, exports) {

$parcel$export(module.exports, "getFromLocalStorage", () => $b5190555285b825d$export$602bc7b349337fec);
$parcel$export(module.exports, "setInLocalStorage", () => $b5190555285b825d$export$e7b9840f77b6b2a4);

var $dnU6V = parcelRequire("dnU6V");

var $ajASe = parcelRequire("ajASe");
const $b5190555285b825d$export$f016358f0af18fa0 = (0, $dnU6V.createLocalExpirableStorageProvider)('servicedesk_queues');
const $b5190555285b825d$var$TIME_BEFORE_EXPIRY = 1209600000; // 14 days
const $b5190555285b825d$export$602bc7b349337fec = (key)=>{
    try {
        return $b5190555285b825d$export$f016358f0af18fa0.get(key);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        // .get() can trigger an exception due to a bug in 'storejs', where if
        // LS is not able to be read or written, it will not initialise the store.
        (0, $ajASe.default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.services', 'Local storage failure on read');
        return null;
    }
};
const $b5190555285b825d$export$e7b9840f77b6b2a4 = (key, value)=>{
    try {
        const now = Date.now();
        $b5190555285b825d$export$f016358f0af18fa0.set(key, value, now + $b5190555285b825d$var$TIME_BEFORE_EXPIRY);
        $b5190555285b825d$export$f016358f0af18fa0.removeExpiredKeys();
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        (0, $ajASe.default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.services', 'Local storage failure');
        return false;
    }
};

});
parcelRegister("ajASe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c2abcca194b2f93$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");
const $0c2abcca194b2f93$var$PREFIX = '[Queues]';
/** This function logs privacy safe error.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0c2abcca194b2f93$var$safeErrorWithoutCustomerData = (location, message, event)=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData(location, `${$0c2abcca194b2f93$var$PREFIX} ${message}`, event);
};
/** This function logs privacy safe warning.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0c2abcca194b2f93$var$safeWarnWithoutCustomerData = (location, message, event)=>{
    (0, $eSnSE.default).safeWarnWithoutCustomerData(location, `${$0c2abcca194b2f93$var$PREFIX} ${message}`, event);
};
/** This function logs privacy safe info.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0c2abcca194b2f93$var$safeInfoWithoutCustomerData = (location, message, event)=>{
    (0, $eSnSE.default).safeInfoWithoutCustomerData(location, `${$0c2abcca194b2f93$var$PREFIX} ${message}`, event);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0c2abcca194b2f93$export$2e2bcd8739ae039 = {
    safeInfoWithoutCustomerData: $0c2abcca194b2f93$var$safeInfoWithoutCustomerData,
    safeWarnWithoutCustomerData: $0c2abcca194b2f93$var$safeWarnWithoutCustomerData,
    safeErrorWithoutCustomerData: $0c2abcca194b2f93$var$safeErrorWithoutCustomerData
};

});


parcelRegister("eDWlr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4bb861b5a805061$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aMJA4 = parcelRequire("aMJA4");

var $2IsS5 = parcelRequire("2IsS5");
class $e4bb861b5a805061$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    static setFavorite() {}
    render() {
        return null;
    }
    constructor(...args){
        super(...args), this.onFavoritesChanged = (items)=>{
            const queueItemsObj = items[0, $aMJA4.QUEUES_ITEM_TYPE];
            if (!queueItemsObj) return;
            // Object.values gives Array<mixed> according to Flow, which is wrong.
            // https://github.com/facebook/flow/issues/2221
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const queueItems = Object.values(queueItemsObj);
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            queueItems.forEach((item)=>this.props.onFavoriteItemChanged((0, $2IsS5.toQueueIdString)(item.id), item.value));
        };
    }
}

});

parcelRegister("3OuNJ", function(module, exports) {

$parcel$export(module.exports, "pageToQueues", () => $00b3e571f2bc9a01$export$8ada91ce992fa66f);

var $7kixv = parcelRequire("7kixv");
parcelRequire("9BkTq");
parcelRequire("6cJUr");

var $2IsS5 = parcelRequire("2IsS5");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$00b3e571f2bc9a01$export$2e2bcd8739ae039 = (rest, transformFunc)=>rest.mergeMap((payload)=>(0, $7kixv.Observable).of(transformFunc(payload)));
const $00b3e571f2bc9a01$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.title,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $00b3e571f2bc9a01$export$8ada91ce992fa66f = (page)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    page.reduce((acc, queue)=>{
        acc[queue.id] = {
            id: (0, $2IsS5.toQueueId)(queue.id),
            name: queue.name,
            jql: queue.jql,
            completeJql: queue.completeJql,
            order: queue.order,
            columns: $00b3e571f2bc9a01$var$transformColumns(queue.columnsDetails),
            // British spelling from legacy Backend code
            isFavorite: queue.favourite,
            category: queue.category,
            canBeHidden: queue.canBeHidden
        };
        return acc;
    }, {});
const $00b3e571f2bc9a01$export$9fd203f323102996 = (prefetchData, queues)=>{
    if (queues === undefined) return [];
    // @ts-expect-error - TS2322 - Type '{ favourite: boolean; columns: string[]; columnsDetails: { title: string; fieldType: string; sortable: boolean; fieldId: string; sortOrder: SortOrder | undefined; }[]; id: number; name: string; ... 8 more ...; shouldSkipIssueCountRefresh?: boolean | undefined; }[]' is not assignable to type 'Page[]'.
    return Object.keys(queues).map((queueId)=>{
        const updatedQueue = queues[queueId];
        const { isFavorite: isFavorite, columns: columns, isTransient: isTransient, ...queuesData } = updatedQueue;
        const cachedPage = prefetchData.find((q)=>String(q.id) === queueId);
        return {
            ...cachedPage,
            ...queuesData,
            favourite: isFavorite,
            columns: columns.map(({ id: id })=>id),
            columnsDetails: columns.map(({ id: id, currentSorting: currentSorting, ...remaining })=>({
                    fieldId: id,
                    sortOrder: currentSorting,
                    ...remaining
                }))
        };
    });
};
const $00b3e571f2bc9a01$export$4906aa3ec3919ad9 = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES && window.JSD_QUEUES_PRELOAD_PROMISES.queues;
const $00b3e571f2bc9a01$export$17bdd949b6a9952 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JSD_QUEUES_PRELOAD_PROMISES) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES.queues = undefined;
};

});


parcelRegister("df3xt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a31808345f4a076$export$2e2bcd8739ae039);

var $6YFG2 = parcelRequire("6YFG2");

var $j712S = parcelRequire("j712S");
var $7a31808345f4a076$export$2e2bcd8739ae039 = (0, $6YFG2.default)((0, $j712S.default));

});
parcelRegister("j712S", function(module, exports) {

$parcel$export(module.exports, "default", () => $f32c576934a64cba$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $iWqim = parcelRequire("iWqim");

var $1sChl = parcelRequire("1sChl");

var $foigc = parcelRequire("foigc");

var $lLuCY = parcelRequire("lLuCY");

var $89UFf = parcelRequire("89UFf");
const $f32c576934a64cba$var$findQueue = (source, id)=>(0, $iWqim.getIn)(source, [
        'data',
        id
    ]);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f32c576934a64cba$export$2e2bcd8739ae039 = ({ queueId: queueId, queuesDataSource: queuesDataSource, projectKey: projectKey, children: children, intl: { formatMessage: formatMessage } })=>{
    const lastUnfoundQueue = (0, $eJOHy.useRef)('');
    if (queuesDataSource.loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $foigc.default), null);
    const queue = $f32c576934a64cba$var$findQueue(queuesDataSource, queueId);
    if (queue) {
        lastUnfoundQueue.current = '';
        (0, $lLuCY.setLastVisitedQueueIdAndCategory)(queue.id, projectKey, queue.category);
        return children(queue);
    }
    if (lastUnfoundQueue.current === queueId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1sChl.default), {
        header: formatMessage((0, $89UFf.default).notFoundHeader),
        description: formatMessage((0, $89UFf.default).notFoundDescription),
        onRetry: ()=>{
            // If data source errors out let user retry the current page they are on.
            // Otherwise queue doesn't exist so go back to /queues
            if (queuesDataSource.error) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.reload();
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.assign(`/jira/servicedesk/projects/${projectKey}/queues`);
        }
    });
    lastUnfoundQueue.current = queueId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $foigc.default), null);
};

});
parcelRegister("1sChl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bf0f4be8561750a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $idGBm = parcelRequire("idGBm");

var $jiDI0 = parcelRequire("jiDI0");

var $bxoX3 = parcelRequire("bxoX3");

var $iAkRR = parcelRequire("iAkRR");
function $6bf0f4be8561750a$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($jiDI0))) : (0, (/*@__PURE__*/$parcel$interopDefault($bxoX3)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$6bf0f4be8561750a$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $iAkRR.default).retry
};
var $6bf0f4be8561750a$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($6bf0f4be8561750a$export$edf27be85e5f6da0);

});
parcelRegister("jiDI0", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("bxoX3", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("iAkRR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf64bf54453c0d07$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cf64bf54453c0d07$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("foigc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2e406fc2f40e0cc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");
// No delay on this spinner; we don't know if the monolith had previously
// provided one. Better to increase risk a very brief display of a spinner
// than have the spinner vanish and return.
const $f2e406fc2f40e0cc$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f2e406fc2f40e0cc$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large",
        testId: "servicedesk-common.ui.components.page-spinner.spinner"
    }));
var $f2e406fc2f40e0cc$export$2e2bcd8739ae039 = $f2e406fc2f40e0cc$var$LoadingSpinner;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2e406fc2f40e0cc$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _154i1jfw _1bsb1osq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lLuCY", function(module, exports) {

$parcel$export(module.exports, "getLastVisitedQueueIdAndCategory", () => $d7c3a4626b2e79b4$export$b5b4407b2529d2c4);
$parcel$export(module.exports, "setLastVisitedQueueIdAndCategory", () => $d7c3a4626b2e79b4$export$947aff127337ffa5);

var $8dH3d = parcelRequire("8dH3d");

var $2IsS5 = parcelRequire("2IsS5");

var $eOMQr = parcelRequire("eOMQr");

var $jlJsl = parcelRequire("jlJsl");

var $k6qAI = parcelRequire("k6qAI");
const $d7c3a4626b2e79b4$var$LAST_VISITED_QUEUE_KEY_PREFIX = 'last_visited_queue';
const $d7c3a4626b2e79b4$var$LAST_VISITED_CATEGORY_KEY_PREFIX = 'last_visited_category';
const $d7c3a4626b2e79b4$export$b5b4407b2529d2c4 = (projectKey, category = (0, $jlJsl.NO_CATEGORY))=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(projectKey)) return [
        null,
        null
    ];
    try {
        if (category === (0, $jlJsl.NO_CATEGORY)) {
            // indicates a redirect from /queues endpoint
            const categoryToRedirectTo = (0, $eOMQr.getFromLocalStorage)(`${$d7c3a4626b2e79b4$var$LAST_VISITED_CATEGORY_KEY_PREFIX}_${projectKey}`);
            const queueId = (0, $eOMQr.getFromLocalStorage)(`${$d7c3a4626b2e79b4$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${categoryToRedirectTo}`);
            return [
                queueId,
                ...(0, $k6qAI.isValidItsmPractice)(categoryToRedirectTo) ? [
                    categoryToRedirectTo
                ] : [
                    (0, $jlJsl.NO_CATEGORY)
                ]
            ];
        }
        return [
            (0, $eOMQr.getFromLocalStorage)(`${$d7c3a4626b2e79b4$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`),
            category
        ];
    } catch (error) {
        return [
            null,
            null
        ];
    }
};
const $d7c3a4626b2e79b4$export$947aff127337ffa5 = (queueId, projectKey, category = (0, $jlJsl.NO_CATEGORY))=>{
    let lastVisitedQueueId;
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(projectKey)) throw new Error('project key is empty');
        lastVisitedQueueId = (0, $eOMQr.getFromLocalStorage)(`${$d7c3a4626b2e79b4$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`);
    } catch (error) {
        lastVisitedQueueId = null;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(projectKey) && lastVisitedQueueId !== queueId) try {
        (0, $eOMQr.setInLocalStorage)(`${$d7c3a4626b2e79b4$var$LAST_VISITED_QUEUE_KEY_PREFIX}_${projectKey}_${category}`, (0, $2IsS5.fromQueueIdString)(queueId));
        (0, $eOMQr.setInLocalStorage)(`${$d7c3a4626b2e79b4$var$LAST_VISITED_CATEGORY_KEY_PREFIX}_${projectKey}`, category);
    } catch (error) {
    // Don't care if it fails. Default behavior in QueuesRedirect will take users to first available queue.
    }
};

});
parcelRegister("k6qAI", function(module, exports) {

$parcel$export(module.exports, "toItsmPractice", () => $c748b34b564c52e0$export$1b27246f3c7494c);
$parcel$export(module.exports, "isValidItsmPractice", () => $c748b34b564c52e0$export$357b94e419749e3d);

var $jlJsl = parcelRequire("jlJsl");
const $c748b34b564c52e0$export$1b27246f3c7494c = (practiceString)=>{
    switch(practiceString){
        case 'incidents':
            return 0, $jlJsl.INCIDENTS;
        case 'changes':
            return 0, $jlJsl.CHANGES;
        case 'service-requests':
            return 0, $jlJsl.SERVICE_REQUEST;
        case 'problems':
            return 0, $jlJsl.PROBLEMS;
        case 'post-incident-reviews':
            return 0, $jlJsl.POST_INCIDENT_REVIEWS;
        default:
            return 0, $jlJsl.NO_CATEGORY;
    }
};
const $c748b34b564c52e0$export$357b94e419749e3d = (practiceString)=>{
    switch(practiceString){
        case 0, $jlJsl.INCIDENTS:
        case 0, $jlJsl.CHANGES:
        case 0, $jlJsl.SERVICE_REQUEST:
        case 0, $jlJsl.PROBLEMS:
        case 0, $jlJsl.POST_INCIDENT_REVIEWS:
        case 0, $jlJsl.NO_CATEGORY:
            return true;
        default:
            return false;
    }
};

});


parcelRegister("89UFf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d5b4ea312f16379$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9d5b4ea312f16379$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    notFoundHeader: {
        "id": "servicedesk-queues-available-queues-api.queue-provider.not-found-header",
        "defaultMessage": "We couldn't find your queue"
    },
    notFoundDescription: {
        "id": "servicedesk-queues-available-queues-api.queue-provider.not-found-description",
        "defaultMessage": "Looks like we\u2019re having trouble connecting, or it may have been removed."
    }
});

});



parcelRegister("3fKYX", function(module, exports) {

$parcel$export(module.exports, "useCategorizedNavItems", () => $00914e36c13c7a02$export$fec6561bcaa1c55b);
$parcel$export(module.exports, "useCurrentCategorizedNavItems", () => $00914e36c13c7a02$export$f9b7a4e20c09f3ce);
$parcel$export(module.exports, "useCategorizedQueues", () => $00914e36c13c7a02$export$c4ca47ba8c81dba6);
$parcel$export(module.exports, "useFavouriteNavItems", () => $00914e36c13c7a02$export$e27d61833d43b175);
$parcel$export(module.exports, "usePracticeMetadata", () => $00914e36c13c7a02$export$f857eeb50ae9b1b2);
$parcel$export(module.exports, "usePracticeList", () => $00914e36c13c7a02$export$216a9245ead6e18a);
$parcel$export(module.exports, "CategorizedQueuesStore", () => $00914e36c13c7a02$export$5577ca8a6b2fed3c);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $aGQ56 = parcelRequire("aGQ56");

var $jlJsl = parcelRequire("jlJsl");

var $jEt3L = parcelRequire("jEt3L");

var $2b3mN = parcelRequire("2b3mN");

var $epLTS = parcelRequire("epLTS");
const $00914e36c13c7a02$var$useCategorizedData = (category, dataSelector, customContext)=>{
    const { data: allData, loading: loading, error: error, refresh: refresh } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $aGQ56.queuesNavigationItems), customContext);
    const memoizedData = (0, $eJOHy.useMemo)(()=>dataSelector(allData, category), [
        allData,
        category,
        dataSelector
    ]);
    return [
        memoizedData,
        loading,
        error,
        refresh
    ];
};
const $00914e36c13c7a02$export$fec6561bcaa1c55b = (projectKey, category = (0, $jlJsl.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $epLTS.useCategorizedActions)(projectKey, category, customContext);
    const [data, loading, error, refresh] = $00914e36c13c7a02$var$useCategorizedData(category, (0, $2b3mN.navDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods,
        refresh
    ];
};
const $00914e36c13c7a02$export$f9b7a4e20c09f3ce = ()=>{
    const projectKey = (0, $jEt3L.useProjectKey)();
    const category = (0, $jEt3L.useCurrentCategory)();
    const [data, loading, error, methods] = $00914e36c13c7a02$export$c4ca47ba8c81dba6(projectKey, category);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $00914e36c13c7a02$export$1dc9816387d038aa = (projectKey, category = (0, $jlJsl.NO_CATEGORY))=>{
    const [methods] = (0, $epLTS.useCategorizedActions)(projectKey, category);
    const [data, loading, error] = $00914e36c13c7a02$var$useCategorizedData(category, (0, $2b3mN.notFavouriteDataSelector));
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $00914e36c13c7a02$export$e27d61833d43b175 = (projectKey, category = (0, $jlJsl.NO_CATEGORY), customContext)=>{
    const [methods] = (0, $epLTS.useCategorizedActions)(projectKey, category, customContext);
    const [data, loading, error] = $00914e36c13c7a02$var$useCategorizedData(category, (0, $2b3mN.favouriteDataSelector), customContext);
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $00914e36c13c7a02$export$c4ca47ba8c81dba6 = (projectKey, category = (0, $jlJsl.NO_CATEGORY))=>{
    const [methods] = (0, $epLTS.useCategorizedActions)(projectKey, category);
    const [data, loading, error] = $00914e36c13c7a02$var$useCategorizedData(category, (0, $2b3mN.queuesDataSelector));
    return [
        data,
        loading,
        error,
        methods
    ];
};
const $00914e36c13c7a02$export$f857eeb50ae9b1b2 = (category = (0, $jlJsl.NO_CATEGORY), customContext)=>$00914e36c13c7a02$var$useCategorizedData(category, (0, $2b3mN.practiceMetadataSelector), customContext);
const $00914e36c13c7a02$export$216a9245ead6e18a = (customContext)=>$00914e36c13c7a02$var$useCategorizedData((0, $jlJsl.NO_CATEGORY), (0, $2b3mN.practiceListSelector), customContext);
const $00914e36c13c7a02$export$5577ca8a6b2fed3c = ({ projectKey: projectKey, category: category, children: children })=>{
    const [data, loading, error, methods] = $00914e36c13c7a02$export$c4ca47ba8c81dba6(projectKey, category);
    return children({
        data: data,
        loading: loading,
        error: error,
        methods: methods
    });
};
const $00914e36c13c7a02$export$aea9dc5735ed30c = ({ projectKey: projectKey, category: category, children: children })=>{
    const [data, loading, error, methods] = $00914e36c13c7a02$export$fec6561bcaa1c55b(projectKey, category);
    return children({
        data: data,
        loading: loading,
        error: error,
        methods: methods
    });
};
$00914e36c13c7a02$export$5577ca8a6b2fed3c.defaultProps = {
    category: (0, $jlJsl.NO_CATEGORY)
};
$00914e36c13c7a02$export$aea9dc5735ed30c.defaultProps = {
    category: (0, $jlJsl.NO_CATEGORY)
};

});
parcelRegister("jEt3L", function(module, exports) {

$parcel$export(module.exports, "getQueuesForCategory", () => $5bfc006c72fff47c$export$fcf9c653a5f7167a);
$parcel$export(module.exports, "setQueuesForCategory", () => $5bfc006c72fff47c$export$7ca50bfd96f22f76);
$parcel$export(module.exports, "queuesToNavItems", () => $5bfc006c72fff47c$export$e6491f132367997c);
$parcel$export(module.exports, "useProjectKey", () => $5bfc006c72fff47c$export$f87be37f8e8be65);
$parcel$export(module.exports, "useCurrentCategory", () => $5bfc006c72fff47c$export$e42116f2f5c27c35);

var $iWqim = parcelRequire("iWqim");

var $5SwkH = parcelRequire("5SwkH");

var $k6qAI = parcelRequire("k6qAI");

var $ljej9 = parcelRequire("ljej9");

var $gCY1z = parcelRequire("gCY1z");
const $5bfc006c72fff47c$export$fcf9c653a5f7167a = (data, category)=>(0, $iWqim.getIn)(data, [
        category,
        'queues'
    ]);
const $5bfc006c72fff47c$export$7ca50bfd96f22f76 = (data, category, newQueues)=>// @ts-expect-error(PARTIAL_RECORD) TS2740 - Type '{}' is missing the following properties from type 'CategorizedQueueData': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
    (0, $iWqim.updateIn)(data || {}, [
        category,
        'queues'
    ], (queues)=>{
        // We only want to update queues if they exist in a category already
        if (queues) return newQueues;
        throw new Error(`${category} does not exist in resource`);
    });
const $5bfc006c72fff47c$export$e6491f132367997c = (queues)=>queues.map(({ id: id, name: name, projectKey: projectKey, count: count, category: category, favourite: favourite, canBeHidden: canBeHidden, shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh, lastRefreshedTime: lastRefreshedTime })=>({
            id: String(id),
            name: name,
            url: `/projects/${projectKey}/${(0, $5SwkH.getQueueFragment)(id, category)}`,
            badgeCount: count,
            starred: favourite,
            canBeHidden: canBeHidden,
            shouldSkipIssueCountRefresh: shouldSkipIssueCountRefresh,
            category: category,
            lastRefreshedTime: lastRefreshedTime
        }));
const $5bfc006c72fff47c$export$f87be37f8e8be65 = ()=>{
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    return (0, $ljej9.toProjectKey)(match.params.projectKey || '');
};
const $5bfc006c72fff47c$export$e42116f2f5c27c35 = ()=>{
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    return (0, $k6qAI.toItsmPractice)(match.params.practiceType);
};

});

parcelRegister("2b3mN", function(module, exports) {

$parcel$export(module.exports, "queuesDataSelector", () => $51cc00c29009f82a$export$fe10e38dc2f0e4c8);
$parcel$export(module.exports, "navDataSelector", () => $51cc00c29009f82a$export$caf8de9cbdbf9102);
$parcel$export(module.exports, "notFavouriteDataSelector", () => $51cc00c29009f82a$export$46aa703ec1a01e);
$parcel$export(module.exports, "favouriteDataSelector", () => $51cc00c29009f82a$export$fc3fab89f453b08e);
$parcel$export(module.exports, "practiceMetadataSelector", () => $51cc00c29009f82a$export$b0af22bb6bff9c49);
$parcel$export(module.exports, "isCountLoadingSelector", () => $51cc00c29009f82a$export$efbcd30acb5e816f);
$parcel$export(module.exports, "hasRequestedCountSelector", () => $51cc00c29009f82a$export$54e54a1ac5e7098f);
$parcel$export(module.exports, "practiceListSelector", () => $51cc00c29009f82a$export$61d9fd7be029b514);

var $iWqim = parcelRequire("iWqim");

var $jEt3L = parcelRequire("jEt3L");
const $51cc00c29009f82a$export$fe10e38dc2f0e4c8 = (data, category)=>(0, $jEt3L.getQueuesForCategory)(data, category) || null;
const $51cc00c29009f82a$export$caf8de9cbdbf9102 = (data, category)=>{
    const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
    return queues ? (0, $jEt3L.queuesToNavItems)(queues) : null;
};
const $51cc00c29009f82a$export$231e113a2e075013 = (data, category)=>{
    const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
    const otherQueuesData = queues ? queues.filter((q)=>q.canBeHidden && !q.favourite) : null;
    return otherQueuesData ? (0, $jEt3L.queuesToNavItems)(otherQueuesData) : null;
};
const $51cc00c29009f82a$export$46aa703ec1a01e = (data, category)=>{
    const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const otherQueuesData = queues ? queues.filter((q)=>!q.favourite) : null;
    return otherQueuesData ? (0, $jEt3L.queuesToNavItems)(otherQueuesData) : null;
};
const $51cc00c29009f82a$export$f28545acfde3f70e = (data, category)=>{
    const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
    const defaultQueuesData = queues ? queues.filter((q)=>!q.canBeHidden && !q.favourite) : null;
    return defaultQueuesData ? (0, $jEt3L.queuesToNavItems)(defaultQueuesData) : null;
};
const $51cc00c29009f82a$export$fc3fab89f453b08e = (data, category)=>{
    const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const starredQueues = queues ? queues.filter((q)=>q.favourite) : null;
    return starredQueues ? (0, $jEt3L.queuesToNavItems)(starredQueues) : null;
};
const $51cc00c29009f82a$export$b0af22bb6bff9c49 = (data, category)=>{
    const practiceData = (0, $iWqim.getIn)(data, [
        category
    ]);
    return practiceData ? (0, $iWqim.dissoc)(practiceData, 'queues') : null;
};
const $51cc00c29009f82a$export$efbcd30acb5e816f = (data, category)=>{
    const practiceData = (0, $iWqim.getIn)(data, [
        category
    ]);
    return practiceData ? practiceData.isCountLoading : false;
};
const $51cc00c29009f82a$export$54e54a1ac5e7098f = (data, category)=>{
    const practiceData = (0, $iWqim.getIn)(data, [
        category
    ]);
    return practiceData ? practiceData.hasRequestedCount : false;
};
const $51cc00c29009f82a$export$61d9fd7be029b514 = (data)=>// @ts-expect-error - TS2322 - Type 'string[] | null' is not assignable to type 'Data<ItsmPractice[]>'.
    data ? Object.keys(data) : null;

});

parcelRegister("epLTS", function(module, exports) {

$parcel$export(module.exports, "useCategorizedActions", () => $b669b4f761f93982$export$8632bfeb0b672958);
$parcel$export(module.exports, "default", () => $b669b4f761f93982$export$2e2bcd8739ae039);

var $bo7Z6 = parcelRequire("bo7Z6");

var $aGQ56 = parcelRequire("aGQ56");

var $dmQTE = parcelRequire("dmQTE");
const $b669b4f761f93982$export$8632bfeb0b672958 = (projectKey, category, customContext)=>{
    const { update: update } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $aGQ56.queuesNavigationItems), customContext);
    const cachedActions = (0, $dmQTE.default)(category, update, {
        projectKey: projectKey
    });
    return [
        cachedActions
    ];
};
const $b669b4f761f93982$var$ActionsProvider = ({ projectKey: projectKey, category: category, children: children })=>{
    const [actions] = $b669b4f761f93982$export$8632bfeb0b672958(projectKey, category);
    return children(actions);
};
var $b669b4f761f93982$export$2e2bcd8739ae039 = $b669b4f761f93982$var$ActionsProvider;

});
parcelRegister("dmQTE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6112c6a20e517891$export$2e2bcd8739ae039);

var $12DRg = parcelRequire("12DRg");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $aCUbT = parcelRequire("aCUbT");
const $6112c6a20e517891$export$36d128238e6b60f5 = {
    currentCacheKey: '',
    // @ts-expect-error(PARTIAL_RECORD) TS2740 - Type '{}' is missing the following properties from type 'Record<ItsmPractice, ChildrenProps>': "change-management", "incident-management", "problem-management", "service-request", and 2 more.
    actionsByCategory: {}
};
const $6112c6a20e517891$export$8b3bc28eb06c49b6 = {
    // Actions are lazily created for each category of a project.
    // Project key is used as the cache key. Once the cache key has changed
    // the store will be reset
    getActions: (...args)=>({ getState: getState, setState: setState })=>{
            const [category, , { projectKey: projectKey }] = args;
            const { currentCacheKey: currentCacheKey, actionsByCategory: actionsByCategory } = getState();
            const categoryActions = actionsByCategory[category];
            const hasSameKey = projectKey === currentCacheKey;
            if (hasSameKey && Boolean(categoryActions)) return categoryActions;
            const newCategoryActions = (0, $aCUbT.getActions)(...args);
            setState({
                currentCacheKey: projectKey,
                // @ts-expect-error(PARTIAL_RECORD) TS2322 - Type '{ "change-management"?: Actions | undefined; "incident-management"?: Actions | undefined; "problem-management"?: Actions | undefined; "service-request"?: Actions | undefined; "post-incident-review"?: Actions | undefined; "no-category"?: Actions | undefined; }' is not assignable to type 'Record<ItsmPractice, ChildrenProps>'.
                actionsByCategory: {
                    ...hasSameKey ? actionsByCategory : {},
                    [category]: newCategoryActions
                }
            });
            return newCategoryActions;
        }
};
const $6112c6a20e517891$var$Store = (0, $GtRbT.createStore)({
    initialState: $6112c6a20e517891$export$36d128238e6b60f5,
    actions: $6112c6a20e517891$export$8b3bc28eb06c49b6,
    name: 'jira-servicedesk-categorized-queues-actions-store'
});
const $6112c6a20e517891$var$useActionsStore = (0, $iJq0l.createHook)($6112c6a20e517891$var$Store, {
    selector: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});
const $6112c6a20e517891$export$193cb0fec61d3692 = (...args)=>{
    const [, { getActions: getActions }] = $6112c6a20e517891$var$useActionsStore();
    return getActions(...args);
};
var $6112c6a20e517891$export$2e2bcd8739ae039 = $6112c6a20e517891$export$193cb0fec61d3692;

});
parcelRegister("aCUbT", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $ed273aa7b7046c63$export$fe3955935f564b31);

var $iWqim = parcelRequire("iWqim");

var $6DCNy = parcelRequire("6DCNy");


var $epTsa = parcelRequire("epTsa");

var $8KUFq = parcelRequire("8KUFq");

var $bGwJI = parcelRequire("bGwJI");

var $jCh1Y = parcelRequire("jCh1Y");

var $hF0mU = parcelRequire("hF0mU");

var $jEt3L = parcelRequire("jEt3L");

var $2b3mN = parcelRequire("2b3mN");

var $kzsKv = parcelRequire("kzsKv");

var $lcKqP = parcelRequire("lcKqP");
const $ed273aa7b7046c63$var$getThrottledRefresh = ()=>Number((0, $epTsa.expVal)('jsm_dynamic_queues_issue_count_refresh_interval', 'value', '120000'));
const $ed273aa7b7046c63$var$getAnalyticsPayload = (err)=>{
    const wasQueueDeleted = err?.statusCode === (0, $44ccf6b895337c89$export$8bca792d963eb0ef);
    const queueConflictOccurred = err?.statusCode === (0, $44ccf6b895337c89$export$c09e7ea0fc79f34f);
    const queueActionNotPermitted = err?.statusCode === (0, $44ccf6b895337c89$export$a3269a3914b007e3);
    return {
        wasQueueDeleted: wasQueueDeleted,
        queueConflictOccurred: queueConflictOccurred,
        queueActionNotPermitted: queueActionNotPermitted,
        isClientFetchError: (0, $8KUFq.isClientFetchError)(err)
    };
};
const $ed273aa7b7046c63$export$fe3955935f564b31 = (category, update, restParams)=>{
    const actions = {
        addItem: (item)=>{
            update((data)=>{
                const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
                if (queues) return (0, $jEt3L.setQueuesForCategory)(data, category, (0, $lcKqP.addItem)(queues, item));
                throw new Error(`Cannot add item because ${category} does not exist in resource`);
            });
        },
        deleteItem: (id)=>{
            update((data)=>{
                const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
                if (queues) return (0, $jEt3L.setQueuesForCategory)(data, category, (0, $lcKqP.deleteItem)(queues, id));
                throw new Error(`Cannot delete item because ${category} does not exist in resource`);
            });
        },
        editItem: (item)=>{
            update((data)=>{
                const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
                if (queues) return (0, $jEt3L.setQueuesForCategory)(data, category, (0, $lcKqP.editItem)(queues, item));
                throw new Error(`Cannot edit item because ${category} does not exist in resource`);
            });
        },
        moveItem: (from, to)=>{
            if (from !== to) update((data)=>{
                const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
                if (queues) {
                    const { projectKey: projectKey } = restParams;
                    const result = (0, $lcKqP.moveItem)(queues, from, to);
                    (0, $jCh1Y.setQueues)(projectKey, (0, $jEt3L.queuesToNavItems)(result), category);
                    return (0, $jEt3L.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item because ${category} does not exist in resource`);
            });
        },
        moveItemBelow: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
                if (queues) {
                    const { projectKey: projectKey } = restParams;
                    const result = (0, $lcKqP.moveItemBelow)(queues, queueId, targetQueueId);
                    (0, $jCh1Y.setQueues)(projectKey, (0, $jEt3L.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($ed273aa7b7046c63$var$getAnalyticsPayload(err)));
                    return (0, $jEt3L.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item below because ${category} does not exist in resource`);
            });
        },
        moveItemAbove: (queueId, targetQueueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
                if (queues) {
                    const { projectKey: projectKey } = restParams;
                    const result = (0, $lcKqP.moveItemAbove)(queues, queueId, targetQueueId);
                    (0, $jCh1Y.setQueues)(projectKey, (0, $jEt3L.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($ed273aa7b7046c63$var$getAnalyticsPayload(err)));
                    return (0, $jEt3L.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item above because ${category} does not exist in resource`);
            });
        },
        moveToTop: (queueId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
                if (queues) {
                    const { projectKey: projectKey } = restParams;
                    const result = (0, $lcKqP.moveToTop)(queues, queueId);
                    (0, $jCh1Y.setQueues)(projectKey, (0, $jEt3L.queuesToNavItems)(result), category).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($ed273aa7b7046c63$var$getAnalyticsPayload(err)));
                    return (0, $jEt3L.setQueuesForCategory)(data, category, result);
                }
                throw new Error(`Cannot move item to top because ${category} does not exist in resource`);
            });
        },
        refreshNavItems: (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))((analyticsEvent)=>{
            setTimeout(()=>{
                update((data)=>{
                    const isCountLoading = (0, $2b3mN.isCountLoadingSelector)(data, category);
                    if (isCountLoading) return data;
                    if (restParams.projectKey) (0, $kzsKv.refreshIssueCountForVisibleAndStarredQueues)(update, {
                        ...restParams,
                        category: category
                    }, analyticsEvent);
                    const updatedData = data ? (0, $iWqim.assocIn)(data, [
                        category,
                        'isCountLoading'
                    ], true) : null;
                    return updatedData;
                });
            // Jitter the call randomly between 1 - 5secs in case of multiple tab requests
            }, Math.floor(Math.random() * 5000) + 1000);
        }, $ed273aa7b7046c63$var$getThrottledRefresh()),
        initialFetchNavItems: (analyticsEvent)=>{
            update((data)=>{
                const isCountLoading = (0, $2b3mN.isCountLoadingSelector)(data, category);
                const hasRequestedCount = (0, $2b3mN.hasRequestedCountSelector)(data, category);
                if (!isCountLoading && !hasRequestedCount) actions.refreshNavItems(analyticsEvent);
                return data;
            });
        },
        refreshIssueCountForItems: (queueIds, analyticsEvent)=>{
            (0, $kzsKv.refreshIssueCountForQueues)(update, {
                ...restParams,
                category: category
            }, queueIds, analyticsEvent);
        },
        editItemIssueCount: (id, count)=>{
            update((data)=>{
                const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
                if (queues) return (0, $jEt3L.setQueuesForCategory)(data, category, (0, $lcKqP.editItem)(queues, {
                    id: Number(id),
                    count: count,
                    lastRefreshedTime: Date.now()
                }));
                // There is no point update the issue-counts for default queue as there is no queues.
                // It might throwing exceptions if we cannot fetch queue categories.
                // Being defensive here for the rollout, if this code throw any errors, it's the same behavior as the below line.
                if (Number(id) === (0, $bGwJI.DEFAULT_QUEUE_ID)) return data;
                throw new Error(`Cannot edit item issue count because ${category} does not exist in resource for queue id ${id}`);
            });
        },
        editItemFavorite: (id, favourite)=>{
            update((data)=>{
                const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
                if (queues) return (0, $jEt3L.setQueuesForCategory)(data, category, (0, $lcKqP.editItem)(queues, {
                    id: Number(id),
                    favourite: favourite
                }));
                throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
            });
        },
        editVisibilityOfItems: (updatedItems, draggableId, onSuccessCallback, onErrorCallback)=>{
            update((data)=>{
                const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
                const { projectKey: projectKey } = restParams;
                if (queues) {
                    (0, $hF0mU.updateQueuesVisibility)(projectKey, updatedItems).then(()=>onSuccessCallback()).catch((err)=>onErrorCallback($ed273aa7b7046c63$var$getAnalyticsPayload(err)));
                    return (0, $jEt3L.setQueuesForCategory)(data, category, (0, $lcKqP.editItems)(queues, [
                        ...updatedItems
                    ]));
                }
                throw new Error(`Cannot edit item favorite because ${category} does not exist in resource`);
            });
        },
        enableRefreshForQueues: (queueIds)=>{
            (0, $kzsKv.enableRefreshForQueues)(update, {
                ...restParams,
                category: category
            }, queueIds);
        },
        enableIssueCountForSelectedQueues: (selectedQueueIds)=>{
            update((data)=>{
                const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
                if (queues) return (0, $jEt3L.setQueuesForCategory)(data, category, (0, $lcKqP.enableSelectedQueuesVisibility)(selectedQueueIds, queues));
                throw new Error(`Cannot enable issue count for selected queues because ${category} does not exist in resource`);
            });
        }
    };
    return actions;
};

});
const $44ccf6b895337c89$export$ff39ebd4bb12b718 = 201;
const $44ccf6b895337c89$export$3288b14b6745c572 = 204;
const $44ccf6b895337c89$export$9de493bcd9b1d977 = 400;
const $44ccf6b895337c89$export$67d19e9a991baa07 = 401;
const $44ccf6b895337c89$export$a3269a3914b007e3 = 403;
const $44ccf6b895337c89$export$8bca792d963eb0ef = 404;
const $44ccf6b895337c89$export$4a3cb39801694eee = 407;
const $44ccf6b895337c89$export$fa405bbf47d510e2 = 408;
const $44ccf6b895337c89$export$c09e7ea0fc79f34f = 409;
const $44ccf6b895337c89$export$5244030134e99 = 412;
const $44ccf6b895337c89$export$f90ac1df0b60853d = 413;
const $44ccf6b895337c89$export$a447d0a965e16776 = 422;
const $44ccf6b895337c89$export$3b48aba8957000cd = 426;
const $44ccf6b895337c89$export$6763168a631449a2 = 429;
const $44ccf6b895337c89$export$e813cd7045fcc98d = 500;
const $44ccf6b895337c89$export$2ce38d41a306034e = 502;
const $44ccf6b895337c89$export$974c37534b0191b1 = 503;
const $44ccf6b895337c89$export$5400e8dddac3fcf3 = 504;

parcelRegister("bGwJI", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COLUMNS", () => $f44971969bdb6d29$export$50c19f60b9c144f7);
$parcel$export(module.exports, "DEFAULT_QUEUE_ID", () => $f44971969bdb6d29$export$e78379cc32bff512);
$parcel$export(module.exports, "FETCH_BATCH_SIZE", () => $f44971969bdb6d29$export$baa236d86cd0d3f5);
$parcel$export(module.exports, "FETCH_SIZE_IN_INITIAL_LOAD", () => $f44971969bdb6d29$export$4ee65d92b7b81b6b);
const $f44971969bdb6d29$export$50c19f60b9c144f7 = [
    'issuetype',
    'issuekey',
    'summary',
    'reporter',
    'assignee',
    'status',
    'created'
];
const $f44971969bdb6d29$export$e78379cc32bff512 = Number.MIN_VALUE;
const $f44971969bdb6d29$export$baa236d86cd0d3f5 = 100;
const $f44971969bdb6d29$export$4ee65d92b7b81b6b = 30;

});

parcelRegister("jCh1Y", function(module, exports) {

$parcel$export(module.exports, "setQueues", () => $259c2ea870cca733$export$51b06787b88b2bf2);

var $jGzN3 = parcelRequire("jGzN3");

var $cRJuG = parcelRequire("cRJuG");
const $259c2ea870cca733$var$getQueuesUrl = (projectKey)=>`/rest/servicedesk/1/servicedesk/${projectKey}/queues`;
const $259c2ea870cca733$export$51b06787b88b2bf2 = (projectKey, queues, category)=>(0, $jGzN3.performPutRequest)($259c2ea870cca733$var$getQueuesUrl(projectKey), {
        body: JSON.stringify((0, $cRJuG.transformQueues)(queues, category))
    });

});
parcelRegister("cRJuG", function(module, exports) {

$parcel$export(module.exports, "transformQueues", () => $fc966370f83ee154$export$66ec85c65393edb4);

var $jlJsl = parcelRequire("jlJsl");
const $fc966370f83ee154$export$66ec85c65393edb4 = (queues, category)=>({
        order: queues.map((queue)=>queue.id),
        id: 'com.atlassian.servicedesk.project-ui:sd-queues-custom',
        inline: true,
        deleted: [],
        ...category && category !== (0, $jlJsl.NO_CATEGORY) ? {
            category: category
        } : undefined
    });

});


parcelRegister("hF0mU", function(module, exports) {

$parcel$export(module.exports, "updateQueuesVisibility", () => $b053c604ad6f0566$export$c0862f2fb17c23c2);

var $jGzN3 = parcelRequire("jGzN3");
const $b053c604ad6f0566$var$getUpdateQueuesVisibilityUrl = (projectKey)=>`/rest/servicedesk/1/servicedesk/${projectKey}/queues/update-visibility`;
const $b053c604ad6f0566$export$c0862f2fb17c23c2 = (projectKey, modified)=>(0, $jGzN3.performPutRequest)($b053c604ad6f0566$var$getUpdateQueuesVisibilityUrl(projectKey), {
        body: JSON.stringify({
            modified: modified
        })
    });

});

parcelRegister("kzsKv", function(module, exports) {

$parcel$export(module.exports, "refreshIssueCountForVisibleAndStarredQueues", () => $86027bad7969e9c1$export$aaa6aeca5994daee);
$parcel$export(module.exports, "enableRefreshForQueues", () => $86027bad7969e9c1$export$6b0c14cefee3edf5);
$parcel$export(module.exports, "refreshIssueCountForQueues", () => $86027bad7969e9c1$export$b05e3887bfb123a8);

var $iWqim = parcelRequire("iWqim");

var $9g7yh = parcelRequire("9g7yh");

var $12DRg = parcelRequire("12DRg");

var $80xRm = parcelRequire("80xRm");

var $gYnSx = parcelRequire("gYnSx");

var $jEt3L = parcelRequire("jEt3L");

var $2b3mN = parcelRequire("2b3mN");

var $fwkMG = parcelRequire("fwkMG");
const $86027bad7969e9c1$export$defcbd4ba0fd3734 = 5;
const $86027bad7969e9c1$var$RETRY_DELAY_IN_MS = 1000;
const $86027bad7969e9c1$var$fireErrorAnalyticsForRetryFailure = (error)=>{
    (0, $gYnSx.default)({
        meta: {
            id: 'retryQueueIssueCountAction',
            packageName: 'jiraServicedeskCategorizedQueuesStore',
            teamName: 'jsd-shield'
        },
        error: error
    });
};
const $86027bad7969e9c1$export$ef7266a9f6c0de43 = ({ projectKey: projectKey, category: category }, skipHiddenQueues, update, retryCount, analyticsEvent)=>async (queueIds)=>{
        if (queueIds && queueIds.length === 0) return;
        if (retryCount >= $86027bad7969e9c1$export$defcbd4ba0fd3734) {
            (0, $fwkMG.fireManualOperationalAnalytics)({
                source: 'refreshQueueIssueCountAction',
                actionSubject: 'retryIssueCount',
                action: 'limitExceeded',
                attributes: {
                    retryCount: retryCount,
                    maxRetryCount: $86027bad7969e9c1$export$defcbd4ba0fd3734
                }
            });
            return;
        }
        setTimeout(()=>{
            try {
                const newRetryCount = retryCount + 1;
                update((data)=>{
                    const queues = (0, $jEt3L.getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id));
                    if (queues && queues.length > 0) {
                        const retryCallback = $86027bad7969e9c1$export$ef7266a9f6c0de43({
                            projectKey: projectKey,
                            category: category
                        }, true, update, newRetryCount, analyticsEvent);
                        (0, $fwkMG.updateIssueCountForQueues)(projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent);
                        (0, $fwkMG.fireManualOperationalAnalytics)({
                            source: 'refreshQueueIssueCountAction',
                            actionSubject: 'retryQueueIssueCount',
                            action: 'triggered',
                            attributes: {
                                retryCount: newRetryCount,
                                maxRetryCount: $86027bad7969e9c1$export$defcbd4ba0fd3734,
                                queuesCount: queues.length
                            }
                        });
                        return data ? (0, $iWqim.assocIn)(data, [
                            category,
                            'isCountLoading'
                        ], true) : null;
                    }
                    return data;
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                $86027bad7969e9c1$var$fireErrorAnalyticsForRetryFailure(error);
                throw error;
            }
        }, $86027bad7969e9c1$var$RETRY_DELAY_IN_MS);
    };
const $86027bad7969e9c1$export$aaa6aeca5994daee = async (update, { projectKey: projectKey, category: category }, analyticsEvent)=>{
    try {
        update((data)=>{
            const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
            const retryCallback = !(0, $2b3mN.hasRequestedCountSelector)(data, category) ? $86027bad7969e9c1$export$ef7266a9f6c0de43({
                projectKey: projectKey,
                category: category
            }, true, update, 0, analyticsEvent) : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
            if (queues) {
                (0, $fwkMG.updateIssueCountForQueues)(projectKey, category, queues, true, update, retryCallback, analyticsEvent);
                return data ? (0, $iWqim.assocIn)(data, [
                    category,
                    'isCountLoading'
                ], true) : null;
            }
            return data;
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $fwkMG.fireErrorAnalyticsForRefreshCountFailure)(error);
        throw error;
    }
};
const $86027bad7969e9c1$export$6b0c14cefee3edf5 = (update, { projectKey: _, category: category }, queueIds)=>{
    update((data)=>{
        const queues = (0, $jEt3L.getQueuesForCategory)(data, category);
        const refreshEnabledQueues = queues?.filter((queue)=>queueIds.includes(queue.id.toString())).map((queue)=>queue.shouldSkipIssueCountRefresh ? {
                ...queue,
                shouldSkipIssueCountRefresh: false,
                count: undefined
            } : queue);
        const queuesMap = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(queues, 'id');
        refreshEnabledQueues?.forEach((queue)=>{
            queuesMap[queue.id] = queue;
        });
        return (0, $jEt3L.setQueuesForCategory)(data, category, (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(Object.values(queuesMap), 'order'));
    });
};
const $86027bad7969e9c1$export$b05e3887bfb123a8 = async (update, { projectKey: projectKey, category: category }, queueIds, analyticsEvent)=>{
    try {
        update((data)=>{
            const queues = (0, $jEt3L.getQueuesForCategory)(data, category)?.filter((queue)=>queueIds.includes(queue.id.toString()));
            if (queues && queues.length > 0) {
                (0, $fwkMG.updateIssueCountForQueues)(projectKey, category, queues, false, update, (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), analyticsEvent);
                return data ? (0, $iWqim.assocIn)(data, [
                    category,
                    'isCountLoading'
                ], true) : null;
            }
            return data;
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $fwkMG.fireErrorAnalyticsForRefreshCountFailure)(error);
        throw error;
    }
};

});
parcelRegister("9g7yh", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $a9KaZ = parcelRequire("a9KaZ");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $6bdb775087644ec3$var$keyBy = $a9KaZ(function(result, value, key) {
    $iBJlb(result, key, value);
});
module.exports = $6bdb775087644ec3$var$keyBy;

});

parcelRegister("80xRm", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");

var $4ppQ2 = parcelRequire("4ppQ2");

var $l76qh = parcelRequire("l76qh");

var $eA1it = parcelRequire("eA1it");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $5d48969fb93c8520$var$sortBy = $l76qh(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $eA1it(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $eA1it(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $4ppQ2(collection, $72Qfa(iteratees, 1), []);
});
module.exports = $5d48969fb93c8520$var$sortBy;

});
parcelRegister("4ppQ2", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $5BbSa = parcelRequire("5BbSa");

var $1lM9j = parcelRequire("1lM9j");

var $k0Eii = parcelRequire("k0Eii");

var $1QISL = parcelRequire("1QISL");

var $cUaWv = parcelRequire("cUaWv");

var $6c1m2 = parcelRequire("6c1m2");

var $d7YnM = parcelRequire("d7YnM");

var $4sprp = parcelRequire("4sprp");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $335d8a321b94e157$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $lylkU(iteratees, function(iteratee) {
        if ($4sprp(iteratee)) return function(value) {
            return $5BbSa(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $d7YnM
    ];
    var index = -1;
    iteratees = $lylkU(iteratees, $cUaWv($1lM9j));
    var result = $k0Eii(collection, function(value, key, collection) {
        var criteria = $lylkU(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $1QISL(result, function(object, other) {
        return $6c1m2(object, other, orders);
    });
}
module.exports = $335d8a321b94e157$var$baseOrderBy;

});
parcelRegister("1QISL", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $158d7678f0c45464$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $158d7678f0c45464$var$baseSortBy;

});

parcelRegister("6c1m2", function(module, exports) {

var $boN2o = parcelRequire("boN2o");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $4824ea093db12906$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $boN2o(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $4824ea093db12906$var$compareMultiple;

});
parcelRegister("boN2o", function(module, exports) {

var $9D78T = parcelRequire("9D78T");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $84c7f970dc532949$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $9D78T(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $9D78T(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $84c7f970dc532949$var$compareAscending;

});




parcelRegister("fwkMG", function(module, exports) {

$parcel$export(module.exports, "fireManualOperationalAnalytics", () => $f9b782dc3fd1aff5$export$a9301d18019c11f9);
$parcel$export(module.exports, "fireErrorAnalyticsForRefreshCountFailure", () => $f9b782dc3fd1aff5$export$b5e2038970f91d6c);
$parcel$export(module.exports, "updateIssueCountForQueues", () => $f9b782dc3fd1aff5$export$d436cbef77099410);

var $iWqim = parcelRequire("iWqim");

var $lBtjB = parcelRequire("lBtjB");

var $9g7yh = parcelRequire("9g7yh");

var $80xRm = parcelRequire("80xRm");

var $40zJW = parcelRequire("40zJW");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $hWeHP = parcelRequire("hWeHP");

var $gCeeo = parcelRequire("gCeeo");

var $5G60L = parcelRequire("5G60L");

var $9D41I = parcelRequire("9D41I");

var $jEt3L = parcelRequire("jEt3L");
const $f9b782dc3fd1aff5$var$ERROR_DB_TIMEOUT = 'error.db-timeout';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $f9b782dc3fd1aff5$var$ERROR_UNKNOWN = 'error.unknown';
const $f9b782dc3fd1aff5$export$cf85cf6a45b00808 = {
    FAILED: 'failed',
    SUCCESS: 'success',
    PENDING: 'pending'
};
const $f9b782dc3fd1aff5$var$MAX_ISSUECOUNT_THRESHOLD = 1000;
const $f9b782dc3fd1aff5$export$a9301d18019c11f9 = (payload)=>(0, $5G60L.getAnalyticsWebClient)().getInstance().sendOperationalEvent(payload);
const $f9b782dc3fd1aff5$var$filterOutHiddenQueues = (queues)=>queues.filter((q)=>!(q.canBeHidden === undefined ? false : q.canBeHidden) || q.favourite);
const $f9b782dc3fd1aff5$var$filterOutBadQueues = (queues)=>queues.filter((q)=>!q.shouldSkipIssueCountRefresh);
const $f9b782dc3fd1aff5$var$getIssueCountPerGroup = (issueCounts)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(issueCounts).reduce((curr, queueId)=>{
        const res = curr;
        if (issueCounts[Number(queueId)]) {
            if (issueCounts[Number(queueId)].issueCount || issueCounts[Number(queueId)].issueCount === 0) res[Number(queueId)] = issueCounts[Number(queueId)].issueCount;
        }
        return res;
    }, {});
const $f9b782dc3fd1aff5$var$getQueuesPerGroup = (queues, skipHiddenQueues)=>{
    const starredQueues = [];
    const defaultQueues = [];
    let toGroupQueues = queues;
    let hasSkippedQueues = false;
    if (skipHiddenQueues === true) toGroupQueues = $f9b782dc3fd1aff5$var$filterOutHiddenQueues(queues);
    toGroupQueues = $f9b782dc3fd1aff5$var$filterOutBadQueues(toGroupQueues);
    let queueByGroups = {};
    toGroupQueues.forEach((queue)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(queue.count) && queue.count > $f9b782dc3fd1aff5$var$MAX_ISSUECOUNT_THRESHOLD) {
            hasSkippedQueues = true;
            return;
        }
        if (queue.favourite) starredQueues.push(queue);
        else defaultQueues.push(queue);
    });
    queueByGroups = {
        starredQueues: starredQueues,
        defaultQueues: defaultQueues
    };
    if (hasSkippedQueues) $f9b782dc3fd1aff5$export$a9301d18019c11f9({
        source: 'refreshQueueIssueCountAction',
        actionSubject: 'queueIssueCountRefresh',
        action: 'skipped'
    });
    return queueByGroups;
};
const $f9b782dc3fd1aff5$var$getQueuesSortByLastRefreshedTime = (queuesBeforeSort)=>{
    let queuesSortByLastRefreshedTime = [];
    const queuesSortByGroup = [
        ...queuesBeforeSort.starredQueues,
        ...queuesBeforeSort.defaultQueues
    ];
    queuesSortByLastRefreshedTime = (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(queuesSortByGroup, [
        'lastRefreshedTime'
    ]);
    return queuesSortByLastRefreshedTime;
};
const $f9b782dc3fd1aff5$export$b5e2038970f91d6c = (error)=>{
    (0, $gYnSx.default)({
        meta: {
            id: 'refreshQueueIssueCountAction',
            packageName: 'jiraServicedeskCategorizedQueuesStore',
            teamName: 'jsd-shield'
        },
        error: error
    });
};
const $f9b782dc3fd1aff5$var$isIssueCountAlreadyFetched = (queue)=>queue.count !== undefined;
const $f9b782dc3fd1aff5$var$getSkippedQueues = (issueCounts, queuesMap)=>Object.keys(issueCounts).map((id)=>Number(id)).filter((queueId)=>issueCounts[queueId].result === $f9b782dc3fd1aff5$export$cf85cf6a45b00808.PENDING && !$f9b782dc3fd1aff5$var$isIssueCountAlreadyFetched(queuesMap[queueId]));
const $f9b782dc3fd1aff5$var$fetchIssueCountForQueueGroup = async (projectKey, queueIds)=>(0, $jGzN3.performPostRequest)(`/rest/servicedesk/1/servicedesk/${projectKey}/queues/issue-counts/refresh`, {
        body: JSON.stringify(queueIds)
    });
const $f9b782dc3fd1aff5$var$getQueueGroupData = (queueIds, issueCounts, queuesMap, batchStartProcessingTime)=>{
    const queueRefreshData = {
        minLastRefreshTimeFromCurrentBatch: Number.MAX_VALUE,
        queueCountChanges: 0
    };
    return queueIds.reduce((changes, queueId)=>{
        if (issueCounts[queueId]) {
            if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) {
                const queue = queuesMap[queueId];
                const currentQueueLastRefreshedTime = queue.lastRefreshedTime !== undefined && queue.lastRefreshedTime !== 0 ? queue.lastRefreshedTime : batchStartProcessingTime;
                const minLastRefreshTimeFromCurrentBatch = Math.min(changes.minLastRefreshTimeFromCurrentBatch, currentQueueLastRefreshedTime);
                const queueCountChanges = queue.count !== issueCounts[queueId].issueCount ? changes.queueCountChanges + 1 : changes.queueCountChanges;
                return {
                    minLastRefreshTimeFromCurrentBatch: minLastRefreshTimeFromCurrentBatch,
                    queueCountChanges: queueCountChanges
                };
            }
        }
        return changes;
    }, queueRefreshData);
};
const $f9b782dc3fd1aff5$var$fetchAndUpdateCount = async (projectKey, queueIds, category, analyticsEvent, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
update, batchStartProcessingTime, retryCallback)=>{
    if (queueIds.length === 0) return;
    let maxQueuesPerSd = await (0, $9D41I.getLimit)((0, $9D41I.MAX_QUEUES_PER_SD));
    if (maxQueuesPerSd === null) maxQueuesPerSd = queueIds.length;
    const queueIdsToFetch = queueIds.slice(0, maxQueuesPerSd);
    const startTime = Date.now();
    await $f9b782dc3fd1aff5$var$fetchIssueCountForQueueGroup(projectKey, queueIdsToFetch).then(({ issueCounts: issueCounts })=>{
        update((data)=>{
            const queuesMap = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))((0, $jEt3L.getQueuesForCategory)(data, category), 'id');
            const skippedQueues = $f9b782dc3fd1aff5$var$getSkippedQueues(issueCounts, queuesMap);
            if (skippedQueues.length > 0) retryCallback(skippedQueues);
            const endTime = Date.now();
            let queueCountChanges = 0;
            let minLastRefreshTimeFromCurrentBatch = 0;
            let numberOfBadQueues = 0;
            const queueRefreshData = $f9b782dc3fd1aff5$var$getQueueGroupData(queueIds, issueCounts, queuesMap, batchStartProcessingTime);
            queueCountChanges = queueRefreshData.queueCountChanges;
            minLastRefreshTimeFromCurrentBatch = queueRefreshData.minLastRefreshTimeFromCurrentBatch;
            queueIds.forEach((queueId)=>{
                const queue = queuesMap[queueId];
                if (issueCounts[queueId]) {
                    if (issueCounts[queueId].issueCount !== undefined || issueCounts[queueId].issueCount === 0) queuesMap[queueId] = {
                        ...queue,
                        count: issueCounts[queueId].issueCount,
                        lastRefreshedTime: endTime,
                        shouldSkipIssueCountRefresh: false
                    };
                    else if (issueCounts[queueId].errorCode === $f9b782dc3fd1aff5$var$ERROR_DB_TIMEOUT) {
                        numberOfBadQueues += 1;
                        queuesMap[queueId] = {
                            ...queue,
                            shouldSkipIssueCountRefresh: true
                        };
                    }
                }
            });
            if (analyticsEvent) {
                const issueCountPerGroup = $f9b782dc3fd1aff5$var$getIssueCountPerGroup(issueCounts);
                const queueIssueCounts = Object.values(issueCountPerGroup).map((queueCount)=>Number(queueCount));
                const jiraShard = (0, $hWeHP.default)('ajs-shard') || '';
                if (queueIssueCounts.length === 0) (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'navigationSession poorPerformanceQueuesCountsInfo', {
                    category: category,
                    queuesRequested: queueIdsToFetch.length,
                    maxQueuesPerSd: maxQueuesPerSd,
                    timeToFetchIssueCount: endTime - startTime,
                    timeSinceBatchStart: endTime - batchStartProcessingTime,
                    jiraShard: jiraShard,
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    browserTabVisibilityState: document.visibilityState,
                    numberOfBadQueues: numberOfBadQueues
                });
                else (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'navigationSession queuesCountsInfo', {
                    category: category,
                    queues: queueIssueCounts.length,
                    queuesRequested: queueIdsToFetch.length,
                    maxQueuesPerSd: maxQueuesPerSd,
                    maxIssueCount: Math.max(...queueIssueCounts),
                    timeToFetchIssueCount: endTime - startTime,
                    timeBetweenQueueRefresh: endTime - minLastRefreshTimeFromCurrentBatch,
                    timeSinceBatchStart: endTime - batchStartProcessingTime,
                    noOfQueuesWithUpdatedCount: queueCountChanges,
                    jiraShard: jiraShard,
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    browserTabVisibilityState: document.visibilityState,
                    numberOfBadQueues: numberOfBadQueues
                });
            }
            return (0, $jEt3L.setQueuesForCategory)(data, category, // Object.values is typed as Mixed[] and makes flow unhappy
            (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))((0, (/*@__PURE__*/$parcel$interopDefault($40zJW)))(queuesMap), 'order'));
        });
    }).catch((error)=>{
        $f9b782dc3fd1aff5$export$b5e2038970f91d6c(error);
    });
};
const $f9b782dc3fd1aff5$var$updateLoadingState = (category, queues, update)=>{
    update((data)=>data ? (0, $iWqim.chain)(data).setIn([
            category,
            'hasRequestedCount'
        ], true).setIn([
            category,
            'isCountLoading'
        ], false).value() : null);
};
const $f9b782dc3fd1aff5$export$d436cbef77099410 = async (projectKey, category, queues, skipHiddenQueues, update, retryCallback, analyticsEvent)=>{
    const queuesPerGroup = $f9b782dc3fd1aff5$var$getQueuesPerGroup(queues, skipHiddenQueues);
    const queuesSortByLastRefreshedTime = $f9b782dc3fd1aff5$var$getQueuesSortByLastRefreshedTime(queuesPerGroup);
    const queueIds = queuesSortByLastRefreshedTime.map((x)=>x.id);
    const batchStartProcessingTime = Date.now();
    try {
        // fetching the result in one call
        await $f9b782dc3fd1aff5$var$fetchAndUpdateCount(projectKey, queueIds, category, analyticsEvent, update, batchStartProcessingTime, retryCallback);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $f9b782dc3fd1aff5$var$updateLoadingState(category, queues, update);
        $f9b782dc3fd1aff5$export$b5e2038970f91d6c(error);
        throw error;
    }
    $f9b782dc3fd1aff5$var$updateLoadingState(category, queues, update);
};

});
parcelRegister("lBtjB", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $fba3cb134bd6d57d$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $fba3cb134bd6d57d$var$isNumber(value) {
    return typeof value == 'number' || $7gKgM(value) && $1O9y6(value) == $fba3cb134bd6d57d$var$numberTag;
}
module.exports = $fba3cb134bd6d57d$var$isNumber;

});

parcelRegister("9D41I", function(module, exports) {

$parcel$export(module.exports, "MAX_AUTOMATION_RULES_PER_SD", () => $6ba7c7d2f96c3944$export$dca2c2105b681490);
$parcel$export(module.exports, "MAX_AUTOMATION_BRANCHES_PER_RULE", () => $6ba7c7d2f96c3944$export$a48ac34d39e0fc22);
$parcel$export(module.exports, "MAX_QUEUES_PER_SD", () => $6ba7c7d2f96c3944$export$2e0ba662d5bb7742);
$parcel$export(module.exports, "MAX_SLA_GOALS_PER_SD", () => $6ba7c7d2f96c3944$export$eb69982aa3a172b4);
$parcel$export(module.exports, "MAX_CMDB_OBJECTS_PER_FIELD", () => $6ba7c7d2f96c3944$export$cb3888a8c43147d2);
$parcel$export(module.exports, "LIMIT_DEFAULTS", () => $6ba7c7d2f96c3944$export$5ed1d2ac050e39d);
$parcel$export(module.exports, "getLimit", () => $6ba7c7d2f96c3944$export$fb8ce379717a383d);
$parcel$export(module.exports, "LimitData", () => $6ba7c7d2f96c3944$export$9989835030ecd317);
$parcel$export(module.exports, "withLimitData", () => $6ba7c7d2f96c3944$export$c5d8aa8a650e690f);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");
const $6ba7c7d2f96c3944$export$dca2c2105b681490 = 'max_automation_rules_per_sd';
const $6ba7c7d2f96c3944$export$a48ac34d39e0fc22 = 'max_automation_branches_per_rule';
const $6ba7c7d2f96c3944$export$2e0ba662d5bb7742 = 'max_queues_per_sd';
const $6ba7c7d2f96c3944$export$eb69982aa3a172b4 = 'max_sla_goals_per_sd';
const $6ba7c7d2f96c3944$export$cb3888a8c43147d2 = 'max_cmdb_objects_per_field';
const $6ba7c7d2f96c3944$export$801a603585fb94d8 = 'max_num_team_priority_queues_per_sd';
const $6ba7c7d2f96c3944$export$5ed1d2ac050e39d = {
    [$6ba7c7d2f96c3944$export$dca2c2105b681490]: 30,
    [$6ba7c7d2f96c3944$export$a48ac34d39e0fc22]: 30,
    [$6ba7c7d2f96c3944$export$2e0ba662d5bb7742]: 300,
    [$6ba7c7d2f96c3944$export$eb69982aa3a172b4]: 30,
    [$6ba7c7d2f96c3944$export$cb3888a8c43147d2]: 20,
    [$6ba7c7d2f96c3944$export$801a603585fb94d8]: 50
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $6ba7c7d2f96c3944$var$limitCache = {};
const $6ba7c7d2f96c3944$export$c419786abd6faaad = (limitProperty)=>{
    delete $6ba7c7d2f96c3944$var$limitCache[limitProperty];
};
const $6ba7c7d2f96c3944$export$fb8ce379717a383d = (limitProperty)=>{
    if (!$6ba7c7d2f96c3944$var$limitCache[limitProperty]) $6ba7c7d2f96c3944$var$limitCache[limitProperty] = (0, $1Ozm9.default)(`/rest/servicedesk/latest/limit/${limitProperty}?_=${Date.now()}`).then(({ limit: limit })=>limit, (error)=>{
        // Will allow us to try again to fetch limit
        $6ba7c7d2f96c3944$export$c419786abd6faaad(limitProperty);
        (0, $eSnSE.default).safeWarnWithoutCustomerData('servicedesk.common.view.components.limit-data', `Failed to fetch limit for ${limitProperty}`);
        throw error;
    });
    return $6ba7c7d2f96c3944$var$limitCache[limitProperty];
};
class $6ba7c7d2f96c3944$export$9989835030ecd317 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { limitProperty: limitProperty } = this.props;
        const defaultLimit = $6ba7c7d2f96c3944$export$5ed1d2ac050e39d[limitProperty];
        $6ba7c7d2f96c3944$export$fb8ce379717a383d(limitProperty).then((limit)=>{
            this.updateLimit(limit || defaultLimit);
        }).catch(()=>{
            this.updateLimit(defaultLimit);
        });
    }
    updateLimit(newLimit) {
        this.setState(({ limit: oldLimit })=>oldLimit !== newLimit ? {
                limit: newLimit
            } : undefined);
    }
    render() {
        return this.props.children(this.state.limit);
    }
    constructor(...args){
        super(...args), this.state = {
            // Current consumers of LimitData expect typeof number so this cannot be an empty value.
            // This also voids limit messages showing until we have a reliable limit,
            // instead of showing then changing the value
            limit: Infinity
        };
    }
}
const $6ba7c7d2f96c3944$export$c5d8aa8a650e690f = (limitProperty, WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ba7c7d2f96c3944$export$9989835030ecd317, {
            limitProperty: limitProperty
        }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
                limit: limit,
                ...props
            }));

});



parcelRegister("lcKqP", function(module, exports) {

$parcel$export(module.exports, "addItem", () => $b807034c667acfd0$export$fb9705de59d96855);
$parcel$export(module.exports, "deleteItem", () => $b807034c667acfd0$export$8d8542dbbc23fe1a);
$parcel$export(module.exports, "editItem", () => $b807034c667acfd0$export$60832f4899fbf6a1);
$parcel$export(module.exports, "editItems", () => $b807034c667acfd0$export$8c896bccb18e1db1);
$parcel$export(module.exports, "moveItem", () => $b807034c667acfd0$export$ec937e64de6c1257);
$parcel$export(module.exports, "moveItemBelow", () => $b807034c667acfd0$export$17c7ebc966cf5476);
$parcel$export(module.exports, "moveItemAbove", () => $b807034c667acfd0$export$d54386016cadff45);
$parcel$export(module.exports, "moveToTop", () => $b807034c667acfd0$export$f2c5cc4c3f787c3e);
$parcel$export(module.exports, "enableSelectedQueuesVisibility", () => $b807034c667acfd0$export$ce58537552972d29);

var $gyBpf = parcelRequire("gyBpf");
const $b807034c667acfd0$export$fb9705de59d96855 = (source, item)=>[
        ...source,
        item
    ];
const $b807034c667acfd0$export$8d8542dbbc23fe1a = (source, id)=>{
    const result = source.slice();
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(result, {
        id: Number(id)
    });
    if (index >= 0) result.splice(index, 1);
    return result;
};
const $b807034c667acfd0$export$60832f4899fbf6a1 = (source, updatedItem)=>{
    const result = source.slice();
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(result, {
        id: updatedItem.id
    });
    if (index >= 0) result[index] = {
        ...result[index],
        ...updatedItem
    };
    return result;
};
const $b807034c667acfd0$export$8c896bccb18e1db1 = (source, updatedItems)=>{
    const result = source.slice();
    updatedItems.forEach((item)=>{
        const index = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(result, {
            id: item.id
        });
        if (index >= 0) result[index] = {
            ...result[index],
            ...item
        };
    });
    return result;
};
const $b807034c667acfd0$export$ec937e64de6c1257 = (source, from, to)=>{
    const result = source.slice();
    const item = result[from];
    if (from !== to && from >= 0) {
        result.splice(from, 1);
        result.splice(to, 0, item);
    }
    return result.map((page, order)=>({
            ...page,
            order: order
        }));
};
const $b807034c667acfd0$export$17c7ebc966cf5476 = (source, sourceId, targetId)=>{
    const result = source.slice();
    if (sourceId !== targetId) {
        const sourceIndex = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(result, {
            id: sourceId
        });
        if (sourceIndex >= 0) {
            const sourceQueue = result[sourceIndex];
            result.splice(sourceIndex, 1);
            const targetIndex = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(result, {
                id: targetId
            });
            if (targetIndex >= 0) {
                result.splice(targetIndex + 1, 0, sourceQueue);
                return result.map((page, order)=>({
                        ...page,
                        order: order
                    }));
            }
        }
    }
    return source;
};
const $b807034c667acfd0$export$d54386016cadff45 = (source, sourceId, targetId)=>{
    const result = source.slice();
    if (sourceId !== targetId) {
        const sourceIndex = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(result, {
            id: sourceId
        });
        if (sourceIndex >= 0) {
            const sourceQueue = result[sourceIndex];
            result.splice(sourceIndex, 1);
            const targetIndex = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(result, {
                id: targetId
            });
            if (targetIndex >= 0) {
                result.splice(targetIndex, 0, sourceQueue);
                return result.map((page, order)=>({
                        ...page,
                        order: order
                    }));
            }
        }
    }
    return source;
};
const $b807034c667acfd0$export$f2c5cc4c3f787c3e = (source, sourceId)=>{
    const result = source.slice();
    if (result.length === 0) return source;
    const index = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(result, {
        id: sourceId
    });
    if (index > 0) {
        const sourceQueue = result[index];
        result.splice(index, 1);
        result.splice(0, 0, sourceQueue);
        return result.map((page, order)=>({
                ...page,
                order: order
            }));
    }
    return source;
};
const $b807034c667acfd0$export$ce58537552972d29 = (selectedQueueIds, queues)=>queues.map((queue)=>{
        if (selectedQueueIds.some((selectedQueueId)=>selectedQueueId === queue.id)) {
            if (!queue.canBeHidden) return queue;
            return {
                ...queue,
                canBeHidden: false
            };
        }
        if (queue.canBeHidden) return queue;
        return {
            ...queue,
            canBeHidden: true
        };
    });

});
parcelRegister("gyBpf", function(module, exports) {

var $9gUEB = parcelRequire("9gUEB");

var $1lM9j = parcelRequire("1lM9j");

var $c9FP3 = parcelRequire("c9FP3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c0dcd66d5aa7faa7$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $c0dcd66d5aa7faa7$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $c9FP3(fromIndex);
    if (index < 0) index = $c0dcd66d5aa7faa7$var$nativeMax(length + index, 0);
    return $9gUEB(array, $1lM9j(predicate, 3), index);
}
module.exports = $c0dcd66d5aa7faa7$var$findIndex;

});






parcelRegister("frEjU", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $554723be8c7dc586$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $554723be8c7dc586$export$c7841d2c1c13065e);

var $eJOHy = parcelRequire("eJOHy");

var $2QUmO = parcelRequire("2QUmO");

var $aBIfT = parcelRequire("aBIfT");

var $lRq8t = parcelRequire("lRq8t");

var $1Z4EJ = parcelRequire("1Z4EJ");
const $554723be8c7dc586$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $1Z4EJ.default)[section])} - ${subsection} - ${formatMessage((0, $1Z4EJ.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $1Z4EJ.default)[section])} - ${formatMessage((0, $1Z4EJ.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DocumentTitle, {
        title: title
    });
};
const $554723be8c7dc586$export$c7841d2c1c13065e = (0, $2QUmO.default)($554723be8c7dc586$export$155581e8dc02007a, {
    DocumentTitle: (0, $aBIfT.DocumentTitle)
});
var $554723be8c7dc586$export$2e2bcd8739ae039 = $554723be8c7dc586$export$c7841d2c1c13065e;

});
parcelRegister("aBIfT", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $730554390b82eb2a$export$dd5ad0b65cf665da);

var $eJOHy = parcelRequire("eJOHy");

var $bJscI = parcelRequire("bJscI");

var $baxYj = parcelRequire("baxYj");
// eslint-disable-next-line jira/react/no-class-components
class $730554390b82eb2a$var$DocumentTitleOld extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $baxYj.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $baxYj.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $baxYj.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $730554390b82eb2a$export$dd5ad0b65cf665da = (0, $bJscI.componentWithFG)('jira-concurrent-document-title', (0, $baxYj.DocumentTitleHelper), $730554390b82eb2a$var$DocumentTitleOld);

});

parcelRegister("1Z4EJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $45f7fa370a8ee5d5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $45f7fa370a8ee5d5$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "External resources"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    projectSummary: {
        "id": "servicedesk-spa-commons.common.utils.document-title.project-summary",
        "defaultMessage": "Summary"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeys: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    },
    helpCenterForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-forms",
        "defaultMessage": "Forms"
    },
    helpCenterDetails: {
        "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-details",
        "defaultMessage": "Details"
    },
    virtualAgentAiAnswers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.ai-answers",
        "defaultMessage": "Atlassian Intelligence answers"
    },
    virtualAgentPerformance: {
        "id": "servicedesk-spa-commons.common.utils.document-title.performance",
        "defaultMessage": "Performance"
    },
    customerAccess: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-access",
        "defaultMessage": "Customer access"
    },
    articles: {
        "id": "servicedesk-spa-commons.common.utils.document-title.articles",
        "defaultMessage": "Articles"
    },
    createArticle: {
        "id": "servicedesk-spa-commons.common.utils.document-title.create-article",
        "defaultMessage": "Create articles"
    },
    viewArticle: {
        "id": "servicedesk-spa-commons.common.utils.document-title.view-article",
        "defaultMessage": "View article"
    },
    supportWebsite: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website",
        "defaultMessage": "Support website"
    },
    supportWebsiteOverview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website-overview",
        "defaultMessage": "Support website overview"
    },
    supportWebsitePages: {
        "id": "servicedesk-spa-commons.common.utils.document-title.support-website-pages",
        "defaultMessage": "Support website pages"
    },
    viewsSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.view-settings",
        "defaultMessage": "Views Settings"
    },
    customerServiceAgentOverview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-overview",
        "defaultMessage": "Customer Service Agent"
    },
    customerServiceAgentKnowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-knowledge",
        "defaultMessage": "Customer Service Agent Knowledge"
    },
    customerServiceAgentHandoff: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-handoff",
        "defaultMessage": "Customer Service Agent Handoff"
    },
    customerServiceAgentReview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-review",
        "defaultMessage": "Customer Service Agent Review"
    },
    customerServiceAgentSimulator: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-agent-simulator",
        "defaultMessage": "Customer Service Agent Test"
    },
    customerServiceFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-features",
        "defaultMessage": "Features"
    },
    getStarted: {
        "id": "servicedesk-spa-commons.common.utils.document-title.get-started",
        "defaultMessage": "Get started"
    },
    settingsOverview: {
        "id": "servicedesk-spa-commons.common.utils.document-title.settings-overview",
        "defaultMessage": "Settings overview"
    },
    widgetConfiguration: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget-configuration",
        "defaultMessage": "Embed"
    }
});

});


parcelRegister("9OCJd", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $0f1ed288f228d066$export$9c25024bdfe755f7);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $dZRaT = parcelRequire("dZRaT");

var $lvKO5 = parcelRequire("lvKO5");

var $5tgJD = parcelRequire("5tgJD");
const $0f1ed288f228d066$var$getProjectContextResource = ()=>(0, $dZRaT.projectContextResourceWithCache);
const $0f1ed288f228d066$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $bo7Z6.useResourceWithCustomRouterContext)($0f1ed288f228d066$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $5tgJD.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $eJOHy.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("5tgJD", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $c0c57c7bdd281961$export$712ead87353ac687);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $kgDPH = parcelRequire("kgDPH");
const $c0c57c7bdd281961$var$getServiceDeskContextResource = ()=>(0, $kgDPH.serviceDeskContextResource);
const $c0c57c7bdd281961$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $bo7Z6.useResourceWithCustomRouterContext)($c0c57c7bdd281961$var$getServiceDeskContextResource(), customContext);
    (0, $eJOHy.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});


parcelRegister("9aEyh", function(module, exports) {

$parcel$export(module.exports, "SpaPageWrapper", () => $a4faad3cc93b9c1a$export$577514961fbf4842);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $eSnSE = parcelRequire("eSnSE");

var $2QUmO = parcelRequire("2QUmO");

var $cZTMg = parcelRequire("cZTMg");

var $aV23b = parcelRequire("aV23b");

var $15sI9 = parcelRequire("15sI9");

var $cRgYj = parcelRequire("cRgYj");

var $kTpIs = parcelRequire("kTpIs");
const $a4faad3cc93b9c1a$export$91f88695e0d311a5 = (props)=>{
    const { projectContext: projectContext, isLoading: isLoading, error: error, children: children, AccessCheck: AccessCheck, AuthenticationCheck: AuthenticationCheck, ProjectNotFound: ProjectNotFound, ServiceHubNotFound: ServiceHubNotFound, GenericError: GenericError, SubProductUpdater: SubProductUpdater } = props;
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null);
    if (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jsdspa-page-wrapper', 'rendering-error-page', error);
        const isHelpCenterSettingsRoute = (0, $15sI9.isHelpCenterSettingsPath)();
        if (isHelpCenterSettingsRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ServiceHubNotFound, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(GenericError, null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AuthenticationCheck, null, error.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ProjectNotFound, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(GenericError, null));
    }
    if (projectContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SubProductUpdater, {
        subProduct: "serviceDesk"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AuthenticationCheck, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AccessCheck, null, children)));
    return null;
};
const $a4faad3cc93b9c1a$export$577514961fbf4842 = (0, $2QUmO.default)($a4faad3cc93b9c1a$export$91f88695e0d311a5, {
    AccessCheck: (0, $cRgYj.default),
    GenericError: (0, $kTpIs.GenericError),
    ProjectNotFound: (0, $kTpIs.ProjectNotFound),
    ServiceHubNotFound: (0, $kTpIs.ServiceHubNotFound),
    AuthenticationCheck: (0, $aV23b.AuthenticationCheck),
    SubProductUpdater: (0, $cZTMg.SubProductUpdater)
});
var $a4faad3cc93b9c1a$export$2e2bcd8739ae039 = $a4faad3cc93b9c1a$export$577514961fbf4842;

});
parcelRegister("cZTMg", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $e3e218a75c21102a$export$eb40d3df56aa5c53);

var $eJOHy = parcelRequire("eJOHy");

var $5onjV = parcelRequire("5onjV");

var $figsJ = parcelRequire("figsJ");

var $5nYJB = parcelRequire("5nYJB");

var $aO6tw = parcelRequire("aO6tw");

var $adiVF = parcelRequire("adiVF");
const $e3e218a75c21102a$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $adiVF.isSubProductProps)(props) ? props.subProduct : (0, $figsJ.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5onjV.default), {
        op: (0, $aO6tw.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5nYJB.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("5nYJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $82e051cbb2adac57$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3aa9n = parcelRequire("3aa9n");

var $8VfmF = parcelRequire("8VfmF");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$82e051cbb2adac57$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aa9n.default), {
        op: (0, $8VfmF.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("8VfmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $811461c69dc55236$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $jGzN3 = parcelRequire("jGzN3");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$811461c69dc55236$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $jGzN3.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("aO6tw", function(module, exports) {

$parcel$export(module.exports, "default", () => $53a2c520c0b2b632$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");


var $eSnSE = parcelRequire("eSnSE");

var $2Mqjh = parcelRequire("2Mqjh");
const $53a2c520c0b2b632$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$53a2c520c0b2b632$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $99993c16fc53d6ec$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $53a2c520c0b2b632$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4T9yL.waitForHeritage)() : null, ()=>(0, $97BGz.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $iyT45.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $eSnSE.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $99993c16fc53d6ec$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("adiVF", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $b41c599c0dbb9c69$export$c3063d6d7a8c075f);
const $b41c599c0dbb9c69$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("cRgYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9acb8d6ce1150b47$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");

var $15sI9 = parcelRequire("15sI9");


var $eHKlc = parcelRequire("eHKlc");

var $2IAE6 = parcelRequire("2IAE6");
const $9acb8d6ce1150b47$var$AccessCheck = ({ children: children })=>{
    const isSettingsRoute = (0, $hih5V.useCurrentRoute)().path.includes(`${(0, $23f0c315ae74645b$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
    const isHelpCenterSettingsRoute = (0, $15sI9.isHelpCenterSettingsPath)();
    const Gate = isSettingsRoute || isHelpCenterSettingsRoute ? (0, $2IAE6.default) : (0, $eHKlc.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Gate, null, children);
};
var $9acb8d6ce1150b47$export$2e2bcd8739ae039 = $9acb8d6ce1150b47$var$AccessCheck;

});
const $23f0c315ae74645b$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';
const $23f0c315ae74645b$export$16a37d277dff22d6 = '/jira/helpcenter/projects';

parcelRegister("eHKlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0feba71fc414b9a9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $iW0U8 = parcelRequire("iW0U8");

var $2mHfh = parcelRequire("2mHfh");
var $2FqDG = parcelRequire("2FqDG");

var $bz1rk = parcelRequire("bz1rk");
const $0feba71fc414b9a9$var$ProductAccessCheck = ({ children: children })=>{
    const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, $iW0U8.useApplicationPermissions)();
    const [projectKey = ''] = (0, $2FqDG.usePathParam)('projectKey');
    if (projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bz1rk.default), null, children);
    return hasServiceDeskAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
        to: "/jira"
    });
};
var $0feba71fc414b9a9$export$2e2bcd8739ae039 = $0feba71fc414b9a9$var$ProductAccessCheck;

});
parcelRegister("iW0U8", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $bdcb134d679d4aa6$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $bdcb134d679d4aa6$export$4d9cadb4042acc1b);

var $ahm5r = parcelRequire("ahm5r");

var $ht3nQ = parcelRequire("ht3nQ");

var $7NgPv = parcelRequire("7NgPv");

var $lvKO5 = parcelRequire("lvKO5");
const $bdcb134d679d4aa6$var$selector = (0, $ahm5r.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $bdcb134d679d4aa6$export$d8c76f7e52d0a856 = (0, $ht3nQ.createSubscriber)((0, $7NgPv.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $bdcb134d679d4aa6$var$selector
});
const $bdcb134d679d4aa6$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});

parcelRegister("bz1rk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac657e33735836c8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2mHfh = parcelRequire("2mHfh");
var $2FqDG = parcelRequire("2FqDG");

var $5tgJD = parcelRequire("5tgJD");


var $48sCU = parcelRequire("48sCU");
const $ac657e33735836c8$var$AgentCheck = ({ children: children })=>{
    const [projectKey = ''] = (0, $2FqDG.usePathParam)('projectKey');
    const [{ data: data, error: error }] = (0, $5tgJD.useServiceDeskContext)();
    if (data || error) {
        // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
        if (!(0, $48sCU.isAccessError)(error)) {
            const { userRole: userRole = '' } = data || {};
            if (userRole === 'agent' || userRole === 'agent-project-admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
            if (error) throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
            to: `${(0, $23f0c315ae74645b$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
        });
    }
    return null;
};
var $ac657e33735836c8$export$2e2bcd8739ae039 = $ac657e33735836c8$var$AgentCheck;

});
parcelRegister("48sCU", function(module, exports) {

$parcel$export(module.exports, "isAccessError", () => $82736d0d849445f1$export$ddaebe4928e793cb);

const $82736d0d849445f1$var$RESTRICTED_ACCESS_CODES = [
    (0, $44ccf6b895337c89$export$a3269a3914b007e3),
    (0, $44ccf6b895337c89$export$8bca792d963eb0ef),
    (0, $44ccf6b895337c89$export$67d19e9a991baa07)
];
const $82736d0d849445f1$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $82736d0d849445f1$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;

});



parcelRegister("2IAE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b362d04aa287a4d8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $15sI9 = parcelRequire("15sI9");

var $kTpIs = parcelRequire("kTpIs");

var $5tgJD = parcelRequire("5tgJD");

var $48sCU = parcelRequire("48sCU");
const $b362d04aa287a4d8$var$SettingsAccessCheck = ({ children: children })=>{
    const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, $5tgJD.useServiceDeskContext)();
    const userRole = serviceDeskContext?.userRole;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type '{ statusCode?: number | undefined; } | null'.
    const hasAccessError = (0, $48sCU.isAccessError)(serviceDeskContextError);
    // Service desk context is updated on every route change
    // If context fails to give us an indicative result (e.g. fetch failed, 500 error)
    // We will continue to use current value to assess permissions
    if (userRole === 'agent-project-admin' && !hasAccessError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    if (userRole !== undefined || hasAccessError) {
        const isHelpCenterSettingsRoute = (0, $15sI9.isHelpCenterSettingsPath)();
        if (isHelpCenterSettingsRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kTpIs.ServiceHubNotFound), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kTpIs.ProjectNotFound), null);
    }
    if (serviceDeskContextError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kTpIs.GenericError), null);
    return null;
};
var $b362d04aa287a4d8$export$2e2bcd8739ae039 = $b362d04aa287a4d8$var$SettingsAccessCheck;

});
parcelRegister("kTpIs", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $b25c7ab73fa3b343$export$849d319c342682a2);
$parcel$export(module.exports, "ServiceHubNotFound", () => $b25c7ab73fa3b343$export$1fbf518ac538659c);
$parcel$export(module.exports, "GenericError", () => $b25c7ab73fa3b343$export$7d465be8efa67280);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $6MnLl = parcelRequire("6MnLl");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $fiPhB = parcelRequire("fiPhB");

var $67Itv = parcelRequire("67Itv");

var $aBIfT = parcelRequire("aBIfT");

var $dymbf = parcelRequire("dymbf");

var $2xwuX = parcelRequire("2xwuX");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $c9uTK = parcelRequire("c9uTK");

var $7jTnu = parcelRequire("7jTnu");

var $eCNkv = parcelRequire("eCNkv");
const $b25c7ab73fa3b343$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBIfT.DocumentTitle), {
        title: formatMessage((0, $eCNkv.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        renderImage: (0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $2xwuX.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $eCNkv.default).notFoundTitle),
        description: formatMessage((0, $eCNkv.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
            to: projectsPath
        }, formatMessage((0, $eCNkv.default).notFoundAction))
    }));
};
const $b25c7ab73fa3b343$export$1fbf518ac538659c = ()=>{
    const projectsPath = '/jira/projects';
    const customerHubsPath = '/jira/helpcenter';
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBIfT.DocumentTitle), {
        title: formatMessage((0, $7jTnu.fg)('jcs_project_type_m3') ? (0, $eCNkv.default).customerHubNotFoundDocumentTitleJsm : (0, $eCNkv.default).serviceHubNotFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        renderImage: (0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $2xwuX.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $7jTnu.fg)('jcs_project_type_m3') ? (0, $eCNkv.default).customerHubNotFoundTitle : (0, $eCNkv.default).serviceHubNotFoundTitle),
        description: formatMessage((0, $7jTnu.fg)('jcs_project_type_m3') ? (0, $eCNkv.default).customerHubNotFoundDescription : (0, $eCNkv.default).serviceHubNotFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
            to: (0, $7jTnu.fg)('jcs_project_type_m3') ? customerHubsPath : projectsPath
        }, formatMessage((0, $7jTnu.fg)('jcs_project_type_m3') ? (0, $eCNkv.default).customerHubNotFoundAction : (0, $eCNkv.default).serviceHubNotFoundAction))
    }));
};
const $b25c7ab73fa3b343$export$7d465be8efa67280 = ()=>{
    const interactionId = (0, $eJOHy.useContext)((0, $kVpZx.default)).current;
    const labelStack = (0, $eJOHy.useContext)((0, $7aoMz.default))?.labelStack;
    const traceId = (0, $eJOHy.useMemo)(()=>{
        const traceContext = (0, $fiPhB.getActiveTrace)();
        return traceContext?.traceId;
    }, []);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let description = formatMessage((0, $eCNkv.default).genericErrorDescription);
    if (traceId) {
        const error = new Error('An error occurred while loading this page');
        description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $b25c7ab73fa3b343$var$styles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $67Itv.ErrorHashAndTraceId), {
            error: error,
            traceId: traceId
        })));
        if ((0, $7jTnu.fg)('add_ufo_error_in_service_desk_genericerror')) {
            const name = 'serviceDeskGenericError';
            if (interactionId) {
                (0, $2QO3b.addError)(interactionId, name, labelStack ?? null, error.name, error.message, error.stack);
                // NOTE: to account for awaiting BM3 TTI in UFO code, however we don't need to wait for BM3 TTI when there is an error
                // https://atlassian.slack.com/archives/C01AY8132S3/p1736380314352749?thread_ts=1736377740.484469&cid=C01AY8132S3
                const activeInteraction = (0, $2QO3b.getActiveInteraction)();
                activeInteraction?.holdActive.forEach((_, holdId)=>{
                    (0, $2QO3b.removeHoldByID)(activeInteraction.id, holdId);
                });
            } else (0, $2QO3b.addErrorToAll)(name, labelStack ?? null, error.name, error.message, error.stack);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBIfT.DocumentTitle), {
        title: formatMessage((0, $eCNkv.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        renderImage: (0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $dymbf.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $eCNkv.default).genericErrorTitle),
        description: description
    }));
};
const $b25c7ab73fa3b343$var$styles = (0, $1DXK0.xcss)({
    marginTop: 'space.100'
});

});
parcelRegister("67Itv", function(module, exports) {

$parcel$export(module.exports, "ErrorHashAndTraceId", () => $48c0b83f12296971$export$61354a7dde2c2d3c);

var $eJOHy = parcelRequire("eJOHy");

var $iqtgH = parcelRequire("iqtgH");

var $2HRPu = parcelRequire("2HRPu");

var $5FGOI = parcelRequire("5FGOI");
const $48c0b83f12296971$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
    const errorHash = (0, $2HRPu.getErrorHash)(error);
    const source = `Hash ${errorHash}\nTrace ${traceId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireOperationalAnalytics), {
        action: "rendered",
        actionSubject: "errorHashAndTraceId",
        attributes: {
            errorHash: errorHash,
            traceId: traceId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5FGOI.CodeBlockWithCopyButton), {
        source: source,
        copyCodeActionSubjectId: "copyErrorHashAndTraceId"
    })));
};

});
parcelRegister("5FGOI", function(module, exports) {

$parcel$export(module.exports, "CodeBlockWithCopyButton", () => $5b00377b96dcd0a0$export$ced1fc74d907d387);

var $eJOHy = parcelRequire("eJOHy");

var $JQPCf = parcelRequire("JQPCf");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6Rkh0 = parcelRequire("6Rkh0");
const $5b00377b96dcd0a0$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5b00377b96dcd0a0$var$wrapperStyles,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Rkh0.ActionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Rkh0.CopyAction), {
        source: source,
        actionSubjectId: copyCodeActionSubjectId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $JQPCf.default), {
        text: source,
        showLineNumbers: false,
        shouldWrapLongLines: false
    })));
const $5b00377b96dcd0a0$var$wrapperStyles = (0, $1DXK0.xcss)({
    width: '100%',
    position: 'relative'
});

});
parcelRegister("JQPCf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d29b310f5adcbb7$export$2e2bcd8739ae039);
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4eDgu = parcelRequire("4eDgu");

var $bRPNB = parcelRequire("bRPNB");

var $1wVTG = parcelRequire("1wVTG");

var $gvE0s = parcelRequire("gvE0s");

var $2qMvj = parcelRequire("2qMvj");

var $9LvmA = parcelRequire("9LvmA");
const $9d29b310f5adcbb7$var$getCodeBlockStyles = {
    root: "_2rkoglpi _1dqoglyw _1wyb1crf _k48pi7a9 _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhktkvp _syaz1fxt _ect41odn _1ozdn7od _7xinn7od _t7aun7od _1v15u2gc _ilvcu2gc _m29uu2gc _17wyu2gc _pn28u2gc _gz9fu2gc _1hmyegat _vblregat _vbulegat _wozj1yev _1agb1yev _lkm81yev _tv41hkgb _1hmimyb0 _1ra01n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _j1w0ww7y _13cdh2mm _15ba126e _zvy9f705 _qcxof705 _14y71a66 _j0l11wug _1weckb7n _1na21hna _1xx2grf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909m7j4 _scgayz1z _ipl81e17 _jeky1l04 _1gec1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _1552u2gc _12afu2gc _28ddu2gc _1i8zu2gc _12tu1a66 _zu0j1a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgcpf9b _bu7zpf9b _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3moej _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eiht5x2v _t9zb5x2v _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t361fxt _137bh55r _1k7d1fxt _97lipnps _12nh9lu1 _1g0517qg _i2ig10m5 _326z1fxt _113p131l _1n6tpnps _tgu817qg _1k47pnps _g0lx1fxt _ys4e131l _7gp8h55r _1yvq10m5 _1vww10m5 _1rju10m5 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o610m5 _kxov17qg _1np517qg _m2f517qg _1b9tpnps _1tq6pnps _1rd2pnps _1pbkpnps _k3lipnps _13zt131l _2g12fb2s _k86b10m5 _b5iy131l _gti3131l _1f0gpnps _9d3e17qg _qdiapnps _72uvpnps",
    showLineNumbers: "_170714ej _1i3h1txw _1huoidpf _1a9lidpf _20bqidpf _1oggidpf _bympidpf _9nnjidpf",
    dontShowLineNumbers: "_1i3h1ule _1huou2gc _1a9lu2gc _20bqu2gc _1oggu2gc _bympu2gc _9nnju2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $9d29b310f5adcbb7$var$CodeBlock = /*#__PURE__*/ (0, $eJOHy.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $eJOHy.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $eJOHy.useState)(false);
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $gvE0s.getLineNumWidth)(numLines) : 0;
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $eJOHy.useEffect)(()=>{
        const schedule = (0, $bRPNB.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $4eDgu.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $1wVTG.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $eJOHy.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $eJOHy.useMemo)(()=>(0, $2qMvj.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9LvmA.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $hcewu.default)([
            $9d29b310f5adcbb7$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $9d29b310f5adcbb7$var$getCodeBlockStyles.shouldWrapLongLines : $9d29b310f5adcbb7$var$getCodeBlockStyles.dontWrapLongLines,
            showLineNumbers ? $9d29b310f5adcbb7$var$getCodeBlockStyles.showLineNumbers : $9d29b310f5adcbb7$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $9d29b310f5adcbb7$export$2e2bcd8739ae039 = $9d29b310f5adcbb7$var$CodeBlock;

});
parcelRegister("1wVTG", function(module, exports) {

$parcel$export(module.exports, "useHighlightLines", () => $118a07406fdcc42b$export$84415a200bdf33ed);

var $eJOHy = parcelRequire("eJOHy");
const $118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $118a07406fdcc42b$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $118a07406fdcc42b$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $118a07406fdcc42b$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $eJOHy.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $eJOHy.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $118a07406fdcc42b$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("gvE0s", function(module, exports) {

$parcel$export(module.exports, "getLineNumWidth", () => $505da49d0d7d5a0b$export$cb7aec0206b595d2);
const $505da49d0d7d5a0b$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};

});

parcelRegister("2qMvj", function(module, exports) {

$parcel$export(module.exports, "normalizeLanguage", () => $aca27a94c0d64a9d$export$f38728011c178796);

var $LFmXM = parcelRequire("LFmXM");

var $236Qa = parcelRequire("236Qa");
const $aca27a94c0d64a9d$export$f38728011c178796 = (0, $LFmXM.default)((language)=>{
    if (!language) return '';
    const match = (0, $236Qa.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("236Qa", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $32521280e8fb1b12$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $32521280e8fb1b12$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    }
];

});


parcelRegister("9LvmA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cdbe531236814ef$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $2Csjy = parcelRequire("2Csjy");
var $5cdbe531236814ef$export$2e2bcd8739ae039 = (0, $2Csjy.default);

});
parcelRegister("2Csjy", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a371b7eb48e23c4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9JmNq = parcelRequire("9JmNq");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $1a371b7eb48e23c4$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $9JmNq.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $gt9Am.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $1a371b7eb48e23c4$var$asyncGenerator = $1a371b7eb48e23c4$var$generator({
    loader: ()=>(parcelRequire("5vjXJ")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $1a371b7eb48e23c4$export$2e2bcd8739ae039 = $1a371b7eb48e23c4$var$asyncGenerator;

});
parcelRegister("9JmNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb3e56997f5681d6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $31Mrt = parcelRequire("31Mrt");

var $aRMho = parcelRequire("aRMho");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $bb3e56997f5681d6$var$Highlight = /*#__PURE__*/ (0, $eJOHy.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $31Mrt.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $aRMho.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $bb3e56997f5681d6$export$2e2bcd8739ae039 = $bb3e56997f5681d6$var$Highlight;

});
parcelRegister("31Mrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9006a9331ecad2$export$2e2bcd8739ae039);

var $iWzFr = parcelRequire("iWzFr");

var $8RUxU = parcelRequire("8RUxU");

var $26DGa = parcelRequire("26DGa");

var $f2iL7 = parcelRequire("f2iL7");
const $ad9006a9331ecad2$var$newLineRegex = /\n/g;
function $ad9006a9331ecad2$var$getNewLines(str) {
    return str.match($ad9006a9331ecad2$var$newLineRegex);
}
function $ad9006a9331ecad2$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $f2iL7.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $iWzFr.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $26DGa.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $ad9006a9331ecad2$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $8RUxU.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $8RUxU.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("iWzFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4195943504268cef$export$2e2bcd8739ae039);

var $8RUxU = parcelRequire("8RUxU");

var $cyPrZ = parcelRequire("cyPrZ");
function $4195943504268cef$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $8RUxU.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $cyPrZ.default)(lineNumber));
            return children;
        }
    };
}
var $4195943504268cef$export$2e2bcd8739ae039 = $4195943504268cef$var$createLineGenerator;

});
parcelRegister("8RUxU", function(module, exports) {

$parcel$export(module.exports, "default", () => $20548ef38714ae82$export$2e2bcd8739ae039);

var $cyPrZ = parcelRequire("cyPrZ");
function $20548ef38714ae82$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && showLineNumbers) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $cyPrZ.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $cyPrZ.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("cyPrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $03d9e4c0cc14d81b$export$2e2bcd8739ae039);
function $03d9e4c0cc14d81b$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("26DGa", function(module, exports) {

$parcel$export(module.exports, "default", () => $380a054e11b3c43e$export$2e2bcd8739ae039);

var $8RUxU = parcelRequire("8RUxU");
function $380a054e11b3c43e$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $8RUxU.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $380a054e11b3c43e$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("f2iL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a951287c386786be$export$2e2bcd8739ae039);
function $a951287c386786be$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("aRMho", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ec570abb3fe649d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $JWUl7 = parcelRequire("JWUl7");
function $9ec570abb3fe649d$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $JWUl7.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});
parcelRegister("JWUl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed639690821efdab$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hDNIq = parcelRequire("hDNIq");

var $2E9Su = parcelRequire("2E9Su");

var $a4ixf = parcelRequire("a4ixf");
function $ed639690821efdab$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $ed639690821efdab$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $2E9Su.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDNIq.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $a4ixf.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $ed639690821efdab$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("hDNIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef15aa1302d4294$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $6JdWh = parcelRequire("6JdWh");
function $9ef15aa1302d4294$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: label,
        tag: $9ef15aa1302d4294$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6JdWh.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: skipChildren ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6JdWh.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: skipChildren ? null : bidiCharacter
    });
}
const $9ef15aa1302d4294$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("6JdWh", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $773f36c924fc369d$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6fs4r = parcelRequire("6fs4r");
const $773f36c924fc369d$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $773f36c924fc369d$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $773f36c924fc369d$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $hcewu.default)([
                    $773f36c924fc369d$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $773f36c924fc369d$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("2E9Su", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb505789c157e144$export$2e2bcd8739ae039);
const $fb505789c157e144$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $fb505789c157e144$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($fb505789c157e144$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("a4ixf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0ac4ebb91026fe6$export$2e2bcd8739ae039);

var $JWUl7 = parcelRequire("JWUl7");
function $e0ac4ebb91026fe6$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $JWUl7.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("5vjXJ", function(module, exports) {

let $401f551c179f054d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $401f551c179f054d$var$load("5sFLQ").then(()=>parcelRequire('5eKjD'));

});




parcelRegister("6Rkh0", function(module, exports) {

$parcel$export(module.exports, "CopyAction", () => $9a0c7740a5069a8b$export$958df07cbf9735fc);
$parcel$export(module.exports, "ActionContainer", () => $9a0c7740a5069a8b$export$37ab3bdebc286ca);

var $eJOHy = parcelRequire("eJOHy");

var $48q59 = parcelRequire("48q59");

var $4TA31 = parcelRequire("4TA31");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $gCeeo = parcelRequire("gCeeo");

var $cTNKB = parcelRequire("cTNKB");
const $9a0c7740a5069a8b$export$2ce9877c9c1aa16 = {
    PROMPT: 'Copy',
    SUCCESS: 'Copied!',
    FAILURE: 'Copy to clipboard failed'
};
const $9a0c7740a5069a8b$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)($9a0c7740a5069a8b$export$2ce9877c9c1aa16.PROMPT);
    const handleSuccess = (0, $eJOHy.useCallback)(()=>{
        setTooltipMessage($9a0c7740a5069a8b$export$2ce9877c9c1aa16.SUCCESS);
    }, [
        setTooltipMessage
    ]);
    const handleError = (0, $eJOHy.useCallback)(()=>{
        setTooltipMessage($9a0c7740a5069a8b$export$2ce9877c9c1aa16.FAILURE);
    }, [
        setTooltipMessage
    ]);
    const writeToClipboard = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        actionSubjectId && (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(source).then(handleSuccess, handleError);
    }, [
        source,
        handleSuccess,
        handleError,
        actionSubjectId
    ]);
    const resetMessage = (0, $eJOHy.useCallback)(()=>{
        setTooltipMessage($9a0c7740a5069a8b$export$2ce9877c9c1aa16.PROMPT);
    }, [
        setTooltipMessage
    ]);
    function shouldRender() {
        if (typeof document !== 'undefined') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return Boolean(navigator?.clipboard?.writeText);
    }
    return shouldRender() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cTNKB.Action), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4TA31))),
        label: tooltipMessage,
        onClick: writeToClipboard,
        onMouseOver: resetMessage,
        onFocus: resetMessage,
        "aria-live": "assertive",
        "aria-atomic": "true",
        name: "Copy"
    }) : null;
};
const $9a0c7740a5069a8b$var$stopPropagation = (event)=>event.stopPropagation();
const $9a0c7740a5069a8b$export$37ab3bdebc286ca = ({ children: children })=>/**
	 * This element uses an `onMouseDown` to block event propagation
	 * to its parent but is not itself interactive.
	 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a0c7740a5069a8b$var$absolutePositionWrapperStyles,
        onMouseDown: $9a0c7740a5069a8b$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), {
        label: "actions"
    }, children));
const $9a0c7740a5069a8b$var$absolutePositionWrapperStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});

});
parcelRegister("4TA31", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746afd86dff7a846534476462b8fe4e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $390842c9527311f0$var$_react = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $390842c9527311f0$var$_copy = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("lGr6J")));

var $390842c9527311f0$var$_copy2 = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("hZKKB")));
function $390842c9527311f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $390842c9527311f0$var$CopyIcon = (props)=>/*#__PURE__*/ $390842c9527311f0$var$_react.default.createElement($390842c9527311f0$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $390842c9527311f0$var$_copy2.default
    }, props));
$390842c9527311f0$var$CopyIcon.Name = 'CopyIconMigration';
var $390842c9527311f0$var$_default = module.exports.default = $390842c9527311f0$var$CopyIcon;

});
parcelRegister("lGr6J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc928c338a001a7a$var$_react = $fc928c338a001a7a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc928c338a001a7a$var$_baseNew = $fc928c338a001a7a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fc928c338a001a7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc928c338a001a7a$var$CopyIcon = (props)=>/*#__PURE__*/ $fc928c338a001a7a$var$_react.default.createElement($fc928c338a001a7a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$fc928c338a001a7a$var$CopyIcon.displayName = 'CopyIcon';
var $fc928c338a001a7a$var$_default = module.exports.default = $fc928c338a001a7a$var$CopyIcon;

});

parcelRegister("hZKKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d19c65e3fa3f02f9$var$_react = $d19c65e3fa3f02f9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $d19c65e3fa3f02f9$var$_copy = $d19c65e3fa3f02f9$var$_interopRequireDefault((parcelRequire("lGr6J")));
function $d19c65e3fa3f02f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d19c65e3fa3f02f9$var$CopyIcon = (props)=>/*#__PURE__*/ $d19c65e3fa3f02f9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $d19c65e3fa3f02f9$var$_copy.default
    }));
$d19c65e3fa3f02f9$var$CopyIcon.displayName = 'CopyIcon';
var $d19c65e3fa3f02f9$var$_default = module.exports.default = $d19c65e3fa3f02f9$var$CopyIcon;

});


parcelRegister("cTNKB", function(module, exports) {

$parcel$export(module.exports, "Action", () => $655e96293892c69e$export$e19cd5f9376f8cee);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $k71qx = parcelRequire("k71qx");
const $655e96293892c69e$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
    const updateTooltip = (0, $eJOHy.useRef)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel,
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel || label;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        isLoading: isLoading,
        appearance: "subtle",
        icon: icon,
        label: label,
        spacing: "compact",
        ...buttonProps
    }));
};

});




parcelRegister("dymbf", function(module, exports) {

$parcel$export(module.exports, "default", () => $42825a5af59db372$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $42825a5af59db372$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6FdCu")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6GQY3")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $c4huj = parcelRequire("c4huj");

var $6GQY3 = parcelRequire("6GQY3");

var $6FdCu = parcelRequire("6FdCu");
const $42825a5af59db372$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6FdCu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6GQY3))
});
var $42825a5af59db372$export$2e2bcd8739ae039 = $42825a5af59db372$var$Illustration;
// for advanced use only
const $42825a5af59db372$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("6GQY3", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("6FdCu", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("2xwuX", function(module, exports) {

$parcel$export(module.exports, "default", () => $fff5857cff93a3f5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("49hnp")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("49hnp")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $c4huj = parcelRequire("c4huj");

var $49hnp = parcelRequire("49hnp");
const $fff5857cff93a3f5$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($49hnp)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($49hnp))
});
var $fff5857cff93a3f5$export$2e2bcd8739ae039 = $fff5857cff93a3f5$var$Illustration;
// for advanced use only
const $fff5857cff93a3f5$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("49hnp", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("eCNkv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f26007e3784d8101$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f26007e3784d8101$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    },
    serviceHubNotFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-document-title-jsm",
        "defaultMessage": "Service hub not found - Service project"
    },
    serviceHubNotFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-title",
        "defaultMessage": "This service hub isn't available"
    },
    serviceHubNotFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    serviceHubNotFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.servicehub-not-found-action",
        "defaultMessage": "View a list of all service hubs"
    },
    customerHubNotFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-document-title-jsm",
        "defaultMessage": "Customer hub not found - Service project"
    },
    customerHubNotFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-title",
        "defaultMessage": "This customer hub isn't available"
    },
    customerHubNotFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-description",
        "defaultMessage": "It might have been deleted or your permissions may have changed."
    },
    customerHubNotFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.customer-hub-not-found-action",
        "defaultMessage": "View all customer hubs"
    }
});

});





parcelRegister("anCpx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceda33cf3736231b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7kixv = parcelRequire("7kixv");
parcelRequire("1AyD5");

var $5SwkH = parcelRequire("5SwkH");

var $83DiZ = parcelRequire("83DiZ");
/* Intended usage is to replace direct usage of history.push from react-dom-router with a Jira SPA compatible push history */ const $ceda33cf3736231b$var$QueuesPushProvider = (props)=>{
    const { projectKey: projectKey, children: children } = props;
    const { push: push, replace: replace } = (0, $83DiZ.useRouterActions)();
    const pushWithSpaCompatibleUrl = (0, $eJOHy.useCallback)((path)=>{
        const pathWithLeadingSlash = path.charAt(0) === '/' ? `${path}` : `/${path}`;
        let fullPath = pathWithLeadingSlash;
        // Don't update the url if it is already in the right format
        if (pathWithLeadingSlash.indexOf('/jira/servicedesk/projects') !== 0) fullPath = `/jira/servicedesk/projects/${projectKey}${pathWithLeadingSlash}`;
        push(fullPath);
        // Some existing consumers in queues expect this to return an observable
        return (0, $7kixv.Observable).empty();
    }, [
        projectKey,
        push
    ]);
    const navigateWithProjectKey = (0, $eJOHy.useCallback)((path)=>(0, $5SwkH.navigate)(projectKey, path), [
        projectKey
    ]);
    if (!projectKey) return children({
        push: undefined
    });
    return __SPA__ ? children({
        push: pushWithSpaCompatibleUrl,
        replace: replace
    }) : children({
        push: navigateWithProjectKey
    });
};
var $ceda33cf3736231b$export$2e2bcd8739ae039 = $ceda33cf3736231b$var$QueuesPushProvider;

});

parcelRegister("akiS9", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $50b865cde2c2d004$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $50b865cde2c2d004$export$2a999c5f84501025);

var $6uWhG = parcelRequire("6uWhG");
const $50b865cde2c2d004$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $50b865cde2c2d004$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($50b865cde2c2d004$export$8e54fca0a680fdfd);
        (0, $6uWhG.setMark)($50b865cde2c2d004$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("iq8v9", function(module, exports) {

$parcel$export(module.exports, "useOnFavoritesChanged", () => $3e60ac89d6759023$export$ddf44c597e03063d);

var $eJOHy = parcelRequire("eJOHy");

var $6kS6u = parcelRequire("6kS6u");

var $40zJW = parcelRequire("40zJW");

var $aMJA4 = parcelRequire("aMJA4");

var $beI5n = parcelRequire("beI5n");
const $3e60ac89d6759023$export$ddf44c597e03063d = (projectKey, category, queues, callback)=>{
    const { items: items } = (0, $eJOHy.useContext)((0, $beI5n.FavoriteChangeContext));
    const queueItemChanges = items[0, $aMJA4.QUEUES_ITEM_TYPE];
    const previousChangesRef = (0, $eJOHy.useRef)({
        projectKey: projectKey,
        category: category,
        changedItems: undefined
    });
    const { current: previousChanges } = previousChangesRef;
    const hasPotentialChanges = previousChanges.projectKey !== projectKey || previousChanges.category !== category || previousChanges.changedItems !== queueItemChanges;
    if (hasPotentialChanges) {
        previousChangesRef.current = {
            projectKey: projectKey,
            category: category,
            changedItems: queueItemChanges
        };
        if (queues) (0, (/*@__PURE__*/$parcel$interopDefault($40zJW)))(queueItemChanges).forEach(({ id: id, value: value })=>{
            const queue = (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(queues, {
                id: Number(id)
            });
            if (queue && queue.favourite !== value) callback(id, value);
        });
    }
};

});
parcelRegister("6kS6u", function(module, exports) {

var $dSzgR = parcelRequire("dSzgR");

var $gyBpf = parcelRequire("gyBpf");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $49ce942e5e13bbf0$var$find = $dSzgR($gyBpf);
module.exports = $49ce942e5e13bbf0$var$find;

});
parcelRegister("dSzgR", function(module, exports) {

var $1lM9j = parcelRequire("1lM9j");

var $7H30b = parcelRequire("7H30b");

var $4c94y = parcelRequire("4c94y");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a1abad92a1851e60$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$7H30b(collection)) {
            var iteratee = $1lM9j(predicate, 3);
            collection = $4c94y(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a1abad92a1851e60$var$createFind;

});



parcelRegister("230Dj", function(module, exports) {

$parcel$export(module.exports, "pageToQueues", () => $f69b790c2527f096$export$8ada91ce992fa66f);

var $2IsS5 = parcelRequire("2IsS5");
const $f69b790c2527f096$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.title,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $f69b790c2527f096$export$8ada91ce992fa66f = (page)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    page.reduce((acc, queue)=>{
        acc[queue.id] = {
            id: (0, $2IsS5.toQueueId)(queue.id),
            name: queue.name,
            jql: queue.jql,
            completeJql: queue.completeJql,
            order: queue.order,
            columns: $f69b790c2527f096$var$transformColumns(queue.columnsDetails),
            // British spelling from legacy Backend code
            isFavorite: queue.favourite,
            category: queue.category,
            canBeHidden: queue.canBeHidden
        };
        return acc;
    }, {});

});


parcelRegister("lFXu9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21686acb9dff0ab$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $LFmXM = parcelRequire("LFmXM");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $d129d = parcelRequire("d129d");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $iWhpv = parcelRequire("iWhpv");

var $8pvq9 = parcelRequire("8pvq9");

var $hV8jN = parcelRequire("hV8jN");

var $lnCC0 = parcelRequire("lnCC0");

var $ek6C2 = parcelRequire("ek6C2");

var $df3xt = parcelRequire("df3xt");

var $9KGpI = parcelRequire("9KGpI");

var $lRxpy = parcelRequire("lRxpy");

var $ljej9 = parcelRequire("ljej9");

var $16sa1 = parcelRequire("16sa1");

var $6zXPf = parcelRequire("6zXPf");

var $jiD6s = parcelRequire("jiD6s");
const $d21686acb9dff0ab$var$SEGMENT_KEY = 'queues-agent-view-top-layout-nav4';
const $d21686acb9dff0ab$var$SEGMENT_KEY_OLD = 'queues-agent-view-top-layout';
const $d21686acb9dff0ab$var$deprecatedAgentViewProps = {
    onAtLeastOneIssueLoaded: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
const $d21686acb9dff0ab$var$getInitialState = (0, $LFmXM.default)((_queue)=>{
    // Only change the reference of initial state when we transition to a new queue, to avoid unnecessary re-renders
    // This shape of prop is required to be compatible what the AgentView expects in the non-spa
    // When JSD agent view is in the SPA by the default we can probably just pass appProps directly
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const initialState = {};
    return (0, $LFmXM.default)((appProps)=>{
        initialState.appProps = appProps;
        return initialState;
    });
});
const $d21686acb9dff0ab$var$PageWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingInline: "space.500",
        testId: "spa-apps-servicedesk-queues-agent-view.ui.content.layout",
        "data-vc": "queues-agent-view-layout-outer-container-fallback-ssr",
        ...false ? {
            'data-ssr-placeholder': 'queues-agent-view-layout-outer-container-fallback-placeholder'
        } : {
            'data-ssr-placeholder-replace': 'queues-agent-view-layout-outer-container-fallback-placeholder'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d129d.default), null, children));
const $d21686acb9dff0ab$var$QueuesAgentViewContent = ({ queuesData: queuesData, queueId: queueId, push: push, pageContext: pageContext, isQueueVisible: isQueueVisible, isAgentViewMountedRef: isAgentViewMountedRef, onIssuesChanged: onIssuesChanged, onIssuesCountChanged: onIssuesCountChanged })=>{
    (0, $eJOHy.useEffect)(()=>{
        if (isAgentViewMountedRef) {
            // eslint-disable-next-line no-param-reassign, react-hooks/react-compiler
            isAgentViewMountedRef.current = true;
            return ()=>{
                // eslint-disable-next-line no-param-reassign
                isAgentViewMountedRef.current = false;
            };
        }
        return 0, (/*@__PURE__*/$parcel$interopDefault($12DRg));
    });
    const { data: isItsmProject } = (0, $iWhpv.useIsItsmTemplateProject)();
    const { canSeeNewIssueView: canSeeNewIssueView, isSiteAdmin: isSiteAdmin, userRole: userRole, serviceDeskId: serviceDeskId, ...appProps } = pageContext;
    const [state] = (0, $hV8jN.useProjectBuilder)();
    const { shouldUseStylingPatch: shouldShowContainer } = (0, $lRxpy.useStylingPatch)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isItsmProject === true && !state.isProjectBuilderOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lnCC0.ProjectTour), {
        projectId: (0, $ljej9.toProjectId)(`${pageContext.projectId}`),
        portalUrl: pageContext.portalUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $df3xt.default), {
        queuesDataSource: queuesData,
        baseUrl: "",
        queueId: queueId,
        projectKey: pageContext.projectKey
    }, (queue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ek6C2.default), {
            ...$d21686acb9dff0ab$var$deprecatedAgentViewProps,
            // @ts-expect-error - TS2741 - Property 'appProps' is missing in type 'Record<string, any>' but required in type 'InitialState'.
            initialState: $d21686acb9dff0ab$var$getInitialState(queue)(appProps),
            locale: pageContext.locale,
            isQueueVisible: isQueueVisible,
            queue: queue,
            push: push,
            // set onQueueRenderFailure - undefined to satisfy flow (ignored prop)
            onQueueRenderFailure: undefined,
            onIssuesChanged: onIssuesChanged,
            onIssuesCountChanged: onIssuesCountChanged
        }))));
    const queueLayoutOld = shouldShowContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRxpy.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingInline: "space.300",
        xcss: $d21686acb9dff0ab$var$layoutStyles
    }, content)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        "data-testId": (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? $d21686acb9dff0ab$var$SEGMENT_KEY_OLD : undefined,
        "data-vc": (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? `${$d21686acb9dff0ab$var$SEGMENT_KEY_OLD}${false ? '-ssr' : ''}` : undefined,
        "data-ssr-placeholder": false && (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? $d21686acb9dff0ab$var$SEGMENT_KEY_OLD : undefined,
        "data-ssr-placeholder-replace": false || !(0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? undefined : $d21686acb9dff0ab$var$SEGMENT_KEY_OLD,
        paddingInline: "space.300",
        xcss: $d21686acb9dff0ab$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d21686acb9dff0ab$var$layoutStyles
    }, content));
    const queueLayoutNew = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRxpy.QueueNav3StylingPatchContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        "data-testId": (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? $d21686acb9dff0ab$var$SEGMENT_KEY : undefined,
        "data-vc": (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? `${$d21686acb9dff0ab$var$SEGMENT_KEY}${false ? '-ssr' : ''}` : undefined,
        "data-ssr-placeholder": false && (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? $d21686acb9dff0ab$var$SEGMENT_KEY : undefined,
        "data-ssr-placeholder-replace": false || !(0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? undefined : $d21686acb9dff0ab$var$SEGMENT_KEY,
        paddingInline: "space.300",
        xcss: (0, $6zXPf.getWillShowNav4)() ? [
            $d21686acb9dff0ab$var$containerStyles,
            $d21686acb9dff0ab$var$layoutStyles
        ] : $d21686acb9dff0ab$var$layoutStyles
    }, content));
    const queueLayout = (0, $7jTnu.fg)('jsm_fix_queue_issue_view_navigate_back_state') ? queueLayoutNew : queueLayoutOld;
    const PageWrapperGated = (0, $7jTnu.fg)('placeholder_for_rhs_ttvc_offender') ? $d21686acb9dff0ab$var$PageWrapper : (0, $9KGpI.PageStyle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "queues-agent-view"
    }, // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $7jTnu.fg)('spartans_cipher_deprecation_banner') && isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jiD6s.default), null), (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? queueLayout : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PageWrapperGated, null, content), (0, $epTsa.expVal)('jsm_hr_expansion', 'cohort', 'not-enrolled') !== 'not-enrolled' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8pvq9.HrExpansionSpotlight), null) : null);
};
var $d21686acb9dff0ab$export$2e2bcd8739ae039 = $d21686acb9dff0ab$var$QueuesAgentViewContent;
const $d21686acb9dff0ab$var$containerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1
});
const $d21686acb9dff0ab$var$layoutStyles = (0, $1DXK0.xcss)({
    height: '100%'
});

});
parcelRegister("d129d", function(module, exports) {

$parcel$export(module.exports, "default", () => $c38f7cfd5c482255$export$2e2bcd8739ae039);

var $48Odo = parcelRequire("48Odo");

var $8yEMd = parcelRequire("8yEMd");

var $IhqEd = parcelRequire("IhqEd");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$c38f7cfd5c482255$export$2e2bcd8739ae039 = (0, $48Odo.default);

});
parcelRegister("48Odo", function(module, exports) {

$parcel$export(module.exports, "default", () => $19c04a0f0cb92a46$export$2e2bcd8739ae039);
/* page.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $h4HIG = parcelRequire("h4HIG");
const $19c04a0f0cb92a46$var$styles = {
    banner: "_1bsb1osq _kqsw1n9t",
    bannerContainer: "_16jlkb7n _1o9zidpf _i0dl1wug _v564evma _1bsb1osq _kqswh2mm _1pby11wp",
    pageContent: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _kqswh2mm _1pbykb7n",
    wrapper: "_1e0c1txw _1bsb1osq _1tke1osq _2lx21bp4",
    mainContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw",
    navigation: "_kqswh2mm _1pbycs5v"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $19c04a0f0cb92a46$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $h4HIG.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            $19c04a0f0cb92a46$var$styles.wrapper
        ]),
        children: [
            banner ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                style: {
                    height: isBannerOpen ? `${bannerHeight}px` : '0'
                },
                "aria-hidden": !isBannerOpen,
                "data-testid": testId ? `${testId}--banner-container` : undefined,
                className: (0, $hcewu.default)([
                    $19c04a0f0cb92a46$var$styles.bannerContainer
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $19c04a0f0cb92a46$var$styles.banner
                    ]),
                    children: banner
                })
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    $19c04a0f0cb92a46$var$styles.mainContainer
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $19c04a0f0cb92a46$var$styles.navigation
                        ]),
                        children: navigation
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            $19c04a0f0cb92a46$var$styles.pageContent
                        ]),
                        children: children
                    })
                ]
            })
        ]
    });
};
var $19c04a0f0cb92a46$export$2e2bcd8739ae039 = $19c04a0f0cb92a46$var$Page;

});
parcelRegister("h4HIG", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $0bf3286651dcbf00$export$74797698e12f8baa);
$parcel$export(module.exports, "spacingMapping", () => $0bf3286651dcbf00$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $0bf3286651dcbf00$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $0bf3286651dcbf00$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $0bf3286651dcbf00$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $0bf3286651dcbf00$export$2303d2bd9eeff99a);
const $0bf3286651dcbf00$var$defaultGridSize = 8;
const $0bf3286651dcbf00$export$74797698e12f8baa = 12;
const $0bf3286651dcbf00$export$b8241a1616ab1b96 = $0bf3286651dcbf00$var$defaultGridSize * 10;
const $0bf3286651dcbf00$export$2a89a65a43bab52d = {
    comfortable: $0bf3286651dcbf00$var$defaultGridSize * 5,
    cosy: $0bf3286651dcbf00$var$defaultGridSize * 2,
    compact: $0bf3286651dcbf00$var$defaultGridSize * 0.5
};
const $0bf3286651dcbf00$export$8ec7372efd74b753 = 'cosy';
const $0bf3286651dcbf00$export$d77f83c3d17a7b8a = 52;
const $0bf3286651dcbf00$export$f8725d21f81f3e01 = 0;
const $0bf3286651dcbf00$export$2303d2bd9eeff99a = 'fixed';
const $0bf3286651dcbf00$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $0bf3286651dcbf00$export$8b7e31f391e6e681 = '--ds-column-span';
const $0bf3286651dcbf00$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("8yEMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7ae0f3f994e81d7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $h4HIG = parcelRequire("h4HIG");

var $jh5Nk = parcelRequire("jh5Nk");

var $IhqEd = parcelRequire("IhqEd");

var $4cctD = parcelRequire("4cctD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $b7ae0f3f994e81d7$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eJOHy.useContext)((0, $4cctD.GridContext));
    const { medium: medium } = (0, $eJOHy.useContext)((0, $IhqEd.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $h4HIG.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $h4HIG.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4cctD.GridContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jh5Nk.Grid), {
            layout: layout,
            testId: testId,
            children: children
        })
    });
};
var $b7ae0f3f994e81d7$export$2e2bcd8739ae039 = $b7ae0f3f994e81d7$var$GridWrapper;

});
parcelRegister("jh5Nk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $a6ea171a1de7fa22$export$ef2184bd89960b14);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $h4HIG = parcelRequire("h4HIG");

var $4cctD = parcelRequire("4cctD");
const $a6ea171a1de7fa22$var$defaultGridColumnWidth = 80;
/**
 * The number of available columns in each row.
 */ const $a6ea171a1de7fa22$var$varColumnsNum = '--ds-columns-num';
/**
 * The spacing (in `px`) between each column.
 */ const $a6ea171a1de7fa22$var$varGridSpacing = '--ds-grid-spacing';
const $a6ea171a1de7fa22$var$styles = {
    grid: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3wx3y _n3tdidpf _19bvwx3y _1e0c1txw _kqswh2mm _4cvr1y6m _1n261g80",
    nestedGrid: "_19pkidpf _2hwx1un2 _otyridpf _18u01un2"
};
const $a6ea171a1de7fa22$var$gridLayoutMapStyles = {
    fixed: "_p12fgkkb",
    fluid: "_p12f1osq"
};
const $a6ea171a1de7fa22$export$ef2184bd89960b14 = ({ layout: layout = (0, $h4HIG.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eJOHy.useContext)((0, $4cctD.GridContext));
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$a6ea171a1de7fa22$var$varColumnsNum]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$a6ea171a1de7fa22$var$varGridSpacing]: `${(0, $h4HIG.spacingMapping)[spacing]}px`
        },
        "data-testid": testId,
        className: (0, $hcewu.default)([
            $a6ea171a1de7fa22$var$styles.grid,
            $a6ea171a1de7fa22$var$gridLayoutMapStyles[layout],
            isNested && $a6ea171a1de7fa22$var$styles.nestedGrid
        ]),
        children: children
    });
};

});
parcelRegister("4cctD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $9c511fcea308e0a6$export$11cae3e04ab99fae);

var $eJOHy = parcelRequire("eJOHy");

var $h4HIG = parcelRequire("h4HIG");
const $9c511fcea308e0a6$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $h4HIG.defaultSpacing),
    columns: (0, $h4HIG.defaultGridColumns)
});

});


parcelRegister("IhqEd", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $9eb926f4db2de6e4$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $9eb926f4db2de6e4$export$2e2bcd8739ae039);
/* grid-column.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $h4HIG = parcelRequire("h4HIG");

var $4cctD = parcelRequire("4cctD");
/**
 * Determines the method by which column width is calculated.
 */ var $9eb926f4db2de6e4$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($9eb926f4db2de6e4$var$ColumnVariant || {});
/**
 * The spacing (in `px`) between each column.
 */ const $9eb926f4db2de6e4$var$varGridSpacing = '--ds-grid-spacing';
/**
 * The number of columns that a `GridColumn` covers.
 */ const $9eb926f4db2de6e4$var$varColumnSpan = '--ds-column-span';
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $9eb926f4db2de6e4$var$singleColumnWidth = `(99.9999% / var(--ds-columns-num))`;
const $9eb926f4db2de6e4$var$styles = {
    gridColumn: "_19pkidpf _2hwxwx3y _otyridpf _18u0wx3y _1ul9hrtj _16jlkb7n _1o9zidpf _slp31hna"
};
const $9eb926f4db2de6e4$var$gridColumnWidthMapStyles = {
    auto: "_p12f1ho1 _i0dl1wug",
    bounded: "_p12fpg3g _i0dl1osq",
    fullWidth: "_p12f1ho1 _i0dl1osq"
};
const $9eb926f4db2de6e4$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $h4HIG.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
const $9eb926f4db2de6e4$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    medium: (0, $h4HIG.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $9eb926f4db2de6e4$var$GridColumn = ({ medium: medium = (0, $h4HIG.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eJOHy.useContext)((0, $4cctD.GridContext));
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $9eb926f4db2de6e4$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($9eb926f4db2de6e4$export$1229ad7112b989f5.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            style: {
                /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ [$9eb926f4db2de6e4$var$varColumnSpan]: variant === "auto" ? 'auto' : colSpan
            },
            "data-testid": testId,
            className: (0, $hcewu.default)([
                $9eb926f4db2de6e4$var$styles.gridColumn,
                $9eb926f4db2de6e4$var$gridColumnWidthMapStyles[variant]
            ]),
            children: children
        })
    });
};
var $9eb926f4db2de6e4$export$2e2bcd8739ae039 = $9eb926f4db2de6e4$var$GridColumn;

});



parcelRegister("8pvq9", function(module, exports) {

$parcel$export(module.exports, "HrExpansionSpotlight", () => $32819350c4ea4a7f$export$70aac9b19a402d6);

var $eJOHy = parcelRequire("eJOHy");

var $1pkzT = parcelRequire("1pkzT");

var $1KdDN = parcelRequire("1KdDN");

var $epTsa = parcelRequire("epTsa");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $9OCJd = parcelRequire("9OCJd");

var $gZTP9 = parcelRequire("gZTP9");


var $kumnd = parcelRequire("kumnd");
const $32819350c4ea4a7f$var$HrExpansionSpotlightWithDelay = ()=>{
    const [shouldShowSpotlight, setShouldShowSpotlight] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setShouldShowSpotlight(true);
        }, 2000);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return shouldShowSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kumnd.HrExpansionSpotlightView), null);
};
const $32819350c4ea4a7f$var$ChoreographedCustomMessageComponent = (0, $1pkzT.withChoreographedRender)($32819350c4ea4a7f$var$HrExpansionSpotlightWithDelay);
const $32819350c4ea4a7f$var$ChoreographedHrSpotlight = ()=>{
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ data: pageContextData }] = (0, $9OCJd.usePageContext)();
    const { projectId: projectId, projectType: projectType } = pageContextData?.projectContext || {};
    (0, $eJOHy.useEffect)(()=>{
        if (isAdmin && (0, $epTsa.expVal)('jsm_hr_expansion', 'cohort', 'not-enrolled') !== 'not-enrolled') (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'statsigExperiment exposed', 'jsm_hr_expansion', {
            cohort: (0, $epTsa.expVal)('jsm_hr_expansion', 'cohort', 'not-enrolled'),
            projectId: projectId,
            projectType: projectType
        });
    }, [
        createAnalyticsEvent,
        isAdmin,
        projectId,
        projectType
    ]);
    return isAdmin && (0, $epTsa.expValEquals)('jsm_hr_expansion', 'cohort', 'experiment') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($32819350c4ea4a7f$var$ChoreographedCustomMessageComponent, {
        messageId: (0, $0833318c75cb3b6b$export$3508d9f7bec6727b)
    }) : null;
};
const $32819350c4ea4a7f$export$70aac9b19a402d6 = ()=>{
    const emptyFallback = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jira-servicedesk-hr-expansion-experiment-spotlight",
        packageName: "jiraServicedeskHrExpansionExperiment",
        teamName: "jsd-getting-started",
        fallback: emptyFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($32819350c4ea4a7f$var$ChoreographedHrSpotlight, null));
};

});
const $0833318c75cb3b6b$export$3508d9f7bec6727b = 'JsmHRExpansionExperimentSpotlight';

parcelRegister("kumnd", function(module, exports) {

$parcel$export(module.exports, "HrExpansionSpotlightView", () => $e54823edab7b75de$export$b94d2eaac7b145e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $guKVF = parcelRequire("guKVF");

var $eJ9f5 = parcelRequire("eJ9f5");

var $IW7jS = parcelRequire("IW7jS");

var $dhdXs = parcelRequire("dhdXs");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $9pWNg = parcelRequire("9pWNg");

var $9cody = parcelRequire("9cody");

var $9OCJd = parcelRequire("9OCJd");

var $fbLtk = parcelRequire("fbLtk");

var $1yrGh = parcelRequire("1yrGh");


var $2uEy3 = parcelRequire("2uEy3");
const $e54823edab7b75de$export$b94d2eaac7b145e = ()=>{
    const [showSpotlight, setShowSpotlight] = (0, $eJOHy.useState)(true);
    const JSM_HR_EXPANSION_SPOTLIGHT_SEEN_STATUS_USER_PROPERTY_KEY = 'JsmHRExpansionExperimentSpotlightSeenStatus';
    const [{ isSeen: hasSeenSpotlight }, { markAsSeen: markSpotlightAsSeen }] = (0, $9cody.useSeenStatus)({
        userPropertyKey: JSM_HR_EXPANSION_SPOTLIGHT_SEEN_STATUS_USER_PROPERTY_KEY,
        isSeenValue: true,
        packageName: 'jsmHrExpansionExperiment',
        teamName: 'jsm-getting-started'
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ data: pageContextData }] = (0, $9OCJd.usePageContext)();
    const { methods: { open: openProjectCreate } } = (0, $9pWNg.useProjectCreateDrawer)();
    const { projectId: projectId, projectType: projectType } = pageContextData?.projectContext || {};
    const renderSpotlightCard = ()=>{
        const onDismissSpotlight = ()=>{
            setShowSpotlight(false);
            markSpotlightAsSeen();
        };
        const handleTryNow = ()=>{
            onDismissSpotlight();
            markSpotlightAsSeen();
            openProjectCreate({
                defaultSelectedTemplateKey: (0, $dhdXs.HR_SERVICE_PROJECT_TEAM_MANAGED_KEY)
            });
        };
        const handleLearnMore = ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'HrExpansionSpotlightLearnMore', {
                projectId: projectId,
                projectType: projectType
            });
        };
        const LEARN_MORE_LINK = 'https://www.atlassian.com/software/jira/service-management/hr';
        const renderNudge = ()=>{
            const SpotlightRef = (0, $fbLtk.createOnboardingSpotlight)({
                actions: [
                    {
                        onClick: ()=>{
                            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'HrExpansionSpotlightDismiss', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            onDismissSpotlight();
                        },
                        content: formatMessage((0, $2uEy3.default).dismiss),
                        appearance: 'subtle'
                    },
                    {
                        onClick: ()=>{
                            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'HrExpansionSpotlightActivate', {
                                projectId: projectId,
                                projectType: projectType
                            });
                            handleTryNow();
                        },
                        content: formatMessage((0, $2uEy3.default).enable),
                        appearance: 'primary'
                    }
                ],
                contentMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $2uEy3.default).description, {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                            href: LEARN_MORE_LINK,
                            target: "_blank",
                            onClick: handleLearnMore
                        }, chunks)
                })),
                image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1yrGh))),
                    alt: "",
                    width: "320"
                }),
                headingMessage: formatMessage((0, $2uEy3.default).heading)
            });
            // eslint-disable-next-line react/no-unstable-nested-components
            return /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                    "aria-label": "hr-expansion",
                    ref: ref
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SpotlightRef, null)));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e54823edab7b75de$var$ModalWrapperStyles, {
            "aria-label": "hr-expansion"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
            sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
            sourceName: "JsmHrExpansionSpotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guKVF.NudgeSpotlight), {
            setHidden: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            hidden: !showSpotlight,
            spotlightCard: renderNudge(),
            position: "bottom-end",
            zIndex: (0, $IW7jS.layers).spotlight(),
            hideSpotlightCardOnOutsideClick: false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
            attributes: {
                messageId: (0, $0833318c75cb3b6b$export$3508d9f7bec6727b),
                name: 'JsmHrExpansionSpotlight',
                projectId: projectId,
                projectType: projectType
            }
        })));
    };
    return showSpotlight && !hasSeenSpotlight ? renderSpotlightCard() : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e54823edab7b75de$var$ModalWrapperStyles = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _94n5xy5q _1xi2oahv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("guKVF", function(module, exports) {

$parcel$export(module.exports, "NudgeSpotlight", () => $ab2a22ecc5abafba$export$eebbda33f5d4d735);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $buco7 = parcelRequire("buco7");

var $67YQP = parcelRequire("67YQP");

var $8qmYl = parcelRequire("8qmYl");

var $4eDgu = parcelRequire("4eDgu");

var $1JTs3 = parcelRequire("1JTs3");

var $2S8TX = parcelRequire("2S8TX");

var $1Q3jn = parcelRequire("1Q3jn");
const $ab2a22ecc5abafba$var$blinkNudge = (nudgeBlinkId, eventTarget, setAnimateIn)=>{
    const nudgeBlinkTriggers = Array.from(document.querySelectorAll(`[data-nudge-blink='${nudgeBlinkId}']`));
    const clickIsInsideTrigger = nudgeBlinkTriggers?.some((triggerElement)=>{
        return triggerElement && triggerElement.contains(eventTarget);
    });
    if (clickIsInsideTrigger) {
        // Blink the nudge
        setAnimateIn(true);
        return true;
    }
    return false;
};
const $ab2a22ecc5abafba$export$eebbda33f5d4d735 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ hidden: externalHidden, setHidden: setHidden, hideNudgeOnClick: hideNudgeOnClick = true, hideSpotlightCardOnOutsideClick: hideSpotlightCardOnOutsideClick = true, concealSpotlightOnReferenceHidden: concealSpotlightOnReferenceHidden = false, showSpotlightCardOnFirstRender: showSpotlightCardOnFirstRender = true, children: children, spotlightCard: Spotlight = (0, $1JTs3.default), nudge: Nudge = (0, $buco7.DefaultNudge), position: position = 'bottom', offset: offset, zIndex: zIndex = 800, onRender: onRender, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor, pulseBorderRadius: pulseBorderRadius, nudgeBlinkId: nudgeBlinkId, nudgeTestId: nudgeTestId, nudgeTag: nudgeTag, headingId: headingId, ...spotlightCardProps }, nudgeSpotlightRef)=>{
    // Put all listeners inside a ref to avoid misfiring events
    // When the listener functions themselves change.
    const handlers = (0, $eJOHy.useRef)();
    handlers.current = {
        onRender: onRender,
        onHide: onHide,
        onShow: onShow,
        onClick: onClick,
        onOutsideClick: onOutsideClick
    };
    const nudgeRef = (0, $eJOHy.useRef)(null);
    const spotlightCardRef = (0, $eJOHy.useRef)(null);
    const showNudge = !externalHidden;
    const [canShowSpotlight, setCanShowSpotlight] = (0, $eJOHy.useState)(showSpotlightCardOnFirstRender);
    const [showSpotlight, setShowSpotlight] = (0, $eJOHy.useState)(false);
    const [shouldBlink, setShouldBlink] = (0, $eJOHy.useState)(false);
    const stopBlink = (0, $eJOHy.useCallback)(()=>setShouldBlink(false), []);
    const forceUpdateFnRef = (0, $eJOHy.useRef)({
        fn: ()=>{}
    });
    (0, $eJOHy.useImperativeHandle)(nudgeSpotlightRef, ()=>({
            toggleCardVisibility: setCanShowSpotlight,
            forceUpdateCardPosition: ()=>forceUpdateFnRef.current.fn()
        }), [
        setCanShowSpotlight
    ]);
    const markReadyToShow = (0, $eJOHy.useCallback)(()=>showNudge && setCanShowSpotlight(true), [
        showNudge
    ]);
    const onTargetClick = (0, $eJOHy.useCallback)((event)=>{
        if (!externalHidden) {
            if (hideNudgeOnClick) setHidden(event);
            handlers.current?.onClick?.();
        }
    }, [
        externalHidden,
        hideNudgeOnClick,
        setHidden,
        handlers
    ]);
    // Effect for show/hide the spotlight
    (0, $eJOHy.useEffect)(()=>{
        setShowSpotlight(showNudge && canShowSpotlight);
    }, [
        showNudge,
        canShowSpotlight
    ]);
    // Effect for onRender and onHide
    (0, $eJOHy.useEffect)(()=>{
        if (!externalHidden) {
            handlers.current?.onRender?.();
            return ()=>handlers.current?.onHide?.();
        }
    }, [
        externalHidden,
        handlers
    ]);
    // Effect for onShow
    (0, $eJOHy.useEffect)(()=>{
        if (showSpotlight) handlers.current?.onShow?.();
    }, [
        showSpotlight,
        handlers
    ]);
    // Effect to reset showSpotlightCardOnFirstRender when hidden
    (0, $eJOHy.useEffect)(()=>{
        if (externalHidden) setCanShowSpotlight(showSpotlightCardOnFirstRender);
    }, [
        externalHidden,
        showSpotlightCardOnFirstRender
    ]);
    // Effect to hide spotlight on outside click
    (0, $eJOHy.useEffect)(()=>{
        let unbind;
        let timeout;
        if (showSpotlight && hideSpotlightCardOnOutsideClick) timeout = window.setTimeout(()=>{
            unbind = (0, $4eDgu.bind)(window, {
                type: 'click',
                listener: (event)=>{
                    const eventTarget = event.target;
                    if (nudgeRef.current && spotlightCardRef.current && eventTarget instanceof Node && !nudgeRef.current.contains(eventTarget) && !spotlightCardRef.current.contains(eventTarget)) {
                        if (nudgeBlinkId) {
                            const didBlink = $ab2a22ecc5abafba$var$blinkNudge(nudgeBlinkId, eventTarget, setShouldBlink);
                            if (didBlink) return;
                        }
                        setCanShowSpotlight(false);
                        handlers.current?.onOutsideClick?.();
                        unbind?.();
                    }
                },
                options: {
                    capture: true,
                    passive: true
                }
            });
        });
        return ()=>{
            unbind?.();
            window.clearTimeout(timeout);
        };
    }, [
        showSpotlight,
        hideSpotlightCardOnOutsideClick,
        setHidden,
        handlers,
        nudgeBlinkId
    ]);
    const concealSpotlightOnScrollStyles = (isReferenceHidden)=>concealSpotlightOnReferenceHidden && isReferenceHidden ? {
            display: 'none'
        } : {};
    const cardConfig = (0, $eJOHy.useMemo)(()=>Spotlight === (0, $1JTs3.default) ? {
            ...spotlightCardProps,
            id: nudgeBlinkId
        } : {
            cardTestId: spotlightCardProps.cardTestId
        }, [
        Spotlight,
        spotlightCardProps,
        nudgeBlinkId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)(Nudge, {
                ref: nudgeRef,
                hasPulse: showNudge,
                onClickCapture: onTargetClick,
                onMouseEnter: markReadyToShow,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor,
                pulseBorderRadius: pulseBorderRadius,
                nudgeTestId: nudgeTestId,
                tag: nudgeTag,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8qmYl.Popper), {
                    placement: position,
                    referenceElement: nudgeRef.current || undefined,
                    offset: offset,
                    children: ({ ref: ref, style: popperStyles, forceUpdate: forceUpdate, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $2S8TX.SpotlightContainer), {
                            showSpotlight: showSpotlight,
                            shouldBlink: shouldBlink,
                            stopBlink: stopBlink,
                            zIndex: zIndex,
                            ref: ref,
                            containerStyles: {
                                ...popperStyles,
                                ...concealSpotlightOnScrollStyles(isReferenceHidden)
                            },
                            role: "dialog",
                            ariaLabelledBy: headingId || 'nudge-spot-light-card-heading',
                            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1Q3jn.default), {
                                children: [
                                    (forceUpdateFnRef.current.fn = forceUpdate) && null,
                                    /*#__PURE__*/ (0, $gt9Am.jsx)(Spotlight, {
                                        ...cardConfig,
                                        ref: spotlightCardRef
                                    })
                                ]
                            })
                        })
                })
            })
        ]
    });
});
var $ab2a22ecc5abafba$export$2e2bcd8739ae039 = $ab2a22ecc5abafba$export$eebbda33f5d4d735;

});
parcelRegister("buco7", function(module, exports) {

$parcel$export(module.exports, "DefaultNudge", () => $0c5a638aba06f9ee$export$b7d614104f4a4a7c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3jO6v = parcelRequire("3jO6v");
const $0c5a638aba06f9ee$export$b7d614104f4a4a7c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...rest }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $3jO6v.NudgeTooltipPulse), {
        ...rest,
        ref: ref,
        "data-testid": nudgeTestId,
        children: children
    }));

});
parcelRegister("3jO6v", function(module, exports) {

$parcel$export(module.exports, "NudgeTooltipPulse", () => $42bc5117e040ba32$export$2d11151259bb3b10);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $IW7jS = parcelRequire("IW7jS");

var $eGOwo = parcelRequire("eGOwo");
function $42bc5117e040ba32$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $42bc5117e040ba32$var$baseShadow = '0 0 0 3px';
const $42bc5117e040ba32$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $7bb4c1736002a04a$exports).P75})`;
const $42bc5117e040ba32$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $42bc5117e040ba32$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $42bc5117e040ba32$var$pulseAnimation = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animationName: 'pulseKeyframes',
    animationDuration: '3000ms',
    animationTimingFunction: $42bc5117e040ba32$var$easing,
    animationIterationCount: 'infinite'
});
const $42bc5117e040ba32$var$pseudoStyle = {
    name: "24nntw",
    styles: "content:'';position:absolute;top:0;left:0;width:100%;height:100%"
};
const $42bc5117e040ba32$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>/*#__PURE__*/ (0, $1NIU8.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $42bc5117e040ba32$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$42bc5117e040ba32$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $42bc5117e040ba32$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$42bc5117e040ba32$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $42bc5117e040ba32$var$pulseAnimation
            ]
        }
    });
const $42bc5117e040ba32$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = (0, $IW7jS.borderRadius)(), pulseColor: pulseColor = $42bc5117e040ba32$var$basePulseColor, pulseShadowColor: pulseShadowColor = $42bc5117e040ba32$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $1NIU8.jsx)(CastTargetContainer, {
        css: [
            $42bc5117e040ba32$export$814d9bf8c56ac913({
                hasPulse: hasPulse,
                pulseBorderRadius: pulseBorderRadius,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor
            }),
            (0, $eGOwo.fg)('jira_onboarding_experiences_a11y_fixes') && $42bc5117e040ba32$var$inHeritWidthStyles
        ],
        ref: ref,
        ...rest
    });
});
const $42bc5117e040ba32$var$inHeritWidthStyles = {
    name: "6n1ert",
    styles: "width:inherit"
};

});
var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';



parcelRegister("1JTs3", function(module, exports) {

$parcel$export(module.exports, "default", () => $15ddc28f657a455a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");


var $1NIU8 = parcelRequire("1NIU8");
function $15ddc28f657a455a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $15ddc28f657a455a$var$borderRadius = 3;
const $15ddc28f657a455a$var$containerStyles = {
    color: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $7bb4c1736002a04a$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}`})`,
    backgroundColor: `var(--ds-background-discovery-bold, ${(0, $7bb4c1736002a04a$export$b48405b95304b5a1)})`,
    borderRadius: `${$15ddc28f657a455a$var$borderRadius}px`,
    overflow: 'auto'
};
const $15ddc28f657a455a$var$bodyStyles = {
    display: 'flex',
    flexDirection: 'column',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $15ddc28f657a455a$var$headingStyles = {
    name: "1m05p0r",
    styles: "font-size:1.42857em;font-style:inherit;line-height:1.2;font-weight:var(--ds-font-weight-medium, 500);margin-top:28px;color:inherit;&:first-child{margin-top:0;}"
};
const $15ddc28f657a455a$var$headerStyles = {
    display: 'flex',
    paddingBottom: "var(--ds-space-100, 8px)",
    alignItems: `baseline`,
    justifyContent: `space-between`
};
const $15ddc28f657a455a$var$footerStyles = {
    display: 'flex',
    paddingTop: "var(--ds-space-100, 8px)",
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $15ddc28f657a455a$var$actionItemStyles = (index)=>/*#__PURE__*/ (0, $1NIU8.css)({
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        cursor: 'pointer',
        alignItems: 'baseline',
        borderWidth: '0px',
        borderRadius: '3px',
        boxSizing: 'border-box',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- TODO: https://product-fabric.atlassian.net/browse/PYX-881
        fontSize: 'inherit',
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        maxWidth: '100%',
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: index ? `var(--ds-background-discovery-bold, ${0, $7bb4c1736002a04a$export$b48405b95304b5a1})` : `var(--ds-background-inverse-subtle, ${0, $7bb4c1736002a04a$export$c71e4279dd54a18d})`,
        height: '2.28571em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '2.28571em',
        padding: '0px 10px',
        verticalAlign: 'middle',
        width: 'auto',
        justifyContent: 'center',
        color: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
        '&:hover': {
            backgroundColor: `var(--ds-interaction-hovered, ${(0, $7bb4c1736002a04a$export$a7175d4e9206bc80)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-interaction-pressed, ${(0, $7bb4c1736002a04a$export$a7175d4e9206bc80)})`
        }
    });
const $15ddc28f657a455a$var$ActionItem = ({ index: index, ...rest })=>/*#__PURE__*/ (0, $1NIU8.jsx)("button", {
        css: $15ddc28f657a455a$var$actionItemStyles(index),
        ...rest
    });
const $15ddc28f657a455a$var$actionItemContainerStyles = {
    display: 'flex',
    margin: `${"var(--ds-space-negative-050, -4px)"}`,
    flexDirection: 'row-reverse'
};
const $15ddc28f657a455a$export$b3ae98194e057550 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ image: image, heading: heading, actions: actions, actionsBeforeElement: actionsBeforeElement, width: width = 300, cardTestId: cardTestId, content: content, id: id }, ref)=>{
    const renderedActions = (0, $eJOHy.useMemo)(()=>actions?.map(({ text: text, onClick: onClick }, index)=>/*#__PURE__*/ (0, $1NIU8.jsx)($15ddc28f657a455a$var$ActionItem, {
                index: index,
                onClick: onClick,
                key: `${text}-${index}`
            }, text)), [
        actions
    ]);
    const renderHeader = !!heading;
    const renderFooter = !!actionsBeforeElement || !!actions;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...$15ddc28f657a455a$var$containerStyles,
            width: `${width}px`
        },
        "data-testid": cardTestId
    }, typeof image === 'string' ? /*#__PURE__*/ (0, $1NIU8.jsx)("img", {
        src: image,
        alt: ""
    }) : image, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: $15ddc28f657a455a$var$bodyStyles,
        id: id
    }, renderHeader && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: $15ddc28f657a455a$var$headerStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: "nudge-spot-light-card-heading",
        css: $15ddc28f657a455a$var$headingStyles
    }, heading)), content, renderFooter && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: $15ddc28f657a455a$var$footerStyles
    }, actionsBeforeElement || /*#__PURE__*/ (0, $1NIU8.jsx)("span", null), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: $15ddc28f657a455a$var$actionItemContainerStyles
    }, renderedActions))));
});
var $15ddc28f657a455a$export$2e2bcd8739ae039 = $15ddc28f657a455a$export$b3ae98194e057550;

});

parcelRegister("2S8TX", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $34810c2406c4e27e$export$d0f55839b708c0a0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1aLTh = parcelRequire("1aLTh");

var $67YQP = parcelRequire("67YQP");
const $34810c2406c4e27e$export$474e8ee88cc7cd8f = 200;
const $34810c2406c4e27e$export$3d6f334bf7dc4597 = 120;
const $34810c2406c4e27e$var$defaultTransitionStyles = {
    opacity: 0,
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease-in-out',
    transitionDuration: `${$34810c2406c4e27e$export$474e8ee88cc7cd8f}ms`
};
const $34810c2406c4e27e$var$statefulTransitionStyles = {
    entering: {},
    entered: {
        opacity: 1
    },
    exiting: {
        transitionDuration: `${$34810c2406c4e27e$export$3d6f334bf7dc4597}ms`,
        opacity: 0
    },
    exited: {},
    unmounted: {}
};
const $34810c2406c4e27e$var$timeoutDurations = {
    enter: 0,
    exit: $34810c2406c4e27e$export$3d6f334bf7dc4597
};
const $34810c2406c4e27e$export$d0f55839b708c0a0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ containerStyles: containerStyles, showSpotlight: showSpotlight, shouldBlink: shouldBlink, zIndex: zIndex, stopBlink: stopBlink, ariaLabelledBy: ariaLabelledBy, ...rest }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $1aLTh.default), {
        appear: true,
        in: showSpotlight && !shouldBlink,
        timeout: $34810c2406c4e27e$var$timeoutDurations,
        onExited: stopBlink,
        unmountOnExit: !shouldBlink,
        children: (state)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...containerStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$34810c2406c4e27e$var$defaultTransitionStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$34810c2406c4e27e$var$statefulTransitionStyles[state]
                    },
                    ref: ref,
                    "aria-labelledby": ariaLabelledBy,
                    ...rest
                })
            })
    }));

});


// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("9cody", function(module, exports) {

$parcel$export(module.exports, "useSeenStatus", () => $dc9f3e2c8caae723$export$12667e37571b0a02);

var $eJOHy = parcelRequire("eJOHy");


var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $1uIew = parcelRequire("1uIew");

var $8KUFq = parcelRequire("8KUFq");

var $hWeHP = parcelRequire("hWeHP");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lvKO5 = parcelRequire("lvKO5");
const $dc9f3e2c8caae723$var$initialState = {
    isSeen: true,
    isLoading: false,
    error: undefined
};
const $dc9f3e2c8caae723$export$f7ab30339d40bcd = ()=>(0, $hWeHP.default)('ajs-is-synthetic') === 'true';
const $dc9f3e2c8caae723$export$12667e37571b0a02 = ({ userPropertyKey: userPropertyKey, isSeenValue: isSeenValue, packageName: packageName, teamName: teamName, skipOnboarding: skipOnboarding })=>{
    const [state, setState] = (0, $eJOHy.useState)($dc9f3e2c8caae723$var$initialState);
    const { atlassianAccountId: accountId } = (0, $lvKO5.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const reportErrorDeps = (0, $eJOHy.useRef)({
        packageName: packageName,
        teamName: teamName
    });
    reportErrorDeps.current = {
        packageName: packageName,
        teamName: teamName
    };
    const reportError = (0, $eJOHy.useCallback)((errorId, error)=>{
        (0, $gYnSx.default)({
            meta: {
                id: errorId,
                ...reportErrorDeps.current
            },
            error: error,
            attributes: {
                isClientFetchError: (0, $8KUFq.isClientFetchError)(error)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (accountId && !$dc9f3e2c8caae723$export$f7ab30339d40bcd() && !skipOnboarding) {
            setState((oldState)=>({
                    ...oldState,
                    isLoading: true
                }));
            (0, $FppkK.getUserProperty)(accountId, userPropertyKey).catch((error)=>{
                if (error.statusCode === (0, $44ccf6b895337c89$export$8bca792d963eb0ef)) // user property has not been set
                return false;
                throw error;
            }).then((value)=>{
                setState((oldState)=>({
                        ...oldState,
                        isSeen: value === isSeenValue,
                        isLoading: false
                    }));
                (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.fetchStatus succeeded', {
                    userPropertyKey: userPropertyKey
                });
            }).catch((error)=>{
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.fetchStatus', error);
            });
        }
    }, [
        userPropertyKey,
        accountId,
        isSeenValue,
        reportError,
        createAnalyticsEvent,
        skipOnboarding
    ]);
    const markAsSeen = (0, $eJOHy.useCallback)(()=>{
        if (accountId && !$dc9f3e2c8caae723$export$f7ab30339d40bcd() && !skipOnboarding) {
            setState((oldState)=>({
                    ...oldState,
                    isSeen: true,
                    isLoading: true
                }));
            (0, $FppkK.setUserProperties)(accountId, userPropertyKey, JSON.stringify(isSeenValue)).then((res)=>{
                if (!res.ok) return res.text().then((errResp)=>{
                    throw new (0, $1uIew.default)(res.status, errResp);
                });
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false
                    }));
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'useSeenStatus.markAsSeen succeeded', {
                    userPropertyKey: userPropertyKey
                });
                return Promise.resolve();
            }).catch((error)=>{
                // leave `isSeen` as true. we don't want to block the user
                setState((oldState)=>({
                        ...oldState,
                        isLoading: false,
                        error: error
                    }));
                reportError('useSeenStatus.markAsSeen', error);
            });
        }
    }, [
        accountId,
        userPropertyKey,
        isSeenValue,
        createAnalyticsEvent,
        reportError,
        skipOnboarding
    ]);
    return [
        state,
        {
            markAsSeen: markAsSeen
        }
    ];
};

});

parcelRegister("fbLtk", function(module, exports) {

$parcel$export(module.exports, "createOnboardingSpotlight", () => $2a8cccc88611f2d5$export$3de3bbc64fe39fe6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $1Q3jn = parcelRequire("1Q3jn");

var $abjs4 = parcelRequire("abjs4");
var $goZPP = parcelRequire("goZPP");

var $3l2IB = parcelRequire("3l2IB");

var $9ycBx = parcelRequire("9ycBx");

var $7jTnu = parcelRequire("7jTnu");
const $2a8cccc88611f2d5$var$NudgeHeading = ({ formattedMessage: formattedMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$Title, {
        id: "nudge-spot-light-card-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$CustomHeading, null, formattedMessage));
const $2a8cccc88611f2d5$var$NudgeAction = ({ appearance: appearance, content: content, onClick: onClick })=>{
    // if appearance is primary, override styles with custom button
    // note CustomThemeButton is advised against and we need a better solution
    // (potentially even going with the blue button). Leaving this code for the experiment
    if (appearance === 'primary') {
        const customTheme = (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: `${"var(--ds-icon-discovery, #8270DB)"}`,
                    minWidth: '84px',
                    margin: `0 ${"var(--ds-space-050, 4px)"}`,
                    color: `${"var(--ds-text-inverse, #FFFFFF)"}`
                },
                spinnerStyles: spinnerStyles
            };
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abjs4.default), {
            appearance: appearance,
            onClick: onClick,
            theme: customTheme
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: appearance,
        onClick: onClick
    }, content);
};
const $2a8cccc88611f2d5$var$NudgeActions = ({ actions: actions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$Footer, null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$NudgeAction, {
            key: index,
            ...action
        })));
const $2a8cccc88611f2d5$var$NudgeActionsNewAndImproved = ({ actions: actions, actionsBeforeElement: actionsBeforeElement })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$ActionsBeforeFooter, null, actionsBeforeElement || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$ActionWrapper, null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$NudgeAction, {
            key: index,
            ...action
        }))));
const $2a8cccc88611f2d5$export$3de3bbc64fe39fe6 = ({ actions: actions, contentMessage: contentMessage, headingMessage: headingMessage, image: image, width: width = (0, $9ycBx.DEFAULT_NUDGE_WIDTH), CustomWrapper: CustomWrapper, actionsBeforeElement: actionsBeforeElement })=>{
    const Wrapper = CustomWrapper || $2a8cccc88611f2d5$var$SpotlightCardWrapper;
    return /*#__PURE__*/ (0, $eJOHy.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3l2IB.default), {
            image: image,
            heading: headingMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$NudgeHeading, {
                formattedMessage: headingMessage
            }) : null,
            width: width,
            ...!(0, $7jTnu.fg)('jfind-spotlight-step-counter-refactor') ? {
                actionsBeforeElement: actionsBeforeElement
            } : {}
        }, contentMessage, (0, $7jTnu.fg)('jfind-spotlight-step-counter-refactor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$NudgeActionsNewAndImproved, {
            actions: actions,
            actionsBeforeElement: actionsBeforeElement
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a8cccc88611f2d5$var$NudgeActions, {
            actions: actions
        }))));
};
const $2a8cccc88611f2d5$export$cbbb2ee263b2a558 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ focusLock: focusLock, ...rest }, ref)=>{
    const Spotlight = $2a8cccc88611f2d5$export$3de3bbc64fe39fe6({
        ...rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Q3jn.default), {
        disabled: !focusLock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Spotlight, {
        ref: ref
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a8cccc88611f2d5$var$SpotlightCardWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_fkwn1bhr _tml11fxt _19yu1fxt",
            __cmplp.className
        ])
    });
});
const $2a8cccc88611f2d5$var$Title = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $2a8cccc88611f2d5$var$CustomHeading = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8nbxd _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $2a8cccc88611f2d5$var$Footer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _ca0qu2gc",
            __cmplp.className
        ])
    });
});
const $2a8cccc88611f2d5$var$ActionsBeforeFooter = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _ca0qu2gc",
            __cmplp.className
        ])
    });
});
const $2a8cccc88611f2d5$var$ActionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1yrGh", function(module, exports) {
module.exports = new URL("spotlightImage.0949772a.png", import.meta.url).toString();

});

parcelRegister("2uEy3", function(module, exports) {

$parcel$export(module.exports, "default", () => $00000c0634aad87b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $00000c0634aad87b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    description: {
        "id": "service-management-hr-expansion-experiment-spotlight.description",
        "defaultMessage": "Set up your new project fast using the HR service management template, or <a>read about service management for HR.</a>"
    },
    heading: {
        "id": "service-management-hr-expansion-experiment-spotlight.heading",
        "defaultMessage": "Want to deliver better HR service experiences from day one?"
    },
    enable: {
        "id": "service-management-hr-expansion-experiment-spotlight.enable",
        "defaultMessage": "Try now"
    },
    dismiss: {
        "id": "service-management-hr-expansion-experiment-spotlight.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});



parcelRegister("hV8jN", function(module, exports) {

$parcel$export(module.exports, "useProjectBuilder", () => $db517b6f347104de$export$5891129c2551a3c0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $db517b6f347104de$var$ProjectBuilderStore = (0, $GtRbT.createStore)({
    initialState: {
        isProjectBuilderOpen: false
    },
    actions: {
        hideProjectBuilder: ()=>({ setState: setState })=>{
                setState({
                    isProjectBuilderOpen: false
                });
            },
        showProjectBuilder: ()=>({ setState: setState })=>{
                setState({
                    isProjectBuilderOpen: true
                });
            }
    },
    name: 'projectBuilder'
});
const $db517b6f347104de$export$5891129c2551a3c0 = (0, $iJq0l.createHook)($db517b6f347104de$var$ProjectBuilderStore);

});

parcelRegister("lnCC0", function(module, exports) {

$parcel$export(module.exports, "ProjectTour", () => $7fd834f7afed6aaa$export$efe5812745c27ad2);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $lHEZf = parcelRequire("lHEZf");

var $b1HJu = parcelRequire("b1HJu");

var $bQWwW = parcelRequire("bQWwW");

var $lwyjC = parcelRequire("lwyjC");

var $cm3CP = parcelRequire("cm3CP");

const $7fd834f7afed6aaa$var$preloadComponent = ()=>(parcelRequire("7NJ44")).then((exportedModule)=>exportedModule.ProjectTour);
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7fd834f7afed6aaa$var$ProjectTourInternal = (0, $bQWwW.lazy)(()=>$7fd834f7afed6aaa$var$preloadComponent(), {});
const $7fd834f7afed6aaa$export$efe5812745c27ad2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "itsm-project-tour",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cm3CP.IfNavTargetsAreShowing), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHEZf.StartExperiencesOnce), {
        experiences: [
            (0, $lwyjC.projectTourFirstStepExperience),
            (0, $b1HJu.sampleSpaceTourFirstStepExperience)
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7fd834f7afed6aaa$var$ProjectTourInternal, props)));

});
parcelRegister("lHEZf", function(module, exports) {

$parcel$export(module.exports, "StartExperiencesOnce", () => $612905160e851166$export$144439ff99ea00b7);

var $eJOHy = parcelRequire("eJOHy");

var $wCrTq = parcelRequire("wCrTq");

var $jnh7D = parcelRequire("jnh7D");
const $612905160e851166$export$144439ff99ea00b7 = ({ experiences: experiences })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $wCrTq.default), {
        mount: ()=>{
            // Only start the experiences if they haven't been started before
            experiences.filter((exp)=>exp.state.id === (0, $jnh7D.UFOExperienceState).NOT_STARTED.id).forEach((exp)=>exp.start());
        },
        unmount: ()=>{
            // Abort the experiences on unmount
            experiences.forEach((exp)=>exp.abort());
        }
    });

});
parcelRegister("wCrTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $106da18fba632589$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
// eslint-disable-next-line jira/react/no-class-components
class $106da18fba632589$var$OpTrigger extends (0, $eJOHy.Component) {
    componentDidMount() {
        this.props.mount();
    }
    componentWillUnmount() {
        this.props.unmount();
    }
    render() {
        return null;
    }
}
var $106da18fba632589$export$2e2bcd8739ae039 = $106da18fba632589$var$OpTrigger;

});


parcelRegister("b1HJu", function(module, exports) {

$parcel$export(module.exports, "sampleSpaceTourFirstStepExperience", () => $c8f717ae264b5a40$export$79aaeba705b81d95);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $c8f717ae264b5a40$export$79aaeba705b81d95 = new (0, $f39LL.UFOExperience)('jsm-first-session-flow-sample-space-tour-first-step', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("lwyjC", function(module, exports) {

$parcel$export(module.exports, "yourWorkFirstStepExperience", () => $ae21e8c133adbc00$export$df0fbb7740eb79c7);
$parcel$export(module.exports, "projectTourFirstStepExperience", () => $ae21e8c133adbc00$export$18d4c572a40cbc5b);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $ae21e8c133adbc00$export$df0fbb7740eb79c7 = new (0, $f39LL.UFOExperience)('jsm-first-session-flow-your-work-tour-first-step', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});
const $ae21e8c133adbc00$export$18d4c572a40cbc5b = new (0, $f39LL.UFOExperience)('jsm-first-session-flow-project-tour-first-step', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("cm3CP", function(module, exports) {

$parcel$export(module.exports, "IfNavTargetsAreShowing", () => $2e300fb14a013943$export$88096496147f47d4);

var $eJOHy = parcelRequire("eJOHy");

var $2OORa = parcelRequire("2OORa");

var $hEw7G = parcelRequire("hEw7G");
const $2e300fb14a013943$var$targetName = (0, $hEw7G.HOME_ITEMS_IDS).ALL_ITSM_QUEUES_SPOTLIGHT;
const $2e300fb14a013943$export$88096496147f47d4 = ({ children: children })=>{
    const { isTargetRendered: isTargetRendered } = (0, $2OORa.default)();
    const isNavTargetPresent = isTargetRendered($2e300fb14a013943$var$targetName);
    return isNavTargetPresent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : null;
};

});
parcelRegister("2OORa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6c703ccc3ab560f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $54CI2 = parcelRequire("54CI2");
function $e6c703ccc3ab560f$export$2e2bcd8739ae039() {
    const { targets: targets } = (0, $eJOHy.useContext)((0, $54CI2.SpotlightContext));
    const targetRef = (0, $eJOHy.useRef)(targets);
    (0, $eJOHy.useEffect)(()=>{
        targetRef.current = targets;
    }, [
        targets
    ]);
    const isTargetRendered = (0, $eJOHy.useCallback)((target)=>!!targetRef.current[target], []);
    return (0, $eJOHy.useMemo)(()=>({
            isTargetRendered: isTargetRendered
        }), [
        isTargetRendered
    ]);
}

});


parcelRegister("7NJ44", function(module, exports) {

let $5ae010e5bfadca95$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5ae010e5bfadca95$var$load("ffQaD"),
    $5ae010e5bfadca95$var$load("kvRbA"),
    $5ae010e5bfadca95$var$load("76n7a"),
    $5ae010e5bfadca95$var$load("l253H"),
    $5ae010e5bfadca95$var$load("jSs4Z")
]).then(()=>parcelRequire('jgVY3'));

});


parcelRegister("ek6C2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e764b609ebcd652$export$2e2bcd8739ae039);

var $49LNW = parcelRequire("49LNW");

var $eJOHy = parcelRequire("eJOHy");

var $dFg4o = parcelRequire("dFg4o");

var $j4oe4 = parcelRequire("j4oe4");

var $in44d = parcelRequire("in44d");

var $BwaQq = parcelRequire("BwaQq");

var $1KdDN = parcelRequire("1KdDN");

var $7jTnu = parcelRequire("7jTnu");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $ftN6c = parcelRequire("ftN6c");

var $gnQAk = parcelRequire("gnQAk");

var $2wyE1 = parcelRequire("2wyE1");

var $3L0P8 = parcelRequire("3L0P8");

var $7dWzg = parcelRequire("7dWzg");

var $gy2Qg = parcelRequire("gy2Qg");

var $3KcCl = parcelRequire("3KcCl");

var $l6Zyu = parcelRequire("l6Zyu");

var $2IsS5 = parcelRequire("2IsS5");

var $6KlxI = parcelRequire("6KlxI");

var $ljej9 = parcelRequire("ljej9");

var $g1NZW = parcelRequire("g1NZW");

var $gZTP9 = parcelRequire("gZTP9");

var $95O7y = parcelRequire("95O7y");
var $eJrcF = parcelRequire("eJrcF");

var $aGQ56 = parcelRequire("aGQ56");

var $bJscI = parcelRequire("bJscI");

var $2ApNu = parcelRequire("2ApNu");

var $kEUB1 = parcelRequire("kEUB1");

var $epTsa = parcelRequire("epTsa");

var $iXXEI = parcelRequire("iXXEI");

var $2R0qn = parcelRequire("2R0qn");

var $7KJik = parcelRequire("7KJik");

var $53tjX = parcelRequire("53tjX");

var $eI1Ks = parcelRequire("eI1Ks");

var $ebHNt = parcelRequire("ebHNt");

var $ll8hb = parcelRequire("ll8hb");

var $fqR30 = parcelRequire("fqR30");

var $gnL1K = parcelRequire("gnL1K");

var $eiNWu = parcelRequire("eiNWu");

var $1TwdM = parcelRequire("1TwdM");

var $6cqaw = parcelRequire("6cqaw");

var $i4aCO = parcelRequire("i4aCO");

var $8ccoX = parcelRequire("8ccoX");

var $f0fwB = parcelRequire("f0fwB");
// for local dev, to be able to open Project Builder without creating project each time
const $2e764b609ebcd652$var$ProjectBuilderWithQueryParamDev = ()=>{
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const isStagingOrDev = (0, $g1NZW.useIsStagingOrDevOrLocal)();
    const [projectBuilderQueryParamDev] = (0, $95O7y.useQueryParam)((0, $l6Zyu.SHOW_PROJECT_BUILDER_QUERY_PARAM_DEV));
    const [isDrawerOpen] = (0, $eJOHy.useState)(()=>isStagingOrDev && projectBuilderQueryParamDev === 'true');
    if (isDrawerOpen) return (0, $3KcCl.canUseProjectBuilder)(isAdmin) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3KcCl.AsyncProjectBuilderDrawer), {
        isOpenInitial: true
    }) : null;
    return null;
};
const $2e764b609ebcd652$export$9c2cd355bb335b4f = (0, $gnQAk.connect)(null, (dispatch)=>({
        setAnalyticsToRedux: (createAnalyticsEvent)=>{
            dispatch((0, $ebHNt.sendAnalyticCreatorAction)(createAnalyticsEvent));
        }
    }))(({ setAnalyticsToRedux: setAnalyticsToRedux, children: children })=>{
    const [isAnalyticsSet, setIsAnalyticsSet] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // Save setAnalyticsToReduxRef to ref to avoid useEffect reevaluation on every rerender
    const setAnalyticsToReduxRef = (0, $eJOHy.useRef)();
    setAnalyticsToReduxRef.current = setAnalyticsToRedux;
    (0, $eJOHy.useEffect)(()=>{
        setAnalyticsToReduxRef.current && setAnalyticsToReduxRef.current(createAnalyticsEvent);
        setIsAnalyticsSet(true);
    }, [
        createAnalyticsEvent
    ]);
    // in server context we need to return children
    if (false) return children;
    return isAnalyticsSet ? children : null;
});
// eslint-disable-next-line jira/react/no-class-components
class $2e764b609ebcd652$var$AgentApp extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            queue: undefined,
            push: undefined
        };
    }
    render() {
        const { initialState: initialState, onQueueRenderFailure: onQueueRenderFailure, push: push, isQueueVisible: isQueueVisible, onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded, queue: queue, onIssuesChanged: onIssuesChanged, onIssuesCountChanged: onIssuesCountChanged } = this.props;
        const state = {
            appProps: initialState.appProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L0P8.ServiceDeskSubAppBase), {
            appName: (0, $gy2Qg.APP_NAMES).QUEUES_AGENT_VIEW,
            initialState: state,
            rootReducer: (0, $dFg4o.enableBatching)((0, $fqR30.default)),
            rootEpic: (0, $7KJik.default)(push),
            onErrorHandler: onQueueRenderFailure,
            ErrorView: (0, $6KlxI.QueuesErrorView),
            resetProjectContextAction: (0, $ll8hb.resetProjectContextAction)
        }, // forceRenderWhileLoading guards against remounting caused by
        // ServiceDeskAnalyticsContext in rare scenarios, which can in turn
        // result in "Cannot update during an existing state transition".
        //
        // See: `this.triggerQueueChange()` called during render() in https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/servicedesk/queues-agent-view/src/view/layout/view.tsx#313
        // See: `TriggerQueueChangeOnce` component in https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/servicedesk/queues-agent-view/src/view/layout/view.tsx#313
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wyE1.ServiceDeskAnalyticsContext), {
            forceRenderWhileLoading: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2e764b609ebcd652$export$9c2cd355bb335b4f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1TwdM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8ccoX.default), {
            queue: queue,
            isQueueVisible: isQueueVisible,
            onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded,
            onIssuesChanged: onIssuesChanged,
            onIssuesCountChanged: onIssuesCountChanged
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6cqaw.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2e764b609ebcd652$var$ProjectBuilderWithQueryParamDev, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eiNWu.ChangeManagementTour), {
            projectId: (0, $ljej9.toProjectId)(`${state.appProps.projectId}`)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
            id: "incidentManagementTourQueues",
            packageName: "jiraServicedeskIncidentManagementTour",
            fallback: "flag"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i4aCO.IncidentManagementTour), {
            projectId: (0, $ljej9.toProjectId)(`${state.appProps.projectId}`)
        })), (0, $7jTnu.fg)('jsm_project_summary_onboarding') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f0fwB.default), {
            projectKey: state.appProps.projectKey
        }))));
    }
}
const $2e764b609ebcd652$var$AgentAppComponent = (props)=>{
    const { initialState: initialState, onQueueRenderFailure: onQueueRenderFailure, push: push, queue: queue, isQueueVisible: isQueueVisible, onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded, onIssuesChanged: onIssuesChanged, onIssuesCountChanged: onIssuesCountChanged } = props;
    const { data: data, error: error } = (0, $eJrcF.useResource)((0, $aGQ56.issueListSsrResource));
    const ssrIssueList = data ?? null;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    if ((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const cloudId = (0, $kEUB1.useCloudId)();
        const [, { addLabelsSuggestions: addLabelsSuggestions }] = (0, $7jTnu.fg)('change_import_path_for_usecoloredlabelsstore') ? // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $2R0qn.useColoredLabelsStore)() : // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $iXXEI.useLabelsStore)();
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const issueAriIds = (0, $eJOHy.useMemo)(()=>{
            if (!ssrIssueList?.issues) return [];
            return ssrIssueList.issues.map((issue)=>{
                const issueId = issue.id;
                return issueId ? (0, $2ApNu.JiraIssueAri).create({
                    issueId: issueId.toString(),
                    siteId: cloudId
                }).toString() : null;
            }).filter(Boolean);
        }, [
            ssrIssueList,
            cloudId
        ]);
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $j4oe4.useLazyLoadQuery)((0, $49LNW.default), {
            issueAris: issueAriIds
        });
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useEffect)(()=>{
            if (!result || !result?.jira_issuesByIds) return;
            result?.jira_issuesByIds?.forEach((issue)=>{
                const fields = issue?.fields;
                fields?.edges?.forEach((field)=>{
                    const fieldId = field?.node?.fieldId;
                    if (fieldId === 'labels') field?.node?.selectedLabelsConnection?.edges?.forEach((label)=>{
                        const labelName = label?.node?.name;
                        const labelColor = label?.node?.color;
                        if (labelName) addLabelsSuggestions(fieldId, {
                            name: labelName,
                            ...labelColor ? {
                                color: labelColor.colorKey
                            } : {}
                        });
                    });
                });
            });
        }, [
            addLabelsSuggestions,
            result
        ]);
    }
    const state = {
        appProps: initialState.appProps,
        persisted: {
            ssrIssuesData: {
                ssrIssueList: ssrIssueList,
                error: error,
                isInitialLoading: true,
                queueId: queue.id
            },
            issues: (0, $gnL1K.DEFAULT_ISSUES_STATE),
            queue: {
                category: queue.category,
                fetchStartIndex: 0,
                pagination: {
                    currentPage: 1
                }
            },
            analytic: {}
        },
        ui: {}
    };
    if (ssrIssueList && !error) {
        const queueData = {
            ...queue,
            // the ssr'd issue list has the sorting data and we want to include it
            columns: ssrIssueList.columns.map(({ fieldId: fieldId, columnHeaderText: columnHeaderText, sortable: sortable, fieldType: fieldType, sortOrder: sortOrder })=>({
                    id: fieldId,
                    title: columnHeaderText,
                    fieldType: fieldType,
                    sortable: sortable,
                    currentSorting: sortOrder
                }))
        };
        state.ui = {
            currentQueue: {
                ...(0, $eI1Ks.createSortedQueue)(queueData)
            },
            isLoadingIssues: false
        };
        const { totalCount: totalCount, isUsingDefaultSorting: isUsingDefaultSorting, issues: issues } = (0, $53tjX.default)(ssrIssueList, (0, $2IsS5.SSR_SOURCE), false, false);
        // @ts-expect-error - TS2322: Type 'never' is not assignable to type 'CollectionItem'.
        state.persisted.issues = (0, $gnL1K.addIssuesResponseToState)(0, totalCount, isUsingDefaultSorting, issues);
    }
    state.persisted.analytic = {
        createAnalyticsEvent: createAnalyticsEvent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L0P8.ServiceDeskSubAppBase), {
        appName: (0, $gy2Qg.APP_NAMES).QUEUES_AGENT_VIEW,
        initialState: state,
        rootReducer: (0, $dFg4o.enableBatching)((0, $fqR30.default)),
        rootEpic: (0, $7KJik.default)(push),
        onErrorHandler: onQueueRenderFailure,
        ErrorView: (0, $6KlxI.QueuesErrorView),
        resetProjectContextAction: (0, $ll8hb.resetProjectContextAction)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1TwdM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8ccoX.default), {
        queue: queue,
        isQueueVisible: isQueueVisible,
        onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded,
        onIssuesChanged: onIssuesChanged,
        onIssuesCountChanged: onIssuesCountChanged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6cqaw.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2e764b609ebcd652$var$ProjectBuilderWithQueryParamDev, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eiNWu.ChangeManagementTour), {
        projectId: (0, $ljej9.toProjectId)(`${state.appProps.projectId}`)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "incidentManagementTourQueues",
        packageName: "jiraServicedeskIncidentManagementTour",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i4aCO.IncidentManagementTour), {
        projectId: (0, $ljej9.toProjectId)(`${state.appProps.projectId}`)
    })), (0, $7jTnu.fg)('jsm_project_summary_onboarding') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f0fwB.default), {
        projectKey: state.appProps.projectKey
    }));
};
// this component moves analytics context up above ServiceDeskSubAppBase
// in order to be able to use useAnalyticsEvents hook, and obtain createAnalyticsEvent function
// that function is then added to the initial state of ServiceDeskSubAppBase
// this allows us to remove ReduxAnalytics component altogether
const $2e764b609ebcd652$var$AgentAppComponentWithAnalyticsAtTheTop = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: "viewQueue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wyE1.ServiceDeskAnalyticsContext), {
        forceRenderWhileLoading: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2e764b609ebcd652$var$AgentAppComponent, props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: {
            context: (0, $7dWzg.ANALYTIC_CONTEXTS).QUEUES,
            redesign: true
        }
    }));
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $2e764b609ebcd652$var$AgentAppWithAnalytics = (0, $BwaQq.AnalyticsSource)('viewQueue', (0, $466f60259c330878$export$f636b5b56f1d624a))((0, $in44d.default)({
    attributes: {
        context: (0, $7dWzg.ANALYTIC_CONTEXTS).QUEUES,
        redesign: true
    }
})($2e764b609ebcd652$var$AgentApp)); // eslint-disable-line @typescript-eslint/no-explicit-any
const $2e764b609ebcd652$var$AgentAppWithFG = (0, $bJscI.componentWithFG)('issuelist_skip_fetch_cache_hit', $2e764b609ebcd652$var$AgentAppComponentWithAnalyticsAtTheTop, $2e764b609ebcd652$var$AgentAppWithAnalytics);
var $2e764b609ebcd652$export$2e2bcd8739ae039 = $2e764b609ebcd652$var$AgentAppWithFG;

});
parcelRegister("49LNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c73a915a7014742$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c417d7bba952c3ed78af209471fcd903>>
 * @relayHash d81de99d75912b13f652b0a7bf91bfd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9e1ca350c979db933088f1e74827069aaf527308e30d6ec8b18fda46d1adb92
const $3c73a915a7014742$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAris"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "issueAris"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "colorKey"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "view_issueColoredLabelsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "jira_issuesByIds",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraLabelConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedLabelsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabelEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabel",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraColor",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "color",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraLabelsField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "view_issueColoredLabelsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "jira_issuesByIds",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraLabelConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedLabelsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabelEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabel",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraColor",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "color",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v5 /*: any*/ ,
                                                                                        v2 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraLabelsField"
                                                },
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c9e1ca350c979db933088f1e74827069aaf527308e30d6ec8b18fda46d1adb92",
            "metadata": {},
            "name": "view_issueColoredLabelsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3c73a915a7014742$var$node.hash = "a1190e22498f826964af5cb163bda524";
var $3c73a915a7014742$export$2e2bcd8739ae039 = $3c73a915a7014742$var$node;

});

parcelRegister("in44d", function(module, exports) {

$parcel$export(module.exports, "default", () => $64852920c40aa53c$export$2e2bcd8739ae039);

var $dUaMU = parcelRequire("dUaMU");

var $5nSuO = parcelRequire("5nSuO");
var /**
 * @deprecated - Just provide the data when firing analytics events.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$64852920c40aa53c$export$2e2bcd8739ae039 = (payload)=>(WrappedComponent)=>(0, $dUaMU.default)((0, $5nSuO.default)(payload))(WrappedComponent);

});

parcelRegister("2wyE1", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $8f31292a89ad467e$export$ac31f8f3368d6881);

var $eJOHy = parcelRequire("eJOHy");

var $4xbv3 = parcelRequire("4xbv3");

var $6nVJI = parcelRequire("6nVJI");

var $cu1g7 = parcelRequire("cu1g7");
const $8f31292a89ad467e$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $eJOHy.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
$8f31292a89ad467e$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $cu1g7.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $6nVJI.useContainerContext)
};

});
parcelRegister("6nVJI", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $6342ac67d1a862a1$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $6342ac67d1a862a1$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $3luhJ = parcelRequire("3luhJ");

var $9pJMP = parcelRequire("9pJMP");

var $eJrcF = parcelRequire("eJrcF");

var $kQSJV = parcelRequire("kQSJV");
const $6342ac67d1a862a1$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)((0, $9pJMP.staticProjectSidebarNavigationResource));
    const projectContext = (0, $eJOHy.useMemo)(()=>data && (0, $kQSJV.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $6342ac67d1a862a1$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)((0, $3luhJ.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $eJOHy.useMemo)(()=>data && (0, $kQSJV.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $6342ac67d1a862a1$export$c7066c2d215990cf = ()=>{
    const projectContext = $6342ac67d1a862a1$var$useProjectContext();
    const userBoardContext = $6342ac67d1a862a1$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $6342ac67d1a862a1$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $6342ac67d1a862a1$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$6342ac67d1a862a1$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("kQSJV", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $3546d4ad536b057d$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $3546d4ad536b057d$export$d17fffd59c7b3c60);

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");

var $imXGf = parcelRequire("imXGf");
const $3546d4ad536b057d$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $3546d4ad536b057d$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $3546d4ad536b057d$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $7jTnu.fg)('jcs_project_type_m3')) return 0, $ln6Iy.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $ln6Iy.CORE_PROJECT;
        case 'software':
            return 0, $ln6Iy.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $ln6Iy.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $3546d4ad536b057d$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $imXGf.extractData)(projectNavInfo);
    const scope = $3546d4ad536b057d$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $3546d4ad536b057d$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $imXGf.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("3L0P8", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskSubAppBase", () => $eaf4a2263876ba87$export$8498ce0981a438a);

var $eJOHy = parcelRequire("eJOHy");

var $4tM8k = parcelRequire("4tM8k");

var $cT3Ey = parcelRequire("cT3Ey");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");

var $9wb1o = parcelRequire("9wb1o");

var $kdtbe = parcelRequire("kdtbe");

var $jMGNC = parcelRequire("jMGNC");

var $58oLH = parcelRequire("58oLH");
// eslint-disable-next-line jira/react/no-class-components
class $eaf4a2263876ba87$var$ServiceDeskSubApp extends (0, $eJOHy.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            children: null,
            onErrorHandler: null
        };
    }
    static{
        this.childContextTypes = {
            monolithNavigationProxy: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).object
        };
    }
    constructor(props){
        super(props), this.onNavigationReject = ()=>{
            this.monolithNavigationProxy?.rejectNavigation();
        }, this.onNavigationConfirm = ()=>{
            this.monolithNavigationProxy?.confirmNavigation();
        };
        this.monolithNavigationProxy = (0, $kdtbe.createMonolithNavigationProxy)();
        const navigationBridgeEpic = (0, $9wb1o.createMonolithNavigationMiddleware)(this.onNavigationConfirm, this.onNavigationReject);
        this.store = (0, $58oLH.createStore)(this.props.appName, this.props.initialState, this.props.rootReducer, this.props.extraMiddleware || [], (0, $4tM8k.combineEpics)(navigationBridgeEpic, this.props.rootEpic));
    }
    getChildContext() {
        return {
            monolithNavigationProxy: this.monolithNavigationProxy
        };
    }
    shouldComponentUpdate(nextProps) {
        const { appName: appName, rootReducer: rootReducer, rootEpic: rootEpic, children: children, extraMiddleware: extraMiddleware, onErrorHandler: onErrorHandler } = this.props;
        // If any prop other than initialState has changed
        return appName !== nextProps.appName || rootReducer !== nextProps.rootReducer || rootEpic !== nextProps.rootEpic || children !== nextProps.children || extraMiddleware !== nextProps.extraMiddleware || onErrorHandler !== nextProps.onErrorHandler;
    }
    // This state update must happens before render() is called to avoid the wrong queue from loading
    UNSAFE_componentWillUpdate(nextProps) {
        this.resetAppPropsState(this.props.initialState.appProps.projectKey, nextProps.initialState.appProps.projectKey, nextProps.initialState.appProps);
    }
    componentWillUnmount() {
        this.monolithNavigationProxy?.disable();
    }
    resetAppPropsState(currentProjectKey, nextProjectKey, appProps) {
        const { resetProjectContextAction: resetProjectContextAction } = this.props;
        if (!resetProjectContextAction) return;
        if (currentProjectKey !== nextProjectKey) this.store.dispatch(resetProjectContextAction(appProps));
    }
    render() {
        const { children: children, appName: appName, onErrorHandler: onErrorHandler, ErrorView: ErrorView } = this.props;
        // We put the error boundary below <AppBase>, to intercept errors before the error boundary provided by AppBase
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMGNC.ServiceDeskErrorBoundary), {
            appName: appName,
            onErrorHandler: onErrorHandler,
            ErrorView: ErrorView
        }, children)));
    }
}
const $eaf4a2263876ba87$export$8498ce0981a438a = $eaf4a2263876ba87$var$ServiceDeskSubApp;

});
parcelRegister("9wb1o", function(module, exports) {

$parcel$export(module.exports, "createMonolithNavigationMiddleware", () => $ca7b12653b1bc598$export$240003469c974148);

var $7kixv = parcelRequire("7kixv");
parcelRequire("1AyD5");
parcelRequire("d2zWP");

var $7c3NP = parcelRequire("7c3NP");
const $ca7b12653b1bc598$export$240003469c974148 = (onNavigationConfirm, onNavigationReject)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action$)=>action$.ofType((0, $7c3NP.REJECT_NAVIGATION), (0, $7c3NP.CONFIRM_NAVIGATION)).switchMap((action)=>{
            switch(action.type){
                case 0, $7c3NP.REJECT_NAVIGATION:
                    onNavigationReject();
                    break;
                case 0, $7c3NP.CONFIRM_NAVIGATION:
                    onNavigationConfirm();
                    break;
                default:
                    return (0, $7kixv.Observable).empty();
            }
            return (0, $7kixv.Observable).empty();
        });

});
parcelRegister("7c3NP", function(module, exports) {

$parcel$export(module.exports, "REJECT_NAVIGATION", () => $831a41e847b7950a$export$c3435b1d4d47dde6);
$parcel$export(module.exports, "rejectNavigationAction", () => $831a41e847b7950a$export$ce226bb73ade3056);
$parcel$export(module.exports, "CONFIRM_NAVIGATION", () => $831a41e847b7950a$export$612d6f3c633890da);
$parcel$export(module.exports, "confirmNavigationAction", () => $831a41e847b7950a$export$949b9bb33ccd5cc0);
// REJECT_NAVIGATION
const $831a41e847b7950a$export$c3435b1d4d47dde6 = 'navigation.bridge.epic.REJECT_NAVIGATION';
const $831a41e847b7950a$export$ce226bb73ade3056 = ()=>({
        type: $831a41e847b7950a$export$c3435b1d4d47dde6
    });
const $831a41e847b7950a$export$612d6f3c633890da = 'navigation.bridge.epic.CONFIRM_NAVIGATION';
const $831a41e847b7950a$export$949b9bb33ccd5cc0 = ()=>({
        type: $831a41e847b7950a$export$612d6f3c633890da
    });

});


parcelRegister("kdtbe", function(module, exports) {

$parcel$export(module.exports, "createMonolithNavigationProxy", () => $a2d0788b6a0d4eac$export$c2e28f1ed2448c47);

var $32HVQ = parcelRequire("32HVQ");
class $a2d0788b6a0d4eac$export$6f7ee1854d56f663 {
    cleanUpPromiseCallBack() {
        delete this.resolveFn;
        delete this.rejectFn;
    }
    /**
	 * Calling setBeforeNavigateListener is deferred to here, so that we don't go through a state
	 * where setBeforeNavigateListener fails to register the new listener because there is already
	 * a listener from another page that hasn't finished cleaning up yet.
	 * This is because an instance of the old page and the new page will both be active during a
	 * navigation. I.e. we need componentWillUnmount of the old page to call #disable before setting
	 * the new listener.
	 */ block(beforeNavigateCallback) {
        (0, $32HVQ.RouterManager).deleteBeforeNavigateListener();
        (0, $32HVQ.RouterManager).setBeforeNavigateListener(this.onBeforeNavigate);
        this.beforeNavigateCallback = beforeNavigateCallback;
    }
    unblock() {
        this.beforeNavigateCallback = undefined;
    }
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onBeforeNavigate = (fragment)=>{
            if (!this.beforeNavigateCallback) return Promise.resolve(null);
            this.promise = new Promise((resolve, reject)=>{
                this.resolveFn = resolve;
                this.rejectFn = reject;
            });
            this.beforeNavigateCallback(fragment);
            return this.promise;
        };
        this.confirmNavigation = ()=>{
            this.resolveFn?.();
            this.cleanUpPromiseCallBack();
        };
        this.rejectNavigation = ()=>{
            this.rejectFn?.();
            this.cleanUpPromiseCallBack();
        };
        this.disable = ()=>{
            (0, $32HVQ.RouterManager).deleteBeforeNavigateListener();
        };
    }
}
const $a2d0788b6a0d4eac$export$c2e28f1ed2448c47 = ()=>new $a2d0788b6a0d4eac$export$6f7ee1854d56f663();

});
parcelRegister("32HVQ", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        function t(r) {
            if (n[r]) return n[r].exports;
            var o = n[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.d = function(e, n, r) {
            t.o(e, n) || Object.defineProperty(e, n, {
                configurable: !1,
                enumerable: !0,
                get: r
            });
        }, t.n = function(e) {
            var n = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(n, "a", n), n;
        }, t.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 3);
    }([
        function(e, t) {
            var n;
            n = function() {
                return this;
            }();
            try {
                n = n || Function("return this")() || (0, eval)("this");
            } catch (e) {
                "object" == typeof window && (n = window);
            }
            e.exports = n;
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.window._jsdFeRouting = e.window._jsdFeRouting || {}, e.window._jsdFeRouting;
                }
                function r() {
                    var t = n();
                    !t || t.feRouteFn || t.beforeNavigateListener || t.willNavigateListener || delete e.window._jsdFeRouting;
                }
                function o() {
                    return n().feRouteFn;
                }
                function i() {
                    delete n().feRouteFn, r();
                }
                function u(e) {
                    o() && console.error("Warning: [Service Desk Frontend routing] FeRouteFunction already exists. This function should be set only once per app."), n().feRouteFn = e;
                }
                function a() {
                    return n().beforeNavigateListener;
                }
                function s(e) {
                    a() && console.error("[Service Desk Frontend routing] beforeNavigateListener already exists. Listener should be set only once per app. Make sure you don't set it twice, or forget to unset it when your app unmounts"), n().beforeNavigateListener = e;
                }
                function c() {
                    delete n().beforeNavigateListener, r();
                }
                function l(e) {
                    var t = a();
                    return t ? t(e) : Promise.resolve();
                }
                function g() {
                    delete n().willNavigateListener, r();
                }
                function f() {
                    return n().willNavigateListener;
                }
                function d(e) {
                    f() && console.error("[Service Desk Frontend routing] willNavigateListener already exists. Listener should be set only once per app. Make sure you don't set it twice, or forget to unset it when your app unmounts"), n().willNavigateListener = e;
                }
                function y() {
                    var e = f();
                    if (!e) return void console.warn("[Service Desk Frontend routing] willNavigateListener is not defined. You should unmountComponentAtNode within a willNavigateListener. This is probably a memory leak.");
                    e();
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getFeRouteFunction = o, t.deleteFeRouteFunction = i, t.setFeRouteFunction = u, t.setBeforeNavigateListener = s, t.deleteBeforeNavigateListener = c, t.onBeforeNavigate = l, t.deleteWillNavigateListener = g, t.setWillNavigateListener = d, t.onWillNavigate = y;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.window._jsdFeComponentRegistry = e.window._jsdFeComponentRegistry || {}, e.window._jsdFeComponentRegistry;
                }
                function r(e, t) {
                    n()[e] = t;
                }
                function o(e, t, n) {
                    return new Promise(function(r, o) {
                        a(e, t, n, i, r, o);
                    });
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.registerFeComponent = r, t.renderFeComponentAsync = o;
                var i = 20, u = t.renderFeComponent = function(e, t, r) {
                    var o = n()[e];
                    if (o) return o(t, r);
                    throw new Error("FE component not found: '" + String(e) + "'");
                }, a = function e(t, n, r, o, i, a) {
                    try {
                        var s = u(t, n, r);
                        i(s);
                    } catch (u) {
                        o <= 0 ? a(u) : setTimeout(function() {
                            return e(t, n, r, o - 1, i, a);
                        }, 500);
                    }
                };
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            function r(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e) for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return t.default = e, t;
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Events = t.LegacyModuleRegistry = t.LegacyPageRegistry = t.ComponentRegistry = t.PageEnabler = t.RouterManager = void 0;
            var o = n(1), i = r(o), u = n(2), a = r(u), s = n(4), c = r(s), l = n(5), g = r(l), f = n(6), d = r(f), y = n(7), v = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }(y);
            t.RouterManager = i, t.PageEnabler = v.default, t.ComponentRegistry = a, t.LegacyPageRegistry = c, t.LegacyModuleRegistry = d, t.Events = g;
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n(e, t) {
                    var n = e && e.getPage && e.getPage(t);
                    return n ? n.controllerForJiraFrontend ? n && n.controllerForJiraFrontend() : Promise.reject("Page doesn't have a suitable controller method '" + t + "'") : Promise.reject("Trying to access a page that doesn't exist: '" + t + "'");
                }
                function r() {
                    return e._jsdLegacyAgentPageRegistry;
                }
                function o(t) {
                    e._jsdLegacyAgentPageRegistry = t;
                }
                function i(e) {
                    return n(r(), e);
                }
                function u() {
                    return e._jsdLegacySettingsPageRegistry;
                }
                function a(t) {
                    e._jsdLegacySettingsPageRegistry = t;
                }
                function s(e) {
                    var t = u();
                    return t ? n(t, e) : Promise.reject("Registry does not exist");
                }
                function c() {
                    e._jsdLegacyAgentPageRegistry = {}, e._jsdLegacySettingsPageRegistry = {};
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getGlobalLegacyAgentPageRegistry = r, t.registerLegacyAgentPageRegistry = o, t.runLegacyAgentPageController = i, t.getGlobalLegacySettingsPageRegistry = u, t.registerLegacySettingsPageRegistry = a, t.runLegacySettingsPageController = s, t.clearLegacyPageRegistries = c;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function n() {
                    return e.__jsdLegacyEventBus = e.__jsdLegacyEventBus || {}, e.__jsdLegacyEventBus;
                }
                function r(e) {
                    return n()[e] || [];
                }
                function o(e, t) {
                    var o = n(), i = r(e);
                    i.push(t), o[e] = i;
                }
                function i(e, t) {
                    if (t) {
                        var o = n(), i = r(e);
                        o[e] = i.filter(function(e) {
                            return e !== t;
                        });
                    } else n()[e] = [];
                }
                function u(e, t) {
                    r(e).forEach(function(e) {
                        return e(t);
                    });
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.on = o, t.off = i, t.trigger = u;
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = t.getLegacyModuleRegistry = function() {
                    return e._jsdLegacyModuleRegistry = e._jsdLegacyModuleRegistry || {}, e._jsdLegacyModuleRegistry;
                };
                t.registerLegacyModule = function(e, t) {
                    n()[e] = t;
                };
            }).call(t, n(0));
        },
        function(e, t, n) {
            "use strict";
            (function(e) {
                function r(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function o(t) {
                    var n = new URL(e.window.location.href), r = n.href.slice(n.origin.length), o = new URL(t), i = o.href.slice(o.origin.length), u = n.hostname === o.hostname && r.startsWith(i) ? r.slice(i.length) : r;
                    return "/" === u[0] ? u : "/" + u;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var i = function() {
                    function e(e, t) {
                        for(var n = 0; n < t.length; n++){
                            var r = t[n];
                            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                        }
                    }
                    return function(t, n, r) {
                        return n && e(t.prototype, n), r && e(t, r), t;
                    };
                }(), u = n(1), a = n(2), s = function() {
                    function e() {
                        r(this, e);
                    }
                    return i(e, [
                        {
                            key: "enablePage",
                            value: function(e, t) {
                                (0, u.deleteFeRouteFunction)();
                                try {
                                    return (0, a.renderFeComponent)(e.feComponentId, t[0], {});
                                } catch (e) {
                                    return Promise.reject(e);
                                }
                            }
                        },
                        {
                            key: "updatePage",
                            value: function(e, t) {
                                var n = (0, u.getFeRouteFunction)();
                                if (t.feComponentId && n) n(o(e));
                                return Promise.resolve();
                            }
                        },
                        {
                            key: "disablePage",
                            value: function() {
                                (0, u.deleteFeRouteFunction)(), (0, u.deleteBeforeNavigateListener)(), (0, u.onWillNavigate)(), (0, u.deleteWillNavigateListener)();
                            }
                        },
                        {
                            key: "beforeNavigate",
                            value: function(e) {
                                return (0, u.onBeforeNavigate)(e);
                            }
                        }
                    ]), e;
                }();
                t.default = s;
            }).call(t, n(0));
        }
    ]);
});

});


parcelRegister("jMGNC", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskErrorBoundary", () => $c920cf392f6f6d66$export$d999c9325a45f4cf);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $gy2Qg = parcelRequire("gy2Qg");
/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ const $c920cf392f6f6d66$var$triggerAnalyticsEvent = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $c920cf392f6f6d66$var$toErrorOrUndefined = (error)=>{
    if (error instanceof Error) return error;
    if (typeof error === 'string') return new Error(error);
    return undefined;
};
class $c920cf392f6f6d66$export$d999c9325a45f4cf extends (0, $eJOHy.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    constructor(props){
        super(props), this.state = {
            hasError: false
        };
        this.triggerEvent = $c920cf392f6f6d66$var$triggerAnalyticsEvent(`${props.appName}`);
    }
    componentDidCatch(error) {
        const { onErrorHandler: onErrorHandler, ErrorView: ErrorView, appName: appName } = this.props;
        const data = error instanceof Error ? {
            message: error.message,
            stack: error.stack
        } : {
            message: error
        };
        this.triggerEvent('error-boundary.error-caught', data);
        (0, $gYnSx.default)({
            meta: {
                id: 'unhandled',
                packageName: (0, $gy2Qg.toPackageName)(appName) || 'jiraServicedeskCommon'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            event: this.triggerEvent,
            error: $c920cf392f6f6d66$var$toErrorOrUndefined(error),
            sendToPrivacyUnsafeSplunk: true
        });
        // If error view is present then allow error view to handle errors.
        if (ErrorView) return;
        // Some of the non spa apps uses this call back function which doesn't have any error view
        if (onErrorHandler) onErrorHandler(error);
        else // Rethrow for error boundary handling by app-base
        throw error;
    }
    render() {
        const { hasError: hasError } = this.state;
        const { ErrorView: ErrorView, children: children } = this.props;
        if (hasError && ErrorView) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ErrorView, null);
        return children;
    }
}

});

parcelRegister("58oLH", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $3e48c0eb9ad71fdd$export$f51a9068ac82ea43);
parcelRequire("4oeCp");
var $d0BCP = parcelRequire("d0BCP");
var $5SIoM = parcelRequire("5SIoM");

var $gs6vs = parcelRequire("gs6vs");

var $32HVQ = parcelRequire("32HVQ");
const $3e48c0eb9ad71fdd$var$combineMiddleWare = (extraMiddleware, history)=>{
    const middlewares = extraMiddleware.slice(0);
    if (history) middlewares.push((0, $5SIoM.default)(history));
    return middlewares;
};
const $3e48c0eb9ad71fdd$var$initStore = (storeName, initialState, rootReducer, extraMiddleware, rootEpic, history)=>{
    const middlewares = $3e48c0eb9ad71fdd$var$combineMiddleWare(extraMiddleware, history);
    return (0, $gs6vs.default)({
        appName: storeName,
        initialState: initialState,
        rootReducer: rootReducer,
        rootEpic: rootEpic,
        middlewares: middlewares
    });
};
const $3e48c0eb9ad71fdd$export$f51a9068ac82ea43 = (storeName, initialState, rootReducer, extraMiddleware = [], rootEpic, history, basename)=>{
    const store = $3e48c0eb9ad71fdd$var$initStore(storeName, initialState, rootReducer, extraMiddleware, rootEpic, history);
    // Expose a route function to the JSD monolith, allowing its page-enabler
    // to manage routing.  We 'replace' the history here as JSD already
    // provides us with a history mechanism; avoids double-up.
    if (history) (0, $32HVQ.RouterManager).setFeRouteFunction((url)=>store.dispatch((0, $d0BCP.replace)(url.replace(basename || '', ''))));
    return store;
};

});
parcelRegister("4oeCp", function(module, exports) {

$parcel$export(module.exports, "routerReducer", () => (parcelRequire("PCq9W")).routerReducer);
$parcel$export(module.exports, "replace", () => (parcelRequire("d0BCP")).replace);
$parcel$export(module.exports, "routerMiddleware", () => (parcelRequire("5SIoM")).default);

var $X6ygm = parcelRequire("X6ygm");

var $1IDLJ = parcelRequire("1IDLJ");

var $PCq9W = parcelRequire("PCq9W");

var $d0BCP = parcelRequire("d0BCP");

var $5SIoM = parcelRequire("5SIoM");

});
parcelRegister("X6ygm", function(module, exports) {

var $eJOHy = parcelRequire("eJOHy");

var $cT3Ey = parcelRequire("cT3Ey");

var $j7vD1 = parcelRequire("j7vD1");

var $PCq9W = parcelRequire("PCq9W");
function $0b1a97d1e8f6ba09$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0b1a97d1e8f6ba09$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0b1a97d1e8f6ba09$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $0b1a97d1e8f6ba09$var$ConnectedRouter = function(_Component) {
    $0b1a97d1e8f6ba09$var$_inherits(ConnectedRouter, _Component);
    function ConnectedRouter() {
        var _temp, _this, _ret;
        $0b1a97d1e8f6ba09$var$_classCallCheck(this, ConnectedRouter);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $0b1a97d1e8f6ba09$var$_possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.handleLocationChange = function(location) {
            _this.store.dispatch({
                type: (0, $PCq9W.LOCATION_CHANGE),
                payload: location
            });
        }, _temp), $0b1a97d1e8f6ba09$var$_possibleConstructorReturn(_this, _ret);
    }
    ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
        var _props = this.props, propsStore = _props.store, history = _props.history, isSSR = _props.isSSR;
        this.store = propsStore || this.context.store;
        this.handleLocationChange(history.location);
        if (!isSSR) this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
    };
    ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
    };
    ConnectedRouter.prototype.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j7vD1.default), this.props);
    };
    return ConnectedRouter;
}((0, $eJOHy.Component));
$0b1a97d1e8f6ba09$var$ConnectedRouter.propTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).object,
    history: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).node,
    isSSR: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).bool
};
$0b1a97d1e8f6ba09$var$ConnectedRouter.contextTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).object
};
var $0b1a97d1e8f6ba09$export$2e2bcd8739ae039 = $0b1a97d1e8f6ba09$var$ConnectedRouter;

});
parcelRegister("j7vD1", function(module, exports) {

$parcel$export(module.exports, "default", () => $deb7348074cb395f$export$2e2bcd8739ae039);

var $9Hk5t = parcelRequire("9Hk5t");

var $423Vm = parcelRequire("423Vm");

var $eJOHy = parcelRequire("eJOHy");

var $cT3Ey = parcelRequire("cT3Ey");
var $deb7348074cb395f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $deb7348074cb395f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $deb7348074cb395f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $deb7348074cb395f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $deb7348074cb395f$var$Router = function(_React$Component) {
    $deb7348074cb395f$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $deb7348074cb395f$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $deb7348074cb395f$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $deb7348074cb395f$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $deb7348074cb395f$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($423Vm)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9Hk5t)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component);
$deb7348074cb395f$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).node
};
$deb7348074cb395f$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).object
};
$deb7348074cb395f$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).object.isRequired
};
var $deb7348074cb395f$export$2e2bcd8739ae039 = $deb7348074cb395f$var$Router;

});

parcelRegister("PCq9W", function(module, exports) {

$parcel$export(module.exports, "LOCATION_CHANGE", () => $09b29121713e4f5d$export$be84bd1ba815d4c2);
$parcel$export(module.exports, "routerReducer", () => $09b29121713e4f5d$export$a6e30f0f4d30936a);
var $09b29121713e4f5d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $09b29121713e4f5d$export$be84bd1ba815d4c2 = '@@router/LOCATION_CHANGE';
var $09b29121713e4f5d$var$initialState = {
    location: null
};
function $09b29121713e4f5d$export$a6e30f0f4d30936a() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $09b29121713e4f5d$var$initialState;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, type = _ref.type, payload = _ref.payload;
    if (type === $09b29121713e4f5d$export$be84bd1ba815d4c2) return $09b29121713e4f5d$var$_extends({}, state, {
        location: payload
    });
    return state;
}

});


parcelRegister("1IDLJ", function(module, exports) {

var $9ewMm = parcelRequire("9ewMm");
var $1408bfc93f2b6d67$export$e7fd20fad3cf4b5f = function getLocation(state) {
    return state.router.location;
};
var $1408bfc93f2b6d67$export$a7b4d762fce9f62a = function createMatchSelector(path) {
    var lastPathname = null;
    var lastMatch = null;
    return function(state) {
        var _ref = $1408bfc93f2b6d67$export$e7fd20fad3cf4b5f(state) || {}, pathname = _ref.pathname;
        if (pathname === lastPathname) return lastMatch;
        lastPathname = pathname;
        var match = (0, $9ewMm.default)(pathname, path);
        if (!match || !lastMatch || match.url !== lastMatch.url) lastMatch = match;
        return lastMatch;
    };
};

});
parcelRegister("9ewMm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b8ed91d7ac08026$export$2e2bcd8739ae039);

var $iJIPY = parcelRequire("iJIPY");
var $6b8ed91d7ac08026$var$patternCache = {};
var $6b8ed91d7ac08026$var$cacheLimit = 10000;
var $6b8ed91d7ac08026$var$cacheCount = 0;
var $6b8ed91d7ac08026$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $6b8ed91d7ac08026$var$patternCache[cacheKey] || ($6b8ed91d7ac08026$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($iJIPY)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($6b8ed91d7ac08026$var$cacheCount < $6b8ed91d7ac08026$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $6b8ed91d7ac08026$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $6b8ed91d7ac08026$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $6b8ed91d7ac08026$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $6b8ed91d7ac08026$export$2e2bcd8739ae039 = $6b8ed91d7ac08026$var$matchPath;

});
parcelRegister("iJIPY", function(module, exports) {

var $jvIcp = parcelRequire("jvIcp");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $da3f35b4ba3d1e18$var$pathToRegexp;
module.exports.parse = $da3f35b4ba3d1e18$var$parse;
module.exports.compile = $da3f35b4ba3d1e18$var$compile;
module.exports.tokensToFunction = $da3f35b4ba3d1e18$var$tokensToFunction;
module.exports.tokensToRegExp = $da3f35b4ba3d1e18$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $da3f35b4ba3d1e18$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $da3f35b4ba3d1e18$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $da3f35b4ba3d1e18$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $da3f35b4ba3d1e18$var$escapeGroup(pattern) : asterisk ? '.*' : $da3f35b4ba3d1e18$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $da3f35b4ba3d1e18$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $da3f35b4ba3d1e18$var$escapeString(delimiter) + ']+?';
    return $da3f35b4ba3d1e18$var$escapeString(prevText) + '|(?:(?!' + $da3f35b4ba3d1e18$var$escapeString(prevText) + ')[^' + $da3f35b4ba3d1e18$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $da3f35b4ba3d1e18$var$compile(str, options) {
    return $da3f35b4ba3d1e18$var$tokensToFunction($da3f35b4ba3d1e18$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $da3f35b4ba3d1e18$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $da3f35b4ba3d1e18$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $da3f35b4ba3d1e18$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $da3f35b4ba3d1e18$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $da3f35b4ba3d1e18$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($jvIcp(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $da3f35b4ba3d1e18$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $da3f35b4ba3d1e18$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $da3f35b4ba3d1e18$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $da3f35b4ba3d1e18$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $da3f35b4ba3d1e18$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $da3f35b4ba3d1e18$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $da3f35b4ba3d1e18$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $da3f35b4ba3d1e18$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($da3f35b4ba3d1e18$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $da3f35b4ba3d1e18$var$flags(options));
    return $da3f35b4ba3d1e18$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $da3f35b4ba3d1e18$var$stringToRegexp(path, keys, options) {
    return $da3f35b4ba3d1e18$var$tokensToRegExp($da3f35b4ba3d1e18$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $da3f35b4ba3d1e18$var$tokensToRegExp(tokens, keys, options) {
    if (!$jvIcp(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $da3f35b4ba3d1e18$var$escapeString(token);
        else {
            var prefix = $da3f35b4ba3d1e18$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $da3f35b4ba3d1e18$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $da3f35b4ba3d1e18$var$attachKeys(new RegExp('^' + route, $da3f35b4ba3d1e18$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $da3f35b4ba3d1e18$var$pathToRegexp(path, keys, options) {
    if (!$jvIcp(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $da3f35b4ba3d1e18$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($jvIcp(path)) return $da3f35b4ba3d1e18$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $da3f35b4ba3d1e18$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("jvIcp", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});




parcelRegister("d0BCP", function(module, exports) {

$parcel$export(module.exports, "CALL_HISTORY_METHOD", () => $97887605d5f68532$export$d035cdafa5d37a89);
$parcel$export(module.exports, "replace", () => $97887605d5f68532$export$77ad94ebf1c2b9ed);
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */ var $97887605d5f68532$export$d035cdafa5d37a89 = '@@router/CALL_HISTORY_METHOD';
function $97887605d5f68532$var$updateLocation(method) {
    return function() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return {
            type: $97887605d5f68532$export$d035cdafa5d37a89,
            payload: {
                method: method,
                args: args
            }
        };
    };
}
var $97887605d5f68532$export$4cbf152802aa238 = $97887605d5f68532$var$updateLocation('push');
var $97887605d5f68532$export$77ad94ebf1c2b9ed = $97887605d5f68532$var$updateLocation('replace');
var $97887605d5f68532$export$93bb224d05b3906d = $97887605d5f68532$var$updateLocation('go');
var $97887605d5f68532$export$28fca2ccfd38b8f = $97887605d5f68532$var$updateLocation('goBack');
var $97887605d5f68532$export$994d0e87e52ba8e3 = $97887605d5f68532$var$updateLocation('goForward');
var $97887605d5f68532$export$95755023e698c378 = {
    push: $97887605d5f68532$export$4cbf152802aa238,
    replace: $97887605d5f68532$export$77ad94ebf1c2b9ed,
    go: $97887605d5f68532$export$93bb224d05b3906d,
    goBack: $97887605d5f68532$export$28fca2ccfd38b8f,
    goForward: $97887605d5f68532$export$994d0e87e52ba8e3
};

});

parcelRegister("5SIoM", function(module, exports) {

$parcel$export(module.exports, "default", () => $44846f8783b00a38$export$2e2bcd8739ae039);

var $d0BCP = parcelRequire("d0BCP");
function $44846f8783b00a38$export$2e2bcd8739ae039(history) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type !== (0, $d0BCP.CALL_HISTORY_METHOD)) return next(action);
                var _action$payload = action.payload, method = _action$payload.method, args = _action$payload.args;
                history[method].apply(history, args);
            };
        };
    };
}

});




parcelRegister("7dWzg", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_CONTEXTS", () => $4f44c34c31d674e4$export$ca021921d5c56515);
$parcel$export(module.exports, "ttiRecommendedSlo", () => $4f44c34c31d674e4$export$dc391c7d81907d3a);
$parcel$export(module.exports, "trackJsdFetchErrors", () => $4f44c34c31d674e4$export$ebdbd98df5a27905);

var $gYnSx = parcelRequire("gYnSx");

var $d3nJY = parcelRequire("d3nJY");
const $4f44c34c31d674e4$export$ca021921d5c56515 = {
    AUTOMATION_SETTINGS: 'AutomationSettings',
    KNOWLEDGE: 'Knowledge',
    QUEUES: 'Queues',
    CSAT: 'Csat'
};
const $4f44c34c31d674e4$export$cca3c4e11cb0a5ce = 1000;
const $4f44c34c31d674e4$export$dc391c7d81907d3a = 4000;
const $4f44c34c31d674e4$export$ebdbd98df5a27905 = async (payload)=>{
    const { error: error, attributes: attributes } = payload;
    if (error instanceof (0, $d3nJY.JsdFetchError)) {
        const { reasonKey: reasonKey } = error;
        (0, $gYnSx.trackFetchErrors)({
            ...payload,
            attributes: {
                ...attributes,
                reasonKey: reasonKey
            }
        });
        return;
    }
    (0, $gYnSx.trackFetchErrors)(payload);
};

});
parcelRegister("d3nJY", function(module, exports) {

$parcel$export(module.exports, "JsdFetchError", () => $31b22b293239e2e3$export$fee0012ae6cb3438);
$parcel$export(module.exports, "performRequest", () => $31b22b293239e2e3$export$5e3f71e18db84142);
$parcel$export(module.exports, "performGetRequest", () => $31b22b293239e2e3$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $31b22b293239e2e3$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $31b22b293239e2e3$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $31b22b293239e2e3$export$8ef51cba9d28f819);

var $8dH3d = parcelRequire("8dH3d");

var $6dPbw = parcelRequire("6dPbw");

var $1oMOM = parcelRequire("1oMOM");


var $ee0TI = parcelRequire("ee0TI");

var $1uIew = parcelRequire("1uIew");

var $jGzN3 = parcelRequire("jGzN3");
const $31b22b293239e2e3$var$VALIDATION_ERROR_KEY = 'validation.error';
class $31b22b293239e2e3$export$fee0012ae6cb3438 extends (0, $1uIew.default) {
    constructor(statusCode, message, reasonKey, response){
        super(statusCode, (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
        this.name = 'JsdFetchError';
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6dPbw)))(reasonKey)) this.reasonKey = reasonKey;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($6dPbw)))(response)) this.response = response;
    }
}
const $31b22b293239e2e3$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
        messages.push(errorMessage);
        return messages;
    }, []).join(' ');
const $31b22b293239e2e3$var$putOptions = {
    ...(0, $1oMOM.defaultOptions),
    method: 'PUT'
};
const $31b22b293239e2e3$var$postOptions = {
    ...(0, $1oMOM.defaultOptions),
    method: 'POST'
};
const $31b22b293239e2e3$var$deleteOptions = {
    ...(0, $1oMOM.defaultOptions),
    method: 'DELETE'
};
const $31b22b293239e2e3$var$patchOptions = {
    ...(0, $1oMOM.defaultOptions),
    method: 'PATCH'
};
const $31b22b293239e2e3$var$processResponse = async (response)=>{
    if ((0, $44ccf6b895337c89$export$9de493bcd9b1d977) === response.status) {
        const jsonResponse = await response.json();
        const { errors: errors, reasonKey: reasonKey } = jsonResponse;
        if (reasonKey === $31b22b293239e2e3$var$VALIDATION_ERROR_KEY) throw (0, $jGzN3.transformValidationErrorFromServer)(jsonResponse);
        const message = $31b22b293239e2e3$var$transformMessageErrorsFromServer(errors);
        throw new $31b22b293239e2e3$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
    }
    if (!response.ok) {
        const traceId = response.headers.get((0, $ee0TI.TRACE_ID_HEADER));
        if (traceId != null && traceId !== '') throw new (0, $1uIew.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $1uIew.default)(response.status, `Error server response: ${response.status}`);
    }
    return response;
};
const $31b22b293239e2e3$var$toJson = (response)=>{
    if (response.status === (0, $44ccf6b895337c89$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $31b22b293239e2e3$export$5e3f71e18db84142 = (url, options = {})=>fetch(url, {
        ...(0, $1oMOM.defaultOptions),
        ...options
    }).then($31b22b293239e2e3$var$processResponse);
const $31b22b293239e2e3$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
        ...(0, $1oMOM.defaultOptions),
        ...options
    }).then($31b22b293239e2e3$var$processResponse).then($31b22b293239e2e3$var$toJson);
const $31b22b293239e2e3$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
        ...$31b22b293239e2e3$var$putOptions,
        ...options
    }).then($31b22b293239e2e3$var$processResponse).then($31b22b293239e2e3$var$toJson);
const $31b22b293239e2e3$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
        ...$31b22b293239e2e3$var$postOptions,
        ...options
    }).then($31b22b293239e2e3$var$processResponse).then($31b22b293239e2e3$var$toJson);
const $31b22b293239e2e3$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
        ...$31b22b293239e2e3$var$deleteOptions,
        ...options
    }).then($31b22b293239e2e3$var$processResponse).then($31b22b293239e2e3$var$toJson);
const $31b22b293239e2e3$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
        ...$31b22b293239e2e3$var$patchOptions,
        ...options
    }).then($31b22b293239e2e3$var$processResponse).then($31b22b293239e2e3$var$toJson);

});


parcelRegister("l6Zyu", function(module, exports) {

$parcel$export(module.exports, "SHOW_PROJECT_BUILDER_QUERY_PARAM", () => $752c2f06d5757a5c$export$ca06930325b64075);
$parcel$export(module.exports, "SHOW_PROJECT_BUILDER_QUERY_PARAM_DEV", () => $752c2f06d5757a5c$export$bdaa4b82186a5b44);
$parcel$export(module.exports, "BLANK_PROJECT_TEMPLATES", () => $752c2f06d5757a5c$export$26b62c0869751109);
const $752c2f06d5757a5c$export$ca06930325b64075 = 'showProjectBuilder';
const $752c2f06d5757a5c$export$bdaa4b82186a5b44 = 'showProjectBuilderDev';
const $752c2f06d5757a5c$export$26b62c0869751109 = [
    'com.atlassian.servicedesk:simplified-blank-project-it',
    'com.atlassian.servicedesk:simplified-blank-project-business',
    'com.atlassian.servicedesk:company-managed-blank-service-project',
    'com.atlassian.servicedesk:team-managed-blank-service-project'
];

});

parcelRegister("6KlxI", function(module, exports) {

$parcel$export(module.exports, "QueuesErrorView", () => $8ce2eeec448d7b38$export$456ee24992efc4a0);

var $eJOHy = parcelRequire("eJOHy");

var $1sChl = parcelRequire("1sChl");

var $6YFG2 = parcelRequire("6YFG2");

var $ixIwv = parcelRequire("ixIwv");
const $8ce2eeec448d7b38$var$onReloadWindow = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.reload();
};
function $8ce2eeec448d7b38$var$Error(props) {
    const { onRetry: onRetry, intl: intl, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1sChl.default), {
        // @ts-expect-error - TS2322 - Type '{ intl: IntlShapeV2; onRetry: (() => void) | undefined; header: string; description: string; retryMessage: MessageDescriptorV2; }' is not assignable to type 'IntrinsicAttributes & Omit<Pick<Props, "description" | "intl" | "onRetry" | "imageWidth" | "maxImageHeight" | "errorImage"> & Partial<Pick<Props, "header" | ... 3 more ... | "isSubtle">> & Partial<...>, "intl"> & { ...; } & { ...; }'. Caused by 2nd party lib
        intl: intl,
        onRetry: onRetry,
        header: formatMessage((0, $ixIwv.default).errorHeader),
        description: formatMessage((0, $ixIwv.default).errorMessage),
        retryMessage: (0, $ixIwv.default).retry
    });
}
$8ce2eeec448d7b38$var$Error.defaultProps = {
    onRetry: $8ce2eeec448d7b38$var$onReloadWindow
};
const $8ce2eeec448d7b38$export$456ee24992efc4a0 = (0, $6YFG2.default)($8ce2eeec448d7b38$var$Error);

});
parcelRegister("ixIwv", function(module, exports) {

$parcel$export(module.exports, "default", () => $a220edfa0b774dc9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a220edfa0b774dc9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorHeader: {
        "id": "servicedesk.queues.agent-view.layout.queues-error-boundary.error-header",
        "defaultMessage": "We couldn't load your queue"
    },
    errorMessage: {
        "id": "servicedesk.queues.agent-view.layout.queues-error-boundary.error-message",
        "defaultMessage": "Check your network connection, then try loading the queue again."
    },
    retry: {
        "id": "servicedesk.queues.agent-view.layout.queues-error-boundary.retry",
        "defaultMessage": "Reload queue"
    }
});

});


parcelRegister("2ApNu", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $1e22f45952f0c501$export$1da6808e89ee03e);

var $dhskT = parcelRequire("dhskT");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issue/manifest.ts
var $1e22f45952f0c501$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $dhskT.JiraIssueAriResourceOwner),
    resourceType: (0, $dhskT.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $1e22f45952f0c501$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $1e22f45952f0c501$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $1e22f45952f0c501$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("dhskT", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $9ab2d7d34ec0a003$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $9ab2d7d34ec0a003$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $9ab2d7d34ec0a003$export$665a39f1b4e29e0a = "jira", $9ab2d7d34ec0a003$export$76beb4d0da177ad4 = "issue";

});


parcelRegister("iXXEI", function(module, exports) {

$parcel$export(module.exports, "useLabelsStore", () => $f27dbd7a7b07f5ab$export$760f05b2dd641a7b);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $f27dbd7a7b07f5ab$var$actions = {
    addLabelsSuggestions: (fieldId, label)=>({ setState: setState, getState: getState })=>{
            const labelSuggestions = getState().coloredLabelSuggestions;
            const suggestions = labelSuggestions ? labelSuggestions[fieldId] : [];
            const alreadyExists = suggestions.some((existingLabel)=>existingLabel.name === label.name);
            if (alreadyExists) return;
            setState({
                coloredLabelSuggestions: {
                    [fieldId]: [
                        ...suggestions,
                        label
                    ]
                }
            });
        },
    labelToColoredLabel: (labelName, labelColor)=>({ getState: getState, setState: setState })=>{
            const coloredLabelSuggestions = getState().coloredLabelSuggestionsMap;
            if (!Object.prototype.hasOwnProperty.call(coloredLabelSuggestions, labelName) && labelColor) coloredLabelSuggestions[labelName] = labelColor;
            else return;
            setState({
                coloredLabelSuggestionsMap: coloredLabelSuggestions
            });
        }
};
const $f27dbd7a7b07f5ab$var$store = (0, $GtRbT.createStore)({
    initialState: {
        coloredLabelSuggestions: {
            labels: []
        },
        coloredLabelSuggestionsMap: {}
    },
    actions: $f27dbd7a7b07f5ab$var$actions,
    name: 'ColoredLabels'
});
const $f27dbd7a7b07f5ab$export$57a5095d1d6807d3 = (0, $iJq0l.createHook)($f27dbd7a7b07f5ab$var$store);
const $f27dbd7a7b07f5ab$export$760f05b2dd641a7b = ()=>{
    const labelsStore = $f27dbd7a7b07f5ab$export$57a5095d1d6807d3();
    return labelsStore;
};

});

parcelRegister("2R0qn", function(module, exports) {

$parcel$export(module.exports, "useColoredLabelsStore", () => $cfd2a31764cb8d2c$export$454cf89d08060d53);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $cfd2a31764cb8d2c$var$actions = {
    addLabelsSuggestions: (fieldId, label)=>({ setState: setState, getState: getState })=>{
            const labelSuggestions = getState().coloredLabelSuggestions;
            const suggestions = labelSuggestions ? labelSuggestions[fieldId] : [];
            const alreadyExists = suggestions.some((existingLabel)=>existingLabel.name === label.name);
            if (alreadyExists) return;
            setState({
                coloredLabelSuggestions: {
                    [fieldId]: [
                        ...suggestions,
                        label
                    ]
                }
            });
        },
    labelToColoredLabel: (labelName, labelColor)=>({ getState: getState, setState: setState })=>{
            const coloredLabelSuggestions = getState().coloredLabelSuggestionsMap;
            if (!Object.prototype.hasOwnProperty.call(coloredLabelSuggestions, labelName) && labelColor) coloredLabelSuggestions[labelName] = labelColor;
            else return;
            setState({
                coloredLabelSuggestionsMap: coloredLabelSuggestions
            });
        },
    updateColoredLabelSuggestionsMap: (coloredLabelsMap)=>({ setState: setState })=>{
            setState({
                coloredLabelSuggestionsMap: coloredLabelsMap
            });
        }
};
const $cfd2a31764cb8d2c$var$store = (0, $GtRbT.createStore)({
    initialState: {
        coloredLabelSuggestions: {
            labels: []
        },
        coloredLabelSuggestionsMap: {}
    },
    actions: $cfd2a31764cb8d2c$var$actions,
    name: 'ColoredLabels'
});
const $cfd2a31764cb8d2c$export$57a5095d1d6807d3 = (0, $iJq0l.createHook)($cfd2a31764cb8d2c$var$store);
const $cfd2a31764cb8d2c$export$454cf89d08060d53 = ()=>{
    const labelsStore = $cfd2a31764cb8d2c$export$57a5095d1d6807d3();
    return labelsStore;
};

});

parcelRegister("7KJik", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ed4210d3ae90c42$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $gYnSx = parcelRequire("gYnSx");

var $ajASe = parcelRequire("ajASe");

var $2qnVe = parcelRequire("2qnVe");

var $4H7Rd = parcelRequire("4H7Rd");

var $6NW6s = parcelRequire("6NW6s");

var $79HQk = parcelRequire("79HQk");

var $6iLr1 = parcelRequire("6iLr1");

var $40A9q = parcelRequire("40A9q");

var $eJsZt = parcelRequire("eJsZt");

var $hA0qE = parcelRequire("hA0qE");

var $6o620 = parcelRequire("6o620");

var $bqJ8a = parcelRequire("bqJ8a");

var $iL21K = parcelRequire("iL21K");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9ed4210d3ae90c42$export$2e2bcd8739ae039 = (push)=>{
    const epic = (0, $4tM8k.combineEpics)((0, $eJsZt.default)(push), (0, $6NW6s.default)(push), (0, $6iLr1.default), (0, $40A9q.default)(), (0, $bqJ8a.default), // @ts-expect-error - No overload matches this call.
    (0, $79HQk.default), (0, $hA0qE.default), (0, $6o620.default), (0, $iL21K.default), (0, $4H7Rd.default));
    return (action$, store)=>// @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type. | TS7006 - Parameter 'stream' implicitly has an 'any' type.
        epic((0, $2qnVe.withUnpackedBatchActions)(action$), store).catch((error, stream)=>{
            (0, $gYnSx.default)({
                meta: {
                    id: 'agentViewOps',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                error: new Error(error)
            });
            (0, $ajASe.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.ops', `Unhandled error: ${error}`);
            return stream;
        });
};

});
parcelRegister("2qnVe", function(module, exports) {

$parcel$export(module.exports, "withUnpackedBatchActions", () => $29b9653eaf225d66$export$25f000f90e13af6b);

var $dFg4o = parcelRequire("dFg4o");
parcelRequire("9BkTq");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");
const $29b9653eaf225d66$export$25f000f90e13af6b = (action$)=>action$.mergeMap((action)=>{
        if (action.type === (0, $dFg4o.BATCH)) return (0, $7kixv.Observable).of(...action.payload);
        return (0, $7kixv.Observable).of(action);
    });

});

parcelRegister("4H7Rd", function(module, exports) {

$parcel$export(module.exports, "default", () => $45af2fe9eebf4df7$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");
parcelRequire("9BkTq");
parcelRequire("d2zWP");


var $cpZzK = parcelRequire("cpZzK");

var $2MzoN = parcelRequire("2MzoN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$45af2fe9eebf4df7$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $cpZzK.FILTER_QUERY_SUBMITTED)).switchMap((action)=>{
        const source = action.payload.filterQuery === null || action.payload.filterQuery === '' ? (0, $f3fa5acbda0f3e0e$export$347de2d26274ffda) : (0, $f3fa5acbda0f3e0e$export$be4c1ea173a5271a);
        return (0, $7kixv.Observable).of((0, $cpZzK.filterQueryChangedAction)(action.payload.filterQuery), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $2MzoN.loadIssuesAction)(0, source));
    });

});
const $f3fa5acbda0f3e0e$export$f162a928a40c7ab8 = 'PAGE';
const $f3fa5acbda0f3e0e$export$3de6d8bdd297654b = 'VIEW';
const $f3fa5acbda0f3e0e$export$fa4dae241333de34 = 'POLL';
const $f3fa5acbda0f3e0e$export$d4d94a8c13e2df1d = 'SCROLL';
const $f3fa5acbda0f3e0e$export$2003e3fdddd4c35b = 'SORT';
const $f3fa5acbda0f3e0e$export$347de2d26274ffda = 'FORCE_UPDATE';
const $f3fa5acbda0f3e0e$export$be4c1ea173a5271a = 'FILTER';
const $f3fa5acbda0f3e0e$export$217a2381e50d4bff = 'SIDEBAR';
const $f3fa5acbda0f3e0e$export$b5ad9376033e98b2 = 'UP';
const $f3fa5acbda0f3e0e$export$28a694fb106a7f62 = 'DOWN';
const $f3fa5acbda0f3e0e$export$57022ca1771ad970 = 'UNCHANGED';

parcelRegister("cpZzK", function(module, exports) {

$parcel$export(module.exports, "FILTER_QUERY_CHANGED", () => $a21b8c8f926e815f$export$9e0f2488271e98d0);
$parcel$export(module.exports, "filterQueryChangedAction", () => $a21b8c8f926e815f$export$5fa47224179ff864);
$parcel$export(module.exports, "FILTER_QUERY_SUBMITTED", () => $a21b8c8f926e815f$export$6a1c1f3d64af9a47);
$parcel$export(module.exports, "filterQuerySubmittedAction", () => $a21b8c8f926e815f$export$d1c2b6692ed10481);
$parcel$export(module.exports, "IS_NEW_FILTER_QUERY_PENDING", () => $a21b8c8f926e815f$export$8a6c9cbc89786426);
$parcel$export(module.exports, "isNewFilterQueryPendingAction", () => $a21b8c8f926e815f$export$ea018c090643753b);
$parcel$export(module.exports, "IS_FILTER_FOCUSED", () => $a21b8c8f926e815f$export$ec8ded223992d792);
$parcel$export(module.exports, "isFilterFocusedAction", () => $a21b8c8f926e815f$export$6fd90bc7d8a253ba);
$parcel$export(module.exports, "IS_FILTER_FAILED", () => $a21b8c8f926e815f$export$963953e34e913763);
$parcel$export(module.exports, "filterBadQueryAction", () => $a21b8c8f926e815f$export$d0b1a5137ee88e41);
// FILTER_QUERY_CHANGED
const $a21b8c8f926e815f$export$9e0f2488271e98d0 = 'state.actions.filter.FILTER_QUERY_CHANGED';
const $a21b8c8f926e815f$export$5fa47224179ff864 = (filterQuery)=>({
        type: $a21b8c8f926e815f$export$9e0f2488271e98d0,
        payload: {
            filterQuery: filterQuery
        }
    });
const $a21b8c8f926e815f$export$6a1c1f3d64af9a47 = 'state.actions.filter.FILTER_QUERY_SUBMITTED';
const $a21b8c8f926e815f$export$d1c2b6692ed10481 = (filterQuery)=>({
        type: $a21b8c8f926e815f$export$6a1c1f3d64af9a47,
        payload: {
            filterQuery: filterQuery
        }
    });
const $a21b8c8f926e815f$export$8a6c9cbc89786426 = 'state.actions.filter.IS_NEW_FILTER_QUERY_PENDING';
const $a21b8c8f926e815f$export$ea018c090643753b = (isNewFilterQueryPending)=>({
        type: $a21b8c8f926e815f$export$8a6c9cbc89786426,
        payload: {
            isNewFilterQueryPending: isNewFilterQueryPending
        }
    });
const $a21b8c8f926e815f$export$ec8ded223992d792 = 'state.actions.filter.IS_FILTER_FOCUSED';
const $a21b8c8f926e815f$export$6fd90bc7d8a253ba = (isFilterFocused)=>({
        type: $a21b8c8f926e815f$export$ec8ded223992d792,
        payload: {
            isFilterFocused: isFilterFocused
        }
    });
const $a21b8c8f926e815f$export$963953e34e913763 = 'state.actions.filter.IS_FILTER_FAILED';
const $a21b8c8f926e815f$export$d0b1a5137ee88e41 = (isNewFilterQueryPending)=>({
        type: $a21b8c8f926e815f$export$963953e34e913763,
        payload: {
            isNewFilterQueryPending: isNewFilterQueryPending
        }
    });

});

parcelRegister("2MzoN", function(module, exports) {

$parcel$export(module.exports, "OPEN_ISSUE", () => $e6564dca4cb76ac1$export$1e8a1b726c043d27);
$parcel$export(module.exports, "openIssueAction", () => $e6564dca4cb76ac1$export$d5542de2015b0d5f);
$parcel$export(module.exports, "LOAD_ISSUES", () => $e6564dca4cb76ac1$export$447a39ee503b31ea);
$parcel$export(module.exports, "loadIssuesAction", () => $e6564dca4cb76ac1$export$3eef863aa89b92c2);
$parcel$export(module.exports, "loadIssuesActionForPage", () => $e6564dca4cb76ac1$export$34fd96b3e33e0d2d);
$parcel$export(module.exports, "LOAD_ISSUES_INTERNAL", () => $e6564dca4cb76ac1$export$e13e56ae077f63d6);
$parcel$export(module.exports, "loadIssuesInternalAction", () => $e6564dca4cb76ac1$export$71ac868813e1a9ac);
$parcel$export(module.exports, "LOAD_ISSUES_SUCCESS", () => $e6564dca4cb76ac1$export$5a92ff25027c7f22);
$parcel$export(module.exports, "loadIssuesSuccessAction", () => $e6564dca4cb76ac1$export$c552dcd13b2a0c6b);
$parcel$export(module.exports, "LOAD_ISSUES_FAILURE", () => $e6564dca4cb76ac1$export$e91cdeca4d2aea23);
$parcel$export(module.exports, "loadIssuesFailureAction", () => $e6564dca4cb76ac1$export$6b830be58d650030);


var $bGwJI = parcelRequire("bGwJI");

const $e6564dca4cb76ac1$export$1e8a1b726c043d27 = 'state.actions.issue.OPEN_ISSUE';
const $e6564dca4cb76ac1$export$d5542de2015b0d5f = ()=>({
        type: $e6564dca4cb76ac1$export$1e8a1b726c043d27
    });
const $e6564dca4cb76ac1$export$447a39ee503b31ea = 'state.actions.issue.LOAD_ISSUES';
const $e6564dca4cb76ac1$export$3eef863aa89b92c2 = (startIndex, source, bypassCache = false, batchSize = (0, $bGwJI.FETCH_BATCH_SIZE))=>{
    const endIndex = startIndex + batchSize - 1;
    return {
        type: $e6564dca4cb76ac1$export$447a39ee503b31ea,
        payload: {
            startIndex: startIndex,
            endIndex: endIndex,
            source: source,
            bypassCache: bypassCache
        }
    };
};
const $e6564dca4cb76ac1$export$34fd96b3e33e0d2d = (currentPage)=>{
    const startIndex = (currentPage - 1) * (0, $b354b11309751a31$export$f88f58d1a4b2078b);
    return $e6564dca4cb76ac1$export$3eef863aa89b92c2(startIndex, (0, $f3fa5acbda0f3e0e$export$f162a928a40c7ab8));
};
const $e6564dca4cb76ac1$export$e13e56ae077f63d6 = 'state.actions.issue.LOAD_ISSUES_INTERNAL';
const $e6564dca4cb76ac1$export$71ac868813e1a9ac = (startIndex, endIndex, source, bypassCache = false)=>({
        type: $e6564dca4cb76ac1$export$e13e56ae077f63d6,
        payload: {
            startIndex: startIndex,
            endIndex: endIndex,
            source: source,
            bypassCache: bypassCache
        }
    });
const $e6564dca4cb76ac1$export$5a92ff25027c7f22 = 'state.actions.issue.LOAD_ISSUES_SUCCESS';
const $e6564dca4cb76ac1$export$c552dcd13b2a0c6b = (loadedIssuesResponse, queueId, startIndex, source)=>({
        type: $e6564dca4cb76ac1$export$5a92ff25027c7f22,
        payload: {
            loadedIssuesResponse: loadedIssuesResponse,
            queueId: queueId,
            startIndex: startIndex,
            source: source
        }
    });
const $e6564dca4cb76ac1$export$e91cdeca4d2aea23 = 'state.actions.issue.LOAD_ISSUES_FAILURE';
const $e6564dca4cb76ac1$export$6b830be58d650030 = (source, error, statusCode, isQueueEmpty, traceId)=>({
        type: $e6564dca4cb76ac1$export$e91cdeca4d2aea23,
        payload: {
            source: source,
            error: error,
            statusCode: statusCode,
            isQueueEmpty: isQueueEmpty,
            traceId: traceId
        }
    });

});
/**
 * Default Props for Table component
 */ const $b354b11309751a31$export$258441c8a79bb589 = 40;
const $b354b11309751a31$export$80fc56c6cdbfffed = true;
const $b354b11309751a31$export$6fd8e343a23be522 = false;
const $b354b11309751a31$export$f88f58d1a4b2078b = 10000;
const $b354b11309751a31$export$ad4eb70d85e8e21f = 100;



parcelRegister("6NW6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $83e41748fc52942b$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $iAYmO = parcelRequire("iAYmO");

var $6MMq7 = parcelRequire("6MMq7");

var $8NpLt = parcelRequire("8NpLt");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$83e41748fc52942b$export$2e2bcd8739ae039 = (push)=>(0, $4tM8k.combineEpics)((0, $6MMq7.default), (0, $iAYmO.default), (0, $8NpLt.default)(push));

});
parcelRegister("iAYmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f25edcb025c3562$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $2MzoN = parcelRequire("2MzoN");

var $ir4eL = parcelRequire("ir4eL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1f25edcb025c3562$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $2MzoN.LOAD_ISSUES)).mergeMap((action)=>(0, $7kixv.Observable).of((0, $ir4eL.stopPollAction)(), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $2MzoN.loadIssuesInternalAction)(action.payload.startIndex, action.payload.endIndex, // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
        action.payload.source, action.payload.bypassCache)));

});
parcelRegister("ir4eL", function(module, exports) {

$parcel$export(module.exports, "STOP_POLL", () => $3959028cbc7f2676$export$beabbea0833100ca);
$parcel$export(module.exports, "stopPollAction", () => $3959028cbc7f2676$export$2b79fcb148191d1);
$parcel$export(module.exports, "RESTART_POLL", () => $3959028cbc7f2676$export$ea1ead92e01d02d1);
$parcel$export(module.exports, "restartPollAction", () => $3959028cbc7f2676$export$ef03a991480cfcdf);
$parcel$export(module.exports, "POLL_SUCCESS", () => $3959028cbc7f2676$export$270005d7201abd12);
$parcel$export(module.exports, "pollSuccessAction", () => $3959028cbc7f2676$export$77220b17516f6c17);
$parcel$export(module.exports, "pollContentNotModifiedAction", () => $3959028cbc7f2676$export$5dda10bc6b4052b9);
$parcel$export(module.exports, "POLL_FAILURE", () => $3959028cbc7f2676$export$8cce70f9c508c33);
$parcel$export(module.exports, "pollFailureAction", () => $3959028cbc7f2676$export$b98aa82aec1f8949);
$parcel$export(module.exports, "RESET_PROJECT_STATE_HASH", () => $3959028cbc7f2676$export$22d4fc20a9bcbb3c);
$parcel$export(module.exports, "DISPLAY_UNSUCCESSFUL_POLL_WARNING", () => $3959028cbc7f2676$export$e03796746e3f4a62);
$parcel$export(module.exports, "displayUnsuccessfulPollWarningAction", () => $3959028cbc7f2676$export$9bb3518e0ef04f1a);
$parcel$export(module.exports, "DISMISS_ALL_FLAGS", () => $3959028cbc7f2676$export$8dde630a1a89a61d);
$parcel$export(module.exports, "dismissAllFlagsAction", () => $3959028cbc7f2676$export$3a102aa35c9fa2b1);
$parcel$export(module.exports, "DISMISS_WARNING_FLAG", () => $3959028cbc7f2676$export$ae3da4b73c471af0);
$parcel$export(module.exports, "dismissWarningFlagAction", () => $3959028cbc7f2676$export$6902f66f812ce9cd);
// STOP_POLL
const $3959028cbc7f2676$export$beabbea0833100ca = 'state.actions.update-metadata.STOP_POLL';
const $3959028cbc7f2676$export$2b79fcb148191d1 = ()=>({
        type: $3959028cbc7f2676$export$beabbea0833100ca
    });
const $3959028cbc7f2676$export$ea1ead92e01d02d1 = 'state.actions.update-metadata.RESTART_POLL';
const $3959028cbc7f2676$export$ef03a991480cfcdf = (skipInitialDelay = false)=>({
        type: $3959028cbc7f2676$export$ea1ead92e01d02d1,
        payload: {
            skipInitialDelay: skipInitialDelay
        }
    });
const $3959028cbc7f2676$export$270005d7201abd12 = 'state.actions.update-metadata.POLL_SUCCESS';
const $3959028cbc7f2676$export$77220b17516f6c17 = (projectStateHash, searchMode)=>({
        type: $3959028cbc7f2676$export$270005d7201abd12,
        payload: {
            projectStateHash: projectStateHash,
            searchMode: searchMode
        }
    });
const $3959028cbc7f2676$export$307cef20083545bd = 'state.actions.update-metadata.POLL_CONTENT_NOT_MODIFIED';
const $3959028cbc7f2676$export$5dda10bc6b4052b9 = ()=>({
        type: $3959028cbc7f2676$export$307cef20083545bd
    });
const $3959028cbc7f2676$export$8cce70f9c508c33 = 'state.actions.update-metadata.POLL_FAILURE';
const $3959028cbc7f2676$export$b98aa82aec1f8949 = ()=>({
        type: $3959028cbc7f2676$export$8cce70f9c508c33
    });
const $3959028cbc7f2676$export$22d4fc20a9bcbb3c = 'state.actions.update-metadata.RESET_PROJECT_STATE_HASH';
const $3959028cbc7f2676$export$b3d5f4d178d2f21e = ()=>({
        type: $3959028cbc7f2676$export$22d4fc20a9bcbb3c
    });
const $3959028cbc7f2676$export$e03796746e3f4a62 = 'state.actions.update-metadata.DISPLAY_UNSUCCESSFUL_POLL_WARNING';
const $3959028cbc7f2676$export$9bb3518e0ef04f1a = ()=>({
        type: $3959028cbc7f2676$export$e03796746e3f4a62
    });
const $3959028cbc7f2676$export$8dde630a1a89a61d = 'state.actions.update-metadata.DISMISS_ALL_FLAGS';
const $3959028cbc7f2676$export$3a102aa35c9fa2b1 = ()=>({
        type: $3959028cbc7f2676$export$8dde630a1a89a61d
    });
const $3959028cbc7f2676$export$ae3da4b73c471af0 = 'state.actions.update-metadata.DISMISS_WARNING_FLAG';
const $3959028cbc7f2676$export$6902f66f812ce9cd = ()=>({
        type: $3959028cbc7f2676$export$ae3da4b73c471af0
    });

});


parcelRegister("6MMq7", function(module, exports) {

$parcel$export(module.exports, "default", () => $db568342ad3f1a46$export$2e2bcd8739ae039);

var $dFg4o = parcelRequire("dFg4o");

var $6kS6u = parcelRequire("6kS6u");

var $7kixv = parcelRequire("7kixv");

var $jbhXM = parcelRequire("jbhXM");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $1uIew = parcelRequire("1uIew");

var $8KUFq = parcelRequire("8KUFq");
parcelRequire("9BkTq");

var $5IGQp = parcelRequire("5IGQp");


var $eAb2j = parcelRequire("eAb2j");

var $cpZzK = parcelRequire("cpZzK");

var $2MzoN = parcelRequire("2MzoN");

var $iGYMr = parcelRequire("iGYMr");

var $ir4eL = parcelRequire("ir4eL");

var $88qDC = parcelRequire("88qDC");

var $3MjJb = parcelRequire("3MjJb");

var $1TuhT = parcelRequire("1TuhT");

var $lc49q = parcelRequire("lc49q");

var $baH07 = parcelRequire("baH07");
const $db568342ad3f1a46$var$MAX_TOTAL_COUNT_DIFF = 30;
const $db568342ad3f1a46$var$getManualSortFromIssueListResult = (columns, isUsingDefaultSorting)=>{
    const manualSortingColumn = isUsingDefaultSorting ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(columns, (column)=>column.currentSorting != null);
    // @ts-expect-error - TS2322 - Type '{ sortedBy: string; sortOrder: SortOrder | undefined; } | undefined' is not assignable to type 'ManualSorting | undefined'.
    return manualSortingColumn ? {
        sortedBy: manualSortingColumn.id,
        sortOrder: manualSortingColumn.currentSorting
    } : undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$db568342ad3f1a46$export$2e2bcd8739ae039 = (action$, store)=>(0, $5IGQp.withConcurrencyLimiting)(action$.ofType((0, $2MzoN.LOAD_ISSUES_INTERNAL)), 3, (action)=>{
        const state = store.getState();
        const queueId = (0, $lc49q.getQueueId)(state);
        const shouldFireGenericErrorAnalytics = (error)=>{
            if ((0, $gYnSx.getStatusCodeGroup)(new (0, $1uIew.default)(error.statusCode)) === 'unknown' || (0, $8KUFq.isClientFetchError)(error)) return false;
            return true;
        };
        const sendGenericErrorAnalytics = (error)=>{
            (0, $gYnSx.default)({
                meta: {
                    id: 'jsmIssueListLoading',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: new (0, $1uIew.default)(error.statusCode),
                attributes: {
                    reasonKey: error.response.reasonKey,
                    reasonCode: error.response.reasonCode
                }
            });
        };
        const sendGenericErrorAnalyticsConditionally = (error)=>{
            if (shouldFireGenericErrorAnalytics(error)) sendGenericErrorAnalytics(error);
        };
        const sendSearchErrorAnalytics = (error)=>{
            (0, $gYnSx.default)({
                meta: {
                    id: 'jsmIssueListLoadingFilter',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: new (0, $1uIew.default)(error.statusCode),
                attributes: {
                    hasPassed: false
                }
            });
        };
        const shouldFireSearchErrorAnalytics = (error)=>{
            const statusCodeGroup = (0, $gYnSx.getStatusCodeGroup)(new (0, $1uIew.default)(error.statusCode));
            return action.payload.source === (0, $f3fa5acbda0f3e0e$export$be4c1ea173a5271a) && (statusCodeGroup === '5xx' || statusCodeGroup === '4xx') && !(0, $8KUFq.isClientFetchError)(error);
        };
        const sendErrorAnalytics = (error)=>{
            if (shouldFireSearchErrorAnalytics(error)) sendSearchErrorAnalytics(error);
            sendGenericErrorAnalyticsConditionally(error);
        };
        const isUpdate = (0, $7jTnu.fg)('jsm-corcap-3692-call-issuelist-bck-from-issue-view') ? (0, $f3fa5acbda0f3e0e$export$fa4dae241333de34) === action.payload.source : [
            (0, $f3fa5acbda0f3e0e$export$fa4dae241333de34),
            (0, $f3fa5acbda0f3e0e$export$3de6d8bdd297654b)
        ].includes(// @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
        action.payload.source);
        const isQueueFiltering = action.payload.source === (0, $f3fa5acbda0f3e0e$export$be4c1ea173a5271a);
        const isPageLoad = action.payload.source === (0, $f3fa5acbda0f3e0e$export$f162a928a40c7ab8);
        const isInitialLoad = (0, $baH07.getIsInitialLoad)(state);
        const dispatchRestartPollActionWhenAppIdleInInitialLoad = ()=>{
            // only run this in initial load
            if (isPageLoad && action.payload.startIndex === 0 && !isUpdate && !isQueueFiltering && isInitialLoad) (0, $jbhXM.unstable_scheduleCallback)((0, $jbhXM.unstable_IdlePriority), ()=>{
                // @ts-expect-error - TS2345 - Argument of type 'RestartPollAction' is not assignable to parameter of type 'State'. Type 'RestartPollAction' is missing the following properties from type 'State': appProps, ui, persisted
                store.dispatch((0, $ir4eL.restartPollAction)(true));
            });
        };
        // @ts-expect-error - TS2345 - rgument of type 'UnsetIsInitialLoad' is not assignable to parameter of type 'State'. Type 'UnsetIsInitialLoad' is missing the following properties from type 'State': appProps, ui, persisted
        const dispatchUnsetIsInitialLoadAction = ()=>store.dispatch((0, $88qDC.unsetIsInitialLoad)());
        return (0, $eAb2j.default)(action.payload.startIndex, action.payload.endIndex, isUpdate, action.payload.source === (0, $f3fa5acbda0f3e0e$export$f162a928a40c7ab8), action.payload.bypassCache, state, action.payload.source === (0, $f3fa5acbda0f3e0e$export$be4c1ea173a5271a), dispatchUnsetIsInitialLoadAction, action.payload.source === (0, $f3fa5acbda0f3e0e$export$2003e3fdddd4c35b)).flatMap((result)=>{
            // dispatch only in initial load
            // running the blow will start the first poll as soon as TTAI finishes.
            if ((0, $7jTnu.fg)('issuelist_skip_fetch_cache_hit')) dispatchRestartPollActionWhenAppIdleInInitialLoad();
            if (isUpdate && result.totalCount - state.persisted.issues.totalCount > $db568342ad3f1a46$var$MAX_TOTAL_COUNT_DIFF && (0, $7jTnu.fg)('issue_list_total_counts_mismatch')) // we're temporarily logging mismatches between total count from /issuelist (JSIS) and /issuelist/updated (JVIS) to look for any bugs
            (0, $gYnSx.default)({
                meta: {
                    id: 'jsmIssueListTotalCountMismatch',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: new Error('total count big mismatch'),
                attributes: {
                    diff: result.totalCount - state.persisted.issues.totalCount
                },
                skipSentry: true
            });
            const actions = [
                (0, $ir4eL.restartPollAction)(),
                (0, $2MzoN.loadIssuesSuccessAction)(result, queueId, action.payload.startIndex, action.payload.source)
            ];
            const manualSort = $db568342ad3f1a46$var$getManualSortFromIssueListResult(result.columns, result.isUsingDefaultSorting);
            if (isInitialLoad && manualSort) // @ts-expect-error - TS2322
            actions.push((0, $iGYMr.sortOrderOnLoadAction)(manualSort.sortedBy, manualSort.sortOrder));
            return (0, $7kixv.Observable).of((0, $dFg4o.batchActions)(actions));
        })// @ts-expect-error - TS2345 - Argument of type '(error: ErrorResponse) => Observable<BatchAction> | Observable<RestartPollAction>' is not assignable to parameter of type '(err: any, caught: Observable<BatchAction>) => ObservableInput<BatchAction>'.
        .catch((error)=>{
            if (error.statusCode === 304) return (0, $7kixv.Observable).of((0, $ir4eL.restartPollAction)());
            if (// Bad query request
            error.statusCode === 400 && action.payload.source === (0, $f3fa5acbda0f3e0e$export$be4c1ea173a5271a)) {
                const isNewFilterQueryPendingAction = (0, $3MjJb.getIsNewFilterQueryPending)(state);
                return (0, $7kixv.Observable).of((0, $dFg4o.batchActions)([
                    (0, $ir4eL.restartPollAction)(),
                    (0, $cpZzK.filterBadQueryAction)(isNewFilterQueryPendingAction)
                ]));
            }
            sendErrorAnalytics(error);
            return (0, $7kixv.Observable).of((0, $dFg4o.batchActions)([
                (0, $ir4eL.restartPollAction)(),
                (0, $2MzoN.loadIssuesFailureAction)(action.payload.source, error.response, error.statusCode, (0, $1TuhT.getIssueCacheSize)(state) === 0, error.traceId)
            ]));
        });
    });

});
parcelRegister("5IGQp", function(module, exports) {

$parcel$export(module.exports, "withConcurrencyLimiting", () => $e9bc625eb5ed0c5d$export$1c063aa9514214db);

var $7kixv = parcelRequire("7kixv");
parcelRequire("1AyD5");
parcelRequire("lniJr");
parcelRequire("c1D7V");
parcelRequire("7La6O");
parcelRequire("llumX");
parcelRequire("6cJUr");
parcelRequire("d2zWP");

var $eSnSE = parcelRequire("eSnSE");

var $6rT6R = parcelRequire("6rT6R");

var $3XBTw = parcelRequire("3XBTw");
const $e9bc625eb5ed0c5d$var$LOCATION = 'servicedesk.common.epic-util.concurrency-limiter';
const $e9bc625eb5ed0c5d$var$EMPTY_SENTINEL = 'EMPTY_SENTINEL';
const $e9bc625eb5ed0c5d$var$defaultOperator = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, // eslint-disable-next-line @typescript-eslint/no-explicit-any
inner)=>source.switchMap(inner);
const $e9bc625eb5ed0c5d$export$1c063aa9514214db = (source, availableTokenCount, inner, operator = $e9bc625eb5ed0c5d$var$defaultOperator, leaseTime)=>{
    if (availableTokenCount < 1) throw new Error(`${$e9bc625eb5ed0c5d$var$LOCATION}: availableTokenCount must be at least 1`);
    const { injectableSource$: injectableSource$, inject: inject } = (0, $3XBTw.createInjectableSource)(source);
    const stateContainer = new (0, $6rT6R.default)(availableTokenCount, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    inject, leaseTime);
    const withToken = (v)=>stateContainer.withToken.call(stateContainer, v);
    return operator(injectableSource$.mergeMap(withToken), ({ returnToken: returnToken, value: value })=>inner(value) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        .defaultIfEmpty($e9bc625eb5ed0c5d$var$EMPTY_SENTINEL).do(returnToken, returnToken, returnToken).catch((err)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData($e9bc625eb5ed0c5d$var$LOCATION, err);
            return (0, $7kixv.Observable).empty();
        }).do((v)=>{
            if (v === $e9bc625eb5ed0c5d$var$EMPTY_SENTINEL) (0, $eSnSE.default).safeWarnWithoutCustomerData($e9bc625eb5ed0c5d$var$LOCATION, 'Empty observable detected. Do not use the concurrency-limiter with empty observables.');
        }).filter((v)=>v !== $e9bc625eb5ed0c5d$var$EMPTY_SENTINEL));
};

});
parcelRegister("lniJr", function(module, exports) {
"use strict";

var $7kixv = parcelRequire("7kixv");

var $bYsRX = parcelRequire("bYsRX");
$7kixv.Observable.prototype.defaultIfEmpty = $bYsRX.defaultIfEmpty;

});
parcelRegister("bYsRX", function(module, exports) {

$parcel$export(module.exports, "defaultIfEmpty", () => $8b7bb128e6d4cf0e$export$e4ca6d7b7a6dcf9b, (v) => $8b7bb128e6d4cf0e$export$e4ca6d7b7a6dcf9b = v);
var $8b7bb128e6d4cf0e$export$e4ca6d7b7a6dcf9b;
"use strict";

var $fg7jT = parcelRequire("fg7jT");
/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $8b7bb128e6d4cf0e$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return $fg7jT.defaultIfEmpty(defaultValue)(this);
}
$8b7bb128e6d4cf0e$export$e4ca6d7b7a6dcf9b = $8b7bb128e6d4cf0e$var$defaultIfEmpty;

});


parcelRegister("6rT6R", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2dbba9f4294f489$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("1AyD5");
parcelRequire("d2zWP");

var $bx11l = parcelRequire("bx11l");

var $7kixv = parcelRequire("7kixv");

var $dEEJO = parcelRequire("dEEJO");
const $f2dbba9f4294f489$var$DEFAULT_LEASE_TIME = 10000;
class $f2dbba9f4294f489$export$2e2bcd8739ae039 {
    constructor(availableTokenCount, injectCallback, leaseTime = $f2dbba9f4294f489$var$DEFAULT_LEASE_TIME){
        this.bufferedValue = null;
        this.onReturnToken = ()=>{
            if (this.bufferedValue) {
                const value = this.bufferedValue;
                this.bufferedValue = null;
                this.injectCallback(value);
            }
        };
        this.tokenDispenser = (0, $dEEJO.default)(availableTokenCount);
        this.injectCallback = injectCallback;
        this.leaseTime = leaseTime;
        this.availableTokenCount = availableTokenCount;
    }
    areAllTokensTaken() {
        return this.tokenDispenser.getAvailableTokenCount() === 0;
    }
    withToken(value) {
        if (this.areAllTokensTaken()) {
            this.bufferedValue = value;
            return (0, $7kixv.Observable).empty();
        }
        return this.tokenDispenser.takeToken().switchMap((token)=>{
            const returnToken = (0, (/*@__PURE__*/$parcel$interopDefault($bx11l)))(()=>{
                token.returnToken();
                this.onReturnToken();
            });
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const leaseTimeoutId = window.setTimeout(returnToken, this.leaseTime);
            return (0, $7kixv.Observable).of({
                returnToken: ()=>{
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.clearTimeout(leaseTimeoutId);
                    returnToken();
                },
                value: value
            });
        });
    }
}

});
parcelRegister("dEEJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $596f2cff6a47dba8$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("ggmnc");
parcelRequire("9BkTq");
parcelRequire("6cJUr");

var $bx11l = parcelRequire("bx11l");

var $7kixv = parcelRequire("7kixv");
const $596f2cff6a47dba8$var$tokenDispenser = (initialTokens)=>{
    let availableTokens = initialTokens;
    const obs$ = (0, $7kixv.Observable).create((observer)=>{
        availableTokens -= 1;
        observer.next('TOKEN');
    });
    const returnToken = ()=>{
        availableTokens += 1;
    };
    return {
        takeToken: ()=>{
            if (availableTokens) return obs$.take(1).mergeMap(()=>(0, $7kixv.Observable).of({
                    returnToken: (0, (/*@__PURE__*/$parcel$interopDefault($bx11l)))(returnToken)
                }));
            return (0, $7kixv.Observable).empty();
        },
        getAvailableTokenCount: ()=>availableTokens
    };
};
var $596f2cff6a47dba8$export$2e2bcd8739ae039 = $596f2cff6a47dba8$var$tokenDispenser;

});


parcelRegister("3XBTw", function(module, exports) {

$parcel$export(module.exports, "createInjectableSource", () => $2fcc30da24d08c62$export$81fae18a40db9d6c);

var $12DRg = parcelRequire("12DRg");

var $7kixv = parcelRequire("7kixv");
parcelRequire("gLxvt");

var $6WhQS = parcelRequire("6WhQS");
parcelRequire("ddfJz");
parcelRequire("7La6O");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2fcc30da24d08c62$var$COMPLETE = 'servicedesk.common.epic-util.concurrency-limiter.COMPLETE_VALUE';
const $2fcc30da24d08c62$export$81fae18a40db9d6c = (source)=>{
    const buffer$ = new (0, $6WhQS.Subject)();
    const completeStream = ()=>{
        buffer$.next($2fcc30da24d08c62$var$COMPLETE);
    };
    return {
        // When the source completes, we must also complete the buffer.
        injectableSource$: (0, $7kixv.Observable).merge(source.do((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), completeStream, completeStream), buffer$.takeWhile((v)=>v !== $2fcc30da24d08c62$var$COMPLETE)),
        inject: (value)=>{
            buffer$.next(value);
        }
    };
};

});


parcelRegister("eAb2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bae95a63f063ead$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");

var $2QO3b = parcelRequire("2QO3b");

var $6uWhG = parcelRequire("6uWhG");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");

var $7WQX3 = parcelRequire("7WQX3");

var $2IsS5 = parcelRequire("2IsS5");

var $f5xwW = parcelRequire("f5xwW");

var $f20Bj = parcelRequire("f20Bj");
parcelRequire("baP6E");
parcelRequire("1AyD5");
parcelRequire("cBiei");
parcelRequire("9BkTq");
parcelRequire("gdMGY");
parcelRequire("c1D7V");
parcelRequire("8gLG0");
parcelRequire("1o2WJ");
parcelRequire("6cJUr");
parcelRequire("ku0B3");

var $7ydZd = parcelRequire("7ydZd");

var $dTFqC = parcelRequire("dTFqC");

var $cqBpI = parcelRequire("cqBpI");

var $3MjJb = parcelRequire("3MjJb");

var $lc49q = parcelRequire("lc49q");

var $4LfWe = parcelRequire("4LfWe");

var $baH07 = parcelRequire("baH07");

var $9kCRJ = parcelRequire("9kCRJ");

var $1EACp = parcelRequire("1EACp");

var $53tjX = parcelRequire("53tjX");

var $f6Yqd = parcelRequire("f6Yqd");

// Number of retries. Excludes the first call.
const $6bae95a63f063ead$var$NUMBER_OF_RETRIES = 2;
const $6bae95a63f063ead$var$ISSUES_FETCH_STARTED_MARK = 'jsd.performance.profile.queues.issues.fetch.from.server.started';
const $6bae95a63f063ead$var$ISSUES_FETCH_COMPLETED_MARK = 'jsd.performance.profile.queues.issues.fetch.from.server.completed';
const $6bae95a63f063ead$var$isRetryableStatusCode = (statusCode)=>statusCode === 429 || statusCode >= 500;
const $6bae95a63f063ead$var$MAX_RETRY_DELAY_MS = 15000;
const $6bae95a63f063ead$var$BASE_DELAY_MS = 5000;
/**
 * Exponential backoff with max delay and jitter
 * https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
 */ const $6bae95a63f063ead$var$maxExpBackoffWithJitter = (retries, baseDelay, maxDelay)=>{
    const exponential = Math.pow(2, retries) * baseDelay;
    const delay = Math.min(exponential, maxDelay);
    const jitter = Math.random();
    const delayWithJitter = Math.floor(jitter * delay);
    return delayWithJitter;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6bae95a63f063ead$export$2e2bcd8739ae039 = (startIndex, endIndex, isUpdate, isSourceFromPage, bypassCache, state, isQueueFiltering = false, unsetIsInitialLoad, isSourceFromSort)=>{
    const queueId = (0, $lc49q.getQueueId)(state);
    const columnIds = (0, $lc49q.getColumnIds)(state);
    const columns = (0, $lc49q.getColumns)(state);
    const jql = (0, $lc49q.getJql)(state);
    const columnTypesAsJson = (0, $7WQX3.getFieldTypesEligibleForJsonData)();
    const issuesPerPage = endIndex - startIndex + 1;
    const projectKey = (0, $f20Bj.getProjectKey)(state);
    const sortedBy = (0, $4LfWe.getSortedByColumn)(state);
    const isAscendingOrder = (0, $4LfWe.getIsAscendingOrder)(state);
    const sortOrder = (0, $4LfWe.getSortOrder)(state);
    const category = (0, $lc49q.getCategory)(state);
    const filterQuery = (0, $3MjJb.getCurrentFilterQuery)(state);
    const isFilterRequested = filterQuery !== null;
    let retries = 0;
    const storeAndTransform = (result, source)=>{
        if (startIndex === 0 && !isFilterRequested) {
            const createAnalyticsEvent = (0, $cqBpI.getCreateAnalyticsEvent)(state);
            (0, $1EACp.storeIssuesInLocalStorage)(result, jql, queueId, sortedBy, sortOrder, isUpdate, createAnalyticsEvent);
        }
        return (0, $53tjX.default)(result, source, isFilterRequested, isFilterRequested);
    };
    const fireQueueFilteringAnalytics = (result)=>{
        if (!(0, $7jTnu.fg)('corcap-2944-add-jqlbuilder-to-jsm-queues')) {
            const createAnalyticsEvent = (0, $cqBpI.getCreateAnalyticsEvent)(state);
            if (createAnalyticsEvent) {
                // extract the query text from the filter query
                const queryText = filterQuery?.match(/"([^"]*)\*"/);
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering searched', {
                    filteredQueueLength: result.issues.length,
                    filterLength: queryText ? queryText[1].length : 0
                });
            }
        }
    };
    const fireIssueListRetryAnalyticsSuccess = (numberOfRetries)=>{
        const createAnalyticsEvent = (0, $cqBpI.getCreateAnalyticsEvent)(state);
        if (createAnalyticsEvent) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jsmIssueList retrySucceeded', {
            numberOfRetries: numberOfRetries
        });
    };
    const fireIssueListRetryAnalyticsFailed = (statusCode)=>{
        const createAnalyticsEvent = (0, $cqBpI.getCreateAnalyticsEvent)(state);
        if (createAnalyticsEvent) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jsmIssueList retryFailed', {
            statusCode: statusCode
        });
    };
    // analytic event to help study issuelist ssr
    const fireInitialLoadSsrAnalyticEvent = (0, $f6Yqd.fireInitialLoadSsrAnalyticEventWithState)(state);
    const resetSorting = isSourceFromSort && sortedBy === undefined;
    const requestData = {
        projectKey: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string' for projectKey.
        projectKey,
        jql: jql,
        columnNames: columnIds,
        columnTypesAsJson: columnTypesAsJson,
        startIndex: startIndex,
        issuesPerPage: issuesPerPage,
        orderBy: sortedBy,
        isAscendingOrder: isAscendingOrder,
        category: category,
        resetSorting: resetSorting,
        queueId: queueId,
        filterClause: filterQuery,
        searchMode: (0, $9kCRJ.getSearchMode)(state)
    };
    const getIssuesFromLocalStorage = ()=>bypassCache || startIndex !== 0 || filterQuery !== null ? (0, $7kixv.Observable).empty() : (0, $1EACp.getIssuesInLocalStorage)(queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder, isSourceFromSort);
    const ssrIssuesData = (0, $baH07.getSsrIssueList)(state);
    const ssrIssuesDataError = (0, $baH07.getSsrIssuesError)(state);
    const fetchRequestHandler = (isInitialLoad)=>{
        (0, $6uWhG.setMark)($6bae95a63f063ead$var$ISSUES_FETCH_STARTED_MARK);
        const fetchStartTime = performance.now();
        return (0, $7ydZd.default)(requestData).flatMap((result)=>{
            (0, $2QO3b.addSpanToAll)('fetch', 'rest/servicedesk/1/servicedesk/projectKey/issuelist', [
                {
                    name: 'network'
                }
            ], fetchStartTime, performance.now());
            if (isInitialLoad) fireInitialLoadSsrAnalyticEvent((0, $33311bff5c7e8608$export$57138ddc6df757ce));
            (0, $6uWhG.setMark)($6bae95a63f063ead$var$ISSUES_FETCH_COMPLETED_MARK);
            (0, $f6Yqd.sendIssuelistStalenessAnalytics)(result, false);
            if (isQueueFiltering) fireQueueFilteringAnalytics(result);
            if (retries > 0) fireIssueListRetryAnalyticsSuccess(retries);
            return (0, $7kixv.Observable).of(storeAndTransform(result, (0, $2IsS5.REST_SOURCE)));
        }).retryWhen((errors)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            errors.mergeMap((error)=>{
                retries += 1;
                if (!$6bae95a63f063ead$var$isRetryableStatusCode(error?.statusCode) || retries > $6bae95a63f063ead$var$NUMBER_OF_RETRIES) {
                    fireIssueListRetryAnalyticsFailed(error.statusCode);
                    return (0, $7kixv.Observable).throw(error);
                }
                return (0, $7kixv.Observable).of(error.statusCode).delay($6bae95a63f063ead$var$maxExpBackoffWithJitter(retries, $6bae95a63f063ead$var$BASE_DELAY_MS, $6bae95a63f063ead$var$MAX_RETRY_DELAY_MS));
            }));
    };
    const getIssuesFromPrefetcher = (prefetchedIssuePromise, isInitialLoad)=>(0, $7kixv.Observable).fromPromise(prefetchedIssuePromise).map((response)=>{
            (0, $6uWhG.setMark)('jsd.performance.profile.queues.prefetch.resolved');
            (0, $f5xwW.unsetPrefetchedIssuePromise)(queueId);
            return storeAndTransform(response.data, (0, $2IsS5.PREFETCHER_SOURCE));
        }).catch(()=>fetchRequestHandler(isInitialLoad));
    if (isUpdate) return (0, $dTFqC.default)({
        ...requestData,
        issueHash: (0, $9kCRJ.getIssueHash)(state)
    }).flatMap((result)=>{
        (0, $f6Yqd.sendIssuelistStalenessAnalytics)(result, true);
        if (isQueueFiltering) fireQueueFilteringAnalytics(result);
        return (0, $7kixv.Observable).of(storeAndTransform(result, (0, $2IsS5.REST_SOURCE)));
    });
    const prefetchedIssuePromise = (0, $f5xwW.getPrefetchedIssuePromise)(queueId);
    const isInitialLoad = (0, $7jTnu.fg)('issuelist_skip_fetch_cache_hit') ? startIndex === 0 && isSourceFromPage && !isFilterRequested && !isUpdate && !!(0, $baH07.getIsInitialLoad)(state) : false;
    if (isInitialLoad) {
        // initial load total traffic
        fireInitialLoadSsrAnalyticEvent((0, $33311bff5c7e8608$export$c1927396d6c152eb));
        unsetIsInitialLoad();
        if ((0, $7jTnu.fg)('ssr_view_queues_issuelist')) {
            if (ssrIssuesData && !ssrIssuesDataError) {
                // initial load SSR hit traffic
                fireInitialLoadSsrAnalyticEvent((0, $33311bff5c7e8608$export$5b6950a89e720fb7));
                const loadedIssueListData = storeAndTransform(ssrIssuesData, (0, $2IsS5.SSR_SOURCE));
                return (0, $7kixv.Observable).of(loadedIssueListData);
            }
            // initial load SSR error out traffic
            if (ssrIssuesDataError && !(0, $7jTnu.fg)('flash_ssr_issuelist_error_analytic_fix')) {
                if (ssrIssuesDataError.name === 'TimeoutError') fireInitialLoadSsrAnalyticEvent((0, $33311bff5c7e8608$export$7f8de25485f27a39));
                fireInitialLoadSsrAnalyticEvent((0, $33311bff5c7e8608$export$932d8e2bf11ecc3d));
            }
            if (ssrIssuesDataError && (0, $7jTnu.fg)('flash_ssr_issuelist_error_analytic_fix')) {
                if (ssrIssuesDataError.name === 'TimeoutError') fireInitialLoadSsrAnalyticEvent((0, $33311bff5c7e8608$export$7f8de25485f27a39));
                else fireInitialLoadSsrAnalyticEvent((0, $33311bff5c7e8608$export$932d8e2bf11ecc3d));
            }
        }
        const localStorageData = (0, $1EACp.maybeIssuesInLocalStorage)(queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder);
        if (localStorageData.isSome()) {
            // initial load cache hit traffic
            fireInitialLoadSsrAnalyticEvent((0, $33311bff5c7e8608$export$431f43d5c108aa95));
            return localStorageData.cata((0, $7kixv.Observable).empty, (0, $7kixv.Observable).of);
        }
    }
    const issueListObservable = prefetchedIssuePromise.isSome() && !filterQuery ? prefetchedIssuePromise// @ts-expect-error - TS7006 - Parameter 'promise' implicitly has an 'any' type.
    .map((promise)=>getIssuesFromPrefetcher(promise, isInitialLoad)).orSome((0, $7kixv.Observable).empty()) : fetchRequestHandler(isInitialLoad);
    // The concat operator is best used when you need to combine multiple observables,
    // but you want their emissions to be in a specific order, one after the other.
    return (0, $7kixv.Observable).concat(getIssuesFromLocalStorage(), issueListObservable);
};

});
parcelRegister("7WQX3", function(module, exports) {

$parcel$export(module.exports, "getFieldTypesEligibleForJsonData", () => $ccfec82717554fef$export$e2bd4328395b4df7);
$parcel$export(module.exports, "getFieldTypesEligibleForJsonDataAsSet", () => $ccfec82717554fef$export$740140e54d80c734);
$parcel$export(module.exports, "getFieldTypesToOverrideHtmlDataForAsSetOld", () => $ccfec82717554fef$export$e049f31fff152375);
$parcel$export(module.exports, "getFieldTypesToOverrideHtmlDataForAsSet", () => $ccfec82717554fef$export$dacb9fc482fbe93);

var $4c94y = parcelRequire("4c94y");

var $9pL9Y = parcelRequire("9pL9Y");

var $LFmXM = parcelRequire("LFmXM");

var $bi9FK = parcelRequire("bi9FK");

var $7jTnu = parcelRequire("7jTnu");
const $ccfec82717554fef$var$getFieldTypesFromFeatureFlagMap = (featureFlagMap)=>(0, (/*@__PURE__*/$parcel$interopDefault($4c94y)))((0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(featureFlagMap, (isAlwaysJsonOrFFKey)=>{
        if (typeof isAlwaysJsonOrFFKey === 'boolean') return isAlwaysJsonOrFFKey;
        // eslint-disable-next-line jira/ff/static-feature-flags
        return (0, $bi9FK.ff)(isAlwaysJsonOrFFKey) || (0, $7jTnu.fg)(isAlwaysJsonOrFFKey);
    }));
const $ccfec82717554fef$export$c394db035bb5cf7d = {
    assignee: true,
    'com.atlassian.servicedesk:sd-sla-field': true,
    status: true,
    issuetype: true,
    reporter: true,
    priority: 'jsm_queues_ssr_transform_status_category_priority',
    summary: true,
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype': true,
    labels: true,
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': true,
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': true,
    'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype': 'jsm_unscreenable_field_phase_2_fg',
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker': true,
    'com.atlassian.servicedesk:sd-request-participants': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion': true,
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker': true,
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement': true,
    'com.atlassian.servicedesk.sentiment:sd-sentiment': true,
    'com.atlassian.servicedesk.customer-context:sd-csm-organization': 'jcs_master_flag'
};
const $ccfec82717554fef$export$e2bd4328395b4df7 = (0, $LFmXM.default)(()=>$ccfec82717554fef$var$getFieldTypesFromFeatureFlagMap($ccfec82717554fef$export$c394db035bb5cf7d));
const $ccfec82717554fef$export$740140e54d80c734 = (0, $LFmXM.default)(()=>new Set($ccfec82717554fef$export$e2bd4328395b4df7()));
// @ts-expect-error(PARTIAL_RECORD) TS2740 | TS2740 - Type '{ issuekey: true; }' is missing the following properties from type 'FeatureFlagMap': summary, status, reporter, date, and 13 more. | Type '{ issuekey: true; }' is missing the following properties from type 'FeatureFlagMap': summary, date, labels, assignee, and 13 more.
const $ccfec82717554fef$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS_OLD = {
    issuekey: true,
    priority: true
};
// @ts-expect-error(PARTIAL_RECORD) TS2740 | TS2740 - Type '{ issuekey: true; }' is missing the following properties from type 'FeatureFlagMap': summary, status, reporter, date, and 13 more. | Type '{ issuekey: true; }' is missing the following properties from type 'FeatureFlagMap': summary, date, labels, assignee, and 13 more.
const $ccfec82717554fef$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS = {
    issuekey: true,
    statusCategory: true
};
const $ccfec82717554fef$export$f418ebfb147e8448 = (0, $LFmXM.default)(()=>$ccfec82717554fef$var$getFieldTypesFromFeatureFlagMap($ccfec82717554fef$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS_OLD));
const $ccfec82717554fef$export$e049f31fff152375 = (0, $LFmXM.default)(()=>new Set($ccfec82717554fef$export$f418ebfb147e8448()));
const $ccfec82717554fef$export$8e81e0bb2e4fc09e = (0, $LFmXM.default)(()=>$ccfec82717554fef$var$getFieldTypesFromFeatureFlagMap($ccfec82717554fef$var$FIELD_TYPES_TO_OVERRIDE_HTML_DATA_FOR_FF_KEYS));
const $ccfec82717554fef$export$dacb9fc482fbe93 = (0, $LFmXM.default)(()=>new Set($ccfec82717554fef$export$8e81e0bb2e4fc09e()));

});

parcelRegister("f5xwW", function(module, exports) {

$parcel$export(module.exports, "transformColumns", () => $805adebf8d953a5d$export$6e8deebce7129a99);
$parcel$export(module.exports, "transformColumnsByRemoveSortOrder", () => $805adebf8d953a5d$export$c2dd410aebdef477);
$parcel$export(module.exports, "removeSortingFromColumns", () => $805adebf8d953a5d$export$b4148c35c271b9a9);
$parcel$export(module.exports, "transformIssues", () => $805adebf8d953a5d$export$a26a6de2e9ae64a0);
$parcel$export(module.exports, "getPrefetchedIssuePromise", () => $805adebf8d953a5d$export$13bba225866f1e46);
$parcel$export(module.exports, "unsetPrefetchedIssuePromise", () => $805adebf8d953a5d$export$56d44580e340f1f4);
$parcel$export(module.exports, "default", () => $805adebf8d953a5d$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("6cJUr");

var $9g7yh = parcelRequire("9g7yh");

var $ljsRg = parcelRequire("ljsRg");

var $7kixv = parcelRequire("7kixv");

var $2IsS5 = parcelRequire("2IsS5");
const $805adebf8d953a5d$export$6e8deebce7129a99 = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.columnHeaderText,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $805adebf8d953a5d$export$c2dd410aebdef477 = (responseColumns)=>responseColumns.map((responseColumn)=>({
            id: responseColumn.fieldId,
            title: responseColumn.columnHeaderText,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        }));
const $805adebf8d953a5d$export$b4148c35c271b9a9 = (columns)=>columns.map((column)=>({
            id: column.id,
            title: column.title,
            fieldType: column.fieldType,
            sortable: column.sortable
        }));
const $805adebf8d953a5d$var$mapFieldsByColumnId = (fields)=>// @ts-expect-error - TS2322 - Type 'Dictionary<number | ResponseField | { (callbackfn: (previousValue: ResponseField, currentValue: ResponseField, currentIndex: number, array: ResponseField[]) => ResponseField): ResponseField; (callbackfn: (previousValue: ResponseField, currentValue: ResponseField, currentIndex: number, array: ResponseField[]) => Resp...' is not assignable to type 'FieldsById'. | TS2339 - Property 'fieldId' does not exist on type 'ResponseField'. | TS2339 - Property 'fieldCssClass' does not exist on type 'ResponseField'.
    (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(fields, (field)=>field.fieldId || field.fieldCssClass);
const $805adebf8d953a5d$export$a26a6de2e9ae64a0 = (issues)=>issues.map((issue)=>({
            id: issue.id,
            key: issue.key,
            fields: $805adebf8d953a5d$var$mapFieldsByColumnId(issue.fields),
            position: issue.position
        }));
const $805adebf8d953a5d$export$13bba225866f1e46 = (queueId)=>(0, $ljsRg.Maybe).fromNull(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES[`queueIssues_${(0, $2IsS5.fromQueueId)(queueId)}`]);
const $805adebf8d953a5d$export$56d44580e340f1f4 = (queueId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JSD_QUEUES_PRELOAD_PROMISES) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES[`queueIssues_${(0, $2IsS5.fromQueueId)(queueId)}`] = undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$805adebf8d953a5d$export$2e2bcd8739ae039 = (rest, transformFunc)=>rest.mergeMap((payload)=>(0, $7kixv.Observable).of(transformFunc(payload)));

});
parcelRegister("ljsRg", function(module, exports) {
//     Monet.js 0.8.10
//     (c) 2012-2016 Chris Myers
//     Monet.js may be freely distributed under the MIT license.
//     For all details and documentation:
//     https://cwmyers.github.com/monet.js
(function(root, factory) {
    module.exports = factory(root);
})(module.exports, function(root) {
    "use strict";
    var curry = function(fn, args) {
        return function() {
            var args1 = args.append(List.fromArray(Array.prototype.slice.call(arguments)));
            return args1.size() >= fn.length ? fn.apply(this, args1.toArray().slice(0, args1.size())) : curry(fn, args1);
        };
    };
    var isFunction = function(f) {
        return !!(f && f.constructor && f.call && f.apply);
    };
    var idFunction = function(value) {
        return value;
    };
    var trueFunction = function() {
        return true;
    };
    var falseFunction = function() {
        return false;
    };
    var Monet = root.Monet = {};
    var swap = Monet.swap = function(f) {
        return function(a, b) {
            return f(b, a);
        };
    };
    var map = function(fn) {
        return this.bind(this.of.compose(fn));
    };
    var apply2 = Monet.apply2 = function(a1, a2, f) {
        return a2.ap(a1.map(f.curry()));
    };
    Monet.curry = function(fn) {
        return curry(fn, Nil);
    };
    Function.prototype.curry = function() {
        return curry(this, Nil);
    };
    // List monad
    var list;
    var List = list = root.List = function(head, tail) {
        return new List.fn.init(head, tail);
    };
    var listMap = function(fn, l) {
        return listMapC(fn, l).run();
    };
    var listMapC = function(fn, l) {
        return l.isNil ? Return(l) : Suspend(function() {
            return listMapC(fn, l.tail());
        }).map(cons.curry()(fn(l.head())));
    };
    var listEach = function(effectFn, l) {
        if (!l.isNil) {
            effectFn(l.head());
            listEach(effectFn, l.tail());
        }
    };
    var foldLeft = function(fn, acc, l) {
        function fL(acc, l) {
            return l.isNil ? Return(acc) : Suspend(function() {
                return fL(fn(acc, l.head()), l.tail());
            });
        }
        return fL(acc, l).run();
    };
    var foldRight = function(fn, l, acc) {
        function fR(l, acc) {
            return l.isNil ? Return(acc) : Suspend(function() {
                return fR(l.tail(), acc);
            }).map(function(acc1) {
                return fn(l.head(), acc1);
            });
        }
        return fR(l, acc).run();
    };
    var append = function(list1, list2) {
        function append1(list1, list2) {
            return list1.isNil ? Return(list2) : Suspend(function() {
                return append1(list1.tail(), list2).map(function(list) {
                    return list.cons(list1.head());
                });
            });
        }
        return append1(list1, list2).run();
    };
    var sequence = function(list, type) {
        return list.foldRight(type.of(Nil))(type.map2(cons));
    };
    var sequenceValidation = function(list) {
        return list.foldLeft(Success(Nil))(function(acc, a) {
            return acc.ap(a.map(function(v) {
                return function(t) {
                    return cons(v, t);
                };
            }));
        }).map(listReverse);
    };
    var listReverse = function(list) {
        return list.foldLeft(Nil)(swap(cons));
    };
    var listFilter = function(list, fn) {
        return list.foldRight(Nil)(function(a, acc) {
            return fn(a) ? cons(a, acc) : acc;
        });
    };
    var listAp = function(list1, list2) {
        return list1.bind(function(x) {
            return list2.map(function(f) {
                return f(x);
            });
        });
    };
    var cons = function(head, tail) {
        return tail.cons(head);
    };
    List.fn = List.prototype = {
        init: function(head, tail) {
            if (head == null) {
                this.isNil = true;
                this.size_ = 0;
            } else {
                this.isNil = false;
                this.head_ = head;
                this.tail_ = tail == null ? Nil : tail;
                this.size_ = tail == null ? 0 : tail.size() + 1;
            }
        },
        of: function(value) {
            return new List(value);
        },
        size: function() {
            return this.size_;
        },
        cons: function(head) {
            return List(head, this);
        },
        snoc: function(element) {
            return this.concat(List(element));
        },
        map: function(fn) {
            return listMap(fn, this);
        },
        toArray: function() {
            return foldLeft(function(acc, e) {
                acc.push(e);
                return acc;
            }, [], this);
        },
        foldLeft: function(initialValue) {
            var self = this;
            return function(fn) {
                return foldLeft(fn, initialValue, self);
            };
        },
        foldRight: function(initialValue) {
            var self = this;
            return function(fn) {
                return foldRight(fn, self, initialValue);
            };
        },
        append: function(list2) {
            return append(this, list2);
        },
        filter: function(fn) {
            return listFilter(this, fn);
        },
        flatten: function() {
            return foldRight(append, this, Nil);
        },
        flattenMaybe: function() {
            return this.flatMap(Maybe.toList);
        },
        reverse: function() {
            return listReverse(this);
        },
        bind: function(fn) {
            return this.map(fn).flatten();
        },
        each: function(effectFn) {
            listEach(effectFn, this);
        },
        // transforms a list of Maybes to a Maybe list
        sequenceMaybe: function() {
            return sequence(this, Maybe);
        },
        sequenceValidation: function() {
            return sequenceValidation(this);
        },
        sequenceEither: function() {
            return sequence(this, Either);
        },
        sequenceIO: function() {
            return sequence(this, IO);
        },
        sequenceReader: function() {
            return sequence(this, Reader);
        },
        sequence: function(monadType) {
            return sequence(this, monadType);
        },
        head: function() {
            return this.head_;
        },
        headMaybe: function() {
            return this.isNil ? None() : Some(this.head_);
        },
        tail: function() {
            return this.isNil ? Nil : this.tail_;
        },
        tails: function() {
            return this.isNil ? List(Nil, Nil) : this.tail().tails().cons(this);
        },
        ap: function(list) {
            return listAp(this, list);
        },
        isNEL: falseFunction
    };
    List.fn.init.prototype = List.fn;
    var Nil = root.Nil = new List.fn.init();
    // Aliases
    List.prototype.empty = function() {
        return Nil;
    };
    List.fromArray = function(array) {
        var l = Nil;
        for(var i = array.length; i--; i)l = l.cons(array[i]);
        return l;
    };
    List.of = function(a) {
        return new List(a, Nil);
    };
    /*
     * Non-Empty List monad
     * This is also a comonad because there exists the implementation of extract(copure), which is just head
     * and cobind and cojoin.
     *
     */ var NonEmptyList;
    var NEL = root.NEL = NonEmptyList = root.NonEmptyList = function(head, tail) {
        if (head == null) throw "Cannot create an empty Non-Empty List.";
        return new NEL.fn.init(head, tail);
    };
    NEL.of = function(a) {
        return NEL(a, Nil);
    };
    NEL.fn = NEL.prototype = {
        init: function(head, tail) {
            if (head == null) {
                this.isNil = true;
                this.size_ = 0;
            } else {
                this.isNil = false;
                this.head_ = head;
                this.tail_ = tail == null ? Nil : tail;
                this.size_ = this.tail_.size() + 1;
            }
        },
        map: function(fn) {
            return NEL(fn(this.head_), listMap(fn, this.tail_));
        },
        bind: function(fn) {
            var p = fn(this.head_);
            if (!p.isNEL()) throw "function must return a NonEmptyList.";
            var list = this.tail().foldLeft(Nil.snoc(p.head()).append(p.tail()))(function(acc, e) {
                var list2 = fn(e).toList();
                return acc.snoc(list2.head()).append(list2.tail());
            });
            return new NEL(list.head(), list.tail());
        },
        head: function() {
            return this.head_;
        },
        tail: function() {
            return this.tail_;
        },
        //NEL[A] -> NEL[NEL[A]]
        tails: function() {
            var listsOfNels = this.toList().tails().map(NEL.fromList).flattenMaybe();
            return NEL(listsOfNels.head(), listsOfNels.tail());
        },
        toList: function() {
            return List(this.head_, this.tail_);
        },
        reverse: function() {
            if (this.tail().isNil) return this;
            else {
                var reversedTail = this.tail().reverse();
                return NEL(reversedTail.head(), reversedTail.tail().append(List(this.head())));
            }
        },
        foldLeft: function(initialValue) {
            return this.toList().foldLeft(initialValue);
        },
        foldRight: function(initialValue) {
            return this.toList().foldRight(initialValue);
        },
        reduceLeft: function(fn) {
            return this.tail().foldLeft(this.head())(fn);
        },
        filter: function(fn) {
            return listFilter(this.toList(), fn);
        },
        append: function(list2) {
            return NEL.fromList(this.toList().append(list2.toList())).some();
        },
        // NEL[A] -> (NEL[A] -> B) -> NEL[B]
        cobind: function(fn) {
            return this.cojoin().map(fn);
        },
        size: function() {
            return this.size_;
        },
        isNEL: trueFunction
    };
    NEL.fromList = function(list) {
        return list.isNil ? None() : Some(NEL(list.head(), list.tail()));
    };
    NEL.fn.init.prototype = NEL.fn;
    NEL.prototype.toArray = List.prototype.toArray;
    NEL.prototype.extract = NEL.prototype.copure = NEL.prototype.head;
    NEL.prototype.cojoin = NEL.prototype.tails;
    NEL.prototype.coflatMap = NEL.prototype.mapTails = NEL.prototype.cobind;
    NEL.prototype.ap = List.prototype.ap;
    /* Maybe Monad */ var Maybe = root.Maybe = {};
    Maybe.fromNull = function(val) {
        return val == null ? Maybe.None() : Maybe.Some(val);
    };
    Maybe.of = function(a) {
        return Some(a);
    };
    var Just;
    var Some = Just = Maybe.Just = Maybe.Some = root.Some = root.Just = function(val) {
        return new Maybe.fn.init(true, val);
    };
    var Nothing;
    var None = Nothing = Maybe.Nothing = Maybe.None = root.None = function() {
        return new Maybe.fn.init(false, null);
    };
    Maybe.toList = function(maybe) {
        return maybe.toList();
    };
    Maybe.fn = Maybe.prototype = {
        init: function(isValue, val) {
            this.isValue = isValue;
            if (val == null && isValue) throw "Illegal state exception";
            this.val = val;
        },
        isSome: function() {
            return this.isValue;
        },
        isNone: function() {
            return !this.isSome();
        },
        bind: function(bindFn) {
            return this.isValue ? bindFn(this.val) : this;
        },
        some: function() {
            if (this.isValue) return this.val;
            else throw "Illegal state exception";
        },
        orSome: function(otherValue) {
            return this.isValue ? this.val : otherValue;
        },
        orElse: function(maybe) {
            return this.isValue ? this : maybe;
        },
        ap: function(maybeWithFunction) {
            var value = this.val;
            return this.isValue ? maybeWithFunction.map(function(fn) {
                return fn(value);
            }) : this;
        },
        toList: function() {
            return this.map(List).orSome(Nil);
        },
        toEither: function(failVal) {
            return this.isSome() ? Right(this.val) : Left(failVal);
        },
        toValidation: function(failVal) {
            return this.isSome() ? Success(this.val) : Fail(failVal);
        },
        fold: function(defaultValue) {
            var self = this;
            return function(fn) {
                return self.isSome() ? fn(self.val) : defaultValue;
            };
        },
        cata: function(none, some) {
            return this.isSome() ? some(this.val) : none();
        },
        filter: function(fn) {
            var self = this;
            return self.flatMap(function(a) {
                return fn(a) ? self : None();
            });
        }
    };
    // aliases
    Maybe.prototype.orJust = Maybe.prototype.orSome;
    Maybe.prototype.just = Maybe.prototype.some;
    Maybe.prototype.isJust = Maybe.prototype.isSome;
    Maybe.prototype.isNothing = Maybe.prototype.isNone;
    Maybe.fn.init.prototype = Maybe.fn;
    var Validation = root.Validation = {};
    var Success = Validation.Success = Validation.success = root.Success = function(val) {
        return new Validation.fn.init(val, true);
    };
    var Fail = Validation.Fail = Validation.fail = root.Fail = function(error) {
        return new Validation.fn.init(error, false);
    };
    Validation.of = function(v) {
        return Success(v);
    };
    Validation.fn = Validation.prototype = {
        init: function(val, success) {
            this.val = val;
            this.isSuccessValue = success;
        },
        success: function() {
            if (this.isSuccess()) return this.val;
            else throw 'Illegal state. Cannot call success() on a Validation.fail';
        },
        isSuccess: function() {
            return this.isSuccessValue;
        },
        isFail: function() {
            return !this.isSuccessValue;
        },
        fail: function() {
            if (this.isSuccess()) throw 'Illegal state. Cannot call fail() on a Validation.success';
            else return this.val;
        },
        bind: function(fn) {
            return this.isSuccess() ? fn(this.val) : this;
        },
        ap: function(validationWithFn) {
            var value = this.val;
            return this.isSuccess() ? validationWithFn.map(function(fn) {
                return fn(value);
            }) : validationWithFn.isFail() ? Validation.Fail(Semigroup.append(value, validationWithFn.fail())) : this;
        },
        acc: function() {
            var x = function() {
                return x;
            };
            return this.isSuccessValue ? Validation.success(x) : this;
        },
        cata: function(fail, success) {
            return this.isSuccessValue ? success(this.val) : fail(this.val);
        },
        failMap: function(fn) {
            return this.isFail() ? Fail(fn(this.val)) : this;
        },
        bimap: function(fail, success) {
            return this.isSuccessValue ? this.map(success) : this.failMap(fail);
        },
        toMaybe: function() {
            return this.isSuccess() ? Some(this.val) : None();
        },
        toEither: function() {
            return (this.isSuccess() ? Right : Left)(this.val);
        }
    };
    Validation.fn.init.prototype = Validation.fn;
    var Semigroup = root.Semigroup = {};
    Semigroup.append = function(a, b) {
        if (a instanceof Array) return a.concat(b);
        if (typeof a === "string") return a + b;
        if (isFunction(a.concat)) return a.concat(b);
        throw "Couldn't find a semigroup appender in the environment, please specify your own append function";
    };
    var monadT, monadTransformer, MonadTransformer;
    var MonadT = monadT = monadTransformer = MonadTransformer = root.monadTransformer = root.MonadT = root.monadT = function(monad) {
        return new MonadT.fn.init(monad);
    };
    MonadT.of = function(m) {
        return MonadT(m);
    };
    MonadT.fn = MonadT.prototype = {
        init: function(monad) {
            this.monad = monad;
        },
        map: function(fn) {
            return monadT(this.monad.map(function(v) {
                return v.map(fn);
            }));
        },
        bind: function(fn) {
            return monadT(this.monad.map(function(v) {
                return v.flatMap(fn);
            }));
        },
        ap: function(monadWithFn) {
            return monadT(this.monad.flatMap(function(v) {
                return monadWithFn.perform().map(function(v2) {
                    return v.ap(v2);
                });
            }));
        },
        perform: function() {
            return this.monad;
        }
    };
    MonadT.fn.init.prototype = MonadT.fn;
    var io;
    var IO = io = root.IO = root.io = function(effectFn) {
        return new IO.fn.init(effectFn);
    };
    IO.of = function(a) {
        return IO(function() {
            return a;
        });
    };
    IO.fn = IO.prototype = {
        init: function(effectFn) {
            if (!isFunction(effectFn)) throw "IO requires a function";
            this.effectFn = effectFn;
        },
        map: function(fn) {
            var self = this;
            return IO(function() {
                return fn(self.effectFn());
            });
        },
        bind: function(fn) {
            var self = this;
            return IO(function() {
                return fn(self.effectFn()).run();
            });
        },
        ap: function(ioWithFn) {
            var self = this;
            return ioWithFn.map(function(fn) {
                return fn(self.effectFn());
            });
        },
        run: function() {
            return this.effectFn();
        }
    };
    IO.fn.init.prototype = IO.fn;
    IO.prototype.perform = IO.prototype.performUnsafeIO = IO.prototype.run;
    /* Either Monad */ var Either = root.Either = {};
    Either.of = function(a) {
        return Right(a);
    };
    var Right = Either.Right = root.Right = function(val) {
        return new Either.fn.init(val, true);
    };
    var Left = Either.Left = root.Left = function(val) {
        return new Either.fn.init(val, false);
    };
    Either.fn = Either.prototype = {
        init: function(val, isRightValue) {
            this.isRightValue = isRightValue;
            this.value = val;
        },
        bind: function(fn) {
            return this.isRightValue ? fn(this.value) : this;
        },
        ap: function(eitherWithFn) {
            var self = this;
            return this.isRightValue ? eitherWithFn.map(function(fn) {
                return fn(self.value);
            }) : this;
        },
        leftMap: function(fn) {
            return this.isLeft() ? Left(fn(this.value)) : this;
        },
        isRight: function() {
            return this.isRightValue;
        },
        isLeft: function() {
            return !this.isRight();
        },
        right: function() {
            if (this.isRightValue) return this.value;
            else throw "Illegal state. Cannot call right() on a Either.left";
        },
        left: function() {
            if (this.isRightValue) throw "Illegal state. Cannot call left() on a Either.right";
            else return this.value;
        },
        cata: function(leftFn, rightFn) {
            return this.isRightValue ? rightFn(this.value) : leftFn(this.value);
        },
        bimap: function(leftFn, rightFn) {
            return this.isRightValue ? this.map(rightFn) : this.leftMap(leftFn);
        },
        toMaybe: function() {
            return this.isRight() ? Some(this.value) : None();
        },
        toValidation: function() {
            return this.isRight() ? Success(this.value) : Fail(this.value);
        }
    };
    Either.fn.init.prototype = Either.fn;
    var reader;
    var Reader = reader = root.Reader = function(fn) {
        return new Reader.fn.init(fn);
    };
    Reader.of = function(x) {
        return Reader(function(_) {
            return x;
        });
    };
    Reader.ask = function() {
        return Reader(idFunction);
    };
    Reader.fn = Reader.prototype = {
        init: function(fn) {
            this.f = fn;
        },
        run: function(config) {
            return this.f(config);
        },
        bind: function(fn) {
            var self = this;
            return Reader(function(config) {
                return fn(self.run(config)).run(config);
            });
        },
        ap: function(readerWithFn) {
            var self = this;
            return readerWithFn.bind(function(fn) {
                return Reader(function(config) {
                    return fn(self.run(config));
                });
            });
        },
        map: function(fn) {
            var self = this;
            return Reader(function(config) {
                return fn(self.run(config));
            });
        },
        local: function(fn) {
            var self = this;
            return Reader(function(c) {
                return self.run(fn(c));
            });
        }
    };
    Reader.fn.init.prototype = Reader.fn;
    var Free = root.Free = {};
    var Suspend = Free.Suspend = root.Suspend = function(functor) {
        return new Free.fn.init(functor, true);
    };
    var Return = Free.Return = root.Return = function(val) {
        return new Free.fn.init(val, false);
    };
    Free.of = function(a) {
        return Return(a);
    };
    Free.liftF = function(functor) {
        return Suspend(functor.map(Return));
    };
    Free.fn = Free.prototype = {
        init: function(val, isSuspend) {
            this.isSuspend = isSuspend;
            if (isSuspend) this.functor = val;
            else this.val = val;
        },
        run: function() {
            return this.go(function(f) {
                return f();
            });
        },
        bind: function(fn) {
            return this.isSuspend ? Suspend(this.functor.map(function(free) {
                return free.bind(fn);
            })) : fn(this.val);
        },
        ap: function(ff) {
            return this.bind(function(x) {
                return ff.map(function(f) {
                    return f(x);
                });
            });
        },
        resume: function() {
            return this.isSuspend ? Left(this.functor) : Right(this.val);
        },
        go1: function(f) {
            function go2(t) {
                return t.resume().cata(function(functor) {
                    return go2(f(functor));
                }, idFunction);
            }
            return go2(this);
        },
        go: function(f) {
            var result = this.resume();
            while(result.isLeft()){
                var next = f(result.left());
                result = next.resume();
            }
            return result.right();
        }
    };
    Free.fn.init.prototype = Free.fn;
    var Identity = root.Identity = function(a) {
        return new Identity.fn.init(a);
    };
    Identity.of = function(a) {
        return new Identity(a);
    };
    Identity.fn = Identity.prototype = {
        init: function(val) {
            this.val = val;
        },
        bind: function(fn) {
            return fn(this.val);
        },
        get: function() {
            return this.val;
        }
    };
    Identity.fn.init.prototype = Identity.fn;
    Function.prototype.io = function() {
        return IO(this);
    };
    Function.prototype.io1 = function() {
        var f = this;
        return function(x) {
            return IO(function() {
                return f(x);
            });
        };
    };
    Function.prototype.reader = function() {
        var f = this;
        var wrapReader = function(fn, args) {
            return function() {
                var args1 = args.append(List.fromArray(Array.prototype.slice.call(arguments)));
                var self = this;
                return args1.size() + 1 == fn.length ? Reader(function(c) {
                    return fn.apply(self, args1.append(List(c)).toArray());
                }) : wrapReader(fn, args1);
            };
        };
        return wrapReader(f, Nil);
    };
    Function.prototype.compose = Function.prototype.o = function(g) {
        var f = this;
        return function(x) {
            return f(g(x));
        };
    };
    Function.prototype.andThen = Function.prototype.map = function(g) {
        var f = this;
        return function(x) {
            return g(f(x));
        };
    };
    function addAliases(type) {
        type.prototype.flatMap = type.prototype.chain = type.prototype.bind;
        type.pure = type.unit = type.of;
        type.prototype.of = type.of;
        if (type.prototype.append != null) type.prototype.concat = type.prototype.append;
        type.prototype.point = type.prototype.pure = type.prototype.unit = type.prototype.of;
    }
    // Wire up aliases
    function addMonadOps(type) {
        type.prototype.join = function() {
            return this.flatMap(idFunction);
        };
        type.map2 = function(fn) {
            return function(ma, mb) {
                return ma.flatMap(function(a) {
                    return mb.map(function(b) {
                        return fn(a, b);
                    });
                });
            };
        };
    }
    function addFunctorOps(type) {
        if (type.prototype.map == null) type.prototype.map = function(fn) {
            return map.call(this, fn);
        };
    }
    function addApplicativeOps(type) {
        type.prototype.takeLeft = function(m) {
            return apply2(this, m, function(a, b) {
                return a;
            });
        };
        type.prototype.takeRight = function(m) {
            return apply2(this, m, function(a, b) {
                return b;
            });
        };
    }
    function decorate(type) {
        addAliases(type);
        addMonadOps(type);
        addFunctorOps(type);
        addApplicativeOps(type);
    }
    decorate(MonadT);
    decorate(Either);
    decorate(Maybe);
    decorate(IO);
    decorate(NEL);
    decorate(List);
    decorate(Validation);
    decorate(Reader);
    decorate(Free);
    decorate(Identity);
    return root;
});

});


parcelRegister("f20Bj", function(module, exports) {

$parcel$export(module.exports, "getCloudId", () => $d2768f00a34ae0d4$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getFabricPfDirUrl", () => $d2768f00a34ae0d4$export$505ebc60b5fc3b2e);
$parcel$export(module.exports, "getAtlassianAccountId", () => $d2768f00a34ae0d4$export$f5baf4f0aaa47428);
$parcel$export(module.exports, "getProjectKey", () => $d2768f00a34ae0d4$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectName", () => $d2768f00a34ae0d4$export$2cd058184eb75757);
$parcel$export(module.exports, "getLocale", () => $d2768f00a34ae0d4$export$180605366c04f0cd);
$parcel$export(module.exports, "getIsAdmin", () => $d2768f00a34ae0d4$export$7d046765d192af80);
$parcel$export(module.exports, "getProjectId", () => $d2768f00a34ae0d4$export$89040d072f281f85);
$parcel$export(module.exports, "getAppPropsForIssueTable", () => $d2768f00a34ae0d4$export$78632e066216024);

var $ahm5r = parcelRequire("ahm5r");

var $ljej9 = parcelRequire("ljej9");
const $d2768f00a34ae0d4$export$876089ea65adc54 = (state)=>state.appProps;
const $d2768f00a34ae0d4$export$fdd2c0ba94025c3c = (state)=>$d2768f00a34ae0d4$export$876089ea65adc54(state).cloudId;
const $d2768f00a34ae0d4$export$505ebc60b5fc3b2e = (state)=>$d2768f00a34ae0d4$export$876089ea65adc54(state).fabricPfDirUrl;
const $d2768f00a34ae0d4$export$f5baf4f0aaa47428 = (state)=>$d2768f00a34ae0d4$export$876089ea65adc54(state).atlassianAccountId;
const $d2768f00a34ae0d4$export$667f2a0f99c75faa = (state)=>$d2768f00a34ae0d4$export$876089ea65adc54(state).projectKey;
const $d2768f00a34ae0d4$export$2cd058184eb75757 = (state)=>$d2768f00a34ae0d4$export$876089ea65adc54(state).projectName;
const $d2768f00a34ae0d4$export$180605366c04f0cd = (state)=>$d2768f00a34ae0d4$export$876089ea65adc54(state).locale;
const $d2768f00a34ae0d4$export$7d046765d192af80 = (state)=>$d2768f00a34ae0d4$export$876089ea65adc54(state).isAdmin;
const $d2768f00a34ae0d4$export$89040d072f281f85 = (state)=>$d2768f00a34ae0d4$export$876089ea65adc54(state).projectId;
const $d2768f00a34ae0d4$export$78632e066216024 = (0, $ahm5r.createSelector)($d2768f00a34ae0d4$export$fdd2c0ba94025c3c, $d2768f00a34ae0d4$export$505ebc60b5fc3b2e, $d2768f00a34ae0d4$export$f5baf4f0aaa47428, (cloudId, fabricPfDirUrl, atlassianAccountId)=>({
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        cloudId: (0, $ljej9.toCloudId)(cloudId),
        fabricPfDirUrl: fabricPfDirUrl,
        atlassianAccountId: atlassianAccountId
    }));

});

parcelRegister("7ydZd", function(module, exports) {

$parcel$export(module.exports, "switchingFetch", () => $92fdd45dc0e5e4b2$export$cffbcfdbac9406a3);
$parcel$export(module.exports, "default", () => $92fdd45dc0e5e4b2$export$2e2bcd8739ae039);

var $l8ZcU = parcelRequire("l8ZcU");

var $jlJsl = parcelRequire("jlJsl");
const $92fdd45dc0e5e4b2$var$postParams = (jql, columnNames, columnTypesAsJson, startIndex, issuesPerPage, currentIssueHash, orderBy, isAscendingOrder, category, filterClause, queueId, resetSorting, searchMode)=>({
        jql: jql,
        columnNames: columnNames,
        columnTypesAsJson: columnTypesAsJson,
        startIndex: startIndex,
        issuesPerPage: issuesPerPage,
        currentIssueHash: currentIssueHash || '',
        ...orderBy ? {
            orderBy: orderBy,
            isAscendingOrder: isAscendingOrder
        } : {},
        ...category && category !== (0, $jlJsl.NO_CATEGORY) ? {
            category: category
        } : {},
        filterClause: filterClause,
        queueId: queueId,
        resetSorting: resetSorting,
        searchMode: searchMode
    });
const $92fdd45dc0e5e4b2$export$cffbcfdbac9406a3 = (args)=>{
    const { projectKey: projectKey, jql: jql, columnNames: columnNames, columnTypesAsJson: columnTypesAsJson, startIndex: startIndex, issuesPerPage: issuesPerPage, orderBy: orderBy, isAscendingOrder: isAscendingOrder, category: category, queueId: queueId, filterClause: filterClause, resetSorting: resetSorting, searchMode: searchMode } = args;
    // @ts-expect-error - TS2339 - Property 'issueHash' does not exist on type 'IssueListFetchArgs | UpdatedFetchArgs'.
    const issueHash = args.issueHash || null;
    const fetchUrl = `/rest/servicedesk/1/servicedesk/${projectKey}/issuelist${issueHash ? '/updated' : ''}?operation=${issueHash ? 'fetchIssueListUpdated' : 'fetchIssueList'}`;
    const fetchOptions = {
        method: 'POST',
        body: JSON.stringify($92fdd45dc0e5e4b2$var$postParams(jql, columnNames, columnTypesAsJson, startIndex, issuesPerPage, issueHash, orderBy, isAscendingOrder, category, filterClause, queueId, resetSorting, searchMode))
    };
    return (0, $l8ZcU.fetchJson$)(fetchUrl, fetchOptions);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$92fdd45dc0e5e4b2$export$2e2bcd8739ae039 = (args)=>$92fdd45dc0e5e4b2$export$cffbcfdbac9406a3(args);

});
parcelRegister("l8ZcU", function(module, exports) {

$parcel$export(module.exports, "fetchJson$", () => $45131632c504eb66$export$2ba52855e389d39e);
$parcel$export(module.exports, "fetchText$", () => $45131632c504eb66$export$64ab95a52860b608);
parcelRequire("gdMGY");
parcelRequire("c1D7V");

var $exWdq = parcelRequire("exWdq");

var $7kixv = parcelRequire("7kixv");

var $1K8u5 = parcelRequire("1K8u5");

var $1Ozm9 = parcelRequire("1Ozm9");

var $aRaT4 = parcelRequire("aRaT4");
const $45131632c504eb66$var$buildErrorResponse = (message, statusCode, traceId)=>({
        response: {
            errors: [
                {
                    errorMessage: message
                }
            ],
            reasonKey: 'generic.error',
            reasonCode: `${statusCode}`
        },
        statusCode: statusCode,
        traceId: traceId
    });
const $45131632c504eb66$var$toAnError = (error)=>{
    const traceId = error.traceId;
    try {
        // ServiceDesk REST errors be usually be in the form of a JSON
        // object (e.g., AnError).  We'll try to parse it.
        const response = JSON.parse(error.message);
        // Normalize the shape of "simple" JSON error responses containing
        // message and status-code, as used in e.g., standard Jira
        // unauthorized response.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(response, 'message') && (0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(response, 'status-code')) return $45131632c504eb66$var$buildErrorResponse(response.message, parseInt(response['status-code'], 10), traceId);
        return {
            response: response,
            statusCode: error.statusCode,
            traceId: traceId
        };
    } catch (e) {
        // Message didn't parse as JSON; assume it's a plain ol' string, and
        // we'll produce an AnError-like object with it.
        return $45131632c504eb66$var$buildErrorResponse(error.message, error.statusCode, traceId);
    }
};
const $45131632c504eb66$export$6d71b655afe1638d = (url, opts)=>(0, $1Ozm9.default)(url, opts).catch((error)=>Promise.reject($45131632c504eb66$var$toAnError(error)));
const $45131632c504eb66$export$2ba52855e389d39e = (url, opts)=>(0, $1K8u5.default)(url, opts).catch((error)=>(0, $7kixv.Observable).throw($45131632c504eb66$var$toAnError(error)));
const $45131632c504eb66$export$64ab95a52860b608 = (url, opts)=>(0, $aRaT4.default)(url, opts).catch((error)=>(0, $7kixv.Observable).throw($45131632c504eb66$var$toAnError(error)));

});
parcelRegister("1K8u5", function(module, exports) {

$parcel$export(module.exports, "default", () => $51ec3aff262c37e1$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $7kixv = parcelRequire("7kixv");
parcelRequire("9BkTq");
parcelRequire("c1D7V");
parcelRequire("llumX");
parcelRequire("1o2WJ");
parcelRequire("6cJUr");

var $6uWhG = parcelRequire("6uWhG");

var $1oMOM = parcelRequire("1oMOM");

var $ee0TI = parcelRequire("ee0TI");

var $1uIew = parcelRequire("1uIew");

var $i4YfB = parcelRequire("i4YfB");

var $3WOLx = parcelRequire("3WOLx");
const $51ec3aff262c37e1$var$noContentStatus = 204;
const $51ec3aff262c37e1$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $51ec3aff262c37e1$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$51ec3aff262c37e1$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $6uWhG.setMark)(`BEGIN_${key}`);
    }
    return (0, $7kixv.Observable).of(url).mergeMap(()=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $iWqim.merge)((0, $iWqim.merge)((0, $1oMOM.defaultOptions), opts), (0, $3WOLx.makeObservabilityHeaders)()))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $6uWhG.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $ee0TI.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $1uIew.default)(status, str, traceId);
                else throw new (0, $1uIew.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $51ec3aff262c37e1$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $7kixv.Observable).of(null);
        return response.json();
    });
}
var $51ec3aff262c37e1$export$2e2bcd8739ae039 = $51ec3aff262c37e1$var$fetchJson$;

});

parcelRegister("aRaT4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cefc3323bab810e$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $7kixv = parcelRequire("7kixv");
parcelRequire("9BkTq");
parcelRequire("6cJUr");

var $1oMOM = parcelRequire("1oMOM");

var $ee0TI = parcelRequire("ee0TI");

var $1uIew = parcelRequire("1uIew");

var $i4YfB = parcelRequire("i4YfB");

var $3WOLx = parcelRequire("3WOLx");
const $6cefc3323bab810e$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$6cefc3323bab810e$export$2e2bcd8739ae039 = (url, options = {})=>(0, $7kixv.Observable).of(url).mergeMap(()=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $iWqim.merge)((0, $iWqim.merge)((0, $1oMOM.defaultOptions), options), (0, $3WOLx.makeObservabilityHeaders)()))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $ee0TI.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $1uIew.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $1uIew.default)(status);
        }
        if (response.status === $6cefc3323bab810e$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $7kixv.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $7kixv.Observable).of(response.responseText || 'OK');
    });

});



parcelRegister("dTFqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a6f2852835d2c28$export$2e2bcd8739ae039);

var $7ydZd = parcelRequire("7ydZd");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0a6f2852835d2c28$export$2e2bcd8739ae039 = (args)=>(0, $7ydZd.switchingFetch)(args);

});

parcelRegister("cqBpI", function(module, exports) {

$parcel$export(module.exports, "getCreateAnalyticsEvent", () => $780a5d09f60e7b3b$export$da28c0e4cac33548);

var $8bvz0 = parcelRequire("8bvz0");
const $780a5d09f60e7b3b$export$da28c0e4cac33548 = (state)=>(0, $8bvz0.getPersisted)(state).analytic.createAnalyticsEvent;

});
parcelRegister("8bvz0", function(module, exports) {

$parcel$export(module.exports, "getPersisted", () => $3f1083009236bea2$export$5239a0a7977ca4de);
$parcel$export(module.exports, "getAppProps", () => $3f1083009236bea2$export$876089ea65adc54);
const $3f1083009236bea2$export$5239a0a7977ca4de = (state)=>state.persisted;
const $3f1083009236bea2$export$876089ea65adc54 = (state)=>state.appProps;
const $3f1083009236bea2$export$180605366c04f0cd = (state)=>state.appProps.locale;

});


parcelRegister("3MjJb", function(module, exports) {

$parcel$export(module.exports, "getCurrentFilterQuery", () => $f62ea8fc42161089$export$cc320d7c20cf1c31);
$parcel$export(module.exports, "getIsCurrentDataFiltered", () => $f62ea8fc42161089$export$20650273aeda865c);
$parcel$export(module.exports, "getIsNewFilterQueryPending", () => $f62ea8fc42161089$export$43771ef8a5224920);
$parcel$export(module.exports, "getIsFilterFocused", () => $f62ea8fc42161089$export$6c44b9a0531900b1);

var $8bvz0 = parcelRequire("8bvz0");
const $f62ea8fc42161089$export$cc320d7c20cf1c31 = (state)=>(0, $8bvz0.getPersisted)(state).filter.filterQuery;
const $f62ea8fc42161089$export$20650273aeda865c = (state)=>(0, $8bvz0.getPersisted)(state).filter.isCurrentDataFiltered;
const $f62ea8fc42161089$export$43771ef8a5224920 = (state)=>(0, $8bvz0.getPersisted)(state).filter.isNewFilterQueryPending;
const $f62ea8fc42161089$export$6c44b9a0531900b1 = (state)=>(0, $8bvz0.getPersisted)(state).filter.isFilterFocused;

});

parcelRegister("lc49q", function(module, exports) {

$parcel$export(module.exports, "getQueuePageData", () => $9559c3d0ef4ee1ac$export$c60f26b8eba0a78a);
$parcel$export(module.exports, "getCategory", () => $9559c3d0ef4ee1ac$export$410364bbb673ddbc);
$parcel$export(module.exports, "getMetricKey", () => $9559c3d0ef4ee1ac$export$cb832de761ecab61);
$parcel$export(module.exports, "getQueueId", () => $9559c3d0ef4ee1ac$export$aed39b3e342d0167);
$parcel$export(module.exports, "getQueueName", () => $9559c3d0ef4ee1ac$export$6b633f8a8623b3f1);
$parcel$export(module.exports, "getJql", () => $9559c3d0ef4ee1ac$export$2720d348d2cbc9fe);
$parcel$export(module.exports, "getCompleteJql", () => $9559c3d0ef4ee1ac$export$6578bd82b9fd6840);
$parcel$export(module.exports, "isQueueTransient", () => $9559c3d0ef4ee1ac$export$a55400a65ac36e18);
$parcel$export(module.exports, "canManageQueue", () => $9559c3d0ef4ee1ac$export$8a3ca2900db73d42);
$parcel$export(module.exports, "getColumns", () => $9559c3d0ef4ee1ac$export$978e30a0fb8610d8);
$parcel$export(module.exports, "getColumnIds", () => $9559c3d0ef4ee1ac$export$3d88032e6be0ee47);
$parcel$export(module.exports, "getColumnType", () => $9559c3d0ef4ee1ac$export$bf02abf02e552bba);
$parcel$export(module.exports, "getColumnsInOrder", () => $9559c3d0ef4ee1ac$export$27292d0b079cd285);
$parcel$export(module.exports, "getNumberOfColumns", () => $9559c3d0ef4ee1ac$export$a3141f11a33b8412);
$parcel$export(module.exports, "getAllFieldTypes", () => $9559c3d0ef4ee1ac$export$e331c771e0c96919);
$parcel$export(module.exports, "getFetchStartIndex", () => $9559c3d0ef4ee1ac$export$4050fbf2b3dcb166);
$parcel$export(module.exports, "getCurrentQueueOrder", () => $9559c3d0ef4ee1ac$export$81ce441046ce0dc9);
$parcel$export(module.exports, "isQueueMateriallyDifferent", () => $9559c3d0ef4ee1ac$export$fd4ec8b47c12049f);

var $ahm5r = parcelRequire("ahm5r");

var $9g7yh = parcelRequire("9g7yh");

var $2IsS5 = parcelRequire("2IsS5");

var $f20Bj = parcelRequire("f20Bj");

var $jlJsl = parcelRequire("jlJsl");

var $8bvz0 = parcelRequire("8bvz0");

var $6I1gv = parcelRequire("6I1gv");
const $9559c3d0ef4ee1ac$export$c60f26b8eba0a78a = (state)=>(0, $8bvz0.getPersisted)(state).queue;
const $9559c3d0ef4ee1ac$export$410364bbb673ddbc = (state)=>$9559c3d0ef4ee1ac$export$c60f26b8eba0a78a(state).category;
const $9559c3d0ef4ee1ac$export$cb832de761ecab61 = (0, $ahm5r.createSelector)($9559c3d0ef4ee1ac$export$410364bbb673ddbc, (category)=>category && category !== (0, $jlJsl.NO_CATEGORY) ? `servicedesk.queues.${category}.view` : 'servicedesk.queues.view');
const $9559c3d0ef4ee1ac$export$aed39b3e342d0167 = (state)=>{
    const queue = (0, $6I1gv.getCurrentQueue)(state);
    return queue ? queue.id : (0, $2IsS5.toQueueId)(-1);
};
const $9559c3d0ef4ee1ac$export$6b633f8a8623b3f1 = (state)=>{
    const queue = (0, $6I1gv.getCurrentQueue)(state);
    return queue ? queue.name : '';
};
const $9559c3d0ef4ee1ac$export$2720d348d2cbc9fe = (state)=>{
    const queue = (0, $6I1gv.getCurrentQueue)(state);
    return queue ? queue.jql : '';
};
const $9559c3d0ef4ee1ac$export$6578bd82b9fd6840 = (state)=>{
    const queue = (0, $6I1gv.getCurrentQueue)(state);
    return queue ? queue.completeJql : '';
};
const $9559c3d0ef4ee1ac$export$a55400a65ac36e18 = (state)=>{
    const queue = (0, $6I1gv.getCurrentQueue)(state);
    return !!(queue && queue.isTransient);
};
const $9559c3d0ef4ee1ac$export$8a3ca2900db73d42 = (state)=>(0, $f20Bj.getIsAdmin)(state) && !$9559c3d0ef4ee1ac$export$a55400a65ac36e18(state);
const $9559c3d0ef4ee1ac$export$978e30a0fb8610d8 = (state)=>{
    const queue = (0, $6I1gv.getCurrentQueue)(state);
    return queue ? queue.columns : [];
};
const $9559c3d0ef4ee1ac$export$3d88032e6be0ee47 = (0, $ahm5r.createSelector)($9559c3d0ef4ee1ac$export$978e30a0fb8610d8, (columns)=>columns.map((column)=>column.id));
const $9559c3d0ef4ee1ac$export$8b87fd0c3c045ba7 = (0, $ahm5r.createSelector)($9559c3d0ef4ee1ac$export$978e30a0fb8610d8, (columns)=>(0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(columns, 'id'));
const $9559c3d0ef4ee1ac$var$getColumnById = (state, columnId)=>$9559c3d0ef4ee1ac$export$8b87fd0c3c045ba7(state)[columnId];
const $9559c3d0ef4ee1ac$export$bf02abf02e552bba = (state, columnId)=>{
    const column = $9559c3d0ef4ee1ac$var$getColumnById(state, columnId);
    return column && column.fieldType;
};
const $9559c3d0ef4ee1ac$export$27292d0b079cd285 = (0, $ahm5r.createSelector)($9559c3d0ef4ee1ac$export$3d88032e6be0ee47, $9559c3d0ef4ee1ac$export$8b87fd0c3c045ba7, (columnIds, columnsById)=>{
    // To prevent scenario where columnIds exist but columnsById do not
    if (columnIds.length === Object.keys(columnsById).length) {
        const checkbox = {
            id: 'checkbox',
            title: '',
            fieldType: 'checkbox',
            sortable: false
        };
        return [
            checkbox
        ].concat(columnIds.map((colId)=>columnsById[colId]));
    }
    return [];
});
const $9559c3d0ef4ee1ac$export$a3141f11a33b8412 = (state)=>$9559c3d0ef4ee1ac$export$978e30a0fb8610d8(state).length;
const $9559c3d0ef4ee1ac$export$e331c771e0c96919 = (state)=>$9559c3d0ef4ee1ac$export$978e30a0fb8610d8(state).map((column)=>column.fieldType);
const $9559c3d0ef4ee1ac$export$4050fbf2b3dcb166 = (state)=>$9559c3d0ef4ee1ac$export$c60f26b8eba0a78a(state).fetchStartIndex;
const $9559c3d0ef4ee1ac$export$81ce441046ce0dc9 = (state)=>{
    const current = (0, $6I1gv.getCurrentQueue)(state);
    return current ? current.order : -1;
};
const $9559c3d0ef4ee1ac$export$fd4ec8b47c12049f = (state, otherQueue)=>otherQueue.id !== $9559c3d0ef4ee1ac$export$aed39b3e342d0167(state) || otherQueue.jql !== $9559c3d0ef4ee1ac$export$2720d348d2cbc9fe(state) || otherQueue.columns !== $9559c3d0ef4ee1ac$export$978e30a0fb8610d8(state) || otherQueue.category !== $9559c3d0ef4ee1ac$export$410364bbb673ddbc(state);

});
parcelRegister("6I1gv", function(module, exports) {

$parcel$export(module.exports, "getCurrentQueue", () => $ddf9d6139623da8e$export$6b47bf3b28f515da);
$parcel$export(module.exports, "getOnboardingResolved", () => $ddf9d6139623da8e$export$edc47c0083cde3ab);
$parcel$export(module.exports, "getDeletingQueue", () => $ddf9d6139623da8e$export$379fa75ab7e97f42);
$parcel$export(module.exports, "getDeleteModalOpen", () => $ddf9d6139623da8e$export$fd306a625859a9fe);
$parcel$export(module.exports, "getIssueKeyContext", () => $ddf9d6139623da8e$export$c0db69db702258b7);
$parcel$export(module.exports, "getSidebarIssueKey", () => $ddf9d6139623da8e$export$df932d2672780b0c);
$parcel$export(module.exports, "getSidebarReactKey", () => $ddf9d6139623da8e$export$ddbf1ddffbf956f2);
$parcel$export(module.exports, "isQueueVisible", () => $ddf9d6139623da8e$export$acdb497766d87546);
$parcel$export(module.exports, "isInitialized", () => $ddf9d6139623da8e$export$3f95c6f800b78024);
$parcel$export(module.exports, "isLoadingIssues", () => $ddf9d6139623da8e$export$bd765e2c10f9e4dc);
$parcel$export(module.exports, "isQueueEmpty", () => $ddf9d6139623da8e$export$f76a0ecd13927ba1);
$parcel$export(module.exports, "hasPageError", () => $ddf9d6139623da8e$export$3d27fec59f3b6313);
$parcel$export(module.exports, "showIssueFailureError", () => $ddf9d6139623da8e$export$98fc822d2fef9708);
$parcel$export(module.exports, "isRetrying", () => $ddf9d6139623da8e$export$2d2253a53b38e901);
$parcel$export(module.exports, "shouldShowBadFilterQueryError", () => $ddf9d6139623da8e$export$f972e8db29021436);
$parcel$export(module.exports, "isQueuesErrorHeaderDisplayed", () => $ddf9d6139623da8e$export$4a6666492f1d4010);
// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.

var $ljsRg = parcelRequire("ljsRg");

var $3MjJb = parcelRequire("3MjJb");

var $1TuhT = parcelRequire("1TuhT");
const $ddf9d6139623da8e$var$getUIState = (state)=>state.ui;
const $ddf9d6139623da8e$export$6b47bf3b28f515da = (state)=>$ddf9d6139623da8e$var$getUIState(state).currentQueue;
const $ddf9d6139623da8e$export$edc47c0083cde3ab = (state)=>$ddf9d6139623da8e$var$getUIState(state).onboardingResolved;
const $ddf9d6139623da8e$export$379fa75ab7e97f42 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $ljsRg.Maybe).fromNull($ddf9d6139623da8e$var$getUIState(state).deletingQueue).orSome(false);
const $ddf9d6139623da8e$export$fd306a625859a9fe = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $ljsRg.Maybe).fromNull($ddf9d6139623da8e$var$getUIState(state).deleteModalOpen).orSome(false);
const $ddf9d6139623da8e$export$c0db69db702258b7 = (state)=>$ddf9d6139623da8e$var$getUIState(state).issueKeyContext;
const $ddf9d6139623da8e$export$df932d2672780b0c = (state)=>$ddf9d6139623da8e$var$getUIState(state).sidebarIssueKey;
const $ddf9d6139623da8e$export$ddbf1ddffbf956f2 = (state)=>$ddf9d6139623da8e$var$getUIState(state).sidebarReactKey;
const $ddf9d6139623da8e$export$5e52d79ee962d3c1 = (state)=>$ddf9d6139623da8e$var$getUIState(state).selectedIssueKeys;
const $ddf9d6139623da8e$export$acdb497766d87546 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $ljsRg.Maybe).fromNull($ddf9d6139623da8e$var$getUIState(state).isQueueVisible).orSome(true);
const $ddf9d6139623da8e$export$3f95c6f800b78024 = (state)=>!!$ddf9d6139623da8e$export$6b47bf3b28f515da(state);
const $ddf9d6139623da8e$export$4814741d778a48d7 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $ljsRg.Maybe).fromNull($ddf9d6139623da8e$var$getUIState(state).isLoadingPage).orSome(false);
const $ddf9d6139623da8e$export$bd765e2c10f9e4dc = (state)=>(0, $ljsRg.Maybe).fromNull($ddf9d6139623da8e$var$getUIState(state).isLoadingIssues).orSome(true) || (0, $3MjJb.getIsNewFilterQueryPending)(state);
const $ddf9d6139623da8e$export$f76a0ecd13927ba1 = (state)=>!$ddf9d6139623da8e$export$bd765e2c10f9e4dc(state) && (0, $1TuhT.getIssueCount)(state) === 0;
const $ddf9d6139623da8e$var$getPageError = (state)=>(0, $ljsRg.Maybe).fromNull($ddf9d6139623da8e$var$getUIState(state).pageError);
const $ddf9d6139623da8e$export$3d27fec59f3b6313 = (state)=>$ddf9d6139623da8e$var$getPageError(state).isSome();
const $ddf9d6139623da8e$export$98fc822d2fef9708 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $ljsRg.Maybe).fromNull($ddf9d6139623da8e$var$getUIState(state).showIssueFailureError).orSome(false);
const $ddf9d6139623da8e$export$2d2253a53b38e901 = (state)=>$ddf9d6139623da8e$export$3d27fec59f3b6313(state) && $ddf9d6139623da8e$export$4814741d778a48d7(state);
const $ddf9d6139623da8e$export$f972e8db29021436 = (state)=>// @ts-expect-error - TS2322 - Type 'boolean | undefined' is not assignable to type 'boolean'.
    (0, $ljsRg.Maybe).fromNull($ddf9d6139623da8e$var$getUIState(state).shouldShowBadFilterQueryError).orSome(false);
const $ddf9d6139623da8e$export$4a6666492f1d4010 = (state)=>$ddf9d6139623da8e$var$getUIState(state).isQueuesErrorHeaderDisplayed || false;

});
parcelRegister("1TuhT", function(module, exports) {

$parcel$export(module.exports, "getIssueCount", () => $efd90f7e7092b5dc$export$56d545f19dc75191);
$parcel$export(module.exports, "getCollection", () => $efd90f7e7092b5dc$export$2716f3327981be5);
$parcel$export(module.exports, "getTimeWhenLastInitialized", () => $efd90f7e7092b5dc$export$a139a3296053f37d);
$parcel$export(module.exports, "getIssueCacheSize", () => $efd90f7e7092b5dc$export$da3bb4024398ace7);
$parcel$export(module.exports, "isFirstFieldInTable", () => $efd90f7e7092b5dc$export$7451b0120e7484bc);
$parcel$export(module.exports, "isFieldToExperienceTrack", () => $efd90f7e7092b5dc$export$9c6d1a54838b7308);
$parcel$export(module.exports, "getFieldPropsSelector", () => $efd90f7e7092b5dc$export$13c62ee6bac293a0);
$parcel$export(module.exports, "getIssueStatusIdsCounts", () => $efd90f7e7092b5dc$export$ef679118f03c956b);
$parcel$export(module.exports, "getIssueCountByAssignee", () => $efd90f7e7092b5dc$export$337304d202b8d38e);

var $iWqim = parcelRequire("iWqim");

var $ahm5r = parcelRequire("ahm5r");

var $6xlsJ = parcelRequire("6xlsJ");

var $eSnSE = parcelRequire("eSnSE");

var $bi9FK = parcelRequire("bi9FK");

var $dklVu = parcelRequire("dklVu");

var $hFgg4 = parcelRequire("hFgg4");

var $3VM8G = parcelRequire("3VM8G");

var $3JZWp = parcelRequire("3JZWp");

var $8bvz0 = parcelRequire("8bvz0");

var $lc49q = parcelRequire("lc49q");
const $efd90f7e7092b5dc$var$isEcClientEnabled = ()=>{
    const experiences = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $bi9FK.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-inline');
};
const $efd90f7e7092b5dc$var$STATUS_COLUMN = 'status';
const $efd90f7e7092b5dc$var$ASSIGNEE_COLUMN = 'assignee';
const $efd90f7e7092b5dc$var$ROWS_TO_MOUNT_EXPERIENCE_TRACKERS = 50;
const $efd90f7e7092b5dc$var$FIELD_TYPES_TO_MOUNT_EXPERIENCE_TRACKERS = new Set([
    'status',
    'summary',
    'issuetype',
    'issuekey'
]);
const $efd90f7e7092b5dc$var$getIssues = (state)=>(0, $8bvz0.getPersisted)(state).issues;
const $efd90f7e7092b5dc$export$56d545f19dc75191 = (state)=>$efd90f7e7092b5dc$var$getIssues(state).totalCount;
const $efd90f7e7092b5dc$export$2716f3327981be5 = (state)=>$efd90f7e7092b5dc$var$getIssues(state).collection;
const $efd90f7e7092b5dc$var$getIssueKeys = (0, $ahm5r.createSelector)($efd90f7e7092b5dc$export$2716f3327981be5, (collection)=>{
    const issueKeys = [];
    collection.forEach((issue, idx)=>{
        if (issue) issueKeys[idx] = issue.key;
    });
    return issueKeys;
});
const $efd90f7e7092b5dc$var$getIndex = (state)=>$efd90f7e7092b5dc$var$getIssues(state).index;
const $efd90f7e7092b5dc$export$a139a3296053f37d = (state)=>$efd90f7e7092b5dc$var$getIssues(state).timeWhenLastInitialized;
const $efd90f7e7092b5dc$export$da3bb4024398ace7 = (0, $ahm5r.createSelector)($efd90f7e7092b5dc$var$getIndex, (index)=>Object.keys(index).length);
const $efd90f7e7092b5dc$var$doesFirstMatch = (array, expectedFirst)=>array.length > 0 && array[0] === expectedFirst;
const $efd90f7e7092b5dc$export$7451b0120e7484bc = (state, issueKey, fieldId)=>{
    const issues = $efd90f7e7092b5dc$var$getIssueKeys(state);
    const columns = (0, $lc49q.getColumnIds)(state);
    return $efd90f7e7092b5dc$var$doesFirstMatch(issues, issueKey) && $efd90f7e7092b5dc$var$doesFirstMatch(columns, fieldId);
};
const $efd90f7e7092b5dc$export$9c6d1a54838b7308 = (state, issueKey, fieldId)=>{
    const positionIndex = $efd90f7e7092b5dc$var$getIndex(state)[issueKey];
    const columnType = (0, $lc49q.getColumnType)(state, fieldId);
    const isInFirstRows = positionIndex != null && positionIndex < $efd90f7e7092b5dc$var$ROWS_TO_MOUNT_EXPERIENCE_TRACKERS;
    const isExperienceTrackingFieldType = columnType != null && $efd90f7e7092b5dc$var$FIELD_TYPES_TO_MOUNT_EXPERIENCE_TRACKERS.has(columnType);
    return isInFirstRows && isExperienceTrackingFieldType;
};
const $efd90f7e7092b5dc$export$13c62ee6bac293a0 = (0, $ahm5r.createSelector)($efd90f7e7092b5dc$var$getIssues, (issues)=>({ issueKey: issueKey, fieldDescriptor: { fieldId: fieldId, fieldType: fieldType } }, issueFieldDispatcher)=>{
        const indexOfIssue = issues.index[issueKey];
        if (indexOfIssue >= 0) {
            const issue = issues.collection[indexOfIssue];
            if (issue && issue.key === issueKey) {
                const storedFieldValue = issue.fields[fieldId];
                const issueID = issue.id;
                if (storedFieldValue != null) {
                    // @ts-expect-error - TS7006 - Parameter 'newVal' implicitly has an 'any' type.
                    const onFieldCellChange = (newVal)=>{
                        issueFieldDispatcher(issueKey, fieldId, newVal);
                        try {
                            if ($efd90f7e7092b5dc$var$isEcClientEnabled()) {
                                const jsisECClient = (0, $dklVu.getEcClient)();
                                const mutationObj = new (0, $hFgg4.default)(issueID.toString(), (0, $3VM8G.MutationSource).CREATE, '1', []);
                                const analyticsEventObj = {
                                    analyticsMetadata: {
                                        scenario: 'jsm-inline'
                                    }
                                };
                                jsisECClient.saveIssueMutationToCache(mutationObj, analyticsEventObj, {
                                    errorMsg: 'FAILED_JSM_INLINE',
                                    error: true
                                });
                            }
                        } catch (e) {
                            (0, $eSnSE.default).safeErrorWithoutCustomerData('jsis-ec-client', `jsm-inline-err : ${e?.toString() || ''}`);
                        }
                    };
                    return (0, $3JZWp.transformField)(issue, storedFieldValue, fieldType, onFieldCellChange);
                }
            }
        }
        return null;
    });
const $efd90f7e7092b5dc$export$ef679118f03c956b = (0, $ahm5r.createSelector)($efd90f7e7092b5dc$export$2716f3327981be5, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($6xlsJ)))(collection.map((issue)=>(0, $iWqim.getIn)(issue, [
            'fields',
            $efd90f7e7092b5dc$var$STATUS_COLUMN,
            'value',
            'id'
        ])).filter((id)=>id)));
const $efd90f7e7092b5dc$var$getIssueCountsByAssignee = (0, $ahm5r.createSelector)($efd90f7e7092b5dc$export$2716f3327981be5, (collection)=>(0, (/*@__PURE__*/$parcel$interopDefault($6xlsJ)))(collection.map((issue)=>(0, $iWqim.getIn)(issue, [
            'fields',
            $efd90f7e7092b5dc$var$ASSIGNEE_COLUMN,
            'value',
            'accountId'
        ])).filter((id)=>id)));
const $efd90f7e7092b5dc$export$337304d202b8d38e = (state, assigneeId)=>assigneeId ? $efd90f7e7092b5dc$var$getIssueCountsByAssignee(state)[assigneeId] || 0 : 0;

});
parcelRegister("6xlsJ", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $a9KaZ = parcelRequire("a9KaZ");
/** Used for built-in method references. */ var $4c26791fd813cb0a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4c26791fd813cb0a$var$hasOwnProperty = $4c26791fd813cb0a$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $4c26791fd813cb0a$var$countBy = $a9KaZ(function(result, value, key) {
    if ($4c26791fd813cb0a$var$hasOwnProperty.call(result, key)) ++result[key];
    else $iBJlb(result, key, 1);
});
module.exports = $4c26791fd813cb0a$var$countBy;

});

parcelRegister("dklVu", function(module, exports) {

$parcel$export(module.exports, "EcClient", () => $cea073ea7805f0d9$export$a736992aaac2307a);
$parcel$export(module.exports, "getEcClient", () => $cea073ea7805f0d9$export$c9342bd32f51406b);
$parcel$export(module.exports, "default", () => $cea073ea7805f0d9$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");

var $gCeeo = parcelRequire("gCeeo");

var $2Mqjh = parcelRequire("2Mqjh");

var $4rNd6 = parcelRequire("4rNd6");

var $3VM8G = parcelRequire("3VM8G");

var $lWP1m = parcelRequire("lWP1m");

var $3Y7uM = parcelRequire("3Y7uM");
class $cea073ea7805f0d9$export$a736992aaac2307a {
    #issueCache;
    #config;
    constructor(){
        this.#issueCache = new (0, $lWP1m.default)('issue-cache-v1');
        this.#config = {};
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, atlassianAccountId) {
        (0, $lWP1m.default).setTenantDetails(activationID, cloudID, atlassianAccountId);
    }
    /**
	 * A method to fire analytics events for both success and failure
	 */ static fireAnalyticsEvents(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, isSaved, analyticsFailureEventObj = {}) {
        try {
            // let mutationAnalyticsObj: any = [];
            let trackingId = '-1';
            if (Array.isArray(issueMutations)) //   mutationAnalyticsObj = issueMutations.map((item: IssueMutation) => item.issueId);
            trackingId = String(new Date(issueMutations[0]?.lastModified).valueOf()) + (0, $lWP1m.default).userID;
            else trackingId = String(new Date(issueMutations.lastModified).valueOf()) + (0, $lWP1m.default).userID;
            const payload = {
                action: 'mutated',
                actionSubject: 'issue',
                source: key?.analyticsMetadata?.scenario || 'unknown',
                attributes: {
                    ...key.analyticsMetadata,
                    trackingId: // issueMutationDetails: mutationAnalyticsObj,
                    trackingId
                }
            };
            // Error condition
            if (!isSaved) {
                if (!analyticsFailureEventObj) // eslint-disable-next-line no-param-reassign
                analyticsFailureEventObj = {
                    error: true,
                    errorMsg: payload.source
                };
                payload.attributes = {
                    ...payload.attributes,
                    ...analyticsFailureEventObj
                };
            }
            if (Object.prototype.hasOwnProperty.call(key, 'analyticsEventObj')) (0, $gCeeo.fireTrackAnalytics)(// @ts-expect-error - Argument of type 'Object' is not assignable to parameter of type 'UIAnalyticsEvent'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key.analyticsEventObj, `${payload.actionSubject} ${payload.action}`, payload.attributes);
            else // if there is no UI component that triggers the event then we manually fire the event
            (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
                client.getInstance().sendTrackEvent(payload);
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('jsis-ec-client', e);
        }
    }
    /**
	 * A method to save a single issue mutations in cache
	 */ async saveIssueMutationToCache(issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        return this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
            let isSaved = false;
            if (issueMutation.mutationType === (0, $3VM8G.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
            else if (result || issueMutation.mutationType === (0, $3VM8G.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
            else isSaved = await this.#issueCache.create(issueMutation.issueId);
            $cea073ea7805f0d9$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return new Promise((resolve)=>resolve(isSaved));
        });
    }
    /**
	 * A method to save multiple issue mutations in cache
	 */ async saveIssueMutationsToCache(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        const data = [];
        issueMutations.forEach(async (issueMutation)=>{
            this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
                let isSaved = false;
                if (issueMutation.mutationType === (0, $3VM8G.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
                else if (result || issueMutation.mutationType === (0, $3VM8G.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
                else isSaved = await this.#issueCache.create(issueMutation.issueId);
                data.push(isSaved);
                $cea073ea7805f0d9$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            });
        });
        return new Promise((resolve)=>resolve(data));
    }
    /**
	 * A method to get issue mutations in saved in cache
	 */ getIssueMutationFromCache(key) {
        return this.#issueCache.get(key);
    }
    /**
	 * A method to remove the deleted issues from the search API
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async filterData(data) {
        const localStorageData = await this.getIssueMutationFromCache(null);
        const deletedData = new Set();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(localStorageData).forEach((element)=>{
            if (element.mutationType === (0, $3VM8G.MutationSource).DELETE) deletedData.add(element.issueId);
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredData = [];
        let success = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(data).forEach((element)=>{
            if (!element.id || typeof element.id !== 'number') success = false;
            else if (!deletedData.has(element.id.toString())) filteredData.push(element);
        });
        return new Promise((// eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            if (success) resolve(filteredData);
            else reject(new Error());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async constructMatchRequest() {
        const issueData = {
            issues: [],
            hydrationMode: 0
        };
        const data = await this.getIssueMutationFromCache(null);
        Object.values(data).forEach((issueMutation)=>{
            const element = {
                issueId: issueMutation.issueId,
                version: issueMutation.version
            };
            issueData.issues.push(element);
        });
        const options = {
            method: 'POST',
            headers: {
                content_type: 'application/json',
                // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
                'x-atlassian-capability': (0, $4rNd6.getEnhancedCapabilityHeader)(this.#config.capability)
            },
            body: JSON.stringify(issueData)
        };
        return new Promise((resolve)=>resolve(options));
    }
    /**
	 * A method to get the relevant search data from the parsing function that the user has provided
	 */ static getIssueDataFromSearch(data, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData) {
        const result = parseIssueData(data);
        if (result == null) return [];
        return result;
    }
    /**
	 * A method to get the search data and reconcile it with the data present in cache
	 */ async searchAndReconcile(matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability) {
        // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
        this.#config.capability = capability;
        const matchRequest = await this.constructMatchRequest();
        if (matchRequest && matchRequest.body && matchRequest.body.issues && matchRequest.body.issues.length === 0) return search.then((data)=>new Promise((resolve)=>resolve({
                    reconciledIssues: $cea073ea7805f0d9$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData),
                    matchAPIResponse: {
                        response: {
                            resultsByIssueId: {}
                        },
                        issue: {
                            issuesResponse: {}
                        }
                    }
                })));
        const matchPromise = (0, $1Ozm9.default)(matchApiUrl, matchRequest);
        return Promise.all([
            search,
            matchPromise
        ]).then(([data, response])=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const structuredData = $cea073ea7805f0d9$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData);
            return this.filterData(structuredData) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((filteredSearchData)=>{
                if (response == null || response.response == null || response.response.resultsByIssueId == null) throw new Error('Match response is invalid!');
                const matchedIssueIds = response.response.resultsByIssueId;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const filteredMatchedIssueIdsData = [];
                Object.entries(matchedIssueIds).forEach(([key, value])=>{
                    if (value === 'RESULT_MATCH') filteredMatchedIssueIdsData.push({
                        id: parseInt(key, 10)
                    });
                });
                return new Promise((resolve)=>{
                    resolve({
                        reconciledIssues: (0, $3Y7uM.mergeResponseData)(filteredSearchData, filteredMatchedIssueIdsData),
                        matchAPIResponse: response
                    });
                });
            }).catch(()=>new Promise((resolve)=>resolve({
                        reconciledIssues: structuredData,
                        matchAPIResponse: response
                    })));
        });
    }
}
const $cea073ea7805f0d9$var$ecClient = new $cea073ea7805f0d9$export$a736992aaac2307a();
function $cea073ea7805f0d9$export$c9342bd32f51406b(tenantContext = {}) {
    $cea073ea7805f0d9$export$a736992aaac2307a.setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    return $cea073ea7805f0d9$var$ecClient;
}
var $cea073ea7805f0d9$export$2e2bcd8739ae039 = $cea073ea7805f0d9$var$ecClient;

});
parcelRegister("3VM8G", function(module, exports) {

$parcel$export(module.exports, "MutationSource", () => $0fb6cb071bb9bb1b$export$17f28c4c94a74282);
$parcel$export(module.exports, "CacheType", () => $0fb6cb071bb9bb1b$export$ba193b555633db78);
const $0fb6cb071bb9bb1b$export$17f28c4c94a74282 = {
    CREATE: 0,
    UPDATE: 1,
    DELETE: 2
};
const $0fb6cb071bb9bb1b$export$ba193b555633db78 = {
    LOCAL: 'local',
    SESSION: 'session'
};

});

parcelRegister("lWP1m", function(module, exports) {

$parcel$export(module.exports, "default", () => $c48dac50e66fa74f$export$2e2bcd8739ae039);
// Issue Cache API is an internal tool and this file should not be edited. Please contact Odin team for any modifications.

var $dQ3qN = parcelRequire("dQ3qN");

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");

var $dnU6V = parcelRequire("dnU6V");

var $7jTnu = parcelRequire("7jTnu");

var $hFgg4 = parcelRequire("hFgg4");

var $3VM8G = parcelRequire("3VM8G");

var $3Y7uM = parcelRequire("3Y7uM");
const $c48dac50e66fa74f$var$MAX_AGE_MIN = 5;
const $c48dac50e66fa74f$var$MAX_AGE = $c48dac50e66fa74f$var$MAX_AGE_MIN * 60000;
const $c48dac50e66fa74f$var$CACHE_SIZE = 100;
const $c48dac50e66fa74f$var$CACHE_KEY_PREFIX = '__storejs';
const $c48dac50e66fa74f$var$BE_CACHE_SAVE_ISSUE_MUTATION = '/gateway/api/jira-jql-service/api/v1/issue-mutation';
const $c48dac50e66fa74f$var$localStorageProvider = (0, $dnU6V.createLocalStorageProvider)('', false);
class $c48dac50e66fa74f$export$2e2bcd8739ae039 {
    #localCache;
    #sessionCache;
    constructor(namespace, maxAge = $c48dac50e66fa74f$var$MAX_AGE){
        this.maxAge = maxAge;
        this.namespace = namespace;
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#localCache = new (0, $dQ3qN.Cache)({
            size: $c48dac50e66fa74f$var$CACHE_SIZE,
            storageType: (0, $3VM8G.CacheType).LOCAL,
            cacheKey: namespace
        });
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#sessionCache = new (0, $dQ3qN.Cache)({
            size: $c48dac50e66fa74f$var$CACHE_SIZE,
            storageType: (0, $3VM8G.CacheType).SESSION,
            cacheKey: namespace
        });
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, userID) {
        if (activationID && activationID !== $c48dac50e66fa74f$export$2e2bcd8739ae039.activationID) $c48dac50e66fa74f$export$2e2bcd8739ae039.activationID = activationID;
        if (cloudID && cloudID !== $c48dac50e66fa74f$export$2e2bcd8739ae039.cloudID) $c48dac50e66fa74f$export$2e2bcd8739ae039.cloudID = cloudID;
        if (userID && userID !== $c48dac50e66fa74f$export$2e2bcd8739ae039.userID) $c48dac50e66fa74f$export$2e2bcd8739ae039.userID = userID;
    }
    /**
	 * A util method to decide whether an issue mutation in cache is stale or not
	 */ static isIssueMutationStale(issueMutation) {
        const lastModified = new Date(issueMutation.lastModified).getTime();
        return Date.now() - lastModified < $c48dac50e66fa74f$var$MAX_AGE;
    }
    /**
	 * A util method to generate partial key containing username for storing in cache
	 */ static generateKey() {
        let anonymousId = (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $c48dac50e66fa74f$var$localStorageProvider.get('ajs_anonymous_id') : window.localStorage.getItem('ajs_anonymous_id');
        anonymousId = anonymousId ? `.${anonymousId}` : '';
        anonymousId = anonymousId.replace(/["]+/g, '');
        // TODO : Replace this with something more generic
        return `jsis.ecCache.data${anonymousId}.newIssuesMutationList`;
    }
    /**
	 * A method to generate key containing username as well as namespace for storing in cache
	 */ generateReadKey() {
        return `${$c48dac50e66fa74f$var$CACHE_KEY_PREFIX}_${this.namespace}_${$c48dac50e66fa74f$export$2e2bcd8739ae039.generateKey()}`;
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds and returns corresponding issue mutations
	 * Returns all the issue mutations when provided with null argument in form of an array
	 * Cleans the cache before accessing issue mutations in order to avoid stale data
	 */ async get(key) {
        return this.cleanCache().then(()=>this.getWithoutClean(key));
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds to return selective issue mutations
	 * Returns all the issue mutations when provided with null argument
	 */ async getWithoutClean(key) {
        if (key == null) return new Promise((resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>data ? resolve(data) : resolve({}));
        });
        return new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>{
                if (!data) resolve({});
                else {
                    const iterableData = data;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const newData = {};
                    if (typeof key === 'string') newData[key] = iterableData[key];
                    else if (Array.isArray(key)) key.forEach((issueId)=>{
                        newData[issueId] = iterableData[issueId];
                    });
                    resolve(newData);
                }
            });
        });
    }
    /**
	 * A method to construct object to be stored in backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static constructBackendCacheObject(value) {
        if (value instanceof (0, $hFgg4.default)) return {
            issueId: value.issueId,
            mutationType: value.mutationType,
            mutationTimestamp: value.lastModified
        };
        const result = [];
        value.forEach((data)=>{
            result.push($c48dac50e66fa74f$export$2e2bcd8739ae039.constructBackendCacheObject(data));
        });
        return result;
    }
    /**
	 * A method to save the issue mutations in the backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static setBackendCache(data) {
        try {
            let issueBody = $c48dac50e66fa74f$export$2e2bcd8739ae039.constructBackendCacheObject(data);
            let trackingId = '-1';
            if (data instanceof (0, $hFgg4.default)) {
                trackingId = String(new Date(data.lastModified).valueOf()) + ($c48dac50e66fa74f$export$2e2bcd8739ae039.userID || '');
                issueBody = [
                    issueBody
                ];
            } else trackingId = String(new Date(data[0].lastModified).valueOf()) + ($c48dac50e66fa74f$export$2e2bcd8739ae039.userID || '');
            (0, $1Ozm9.default)($c48dac50e66fa74f$var$BE_CACHE_SAVE_ISSUE_MUTATION, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'ATL-activationId': $c48dac50e66fa74f$export$2e2bcd8739ae039.activationID || '',
                    'atl-CloudId': $c48dac50e66fa74f$export$2e2bcd8739ae039.cloudID || '',
                    trackingId: trackingId
                },
                body: JSON.stringify({
                    issueMutations: issueBody
                })
            });
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('jsis-ec-client', `${e?.toString() || ''}mutationObj: ${data}`);
            return false;
        }
    }
    /**
	 * A method to save the issue mutations in the cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ async set(value) {
        return this.getWithoutClean().then(async (cacheData)=>{
            if (value instanceof (0, $hFgg4.default)) {
                const storeValue = {
                    [value.issueId]: value
                };
                return new Promise((resolve)=>{
                    try {
                        this.#localCache.set(this.generateReadKey(), (0, $3Y7uM.mergeData)(cacheData, storeValue));
                        resolve(true);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (e) {
                        resolve(false);
                    }
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const storeData = {};
            value.forEach((data)=>{
                storeData[data.issueId] = data;
            });
            return new Promise((resolve)=>{
                try {
                    this.#localCache.set(this.generateReadKey(), (0, $3Y7uM.mergeData)(cacheData, storeData));
                    resolve(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    resolve(false);
                }
            });
        });
    }
    /**
	 * A method to create a new issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be created in cache
	 */ async create(value) {
        return this.cleanCache().then(()=>{
            if (!Array.isArray(value)) return this.set(new (0, $hFgg4.default)(value, (0, $3VM8G.MutationSource).CREATE, '1', [], new Date().toISOString()));
            const storeData = value.map((data)=>new (0, $hFgg4.default)(data, (0, $3VM8G.MutationSource).CREATE, '1', [], new Date().toISOString()));
            return this.set(storeData);
        });
    }
    /**
	 * A method to update an already existing issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be updated in cache
	 */ async update(value) {
        return this.getWithoutClean(value).then((data)=>{
            const valueToUpdate = [];
            Object.entries(data).forEach(([issueId, issueMutationObj])=>{
                if (issueMutationObj instanceof (0, $hFgg4.default)) {
                    if ($c48dac50e66fa74f$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) valueToUpdate.push(new (0, $hFgg4.default)(String(issueId), (0, $3VM8G.MutationSource).UPDATE, issueMutationObj.version, issueMutationObj.matchStatus, new Date().toISOString()));
                    else valueToUpdate.push(new (0, $hFgg4.default)(String(issueId), (0, $3VM8G.MutationSource).CREATE, '1', issueMutationObj.matchStatus, new Date().toISOString()));
                } else valueToUpdate.push(new (0, $hFgg4.default)(String(issueId), (0, $3VM8G.MutationSource).UPDATE, // TODO: Incorporate the version and match status and change the update method signature
                '1', [], new Date().toISOString()));
            });
            return this.set(valueToUpdate);
        });
    }
    /**
	 * A method to delete an issue mutation in cache
	 */ async delete(key) {
        if (typeof key === 'string') return this.set(new (0, $hFgg4.default)(key, (0, $3VM8G.MutationSource).DELETE, '', [], new Date().toISOString()));
        const storeData = key.map((data)=>new (0, $hFgg4.default)(data, (0, $3VM8G.MutationSource).DELETE, '', [], new Date().toISOString()));
        return this.set(storeData);
    }
    /**
	 * A method to clear the cache
	 */ async clear() {
        return this.#localCache.clear();
    }
    /**
	 * A method that selectively deletes the stale cache entries
	 */ async cleanCache() {
        return this.getWithoutClean(null).then((data)=>{
            const issuesToKeep = [];
            if (data && Object.keys(data).length !== 0 && Object.getPrototypeOf(data) === Object.prototype) Object.keys(data).forEach((issueId)=>{
                const issueMutationObj = data[issueId];
                if ($c48dac50e66fa74f$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) issuesToKeep.push(issueMutationObj);
            });
            return this.clear().then(()=>this.set(issuesToKeep));
        });
    }
    /**
	 * A method to check if an issue id is present in the cache
	 */ isPresent(issueId) {
        return this.get(issueId).then((data)=>!!data && !!Object.values(data)[0]);
    }
    /**
	 * A method to check if any mutation is present in the cache
	 */ isEmpty() {
        return this.get(null).then((data)=>Object.keys(data).length === 0);
    }
    /**
	 * A method to find the size of the local storage for any given key
	 */ static getLocalStorageSizeForGivenKey(key) {
        const value = (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $c48dac50e66fa74f$var$localStorageProvider.get(key) : window.localStorage.getItem(key);
        if (value != null) {
            const keySize = value.length;
            return keySize;
        }
        return 0;
    }
    /**
	 * A method to find the size of the local storage for any given key
	 * It returns size of all the keys when provided with no key
	 */ static getLocalStorageSize(key) {
        if (key != null) return $c48dac50e66fa74f$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(key);
        let totalSize = 0;
        Object.keys(localStorage).forEach((keys)=>{
            totalSize += $c48dac50e66fa74f$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(keys);
        });
        return totalSize;
    }
}

});
parcelRegister("dQ3qN", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $dad4e0b94ce9085b$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $dad4e0b94ce9085b$export$2e2bcd8739ae039);

var $dnU6V = parcelRequire("dnU6V");

var $4elgJ = parcelRequire("4elgJ");

var $eSnSE = parcelRequire("eSnSE");


var $6O0zm = parcelRequire("6O0zm");
const $dad4e0b94ce9085b$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $dad4e0b94ce9085b$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $6O0zm.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $8da4e41a25982619$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $dad4e0b94ce9085b$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $8da4e41a25982619$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $dad4e0b94ce9085b$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $8da4e41a25982619$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $8da4e41a25982619$export$2670cb7d5d4f7184)) storage = (0, $dnU6V.createLocalStorageProvider)((0, $6O0zm.CACHE_PREFIX));
        else storage = (0, $4elgJ.createSessionStorageProvider)((0, $6O0zm.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $8da4e41a25982619$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $8da4e41a25982619$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $8da4e41a25982619$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $eSnSE.default).safeWarnWithoutCustomerData((0, $8da4e41a25982619$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $8da4e41a25982619$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $8da4e41a25982619$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $8da4e41a25982619$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $6O0zm.default).scopes.current !== (0, $6O0zm.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dad4e0b94ce9085b$var$cacheMap = {};
const $dad4e0b94ce9085b$var$getCache = async (props)=>{
    await (0, $6O0zm.scopeGuard)().catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $dad4e0b94ce9085b$var$cacheMap[cacheKey] = $dad4e0b94ce9085b$var$cacheMap[cacheKey] || new $dad4e0b94ce9085b$export$94affb487e701bf2(props);
    return $dad4e0b94ce9085b$var$cacheMap[cacheKey];
};
const $dad4e0b94ce9085b$export$710d301bf26d9700 = ()=>{
    Object.values($dad4e0b94ce9085b$var$cacheMap).forEach((cache)=>cache.clear());
};
var $dad4e0b94ce9085b$export$2e2bcd8739ae039 = $dad4e0b94ce9085b$var$getCache;

});
const $8da4e41a25982619$export$7271276960377470 = 'common-cache';
const $8da4e41a25982619$export$a61768fefd33fcb1 = 'capacity exceeded';
const $8da4e41a25982619$export$6c4d37c7f376a1de = 'clear';
const $8da4e41a25982619$export$e271b26eefe41db8 = 'update';
const $8da4e41a25982619$export$4bd2facc4a3e6aa1 = 'delete';
const $8da4e41a25982619$export$26d12233004a7a60 = 'delete stale entry';
const $8da4e41a25982619$export$1bb358554aac31c1 = 'get';
const $8da4e41a25982619$export$61f74127e2b53cbe = 'hydrate';
const $8da4e41a25982619$export$5e8f180ef0142226 = 'set';
const $8da4e41a25982619$export$9eb68924983e00fb = 'get entries';
const $8da4e41a25982619$export$bf340b99118a1511 = 'memory';
const $8da4e41a25982619$export$2670cb7d5d4f7184 = 'local';
const $8da4e41a25982619$export$b796061ff0c82e1a = 'session';

parcelRegister("6O0zm", function(module, exports) {

$parcel$export(module.exports, "CACHE_PREFIX", () => $24dcac986fde8d1b$export$69ca515e4489d790);
$parcel$export(module.exports, "scopeGuard", () => $24dcac986fde8d1b$export$653cd03438bb0386);
$parcel$export(module.exports, "default", () => $24dcac986fde8d1b$export$2e2bcd8739ae039);

var $dnU6V = parcelRequire("dnU6V");
let $24dcac986fde8d1b$var$resolveCachePromise;
const $24dcac986fde8d1b$var$cachePromise = new Promise((resolve)=>{
    $24dcac986fde8d1b$var$resolveCachePromise = resolve;
});
const $24dcac986fde8d1b$export$27be962d708928a = '__scope_key__';
const $24dcac986fde8d1b$export$69ca515e4489d790 = 'cache_prefix';
const $24dcac986fde8d1b$var$TIMEOUT = 10000;
const $24dcac986fde8d1b$var$promiseWithMaxExecutionTime = (ms, promise)=>{
    let id;
    const timeout = new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        id = setTimeout(()=>{
            const storage = (0, $dnU6V.createLocalStorageProvider)($24dcac986fde8d1b$export$69ca515e4489d790);
            storage.clearAll();
            reject(new Error(`Cache scope was not set within ${$24dcac986fde8d1b$var$TIMEOUT}ms`));
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then((result)=>{
        clearTimeout(id);
        return result;
    });
};
const $24dcac986fde8d1b$export$653cd03438bb0386 = ()=>$24dcac986fde8d1b$var$promiseWithMaxExecutionTime($24dcac986fde8d1b$var$TIMEOUT, $24dcac986fde8d1b$var$cachePromise);
const $24dcac986fde8d1b$var$config = {
    devTools: false,
    scopes: {
        prev: null,
        current: null
    },
    set (scopeKey) {
        const storage = (0, $dnU6V.createLocalStorageProvider)($24dcac986fde8d1b$export$69ca515e4489d790);
        const scopeKeyInStorage = storage.get($24dcac986fde8d1b$export$27be962d708928a);
        // init value
        if (this.scopes.prev === null && this.scopes.current === null) {
            if (scopeKeyInStorage) {
                // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
                this.scopes.prev = scopeKeyInStorage;
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.scopes.current = scopeKeyInStorage;
            }
        }
        // same account id
        if (this.scopes.current !== scopeKey) {
            // diffrent account id
            if (this.scopes.current !== null) // scope has changed during session
            storage.clearAll();
            // @ts-expect-error - TS2540 - Cannot assign to 'prev' because it is a read-only property.
            this.scopes.prev = this.scopes.current;
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.scopes.current = scopeKey;
            storage.set($24dcac986fde8d1b$export$27be962d708928a, scopeKey);
        }
        // @ts-expect-error - TS7005 - Variable 'resolveCachePromise' implicitly has an 'any' type.
        $24dcac986fde8d1b$var$resolveCachePromise();
    },
    get () {
        return this.scopes.current;
    }
};
var $24dcac986fde8d1b$export$2e2bcd8739ae039 = $24dcac986fde8d1b$var$config;

});


parcelRegister("hFgg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb3f6361684d0c47$export$2e2bcd8739ae039);
class $cb3f6361684d0c47$export$2e2bcd8739ae039 {
    constructor(issueId, mutationType, version = '1', matchStatus = [], // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lastModified){
        this.issueId = issueId;
        this.mutationType = mutationType;
        this.version = version;
        this.matchStatus = matchStatus;
        // create a new timeStamp whenever an object is initialized
        this.lastModified = new Date().toISOString();
    }
}

});

parcelRegister("3Y7uM", function(module, exports) {

$parcel$export(module.exports, "mergeData", () => $cc80038c9728d494$export$696bf4df45a0ddde);
$parcel$export(module.exports, "mergeResponseData", () => $cc80038c9728d494$export$71923bad28063cb1);

var $hWeHP = parcelRequire("hWeHP");
function $cc80038c9728d494$export$696bf4df45a0ddde(oldData, newData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(oldData).forEach((issueId)=>{
        result[issueId] = oldData[issueId];
    });
    Object.keys(newData).forEach((issueId)=>{
        result[issueId] = newData[issueId];
    });
    return result;
}
function $cc80038c9728d494$export$71923bad28063cb1(searchData, matchData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mergedData = [];
    const issueData = new Map();
    if (matchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchData.forEach((element)=>{
        issueData.set(element.id, element);
    });
    if (searchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchData.forEach((element)=>{
        // TODO: if issueVersion in Match is less than Search, we should not be overwriting that issueID.
        if (issueData.has(element.id)) {
            mergedData.push(issueData.get(element.id));
            issueData.delete(element.id);
        } else mergedData.push(element);
    });
    if (issueData.size) issueData.forEach((value)=>{
        mergedData.push(value);
    });
    return mergedData;
}
function $cc80038c9728d494$export$eeaad9fa1f02ef4a(customKeys) {
    return {
        shard: (0, $hWeHP.default)('ajs-shard') || '',
        userId: (0, $hWeHP.default)('ajs-atlassian-account-id') || '',
        projectId: (0, $hWeHP.default)('ajs-project-key') || '',
        ...customKeys
    };
}

});



parcelRegister("3JZWp", function(module, exports) {

$parcel$export(module.exports, "transformField", () => $5defd96322b7f13f$export$fbce423ada1f57a0);

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $ajASe = parcelRequire("ajASe");

var $xotLX = parcelRequire("xotLX");

var $3eUTC = parcelRequire("3eUTC");
const $5defd96322b7f13f$var$LOCATION = 'servicedesk.queues.selectors.fields-transformers';
const $5defd96322b7f13f$var$skipTransformer = (fieldType, field)=>{
    const errMessage = `No transformer for the field of type '${fieldType}', passing it straight to issue-table from redux`;
    (0, $gYnSx.default)({
        meta: {
            id: 'selectorsFieldsTransformers',
            packageName: 'jiraServicedeskQueuesAgentView',
            teamName: 'jsd-shield'
        },
        error: new Error(errMessage)
    });
    (0, $ajASe.default).safeErrorWithoutCustomerData($5defd96322b7f13f$var$LOCATION, errMessage);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        // @ts-expect-error - TS2352 - Conversion of type '{ fieldId: string; value: User | null; isEditable: boolean; noJsonFieldTransformer: boolean; fieldType: string; } | { fieldId: string; value: User; isEditable: boolean; noJsonFieldTransformer: boolean; fieldType: string; } | ... 9 more ... | { ...; }' to type 'FieldDataSelectorChildrenProps' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
        noJsonFieldTransformer: true,
        fieldType: fieldType,
        ...field
    };
};
const $5defd96322b7f13f$export$fbce423ada1f57a0 = (issue, field, fieldType, storedFieldUpdater)=>{
    const htmlOverrideFieldTransformer = (0, $7jTnu.fg)('jsm_queues_ssr_transform_status_category_priority') ? (0, $3eUTC.getHtmlOverrideFieldTransformer)(fieldType) : (0, $3eUTC.getHtmlOverrideFieldTransformerOld)(fieldType);
    if (htmlOverrideFieldTransformer) return htmlOverrideFieldTransformer(issue, field);
    // @ts-expect-error - TS2339 - Property 'fieldAsHtml' does not exist on type 'ResponseField'. | TS2339 - Property 'fieldCssClass' does not exist on type 'ResponseField'.
    if (field.fieldAsHtml != null || field.fieldCssClass != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $xotLX.htmlTransformer)(field);
    const jsonFieldTransformer = (0, $3eUTC.getJsonTransformer)(fieldType);
    if (!jsonFieldTransformer) return $5defd96322b7f13f$var$skipTransformer(fieldType, field);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const storedValue = field;
    const transformerInputParams = {
        storedValue: storedValue,
        storedFieldUpdater: storedFieldUpdater
    };
    if ((0, $7jTnu.fg)('handle-queues-column-exceptions')) {
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GenericFieldDataTransformerInput<AssigneeFieldResponse> & GenericFieldDataTransformerInput<CreatorFieldResponse> & ... 9 more ... & GenericFieldDataTransformerInput<...>'.
        const transformedFieldData = jsonFieldTransformer(transformerInputParams);
        // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'unknown'.
        const { value: responseValue } = storedValue;
        if (responseValue && responseValue.error) return {
            ...transformedFieldData,
            value: responseValue
        };
        return transformedFieldData;
    }
    // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'GenericFieldDataTransformerInput<AssigneeFieldResponse> & GenericFieldDataTransformerInput<CreatorFieldResponse> & ... 9 more ... & GenericFieldDataTransformerInput<...>'.
    return jsonFieldTransformer(transformerInputParams);
};

});
parcelRegister("xotLX", function(module, exports) {

$parcel$export(module.exports, "htmlTransformer", () => $fdfd0b8a74bb6dff$export$7237dba103a5f934);
const $fdfd0b8a74bb6dff$export$7237dba103a5f934 = (storedValue)=>{
    const { fieldAsHtml: fieldRenderedValue, fieldCssClass: fieldCssClass } = storedValue;
    return {
        fieldRenderedValue: fieldRenderedValue,
        fieldCssClass: fieldCssClass
    };
};

});

parcelRegister("3eUTC", function(module, exports) {

$parcel$export(module.exports, "getJsonTransformer", () => $1e3b0e06a3a99668$export$437c449f44600e71);
$parcel$export(module.exports, "getHtmlOverrideFieldTransformerOld", () => $1e3b0e06a3a99668$export$3ce922203698bede);
$parcel$export(module.exports, "getHtmlOverrideFieldTransformer", () => $1e3b0e06a3a99668$export$bd0e12633e105768);

var $7WQX3 = parcelRequire("7WQX3");

var $a8ec6 = parcelRequire("a8ec6");

var $klRja = parcelRequire("klRja");
const $1e3b0e06a3a99668$var$FIELD_DATA_TRANSFORMERS = {
    assignee: (0, $klRja.assigneeFieldTransformer),
    creator: (0, $klRja.creatorFieldTransformer),
    'com.atlassian.servicedesk:sd-sla-field': (0, $a8ec6.SlaFieldTransformer),
    status: (0, $klRja.statusFieldTransformer),
    issuetype: (0, $klRja.issueTypeTransformer),
    priority: (0, $klRja.priorityTransformerNew),
    reporter: (0, $klRja.reporterFieldTransformer),
    summary: (0, $klRja.summaryFieldTransformer),
    labels: (0, $klRja.labelsFieldTransformer),
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype': (0, $a8ec6.serviceEntityFieldTransformer),
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': (0, $a8ec6.cmdbFieldTransformer),
    'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype': (0, $a8ec6.respondersFieldTransformer),
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': (0, $a8ec6.majorIncidentFieldTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker': (0, $a8ec6.multiUserPickerTransformer),
    'com.atlassian.servicedesk:sd-request-participants': (0, $klRja.requestParticipantsPickerTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes': (0, $a8ec6.multiCheckBoxesFieldTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect': (0, $a8ec6.multiSelectFieldTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion': (0, $a8ec6.multiVersionFieldTransformer),
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker': (0, $a8ec6.multiGroupPickerTransformer),
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement': (0, $a8ec6.entitlementFieldTransformer),
    'com.atlassian.servicedesk.sentiment:sd-sentiment': (0, $a8ec6.sentimentFieldTransformer),
    'com.atlassian.servicedesk.customer-context:sd-csm-organization': (0, $a8ec6.organizationFieldTransformer)
};
const $1e3b0e06a3a99668$export$437c449f44600e71 = (fieldType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FieldDataTransformers'.
    const transformer = $1e3b0e06a3a99668$var$FIELD_DATA_TRANSFORMERS[fieldType];
    return transformer;
};
const $1e3b0e06a3a99668$var$HTML_OVERRIDE_TRANSFORMERS_OLD = {
    issuekey: (0, $klRja.issueKeyTransformer),
    priority: (0, $klRja.priorityTransformer)
};
const $1e3b0e06a3a99668$var$HTML_OVERRIDE_TRANSFORMERS = {
    issuekey: (0, $klRja.issueKeyTransformer),
    statusCategory: (0, $klRja.statusCategoryTransformer)
};
const $1e3b0e06a3a99668$export$3ce922203698bede = (fieldType)=>(0, $7WQX3.getFieldTypesToOverrideHtmlDataForAsSetOld)().has(fieldType) ? $1e3b0e06a3a99668$var$HTML_OVERRIDE_TRANSFORMERS_OLD[fieldType] : undefined;
const $1e3b0e06a3a99668$export$bd0e12633e105768 = (fieldType)=>(0, $7WQX3.getFieldTypesToOverrideHtmlDataForAsSet)().has(fieldType) ? $1e3b0e06a3a99668$var$HTML_OVERRIDE_TRANSFORMERS[fieldType] : undefined;

});
parcelRegister("a8ec6", function(module, exports) {

$parcel$export(module.exports, "SlaFieldTransformer", () => $36554a6626af8125$export$631ca5fe503ed873);
$parcel$export(module.exports, "serviceEntityFieldTransformer", () => $36554a6626af8125$export$71a2c8878bbf90c0);
$parcel$export(module.exports, "cmdbFieldTransformer", () => $36554a6626af8125$export$29b1e5041a029737);
$parcel$export(module.exports, "respondersFieldTransformer", () => $36554a6626af8125$export$7cbfbf5c2db25ae9);
$parcel$export(module.exports, "majorIncidentFieldTransformer", () => $36554a6626af8125$export$61023cbab62d778a);
$parcel$export(module.exports, "multiCheckBoxesFieldTransformer", () => $36554a6626af8125$export$ff4e3a9e8bd4c54e);
$parcel$export(module.exports, "multiSelectFieldTransformer", () => $36554a6626af8125$export$b2cbc32d83bc65fc);
$parcel$export(module.exports, "multiUserPickerTransformer", () => $36554a6626af8125$export$80f3565c0e85deed);
$parcel$export(module.exports, "multiVersionFieldTransformer", () => $36554a6626af8125$export$63aceefa091c51d7);
$parcel$export(module.exports, "multiGroupPickerTransformer", () => $36554a6626af8125$export$4ae5e1efce8cc8a3);
$parcel$export(module.exports, "entitlementFieldTransformer", () => $36554a6626af8125$export$38764a4ff2cdd62e);
$parcel$export(module.exports, "sentimentFieldTransformer", () => $36554a6626af8125$export$2a202309361bd23b);
$parcel$export(module.exports, "organizationFieldTransformer", () => $36554a6626af8125$export$7705af841a48f502);

var $8RQlO = parcelRequire("8RQlO");
var $2InI0 = parcelRequire("2InI0");
var $iux1t = parcelRequire("iux1t");

var $hT96M = parcelRequire("hT96M");
var $6pRIG = parcelRequire("6pRIG");

var $hWeHP = parcelRequire("hWeHP");

var $eSnSE = parcelRequire("eSnSE");

var $lRq8t = parcelRequire("lRq8t");



var $2cfd4 = parcelRequire("2cfd4");

var $c9f6v = parcelRequire("c9f6v");

var $3SoUO = parcelRequire("3SoUO");
const $36554a6626af8125$var$LOCATION = 'servicedesk.queues.selectors.fields-transformers.json-fields.custom-fields';
const $36554a6626af8125$var$checkCycleValidity = (cycle)=>{
    const { remainingTime: remainingTime, goalDuration: goalDuration, elapsedTime: elapsedTime } = cycle;
    const undefinedValues = [];
    if (!remainingTime) undefinedValues.push('remainingTime');
    if (!goalDuration) undefinedValues.push('goalDuration');
    if (!elapsedTime) undefinedValues.push('elapsedTime');
    return undefinedValues;
};
const $36554a6626af8125$var$isCompletedCycleValid = (cycle)=>{
    const undefinedValues = $36554a6626af8125$var$checkCycleValidity(cycle);
    if (undefinedValues.length > 0) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData($36554a6626af8125$var$LOCATION, `[FD-4303] CompletedCycle data is invalid: ${String(undefinedValues)}`);
        return false;
    }
    return true;
};
const $36554a6626af8125$var$isOngoingCycleValid = (cycle)=>{
    const undefinedValues = $36554a6626af8125$var$checkCycleValidity(cycle);
    if (undefinedValues.length > 0) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData($36554a6626af8125$var$LOCATION, `[FD-4303] OngoingCycle data is invalid: ${String(undefinedValues)}`);
        return false;
    }
    return true;
};
const $36554a6626af8125$var$getLastCompletedCycle = (completedCycles)=>{
    let lastCompletedCycle = completedCycles[0];
    completedCycles.forEach((cycle)=>{
        if (cycle.stopTime.epochMillis > lastCompletedCycle.stopTime.epochMillis) lastCompletedCycle = cycle;
    });
    return lastCompletedCycle;
};
const $36554a6626af8125$var$getDays = (timezone)=>{
    const date = (0, $6pRIG.default)(new Date(), timezone);
    return [
        (0, $2InI0.default)(date),
        (0, $2InI0.default)((0, $8RQlO.default)(date, 1)),
        (0, $2InI0.default)((0, $iux1t.default)(date, 1))
    ];
};
// This shall be deleted when localised time shown feature is fully rolled out
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $36554a6626af8125$var$getMatchingDay = (receivedDate, timezone, formatMessage)=>{
    const [today, tomorrow, yesterday] = $36554a6626af8125$var$getDays(timezone);
    const isSame = (dateOne, dateTwo)=>dateOne.getDate() === dateTwo.getDate() && dateOne.getMonth() === dateTwo.getMonth() && dateOne.getFullYear() === dateTwo.getFullYear();
    const isToday = isSame(today, receivedDate);
    const isTomorrow = isSame(tomorrow, receivedDate);
    const isYesterday = isSame(yesterday, receivedDate);
    let defaultDayFormat = (0, $hT96M.default)(receivedDate, 'd MMM');
    isToday && (defaultDayFormat = formatMessage((0, $3SoUO.default).today));
    isTomorrow && (defaultDayFormat = formatMessage((0, $3SoUO.default).tomorrow));
    isYesterday && (defaultDayFormat = formatMessage((0, $3SoUO.default).yesterday));
    return defaultDayFormat;
};
const $36554a6626af8125$export$9015300e6978c54b = (timeInEpochMillis, userTimezone, formatMessage)=>{
    if (timeInEpochMillis) {
        const breachTimeTz = (0, $6pRIG.default)(timeInEpochMillis, userTimezone);
        return `${$36554a6626af8125$var$getMatchingDay(breachTimeTz, userTimezone, formatMessage)} ${(0, $hT96M.default)(breachTimeTz, 'hh:mm a', {
            timeZone: userTimezone
        })}`;
    }
    return '';
};
const $36554a6626af8125$export$631ca5fe503ed873 = ({ storedValue: storedValue })=>{
    const { value: responseValue } = storedValue;
    const [{ data: loggedInUser }] = (0, $c9f6v.useUserSubscriber)();
    const metaTimezone = (0, $hWeHP.default)('ajs-user-timezone');
    const defaultTimezone = 'America/Toronto';
    const userTimezone = loggedInUser?.timeZone || metaTimezone || defaultTimezone;
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $lRq8t.default)();
    let locale = (0, $2cfd4.useLocale)();
    if (locale === undefined) locale = 'en_US';
    const localeString = locale.replace('_', '-');
    const dateTimeFormat = new Intl.DateTimeFormat(localeString, {
        hour: 'numeric'
    });
    const isBrowserLocale24h = ()=>!dateTimeFormat.format(0).match(/[A/P]M/);
    const getMatchingDayForLocale = (receivedDate, timeInEpochMillis)=>{
        const [today, tomorrow, yesterday] = $36554a6626af8125$var$getDays(userTimezone);
        const isSame = (dateOne, dateTwo)=>dateOne.getDate() === dateTwo.getDate() && dateOne.getMonth() === dateTwo.getMonth() && dateOne.getFullYear() === dateTwo.getFullYear();
        const isToday = isSame(today, receivedDate);
        const isTomorrow = isSame(tomorrow, receivedDate);
        const isYesterday = isSame(yesterday, receivedDate);
        let defaultDayFormat = formatDate(timeInEpochMillis, {
            timeZone: userTimezone,
            day: '2-digit',
            month: 'short'
        });
        isToday && (defaultDayFormat = formatMessage((0, $3SoUO.default).today));
        isTomorrow && (defaultDayFormat = formatMessage((0, $3SoUO.default).tomorrow));
        isYesterday && (defaultDayFormat = formatMessage((0, $3SoUO.default).yesterday));
        return defaultDayFormat;
    };
    const getTimeInSlaFriendlierFormatForLocale = (timeInEpochMillis)=>{
        if (timeInEpochMillis) {
            const breachTimeTz = (0, $6pRIG.default)(timeInEpochMillis, userTimezone);
            return `${getMatchingDayForLocale(breachTimeTz, timeInEpochMillis)} ${formatDate(timeInEpochMillis, {
                hour12: !isBrowserLocale24h(),
                timeZone: userTimezone,
                hour: '2-digit',
                minute: '2-digit'
            })}`;
        }
        return '';
    };
    const getTimeRemainingInMinutes = (timeInHourSpaceMinutes)=>{
        const isTimeInMinus = timeInHourSpaceMinutes.indexOf('-') === 0;
        const absoluteTime = isTimeInMinus ? timeInHourSpaceMinutes.substring(1) : timeInHourSpaceMinutes;
        const millis = parseInt(absoluteTime, 10);
        const totalMinutes = millis / 60000;
        return isTimeInMinus ? -1 * totalMinutes : totalMinutes;
    };
    const getPercentageOfTimeTaken = (goalTime, remainingTime)=>{
        const goalTimeInMinutes = getTimeRemainingInMinutes(goalTime);
        const remainingTimeInMinutes = getTimeRemainingInMinutes(remainingTime);
        let percentage = (goalTimeInMinutes - remainingTimeInMinutes) / goalTimeInMinutes;
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number'.
        percentage = (percentage * 100).toFixed(2);
        // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
        return Math.round(parseInt(percentage, 10)).toString();
    };
    const getBreachTimeInLocalStringForLocale = (breachTimeInEpochMillis)=>{
        if (breachTimeInEpochMillis) {
            const BREACH_DATE = (0, $6pRIG.default)(breachTimeInEpochMillis, userTimezone);
            return `${formatDate(breachTimeInEpochMillis, {
                hour12: !isBrowserLocale24h(),
                timeZone: userTimezone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })} GMT${(0, $hT96M.default)(BREACH_DATE, 'xx', {
                timeZone: userTimezone
            })}`;
        }
        return `${formatMessage((0, $3SoUO.default).notApplicable)}`;
    };
    const getHoverContent = (closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly)=>{
        const isTimeInMinus = remainingTimeFriendly.indexOf('-') === 0;
        let remainingTimeString;
        let timeStatus;
        if (isTimeInMinus) {
            remainingTimeString = remainingTimeFriendly.substring(1);
            timeStatus = formatMessage((0, $3SoUO.default).past);
        } else {
            remainingTimeString = remainingTimeFriendly;
            timeStatus = formatMessage((0, $3SoUO.default).left);
        }
        if (closed === true) {
            timeStatus = isTimeInMinus ? formatMessage((0, $3SoUO.default).breached) : formatMessage((0, $3SoUO.default).met);
            const percentage = getPercentageOfTimeTaken(goalTimeMillis, remainingTimeMillis);
            const hoverContentCompleted = `${isTimeInMinus ? `-${remainingTimeString}` : remainingTimeString} ${timeStatus ?? ''} ${String.fromCodePoint(0x2022)} ${percentage}% of ${goalTimeLongFriendly} ${String.fromCodePoint(0x2022)} ${getBreachTimeInLocalStringForLocale(breachTime)}`;
            return hoverContentCompleted;
        }
        const hoverContent = `${remainingTimeString} ${timeStatus ?? ''} ${String.fromCodePoint(0x2022)} ${formatMessage((0, $3SoUO.default).due) ?? ''}: ${getBreachTimeInLocalStringForLocale(breachTime)}`;
        return hoverContent;
    };
    const friendlierHoverContent = (closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly, slaDisplayFormat)=>slaDisplayFormat === (0, $625973d79d814c58$export$13ecaaf97b049384) ? getHoverContent(closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly) : undefined;
    // @ts-expect-error - TS2339 - Property 'errorMessage' does not exist on type 'Sla | SlaError'.
    if (responseValue && responseValue.errorMessage) return {
        fieldType: (0, $9f37490eed0e5ebb$export$f790c24298ed441b),
        value: responseValue
    };
    if (responseValue && // @ts-expect-error - TS2339 - Property 'ongoingCycle' does not exist on type 'Sla | SlaError'.
    responseValue.ongoingCycle && // @ts-expect-error - TS2339 - Property 'ongoingCycle' does not exist on type 'Sla | SlaError'.
    $36554a6626af8125$var$isOngoingCycleValid(responseValue.ongoingCycle)) {
        const { paused: paused, remainingTime: remainingTime, breached: breached, breachTime: breachTime, goalDuration: goalDuration, elapsedTime: elapsedTime, withinCalendarHours: withinCalendarHours } = responseValue.ongoingCycle;
        const slaDisplayFormat = // @ts-expect-error - TS2339 - Property 'slaDisplayFormat' does not exist on type 'Sla | SlaError'.
        responseValue.slaDisplayFormat ?? (0, $625973d79d814c58$export$13ecaaf97b049384);
        // When an SLA is paused due to being outside of working hours, the paused value is false
        const status = paused || !withinCalendarHours ? (0, $9f37490eed0e5ebb$export$3ad39751a33c16b8) : (0, $9f37490eed0e5ebb$export$d1917132a74c7b93);
        const timeRemainingInMinutes = Math.floor(remainingTime.millis / 60000);
        const breachTimeFriendly = breachTime ? breachTime.friendly : undefined;
        const timeInFriendlyFormat = ()=>getTimeInSlaFriendlierFormatForLocale(breachTime?.epochMillis).toString();
        return {
            fieldType: (0, $9f37490eed0e5ebb$export$f790c24298ed441b),
            value: {
                status: status,
                timeRemainingFriendly: slaDisplayFormat === (0, $625973d79d814c58$export$13ecaaf97b049384) ? timeInFriendlyFormat() : remainingTime.friendly,
                isBreached: breached,
                timeRemainingInMinutes: timeRemainingInMinutes,
                breachTime: breachTimeFriendly,
                elapsedTime: elapsedTime.friendly,
                goalDuration: goalDuration.friendly,
                withinCalendarHours: withinCalendarHours,
                hoverContent: friendlierHoverContent(false, `${remainingTime.millis}`, breachTime?.epochMillis, goalDuration.millis, goalDuration.friendly, remainingTime.friendly, slaDisplayFormat),
                slaDisplayFormat: slaDisplayFormat
            }
        };
    }
    if (responseValue && // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
    responseValue.completedCycles && // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
    responseValue.completedCycles.length !== 0) {
        const slaDisplayFormat = // @ts-expect-error - TS2339 - Property 'slaDisplayFormat' does not exist on type 'Sla | SlaError'.
        responseValue.slaDisplayFormat ?? (0, $625973d79d814c58$export$13ecaaf97b049384);
        // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
        const lastCompletedCycle = $36554a6626af8125$var$getLastCompletedCycle(responseValue.completedCycles);
        if (!$36554a6626af8125$var$isCompletedCycleValid(lastCompletedCycle)) return {
            fieldType: (0, $9f37490eed0e5ebb$export$f790c24298ed441b)
        };
        const timeRemainingInMinutes = Math.floor(lastCompletedCycle.remainingTime.millis / 60000);
        const { remainingTime: remainingTime, breached: breached, goalDuration: goalDuration, elapsedTime: elapsedTime, stopTime: stopTime, breachTime: breachTime } = lastCompletedCycle;
        const timeInFriendlyFormat = ()=>getTimeInSlaFriendlierFormatForLocale(stopTime.epochMillis).toString();
        return {
            fieldType: (0, $9f37490eed0e5ebb$export$f790c24298ed441b),
            value: {
                status: (0, $9f37490eed0e5ebb$export$fc332a617fd34192),
                timeRemainingFriendly: slaDisplayFormat === (0, $625973d79d814c58$export$13ecaaf97b049384) ? timeInFriendlyFormat() : remainingTime.friendly,
                isBreached: breached,
                timeRemainingInMinutes: timeRemainingInMinutes,
                // A completed cycle doesn't have a breachTime value
                breachTime: undefined,
                elapsedTime: elapsedTime.friendly,
                goalDuration: goalDuration.friendly,
                withinCalendarHours: undefined,
                hoverContent: friendlierHoverContent(true, `${remainingTime.millis}`, breachTime?.epochMillis, `${goalDuration.millis}`, goalDuration.friendly, remainingTime.friendly, slaDisplayFormat),
                slaDisplayFormat: slaDisplayFormat
            }
        };
    }
    return {
        fieldType: (0, $9f37490eed0e5ebb$export$f790c24298ed441b)
    };
};
const $36554a6626af8125$export$71a2c8878bbf90c0 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $9f37490eed0e5ebb$export$991960fb6e9ea7dd),
        value: value ? value.map((obj)=>({
                id: obj.id,
                name: obj.name
            })) : []
    });
const $36554a6626af8125$export$29b1e5041a029737 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $9f37490eed0e5ebb$export$b84257e6dcaab24d),
        value: value
    });
const $36554a6626af8125$export$7cbfbf5c2db25ae9 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $9f37490eed0e5ebb$export$dd2fa454b47497da),
        value: value
    });
const $36554a6626af8125$export$61023cbab62d778a = ({ storedValue: { value: value } })=>({
        fieldType: (0, $9f37490eed0e5ebb$export$f0f60e2d773695fc),
        value: value
    });
const $36554a6626af8125$export$ff4e3a9e8bd4c54e = ({ storedValue: { value: value } })=>({
        fieldType: (0, $9f37490eed0e5ebb$export$d8fae0f9b622e615),
        value: value || []
    });
const $36554a6626af8125$export$b2cbc32d83bc65fc = ({ storedValue: { value: value } })=>({
        fieldType: (0, $9f37490eed0e5ebb$export$155ae54d06c908ea),
        value: value || []
    });
const $36554a6626af8125$export$80f3565c0e85deed = ({ storedValue: { value: value } })=>({
        fieldType: (0, $9f37490eed0e5ebb$export$2ddc21f5fedfaf92),
        value: value ? value.map((user)=>({
                name: user.displayName,
                email: user.emailAddress,
                avatarUrl: user.avatarUrls['48x48']
            })) : []
    });
const $36554a6626af8125$export$63aceefa091c51d7 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $9f37490eed0e5ebb$export$5ae60777f05f3dfa),
        value: value ? value.map((version)=>({
                value: version.name,
                self: version.self,
                id: version.id
            })) : []
    });
const $36554a6626af8125$export$4ae5e1efce8cc8a3 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $9f37490eed0e5ebb$export$734a41c9fe85799a),
        value: value ? value.map((group)=>({
                value: group.name,
                self: group.self,
                id: group.groupId
            })) : []
    });
const $36554a6626af8125$export$38764a4ff2cdd62e = ({ storedValue: { value: value } })=>({
        fieldType: (0, $9f37490eed0e5ebb$export$80b6ff34fe6a6e00),
        value: value
    });
const $36554a6626af8125$export$2a202309361bd23b = ({ storedValue: { value: value } })=>({
        fieldType: (0, $9f37490eed0e5ebb$export$37cb0de8d249ef22),
        value: value
    });
const $36554a6626af8125$export$7705af841a48f502 = ({ storedValue: { value: value } })=>({
        fieldType: (0, $9f37490eed0e5ebb$export$a370b4fb11e50a66),
        value: value
    });

});
const $9f37490eed0e5ebb$export$d1917132a74c7b93 = 'ONGOING';
const $9f37490eed0e5ebb$export$fc332a617fd34192 = 'COMPLETED';
const $9f37490eed0e5ebb$export$3ad39751a33c16b8 = 'PAUSED';
const $9f37490eed0e5ebb$export$f790c24298ed441b = 'com.atlassian.servicedesk:sd-sla-field';
const $9f37490eed0e5ebb$export$991960fb6e9ea7dd = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $9f37490eed0e5ebb$export$b84257e6dcaab24d = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $9f37490eed0e5ebb$export$dd2fa454b47497da = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $9f37490eed0e5ebb$export$f0f60e2d773695fc = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $9f37490eed0e5ebb$export$794539092c70e595 = 'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype';
const $9f37490eed0e5ebb$export$2ddc21f5fedfaf92 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $9f37490eed0e5ebb$export$d8fae0f9b622e615 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $9f37490eed0e5ebb$export$155ae54d06c908ea = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $9f37490eed0e5ebb$export$5ae60777f05f3dfa = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $9f37490eed0e5ebb$export$734a41c9fe85799a = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $9f37490eed0e5ebb$export$80b6ff34fe6a6e00 = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $9f37490eed0e5ebb$export$37cb0de8d249ef22 = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $9f37490eed0e5ebb$export$a370b4fb11e50a66 = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';

const $625973d79d814c58$export$aad60a8e044b5914 = 'OLD_SLA_FORMAT';
const $625973d79d814c58$export$13ecaaf97b049384 = 'NEW_SLA_FORMAT';

parcelRegister("3SoUO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2f0e43d6e0d99dc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e2f0e43d6e0d99dc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.title",
        "defaultMessage": "SLAs"
    },
    past: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.past",
        "defaultMessage": "past"
    },
    left: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.left",
        "defaultMessage": "left"
    },
    met: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.met",
        "defaultMessage": "met"
    },
    breached: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.breached",
        "defaultMessage": "breached"
    },
    due: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.due",
        "defaultMessage": "Due"
    },
    today: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.today",
        "defaultMessage": "Today"
    },
    tomorrow: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.tomorrow",
        "defaultMessage": "Tomorrow"
    },
    yesterday: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.yesterday",
        "defaultMessage": "Yesterday"
    },
    notApplicable: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.not-applicable",
        "defaultMessage": "Breach time not found"
    }
});

});


parcelRegister("klRja", function(module, exports) {

$parcel$export(module.exports, "assigneeFieldTransformer", () => $3632e07cc0551206$export$c06a1d947706df0d);
$parcel$export(module.exports, "creatorFieldTransformer", () => $3632e07cc0551206$export$e084c35a52aac478);
$parcel$export(module.exports, "issueKeyTransformer", () => $3632e07cc0551206$export$f2658e11d37b4233);
$parcel$export(module.exports, "priorityTransformer", () => $3632e07cc0551206$export$c94a7bc669e96e93);
$parcel$export(module.exports, "priorityTransformerNew", () => $3632e07cc0551206$export$9629f830d8d055d6);
$parcel$export(module.exports, "statusCategoryTransformer", () => $3632e07cc0551206$export$83a524f00f1402c);
$parcel$export(module.exports, "issueTypeTransformer", () => $3632e07cc0551206$export$fb98dd6a5625192e);
$parcel$export(module.exports, "statusFieldTransformer", () => $3632e07cc0551206$export$72090e970546b9fd);
$parcel$export(module.exports, "reporterFieldTransformer", () => $3632e07cc0551206$export$e3cfac85b17dd6f4);
$parcel$export(module.exports, "summaryFieldTransformer", () => $3632e07cc0551206$export$7eadf4b26c5ed08);
$parcel$export(module.exports, "labelsFieldTransformer", () => $3632e07cc0551206$export$6e9eafdaf42a340d);
$parcel$export(module.exports, "requestParticipantsPickerTransformer", () => $3632e07cc0551206$export$1d7e6e4518ca808f);


var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");
const $3632e07cc0551206$var$onChangeAssignee = (originalStoredValue, storedFieldUpdater)=>(issueKey, newValue)=>{
        let newValueReverseTransformed = null;
        if (newValue) {
            const { displayName: displayName, avatarUrl: avatarUrl, accountId: accountId, emailAddress: emailAddress } = newValue;
            newValueReverseTransformed = {
                displayName: displayName,
                avatarUrls: {
                    '48x48': avatarUrl
                },
                accountId: accountId,
                emailAddress: emailAddress
            };
        }
        storedFieldUpdater({
            value: newValueReverseTransformed
        }, originalStoredValue);
    };
const $3632e07cc0551206$export$c06a1d947706df0d = ({ storedValue: storedValue, storedFieldUpdater: storedFieldUpdater })=>{
    const { isEditable: isEditable, value: responseValue } = storedValue;
    let value;
    if (responseValue) {
        const { accountId: accountId, emailAddress: emailAddress, displayName: displayName, avatarUrls: { '48x48': avatarUrl } } = responseValue;
        value = {
            displayName: displayName,
            avatarUrl: avatarUrl,
            accountId: accountId,
            emailAddress: emailAddress
        };
    }
    return {
        fieldType: 'assignee',
        value: value,
        key: responseValue ? responseValue.key : undefined,
        isEditable: isEditable,
        onChange: $3632e07cc0551206$var$onChangeAssignee(storedValue, storedFieldUpdater)
    };
};
const $3632e07cc0551206$export$e084c35a52aac478 = ({ storedValue: storedValue })=>{
    const { value: { accountId: accountId, emailAddress: emailAddress, displayName: displayName, avatarUrls: { '48x48': avatarUrl } } } = storedValue;
    const value = {
        displayName: displayName,
        avatarUrl: avatarUrl,
        accountId: accountId,
        emailAddress: emailAddress
    };
    return {
        fieldType: 'creator',
        value: value
    };
};
const $3632e07cc0551206$export$f2658e11d37b4233 = (issue)=>({
        fieldType: 'issuekey',
        value: issue.key
    });
const $3632e07cc0551206$export$c94a7bc669e96e93 = (issue)=>{
    const parser = new DOMParser();
    // @ts-expect-error: Property 'fieldAsHtml' does not exist on type 'ResponseField'.
    const doc = parser.parseFromString(issue.fields.priority.fieldAsHtml, 'text/html');
    const priorityHtml = doc.querySelector('img');
    if (!priorityHtml) return {
        fieldType: 'priority',
        value: undefined
    };
    return {
        fieldType: 'priority',
        value: {
            name: priorityHtml.title,
            iconUrl: priorityHtml.src
        }
    };
};
const $3632e07cc0551206$export$9629f830d8d055d6 = ({ storedValue: storedValue })=>{
    const { value: value } = storedValue;
    if (!value) return {
        fieldType: 'priority',
        value: undefined
    };
    return {
        fieldType: 'priority',
        value: {
            name: value.name,
            iconUrl: value.iconUrl
        }
    };
};
const $3632e07cc0551206$var$matchCssClassToStatusCategory = (cssClass)=>{
    switch(cssClass){
        case 'jira-issue-status-lozenge-green':
            return 'done';
        case 'jira-issue-status-lozenge-yellow':
            return 'inProgress';
        default:
            return 'toDo';
    }
};
const $3632e07cc0551206$var$handleStatusCategoryTransformerError = (errorMsg)=>{
    (0, $gYnSx.default)({
        meta: {
            id: 'statusCategoryTransformer',
            packageName: 'servicedeskQueuesCommon',
            teamName: 'jsd-shield'
        },
        error: new Error(errorMsg),
        sendToPrivacyUnsafeSplunk: true
    });
    return {
        fieldType: 'statusCategory',
        value: undefined
    };
};
const $3632e07cc0551206$export$83a524f00f1402c = (_, field)=>{
    // we are sure that if we are in this transformer that fieldAsHtml will exist
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const htmlString = field.fieldAsHtml;
    if (!htmlString) return $3632e07cc0551206$var$handleStatusCategoryTransformerError('Status category field not found in html format');
    // the regex to capture the value in between the span tag eg. >In Progress<
    const categoryNameRegex = />(.*)</;
    const categoryName = htmlString.match(categoryNameRegex);
    // only 3 status categories exist: todo, in progress and done
    const categoryCssRegex = /jira-issue-status-lozenge-(blue-gray|yellow|green)/;
    const categoryCssMatch = htmlString.match(categoryCssRegex);
    if (!categoryName) return $3632e07cc0551206$var$handleStatusCategoryTransformerError('Could not extract status category name from html');
    // technically we don't need to match the CSS to determine the lozenge style
    // since we know the categories are predefined already but doing it just in case
    if (!categoryCssMatch) return $3632e07cc0551206$var$handleStatusCategoryTransformerError('Could not extract status category styles from html');
    return {
        fieldType: 'statusCategory',
        value: {
            name: categoryName[1],
            category: $3632e07cc0551206$var$matchCssClassToStatusCategory(categoryCssMatch[0])
        }
    };
};
const $3632e07cc0551206$var$onChangeStatus = (originalStoredValue, storedFieldUpdater)=>(issueKey, newValue)=>{
        let newValueReverseTransformed = null;
        const { description: description, name: name, id: id, statusCategory: { id: statusCategoryId } } = newValue;
        newValueReverseTransformed = {
            id: id,
            description: description,
            name: name,
            statusCategory: {
                id: statusCategoryId
            }
        };
        storedFieldUpdater({
            value: newValueReverseTransformed
        }, originalStoredValue);
    };
const $3632e07cc0551206$export$fb98dd6a5625192e = ({ storedValue: storedValue })=>{
    const { value: { name: name, iconUrl: iconUrl, description: description } } = storedValue;
    const value = {
        name: name,
        iconUrl: iconUrl,
        description: description
    };
    return {
        fieldType: 'issuetype',
        value: value
    };
};
const $3632e07cc0551206$export$72090e970546b9fd = ({ storedValue: storedValue, storedFieldUpdater: storedFieldUpdater })=>{
    const { value: { id: id, name: name, description: description, statusCategory: { id: statusCategoryId } }, isEditable: isEditable } = storedValue;
    const value = {
        id: id,
        name: name,
        description: description,
        statusCategory: {
            id: statusCategoryId
        }
    };
    return {
        key: value.id.toString(),
        fieldType: 'status',
        value: value,
        onChange: $3632e07cc0551206$var$onChangeStatus(storedValue, storedFieldUpdater),
        isEditable: isEditable
    };
};
const $3632e07cc0551206$export$e3cfac85b17dd6f4 = ({ storedValue: storedValue })=>{
    const { value: value } = storedValue;
    if (!value) return {
        fieldType: 'reporter',
        value: null
    };
    const { displayName: displayName, emailAddress: emailAddress, active: active } = value;
    const transformedValue = {
        displayName: displayName,
        emailAddress: emailAddress,
        active: !!active
    };
    return {
        fieldType: 'reporter',
        value: transformedValue
    };
};
const $3632e07cc0551206$export$7eadf4b26c5ed08 = ({ storedValue: storedValue })=>({
        fieldType: 'summary',
        value: storedValue.value
    });
const $3632e07cc0551206$export$6e9eafdaf42a340d = ({ storedValue: storedValue })=>({
        fieldType: 'labels',
        value: storedValue.value.map((label)=>({
                name: label,
                href: (0, $7jTnu.fg)('jql_fix_for_queue_labels_with_special_chars') ? `/issues/?jql=${encodeURIComponent(`labels = "${label.replace(/"/g, '\\"')}"`)}` : `/issues/?jql=labels+%3D+${label}`
            }))
    });
const $3632e07cc0551206$export$1d7e6e4518ca808f = ({ storedValue: { value: value } })=>({
        fieldType: (0, $ec619a2fc20bcfda$export$e918afe651ac9e7a),
        value: value ? value.map((user)=>({
                name: user.displayName,
                email: user.emailAddress,
                avatarUrl: user.avatarUrls['48x48']
            })) : []
    });

});
const $ec619a2fc20bcfda$export$e918afe651ac9e7a = 'com.atlassian.servicedesk:sd-request-participants';







parcelRegister("4LfWe", function(module, exports) {

$parcel$export(module.exports, "getSortedByColumn", () => $f0c1d43b77237a1e$export$89e3e8c1d19874d1);
$parcel$export(module.exports, "getSortFieldType", () => $f0c1d43b77237a1e$export$8d69ea9f7db079ef);
$parcel$export(module.exports, "getSortOrder", () => $f0c1d43b77237a1e$export$c11dbba94a24125);
$parcel$export(module.exports, "isManuallySorted", () => $f0c1d43b77237a1e$export$abe45b95ac16d893);
$parcel$export(module.exports, "getIsAscendingOrder", () => $f0c1d43b77237a1e$export$19e36eff55595869);
// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.

var $ljsRg = parcelRequire("ljsRg");


var $lc49q = parcelRequire("lc49q");

var $6I1gv = parcelRequire("6I1gv");
const $f0c1d43b77237a1e$var$maybeManualSorting = (state)=>{
    const queue = (0, $6I1gv.getCurrentQueue)(state);
    return (0, $ljsRg.Maybe).fromNull(queue && queue.manualSorting || (0, $lc49q.getQueuePageData)(state).manualSorting);
};
const $f0c1d43b77237a1e$export$89e3e8c1d19874d1 = (state)=>$f0c1d43b77237a1e$var$maybeManualSorting(state)// @ts-expect-error - TS7006 - Parameter 'manualSorting' implicitly has an 'any' type.
    .map((manualSorting)=>manualSorting.sortedBy).orSome(undefined);
const $f0c1d43b77237a1e$export$8d69ea9f7db079ef = (state)=>{
    const sortedColumn = (0, $lc49q.getColumns)(state).find((column)=>Boolean(column.currentSorting));
    return sortedColumn ? sortedColumn.fieldType : undefined;
};
const $f0c1d43b77237a1e$export$c11dbba94a24125 = (state)=>$f0c1d43b77237a1e$var$maybeManualSorting(state)// @ts-expect-error - TS7006 - Parameter 'manualSorting' implicitly has an 'any' type.
    .map((manualSorting)=>manualSorting.sortOrder).orSome((0, $4ec7ec7f2cfbc873$export$1dee026a19752d6b));
const $f0c1d43b77237a1e$export$abe45b95ac16d893 = (state)=>$f0c1d43b77237a1e$export$89e3e8c1d19874d1(state) !== undefined;
const $f0c1d43b77237a1e$export$19e36eff55595869 = (state)=>$f0c1d43b77237a1e$export$c11dbba94a24125(state) === (0, $4ec7ec7f2cfbc873$export$1dee026a19752d6b);

});
const $4ec7ec7f2cfbc873$export$1dee026a19752d6b = 'ASC';
const $4ec7ec7f2cfbc873$export$b6abcf7fa1d94f65 = 'DESC';
const $4ec7ec7f2cfbc873$export$c53d0f541b41b88e = 'NONE';


parcelRegister("baH07", function(module, exports) {

$parcel$export(module.exports, "getSsrIssueList", () => $192af59d2e8fbaa8$export$b00c26bb659fae04);
$parcel$export(module.exports, "getIsInitialLoad", () => $192af59d2e8fbaa8$export$f4ff973e05a3a506);
$parcel$export(module.exports, "getSsrIssuesError", () => $192af59d2e8fbaa8$export$7d0b4d99fd869d11);
$parcel$export(module.exports, "getSsrQueueId", () => $192af59d2e8fbaa8$export$c67727714b766ad6);
$parcel$export(module.exports, "hasSsrData", () => $192af59d2e8fbaa8$export$6f1a72637be08b54);
const $192af59d2e8fbaa8$export$b00c26bb659fae04 = (state)=>state.persisted.ssrIssuesData?.ssrIssueList;
const $192af59d2e8fbaa8$export$f4ff973e05a3a506 = (state)=>state.persisted.ssrIssuesData?.isInitialLoading;
const $192af59d2e8fbaa8$export$7d0b4d99fd869d11 = (state)=>state.persisted.ssrIssuesData?.error;
const $192af59d2e8fbaa8$export$c67727714b766ad6 = (state)=>state.persisted.ssrIssuesData?.queueId;
const $192af59d2e8fbaa8$export$6f1a72637be08b54 = (state)=>!!state.persisted.ssrIssuesData?.ssrIssueList;

});

parcelRegister("9kCRJ", function(module, exports) {

$parcel$export(module.exports, "getProjectStateHash", () => $82821b6e02556130$export$6b15279c446fd00d);
$parcel$export(module.exports, "getIssueHash", () => $82821b6e02556130$export$57f7822280b6c408);
$parcel$export(module.exports, "getSearchMode", () => $82821b6e02556130$export$918e908cac033d76);
// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.

var $ljsRg = parcelRequire("ljsRg");

var $8bvz0 = parcelRequire("8bvz0");
const $82821b6e02556130$var$maybeUpdateMetadata = (state)=>(0, $ljsRg.Maybe).fromNull((0, $8bvz0.getPersisted)(state).updateMetadata);
const $82821b6e02556130$export$6b15279c446fd00d = (state)=>$82821b6e02556130$var$maybeUpdateMetadata(state)// @ts-expect-error - TS7006 - Parameter 'updateMetadata' implicitly has an 'any' type.
    .flatMap((updateMetadata)=>(0, $ljsRg.Maybe).fromNull(updateMetadata.projectStateHash)).orSome('');
const $82821b6e02556130$export$57f7822280b6c408 = (state)=>$82821b6e02556130$var$maybeUpdateMetadata(state)// @ts-expect-error - TS7006 - Parameter 'updateMetadata' implicitly has an 'any' type.
    .flatMap((updateMetadata)=>(0, $ljsRg.Maybe).fromNull(updateMetadata.issueHash)).orSome('');
const $82821b6e02556130$export$918e908cac033d76 = (state)=>{
    return $82821b6e02556130$var$maybeUpdateMetadata(state)// @ts-expect-error - TS7006 - Parameter 'updateMetadata' implicitly has an 'any' type.
    .flatMap((updateMetadata)=>(0, $ljsRg.Maybe).fromNull(updateMetadata.searchMode)).orSome(undefined);
};

});

parcelRegister("1EACp", function(module, exports) {

$parcel$export(module.exports, "storeIssuesInLocalStorage", () => $f7f404daf994bf17$export$265b10942ef9ca4d);
$parcel$export(module.exports, "maybeIssuesInLocalStorage", () => $f7f404daf994bf17$export$889a3e4f0169c0d7);
$parcel$export(module.exports, "getIssuesInLocalStorage", () => $f7f404daf994bf17$export$a260c6806177a9f6);

var $2zs80 = parcelRequire("2zs80");

var $cSmYj = parcelRequire("cSmYj");

var $ljsRg = parcelRequire("ljsRg");

var $7kixv = parcelRequire("7kixv");

var $6uWhG = parcelRequire("6uWhG");

var $gCeeo = parcelRequire("gCeeo");

var $7WQX3 = parcelRequire("7WQX3");

var $2IsS5 = parcelRequire("2IsS5");

var $f5xwW = parcelRequire("f5xwW");

var $eOMQr = parcelRequire("eOMQr");

var $53tjX = parcelRequire("53tjX");
const $f7f404daf994bf17$var$ISSUES_KEY = 'issues';
const $f7f404daf994bf17$var$getLocalStorageData = (queueId)=>(0, $ljsRg.Maybe).fromNull((0, $eOMQr.getFromLocalStorage)(`${$f7f404daf994bf17$var$ISSUES_KEY}_${(0, $2IsS5.fromQueueId)(queueId)}`));
const $f7f404daf994bf17$var$localStorageMatchesIssueListResponse = (localStorage, issueListResponse, jql, sortedBy, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
sortOrder)=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(localStorage.jql, jql) && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(localStorage.issueListResponse.issueHash, issueListResponse.issueHash) && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(localStorage.issueListResponse.columns, issueListResponse.columns) && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(localStorage.sortedBy, sortedBy) && (!sortedBy || (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(localStorage.sortOrder, sortOrder));
const $f7f404daf994bf17$export$265b10942ef9ca4d = (issueListResponse, jql, queueId, sortedBy, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
sortOrder, isUpdate, createAnalyticsEvent)=>{
    if (!isUpdate) {
        const localStorageData = $f7f404daf994bf17$var$getLocalStorageData(queueId);
        const hasData = localStorageData.isSome();
        const hasLatestData = localStorageData.cata(()=>false, // @ts-expect-error - TS7006 - Parameter 'localStorage' implicitly has an 'any' type.
        (localStorage)=>$f7f404daf994bf17$var$localStorageMatchesIssueListResponse(localStorage, issueListResponse, jql, sortedBy, sortOrder));
        if (createAnalyticsEvent) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'viewQueuesLocalStorageData updated', {
            hasData: hasData,
            hasLatestData: hasLatestData
        });
    }
    (0, $eOMQr.setInLocalStorage)(`${$f7f404daf994bf17$var$ISSUES_KEY}_${(0, $2IsS5.fromQueueId)(queueId)}`, {
        jql: jql,
        issueListResponse: issueListResponse,
        jsonColumns: (0, $7WQX3.getFieldTypesEligibleForJsonData)(),
        sortedBy: sortedBy,
        sortOrder: sortOrder
    });
};
const $f7f404daf994bf17$var$localStorageMatchesStore = (localStorage, jql, columns, columnTypesAsJson, sortedBy, sortOrder, isSourceFromSort = false)=>{
    // we are still comparing the columns but disregard the sorting
    // also cache match logic determines the show of the UI loading in case of sort update
    const isColumnsMatch = !isSourceFromSort ? (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))((0, $f5xwW.transformColumnsByRemoveSortOrder)(localStorage.issueListResponse.columns), (0, $f5xwW.removeSortingFromColumns)(columns)) : (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))((0, $f5xwW.transformColumns)(localStorage.issueListResponse.columns), columns);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(localStorage.jql, jql) && isColumnsMatch && (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(localStorage.jsonColumns, columnTypesAsJson).length === 0;
};
const $f7f404daf994bf17$var$maybeIssuesInLocalStorageInternal = (queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder, isSourceFromSort)=>{
    try {
        return $f7f404daf994bf17$var$getLocalStorageData(queueId)// @ts-expect-error - TS7006 - Parameter 'localStorage' implicitly has an 'any' type.
        .map((localStorage)=>{
            if ($f7f404daf994bf17$var$localStorageMatchesStore(localStorage, jql, columns, columnTypesAsJson, sortedBy, sortOrder, isSourceFromSort)) {
                (0, $6uWhG.setMark)('jsd.performance.profile.queues.localstorage.received');
                return (0, $ljsRg.Maybe).Some((0, $53tjX.default)(localStorage.issueListResponse, (0, $2IsS5.LOCAL_STORAGE_SOURCE), filterQuery !== null, false));
            }
            return (0, $ljsRg.Maybe).None();
        }).orSome((0, $ljsRg.Maybe).None());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        return (0, $ljsRg.Maybe).None();
    }
};
const $f7f404daf994bf17$export$889a3e4f0169c0d7 = (queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder, isSourceFromSort)=>{
    const maybeIssueList = $f7f404daf994bf17$var$maybeIssuesInLocalStorageInternal(queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder, isSourceFromSort);
    return maybeIssueList;
};
const $f7f404daf994bf17$export$a260c6806177a9f6 = (queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder, isSourceFromSort)=>$f7f404daf994bf17$export$889a3e4f0169c0d7(queueId, jql, columns, columnTypesAsJson, filterQuery, sortedBy, sortOrder, isSourceFromSort).cata((0, $7kixv.Observable).empty, (0, $7kixv.Observable).of);

});
parcelRegister("53tjX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b882ea1a88a7e5a7$export$2e2bcd8739ae039);

var $f5xwW = parcelRequire("f5xwW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b882ea1a88a7e5a7$export$2e2bcd8739ae039 = (issueListResponse, source, isFilterRequested, isFiltered)=>({
        issues: (0, $f5xwW.transformIssues)(issueListResponse.issues),
        issueHash: issueListResponse.issueHash,
        totalCount: issueListResponse.total,
        columns: (0, $f5xwW.transformColumns)(issueListResponse.columns),
        isUsingDefaultSorting: issueListResponse.isUsingDefaultSorting,
        source: source,
        isFilterRequested: isFilterRequested,
        isFiltered: isFiltered
    });

});


parcelRegister("f6Yqd", function(module, exports) {

$parcel$export(module.exports, "sendIssuelistStalenessAnalytics", () => $cc47c3e10cbc10e1$export$63318741cbb194f3);
$parcel$export(module.exports, "fireInitialLoadSsrAnalyticEventWithState", () => $cc47c3e10cbc10e1$export$6ef7fec9c936098);

var $hWeHP = parcelRequire("hWeHP");

var $gCeeo = parcelRequire("gCeeo");

var $5G60L = parcelRequire("5G60L");

var $cqBpI = parcelRequire("cqBpI");
const $cc47c3e10cbc10e1$var$STALENESS_THRESHOLD_FOR_FETCH = 3600000;
const $cc47c3e10cbc10e1$var$STALENESS_THRESHOLD_FOR_UPDATE = 180000;
// @ts-expect-error - TS7006 - Parameter 'payload' implicitly has an 'any' type.
const $cc47c3e10cbc10e1$var$fireManualOperationalAnalytics = (payload)=>(0, $5G60L.getAnalyticsWebClient)().getInstance().sendOperationalEvent(payload);
const $cc47c3e10cbc10e1$export$63318741cbb194f3 = (result, isUpdate)=>{
    const { metadata: metadata } = result;
    const currentTimeInMs = Date.now();
    const delayInMs = currentTimeInMs - metadata.lastUpdatedTimeInMs;
    const thresholdInMs = isUpdate ? $cc47c3e10cbc10e1$var$STALENESS_THRESHOLD_FOR_UPDATE : $cc47c3e10cbc10e1$var$STALENESS_THRESHOLD_FOR_FETCH;
    const jiraShard = (0, $hWeHP.default)('ajs-shard') || '';
    $cc47c3e10cbc10e1$var$fireManualOperationalAnalytics({
        source: 'viewQueueScreen',
        actionSubject: 'issuelist',
        action: isUpdate ? 'updated' : 'fetched',
        attributes: {
            issuelistStale: delayInMs > thresholdInMs,
            delayInMs: delayInMs,
            currentTimeInMs: currentTimeInMs,
            thresholdInMs: thresholdInMs,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            browserTabVisibilityState: document.visibilityState,
            jiraShard: jiraShard,
            ...metadata
        }
    });
};
const $cc47c3e10cbc10e1$export$6ef7fec9c936098 = (state)=>{
    return (event)=>{
        const createAnalyticsEvent = (0, $cqBpI.getCreateAnalyticsEvent)(state);
        if (createAnalyticsEvent) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), `jsmIssueList ${event}`, {});
    };
};

});

const $33311bff5c7e8608$export$c1927396d6c152eb = 'initialLoadAll';
const $33311bff5c7e8608$export$5b6950a89e720fb7 = 'initialLoadSsrHit';
const $33311bff5c7e8608$export$932d8e2bf11ecc3d = 'initialLoadSsrError';
const $33311bff5c7e8608$export$7f8de25485f27a39 = 'initialLoadSsrTimeoutError';
const $33311bff5c7e8608$export$431f43d5c108aa95 = 'initialLoadCacheHit';
const $33311bff5c7e8608$export$57138ddc6df757ce = 'initialLoadBrowserIssueListFetch';


parcelRegister("iGYMr", function(module, exports) {

$parcel$export(module.exports, "TABLE_CHANGED", () => $12741d1e4ab3f1e6$export$68b362e6b981d575);
$parcel$export(module.exports, "tableChangedAction", () => $12741d1e4ab3f1e6$export$3c516629fbb0d924);
$parcel$export(module.exports, "activeItemChangedAction", () => $12741d1e4ab3f1e6$export$ce58420b2705f9ee);
$parcel$export(module.exports, "activeItemRemovedAction", () => $12741d1e4ab3f1e6$export$42120e4638639b68);
$parcel$export(module.exports, "PAGE_CHANGED", () => $12741d1e4ab3f1e6$export$e09b596b5ad52fee);
$parcel$export(module.exports, "pageChangedAction", () => $12741d1e4ab3f1e6$export$ef479dcaff4dd067);
$parcel$export(module.exports, "SORT_ORDER_CHANGED", () => $12741d1e4ab3f1e6$export$25e584dfc9e3eff4);
$parcel$export(module.exports, "sortOrderChangedAction", () => $12741d1e4ab3f1e6$export$6053015c901f4a6f);
$parcel$export(module.exports, "SORT_ORDER_OPTIMISTIC_UPDATE", () => $12741d1e4ab3f1e6$export$acc4e88a28a7b0a0);
$parcel$export(module.exports, "sortOrderOptimisticUpdateAction", () => $12741d1e4ab3f1e6$export$fc03e6e4f23c5a8f);
$parcel$export(module.exports, "SORT_ORDER_OPTIMISTIC_RESET", () => $12741d1e4ab3f1e6$export$533ed746a3d5dc9c);
$parcel$export(module.exports, "sortOrderOptimisticResetAction", () => $12741d1e4ab3f1e6$export$c1c6e7ee5582b9c8);
$parcel$export(module.exports, "SORT_ORDER_ON_LOAD", () => $12741d1e4ab3f1e6$export$d4e7f6a156826402);
$parcel$export(module.exports, "sortOrderOnLoadAction", () => $12741d1e4ab3f1e6$export$d2ecbc20e3155b0f);
$parcel$export(module.exports, "RESET_SORT_ORDER", () => $12741d1e4ab3f1e6$export$2f4dfac96c2f056a);
$parcel$export(module.exports, "resetSortOrderAction", () => $12741d1e4ab3f1e6$export$203744a3e48fd32);
$parcel$export(module.exports, "TOGGLE_QUEUE_HEADER", () => $12741d1e4ab3f1e6$export$4ee6cf3ac95ffd6f);
$parcel$export(module.exports, "toggleQueueHeaderAction", () => $12741d1e4ab3f1e6$export$246f86636f1800cd);
$parcel$export(module.exports, "FETCH_ISSUE_DATA_ONSCROLL", () => $12741d1e4ab3f1e6$export$5b6c833dfdf472fa);
$parcel$export(module.exports, "fetchIssueDataOnScrollAction", () => $12741d1e4ab3f1e6$export$1ebcd0c4bc8d1a17);
$parcel$export(module.exports, "DISPLAY_UNSUCCESSFUL_FETCH_WARNING", () => $12741d1e4ab3f1e6$export$b01127fa720badfd);
$parcel$export(module.exports, "displayUnsuccessfulFetchWarningAction", () => $12741d1e4ab3f1e6$export$533da0160b901b24);
$parcel$export(module.exports, "DISPLAY_UNSUCCESSFUL_FETCH_ERROR", () => $12741d1e4ab3f1e6$export$9288a47530ff1e41);
$parcel$export(module.exports, "displayUnsuccessfulFetchErrorOnScrollAction", () => $12741d1e4ab3f1e6$export$9af7482c09c5cf94);
const $12741d1e4ab3f1e6$export$68b362e6b981d575 = 'state.actions.table.TABLE_CHANGED';
const $12741d1e4ab3f1e6$export$3c516629fbb0d924 = (analyticsEvent)=>({
        type: $12741d1e4ab3f1e6$export$68b362e6b981d575,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $12741d1e4ab3f1e6$export$bf878f94e95fcc5d = 'state.actions.table.ACTIVE_ITEM_CHANGED';
const $12741d1e4ab3f1e6$export$ce58420b2705f9ee = (rowId, colId)=>({
        type: $12741d1e4ab3f1e6$export$bf878f94e95fcc5d,
        payload: {
            rowId: rowId,
            colId: colId
        }
    });
const $12741d1e4ab3f1e6$export$dff3d0f13dc2a535 = 'state.actions.table.ACTIVE_ITEM_REMOVED';
const $12741d1e4ab3f1e6$export$42120e4638639b68 = ()=>({
        type: $12741d1e4ab3f1e6$export$dff3d0f13dc2a535
    });
const $12741d1e4ab3f1e6$export$e09b596b5ad52fee = 'state.actions.table.PAGE_CHANGED';
const $12741d1e4ab3f1e6$export$ef479dcaff4dd067 = (currentPage)=>({
        type: $12741d1e4ab3f1e6$export$e09b596b5ad52fee,
        payload: {
            currentPage: currentPage
        }
    });
const $12741d1e4ab3f1e6$export$25e584dfc9e3eff4 = 'state.actions.table.SORT_ORDER_CHANGED';
const $12741d1e4ab3f1e6$export$6053015c901f4a6f = (sortedBy, sortOrder)=>({
        type: $12741d1e4ab3f1e6$export$25e584dfc9e3eff4,
        payload: {
            sortedBy: sortedBy,
            sortOrder: sortOrder
        }
    });
const $12741d1e4ab3f1e6$export$acc4e88a28a7b0a0 = 'state.actions.table.SORT_ORDER_OPTIMISTIC_UPDATE';
const $12741d1e4ab3f1e6$export$fc03e6e4f23c5a8f = (queueId, sortedBy, sortOrder)=>({
        type: $12741d1e4ab3f1e6$export$acc4e88a28a7b0a0,
        payload: {
            queueId: queueId,
            sortedBy: sortedBy,
            sortOrder: sortOrder
        }
    });
const $12741d1e4ab3f1e6$export$533ed746a3d5dc9c = 'state.actions.table.SORT_ORDER_OPTIMISTIC_RESET';
const $12741d1e4ab3f1e6$export$c1c6e7ee5582b9c8 = ()=>({
        type: $12741d1e4ab3f1e6$export$533ed746a3d5dc9c
    });
const $12741d1e4ab3f1e6$export$d4e7f6a156826402 = 'state.actions.table.SORT_ORDER_ON_LOAD';
const $12741d1e4ab3f1e6$export$d2ecbc20e3155b0f = (sortedBy, sortOrder)=>({
        type: $12741d1e4ab3f1e6$export$d4e7f6a156826402,
        payload: {
            sortedBy: sortedBy,
            sortOrder: sortOrder
        }
    });
const $12741d1e4ab3f1e6$export$2f4dfac96c2f056a = 'state.actions.table.RESET_SORT_ORDER';
const $12741d1e4ab3f1e6$export$203744a3e48fd32 = ()=>({
        type: $12741d1e4ab3f1e6$export$2f4dfac96c2f056a
    });
const $12741d1e4ab3f1e6$export$4ee6cf3ac95ffd6f = 'state.actions.table.TOGGLE_QUEUE_HEADER';
const $12741d1e4ab3f1e6$export$246f86636f1800cd = (scrollDirection)=>({
        type: $12741d1e4ab3f1e6$export$4ee6cf3ac95ffd6f,
        payload: scrollDirection
    });
const $12741d1e4ab3f1e6$export$5b6c833dfdf472fa = 'state.actions.table.FETCH_ISSUE_DATA_ONSCROLL';
const $12741d1e4ab3f1e6$export$1ebcd0c4bc8d1a17 = (startIndex)=>({
        type: $12741d1e4ab3f1e6$export$5b6c833dfdf472fa,
        payload: startIndex
    });
const $12741d1e4ab3f1e6$export$b01127fa720badfd = 'state.actions.table.DISPLAY_UNSUCCESSFUL_FETCH_WARNING';
const $12741d1e4ab3f1e6$export$533da0160b901b24 = ()=>({
        type: $12741d1e4ab3f1e6$export$b01127fa720badfd
    });
const $12741d1e4ab3f1e6$export$9288a47530ff1e41 = 'state.actions.table.DISPLAY_UNSUCCESSFUL_FETCH_ERROR';
const $12741d1e4ab3f1e6$export$9af7482c09c5cf94 = ()=>({
        type: $12741d1e4ab3f1e6$export$9288a47530ff1e41
    });

});

parcelRegister("88qDC", function(module, exports) {

$parcel$export(module.exports, "unsetIsInitialLoad", () => $f1aa6db7dc7fe80d$export$2fa696454aa7ac86);
$parcel$export(module.exports, "default", () => $f1aa6db7dc7fe80d$export$2e2bcd8739ae039);
const $f1aa6db7dc7fe80d$var$UNSET_IS_INITIAL_LOAD = 'state.actions.page.UNSET_IS_INITIAL_LOAD';
const $f1aa6db7dc7fe80d$export$2fa696454aa7ac86 = ()=>({
        type: $f1aa6db7dc7fe80d$var$UNSET_IS_INITIAL_LOAD
    });
const $f1aa6db7dc7fe80d$export$1650419e431d3ba3 = (state = null, action)=>{
    switch(action.type){
        case $f1aa6db7dc7fe80d$var$UNSET_IS_INITIAL_LOAD:
            return {
                ...state,
                isInitialLoading: false
            };
        default:
            return state || null;
    }
};
var $f1aa6db7dc7fe80d$export$2e2bcd8739ae039 = $f1aa6db7dc7fe80d$export$1650419e431d3ba3;

});


parcelRegister("8NpLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $67bcefdbb1a8ff7d$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("d2zWP");

var $7kixv = parcelRequire("7kixv");

var $5SwkH = parcelRequire("5SwkH");

var $2IsS5 = parcelRequire("2IsS5");

var $f20Bj = parcelRequire("f20Bj");

var $2MzoN = parcelRequire("2MzoN");

var $lc49q = parcelRequire("lc49q");

var $6I1gv = parcelRequire("6I1gv");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$67bcefdbb1a8ff7d$export$2e2bcd8739ae039 = (push)=>(action$, store)=>action$.ofType((0, $2MzoN.OPEN_ISSUE)).switchMap(()=>{
            const state = store.getState();
            const projectKey = (0, $f20Bj.getProjectKey)(state);
            const queueId = (0, $lc49q.getQueueId)(state);
            const issueKey = (0, $6I1gv.getIssueKeyContext)(state);
            const category = (0, $lc49q.getCategory)(state);
            if (issueKey != null && issueKey !== '') {
                if (push) return push((0, $5SwkH.getQueueIssueFragment)((0, $2IsS5.fromQueueId)(queueId), issueKey, category));
                // Fallback to push state navigator.
                return (0, $5SwkH.navigate)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                projectKey, (0, $5SwkH.getQueueIssueFragment)((0, $2IsS5.fromQueueId)(queueId), issueKey, category));
            }
            return (0, $7kixv.Observable).empty();
        });

});


parcelRegister("79HQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e96a80c5736ae5f1$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");
parcelRequire("1AyD5");
parcelRequire("baP6E");
parcelRequire("9BkTq");
parcelRequire("7La6O");
parcelRequire("8gLG0");
parcelRequire("llumX");
parcelRequire("d2zWP");

var $2IsS5 = parcelRequire("2IsS5");


var $2MzoN = parcelRequire("2MzoN");

var $iGYMr = parcelRequire("iGYMr");

var $ir4eL = parcelRequire("ir4eL");
const $e96a80c5736ae5f1$export$68fb821c332f6a6 = 600000;
const $e96a80c5736ae5f1$export$e6b4578b8d511a17 = 2000;
const $e96a80c5736ae5f1$export$a2949fb7526d3e7a = 500;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e96a80c5736ae5f1$export$2e2bcd8739ae039 = (action$)=>{
    let isFailing = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isSuccess = (action)=>action.type === (0, $2MzoN.LOAD_ISSUES_SUCCESS) && action.payload.loadedIssuesResponse.source !== (0, $2IsS5.LOCAL_STORAGE_SOURCE);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isFirstPollFailure = (action)=>action.type === (0, $ir4eL.POLL_FAILURE) && isFailing === false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isFetchFailureInCachedQueue = (action)=>action.type === (0, $2MzoN.LOAD_ISSUES_FAILURE) && action.payload.source === (0, $f3fa5acbda0f3e0e$export$f162a928a40c7ab8) && !action.payload.isQueueEmpty;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isFetchFailureInEmptyQueue = (action)=>action.type === (0, $2MzoN.LOAD_ISSUES_FAILURE) && action.payload.source === (0, $f3fa5acbda0f3e0e$export$f162a928a40c7ab8) && action.payload.isQueueEmpty;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isFetchFailureInSortQueue = (action)=>action.type === (0, $2MzoN.LOAD_ISSUES_FAILURE) && action.payload.source === (0, $f3fa5acbda0f3e0e$export$2003e3fdddd4c35b);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const shouldShowWarning = (action)=>isFetchFailureInCachedQueue(action) || isFetchFailureInSortQueue(action) || isFirstPollFailure(action);
    // show error flag only in case of failure during scroll. Show warning in all other cases
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const shouldShowError = (action)=>action.type === (0, $2MzoN.LOAD_ISSUES_FAILURE) && action.payload.source === (0, $f3fa5acbda0f3e0e$export$d4d94a8c13e2df1d);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const shouldDismissAllFlags = (action)=>isSuccess(action) || isFetchFailureInEmptyQueue(action);
    return action$.ofType((0, $ir4eL.POLL_FAILURE), (0, $2MzoN.LOAD_ISSUES_SUCCESS), (0, $2MzoN.LOAD_ISSUES_FAILURE)).filter((action)=>shouldDismissAllFlags(action) || shouldShowWarning(action) || shouldShowError(action))// @ts-expect-error - TS2345: Types of property 'type' are incompatible. Type 'state.actions.update-metadata.DISMISS_ALL_FLAGS' is not assignable to type 'state.actions.update-metadata.DISPLAY_UNSUCCESSFUL_POLL_WARNING'.
    .switchMap((action)=>{
        if (shouldShowWarning(action) || shouldShowError(action)) {
            let returnObservable = (0, $7kixv.Observable).of((0, $ir4eL.displayUnsuccessfulPollWarningAction)());
            if (shouldShowError(action)) // @ts-expect-error - TS2322 - Type 'Observable<DisplayUnsuccessfulFetchErrorOnScrollAction | DismissWarningFlagAction>' is not assignable to type 'Observable<DisplayUnsuccessfulPollWarningAction>'.
            returnObservable = (0, $7kixv.Observable).concat((0, $7kixv.Observable).of((0, $ir4eL.dismissWarningFlagAction)()), (0, $7kixv.Observable).of((0, $iGYMr.displayUnsuccessfulFetchErrorOnScrollAction)()).delay($e96a80c5736ae5f1$export$a2949fb7526d3e7a));
            else if (isFetchFailureInCachedQueue(action)) // @ts-expect-error - TS2322 - Type 'Observable<DisplayUnsuccessfulFetchWarningAction>' is not assignable to type 'Observable<DisplayUnsuccessfulPollWarningAction>'.
            returnObservable = (0, $7kixv.Observable).of((0, $iGYMr.displayUnsuccessfulFetchWarningAction)());
            return returnObservable.do(()=>{
                isFailing = true;
            }).delay(isFirstPollFailure(action) ? $e96a80c5736ae5f1$export$68fb821c332f6a6 : $e96a80c5736ae5f1$export$e6b4578b8d511a17);
        }
        if (shouldDismissAllFlags(action)) {
            isFailing = false;
            return (0, $7kixv.Observable).of((0, $ir4eL.dismissAllFlagsAction)());
        }
        return (0, $7kixv.Observable).empty();
    });
};

});

parcelRegister("6iLr1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0981ec6c264bab08$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $9CYWP = parcelRequire("9CYWP");

var $j7ARU = parcelRequire("j7ARU");

var $hff3c = parcelRequire("hff3c");
var // @ts-expect-error - TS2345: Type 'unknown' is not assignable to type 'Action'.
$0981ec6c264bab08$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $j7ARU.default), (0, $hff3c.default), (0, $9CYWP.default));

});
parcelRegister("9CYWP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a54aad1101d10e55$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("89McN");
parcelRequire("d2zWP");

var $7kixv = parcelRequire("7kixv");


var $2MzoN = parcelRequire("2MzoN");

var $bKkYU = parcelRequire("bKkYU");

var $lc49q = parcelRequire("lc49q");

var $6I1gv = parcelRequire("6I1gv");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$a54aad1101d10e55$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $bKkYU.CHANGE_VISIBILITY)).switchMap((action)=>{
        const state = store.getState();
        const newVisibility = action.payload.isQueueVisible;
        if ((0, $6I1gv.isQueueVisible)(state) === newVisibility) return (0, $7kixv.Observable).of();
        const result = (0, $7kixv.Observable).of((0, $bKkYU.setQueueVisibilityAction)(newVisibility));
        if (newVisibility) return result.concat((0, $7kixv.Observable).of((0, $2MzoN.loadIssuesAction)((0, $lc49q.getFetchStartIndex)(state), (0, $f3fa5acbda0f3e0e$export$3de6d8bdd297654b))));
        return result;
    });

});
parcelRegister("bKkYU", function(module, exports) {

$parcel$export(module.exports, "SET_QUEUE_VISIBILITY", () => $50e2f790afe1611c$export$92fe62de9bdb5843);
$parcel$export(module.exports, "setQueueVisibilityAction", () => $50e2f790afe1611c$export$64da69d76b8c2108);
$parcel$export(module.exports, "CHANGE_VISIBILITY", () => $50e2f790afe1611c$export$9c635dbaffb42239);
$parcel$export(module.exports, "changeVisibilityAction", () => $50e2f790afe1611c$export$dcdfcd96c3c9f5d1);
$parcel$export(module.exports, "RESET_STATE", () => $50e2f790afe1611c$export$7431817582ed8a25);
$parcel$export(module.exports, "resetStateAction", () => $50e2f790afe1611c$export$d6c39c41a445a29f);
$parcel$export(module.exports, "LOAD_PAGE_DATA", () => $50e2f790afe1611c$export$1b8361138f3b24e8);
$parcel$export(module.exports, "loadPageDataAction", () => $50e2f790afe1611c$export$68ce54e2208e7a36);
$parcel$export(module.exports, "RELOAD_PAGE_DATA", () => $50e2f790afe1611c$export$54fb7345a7b2e0f3);
$parcel$export(module.exports, "reloadPageDataAction", () => $50e2f790afe1611c$export$9455bc428956d0f);
$parcel$export(module.exports, "LOAD_PAGE_DATA_SUCCESS", () => $50e2f790afe1611c$export$6fd4caf8424e356b);
$parcel$export(module.exports, "loadPageDataSuccessAction", () => $50e2f790afe1611c$export$308c96ca263cb52);
$parcel$export(module.exports, "LOAD_PAGE_DATA_FAILURE", () => $50e2f790afe1611c$export$65b7c02925f4c6d8);
$parcel$export(module.exports, "loadPageDataFailureAction", () => $50e2f790afe1611c$export$3fbdb12567de364c);
$parcel$export(module.exports, "DISPLAY_QUEUES_ERROR_HEADER", () => $50e2f790afe1611c$export$464be1c8e7c172ad);
$parcel$export(module.exports, "displayQueuesErrorHeaderAction", () => $50e2f790afe1611c$export$da47c211f950cb59);
const $50e2f790afe1611c$export$92fe62de9bdb5843 = 'state.actions.page.SET_QUEUE_VISIBILITY';
const $50e2f790afe1611c$export$64da69d76b8c2108 = (isQueueVisible)=>({
        type: $50e2f790afe1611c$export$92fe62de9bdb5843,
        payload: {
            isQueueVisible: isQueueVisible
        }
    });
const $50e2f790afe1611c$export$9c635dbaffb42239 = 'state.actions.page.CHANGE_VISIBILITY';
const $50e2f790afe1611c$export$dcdfcd96c3c9f5d1 = (isQueueVisible)=>({
        type: $50e2f790afe1611c$export$9c635dbaffb42239,
        payload: {
            isQueueVisible: isQueueVisible
        }
    });
const $50e2f790afe1611c$export$7431817582ed8a25 = 'state.actions.page.RESET_STATE';
const $50e2f790afe1611c$export$d6c39c41a445a29f = (queueId)=>({
        type: $50e2f790afe1611c$export$7431817582ed8a25,
        payload: {
            queueId: queueId
        }
    });
const $50e2f790afe1611c$export$1b8361138f3b24e8 = 'state.actions.page.LOAD_PAGE_DATA';
const $50e2f790afe1611c$export$68ce54e2208e7a36 = (queueId)=>({
        type: $50e2f790afe1611c$export$1b8361138f3b24e8,
        payload: {
            queueId: queueId
        }
    });
const $50e2f790afe1611c$export$54fb7345a7b2e0f3 = 'state.actions.page.RELOAD_PAGE_DATA';
const $50e2f790afe1611c$export$9455bc428956d0f = (queueId)=>({
        type: $50e2f790afe1611c$export$54fb7345a7b2e0f3,
        payload: {
            queueId: queueId
        }
    });
const $50e2f790afe1611c$export$6fd4caf8424e356b = 'state.actions.page.LOAD_PAGE_DATA_SUCCESS';
const $50e2f790afe1611c$export$308c96ca263cb52 = (queuesWithSorting)=>({
        type: $50e2f790afe1611c$export$6fd4caf8424e356b,
        payload: {
            queuesWithSorting: queuesWithSorting
        }
    });
const $50e2f790afe1611c$export$65b7c02925f4c6d8 = 'state.actions.page.LOAD_PAGE_DATA_FAILURE';
const $50e2f790afe1611c$export$3fbdb12567de364c = (error, statusCode)=>({
        type: $50e2f790afe1611c$export$65b7c02925f4c6d8,
        payload: {
            error: error,
            statusCode: statusCode
        }
    });
const $50e2f790afe1611c$export$464be1c8e7c172ad = 'state.actions.page.DISPLAY_QUEUES_ERROR_HEADER';
const $50e2f790afe1611c$export$da47c211f950cb59 = ()=>({
        type: $50e2f790afe1611c$export$464be1c8e7c172ad
    });

});


parcelRegister("j7ARU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2087d5811c47ef66$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("d2zWP");
parcelRequire("1o2WJ");
parcelRequire("6cJUr");
parcelRequire("c1D7V");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");


var $3D6XN = parcelRequire("3D6XN");

var $2MzoN = parcelRequire("2MzoN");

var $bKkYU = parcelRequire("bKkYU");

var $lgeFD = parcelRequire("lgeFD");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2087d5811c47ef66$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $bKkYU.LOAD_PAGE_DATA)).switchMap((action)=>{
        const state = store.getState();
        return (0, $3D6XN.default)(action.payload.queueId, state).flatMap((result)=>(0, $7kixv.Observable).of((0, $bKkYU.loadPageDataSuccessAction)(result), // @ts-expect-error - TS2769 - No overload matches this call.
            (0, $2MzoN.loadIssuesAction)((0, $lgeFD.getCurrentPageStartIndex)(state), (0, $f3fa5acbda0f3e0e$export$f162a928a40c7ab8)))).catch((error)=>{
            (0, $gYnSx.default)({
                meta: {
                    id: 'opsPageLoad',
                    packageName: 'jiraServicedeskQueuesAgentView',
                    teamName: 'jsd-shield'
                },
                // @ts-expect-error - TS2345 - Argument of type 'ErrorResponse' is not assignable to parameter of type 'string'.
                error: new Error(error)
            });
            (0, $eSnSE.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.ops.page.load', `[FD-3358] Error while trying to load page data: ${JSON.stringify(error.response.errors)}`);
            return (0, $7kixv.Observable).of((0, $bKkYU.loadPageDataFailureAction)(error.response, error.statusCode));
        });
    });

});
parcelRegister("3D6XN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0f4e60f24aa02f9$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");
parcelRequire("cBiei");
parcelRequire("1o2WJ");
parcelRequire("c1D7V");

var $f5xwW = parcelRequire("f5xwW");

var $f20Bj = parcelRequire("f20Bj");

var $1Z0md = parcelRequire("1Z0md");

var $2MNyX = parcelRequire("2MNyX");

var $eI1Ks = parcelRequire("eI1Ks");
const $a0f4e60f24aa02f9$var$prefetcherTransformFunc = (queueId, prefetcherPageResponse)=>(0, $eI1Ks.addSortingToQueues)(queueId, (0, $2MNyX.pageToQueues)(prefetcherPageResponse.data.queues));
const $a0f4e60f24aa02f9$var$pageResponseTransformFunc = (queueId)=>(pageResponse)=>(0, $eI1Ks.addSortingToQueues)(queueId, (0, $2MNyX.pageToQueues)(pageResponse.queues));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a0f4e60f24aa02f9$export$2e2bcd8739ae039 = (queueId, state)=>{
    const prefetchedPagePromise = (0, $2MNyX.getPrefetchedPagePromise)();
    if (prefetchedPagePromise.isSome()) return (0, $7kixv.Observable).fromPromise(prefetchedPagePromise.some()).map((data)=>{
        (0, $2MNyX.unsetPrefetchedPagePromise)();
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'PrefetcherPageResponse'.
        return $a0f4e60f24aa02f9$var$prefetcherTransformFunc(queueId, data);
    }).catch(()=>(0, $f5xwW.default)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        (0, $1Z0md.default)((0, $f20Bj.getProjectKey)(state)), $a0f4e60f24aa02f9$var$pageResponseTransformFunc(queueId)));
    return (0, $f5xwW.default)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (0, $1Z0md.default)((0, $f20Bj.getProjectKey)(state)), $a0f4e60f24aa02f9$var$pageResponseTransformFunc(queueId));
};

});
parcelRegister("1Z0md", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bc2aba79efbecb0$export$2e2bcd8739ae039);

var $l8ZcU = parcelRequire("l8ZcU");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3bc2aba79efbecb0$export$2e2bcd8739ae039 = (projectKey)=>(0, $l8ZcU.fetchJson$)(`/rest/servicedesk/1/servicedesk/${projectKey}/queues/page`, {
        method: 'GET'
    });

});

parcelRegister("2MNyX", function(module, exports) {

$parcel$export(module.exports, "pageToQueues", () => $77bfadac9d0cfd21$export$8ada91ce992fa66f);
$parcel$export(module.exports, "getPrefetchedPagePromise", () => $77bfadac9d0cfd21$export$4906aa3ec3919ad9);
$parcel$export(module.exports, "unsetPrefetchedPagePromise", () => $77bfadac9d0cfd21$export$17bdd949b6a9952);
// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.

var $ljsRg = parcelRequire("ljsRg");

var $2IsS5 = parcelRequire("2IsS5");
const $77bfadac9d0cfd21$var$transformColumns = (responseColumns)=>responseColumns.map((responseColumn)=>{
        const column = {
            id: responseColumn.fieldId,
            title: responseColumn.title,
            fieldType: responseColumn.fieldType,
            sortable: responseColumn.sortable
        };
        if (responseColumn.sortOrder) return {
            ...column,
            currentSorting: responseColumn.sortOrder
        };
        return column;
    });
const $77bfadac9d0cfd21$export$8ada91ce992fa66f = (page)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    page.reduce((acc, queue)=>{
        acc[queue.id] = {
            id: (0, $2IsS5.toQueueId)(queue.id),
            name: queue.name,
            jql: queue.jql,
            completeJql: queue.completeJql,
            order: queue.order,
            columns: $77bfadac9d0cfd21$var$transformColumns(queue.columnsDetails),
            // British spelling from legacy Backend code
            isFavorite: queue.favourite
        };
        return acc;
    }, {});
const $77bfadac9d0cfd21$export$4906aa3ec3919ad9 = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    (0, $ljsRg.Maybe).fromNull(window.JSD_QUEUES_PRELOAD_PROMISES && window.JSD_QUEUES_PRELOAD_PROMISES.queues);
const $77bfadac9d0cfd21$export$17bdd949b6a9952 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.JSD_QUEUES_PRELOAD_PROMISES) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.JSD_QUEUES_PRELOAD_PROMISES.queues = undefined;
};

});

parcelRegister("eI1Ks", function(module, exports) {

$parcel$export(module.exports, "addSortingToQueues", () => $5854c9193915e80b$export$406ba23a25949900);
$parcel$export(module.exports, "createSortedQueue", () => $5854c9193915e80b$export$e8964ed223410f32);

var $iWqim = parcelRequire("iWqim");

var $6kS6u = parcelRequire("6kS6u");

var $aDqEX = parcelRequire("aDqEX");

var $ljsRg = parcelRequire("ljsRg");

var $gYnSx = parcelRequire("gYnSx");


var $gCeeo = parcelRequire("gCeeo");

var $ajASe = parcelRequire("ajASe");

var $2IsS5 = parcelRequire("2IsS5");

var $dnU6V = parcelRequire("dnU6V");

const $5854c9193915e80b$var$getKey = (queueId)=>`${0, $bbd0c274fc29919b$export$380a2d1eea3be734}${queueId}`;
const $5854c9193915e80b$export$aa821bfb3308a1f5 = (0, $dnU6V.createLocalStorageProvider)('servicedesk_queues');
const $5854c9193915e80b$export$27624a2b25e61084 = (queueId)=>{
    try {
        $5854c9193915e80b$export$aa821bfb3308a1f5.remove($5854c9193915e80b$var$getKey((0, $2IsS5.fromQueueId)(queueId).toString()));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        const errMessage = 'Local storage deletion failure for sorting';
        (0, $gYnSx.default)({
            meta: {
                id: 'servicesSortLocalstorageDelete',
                packageName: 'jiraServiceDeskQueuesAgentView',
                teamName: 'jsd-shield'
            },
            attributes: {
                type: 'localStorageDelete'
            },
            error: new Error(errMessage)
        });
        (0, $ajASe.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.services', errMessage);
    }
};
const $5854c9193915e80b$export$b0fb563b02669fb1 = (queueId, createAnalyticsEvent)=>{
    try {
        let stored = null;
        stored = $5854c9193915e80b$export$aa821bfb3308a1f5.get($5854c9193915e80b$var$getKey(queueId)) ? JSON.stringify($5854c9193915e80b$export$aa821bfb3308a1f5.get($5854c9193915e80b$var$getKey(queueId))) : null;
        if (createAnalyticsEvent) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'viewQueuesSortingFromLocalStorage updated', {
            hasSorting: stored !== null
        });
        if (stored !== null) {
            const storedSortOrder = JSON.parse(stored);
            if (storedSortOrder.fieldId && storedSortOrder.fieldId.length > 0 && (storedSortOrder.sortOrder === (0, $4ec7ec7f2cfbc873$export$1dee026a19752d6b) || storedSortOrder.sortOrder === (0, $4ec7ec7f2cfbc873$export$b6abcf7fa1d94f65))) return (0, $ljsRg.Maybe).of({
                sortedBy: storedSortOrder.fieldId,
                sortOrder: storedSortOrder.sortOrder
            });
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        const errMessage = 'Local storage for sorting getItem failure';
        (0, $gYnSx.default)({
            meta: {
                id: 'servicesSortLocalstorageGet',
                packageName: 'jiraServiceDeskQueuesAgentView',
                teamName: 'jsd-shield'
            },
            attributes: {
                type: 'localStorageGet'
            },
            error: new Error(errMessage)
        });
        (0, $ajASe.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.services', errMessage);
    }
    return (0, $ljsRg.Maybe).None();
};
const $5854c9193915e80b$var$applyManualSortingToColumns = (columns, manualSorting)=>columns.map((column)=>{
        if (column.id === manualSorting.sortedBy) return (0, $iWqim.assoc)(column, 'currentSorting', manualSorting.sortOrder);
        return (0, $iWqim.dissoc)(column, 'currentSorting');
    });
const $5854c9193915e80b$export$bdc8ae2ac7632444 = (queue, maybeManualSorting)=>maybeManualSorting.cata(()=>queue, // @ts-expect-error - TS7006 - Parameter 'manualSorting' implicitly has an 'any' type.
    (manualSorting)=>(0, $iWqim.updateIn)(queue, [
            'columns'
        ], (columns)=>// @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'Column[]'.
            $5854c9193915e80b$var$applyManualSortingToColumns(columns, manualSorting)));
const $5854c9193915e80b$var$addSortingToQueuesInternal = (currentQueueId, queues)=>// @ts-expect-error - TS2322 - Type '[string, SortedQueue]' is not assignable to type 'SortedQueues'. | TS2345 - Argument of type '(acc: Record<string, any>, [queueId, queue]: [number, Queue]) => Record<string, any>' is not assignable to parameter of type '(previousValue: Record<string, any>, currentValue: [string, SortedQueue], currentIndex: number, array: [string, SortedQueue][]) => Record<string, any>'. | TS2304 - Cannot find name 'Queue'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, (/*@__PURE__*/$parcel$interopDefault($aDqEX)))(queues).reduce((acc, [queueId, queue])=>{
        const maybeManualSorting = $5854c9193915e80b$export$b0fb563b02669fb1(String(queueId));
        const newQueue = $5854c9193915e80b$export$bdc8ae2ac7632444(queue, maybeManualSorting);
        acc[queueId] = newQueue;
        return acc;
    }, {});
const $5854c9193915e80b$export$406ba23a25949900 = (currentQueueId, queues)=>{
    const updatedQueues = $5854c9193915e80b$var$addSortingToQueuesInternal(currentQueueId, queues);
    const currentQueueIdString = (0, $2IsS5.fromQueueId)(currentQueueId).toString();
    if (!updatedQueues[currentQueueIdString]) return {
        queues: updatedQueues
    };
    const manualSortColumn = updatedQueues[currentQueueIdString].columns.find((column)=>column.currentSorting);
    if (!manualSortColumn || !manualSortColumn.currentSorting) return {
        queues: updatedQueues
    };
    return {
        queues: updatedQueues,
        manualSorting: {
            sortedBy: manualSortColumn.id,
            sortOrder: manualSortColumn.currentSorting
        }
    };
};
// SHIELD-3415 Methods used by queue quality only
const $5854c9193915e80b$var$createQueueFromManualSorting = (queue, manualSorting)=>{
    const { columns: columns } = queue;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(columns, {
        id: manualSorting.sortedBy
    })) return {
        ...queue,
        columns: $5854c9193915e80b$var$applyManualSortingToColumns(columns, manualSorting),
        manualSorting: manualSorting
    };
    return queue;
};
const $5854c9193915e80b$export$e8964ed223410f32 = (queue, createAnalyticsEvent)=>$5854c9193915e80b$export$b0fb563b02669fb1((0, $2IsS5.fromQueueIdString)(queue.id), createAnalyticsEvent).cata(()=>queue, // @ts-expect-error - TS7006 - Parameter 'manualSorting' implicitly has an 'any' type.
    (manualSorting)=>{
        const sortedQueue = $5854c9193915e80b$var$createQueueFromManualSorting(queue, manualSorting);
        if (!sortedQueue.manualSorting) $5854c9193915e80b$export$27624a2b25e61084(sortedQueue.id);
        return sortedQueue;
    });

});
parcelRegister("aDqEX", function(module, exports) {

var $43fco = parcelRequire("43fco");

var $4c94y = parcelRequire("4c94y");
/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */ var $7be239ef8bf585e8$var$toPairs = $43fco($4c94y);
module.exports = $7be239ef8bf585e8$var$toPairs;

});
parcelRegister("43fco", function(module, exports) {

var $94c5e = parcelRequire("94c5e");

var $PodIB = parcelRequire("PodIB");

var $fy1iF = parcelRequire("fy1iF");

var $dkJtE = parcelRequire("dkJtE");
/** `Object#toString` result references. */ var $2f333b71c1fa6e41$var$mapTag = '[object Map]', $2f333b71c1fa6e41$var$setTag = '[object Set]';
/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */ function $2f333b71c1fa6e41$var$createToPairs(keysFunc) {
    return function(object) {
        var tag = $PodIB(object);
        if (tag == $2f333b71c1fa6e41$var$mapTag) return $fy1iF(object);
        if (tag == $2f333b71c1fa6e41$var$setTag) return $dkJtE(object);
        return $94c5e(object, keysFunc(object));
    };
}
module.exports = $2f333b71c1fa6e41$var$createToPairs;

});
parcelRegister("94c5e", function(module, exports) {

var $lylkU = parcelRequire("lylkU");
/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */ function $699ddc42dfa898c4$var$baseToPairs(object, props) {
    return $lylkU(props, function(key) {
        return [
            key,
            object[key]
        ];
    });
}
module.exports = $699ddc42dfa898c4$var$baseToPairs;

});

parcelRegister("dkJtE", function(module, exports) {
/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */ function $9b506b71029020c4$var$setToPairs(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = [
            value,
            value
        ];
    });
    return result;
}
module.exports = $9b506b71029020c4$var$setToPairs;

});



// SORT_PREFIX needs to be kept consistent with what prefetcher uses
const $bbd0c274fc29919b$export$380a2d1eea3be734 = 'QUEUE_ORDER_BY_';



parcelRegister("lgeFD", function(module, exports) {

$parcel$export(module.exports, "getCurrentPage", () => $2d5262658de31aea$export$7945ba8eb1c827e6);
$parcel$export(module.exports, "getCurrentPageStartIndex", () => $2d5262658de31aea$export$e4d555459a632790);
$parcel$export(module.exports, "getTotalPages", () => $2d5262658de31aea$export$652b307566494a6);
$parcel$export(module.exports, "getIssueKeysForPage", () => $2d5262658de31aea$export$c1360f0f194316c8);

var $ahm5r = parcelRequire("ahm5r");


var $7jTnu = parcelRequire("7jTnu");

var $1TuhT = parcelRequire("1TuhT");

var $lc49q = parcelRequire("lc49q");

var $6I1gv = parcelRequire("6I1gv");
const $2d5262658de31aea$var$LOADING_ROW_COUNT = 10;
const $2d5262658de31aea$var$SCROLL_DEPTH = 100;
const $2d5262658de31aea$export$7107d372eaf3477f = (state)=>(0, $lc49q.getQueuePageData)(state).pagination;
const $2d5262658de31aea$export$7945ba8eb1c827e6 = (state)=>$2d5262658de31aea$export$7107d372eaf3477f(state).currentPage;
const $2d5262658de31aea$export$e4d555459a632790 = (state)=>($2d5262658de31aea$export$7945ba8eb1c827e6(state) - 1) * (0, $b354b11309751a31$export$f88f58d1a4b2078b);
const $2d5262658de31aea$export$652b307566494a6 = (state)=>{
    if ((0, $7jTnu.fg)('jsm-corcap-3691-reduce-queues-table-scroll-depth')) {
        const issues = (0, $1TuhT.getCollection)(state);
        return Math.max(1, issues.length / (0, $b354b11309751a31$export$f88f58d1a4b2078b));
    }
    return Math.max(1, Math.ceil((0, $1TuhT.getIssueCount)(state) / (0, $b354b11309751a31$export$f88f58d1a4b2078b)));
};
const $2d5262658de31aea$export$303dbf47f10892ce = (state)=>$2d5262658de31aea$export$7945ba8eb1c827e6(state) * (0, $b354b11309751a31$export$f88f58d1a4b2078b) - 1;
const $2d5262658de31aea$export$e81b7cdc3b6d6b1f = (state)=>{
    const maxPageEndIndex = $2d5262658de31aea$export$303dbf47f10892ce(state);
    const minPageEndIndex = $2d5262658de31aea$export$e4d555459a632790(state) - 1;
    const issues = (0, $1TuhT.getCollection)(state);
    const indexOfLastIssueOnPage = Math.min(Math.max((0, $1TuhT.getIssueCount)(state) - 1, minPageEndIndex), maxPageEndIndex);
    if ((0, $7jTnu.fg)('jsm-corcap-3691-reduce-queues-table-scroll-depth')) return Math.min(indexOfLastIssueOnPage, issues.length - 1 + $2d5262658de31aea$var$SCROLL_DEPTH);
    return indexOfLastIssueOnPage;
};
const $2d5262658de31aea$export$c1360f0f194316c8 = (0, $ahm5r.createSelector)((0, $1TuhT.getCollection), $2d5262658de31aea$export$e4d555459a632790, $2d5262658de31aea$export$e81b7cdc3b6d6b1f, (0, $6I1gv.isLoadingIssues), (issues, startIndex, endIndex, isLoading)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueKeys = [];
    const isNewDataSet = isLoading && issues.length === 0;
    // If we are expecting data from a new source like a queue or a page.
    // If the collection has not been cleared we want to show
    // existing row until loading is complete
    if (isNewDataSet) {
        issueKeys.length = $2d5262658de31aea$var$LOADING_ROW_COUNT;
        if (endIndex - startIndex + 1 === (0, $b354b11309751a31$export$f88f58d1a4b2078b)) issueKeys.length = (0, $b354b11309751a31$export$f88f58d1a4b2078b);
        return issueKeys;
    }
    issueKeys.length = endIndex - startIndex + 1;
    for(let i = startIndex; i <= endIndex; i += 1){
        const issue = issues[i];
        if (issue) issueKeys[i - startIndex] = issue.key;
    }
    return issueKeys;
});

});


parcelRegister("hff3c", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8c85a9f6daca766$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");
parcelRequire("9BkTq");
parcelRequire("d2zWP");

var $bKkYU = parcelRequire("bKkYU");

var $ir4eL = parcelRequire("ir4eL");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$a8c85a9f6daca766$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $bKkYU.RELOAD_PAGE_DATA)).switchMap((action)=>{
        const { queueId: queueId } = action.payload;
        return (0, $7kixv.Observable).of((0, $ir4eL.stopPollAction)(), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $bKkYU.resetStateAction)(queueId), (0, $bKkYU.loadPageDataAction)(queueId));
    });

});


parcelRegister("40A9q", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be179768c0a12e8$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("1h54Q");
parcelRequire("1AyD5");
parcelRequire("6cJUr");
parcelRequire("c1D7V");
parcelRequire("d2zWP");

var $5CykT = parcelRequire("5CykT");

var $7kixv = parcelRequire("7kixv");

var $7jTnu = parcelRequire("7jTnu");


var $gzIcp = parcelRequire("gzIcp");

var $2MzoN = parcelRequire("2MzoN");

var $kfJuF = parcelRequire("kfJuF");

var $ir4eL = parcelRequire("ir4eL");

var $3MjJb = parcelRequire("3MjJb");

var $lc49q = parcelRequire("lc49q");
const $6be179768c0a12e8$var$INITIAL_POLLING_INTERVAL = 5000;
const $6be179768c0a12e8$export$8201d195ec654b2c = 60000;
const $6be179768c0a12e8$export$8403745c406d60ee = 300000;
const $6be179768c0a12e8$export$acdfd55989a32c36 = 2000;
const $6be179768c0a12e8$var$BROWSER_TAB_VISIBLE_STATE = 'visible';
const $6be179768c0a12e8$var$getInterval = (initialInterval)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.visibilityState !== $6be179768c0a12e8$var$BROWSER_TAB_VISIBLE_STATE) return $6be179768c0a12e8$export$acdfd55989a32c36;
    return initialInterval;
};
const $6be179768c0a12e8$var$getNextInterval = (interval, statusCode)=>{
    if (statusCode >= 500 && (0, $7jTnu.fg)('jsm_queue_polling_exponential_backoff')) {
        const nextInterval = interval * 5;
        return Math.min($6be179768c0a12e8$export$8403745c406d60ee, nextInterval);
    }
    const nextInterval = interval * 1.1;
    return Math.min($6be179768c0a12e8$export$8201d195ec654b2c, nextInterval);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6be179768c0a12e8$export$2e2bcd8739ae039 = (initialInterval = $6be179768c0a12e8$var$INITIAL_POLLING_INTERVAL, scheduler)=>(action$, store)=>{
        let isShutdown = false;
        return action$.ofType((0, $kfJuF.SHUTDOWN), (0, $ir4eL.STOP_POLL), (0, $ir4eL.RESTART_POLL)).switchMap((action)=>{
            if (action.type === (0, $kfJuF.SHUTDOWN) || isShutdown) {
                isShutdown = true;
                return (0, $7kixv.Observable).empty();
            }
            if (action.type === (0, $ir4eL.STOP_POLL)) return (0, $7kixv.Observable).empty();
            const pollingInterval$ = new (0, $5CykT.BehaviorSubject)($6be179768c0a12e8$var$getInterval(initialInterval));
            return pollingInterval$.switchMap((interval)=>{
                let initialDelay = interval;
                if (action.payload?.skipInitialDelay) initialDelay = 0;
                return (0, $7kixv.Observable).timer(initialDelay, interval, scheduler).switchMap(()=>(0, $7kixv.Observable).of(interval));
            }).switchMap((interval)=>{
                const state = store.getState();
                // If browser tab is not visible, do nothing.
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                if (document.visibilityState !== $6be179768c0a12e8$var$BROWSER_TAB_VISIBLE_STATE) {
                    pollingInterval$.next($6be179768c0a12e8$var$getInterval(initialInterval));
                    return (0, $7kixv.Observable).empty();
                }
                return (0, $gzIcp.default)(state).mergeMap((result)=>{
                    // going back to the original interval if there is new data
                    pollingInterval$.next($6be179768c0a12e8$var$getInterval(initialInterval));
                    const successAction = (0, $7jTnu.fg)('jsm-corcap-3722-pass-search-mode') ? (0, $ir4eL.pollSuccessAction)(result.projectStateHash, result?.searchMode) : (0, $ir4eL.pollSuccessAction)(result.projectStateHash);
                    if ((0, $3MjJb.getIsCurrentDataFiltered)(state)) return (0, $7kixv.Observable).of(successAction);
                    return (0, $7kixv.Observable).of(successAction, // @ts-expect-error - TS2769 - No overload matches this call.
                    (0, $2MzoN.loadIssuesAction)((0, $lc49q.getFetchStartIndex)(state), (0, $f3fa5acbda0f3e0e$export$fa4dae241333de34)));
                })// 304 returned by endpoint
                // @ts-expect-error - TS2345 - Argument of type '(error: ErrorResponse) => Observable<PollContentNotModifiedAction> | Observable<PollFailureAction>' is not assignable to parameter of type '(err: any, caught: Observable<PollSuccessAction>) => ObservableInput<PollContentNotModifiedAction>'.
                .catch((error)=>{
                    // going back to the original interval if there is new data
                    pollingInterval$.next($6be179768c0a12e8$var$getNextInterval(interval, error.statusCode));
                    if (error.statusCode === 304) return (0, $7kixv.Observable).of((0, $ir4eL.pollContentNotModifiedAction)());
                    return (0, $7kixv.Observable).of((0, $ir4eL.pollFailureAction)());
                });
            });
        });
    };

});
parcelRegister("gzIcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $19306f752a0d1ebe$export$2e2bcd8739ae039);

var $f5xwW = parcelRequire("f5xwW");

var $f20Bj = parcelRequire("f20Bj");

var $lrWHL = parcelRequire("lrWHL");

var $9kCRJ = parcelRequire("9kCRJ");
const $19306f752a0d1ebe$var$transformFunction = (pollResponse)=>pollResponse;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$19306f752a0d1ebe$export$2e2bcd8739ae039 = (state)=>(0, $f5xwW.default)(// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (0, $lrWHL.default)((0, $f20Bj.getProjectKey)(state), (0, $9kCRJ.getProjectStateHash)(state)), $19306f752a0d1ebe$var$transformFunction);

});
parcelRegister("lrWHL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cac179f1d49a1091$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");
parcelRequire("cBiei");

var $l8ZcU = parcelRequire("l8ZcU");

var $7jTnu = parcelRequire("7jTnu");

var $d3nJY = parcelRequire("d3nJY");
const $cac179f1d49a1091$var$pollWithHeaders = (url)=>{
    return (0, $7kixv.Observable).fromPromise((0, $d3nJY.performRequest)(url, {
        method: 'GET'
    })).flatMap((response)=>(0, $7kixv.Observable).fromPromise(response.json()).map((data)=>({
                ...data,
                searchMode: response.headers.get('Atl-Issue-Search-Mode')
            })));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cac179f1d49a1091$export$2e2bcd8739ae039 = (projectKey, projectStateHash)=>{
    const params = new URLSearchParams();
    if (projectStateHash) params.set('projectStateHash', projectStateHash);
    params.set('operation', 'fetchQueuesPoll');
    const queryString = params.size ? `?${params.toString()}` : '';
    const url = `/rest/servicedesk/1/servicedesk/${projectKey}/queues/poll${queryString}`;
    if ((0, $7jTnu.fg)('jsm-corcap-3722-pass-search-mode')) return $cac179f1d49a1091$var$pollWithHeaders(url);
    return (0, $l8ZcU.fetchJson$)(url, {
        method: 'GET'
    });
};

});


parcelRegister("kfJuF", function(module, exports) {

$parcel$export(module.exports, "SHUTDOWN", () => $117bd14fbc9aa91f$export$9d68ba11045ae7c3);
$parcel$export(module.exports, "shutdownAction", () => $117bd14fbc9aa91f$export$d45c0b180c9b57f7);
// SHUTDOWN
const $117bd14fbc9aa91f$export$9d68ba11045ae7c3 = 'state.actions.lifecycle.SHUTDOWN';
const $117bd14fbc9aa91f$export$d45c0b180c9b57f7 = ()=>({
        type: $117bd14fbc9aa91f$export$9d68ba11045ae7c3
    });

});


parcelRegister("eJsZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab16c43a5722f9e9$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $lwxJF = parcelRequire("lwxJF");

var $itTYs = parcelRequire("itTYs");

var $bf2xA = parcelRequire("bf2xA");

var $eCJKS = parcelRequire("eCJKS");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab16c43a5722f9e9$export$2e2bcd8739ae039 = (push)=>// @ts-expect-error - TS2322: Type 'unknown' is not assignable to type 'Action'.
    (0, $4tM8k.combineEpics)((0, $bf2xA.default)(push), (0, $eCJKS.default)(push), (0, $itTYs.default)(push), (0, $lwxJF.default));

});
parcelRegister("lwxJF", function(module, exports) {

$parcel$export(module.exports, "default", () => $85cef11eb6068ea2$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("d2zWP");

var $dFg4o = parcelRequire("dFg4o");
parcelRequire("baP6E");
parcelRequire("8gLG0");

var $7kixv = parcelRequire("7kixv");

var $jbhXM = parcelRequire("jbhXM");

var $7jTnu = parcelRequire("7jTnu");

var $7WQX3 = parcelRequire("7WQX3");

var $bGwJI = parcelRequire("bGwJI");


var $1EACp = parcelRequire("1EACp");

var $cVlq2 = parcelRequire("cVlq2");

var $cpZzK = parcelRequire("cpZzK");

var $2MzoN = parcelRequire("2MzoN");

var $bKkYU = parcelRequire("bKkYU");

var $ea3Ck = parcelRequire("ea3Ck");

var $iGYMr = parcelRequire("iGYMr");

var $lc49q = parcelRequire("lc49q");

var $6I1gv = parcelRequire("6I1gv");

var $baH07 = parcelRequire("baH07");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$85cef11eb6068ea2$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $ea3Ck.QUEUE_CHANGED)).switchMap((action)=>{
        const state = store.getState();
        const isInitialLoad = (0, $baH07.getIsInitialLoad)(state);
        const hasSsr = (0, $baH07.hasSsrData)(state);
        const { queue: sortedQueue } = action.payload;
        const queueId = sortedQueue.id;
        if ((0, $6I1gv.hasPageError)(state)) return (0, $7kixv.Observable).of((0, $bKkYU.reloadPageDataAction)(queueId));
        if (!(0, $lc49q.isQueueMateriallyDifferent)(state, sortedQueue)) return (0, $7kixv.Observable).of((0, $ea3Ck.setQueueAction)(sortedQueue));
        // QUEUE_CHANGED is also called on the first load for queue which was loaded from SSR
        // if that's the case, we don't need to check local storage for issues as issues from SSR
        // are already in the state, and issues from local storage might be outdated
        if (isInitialLoad && hasSsr && (0, $baH07.getSsrQueueId)(state) === queueId && (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page')) {
            // we do not want to trigger /issuelist/updated immediately to not create a visual changes when hydrating from SSR
            // this is why we will trigger it only after app is idle, i.e. TTAI happens
            (0, $jbhXM.unstable_scheduleCallback)((0, $jbhXM.unstable_IdlePriority), ()=>{
                store.dispatch(// @ts-expect-error - TS2345 - Argument of type 'LoadIssuesAction' is not assignable to parameter of type 'State'.
                (0, $2MzoN.loadIssuesAction)(0, (0, $f3fa5acbda0f3e0e$export$f162a928a40c7ab8), true, (0, $bGwJI.FETCH_SIZE_IN_INITIAL_LOAD)));
            });
            return (0, $7kixv.Observable).concat((0, $7kixv.Observable).of((0, $ea3Ck.setQueueAction)(sortedQueue)));
        }
        const columnTypesAsJson = (0, $7WQX3.getFieldTypesEligibleForJsonData)();
        const { columns: columns, jql: jql } = sortedQueue;
        const actions = [
            (0, $cVlq2.experienceTrackingResetAction)(),
            (0, $cpZzK.filterQueryChangedAction)(null),
            (0, $ea3Ck.setQueueAction)(sortedQueue),
            (0, $iGYMr.pageChangedAction)(1),
            (0, $2MzoN.loadIssuesAction)(0, (0, $f3fa5acbda0f3e0e$export$f162a928a40c7ab8), true, isInitialLoad ? (0, $bGwJI.FETCH_SIZE_IN_INITIAL_LOAD) : undefined)
        ];
        return (0, $1EACp.maybeIssuesInLocalStorage)(queueId, jql, columns, columnTypesAsJson, null).cata(()=>(0, $7kixv.Observable).of((0, $dFg4o.batchActions)(actions)), // @ts-expect-error - TS7006 - Parameter 'issues' implicitly has an 'any' type.
        (issues)=>(0, $7kixv.Observable).of((0, $dFg4o.batchActions)([
                ...actions,
                (0, $2MzoN.loadIssuesSuccessAction)(issues, queueId, 0, (0, $f3fa5acbda0f3e0e$export$f162a928a40c7ab8))
            ])));
    });

});
parcelRegister("cVlq2", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCE_TRACKING_RESET", () => $83895d4ac1b49513$export$70281a0b6f2c039e);
$parcel$export(module.exports, "experienceTrackingResetAction", () => $83895d4ac1b49513$export$ce671cb9c43406e2);
// EXPERIENCE_TRACKING_RESET
const $83895d4ac1b49513$export$70281a0b6f2c039e = 'state.actions.experience-tracking.EXPERIENCE_TRACKING_RESET';
const $83895d4ac1b49513$export$ce671cb9c43406e2 = ()=>({
        type: $83895d4ac1b49513$export$70281a0b6f2c039e
    });

});

parcelRegister("ea3Ck", function(module, exports) {

$parcel$export(module.exports, "EDIT_QUEUE", () => $8b5e991db386763f$export$e6f7be4f3096aeae);
$parcel$export(module.exports, "editQueueAction", () => $8b5e991db386763f$export$f6652267a5390fe1);
$parcel$export(module.exports, "CLONE_QUEUE", () => $8b5e991db386763f$export$83e90b00e7702db8);
$parcel$export(module.exports, "cloneQueueAction", () => $8b5e991db386763f$export$1db711c2821ce3f4);
$parcel$export(module.exports, "QUEUE_CHANGED", () => $8b5e991db386763f$export$6c2e1579a5716bb5);
$parcel$export(module.exports, "queueChangedAction", () => $8b5e991db386763f$export$1e1b815e3dd544e);
$parcel$export(module.exports, "SET_QUEUE", () => $8b5e991db386763f$export$45923f75df5860e7);
$parcel$export(module.exports, "setQueueAction", () => $8b5e991db386763f$export$a22fe719d6fd366f);
const $8b5e991db386763f$export$e6f7be4f3096aeae = 'state.actions.queue.EDIT_QUEUE';
const $8b5e991db386763f$export$f6652267a5390fe1 = ()=>({
        type: $8b5e991db386763f$export$e6f7be4f3096aeae
    });
const $8b5e991db386763f$export$83e90b00e7702db8 = 'state.actions.queue.CLONE_QUEUE';
const $8b5e991db386763f$export$1db711c2821ce3f4 = (category)=>({
        type: $8b5e991db386763f$export$83e90b00e7702db8,
        payload: {
            category: category
        }
    });
const $8b5e991db386763f$export$6c2e1579a5716bb5 = 'state.actions.queue.QUEUE_CHANGED';
const $8b5e991db386763f$export$1e1b815e3dd544e = (queue)=>({
        type: $8b5e991db386763f$export$6c2e1579a5716bb5,
        payload: {
            queue: queue
        }
    });
const $8b5e991db386763f$export$45923f75df5860e7 = 'state.actions.queue.SET_QUEUE';
const $8b5e991db386763f$export$a22fe719d6fd366f = (queue)=>({
        type: $8b5e991db386763f$export$45923f75df5860e7,
        payload: {
            queue: queue
        }
    });

});


parcelRegister("itTYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $218b3ad07442037e$export$2e2bcd8739ae039);
parcelRequire("d2zWP");

var $5SwkH = parcelRequire("5SwkH");

var $2IsS5 = parcelRequire("2IsS5");

var $f20Bj = parcelRequire("f20Bj");

var $ea3Ck = parcelRequire("ea3Ck");

var $lc49q = parcelRequire("lc49q");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$218b3ad07442037e$export$2e2bcd8739ae039 = (push)=>(action$, store)=>action$.ofType((0, $ea3Ck.CLONE_QUEUE)).switchMap((action)=>{
            const { payload: { category: category } } = action;
            const state = store.getState();
            const projectKey = (0, $f20Bj.getProjectKey)(state);
            const queueId = (0, $lc49q.getQueueId)(state);
            if (push) return push((0, $5SwkH.getCloneQueueFragment)((0, $2IsS5.fromQueueId)(queueId), category));
            // fallback to push state nav in case anything goes wrong.
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            return (0, $5SwkH.navigate)(projectKey, (0, $5SwkH.getCloneQueueFragment)((0, $2IsS5.fromQueueId)(queueId), category));
        });

});

parcelRegister("bf2xA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec610892e13db506$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("d2zWP");

var $7kixv = parcelRequire("7kixv");

var $2ZYsz = parcelRequire("2ZYsz");

var $5SwkH = parcelRequire("5SwkH");

var $f20Bj = parcelRequire("f20Bj");

var $fHAel = parcelRequire("fHAel");

var $aXT93 = parcelRequire("aXT93");

var $lc49q = parcelRequire("lc49q");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ec610892e13db506$export$2e2bcd8739ae039 = (push)=>(action$, store)=>action$.ofType((0, $aXT93.DELETE_QUEUE)).switchMap((action)=>{
            const state = store.getState();
            const { payload: { queueId: queueId, onDeleteComplete: onDeleteComplete }, meta: { analyticsEvent: analyticsEvent } } = action;
            const queueName = (0, $lc49q.getQueueName)(state);
            const payload = {
                deleted: [
                    queueId
                ]
            };
            return (0, $fHAel.default)(payload, state).flatMap(()=>{
                const analyticsProperties = {
                    action: 'deleted',
                    containerType: 'project',
                    containerId: (0, $f20Bj.getProjectId)(state).toString(),
                    objectType: 'queue',
                    objectId: queueId,
                    attributes: {
                        redesign: true
                    }
                };
                // @ts-expect-error TS2345 | TS2345 - Argument of type '{ action: string; containerType: string; containerId: string; objectType: string; objectId: number; attributes: { redesign: boolean; }; }' is not assignable to parameter of type 'Readonly<Readonly<{ name?: string | undefined; containerId?: string | undefined; containers?: Containers | undefined; containerType?: string | undefined; objectType?: string | undefined; objectId?: string | undefined; readonly tags?: readonly string[] | undefined; attributes?: Readonly<...> | undefined; }> & { ...; }>'. | Argument of type '{ action: string; containerType: string; containerId: string; objectType: string; objectId: number; attributes: { redesign: boolean; }; }' is not assignable to parameter of type 'Readonly<Readonly<{ name?: string | undefined; containerId?: string | undefined; containers?: Containers | undefined; containerType?: string | undefined; objectType?: string | undefined; objectId?: string | undefined; readonly tags?: readonly string[] | undefined; attributes?: Readonly<...> | undefined; }> & { ...; }>'.
                (0, $2ZYsz.fireTrackAnalytics)(analyticsEvent, analyticsProperties);
                onDeleteComplete(queueId);
                if (push) {
                    const category = (0, $lc49q.getCategory)(state);
                    return push((0, $5SwkH.getQueueFragment)(undefined, category));
                }
                return (0, $7kixv.Observable).of((0, $aXT93.setDeleteModalVisibilityAction)(false), // @ts-expect-error - TS2769 - No overload matches this call.
                (0, $aXT93.setModalIsDeletingAction)(false));
            }).catch((error)=>(0, $7kixv.Observable).of((0, $aXT93.setDeleteModalVisibilityAction)(false), // @ts-expect-error - TS2769 - No overload matches this call.
                (0, $aXT93.deleteQueueFailureAction)(queueName, error.response), (0, $aXT93.setModalIsDeletingAction)(false)));
        });

});
parcelRegister("fHAel", function(module, exports) {

$parcel$export(module.exports, "default", () => $36b6a54756faa530$export$2e2bcd8739ae039);
$parcel$export(module.exports, "updateQueuePromise", () => $36b6a54756faa530$export$f234ead1318b17ac);

var $f5xwW = parcelRequire("f5xwW");

var $f20Bj = parcelRequire("f20Bj");

var $8b0lh = parcelRequire("8b0lh");

var $2MNyX = parcelRequire("2MNyX");
const $36b6a54756faa530$export$7adc0d541825d917 = (page)=>(0, $2MNyX.pageToQueues)(page);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$36b6a54756faa530$export$2e2bcd8739ae039 = (payload, state)=>// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    (0, $f5xwW.default)((0, $8b0lh.default)((0, $f20Bj.getProjectKey)(state), payload), $36b6a54756faa530$export$7adc0d541825d917);
const $36b6a54756faa530$export$f234ead1318b17ac = (payload, projectKey)=>(0, $8b0lh.default)(projectKey, payload).toPromise().then($36b6a54756faa530$export$7adc0d541825d917);

});
parcelRegister("8b0lh", function(module, exports) {

$parcel$export(module.exports, "default", () => $681bcd68464cb1f6$export$2e2bcd8739ae039);

var $l8ZcU = parcelRequire("l8ZcU");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$681bcd68464cb1f6$export$2e2bcd8739ae039 = (projectKey, payload)=>(0, $l8ZcU.fetchJson$)(`/rest/servicedesk/1/servicedesk/${projectKey}/queues`, {
        method: 'PUT',
        body: JSON.stringify(payload)
    });

});


parcelRegister("aXT93", function(module, exports) {

$parcel$export(module.exports, "ONBOARDING_RESOLVED", () => $ca7fdccc5dde7379$export$bc6edc14c190bba8);
$parcel$export(module.exports, "onboardingResolvedAction", () => $ca7fdccc5dde7379$export$796732fe0ca79daa);
$parcel$export(module.exports, "SET_DELETE_MODAL_VISIBILITY", () => $ca7fdccc5dde7379$export$f22130204a023293);
$parcel$export(module.exports, "setDeleteModalVisibilityAction", () => $ca7fdccc5dde7379$export$190dceccabe571f5);
$parcel$export(module.exports, "SET_MODAL_IS_DELETING", () => $ca7fdccc5dde7379$export$f95c039bb3ac7543);
$parcel$export(module.exports, "setModalIsDeletingAction", () => $ca7fdccc5dde7379$export$99f97fd8f5eb3051);
$parcel$export(module.exports, "DELETE_QUEUE", () => $ca7fdccc5dde7379$export$5ab05b9e296b458f);
$parcel$export(module.exports, "deleteQueueAction", () => $ca7fdccc5dde7379$export$582ac7ef548f7ea3);
$parcel$export(module.exports, "DELETE_QUEUE_FAILURE", () => $ca7fdccc5dde7379$export$c87901f527c6ecbf);
$parcel$export(module.exports, "deleteQueueFailureAction", () => $ca7fdccc5dde7379$export$c9318fa931763930);
$parcel$export(module.exports, "SET_NAV_COLLAPSED", () => $ca7fdccc5dde7379$export$a3657f3e279415da);
$parcel$export(module.exports, "setNavCollapsedAction", () => $ca7fdccc5dde7379$export$24eece95a2a56eca);
$parcel$export(module.exports, "SET_ISSUE_KEY_CONTEXT", () => $ca7fdccc5dde7379$export$ad460ac72e5ca5db);
$parcel$export(module.exports, "setIssueKeyContext", () => $ca7fdccc5dde7379$export$e203161ddfaf33fa);
$parcel$export(module.exports, "SET_SIDEBAR_ISSUE_KEY", () => $ca7fdccc5dde7379$export$8d3ef3d3f35457dd);
$parcel$export(module.exports, "setSidebarIssueKey", () => $ca7fdccc5dde7379$export$31f0fd7bef8d8084);
$parcel$export(module.exports, "SET_SIDEBAR_REACT_KEY", () => $ca7fdccc5dde7379$export$e61a8facd12c5b11);
$parcel$export(module.exports, "SET_SELECTED_ISSUE_KEYS", () => $ca7fdccc5dde7379$export$ff2fe70017e5b8bb);
$parcel$export(module.exports, "setSelectedIssueKeys", () => $ca7fdccc5dde7379$export$bf3ca5f3d49d924b);
$parcel$export(module.exports, "REFRESH_SIDEBAR_ISSUE_VIEW", () => $ca7fdccc5dde7379$export$1801c47649c78d8c);
$parcel$export(module.exports, "refreshSidebarIssueView", () => $ca7fdccc5dde7379$export$38079ab67858e297);
const $ca7fdccc5dde7379$export$bc6edc14c190bba8 = 'state.actions.ui.ONBOARDING_RESOLVED';
const $ca7fdccc5dde7379$export$796732fe0ca79daa = (onboardingResolved)=>({
        type: $ca7fdccc5dde7379$export$bc6edc14c190bba8,
        payload: {
            onboardingResolved: onboardingResolved
        }
    });
const $ca7fdccc5dde7379$export$f22130204a023293 = 'state.actions.ui.SET_DELETE_MODAL_VISIBILITY';
const $ca7fdccc5dde7379$export$190dceccabe571f5 = (isVisible)=>({
        type: $ca7fdccc5dde7379$export$f22130204a023293,
        payload: {
            isVisible: isVisible
        }
    });
const $ca7fdccc5dde7379$export$f95c039bb3ac7543 = 'state.actions.ui.SET_MODAL_IS_DELETING';
const $ca7fdccc5dde7379$export$99f97fd8f5eb3051 = (isDeleting)=>({
        type: $ca7fdccc5dde7379$export$f95c039bb3ac7543,
        payload: {
            isDeleting: isDeleting
        }
    });
const $ca7fdccc5dde7379$export$5ab05b9e296b458f = 'state.actions.ui.DELETE_QUEUE';
const $ca7fdccc5dde7379$export$582ac7ef548f7ea3 = (queueId, onDeleteComplete, analyticsEvent)=>({
        type: $ca7fdccc5dde7379$export$5ab05b9e296b458f,
        payload: {
            queueId: queueId,
            onDeleteComplete: onDeleteComplete
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $ca7fdccc5dde7379$export$c87901f527c6ecbf = 'state.actions.ui.DELETE_QUEUE_FAILURE';
const $ca7fdccc5dde7379$export$c9318fa931763930 = (queueName, error)=>({
        type: $ca7fdccc5dde7379$export$c87901f527c6ecbf,
        payload: {
            error: error,
            queueName: queueName
        }
    });
const $ca7fdccc5dde7379$export$a3657f3e279415da = 'state.actions.ui.SET_NAV_COLLAPSED';
const $ca7fdccc5dde7379$export$24eece95a2a56eca = (isNavCollapsed)=>({
        type: $ca7fdccc5dde7379$export$a3657f3e279415da,
        payload: {
            isNavCollapsed: isNavCollapsed
        }
    });
const $ca7fdccc5dde7379$export$ad460ac72e5ca5db = 'state.actions.ui.SET_ISSUE_KEY_CONTEXT';
const $ca7fdccc5dde7379$export$e203161ddfaf33fa = (issueKey)=>({
        type: $ca7fdccc5dde7379$export$ad460ac72e5ca5db,
        payload: {
            issueKey: issueKey
        }
    });
const $ca7fdccc5dde7379$export$8d3ef3d3f35457dd = 'state.actions.ui.SET_SIDEBAR_ISSUE_KEY';
const $ca7fdccc5dde7379$export$31f0fd7bef8d8084 = (sidebarIssueKey)=>({
        type: $ca7fdccc5dde7379$export$8d3ef3d3f35457dd,
        payload: {
            sidebarIssueKey: sidebarIssueKey
        }
    });
const $ca7fdccc5dde7379$export$e61a8facd12c5b11 = 'state.actions.ui.SET_SIDEBAR_REACT_KEY';
const $ca7fdccc5dde7379$export$f3d2a7eb1d1eb1db = (sidebarReactKey)=>({
        type: $ca7fdccc5dde7379$export$e61a8facd12c5b11,
        payload: {
            sidebarReactKey: sidebarReactKey
        }
    });
const $ca7fdccc5dde7379$export$ff2fe70017e5b8bb = 'state.actions.ui.SET_SELECTED_ISSUE_KEYS';
const $ca7fdccc5dde7379$export$bf3ca5f3d49d924b = (selectedIssueKeys)=>({
        type: $ca7fdccc5dde7379$export$ff2fe70017e5b8bb,
        payload: {
            selectedIssueKeys: selectedIssueKeys
        }
    });
const $ca7fdccc5dde7379$export$1801c47649c78d8c = 'state.actions.ui.REFRESH_SIDEBAR_ISSUE_VIEW';
const $ca7fdccc5dde7379$export$38079ab67858e297 = ({ issueKey: issueKey } = {})=>({
        type: $ca7fdccc5dde7379$export$1801c47649c78d8c,
        payload: {
            issueKey: issueKey
        }
    });

});


parcelRegister("eCJKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf333f02dc89585$export$2e2bcd8739ae039);
parcelRequire("d2zWP");

var $5SwkH = parcelRequire("5SwkH");

var $2IsS5 = parcelRequire("2IsS5");

var $f20Bj = parcelRequire("f20Bj");

var $ea3Ck = parcelRequire("ea3Ck");

var $lc49q = parcelRequire("lc49q");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5cf333f02dc89585$export$2e2bcd8739ae039 = (push)=>(action$, store)=>action$.ofType((0, $ea3Ck.EDIT_QUEUE)).switchMap(()=>{
            const state = store.getState();
            const projectKey = (0, $f20Bj.getProjectKey)(state);
            const queueId = (0, $lc49q.getQueueId)(state);
            const category = (0, $lc49q.getCategory)(state);
            if (push) return push((0, $5SwkH.getEditQueueFragment)((0, $2IsS5.fromQueueId)(queueId), category));
            // fallback to push state nav in case anything goes wrong.
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            return (0, $5SwkH.navigate)(projectKey, (0, $5SwkH.getEditQueueFragment)((0, $2IsS5.fromQueueId)(queueId), category));
        });

});


parcelRegister("hA0qE", function(module, exports) {

$parcel$export(module.exports, "default", () => $594f8af8c84e8351$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("c1D7V");
parcelRequire("d2zWP");

var $7kixv = parcelRequire("7kixv");

var $ajASe = parcelRequire("ajASe");

var $f20Bj = parcelRequire("f20Bj");

var $f1JDi = parcelRequire("f1JDi");

var $bKkYU = parcelRequire("bKkYU");

var $ea3Ck = parcelRequire("ea3Ck");

var $lc49q = parcelRequire("lc49q");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$594f8af8c84e8351$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $bKkYU.LOAD_PAGE_DATA), (0, $ea3Ck.QUEUE_CHANGED)).switchMap((action)=>{
        const { payload: payload, type: type } = action;
        const queueId = type === (0, $bKkYU.LOAD_PAGE_DATA) ? payload.queueId : payload.queue.id;
        const state = store.getState();
        const projectKey = (0, $f20Bj.getProjectKey)(state);
        if ((0, $lc49q.isQueueTransient)(state)) return (0, $7kixv.Observable).empty();
        // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
        return (0, $f1JDi.default)(projectKey, queueId).switchMap(()=>(0, $7kixv.Observable).empty()).catch((error)=>{
            (0, $ajASe.default).safeWarnWithoutCustomerData('servicedesk.queues.agent-view.ops.recent.add', `Failed to add recent queue - error: ${JSON.stringify(error)}`, {
                queueId: queueId
            });
            return (0, $7kixv.Observable).empty();
        });
    });

});
parcelRegister("f1JDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c660252cae14b5ca$export$2e2bcd8739ae039);

var $l8ZcU = parcelRequire("l8ZcU");

var $2IsS5 = parcelRequire("2IsS5");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c660252cae14b5ca$export$2e2bcd8739ae039 = (projectKey, queueId)=>{
    const queueIdStr = (0, $2IsS5.fromQueueId)(queueId).toString();
    const params = new URLSearchParams();
    params.set('queueId', queueIdStr);
    params.set('operation', 'fetchQueuesHistory');
    const url = `/rest/servicedesk/1/servicedesk/${projectKey}/queues-history?${params.toString()}`;
    return (0, $l8ZcU.fetchJson$)(url, {
        method: 'POST'
    });
};

});


parcelRegister("6o620", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d00f311525cec0d$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");
parcelRequire("9BkTq");
parcelRequire("d2zWP");


var $2MzoN = parcelRequire("2MzoN");

var $iGYMr = parcelRequire("iGYMr");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4d00f311525cec0d$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $iGYMr.FETCH_ISSUE_DATA_ONSCROLL)).switchMap((action)=>(0, $7kixv.Observable).of((0, $2MzoN.loadIssuesAction)(action.payload, (0, $f3fa5acbda0f3e0e$export$d4d94a8c13e2df1d))));

});

parcelRegister("bqJ8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $922c197771d61752$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $jhjNq = parcelRequire("jhjNq");

var $4v5Ot = parcelRequire("4v5Ot");

var $dyjnh = parcelRequire("dyjnh");

var $4sYuR = parcelRequire("4sYuR");
var $922c197771d61752$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $jhjNq.default), (0, $dyjnh.default), (0, $4v5Ot.default), (0, $4sYuR.default));

});
parcelRegister("jhjNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fba4f14ea3c8b1de$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("d2zWP");

var $7kixv = parcelRequire("7kixv");


var $2MzoN = parcelRequire("2MzoN");

var $iGYMr = parcelRequire("iGYMr");

var $lc49q = parcelRequire("lc49q");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fba4f14ea3c8b1de$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $iGYMr.SORT_ORDER_CHANGED)).switchMap((action)=>{
        const state = store.getState();
        const queueId = (0, $lc49q.getQueueId)(state);
        const { sortedBy: sortedBy, sortOrder: sortOrder } = action.payload;
        return (0, $7kixv.Observable).of((0, $iGYMr.sortOrderOptimisticUpdateAction)(queueId, sortedBy, sortOrder), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $2MzoN.loadIssuesAction)(0, (0, $f3fa5acbda0f3e0e$export$2003e3fdddd4c35b)));
    });

});

parcelRegister("4v5Ot", function(module, exports) {

$parcel$export(module.exports, "default", () => $55b62ec27bde8e36$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("d2zWP");
parcelRequire("c1D7V");

var $7kixv = parcelRequire("7kixv");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");

var $ajASe = parcelRequire("ajASe");

var $fpTtT = parcelRequire("fpTtT");

var $iGYMr = parcelRequire("iGYMr");

var $cqBpI = parcelRequire("cqBpI");

var $lc49q = parcelRequire("lc49q");

var $2EkyV = parcelRequire("2EkyV");
const $55b62ec27bde8e36$var$epic = (action$, store)=>action$.ofType((0, $iGYMr.RESET_SORT_ORDER)).switchMap(()=>{
        const state = store.getState();
        const accountId = (0, $2EkyV.getAccountId)(state);
        const queueId = (0, $lc49q.getQueueId)(state);
        const createAnalyticsEvent = (0, $cqBpI.getCreateAnalyticsEvent)(state);
        return (0, $fpTtT.removeQueueIssuesSortingDataUserProperty)(queueId, accountId).switchMap(()=>{
            if (createAnalyticsEvent) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'viewQueueManualSortingToUserProperty reset');
            return (0, $7kixv.Observable).empty();
        }).catch((error)=>{
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'opsRemoveQueueSorting',
                    packageName: 'jira-servicedesk-queues-agent-view',
                    teamName: 'Flash'
                }
            });
            (0, $ajASe.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.ops', 'User properties failure for reset sorting');
            return (0, $7kixv.Observable).empty();
        });
    });
var $55b62ec27bde8e36$export$2e2bcd8739ae039 = $55b62ec27bde8e36$var$epic;

});
parcelRegister("fpTtT", function(module, exports) {

$parcel$export(module.exports, "removeQueueIssuesSortingDataUserProperty", () => $31c32dbe8d60b721$export$6f099fa03e8e42e9);
$parcel$export(module.exports, "updateQueueIssuesSortingDataUserProperty", () => $31c32dbe8d60b721$export$d117216f4f9bafb6);

var $l8ZcU = parcelRequire("l8ZcU");

const $31c32dbe8d60b721$export$2f7635a22c9f0f05 = (queueId)=>`${0, $bbd0c274fc29919b$export$380a2d1eea3be734}${queueId}`;
const $31c32dbe8d60b721$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $31c32dbe8d60b721$var$MISSING_ACCOUNT_ID_ERROR_MSG = 'accountId is missing.';
const $31c32dbe8d60b721$export$6f099fa03e8e42e9 = (queueId, accountId)=>{
    if (!accountId) throw new Error($31c32dbe8d60b721$var$MISSING_ACCOUNT_ID_ERROR_MSG);
    return (0, $l8ZcU.fetchJson$)($31c32dbe8d60b721$export$f474e53c8191800a(accountId, $31c32dbe8d60b721$export$2f7635a22c9f0f05(queueId)), {
        method: 'DELETE'
    });
};
const $31c32dbe8d60b721$export$d117216f4f9bafb6 = (data, queueId, accountId)=>{
    if (!accountId) throw new Error($31c32dbe8d60b721$var$MISSING_ACCOUNT_ID_ERROR_MSG);
    return (0, $l8ZcU.fetchText$)($31c32dbe8d60b721$export$f474e53c8191800a(accountId, $31c32dbe8d60b721$export$2f7635a22c9f0f05(queueId)), {
        method: 'PUT',
        body: JSON.stringify(data)
    });
};

});

parcelRegister("2EkyV", function(module, exports) {

$parcel$export(module.exports, "getAccountId", () => $2e3c618e0e7d12f4$export$c1e0336bde96e2dc);
const $2e3c618e0e7d12f4$export$c1e0336bde96e2dc = (state)=>state.appProps.atlassianAccountId;

});


parcelRegister("dyjnh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4cda53b8dc4906b$export$2e2bcd8739ae039);
parcelRequire("1o2WJ");

var $7kixv = parcelRequire("7kixv");


var $2MzoN = parcelRequire("2MzoN");

var $iGYMr = parcelRequire("iGYMr");
parcelRequire("9BkTq");
parcelRequire("d2zWP");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e4cda53b8dc4906b$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $iGYMr.RESET_SORT_ORDER)).switchMap(()=>(0, $7kixv.Observable).of((0, $iGYMr.sortOrderOptimisticResetAction)(), // @ts-expect-error - TS2769 - No overload matches this call.
        (0, $2MzoN.loadIssuesAction)(0, (0, $f3fa5acbda0f3e0e$export$2003e3fdddd4c35b))));

});

parcelRegister("4sYuR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2a316e60fe0dba8$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("d2zWP");
parcelRequire("c1D7V");

var $7kixv = parcelRequire("7kixv");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");

var $ajASe = parcelRequire("ajASe");

var $fpTtT = parcelRequire("fpTtT");

var $iGYMr = parcelRequire("iGYMr");

var $cqBpI = parcelRequire("cqBpI");

var $lc49q = parcelRequire("lc49q");

var $2EkyV = parcelRequire("2EkyV");
const $a2a316e60fe0dba8$var$epic = (action$, store)=>action$.ofType((0, $iGYMr.SORT_ORDER_CHANGED)).switchMap((action)=>{
        const state = store.getState();
        const queueId = (0, $lc49q.getQueueId)(state);
        const manualSorting = action.payload;
        const accountId = (0, $2EkyV.getAccountId)(state);
        const createAnalyticsEvent = (0, $cqBpI.getCreateAnalyticsEvent)(state);
        return (0, $fpTtT.updateQueueIssuesSortingDataUserProperty)(manualSorting, queueId, accountId).switchMap(()=>{
            if (createAnalyticsEvent) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'viewQueueManualSortingToUserProperty updated');
            return (0, $7kixv.Observable).empty();
        }).catch((error)=>{
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'opsUpdateQueueSorting',
                    packageName: 'jira-servicedesk-queues-agent-view',
                    teamName: 'Flash'
                }
            });
            (0, $ajASe.default).safeErrorWithoutCustomerData('servicedesk.queues.agent-view.ops', 'User properties failure for update sorting');
            return (0, $7kixv.Observable).empty();
        });
    });
var $a2a316e60fe0dba8$export$2e2bcd8739ae039 = $a2a316e60fe0dba8$var$epic;

});


parcelRegister("iL21K", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a67c3eb77b7a4ca$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("d2zWP");

var $7kixv = parcelRequire("7kixv");

var $2ZYsz = parcelRequire("2ZYsz");

var $2IsS5 = parcelRequire("2IsS5");

var $f20Bj = parcelRequire("f20Bj");

var $iGYMr = parcelRequire("iGYMr");

var $1TuhT = parcelRequire("1TuhT");

var $lgeFD = parcelRequire("lgeFD");

var $jmHUF = parcelRequire("jmHUF");

var $lc49q = parcelRequire("lc49q");

var $4LfWe = parcelRequire("4LfWe");

var $6I1gv = parcelRequire("6I1gv");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5a67c3eb77b7a4ca$var$onTableChange = (state, analyticsEvent)=>{
    const queueId = (0, $lc49q.getQueueId)(state);
    const issueKeys = (0, $lgeFD.getIssueKeysForPage)(state);
    const sortedBy = (0, $4LfWe.getSortedByColumn)(state);
    const sortOrder = (0, $4LfWe.getSortOrder)(state);
    const atlassianAccountId = (0, $f20Bj.getAtlassianAccountId)(state);
    const issueStatusIdsCountsInQueue = (0, $1TuhT.getIssueStatusIdsCounts)(state);
    const numberOfIssuesAssignedToCurrentUser = (0, $1TuhT.getIssueCountByAssignee)(state, atlassianAccountId);
    !(0, $6I1gv.isLoadingIssues)(state) && (0, $2ZYsz.fireTrackAnalytics)(analyticsEvent, {
        containerType: 'project',
        containerId: `${(0, $f20Bj.getProjectId)(state)}`,
        action: 'viewed',
        objectType: 'queue',
        objectId: `${(0, $2IsS5.fromQueueId)(queueId)}`,
        actionSubjectId: `${(0, $2IsS5.fromQueueId)(queueId)}`,
        attributes: {
            isAdmin: (0, $f20Bj.getIsAdmin)(state),
            isTransient: (0, $lc49q.isQueueTransient)(state),
            numberOfIssuesDisplayed: issueKeys.length,
            numberOfColumnsDisplayed: (0, $lc49q.getNumberOfColumns)(state),
            displayedColumnsInOrder: (0, $lc49q.getAllFieldTypes)(state),
            sortedByColumnId: sortedBy,
            sortOrder: sortOrder,
            // store as a list of 1 to prevent amplitude creating too many attributes
            issueStatusIdsCountsInQueue: [
                issueStatusIdsCountsInQueue
            ],
            numberOfIssuesAssignedToCurrentUser: numberOfIssuesAssignedToCurrentUser,
            ...(0, $jmHUF.isItsmProject)(state) ? {
                itsmPractices: (0, $jmHUF.getEnabledPractices)(state)
            } : {}
        }
    });
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$5a67c3eb77b7a4ca$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $iGYMr.TABLE_CHANGED)).switchMap((action)=>{
        $5a67c3eb77b7a4ca$var$onTableChange(store.getState(), action.meta.analyticsEvent);
        return (0, $7kixv.Observable).empty();
    });

});
parcelRegister("jmHUF", function(module, exports) {

$parcel$export(module.exports, "getEnabledPractices", () => $33bfb7d7ff4ca42b$export$8f33cbf43c24a6e7);
$parcel$export(module.exports, "isItsmProject", () => $33bfb7d7ff4ca42b$export$90859dc8800b0a1b);

var $ahm5r = parcelRequire("ahm5r");

var $3l9kN = parcelRequire("3l9kN");

var $jlJsl = parcelRequire("jlJsl");

var $8bvz0 = parcelRequire("8bvz0");

var $lc49q = parcelRequire("lc49q");
const $33bfb7d7ff4ca42b$var$getProjectPractices = (state)=>(0, $8bvz0.getPersisted)(state).practices;
const $33bfb7d7ff4ca42b$export$8f33cbf43c24a6e7 = (0, $ahm5r.createSelector)((0, $lc49q.getCategory), (category = (0, $jlJsl.NO_CATEGORY))=>category === (0, $jlJsl.NO_CATEGORY) ? [] : [
        category
    ]);
const $33bfb7d7ff4ca42b$export$90859dc8800b0a1b = (0, $ahm5r.createSelector)($33bfb7d7ff4ca42b$var$getProjectPractices, (practiceList)=>(0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(practiceList, (0, $jlJsl.NO_CATEGORY)).length > 0);

});



parcelRegister("ebHNt", function(module, exports) {

$parcel$export(module.exports, "SEND_ANALYTIC_CREATOR", () => $5c954340ed0925ab$export$2f4a111814bf0140);
$parcel$export(module.exports, "sendAnalyticCreatorAction", () => $5c954340ed0925ab$export$632dfc648efd02eb);
const $5c954340ed0925ab$export$2f4a111814bf0140 = 'state.actions.analytic.SEND_ANALYTIC_CREATOR';
const $5c954340ed0925ab$export$632dfc648efd02eb = (createAnalyticsEvent)=>({
        type: $5c954340ed0925ab$export$2f4a111814bf0140,
        payload: {
            createAnalyticsEvent: createAnalyticsEvent
        }
    });

});

parcelRegister("ll8hb", function(module, exports) {

$parcel$export(module.exports, "RESET_PROJECT_CONTEXT", () => $27df9aebc4c7d3d6$export$dfc3064c33d1270a);
$parcel$export(module.exports, "resetProjectContextAction", () => $27df9aebc4c7d3d6$export$6a8d4f70c30642d0);
const $27df9aebc4c7d3d6$export$dfc3064c33d1270a = 'state.actions.page.RESET_PROJECT_CONTEXT';
const $27df9aebc4c7d3d6$export$6a8d4f70c30642d0 = (projectContext)=>({
        type: $27df9aebc4c7d3d6$export$dfc3064c33d1270a,
        payload: {
            projectContext: projectContext
        }
    });

});

parcelRegister("fqR30", function(module, exports) {

$parcel$export(module.exports, "default", () => $478a8770ebc39fa1$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $eG6Qd = parcelRequire("eG6Qd");

var $54yP5 = parcelRequire("54yP5");

var $49rgM = parcelRequire("49rgM");
const $478a8770ebc39fa1$var$combinedReducer = (0, $7HHI1.combineReducers)({
    appProps: $eG6Qd.default,
    persisted: $54yP5.default,
    ui: $49rgM.default
});
var $478a8770ebc39fa1$export$2e2bcd8739ae039 = $478a8770ebc39fa1$var$combinedReducer;

});
parcelRegister("eG6Qd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6776bc38fc6bb6bf$export$2e2bcd8739ae039);

var $ll8hb = parcelRequire("ll8hb");
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $6776bc38fc6bb6bf$var$reducer = (state, action)=>{
    switch(action.type){
        case 0, $ll8hb.RESET_PROJECT_CONTEXT:
            return {
                ...state,
                ...action.payload.projectContext
            };
        default:
            {
                // @ts-expect-error - TS2322 - Type 'ResetProjectContextAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state || null;
            }
    }
};
var $6776bc38fc6bb6bf$export$2e2bcd8739ae039 = $6776bc38fc6bb6bf$var$reducer;

});

parcelRegister("54yP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $69e00dbafc4490dc$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $fKETY = parcelRequire("fKETY");

var $bdtd6 = parcelRequire("bdtd6");

var $bZ8uL = parcelRequire("bZ8uL");

var $bJzeW = parcelRequire("bJzeW");

var $gatZa = parcelRequire("gatZa");

var $7iquC = parcelRequire("7iquC");

var $88qDC = parcelRequire("88qDC");

var $eziZS = parcelRequire("eziZS");
const $69e00dbafc4490dc$var$combinedReducer = (0, $7HHI1.combineReducers)({
    issues: $bJzeW.default,
    queue: $7iquC.default,
    updateMetadata: $eziZS.default,
    experienceTracking: $bdtd6.default,
    practices: $gatZa.default,
    filter: $bZ8uL.default,
    analytic: $fKETY.default,
    ssrIssuesData: $88qDC.default
});
var $69e00dbafc4490dc$export$2e2bcd8739ae039 = $69e00dbafc4490dc$var$combinedReducer;

});
parcelRegister("fKETY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a1babb5856ec189$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $ebHNt = parcelRequire("ebHNt");

var $imTAV = parcelRequire("imTAV");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2a1babb5856ec189$export$2e2bcd8739ae039 = (state = (0, $imTAV.initialState), action)=>{
    switch(action.type){
        case 0, $ebHNt.SEND_ANALYTIC_CREATOR:
            {
                const { createAnalyticsEvent: createAnalyticsEvent } = action.payload;
                return (0, $iWqim.assoc)(state, 'createAnalyticsEvent', createAnalyticsEvent);
            }
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});
parcelRegister("imTAV", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $065072c5332c3db3$export$d4c72bab9d6cc13a);
const $065072c5332c3db3$export$d4c72bab9d6cc13a = {
    createAnalyticsEvent: undefined
};

});


parcelRegister("bdtd6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c37866ad99c2e77$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $7jTnu = parcelRequire("7jTnu");

var $2IsS5 = parcelRequire("2IsS5");



var $cVlq2 = parcelRequire("cVlq2");

var $2MzoN = parcelRequire("2MzoN");

var $bKkYU = parcelRequire("bKkYU");
const $9c37866ad99c2e77$var$initialExperienceTrackingState = {
    initialDataLoadStatus: (0, $92d95f8a5e1140be$export$2fc553b73365b8c4),
    hasLoadedIssueDataFromCache: false
};
const $9c37866ad99c2e77$var$ERROR_STATUS_CODE_ALLOWLIST_OLD = [
    403,
    401,
    429
];
const $9c37866ad99c2e77$var$ERROR_STATUS_CODE_ALLOWLIST = [
    400,
    401,
    403,
    429
];
// We don't want to cover all 400 errors because some might be a bug, in most cases issuelist shouldn't return 400.
const $9c37866ad99c2e77$var$NON_EXPERIENCE_FAILURE_REASON_KEY = [
    'sd.issue.search.invalid.project',
    'Invalid category'
];
const $9c37866ad99c2e77$var$isStatusCodeAnExperienceFailureOld = (statusCode)=>// This indicates that browser has no connectivity
    // @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    Boolean(statusCode) && !$9c37866ad99c2e77$var$ERROR_STATUS_CODE_ALLOWLIST_OLD.includes(statusCode);
const $9c37866ad99c2e77$var$isStatusCodeAnExperienceFailure = (statusCode)=>// This indicates that browser has no connectivity
    // @ts-expect-error - TS2345 - Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    Boolean(statusCode) && !$9c37866ad99c2e77$var$ERROR_STATUS_CODE_ALLOWLIST.includes(statusCode);
const $9c37866ad99c2e77$var$isProjectOrCategoryNotFound = (error, statusCode)=>statusCode === 400 && $9c37866ad99c2e77$var$NON_EXPERIENCE_FAILURE_REASON_KEY.includes(error?.reasonKey);
const $9c37866ad99c2e77$var$isAnExperienceFailure = (error, statusCode)=>{
    if ((0, $7jTnu.fg)('exclude_issue_list_400_from_view_queue')) return $9c37866ad99c2e77$var$isStatusCodeAnExperienceFailure(statusCode);
    return $9c37866ad99c2e77$var$isStatusCodeAnExperienceFailureOld(statusCode) && !$9c37866ad99c2e77$var$isProjectOrCategoryNotFound(error, statusCode);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9c37866ad99c2e77$export$2e2bcd8739ae039 = (state = $9c37866ad99c2e77$var$initialExperienceTrackingState, action)=>{
    switch(action.type){
        case 0, $2MzoN.LOAD_ISSUES_SUCCESS:
            {
                let newStateChain = (0, $iWqim.chain)(state);
                if (action.payload.loadedIssuesResponse.source === (0, $2IsS5.LOCAL_STORAGE_SOURCE)) newStateChain = newStateChain.assoc('hasLoadedIssueDataFromCache', true);
                else if (action.payload.source === (0, $f3fa5acbda0f3e0e$export$f162a928a40c7ab8)) // Do no set status to true if the payload is from localstorage, that doesn't count
                newStateChain = newStateChain.assoc('initialDataLoadStatus', (0, $92d95f8a5e1140be$export$d3ab616c5a76689d));
                return newStateChain.value();
            }
        case 0, $2MzoN.LOAD_ISSUES_FAILURE:
            if (action.payload.source === (0, $f3fa5acbda0f3e0e$export$f162a928a40c7ab8)) {
                if ($9c37866ad99c2e77$var$isAnExperienceFailure(action.payload.error, action.payload.statusCode)) {
                    if ((0, $7jTnu.fg)('adding-more-data-for-viewqueue-and-viewnav-event')) return {
                        ...state,
                        initialDataLoadStatus: (0, $92d95f8a5e1140be$export$70ef9aa03c29b42b),
                        errorStatusCode: action.payload.statusCode,
                        errorMessages: action.payload.error?.errors,
                        errorKey: action.payload.error?.reasonKey,
                        traceId: action.payload.traceId
                    };
                    return {
                        ...state,
                        initialDataLoadStatus: (0, $92d95f8a5e1140be$export$70ef9aa03c29b42b),
                        errorStatusCode: action.payload.statusCode
                    };
                }
                return (0, $iWqim.assoc)(state, 'initialDataLoadStatus', (0, $92d95f8a5e1140be$export$d3ab616c5a76689d));
            }
            return state;
        case 0, $bKkYU.LOAD_PAGE_DATA_FAILURE:
            if ($9c37866ad99c2e77$var$isStatusCodeAnExperienceFailure(action.payload.statusCode)) return (0, $iWqim.assoc)(state, 'initialDataLoadStatus', (0, $92d95f8a5e1140be$export$70ef9aa03c29b42b));
            return state;
        case 0, $bKkYU.RESET_STATE:
        case 0, $cVlq2.EXPERIENCE_TRACKING_RESET:
            return $9c37866ad99c2e77$var$initialExperienceTrackingState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
const $92d95f8a5e1140be$export$2fc553b73365b8c4 = 'pending';
const $92d95f8a5e1140be$export$70ef9aa03c29b42b = 'failed';
const $92d95f8a5e1140be$export$d3ab616c5a76689d = 'succeeded';
const $92d95f8a5e1140be$export$dc375b194b1b79d5 = 'jsm.views-in-queues-agent-view-change-boarding-seen-status';
const $92d95f8a5e1140be$export$b8b9d90f9e5bd72b = 'servicedesk.queues.agent-view';
const $92d95f8a5e1140be$export$d57b6b390e78d90f = 'jsd-shield';
const $92d95f8a5e1140be$export$c0474d356c29ba4d = 'jsm-project-summary-boarding-seen-status';


parcelRegister("bZ8uL", function(module, exports) {

$parcel$export(module.exports, "default", () => $39573e6de8ca723d$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $cpZzK = parcelRequire("cpZzK");

var $2MzoN = parcelRequire("2MzoN");

var $gLzW7 = parcelRequire("gLzW7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$39573e6de8ca723d$export$2e2bcd8739ae039 = (state = (0, $gLzW7.initialState), action)=>{
    switch(action.type){
        case 0, $2MzoN.LOAD_ISSUES_SUCCESS:
            {
                const filtered = action.payload.loadedIssuesResponse.isFiltered;
                return (0, $iWqim.chain)(state).assoc('isCurrentDataFiltered', filtered).assoc('isNewFilterQueryPending', false).value();
            }
        case 0, $cpZzK.FILTER_QUERY_CHANGED:
            {
                const { filterQuery: filterQuery } = action.payload;
                return (0, $iWqim.assoc)(state, 'filterQuery', filterQuery);
            }
        case 0, $cpZzK.IS_NEW_FILTER_QUERY_PENDING:
            {
                const { isNewFilterQueryPending: isNewFilterQueryPending } = action.payload;
                return (0, $iWqim.assoc)(state, 'isNewFilterQueryPending', isNewFilterQueryPending);
            }
        case 0, $cpZzK.IS_FILTER_FOCUSED:
            {
                const { isFilterFocused: isFilterFocused } = action.payload;
                return (0, $iWqim.assoc)(state, 'isFilterFocused', isFilterFocused);
            }
        case 0, $cpZzK.IS_FILTER_FAILED:
            return (0, $iWqim.chain)(state).assoc('isCurrentDataFiltered', true).assoc('isNewFilterQueryPending', false).value();
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("gLzW7", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $f70af100a9a314fa$export$d4c72bab9d6cc13a);
const $f70af100a9a314fa$export$d4c72bab9d6cc13a = {
    filterQuery: null,
    isNewFilterQueryPending: false,
    isCurrentDataFiltered: false,
    isFilterFocused: false
};

});


parcelRegister("bJzeW", function(module, exports) {

$parcel$export(module.exports, "default", () => $be9288df29db25aa$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $6uWhG = parcelRequire("6uWhG");

var $gPCSe = parcelRequire("gPCSe");

var $dcH9w = parcelRequire("dcH9w");

var $cpZzK = parcelRequire("cpZzK");

var $2MzoN = parcelRequire("2MzoN");

var $bKkYU = parcelRequire("bKkYU");

var $iGYMr = parcelRequire("iGYMr");

var $gnL1K = parcelRequire("gnL1K");
const $be9288df29db25aa$var$DEFAULT_ISSUES_STATE = {
    collection: [],
    index: {},
    totalCount: 0
};
const $be9288df29db25aa$var$resetIssuesState = ()=>({
        ...$be9288df29db25aa$var$DEFAULT_ISSUES_STATE,
        timeWhenLastInitialized: (0, $gPCSe.default).now()
    });
// @ts-expect-error - TS2314 - Generic type 'Reducer' requires 1 type argument(s). | TS1016 - A required parameter cannot follow an optional parameter.
const $be9288df29db25aa$var$reducer = (state, action)=>{
    if (state === undefined) return $be9288df29db25aa$var$resetIssuesState();
    switch(action.type){
        case 0, $bKkYU.RESET_STATE:
            return $be9288df29db25aa$var$resetIssuesState();
        case 0, $iGYMr.PAGE_CHANGED:
            return (0, $iWqim.chain)(state).assoc('collection', []).assoc('index', {}).assoc('timeWhenLastInitialized', (0, $gPCSe.default).now()).value();
        case 0, $cpZzK.IS_FILTER_FAILED:
            return (0, $iWqim.chain)(state).assoc('totalCount', 0).value();
        case 0, $2MzoN.LOAD_ISSUES_SUCCESS:
            {
                // This is here because setting the mark in a side effect
                // doesn't guarantee this is fired straight away.
                if (!(0, $6uWhG.getMark)('jsd.performance.profile.queues.issues.loaded')) (0, $6uWhG.setMark)('jsd.performance.profile.queues.issues.loaded');
                const { startIndex: startIndex, loadedIssuesResponse: { totalCount: totalCount, isUsingDefaultSorting: isUsingDefaultSorting }, loadedIssuesResponse: { issues: issues } } = action.payload;
                return (0, $gnL1K.addIssuesResponseToState)(startIndex, totalCount, isUsingDefaultSorting, issues, state);
            }
        case 0, $dcH9w.CHANGE_ISSUE_FIELD_VALUE:
            {
                const { issueKey: issueKey, columnId: columnId, newValue: newValue } = action.payload;
                const issueIndex = state.index[issueKey];
                return (0, $iWqim.updateIn)(state, [
                    'collection'
                ], (issueCollection)=>{
                    // TODO FREE-2659 - unfortunately need to ensure the index entry wasn't stale, restructure issue object array + index -> a store where issues can be accessed by key
                    const issue = issueCollection[issueIndex];
                    if (issue && issue.key === issueKey) {
                        const newIssueValue = (0, $iWqim.updateIn)(issue, [
                            'fields',
                            columnId
                        ], (storedValue)=>(0, $iWqim.merge)(storedValue, newValue));
                        return (0, $iWqim.chain)(issueCollection).set(issueIndex, newIssueValue).value();
                    }
                    return issueCollection;
                });
            }
        case 0, $iGYMr.SORT_ORDER_CHANGED:
            return (0, $iWqim.assoc)(state, 'timeWhenLastInitialized', (0, $gPCSe.default).now());
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $be9288df29db25aa$export$2e2bcd8739ae039 = $be9288df29db25aa$var$reducer;

});
parcelRegister("dcH9w", function(module, exports) {

$parcel$export(module.exports, "CHANGE_ISSUE_FIELD_VALUE", () => $d537f2282514f472$export$cfdceb3f950b2ccc);
$parcel$export(module.exports, "changeIssueFieldValueAction", () => $d537f2282514f472$export$138172374138566d);
// CHANGE_ISSUE_FIELD_VALUE
const $d537f2282514f472$export$cfdceb3f950b2ccc = 'state.actions.issue.field.CHANGE_ISSUE_FIELD_VALUE';
const $d537f2282514f472$export$138172374138566d = (issueKey, columnId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
newValue)=>({
        type: $d537f2282514f472$export$cfdceb3f950b2ccc,
        payload: {
            issueKey: issueKey,
            columnId: columnId,
            newValue: newValue
        }
    });

});

parcelRegister("gnL1K", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ISSUES_STATE", () => $050d278bfcc0f641$export$95fccf325af63293);
$parcel$export(module.exports, "addIssuesResponseToState", () => $050d278bfcc0f641$export$b2c48a44510b4c8);

var $iWqim = parcelRequire("iWqim");

var $cSmYj = parcelRequire("cSmYj");

var $jFHCE = parcelRequire("jFHCE");
const $050d278bfcc0f641$export$95fccf325af63293 = {
    collection: [],
    index: {},
    totalCount: 0,
    timeWhenLastInitialized: 0,
    isUsingDefaultSorting: false
};
const $050d278bfcc0f641$var$updateCollection = (collection, index, issue, startIndex)=>{
    const { key: key } = issue;
    const position = issue.position + startIndex;
    const newCollection = collection;
    // Find where the issue used to live in the collection, and delete if it exists
    if (index[key] != null) {
        const oldPosition = index[key];
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        if (newCollection[oldPosition] != null && newCollection[oldPosition].key === key) delete newCollection[oldPosition];
    }
    newCollection[position] = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(issue, 'position');
    return newCollection;
};
const $050d278bfcc0f641$var$updateIndex = (index, issue, startIndex)=>{
    const { key: key } = issue;
    const position = startIndex + issue.position;
    const newIndex = index;
    newIndex[key] = position;
    return newIndex;
};
const $050d278bfcc0f641$export$b2c48a44510b4c8 = (startIndex, totalCount, isUsingDefaultSorting, issues, state = $050d278bfcc0f641$export$95fccf325af63293)=>{
    // Slice as any issues in collection that exist beyond totalCount need to be deleted
    const collection = state.collection.slice(0, totalCount);
    const index = {
        ...state.index
    };
    issues.forEach((newIssue)=>{
        $050d278bfcc0f641$var$updateCollection(collection, index, newIssue, startIndex);
        $050d278bfcc0f641$var$updateIndex(index, newIssue, startIndex);
    });
    if (state.totalCount === totalCount && state.isUsingDefaultSorting === isUsingDefaultSorting && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(state.index, index) && (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(state.collection, collection)) return state;
    return (0, $iWqim.chain)(state).assoc('collection', collection).assoc('index', index).assoc('totalCount', totalCount).assoc('isUsingDefaultSorting', isUsingDefaultSorting).value();
};

});


parcelRegister("gatZa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8e1de9a911f330f$export$2e2bcd8739ae039);

var $iYrDT = parcelRequire("iYrDT");
const $c8e1de9a911f330f$var$defaultPracticesState = [];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c8e1de9a911f330f$export$2e2bcd8739ae039 = (state = $c8e1de9a911f330f$var$defaultPracticesState, action)=>{
    switch(action.type){
        case 0, $iYrDT.SET_ENABLED_PRACTICES:
            return action.payload.practices;
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});
parcelRegister("iYrDT", function(module, exports) {

$parcel$export(module.exports, "SET_ENABLED_PRACTICES", () => $30f0d9f2fa601445$export$2c78e2c3ded512ec);
$parcel$export(module.exports, "setEnabledPracticesAction", () => $30f0d9f2fa601445$export$d050127f311d3c95);
const $30f0d9f2fa601445$export$2c78e2c3ded512ec = 'state.actions.practices.SET_ENABLED_PRACTICES';
const $30f0d9f2fa601445$export$d050127f311d3c95 = (practices)=>({
        type: $30f0d9f2fa601445$export$2c78e2c3ded512ec,
        payload: {
            practices: practices
        }
    });

});


parcelRegister("7iquC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f2d50e39c5d49a$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $g0bBb = parcelRequire("g0bBb");


var $2MzoN = parcelRequire("2MzoN");

var $bKkYU = parcelRequire("bKkYU");

var $ea3Ck = parcelRequire("ea3Ck");

var $iGYMr = parcelRequire("iGYMr");
const $f6f2d50e39c5d49a$var$DEFAULT_QUEUE_STATE = {
    pagination: {
        currentPage: 1
    },
    fetchStartIndex: 0,
    category: undefined
};
var // SHIELD-3575 This reducer describes queue page data and should be renamed to
// avoid ambiguity with state in ui/current-queue
// eslint-disable-next-line jira/import/no-anonymous-default-export
$f6f2d50e39c5d49a$export$2e2bcd8739ae039 = (state = $f6f2d50e39c5d49a$var$DEFAULT_QUEUE_STATE, action)=>{
    switch(action.type){
        case 0, $bKkYU.LOAD_PAGE_DATA:
        case 0, $bKkYU.RESET_STATE:
            {
                const { queueId: queueId } = action.payload;
                return (0, $iWqim.assoc)($f6f2d50e39c5d49a$var$DEFAULT_QUEUE_STATE, 'queueId', queueId);
            }
        case 0, $bKkYU.LOAD_PAGE_DATA_SUCCESS:
            if (action.payload.queuesWithSorting.manualSorting) return (0, $iWqim.assoc)(state, 'manualSorting', action.payload.queuesWithSorting.manualSorting);
            return state;
        case 0, $iGYMr.PAGE_CHANGED:
            {
                const { currentPage: actionPage } = action.payload;
                let currentPage = Math.max(1, Math.ceil(actionPage));
                if ((0, (/*@__PURE__*/$parcel$interopDefault($g0bBb)))(currentPage)) currentPage = 1;
                return (0, $iWqim.assocIn)(state, [
                    'pagination',
                    'currentPage'
                ], currentPage);
            }
        case 0, $iGYMr.SORT_ORDER_CHANGED:
            return (0, $iWqim.assoc)(state, 'manualSorting', undefined);
        case 0, $iGYMr.RESET_SORT_ORDER:
            return (0, $iWqim.dissoc)(state, 'manualSorting');
        case 0, $2MzoN.LOAD_ISSUES_SUCCESS:
            /* Due to various reason (sorting field id is not longer valid, custom field has been removed, sorting field
    is no longer visible in the queue, etc), the sorting returned from the /issuelist endpoint maybe different
    from what we stored in the state. We should keep them in sync after we got the response. */ return action.payload.source === (0, $f3fa5acbda0f3e0e$export$2003e3fdddd4c35b) || action.payload.source === (0, $f3fa5acbda0f3e0e$export$be4c1ea173a5271a) ? (0, $iWqim.assocIn)(state, [
                'pagination',
                'currentPage'
            ], 1) : state;
        case 0, $iGYMr.FETCH_ISSUE_DATA_ONSCROLL:
            return (0, $iWqim.assoc)(state, 'fetchStartIndex', action.payload);
        case 0, $ea3Ck.QUEUE_CHANGED:
            return (0, $iWqim.assoc)(state, 'category', action.payload.queue.category);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("g0bBb", function(module, exports) {

var $lBtjB = parcelRequire("lBtjB");
/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $ba65a4b582214aac$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $lBtjB(value) && value != +value;
}
module.exports = $ba65a4b582214aac$var$isNaN;

});


parcelRegister("eziZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $649c6e897b0c556d$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $2MzoN = parcelRequire("2MzoN");

var $ir4eL = parcelRequire("ir4eL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$649c6e897b0c556d$export$2e2bcd8739ae039 = (state = {}, action)=>{
    switch(action.type){
        case 0, $2MzoN.LOAD_ISSUES_SUCCESS:
            {
                const { issueHash: issueHash } = action.payload.loadedIssuesResponse;
                return (0, $iWqim.assoc)(state, 'issueHash', issueHash);
            }
        case 0, $ir4eL.POLL_SUCCESS:
            return (0, $iWqim.chain)(state).assoc('projectStateHash', action.payload.projectStateHash).assoc('searchMode', action.payload.searchMode).value();
        case 0, $ir4eL.RESET_PROJECT_STATE_HASH:
            return (0, $iWqim.unset)(state, 'projectStateHash');
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});


parcelRegister("49rgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c00cfd15b2573bb$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $2IsS5 = parcelRequire("2IsS5");


var $cpZzK = parcelRequire("cpZzK");

var $2MzoN = parcelRequire("2MzoN");

var $bKkYU = parcelRequire("bKkYU");

var $iGYMr = parcelRequire("iGYMr");

var $aXT93 = parcelRequire("aXT93");

var $9jSiL = parcelRequire("9jSiL");
const $9c00cfd15b2573bb$var$DEFAULT_UI_STATE = {
    onboardingResolved: false,
    isNavCollapsed: true,
    isHeaderCollapsed: false,
    sidebarIssueKey: null,
    isQueuesErrorHeaderDisplayed: false,
    sidebarReactKey: Math.random().toString()
};
const $9c00cfd15b2573bb$var$rootUiReducer = (state, action)=>{
    switch(action.type){
        case 0, $bKkYU.SET_QUEUE_VISIBILITY:
            return (0, $iWqim.assoc)(state, 'isQueueVisible', action.payload.isQueueVisible);
        case 0, $aXT93.ONBOARDING_RESOLVED:
            return (0, $iWqim.assoc)(state, 'onboardingResolved', action.payload.onboardingResolved);
        case 0, $aXT93.SET_NAV_COLLAPSED:
            return (0, $iWqim.assoc)(state, 'isNavCollapsed', action.payload.isNavCollapsed);
        case 0, $aXT93.SET_DELETE_MODAL_VISIBILITY:
            return (0, $iWqim.chain)(state).setIn([
                'deleteModalOpen'
            ], action.payload.isVisible).value();
        case 0, $aXT93.SET_ISSUE_KEY_CONTEXT:
            return (0, $iWqim.assoc)(state, 'issueKeyContext', action.payload.issueKey);
        case 0, $aXT93.SET_SIDEBAR_ISSUE_KEY:
            return (0, $iWqim.assoc)(state, 'sidebarIssueKey', action.payload.sidebarIssueKey);
        case 0, $aXT93.SET_SIDEBAR_REACT_KEY:
            return (0, $iWqim.assoc)(state, 'sidebarReactKey', action.payload.sidebarReactKey);
        case 0, $aXT93.SET_SELECTED_ISSUE_KEYS:
            return (0, $iWqim.assoc)(state, 'selectedIssueKeys', action.payload.selectedIssueKeys);
        case 0, $aXT93.REFRESH_SIDEBAR_ISSUE_VIEW:
            if (state.sidebarIssueKey && (state.selectedIssueKeys?.includes(state.sidebarIssueKey) || state.sidebarIssueKey === action.payload.issueKey)) return (0, $iWqim.assoc)(state, 'sidebarReactKey', Math.random().toString());
            return state;
        case 0, $aXT93.DELETE_QUEUE:
            return (0, $iWqim.assoc)(state, 'deletingQueue', true);
        case 0, $aXT93.SET_MODAL_IS_DELETING:
            return (0, $iWqim.assoc)(state, 'deletingQueue', action.payload.isDeleting);
        case 0, $iGYMr.PAGE_CHANGED:
        case 0, $bKkYU.LOAD_PAGE_DATA:
        case 0, $iGYMr.SORT_ORDER_CHANGED:
        case 0, $cpZzK.FILTER_QUERY_SUBMITTED:
        case 0, $iGYMr.RESET_SORT_ORDER:
            return (0, $iWqim.assoc)(state, 'isLoadingIssues', true);
        case 0, $bKkYU.LOAD_PAGE_DATA_FAILURE:
            {
                const { error: error } = action.payload;
                return (0, $iWqim.chain)(state).assoc('isLoadingPage', false).assoc('pageError', error).value();
            }
        case 0, $bKkYU.LOAD_PAGE_DATA_SUCCESS:
            return (0, $iWqim.chain)(state).assoc('isLoadingPage', false).dissoc('pageError').value();
        case 0, $2MzoN.LOAD_ISSUES_SUCCESS:
            {
                const { isFiltered: isFiltered, isFilterRequested: isFilterRequested } = action.payload.loadedIssuesResponse;
                const isLoadingIssues = isFilterRequested !== isFiltered;
                const areIssuesLoadedFromServer = action.payload.loadedIssuesResponse.source === (0, $2IsS5.REST_SOURCE);
                return (0, $iWqim.chain)(state).assoc('isLoadingIssues', isLoadingIssues).assoc('areIssuesLoadedFromServer', areIssuesLoadedFromServer).dissoc('showIssueFailureError').dissoc('shouldShowBadFilterQueryError').value();
            }
        case 0, $2MzoN.LOAD_ISSUES_FAILURE:
            {
                const { source: source, isQueueEmpty: isQueueEmpty } = action.payload;
                const updatedState = (0, $iWqim.chain)(state).assoc('isLoadingIssues', false);
                if (source === (0, $f3fa5acbda0f3e0e$export$f162a928a40c7ab8) && isQueueEmpty) updatedState.assoc('showIssueFailureError', true);
                return updatedState.value();
            }
        case 0, $bKkYU.RESET_STATE:
            return (0, $iWqim.chain)(state).assoc('isLoadingPage', true).assoc('isLoadingIssues', true).assoc('areIssuesLoadedFromServer', false).assoc('isQueueVisible', true).dissoc('showIssueFailureError').dissoc('shouldShowBadFilterQueryError').value();
        case 0, $iGYMr.TOGGLE_QUEUE_HEADER:
            {
                const direction = action.payload;
                if (direction === (0, $f3fa5acbda0f3e0e$export$57022ca1771ad970)) return state;
                return (0, $iWqim.assoc)(state, 'isHeaderCollapsed', direction === (0, $f3fa5acbda0f3e0e$export$28a694fb106a7f62));
            }
        case 0, $cpZzK.IS_FILTER_FAILED:
            return (0, $iWqim.chain)(state).assoc('isLoadingIssues', false).assoc('issueCount', 0).assoc('shouldShowBadFilterQueryError', true).value();
        case 0, $bKkYU.DISPLAY_QUEUES_ERROR_HEADER:
            return (0, $iWqim.assoc)(state, 'isQueuesErrorHeaderDisplayed', true);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$9c00cfd15b2573bb$export$2e2bcd8739ae039 = (state = $9c00cfd15b2573bb$var$DEFAULT_UI_STATE, action)=>{
    const { currentQueue: currentQueue } = state;
    const nextState = $9c00cfd15b2573bb$var$rootUiReducer(state, action);
    const nextQueue = (0, $9jSiL.default)(currentQueue, action);
    // Do not return a new object if no changes are made.
    // Or else anything using this state as reference will
    // cause a re-render even if leaf values are the same
    if (state === nextState && currentQueue === nextQueue) return state;
    return {
        ...nextState,
        currentQueue: nextQueue
    };
};

});
parcelRegister("9jSiL", function(module, exports) {

$parcel$export(module.exports, "default", () => $05cd895d6f800532$export$2e2bcd8739ae039);

var $cSmYj = parcelRequire("cSmYj");

var $fEoqD = parcelRequire("fEoqD");

var $2MzoN = parcelRequire("2MzoN");

var $ea3Ck = parcelRequire("ea3Ck");

var $iGYMr = parcelRequire("iGYMr");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$05cd895d6f800532$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 0, $ea3Ck.SET_QUEUE:
            return action.payload.queue;
        case 0, $2MzoN.LOAD_ISSUES_SUCCESS:
            {
                const { loadedIssuesResponse: { columns: columns, isUsingDefaultSorting: isUsingDefaultSorting } } = action.payload;
                const newState = (0, $fEoqD.chainUnsafe)(state);
                if (state && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(columns, state.columns)) newState.assoc('columns', columns);
                return isUsingDefaultSorting ? newState.dissoc('manualSorting').value() : newState.value();
            }
        case 0, $iGYMr.SORT_ORDER_CHANGED:
            return (0, $fEoqD.assocUnsafe)(state, 'manualSorting', action.payload);
        case 0, $iGYMr.SORT_ORDER_OPTIMISTIC_UPDATE:
            {
                const { sortedBy: sortedBy, sortOrder: sortOrder } = action.payload;
                return (0, $fEoqD.updateInUnsafe)(state, [
                    'columns'
                ], (columns)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'column' implicitly has an 'any' type.
                    columns.map((column)=>(0, $fEoqD.assocUnsafe)(column, 'currentSorting', column.id === sortedBy ? sortOrder : undefined)));
            }
        case 0, $iGYMr.SORT_ORDER_OPTIMISTIC_RESET:
            return (0, $fEoqD.updateInUnsafe)(state, [
                'columns'
            ], (columns)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'column' implicitly has an 'any' type.
                columns.map((column)=>(0, $fEoqD.dissocUnsafe)(column, 'currentSorting')));
        case 0, $iGYMr.SORT_ORDER_ON_LOAD:
            return (0, $fEoqD.assocUnsafe)(state, 'manualSorting', action.payload);
        case 0, $iGYMr.RESET_SORT_ORDER:
            return (0, $fEoqD.dissocUnsafe)(state, 'manualSorting');
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("fEoqD", function(module, exports) {

$parcel$export(module.exports, "assocUnsafe", () => $5e1e215639914b55$export$a759ec8fde46de77);
$parcel$export(module.exports, "dissocUnsafe", () => $5e1e215639914b55$export$e0867c1b5da854fe);
$parcel$export(module.exports, "assocInUnsafe", () => $5e1e215639914b55$export$1bfac1118aad2c2f);
$parcel$export(module.exports, "updateInUnsafe", () => $5e1e215639914b55$export$f920b8c255ec1192);
$parcel$export(module.exports, "chainUnsafe", () => $5e1e215639914b55$export$181c753256d1c9a0);

var $iWqim = parcelRequire("iWqim");
const $5e1e215639914b55$export$a759ec8fde46de77 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $iWqim.assoc(collection, key, value);
const $5e1e215639914b55$export$9b65d21cdbb50a87 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $iWqim.set(collection, key, value);
const $5e1e215639914b55$export$e0867c1b5da854fe = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $iWqim.dissoc(collection, key);
const $5e1e215639914b55$export$958195bad0a3dbcf = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $iWqim.unset(collection, key);
const $5e1e215639914b55$export$1bfac1118aad2c2f = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $iWqim.assocIn(collection, path, value);
const $5e1e215639914b55$export$565e6fa2e54b66b3 = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $iWqim.setIn(collection, path, value);
const $5e1e215639914b55$export$75197f11bfe5de5f = (collection, path)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $iWqim.getIn(collection, path);
const $5e1e215639914b55$export$f920b8c255ec1192 = (collection, path, callback)=>$iWqim.updateIn(collection, path, callback);
class $5e1e215639914b55$var$IcepickUnsafeWrapper {
    constructor(collection){
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        this.wrapper = $iWqim.chain(collection);
    }
    value() {
        return this.wrapper.value();
    }
    freeze() {
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.freeze().value());
    }
    assoc(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.assoc(key, value).value());
    }
    set(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.set(key, value).value());
    }
    dissoc(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.dissoc(key).value());
    }
    unset(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.unset(key).value());
    }
    assocIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.assocIn(path, value).value());
    }
    setIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.setIn(path, value).value());
    }
    getIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.getIn(path, value).value());
    }
    updateIn(path, callback) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.updateIn(path, callback).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(source) {
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.assign(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2) {
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3) {
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3, s4) {
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3, s4).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(source) {
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.extend(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2) {
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3) {
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3, s4) {
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3, s4).value());
    }
    merge(source) {
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.merge(source).value());
    }
    thru(val) {
        return new $5e1e215639914b55$var$IcepickUnsafeWrapper(this.wrapper.thru(val).value());
    }
}
const $5e1e215639914b55$export$181c753256d1c9a0 = (collection)=>new $5e1e215639914b55$var$IcepickUnsafeWrapper(collection);

});




parcelRegister("eiNWu", function(module, exports) {

$parcel$export(module.exports, "ChangeManagementTour", () => $4a6975cfbd15229c$export$b9e679128cfbb66a);

var $eJOHy = parcelRequire("eJOHy");

var $2aY2d = parcelRequire("2aY2d");

var $iWhpv = parcelRequire("iWhpv");

var $c0SeW = parcelRequire("c0SeW");

var $jlJsl = parcelRequire("jlJsl");

var $2FqDG = parcelRequire("2FqDG");
const $4a6975cfbd15229c$export$b9e679128cfbb66a = (props)=>{
    const [practiceType] = (0, $2FqDG.usePathParam)('practiceType');
    const { data: isItsmProject } = (0, $iWhpv.useIsItsmTemplateProject)();
    if (isItsmProject !== true) return null;
    return practiceType === (0, $jlJsl.SHORT_FORM_CHANGES) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2aY2d.ProjectContextProvider), null, ({ data: data })=>data && data.isProjectAdmin === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c0SeW.AsyncChangeManagementTourQueues), props) : null) : null;
};

});
parcelRegister("c0SeW", function(module, exports) {

$parcel$export(module.exports, "AsyncChangeManagementTourIssue", () => $2f4cbaf5a7867590$export$1ed01ce8c1ac7746);
$parcel$export(module.exports, "AsyncChangeManagementTourQueues", () => $2f4cbaf5a7867590$export$fb9c9876407ca830);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $ehzLu = parcelRequire("ehzLu");

var $bQWwW = parcelRequire("bQWwW");

const $2f4cbaf5a7867590$var$ChangeManagementTourIssueComponent = ()=>(parcelRequire("68wNy"));

const $2f4cbaf5a7867590$var$ChangeManagementTourQueuesComponent = ()=>(parcelRequire("gySRC"));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2f4cbaf5a7867590$var$ChangeManagementTourIssue = (0, $bQWwW.lazy)(()=>$2f4cbaf5a7867590$var$ChangeManagementTourIssueComponent(), {});
const $2f4cbaf5a7867590$export$1ed8a177940b97cb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "change-management-tour-issue",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f4cbaf5a7867590$var$ChangeManagementTourIssue, props));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2f4cbaf5a7867590$var$ChangeManagementTourQueues = (0, $bQWwW.lazy)(()=>$2f4cbaf5a7867590$var$ChangeManagementTourQueuesComponent(), {});
const $2f4cbaf5a7867590$export$2e6a672121096a76 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "change-management-tour-queues",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f4cbaf5a7867590$var$ChangeManagementTourQueues, props));
const $2f4cbaf5a7867590$export$1ed01ce8c1ac7746 = (0, $ehzLu.withShouldRenderWithinItsmSampleProject)($2f4cbaf5a7867590$export$1ed8a177940b97cb, false);
const $2f4cbaf5a7867590$export$fb9c9876407ca830 = (0, $ehzLu.withShouldRenderWithinItsmSampleProject)($2f4cbaf5a7867590$export$2e6a672121096a76, false);

});
parcelRegister("ehzLu", function(module, exports) {

$parcel$export(module.exports, "withShouldRenderWithinItsmSampleProject", () => $e0cb5c722d703d21$export$226e9fc1ef19c2cf);

var $eJOHy = parcelRequire("eJOHy");

var $46OwJ = parcelRequire("46OwJ");
const $e0cb5c722d703d21$export$226e9fc1ef19c2cf = (WrappedComponent, shouldRenderWithinItsmSampleProject)=>{
    const WithShouldRenderWithinItsmSampleProject = (props)=>{
        const { data: isItsmSampleProject } = (0, $46OwJ.useIsItsmSampleProject)();
        const shouldRender = shouldRenderWithinItsmSampleProject === isItsmSampleProject;
        // @ts-expect-error - TS2322 - Type 'Props' is not assignable to type 'IntrinsicAttributes & LibraryManagedAttributes<Component, PropsWithChildren<PropsWithoutRef<Props> & RefAttributes<any>>>'.
        return shouldRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, props);
    };
    WithShouldRenderWithinItsmSampleProject.displayName = `WithShouldRenderWithinItsmSampleProject(${WrappedComponent.displayName ?? WrappedComponent.name ?? 'Component'})`;
    // @ts-expect-error - TS2322 - Type '{ (props: Props): false | JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<Props, any>'.
    return WithShouldRenderWithinItsmSampleProject;
};

});
parcelRegister("46OwJ", function(module, exports) {

$parcel$export(module.exports, "useIsItsmSampleProject", () => $b88cf250ae9a65c8$export$b8afdaba4bd6f483);

var $jPROM = parcelRequire("jPROM");

var $iWhpv = parcelRequire("iWhpv");

var $lCHpy = parcelRequire("lCHpy");
const $b88cf250ae9a65c8$export$b8afdaba4bd6f483 = ()=>{
    const { data: isDemoProject, loading: loadingIsDemoProject, error: errorIsDemoProject } = (0, $lCHpy.useIsDemoProject)();
    const { data: isItsmProject, loading: loadingIsItsmProject, error: errorIsItsmProject } = (0, $iWhpv.useIsItsmTemplateProject)();
    return {
        data: !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(isDemoProject) && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(isItsmProject) ? isDemoProject === true && isItsmProject === true : null,
        loading: loadingIsDemoProject || loadingIsItsmProject,
        error: errorIsDemoProject || errorIsItsmProject
    };
};

});
parcelRegister("lCHpy", function(module, exports) {

$parcel$export(module.exports, "useIsDemoProject", () => $67c55c522fcd4ab9$export$9b4078600f2ad4d2);

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $6nVJI = parcelRequire("6nVJI");

var $ljej9 = parcelRequire("ljej9");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $d7ziq = parcelRequire("d7ziq");

var $icxV7 = parcelRequire("icxV7");
const $67c55c522fcd4ab9$export$d4c72bab9d6cc13a = {};
const $67c55c522fcd4ab9$export$bf108b10a3a0ab90 = (0, $GtRbT.createStore)({
    name: 'IsDemoProject',
    initialState: $67c55c522fcd4ab9$export$d4c72bab9d6cc13a,
    actions: (0, $d7ziq.actions)
});
const $67c55c522fcd4ab9$var$useIsDemoProjectStore = (0, $iJq0l.createHook)($67c55c522fcd4ab9$export$bf108b10a3a0ab90);
// @ts-expect-error - TS7031 - Binding element 'data' implicitly has an 'any' type. | TS7031 - Binding element 'loading' implicitly has an 'any' type. | TS7031 - Binding element 'error' implicitly has an 'any' type.
const $67c55c522fcd4ab9$var$useStateMemo = ({ data: data, loading: loading, error: error })=>(0, $eJOHy.useMemo)(()=>({
            data: data,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
const $67c55c522fcd4ab9$export$9b4078600f2ad4d2 = ()=>{
    const [{ data: contextData }] = (0, $6nVJI.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const numProjectId = contextData && contextData.project && contextData.project.id;
    const projectId = (0, $ljej9.toProjectId)(String(numProjectId));
    const [state, { fetchIsDemoProject: fetchIsDemoProject }] = $67c55c522fcd4ab9$var$useIsDemoProjectStore();
    const memoizedState = $67c55c522fcd4ab9$var$useStateMemo({
        ...state[projectId] ?? (0, $icxV7.initialIsDemoProjectState)
    });
    const { data: data } = memoizedState;
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(numProjectId) && (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(data)) // @ts-expect-error - TS2349 - This expression is not callable.
        fetchIsDemoProject({
            projectId: projectId
        })();
    }, [
        fetchIsDemoProject,
        numProjectId,
        projectId,
        data
    ]);
    return memoizedState;
};

});
parcelRegister("d7ziq", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d2a67ae2e88ac128$export$e324594224ef24da);

var $cC2sN = parcelRequire("cC2sN");
const $d2a67ae2e88ac128$export$e324594224ef24da = {
    fetchIsDemoProject: $cC2sN.fetchIsDemoProject
};

});
parcelRegister("cC2sN", function(module, exports) {

$parcel$export(module.exports, "fetchIsDemoProject", () => $033c23ec7e9589bc$export$feaee63a215b34da);

var $jPROM = parcelRequire("jPROM");

var $c5o9J = parcelRequire("c5o9J");

var $icxV7 = parcelRequire("icxV7");
const $033c23ec7e9589bc$export$feaee63a215b34da = ({ projectId: projectId })=>// @ts-expect-error - TS2322 - Type '({ getState, setState }: StoreActionApi<Partial<Record<string, DataState<boolean>>>>) => () => Promise<void>' is not assignable to type 'Action<Partial<Record<string, DataState<boolean>>>, void, void | Promise<void>>'.
    ({ getState: getState, setState: setState })=>async ()=>{
            const projectState = getState()[projectId] ?? (0, $icxV7.initialIsDemoProjectState);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(projectState.data) || projectState.loading) return;
            setState({
                ...getState(),
                [String(projectId)]: {
                    ...projectState,
                    loading: true
                }
            });
            try {
                const isDemo = await (0, $c5o9J.isDemoProject)({
                    projectId: projectId
                });
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        data: isDemo,
                        error: null,
                        loading: false
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        error: error,
                        loading: false
                    }
                });
                throw error;
            }
        };

});
parcelRegister("c5o9J", function(module, exports) {

$parcel$export(module.exports, "isDemoProject", () => $6ef3f9d0e6deb20a$export$cf7813449d38d4ac);
$parcel$export(module.exports, "getItsmSampleProject", () => $6ef3f9d0e6deb20a$export$c498e29d716efe7a);

var $gxjHI = parcelRequire("gxjHI");

var $epTsa = parcelRequire("epTsa");

var $jGzN3 = parcelRequire("jGzN3");
const $6ef3f9d0e6deb20a$var$onFetchErrorCacheHandler = (error)=>{
    if (error.statusCode === 404) return {
        value: false
    };
    throw error;
};
const $6ef3f9d0e6deb20a$export$cf7813449d38d4ac = async ({ projectId: projectId })=>{
    try {
        if ((0, $epTsa.expValEquals)('jira_caching_layer_milestone_1_exp', 'cohort', 'variation')) {
            const response = await (0, $gxjHI.performGetRequestWithCache)(`/rest/api/3/project/${projectId}/properties/isDemo`, $6ef3f9d0e6deb20a$var$onFetchErrorCacheHandler);
            return !!response && !!response.value;
        }
        const response = await (0, $jGzN3.performGetRequest)(`/rest/api/3/project/${projectId}/properties/isDemo`);
        return !!response && !!response.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) /**
			 * Expected when project property is not found.
			 * Demo project has project property "isDemo = true",
			 * otherwise property does not exist
			 * and response status will be 404
			 */ return false;
        throw error;
    }
};
const $6ef3f9d0e6deb20a$export$c498e29d716efe7a = async ()=>{
    try {
        const response = await (0, $jGzN3.performGetRequest)('/rest/servicedesk/onboarding/1/itsm/sample-project');
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) return undefined;
        throw error;
    }
};

});
parcelRegister("gxjHI", function(module, exports) {

$parcel$export(module.exports, "performGetRequestWithCache", () => $fa5b8f32fe3c89e1$export$2df9cfe22532d245);

var $jGzN3 = parcelRequire("jGzN3");

var $kVohp = parcelRequire("kVohp");
const $fa5b8f32fe3c89e1$export$2df9cfe22532d245 = (0, $kVohp.withCache)((0, $jGzN3.performGetRequest));

});
parcelRegister("kVohp", function(module, exports) {

$parcel$export(module.exports, "withCache", () => $a6039d1a27d6a980$export$33b32b3abf8170f0);

var $6uWhG = parcelRequire("6uWhG");

var $gYnSx = parcelRequire("gYnSx");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $737wO = parcelRequire("737wO");

var $9A2OL = parcelRequire("9A2OL");

var $3DJZK = parcelRequire("3DJZK");

var $kLf4c = parcelRequire("kLf4c");
const $a6039d1a27d6a980$export$33b32b3abf8170f0 = (fn)=>async (url, onFnErrorCacheHandler, maxAge = (0, $737wO.SEVEN_DAYS_IN_MILLIS), options = {})=>{
        if (false) return fn(url, options);
        try {
            if (!(0, $epTsa.expValEquals)('jira_caching_layer_milestone_1_exp', 'cohort', 'variation')) return fn(url, options);
            const cachedKey = (0, $9A2OL.createCacheKey)(url);
            const readMeasureName = 'indexed-db-cache-read';
            const readStartMark = `${readMeasureName}:start`;
            const readEndMark = `${readMeasureName}:end`;
            (0, $6uWhG.setMark)(readStartMark);
            const cachedData = await (0, $kLf4c.jiraCache).get(cachedKey);
            (0, $6uWhG.setMark)(readEndMark);
            (0, $6uWhG.setMeasure)(readMeasureName, readStartMark, readEndMark);
            if (cachedData !== undefined && Date.now() < cachedData.expiresAt) return cachedData.data;
            let data;
            try {
                data = await fn(url, options);
            } catch (error) {
                if (onFnErrorCacheHandler) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                data = onFnErrorCacheHandler(error);
                else throw error;
            }
            const writeMeasureName = 'indexed-db-cache-write';
            const writeStartMark = `${writeMeasureName}:start`;
            const writeEndMark = `${writeMeasureName}:end`;
            (0, $6uWhG.setMark)(writeStartMark);
            (0, $kLf4c.jiraCache).set(cachedKey, {
                data: data,
                expiresAt: Date.now() + maxAge
            }).then(()=>{
                (0, $6uWhG.setMark)(writeEndMark);
                (0, $6uWhG.setMeasure)(writeMeasureName, writeStartMark, writeEndMark);
            });
            return data;
        } catch (error) {
            if ((0, $7jTnu.fg)('jcl_error_handling_and_conditional_skip_sentry')) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $3DJZK.errorHandler)(error, 'withCache');
            else (0, $gYnSx.default)({
                meta: {
                    id: 'withCache',
                    packageName: (0, $737wO.PACKAGE_NAME),
                    teamName: (0, $737wO.TEAM_NAME)
                },
                error: new Error('Error in JCL withCache'),
                attributes: {
                    cause: error instanceof Error ? error.message : 'Not known'
                },
                sendToPrivacyUnsafeSplunk: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                skipSentry: (0, $gYnSx.isNetworkError)(error)
            });
            return fn(url, options);
        }
    };

});
parcelRegister("737wO", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $c846f704a6870f10$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $c846f704a6870f10$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SEVEN_DAYS_IN_MILLIS", () => $c846f704a6870f10$export$b14f1fa28090cb18);
$parcel$export(module.exports, "CACHE_NAME_PREFIX", () => $c846f704a6870f10$export$7c8c9e2fd09cd6cd);
const $c846f704a6870f10$export$b8b9d90f9e5bd72b = 'jiraCachingLayer';
const $c846f704a6870f10$export$d57b6b390e78d90f = 'aurum';
const $c846f704a6870f10$export$b14f1fa28090cb18 = 604800000;
const $c846f704a6870f10$export$7c8c9e2fd09cd6cd = 'jira-cache';

});

parcelRegister("9A2OL", function(module, exports) {

$parcel$export(module.exports, "createCacheKey", () => $bcb0a4e752081b41$export$aa68fd26e593cc7e);

var $aYncF = parcelRequire("aYncF");
const $bcb0a4e752081b41$export$aa68fd26e593cc7e = (endpoint)=>{
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const url = new URL(endpoint, window.location.origin);
    const searchParams = new URLSearchParams(url.search);
    const sortedParams = new URLSearchParams([
        ...searchParams.entries()
    ].sort());
    url.search = sortedParams.toString();
    const prefix = (atlassianAccountId + cloudId).replace(/-/g, '');
    const endpointWithSearch = prefix + url.pathname + url.search;
    return endpointWithSearch.replace(/[/?&=]/g, '-').substring(1);
};

});

parcelRegister("3DJZK", function(module, exports) {

$parcel$export(module.exports, "errorHandler", () => $1bed243b298c3c8b$export$cc3fdd528b56c4a9);

var $gYnSx = parcelRequire("gYnSx");

var $737wO = parcelRequire("737wO");
const $1bed243b298c3c8b$export$3b21ec5932035f63 = [
    'Internal error.',
    'Internal error opening backing store for indexedDB.open.',
    "Can't find variable: indexedDB",
    'Error looking up record in object store by key range',
    "IDBDatabase.transaction: 'keyval' is not a known object store name",
    'A mutation operation was attempted on a database that did not allow mutations.',
    'Encountered full disk while opening backing store for indexedDB.open.',
    "Failed to execute 'transaction' on 'IDBDatabase': One of the specified object stores was not found.",
    'Internal error retrieving bucket data directory.',
    'Connection to Indexed Database server lost. Refresh the page to try again',
    'The current transaction exceeded its quota limitations.',
    'The operation failed for reasons unrelated to the database itself and not covered by any other error code.',
    'Attempt to get a record from database without an in-progress transaction'
];
const $1bed243b298c3c8b$var$shouldSkipSentry = (error)=>(0, $gYnSx.isNetworkError)(error) || $1bed243b298c3c8b$export$3b21ec5932035f63.includes(error?.message);
const $1bed243b298c3c8b$export$cc3fdd528b56c4a9 = (error, source)=>{
    const cause = error instanceof Error ? error.message : 'Not known';
    (0, $gYnSx.default)({
        meta: {
            id: source,
            packageName: (0, $737wO.PACKAGE_NAME),
            teamName: (0, $737wO.TEAM_NAME)
        },
        error: new Error(`JCL ${source} - ${cause}`, {
            cause: error
        }),
        attributes: {
            cause: cause
        },
        sendToPrivacyUnsafeSplunk: true,
        skipSentry: $1bed243b298c3c8b$var$shouldSkipSentry(error)
    });
};

});

parcelRegister("kLf4c", function(module, exports) {

$parcel$export(module.exports, "jiraCache", () => $45c1c0e4f17aa9e0$export$8b9e5c9ea3bf5aac);

var $fclB9 = parcelRequire("fclB9");

var $737wO = parcelRequire("737wO");
const $45c1c0e4f17aa9e0$export$8b9e5c9ea3bf5aac = (0, $fclB9.createIndexedDBStorageProvider)((0, $737wO.CACHE_NAME_PREFIX), {
    shouldAutoReconnect: true
});

});
parcelRegister("fclB9", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $c1555772a5bddb48$export$6ba36c4f5fb8919d);

var $5PQOA = parcelRequire("5PQOA");

var $czeV6 = parcelRequire("czeV6");
const $c1555772a5bddb48$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $czeV6.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $czeV6.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("czeV6", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $83715273b7a8b6ec$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $83715273b7a8b6ec$export$8432fe49db7d8865);

var $98dDj = parcelRequire("98dDj");
const $83715273b7a8b6ec$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $83715273b7a8b6ec$var$createCustomStore = ()=>(0, $98dDj.createStore)('keyval-store', 'keyval');
let $83715273b7a8b6ec$var$customStore;
const $83715273b7a8b6ec$var$getStore = ()=>{
    let store = $83715273b7a8b6ec$var$customStore;
    if (!store) {
        $83715273b7a8b6ec$var$customStore = $83715273b7a8b6ec$var$createCustomStore();
        store = $83715273b7a8b6ec$var$customStore;
    }
    return store;
};
const $83715273b7a8b6ec$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $83715273b7a8b6ec$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$83715273b7a8b6ec$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $98dDj.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $83715273b7a8b6ec$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $98dDj.get)(prefix(key), $83715273b7a8b6ec$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $98dDj.del)(prefixedKey, $83715273b7a8b6ec$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $98dDj.get)(KEYS_STORE_PREFIX, $83715273b7a8b6ec$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $98dDj.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $98dDj.update)(prefixedKey, value);
            else (0, $98dDj.set)(prefixedKey, value, $83715273b7a8b6ec$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $83715273b7a8b6ec$var$customStore = $83715273b7a8b6ec$var$createCustomStore();
        }
    };
};
const $83715273b7a8b6ec$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("98dDj", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $6a5f6fa33a187ce0$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $6a5f6fa33a187ce0$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $6a5f6fa33a187ce0$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $6a5f6fa33a187ce0$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $6a5f6fa33a187ce0$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $6a5f6fa33a187ce0$export$c8aa84257229cac8);
function $6a5f6fa33a187ce0$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $6a5f6fa33a187ce0$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $6a5f6fa33a187ce0$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $6a5f6fa33a187ce0$var$defaultGetStoreFunc;
function $6a5f6fa33a187ce0$var$defaultGetStore() {
    if (!$6a5f6fa33a187ce0$var$defaultGetStoreFunc) $6a5f6fa33a187ce0$var$defaultGetStoreFunc = $6a5f6fa33a187ce0$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $6a5f6fa33a187ce0$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$3988ae62b71be9a3(key, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$6a5f6fa33a187ce0$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$adaa4cf7ef1b65be(key, value, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$daa0a5170277c7a8(entries, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$5df405cccea42673(keys, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$6a5f6fa33a187ce0$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$722fbec263ad908a(key, updater, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$1d2f21e549771e67(key, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$c8aa84257229cac8(keys, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$42ffd38884aecdac(customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
function $6a5f6fa33a187ce0$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$ed97f33186d4b816(customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $6a5f6fa33a187ce0$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $6a5f6fa33a187ce0$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$68c286be0e7e55b7(customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $6a5f6fa33a187ce0$export$b327150396135fe7(store.getAll());
        const items = [];
        return $6a5f6fa33a187ce0$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$3e9f948b41964866(customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $6a5f6fa33a187ce0$export$b327150396135fe7(store.getAllKeys()),
            $6a5f6fa33a187ce0$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$6a5f6fa33a187ce0$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});







parcelRegister("icxV7", function(module, exports) {

$parcel$export(module.exports, "initialIsDemoProjectState", () => $02cd857ec8b95be9$export$f6365b0f25aeae62);
const $02cd857ec8b95be9$export$f6365b0f25aeae62 = {
    data: null,
    loading: false,
    error: null
};

});






parcelRegister("68wNy", function(module, exports) {

let $477cee7f3971a5e6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $477cee7f3971a5e6$var$load("3yAl4"),
    $477cee7f3971a5e6$var$load("ffQaD"),
    $477cee7f3971a5e6$var$load("kvRbA"),
    $477cee7f3971a5e6$var$load("9ZDWr")
]).then(()=>parcelRequire('jCbir'));

});

parcelRegister("gySRC", function(module, exports) {

let $c0ea612322158d31$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $c0ea612322158d31$var$load("ffQaD"),
    $c0ea612322158d31$var$load("kvRbA"),
    $c0ea612322158d31$var$load("42k8s")
]).then(()=>parcelRequire('jSeKM'));

});



parcelRegister("1TwdM", function(module, exports) {

$parcel$export(module.exports, "default", () => $29c83bb021f29090$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $lc49q = parcelRequire("lc49q");

var $6I1gv = parcelRequire("6I1gv");

var $iOvF5 = parcelRequire("iOvF5");
const $29c83bb021f29090$var$mapStateToProps = (state)=>({
        queueId: (0, $lc49q.getQueueId)(state),
        isQueueVisible: (0, $6I1gv.isQueueVisible)(state)
    });
var $29c83bb021f29090$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($29c83bb021f29090$var$mapStateToProps, {})((0, $iOvF5.default));

});
parcelRegister("iOvF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a2990af029860f2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fakPW = parcelRequire("fakPW");

var $2IsS5 = parcelRequire("2IsS5");

var $bRJAs = parcelRequire("bRJAs");

var $lvKO5 = parcelRequire("lvKO5");

var $kJZCj = parcelRequire("kJZCj");
function $5a2990af029860f2$export$2e2bcd8739ae039(props) {
    const { queueId: queueId, children: children, isQueueVisible: isQueueVisible } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvKO5.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fakPW.ViewExperienceTrackingProvider), {
            analyticsSource: "queues",
            experience: "viewQueue",
            experienceId: (0, $2IsS5.fromQueueIdString)(queueId),
            application: (0, $bRJAs.JIRA_SERVICE_DESK),
            edition: tenantContext.appEditions.serviceDesk,
            isExperienceReady: isQueueVisible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJZCj.default), null), children));
}

});
parcelRegister("kJZCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $840bfc2d80ab48e2$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $f2fyU = parcelRequire("f2fyU");

var $iphTz = parcelRequire("iphTz");
const $840bfc2d80ab48e2$var$mapStateToProps = (state)=>({
        initialFetchStatus: (0, $f2fyU.getExperienceTrackingInitialFetchStatus)(state),
        initialFetchFailureEventAttributes: (0, $f2fyU.getInitialFetchErrorEventAttributes)(state)
    });
var $840bfc2d80ab48e2$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($840bfc2d80ab48e2$var$mapStateToProps, {})((0, $iphTz.default));

});
parcelRegister("f2fyU", function(module, exports) {

$parcel$export(module.exports, "getExperienceTrackingInitialFetchStatus", () => $81bc2fe9f8fa53d6$export$ec3d1bbe6bde55e);
$parcel$export(module.exports, "getHasLoadedIssueDataFromCache", () => $81bc2fe9f8fa53d6$export$c50657eec51e9e);
$parcel$export(module.exports, "getInitialFetchErrorEventAttributes", () => $81bc2fe9f8fa53d6$export$711bef1cfb497c56);

var $ahm5r = parcelRequire("ahm5r");

var $7jTnu = parcelRequire("7jTnu");


var $8bvz0 = parcelRequire("8bvz0");
const $81bc2fe9f8fa53d6$export$3c50a15364b58a95 = (state)=>(0, $8bvz0.getPersisted)(state).experienceTracking;
const $81bc2fe9f8fa53d6$export$ec3d1bbe6bde55e = (state)=>$81bc2fe9f8fa53d6$export$3c50a15364b58a95(state).initialDataLoadStatus;
const $81bc2fe9f8fa53d6$export$c50657eec51e9e = (state)=>$81bc2fe9f8fa53d6$export$3c50a15364b58a95(state).hasLoadedIssueDataFromCache;
const $81bc2fe9f8fa53d6$var$getErrorStatusCode = (state)=>$81bc2fe9f8fa53d6$export$3c50a15364b58a95(state).errorStatusCode;
const $81bc2fe9f8fa53d6$var$getErrorMessage = (state)=>$81bc2fe9f8fa53d6$export$3c50a15364b58a95(state).errorMessages;
const $81bc2fe9f8fa53d6$var$getErrorKey = (state)=>$81bc2fe9f8fa53d6$export$3c50a15364b58a95(state).errorKey;
const $81bc2fe9f8fa53d6$var$getTraceId = (state)=>$81bc2fe9f8fa53d6$export$3c50a15364b58a95(state).traceId;
const $81bc2fe9f8fa53d6$var$constructErrorMessage = (statusCode, errorMessage, errorKey)=>`Initial fetch failed status code: ${statusCode}, error: ${JSON.stringify(errorMessage)}, errorKey: ${errorKey}`;
const $81bc2fe9f8fa53d6$export$711bef1cfb497c56 = (0, $ahm5r.createSelector)($81bc2fe9f8fa53d6$export$ec3d1bbe6bde55e, $81bc2fe9f8fa53d6$export$c50657eec51e9e, $81bc2fe9f8fa53d6$var$getErrorStatusCode, $81bc2fe9f8fa53d6$var$getErrorMessage, $81bc2fe9f8fa53d6$var$getErrorKey, $81bc2fe9f8fa53d6$var$getTraceId, (initialDataLoadStatus, hasLoadedIssueDataFromCache, errorStatusCode, errorMessage, errorKey, traceId)=>{
    if (initialDataLoadStatus === (0, $92d95f8a5e1140be$export$70ef9aa03c29b42b)) {
        if ((0, $7jTnu.fg)('adding-more-data-for-viewqueue-and-viewnav-event')) return {
            didFallbackOnIssueCache: hasLoadedIssueDataFromCache,
            errorMessage: $81bc2fe9f8fa53d6$var$constructErrorMessage(errorStatusCode, errorMessage, errorKey),
            traceId: traceId || 'no-trace-id'
        };
        return {
            didFallbackOnIssueCache: hasLoadedIssueDataFromCache,
            errorMessage: errorStatusCode !== undefined ? `Initial fetch failed with status code ${errorStatusCode}` : 'Initial fetch failed'
        };
    }
    return undefined;
});

});

parcelRegister("iphTz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0ceb304b1a9d535$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hya93 = parcelRequire("hya93");

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e0ceb304b1a9d535$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceResultFromPropsTracker), {
        location: "failed-fetching-initial-data",
        hasSucceeded: props.initialFetchStatus === (0, $92d95f8a5e1140be$export$d3ab616c5a76689d),
        hasFailed: props.initialFetchStatus === (0, $92d95f8a5e1140be$export$70ef9aa03c29b42b),
        failureEventAttributes: props.initialFetchFailureEventAttributes
    });

});




parcelRegister("6cqaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e25f08f9ec40dcbd$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $dUugX = parcelRequire("dUugX");
var $hrodw = parcelRequire("hrodw");

var $gCeeo = parcelRequire("gCeeo");
var $8Plmb = parcelRequire("8Plmb");

var $j91oc = parcelRequire("j91oc");
class $e25f08f9ec40dcbd$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
            onMount: this.onMount
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dUugX.AsyncFlagsDispatcher), {
            mapperFactory: this.getFlagsMapperFactory((0, $j91oc.default))
        }));
    }
    constructor(...args){
        super(...args), this.onMount = (analyticsEvent)=>{
            this.flagsAnalyticEvent = analyticsEvent;
        }, this.getFlagsMapperFactory = (0, $LFmXM.default)((factory)=>(args)=>{
                const mapper = factory(args);
                return (action, state)=>{
                    const flagConfig = mapper(action, state);
                    if (flagConfig) {
                        const { type: type } = action;
                        let analyticsAction = 'viewed';
                        // Only type of DismissFlag has command field
                        // @ts-expect-error - TS2339 - Property 'command' does not exist on type 'DismissFlag | Flag'.
                        if (flagConfig.command) analyticsAction = (0, $hrodw.DISMISS_COMMAND).toLowerCase();
                        this.flagsAnalyticEvent.update({
                            action: analyticsAction
                        });
                        (0, $gCeeo.fireUIAnalytics)(this.flagsAnalyticEvent, `flag ${analyticsAction}`, {
                            actionType: type.split('.').pop()
                        });
                    }
                    return flagConfig;
                };
            });
    }
}

});
parcelRegister("dUugX", function(module, exports) {

$parcel$export(module.exports, "AsyncFlagsDispatcher", () => $d423da4dc01c3286$export$7bcb9f5644d87fa4);

var $eJOHy = parcelRequire("eJOHy");

var $5PQOA = parcelRequire("5PQOA");

var $xvuCV = parcelRequire("xvuCV");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $hrodw = parcelRequire("hrodw");
const $d423da4dc01c3286$var$createFlagsDispatcherImpl = (mapperFactory, props, { FlagsDispatcher: FlagsDispatcher, toFlagId: toFlagId, dismissFlag: dismissFlag })=>{
    const mapper = mapperFactory({
        dismissFlag: dismissFlag,
        toFlagId: toFlagId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FlagsDispatcher, {
        ...props,
        mapper: mapper
    });
};
// We create flags mappers dynamically, in part, to allow a closure to be established.
// This is memoized to retain any state provided via a closure.
const $d423da4dc01c3286$var$createFlagsDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($d423da4dc01c3286$var$createFlagsDispatcherImpl);
const $d423da4dc01c3286$var$getFlagsDispatcher = (module, props)=>{
    if ('mapperFactory' in props) {
        const { mapperFactory: mapperFactory, ...dispatcherProps } = props;
        const flagsDispatcher = $d423da4dc01c3286$var$createFlagsDispatcher(mapperFactory, dispatcherProps, module);
        return flagsDispatcher;
    }
    const { FlagsDispatcher: FlagsDispatcher } = module;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FlagsDispatcher, props);
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d423da4dc01c3286$var$LazyFlagsDispatcher = (0, $bQWwW.lazy)(()=>(parcelRequire("lHSAO")).then((module)=>(props)=>$d423da4dc01c3286$var$getFlagsDispatcher(module, props)), {
    moduleId: "./src/packages/platform/ui/flags/src/index.tsx"
});
const $d423da4dc01c3286$export$7bcb9f5644d87fa4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-flags-dispatcher",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: "async-flags-dispatcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d423da4dc01c3286$var$LazyFlagsDispatcher, props)));

});
parcelRegister("lHSAO", function(module, exports) {

let $fcd7f61f83c87389$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fcd7f61f83c87389$var$load("33l2e").then(()=>parcelRequire('gOtBp'));

});


parcelRegister("j91oc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab2746e868ef883f$export$2e2bcd8739ae039);

var $cSmYj = parcelRequire("cSmYj");

var $iGYMr = parcelRequire("iGYMr");

var $aXT93 = parcelRequire("aXT93");

var $ir4eL = parcelRequire("ir4eL");

var $lCUqp = parcelRequire("lCUqp");
const $ab2746e868ef883f$var$WARNING_FLAG_ID = 'WARNING_FLAG_ID';
const $ab2746e868ef883f$var$FETCH_WARNING_FLAG_ID = 'FETCH_WARNING_FLAG_ID';
const $ab2746e868ef883f$var$ERROR_FLAG_ID = 'ERROR_FLAG_ID';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab2746e868ef883f$export$2e2bcd8739ae039 = ({ dismissFlag: dismissFlag, toFlagId: toFlagId })=>{
    let unsuccessfulFlagId;
    const isErrorFlagDisplayed = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(unsuccessfulFlagId, toFlagId($ab2746e868ef883f$var$ERROR_FLAG_ID));
    const flagsMapper = (action)=>{
        switch(action.type){
            case 0, $aXT93.DELETE_QUEUE_FAILURE:
                return (0, $lCUqp.deleteQueueErrorConfig)(action.payload.queueName);
            case 0, $ir4eL.DISPLAY_UNSUCCESSFUL_POLL_WARNING:
                if (unsuccessfulFlagId) return undefined;
                unsuccessfulFlagId = toFlagId($ab2746e868ef883f$var$WARNING_FLAG_ID);
                return (0, $lCUqp.unsuccessfulPollFlagConfig)(unsuccessfulFlagId);
            case 0, $iGYMr.DISPLAY_UNSUCCESSFUL_FETCH_WARNING:
                if (unsuccessfulFlagId) return undefined;
                unsuccessfulFlagId = toFlagId($ab2746e868ef883f$var$FETCH_WARNING_FLAG_ID);
                return (0, $lCUqp.unsuccessfulFetchFlagConfig)(unsuccessfulFlagId);
            case 0, $iGYMr.DISPLAY_UNSUCCESSFUL_FETCH_ERROR:
                if (unsuccessfulFlagId) return undefined;
                unsuccessfulFlagId = toFlagId($ab2746e868ef883f$var$ERROR_FLAG_ID);
                return (0, $lCUqp.unsuccessfulFetchErrorFlagConfig)(unsuccessfulFlagId);
            case 0, $ir4eL.DISMISS_ALL_FLAGS:
                {
                    if (!unsuccessfulFlagId) return undefined;
                    const dismissAllFlagsConfig = dismissFlag(unsuccessfulFlagId);
                    unsuccessfulFlagId = undefined;
                    return dismissAllFlagsConfig;
                }
            case 0, $ir4eL.DISMISS_WARNING_FLAG:
                {
                    if (!unsuccessfulFlagId || isErrorFlagDisplayed()) return undefined;
                    const dismissWarningFlagConfig = dismissFlag(unsuccessfulFlagId);
                    unsuccessfulFlagId = undefined;
                    return dismissWarningFlagConfig;
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return undefined;
                }
        }
    };
    return flagsMapper;
};

});
parcelRegister("lCUqp", function(module, exports) {

$parcel$export(module.exports, "unsuccessfulFetchFlagConfig", () => $b97e7e74c1ee301d$export$1c654f36e3d7dd60);
$parcel$export(module.exports, "unsuccessfulFetchErrorFlagConfig", () => $b97e7e74c1ee301d$export$e39d17f9389fd3ea);
$parcel$export(module.exports, "unsuccessfulPollFlagConfig", () => $b97e7e74c1ee301d$export$84de65b00282fe10);
$parcel$export(module.exports, "deleteQueueErrorConfig", () => $b97e7e74c1ee301d$export$894642f3f2ceae70);

var $1sXQv = parcelRequire("1sXQv");
const $b97e7e74c1ee301d$var$reload = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.reload();
};
const $b97e7e74c1ee301d$export$1c654f36e3d7dd60 = (id)=>({
        id: id,
        type: 'warning',
        title: (0, $1sXQv.default).warningTitle,
        description: (0, $1sXQv.default).warningDescription,
        appearance: 'warning',
        messageId: 'servicedesk-queues-agent-view.flags.flag.warning.warning.unsuccessful-fetch',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $1sXQv.default).tryAgainButton,
                onClick: $b97e7e74c1ee301d$var$reload
            }
        ]
    });
const $b97e7e74c1ee301d$export$e39d17f9389fd3ea = (id)=>({
        id: id,
        type: 'error',
        title: (0, $1sXQv.default).errorTitle,
        description: (0, $1sXQv.default).errorOnScrollDescription,
        appearance: 'error',
        messageId: 'servicedesk-queues-agent-view.flags.flag.error.error.unsuccessful-fetch',
        messageType: 'transactional'
    });
const $b97e7e74c1ee301d$export$84de65b00282fe10 = (id)=>({
        id: id,
        type: 'warning',
        title: (0, $1sXQv.default).warningTitle,
        description: (0, $1sXQv.default).warningDescription,
        appearance: 'warning',
        messageId: 'servicedesk-queues-agent-view.flags.flag.warning.warning.unsuccessful-poll',
        messageType: 'transactional'
    });
const $b97e7e74c1ee301d$export$894642f3f2ceae70 = (queueName)=>({
        type: 'error',
        title: (0, $1sXQv.default).queueDeleteFlagErrorTitle,
        description: [
            (0, $1sXQv.default).queueDeleteFlagErrorDescription,
            {
                queueName: queueName
            }
        ],
        messageId: 'servicedesk-queues-agent-view.flags.flag.error.error.delete-queue',
        messageType: 'transactional'
    });

});
parcelRegister("1sXQv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a3735bdc11269c4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0a3735bdc11269c4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    warningTitle: {
        "id": "servicedesk.queues.agent-view.flags.message.warning-title",
        "defaultMessage": "Queue data may be outdated"
    },
    warningDescription: {
        "id": "servicedesk.queues.agent-view.flags.message.warning-description",
        "defaultMessage": "We are unable to refresh the queue data. Check your internet connection."
    },
    errorTitle: {
        "id": "servicedesk.queues.agent-view.flags.message.error-title",
        "defaultMessage": "Problem loading queue"
    },
    errorDescription: {
        "id": "servicedesk.queues.agent-view.flags.message.error-description",
        "defaultMessage": "We couldn't load the queue. Give it a few seconds, then try again."
    },
    errorOnScrollDescription: {
        "id": "servicedesk.queues.agent-view.flags.message.error-on-scroll-description",
        "defaultMessage": "We couldn't load some requests. Check your internet connection."
    },
    tryAgainButton: {
        "id": "servicedesk.queues.agent-view.flags.message.try-again-button",
        "defaultMessage": "Try again"
    },
    queueDeleteFlagErrorTitle: {
        "id": "servicedesk.queues.agent-view.flags.message.queue-delete-flag-error-title",
        "defaultMessage": "Problem deleting queue"
    },
    queueDeleteFlagErrorDescription: {
        "id": "servicedesk.queues.agent-view.flags.message.queue-delete-flag-error-description",
        "defaultMessage": "'{queueName}' couldn't be deleted. Please try again in a few seconds."
    }
});

});




parcelRegister("i4aCO", function(module, exports) {

$parcel$export(module.exports, "IncidentManagementTour", () => $e12ab090cde5b58f$export$f345c7b8b33c1ee8);

var $eJOHy = parcelRequire("eJOHy");

var $2aY2d = parcelRequire("2aY2d");

var $iWhpv = parcelRequire("iWhpv");

var $8TQAR = parcelRequire("8TQAR");

var $jlJsl = parcelRequire("jlJsl");

var $2FqDG = parcelRequire("2FqDG");
const $e12ab090cde5b58f$export$f345c7b8b33c1ee8 = (props)=>{
    const [practiceType] = (0, $2FqDG.usePathParam)('practiceType');
    const { data: isItsmProject } = (0, $iWhpv.useIsItsmTemplateProject)();
    if (isItsmProject !== true) return null;
    return practiceType === (0, $jlJsl.SHORT_FORM_INCIDENTS) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2aY2d.ProjectContextProvider), null, ({ data: data })=>data && data.isProjectAdmin === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8TQAR.AsyncIncidentManagementTourQueues), props) : null) : null;
};

});
parcelRegister("8TQAR", function(module, exports) {

$parcel$export(module.exports, "AsyncIncidentManagementTourIssue", () => $24bcc37c0c86dd25$export$2dc985b4b00b6eec);
$parcel$export(module.exports, "AsyncIncidentManagementTourQueues", () => $24bcc37c0c86dd25$export$a33c87c292735e8b);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $ehzLu = parcelRequire("ehzLu");

var $bQWwW = parcelRequire("bQWwW");

const $24bcc37c0c86dd25$var$IncidentManagementTourIssueComponent = ()=>(parcelRequire("keNgN"));

const $24bcc37c0c86dd25$var$IncidentManagementTourQueuesComponent = ()=>(parcelRequire("94zLH"));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $24bcc37c0c86dd25$var$IncidentManagementTourIssueNew = (0, $bQWwW.lazy)(()=>$24bcc37c0c86dd25$var$IncidentManagementTourIssueComponent(), {});
const $24bcc37c0c86dd25$var$AsyncIncidentManagementTourIssueNew = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "incident-management-tour-issue",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24bcc37c0c86dd25$var$IncidentManagementTourIssueNew, props));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $24bcc37c0c86dd25$var$IncidentManagementTourQueuesNew = (0, $bQWwW.lazy)(()=>$24bcc37c0c86dd25$var$IncidentManagementTourQueuesComponent(), {});
const $24bcc37c0c86dd25$var$AsyncIncidentManagementTourQueuesNew = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "incident-management-tour-queues",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24bcc37c0c86dd25$var$IncidentManagementTourQueuesNew, props));
const $24bcc37c0c86dd25$export$2dc985b4b00b6eec = (0, $ehzLu.withShouldRenderWithinItsmSampleProject)($24bcc37c0c86dd25$var$AsyncIncidentManagementTourIssueNew, false);
const $24bcc37c0c86dd25$export$a33c87c292735e8b = (0, $ehzLu.withShouldRenderWithinItsmSampleProject)($24bcc37c0c86dd25$var$AsyncIncidentManagementTourQueuesNew, false);

});
parcelRegister("keNgN", function(module, exports) {

let $ebbb556da8f9a12b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ebbb556da8f9a12b$var$load("ffQaD"),
    $ebbb556da8f9a12b$var$load("kvRbA"),
    $ebbb556da8f9a12b$var$load("8o663")
]).then(()=>parcelRequire('8jFxc'));

});

parcelRegister("94zLH", function(module, exports) {

let $69b03ba06c8abf47$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $69b03ba06c8abf47$var$load("ffQaD"),
    $69b03ba06c8abf47$var$load("kvRbA"),
    $69b03ba06c8abf47$var$load("6ntMT")
]).then(()=>parcelRequire('fCd9w'));

});



parcelRegister("8ccoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec607219d344757a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ahm5r = parcelRequire("ahm5r");

var $LFmXM = parcelRequire("LFmXM");

var $jtIA2 = parcelRequire("jtIA2");

var $fcM2a = parcelRequire("fcM2a");

var $7pRCV = parcelRequire("7pRCV");

var $gnQAk = parcelRequire("gnQAk");


var $cpZzK = parcelRequire("cpZzK");

var $2MzoN = parcelRequire("2MzoN");

var $kfJuF = parcelRequire("kfJuF");

var $bKkYU = parcelRequire("bKkYU");

var $ea3Ck = parcelRequire("ea3Ck");

var $aXT93 = parcelRequire("aXT93");

var $ir4eL = parcelRequire("ir4eL");

var $cqBpI = parcelRequire("cqBpI");

var $8bvz0 = parcelRequire("8bvz0");

var $3MjJb = parcelRequire("3MjJb");

var $1TuhT = parcelRequire("1TuhT");

var $jmHUF = parcelRequire("jmHUF");

var $lc49q = parcelRequire("lc49q");

var $6I1gv = parcelRequire("6I1gv");

var $7RZlK = parcelRequire("7RZlK");

var $5ulZp = parcelRequire("5ulZp");

var $eR1Cn = parcelRequire("eR1Cn");

var $aaZPf = parcelRequire("aaZPf");

var $bsyRU = parcelRequire("bsyRU");

var $8U6qY = parcelRequire("8U6qY");

var $5JzRO = parcelRequire("5JzRO");

var $F7Mtp = parcelRequire("F7Mtp");

var $4nUR9 = parcelRequire("4nUR9");

var $hbWqB = parcelRequire("hbWqB");
const $ec607219d344757a$var$getColumnsMemoized = ()=>(0, $ahm5r.createSelector)((0, $lc49q.getColumns), (res)=>res);
const $ec607219d344757a$var$EMPTY_LIST = [];
const $ec607219d344757a$var$mapStateToPropsFactory = ()=>{
    const getColumnsInstance = $ec607219d344757a$var$getColumnsMemoized();
    return (state)=>({
            UsageSampler: $4nUR9.default,
            EmptyQueue: $5ulZp.default,
            ErrorState: $eR1Cn.default,
            isQueueEmpty: (0, $6I1gv.isQueueEmpty)(state),
            showIssueFailureError: (0, $6I1gv.showIssueFailureError)(state),
            isLoadingIssues: (0, $6I1gv.isLoadingIssues)(state),
            issueCount: (0, $1TuhT.getIssueCount)(state),
            onboardingResolved: (0, $6I1gv.getOnboardingResolved)(state),
            isCurrentDataFiltered: (0, $3MjJb.getIsCurrentDataFiltered)(state),
            Table: $F7Mtp.default,
            EmptyFilteredQueue: $7RZlK.default,
            NavUpdater: $8U6qY.default,
            ViewTracker: $jtIA2.default,
            QueuesBreadcrumb: $5JzRO.default,
            IssueContextListener: $aaZPf.default,
            ItsmContextListener: $bsyRU.default,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            projectKey: (0, $8bvz0.getAppProps)(state).projectKey,
            isInitialized: (0, $6I1gv.isInitialized)(state),
            category: (0, $lc49q.getCategory)(state),
            itsmPractices: (0, $jmHUF.isItsmProject)(state) ? (0, $jmHUF.getEnabledPractices)(state) : $ec607219d344757a$var$EMPTY_LIST,
            issueCollection: (0, $1TuhT.getCollection)(state),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            projectId: (0, $8bvz0.getAppProps)(state).projectId,
            columns: getColumnsInstance(state),
            jql: (0, $lc49q.getJql)(state),
            shouldShowBadFilterQueryError: (0, $6I1gv.shouldShowBadFilterQueryError)(state),
            createAnalyticsEvent: (0, $cqBpI.getCreateAnalyticsEvent)(state),
            sidebarIssueKey: (0, $6I1gv.getSidebarIssueKey)(state),
            sidebarReactKey: (0, $6I1gv.getSidebarReactKey)(state),
            isQueuesErrorHeaderDisplayed: (0, $6I1gv.isQueuesErrorHeaderDisplayed)(state)
        });
};
const $ec607219d344757a$var$mapDispatchToProps = (dispatch)=>({
        onPageVisibilityChanged: (isQueueVisible)=>{
            dispatch((0, $bKkYU.changeVisibilityAction)(isQueueVisible));
            if (!isQueueVisible) dispatch((0, $ir4eL.stopPollAction)());
        },
        onUnmount: ()=>{
            dispatch((0, $kfJuF.shutdownAction)());
        },
        onQueueChanged: (queue)=>{
            dispatch((0, $ea3Ck.queueChangedAction)(queue));
        },
        onOnboardingResolved: (resolved)=>dispatch((0, $aXT93.onboardingResolvedAction)(resolved)),
        onNavCollapseChange: (isNavCollapsed)=>{
            dispatch((0, $aXT93.setNavCollapsedAction)(isNavCollapsed));
        },
        onWindowFocus: ()=>{
            dispatch((0, $ir4eL.restartPollAction)());
        },
        onFilterClear: ()=>{
            dispatch((0, $cpZzK.filterQueryChangedAction)(null));
            dispatch((0, $cpZzK.filterQuerySubmittedAction)(null));
        },
        onIssueChange: ()=>{
            dispatch((0, $cpZzK.isNewFilterQueryPendingAction)(true));
            dispatch((0, $2MzoN.loadIssuesAction)(0, (0, $f3fa5acbda0f3e0e$export$217a2381e50d4bff)));
        },
        onSetIssueKey: (key)=>{
            dispatch((0, $aXT93.setSidebarIssueKey)(key));
        },
        onNonPremiumSLAColumnError: ()=>(0, $bKkYU.displayQueuesErrorHeaderAction)
    });
const $ec607219d344757a$var$getSidebarApiProps = (0, $LFmXM.default)((sidebarApiProps)=>sidebarApiProps);
const $ec607219d344757a$var$LayoutWithSidebarApi = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fcM2a.UIControllerSubscriber), null, ({ state: sidebarState })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7pRCV.NavigationUISubscriber), null, (_, navActions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hbWqB.default), {
                ...props,
                sidebarApi: $ec607219d344757a$var$getSidebarApiProps({
                    navActions: navActions,
                    isCollapsed: sidebarState.isCollapsed
                })
            })));
const $ec607219d344757a$var$ConnectedLayout = (0, $gnQAk.connect)($ec607219d344757a$var$mapStateToPropsFactory, $ec607219d344757a$var$mapDispatchToProps)($ec607219d344757a$var$LayoutWithSidebarApi);
var $ec607219d344757a$export$2e2bcd8739ae039 = $ec607219d344757a$var$ConnectedLayout;

});
parcelRegister("fcM2a", function(module, exports) {

$parcel$export(module.exports, "UIControllerSubscriber", () => $460351244107c238$export$8e3db525e646de2c);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $9Sckd = parcelRequire("9Sckd");

var $f2JN3 = parcelRequire("f2JN3");

var $cUxaS = parcelRequire("cUxaS");

var $6zXPf = parcelRequire("6zXPf");
// Nav3
const $460351244107c238$var$UIControllerSubscriberOld = ({ children: children })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $cUxaS.useLeftSidebarController)();
    const { isCollapsed: isCollapsed, width: width } = (0, $cUxaS.useLeftSidebarState)();
    const stateRef = (0, $eJOHy.useRef)({
        state: {
            isCollapsed: isCollapsed,
            isResizing: false,
            isResizeDisabled: false,
            productNavWidth: width
        },
        collapse: collapseLeftSidebar,
        expand: expandLeftSidebar,
        toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
    });
    const navigationUIController = (0, $eJOHy.useMemo)(()=>({
            state: {
                isCollapsed: isCollapsed,
                isResizing: false,
                isResizeDisabled: false,
                productNavWidth: width
            },
            collapse: collapseLeftSidebar,
            expand: expandLeftSidebar,
            toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
        }), [
        collapseLeftSidebar,
        expandLeftSidebar,
        isCollapsed,
        width
    ]);
    stateRef.current = Object.assign(stateRef.current, navigationUIController);
    return children(stateRef.current);
};
const $460351244107c238$var$defaultState = {
    state: {
        isCollapsed: false,
        isResizing: false,
        isResizeDisabled: false,
        productNavWidth: 0
    },
    collapse: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    expand: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    toggleCollapse: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
// Nav4
const $460351244107c238$var$UIControllerSubscriberNew = ({ children: children })=>{
    const toggleSideNav = (0, $9Sckd.useToggleSideNav)();
    const stateRef = (0, $eJOHy.useRef)({
        ...$460351244107c238$var$defaultState,
        toggleCollapse: toggleSideNav
    });
    const navigationUIController = (0, $eJOHy.useMemo)(()=>({
            ...$460351244107c238$var$defaultState,
            toggleCollapse: toggleSideNav
        }), [
        toggleSideNav
    ]);
    stateRef.current = Object.assign(stateRef.current, navigationUIController);
    return children(stateRef.current);
};
const $460351244107c238$export$8e3db525e646de2c = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $460351244107c238$var$UIControllerSubscriberNew, $460351244107c238$var$UIControllerSubscriberOld);

});

parcelRegister("7RZlK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dea1f7720327a08$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $7jTnu = parcelRequire("7jTnu");

var $7uL8m = parcelRequire("7uL8m");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $8vQmW = parcelRequire("8vQmW");

var $5cKBg = parcelRequire("5cKBg");
const $4dea1f7720327a08$var$EmptyView = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        renderImage: (0, $7jTnu.fg)('jsm_queues_consolidate_jfe_assets') ? (0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $7uL8m.default)) : undefined,
        imageUrl: (0, $7jTnu.fg)('jsm_queues_consolidate_jfe_assets') ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($8vQmW))),
        header: formatMessage((0, $5cKBg.default).header),
        description: formatMessage((0, $5cKBg.default).description),
        headingLevel: 2
    });
};
var $4dea1f7720327a08$export$2e2bcd8739ae039 = $4dea1f7720327a08$var$EmptyView;

});
parcelRegister("7uL8m", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a8498e45c2fcae9$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $c4huj = parcelRequire("c4huj");

var $lGiXj = parcelRequire("lGiXj");

var $dIBgP = parcelRequire("dIBgP");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $8a8498e45c2fcae9$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dIBgP)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($lGiXj))
});
var $8a8498e45c2fcae9$export$2e2bcd8739ae039 = $8a8498e45c2fcae9$var$Illustration;
// for advanced use only
const $8a8498e45c2fcae9$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("lGiXj", function(module, exports) {
module.exports = new URL("search-no-results-old-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("dIBgP", function(module, exports) {
module.exports = new URL("search-no-results-old.10b14394.svg", import.meta.url).toString();

});


parcelRegister("8vQmW", function(module, exports) {
module.exports = new URL("no-search-results.6374065e.svg", import.meta.url).toString();

});

parcelRegister("5cKBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6e4d16b2396347f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e6e4d16b2396347f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    header: {
        "id": "servicedesk.queues.agent-view.layout.empty-filtered-queue.header",
        "defaultMessage": "We couldn't find any requests that match your search"
    },
    description: {
        "id": "servicedesk.queues.agent-view.layout.empty-filtered-queue.description",
        "defaultMessage": "Check for typos, or try another search term"
    }
});

});


parcelRegister("5ulZp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e99ffbb5957b3c$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $f20Bj = parcelRequire("f20Bj");

var $jIeeH = parcelRequire("jIeeH");

var $6GpZA = parcelRequire("6GpZA");

var $lc49q = parcelRequire("lc49q");

var $6I1gv = parcelRequire("6I1gv");

var $8pEJH = parcelRequire("8pEJH");

var $24D4A = parcelRequire("24D4A");

var $dEoHu = parcelRequire("dEoHu");
const $f8e99ffbb5957b3c$var$mapStateToProps = (state)=>({
        emptyStateMessage: (0, $24D4A.getEmptyStateMessage)(state),
        projectId: (0, $f20Bj.getProjectId)(state),
        queueId: (0, $lc49q.getQueueId)(state),
        isQueueVisible: (0, $6I1gv.isQueueVisible)(state),
        category: (0, $lc49q.getCategory)(state),
        EmptyQueueComponent: $6GpZA.default,
        DemoDripFeed: $8pEJH.default,
        ReadyForUser: $jIeeH.ReadyForUser,
        metricKey: (0, $lc49q.getMetricKey)(state)
    });
var $f8e99ffbb5957b3c$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($f8e99ffbb5957b3c$var$mapStateToProps, {})((0, $dEoHu.default));

});
parcelRegister("jIeeH", function(module, exports) {

$parcel$export(module.exports, "ReadyForUser", () => $98e387be4b151760$export$c05d1149dfea94a1);

var $eJOHy = parcelRequire("eJOHy");

var $6uWhG = parcelRequire("6uWhG");

var $aS0KX = parcelRequire("aS0KX");
const $98e387be4b151760$export$c05d1149dfea94a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($98e387be4b151760$export$5efccbb976d3d994, props);
class $98e387be4b151760$export$5efccbb976d3d994 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            context: undefined,
            onLoadEnd: (0, $aS0KX.end)
        };
    }
    componentDidMount() {
        this.recordEndMetric();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.context !== this.props.context) this.recordEndMetric();
    }
    recordEndMetric() {
        const { onLoadEnd: onLoadEnd } = this.props;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const location = window.location.pathname;
        (0, $6uWhG.setMark)('jsd.performance.profile.record.metric.end');
        onLoadEnd(location);
        var emitSignal;
    }
    render() {
        return null;
    }
}

});
parcelRegister("aS0KX", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    return function(t) {
        function e(n) {
            if (r[n]) return r[n].exports;
            var o = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
        }
        var r = {};
        return e.m = t, e.c = r, e.d = function(t, r, n) {
            e.o(t, r) || Object.defineProperty(t, r, {
                configurable: !1,
                enumerable: !0,
                get: n
            });
        }, e.n = function(t) {
            var r = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return e.d(r, "a", r), r;
        }, e.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, e.p = "", e(e.s = 43);
    }([
        function(t, e) {
            var r = Array.isArray;
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(22), o = "object" == typeof self && self && self.Object === Object && self, u = n || o || Function("return this")();
            t.exports = u;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = u(t, e);
                return o(r) ? r : void 0;
            }
            var o = r(75), u = r(78);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return null == t ? void 0 === t ? a : c : f && f in Object(t) ? u(t) : i(t);
            }
            var o = r(5), u = r(52), i = r(53), c = "[object Null]", a = "[object Undefined]", f = o ? o.toStringTag : void 0;
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return null != t && "object" == typeof t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(1), o = n.Symbol;
            t.exports = o;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            var o = r(65), u = r(66), i = r(67), c = r(68), a = r(69);
            n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                for(var r = t.length; r--;)if (o(t[r][0], e)) return r;
                return -1;
            }
            var o = r(31);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(2), o = n(Object, "create");
            t.exports = o;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = t.__data__;
                return o(e) ? r["string" == typeof e ? "string" : "hash"] : r.map;
            }
            var o = r(87);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                if ("string" == typeof t || o(t)) return t;
                var e = t + "";
                return "0" == e && 1 / t == -u ? "-0" : e;
            }
            var o = r(18), u = 1 / 0;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return i(t) ? o(t) : u(t);
            }
            var o = r(49), u = r(58), i = r(13);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return "number" == typeof t && t > -1 && t % 1 == 0 && t <= n;
            }
            var n = 9007199254740991;
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return null != t && u(t.length) && !o(t);
            }
            var o = r(28), u = r(12);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = typeof t;
                return null != t && ("object" == e || "function" == e);
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "Map");
            t.exports = u;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            var o = r(79), u = r(86), i = r(88), c = r(89), a = r(90);
            n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                if (o(t)) return !1;
                var r = typeof t;
                return !("number" != r && "symbol" != r && "boolean" != r && null != t && !u(t)) || c.test(t) || !i.test(t) || null != e && t in Object(e);
            }
            var o = r(0), u = r(18), i = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, c = /^\w*$/;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return "symbol" == typeof t || u(t) && o(t) == i;
            }
            var o = r(3), u = r(4), i = "[object Symbol]";
            t.exports = n;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }
            function o(t) {
                return !isNaN(parseInt(t, 10));
            }
            function u(t) {
                return new RegExp("[A-Z0-9]+-\\d+").test(t);
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var i = r(44), c = n(i), a = r(127), f = n(a), s = r(129), p = n(s), l = r(42);
            e.default = function(t) {
                var e = (0, p.default)([
                    t.module,
                    t.item,
                    t.secondaryItem,
                    t.tertiaryItem,
                    t.quaternaryItem,
                    t.quinternaryItem
                ]), r = (0, f.default)(e, function(t) {
                    return o(t) ? "ENTITY_ID" : u(t) ? "ISSUE_KEY" : t;
                }).join(".");
                return (0, c.default)((0, l.getKeyTransformers)(), function(t, e) {
                    return e(t);
                }, r);
            };
        },
        function(t, e, r) {
            var n = r(46), o = r(62), u = o(n);
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(51), o = r(4), u = Object.prototype, i = u.hasOwnProperty, c = u.propertyIsEnumerable, a = n(function() {
                return arguments;
            }()) ? n : function(t) {
                return o(t) && i.call(t, "callee") && !c.call(t, "callee");
            };
            t.exports = a;
        },
        function(t, e, r) {
            (function(e) {
                var r = "object" == typeof e && e && e.Object === Object && e;
                t.exports = r;
            }).call(e, r(23));
        },
        function(t, e) {
            var r;
            r = function() {
                return this;
            }();
            try {
                r = r || Function("return this")() || (0, eval)("this");
            } catch (t) {
                "object" == typeof window && (r = window);
            }
            t.exports = r;
        },
        function(t, e, r) {
            (function(t) {
                var n = r(1), o = r(54), u = "object" == typeof e && e && !e.nodeType && e, i = u && "object" == typeof t && t && !t.nodeType && t, c = i && i.exports === u, a = c ? n.Buffer : void 0, f = a ? a.isBuffer : void 0, s = f || o;
                t.exports = s;
            }).call(e, r(25)(t));
        },
        function(t, e) {
            t.exports = function(t) {
                return t.webpackPolyfill || (t.deprecate = function() {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
                    enumerable: !0,
                    get: function() {
                        return t.l;
                    }
                }), Object.defineProperty(t, "id", {
                    enumerable: !0,
                    get: function() {
                        return t.i;
                    }
                }), t.webpackPolyfill = 1), t;
            };
        },
        function(t, e) {
            function r(t, e) {
                var r = typeof t;
                return !!(e = null == e ? n : e) && ("number" == r || "symbol" != r && o.test(t)) && t > -1 && t % 1 == 0 && t < e;
            }
            var n = 9007199254740991, o = /^(?:0|[1-9]\d*)$/;
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(55), o = r(56), u = r(57), i = u && u.isTypedArray, c = i ? o(i) : n;
            t.exports = c;
        },
        function(t, e, r) {
            function n(t) {
                if (!u(t)) return !1;
                var e = o(t);
                return e == c || e == a || e == i || e == f;
            }
            var o = r(3), u = r(14), i = "[object AsyncFunction]", c = "[object Function]", a = "[object GeneratorFunction]", f = "[object Proxy]";
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return "function" == typeof t ? t : null == t ? i : "object" == typeof t ? c(t) ? u(t[0], t[1]) : o(t) : a(t);
            }
            var o = r(63), u = r(114), i = r(41), c = r(0), a = r(123);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__ = new o(t);
                this.size = e.size;
            }
            var o = r(6), u = r(70), i = r(71), c = r(72), a = r(73), f = r(74);
            n.prototype.clear = u, n.prototype.delete = i, n.prototype.get = c, n.prototype.has = a, n.prototype.set = f, t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return t === e || t !== t && e !== e;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                if (null != t) {
                    try {
                        return o.call(t);
                    } catch (t) {}
                    try {
                        return t + "";
                    } catch (t) {}
                }
                return "";
            }
            var n = Function.prototype, o = n.toString;
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r, i, c) {
                return t === e || (null == t || null == e || !u(t) && !u(e) ? t !== t && e !== e : o(t, e, r, i, n, c));
            }
            var o = r(91), u = r(4);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r, n, f, s) {
                var p = r & c, l = t.length, v = e.length;
                if (l != v && !(p && v > l)) return !1;
                var d = s.get(t);
                if (d && s.get(e)) return d == e;
                var y = -1, h = !0, b = r & a ? new o : void 0;
                for(s.set(t, e), s.set(e, t); ++y < l;){
                    var x = t[y], _ = e[y];
                    if (n) var j = p ? n(_, x, y, e, t, s) : n(x, _, y, t, e, s);
                    if (void 0 !== j) {
                        if (j) continue;
                        h = !1;
                        break;
                    }
                    if (b) {
                        if (!u(e, function(t, e) {
                            if (!i(b, e) && (x === t || f(x, t, r, n, s))) return b.push(e);
                        })) {
                            h = !1;
                            break;
                        }
                    } else if (x !== _ && !f(x, _, r, n, s)) {
                        h = !1;
                        break;
                    }
                }
                return s.delete(t), s.delete(e), h;
            }
            var o = r(92), u = r(95), i = r(96), c = 1, a = 2;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return t === t && !o(t);
            }
            var o = r(14);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return function(r) {
                    return null != r && r[t] === e && (void 0 !== e || t in Object(r));
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                e = o(e, t);
                for(var r = 0, n = e.length; null != t && r < n;)t = t[u(e[r++])];
                return r && r == n ? t : void 0;
            }
            var o = r(38), u = r(10);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                return o(t) ? t : u(t, e) ? [
                    t
                ] : i(c(t));
            }
            var o = r(0), u = r(17), i = r(116), c = r(119);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length, o = Array(n); ++r < n;)o[r] = e(t[r], r, t);
                return o;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r) {
                e = o(e, t);
                for(var n = -1, s = e.length, p = !1; ++n < s;){
                    var l = f(e[n]);
                    if (!(p = null != t && r(t, l))) break;
                    t = t[l];
                }
                return p || ++n != s ? p : !!(s = null == t ? 0 : t.length) && a(s) && c(l, s) && (i(t) || u(t));
            }
            var o = r(38), u = r(21), i = r(0), c = r(26), a = r(12), f = r(10);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            "use strict";
            (function(t) {
                function n(t) {
                    return t && t.__esModule ? t : {
                        default: t
                    };
                }
                function o(t, e, r) {
                    return e in t ? Object.defineProperty(t, e, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : t[e] = r, t;
                }
                function u(e, r) {
                    t.window._jsdApdex ? (0, d.default)(t.window._jsdApdex, e) || (t.window._jsdApdex[e] = r) : t.window._jsdApdex = o({}, e, r);
                }
                function i() {
                    return t.window._jsdApdex || {};
                }
                function c(t) {
                    u("metricsRecorder", t);
                }
                function a() {
                    return i().metricsRecorder ? i().metricsRecorder : (console.error("APDEX metrics recorder not initialized. Not recording APDEX."), {
                        start: l.default,
                        end: l.default
                    });
                }
                function f(t) {
                    u("keyTransformers", t);
                }
                function s() {
                    return i().keyTransformers || [];
                }
                Object.defineProperty(e, "__esModule", {
                    value: !0
                });
                var p = r(41), l = n(p), v = r(130), d = n(v);
                e.installMetricsRecorder = c, e.getMetricsRecorder = a, e.installKeyTransformers = f, e.getKeyTransformers = s;
            }).call(e, r(23));
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }
            function o(t) {
                return "object" === (void 0 === t ? "undefined" : f(t)) ? (0, p.default)(t) : "string" == typeof t ? (0, v.default)(t) : "";
            }
            function u(t, e) {
                (0, y.installMetricsRecorder)(t), (0, y.installKeyTransformers)(e);
            }
            function i(t, e) {
                var r = o(t);
                return (0, d.withStartEventFiltering)(r, function(t) {
                    (0, y.getMetricsRecorder)().start(t, e);
                });
            }
            function c(t) {
                var e = o(t);
                return (0, d.withEndEventFiltering)(e, function(t) {
                    (0, y.getMetricsRecorder)().end(t);
                });
            }
            function a(t) {
                return c(t);
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.getExpectedRedirect = e.hasExpectedRedirect = e.hasExpectedRedirectOf = void 0;
            var f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            };
            e.install = u, e.start = i, e.end = c, e.readyForUser = a;
            var s = r(19), p = n(s), l = r(132), v = n(l), d = r(133), y = r(42);
            e.hasExpectedRedirectOf = d.hasExpectedRedirectOf, e.hasExpectedRedirect = d.hasExpectedRedirect, e.getExpectedRedirect = d.getExpectedRedirect;
        },
        function(t, e, r) {
            function n(t, e, r) {
                var n = a(t) ? o : c, f = arguments.length < 3;
                return n(t, i(e, 4), r, f, u);
            }
            var o = r(45), u = r(20), i = r(29), c = r(126), a = r(0);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e, r, n) {
                var o = -1, u = null == t ? 0 : t.length;
                for(n && u && (r = t[++o]); ++o < u;)r = e(r, t[o], o, t);
                return r;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return t && o(t, e, u);
            }
            var o = r(47), u = r(11);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(48), o = n();
            t.exports = o;
        },
        function(t, e) {
            function r(t) {
                return function(e, r, n) {
                    for(var o = -1, u = Object(e), i = n(e), c = i.length; c--;){
                        var a = i[t ? c : ++o];
                        if (!1 === r(u[a], a, u)) break;
                    }
                    return e;
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = i(t), n = !r && u(t), s = !r && !n && c(t), l = !r && !n && !s && f(t), v = r || n || s || l, d = v ? o(t.length, String) : [], y = d.length;
                for(var h in t)!e && !p.call(t, h) || v && ("length" == h || s && ("offset" == h || "parent" == h) || l && ("buffer" == h || "byteLength" == h || "byteOffset" == h) || a(h, y)) || d.push(h);
                return d;
            }
            var o = r(50), u = r(21), i = r(0), c = r(24), a = r(26), f = r(27), s = Object.prototype, p = s.hasOwnProperty;
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = Array(t); ++r < t;)n[r] = e(r);
                return n;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return u(t) && o(t) == i;
            }
            var o = r(3), u = r(4), i = "[object Arguments]";
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = i.call(t, a), r = t[a];
                try {
                    t[a] = void 0;
                    var n = !0;
                } catch (t) {}
                var o = c.call(t);
                return n && (e ? t[a] = r : delete t[a]), o;
            }
            var o = r(5), u = Object.prototype, i = u.hasOwnProperty, c = u.toString, a = o ? o.toStringTag : void 0;
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return o.call(t);
            }
            var n = Object.prototype, o = n.toString;
            t.exports = r;
        },
        function(t, e) {
            function r() {
                return !1;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return i(t) && u(t.length) && !!c[o(t)];
            }
            var o = r(3), u = r(12), i = r(4), c = {};
            c["[object Float32Array]"] = c["[object Float64Array]"] = c["[object Int8Array]"] = c["[object Int16Array]"] = c["[object Int32Array]"] = c["[object Uint8Array]"] = c["[object Uint8ClampedArray]"] = c["[object Uint16Array]"] = c["[object Uint32Array]"] = !0, c["[object Arguments]"] = c["[object Array]"] = c["[object ArrayBuffer]"] = c["[object Boolean]"] = c["[object DataView]"] = c["[object Date]"] = c["[object Error]"] = c["[object Function]"] = c["[object Map]"] = c["[object Number]"] = c["[object Object]"] = c["[object RegExp]"] = c["[object Set]"] = c["[object String]"] = c["[object WeakMap]"] = !1, t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return function(e) {
                    return t(e);
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            (function(t) {
                var n = r(22), o = "object" == typeof e && e && !e.nodeType && e, u = o && "object" == typeof t && t && !t.nodeType && t, i = u && u.exports === o, c = i && n.process, a = function() {
                    try {
                        var t = u && u.require && u.require("util").types;
                        return t || c && c.binding && c.binding("util");
                    } catch (t) {}
                }();
                t.exports = a;
            }).call(e, r(25)(t));
        },
        function(t, e, r) {
            function n(t) {
                if (!o(t)) return u(t);
                var e = [];
                for(var r in Object(t))c.call(t, r) && "constructor" != r && e.push(r);
                return e;
            }
            var o = r(59), u = r(60), i = Object.prototype, c = i.hasOwnProperty;
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = t && t.constructor;
                return t === ("function" == typeof e && e.prototype || n);
            }
            var n = Object.prototype;
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(61), o = n(Object.keys, Object);
            t.exports = o;
        },
        function(t, e) {
            function r(t, e) {
                return function(r) {
                    return t(e(r));
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return function(r, n) {
                    if (null == r) return r;
                    if (!o(r)) return t(r, n);
                    for(var u = r.length, i = e ? u : -1, c = Object(r); (e ? i-- : ++i < u) && !1 !== n(c[i], i, c););
                    return r;
                };
            }
            var o = r(13);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = u(t);
                return 1 == e.length && e[0][2] ? i(e[0][0], e[0][1]) : function(r) {
                    return r === t || o(r, t, e);
                };
            }
            var o = r(64), u = r(113), i = r(36);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r, n) {
                var a = r.length, f = a, s = !n;
                if (null == t) return !f;
                for(t = Object(t); a--;){
                    var p = r[a];
                    if (s && p[2] ? p[1] !== t[p[0]] : !(p[0] in t)) return !1;
                }
                for(; ++a < f;){
                    p = r[a];
                    var l = p[0], v = t[l], d = p[1];
                    if (s && p[2]) {
                        if (void 0 === v && !(l in t)) return !1;
                    } else {
                        var y = new o;
                        if (n) var h = n(v, d, l, t, e, y);
                        if (!(void 0 === h ? u(d, v, i | c, n, y) : h)) return !1;
                    }
                }
                return !0;
            }
            var o = r(30), u = r(33), i = 1, c = 2;
            t.exports = n;
        },
        function(t, e) {
            function r() {
                this.__data__ = [], this.size = 0;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__, r = o(e, t);
                return !(r < 0) && (r == e.length - 1 ? e.pop() : i.call(e, r, 1), --this.size, !0);
            }
            var o = r(7), u = Array.prototype, i = u.splice;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__, r = o(e, t);
                return r < 0 ? void 0 : e[r][1];
            }
            var o = r(7);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return o(this.__data__, t) > -1;
            }
            var o = r(7);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = this.__data__, n = o(r, t);
                return n < 0 ? (++this.size, r.push([
                    t,
                    e
                ])) : r[n][1] = e, this;
            }
            var o = r(7);
            t.exports = n;
        },
        function(t, e, r) {
            function n() {
                this.__data__ = new o, this.size = 0;
            }
            var o = r(6);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = this.__data__, r = e.delete(t);
                return this.size = e.size, r;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.get(t);
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.has(t);
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = this.__data__;
                if (r instanceof o) {
                    var n = r.__data__;
                    if (!u || n.length < c - 1) return n.push([
                        t,
                        e
                    ]), this.size = ++r.size, this;
                    r = this.__data__ = new i(n);
                }
                return r.set(t, e), this.size = r.size, this;
            }
            var o = r(6), u = r(15), i = r(16), c = 200;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return !(!i(t) || u(t)) && (o(t) ? d : f).test(c(t));
            }
            var o = r(28), u = r(76), i = r(14), c = r(32), a = /[\\^$.*+?()[\]{}|]/g, f = /^\[object .+?Constructor\]$/, s = Function.prototype, p = Object.prototype, l = s.toString, v = p.hasOwnProperty, d = RegExp("^" + l.call(v).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return !!u && u in t;
            }
            var o = r(77), u = function() {
                var t = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "");
                return t ? "Symbol(src)_1." + t : "";
            }();
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(1), o = n["__core-js_shared__"];
            t.exports = o;
        },
        function(t, e) {
            function r(t, e) {
                return null == t ? void 0 : t[e];
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n() {
                this.size = 0, this.__data__ = {
                    hash: new o,
                    map: new (i || u),
                    string: new o
                };
            }
            var o = r(80), u = r(6), i = r(15);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.clear(); ++e < r;){
                    var n = t[e];
                    this.set(n[0], n[1]);
                }
            }
            var o = r(81), u = r(82), i = r(83), c = r(84), a = r(85);
            n.prototype.clear = o, n.prototype.delete = u, n.prototype.get = i, n.prototype.has = c, n.prototype.set = a, t.exports = n;
        },
        function(t, e, r) {
            function n() {
                this.__data__ = o ? o(null) : {}, this.size = 0;
            }
            var o = r(8);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = this.has(t) && delete this.__data__[t];
                return this.size -= e ? 1 : 0, e;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__;
                if (o) {
                    var r = e[t];
                    return r === u ? void 0 : r;
                }
                return c.call(e, t) ? e[t] : void 0;
            }
            var o = r(8), u = "__lodash_hash_undefined__", i = Object.prototype, c = i.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = this.__data__;
                return o ? void 0 !== e[t] : i.call(e, t);
            }
            var o = r(8), u = Object.prototype, i = u.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = this.__data__;
                return this.size += this.has(t) ? 0 : 1, r[t] = o && void 0 === e ? u : e, this;
            }
            var o = r(8), u = "__lodash_hash_undefined__";
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = o(this, t).delete(t);
                return this.size -= e ? 1 : 0, e;
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                var e = typeof t;
                return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return o(this, t).get(t);
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return o(this, t).has(t);
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = o(this, t), n = r.size;
                return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
            }
            var o = r(9);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r, n, h, x) {
                var _ = f(t), j = f(e), g = _ ? d : a(t), m = j ? d : a(e);
                g = g == v ? y : g, m = m == v ? y : m;
                var w = g == y, O = m == y, A = g == m;
                if (A && s(t)) {
                    if (!s(e)) return !1;
                    _ = !0, w = !1;
                }
                if (A && !w) return x || (x = new o), _ || p(t) ? u(t, e, r, n, h, x) : i(t, e, g, r, n, h, x);
                if (!(r & l)) {
                    var E = w && b.call(t, "__wrapped__"), P = O && b.call(e, "__wrapped__");
                    if (E || P) {
                        var R = E ? t.value() : t, S = P ? e.value() : e;
                        return x || (x = new o), h(R, S, r, n, x);
                    }
                }
                return !!A && (x || (x = new o), c(t, e, r, n, h, x));
            }
            var o = r(30), u = r(34), i = r(97), c = r(101), a = r(108), f = r(0), s = r(24), p = r(27), l = 1, v = "[object Arguments]", d = "[object Array]", y = "[object Object]", h = Object.prototype, b = h.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                var e = -1, r = null == t ? 0 : t.length;
                for(this.__data__ = new o; ++e < r;)this.add(t[e]);
            }
            var o = r(16), u = r(93), i = r(94);
            n.prototype.add = n.prototype.push = u, n.prototype.has = i, t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.set(t, n), this;
            }
            var n = "__lodash_hash_undefined__";
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                return this.__data__.has(t);
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length; ++r < n;)if (e(t[r], r, t)) return !0;
                return !1;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t, e) {
                return t.has(e);
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r, n, o, w, A) {
                switch(r){
                    case m:
                        if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
                        t = t.buffer, e = e.buffer;
                    case g:
                        return !(t.byteLength != e.byteLength || !w(new u(t), new u(e)));
                    case l:
                    case v:
                    case h:
                        return i(+t, +e);
                    case d:
                        return t.name == e.name && t.message == e.message;
                    case b:
                    case _:
                        return t == e + "";
                    case y:
                        var E = a;
                    case x:
                        var P = n & s;
                        if (E || (E = f), t.size != e.size && !P) return !1;
                        var R = A.get(t);
                        if (R) return R == e;
                        n |= p, A.set(t, e);
                        var S = c(E(t), E(e), n, o, w, A);
                        return A.delete(t), S;
                    case j:
                        if (O) return O.call(t) == O.call(e);
                }
                return !1;
            }
            var o = r(5), u = r(98), i = r(31), c = r(34), a = r(99), f = r(100), s = 1, p = 2, l = "[object Boolean]", v = "[object Date]", d = "[object Error]", y = "[object Map]", h = "[object Number]", b = "[object RegExp]", x = "[object Set]", _ = "[object String]", j = "[object Symbol]", g = "[object ArrayBuffer]", m = "[object DataView]", w = o ? o.prototype : void 0, O = w ? w.valueOf : void 0;
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(1), o = n.Uint8Array;
            t.exports = o;
        },
        function(t, e) {
            function r(t) {
                var e = -1, r = Array(t.size);
                return t.forEach(function(t, n) {
                    r[++e] = [
                        n,
                        t
                    ];
                }), r;
            }
            t.exports = r;
        },
        function(t, e) {
            function r(t) {
                var e = -1, r = Array(t.size);
                return t.forEach(function(t) {
                    r[++e] = t;
                }), r;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e, r, n, i, a) {
                var f = r & u, s = o(t), p = s.length;
                if (p != o(e).length && !f) return !1;
                for(var l = p; l--;){
                    var v = s[l];
                    if (!(f ? v in e : c.call(e, v))) return !1;
                }
                var d = a.get(t);
                if (d && a.get(e)) return d == e;
                var y = !0;
                a.set(t, e), a.set(e, t);
                for(var h = f; ++l < p;){
                    v = s[l];
                    var b = t[v], x = e[v];
                    if (n) var _ = f ? n(x, b, v, e, t, a) : n(b, x, v, t, e, a);
                    if (!(void 0 === _ ? b === x || i(b, x, r, n, a) : _)) {
                        y = !1;
                        break;
                    }
                    h || (h = "constructor" == v);
                }
                if (y && !h) {
                    var j = t.constructor, g = e.constructor;
                    j != g && "constructor" in t && "constructor" in e && !("function" == typeof j && j instanceof j && "function" == typeof g && g instanceof g) && (y = !1);
                }
                return a.delete(t), a.delete(e), y;
            }
            var o = r(102), u = 1, i = Object.prototype, c = i.hasOwnProperty;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return o(t, i, u);
            }
            var o = r(103), u = r(105), i = r(11);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r) {
                var n = e(t);
                return u(t) ? n : o(n, r(t));
            }
            var o = r(104), u = r(0);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = e.length, o = t.length; ++r < n;)t[o + r] = e[r];
                return t;
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(106), o = r(107), u = Object.prototype, i = u.propertyIsEnumerable, c = Object.getOwnPropertySymbols, a = c ? function(t) {
                return null == t ? [] : (t = Object(t), n(c(t), function(e) {
                    return i.call(t, e);
                }));
            } : o;
            t.exports = a;
        },
        function(t, e) {
            function r(t, e) {
                for(var r = -1, n = null == t ? 0 : t.length, o = 0, u = []; ++r < n;){
                    var i = t[r];
                    e(i, r, t) && (u[o++] = i);
                }
                return u;
            }
            t.exports = r;
        },
        function(t, e) {
            function r() {
                return [];
            }
            t.exports = r;
        },
        function(t, e, r) {
            var n = r(109), o = r(15), u = r(110), i = r(111), c = r(112), a = r(3), f = r(32), s = f(n), p = f(o), l = f(u), v = f(i), d = f(c), y = a;
            (n && "[object DataView]" != y(new n(new ArrayBuffer(1))) || o && "[object Map]" != y(new o) || u && "[object Promise]" != y(u.resolve()) || i && "[object Set]" != y(new i) || c && "[object WeakMap]" != y(new c)) && (y = function(t) {
                var e = a(t), r = "[object Object]" == e ? t.constructor : void 0, n = r ? f(r) : "";
                if (n) switch(n){
                    case s:
                        return "[object DataView]";
                    case p:
                        return "[object Map]";
                    case l:
                        return "[object Promise]";
                    case v:
                        return "[object Set]";
                    case d:
                        return "[object WeakMap]";
                }
                return e;
            }), t.exports = y;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "DataView");
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "Promise");
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "Set");
            t.exports = u;
        },
        function(t, e, r) {
            var n = r(2), o = r(1), u = n(o, "WeakMap");
            t.exports = u;
        },
        function(t, e, r) {
            function n(t) {
                for(var e = u(t), r = e.length; r--;){
                    var n = e[r], i = t[n];
                    e[r] = [
                        n,
                        i,
                        o(i)
                    ];
                }
                return e;
            }
            var o = r(35), u = r(11);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                return c(t) && a(e) ? f(s(t), e) : function(r) {
                    var n = u(r, t);
                    return void 0 === n && n === e ? i(r, t) : o(e, n, p | l);
                };
            }
            var o = r(33), u = r(115), i = r(121), c = r(17), a = r(35), f = r(36), s = r(10), p = 1, l = 2;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e, r) {
                var n = null == t ? void 0 : o(t, e);
                return void 0 === n ? r : n;
            }
            var o = r(37);
            t.exports = n;
        },
        function(t, e, r) {
            var n = r(117), o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, u = /\\(\\)?/g, i = n(function(t) {
                var e = [];
                return 46 === t.charCodeAt(0) && e.push(""), t.replace(o, function(t, r, n, o) {
                    e.push(n ? o.replace(u, "$1") : r || t);
                }), e;
            });
            t.exports = i;
        },
        function(t, e, r) {
            function n(t) {
                var e = o(t, function(t) {
                    return r.size === u && r.clear(), t;
                }), r = e.cache;
                return e;
            }
            var o = r(118), u = 500;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError(u);
                var r = function() {
                    var n = arguments, o = e ? e.apply(this, n) : n[0], u = r.cache;
                    if (u.has(o)) return u.get(o);
                    var i = t.apply(this, n);
                    return r.cache = u.set(o, i) || u, i;
                };
                return r.cache = new (n.Cache || o), r;
            }
            var o = r(16), u = "Expected a function";
            n.Cache = o, t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                return null == t ? "" : o(t);
            }
            var o = r(120);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t) {
                if ("string" == typeof t) return t;
                if (i(t)) return u(t, n) + "";
                if (c(t)) return s ? s.call(t) : "";
                var e = t + "";
                return "0" == e && 1 / t == -a ? "-0" : e;
            }
            var o = r(5), u = r(39), i = r(0), c = r(18), a = 1 / 0, f = o ? o.prototype : void 0, s = f ? f.toString : void 0;
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                return null != t && u(t, e, o);
            }
            var o = r(122), u = r(40);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return null != t && e in Object(t);
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return i(t) ? o(c(t)) : u(t);
            }
            var o = r(124), u = r(125), i = r(17), c = r(10);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                return function(e) {
                    return null == e ? void 0 : e[t];
                };
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t) {
                return function(e) {
                    return o(e, t);
                };
            }
            var o = r(37);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e, r, n, o) {
                return o(t, function(t, o, u) {
                    r = n ? (n = !1, t) : e(r, t, o, u);
                }), r;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return (c(t) ? o : i)(t, u(e, 3));
            }
            var o = r(39), u = r(29), i = r(128), c = r(0);
            t.exports = n;
        },
        function(t, e, r) {
            function n(t, e) {
                var r = -1, n = u(t) ? Array(t.length) : [];
                return o(t, function(t, o, u) {
                    n[++r] = e(t, o, u);
                }), n;
            }
            var o = r(20), u = r(13);
            t.exports = n;
        },
        function(t, e) {
            function r(t) {
                for(var e = -1, r = null == t ? 0 : t.length, n = 0, o = []; ++e < r;){
                    var u = t[e];
                    u && (o[n++] = u);
                }
                return o;
            }
            t.exports = r;
        },
        function(t, e, r) {
            function n(t, e) {
                return null != t && u(t, e, o);
            }
            var o = r(131), u = r(40);
            t.exports = n;
        },
        function(t, e) {
            function r(t, e) {
                return null != t && o.call(t, e);
            }
            var n = Object.prototype, o = n.hasOwnProperty;
            t.exports = r;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                if (Array.isArray(t)) {
                    for(var e = 0, r = Array(t.length); e < t.length; e++)r[e] = t[e];
                    return r;
                }
                return Array.from(t);
            }
            function o(t) {
                return f.test(t) ? t.replace(f, "") : s.test(t) ? t.replace(s, "") : p.test(t) ? t.replace(p, "") : t.substr(1);
            }
            function u(t, e, r, n, o, u) {
                return {
                    module: t,
                    item: e,
                    secondaryItem: r,
                    tertiaryItem: n,
                    quaternaryItem: o,
                    quinternaryItem: u
                };
            }
            function i(t) {
                var e = o(t);
                return u.apply(void 0, n(e.split("/")));
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.stateFromRoute = i;
            var c = r(19), a = function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }(c), f = /^\/servicedesk\/admin\/[A-Z][A-Z0-9]{1,9}\//, s = /^\/projects\/[A-Z][A-Z0-9]{1,9}\//, p = /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]{1,9}\//;
            e.default = function(t) {
                return (0, a.default)(i(t));
            };
        },
        function(t, e, r) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = RegExp("\\.REDIRECT$"), o = void 0, u = e.getExpectedRedirect = function(t) {
                return t.replace(n, "");
            }, i = e.hasExpectedRedirect = function(t) {
                return n.test(t);
            }, c = (e.hasExpectedRedirectOf = function(t) {
                return t + ".REDIRECT";
            }, function(t) {
                return i(t) ? o = u(t) : (o = void 0, t);
            });
            e.resetSuppressedEvent = function() {
                o = void 0;
            }, e.withStartEventFiltering = function(t, e) {
                if (u(t) === o) return c(t);
                var r = c(t);
                return e(r), r;
            }, e.withEndEventFiltering = function(t, e) {
                return i(t) ? u(t) : (e(t), t);
            };
        }
    ]);
});

});


parcelRegister("6GpZA", function(module, exports) {

$parcel$export(module.exports, "default", () => $37679694fcd947d3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $5CSKW = parcelRequire("5CSKW");

var $6MnLl = parcelRequire("6MnLl");

var $58yRG = parcelRequire("58yRG");

var $7jTnu = parcelRequire("7jTnu");

var $ecCxV = parcelRequire("ecCxV");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $84DOT = parcelRequire("84DOT");

var $jipjz = parcelRequire("jipjz");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $3fKYX = parcelRequire("3fKYX");

var $byTOA = parcelRequire("byTOA");

var $ltq1U = parcelRequire("ltq1U");

var $8N3bi = parcelRequire("8N3bi");


var $14Ugu = parcelRequire("14Ugu");
const $37679694fcd947d3$export$fdbb6e83492670a7 = (props)=>{
    const { category: category, projectId: projectId, showCTA: showCTA = true } = props;
    const [practices] = (0, $3fKYX.usePracticeList)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const isDarkMode = colorMode === 'dark';
    const openCreateIssueDialogModern = (0, $eJOHy.useCallback)((_event, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'emptyQueueCreateIssueButton', {
            isAnyWorkCategoryEnabled: false
        });
        openIssueCreateModal({
            triggerPointKey: (0, $84DOT.JSM_EMPTY_QUEUE_CREATE_REQUEST)
        });
    }, [
        openIssueCreateModal
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (0, $gCeeo.fireScreenAnalytics)(createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const primaryAction = (0, $eJOHy.useMemo)(()=>{
        if (showCTA) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
            appearance: "primary",
            onClick: openCreateIssueDialogModern,
            "data-pid": projectId,
            testId: "servicedesk-queues-empty-queue.create-issue-button"
        }, formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $14Ugu.default).emptyQueueButtonLabelIssueTermRefresh : (0, $14Ugu.default).emptyQueueButtonLabel));
    }, [
        formatMessage,
        openCreateIssueDialogModern,
        projectId,
        showCTA
    ]);
    // If ITSM Project, render the ITSM empty states
    if (category !== undefined && practices && practices.length > 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8N3bi.EmptyPracticeQueue), {
        projectId: projectId
    });
    const IPHButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ecCxV.default), {
        articleId: "5b7BuVaVJqmbyCZ2mbMYHD",
        appearance: "link",
        spacing: "none",
        fallbackComponent: (0, $7jTnu.fg)('replace-anchor-with-link__jsd-shield') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            target: "_blank",
            href: (0, $3f68d10713a8cf4b$export$f960f87b7b043226)
        }, formatMessage((0, $14Ugu.default).emptyQueueLearnMoreText)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
            target: "_blank",
            href: (0, $3f68d10713a8cf4b$export$f960f87b7b043226)
        }, formatMessage((0, $14Ugu.default).emptyQueueLearnMoreText))
    }, formatMessage((0, $14Ugu.default).emptyQueueLearnMoreText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage((0, $14Ugu.default).emptyQueueHeader),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $14Ugu.default).emptyQueueDescriptionIssueTermRefresh : (0, $14Ugu.default).emptyQueueDescription,
            values: {
                // @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
                // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                p: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, chunks),
                IPHArticle: IPHButton,
                break: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null)
            }
        }),
        imageUrl: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($ltq1U))) : (0, (/*@__PURE__*/$parcel$interopDefault($byTOA))),
        maxImageWidth: (0, $3f68d10713a8cf4b$export$caaf33f9dba14d10),
        maxImageHeight: (0, $3f68d10713a8cf4b$export$3465603c26b84396),
        primaryAction: primaryAction
    });
};
var $37679694fcd947d3$export$2e2bcd8739ae039 = $37679694fcd947d3$export$fdbb6e83492670a7;

});
parcelRegister("ecCxV", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "HelpPanelLink", () => $ceecb2ae691c2ef9$export$5a09250ffddd7fd1);
$parcel$export(module.exports, "default", () => $ceecb2ae691c2ef9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $eJ9f5 = parcelRequire("eJ9f5");

var $7jTnu = parcelRequire("7jTnu");

var $hLzUY = parcelRequire("hLzUY");

var $3VPsL = parcelRequire("3VPsL");

var $dfP3D = parcelRequire("dfP3D");

var $epTsa = parcelRequire("epTsa");
const $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $3VPsL.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $hLzUY.HELP_PANEL_ID), (0, $hLzUY.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $ceecb2ae691c2ef9$export$5a09250ffddd7fd1 = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $7jTnu.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    if ((0, $7jTnu.fg)('help_panel_as_link')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default",
        testId: props.testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $epTsa.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $epTsa.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var /**
 * @deprecated Use named export instead.
 */ $ceecb2ae691c2ef9$export$2e2bcd8739ae039 = $ceecb2ae691c2ef9$export$5a09250ffddd7fd1;
const $ceecb2ae691c2ef9$var$buttonWrapperStyles = null;
const $ceecb2ae691c2ef9$var$buttonWrapperSubtleStyles = null;

});

parcelRegister("byTOA", function(module, exports) {
module.exports = new URL("generic.28da7925.svg", import.meta.url).toString();

});

parcelRegister("ltq1U", function(module, exports) {
module.exports = new URL("genericDark.a2b43fbb.svg", import.meta.url).toString();

});

parcelRegister("8N3bi", function(module, exports) {

$parcel$export(module.exports, "EmptyPracticeQueue", () => $ee34c2d129cf853a$export$b66e73d71b13aaba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $7ep4S = parcelRequire("7ep4S");

var $58yRG = parcelRequire("58yRG");

var $gjeS9 = parcelRequire("gjeS9");

var $7jTnu = parcelRequire("7jTnu");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $84DOT = parcelRequire("84DOT");

var $jipjz = parcelRequire("jipjz");

var $gCeeo = parcelRequire("gCeeo");

var $hJlBY = parcelRequire("hJlBY");

var $jlJsl = parcelRequire("jlJsl");

var $k6qAI = parcelRequire("k6qAI");

var $2FqDG = parcelRequire("2FqDG");


var $eXFVy = parcelRequire("eXFVy");

var $1milV = parcelRequire("1milV");
const $ee34c2d129cf853a$var$openCreateIssueDialog = (queueCategory = (0, $jlJsl.NO_CATEGORY))=>(event, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'emptyQueueCreateIssueButton', {
            queueCategory: queueCategory
        });
        const buttonElement = event.currentTarget;
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $gjeS9.loadBridge)({
            name: 'quick-edit/init/create-dialogs',
            wrmKeys: 'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap'
        }).then(({ showCreateDialog: showCreateDialog })=>{
            // the issue create dialog will read attributes off the event's target,
            // which in the case of our AK button could be the outer `button`, outer `span` or
            // or inner `span` so we reassign the target to the button so that those attributes
            // will always be present
            const eventWithButtonTarget = {
                ...event,
                target: buttonElement
            };
            showCreateDialog(eventWithButtonTarget);
        });
    };
const $ee34c2d129cf853a$export$6c775f6de634e0f7 = ()=>Boolean(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.IssueCreate && window.IssueCreate.Visibility && window.IssueCreate.Visibility.isEnabled);
const $ee34c2d129cf853a$export$b66e73d71b13aaba = (props)=>{
    const { projectId: projectId } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [practiceType] = (0, $2FqDG.usePathParam)('practiceType');
    const practice = (0, $k6qAI.toItsmPractice)(practiceType);
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const openCreateIssueDialogModern = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'emptyQueueCreateIssueButton', {
            queueCategory: practice
        });
        openIssueCreateModal({
            triggerPointKey: (0, $84DOT.JSM_EMPTY_QUEUE_CREATE_REQUEST)
        });
    }, [
        openIssueCreateModal,
        practice
    ]);
    const onClickHandler = (0, $eJOHy.useMemo)(()=>{
        if ($ee34c2d129cf853a$export$6c775f6de634e0f7()) return openCreateIssueDialogModern;
        return $ee34c2d129cf853a$var$openCreateIssueDialog(practice);
    }, [
        openCreateIssueDialogModern,
        practice
    ]);
    const { data: data, loading: loading, error: error } = (0, $hJlBY.default)(projectId, practice);
    const { headerMessage: headerMessage, descriptionMessage: descriptionMessage, buttonLabel: buttonLabel, getImageUrl: getImageUrl, renderImage: renderImage } = (0, $eXFVy.PRACTICE_DATA)[practice];
    const itsmCategoryToPreSelect = practice !== (0, $jlJsl.NO_CATEGORY) ? (0, $k6qAI.toItsmPractice)(practice) : undefined;
    const primaryAction = (0, $eJOHy.useMemo)(()=>{
        if (!error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            onClick: onClickHandler,
            "data-pid": projectId,
            "data-itsm-category": itsmCategoryToPreSelect,
            // rendered as `data-testid` on the button element
            testId: "servicedesk-queues-empty-queue.common.ui.empty-practice-queue.create-issue-button"
        }, formatMessage(buttonLabel));
    }, [
        buttonLabel,
        error,
        formatMessage,
        itsmCategoryToPreSelect,
        onClickHandler,
        projectId
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ee34c2d129cf853a$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    }));
    if (practice !== (0, $jlJsl.NO_CATEGORY) && data && !data.ticketTypes.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1milV.EmptyUnconfiguredPracticeQueue), null);
    const renderImageWithSize = ()=>(0, $aTJmy.getAkEmptyStateRenderImageFn)(renderImage)({
            maxImageHeight: 250,
            maxImageWidth: 250
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        imageUrl: (0, $7jTnu.fg)('jsm_queues_consolidate_jfe_assets') ? undefined : getImageUrl(colorMode),
        renderImage: (0, $7jTnu.fg)('jsm_queues_consolidate_jfe_assets') ? renderImageWithSize : undefined,
        header: formatMessage(headerMessage),
        description: formatMessage(descriptionMessage),
        headingLevel: 2,
        primaryAction: primaryAction,
        maxImageWidth: (0, $3f68d10713a8cf4b$export$caaf33f9dba14d10),
        maxImageHeight: (0, $3f68d10713a8cf4b$export$3465603c26b84396),
        testId: "servicedesk-queues-empty-queue.common.ui.empty-practice-queue.empty-practice-queue"
    });
};
// matches the margin and max-width of atlaskit EmptyState component
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ee34c2d129cf853a$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkoahv _2hwx1wug _otyroahv _18u01wug _p12f1pl1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hJlBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6615e737fda7ba$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hPZg4 = parcelRequire("hPZg4");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $d3nJY = parcelRequire("d3nJY");

var $jlJsl = parcelRequire("jlJsl");
const $2c6615e737fda7ba$var$usePracticeRequestTypesService = (projectId, practice)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const request = (0, $eJOHy.useCallback)(()=>(0, $d3nJY.performGetRequest)(`/rest/servicedesk/1/servicedesk/${projectId}/request-types?practices=${practice}`), [
        projectId,
        practice
    ]);
    const { data: data, loading: loading, error: error, fetch: fetch } = (0, $hPZg4.useService)(request);
    (0, $eJOHy.useEffect)(()=>{
        if (practice !== (0, $jlJsl.NO_CATEGORY)) fetch();
    }, [
        practice,
        fetch
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (data) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'practiceRequestTypes fetched');
    }, [
        data,
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (error) (0, $gYnSx.default)({
            meta: {
                id: 'practiceRequestTypes',
                packageName: 'jiraServicedeskQueuesCommon'
            },
            error: error,
            event: createAnalyticsEvent({}),
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error,
        createAnalyticsEvent
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
};
var $2c6615e737fda7ba$export$2e2bcd8739ae039 = $2c6615e737fda7ba$var$usePracticeRequestTypesService;

});

const $3f68d10713a8cf4b$export$3465603c26b84396 = 250;
const $3f68d10713a8cf4b$export$caaf33f9dba14d10 = 400;
const $3f68d10713a8cf4b$export$f960f87b7b043226 = 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-queues/';

parcelRegister("eXFVy", function(module, exports) {

$parcel$export(module.exports, "PRACTICE_DATA", () => $0f07ec111e3373c3$export$cda75610eb70fde9);

var $2yK5w = parcelRequire("2yK5w");

var $f3Gfr = parcelRequire("f3Gfr");

var $3BLsT = parcelRequire("3BLsT");

var $41OSs = parcelRequire("41OSs");

var $jR8gK = parcelRequire("jR8gK");

var $2kvfV = parcelRequire("2kvfV");

var $jlJsl = parcelRequire("jlJsl");

var $fn0Yi = parcelRequire("fn0Yi");

var $EMFpx = parcelRequire("EMFpx");

var $g03SN = parcelRequire("g03SN");

var $hkAfq = parcelRequire("hkAfq");

var $51Poz = parcelRequire("51Poz");

var $c3htn = parcelRequire("c3htn");

var $39qKU = parcelRequire("39qKU");

var $d5Z6u = parcelRequire("d5Z6u");

var $f2mYW = parcelRequire("f2mYW");

var $faYJU = parcelRequire("faYJU");

var $bqQCY = parcelRequire("bqQCY");

var $5dYaX = parcelRequire("5dYaX");

var $ijabT = parcelRequire("ijabT");
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $0f07ec111e3373c3$var$LIGHT_MODE = 'light';
const $0f07ec111e3373c3$var$DARK_MODE = 'dark';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $0f07ec111e3373c3$var$AUTO = 'auto';
const $0f07ec111e3373c3$export$cda75610eb70fde9 = {
    [(0, $jlJsl.SERVICE_REQUEST)]: {
        headerMessage: (0, $ijabT.default).serviceRequestsHeader,
        descriptionMessage: (0, $ijabT.default).serviceRequestsDescription,
        buttonLabel: (0, $ijabT.default).serviceRequestsCreateIssueButtonText,
        renderImage: (0, $41OSs.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($bqQCY))),
        getImageUrl: (currentTheme)=>currentTheme === $0f07ec111e3373c3$var$DARK_MODE ? (0, (/*@__PURE__*/$parcel$interopDefault($5dYaX))) : (0, (/*@__PURE__*/$parcel$interopDefault($bqQCY))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-service-requests/'
    },
    [(0, $jlJsl.INCIDENTS)]: {
        headerMessage: (0, $ijabT.default).incidentsHeader,
        descriptionMessage: (0, $ijabT.default).incidentsDescription,
        buttonLabel: (0, $ijabT.default).incidentsCreateIssueButtonText,
        renderImage: (0, $2kvfV.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($51Poz))),
        getImageUrl: (currentTheme)=>currentTheme === $0f07ec111e3373c3$var$DARK_MODE ? (0, (/*@__PURE__*/$parcel$interopDefault($c3htn))) : (0, (/*@__PURE__*/$parcel$interopDefault($51Poz))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-incidents/'
    },
    [(0, $jlJsl.PROBLEMS)]: {
        headerMessage: (0, $ijabT.default).problemsHeader,
        descriptionMessage: (0, $ijabT.default).problemsDescription,
        buttonLabel: (0, $ijabT.default).problemsCreateIssueButtonText,
        renderImage: (0, $f3Gfr.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($f2mYW))),
        getImageUrl: (currentTheme)=>currentTheme === $0f07ec111e3373c3$var$DARK_MODE ? (0, (/*@__PURE__*/$parcel$interopDefault($faYJU))) : (0, (/*@__PURE__*/$parcel$interopDefault($f2mYW))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-problems/'
    },
    [(0, $jlJsl.CHANGES)]: {
        headerMessage: (0, $ijabT.default).changesHeader,
        descriptionMessage: (0, $ijabT.default).changesDescription,
        buttonLabel: (0, $ijabT.default).changesCreateIssueButtonText,
        renderImage: (0, $2yK5w.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($g03SN))),
        getImageUrl: (currentTheme)=>currentTheme === $0f07ec111e3373c3$var$DARK_MODE ? (0, (/*@__PURE__*/$parcel$interopDefault($hkAfq))) : (0, (/*@__PURE__*/$parcel$interopDefault($g03SN))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-changes/'
    },
    [(0, $jlJsl.POST_INCIDENT_REVIEWS)]: {
        headerMessage: (0, $ijabT.default).postIncidentReviewsHeader,
        descriptionMessage: (0, $ijabT.default).postIncidentReviewsDescription,
        buttonLabel: (0, $ijabT.default).postIncidentReviewsCreateIssueButtonText,
        renderImage: (0, $jR8gK.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($39qKU))),
        getImageUrl: (currentTheme)=>currentTheme === $0f07ec111e3373c3$var$DARK_MODE ? (0, (/*@__PURE__*/$parcel$interopDefault($d5Z6u))) : (0, (/*@__PURE__*/$parcel$interopDefault($39qKU))),
        learnMoreUrl: 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-post-incident-reviews/'
    },
    [(0, $jlJsl.NO_CATEGORY)]: {
        headerMessage: (0, $ijabT.default).allTicketsHeader,
        descriptionMessage: (0, $ijabT.default).allTicketsDescription,
        buttonLabel: (0, $ijabT.default).allTicketsCreateIssueButtonText,
        renderImage: (0, $3BLsT.default),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($fn0Yi))),
        getImageUrl: (currentTheme)=>currentTheme === $0f07ec111e3373c3$var$DARK_MODE ? (0, (/*@__PURE__*/$parcel$interopDefault($EMFpx))) : (0, (/*@__PURE__*/$parcel$interopDefault($fn0Yi))),
        learnMoreUrl: undefined
    }
};

});
parcelRegister("2yK5w", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc83e1579c081f9$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = g4nfj272vxmnnng6jh384m
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/g4nfj272vxmnnng6jh384m

var $c4huj = parcelRequire("c4huj");

var $d1eW4 = parcelRequire("d1eW4");
const $8bc83e1579c081f9$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($d1eW4)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($d1eW4))
});
var $8bc83e1579c081f9$export$2e2bcd8739ae039 = $8bc83e1579c081f9$var$Illustration;
// for advanced use only
const $8bc83e1579c081f9$export$a179c88182cb9d56 = [
    0,
    0,
    497,
    318
];

});
parcelRegister("d1eW4", function(module, exports) {
module.exports = new URL("software-development.a5df06ef.svg", import.meta.url).toString();

});


parcelRegister("f3Gfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cf471f40dbb747d$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = q7cns859w734758qv5wmgpm
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/q7cns859w734758qv5wmgpm

var $c4huj = parcelRequire("c4huj");

var $hsjqu = parcelRequire("hsjqu");

var $lVr2c = parcelRequire("lVr2c");
const $1cf471f40dbb747d$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($lVr2c)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hsjqu))
});
var $1cf471f40dbb747d$export$2e2bcd8739ae039 = $1cf471f40dbb747d$var$Illustration;
// for advanced use only
const $1cf471f40dbb747d$export$a179c88182cb9d56 = [
    0,
    0,
    223,
    189
];

});
parcelRegister("hsjqu", function(module, exports) {
module.exports = new URL("target-single-darkmode.5d8fc324.svg", import.meta.url).toString();

});

parcelRegister("lVr2c", function(module, exports) {
module.exports = new URL("target-single.a1a07a4f.svg", import.meta.url).toString();

});


parcelRegister("3BLsT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a9306beef15db93$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = hrv73kh63rncntxr5mpzh
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/hrv73kh63rncntxr5mpzh

var $c4huj = parcelRequire("c4huj");

var $5JXvK = parcelRequire("5JXvK");
const $8a9306beef15db93$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5JXvK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($5JXvK))
});
var $8a9306beef15db93$export$2e2bcd8739ae039 = $8a9306beef15db93$var$Illustration;
// for advanced use only
const $8a9306beef15db93$export$a179c88182cb9d56 = [
    0,
    0,
    233,
    235
];

});
parcelRegister("5JXvK", function(module, exports) {
module.exports = new URL("ticket-dispensor.f4a024b2.svg", import.meta.url).toString();

});


parcelRegister("41OSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $495cab91e5b87c8c$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $lAtYr = parcelRequire("lAtYr");

var $6ijej = parcelRequire("6ijej");
const $495cab91e5b87c8c$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6ijej)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($lAtYr))
});
var $495cab91e5b87c8c$export$2e2bcd8739ae039 = $495cab91e5b87c8c$var$Illustration;
// for advanced use only
const $495cab91e5b87c8c$export$a179c88182cb9d56 = [
    0,
    0,
    595,
    601
];

});
parcelRegister("lAtYr", function(module, exports) {
module.exports = new URL("balloons-darkmode.7d1967f8.svg", import.meta.url).toString();

});

parcelRegister("6ijej", function(module, exports) {
module.exports = new URL("balloons.8acbde79.svg", import.meta.url).toString();

});


parcelRegister("jR8gK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc0684d85a4f7184$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $1V6RS = parcelRequire("1V6RS");
const $bc0684d85a4f7184$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1V6RS)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1V6RS))
});
var $bc0684d85a4f7184$export$2e2bcd8739ae039 = $bc0684d85a4f7184$var$Illustration;
// for advanced use only
const $bc0684d85a4f7184$export$a179c88182cb9d56 = [
    0,
    0,
    600,
    282
];

});
parcelRegister("1V6RS", function(module, exports) {
module.exports = new URL("people-working-on-computers.c86cef7c.svg", import.meta.url).toString();

});


parcelRegister("2kvfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9fdca6bc06537ee$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $3Fkeb = parcelRequire("3Fkeb");
const $d9fdca6bc06537ee$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3Fkeb)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3Fkeb))
});
var $d9fdca6bc06537ee$export$2e2bcd8739ae039 = $d9fdca6bc06537ee$var$Illustration;
// for advanced use only
const $d9fdca6bc06537ee$export$a179c88182cb9d56 = [
    0,
    0,
    600,
    386
];

});
parcelRegister("3Fkeb", function(module, exports) {
module.exports = new URL("task-board-with-people.e468116d.svg", import.meta.url).toString();

});


parcelRegister("fn0Yi", function(module, exports) {
module.exports = new URL("all-tickets.e438cf2e.svg", import.meta.url).toString();

});

parcelRegister("EMFpx", function(module, exports) {
module.exports = new URL("all-ticketsDark.5aecc647.svg", import.meta.url).toString();

});

parcelRegister("g03SN", function(module, exports) {
module.exports = new URL("changes.0ea22c65.svg", import.meta.url).toString();

});

parcelRegister("hkAfq", function(module, exports) {
module.exports = new URL("changesDark.e78f0f3f.svg", import.meta.url).toString();

});

parcelRegister("51Poz", function(module, exports) {
module.exports = new URL("incidents.c1cdd3ac.svg", import.meta.url).toString();

});

parcelRegister("c3htn", function(module, exports) {
module.exports = new URL("incidentsDark.aba376a8.svg", import.meta.url).toString();

});

parcelRegister("39qKU", function(module, exports) {
module.exports = new URL("post-incident-reviews.28e33ce7.svg", import.meta.url).toString();

});

parcelRegister("d5Z6u", function(module, exports) {
module.exports = new URL("post-incident-reviewsDark.79dea6fc.svg", import.meta.url).toString();

});

parcelRegister("f2mYW", function(module, exports) {
module.exports = new URL("problems.9524f82d.svg", import.meta.url).toString();

});

parcelRegister("faYJU", function(module, exports) {
module.exports = new URL("problemsDark.2e76c8e2.svg", import.meta.url).toString();

});

parcelRegister("bqQCY", function(module, exports) {
module.exports = new URL("service-requests.266aad3f.svg", import.meta.url).toString();

});

parcelRegister("5dYaX", function(module, exports) {
module.exports = new URL("service-requestsDark.ce6d6e11.svg", import.meta.url).toString();

});

parcelRegister("ijabT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef40cdc77b70af40$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ef40cdc77b70af40$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    allTicketsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.all-tickets-header",
        "defaultMessage": "All of your requests will show up here"
    },
    allTicketsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.all-tickets-description",
        "defaultMessage": "Talk with customers, notify your teammates and track work all in one place. Create a request of your own to see it in action."
    },
    allTicketsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.all-tickets-create-issue-button-text",
        "defaultMessage": "Create a request"
    },
    serviceRequestsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.service-requests-header",
        "defaultMessage": "Solve service requests"
    },
    serviceRequestsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.service-requests-description",
        "defaultMessage": "Track requests for support, monitor SLAs, and communicate with help seekers."
    },
    serviceRequestsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.service-requests-create-issue-button-text",
        "defaultMessage": "Create a service request"
    },
    incidentsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.incidents-header",
        "defaultMessage": "Resolve disruptions"
    },
    incidentsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.incidents-description",
        "defaultMessage": "Detect, respond to and resolve incidents. Catch issues early with alerts and on-call scheduling, and keep stakeholders updated at every step."
    },
    incidentsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.incidents-create-issue-button-text",
        "defaultMessage": "Report an incident"
    },
    problemsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.problems-header",
        "defaultMessage": "Fix all the things"
    },
    problemsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.problems-description",
        "defaultMessage": "Investigate the root cause of repeat incidents and track their resolution from start to finish."
    },
    problemsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.problems-create-issue-button-text",
        "defaultMessage": "Investigate a problem"
    },
    changesHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.changes-header",
        "defaultMessage": "Make things happen"
    },
    changesDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.changes-description",
        "defaultMessage": "Get full visibility of scheduled changes. Set approval steps, minimize disruption, create change records, and keep impacted stakeholders updated."
    },
    changesCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.changes-create-issue-button-text",
        "defaultMessage": "Create a change request"
    },
    postIncidentReviewsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.post-incident-reviews-header",
        "defaultMessage": "Learn from post-incident reviews"
    },
    postIncidentReviewsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.post-incident-reviews-description",
        "defaultMessage": "Bring your team together to capture the causes and impacts of an incident, and learn how to prevent similar incidents from happening again."
    },
    postIncidentReviewsCreateIssueButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.post-incident-reviews-create-issue-button-text",
        "defaultMessage": "Start a post-incident review"
    }
});

});


parcelRegister("1milV", function(module, exports) {

$parcel$export(module.exports, "EmptyUnconfiguredPracticeQueue", () => $dfee472717c5a3b6$export$da55df0aa01118ce);

var $eJOHy = parcelRequire("eJOHy");

var $5tgJD = parcelRequire("5tgJD");

var $6omGY = parcelRequire("6omGY");

var $1PmIF = parcelRequire("1PmIF");
const $dfee472717c5a3b6$export$da55df0aa01118ce = ()=>{
    const [{ data: data }] = (0, $5tgJD.useServiceDeskContext)();
    const isAgentAdmin = data?.userRole === 'agent-project-admin';
    return isAgentAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6omGY.EmptyQueueAdminView), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PmIF.EmptyQueueAgentView), null);
};

});
parcelRegister("6omGY", function(module, exports) {

$parcel$export(module.exports, "EmptyQueueAdminView", () => $47b73ad4f62fcf49$export$c52b9754879a0252);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eJ9f5 = parcelRequire("eJ9f5");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $58yRG = parcelRequire("58yRG");

var $7jTnu = parcelRequire("7jTnu");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $k6qAI = parcelRequire("k6qAI");

var $2FqDG = parcelRequire("2FqDG");


var $bR1F0 = parcelRequire("bR1F0");

var $hFyGJ = parcelRequire("hFyGJ");
const $47b73ad4f62fcf49$export$c52b9754879a0252 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [practice] = (0, $2FqDG.usePathParam)('practiceType');
    const [projectKey] = (0, $2FqDG.usePathParam)('projectKey');
    const { colorMode: colorMode } = (0, $58yRG.default)();
    // practice should always be set in case of an unconfigured queue, if not this is a wrong route
    if (practice === undefined) return null;
    const emptyStateData = (0, $bR1F0.EMPTY_STATE_DATA)[(0, $k6qAI.toItsmPractice)(practice)];
    const { headerMessage: headerMessage, descriptionMessage: descriptionMessage, getImageUrl: getImageUrl, learnMoreText: learnMoreText, learnMoreUrl: learnMoreUrl } = emptyStateData;
    // This is a temporary fix to Feature Flag emptyStateData.descriptionMessage, as emptyStateData is not typed and we need to check if the object has the property descriptionMessageGalaxia
    // since some of them don't have the property descriptionMessageGalaxia. Please remove this on FF cleanup
    const selectedDescriptionMessage = 'descriptionMessageGalaxia' in emptyStateData && emptyStateData.descriptionMessageGalaxia && (0, $7jTnu.fg)('itsm-project-renaming') ? emptyStateData.descriptionMessageGalaxia : descriptionMessage;
    const getHref = ()=>{
        if (projectKey == null) return undefined;
        return `/jira/servicedesk/projects/${projectKey}/settings/request-types/category/${practice}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage(headerMessage),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($47b73ad4f62fcf49$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...selectedDescriptionMessage,
            values: {
                // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                p: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, chunks),
                a: ()=>(0, $7jTnu.fg)('replace-anchor-with-link__jsd-shield') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                        target: "_blank",
                        href: learnMoreUrl || ''
                    }, learnMoreText && formatMessage(learnMoreText)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                        target: "_blank",
                        href: learnMoreUrl
                    }, learnMoreText && formatMessage(learnMoreText))
            }
        })),
        imageUrl: getImageUrl(colorMode),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            href: getHref()
        }, formatMessage((0, $hFyGJ.default).addRequestTypeButtonText)),
        maxImageWidth: (0, $3f68d10713a8cf4b$export$caaf33f9dba14d10),
        maxImageHeight: (0, $3f68d10713a8cf4b$export$3465603c26b84396),
        testId: "servicedesk-queues-empty-queue.common.ui.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.empty-queue-admin-view"
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $47b73ad4f62fcf49$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1ejb _2hwxidpf _otyr1ejb _18u0idpf _y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bR1F0", function(module, exports) {

$parcel$export(module.exports, "EMPTY_STATE_DATA", () => $09f0c8e0492e1a66$export$cfb3b7ce372d6279);

var $jlJsl = parcelRequire("jlJsl");

var $eXFVy = parcelRequire("eXFVy");

var $ax3qo = parcelRequire("ax3qo");

var $hFyGJ = parcelRequire("hFyGJ");
const $09f0c8e0492e1a66$export$cfb3b7ce372d6279 = {
    [(0, $jlJsl.SERVICE_REQUEST)]: {
        headerMessage: (0, $hFyGJ.default).serviceRequestsHeader,
        descriptionMessage: (0, $hFyGJ.default).serviceRequestsDescription,
        descriptionMessageGalaxia: (0, $hFyGJ.default).serviceRequestsDescriptionGalaxia,
        imageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.SERVICE_REQUEST].imageUrl,
        getImageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.SERVICE_REQUEST].getImageUrl,
        learnMoreUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.SERVICE_REQUEST].learnMoreUrl,
        learnMoreText: (0, $ax3qo.default).serviceRequestsLearnMore
    },
    [(0, $jlJsl.INCIDENTS)]: {
        headerMessage: (0, $hFyGJ.default).incidentsHeader,
        descriptionMessage: (0, $hFyGJ.default).incidentsDescription,
        descriptionMessageGalaxia: (0, $hFyGJ.default).incidentsDescriptionGalaxia,
        imageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.INCIDENTS].imageUrl,
        getImageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.INCIDENTS].getImageUrl,
        learnMoreUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.INCIDENTS].learnMoreUrl,
        learnMoreText: (0, $ax3qo.default).incidentsLearnMore
    },
    [(0, $jlJsl.PROBLEMS)]: {
        headerMessage: (0, $hFyGJ.default).problemsHeader,
        descriptionMessage: (0, $hFyGJ.default).problemsDescription,
        descriptionMessageGalaxia: (0, $hFyGJ.default).problemsDescriptionGalaxia,
        imageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.PROBLEMS].imageUrl,
        getImageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.PROBLEMS].getImageUrl,
        learnMoreUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.PROBLEMS].learnMoreUrl,
        learnMoreText: (0, $ax3qo.default).problemsLearnMore
    },
    [(0, $jlJsl.CHANGES)]: {
        headerMessage: (0, $hFyGJ.default).changesHeader,
        descriptionMessage: (0, $hFyGJ.default).changesDescription,
        descriptionMessageGalaxia: (0, $hFyGJ.default).changesDescriptionGalaxia,
        imageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.CHANGES].imageUrl,
        getImageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.CHANGES].getImageUrl,
        learnMoreUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.CHANGES].learnMoreUrl,
        learnMoreText: (0, $ax3qo.default).changesLearnMore
    },
    [(0, $jlJsl.POST_INCIDENT_REVIEWS)]: {
        headerMessage: (0, $hFyGJ.default).postIncidentReviewsHeader,
        descriptionMessage: (0, $hFyGJ.default).postIncidentReviewsDescription,
        imageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.POST_INCIDENT_REVIEWS].imageUrl,
        getImageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.POST_INCIDENT_REVIEWS].getImageUrl,
        learnMoreUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.POST_INCIDENT_REVIEWS].learnMoreUrl,
        learnMoreText: (0, $ax3qo.default).postIncidentReviewsLearnMore
    },
    // NO_CATEGORY will never be a valid case in case of unconfigured queue, need to do this to keep Flow happy
    [(0, $jlJsl.NO_CATEGORY)]: {
        ...(0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.NO_CATEGORY],
        learnMoreText: undefined
    }
};

});
parcelRegister("ax3qo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b983bc9c9594e22$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0b983bc9c9594e22$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    serviceRequestsLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.service-requests-learn-more",
        "defaultMessage": "Learn more about service requests"
    },
    incidentsLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.incidents-learn-more",
        "defaultMessage": "Learn more about incident management"
    },
    problemsLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.problems-learn-more",
        "defaultMessage": "Learn more about problem management"
    },
    changesLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.changes-learn-more",
        "defaultMessage": "Learn more about change management"
    },
    postIncidentReviewsLearnMore: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.post-incident-reviews-learn-more",
        "defaultMessage": "Learn more about post-incident reviews"
    }
});

});

parcelRegister("hFyGJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f001e50c54b1dcf3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f001e50c54b1dcf3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    serviceRequestsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.service-requests-header",
        "defaultMessage": "Get started with service requests"
    },
    serviceRequestsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.service-requests-description",
        "defaultMessage": "<p>To start using your new queue, add a request type to the service requests category. You can create a new request type, or assign an existing request type from this project. <a></a>.</p>"
    },
    serviceRequestsDescriptionGalaxia: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.service-requests-description-galaxia",
        "defaultMessage": "<p>To start using your new queue, add a request type to the service requests category. You can create a new request type, or assign an existing request type from this space. <a></a>.</p>"
    },
    incidentsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.incidents-header",
        "defaultMessage": "Get started with incident management"
    },
    incidentsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.incidents-description",
        "defaultMessage": "<p>To start using your new queue, add a request type to the incidents category. You can create a new request type, or assign an existing request type from this project. <a></a>.</p>"
    },
    incidentsDescriptionGalaxia: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.incidents-description-galaxia",
        "defaultMessage": "<p>To start using your new queue, add a request type to the incidents category. You can create a new request type, or assign an existing request type from this space. <a></a>.</p>"
    },
    problemsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.problems-header",
        "defaultMessage": "Get started with problem management"
    },
    problemsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.problems-description",
        "defaultMessage": "<p>To start using your new queue, add a request type to the problems category. You can create a new request type, or assign an existing request type from this project. <a></a>.</p>"
    },
    problemsDescriptionGalaxia: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.problems-description-galaxia",
        "defaultMessage": "<p>To start using your new queue, add a request type to the problems category. You can create a new request type, or assign an existing request type from this space. <a></a>.</p>"
    },
    changesHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.changes-header",
        "defaultMessage": "Get started with change management"
    },
    changesDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.changes-description",
        "defaultMessage": "<p>To start using your new queue, add a request type to the changes category. You can create a new request type, or assign an existing request type from this project. <a></a>.</p>"
    },
    changesDescriptionGalaxia: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.changes-description-galaxia",
        "defaultMessage": "<p>To start using your new queue, add a request type to the changes category. You can create a new request type, or assign an existing request type from this space. <a></a>.</p>"
    },
    postIncidentReviewsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.post-incident-reviews-header",
        "defaultMessage": "Get started with post-incident reviews"
    },
    postIncidentReviewsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.post-incident-reviews-description",
        "defaultMessage": "<p>To start using your new queue, create a new request type, or assign an existing request type to the post-incident review category. <a></a>.</p>"
    },
    addRequestTypeButtonText: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-admin-view.add-request-type-button-text",
        "defaultMessage": "Add request types"
    }
});

});



parcelRegister("1PmIF", function(module, exports) {

$parcel$export(module.exports, "EmptyQueueAgentView", () => $285bf9149b210251$export$c7fde069a1782c75);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6MnLl = parcelRequire("6MnLl");

var $58yRG = parcelRequire("58yRG");

var $lRq8t = parcelRequire("lRq8t");

var $k6qAI = parcelRequire("k6qAI");

var $2FqDG = parcelRequire("2FqDG");


var $bn46D = parcelRequire("bn46D");
const $285bf9149b210251$export$c7fde069a1782c75 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [practice] = (0, $2FqDG.usePathParam)('practiceType');
    const { colorMode: colorMode } = (0, $58yRG.default)();
    // practice should always be set in case of an unconfigured queue, if not this is a wrong route
    if (practice === undefined) return null;
    const { headerMessage: headerMessage, descriptionMessage: descriptionMessage, getImageUrl: getImageUrl, learnMoreText: learnMoreText, learnMoreUrl: learnMoreUrl } = (0, $bn46D.EMPTY_STATE_DATA)[(0, $k6qAI.toItsmPractice)(practice)];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        header: formatMessage(headerMessage),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($285bf9149b210251$var$Description, null, formatMessage(descriptionMessage)),
        imageUrl: getImageUrl(colorMode),
        primaryAction: learnMoreText && learnMoreUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($285bf9149b210251$var$LearnMoreLink, {
            target: "_blank",
            href: learnMoreUrl
        }, formatMessage(learnMoreText)),
        maxImageWidth: (0, $3f68d10713a8cf4b$export$caaf33f9dba14d10),
        maxImageHeight: (0, $3f68d10713a8cf4b$export$3465603c26b84396),
        testId: "servicedesk-queues-empty-queue.common.ui.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.empty-queue-agent-view"
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $285bf9149b210251$var$LearnMoreLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule _otyrgx6n _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $285bf9149b210251$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1ejb _2hwxidpf _otyr1ejb _18u0idpf _y3gn1e5h _1bsb189v",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bn46D", function(module, exports) {

$parcel$export(module.exports, "EMPTY_STATE_DATA", () => $a3d1b61f01c7b545$export$cfb3b7ce372d6279);

var $jlJsl = parcelRequire("jlJsl");

var $eXFVy = parcelRequire("eXFVy");

var $ax3qo = parcelRequire("ax3qo");

var $kH2r9 = parcelRequire("kH2r9");
const $a3d1b61f01c7b545$export$cfb3b7ce372d6279 = {
    [(0, $jlJsl.SERVICE_REQUEST)]: {
        headerMessage: (0, $kH2r9.default).serviceRequestsHeader,
        descriptionMessage: (0, $kH2r9.default).serviceRequestsDescription,
        imageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.SERVICE_REQUEST].imageUrl,
        getImageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.SERVICE_REQUEST].getImageUrl,
        learnMoreUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.SERVICE_REQUEST].learnMoreUrl,
        learnMoreText: (0, $ax3qo.default).serviceRequestsLearnMore
    },
    [(0, $jlJsl.INCIDENTS)]: {
        headerMessage: (0, $kH2r9.default).incidentsHeader,
        descriptionMessage: (0, $kH2r9.default).incidentsDescription,
        imageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.INCIDENTS].imageUrl,
        getImageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.INCIDENTS].getImageUrl,
        learnMoreUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.INCIDENTS].learnMoreUrl,
        learnMoreText: (0, $ax3qo.default).incidentsLearnMore
    },
    [(0, $jlJsl.PROBLEMS)]: {
        headerMessage: (0, $kH2r9.default).problemsHeader,
        descriptionMessage: (0, $kH2r9.default).problemsDescription,
        imageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.PROBLEMS].imageUrl,
        getImageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.PROBLEMS].getImageUrl,
        learnMoreUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.PROBLEMS].learnMoreUrl,
        learnMoreText: (0, $ax3qo.default).problemsLearnMore
    },
    [(0, $jlJsl.CHANGES)]: {
        headerMessage: (0, $kH2r9.default).changesHeader,
        descriptionMessage: (0, $kH2r9.default).changesDescription,
        imageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.CHANGES].imageUrl,
        getImageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.CHANGES].getImageUrl,
        learnMoreUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.CHANGES].learnMoreUrl,
        learnMoreText: (0, $ax3qo.default).changesLearnMore
    },
    [(0, $jlJsl.POST_INCIDENT_REVIEWS)]: {
        headerMessage: (0, $kH2r9.default).postIncidentReviewsHeader,
        descriptionMessage: (0, $kH2r9.default).postIncidentReviewsDescription,
        imageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.POST_INCIDENT_REVIEWS].imageUrl,
        getImageUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.POST_INCIDENT_REVIEWS].getImageUrl,
        learnMoreUrl: (0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.POST_INCIDENT_REVIEWS].learnMoreUrl,
        learnMoreText: (0, $ax3qo.default).postIncidentReviewsLearnMore
    },
    // NO_CATEGORY will never be a valid case in case of unconfigured queue, need to do this to keep Flow happy
    [(0, $jlJsl.NO_CATEGORY)]: {
        ...(0, $eXFVy.PRACTICE_DATA)[0, $jlJsl.NO_CATEGORY],
        learnMoreText: undefined
    }
};

});
parcelRegister("kH2r9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b85ecb7366b6a812$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b85ecb7366b6a812$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    serviceRequestsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.service-requests-header",
        "defaultMessage": "Welcome to your new service requests queue"
    },
    serviceRequestsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.service-requests-description",
        "defaultMessage": "Your admin is setting up a service request management workflow to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the service requests category. Contact your admin for more information."
    },
    incidentsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.incidents-header",
        "defaultMessage": "Welcome to your new incidents queue"
    },
    incidentsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.incidents-description",
        "defaultMessage": "Your admin is setting up an incident management workflow to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the incidents category. Contact your admin for more information."
    },
    problemsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.problems-header",
        "defaultMessage": "Welcome to your new problems queue"
    },
    problemsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.problems-description",
        "defaultMessage": "Your admin is setting up a problem management workflow to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the problems category. Contact your admin for more information."
    },
    changesHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.changes-header",
        "defaultMessage": "Welcome to your new changes queue"
    },
    changesDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.changes-description",
        "defaultMessage": "Your admin is setting up a change management workflow to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the changes category. Contact your admin for more information."
    },
    postIncidentReviewsHeader: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.post-incident-reviews-header",
        "defaultMessage": "Get started with post-incident reviews"
    },
    postIncidentReviewsDescription: {
        "id": "servicedesk-queues-empty-queue.common.empty-practice-queue.empty-unconfigured-practice-queue.empty-queue-agent-view.post-incident-reviews-description",
        "defaultMessage": "Your admin is setting up a post-incident review queue to help you deliver great service experiences. To start using your new queue, your admin will need to add request types to the post-incident review category. Contact your admin for more information."
    }
});

});





parcelRegister("14Ugu", function(module, exports) {

$parcel$export(module.exports, "default", () => $94ac2f66bc1658ac$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $94ac2f66bc1658ac$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyQueueHeader: {
        "id": "servicedesk-queues-empty-queue.empty-queue-header",
        "defaultMessage": "Your queue is empty"
    },
    emptyQueueDescription: {
        "id": "servicedesk-queues-empty-queue.empty-queue-description",
        "defaultMessage": "<p>Incoming requests from multiple channels are filtered and displayed in your queues as issues, ready to be triaged and assigned. {break} {IPHArticle} </p>"
    },
    emptyQueueButtonLabel: {
        "id": "servicedesk-queues-empty-queue.empty-queue-button-label",
        "defaultMessage": "Create an issue"
    },
    emptyQueueLearnMoreText: {
        "id": "servicedesk-queues-empty-queue.empty-queue-learn-more-text",
        "defaultMessage": "Learn more about queues"
    },
    emptyQueueDescriptionIssueTermRefresh: {
        "id": "servicedesk-queues-empty-queue.empty-queue-description-issue-term-refresh",
        "defaultMessage": "<p>Incoming requests from multiple channels are filtered and displayed in your queues as work items, ready to be triaged and assigned. {break} {IPHArticle} </p>"
    },
    emptyQueueButtonLabelIssueTermRefresh: {
        "id": "servicedesk-queues-empty-queue.empty-queue-button-label-issue-term-refresh",
        "defaultMessage": "Create a work item"
    }
});

});


parcelRegister("8pEJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9113741d9c23599$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $f20Bj = parcelRequire("f20Bj");

var $lc49q = parcelRequire("lc49q");

var $6I1gv = parcelRequire("6I1gv");

var $eT95y = parcelRequire("eT95y");
const $b9113741d9c23599$var$mapStateToProps = (state)=>({
        queueOrder: (0, $lc49q.getCurrentQueueOrder)(state),
        isQueueVisible: (0, $6I1gv.isQueueVisible)(state),
        isLoadingIssues: (0, $6I1gv.isLoadingIssues)(state),
        projectId: (0, $f20Bj.getProjectId)(state)
    });
var $b9113741d9c23599$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($b9113741d9c23599$var$mapStateToProps, {})((0, $eT95y.default));

});
parcelRegister("eT95y", function(module, exports) {

$parcel$export(module.exports, "default", () => $13bb3b91ba108fdc$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $jHANl = parcelRequire("jHANl");
class $13bb3b91ba108fdc$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    shouldDripFeed() {
        const { queueOrder: queueOrder, isQueueVisible: isQueueVisible, isLoadingIssues: isLoadingIssues } = this.props;
        // Ideally, we would like to drip-feed further issues only on the "All Open" queue of a demo project.
        // However, there is no reliable way to figure out the exact queue we are on. Thus, we rely on the initial
        // ordering of the queues. We accept the risk of users missing the drip-feed altogether when they re-order
        // their queues. The DemoProjectDripFeed component itself will check if we are actually on a demo project.
        // Also make sure that queues page is visible.
        if (queueOrder !== 0 || !isQueueVisible || isLoadingIssues) return false;
        return true;
    }
    render() {
        return this.shouldDripFeed() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jHANl.DemoProjectDripFeed), {
            projectId: this.props.projectId
        }) : null;
    }
}

});
parcelRegister("jHANl", function(module, exports) {

$parcel$export(module.exports, "DemoProjectDripFeed", () => $54baba2de85652d4$export$3fb4ae8058b3efa3);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $lCHpy = parcelRequire("lCHpy");

var $46OwJ = parcelRequire("46OwJ");

var $42SqP = parcelRequire("42SqP");
const $54baba2de85652d4$export$3fb4ae8058b3efa3 = ({ projectId: projectId })=>{
    const { data: isDemoProject } = (0, $lCHpy.useIsDemoProject)();
    const { data: isItsmSampleProject } = (0, $46OwJ.useIsItsmSampleProject)();
    const [isRequestCreated, setIsRequestCreated] = (0, $eJOHy.useState)(false);
    const shouldCreateRequest = // Allow request creation for demo and non ITSM sample project
    !isRequestCreated && isDemoProject === true && isItsmSampleProject === false;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (shouldCreateRequest) {
            setIsRequestCreated(true);
            (0, $42SqP.default)({
                projectId: projectId,
                analyticsEvent: createAnalyticsEvent({})
            });
        }
    }, [
        shouldCreateRequest,
        setIsRequestCreated,
        projectId,
        createAnalyticsEvent
    ]);
    return null;
};

});
parcelRegister("42SqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $53fe09cd60fa957e$export$2e2bcd8739ae039);

var $hISPA = parcelRequire("hISPA");

var $azILi = parcelRequire("azILi");

var $dwfuU = parcelRequire("dwfuU");
const $53fe09cd60fa957e$var$service = async ({ projectId: projectId, analyticsEvent: analyticsEvent })=>{
    const createdAliases = await (0, $azILi.default)({
        projectId: projectId
    });
    const requestAlias = (0, $dwfuU.default)({
        createdAliases: createdAliases
    });
    if (!requestAlias) return;
    await (0, $hISPA.default)({
        projectId: projectId,
        requestAlias: requestAlias,
        analyticsEvent: analyticsEvent
    });
};
var $53fe09cd60fa957e$export$2e2bcd8739ae039 = $53fe09cd60fa957e$var$service;

});
parcelRegister("hISPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e1ef9f624ecc58e$export$2e2bcd8739ae039);

var $gYnSx = parcelRequire("gYnSx");

var $8KUFq = parcelRequire("8KUFq");

var $gCeeo = parcelRequire("gCeeo");

var $fDT3j = parcelRequire("fDT3j");

var $ocIMt = parcelRequire("ocIMt");
const $9e1ef9f624ecc58e$var$service = async ({ projectId: projectId, requestAlias: requestAlias, analyticsEvent: analyticsEvent })=>{
    try {
        await (0, $ocIMt.post)(projectId, requestAlias);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        !(0, $8KUFq.isClientFetchError)(error) && (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'createRequest',
                packageName: (0, $fDT3j.PACKAGE_NAME),
                teamName: 'jsm-getting-started'
            },
            attributes: {
                demoDripFeedRequestAlias: requestAlias
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return false;
    }
    analyticsEvent && (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, `${(0, $fDT3j.PACKAGE_NAME)} requestCreated`, {
        demoDripFeedRequestAlias: requestAlias
    });
    return true;
};
var $9e1ef9f624ecc58e$export$2e2bcd8739ae039 = $9e1ef9f624ecc58e$var$service;

});
parcelRegister("fDT3j", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $904cb6e9f50974f9$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "CREATED_DEMO_REQUESTS_PROPERTY_KEY", () => $904cb6e9f50974f9$export$e5714b96e7139e44);
$parcel$export(module.exports, "REQUEST_CREATION_ORDER", () => $904cb6e9f50974f9$export$b3140adec43d0709);
const $904cb6e9f50974f9$export$b8b9d90f9e5bd72b = 'jiraServicedeskQueuesDemoProjectDripFeed';
const $904cb6e9f50974f9$export$e5714b96e7139e44 = 'jsd.demo-project.created-demo-requests';
const $904cb6e9f50974f9$export$c2fc572f1ae12c8 = {
    triageRequests: 'TRIAGE_REQUESTS',
    highPriority: 'HIGH_PRIORITY',
    trackPerformance: 'TRACK_PERFORMANCE'
};
const $904cb6e9f50974f9$export$b3140adec43d0709 = [
    $904cb6e9f50974f9$export$c2fc572f1ae12c8.triageRequests,
    $904cb6e9f50974f9$export$c2fc572f1ae12c8.highPriority,
    $904cb6e9f50974f9$export$c2fc572f1ae12c8.trackPerformance
];

});

parcelRegister("ocIMt", function(module, exports) {

$parcel$export(module.exports, "post", () => $619e807ad1e7bc46$export$299ba2dee77727e9);

var $jGzN3 = parcelRequire("jGzN3");
const $619e807ad1e7bc46$var$constructEndpoint = (projectId, requestAlias)=>`/rest/servicedesk/onboarding/1/create-demo-requests/${projectId}/${requestAlias}`;
const $619e807ad1e7bc46$export$299ba2dee77727e9 = (projectId, requestAlias)=>{
    const url = $619e807ad1e7bc46$var$constructEndpoint(projectId, requestAlias);
    return (0, $jGzN3.performPostRequest)(url);
};

});


parcelRegister("azILi", function(module, exports) {

$parcel$export(module.exports, "default", () => $13705a327fc54061$export$2e2bcd8739ae039);

var $fDT3j = parcelRequire("fDT3j");

var $2uBHr = parcelRequire("2uBHr");
const $13705a327fc54061$var$service = async ({ projectId: projectId })=>{
    try {
        const response = await (0, $2uBHr.get)(projectId, (0, $fDT3j.CREATED_DEMO_REQUESTS_PROPERTY_KEY));
        return response.value || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return [];
    }
};
var $13705a327fc54061$export$2e2bcd8739ae039 = $13705a327fc54061$var$service;

});
parcelRegister("2uBHr", function(module, exports) {

$parcel$export(module.exports, "get", () => $272edda39b824977$export$3988ae62b71be9a3);

var $jGzN3 = parcelRequire("jGzN3");
const $272edda39b824977$export$a5b7a8c3b1c6e775 = (projectId, propertyKey)=>`/rest/api/3/project/${projectId}/properties/${propertyKey}`;
const $272edda39b824977$export$3988ae62b71be9a3 = (projectId, propertyKey)=>{
    const url = $272edda39b824977$export$a5b7a8c3b1c6e775(projectId, propertyKey);
    return (0, $jGzN3.performGetRequest)(url);
};

});


parcelRegister("dwfuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bb1feb730d2dc01$export$2e2bcd8739ae039);

var $bPWfC = parcelRequire("bPWfC");

var $fDT3j = parcelRequire("fDT3j");
const $4bb1feb730d2dc01$var$service = ({ createdAliases: createdAliases })=>(0, $fDT3j.REQUEST_CREATION_ORDER).find((issueAlias)=>!(0, (/*@__PURE__*/$parcel$interopDefault($bPWfC)))(createdAliases, issueAlias));
var $4bb1feb730d2dc01$export$2e2bcd8739ae039 = $4bb1feb730d2dc01$var$service;

});





parcelRegister("24D4A", function(module, exports) {

$parcel$export(module.exports, "getEmptyStateMessage", () => $10313038a9797a1e$export$383ed4a3403ea4fc);

var $5PQOA = parcelRequire("5PQOA");

var $lc49q = parcelRequire("lc49q");

var $i1KSn = parcelRequire("i1KSn");
const $10313038a9797a1e$export$6d2dfff2bbcb7a21 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))(()=>{
    const randomNumber = Math.floor(Math.random() * Math.floor(4));
    switch(randomNumber){
        case 0:
            return {
                header: (0, $i1KSn.default).emptyQueueHeaderOne,
                description: (0, $i1KSn.default).emptyQueueDescriptionOne
            };
        case 1:
            return {
                header: (0, $i1KSn.default).emptyQueueHeaderTwo,
                description: (0, $i1KSn.default).emptyQueueDescriptionTwo
            };
        case 2:
            return {
                header: (0, $i1KSn.default).emptyQueueHeaderThree,
                description: (0, $i1KSn.default).emptyQueueDescriptionThree
            };
        default:
            return {
                header: (0, $i1KSn.default).emptyQueueHeaderFour,
                description: (0, $i1KSn.default).emptyQueueDescriptionFour
            };
    }
});
const $10313038a9797a1e$export$383ed4a3403ea4fc = (state)=>// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
    $10313038a9797a1e$export$6d2dfff2bbcb7a21((0, $lc49q.getQueueId)(state));

});
parcelRegister("i1KSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f9ab3494e615170$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0f9ab3494e615170$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyQueueHeaderOne: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-header-one",
        "defaultMessage": "Your queue is empty but what is empty?"
    },
    emptyQueueDescriptionOne: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-description-one",
        "defaultMessage": "Time to ponder the mysteries of the Universe."
    },
    emptyQueueHeaderTwo: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-header-two",
        "defaultMessage": "You\u2019ve cleaned up here perfectly!"
    },
    emptyQueueDescriptionTwo: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-description-two",
        "defaultMessage": "The only thing left to clean is your computer screen."
    },
    emptyQueueHeaderThree: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-header-three",
        "defaultMessage": "Queue\u2019s empty! Dance party!"
    },
    emptyQueueDescriptionThree: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-description-three",
        "defaultMessage": "Congratulate yourself on a job well done!"
    },
    emptyQueueHeaderFour: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-header-four",
        "defaultMessage": "Your queue is empty."
    },
    emptyQueueDescriptionFour: {
        "id": "servicedesk.queues.agent-view.layout.empty-queue.empty-queue-description-four",
        "defaultMessage": "Cupcakes for all!"
    }
});

});


parcelRegister("dEoHu", function(module, exports) {

$parcel$export(module.exports, "default", () => $948d9cc617c01a22$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $4xbv3 = parcelRequire("4xbv3");

var $lYjMM = parcelRequire("lYjMM");

var $fLAsw = parcelRequire("fLAsw");

var $2IsS5 = parcelRequire("2IsS5");

var $dTqD3 = parcelRequire("dTqD3");

var $abeuj = parcelRequire("abeuj");
function $948d9cc617c01a22$export$fdbb6e83492670a7({ intl: { formatMessage: formatMessage }, projectId: projectId, isQueueVisible: isQueueVisible, queueId: queueId, EmptyQueueComponent: EmptyQueueComponent, DemoDripFeed: DemoDripFeed, emptyStateMessage: { header: header, description: description }, metricKey: metricKey, category: category }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStatePageReadyOnUpdate), {
        comparer: [
            queueId
        ],
        updateKey: queueId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: "emptyQueue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(EmptyQueueComponent, {
        projectId: projectId,
        header: formatMessage(header),
        description: formatMessage(description),
        category: category
    })), isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lYjMM.JsmPageInteractiveEvent), {
        key: (0, $2IsS5.fromQueueIdString)(queueId),
        metricKey: metricKey,
        withMarks: (0, $fLAsw.getAgentViewMarks)(),
        // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
        metric: (0, $abeuj.serviceViewPageLoad),
        extra: {
            category: category || 'no-category',
            empty: true
        }
    }), DemoDripFeed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DemoDripFeed, null) : null);
}
var $948d9cc617c01a22$export$2e2bcd8739ae039 = (0, $6YFG2.default)($948d9cc617c01a22$export$fdbb6e83492670a7);

});
parcelRegister("lYjMM", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $ee4aa9865402da99$export$c4ba40c380ee9a11);

var $eJOHy = parcelRequire("eJOHy");

var $lA4uT = parcelRequire("lA4uT");
const $ee4aa9865402da99$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lA4uT.default), args);
$ee4aa9865402da99$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$ee4aa9865402da99$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("lA4uT", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $70fb2661bfe02c7c$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $70fb2661bfe02c7c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $70fb2661bfe02c7c$export$9b3029ee6188a41f);

var $eJOHy = parcelRequire("eJOHy");

var $2gvG4 = parcelRequire("2gvG4");

var $6whQo = parcelRequire("6whQo");

var $kVpZx = parcelRequire("kVpZx");

var $ioEQd = parcelRequire("ioEQd");

var $4l9pO = parcelRequire("4l9pO");

var $2UxSQ = parcelRequire("2UxSQ");

var $jPcl6 = parcelRequire("jPcl6");

var $9j9F7 = parcelRequire("9j9F7");

var $jSrj1 = parcelRequire("jSrj1");
const $70fb2661bfe02c7c$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $70fb2661bfe02c7c$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $70fb2661bfe02c7c$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $9j9F7.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $jPcl6.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $jSrj1.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6whQo.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2UxSQ.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $kVpZx.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4l9pO.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $70fb2661bfe02c7c$export$9b3029ee6188a41f = $70fb2661bfe02c7c$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("2gvG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbfbe10f2ed80f4c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $bbfbe10f2ed80f4c$export$d12f56a472cdbe6c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $bbfbe10f2ed80f4c$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    (0, $eJOHy.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof globalThis?.structuredClone === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $bbfbe10f2ed80f4c$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof globalThis?.structuredClone === 'function') (0, $2QO3b.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $2QO3b.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("6whQo", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $3708d872c36dd1bb$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $3708d872c36dd1bb$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $3708d872c36dd1bb$export$d93d677ef2f33c5c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $3708d872c36dd1bb$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    (0, $eJOHy.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $3708d872c36dd1bb$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingsConfig);
        (0, $2QO3b.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("4l9pO", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $4802f5e968b3fe62$export$575e93c0f9905999);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $k04JP = parcelRequire("k04JP");

var $6uWhG = parcelRequire("6uWhG");

var $2HxHL = parcelRequire("2HxHL");

var $akiS9 = parcelRequire("akiS9");

var $dydef = parcelRequire("dydef");

var $9DwQv = parcelRequire("9DwQv");

const $4802f5e968b3fe62$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
};
class $4802f5e968b3fe62$export$575e93c0f9905999 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $k04JP.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $akiS9.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $2e47af044bce450a$export$99c08ec92759c71c));
                (0, $6uWhG.setMark)((0, $2e47af044bce450a$export$99c08ec92759c71c));
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $2e47af044bce450a$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $4802f5e968b3fe62$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $akiS9.PRODUCT_START_MARK), true);
            $4802f5e968b3fe62$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});
const $2e47af044bce450a$export$56940a9488e85199 = 'jira.fe.spa-';
const $2e47af044bce450a$export$45c4b6bf7935c69a = `${$2e47af044bce450a$export$56940a9488e85199}start`;
const $2e47af044bce450a$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $2e47af044bce450a$export$ff834eccc35b9089 = 'appBundleReady';
const $2e47af044bce450a$export$86b05e34d462ead8 = 'prefetchApiReady';
const $2e47af044bce450a$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $2e47af044bce450a$export$3ae43cc1782d058f = 'jswRenderStart';
const $2e47af044bce450a$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $2e47af044bce450a$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $2e47af044bce450a$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $2e47af044bce450a$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $2e47af044bce450a$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $2e47af044bce450a$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $2e47af044bce450a$export$99c08ec92759c71c = 'tti-raf-mark';
const $2e47af044bce450a$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("2UxSQ", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $9ca3da1474781c5a$export$d91154f099475c5);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $ioEQd = parcelRequire("ioEQd");
class $9ca3da1474781c5a$export$d91154f099475c5 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $ioEQd.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("jPcl6", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9af3d786d904c43c$export$bf239ac2bfb04967);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $9af3d786d904c43c$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("9j9F7", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $79450f1fef3080e8$export$e63862cd888fe05a);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $ioEQd = parcelRequire("ioEQd");
var $8tVkR = parcelRequire("8tVkR");
async function $79450f1fef3080e8$export$e63862cd888fe05a() {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $ioEQd.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $8tVkR.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("jSrj1", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $0af00334d248807d$export$f00f1e874ce869e9);

var $kVpZx = parcelRequire("kVpZx");

var $j500r = parcelRequire("j500r");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0af00334d248807d$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0af00334d248807d$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0af00334d248807d$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $0af00334d248807d$export$7b4abba432e57989 = (value)=>$0af00334d248807d$var$isString(value) && $0af00334d248807d$var$startsAsObject(value) || $0af00334d248807d$var$isObject(value);
const $0af00334d248807d$export$fcc03ee4c944962f = (featureFlagValue)=>$0af00334d248807d$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $0af00334d248807d$export$d2818866b4acbea4 = new Map();
const $0af00334d248807d$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $j500r.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $0af00334d248807d$export$fcc03ee4c944962f(value);
            $0af00334d248807d$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("fLAsw", function(module, exports) {

$parcel$export(module.exports, "getAgentViewMarks", () => $01e129afff72757e$export$551d840952c7afcf);

var $9Dhvc = parcelRequire("9Dhvc");

var $6uWhG = parcelRequire("6uWhG");

var $4kMB4 = parcelRequire("4kMB4");

var $dNyX9 = parcelRequire("dNyX9");
const $01e129afff72757e$var$PREFIX = 'servicedesk.queues';
/**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ const $01e129afff72757e$var$triggerAnalyticsEvent = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $01e129afff72757e$var$triggerAnalyticsFunction = $01e129afff72757e$var$triggerAnalyticsEvent($01e129afff72757e$var$PREFIX);
var /**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$01e129afff72757e$export$2e2bcd8739ae039 = (eventNameSuffix, data)=>{
    $01e129afff72757e$var$triggerAnalyticsFunction(eventNameSuffix, data);
};
const $01e129afff72757e$var$getName = (mark)=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(mark, 'name', undefined);
const $01e129afff72757e$export$551d840952c7afcf = ()=>[
        (0, $4kMB4.appBundleReadyMark),
        (0, $4kMB4.prefetchApiReadyMark),
        $01e129afff72757e$var$getName((0, $6uWhG.getMark)('jsd.performance.profile.queues.issuetable.mount')),
        $01e129afff72757e$var$getName((0, $6uWhG.getMark)('jsd.performance.profile.queues.firstfield.render')),
        $01e129afff72757e$var$getName((0, $6uWhG.getMark)('jsd.performance.profile.queues.issues.loaded')),
        $01e129afff72757e$var$getName((0, $6uWhG.getMark)('jsd.performance.profile.queues.localstorage.received'))
    ].filter(Boolean).map((0, $dNyX9.getPrefixedMarkName));

});

parcelRegister("abeuj", function(module, exports) {

$parcel$export(module.exports, "serviceViewPageLoad", () => $e128a79c14b505fd$export$61008c925a90a363);

var $hqYEY = parcelRequire("hqYEY");
const $e128a79c14b505fd$export$61008c925a90a363 = (0, $hqYEY.metrics).pageLoad({
    key: 'service-management.queues.view'
});

});



parcelRegister("eR1Cn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f33af333f2143682$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $6I1gv = parcelRequire("6I1gv");

var $bPkxw = parcelRequire("bPkxw");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f33af333f2143682$var$reloadWindow = ()=>window.location.reload();
const $f33af333f2143682$var$mapStateToProps = (state)=>({
        isLoading: (0, $6I1gv.isRetrying)(state)
    });
const $f33af333f2143682$var$mapDispatchToProps = ()=>({
        onRetry: $f33af333f2143682$var$reloadWindow
    });
var $f33af333f2143682$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($f33af333f2143682$var$mapStateToProps, $f33af333f2143682$var$mapDispatchToProps)((0, $bPkxw.default));

});
parcelRegister("bPkxw", function(module, exports) {

$parcel$export(module.exports, "default", () => $33e0e4bf39f395e6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1sChl = parcelRequire("1sChl");

var $lRq8t = parcelRequire("lRq8t");

var $5fvRS = parcelRequire("5fvRS");
function $33e0e4bf39f395e6$var$Error(props) {
    const { isLoading: isLoading, onRetry: onRetry } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1sChl.default), {
        isLoading: isLoading,
        onRetry: onRetry,
        header: formatMessage((0, $5fvRS.default).errorHeader),
        description: formatMessage((0, $5fvRS.default).errorMessage)
    });
}
$33e0e4bf39f395e6$var$Error.defaultProps = {
    isLoading: false
};
var $33e0e4bf39f395e6$export$2e2bcd8739ae039 = $33e0e4bf39f395e6$var$Error;

});
parcelRegister("5fvRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e7c801a725d3e86$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8e7c801a725d3e86$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorHeader: {
        "id": "servicedesk.queues.agent-view.layout.error-state.error-header",
        "defaultMessage": "We couldn't load your queue"
    },
    errorMessage: {
        "id": "servicedesk.queues.agent-view.layout.error-state.error-message",
        "defaultMessage": "Give it a few seconds, then try again."
    },
    reload: {
        "id": "servicedesk.queues.agent-view.layout.error-state.reload",
        "defaultMessage": "Reload"
    }
});

});



parcelRegister("aaZPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $084efa065206c46d$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $aXT93 = parcelRequire("aXT93");

var $b6xyr = parcelRequire("b6xyr");
const $084efa065206c46d$var$mapDispatchToProps = {
    onSetIssueKeyContext: (0, $aXT93.setIssueKeyContext)
};
var $084efa065206c46d$export$2e2bcd8739ae039 = (0, $gnQAk.connect)(null, $084efa065206c46d$var$mapDispatchToProps)((0, $b6xyr.IssueContextListener));

});
parcelRegister("b6xyr", function(module, exports) {

$parcel$export(module.exports, "IssueContextListener", () => $3ee00050e4ae3fe6$export$3581168f8217134);

var $eJOHy = parcelRequire("eJOHy");

var $lQL5M = parcelRequire("lQL5M");
function $3ee00050e4ae3fe6$export$3581168f8217134({ onSetIssueKeyContext: onSetIssueKeyContext }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lQL5M.IssueContextSubscriber), null, ({ issueKeyContext: issueKeyContext })=>{
        onSetIssueKeyContext(issueKeyContext);
        return null;
    });
}

});
parcelRegister("lQL5M", function(module, exports) {

$parcel$export(module.exports, "IssueContextSubscriber", () => $4eddc9957d786751$export$d5fe934bda9e4605);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $ht3nQ = parcelRequire("ht3nQ");

var $8xLwN = parcelRequire("8xLwN");
const $4eddc9957d786751$export$93db6a8f3342dddf = (0, $6E16M.createContainer)((0, $8xLwN.default));
const $4eddc9957d786751$export$d5fe934bda9e4605 = (0, $ht3nQ.createSubscriber)((0, $8xLwN.default));
const $4eddc9957d786751$export$95e128ed686255dc = (0, $iJq0l.createHook)((0, $8xLwN.default));

});
parcelRegister("8xLwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $63bb42baf6fd5379$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $GtRbT = parcelRequire("GtRbT");

var $ahdrT = parcelRequire("ahdrT");
const $63bb42baf6fd5379$var$initialState = {
    issueKeyContext: undefined
};
var $63bb42baf6fd5379$export$2e2bcd8739ae039 = (0, $GtRbT.createStore)({
    name: 'issue-context',
    initialState: $63bb42baf6fd5379$var$initialState,
    actions: $ahdrT.default
});

});
parcelRegister("ahdrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ef2ce607e287507$export$2e2bcd8739ae039);
const $4ef2ce607e287507$var$actions = {
    setIssueKeyContext: (issueKey)=>({ setState: setState })=>setState({
                issueKeyContext: issueKey
            })
};
var $4ef2ce607e287507$export$2e2bcd8739ae039 = $4ef2ce607e287507$var$actions;

});





parcelRegister("bsyRU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0979903477a43141$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $iYrDT = parcelRequire("iYrDT");

var $2FFkl = parcelRequire("2FFkl");
var $0979903477a43141$export$2e2bcd8739ae039 = (0, $gnQAk.connect)(null, (dispatch)=>({
        onUpdatePractices: (practiceList)=>{
            dispatch((0, $iYrDT.setEnabledPracticesAction)(practiceList));
        }
    }))((0, $2FFkl.default));

});
parcelRegister("2FFkl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29031c0a742bff1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $3fKYX = parcelRequire("3fKYX");
const $b29031c0a742bff1$var$ItsmContextListener = ({ projectKey: projectKey, onUpdatePractices: onUpdatePractices })=>{
    const practicesBelongsToRef = (0, $eJOHy.useRef)('');
    const [practices, loading, error] = (0, $3fKYX.usePracticeList)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        const canUpdatePractices = !loading && !error && practicesBelongsToRef.current !== projectKey;
        if (canUpdatePractices) {
            practicesBelongsToRef.current = projectKey;
            onUpdatePractices(practices || []);
        }
    }, [
        projectKey,
        loading,
        error,
        onUpdatePractices,
        practices
    ]);
    return null;
};
$b29031c0a742bff1$var$ItsmContextListener.defaultProps = {
    projectKey: '',
    onUpdatePractices: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
var $b29031c0a742bff1$export$2e2bcd8739ae039 = $b29031c0a742bff1$var$ItsmContextListener;

});


parcelRegister("8U6qY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b784cf5645a70d5$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $hjf2q = parcelRequire("hjf2q");

var $gnQAk = parcelRequire("gnQAk");

var $3MjJb = parcelRequire("3MjJb");

var $1TuhT = parcelRequire("1TuhT");

var $9kCRJ = parcelRequire("9kCRJ");

var $9ZLQI = parcelRequire("9ZLQI");
const $0b784cf5645a70d5$var$mapStateToProps = (state)=>({
        issueCount: (0, $1TuhT.getIssueCount)(state),
        projectStateHash: (0, $9kCRJ.getProjectStateHash)(state),
        isCurrentDataFiltered: (0, $3MjJb.getIsCurrentDataFiltered)(state)
    });
var $0b784cf5645a70d5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $gnQAk.connect)($0b784cf5645a70d5$var$mapStateToProps, {}), (0, $hjf2q.AnalyticsEventToProps)('navUpdate', {
    onProjectStateHashUpdate: 'queuesCountsRefreshed'
}))((0, $9ZLQI.default));

});
parcelRegister("9ZLQI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fa7cc00c98395d1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");
class $0fa7cc00c98395d1$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            onQueueIssueCountUpdated: undefined,
            onProjectStateHashUpdate: undefined
        };
    }
    componentDidMount() {
        this.updateIssueCount();
    }
    componentDidUpdate(prevProps) {
        const { projectStateHash: projectStateHash, onProjectStateHashUpdate: onProjectStateHashUpdate, issueCount: issueCount } = this.props;
        if (prevProps.issueCount !== issueCount) this.updateIssueCount();
        if (// Only call again if it isn't immediately following an initialization call (projectStateHash = null)
        !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(prevProps.projectStateHash) && prevProps.projectStateHash !== projectStateHash && onProjectStateHashUpdate) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        onProjectStateHashUpdate();
    }
    updateIssueCount() {
        const { queueId: queueId, issueCount: issueCount, onQueueIssueCountUpdated: onQueueIssueCountUpdated, isCurrentDataFiltered: isCurrentDataFiltered } = this.props;
        !isCurrentDataFiltered && onQueueIssueCountUpdated && onQueueIssueCountUpdated(queueId, issueCount);
    }
    render() {
        return null;
    }
}

});


parcelRegister("5JzRO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1174d2ec81722067$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $f20Bj = parcelRequire("f20Bj");

var $lc49q = parcelRequire("lc49q");

var $8UrVU = parcelRequire("8UrVU");
var $1174d2ec81722067$export$2e2bcd8739ae039 = (0, $gnQAk.connect)((state)=>({
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        projectKey: (0, $f20Bj.getProjectKey)(state),
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        projectName: (0, $f20Bj.getProjectName)(state),
        category: (0, $lc49q.getCategory)(state)
    }), {})((0, $8UrVU.default));

});
parcelRegister("8UrVU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d2b95be0e471d84$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5SwkH = parcelRequire("5SwkH");

var $5Wr46 = parcelRequire("5Wr46");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2d2b95be0e471d84$export$2e2bcd8739ae039 = ({ children: children, category: category, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Wr46.default), {
        ...rest,
        category: category,
        href: (0, $5SwkH.getQueueUrl)({
            projectKey: rest.projectKey,
            category: category,
            queueId: null
        })
    }, children);

});
parcelRegister("5Wr46", function(module, exports) {

$parcel$export(module.exports, "default", () => $af2e29d1e702b81c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gNYyp = parcelRequire("gNYyp");

var $6T1wD = parcelRequire("6T1wD");

var $gFB4g = parcelRequire("gFB4g");

var $lRq8t = parcelRequire("lRq8t");

var $3fKYX = parcelRequire("3fKYX");

var $jlJsl = parcelRequire("jlJsl");

var $ZfaX7 = parcelRequire("ZfaX7");

var $6P1Q4 = parcelRequire("6P1Q4");
const $af2e29d1e702b81c$var$getBreadcrumbText = (category)=>{
    if (!category) return (0, $6P1Q4.default).queues;
    switch(category){
        case 0, $jlJsl.INCIDENTS:
            return (0, $ZfaX7.default).incidents;
        case 0, $jlJsl.CHANGES:
            return (0, $ZfaX7.default).changes;
        case 0, $jlJsl.SERVICE_REQUEST:
            return (0, $ZfaX7.default).serviceRequests;
        case 0, $jlJsl.PROBLEMS:
            return (0, $ZfaX7.default).problems;
        case 0, $jlJsl.POST_INCIDENT_REVIEWS:
            return (0, $ZfaX7.default).postIncidentReviews;
        default:
            return (0, $ZfaX7.default).queues;
    }
};
const $af2e29d1e702b81c$var$QueuesBreadcrumbManager = ({ children: children, projectKey: projectKey, projectName: projectName, href: href, text: text = '', type: type = 'queues', category: category })=>{
    const [practiceList] = (0, $3fKYX.usePracticeList)();
    const hasPractices = Boolean(practiceList && practiceList.length > 1);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gNYyp.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gFB4g.default), {
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6T1wD.default), {
        breadcrumb: {
            href: href,
            text: text || formatMessage($af2e29d1e702b81c$var$getBreadcrumbText(hasPractices ? category : undefined)),
            type: type
        }
    }, children)));
};
var $af2e29d1e702b81c$export$2e2bcd8739ae039 = $af2e29d1e702b81c$var$QueuesBreadcrumbManager;

});
parcelRegister("6P1Q4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fa760243c9aa85e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6fa760243c9aa85e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    queues: {
        "id": "servicedesk-queues-breadcrumb.queues-breadcrumb-manager.queues",
        "defaultMessage": "Queues"
    }
});

});




parcelRegister("F7Mtp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8249dc8fb3960239$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $LFmXM = parcelRequire("LFmXM");

var $7jTnu = parcelRequire("7jTnu");

var $BwaQq = parcelRequire("BwaQq");

var $l5htz = parcelRequire("l5htz");

var $6gaEC = parcelRequire("6gaEC");


var $4vqDL = parcelRequire("4vqDL");

var $gnQAk = parcelRequire("gnQAk");

var $6I8xu = parcelRequire("6I8xu");

var $f20Bj = parcelRequire("f20Bj");

var $2MzoN = parcelRequire("2MzoN");

var $bKkYU = parcelRequire("bKkYU");

var $iGYMr = parcelRequire("iGYMr");

var $aXT93 = parcelRequire("aXT93");

var $ir4eL = parcelRequire("ir4eL");

var $f2fyU = parcelRequire("f2fyU");

var $3MjJb = parcelRequire("3MjJb");

var $1TuhT = parcelRequire("1TuhT");

var $lgeFD = parcelRequire("lgeFD");

var $lc49q = parcelRequire("lc49q");

var $4LfWe = parcelRequire("4LfWe");

var $6dk7W = parcelRequire("6dk7W");

var $6I1gv = parcelRequire("6I1gv");

var $8pEJH = parcelRequire("8pEJH");

var $1WNMX = parcelRequire("1WNMX");

var $9HCVY = parcelRequire("9HCVY");

var $3V2vB = parcelRequire("3V2vB");

var $dOXjW = parcelRequire("dOXjW");
const $8249dc8fb3960239$var$onActiveItemChanged = (payload)=>payload && (0, $iGYMr.activeItemChangedAction)(payload.rowId, payload.columnId) || (0, $iGYMr.activeItemRemovedAction)();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8249dc8fb3960239$var$mapStateToProps = (state, ownProps)=>{
    const isLoading = (0, $6I1gv.isLoadingIssues)(state);
    return {
        appProps: (0, $6dk7W.getIssueTableAppProps)(state),
        queueId: (0, $lc49q.getQueueId)(state),
        queueName: (0, $7jTnu.fg)('jsm_virtual_table_a11y') ? (0, $lc49q.getQueueName)(state) : undefined,
        queueCategory: (0, $lc49q.getCategory)(state),
        columns: (0, $lc49q.getColumnsInOrder)(state),
        DemoDripFeed: $8pEJH.default,
        FieldDataSelector: $1WNMX.default,
        issueKeys: (0, $lgeFD.getIssueKeysForPage)(state),
        IssueTable: $4vqDL.default,
        KeyboardShortcutListener: $9HCVY.default,
        AsyncBulkActionToolbar: $6I8xu.AsyncBulkActionToolbar,
        SelectedIssuesSubscriber: $6gaEC.SelectedIssuesSubscriber,
        currentPage: (0, $lgeFD.getCurrentPage)(state),
        totalPages: (0, $lgeFD.getTotalPages)(state),
        sortedBy: (0, $4LfWe.getSortedByColumn)(state),
        sortOrder: (0, $4LfWe.getSortOrder)(state),
        isQueueVisible: (0, $6I1gv.isQueueVisible)(state),
        isQueueTransient: (0, $lc49q.isQueueTransient)(state),
        projectKey: (0, $f20Bj.getProjectKey)(state),
        isLoading: isLoading,
        isContentStale: isLoading && (0, $1TuhT.getCollection)(state).length > 0,
        metricKey: (0, $lc49q.getMetricKey)(state),
        hasLoadedIssueDataFromCache: (0, $f2fyU.getHasLoadedIssueDataFromCache)(state),
        canFocusTable: !(0, $3MjJb.getIsFilterFocused)(state),
        useJSMQueueDurationEvent: ownProps.useJSMQueueDurationEvent,
        renderSidebarIcon: ownProps.renderSidebarIcon,
        shouldRerenderRowOnHover: ownProps.shouldRerenderRowOnHover,
        width: ownProps.width,
        tableWidth: ownProps.tableWidth
    };
};
// We want to avoid creating a new anonymous function every time the state has changed, so that later in `issue-table`
// we can compare the prop to decide whether we should update the component.
const $8249dc8fb3960239$var$onSortOrderChangedGenerator = (0, $LFmXM.default)((dispatch)=>(sortedBy, sortOrder)=>dispatch((0, $iGYMr.sortOrderChangedAction)(sortedBy, sortOrder)));
const $8249dc8fb3960239$var$mapDispatchToProps = (dispatch)=>({
        // @ts-expect-error - TS7006 - Parameter 'payload' implicitly has an 'any' type.
        onActiveItemChanged: (payload)=>dispatch($8249dc8fb3960239$var$onActiveItemChanged(payload)),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onPageChange: (event, newPage)=>{
            dispatch((0, $iGYMr.pageChangedAction)(newPage));
            dispatch((0, $2MzoN.loadIssuesActionForPage)(newPage));
        },
        onSortOrderChanged: $8249dc8fb3960239$var$onSortOrderChangedGenerator(dispatch),
        onIssueDataRequested: (startIndex)=>dispatch((0, $iGYMr.fetchIssueDataOnScrollAction)(startIndex)),
        onVerticalScrollChanged: (verticalPosition)=>dispatch((0, $iGYMr.toggleQueueHeaderAction)(verticalPosition.direction)),
        onTableChange: (analyticsEvent)=>dispatch((0, $iGYMr.tableChangedAction)(analyticsEvent)),
        onSetSelectedIssueKeys: (selectedIssueKeys)=>dispatch((0, $aXT93.setSelectedIssueKeys)(selectedIssueKeys)),
        onRefreshSidebar: ({ issueKey: issueKey } = {})=>{
            dispatch((0, $aXT93.refreshSidebarIssueView)({
                issueKey: issueKey
            }));
        },
        onSetIssueKey: (key)=>{
            dispatch((0, $aXT93.setSidebarIssueKey)(key));
        },
        onNonPremiumSLAColumnError: ()=>dispatch((0, $bKkYU.displayQueuesErrorHeaderAction)()),
        controlPolling: {
            restartPolling: ()=>{
                dispatch((0, $aXT93.refreshSidebarIssueView)());
                dispatch((0, $ir4eL.restartPollAction)());
            },
            stopPolling: ()=>dispatch((0, $ir4eL.stopPollAction)())
        }
    });
const $8249dc8fb3960239$var$getColumnsForIssueTableFactory = (0, $LFmXM.default)((columns, onSortOrderChanged)=>(0, $3V2vB.getColumnsForIssueTable)(columns, onSortOrderChanged));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8249dc8fb3960239$var$mergeProps = (stateProps, dispatchProps)=>({
        ...stateProps,
        ...dispatchProps,
        columns: $8249dc8fb3960239$var$getColumnsForIssueTableFactory(stateProps.columns, dispatchProps.onSortOrderChanged)
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8249dc8fb3960239$var$connectedTable = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $l5htz.default)({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onPageChange: (event, newPage)=>({
            name: 'queue',
            pageNumber: newPage,
            startIndex: (0, $b354b11309751a31$export$f88f58d1a4b2078b) * (newPage - 1) + 1
        })
}), (0, $gnQAk.connect)($8249dc8fb3960239$var$mapStateToProps, $8249dc8fb3960239$var$mapDispatchToProps, $8249dc8fb3960239$var$mergeProps), (0, $BwaQq.AnalyticsSubject)('queue'))((0, $dOXjW.default));
var $8249dc8fb3960239$export$2e2bcd8739ae039 = $8249dc8fb3960239$var$connectedTable;

});
parcelRegister("6gaEC", function(module, exports) {

$parcel$export(module.exports, "SelectedIssuesContainer", () => $9fe2d4847777aaf2$export$738cdb08d2b14320);
$parcel$export(module.exports, "SelectedIssuesSubscriber", () => $9fe2d4847777aaf2$export$e95e49d0cb3be823);
$parcel$export(module.exports, "useSelectedIssues", () => $9fe2d4847777aaf2$export$a435421a00d3bee);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $gPssM = parcelRequire("gPssM");

const $9fe2d4847777aaf2$export$d4c72bab9d6cc13a = {
    issueKeys: [],
    limit: (0, $119bdb92cb31a359$export$81a88ed305997a6d),
    isLocked: false
};
const $9fe2d4847777aaf2$var$Store = (0, $GtRbT.createStore)({
    name: 'issue-table-selection',
    initialState: $9fe2d4847777aaf2$export$d4c72bab9d6cc13a,
    actions: $gPssM
});
const $9fe2d4847777aaf2$export$738cdb08d2b14320 = (0, $6E16M.createContainer)($9fe2d4847777aaf2$var$Store);
const $9fe2d4847777aaf2$export$e95e49d0cb3be823 = (0, $ht3nQ.createSubscriber)($9fe2d4847777aaf2$var$Store, {
    displayName: 'SelectedIssuesSubscriber'
});
const $9fe2d4847777aaf2$export$ded196a925e981e1 = (0, $ht3nQ.createSubscriber)($9fe2d4847777aaf2$var$Store, {
    displayName: 'SelectedIssuesActionsSubscriber',
    selector: null
});
const $9fe2d4847777aaf2$export$a435421a00d3bee = (0, $iJq0l.createHook)($9fe2d4847777aaf2$var$Store);
var $9fe2d4847777aaf2$export$2e2bcd8739ae039 = $9fe2d4847777aaf2$var$Store;

});
parcelRegister("gPssM", function(module, exports) {

$parcel$export(module.exports, "selectIssues", () => (parcelRequire("cJaFK")).selectIssues);
$parcel$export(module.exports, "deselectIssues", () => (parcelRequire("5Zgpo")).deselectIssues);
$parcel$export(module.exports, "deselectAllIssues", () => (parcelRequire("lPmuc")).deselectAllIssues);
$parcel$export(module.exports, "refreshSelection", () => (parcelRequire("hJOWY")).refreshSelection);
$parcel$export(module.exports, "getCurrentlySelectedIssues", () => (parcelRequire("dR2xD")).getCurrentlySelectedIssues);
$parcel$export(module.exports, "lockSelection", () => (parcelRequire("e3W37")).lockSelection);
$parcel$export(module.exports, "unlockSelection", () => (parcelRequire("dhE0G")).unlockSelection);
$parcel$export(module.exports, "refreshSelectionLimit", () => (parcelRequire("bB2z4")).refreshSelectionLimit);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $cJaFK = parcelRequire("cJaFK");

var $5Zgpo = parcelRequire("5Zgpo");

var $lPmuc = parcelRequire("lPmuc");

var $hJOWY = parcelRequire("hJOWY");

var $dR2xD = parcelRequire("dR2xD");

var $e3W37 = parcelRequire("e3W37");

var $dhE0G = parcelRequire("dhE0G");

var $bB2z4 = parcelRequire("bB2z4");

});
parcelRegister("cJaFK", function(module, exports) {

$parcel$export(module.exports, "selectIssues", () => $ce33ff593e3ddb83$export$1e9b66e71acaf40b);

var $2zs80 = parcelRequire("2zs80");

var $8dH3d = parcelRequire("8dH3d");

var $02cdO = parcelRequire("02cdO");

var $gCeeo = parcelRequire("gCeeo");
const $ce33ff593e3ddb83$export$1e9b66e71acaf40b = (selectedIssueKeys, analyticsEvent)=>({ getState: getState, setState: setState })=>{
        const { issueKeys: issueKeys, limit: limit } = getState();
        const newlySelectedIssueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(selectedIssueKeys, issueKeys);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(newlySelectedIssueKeys)) {
            const newIssueKeys = issueKeys.concat(...newlySelectedIssueKeys);
            setState({
                issueKeys: (0, (/*@__PURE__*/$parcel$interopDefault($02cdO)))(newIssueKeys, limit)
            });
            analyticsEvent && (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'bulkSelection added', {
                selectionTruncated: newIssueKeys.length > limit,
                desiredIssuesCount: newIssueKeys.length,
                selectedIssuesCount: Math.min(newIssueKeys.length, limit),
                previousSelectedIssuesCount: issueKeys.length
            });
        }
    };

});
parcelRegister("02cdO", function(module, exports) {

var $1FqKq = parcelRequire("1FqKq");

var $c9FP3 = parcelRequire("c9FP3");
/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */ function $0069ab02945d55e7$var$take(array, n, guard) {
    if (!(array && array.length)) return [];
    n = guard || n === undefined ? 1 : $c9FP3(n);
    return $1FqKq(array, 0, n < 0 ? 0 : n);
}
module.exports = $0069ab02945d55e7$var$take;

});


parcelRegister("5Zgpo", function(module, exports) {

$parcel$export(module.exports, "deselectIssues", () => $cd19ee729474f476$export$2d010dfcbbe2bfe4);

var $7BEaI = parcelRequire("7BEaI");

var $8dH3d = parcelRequire("8dH3d");

var $3l9kN = parcelRequire("3l9kN");

var $gCeeo = parcelRequire("gCeeo");
const $cd19ee729474f476$export$2d010dfcbbe2bfe4 = (deselectedIssueKeys, analyticsEvent)=>({ getState: getState, setState: setState })=>{
        const { issueKeys: issueKeys } = getState();
        const newlyDeselectedIssueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($7BEaI)))(deselectedIssueKeys, issueKeys);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(newlyDeselectedIssueKeys)) {
            const newIssueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(issueKeys, ...newlyDeselectedIssueKeys);
            setState({
                issueKeys: newIssueKeys
            });
            analyticsEvent && (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'bulkSelection reduced', {
                selectedIssuesCount: newIssueKeys.length,
                previousSelectedIssuesCount: issueKeys.length
            });
        }
    };

});
parcelRegister("7BEaI", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $lk1pL = parcelRequire("lk1pL");

var $l76qh = parcelRequire("l76qh");

var $9gcs2 = parcelRequire("9gcs2");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $589b265f473fd80f$var$intersection = $l76qh(function(arrays) {
    var mapped = $lylkU(arrays, $9gcs2);
    return mapped.length && mapped[0] === arrays[0] ? $lk1pL(mapped) : [];
});
module.exports = $589b265f473fd80f$var$intersection;

});


parcelRegister("lPmuc", function(module, exports) {

$parcel$export(module.exports, "deselectAllIssues", () => $39971bddb2234018$export$dd4a406c0382217f);

var $8dH3d = parcelRequire("8dH3d");

var $gCeeo = parcelRequire("gCeeo");
const $39971bddb2234018$export$dd4a406c0382217f = (analyticsEvent)=>({ getState: getState, setState: setState })=>{
        const { issueKeys: issueKeys } = getState();
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(issueKeys)) {
            setState({
                issueKeys: []
            });
            analyticsEvent && (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'bulkSelection reduced', {
                selectedIssuesCount: 0,
                previousSelectedIssuesCount: issueKeys.length
            });
        }
    };

});

parcelRegister("hJOWY", function(module, exports) {

$parcel$export(module.exports, "refreshSelection", () => $51ad372c7127dcec$export$86ff8cf593d1a265);

var $2zs80 = parcelRequire("2zs80");

var $8dH3d = parcelRequire("8dH3d");

var $02cdO = parcelRequire("02cdO");

var $3l9kN = parcelRequire("3l9kN");

const $51ad372c7127dcec$export$86ff8cf593d1a265 = (existingIssueKeys)=>({ getState: getState, setState: setState })=>{
        const { issueKeys: issueKeys } = getState();
        const deselectIssueKeys = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(issueKeys, existingIssueKeys);
        !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(deselectIssueKeys) && setState({
            issueKeys: (0, (/*@__PURE__*/$parcel$interopDefault($02cdO)))((0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(issueKeys, ...deselectIssueKeys), (0, $119bdb92cb31a359$export$81a88ed305997a6d))
        });
    };

});
const $119bdb92cb31a359$export$81a88ed305997a6d = 150;


parcelRegister("dR2xD", function(module, exports) {

$parcel$export(module.exports, "getCurrentlySelectedIssues", () => $d2d9869897d7f360$export$d6e9b99bcd1d7d6c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $d2d9869897d7f360$export$d6e9b99bcd1d7d6c = ()=>({ getState: getState })=>{
        const { issueKeys: issueKeys } = getState();
        return issueKeys;
    };

});

parcelRegister("e3W37", function(module, exports) {

$parcel$export(module.exports, "lockSelection", () => $76f1a601ac372517$export$790a7f6053d9b4a1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $76f1a601ac372517$export$790a7f6053d9b4a1 = ()=>({ setState: setState })=>setState({
            isLocked: true
        });

});

parcelRegister("dhE0G", function(module, exports) {

$parcel$export(module.exports, "unlockSelection", () => $ca699f6e704d12ed$export$a90d629fd06371e4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $ca699f6e704d12ed$export$a90d629fd06371e4 = ()=>({ setState: setState })=>setState({
            isLocked: false
        });

});

parcelRegister("bB2z4", function(module, exports) {

$parcel$export(module.exports, "refreshSelectionLimit", () => $bc473d49125be7b3$export$53f550a8d1ce7a3c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

const $bc473d49125be7b3$export$53f550a8d1ce7a3c = (numSelected)=>({ setState: setState })=>{
        if (numSelected > 0) setState({
            limit: Math.max((0, $119bdb92cb31a359$export$81a88ed305997a6d) - numSelected, 0)
        });
    };

});



parcelRegister("4vqDL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3cba0e65f4c8cc7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $dUugX = parcelRequire("dUugX");

var $6gaEC = parcelRequire("6gaEC");

var $caBl1 = parcelRequire("caBl1");

var $jkdXW = parcelRequire("jkdXW");

var $dpmnN = parcelRequire("dpmnN");

var $iN885 = parcelRequire("iN885");

var $987AO = parcelRequire("987AO");

var $cLGK3 = parcelRequire("cLGK3");

var $3fOWJ = parcelRequire("3fOWJ");

var $cN0WI = parcelRequire("cN0WI");

var $j3i8l = parcelRequire("j3i8l");

var $blTcR = parcelRequire("blTcR");

var $2f0m6 = parcelRequire("2f0m6");

var $dQRbF = parcelRequire("dQRbF");

var $8toaC = parcelRequire("8toaC");

var $4E6uF = parcelRequire("4E6uF");





// FIXME: this component should be using `connect` rather than unboundedly selecting from store state... (but please move off Redux)
// @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type. | TS7031 - Binding element 'tableProps' implicitly has an 'any' type.
const $a3cba0e65f4c8cc7$var$BulkSelectionAwareTableStateUpdater = ({ store: store, tableProps: tableProps })=>{
    const { dispatch: dispatch } = store;
    const { columns: columns, issueKeys: issueKeys, currentPage: currentPage, isDisabled: isDisabled, contentKey: contentKey, onIssueViewTransition: onIssueViewTransition, useJSMQueueDurationEvent: useJSMQueueDurationEvent, renderSidebarIcon: renderSidebarIcon, refreshSidebar: refreshSidebar } = tableProps;
    const [{ issueKeys: selectedIssueKeys }, actions] = (0, $6gaEC.useSelectedIssues)();
    const hasBulkSelection = selectedIssueKeys.length > 0;
    (0, $eJOHy.useEffect)(()=>{
        actions.refreshSelection([]);
    }, [
        actions,
        contentKey
    ]);
    // state is a new reference every render so DO NOT add it as a dependency to hooks!
    const state = store.getState();
    const columnsInState = (0, $blTcR.getColumns)(state);
    const issueKeysInState = (0, $2f0m6.getProvidedIssueKeys)(state);
    const currentPageInState = (0, $dQRbF.getCurrentPage)(state);
    const isDisabledInState = (0, $dQRbF.isTableDisabled)(state);
    const onIssueViewTransitionInState = (0, $dQRbF.getOnIssueViewTransition)(state);
    (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2322 - Type 'BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/issue-table-selection/src/services/actions/index")>' is not assignable to type 'typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services/issue-table-selection/src/services/actions/index")'.
        dispatch((0, $dpmnN.setSelectionServiceActionsAction)({
            actions: actions
        }));
        dispatch((0, $dpmnN.setHasSelectionAction)({
            hasSelection: hasBulkSelection
        }));
        if (hasBulkSelection) {
            dispatch(// @ts-expect-error - TS7006 - Parameter 'c' implicitly has an 'any' type.
            (0, $iN885.updateColumnsAction)(columns.map((c)=>({
                    ...c,
                    isDisabled: hasBulkSelection
                }))));
            dispatch((0, $cN0WI.setIsTableDisabled)(hasBulkSelection));
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(columns, columnsInState) && !hasBulkSelection) {
            dispatch((0, $iN885.updateColumnsAction)(columns));
            dispatch((0, $987AO.unlockAllFieldsAction)());
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(issueKeys, issueKeysInState)) dispatch((0, $cLGK3.updateProvidedIssueKeysAction)(issueKeys));
        if (currentPage !== currentPageInState) {
            dispatch((0, $987AO.unlockAllFieldsAction)());
            dispatch((0, $cN0WI.setCurrentPageAction)(currentPage));
        }
        if (isDisabled !== isDisabledInState && !hasBulkSelection) dispatch((0, $cN0WI.setIsTableDisabled)(isDisabled || false));
    }, [
        actions,
        columns,
        columnsInState,
        currentPage,
        currentPageInState,
        dispatch,
        hasBulkSelection,
        isDisabled,
        isDisabledInState,
        issueKeys,
        issueKeysInState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (onIssueViewTransition && onIssueViewTransition !== onIssueViewTransitionInState) dispatch((0, $cN0WI.setOnIssueViewTransition)(onIssueViewTransition));
    }, [
        dispatch,
        onIssueViewTransition,
        onIssueViewTransitionInState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        useJSMQueueDurationEvent && dispatch((0, $cN0WI.setJSMQueueDurationEvent)(useJSMQueueDurationEvent));
    }, [
        dispatch,
        useJSMQueueDurationEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        renderSidebarIcon && dispatch((0, $cN0WI.setRenderSidebarIcon)(renderSidebarIcon));
    }, [
        dispatch,
        renderSidebarIcon
    ]);
    (0, $eJOHy.useEffect)(()=>{
        refreshSidebar && dispatch((0, $cN0WI.setRefreshSidebar)(refreshSidebar));
    }, [
        dispatch,
        refreshSidebar
    ]);
    return null;
};
class $a3cba0e65f4c8cc7$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    focusContent() {
        this.tableFocusFunction && this.tableFocusFunction();
    }
    scrollToTop() {
        this.tableRef && this.tableRef.resetVerticalScrollOffset();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8toaC.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dUugX.AsyncFlagsDispatcher), {
            store: this.store,
            mapper: (0, $caBl1.default)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3cba0e65f4c8cc7$var$BulkSelectionAwareTableStateUpdater, {
            store: this.store,
            tableProps: this.props
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4E6uF.default), {
            ...this.props,
            tableRef: this.onSetTableRef,
            onTableFocusFunctionChanged: this.onTableFocusFunctionChanged,
            onTableRefChanged: this.onTableRefChanged
        })));
    }
    constructor(...args){
        super(...args), this.onTableFocusFunctionChanged = (tableFocusFunction)=>{
            this.tableFocusFunction = tableFocusFunction;
        }, this.onTableRefChanged = (ref)=>{
            this.store.dispatch((0, $3fOWJ.setRowListRefAction)(ref));
        }, this.onSetTableRef = (ref)=>{
            this.tableRef = ref;
        }, this.store = (0, $8toaC.createStore)((0, $jkdXW.default), {
            initialAppProps: this.props.appProps,
            ui: {
                ...(0, $j3i8l.DEFAULT_STATE),
                onIssueViewTransition: this.props.onIssueViewTransition,
                useJSMQueueDurationEvent: this.props.useJSMQueueDurationEvent,
                getIssueLinkOverride: this.props.getIssueLinkOverride
            },
            persisted: {
                columns: false ? this.props.columns : [],
                providedIssueKeys: this.props.issueKeys,
                lockedIssues: {},
                offsets: {
                    verticalScrollOffset: 0,
                    horizontalScrollOffset: 0
                },
                rowListRef: undefined
            }
        });
    }
}

});
parcelRegister("caBl1", function(module, exports) {

$parcel$export(module.exports, "default", () => $128fc6d38aa2538a$export$2e2bcd8739ae039);

var $4Jmvl = parcelRequire("4Jmvl");

var $cN0WI = parcelRequire("cN0WI");

var $8m3tC = parcelRequire("8m3tC");

var $2lrtP = parcelRequire("2lrtP");
const $128fc6d38aa2538a$var$decodeFailure = (stringThatMayBeJson)=>{
    try {
        const obj = JSON.parse(stringThatMayBeJson);
        if (obj.errorMessages && obj.errorMessages[0]) return obj.errorMessages[0];
        if (obj.errors) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return Object.values(obj.errors)[0];
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return stringThatMayBeJson;
    }
};
// @ts-expect-error - TS7006 - Parameter 'failureReason' implicitly has an 'any' type.
const $128fc6d38aa2538a$var$isPresentableFailureReason = (failureReason)=>failureReason.statusCode && failureReason.message && failureReason.message.indexOf(`: ${failureReason.statusCode}`) === -1;
const $128fc6d38aa2538a$var$flagsMapper = (action)=>{
    switch(action.type){
        case 0, $4Jmvl.FIELD_UPDATE_FAILURE:
            {
                const { fieldName: fieldName, issueKey: issueKey, failureReason: failureReason } = action.payload;
                return (0, $2lrtP.default)({
                    fieldName: fieldName,
                    issueKey: issueKey,
                    reasonMessage: failureReason.message && $128fc6d38aa2538a$var$isPresentableFailureReason(failureReason) ? $128fc6d38aa2538a$var$decodeFailure(failureReason.message) : undefined
                });
            }
        case 0, $cN0WI.DISABLE_USER_PICKER:
            return (0, $8m3tC.default)();
        default:
            {
                const _exhaustiveCheck = action;
                return undefined;
            }
    }
};
var $128fc6d38aa2538a$export$2e2bcd8739ae039 = $128fc6d38aa2538a$var$flagsMapper;

});
parcelRegister("4Jmvl", function(module, exports) {

$parcel$export(module.exports, "FIELD_UPDATE_SUBMIT", () => $4fa7cd1300e0416f$export$d8a6a3dbb4cd0e2b);
$parcel$export(module.exports, "submitFieldUpdateAction", () => $4fa7cd1300e0416f$export$94f231b4f54796b);
$parcel$export(module.exports, "updateFieldSuccessAction", () => $4fa7cd1300e0416f$export$cf3e633d76bec1c0);
$parcel$export(module.exports, "ERROR_RESPONSE", () => $4fa7cd1300e0416f$export$e7c20800d1dc6c31);
$parcel$export(module.exports, "FIELD_UPDATE_FAILURE", () => $4fa7cd1300e0416f$export$f6339a854154c99e);
$parcel$export(module.exports, "updateFieldFailureErrorResponseAction", () => $4fa7cd1300e0416f$export$80effa926bcee3a6);
// LOCK_FIELD
const $4fa7cd1300e0416f$export$d8a6a3dbb4cd0e2b = 'state.actions.field.update.FIELD_UPDATE_SUBMIT';
const $4fa7cd1300e0416f$export$94f231b4f54796b = (issueKey, fieldId, fieldValue, onSuccess, onFailure)=>({
        type: $4fa7cd1300e0416f$export$d8a6a3dbb4cd0e2b,
        payload: {
            issueKey: issueKey,
            fieldId: fieldId,
            fieldValue: fieldValue,
            onSuccess: onSuccess,
            onFailure: onFailure
        }
    });
const $4fa7cd1300e0416f$export$4374b1b680dead41 = 'state.actions.field.update.FIELD_UPDATE_SUCCESS';
const $4fa7cd1300e0416f$export$cf3e633d76bec1c0 = (issueKey, fieldId)=>({
        type: $4fa7cd1300e0416f$export$4374b1b680dead41,
        payload: {
            issueKey: issueKey,
            fieldId: fieldId
        }
    });
const $4fa7cd1300e0416f$export$e7c20800d1dc6c31 = 'ERROR_RESPONSE';
const $4fa7cd1300e0416f$export$f6339a854154c99e = 'state.actions.field.update.FIELD_UPDATE_FAILURE';
const $4fa7cd1300e0416f$export$80effa926bcee3a6 = (issueKey, fieldId, fieldType, fieldName, error)=>({
        type: $4fa7cd1300e0416f$export$f6339a854154c99e,
        payload: {
            issueKey: issueKey,
            fieldId: fieldId,
            fieldType: fieldType,
            fieldName: fieldName,
            failureReason: {
                type: $4fa7cd1300e0416f$export$e7c20800d1dc6c31,
                statusCode: error.statusCode,
                message: error.message
            }
        }
    });

});

parcelRegister("cN0WI", function(module, exports) {

$parcel$export(module.exports, "SHOW_PAGINATION", () => $27cd4fe3006c8053$export$5d9390342a7644ac);
$parcel$export(module.exports, "setPaginationVisibility", () => $27cd4fe3006c8053$export$c1bc18f3f5aacbab);
$parcel$export(module.exports, "SET_EDITING_FIELD_POSITION", () => $27cd4fe3006c8053$export$c89eb1efa157bec9);
$parcel$export(module.exports, "setEditingFieldPositionAction", () => $27cd4fe3006c8053$export$300d660c6d75f0cc);
$parcel$export(module.exports, "SET_CURRENT_PAGE", () => $27cd4fe3006c8053$export$483508f263cba397);
$parcel$export(module.exports, "setCurrentPageAction", () => $27cd4fe3006c8053$export$6f9713cf11255bd4);
$parcel$export(module.exports, "SET_IS_TABLE_DISABLED", () => $27cd4fe3006c8053$export$a871a4533fe0415c);
$parcel$export(module.exports, "setIsTableDisabled", () => $27cd4fe3006c8053$export$adbd404608132b43);
$parcel$export(module.exports, "DISABLE_USER_PICKER", () => $27cd4fe3006c8053$export$a3bc24c2e3b7c2a2);
$parcel$export(module.exports, "disableUserPickerAction", () => $27cd4fe3006c8053$export$da8d58cd19fa9174);
$parcel$export(module.exports, "SET_ON_ISSUE_VIEW_TRANSITION", () => $27cd4fe3006c8053$export$91f1228c532af4);
$parcel$export(module.exports, "setOnIssueViewTransition", () => $27cd4fe3006c8053$export$fa4a37077fc8610b);
$parcel$export(module.exports, "SET_JSM_QUEUE_DURATION_EVENT", () => $27cd4fe3006c8053$export$c00a50fc22eee33c);
$parcel$export(module.exports, "setJSMQueueDurationEvent", () => $27cd4fe3006c8053$export$834790f742597c01);
$parcel$export(module.exports, "SET_RENDER_SIDE_BAR_ICON", () => $27cd4fe3006c8053$export$9699e624bf23e2bb);
$parcel$export(module.exports, "setRenderSidebarIcon", () => $27cd4fe3006c8053$export$28433d58f8f5bf2);
$parcel$export(module.exports, "SET_REFRESH_SIDE_BAR", () => $27cd4fe3006c8053$export$dd236613845bdbce);
$parcel$export(module.exports, "setRefreshSidebar", () => $27cd4fe3006c8053$export$a6ee15011295b023);
const $27cd4fe3006c8053$export$5d9390342a7644ac = 'state.actions.ui.SHOW_PAGINATION';
const $27cd4fe3006c8053$export$c1bc18f3f5aacbab = (payload)=>({
        type: $27cd4fe3006c8053$export$5d9390342a7644ac,
        payload: payload
    });
const $27cd4fe3006c8053$export$c89eb1efa157bec9 = 'state.actions.ui.SET_EDITING_FIELD_POSITION';
const $27cd4fe3006c8053$export$300d660c6d75f0cc = (horizontalOffset, verticalOffset, fieldWidth, tableWidth, tableHeight)=>({
        type: $27cd4fe3006c8053$export$c89eb1efa157bec9,
        payload: {
            horizontalOffset: horizontalOffset,
            verticalOffset: verticalOffset,
            fieldWidth: fieldWidth,
            tableWidth: tableWidth,
            tableHeight: tableHeight
        }
    });
const $27cd4fe3006c8053$export$483508f263cba397 = 'state.actions.ui.SET_CURRENT_PAGE';
const $27cd4fe3006c8053$export$6f9713cf11255bd4 = (payload)=>({
        type: $27cd4fe3006c8053$export$483508f263cba397,
        payload: payload
    });
const $27cd4fe3006c8053$export$a871a4533fe0415c = 'state.actions.ui.SET_IS_TABLE_DISABLED';
const $27cd4fe3006c8053$export$adbd404608132b43 = (isDisabled)=>({
        type: $27cd4fe3006c8053$export$a871a4533fe0415c,
        payload: isDisabled
    });
const $27cd4fe3006c8053$export$a3bc24c2e3b7c2a2 = 'state.actions.ui.DISABLE_USER_PICKER';
const $27cd4fe3006c8053$export$da8d58cd19fa9174 = ()=>({
        type: $27cd4fe3006c8053$export$a3bc24c2e3b7c2a2
    });
const $27cd4fe3006c8053$export$91f1228c532af4 = 'state.actions.ui.SET_ON_ISSUE_VIEW_TRANSITION';
const $27cd4fe3006c8053$export$fa4a37077fc8610b = (onIssueViewTransition)=>({
        type: $27cd4fe3006c8053$export$91f1228c532af4,
        payload: onIssueViewTransition
    });
const $27cd4fe3006c8053$export$c00a50fc22eee33c = 'state.actions.ui.SET_JSM_QUEUE_DURATION_EVENT';
const $27cd4fe3006c8053$export$834790f742597c01 = (useJSMQueueDurationEvent)=>({
        type: $27cd4fe3006c8053$export$c00a50fc22eee33c,
        payload: useJSMQueueDurationEvent
    });
const $27cd4fe3006c8053$export$9699e624bf23e2bb = 'state.actions.ui.SET_RENDER_SIDE_BAR_ICON';
const $27cd4fe3006c8053$export$28433d58f8f5bf2 = (renderSidebarIcon)=>({
        type: $27cd4fe3006c8053$export$9699e624bf23e2bb,
        payload: renderSidebarIcon
    });
const $27cd4fe3006c8053$export$dd236613845bdbce = 'state.actions.ui.SET_REFRESH_SIDE_BAR';
const $27cd4fe3006c8053$export$a6ee15011295b023 = (refreshSidebar)=>({
        type: $27cd4fe3006c8053$export$dd236613845bdbce,
        payload: refreshSidebar
    });

});

parcelRegister("8m3tC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c14f234a6db1e40$export$2e2bcd8739ae039);

var $2JQ4I = parcelRequire("2JQ4I");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4c14f234a6db1e40$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: (0, $2JQ4I.default).title,
        description: (0, $2JQ4I.default).description,
        messageId: 'issue-table.flags.field.assignee.error',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $2JQ4I.default).refresh,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            }
        ]
    });

});
parcelRegister("2JQ4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $04349a33f05a401a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $04349a33f05a401a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-table.flags.field.assignee.error.title",
        "defaultMessage": "Looks like there was a problem"
    },
    description: {
        "id": "issue-table.flags.field.assignee.error.description",
        "defaultMessage": "The assignee field cannot be edited. Try refreshing the page."
    },
    refresh: {
        "id": "issue-table.flags.field.assignee.error.refresh",
        "defaultMessage": "Refresh"
    }
});

});


parcelRegister("2lrtP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be918cf25d8daae$export$2e2bcd8739ae039);

var $b5pHB = parcelRequire("b5pHB");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6be918cf25d8daae$export$2e2bcd8739ae039 = ({ issueKey: issueKey, fieldName: fieldName, reasonMessage: reasonMessage })=>{
    if (reasonMessage) return {
        type: 'error',
        title: (0, $b5pHB.default).title,
        description: [
            (0, $b5pHB.default).description,
            {
                issueKey: issueKey,
                fieldName: fieldName.toLowerCase(),
                reasonMessage: reasonMessage
            }
        ],
        messageId: 'issue-table.flags.field.update.error',
        messageType: 'transactional'
    };
    return {
        messageId: 'issue-table.flags.field.update.error',
        messageType: 'transactional',
        type: 'error',
        title: (0, $b5pHB.default).title,
        description: [
            (0, $b5pHB.default).simpleDescription,
            {
                issueKey: issueKey,
                fieldName: fieldName.toLowerCase()
            }
        ]
    };
};

});
parcelRegister("b5pHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8a1d316560d21b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9b8a1d316560d21b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-table.flags.field.update.error.title",
        "defaultMessage": "Issue could not be updated"
    },
    description: {
        "id": "issue-table.flags.field.update.error.description",
        "defaultMessage": "The ''{fieldName}'' field of {issueKey} could not be updated. {reasonMessage}"
    },
    simpleDescription: {
        "id": "issue-table.flags.field.update.error.simple-description",
        "defaultMessage": "The ''{fieldName}'' field of {issueKey} could not be updated. Please try again later."
    }
});

});



parcelRegister("jkdXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c277ecde3ddd3360$export$2e2bcd8739ae039);
parcelRequire("c1D7V");

var $4tM8k = parcelRequire("4tM8k");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $kXNsM = parcelRequire("kXNsM");

var $cwrUj = parcelRequire("cwrUj");

var $g4mO1 = parcelRequire("g4mO1");

var $jsNbv = parcelRequire("jsNbv");

var $ipfNb = parcelRequire("ipfNb");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$c277ecde3ddd3360$export$2e2bcd8739ae039 = (action$, store)=>(0, $4tM8k.combineEpics)(...[
        (0, $g4mO1.default),
        (0, $cwrUj.default),
        (0, $ipfNb.default),
        (0, $jsNbv.default),
        (0, $kXNsM.default)
    ])(action$, store).catch((error, stream)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-table.ops', 'Unhandled error');
        (0, $gYnSx.default)({
            meta: {
                id: 'opsUnhandledError',
                packageName: 'jiraIssueTable',
                teamName: 'jsd-shield'
            },
            error: new Error(error)
        });
        return stream;
    });

});
parcelRegister("kXNsM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cf683ba81bc9774$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $eD3lT = parcelRequire("eD3lT");

var $cqACi = parcelRequire("cqACi");
var // @ts-expect-error - No overload matches this call
$4cf683ba81bc9774$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $cqACi.default), (0, $eD3lT.default));

});
parcelRegister("eD3lT", function(module, exports) {

$parcel$export(module.exports, "default", () => $74b842cbfb00c664$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("1AyD5");
parcelRequire("d2zWP");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $ljej9 = parcelRequire("ljej9");

var $dpmnN = parcelRequire("dpmnN");

var $987AO = parcelRequire("987AO");

var $cLGK3 = parcelRequire("cLGK3");

var $5IyBz = parcelRequire("5IyBz");

var $2f0m6 = parcelRequire("2f0m6");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$74b842cbfb00c664$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $987AO.UNLOCK_FIELD), (0, $987AO.LOCK_FIELD), (0, $987AO.UNLOCK_ALL_FIELDS), (0, $cLGK3.UPDATE_PROVIDED_ISSUE_KEYS)).switchMap(()=>{
        const state = store.getState();
        const selectionServiceActions = (0, $5IyBz.getSelectionServiceActions)(state);
        if (!selectionServiceActions) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-table.ops.bulk-select.refresh-selection', 'selectionServiceActions is not set.');
            (0, $gYnSx.default)({
                meta: {
                    id: 'opsRefreshSelection',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                }
            });
            return (0, $7kixv.Observable).empty();
        }
        const { refreshSelection: refreshSelection } = selectionServiceActions;
        const issues = (0, $2f0m6.mergeIssueKeysWithLockedIssues)(state);
        refreshSelection(issues.map((0, $ljej9.toIssueKey)));
        return (0, $7kixv.Observable).of((0, $dpmnN.setHasSelectionAction)({
            hasSelection: issues.length > 0
        }));
    });

});
parcelRegister("dpmnN", function(module, exports) {

$parcel$export(module.exports, "SELECT_ROW", () => $ca7265087190c24e$export$23dac9ed99690a9c);
$parcel$export(module.exports, "selectRowAction", () => $ca7265087190c24e$export$dd5cc62656892181);
$parcel$export(module.exports, "SET_LAST_CLICKED_ROW", () => $ca7265087190c24e$export$30e11d52d9d0165c);
$parcel$export(module.exports, "setLastClickedRowAction", () => $ca7265087190c24e$export$18aafbbe21119db1);
$parcel$export(module.exports, "SET_SELECTION_SERVICE_ACTIONS", () => $ca7265087190c24e$export$b0dea82abc030a23);
$parcel$export(module.exports, "setSelectionServiceActionsAction", () => $ca7265087190c24e$export$b43829a128a6202f);
$parcel$export(module.exports, "SET_HAS_SELECTION", () => $ca7265087190c24e$export$7e3b4dceab941566);
$parcel$export(module.exports, "setHasSelectionAction", () => $ca7265087190c24e$export$6647d68ebe704b97);
const $ca7265087190c24e$export$23dac9ed99690a9c = 'state.actions.bulk-selection.SELECT_ROW';
const $ca7265087190c24e$export$dd5cc62656892181 = (data, analyticsEvent)=>({
        type: $ca7265087190c24e$export$23dac9ed99690a9c,
        payload: data,
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $ca7265087190c24e$export$30e11d52d9d0165c = 'state.actions.bulk-selection.SET_LAST_CLICKED_ROW';
const $ca7265087190c24e$export$18aafbbe21119db1 = (data)=>({
        type: $ca7265087190c24e$export$30e11d52d9d0165c,
        payload: data
    });
const $ca7265087190c24e$export$b0dea82abc030a23 = 'state.actions.bulk-selection.SET_SELECTION_SERVICE_ACTIONS';
const $ca7265087190c24e$export$b43829a128a6202f = (data)=>({
        type: $ca7265087190c24e$export$b0dea82abc030a23,
        payload: data
    });
const $ca7265087190c24e$export$7e3b4dceab941566 = 'state.actions.bulk-selection.SET_HAS_SELECTION';
const $ca7265087190c24e$export$6647d68ebe704b97 = (data)=>({
        type: $ca7265087190c24e$export$7e3b4dceab941566,
        payload: data
    });

});

parcelRegister("987AO", function(module, exports) {

$parcel$export(module.exports, "LOCK_FIELD", () => $bba9934b1a4eb5d3$export$9577624537ff74ab);
$parcel$export(module.exports, "lockFieldAction", () => $bba9934b1a4eb5d3$export$293db56aa8facb7a);
$parcel$export(module.exports, "UNLOCK_FIELD", () => $bba9934b1a4eb5d3$export$aa4a28625eb23c44);
$parcel$export(module.exports, "unlockFieldAction", () => $bba9934b1a4eb5d3$export$539db32098e03442);
$parcel$export(module.exports, "UNLOCK_ALL_FIELDS", () => $bba9934b1a4eb5d3$export$43011103b4549dc1);
$parcel$export(module.exports, "unlockAllFieldsAction", () => $bba9934b1a4eb5d3$export$4db21b2c60d7d96);
// LOCK_FIELD
const $bba9934b1a4eb5d3$export$9577624537ff74ab = 'state.actions.field.lock.LOCK_FIELD';
const $bba9934b1a4eb5d3$export$293db56aa8facb7a = (issueKey, fieldId, positionIndex)=>({
        type: $bba9934b1a4eb5d3$export$9577624537ff74ab,
        payload: {
            issueKey: issueKey,
            positionIndex: positionIndex,
            fieldId: fieldId
        }
    });
const $bba9934b1a4eb5d3$export$aa4a28625eb23c44 = 'state.actions.field.lock.UNLOCK_FIELD';
const $bba9934b1a4eb5d3$export$539db32098e03442 = (issueKey, fieldId)=>({
        type: $bba9934b1a4eb5d3$export$aa4a28625eb23c44,
        payload: {
            issueKey: issueKey,
            fieldId: fieldId
        }
    });
const $bba9934b1a4eb5d3$export$43011103b4549dc1 = 'state.actions.field.lock.UNLOCK_ALL_FIELDS';
const $bba9934b1a4eb5d3$export$4db21b2c60d7d96 = ()=>({
        type: $bba9934b1a4eb5d3$export$43011103b4549dc1
    });

});

parcelRegister("cLGK3", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PROVIDED_ISSUE_KEYS", () => $bb49738c584d2807$export$c3876599022b4e78);
$parcel$export(module.exports, "updateProvidedIssueKeysAction", () => $bb49738c584d2807$export$7435108bc993705e);
$parcel$export(module.exports, "ISSUE_EDIT_STARTED", () => $bb49738c584d2807$export$1e3bdce3d6fbd74a);
$parcel$export(module.exports, "issueEditStartedAction", () => $bb49738c584d2807$export$f5109cd21d1574dd);
const $bb49738c584d2807$export$c3876599022b4e78 = 'state.actions.issues.UPDATE_PROVIDED_ISSUE_KEYS';
const $bb49738c584d2807$export$7435108bc993705e = (issueKeys)=>({
        type: $bb49738c584d2807$export$c3876599022b4e78,
        payload: {
            issueKeys: issueKeys
        }
    });
const $bb49738c584d2807$export$1e3bdce3d6fbd74a = 'state.actions.issues.ISSUE_EDIT_STARTED';
const $bb49738c584d2807$export$f5109cd21d1574dd = (fieldType, issueKey, analyticsEvent)=>({
        type: $bb49738c584d2807$export$1e3bdce3d6fbd74a,
        payload: {
            issueKey: issueKey,
            fieldType: fieldType
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("5IyBz", function(module, exports) {

$parcel$export(module.exports, "getLastClickedRow", () => $d377635fce74d906$export$ec93017dc2536f2e);
$parcel$export(module.exports, "getSelectionServiceActions", () => $d377635fce74d906$export$e9a1d97035e6d261);
const $d377635fce74d906$export$ec93017dc2536f2e = (state)=>state.bulkSelection.lastClickedRow;
const $d377635fce74d906$export$e9a1d97035e6d261 = (state)=>state.bulkSelection.selectionServiceActions;
const $d377635fce74d906$export$2cf0f4905f25f4a4 = (state)=>state.bulkSelection.hasSelection;

});

parcelRegister("2f0m6", function(module, exports) {

$parcel$export(module.exports, "getProvidedIssueKeys", () => $56a21408f29a9c67$export$af07af04b01adfd5);
$parcel$export(module.exports, "mergeIssueKeysWithLockedIssues", () => $56a21408f29a9c67$export$12a917ff04fbe0e8);
$parcel$export(module.exports, "getAllKnownIssueKeys", () => $56a21408f29a9c67$export$ef16b3729204077d);
$parcel$export(module.exports, "getIssueKeyPositionIndex", () => $56a21408f29a9c67$export$7424fd062ec0b8e4);
$parcel$export(module.exports, "isIssueKnown", () => $56a21408f29a9c67$export$46d566aafca01d9e);

var $ahm5r = parcelRequire("ahm5r");

var $8dH3d = parcelRequire("8dH3d");

var $80xRm = parcelRequire("80xRm");

var $LFmXM = parcelRequire("LFmXM");

var $ljej9 = parcelRequire("ljej9");

var $lhJwW = parcelRequire("lhJwW");

var $coQbr = parcelRequire("coQbr");

var $j1K0Y = parcelRequire("j1K0Y");
const $56a21408f29a9c67$export$af07af04b01adfd5 = (state)=>(0, $lhJwW.getPersisted)(state).providedIssueKeys;
const $56a21408f29a9c67$export$48c3724a62ab72dc = (0, $LFmXM.default)((0, $j1K0Y.getIndexesOfStringArray));
const $56a21408f29a9c67$var$areLockedIssuesAlreadyInPosition = (lockedIssuesByKey, originalIssueKeys)=>Object.entries(lockedIssuesByKey).every(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    ([issueKey, lockedIssue])=>originalIssueKeys[lockedIssue.positionIndex] === issueKey);
const $56a21408f29a9c67$var$desparsify = (issueKeys)=>{
    const resultArray = [];
    issueKeys.forEach((issueKey, positionIndex)=>resultArray.push({
            issueKey: issueKey,
            positionIndex: positionIndex
        }));
    return resultArray;
};
const $56a21408f29a9c67$export$12a917ff04fbe0e8 = (0, $ahm5r.createSelector)((0, $coQbr.getLockedIssues), $56a21408f29a9c67$export$af07af04b01adfd5, (lockedIssuesByKey, originalIssueKeys)=>{
    // Performance shortcut
    if ($56a21408f29a9c67$var$areLockedIssuesAlreadyInPosition(lockedIssuesByKey, originalIssueKeys)) return originalIssueKeys;
    const resultIssueKeys = [];
    const originalIssueKeysIterator = new (0, $j1K0Y.IteratorWrapper)($56a21408f29a9c67$var$desparsify(originalIssueKeys));
    const lockedRowsIterator = new (0, $j1K0Y.IteratorWrapper)((0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(lockedIssuesByKey, (lockedIssue)=>lockedIssue.positionIndex));
    let issueIndexOffset = 0;
    let newArrayLength = originalIssueKeys.length + issueIndexOffset;
    do {
        const nextIssue = originalIssueKeysIterator.current;
        const nextLockedIssue = lockedRowsIterator.current;
        if (nextIssue.done) {
            if (!nextLockedIssue.done) {
                const latestPossibleInsertionPoint = Math.min(nextLockedIssue.value.positionIndex, newArrayLength);
                resultIssueKeys[latestPossibleInsertionPoint] = nextLockedIssue.value.issueKey;
                lockedRowsIterator.next();
                issueIndexOffset += 1;
            }
        } else {
            const realNextIssueIndex = nextIssue.value.positionIndex + issueIndexOffset;
            if (nextLockedIssue.done) {
                if (!lockedIssuesByKey[nextIssue.value.issueKey]) resultIssueKeys[realNextIssueIndex] = nextIssue.value.issueKey;
                else issueIndexOffset -= 1;
                originalIssueKeysIterator.next();
            } else if (realNextIssueIndex >= nextLockedIssue.value.positionIndex) {
                if (realNextIssueIndex === nextLockedIssue.value.positionIndex && nextLockedIssue.value.issueKey === nextIssue.value.issueKey) {
                    resultIssueKeys[nextLockedIssue.value.positionIndex] = nextLockedIssue.value.issueKey;
                    originalIssueKeysIterator.next();
                    lockedRowsIterator.next();
                } else {
                    resultIssueKeys[nextLockedIssue.value.positionIndex] = nextLockedIssue.value.issueKey;
                    lockedRowsIterator.next();
                    issueIndexOffset += 1;
                }
            } else if (lockedIssuesByKey[nextIssue.value.issueKey]) {
                originalIssueKeysIterator.next();
                issueIndexOffset -= 1;
            } else {
                resultIssueKeys[realNextIssueIndex] = nextIssue.value.issueKey;
                originalIssueKeysIterator.next();
            }
        }
        newArrayLength = originalIssueKeys.length + issueIndexOffset;
    }while (!originalIssueKeysIterator.current.done || !lockedRowsIterator.current.done);
    resultIssueKeys.length = Math.max(0, newArrayLength);
    return resultIssueKeys;
});
const $56a21408f29a9c67$export$ef16b3729204077d = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $56a21408f29a9c67$export$12a917ff04fbe0e8(state).reduce((result, issueKey)=>{
        !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(issueKey) && result.push((0, $ljej9.toIssueKey)(issueKey));
        return result;
    }, []);
const $56a21408f29a9c67$export$7424fd062ec0b8e4 = (0, $ahm5r.createSelector)($56a21408f29a9c67$export$12a917ff04fbe0e8, // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type. | TS7006 - Parameter 'issueKeyToFind' implicitly has an 'any' type.
(state, issueKeyToFind)=>issueKeyToFind, (issueKeys, issueKeyToFind)=>$56a21408f29a9c67$export$48c3724a62ab72dc(issueKeys)[issueKeyToFind]);
const $56a21408f29a9c67$export$46d566aafca01d9e = (state, issueKey)=>$56a21408f29a9c67$export$7424fd062ec0b8e4(state, issueKey) !== undefined;

});
parcelRegister("lhJwW", function(module, exports) {

$parcel$export(module.exports, "getPersisted", () => $73bf1fbea92bfd43$export$5239a0a7977ca4de);
$parcel$export(module.exports, "getFieldInitialization", () => $73bf1fbea92bfd43$export$4b5927991797d9ed);
$parcel$export(module.exports, "getInitialAppProps", () => $73bf1fbea92bfd43$export$776ca926a037ba63);
const $73bf1fbea92bfd43$export$5239a0a7977ca4de = (state)=>state.persisted;
const $73bf1fbea92bfd43$export$4b5927991797d9ed = (state)=>state.fieldInitialization;
const $73bf1fbea92bfd43$export$776ca926a037ba63 = (state)=>state.initialAppProps;

});

parcelRegister("coQbr", function(module, exports) {

$parcel$export(module.exports, "getLockedIssues", () => $427ed880b43a6814$export$a17d008b40b9a206);
$parcel$export(module.exports, "getLockedIssueCountAssumingIssueKeyWillBeLocked", () => $427ed880b43a6814$export$d1184755c39ce1f8);
$parcel$export(module.exports, "getIsFieldLocked", () => $427ed880b43a6814$export$3954fe8afa4b46a);

var $lhJwW = parcelRequire("lhJwW");
const $427ed880b43a6814$export$a17d008b40b9a206 = (state)=>(0, $lhJwW.getPersisted)(state).lockedIssues;
const $427ed880b43a6814$export$d1184755c39ce1f8 = (state, issueKey)=>{
    const issueKeys = Object.keys($427ed880b43a6814$export$a17d008b40b9a206(state));
    issueKeys.push(issueKey);
    return new Set(issueKeys).size;
};
const $427ed880b43a6814$export$3954fe8afa4b46a = (state, props)=>{
    const { issueKey: issueKey, fieldDescriptor: { fieldId: fieldId } } = props;
    const lockedIssue = $427ed880b43a6814$export$a17d008b40b9a206(state)[issueKey];
    return lockedIssue && !!lockedIssue.fields[fieldId];
};

});

parcelRegister("j1K0Y", function(module, exports) {

$parcel$export(module.exports, "getIndexesOfStringArray", () => $ad3d892c83557a2f$export$2b158dd2191953a2);
$parcel$export(module.exports, "IteratorWrapper", () => $ad3d892c83557a2f$export$8dbb1a760abb7548);
const $ad3d892c83557a2f$export$2b158dd2191953a2 = (issueKeys)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const positionIndexByIssueKey = {};
    issueKeys.forEach((value, index)=>{
        positionIndexByIssueKey[value] = index;
    });
    return positionIndexByIssueKey;
};
class $ad3d892c83557a2f$export$8dbb1a760abb7548 {
    constructor(sourceArray){
        this.iterator = sourceArray.values();
        // @ts-expect-error - TS2322 - Type 'IteratorResult<T, any>' is not assignable to type 'IteratorResult<T>'.
        this.current = this.iterator.next();
        this.lastNonDoneValue = this.current.done ? undefined : this.current.value;
    }
    next() {
        // @ts-expect-error - TS2322 - Type 'IteratorResult<T, any>' is not assignable to type 'IteratorResult<T>'.
        this.current = this.iterator.next();
        return this.current;
    }
}

});



parcelRegister("cqACi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e94d564b4addd14$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("1AyD5");
parcelRequire("d2zWP");

var $80xRm = parcelRequire("80xRm");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $ljej9 = parcelRequire("ljej9");

var $dpmnN = parcelRequire("dpmnN");

var $5IyBz = parcelRequire("5IyBz");

var $2f0m6 = parcelRequire("2f0m6");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$7e94d564b4addd14$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $dpmnN.SELECT_ROW)).switchMap((action)=>{
        const state = store.getState();
        const selectionServiceActions = (0, $5IyBz.getSelectionServiceActions)(state);
        if (!selectionServiceActions) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-table.ops.bulk-select.select-rows', 'selectionServiceActions is not set.');
            (0, $gYnSx.default)({
                meta: {
                    id: 'opsSelectRows',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                }
            });
            return (0, $7kixv.Observable).empty();
        }
        const { selectIssues: selectIssues, deselectIssues: deselectIssues } = selectionServiceActions;
        const { rowId: rowId, selection: selection, isShiftKeyDown: isShiftKeyDown } = action.payload;
        const { analyticsEvent: analyticsEvent } = action.meta;
        const lastClickedRow = (0, $5IyBz.getLastClickedRow)(state);
        if (isShiftKeyDown && !!lastClickedRow) {
            const allIssues = (0, $2f0m6.getAllKnownIssueKeys)(state);
            const [start, end] = (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))([
                allIssues.indexOf((0, $ljej9.toIssueKey)(rowId)),
                allIssues.indexOf((0, $ljej9.toIssueKey)(lastClickedRow))
            ]);
            const issuesIncluded = allIssues.slice(start, end + 1);
            (selection ? selectIssues : deselectIssues)(issuesIncluded, analyticsEvent);
            return (0, $7kixv.Observable).of((0, $dpmnN.setLastClickedRowAction)({
                rowId: rowId
            }));
        }
        (selection ? selectIssues : deselectIssues)([
            (0, $ljej9.toIssueKey)(rowId)
        ], analyticsEvent);
        return (0, $7kixv.Observable).of((0, $dpmnN.setLastClickedRowAction)({
            rowId: rowId
        }));
    });

});


parcelRegister("cwrUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $062ade17bdd36e85$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $bjhhD = parcelRequire("bjhhD");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$062ade17bdd36e85$export$2e2bcd8739ae039 = (action$, store)=>(0, $4tM8k.combineEpics)((0, $bjhhD.default)())(action$, store);

});
parcelRegister("bjhhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f106447cbf2f42a$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");
parcelRequire("ewPaU");
parcelRequire("d2zWP");

var $iN885 = parcelRequire("iN885");

var $cSj0h = parcelRequire("cSj0h");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9f106447cbf2f42a$export$2e2bcd8739ae039 = ()=>{
    const initializeActionDispatchedFields = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (action$)=>action$.ofType((0, $iN885.UPDATE_COLUMNS)).switchMap((action)=>{
            const initializationColumnsArray = action.payload.columns// @ts-expect-error - TS7006 - Parameter 'columnProp' implicitly has an 'any' type.
            .filter((columnProp)=>{
                const fieldConfiguration = (0, $cSj0h.getJsonColumnConfiguration)(columnProp.fieldType);
                return fieldConfiguration && fieldConfiguration.needsInitialization;
            })// @ts-expect-error - TS7006 - Parameter 'columnProp' implicitly has an 'any' type.
            .filter((columnProp)=>{
                const fieldIdSet = initializeActionDispatchedFields[columnProp.fieldType];
                const needsInitialize = !fieldIdSet || !fieldIdSet.has(columnProp.id);
                if (fieldIdSet) fieldIdSet.add(columnProp.id);
                else initializeActionDispatchedFields[columnProp.fieldType] = new Set([
                    columnProp.id
                ]);
                return needsInitialize;
            }).map((0, $iN885.initializeColumnAction));
            return (0, $7kixv.Observable).from(initializationColumnsArray);
        });
};

});
parcelRegister("iN885", function(module, exports) {

$parcel$export(module.exports, "UPDATE_COLUMNS", () => $ecd51118c117fb6d$export$c9ad0e7c9c02af77);
$parcel$export(module.exports, "updateColumnsAction", () => $ecd51118c117fb6d$export$3d6d47022c85b605);
$parcel$export(module.exports, "INITIALIZE_COLUMN", () => $ecd51118c117fb6d$export$8531a79f419258d8);
$parcel$export(module.exports, "initializeColumnAction", () => $ecd51118c117fb6d$export$12f5c79cbb2fd6b4);
const $ecd51118c117fb6d$export$c9ad0e7c9c02af77 = 'state.actions.columns.UPDATE_COLUMNS';
const $ecd51118c117fb6d$export$3d6d47022c85b605 = (columns)=>({
        type: $ecd51118c117fb6d$export$c9ad0e7c9c02af77,
        payload: {
            columns: columns
        }
    });
const $ecd51118c117fb6d$export$8531a79f419258d8 = 'state.actions.columns.INITIALIZE_COLUMN';
const $ecd51118c117fb6d$export$12f5c79cbb2fd6b4 = (column)=>({
        type: $ecd51118c117fb6d$export$8531a79f419258d8,
        payload: {
            column: column
        }
    });

});

parcelRegister("cSj0h", function(module, exports) {

$parcel$export(module.exports, "getJsonColumnConfiguration", () => $f90c39f7ded50e01$export$34c320c31bc4122b);
$parcel$export(module.exports, "default", () => $f90c39f7ded50e01$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $9Dhvc = parcelRequire("9Dhvc");

var $4QehB = parcelRequire("4QehB");

var $fMEaU = parcelRequire("fMEaU");

var $7XoO0 = parcelRequire("7XoO0");

var $7gc68 = parcelRequire("7gc68");

var $60TLL = parcelRequire("60TLL");
const $f90c39f7ded50e01$var$getAdditionalColumnWidth = (index, totalColumns)=>(index > 0 ? (0, $7gc68.COLUMN_GUTTER).left : 0) + (index < totalColumns - 1 ? (0, $7gc68.COLUMN_GUTTER).right : 0);
const $f90c39f7ded50e01$var$finaliseColumnConfiguration = (config, index, totalColumns)=>{
    const additionalWidth = $f90c39f7ded50e01$var$getAdditionalColumnWidth(index, totalColumns);
    return (0, $iWqim.chain)(config)// @ts-expect-error - TS2571 - Object is of type 'unknown'.
    .updateIn([
        'minWidth'
    ], (minWidth)=>Math.max((0, $4QehB.MIN_WIDTH), minWidth + additionalWidth))// @ts-expect-error - TS2571 - Object is of type 'unknown'.
    .updateIn([
        'maxWidth'
    ], (maxWidth)=>Math.max((0, $4QehB.MIN_WIDTH), maxWidth + additionalWidth)).value();
};
const $f90c39f7ded50e01$var$getKnownFieldType = (fieldType)=>// @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'keyof DataSelectorPropsMap | null'.
    (0, $4QehB.BUILTIN_COLUMN_CONFIGURATIONS)[fieldType] ? fieldType : null;
const $f90c39f7ded50e01$export$34c320c31bc4122b = (fieldType)=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))((0, $4QehB.BUILTIN_COLUMN_CONFIGURATIONS), fieldType);
const $f90c39f7ded50e01$var$getJsonColumnProps = (fieldType, columnProps)=>{
    const builtinJsonColumnConfiguration = $f90c39f7ded50e01$export$34c320c31bc4122b(fieldType);
    return {
        ...builtinJsonColumnConfiguration,
        fieldId: columnProps.id,
        fieldType: fieldType
    };
};
const $f90c39f7ded50e01$var$getHtmlColumnProps = (columnProps)=>{
    const { fieldType: fieldType } = columnProps;
    const columnConfiguration = (0, $4QehB.BUILTIN_HTML_COLUMN_CONFIGURATIONS)[fieldType] || (0, $4QehB.FALLBACK_COLUMN_CONFIGURATION);
    return {
        ...columnConfiguration,
        fieldId: columnProps.id,
        fieldType: fieldType
    };
};
const $f90c39f7ded50e01$var$transformJsonColumnProps = (fieldType, columnProps, FieldDataSelector, HeaderComponent, createCell)=>{
    const { id: id, title: title } = columnProps;
    const mergedColumnProps = $f90c39f7ded50e01$var$getJsonColumnProps(fieldType, columnProps);
    const { minWidth: minWidth, maxWidth: maxWidth, canBeMultiLine: canBeMultiLine, FieldComponent: FieldComponent } = mergedColumnProps;
    const jsonComponentArgs = {
        fieldType: fieldType,
        FieldComponent: FieldComponent
    };
    return {
        id: id,
        title: title,
        minWidth: columnProps.minWidth || minWidth,
        maxWidth: columnProps.maxWidth || maxWidth,
        canBeMultiLine: canBeMultiLine,
        // @ts-expect-error - TS2345 - Argument of type '{ fieldType: T; FieldComponent: ComponentType<JsonComponentProps<T>>; }' is not assignable to parameter of type 'JsonComponentArgs<keyof DataSelectorPropsMap>'.
        CellComponent: createCell(jsonComponentArgs, mergedColumnProps, FieldDataSelector),
        HeaderComponent: HeaderComponent
    };
};
const $f90c39f7ded50e01$var$transformHtmlColumnProps = (// @ts-expect-error - TS7006 - Parameter 'columnProps' implicitly has an 'any' type.
columnProps, FieldDataSelector, HeaderComponent, createCell)=>{
    const { id: id, title: title } = columnProps;
    const mergedColumnProps = $f90c39f7ded50e01$var$getHtmlColumnProps(columnProps);
    const { minWidth: minWidth, maxWidth: maxWidth, canBeMultiLine: canBeMultiLine } = mergedColumnProps;
    return {
        id: id,
        title: title,
        minWidth: columnProps.minWidth || minWidth,
        maxWidth: columnProps.maxWidth || maxWidth,
        canBeMultiLine: canBeMultiLine,
        CellComponent: createCell(null, mergedColumnProps, FieldDataSelector),
        HeaderComponent: HeaderComponent
    };
};
const $f90c39f7ded50e01$export$6e8deebce7129a99 = (FieldDataSelector, columns, createCell)=>columns.map((column)=>{
        const knownFieldType = $f90c39f7ded50e01$var$getKnownFieldType(column.fieldType);
        if (column.fieldType === 'checkbox') return {
            id: 'checkbox',
            title: '',
            minWidth: 25,
            maxWidth: 25,
            CellComponent: (0, $7XoO0.default),
            HeaderComponent: (0, $fMEaU.default)
        };
        if (knownFieldType) return $f90c39f7ded50e01$var$transformJsonColumnProps(knownFieldType, column, FieldDataSelector, // @ts-expect-error - Argument of type 'ConnectedComponent<ComponentType<any>, { [x: string]: any; [x: number]: any; [x: symbol]: any; context?: Context<ReactReduxContextValue<any, AnyAction>> | undefined; store?: Store<...> | undefined; } | { ...; }>' is not assignable to parameter of type 'ComponentType<HeaderComponentProps>'.
        (0, $60TLL.default), createCell);
        return $f90c39f7ded50e01$var$transformHtmlColumnProps(column, FieldDataSelector, // @ts-expect-error - Argument of type 'ConnectedComponent<ComponentType<any>, { [x: string]: any; [x: number]: any; [x: symbol]: any; context?: Context<ReactReduxContextValue<any, AnyAction>> | undefined; store?: Store<...> | undefined; } | { ...; }>' is not assignable to parameter of type 'ComponentType<HeaderComponentProps>'.
        (0, $60TLL.default), createCell);
    })// @ts-expect-error - TS2345 - Argument of type '(column: TableColumn, index: number) => TableColumn' is not assignable to parameter of type '(value: { id: any; title: any; minWidth: any; maxWidth: any; canBeMultiLine: boolean | undefined; CellComponent: CellComponentType; HeaderComponent: ComponentType<HeaderComponentProps>; } | { ...; }, index: number, array: ({ ...; } | { ...; })[]) => TableColumn'.
    .map((column, index)=>$f90c39f7ded50e01$var$finaliseColumnConfiguration(column, index, columns.length));
var $f90c39f7ded50e01$export$2e2bcd8739ae039 = $f90c39f7ded50e01$export$6e8deebce7129a99;

});
parcelRegister("4QehB", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_COLUMN_CONFIGURATION", () => $0b5bb75eec0fd814$export$9b544c2606a30a3a);
$parcel$export(module.exports, "MIN_WIDTH", () => $0b5bb75eec0fd814$export$1d9fdc71b83a8eac);
$parcel$export(module.exports, "BUILTIN_COLUMN_CONFIGURATIONS", () => $0b5bb75eec0fd814$export$a7c09d12ef8597c0);
$parcel$export(module.exports, "BUILTIN_HTML_COLUMN_CONFIGURATIONS", () => $0b5bb75eec0fd814$export$9f3c8ab747beea8);

var $iWqim = parcelRequire("iWqim");

var $dPMMf = parcelRequire("dPMMf");



var $8ULSA = parcelRequire("8ULSA");

var $dGEw9 = parcelRequire("dGEw9");

var $4lvo5 = parcelRequire("4lvo5");

var $eQ9Cm = parcelRequire("eQ9Cm");

var $bsplE = parcelRequire("bsplE");

var $6hnhp = parcelRequire("6hnhp");

var $3YrDW = parcelRequire("3YrDW");

var $71Yrd = parcelRequire("71Yrd");

var $8JSWU = parcelRequire("8JSWU");

var $16gLw = parcelRequire("16gLw");

var $59u8X = parcelRequire("59u8X");

var $8Vbi1 = parcelRequire("8Vbi1");

var $7gNKk = parcelRequire("7gNKk");

var $k9wMY = parcelRequire("k9wMY");

var $3qN4t = parcelRequire("3qN4t");

var $1Xg5n = parcelRequire("1Xg5n");

var $7UdCP = parcelRequire("7UdCP");

var $6GT3d = parcelRequire("6GT3d");

var $kCaV6 = parcelRequire("kCaV6");

var $4QTpT = parcelRequire("4QTpT");

var $bwBMG = parcelRequire("bwBMG");

var $eFu13 = parcelRequire("eFu13");

var $fDYcT = parcelRequire("fDYcT");
const $0b5bb75eec0fd814$export$9b544c2606a30a3a = (0, $iWqim.freeze)({
    minWidth: (0, $dPMMf.gridSize) * 20,
    maxWidth: (0, $dPMMf.gridSize) * 20,
    canBeMultiLine: true
});
const $0b5bb75eec0fd814$var$USER_FIELD_CONFIGURATION = {
    minWidth: 100,
    maxWidth: 300,
    canBeMultiLine: true
};
const $0b5bb75eec0fd814$var$USER_FIELD_TYPES = [
    'creator',
    'reporter',
    'com.atlassian.jira.plugin.system.customfieldtypes:userpicker'
];
const $0b5bb75eec0fd814$var$MULTI_USER_FIELD_CONFIGURATION = {
    minWidth: 100,
    maxWidth: 200,
    canBeMultiLine: true
};
const $0b5bb75eec0fd814$var$MULTI_USER_FIELD_TYPES = [
    'com.atlassian.servicedesk:sd-request-participants',
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker'
];
const $0b5bb75eec0fd814$var$FEATURED_DATE_FIELD_CONFIGURATION = {
    minWidth: 90,
    maxWidth: 90,
    doNotRenderTooltip: true,
    canBeMultiLine: true
};
const $0b5bb75eec0fd814$var$FEATURED_DATE_FIELD_TYPES = [
    'created',
    'updated',
    'com.atlassian.jira.plugin.system.customfieldtypes:datepicker'
];
const $0b5bb75eec0fd814$var$STANDARD_DATE_FIELD_CONFIGURATION = {
    minWidth: 90,
    maxWidth: 90,
    canBeMultiLine: true
};
const $0b5bb75eec0fd814$var$STANDARD_DATE_FIELD_TYPES = [
    'duedate',
    'resolutiondate'
];
const $0b5bb75eec0fd814$var$DATETIME_FIELD_CONFIGURATION = {
    minWidth: (0, $dPMMf.gridSize) * 11,
    maxWidth: (0, $dPMMf.gridSize) * 18,
    doNotRenderTooltip: true
};
const $0b5bb75eec0fd814$var$DATETIME_FIELD_TYPES = [
    'lastViewed',
    'com.atlassian.jira.plugin.system.customfieldtypes:datetime'
];
const $0b5bb75eec0fd814$var$SHORT_TEXT_FIELD_CONFIGURATION = {
    minWidth: (0, $dPMMf.gridSize) * 12,
    maxWidth: (0, $dPMMf.gridSize) * 25,
    canBeMultiLine: true
};
const $0b5bb75eec0fd814$var$SHORT_TEXT_FIELD_TYPES = [
    'com.atlassian.servicedesk:vp-origin',
    'components',
    'com.atlassian.jira.plugin.system.customfieldtypes:select',
    'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons',
    'resolution',
    'timespent',
    'aggregatetimespent',
    'timeoriginalestimate',
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement',
    'com.atlassian.servicedesk.sentiment:sd-sentiment',
    'com.atlassian.servicedesk.customer-context:sd-csm-organization'
];
const $0b5bb75eec0fd814$var$LONG_TEXT_FIELD_CONFIGURATION = {
    minWidth: (0, $dPMMf.gridSize) * 20,
    maxWidth: (0, $dPMMf.gridSize) * 75,
    canBeMultiLine: true
};
const $0b5bb75eec0fd814$var$LONG_TEXT_FIELD_TYPES = [
    'summary',
    'com.atlassian.jira.plugin.system.customfieldtypes:textfield'
];
const $0b5bb75eec0fd814$var$MULTI_SELECT_FIELD_CONFIGURATION = {
    minWidth: (0, $dPMMf.gridSize) * 12,
    maxWidth: (0, $dPMMf.gridSize) * 20,
    canBeMultiLine: true
};
// Atlaskit/Tag doesn't truncate long tags until 180px
const $0b5bb75eec0fd814$var$JSON_MULTI_SELECT_FIELD_CONFIGURATION = {
    minWidth: (0, $dPMMf.gridSize) * 21,
    maxWidth: (0, $dPMMf.gridSize) * 21,
    canBeMultiLine: true
};
const $0b5bb75eec0fd814$var$MULTI_SELECT_FIELD_TYPES = [
    'com.atlassian.servicedesk:sd-customer-organizations',
    'com.atlassian.jira.plugin.system.customfieldtypes:labels',
    'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
    'fixVersions',
    'issuelinks'
];
const $0b5bb75eec0fd814$var$JSON_MULTI_SELECT_FIELD_TYPES = [
    'labels',
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype',
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion',
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker'
];
const $0b5bb75eec0fd814$var$MULTILINE_TEXT_FIELD_CONFIGURATION = {
    minWidth: (0, $dPMMf.gridSize) * 20,
    maxWidth: (0, $dPMMf.gridSize) * 75,
    canBeMultiLine: true
};
const $0b5bb75eec0fd814$var$MULTILINE_TEXT_FIELD_TYPES = [
    'description',
    'com.atlassian.jira.plugin.system.customfieldtypes:textarea'
];
const $0b5bb75eec0fd814$var$NUMERIC_FIELD_CONFIGURATION = {
    minWidth: (0, $dPMMf.gridSize) * 8,
    maxWidth: (0, $dPMMf.gridSize) * 16
};
const $0b5bb75eec0fd814$var$NUMERIC_FIELD_TYPES = [
    'com.atlassian.jira.plugin.system.customfieldtypes:float'
];
const $0b5bb75eec0fd814$var$FIELD_CONFIGURATION_CATEGORIES = [
    {
        fieldTypes: $0b5bb75eec0fd814$var$USER_FIELD_TYPES,
        configuration: $0b5bb75eec0fd814$var$USER_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $0b5bb75eec0fd814$var$MULTI_USER_FIELD_TYPES,
        configuration: $0b5bb75eec0fd814$var$MULTI_USER_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $0b5bb75eec0fd814$var$FEATURED_DATE_FIELD_TYPES,
        configuration: $0b5bb75eec0fd814$var$FEATURED_DATE_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $0b5bb75eec0fd814$var$STANDARD_DATE_FIELD_TYPES,
        configuration: $0b5bb75eec0fd814$var$STANDARD_DATE_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $0b5bb75eec0fd814$var$DATETIME_FIELD_TYPES,
        configuration: $0b5bb75eec0fd814$var$DATETIME_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $0b5bb75eec0fd814$var$SHORT_TEXT_FIELD_TYPES,
        configuration: $0b5bb75eec0fd814$var$SHORT_TEXT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $0b5bb75eec0fd814$var$LONG_TEXT_FIELD_TYPES,
        configuration: $0b5bb75eec0fd814$var$LONG_TEXT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $0b5bb75eec0fd814$var$MULTILINE_TEXT_FIELD_TYPES,
        configuration: $0b5bb75eec0fd814$var$MULTILINE_TEXT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $0b5bb75eec0fd814$var$MULTI_SELECT_FIELD_TYPES,
        configuration: $0b5bb75eec0fd814$var$MULTI_SELECT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $0b5bb75eec0fd814$var$JSON_MULTI_SELECT_FIELD_TYPES,
        configuration: $0b5bb75eec0fd814$var$JSON_MULTI_SELECT_FIELD_CONFIGURATION
    },
    {
        fieldTypes: $0b5bb75eec0fd814$var$NUMERIC_FIELD_TYPES,
        configuration: $0b5bb75eec0fd814$var$NUMERIC_FIELD_CONFIGURATION
    }
];
const $0b5bb75eec0fd814$var$buildFieldConfigurationsFromCategories = (categories)=>categories.reduce((acc, { fieldTypes: fieldTypes, configuration: configuration })=>{
        fieldTypes.forEach((fieldType)=>{
            if (acc[fieldType] != null) throw new Error(`Field configuration for ${fieldType} already defined`);
            acc[fieldType] = configuration;
        });
        return acc;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
const $0b5bb75eec0fd814$export$ec8fde615467a6e1 = (0, $iWqim.freeze)({
    ...$0b5bb75eec0fd814$var$buildFieldConfigurationsFromCategories($0b5bb75eec0fd814$var$FIELD_CONFIGURATION_CATEGORIES),
    issuekey: {
        minWidth: 85,
        maxWidth: 100
    },
    issuetype: {
        minWidth: 16,
        maxWidth: 16,
        // Prevent ellipsis from rendering in IE & Edge
        canBeMultiLine: true
    },
    status: {
        minWidth: 150,
        maxWidth: 200,
        doNotRenderTooltip: true
    },
    priority: {
        minWidth: 16,
        maxWidth: 16
    },
    assignee: {
        minWidth: 100,
        maxWidth: 220,
        canBeMultiLine: true,
        needsInitialization: true
    },
    'com.atlassian.servicedesk:sd-sla-field': {
        minWidth: 182,
        maxWidth: 200
    },
    'com.atlassian.servicedesk:sd-request-feedback': {
        minWidth: (0, $dPMMf.gridSize) * 11,
        maxWidth: (0, $dPMMf.gridSize) * 11
    },
    summary: {
        minWidth: (0, $dPMMf.gridSize) * 20,
        maxWidth: (0, $dPMMf.gridSize) * 75,
        canBeMultiLine: true
    },
    date: {
        minWidth: (0, $dPMMf.gridSize) * 25,
        maxWidth: (0, $dPMMf.gridSize) * 25,
        doNotRenderTooltip: true
    },
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': {
        minWidth: (0, $dPMMf.gridSize) * 25,
        maxWidth: (0, $dPMMf.gridSize) * 25,
        doNotRenderTooltip: true
    },
    'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype': {
        minWidth: (0, $dPMMf.gridSize) * 25,
        maxWidth: (0, $dPMMf.gridSize) * 25
    },
    meatball: {
        minWidth: (0, $dPMMf.gridSize) * 3,
        maxWidth: (0, $dPMMf.gridSize) * 3
    },
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': {
        minWidth: (0, $dPMMf.gridSize) * 22,
        maxWidth: (0, $dPMMf.gridSize) * 25
    },
    'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype': {
        minWidth: (0, $dPMMf.gridSize) * 15,
        maxWidth: (0, $dPMMf.gridSize) * 20
    }
});
const $0b5bb75eec0fd814$export$1d9fdc71b83a8eac = 48;
const $0b5bb75eec0fd814$export$a7c09d12ef8597c0 = (0, $iWqim.freeze)({
    assignee: {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1.assignee,
        canBeMultiLine: false,
        FieldComponent: (0, $dGEw9.default)
    },
    reporter: {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1.reporter,
        FieldComponent: (0, $1Xg5n.default)
    },
    reporterWithIcon: {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1.assignee,
        canBeMultiLine: false,
        FieldComponent: (0, $dGEw9.default)
    },
    creator: {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1.creator,
        FieldComponent: (0, $eQ9Cm.default)
    },
    issuekey: {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1.issuekey,
        FieldComponent: (0, $3YrDW.default)
    },
    issuetype: {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1.issuetype,
        FieldComponent: (0, $8JSWU.default)
    },
    'com.atlassian.servicedesk:sd-sla-field': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$f790c24298ed441b],
        FieldComponent: (0, $kCaV6.default)
    },
    'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$991960fb6e9ea7dd],
        FieldComponent: (0, $8ULSA.AsyncAffectedServices)
    },
    labels: {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1.labels,
        FieldComponent: (0, $16gLw.default)
    },
    status: {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1.status,
        FieldComponent: (0, $4QTpT.default)
    },
    statusCategory: {
        // using the same width config as status here since its also rendering lozenges
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1.status,
        FieldComponent: (0, $fDYcT.default)
    },
    summary: {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1.summary,
        FieldComponent: (0, $bwBMG.default)
    },
    priority: {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1.priority,
        FieldComponent: (0, $3qN4t.default)
    },
    date: {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1.date,
        FieldComponent: (0, $bsplE.default)
    },
    'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$b84257e6dcaab24d],
        FieldComponent: (0, $4lvo5.CmdbObjects)
    },
    'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$dd2fa454b47497da],
        FieldComponent: (0, $7UdCP.default)
    },
    meatball: {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1.meatball,
        FieldComponent: (0, $71Yrd.default)
    },
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$f0f60e2d773695fc],
        FieldComponent: (0, $59u8X.default)
    },
    'com.atlassian.jira.plugins.work-category-field:work-category-field-cftype': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$794539092c70e595],
        FieldComponent: (0, $eFu13.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$d8fae0f9b622e615],
        FieldComponent: (0, $7gNKk.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multiselect': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$155ae54d06c908ea],
        FieldComponent: (0, $7gNKk.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$2ddc21f5fedfaf92],
        FieldComponent: (0, $8Vbi1.default)
    },
    'com.atlassian.servicedesk:sd-request-participants': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $ec619a2fc20bcfda$export$e918afe651ac9e7a],
        FieldComponent: (0, $8Vbi1.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multiversion': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$5ae60777f05f3dfa],
        FieldComponent: (0, $7gNKk.default)
    },
    'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$734a41c9fe85799a],
        FieldComponent: (0, $7gNKk.default)
    },
    'com.atlassian.servicedesk.customer-context:sd-csm-entitlement': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$80b6ff34fe6a6e00],
        FieldComponent: (0, $6hnhp.default)
    },
    'com.atlassian.servicedesk.sentiment:sd-sentiment': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$37cb0de8d249ef22],
        FieldComponent: (0, $6GT3d.default)
    },
    'com.atlassian.servicedesk.customer-context:sd-csm-organization': {
        ...$0b5bb75eec0fd814$export$ec8fde615467a6e1[0, $9f37490eed0e5ebb$export$a370b4fb11e50a66],
        FieldComponent: (0, $k9wMY.default)
    }
});
const $0b5bb75eec0fd814$export$9f3c8ab747beea8 = (0, $iWqim.freeze)({
    ...$0b5bb75eec0fd814$export$ec8fde615467a6e1
});
// @ts-expect-error - Property 'parent' is missing
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$0b5bb75eec0fd814$export$a7c09d12ef8597c0
});

});
parcelRegister("8ULSA", function(module, exports) {

$parcel$export(module.exports, "AsyncAffectedServices", () => $bd3490302e7b478c$export$6f7aec38b8acafe4);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

const $bd3490302e7b478c$var$LazyAffectedServices = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1H2g2")).then((module)=>module.AffectedServices), {
    moduleId: "./src/packages/issue-table/src/common/fields/affected-services/index.tsx"
});
const $bd3490302e7b478c$export$6f7aec38b8acafe4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "affectedServicesField",
        packageName: "jiraIssueTable",
        teamName: "jsd-shield",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-affected-services",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd3490302e7b478c$var$LazyAffectedServices, props)));

});
parcelRegister("1H2g2", function(module, exports) {

let $13bb8eecb17a55da$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $13bb8eecb17a55da$var$load("03EMG").then(()=>parcelRequire('9eRKK'));

});


parcelRegister("dGEw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b7914c7b0c0f736$export$2e2bcd8739ae039);

var $dQRbF = parcelRequire("dQRbF");

var $8toaC = parcelRequire("8toaC");

var $fRfGu = parcelRequire("fRfGu");

var $3oX0a = parcelRequire("3oX0a");
const $4b7914c7b0c0f736$var$mapStateToProps = (state)=>({
        onRefreshSidebar: (0, $dQRbF.getRefreshSidebar)(state)
    });
// @ts-expect-error - TS2345 - Argument of type '<T extends UserFieldType>(props: FieldComponentProps<T>) => JSX.Element' is not assignable to parameter of type 'ComponentType<FieldComponentProps<"assignee" | "reporterWithIcon">>'.
const $4b7914c7b0c0f736$var$AssigneeField = (0, $fRfGu.default)((0, $3oX0a.default));
var $4b7914c7b0c0f736$export$2e2bcd8739ae039 = (0, $8toaC.connect)($4b7914c7b0c0f736$var$mapStateToProps, {})($4b7914c7b0c0f736$var$AssigneeField);

});
parcelRegister("dQRbF", function(module, exports) {

$parcel$export(module.exports, "shouldShowPagination", () => $c1a82ba5287ded70$export$6e158a7480642df3);
$parcel$export(module.exports, "getCurrentPage", () => $c1a82ba5287ded70$export$7945ba8eb1c827e6);
$parcel$export(module.exports, "getEditingFieldHorizontalOffset", () => $c1a82ba5287ded70$export$ea5cb0fb82c4318e);
$parcel$export(module.exports, "getEditingFieldVerticalOffset", () => $c1a82ba5287ded70$export$446d316b4302b660);
$parcel$export(module.exports, "getEditingFieldWidth", () => $c1a82ba5287ded70$export$9d6a956ae977aa72);
$parcel$export(module.exports, "getTableWidth", () => $c1a82ba5287ded70$export$4910020ffe58186f);
$parcel$export(module.exports, "getTableHeight", () => $c1a82ba5287ded70$export$81ff4c821ba5ba90);
$parcel$export(module.exports, "isUserPickerDisabled", () => $c1a82ba5287ded70$export$dd971882ae58428);
$parcel$export(module.exports, "isTableDisabled", () => $c1a82ba5287ded70$export$739fac98c5c8c5b1);
$parcel$export(module.exports, "getOnIssueViewTransition", () => $c1a82ba5287ded70$export$91f8b9de4d443a00);
$parcel$export(module.exports, "getOnIssueViewTransitionCallback", () => $c1a82ba5287ded70$export$2cdb474716074fd9);
$parcel$export(module.exports, "getUseJSMQueueDurationEvent", () => $c1a82ba5287ded70$export$95f35106d46731dd);
$parcel$export(module.exports, "getRenderSidebarIcon", () => $c1a82ba5287ded70$export$a0841f9badd7cdca);
$parcel$export(module.exports, "getRefreshSidebar", () => $c1a82ba5287ded70$export$c193060edd582f66);
$parcel$export(module.exports, "getIssueLinkOverride", () => $c1a82ba5287ded70$export$10c8fbcbc88112bb);

var $ljsRg = parcelRequire("ljsRg");
const $c1a82ba5287ded70$export$f636b7a9195cdaf0 = (state)=>state.ui;
const $c1a82ba5287ded70$export$6e158a7480642df3 = (state)=>$c1a82ba5287ded70$export$f636b7a9195cdaf0(state).showPagination;
const $c1a82ba5287ded70$export$7945ba8eb1c827e6 = (state)=>$c1a82ba5287ded70$export$f636b7a9195cdaf0(state).currentPage;
const $c1a82ba5287ded70$var$maybeEditingFieldPosition = (state)=>(0, $ljsRg.Maybe).fromNull($c1a82ba5287ded70$export$f636b7a9195cdaf0(state).editingFieldPosition);
const $c1a82ba5287ded70$export$ea5cb0fb82c4318e = (state)=>$c1a82ba5287ded70$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.horizontalOffset).orSome(0);
const $c1a82ba5287ded70$export$446d316b4302b660 = (state)=>$c1a82ba5287ded70$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.verticalOffset).orSome(0);
const $c1a82ba5287ded70$export$9d6a956ae977aa72 = (state)=>$c1a82ba5287ded70$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.fieldWidth).orSome(0);
const $c1a82ba5287ded70$export$4910020ffe58186f = (state)=>$c1a82ba5287ded70$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.tableWidth).orSome(0);
const $c1a82ba5287ded70$export$81ff4c821ba5ba90 = (state)=>$c1a82ba5287ded70$var$maybeEditingFieldPosition(state)// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    .map((position)=>position.tableHeight).orSome(0);
const $c1a82ba5287ded70$export$dd971882ae58428 = (state)=>$c1a82ba5287ded70$export$f636b7a9195cdaf0(state).userPickerDisabled;
const $c1a82ba5287ded70$export$739fac98c5c8c5b1 = (state)=>$c1a82ba5287ded70$export$f636b7a9195cdaf0(state).isTableDisabled;
const $c1a82ba5287ded70$export$91f8b9de4d443a00 = (state)=>$c1a82ba5287ded70$export$f636b7a9195cdaf0(state).onIssueViewTransition;
const $c1a82ba5287ded70$export$2cdb474716074fd9 = (state, issueKey)=>{
    const onIssueViewTransition = $c1a82ba5287ded70$export$91f8b9de4d443a00(state);
    return onIssueViewTransition ? (event)=>onIssueViewTransition(issueKey, event) : undefined;
};
const $c1a82ba5287ded70$export$95f35106d46731dd = (state)=>$c1a82ba5287ded70$export$f636b7a9195cdaf0(state).useJSMQueueDurationEvent;
const $c1a82ba5287ded70$export$a0841f9badd7cdca = (state)=>$c1a82ba5287ded70$export$f636b7a9195cdaf0(state).renderSidebarIcon;
const $c1a82ba5287ded70$export$c193060edd582f66 = (state)=>$c1a82ba5287ded70$export$f636b7a9195cdaf0(state).refreshSidebar;
const $c1a82ba5287ded70$export$10c8fbcbc88112bb = (state)=>$c1a82ba5287ded70$export$f636b7a9195cdaf0(state).getIssueLinkOverride;

});

parcelRegister("8toaC", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $80ecdc9eeb750f1d$export$f51a9068ac82ea43);
$parcel$export(module.exports, "IssueTableContext", () => $80ecdc9eeb750f1d$export$75838b369936001);
$parcel$export(module.exports, "Provider", () => $80ecdc9eeb750f1d$export$2881499e37b75b9a);
$parcel$export(module.exports, "connect", () => $80ecdc9eeb750f1d$export$64605811ab45167f);

var $eJOHy = parcelRequire("eJOHy");

var $dFg4o = parcelRequire("dFg4o");

var $gs6vs = parcelRequire("gs6vs");

var $gnQAk = parcelRequire("gnQAk");


var $aOUL3 = parcelRequire("aOUL3");
const $80ecdc9eeb750f1d$export$f51a9068ac82ea43 = (rootEpic, initialState)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $gs6vs.default)({
        appName: 'IssueTable',
        initialState: // @ts-expect-error - Type 'Partial<State>' is not assignable to type '{ readonly initialAppProps: { cloudId?: string | undefined; atlassianAccountId?: string | undefined; fabricPfDirUrl?: string | undefined; }; readonly persisted: { lockedIssues: { [x: string]: { issueKey: string; positionIndex: number; fields: { ...; }; } | undefined; }; columns: { ...; }[]; providedIssueKeys: string...'.
        initialState,
        rootReducer: (0, $dFg4o.enableBatching)((0, $aOUL3.default)),
        rootEpic: rootEpic
    });
const $80ecdc9eeb750f1d$export$75838b369936001 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $80ecdc9eeb750f1d$export$2881499e37b75b9a = (0, $gnQAk.createProvider)($80ecdc9eeb750f1d$export$75838b369936001);
const $80ecdc9eeb750f1d$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = {})=>(0, $gnQAk.connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
        ...options,
        context: $80ecdc9eeb750f1d$export$75838b369936001,
        storeKey: (0, $7960a17eac94f01b$export$b94951a11282ae6a)
    });

});
const $7960a17eac94f01b$export$b94951a11282ae6a = 'issueTableStore';

parcelRegister("aOUL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $23d40737e4c6ff86$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $8Xsn4 = parcelRequire("8Xsn4");

var $kRtnt = parcelRequire("kRtnt");

var $lBGee = parcelRequire("lBGee");

var $j3i8l = parcelRequire("j3i8l");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $23d40737e4c6ff86$var$noopReducer = (state)=>state || {};
var $23d40737e4c6ff86$export$2e2bcd8739ae039 = (0, $7HHI1.combineReducers)({
    persisted: $lBGee.default,
    ui: $j3i8l.default,
    fieldInitialization: $kRtnt.default,
    bulkSelection: $8Xsn4.default,
    initialAppProps: $23d40737e4c6ff86$var$noopReducer
});

});
parcelRegister("8Xsn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $287245bd2a7fa481$export$2e2bcd8739ae039);

var $dpmnN = parcelRequire("dpmnN");
const $287245bd2a7fa481$export$c9e0737591e76440 = {
    lastClickedRow: undefined,
    selectionServiceActions: undefined,
    hasSelection: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$287245bd2a7fa481$export$2e2bcd8739ae039 = (state = $287245bd2a7fa481$export$c9e0737591e76440, action)=>{
    switch(action.type){
        case 0, $dpmnN.SET_LAST_CLICKED_ROW:
            {
                const { rowId: lastClickedRow } = action.payload;
                return {
                    ...state,
                    lastClickedRow: lastClickedRow
                };
            }
        case 0, $dpmnN.SET_SELECTION_SERVICE_ACTIONS:
            {
                const { actions: actions } = action.payload;
                return {
                    ...state,
                    selectionServiceActions: actions
                };
            }
        // @ts-expect-error - TS2678 - Type '"state.actions.bulk-selection.SET_HAS_SELECTION"' is not comparable to type '"state.actions.bulk-selection.SET_LAST_CLICKED_ROW" | "state.actions.bulk-selection.SET_SELECTION_SERVICE_ACTIONS"'.
        case 0, $dpmnN.SET_HAS_SELECTION:
            {
                // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'never'.
                const { hasSelection: hasSelection } = action.payload;
                return {
                    ...state,
                    hasSelection: hasSelection
                };
            }
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("kRtnt", function(module, exports) {

$parcel$export(module.exports, "default", () => $751fa7651ca26c19$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $9HaBK = parcelRequire("9HaBK");
const $751fa7651ca26c19$var$DEFAULT_FIELD_INITIALIZATION = {
    assignee: {}
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$751fa7651ca26c19$export$2e2bcd8739ae039 = (state = $751fa7651ca26c19$var$DEFAULT_FIELD_INITIALIZATION, action)=>{
    switch(action.type){
        case 0, $9HaBK.SET_ASSIGNEE_INITIALIZATION_STATE:
            {
                const { avatarUrl: avatarUrl, displayName: displayName, emailAddress: emailAddress } = action.payload;
                return (0, $iWqim.assoc)(state, 'assignee', {
                    avatarUrl: avatarUrl,
                    displayName: displayName,
                    emailAddress: emailAddress
                });
            }
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});
parcelRegister("9HaBK", function(module, exports) {

$parcel$export(module.exports, "SET_ASSIGNEE_INITIALIZATION_STATE", () => $479e35b2b09085ab$export$9b3381a1fe204800);
$parcel$export(module.exports, "setAssigneeInitializationStateAction", () => $479e35b2b09085ab$export$50a032c03fced60e);
const $479e35b2b09085ab$export$9b3381a1fe204800 = 'state.actions.field.initialization.SET_ASSIGNEE_INITIALIZATION_STATE';
const $479e35b2b09085ab$export$50a032c03fced60e = (assigneeInitialization)=>({
        type: $479e35b2b09085ab$export$9b3381a1fe204800,
        payload: assigneeInitialization
    });

});


parcelRegister("lBGee", function(module, exports) {

$parcel$export(module.exports, "default", () => $03fac2ef7838ad5d$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $8dH3d = parcelRequire("8dH3d");

var $cSmYj = parcelRequire("cSmYj");

var $4lYQk = parcelRequire("4lYQk");

var $33JWf = parcelRequire("33JWf");

var $iN885 = parcelRequire("iN885");

var $987AO = parcelRequire("987AO");

var $cLGK3 = parcelRequire("cLGK3");

var $gY8BA = parcelRequire("gY8BA");

var $3fOWJ = parcelRequire("3fOWJ");
const $03fac2ef7838ad5d$var$DEFAULT_PERSISTED_STATE = {
    columns: [],
    providedIssueKeys: [],
    lockedIssues: {},
    offsets: {
        verticalScrollOffset: 0,
        horizontalScrollOffset: 0
    },
    rowListRef: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$03fac2ef7838ad5d$export$2e2bcd8739ae039 = (state = $03fac2ef7838ad5d$var$DEFAULT_PERSISTED_STATE, action)=>{
    switch(action.type){
        case 0, $987AO.UNLOCK_FIELD:
            {
                const { issueKey: issueKey, fieldId: fieldId } = action.payload;
                const newLockedIssues = (0, $33JWf.default)(state, [
                    'lockedIssues',
                    issueKey,
                    'fields',
                    fieldId
                ]);
                const newLockedIssue = newLockedIssues.lockedIssues[issueKey];
                if (newLockedIssue && (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(newLockedIssue.fields)) return (0, $33JWf.default)(state, [
                    'lockedIssues',
                    issueKey
                ]);
                return newLockedIssues;
            }
        case 0, $987AO.LOCK_FIELD:
            {
                const { issueKey: issueKey, fieldId: fieldId, positionIndex: positionIndex } = action.payload;
                return (0, $iWqim.updateIn)(state, [
                    'lockedIssues'
                ], (lockedIssues)=>{
                    // Clean up any other issues with the same position
                    const newLockedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))(// @ts-expect-error - TS2769 - No overload matches this call.
                    lockedIssues, (lockedIssue)=>lockedIssue.positionIndex === positionIndex && lockedIssue.issueKey !== issueKey);
                    // Overwrite/update the current locked issue details
                    return (0, $iWqim.updateIn)(newLockedIssues, [
                        issueKey
                    ], (lockedIssue)=>{
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const fields = {};
                        fields[fieldId] = true;
                        return (0, $iWqim.merge)(lockedIssue || {}, {
                            issueKey: issueKey,
                            positionIndex: positionIndex,
                            fields: fields
                        });
                    });
                });
            }
        case 0, $987AO.UNLOCK_ALL_FIELDS:
            return (0, $iWqim.assoc)(state, 'lockedIssues', {});
        case 0, $iN885.UPDATE_COLUMNS:
            {
                const { columns: columns } = action.payload;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(state.columns, columns)) return state;
                return (0, $iWqim.assoc)(state, 'columns', columns);
            }
        case 0, $cLGK3.UPDATE_PROVIDED_ISSUE_KEYS:
            {
                const { issueKeys: issueKeys } = action.payload;
                return (0, $iWqim.assoc)(state, 'providedIssueKeys', issueKeys);
            }
        case 0, $gY8BA.SET_HORIZONTAL_OFFSET:
            {
                const { horizontalOffset: horizontalOffset } = action.payload;
                return (0, $iWqim.assocIn)(state, [
                    'offsets',
                    'horizontalScrollOffset'
                ], horizontalOffset);
            }
        case 0, $gY8BA.SET_VERTICAL_OFFSET:
            {
                const { verticalOffset: verticalOffset } = action.payload;
                return (0, $iWqim.assocIn)(state, [
                    'offsets',
                    'verticalScrollOffset'
                ], verticalOffset);
            }
        case 0, $3fOWJ.SET_ROW_LIST_REF:
            return (0, $iWqim.assoc)(state, 'rowListRef', action.payload);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("33JWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $07b7fe65f9dcae19$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $07b7fe65f9dcae19$var$unsetInSingle = (state, pathToParent, key)=>{
    if (pathToParent.length === 0) return (0, $iWqim.unset)(state, key);
    const ret = (0, $iWqim.updateIn)(state, pathToParent, (parent)=>parent ? (0, $iWqim.unset)(parent, key) : undefined);
    return ret;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $07b7fe65f9dcae19$var$unsetInMulti = (state, pathToParent, keys)=>// @ts-expect-error - TS7006 - Parameter 'folded' implicitly has an 'any' type. | TS7006 - Parameter 'subkey' implicitly has an 'any' type.
    keys.reduce((folded, subkey)=>$07b7fe65f9dcae19$var$unsetInSingle(folded, pathToParent, subkey), state);
var //   ['a', 'b', 'c'] - removes values at 'a/b/c'
//   ['a', ['b', 'c']] - removes values at 'a/b' and 'a/c'
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$07b7fe65f9dcae19$export$2e2bcd8739ae039 = (state, path)=>{
    if (path.length === 0) return state;
    const pathToParent = path.slice(0, path.length - 1);
    const lastPathItem = path.slice(-1)[0];
    if (Array.isArray(lastPathItem)) return $07b7fe65f9dcae19$var$unsetInMulti(state, pathToParent, lastPathItem);
    return $07b7fe65f9dcae19$var$unsetInSingle(state, pathToParent, lastPathItem);
};

});

parcelRegister("gY8BA", function(module, exports) {

$parcel$export(module.exports, "UPDATE_VERTICAL_OFFSET", () => $3a9dc42f0e7ddfff$export$676d1c528632e526);
$parcel$export(module.exports, "updateVerticalOffsetAction", () => $3a9dc42f0e7ddfff$export$18b97acfb3435930);
$parcel$export(module.exports, "SET_VERTICAL_OFFSET", () => $3a9dc42f0e7ddfff$export$377cee6e888818c4);
$parcel$export(module.exports, "setVerticalOffsetAction", () => $3a9dc42f0e7ddfff$export$d4159e3b6bc6e867);
$parcel$export(module.exports, "SET_HORIZONTAL_OFFSET", () => $3a9dc42f0e7ddfff$export$d3a9fff38ab5d354);
$parcel$export(module.exports, "setHorizontalOffsetAction", () => $3a9dc42f0e7ddfff$export$3ed7387f47277f6a);
const $3a9dc42f0e7ddfff$export$676d1c528632e526 = 'state.actions.offsets.UPDATE_VERTICAL_OFFSET';
const $3a9dc42f0e7ddfff$export$18b97acfb3435930 = (totalPages, verticalPosition, onVerticalScrollOffsetChanged)=>({
        type: $3a9dc42f0e7ddfff$export$676d1c528632e526,
        payload: {
            totalPages: totalPages,
            verticalPosition: verticalPosition,
            onVerticalScrollOffsetChanged: onVerticalScrollOffsetChanged
        }
    });
const $3a9dc42f0e7ddfff$export$377cee6e888818c4 = 'state.actions.offsets.SET_VERTICAL_OFFSET';
const $3a9dc42f0e7ddfff$export$d4159e3b6bc6e867 = (verticalOffset)=>({
        type: $3a9dc42f0e7ddfff$export$377cee6e888818c4,
        payload: {
            verticalOffset: verticalOffset
        }
    });
const $3a9dc42f0e7ddfff$export$d3a9fff38ab5d354 = 'state.actions.offsets.SET_HORIZONTAL_OFFSET';
const $3a9dc42f0e7ddfff$export$3ed7387f47277f6a = (horizontalOffset)=>({
        type: $3a9dc42f0e7ddfff$export$d3a9fff38ab5d354,
        payload: {
            horizontalOffset: horizontalOffset
        }
    });

});

parcelRegister("3fOWJ", function(module, exports) {

$parcel$export(module.exports, "SET_ROW_LIST_REF", () => $55bf86fce70ec4be$export$bb9e2ef2ff07df11);
$parcel$export(module.exports, "setRowListRefAction", () => $55bf86fce70ec4be$export$9264a3dd68126495);
const $55bf86fce70ec4be$export$bb9e2ef2ff07df11 = 'state.actions.table.SET_ROW_LIST_REF';
const $55bf86fce70ec4be$export$9264a3dd68126495 = (payload)=>({
        type: $55bf86fce70ec4be$export$bb9e2ef2ff07df11,
        payload: payload
    });

});


parcelRegister("j3i8l", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_STATE", () => $0e40c9f3062609c7$export$a3a6a28ae8823b06);
$parcel$export(module.exports, "default", () => $0e40c9f3062609c7$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $cN0WI = parcelRequire("cN0WI");
const $0e40c9f3062609c7$export$a3a6a28ae8823b06 = {
    showPagination: false,
    currentPage: 1,
    userPickerDisabled: false,
    isTableDisabled: false,
    onIssueViewTransition: undefined,
    useJSMQueueDurationEvent: undefined,
    renderSidebarIcon: undefined,
    refreshSidebar: undefined
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e40c9f3062609c7$export$2e2bcd8739ae039 = (state = $0e40c9f3062609c7$export$a3a6a28ae8823b06, action)=>{
    switch(action.type){
        case 0, $cN0WI.SHOW_PAGINATION:
            return (0, $iWqim.assoc)(state, 'showPagination', action.payload);
        case 0, $cN0WI.SET_EDITING_FIELD_POSITION:
            return (0, $iWqim.assoc)(state, 'editingFieldPosition', {
                horizontalOffset: action.payload.horizontalOffset,
                verticalOffset: action.payload.verticalOffset,
                fieldWidth: action.payload.fieldWidth,
                tableWidth: action.payload.tableWidth,
                tableHeight: action.payload.tableHeight
            });
        case 0, $cN0WI.SET_CURRENT_PAGE:
            return (0, $iWqim.assoc)(state, 'currentPage', action.payload);
        case 0, $cN0WI.SET_IS_TABLE_DISABLED:
            return (0, $iWqim.assoc)(state, 'isTableDisabled', action.payload);
        case 0, $cN0WI.DISABLE_USER_PICKER:
            return (0, $iWqim.assoc)(state, 'userPickerDisabled', true);
        case 0, $cN0WI.SET_ON_ISSUE_VIEW_TRANSITION:
            return (0, $iWqim.assoc)(state, 'onIssueViewTransition', action.payload);
        case 0, $cN0WI.SET_JSM_QUEUE_DURATION_EVENT:
            return (0, $iWqim.assoc)(state, 'useJSMQueueDurationEvent', action.payload);
        case 0, $cN0WI.SET_RENDER_SIDE_BAR_ICON:
            return (0, $iWqim.assoc)(state, 'renderSidebarIcon', action.payload);
        case 0, $cN0WI.SET_REFRESH_SIDE_BAR:
            return (0, $iWqim.assoc)(state, 'refreshSidebar', action.payload);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("fRfGu", function(module, exports) {

$parcel$export(module.exports, "default", () => $340c6ab318f87b76$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $lLL16 = parcelRequire("lLL16");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $ia7qg = parcelRequire("ia7qg");

var $2is8h = parcelRequire("2is8h");

var $bNR2Y = parcelRequire("bNR2Y");
const $340c6ab318f87b76$var$OVERLAY_TIMEOUT = 1000;
const $340c6ab318f87b76$var$LOCATION = 'issue-table.view.fields.common.editable-field';
const $340c6ab318f87b76$var$AUTOMATIC_ID_VALUE = '-1';
const $340c6ab318f87b76$export$ae8818331f1797ff = (response)=>{
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    const { assignee: assignee } = response ? response.fields || {} : {};
    if (assignee !== null && assignee !== undefined) {
        const currentAssignee = {
            accountId: assignee.accountId,
            displayName: assignee.displayName || '',
            emailAddress: assignee.emailAddress,
            avatarUrl: assignee.avatarUrls['48x48'] || ''
        };
        return currentAssignee;
    }
    return undefined;
};
function $340c6ab318f87b76$export$2e2bcd8739ae039(ChildComponent) {
    // eslint-disable-next-line jira/react/no-class-components
    return class EditableField extends (0, $eJOHy.Component) {
        static getDerivedStateFromProps(props, state) {
            const { dataSelectorProps: { key: key } } = props;
            if (key !== state.key) return {
                overlay: undefined,
                key: key
            };
            return null;
        }
        constructor(props){
            super(props), this.onSuccess = (fieldValue, event)=>{
                const { dataSelectorProps: { onChange: onChange, value: value, fieldType: fieldType }, tableInjectedProps: { issueKey: issueKey, issueFieldLockControls: issueFieldLockControls }, onRefreshSidebar: onRefreshSidebar } = this.props;
                this.timeoutOverlay();
                if (fieldValue && fieldValue.accountId === $340c6ab318f87b76$var$AUTOMATIC_ID_VALUE) (0, $bNR2Y.getCurrentAssignee)(issueKey).then((response)=>{
                    onChange && onChange(issueKey, $340c6ab318f87b76$export$ae8818331f1797ff(response));
                    issueFieldLockControls.onFieldUnlock();
                }).catch((err)=>{
                    (0, $gYnSx.default)({
                        meta: {
                            id: 'getCurrentAssigneeFailure',
                            packageName: 'jiraIssueTable',
                            teamName: 'jsd-shield'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    onChange && onChange(issueKey, fieldValue);
                    issueFieldLockControls.onFieldUnlock();
                });
                else {
                    onChange && onChange(issueKey, fieldValue);
                    issueFieldLockControls.onFieldUnlock();
                }
                onRefreshSidebar?.({
                    issueKey: issueKey
                });
                if (fieldType) (0, $ia7qg.trackUpdatedField)(event, fieldType, this.getAccountIds(fieldValue, value));
            }, this.onFailure = ()=>{
                this.setState({
                    overlay: undefined
                });
                const { tableInjectedProps: { issueFieldLockControls: issueFieldLockControls } } = this.props;
                issueFieldLockControls.onFieldUnlock();
            }, this.onEditStart = ()=>{
                const { tableInjectedProps: { issueFieldLockControls: issueFieldLockControls, onEditStart: onEditStart, issueKey: issueKey }, dataSelectorProps: { fieldType: fieldType } } = this.props;
                issueFieldLockControls.onFieldLock();
                onEditStart(fieldType, issueKey);
                this.isSelection = false;
                this.setState({
                    inEditState: true
                });
            }, this.onEditCancel = ()=>{
                if (!this.isSelection) {
                    this.setState({
                        overlay: undefined
                    });
                    const { tableInjectedProps: { issueFieldLockControls: issueFieldLockControls } } = this.props;
                    issueFieldLockControls.onFieldUnlock();
                }
                this.isSelection = false;
                this.setState({
                    inEditState: false
                });
            }, this.onEditSelection = ()=>{
                this.isSelection = true;
            }, this.onSubmit = (fieldValue)=>{
                this.childWrapperRef && this.childWrapperRef.focus();
                this.setState({
                    overlay: {
                        value: fieldValue
                    },
                    inEditState: false
                });
            }, this.onChildWrapperRefUpdate = (el)=>{
                this.childWrapperRef = el;
            }, this.getAccountIds = (fieldValue, value)=>({
                    oldId: value && value.accountId ? value.accountId : null,
                    newId: fieldValue && fieldValue.accountId ? fieldValue.accountId : null
                });
            this.state = {
                key: props.dataSelectorProps.key,
                inEditState: false
            };
        }
        componentDidUpdate(prevProps, prevState) {
            if (this.state.key !== prevState.key && this.overlayTimeoutId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearTimeout(this.overlayTimeoutId);
        }
        componentWillUnmount() {
            if (this.overlayTimeoutId) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearTimeout(this.overlayTimeoutId);
        }
        getValue() {
            const { overlay: overlay } = this.state;
            if (overlay) return overlay.value;
            const { dataSelectorProps: { value: value } } = this.props;
            return value;
        }
        timeoutOverlay() {
            const { dataSelectorProps: { fieldType: fieldType } } = this.props;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            this.overlayTimeoutId = window.setTimeout(()=>{
                this.setState({
                    overlay: undefined
                });
                delete this.overlayTimeoutId;
                (0, $eSnSE.default).safeWarnWithoutCustomerData($340c6ab318f87b76$var$LOCATION, `Overlay timeout reached for ${fieldType} field`);
            }, $340c6ab318f87b76$var$OVERLAY_TIMEOUT);
        }
        renderChildComponent(isSaving) {
            const { dataSelectorProps: { fieldType: fieldType, key: key, isEditable: isEditable, overrideDisabledAppearance: overrideDisabledAppearance }, tableInjectedProps: { width: width, issueKey: issueKey, fieldId: fieldId, rowListRef: rowListRef, onSetEditingFieldPosition: onSetEditingFieldPosition, isFieldLocked: isFieldLocked, isUserPickerDisabled: isUserPickerDisabled, isLastColumn: isLastColumn } } = this.props;
            const props = {
                value: this.getValue(),
                fieldType: fieldType,
                fieldId: fieldId,
                width: width,
                isEditable: isEditable,
                issueKey: issueKey,
                rowListRef: rowListRef,
                onSetEditingFieldPosition: onSetEditingFieldPosition,
                isFieldLocked: isFieldLocked,
                isUserPickerDisabled: isUserPickerDisabled,
                isLastColumn: isLastColumn,
                overrideDisabledAppearance: overrideDisabledAppearance
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ChildComponent, {
                ...props,
                key: key,
                onSubmit: this.onSubmit,
                onEditStart: this.onEditStart,
                onEditCancel: this.onEditCancel,
                // @ts-expect-error - TS2322 - Type '(fieldValue: FieldValue<T>, event: UIAnalyticsEventInterface) => void' is not assignable to type '(arg1: FieldValue<T>) => void'.
                onEditSuccess: this.onSuccess,
                onEditFailure: this.onFailure,
                isFieldLocked: isFieldLocked,
                isSaving: isSaving,
                onEditSelection: this.onEditSelection
            });
        }
        renderWithFocusWrapper(children) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2is8h.default), {
                inEditState: this.state.inEditState
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                style: {
                    outline: 'none'
                },
                ref: this.onChildWrapperRefUpdate
            }, children));
        }
        render() {
            const { tableInjectedProps: { isLastColumn: isLastColumn } } = this.props;
            const { overlay: overlay } = this.state;
            return overlay ? this.renderWithFocusWrapper(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                paddingInlineEnd: isLastColumn ? 'space.0' : 'space.200'
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lLL16.default), null, this.renderChildComponent(true)))) : this.renderWithFocusWrapper(this.renderChildComponent(false));
        }
    };
}

});
parcelRegister("lLL16", function(module, exports) {

$parcel$export(module.exports, "default", () => $da1f6c4838dfb0b0$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");
function $da1f6c4838dfb0b0$export$2e2bcd8739ae039(props) {
    const { border: border, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$BlanketContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$BackgroundContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$Background, {
        border: border
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$ComponentContainer, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$SpinnerContainer, {
        role: "status",
        "aria-label": "Loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null)));
}
$da1f6c4838dfb0b0$export$2e2bcd8739ae039.defaultProps = {
    border: true
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da1f6c4838dfb0b0$var$BlanketContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1e0c116y _2lx2vrvc _4t3i1wug",
            __cmplp.className
        ])
    });
});
const $da1f6c4838dfb0b0$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _4t3i1osq _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _u5f3u2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $da1f6c4838dfb0b0$var$BackgroundContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug _kqswstnw _4t3i1osq _1bsb1osq _vchhusvi _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            __cmplp.className
        ])
    });
});
const $da1f6c4838dfb0b0$var$Background = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { border: border, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _kqswh2mm _4t3i1osq _1bsb1osq _vchhusvi _bfhk11bn",
            __cmplp.border ? "_19it1x87" : "_19itglyw",
            __cmplp.className
        ])
    });
});
const $da1f6c4838dfb0b0$var$ComponentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _tzy4sxj9",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ia7qg", function(module, exports) {

$parcel$export(module.exports, "updateFieldValue$", () => $6d53f2c2bd12b2de$export$62b1d44da2518e20);
$parcel$export(module.exports, "trackUpdatedField", () => $6d53f2c2bd12b2de$export$a57c24e3bce9af0e);

var $7kixv = parcelRequire("7kixv");
parcelRequire("gdMGY");

var $814y1 = parcelRequire("814y1");

var $gCeeo = parcelRequire("gCeeo");

var $ljej9 = parcelRequire("ljej9");

var $lz4M7 = parcelRequire("lz4M7");
const $6d53f2c2bd12b2de$var$toAccountIdOrNull = (accountId)=>accountId ? (0, $ljej9.toAccountId)(accountId) : null;
const $6d53f2c2bd12b2de$var$putUserFieldValue = (// TODO: SHIELD-3213 - Not actually UserProps being passed - also includes fieldType
value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
fieldId, issueKey)=>{
    const newUserFieldValue = value ? {
        id: $6d53f2c2bd12b2de$var$toAccountIdOrNull(value.accountId)
    } : null;
    const newFieldValues = {
        [fieldId]: newUserFieldValue
    };
    return (0, $lz4M7.putFieldValue$)((0, $ljej9.toIssueKey)(issueKey), newFieldValues);
};
const $6d53f2c2bd12b2de$export$62b1d44da2518e20 = (issueKey, fieldId, newValue)=>{
    switch(newValue.fieldType){
        case 0, $814y1.ASSIGNEE_TYPE:
        case 0, $814y1.REPORTER_TYPE:
            // @ts-expect-error - TS2345 - Argument of type 'DataSelectorFieldValue<T>' is not assignable to parameter of type 'UserProps'.
            return $6d53f2c2bd12b2de$var$putUserFieldValue(newValue, fieldId, issueKey);
        default:
            return (0, $7kixv.Observable).throw(new Error(`fieldType ${newValue.fieldType} not supported`));
    }
};
const $6d53f2c2bd12b2de$export$a57c24e3bce9af0e = (event, field, fieldData)=>{
    const { oldId: oldId, oldCategory: oldCategory, newId: newId, newCategory: newCategory } = fieldData;
    (0, $gCeeo.fireTrackAnalytics)(event, 'issueFields updated', {
        updatedField: field,
        updatedFieldOldID: oldId,
        updatedFieldNewID: newId,
        statusCategoryOld: oldCategory,
        statusCategoryNew: newCategory
    });
};

});
parcelRegister("814y1", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $1e0b34ed3288576a$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $1e0b34ed3288576a$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $1e0b34ed3288576a$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $1e0b34ed3288576a$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $1e0b34ed3288576a$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $1e0b34ed3288576a$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $1e0b34ed3288576a$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $1e0b34ed3288576a$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $1e0b34ed3288576a$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $1e0b34ed3288576a$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $1e0b34ed3288576a$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $1e0b34ed3288576a$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $1e0b34ed3288576a$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $1e0b34ed3288576a$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $1e0b34ed3288576a$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $1e0b34ed3288576a$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $1e0b34ed3288576a$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $1e0b34ed3288576a$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $1e0b34ed3288576a$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $1e0b34ed3288576a$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $1e0b34ed3288576a$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $1e0b34ed3288576a$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $1e0b34ed3288576a$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $1e0b34ed3288576a$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $1e0b34ed3288576a$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $1e0b34ed3288576a$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $1e0b34ed3288576a$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $1e0b34ed3288576a$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $1e0b34ed3288576a$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $1e0b34ed3288576a$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $1e0b34ed3288576a$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $1e0b34ed3288576a$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $1e0b34ed3288576a$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $1e0b34ed3288576a$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $1e0b34ed3288576a$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $1e0b34ed3288576a$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $1e0b34ed3288576a$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $1e0b34ed3288576a$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $1e0b34ed3288576a$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $1e0b34ed3288576a$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $1e0b34ed3288576a$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $1e0b34ed3288576a$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $1e0b34ed3288576a$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $1e0b34ed3288576a$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $1e0b34ed3288576a$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $1e0b34ed3288576a$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $1e0b34ed3288576a$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $1e0b34ed3288576a$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $1e0b34ed3288576a$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $1e0b34ed3288576a$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $1e0b34ed3288576a$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $1e0b34ed3288576a$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $1e0b34ed3288576a$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $1e0b34ed3288576a$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $1e0b34ed3288576a$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $1e0b34ed3288576a$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $1e0b34ed3288576a$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $1e0b34ed3288576a$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $1e0b34ed3288576a$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $1e0b34ed3288576a$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $1e0b34ed3288576a$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $1e0b34ed3288576a$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $1e0b34ed3288576a$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $1e0b34ed3288576a$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $1e0b34ed3288576a$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $1e0b34ed3288576a$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $1e0b34ed3288576a$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $1e0b34ed3288576a$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $1e0b34ed3288576a$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $1e0b34ed3288576a$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $1e0b34ed3288576a$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $1e0b34ed3288576a$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $1e0b34ed3288576a$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $1e0b34ed3288576a$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $1e0b34ed3288576a$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $1e0b34ed3288576a$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $1e0b34ed3288576a$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $1e0b34ed3288576a$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $1e0b34ed3288576a$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $1e0b34ed3288576a$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $1e0b34ed3288576a$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $1e0b34ed3288576a$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $1e0b34ed3288576a$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $1e0b34ed3288576a$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $1e0b34ed3288576a$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $1e0b34ed3288576a$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $1e0b34ed3288576a$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $1e0b34ed3288576a$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $1e0b34ed3288576a$export$798d2f5814884447);
$parcel$export(module.exports, "FORGE_STRING_TYPE", () => $1e0b34ed3288576a$export$1e188101081be3f8);
$parcel$export(module.exports, "FORGE_STRING_LIST_TYPE", () => $1e0b34ed3288576a$export$caf3b3f20c0589b9);
$parcel$export(module.exports, "FORGE_NUMBER_TYPE", () => $1e0b34ed3288576a$export$9bdf08a1276e866c);
$parcel$export(module.exports, "FORGE_DATE_TYPE", () => $1e0b34ed3288576a$export$996c3d3eb2880229);
$parcel$export(module.exports, "FORGE_DATETIME_TYPE", () => $1e0b34ed3288576a$export$578c5856bf684e2a);
$parcel$export(module.exports, "FORGE_USER_TYPE", () => $1e0b34ed3288576a$export$38791c0fdd0bcce);
$parcel$export(module.exports, "FORGE_USER_LIST_TYPE", () => $1e0b34ed3288576a$export$5c209e1debd6c274);
$parcel$export(module.exports, "FORGE_GROUP_TYPE", () => $1e0b34ed3288576a$export$8646fecba9a8be61);
$parcel$export(module.exports, "FORGE_GROUP_LIST_TYPE", () => $1e0b34ed3288576a$export$68b91cd2f2e6b810);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $1e0b34ed3288576a$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $1e0b34ed3288576a$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $1e0b34ed3288576a$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $1e0b34ed3288576a$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $1e0b34ed3288576a$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $1e0b34ed3288576a$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $1e0b34ed3288576a$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $1e0b34ed3288576a$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $1e0b34ed3288576a$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $1e0b34ed3288576a$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $1e0b34ed3288576a$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $1e0b34ed3288576a$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $1e0b34ed3288576a$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $1e0b34ed3288576a$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $1e0b34ed3288576a$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $1e0b34ed3288576a$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $1e0b34ed3288576a$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $1e0b34ed3288576a$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $1e0b34ed3288576a$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $1e0b34ed3288576a$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $1e0b34ed3288576a$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $1e0b34ed3288576a$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $1e0b34ed3288576a$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $1e0b34ed3288576a$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $1e0b34ed3288576a$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $1e0b34ed3288576a$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $1e0b34ed3288576a$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $1e0b34ed3288576a$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $1e0b34ed3288576a$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $1e0b34ed3288576a$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $1e0b34ed3288576a$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $1e0b34ed3288576a$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $1e0b34ed3288576a$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $1e0b34ed3288576a$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $1e0b34ed3288576a$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $1e0b34ed3288576a$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $1e0b34ed3288576a$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $1e0b34ed3288576a$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $1e0b34ed3288576a$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $1e0b34ed3288576a$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $1e0b34ed3288576a$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $1e0b34ed3288576a$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $1e0b34ed3288576a$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $1e0b34ed3288576a$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $1e0b34ed3288576a$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $1e0b34ed3288576a$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $1e0b34ed3288576a$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $1e0b34ed3288576a$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $1e0b34ed3288576a$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $1e0b34ed3288576a$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $1e0b34ed3288576a$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $1e0b34ed3288576a$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $1e0b34ed3288576a$export$7b79405842547ccb);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $1e0b34ed3288576a$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $1e0b34ed3288576a$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $1e0b34ed3288576a$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $1e0b34ed3288576a$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $1e0b34ed3288576a$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ANY_CF_TYPE", () => $1e0b34ed3288576a$export$8c0f7dd088e5671d);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $1e0b34ed3288576a$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $1e0b34ed3288576a$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $1e0b34ed3288576a$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $1e0b34ed3288576a$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $1e0b34ed3288576a$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $1e0b34ed3288576a$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $1e0b34ed3288576a$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $1e0b34ed3288576a$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $1e0b34ed3288576a$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $1e0b34ed3288576a$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $1e0b34ed3288576a$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $1e0b34ed3288576a$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $1e0b34ed3288576a$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $1e0b34ed3288576a$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $1e0b34ed3288576a$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $1e0b34ed3288576a$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $1e0b34ed3288576a$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $1e0b34ed3288576a$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $1e0b34ed3288576a$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $1e0b34ed3288576a$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $1e0b34ed3288576a$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $1e0b34ed3288576a$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $1e0b34ed3288576a$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $1e0b34ed3288576a$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $1e0b34ed3288576a$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $1e0b34ed3288576a$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $1e0b34ed3288576a$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $1e0b34ed3288576a$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $1e0b34ed3288576a$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $1e0b34ed3288576a$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $1e0b34ed3288576a$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $1e0b34ed3288576a$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $1e0b34ed3288576a$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $1e0b34ed3288576a$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $1e0b34ed3288576a$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $1e0b34ed3288576a$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $1e0b34ed3288576a$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $1e0b34ed3288576a$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $1e0b34ed3288576a$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $1e0b34ed3288576a$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $1e0b34ed3288576a$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $1e0b34ed3288576a$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $1e0b34ed3288576a$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $1e0b34ed3288576a$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $1e0b34ed3288576a$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $1e0b34ed3288576a$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $1e0b34ed3288576a$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $1e0b34ed3288576a$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $1e0b34ed3288576a$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $1e0b34ed3288576a$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $1e0b34ed3288576a$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $1e0b34ed3288576a$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $1e0b34ed3288576a$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $1e0b34ed3288576a$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "WORKLOG", () => $1e0b34ed3288576a$export$df36fc05622c402);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $1e0b34ed3288576a$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $1e0b34ed3288576a$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $1e0b34ed3288576a$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "DETAILS_PANEL_IN_EDIT_MODE", () => $1e0b34ed3288576a$export$f4909db381566ce3);
$parcel$export(module.exports, "ARE_FIELDS_REORDERED", () => $1e0b34ed3288576a$export$6159d4eb69c78696);
$parcel$export(module.exports, "HIDE_EMPTY_FIELDS", () => $1e0b34ed3288576a$export$962c5b8782b7a233);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $1e0b34ed3288576a$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $1e0b34ed3288576a$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $1e0b34ed3288576a$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $1e0b34ed3288576a$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $1e0b34ed3288576a$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $1e0b34ed3288576a$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $1e0b34ed3288576a$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $1e0b34ed3288576a$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $1e0b34ed3288576a$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $1e0b34ed3288576a$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $1e0b34ed3288576a$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $1e0b34ed3288576a$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $1e0b34ed3288576a$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $1e0b34ed3288576a$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $1e0b34ed3288576a$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $1e0b34ed3288576a$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $1e0b34ed3288576a$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $1e0b34ed3288576a$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $1e0b34ed3288576a$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "AGGREGATE_TIME_ORIGINAL_ESTIMATE", () => $1e0b34ed3288576a$export$871661506c0a91ea);
$parcel$export(module.exports, "AGGREGATE_TIME_ESTIMATE", () => $1e0b34ed3288576a$export$4a7ecfe931ab6c07);
$parcel$export(module.exports, "PROGRESS", () => $1e0b34ed3288576a$export$fbc5ebe2e580bf8b);
$parcel$export(module.exports, "AGGREGATE_PROGRESS", () => $1e0b34ed3288576a$export$aa3b37e271efd578);
$parcel$export(module.exports, "WORKRATIO", () => $1e0b34ed3288576a$export$444bffe6526fb5f2);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $1e0b34ed3288576a$export$3c3e26aadbfa2c32);

var $LFmXM = parcelRequire("LFmXM");

var $7jTnu = parcelRequire("7jTnu");
const $1e0b34ed3288576a$export$b144116dae474c88 = 'issue-link-search';
const $1e0b34ed3288576a$export$bc917bc699b25f75 = 'number';
const $1e0b34ed3288576a$export$5f26ca419fdffbe7 = 'string';
const $1e0b34ed3288576a$export$ce9bfd823c7e1a6d = 'datetime';
const $1e0b34ed3288576a$export$346b72b1f7cd6d5a = 'date';
const $1e0b34ed3288576a$export$b20fbcacd7942c2a = 'option2';
const $1e0b34ed3288576a$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $1e0b34ed3288576a$export$a2e8554bffc61ece = 'any';
const $1e0b34ed3288576a$export$f25cd4907cbb25b9 = 'array';
const $1e0b34ed3288576a$export$5600354b43577e17 = 'user';
const $1e0b34ed3288576a$export$5dbc9917f72d0d2a = 'group';
const $1e0b34ed3288576a$export$253649f07fb55948 = 'object';
const $1e0b34ed3288576a$export$eb39592ba5247ee7 = 'group-list';
const $1e0b34ed3288576a$export$f48a9be226105736 = 'array-string';
const $1e0b34ed3288576a$export$42e2e93fc721df5d = 'version';
const $1e0b34ed3288576a$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $1e0b34ed3288576a$export$7773375e72c953ed = 'approval-panel';
const $1e0b34ed3288576a$export$80ad0037098f3919 = 'project';
const $1e0b34ed3288576a$export$82db8a26de491dd2 = 'array';
const $1e0b34ed3288576a$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $1e0b34ed3288576a$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $1e0b34ed3288576a$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $1e0b34ed3288576a$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $1e0b34ed3288576a$export$c979d9c548c05133 = 'JiraBooleanField';
const $1e0b34ed3288576a$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $1e0b34ed3288576a$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $1e0b34ed3288576a$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $1e0b34ed3288576a$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $1e0b34ed3288576a$export$b0deb225eed90fbd = 'JiraCMDBField';
const $1e0b34ed3288576a$export$add3775cfea8fde3 = 'JiraColorField';
const $1e0b34ed3288576a$export$9631d4098abab3eb = 'JiraComponentsField';
const $1e0b34ed3288576a$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $1e0b34ed3288576a$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $1e0b34ed3288576a$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $1e0b34ed3288576a$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $1e0b34ed3288576a$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $1e0b34ed3288576a$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $1e0b34ed3288576a$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $1e0b34ed3288576a$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $1e0b34ed3288576a$export$6d8da4497234455 = 'JiraEpicLinkField';
const $1e0b34ed3288576a$export$9bcfac568e4fa59c = 'JiraFlagField';
const $1e0b34ed3288576a$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $1e0b34ed3288576a$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $1e0b34ed3288576a$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $1e0b34ed3288576a$export$810709f0c5c2e9db = 'JiraLabelsField';
const $1e0b34ed3288576a$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $1e0b34ed3288576a$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $1e0b34ed3288576a$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $1e0b34ed3288576a$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $1e0b34ed3288576a$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $1e0b34ed3288576a$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $1e0b34ed3288576a$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $1e0b34ed3288576a$export$31aea7548807c6b5 = 'JiraPeopleField';
const $1e0b34ed3288576a$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $1e0b34ed3288576a$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $1e0b34ed3288576a$export$12f54499c6252188 = 'JiraProjectField';
const $1e0b34ed3288576a$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $1e0b34ed3288576a$export$c69486dd643dfb69 = 'JiraReporterField';
const $1e0b34ed3288576a$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $1e0b34ed3288576a$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $1e0b34ed3288576a$export$37f4daaa7b409554 = 'JiraRichTextField';
const $1e0b34ed3288576a$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $1e0b34ed3288576a$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $1e0b34ed3288576a$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $1e0b34ed3288576a$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $1e0b34ed3288576a$export$e40f819979b3881d = 'JiraStatusField';
const $1e0b34ed3288576a$export$6c243704a22baffe = 'JiraTeamField';
const $1e0b34ed3288576a$export$6c32429bac235203 = 'JiraTeamViewField';
const $1e0b34ed3288576a$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $1e0b34ed3288576a$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $1e0b34ed3288576a$export$37ccd11f08a93ccb = 'JiraUrlField';
const $1e0b34ed3288576a$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $1e0b34ed3288576a$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $1e0b34ed3288576a$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $1e0b34ed3288576a$export$aa815aaa741ae18 = 'JiraWatchesField';
const $1e0b34ed3288576a$export$e805f89b15d2abf4 = 'JiraAssetField';
const $1e0b34ed3288576a$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $1e0b34ed3288576a$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $1e0b34ed3288576a$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $1e0b34ed3288576a$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $1e0b34ed3288576a$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $1e0b34ed3288576a$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $1e0b34ed3288576a$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $1e0b34ed3288576a$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $1e0b34ed3288576a$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $1e0b34ed3288576a$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $1e0b34ed3288576a$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $1e0b34ed3288576a$export$c48132adab502d6b = 'JiraForgeUsersField';
const $1e0b34ed3288576a$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $1e0b34ed3288576a$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $1e0b34ed3288576a$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $1e0b34ed3288576a$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $1e0b34ed3288576a$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $1e0b34ed3288576a$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $1e0b34ed3288576a$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $1e0b34ed3288576a$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $1e0b34ed3288576a$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $1e0b34ed3288576a$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $1e0b34ed3288576a$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $1e0b34ed3288576a$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $1e0b34ed3288576a$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $1e0b34ed3288576a$export$bfcb1a91094f113a = 'JiraGoalsField';
const $1e0b34ed3288576a$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $1e0b34ed3288576a$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $1e0b34ed3288576a$export$798d2f5814884447 = 'forgeCustomField';
const $1e0b34ed3288576a$export$1e188101081be3f8 = 'forge/string';
const $1e0b34ed3288576a$export$caf3b3f20c0589b9 = 'forge/string-list';
const $1e0b34ed3288576a$export$9bdf08a1276e866c = 'forge/number';
const $1e0b34ed3288576a$export$996c3d3eb2880229 = 'forge/date';
const $1e0b34ed3288576a$export$578c5856bf684e2a = 'forge/datetime';
const $1e0b34ed3288576a$export$38791c0fdd0bcce = 'forge/user';
const $1e0b34ed3288576a$export$5c209e1debd6c274 = 'forge/user-list';
const $1e0b34ed3288576a$export$8646fecba9a8be61 = 'forge/group';
const $1e0b34ed3288576a$export$68b91cd2f2e6b810 = 'forge/group-list';
const $1e0b34ed3288576a$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $1e0b34ed3288576a$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $1e0b34ed3288576a$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $1e0b34ed3288576a$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $1e0b34ed3288576a$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $1e0b34ed3288576a$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $1e0b34ed3288576a$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $1e0b34ed3288576a$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $1e0b34ed3288576a$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $1e0b34ed3288576a$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $1e0b34ed3288576a$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $1e0b34ed3288576a$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $1e0b34ed3288576a$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $1e0b34ed3288576a$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $1e0b34ed3288576a$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $1e0b34ed3288576a$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $1e0b34ed3288576a$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $1e0b34ed3288576a$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $1e0b34ed3288576a$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $1e0b34ed3288576a$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $1e0b34ed3288576a$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $1e0b34ed3288576a$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $1e0b34ed3288576a$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $1e0b34ed3288576a$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $1e0b34ed3288576a$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $1e0b34ed3288576a$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $1e0b34ed3288576a$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $1e0b34ed3288576a$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $1e0b34ed3288576a$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $1e0b34ed3288576a$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $1e0b34ed3288576a$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $1e0b34ed3288576a$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $1e0b34ed3288576a$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $1e0b34ed3288576a$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $1e0b34ed3288576a$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $1e0b34ed3288576a$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $1e0b34ed3288576a$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $1e0b34ed3288576a$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $1e0b34ed3288576a$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $1e0b34ed3288576a$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $1e0b34ed3288576a$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $1e0b34ed3288576a$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $1e0b34ed3288576a$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $1e0b34ed3288576a$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $1e0b34ed3288576a$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $1e0b34ed3288576a$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $1e0b34ed3288576a$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $1e0b34ed3288576a$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $1e0b34ed3288576a$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $1e0b34ed3288576a$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $1e0b34ed3288576a$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $1e0b34ed3288576a$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $1e0b34ed3288576a$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $1e0b34ed3288576a$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $1e0b34ed3288576a$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $1e0b34ed3288576a$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $1e0b34ed3288576a$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $1e0b34ed3288576a$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $1e0b34ed3288576a$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $1e0b34ed3288576a$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $1e0b34ed3288576a$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $1e0b34ed3288576a$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $1e0b34ed3288576a$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $1e0b34ed3288576a$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $1e0b34ed3288576a$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $1e0b34ed3288576a$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $1e0b34ed3288576a$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $1e0b34ed3288576a$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $1e0b34ed3288576a$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $1e0b34ed3288576a$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $1e0b34ed3288576a$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $1e0b34ed3288576a$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $1e0b34ed3288576a$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $1e0b34ed3288576a$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $1e0b34ed3288576a$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $1e0b34ed3288576a$export$8c0f7dd088e5671d = 'any.custom.field.type';
const $1e0b34ed3288576a$export$fba8634fd401ba8b = 'assignee';
const $1e0b34ed3288576a$export$a91aea2438afcce8 = 'reporter';
const $1e0b34ed3288576a$export$b159f8b8f27aae4c = 'duedate';
const $1e0b34ed3288576a$export$34740f8d07d23ac0 = 'priority';
const $1e0b34ed3288576a$export$43b6e33ec70f2272 = 'labels';
const $1e0b34ed3288576a$export$ff39ebd4bb12b718 = 'created';
const $1e0b34ed3288576a$export$cd8e68094cb5c3cb = 'updated';
const $1e0b34ed3288576a$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $1e0b34ed3288576a$export$37abf56f13f61ec5 = 'components';
const $1e0b34ed3288576a$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $1e0b34ed3288576a$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $1e0b34ed3288576a$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $1e0b34ed3288576a$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $1e0b34ed3288576a$export$791007408faf42f4 = 'servicedesk-incident-management';
const $1e0b34ed3288576a$export$827a1c600bac12a3 = 'devSummary';
const $1e0b34ed3288576a$export$e9ba671d077969f8 = 'releases';
const $1e0b34ed3288576a$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $1e0b34ed3288576a$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $1e0b34ed3288576a$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $1e0b34ed3288576a$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $1e0b34ed3288576a$export$a5c9f63aadcb220 = 'fixVersions';
const $1e0b34ed3288576a$export$94009605902e4fe5 = 'versions';
const $1e0b34ed3288576a$export$5e7324042f1d6b31 = 'description';
const $1e0b34ed3288576a$export$113281d03e6830ef = 'environment';
const $1e0b34ed3288576a$export$5ff798870a3dffbf = 'watches';
const $1e0b34ed3288576a$export$907219511d14ba3d = 'summary';
const $1e0b34ed3288576a$export$d09aa6a4f3538063 = 'proforma-forms';
const $1e0b34ed3288576a$export$3aca8c91b58a42e2 = 'resolution';
const $1e0b34ed3288576a$export$ccb5ffefbf8b987c = 'timetracking';
const $1e0b34ed3288576a$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $1e0b34ed3288576a$export$358267065be1e = 'status';
const $1e0b34ed3288576a$export$dcaa788c7ada56de = 'statusCategory';
const $1e0b34ed3288576a$export$ebb48b08205007c5 = 'issuetype';
const $1e0b34ed3288576a$export$5e91047fe9955d0e = 'issuekey';
const $1e0b34ed3288576a$export$3b3d0889022c85b3 = 'children-issues';
const $1e0b34ed3288576a$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $1e0b34ed3288576a$export$8fe3d5be8cb17459 = 'epic-issues';
const $1e0b34ed3288576a$export$335851d83a79891 = 'hierarchy-level-below';
const $1e0b34ed3288576a$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $1e0b34ed3288576a$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $1e0b34ed3288576a$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $1e0b34ed3288576a$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $1e0b34ed3288576a$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $1e0b34ed3288576a$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $1e0b34ed3288576a$export$7b3d247435a784fa = 'SLA_PANEL';
const $1e0b34ed3288576a$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $1e0b34ed3288576a$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $1e0b34ed3288576a$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $1e0b34ed3288576a$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $1e0b34ed3288576a$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $1e0b34ed3288576a$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $1e0b34ed3288576a$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $1e0b34ed3288576a$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $1e0b34ed3288576a$export$22f61ccc2730431f = 'similar-issues';
const $1e0b34ed3288576a$export$8bbb446f57294715 = 'subtasks';
const $1e0b34ed3288576a$export$34fcd7cb291a1e4d = 'votes';
const $1e0b34ed3288576a$export$5e93f2a57cc4ca3a = 'parent';
const $1e0b34ed3288576a$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $1e0b34ed3288576a$export$91a9dba2d38d9a6f = 'project';
const $1e0b34ed3288576a$export$df36fc05622c402 = 'worklog';
const $1e0b34ed3288576a$export$ede0a4c20124ec85 = 'timespent';
const $1e0b34ed3288576a$export$3eeb79d48fb5f667 = 'dataclassification';
const $1e0b34ed3288576a$export$45e72c9a63ab61ab = 'SENTIMENT';
const $1e0b34ed3288576a$export$f4909db381566ce3 = 'DETAILS_PANEL_IN_EDIT_MODE';
const $1e0b34ed3288576a$export$6159d4eb69c78696 = 'ARE_FIELDS_REORDERED';
const $1e0b34ed3288576a$export$962c5b8782b7a233 = 'HIDE_EMPTY_FIELDS';
const $1e0b34ed3288576a$export$99ad62164189f781 = 'ecosystemGlance';
const $1e0b34ed3288576a$export$7719ef6e9283671 = 'forgeGlance';
const $1e0b34ed3288576a$export$bfebea5ce2e1887a = 'ecosystemContext';
const $1e0b34ed3288576a$export$be8e68fb1aed253e = 'forgeContext';
const $1e0b34ed3288576a$export$84e5674890d55030 = 'issuerestriction';
const $1e0b34ed3288576a$export$326a5522a485e43d = 'security';
const $1e0b34ed3288576a$export$c9f3f01e2c535302 = 'securitylevel';
const $1e0b34ed3288576a$export$35e5652f764785bd = 'creator';
const $1e0b34ed3288576a$export$66519f3bbff1796a = 'team';
const $1e0b34ed3288576a$export$a4ee0bca77cc8463 = 'estimate';
const $1e0b34ed3288576a$export$fed53408e89e0497 = 'dueDate';
const $1e0b34ed3288576a$export$d53c26f9ce31f56b = 'targetStart';
const $1e0b34ed3288576a$export$48f82d653f85e459 = 'targetEnd';
const $1e0b34ed3288576a$export$ea5a888f39f722c7 = 'startDate';
const $1e0b34ed3288576a$export$f245bbec12cc0e40 = 'color';
const $1e0b34ed3288576a$export$aed630b4b7114a59 = 'attachment';
const $1e0b34ed3288576a$export$b50c1a8fef07104 = 'issuelinks';
const $1e0b34ed3288576a$export$ea3d72f4bb7738ba = 'timeestimate';
const $1e0b34ed3288576a$export$a4cab0124760d860 = 'comment';
const $1e0b34ed3288576a$export$734929aef118d7e2 = 'worklog';
const $1e0b34ed3288576a$export$ffbacacb07c1d46d = 'parent';
const $1e0b34ed3288576a$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $1e0b34ed3288576a$export$278c072e2f9176ab = 'aggregatetimespent';
const $1e0b34ed3288576a$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $1e0b34ed3288576a$export$fbc5ebe2e580bf8b = 'progress';
const $1e0b34ed3288576a$export$aa3b37e271efd578 = 'aggregateprogress';
const $1e0b34ed3288576a$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $1e0b34ed3288576a$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $1e0b34ed3288576a$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $1e0b34ed3288576a$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $1e0b34ed3288576a$export$34740f8d07d23ac0,
        REPORTER_TYPE: $1e0b34ed3288576a$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $1e0b34ed3288576a$export$5e7324042f1d6b31,
        LABELS_TYPE: $1e0b34ed3288576a$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $1e0b34ed3288576a$export$37abf56f13f61ec5,
        SPRINT_TYPE: $1e0b34ed3288576a$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $1e0b34ed3288576a$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $1e0b34ed3288576a$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $1e0b34ed3288576a$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $1e0b34ed3288576a$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $1e0b34ed3288576a$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $1e0b34ed3288576a$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $1e0b34ed3288576a$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $1e0b34ed3288576a$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $1e0b34ed3288576a$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $1e0b34ed3288576a$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $1e0b34ed3288576a$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $1e0b34ed3288576a$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $1e0b34ed3288576a$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $1e0b34ed3288576a$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $1e0b34ed3288576a$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $1e0b34ed3288576a$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $1e0b34ed3288576a$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $1e0b34ed3288576a$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $1e0b34ed3288576a$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $1e0b34ed3288576a$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $1e0b34ed3288576a$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $1e0b34ed3288576a$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $1e0b34ed3288576a$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $1e0b34ed3288576a$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $1e0b34ed3288576a$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $1e0b34ed3288576a$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $1e0b34ed3288576a$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $1e0b34ed3288576a$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $1e0b34ed3288576a$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $1e0b34ed3288576a$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $1e0b34ed3288576a$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $1e0b34ed3288576a$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $1e0b34ed3288576a$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $1e0b34ed3288576a$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $1e0b34ed3288576a$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $1e0b34ed3288576a$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $1e0b34ed3288576a$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $1e0b34ed3288576a$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $1e0b34ed3288576a$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $1e0b34ed3288576a$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $1e0b34ed3288576a$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $1e0b34ed3288576a$export$39866626496bbfc8,
        VERSION_CF_TYPE: $1e0b34ed3288576a$export$24382b4e8c58336b,
        DATE_CF_TYPE: $1e0b34ed3288576a$export$ff745f432984005d,
        GROUP_CF_TYPE: $1e0b34ed3288576a$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $1e0b34ed3288576a$export$b600addfa3355c57,
        USER_CF_TYPE: $1e0b34ed3288576a$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $1e0b34ed3288576a$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $1e0b34ed3288576a$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $1e0b34ed3288576a$export$65524be5675e57e6,
        TEAM_CF_TYPE: $1e0b34ed3288576a$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $1e0b34ed3288576a$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $1e0b34ed3288576a$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $1e0b34ed3288576a$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $1e0b34ed3288576a$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $1e0b34ed3288576a$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $1e0b34ed3288576a$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $1e0b34ed3288576a$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $1e0b34ed3288576a$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $1e0b34ed3288576a$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $1e0b34ed3288576a$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $1e0b34ed3288576a$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $1e0b34ed3288576a$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $1e0b34ed3288576a$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $1e0b34ed3288576a$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $1e0b34ed3288576a$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $1e0b34ed3288576a$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $1e0b34ed3288576a$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $1e0b34ed3288576a$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $1e0b34ed3288576a$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $1e0b34ed3288576a$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $1e0b34ed3288576a$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $1e0b34ed3288576a$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $1e0b34ed3288576a$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $1e0b34ed3288576a$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $1e0b34ed3288576a$export$2bbb7f69c97ea279,
        PARENT_TYPE: $1e0b34ed3288576a$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $1e0b34ed3288576a$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $1e0b34ed3288576a$export$c23cfbdf83daa90d
    };
    Object.assign(types, {
        SENTIMENT_TYPE: $1e0b34ed3288576a$export$45e72c9a63ab61ab
    });
    if ((0, $7jTnu.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $1e0b34ed3288576a$export$d2a475ff30e5bf97
    });
    return types;
};
const $1e0b34ed3288576a$export$3c3e26aadbfa2c32 = (0, $LFmXM.default)($1e0b34ed3288576a$var$getLayoutFieldTypesNonMemoized);

});

parcelRegister("lz4M7", function(module, exports) {

$parcel$export(module.exports, "putFieldValue$", () => $496d98265b756dd6$export$1e79252a3a0c4801);

var $1K8u5 = parcelRequire("1K8u5");
const $496d98265b756dd6$var$getUpdateFieldValueUrl = (issueKey)=>`/rest/api/2/issue/${issueKey}`;
const $496d98265b756dd6$export$1e79252a3a0c4801 = (issueKey, newFieldValues)=>(0, $1K8u5.default)($496d98265b756dd6$var$getUpdateFieldValueUrl(issueKey), {
        method: 'PUT',
        body: JSON.stringify({
            fields: newFieldValues
        })
    });

});


parcelRegister("2is8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6d23919ab055352$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e6d23919ab055352$var$preventKeyDownProp = (inEditState)=>(e)=>{
        if (inEditState || e.key === 'Enter') e.stopPropagation();
    };
const $e6d23919ab055352$var$PreventKeyboardPropWrapper = ({ children: children, inEditState: inEditState })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        onKeyDown: $e6d23919ab055352$var$preventKeyDownProp(inEditState),
        role: "presentation"
    }, children);
var $e6d23919ab055352$export$2e2bcd8739ae039 = $e6d23919ab055352$var$PreventKeyboardPropWrapper;

});

parcelRegister("bNR2Y", function(module, exports) {

$parcel$export(module.exports, "getCurrentAssignee", () => $7b8af1bc13a18eb3$export$7ff716f0bdf4c335);

var $1Ozm9 = parcelRequire("1Ozm9");
const $7b8af1bc13a18eb3$var$getCurrentAssigneeUrl = (issueKey)=>`/rest/api/3/issue/${issueKey}?fields=assignee`;
const $7b8af1bc13a18eb3$export$7ff716f0bdf4c335 = (issueKey)=>(0, $1Ozm9.default)($7b8af1bc13a18eb3$var$getCurrentAssigneeUrl(issueKey), {
        method: 'GET'
    });

});


parcelRegister("3oX0a", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed844036c98af3d9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hjf2q = parcelRequire("hjf2q");

var $7xXvm = parcelRequire("7xXvm");

var $lcB5K = parcelRequire("lcB5K");

var $iASjg = parcelRequire("iASjg");

var $ffyBp = parcelRequire("ffyBp");

var $7Ij3u = parcelRequire("7Ij3u");
const $ed844036c98af3d9$var$SingleUserSelectWithAnalytics = (0, $hjf2q.AnalyticsEventToProps)('issueField', {
    onEditSuccess: 'updated'
})((0, $7Ij3u.default));
const $ed844036c98af3d9$var$SingleUserSelect = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed844036c98af3d9$var$SingleUserSelectWithAnalytics, {
            UserSelect: (0, $ffyBp.default),
            ProfileCard: (0, $7xXvm.default),
            AssigneeButton: (0, $iASjg.default),
            onPushAction: push,
            ...props
        }));
var $ed844036c98af3d9$export$2e2bcd8739ae039 = $ed844036c98af3d9$var$SingleUserSelect;

});
parcelRegister("7xXvm", function(module, exports) {

$parcel$export(module.exports, "ProfileCard", () => $329dd4b85ed15d85$export$bed540ccfa8743c4);
$parcel$export(module.exports, "default", () => $329dd4b85ed15d85$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");

var $4xbv3 = parcelRequire("4xbv3");

var $lcB5K = parcelRequire("lcB5K");

var $lRq8t = parcelRequire("lRq8t");

var $8q7lT = parcelRequire("8q7lT");

var $7jTnu = parcelRequire("7jTnu");

var $bJscI = parcelRequire("bJscI");

var $1KdDN = parcelRequire("1KdDN");


var $lFp9s = parcelRequire("lFp9s");

var $38H79 = parcelRequire("38H79");

var $28Csj = parcelRequire("28Csj");
const $329dd4b85ed15d85$var$ConditionalErrorBoundary = (0, $bJscI.componentWithFG)('empanada_profilecard_sync_trigger_import_final', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "profilecard",
        packageName: (0, $6d22448f78a7f25a$export$9345d7360ffe0722),
        fallback: "flag"
    }, children), (0, $eJOHy.Fragment));
const $329dd4b85ed15d85$export$bed540ccfa8743c4 = ({ externalProfileClient: externalProfileClient, accountId: accountId, actions: actions, analyticsData: analyticsData, children: children, position: position, testId: testId, trigger: trigger, prepopulatedData: prepopulatedData, ariaHideProfileTrigger: ariaHideProfileTrigger, isChildComment: isChildComment = false, shouldTruncate: shouldTruncate = false })=>{
    const intl = (0, $lRq8t.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const currentUserAccountId = (0, $8q7lT.useAccountId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($329dd4b85ed15d85$var$ConditionalErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: (0, $6d22448f78a7f25a$export$81319ffa9c0d18d7),
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lFp9s.ProfileCardWrapper), {
        externalProfileClient: externalProfileClient
    }, currentUserAccountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $28Csj.ProfileCardView), {
            accountId: accountId,
            actions: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $7jTnu.fg)('jira_nin_smart_link') && (0, $7jTnu.fg)('jsc_nin_smart_link_fast_follows') ? (0, $38H79.getSpaActions)(accountId, intl, actions) : (0, $38H79.getSpaActionsWithRouterPush)(accountId, intl, push, actions),
            position: position,
            onProfileClick: (profileAccountId)=>push(`/jira/people/${profileAccountId}`),
            addFlag: showFlag,
            dismissFlag: dismissFlag,
            testId: testId,
            trigger: trigger,
            prepopulatedData: prepopulatedData,
            ariaHideProfileTrigger: ariaHideProfileTrigger,
            isChildComment: isChildComment,
            shouldTruncate: shouldTruncate
        }, children)) : children)));
};
var $329dd4b85ed15d85$export$2e2bcd8739ae039 = $329dd4b85ed15d85$export$bed540ccfa8743c4;

});
const $6d22448f78a7f25a$export$9345d7360ffe0722 = 'jira-profilecard-next';
const $6d22448f78a7f25a$export$81319ffa9c0d18d7 = 'profileCardNext';
const $6d22448f78a7f25a$export$50632e21ea714398 = 'profileCardNextLegacy';
const $6d22448f78a7f25a$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $6d22448f78a7f25a$export$23cedd3261bd8015 = 'viewProfile';
const $6d22448f78a7f25a$export$6bef782d14a92db8 = 'assignedIssues';
const $6d22448f78a7f25a$export$6b36f20db7a18a86 = 'reportedIssues';
const $6d22448f78a7f25a$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("lFp9s", function(module, exports) {

$parcel$export(module.exports, "ProfileCardWrapper", () => $298aff9366b0951f$export$59abd6feb7dc8540);

var $eJOHy = parcelRequire("eJOHy");

var $kEUB1 = parcelRequire("kEUB1");

var $8q7lT = parcelRequire("8q7lT");

var $9hopi = parcelRequire("9hopi");

var $9yGgq = parcelRequire("9yGgq");

var $16TBK = parcelRequire("16TBK");
const $298aff9366b0951f$export$59abd6feb7dc8540 = ({ externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const accountId = (0, $8q7lT.useAccountId)();
    const fabricPfDirUrl = (0, $9yGgq.useFabricProfileDirectoryUrl)();
    const orgId = (0, $9hopi.useOrgId)();
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16TBK.ProfileClientContainer), {
        fabricPfDirUrl: fabricPfDirUrl,
        profileClient: externalProfileClient || null,
        onLoadError: onLoadError,
        cloudId: cloudId,
        // Only use the global store when no external client is provided
        isGlobal: !externalProfileClient,
        orgId: orgId
    }, children);
    // When there is no tenantContext, this will cause the child
    // component of <ProfileCard> to render without being wrapped by
    // a profile card and it will do nothing on hover
    return children;
};

});
parcelRegister("9hopi", function(module, exports) {

$parcel$export(module.exports, "useOrgId", () => $854fde3141521561$export$52a03a3207af3687);

var $lvKO5 = parcelRequire("lvKO5");
const $854fde3141521561$export$52a03a3207af3687 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.orgId;
};

});

parcelRegister("9yGgq", function(module, exports) {

$parcel$export(module.exports, "useFabricProfileDirectoryUrl", () => $3671ddc1abbfe28d$export$cb9379d435214a54);

var $lvKO5 = parcelRequire("lvKO5");
const $3671ddc1abbfe28d$export$cb9379d435214a54 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.fabricPfDirUrl || '';
};

});

parcelRegister("16TBK", function(module, exports) {

$parcel$export(module.exports, "createUserProfileCardClient", () => $ca869b060f836c8a$export$c4393c51e6d104c3);
$parcel$export(module.exports, "ProfileClientContainer", () => $ca869b060f836c8a$export$d816ba2709570028);
$parcel$export(module.exports, "useProfileClient", () => $ca869b060f836c8a$export$d43dc22a8337ee9f);

var $d5fwz = parcelRequire("d5fwz");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $aBTmI = parcelRequire("aBTmI");
const $ca869b060f836c8a$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
const $ca869b060f836c8a$export$c4393c51e6d104c3 = (fabricPfDirUrl, onLoadError, gatewayGraphqlUrl, cloudId, orgId)=>{
    const userClient = new (0, $aBTmI.CustomUserProfileClient)(fabricPfDirUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $d5fwz.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId,
        orgId: orgId
    }, {
        userClient: userClient
    });
};
const $ca869b060f836c8a$export$e324594224ef24da = {
    bootstrap: ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, profileClient: profileClient, onLoadError: onLoadError, cloudId: cloudId, orgId: orgId })=>{
            const finalProfileClient = profileClient || $ca869b060f836c8a$export$c4393c51e6d104c3(fabricPfDirUrl ?? '', onLoadError, $ca869b060f836c8a$var$GATEWAY_GRAPHQL_URL, cloudId, orgId);
            setState({
                profileClient: finalProfileClient
            });
        }
};
const $ca869b060f836c8a$export$d816ba2709570028 = (0, $6E16M.createContainer)({
    displayName: 'ProfileClientContainer'
});
const $ca869b060f836c8a$export$d4c72bab9d6cc13a = {
    profileClient: null
};
const $ca869b060f836c8a$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'ProfileClientStore',
    initialState: $ca869b060f836c8a$export$d4c72bab9d6cc13a,
    actions: $ca869b060f836c8a$export$e324594224ef24da,
    containedBy: $ca869b060f836c8a$export$d816ba2709570028,
    handlers: {
        onInit: ()=>({ dispatch: dispatch })=>dispatch($ca869b060f836c8a$export$e324594224ef24da.bootstrap())
    }
});
const $ca869b060f836c8a$export$d43dc22a8337ee9f = (0, $iJq0l.createStateHook)($ca869b060f836c8a$export$6f57813fe9f31bf9);

});
parcelRegister("d5fwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f71266daf2e15d5$export$2e2bcd8739ae039);


var $9PyvN = parcelRequire("9PyvN");


var $9uvjI = parcelRequire("9uvjI");
var $5f71266daf2e15d5$export$2e2bcd8739ae039 = (0, $9PyvN.default);

});
parcelRegister("9PyvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $495edb629a854866$export$2e2bcd8739ae039);

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");

var $bRjww = parcelRequire("bRjww");

var $49UfM = parcelRequire("49UfM");

var $52RFj = parcelRequire("52RFj");

var $9uvjI = parcelRequire("9uvjI");
const $495edb629a854866$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $495edb629a854866$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$495edb629a854866$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $495edb629a854866$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $9uvjI.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $52RFj.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $bRjww.default)(withDefaultConfig);
        this.tcClient = $495edb629a854866$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $8RHPx.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $8RHPx.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    getRovoAgentPermissions(id, fireAnalytics) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
}
function $495edb629a854866$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $lopBx.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $49UfM.default)({
        ...config
    }) : undefined;
}
var $495edb629a854866$export$2e2bcd8739ae039 = $495edb629a854866$var$ProfileCardClient;

});
parcelRegister("bRjww", function(module, exports) {

$parcel$export(module.exports, "default", () => $05e8b6328c708954$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $2EPX4 = parcelRequire("2EPX4");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");
const $05e8b6328c708954$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $05e8b6328c708954$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    basePath() {
        return (0, $eGOwo.fg)('pt-deprecate-assistance-service') ? '/gateway/api/assist/rovo/v1/agents' : '/gateway/api/assist/agents/v1';
    }
    makeRequest(id, cloudId) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
        if (id.type === 'identity') return fetch(new Request(`${this.basePath()}/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        return fetch(new Request(`${this.basePath()}/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`${this.basePath()}/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`${this.basePath()}/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("2EPX4", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $7d8a130fd15a8bb5$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $7d8a130fd15a8bb5$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $7d8a130fd15a8bb5$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $7d8a130fd15a8bb5$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $7d8a130fd15a8bb5$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $7d8a130fd15a8bb5$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $7d8a130fd15a8bb5$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $7d8a130fd15a8bb5$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $7d8a130fd15a8bb5$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $7d8a130fd15a8bb5$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $7d8a130fd15a8bb5$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $7d8a130fd15a8bb5$export$a9f8c9f412cf5664);

var $kNQN4 = parcelRequire("kNQN4");
/** Below lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $7d8a130fd15a8bb5$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $7d8a130fd15a8bb5$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $7d8a130fd15a8bb5$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$TEAM_SUBJECT = 'teamProfileCard';
const $7d8a130fd15a8bb5$var$USER_SUBJECT = 'profilecard';
const $7d8a130fd15a8bb5$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $7d8a130fd15a8bb5$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $kNQN4.getPageTime)())
        }
    });
const $7d8a130fd15a8bb5$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $7d8a130fd15a8bb5$var$USER_SUBJECT;
        case 'team':
            return $7d8a130fd15a8bb5$var$TEAM_SUBJECT;
        case 'agent':
            return $7d8a130fd15a8bb5$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $7d8a130fd15a8bb5$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $7d8a130fd15a8bb5$var$createEvent('ui', 'triggered', $7d8a130fd15a8bb5$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $7d8a130fd15a8bb5$export$c9b0e37b229a297b = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$12dae48763368ac9 = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$USER_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$41816a317479160b = (type, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'rendered', $7d8a130fd15a8bb5$var$getActionSubject(type), actionSubjectId, attributes);
const $7d8a130fd15a8bb5$export$fdcd134fbeb1f921 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$getActionSubject(type), 'action', attributes);
const $7d8a130fd15a8bb5$export$93260987012593be = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$USER_SUBJECT, 'reportingLines', attributes);
const $7d8a130fd15a8bb5$export$79befd155063a6a7 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$getActionSubject(type), 'moreActions', attributes);
const $7d8a130fd15a8bb5$export$2703289b35687fde = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'avatar', attributes);
const $7d8a130fd15a8bb5$export$b4411a7661cf2d3f = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $7d8a130fd15a8bb5$export$c86679da702d560e = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $7d8a130fd15a8bb5$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("kNQN4", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $64b9704217d393a1$export$e9faea7c41053334);
const $64b9704217d393a1$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $64b9704217d393a1$var$performanceAvailable = $64b9704217d393a1$var$isPerformanceAvailable();
const $64b9704217d393a1$var$initialPageTime = Date.now();
const $64b9704217d393a1$export$e9faea7c41053334 = ()=>{
    if ($64b9704217d393a1$var$performanceAvailable) return performance.now();
    return Date.now() - $64b9704217d393a1$var$initialPageTime;
};

});


parcelRegister("fqVaP", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc90275f52a03ea7$export$2e2bcd8739ae039);

var $7xkt0 = parcelRequire("7xkt0");
class $cc90275f52a03ea7$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $7xkt0.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});

parcelRegister("2stUb", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $3d31a5950b175c26$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $3d31a5950b175c26$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $3d31a5950b175c26$export$d9ad65d422ee3f8c);

var $as7HK = parcelRequire("as7HK");
const $3d31a5950b175c26$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $3d31a5950b175c26$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $3d31a5950b175c26$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $3d31a5950b175c26$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $as7HK.DirectoryGraphQLError)) return !!error && $3d31a5950b175c26$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $as7HK.AGGError)) return !!error.errorType && $3d31a5950b175c26$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $3d31a5950b175c26$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $3d31a5950b175c26$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $as7HK.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($3d31a5950b175c26$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($3d31a5950b175c26$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $as7HK.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$3d31a5950b175c26$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $as7HK.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($3d31a5950b175c26$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($3d31a5950b175c26$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $as7HK.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$3d31a5950b175c26$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $as7HK.DirectoryGraphQLErrors) || causeError instanceof (0, $as7HK.AGGErrors)) return $3d31a5950b175c26$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $3d31a5950b175c26$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $as7HK.DirectoryGraphQLErrors)(errors, traceId);
};
const $3d31a5950b175c26$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $as7HK.AGGErrors)(errors, traceId);
};

});
parcelRegister("as7HK", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $e980080011a8d765$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $e980080011a8d765$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $e980080011a8d765$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $e980080011a8d765$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $e980080011a8d765$export$60d8267243755b9c);
class $e980080011a8d765$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $e980080011a8d765$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $e980080011a8d765$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $e980080011a8d765$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $e980080011a8d765$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $e980080011a8d765$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $e980080011a8d765$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});



parcelRegister("49UfM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b519ebe8bdd19c29$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $fqVaP = parcelRequire("fqVaP");

var $jjeHq = parcelRequire("jjeHq");

var $4qbZy = parcelRequire("4qbZy");
const $b519ebe8bdd19c29$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $b519ebe8bdd19c29$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $b519ebe8bdd19c29$var$orgIdPromiseCache = new Map();
const $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache = new Map();
class $b519ebe8bdd19c29$var$TeamCentralCardClient extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
	 * `public` so that mock client can override it; do not use it otherwise!
	 */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = $b519ebe8bdd19c29$export$1862ef0c3880ca8d(userId);
        const response = await (0, $4qbZy.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $eGOwo.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $eGOwo.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $b519ebe8bdd19c29$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return Promise.resolve(workspaceType);
            }
        } catch (err) {
            return Promise.resolve(undefined);
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $b519ebe8bdd19c29$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $jjeHq.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
        $b519ebe8bdd19c29$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $b519ebe8bdd19c29$export$2e2bcd8739ae039 = $b519ebe8bdd19c29$var$TeamCentralCardClient;

});
parcelRegister("jjeHq", function(module, exports) {

$parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", () => $a1fbf8b2b4930fa8$export$d38a536fd806c68f);

var $4qbZy = parcelRequire("4qbZy");
const $a1fbf8b2b4930fa8$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $a1fbf8b2b4930fa8$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $a1fbf8b2b4930fa8$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $a1fbf8b2b4930fa8$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $4qbZy.AGGQuery)(url, query, $a1fbf8b2b4930fa8$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}

});
parcelRegister("4qbZy", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $79a99a18e51eddf3$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $79a99a18e51eddf3$export$a14afb5f82fe705);

var $as7HK = parcelRequire("as7HK");

var $2stUb = parcelRequire("2stUb");
const $79a99a18e51eddf3$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $79a99a18e51eddf3$var$id = (headers)=>headers;
async function $79a99a18e51eddf3$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id) {
    return $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $2stUb.handleDirectoryGraphQLErrors));
}
async function $79a99a18e51eddf3$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id) {
    return $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $2stUb.handleAGGErrors));
}
async function $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id, handleErrors) {
    const headers = processHeaders($79a99a18e51eddf3$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $as7HK.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});



parcelRegister("52RFj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8330ec0bc030b200$export$2e2bcd8739ae039);

var $2EPX4 = parcelRequire("2EPX4");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");

var $7jwft = parcelRequire("7jwft");
class $8330ec0bc030b200$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $7jwft.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('succeeded', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('failed', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("7jwft", function(module, exports) {

$parcel$export(module.exports, "extractIdFromAri", () => $34e7bc800a4991e6$export$5816a09dbb711691);
$parcel$export(module.exports, "getTeamFromAGG", () => $34e7bc800a4991e6$export$26a8aad0c7182dd6);

var $4qbZy = parcelRequire("4qbZy");
const $34e7bc800a4991e6$var$ARI_PREFIX = 'ari:cloud:identity::team/';
const $34e7bc800a4991e6$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $34e7bc800a4991e6$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $34e7bc800a4991e6$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($34e7bc800a4991e6$var$ARI_PREFIX) ? teamIdOrTeamAri : $34e7bc800a4991e6$export$681597d03c8a0fd2(teamIdOrTeamAri);
const $34e7bc800a4991e6$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $34e7bc800a4991e6$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $34e7bc800a4991e6$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $34e7bc800a4991e6$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$34e7bc800a4991e6$var$TEAM_FRAGMENT}
    }
  }
}`;
const $34e7bc800a4991e6$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $34e7bc800a4991e6$export$4968f4e0119a5d9c,
        variables: {
            teamId: $34e7bc800a4991e6$export$7878e28c136af76(teamId),
            siteId: siteId || 'None'
        }
    });
const $34e7bc800a4991e6$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $34e7bc800a4991e6$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $34e7bc800a4991e6$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $4qbZy.AGGQuery)(url, query, $34e7bc800a4991e6$export$1229c72526c01df2);
    return $34e7bc800a4991e6$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("9uvjI", function(module, exports) {

$parcel$export(module.exports, "default", () => $467a485168b1cd0d$export$2e2bcd8739ae039);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");

var $eGOwo = parcelRequire("eGOwo");

var $2EPX4 = parcelRequire("2EPX4");

var $hX5cm = parcelRequire("hX5cm");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");

var $4qbZy = parcelRequire("4qbZy");
const $467a485168b1cd0d$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $467a485168b1cd0d$var$aggUserQuery = (0, $kuAvn.default)`
	query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`;
const $467a485168b1cd0d$var$aggUserQueryString = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;
const $467a485168b1cd0d$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $eGOwo.fg)('platform_agg_user_query_doc_change') ? (0, $6NFTG.print)($467a485168b1cd0d$var$aggUserQuery) : $467a485168b1cd0d$var$aggUserQueryString,
        variables: {
            userId: userId
        }
    });
const $467a485168b1cd0d$var$queryAGGUser = async (url, userId)=>{
    const query = $467a485168b1cd0d$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $4qbZy.AGGQuery)(url, query);
    return user;
};
class $467a485168b1cd0d$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $467a485168b1cd0d$var$queryAGGUser(urlWithOperationName, userId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        const timeFormat = (0, $eGOwo.fg)('platform_profilecard-update-time-format') ? 'h:mmaaa' : 'h:mmbbb';
        if (user.zoneinfo) {
            if ((0, $hX5cm.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $hX5cm.localTime)(user.zoneinfo, timeFormat) || undefined;
            else timestring = (0, $hX5cm.localTime)(user.zoneinfo, `eee ${timeFormat}`) || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            isServiceAccount: user.__typename === 'AppUser' && user.appType === 'service',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('succeeded', {
                    duration: (0, $kNQN4.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('failed', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("hX5cm", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $98ebf9c8b6385a65$export$f0dfd716e7b023cd);
parcelRequire("7XJii");
var $iLEEy = parcelRequire("iLEEy");
const $98ebf9c8b6385a65$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $iLEEy.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("7XJii", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("iLEEy")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $iLEEy = parcelRequire("iLEEy");





});
parcelRegister("iLEEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $da9c26a946bf047b$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $a4wuW = parcelRequire("a4wuW");

var $iEVvn = parcelRequire("iEVvn");
function $da9c26a946bf047b$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $a4wuW.default)((0, $iEVvn.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("a4wuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $75537c87aa32bbea$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $jn1Yb = parcelRequire("jn1Yb");

var $bWiNt = parcelRequire("bWiNt");
var $75537c87aa32bbea$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $75537c87aa32bbea$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($75537c87aa32bbea$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $bWiNt.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $jn1Yb.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("jn1Yb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a1b16befdfb889$export$2e2bcd8739ae039);

var $emmbH = parcelRequire("emmbH");

var $a2zuC = parcelRequire("a2zuC");
var $e1a1b16befdfb889$var$MILLISECONDS_IN_MINUTE = 60000;
var $e1a1b16befdfb889$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $e1a1b16befdfb889$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $emmbH.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $emmbH.default)('long', date, options);
        }
    }
};
function $e1a1b16befdfb889$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $a2zuC.default)(timeZone, originalDate, true) / $e1a1b16befdfb889$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $e1a1b16befdfb889$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $e1a1b16befdfb889$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $e1a1b16befdfb889$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $e1a1b16befdfb889$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $e1a1b16befdfb889$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $e1a1b16befdfb889$var$formatTimezone(offset, dirtyDelimeter);
}
function $e1a1b16befdfb889$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $e1a1b16befdfb889$var$addLeadingZeros(minutes, 2);
}
var $e1a1b16befdfb889$export$2e2bcd8739ae039 = $e1a1b16befdfb889$var$formatters;

});
parcelRegister("emmbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a74454c810e10efc$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $a74454c810e10efc$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $a74454c810e10efc$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $a74454c810e10efc$var$partsTimeZone(dtf, date) : $a74454c810e10efc$var$hackyTimeZone(dtf, date);
}
function $a74454c810e10efc$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $a74454c810e10efc$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $a74454c810e10efc$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("a2zuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f59f73042f5ea2$export$2e2bcd8739ae039);

var $iKmlv = parcelRequire("iKmlv");

var $eMjjs = parcelRequire("eMjjs");
var $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR = 3600000;
var $74f59f73042f5ea2$var$MILLISECONDS_IN_MINUTE = 60000;
var $74f59f73042f5ea2$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $74f59f73042f5ea2$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $74f59f73042f5ea2$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $74f59f73042f5ea2$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$74f59f73042f5ea2$var$validateTimezone(hours)) return NaN;
        return -(hours * $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $74f59f73042f5ea2$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$74f59f73042f5ea2$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR + minutes * $74f59f73042f5ea2$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($74f59f73042f5ea2$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $74f59f73042f5ea2$var$toUtcDate(date);
        var offset = $74f59f73042f5ea2$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $74f59f73042f5ea2$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $74f59f73042f5ea2$var$toUtcDate(date) {
    return (0, $eMjjs.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $74f59f73042f5ea2$var$calcOffset(date, timezoneString) {
    var tokens = (0, $iKmlv.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $eMjjs.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $74f59f73042f5ea2$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $74f59f73042f5ea2$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $74f59f73042f5ea2$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $74f59f73042f5ea2$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $74f59f73042f5ea2$var$validIANATimezoneCache = {};
function $74f59f73042f5ea2$var$isValidTimezoneIANAString(timeZoneString) {
    if ($74f59f73042f5ea2$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $74f59f73042f5ea2$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("iKmlv", function(module, exports) {

$parcel$export(module.exports, "default", () => $da5ddb5213ce8f83$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $da5ddb5213ce8f83$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $da5ddb5213ce8f83$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $da5ddb5213ce8f83$var$partsOffset(dtf, date) : $da5ddb5213ce8f83$var$hackyOffset(dtf, date);
}
var $da5ddb5213ce8f83$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $da5ddb5213ce8f83$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $da5ddb5213ce8f83$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $da5ddb5213ce8f83$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $da5ddb5213ce8f83$var$dtfCache = {};
function $da5ddb5213ce8f83$var$getDateTimeFormat(timeZone) {
    if (!$da5ddb5213ce8f83$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $da5ddb5213ce8f83$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $da5ddb5213ce8f83$var$dtfCache[timeZone];
}

});

parcelRegister("eMjjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac2487857a682a48$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $ac2487857a682a48$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("bWiNt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b13b1308e9ec166$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $a2zuC = parcelRequire("a2zuC");

var $cIjNZ = parcelRequire("cIjNZ");
var $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR = 3600000;
var $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE = 60000;
var $8b13b1308e9ec166$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $8b13b1308e9ec166$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $cIjNZ.default)
};
function $8b13b1308e9ec166$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $8b13b1308e9ec166$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $8b13b1308e9ec166$var$splitDateString(argument);
    var parseYearResult = $8b13b1308e9ec166$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $8b13b1308e9ec166$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $8b13b1308e9ec166$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $a2zuC.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $8b13b1308e9ec166$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $8b13b1308e9ec166$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $8b13b1308e9ec166$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $8b13b1308e9ec166$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $8b13b1308e9ec166$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $8b13b1308e9ec166$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $8b13b1308e9ec166$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $8b13b1308e9ec166$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $8b13b1308e9ec166$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $8b13b1308e9ec166$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $8b13b1308e9ec166$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $8b13b1308e9ec166$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$8b13b1308e9ec166$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $8b13b1308e9ec166$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$8b13b1308e9ec166$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $8b13b1308e9ec166$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateWeekDate(year, week)) return new Date(NaN);
        return $8b13b1308e9ec166$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $8b13b1308e9ec166$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $8b13b1308e9ec166$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $8b13b1308e9ec166$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $8b13b1308e9ec166$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $8b13b1308e9ec166$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR + minutes * $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $8b13b1308e9ec166$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR + minutes * $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $8b13b1308e9ec166$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $8b13b1308e9ec166$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8b13b1308e9ec166$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $8b13b1308e9ec166$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $8b13b1308e9ec166$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $8b13b1308e9ec166$var$isLeapYearIndex(year);
        if (isLeapYear && date > $8b13b1308e9ec166$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $8b13b1308e9ec166$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $8b13b1308e9ec166$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $8b13b1308e9ec166$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $8b13b1308e9ec166$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $8b13b1308e9ec166$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("cIjNZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9418f4fd702d1312$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $9418f4fd702d1312$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $9418f4fd702d1312$export$2e2bcd8739ae039 = $9418f4fd702d1312$var$tzPattern;

});



parcelRegister("iEVvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d95891bc4ee0ba6d$export$2e2bcd8739ae039);

var $a2zuC = parcelRequire("a2zuC");

var $bWiNt = parcelRequire("bWiNt");
function $d95891bc4ee0ba6d$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $bWiNt.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $a2zuC.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});







parcelRegister("aBTmI", function(module, exports) {

$parcel$export(module.exports, "CustomUserProfileClient", () => $21d1f3a214a5c794$export$4b2a86afb64f42f1);

var $9uvjI = parcelRequire("9uvjI");

var $1Ozm9 = parcelRequire("1Ozm9");

var $38H79 = parcelRequire("38H79");
class $21d1f3a214a5c794$export$4b2a86afb64f42f1 extends (0, $9uvjI.default) {
    constructor(fabricPfDirUrl, onLoadError){
        super({
            url: fabricPfDirUrl,
            cacheSize: 20,
            cacheMaxAge: 180000
        }), this.makeRequest = async (cloudId, userId)=>{
            // call old profile rest endpoint
            try {
                if ((0, $38H79.isCustomerAccount)(userId)) {
                    const response = await (0, $1Ozm9.default)(`/rest/api/3/user?accountId=${userId}`);
                    return (0, $38H79.restResponseToUserData)(response);
                }
                return await this.parentMakeRequest(cloudId, userId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const error = new Error(`Unable to fetch user: ${err.message}`, {
                    cause: err
                });
                this.onLoadError?.(err);
                throw error;
            }
        };
        this.onLoadError = onLoadError;
        this.parentMakeRequest = super.makeRequest;
    }
}

});
parcelRegister("38H79", function(module, exports) {

$parcel$export(module.exports, "generateUserLink", () => $b826be912fd09914$export$f4673d7e11341514);
$parcel$export(module.exports, "generateTeamLink", () => $b826be912fd09914$export$b163ce931504dcff);
$parcel$export(module.exports, "isTeamProfileCardEventContentRendered", () => $b826be912fd09914$export$6dc006c3779708c0);
$parcel$export(module.exports, "fireLegacyTeamAnalytics", () => $b826be912fd09914$export$ffbbcf55d672ec61);
$parcel$export(module.exports, "restResponseToUserData", () => $b826be912fd09914$export$66691b1affeb3bc5);
$parcel$export(module.exports, "isCustomerAccount", () => $b826be912fd09914$export$67a41405362363f0);
$parcel$export(module.exports, "getSpaActions", () => $b826be912fd09914$export$518f47d656cb4e1a);
$parcel$export(module.exports, "getSpaActionsWithRouterPush", () => $b826be912fd09914$export$96e0a21dc8f6c225);

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");

var $9LvIj = parcelRequire("9LvIj");

const $b826be912fd09914$export$f4673d7e11341514 = (userId)=>`/jira/people/${userId}`;
const $b826be912fd09914$export$b163ce931504dcff = (teamId)=>`/jira/people/team/${teamId}`;
const $b826be912fd09914$export$7b55c373f7e07896 = (label, profileUrl)=>({
        id: 'view-profile',
        label: label,
        callback: (event)=>{
            event.stopPropagation();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(profileUrl);
        }
    });
const $b826be912fd09914$export$6dc006c3779708c0 = (analyticsPayload)=>analyticsPayload?.action === 'rendered' && analyticsPayload?.actionSubjectId === 'content';
const $b826be912fd09914$export$ffbbcf55d672ec61 = (analyticsEvent)=>{
    if (analyticsEvent?.payload?.eventType === 'ui') {
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, `legacyTeamProfileCard ${analyticsEvent.payload.action}}`);
        if ($b826be912fd09914$export$6dc006c3779708c0(analyticsEvent?.payload)) (0, $gCeeo.fireScreenAnalytics)(analyticsEvent);
    }
};
const $b826be912fd09914$export$66691b1affeb3bc5 = (userData)=>({
        avatarUrl: userData.avatarUrls?.['48x48'],
        email: userData.emailAddress,
        fullName: userData.displayName,
        isBot: false,
        isCurrentUser: false,
        status: userData.active ? 'active' : 'inactive',
        accountType: userData.accountType
    });
const $b826be912fd09914$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
const $b826be912fd09914$var$getSpaViewProfileAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $9LvIj.profileCardMessages).viewProfile),
        id: 'view-profile',
        link: `/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
const $b826be912fd09914$var$getSpaViewProfileActionWithRouterPush = (intl, accountId, onPushAction, onActionCleanup)=>({
        label: intl && intl.formatMessage((0, $9LvIj.profileCardMessages).viewProfile),
        id: 'view-profile',
        callback: ()=>{
            onPushAction(`/jira/people/${accountId}`);
            onActionCleanup && onActionCleanup();
        },
        link: `/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
const $b826be912fd09914$var$getAssignedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $9LvIj.profileCardMessages).assignedIssuesIssueTerminologyRefreshM4 : (0, $9LvIj.profileCardMessages).assignedIssues),
        id: 'assigned-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $b826be912fd09914$var$getReportedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $9LvIj.profileCardMessages).reportedIssuesIssueTerminologyRefreshM4 : (0, $9LvIj.profileCardMessages).reportedIssues),
        id: 'reported-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $b826be912fd09914$var$getViewFiltersAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $9LvIj.profileCardMessages).viewFilters),
        id: 'view-filters',
        callback: ()=>{
            const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $b826be912fd09914$export$518f47d656cb4e1a = (accountId, intl, actions)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $6d22448f78a7f25a$export$23cedd3261bd8015:
                return $b826be912fd09914$var$getSpaViewProfileAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$6bef782d14a92db8:
                return $b826be912fd09914$var$getAssignedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$6b36f20db7a18a86:
                return $b826be912fd09914$var$getReportedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$56da0dd0b0aa67b9:
                return $b826be912fd09914$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $b826be912fd09914$var$getSpaViewProfileAction(intl, accountId)
    ];
};
const $b826be912fd09914$export$96e0a21dc8f6c225 = (accountId, intl, onPushAction, actions, onActionCleanup)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $6d22448f78a7f25a$export$23cedd3261bd8015:
                return $b826be912fd09914$var$getSpaViewProfileActionWithRouterPush(intl, accountId, onPushAction, onActionCleanup);
            case 0, $6d22448f78a7f25a$export$6bef782d14a92db8:
                return $b826be912fd09914$var$getAssignedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$6b36f20db7a18a86:
                return $b826be912fd09914$var$getReportedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$56da0dd0b0aa67b9:
                return $b826be912fd09914$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $b826be912fd09914$var$getSpaViewProfileActionWithRouterPush(intl, accountId, onPushAction, onActionCleanup)
    ];
};

});
parcelRegister("9LvIj", function(module, exports) {

$parcel$export(module.exports, "profileCardMessages", () => $8d56fb88e7ef3ba6$export$49f2d2ccb123fddf);

var $7qGN1 = parcelRequire("7qGN1");
const $8d56fb88e7ef3ba6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    view: {
        "id": "profilecard-next",
        "defaultMessage": "View profile"
    }
});
const $8d56fb88e7ef3ba6$export$49f2d2ccb123fddf = (0, $7qGN1.defineMessages)({
    assignedIssues: {
        "id": "profilecard-next.assigned-issues",
        "defaultMessage": "Assigned issues"
    },
    viewProfile: {
        "id": "profilecard-next.view-profile",
        "defaultMessage": "View profile"
    },
    reportedIssues: {
        "id": "profilecard-next.reported-issues",
        "defaultMessage": "Reported issues"
    },
    viewFilters: {
        "id": "profilecard-next.view-filters",
        "defaultMessage": "View filters"
    },
    assignedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.assigned-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Assigned work items"
    },
    reportedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.reported-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Reported work items"
    }
});

});





parcelRegister("28Csj", function(module, exports) {

$parcel$export(module.exports, "ProfileCardView", () => $64d7fb877670625a$export$da5098f02f405a40);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $caeqU = parcelRequire("caeqU");

var $22c3C = parcelRequire("22c3C");
var $hrodw = parcelRequire("hrodw");

var $hjf2q = parcelRequire("hjf2q");

var $6XJko = parcelRequire("6XJko");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $16TBK = parcelRequire("16TBK");

const $64d7fb877670625a$var$PEOPLE_PROFILE_PATH = '/people/';
const $64d7fb877670625a$var$ProfileCardTriggerWithAnalytics = (0, $hjf2q.AnalyticsEventToProps)((0, $b9c60665faffac50$export$a1455360a24a2234), {
    analytics: ''
})((0, $caeqU.default));
const $64d7fb877670625a$export$da5098f02f405a40 = ({ children: children, position: position = 'top-start', trigger: trigger = 'hover', accountId: accountId, actions: actions, onProfileClick: onProfileClick, addFlag: addFlag, dismissFlag: dismissFlag, testId: testId, prepopulatedData: prepopulatedData, ariaHideProfileTrigger: ariaHideProfileTrigger, isChildComment: isChildComment, shouldTruncate: shouldTruncate })=>{
    const profileCardWrapperRef = (0, $eJOHy.useRef)(null);
    const cloudId = (0, $kEUB1.useCloudId)();
    const viewingUserId = (0, $8q7lT.useAccountId)();
    const { profileClient: profileClient } = (0, $16TBK.useProfileClient)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64d7fb877670625a$var$Wrapper, {
        ref: profileCardWrapperRef,
        onClick: (event)=>{
            if (profileCardWrapperRef?.current !== null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            !profileCardWrapperRef?.current?.contains(event.target)) event.stopPropagation();
        },
        "data-vc": `profilecard-wrapper${false ? '-ssr' : ''}`,
        isVisualRefresh: (0, $6XJko.isVisualRefreshEnabled)(),
        className: (0, $hcewu.default)([
            isChildComment && "_kqswh2mm _1hjgt94y _1pty1eak _161e1v33 _ft5qdlk8 _2wzdc71f _2kncueha _qlwiueha _aetrb3bt _631ousvi _18postnw _g0nf1yie _15l21pz7 _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            isChildComment && "_p12f1kdh _kqswh2mm _uglpt94y _161e1v33 _1pty1eak _2knc163p _qlwi163p _631ousvi _aetrb3bt _18postnw _g0nf1yie _15l24uri _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            shouldTruncate && "_1reo15vq _18m915vq _1o9zidpf _1bto1l2s _o5721q9c"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64d7fb877670625a$var$ProfileCardTriggerWithAnalytics, {
        cloudId: cloudId,
        userId: accountId,
        resourceClient: profileClient,
        position: position,
        trigger: trigger,
        testId: testId,
        actions: actions,
        reportingLinesProfileUrl: $64d7fb877670625a$var$PEOPLE_PROFILE_PATH,
        prepopulatedData: prepopulatedData,
        onReportingLinesClick: // @ts-expect-error - TS7006 - Parameter 'user' implicitly has an 'any' type.
        onProfileClick ? (user)=>onProfileClick(user.accountIdentifier) : null,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        addFlag: (flag)=>{
            const flagId = (0, $hrodw.toFlagId)(flag.id);
            addFlag({
                id: flagId,
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $22c3C.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        ...props
                    })
            });
        },
        viewingUserId: viewingUserId,
        ariaHideProfileTrigger: ariaHideProfileTrigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "profilecard-next.ui.profilecard.profilecard-trigger",
        className: (0, $hcewu.default)([
            shouldTruncate && "_1e0c1nu9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64d7fb877670625a$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq",
            __cmplp.isVisualRefresh && "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $64d7fb877670625a$var$profileCardStyles = null;
const $64d7fb877670625a$var$replyProfileCardStyles = null;
const $64d7fb877670625a$var$truncatedProfileCardStyles = null;
const $64d7fb877670625a$var$truncatedProfileCardInnerStyles = null;
$64d7fb877670625a$var$Wrapper.displayName = 'Wrapper';

});
parcelRegister("caeqU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9b60a56512bd43f$export$2e2bcd8739ae039);


var $1GAK3 = parcelRequire("1GAK3");

var $39Fdj = parcelRequire("39Fdj");
var $f9b60a56512bd43f$export$2e2bcd8739ae039 = (0, $39Fdj.default);

});
parcelRegister("1GAK3", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $500dc3728366069c$export$403d297463f226af);

var $eJOHy = parcelRequire("eJOHy");

const $500dc3728366069c$export$403d297463f226af = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2ly6c")));

});
parcelRegister("2ly6c", function(module, exports) {

let $1b57fe43f319ccc2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1b57fe43f319ccc2$var$load("ffQaD"),
    $1b57fe43f319ccc2$var$load("kvRbA"),
    $1b57fe43f319ccc2$var$load("2wjWj")
]).then(()=>parcelRequire('k60Oj'));

});


parcelRegister("39Fdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a556daa2b306b37$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $7m76n = parcelRequire("7m76n");
var $XUWry = parcelRequire("XUWry");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $IW7jS = parcelRequire("IW7jS");

var $gh6xW = parcelRequire("gh6xW");

var $8WJ7D = parcelRequire("8WJ7D");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");


var $bQmsU = parcelRequire("bQmsU");

var $1GAK3 = parcelRequire("1GAK3");

var $5H2ec = parcelRequire("5H2ec");
function $9a556daa2b306b37$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQmsU.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1GAK3.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $9a556daa2b306b37$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible, ssrPlaceholderId: ssrPlaceholderId }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isMounted = (0, $eJOHy.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $776ef75d5b01ad48$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $776ef75d5b01ad48$export$89a9f35a94d7f196);
    const showTimer = (0, $eJOHy.useRef)(0);
    const hideTimer = (0, $eJOHy.useRef)(0);
    const [visible, setVisible] = (0, $eJOHy.useState)(false);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(undefined);
    const [hasError, setHasError] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [data, setData] = (0, $eJOHy.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $eJOHy.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $eJOHy.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $eJOHy.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $eJOHy.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eJOHy.useState)(false);
    const triggerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $eJOHy.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $eJOHy.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $eJOHy.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $eJOHy.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $eGOwo.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $eJOHy.useCallback)(()=>{
        return (0, $gh6xW.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    const ssrPlaceholderProp = (0, $eGOwo.fg)('cc_mention_ssr_placeholder') ? {
        'data-ssr-placeholder-replace': ssrPlaceholderId
    } : {};
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $8WJ7D.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        ...ssrPlaceholderProp,
                        children: children
                    });
                },
                zIndex: (0, $IW7jS.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card'),
                shouldDisableFocusLock: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $XUWry.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $9a556daa2b306b37$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5H2ec.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("7m76n", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $ec00209f14041f24$export$93fe397a02fe8b76);

var $eJOHy = parcelRequire("eJOHy");

const $ec00209f14041f24$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lWqKn")));

});
parcelRegister("lWqKn", function(module, exports) {

let $ff93c327b9f5ea83$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ff93c327b9f5ea83$var$load("76n7a"),
    $ff93c327b9f5ea83$var$load("l253H"),
    $ff93c327b9f5ea83$var$load("ffQaD"),
    $ff93c327b9f5ea83$var$load("kvRbA"),
    $ff93c327b9f5ea83$var$load("2tv8I")
]).then(()=>parcelRequire('3dj1A'));

});


parcelRegister("XUWry", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $2c3b135763fda18f$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $2c3b135763fda18f$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $2c3b135763fda18f$export$7a1fc1a1b0477464);
var $2c3b135763fda18f$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    KudosType["MIXED"] = "mixed";
    return KudosType;
}({});
var $2c3b135763fda18f$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $2c3b135763fda18f$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($2c3b135763fda18f$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("gh6xW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4adbe5caf86a5ece$export$2e2bcd8739ae039);
const $4adbe5caf86a5ece$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $4adbe5caf86a5ece$export$2e2bcd8739ae039 = $4adbe5caf86a5ece$var$filterActions;

});

parcelRegister("8WJ7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a2772a88ae71e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $95a2772a88ae71e4$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($95a2772a88ae71e4$var$messages.label, {
        fullName: fullName
    }) : formatMessage($95a2772a88ae71e4$var$messages.fallbackLabel);
};
const $95a2772a88ae71e4$var$messages = (0, $7qGN1.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $95a2772a88ae71e4$export$2e2bcd8739ae039 = $95a2772a88ae71e4$var$getLabelMessage;

});

parcelRegister("b4A0H", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $d37aab7a36a1d923$export$6aa22a823032b784);
$parcel$export(module.exports, "SpinnerContainer", () => $d37aab7a36a1d923$export$a5e06607a5ac6158);
/* UserTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ // PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $d37aab7a36a1d923$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm"
};
const $d37aab7a36a1d923$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    });
const $d37aab7a36a1d923$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.spinnerContainer),
        children: children
    });

});

const $776ef75d5b01ad48$export$5b956b542f1bc1b3 = 800;
const $776ef75d5b01ad48$export$89a9f35a94d7f196 = 200;

parcelRegister("bQmsU", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $2dca9d01bdb4de20$export$4b013ffffcb40af8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $j19W0 = parcelRequire("j19W0");

var $2EPX4 = parcelRequire("2EPX4");

var $46Rs7 = parcelRequire("46Rs7");

var $dWlMJ = parcelRequire("dWlMJ");

var $kKboJ = parcelRequire("kKboJ");

var $5TZsz = parcelRequire("5TZsz");
const $2dca9d01bdb4de20$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $eJOHy.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $46Rs7.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const { href: profileHref } = (0, $j19W0.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    const getCreator = (0, $eJOHy.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: (0, $eGOwo.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKboJ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWlMJ.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5TZsz.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("46Rs7", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $5342ced741c59880$export$3761e66a04602cbd);
const $5342ced741c59880$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $5342ced741c59880$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($5342ced741c59880$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("dWlMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4c4e00d9fd0e109$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $a03qM = parcelRequire("a03qM");

var $jZF1f = parcelRequire("jZF1f");

var $5qJVF = parcelRequire("5qJVF");

var $3CCXY = parcelRequire("3CCXY");

var $2EPX4 = parcelRequire("2EPX4");
const $d4c4e00d9fd0e109$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $eJOHy.useEffect)(()=>{
        fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3CCXY.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $gt9Am.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jZF1f))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                onClick: reload,
                children: "Try again"
            })
        ]
    });
};
var $d4c4e00d9fd0e109$export$2e2bcd8739ae039 = $d4c4e00d9fd0e109$var$ErrorMessage;

});
parcelRegister("3CCXY", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $f4fe046f369d0d86$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $f4fe046f369d0d86$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $f4fe046f369d0d86$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $f4fe046f369d0d86$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $f4fe046f369d0d86$export$bb27b7e39840238f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.errorWrapper),
        ...props
    });
const $f4fe046f369d0d86$export$b065fd053267ec81 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.errorTitle),
        children: props.children
    });
const $f4fe046f369d0d86$export$90d92ccfb27352c6 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.teamErrorText),
        children: props.children
    });

});


parcelRegister("kKboJ", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $d15bd5f3ea87f8ed$export$2c6604b50c274e6f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $d15bd5f3ea87f8ed$var$styles = (0, $1DXK0.xcss)({
    width: '360px'
});
const $d15bd5f3ea87f8ed$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $d15bd5f3ea87f8ed$var$styles,
        children: children
    });
};

});

parcelRegister("5TZsz", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $aff86c6979038d17$export$ed0ca9c1d49ea0bf);

var $eJOHy = parcelRequire("eJOHy");

const $aff86c6979038d17$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2XXEr")));

});
parcelRegister("2XXEr", function(module, exports) {

let $228f5cf7f6ecd638$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $228f5cf7f6ecd638$var$load("76n7a"),
    $228f5cf7f6ecd638$var$load("l253H"),
    $228f5cf7f6ecd638$var$load("ffQaD"),
    $228f5cf7f6ecd638$var$load("kvRbA"),
    $228f5cf7f6ecd638$var$load("gsod0")
]).then(()=>parcelRequire('e1nCN'));

});



parcelRegister("5H2ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $75ec444a04f48b56$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");
const $75ec444a04f48b56$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $eJOHy.useEffect)(()=>{
        fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
    });
};
var $75ec444a04f48b56$export$2e2bcd8739ae039 = $75ec444a04f48b56$var$UserLoadingState;

});



const $b9c60665faffac50$export$a1455360a24a2234 = 'profileCardNextView';



parcelRegister("iASjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $be6e396986ab4d32$export$2e2bcd8739ae039);

var $idGBm = parcelRequire("idGBm");

var $hYag0 = parcelRequire("hYag0");
var $be6e396986ab4d32$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)((0, $hYag0.default));

});
parcelRegister("hYag0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1ce04ee9a633ad1$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $5DgXR = parcelRequire("5DgXR");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");


var $7jTnu = parcelRequire("7jTnu");

var $6VBOD = parcelRequire("6VBOD");
const $a1ce04ee9a633ad1$var$AssigneeButton = ({ isLastColumn: isLastColumn, assignee: assignee, intl: intl, overrideDisabledAppearance: overrideDisabledAppearance, accountId: accountId, ProfileCard: ProfileCard, ...rest })=>{
    const [isHover, setIsHover] = (0, $eJOHy.useState)(false);
    const setIsHoverToTrue = ()=>setIsHover(true);
    const setIsHoverToFalse = ()=>setIsHover(false);
    const assigneeName = assignee ? assignee.displayName || assignee.emailAddress : intl.formatMessage((0, $6VBOD.default).unassigned);
    const isFromServerSide = false && (0, $7jTnu.fg)('issue_list_ssr_disable_sort_and_inline_edit');
    const isDisabled = !overrideDisabledAppearance && rest.isButtonDisabled;
    const assigneeAvatar = isDisabled && (0, $7jTnu.fg)('corcap-3761-a11y-button-no-text') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: assignee && assignee.avatarUrl,
        isDisabled: isDisabled,
        size: "small",
        borderColor: "transparent"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: assignee && assignee.avatarUrl,
        isDisabled: isDisabled,
        size: "small",
        borderColor: "transparent"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a1ce04ee9a633ad1$var$wrapperBaseStyles,
        paddingInlineEnd: isLastColumn ? 'space.100' : 'space.0',
        onMouseEnter: setIsHoverToTrue,
        onMouseLeave: setIsHoverToFalse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a1ce04ee9a633ad1$export$2d5d2ba3c7c8c40b, {
        ...rest,
        isHovered: isHover,
        "aria-label": `${assigneeName} - edit Assignee`,
        isFromServerSide: isFromServerSide
    }, accountId && ProfileCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ProfileCard, {
        accountId: accountId,
        actions: [
            (0, $6d22448f78a7f25a$export$23cedd3261bd8015),
            (0, $6d22448f78a7f25a$export$6bef782d14a92db8)
        ]
    }, assigneeAvatar) : assigneeAvatar, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a1ce04ee9a633ad1$var$Text, null, assigneeName)));
};
$a1ce04ee9a633ad1$var$AssigneeButton.defaultProps = {
    isLastColumn: false,
    isButtonDisabled: false,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    overrideDisabledAppearance: false
};
var $a1ce04ee9a633ad1$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $a1ce04ee9a633ad1$var$AssigneeButton;
const $a1ce04ee9a633ad1$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isButtonDisabled: isButtonDisabled, isHovered: isHovered, isFromServerSide: isFromServerSide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _16jlkb7n _1o9zkb7n _i0dlf1ug _19itidpf _2rko1l7b _12ji1r31 _1qu2glyw _12y31o36 _1e0c1txw _4cvr1h6o _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1bsb1osq _4t3ixy5q _1reo15vq _syaz1kw7 _wtsb13gf",
            !__cmplp.isButtonDisabled && __cmplp.isHovered ? "_bfhk15ej" : "_bfhk18uv",
            __cmplp.className
        ])
    });
});
const $a1ce04ee9a633ad1$var$wrapperBaseStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.050',
    paddingRight: 'space.0',
    paddingBottom: 'space.050',
    paddingLeft: 'space.0',
    display: 'flex',
    textAlign: 'left'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1ce04ee9a633ad1$var$Text = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _1bto1l2s _o5721q9c _y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6VBOD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ccb40c8e15108d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c8ccb40c8e15108d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    assignToMe: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    unassigned: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.unassigned",
        "defaultMessage": "Unassigned"
    },
    automatic: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.automatic",
        "defaultMessage": "Automatic"
    },
    invitePeopleOption: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-table.common.fields.assignee.single-user-select.user-select.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});



parcelRegister("ffyBp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dd4b0e6115dfa73$export$2e2bcd8739ae039);

var $aYncF = parcelRequire("aYncF");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $4Jmvl = parcelRequire("4Jmvl");

var $cN0WI = parcelRequire("cN0WI");

var $5dA7A = parcelRequire("5dA7A");

var $7g5t8 = parcelRequire("7g5t8");

var $8toaC = parcelRequire("8toaC");

var $lMgZZ = parcelRequire("lMgZZ");

var $4IXnw = parcelRequire("4IXnw");

var $dJIeg = parcelRequire("dJIeg");
const $6dd4b0e6115dfa73$var$mapStateToProps = (state)=>({
        avatarUrl: (0, $5dA7A.getAvatarUrl)(state),
        atlassianAccountId: (0, $7g5t8.getAtlassianAccountId)(state),
        displayName: (0, $5dA7A.getDisplayName)(state),
        emailAddress: (0, $5dA7A.getEmailAddress)(state),
        AsyncUserPicker: $4IXnw.default,
        onSearchUser: $lMgZZ.default,
        isAdmin: (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)().isAdmin
    });
var // @ts-expect-error - Parameter 'ownProps' implicitly has an 'any' type.
$6dd4b0e6115dfa73$export$2e2bcd8739ae039 = (0, $8toaC.connect)($6dd4b0e6115dfa73$var$mapStateToProps, (dispatch, ownProps)=>({
        // @ts-expect-error - TS7006 - Parameter 'issueKey' implicitly has an 'any' type. | TS7006 - Parameter 'fieldId' implicitly has an 'any' type. | TS7006 - Parameter 'fieldValue' implicitly has an 'any' type.
        onChange: (issueKey, fieldId, fieldValue)=>{
            ownProps.onSubmit(fieldValue);
            return dispatch((0, $4Jmvl.submitFieldUpdateAction)(issueKey, fieldId, fieldValue, ownProps.onEditSuccess, ownProps.onEditFailure));
        },
        onComponentLoadFailure: ()=>{
            ownProps.onComponentLoadFailure && ownProps.onComponentLoadFailure();
            dispatch((0, $cN0WI.disableUserPickerAction)());
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-table.view.fields.common.single-user-select.user-select', '[FD-4424] Async user select failed to load');
            (0, $gYnSx.default)({
                meta: {
                    id: 'asyncUserSelectLoadFailure',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                }
            });
        }
    }))((0, $dJIeg.default));

});
parcelRegister("5dA7A", function(module, exports) {

$parcel$export(module.exports, "getAvatarUrl", () => $b19f75d805bba6a4$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "getDisplayName", () => $b19f75d805bba6a4$export$be63e0664592e141);
$parcel$export(module.exports, "getEmailAddress", () => $b19f75d805bba6a4$export$ec5591214e33605f);

var $lhJwW = parcelRequire("lhJwW");
const $b19f75d805bba6a4$var$getAssigneeInitialization = (state)=>(0, $lhJwW.getFieldInitialization)(state).assignee;
const $b19f75d805bba6a4$export$b4f8f1f54acec99b = (state)=>{
    const assignee = $b19f75d805bba6a4$var$getAssigneeInitialization(state);
    return assignee ? assignee.avatarUrl : undefined;
};
const $b19f75d805bba6a4$export$be63e0664592e141 = (state)=>{
    const assignee = $b19f75d805bba6a4$var$getAssigneeInitialization(state);
    return assignee ? assignee.displayName : undefined;
};
const $b19f75d805bba6a4$export$ec5591214e33605f = (state)=>{
    const assignee = $b19f75d805bba6a4$var$getAssigneeInitialization(state);
    return assignee ? assignee.emailAddress : undefined;
};

});

parcelRegister("7g5t8", function(module, exports) {

$parcel$export(module.exports, "getAtlassianAccountId", () => $8c39cb9116e20462$export$f5baf4f0aaa47428);

var $lhJwW = parcelRequire("lhJwW");
const $8c39cb9116e20462$export$f5baf4f0aaa47428 = (state)=>(0, $lhJwW.getInitialAppProps)(state).atlassianAccountId;
const $8c39cb9116e20462$export$fdd2c0ba94025c3c = (state)=>(0, $lhJwW.getInitialAppProps)(state).cloudId;
const $8c39cb9116e20462$export$505ebc60b5fc3b2e = (state)=>(0, $lhJwW.getInitialAppProps)(state).fabricPfDirUrl;

});

parcelRegister("lMgZZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c089c662bdc24c$export$2e2bcd8739ae039);


var $d1TNn = parcelRequire("d1TNn");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$58c089c662bdc24c$export$2e2bcd8739ae039 = (issueKey, query, fieldContext)=>{
    if (fieldContext === (0, $e5c4c2652dc768b9$export$17e03e15c8be5abe)) return (0, $d1TNn.default)(issueKey, query ?? '');
    throw new Error('Not implemented');
};

});
const $e5c4c2652dc768b9$export$17e03e15c8be5abe = 'ASSIGNEE';
const $e5c4c2652dc768b9$export$9c542858adf7dcd0 = 'DEFAULT';

parcelRegister("d1TNn", function(module, exports) {

$parcel$export(module.exports, "default", () => $72dd98ba4a5fa784$export$2e2bcd8739ae039);

var $eN6Hc = parcelRequire("eN6Hc");
const $72dd98ba4a5fa784$var$transformResponse = (response)=>response.map((userResponse)=>({
            id: userResponse.accountId,
            avatarUrl: userResponse.avatarUrls['48x48'],
            name: userResponse.displayName,
            byline: userResponse.emailAddress,
            value: {
                accountId: userResponse.accountId,
                avatarUrl: userResponse.avatarUrls['48x48'],
                displayName: userResponse.displayName,
                emailAddress: userResponse.emailAddress
            }
        }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$72dd98ba4a5fa784$export$2e2bcd8739ae039 = (issueKey, query)=>(0, $eN6Hc.default)(issueKey, query).then((response)=>new Promise((resolve)=>{
            resolve($72dd98ba4a5fa784$var$transformResponse(response));
        }));

});
parcelRegister("eN6Hc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3016405e8c6cfc92$export$2e2bcd8739ae039);

var $1Ozm9 = parcelRequire("1Ozm9");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3016405e8c6cfc92$export$2e2bcd8739ae039 = (issueKey, query)=>(0, $1Ozm9.default)(`/rest/api/latest/user/assignable/search?issueKey=${issueKey}&query=${query}`, {
        method: 'GET'
    });

});



parcelRegister("4IXnw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e96a81f95e5cd4b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9e96a81f95e5cd4b$var$LazyUserPicker = (0, $bQWwW.lazy)(()=>(parcelRequire("4IsmS")), {
    moduleId: "../platform/packages/elements/user-picker/src/index.ts"
});
const $9e96a81f95e5cd4b$export$2e2bcd8739ae039 = (props)=>{
    const { onError: onError, ...userPickerProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "async-issue-table-user-picker",
        packageName: "jiraIssueTable",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "user-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9e96a81f95e5cd4b$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9e96a81f95e5cd4b$var$UserPickerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9e96a81f95e5cd4b$var$LazyUserPicker, userPickerProps))));
};
const $9e96a81f95e5cd4b$var$SpinnerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1h6o _kqswh2mm _154i12x7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e96a81f95e5cd4b$var$UserPickerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1q5411p5 _16vph2mm _14od1wug _1etn1wug _1ospglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4IsmS", function(module, exports) {

let $36f146c4404902b4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $36f146c4404902b4$var$load("93pKH").then(()=>parcelRequire('djG0m'));

});


parcelRegister("dJIeg", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbbc0ee5ce841cbf$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/react-arrow-function-property-naming */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4J0ad = parcelRequire("4J0ad");

var $eSnSE = parcelRequire("eSnSE");

var $idGBm = parcelRequire("idGBm");

var $lMRlJ = parcelRequire("lMRlJ");

var $gCeeo = parcelRequire("gCeeo");


var $3ky2L = parcelRequire("3ky2L");


var $6VBOD = parcelRequire("6VBOD");
const $dbbc0ee5ce841cbf$var$toUserForEditing = (value)=>{
    if (!value) return undefined;
    return {
        id: value.accountId,
        name: value.displayName || value.emailAddress || '',
        avatarUrl: value.avatarUrl,
        value: value
    };
};
const $dbbc0ee5ce841cbf$var$fireInviteItemRendererEvent = (createAnalyticsEvent, fieldId, suggestionsCount, isAdmin)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'rendered';
    const actionSubject = 'inviteItem';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: fieldId,
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField'
    };
    (0, $gCeeo.fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
class $dbbc0ee5ce841cbf$export$fc39e35a5100d3e8 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isAdmin: false,
            enablePeopleInvite: true
        };
    }
    loadAssignToMeUser() {
        const { value: value, avatarUrl: avatarUrl, atlassianAccountId: atlassianAccountId, emailAddress: emailAddress, displayName: displayName, intl: intl } = this.props;
        if (value && value.accountId === atlassianAccountId) return undefined;
        if (!emailAddress && !avatarUrl && !displayName) {
            (0, $eSnSE.default).safeWarnWithoutCustomerData('issue-table.view.fields.common.single-user-select.user-select', 'Assign-to-me not initialized in time', {});
            return undefined;
        }
        const assignToMeUser = {
            id: (0, $d61624498c4ec07f$export$34c10ac17efea7b3),
            name: intl.formatMessage((0, $6VBOD.default).assignToMe),
            avatarUrl: avatarUrl,
            value: {
                emailAddress: emailAddress,
                accountId: atlassianAccountId,
                avatarUrl: avatarUrl,
                displayName: displayName
            }
        };
        return assignToMeUser;
    }
    loadUnassignedUser() {
        const { value: value, intl: intl } = this.props; // While the 'Unassigned' option is defined as value being undefined, the value can briefly have a displayName
        // of "Unassigned" when selected from the user-picker, before the issue-table polls again. To avoid this, added
        // a check of accountId as the 'Unassigned' option does not have an accountId.
        if (!value || !value.accountId) return undefined;
        const unassignedUser = {
            id: (0, $d61624498c4ec07f$export$bdab9bfb39981463),
            name: intl.formatMessage((0, $6VBOD.default).unassigned)
        };
        return unassignedUser;
    }
    loadAutomaticUser() {
        const { value: value, intl: intl } = this.props;
        if (value && value.accountId === (0, $d61624498c4ec07f$export$f42e6736d1a95712)) return undefined;
        const automaticUser = {
            id: (0, $d61624498c4ec07f$export$f5d5f6bb902f1027),
            name: intl.formatMessage((0, $6VBOD.default).automatic),
            value: {
                accountId: (0, $d61624498c4ec07f$export$f42e6736d1a95712),
                displayName: intl.formatMessage((0, $6VBOD.default).automatic),
                avatarUrl: '',
                emailAddress: ''
            }
        };
        return automaticUser;
    }
    getInvitePeopleOption() {
        const { intl: intl, isAdmin: isAdmin } = this.props;
        return {
            id: (0, $d61624498c4ec07f$export$d875316cb0cd94f7),
            avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($3ky2L))),
            name: intl.formatMessage(isAdmin ? (0, $6VBOD.default).invitePeopleOptionAdmin : (0, $6VBOD.default).invitePeopleOption)
        };
    }
    render() {
        const { width: width, value: value, AsyncUserPicker: AsyncUserPicker, onComponentLoadFailure: onComponentLoadFailure, rowListRef: rowListRef, fieldId: fieldId, isSaving: isSaving, onSetEditingRef: onSetEditingRef } = this.props;
        const isOpen = this.state.isOpen && !isSaving; // onSetEditingRef is used to set ref of current container such that
        // UserPicker options list can render with the correct X/Y offset.
        // This is required in react-redux v8 upgrade because ref is not set properly.
        // https://hello.atlassian.net/wiki/spaces/JFP/pages/3593342635/Rollout+Strategy+For+React-Redux+V8#JSM-assignee-bug
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dbbc0ee5ce841cbf$var$Container // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        , {
            "data-testid": "issue-table.view.fields.common.single-user-select.user-select",
            ref: onSetEditingRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AsyncUserPicker, {
            open: isOpen,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            loadOptions: this.loadUsers,
            width: width,
            value: $dbbc0ee5ce841cbf$var$toUserForEditing(value),
            onChange: this.onChange,
            onError: onComponentLoadFailure,
            isClearable: false,
            menuMinWidth: (0, $d61624498c4ec07f$export$eef3ca04e2ec81e0),
            menuPortalTarget: rowListRef,
            onSelection: this.onSelection,
            fieldId: fieldId
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: true
        }, this.onChange = (item)=>{
            const { onChange: onChange, issueKey: issueKey, fieldId: fieldId, fieldType: fieldType, intl: intl, enablePeopleInvite: enablePeopleInvite } = this.props;
            if (enablePeopleInvite !== true || item.id !== (0, $d61624498c4ec07f$export$d875316cb0cd94f7)) {
                if (item.value) onChange(issueKey, fieldId, {
                    ...item.value,
                    fieldType: fieldType
                });
                else onChange(issueKey, fieldId, {
                    displayName: intl.formatMessage((0, $6VBOD.default).unassigned),
                    fieldType: fieldType
                });
            }
        }, this.onBlur = ()=>{
            this.setState({
                isOpen: false
            });
            this.props.onEditCancel();
        }, this.onFocus = ()=>{
            this.setState({
                isOpen: true
            });
        }, this.onSelection = (item)=>{
            const { onEditSelection: onEditSelection, createAnalyticsEvent: createAnalyticsEvent, enablePeopleInvite: enablePeopleInvite } = this.props;
            if (enablePeopleInvite === true && item.id === (0, $d61624498c4ec07f$export$d875316cb0cd94f7)) (0, $lMRlJ.triggerOpenModal)(createAnalyticsEvent ?? null, {
                inviteFlow: 'assignee'
            });
            else onEditSelection();
        }, this.loadUsers = (query)=>{
            const { issueKey: issueKey, onSearchUser: onSearchUser, enablePeopleInvite: enablePeopleInvite, createAnalyticsEvent: createAnalyticsEvent, isAdmin: isAdmin, fieldId: fieldId } = this.props;
            const searchPromise = onSearchUser(issueKey, query, (0, $e5c4c2652dc768b9$export$17e03e15c8be5abe)).then((users)=>{
                if (enablePeopleInvite === true && query !== undefined && query !== '' && users.length < 3) {
                    $dbbc0ee5ce841cbf$var$fireInviteItemRendererEvent(createAnalyticsEvent, fieldId, users.length, isAdmin);
                    return [
                        ...users,
                        this.getInvitePeopleOption()
                    ];
                }
                return users;
            });
            const options = [];
            const assignToMeUser = this.loadAssignToMeUser();
            if (assignToMeUser) options.push(assignToMeUser);
            const unassignedUser = this.loadUnassignedUser();
            if (unassignedUser) options.push(unassignedUser);
            const automaticUser = this.loadAutomaticUser();
            if (automaticUser) options.push(automaticUser);
            options.push(searchPromise);
            return options;
        };
    }
}
var $dbbc0ee5ce841cbf$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $4J0ad.default)()((0, $idGBm.injectIntlV2)($dbbc0ee5ce841cbf$export$fc39e35a5100d3e8));
const $dbbc0ee5ce841cbf$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1ltvr5cr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lMRlJ", function(module, exports) {

$parcel$export(module.exports, "useInvitePeopleModal", () => $4e329b8cb1486bd7$export$b9ec44715ae5ad99);
$parcel$export(module.exports, "triggerOpenModal", () => $4e329b8cb1486bd7$export$3da9a54757b29739);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
var $14kUX = parcelRequire("14kUX");

var $ec6Db = parcelRequire("ec6Db");
const $4e329b8cb1486bd7$var$CONTROLLER_NAME = 'invite-people-modal';
const $4e329b8cb1486bd7$var$initialState = {
    isOpen: false,
    inviteFlow: 'unknown',
    continueUrl: undefined
};
const $4e329b8cb1486bd7$var$Store = (0, $GtRbT.createStore)({
    name: $4e329b8cb1486bd7$var$CONTROLLER_NAME,
    initialState: $4e329b8cb1486bd7$var$initialState,
    actions: {
        openModal: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl })=>({ setState: setState })=>{
                (0, $ec6Db.fireAddTeammatetoJiraAnalytics)(createAnalyticsEvent, analyticsSource);
                (0, $ec6Db.fireModalTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, analyticsSource);
                setState({
                    isOpen: true,
                    inviteFlow: inviteFlow,
                    continueUrl: continueUrl
                });
            },
        closeModal: ()=>({ setState: setState })=>setState($4e329b8cb1486bd7$var$initialState)
    }
});
const $4e329b8cb1486bd7$export$b9ec44715ae5ad99 = (0, $iJq0l.createHook)($4e329b8cb1486bd7$var$Store);
const $4e329b8cb1486bd7$export$42437f35b39968af = (0, $6E16M.createContainer)($4e329b8cb1486bd7$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
            setState({
                isOpen: isOpen
            });
        }
});
const $4e329b8cb1486bd7$export$c109a2947e32aee9 = (0, $ht3nQ.createSubscriber)($4e329b8cb1486bd7$var$Store, {
    displayName: 'InvitePeopleModalSubscriber',
    selector: (state)=>state.isOpen
});
const $4e329b8cb1486bd7$export$3da9a54757b29739 = (createAnalyticsEvent, contextConfig)=>{
    (0, $14kUX.defaultRegistry).getStore($4e329b8cb1486bd7$var$Store)?.actions.openModal(createAnalyticsEvent, contextConfig);
};

});
parcelRegister("ec6Db", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $f0e7c62e1985a15a$export$1b581a2ec13e37f1);
$parcel$export(module.exports, "fireModalTriggeredAnalytics", () => $f0e7c62e1985a15a$export$6815765da918b983);
$parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", () => $f0e7c62e1985a15a$export$21b810258e82d438);

var $eJOHy = parcelRequire("eJOHy");

var $8QoO2 = parcelRequire("8QoO2");

var $gCeeo = parcelRequire("gCeeo");
var $1WOGD = parcelRequire("1WOGD");

var $2Mqjh = parcelRequire("2Mqjh");

var $bDk9X = parcelRequire("bDk9X");
const $f0e7c62e1985a15a$var$useAnalyticsClient = ()=>{
    const analyticsWebClientRef = (0, $eJOHy.useRef)((0, $2Mqjh.getAnalyticsWebClientPromise)());
    return {
        sendEvent: (analyticsEvent)=>{
            analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, $1WOGD.getEvent)(analyticsEvent)));
        }
    };
};
const $f0e7c62e1985a15a$export$1b581a2ec13e37f1 = ({ children: children })=>{
    const { sendEvent: sendEvent } = $f0e7c62e1985a15a$var$useAnalyticsClient();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8QoO2.default), {
        channel: "peopleAndTeams",
        onEvent: sendEvent
    }, children);
};
const $f0e7c62e1985a15a$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
    if (createAnalyticsEvent) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), // @ts-expect-error Argument of type '[string, string, Attributes | undefined]' is not assignable to parameter of type 'RestArguments'.
    `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId || '', analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $2Mqjh.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
    }
};
const $f0e7c62e1985a15a$export$6815765da918b983 = async (createAnalyticsEvent, inviteFlow, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'modal',
        actionSubjectId: 'invitePeopleModal',
        attributes: {
            source: (0, $bDk9X.getSourceByInviteFlow)(inviteFlow)
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $f0e7c62e1985a15a$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $f0e7c62e1985a15a$export$21b810258e82d438 = async (createAnalyticsEvent, source)=>{
    const analyticsPayload = {
        action: 'clicked',
        actionSubject: 'addTeammatetoJira',
        product: 'jira',
        source: source != null && source !== '' ? source : 'unknown'
    };
    $f0e7c62e1985a15a$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};

});
parcelRegister("bDk9X", function(module, exports) {

$parcel$export(module.exports, "getSourceByInviteFlow", () => $7650e673c142be40$export$c35cd18e9d0123e3);
const $7650e673c142be40$export$c35cd18e9d0123e3 = (inviteFlow)=>{
    let source = inviteFlow;
    if (inviteFlow === 'mention') source = 'mentionInEditor';
    else if (inviteFlow === 'assignee') source = 'assigneeField';
    return source;
};

});



parcelRegister("3ky2L", function(module, exports) {
module.exports = new URL("add.b8fea212.png", import.meta.url).toString();

});

const $d61624498c4ec07f$export$eef3ca04e2ec81e0 = 300;
const $d61624498c4ec07f$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $d61624498c4ec07f$export$bdab9bfb39981463 = 'unassigned';
const $d61624498c4ec07f$export$34c10ac17efea7b3 = 'assignToMe';
const $d61624498c4ec07f$export$f5d5f6bb902f1027 = 'automatic';
const $d61624498c4ec07f$export$f42e6736d1a95712 = '-1';



parcelRegister("7Ij3u", function(module, exports) {

$parcel$export(module.exports, "default", () => $855b504570238447$export$2e2bcd8739ae039);
/* eslint-disable react/no-find-dom-node */ 
var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $goZPP = parcelRequire("goZPP");

var $idGBm = parcelRequire("idGBm");


var $7gc68 = parcelRequire("7gc68");
// eslint-disable-next-line jira/react/no-class-components
class $855b504570238447$var$SingleUserSelect extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isEditable: true
        };
    }
    constructor(props){
        super(props), this.onEditStart = ()=>{
            const { onEditStart: onEditStart } = this.props;
            onEditStart && onEditStart();
        }, this.onEditCancel = ()=>{
            const { onEditCancel: onEditCancel } = this.props;
            onEditCancel && onEditCancel();
        }, this.onSubmit = (fieldValue)=>{
            const { onSubmit: onSubmit, value: value } = this.props;
            const isValueUnchanged = value == null && fieldValue == null || value && fieldValue && value.accountId === fieldValue.accountId;
            if (isValueUnchanged) return;
            onSubmit && onSubmit(fieldValue);
        }, this.onSuccess = (fieldValue)=>{
            const { onEditSuccess: onEditSuccess } = this.props;
            onEditSuccess && onEditSuccess(fieldValue);
        }, this.onFailure = ()=>{
            const { onEditFailure: onEditFailure } = this.props;
            onEditFailure && onEditFailure();
        }, this.onMouseEnter = ()=>{
            if (this.node) {
                if (this.state.fieldVerticalOffset !== this.node.offsetTop || this.state.fieldHorizontalOffset !== this.node.offsetLeft) this.setState({
                    fieldVerticalOffset: this.node.offsetTop,
                    fieldHorizontalOffset: this.node.offsetLeft
                });
            }
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSetRef = (ref)=>{
            if (ref && ref instanceof HTMLElement) {
                this.node = ref;
                if ((this.state.fieldVerticalOffset !== ref.offsetTop || this.state.fieldHorizontalOffset !== ref.offsetLeft) && ref.offsetParent instanceof HTMLElement) this.setState({
                    fieldVerticalOffset: ref.offsetTop,
                    fieldHorizontalOffset: ref.offsetLeft
                });
            }
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onSetEditingRef = (ref)=>{
            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'ReactInstance | null | undefined'.
            const node = (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).findDOMNode(ref);
            if (ref && node instanceof HTMLElement) {
                this.editingNode = node;
                const { onSetEditingFieldPosition: onSetEditingFieldPosition } = this.props;
                const { fieldHorizontalOffset: fieldHorizontalOffset, fieldVerticalOffset: fieldVerticalOffset } = this.state;
                this.setState({
                    fieldHorizontalOffset: fieldHorizontalOffset,
                    fieldVerticalOffset: fieldVerticalOffset
                });
                if (node.offsetParent instanceof HTMLElement) onSetEditingFieldPosition(fieldHorizontalOffset, fieldVerticalOffset, node.offsetWidth, node.offsetParent.offsetWidth, node.offsetParent.offsetHeight);
            }
        }, this.renderAssigneeButton = ()=>{
            const { value: value, AssigneeButton: AssigneeButton, isUserPickerDisabled: isUserPickerDisabled, isLastColumn: isLastColumn, isEditable: isEditable, overrideDisabledAppearance: overrideDisabledAppearance } = this.props;
            const isButtonDisabled = !isEditable || isUserPickerDisabled;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AssigneeButton, {
                assignee: value,
                isButtonDisabled: isButtonDisabled,
                overrideDisabledAppearance: overrideDisabledAppearance,
                onClick: !isButtonDisabled ? this.onEditStart : undefined,
                onMouseEnter: this.onMouseEnter,
                isLastColumn: isLastColumn
            });
        };
        this.state = {
            fieldVerticalOffset: 0,
            fieldHorizontalOffset: 0
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.width !== this.props.width && this.props.isFieldLocked && this.editingNode && this.editingNode.offsetParent instanceof HTMLElement) this.props.onSetEditingFieldPosition(this.editingNode.offsetLeft, this.editingNode.offsetTop, this.editingNode.offsetWidth, this.editingNode.offsetParent.offsetWidth, this.editingNode.offsetParent.offsetHeight);
    }
    componentWillUnmount() {
        this.node = null;
    }
    renderFullLengthAvatar() {
        const { isEditable: isEditable, issueKey: issueKey, width: width, isLastColumn: isLastColumn, value: value } = this.props;
        let assigneeButtonKey;
        if (value && value.accountId) assigneeButtonKey = `${issueKey}-${isEditable.toString()}-${value.accountId}`;
        else assigneeButtonKey = `${issueKey}-${isEditable.toString()}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.SelectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                width: width || 'auto'
            },
            ref: this.onSetRef,
            "data-testid": `issue-table.view.fields.common.single-user-select.${issueKey}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            key: assigneeButtonKey,
            component: this.renderAssigneeButton
        })));
    }
    renderWithProfileCard(element) {
        if (!this.props.value) return null;
        const { ProfileCard: ProfileCard } = this.props;
        const { accountId: accountId } = this.props.value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ProfileCard, {
            accountId: accountId,
            actions: [
                (0, $6d22448f78a7f25a$export$23cedd3261bd8015),
                (0, $6d22448f78a7f25a$export$6bef782d14a92db8)
            ]
        }, element);
    }
    renderUserSelect() {
        const { value: value, width: width, fieldType: fieldType, fieldId: fieldId, issueKey: issueKey, UserSelect: UserSelect, rowListRef: rowListRef, onSetEditingFieldPosition: onSetEditingFieldPosition, onEditSelection: onEditSelection, isSaving: isSaving } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(UserSelect, {
            issueKey: issueKey,
            fieldType: fieldType,
            fieldId: fieldId,
            width: width,
            value: value,
            onSubmit: this.onSubmit,
            onEditCancel: this.onEditCancel,
            onEditSuccess: this.onSuccess,
            onEditFailure: this.onFailure,
            onEditSelection: onEditSelection,
            onComponentLoadFailure: this.onEditCancel,
            rowListRef: rowListRef,
            onSetDropdownLocation: onSetEditingFieldPosition,
            ref: this.onSetEditingRef,
            isSaving: isSaving,
            onSetEditingRef: this.onSetEditingRef
        });
    }
    render() {
        const { isFieldLocked: isFieldLocked } = this.props;
        if (isFieldLocked) return this.renderUserSelect();
        const avatarElement = this.renderFullLengthAvatar();
        if (!this.props.value || !this.props.value.accountId) return avatarElement;
        return this.renderWithProfileCard(avatarElement);
    }
}
var // @ts-expect-error - Argument of type 'typeof SingleUserSelect' is not assignable to parameter of type 'ComponentType<WithIntlProvided<{ isSaving: boolean; } & FieldComponentProps<UserFieldType> & { UserSelect: ComponentType<any>; ProfileCard: ComponentType<any>; AssigneeButton: ComponentType<...>; onEditSelection: () => void; }>> & typeof SingleUserSelect'.
$855b504570238447$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($855b504570238447$var$SingleUserSelect);

});
parcelRegister("7gc68", function(module, exports) {

$parcel$export(module.exports, "COLUMN_GUTTER", () => $10214be4689d05a2$export$515be1884a10d89);
$parcel$export(module.exports, "UnselectableChildGutterPaddingContainer", () => $10214be4689d05a2$export$bc94b44cfbfbe38d);
$parcel$export(module.exports, "SelectableChildGutterPaddingContainer", () => $10214be4689d05a2$export$4845bba6014b7a3e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $dPMMf = parcelRequire("dPMMf");
const $10214be4689d05a2$export$515be1884a10d89 = {
    left: (0, $dPMMf.gridSize),
    right: (0, $dPMMf.gridSize) * 3,
    rightLastColumn: (0, $dPMMf.gridSize)
};
const $10214be4689d05a2$var$breakWordStyle = {
    minWidth: '0px',
    overflowWrap: 'break-word'
};
const $10214be4689d05a2$export$bc94b44cfbfbe38d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastColumn: isLastColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gg4a5j": (0, $awdRS.default)(`0px ${__cmplp.isLastColumn ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)"} 0px ${"var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1yt44105 _1ul9idpf _1i4q1hna",
            __cmplp.className
        ])
    });
});
const $10214be4689d05a2$export$4845bba6014b7a3e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastColumn: isLastColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul9idpf _1i4q1hna",
            __cmplp.isLastColumn ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});

});




parcelRegister("4lvo5", function(module, exports) {

$parcel$export(module.exports, "CmdbObjects", () => $368dde458f2b928e$export$1db90f8a9b594ea2);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $rJILZ = parcelRequire("rJILZ");

var $9k1hF = parcelRequire("9k1hF");

var $bAy3a = parcelRequire("bAy3a");
const $368dde458f2b928e$export$1db90f8a9b594ea2 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isExpanded, setIsExpanded] = (0, $eJOHy.useState)(false);
    const enrichedObjects = (0, $bAy3a.filterEnrichedObjects)(props.dataSelectorProps.value);
    const [firstObject, ...remainingObjects] = (0, $bAy3a.sortCmdbObjects)(enrichedObjects);
    const handleShowMoreClick = (event, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'insightObjectQueuesToggleShowMore', {
            action: isExpanded ? 'hiding' : 'showing'
        });
        setIsExpanded(!isExpanded);
    };
    const renderObject = (object)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($368dde458f2b928e$var$SingleObject, {
            key: object.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $rJILZ.MemoizedInsightIcon), {
            mediaClientConfig: object.avatar.mediaClientConfig,
            size: "xsmall",
            iconUrl: object.avatar.url16,
            label: object.label
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($368dde458f2b928e$var$ObjectLabel, null, object.label));
    const hasMoreObjects = remainingObjects.length > 0;
    const showAllObjects = isExpanded && hasMoreObjects;
    if (!firstObject) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($368dde458f2b928e$var$EmptyObject, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($368dde458f2b928e$var$MessageWrapper, null, formatMessage((0, $9k1hF.default).none)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($368dde458f2b928e$var$Wrapper, null, renderObject(firstObject), showAllObjects && remainingObjects.map(renderObject), hasMoreObjects && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "link",
        onClick: handleShowMoreClick
    }, isExpanded ? formatMessage((0, $9k1hF.default).showLess) : formatMessage((0, $9k1hF.default).showMore, {
        numberOfObjects: remainingObjects.length
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $368dde458f2b928e$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $368dde458f2b928e$var$SingleObject = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _19pk1b66 _2hwxidpf _otyr1b66 _18u0idpf _ca0qv77o _u5f3u2gc _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $368dde458f2b928e$var$ObjectLabel = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $368dde458f2b928e$var$MessageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1yt412v8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $368dde458f2b928e$var$EmptyObject = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _19pk1b66 _2hwxidpf _otyr1b66 _18u0idpf _ca0qv77o _u5f3u2gc _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("rJILZ", function(module, exports) {

$parcel$export(module.exports, "InsightIcon", () => $b4089468fa56dc7f$export$4f72cced31fa9b94);
$parcel$export(module.exports, "MemoizedInsightIcon", () => $b4089468fa56dc7f$export$55641517b59933d7);
$parcel$export(module.exports, "UnstyledInsightIcon", () => $b4089468fa56dc7f$export$30c7947f25987be2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2TCFC = parcelRequire("2TCFC");
var $5DgXR = parcelRequire("5DgXR");
var $lC3pF = parcelRequire("lC3pF");

var $cgxPA = parcelRequire("cgxPA");

var $51aj0 = parcelRequire("51aj0");
const $b4089468fa56dc7f$export$d80733771196ad02 = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.clientId) && Boolean(mediaClientConfig.fileId);
const $b4089468fa56dc7f$var$DefaultIcon = ({ size: size, label: label })=>/*#__PURE__*/ $eJOHy.createElement((0, $5DgXR.default), {
        appearance: "square",
        size: size,
        name: label
    });
const $b4089468fa56dc7f$export$a39db5532f57c7c2 = (clientAuth)=>Promise.resolve({
        clientId: clientAuth.clientId,
        token: clientAuth.mediaJwtToken,
        // eslint-disable-next-line jira/deprecations/no-base-url
        baseUrl: clientAuth.mediaBaseUrl
    });
const $b4089468fa56dc7f$export$4f72cced31fa9b94 = (props)=>{
    const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
    const sizeInPx = (0, $2TCFC.AVATAR_SIZES)[size];
    const renderAvatar = (src)=>/*#__PURE__*/ $eJOHy.createElement("img", {
            loading: "lazy",
            src: src,
            width: sizeInPx,
            height: sizeInPx,
            alt: ""
        });
    if (!mediaClientConfig || $b4089468fa56dc7f$export$d80733771196ad02(mediaClientConfig) === false) {
        if (iconUrl) return renderAvatar(iconUrl);
        return /*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$var$DefaultIcon, {
            size: size,
            label: label
        });
    }
    const fileIdentifier = {
        id: mediaClientConfig.fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: (0, $2TCFC.AVATAR_SIZES)[size],
        height: (0, $2TCFC.AVATAR_SIZES)[size]
    };
    return /*#__PURE__*/ $eJOHy.createElement((0, $cgxPA.MediaImageWithErrorBoundary), {
        identifier: fileIdentifier,
        mediaClientConfig: {
            authProvider: ()=>$b4089468fa56dc7f$export$a39db5532f57c7c2(mediaClientConfig)
        },
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ $eJOHy.createElement((0, $lC3pF.default), {
            appearance: "square",
            size: size
        });
        if (error) {
            (0, $51aj0.fireCmdbErrorAnalytics)({
                error: // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'Error | undefined'.
                error,
                meta: {
                    id: 'insightIcon',
                    packageName: 'jiraServicedeskInsightIcon',
                    teamName: 'aurum'
                }
            });
            return /*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        if (!data) return /*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$var$DefaultIcon, {
            size: size,
            label: label
        });
        return renderAvatar(data.src);
    });
};
const $b4089468fa56dc7f$export$55641517b59933d7 = /*#__PURE__*/ (0, $eJOHy.memo)($b4089468fa56dc7f$export$4f72cced31fa9b94);
const $b4089468fa56dc7f$export$30c7947f25987be2 = (props)=>/*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$var$UnstyledInsightIconWrapper, null, /*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$export$55641517b59933d7, props));
/**
 * The reason for calling !important on display block is to ovveride the inherited
 * CSS from Avatar atlaskit component in order to centre the icon within the reference
 * object container.
 */ // Double check the shadow !
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4089468fa56dc7f$var$UnstyledInsightIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1i6y _2hwx1i6y _otyr1i6y _18u01i6y _1e0c1txw _p7r1tcjq _1ugpglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lC3pF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd8f08acdf78d9e1$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $fd8f08acdf78d9e1$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $fd8f08acdf78d9e1$var$styles = {
    root: "_2rko1q5u _189e1bk5 _1dqonqa1 _1h6d3acm _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    strongOpacity: "_tzy4clii"
};
const $fd8f08acdf78d9e1$var$sizeStyles = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $fd8f08acdf78d9e1$var$borderRadiusMap = {
    xsmall: "_2rkogqwt",
    small: "_2rkogqwt",
    medium: "_2rko1l7b",
    large: "_2rko1l7b",
    xlarge: "_2rkoi2wt",
    xxlarge: "_2rkob7nn"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $fd8f08acdf78d9e1$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$fd8f08acdf78d9e1$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $hcewu.default)([
            $fd8f08acdf78d9e1$var$styles.root,
            $fd8f08acdf78d9e1$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' && $fd8f08acdf78d9e1$var$borderRadiusMap[size ?? 'medium'],
            weight === 'strong' && $fd8f08acdf78d9e1$var$styles.strongOpacity
        ])
    });
var $fd8f08acdf78d9e1$export$2e2bcd8739ae039 = $fd8f08acdf78d9e1$var$Skeleton;

});

parcelRegister("cgxPA", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $4d10e61645f59e88$export$758a2fef95a29ad0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $iDkaD = parcelRequire("iDkaD");
const $4d10e61645f59e88$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: props.children({
                loading: false,
                error: true
            })
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iDkaD.MediaImageWithMediaClient), {
            ...props
        })
    });

});
parcelRegister("iDkaD", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithMediaClient", () => $124670e45144e8f4$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cu5Ae = parcelRequire("cu5Ae");

var $iN7PZ = parcelRequire("iN7PZ");

var $eGOwo = parcelRequire("eGOwo");
const $124670e45144e8f4$var$copyDivStyles = null;
const $124670e45144e8f4$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $iN7PZ.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            children({
                loading: status === 'loading',
                error: status === 'error',
                data: status === 'succeeded' ? {
                    status: status,
                    src: preview?.dataURI
                } : undefined
            }),
            (0, $eGOwo.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ref: copyNodeRef,
                className: (0, $hcewu.default)([
                    "_1e0cglyw"
                ])
            }),
            getSsrScriptProps && /*#__PURE__*/ (0, $gt9Am.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};
const $124670e45144e8f4$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $eJOHy.useMemo)(()=>(0, $cu5Ae.withMediaClient)($124670e45144e8f4$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(MediaImageComponent, {
        ...props
    });
};

});
parcelRegister("cu5Ae", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $5bfc4058bddc627f$export$9f7977d4a2561bee);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");
const $5bfc4058bddc627f$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        });

});
parcelRegister("93R6D", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $c470ce77068e97aa$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $c470ce77068e97aa$export$5bff351c86f56d97);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");
const $c470ce77068e97aa$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $c470ce77068e97aa$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($c470ce77068e97aa$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};

});
parcelRegister("aRuva", function(module, exports) {

$parcel$export(module.exports, "getMediaClient", () => $3430d7925e0b0890$export$c9ecbc1b719fd417);

var $e33YM = parcelRequire("e33YM");
const $3430d7925e0b0890$export$f92e83e86b03c398 = new Map();
const $3430d7925e0b0890$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $e33YM.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $3430d7925e0b0890$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $e33YM.MediaClient)(mediaClientConfig);
        $3430d7925e0b0890$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});
parcelRegister("e33YM", function(module, exports) {

$parcel$export(module.exports, "MediaClient", () => $4ee615cd17ba35c7$export$fba8b4ca6d386aec);

var $adK77 = parcelRequire("adK77");
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");

var $jkwTu = parcelRequire("jkwTu");

var $iPHIU = parcelRequire("iPHIU");

var $gWavf = parcelRequire("gWavf");
parcelRequire("48hWz");
var $1ZNSP = parcelRequire("1ZNSP");

class $4ee615cd17ba35c7$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $1ZNSP.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $jkwTu.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $9t1Mu.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $iPHIU.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $adK77.EventEmitter2)();
        this.stargate = new (0, $gWavf.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("c4FM0"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("adK77", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $igDjg !== 'undefined' && $igDjg.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $igDjg.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("1jG9B", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("bLPxw")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("7mZlN")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("7mZlN")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("9t1Mu")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $bLPxw = parcelRequire("bLPxw");

var $7mZlN = parcelRequire("7mZlN");

var $9t1Mu = parcelRequire("9t1Mu");

});
parcelRegister("bLPxw", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $b0497af2bbf706c4$export$8cef61637918b288);

var $adK77 = parcelRequire("adK77");

var $7xkt0 = parcelRequire("7xkt0");
const $b0497af2bbf706c4$export$8cef61637918b288 = {
    streams: new (0, $7xkt0.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $adK77.EventEmitter2)()
};

});

parcelRegister("7mZlN", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $8faf84af4f6865cd$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $8faf84af4f6865cd$export$17f6055767a8d96a);
function $8faf84af4f6865cd$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $8faf84af4f6865cd$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $8faf84af4f6865cd$export$17f6055767a8d96a = (auth)=>{
    if ($8faf84af4f6865cd$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("9t1Mu", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $7f634a1b182817d3$export$d3e73a50cc549c2e);
var $7f634a1b182817d3$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});


parcelRegister("jkwTu", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $6c83a790055aaff5$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $6c83a790055aaff5$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $6c83a790055aaff5$export$20f9315304dd6726);
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");
var $7mZlN = parcelRequire("7mZlN");

var $6PCIn = parcelRequire("6PCIn");

var $1xw3A = parcelRequire("1xw3A");

var $h3W10 = parcelRequire("h3W10");
var $8RCh7 = parcelRequire("8RCh7");

var $2Cdf9 = parcelRequire("2Cdf9");

var $2dJnj = parcelRequire("2dJnj");

var $hsEvX = parcelRequire("hsEvX");

var $eGOwo = parcelRequire("eGOwo");

var $3NmFr = parcelRequire("3NmFr");
const $6c83a790055aaff5$var$MEDIA_API_REGION = 'media-api-region';
const $6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $6c83a790055aaff5$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $6PCIn.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $6PCIn.MAX_RESOLUTION),
            height: (0, $6PCIn.MAX_RESOLUTION)
        } : {}
    };
};
const $6c83a790055aaff5$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $6c83a790055aaff5$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $3NmFr.isCommercial)() && (0, $eGOwo.fg)('platform_media_cdn_delivery')) result += '/cdn';
    return result;
};
class $6c83a790055aaff5$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.getArtifactBinary = async (artifacts, artifactName, { collectionName: collectionName, abortController: abortController, maxAge: maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE), traceContext: traceContext })=>{
            const metadata = {
                method: 'GET',
                endpoint: `artifact-cdn-url`
            };
            const extendedTraceContext = (0, $2Cdf9.extendTraceContext)(traceContext);
            const options = {
                ...metadata,
                traceContext: extendedTraceContext
            };
            const artifactUrl = await this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
            return (0, $8RCh7.request)(artifactUrl, options, abortController).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const metadata = {
                method: 'POST',
                endpoint: '/file/{fileId}/artifact/binary'
            };
            const headers = {
                Accept: 'application/json',
                'Content-Type': file.type
            };
            const extendedParams = {
                ...params,
                name: file.name,
                collection: collectionName
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                headers: headers,
                params: extendedParams,
                body: file,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/artifact/binary`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            const metadata = {
                method: 'DELETE',
                endpoint: '/file/{fileId}/artifact/{artifactName}'
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                traceContext: traceContext,
                params: {
                    collection: collectionName
                }
            };
            await this.request(`/file/${id}/artifact/${artifactName}`, options);
        };
        this.resolveAuth = (authContext)=>(0, $hsEvX.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $hsEvX.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $9t1Mu.ChunkHashAlgorithm).Sha256;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $6c83a790055aaff5$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('image');
        return (0, $2dJnj.mapToMediaCdnUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('binary');
        return (0, $2dJnj.mapToMediaCdnUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        // ----- WARNING ----------
        // DO NOT USE!!!!!
        // artifact.cdnUrl fails in Jira.
        // ----------------------------------
        // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
        // We use the provided cdnUrl from metadata first.
        /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
			const cdnUrl = artifacts[artifactName]?.cdnUrl;
			if (cdnUrl) {
				return cdnUrl;
			}
		} */ const artifactUrl = (0, $1xw3A.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        return (0, $2Cdf9.createUrl)((0, $2dJnj.mapToMediaCdnUrl)(artifactUrl, auth.token), options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $6c83a790055aaff5$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getDocumentContent(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $6c83a790055aaff5$var$cdnFeatureFlag('contents') : 'contents';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                pageStart: options.pageStart,
                pageEnd: options.pageEnd,
                'max-age': shouldCache ? (0, $6PCIn.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getDocumentPageImage(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $6c83a790055aaff5$var$cdnFeatureFlag('page') : 'page';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                page: options.page,
                zoom: options.zoom,
                'max-age': shouldCache ? (0, $6PCIn.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                id: id
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>(0, $2Cdf9.defaultShouldRetryError)(err) || (0, $h3W10.isRequestError)(err) && err?.metadata?.statusCode === 401
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $7mZlN.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $2Cdf9.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $2dJnj.mapToMediaCdnUrl)(url, auth.token);
        const response = await (0, $8RCh7.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $6c83a790055aaff5$var$setKeyValueInSessionStorage($6c83a790055aaff5$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $6c83a790055aaff5$var$setKeyValueInSessionStorage($6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $8RCh7.request)(url, {
            method: 'HEAD',
            traceContext: (0, $2Cdf9.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $6c83a790055aaff5$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $6c83a790055aaff5$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $6c83a790055aaff5$export$c8b741e18397852a = ()=>{
    return $6c83a790055aaff5$var$getValueFromSessionStorage($6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT);
};
const $6c83a790055aaff5$export$20f9315304dd6726 = ()=>{
    return $6c83a790055aaff5$var$getValueFromSessionStorage($6c83a790055aaff5$var$MEDIA_API_REGION);
};

});
parcelRegister("6PCIn", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $b90d9cdebe03397b$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $b90d9cdebe03397b$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $b90d9cdebe03397b$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $b90d9cdebe03397b$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $b90d9cdebe03397b$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $b90d9cdebe03397b$export$f14f521f3d306044);

var $jmTJ7 = parcelRequire("jmTJ7");
const $b90d9cdebe03397b$export$860a16125e30000b = 'recents';
const $b90d9cdebe03397b$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $b90d9cdebe03397b$export$6e70f30e392bc53f = 4096;
const $b90d9cdebe03397b$export$c1abb8bab1e615cd = 5 * (0, $jmTJ7.DATA_UNIT).MB;
const $b90d9cdebe03397b$export$3d5157f0def70e54 = 1000;
const $b90d9cdebe03397b$export$f14f521f3d306044 = 2 * (0, $jmTJ7.DATA_UNIT).TB;

});
parcelRegister("jmTJ7", function(module, exports) {

$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $29f3d51eb645d15a$export$fd27d7abbc4a746d);
$parcel$export(module.exports, "DATA_UNIT", () => $29f3d51eb645d15a$export$76cfea4c354af843);
const $29f3d51eb645d15a$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
const $29f3d51eb645d15a$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $29f3d51eb645d15a$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("1xw3A", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $91442ef87cdc4338$export$1cc24defa44e7f84);

var $eGOwo = parcelRequire("eGOwo");

var $3NmFr = parcelRequire("3NmFr");
const $91442ef87cdc4338$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $3NmFr.isCommercial)() && (0, $eGOwo.fg)('platform_media_cdn_delivery') && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};

});
parcelRegister("3NmFr", function(module, exports) {

$parcel$export(module.exports, "isCommercial", () => $130542adabbe691e$export$df69ff6733e73e50);
function $130542adabbe691e$export$df69ff6733e73e50() {
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
}

});


parcelRegister("h3W10", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $360d238df22c07b8$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $360d238df22c07b8$export$3717b1ffef4428ea);

var $4rKJa = parcelRequire("4rKJa");
class $360d238df22c07b8$export$43ee7d0e4f429743 extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}
function $360d238df22c07b8$export$3717b1ffef4428ea(err) {
    return err instanceof $360d238df22c07b8$export$43ee7d0e4f429743;
}

});
parcelRegister("4rKJa", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $e9c543355e5204ca$export$2b0aca14d61c3190);
$parcel$export(module.exports, "CommonMediaClientError", () => $e9c543355e5204ca$export$e574d1724215079f);
$parcel$export(module.exports, "isCommonMediaClientError", () => $e9c543355e5204ca$export$881f0f9bc813e1f3);
$parcel$export(module.exports, "toCommonMediaClientError", () => $e9c543355e5204ca$export$a5db89cfc88eff9);
$parcel$export(module.exports, "fromCommonMediaClientError", () => $e9c543355e5204ca$export$c2b89b9a32286816);

var $eBofv = parcelRequire("eBofv");
class $e9c543355e5204ca$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $e9c543355e5204ca$export$e574d1724215079f extends $e9c543355e5204ca$export$2b0aca14d61c3190 {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}
function $e9c543355e5204ca$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $e9c543355e5204ca$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
const $e9c543355e5204ca$export$a5db89cfc88eff9 = (errorFileState)=>{
    const error = errorFileState.details?.error;
    return new $e9c543355e5204ca$export$e574d1724215079f(error?.reason || 'unknown-reason', error.metadata, error.innerError);
};
const $e9c543355e5204ca$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error?.reason,
                metadata: error?.metadata,
                innerError: error?.innerError
            },
            // Legacy details
            ...error?.attributes
        },
        message: error?.message
    };
};

});
parcelRegister("eBofv", function(module, exports) {

$parcel$export(module.exports, "getMediaClientErrorReason", () => $508e04f54b9269ab$export$c15d72765ee2baa4);
function $508e04f54b9269ab$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $508e04f54b9269ab$export$c15d72765ee2baa4(err) {
    return $508e04f54b9269ab$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("8RCh7", function(module, exports) {

$parcel$export(module.exports, "request", () => $16d1dca60bf2e497$export$b5fe3f66a567bec0);

var $h3W10 = parcelRequire("h3W10");

var $2Cdf9 = parcelRequire("2Cdf9");
async function $16d1dca60bf2e497$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $2Cdf9.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $2Cdf9.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $2Cdf9.createProcessFetchResponse)(metadata));
    return (0, $2Cdf9.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("2Cdf9", function(module, exports) {

$parcel$export(module.exports, "extendTraceContext", () => $8e2ee04a8e27c7ba$export$ee24a95986dfd173);
$parcel$export(module.exports, "createUrl", () => $8e2ee04a8e27c7ba$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $8e2ee04a8e27c7ba$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $8e2ee04a8e27c7ba$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $8e2ee04a8e27c7ba$export$5cc7b0795397da86);
$parcel$export(module.exports, "defaultShouldRetryError", () => $8e2ee04a8e27c7ba$export$fee2242cbb339663);
$parcel$export(module.exports, "fetchRetry", () => $8e2ee04a8e27c7ba$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $8e2ee04a8e27c7ba$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $8e2ee04a8e27c7ba$export$6e2e477edb7d6032);
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");

var $3xaEP = parcelRequire("3xaEP");

var $9WNJB = parcelRequire("9WNJB");

var $h3W10 = parcelRequire("h3W10");
const $8e2ee04a8e27c7ba$var$getStatusCode = (error)=>(0, $h3W10.isRequestError)(error) && error.metadata?.statusCode && error.metadata.statusCode;
function $8e2ee04a8e27c7ba$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $8e2ee04a8e27c7ba$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $8e2ee04a8e27c7ba$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $8e2ee04a8e27c7ba$export$bc96a6a479480590(error) {
    const statusCode = error && $8e2ee04a8e27c7ba$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $8e2ee04a8e27c7ba$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: traceContext?.spanId || (0, $3xaEP.getRandomTelemetryId)()
    } : undefined;
const $8e2ee04a8e27c7ba$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $8e2ee04a8e27c7ba$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$8e2ee04a8e27c7ba$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$8e2ee04a8e27c7ba$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $8e2ee04a8e27c7ba$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $7mZlN.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $8e2ee04a8e27c7ba$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $9WNJB.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.set(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $8e2ee04a8e27c7ba$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$8e2ee04a8e27c7ba$export$eaf4479116d2f925(auth),
        ...$8e2ee04a8e27c7ba$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $8e2ee04a8e27c7ba$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $h3W10.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $8e2ee04a8e27c7ba$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $h3W10.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $8e2ee04a8e27c7ba$export$fee2242cbb339663 = (err)=>{
    const statusCode = $8e2ee04a8e27c7ba$var$getStatusCode(err);
    return $8e2ee04a8e27c7ba$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
const $8e2ee04a8e27c7ba$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $8e2ee04a8e27c7ba$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $h3W10.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $8e2ee04a8e27c7ba$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$8e2ee04a8e27c7ba$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = $8e2ee04a8e27c7ba$export$fee2242cbb339663 } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $8e2ee04a8e27c7ba$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($8e2ee04a8e27c7ba$export$de0b576cf7ce4a53(err)) throw new (0, $h3W10.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $h3W10.isRequestError)(lastError)) throw $8e2ee04a8e27c7ba$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $h3W10.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $8e2ee04a8e27c7ba$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 422:
            return 'serverUnprocessableEntity';
        case 423:
            return 'serverEntityLocked';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $8e2ee04a8e27c7ba$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $8e2ee04a8e27c7ba$export$6397609af718d008(statusCode);
    return new (0, $h3W10.RequestError)(reason, {
        ...metadata,
        ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $8e2ee04a8e27c7ba$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $8e2ee04a8e27c7ba$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $8e2ee04a8e27c7ba$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("3xaEP", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $af4102ec3e3c11b2$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $af4102ec3e3c11b2$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $af4102ec3e3c11b2$export$456b25e3a9b4a843);
$parcel$export(module.exports, "getRandomTelemetryId", () => $af4102ec3e3c11b2$export$2e36de8639bad0ad);
const $af4102ec3e3c11b2$export$fce6876652108ab = (value)=>value === undefined;
const $af4102ec3e3c11b2$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $af4102ec3e3c11b2$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $af4102ec3e3c11b2$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $af4102ec3e3c11b2$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $af4102ec3e3c11b2$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $af4102ec3e3c11b2$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $af4102ec3e3c11b2$var$getRandomHexValues(byte);
    }
    else randomHex = $af4102ec3e3c11b2$var$getRandomHexValues(byte);
    return randomHex;
}
function $af4102ec3e3c11b2$export$2e36de8639bad0ad() {
    return $af4102ec3e3c11b2$export$456b25e3a9b4a843(8);
}

});

parcelRegister("9WNJB", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $47d6feb819b26718$export$6833b130611df767);
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");
function $47d6feb819b26718$export$6833b130611df767(auth) {
    if ((0, $7mZlN.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("2dJnj", function(module, exports) {

$parcel$export(module.exports, "mapToMediaCdnUrl", () => $bf5b522ee1224e39$export$fb88a576cf28364d);

var $eGOwo = parcelRequire("eGOwo");

var $3NmFr = parcelRequire("3NmFr");
const $bf5b522ee1224e39$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $bf5b522ee1224e39$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $bf5b522ee1224e39$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if (!(0, $3NmFr.isCommercial)() || tokenLength > $bf5b522ee1224e39$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $eGOwo.fg)('platform_media_cdn_delivery') && (0, $eGOwo.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $bf5b522ee1224e39$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});

parcelRegister("hsEvX", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $6d143f49360dbe76$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $6d143f49360dbe76$export$5211e1371264aec3);

var $3Y4Hn = parcelRequire("3Y4Hn");

var $3nErQ = parcelRequire("3nErQ");
const $6d143f49360dbe76$export$560085fe411c0660 = 10000;
const $6d143f49360dbe76$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $6d143f49360dbe76$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $3nErQ.rejectTimeout)(authProviderTimeout, new (0, $3Y4Hn.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $3Y4Hn.MediaStoreError)) throw err;
        throw new (0, $3Y4Hn.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $3Y4Hn.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $6d143f49360dbe76$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $3Y4Hn.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("3Y4Hn", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $d19f60583c5ce4e8$export$b78480bd311630bc);

var $4rKJa = parcelRequire("4rKJa");
class $d19f60583c5ce4e8$export$b78480bd311630bc extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $d19f60583c5ce4e8$export$8d2a9b675b2ce37a(err) {
    return err instanceof $d19f60583c5ce4e8$export$b78480bd311630bc;
}

});

parcelRegister("3nErQ", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $bdd7813d02cb717f$export$cf2d2a1124beacb2);
const $bdd7813d02cb717f$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $bdd7813d02cb717f$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("iPHIU", function(module, exports) {

$parcel$export(module.exports, "FileFetcherImpl", () => $09c82e56436a3d4e$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("1GWfm")).FileFetcherError);

var $2PBDa = parcelRequire("2PBDa");

var $3PmNk = parcelRequire("3PmNk");

var $8KLBw = parcelRequire("8KLBw");
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");

var $g1OQu = parcelRequire("g1OQu");

var $jkwTu = parcelRequire("jkwTu");

var $bbNl0 = parcelRequire("bbNl0");

var $jmTJ7 = parcelRequire("jmTJ7");

var $1GWfm = parcelRequire("1GWfm");

var $2mMyO = parcelRequire("2mMyO");

var $abkQS = parcelRequire("abkQS");

var $lRBVi = parcelRequire("lRBVi");

var $6PCIn = parcelRequire("6PCIn");

var $eaj78 = parcelRequire("eaj78");

var $hRxrn = parcelRequire("hRxrn");

var $atDjN = parcelRequire("atDjN");

var $053B3 = parcelRequire("053B3");

var $iDYg8 = parcelRequire("iDYg8");

var $jFXx8 = parcelRequire("jFXx8");
var $kFG4u = parcelRequire("kFG4u");

var $ea8A0 = parcelRequire("ea8A0");

var $jkEmk = parcelRequire("jkEmk");

var $5JVfG = parcelRequire("5JVfG");

var $8UZz3 = parcelRequire("8UZz3");

var $393Zn = parcelRequire("393Zn");

var $iX2Cl = parcelRequire("iX2Cl");
parcelRequire("48hWz");
var $1ZNSP = parcelRequire("1ZNSP");

var $bksvR = parcelRequire("bksvR");

var $2Cdf9 = parcelRequire("2Cdf9");

var $4rKJa = parcelRequire("4rKJa");
const $09c82e56436a3d4e$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $09c82e56436a3d4e$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
class $09c82e56436a3d4e$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $1ZNSP.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $4rKJa.isCommonMediaClientError)(error)) return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $4rKJa.CommonMediaClientError)(error);
                return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $4rKJa.CommonMediaClientError)(error?.reason || 'unknown', error?.metadata, error?.innerError);
                return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh)=>{
            const subject = (0, $jkEmk.createMediaSubject)();
            const poll = new (0, $393Zn.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $jmTJ7.isNotFoundMediaItemDetails)(response)) throw new (0, $1GWfm.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $iX2Cl.isEmptyFile)(response)) throw new (0, $1GWfm.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $bbNl0.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $iDYg8.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $atDjN.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const { data: data } = await this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
            /* TEMPORARYLY PULLING NEW METADATA till the endpoint is fixed */ const { data: altData } = await this.mediaApi.getItems([
                id
            ], collectionName, traceContext);
            const itemDetails = altData.items[0].details;
            // ------------------------------------------------------------
            this.setFileState(id, (0, $bbNl0.mapMediaItemToFileState)(id, itemDetails));
            return data;
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            await this.mediaApi.deleteArtifact(id, artifactName, collectionName, traceContext);
            // Manually remove the artifact from file state instead of re-requesting the entire payload.
            const file = this.store.getState().files[id];
            if (file && file.status === 'processed' && file.artifacts) {
                const updatedArtifacts = {
                    ...file.artifacts
                };
                delete updatedArtifacts[artifactName];
                const updatedFileState = {
                    ...file,
                    artifacts: updatedArtifacts
                };
                this.setFileState(id, updatedFileState);
            }
        };
        this.getOrFetchFileState = async (id, collectionName)=>{
            let fileState = this.store.getState().files[id];
            return fileState ?? await this.getCurrentState(id, {
                collectionName: collectionName
            });
        };
        this.getDurationOfVideo = async (id, collectionName)=>{
            const fileState = await this.getOrFetchFileState(id, collectionName);
            if (fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4']) throw new Error('File is not a video');
            const artifactUrlString = await this.getArtifactURL(fileState.artifacts, 'video.mp4');
            const artifactUrl = new URL(artifactUrlString);
            const artifactPath = `${artifactUrl.pathname}${artifactUrl.search}`;
            const res = await this.mediaApi.request(artifactPath, {
                headers: {
                    Range: 'bytes=0-199'
                }
            });
            // Get the response as ArrayBuffer
            const arrayBuffer = await res.arrayBuffer();
            const uint8Array = new Uint8Array(arrayBuffer);
            const mvhdBytes = new Uint8Array([
                109,
                118,
                104,
                100
            ]); // "mvhd" in ASCII
            let mvhdIndex = -1;
            for(let i = 0; i <= uint8Array.length - mvhdBytes.length; i++){
                mvhdIndex = i;
                for(let j = 0; j < mvhdBytes.length; j++)if (uint8Array[i + j] !== mvhdBytes[j]) {
                    mvhdIndex = -1;
                    break;
                }
                if (mvhdIndex !== -1) break;
            }
            if (mvhdIndex === -1) throw new Error('Unable to find mvhd bytes');
            // Create DataView for reading big-endian integers
            const dataView = new DataView(arrayBuffer);
            const start = mvhdIndex + 16; // Skip atom header and version/flags
            // Check if we have enough bytes to read timescale and duration
            if (start + 8 > arrayBuffer.byteLength) return 0;
            // flase as second parameter indicates big-endian 32-bit integers
            const timeScale = dataView.getUint32(start, false);
            const duration = dataView.getUint32(start + 4, false);
            if (timeScale === 0) throw new Error('Timescale is invalid');
            // get the video length in seconds
            const videoLength = Math.floor(duration / timeScale);
            return videoLength;
        };
        this.getVideoDurations = async (files)=>{
            // get all the duration promises
            const promises = files.map(async ({ id: id, collectionName: collectionName })=>{
                try {
                    return await this.getDurationOfVideo(id, collectionName);
                } catch (_err) {
                    return -1;
                }
            });
            const durations = await Promise.all(promises);
            // only return the durations that are present;
            return durations.reduce((acc, curr, i)=>{
                if (curr !== -1) {
                    const id = files[i].id;
                    acc[id] = curr;
                }
                return acc;
            }, {});
        };
        this.dataloader = (0, $hRxrn.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $bksvR.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eaj78)))(id)) {
            const subject = (0, $jkEmk.createMediaSubject)();
            const err = new (0, $1GWfm.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $jFXx8.fromObservable)(subject);
        }
        if (forceRefresh) (0, $abkQS.getFileStreamsCache)().remove(id);
        return (0, $jFXx8.fromObservable)((0, $abkQS.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $kFG4u.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $jkEmk.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $abkQS.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $5JVfG.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $ea8A0.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $jkEmk.createMediaSubject)();
        (0, $abkQS.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $2PBDa.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $3PmNk.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $053B3.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $2mMyO.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $jFXx8.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName, traceContext) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $g1OQu.downloadUrl)(url, {
            name: name
        });
        (0, $lRBVi.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $6PCIn.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $2Cdf9.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $jkwTu.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $7mZlN.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $abkQS.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($09c82e56436a3d4e$var$isCopySourceFileWithToken(source) && $09c82e56436a3d4e$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $5JVfG.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $bbNl0.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $jkEmk.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $bbNl0.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $bbNl0.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $8UZz3.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $053B3.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $053B3.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $bbNl0.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $bbNl0.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $bbNl0.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $abkQS.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $jkEmk.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("g1OQu", function(module, exports) {

$parcel$export(module.exports, "downloadUrl", () => $c1f893c1652c9963$export$8a96edb1c96563f4);
const $c1f893c1652c9963$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("bbNl0", function(module, exports) {

$parcel$export(module.exports, "isUploadingFileState", () => $071e98cd60064284$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $071e98cd60064284$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $071e98cd60064284$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $071e98cd60064284$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $071e98cd60064284$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $071e98cd60064284$export$270b3fc27120edd0);
$parcel$export(module.exports, "isNonErrorFinalFileState", () => $071e98cd60064284$export$8f33148a37b0c72f);
$parcel$export(module.exports, "hasArtifacts", () => $071e98cd60064284$export$ecdf3dee1d148302);
$parcel$export(module.exports, "isImageRepresentationReady", () => $071e98cd60064284$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $071e98cd60064284$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $071e98cd60064284$export$ea3730792e8bebfb);
const $071e98cd60064284$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $071e98cd60064284$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $071e98cd60064284$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $071e98cd60064284$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $071e98cd60064284$export$92dd692b31e42e64 = (fileState)=>!$071e98cd60064284$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $071e98cd60064284$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $071e98cd60064284$export$8f33148a37b0c72f = (fileState)=>[
        'processed',
        'failed-processing'
    ].includes(fileState.status);
const $071e98cd60064284$export$ecdf3dee1d148302 = (fileState)=>'artifacts' in fileState && fileState.artifacts !== undefined;
const $071e98cd60064284$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $071e98cd60064284$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification, mediaMetadata: mediaMetadata } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification,
        mediaMetadata: mediaMetadata
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $071e98cd60064284$export$ea3730792e8bebfb = (id, item)=>{
    return $071e98cd60064284$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("1GWfm", function(module, exports) {

$parcel$export(module.exports, "FileFetcherError", () => $a248c46a7558c626$export$e3e60f0dab8641de);

var $4rKJa = parcelRequire("4rKJa");
class $a248c46a7558c626$export$e3e60f0dab8641de extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
}
function $a248c46a7558c626$export$5c3435f75ce0ce70(err) {
    return err instanceof $a248c46a7558c626$export$e3e60f0dab8641de;
}

});

parcelRegister("2mMyO", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $d0f3b9835713140d$export$a5575dbeeffdad98);

var $irjb3 = parcelRequire("irjb3");

var $2opa2 = parcelRequire("2opa2");

var $4pIMA = parcelRequire("4pIMA");

var $keN2a = parcelRequire("keN2a");

var $bpbRw = parcelRequire("bpbRw");

var $6PCIn = parcelRequire("6PCIn");

var $jZL78 = parcelRequire("jZL78");
const $d0f3b9835713140d$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $keN2a.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $d0f3b9835713140d$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $d0f3b9835713140d$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $d0f3b9835713140d$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $d0f3b9835713140d$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $d0f3b9835713140d$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $6PCIn.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $jZL78.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $jZL78.fileSizeError)) callbacks?.onUploadFinish(new (0, $bpbRw.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $irjb3.chunkinator)(content, {
        hashingFunction: (blob)=>$d0f3b9835713140d$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $d0f3b9835713140d$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $6PCIn.PROCESSING_BATCH_SIZE),
        processingFunction: $d0f3b9835713140d$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $2opa2.from)(deferredUploadId).pipe((0, $4pIMA.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $4pIMA.concatMap)(()=>(0, $2opa2.from)($d0f3b9835713140d$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $d0f3b9835713140d$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("irjb3", function(module, exports) {

$parcel$export(module.exports, "chunkinator", () => $d61183fbf8357e07$export$9ab6bef3838698f8);

var $jgII5 = parcelRequire("jgII5");

var $4pIMA = parcelRequire("4pIMA");

var $aoje7 = parcelRequire("aoje7");

var $9cPse = parcelRequire("9cPse");

var $fjIB7 = parcelRequire("fjIB7");

var $iyZWI = parcelRequire("iyZWI");

var $htAnC = parcelRequire("htAnC");

var $h9RjH = parcelRequire("h9RjH");

var $aN4rI = parcelRequire("aN4rI");

var $2opa2 = parcelRequire("2opa2");
const $d61183fbf8357e07$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $9cPse.fromPromise)((0, $aN4rI.fetchBlob)(file)).pipe((0, $4pIMA.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $fjIB7.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $iyZWI.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $htAnC.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $jgII5.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $h9RjH.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $4pIMA.concatMap)((batchedChunks)=>{
            return (0, $2opa2.from)(batchedChunks);
        }), (0, $aoje7.bufferCount)(totalChunks));
    }));
const $d61183fbf8357e07$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $d61183fbf8357e07$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("fjIB7", function(module, exports) {

$parcel$export(module.exports, "slicenator", () => $0dec34349839a009$export$5b92d769f2f57509);

var $4NFCE = parcelRequire("4NFCE");

var $3PmNk = parcelRequire("3PmNk");
const $0dec34349839a009$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $4NFCE.range)(0, totalChunks).pipe((0, $3PmNk.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("iyZWI", function(module, exports) {

$parcel$export(module.exports, "hashinator", () => $946c6df5bbe7edda$export$d5f5a550a38ec367);

var $aN4rI = parcelRequire("aN4rI");
const $946c6df5bbe7edda$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $946c6df5bbe7edda$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $aN4rI.asyncMap)($946c6df5bbe7edda$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("aN4rI", function(module, exports) {

$parcel$export(module.exports, "fetchBlob", () => $6bb2bbe9f31d7b02$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $6bb2bbe9f31d7b02$export$707ee4c4c95d39e3);

var $7kixv = parcelRequire("7kixv");

var $eynBz = parcelRequire("eynBz");
async function $6bb2bbe9f31d7b02$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $6bb2bbe9f31d7b02$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $6bb2bbe9f31d7b02$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $7kixv.Observable)((sub)=>{
            notifiers.push($6bb2bbe9f31d7b02$var$notify(project(value), sub, onReady));
        });
};
const $6bb2bbe9f31d7b02$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $eynBz.mergeMap)($6bb2bbe9f31d7b02$var$mapper(project), concurrent);

});


parcelRegister("htAnC", function(module, exports) {

$parcel$export(module.exports, "uploadinator", () => $376f95738497d04c$export$94ce0f3fcf999415);

var $aN4rI = parcelRequire("aN4rI");
const $376f95738497d04c$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $aN4rI.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("h9RjH", function(module, exports) {

$parcel$export(module.exports, "processinator", () => $cfa6e3d7bb356500$export$2f21790600302ed);

var $aoje7 = parcelRequire("aoje7");

var $4pIMA = parcelRequire("4pIMA");
const $cfa6e3d7bb356500$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $aoje7.bufferCount)(options.batchSize)).pipe((0, $4pIMA.concatMap)(process));
};

});


parcelRegister("keN2a", function(module, exports) {

$parcel$export(module.exports, "createHasher", () => $a41e44f7241fbce8$export$14b114effbc08b6b);
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");
let $a41e44f7241fbce8$var$hasher = null;
let $a41e44f7241fbce8$var$sha256Hasher = null;
const $a41e44f7241fbce8$export$d9c9d11cd648a505 = ()=>{
    $a41e44f7241fbce8$var$hasher = null;
    $a41e44f7241fbce8$var$sha256Hasher = null;
};


const $a41e44f7241fbce8$export$14b114effbc08b6b = async (algorithm)=>{
    try {
        if (algorithm === (0, $9t1Mu.ChunkHashAlgorithm).Sha256) {
            if (!$a41e44f7241fbce8$var$sha256Hasher) {
                // TODO this needs to support worker sha256 hasher as well
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("aOfga"));
                $a41e44f7241fbce8$var$sha256Hasher = new SimpleHasher();
            }
            return $a41e44f7241fbce8$var$sha256Hasher;
        }
    } catch (error) {}
    const { SimpleHasher: SimpleHasher } = await (parcelRequire("63Grn"));
    $a41e44f7241fbce8$var$hasher = new SimpleHasher();
    return $a41e44f7241fbce8$var$hasher;
};

});
parcelRegister("aOfga", function(module, exports) {

let $7dea6927bc881dd1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7dea6927bc881dd1$var$load("kxQbf").then(()=>parcelRequire('g8wZ9'));

});

parcelRegister("63Grn", function(module, exports) {

let $4693f1ae0207df80$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4693f1ae0207df80$var$load("76n7a"),
    $4693f1ae0207df80$var$load("l253H"),
    $4693f1ae0207df80$var$load("6rET6")
]).then(()=>parcelRequire('cPCGi'));

});


parcelRegister("bpbRw", function(module, exports) {

$parcel$export(module.exports, "UploaderError", () => $85ab3781ae20a637$export$515240c3f059c807);

var $4rKJa = parcelRequire("4rKJa");
class $85ab3781ae20a637$export$515240c3f059c807 extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $85ab3781ae20a637$export$80ee180172bc336(err) {
    return err instanceof $85ab3781ae20a637$export$515240c3f059c807;
}

});

parcelRegister("jZL78", function(module, exports) {

$parcel$export(module.exports, "fileSizeError", () => $b71a6cbe9ec1a24a$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $b71a6cbe9ec1a24a$export$71f452e02035c1e2);

var $jmTJ7 = parcelRequire("jmTJ7");

var $6PCIn = parcelRequire("6PCIn");
const $b71a6cbe9ec1a24a$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $b71a6cbe9ec1a24a$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $6PCIn.MAX_UPLOAD_FILE_SIZE)) throw new Error($b71a6cbe9ec1a24a$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $jmTJ7.DATA_UNIT).GB) return 5 * (0, $jmTJ7.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $jmTJ7.DATA_UNIT).GB && fileSize <= 50 * (0, $jmTJ7.DATA_UNIT).GB) return 50 * (0, $jmTJ7.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $jmTJ7.DATA_UNIT).GB && fileSize <= 0.95 * (0, $jmTJ7.DATA_UNIT).TB) return 100 * (0, $jmTJ7.DATA_UNIT).MB;
    return 210 * (0, $jmTJ7.DATA_UNIT).MB;
};

});


parcelRegister("abkQS", function(module, exports) {

$parcel$export(module.exports, "getFileStreamsCache", () => $20fb1b7a81082f5e$export$f2f061938c1e6810);
class $20fb1b7a81082f5e$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $20fb1b7a81082f5e$var$streamCache;

const $20fb1b7a81082f5e$export$f2f061938c1e6810 = ()=>{
    if (!$20fb1b7a81082f5e$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("bLPxw")).mediaState;
        $20fb1b7a81082f5e$var$streamCache = new $20fb1b7a81082f5e$export$4293896e79732236(mediaState.streams);
    }
    return $20fb1b7a81082f5e$var$streamCache;
};

});

parcelRegister("lRBVi", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $175af825576b091d$export$68d003d3105952ad);
parcelRequire("1jG9B");
var $bLPxw = parcelRequire("bLPxw");
const $175af825576b091d$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $bLPxw.mediaState).eventEmitter) (0, $bLPxw.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $bLPxw.mediaState).eventEmitter) (0, $bLPxw.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $bLPxw.mediaState).eventEmitter) return (0, $bLPxw.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("hRxrn", function(module, exports) {

$parcel$export(module.exports, "createFileDataloader", () => $611f84914cb6f1a5$export$ae188fee39529b82);

var $79KwK = parcelRequire("79KwK");

var $3xaEP = parcelRequire("3xaEP");
const $611f84914cb6f1a5$export$b79d95ee17a87a = 100;
const $611f84914cb6f1a5$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $611f84914cb6f1a5$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $611f84914cb6f1a5$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $611f84914cb6f1a5$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $611f84914cb6f1a5$var$makeCacheKey(id, collection);
        if ($611f84914cb6f1a5$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($611f84914cb6f1a5$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $611f84914cb6f1a5$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};
function $611f84914cb6f1a5$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $3xaEP.getRandomTelemetryId)(),
                spanId: (0, $3xaEP.getRandomTelemetryId)()
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $611f84914cb6f1a5$export$71cd2e8f8162d47b(keys, items);
    };
}
function $611f84914cb6f1a5$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))($611f84914cb6f1a5$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $611f84914cb6f1a5$export$b79d95ee17a87a
    });
}

});

parcelRegister("atDjN", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $4c3ee7170cb316c1$export$ac3214931ffd82af);

var $5JVfG = parcelRequire("5JVfG");
const $4c3ee7170cb316c1$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $5JVfG.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("5JVfG", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $2a0d3eeca821ff8d$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("fK3MF")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("fK3MF")).isVideoMimeTypeSupportedByBrowser);

var $5hd6w = parcelRequire("5hd6w");

var $fK3MF = parcelRequire("fK3MF");

var $i9yw1 = parcelRequire("i9yw1");
const $2a0d3eeca821ff8d$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $5hd6w.isArchive)(mimeType)) return 'archive';
    if ((0, $fK3MF.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $fK3MF.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $fK3MF.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $fK3MF.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("5hd6w", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $d95d3f124d05d5e2$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $d95d3f124d05d5e2$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("fK3MF", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $14d0a1fe72c887af$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $14d0a1fe72c887af$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$55ca6cdaf6093034 = (mimeType)=>$14d0a1fe72c887af$export$74325e3c843a9555(mimeType) || $14d0a1fe72c887af$export$c021f2623a75015f(mimeType) || $14d0a1fe72c887af$export$ff36075ea755a717(mimeType) || $14d0a1fe72c887af$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("i9yw1", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $b92ae6a0fa1244e6$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$548d9148a80556a3 = (mimeType)=>$b92ae6a0fa1244e6$export$e9a065a80f76311e(mimeType) || $b92ae6a0fa1244e6$export$86baad7a89d908e9(mimeType) || $b92ae6a0fa1244e6$export$8cba23825d020bbb(mimeType) || $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3(mimeType) || $b92ae6a0fa1244e6$export$94e1479e01d2af53(mimeType);

});



parcelRegister("053B3", function(module, exports) {

$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $492d4a64b2b2425c$export$89097c0ec1e0dee1);

var $bbNl0 = parcelRequire("bbNl0");
const $492d4a64b2b2425c$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $bbNl0.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("iDYg8", function(module, exports) {

$parcel$export(module.exports, "convertBase64ToBlob", () => $87b4c423efa40e5c$export$ed17558b11b88056);
const $87b4c423efa40e5c$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("jFXx8", function(module, exports) {

$parcel$export(module.exports, "fromObservable", () => $a6ac257ab8a71611$export$4b2432e2d8723823);

var $jkEmk = parcelRequire("jkEmk");
function $a6ac257ab8a71611$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $a6ac257ab8a71611$export$8659d1f07d151381(item) {
    return $a6ac257ab8a71611$export$4b2432e2d8723823((0, $jkEmk.createMediaSubject)(item));
}

});
parcelRegister("jkEmk", function(module, exports) {

$parcel$export(module.exports, "createMediaSubject", () => $5f3a872941d2eff3$export$bc76d51553fa5e35);

var $86Sof = parcelRequire("86Sof");
function $5f3a872941d2eff3$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $86Sof.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("kFG4u", function(module, exports) {

$parcel$export(module.exports, "toPromise", () => $74eb9133065f0126$export$4dbaaf6c79705e6c);

var $2PBDa = parcelRequire("2PBDa");
const $74eb9133065f0126$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $2PBDa.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("ea8A0", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $2f9cb480159d13ae$export$71797c284d89a3e1);

var $hthqT = parcelRequire("hthqT");

var $gOskN = parcelRequire("gOskN");
const $2f9cb480159d13ae$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $hthqT.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $gOskN.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("hthqT", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $d7d48590d371ba3a$export$a1c3205f28a20414);
const $d7d48590d371ba3a$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("gOskN", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $4a8128b4320ca47f$export$62aabd5ff85d0451);
const $4a8128b4320ca47f$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("8UZz3", function(module, exports) {

$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $d7014b773fe3cff6$export$2ccdd6f9a9eba6a);

var $fK3MF = parcelRequire("fK3MF");
var $i9yw1 = parcelRequire("i9yw1");

var $gOskN = parcelRequire("gOskN");
async function $d7014b773fe3cff6$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $fK3MF.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $i9yw1.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $gOskN.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("393Zn", function(module, exports) {

$parcel$export(module.exports, "PollingFunction", () => $10b695ec33f62c2d$export$4c54d536f8e37dc2);

var $8iexj = parcelRequire("8iexj");
const $10b695ec33f62c2d$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $10b695ec33f62c2d$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$10b695ec33f62c2d$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $8iexj.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $8iexj.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("8iexj", function(module, exports) {

$parcel$export(module.exports, "PollingError", () => $76319a6a54892893$export$c3748c310e92340a);

var $4rKJa = parcelRequire("4rKJa");
class $76319a6a54892893$export$c3748c310e92340a extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $76319a6a54892893$export$541e3e52eea6fece(err) {
    return err instanceof $76319a6a54892893$export$c3748c310e92340a;
}

});


parcelRegister("iX2Cl", function(module, exports) {

$parcel$export(module.exports, "isEmptyFile", () => $0723e6aaf9777481$export$728192ce8dd94659);
const $0723e6aaf9777481$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $0723e6aaf9777481$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $0723e6aaf9777481$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("48hWz", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => (parcelRequire("1ZNSP")).mediaStore);

var $1ZNSP = parcelRequire("1ZNSP");

});
parcelRegister("1ZNSP", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => $8cb4e2ad5e722a42$export$5785580dea19518d);

var $7LOiC = parcelRequire("7LOiC");

var $1pZVO = parcelRequire("1pZVO");

var $96y8R = parcelRequire("96y8R");
const $8cb4e2ad5e722a42$var$mediaStoreWithoutDevtools = (0, $96y8R.createStore)()((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
        files: {}
    }))));
const $8cb4e2ad5e722a42$var$mediaStoreWithDevtools = (0, $96y8R.createStore)()((0, $7LOiC.devtools)((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
        files: {}
    })))));
const $8cb4e2ad5e722a42$export$5785580dea19518d = $8cb4e2ad5e722a42$var$mediaStoreWithoutDevtools;
const $8cb4e2ad5e722a42$export$503459913a0dc356 = (initialStore)=>{
    return (0, $96y8R.createStore)()((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("7LOiC", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $5a83f092dca5fc3e$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $5a83f092dca5fc3e$export$5c593627aef9f076);
var $5a83f092dca5fc3e$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $5a83f092dca5fc3e$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $5a83f092dca5fc3e$export$4feba8a1bc8e9afd = $5a83f092dca5fc3e$var$reduxImpl;
const $5a83f092dca5fc3e$var$trackedConnections = /* @__PURE__ */ new Map();
const $5a83f092dca5fc3e$var$getTrackedConnectionState = (name)=>{
    const api = $5a83f092dca5fc3e$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $5a83f092dca5fc3e$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $5a83f092dca5fc3e$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $5a83f092dca5fc3e$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $5a83f092dca5fc3e$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) {
            if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $5a83f092dca5fc3e$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$5a83f092dca5fc3e$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $5a83f092dca5fc3e$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $5a83f092dca5fc3e$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $5a83f092dca5fc3e$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $5a83f092dca5fc3e$export$6922d3b3a607469e = $5a83f092dca5fc3e$var$devtoolsImpl;
const $5a83f092dca5fc3e$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $5a83f092dca5fc3e$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $5a83f092dca5fc3e$export$5c593627aef9f076 = $5a83f092dca5fc3e$var$subscribeWithSelectorImpl;
const $5a83f092dca5fc3e$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $5a83f092dca5fc3e$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $5a83f092dca5fc3e$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $5a83f092dca5fc3e$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $5a83f092dca5fc3e$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $5a83f092dca5fc3e$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $5a83f092dca5fc3e$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $5a83f092dca5fc3e$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $5a83f092dca5fc3e$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $5a83f092dca5fc3e$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $5a83f092dca5fc3e$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $5a83f092dca5fc3e$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $5a83f092dca5fc3e$var$oldImpl(config, baseOptions);
    }
    return $5a83f092dca5fc3e$var$newImpl(config, baseOptions);
};
const $5a83f092dca5fc3e$export$9a6132153fba2e0 = $5a83f092dca5fc3e$var$persistImpl;

});

parcelRegister("1pZVO", function(module, exports) {

$parcel$export(module.exports, "immer", () => $10882a850d9663b5$export$428de7ec69ac95c);

var $K2rwM = parcelRequire("K2rwM");
const $10882a850d9663b5$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $K2rwM.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $10882a850d9663b5$export$428de7ec69ac95c = $10882a850d9663b5$var$immerImpl;

});
parcelRegister("K2rwM", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $08a6311ec7f77a2c$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $08a6311ec7f77a2c$export$2e2bcd8739ae039 = fn;

});


parcelRegister("96y8R", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $6a0f287ca3f709ed$export$f51a9068ac82ea43);
var $6a0f287ca3f709ed$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $6a0f287ca3f709ed$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($6a0f287ca3f709ed$import_meta.env ? $6a0f287ca3f709ed$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $6a0f287ca3f709ed$export$f51a9068ac82ea43 = (createState)=>createState ? $6a0f287ca3f709ed$var$createStoreImpl(createState) : $6a0f287ca3f709ed$var$createStoreImpl;
var $6a0f287ca3f709ed$export$2e2bcd8739ae039 = (createState)=>{
    if (($6a0f287ca3f709ed$import_meta.env ? $6a0f287ca3f709ed$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $6a0f287ca3f709ed$export$f51a9068ac82ea43(createState);
};

});



parcelRegister("bksvR", function(module, exports) {

$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $6bed172d1e1e47c4$export$57945b6819e39246);

var $79KwK = parcelRequire("79KwK");

var $3xaEP = parcelRequire("3xaEP");
const $6bed172d1e1e47c4$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $6bed172d1e1e47c4$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $3xaEP.getRandomTelemetryId)(),
                spanId: (0, $3xaEP.getRandomTelemetryId)()
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            return items.find((item)=>item.id === id && item.collection === collectionName)?.error;
        });
    };
}
function $6bed172d1e1e47c4$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))($6bed172d1e1e47c4$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $6bed172d1e1e47c4$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}

});


parcelRegister("gWavf", function(module, exports) {

$parcel$export(module.exports, "StargateClient", () => $60a1ef1a71feccaf$export$c66ca190f89caaac);
class $60a1ef1a71feccaf$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("c4FM0", function(module, exports) {

let $8ca6431068cfdd61$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8ca6431068cfdd61$var$load("lPk9Z").then(()=>parcelRequire('h77Xn'));

});





parcelRegister("iN7PZ", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $e54d3f9e11f733f6$export$4eaebdef02112fe4);

var $eJOHy = parcelRequire("eJOHy");

var $bbNl0 = parcelRequire("bbNl0");
var $4rKJa = parcelRequire("4rKJa");

var $kCvcX = parcelRequire("kCvcX");
var $djK7X = parcelRequire("djK7X");
var $3cc2J = parcelRequire("3cc2J");

var $fK3MF = parcelRequire("fK3MF");

var $eGOwo = parcelRequire("eGOwo");

var $7aoMz = parcelRequire("7aoMz");

var $e2t9t = parcelRequire("e2t9t");

var $33YQ1 = parcelRequire("33YQ1");

var $k9eRE = parcelRequire("k9eRE");
var $hNvWT = parcelRequire("hNvWT");
var $9Mg12 = parcelRequire("9Mg12");

var $i0gVY = parcelRequire("i0gVY");
var $8Dv9L = parcelRequire("8Dv9L");

var $3c1p9 = parcelRequire("3c1p9");
const $e54d3f9e11f733f6$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const [status, setStatus] = (0, $eJOHy.useState)('loading');
    const [error, setError] = (0, $eJOHy.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $eJOHy.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $eJOHy.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $eJOHy.useState)('not-resolved');
    const ssrReliabilityRef = (0, $eJOHy.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $7aoMz.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (isLoading && (0, $eGOwo.fg)('platform_close_image_blindspot_2')) return ufoContext?.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $eJOHy.useMemo)(()=>dimensions ? (0, $3c1p9.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $3c1p9.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $8Dv9L.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $k9eRE.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $e2t9t.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $eJOHy.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $djK7X.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $bbNl0.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $eJOHy.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('metadata-fetch', (0, $4rKJa.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $3c1p9.useCurrentValueRef)(()=>{
        return (0, $k9eRE.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $eJOHy.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $3c1p9.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $3c1p9.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $eJOHy.useEffect)(()=>{
        const cachedPreview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $3c1p9.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $hNvWT.isSupportedLocalPreview)(mediaType) && (0, $fK3MF.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $k9eRE.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview || (0, $3c1p9.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $k9eRE.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, $33YQ1.ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $eJOHy.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $k9eRE.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $k9eRE.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $k9eRE.isLocalPreview)(failedPreview);
        const isRemote = (0, $k9eRE.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $33YQ1.ImageLoadError)(failedPreview?.source);
            (0, $9Mg12.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $eJOHy.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $k9eRE.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $k9eRE.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $i0gVY.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $kCvcX.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("kCvcX", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $556b9eb703c9e12d$export$46fd859414de9d62);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $3cc2J = parcelRequire("3cc2J");

var $bMoFA = parcelRequire("bMoFA");

var $b7hyt = parcelRequire("b7hyt");
function $556b9eb703c9e12d$var$useCurrentValueRef(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}
const $556b9eb703c9e12d$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const innerRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const registerCopyIntentRef = $556b9eb703c9e12d$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $bMoFA.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $bMoFA.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $eJOHy.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $eJOHy.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) (0, $b7hyt.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $b7hyt.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("3cc2J", function(module, exports) {

$parcel$export(module.exports, "useMediaClient", () => $d8e7b96ea4671e74$export$8b3e87ea56c3a345);

var $eJOHy = parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");

var $f7iZ0 = parcelRequire("f7iZ0");
const $d8e7b96ea4671e74$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $93R6D.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $f7iZ0.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("f7iZ0", function(module, exports) {

$parcel$export(module.exports, "MediaContext", () => $b977b15c2bc7301b$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $b977b15c2bc7301b$export$57164260bc1f1218);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");

var $lMkQs = parcelRequire("lMkQs");
const $b977b15c2bc7301b$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $b977b15c2bc7301b$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $lMkQs.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b977b15c2bc7301b$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};

});
parcelRegister("lMkQs", function(module, exports) {

$parcel$export(module.exports, "useMediaParsedSettings", () => $e0ef7db6f81da61d$export$d54af28440a5efc0);

var $eJOHy = parcelRequire("eJOHy");

var $4iDQM = parcelRequire("4iDQM");
const $e0ef7db6f81da61d$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $eJOHy.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $4iDQM.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("4iDQM", function(module, exports) {

$parcel$export(module.exports, "defaultMediaUserPreferences", () => $fd3af50559080092$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $fd3af50559080092$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $fd3af50559080092$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($fd3af50559080092$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $fd3af50559080092$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $fd3af50559080092$export$2d23ed2854ac1650 = $fd3af50559080092$export$7e209e67b965bc63($fd3af50559080092$var$defaultUserPreferences);

});




parcelRegister("bMoFA", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $93f079c5c30deecd$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $93f079c5c30deecd$export$aacb463551da2e8f);

var $h3W10 = parcelRequire("h3W10");
const $93f079c5c30deecd$var$getRequestErrorDetails = (err)=>{
    if ((0, $h3W10.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $93f079c5c30deecd$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $h3W10.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$93f079c5c30deecd$var$getRequestErrorDetails(error)
        }
    };
};
const $93f079c5c30deecd$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("b7hyt", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $b67882b47b14e094$export$f65ca476c09acec0);
const $b67882b47b14e094$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("djK7X", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $5a07b53d359ee7c3$export$90ff537b0999afb);

var $eJOHy = parcelRequire("eJOHy");

var $3cc2J = parcelRequire("3cc2J");

var $kNd6B = parcelRequire("kNd6B");
function $5a07b53d359ee7c3$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const fileState = (0, $kNd6B.useMediaStore)((state)=>state.files[id]);
    (0, $eJOHy.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("kNd6B", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $d5b1e147a2796345$export$8a9cc8c330400af8);

var $eOVQp = parcelRequire("eOVQp");

var $3cc2J = parcelRequire("3cc2J");
const $d5b1e147a2796345$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $eOVQp.useStore)(store, selector, equals);
function $d5b1e147a2796345$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $d5b1e147a2796345$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("eOVQp", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $aca29ade4cd157ce$export$6ccbb43953eebf8);

var $96y8R = parcelRequire("96y8R");

var $eJOHy = parcelRequire("eJOHy");

var $iHcr1 = parcelRequire("iHcr1");
var $aca29ade4cd157ce$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $aca29ade4cd157ce$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)));
const { useSyncExternalStoreWithSelector: $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($iHcr1)));
let $aca29ade4cd157ce$var$didWarnAboutEqualityFn = false;
const $aca29ade4cd157ce$var$identity = (arg)=>arg;
function $aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector = $aca29ade4cd157ce$var$identity, equalityFn) {
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$aca29ade4cd157ce$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $aca29ade4cd157ce$var$didWarnAboutEqualityFn = true;
    }
    const slice = $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $aca29ade4cd157ce$var$useDebugValue(slice);
    return slice;
}
const $aca29ade4cd157ce$var$createImpl = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $96y8R.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $aca29ade4cd157ce$export$185802fd694ee1f5 = (createState)=>createState ? $aca29ade4cd157ce$var$createImpl(createState) : $aca29ade4cd157ce$var$createImpl;
var $aca29ade4cd157ce$export$2e2bcd8739ae039 = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $aca29ade4cd157ce$export$185802fd694ee1f5(createState);
};

});



parcelRegister("e2t9t", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $3f058c26ca766723$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $3f058c26ca766723$export$768c370ed0dbaeb3);

var $4rKJa = parcelRequire("4rKJa");

var $33YQ1 = parcelRequire("33YQ1");
const $3f058c26ca766723$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $3f058c26ca766723$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $3f058c26ca766723$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $3f058c26ca766723$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $3f058c26ca766723$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $3f058c26ca766723$export$4af9d71992e89714(error),
        error: $3f058c26ca766723$export$88c61dcad53762da(error),
        errorDetail: $3f058c26ca766723$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $3f058c26ca766723$export$29aa614726672b2e(error)
    };
};
const $3f058c26ca766723$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$3f058c26ca766723$export$74aaf4784c2edb2c(new (0, $33YQ1.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("33YQ1", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $ba556c1ff2a47bc7$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $ba556c1ff2a47bc7$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $ba556c1ff2a47bc7$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $ba556c1ff2a47bc7$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $ba556c1ff2a47bc7$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $ba556c1ff2a47bc7$export$7156ce7b78b49bd7);
class $ba556c1ff2a47bc7$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $ba556c1ff2a47bc7$export$2c035820a31723e extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$10ab445310d30114 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$18e89b7e50818288 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $ba556c1ff2a47bc7$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $ba556c1ff2a47bc7$export$d0a45ab59b4606b extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(source){
        super($ba556c1ff2a47bc7$var$getImageLoadPrimaryReason(source));
    }
}
function $ba556c1ff2a47bc7$export$553696a6e769784c(err) {
    return err instanceof $ba556c1ff2a47bc7$export$96e559194c287cf4;
}
const $ba556c1ff2a47bc7$export$b380593ba3516c6f = (err)=>err instanceof $ba556c1ff2a47bc7$export$2c035820a31723e;
const $ba556c1ff2a47bc7$export$e1d87830b3784f94 = (err)=>err instanceof $ba556c1ff2a47bc7$export$10ab445310d30114;
const $ba556c1ff2a47bc7$export$443aeb298d35d79d = (err)=>$ba556c1ff2a47bc7$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $ba556c1ff2a47bc7$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($ba556c1ff2a47bc7$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("k9eRE", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $acdcd6198e7dee1d$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $acdcd6198e7dee1d$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $acdcd6198e7dee1d$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $acdcd6198e7dee1d$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $acdcd6198e7dee1d$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $acdcd6198e7dee1d$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $acdcd6198e7dee1d$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $acdcd6198e7dee1d$export$98e935d981c884d);

var $bajro = parcelRequire("bajro");

var $33YQ1 = parcelRequire("33YQ1");

var $9Mg12 = parcelRequire("9Mg12");

var $hNvWT = parcelRequire("hNvWT");
const $acdcd6198e7dee1d$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $9Mg12.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $acdcd6198e7dee1d$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $33YQ1.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $acdcd6198e7dee1d$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $acdcd6198e7dee1d$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $acdcd6198e7dee1d$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $hNvWT.getRemotePreview)(mediaClient, id, params, traceContext);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $acdcd6198e7dee1d$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $hNvWT.getLocalPreview)(filePreview);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("bajro", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $dd0a5c69b434a5a7$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $dd0a5c69b434a5a7$export$e51a8146182600b8);
const $dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $dd0a5c69b434a5a7$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $dd0a5c69b434a5a7$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $dd0a5c69b434a5a7$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'collection'),
        alt: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'alt'),
        height: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'height'),
        width: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'width'),
        size: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'size'),
        name: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'name'),
        mimeType: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'mimeType')
    };
};
const $dd0a5c69b434a5a7$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $dd0a5c69b434a5a7$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $dd0a5c69b434a5a7$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("9Mg12", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $d9909271b08294f2$export$b7e8ee3f7a41459);

var $4ZQua = parcelRequire("4ZQua");
const $d9909271b08294f2$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $d9909271b08294f2$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $d9909271b08294f2$export$b7e8ee3f7a41459 = new $d9909271b08294f2$export$7b50526c091bb915((0, $4ZQua.createObjectURLCache)());

});
parcelRegister("4ZQua", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $7640c7504dcb2ad6$export$ba71be67d5c32535);

var $adK77 = parcelRequire("adK77");

var $7xkt0 = parcelRequire("7xkt0");
const $7640c7504dcb2ad6$export$36d0f9859761643d = 50;
class $7640c7504dcb2ad6$var$ExtendedLRUCache extends (0, $7xkt0.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $adK77.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $7640c7504dcb2ad6$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $7640c7504dcb2ad6$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $7640c7504dcb2ad6$export$ba71be67d5c32535 = ()=>new $7640c7504dcb2ad6$export$75d1c8c9ba1d0773($7640c7504dcb2ad6$export$36d0f9859761643d);

});


parcelRegister("hNvWT", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3247cef0fce3851d$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3247cef0fce3851d$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3247cef0fce3851d$export$bfe20bd01db02b3);

var $5JVfG = parcelRequire("5JVfG");

var $cK5G4 = parcelRequire("cK5G4");

var $33YQ1 = parcelRequire("33YQ1");

var $heXDA = parcelRequire("heXDA");
const $3247cef0fce3851d$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3247cef0fce3851d$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $cK5G4.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $heXDA.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $5JVfG.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3247cef0fce3851d$var$getImageLocalPreview(value);
            case 'video':
                return $3247cef0fce3851d$var$getVideoLocalPreview(value);
            default:
                throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
};
const $3247cef0fce3851d$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $33YQ1.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("cK5G4", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $4622caaad73ce041$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $4622caaad73ce041$export$67689507e8404821);

var $9PgO0 = parcelRequire("9PgO0");

var $f8uqC = parcelRequire("f8uqC");

var $fOXQV = parcelRequire("fOXQV");

var $kHzU5 = parcelRequire("kHzU5");
const { Orientation: $4622caaad73ce041$var$Orientation, XResolution: $4622caaad73ce041$var$XResolution } = (0, $9PgO0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $4622caaad73ce041$var$DPI_WEB_BASELINE = 72;
async function $4622caaad73ce041$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $4622caaad73ce041$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $4622caaad73ce041$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $4622caaad73ce041$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
        else return $4622caaad73ce041$export$268f92356524130b(tags, $4622caaad73ce041$var$XResolution, $4622caaad73ce041$var$DPI_WEB_BASELINE) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $4622caaad73ce041$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$4622caaad73ce041$var$Orientation]) {
        const tagValue = tags[$4622caaad73ce041$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $9PgO0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $4622caaad73ce041$export$67689507e8404821(file) {
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    return $4622caaad73ce041$var$getOrientationFromTags(tags);
}
function $4622caaad73ce041$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $4622caaad73ce041$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $fOXQV.loadImage)(src);
        const { width: width, height: height } = (0, $fOXQV.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("9PgO0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $c8d64cb551bef33f$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $c8d64cb551bef33f$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $c8d64cb551bef33f$export$f6ea0c89fd7d156);
var $c8d64cb551bef33f$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $c8d64cb551bef33f$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $c8d64cb551bef33f$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("f8uqC", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $80e2aeeb99751964$export$41982b5c7acb23c4);

var $9PgO0 = parcelRequire("9PgO0");

var $dCEVY = parcelRequire("dCEVY");

var $7BlyC = parcelRequire("7BlyC");

var $3yAnp = parcelRequire("3yAnp");
async function $80e2aeeb99751964$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $9PgO0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $7BlyC.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $3yAnp.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $9PgO0.ImageType).JPEG) return await (0, $dCEVY.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("dCEVY", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $ff103de7f6ab6f18$export$556b2ccec62d7f2a);

var $9PgO0 = parcelRequire("9PgO0");
const { XResolution: $ff103de7f6ab6f18$var$XResolution, YResolution: $ff103de7f6ab6f18$var$YResolution } = (0, $9PgO0.SupportedImageMetaTag);
let $ff103de7f6ab6f18$var$loadImage;

function $ff103de7f6ab6f18$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$ff103de7f6ab6f18$var$loadImage) {
            const module = await (parcelRequire("9JMwr"));
            $ff103de7f6ab6f18$var$loadImage = module.default || module;
        }
        $ff103de7f6ab6f18$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $ff103de7f6ab6f18$var$XResolution || key === $ff103de7f6ab6f18$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("9JMwr", function(module, exports) {

let $716df486413b4273$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $716df486413b4273$var$load("2HU4O").then(()=>parcelRequire('4Mu1O'));

});


parcelRegister("7BlyC", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $e9cd4ca7c89b16ee$export$5fb37736440fca6f);

var $fOXQV = parcelRequire("fOXQV");
let $e9cd4ca7c89b16ee$var$pngChunksExtract;

async function $e9cd4ca7c89b16ee$export$5fb37736440fca6f(file) {
    if (!$e9cd4ca7c89b16ee$var$pngChunksExtract) {
        const module = await (parcelRequire("dopkG"));
        $e9cd4ca7c89b16ee$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $fOXQV.fileToArrayBuffer)(file);
    const chunks = $e9cd4ca7c89b16ee$var$pngChunksExtract(buffer);
    return await $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks);
}
async function $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("fOXQV", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $cb7adf01e70d1e12$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $cb7adf01e70d1e12$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $cb7adf01e70d1e12$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $cb7adf01e70d1e12$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $cb7adf01e70d1e12$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $cb7adf01e70d1e12$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $cb7adf01e70d1e12$export$61a1de0822e2820);

var $6OBnQ = parcelRequire("6OBnQ");

var $2Pj0H = parcelRequire("2Pj0H");

var $jb8ZN = parcelRequire("jb8ZN");

var $4w1Xx = parcelRequire("4w1Xx");

var $heBKY = parcelRequire("heBKY");

var $jP9Cl = parcelRequire("jP9Cl");

var $gAsmN = parcelRequire("gAsmN");

var $iqmbF = parcelRequire("iqmbF");

var $hLw8T = parcelRequire("hLw8T");

var $jpYYq = parcelRequire("jpYYq");

var $4SXVP = parcelRequire("4SXVP");

var $91IX3 = parcelRequire("91IX3");

var $i9oSq = parcelRequire("i9oSq");

var $1TONM = parcelRequire("1TONM");

var $3LgN4 = parcelRequire("3LgN4");

var $jmdLl = parcelRequire("jmdLl");
function $cb7adf01e70d1e12$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $cb7adf01e70d1e12$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $cb7adf01e70d1e12$export$849633012686f7ee(file)
    };
}
async function $cb7adf01e70d1e12$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $cb7adf01e70d1e12$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $cb7adf01e70d1e12$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $cb7adf01e70d1e12$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $cb7adf01e70d1e12$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $cb7adf01e70d1e12$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $cb7adf01e70d1e12$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6OBnQ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SXVP)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jpYYq)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iqmbF)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4w1Xx)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jb8ZN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Pj0H)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($91IX3)))
    }
];
function $cb7adf01e70d1e12$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $cb7adf01e70d1e12$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $jmdLl.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3LgN4)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($heBKY)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jP9Cl)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gAsmN)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("6OBnQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $4f6469314c3d6ff1$var$_react = $4f6469314c3d6ff1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $4f6469314c3d6ff1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6469314c3d6ff1$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $4f6469314c3d6ff1$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$4f6469314c3d6ff1$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $4f6469314c3d6ff1$var$_default = module.exports.default = $4f6469314c3d6ff1$var$PdfDocument24Icon;

});

parcelRegister("2Pj0H", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $20ef173efcc507e4$var$_react = $20ef173efcc507e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $20ef173efcc507e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $20ef173efcc507e4$var$Gif24Icon = (props)=>/*#__PURE__*/ $20ef173efcc507e4$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$20ef173efcc507e4$var$Gif24Icon.displayName = 'Gif24Icon';
var $20ef173efcc507e4$var$_default = module.exports.default = $20ef173efcc507e4$var$Gif24Icon;

});

parcelRegister("jb8ZN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $df6605c69004c362$var$_react = $df6605c69004c362$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $df6605c69004c362$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $df6605c69004c362$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $df6605c69004c362$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$df6605c69004c362$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $df6605c69004c362$var$_default = module.exports.default = $df6605c69004c362$var$PowerpointPresentation24Icon;

});

parcelRegister("4w1Xx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $349babaa4a8a09e8$var$_react = $349babaa4a8a09e8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $349babaa4a8a09e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $349babaa4a8a09e8$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $349babaa4a8a09e8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$349babaa4a8a09e8$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $349babaa4a8a09e8$var$_default = module.exports.default = $349babaa4a8a09e8$var$WordDocument24Icon;

});

parcelRegister("heBKY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c8c1082e5cae77c8$var$_react = $c8c1082e5cae77c8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $c8c1082e5cae77c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c8c1082e5cae77c8$var$Sketch24Icon = (props)=>/*#__PURE__*/ $c8c1082e5cae77c8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c8c1082e5cae77c8$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $c8c1082e5cae77c8$var$_default = module.exports.default = $c8c1082e5cae77c8$var$Sketch24Icon;

});

parcelRegister("jP9Cl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6ea3d8b8f4b0c1d$var$_react = $e6ea3d8b8f4b0c1d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $e6ea3d8b8f4b0c1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6ea3d8b8f4b0c1d$var$Figma24Icon = (props)=>/*#__PURE__*/ $e6ea3d8b8f4b0c1d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e6ea3d8b8f4b0c1d$var$Figma24Icon.displayName = 'Figma24Icon';
var $e6ea3d8b8f4b0c1d$var$_default = module.exports.default = $e6ea3d8b8f4b0c1d$var$Figma24Icon;

});

parcelRegister("gAsmN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c1360329a45292df$var$_react = $c1360329a45292df$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $c1360329a45292df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1360329a45292df$var$Executable24Icon = (props)=>/*#__PURE__*/ $c1360329a45292df$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c1360329a45292df$var$Executable24Icon.displayName = 'Executable24Icon';
var $c1360329a45292df$var$_default = module.exports.default = $c1360329a45292df$var$Executable24Icon;

});

parcelRegister("iqmbF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d69bdda0af90a430$var$_react = $d69bdda0af90a430$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $d69bdda0af90a430$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d69bdda0af90a430$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d69bdda0af90a430$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d69bdda0af90a430$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d69bdda0af90a430$var$_default = module.exports.default = $d69bdda0af90a430$var$GoogleDoc24Icon;

});

parcelRegister("hLw8T", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ceefc245c72865b3$var$_react = $ceefc245c72865b3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $ceefc245c72865b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ceefc245c72865b3$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $ceefc245c72865b3$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ceefc245c72865b3$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $ceefc245c72865b3$var$_default = module.exports.default = $ceefc245c72865b3$var$GoogleForm24Icon;

});

parcelRegister("jpYYq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e22fa632d0a47674$var$_react = $e22fa632d0a47674$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $e22fa632d0a47674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e22fa632d0a47674$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $e22fa632d0a47674$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e22fa632d0a47674$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $e22fa632d0a47674$var$_default = module.exports.default = $e22fa632d0a47674$var$GoogleSheet24Icon;

});

parcelRegister("4SXVP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $38eab1c43401fe51$var$_react = $38eab1c43401fe51$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $38eab1c43401fe51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $38eab1c43401fe51$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $38eab1c43401fe51$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$38eab1c43401fe51$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $38eab1c43401fe51$var$_default = module.exports.default = $38eab1c43401fe51$var$GoogleSlide24Icon;

});

parcelRegister("91IX3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $69271380a604c514$var$_react = $69271380a604c514$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $69271380a604c514$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $69271380a604c514$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $69271380a604c514$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$69271380a604c514$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $69271380a604c514$var$_default = module.exports.default = $69271380a604c514$var$ExcelSpreadsheet24Icon;

});

parcelRegister("i9oSq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36c5d4aab250180$var$_react = $d36c5d4aab250180$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $d36c5d4aab250180$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36c5d4aab250180$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d36c5d4aab250180$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36c5d4aab250180$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d36c5d4aab250180$var$_default = module.exports.default = $d36c5d4aab250180$var$Spreadsheet24Icon;

});

parcelRegister("1TONM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $162255ae7d5921b9$var$_react = $162255ae7d5921b9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $162255ae7d5921b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $162255ae7d5921b9$var$Presentation24Icon = (props)=>/*#__PURE__*/ $162255ae7d5921b9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$162255ae7d5921b9$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $162255ae7d5921b9$var$_default = module.exports.default = $162255ae7d5921b9$var$Presentation24Icon;

});

parcelRegister("3LgN4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2bd2c91c79a3039e$var$_react = $2bd2c91c79a3039e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $2bd2c91c79a3039e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bd2c91c79a3039e$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2bd2c91c79a3039e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2bd2c91c79a3039e$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2bd2c91c79a3039e$var$_default = module.exports.default = $2bd2c91c79a3039e$var$SourceCode24Icon;

});

parcelRegister("jmdLl", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $d6ba8b104df87d35$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $d6ba8b104df87d35$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $d6ba8b104df87d35$export$ba4368c844580f9e);
function $d6ba8b104df87d35$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $d6ba8b104df87d35$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $d6ba8b104df87d35$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $d6ba8b104df87d35$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $d6ba8b104df87d35$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("dopkG", function(module, exports) {

let $9c012ac78e0c2259$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9c012ac78e0c2259$var$load("fWdHm").then(()=>parcelRequire('6TwJU'));

});


parcelRegister("3yAnp", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $a54c683875c3acaa$export$55c3bc9841b19de2);
function $a54c683875c3acaa$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("kHzU5", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $d080920ecf648ea4$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $d080920ecf648ea4$export$43142f95b8de7a91);
const $d080920ecf648ea4$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $d080920ecf648ea4$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $d080920ecf648ea4$export$43142f95b8de7a91 = (orientation)=>{
    return $d080920ecf648ea4$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("heXDA", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $e7f813388d1815ac$export$4269d30173168e5c);
const $e7f813388d1815ac$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("i0gVY", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $c6ffe105f3de4b84$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $c6ffe105f3de4b84$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $c6ffe105f3de4b84$export$de7c49925e44d75d);

var $itX9h = parcelRequire("itX9h");
const $c6ffe105f3de4b84$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $c6ffe105f3de4b84$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $c6ffe105f3de4b84$var$dashed = (param)=>param ? `-${param}` : '';
const $c6ffe105f3de4b84$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$c6ffe105f3de4b84$var$dashed(collectionName)}${$c6ffe105f3de4b84$var$dashed(occurrenceKey)}`;
const $c6ffe105f3de4b84$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $c6ffe105f3de4b84$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $itX9h.printFunctionCall)($c6ffe105f3de4b84$export$4310981e0aa4ce67, $c6ffe105f3de4b84$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $itX9h.printScript)([
        $c6ffe105f3de4b84$export$ede93d4564eaa8da.toString(),
        $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $c6ffe105f3de4b84$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $c6ffe105f3de4b84$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("itX9h", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $58d2f85efd2afaca$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $58d2f85efd2afaca$export$8b902fb69a2f17c1);
const $58d2f85efd2afaca$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $58d2f85efd2afaca$var$printParams = (args)=>args.map((arg)=>$58d2f85efd2afaca$var$printParam(arg)).join(',');
const $58d2f85efd2afaca$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$58d2f85efd2afaca$var$printParams(args)});`;
const $58d2f85efd2afaca$export$8b902fb69a2f17c1 = (statements)=>`(function(){
 			 ${statements.join(';')}
  			document.currentScript.remove();
		})();
		`;

});


parcelRegister("8Dv9L", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $2f30a37781c6f0c3$export$d3a890b0f7844b6f);

var $i0gVY = parcelRequire("i0gVY");
const $2f30a37781c6f0c3$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $i0gVY.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $i0gVY.getKey)(identifier)];
};

});

parcelRegister("3c1p9", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $f93a7743871712e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $f93a7743871712e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $f93a7743871712e9$export$b3e10e1f0fbb71db);

var $eJOHy = parcelRequire("eJOHy");
const $f93a7743871712e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $f93a7743871712e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $f93a7743871712e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $f93a7743871712e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $f93a7743871712e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}

});





parcelRegister("9k1hF", function(module, exports) {

$parcel$export(module.exports, "default", () => $63f607b72739cf2b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $63f607b72739cf2b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showLess: {
        "id": "issue-table.common.fields.cmdb-object.show-less",
        "defaultMessage": "\u2026 Show less"
    },
    showMore: {
        "id": "issue-table.common.fields.cmdb-object.show-more",
        "defaultMessage": "\u2026 ({numberOfObjects, plural, one {# more} other {# more}})"
    },
    none: {
        "id": "issue-table.common.fields.cmdb-object.none",
        "defaultMessage": "None"
    }
});

});

parcelRegister("bAy3a", function(module, exports) {

$parcel$export(module.exports, "filterEnrichedObjects", () => $2bf42d9b22bfa633$export$91f05c2342ca3f05);
$parcel$export(module.exports, "sortCmdbObjects", () => $2bf42d9b22bfa633$export$51618eba19894675);
const $2bf42d9b22bfa633$var$baseKeys = [
    'id',
    'workspaceId',
    'objectId',
    'objectKey',
    'label',
    'avatar',
    'objectType',
    'links',
    'attributes'
];
const $2bf42d9b22bfa633$export$91f05c2342ca3f05 = (values)=>{
    const isEnrichedObject = (value)=>{
        const keys = Object.keys(value);
        return $2bf42d9b22bfa633$var$baseKeys.every((key)=>keys.includes(key));
    };
    return values.filter(isEnrichedObject);
};
const $2bf42d9b22bfa633$export$51618eba19894675 = (unsortedObjects)=>unsortedObjects.sort((objectOne, objectTwo)=>{
        if (objectOne.label.toLowerCase() < objectTwo.label.toLowerCase()) return -1;
        if (objectOne.label.toLowerCase() > objectTwo.label.toLowerCase()) return 1;
        return 0;
    });

});


parcelRegister("eQ9Cm", function(module, exports) {

$parcel$export(module.exports, "default", () => $66ffd7c1b61737d3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $66ffd7c1b61737d3$export$2e2bcd8739ae039(props) {
    const { dataSelectorProps: { value: { displayName: displayName } } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, displayName);
}

});

parcelRegister("bsplE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f58cc7f27826a00$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7qGN1 = parcelRequire("7qGN1");
function $5f58cc7f27826a00$export$2e2bcd8739ae039(props) {
    const { dataSelectorProps: { value: value } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5f58cc7f27826a00$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7qGN1.FormattedDate), {
        value: value,
        year: "numeric",
        month: "short",
        day: "numeric"
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f58cc7f27826a00$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qu2gc _u5f3idpf _n3tdu2gc _19bvu2gc _1i4q1hna",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6hnhp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f9a8d976c8bf5db$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2mbDv = parcelRequire("2mbDv");

var $SB9Jx = parcelRequire("SB9Jx");

var $7gc68 = parcelRequire("7gc68");
const $9f9a8d976c8bf5db$var$Entitlement = ({ dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } })=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mbDv.ReadView), {
        name: (0, $SB9Jx.getNameFromFieldData)(value)
    })) : null;
var $9f9a8d976c8bf5db$export$2e2bcd8739ae039 = $9f9a8d976c8bf5db$var$Entitlement;

});
parcelRegister("2mbDv", function(module, exports) {

$parcel$export(module.exports, "ReadView", () => $1b1ac709712368b1$export$a4b5824ec1e018e1);

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $c2Sgp = parcelRequire("c2Sgp");

var $7jTnu = parcelRequire("7jTnu");

var $g64ll = parcelRequire("g64ll");
const $1b1ac709712368b1$export$a4b5824ec1e018e1 = ({ name: name })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: (0, $7jTnu.fg)('jcs-issue-view-truncate-reporter') ? [
            $1b1ac709712368b1$var$inlineStyles,
            !name && $1b1ac709712368b1$var$placeholderStyles
        ] : [
            $1b1ac709712368b1$var$containerStyles,
            !name && $1b1ac709712368b1$var$placeholderStyles,
            $1b1ac709712368b1$var$overflowStyles,
            $1b1ac709712368b1$var$alignmentFixStyles
        ],
        testId: "servicedesk-customer-service-entitlements-field.common.ui.read-view.inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c2Sgp.LabelIcon), {
        size: "xsmall",
        type: "PRODUCT"
    }), name || formatMessage((0, $g64ll.default).entitlementFieldPlaceholder));
};
const $1b1ac709712368b1$var$containerStyles = (0, $1DXK0.xcss)({
    margin: 'space.050'
});
const $1b1ac709712368b1$var$placeholderStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest'
});
const $1b1ac709712368b1$var$overflowStyles = (0, $1DXK0.xcss)({
    overflowWrap: 'anywhere'
});
const $1b1ac709712368b1$var$alignmentFixStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.100'
});
const $1b1ac709712368b1$var$inlineStyles = (0, $1DXK0.xcss)({
    margin: 'space.050',
    overflowWrap: 'anywhere',
    paddingLeft: 'space.050'
});

});
parcelRegister("c2Sgp", function(module, exports) {

$parcel$export(module.exports, "LabelIcon", () => $8e0a4930fab8c8ac$export$6722f2abd5aa752a);

var $eJOHy = parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $9hb7e = parcelRequire("9hb7e");

var $fYw7A = parcelRequire("fYw7A");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");
const $8e0a4930fab8c8ac$export$6722f2abd5aa752a = ({ size: size, type: type, label: label = '', testId: testId, ...etc })=>{
    const Icon = type === 'ORGANIZATION' ? (0, (/*@__PURE__*/$parcel$interopDefault($9hb7e))) : (0, (/*@__PURE__*/$parcel$interopDefault($fYw7A)));
    const iconSize = size === 'large' ? 'large' : 'small';
    const isLarge = size === 'large';
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $8e0a4930fab8c8ac$var$containerStyles,
            size === 'small' && $8e0a4930fab8c8ac$var$smallStyles,
            size === 'xsmall' && $8e0a4930fab8c8ac$var$xsmallStyles
        ],
        testId: testId
    }, isLarge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1WryD.default), {
        icon: Icon,
        appearance: "gray",
        shape: "square",
        size: "40",
        label: label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        color: "var(--ds-icon, #44546F)",
        label: label,
        ...etc
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $8e0a4930fab8c8ac$var$containerStyles,
            size === 'large' && $8e0a4930fab8c8ac$var$largeStyles,
            size === 'small' && $8e0a4930fab8c8ac$var$smallStyles,
            size === 'xsmall' && $8e0a4930fab8c8ac$var$xsmallStyles
        ],
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        LEGACY_size: iconSize,
        label: label,
        ...etc
    }));
};
const $8e0a4930fab8c8ac$var$containerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    backgroundColor: 'color.background.neutral'
});
const $8e0a4930fab8c8ac$var$largeStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius.200',
    padding: 'space.050'
});
const $8e0a4930fab8c8ac$var$smallStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius.050',
    padding: 'space.050'
});
const $8e0a4930fab8c8ac$var$xsmallStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius.050',
    padding: 'space.025'
});

});
parcelRegister("1WryD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5a874af77e003e$export$2e2bcd8739ae039);
/* icon-tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
const $6d5a874af77e003e$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $6d5a874af77e003e$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $6d5a874af77e003e$var$shapeMap = {
    square: "_2rkoiti9",
    circle: "_2rko14q2"
};
const $6d5a874af77e003e$var$iconTileStyles = null;
function $6d5a874af77e003e$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $eGOwo.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $6d5a874af77e003e$var$appearanceMap[appearance],
            $6d5a874af77e003e$var$sizeMap[size],
            $6d5a874af77e003e$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});

parcelRegister("9hb7e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c9411407c1f042ec99fb06f89567549>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c0e52f169dc52c1$var$_react = $6c0e52f169dc52c1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6c0e52f169dc52c1$var$_officeBuilding = $6c0e52f169dc52c1$var$_interopRequireDefault((parcelRequire("jPgjO")));

var $6c0e52f169dc52c1$var$_officeBuildingFilled = $6c0e52f169dc52c1$var$_interopRequireDefault((parcelRequire("bjFeZ")));
function $6c0e52f169dc52c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for OfficeBuildingIcon.
 * This component is OfficeBuildingIcon, with `UNSAFE_fallbackIcon` set to "OfficeBuildingFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c0e52f169dc52c1$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $6c0e52f169dc52c1$var$_react.default.createElement($6c0e52f169dc52c1$var$_officeBuilding.default, Object.assign({
        LEGACY_fallbackIcon: $6c0e52f169dc52c1$var$_officeBuildingFilled.default
    }, props));
$6c0e52f169dc52c1$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
var $6c0e52f169dc52c1$var$_default = module.exports.default = $6c0e52f169dc52c1$var$OfficeBuildingIcon;

});
parcelRegister("jPgjO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfe75e26330f86b48e811f0d520fc5e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6ef7042ada3add3$var$_react = $e6ef7042ada3add3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e6ef7042ada3add3$var$_baseNew = $e6ef7042ada3add3$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e6ef7042ada3add3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6ef7042ada3add3$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $e6ef7042ada3add3$var$_react.default.createElement($e6ef7042ada3add3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$e6ef7042ada3add3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $e6ef7042ada3add3$var$_default = module.exports.default = $e6ef7042ada3add3$var$OfficeBuildingIcon;

});

parcelRegister("bjFeZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83d1759e81e2efbc$var$_react = $83d1759e81e2efbc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $83d1759e81e2efbc$var$_officeBuilding = $83d1759e81e2efbc$var$_interopRequireDefault((parcelRequire("jPgjO")));
function $83d1759e81e2efbc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $83d1759e81e2efbc$var$OfficeBuildingFilledIcon = (props)=>/*#__PURE__*/ $83d1759e81e2efbc$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8z"/><path fill="inherit" d="M6 10h2v2H6zm0 3h2v2H6z"/><path fill="currentcolor" d="M9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/><path fill="inherit" d="M12 7h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/></g></svg>`
    }, props, {
        newIcon: $83d1759e81e2efbc$var$_officeBuilding.default
    }));
$83d1759e81e2efbc$var$OfficeBuildingFilledIcon.displayName = 'OfficeBuildingFilledIcon';
var $83d1759e81e2efbc$var$_default = module.exports.default = $83d1759e81e2efbc$var$OfficeBuildingFilledIcon;

});



parcelRegister("g64ll", function(module, exports) {

$parcel$export(module.exports, "default", () => $a75486088cf44f62$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a75486088cf44f62$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    entitlementFieldPlaceholder: {
        "id": "servicedesk-customer-service-entitlements-field.common.read-view.entitlement-field-placeholder",
        "defaultMessage": "None"
    }
});

});


parcelRegister("SB9Jx", function(module, exports) {

$parcel$export(module.exports, "getNameFromFieldData", () => $7e5bc1899441b8ae$export$88049b8e8e0c8291);
const $7e5bc1899441b8ae$export$88049b8e8e0c8291 = (value)=>value?.product?.name;

});


parcelRegister("3YrDW", function(module, exports) {

$parcel$export(module.exports, "default", () => $632ebb40223f954d$export$2e2bcd8739ae039);

var $dQRbF = parcelRequire("dQRbF");

var $8toaC = parcelRequire("8toaC");

var $j55IR = parcelRequire("j55IR");
const $632ebb40223f954d$var$mapStateToProps = (state)=>({
        useJSMQueueDurationEvent: (0, $dQRbF.getUseJSMQueueDurationEvent)(state),
        getIssueLinkOverride: (0, $dQRbF.getIssueLinkOverride)(state)
    });
const $632ebb40223f954d$var$mergeProps = (stateProps, dispatchProps, ownProps)=>({
        ...ownProps,
        ...stateProps
    });
var $632ebb40223f954d$export$2e2bcd8739ae039 = (0, $8toaC.connect)($632ebb40223f954d$var$mapStateToProps, {}, $632ebb40223f954d$var$mergeProps)((0, $j55IR.default));

});
parcelRegister("j55IR", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a5e554ac479b65$export$2e2bcd8739ae039);
/* eslint-disable jira/react/no-style-attribute */ 
var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $hdC3k = parcelRequire("hdC3k");

var $gCeeo = parcelRequire("gCeeo");

var $7gc68 = parcelRequire("7gc68");
const $66a5e554ac479b65$var$TruncateFirstSpan = ({ children: children, innerRef: innerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        ref: innerRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textOverflow: 'ellipsis',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexGrow: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexShrink: 10000,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: '12px'
        }
    }, children);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $66a5e554ac479b65$var$TruncateSecondSpan = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textOverflow: 'ellipsis',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexGrow: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexShrink: 1,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexBasis: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: '12px'
        }
    }, children);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $66a5e554ac479b65$var$StandaloneTruncateDiv = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            textOverflow: 'ellipsis',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            whiteSpace: 'nowrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, children);
const $66a5e554ac479b65$var$SPAN_PARENT_FLEX_TRUNCATE_STYLE = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'flex',
    flexGrow: 1
};
const $66a5e554ac479b65$var$SECONDARY_LINK_STYLE = {
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text-subtlest, #626F86)"
};
const $66a5e554ac479b65$var$getSecondaryLinkStyle = ()=>$66a5e554ac479b65$var$SECONDARY_LINK_STYLE;
const $66a5e554ac479b65$var$PADDING_STYLE = {
    padding: `10px ${"var(--ds-space-075, 6px)"} 10px ${"var(--ds-space-075, 6px)"}`,
    width: 'auto'
};
const $66a5e554ac479b65$var$getFocusStyle = (isFocused)=>({
        borderColor: isFocused ? `${"var(--ds-border-focused, #388BFF)"}` : 'transparent',
        borderRadius: '3px',
        borderWidth: '2px',
        borderStyle: 'solid',
        boxShadow: 'none',
        outline: 'none'
    });
const $66a5e554ac479b65$var$getFocusableTruncatingParentLinkStyle = (isFocused)=>({
        ...$66a5e554ac479b65$var$SPAN_PARENT_FLEX_TRUNCATE_STYLE,
        ...$66a5e554ac479b65$var$getSecondaryLinkStyle(),
        ...$66a5e554ac479b65$var$PADDING_STYLE,
        ...$66a5e554ac479b65$var$getFocusStyle(isFocused)
    });
const $66a5e554ac479b65$var$disabledStyle = {
    ...$66a5e554ac479b65$var$SPAN_PARENT_FLEX_TRUNCATE_STYLE,
    ...$66a5e554ac479b65$var$getSecondaryLinkStyle(),
    padding: `${"var(--ds-space-150, 12px)"} 0px`
};
const $66a5e554ac479b65$export$fd902cb3210d888f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        style: {
            flexGrow: 10
        }
    });
const $66a5e554ac479b65$var$renderNonInteractiveIssueKey = (isLastColumn, issueKey)=>// Monolith still relies on 'issuekey' class selector for it's webdriver tests
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
        className: "issuekey",
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($66a5e554ac479b65$var$StandaloneTruncateDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        style: $66a5e554ac479b65$var$disabledStyle
    }, issueKey)));
class $66a5e554ac479b65$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            linkStyle: {}
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataSelectorProps.value !== nextProps.dataSelectorProps.value || this.props.tableInjectedProps.isTableDisabled !== nextProps.tableInjectedProps.isTableDisabled || this.state.isFocused !== nextState.isFocused || this.state.tooltipText !== nextState.tooltipText;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderIssueKeyLink(issueKey, projectKey, issueNumber) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hdC3k.default), {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...$66a5e554ac479b65$var$getFocusableTruncatingParentLinkStyle(this.state.isFocused),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...this.props.linkStyle
            },
            onMouseOver: this.onMouseOver,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            href: this.props.getIssueLinkOverride ? this.props.getIssueLinkOverride(issueKey) : `/browse/${issueKey}`,
            onClick: this.onClick,
            onAuxClick: this.onAuxClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "issue-link",
            'data-issue-key': issueKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($66a5e554ac479b65$var$TruncateFirstSpan, {
            innerRef: this.onSetProjectKeyRef
        }, projectKey), "-", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($66a5e554ac479b65$var$TruncateSecondSpan, null, issueNumber)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($66a5e554ac479b65$export$fd902cb3210d888f, null));
    }
    renderNonInteractiveIssueKeyFF(isLastColumn, issueKey, projectKey, issueNumber) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
            // Monolith still relies on 'issuekey' class selector for it's webdriver tests
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "issuekey",
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            style: $66a5e554ac479b65$var$disabledStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($66a5e554ac479b65$var$TruncateFirstSpan, {
            innerRef: this.onSetProjectKeyRef
        }, projectKey), "-", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($66a5e554ac479b65$var$TruncateSecondSpan, null, issueNumber)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($66a5e554ac479b65$export$fd902cb3210d888f, null));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderWithTooltipIfRequired(content) {
        const { tooltipText: tooltipText } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.SelectableChildGutterPaddingContainer), {
            // Monolith still relies on 'issuekey' class selector for it's webdriver tests
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "issuekey",
            isLastColumn: this.props.tableInjectedProps.isLastColumn
        }, tooltipText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            delay: 0,
            content: tooltipText
        }, content) : content);
    }
    render() {
        const { dataSelectorProps: { value: issueKey }, tableInjectedProps: { isLastColumn: isLastColumn, isTableDisabled: isTableDisabled } } = this.props;
        const splitIssueKey = issueKey.split('-');
        if (splitIssueKey && splitIssueKey.length === 2) {
            if (!isTableDisabled) return this.renderWithTooltipIfRequired(this.renderIssueKeyLink(issueKey, splitIssueKey[0], splitIssueKey[1]));
            return this.renderNonInteractiveIssueKeyFF(isLastColumn, issueKey, splitIssueKey[0], splitIssueKey[1]);
        }
        return $66a5e554ac479b65$var$renderNonInteractiveIssueKey(isLastColumn, issueKey);
    }
    constructor(...args){
        super(...args), this.state = {
            isFocused: false,
            tooltipText: ''
        }, this.onSetProjectKeyRef = (ref)=>{
            // @ts-expect-error - TS2322 - Type 'HTMLElement | null | undefined' is not assignable to type 'null'.
            this.projectKeyRef = ref;
        }, this.onFocus = ()=>{
            this.setState({
                isFocused: true
            });
        }, this.onBlur = ()=>{
            this.setState({
                isFocused: false
            });
        }, this.onMouseOver = ()=>{
            if (this.projectKeyRef) {
                let tooltipText = '';
                // Check if the element has overflown. If yes, set the innerText in state for tooltip to display
                // @ts-expect-error - TS2339 - Property 'scrollWidth' does not exist on type 'never'. | TS2339 - Property 'offsetWidth' does not exist on type 'never'.
                if (this.projectKeyRef.scrollWidth > this.projectKeyRef.offsetWidth) tooltipText = this.props.dataSelectorProps.value;
                if (this.state.tooltipText !== tooltipText) this.setState(()=>({
                        tooltipText: tooltipText
                    }));
            }
        }, this.onClick = (event, analyticsEvent)=>{
            const { onIssueViewTransition: onIssueViewTransition } = this.props.tableInjectedProps;
            const { useJSMQueueDurationEvent: useJSMQueueDurationEvent } = this.props;
            // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useJSMQueueDurationEvent && useJSMQueueDurationEvent();
            onIssueViewTransition?.(event);
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
        }, this.onAuxClick = ()=>{
            const { useJSMQueueDurationEvent: useJSMQueueDurationEvent } = this.props;
            // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useJSMQueueDurationEvent && useJSMQueueDurationEvent();
        }, this.projectKeyRef = null;
    }
}

});


parcelRegister("71Yrd", function(module, exports) {

$parcel$export(module.exports, "default", () => $810719060c3d6dac$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $51ksj = parcelRequire("51ksj");

var $cGjjW = parcelRequire("cGjjW");
// TODO: Show meatball only onHover and onFocus
const $810719060c3d6dac$var$IssueOperations = ({ tableInjectedProps: { issueKey: issueKey }, dataSelectorProps: { issueId: issueId, useRefetch: useRefetch } })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const { onRefetch: onRefetch } = useRefetch();
    const [flags, setFlags] = (0, $eJOHy.useState)([]);
    const onAddFlag = (styleClass, isSuccessful)=>setFlags([
            {
                id: flags.length + 1,
                styleClass: styleClass,
                isSuccessful: isSuccessful
            },
            ...flags
        ]);
    const onDismissFlag = ()=>setFlags(flags.slice(1));
    const onIssueRefetch = ()=>onRefetch(issueKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($810719060c3d6dac$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51ksj.default), {
        issueId: issueId,
        issueKey: issueKey,
        onAddFlag: onAddFlag,
        onIssueRefetch: onIssueRefetch
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cGjjW.default), {
        flags: flags,
        onDismiss: onDismissFlag,
        issueKey: issueKey
    }));
};
var $810719060c3d6dac$export$2e2bcd8739ae039 = $810719060c3d6dac$var$IssueOperations;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $810719060c3d6dac$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("51ksj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0cffe7a77b8f4ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $aMdh8 = parcelRequire("aMdh8");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e0cffe7a77b8f4ac$var$MeatballMenu = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("ekPiY")), {
    ssr: false,
    moduleId: "./src/packages/issue-table/src/common/fields/issue-operations/meatball-menu/index.tsx"
});
const $e0cffe7a77b8f4ac$var$AsyncMeatballMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                label: "",
                LEGACY_size: "medium",
                spacing: "spacious"
            }),
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e0cffe7a77b8f4ac$var$MeatballMenu, props));
var $e0cffe7a77b8f4ac$export$2e2bcd8739ae039 = $e0cffe7a77b8f4ac$var$AsyncMeatballMenu;

});
parcelRegister("ekPiY", function(module, exports) {

let $a6fabb0db927038c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a6fabb0db927038c$var$load("fCJxY").then(()=>parcelRequire('5y24M'));

});


parcelRegister("cGjjW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c8d24866e4957e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3TFuO = parcelRequire("3TFuO");

var $1NG86 = parcelRequire("1NG86");

var $aMGpU = parcelRequire("aMGpU");

var $jFfVF = parcelRequire("jFfVF");

var $lRq8t = parcelRequire("lRq8t");

var $jeCZF = parcelRequire("jeCZF");

var $doHpF = parcelRequire("doHpF");
const $d8c8d24866e4957e$var$NotificationFlagGroup = ({ flags: flags, onDismiss: onDismiss, issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jFfVF.default), {
        onDismissed: onDismiss
    }, flags.map(({ id: id, styleClass: styleClass, isSuccessful: isSuccessful })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aMGpU.default), {
            id: id,
            icon: isSuccessful ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))), {
                label: "Success",
                LEGACY_size: "medium",
                spacing: "spacious",
                color: "var(--ds-icon-success, #22A06B)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
                label: "Error",
                LEGACY_size: "medium",
                spacing: "spacious",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            key: id,
            title: isSuccessful ? formatMessage((0, $jeCZF.default).successTitle) : formatMessage((0, $jeCZF.default).errorTitle),
            description: isSuccessful ? formatMessage((0, $jeCZF.default)[(0, $doHpF.getMessageId)(styleClass)], {
                issueKey: issueKey
            }) : formatMessage((0, $jeCZF.default).errorDesc, {
                issueKey: issueKey
            }),
            messageId: "issue-table.common.fields.issue-operations.notification-flag-group.auto-dismiss-flag",
            messageType: "transactional"
        })));
};
var $d8c8d24866e4957e$export$2e2bcd8739ae039 = $d8c8d24866e4957e$var$NotificationFlagGroup;

});
parcelRegister("jFfVF", function(module, exports) {

$parcel$export(module.exports, "default", () => $baac1c5c645cc856$export$2e2bcd8739ae039);

var $a9cht = parcelRequire("a9cht");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$baac1c5c645cc856$export$2e2bcd8739ae039 = (0, $a9cht.FlagGroup);

});

parcelRegister("jeCZF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d198e69f4c834b0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1d198e69f4c834b0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    thanksIssueUpdated: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-updated",
        "defaultMessage": "{issueKey} has been updated."
    },
    thanksIssueAssigned: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-assigned",
        "defaultMessage": "{issueKey} has been assigned."
    },
    thanksIssueCommented: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-commented",
        "defaultMessage": "{issueKey} has been updated with your comment."
    },
    thanksIssueWorklogged: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-worklogged",
        "defaultMessage": "Work has been logged on {issueKey}."
    },
    thanksIssueVoted: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-voted",
        "defaultMessage": "Your vote on {issueKey} has been updated."
    },
    thanksIssueWatched: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-watched",
        "defaultMessage": "Your watcher status on {issueKey} has been updated."
    },
    thanksIssueMoved: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-moved",
        "defaultMessage": "{issueKey} has been moved."
    },
    thanksIssueLinked: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-linked",
        "defaultMessage": "The links on {issueKey} have been updated."
    },
    thanksIssueCloned: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-cloned",
        "defaultMessage": "{issueKey} has been cloned."
    },
    thanksIssueLabelled: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-labelled",
        "defaultMessage": "The labels on {issueKey} have been updated."
    },
    thanksIssueDeleted: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-deleted",
        "defaultMessage": "{issueKey} has been deleted."
    },
    thanksIssueAttached: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.thanks-issue-attached",
        "defaultMessage": "The file(s) have been attached to {issueKey}."
    },
    successTitle: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.success-title",
        "defaultMessage": "Issue updated"
    },
    errorTitle: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.error-title",
        "defaultMessage": "Error"
    },
    errorDesc: {
        "id": "issue-table.common.fields.issue-operations.notification-flag-group.error-desc",
        "defaultMessage": "Your operation on {issueKey} could not be performed."
    }
});

});

parcelRegister("doHpF", function(module, exports) {

$parcel$export(module.exports, "getMessageId", () => $39d7c12cdf2f8ca7$export$7a6ec380c1221521);

var $ckro8 = parcelRequire("ckro8");
const $39d7c12cdf2f8ca7$export$7a6ec380c1221521 = (styleClass)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "issueaction-assign-issue": { readonly id: "assign-dialog"; readonly issueMsg: "thanksIssueAssigned"; }; readonly "issueaction-assign-to-me hide-from-opsbar": { readonly id: "assign-dialog"; readonly issueMsg: "thanksIssueAssigned"; }; ... 5 more ...; readonly "issueaction-edit-labels": { ...; }; }'.
    (0, $ckro8.DIALOG_DATA)[styleClass]?.issueMsg ?? 'thanksIssueUpdated';

});
parcelRegister("ckro8", function(module, exports) {

$parcel$export(module.exports, "RANK_TO_TOP", () => $eed9e52834c04a02$export$a1d82a1fb322eabf);
$parcel$export(module.exports, "RANK_TO_BOTTOM", () => $eed9e52834c04a02$export$264804825e75ec82);
$parcel$export(module.exports, "OPERATION_IDS", () => $eed9e52834c04a02$export$498178c427a35252);
$parcel$export(module.exports, "LINK_IDS", () => $eed9e52834c04a02$export$1fff534c17344ccf);
$parcel$export(module.exports, "DIALOG_FIELDS", () => $eed9e52834c04a02$export$5ae74c325a8e870e);
$parcel$export(module.exports, "SKIP_FIELDS", () => $eed9e52834c04a02$export$cb2989a570fe66ad);
$parcel$export(module.exports, "URL_OVERRIDE_FIELDS", () => $eed9e52834c04a02$export$b86499b7cf24c281);
$parcel$export(module.exports, "DIALOG_DATA", () => $eed9e52834c04a02$export$f57e70208d0fb8b9);
const $eed9e52834c04a02$var$EDIT_ISSUE = 'issueaction-edit-issue';
const $eed9e52834c04a02$var$ASSIGN = 'issueaction-assign-issue';
const $eed9e52834c04a02$var$ASSIGN_TO_ME = 'issueaction-assign-to-me hide-from-opsbar';
const $eed9e52834c04a02$var$COMMENT_ISSUE = 'issueaction-comment-issue add-issue-comment';
const $eed9e52834c04a02$var$LOG_WORK = 'issueaction-log-work';
const $eed9e52834c04a02$var$AGILE_BOARD = 'issueaction-greenhopper-rapidboard-operation js-rapidboard-operation-issue';
const $eed9e52834c04a02$export$a1d82a1fb322eabf = 'issueaction-greenhopper-rank-top-operation';
const $eed9e52834c04a02$export$264804825e75ec82 = 'issueaction-greenhopper-rank-bottom-operation';
const $eed9e52834c04a02$var$ATTACH_FILE = 'unified-attach-file';
const $eed9e52834c04a02$var$ATTACH_SCREENSHOT = 'issueaction-attach-screenshot-html5';
const $eed9e52834c04a02$var$ADD_VOTE = 'issueaction-vote-issue';
const $eed9e52834c04a02$var$REMOVE_VOTE = 'issueaction-unvote-issue';
const $eed9e52834c04a02$var$VIEW_VOTERS = 'issueaction-view-voters';
const $eed9e52834c04a02$var$WATCH_ISSUE = 'issueaction-watch-issue';
const $eed9e52834c04a02$var$UNWATCH_ISSUE = 'issueaction-unwatch-issue';
const $eed9e52834c04a02$var$WATCHERS = 'issueaction-manage-watchers';
const $eed9e52834c04a02$var$CREATE_SUBTASK = 'issueaction-create-subtask';
const $eed9e52834c04a02$var$CONVERT_TO_ISSUE = 'issueaction-subtask-to-issue';
const $eed9e52834c04a02$var$CONVERT_TO_SUBTASK = 'issueaction-issue-to-subtask';
const $eed9e52834c04a02$var$CREATE_BRANCH = 'devstatus-cta-link';
const $eed9e52834c04a02$var$CREATE_LINKED_ISSUE = 'issueaction-create-linked-issue';
const $eed9e52834c04a02$var$MOVE = 'issueaction-move-issue';
const $eed9e52834c04a02$var$LINK = 'issueaction-link-issue';
const $eed9e52834c04a02$var$CLONE = 'issueaction-clone-issue';
const $eed9e52834c04a02$var$LABELS = 'issueaction-edit-labels';
const $eed9e52834c04a02$var$DELETE = 'issueaction-delete-issue';
const $eed9e52834c04a02$var$ADD_FIELD = 'issueaction-fields-add';
const $eed9e52834c04a02$var$PERMISSION_HELPER = 'permissionhelper-trigger';
const $eed9e52834c04a02$var$NOTIFICATION_HELPER = 'notificationhelper-trigger';
const $eed9e52834c04a02$var$LINK_ISSUE = 'add-jira-issue-link-link';
const $eed9e52834c04a02$var$LINK_CONFLUENCE_PAGE = 'add-confluence-page-link-link';
const $eed9e52834c04a02$var$ADD_WEB_LINK = 'add-web-link-link';
const $eed9e52834c04a02$export$498178c427a35252 = {
    EDIT_ISSUE: $eed9e52834c04a02$var$EDIT_ISSUE,
    ASSIGN: $eed9e52834c04a02$var$ASSIGN,
    ASSIGN_TO_ME: $eed9e52834c04a02$var$ASSIGN_TO_ME,
    COMMENT_ISSUE: $eed9e52834c04a02$var$COMMENT_ISSUE,
    LOG_WORK: $eed9e52834c04a02$var$LOG_WORK,
    AGILE_BOARD: $eed9e52834c04a02$var$AGILE_BOARD,
    RANK_TO_TOP: $eed9e52834c04a02$export$a1d82a1fb322eabf,
    RANK_TO_BOTTOM: $eed9e52834c04a02$export$264804825e75ec82,
    ATTACH_FILE: $eed9e52834c04a02$var$ATTACH_FILE,
    ATTACH_SCREENSHOT: $eed9e52834c04a02$var$ATTACH_SCREENSHOT,
    ADD_VOTE: $eed9e52834c04a02$var$ADD_VOTE,
    REMOVE_VOTE: $eed9e52834c04a02$var$REMOVE_VOTE,
    VIEW_VOTERS: $eed9e52834c04a02$var$VIEW_VOTERS,
    WATCH_ISSUE: $eed9e52834c04a02$var$WATCH_ISSUE,
    UNWATCH_ISSUE: $eed9e52834c04a02$var$UNWATCH_ISSUE,
    WATCHERS: $eed9e52834c04a02$var$WATCHERS,
    CREATE_SUBTASK: $eed9e52834c04a02$var$CREATE_SUBTASK,
    CONVERT_TO_ISSUE: $eed9e52834c04a02$var$CONVERT_TO_ISSUE,
    CONVERT_TO_SUBTASK: $eed9e52834c04a02$var$CONVERT_TO_SUBTASK,
    CREATE_BRANCH: $eed9e52834c04a02$var$CREATE_BRANCH,
    CREATE_LINKED_ISSUE: $eed9e52834c04a02$var$CREATE_LINKED_ISSUE,
    MOVE: $eed9e52834c04a02$var$MOVE,
    LINK: $eed9e52834c04a02$var$LINK,
    CLONE: $eed9e52834c04a02$var$CLONE,
    LABELS: $eed9e52834c04a02$var$LABELS,
    DELETE: $eed9e52834c04a02$var$DELETE,
    ADD_FIELD: $eed9e52834c04a02$var$ADD_FIELD,
    PERMISSION_HELPER: $eed9e52834c04a02$var$PERMISSION_HELPER,
    NOTIFICATION_HELPER: $eed9e52834c04a02$var$NOTIFICATION_HELPER
};
const $eed9e52834c04a02$export$1fff534c17344ccf = {
    LINK_ISSUE: $eed9e52834c04a02$var$LINK_ISSUE,
    LINK_CONFLUENCE_PAGE: $eed9e52834c04a02$var$LINK_CONFLUENCE_PAGE,
    ADD_WEB_LINK: $eed9e52834c04a02$var$ADD_WEB_LINK
};
const $eed9e52834c04a02$export$5ae74c325a8e870e = [
    $eed9e52834c04a02$var$EDIT_ISSUE,
    $eed9e52834c04a02$var$COMMENT_ISSUE,
    $eed9e52834c04a02$var$LOG_WORK,
    $eed9e52834c04a02$export$a1d82a1fb322eabf,
    $eed9e52834c04a02$export$264804825e75ec82,
    $eed9e52834c04a02$var$ATTACH_FILE,
    $eed9e52834c04a02$var$ADD_VOTE,
    $eed9e52834c04a02$var$REMOVE_VOTE,
    $eed9e52834c04a02$var$WATCH_ISSUE,
    $eed9e52834c04a02$var$UNWATCH_ISSUE,
    $eed9e52834c04a02$var$LINK,
    $eed9e52834c04a02$var$CLONE,
    $eed9e52834c04a02$var$LABELS,
    $eed9e52834c04a02$var$DELETE,
    $eed9e52834c04a02$var$ADD_FIELD,
    $eed9e52834c04a02$var$PERMISSION_HELPER,
    $eed9e52834c04a02$var$NOTIFICATION_HELPER,
    $eed9e52834c04a02$var$ASSIGN,
    $eed9e52834c04a02$var$ASSIGN_TO_ME,
    $eed9e52834c04a02$var$ATTACH_SCREENSHOT,
    $eed9e52834c04a02$var$CREATE_LINKED_ISSUE,
    $eed9e52834c04a02$var$CREATE_SUBTASK
];
const $eed9e52834c04a02$export$cb2989a570fe66ad = [
    $eed9e52834c04a02$var$EDIT_ISSUE,
    $eed9e52834c04a02$var$ASSIGN,
    $eed9e52834c04a02$var$ASSIGN_TO_ME,
    $eed9e52834c04a02$var$ATTACH_SCREENSHOT,
    $eed9e52834c04a02$var$CREATE_LINKED_ISSUE,
    $eed9e52834c04a02$var$CREATE_BRANCH,
    $eed9e52834c04a02$var$LINK
];
const $eed9e52834c04a02$export$b86499b7cf24c281 = {
    [$eed9e52834c04a02$var$PERMISSION_HELPER]: '/secure/admin/PermissionHelperAdmin.jspa',
    [$eed9e52834c04a02$var$NOTIFICATION_HELPER]: '/secure/admin/NotificationHelperAdmin.jspa'
};
const $eed9e52834c04a02$export$f57e70208d0fb8b9 = {
    [$eed9e52834c04a02$var$ASSIGN]: {
        id: 'assign-dialog',
        issueMsg: 'thanksIssueAssigned'
    },
    [$eed9e52834c04a02$var$ASSIGN_TO_ME]: {
        id: 'assign-dialog',
        issueMsg: 'thanksIssueAssigned'
    },
    [$eed9e52834c04a02$var$COMMENT_ISSUE]: {
        id: 'comment-add-dialog',
        issueMsg: 'thanksIssueCommented'
    },
    [$eed9e52834c04a02$var$ATTACH_FILE]: {
        id: 'attach-file-dialog',
        issueMsg: 'thanksIssueAttached'
    },
    [$eed9e52834c04a02$var$DELETE]: {
        id: 'delete-issue-dialog',
        issueMsg: 'thanksIssueDeleted'
    },
    [$eed9e52834c04a02$var$CLONE]: {
        id: 'clone-issue-dialog',
        issueMsg: 'thanksIssueCloned'
    },
    [$eed9e52834c04a02$var$LOG_WORK]: {
        id: 'edit-log-work-dialog',
        issueMsg: 'thanksIssueWorklogged'
    },
    [$eed9e52834c04a02$var$LABELS]: {
        id: 'edit-labels-dialog',
        issueMsg: 'thanksIssueLabelled'
    }
};

});




parcelRegister("8JSWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b330ae840ad151eb$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7gc68 = parcelRequire("7gc68");
function $b330ae840ad151eb$export$2e2bcd8739ae039(props) {
    const { dataSelectorProps: { value: { iconUrl: iconUrl, description: description, name: name } }, tableInjectedProps: { isLastColumn: isLastColumn } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b330ae840ad151eb$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        height: "16",
        width: "16",
        src: iconUrl,
        alt: description,
        title: name
    })));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b330ae840ad151eb$var$StyledWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itidpf _ca0q19bv _u5f3u2gc _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("16gLw", function(module, exports) {

$parcel$export(module.exports, "default", () => $752038b720c65c3b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $epTsa = parcelRequire("epTsa");

var $aCFLd = parcelRequire("aCFLd");

var $051tO = parcelRequire("051tO");

var $2R0qn = parcelRequire("2R0qn");

var $7jTnu = parcelRequire("7jTnu");

var $iXXEI = parcelRequire("iXXEI");

var $8exF9 = parcelRequire("8exF9");
const $752038b720c65c3b$var$getLabelColor = (label)=>{
    const colorName = label.color;
    const { backgroundColor: color } = (0, $051tO.getColorMetadata)(colorName || (0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(label.name));
    return color;
};
const $752038b720c65c3b$var$Labels = ({ tableInjectedProps: { isLastColumn: isLastColumn }, dataSelectorProps: { value: value } })=>{
    if ((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
        const [{ coloredLabelSuggestions: coloredLabelSuggestions }] = (0, $7jTnu.fg)('change_import_path_for_usecoloredlabelsstore') ? // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $2R0qn.useColoredLabelsStore)() : // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $iXXEI.useLabelsStore)();
        const coloredLabels = coloredLabelSuggestions?.labels;
        const coloredValue = value.map((val)=>{
            const labelWithColor = coloredLabels.find((label)=>label.name === val.name);
            const labelColor = labelWithColor && $752038b720c65c3b$var$getLabelColor(labelWithColor);
            return {
                ...val,
                color: labelColor
            };
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8exF9.default), {
            // @ts-expect-error - ts2322 -  Property 'href' is optional in type '{ color: string | undefined; name: string; href?: string | undefined; }' but required in type 'TagData'.
            tags: coloredValue,
            isLastColumn: isLastColumn,
            ...(0, $epTsa.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) ? {
                isColored: true
            } : {}
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8exF9.default), {
        // @ts-expect-error - TS2322 - Type 'LabelsProps' is not assignable to type 'TagData[]'.
        tags: value,
        isLastColumn: isLastColumn,
        ...(0, $epTsa.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) ? {
            isColored: true
        } : {}
    });
};
var $752038b720c65c3b$export$2e2bcd8739ae039 = $752038b720c65c3b$var$Labels;

});
parcelRegister("aCFLd", function(module, exports) {

$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabels", () => $3bdc301abc6592d1$export$8100203285e9ab92);
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabelsTag", () => $3bdc301abc6592d1$export$a80529ae8ec44f02);

var $5PQOA = parcelRequire("5PQOA");

var $cNNNb = parcelRequire("cNNNb");

var $1mQND = parcelRequire("1mQND");

var $eFge8 = parcelRequire("eFge8");
const $3bdc301abc6592d1$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $1mQND.getHashValueForText)(option);
        const randomIndex = (0, $eFge8.getRandomIndex)(hashValue);
        return (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $cNNNb.GREY_META).name;
};
const $3bdc301abc6592d1$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $1mQND.getHashValueForText)(option);
        const randomIndex = (0, $eFge8.getRandomIndex)(hashValue);
        return (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $cNNNb.GREY_META).tagColor;
};
const $3bdc301abc6592d1$export$8100203285e9ab92 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($3bdc301abc6592d1$export$97056d4b28203ee9);
const $3bdc301abc6592d1$export$a80529ae8ec44f02 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($3bdc301abc6592d1$export$a3f5334e7a13e57a);

});
parcelRegister("cNNNb", function(module, exports) {

$parcel$export(module.exports, "GREY_META", () => $711a16afce0bfcb3$export$11b75436f568ab00);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $711a16afce0bfcb3$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $711a16afce0bfcb3$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "OPTION_COLOR_THEMES", () => $711a16afce0bfcb3$export$7f42563469df7e01);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT", () => $711a16afce0bfcb3$export$2c649adf8351b065);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_DARKER_SINGLE_SELECT", () => $711a16afce0bfcb3$export$20b2b274810f728a);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_MAP", () => $711a16afce0bfcb3$export$7c14120abebd4749);

var $isE62 = parcelRequire("isE62");
const $711a16afce0bfcb3$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $isE62.default).greyLightest
};
const $711a16afce0bfcb3$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $isE62.default).greyLighter
};
const $711a16afce0bfcb3$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $isE62.default).grey
};
const $711a16afce0bfcb3$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greyDarker
};
const $711a16afce0bfcb3$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greyDarkest
};
const $711a16afce0bfcb3$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $isE62.default).purpleLightest
};
const $711a16afce0bfcb3$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $isE62.default).purpleLighter
};
const $711a16afce0bfcb3$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $isE62.default).purple
};
const $711a16afce0bfcb3$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).purpleDarker
};
const $711a16afce0bfcb3$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).purpleDarkest
};
const $711a16afce0bfcb3$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $isE62.default).blueLightest
};
const $711a16afce0bfcb3$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $isE62.default).blueLighter
};
const $711a16afce0bfcb3$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $isE62.default).blue
};
const $711a16afce0bfcb3$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).blueDarker
};
const $711a16afce0bfcb3$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).blueDarkest
};
const $711a16afce0bfcb3$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).tealLightest
};
const $711a16afce0bfcb3$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).tealLighter
};
const $711a16afce0bfcb3$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).teal
};
const $711a16afce0bfcb3$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).tealDarker
};
const $711a16afce0bfcb3$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).tealDarkest
};
const $711a16afce0bfcb3$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).greenLightest
};
const $711a16afce0bfcb3$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).greenLighter
};
const $711a16afce0bfcb3$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).green
};
const $711a16afce0bfcb3$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greenDarker
};
const $711a16afce0bfcb3$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greenDarkest
};
const $711a16afce0bfcb3$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).limeLightest
};
const $711a16afce0bfcb3$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).limeLighter
};
const $711a16afce0bfcb3$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).lime
};
const $711a16afce0bfcb3$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).limeDarker
};
const $711a16afce0bfcb3$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).limeDarkest
};
const $711a16afce0bfcb3$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellowLightest
};
const $711a16afce0bfcb3$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellowLighter
};
const $711a16afce0bfcb3$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellow
};
const $711a16afce0bfcb3$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).yellowDarker
};
const $711a16afce0bfcb3$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).yellowDarkest
};
const $711a16afce0bfcb3$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $isE62.default).orangeLightest
};
const $711a16afce0bfcb3$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $isE62.default).orangeLighter
};
const $711a16afce0bfcb3$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $isE62.default).orange
};
const $711a16afce0bfcb3$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).orangeDarker
};
const $711a16afce0bfcb3$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).orangeDarkest
};
const $711a16afce0bfcb3$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).redLightest
};
const $711a16afce0bfcb3$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).redLighter
};
const $711a16afce0bfcb3$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).red
};
const $711a16afce0bfcb3$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).redDarker
};
const $711a16afce0bfcb3$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).redDarkest
};
const $711a16afce0bfcb3$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magentaLightest
};
const $711a16afce0bfcb3$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magentaLighter
};
const $711a16afce0bfcb3$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magenta
};
const $711a16afce0bfcb3$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).magentaDarker
};
const $711a16afce0bfcb3$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).magentaDarkest
};
const $711a16afce0bfcb3$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $711a16afce0bfcb3$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $711a16afce0bfcb3$export$7f42563469df7e01 = [
    $711a16afce0bfcb3$var$GREY_LIGHTEST_META,
    $711a16afce0bfcb3$var$PURPLE_LIGHTEST_META,
    $711a16afce0bfcb3$var$BLUE_LIGHTEST_META,
    $711a16afce0bfcb3$var$TEAL_LIGHTEST_META,
    $711a16afce0bfcb3$var$GREEN_LIGHTEST_META,
    $711a16afce0bfcb3$var$LIME_LIGHTEST_META,
    $711a16afce0bfcb3$var$YELLOW_LIGHTEST_META,
    $711a16afce0bfcb3$var$ORANGE_LIGHTEST_META,
    $711a16afce0bfcb3$var$RED_LIGHTEST_META,
    $711a16afce0bfcb3$var$MAGENTA_LIGHTEST_META,
    $711a16afce0bfcb3$var$GREY_LIGHTER_META,
    $711a16afce0bfcb3$var$PURPLE_LIGHTER_META,
    $711a16afce0bfcb3$var$BLUE_LIGHTER_META,
    $711a16afce0bfcb3$var$TEAL_LIGHTER_META,
    $711a16afce0bfcb3$var$GREEN_LIGHTER_META,
    $711a16afce0bfcb3$var$LIME_LIGHTER_META,
    $711a16afce0bfcb3$var$YELLOW_LIGHTER_META,
    $711a16afce0bfcb3$var$ORANGE_LIGHTER_META,
    $711a16afce0bfcb3$var$RED_LIGHTER_META,
    $711a16afce0bfcb3$var$MAGENTA_LIGHTER_META,
    $711a16afce0bfcb3$export$11b75436f568ab00,
    $711a16afce0bfcb3$var$PURPLE_META,
    $711a16afce0bfcb3$var$BLUE_META,
    $711a16afce0bfcb3$var$TEAL_META,
    $711a16afce0bfcb3$var$GREEN_META,
    $711a16afce0bfcb3$var$LIME_META,
    $711a16afce0bfcb3$var$YELLOW_META,
    $711a16afce0bfcb3$var$ORANGE_META,
    $711a16afce0bfcb3$var$RED_META,
    $711a16afce0bfcb3$var$MAGENTA_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$export$7c314e2461a7241b,
    $711a16afce0bfcb3$var$BLUE_DARKER_META,
    $711a16afce0bfcb3$export$6daaa1cc3f46f41,
    $711a16afce0bfcb3$var$GREEN_DARKER_META,
    $711a16afce0bfcb3$var$LIME_DARKER_META,
    $711a16afce0bfcb3$var$YELLOW_DARKER_META,
    $711a16afce0bfcb3$var$ORANGE_DARKER_META,
    $711a16afce0bfcb3$var$RED_DARKER_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKEST_META,
    $711a16afce0bfcb3$var$PURPLE_DARKEST_META,
    $711a16afce0bfcb3$export$69c4eac71b813fba,
    $711a16afce0bfcb3$var$TEAL_DARKEST_META,
    $711a16afce0bfcb3$var$GREEN_DARKEST_META,
    $711a16afce0bfcb3$var$LIME_DARKEST_META,
    $711a16afce0bfcb3$var$YELLOW_DARKEST_META,
    $711a16afce0bfcb3$var$ORANGE_DARKEST_META,
    $711a16afce0bfcb3$var$RED_DARKEST_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKEST_META
];
const $711a16afce0bfcb3$export$2c649adf8351b065 = [
    $711a16afce0bfcb3$var$PURPLE_META,
    $711a16afce0bfcb3$var$YELLOW_META,
    $711a16afce0bfcb3$var$GREEN_META,
    $711a16afce0bfcb3$var$TEAL_META,
    $711a16afce0bfcb3$var$RED_META,
    $711a16afce0bfcb3$var$ORANGE_META,
    $711a16afce0bfcb3$var$MAGENTA_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$export$11b75436f568ab00
];
const $711a16afce0bfcb3$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$711a16afce0bfcb3$export$2c649adf8351b065.forEach((option)=>{
    $711a16afce0bfcb3$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $711a16afce0bfcb3$export$20b2b274810f728a = [
    $711a16afce0bfcb3$export$7c314e2461a7241b,
    $711a16afce0bfcb3$var$YELLOW_DARKER_META,
    $711a16afce0bfcb3$var$GREEN_DARKER_META,
    $711a16afce0bfcb3$export$6daaa1cc3f46f41,
    $711a16afce0bfcb3$var$RED_DARKER_META,
    $711a16afce0bfcb3$var$ORANGE_DARKER_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKEST_META
];
const $711a16afce0bfcb3$export$7c14120abebd4749 = {};
$711a16afce0bfcb3$export$7f42563469df7e01.forEach((option)=>{
    $711a16afce0bfcb3$export$7c14120abebd4749[option.name] = option;
});

});
parcelRegister("isE62", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ddc0b3065e46f63$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2ddc0b3065e46f63$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    greyLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});


parcelRegister("1mQND", function(module, exports) {

$parcel$export(module.exports, "getHashValueForText", () => $682ff2f1c6e48764$export$e352defce701b36e);

const $682ff2f1c6e48764$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $12800e69511f991d$export$d15e38bcd75fda7c) + text.charCodeAt(i)) % (0, $12800e69511f991d$export$e143f4b09221a374);
    return hashValue;
};

});
/*
 * This is used to calculate the hash value of the provided text,
 * allowing us to generate random hash values for the options in the Labels field.
 * As a result, we enhance the randomization of color assignments to Labels.
 */ const $12800e69511f991d$export$d15e38bcd75fda7c = 256;
const $12800e69511f991d$export$e143f4b09221a374 = 1000000007;


parcelRegister("eFge8", function(module, exports) {

$parcel$export(module.exports, "getRandomIndex", () => $e4e4b7d26b0de284$export$cb0dffe2d2ae675a);

var $cNNNb = parcelRequire("cNNNb");
const $e4e4b7d26b0de284$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};

});


parcelRegister("051tO", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $3b3f14c0d0659bfe$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $3b3f14c0d0659bfe$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $3b3f14c0d0659bfe$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $3b3f14c0d0659bfe$export$49fce7fdcf55f26d);

var $cNNNb = parcelRequire("cNNNb");
const $3b3f14c0d0659bfe$export$e4369cabd7e84cd9 = ({ colorPaletteVariant: colorPaletteVariant = '' } = {})=>{
    // usign colorPaletteVariant to determine which color palette to use for random color selection
    const palette = colorPaletteVariant === 'newDarker' ? (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_DARKER_SINGLE_SELECT) : (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT);
    const randomIndex = Math.floor(Math.random() * palette.length);
    return palette[randomIndex].name;
};
const $3b3f14c0d0659bfe$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $cNNNb.OPTION_COLOR_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $3b3f14c0d0659bfe$export$9eff62e8ee2aaa2c = (colorName)=>(0, $cNNNb.OPTION_COLOR_THEMES_MAP)[colorName]?.backgroundColor ?? '';
const $3b3f14c0d0659bfe$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $cNNNb.GREY_META;
    return (0, $cNNNb.OPTION_COLOR_THEMES_MAP)[colorName] ?? (0, $cNNNb.GREY_META);
};
const $3b3f14c0d0659bfe$export$4ef6b7574883e63d = ()=>(0, $cNNNb.OPTION_COLOR_THEMES).map((item)=>item.name);

});

parcelRegister("8exF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $89039fe9388e8883$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ar6fB = parcelRequire("ar6fB");

var $9ewtR = parcelRequire("9ewtR");

var $lRq8t = parcelRequire("lRq8t");

var $aCFLd = parcelRequire("aCFLd");

var $6XJko = parcelRequire("6XJko");

var $iyBBa = parcelRequire("iyBBa");

var $epTsa = parcelRequire("epTsa");

var $7gc68 = parcelRequire("7gc68");

var $bbJY3 = parcelRequire("bbJY3");
const $89039fe9388e8883$var$Tags = ({ tags: tags, isLastColumn: isLastColumn, isColored: isColored })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (tags.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89039fe9388e8883$var$MessageWrapper, null, formatMessage((0, $bbJY3.default).none)));
    if ((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89039fe9388e8883$var$TagWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ewtR.default), null, tags.map((tag, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iyBBa.ColoredTag), {
            key: index,
            labelName: tag.name,
            color: tag.color,
            href: tag.href
        })))));
    if (!(0, $6XJko.isVisualRefreshEnabled)()) {
        if (isColored) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89039fe9388e8883$var$TagWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ewtR.default), null, tags.map((tag, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iyBBa.ColoredTag), {
                key: index,
                labelName: tag.name,
                href: tag.href
            })))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89039fe9388e8883$var$TagWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ewtR.default), null, tags.map((tag, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ar6fB.default), {
                key: index,
                appearance: "default",
                text: tag.name,
                href: tag.href,
                isRemovable: false
            })))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89039fe9388e8883$var$TagWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ewtR.default), null, tags.map((tag, index)=>// @ts-expect-error - ts2322 - Type 'string' is not assignable to type 'TagColor'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ar6fB.default), {
            key: index,
            appearance: "default",
            text: tag.name,
            href: tag.href,
            isRemovable: false,
            ...isColored ? {
                color: (0, $aCFLd.memoizeGetAutoGeneratedColorForLabelsTag)(tag.name)
            } : {}
        })))));
};
var $89039fe9388e8883$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $89039fe9388e8883$var$Tags;
const $89039fe9388e8883$var$TagWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18s87c40",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89039fe9388e8883$var$MessageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ar6fB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf2340f5bdb4d38$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $315a7 = parcelRequire("315a7");

var $gyJTO = parcelRequire("gyJTO");

var $3Vuhz = parcelRequire("3Vuhz");

var $Ys7jv = parcelRequire("Ys7jv");
var $lncqW = parcelRequire("lncqW");

var $eGOwo = parcelRequire("eGOwo");

var $5itvH = parcelRequire("5itvH");

var $1fStw = parcelRequire("1fStw");

var $40nZT = parcelRequire("40nZT");

var $6UE2q = parcelRequire("6UE2q");

var $h89xH = parcelRequire("h89xH");
const $7bf2340f5bdb4d38$var$textLinkCssVar = '--ds-ctl';
const $7bf2340f5bdb4d38$var$textDefaultCssVar = '--ds-ct';
const $7bf2340f5bdb4d38$var$textActiveCssVar = '--ds-ctp';
const $7bf2340f5bdb4d38$var$backgroundHoverCssVar = '--ds-cbh';
const $7bf2340f5bdb4d38$var$backgroundActiveCssVar = '--ds-cba';
var $7bf2340f5bdb4d38$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($7bf2340f5bdb4d38$var$TagStatus || {});
const $7bf2340f5bdb4d38$var$packageName = "platform-pkg";
const $7bf2340f5bdb4d38$var$packageVersion = "0.0.0-use.local";
const $7bf2340f5bdb4d38$var$defaultBeforeRemoveAction = ()=>true; /**
                                               * These hide the focus ring for the tag when its remove button is focused,
                                               * preventing a double focus ring.
                                               */ 
const $7bf2340f5bdb4d38$var$removingStyles = null;
const $7bf2340f5bdb4d38$var$RemovableTagComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $7bf2340f5bdb4d38$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $3Vuhz.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $eJOHy.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $eJOHy.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $315a7.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $7bf2340f5bdb4d38$var$packageName,
            packageVersion: $7bf2340f5bdb4d38$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $eJOHy.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $eJOHy.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $eJOHy.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $eJOHy.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $eJOHy.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $eJOHy.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $eJOHy.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h89xH.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6UE2q.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: (0, $eGOwo.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle, #00000000)" : undefined,
        // Tag background color on hover
        [$7bf2340f5bdb4d38$var$backgroundHoverCssVar]: (0, $eGOwo.fg)('platform-component-visual-refresh') ? undefined : (0, $5itvH.removalHoverBackgroundColors),
        // Tag background color on press
        [$7bf2340f5bdb4d38$var$backgroundActiveCssVar]: (0, $eGOwo.fg)('platform-component-visual-refresh') ? undefined : (0, $5itvH.removalActiveBackgroundColors),
        // The tag text on hover of remove button
        [$7bf2340f5bdb4d38$var$textDefaultCssVar]: (0, $eGOwo.fg)('platform-component-visual-refresh') ? undefined : (0, $5itvH.removalTextColors),
        // 'elemBefore' text on press of remove button
        [$7bf2340f5bdb4d38$var$textActiveCssVar]: (0, $eGOwo.fg)('platform-component-visual-refresh') ? undefined : (0, $5itvH.removalTextColors),
        // The tag link text on hover of remove button
        [$7bf2340f5bdb4d38$var$textLinkCssVar]: (0, $eGOwo.fg)('platform-component-visual-refresh') ? undefined : (0, $5itvH.removalTextColors)
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ys7jv.default), {
        children: !(status === "removed") && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lncqW.default), {
            children: (motion)=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1fStw.default), {
                    ref: (0, $gyJTO.default)([
                        motion.ref,
                        ref
                    ]),
                    appearance: appearance,
                    color: color,
                    testId: testId,
                    style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                    "data-removable": true,
                    "data-removing": status === "removing",
                    "data-ishoverclosebutton": isHoverCloseButton,
                    href: href,
                    before: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40nZT.default), {
                        elemBefore: elemBefore
                    }),
                    contentElement: content,
                    after: removeButton,
                    className: (0, $hcewu.default)([
                        status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqht1nip"
                    ])
                });
            }
        })
    });
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $7bf2340f5bdb4d38$var$RemovableTag = /*#__PURE__*/ (0, $eJOHy.memo)($7bf2340f5bdb4d38$var$RemovableTagComponent);
var $7bf2340f5bdb4d38$export$2e2bcd8739ae039 = $7bf2340f5bdb4d38$var$RemovableTag;

});
parcelRegister("lncqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $10f384baaa61acd2$export$2e2bcd8739ae039);

var $34ZNB = parcelRequire("34ZNB");

var $gcrIE = parcelRequire("gcrIE");

var $grWPV = parcelRequire("grWPV");

var $5mfrv = parcelRequire("5mfrv");

var $Ys7jv = parcelRequire("Ys7jv");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $10f384baaa61acd2$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $grWPV.useElementRef)();
    const exiting = (0, $Ys7jv.useExitingPersistence)();
    const requestAnimationFrame = (0, $gcrIE.useRequestAnimationFrame)();
    const setTimeout = (0, $gcrIE.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $5mfrv.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $34ZNB.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $34ZNB.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $10f384baaa61acd2$export$2e2bcd8739ae039 = $10f384baaa61acd2$var$ShrinkOut;

});
parcelRegister("grWPV", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $d3a4ee4e08936b24$export$ff879f35a69d56b7);

var $eJOHy = parcelRequire("eJOHy");
const $d3a4ee4e08936b24$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $eJOHy.useRef)(null);
    const setRef = (0, $eJOHy.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("5itvH", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $4a01ae90fd3660b9$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $4a01ae90fd3660b9$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $4a01ae90fd3660b9$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $4a01ae90fd3660b9$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $4a01ae90fd3660b9$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $4a01ae90fd3660b9$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $4a01ae90fd3660b9$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $4a01ae90fd3660b9$export$2a31dbe82788f940);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $4a01ae90fd3660b9$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $4a01ae90fd3660b9$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $4a01ae90fd3660b9$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $4a01ae90fd3660b9$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $4a01ae90fd3660b9$export$b03fbc2a369c563e);
// Text colors
const $4a01ae90fd3660b9$export$daa0ace263cb20d2 = {
    standard: "var(--ds-text, #253858)",
    standardLink: "var(--ds-link, #0052CC)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $4a01ae90fd3660b9$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $4a01ae90fd3660b9$export$7c7104a5f052cab7 = {
    standard: "var(--ds-link, #0065FF)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $4a01ae90fd3660b9$export$382469baad253eb7 = {
    standard: "var(--ds-link-pressed, #0065FF)",
    blue: "var(--ds-text-accent-blue, #172B4D)",
    red: "var(--ds-text-accent-red, #172B4D)",
    yellow: "var(--ds-text-accent-yellow, #172B4D)",
    green: "var(--ds-text-accent-green, #172B4D)",
    teal: "var(--ds-text-accent-teal, #172B4D)",
    purple: "var(--ds-text-accent-purple, #172B4D)",
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: "var(--ds-text-accent-gray, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue-bolder, #0747A6)",
    redLight: "var(--ds-text-accent-red-bolder, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow-bolder, #42526E)",
    greenLight: "var(--ds-text-accent-green-bolder, #006644)",
    tealLight: "var(--ds-text-accent-teal-bolder, #42526E)",
    purpleLight: "var(--ds-text-accent-purple-bolder, #403294)",
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: "var(--ds-text-accent-gray-bolder, #42526E)"
};
const $4a01ae90fd3660b9$export$b9d7c59a579c23c6 = {
    standard: "var(--ds-background-neutral, #F4F5F7)",
    blue: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    red: "var(--ds-background-accent-red-subtle, #FF8F73)",
    yellow: "var(--ds-background-accent-yellow-subtle, #FFC400)",
    green: "var(--ds-background-accent-green-subtle, #57D9A3)",
    teal: "var(--ds-background-accent-teal-subtle, #00C7E6)",
    purple: "var(--ds-background-accent-purple-subtle, #998DD9)",
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: "var(--ds-background-accent-gray-subtle, #42526E)",
    blueLight: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    redLight: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    yellowLight: "var(--ds-background-accent-yellow-subtler, #FFE380)",
    greenLight: "var(--ds-background-accent-green-subtler, #79F2C0)",
    tealLight: "var(--ds-background-accent-teal-subtler, #79E2F2)",
    purpleLight: "var(--ds-background-accent-purple-subtler, #C0B6F2)",
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: "var(--ds-background-accent-gray-subtler, #EBECF0)"
};
const $4a01ae90fd3660b9$export$4410079763249c74 = {
    standard: "var(--ds-background-neutral-hovered, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-hovered, #B3D4FF)",
    red: "var(--ds-background-accent-red-subtle-hovered, #FFBDAD)",
    yellow: "var(--ds-background-accent-yellow-subtle-hovered, #FFE380)",
    green: "var(--ds-background-accent-green-subtle-hovered, #79F2C0)",
    teal: "var(--ds-background-accent-teal-subtle-hovered, #79E2F2)",
    purple: "var(--ds-background-accent-purple-subtle-hovered, #C0B6F2)",
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: "var(--ds-background-accent-gray-subtle-hovered, #505F79)",
    blueLight: "var(--ds-background-accent-blue-subtler-hovered, #DEEBFF)",
    redLight: "var(--ds-background-accent-red-subtler-hovered, #FFEBE6)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-hovered, #FFF0B3)",
    greenLight: "var(--ds-background-accent-green-subtler-hovered, #ABF5D1)",
    tealLight: "var(--ds-background-accent-teal-subtler-hovered, #B3F5FF)",
    purpleLight: "var(--ds-background-accent-purple-subtler-hovered, #EAE6FF)",
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: "var(--ds-background-accent-gray-subtler-hovered, #DFE1E6)"
};
const $4a01ae90fd3660b9$export$76be99c5e13e3566 = {
    standard: "var(--ds-background-neutral-pressed, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-pressed, #DEEBFF)",
    red: "var(--ds-background-accent-red-subtle-pressed, #FFEBE6)",
    yellow: "var(--ds-background-accent-yellow-subtle-pressed, #FFF0B3)",
    green: "var(--ds-background-accent-green-subtle-pressed, #ABF5D1)",
    teal: "var(--ds-background-accent-teal-subtle-pressed, #B3F5FF)",
    purple: "var(--ds-background-accent-purple-subtle-pressed, #EAE6FF)",
    grey: "var(--ds-background-accent-gray-subtle-pressed, #5E6C84)",
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: "var(--ds-background-accent-blue-subtler-pressed, #4C9AFF)",
    redLight: "var(--ds-background-accent-red-subtler-pressed, #FF8F73)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-pressed, #FFC400)",
    greenLight: "var(--ds-background-accent-green-subtler-pressed, #57D9A3)",
    tealLight: "var(--ds-background-accent-teal-subtler-pressed, #00C7E6)",
    purpleLight: "var(--ds-background-accent-purple-subtler-pressed, #998DD9)",
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: "var(--ds-background-accent-gray-subtler-pressed, #C1C7D0)"
};
const $4a01ae90fd3660b9$export$2a31dbe82788f940 = "var(--ds-border-focused, #4C9AFF)";
const $4a01ae90fd3660b9$export$1202b7eb21da7b58 = "var(--ds-background-danger, #FFEBE6)";
const $4a01ae90fd3660b9$export$62ace793ebb16bda = "var(--ds-background-danger-hovered, #FFEBE6)";
const $4a01ae90fd3660b9$export$17d206ccea111bbb = "var(--ds-text-danger, #BF2600)";
const $4a01ae90fd3660b9$export$f64c7641cbc22da7 = {
    standard: "var(--ds-text, #42526E)",
    blue: "var(--ds-text-accent-blue-bolder, #42526E)",
    red: "var(--ds-text-accent-red-bolder, #42526E)",
    yellow: "var(--ds-text-accent-yellow-bolder, #42526E)",
    green: "var(--ds-text-accent-green-bolder, #42526E)",
    teal: "var(--ds-text-accent-teal-bolder, #42526E)",
    purple: "var(--ds-text-accent-purple-bolder, #42526E)",
    lime: "var(--ds-text-accent-lime-bolder, #42526E)",
    magenta: "var(--ds-text-accent-magenta-bolder, #42526E)",
    orange: "var(--ds-text-accent-orange-bolder, #42526E)",
    grey: "var(--ds-text-accent-gray-bolder, #42526E)",
    blueLight: "var(--ds-text-accent-blue, #42526E)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #42526E)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #42526E)",
    limeLight: "var(--ds-text-accent-lime, #42526E)",
    magentaLight: "var(--ds-text-accent-magenta, #42526E)",
    orangeLight: "var(--ds-text-accent-orange, #42526E)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $4a01ae90fd3660b9$export$b03fbc2a369c563e = {
    standard: "var(--ds-text-danger, #253858)",
    standardLink: "var(--ds-text-danger, #0052CC)",
    blue: "var(--ds-text-danger, #172B4D)",
    red: "var(--ds-text-danger, #172B4D)",
    yellow: "var(--ds-text-danger, #172B4D)",
    green: "var(--ds-text-danger, #172B4D)",
    teal: "var(--ds-text-danger, #172B4D)",
    purple: "var(--ds-text-danger, #172B4D)",
    lime: "var(--ds-text-danger, #172B4D)",
    magenta: "var(--ds-text-danger, #172B4D)",
    orange: "var(--ds-text-danger, #172B4D)",
    grey: "var(--ds-text-danger, #FFFFFF)",
    blueLight: "var(--ds-text-danger, #0747A6)",
    redLight: "var(--ds-text-danger, #42526E)",
    yellowLight: "var(--ds-text-danger, #42526E)",
    greenLight: "var(--ds-text-danger, #006644)",
    tealLight: "var(--ds-text-danger, #42526E)",
    purpleLight: "var(--ds-text-danger, #403294)",
    limeLight: "var(--ds-text-danger, #403294)",
    magentaLight: "var(--ds-text-danger, #403294)",
    orangeLight: "var(--ds-text-danger, #403294)",
    greyLight: "var(--ds-text-danger, #42526E)"
};

});

parcelRegister("1fStw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb40a4175fb93ea9$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5itvH = parcelRequire("5itvH");
const $eb40a4175fb93ea9$var$borderColorCssVar = '--ds-bc';
const $eb40a4175fb93ea9$var$focusRingCssVar = '--ds-cfr';
const $eb40a4175fb93ea9$var$textLinkCssVar = '--ds-ctl';
const $eb40a4175fb93ea9$var$textDefaultCssVar = '--ds-ct';
const $eb40a4175fb93ea9$var$textHoverCssVar = '--ds-cth';
const $eb40a4175fb93ea9$var$textActiveCssVar = '--ds-ctp';
const $eb40a4175fb93ea9$var$backgroundDefaultCssVar = '--ds-cb';
const $eb40a4175fb93ea9$var$backgroundHoverCssVar = '--ds-cbh';
const $eb40a4175fb93ea9$var$backgroundActiveCssVar = '--ds-cba';
const $eb40a4175fb93ea9$var$removeButtonDefaultCssVar = '--ds-rb';
const $eb40a4175fb93ea9$var$removeButtonHoverCssVar = '--ds-rbh';
const $eb40a4175fb93ea9$var$borderRadiusCssVar = '--ds-br';
// To be removed with platform-component-visual-refresh (BLU-2992)
const $eb40a4175fb93ea9$var$baseStylesOld = null;
const $eb40a4175fb93ea9$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $eb40a4175fb93ea9$var$interactiveStylesOld = null;
const $eb40a4175fb93ea9$var$interactiveStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $eb40a4175fb93ea9$var$focusRingStylesOld = null;
const $eb40a4175fb93ea9$var$focusRingStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $eb40a4175fb93ea9$var$nonStandardLinkStyles = null;
const $eb40a4175fb93ea9$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? (0, $5itvH.textColors)['standardLink'] : (0, $5itvH.textColors)[color];
    const backgroundHoverColors = isRemovable && !isLink ? (0, $5itvH.backgroundColors)[color] : (0, $5itvH.linkHoverBackgroundColors)[color];
    const backgroundActiveColors = isRemovable && !isLink ? (0, $5itvH.backgroundColors)[color] : (0, $5itvH.linkActiveBackgroundColors)[color];
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // NOTE: The vast majority of these styles have zero purpose to be runtime computed
            // This can all be migrated to statically distributed atomic CSS with Compiled in the future
            // The main reason for not touching this is there is to avoid excessive changes in the same PR on non-visual-refresh code
            /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ [$eb40a4175fb93ea9$var$borderColorCssVar]: (0, $5itvH.borderColors)[color],
            [$eb40a4175fb93ea9$var$textDefaultCssVar]: (0, $5itvH.textColors)[color],
            [$eb40a4175fb93ea9$var$textHoverCssVar]: (0, $5itvH.textHoverColors)[color],
            [$eb40a4175fb93ea9$var$textActiveCssVar]: (0, $5itvH.textActiveColors)[color],
            [$eb40a4175fb93ea9$var$textLinkCssVar]: textLinkColors,
            [$eb40a4175fb93ea9$var$backgroundDefaultCssVar]: (0, $5itvH.backgroundColors)[color],
            [$eb40a4175fb93ea9$var$backgroundHoverCssVar]: backgroundHoverColors,
            [$eb40a4175fb93ea9$var$backgroundActiveCssVar]: backgroundActiveColors,
            [$eb40a4175fb93ea9$var$focusRingCssVar]: (0, $5itvH.focusRingColors),
            [$eb40a4175fb93ea9$var$removeButtonDefaultCssVar]: (0, $5itvH.removeButtonColors)[color],
            [$eb40a4175fb93ea9$var$removeButtonHoverCssVar]: (0, $5itvH.removeButtonHoverColors)[color],
            [$eb40a4175fb93ea9$var$borderRadiusCssVar]: appearance === 'rounded' ? '10px' : '3px',
            /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_zulp1b66 _2rko1sit _1h6d2fso _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhk1w7a _syaz1fxt _80om73ad" : "_2rko1l5z _1mou1b66 _195g1b66 _1rjcze3t _18zrze3t _1e0c116y _1ul9idpf _4t3iv47k _kqswh2mm _bfhklsll _syaz148y _80om73ad",
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_1e38ugt7 _7glxv77o" : "_1guj1r31 _pbhaglyw _11ow1o36 _1u6lnr64",
            isLink && (0, $eGOwo.fg)('platform-component-visual-refresh') && "_irr3166n _1di61dty",
            !(0, $eGOwo.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && "_9h8h1348",
            !(0, $eGOwo.fg)('platform-component-visual-refresh') && isInteractive && "_irr31lyj _1di6oo20",
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eb40a4175fb93ea9$export$2e2bcd8739ae039 = $eb40a4175fb93ea9$var$BaseTag;

});

parcelRegister("40nZT", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae242ab93c29e38$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
const $dae242ab93c29e38$var$beforeElementStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $dae242ab93c29e38$var$beforeElementStylesOld = null;
const $dae242ab93c29e38$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t" : "_2rko1l5z _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dae242ab93c29e38$export$2e2bcd8739ae039 = $dae242ab93c29e38$var$Before;

});

parcelRegister("6UE2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d73caba6a9e3a1c$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
// To be removed with platform-component-visual-refresh (BLU-2992)
const $6d73caba6a9e3a1c$var$baseStylesOld = null;
const $6d73caba6a9e3a1c$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $6d73caba6a9e3a1c$var$linkStylesOld = null;
const $6d73caba6a9e3a1c$var$linkStyles = null;
const $6d73caba6a9e3a1c$var$hasAfterStylesOld = null;
const $6d73caba6a9e3a1c$var$hasAfterStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $6d73caba6a9e3a1c$var$hasBeforeStyles = null;
const $6d73caba6a9e3a1c$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $gt9Am.jsx)(Link, {
        href: href,
        "data-color": color,
        className: (0, $hcewu.default)([
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt" : "_4bfu18uv _1hmsglyw _ajmmnqa1 _syazs5nr _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l3117u _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1348",
            !(0, $eGOwo.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $eGOwo.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $eGOwo.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            !(0, $eGOwo.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $eGOwo.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $eGOwo.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6d73caba6a9e3a1c$export$2e2bcd8739ae039 = $6d73caba6a9e3a1c$var$Content;

});

parcelRegister("h89xH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebeaa36c6c332ef4$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $82pO9 = parcelRequire("82pO9");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");
const $ebeaa36c6c332ef4$var$removeButtonStyles = {
    root: "_19itglyw _2rkogqwt _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _1bsb7vkz _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syaz1fxt _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah31i6y _irr3166n _1di61dty"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $ebeaa36c6c332ef4$var$removeButtonStylesOld = {
    root: "_19itglyw _2rko1l5z _18zrze3t _1rjcze3t _1e0c1txw _4t3i7vkz _ahbqze3t _12l2ze3t _1pfhze3t _6rthze3t _kqswstnw _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhk1w7a _syaz1bah _80omtlke _lcxv1wug _1ah3ze3t _30l31eu2"
};
const $ebeaa36c6c332ef4$var$removeButtonStylesOldIcon = {
    root: "_rjxpze3t"
};
const $ebeaa36c6c332ef4$var$removeButtonStylesNewIcon = {
    root: "_rjxpv77o"
};
const $ebeaa36c6c332ef4$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: (0, $6qaBj.cx)(// TODO: When cleaning up all these feature gates, they should just be converged into a single `styles` object.
        (0, $eGOwo.fg)('platform-component-visual-refresh') && $ebeaa36c6c332ef4$var$removeButtonStyles.root, !(0, $eGOwo.fg)('platform-component-visual-refresh') && $ebeaa36c6c332ef4$var$removeButtonStylesOld.root, $ebeaa36c6c332ef4$var$removeButtonStylesOldIcon.root, (0, $eGOwo.fg)('platform-visual-refresh-icons') && $ebeaa36c6c332ef4$var$removeButtonStylesNewIcon.root),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($82pO9))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "small",
            size: "small"
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ebeaa36c6c332ef4$export$2e2bcd8739ae039 = $ebeaa36c6c332ef4$var$RemoveButton;

});
parcelRegister("82pO9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a8221850e05ac929fb26618da6db4acc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5da2878f9cf22fc5$var$_react = $5da2878f9cf22fc5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5da2878f9cf22fc5$var$_close = $5da2878f9cf22fc5$var$_interopRequireDefault((parcelRequire("l0U1U")));

var $5da2878f9cf22fc5$var$_close2 = $5da2878f9cf22fc5$var$_interopRequireDefault((parcelRequire("6OLN4")));
function $5da2878f9cf22fc5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5da2878f9cf22fc5$var$CloseIcon = (props)=>/*#__PURE__*/ $5da2878f9cf22fc5$var$_react.default.createElement($5da2878f9cf22fc5$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $5da2878f9cf22fc5$var$_close2.default
    }, props));
$5da2878f9cf22fc5$var$CloseIcon.Name = 'CloseIconMigration';
var $5da2878f9cf22fc5$var$_default = module.exports.default = $5da2878f9cf22fc5$var$CloseIcon;

});
parcelRegister("6OLN4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f6c7bc606f2d15e$var$_react = $4f6c7bc606f2d15e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $4f6c7bc606f2d15e$var$_cross = $4f6c7bc606f2d15e$var$_interopRequireDefault((parcelRequire("6zhpo")));
function $4f6c7bc606f2d15e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6c7bc606f2d15e$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $4f6c7bc606f2d15e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $4f6c7bc606f2d15e$var$_cross.default
    }));
$4f6c7bc606f2d15e$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $4f6c7bc606f2d15e$var$_default = module.exports.default = $4f6c7bc606f2d15e$var$EditorCloseIcon;

});




parcelRegister("9ewtR", function(module, exports) {

$parcel$export(module.exports, "default", () => $07b7decad61e4cb4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $07b7decad61e4cb4$var$baseStyles = null;
const $07b7decad61e4cb4$var$justifyStartStyles = null;
const $07b7decad61e4cb4$var$justifyEndStyles = null;
/**
 * __Tag group__
 *
 * A tag group controls the layout and alignment for a collection of tags.
 *
 * - [Examples](https://atlassian.design/components/tag-group/examples)
 * - [Code](https://atlassian.design/components/tag-group/code)
 * - [Usage](https://atlassian.design/components/tag-group/usage)
 */ const $07b7decad61e4cb4$var$TagGroup = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            alignment === 'start' && "_1bah1y6m",
            alignment === 'end' && "_1bahesu3"
        ]),
        children: children
    });
});
var $07b7decad61e4cb4$export$2e2bcd8739ae039 = $07b7decad61e4cb4$var$TagGroup;

});

parcelRegister("iyBBa", function(module, exports) {

$parcel$export(module.exports, "ColoredTag", () => $edbc1f1c5365a1cc$export$526384205b143b58);

var $eJOHy = parcelRequire("eJOHy");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $051tO = parcelRequire("051tO");

var $aCFLd = parcelRequire("aCFLd");
const $edbc1f1c5365a1cc$export$526384205b143b58 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ labelName: labelName, href: href, actionSubjectId: actionSubjectId, pressableXcss: pressableXcss, contentXcss: contentXcss, analyticsAttributes: analyticsAttributes, color: color, ...restProps }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { backgroundColor: borderColor } = (0, $051tO.getColorMetadata)((0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(labelName));
    const isPressable = (0, $7jTnu.fg)('colored_tag_pressable_by_href') ? !!href : true;
    const onHandleClick = (0, $eJOHy.useCallback)(()=>{
        if (href) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.href = href;
        if (actionSubjectId) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            attributes: analyticsAttributes
        }), actionSubjectId);
    }, [
        actionSubjectId,
        createAnalyticsEvent,
        href,
        analyticsAttributes
    ]);
    const onHandleClickForAnchor = (0, $eJOHy.useCallback)(()=>{
        if (actionSubjectId) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            attributes: analyticsAttributes
        }), actionSubjectId);
    }, [
        actionSubjectId,
        createAnalyticsEvent,
        analyticsAttributes
    ]);
    if (href && (0, $7jTnu.fg)('replacing_pressable_by_anchor_for_colored_tag')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        xcss: [
            $edbc1f1c5365a1cc$var$tagStyles,
            $edbc1f1c5365a1cc$var$hoverStyles,
            $edbc1f1c5365a1cc$var$anchorTextStyles,
            ...pressableXcss ? [
                pressableXcss
            ] : []
        ],
        href: href,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: color || borderColor
        },
        onClick: onHandleClickForAnchor,
        ...restProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $edbc1f1c5365a1cc$var$tagTextStyles,
            ...contentXcss ? [
                contentXcss
            ] : []
        ]
    }, labelName));
    return isPressable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ref: ref,
        xcss: [
            $edbc1f1c5365a1cc$var$tagStyles,
            $edbc1f1c5365a1cc$var$hoverStyles,
            ...pressableXcss ? [
                pressableXcss
            ] : []
        ],
        onClick: onHandleClick,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: color || borderColor
        },
        ...restProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $edbc1f1c5365a1cc$var$tagTextStyles,
            ...contentXcss ? [
                contentXcss
            ] : []
        ]
    }, labelName)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: ref,
        xcss: [
            $edbc1f1c5365a1cc$var$tagStyles,
            $edbc1f1c5365a1cc$var$tagTextStyles,
            ...contentXcss ? [
                contentXcss
            ] : []
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: color || borderColor
        }
    }, labelName);
});
const $edbc1f1c5365a1cc$var$tagStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    backgroundColor: 'color.background.neutral.subtle',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    paddingInline: 'space.050',
    paddingBlock: '0',
    font: 'font.body',
    marginBlock: 'space.050',
    marginInline: 'space.050',
    height: '20px',
    alignItems: 'center',
    maxWidth: '100%'
});
const $edbc1f1c5365a1cc$var$hoverStyles = (0, $1DXK0.xcss)({
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered',
        textDecoration: 'underline'
    }
});
const $edbc1f1c5365a1cc$var$tagTextStyles = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '180px'
});
const $edbc1f1c5365a1cc$var$anchorTextStyles = (0, $1DXK0.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    ':hover': {
        color: 'color.text'
    }
});

});

parcelRegister("bbJY3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5f61025620e2ca0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c5f61025620e2ca0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    none: {
        "id": "issue-table.common.fields.common.tags.none",
        "defaultMessage": "None"
    }
});

});



parcelRegister("59u8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $97ebedcc345a823d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $igb4v = parcelRequire("igb4v");

var $8LW0P = parcelRequire("8LW0P");
const $97ebedcc345a823d$var$MajorIncident = ({ dataSelectorProps: { value: value } })=>value === (0, $igb4v.MAJOR_INCIDENT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8LW0P.MajorIncidentLozenge), null) : null;
var $97ebedcc345a823d$export$2e2bcd8739ae039 = $97ebedcc345a823d$var$MajorIncident;

});
parcelRegister("igb4v", function(module, exports) {

$parcel$export(module.exports, "MAJOR_INCIDENT", () => $fdf0435cb4f074e5$export$f5d2c3c7bebeaa98);
$parcel$export(module.exports, "SPOTLIGHT_ID", () => $fdf0435cb4f074e5$export$1222b4ae9a94b9ec);

var $avBqB = parcelRequire("avBqB");
const $fdf0435cb4f074e5$export$f5d2c3c7bebeaa98 = 'MAJOR_INCIDENT';
const $fdf0435cb4f074e5$var$MAJOR_INCIDENT_FIELD_KEY = 'major-incident-field';
const $fdf0435cb4f074e5$export$1222b4ae9a94b9ec = `${(0, $avBqB.ISSUE_FIELD_SPOTLIGHT_PREFIX)}${$fdf0435cb4f074e5$var$MAJOR_INCIDENT_FIELD_KEY}`;

});
parcelRegister("avBqB", function(module, exports) {

$parcel$export(module.exports, "BOARD_SIDEBAR", () => $cba7991bf5f8bff2$export$d84e7970e2d564af);
$parcel$export(module.exports, "EDIT_FIELD", () => $cba7991bf5f8bff2$export$256eddbefbf4b2ce);
$parcel$export(module.exports, "GIVE_FEEDBACK", () => $cba7991bf5f8bff2$export$3c1bb52064935485);
$parcel$export(module.exports, "STATUS_AND_APPROVAL_SPOTLIGHT", () => $cba7991bf5f8bff2$export$988f0f6f6457039a);
$parcel$export(module.exports, "STATUS_SPOTLIGHT", () => $cba7991bf5f8bff2$export$b11eec52127ca1f1);
$parcel$export(module.exports, "ISSUE_FIELD_SPOTLIGHT_PREFIX", () => $cba7991bf5f8bff2$export$2028cf1423b28cf8);
const $cba7991bf5f8bff2$export$d84e7970e2d564af = 'BOARD_SIDEBAR';
const $cba7991bf5f8bff2$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $cba7991bf5f8bff2$export$3c1bb52064935485 = 'GIVE_FEEDBACK';
const $cba7991bf5f8bff2$export$95f98990d7202b31 = 'SHOW_MORE';
const $cba7991bf5f8bff2$export$988f0f6f6457039a = 'status-and-approval-spotlight';
const $cba7991bf5f8bff2$export$b11eec52127ca1f1 = 'status-spotlight';
const $cba7991bf5f8bff2$export$e5820f3349d3bcf0 = 'reporter-spotlight';
const $cba7991bf5f8bff2$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $cba7991bf5f8bff2$export$43c3daf5ccfeb2da = {
    ASSIGNEE: {
        TIME_TO_RENDER_INITIAL_SUGGESTIONS: 'jira.fe.issue.fields.assignee.time-to.render-initial-suggestions',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.assignee.time-to.reflect-input-results',
        TIME_TO_REFLECT_SELECTED: 'jira.fe.issue.fields.assignee.time-to.reflect-selected',
        TIME_TO_ASSIGN_TO_ME_VIA_SHORTCUT: 'jira.fe.issue.fields.assignee.time-to.assign-to-me-via-shortcut'
    },
    SUMMARY: {
        TIME_TO_RENDER_EDIT_VIEW: 'jira.fe.issue.field.summary.time-to.render-edit-view',
        TIME_TO_RENDER_READ_VIEW_ON_CONFIRM: 'jira.fe.issue.field.summary.time-to.render-read-view-on-confirm',
        TIME_TO_RENDER_READ_VIEW_ON_CANCEL: 'jira.fe.issue.field.summary.time-to.render-read-view-on-cancel'
    },
    LABELS: {
        TIME_TO_RENDER_INITIAL_SUGGESTIONS: 'jira.fe.issue.fields.labels.time-to.render-initial-suggestions',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.labels.time-to.reflect-input-results',
        TIME_TO_RENDER_READ_VIEW_ON_CONFIRM: 'jira.fe.issue.field.labels.time-to.render-read-view-on-confirm',
        TIME_TO_RENDER_READ_VIEW_ON_CANCEL: 'jira.fe.issue.field.labels.time-to.render-read-view-on-cancel',
        TIME_TO_REFLECT_SELECTED_EXISTING: 'jira.fe.issue.fields.labels.time-to.reflect-selected-existing',
        TIME_TO_REFLECT_SELECTED_NEW: 'jira.fe.issue.fields.labels.time-to.reflect-selected-new',
        TIME_TO_REFLECT_REMOVED_EXISTING: 'jira.fe.issue.fields.labels.time-to.reflect-removed-existing'
    },
    STORY_POINTS: {
        TIME_TO_RENDER_EDIT_VIEW: 'jira.fe.issue.field.story-points.time-to.render-edit-view',
        TIME_TO_RENDER_READ_VIEW_ON_CONFIRM: 'jira.fe.issue.field.story-points.time-to.render-read-view-on-confirm',
        TIME_TO_RENDER_READ_VIEW_ON_CANCEL: 'jira.fe.issue.field.story-points.time-to.render-read-view-on-cancel'
    },
    ISSUE_LINKS: {
        TIME_TO_REFLECT_SELECTED_ISSUE: 'jira.fe.issue.fields.issue-links.time-to.reflect-selected-issue',
        TIME_TO_REFLECT_REMOVED_ISSUE: 'jira.fe.issue.fields.issue-links.time-to.reflect-removed-issue',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.issue-links.time-to.reflect-input-results',
        TIME_TO_RENDER_LINKED_ISSUE: 'jira.fe.issue.fields.issue-links.time-to.render-linked-issue',
        TIME_TO_RENDER_NEW_LINKED_ISSUE_INPUT: 'jira.fe.issue.fields.issue-links.time-to.render-new-linked-issue-input'
    },
    SPRINT: {
        TIME_TO_REFLECT_SELECTED_SPRINT: 'jira.fe.issue.fields.sprint.time-to.reflect-selected-sprint',
        TIME_TO_REFLECT_REMOVED_SPRINT: 'jira.fe.issue.fields.sprint.time-to.reflect-removed-sprint',
        TIME_TO_REFLECT_INPUT_RESULT: 'jira.fe.issue.fields.sprint.time-to.reflect-input-results',
        TIME_TO_RENDER_READ_VIEW: 'jira.fe.issue.fields.sprint.time-to.render-read-view',
        TIME_TO_RENDER_INITIAL_SUGGESTIONS: 'jira.fe.issue.fields.sprint.time-to.render-initial-suggestions'
    },
    PRIORITY: {
        TIME_TO_RENDER_READ_VIEW: 'jira.fe.issue.fields.priority.time-to.render-read-view',
        TIME_TO_RENDER_SUGGESTIONS: 'jira.fe.issue.fields.priority.time-to.render-suggestions',
        TIME_TO_REFLECT_PRIORITY_UPDATE: 'jira.fe.issue.fields.priority.time-to.reflect-priority-update'
    },
    COMMENTS: {
        TIME_TO_RENDER_NEW_COMMENT_EDITOR: 'jira.fe.issue.fields.comments.time-to.render-new-comment-editor',
        TIME_TO_RENDER_SAVED_COMMENT: 'jira.fe.issue.fields.comments.time-to.render-saved-comment'
    },
    DESCRIPTION: {
        TIME_TO_RENDER_EDIT_VIEW: 'jira.fe.issue.field.description.time-to.render-edit-view',
        TIME_TO_SAVE_UPDATED_DESCRIPTION: 'jira.fe.issue.field.description.time-to.save-updated-description',
        TIME_TO_SAVE_UNCHANGED_DESCRIPTION: 'jira.fe.issue.field.description.time-to.save-unchanged-description'
    },
    EPIC_LINKS: {
        TIME_TO_FETCH_INPUT_RESULTS_EPIC_PICKER_ENABLED: 'jira.fe.issue.fields.epic-link.time-to.fetch-input-results.epic-picker-enabled',
        TIME_TO_FETCH_INPUT_RESULTS_EPIC_PICKER_DISABLED: 'jira.fe.issue.fields.epic-link.time-to.fetch-input-results.epic-picker-disabled'
    }
};

});


parcelRegister("8LW0P", function(module, exports) {

$parcel$export(module.exports, "MajorIncidentLozenge", () => $0be7ec5f048b4c0a$export$d005b05e81381a5a);
$parcel$export(module.exports, "MajorIncidentLozengeWithTooltip", () => $0be7ec5f048b4c0a$export$1f7421f79cdd882a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jdqdp = parcelRequire("jdqdp");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $bmoS1 = parcelRequire("bmoS1");

var $aMZVu = parcelRequire("aMZVu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $4ShP4 = parcelRequire("4ShP4");

var $kEUB1 = parcelRequire("kEUB1");

var $igb4v = parcelRequire("igb4v");

var $gZc2u = parcelRequire("gZc2u");

var $a1Bfa = parcelRequire("a1Bfa");
const $0be7ec5f048b4c0a$export$d005b05e81381a5a = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "removed"
    }, formatMessage((0, $a1Bfa.default).lozengeLabel));
};
const $0be7ec5f048b4c0a$export$1f7421f79cdd882a = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isEntitled: isMIMEntitled } = (0, $4ShP4.useJsmMimEntitlementResource)((0, $kEUB1.useCloudId)());
    const issueKey = (0, $bmoS1.useIssueKey)();
    const [{ value: value }] = (0, $gZc2u.useMajorIncidentField)({
        issueKey: issueKey
    });
    const isIssueOfIncidentsPractice = (0, $aMZVu.useIsIssueOfIncidentsPractice)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const shouldRenderLozenge = isMIMEntitled && isIssueOfIncidentsPractice && value === (0, $igb4v.MAJOR_INCIDENT);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldRenderLozenge) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'majorIncidentLozenge viewed', {
            action: 'viewed',
            actionSubjectId: 'majorIncidentLozenge',
            teamName: 'jsm-getting-started'
        });
    }, [
        createAnalyticsEvent,
        shouldRenderLozenge
    ]);
    return shouldRenderLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0be7ec5f048b4c0a$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $a1Bfa.default).tootltipContent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0be7ec5f048b4c0a$export$d005b05e81381a5a, null))) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0be7ec5f048b4c0a$var$LozengeWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bmoS1", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $7e10397d24adf8a0$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $7e10397d24adf8a0$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $7e10397d24adf8a0$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $7e10397d24adf8a0$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $7e10397d24adf8a0$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $7e10397d24adf8a0$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $7e10397d24adf8a0$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $7e10397d24adf8a0$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $7e10397d24adf8a0$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $7e10397d24adf8a0$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $7e10397d24adf8a0$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $7e10397d24adf8a0$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $7e10397d24adf8a0$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "usePreviousViewMode", () => $7e10397d24adf8a0$export$b4140dbbd0965fe4);
$parcel$export(module.exports, "useIsViewModeFullScreenModal", () => $7e10397d24adf8a0$export$ebf6e1e7912e65c3);
$parcel$export(module.exports, "useBackButtonUrl", () => $7e10397d24adf8a0$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $7e10397d24adf8a0$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $7e10397d24adf8a0$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $7e10397d24adf8a0$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $7e10397d24adf8a0$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $7e10397d24adf8a0$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $7e10397d24adf8a0$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $7e10397d24adf8a0$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiEnabledForIssue", () => $7e10397d24adf8a0$export$db5174c7538abe4b);
$parcel$export(module.exports, "useIsJiraIssue", () => $7e10397d24adf8a0$export$cf5fc815f761fb4b);

var $eJOHy = parcelRequire("eJOHy");


var $ln6Iy = parcelRequire("ln6Iy");

var $aYncF = parcelRequire("aYncF");

var $bNexr = parcelRequire("bNexr");

var $ljej9 = parcelRequire("ljej9");

var $hmtVp = parcelRequire("hmtVp");

var $8wUZn = parcelRequire("8wUZn");

var $b9nqM = parcelRequire("b9nqM");

var $U4tkh = parcelRequire("U4tkh");
const $7e10397d24adf8a0$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $U4tkh.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $7e10397d24adf8a0$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $U4tkh.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $7e10397d24adf8a0$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $7e10397d24adf8a0$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $7e10397d24adf8a0$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $U4tkh.useIssueContextStoreIsModal)();
    return isModal;
};
const $7e10397d24adf8a0$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $U4tkh.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $7e10397d24adf8a0$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $U4tkh.useIssueContextStoreIssueId)();
    return issueId;
};
const $7e10397d24adf8a0$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $U4tkh.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $7e10397d24adf8a0$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $U4tkh.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $7e10397d24adf8a0$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $U4tkh.useIssueContextStoreIssueKey)();
    return (0, $ljej9.toProjectKey)(issueKey.split('-')[0]);
};
const $7e10397d24adf8a0$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $U4tkh.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $7e10397d24adf8a0$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsFullScreenModal: setDetailViewAsFullScreenModal, setDetailViewAsCollapsedModal: setDetailViewAsCollapsedModal, resetDetailView: resetDetailView }] = (0, $U4tkh.useIssueContextStoreActions)() || [
        null,
        {}
    ];
    const actions = (0, $eJOHy.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            setDetailViewAsFullScreenModal: setDetailViewAsFullScreenModal,
            setDetailViewAsCollapsedModal: setDetailViewAsCollapsedModal,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        setDetailViewAsFullScreenModal,
        setDetailViewAsCollapsedModal,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $7e10397d24adf8a0$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $U4tkh.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $7e10397d24adf8a0$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $U4tkh.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $7e10397d24adf8a0$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $U4tkh.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $7e10397d24adf8a0$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $U4tkh.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $7e10397d24adf8a0$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $U4tkh.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $7e10397d24adf8a0$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $U4tkh.useIssueContextStoreViewMode)();
    return viewMode;
};
const $7e10397d24adf8a0$export$b4140dbbd0965fe4 = ()=>{
    const [previousViewMode] = (0, $U4tkh.useIssueContextStorePreviousViewMode)();
    return previousViewMode;
};
const $7e10397d24adf8a0$export$ebf6e1e7912e65c3 = ()=>{
    const [viewMode] = (0, $U4tkh.useIssueContextStoreViewMode)();
    const [isViewModeFullScreenModal] = (0, $U4tkh.useIssueContextStoreIsViewModeFullScreenModal)();
    return isViewModeFullScreenModal && viewMode === 'MODAL';
};
const $7e10397d24adf8a0$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $U4tkh.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $7e10397d24adf8a0$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $U4tkh.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $7e10397d24adf8a0$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $U4tkh.useIssueContextStoreBoardId)();
    return boardId;
};
const $7e10397d24adf8a0$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $U4tkh.useIssueContextStoreBoardType)();
    return boardType;
};
const $7e10397d24adf8a0$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $U4tkh.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $7e10397d24adf8a0$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $U4tkh.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $7e10397d24adf8a0$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $U4tkh.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $7e10397d24adf8a0$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $U4tkh.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $7e10397d24adf8a0$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $U4tkh.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $7e10397d24adf8a0$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const licenseStates = (0, $8wUZn.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $hmtVp.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $7e10397d24adf8a0$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $7e10397d24adf8a0$export$aad3917152559b87();
    return analyticsSource === (0, $d851676a1c983028$export$b19f949fb9713614);
};
const $7e10397d24adf8a0$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $7e10397d24adf8a0$export$aad3917152559b87();
    return analyticsSource === (0, $d851676a1c983028$export$a5132300c5214280);
};
const $7e10397d24adf8a0$export$db5174c7538abe4b = ()=>{
    const [isAiEnabledForIssue] = (0, $U4tkh.useIssueContextIsAiEnabledForIssue)();
    return isAiEnabledForIssue;
};
const $7e10397d24adf8a0$export$cf5fc815f761fb4b = ()=>{
    const issueKey = $7e10397d24adf8a0$export$22108eca27445997();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    return [
        (0, $ln6Iy.SOFTWARE_PROJECT),
        (0, $ln6Iy.CORE_PROJECT)
    ].some((type)=>type === projectType);
};

});
const $d851676a1c983028$export$53d41ff2666118e1 = 'agility-backlog';
const $d851676a1c983028$export$7552fe2669628499 = 'bitbucket-issue';
const $d851676a1c983028$export$41a718da0a8636f4 = 'connect-issue';
const $d851676a1c983028$export$cebf0bc8b2ccaf57 = 'core-issue';
const $d851676a1c983028$export$5e91e17726e54450 = 'jiraCalendar';
const $d851676a1c983028$export$2dac1950892123f5 = 'jiraTimeline';
const $d851676a1c983028$export$82540942fb014b0a = 'business-calendar';
const $d851676a1c983028$export$7ca28938a07e0c33 = 'business-list';
const $d851676a1c983028$export$f6cf06aaaeb58a54 = 'business-timeline';
const $d851676a1c983028$export$b2c0462ff17aa26e = 'business-board';
const $d851676a1c983028$export$a607850ebccd28ac = 'business-approvals';
const $d851676a1c983028$export$1da6cede3561048f = 'business-files';
const $d851676a1c983028$export$b19f949fb9713614 = 'full-issue';
const $d851676a1c983028$export$a5132300c5214280 = 'embed-issue';
const $d851676a1c983028$export$710114090a811b37 = 'global-issue-navigator-issue';
const $d851676a1c983028$export$ce88447986394f2d = 'mobile-issue';
const $d851676a1c983028$export$6a90d9196d330040 = 'project-issue-navigator';
const $d851676a1c983028$export$2247c9059c171db1 = 'roadmap-issue';
const $d851676a1c983028$export$cd16d39c55c569d0 = 'simple-software-board';
const $d851676a1c983028$export$f72626bf0d75dfad = 'software-backlog-issue';
const $d851676a1c983028$export$778b4609e784cb27 = 'software-deployments-issue';
const $d851676a1c983028$export$5b73d694a6048002 = 'version-detail-issue';
const $d851676a1c983028$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $d851676a1c983028$export$21b5b7189add7861 = 'software-incidents-issue';
const $d851676a1c983028$export$9c5d81b901471b27 = 'software-issue';
const $d851676a1c983028$export$1735f6ad917dc411 = 'change-calendar';
const $d851676a1c983028$export$7063ee6d0035a982 = 'queues-issue-view';
const $d851676a1c983028$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $d851676a1c983028$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $d851676a1c983028$export$14a8072f422804fd = 'issue-navigator-next';
const $d851676a1c983028$export$5f3c20fe2ff6c0a2 = 'staffing-issue';

parcelRegister("bNexr", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $394a54b0d708bbf0$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $394a54b0d708bbf0$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $394a54b0d708bbf0$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $394a54b0d708bbf0$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $394a54b0d708bbf0$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $394a54b0d708bbf0$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $394a54b0d708bbf0$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $394a54b0d708bbf0$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $394a54b0d708bbf0$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $394a54b0d708bbf0$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $394a54b0d708bbf0$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $394a54b0d708bbf0$export$80bef597b440cf71);

var $eJOHy = parcelRequire("eJOHy");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $bRJAs = parcelRequire("bRJAs");

var $a9ldn = parcelRequire("a9ldn");

var $ljej9 = parcelRequire("ljej9");

var $lvKO5 = parcelRequire("lvKO5");

var $b8rQb = parcelRequire("b8rQb");

var $aAqmd = parcelRequire("aAqmd");
const $394a54b0d708bbf0$export$f87be37f8e8be65 = (issueKey)=>(0, $ljej9.toProjectKey)(issueKey.split('-')[0]);
const $394a54b0d708bbf0$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $b8rQb.useProjectContextActionStore)();
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $394a54b0d708bbf0$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $b8rQb.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $394a54b0d708bbf0$export$27e24febf0f5c3bc = (projectKey)=>{
    const [projectStyle] = (0, $b8rQb.useProjectContextJiraProjectStyleStore)({
        projectKey: projectKey
    });
    return projectStyle;
};
const $394a54b0d708bbf0$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $394a54b0d708bbf0$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $394a54b0d708bbf0$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $bRJAs.getApplicationForProject)(projectType);
};
const $394a54b0d708bbf0$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $lvKO5.useTenantContext)();
    const application = $394a54b0d708bbf0$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $a9ldn.getEdition)(application, appEditions);
};
const $394a54b0d708bbf0$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $394a54b0d708bbf0$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $394a54b0d708bbf0$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $394a54b0d708bbf0$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $b8rQb.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $394a54b0d708bbf0$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $394a54b0d708bbf0$export$6de29d851c914935(projectKey);
    const isSimplified = $394a54b0d708bbf0$export$524ef4f6102ed540(projectKey);
    return (0, $fAZgY.useMemoWithCondition)(()=>(0, $aAqmd.getIssueConfiguration)({
            isSimplified: isSimplified,
            projectType: projectType
        }), [
        isSimplified,
        projectType
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $394a54b0d708bbf0$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $b8rQb.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $394a54b0d708bbf0$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $b8rQb.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("b8rQb", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $9f277dbc5eafd530$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $9f277dbc5eafd530$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $9f277dbc5eafd530$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextJiraProjectStyleStore", () => $9f277dbc5eafd530$export$b291cf203d6481a4);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $9f277dbc5eafd530$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $9f277dbc5eafd530$export$f73e9904779f6be5);

var $ln6Iy = parcelRequire("ln6Iy");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $6KYi0 = parcelRequire("6KYi0");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9f277dbc5eafd530$var$initialState = {};
const $9f277dbc5eafd530$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'project-context',
    initialState: $9f277dbc5eafd530$var$initialState,
    actions: $6KYi0
});
const $9f277dbc5eafd530$export$9afb89c1fe103bbe = (0, $iJq0l.createHook)($9f277dbc5eafd530$export$6f57813fe9f31bf9, {
    selector: null
});
const $9f277dbc5eafd530$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $9f277dbc5eafd530$export$8b09478b33186ec = (0, $iJq0l.createHook)($9f277dbc5eafd530$export$6f57813fe9f31bf9, {
    selector: $9f277dbc5eafd530$var$getProjectContext
});
const $9f277dbc5eafd530$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $9f277dbc5eafd530$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $9f277dbc5eafd530$var$getJiraProjectStyle = (state, { projectKey: projectKey })=>{
    const projectContext = $9f277dbc5eafd530$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.isSimplified ? (0, $ln6Iy.TEAM_MANAGED_PROJECT) : (0, $ln6Iy.COMPANY_MANAGED_PROJECT);
};
const $9f277dbc5eafd530$export$f2e1ed3b2b4707cb = (0, $iJq0l.createHook)($9f277dbc5eafd530$export$6f57813fe9f31bf9, {
    selector: $9f277dbc5eafd530$var$getProjectType
});
const $9f277dbc5eafd530$export$b291cf203d6481a4 = (0, $iJq0l.createHook)($9f277dbc5eafd530$export$6f57813fe9f31bf9, {
    selector: $9f277dbc5eafd530$var$getJiraProjectStyle
});
const $9f277dbc5eafd530$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $9f277dbc5eafd530$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $9f277dbc5eafd530$export$9469fde70658518 = (0, $iJq0l.createHook)($9f277dbc5eafd530$export$6f57813fe9f31bf9, {
    selector: $9f277dbc5eafd530$var$getProjectName
});
const $9f277dbc5eafd530$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $9f277dbc5eafd530$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $9f277dbc5eafd530$export$f73e9904779f6be5 = (0, $iJq0l.createHook)($9f277dbc5eafd530$export$6f57813fe9f31bf9, {
    selector: $9f277dbc5eafd530$var$getIssueTypes
});

});
parcelRegister("6KYi0", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $da8fc507538f01dc$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $da8fc507538f01dc$export$78f1c6052937615f);
const $da8fc507538f01dc$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $da8fc507538f01dc$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("aAqmd", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $260acdbd5c3f4032$export$902f6c5cc939598a);

var $kkiRT = parcelRequire("kkiRT");

var $ln6Iy = parcelRequire("ln6Iy");
const $260acdbd5c3f4032$export$cdbd1eb3b05729e0 = 'flagActions';
const $260acdbd5c3f4032$export$c161a774ec2e7e56 = 'cardCoverActions';
const $260acdbd5c3f4032$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $260acdbd5c3f4032$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $kkiRT.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $kkiRT.default).SOFTWARE_ISSUE,
        issueActions: [
            $260acdbd5c3f4032$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $kkiRT.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $260acdbd5c3f4032$export$cdbd1eb3b05729e0,
            $260acdbd5c3f4032$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $kkiRT.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $260acdbd5c3f4032$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $kkiRT.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $260acdbd5c3f4032$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $kkiRT.default).MOBILE_ISSUE,
        issueActions: []
    });
const $260acdbd5c3f4032$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $kkiRT.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $260acdbd5c3f4032$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            if (config.isSimplified) return $260acdbd5c3f4032$export$aebf676dfa727a1c();
            return $260acdbd5c3f4032$export$27e0678365e5dcff();
        case 0, $ln6Iy.CORE_PROJECT:
            return $260acdbd5c3f4032$export$381ce08838c53afa();
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return $260acdbd5c3f4032$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $260acdbd5c3f4032$export$27e0678365e5dcff();
    }
    return $260acdbd5c3f4032$export$27e0678365e5dcff();
};

});
parcelRegister("kkiRT", function(module, exports) {

$parcel$export(module.exports, "default", () => $005a3792ecb89923$export$2e2bcd8739ae039);
const $005a3792ecb89923$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $005a3792ecb89923$export$2e2bcd8739ae039 = $005a3792ecb89923$var$keys;

});



parcelRegister("8wUZn", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $aad4eaa422fd4f11$export$268651a63abe408a);

var $lvKO5 = parcelRequire("lvKO5");
const $aad4eaa422fd4f11$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("b9nqM", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $e7b633a490276fcc$export$54d534cc91e54850);

var $lvKO5 = parcelRequire("lvKO5");
const $e7b633a490276fcc$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("U4tkh", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStore", () => $37a5d4913156d800$export$f6e0a3ee03299fbc);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $37a5d4913156d800$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $37a5d4913156d800$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $37a5d4913156d800$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $37a5d4913156d800$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $37a5d4913156d800$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $37a5d4913156d800$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $37a5d4913156d800$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $37a5d4913156d800$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $37a5d4913156d800$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $37a5d4913156d800$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $37a5d4913156d800$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $37a5d4913156d800$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $37a5d4913156d800$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $37a5d4913156d800$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $37a5d4913156d800$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStorePreviousViewMode", () => $37a5d4913156d800$export$1473982989cfd8bf);
$parcel$export(module.exports, "useIssueContextStoreIsViewModeFullScreenModal", () => $37a5d4913156d800$export$3920404a544ed959);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $37a5d4913156d800$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $37a5d4913156d800$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $37a5d4913156d800$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $37a5d4913156d800$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $37a5d4913156d800$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $37a5d4913156d800$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $37a5d4913156d800$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $37a5d4913156d800$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiEnabledForIssue", () => $37a5d4913156d800$export$455ae7fd9d68b157);
$parcel$export(module.exports, "useIssueTypeName", () => $37a5d4913156d800$export$ec3ac562fe41f8db);
$parcel$export(module.exports, "useIssueHierarchyLevel", () => $37a5d4913156d800$export$c998d5da56eeedf0);
$parcel$export(module.exports, "IssueContextContainer", () => $37a5d4913156d800$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $37a5d4913156d800$export$965360ae27fcae98);

var $ljej9 = parcelRequire("ljej9");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9CRRg = parcelRequire("9CRRg");

var $2ZenB = parcelRequire("2ZenB");

var $c5gcy = parcelRequire("c5gcy");
const $37a5d4913156d800$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $ljej9.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $c5gcy.getViewModeFromLocalStorage)(),
    previousViewMode: (0, $c5gcy.getPreviousViewModeFromLocalStorage)(),
    isViewModeFullScreenModal: (0, $c5gcy.getIsViewModeFullScreenModalFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false,
    isAiEnabledForIssue: false,
    issueHierarchyLevel: undefined,
    issueType: undefined
};
const $37a5d4913156d800$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-context',
    initialState: $37a5d4913156d800$export$d4c72bab9d6cc13a,
    actions: $9CRRg.actions
});
const $37a5d4913156d800$var$getIssueContext = (state)=>state;
const $37a5d4913156d800$var$getIsModal = (state)=>state.isModal;
const $37a5d4913156d800$var$getIssueKey = (state)=>state.issueKey;
const $37a5d4913156d800$var$getIsArchived = (state)=>state.isArchived;
const $37a5d4913156d800$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $37a5d4913156d800$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $37a5d4913156d800$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $37a5d4913156d800$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $37a5d4913156d800$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $37a5d4913156d800$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $37a5d4913156d800$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $37a5d4913156d800$var$getIsLoading = (state)=>state.isLoading;
const $37a5d4913156d800$var$getViewMode = (state)=>state.viewMode;
const $37a5d4913156d800$var$getPreviousViewMode = (state)=>state.previousViewMode;
const $37a5d4913156d800$var$getIsViewModeFullScreenModal = (state)=>state.isViewModeFullScreenModal;
const $37a5d4913156d800$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $37a5d4913156d800$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $37a5d4913156d800$var$getBoardId = (state)=>state.boardId;
const $37a5d4913156d800$var$getBoardType = (state)=>state.boardType;
const $37a5d4913156d800$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $37a5d4913156d800$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $37a5d4913156d800$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $37a5d4913156d800$var$getRapidViewId = (state)=>state.rapidViewId;
const $37a5d4913156d800$var$getViewScreenId = (state)=>state.viewScreenId;
const $37a5d4913156d800$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $37a5d4913156d800$var$getisAiEnabledForIssue = (state)=>Boolean(state.isAiEnabledForIssue);
const $37a5d4913156d800$var$getIssueTypeName = (state)=>state.issueType;
const $37a5d4913156d800$var$getIssueHierarchyLevel = (state)=>state.issueHierarchyLevel;
const $37a5d4913156d800$export$f6e0a3ee03299fbc = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueContext
});
const $37a5d4913156d800$export$abdbea56d86b4aac = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: (0, $2ZenB.getChildIssuesLimit)
});
const $37a5d4913156d800$export$326ff2b963d51c5c = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: (0, $2ZenB.getChildIssuesIssueLimitUrls)
});
const $37a5d4913156d800$export$44bcaaabb74e402b = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueKey
});
const $37a5d4913156d800$export$332dcee0cf9f4e45 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueId
});
const $37a5d4913156d800$export$c940355b1fc6e1c4 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsArchived
});
const $37a5d4913156d800$export$b9eebaa1da421997 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsClassifyEditEnabled
});
const $37a5d4913156d800$export$daa47fd600e43a32 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsModal
});
const $37a5d4913156d800$export$ba2e9546ab5ba6f = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getViewScreenId
});
const $37a5d4913156d800$export$74d38d6c437efc1b = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getAnalyticsSource
});
const $37a5d4913156d800$export$2092528ee170d9e7 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getRapidViewMap
});
const $37a5d4913156d800$export$57898374e6239a5a = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getMaxTokenLength
});
const $37a5d4913156d800$export$ff0264ec4c015dc1 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsLoadedWithPage
});
const $37a5d4913156d800$export$6c8b81f6dca8c23d = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getEstimationStatistic
});
const $37a5d4913156d800$export$fe7085456138f0fc = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsLoading
});
const $37a5d4913156d800$export$c339e36468c12443 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getViewMode
});
const $37a5d4913156d800$export$1473982989cfd8bf = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getPreviousViewMode
});
const $37a5d4913156d800$export$3920404a544ed959 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsViewModeFullScreenModal
});
const $37a5d4913156d800$export$ef3bfa2642bb98cd = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getBackButtonUrl
});
const $37a5d4913156d800$export$8accd063c74cd455 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueNavigatorData
});
const $37a5d4913156d800$export$e7edffc2a20027e7 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getBoardId
});
const $37a5d4913156d800$export$48aaa3a6bc2085d7 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getBoardType
});
const $37a5d4913156d800$export$4a4b96bcf5166327 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsSpaEnabled
});
const $37a5d4913156d800$export$bbd8ba0180545556 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getLoginRedirectUrl
});
const $37a5d4913156d800$export$aaa89627762c7d00 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getOnIssueKeyChange
});
const $37a5d4913156d800$export$796589b0ec52848a = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getRapidViewId
});
const $37a5d4913156d800$export$7e70ee570119a0a7 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIsAiOptInEnabled
});
const $37a5d4913156d800$export$455ae7fd9d68b157 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getisAiEnabledForIssue
});
const $37a5d4913156d800$export$ec3ac562fe41f8db = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueTypeName
});
const $37a5d4913156d800$export$c998d5da56eeedf0 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: $37a5d4913156d800$var$getIssueHierarchyLevel
});
const $37a5d4913156d800$export$93db6a8f3342dddf = (0, $6E16M.createContainer)($37a5d4913156d800$export$6f57813fe9f31bf9);
const $37a5d4913156d800$export$965360ae27fcae98 = (0, $iJq0l.createHook)($37a5d4913156d800$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("9CRRg", function(module, exports) {

$parcel$export(module.exports, "actions", () => $37cf6cc1d4339972$export$e324594224ef24da);

var $axSQB = parcelRequire("axSQB");

var $2ZenB = parcelRequire("2ZenB");

var $c5gcy = parcelRequire("c5gcy");
const $37cf6cc1d4339972$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        const currentState = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || currentState.viewMode,
            // Preserve previousViewMode if it exists and not explicitly set in new context
            previousViewMode: issueContext.previousViewMode || currentState.previousViewMode,
            // Preserve isViewModeFullScreenModal if it's currently true and not explicitly set in new context
            isViewModeFullScreenModal: currentState.isViewModeFullScreenModal && issueContext.isViewModeFullScreenModal === false ? currentState.isViewModeFullScreenModal : issueContext.isViewModeFullScreenModal
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || currentState.viewMode,
            // Preserve previousViewMode if it exists and not explicitly set in new context
            previousViewMode: issueContext.previousViewMode || currentState.previousViewMode,
            // Preserve isViewModeFullScreenModal if it's currently true and not explicitly set in new context
            isViewModeFullScreenModal: currentState.isViewModeFullScreenModal && issueContext.isViewModeFullScreenModal === false ? currentState.isViewModeFullScreenModal : issueContext.isViewModeFullScreenModal
        });
    };
const $37cf6cc1d4339972$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $37cf6cc1d4339972$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $2ZenB.getChildIssuesLimit)(getState());
const $37cf6cc1d4339972$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $37cf6cc1d4339972$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $37cf6cc1d4339972$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $37cf6cc1d4339972$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $37cf6cc1d4339972$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $37cf6cc1d4339972$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $37cf6cc1d4339972$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) {
            (0, $axSQB.localStorage).set((0, $axSQB.VIEW_MODE_STORAGE_KEY), 'MODAL');
            (0, $axSQB.localStorage).remove((0, $axSQB.PREVIOUS_VIEW_MODE_STORAGE_KEY));
            (0, $axSQB.localStorage).set((0, $axSQB.IS_VIEW_MODE_FULL_SCREEN_MODAL_STORAGE_KEY), 'false');
        }
        setState({
            viewMode: 'MODAL',
            isViewModeFullScreenModal: false,
            previousViewMode: undefined
        });
    };
const $37cf6cc1d4339972$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) {
            (0, $axSQB.localStorage).set((0, $axSQB.VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
            (0, $axSQB.localStorage).remove((0, $axSQB.PREVIOUS_VIEW_MODE_STORAGE_KEY));
            (0, $axSQB.localStorage).set((0, $axSQB.IS_VIEW_MODE_FULL_SCREEN_MODAL_STORAGE_KEY), 'false');
        }
        setState({
            viewMode: 'SIDEBAR',
            isViewModeFullScreenModal: false,
            previousViewMode: undefined
        });
    };
const $37cf6cc1d4339972$export$c712e8f2f2fbf45b = (willSave = true)=>({ getState: getState, setState: setState })=>{
        const previousViewMode = getState().viewMode;
        if (willSave) {
            (0, $axSQB.localStorage).set((0, $axSQB.PREVIOUS_VIEW_MODE_STORAGE_KEY), previousViewMode);
            (0, $axSQB.localStorage).set((0, $axSQB.VIEW_MODE_STORAGE_KEY), 'MODAL');
            (0, $axSQB.localStorage).set((0, $axSQB.IS_VIEW_MODE_FULL_SCREEN_MODAL_STORAGE_KEY), 'true');
        }
        setState({
            viewMode: 'MODAL',
            isViewModeFullScreenModal: true,
            previousViewMode: previousViewMode
        });
    };
const $37cf6cc1d4339972$export$ee359474c5820bf = (willSave = true)=>({ getState: getState, setState: setState })=>{
        const previousViewMode = getState().previousViewMode ?? 'MODAL';
        if (willSave) {
            (0, $axSQB.localStorage).set((0, $axSQB.VIEW_MODE_STORAGE_KEY), previousViewMode);
            // Clear the previous view mode since we've restored it
            (0, $axSQB.localStorage).remove((0, $axSQB.PREVIOUS_VIEW_MODE_STORAGE_KEY));
            (0, $axSQB.localStorage).set((0, $axSQB.IS_VIEW_MODE_FULL_SCREEN_MODAL_STORAGE_KEY), 'false');
        }
        setState({
            viewMode: previousViewMode,
            previousViewMode: undefined,
            isViewModeFullScreenModal: false
        });
    };
const $37cf6cc1d4339972$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $c5gcy.getViewModeFromLocalStorage)()
        });
    };
const $37cf6cc1d4339972$export$e324594224ef24da = {
    setIssueContext: $37cf6cc1d4339972$export$784a03c4b74da53e,
    mergeIssueContext: $37cf6cc1d4339972$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $37cf6cc1d4339972$export$89b6937a83edcaa6,
    getMaxTokenLength: $37cf6cc1d4339972$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $37cf6cc1d4339972$export$2fe981b90be13483,
    getBackButtonUrl: $37cf6cc1d4339972$export$afce556782490aae,
    getIsSpaEnabled: $37cf6cc1d4339972$export$711dfa096bf81f2d,
    getIssueKey: $37cf6cc1d4339972$export$4a030f6192bebe03,
    getIsArchived: $37cf6cc1d4339972$export$b41341ac6c74ca6,
    setDetailViewAsModal: $37cf6cc1d4339972$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $37cf6cc1d4339972$export$b303af51de56a0e,
    resetDetailView: $37cf6cc1d4339972$export$75007d125f198b78,
    setDetailViewAsFullScreenModal: $37cf6cc1d4339972$export$c712e8f2f2fbf45b,
    setDetailViewAsCollapsedModal: $37cf6cc1d4339972$export$ee359474c5820bf
};

});
parcelRegister("axSQB", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $13b297323309c4b3$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $13b297323309c4b3$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $13b297323309c4b3$export$a13f7f627010bccd);
$parcel$export(module.exports, "PREVIOUS_VIEW_MODE_STORAGE_KEY", () => $13b297323309c4b3$export$c2cda7684022695d);
$parcel$export(module.exports, "IS_VIEW_MODE_FULL_SCREEN_MODAL_STORAGE_KEY", () => $13b297323309c4b3$export$3cdbcf459cce204a);

var $dnU6V = parcelRequire("dnU6V");
const $13b297323309c4b3$export$25a759e49d5049db = 'issue.issue-context-service';
const $13b297323309c4b3$export$c2ed3351cac403d1 = (0, $dnU6V.createLocalStorageProvider)('jira_issue_view');
const $13b297323309c4b3$export$a13f7f627010bccd = 'view-mode';
const $13b297323309c4b3$export$c2cda7684022695d = 'previous-view-mode';
const $13b297323309c4b3$export$3cdbcf459cce204a = 'is-view-mode-full-screen-modal';

});

parcelRegister("2ZenB", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $f915ff48c2d8f087$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $f915ff48c2d8f087$export$8f43520910e8128c);

var $eSnSE = parcelRequire("eSnSE");

var $axSQB = parcelRequire("axSQB");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $f915ff48c2d8f087$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $f915ff48c2d8f087$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData(`${(0, $axSQB.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $f915ff48c2d8f087$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $f915ff48c2d8f087$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $f915ff48c2d8f087$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $f915ff48c2d8f087$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

parcelRegister("c5gcy", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $44ce6f363203119e$export$cae7c4c591dcc261);
$parcel$export(module.exports, "getPreviousViewModeFromLocalStorage", () => $44ce6f363203119e$export$d32761230a2a17ad);
$parcel$export(module.exports, "getIsViewModeFullScreenModalFromLocalStorage", () => $44ce6f363203119e$export$baa08635e57cf1e5);

var $axSQB = parcelRequire("axSQB");
const $44ce6f363203119e$export$cae7c4c591dcc261 = ()=>{
    if (false) return 'DEFAULT';
    return (0, $axSQB.localStorage).get((0, $axSQB.VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
};
const $44ce6f363203119e$export$d32761230a2a17ad = ()=>{
    if (false) return 'DEFAULT';
    return (0, $axSQB.localStorage).get((0, $axSQB.PREVIOUS_VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
};
const $44ce6f363203119e$export$baa08635e57cf1e5 = ()=>{
    if (false) return false;
    return (0, $axSQB.localStorage).get((0, $axSQB.IS_VIEW_MODE_FULL_SCREEN_MODAL_STORAGE_KEY)) || false;
};

});




parcelRegister("aMZVu", function(module, exports) {

$parcel$export(module.exports, "usePracticesFieldValue", () => $af251ed4c407aa57$export$edecf7b484763b0d);
$parcel$export(module.exports, "useIsAgentOrProjectAdmin", () => $af251ed4c407aa57$export$e1f1a212ffd431eb);
$parcel$export(module.exports, "useIsIssueOfIncidentsPractice", () => $af251ed4c407aa57$export$3d5b53ead0d10d84);
$parcel$export(module.exports, "useIsIssueOfPostIncidentReviewPractice", () => $af251ed4c407aa57$export$2a245b8b8b1276b1);
$parcel$export(module.exports, "useIsIssueOfDeveloperEscalationPractice", () => $af251ed4c407aa57$export$4f9a7f08c8bc7afb);
$parcel$export(module.exports, "useIsIssueOfServiceRequestPractice", () => $af251ed4c407aa57$export$5b58271f0207861c);

var $bmoS1 = parcelRequire("bmoS1");

var $eaTQ3 = parcelRequire("eaTQ3");

var $814y1 = parcelRequire("814y1");

var $5L9Ai = parcelRequire("5L9Ai");

var $5tgJD = parcelRequire("5tgJD");

var $jlJsl = parcelRequire("jlJsl");
const $af251ed4c407aa57$export$edecf7b484763b0d = ({ issueKey: issueKey })=>(0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $814y1.SERVICEDESK_PRACTICES_TYPE)
    });
const $af251ed4c407aa57$export$e1f1a212ffd431eb = ()=>{
    const [{ data: data, error: error }] = (0, $5tgJD.useServiceDeskContext)();
    if (error) return false;
    return data?.userRole === (0, $5L9Ai.USER_JSM_PROJECT_ROLE).AGENT_ROLE || data?.userRole === (0, $5L9Ai.USER_JSM_PROJECT_ROLE).AGENT_PROJECT_ADMIN_ROLE;
};
const $af251ed4c407aa57$export$3d5b53ead0d10d84 = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const [practices] = $af251ed4c407aa57$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices?.includes((0, $jlJsl.INCIDENTS));
};
const $af251ed4c407aa57$export$2a245b8b8b1276b1 = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const [practices] = $af251ed4c407aa57$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices?.includes((0, $jlJsl.POST_INCIDENT_REVIEWS));
};
const $af251ed4c407aa57$export$4f9a7f08c8bc7afb = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const [practices] = $af251ed4c407aa57$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices?.includes((0, $jlJsl.DEVELOPER_ESCALATION));
};
const $af251ed4c407aa57$export$5b58271f0207861c = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const [practices] = $af251ed4c407aa57$export$edecf7b484763b0d({
        issueKey: issueKey
    });
    return Array.isArray(practices) && practices.includes((0, $jlJsl.SERVICE_REQUEST));
};

});
parcelRegister("eaTQ3", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $626f51b4fb1f2379$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $626f51b4fb1f2379$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $626f51b4fb1f2379$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $626f51b4fb1f2379$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $626f51b4fb1f2379$export$612d9bcb0c9d8976);

var $eJOHy = parcelRequire("eJOHy");

var $1O6Yz = parcelRequire("1O6Yz");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $626f51b4fb1f2379$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $626f51b4fb1f2379$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $626f51b4fb1f2379$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $626f51b4fb1f2379$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $626f51b4fb1f2379$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState()[issueKey], fields)
        });
    };
const $626f51b4fb1f2379$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState(), newIssues));
    };
const $626f51b4fb1f2379$var$actions = {
    setFieldValue: $626f51b4fb1f2379$var$setFieldValue,
    getFieldValue: $626f51b4fb1f2379$var$getFieldValue,
    setIssue: $626f51b4fb1f2379$var$setIssue,
    mergeIssue: $626f51b4fb1f2379$var$mergeIssue,
    setIssues: $626f51b4fb1f2379$var$setIssues,
    mergeIssues: $626f51b4fb1f2379$export$11aa02e14fdf7753
};
// this is a global store
const $626f51b4fb1f2379$var$store = (0, $GtRbT.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $626f51b4fb1f2379$var$actions
});
const $626f51b4fb1f2379$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $626f51b4fb1f2379$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$626f51b4fb1f2379$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $626f51b4fb1f2379$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $626f51b4fb1f2379$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $626f51b4fb1f2379$var$getAllFields = (state, issueKey)=>state[issueKey];
const $626f51b4fb1f2379$export$b79fae7fbe3ac392 = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValueSelector
});
const $626f51b4fb1f2379$export$25b73e671fe7a8fa = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getAllFields
});
const $626f51b4fb1f2379$export$ac289b84121829df = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValuesForIssuesSelector
});
const $626f51b4fb1f2379$export$915cdeec521b54f7 = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getMultiFieldValuesForIssuesSelector
});
const $626f51b4fb1f2379$export$4e5f1f4ed08d155e = (0, $ht3nQ.createSubscriber)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValueSelector
});
const $626f51b4fb1f2379$var$useFieldValueStoreActions = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: null
});
const $626f51b4fb1f2379$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $626f51b4fb1f2379$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eJOHy.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("5L9Ai", function(module, exports) {

$parcel$export(module.exports, "USER_JSM_PROJECT_ROLE", () => $69eee2502f937cb2$export$a9054e41660c4d00);
const $69eee2502f937cb2$var$AGENT_ROLE = 'agent';
const $69eee2502f937cb2$var$AGENT_PROJECT_ADMIN_ROLE = 'agent-project-admin';
const $69eee2502f937cb2$var$JIRA_ROLE = 'jira-user';
const $69eee2502f937cb2$export$a9054e41660c4d00 = {
    AGENT_ROLE: $69eee2502f937cb2$var$AGENT_ROLE,
    AGENT_PROJECT_ADMIN_ROLE: $69eee2502f937cb2$var$AGENT_PROJECT_ADMIN_ROLE,
    JIRA_ROLE: $69eee2502f937cb2$var$JIRA_ROLE
};

});


parcelRegister("4ShP4", function(module, exports) {

$parcel$export(module.exports, "useJsmMimEntitlementResource", () => $2cf51e344e96cc23$export$db2d9c66103c357c);

var $eJOHy = parcelRequire("eJOHy");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $2cf51e344e96cc23$var$getDataLoader = ()=>(parcelRequire("gwQIV"));
const $2cf51e344e96cc23$export$972b28729379ca5f = (0, $l1VxS.createResource)({
    type: 'JSM_MIM_ENTITLEMENT',
    getKey: ()=>'JSM_MIM_ENTITLEMENT',
    getDataLoader: $2cf51e344e96cc23$var$getDataLoader,
    maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});
const $2cf51e344e96cc23$export$db2d9c66103c357c = (cloudId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)($2cf51e344e96cc23$export$972b28729379ca5f);
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (error || loading || !data || !cloudId) return {
            isEntitled: false
        };
        const { isEntitled: isEntitled } = data;
        return {
            isEntitled: isEntitled
        };
    }, [
        data,
        loading,
        error,
        cloudId
    ]);
};

});
parcelRegister("gwQIV", function(module, exports) {

let $c088885141e3e66b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c088885141e3e66b$var$load("68P46").then(()=>parcelRequire('jTrgz'));

});


parcelRegister("gZc2u", function(module, exports) {

$parcel$export(module.exports, "useMajorIncidentField", () => $443937c71229f4fb$export$91517ada3bce1236);

var $2QNHW = parcelRequire("2QNHW");

var $aASNQ = parcelRequire("aASNQ");
const $443937c71229f4fb$export$91517ada3bce1236 = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure, onSubmit: onSubmit })=>{
    const { majorIncidentFieldIdKey: fieldKey, fieldType: fieldType } = (0, $aASNQ.useMajorIncidentConfig)(issueKey);
    const [{ value: value, loading: loading, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $2QNHW.useEditField)({
        issueKey: issueKey,
        fieldKey: fieldKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onSubmit: onSubmit
    });
    return [
        {
            value: value,
            loading: loading,
            error: error
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("2QNHW", function(module, exports) {

$parcel$export(module.exports, "useContextualIssueIdForIssueKey", () => $bce61970be345088$export$76d937477b5f784a);
$parcel$export(module.exports, "useEditField", () => $bce61970be345088$export$343e962d356c0af1);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $8Z9Ld = parcelRequire("8Z9Ld");

var $eSnSE = parcelRequire("eSnSE");

var $7jTnu = parcelRequire("7jTnu");

var $1uIew = parcelRequire("1uIew");

var $8KUFq = parcelRequire("8KUFq");

var $d2AGn = parcelRequire("d2AGn");

var $eDOqM = parcelRequire("eDOqM");

var $bmoS1 = parcelRequire("bmoS1");

var $1Elll = parcelRequire("1Elll");

var $4TKh4 = parcelRequire("4TKh4");

var $4im1M = parcelRequire("4im1M");

var $gCeeo = parcelRequire("gCeeo");

var $eaTQ3 = parcelRequire("eaTQ3");

var $iaPZb = parcelRequire("iaPZb");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $bce61970be345088$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $bce61970be345088$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $bce61970be345088$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $bce61970be345088$var$getFieldValue, saveField: saveField = (0, $iaPZb.defaultSaveField), saveFieldById: saveFieldById = (0, $iaPZb.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $iaPZb.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $iaPZb.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $4im1M.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const resetError = (0, $eJOHy.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $eJOHy.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const actualFieldType = analyticsFieldTypeAlias ?? fieldType;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: actualFieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $bce61970be345088$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
            (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(fieldKey, {
                analytics: analyticsEvent,
                attributes: {
                    fieldType: actualFieldType,
                    isInlineEditing: !(0, $eDOqM.getIsEditFromIssueView)(analyticsEvent),
                    ...(0, $7jTnu.fg)('one_event_improvements_1') && {
                        issueId: issueId
                    }
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $1uIew.ValidationError);
            if (!isValidationError) (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: analyticsFieldTypeAlias ?? fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $8KUFq.isClientFetchError)(ex)
            });
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().endSession(fieldKey);
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $eJOHy.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $eJOHy.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $eJOHy.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $eJOHy.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $bce61970be345088$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $bmoS1.useIssueId)();
    const contextualIssueKey = (0, $bmoS1.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $bce61970be345088$var$getAdditionalProperties = (meta, isEditFromIssueView)=>{
    if (!meta || typeof meta === 'object') return {
        ...meta ?? {},
        isEditFromIssueView: isEditFromIssueView
    };
    return meta;
};
const $bce61970be345088$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $4TKh4.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $bce61970be345088$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const onSubmitFn = (0, $eJOHy.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $eJOHy.useCallback)(async (fieldValue, event, meta)=>{
        onSuccess(fieldValue);
        issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, $bce61970be345088$var$getAdditionalProperties(meta, (0, $eDOqM.getIsEditFromIssueView)(event)));
        if (!shouldPreventIssueViewSoftRefresh && !(0, $eDOqM.getIsEditFromIssueView)(event)) try {
            const reason = (0, $1Elll.Reason).SoftRefresh;
            await (0, $8Z9Ld.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        shouldPreventIssueViewSoftRefresh,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $eJOHy.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $bce61970be345088$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("8Z9Ld", function(module, exports) {

$parcel$export(module.exports, "default", () => $625abf3f3d5ba00e$export$2e2bcd8739ae039);
const $625abf3f3d5ba00e$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $625abf3f3d5ba00e$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$addEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$removeEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$addRefreshIssueListener = (callback)=>$625abf3f3d5ba00e$var$addEventListener($625abf3f3d5ba00e$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$removeRefreshIssueListener = (callback)=>$625abf3f3d5ba00e$var$removeEventListener($625abf3f3d5ba00e$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$addUpdateIssueGlanceListener = (callback)=>$625abf3f3d5ba00e$var$addEventListener($625abf3f3d5ba00e$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$removeUpdateIssueGlanceListener = (callback)=>$625abf3f3d5ba00e$var$removeEventListener($625abf3f3d5ba00e$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $625abf3f3d5ba00e$var$refreshIssuePageThrowable = (issueKey, reason = 'ON_DEMAND')=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.dispatchEvent(new CustomEvent($625abf3f3d5ba00e$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $625abf3f3d5ba00e$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $625abf3f3d5ba00e$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$625abf3f3d5ba00e$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $625abf3f3d5ba00e$var$addRefreshIssueListener,
    removeRefreshIssueListener: $625abf3f3d5ba00e$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $625abf3f3d5ba00e$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $625abf3f3d5ba00e$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $625abf3f3d5ba00e$var$refreshIssuePageThrowable,
    refreshIssuePage: $625abf3f3d5ba00e$var$refreshIssuePage
};

});

parcelRegister("eDOqM", function(module, exports) {

$parcel$export(module.exports, "getIsEditFromIssueView", () => $2cf48d43ab1e3da4$export$8846558eb0b5fa3);

var $9gq2c = parcelRequire("9gq2c");

var $1WOGD = parcelRequire("1WOGD");
const $2cf48d43ab1e3da4$export$8846558eb0b5fa3 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $1WOGD.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $9gq2c.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("1Elll", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $a34fa8d661c29191$export$fe867595c4640fb1);
const $a34fa8d661c29191$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});

parcelRegister("4TKh4", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $f55e0c2b65585da2$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $f55e0c2b65585da2$export$f9eb49cc2f0e28ce);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $bOaiQ = parcelRequire("bOaiQ");

var $4P77p = parcelRequire("4P77p");
const $f55e0c2b65585da2$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $f55e0c2b65585da2$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $bOaiQ.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $4P77p.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $f55e0c2b65585da2$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $4P77p.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $f55e0c2b65585da2$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $bOaiQ.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $4P77p.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $f55e0c2b65585da2$var$actions = {
    fieldChanged: $f55e0c2b65585da2$var$fieldChanged,
    fieldChangeFailed: $f55e0c2b65585da2$var$fieldChangeFailed,
    fieldChangeRequested: $f55e0c2b65585da2$var$fieldChangeRequested,
    registerEventHandler: $f55e0c2b65585da2$var$registerEventHandler
};
// this is a global state
const $f55e0c2b65585da2$var$store = (0, $GtRbT.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $f55e0c2b65585da2$var$actions
});
const $f55e0c2b65585da2$export$444af741f6d8f512 = (0, $iJq0l.createHook)($f55e0c2b65585da2$var$store, {
    selector: null
});
const $f55e0c2b65585da2$export$f9eb49cc2f0e28ce = (0, $6E16M.createContainer)($f55e0c2b65585da2$var$store);

});
parcelRegister("bOaiQ", function(module, exports) {

$parcel$export(module.exports, "transformAggToLegacy", () => $a6ba0b2822402a6d$export$d951e3c38e10736d);

var $dJvZv = parcelRequire("dJvZv");

var $814y1 = parcelRequire("814y1");

var $7QMat = parcelRequire("7QMat");

var $i6YHz = parcelRequire("i6YHz");
const $a6ba0b2822402a6d$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
    if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
    switch(aggFieldChangeProps.__typename){
        // These fields require context for their transform in transformAggFieldToLegacyField so need to be manually implemented
        // This is not an exhaustive list, I did a quick check is all, so best to check the transform works as expected as you migrate fields to relay
        // These are commented out because they are not implemented and due to types can't just be added here until implemented
        // case JSM_PEOPLE_GQL_FIELD:
        // case ISSUE_RESTRICTION_GQL_FIELD:
        // otherwise we can default to the existing package
        case 0, $814y1.RADIO_GQL_FIELD:
        case 0, $814y1.TEAM_VIEW_GQL_FIELD:
        case 0, $814y1.MULTI_GROUP_PICKER_GQL_FIELD:
        case 0, $814y1.SINGLE_GROUP_PICKER_GQL_FIELD:
        case 0, $814y1.MULTI_USER_PICKER_GQL_FIELD:
        case 0, $814y1.PEOPLE_GQL_FIELD:
        case 0, $814y1.SECURITY_GQL_FIELD:
        case 0, $814y1.NUMBER_GQL_FIELD:
        case 0, $814y1.TEXT_GQL_FIELD:
        case 0, $814y1.USER_PICKER_GQL_FIELD:
        case 0, $814y1.PRIORITY_GQL_FIELD:
        case 0, $814y1.URL_GQL_FIELD:
        case 0, $814y1.DATE_PICKER_GQL_FIELD:
        case 0, $814y1.PROJECT_GQL_FIELD:
        case 0, $814y1.DATE_TIME_GQL_FIELD:
        case 0, $814y1.COLOR_GQL_FIELD:
        case 0, $814y1.ORIGINAL_ESTIMATE_GQL_FIELD:
        case 0, $814y1.ISSUE_TYPE_GQL_FIELD:
        case 0, $814y1.VOTES_GQL_FIELD:
        case 0, $814y1.WATCHES_GQL_FIELD:
        case 0, $814y1.RESOLUTION_GQL_FIELD:
        case 0, $814y1.STATUS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                [$a6ba0b2822402a6d$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type
            })?.value;
        case 0, $814y1.RICH_TEXT_GQL_FIELD:
            return (0, $i6YHz.transformAggRichTextFieldValueToLegacyFieldValue)(fieldValue, aggFieldChangeProps.renderer);
        case 0, $814y1.PARENT_GQL_FIELD:
            return (0, $7QMat.transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
        case 0, $814y1.SPRINT_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                ...fieldValue
            })?.value;
        case 0, $814y1.TIME_TRACKING_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                originalEstimate: fieldValue.originalEstimate,
                remainingEstimate: fieldValue.remainingEstimate,
                timeSpent: fieldValue.timeSpent
            })?.value;
        case 0, $814y1.CHECKBOX_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedOptions: fieldValue.selectedOptions,
                checkboxesFieldOptions: fieldValue.fieldOptions
            })?.value;
        case 0, $814y1.COMPONENTS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedComponentsConnection: fieldValue.selectedComponentsConnection
            })?.value;
        default:
            throw new Error('__typename not implemented');
    }
};
const $a6ba0b2822402a6d$var$getValueKey = (__typename)=>{
    const VALUE_KEYS = {
        [(0, $814y1.TEXT_GQL_FIELD)]: 'text',
        [(0, $814y1.NUMBER_GQL_FIELD)]: 'number',
        [(0, $814y1.PRIORITY_GQL_FIELD)]: 'priority',
        [(0, $814y1.USER_PICKER_GQL_FIELD)]: 'user',
        [(0, $814y1.DATE_PICKER_GQL_FIELD)]: 'date',
        [(0, $814y1.PROJECT_GQL_FIELD)]: 'project',
        [(0, $814y1.DATE_TIME_GQL_FIELD)]: 'dateTime',
        [(0, $814y1.ORIGINAL_ESTIMATE_GQL_FIELD)]: 'originalEstimate',
        [(0, $814y1.URL_GQL_FIELD)]: 'uri',
        [(0, $814y1.SECURITY_GQL_FIELD)]: 'securityLevel',
        [(0, $814y1.PEOPLE_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $814y1.WATCHES_GQL_FIELD)]: 'watch',
        [(0, $814y1.VOTES_GQL_FIELD)]: 'vote',
        [(0, $814y1.COLOR_GQL_FIELD)]: 'color',
        [(0, $814y1.MULTI_USER_PICKER_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $814y1.ISSUE_TYPE_GQL_FIELD)]: 'issueType',
        [(0, $814y1.RESOLUTION_GQL_FIELD)]: 'resolution',
        [(0, $814y1.MULTI_GROUP_PICKER_GQL_FIELD)]: 'selectedGroupsConnection',
        [(0, $814y1.SINGLE_GROUP_PICKER_GQL_FIELD)]: 'selectedGroup',
        [(0, $814y1.TEAM_VIEW_GQL_FIELD)]: 'selectedTeam',
        [(0, $814y1.STATUS_GQL_FIELD)]: 'status',
        [(0, $814y1.RADIO_GQL_FIELD)]: 'selectedOption',
        [(0, $814y1.RICH_TEXT_GQL_FIELD)]: 'richText'
    };
    const value = VALUE_KEYS[__typename];
    if (value) return value;
    throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
};

});
parcelRegister("dJvZv", function(module, exports) {

$parcel$export(module.exports, "transformAggFieldToLegacyField", () => $2bc37c1610784c31$export$586ba15cbf3d3031);
$parcel$export(module.exports, "transformAggFieldsToLegacyFields", () => $2bc37c1610784c31$export$ba106ff8c087e6b1);

var $LFmXM = parcelRequire("LFmXM");

var $814y1 = parcelRequire("814y1");

var $aFoDn = parcelRequire("aFoDn");

var $b8cRA = parcelRequire("b8cRA");

var $avDDJ = parcelRequire("avDDJ");

var $kHeCF = parcelRequire("kHeCF");

var $2Emz9 = parcelRequire("2Emz9");

var $3z9ZQ = parcelRequire("3z9ZQ");

var $kIiU4 = parcelRequire("kIiU4");

var $eOcuA = parcelRequire("eOcuA");

var $buly8 = parcelRequire("buly8");

var $4w7K1 = parcelRequire("4w7K1");

var $5p7Yl = parcelRequire("5p7Yl");

var $38Ayh = parcelRequire("38Ayh");

var $A0nGG = parcelRequire("A0nGG");

var $9YIgG = parcelRequire("9YIgG");

var $78GMW = parcelRequire("78GMW");

var $atdJk = parcelRequire("atdJk");

var $hWz6P = parcelRequire("hWz6P");

var $h6tdv = parcelRequire("h6tdv");

var $5IGk7 = parcelRequire("5IGk7");

var $aPcUN = parcelRequire("aPcUN");

var $1ZZyu = parcelRequire("1ZZyu");

var $dTYkW = parcelRequire("dTYkW");

var $esMH6 = parcelRequire("esMH6");

var $hqVWW = parcelRequire("hqVWW");

var $eDXnT = parcelRequire("eDXnT");

var $gmqe0 = parcelRequire("gmqe0");

var $95NMG = parcelRequire("95NMG");

var $kctB6 = parcelRequire("kctB6");

var $lBZeI = parcelRequire("lBZeI");

var $bl4cc = parcelRequire("bl4cc");

var $fj4N6 = parcelRequire("fj4N6");

var $7Elqr = parcelRequire("7Elqr");

var $eC8dc = parcelRequire("eC8dc");

var $7Qjvd = parcelRequire("7Qjvd");

var $iHCXo = parcelRequire("iHCXo");

var $2ZqHG = parcelRequire("2ZqHG");

var $kk6ni = parcelRequire("kk6ni");

var $5x8Qz = parcelRequire("5x8Qz");

var $5A5gO = parcelRequire("5A5gO");

var $fw41c = parcelRequire("fw41c");

var $8H6KM = parcelRequire("8H6KM");

var $iyjVB = parcelRequire("iyjVB");

var $lMiiC = parcelRequire("lMiiC");

var $gFEWP = parcelRequire("gFEWP");

var $a0aZw = parcelRequire("a0aZw");

var $7pxBz = parcelRequire("7pxBz");

var $dAiWn = parcelRequire("dAiWn");

var $a6vLL = parcelRequire("a6vLL");

var $gECU8 = parcelRequire("gECU8");

var $c8gRg = parcelRequire("c8gRg");

var $1exBo = parcelRequire("1exBo");

var $gtUzp = parcelRequire("gtUzp");

var $5iFQF = parcelRequire("5iFQF");

var $dSS0X = parcelRequire("dSS0X");

var $hpJ0s = parcelRequire("hpJ0s");

var $8plR2 = parcelRequire("8plR2");

var $92N3i = parcelRequire("92N3i");

var $lR2em = parcelRequire("lR2em");

var $9dsiy = parcelRequire("9dsiy");

var $2eP7x = parcelRequire("2eP7x");

var $ksE6r = parcelRequire("ksE6r");

var $dN5mk = parcelRequire("dN5mk");

var $2CpT2 = parcelRequire("2CpT2");

var $4MVer = parcelRequire("4MVer");

var $kPSkL = parcelRequire("kPSkL");

var $gpNkV = parcelRequire("gpNkV");

var $jE1Uq = parcelRequire("jE1Uq");

var $btvTF = parcelRequire("btvTF");

var $gujad = parcelRequire("gujad");
// We're memoising this just in case we FF another field
const $2bc37c1610784c31$var$getTransformersNonMemoised = ()=>({
        [(0, $814y1.AFFECTED_SERVICES_GQL_FIELD)]: (0, $aFoDn.transformAggAffectedServicesToLegacyField),
        [(0, $814y1.BOOLEAN_GQL_FIELD)]: (0, $avDDJ.transformAggBooleanToLegacyField),
        [(0, $814y1.CASCADING_SELECT_GQL_FIELD)]: (0, $kHeCF.transformAggCascadingSelectToLegacyField),
        [(0, $814y1.CHECKBOX_GQL_FIELD)]: (0, $2Emz9.transformAggCheckboxToLegacyField),
        [(0, $814y1.CMDB_GQL_FIELD)]: (0, $3z9ZQ.transformAggCMDBToLegacyField),
        [(0, $814y1.MULTI_SELECT_GQL_FIELD)]: (0, $a0aZw.transformAggMultipleSelectToLegacyField),
        [(0, $814y1.COMPONENTS_GQL_FIELD)]: (0, $eOcuA.transformAggComponentsToLegacyField),
        [(0, $814y1.CONNECT_DATE_TIME_GQL_FIELD)]: (0, $buly8.transformAggConnectDateTimeToLegacyField),
        [(0, $814y1.CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, $4w7K1.transformAggConnectMultipleSelectToLegacyField),
        [(0, $814y1.CONNECT_NUMBER_GQL_FIELD)]: (0, $5p7Yl.transformAggConnectNumberToLegacyField),
        [(0, $814y1.CONNECT_RICH_TEXT_GQL_FIELD)]: (0, $38Ayh.transformAggConnectRichTextToLegacyField),
        [(0, $814y1.CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, $A0nGG.transformAggConnectSingleSelectToLegacyField),
        [(0, $814y1.CONNECT_TEXT_GQL_FIELD)]: (0, $9YIgG.transformAggConnectTextToLegacyField),
        [(0, $814y1.COLOR_GQL_FIELD)]: (0, $kIiU4.transformAggColorToLegacyField),
        [(0, $814y1.DATE_PICKER_GQL_FIELD)]: (0, $atdJk.transformAggDatePickerToLegacyField),
        [(0, $814y1.DATE_TIME_GQL_FIELD)]: (0, $hWz6P.transformAggDateTimePickerToLegacyField),
        [(0, $814y1.EPIC_LINK_GQL_FIELD)]: (0, $h6tdv.transformAggEpicLinkToLegacyField),
        [(0, $814y1.FLAG_GQL_FIELD)]: (0, $5IGk7.transformAggFlagToLegacyField),
        [(0, $814y1.FORGE_DATETIME_GQL_FIELD)]: (0, $1ZZyu.transformAggForgeDateTimeToLegacyField),
        [(0, $814y1.FORGE_DATE_GQL_FIELD)]: (0, $aPcUN.transformAggForgeDateToLegacyField),
        [(0, $814y1.FORGE_GROUP_GQL_FIELD)]: (0, $dTYkW.transformAggForgeGroupToLegacyField),
        [(0, $814y1.FORGE_GROUPS_GQL_FIELD)]: (0, $esMH6.transformAggForgeGroupsToLegacyField),
        [(0, $814y1.FORGE_NUMBER_GQL_FIELD)]: (0, $hqVWW.transformAggForgeNumberToLegacyField),
        [(0, $814y1.FORGE_OBJECT_GQL_FIELD)]: (0, $eDXnT.transformAggForgeObjectToLegacyField),
        [(0, $814y1.FORGE_STRING_GQL_FIELD)]: (0, $gmqe0.transformAggForgeStringToLegacyField),
        [(0, $814y1.FORGE_STRINGS_GQL_FIELD)]: (0, $95NMG.transformAggForgeStringsToLegacyField),
        [(0, $814y1.FORGE_USER_GQL_FIELD)]: (0, $kctB6.transformAggForgeUserToLegacyField),
        [(0, $814y1.FORGE_USERS_GQL_FIELD)]: (0, $lBZeI.transformAggForgeUsersToLegacyField),
        [(0, $814y1.ISSUE_RESTRICTION_GQL_FIELD)]: (0, $fj4N6.transformAggIssueRestrictionToLegacyField),
        [(0, $814y1.ISSUE_TYPE_GQL_FIELD)]: (0, $7Elqr.transformAggIssueTypeToLegacyField),
        [(0, $814y1.JSM_APPROVAL_GQL_FIELD)]: (0, $eC8dc.transformAggJSMApprovalsToLegacyField),
        [(0, $814y1.JSM_ASSETS_GQL_FIELD)]: (0, $b8cRA.transformAggAssetToLegacyField),
        [(0, $814y1.JSM_MAJOR_INCIDENT_FIELD)]: (0, $iHCXo.transformAggJSMMajorIncidentToLegacyField),
        [(0, $814y1.JSM_ORGANIZATION_GQL_FIELD)]: (0, $2ZqHG.transformAggJSMOrganizationToLegacyField),
        [(0, $814y1.JSM_ENTITLEMENTS_GQL_FIELD)]: (0, $7Qjvd.transformAggJSMEntitlementsToLegacyField),
        [(0, $814y1.JSM_SENTIMENT_GQL_FIELD)]: (0, $iyjVB.transformAggJSMSentimentToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $814y1.JSM_PEOPLE_GQL_FIELD)]: (0, $7pxBz.transformAggMultipleUserPickerToLegacyField),
        [(0, $814y1.JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, $5x8Qz.transformAggJSMRequestFeedbackToLegacyField),
        [(0, $814y1.JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, $5A5gO.transformAggJSMRequestLanguageToLegacyField),
        [(0, $814y1.JSM_REQUEST_TYPE_GQL_FIELD)]: (0, $fw41c.transformAggJSMRequestTypeToLegacyField),
        [(0, $814y1.JSM_RESPONDERS_GQL_FIELD)]: (0, $8H6KM.transformAggJSMRespondersToLegacyField),
        [(0, $814y1.LABEL_GQL_FIELD)]: (0, $lMiiC.transformAggLabelsNodeToLegacyField),
        [(0, $814y1.PRIORITY_GQL_FIELD)]: (0, $c8gRg.transformAggPriorityToLegacyField),
        [(0, $814y1.MULTI_GROUP_PICKER_GQL_FIELD)]: (0, $gFEWP.transformAggMultiGroupPickerToLegacyField),
        [(0, $814y1.MULTI_USER_PICKER_GQL_FIELD)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $7pxBz.transformAggMultipleUserPickerToLegacyField),
        [(0, $814y1.NUMBER_GQL_FIELD)]: (0, $a6vLL.transformAggNumberToLegacyField),
        [(0, $814y1.ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, $gECU8.transformAggOriginalEstimateToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $814y1.PEOPLE_GQL_FIELD)]: (0, $7pxBz.transformAggMultipleUserPickerToLegacyField),
        [(0, $814y1.PROFORMA_FORMS_GQL_FIELD)]: (0, $1exBo.transformAggProformaFormsToLegacyField),
        [(0, $814y1.PROJECT_GQL_FIELD)]: (0, $gtUzp.transformAggProjectToLegacyField),
        [(0, $814y1.MULTI_VERSION_GQL_FIELD)]: (0, $dAiWn.transformAggMultipleVersionPickerToLegacyField),
        [(0, $814y1.RADIO_GQL_FIELD)]: (0, $5iFQF.transformAggRadioSelectToLegacyField),
        [(0, $814y1.RICH_TEXT_GQL_FIELD)]: (0, $hpJ0s.transformAggRichTextToLegacyField),
        [(0, $814y1.RESOLUTION_GQL_FIELD)]: (0, $dSS0X.transformAggResolutionToLegacyField),
        [(0, $814y1.SECURITY_GQL_FIELD)]: (0, $8plR2.transformAggSecurityLevelToLegacyField),
        [(0, $814y1.SPRINT_GQL_FIELD)]: (0, $dN5mk.transformAggSprintToLegacyField),
        [(0, $814y1.STATUS_GQL_FIELD)]: (0, $2CpT2.transformAggStatusToLegacyField),
        [(0, $814y1.SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, $92N3i.transformAggSingleGroupPickerToLegacyField),
        [(0, $814y1.SINGLE_SELECT_GQL_FIELD)]: (0, $9dsiy.transformAggSingleSelectToLegacyField),
        [(0, $814y1.TEAM_GQL_FIELD)]: (0, $4MVer.transformAggTeamToLegacyField),
        [(0, $814y1.TEAM_VIEW_GQL_FIELD)]: (0, $kPSkL.transformAggTeamViewToLegacyField),
        [(0, $814y1.TEXT_GQL_FIELD)]: (0, $lR2em.transformAggSingleLineTextToLegacyField),
        [(0, $814y1.TIME_TRACKING_GQL_FIELD)]: (0, $gpNkV.transformAggTimeTrackingToLegacyField),
        [(0, $814y1.USER_PICKER_GQL_FIELD)]: (0, $2eP7x.transformAggSingleSelectUserPickerToLegacyField),
        [(0, $814y1.URL_GQL_FIELD)]: (0, $jE1Uq.transformAggUrlToLegacyField),
        [(0, $814y1.VERSION_GQL_FIELD)]: (0, $ksE6r.transformAggSingleVersionPickerToLegacyField),
        [(0, $814y1.VOTES_GQL_FIELD)]: (0, $btvTF.transformAggVotesToLegacyField),
        [(0, $814y1.WATCHES_GQL_FIELD)]: (0, $gujad.transformAggWatchesToLegacyField),
        [(0, $814y1.DATA_CLASSIFICATION_FIELD)]: (0, $78GMW.transformAggDataClassificationToLegacyField),
        [(0, $814y1.GOALS_GQL_FIELD)]: (0, $bl4cc.transformAggGoalsToLegacyField),
        [(0, $814y1.JCS_ORGANIZATION_GQL_FIELD)]: (0, $kk6ni.transformAggJCSOrganizationToLegacyField)
    });
const $2bc37c1610784c31$var$getTransformers = (0, $LFmXM.default)($2bc37c1610784c31$var$getTransformersNonMemoised);
const $2bc37c1610784c31$export$586ba15cbf3d3031 = (node, projectContext)=>{
    const typename = node.__typename;
    const transformer = $2bc37c1610784c31$var$getTransformers()[typename];
    return transformer ? transformer(node, projectContext) : undefined;
};
const $2bc37c1610784c31$export$ba106ff8c087e6b1 = (fields, projectField)=>{
    if (fields == null) return {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields.reduce((fieldsState, fieldEdge)=>{
        if (fieldEdge?.node != null) {
            const projectContext = projectField != null ? projectField : (0, $gtUzp.getProjectField)(fields)?.project;
            const transformedField = $2bc37c1610784c31$export$586ba15cbf3d3031(fieldEdge.node, projectContext);
            if (transformedField != null) {
                const fieldData = 'key' in transformedField ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    [transformedField.key]: transformedField
                } : transformedField;
                Object.assign(fieldsState, fieldData);
            }
        }
        return fieldsState;
    }, {});
};

});
parcelRegister("aFoDn", function(module, exports) {

$parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", () => $fbc7a191f371631a$export$231e0419515441d4);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $fbc7a191f371631a$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
        id: serviceId,
        name: name ?? undefined
    });
const $fbc7a191f371631a$export$231e0419515441d4 = (node)=>{
    if (node.type !== (0, $814y1.SERVICE_ENTITY_CF_TYPE)) return undefined;
    const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
    const value = hasValue ? (0, $8Tw1Q.transformAggConnection)(node.selectedAffectedServicesConnection, $fbc7a191f371631a$var$transformJiraServicesToLegacyServices) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: value,
        schema: {
            configuration: null,
            custom: (0, $814y1.SERVICE_ENTITY_CF_TYPE),
            items: 'service-entity-field',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});
const $6e3c8900fd92f5d7$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $6e3c8900fd92f5d7$export$a4a240cb4053b29f = 'jira-text-renderer';
const $6e3c8900fd92f5d7$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("8Tw1Q", function(module, exports) {

$parcel$export(module.exports, "transformAggNodeToLegacyField", () => $b9bdfd906e198405$export$e7ea61856a169c36);
$parcel$export(module.exports, "transformAggConnection", () => $b9bdfd906e198405$export$daf92cda81d86cdc);
$parcel$export(module.exports, "toLegacyConnectOption", () => $b9bdfd906e198405$export$b5de5f3d2de73afc);
const $b9bdfd906e198405$export$e7ea61856a169c36 = (node)=>({
        ari: 'id' in node ? node.id : undefined,
        key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
        title: 'name' in node ? node.name : '',
        editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
        required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
        autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
        allowedValues: [],
        value: null,
        schema: {
            type: 'type' in node ? node.type : '',
            custom: null,
            system: null
        },
        description: 'description' in node && node.description ? node.description : undefined
    });
const $b9bdfd906e198405$export$daf92cda81d86cdc = (connection, transformCallback)=>{
    const edges = connection?.edges ?? [];
    if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
    return edges.map((edge)=>edge?.node).filter(Boolean);
};
const $b9bdfd906e198405$export$b5de5f3d2de73afc = (node)=>{
    if (!node) return null;
    return {
        value: node.value ?? null,
        id: parseInt(node.optionId, 10)
    };
};

});


parcelRegister("b8cRA", function(module, exports) {

$parcel$export(module.exports, "transformAggAssetToLegacyField", () => $b693f7b60620dcc9$export$2136dcd78a2ef18f);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b693f7b60620dcc9$export$2136dcd78a2ef18f = (node)=>{
    switch(node.type){
        case 0, $814y1.ASSETS_CF_TYPE:
            {
                const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                const assetValue = hasValue ? (0, $8Tw1Q.transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                        appKey: appKey,
                        originId: originId,
                        serializedOrigin: serializedOrigin,
                        value: value
                    })) : null;
                return {
                    ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                    autoCompleteUrl: node.searchUrl,
                    value: assetValue,
                    schema: {
                        custom: node.type,
                        system: null,
                        items: 'sd-asset',
                        type: 'array',
                        renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("avDDJ", function(module, exports) {

$parcel$export(module.exports, "transformAggBooleanToLegacyField", () => $19076dc45029b83c$export$4bd89b95f0d10de9);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $19076dc45029b83c$export$4bd89b95f0d10de9 = (node)=>{
    switch(node.type){
        case 0, $814y1.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: {
                    alertLinking: {
                        enabled: node.value
                    }
                },
                schema: {
                    configuration: null,
                    items: null,
                    renderer: null,
                    custom: null,
                    system: (0, $814y1.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                    type: (0, $814y1.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("kHeCF", function(module, exports) {

$parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", () => $34b9c9aeef57642b$export$a8778af5ceb1017c);


var $8Tw1Q = parcelRequire("8Tw1Q");
const $34b9c9aeef57642b$export$a8778af5ceb1017c = (node)=>{
    let value = null;
    if (node.cascadingOption) {
        const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
        const child = childOptionValue ? {
            child: {
                id: childOptionValue.optionId,
                value: childOptionValue.value
            }
        } : {};
        value = {
            // assigned in the statement above
            id: parentOptionValue?.optionId,
            value: parentOptionValue?.value,
            ...child
        };
    }
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: [],
        schema: {
            type: 'option-with-child',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2Emz9", function(module, exports) {

$parcel$export(module.exports, "transformAggCheckboxToLegacyField", () => $c452c87cf3235dda$export$baa5afdbd8fd12d3);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $c452c87cf3235dda$export$baa5afdbd8fd12d3 = (node)=>{
    switch(node.type){
        case 0, $814y1.MULTI_CHECKBOXES_CF_TYPE:
            {
                // We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
                const value = (0, $8Tw1Q.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                const allowedValues = (0, $8Tw1Q.transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: allowedValues,
                    schema: {
                        type: 'array',
                        renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("3z9ZQ", function(module, exports) {

$parcel$export(module.exports, "transformAggCMDBToLegacyField", () => $f335a71a0f3327b1$export$93506453d9bb56ae);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $f335a71a0f3327b1$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>{
    if (!attribute) return null;
    return {
        workspaceId: workspaceId,
        id: `${workspaceId}:${attribute.objectTypeId}`,
        name: attribute.name,
        objectSchemaId: attribute.objectSchemaId,
        objectTypeId: attribute.objectTypeId,
        // `icon` is unused
        icon: attribute.icon
    };
};
const $f335a71a0f3327b1$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
    if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
        isInsightAvailable: node.isInsightAvailable
    } : {};
    return {
        cmdbFieldConfig: {
            multiple: node.cmdbFieldConfig.multiple,
            objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
            attributesDisplayedOnIssue: (0, $8Tw1Q.transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
            attributesIncludedInAutoCompleteSearch: (0, $8Tw1Q.transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
        },
        isInsightAvailable: node.isInsightAvailable,
        wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
    };
};
const $f335a71a0f3327b1$var$transformObjectTypeAttributeToLegacy = (type)=>{
    switch(type){
        case 'REFERENCED_OBJECT':
            return 1;
        case 'USER':
            return 2;
        case 'GROUP':
            return 4;
        case 'PROJECT':
            return 6;
        case 'STATUS':
            return 7;
        case 'BITBUCKET_REPO':
            return 8;
        case 'OPSGENIE_TEAM':
            return 9;
        case 'DEFAULT':
            return 0;
        default:
            // eslint-disable-next-line no-console
            console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
            return -1;
    }
};
const $f335a71a0f3327b1$var$transformReferencedObject = (node)=>({
        id: node.objectGlobalId,
        workspaceId: node.workspaceId,
        objectKey: node.objectKey,
        label: node.label,
        avatar: node.avatar,
        objectId: node.objectId
    });
const $f335a71a0f3327b1$var$transformCmdbUser = (node)=>({
        avatarUrl: node.picture,
        displayName: node.name,
        name: node.name,
        key: node.accountId
    });
const $f335a71a0f3327b1$var$transformCmdbGroup = (node)=>({
        name: node.name
    });
const $f335a71a0f3327b1$var$transformCmdbProject = (node)=>({
        avatarUrl: node.avatar?.large,
        id: Number(node.id),
        key: node.key,
        name: node.name
    });
const $f335a71a0f3327b1$var$transformCmdbBitbucketRepo = (node)=>({
        uuid: node.uuid,
        name: node.name,
        url: node.url,
        avatarUrl: node.avatarUrl
    });
const $f335a71a0f3327b1$var$transformCmdbOpsgenieTeam = (node)=>({
        id: node.id,
        name: node.name,
        url: node.url
    });
const $f335a71a0f3327b1$var$transformCmdbStatus = (node)=>({
        id: node.id,
        name: node.name,
        category: node.category
    });
const $f335a71a0f3327b1$var$transformObjectAttributeValuesToLegacy = (node)=>{
    if (!node) return null;
    const defaultObjectValue = {
        displayValue: node.displayValue,
        searchValue: node.searchValue,
        ...node.value != null ? {
            value: node.value
        } : {}
    };
    if (node.referencedObject) return {
        ...defaultObjectValue,
        referencedObject: $f335a71a0f3327b1$var$transformReferencedObject(node.referencedObject)
    };
    if (node.user) return {
        ...defaultObjectValue,
        user: $f335a71a0f3327b1$var$transformCmdbUser(node.user)
    };
    if (node.group) return {
        ...defaultObjectValue,
        group: $f335a71a0f3327b1$var$transformCmdbGroup(node.group)
    };
    if (node.project) return {
        ...defaultObjectValue,
        project: $f335a71a0f3327b1$var$transformCmdbProject(node.project)
    };
    if (node.bitbucketRepo) return {
        ...defaultObjectValue,
        bitbucketRepo: $f335a71a0f3327b1$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
    };
    if (node.opsgenieTeam) return {
        ...defaultObjectValue,
        opsgenieTeam: $f335a71a0f3327b1$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
    };
    if (node.status) return {
        ...defaultObjectValue,
        status: $f335a71a0f3327b1$var$transformCmdbStatus(node.status)
    };
    return defaultObjectValue;
};
const $f335a71a0f3327b1$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
    if (!node) return null;
    const { objectTypeAttributeId: objectTypeAttributeId } = node;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const objectTypeAttribute = node.objectTypeAttribute;
    return {
        objectTypeAttributeId: objectTypeAttributeId,
        workspaceId: workspaceId,
        objectAttributeValues: (0, $8Tw1Q.transformAggConnection)(node.objectAttributeValues, $f335a71a0f3327b1$var$transformObjectAttributeValuesToLegacy),
        objectTypeAttribute: {
            id: objectTypeAttributeId,
            label: objectTypeAttribute.label,
            name: objectTypeAttribute.name,
            workspaceId: workspaceId,
            type: $f335a71a0f3327b1$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
            ...objectTypeAttribute.defaultType ? {
                defaultType: {
                    id: objectTypeAttribute.defaultType.id,
                    name: objectTypeAttribute.defaultType.name
                }
            } : {}
        }
    };
};
const $f335a71a0f3327b1$var$transformJiraCMDBToLegacyCMDB = (node)=>{
    if (!node) return null;
    const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, webUrl: webUrl, avatar: avatar } = node;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const workspaceId = node.workspaceId;
    return {
        attributes: (0, $8Tw1Q.transformAggConnection)(node.attributes, (nodeAttribute)=>$f335a71a0f3327b1$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
        avatar: avatar,
        label: label,
        id: objectGlobalId,
        objectId: objectId,
        objectKey: objectKey,
        workspaceId: workspaceId,
        links: {
            self: webUrl
        },
        objectType: $f335a71a0f3327b1$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
    };
};
const $f335a71a0f3327b1$export$93506453d9bb56ae = (node)=>{
    if (node.type !== (0, $814y1.CMDB_OBJECT_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
        configuration: $f335a71a0f3327b1$var$transformCMDBConfigurationToLegacyConfiguration(node),
        value: (0, $8Tw1Q.transformAggConnection)(node.selectedCmdbObjectsConnection, $f335a71a0f3327b1$var$transformJiraCMDBToLegacyCMDB),
        schema: {
            configuration: null,
            custom: (0, $814y1.CMDB_OBJECT_CF_TYPE),
            items: 'cmdb-object-field',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("kIiU4", function(module, exports) {

$parcel$export(module.exports, "transformAggColorToLegacyField", () => $46915e9bf9032cfd$export$587c178f1b45e5e9);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $46915e9bf9032cfd$export$587c178f1b45e5e9 = (node)=>{
    const value = node.color?.colorKey ?? null;
    switch(node.type){
        case 0, $814y1.EPIC_COLOR_TYPE:
        case 0, $814y1.COLOR_CF_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: value,
                schema: {
                    configuration: null,
                    type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
                    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                    custom: node.type,
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("eOcuA", function(module, exports) {

$parcel$export(module.exports, "transformAggComponentsToLegacyField", () => $65b417152350f194$export$97a9275777684b77);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @DoNotExport Flow is deriving component's type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $65b417152350f194$var$transformJiraComponentToLegacyComponent = (component)=>{
    if (component == null) return null;
    return {
        id: component.componentId,
        name: component.name,
        ari: component.ari,
        metadata: component.metadata
    };
};
const $65b417152350f194$export$97a9275777684b77 = (node)=>{
    if (node.type !== (0, $814y1.COMPONENTS_TYPE)) return undefined;
    const value = (0, $8Tw1Q.transformAggConnection)(node.selectedComponentsConnection, $65b417152350f194$var$transformJiraComponentToLegacyComponent);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: value,
        schema: {
            configuration: null,
            items: 'component',
            renderer: (0, $6e3c8900fd92f5d7$export$840ed33fa94f7693),
            type: (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            custom: null,
            system: (0, $814y1.COMPONENTS_TYPE)
        }
    };
};

});

parcelRegister("buly8", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", () => $221506f594bc9cb4$export$e6d015aa746cbdaf);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $221506f594bc9cb4$export$e6d015aa746cbdaf = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.dateTime ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $814y1.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    });

});

parcelRegister("4w7K1", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", () => $b8b4e3981ba17f3d$export$edf5c98d20696686);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b8b4e3981ba17f3d$export$edf5c98d20696686 = (node)=>{
    const value = (0, $8Tw1Q.transformAggConnection)(node.selectedOptions, (0, $8Tw1Q.toLegacyConnectOption));
    const allowedValues = (0, $8Tw1Q.transformAggConnection)(node.connectMultiSelectFieldOptions, (0, $8Tw1Q.toLegacyConnectOption));
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: allowedValues,
        schema: {
            type: (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $814y1.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};

});

parcelRegister("5p7Yl", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectNumberToLegacyField", () => $d4146295cc2f8675$export$4638a5dd3285d8f2);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $d4146295cc2f8675$export$4638a5dd3285d8f2 = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.number ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $814y1.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    });

});

parcelRegister("38Ayh", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", () => $ccba2b4e2894a74a$export$11063e1f9210f191);

var $clRM1 = parcelRequire("clRM1");


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $ccba2b4e2894a74a$var$emptyAdfObject = (0, $clRM1.getEmptyADF)();
const $ccba2b4e2894a74a$var$getPlainTextValue = (node)=>{
    if (!node.richText) return null;
    if (node.richText.plainText == null) return '';
    return node.richText.plainText;
};
const $ccba2b4e2894a74a$export$11063e1f9210f191 = (node)=>{
    const { renderer: renderer } = node;
    if ((0, $h9Xzk.default)(node)) return undefined;
    const isPlainTextRenderer = renderer === (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f);
    const values = isPlainTextRenderer ? {
        value: $ccba2b4e2894a74a$var$getPlainTextValue(node)
    } : {
        adfValue: node.richText?.adfValue?.json || $ccba2b4e2894a74a$var$emptyAdfObject
    };
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        ...values,
        schema: {
            custom: (0, $814y1.TEXT_AREA_CF_TYPE),
            renderer: renderer,
            type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            configuration: null,
            items: null
        }
    };
};

});
parcelRegister("h9Xzk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7b33a46f73dd986$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");
const $a7b33a46f73dd986$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
// If the renderer is missing, log an error and return true.
// This was added as part of https://jplat.atlassian.net/browse/JIV-14881 to help identify why
// fields are sometimes missing the renderer.
const $a7b33a46f73dd986$var$isFieldMissingRenderer = (field)=>{
    try {
        // Narrow the type of field to fields with a renderer
        if (!('renderer' in field)) return false;
        if (field?.renderer) return false;
        (0, $eSnSE.default).safeErrorWithoutCustomerData($a7b33a46f73dd986$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
        return true;
    } catch  {
        return false;
    }
};
var $a7b33a46f73dd986$export$2e2bcd8739ae039 = $a7b33a46f73dd986$var$isFieldMissingRenderer;

});


parcelRegister("A0nGG", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", () => $f44e8e94ee36a4ad$export$e44db7cf61369a28);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $f44e8e94ee36a4ad$export$e44db7cf61369a28 = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: parseInt(node.fieldOption?.optionId, 10),
        value: node.fieldOption?.value
    };
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: (0, $8Tw1Q.transformAggConnection)(node.connectSingleSelectFieldOptions, (0, $8Tw1Q.toLegacyConnectOption)),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $814y1.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("9YIgG", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectTextToLegacyField", () => $fb3ccbbdcae36154$export$dd05277f5aa90657);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $fb3ccbbdcae36154$export$dd05277f5aa90657 = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("78GMW", function(module, exports) {

$parcel$export(module.exports, "transformAggDataClassificationToLegacyField", () => $ed99b79bb25d8ed0$export$b5edfdc89a7a2932);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $ed99b79bb25d8ed0$export$b5edfdc89a7a2932 = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        key: (0, $814y1.DATA_CLASSIFICATION_TYPE),
        value: node,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            custom: null,
            system: null,
            type: (0, $814y1.DATA_CLASSIFICATION_TYPE)
        }
    });

});

parcelRegister("atdJk", function(module, exports) {

$parcel$export(module.exports, "transformAggDatePickerToLegacyField", () => $4b9ed7131bec6e05$export$3d6e51d37c0454a9);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $4b9ed7131bec6e05$export$3d6e51d37c0454a9 = (node)=>{
    switch(node.type){
        case 0, $814y1.DUE_DATE_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $814y1.ISSUE_FIELD_DATE_CF_TYPE),
                    configuration: null,
                    system: node.type,
                    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                    custom: null,
                    items: null
                }
            };
        case 0, $814y1.DATE_CF_TYPE:
        case 0, $814y1.BASELINE_START_CF_TYPE:
        case 0, $814y1.BASELINE_END_CF_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $814y1.ISSUE_FIELD_DATE_CF_TYPE),
                    custom: node.type,
                    configuration: null,
                    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hWz6P", function(module, exports) {

$parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", () => $1a0e6d673c934121$export$3de22f1277f0c239);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $1a0e6d673c934121$var$defaultSchema = {
    type: (0, $814y1.ISSUE_FIELD_DATETIME_CF_TYPE),
    custom: null,
    system: null,
    configuration: null,
    items: null,
    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f)
};
const $1a0e6d673c934121$export$3de22f1277f0c239 = (node)=>{
    switch(node.type){
        case 0, $814y1.CREATED:
        case 0, $814y1.UPDATED:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: node.dateTime || '',
                schema: {
                    ...$1a0e6d673c934121$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $814y1.RESOLUTION_DATE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$1a0e6d673c934121$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $814y1.DATETIME_CF_TYPE:
        case 0, $814y1.FIRST_RESPONSE_DATE_CF_TYPE:
        case 0, $814y1.REQUEST_FEEDBACK_DATE_CF_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$1a0e6d673c934121$var$defaultSchema,
                    custom: node.type
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("h6tdv", function(module, exports) {

$parcel$export(module.exports, "transformAggEpicLinkToLegacyField", () => $e459964244aebe6e$export$1311f30c94840aa2);

var $38IWH = parcelRequire("38IWH");

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $e459964244aebe6e$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
    if (epic == null) return null;
    return {
        id: Number(epic.issueId),
        key: epic.key || '',
        done: !!epic.done,
        name: epic.name || '',
        summary: epic.summary || '',
        color: {
            key: epic.color ?? (0, $38IWH.AgileColors).AGILE_COLOR_1
        },
        // This can only be set from cache handlers
        fromCache: false
    };
};
const $e459964244aebe6e$export$1311f30c94840aa2 = (node)=>{
    if (node.type !== (0, $814y1.EPIC_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: $e459964244aebe6e$var$transformJiraEpicToLegacyEpicLink(node.epic),
        schema: {
            configuration: null,
            items: null,
            renderer: 'jira-text-renderer',
            type: 'any',
            custom: (0, $814y1.EPIC_TYPE),
            system: null
        }
    };
};

});
parcelRegister("38IWH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $92f22b7535e1838e$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $92f22b7535e1838e$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $92f22b7535e1838e$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $92f22b7535e1838e$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $92f22b7535e1838e$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $92f22b7535e1838e$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $92f22b7535e1838e$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $92f22b7535e1838e$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $92f22b7535e1838e$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $92f22b7535e1838e$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $92f22b7535e1838e$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $92f22b7535e1838e$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $92f22b7535e1838e$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $92f22b7535e1838e$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $92f22b7535e1838e$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $92f22b7535e1838e$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $92f22b7535e1838e$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $92f22b7535e1838e$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $92f22b7535e1838e$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $92f22b7535e1838e$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $92f22b7535e1838e$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $92f22b7535e1838e$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $92f22b7535e1838e$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $92f22b7535e1838e$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $92f22b7535e1838e$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $92f22b7535e1838e$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $92f22b7535e1838e$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $92f22b7535e1838e$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $92f22b7535e1838e$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $92f22b7535e1838e$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $92f22b7535e1838e$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $92f22b7535e1838e$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $92f22b7535e1838e$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $92f22b7535e1838e$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $92f22b7535e1838e$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $92f22b7535e1838e$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $92f22b7535e1838e$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $92f22b7535e1838e$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $92f22b7535e1838e$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $92f22b7535e1838e$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $92f22b7535e1838e$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $92f22b7535e1838e$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $92f22b7535e1838e$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $92f22b7535e1838e$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $92f22b7535e1838e$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $92f22b7535e1838e$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $92f22b7535e1838e$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $92f22b7535e1838e$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $92f22b7535e1838e$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $92f22b7535e1838e$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $92f22b7535e1838e$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $92f22b7535e1838e$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $92f22b7535e1838e$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $92f22b7535e1838e$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $92f22b7535e1838e$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $92f22b7535e1838e$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $92f22b7535e1838e$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $92f22b7535e1838e$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $92f22b7535e1838e$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $92f22b7535e1838e$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $92f22b7535e1838e$export$4b7407b8700035bd);
/**
 * @fileoverview This file was moved from `@atlassian/jira-issue-epic-color-types`
 * so that these types do not require atlaskit dependencies.
 *
 * Color constants
 */ const $92f22b7535e1838e$export$7ffdeca4b2f927a2 = 'PURPLE';
const $92f22b7535e1838e$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $92f22b7535e1838e$export$738c3b9a44c87ecc = 'BLUE';
const $92f22b7535e1838e$export$1225f83626261b80 = 'DARK_BLUE';
const $92f22b7535e1838e$export$48d4b2cd5bc0e88b = 'GREEN';
const $92f22b7535e1838e$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $92f22b7535e1838e$export$d0446fe88325854e = 'TEAL';
const $92f22b7535e1838e$export$bb848c92687e69dc = 'DARK_TEAL';
const $92f22b7535e1838e$export$aab610c505c06a8f = 'YELLOW';
const $92f22b7535e1838e$export$466af87757d343a2 = 'DARK_YELLOW';
const $92f22b7535e1838e$export$3de5e29ed1757f9b = 'ORANGE';
const $92f22b7535e1838e$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $92f22b7535e1838e$export$7d278ca694634874 = 'GREY';
const $92f22b7535e1838e$export$26453300bfc61cb8 = 'DARK_GREY';
const $92f22b7535e1838e$export$56d196d2844d1ca1 = [
    $92f22b7535e1838e$export$7ffdeca4b2f927a2,
    $92f22b7535e1838e$export$c815fe495e8174a0,
    $92f22b7535e1838e$export$738c3b9a44c87ecc,
    $92f22b7535e1838e$export$1225f83626261b80,
    $92f22b7535e1838e$export$48d4b2cd5bc0e88b,
    $92f22b7535e1838e$export$c6f4cf2e5768eb78,
    $92f22b7535e1838e$export$d0446fe88325854e,
    $92f22b7535e1838e$export$bb848c92687e69dc,
    $92f22b7535e1838e$export$aab610c505c06a8f,
    $92f22b7535e1838e$export$466af87757d343a2,
    $92f22b7535e1838e$export$3de5e29ed1757f9b,
    $92f22b7535e1838e$export$da02e4820b6ab753,
    $92f22b7535e1838e$export$7d278ca694634874,
    $92f22b7535e1838e$export$26453300bfc61cb8
];
const $92f22b7535e1838e$export$792af22a0198af8d = 'purple';
const $92f22b7535e1838e$export$588af712afdcb006 = 'dark_purple';
const $92f22b7535e1838e$export$84c4918645391802 = 'blue';
const $92f22b7535e1838e$export$b8f1f5838352a33a = 'dark_blue';
const $92f22b7535e1838e$export$9384b7e350ee6542 = 'green';
const $92f22b7535e1838e$export$87d3fb8d8656d38b = 'dark_green';
const $92f22b7535e1838e$export$b0b4ce3e99e66aae = 'teal';
const $92f22b7535e1838e$export$a89b77a449bd223e = 'dark_teal';
const $92f22b7535e1838e$export$9a33b5e3cde94885 = 'yellow';
const $92f22b7535e1838e$export$33253d7862bceb8a = 'dark_yellow';
const $92f22b7535e1838e$export$6609c2b23fc42f39 = 'orange';
const $92f22b7535e1838e$export$cd994662b5911917 = 'dark_orange';
const $92f22b7535e1838e$export$1793d43e13e078c5 = 'grey';
const $92f22b7535e1838e$export$487a6e9145526564 = 'dark_grey';
const $92f22b7535e1838e$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $92f22b7535e1838e$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $92f22b7535e1838e$export$94ac87c81ed074a7 = 'ghx-label-3';
const $92f22b7535e1838e$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $92f22b7535e1838e$export$610a2c132b6fcf96 = 'ghx-label-5';
const $92f22b7535e1838e$export$8e4997dba71f1c40 = 'ghx-label-6';
const $92f22b7535e1838e$export$18a545b4e69b27b4 = 'ghx-label-7';
const $92f22b7535e1838e$export$27fff1a0d295292a = 'ghx-label-8';
const $92f22b7535e1838e$export$e57aa662a56724e1 = 'ghx-label-9';
const $92f22b7535e1838e$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $92f22b7535e1838e$export$457ecb9560f2bf83 = 'ghx-label-11';
const $92f22b7535e1838e$export$a866db37165a696c = 'ghx-label-12';
const $92f22b7535e1838e$export$9b18447c1168a1b6 = 'ghx-label-13';
const $92f22b7535e1838e$export$93b9ad4020e271b7 = 'ghx-label-14';
const $92f22b7535e1838e$export$5cd2af17b34de3e3 = 'color_1';
const $92f22b7535e1838e$export$987671fa69482a7b = 'color_2';
const $92f22b7535e1838e$export$70ba8a5b1f4c7446 = 'color_3';
const $92f22b7535e1838e$export$fcd1c42d8d3ebd36 = 'color_4';
const $92f22b7535e1838e$export$f80a5bd2fa0ba256 = 'color_5';
const $92f22b7535e1838e$export$37ad5ce8d2aeaf78 = 'color_6';
const $92f22b7535e1838e$export$9dc62d5d151cb355 = 'color_7';
const $92f22b7535e1838e$export$1ed15b30f5663f92 = 'color_8';
const $92f22b7535e1838e$export$5d23a84d55ac1644 = 'color_9';
const $92f22b7535e1838e$export$bf08c9a6ed42e349 = 'color_10';
const $92f22b7535e1838e$export$66c5d8f0b5ff279c = 'color_11';
const $92f22b7535e1838e$export$da30755a37c3a597 = 'color_12';
const $92f22b7535e1838e$export$721cf84faff6bf19 = 'color_13';
const $92f22b7535e1838e$export$4b8f8666bd7b61dd = 'color_14';
const $92f22b7535e1838e$export$c537fa0d021d010b = {
    PURPLE: $92f22b7535e1838e$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $92f22b7535e1838e$export$c815fe495e8174a0,
    BLUE: $92f22b7535e1838e$export$738c3b9a44c87ecc,
    DARK_BLUE: $92f22b7535e1838e$export$1225f83626261b80,
    GREEN: $92f22b7535e1838e$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $92f22b7535e1838e$export$c6f4cf2e5768eb78,
    TEAL: $92f22b7535e1838e$export$d0446fe88325854e,
    DARK_TEAL: $92f22b7535e1838e$export$bb848c92687e69dc,
    YELLOW: $92f22b7535e1838e$export$aab610c505c06a8f,
    DARK_YELLOW: $92f22b7535e1838e$export$466af87757d343a2,
    ORANGE: $92f22b7535e1838e$export$3de5e29ed1757f9b,
    DARK_ORANGE: $92f22b7535e1838e$export$da02e4820b6ab753,
    GREY: $92f22b7535e1838e$export$7d278ca694634874,
    DARK_GREY: $92f22b7535e1838e$export$26453300bfc61cb8
};
const $92f22b7535e1838e$export$d33d39828a18210a = {
    SERVER_PURPLE: $92f22b7535e1838e$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $92f22b7535e1838e$export$588af712afdcb006,
    SERVER_BLUE: $92f22b7535e1838e$export$84c4918645391802,
    SERVER_DARK_BLUE: $92f22b7535e1838e$export$b8f1f5838352a33a,
    SERVER_GREEN: $92f22b7535e1838e$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $92f22b7535e1838e$export$87d3fb8d8656d38b,
    SERVER_TEAL: $92f22b7535e1838e$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $92f22b7535e1838e$export$a89b77a449bd223e,
    SERVER_YELLOW: $92f22b7535e1838e$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $92f22b7535e1838e$export$33253d7862bceb8a,
    SERVER_ORANGE: $92f22b7535e1838e$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $92f22b7535e1838e$export$cd994662b5911917,
    SERVER_GREY: $92f22b7535e1838e$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $92f22b7535e1838e$export$487a6e9145526564
};
const $92f22b7535e1838e$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $92f22b7535e1838e$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $92f22b7535e1838e$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $92f22b7535e1838e$export$94ac87c81ed074a7,
    GHX_LABEL_4: $92f22b7535e1838e$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $92f22b7535e1838e$export$610a2c132b6fcf96,
    GHX_LABEL_6: $92f22b7535e1838e$export$8e4997dba71f1c40,
    GHX_LABEL_7: $92f22b7535e1838e$export$18a545b4e69b27b4,
    GHX_LABEL_8: $92f22b7535e1838e$export$27fff1a0d295292a,
    GHX_LABEL_9: $92f22b7535e1838e$export$e57aa662a56724e1,
    GHX_LABEL_10: $92f22b7535e1838e$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $92f22b7535e1838e$export$457ecb9560f2bf83,
    GHX_LABEL_12: $92f22b7535e1838e$export$a866db37165a696c,
    GHX_LABEL_13: $92f22b7535e1838e$export$9b18447c1168a1b6,
    GHX_LABEL_14: $92f22b7535e1838e$export$93b9ad4020e271b7
};
const $92f22b7535e1838e$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $92f22b7535e1838e$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $92f22b7535e1838e$export$987671fa69482a7b,
    AGILE_COLOR_3: $92f22b7535e1838e$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $92f22b7535e1838e$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $92f22b7535e1838e$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $92f22b7535e1838e$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $92f22b7535e1838e$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $92f22b7535e1838e$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $92f22b7535e1838e$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $92f22b7535e1838e$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $92f22b7535e1838e$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $92f22b7535e1838e$export$da30755a37c3a597,
    AGILE_COLOR_13: $92f22b7535e1838e$export$721cf84faff6bf19,
    AGILE_COLOR_14: $92f22b7535e1838e$export$4b8f8666bd7b61dd
};

});


parcelRegister("5IGk7", function(module, exports) {

$parcel$export(module.exports, "transformAggFlagToLegacyField", () => $a3532dc678d08ada$export$31555b6ea19f4c2);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $a3532dc678d08ada$var$transformJiraFlagToLegacyFlag = (flag)=>{
    if (flag == null || flag.isFlagged == null) return null;
    return [
        {
            value: flag.isFlagged
        }
    ];
};
const $a3532dc678d08ada$export$31555b6ea19f4c2 = (node)=>{
    // Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
    if (node.type !== (0, $814y1.MULTI_CHECKBOXES_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $a3532dc678d08ada$var$transformJiraFlagToLegacyFlag(node.flag),
        schema: {
            configuration: null,
            custom: (0, $814y1.FLAGGED_CF_TYPE),
            items: 'option',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("aPcUN", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateToLegacyField", () => $45d2a807fecba84f$export$30fccfce22948120);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $45d2a807fecba84f$export$30fccfce22948120 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.date,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_DATE_CF_TYPE)
        }
    };
};

});

parcelRegister("1ZZyu", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", () => $e0a4b577749ae3db$export$61b1f0cbd04c7b9c);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $e0a4b577749ae3db$export$61b1f0cbd04c7b9c = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.dateTime,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    };
};

});

parcelRegister("dTYkW", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupToLegacyField", () => $6c830c67e2d50cb9$export$60b03d63015cbb9f);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $6c830c67e2d50cb9$export$60b03d63015cbb9f = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.selectedGroup ? {
            name: node.selectedGroup.name
        } : null,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
        }
    };
};

});

parcelRegister("esMH6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", () => $09a4b6c46d9b3fa9$export$2dfa4944fba5d1f5);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $09a4b6c46d9b3fa9$export$2dfa4944fba5d1f5 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    const value = node.selectedGroupsConnection?.edges?.length ? (0, $8Tw1Q.transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
            name: name
        })) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $814y1.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("hqVWW", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeNumberToLegacyField", () => $19fcb5a1ca2a0e66$export$5dab8986dc45db07);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $19fcb5a1ca2a0e66$export$5dab8986dc45db07 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.number,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    };
};

});

parcelRegister("eDXnT", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeObjectToLegacyField", () => $84e4daeebd05036a$export$fbdabdbae2a203b9);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $84e4daeebd05036a$export$fbdabdbae2a203b9 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    const value = (()=>{
        if (node.object == null) return null;
        try {
            return JSON.parse(node.object);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
        }
    })();
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_OBJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("gmqe0", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringToLegacyField", () => $ac8fda7c9b1a7eca$export$3a581fb4b3e578bd);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $ac8fda7c9b1a7eca$export$3a581fb4b3e578bd = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("95NMG", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringsToLegacyField", () => $8d8cd734e91ff053$export$418a06cb5dc6aba5);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $8d8cd734e91ff053$export$418a06cb5dc6aba5 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
    const value = hasValue ? (0, $8Tw1Q.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("kctB6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUserToLegacyField", () => $0fbafb49b1bf00d7$export$bc73c7a747f907e5);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");

var $74RuE = parcelRequire("74RuE");
const $0fbafb49b1bf00d7$export$bc73c7a747f907e5 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $74RuE.transformJiraUserToLegacyServerUser)(node.user) : null,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_USER_CF_TYPE)
        }
    };
};

});
parcelRegister("74RuE", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToLegacyServerUser", () => $e296ae9d66be02be$export$d7b231260a016eaf);

const $e296ae9d66be02be$var$getAccountType = (objectType)=>{
    switch(objectType){
        case 'AtlassianAccountUser':
            return 0, $2a25afeed5eb2192$export$981400c14dd99bc0;
        case 'CustomerUser':
            return 0, $2a25afeed5eb2192$export$2823897fb92cd040;
        case 'AppUser':
            return 0, $2a25afeed5eb2192$export$1973ca62b6c5abfe;
        default:
            return 0, $2a25afeed5eb2192$export$d1f5101c0939e3fe;
    }
};
const $e296ae9d66be02be$var$generateAvatarUrls = (url)=>({
        '16x16': url,
        '24x24': url,
        '32x32': url,
        '48x48': url
    });
const $e296ae9d66be02be$export$d7b231260a016eaf = (user)=>{
    if (!user) return null;
    const userOptionalKeysMap = {
        emailAddress: 'email',
        locale: 'locale',
        timeZone: 'zoneinfo'
    };
    const optionalValues = {};
    Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const aggValue = user[aggKey];
        if (aggValue !== undefined && aggValue !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        optionalValues[key] = aggValue;
    });
    const avatars = user.picture != null ? {
        avatarUrl: user.picture,
        avatarUrls: $e296ae9d66be02be$var$generateAvatarUrls(user.picture)
    } : {};
    return {
        ...avatars,
        ...optionalValues,
        accountId: user.accountId,
        accountType: $e296ae9d66be02be$var$getAccountType(user.__typename),
        active: user.accountStatus === 'active',
        displayName: user.name
    };
};

});
const $2a25afeed5eb2192$export$981400c14dd99bc0 = 'atlassian';
const $2a25afeed5eb2192$export$2823897fb92cd040 = 'customer';
const $2a25afeed5eb2192$export$1973ca62b6c5abfe = 'app';
const $2a25afeed5eb2192$export$d1f5101c0939e3fe = 'unknown';



parcelRegister("lBZeI", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUsersToLegacyField", () => $312acaf5adbb266a$export$bbfea2e2f2c853b8);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");

var $74RuE = parcelRequire("74RuE");
const $312acaf5adbb266a$export$bbfea2e2f2c853b8 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    const value = node.selectedUsersConnection?.edges?.length ? (0, $8Tw1Q.transformAggConnection)(node.selectedUsersConnection, (0, $74RuE.transformJiraUserToLegacyServerUser)) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $814y1.ISSUE_FIELD_USER_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("bl4cc", function(module, exports) {

$parcel$export(module.exports, "transformAggGoalsToLegacyField", () => $c42fa72110704597$export$158301a02ae4cbe7);

var $814y1 = parcelRequire("814y1");

var $7jTnu = parcelRequire("7jTnu");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $c42fa72110704597$export$158301a02ae4cbe7 = (node)=>{
    if (node.type !== (0, $814y1.GOALS_CF_TYPE)) return undefined;
    // eslint-disable-next-line jira/ff/no-preconditioning
    const isShowAllGoals = (0, $7jTnu.fg)('goals_field_with_gpp_in_issue_view') && (0, $7jTnu.fg)('jira-glance-panel');
    const activeSelectedGoals = isShowAllGoals ? node.selectedGoalsShowAllGoals : node.selectedGoals;
    const value = activeSelectedGoals ? {
        goals: activeSelectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>{
            const transformedNode = edge?.node;
            const result = {
                id: transformedNode?.id || '',
                name: transformedNode?.name || '',
                status: transformedNode?.status || null
            };
            // Include key for multi-goal case (key field is only available in selectedGoalsShowAllGoals)
            if (isShowAllGoals && transformedNode) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const nodeWithKey = transformedNode;
                if (nodeWithKey.key) result.key = nodeWithKey.key;
            }
            return result;
        }) || [],
        totalCount: activeSelectedGoals?.totalCount || 0
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $814y1.GOALS_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $814y1.GOALS_CF_TYPE)
        }
    };
};

});

parcelRegister("fj4N6", function(module, exports) {

$parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", () => $23256e2230655f0b$export$62db794d5816e28e);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $23256e2230655f0b$var$transformJiraRoleToRestriction = (role)=>{
    if (role == null) return null;
    return {
        restrictionValue: role.roleId
    };
};
const $23256e2230655f0b$export$62db794d5816e28e = (node, projectContext)=>{
    if (node.type !== (0, $814y1.ISSUE_RESTRICTION_TYPE)) return undefined;
    const roles = (0, $8Tw1Q.transformAggConnection)(node.selectedRolesConnection, $23256e2230655f0b$var$transformJiraRoleToRestriction);
    const restrictions = roles.length > 0 ? {
        projectrole: roles
    } : {};
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: {
            shouldDisplay: projectContext?.canSetIssueRestriction === true,
            issuerestrictions: restrictions
        },
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            type: (0, $814y1.ISSUE_RESTRICTION_TYPE),
            custom: null,
            system: node.type
        }
    };
};

});

parcelRegister("7Elqr", function(module, exports) {

$parcel$export(module.exports, "getSystemAggJiraIssueType", () => $b196dfe2103ffd7c$export$b4644a0cc2f2935e);
$parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", () => $b196dfe2103ffd7c$export$2356062173546155);
$parcel$export(module.exports, "transformAggIssueTypeToLegacyField", () => $b196dfe2103ffd7c$export$de2eb3b47c7c887b);


var $hj7L9 = parcelRequire("hj7L9");

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b196dfe2103ffd7c$export$d95e76b2d065f98d = {
    avatarId: 0,
    self: ''
};
const $b196dfe2103ffd7c$export$b4644a0cc2f2935e = (fields)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, $814y1.ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, $814y1.ISSUE_TYPE))?.node;
    if (issueTypeField == null || issueTypeField.__typename !== (0, $814y1.ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, $814y1.ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, $814y1.ISSUE_TYPE_GQL_FIELD)} with ${(0, $814y1.ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, $814y1.ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
    return issueTypeField.issueType;
};
const $b196dfe2103ffd7c$export$2356062173546155 = (issueType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const id = issueType.issueTypeId;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const hierarchyLevel = issueType.hierarchy?.level;
    return {
        ...$b196dfe2103ffd7c$export$d95e76b2d065f98d,
        id: id,
        iconUrl: issueType.avatar?.medium ?? '',
        name: issueType.name,
        description: 'description' in issueType && issueType.description != null ? issueType.description : '',
        hierarchyLevel: hierarchyLevel,
        subtask: hierarchyLevel === (0, $hj7L9.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
    };
};
const $b196dfe2103ffd7c$export$de2eb3b47c7c887b = (node)=>{
    if (node.type !== (0, $814y1.ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, $814y1.ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, $814y1.ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $b196dfe2103ffd7c$export$2356062173546155(node.issueType),
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: (0, $814y1.ISSUE_TYPE),
            type: (0, $814y1.ISSUE_TYPE)
        }
    };
};

});
parcelRegister("hj7L9", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", () => $a4de97c2b1c75d0a$export$2fe6880f0073407c);

var $eBWnc = parcelRequire("eBWnc");
const $a4de97c2b1c75d0a$export$2fe6880f0073407c = {
    SUBTASK_LEVEL: (0, $eBWnc.ISSUE_HIERARCHY_LEVEL_SUBTASK),
    BASE_LEVEL: (0, $eBWnc.ISSUE_HIERARCHY_LEVEL_BASE),
    LEVEL_ONE: (0, $eBWnc.ISSUE_HIERARCHY_LEVEL_EPIC),
    LEVEL_TWO: 2
};

});
parcelRegister("eBWnc", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $9f3e0c182d6aa29f$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $9f3e0c182d6aa29f$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $9f3e0c182d6aa29f$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $9f3e0c182d6aa29f$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $9f3e0c182d6aa29f$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $9f3e0c182d6aa29f$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $9f3e0c182d6aa29f$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $9f3e0c182d6aa29f$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $9f3e0c182d6aa29f$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $9f3e0c182d6aa29f$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $9f3e0c182d6aa29f$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $9f3e0c182d6aa29f$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $9f3e0c182d6aa29f$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $9f3e0c182d6aa29f$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $9f3e0c182d6aa29f$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $9f3e0c182d6aa29f$export$638ac52227e67c8);
const $9f3e0c182d6aa29f$export$2294cfc7730248df = 4;
const $9f3e0c182d6aa29f$export$961a1d6da881600c = 3;
const $9f3e0c182d6aa29f$export$e11dea67b88ee556 = 2;
const $9f3e0c182d6aa29f$export$9ad20e435294162a = 1;
const $9f3e0c182d6aa29f$export$a454b3474c5ee5f5 = 0;
const $9f3e0c182d6aa29f$export$b69c1b48ce8f83de = -1;
const $9f3e0c182d6aa29f$export$ba7c785763a2a58f = 'BASE';
const $9f3e0c182d6aa29f$export$e09d07f2dcff2603 = 'CHILD';
const $9f3e0c182d6aa29f$export$1165245f61159842 = 'PARENT';
const $9f3e0c182d6aa29f$export$8a96a83b3f957e58 = 'EPIC';
const $9f3e0c182d6aa29f$export$c0c893ca5ccae9dd = (level)=>level;
const $9f3e0c182d6aa29f$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $9f3e0c182d6aa29f$export$a454b3474c5ee5f5;
};
const $9f3e0c182d6aa29f$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $9f3e0c182d6aa29f$export$9ad20e435294162a;
};
const $9f3e0c182d6aa29f$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $9f3e0c182d6aa29f$export$b69c1b48ce8f83de;
};
const $9f3e0c182d6aa29f$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $9f3e0c182d6aa29f$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $9f3e0c182d6aa29f$export$e09d07f2dcff2603;
    return $9f3e0c182d6aa29f$export$ba7c785763a2a58f;
};
const $9f3e0c182d6aa29f$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $9f3e0c182d6aa29f$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $9f3e0c182d6aa29f$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $9f3e0c182d6aa29f$export$e09d07f2dcff2603;
    return $9f3e0c182d6aa29f$export$ba7c785763a2a58f;
};

});



parcelRegister("eC8dc", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", () => $a2eea09779371a38$export$b14d30f2a9e4c343);

var $8BAUB = parcelRequire("8BAUB");

var $814y1 = parcelRequire("814y1");

var $ljej9 = parcelRequire("ljej9");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $74RuE = parcelRequire("74RuE");
const $a2eea09779371a38$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
    if (!approverPrincipal) return undefined;
    switch(approverPrincipal.__typename){
        case 0, $814y1.JSM_USER_APPROVER_PRINCIPAL_FIELD:
            if (!approverPrincipal.user) return undefined;
            return {
                id: (0, $ljej9.toAccountId)(approverPrincipal.user.accountId),
                name: approverPrincipal.user.name,
                meta: {
                    jiraRest: approverPrincipal.jiraRest ?? ''
                },
                type: 'user',
                avatarUrl: approverPrincipal.user.picture
            };
        case 0, $814y1.JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
            if (!approverPrincipal.groupId) return undefined;
            return {
                id: (0, $8BAUB.toGroupId)(approverPrincipal.groupId),
                meta: {
                    memberCount: approverPrincipal.memberCount || 0,
                    approvedCount: approverPrincipal.approvedCount || 0
                },
                name: approverPrincipal.name || '',
                type: 'group'
            };
        default:
            return undefined;
    }
};
const $a2eea09779371a38$var$getApproverDecision = (decision)=>{
    switch(decision){
        case 0, $8BAUB.APPROVER_APPROVED:
            return 0, $8BAUB.APPROVER_APPROVED;
        case 0, $8BAUB.APPROVER_DECLINED:
            return 0, $8BAUB.APPROVER_DECLINED;
        case 0, $8BAUB.APPROVER_PENDING:
        default:
            return 0, $8BAUB.APPROVER_PENDING;
    }
};
const $a2eea09779371a38$var$transformApproverToLegacy = (approvalNode)=>{
    if (!approvalNode) return undefined;
    const approver = (0, $74RuE.transformJiraUserToLegacyServerUser)(approvalNode.approver);
    if (!approver) return undefined;
    return {
        approverDecision: $a2eea09779371a38$var$getApproverDecision(approvalNode.approverDecision),
        approver: approver
    };
};
const $a2eea09779371a38$var$transformConfigurationToLegacy = (configurations)=>{
    // This function contains a lot of null checks and default empty values to satisfy flow because
    // the AGG type coming back is in the shape of [JiraServiceManagementApprovalConfiguration]
    // Which means technically it can be an empty array. Even though we will always only ever
    // get 1 object back.
    const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
    const approverConfiguration = approversConfigurations?.[0];
    return {
        approvers: {
            type: approverConfiguration?.type ?? '',
            customFieldName: approverConfiguration?.fieldName ?? '',
            customFieldId: approverConfiguration?.fieldId ?? ''
        },
        condition: {
            type: condition?.type ?? '',
            value: condition?.value ?? ''
        }
    };
};
const $a2eea09779371a38$var$transformDateToLegacy = (date)=>({
        epochMillis: date ? new Date(date).valueOf() : -1
    });
const $a2eea09779371a38$var$transformStatusToLegacy = (status)=>({
        name: status.name || '',
        category: Number(status.categoryId)
    });
const $a2eea09779371a38$var$transformActiveApprovalToLegacy = (activeApproval)=>{
    const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
    return {
        id: id,
        approvalState: approvalState,
        approvedStatus: approvedStatus,
        finalDecision: $a2eea09779371a38$var$getApproverDecision(finalDecision),
        name: name,
        pendingApprovalCount: pendingApprovalCount,
        canAnswerApproval: canAnswerApproval,
        approverPrincipals: (0, $8Tw1Q.transformAggConnection)(activeApproval.approverPrincipals, $a2eea09779371a38$var$transformApproverPrincipalsToLegacy),
        approvers: (0, $8Tw1Q.transformAggConnection)(activeApproval.approvers, $a2eea09779371a38$var$transformApproverToLegacy),
        configuration: $a2eea09779371a38$var$transformConfigurationToLegacy(configurations),
        createdDate: $a2eea09779371a38$var$transformDateToLegacy(createdDate ?? ''),
        decisions: (0, $8Tw1Q.transformAggConnection)(activeApproval.decisions, $a2eea09779371a38$var$transformApproverToLegacy),
        excludedApprovers: (0, $8Tw1Q.transformAggConnection)(activeApproval.excludedApprovers, (0, $74RuE.transformJiraUserToLegacyServerUser)),
        status: status ? $a2eea09779371a38$var$transformStatusToLegacy(status) : null
    };
};
const $a2eea09779371a38$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
    if (!completedApproval) return undefined;
    const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
    return {
        id: id,
        name: name,
        finalDecision: $a2eea09779371a38$var$getApproverDecision(finalDecision),
        createdDate: $a2eea09779371a38$var$transformDateToLegacy(createdDate ?? ''),
        completedDate: $a2eea09779371a38$var$transformDateToLegacy(completedDate),
        status: status ? $a2eea09779371a38$var$transformStatusToLegacy(status) : null,
        approvers: (0, $8Tw1Q.transformAggConnection)(completedApproval.approvers, $a2eea09779371a38$var$transformApproverToLegacy)
    };
};
const $a2eea09779371a38$export$b14d30f2a9e4c343 = (node)=>{
    if (node.type !== (0, $814y1.SERVICEDESK_APPROVAL_TYPE)) return undefined;
    const activeApproval = node.activeApproval ? {
        activeApproval: $a2eea09779371a38$var$transformActiveApprovalToLegacy(node.activeApproval)
    } : {};
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: {
            ...activeApproval,
            completedApprovals: (0, $8Tw1Q.transformAggConnection)(node.completedApprovalsConnection, $a2eea09779371a38$var$transformCompletedApprovalToLegacy)
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $814y1.SERVICEDESK_APPROVAL_TYPE),
            type: (0, $814y1.SERVICEDESK_APPROVAL_TYPE)
        }
    };
};

});
parcelRegister("8BAUB", function(module, exports) {

$parcel$export(module.exports, "toGroupId", () => $a32e17d33af9616f$export$779c261480444a4d);
$parcel$export(module.exports, "APPROVER_PENDING", () => $a32e17d33af9616f$export$3b59c4db06f5829b);
$parcel$export(module.exports, "APPROVER_APPROVED", () => $a32e17d33af9616f$export$e17ae8ca1010e2a4);
$parcel$export(module.exports, "APPROVER_DECLINED", () => $a32e17d33af9616f$export$b5a0d270c9cd7435);
$parcel$export(module.exports, "APPROVAL_OK", () => $a32e17d33af9616f$export$2e6187b6a4348938);
const $a32e17d33af9616f$export$779c261480444a4d = (x)=>x;
const $a32e17d33af9616f$export$3b59c4db06f5829b = 'pending';
const $a32e17d33af9616f$export$e17ae8ca1010e2a4 = 'approved';
const $a32e17d33af9616f$export$b5a0d270c9cd7435 = 'declined';
const $a32e17d33af9616f$export$2e6187b6a4348938 = 'OK';
const $a32e17d33af9616f$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';

});


parcelRegister("7Qjvd", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", () => $3e00182679906144$export$850fadda8a5e6f27);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $3e00182679906144$export$850fadda8a5e6f27 = (node)=>{
    if (node.type !== (0, $814y1.ENTITLEMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.selectedEntitlement,
        schema: {
            configuration: null,
            custom: (0, $814y1.ENTITLEMENT_CF_TYPE),
            items: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iHCXo", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", () => $c7ffd6a8a8025014$export$d4e0b2288fb31144);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $c7ffd6a8a8025014$export$d4e0b2288fb31144 = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.majorIncident,
        renderedValue: null,
        configuration: {},
        schema: {
            configuration: null,
            custom: (0, $814y1.MAJOR_INCIDENT_CF_TYPE),
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("2ZqHG", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", () => $2d322beb8f2cd6d6$export$7bd14951253a7c5f);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $2d322beb8f2cd6d6$export$7bd14951253a7c5f = (node)=>{
    if (node.type !== (0, $814y1.ORGANIZATIONS_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: (0, $8Tw1Q.transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                id: selectedNode.organizationId,
                name: selectedNode.organizationName
            })),
        schema: {
            configuration: null,
            custom: (0, $814y1.ORGANIZATIONS_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("kk6ni", function(module, exports) {

$parcel$export(module.exports, "transformAggJCSOrganizationToLegacyField", () => $3d5c3716e18b39d8$export$81bfe5b16f9be413);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $3d5c3716e18b39d8$export$81bfe5b16f9be413 = (node)=>{
    if (node.type !== (0, $814y1.ORGANIZATION_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.selectedOrganization,
        schema: {
            configuration: null,
            custom: (0, $814y1.ORGANIZATION_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("5x8Qz", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", () => $7269440389468f87$export$c52c6988b335096);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $7269440389468f87$export$c52c6988b335096 = (node)=>{
    if (node.type !== (0, $814y1.REQUEST_FEEDBACK_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.feedback,
        schema: {
            type: 'sd-feedback',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: (0, $814y1.REQUEST_FEEDBACK_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("5A5gO", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", () => $cf1d539f2192cd8b$export$6a53240e225f742);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $cf1d539f2192cd8b$export$6a53240e225f742 = (node)=>{
    if (node.type !== (0, $814y1.REQUEST_LANGUAGE_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.language,
        allowedValues: [
            ...node.languages ?? []
        ],
        schema: {
            type: 'sd-request-lang',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: (0, $814y1.REQUEST_LANGUAGE_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("fw41c", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", () => $cd769e66cd433490$export$5ffaab1383177efa);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $cd769e66cd433490$var$transformRequestTypeToLegacy = (requestType)=>{
    if (!requestType) return null;
    return {
        requestType: {
            id: parseInt(requestType.requestTypeId, 10),
            issueTypeId: requestType.issueType?.issueTypeId || '',
            name: requestType.name || '',
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': requestType.avatar?.large || ''
                    }
                }
            }
        }
    };
};
const $cd769e66cd433490$export$5ffaab1383177efa = (node)=>{
    if (node.type !== (0, $814y1.REQUEST_TYPE_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...' is not assignable to parameter of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...'.
        value: $cd769e66cd433490$var$transformRequestTypeToLegacy(node.requestType),
        schema: {
            configuration: null,
            custom: (0, $814y1.REQUEST_TYPE_CF_TYPE),
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'sd-customerrequesttype'
        }
    };
};

});

parcelRegister("8H6KM", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", () => $eb05aff33486cf5e$export$5171c4d1ae5bcde5);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $eb05aff33486cf5e$var$transformJiraResponderToLegacyResponder = (responder)=>{
    if (responder == null) return undefined;
    switch(responder.__typename){
        case 0, $814y1.JSM_USER_RESPONDER_GQL_FIELD:
            if (responder.user === null) return undefined;
            return {
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                ari: responder.user.canonicalAccountId,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                avatarUrl: responder.user.picture,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                name: responder.user.name,
                type: 'user'
            };
        case 0, $814y1.JSM_TEAM_RESPONDER_FIELD:
            return {
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                ari: responder.teamId,
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                name: responder.teamName,
                type: 'team'
            };
        default:
            return undefined;
    }
};
const $eb05aff33486cf5e$export$5171c4d1ae5bcde5 = (node)=>{
    if (node.type !== (0, $814y1.RESPONDERS_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: (0, $8Tw1Q.transformAggConnection)(node.respondersConnection, $eb05aff33486cf5e$var$transformJiraResponderToLegacyResponder),
        schema: {
            configuration: null,
            custom: (0, $814y1.RESPONDERS_CF_TYPE),
            items: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iyjVB", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", () => $6924b07eb4bc26b7$export$702d3754a4c7d90a);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $6924b07eb4bc26b7$export$702d3754a4c7d90a = (node)=>{
    if (node.type !== (0, $814y1.SENTIMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.sentiment,
        schema: {
            configuration: null,
            custom: (0, $814y1.SENTIMENT_CF_TYPE),
            items: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("lMiiC", function(module, exports) {

$parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", () => $b41f86ecf5e4d228$export$98e4f56e2e6c44fe);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b41f86ecf5e4d228$var$defaultSchema = {
    configuration: null,
    items: 'string',
    type: (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f)
};
const $b41f86ecf5e4d228$export$98e4f56e2e6c44fe = (node)=>{
    const selectedLabels = (0, $8Tw1Q.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
    switch(node.type){
        case 0, $814y1.LABELS_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: selectedLabels,
                schema: {
                    ...$b41f86ecf5e4d228$var$defaultSchema,
                    custom: null,
                    system: node.type
                }
            };
        case 0, $814y1.LABELS_CF_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                // empty value for custom labels field is null while system labels field is `[]`
                value: selectedLabels.length === 0 ? null : selectedLabels,
                schema: {
                    ...$b41f86ecf5e4d228$var$defaultSchema,
                    custom: node.type,
                    system: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("gFEWP", function(module, exports) {

$parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", () => $643b7d371a35e493$export$f968da580693597d);


var $8Tw1Q = parcelRequire("8Tw1Q");
const $643b7d371a35e493$export$f968da580693597d = (node)=>{
    const value = (0, $8Tw1Q.transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
            groupId: groupNode.groupId,
            name: groupNode.name
        }));
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            type: 'array',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: 'group',
            configuration: null
        }
    };
};

});

parcelRegister("a0aZw", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", () => $3dd5c1f07e748aa4$export$869fb8fbcb97e0ee);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $3dd5c1f07e748aa4$export$869fb8fbcb97e0ee = (node)=>{
    switch(node.type){
        case 0, $814y1.MULTI_SELECT_CF_TYPE:
            {
                const value = (0, $8Tw1Q.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("7pxBz", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", () => $32440852381c3dc7$export$cdd9991119eb040e);

var $ln6Iy = parcelRequire("ln6Iy");


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $gtUzp = parcelRequire("gtUzp");

var $74RuE = parcelRequire("74RuE");
const $32440852381c3dc7$export$cdd9991119eb040e = (node, projectContext)=>{
    const value = (0, $8Tw1Q.transformAggConnection)(node.selectedUsersConnection, (0, $74RuE.transformJiraUserToLegacyServerUser));
    const legacyFieldValues = {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            configuration: null,
            custom: node.type,
            items: 'user',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
    switch(node.type){
        case 0, $814y1.REQUEST_PARTICIPANTS_CF_TYPE:
            if (node.__typename === (0, $814y1.MULTI_USER_PICKER_GQL_FIELD)) return {
                ...legacyFieldValues,
                value: value
            };
            if ((0, $gtUzp.getProjectType)(projectContext?.projectType) !== (0, $ln6Iy.SERVICE_DESK_PROJECT)) return undefined;
            // Empty array is the expected value when there are no request
            // participants.
            return {
                ...legacyFieldValues,
                value: value
            };
        case 0, $814y1.PARTICIPANTS_CF_TYPE:
        case 0, $814y1.MULTI_USER_CF_TYPE:
            return legacyFieldValues;
        case 0, $814y1.APPROVERS_LIST_CF_TYPE:
        case 0, $814y1.PEOPLE_CF_TYPE:
            {
                const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                    {
                        key: 'isMulti',
                        value: String(node.isMulti)
                    }
                ] : null;
                return {
                    ...legacyFieldValues,
                    autoCompleteUrl: node.searchUrl,
                    schema: {
                        ...legacyFieldValues.schema,
                        configuration: schemaConfig
                    }
                };
            }
        default:
            return undefined;
    }
};

});
parcelRegister("gtUzp", function(module, exports) {

$parcel$export(module.exports, "getProjectType", () => $ccb6368d5f105ec2$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProjectField", () => $ccb6368d5f105ec2$export$b19207d974ad5e77);
$parcel$export(module.exports, "getSystemAggJiraProject", () => $ccb6368d5f105ec2$export$d100105d56da4a0a);
$parcel$export(module.exports, "isAggJiraProjectClassic", () => $ccb6368d5f105ec2$export$3502ed01c034e451);
$parcel$export(module.exports, "transformAggSystemProjectToProjectContext", () => $ccb6368d5f105ec2$export$77162d1422f22f47);
$parcel$export(module.exports, "transformAggProjectToLegacyField", () => $ccb6368d5f105ec2$export$30c14b802399f417);

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");



var $814y1 = parcelRequire("814y1");

var $ljej9 = parcelRequire("ljej9");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $ccb6368d5f105ec2$var$getProjectStatus = (status)=>{
    switch(status){
        case 'ACTIVE':
            return 0, $9ac759e54cf0eba0$export$62113557945f790a;
        case 'ARCHIVED':
            return 0, $9ac759e54cf0eba0$export$4ccc35479ba9ad1;
        case 'DELETED':
            return 0, $9ac759e54cf0eba0$export$a95d71e582b8bc0;
        default:
            // Based on `getProjectStatus` from src/packages/issue/issue-view/src/common/service/issue/issue-transformer.js
            return 0, $9ac759e54cf0eba0$export$62113557945f790a;
    }
};
const $ccb6368d5f105ec2$export$3dd0da95519c1a33 = (projectType)=>{
    if (projectType === 'CUSTOMER_SERVICE' && (0, $7jTnu.fg)('jcs_project_type_m3')) return 0, $ln6Iy.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'SERVICE_DESK':
            return 0, $ln6Iy.SERVICE_DESK_PROJECT;
        case 'BUSINESS':
            return 0, $ln6Iy.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $ln6Iy.SOFTWARE_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $ccb6368d5f105ec2$export$b19207d974ad5e77 = (fields)=>{
    /**
	 * The only way to get the type to return an optional value with `AggJiraProject` type
	 * is to re-assign the type wihtout throwing an error.
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields?.find((edge)=>edge?.node?.__typename === (0, $814y1.PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, $814y1.PROJECT_TYPE))?.node;
};
const $ccb6368d5f105ec2$export$d100105d56da4a0a = (fields)=>{
    /**
	 * We only want the system `PROJECT_TYPE` field.
	 * For custom fields, e.g., project picker, see `transformAggProjectToLegacyField`
	 */ const projectField = $ccb6368d5f105ec2$export$b19207d974ad5e77(fields);
    // Needs the `PROJECT_GQL_FIELD` refinement so we can return as `AggJiraProject`
    if (projectField == null || projectField.__typename !== (0, $814y1.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $814y1.PROJECT_GQL_FIELD)} with ${(0, $814y1.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $814y1.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    return projectField.project;
};
const $ccb6368d5f105ec2$export$f7d5cb97957d02e3 = (project)=>project?.projectStyle === 'TEAM_MANAGED_PROJECT';
const $ccb6368d5f105ec2$export$3502ed01c034e451 = (project)=>!$ccb6368d5f105ec2$export$f7d5cb97957d02e3(project);
const $ccb6368d5f105ec2$var$transformAggProjectToServerProjectOption = (project)=>{
    if (project == null) return null;
    const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
    return {
        name: name,
        id: projectId ?? undefined,
        key: (0, $ljej9.toProjectKey)(key),
        avatarUrls: {
            '48x48': avatar?.large || ''
        }
    };
};
const $ccb6368d5f105ec2$export$77162d1422f22f47 = (project)=>{
    const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type } = project;
    const projectType = $ccb6368d5f105ec2$export$3dd0da95519c1a33(type);
    // TODO JPX-34: Remove the need for this; add a fragment in breadcrumbs component to get correct URL from server
    const boardId = 'navigationMetadata' in project ? project.navigationMetadata?.boardId : undefined;
    if (!projectId || !projectType) throw new Error(`Failed to transform system project: projectId ${projectId} and projectType ${String(type)} was invalid`);
    return {
        projectId: projectId,
        projectType: projectType,
        projectName: name,
        projectKey: key,
        projectStatus: $ccb6368d5f105ec2$var$getProjectStatus(status),
        avatarUrl: avatar?.medium,
        isSimplified: $ccb6368d5f105ec2$export$f7d5cb97957d02e3(project),
        boardId: boardId
    };
};
const $ccb6368d5f105ec2$export$275f121d4e6f5165 = (fields)=>{
    const project = $ccb6368d5f105ec2$export$d100105d56da4a0a(fields);
    return $ccb6368d5f105ec2$export$77162d1422f22f47(project);
};
const $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: $ccb6368d5f105ec2$var$transformAggProjectToServerProjectOption(node.project),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            type: (0, $814y1.PROJECT_TYPE),
            custom: (0, $814y1.PROJECT_PICKER_CF_TYPE),
            system: null
        }
    });
const $ccb6368d5f105ec2$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
    // Similar issues field only exist in JSM projects
    if ($ccb6368d5f105ec2$export$3dd0da95519c1a33(node.project?.projectType) !== (0, $ln6Iy.SERVICE_DESK_PROJECT)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        key: (0, $814y1.SIMILAR_ISSUES_TYPE),
        title: (0, $814y1.SIMILAR_ISSUES_TYPE),
        value: node.project?.similarIssues?.featureEnabled === true,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $814y1.SIMILAR_ISSUES_TYPE),
            custom: null,
            system: (0, $814y1.SIMILAR_ISSUES_TYPE)
        }
    };
};
const $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectField = (node)=>{
    if (node?.__typename !== (0, $814y1.PROJECT_GQL_FIELD) || node?.type === null || node?.type !== (0, $814y1.PROJECT_TYPE)) throw new Error(`Failed to get system project data: ${(0, $814y1.PROJECT_GQL_FIELD)} with ${(0, $814y1.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node)}]`);
    const projectField = node;
    if (projectField == null || projectField.__typename !== (0, $814y1.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $814y1.PROJECT_GQL_FIELD)} with ${(0, $814y1.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $814y1.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    const project = projectField.project;
    const { projectType: type } = project;
    const projectType = $ccb6368d5f105ec2$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform project: projectType ${String(project?.projectType)} was invalid`);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: {
            projectType: projectType
        }
    };
};
const $ccb6368d5f105ec2$var$transformAggProjectToLegacyFieldByType = (node)=>{
    const projectType = $ccb6368d5f105ec2$export$3dd0da95519c1a33(node.project?.projectType);
    if (projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT)) // Similar issues field only exist in JSM projects
    return $ccb6368d5f105ec2$var$transformAggProjectToLegacySimilarIssuesField(node);
    if (projectType === (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)) return $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectField(node);
    return undefined;
};
const $ccb6368d5f105ec2$export$30c14b802399f417 = (node)=>{
    if ((0, $7jTnu.fg)('jpd_idea_panel_in_issue_view')) switch(node.type){
        case 0, $814y1.PROJECT_PICKER_CF_TYPE:
            return $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $814y1.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $ccb6368d5f105ec2$var$transformAggProjectToLegacyFieldByType(node);
        default:
            return undefined;
    }
    else switch(node.type){
        case 0, $814y1.PROJECT_PICKER_CF_TYPE:
            return $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $814y1.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $ccb6368d5f105ec2$var$transformAggProjectToLegacySimilarIssuesField(node);
        default:
            return undefined;
    }
};

});
const $9ac759e54cf0eba0$export$62113557945f790a = 'PROJECT_ACTIVE';
const $9ac759e54cf0eba0$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $9ac759e54cf0eba0$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';



parcelRegister("dAiWn", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", () => $e7bc731374bc7784$export$6207ea60703068d8);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $dVGVP = parcelRequire("dVGVP");
const $e7bc731374bc7784$var$defaultSchema = {
    configuration: null,
    custom: null,
    items: 'version',
    renderer: (0, $6e3c8900fd92f5d7$export$840ed33fa94f7693),
    system: null,
    type: 'array'
};
const $e7bc731374bc7784$export$6207ea60703068d8 = (node)=>{
    if (node.type !== (0, $814y1.MULTI_VERSION_CF_TYPE) && node.type !== (0, $814y1.AFFECTS_VERSIONS_TYPE) && node.type !== (0, $814y1.FIX_VERSIONS_TYPE)) return undefined;
    const legacyFieldValues = {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: (0, $8Tw1Q.transformAggConnection)(node.selectedVersionsConnection, (0, $dVGVP.transformAggVersionToLegacyVersion))
    };
    switch(node.type){
        case 0, $814y1.MULTI_VERSION_CF_TYPE:
            return {
                ...legacyFieldValues,
                value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                schema: {
                    ...$e7bc731374bc7784$var$defaultSchema,
                    custom: (0, $814y1.MULTI_VERSION_CF_TYPE)
                }
            };
        case 0, $814y1.AFFECTS_VERSIONS_TYPE:
        case 0, $814y1.FIX_VERSIONS_TYPE:
            return {
                ...legacyFieldValues,
                schema: {
                    ...$e7bc731374bc7784$var$defaultSchema,
                    system: node.type
                }
            };
        default:
            return undefined;
    }
};

});
parcelRegister("dVGVP", function(module, exports) {

$parcel$export(module.exports, "transformAggVersionToLegacyVersion", () => $6d5aa6e85a56b096$export$becef8d087e8b62b);

var $be4Fs = parcelRequire("be4Fs");
const $6d5aa6e85a56b096$export$becef8d087e8b62b = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $be4Fs.VersionStatus).ARCHIVED,
        released: version.status === (0, $be4Fs.VersionStatus).RELEASED,
        ari: version.id
    });

});
parcelRegister("be4Fs", function(module, exports) {

$parcel$export(module.exports, "VersionStatus", () => $5bceeeaddd71111f$export$8c6e0f93bfb5c6a4);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports




var $hj7L9 = parcelRequire("hj7L9");


const $5bceeeaddd71111f$export$8c6e0f93bfb5c6a4 = {
    ARCHIVED: 'ARCHIVED',
    RELEASED: 'RELEASED',
    UNRELEASED: 'UNRELEASED'
};

});



parcelRegister("a6vLL", function(module, exports) {

$parcel$export(module.exports, "transformAggNumberToLegacyField", () => $d06856cdc1673eac$export$d754a24ed0096d2f);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $d06856cdc1673eac$export$d754a24ed0096d2f = (node)=>{
    const fieldType = node.isStoryPointField === true ? (0, $814y1.STORY_POINTS_TYPE) : node.type;
    switch(fieldType){
        case 0, $814y1.NUMBER_CF_TYPE:
        case 0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $814y1.STORY_POINTS_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: node.number ?? null,
                schema: {
                    configuration: null,
                    items: null,
                    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                    custom: fieldType,
                    system: null,
                    type: (0, $814y1.ISSUE_FIELD_NUMBER_CF_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("gECU8", function(module, exports) {

$parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", () => $b90b41b6702a4488$export$f08d02fdc74f920e);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b90b41b6702a4488$export$f08d02fdc74f920e = (node)=>{
    if (node.type !== (0, $814y1.TIME_ESTIMATE_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.originalEstimate?.timeInSeconds ?? null,
        schema: {
            configuration: null,
            custom: null,
            system: node.type,
            items: null,
            type: (0, $814y1.ISSUE_FIELD_NUMBER_CF_TYPE),
            renderer: null
        }
    };
};

});

parcelRegister("c8gRg", function(module, exports) {

$parcel$export(module.exports, "transformAggPriorityToLegacyField", () => $e1ebf74a07d64a5c$export$9e966ce605f800d2);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $e1ebf74a07d64a5c$var$transformJiraPriorityToLegacyPriority = (priority)=>{
    if (priority == null) return null;
    return {
        id: priority.priorityId,
        iconUrl: String(priority.iconUrl || ''),
        name: priority.name || '',
        sequence: priority.sequence || undefined
    };
};
const $e1ebf74a07d64a5c$export$9e966ce605f800d2 = (node)=>{
    if (node.type !== (0, $814y1.PRIORITY_TYPE)) return undefined;
    const allowedValues = (0, $8Tw1Q.transformAggConnection)('priorities' in node ? node.priorities : null, $e1ebf74a07d64a5c$var$transformJiraPriorityToLegacyPriority);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        // @ts-expect-error - Argument of type '{ readonly color: string | null | undefined; readonly iconUrl: string | null | undefined; readonly name: string | null | undefined; readonly priorityId: string; } | { readonly iconUrl: string | ... 1 more ... | undefined; readonly name: string | ... 1 more ... | undefined; readonly priorityId: string; } | { ...; } |...' is not assignable to parameter of type 'AggJiraPriority | null'.
        value: $e1ebf74a07d64a5c$var$transformJiraPriorityToLegacyPriority(node.priority),
        schema: {
            type: (0, $814y1.PRIORITY_TYPE),
            custom: null,
            system: (0, $814y1.PRIORITY_TYPE),
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f)
        }
    };
};

});

parcelRegister("1exBo", function(module, exports) {

$parcel$export(module.exports, "transformAggProformaFormsToLegacyField", () => $8e8dae50d765b259$export$fdcdbf17b0d4e36f);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $8e8dae50d765b259$export$fdcdbf17b0d4e36f = (node)=>{
    if (node.type !== (0, $814y1.PROFORMA_FORMS)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.proformaForms,
        schema: {
            configuration: null,
            items: null,
            system: (0, $814y1.PROFORMA_FORMS),
            custom: null,
            renderer: null,
            type: (0, $814y1.PROFORMA_FORMS)
        }
    };
};

});

parcelRegister("5iFQF", function(module, exports) {

$parcel$export(module.exports, "transformAggRadioSelectToLegacyField", () => $c9221aeb6fc8fb91$export$f147f1eb3a15ccfc);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $c9221aeb6fc8fb91$export$f147f1eb3a15ccfc = (node)=>{
    if (node.type !== (0, $814y1.RADIO_BUTTONS_CF_TYPE)) return undefined;
    const value = node.selectedOption ? {
        id: node.selectedOption?.optionId,
        value: node.selectedOption?.value,
        isDisabled: node.selectedOption?.isDisabled
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("dSS0X", function(module, exports) {

$parcel$export(module.exports, "transformAggResolutionToLegacyField", () => $7eee2703929d5623$export$179f600c7e1d0230);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $7eee2703929d5623$var$resolutionTransformer = (resolution)=>{
    if (resolution == null) return null;
    return {
        id: resolution.resolutionId,
        name: resolution.name || ''
    };
};
const $7eee2703929d5623$export$179f600c7e1d0230 = (node)=>{
    if (node.type !== (0, $814y1.RESOLUTION_TYPE)) return undefined;
    const value = $7eee2703929d5623$var$resolutionTransformer(node.resolution);
    const allowedValues = (0, $8Tw1Q.transformAggConnection)(node.resolutions, $7eee2703929d5623$var$resolutionTransformer);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: (0, $814y1.RESOLUTION_TYPE),
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $814y1.RESOLUTION_TYPE),
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("hpJ0s", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextToLegacyField", () => $f231e7baf13c7424$export$e65ff2ce94be106e);

var $clRM1 = parcelRequire("clRM1");


var $814y1 = parcelRequire("814y1");

var $dk7W5 = parcelRequire("dk7W5");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $f231e7baf13c7424$var$emptyAdfObject = (0, $clRM1.getEmptyADF)();
const $f231e7baf13c7424$var$getSchema = (aggType, renderer)=>{
    switch(aggType){
        case 0, $814y1.TEXT_AREA_CF_TYPE:
            return {
                custom: aggType,
                renderer: renderer,
                type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            };
        case 0, $814y1.DESCRIPTION_TYPE:
        case 0, $814y1.ENVIRONMENT_TYPE:
        default:
            return {
                system: aggType,
                renderer: renderer,
                type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
                custom: null,
                configuration: null,
                items: null
            };
    }
};
// Exactly match the legacy /graphql value, handling the case where the field is empty and has never been edited
// There's no functional difference between `null` or empty string when rendering the field in the issue view.
const $f231e7baf13c7424$var$getPlainTextValue = (node)=>{
    // When the field is empty and a value has never been set
    if (!node.richText) return null;
    // When the field has been set to a value, and then set back to empty
    if (node.richText?.plainText == null) return '';
    return node.richText?.plainText;
};
const $f231e7baf13c7424$export$e65ff2ce94be106e = (node)=>{
    // Description field always renders with ADF
    const { renderer: renderer } = node;
    if ((0, $h9Xzk.default)(node)) return undefined;
    const isPlainTextRenderer = node.type !== (0, $814y1.DESCRIPTION_TYPE) && renderer === (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f);
    if (isPlainTextRenderer) return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $f231e7baf13c7424$var$getPlainTextValue(node),
        schema: $f231e7baf13c7424$var$getSchema(node.type, renderer)
    };
    const adfValueJson = node.richText?.adfValue?.json ?? null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        // The usages of the collection is deprecated.
        adfValue: adfValueJson ? (0, $dk7W5.removeCollectionFromAdf)(adfValueJson) : $f231e7baf13c7424$var$emptyAdfObject,
        value: null,
        schema: $f231e7baf13c7424$var$getSchema(node.type, renderer)
    };
};

});
parcelRegister("dk7W5", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $330901af3cc572d4$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $330901af3cc572d4$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $330901af3cc572d4$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $330901af3cc572d4$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $330901af3cc572d4$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $330901af3cc572d4$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $330901af3cc572d4$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasEmojiNode", () => $330901af3cc572d4$export$8c6c40d1455b914a);
$parcel$export(module.exports, "hasMediaFileNodes", () => $330901af3cc572d4$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $330901af3cc572d4$export$80a6e90c7b29d88c);

var $fpoq4 = parcelRequire("fpoq4");
var $0mclG = parcelRequire("0mclG");

var $eSnSE = parcelRequire("eSnSE");
const $330901af3cc572d4$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $330901af3cc572d4$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($330901af3cc572d4$export$9e9311e676291037)
    };
    return adf;
};
const $330901af3cc572d4$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $330901af3cc572d4$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $330901af3cc572d4$export$9e9311e676291037(adf);
};
const $330901af3cc572d4$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $330901af3cc572d4$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $330901af3cc572d4$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $330901af3cc572d4$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $330901af3cc572d4$export$def86d25f0c7f0bc = (adf)=>$330901af3cc572d4$export$cf4bde415465976c(adf) ? $330901af3cc572d4$export$202742e99f678c60 : adf;
const $330901af3cc572d4$export$8c6c40d1455b914a = (doc)=>{
    let hasEmoji = false;
    (0, $0mclG.traverse)(doc, {
        emoji: ()=>{
            hasEmoji = true;
            return false; // stop traversing
        }
    });
    return hasEmoji;
};
const $330901af3cc572d4$export$9a632b58fb9b287c = (doc)=>{
    const mediaNodes = new Map();
    (0, $0mclG.traverse)(doc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            mediaNodes.set(mediaNode.attrs.id, node);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            mediaNodes.set(mediaInlineNode.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $330901af3cc572d4$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) (0, $0mclG.traverse)(newDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            newMediaNodes.add(mediaNode.attrs.id);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            newMediaNodes.add(mediaInlineNode.attrs.id);
        }
    });
    if (currentDoc) (0, $0mclG.traverse)(currentDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            currentMediaNodes.add(mediaNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
            }
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            currentMediaNodes.add(mediaInlineNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $330901af3cc572d4$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $fpoq4.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $330901af3cc572d4$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await (parcelRequire("hNP9J"));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("lfLtz"));
    const { JSONTransformer: JSONTransformer } = await (parcelRequire("ejy1G"));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("fpoq4", function(module, exports) {

$parcel$export(module.exports, "filter", () => $01d8b182e291a8c9$export$3dea766d36a8935f);

var $0mclG = parcelRequire("0mclG");
function $01d8b182e291a8c9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $0mclG.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});
parcelRegister("0mclG", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $9495d7eb76b80944$export$df3f009e3d155b20);
function $9495d7eb76b80944$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $9495d7eb76b80944$export$df3f009e3d155b20(adf, visitors) {
    if (!$9495d7eb76b80944$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $9495d7eb76b80944$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $9495d7eb76b80944$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $9495d7eb76b80944$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("hNP9J", function(module, exports) {

let $cf5eb1c50a6ffda8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cf5eb1c50a6ffda8$var$load("1XGRs").then(()=>parcelRequire('8DB98'));

});

parcelRegister("lfLtz", function(module, exports) {

let $f78fd3657f90f397$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f78fd3657f90f397$var$load("7r7tG").then(()=>parcelRequire('dmYzn'));

});

parcelRegister("ejy1G", function(module, exports) {

let $a6bd3bf1ff3c9721$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a6bd3bf1ff3c9721$var$load("24hV7").then(()=>parcelRequire('lovmf'));

});



parcelRegister("8plR2", function(module, exports) {

$parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", () => $d33aa6cc7441217e$export$45e25e2a6750ea5a);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $d33aa6cc7441217e$var$transformJiraSecurityLevel = (securityLevel)=>{
    if (securityLevel == null) return null;
    return {
        id: securityLevel.securityId,
        description: securityLevel.description || '',
        name: securityLevel.name || ''
    };
};
const $d33aa6cc7441217e$export$45e25e2a6750ea5a = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $d33aa6cc7441217e$var$transformJiraSecurityLevel(node.securityLevel),
        allowedValues: (0, $8Tw1Q.transformAggConnection)(node.securityLevels, $d33aa6cc7441217e$var$transformJiraSecurityLevel),
        schema: {
            configuration: null,
            type: (0, $814y1.SECURITY_LEVEL_TYPE_OVERRIDE),
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $814y1.SECURITY_LEVEL_TYPE),
            items: null
        }
    });

});

parcelRegister("92N3i", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", () => $8b96c0b3204c894a$export$e6697ec5bdac9ec0);


var $8Tw1Q = parcelRequire("8Tw1Q");
const $8b96c0b3204c894a$export$e6697ec5bdac9ec0 = (node)=>{
    const value = node.selectedGroup != null ? {
        groupId: node.selectedGroup.groupId,
        name: node.selectedGroup.name
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'group',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("lR2em", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", () => $659d7d4b8257722d$export$31f32b3fd9e5ab6);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $659d7d4b8257722d$var$defaultSchema = {
    configuration: null,
    items: null,
    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f)
};
const $659d7d4b8257722d$export$31f32b3fd9e5ab6 = (node)=>{
    const defaultTransformedField = {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.text
    };
    switch(node.type){
        case 0, $814y1.EPIC_NAME_TYPE:
        case 0, $814y1.MESSAGE_EDIT_CF_TYPE:
        case 0, $814y1.MESSAGE_VIEW_CF_TYPE:
        case 0, $814y1.READ_ONLY_CF_TYPE:
        case 0, $814y1.TEXT_CF_TYPE:
        case 0, $814y1.USER_PROPERTY_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$659d7d4b8257722d$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE)
                }
            };
        case 0, $814y1.RANK_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$659d7d4b8257722d$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $814y1.ISSUE_FIELD_ANY_CF_TYPE)
                }
            };
        case 0, $814y1.SUMMARY_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$659d7d4b8257722d$var$defaultSchema,
                    type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    system: node.type
                }
            };
        case 0, $814y1.SERVICEDESK_PRACTICES_TYPE:
            // Transform field only if the practice has a value
            return node.text != null ? {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: [
                    node.text
                ],
                schema: {
                    ...$659d7d4b8257722d$var$defaultSchema,
                    renderer: null,
                    custom: null,
                    system: node.type,
                    type: (0, $814y1.SERVICEDESK_PRACTICES_TYPE)
                }
            } : undefined;
        default:
            return undefined;
    }
};

});

parcelRegister("9dsiy", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectToLegacyField", () => $1f5f63ca883225b4$export$4e113f935e09d226);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $1f5f63ca883225b4$var$getField = (node, customType)=>{
    const value = node.fieldOption != null ? {
        ari: node.fieldOption.id,
        id: node.fieldOption.optionId,
        value: node.fieldOption.value
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: customType || node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};
const $1f5f63ca883225b4$export$4e113f935e09d226 = (node)=>{
    switch(node.type){
        case 0, $814y1.EPIC_STATUS_TYPE:
        case 0, $814y1.SELECT_CF_TYPE:
            return $1f5f63ca883225b4$var$getField(node);
        case 0, $814y1.CATEGORY_TYPE:
            return $1f5f63ca883225b4$var$getField(node, (0, $814y1.SELECT_CF_TYPE));
        default:
            return undefined;
    }
};

});

parcelRegister("2eP7x", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", () => $b86adefd697ce3f4$export$7bf73fc06c6d71be);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $74RuE = parcelRequire("74RuE");
const $b86adefd697ce3f4$export$7bf73fc06c6d71be = (node)=>{
    const legacyField = {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $74RuE.transformJiraUserToLegacyServerUser)(node.user) : null
    };
    switch(node.type){
        case 0, $814y1.ASSIGNEE_TYPE:
        case 0, $814y1.REPORTER_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $814y1.ISSUE_FIELD_USER_CF_TYPE),
                    custom: null,
                    system: node.type,
                    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        case 0, $814y1.USER_CF_TYPE:
        case 0, $814y1.LAST_UPDATER_OR_COMMENTER_CF_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $814y1.ISSUE_FIELD_USER_CF_TYPE),
                    custom: node.type,
                    system: null,
                    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("ksE6r", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", () => $fa047c4e6c9f5935$export$d03f622577260442);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $dVGVP = parcelRequire("dVGVP");
const $fa047c4e6c9f5935$export$d03f622577260442 = (node)=>{
    if (node.type !== (0, $814y1.VERSION_CF_TYPE)) return undefined;
    const allowedValues = (0, $8Tw1Q.transformAggConnection)(null, (0, $dVGVP.transformAggVersionToLegacyVersion));
    const value = node.version ? (0, $dVGVP.transformAggVersionToLegacyVersion)(node.version) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            type: (0, $814y1.ISSUE_FIELD_VERSION_CF_TYPE),
            custom: (0, $814y1.VERSION_CF_TYPE),
            system: null
        }
    };
};

});

parcelRegister("dN5mk", function(module, exports) {

$parcel$export(module.exports, "transformAggSprintToLegacyField", () => $01a8b99e170d26ed$export$9b5bb05d50970021);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $01a8b99e170d26ed$var$SprintOptionalKeyMap = {
    goal: 'goal',
    completeDate: 'completionDate',
    startDate: 'startDate',
    endDate: 'endDate'
};
const $01a8b99e170d26ed$var$transformAggSprintToLegacySprint = (sprint)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionalValues = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys($01a8b99e170d26ed$var$SprintOptionalKeyMap).forEach((key)=>{
        const aggKey = $01a8b99e170d26ed$var$SprintOptionalKeyMap[key];
        const aggValue = sprint[aggKey];
        if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
    });
    return {
        id: Number(sprint.sprintId),
        name: sprint?.name ?? '',
        state: sprint.state?.toLowerCase(),
        boardId: Number(sprint.boardName) || 0,
        ...optionalValues
    };
};
const $01a8b99e170d26ed$export$9b5bb05d50970021 = (node)=>{
    if (node.type !== (0, $814y1.SPRINT_TYPE)) return undefined;
    const sprints = (0, $8Tw1Q.transformAggConnection)(node.selectedSprintsConnection, $01a8b99e170d26ed$var$transformAggSprintToLegacySprint);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: sprints,
        schema: {
            configuration: null,
            custom: (0, $814y1.SPRINT_TYPE),
            items: 'json',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("2CpT2", function(module, exports) {

$parcel$export(module.exports, "getStatusesDeprecatedValue", () => $f310693121110726$export$b80ec59d806c2f94);
$parcel$export(module.exports, "transformAggStatusToLegacyField", () => $f310693121110726$export$c80e5acb1c882c48);

var $7keuM = parcelRequire("7keuM");

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $f310693121110726$export$b80ec59d806c2f94 = (fields)=>{
    const { status: status } = fields;
    if (!status || status.value == null) return {};
    const { value: value } = status;
    return {
        [value.id]: {
            id: value.id,
            name: value.name,
            statusCategory: (0, $7keuM.statusCategoryForId)(value.statusCategory?.id)
        }
    };
};
const $f310693121110726$var$transformJiraStatusToLegacyStatus = (status)=>{
    if (!status || !status.statusCategory) return null;
    const { statusCategory: statusCategory } = status;
    return {
        id: status.statusId,
        name: status.name || '',
        statusCategory: {
            id: Number(statusCategory.statusCategoryId)
        }
    };
};
const $f310693121110726$export$c80e5acb1c882c48 = (node)=>{
    if (node.type !== (0, $814y1.STATUS_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $f310693121110726$var$transformJiraStatusToLegacyStatus(node.status),
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $814y1.STATUS_TYPE),
            custom: null,
            system: (0, $814y1.STATUS_TYPE)
        }
    };
};

});

parcelRegister("4MVer", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamToLegacyField", () => $0bbc3c7042b91d39$export$fb1b80497e96456f);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $0bbc3c7042b91d39$export$fb1b80497e96456f = (node)=>{
    if (node.type !== (0, $814y1.TEAM_CF_TYPE)) return undefined;
    const value = node.selectedTeam ? {
        id: node.selectedTeam.teamId,
        title: node.selectedTeam.name,
        isShared: node.selectedTeam.isShared,
        avatarUrl: node.selectedTeam.avatar?.medium
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $814y1.TEAM_CF_TYPE),
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: (0, $814y1.ISSUE_FIELD_ANY_CF_TYPE)
        }
    };
};

});

parcelRegister("kPSkL", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamViewToLegacyField", () => $ce17f04c98aba2c2$export$6f6aaafb49bd4769);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $ce17f04c98aba2c2$var$transformAggTeamViewToLegacyTeam = (team)=>{
    if (team == null) return null;
    return {
        id: team.jiraSuppliedTeamId,
        name: team.jiraSuppliedName || '',
        isVisible: team.jiraSuppliedVisibility || false,
        avatarUrl: team.jiraSuppliedAvatar?.xsmall || '',
        isVerified: team.jiraSuppliedIsVerified || false
    };
};
const $ce17f04c98aba2c2$export$6f6aaafb49bd4769 = (node)=>{
    if (node.type !== (0, $814y1.TEAMS_PLATFORM_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...' is not assignable to parameter of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...'.
        value: $ce17f04c98aba2c2$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
        schema: {
            configuration: null,
            custom: (0, $814y1.TEAMS_PLATFORM_CF_TYPE),
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'team'
        }
    };
};

});

parcelRegister("gpNkV", function(module, exports) {

$parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", () => $ee864f653750a614$export$874d9bd14269ec6f);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $ee864f653750a614$var$getEstimateValues = (estimate, key)=>{
    if (estimate) return {
        [key]: estimate.timeInSeconds || 0
    };
    return {};
};
const $ee864f653750a614$export$874d9bd14269ec6f = (node)=>{
    if (node.type !== (0, $814y1.TIME_TRACKING_TYPE)) return undefined;
    const originalEstimate = $ee864f653750a614$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
    const remainingEstimate = $ee864f653750a614$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
    const timeSpent = $ee864f653750a614$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: {
            ...originalEstimate,
            ...remainingEstimate,
            ...timeSpent
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: (0, $814y1.TIME_TRACKING_TYPE),
            type: (0, $814y1.TIME_TRACKING_TYPE)
        }
    };
};

});

parcelRegister("jE1Uq", function(module, exports) {

$parcel$export(module.exports, "transformAggUrlToLegacyField", () => $f61b428b363526c3$export$6e950e0ec9801f6c);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $f61b428b363526c3$export$6e950e0ec9801f6c = (node)=>{
    if (node.type !== (0, $814y1.URL_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.uri ?? null,
        schema: {
            configuration: null,
            custom: (0, $814y1.URL_CF_TYPE),
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("btvTF", function(module, exports) {

$parcel$export(module.exports, "transformAggVotesToLegacyField", () => $95434af0f8409f2f$export$8966614b8594736);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $95434af0f8409f2f$var$transformAggVoteToLegacyVote = (vote)=>({
        votes: vote.count != null ? Number(vote.count) : 0,
        hasVoted: vote.hasVoted ?? false
    });
const $95434af0f8409f2f$export$8966614b8594736 = (node)=>{
    if (node.type !== (0, $814y1.VOTES_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.vote ? $95434af0f8409f2f$var$transformAggVoteToLegacyVote(node.vote) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $814y1.VOTES_TYPE),
            type: (0, $814y1.VOTES_TYPE)
        }
    };
};

});

parcelRegister("gujad", function(module, exports) {

$parcel$export(module.exports, "transformAggWatchesToLegacyField", () => $e1ddb36e41b722e0$export$6730cb17d10d6156);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $e1ddb36e41b722e0$var$transformAggWatchesToLegacyWatches = (watch)=>({
        watchCount: watch.count != null ? Number(watch.count) : 0,
        isWatching: watch.isWatching ?? false
    });
const $e1ddb36e41b722e0$export$6730cb17d10d6156 = (node)=>{
    if (node.type !== (0, $814y1.WATCHES_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.watch ? $e1ddb36e41b722e0$var$transformAggWatchesToLegacyWatches(node.watch) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $814y1.WATCHES_TYPE),
            type: (0, $814y1.WATCHES_TYPE)
        }
    };
};

});


parcelRegister("7QMat", function(module, exports) {

$parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", () => $24cb110b5fbfe797$export$d8a5feb2bb0425b4);
const $24cb110b5fbfe797$export$d8a5feb2bb0425b4 = (parentIssue)=>{
    if (!parentIssue) return null;
    return {
        id: parentIssue.issueId,
        ari: parentIssue.id,
        key: parentIssue.key,
        self: parentIssue.webUrl,
        color: parentIssue.issueColorField?.color?.colorKey,
        fields: {
            summary: parentIssue.summaryField?.text,
            issuetype: {
                name: parentIssue.issueTypeField?.issueType?.name,
                iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                // We do not have this data
                id: '',
                self: '',
                description: '',
                subtask: false,
                avatarId: 0,
                hierarchyLevel: 0
            }
        }
    };
};

});

parcelRegister("i6YHz", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextFieldValueToLegacyFieldValue", () => $3ee48b837f83cdcc$export$b3a2c3992977726e);

var $clRM1 = parcelRequire("clRM1");


var $dk7W5 = parcelRequire("dk7W5");
const $3ee48b837f83cdcc$var$emptyAdfObject = (0, $clRM1.getEmptyADF)();
const $3ee48b837f83cdcc$export$b3a2c3992977726e = (richText, renderer)=>{
    if (!renderer) throw new Error('aggFieldChangeProps did not have renderer');
    if (renderer === (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f)) {
        if (richText.plainText !== undefined) return richText.plainText;
        return richText?.adfValue?.convertedPlainText?.plainText;
    }
    return richText?.adfValue?.json ? (0, $dk7W5.removeCollectionFromAdf)(richText?.adfValue?.json) : $3ee48b837f83cdcc$var$emptyAdfObject;
};

});


parcelRegister("4P77p", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $5d2cfcdff3aefb29$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $5d2cfcdff3aefb29$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $5d2cfcdff3aefb29$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $5d2cfcdff3aefb29$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $5d2cfcdff3aefb29$export$8db21fc94823e1cc = {
    [$5d2cfcdff3aefb29$var$FIELD_CHANGE_REQUESTED]: $5d2cfcdff3aefb29$var$FIELD_CHANGE_REQUESTED,
    [$5d2cfcdff3aefb29$var$FIELD_CHANGE_FAILED]: $5d2cfcdff3aefb29$var$FIELD_CHANGE_FAILED,
    [$5d2cfcdff3aefb29$var$FIELD_CHANGED]: $5d2cfcdff3aefb29$var$FIELD_CHANGED
};

});


parcelRegister("4im1M", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $bb7ff1168b248128$export$80c2a3957bcb42ea);

var $eJOHy = parcelRequire("eJOHy");
const $bb7ff1168b248128$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});

parcelRegister("iaPZb", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $21527ec442db63fe$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $21527ec442db63fe$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $21527ec442db63fe$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $21527ec442db63fe$export$33b78476f5d734b3);

var $jGzN3 = parcelRequire("jGzN3");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $21527ec442db63fe$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $21527ec442db63fe$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue)=>(0, $jGzN3.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($21527ec442db63fe$var$getFieldUpdate(fieldKey, newValue))
    });
const $21527ec442db63fe$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue)=>(0, $jGzN3.performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($21527ec442db63fe$var$getFieldUpdate(fieldKey, newValue))
    });
const $21527ec442db63fe$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $jGzN3.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $21527ec442db63fe$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $jGzN3.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("aASNQ", function(module, exports) {

$parcel$export(module.exports, "useMajorIncidentConfig", () => $6598a2ff4d310444$export$4fa770b3011492c);

var $eJOHy = parcelRequire("eJOHy");

var $2rHwS = parcelRequire("2rHwS");

var $814y1 = parcelRequire("814y1");
const $6598a2ff4d310444$export$4fa770b3011492c = (issueKey)=>{
    const [{ value: fieldConfig }] = (0, $2rHwS.useIssueFieldConfig)(issueKey);
    const [majorIncidentFieldIdKey, searchUrl, fieldType] = (0, $eJOHy.useMemo)(()=>{
        if (fieldConfig != null) {
            const fieldId = Object.keys(fieldConfig).find((fieldKey)=>fieldConfig[fieldKey].schema.custom === (0, $814y1.MAJOR_INCIDENT_CF_TYPE));
            if (fieldId != null) {
                const majorIncidentConfig = fieldConfig[fieldId];
                const { autoCompleteUrl: autoCompleteUrl, schema: { type: type } } = majorIncidentConfig;
                return [
                    fieldId,
                    autoCompleteUrl || '',
                    type
                ];
            }
        }
        return [
            '',
            '',
            'string'
        ];
    }, [
        fieldConfig
    ]);
    return {
        majorIncidentFieldIdKey: majorIncidentFieldIdKey,
        searchUrl: searchUrl,
        fieldType: fieldType
    };
};

});
parcelRegister("2rHwS", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $9c87b1a177d5273e$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $9c87b1a177d5273e$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $9c87b1a177d5273e$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $9c87b1a177d5273e$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $9c87b1a177d5273e$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $9c87b1a177d5273e$export$28a22fd0dedf31b7);

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $7jTnu = parcelRequire("7jTnu");

var $fAZgY = parcelRequire("fAZgY");

var $1uIew = parcelRequire("1uIew");

var $jGzN3 = parcelRequire("jGzN3");

var $XGDec = parcelRequire("XGDec");

var $3KXZZ = parcelRequire("3KXZZ");

var $3ibpe = parcelRequire("3ibpe");

var $4im1M = parcelRequire("4im1M");

var $b1smt = parcelRequire("b1smt");
const $9c87b1a177d5273e$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: (0, $3KXZZ.IssueViewFetchOperations).FIELD_CONFIGURATION,
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: 'Issue View Field Configuration Query',
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
    (0, $3ibpe.sendExperienceAnalytics)($9c87b1a177d5273e$var$fieldConfigurationQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error?.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $1uIew.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {}
    }));
};
const $9c87b1a177d5273e$var$fetchData = async (issueKey)=>{
    try {
        const response = await (0, $jGzN3.performPostRequest)((0, $XGDec.getGraphQlUrl)((0, $3KXZZ.IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $9c87b1a177d5273e$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response?.data?.issue?.fields) {
            const fieldConfigData = response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
            (result, field)=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...result,
                    [field.key]: {
                        autoCompleteUrl: field.autoCompleteUrl,
                        allowedValues: field.allowedValues,
                        isEditable: field.editable,
                        isRequired: field.required,
                        schema: field.schema,
                        title: field.title,
                        ...field.description ? {
                            description: field.description
                        } : {}
                    }
                }), {});
            $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: true
            });
            return fieldConfigData;
        }
        $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: new Error('Unexpected field configuration response')
        });
        return null;
    } catch (error) {
        $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: error instanceof (0, $1uIew.default) ? error : undefined
        });
        return null;
    }
};
const $9c87b1a177d5273e$var$requestSet = new Set();
const $9c87b1a177d5273e$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $9c87b1a177d5273e$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $9c87b1a177d5273e$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $4im1M.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $b1smt.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $eJOHy.useState)(()=>!skipRefresh && value === undefined && !$9c87b1a177d5273e$var$requestSet.has(issueKey));
    const getData = (0, $eJOHy.useCallback)(async ()=>{
        setLoading(true);
        $9c87b1a177d5273e$var$requestSet.add(issueKey);
        const result = await $9c87b1a177d5273e$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $9c87b1a177d5273e$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const shouldGetData = (0, $7jTnu.fg)('jiv-19312-fix-fieldconfigurationquery-refetch') ? !skipRefresh && !$9c87b1a177d5273e$var$requestSet.has(issueKey) && value === undefined && issueKey !== '' : !skipRefresh && !$9c87b1a177d5273e$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                loading: loading
            }
        ], [
        loading
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $b1smt.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $b1smt.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $eJOHy.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $9c87b1a177d5273e$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $b1smt.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $b1smt.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $9c87b1a177d5273e$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $9c87b1a177d5273e$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $9c87b1a177d5273e$var$useIssueFieldConfigRefetch(issueKey, value);
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value,
                loading: loading
            }
        ], [
        loading,
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $9c87b1a177d5273e$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value
            }
        ], [
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $b1smt.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $9c87b1a177d5273e$var$useIssueFieldConfigRefetch(issueKey, value);
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value,
                loading: loading
            }
        ], [
        loading,
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $9c87b1a177d5273e$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $9c87b1a177d5273e$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $9c87b1a177d5273e$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value,
                loading: loading
            }
        ], [
        loading,
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $9c87b1a177d5273e$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value
            }
        ], [
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $b1smt.useFieldConfigStoreActions)();
    const actions = (0, $eJOHy.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("XGDec", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $d2d607861b22c2c1$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $d2d607861b22c2c1$export$f2fec0cacdfabaaf);

var $cTI7h = parcelRequire("cTI7h");

var $bcdww = parcelRequire("bcdww");

const $d2d607861b22c2c1$export$5647e6bbf2b3526f = (operation)=>`/rest/graphql/1/${(0, $cTI7h.appendOperationQuery)(operation)}`;
const $d2d607861b22c2c1$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $bcdww.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("bcdww", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ded878d9b9c772$export$2e2bcd8739ae039);
const $c8ded878d9b9c772$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $c8ded878d9b9c772$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $c8ded878d9b9c772$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $c8ded878d9b9c772$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $c8ded878d9b9c772$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $c8ded878d9b9c772$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$c8ded878d9b9c772$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$c8ded878d9b9c772$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$c8ded878d9b9c772$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$c8ded878d9b9c772$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$c8ded878d9b9c772$var$getIsHybridAgilityProjectQuery()}
            ${$c8ded878d9b9c772$var$getAgileQuery()}
        }
        ${$c8ded878d9b9c772$var$getProjectQuery(projectKey)}
    }`;

});


parcelRegister("3KXZZ", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $cc433f27aee6ba76$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $cc433f27aee6ba76$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $cc433f27aee6ba76$export$b38f30d67f730bc4);
const $cc433f27aee6ba76$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $cc433f27aee6ba76$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $cc433f27aee6ba76$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("b1smt", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $f4887671cea7e277$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $f4887671cea7e277$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $f4887671cea7e277$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $f4887671cea7e277$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $f4887671cea7e277$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $f4887671cea7e277$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $f4887671cea7e277$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $f4887671cea7e277$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $f4887671cea7e277$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $ahm5r = parcelRequire("ahm5r");

var $1O6Yz = parcelRequire("1O6Yz");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $f4887671cea7e277$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $f4887671cea7e277$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $f4887671cea7e277$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $f4887671cea7e277$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState(), newIssues));
    };
const $f4887671cea7e277$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $f4887671cea7e277$var$actions = {
    setIssueConfig: $f4887671cea7e277$var$setIssueConfig,
    setIssuesConfig: $f4887671cea7e277$var$setIssuesConfig,
    mergeIssueConfig: $f4887671cea7e277$var$mergeIssueConfig,
    mergeIssuesConfig: $f4887671cea7e277$var$mergeIssuesConfig,
    setFieldConfigValue: $f4887671cea7e277$var$setFieldConfigValue
};
// this is a global state
const $f4887671cea7e277$var$store = (0, $GtRbT.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $f4887671cea7e277$var$actions
});
const $f4887671cea7e277$var$getIssueFieldConfig = (0, $ahm5r.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $f4887671cea7e277$export$52f51db4e2b3da57 = (0, $iJq0l.createHook)($f4887671cea7e277$var$store, {
    selector: $f4887671cea7e277$var$getIssueFieldConfig
});
const $f4887671cea7e277$var$getFieldConfig = (0, $ahm5r.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $f4887671cea7e277$var$getFieldConfigWithLabel = (0, $ahm5r.createSelector)($f4887671cea7e277$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $f4887671cea7e277$var$getFieldOptionsOverrides = (0, $ahm5r.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $f4887671cea7e277$export$f9beb98c7488fd61 = (0, $iJq0l.createHook)($f4887671cea7e277$var$store, {
    selector: $f4887671cea7e277$var$getFieldConfig
});
const $f4887671cea7e277$export$314199caf05d245 = (0, $iJq0l.createHook)($f4887671cea7e277$var$store, {
    selector: null
});
const $f4887671cea7e277$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $f4887671cea7e277$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $f4887671cea7e277$var$overridesActions = {
    setFieldConfigOverridesValue: $f4887671cea7e277$var$setOverrides,
    resetOverridesStore: $f4887671cea7e277$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $f4887671cea7e277$var$overridesStore = (0, $GtRbT.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $f4887671cea7e277$var$overridesActions
});
const $f4887671cea7e277$export$ff357cf5a96ec0c6 = (0, $iJq0l.createHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getIssueFieldConfig
});
const $f4887671cea7e277$export$6e41e9c34587d557 = (0, $iJq0l.createHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getFieldConfig
});
const $f4887671cea7e277$export$e704d739927bd1d6 = (0, $iJq0l.createStateHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getFieldConfigWithLabel
});
const $f4887671cea7e277$export$d94ae842140da412 = (0, $iJq0l.createActionsHook)($f4887671cea7e277$var$overridesStore);
const $f4887671cea7e277$export$bfea9bb9bad7bc8f = (0, $iJq0l.createHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getFieldOptionsOverrides
});
const $f4887671cea7e277$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $f4887671cea7e277$export$982ff1008c2e2780 = (0, $iJq0l.createStateHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getIsFieldBusySelector
});

});




parcelRegister("a1Bfa", function(module, exports) {

$parcel$export(module.exports, "default", () => $295b6c958f08d947$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $295b6c958f08d947$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tootltipContent: {
        "id": "major-incident.major-incident-lozenge.tootltip-content",
        "defaultMessage": "This incident is marked as a major incident to increase visibility."
    },
    lozengeLabel: {
        "id": "major-incident.major-incident-lozenge.lozenge-label",
        "defaultMessage": "MAJOR INCIDENT"
    }
});

});



parcelRegister("8Vbi1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e826823eba138bdf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gqBnP = parcelRequire("gqBnP");
const $e826823eba138bdf$var$MultiUserField = (props)=>{
    const { dataSelectorProps: { value: items } } = props;
    const userData = (0, $eJOHy.useMemo)(()=>items.map((user)=>({
                email: user.email,
                key: user.email,
                name: user.name,
                src: user.avatarUrl
            })), [
        items
    ]);
    if (!items || items.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e826823eba138bdf$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e826823eba138bdf$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gqBnP.default), {
        size: "small",
        maxCount: 5,
        appearance: "stack",
        data: userData
    })));
};
var $e826823eba138bdf$export$2e2bcd8739ae039 = $e826823eba138bdf$var$MultiUserField;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e826823eba138bdf$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qu2gc _u5f31ejb _n3tdu2gc _19bvu2gc _1i4q1hna",
            __cmplp.className
        ])
    });
});
const $e826823eba138bdf$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug _80omtlke",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7gNKk", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd9de16c9e6b0e68$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $ewOxf = parcelRequire("ewOxf");

var $9ewtR = parcelRequire("9ewtR");

var $cNe2t = parcelRequire("cNe2t");
const $bd9de16c9e6b0e68$var$MultiValueField = (props)=>{
    const { dataSelectorProps: { value: items }, tableInjectedProps: { fieldName: fieldName, fieldId: fieldId } } = props;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const expandedView = (0, $eJOHy.useMemo)(()=>items.map(({ value: value }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
                key: `multi-value-${fieldId}-${index}`,
                text: value
            })), [
        items,
        fieldId
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const onToggle = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        setIsOpen,
        isOpen
    ]);
    const getContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd9de16c9e6b0e68$var$PopUpContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ewtR.default), null, expandedView));
    const getTrigger = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            ...triggerProps,
            appearance: "link",
            isSelected: isOpen,
            onClick: onToggle
        }, `${items.length} ${fieldName}`);
    if (!items || items.length === 0) return null;
    if (items.length <= 3) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd9de16c9e6b0e68$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd9de16c9e6b0e68$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ewtR.default), null, expandedView)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd9de16c9e6b0e68$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd9de16c9e6b0e68$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        messageId: "issue-table.common.fields.multi-value-field.popup",
        messageType: "transactional",
        content: getContent,
        trigger: getTrigger
    })));
};
var $bd9de16c9e6b0e68$export$2e2bcd8739ae039 = $bd9de16c9e6b0e68$var$MultiValueField;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $bd9de16c9e6b0e68$var$PopUpContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12fnklw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $bd9de16c9e6b0e68$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qu2gc _u5f31ejb _n3tdu2gc _19bvu2gc _1i4q1hna",
            __cmplp.className
        ])
    });
});
const $bd9de16c9e6b0e68$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug _80omtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ewOxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $935d42f1f33a5e95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1fStw = parcelRequire("1fStw");

var $40nZT = parcelRequire("40nZT");

var $6UE2q = parcelRequire("6UE2q");
const $935d42f1f33a5e95$var$SimpleTagComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6UE2q.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1fStw.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $40nZT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $935d42f1f33a5e95$var$SimpleTag = /*#__PURE__*/ (0, $eJOHy.memo)($935d42f1f33a5e95$var$SimpleTagComponent);
var $935d42f1f33a5e95$export$2e2bcd8739ae039 = $935d42f1f33a5e95$var$SimpleTag;

});


parcelRegister("k9wMY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4273e57aba706f5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9gIM4 = parcelRequire("9gIM4");

var $c2On5 = parcelRequire("c2On5");

var $7gc68 = parcelRequire("7gc68");
const $a4273e57aba706f5$var$Organization = ({ dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } })=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9gIM4.ReadView), {
        name: (0, $c2On5.getNameFromOrganizationFieldData)(value)
    })) : null;
var $a4273e57aba706f5$export$2e2bcd8739ae039 = $a4273e57aba706f5$var$Organization;

});
parcelRegister("9gIM4", function(module, exports) {

$parcel$export(module.exports, "ReadView", () => $51ecff7e3f59cc07$export$a4b5824ec1e018e1);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $c2Sgp = parcelRequire("c2Sgp");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $aYpdW = parcelRequire("aYpdW");
const $51ecff7e3f59cc07$var$TextWrapper = ({ children: children })=>{
    return (0, $7jTnu.fg)('jcs-issue-view-truncate-reporter') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $51ecff7e3f59cc07$var$textStyles
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $51ecff7e3f59cc07$export$a4b5824ec1e018e1 = ({ name: name })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: [
            (0, $7jTnu.fg)('jcs-issue-view-truncate-reporter') ? $51ecff7e3f59cc07$var$containerStyles : $51ecff7e3f59cc07$var$containerStylesOld,
            !name && $51ecff7e3f59cc07$var$placeholderStyles
        ],
        testId: "servicedesk-customer-service-custom-fields.common.ui.organization-read-view.inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c2Sgp.LabelIcon), {
        size: "xsmall",
        type: "ORGANIZATION"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($51ecff7e3f59cc07$var$TextWrapper, null, name || formatMessage((0, $aYpdW.default).none)));
};
const $51ecff7e3f59cc07$var$containerStylesOld = (0, $1DXK0.xcss)({
    margin: 'space.050',
    overflowWrap: 'anywhere',
    paddingLeft: 'space.100'
});
const $51ecff7e3f59cc07$var$containerStyles = (0, $1DXK0.xcss)({
    paddingInline: 'space.100',
    paddingBlock: 'space.050',
    display: 'flex',
    alignItems: 'center',
    width: '100%'
});
const $51ecff7e3f59cc07$var$textStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: '0px',
    flexGrow: 1
});
const $51ecff7e3f59cc07$var$placeholderStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest'
});

});
parcelRegister("aYpdW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f811cea01588e7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e7f811cea01588e7$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    none: {
        "id": "servicedesk-customer-service-custom-fields.common.ui.organization-read-view.none-non-final",
        "defaultMessage": "None"
    }
});

});


parcelRegister("c2On5", function(module, exports) {

$parcel$export(module.exports, "getNameFromOrganizationFieldData", () => $739472eeb90c2578$export$33a16ab674eb1646);
const $739472eeb90c2578$export$33a16ab674eb1646 = (value)=>value?.name;

});


parcelRegister("3qN4t", function(module, exports) {

$parcel$export(module.exports, "default", () => $b325d6c57b4ea279$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6kau5 = parcelRequire("6kau5");
function $b325d6c57b4ea279$export$2e2bcd8739ae039(props) {
    if (props.dataSelectorProps.value === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6kau5.default), null);
    const { dataSelectorProps: { value: { iconUrl: iconUrl, name: name } } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b325d6c57b4ea279$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        height: "16",
        width: "16",
        src: iconUrl,
        alt: name,
        title: name
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b325d6c57b4ea279$var$StyledWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itidpf _ca0qutpp _u5f3u2gc _n3tdu2gc _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6kau5", function(module, exports) {

$parcel$export(module.exports, "default", () => $883db3765c99f4c7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1NG86 = parcelRequire("1NG86");

var $lRq8t = parcelRequire("lRq8t");

var $49vNz = parcelRequire("49vNz");

var $eoiJ8 = parcelRequire("eoiJ8");
function $883db3765c99f4c7$var$Error(props) {
    const { isLastColumn: isLastColumn, message: message } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const tooltipMessage = typeof message === 'string' ? message : formatMessage(message);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $49vNz.default), {
        isLastColumn: isLastColumn,
        tooltipMessage: tooltipMessage,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1NG86))),
        color: "var(--ds-icon-danger, #C9372C)",
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    });
}
$883db3765c99f4c7$var$Error.defaultProps = {
    isLastColumn: false,
    message: (0, $eoiJ8.default).errorMessage
};
var $883db3765c99f4c7$export$2e2bcd8739ae039 = $883db3765c99f4c7$var$Error;

});
parcelRegister("49vNz", function(module, exports) {

$parcel$export(module.exports, "default", () => $45bd04435566e346$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $80DPg = parcelRequire("80DPg");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $dPMMf = parcelRequire("dPMMf");

var $7jTnu = parcelRequire("7jTnu");

var $6joHJ = parcelRequire("6joHJ");

var $7gc68 = parcelRequire("7gc68");
const $45bd04435566e346$var$DIALOG_MAX_WIDTH = (0, $dPMMf.gridSize) * 36;
const $45bd04435566e346$var$TABLE_LEFT_MARGIN = (0, $dPMMf.gridSize) * 5;
class $45bd04435566e346$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isLastColumn: false,
            tooltipTitle: undefined
        };
    }
    calculateDialogPosition() {
        if (this.alertRef.current) {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            const { left: left } = this.alertRef.current.getBoundingClientRect();
            if (this.alertRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            this.alertRef.current.offsetParent && left > // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            this.alertRef.current.offsetParent.getBoundingClientRect().left + $45bd04435566e346$var$DIALOG_MAX_WIDTH + $45bd04435566e346$var$TABLE_LEFT_MARGIN) return 'bottom-end';
        }
        return 'bottom-start';
    }
    renderDialogContent() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($45bd04435566e346$var$DialogContainer, null, this.props.tooltipTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, this.props.tooltipTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, this.props.tooltipMessage));
    }
    render() {
        const { isLastColumn: isLastColumn, Icon: Icon, color: color, backgroundColor: backgroundColor } = this.props;
        return !(0, $7jTnu.fg)('handle-queues-column-exceptions') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
            placement: this.calculateDialogPosition(),
            messageId: "issue-table.common.fields.common.alert.inline-dialog",
            messageType: "transactional",
            content: this.renderDialogContent(),
            isOpen: this.state.dialogOpen,
            onClose: this.onClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($45bd04435566e346$var$Container, {
            onClick: this.onClick,
            color: color,
            backgroundColor: backgroundColor,
            /* @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type '{ current: HTMLDivElement | null; }'. */ ref: this.alertRef,
            tabIndex: 0,
            onMouseEnter: this.onMouseEnterContainer,
            onMouseLeave: this.onMouseLeaveContainer,
            isHovered: this.state.isHovered,
            "aria-label": (0, $7jTnu.fg)('corcap-3761-a11y-button-no-text') ? 'Alert' : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $45bd04435566e346$var$IconContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            color: color
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($45bd04435566e346$var$Container, {
            onClick: this.onClick,
            color: color,
            backgroundColor: backgroundColor,
            /* @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type '{ current: HTMLDivElement | null; }'. */ ref: this.alertRef,
            tabIndex: 0,
            "aria-label": (0, $7jTnu.fg)('corcap-3761-a11y-button-no-text') ? 'Alert' : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $45bd04435566e346$var$IconContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
            color: "currentColor"
        }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
            messageId: "issue-table.common.fields.common.alert.inline-dialog.1",
            messageType: "transactional",
            placement: this.calculateDialogPosition(),
            content: this.renderDialogContent(),
            isOpen: this.state.dialogOpen,
            onClose: this.onClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($45bd04435566e346$var$ErrorContainer, {
            onClick: this.onClick,
            color: color,
            backgroundColor: backgroundColor,
            /* @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type '{ current: HTMLDivElement | null; }'. */ ref: this.alertRef,
            tabIndex: 0,
            onMouseEnter: this.onMouseEnterContainer,
            onMouseLeave: this.onMouseLeaveContainer,
            isHovered: this.state.isHovered,
            isLastColumn: isLastColumn,
            "aria-label": (0, $7jTnu.fg)('corcap-3761-a11y-button-no-text') ? 'Alert' : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $45bd04435566e346$var$iconContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
            label: "",
            size: "small"
        })))));
    }
    constructor(...args){
        super(...args), this.state = {
            dialogOpen: false,
            isHovered: false
        }, this.onClick = ()=>this.setState({
                dialogOpen: !this.state.dialogOpen
            }), this.onMouseEnterContainer = ()=>this.setState({
                ...this.state,
                isHovered: true
            }), this.onMouseLeaveContainer = ()=>this.setState({
                ...this.state,
                isHovered: false
            }), this.alertRef = /*#__PURE__*/ (0, $eJOHy.createRef)();
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45bd04435566e346$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, isHovered: isHovered, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1aegsjq": (0, $awdRS.default)(`2px solid ${__cmplp.color}`),
            "--_xexnhp": (0, $awdRS.default)(__cmplp.color),
            "--_1hphqkz": (0, $awdRS.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19it1pqh _2rkoi2wt _syaz1cj8 _bfhk3qkl _1bsb1osq _4t3i1ylp _y3gn1h6o",
            __cmplp.isHovered ? "_80omtlke" : "_80om1wug",
            __cmplp.className
        ])
    });
});
const $45bd04435566e346$var$ErrorContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastColumn: isLastColumn, backgroundColor: backgroundColor, isHovered: isHovered, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gg4a5j": (0, $awdRS.default)(`0px ${__cmplp.isLastColumn ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)"} 0px ${"var(--ds-space-100, 8px)"}`),
            "--_1aegsjq": (0, $awdRS.default)(`2px solid ${__cmplp.color}`),
            "--_xexnhp": (0, $awdRS.default)(__cmplp.color),
            "--_1hphqkz": (0, $awdRS.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1yt44105 _19it1pqh _2rkoi2wt _syaz1cj8 _bfhk3qkl _1bsb1osq _4t3i1ylp _y3gn1h6o _1e0c1txw _4cvr1h6o",
            __cmplp.isHovered ? "_80omtlke" : "_80om1wug",
            __cmplp.className
        ])
    });
});
const $45bd04435566e346$var$iconContainerStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.200'
});
const $45bd04435566e346$var$IconContainer = (0, $1DXK0.xcss)({
    marginTop: 'space.025'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45bd04435566e346$var$DialogContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12fo812",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6joHJ", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $765bdfac52a4c302$export$7ab52478615504b3);

var $eJOHy = parcelRequire("eJOHy");

var $cwZBT = parcelRequire("cwZBT");

var $SyPNn = parcelRequire("SyPNn");

var $fYeTG = parcelRequire("fYeTG");

var $1kIuW = parcelRequire("1kIuW");
const $765bdfac52a4c302$export$7ab52478615504b3 = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kIuW.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cwZBT.default), rest);
};

});
parcelRegister("1kIuW", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $7432b934335413bd$export$44a404f218b0e66e);

var $cwZBT = parcelRequire("cwZBT");

var $gL5G0 = parcelRequire("gL5G0");
const $7432b934335413bd$export$44a404f218b0e66e = (0, $gL5G0.withChoreographedToggle)((0, $cwZBT.default), 'isOpen', 'content');

});



parcelRegister("eoiJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7019f0be67f25961$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7019f0be67f25961$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "issue-table.common.fields.error.error-message",
        "defaultMessage": "There was a problem showing this field."
    }
});

});



parcelRegister("1Xg5n", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6f77dec042924fe$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k71qx = parcelRequire("k71qx");

var $idGBm = parcelRequire("idGBm");

var $7gc68 = parcelRequire("7gc68");

var $8A9Nx = parcelRequire("8A9Nx");
const $c6f77dec042924fe$var$ANONYMOUS_STYLE = 'anonymous';
const $c6f77dec042924fe$var$TOOLTIP_STYLE = 'tooltip';
const $c6f77dec042924fe$var$SIMPLE_STYLE = 'simple';
const $c6f77dec042924fe$var$getTooltipMessage = (style)=>{
    if (style.type === $c6f77dec042924fe$var$TOOLTIP_STYLE) return `${style.displayName} - ${style.emailAddress}`;
    return null;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c6f77dec042924fe$var$renderWithTooltipIfRequired = (content, tooltipText)=>{
    if (tooltipText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipText
    }, content);
    return content;
};
// eslint-disable-next-line jira/react/no-class-components
class $c6f77dec042924fe$var$Reporter extends (0, $eJOHy.Component) {
    getDisplayMessage(style) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        switch(style.type){
            case $c6f77dec042924fe$var$TOOLTIP_STYLE:
                return this.formatForDisplay(style.displayName);
            case $c6f77dec042924fe$var$SIMPLE_STYLE:
                return this.formatForDisplay(style.value);
            case $c6f77dec042924fe$var$ANONYMOUS_STYLE:
                return formatMessage((0, $8A9Nx.default).anonymous);
            default:
                // prettier-ignore
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                style;
                return '';
        }
    }
    getStyle() {
        const { dataSelectorProps: { value: value } } = this.props;
        if (!value || !value.emailAddress && !value.displayName) return {
            type: $c6f77dec042924fe$var$ANONYMOUS_STYLE
        };
        const { emailAddress: emailAddress, displayName: displayName } = value;
        if (!emailAddress || !displayName || emailAddress === displayName) return {
            type: $c6f77dec042924fe$var$SIMPLE_STYLE,
            value: emailAddress || displayName || ''
        };
        return {
            type: $c6f77dec042924fe$var$TOOLTIP_STYLE,
            emailAddress: emailAddress,
            displayName: displayName
        };
    }
    formatForDisplay(name) {
        const { dataSelectorProps: { value: value }, intl: { formatMessage: formatMessage } } = this.props;
        const active = !value || value.active;
        if (active) return name;
        return formatMessage((0, $8A9Nx.default).inactive, {
            name: name
        });
    }
    render() {
        const { tableInjectedProps: { isLastColumn: isLastColumn } } = this.props;
        const style = this.getStyle();
        const tooltip = $c6f77dec042924fe$var$getTooltipMessage(style);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, $c6f77dec042924fe$var$renderWithTooltipIfRequired(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c6f77dec042924fe$var$ReporterWrapper, null, this.getDisplayMessage(style)), tooltip));
    }
}
var $c6f77dec042924fe$export$2e2bcd8739ae039 // gridSize + 2 to account for summary field {padding: gridSize} + 2px from transparent border
 = (0, $idGBm.injectIntlV2)($c6f77dec042924fe$var$Reporter);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c6f77dec042924fe$var$ReporterWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qu2gc _u5f3ze3t _n3tdu2gc _19bvze3t _1i4q1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8A9Nx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29638fbba23995f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e29638fbba23995f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    anonymous: {
        "id": "issue-table.common.fields.reporter.anonymous",
        "defaultMessage": "Anonymous"
    },
    inactive: {
        "id": "issue-table.common.fields.reporter.inactive",
        "defaultMessage": "{name} (Inactive)"
    }
});

});


parcelRegister("7UdCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c91433325a8347$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3qG8w6 = parcelRequire("3qG8w6");
const $c8c91433325a8347$var$Responders = ({ dataSelectorProps: { value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3qG8w6.RespondersInlineView), {
        values: value
    });
var $c8c91433325a8347$export$2e2bcd8739ae039 = $c8c91433325a8347$var$Responders;

});
parcelRegister("3qG8w6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "RespondersInlineView", () => $9e49510de3130857$export$c1d034b633262480);
$parcel$export(module.exports, "default", () => $9e49510de3130857$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ewOxf = parcelRequire("ewOxf");

var $9ewtR = parcelRequire("9ewtR");

var $7xXvm = parcelRequire("7xXvm");

const $9e49510de3130857$export$c1d034b633262480 = ({ values: values })=>{
    const respondersRender = values.map((it)=>{
        const accountId = it.ari.startsWith((0, $50aaeb1ca8bf87fb$export$470b0d72e4fdc43a)) ? it.ari.substring((0, $50aaeb1ca8bf87fb$export$470b0d72e4fdc43a).length) : null;
        const renderTagWithProfileCardWrapper = (accountIdValue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7xXvm.default), {
                key: it.ari,
                accountId: accountIdValue
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
                testId: "responders.ui.inline.async-tag",
                key: it.ari,
                text: it.name
            }));
        return accountId !== null ? renderTagWithProfileCardWrapper(accountId) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewOxf.default), {
            testId: "responders.ui.inline.tag",
            key: it.ari,
            text: it.name
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ewtR.default), null, respondersRender);
};
var $9e49510de3130857$export$2e2bcd8739ae039 = $9e49510de3130857$export$c1d034b633262480;

});
const $50aaeb1ca8bf87fb$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';



parcelRegister("6GT3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e91bcd185dd5f6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7gc68 = parcelRequire("7gc68");

var $hZn1p = parcelRequire("hZn1p");
const $a9e91bcd185dd5f6$var$Sentiment = ({ dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } })=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
        isLastColumn: isLastColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hZn1p.ReadView), {
        id: value.id,
        name: value.name
    })) : null;
var $a9e91bcd185dd5f6$export$2e2bcd8739ae039 = $a9e91bcd185dd5f6$var$Sentiment;

});
parcelRegister("hZn1p", function(module, exports) {

$parcel$export(module.exports, "ReadView", () => $c7b09614f3ef8114$export$a4b5824ec1e018e1);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $4xic8 = parcelRequire("4xic8");
const $c7b09614f3ef8114$export$a4b5824ec1e018e1 = ({ id: id, name: name })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), null, (0, $4xic8.EmojiIconForSentimentCustomField)(id, formatMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $c7b09614f3ef8114$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, name)));
};
const $c7b09614f3ef8114$var$contentStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.025',
    marginLeft: 'space.150',
    whiteSpace: 'nowrap'
});

});
parcelRegister("4xic8", function(module, exports) {

$parcel$export(module.exports, "EmojiIconForSentimentCustomField", () => $bf1bb58a0956d2b4$export$48a4724ca11bcd06);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $aGMxL = parcelRequire("aGMxL");

var $e2Lrv = parcelRequire("e2Lrv");
const $bf1bb58a0956d2b4$var$NegativeSentimentGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "96",
        height: "96",
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M61.7766 14.7403C57.4089 12.9312 52.7276 12 48 12C38.4522 12 29.2955 15.7928 22.5442 22.5442C15.7928 29.2955 12 38.4522 12 48C12 57.5478 15.7928 66.7045 22.5442 73.4558C29.2955 80.2072 38.4522 84 48 84C52.7276 84 57.4089 83.0688 61.7766 81.2597C66.1443 79.4505 70.1129 76.7988 73.4558 73.4558C76.7988 70.1129 79.4505 66.1443 81.2597 61.7766C83.0688 57.4089 84 52.7276 84 48C84 43.2724 83.0688 38.5911 81.2597 34.2234C79.4505 29.8557 76.7988 25.8871 73.4558 22.5442C70.1129 19.2012 66.1443 16.5495 61.7766 14.7403ZM76.284 48C76.284 63.6 63.6 76.284 48 76.284C32.4 76.284 19.716 63.6 19.716 48C19.7245 40.5012 22.7071 33.312 28.0095 28.0095C33.312 22.7071 40.5012 19.7245 48 19.716C63.6 19.716 76.284 32.4 76.284 48ZM38.3156 45.0357C38.9396 45.2944 39.6085 45.4277 40.284 45.428C41.6483 45.428 42.9607 44.886 43.9254 43.9214C44.89 42.9567 45.432 41.6483 45.432 40.284C45.432 38.9197 44.89 37.6113 43.9254 36.6466C42.9607 35.682 41.6523 35.14 40.288 35.14C39.6125 35.1397 38.9435 35.2725 38.3193 35.5308C37.6951 35.7891 37.1279 36.1678 36.6501 36.6452C36.1722 37.1227 35.7931 37.6896 35.5343 38.3136C35.2756 38.9376 35.1423 39.6065 35.142 40.282C35.1417 40.9575 35.2745 41.6265 35.5328 42.2507C35.7911 42.8749 36.1698 43.4421 36.6472 43.9199C37.1247 44.3978 37.6916 44.7769 38.3156 45.0357ZM52.0786 43.9214C53.0433 44.886 54.3517 45.428 55.716 45.428C57.0803 45.428 58.3887 44.886 59.3534 43.9214C60.318 42.9567 60.86 41.6483 60.86 40.284C60.86 38.9197 60.318 37.6113 59.3534 36.6466C58.3887 35.682 57.0803 35.14 55.716 35.14C54.3517 35.14 53.0433 35.682 52.0786 36.6466C51.114 37.6113 50.572 38.9197 50.572 40.284C50.572 41.6483 51.114 42.9567 52.0786 43.9214ZM38.8717 63.0827C38.2912 63.6733 37.5055 64.0176 36.6777 64.0439C35.85 64.0702 35.0439 63.7766 34.427 63.2241C33.8101 62.6716 33.4298 61.9026 33.3651 61.077C33.3005 60.2513 33.5564 59.4325 34.0798 58.7907C35.8298 56.8374 37.9718 55.2747 40.366 54.2044C42.7603 53.1341 45.3531 52.5802 47.9757 52.5787C50.5936 52.5799 53.1818 53.1319 55.5724 54.1987C57.963 55.2654 60.1024 56.8232 61.8517 58.7707C62.3954 59.4089 62.6683 60.2342 62.6123 61.0707C62.5564 61.9071 62.176 62.6887 61.5522 63.2489C60.9285 63.809 60.1106 64.1034 59.273 64.0694C58.4353 64.0354 57.644 63.6756 57.0677 63.0667C52.4357 57.9067 43.4958 57.9067 38.8717 63.0827Z",
        fill: "currentColor"
    }));
const $bf1bb58a0956d2b4$var$NeutralSentimentGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "96",
        height: "96",
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M61.7766 14.7403C57.4089 12.9312 52.7276 12 48 12C38.4522 12 29.2955 15.7928 22.5442 22.5442C15.7928 29.2955 12 38.4522 12 48C12 57.5478 15.7928 66.7045 22.5442 73.4558C29.2955 80.2072 38.4522 84 48 84C52.7276 84 57.4089 83.0688 61.7766 81.2597C66.1443 79.4505 70.1129 76.7988 73.4558 73.4558C76.7988 70.1129 79.4505 66.1443 81.2597 61.7766C83.0688 57.4089 84 52.7276 84 48C84 43.2724 83.0688 38.5911 81.2597 34.2234C79.4505 29.8557 76.7988 25.8871 73.4558 22.5442C70.1129 19.2012 66.1443 16.5495 61.7766 14.7403ZM76.284 48C76.284 63.6 63.6 76.284 48 76.284C32.4 76.284 19.716 63.6 19.716 48C19.7245 40.5012 22.7071 33.312 28.0095 28.0095C33.312 22.7071 40.5012 19.7245 48 19.716C63.6 19.716 76.284 32.4 76.284 48ZM38.3156 45.0357C38.9396 45.2944 39.6085 45.4277 40.284 45.428C41.6483 45.428 42.9607 44.886 43.9254 43.9214C44.89 42.9567 45.432 41.6483 45.432 40.284C45.432 38.9197 44.89 37.6113 43.9254 36.6466C42.9607 35.682 41.6523 35.14 40.288 35.14C39.6125 35.1397 38.9435 35.2725 38.3193 35.5308C37.6951 35.7891 37.1279 36.1678 36.6501 36.6452C36.1722 37.1227 35.7931 37.6896 35.5343 38.3136C35.2756 38.9376 35.1423 39.6065 35.142 40.282C35.1417 40.9575 35.2745 41.6265 35.5328 42.2507C35.7911 42.8749 36.1698 43.4421 36.6472 43.9199C37.1247 44.3978 37.6916 44.7769 38.3156 45.0357ZM52.0786 43.9214C53.0433 44.886 54.3517 45.428 55.716 45.428C57.0803 45.428 58.3887 44.886 59.3534 43.9214C60.318 42.9567 60.86 41.6483 60.86 40.284C60.86 38.9197 60.318 37.6113 59.3534 36.6466C58.3887 35.682 57.0803 35.14 55.716 35.14C54.3517 35.14 53.0433 35.682 52.0786 36.6466C51.114 37.6113 50.572 38.9197 50.572 40.284C50.572 41.6483 51.114 42.9567 52.0786 43.9214ZM37 54.625C35.136 54.625 33.625 56.136 33.625 58C33.625 59.864 35.136 61.375 37 61.375L59 61.375C60.864 61.375 62.375 59.864 62.375 58C62.375 56.136 60.864 54.625 59 54.625L37 54.625Z",
        fill: "currentColor"
    }));
const $bf1bb58a0956d2b4$export$48a4724ca11bcd06 = (sentimentId, formatMessage)=>{
    switch(sentimentId){
        case '1000':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $bf1bb58a0956d2b4$var$NegativeSentimentGlyph,
                label: formatMessage((0, $e2Lrv.default).negativeSentimentIconLabel),
                primaryColor: "var(--ds-icon-danger, #C9372C)",
                size: "medium"
            });
        case '2000':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $bf1bb58a0956d2b4$var$NeutralSentimentGlyph,
                label: formatMessage((0, $e2Lrv.default).neutralSentimentIconLabel),
                primaryColor: "var(--ds-icon-subtle, #626F86)",
                size: "medium"
            });
        case '3000':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aGMxL))), {
                color: "var(--ds-icon-success, #22A06B)",
                LEGACY_size: "medium",
                spacing: "spacious",
                label: formatMessage((0, $e2Lrv.default).positiveSentimentIconLabel)
            });
        default:
            return null;
    }
};

});
parcelRegister("aGMxL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3cbbd0d6d1aaac61ee97089092149436>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c837b5c4c24d430$var$_react = $7c837b5c4c24d430$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7c837b5c4c24d430$var$_emoji = $7c837b5c4c24d430$var$_interopRequireDefault((parcelRequire("euu4D")));

var $7c837b5c4c24d430$var$_emoji2 = $7c837b5c4c24d430$var$_interopRequireDefault((parcelRequire("gBuYk")));
function $7c837b5c4c24d430$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmojiIcon.
 * This component is EmojiIcon, with `UNSAFE_fallbackIcon` set to "EmojiIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c837b5c4c24d430$var$EmojiIcon = (props)=>/*#__PURE__*/ $7c837b5c4c24d430$var$_react.default.createElement($7c837b5c4c24d430$var$_emoji.default, Object.assign({
        LEGACY_fallbackIcon: $7c837b5c4c24d430$var$_emoji2.default
    }, props));
$7c837b5c4c24d430$var$EmojiIcon.Name = 'EmojiIconMigration';
var $7c837b5c4c24d430$var$_default = module.exports.default = $7c837b5c4c24d430$var$EmojiIcon;

});
parcelRegister("euu4D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8cb3213f8552b4b$var$_react = $a8cb3213f8552b4b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a8cb3213f8552b4b$var$_baseNew = $a8cb3213f8552b4b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $a8cb3213f8552b4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8cb3213f8552b4b$var$EmojiIcon = (props)=>/*#__PURE__*/ $a8cb3213f8552b4b$var$_react.default.createElement($a8cb3213f8552b4b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$a8cb3213f8552b4b$var$EmojiIcon.displayName = 'EmojiIcon';
var $a8cb3213f8552b4b$var$_default = module.exports.default = $a8cb3213f8552b4b$var$EmojiIcon;

});

parcelRegister("gBuYk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $031e952b100d52d0$var$_react = $031e952b100d52d0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $031e952b100d52d0$var$_emoji = $031e952b100d52d0$var$_interopRequireDefault((parcelRequire("euu4D")));
function $031e952b100d52d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $031e952b100d52d0$var$EmojiIcon = (props)=>/*#__PURE__*/ $031e952b100d52d0$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18m0 16.071c3.9 0 7.071-3.171 7.071-7.071S15.9 4.929 12 4.929A7.08 7.08 0 0 0 4.929 12c0 3.9 3.171 7.071 7.071 7.071m-1.929-7.714a1.286 1.286 0 1 1 .001-2.572 1.286 1.286 0 0 1 0 2.572m3.858 0a1.286 1.286 0 1 1 0-2.572 1.286 1.286 0 0 1 0 2.572m.347 2.035a.805.805 0 0 1 1.198 1.073A4.67 4.67 0 0 1 12 16.018a4.67 4.67 0 0 1-3.469-1.548.804.804 0 0 1 1.196-1.074c1.158 1.29 3.393 1.29 4.549-.004"/></svg>`
    }, props, {
        newIcon: $031e952b100d52d0$var$_emoji.default
    }));
$031e952b100d52d0$var$EmojiIcon.displayName = 'EmojiIcon';
var $031e952b100d52d0$var$_default = module.exports.default = $031e952b100d52d0$var$EmojiIcon;

});


parcelRegister("e2Lrv", function(module, exports) {

$parcel$export(module.exports, "default", () => $30b171610301c03b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $30b171610301c03b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    negativeSentimentIconLabel: {
        "id": "issue-table.common.fields.sentiment.negative-sentiment-icon-label",
        "defaultMessage": "Negative sentiment icon"
    },
    positiveSentimentIconLabel: {
        "id": "issue-table.common.fields.sentiment.positive-sentiment-icon-label",
        "defaultMessage": "Positive sentiment icon"
    },
    neutralSentimentIconLabel: {
        "id": "issue-table.common.fields.sentiment.neutral-sentiment-icon-label",
        "defaultMessage": "Neutral sentiment icon"
    }
});

});




parcelRegister("kCaV6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c4e03c95f78caea$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");


var $3VoMh = parcelRequire("3VoMh");


var $f8rYl = parcelRequire("f8rYl");
const $2c4e03c95f78caea$export$a7502422f07570ed = 'metric not found';
const $2c4e03c95f78caea$var$Sla = (props)=>{
    const { dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } } = props;
    const onError = (location, error, attributes)=>{
        // This check is added to supress the false burn events the client errors are creating in SLA Queue View Reliability SLOs
        // These errors are safe to be ignored
        // Platform team added a check to filter them from SFX & Splunk but still JSM Bumblebee team is seeing SLO Burn events
        // Ref: https://product-fabric.atlassian.net/browse/P2X-1109
        if ((0, $f8rYl.isClientFetchError)(error)) return;
        const errorPayload = {
            error: error,
            meta: {
                id: 'slaQueueView',
                packageName: 'jiraIssueTable'
            },
            attributes: {
                ...attributes,
                location: location,
                fieldType: (0, $9f37490eed0e5ebb$export$f790c24298ed441b)
            },
            sendToPrivacyUnsafeSplunk: true
        };
        return (0, $gYnSx.default)(errorPayload);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VoMh.AsyncLazySla), {
        isLastColumn: isLastColumn,
        value: value,
        onError: onError,
        viewMode: (0, $16d54c09e3ba75d5$export$2e5e3c3156fc4c3c)
    });
};
var $2c4e03c95f78caea$export$2e2bcd8739ae039 = $2c4e03c95f78caea$var$Sla;

});
const $16d54c09e3ba75d5$export$a63db8d18dae0c68 = 'card';
const $16d54c09e3ba75d5$export$2e5e3c3156fc4c3c = 'queue';
const $16d54c09e3ba75d5$export$6b218e85068d9955 = 'insights';

parcelRegister("3VoMh", function(module, exports) {

$parcel$export(module.exports, "AsyncLazySla", () => $b400270162cb2868$export$e4c697b53a973eb5);

var $eJOHy = parcelRequire("eJOHy");

var $7mF43 = parcelRequire("7mF43");

var $h47gY = parcelRequire("h47gY");

var $bQWwW = parcelRequire("bQWwW");
var $eSXqs = parcelRequire("eSXqs");

const $b400270162cb2868$var$AsyncSla = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("fD2Yp")), {
    moduleId: "./src/packages/jira-issue-sla/src/ui/sla/main.tsx"
});
const $b400270162cb2868$export$e4c697b53a973eb5 = (props)=>{
    const { viewMode: viewMode, onError: onError } = props;
    const boundary = (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(`sla ${viewMode} View`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: boundary,
        packageName: "jira-issue-sla",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eSXqs.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b400270162cb2868$var$AsyncSla, props)));
};

});
parcelRegister("fD2Yp", function(module, exports) {

let $b60ccdffe362ba91$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b60ccdffe362ba91$var$load("krP5k").then(()=>parcelRequire('lMIVz'));

});


parcelRegister("f8rYl", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $1fef73a9b11b93c9$export$2e7adc44463c3f4f);
const $1fef73a9b11b93c9$var$KNOWN_NETWORK_ERRORS = [
    'Failed to fetch dynamically imported module',
    'error loading dynamically imported module',
    'Importing a module script failed'
];
const $1fef73a9b11b93c9$var$isClientFetchErrorMessage = (message)=>Boolean(message) && !!$1fef73a9b11b93c9$var$KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $1fef73a9b11b93c9$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($1fef73a9b11b93c9$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && $1fef73a9b11b93c9$var$isClientFetchErrorMessage(error.cause.message));

});


parcelRegister("4QTpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c611d803c6020b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ljej9 = parcelRequire("ljej9");

var $7gc68 = parcelRequire("7gc68");

var $bzdAT = parcelRequire("bzdAT");

var $1S2ok = parcelRequire("1S2ok");
class $34c611d803c6020b$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props, { canRenderEditExperience: canRenderEditExperience }) {
        const { dataSelectorProps: { isEditable: isEditable }, tableInjectedProps: { shouldHydrateFully: shouldHydrateFully } } = props;
        if (shouldHydrateFully && isEditable === true && !canRenderEditExperience) return {
            canRenderEditExperience: true
        };
        return null;
    }
    enableEditExperienceIfAvailable() {
        if (this.props.dataSelectorProps.isEditable === true && !this.state.canRenderEditExperience) this.setState({
            canRenderEditExperience: true
        });
    }
    render() {
        const { dataSelectorProps: { value: { id: id, name: name, description: description, statusCategory: { id: statusCategoryId } }, isEditable: isEditable, onChange: onChange }, tableInjectedProps: { isLastColumn: isLastColumn, issueKey: issueKey, issueFieldLockControls: issueFieldLockControls } } = this.props;
        const { canRenderEditExperience: canRenderEditExperience } = this.state;
        const transformedProps = {
            value: {
                id: id.toString(),
                name: name,
                description: description,
                statusCategory: {
                    id: statusCategoryId
                }
            },
            isLastColumn: isLastColumn,
            appearance: 'lozenge',
            issueKey: (0, $ljej9.toIssueKey)(issueKey),
            onChange: onChange,
            issueFieldLockControls: issueFieldLockControls
        };
        if (isEditable === true && canRenderEditExperience) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.SelectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bzdAT.default), transformedProps));
        // SelectableChildGutterPaddingContainer, because it always renders within (possibly disabled) button.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.SelectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn,
            onMouseOver: this.onMouseOver,
            onFocus: this.onFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1S2ok.default), transformedProps));
    }
    constructor(...args){
        super(...args), this.state = {
            canRenderEditExperience: false
        }, this.onMouseOver = ()=>{
            this.enableEditExperienceIfAvailable();
        }, this.onFocus = ()=>{
            this.enableEditExperienceIfAvailable();
        };
    }
}

});
parcelRegister("bzdAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1dc139f76e8c6c9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $6BnaS = parcelRequire("6BnaS");

var $hRhIm = parcelRequire("hRhIm");

var $bQWwW = parcelRequire("bQWwW");

var $7jTnu = parcelRequire("7jTnu");

var $ia7qg = parcelRequire("ia7qg");

var $2is8h = parcelRequire("2is8h");
const $e1dc139f76e8c6c9$var$FIELD_TYPE = 'status';

// TODO reevaluate phase - forPaint is simply for initial parity
const $e1dc139f76e8c6c9$var$IssueStatusField = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("dAC9q")), {
    moduleId: "./src/packages/issue/fields/status/src/index.tsx"
});
class $e1dc139f76e8c6c9$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.onSuccess = (fieldValue, viaDialog, event)=>{
            const { onChange: onChange, issueKey: issueKey, issueFieldLockControls: issueFieldLockControls } = this.props;
            (0, $ia7qg.trackUpdatedField)(event, $e1dc139f76e8c6c9$var$FIELD_TYPE, this.getDataForAnalytics(fieldValue));
            // issue-field/status type does not have a description but JSD status type expects one
            const status = {
                ...fieldValue,
                description: ''
            };
            onChange && onChange(issueKey, status);
            issueFieldLockControls.onFieldUnlock();
        }, this.onSubmit = ()=>{
            this.setState({
                inEditState: false
            });
        }, this.onEditStart = ()=>{
            this.props.issueFieldLockControls.onFieldLock();
            this.setState({
                inEditState: true
            });
        }, this.onEditCancel = ()=>{
            this.props.issueFieldLockControls.onFieldUnlock();
            this.setState({
                inEditState: false
            });
        };
        this.state = {
            inEditState: false
        };
    }
    getDataForAnalytics(fieldValue) {
        const { value: value } = this.props;
        return {
            ...value ? {
                oldId: value.id,
                oldCategory: value.statusCategory.id
            } : {},
            ...fieldValue ? {
                newId: fieldValue.id,
                newCategory: fieldValue.statusCategory.id
            } : {}
        };
    }
    render() {
        const { value: value, appearance: appearance, issueKey: issueKey, issueFieldLockControls: { onFieldUnlock: onFieldUnlock } } = this.props;
        const status = {
            id: value.id,
            name: value.name,
            statusCategory: value.statusCategory
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2is8h.default), {
            inEditState: this.state.inEditState
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6BnaS.IssueStatusFieldBoundary), {
            packageName: "issue-table",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
                value: status
            })
        }, false && (0, $7jTnu.fg)('issue_list_ssr_disable_sort_and_inline_edit') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
            value: status
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e1dc139f76e8c6c9$var$IssueStatusField, {
            value: status,
            appearance: appearance,
            issueKey: issueKey,
            isOptimistic: false,
            onSubmit: this.onSubmit,
            onSuccess: this.onSuccess,
            onFailure: onFieldUnlock,
            onEditStart: this.onEditStart,
            onEditCancel: this.onEditCancel
        })));
    }
}

});
parcelRegister("6BnaS", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueStatusField", () => $d4bd70c5964975e8$export$ddd324b06f34200);
$parcel$export(module.exports, "IssueStatusFieldBoundary", () => $d4bd70c5964975e8$export$dba9e9c892560f60);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $hRhIm = parcelRequire("hRhIm");

const $d4bd70c5964975e8$export$6dbb1a485af348f = (0, $bQWwW.lazy)(()=>(parcelRequire("hOKLP")), {
    moduleId: "./src/packages/issue/fields/status/src/ui/main.tsx"
});
const $d4bd70c5964975e8$export$ddd324b06f34200 = (props)=>{
    const { initialValue: initialValue, value: value } = props;
    const errorProps = {
        initialValue: initialValue,
        value: value
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue-field-status",
        packageName: "jira-issue-field-status",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-status-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozengeWithDropdownIndicator), errorProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d4bd70c5964975e8$export$6dbb1a485af348f, props)));
};
const $d4bd70c5964975e8$export$dba9e9c892560f60 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue-status-field",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-status-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("hRhIm", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $7b782d104096cf08$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $7b782d104096cf08$export$9f5070a985b0679b);

var $eJOHy = parcelRequire("eJOHy");

var $6UBwj = parcelRequire("6UBwj");
const $7b782d104096cf08$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        contentRef: props.contentRef
    });
};
const $7b782d104096cf08$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});
parcelRegister("6UBwj", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $517c92a4e3fff9f6$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $517c92a4e3fff9f6$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $517c92a4e3fff9f6$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");

var $abjs4 = parcelRequire("abjs4");

var $fL0In = parcelRequire("fL0In");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $2zOdI = parcelRequire("2zOdI");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $fWpUz = parcelRequire("fWpUz");

var $jAZ6b = parcelRequire("jAZ6b");
const $517c92a4e3fff9f6$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $517c92a4e3fff9f6$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $517c92a4e3fff9f6$var$StatusLozengeNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusContentWrapper, {
        "data-testid": `${$517c92a4e3fff9f6$export$9cbc201c09a37b3f}${statusCategory.id}`,
        ref: ref
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fWpUz.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StyledLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $517c92a4e3fff9f6$var$CustomChevronDownGlyph,
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fWpUz.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, name)), hasHoverState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $517c92a4e3fff9f6$var$hoverOverlayStyles
    })));
const $517c92a4e3fff9f6$var$WrappedStatusLozengeNew = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, contentRef: contentRef, triggerProps: triggerProps = {}, ...others } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $517c92a4e3fff9f6$var$pressableStyles,
        ref: targetRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusLozengeNew, {
        ...others,
        isEditable: isEditable,
        ref: contentRef
    }));
};
const $517c92a4e3fff9f6$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jAZ6b.LozengeOld), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $517c92a4e3fff9f6$var$CustomChevronDownGlyph,
        label: ""
    })));
const $517c92a4e3fff9f6$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$517c92a4e3fff9f6$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jAZ6b.LozengeOld), null, name)));
const $517c92a4e3fff9f6$var$WrappedStatusLozengeOld = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, triggerProps: triggerProps = {}, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abjs4.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? "var(--ds-border-danger, #E2483D)" : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? "var(--ds-border-focused, #388BFF)" : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusLozengeOld, {
        ...other,
        isEditable: isEditable
    }));
};
const $517c92a4e3fff9f6$export$f72db4ad1e9b3e6d = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $517c92a4e3fff9f6$var$StatusLozengeNew, $517c92a4e3fff9f6$var$StatusLozengeOld);
const $517c92a4e3fff9f6$export$69ea4907eefa8e7b = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $517c92a4e3fff9f6$var$WrappedStatusLozengeNew, $517c92a4e3fff9f6$var$WrappedStatusLozengeOld); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $517c92a4e3fff9f6$var$StyledLozenge = /*#__PURE__*/ (0, $cdbP5.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>// eslint-disable-next-line no-nested-ternary
    props.isDisabled ? (0, $2zOdI.disabledColor).text : !(0, $6XJko.isVisualRefreshEnabled)() ? (0, $2zOdI.textColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]] : (0, $2zOdI.textColorOld)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $2zOdI.disabledColor).bg : (0, $2zOdI.bgColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $2zOdI.disabledColor).text : (0, $2zOdI.textHoverColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $2zOdI.disabledColor).bg : (0, $2zOdI.bgHoverColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $cdbP5.css)({
        pointerEvents: 'none'
    })}}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $517c92a4e3fff9f6$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1bgi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $517c92a4e3fff9f6$var$StatusContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $517c92a4e3fff9f6$var$pressableStyles = (0, $1DXK0.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: '3px',
    background: 'transparent',
    position: 'relative',
    maxWidth: '100%',
    marginLeft: 'space.025'
});
const $517c92a4e3fff9f6$var$hoverOverlayStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    inset: '0',
    borderRadius: '3px',
    marginRight: 'space.025',
    ':hover': {
        opacity: 0.3,
        backgroundColor: 'color.background.inverse.subtle'
    }
});

});
parcelRegister("2zOdI", function(module, exports) {

$parcel$export(module.exports, "statusCategoryToThemeMap", () => $576836415c331af3$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $576836415c331af3$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $576836415c331af3$export$32f78bffcd82ff28);
$parcel$export(module.exports, "textColorOld", () => $576836415c331af3$export$26ac04004fa4ead4);
$parcel$export(module.exports, "bgHoverColor", () => $576836415c331af3$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $576836415c331af3$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $576836415c331af3$export$b70f10fc4a6ba453);
const $576836415c331af3$export$61137dce61763ec3 = 'default';
const $576836415c331af3$export$132676d06d92ad48 = 'success';
const $576836415c331af3$export$5c1f3b72419aa125 = 'inprogress';
const $576836415c331af3$export$d9e35f42afe1e488 = {
    '1': $576836415c331af3$export$61137dce61763ec3,
    '2': $576836415c331af3$export$61137dce61763ec3,
    '3': $576836415c331af3$export$132676d06d92ad48,
    '4': $576836415c331af3$export$5c1f3b72419aa125
};
const $576836415c331af3$export$7dcbec377a25efc6 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-background-neutral, #091E420F)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-background-success, #DCFFF1)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-background-information, #E9F2FF)"
};
const $576836415c331af3$export$32f78bffcd82ff28 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-text-subtle, #44546F)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $576836415c331af3$export$26ac04004fa4ead4 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $576836415c331af3$export$69fdf3ba928b4c77 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-background-neutral-hovered, #091E4224)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-background-success-hovered, #BAF3DB)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-background-information-hovered, #CCE0FF)"
};
const $576836415c331af3$export$99ec0cf2cf1b2082 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $576836415c331af3$export$b70f10fc4a6ba453 = {
    bg: "var(--ds-background-neutral, #091E420F)",
    text: "var(--ds-text-disabled, #091E424F)"
};

});

parcelRegister("fWpUz", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $b5ac3d09b389e3b4$export$a31cbe1bf5463979);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $2zOdI = parcelRequire("2zOdI");

const $b5ac3d09b389e3b4$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        appearance: (0, $2zOdI.statusCategoryToThemeMap)[statusCategoryId],
        isBold: true,
        ...isDisabled ? {
            style: {
                color: (0, $2zOdI.disabledColor).text,
                backgroundColor: (0, $2zOdI.disabledColor).bg
            }
        } : {}
    }, children);

});

parcelRegister("jAZ6b", function(module, exports) {

$parcel$export(module.exports, "LozengeOld", () => $6750667a552dd8b6$export$26089816624d22fc);
// TODO - delete this file when cleaning up visual-refresh

var $eJOHy = parcelRequire("eJOHy");
const $6750667a552dd8b6$var$containerStyles = {
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $6750667a552dd8b6$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $6750667a552dd8b6$export$26089816624d22fc = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $6750667a552dd8b6$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $6750667a552dd8b6$var$contentStyles
    }, children));
$6750667a552dd8b6$export$26089816624d22fc.displayName = 'Lozenge';

});



parcelRegister("hOKLP", function(module, exports) {

let $cf8b62cdc0bc065e$var$load = (parcelRequire("gLHA4"))(4);

module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $cf8b62cdc0bc065e$var$load("ltVCh")
        ]);
    }, function() {
        return Promise.all([
            $cf8b62cdc0bc065e$var$load("7BIsM")
        ]);
    }),
    $cf8b62cdc0bc065e$var$load("76n7a"),
    $cf8b62cdc0bc065e$var$load("l253H"),
    $cf8b62cdc0bc065e$var$load("kvhnd")
]).then(()=>parcelRequire('d8WYQ'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            console.error('Conditional dependency was not registered when executing. Falling back to synchronous bundle loading.');
            for (const url of fallback.urls)fallback.loader(url);
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});



parcelRegister("dAC9q", function(module, exports) {

let $9e4c3b29d6a25113$var$load = (parcelRequire("gLHA4"))(4);


module.exports = Promise.all([
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $9e4c3b29d6a25113$var$load("ltVCh")
        ]);
    }, function() {
        return Promise.all([
            $9e4c3b29d6a25113$var$load("7BIsM")
        ]);
    }),
    (parcelRequire("g81qY"))('improve_issue_automation_button_iv_llc', function() {
        return Promise.all([
            $9e4c3b29d6a25113$var$load("jteQo")
        ]);
    }, function() {
        return Promise.all([
            $9e4c3b29d6a25113$var$load("6Ry6c"),
            $9e4c3b29d6a25113$var$load("kvRbA"),
            $9e4c3b29d6a25113$var$load("ffQaD")
        ]);
    }),
    $9e4c3b29d6a25113$var$load("76n7a"),
    $9e4c3b29d6a25113$var$load("l253H"),
    $9e4c3b29d6a25113$var$load("7H9BN")
]).then(()=>parcelRequire('acyjq'));

});


parcelRegister("1S2ok", function(module, exports) {

$parcel$export(module.exports, "default", () => $634297a8139d6d41$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hRhIm = parcelRequire("hRhIm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$634297a8139d6d41$export$2e2bcd8739ae039 = ({ value: value })=>{
    const status = {
        id: value.id,
        name: value.name,
        statusCategory: value.statusCategory
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hRhIm.StatusLozenge), {
        value: status
    });
};

});


parcelRegister("bwBMG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e88d0308f1aa7b4$export$2e2bcd8739ae039);

var $dQRbF = parcelRequire("dQRbF");

var $8toaC = parcelRequire("8toaC");

var $jIWbT = parcelRequire("jIWbT");
const $6e88d0308f1aa7b4$var$mapStateToProps = (state)=>({
        useJSMQueueDurationEvent: (0, $dQRbF.getUseJSMQueueDurationEvent)(state),
        getIssueLinkOverride: (0, $dQRbF.getIssueLinkOverride)(state)
    });
const $6e88d0308f1aa7b4$var$mergeProps = (stateProps, dispatchProps, ownProps)=>({
        ...ownProps,
        ...stateProps
    });
var $6e88d0308f1aa7b4$export$2e2bcd8739ae039 = (0, $8toaC.connect)($6e88d0308f1aa7b4$var$mapStateToProps, {}, $6e88d0308f1aa7b4$var$mergeProps)((0, $jIWbT.default));

});
parcelRegister("jIWbT", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf18b546a5a45e87$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8IeH1 = parcelRequire("8IeH1");

var $hdC3k = parcelRequire("hdC3k");

var $gCeeo = parcelRequire("gCeeo");

var $7gc68 = parcelRequire("7gc68");
const $cf18b546a5a45e87$var$linkStyle = ()=>({
        boxShadow: 'none',
        outline: 'none'
    });
class $cf18b546a5a45e87$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    renderDisabled() {
        const { dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.UnselectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            paddingBlock: "space.100",
            paddingInline: "space.0"
        }, value));
    }
    render() {
        const { dataSelectorProps: { value: value }, tableInjectedProps: { isLastColumn: isLastColumn, issueKey: issueKey, isTableDisabled: isTableDisabled }, getIssueLinkOverride: getIssueLinkOverride } = this.props;
        if (isTableDisabled) return this.renderDisabled();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7gc68.SelectableChildGutterPaddingContainer), {
            isLastColumn: isLastColumn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cf18b546a5a45e87$var$Container, {
            isFocused: this.state.isFocused
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hdC3k.default), {
            // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $cf18b546a5a45e87$var$linkStyle(),
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            href: getIssueLinkOverride ? getIssueLinkOverride(issueKey) : `/browse/${issueKey}`,
            onClick: this.onClick,
            onAuxClick: this.onAuxClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "issue-link",
            'data-issue-key': issueKey
        }, value)));
    }
    constructor(...args){
        super(...args), this.state = {
            isFocused: false
        }, this.onFocus = ()=>{
            this.setState({
                isFocused: true
            });
        }, this.onBlur = ()=>{
            this.setState({
                isFocused: false
            });
        }, this.onClick = (event, analyticsEvent)=>{
            const { onIssueViewTransition: onIssueViewTransition } = this.props.tableInjectedProps;
            const { useJSMQueueDurationEvent: useJSMQueueDurationEvent } = this.props;
            onIssueViewTransition?.(event);
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'tableIssueLink');
            // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useJSMQueueDurationEvent && useJSMQueueDurationEvent();
        }, this.onAuxClick = ()=>{
            const { useJSMQueueDurationEvent: useJSMQueueDurationEvent } = this.props;
            // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useJSMQueueDurationEvent && useJSMQueueDurationEvent();
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf18b546a5a45e87$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _12ji1r31 _1qu2glyw _12y31o36 _189eyh40 _1dqonqa1 _ca0qu2gc _u5f312x7 _n3tdu2gc _19bv12x7 _1bsb1wug _16qsglyw",
            __cmplp.isFocused ? "_1h6d1p6i" : "_1h6d3acm",
            __cmplp.className
        ])
    });
});

});


parcelRegister("eFu13", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ad33f4e732722b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $b3ad33f4e732722b$var$WorkCategory = (props)=>{
    const { dataSelectorProps: { value: value } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, value);
};
var $b3ad33f4e732722b$export$2e2bcd8739ae039 = $b3ad33f4e732722b$var$WorkCategory;

});

parcelRegister("fDYcT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f82c960a96f78c6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $6XJko = parcelRequire("6XJko");

var $6kau5 = parcelRequire("6kau5");
const $9f82c960a96f78c6$var$statusCategoryToAppearanceMap = (statusCategory)=>{
    switch(statusCategory){
        case 'inProgress':
            return 'inprogress';
        case 'done':
            return 'success';
        default:
            return 'default';
    }
};
const $9f82c960a96f78c6$var$StatusCategoryLozenge = ({ dataSelectorProps: dataSelectorProps, tableInjectedProps: tableInjectedProps })=>{
    const { value: value } = dataSelectorProps;
    const { isLastColumn: isLastColumn } = tableInjectedProps;
    if (!value) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6kau5.default), {
        isLastColumn: isLastColumn
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: $9f82c960a96f78c6$var$statusCategoryToAppearanceMap(value.category),
        isBold: (0, $6XJko.isVisualRefreshEnabled)(),
        maxWidth: "192px"
    }, value.name);
};
var $9f82c960a96f78c6$export$2e2bcd8739ae039 = $9f82c960a96f78c6$var$StatusCategoryLozenge;

});


parcelRegister("fMEaU", function(module, exports) {

$parcel$export(module.exports, "default", () => $199c77ea99a9b432$export$2e2bcd8739ae039);

var $ahm5r = parcelRequire("ahm5r");

var $86tBw = parcelRequire("86tBw");

var $6gaEC = parcelRequire("6gaEC");

var $2f0m6 = parcelRequire("2f0m6");

var $8toaC = parcelRequire("8toaC");

var $gG2oQ = parcelRequire("gG2oQ");
const $199c77ea99a9b432$var$getAllKnownIssueKeysFactory = ()=>(0, $ahm5r.createSelector)((0, $2f0m6.getAllKnownIssueKeys), (res)=>res);
const $199c77ea99a9b432$var$mapStateToPropsFactory = ()=>{
    const getAllKnownIssueKeysInstance = $199c77ea99a9b432$var$getAllKnownIssueKeysFactory();
    return (state)=>({
            allIssueKeys: getAllKnownIssueKeysInstance(state),
            SelectedIssuesSubscriber: $6gaEC.SelectedIssuesSubscriber,
            Checkbox: $86tBw.default
        });
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 1. | TS2345 - Argument of type 'typeof CheckboxWrapper' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$199c77ea99a9b432$export$2e2bcd8739ae039 = (0, $8toaC.connect)($199c77ea99a9b432$var$mapStateToPropsFactory)((0, $gG2oQ.default));

});
parcelRegister("86tBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $43629aa548cc82fb$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $gyJTO = parcelRequire("gyJTO");

var $cM2mi = parcelRequire("cM2mi");
var $jJLKy = parcelRequire("jJLKy");
var $9ywMw = parcelRequire("9ywMw");
var $lsp6q = parcelRequire("lsp6q");
const $43629aa548cc82fb$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $43629aa548cc82fb$var$Checkbox = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $eJOHy.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eJOHy.useRef)(null);
    const mergedRefs = (0, $gyJTO.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eJOHy.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jJLKy.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hcewu.default)([
                    $43629aa548cc82fb$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cM2mi.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ywMw.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lsp6q.default), {})
                ]
            })
        ]
    });
}));
$43629aa548cc82fb$var$Checkbox.displayName = 'Checkbox';
var $43629aa548cc82fb$export$2e2bcd8739ae039 = $43629aa548cc82fb$var$Checkbox;

});
parcelRegister("cM2mi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b89a586a6c2ef726$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
function $b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $b89a586a6c2ef726$var$CheckboxIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eJOHy.useMemo)(()=>$b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $b89a586a6c2ef726$export$2e2bcd8739ae039 = $b89a586a6c2ef726$var$CheckboxIcon;

});

parcelRegister("jJLKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4573aabb850f2ff0$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4573aabb850f2ff0$var$baseStyles = null;
const $4573aabb850f2ff0$var$textLabelLayoutStyles = null;
const $4573aabb850f2ff0$var$disabledStyles = null;
const $4573aabb850f2ff0$var$labelStyles = null;
function $4573aabb850f2ff0$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("9ywMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $94306373cce3a9fe$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $94306373cce3a9fe$var$labelTextStyles = null;
function $94306373cce3a9fe$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("lsp6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bafcc116ddbb4544$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bafcc116ddbb4544$var$requiredIndicatorStyles = null;
function $bafcc116ddbb4544$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hcewu.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("gG2oQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $96d10ca152ea6327$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $8dH3d = parcelRequire("8dH3d");

var $idGBm = parcelRequire("idGBm");

var $gCeeo = parcelRequire("gCeeo");

var $eKlJN = parcelRequire("eKlJN");
// eslint-disable-next-line jira/react/no-class-components
class $96d10ca152ea6327$var$CheckboxWrapperWithoutIntl extends (0, $eJOHy.Component) {
    static isSelected(state) {
        const { issueKeys: issueKeys } = state; // for isIndeterminate to work, we must always also set isSelected. Thus, this condition becomes very simple.
        return !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(issueKeys);
    }
    isIndeterminate(state) {
        const { issueKeys: issueKeys } = state;
        const { allIssueKeys: allIssueKeys } = this.props;
        return issueKeys.length !== allIssueKeys.length && !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(issueKeys);
    }
    createOnChange(state, actions) {
        return (e, analyticsEvent)=>{
            const { issueKeys: issueKeys } = state;
            const { allIssueKeys: allIssueKeys } = this.props;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(issueKeys)) {
                actions.selectIssues(allIssueKeys, analyticsEvent);
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'issueTableHeaderBulkActionCheckbox', {
                    usage: 'selectAll'
                });
            } else {
                // allIssueKeys not guaranteed to contain all issueKeys
                actions.deselectAllIssues(analyticsEvent);
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'issueTableHeaderBulkActionCheckbox', {
                    usage: 'deselectAll'
                });
            }
        };
    }
    render() {
        const { SelectedIssuesSubscriber: SelectedIssuesSubscriber, Checkbox: Checkbox, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SelectedIssuesSubscriber, null, (state, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($96d10ca152ea6327$var$StyledWrapper, {
                isDisabled: false ? true : state.isLocked
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Checkbox, {
                "aria-label": intl.formatMessage((0, $eKlJN.default).selectAllCheckboxLabel),
                isDisabled: state.isLocked,
                isChecked: $96d10ca152ea6327$var$CheckboxWrapperWithoutIntl.isSelected(state),
                isIndeterminate: this.isIndeterminate(state),
                onChange: this.createOnChange(state, actions)
            }), /* We render the real color of the checkbox on top of the actual checkbox
        	to hide the issue where it renders as black initially, and to make it non-interactable */ false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                "data-testid": "issue-table.common.fields.checkbox.header.div",
                className: (0, $hcewu.default)([
                    $96d10ca152ea6327$var$styles.shadowCheckboxWrapper
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                className: (0, $hcewu.default)([
                    $96d10ca152ea6327$var$styles.shadowCheckbox
                ])
            }))));
    }
}
const $96d10ca152ea6327$export$eef12940a6696c78 = (0, $idGBm.injectIntlV2)($96d10ca152ea6327$var$CheckboxWrapperWithoutIntl);
var $96d10ca152ea6327$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $96d10ca152ea6327$export$eef12940a6696c78;
const $96d10ca152ea6327$var$StyledWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_jmuphv": (0, $awdRS.default)(__cmplp.isDisabled ? 'not-allowed' : 'pointer')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_uiztglyw _vchhusvi _1bsb1osq _ca0qidpf _u5f3pxbi _n3tdidpf _19bvutpp _12ul13s5",
            __cmplp.className
        ])
    });
});
const $96d10ca152ea6327$var$styles = {
    shadowCheckbox: "_kqswstnw _154i12x7 _1ltvu2gc _4t3i1crf _1bsb1crf _bfhk1j9a",
    shadowCheckboxWrapper: "_80om13gf _kqswstnw _1bsbzwfg _4t3izwfg _154iu2gc _1ltvv77o"
};

});
parcelRegister("eKlJN", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d29c17ac6b96e59$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7d29c17ac6b96e59$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    selectAllCheckboxLabel: {
        "id": "issue-table.common.fields.checkbox.header.select-all-checkbox-label",
        "defaultMessage": "Select all issues"
    }
});

});



parcelRegister("7XoO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a3933c8113ed2a0$export$2e2bcd8739ae039);

var $dpmnN = parcelRequire("dpmnN");

var $8toaC = parcelRequire("8toaC");

var $c10dn = parcelRequire("c10dn");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8a3933c8113ed2a0$var$mapDispatchToProps = (dispatch, { rowId: rowId })=>({
        // @ts-expect-error - TS7031 - Binding element 'isShiftKeyDown' implicitly has an 'any' type. | TS7031 - Binding element 'selection' implicitly has an 'any' type.
        onChange: ({ isShiftKeyDown: isShiftKeyDown, isSelected: selection }, analyticsEvent)=>dispatch((0, $dpmnN.selectRowAction)({
                rowId: rowId,
                isShiftKeyDown: isShiftKeyDown,
                selection: selection
            }, analyticsEvent))
    });
var $8a3933c8113ed2a0$export$2e2bcd8739ae039 = (0, $8toaC.connect)(null, $8a3933c8113ed2a0$var$mapDispatchToProps)((0, $c10dn.default));

});
parcelRegister("c10dn", function(module, exports) {

$parcel$export(module.exports, "default", () => $89cbe94b577dd888$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $bPWfC = parcelRequire("bPWfC");

var $86tBw = parcelRequire("86tBw");

var $k71qx = parcelRequire("k71qx");

var $dPMMf = parcelRequire("dPMMf");

var $idGBm = parcelRequire("idGBm");


var $6gaEC = parcelRequire("6gaEC");

var $gCeeo = parcelRequire("gCeeo");

var $ljej9 = parcelRequire("ljej9");

var $8lKn7 = parcelRequire("8lKn7");
const $89cbe94b577dd888$var$checkboxCellPaddingLeft = `${1.5 * (0, $dPMMf.gridSize)}px`;
// eslint-disable-next-line jira/react/no-class-components
class $89cbe94b577dd888$var$CheckboxWrapperWithoutIntl extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            Checkbox: (0, $86tBw.default),
            SelectedIssuesSubscriber: (0, $6gaEC.SelectedIssuesSubscriber)
        };
    }
    createOnChange({ selectedIssueKeys: selectedIssueKeys }) {
        return (event, analyticsEvent)=>{
            const { onChange: onChange, rowId: rowId } = this.props; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const isShiftKeyDown = event.nativeEvent.shiftKey;
            onChange({
                isSelected: !(0, (/*@__PURE__*/$parcel$interopDefault($bPWfC)))(selectedIssueKeys, (0, $ljej9.toIssueKey)(rowId)),
                isShiftKeyDown: isShiftKeyDown
            }, analyticsEvent);
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'issueTableBulkActionCheckbox');
        };
    }
    render() {
        const { SelectedIssuesSubscriber: SelectedIssuesSubscriber, rowId: rowId, Checkbox: Checkbox, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SelectedIssuesSubscriber, null, ({ issueKeys: issueKeys, limit: limit, isLocked: isLocked })=>{
            const issueKey = (0, $ljej9.toIssueKey)(rowId);
            const isChecked = (0, (/*@__PURE__*/$parcel$interopDefault($bPWfC)))(issueKeys, issueKey);
            // In the SSR'd doc the checkbox should be disabled to select but with
            // enabled styling.
            if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89cbe94b577dd888$var$StyledWrapper, {
                isDisabled: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Checkbox, {
                isChecked: false
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: intl.formatMessage((0, $8lKn7.default).maximumReached, {
                    limit: (0, $119bdb92cb31a359$export$81a88ed305997a6d)
                }),
                delay: 0,
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89cbe94b577dd888$var$TooltipHolder, null)));
            if (isLocked) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89cbe94b577dd888$var$StyledWrapper, {
                isDisabled: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Checkbox, {
                isDisabled: true,
                isChecked: isChecked
            }));
            const isDisabled = !isChecked && issueKeys.length >= limit;
            return isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89cbe94b577dd888$var$StyledWrapper, {
                isDisabled: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Checkbox, {
                isDisabled: true,
                isChecked: isChecked
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: intl.formatMessage((0, $8lKn7.default).maximumReached, {
                    limit: (0, $119bdb92cb31a359$export$81a88ed305997a6d)
                }),
                delay: 0,
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89cbe94b577dd888$var$TooltipHolder, null))) : // @ts-expect-error - TS2741 - Property 'isDisabled' is missing in type '{ children: Element; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { isDisabled: boolean; }, any>>'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89cbe94b577dd888$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Checkbox, {
                "aria-label": intl.formatMessage((0, $8lKn7.default).selectThisCheckboxLabel, {
                    issueKey: issueKey
                }),
                isChecked: isChecked,
                onChange: this.createOnChange({
                    selectedIssueKeys: issueKeys
                })
            }));
        });
    }
}
const $89cbe94b577dd888$export$eef12940a6696c78 = (0, $idGBm.injectIntlV2)($89cbe94b577dd888$var$CheckboxWrapperWithoutIntl);
var $89cbe94b577dd888$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $89cbe94b577dd888$export$eef12940a6696c78;
const $89cbe94b577dd888$var$StyledWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1sdlsvv": (0, $awdRS.default)($89cbe94b577dd888$var$checkboxCellPaddingLeft),
            "--_jmuphv": (0, $awdRS.default)(__cmplp.isDisabled ? 'not-allowed' : 'pointer')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1yt41ah3 _uiztglyw _kqswh2mm _vchhusvi _1bsb1osq _12ul13s5",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89cbe94b577dd888$var$TooltipHolder = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_80om13gf _kqswstnw _154iu2gc _1ltvu2gc _1xi2u2gc _94n5u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8lKn7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7b7473498ad454$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fc7b7473498ad454$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    maximumReached: {
        "id": "issue-table.common.fields.checkbox.maximum-reached",
        "defaultMessage": "Limit reached ({limit})"
    },
    selectThisCheckboxLabel: {
        "id": "issue-table.common.fields.checkbox.select-this-checkbox-label",
        "defaultMessage": "Select issue ({issueKey})"
    }
});

});



parcelRegister("60TLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $5786c676c4e3aaa6$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $l5htz = parcelRequire("l5htz");

var $blTcR = parcelRequire("blTcR");

var $8toaC = parcelRequire("8toaC");

var $iRw78 = parcelRequire("iRw78");

var $dboTq = parcelRequire("dboTq");
const $5786c676c4e3aaa6$var$mapStateToProps = (state, ownProps)=>{
    const { columnId: columnId } = ownProps;
    const onSortOrderChange = (0, $blTcR.getOnSortOrderChanged)(state, columnId);
    const sortOrder = (0, $blTcR.getCurrentSorting)(state, columnId);
    let isSortable = false;
    if (onSortOrderChange) isSortable = true;
    return {
        columnName: (0, $blTcR.maybeColumnTitle)(state, columnId).orSome(''),
        fieldType: (0, $blTcR.getFieldType)(state, columnId),
        sortOrder: sortOrder,
        isDisabled: (0, $blTcR.isDisabled)(state, columnId) && sortOrder,
        onSortOrderChange: onSortOrderChange,
        isSortable: isSortable
    };
};
var $5786c676c4e3aaa6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $l5htz.default)({
    onSortOrderChange: (fieldId, sortOrder)=>({
            name: 'sortOrderChange',
            fieldId: fieldId,
            sortOrder: sortOrder
        })
}), (0, $iRw78.ReduxAnalyticsData)((state, ownProps)=>({
        attributes: {
            fieldId: (0, $blTcR.getFieldType)(state, ownProps.columnId)
        }
    })), // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 1.
(0, $8toaC.connect)($5786c676c4e3aaa6$var$mapStateToProps))((0, $dboTq.default));

});
parcelRegister("blTcR", function(module, exports) {

$parcel$export(module.exports, "getColumns", () => $b7c3a1743037d51c$export$978e30a0fb8610d8);
$parcel$export(module.exports, "maybeColumnTitle", () => $b7c3a1743037d51c$export$7929a97abf07197e);
$parcel$export(module.exports, "getColumnTitle", () => $b7c3a1743037d51c$export$7fd4bf39bc1fa7d6);
$parcel$export(module.exports, "getCurrentSorting", () => $b7c3a1743037d51c$export$d31773bdd38d8c2c);
$parcel$export(module.exports, "isDisabled", () => $b7c3a1743037d51c$export$30e0dc115df457ed);
$parcel$export(module.exports, "getFieldType", () => $b7c3a1743037d51c$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "getOnSortOrderChanged", () => $b7c3a1743037d51c$export$7d6c76fc2d097cc2);
$parcel$export(module.exports, "isLastColumn", () => $b7c3a1743037d51c$export$e509b4c22370e953);
$parcel$export(module.exports, "isColumnKnown", () => $b7c3a1743037d51c$export$265a5752f4c87727);

var $ahm5r = parcelRequire("ahm5r");

var $6kS6u = parcelRequire("6kS6u");

var $ljsRg = parcelRequire("ljsRg");

var $lhJwW = parcelRequire("lhJwW");
const $b7c3a1743037d51c$export$978e30a0fb8610d8 = (state)=>(0, $lhJwW.getPersisted)(state).columns;
const $b7c3a1743037d51c$export$46d040b9076e32ab = (state, columnId)=>(0, $ljsRg.Maybe).fromNull((0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))($b7c3a1743037d51c$export$978e30a0fb8610d8(state), {
        id: columnId
    }));
const $b7c3a1743037d51c$export$7929a97abf07197e = (state, columnId)=>// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    $b7c3a1743037d51c$export$46d040b9076e32ab(state, columnId).map((column)=>column.title);
const $b7c3a1743037d51c$export$7fd4bf39bc1fa7d6 = (state, columnId)=>$b7c3a1743037d51c$export$7929a97abf07197e(state, columnId).orSome('');
const $b7c3a1743037d51c$export$d31773bdd38d8c2c = (state, columnId)=>$b7c3a1743037d51c$export$46d040b9076e32ab(state, columnId)// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    .flatMap((column)=>(0, $ljsRg.Maybe).fromNull(column.currentSorting)).cata(()=>undefined, // @ts-expect-error - TS7006 - Parameter 'order' implicitly has an 'any' type.
    (order)=>order);
const $b7c3a1743037d51c$export$30e0dc115df457ed = (state, columnId)=>$b7c3a1743037d51c$export$46d040b9076e32ab(state, columnId)// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    .flatMap((column)=>(0, $ljsRg.Maybe).fromNull(column.isDisabled)).cata(()=>false, // @ts-expect-error - TS7006 - Parameter 'disabled' implicitly has an 'any' type.
    (disabled)=>disabled);
const $b7c3a1743037d51c$export$b9089a6e41ed43aa = (state, columnId)=>$b7c3a1743037d51c$export$46d040b9076e32ab(state, columnId)// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    .map((column)=>column.fieldType).orSome('');
const $b7c3a1743037d51c$export$932a39ca74873b9d = (state, columnId)=>// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    $b7c3a1743037d51c$export$46d040b9076e32ab(state, columnId).flatMap((column)=>(0, $ljsRg.Maybe).fromNull(column.onSortOrderChanged));
const $b7c3a1743037d51c$export$7d6c76fc2d097cc2 = (state, columnId)=>$b7c3a1743037d51c$export$932a39ca74873b9d(state, columnId).cata(()=>undefined, // @ts-expect-error - TS7006 - Parameter 'callback' implicitly has an 'any' type.
    (callback)=>callback);
const $b7c3a1743037d51c$export$e509b4c22370e953 = (state, columnId)=>{
    const columns = $b7c3a1743037d51c$export$978e30a0fb8610d8(state);
    return columns.length > 0 && columns[columns.length - 1].id === columnId;
};
const $b7c3a1743037d51c$var$indexColumnIds = (0, $ahm5r.createSelector)($b7c3a1743037d51c$export$978e30a0fb8610d8, (columns)=>new Set(columns.map((column)=>column.id)));
const $b7c3a1743037d51c$export$265a5752f4c87727 = (state, columnId)=>$b7c3a1743037d51c$var$indexColumnIds(state).has(columnId);

});

parcelRegister("iRw78", function(module, exports) {

$parcel$export(module.exports, "ReduxAnalyticsData", () => $165639d7f47cb85a$export$eb16d2484452fbaa);

var $9fn3D = parcelRequire("9fn3D");

var $8toaC = parcelRequire("8toaC");
const $165639d7f47cb85a$export$eb16d2484452fbaa = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, { storeKey: storeKey, ...restConnectOptions } = {})=>(0, $9fn3D.default)(mapStateToAnalytics, {
        ...restConnectOptions,
        context: (0, $8toaC.IssueTableContext)
    });

});
parcelRegister("9fn3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $79b219d3a17c61db$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $e2B2h = parcelRequire("e2B2h");

var $gnQAk = parcelRequire("gnQAk");

var $6Cihn = parcelRequire("6Cihn");

var $5nSuO = parcelRequire("5nSuO");
const $79b219d3a17c61db$var$ReduxAnalyticsData = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, connectOptions = {})=>(WrappedComponent)=>{
        // eslint-disable-next-line jira/react/no-class-components
        class ComponentWrappedInAnalytics extends (0, $eJOHy.Component) {
            static{
                this.displayName = `ReduxAnalyticsData(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            static{
                this.defaultProps = {
                    analyticsContext: {}
                };
            }
            render() {
                const { analyticsContext: analyticsContext, ...componentProps } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e2B2h.default), {
                    data: analyticsContext
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, componentProps));
            }
        }
        const mapStateToPropsFactory = ()=>{
            const analyticsContextSelectorInstance = (0, $LFmXM.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (state, ownProps)=>(0, $5nSuO.default)(mapStateToAnalytics(state, ownProps)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (state, ownProps)=>({
                    analyticsContext: analyticsContextSelectorInstance(state, ownProps)
                });
        };
        return (0, $gnQAk.connect)(mapStateToPropsFactory, ()=>({}), null, {
            // to prevent connected component from unnecessary re-render
            areStatePropsEqual: (nextProps, prevProps)=>{
                const { attributes: prevAttributes, ...prevFields } = prevProps.analyticsContext;
                const { attributes: nextAttributes, ...nextFields } = nextProps.analyticsContext;
                return (0, $6Cihn.default)(prevAttributes, nextAttributes) && (0, $6Cihn.default)(prevFields, nextFields);
            },
            ...connectOptions
        })(ComponentWrappedInAnalytics);
    };
var $79b219d3a17c61db$export$2e2bcd8739ae039 = $79b219d3a17c61db$var$ReduxAnalyticsData;

});
parcelRegister("6Cihn", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c69ae16e9371c16$export$2e2bcd8739ae039);
const $6c69ae16e9371c16$var$isArrayEqual = (array1 = [], array2 = [])=>{
    if (array1 === array2) return true;
    // check one level deep
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var // one level check to see if object references are equal
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$6c69ae16e9371c16$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'never[]'.
    if (!$6c69ae16e9371c16$var$isArrayEqual(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        const value = obj1[key];
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'never[]'.
        return Array.isArray(nextValue) && Array.isArray(value) && $6c69ae16e9371c16$var$isArrayEqual(value, nextValue);
    });
    return areValuesEqual;
};

});



parcelRegister("dboTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ffab81445d9a928$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $goZPP = parcelRequire("goZPP");

var $fL0In = parcelRequire("fL0In");

var $jkYbX = parcelRequire("jkYbX");

var $k71qx = parcelRequire("k71qx");

var $3cMgR = parcelRequire("3cMgR");

var $dPMMf = parcelRequire("dPMMf");

var $idGBm = parcelRequire("idGBm");

var $7jTnu = parcelRequire("7jTnu");

var $40bqY = parcelRequire("40bqY");


var $gRBoi = parcelRequire("gRBoi");

var $bllBK = parcelRequire("bllBK");
const $9ffab81445d9a928$var$ascendingGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 25"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M10.7 16.7v-5.6l-1.3 1.3c-.4.4-1 .4-1.4 0-.2-.2-.3-.5-.3-.7 0-.3.1-.5.3-.7l3-3c.2-.2.5-.3.7-.3.3 0 .5.1.7.3l3 3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-1.3-1.3v5.6c0 .6-.5 1-1 1s-1-.5-1-1z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
    }));
const $9ffab81445d9a928$var$descendingGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 25"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.7 8.7v5.6L14 13c.4-.4 1-.4 1.4 0 .2.2.3.5.3.7 0 .3-.1.5-.3.7l-3 3c-.2.2-.5.3-.7.3-.3 0-.5-.1-.7-.3l-3-3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l1.3 1.3V8.7c0-.6.4-1 1-1s1 .4 1 1z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
    }));
class $9ffab81445d9a928$export$99f5cf69b7ccb3ed extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isDefaultSortOrder: false,
            allowClearingSort: false,
            sortOrder: (0, $4ec7ec7f2cfbc873$export$c53d0f541b41b88e),
            width: undefined,
            onSortOrderChange: undefined
        };
    }
    onKeyDownCapture(event) {
        if (event.key === 'Enter') event.stopPropagation();
    }
    getTooltipText(columnName) {
        if (typeof columnName === 'string') return `${columnName} \u{2022} ${this.getSortOrderTooltipText()}`;
        return this.getSortOrderTooltipText();
    }
    getSortOrderTooltipText() {
        switch(this.props.sortOrder){
            case 0, $4ec7ec7f2cfbc873$export$c53d0f541b41b88e:
                return this.getNoOrderTooltipText();
            case 0, $4ec7ec7f2cfbc873$export$1dee026a19752d6b:
                return this.getAscOrderTooltipText();
            case 0, $4ec7ec7f2cfbc873$export$b6abcf7fa1d94f65:
                return this.getDescOrderTooltipText();
            default:
                return 'Invalid state';
        }
    }
    getNoOrderTooltipText() {
        const { fieldType: fieldType, intl: { formatMessage: format } } = this.props;
        const fieldConfigs = (0, $40bqY.default)[fieldType];
        if (fieldConfigs && fieldConfigs.ascText) return format((0, $gRBoi.default).sortOrder, {
            sortOrder: format(fieldConfigs.ascText)
        });
        return format((0, $gRBoi.default).defaultSortOrder, {
            isAscending: true
        });
    }
    getAscOrderTooltipText() {
        const { fieldType: fieldType, isDefaultSortOrder: isDefaultSortOrder, intl: { formatMessage: format } } = this.props;
        const fieldConfigs = (0, $40bqY.default)[fieldType];
        if (fieldConfigs && fieldConfigs.ascText) return format((0, $gRBoi.default).sortedOrder, {
            sortOrder: format(fieldConfigs.ascText),
            isDefault: isDefaultSortOrder
        });
        return format((0, $gRBoi.default).defaultSortedOrder, {
            isAscending: true,
            isDefault: isDefaultSortOrder
        });
    }
    getDescOrderTooltipText() {
        const { fieldType: fieldType, isDefaultSortOrder: isDefaultSortOrder, intl: { formatMessage: format } } = this.props;
        const fieldConfigs = (0, $40bqY.default)[fieldType];
        if (fieldConfigs && fieldConfigs.descText) return format((0, $gRBoi.default).sortedOrder, {
            sortOrder: format(fieldConfigs.descText),
            isDefault: isDefaultSortOrder
        });
        return format((0, $gRBoi.default).defaultSortedOrder, {
            isAscending: false,
            isDefault: isDefaultSortOrder
        });
    }
    getNextSortOrder(currentSortOrder) {
        switch(currentSortOrder){
            case 0, $4ec7ec7f2cfbc873$export$c53d0f541b41b88e:
                return 0, $4ec7ec7f2cfbc873$export$1dee026a19752d6b;
            case 0, $4ec7ec7f2cfbc873$export$1dee026a19752d6b:
                return 0, $4ec7ec7f2cfbc873$export$b6abcf7fa1d94f65;
            case 0, $4ec7ec7f2cfbc873$export$b6abcf7fa1d94f65:
            default:
                return this.props.allowClearingSort ? (0, $4ec7ec7f2cfbc873$export$c53d0f541b41b88e) : (0, $4ec7ec7f2cfbc873$export$1dee026a19752d6b);
        }
    }
    getHeaderIcon() {
        switch(this.props.sortOrder){
            case 0, $4ec7ec7f2cfbc873$export$1dee026a19752d6b:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                    testId: (0, $gRBoi.default).sortingButtonIcon.id,
                    glyph: $9ffab81445d9a928$var$ascendingGlyph,
                    "aria-hidden": (0, $7jTnu.fg)('jsm_queue_a11y_improvement'),
                    label: (0, $7jTnu.fg)('jsm_queue_a11y_improvement') ? '' : 'Ascending icon',
                    size: "medium"
                });
            case 0, $4ec7ec7f2cfbc873$export$b6abcf7fa1d94f65:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                    testId: (0, $gRBoi.default).sortingButtonIcon.id,
                    glyph: $9ffab81445d9a928$var$descendingGlyph,
                    "aria-hidden": (0, $7jTnu.fg)('jsm_queue_a11y_improvement'),
                    label: (0, $7jTnu.fg)('jsm_queue_a11y_improvement') ? '' : 'Descending icon',
                    size: "medium"
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                    testId: (0, $gRBoi.default).sortingButtonIcon.id,
                    glyph: $9ffab81445d9a928$var$ascendingGlyph,
                    "aria-hidden": (0, $7jTnu.fg)('jsm_queue_a11y_improvement'),
                    label: (0, $7jTnu.fg)('jsm_queue_a11y_improvement') ? '' : 'Sort-by icon',
                    size: "medium",
                    primaryColor: "var(--ds-icon-subtle, #626F86)"
                });
        }
    }
    getButtonWithTooltip() {
        const { columnName: columnName, sortOrder: sortOrder, width: width, isDisabled: isDisabled, intl: { formatMessage: formatMessage } } = this.props;
        const buttonAppearance = sortOrder === (0, $4ec7ec7f2cfbc873$export$c53d0f541b41b88e) ? 'subtle' : 'default';
        const isHeaderSelected = sortOrder !== (0, $4ec7ec7f2cfbc873$export$c53d0f541b41b88e);
        const isSsr = false && (0, $7jTnu.fg)('issue_list_ssr_disable_sort_and_inline_edit');
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: buttonAppearance,
            onClick: this.onSortOrderChange,
            spacing: "none",
            isDisabled: isSsr ? true : isDisabled,
            ...(0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') ? {
                role: 'button',
                'aria-roledescription': formatMessage((0, $gRBoi.default).a11YSortButtonDescriptionLabel)
            } : {}
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9ffab81445d9a928$var$HeaderContent, {
            hasIcon: isHeaderSelected,
            hasFixedWidth: !!width
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9ffab81445d9a928$var$HeaderText, {
            hasIcon: isHeaderSelected,
            maxWidth: width
        }, columnName), /* The icon must be part of the tooltip target, so we can't use the
        `iconAfter` prop of the atlaskit button */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9ffab81445d9a928$var$IconWrapper, {
            isVisible: isHeaderSelected
        }, this.getHeaderIcon())));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bllBK.default), {
            isSortOrderChanged: this.state.sortOrderChanged,
            tooltipText: this.getTooltipText(columnName),
            onShow: this.onSortOrderTooltipShow
        }, isSsr ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9ffab81445d9a928$var$HeaderButtonContainer, null, button) : button);
    }
    render() {
        const { intl: { formatMessage: formatMessage }, isDisabled: isDisabled, isSortable: isSortable, columnName: columnName, fieldType: fieldType, width: width } = this.props; /**
                     * "Epic Link" and "Parent Link" fields are both deprecated in favour of the new "Parent" field,
                     * therefore we show a plain header with a warning icon and a tooltip for both fields to "request"
                     * customers to remove these fields from their queues
                     */ 
        if ((fieldType === 'com.pyxis.greenhopper.jira:gh-epic-link' || fieldType === 'com.atlassian.jpo:jpo-custom-field-parent') && (0, $7jTnu.fg)('jsm_queue_epic_parent_link_deprecation_msg_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9ffab81445d9a928$var$PlainHeader, {
            maxWidth: width
        }, columnName, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage(fieldType === 'com.pyxis.greenhopper.jira:gh-epic-link' ? (0, $gRBoi.default).epicLinkFieldReplacedByParentField : (0, $gRBoi.default).parentLinkFieldReplacedByParentField, {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                        as: "strong",
                        color: "inherit"
                    }, chunks)
            }),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
            color: "var(--ds-icon-warning, #E56910)",
            spacing: "spacious",
            label: "",
            testId: fieldType === 'com.pyxis.greenhopper.jira:gh-epic-link' ? 'issue-table.common.sort-column-header.warning-icon.epic-link' : 'issue-table.common.sort-column-header.warning-icon.parent-link'
        })));
        if (isSortable || isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9ffab81445d9a928$var$HeaderWrapperExperiment, {
            onKeyDownCapture: this.onKeyDownCapture,
            "data-component-selector": "header-wrapper-experiment-component-selector"
        }, this.getButtonWithTooltip());
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9ffab81445d9a928$var$PlainHeader, {
            maxWidth: width
        }, columnName);
    }
    constructor(...args){
        super(...args), this.state = {
            sortOrderChanged: false
        }, this.onSortOrderChange = (e, analyticsEvent)=>{
            const { onSortOrderChange: onSortOrderChange, sortOrder: sortOrder, columnId: columnId } = this.props;
            const nextSortOrder = this.getNextSortOrder(sortOrder);
            onSortOrderChange && onSortOrderChange(columnId, nextSortOrder, analyticsEvent);
            this.setState({
                sortOrderChanged: true
            });
        }, this.onSortOrderTooltipShow = ()=>{
            this.setState({
                sortOrderChanged: false
            });
        };
    }
}
var $9ffab81445d9a928$export$2e2bcd8739ae039 /* Icon also appears under these pseudo-classes */  = (0, $idGBm.injectIntlV2)($9ffab81445d9a928$export$99f5cf69b7ccb3ed);
const $9ffab81445d9a928$var$addWhenInteracted = 'button:focus &, [data-component-selector="header-wrapper-experiment-component-selector"]:hover &'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ffab81445d9a928$var$HeaderWrapperExperiment = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _z29h64oc _1m1b1r31 _lt2an7od _1twe1o36 _1s3gn7od",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ffab81445d9a928$var$HeaderButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_6bu41gjq _1xl01w7a",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ffab81445d9a928$var$HeaderContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasFixedWidth: hasFixedWidth, hasIcon: hasIcon, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_t94dt9": (0, $awdRS.default)(`${"var(--ds-space-0, 0px)"} ${__cmplp.hasFixedWidth || __cmplp.hasIcon ? "var(--ds-space-0, 0px)" : "var(--ds-space-300, 24px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1yt41d6p _vchhusvi _1e0c1txw _y3gn1e5h _1v7oze3t _3myyze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ffab81445d9a928$var$HeaderText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidth: maxWidth, hasIcon: hasIcon, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_e2mome": (0, $awdRS.default)(__cmplp.maxWidth - (0, $dPMMf.gridSize) * (__cmplp.hasIcon ? 5 : 2), "px"),
            "--_uyt2xi": (0, $awdRS.default)(__cmplp.maxWidth - (0, $dPMMf.gridSize) * 5, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _4t3i1tcg _o5721q9c _1bto1l2s",
            __cmplp.maxWidth && "_p12f1388",
            __cmplp.maxWidth && "_1i461gch _123n1gch",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ffab81445d9a928$var$PlainHeader = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidth: maxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _syaz1gjq _1e0c1txw _4cvr1h6o _4t3i1tcg _ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc _o5721q9c _1bto1l2s",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ffab81445d9a928$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16q71kw7 _1dhe1kw7",
            __cmplp.isVisible ? "_1e0c1kw7" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jkYbX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c4f87fa6bbdffcdd6698ec12cc5fa12>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e13e9370299759dc$var$_react = $e13e9370299759dc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e13e9370299759dc$var$_statusWarning = $e13e9370299759dc$var$_interopRequireDefault((parcelRequire("d8UFE")));

var $e13e9370299759dc$var$_warning = $e13e9370299759dc$var$_interopRequireDefault((parcelRequire("60rxg")));
function $e13e9370299759dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e13e9370299759dc$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $e13e9370299759dc$var$_react.default.createElement($e13e9370299759dc$var$_statusWarning.default, Object.assign({
        LEGACY_fallbackIcon: $e13e9370299759dc$var$_warning.default
    }, props));
$e13e9370299759dc$var$StatusWarningIcon.Name = 'StatusWarningIconMigration';
var $e13e9370299759dc$var$_default = module.exports.default = $e13e9370299759dc$var$StatusWarningIcon;

});

parcelRegister("40bqY", function(module, exports) {

$parcel$export(module.exports, "default", () => $aad59911d79fb1eb$export$2e2bcd8739ae039);

var $lFXea = parcelRequire("lFXea");
// Map system field ids and custom field types to their configurations: max width, min width, asc text, desc text, etc.
const $aad59911d79fb1eb$var$fieldConfigurationsMap = {
    assignee: {
        ascText: (0, $lFXea.default).aToZOrder,
        descText: (0, $lFXea.default).zToAOrder
    },
    reporterWithIcon: {
        ascText: (0, $lFXea.default).aToZOrder,
        descText: (0, $lFXea.default).zToAOrder
    },
    'com.atlassian.servicedesk:sd-sla-field': {
        ascText: (0, $lFXea.default).shortestToLongestOrder,
        descText: (0, $lFXea.default).longestToShortestOrder
    },
    components: {
        ascText: (0, $lFXea.default).aToZOrder,
        descText: (0, $lFXea.default).zToAOrder
    },
    created: {
        ascText: (0, $lFXea.default).oldestToNewestOrder,
        descText: (0, $lFXea.default).newestToOldestOrder
    },
    issuekey: {
        ascText: (0, $lFXea.default).aToZOrder,
        descText: (0, $lFXea.default).zToAOrder
    },
    issuetype: {
        ascText: (0, $lFXea.default).aToZOrder,
        descText: (0, $lFXea.default).zToAOrder
    },
    reporter: {
        ascText: (0, $lFXea.default).aToZOrder,
        descText: (0, $lFXea.default).zToAOrder
    },
    summary: {
        ascText: (0, $lFXea.default).aToZOrder,
        descText: (0, $lFXea.default).zToAOrder
    },
    updated: {
        ascText: (0, $lFXea.default).oldestToNewestOrder,
        descText: (0, $lFXea.default).newestToOldestOrder
    },
    date: {
        ascText: (0, $lFXea.default).oldestToNewestOrder,
        descText: (0, $lFXea.default).newestToOldestOrder
    }
};
var $aad59911d79fb1eb$export$2e2bcd8739ae039 = $aad59911d79fb1eb$var$fieldConfigurationsMap;

});
parcelRegister("lFXea", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e5a98dfa8ea9ace$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8e5a98dfa8ea9ace$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    aToZOrder: {
        "id": "issue-table.model.fields.field-configurations-map.a-to-z-order",
        "defaultMessage": "A \u2192 Z"
    },
    zToAOrder: {
        "id": "issue-table.model.fields.field-configurations-map.z-to-a-order",
        "defaultMessage": "Z \u2192 A"
    },
    oldestToNewestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.oldest-to-newest-order",
        "defaultMessage": "oldest \u2192 newest"
    },
    newestToOldestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.newest-to-oldest-order",
        "defaultMessage": "newest \u2192 oldest"
    },
    shortestToLongestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.shortest-to-longest-order",
        "defaultMessage": "shortest \u2192 longest"
    },
    longestToShortestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.longest-to-shortest-order",
        "defaultMessage": "longest \u2192 shortest"
    },
    lowestToHighestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.lowest-to-highest-order",
        "defaultMessage": "lowest \u2192 highest"
    },
    highestToLowestOrder: {
        "id": "issue-table.model.fields.field-configurations-map.highest-to-lowest-order",
        "defaultMessage": "highest \u2192 lowest"
    }
});

});


parcelRegister("gRBoi", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdc73b27cf6652a6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cdc73b27cf6652a6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    sortedOrder: {
        "id": "issue-table.common.sort-column-header.sorted-order",
        "defaultMessage": "Sorted {sortOrder} {isDefault, select,\n                true {(Default)}\n                other {}\n            }"
    },
    sortOrder: {
        "id": "issue-table.common.sort-column-header.sort-order",
        "defaultMessage": "Sort {sortOrder}"
    },
    defaultSortedOrder: {
        "id": "issue-table.common.sort-column-header.default-sorted-order",
        "defaultMessage": "Sorted in {isAscending, select,\n                true {ascending}\n                other {descending}\n            } order {isDefault, select,\n                true {(Default)}\n                other {}\n            }"
    },
    defaultSortOrder: {
        "id": "issue-table.common.sort-column-header.default-sort-order",
        "defaultMessage": "Sort in {isAscending, select,\n                true {ascending}\n                other {descending}\n            } order"
    },
    sortingButtonIcon: {
        "id": "issue-table.common.sort-column-header.sorting-icon",
        "defaultMessage": "Sort-By icon"
    },
    a11YSortButtonDescriptionLabel: {
        "id": "issue-table.common.sort-column-header.a-11-y-sort-button-description-label",
        "defaultMessage": "Column sort button"
    },
    epicLinkFieldReplacedByParentField: {
        "id": "issue-table.common.sort-column-header.epic-link-field-replaced-by-parent-field",
        "defaultMessage": "<strong>Epic Link</strong> field is deprecated. Please use the <strong>Parent</strong> field instead."
    },
    parentLinkFieldReplacedByParentField: {
        "id": "issue-table.common.sort-column-header.parent-link-field-replaced-by-parent-field",
        "defaultMessage": "<strong>Parent Link</strong> field is deprecated. Please use the <strong>Parent</strong> field instead."
    }
});

});

parcelRegister("bllBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dbca448b5d46276$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");
const $6dbca448b5d46276$var$SORT_ORDER_CHANGED_TOOLTIP_DELAY = 0;
const $6dbca448b5d46276$var$TOOLTIP_DELAY = 1000;
const $6dbca448b5d46276$var$TOOLTIP_POSITION = 'top';
class $6dbca448b5d46276$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(nextProps, state) {
        if (nextProps.isSortOrderChanged) return {
            // force re-rendering the tooltip component to let the new delay value take into effect
            tooltipComponentKey: state.tooltipComponentKey + 1
        };
        return null;
    }
    render() {
        const { isSortOrderChanged: isSortOrderChanged, tooltipText: tooltipText, children: children } = this.props;
        const delay = isSortOrderChanged ? $6dbca448b5d46276$var$SORT_ORDER_CHANGED_TOOLTIP_DELAY : $6dbca448b5d46276$var$TOOLTIP_DELAY;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            delay: delay,
            position: $6dbca448b5d46276$var$TOOLTIP_POSITION,
            content: tooltipText,
            onShow: this.onShow,
            key: this.state.tooltipComponentKey
        }, children);
    }
    constructor(...args){
        super(...args), this.state = {
            tooltipComponentKey: 0
        }, this.onShow = ()=>{
            this.props.onShow && this.props.onShow();
        };
    }
}

});






parcelRegister("g4mO1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cdba299cf3ab57c$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $fzsdT = parcelRequire("fzsdT");

var $lFQwd = parcelRequire("lFQwd");
var // @ts-expect-error - No overload matches this call
$4cdba299cf3ab57c$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $lFQwd.default), (0, $fzsdT.default));

});
parcelRegister("fzsdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $739c0af51dfe980f$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $khNng = parcelRequire("khNng");
var $739c0af51dfe980f$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $khNng.default));

});
parcelRegister("khNng", function(module, exports) {

$parcel$export(module.exports, "default", () => $218a40177bc664fe$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("1AyD5");
parcelRequire("6cJUr");
parcelRequire("c1D7V");
parcelRequire("llumX");
parcelRequire("d2zWP");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $1dYxZ = parcelRequire("1dYxZ");

var $iN885 = parcelRequire("iN885");

var $9HaBK = parcelRequire("9HaBK");

var $dQRbF = parcelRequire("dQRbF");
let $218a40177bc664fe$var$cachedAssigneeInitializationResponse;
const $218a40177bc664fe$export$6e5dca841bdf93e3 = ()=>{
    $218a40177bc664fe$var$cachedAssigneeInitializationResponse = undefined;
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$218a40177bc664fe$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $iN885.INITIALIZE_COLUMN)).filter((action)=>action.payload.column.fieldType === 'assignee').switchMap(()=>{
        if ((0, $dQRbF.isTableDisabled)(store.getState())) return (0, $7kixv.Observable).empty();
        if ($218a40177bc664fe$var$cachedAssigneeInitializationResponse) return (0, $7kixv.Observable).of((0, $9HaBK.setAssigneeInitializationStateAction)($218a40177bc664fe$var$cachedAssigneeInitializationResponse));
        return (0, $1dYxZ.default)().mergeMap((response)=>{
            $218a40177bc664fe$var$cachedAssigneeInitializationResponse = response;
            return (0, $7kixv.Observable).of((0, $9HaBK.setAssigneeInitializationStateAction)(response));
        }).catch((error)=>{
            (0, $eSnSE.default).safeWarnWithoutCustomerData('issue-table.ops.field.initialize.assignee', `Failed to initialize assignee. Received status code ${error.statusCode}`);
            return (0, $7kixv.Observable).empty();
        });
    });

});
parcelRegister("1dYxZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1999eeba21164000$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");
parcelRequire("9BkTq");
parcelRequire("6cJUr");

var $7KeZy = parcelRequire("7KeZy");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1999eeba21164000$export$2e2bcd8739ae039 = ()=>(0, $7KeZy.getCurrentUser$)().mergeMap((response)=>(0, $7kixv.Observable).of({
            avatarUrl: response.avatarUrls['48x48'],
            displayName: response.displayName,
            emailAddress: response.emailAddress
        }));

});
parcelRegister("7KeZy", function(module, exports) {

$parcel$export(module.exports, "getCurrentUser$", () => $fb02e67731ba75b1$export$87b9ee5a2e330d07);

var $1K8u5 = parcelRequire("1K8u5");
const $fb02e67731ba75b1$export$87b9ee5a2e330d07 = ()=>(0, $1K8u5.default)('/rest/api/3/myself', {
        method: 'GET'
    });

});




parcelRegister("lFQwd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f01592fef5498983$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $5NoSa = parcelRequire("5NoSa");

var $aA5Wf = parcelRequire("aA5Wf");
var $f01592fef5498983$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $aA5Wf.default), (0, $5NoSa.default));

});
parcelRegister("5NoSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0248926a469b1bf$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");
parcelRequire("1AyD5");
parcelRequire("d2zWP");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $4Jmvl = parcelRequire("4Jmvl");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$b0248926a469b1bf$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $4Jmvl.FIELD_UPDATE_FAILURE)).switchMap((action)=>{
        const { fieldType: fieldType, failureReason: failureReason } = action.payload;
        if (failureReason.type === (0, $4Jmvl.ERROR_RESPONSE)) {
            const { statusCode: statusCode } = failureReason;
            (0, $gYnSx.default)({
                meta: {
                    id: 'opsFieldUpdate',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                },
                attributes: {
                    message: 'Error response from server attempting to update field value',
                    statusCode: statusCode,
                    fieldType: fieldType
                }
            });
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-table.ops.field.update', `[FD-3358] Error response from server attempting to update field value. statusCode: [${statusCode}], fieldType: [${fieldType}]`);
        } else {
            (0, $gYnSx.default)({
                meta: {
                    id: 'opsFieldUpdate',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                },
                attributes: {
                    message: 'Unknown error attempting to update field value.',
                    fieldType: fieldType
                }
            });
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-table.ops.field.update', `[FD-3358] Unknown error attempting to update field value. fieldType: [${fieldType}]`);
        }
        return (0, $7kixv.Observable).empty();
    });

});

parcelRegister("aA5Wf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3ab1be81318e14c$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("6cJUr");
parcelRequire("c1D7V");
parcelRequire("d2zWP");

var $7kixv = parcelRequire("7kixv");

var $ia7qg = parcelRequire("ia7qg");

var $4Jmvl = parcelRequire("4Jmvl");

var $blTcR = parcelRequire("blTcR");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$c3ab1be81318e14c$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $4Jmvl.FIELD_UPDATE_SUBMIT)).switchMap((action)=>{
        const state = store.getState();
        const { issueKey: issueKey, fieldId: fieldId, fieldValue: fieldValue, onSuccess: onSuccess, onFailure: onFailure } = action.payload;
        return (0, $ia7qg.updateFieldValue$)(issueKey, fieldId, fieldValue).mergeMap(()=>{
            onSuccess(fieldValue);
            return (0, $7kixv.Observable).of((0, $4Jmvl.updateFieldSuccessAction)(issueKey, fieldId));
        }).catch((error)=>{
            onFailure();
            return (0, $7kixv.Observable).of((0, $4Jmvl.updateFieldFailureErrorResponseAction)(issueKey, fieldId, fieldValue.fieldType, (0, $blTcR.getColumnTitle)(state, fieldId), error));
        });
    });

});



parcelRegister("jsNbv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c713610819ec556$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $7zhyI = parcelRequire("7zhyI");
var $5c713610819ec556$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $7zhyI.default));

});
parcelRegister("7zhyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec7283454a74430e$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("d2zWP");

var $7kixv = parcelRequire("7kixv");

var $gCeeo = parcelRequire("gCeeo");

var $cLGK3 = parcelRequire("cLGK3");

var $coQbr = parcelRequire("coQbr");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$ec7283454a74430e$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $cLGK3.ISSUE_EDIT_STARTED)).switchMap((action)=>{
        const { fieldType: fieldType, issueKey: issueKey } = action.payload;
        const { analyticsEvent: analyticsEvent } = action.meta;
        const state = store.getState();
        (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'tableRow locked', {
            fieldType: fieldType,
            lockedIssuesCount: (0, $coQbr.getLockedIssueCountAssumingIssueKeyWillBeLocked)(state, issueKey)
        });
        return (0, $7kixv.Observable).empty();
    });

});


parcelRegister("ipfNb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6d51d69c9b9cf90$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $edqmJ = parcelRequire("edqmJ");
var $e6d51d69c9b9cf90$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $edqmJ.default));

});
parcelRegister("edqmJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c1628db2e456589$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("d2zWP");

var $7kixv = parcelRequire("7kixv");


var $gY8BA = parcelRequire("gY8BA");

var $cN0WI = parcelRequire("cN0WI");

var $dQRbF = parcelRequire("dQRbF");
const $7c1628db2e456589$export$3869e16e736a9111 = (prevShowPagination, offsetFromBottom, totalPages)=>{
    if (totalPages > 1) return(// If pagination is already shown but the table has not been scrolled back up enough
    prevShowPagination && offsetFromBottom < (0, $b354b11309751a31$export$ad4eb70d85e8e21f) || // Or, if no pagination is shown and table has been scrolled to the bottom
    !prevShowPagination && offsetFromBottom === 0);
    return false;
};
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$7c1628db2e456589$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $gY8BA.UPDATE_VERTICAL_OFFSET)).switchMap((action)=>{
        const { totalPages: totalPages, verticalPosition: verticalPosition, onVerticalScrollOffsetChanged: onVerticalScrollOffsetChanged } = action.payload;
        const showPagination = (0, $dQRbF.shouldShowPagination)(store.getState());
        const { offsetFromTop: offsetFromTop, offsetFromBottom: offsetFromBottom } = verticalPosition;
        const nextShowPagination = $7c1628db2e456589$export$3869e16e736a9111(showPagination, offsetFromBottom, totalPages);
        onVerticalScrollOffsetChanged && onVerticalScrollOffsetChanged(verticalPosition);
        // @ts-expect-error - TS2304 - Cannot find name 'SetVerticalOffsetAction'. | TS2304 - Cannot find name 'SetPaginationVisibilityAction'.
        const actions = [];
        if (nextShowPagination !== showPagination) actions.push((0, $cN0WI.setPaginationVisibility)(nextShowPagination));
        actions.push((0, $gY8BA.setVerticalOffsetAction)(offsetFromTop));
        return (0, $7kixv.Observable).of(...actions);
    });

});



parcelRegister("4E6uF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7de1af14934ffe$export$2e2bcd8739ae039);

var $gY8BA = parcelRequire("gY8BA");

var $blTcR = parcelRequire("blTcR");

var $2f0m6 = parcelRequire("2f0m6");

var $ezcSZ = parcelRequire("ezcSZ");

var $dQRbF = parcelRequire("dQRbF");

var $8toaC = parcelRequire("8toaC");

var $d1K1y = parcelRequire("d1K1y");

var $4ENF0 = parcelRequire("4ENF0");

var $cgPFO = parcelRequire("cgPFO");
const $7b7de1af14934ffe$var$mapStateToProps = (state)=>({
        Table: $4ENF0.default,
        columns: (0, $blTcR.getColumns)(state),
        Pagination: $d1K1y.default,
        showPagination: (0, $dQRbF.shouldShowPagination)(state),
        editingFieldHorizontalOffset: (0, $dQRbF.getEditingFieldHorizontalOffset)(state),
        editingFieldVerticalOffset: (0, $dQRbF.getEditingFieldVerticalOffset)(state),
        editingFieldWidth: (0, $dQRbF.getEditingFieldWidth)(state),
        horizontalScrollOffset: (0, $ezcSZ.getHorizontalScrollOffset)(state),
        verticalScrollOffset: (0, $ezcSZ.getVerticalScrollOffset)(state),
        tableWidth: (0, $dQRbF.getTableWidth)(state),
        tableHeight: (0, $dQRbF.getTableHeight)(state),
        loadedIssueKeys: (0, $2f0m6.mergeIssueKeysWithLockedIssues)(state)
    });
const $7b7de1af14934ffe$var$mapDispatchToProps = {
    onUpdateHorizontalScrollOffset: (offset)=>(0, $gY8BA.setHorizontalOffsetAction)(offset.offsetFromLeft),
    onUpdateVerticalScrollOffset: (0, $gY8BA.updateVerticalOffsetAction)
};
// @ts-expect-error - TS2322 - Type 'ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }' is not assignable to type 'ComponentType<PropsWithDefaults>'. | TS2554 - Expected 3-4 arguments, but got 2.
const $7b7de1af14934ffe$var$ConnectedIssueTable = (0, $8toaC.connect)($7b7de1af14934ffe$var$mapStateToProps, $7b7de1af14934ffe$var$mapDispatchToProps)((0, $cgPFO.default));
var $7b7de1af14934ffe$export$2e2bcd8739ae039 = $7b7de1af14934ffe$var$ConnectedIssueTable;

});
parcelRegister("ezcSZ", function(module, exports) {

$parcel$export(module.exports, "getHorizontalScrollOffset", () => $1bb700de50af8a48$export$624a30c8322e672b);
$parcel$export(module.exports, "getVerticalScrollOffset", () => $1bb700de50af8a48$export$76e51b2d87e066ab);

var $lhJwW = parcelRequire("lhJwW");
const $1bb700de50af8a48$export$6db1911eee044119 = (state)=>(0, $lhJwW.getPersisted)(state).offsets;
const $1bb700de50af8a48$export$624a30c8322e672b = (state)=>$1bb700de50af8a48$export$6db1911eee044119(state).horizontalScrollOffset;
const $1bb700de50af8a48$export$76e51b2d87e066ab = (state)=>$1bb700de50af8a48$export$6db1911eee044119(state).verticalScrollOffset;

});

parcelRegister("d1K1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f8183fa00104851$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $1WDSo = parcelRequire("1WDSo");

var $blVe0 = parcelRequire("blVe0");
var $0f8183fa00104851$export$2e2bcd8739ae039 = (0, $gnQAk.connect)(()=>({
        Pagination: (0, $1WDSo.default)
    }), {})((0, $blVe0.default));

});
parcelRegister("1WDSo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d813dc49ad620f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

const $f7d813dc49ad620f$var$LazyPagination = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("iOZNW")), {
    moduleId: "../platform/packages/design-system/pagination/src/index.tsx"
});
const $f7d813dc49ad620f$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "async-issue-table-pagination",
        packageName: "issueTable",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-issue-table-pagination",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f7d813dc49ad620f$var$LoadingComponent, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f7d813dc49ad620f$var$LazyPagination, props)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f7d813dc49ad620f$var$LoadingComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3izwfg _1bsb19bv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iOZNW", function(module, exports) {

let $db3cd694ae58a126$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $db3cd694ae58a126$var$load("hZ76U").then(()=>parcelRequire('1IZy7'));

});


parcelRegister("blVe0", function(module, exports) {

$parcel$export(module.exports, "default", () => $af18597860817051$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $tGEEK = parcelRequire("tGEEK");

var $idGBm = parcelRequire("idGBm");

var $bg58v = parcelRequire("bg58v");
function $af18597860817051$var$PaginationComponent(props) {
    const { currentPage: currentPage, totalPages: totalPages, Pagination: Pagination, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($af18597860817051$export$b14e02386c6038ac, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($af18597860817051$export$8c3f8ac08a926abc, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Pagination, {
        selectedIndex: currentPage - 1,
        onChange: props.onPageChange,
        i18n: {
            prev: formatMessage((0, $bg58v.default).previousButton),
            next: formatMessage((0, $bg58v.default).nextButton)
        },
        pages: (0, (/*@__PURE__*/$parcel$interopDefault($tGEEK)))(1, totalPages + 1)
    })));
}
var $af18597860817051$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = (0, $idGBm.injectIntlV2)($af18597860817051$var$PaginationComponent);
const $af18597860817051$export$b14e02386c6038ac = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _2hwx1ejb",
            __cmplp.className
        ])
    });
});
const $af18597860817051$export$8c3f8ac08a926abc = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _n3tdu2gc _ca0qu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bg58v", function(module, exports) {

$parcel$export(module.exports, "default", () => $85cc4f16f02bf7e2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $85cc4f16f02bf7e2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    previousButton: {
        "id": "issue-table.pagination.previous-button",
        "defaultMessage": "Prev"
    },
    nextButton: {
        "id": "issue-table.pagination.next-button",
        "defaultMessage": "Next"
    }
});

});



parcelRegister("4ENF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ab49e61501bd52e$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");

var $2f0m6 = parcelRequire("2f0m6");

var $iTt3s = parcelRequire("iTt3s");

var $dQRbF = parcelRequire("dQRbF");

var $8toaC = parcelRequire("8toaC");

var $lgqgi = parcelRequire("lgqgi");
const $0ab49e61501bd52e$var$mapStateToProps = (state)=>({
        issueKeys: (0, $2f0m6.mergeIssueKeysWithLockedIssues)(state),
        transformProps: $iTt3s.transformProps,
        renderSidebarIcon: (0, $dQRbF.getRenderSidebarIcon)(state),
        refreshSidebar: (0, $dQRbF.getRefreshSidebar)(state),
        ...(0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') ? {
            persistedStoreColumns: state.persisted.columns
        } : {}
    });
// @ts-expect-error - TS2322 - Type 'ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }' is not assignable to type 'ComponentType<Props>'. | TS2554 - Expected 3-4 arguments, but got 1. | TS2345 - Argument of type 'typeof Table' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
const $0ab49e61501bd52e$var$ConnectedIssueTable = (0, $8toaC.connect)($0ab49e61501bd52e$var$mapStateToProps)((0, $lgqgi.default));
var $0ab49e61501bd52e$export$2e2bcd8739ae039 = $0ab49e61501bd52e$var$ConnectedIssueTable;

});
parcelRegister("iTt3s", function(module, exports) {

$parcel$export(module.exports, "transformProps", () => $b39d03889a272216$export$7b42a0094fb00b6e);



var $cSj0h = parcelRequire("cSj0h");

var $eJGF3 = parcelRequire("eJGF3");

var $uOwT4 = parcelRequire("uOwT4");
const $b39d03889a272216$var$transformScrollCallback = (0, $uOwT4.default)();
const $b39d03889a272216$export$7b42a0094fb00b6e = (props, createCell)=>{
    const { issueKeys: issueKeys, columns: columns, isContentStale: isContentStale, shouldSkipVirtualization: shouldSkipVirtualization, shouldHideLoadingIndicator: shouldHideLoadingIndicator, shouldRerenderRowOnHover: shouldRerenderRowOnHover, totalPages: totalPages, FieldDataSelector: FieldDataSelector, onActiveItemChanged: onActiveItemChanged, onActiveRowIdChanged: onActiveRowIdChanged, onDisplayedRowsChanged: onDisplayedRowsChanged, onTableFocusFunctionChanged: onTableFocusFunctionChanged, onTableRefChanged: onTableRefChanged, onUpdateHorizontalScrollOffset: onUpdateHorizontalScrollOffset, selectedIssueKeys: selectedIssueKeys = [], contentKey: contentKey, ariaLabel: ariaLabel, ssrTableSize: ssrTableSize, disableRowHighlight: disableRowHighlight = false, renderSidebarIcon: renderSidebarIcon, appProps: appProps, shouldUseCssForRendering: shouldUseCssForRendering } = props;
    const { rowIds: rowIds, rowsConfiguration: rowsConfiguration } = (0, $eJGF3.default)(issueKeys, selectedIssueKeys);
    return {
        isContentStale: isContentStale,
        shouldSkipVirtualization: shouldSkipVirtualization,
        shouldHideLoadingIndicator: shouldHideLoadingIndicator,
        shouldRerenderRowOnHover: shouldRerenderRowOnHover,
        rowIds: rowIds,
        rowsConfiguration: rowsConfiguration,
        columns: (0, $cSj0h.default)(FieldDataSelector, columns, createCell),
        navigationMode: (0, $1d080e9e60c37b43$export$a01cd8e028b3d34f),
        expandedColumnIds: [],
        columnWidths: {},
        hiddenColumnIds: [],
        defaultRowHeight: (0, $b354b11309751a31$export$258441c8a79bb589),
        autoRowHeight: (0, $b354b11309751a31$export$80fc56c6cdbfffed),
        draggableRows: (0, $b354b11309751a31$export$6fd8e343a23be522),
        showDecalAtBottom: totalPages > 1,
        NonTemporaryCellWrapper: undefined,
        onActiveItemChanged: onActiveItemChanged,
        onActiveRowIdChanged: onActiveRowIdChanged,
        onDisplayedRowsChanged: onDisplayedRowsChanged,
        onVerticalScrollOffsetChanged: $b39d03889a272216$var$transformScrollCallback(props),
        onHorizontalScrollOffsetChanged: onUpdateHorizontalScrollOffset,
        onRowListFocusFunctionChanged: onTableFocusFunctionChanged,
        onReactPortalContainerRefChanged: onTableRefChanged,
        contentKey: contentKey,
        ariaLabel: ariaLabel,
        ssrTableSize: ssrTableSize,
        disableRowHighlight: disableRowHighlight,
        renderSidebarIcon: renderSidebarIcon,
        premiumSLAColumnIds: appProps.premiumSLAColumns,
        shouldUseCssForRendering: shouldUseCssForRendering
    };
};

});
const $1d080e9e60c37b43$export$9e9986b7abe95577 = 'cellNavigation';
const $1d080e9e60c37b43$export$a01cd8e028b3d34f = 'rowNavigation';
const $1d080e9e60c37b43$export$8ea4ff4da61b68e4 = 'noNavigation';
const $1d080e9e60c37b43$export$8a257aa81ef4a9e0 = 'activeRow';
const $1d080e9e60c37b43$export$4b3489234fd17200 = 'activeCell';

parcelRegister("eJGF3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e127322df7960687$export$2e2bcd8739ae039);

var $bPWfC = parcelRequire("bPWfC");

var $LFmXM = parcelRequire("LFmXM");
const $e127322df7960687$var$LOADING_ROW_CONFIGURATION = {
    isLoading: true
};
var $e127322df7960687$export$2e2bcd8739ae039 = (0, $LFmXM.default)((issueKeys, selectedIssueKeys)=>{
    const rowIds = [];
    const rowsConfiguration = {};
    for(let i = 0; i < issueKeys.length; i += 1){
        const issueKey = issueKeys[i];
        if (issueKey == null) {
            rowIds[i] = i.toString();
            rowsConfiguration[i.toString()] = $e127322df7960687$var$LOADING_ROW_CONFIGURATION;
        } else {
            rowIds[i] = issueKey;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($bPWfC)))(selectedIssueKeys, issueKey)) rowsConfiguration[issueKey] = {
                isSelected: true
            };
        }
    }
    return {
        rowIds: rowIds,
        rowsConfiguration: rowsConfiguration
    };
});

});

parcelRegister("uOwT4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6627227b2542a06a$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");

const $6627227b2542a06a$var$DIRECTION_UP = 'UP';
const $6627227b2542a06a$var$DIRECTION_DOWN = 'DOWN';
// The number of issue keys that would be fetched on scroll
const $6627227b2542a06a$var$FETCH_BATCH_SIZE = 100;
// The number of issue keys to overfetch on the last batch
// This ensures the issues up to the end of the current page are always fetched regardless of the scroll based fetch requirements
const $6627227b2542a06a$var$LEGACY_OVERFETCH_SIZE = 3;
const $6627227b2542a06a$var$OVERFETCH_SIZE = 30;
// Fetch issues only if the index changed (after scrolling) by 25% of buffer in store
const $6627227b2542a06a$var$ISSUE_FETCH_SCROLL_THRESHOLD = 0.25;
// load more issues in the direction of scroll
const $6627227b2542a06a$var$FETCH_BATCH_DIRECTIONAL_BIAS = 0.8;
// min rows scrolled before a fetch is requested
const $6627227b2542a06a$var$MIN_SCROLL_BOUNDARY_DELTA = 3;
// validation functions
const $6627227b2542a06a$var$isFirstBatch = (prevPageIssueCount, startIndex)=>startIndex === prevPageIssueCount;
const $6627227b2542a06a$var$isLastBatch = (issueKeyCount, startIndex)=>{
    const overfetchSize = (0, $7jTnu.fg)('jsm-corcap-3691-reduce-queues-table-scroll-depth') ? $6627227b2542a06a$var$OVERFETCH_SIZE : $6627227b2542a06a$var$LEGACY_OVERFETCH_SIZE;
    return startIndex === issueKeyCount - $6627227b2542a06a$var$FETCH_BATCH_SIZE + overfetchSize;
};
const $6627227b2542a06a$var$hasScrolledPastThreshold = (issueCountForThresholdCheck, scrollDelta)=>Math.abs(scrollDelta) > issueCountForThresholdCheck * $6627227b2542a06a$var$ISSUE_FETCH_SCROLL_THRESHOLD;
const $6627227b2542a06a$export$acc3c238efb0cb80 = (issueKeyCount, prevPageIssueCount, isLastPage, displayStart, displayEnd, isScrollingUp)=>{
    // Find out how many issues are rendered and how many more are needed for a batch of 100 issues.
    const extraIssuesToBeFetched = $6627227b2542a06a$var$FETCH_BATCH_SIZE - (displayEnd - displayStart);
    // count of issues in either direction based on scroll direction
    const extraIssuesInScrollDirection = Math.floor(extraIssuesToBeFetched * $6627227b2542a06a$var$FETCH_BATCH_DIRECTIONAL_BIAS);
    const extraIssuesOppositeScrollDirection = extraIssuesToBeFetched - extraIssuesInScrollDirection;
    const extraIssuesAtTopOfTable = isScrollingUp ? extraIssuesInScrollDirection : extraIssuesOppositeScrollDirection;
    const overfetchSize = (0, $7jTnu.fg)('jsm-corcap-3691-reduce-queues-table-scroll-depth') ? $6627227b2542a06a$var$OVERFETCH_SIZE : $6627227b2542a06a$var$LEGACY_OVERFETCH_SIZE;
    return {
        startIndex: Math.min(Math.max(displayStart + prevPageIssueCount - extraIssuesAtTopOfTable, prevPageIssueCount), prevPageIssueCount + issueKeyCount - $6627227b2542a06a$var$FETCH_BATCH_SIZE + (isLastPage ? overfetchSize : 0)),
        extraIssuesInScrollDirection: extraIssuesInScrollDirection,
        extraIssuesOppositeScrollDirection: extraIssuesOppositeScrollDirection
    };
};
const $6627227b2542a06a$export$2ad5771a0a9b303a = (issueKeyCount, issueCountForThresholdCheck, prevPageIssueCount, startIndex, prevStartIndex, scrollDelta)=>{
    // fetch only if the index changes by 25% of the buffer in store in the direction of scroll
    // or if it's the first or the last batch for that page
    if (scrollDelta && startIndex !== prevStartIndex && ($6627227b2542a06a$var$hasScrolledPastThreshold(issueCountForThresholdCheck, scrollDelta) || $6627227b2542a06a$var$isLastBatch(issueKeyCount, startIndex) || $6627227b2542a06a$var$isFirstBatch(prevPageIssueCount, startIndex))) return true;
    return false;
};
var // We are executing multiple IssueTable callbacks which are all tied to vertical scroll offset changes in VirtualTable
// eslint-disable-next-line jira/import/no-anonymous-default-export
$6627227b2542a06a$export$2e2bcd8739ae039 = ()=>{
    // to keep a track of dispay boundary, used in identifying the scroll direction and offset
    let prevVisibleStart = 0;
    // to keep a track of prev indices, to not do anything if index didn't change
    let prevStartIndex;
    // to keep a track of any changes in scroll direction
    let prevScrollDirection = $6627227b2542a06a$var$DIRECTION_DOWN;
    return (props)=>(verticalPosition)=>{
            const { onUpdateVerticalScrollOffset: onUpdateVerticalScrollOffset, onVerticalScrollOffsetChanged: onVerticalScrollOffsetChanged, onIssueDataRequested: onIssueDataRequested, issueKeys: issueKeys, currentPage: currentPage, totalPages: totalPages } = props;
            const { displayStart: displayStart, displayEnd: displayEnd, visibleStart: visibleStart, offsetFromTop: offsetFromTop, offsetFromBottom: offsetFromBottom } = verticalPosition;
            const issueKeyCount = issueKeys.length;
            const topAndBottomOffset = {
                offsetFromTop: offsetFromTop,
                offsetFromBottom: offsetFromBottom
            };
            onUpdateVerticalScrollOffset(totalPages, topAndBottomOffset, onVerticalScrollOffsetChanged);
            const scrollDelta = visibleStart - prevVisibleStart;
            // if all issues are already rendered, or no change in display boundaries, no need to fetch any more
            if (issueKeyCount < $6627227b2542a06a$var$FETCH_BATCH_SIZE || Math.abs(scrollDelta) < $6627227b2542a06a$var$MIN_SCROLL_BOUNDARY_DELTA) return;
            const scrollDirection = visibleStart > prevVisibleStart ? $6627227b2542a06a$var$DIRECTION_DOWN : $6627227b2542a06a$var$DIRECTION_UP;
            // take pagination into account
            const prevPageIssueCount = (currentPage - 1) * (0, $b354b11309751a31$export$f88f58d1a4b2078b);
            const isLastPage = currentPage === totalPages;
            const { startIndex: startIndex, extraIssuesInScrollDirection: extraIssuesInScrollDirection, extraIssuesOppositeScrollDirection: extraIssuesOppositeScrollDirection } = $6627227b2542a06a$export$acc3c238efb0cb80(issueKeyCount, prevPageIssueCount, isLastPage, displayStart, displayEnd, scrollDirection === $6627227b2542a06a$var$DIRECTION_UP);
            // if the scroll direction was changed, the threshold must be smaller because there are less issues loaded in that direction
            const issueCountForThresholdCheck = scrollDirection === prevScrollDirection ? extraIssuesInScrollDirection : extraIssuesOppositeScrollDirection;
            // @ts-expect-error - TS2322 - Type '"UP" | "DOWN"' is not assignable to type '"DOWN"'.
            prevScrollDirection = scrollDirection;
            const shouldFetchData = $6627227b2542a06a$export$2ad5771a0a9b303a(issueKeyCount, issueCountForThresholdCheck, prevPageIssueCount, startIndex, prevStartIndex, scrollDelta);
            onIssueDataRequested && shouldFetchData && onIssueDataRequested(startIndex);
            // unless the scroll is not enough to enforce a new fetch, do not update the previous values
            if (shouldFetchData) {
                prevStartIndex = startIndex;
                prevVisibleStart = visibleStart;
            }
        };
};

});


parcelRegister("lgqgi", function(module, exports) {

$parcel$export(module.exports, "default", () => $acaed5b298188686$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $fHkSO = parcelRequire("fHkSO");

var $7jTnu = parcelRequire("7jTnu");

var $3Q3rN = parcelRequire("3Q3rN");

class $acaed5b298188686$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props);
        this.createCell = (0, $3Q3rN.createCellsCache)();
    }
    render() {
        const { issueKeys: issueKeys } = this.props;
        const { transformProps: transformProps, tableRef: tableRef, ...otherProps } = this.props;
        if (issueKeys && issueKeys.length > (0, $b354b11309751a31$export$f88f58d1a4b2078b)) (0, $eSnSE.default).safeWarnWithoutCustomerData('issue-table', `[FD-4474] Maximum number of issues allowed by IssueTable on a page is ${(0, $b354b11309751a31$export$f88f58d1a4b2078b)}`);
        const tableProps = transformProps(otherProps, this.createCell);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fHkSO.default), {
            ...tableProps,
            ...(0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') ? {
                persistedStoreColumns: this.props.persistedStoreColumns
            } : {},
            ref: tableRef
        });
    }
}

});
parcelRegister("fHkSO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8b95d12631fbea5$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $12DRg = parcelRequire("12DRg");

var $7jTnu = parcelRequire("7jTnu");

var $aIrSA = parcelRequire("aIrSA");


var $4d9Fy = parcelRequire("4d9Fy");

var $3Smvh = parcelRequire("3Smvh");

var $3z7Cz = parcelRequire("3z7Cz");

var $kMKvn = parcelRequire("kMKvn");

var $9lqzG = parcelRequire("9lqzG");

var $9vAxP = parcelRequire("9vAxP");

var $TV84k = parcelRequire("TV84k");

var $i1eKe = parcelRequire("i1eKe");

var $61sqG = parcelRequire("61sqG");

var $gm7EY = parcelRequire("gm7EY");

var $aiVOt = parcelRequire("aiVOt");
class $e8b95d12631fbea5$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            NonTemporaryCellWrapper: undefined,
            navigationMode: (0, $1d080e9e60c37b43$export$9e9986b7abe95577),
            rowIds: [],
            rowsConfiguration: {},
            defaultRowHeight: Math.max((0, $61sqG.default).row.height, (0, $61sqG.default).row.minHeight),
            autoRowHeight: false,
            draggableRows: false,
            columns: [],
            expandedColumnIds: [],
            columnWidths: {},
            hiddenColumnIds: [],
            onActiveItemChanged: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onRowListFocusFunctionChanged: undefined,
            contentKey: undefined,
            ariaLabel: undefined
        };
    }
    static getInitialStoreState(props) {
        if (props.shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table')) return {
            internal: {
                ...(0, $9vAxP.initialState),
                shouldUseCssForRendering: true,
                tableSize: {
                    width: 0,
                    // in case of SSR arbitrary number to allow some rows to be rendered, ideally bigger than any screen you can think of
                    // otherwise we will read it from the ref of the wrapper
                    height: false ? 10000 : 0,
                    // if we don't set it, some editable fields inside cells (e.g. assignee) don't render, and cause errors
                    widthWithoutScrollbarOffset: 0,
                    rowMargin: 0
                }
            }
        };
        return false && props.ssrTableSize ? {
            internal: {
                ...(0, $9vAxP.initialState),
                tableSize: props.ssrTableSize
            }
        } : undefined;
    }
    constructor(props){
        super(props);
        const initialStoreState = $e8b95d12631fbea5$export$2e2bcd8739ae039.getInitialStoreState(props);
        this.store = (0, $gm7EY.default)(initialStoreState);
        const consumerState = (0, $aiVOt.default)(props);
        this.store.dispatch((0, $4d9Fy.setStateFromProps)(consumerState, (0, $61sqG.default)));
        if (props.renderSidebarIcon) this.store.dispatch((0, $9lqzG.setRenderSidebarIcon)(props.renderSidebarIcon));
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(this.props, nextProps)) {
            const consumerState = (0, $aiVOt.default)(nextProps);
            this.store.dispatch((0, $3Smvh.updateStateFromProps)(consumerState));
            if (nextProps.renderSidebarIcon) this.store.dispatch((0, $9lqzG.setRenderSidebarIcon)(nextProps.renderSidebarIcon));
        }
    }
    scrollToRow(rowId) {
        this.store.dispatch((0, $kMKvn.scrollToRow)(rowId));
    }
    resetVerticalScrollOffset() {
        this.store.dispatch((0, $3z7Cz.setVertical)(0));
    }
    render() {
        const { defaultRowHeight: defaultRowHeight, autoRowHeight: autoRowHeight, customScrollBarOffset: customScrollBarOffset } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIrSA.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i1eKe.ThemeProvider), {
            defaultRowHeight: defaultRowHeight,
            autoRowHeight: autoRowHeight,
            customScrollBarOffset: customScrollBarOffset
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $TV84k.default), null)));
    }
}

});
parcelRegister("aIrSA", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $bc2eafd7322724c9$export$2881499e37b75b9a);
$parcel$export(module.exports, "connect", () => $bc2eafd7322724c9$export$64605811ab45167f);

var $eJOHy = parcelRequire("eJOHy");

var $gnQAk = parcelRequire("gnQAk");
const $bc2eafd7322724c9$var$STORE_KEY = 'tableStore';
const $bc2eafd7322724c9$export$93e4b0b2cc49b648 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $bc2eafd7322724c9$export$2881499e37b75b9a = (0, $gnQAk.createProvider)($bc2eafd7322724c9$export$93e4b0b2cc49b648);
const $bc2eafd7322724c9$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = {})=>(0, $gnQAk.connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
        ...options,
        context: $bc2eafd7322724c9$export$93e4b0b2cc49b648,
        storeKey: $bc2eafd7322724c9$var$STORE_KEY
    });

});

parcelRegister("4d9Fy", function(module, exports) {

$parcel$export(module.exports, "SET_STATE_FROM_PROPS", () => $371d4253259f9d83$export$fa83d46c9d6439df);
$parcel$export(module.exports, "setStateFromProps", () => $371d4253259f9d83$export$ecd61896fb1d9dfc);
const $371d4253259f9d83$export$fa83d46c9d6439df = 'ops.hydrate.set.SET_STATE_FROM_PROPS';
const $371d4253259f9d83$export$ecd61896fb1d9dfc = (apiState, theme)=>({
        type: $371d4253259f9d83$export$fa83d46c9d6439df,
        payload: {
            apiState: apiState,
            theme: theme
        }
    });

});

parcelRegister("3Smvh", function(module, exports) {

$parcel$export(module.exports, "UPDATE_STATE_FROM_PROPS", () => $f753c86d3007d44c$export$9915f5b7a701b9dc);
$parcel$export(module.exports, "updateStateFromProps", () => $f753c86d3007d44c$export$129cd88740c3c561);
const $f753c86d3007d44c$export$9915f5b7a701b9dc = 'ops.hydrate.update.UPDATE_STATE_FROM_PROPS';
const $f753c86d3007d44c$export$129cd88740c3c561 = (payload)=>({
        type: $f753c86d3007d44c$export$9915f5b7a701b9dc,
        payload: payload
    });

});

parcelRegister("3z7Cz", function(module, exports) {

$parcel$export(module.exports, "SET_SCROLL_OFFSET", () => $bfd12469c173943b$export$b62cd193236337c8);
$parcel$export(module.exports, "setVertical", () => $bfd12469c173943b$export$f34530221b3f1c79);
$parcel$export(module.exports, "setHorizontal", () => $bfd12469c173943b$export$dd2992a7040a040);
const $bfd12469c173943b$export$226d1a200557982a = 'VERTICAL';
const $bfd12469c173943b$export$608a8b0c7bb8a183 = 'HORIZONTAL';
const $bfd12469c173943b$export$b62cd193236337c8 = 'ops.scrolling.offset.SET_SCROLL_OFFSET';
const $bfd12469c173943b$export$adaa4cf7ef1b65be = (payload)=>({
        type: $bfd12469c173943b$export$b62cd193236337c8,
        payload: payload
    });
const $bfd12469c173943b$export$f34530221b3f1c79 = (offset)=>({
        type: $bfd12469c173943b$export$b62cd193236337c8,
        payload: {
            offset: offset,
            direction: $bfd12469c173943b$export$226d1a200557982a
        }
    });
const $bfd12469c173943b$export$dd2992a7040a040 = (offset)=>({
        type: $bfd12469c173943b$export$b62cd193236337c8,
        payload: {
            offset: offset,
            direction: $bfd12469c173943b$export$608a8b0c7bb8a183
        }
    });

});

parcelRegister("kMKvn", function(module, exports) {

$parcel$export(module.exports, "SCROLL_TO_ROW", () => $b7fd9d2ecf13f14c$export$ac622773190ce65e);
$parcel$export(module.exports, "scrollToRow", () => $b7fd9d2ecf13f14c$export$71590875881b540);
const $b7fd9d2ecf13f14c$export$ac622773190ce65e = 'ops.scrolling.to-row.SCROLL_TO_ROW';
const $b7fd9d2ecf13f14c$export$71590875881b540 = (payload)=>({
        type: $b7fd9d2ecf13f14c$export$ac622773190ce65e,
        payload: payload
    });

});

parcelRegister("9lqzG", function(module, exports) {

$parcel$export(module.exports, "SET_VERTICAL_SCROLL_OFFSET", () => $e6daffef1b272f85$export$80ba52f206861eb4);
$parcel$export(module.exports, "setVerticalScrollOffset", () => $e6daffef1b272f85$export$326ff279ca4dfb77);
$parcel$export(module.exports, "SET_VERTICAL_SCROLL_DELTA", () => $e6daffef1b272f85$export$653d24855aaede15);
$parcel$export(module.exports, "setVerticalScrollDelta", () => $e6daffef1b272f85$export$1331c3f83dd180bd);
$parcel$export(module.exports, "SET_HORIZONTAL_SCROLL_OFFSET", () => $e6daffef1b272f85$export$e1dd7001449ed5e8);
$parcel$export(module.exports, "setHorizontalScrollOffset", () => $e6daffef1b272f85$export$22fd5ac5ac6862d2);
$parcel$export(module.exports, "SET_TABLE_SIZE", () => $e6daffef1b272f85$export$7988e33354cc36c5);
$parcel$export(module.exports, "setTableSize", () => $e6daffef1b272f85$export$ef8b504c11e86ef2);
$parcel$export(module.exports, "SET_ACTIVE_ITEM", () => $e6daffef1b272f85$export$ff7b028545454800);
$parcel$export(module.exports, "setActiveItem", () => $e6daffef1b272f85$export$375743a38c44f220);
$parcel$export(module.exports, "CLEAR_ACTIVE_ITEM", () => $e6daffef1b272f85$export$d63ae865b2dc3e7f);
$parcel$export(module.exports, "clearActiveItem", () => $e6daffef1b272f85$export$f8e43f3f64585431);
$parcel$export(module.exports, "SET_RESIZING_COLUMN", () => $e6daffef1b272f85$export$9b07079645db68ce);
$parcel$export(module.exports, "setResizingColumn", () => $e6daffef1b272f85$export$ecabdd68bb804ada);
$parcel$export(module.exports, "SET_COLUMN_SORT_ORDER", () => $e6daffef1b272f85$export$d353d2412612deea);
$parcel$export(module.exports, "setColumnSortOrder", () => $e6daffef1b272f85$export$53f60a18200636);
$parcel$export(module.exports, "SET_SORT_ORDER_WITH_OVERRIDE", () => $e6daffef1b272f85$export$bd2944db1d7878d7);
$parcel$export(module.exports, "setSortOrderWithOverride", () => $e6daffef1b272f85$export$21099b8525c19e6b);
$parcel$export(module.exports, "SET_MULTI_ADD_ANCHOR", () => $e6daffef1b272f85$export$45d5c36be62dcf8e);
$parcel$export(module.exports, "setMultiAddAnchor", () => $e6daffef1b272f85$export$ccc97b11ed34fa9c);
$parcel$export(module.exports, "CLEAR_MULTI_ADD_ANCHOR", () => $e6daffef1b272f85$export$28f3def567195a3c);
$parcel$export(module.exports, "clearMultiAddAnchor", () => $e6daffef1b272f85$export$fba9cdc0d3369b8b);
$parcel$export(module.exports, "SET_SORTED_ROW_IDS_HASH", () => $e6daffef1b272f85$export$a5a55dd3afd00236);
$parcel$export(module.exports, "setSortedRowIdsHash", () => $e6daffef1b272f85$export$7b78b0b46aa05c76);
$parcel$export(module.exports, "SET_ROW_BORDER_WIDTH", () => $e6daffef1b272f85$export$a347b798ae4b070c);
$parcel$export(module.exports, "setRowBorderWidth", () => $e6daffef1b272f85$export$a1c22b3a0006689b);
$parcel$export(module.exports, "SET_ROW_HEIGHT_MAPPING", () => $e6daffef1b272f85$export$3c2f00efa2858459);
$parcel$export(module.exports, "clearRowHeightMapping", () => $e6daffef1b272f85$export$ee45b95e009bf919);
$parcel$export(module.exports, "BATCH_UPDATE_ROW_HEIGHT_MAPPING", () => $e6daffef1b272f85$export$1e2cc4b1d7e85685);
$parcel$export(module.exports, "batchUpdateRowHeightMapping", () => $e6daffef1b272f85$export$6ad1445af83aec72);
$parcel$export(module.exports, "SET_SCROLLBAR_SIZE", () => $e6daffef1b272f85$export$1343829730561bf3);
$parcel$export(module.exports, "setScrollbarSize", () => $e6daffef1b272f85$export$dc80aaf47c2ba019);
$parcel$export(module.exports, "SET_HEADER_HEIGHT", () => $e6daffef1b272f85$export$e52e6a4be99a8322);
$parcel$export(module.exports, "setHeaderHeight", () => $e6daffef1b272f85$export$5f442def93f9b3e5);
$parcel$export(module.exports, "SET_RENDER_SIDE_BAR_ICON", () => $e6daffef1b272f85$export$9699e624bf23e2bb);
$parcel$export(module.exports, "setRenderSidebarIcon", () => $e6daffef1b272f85$export$28433d58f8f5bf2);
const $e6daffef1b272f85$export$80ba52f206861eb4 = 'state.internal.SET_VERTICAL_SCROLL_OFFSET';
const $e6daffef1b272f85$export$326ff279ca4dfb77 = (offset)=>({
        type: $e6daffef1b272f85$export$80ba52f206861eb4,
        payload: offset
    });
const $e6daffef1b272f85$export$653d24855aaede15 = 'state.internal.SET_VERTICAL_SCROLL_DELTA';
const $e6daffef1b272f85$export$1331c3f83dd180bd = (delta)=>({
        type: $e6daffef1b272f85$export$653d24855aaede15,
        payload: delta
    });
const $e6daffef1b272f85$export$e1dd7001449ed5e8 = 'state.internal.SET_HORIZONTAL_SCROLL_OFFSET';
const $e6daffef1b272f85$export$22fd5ac5ac6862d2 = (offset)=>({
        type: $e6daffef1b272f85$export$e1dd7001449ed5e8,
        payload: offset
    });
const $e6daffef1b272f85$export$7988e33354cc36c5 = 'state.internal.SET_TABLE_SIZE';
const $e6daffef1b272f85$export$ef8b504c11e86ef2 = (tableSize)=>({
        type: $e6daffef1b272f85$export$7988e33354cc36c5,
        payload: tableSize
    });
const $e6daffef1b272f85$export$ff7b028545454800 = 'state.internal.SET_ACTIVE_ITEM';
const $e6daffef1b272f85$export$375743a38c44f220 = (payload)=>({
        type: $e6daffef1b272f85$export$ff7b028545454800,
        payload: payload
    });
const $e6daffef1b272f85$export$d63ae865b2dc3e7f = 'state.internal.CLEAR_ACTIVE_ITEM';
const $e6daffef1b272f85$export$f8e43f3f64585431 = ()=>({
        type: $e6daffef1b272f85$export$d63ae865b2dc3e7f
    });
const $e6daffef1b272f85$export$9b07079645db68ce = 'state.internal.SET_RESIZING_COLUMN';
const $e6daffef1b272f85$export$ecabdd68bb804ada = (payload)=>({
        type: $e6daffef1b272f85$export$9b07079645db68ce,
        payload: payload
    });
const $e6daffef1b272f85$export$d353d2412612deea = 'state.internal.SET_COLUMN_SORT_ORDER';
const $e6daffef1b272f85$export$53f60a18200636 = (payload)=>({
        type: $e6daffef1b272f85$export$d353d2412612deea,
        payload: payload
    });
const $e6daffef1b272f85$export$bd2944db1d7878d7 = 'state.internal.SET_SORT_ORDER_WITH_OVERRIDE';
const $e6daffef1b272f85$export$21099b8525c19e6b = (payload)=>({
        type: $e6daffef1b272f85$export$bd2944db1d7878d7,
        payload: payload
    });
const $e6daffef1b272f85$export$45d5c36be62dcf8e = 'state.internal.SET_MULTI_ADD_ANCHOR';
const $e6daffef1b272f85$export$ccc97b11ed34fa9c = (payload)=>({
        type: $e6daffef1b272f85$export$45d5c36be62dcf8e,
        payload: payload
    });
const $e6daffef1b272f85$export$28f3def567195a3c = 'state.internal.CLEAR_MULTI_ADD_ANCHOR';
const $e6daffef1b272f85$export$fba9cdc0d3369b8b = ()=>({
        type: $e6daffef1b272f85$export$28f3def567195a3c
    });
const $e6daffef1b272f85$export$a5a55dd3afd00236 = 'state.internal.SET_SORTED_ROW_IDS_HASH';
const $e6daffef1b272f85$export$7b78b0b46aa05c76 = (payload)=>({
        type: $e6daffef1b272f85$export$a5a55dd3afd00236,
        payload: payload
    });
const $e6daffef1b272f85$export$a347b798ae4b070c = 'state.internal.SET_ROW_BORDER_WIDTH';
const $e6daffef1b272f85$export$a1c22b3a0006689b = (payload)=>({
        type: $e6daffef1b272f85$export$a347b798ae4b070c,
        payload: payload
    });
const $e6daffef1b272f85$export$3c2f00efa2858459 = 'state.internal.SET_ROW_HEIGHT_MAPPING';
const $e6daffef1b272f85$export$a0d036f26f10d9d2 = (payload)=>({
        type: $e6daffef1b272f85$export$3c2f00efa2858459,
        payload: payload
    });
const $e6daffef1b272f85$export$ee45b95e009bf919 = ()=>$e6daffef1b272f85$export$a0d036f26f10d9d2({});
const $e6daffef1b272f85$export$1e2cc4b1d7e85685 = 'state.internal.BATCH_UPDATE_ROW_HEIGHT_MAPPING';
const $e6daffef1b272f85$export$6ad1445af83aec72 = (rowIds, rowHeightMapping)=>({
        type: $e6daffef1b272f85$export$1e2cc4b1d7e85685,
        payload: {
            rowIds: rowIds,
            rowHeightMapping: rowHeightMapping
        }
    });
const $e6daffef1b272f85$export$1343829730561bf3 = 'state.internal.SET_SCROLLBAR_SIZE';
const $e6daffef1b272f85$export$dc80aaf47c2ba019 = (payload)=>({
        type: $e6daffef1b272f85$export$1343829730561bf3,
        payload: payload
    });
const $e6daffef1b272f85$export$e52e6a4be99a8322 = 'state.internal.SET_HEADER_HEIGHT';
const $e6daffef1b272f85$export$5f442def93f9b3e5 = (height)=>({
        type: $e6daffef1b272f85$export$e52e6a4be99a8322,
        payload: height
    });
const $e6daffef1b272f85$export$9699e624bf23e2bb = 'state.consumer.SET_RENDER_SIDE_BAR_ICON';
const $e6daffef1b272f85$export$28433d58f8f5bf2 = (payload)=>({
        type: $e6daffef1b272f85$export$9699e624bf23e2bb,
        payload: payload
    });

});

parcelRegister("9vAxP", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $52fb8b3e4342ef5a$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $52fb8b3e4342ef5a$export$2e2bcd8739ae039);

var $8sbs2 = parcelRequire("8sbs2");

var $9lqzG = parcelRequire("9lqzG");
const $52fb8b3e4342ef5a$export$d4c72bab9d6cc13a = {
    verticalScrollOffset: 0,
    verticalScrollDelta: 0,
    horizontalScrollOffset: 0,
    // FSN-4037 Remove draggingRowId related logic during FF cleanup
    draggingRowId: undefined,
    multiAddAnchorId: undefined,
    resizingColumnId: undefined,
    draggingColumnId: undefined,
    isSortOverrideEnabled: false,
    activeSortedColumnConfiguration: undefined,
    activeItem: undefined,
    tableSize: {
        width: 0,
        height: 0,
        widthWithoutScrollbarOffset: 0,
        rowMargin: 0
    },
    rowBorderWidth: 0,
    rowHeightMapping: {},
    scrollbarSize: 0,
    sortedRowIdsHash: {},
    headerHeight: 0,
    renderSidebarIcon: undefined,
    shouldUseCssForRendering: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$52fb8b3e4342ef5a$export$2e2bcd8739ae039 = (state = $52fb8b3e4342ef5a$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $9lqzG.SET_VERTICAL_SCROLL_OFFSET:
            return {
                ...state,
                verticalScrollOffset: action.payload
            };
        case 0, $9lqzG.SET_VERTICAL_SCROLL_DELTA:
            return {
                ...state,
                verticalScrollDelta: action.payload
            };
        case 0, $9lqzG.SET_HORIZONTAL_SCROLL_OFFSET:
            return {
                ...state,
                horizontalScrollOffset: action.payload
            };
        case 0, $9lqzG.SET_MULTI_ADD_ANCHOR:
            return {
                ...state,
                multiAddAnchorId: action.payload
            };
        case 0, $9lqzG.CLEAR_MULTI_ADD_ANCHOR:
            return {
                ...state,
                multiAddAnchorId: undefined
            };
        case 0, $9lqzG.SET_TABLE_SIZE:
            return {
                ...state,
                tableSize: action.payload
            };
        case 0, $9lqzG.SET_RESIZING_COLUMN:
            return {
                ...state,
                resizingColumnId: action.payload
            };
        case 0, $9lqzG.SET_COLUMN_SORT_ORDER:
            return {
                ...state,
                activeSortedColumnConfiguration: action.payload,
                isSortOverrideEnabled: false
            };
        case 0, $9lqzG.SET_ACTIVE_ITEM:
            return {
                ...state,
                activeItem: action.payload
            };
        case 0, $9lqzG.CLEAR_ACTIVE_ITEM:
            return {
                ...state,
                activeItem: undefined
            };
        case 0, $9lqzG.SET_SORT_ORDER_WITH_OVERRIDE:
            return {
                ...state,
                isSortOverrideEnabled: action.payload.isSortOverrideEnabled
            };
        case 0, $9lqzG.SET_SORTED_ROW_IDS_HASH:
            return {
                ...state,
                sortedRowIdsHash: action.payload
            };
        case 0, $9lqzG.SET_ROW_BORDER_WIDTH:
            return {
                ...state,
                rowBorderWidth: action.payload
            };
        case 0, $9lqzG.SET_ROW_HEIGHT_MAPPING:
            return {
                ...state,
                rowHeightMapping: action.payload
            };
        case 0, $9lqzG.BATCH_UPDATE_ROW_HEIGHT_MAPPING:
            {
                const { rowHeightMapping: rowHeightMapping, rowIds: rowIds } = action.payload;
                const validatedRowHeights = (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(state.rowHeightMapping, rowIds);
                return {
                    ...state,
                    rowHeightMapping: {
                        ...validatedRowHeights,
                        ...rowHeightMapping
                    }
                };
            }
        case 0, $9lqzG.SET_SCROLLBAR_SIZE:
            return {
                ...state,
                scrollbarSize: action.payload
            };
        case 0, $9lqzG.SET_HEADER_HEIGHT:
            return {
                ...state,
                headerHeight: action.payload
            };
        case 0, $9lqzG.SET_RENDER_SIDE_BAR_ICON:
            return {
                ...state,
                renderSidebarIcon: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("TV84k", function(module, exports) {

$parcel$export(module.exports, "default", () => $3937c4ebac3aa967$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $3kmxb = parcelRequire("3kmxb");

var $5wAOx = parcelRequire("5wAOx");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $ccn7u = parcelRequire("ccn7u");

var $iRbuQ = parcelRequire("iRbuQ");

var $13uzg = parcelRequire("13uzg");
var $3937c4ebac3aa967$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        isAutoHeight: (0, $5wAOx.isAutoHeight)(state),
        width: (0, $atQRE.getTableWidth)(state),
        height: (0, $fRJOe.getTableHeight)(state),
        virtualBoundaries: (0, $fRJOe.getVirtualBoundaries)(state),
        TableMain: $13uzg.default,
        DetailsPanel: $ccn7u.default,
        shouldUseCssForRendering: (0, $atQRE.getShouldUseCssForRendering)(state)
    }), {
    setTableSize: $3kmxb.set
})((0, $iRbuQ.default));

});
parcelRegister("3kmxb", function(module, exports) {

$parcel$export(module.exports, "SET_TABLE_SIZE", () => $d6c7094f3264c4b3$export$7988e33354cc36c5);
$parcel$export(module.exports, "set", () => $d6c7094f3264c4b3$export$adaa4cf7ef1b65be);
// set table size
const $d6c7094f3264c4b3$export$7988e33354cc36c5 = 'ops.table-size.SET_TABLE_SIZE';
const $d6c7094f3264c4b3$export$adaa4cf7ef1b65be = (tableSize)=>({
        type: $d6c7094f3264c4b3$export$7988e33354cc36c5,
        payload: tableSize
    });

});

parcelRegister("5wAOx", function(module, exports) {

$parcel$export(module.exports, "getConsumerState", () => $0dd266d415550ba5$export$341d8012284373b1);
$parcel$export(module.exports, "isAutoHeight", () => $0dd266d415550ba5$export$db0e511b14aa0a6e);
$parcel$export(module.exports, "getAriaLabel", () => $0dd266d415550ba5$export$b908d89b50cd4e14);
$parcel$export(module.exports, "isContentStale", () => $0dd266d415550ba5$export$9039d26c291af11d);
$parcel$export(module.exports, "shouldHideLoadingIndicator", () => $0dd266d415550ba5$export$fffff0ed501bd482);
$parcel$export(module.exports, "shouldRerenderRowOnHover", () => $0dd266d415550ba5$export$21a66ad733a5f373);
$parcel$export(module.exports, "showBottomDecal", () => $0dd266d415550ba5$export$6587735983eaa612);
$parcel$export(module.exports, "getNavigationMode", () => $0dd266d415550ba5$export$d8d84b9edb2f3121);
$parcel$export(module.exports, "isInCellNavigationMode", () => $0dd266d415550ba5$export$164b1d002ce21ad4);
$parcel$export(module.exports, "isInRowNavigationMode", () => $0dd266d415550ba5$export$a7cdf0911782f4e9);
$parcel$export(module.exports, "getShouldSkipVirtualization", () => $0dd266d415550ba5$export$76b0eed37faf2db7);
$parcel$export(module.exports, "disableRowHighlight", () => $0dd266d415550ba5$export$94e08c39526945ff);
$parcel$export(module.exports, "getRowExpansionCallback", () => $0dd266d415550ba5$export$bd84bd77b16747b0);
$parcel$export(module.exports, "getRowAddCallback", () => $0dd266d415550ba5$export$6b23e7f48fb98382);
$parcel$export(module.exports, "getClearAddedRowsCallback", () => $0dd266d415550ba5$export$b1c02c566f8f8e21);
$parcel$export(module.exports, "getPersistAddedRowCallback", () => $0dd266d415550ba5$export$8f6f1d89690007b6);
$parcel$export(module.exports, "getCancelAddedRowCallback", () => $0dd266d415550ba5$export$549fbf34b02d3f9f);
$parcel$export(module.exports, "getColumnExpandCallback", () => $0dd266d415550ba5$export$d1881e0c1d23cb54);
$parcel$export(module.exports, "getChangeHiddenColumnsCallback", () => $0dd266d415550ba5$export$c5513fe56d491d3c);
$parcel$export(module.exports, "getActiveItemChangedCallback", () => $0dd266d415550ba5$export$940cf9a84f2cd566);
$parcel$export(module.exports, "getActiveRowIdChangedCallback", () => $0dd266d415550ba5$export$e4a9acb7b8a41ad4);
$parcel$export(module.exports, "getSortedColumnChangedCallback", () => $0dd266d415550ba5$export$54ab8d2edb67b6c5);
$parcel$export(module.exports, "getVerticalScrollOffsetChangedCallback", () => $0dd266d415550ba5$export$208a9f508202aaea);
$parcel$export(module.exports, "getHorizontalScrollOffsetChangedCallback", () => $0dd266d415550ba5$export$9bc70187ed1fe3de);
$parcel$export(module.exports, "getOnRowListFocusFunctionChangedCallback", () => $0dd266d415550ba5$export$f3043684c353f104);
$parcel$export(module.exports, "getOnReactPortalContainerRefChangedCallback", () => $0dd266d415550ba5$export$4b1da0361b069d9);
$parcel$export(module.exports, "getDetailsPanelComponent", () => $0dd266d415550ba5$export$eb8f069328f0ef13);
$parcel$export(module.exports, "getNonTemporaryCellWrapper", () => $0dd266d415550ba5$export$9d360b10d6c49c27);
$parcel$export(module.exports, "isDetailsPanelOpen", () => $0dd266d415550ba5$export$8eff1175be4b2e5d);
$parcel$export(module.exports, "isColumnConfigurationVisible", () => $0dd266d415550ba5$export$af0e6e54e108dbdf);
$parcel$export(module.exports, "getVisibleAdditionalColumnIds", () => $0dd266d415550ba5$export$95e03d3af742e020);
$parcel$export(module.exports, "getVisibleColumnIds", () => $0dd266d415550ba5$export$9158bf17317ec5a3);
$parcel$export(module.exports, "getVisibleColumnCount", () => $0dd266d415550ba5$export$a494b4888339717d);
$parcel$export(module.exports, "getDefaultAddColumnId", () => $0dd266d415550ba5$export$d2c4eee6843b68dc);
$parcel$export(module.exports, "getTotalDynamicColumnMaxWidth", () => $0dd266d415550ba5$export$b87f4bf1dea22966);
$parcel$export(module.exports, "getTotalDynamicColumnMinWidth", () => $0dd266d415550ba5$export$2143bc4b2542ea5d);
$parcel$export(module.exports, "getLoadingRowComponent", () => $0dd266d415550ba5$export$65784ca6b29dc2a3);
$parcel$export(module.exports, "getFacade", () => $0dd266d415550ba5$export$379c1b3c8c56422e);
$parcel$export(module.exports, "isTableFacade", () => $0dd266d415550ba5$export$f4b00b57da9022eb);
$parcel$export(module.exports, "isTreeTableFacade", () => $0dd266d415550ba5$export$428877d41520e34c);
$parcel$export(module.exports, "shouldDelayRowRenderingOnScroll", () => $0dd266d415550ba5$export$47cf89187102921d);

var $ahm5r = parcelRequire("ahm5r");



var $fZDXk = parcelRequire("fZDXk");

var $2Ctxl = parcelRequire("2Ctxl");
const $0dd266d415550ba5$export$341d8012284373b1 = (state)=>state.consumer;
const $0dd266d415550ba5$export$db0e511b14aa0a6e = (state)=>state.consumer.autoHeight;
const $0dd266d415550ba5$export$b908d89b50cd4e14 = (state)=>state.consumer.ariaLabel;
const $0dd266d415550ba5$export$9039d26c291af11d = (state)=>state.consumer.isContentStale;
const $0dd266d415550ba5$export$fffff0ed501bd482 = (state)=>state.consumer.shouldHideLoadingIndicator;
const $0dd266d415550ba5$export$21a66ad733a5f373 = (state)=>state.consumer.shouldRerenderRowOnHover;
const $0dd266d415550ba5$export$6587735983eaa612 = (state)=>state.consumer.showDecalAtBottom;
const $0dd266d415550ba5$export$d8d84b9edb2f3121 = (state)=>state.consumer.navigationMode;
const $0dd266d415550ba5$export$164b1d002ce21ad4 = (state)=>$0dd266d415550ba5$export$d8d84b9edb2f3121(state) === (0, $1d080e9e60c37b43$export$9e9986b7abe95577);
const $0dd266d415550ba5$export$a7cdf0911782f4e9 = (state)=>$0dd266d415550ba5$export$d8d84b9edb2f3121(state) === (0, $1d080e9e60c37b43$export$a01cd8e028b3d34f);
const $0dd266d415550ba5$export$76b0eed37faf2db7 = (state)=>state.consumer.shouldSkipVirtualization;
const $0dd266d415550ba5$export$94e08c39526945ff = (state)=>state.consumer.disableRowHighlight;
// CALLBACKS
const $0dd266d415550ba5$var$getConsumerCallbacks = (state)=>state.consumer.callbacks;
const $0dd266d415550ba5$export$bd84bd77b16747b0 = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onRowExpansionChangeRequested;
const $0dd266d415550ba5$export$6b23e7f48fb98382 = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onRowAddRequested;
const $0dd266d415550ba5$export$b1c02c566f8f8e21 = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onClearAddedRowsRequested;
const $0dd266d415550ba5$export$8f6f1d89690007b6 = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onPersistAddedRowRequested;
const $0dd266d415550ba5$export$549fbf34b02d3f9f = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onCancelAddedRowRequested;
const $0dd266d415550ba5$export$d1881e0c1d23cb54 = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onColumnExpansionChangeRequested;
const $0dd266d415550ba5$export$9bc4a4d8de396706 = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onColumnMoveRequested;
const $0dd266d415550ba5$export$c5513fe56d491d3c = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onChangeHiddenColumnsRequested;
const $0dd266d415550ba5$export$940cf9a84f2cd566 = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onActiveItemChanged;
const $0dd266d415550ba5$export$e4a9acb7b8a41ad4 = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onActiveRowIdChanged;
const $0dd266d415550ba5$export$54ab8d2edb67b6c5 = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onSortedColumnChanged;
const $0dd266d415550ba5$export$15d0406154f187f9 = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onSortedRowIdsChanged;
const $0dd266d415550ba5$export$80456d589232e453 = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onDisplayedRowsChanged;
const $0dd266d415550ba5$export$208a9f508202aaea = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onVerticalScrollOffsetChanged;
const $0dd266d415550ba5$export$9bc70187ed1fe3de = (state)=>$0dd266d415550ba5$var$getConsumerCallbacks(state).onHorizontalScrollOffsetChanged;
const $0dd266d415550ba5$export$f3043684c353f104 = (state)=>state.consumer.callbacks.onRowListFocusFunctionChanged;
const $0dd266d415550ba5$export$4b1da0361b069d9 = (state)=>state.consumer.callbacks.onReactPortalContainerRefChanged;
const $0dd266d415550ba5$export$eb8f069328f0ef13 = (state)=>state.consumer.DetailsPanelComponent;
const $0dd266d415550ba5$export$9d360b10d6c49c27 = (state)=>state.consumer.NonTemporaryCellWrapper;
const $0dd266d415550ba5$export$8eff1175be4b2e5d = (state)=>!!$0dd266d415550ba5$export$eb8f069328f0ef13(state);
const $0dd266d415550ba5$export$af0e6e54e108dbdf = (0, $ahm5r.createSelector)($0dd266d415550ba5$export$c5513fe56d491d3c, $0dd266d415550ba5$export$8eff1175be4b2e5d, (hiddenColumnsCallback, detailsPanelOpen)=>hiddenColumnsCallback !== undefined && !detailsPanelOpen);
const $0dd266d415550ba5$export$95e03d3af742e020 = (0, $ahm5r.createSelector)((0, $2Ctxl.getColumnTree), (0, $2Ctxl.getExpandedColumnIdsHash), (0, $2Ctxl.getHiddenColumnsLookupHash), (0, $2Ctxl.getSortedColumnIds), $0dd266d415550ba5$export$8eff1175be4b2e5d, (columnTree, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds, isDetailsOpen)=>isDetailsOpen ? [] : (0, $fZDXk.default)(columnTree, columnTree.rootAdditionalIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds));
const $0dd266d415550ba5$export$9158bf17317ec5a3 = (0, $ahm5r.createSelector)((0, $2Ctxl.getVisibleCoreColumnIds), $0dd266d415550ba5$export$95e03d3af742e020, (coreColumnIds, additionalColumnIds)=>coreColumnIds.concat(additionalColumnIds));
const $0dd266d415550ba5$export$a494b4888339717d = (0, $ahm5r.createSelector)($0dd266d415550ba5$export$9158bf17317ec5a3, (visibleColumnIds)=>visibleColumnIds.length);
const $0dd266d415550ba5$export$d2c4eee6843b68dc = (0, $ahm5r.createSelector)((0, $2Ctxl.getColumnTree), $0dd266d415550ba5$export$9158bf17317ec5a3, (columnTree, visibleColumnIds)=>visibleColumnIds.find((columnId)=>columnTree.columns[columnId].isDefaultAdd) || visibleColumnIds[0]);
const $0dd266d415550ba5$var$makeSummedDynamicColumnProperty = (accessor)=>(0, $ahm5r.createSelector)($0dd266d415550ba5$export$9158bf17317ec5a3, (0, $2Ctxl.getColumnTree), (visibleColumnIds, columnTree)=>visibleColumnIds.map((columnId)=>accessor(columnTree.columns[columnId])).reduce((a, b)=>a + b, 0));
const $0dd266d415550ba5$export$b87f4bf1dea22966 = $0dd266d415550ba5$var$makeSummedDynamicColumnProperty((column)=>column.maxWidth);
const $0dd266d415550ba5$export$2143bc4b2542ea5d = $0dd266d415550ba5$var$makeSummedDynamicColumnProperty((column)=>column.minWidth);
const $0dd266d415550ba5$export$65784ca6b29dc2a3 = (state)=>$0dd266d415550ba5$export$341d8012284373b1(state).LoadingRowComponent;
const $0dd266d415550ba5$export$379c1b3c8c56422e = (state)=>$0dd266d415550ba5$export$341d8012284373b1(state).facade;
const $0dd266d415550ba5$export$f4b00b57da9022eb = (state)=>$0dd266d415550ba5$export$379c1b3c8c56422e(state) === (0, $bce106de39319478$export$88a597d0c7ae97b);
const $0dd266d415550ba5$export$428877d41520e34c = (state)=>$0dd266d415550ba5$export$379c1b3c8c56422e(state) === (0, $bce106de39319478$export$1d9e930504ed3ddf);
const $0dd266d415550ba5$export$47cf89187102921d = (state)=>$0dd266d415550ba5$export$f4b00b57da9022eb(state);

});
const $bce106de39319478$export$88a597d0c7ae97b = 'TABLE';
const $bce106de39319478$export$1d9e930504ed3ddf = 'TREE_TABLE';

parcelRegister("fZDXk", function(module, exports) {

$parcel$export(module.exports, "default", () => $453f6fd55b2e8bbb$export$2e2bcd8739ae039);

var $fiH87 = parcelRequire("fiH87");
const $453f6fd55b2e8bbb$var$traverseColumns = (columnTree, columnIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds, result)=>{
    (0, $fiH87.default)(sortedColumnIds, columnIds).forEach((columnId)=>{
        const childrenIds = (expandedColumnIdsHash[columnId] ? columnTree.columns[columnId].childrenIds : []) || [];
        if (!hiddenColumnIdsHash[columnId]) {
            result.push(columnId);
            $453f6fd55b2e8bbb$var$traverseColumns(columnTree, childrenIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds, result);
        }
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$453f6fd55b2e8bbb$export$2e2bcd8739ae039 = (columnTree, rootColumnIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds)=>{
    const result = [];
    $453f6fd55b2e8bbb$var$traverseColumns(columnTree, rootColumnIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds, result);
    return result;
};

});
parcelRegister("fiH87", function(module, exports) {

$parcel$export(module.exports, "default", () => $361a1adb35f6d57e$export$2e2bcd8739ae039);

var $umifb = parcelRequire("umifb");

var $2zs80 = parcelRequire("2zs80");

var $7BEaI = parcelRequire("7BEaI");
const $361a1adb35f6d57e$var$getLevelIds = (sortedColumnIds, columnIds)=>{
    if (sortedColumnIds === undefined) return columnIds;
    const levelIdsNotInSortedArray = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(columnIds, sortedColumnIds);
    const sortedIdsInLevel = (0, (/*@__PURE__*/$parcel$interopDefault($7BEaI)))(sortedColumnIds, columnIds);
    /*  to cope with inconsistent data provided by the consumer - in case of overridden column sort order,
        we append ids that exist in the current level array but not in the sorted array (override), at the end.
     */ return (0, (/*@__PURE__*/$parcel$interopDefault($umifb)))(sortedIdsInLevel, levelIdsNotInSortedArray);
};
var $361a1adb35f6d57e$export$2e2bcd8739ae039 = $361a1adb35f6d57e$var$getLevelIds;

});
parcelRegister("umifb", function(module, exports) {

var $7pKvH = parcelRequire("7pKvH");

var $72Qfa = parcelRequire("72Qfa");

var $k4ZVz = parcelRequire("k4ZVz");

var $4sprp = parcelRequire("4sprp");
/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */ function $05b4186ecb65c386$var$concat() {
    var length = arguments.length;
    if (!length) return [];
    var args = Array(length - 1), array = arguments[0], index = length;
    while(index--)args[index - 1] = arguments[index];
    return $7pKvH($4sprp(array) ? $k4ZVz(array) : [
        array
    ], $72Qfa(args, 1));
}
module.exports = $05b4186ecb65c386$var$concat;

});



parcelRegister("2Ctxl", function(module, exports) {

$parcel$export(module.exports, "getColumnTree", () => $b0406023310542ff$export$626e2d661dbdbb1e);
$parcel$export(module.exports, "getColumnWidths", () => $b0406023310542ff$export$e54c9225ca52acc);
$parcel$export(module.exports, "getDefaultComparator", () => $b0406023310542ff$export$db92824abfb21a2e);
$parcel$export(module.exports, "getSortedColumnIds", () => $b0406023310542ff$export$9286093f6e1ecac);
$parcel$export(module.exports, "getCellComponent", () => $b0406023310542ff$export$cc7ae951af4ebc4e);
$parcel$export(module.exports, "getExpandedColumnIdsHash", () => $b0406023310542ff$export$973bd9cbde2d338d);
$parcel$export(module.exports, "getHiddenColumnsLookupHash", () => $b0406023310542ff$export$a6f67a8a23dbf9a1);
$parcel$export(module.exports, "getVisibleCoreColumnIds", () => $b0406023310542ff$export$489e7298b8651c2e);
$parcel$export(module.exports, "getVisibleCoreColumnsWidth", () => $b0406023310542ff$export$987e0cd3ec211c8);
$parcel$export(module.exports, "getColumnConfiguration", () => $b0406023310542ff$export$3d6f7f2469223338);
$parcel$export(module.exports, "getColumnTitle", () => $b0406023310542ff$export$7fd4bf39bc1fa7d6);
$parcel$export(module.exports, "getColumnHeaderComponent", () => $b0406023310542ff$export$b4e69e5204b2a3b0);
$parcel$export(module.exports, "getColumnTooltip", () => $b0406023310542ff$export$b165f1ee654a6c88);
$parcel$export(module.exports, "getColumnMinWidth", () => $b0406023310542ff$export$76d9570454343133);
$parcel$export(module.exports, "getColumnColor", () => $b0406023310542ff$export$cf34af5efc32c51);
$parcel$export(module.exports, "getColumnHasChildren", () => $b0406023310542ff$export$55dbcdc822375b7c);
$parcel$export(module.exports, "getColumnParentId", () => $b0406023310542ff$export$a63e62bf5f23be09);
$parcel$export(module.exports, "isColumnExpanded", () => $b0406023310542ff$export$fd339f76e0ca945c);
$parcel$export(module.exports, "isColumnSortable", () => $b0406023310542ff$export$19a1e000b0c7f615);
$parcel$export(module.exports, "isParentColumn", () => $b0406023310542ff$export$d5f9813bca43da33);
$parcel$export(module.exports, "isChildColumn", () => $b0406023310542ff$export$3289971ebd775b18);
$parcel$export(module.exports, "getParentId", () => $b0406023310542ff$export$e6e327a97512715e);
$parcel$export(module.exports, "isFirstColumn", () => $b0406023310542ff$export$d3671a4f3687bed);
$parcel$export(module.exports, "isVisibleCoreColumn", () => $b0406023310542ff$export$3180485c5d58c720);
$parcel$export(module.exports, "canCellBeMultiLine", () => $b0406023310542ff$export$f36235907d788d9d);
$parcel$export(module.exports, "hasAnyMultiLineColumn", () => $b0406023310542ff$export$893dde5c71a334bb);
$parcel$export(module.exports, "getAllColumnIds", () => $b0406023310542ff$export$373740f91e6ef0b9);

var $ahm5r = parcelRequire("ahm5r");

var $3zv7S = parcelRequire("3zv7S");

var $ejGPc = parcelRequire("ejGPc");

var $eU03Z = parcelRequire("eU03Z");

var $fZDXk = parcelRequire("fZDXk");

var $4WvZs = parcelRequire("4WvZs");
const $b0406023310542ff$export$626e2d661dbdbb1e = (state)=>state.consumer.columnTree;
const $b0406023310542ff$export$d6f73af294120ea1 = (state)=>state.consumer.expandedColumnIds;
const $b0406023310542ff$export$701fee8fc287bd90 = (state)=>state.consumer.hiddenColumnIds;
const $b0406023310542ff$export$e54c9225ca52acc = (state)=>state.consumer.columnWidths;
const $b0406023310542ff$export$7a380d7d28b470cc = (state)=>state.consumer.columnComparators;
const $b0406023310542ff$export$db92824abfb21a2e = (state)=>state.consumer.defaultComparator;
const $b0406023310542ff$export$6dd907dd5b1dc40e = (state)=>state.consumer.minAdditionalColumnsWidth;
const $b0406023310542ff$export$9286093f6e1ecac = (state)=>state.consumer.sortedColumnIds;
const $b0406023310542ff$export$cc7ae951af4ebc4e = (state, columnId)=>$b0406023310542ff$export$626e2d661dbdbb1e(state).columns[columnId].CellComponent;
const $b0406023310542ff$export$78d02608cba67d5b = (0, $ahm5r.createSelector)($b0406023310542ff$export$db92824abfb21a2e, $b0406023310542ff$export$7a380d7d28b470cc, (defaultComparator, columnComparators)=>(0, $ejGPc.default)(defaultComparator, columnComparators));
const $b0406023310542ff$export$973bd9cbde2d338d = (0, $ahm5r.createSelector)($b0406023310542ff$export$d6f73af294120ea1, (expandedColumnIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    expandedColumnIds.reduce((acc, next)=>{
        // for effeciency sake we are mutating the accumulator to build up our hash
        acc[next] = true;
        return acc;
    }, {}));
const $b0406023310542ff$export$a6f67a8a23dbf9a1 = (0, $ahm5r.createSelector)($b0406023310542ff$export$701fee8fc287bd90, (hiddenColumnIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(hiddenColumnIds, (hash, id)=>({
            ...hash,
            [id]: true
        }), {}));
const $b0406023310542ff$export$489e7298b8651c2e = (0, $ahm5r.createSelector)($b0406023310542ff$export$626e2d661dbdbb1e, $b0406023310542ff$export$973bd9cbde2d338d, $b0406023310542ff$export$a6f67a8a23dbf9a1, $b0406023310542ff$export$9286093f6e1ecac, (columnTree, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds)=>(0, $fZDXk.default)(columnTree, columnTree.rootCoreIds, expandedColumnIdsHash, hiddenColumnIdsHash, sortedColumnIds));
const $b0406023310542ff$export$987e0cd3ec211c8 = (0, $ahm5r.createSelector)($b0406023310542ff$export$489e7298b8651c2e, $b0406023310542ff$export$626e2d661dbdbb1e, $b0406023310542ff$export$e54c9225ca52acc, (coreColumns, columnTree, columnWidths)=>coreColumns.length === 0 ? 0 : coreColumns.reduce((acc, columnId)=>{
        const columnWidth = columnWidths[columnId] || columnTree.columns[columnId].defaultWidth;
        return acc + columnWidth;
    }, 54));
const $b0406023310542ff$export$3d6f7f2469223338 = (0, $ahm5r.createSelector)($b0406023310542ff$export$626e2d661dbdbb1e, $b0406023310542ff$export$a6f67a8a23dbf9a1, $b0406023310542ff$export$9286093f6e1ecac, (columnTree, hiddenColumnIdsHash, sortedColumnIds)=>(0, $4WvZs.default)(columnTree, columnTree.rootCoreIds.concat(columnTree.rootAdditionalIds), hiddenColumnIdsHash, sortedColumnIds));
const $b0406023310542ff$export$d12de2db7af15c1f = (0, $ahm5r.createSelector)($b0406023310542ff$export$489e7298b8651c2e, (visibleCoreColumnIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(visibleCoreColumnIds, (hash, id)=>({
            ...hash,
            [id]: true
        }), {}));
const $b0406023310542ff$export$7fd4bf39bc1fa7d6 = (state, columnId)=>$b0406023310542ff$export$626e2d661dbdbb1e(state).columns[columnId].title;
const $b0406023310542ff$export$b4e69e5204b2a3b0 = (state, columnId)=>$b0406023310542ff$export$626e2d661dbdbb1e(state).columns[columnId].HeaderComponent;
const $b0406023310542ff$export$b165f1ee654a6c88 = (state, columnId)=>$b0406023310542ff$export$626e2d661dbdbb1e(state).columns[columnId].tooltip;
const $b0406023310542ff$export$76d9570454343133 = (state, columnId)=>{
    const columnTree = $b0406023310542ff$export$626e2d661dbdbb1e(state);
    return columnTree.columns[columnId].minWidth;
};
const $b0406023310542ff$export$134c72f8153b1472 = (state, columnId)=>{
    const columnTree = $b0406023310542ff$export$626e2d661dbdbb1e(state);
    return columnTree.columns[columnId].maxWidth;
};
const $b0406023310542ff$export$cf34af5efc32c51 = (state, columnId)=>$b0406023310542ff$export$626e2d661dbdbb1e(state).columns[columnId].color || '#333';
const $b0406023310542ff$export$55dbcdc822375b7c = (state, columnId)=>{
    const columnTree = $b0406023310542ff$export$626e2d661dbdbb1e(state);
    return !!columnTree.columns[columnId].childrenIds && // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
    columnTree.columns[columnId].childrenIds.length > 0;
};
const $b0406023310542ff$export$a63e62bf5f23be09 = (state, columnId)=>{
    const columnTree = $b0406023310542ff$export$626e2d661dbdbb1e(state);
    return columnTree.columns[columnId].parentId;
};
const $b0406023310542ff$export$588980822120b07b = (state, columnId)=>$b0406023310542ff$export$626e2d661dbdbb1e(state).columns[columnId].resizeStrategy;
const $b0406023310542ff$export$fd339f76e0ca945c = (state, columnId)=>{
    const expandedColumnIdsHash = $b0406023310542ff$export$973bd9cbde2d338d(state);
    return !!expandedColumnIdsHash[columnId];
};
const $b0406023310542ff$export$19a1e000b0c7f615 = (state, columnId)=>{
    const columnComparators = $b0406023310542ff$export$7a380d7d28b470cc(state);
    return !!columnComparators[columnId];
};
const $b0406023310542ff$export$d5f9813bca43da33 = (state, columnId)=>!!$b0406023310542ff$export$626e2d661dbdbb1e(state).columns[columnId].childrenIds;
const $b0406023310542ff$export$3289971ebd775b18 = (state, columnId)=>!!$b0406023310542ff$export$626e2d661dbdbb1e(state).columns[columnId].parentId;
const $b0406023310542ff$export$e6e327a97512715e = (state, columnId)=>$b0406023310542ff$export$626e2d661dbdbb1e(state).columns[columnId].parentId;
const $b0406023310542ff$export$d3671a4f3687bed = (state, columnId)=>$b0406023310542ff$export$489e7298b8651c2e(state)[0] === columnId;
const $b0406023310542ff$export$3180485c5d58c720 = (state, columnId)=>{
    const visibleColumnsLookupHash = $b0406023310542ff$export$d12de2db7af15c1f(state);
    return !!visibleColumnsLookupHash[columnId];
};
const $b0406023310542ff$export$f36235907d788d9d = (state, columnId)=>$b0406023310542ff$export$626e2d661dbdbb1e(state).columns[columnId].canBeMultiLine || false;
const $b0406023310542ff$export$893dde5c71a334bb = (0, $ahm5r.createSelector)($b0406023310542ff$export$626e2d661dbdbb1e, (columnTree)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const columns = Object.values(columnTree.columns);
    return columns.filter((column)=>column.canBeMultiLine).length > 0;
});
const $b0406023310542ff$export$1e5039fcef278b0d = (0, $ahm5r.createSelector)($b0406023310542ff$export$626e2d661dbdbb1e, (columnTree)=>[
        ...columnTree.rootCoreIds,
        ...columnTree.rootAdditionalIds
    ]);
const $b0406023310542ff$export$373740f91e6ef0b9 = (0, $ahm5r.createSelector)($b0406023310542ff$export$9286093f6e1ecac, $b0406023310542ff$export$626e2d661dbdbb1e, $b0406023310542ff$export$1e5039fcef278b0d, (sortedColumnIds, columnTree, rootColumnIds)=>(0, $eU03Z.default)(columnTree, rootColumnIds, sortedColumnIds));

});
parcelRegister("3zv7S", function(module, exports) {

var $2x6Yt = parcelRequire("2x6Yt");

var $c3u3c = parcelRequire("c3u3c");

var $1lM9j = parcelRequire("1lM9j");

var $aiJg7 = parcelRequire("aiJg7");

var $4sprp = parcelRequire("4sprp");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $299cc8f655bd088e$var$reduce(collection, iteratee, accumulator) {
    var func = $4sprp(collection) ? $2x6Yt : $aiJg7, initAccum = arguments.length < 3;
    return func(collection, $1lM9j(iteratee, 4), accumulator, initAccum, $c3u3c);
}
module.exports = $299cc8f655bd088e$var$reduce;

});
parcelRegister("aiJg7", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $77feb151e6770379$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $77feb151e6770379$var$baseReduce;

});


parcelRegister("ejGPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab53873551c0d396$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ab53873551c0d396$export$2e2bcd8739ae039 = (defaultComparator, columnComparators)=>{
    if (!defaultComparator) return undefined;
    return typeof defaultComparator === 'function' ? defaultComparator : columnComparators[defaultComparator];
};

});

parcelRegister("eU03Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $a26c2469b689461c$export$2e2bcd8739ae039);

var $fiH87 = parcelRequire("fiH87");
const $a26c2469b689461c$var$traverseColumns = (columnTree, columnIds, sortedColumnIds, result)=>{
    (0, $fiH87.default)(sortedColumnIds, columnIds).forEach((columnId)=>{
        const childrenIds = columnTree.columns[columnId].childrenIds || [];
        result.push(columnId);
        $a26c2469b689461c$var$traverseColumns(columnTree, childrenIds, sortedColumnIds, result);
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a26c2469b689461c$export$2e2bcd8739ae039 = (columnTree, rootColumnIds, sortedColumnIds)=>{
    const result = [];
    $a26c2469b689461c$var$traverseColumns(columnTree, rootColumnIds, sortedColumnIds, result);
    return result;
};

});

parcelRegister("4WvZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe7ab2651a25c180$export$2e2bcd8739ae039);

var $60q4r = parcelRequire("60q4r");

var $fiH87 = parcelRequire("fiH87");
const $fe7ab2651a25c180$var$traverseColumns = (columnTree, columnIds, hiddenColumnIdsHash, sortedColumnIds, result)=>{
    (0, $fiH87.default)(sortedColumnIds, columnIds).forEach((columnId)=>{
        const column = columnTree.columns[columnId];
        const { parentId: parentId } = column;
        const isParentHidden = parentId ? !!hiddenColumnIdsHash[parentId] : false;
        const columnConfiguration = {
            id: column.id,
            title: column.title,
            // FSN-4987 Remove resize strategy related logic during cleanup
            resizeStrategy: column.resizeStrategy,
            isHidden: !!hiddenColumnIdsHash[columnId],
            isDisabled: column.isHideable === false,
            parentId: parentId,
            isParentHidden: isParentHidden,
            depth: (0, $60q4r.default)(columnTree.columns, columnId)
        };
        if (!column.isMarkup) result.push(columnConfiguration);
        const childrenIds = column.childrenIds || [];
        $fe7ab2651a25c180$var$traverseColumns(columnTree, childrenIds, hiddenColumnIdsHash, sortedColumnIds, result);
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fe7ab2651a25c180$export$2e2bcd8739ae039 = (columnTree, rootColumnIds, hiddenColumnIdsHash, sortedColumnIds)=>{
    const result = [];
    $fe7ab2651a25c180$var$traverseColumns(columnTree, rootColumnIds, hiddenColumnIdsHash, sortedColumnIds, result);
    return result;
};

});
parcelRegister("60q4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9832fd20fbafcde$export$2e2bcd8739ae039);

var $beufL = parcelRequire("beufL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a9832fd20fbafcde$export$2e2bcd8739ae039 = (tree, id)=>(0, $beufL.default)(tree, id).length - 1;

});
parcelRegister("beufL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b108c8f47c53f52$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b108c8f47c53f52$export$2e2bcd8739ae039 = (tree, id)=>{
    const path = [
        id
    ];
    let currentId = id;
    while(tree[currentId].parentId){
        const { parentId: parentId } = tree[currentId];
        // @ts-expect-error - TS2345 - Argument of type 'Optional<string>' is not assignable to parameter of type 'string'.
        path.unshift(parentId);
        // @ts-expect-error - TS2322 - Type 'Optional<string>' is not assignable to type 'string'.
        currentId = parentId;
    }
    return path;
};

});





parcelRegister("atQRE", function(module, exports) {

$parcel$export(module.exports, "getActiveItem", () => $664955a4e31c5852$export$f0f14253205ef68f);
$parcel$export(module.exports, "getActiveRow", () => $664955a4e31c5852$export$be515f6e1df61362);
$parcel$export(module.exports, "getActiveCell", () => $664955a4e31c5852$export$70059ae5084357cb);
$parcel$export(module.exports, "getResizingColumnId", () => $664955a4e31c5852$export$db5a621909f822c0);
$parcel$export(module.exports, "getVerticalScrollOffset", () => $664955a4e31c5852$export$76e51b2d87e066ab);
$parcel$export(module.exports, "hasVerticallyScrolled", () => $664955a4e31c5852$export$e7c447ae7e47068f);
$parcel$export(module.exports, "getHorizontalScrollOffset", () => $664955a4e31c5852$export$624a30c8322e672b);
$parcel$export(module.exports, "getIsSortOverrideEnabled", () => $664955a4e31c5852$export$97b55762fc1eba7f);
$parcel$export(module.exports, "getShouldUseCssForRendering", () => $664955a4e31c5852$export$94ad9100e15f7253);
$parcel$export(module.exports, "getTableHeight", () => $664955a4e31c5852$export$81ff4c821ba5ba90);
$parcel$export(module.exports, "getTableWidth", () => $664955a4e31c5852$export$4910020ffe58186f);
$parcel$export(module.exports, "getTableWidthWithoutScrollbarOffset", () => $664955a4e31c5852$export$cbeeb8058672c78a);
$parcel$export(module.exports, "getTableRowMargin", () => $664955a4e31c5852$export$a388e245e4b1a116);
$parcel$export(module.exports, "getDraggingRowId", () => $664955a4e31c5852$export$fdc0e8ca65eb11e);
$parcel$export(module.exports, "getActiveSortedColumnConfiguration", () => $664955a4e31c5852$export$eaa5c021c57b0ffd);
$parcel$export(module.exports, "getSortedRowIdsHash", () => $664955a4e31c5852$export$204c73f66abde0fb);
$parcel$export(module.exports, "getHeaderHeight", () => $664955a4e31c5852$export$98ba287114e9d0c3);
$parcel$export(module.exports, "getRenderSidebarIcon", () => $664955a4e31c5852$export$a0841f9badd7cdca);

const $664955a4e31c5852$export$f0f14253205ef68f = (state)=>state.internal.activeItem;
const $664955a4e31c5852$export$be515f6e1df61362 = (state)=>{
    const activeItem = $664955a4e31c5852$export$f0f14253205ef68f(state);
    return activeItem && activeItem.type === (0, $1d080e9e60c37b43$export$8a257aa81ef4a9e0) ? activeItem : undefined;
};
const $664955a4e31c5852$export$70059ae5084357cb = (state)=>{
    const activeItem = $664955a4e31c5852$export$f0f14253205ef68f(state);
    return activeItem && activeItem.type === (0, $1d080e9e60c37b43$export$4b3489234fd17200) ? activeItem : undefined;
};
const $664955a4e31c5852$export$db5a621909f822c0 = (state)=>state.internal.resizingColumnId;
const $664955a4e31c5852$export$76e51b2d87e066ab = (state)=>state.internal.verticalScrollOffset;
const $664955a4e31c5852$export$e7c447ae7e47068f = (state)=>state.internal.verticalScrollOffset > 0;
const $664955a4e31c5852$export$becdfc8521c14ad2 = (state)=>state.internal.verticalScrollDelta;
const $664955a4e31c5852$export$624a30c8322e672b = (state)=>state.internal.horizontalScrollOffset;
const $664955a4e31c5852$export$97b55762fc1eba7f = (state)=>state.internal.isSortOverrideEnabled;
const $664955a4e31c5852$export$94ad9100e15f7253 = (state)=>state.internal.shouldUseCssForRendering;
const $664955a4e31c5852$export$af7a4f73692b1459 = (state)=>state.internal.tableSize;
const $664955a4e31c5852$export$81ff4c821ba5ba90 = (state)=>$664955a4e31c5852$export$af7a4f73692b1459(state).height;
const $664955a4e31c5852$export$4910020ffe58186f = (state)=>$664955a4e31c5852$export$af7a4f73692b1459(state).width;
const $664955a4e31c5852$export$cbeeb8058672c78a = (state)=>$664955a4e31c5852$export$af7a4f73692b1459(state).widthWithoutScrollbarOffset;
const $664955a4e31c5852$export$a388e245e4b1a116 = (state)=>$664955a4e31c5852$export$af7a4f73692b1459(state).rowMargin;
const $664955a4e31c5852$export$fdc0e8ca65eb11e = (state)=>state.internal.draggingRowId;
const $664955a4e31c5852$export$f0d8a9d6630b9103 = (state)=>state.internal.multiAddAnchorId;
const $664955a4e31c5852$export$eaa5c021c57b0ffd = (state)=>state.internal.activeSortedColumnConfiguration;
const $664955a4e31c5852$export$204c73f66abde0fb = (state)=>state.internal.sortedRowIdsHash;
const $664955a4e31c5852$export$728dbf35b325565b = (state)=>state.internal.scrollbarSize;
const $664955a4e31c5852$export$98ba287114e9d0c3 = (state)=>state.internal.headerHeight;
const $664955a4e31c5852$export$a0841f9badd7cdca = (state)=>state.internal.renderSidebarIcon;

});

parcelRegister("fRJOe", function(module, exports) {

$parcel$export(module.exports, "getRowDepth", () => $c01bc7434e4fbf2a$export$d9790c6d67ace138);
$parcel$export(module.exports, "getVisibleLoadingRowIds", () => $c01bc7434e4fbf2a$export$79bc68636023e019);
$parcel$export(module.exports, "isAddLinkShown", () => $c01bc7434e4fbf2a$export$f1f55f40e2397801);
$parcel$export(module.exports, "isGlobalAddEnabled", () => $c01bc7434e4fbf2a$export$53bdd4654b396c67);
$parcel$export(module.exports, "canLastRowAddSiblingOrChildren", () => $c01bc7434e4fbf2a$export$7c458dc02abd8dc7);
$parcel$export(module.exports, "getTableHeight", () => $c01bc7434e4fbf2a$export$81ff4c821ba5ba90);
$parcel$export(module.exports, "getTableContentWidth", () => $c01bc7434e4fbf2a$export$bf1a6d4805ae1aa3);
$parcel$export(module.exports, "getTableContentHeight", () => $c01bc7434e4fbf2a$export$6d30ea7d886d20a8);
$parcel$export(module.exports, "getTableRowsHeight", () => $c01bc7434e4fbf2a$export$508de1ea1f8be016);
$parcel$export(module.exports, "getHorizontalScrollWidth", () => $c01bc7434e4fbf2a$export$59e4df7bc874f4dc);
$parcel$export(module.exports, "getColumn", () => $c01bc7434e4fbf2a$export$c9dd4bee4ae86f53);
$parcel$export(module.exports, "getColumnWidth", () => $c01bc7434e4fbf2a$export$dfa11a34ceba822);
$parcel$export(module.exports, "getScrollOffsetForRowIndex", () => $c01bc7434e4fbf2a$export$7f5dc96b25afd50);
$parcel$export(module.exports, "hasHorizontalScrollbar", () => $c01bc7434e4fbf2a$export$35f00941c70ac98c);
$parcel$export(module.exports, "hasVerticalScrollbar", () => $c01bc7434e4fbf2a$export$5ce15b832a232abf);
$parcel$export(module.exports, "isHorizontalScrollLeftShadowVisible", () => $c01bc7434e4fbf2a$export$482d647122d9850d);
$parcel$export(module.exports, "getMaxHorizontalScrollOffset", () => $c01bc7434e4fbf2a$export$9854f9aebd7abc1c);
$parcel$export(module.exports, "isHorizontalScrollRightShadowVisible", () => $c01bc7434e4fbf2a$export$a5fd1dde37333151);
$parcel$export(module.exports, "getVisibleAdditionalColumnsWidth", () => $c01bc7434e4fbf2a$export$c17b791581a1b518);
$parcel$export(module.exports, "getOffsetFromBottom", () => $c01bc7434e4fbf2a$export$8d5a56e5651cf107);
$parcel$export(module.exports, "getOffsetFromTop", () => $c01bc7434e4fbf2a$export$302e8799c65ec80);
$parcel$export(module.exports, "getOffsetFromLeft", () => $c01bc7434e4fbf2a$export$be46d880d5c67a2f);
$parcel$export(module.exports, "getOffsetFromRight", () => $c01bc7434e4fbf2a$export$cdbbb229c03c4259);
$parcel$export(module.exports, "getColumnSortOrder", () => $c01bc7434e4fbf2a$export$28e014ec3d91f1b2);
$parcel$export(module.exports, "getShouldVirtualize", () => $c01bc7434e4fbf2a$export$75cdbb73a780df34);
$parcel$export(module.exports, "getVirtualBoundaries", () => $c01bc7434e4fbf2a$export$3ddd5b9a27496e14);
$parcel$export(module.exports, "getNumberOfLoadingRowsInDisplayBoundary", () => $c01bc7434e4fbf2a$export$15a684dfff6d5394);
$parcel$export(module.exports, "getActiveRowIndex", () => $c01bc7434e4fbf2a$export$b455bac95fd02aad);
$parcel$export(module.exports, "getNextActiveRowIndex", () => $c01bc7434e4fbf2a$export$7b06ecd71d436a71);
$parcel$export(module.exports, "getPrevActiveRowIndex", () => $c01bc7434e4fbf2a$export$c98fb65aaf1fa4f7);
$parcel$export(module.exports, "rowIndexToRowId", () => $c01bc7434e4fbf2a$export$7bf5553e96d8acb1);
$parcel$export(module.exports, "getActiveRowId", () => $c01bc7434e4fbf2a$export$f5e04ce1033f6b64);
$parcel$export(module.exports, "isActiveRowId", () => $c01bc7434e4fbf2a$export$4fad04245eebe683);
$parcel$export(module.exports, "isActiveRowItem", () => $c01bc7434e4fbf2a$export$9b16a7f2e1834f77);
$parcel$export(module.exports, "getSetFocusOnRow", () => $c01bc7434e4fbf2a$export$cff73bbfaa0526d1);
$parcel$export(module.exports, "isCellActive", () => $c01bc7434e4fbf2a$export$c14f48cad4f0ee46);
$parcel$export(module.exports, "shouldRowHydrateFully", () => $c01bc7434e4fbf2a$export$9b148117f6b512ea);

var $ahm5r = parcelRequire("ahm5r");

var $iOMo4 = parcelRequire("iOMo4");

var $8nFYk = parcelRequire("8nFYk");



var $2Ctxl = parcelRequire("2Ctxl");

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $atQRE = parcelRequire("atQRE");

var $02dWc = parcelRequire("02dWc");
const $c01bc7434e4fbf2a$export$d9790c6d67ace138 = (state, rowId)=>{
    const rowDepthAndPath = (0, $kcVGc.getStaticRowPathAndDepth)(state);
    if ((0, $kcVGc.isRowBeingAdded)(state, rowId)) {
        // @ts-expect-error - TS2339 - Property 'anchorId' does not exist on type 'Optional<TemporaryAddedRow>'. | TS2339 - Property 'position' does not exist on type 'Optional<TemporaryAddedRow>'.
        const { anchorId: anchorId, position: position } = (0, $kcVGc.getTemporaryAddedRow)(state);
        if (anchorId) return position === 'INSIDE' ? rowDepthAndPath[anchorId].depth + 1 : rowDepthAndPath[anchorId].depth;
        /* FIRST or LAST rows will be designated to the highest level */ return 0;
    }
    if (rowDepthAndPath[rowId] === undefined) return 0;
    return rowDepthAndPath[rowId].depth;
};
const $c01bc7434e4fbf2a$export$79bc68636023e019 = (0, $ahm5r.createSelector)((0, $02dWc.getFlattenedWithAddedRowIds), (0, $kcVGc.getRowsConfiguration), (visibleRowIds, rowsConfiguration)=>visibleRowIds.filter((rowId)=>{
        const rowConfiguration = rowsConfiguration[rowId];
        if (!rowConfiguration) return false;
        return rowConfiguration.isLoading;
    }));
const $c01bc7434e4fbf2a$export$f1f55f40e2397801 = (state)=>(0, $5wAOx.getRowAddCallback)(state) !== undefined && (0, $kcVGc.getAddLinkCaption)(state) !== undefined && !(0, $kcVGc.isAnyRowBeingAdded)(state);
const $c01bc7434e4fbf2a$export$53bdd4654b396c67 = (0, $ahm5r.createSelector)((0, $5wAOx.getRowAddCallback), (0, $kcVGc.isAnyRowBeingAdded), (0, $atQRE.getDraggingRowId), (rowAddCallback, rowBeingAdded, draggingRowId)=>rowAddCallback !== undefined && !rowBeingAdded && !draggingRowId);
const $c01bc7434e4fbf2a$export$ffaca24172efb7ca = (0, $ahm5r.createSelector)((0, $atQRE.getActiveSortedColumnConfiguration), (0, $2Ctxl.getDefaultComparator), (0, $kcVGc.isAnyRowBeingAdded), (activeSortedColumnConfiguration, defaultComparator, anyRowBeingAdded)=>{
    if (anyRowBeingAdded) return false;
    // If we are sorted by something, it's still ok IF it would match the default sort order
    return !activeSortedColumnConfiguration || typeof defaultComparator === 'string' && activeSortedColumnConfiguration.columnId === defaultComparator && activeSortedColumnConfiguration.sortOrder === (0, $53724ea925cf4e57$export$6e386ac144cffab5);
});
const $c01bc7434e4fbf2a$export$4835fe21099e222d = (state)=>state.consumer.draggableRows;
const $c01bc7434e4fbf2a$var$isDraggablePerRow = (0, $ahm5r.createSelector)((0, $kcVGc.getRowTree), (0, $kcVGc.getRowsConfiguration), (rowTree, rowsConfiguration)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isDraggableHash = {};
    Object.keys(rowTree.rows).forEach((rowId)=>{
        const rowConfiguration = rowsConfiguration[rowId];
        if (rowConfiguration) // if it is configured on a per-row basis
        isDraggableHash[rowId] = rowConfiguration.isDraggable !== undefined ? rowConfiguration.isDraggable : true;
        else // if the callback is implemented, and it has not been
        // configured, default to allow dragging
        isDraggableHash[rowId] = true;
    });
    return isDraggableHash;
});
const $c01bc7434e4fbf2a$export$f04970757ee58393 = (state, rowId)=>$c01bc7434e4fbf2a$export$4835fe21099e222d(state) && $c01bc7434e4fbf2a$var$isDraggablePerRow(state)[rowId];
const $c01bc7434e4fbf2a$export$7c458dc02abd8dc7 = (state)=>{
    const rowIds = (0, $02dWc.getFlattenedWithAddedRowIds)(state);
    const lastRowId = rowIds[rowIds.length - 1];
    const lastRowConfig = (0, $kcVGc.getRowsConfiguration)(state)[lastRowId];
    if (lastRowConfig) return (0, $kcVGc.getRowCanAddSibling)(state, lastRowId) || (0, $kcVGc.getRowCanAddChildren)(state, lastRowId);
    return false;
};
const $c01bc7434e4fbf2a$export$81ff4c821ba5ba90 = (0, $ahm5r.createSelector)((0, $atQRE.getTableHeight), (0, $02dWc.getVisibleRowsCount), (0, $5wAOx.isAutoHeight), $c01bc7434e4fbf2a$export$f1f55f40e2397801, (0, $kcVGc.getAbsoluteRowHeight), $c01bc7434e4fbf2a$export$7c458dc02abd8dc7, (0, $kcVGc.getAddBarOverflow), (0, $atQRE.getHeaderHeight), (tableHeightInternal, visibleRowsCount, autoHeight, addLinkShown, absoluteRowHeight, hasAddBar, addBarOverflow, headerHeight)=>{
    if (autoHeight) {
        const rowMultiplier = visibleRowsCount + (addLinkShown ? 1 : 0);
        return rowMultiplier * absoluteRowHeight + (hasAddBar || addLinkShown ? addBarOverflow : 0) + headerHeight;
    }
    return tableHeightInternal;
});
const $c01bc7434e4fbf2a$export$bf1a6d4805ae1aa3 = (0, $ahm5r.createSelector)((0, $5wAOx.isDetailsPanelOpen), (0, $2Ctxl.getVisibleCoreColumnsWidth), (0, $atQRE.getTableWidth), (isDetailsOpen, visibleCoreColumnWidth, tableWidth)=>isDetailsOpen ? visibleCoreColumnWidth : tableWidth);
const $c01bc7434e4fbf2a$export$6d30ea7d886d20a8 = (state)=>Math.max(0, $c01bc7434e4fbf2a$export$81ff4c821ba5ba90(state) - (0, $atQRE.getHeaderHeight)(state));
const $c01bc7434e4fbf2a$export$508de1ea1f8be016 = (0, $ahm5r.createSelector)((0, $02dWc.getVisibleRowsCount), (0, $kcVGc.getAbsoluteRowHeight), $c01bc7434e4fbf2a$export$7c458dc02abd8dc7, $c01bc7434e4fbf2a$export$f1f55f40e2397801, (0, $kcVGc.getAddBarOverflow), (visibleRowsCount, absoluteRowHeight, hasAddBar, addLinkShown, addBarOverflow)=>visibleRowsCount * absoluteRowHeight + (hasAddBar || addLinkShown ? addBarOverflow : 0));
const $c01bc7434e4fbf2a$export$59e4df7bc874f4dc = (state)=>(0, $atQRE.getTableWidth)(state) - (0, $2Ctxl.getVisibleCoreColumnsWidth)(state);
const $c01bc7434e4fbf2a$export$99ecae6d98dc3df3 = (0, $ahm5r.createSelector)((0, $5wAOx.getTotalDynamicColumnMinWidth), (0, $5wAOx.getTotalDynamicColumnMaxWidth), (0, $2Ctxl.getColumnTree), (0, $atQRE.getTableWidthWithoutScrollbarOffset), (0, $atQRE.getTableRowMargin), (0, $5wAOx.getVisibleColumnIds), (0, $2Ctxl.getColumnWidths), (totalDynamicMinWidth, totalDynamicMaxWidth, columnTree, tableWidth, _rowMargin, visibleColumnIds)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    const totalStaticColumnWidth = 0;
    const distributableWidth = tableWidth - totalStaticColumnWidth;
    visibleColumnIds.forEach((columnId)=>{
        if (columnTree.columns[columnId] === undefined) return;
        if (totalDynamicMaxWidth <= distributableWidth) // Plenty of space; consume as much as possible
        result[columnId] = columnTree.columns[columnId].maxWidth;
        else if (totalDynamicMinWidth >= distributableWidth) // Less space than required; consume as little as possible
        result[columnId] = columnTree.columns[columnId].minWidth;
        else {
            // Between min & max; distribute remaining space based on relative min widths.
            const { minWidth: minWidth } = columnTree.columns[columnId];
            const { maxWidth: maxWidth } = columnTree.columns[columnId];
            const scalingFactor = (maxWidth - minWidth) / (totalDynamicMaxWidth - totalDynamicMinWidth);
            result[columnId] = Math.min(maxWidth, minWidth + scalingFactor * (distributableWidth - totalDynamicMinWidth));
        }
    });
    return result;
});
const $c01bc7434e4fbf2a$export$c9dd4bee4ae86f53 = (0, $ahm5r.createSelector)((0, $2Ctxl.getColumnTree), (_, p)=>p, (columnTree, columnId)=>{
    return columnTree.columns[columnId];
});
const $c01bc7434e4fbf2a$export$dfa11a34ceba822 = (state, columnId)=>$c01bc7434e4fbf2a$export$99ecae6d98dc3df3(state)[columnId];
const $c01bc7434e4fbf2a$export$96b57a8283901306 = (state)=>Math.round(Object.values($c01bc7434e4fbf2a$export$99ecae6d98dc3df3(state)).reduce((sum, width)=>sum + width, 0));
const $c01bc7434e4fbf2a$export$354f0f01a9ec3ab0 = (0, $ahm5r.createSelector)((0, $02dWc.getFlattenedWithAddedRowIds), (0, $kcVGc.getRowHeightMapping), (0, $kcVGc.getAbsoluteRowHeight), (visibleRowIds, rowHeightMapping, approximateRowHeight)=>{
    if (visibleRowIds.length === 0) return [];
    // We map heights to _start_ positions of the rows, hence starting
    // with "[0]" and deleting the last. We deliberately exclude the last
    // row.
    const rowPositions = [
        0
    ];
    for(let i = 0; i < visibleRowIds.length - 1; i += 1){
        const lastHeight = rowPositions[rowPositions.length - 1];
        const nextHeight = lastHeight + (rowHeightMapping[visibleRowIds[i]] || approximateRowHeight);
        rowPositions.push(nextHeight);
    }
    return rowPositions;
});
const $c01bc7434e4fbf2a$export$7f5dc96b25afd50 = (0, $ahm5r.createSelector)($c01bc7434e4fbf2a$export$354f0f01a9ec3ab0, // @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type. | TS7006 - Parameter 'rowIndex' implicitly has an 'any' type.
(_, rowIndex)=>rowIndex, (rowPositionArray, rowIndex)=>{
    if (rowIndex < 0) return 0;
    if (rowIndex >= rowPositionArray.length) return rowPositionArray[rowPositionArray.length - 1];
    return rowPositionArray[rowIndex];
});
const $c01bc7434e4fbf2a$export$e04c926b10911ac2 = (0, $ahm5r.createSelector)($c01bc7434e4fbf2a$export$354f0f01a9ec3ab0, $c01bc7434e4fbf2a$export$6d30ea7d886d20a8, (0, $kcVGc.getRowHeightMapping), (0, $02dWc.getFlattenedWithAddedRowIds), (rowPositionArray, tableHeight, rowHeightMapping, visibleRowIds)=>{
    const lastRowStartPosition = rowPositionArray[rowPositionArray.length - 1];
    const lastRowHeight = rowHeightMapping[visibleRowIds[visibleRowIds.length - 1]];
    return lastRowStartPosition + lastRowHeight - tableHeight;
});
const $c01bc7434e4fbf2a$export$35f00941c70ac98c = (0, $ahm5r.createSelector)($c01bc7434e4fbf2a$export$96b57a8283901306, (0, $atQRE.getTableWidthWithoutScrollbarOffset), (allColumnWidth, tableWidth)=>allColumnWidth > tableWidth);
const $c01bc7434e4fbf2a$export$5ce15b832a232abf = (state)=>$c01bc7434e4fbf2a$export$e04c926b10911ac2(state) > 0;
const $c01bc7434e4fbf2a$export$482d647122d9850d = (0, $ahm5r.createSelector)((0, $5wAOx.isDetailsPanelOpen), (0, $atQRE.getHorizontalScrollOffset), (isDetailsOpen, horizontalScrollOffset)=>!isDetailsOpen && horizontalScrollOffset > 0);
const $c01bc7434e4fbf2a$export$9854f9aebd7abc1c = (0, $ahm5r.createSelector)($c01bc7434e4fbf2a$export$96b57a8283901306, (0, $atQRE.getTableWidthWithoutScrollbarOffset), (allColumnWidth, tableWidth)=>allColumnWidth - tableWidth);
const $c01bc7434e4fbf2a$export$a5fd1dde37333151 = (0, $ahm5r.createSelector)((0, $5wAOx.isDetailsPanelOpen), (0, $atQRE.getHorizontalScrollOffset), $c01bc7434e4fbf2a$export$9854f9aebd7abc1c, (isDetailsOpen, horizontalScrollOffset, maxHorizontalScrollOffset)=>!isDetailsOpen && horizontalScrollOffset < maxHorizontalScrollOffset);
const $c01bc7434e4fbf2a$export$c17b791581a1b518 = (0, $ahm5r.createSelector)((0, $5wAOx.getVisibleAdditionalColumnIds), $c01bc7434e4fbf2a$export$99ecae6d98dc3df3, (additionalColumns, columnWidthHash)=>additionalColumns.reduce((acc, columnId)=>acc + columnWidthHash[columnId], 0));
const $c01bc7434e4fbf2a$export$a4a1496398ad37a = (distance)=>Math.max(0, Math.floor(distance));
const $c01bc7434e4fbf2a$export$8d5a56e5651cf107 = (state)=>$c01bc7434e4fbf2a$export$a4a1496398ad37a($c01bc7434e4fbf2a$export$e04c926b10911ac2(state) - (0, $atQRE.getVerticalScrollOffset)(state));
const $c01bc7434e4fbf2a$export$302e8799c65ec80 = (state)=>$c01bc7434e4fbf2a$export$a4a1496398ad37a((0, $atQRE.getVerticalScrollOffset)(state));
const $c01bc7434e4fbf2a$export$be46d880d5c67a2f = (state)=>$c01bc7434e4fbf2a$export$a4a1496398ad37a((0, $atQRE.getHorizontalScrollOffset)(state));
const $c01bc7434e4fbf2a$export$cdbbb229c03c4259 = (state)=>$c01bc7434e4fbf2a$export$a4a1496398ad37a($c01bc7434e4fbf2a$export$9854f9aebd7abc1c(state) - (0, $atQRE.getHorizontalScrollOffset)(state));
const $c01bc7434e4fbf2a$var$getSortOrderForColumns = (0, $ahm5r.createSelector)((0, $2Ctxl.getColumnTree), (0, $2Ctxl.getDefaultComparator), (0, $atQRE.getActiveSortedColumnConfiguration), (columnTree, defaultComparator, activeSortedColumnConfiguration)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const columnSortOrderHash = {};
    if (activeSortedColumnConfiguration === undefined) {
        /* When the default comparator is specified as a column id,
			 * rather than the function, we have to be explicit since
			 * sorting behaviour differs. In this case, if not actively
			 * sorting by anything, we are actively sorting by the default
			 * column (compared to passively).
			 */ if (typeof defaultComparator === 'string') columnSortOrderHash[defaultComparator] = (0, $53724ea925cf4e57$export$6e386ac144cffab5);
        return columnSortOrderHash;
    }
    Object.keys(columnTree.columns).forEach((columnId)=>{
        // need to check truthy-ness again since flow disregards check outside a function call
        if (activeSortedColumnConfiguration !== undefined && columnId === activeSortedColumnConfiguration.columnId) columnSortOrderHash[columnId] = activeSortedColumnConfiguration.sortOrder;
    });
    return columnSortOrderHash;
});
const $c01bc7434e4fbf2a$export$28e014ec3d91f1b2 = (state, columnId)=>$c01bc7434e4fbf2a$var$getSortOrderForColumns(state)[columnId];
const $c01bc7434e4fbf2a$var$DEFAULT_BOUNDARIES = {
    visibleStart: 0,
    visibleEnd: 0,
    displayStart: 0,
    displayEnd: 0
};
const $c01bc7434e4fbf2a$var$DEFAULT_BUFFER_SIZE = 5;
const $c01bc7434e4fbf2a$var$getVisibleRowIndexAtOffset = (rowPositions, offsetPosition)=>{
    if (rowPositions.length === 0) return 0;
    // sortedIndex for log(n) performance.
    const idx = (0, (/*@__PURE__*/$parcel$interopDefault($iOMo4)))(rowPositions, offsetPosition);
    // sortedIndex always returns the position after the equality. To make
    // this easier to reason about, we'll check whether the index prior starts
    // at exactly the offsetPosition, and return that instead if it does.
    if (rowPositions[idx] === offsetPosition) return idx;
    return idx - 1;
};
const $c01bc7434e4fbf2a$var$calculateVirtualBoundaries = (rowIds, scrollTop, contentHeight, rowPositionArray, shouldVirtualize, virtualBufferSize)=>{
    if (contentHeight === 0 || rowIds.length === 0) return $c01bc7434e4fbf2a$var$DEFAULT_BOUNDARIES;
    const numberOfTotalRows = rowIds.length - 1;
    const visibleStart = Math.max($c01bc7434e4fbf2a$var$getVisibleRowIndexAtOffset(rowPositionArray, scrollTop), 0);
    const visibleEnd = Math.min($c01bc7434e4fbf2a$var$getVisibleRowIndexAtOffset(rowPositionArray, scrollTop + contentHeight), numberOfTotalRows);
    const bufferSize = shouldVirtualize ? virtualBufferSize : numberOfTotalRows;
    // if the total number of rows is rather small (up to the provided threshold) then we render all, always.
    const displayStart = Math.max(0, visibleStart - bufferSize);
    const displayEnd = Math.min(visibleEnd + bufferSize, numberOfTotalRows);
    return {
        visibleStart: visibleStart,
        visibleEnd: visibleEnd,
        displayStart: displayStart,
        displayEnd: displayEnd
    };
};
const $c01bc7434e4fbf2a$export$75cdbb73a780df34 = (0, $ahm5r.createSelector)((0, $5wAOx.isTableFacade), (0, $02dWc.getFlattenedWithAddedRowIds), (0, $5wAOx.getShouldSkipVirtualization), (tableFacade, rowIds, shouldSkipVirtualization)=>{
    if (shouldSkipVirtualization ?? false) return false;
    return tableFacade || rowIds.length > (0, $8nFYk.minRowsForTreeTableVirtualisation);
});
const $c01bc7434e4fbf2a$export$3ddd5b9a27496e14 = (0, $ahm5r.createSelector)((0, $02dWc.getFlattenedWithAddedRowIds), (0, $atQRE.getVerticalScrollOffset), $c01bc7434e4fbf2a$export$6d30ea7d886d20a8, $c01bc7434e4fbf2a$export$354f0f01a9ec3ab0, $c01bc7434e4fbf2a$export$75cdbb73a780df34, (rowIds, scrollTop, contentHeight, rowPositionArray, shouldVirtualize)=>// render all rows when there are not more than minRowsForVirtualisation
    $c01bc7434e4fbf2a$var$calculateVirtualBoundaries(rowIds, scrollTop, contentHeight, rowPositionArray, shouldVirtualize, $c01bc7434e4fbf2a$var$DEFAULT_BUFFER_SIZE));
const $c01bc7434e4fbf2a$export$1e9cf27313ff3cdf = (0, $ahm5r.createSelector)((0, $02dWc.getFlattenedWithAddedRowIds), (0, $kcVGc.getRowsConfiguration), $c01bc7434e4fbf2a$export$3ddd5b9a27496e14, (visibleRowIds, rowsConfiguration, virtualBoundaries)=>{
    const { displayStart: displayStart, displayEnd: displayEnd } = virtualBoundaries;
    return visibleRowIds.slice(displayStart, displayEnd).filter((rowId)=>{
        const rowConfiguration = rowsConfiguration[rowId];
        if (!rowConfiguration) return false;
        return rowConfiguration.isLoading;
    });
});
const $c01bc7434e4fbf2a$export$15a684dfff6d5394 = (state)=>$c01bc7434e4fbf2a$export$1e9cf27313ff3cdf(state).length;
const $c01bc7434e4fbf2a$export$b455bac95fd02aad = (state)=>{
    const activeItem = (0, $atQRE.getActiveItem)(state);
    if (activeItem && activeItem.type === (0, $1d080e9e60c37b43$export$8a257aa81ef4a9e0)) return activeItem.rowIndex;
    if (activeItem && activeItem.type === (0, $1d080e9e60c37b43$export$4b3489234fd17200)) return (0, $02dWc.getVisibleIndexForRowId)(state, activeItem.rowId);
    return undefined;
};
const $c01bc7434e4fbf2a$export$7b06ecd71d436a71 = (state)=>{
    const currRow = $c01bc7434e4fbf2a$export$b455bac95fd02aad(state);
    if (currRow === undefined) return 0;
    const lastVisibleRow = (0, $02dWc.getVisibleRowsCount)(state) - 1;
    return Math.min(currRow + 1, lastVisibleRow);
};
const $c01bc7434e4fbf2a$export$c98fb65aaf1fa4f7 = (state)=>{
    const currRow = $c01bc7434e4fbf2a$export$b455bac95fd02aad(state);
    if (currRow === undefined) return 0;
    return Math.max(currRow - 1, 0);
};
const $c01bc7434e4fbf2a$export$7bf5553e96d8acb1 = (state, rowIndex)=>{
    const visibleRowIds = (0, $02dWc.getFlattenedWithAddedRowIds)(state);
    return rowIndex == null ? undefined : visibleRowIds[rowIndex];
};
const $c01bc7434e4fbf2a$export$f5e04ce1033f6b64 = (state)=>{
    const activeItem = (0, $atQRE.getActiveItem)(state);
    if (!activeItem) return undefined;
    switch(activeItem.type){
        case 0, $1d080e9e60c37b43$export$4b3489234fd17200:
            return activeItem.rowId;
        case 0, $1d080e9e60c37b43$export$8a257aa81ef4a9e0:
            {
                const { rowIndex: rowIndex } = activeItem;
                return $c01bc7434e4fbf2a$export$7bf5553e96d8acb1(state, rowIndex);
            }
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            activeItem;
            return undefined;
    }
};
const $c01bc7434e4fbf2a$export$4fad04245eebe683 = (state, rowId)=>$c01bc7434e4fbf2a$export$f5e04ce1033f6b64(state) === rowId;
const $c01bc7434e4fbf2a$export$9b16a7f2e1834f77 = (state, rowId)=>(0, $5wAOx.isInRowNavigationMode)(state) && $c01bc7434e4fbf2a$export$4fad04245eebe683(state, rowId);
const $c01bc7434e4fbf2a$export$cff73bbfaa0526d1 = (state, rowId)=>{
    const activeRow = (0, $atQRE.getActiveRow)(state);
    return !!activeRow && $c01bc7434e4fbf2a$export$4fad04245eebe683(state, rowId) && !!activeRow.setFocusOnRow;
};
const $c01bc7434e4fbf2a$export$c14f48cad4f0ee46 = (state, rowId, columnId)=>{
    const activeItem = (0, $atQRE.getActiveCell)(state);
    return !!activeItem && activeItem.rowId === rowId && activeItem.columnId === columnId;
};
const $c01bc7434e4fbf2a$export$eca20d464f1d2890 = (0, $ahm5r.createSelector)((0, $02dWc.getFlattenedWithAddedRowIds), $c01bc7434e4fbf2a$export$b455bac95fd02aad, (visibleRowIds, activeRowIndex)=>{
    if (activeRowIndex === undefined || activeRowIndex >= visibleRowIds.length) return [];
    return [
        ...Array(3).keys()
    ].map((adjacencyIndex)=>activeRowIndex + adjacencyIndex - 1).filter((rowIndex)=>rowIndex >= 0 && rowIndex < visibleRowIds.length).map((idx)=>visibleRowIds[idx]);
});
const $c01bc7434e4fbf2a$export$e333218078e16c44 = (state, rowId)=>(0, $02dWc.getFlattenedWithAddedRowIds)(state)[0] === rowId;
const $c01bc7434e4fbf2a$export$9b148117f6b512ea = (0, $ahm5r.createSelector)($c01bc7434e4fbf2a$export$eca20d464f1d2890, $c01bc7434e4fbf2a$export$e333218078e16c44, (_, rowId)=>rowId, (activeAndAdjacentRowIds, firstRow, rowId)=>activeAndAdjacentRowIds.length === 0 && firstRow || activeAndAdjacentRowIds.some((activeOrAdjacentRowId)=>activeOrAdjacentRowId === rowId));

});
parcelRegister("iOMo4", function(module, exports) {

var $YDb3M = parcelRequire("YDb3M");
/**
 * Uses a binary search to determine the lowest index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedIndex([30, 50], 40);
 * // => 1
 */ function $db326e306f94da54$var$sortedIndex(array, value) {
    return $YDb3M(array, value);
}
module.exports = $db326e306f94da54$var$sortedIndex;

});
parcelRegister("YDb3M", function(module, exports) {

var $lmvZU = parcelRequire("lmvZU");

var $d7YnM = parcelRequire("d7YnM");

var $9D78T = parcelRequire("9D78T");
/** Used as references for the maximum length and index of an array. */ var $0b63fe8641a5099c$var$MAX_ARRAY_LENGTH = 4294967295, $0b63fe8641a5099c$var$HALF_MAX_ARRAY_LENGTH = $0b63fe8641a5099c$var$MAX_ARRAY_LENGTH >>> 1;
/**
 * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
 * performs a binary search of `array` to determine the index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */ function $0b63fe8641a5099c$var$baseSortedIndex(array, value, retHighest) {
    var low = 0, high = array == null ? low : array.length;
    if (typeof value == 'number' && value === value && high <= $0b63fe8641a5099c$var$HALF_MAX_ARRAY_LENGTH) {
        while(low < high){
            var mid = low + high >>> 1, computed = array[mid];
            if (computed !== null && !$9D78T(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
            else high = mid;
        }
        return high;
    }
    return $lmvZU(array, value, $d7YnM, retHighest);
}
module.exports = $0b63fe8641a5099c$var$baseSortedIndex;

});
parcelRegister("lmvZU", function(module, exports) {

var $9D78T = parcelRequire("9D78T");
/** Used as references for the maximum length and index of an array. */ var $f8d47913e74e2f18$var$MAX_ARRAY_LENGTH = 4294967295, $f8d47913e74e2f18$var$MAX_ARRAY_INDEX = $f8d47913e74e2f18$var$MAX_ARRAY_LENGTH - 1;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f8d47913e74e2f18$var$nativeFloor = Math.floor, $f8d47913e74e2f18$var$nativeMin = Math.min;
/**
 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
 * which invokes `iteratee` for `value` and each element of `array` to compute
 * their sort ranking. The iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The iteratee invoked per element.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */ function $f8d47913e74e2f18$var$baseSortedIndexBy(array, value, iteratee, retHighest) {
    var low = 0, high = array == null ? 0 : array.length;
    if (high === 0) return 0;
    value = iteratee(value);
    var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = $9D78T(value), valIsUndefined = value === undefined;
    while(low < high){
        var mid = $f8d47913e74e2f18$var$nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = $9D78T(computed);
        if (valIsNaN) var setLow = retHighest || othIsReflexive;
        else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
        else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        else if (othIsNull || othIsSymbol) setLow = false;
        else setLow = retHighest ? computed <= value : computed < value;
        if (setLow) low = mid + 1;
        else high = mid;
    }
    return $f8d47913e74e2f18$var$nativeMin(high, $f8d47913e74e2f18$var$MAX_ARRAY_INDEX);
}
module.exports = $f8d47913e74e2f18$var$baseSortedIndexBy;

});



parcelRegister("8nFYk", function(module, exports) {

$parcel$export(module.exports, "minRowsForTreeTableVirtualisation", () => $357a7f0659f0495f$export$3c21ff0ba5a7aae2);
$parcel$export(module.exports, "childrenOperationIndicatorWidth", () => $357a7f0659f0495f$export$3f2e7d270d9c828e);
$parcel$export(module.exports, "levelIndentBaseline", () => $357a7f0659f0495f$export$8831b0de9d6cd1e0);
$parcel$export(module.exports, "addBarCircleSize", () => $357a7f0659f0495f$export$3d6f348975bc66c6);
$parcel$export(module.exports, "akButtonHeight", () => $357a7f0659f0495f$export$21cb66b1f2cfe05b);
$parcel$export(module.exports, "scrollbarWidth", () => $357a7f0659f0495f$export$14c8a45ff6da16d);
// ROW BODY
const $357a7f0659f0495f$export$3c21ff0ba5a7aae2 = 100;
const $357a7f0659f0495f$export$3f2e7d270d9c828e = 24;
const $357a7f0659f0495f$export$66910203ed6bdbb = 8;
const $357a7f0659f0495f$export$a659c25736116809 = 3;
const $357a7f0659f0495f$export$8831b0de9d6cd1e0 = $357a7f0659f0495f$export$a659c25736116809 + $357a7f0659f0495f$export$3f2e7d270d9c828e;
const $357a7f0659f0495f$export$75e30597b152d012 = $357a7f0659f0495f$export$a659c25736116809 + $357a7f0659f0495f$export$66910203ed6bdbb;
const $357a7f0659f0495f$export$1380a626586d9aba = 12;
const $357a7f0659f0495f$export$9aeb22ae511a8bf4 = 5;
const $357a7f0659f0495f$export$3d6f348975bc66c6 = 24;
const $357a7f0659f0495f$export$21cb66b1f2cfe05b = 32;
const $357a7f0659f0495f$export$15a53da47f8d8b84 = 8;
const $357a7f0659f0495f$export$14c8a45ff6da16d = 5;

});

const $53724ea925cf4e57$export$4670af9f718b9e66 = 'DYNAMIC_RESIZE';
const $53724ea925cf4e57$export$3920b9c14da1301c = 'DRAGGABLE_RESIZE';
const $53724ea925cf4e57$export$913055729e1380b2 = 'summary';
const $53724ea925cf4e57$export$6e386ac144cffab5 = 'ASCENDING';
const $53724ea925cf4e57$export$f634ff5a7f1c8f3 = 'DESCENDING';

parcelRegister("kcVGc", function(module, exports) {

$parcel$export(module.exports, "getRowTree", () => $496103bb2fcba42e$export$51f19bc561029712);
$parcel$export(module.exports, "getRowsConfiguration", () => $496103bb2fcba42e$export$7afbda1c447dab73);
$parcel$export(module.exports, "getAddedRows", () => $496103bb2fcba42e$export$b65d941a4f06833c);
$parcel$export(module.exports, "getMaxDepth", () => $496103bb2fcba42e$export$dc00159d5f925dca);
$parcel$export(module.exports, "getAddLinkCaption", () => $496103bb2fcba42e$export$b08f0f9a8b4bbfe8);
$parcel$export(module.exports, "getExpandedRowIdsHash", () => $496103bb2fcba42e$export$5874281f3f9f8f1f);
$parcel$export(module.exports, "isRowExpanded", () => $496103bb2fcba42e$export$22559e97b2ec8b6);
$parcel$export(module.exports, "getTemporaryAddedRow", () => $496103bb2fcba42e$export$692ae8ed13990af6);
$parcel$export(module.exports, "isAnyRowBeingAdded", () => $496103bb2fcba42e$export$53a366bd49d883e9);
$parcel$export(module.exports, "isRowBeingAdded", () => $496103bb2fcba42e$export$a59b29339b2950b1);
$parcel$export(module.exports, "getRowAddingStatus", () => $496103bb2fcba42e$export$4be3de2f99f7bcb7);
$parcel$export(module.exports, "getRowHasChildren", () => $496103bb2fcba42e$export$bac1675af7abd620);
$parcel$export(module.exports, "getRow", () => $496103bb2fcba42e$export$42035f545ecd5428);
$parcel$export(module.exports, "getDefaultRowHeight", () => $496103bb2fcba42e$export$d44a80f12163dfc8);
$parcel$export(module.exports, "getRowHeightMapping", () => $496103bb2fcba42e$export$86d23b7fefef4879);
$parcel$export(module.exports, "getAbsoluteRowHeight", () => $496103bb2fcba42e$export$d58c78cd12373bd6);
$parcel$export(module.exports, "getRowHeight", () => $496103bb2fcba42e$export$69b171017bdea2b4);
$parcel$export(module.exports, "isAutoRowHeight", () => $496103bb2fcba42e$export$736c13cc18282c63);
$parcel$export(module.exports, "getStaticRowPathAndDepth", () => $496103bb2fcba42e$export$d3cd1bd0d2f257ec);
$parcel$export(module.exports, "getRowAddPosition", () => $496103bb2fcba42e$export$d1680008a2c9c92a);
$parcel$export(module.exports, "getAddBarOverflow", () => $496103bb2fcba42e$export$89d1c0cf2787df2d);
$parcel$export(module.exports, "isRowLoading", () => $496103bb2fcba42e$export$a15c7e972e303897);
$parcel$export(module.exports, "getRowCanAddChildren", () => $496103bb2fcba42e$export$da03f1b8699c006f);
$parcel$export(module.exports, "getRowCanAddSibling", () => $496103bb2fcba42e$export$622bee8dc98ce142);
$parcel$export(module.exports, "isRowSelected", () => $496103bb2fcba42e$export$710e11cf672b86c);

var $ahm5r = parcelRequire("ahm5r");

var $4sCoA = parcelRequire("4sCoA");

var $8nFYk = parcelRequire("8nFYk");

var $60q4r = parcelRequire("60q4r");

var $beufL = parcelRequire("beufL");
const $496103bb2fcba42e$export$51f19bc561029712 = (state)=>state.consumer.rowTree;
const $496103bb2fcba42e$export$7afbda1c447dab73 = (state)=>state.consumer.rowsConfiguration;
const $496103bb2fcba42e$export$b65d941a4f06833c = (state)=>state.consumer.addedRows;
const $496103bb2fcba42e$export$dc00159d5f925dca = (state)=>state.consumer.maxDepth;
const $496103bb2fcba42e$export$b08f0f9a8b4bbfe8 = (state)=>state.consumer.addLinkCaption;
const $496103bb2fcba42e$export$f7d97a6a8ca8eb30 = (state)=>state.consumer.expandedRowIds;
const $496103bb2fcba42e$export$5874281f3f9f8f1f = (0, $ahm5r.createSelector)($496103bb2fcba42e$export$f7d97a6a8ca8eb30, (expandedRowIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    expandedRowIds.reduce((acc, next)=>{
        // for effeciency sake we are mutating the accumulator to build up our hash
        acc[next] = true;
        return acc;
    }, {}));
const $496103bb2fcba42e$export$22559e97b2ec8b6 = (state, rowId)=>!!$496103bb2fcba42e$export$5874281f3f9f8f1f(state)[rowId];
const $496103bb2fcba42e$export$692ae8ed13990af6 = (state)=>state.consumer.addedRows !== undefined ? state.consumer.addedRows.temporary : undefined;
const $496103bb2fcba42e$export$16d7466356aaf65d = (state)=>state.consumer.addedRows !== undefined ? state.consumer.addedRows.persisted : undefined;
const $496103bb2fcba42e$export$53a366bd49d883e9 = (state)=>$496103bb2fcba42e$export$692ae8ed13990af6(state) !== undefined;
const $496103bb2fcba42e$export$a59b29339b2950b1 = (state, rowId)=>{
    const temporaryAddedRow = $496103bb2fcba42e$export$692ae8ed13990af6(state);
    return temporaryAddedRow !== undefined && temporaryAddedRow.temporaryId === rowId;
};
const $496103bb2fcba42e$export$4be3de2f99f7bcb7 = (state, rowId)=>{
    const addedRows = $496103bb2fcba42e$export$b65d941a4f06833c(state);
    if (addedRows !== undefined) {
        if (!!addedRows.temporary && addedRows.temporary.temporaryId === rowId) return addedRows.temporary.isPersisting ? 'PERSISTING' : 'NEW';
        if (!!addedRows.persisted && addedRows.persisted[rowId]) return 'PERSISTED';
    }
    return undefined;
};
const $496103bb2fcba42e$export$ab5d39c3fc4e75a3 = (state, rowId)=>$496103bb2fcba42e$export$51f19bc561029712(state).rows[rowId].parentId;
const $496103bb2fcba42e$export$bac1675af7abd620 = (state, rowId)=>{
    // a temp child will not be included in the row tree children - need to check both.
    const temporaryAddedRow = $496103bb2fcba42e$export$692ae8ed13990af6(state);
    const row = $496103bb2fcba42e$export$51f19bc561029712(state).rows[rowId];
    return row && row.childrenIds.length > 0 || temporaryAddedRow !== undefined && temporaryAddedRow.anchorId === rowId && temporaryAddedRow.position === 'INSIDE';
};
const $496103bb2fcba42e$export$42035f545ecd5428 = (state, rowId)=>$496103bb2fcba42e$export$51f19bc561029712(state).rows[rowId];
const $496103bb2fcba42e$export$d44a80f12163dfc8 = (state)=>state.consumer.rowHeight;
const $496103bb2fcba42e$var$getRowBorderWidth = (state)=>state.internal.rowBorderWidth;
const $496103bb2fcba42e$export$86d23b7fefef4879 = (state)=>state.internal.rowHeightMapping;
const $496103bb2fcba42e$export$e61f0a8029f642f4 = (0, $ahm5r.createSelector)($496103bb2fcba42e$export$86d23b7fefef4879, $496103bb2fcba42e$export$d44a80f12163dfc8, (rowHeightMapping, defaultRowHeight)=>{
    const vals = Object.values(rowHeightMapping).sort();
    const medianIdx = Math.floor(vals.length / 2);
    return vals[medianIdx] || defaultRowHeight;
});
const $496103bb2fcba42e$export$d58c78cd12373bd6 = (state)=>Math.max(0, ($496103bb2fcba42e$export$e61f0a8029f642f4(state) || $496103bb2fcba42e$export$d44a80f12163dfc8(state)) - $496103bb2fcba42e$var$getRowBorderWidth(state));
const $496103bb2fcba42e$export$69b171017bdea2b4 = (state, rowId)=>{
    const knownRowHeight = $496103bb2fcba42e$export$86d23b7fefef4879(state)[rowId];
    if (knownRowHeight) return Math.max(0, knownRowHeight);
    return $496103bb2fcba42e$export$d58c78cd12373bd6(state);
};
const $496103bb2fcba42e$export$736c13cc18282c63 = (state)=>state.consumer.autoRowHeight;
const $496103bb2fcba42e$export$d3cd1bd0d2f257ec = (0, $ahm5r.createSelector)($496103bb2fcba42e$export$51f19bc561029712, (rowTree)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rowPathAndDepthHash = {};
    Object.keys(rowTree.rows).forEach((rowId)=>{
        const depth = (0, $60q4r.default)(rowTree.rows, rowId);
        const path = (0, $beufL.default)(rowTree.rows, rowId);
        rowPathAndDepthHash[rowId] = {
            depth: depth,
            path: path
        };
    });
    return rowPathAndDepthHash;
});
const $496103bb2fcba42e$export$829a6e4495ba9529 = (0, $ahm5r.createSelector)($496103bb2fcba42e$export$51f19bc561029712, (rowTree)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rowDepthHash = {};
    Object.keys(rowTree.rows).forEach((rowId)=>{
        const depth = (0, $60q4r.default)(rowTree.rows, rowId);
        rowDepthHash[rowId] = {
            depth: depth
        };
    });
    return rowDepthHash;
});
const $496103bb2fcba42e$export$ecd30898c6a65cf4 = (0, $ahm5r.createSelector)($496103bb2fcba42e$export$51f19bc561029712, (rowTree)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rowPathHash = {};
    Object.keys(rowTree.rows).forEach((rowId)=>{
        const path = (0, $beufL.default)(rowTree.rows, rowId);
        rowPathHash[rowId] = {
            path: path
        };
    });
    return rowPathHash;
});
const $496103bb2fcba42e$export$e57b56ebfdae922b = (0, $ahm5r.createSelector)($496103bb2fcba42e$export$dc00159d5f925dca, $496103bb2fcba42e$export$f7d97a6a8ca8eb30, (maxDepth, expandedRowIds)=>({
        maxDepth: maxDepth,
        expandedRowIds: expandedRowIds
    }));
const $496103bb2fcba42e$export$d1680008a2c9c92a = (0, $4sCoA.createWeakMapSelector)($496103bb2fcba42e$export$42035f545ecd5428, $496103bb2fcba42e$export$829a6e4495ba9529, $496103bb2fcba42e$export$e57b56ebfdae922b, // @ts-expect-error - TS7006 - Parameter 'row' implicitly has an 'any' type. | TS7006 - Parameter 'rowDepth' implicitly has an 'any' type. | TS7031 - Binding element 'maxDepth' implicitly has an 'any' type. | TS7031 - Binding element 'expandedRowIds' implicitly has an 'any' type.
(row, rowDepth, { maxDepth: maxDepth, expandedRowIds: expandedRowIds })=>{
    if (row === undefined) throw new Error('row must not be undefined');
    const rowId = row.id;
    const currentRowDepth = rowDepth[rowId].depth;
    // if a row can have children and is expanded, add a child
    // if a row can have children but is collapsed, add a sibling
    if (currentRowDepth < maxDepth) {
        if (expandedRowIds.indexOf(rowId) !== -1) return 'INSIDE';
        return 'AFTER';
    }
    // otherwise it is a child row, add a sibling
    return 'AFTER';
});
const $496103bb2fcba42e$export$89d1c0cf2787df2d = (state)=>((0, $8nFYk.addBarCircleSize) - $496103bb2fcba42e$var$getRowBorderWidth(state)) / 2;
const $496103bb2fcba42e$export$f9af5c27d326c0d1 = (state, rowId)=>{
    const rowConfiguration = $496103bb2fcba42e$export$7afbda1c447dab73(state)[rowId];
    return rowConfiguration ? rowConfiguration.dragIndicatorColor : undefined;
};
const $496103bb2fcba42e$export$a15c7e972e303897 = (state, rowId)=>{
    const rowConfiguration = $496103bb2fcba42e$export$7afbda1c447dab73(state)[rowId];
    if (rowConfiguration) return rowConfiguration.isLoading || false;
    return false;
};
const $496103bb2fcba42e$export$da03f1b8699c006f = (state, rowId)=>{
    const rowConfiguration = $496103bb2fcba42e$export$7afbda1c447dab73(state)[rowId];
    if (rowConfiguration) return rowConfiguration.canAddChildren !== undefined ? rowConfiguration.canAddChildren : true;
    return true;
};
const $496103bb2fcba42e$export$622bee8dc98ce142 = (state, rowId)=>{
    const rowConfiguration = $496103bb2fcba42e$export$7afbda1c447dab73(state)[rowId];
    if (rowConfiguration) return rowConfiguration.canAddSibling !== undefined ? rowConfiguration.canAddSibling : true;
    return true;
};
const $496103bb2fcba42e$export$710e11cf672b86c = (state, rowId)=>{
    const rowConfiguration = $496103bb2fcba42e$export$7afbda1c447dab73(state)[rowId];
    if (rowConfiguration) return rowConfiguration.isSelected || false;
    return false;
};

});
parcelRegister("4sCoA", function(module, exports) {

$parcel$export(module.exports, "createWeakMapSelector", () => $c59b2cf83707a8dc$export$3a90d1d234e724b5);
$parcel$export(module.exports, "createSelector", () => $c59b2cf83707a8dc$export$595d22ed68ca2841);
// @ts-expect-error - TS2305 - Module '"reselect"' has no exported member 'SelectorCreator'.

var $ahm5r = parcelRequire("ahm5r");

var $8rRgI = parcelRequire("8rRgI");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c59b2cf83707a8dc$var$weakMapMemoize = (func)=>{
    const memorizer = (0, $8rRgI.createMemorizer)();
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    return (...args)=>{
        const cached = memorizer.read(args);
        if (cached !== undefined) return (0, $8rRgI.toReturnValue)(cached);
        const result = func.apply(func, args);
        memorizer.store(args, result);
        return result;
    };
};
const $c59b2cf83707a8dc$export$3a90d1d234e724b5 = (0, $ahm5r.createSelectorCreator)($c59b2cf83707a8dc$var$weakMapMemoize);
const $c59b2cf83707a8dc$export$595d22ed68ca2841 = (0, $ahm5r.createSelectorCreator)((0, $ahm5r.defaultMemoize));

});
parcelRegister("8rRgI", function(module, exports) {

$parcel$export(module.exports, "toReturnValue", () => $5a0e9edd8d520515$export$9f3707bed4fc53c8);
$parcel$export(module.exports, "createMemorizer", () => $5a0e9edd8d520515$export$9db09f4ba21f9d2a);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5a0e9edd8d520515$var$UNDEFINED = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5a0e9edd8d520515$var$NULL = {};
const $5a0e9edd8d520515$export$7abc386bcfed62e1 = (key)=>{
    if (key === undefined) return $5a0e9edd8d520515$var$UNDEFINED;
    if (key === null) return $5a0e9edd8d520515$var$NULL;
    return key;
};
const $5a0e9edd8d520515$export$9f3707bed4fc53c8 = (x)=>{
    if (x === $5a0e9edd8d520515$var$UNDEFINED) return undefined;
    if (x === $5a0e9edd8d520515$var$NULL) return null;
    return x;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5a0e9edd8d520515$var$getFromWeakMapChain = (args, index, map)=>{
    const element = map.get($5a0e9edd8d520515$export$7abc386bcfed62e1(args[index]));
    if (index < args.length - 1) {
        if (element) return $5a0e9edd8d520515$var$getFromWeakMapChain(args, index + 1, element);
        return undefined;
    }
    return element;
};
const $5a0e9edd8d520515$var$storeToEmptyWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const subMap = new WeakMap();
        map.set($5a0e9edd8d520515$export$7abc386bcfed62e1(args[index]), subMap);
        $5a0e9edd8d520515$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
    } else map.set($5a0e9edd8d520515$export$7abc386bcfed62e1(args[index]), result);
};
const $5a0e9edd8d520515$var$storeToWeakMapChain = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
args, index, // eslint-disable-next-line @typescript-eslint/no-explicit-any
map, // eslint-disable-next-line @typescript-eslint/no-explicit-any
result)=>{
    if (index < args.length - 1) {
        const element = map.get($5a0e9edd8d520515$export$7abc386bcfed62e1(args[index]));
        if (element) $5a0e9edd8d520515$var$storeToWeakMapChain(args, index + 1, element, result);
        else {
            const subMap = new WeakMap();
            map.set($5a0e9edd8d520515$export$7abc386bcfed62e1(args[index]), subMap);
            // we know that from now on, all chain elements need to be new maps,
            // so we move to a slightly more performent recursion
            $5a0e9edd8d520515$var$storeToEmptyWeakMapChain(args, index + 1, subMap, result);
        }
    } else map.set($5a0e9edd8d520515$export$7abc386bcfed62e1(args[index]), result);
};
const $5a0e9edd8d520515$export$9db09f4ba21f9d2a = ()=>{
    const weakMap = new WeakMap();
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        store: (args, result)=>result !== undefined ? $5a0e9edd8d520515$var$storeToWeakMapChain(args, 0, weakMap, result) : $5a0e9edd8d520515$var$storeToWeakMapChain(args, 0, weakMap, $5a0e9edd8d520515$var$UNDEFINED),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        read: (args)=>$5a0e9edd8d520515$var$getFromWeakMapChain(args, 0, weakMap)
    };
};

});



parcelRegister("02dWc", function(module, exports) {

$parcel$export(module.exports, "getFlattenedWithAddedRowIds", () => $9c4b6923ed894c5d$export$6e21a717b784ff6c);
$parcel$export(module.exports, "getVisibleRowsCount", () => $9c4b6923ed894c5d$export$b4a9f7539f5aceeb);
$parcel$export(module.exports, "getVisibleIndexForRowId", () => $9c4b6923ed894c5d$export$79cf3e6172c1e206);

var $ahm5r = parcelRequire("ahm5r");

var $kcVGc = parcelRequire("kcVGc");

var $atQRE = parcelRequire("atQRE");

var $dTiUs = parcelRequire("dTiUs");

var $lwDil = parcelRequire("lwDil");
const $9c4b6923ed894c5d$export$53ea5f0c9428e57 = (0, $ahm5r.createSelector)((0, $atQRE.getSortedRowIdsHash), // FSN-4037 Remove draggingRowId related logic during FF cleanup
(0, $atQRE.getDraggingRowId), (0, $kcVGc.getExpandedRowIdsHash), (sortedRowIdsHash, draggingRowId, expandedRowIdsHash)=>(0, $dTiUs.default)(sortedRowIdsHash, draggingRowId, expandedRowIdsHash));
// memoize and transform to expected type for insertAnchoredRowIds utility
const $9c4b6923ed894c5d$var$getTemporaryAddedRowHash = (0, $ahm5r.createSelector)((0, $kcVGc.getTemporaryAddedRow), (temporaryAddedRow)=>temporaryAddedRow !== undefined ? {
        [temporaryAddedRow.temporaryId]: temporaryAddedRow
    } : undefined);
const $9c4b6923ed894c5d$export$6e21a717b784ff6c = (0, $ahm5r.createSelector)($9c4b6923ed894c5d$export$53ea5f0c9428e57, (0, $kcVGc.getRowTree), (0, $kcVGc.getExpandedRowIdsHash), $9c4b6923ed894c5d$var$getTemporaryAddedRowHash, (flattenedRowIds, rowTree, expandedRowIdsHash, temporaryAddedRows)=>(0, $lwDil.default)(flattenedRowIds, rowTree, expandedRowIdsHash, temporaryAddedRows));
const $9c4b6923ed894c5d$export$b4a9f7539f5aceeb = (state)=>$9c4b6923ed894c5d$export$6e21a717b784ff6c(state).length;
const $9c4b6923ed894c5d$export$883d77261e4c3cdd = (0, $ahm5r.createSelector)($9c4b6923ed894c5d$export$6e21a717b784ff6c, (flattenedRowIds)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    flattenedRowIds.reduce((acc, rowId, idx)=>{
        acc[rowId] = idx;
        return acc;
    }, {}));
const $9c4b6923ed894c5d$export$79cf3e6172c1e206 = (state, rowId)=>$9c4b6923ed894c5d$export$883d77261e4c3cdd(state)[rowId];

});
parcelRegister("dTiUs", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dfaf07455d97a95$export$2e2bcd8739ae039);

const $4dfaf07455d97a95$var$traverseRows = (rowIds, sortedRowIdsHash, // FSN-4037 Remove draggingRowId related logic during FF cleanup
draggingRowId, result, expandedRowIdsHash)=>{
    if (rowIds === undefined || rowIds.length === 0) return;
    rowIds.forEach((rowId)=>{
        // if an item is being dragged, its' children should be hidden
        // otherwise check if it is the list of consumer expanded rows
        const childrenIds = draggingRowId === rowId ? [] : expandedRowIdsHash[rowId] && sortedRowIdsHash[rowId] || [];
        result.push(rowId);
        $4dfaf07455d97a95$var$traverseRows(childrenIds, sortedRowIdsHash, draggingRowId, result, expandedRowIdsHash);
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4dfaf07455d97a95$export$2e2bcd8739ae039 = (sortedRowIdsHash, draggingRowId, expandedRowIdsHash)=>{
    const result = [];
    $4dfaf07455d97a95$var$traverseRows(sortedRowIdsHash[0, $ff4c22136947deab$export$59c500c4e33fdb0], sortedRowIdsHash, draggingRowId, result, expandedRowIdsHash);
    return result;
};

});
const $ff4c22136947deab$export$d12b3737880ade32 = 'FIRST';
const $ff4c22136947deab$export$c7329282a8166cba = 'LAST';
const $ff4c22136947deab$export$45ce4e6476e88525 = 'BEFORE';
const $ff4c22136947deab$export$6a633207bebc1e0e = 'AFTER';
const $ff4c22136947deab$export$667b331f8de09773 = 'INSIDE';
const $ff4c22136947deab$export$a63dec0667c2f97a = 'IS_LOADING';
const $ff4c22136947deab$export$456b4a90eb507580 = 'DELAYED_RENDER';
const $ff4c22136947deab$export$59c500c4e33fdb0 = 'ROOT';


parcelRegister("lwDil", function(module, exports) {

$parcel$export(module.exports, "default", () => $92fe1a4c5a967312$export$2e2bcd8739ae039);

var $5spib = parcelRequire("5spib");

var $5m7Wy = parcelRequire("5m7Wy");

var $aHi76 = parcelRequire("aHi76");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$92fe1a4c5a967312$export$2e2bcd8739ae039 = (baseRowIds, rowTree, expandedRowIdsHash, anchoredRows)=>{
    if (!anchoredRows) return baseRowIds;
    // remove added rows from their sorted order, to be positioned by anchor instead
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($5m7Wy)))(baseRowIds, (baseRowId)=>anchoredRows !== undefined && anchoredRows[baseRowId] !== undefined);
    // for each added row, insert based on the anchor
    (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(anchoredRows, (anchorRow, anchoredRowId)=>{
        const { anchorId: anchorId, position: position } = anchorRow;
        if (position === 'FIRST') result.unshift(anchoredRowId);
        else if (position === 'LAST') result.push(anchoredRowId);
        else if (anchorId) {
            const anchorRowLocation = result.indexOf(anchorId);
            // the anchor row may not be in the set of currently visible things
            if (anchorRowLocation !== -1) {
                if (position === 'BEFORE') result.splice(anchorRowLocation, 0, anchoredRowId);
                else if (position === 'AFTER') {
                    const spliceOffset = 1 + (0, $aHi76.default)(anchorId, rowTree, expandedRowIdsHash);
                    result.splice(anchorRowLocation + spliceOffset, 0, anchoredRowId);
                } else if (position === 'INSIDE' && expandedRowIdsHash[anchorId]) result.splice(anchorRowLocation + 1, 0, anchoredRowId);
            }
        }
    });
    return result;
};

});
parcelRegister("5m7Wy", function(module, exports) {

var $821Ou = parcelRequire("821Ou");

var $3PLp8 = parcelRequire("3PLp8");

var $1lM9j = parcelRequire("1lM9j");

var $4sprp = parcelRequire("4sprp");

var $iNghu = parcelRequire("iNghu");
/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */ function $3e652b37467fcd1d$var$reject(collection, predicate) {
    var func = $4sprp(collection) ? $821Ou : $3PLp8;
    return func(collection, $iNghu($1lM9j(predicate, 3)));
}
module.exports = $3e652b37467fcd1d$var$reject;

});
parcelRegister("3PLp8", function(module, exports) {

var $c3u3c = parcelRequire("c3u3c");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $2caae80f7af1e608$var$baseFilter(collection, predicate) {
    var result = [];
    $c3u3c(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $2caae80f7af1e608$var$baseFilter;

});


parcelRegister("aHi76", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f097d4d83be5c8a$export$2e2bcd8739ae039);

var $5spib = parcelRequire("5spib");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3f097d4d83be5c8a$export$2e2bcd8739ae039 = (rowId, rowTree, expandedRowIdsHash)=>{
    let childLength = 0;
    // @ts-expect-error - TS2304 - Cannot find name 'Identifier'.
    const traverseChildren = (parentId)=>{
        const childrenIds = expandedRowIdsHash[parentId] ? rowTree.rows[parentId].childrenIds : [];
        childLength += childrenIds.length;
        (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(childrenIds, (childId)=>{
            traverseChildren(childId);
        });
    };
    traverseChildren(rowId);
    return childLength;
};

});




parcelRegister("ccn7u", function(module, exports) {

$parcel$export(module.exports, "default", () => $a054e448c78bc11a$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $5wAOx = parcelRequire("5wAOx");

var $fRJOe = parcelRequire("fRJOe");

var $jnWVc = parcelRequire("jnWVc");
var $a054e448c78bc11a$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        activeRowId: (0, $fRJOe.getActiveRowId)(state),
        DetailsContent: (0, $5wAOx.getDetailsPanelComponent)(state)
    }), {})((0, $jnWVc.default));

});
parcelRegister("jnWVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $24665c000cd7da0b$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $i1eKe = parcelRequire("i1eKe");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $24665c000cd7da0b$var$Panel = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1x5895j": (0, $awdRS.default)(`1px solid ${__cmplp.theme.header.borderColor}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1kl7135k",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $24665c000cd7da0b$var$DetailsPanel extends (0, $eJOHy.PureComponent) {
    componentDidMount() {
        const { DetailsContent: DetailsContent } = this.props;
        // only try focus the panel if it would be open (some DetailsContent is supplied)
        DetailsContent && this.panelRef && this.panelRef.focus();
    }
    render() {
        const { activeRowId: activeRowId, DetailsContent: DetailsContent, theme: theme } = this.props;
        if (DetailsContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24665c000cd7da0b$var$Panel, {
            tabIndex: 0,
            ref: (div)=>{
                this.panelRef = div;
            },
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DetailsContent, {
            activeRowId: activeRowId
        }));
        return null;
    }
}
var $24665c000cd7da0b$export$2e2bcd8739ae039 = (0, $i1eKe.withTheme)($24665c000cd7da0b$var$DetailsPanel);

});
parcelRegister("i1eKe", function(module, exports) {

$parcel$export(module.exports, "withTheme", () => $1b26afa93629407d$export$e8748c6a27b910dc);
$parcel$export(module.exports, "ThemeProvider", () => $1b26afa93629407d$export$d8964aec282183a3);

var $eJOHy = parcelRequire("eJOHy");

var $hGM8A = parcelRequire("hGM8A");

var $61sqG = parcelRequire("61sqG");
/*
 * This is to replace the styledComponent theme provider as part of the compiled
 * css migration at https://hello.jira.atlassian.cloud/browse/ENGHEALTH-4743.
 * Before the migration, styled-components/ThemeProvider was used at
 * jira/src/packages/servicedesk/virtual-table/src/app/table/index.tsx
 * to inject StyledTheme context for the styledComponents to consume and after
 * the migration below theme context is used instead.
 *
 * */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $1b26afa93629407d$var$ThemeContext = /*#__PURE__*/ (0, $eJOHy.createContext)({});
const $1b26afa93629407d$export$93d4e7f90805808f = ()=>(0, $eJOHy.useContext)($1b26afa93629407d$var$ThemeContext);
function $1b26afa93629407d$export$e8748c6a27b910dc(Component) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1b26afa93629407d$var$ThemeContext.Consumer, null, (defaultTheme)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
                ...props,
                theme: defaultTheme
            }));
}
const $1b26afa93629407d$export$d8964aec282183a3 = ({ children: children, defaultRowHeight: defaultRowHeight, autoRowHeight: autoRowHeight, customScrollBarOffset: customScrollBarOffset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1b26afa93629407d$var$ThemeContext.Provider, {
        value: (0, $hGM8A.compiledThemeWithProps)((0, $61sqG.default), defaultRowHeight, autoRowHeight, customScrollBarOffset)
    }, children);

});
parcelRegister("hGM8A", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => $85f67ca5f7b592ed$export$25d302a5b900a763);
$parcel$export(module.exports, "compiledThemeWithProps", () => $85f67ca5f7b592ed$export$5a55b0960b1e154b);

var $1O6Yz = parcelRequire("1O6Yz");

var $LFmXM = parcelRequire("LFmXM");

var $2shLh = parcelRequire("2shLh");
const $85f67ca5f7b592ed$export$919aa3481b25eaec = (aTheme, anotherTheme)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, aTheme, anotherTheme);
const $85f67ca5f7b592ed$var$createRowCompiledTheme = ({ height: height, minHeight: minHeight, borderRadius: borderRadius, ...others }, autoHeight)=>({
        defaultHeight: Math.max(height, minHeight),
        height: height && !autoHeight ? `${height}px` : 'auto',
        minHeight: `${Math.max(height, minHeight)}px`,
        borderRadius: `${borderRadius}px`,
        ...others
    });
const $85f67ca5f7b592ed$var$createHeaderCompiledTheme = ({ height: height, paddingBottom: paddingBottom, paddingTop: paddingTop, ...others })=>({
        height: height ? `${height}px` : 'auto',
        paddingBottom: `${paddingBottom}px`,
        paddingTop: `${paddingTop}px`,
        ...others
    });
const $85f67ca5f7b592ed$var$createListCompiledTheme = ({ paddingTop: paddingTop })=>({
        paddingTop: `${paddingTop}px`
    });
const $85f67ca5f7b592ed$var$createCompiledTheme = (theme, autoHeight, customScrollBarOffset)=>{
    const { decal: decal, header: header, list: list, row: row, scrollbar: scrollbar, shadow: shadow } = theme;
    const scrollBarTheme = customScrollBarOffset !== undefined ? {
        ...scrollbar,
        offset: customScrollBarOffset
    } : scrollbar;
    return {
        decal: decal,
        header: $85f67ca5f7b592ed$var$createHeaderCompiledTheme(header),
        list: $85f67ca5f7b592ed$var$createListCompiledTheme(list),
        row: $85f67ca5f7b592ed$var$createRowCompiledTheme(row, autoHeight),
        scrollbar: scrollBarTheme,
        shadow: shadow
    };
};
const $85f67ca5f7b592ed$export$25d302a5b900a763 = (theme)=>$85f67ca5f7b592ed$export$919aa3481b25eaec((0, $2shLh.default), theme);
const $85f67ca5f7b592ed$export$5a55b0960b1e154b = (0, $LFmXM.default)((theme, height, autoHeight, customScrollBarOffset)=>$85f67ca5f7b592ed$var$createCompiledTheme((0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, theme, {
        row: {
            defaultHeight: height,
            height: height
        }
    }), autoHeight, customScrollBarOffset));

});
parcelRegister("2shLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34d3f2030f71dbe$export$2e2bcd8739ae039);

var /**
 * Default theme
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f34d3f2030f71dbe$export$2e2bcd8739ae039 = {
    list: {
        paddingTop: 0
    },
    row: {
        height: 40,
        minHeight: 40,
        borderColor: (0, $7bb4c1736002a04a$exports).N40,
        borderRadius: 0,
        borderWidth: 1,
        maxDepthChildrenOperationIndicatorWidth: 8,
        activeColor: (0, $7bb4c1736002a04a$exports).T50,
        hoveredColor: (0, $7bb4c1736002a04a$exports).N20
    },
    header: {
        height: 35,
        borderWidth: 1,
        borderColor: (0, $7bb4c1736002a04a$exports).N60,
        paddingBottom: 0,
        paddingTop: 0,
        sideMargin: 0,
        hasShadow: false
    },
    scrollbar: {
        offset: 0,
        marginTop: 0,
        marginBottom: 0,
        paddingTop: 0,
        paddingBottom: 0,
        computeHeight: false
    },
    shadow: {
        softenShadow: false,
        right: {
            display: 'none'
        },
        left: {
            borderWidth: 1,
            computeHeight: false
        },
        bottom: {
            display: 'none'
        }
    },
    decal: {
        borderWidth: 0,
        borderColor: (0, $7bb4c1736002a04a$exports).N50
    }
};

});


parcelRegister("61sqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a5e887252de2460$export$2e2bcd8739ae039);


var $dPMMf = parcelRequire("dPMMf");

var $hGM8A = parcelRequire("hGM8A");
var $2a5e887252de2460$export$2e2bcd8739ae039 = (0, $hGM8A.createTheme)({
    list: {
        paddingTop: (0, $dPMMf.gridSize) / 2
    },
    row: {
        height: 0,
        minHeight: (0, $dPMMf.gridSize) * 5,
        borderColor: 'transparent',
        borderRadius: (0, $dPMMf.gridSize) / 2,
        borderWidth: 0,
        maxDepthChildrenOperationIndicatorWidth: 0,
        activeColor: (0, $7bb4c1736002a04a$exports).N20,
        hoveredColor: (0, $7bb4c1736002a04a$exports).N20,
        useCssHover: true
    },
    header: {
        height: 0,
        borderColor: (0, $7bb4c1736002a04a$exports).N50,
        borderWidth: 2,
        paddingBottom: (0, $dPMMf.gridSize) / 2,
        paddingTop: (0, $dPMMf.gridSize),
        sideMargin: (0, $dPMMf.gridSize),
        hasShadow: true
    },
    scrollbar: {
        offset: (0, $dPMMf.gridSize) * 4,
        marginTop: (0, $dPMMf.gridSize) + (0, $dPMMf.gridSize) / 2,
        marginBottom: (0, $dPMMf.gridSize),
        paddingTop: (0, $dPMMf.gridSize),
        paddingBottom: (0, $dPMMf.gridSize) / 2,
        computeHeight: true
    },
    shadow: {
        softenShadow: true,
        right: {
            display: 'block'
        },
        left: {
            borderWidth: 0,
            computeHeight: true
        },
        bottom: {
            display: 'block'
        }
    },
    decal: {
        borderColor: (0, $7bb4c1736002a04a$exports).N50,
        borderWidth: 2
    }
});

});




parcelRegister("iRbuQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b3cd61246bba2e$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $9i8yy = parcelRequire("9i8yy");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $i1eKe = parcelRequire("i1eKe");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $69b3cd61246bba2e$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isAutoHeight: isAutoHeight, hideVerticalScrollBar: hideVerticalScrollBar, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isAutoHeight ? "_4t3i1wug" : "_4t3i1osq",
            !__cmplp.isAutoHeight && "_16jlkb7n _1o9zidpf _i0dl1wug",
            __cmplp.hideVerticalScrollBar ? "_1reo15vq _18m915vq" : "_1reo73ad _18m973ad",
            __cmplp.className
        ])
    });
});
const $69b3cd61246bba2e$var$FullHeightAutoSizer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $9i8yy.AutoSizer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3iaq80",
            __cmplp.className
        ])
    });
});
const $69b3cd61246bba2e$var$AutoSizedContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $awdRS.default)(`${__cmplp.width}px`),
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1hdq _4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $69b3cd61246bba2e$var$VirtualBoundriesTracker = ({ visibleStart: visibleStart, visibleEnd: visibleEnd })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (visibleStart === 0) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'virtualBoundaries calculated', {
            visibleEnd: visibleEnd
        });
    }, [
        visibleStart,
        visibleEnd,
        createAnalyticsEvent
    ]);
    return null;
};
// eslint-disable-next-line jira/react/no-class-components
class $69b3cd61246bba2e$var$Table extends (0, $eJOHy.PureComponent) {
    componentDidMount() {
        if ((0, $7jTnu.fg)('css_support_for_virtual_table')) {
            if (this.flexRef.current) {
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                const { height: height, width: width } = this.flexRef.current.getBoundingClientRect();
                this.onResize({
                    height: height,
                    width: width
                });
            }
        }
    }
    render() {
        const { width: width, height: height, isAutoHeight: isAutoHeight, shouldUseCssForRendering: shouldUseCssForRendering, TableMain: TableMain, DetailsPanel: DetailsPanel } = this.props;
        const autoSizerStyle = isAutoHeight ? {
            height: 'auto'
        } : {};
        if (shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69b3cd61246bba2e$var$Wrapper, {
            hideVerticalScrollBar: false,
            isAutoHeight: isAutoHeight,
            "data-component-selector": "virtual-table.view.table-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            ref: this.flexRef,
            xcss: [
                $69b3cd61246bba2e$var$containerStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TableMain, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DetailsPanel, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69b3cd61246bba2e$var$VirtualBoundriesTracker, {
            visibleStart: this.props.virtualBoundaries.visibleStart,
            visibleEnd: this.props.virtualBoundaries.visibleEnd
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69b3cd61246bba2e$var$Wrapper, {
            isAutoHeight: isAutoHeight,
            hideVerticalScrollBar: false,
            "data-component-selector": "virtual-table.view.table-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69b3cd61246bba2e$var$FullHeightAutoSizer, {
            onResize: this.onResize,
            style: {
                ...autoSizerStyle
            }
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69b3cd61246bba2e$var$AutoSizedContentWrapper, {
                width: width,
                height: height
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TableMain, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DetailsPanel, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69b3cd61246bba2e$var$VirtualBoundriesTracker, {
            visibleStart: this.props.virtualBoundaries.visibleStart,
            visibleEnd: this.props.virtualBoundaries.visibleEnd
        }));
    }
    constructor(...args){
        super(...args), this.onResize = (size)=>{
            const { setTableSize: setTableSize, theme: theme } = this.props;
            // AutoSizer uses offsetWidth/offsetHeight for dimensions which rounds and can cause scrollbars.
            // i.e. height of 700.5 will be rounded to 701
            // We need to remove a single pixel to prevent this
            // https://github.com/bvaughn/react-virtualized/issues/1287
            const width = size.width - 1;
            const height = size.height - 1;
            setTableSize({
                height: height,
                width: width,
                widthWithoutScrollbarOffset: width - theme.scrollbar.offset,
                rowMargin: theme.header.sideMargin * 2
            });
        }, this.flexRef = /*#__PURE__*/ (0, $eJOHy.createRef)();
    }
}
var $69b3cd61246bba2e$export$2e2bcd8739ae039 = (0, $i1eKe.withTheme)($69b3cd61246bba2e$var$Table);
const $69b3cd61246bba2e$var$containerStyles = (0, $1DXK0.xcss)({
    width: '100%',
    height: '100%'
});

});
parcelRegister("9i8yy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cobST = parcelRequire("cobST");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $6c3c6e96e29f13f8$var$_interopRequireDefault($cobST).default;
    }
});
Object.defineProperty(module.exports, 'AutoSizer', {
    enumerable: true,
    get: function get() {
        return $6c3c6e96e29f13f8$var$_interopRequireDefault($cobST).default;
    }
});
function $6c3c6e96e29f13f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("cobST", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $izRwq = parcelRequire("izRwq");
var $9050f1e5b5e51048$var$_extends3 = $9050f1e5b5e51048$var$_interopRequireDefault($izRwq);

var $1nR2i = parcelRequire("1nR2i");
var $9050f1e5b5e51048$var$_getPrototypeOf2 = $9050f1e5b5e51048$var$_interopRequireDefault($1nR2i);

var $jK0mf = parcelRequire("jK0mf");
var $9050f1e5b5e51048$var$_classCallCheck3 = $9050f1e5b5e51048$var$_interopRequireDefault($jK0mf);

var $7kKnu = parcelRequire("7kKnu");
var $9050f1e5b5e51048$var$_createClass3 = $9050f1e5b5e51048$var$_interopRequireDefault($7kKnu);

var $dopow = parcelRequire("dopow");
var $9050f1e5b5e51048$var$_possibleConstructorReturn3 = $9050f1e5b5e51048$var$_interopRequireDefault($dopow);

var $2G5Ta = parcelRequire("2G5Ta");
var $9050f1e5b5e51048$var$_inherits3 = $9050f1e5b5e51048$var$_interopRequireDefault($2G5Ta);

var $eJOHy = parcelRequire("eJOHy");
var $9050f1e5b5e51048$var$React = $9050f1e5b5e51048$var$_interopRequireWildcard($eJOHy);

var $1MbhJ = parcelRequire("1MbhJ");
var $9050f1e5b5e51048$var$_detectElementResize2 = $9050f1e5b5e51048$var$_interopRequireDefault($1MbhJ);

var $cT3Ey = parcelRequire("cT3Ey");
var $9050f1e5b5e51048$var$_propTypes2 = $9050f1e5b5e51048$var$_interopRequireDefault($cT3Ey);
function $9050f1e5b5e51048$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $9050f1e5b5e51048$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9050f1e5b5e51048$var$AutoSizer = function(_React$PureComponent) {
    (0, $9050f1e5b5e51048$var$_inherits3.default)(AutoSizer, _React$PureComponent);
    function AutoSizer() {
        var _ref;
        var _temp, _this, _ret;
        (0, $9050f1e5b5e51048$var$_classCallCheck3.default)(this, AutoSizer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $9050f1e5b5e51048$var$_possibleConstructorReturn3.default)(this, (_ref = AutoSizer.__proto__ || (0, $9050f1e5b5e51048$var$_getPrototypeOf2.default)(AutoSizer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            height: _this.props.defaultHeight || 0,
            width: _this.props.defaultWidth || 0
        }, _this._onResize = function() {
            var _this$props = _this.props, disableHeight = _this$props.disableHeight, disableWidth = _this$props.disableWidth, onResize = _this$props.onResize;
            if (_this._parentNode) {
                // Guard against AutoSizer component being removed from the DOM immediately after being added.
                // This can result in invalid style values which can result in NaN values if we don't handle them.
                // See issue #150 for more context.
                var _height = _this._parentNode.offsetHeight || 0;
                var _width = _this._parentNode.offsetWidth || 0;
                var win = _this._window || window;
                var _style = win.getComputedStyle(_this._parentNode) || {};
                var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
                var paddingRight = parseInt(_style.paddingRight, 10) || 0;
                var paddingTop = parseInt(_style.paddingTop, 10) || 0;
                var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;
                var newHeight = _height - paddingTop - paddingBottom;
                var newWidth = _width - paddingLeft - paddingRight;
                if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
                    _this.setState({
                        height: _height - paddingTop - paddingBottom,
                        width: _width - paddingLeft - paddingRight
                    });
                    onResize({
                        height: _height,
                        width: _width
                    });
                }
            }
        }, _this._setRef = function(autoSizer) {
            _this._autoSizer = autoSizer;
        }, _temp), (0, $9050f1e5b5e51048$var$_possibleConstructorReturn3.default)(_this, _ret);
    } // uses any instead of Window because Flow doesn't have window type
    (0, $9050f1e5b5e51048$var$_createClass3.default)(AutoSizer, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var nonce = this.props.nonce;
                if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
                    // Delay access of parentNode until mount.
                    // This handles edge-cases where the component has already been unmounted before its ref has been set,
                    // As well as libraries like react-lite which have a slightly different lifecycle.
                    this._parentNode = this._autoSizer.parentNode;
                    this._window = this._autoSizer.parentNode.ownerDocument.defaultView;
                    // Defer requiring resize handler in order to support server-side rendering.
                    // See issue #41
                    this._detectElementResize = (0, $9050f1e5b5e51048$var$_detectElementResize2.default)(nonce, this._window);
                    this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
                    this._onResize();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this._detectElementResize && this._parentNode) this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, className = _props.className, disableHeight = _props.disableHeight, disableWidth = _props.disableWidth, style = _props.style;
                var _state = this.state, height = _state.height, width = _state.width;
                // Outer div should not force width/height since that may prevent containers from shrinking.
                // Inner component should overflow and use calculated width/height.
                // See issue #68 for more information.
                var outerStyle = {
                    overflow: 'visible'
                };
                var childParams = {};
                if (!disableHeight) {
                    outerStyle.height = 0;
                    childParams.height = height;
                }
                if (!disableWidth) {
                    outerStyle.width = 0;
                    childParams.width = width;
                }
                /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */ return $9050f1e5b5e51048$var$React.createElement('div', {
                    className: className,
                    ref: this._setRef,
                    style: (0, $9050f1e5b5e51048$var$_extends3.default)({}, outerStyle, style)
                }, children(childParams));
            }
        }
    ]);
    return AutoSizer;
}($9050f1e5b5e51048$var$React.PureComponent);
$9050f1e5b5e51048$var$AutoSizer.defaultProps = {
    onResize: function onResize() {},
    disableHeight: false,
    disableWidth: false,
    style: {}
};
$9050f1e5b5e51048$var$AutoSizer.propTypes = null;
module.exports.default = $9050f1e5b5e51048$var$AutoSizer;

});
parcelRegister("izRwq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $d865033b5037152b$export$1e511d4a378977f5, (v) => $d865033b5037152b$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $d865033b5037152b$export$2e2bcd8739ae039, (v) => $d865033b5037152b$export$2e2bcd8739ae039 = v);
var $d865033b5037152b$export$1e511d4a378977f5;
var $d865033b5037152b$export$2e2bcd8739ae039;
"use strict";
$d865033b5037152b$export$1e511d4a378977f5 = true;

var $3ny3M = parcelRequire("3ny3M");
var $d865033b5037152b$var$_assign2 = $d865033b5037152b$var$_interopRequireDefault($3ny3M);
function $d865033b5037152b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$d865033b5037152b$export$2e2bcd8739ae039 = $d865033b5037152b$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("3ny3M", function(module, exports) {

module.exports = {
    "default": (parcelRequire("aJlqc")),
    __esModule: true
};

});
parcelRegister("aJlqc", function(module, exports) {
parcelRequire("9HxL5");

module.exports = (parcelRequire("h9BqL")).Object.assign;

});
parcelRegister("9HxL5", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $1VdgD = parcelRequire("1VdgD");

$1VdgD($1VdgD.S + $1VdgD.F, 'Object', {
    assign: (parcelRequire("j3SKw"))
});

});
parcelRegister("1VdgD", function(module, exports) {

var $ea50F = parcelRequire("ea50F");

var $h9BqL = parcelRequire("h9BqL");

var $hFYx0 = parcelRequire("hFYx0");

var $2fICR = parcelRequire("2fICR");

var $2k1EH = parcelRequire("2k1EH");
var $166567f03e3e0b37$var$PROTOTYPE = 'prototype';
var $166567f03e3e0b37$var$$export = function(type, name, source) {
    var IS_FORCED = type & $166567f03e3e0b37$var$$export.F;
    var IS_GLOBAL = type & $166567f03e3e0b37$var$$export.G;
    var IS_STATIC = type & $166567f03e3e0b37$var$$export.S;
    var IS_PROTO = type & $166567f03e3e0b37$var$$export.P;
    var IS_BIND = type & $166567f03e3e0b37$var$$export.B;
    var IS_WRAP = type & $166567f03e3e0b37$var$$export.W;
    var exports = IS_GLOBAL ? $h9BqL : $h9BqL[name] || ($h9BqL[name] = {});
    var expProto = exports[$166567f03e3e0b37$var$PROTOTYPE];
    var target = IS_GLOBAL ? $ea50F : IS_STATIC ? $ea50F[name] : ($ea50F[name] || {})[$166567f03e3e0b37$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $2k1EH(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $hFYx0(out, $ea50F) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$166567f03e3e0b37$var$PROTOTYPE] = C[$166567f03e3e0b37$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $hFYx0(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $166567f03e3e0b37$var$$export.R && expProto && !expProto[key]) $2fICR(expProto, key, out);
        }
    }
};
// type bitmap
$166567f03e3e0b37$var$$export.F = 1; // forced
$166567f03e3e0b37$var$$export.G = 2; // global
$166567f03e3e0b37$var$$export.S = 4; // static
$166567f03e3e0b37$var$$export.P = 8; // proto
$166567f03e3e0b37$var$$export.B = 16; // bind
$166567f03e3e0b37$var$$export.W = 32; // wrap
$166567f03e3e0b37$var$$export.U = 64; // safe
$166567f03e3e0b37$var$$export.R = 128; // real proto method for `library`
module.exports = $166567f03e3e0b37$var$$export;

});
parcelRegister("ea50F", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $a4f5e2b85dab3797$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $a4f5e2b85dab3797$var$global; // eslint-disable-line no-undef

});

parcelRegister("h9BqL", function(module, exports) {
var $c7d04fe055d04aa8$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $c7d04fe055d04aa8$var$core; // eslint-disable-line no-undef

});

parcelRegister("hFYx0", function(module, exports) {
// optional / simple context binding

var $ixKF3 = parcelRequire("ixKF3");
module.exports = function(fn, that, length) {
    $ixKF3(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("ixKF3", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("2fICR", function(module, exports) {

var $6SgFA = parcelRequire("6SgFA");

var $65sdk = parcelRequire("65sdk");

module.exports = (parcelRequire("2ZZjJ")) ? function(object, key, value) {
    return $6SgFA.f(object, key, $65sdk(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("6SgFA", function(module, exports) {

$parcel$export(module.exports, "f", () => $5014b779d90da306$export$2d1720544b23b823, (v) => $5014b779d90da306$export$2d1720544b23b823 = v);
var $5014b779d90da306$export$2d1720544b23b823;

var $gH7sg = parcelRequire("gH7sg");

var $d5nHr = parcelRequire("d5nHr");

var $cBMOE = parcelRequire("cBMOE");
var $5014b779d90da306$var$dP = Object.defineProperty;

$5014b779d90da306$export$2d1720544b23b823 = (parcelRequire("2ZZjJ")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $gH7sg(O);
    P = $cBMOE(P, true);
    $gH7sg(Attributes);
    if ($d5nHr) try {
        return $5014b779d90da306$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("gH7sg", function(module, exports) {

var $4Us5Z = parcelRequire("4Us5Z");
module.exports = function(it) {
    if (!$4Us5Z(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("4Us5Z", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("d5nHr", function(module, exports) {



module.exports = !(parcelRequire("2ZZjJ")) && !(parcelRequire("60hL6"))(function() {
    return Object.defineProperty((parcelRequire("1uU7O"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("2ZZjJ", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("60hL6"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("60hL6", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("1uU7O", function(module, exports) {

var $4Us5Z = parcelRequire("4Us5Z");

var $ea50F = parcelRequire("ea50F");
var $117421055f7b9992$require$document = $ea50F.document;
// typeof document.createElement is 'object' in old IE
var $117421055f7b9992$var$is = $4Us5Z($117421055f7b9992$require$document) && $4Us5Z($117421055f7b9992$require$document.createElement);
module.exports = function(it) {
    return $117421055f7b9992$var$is ? $117421055f7b9992$require$document.createElement(it) : {};
};

});


parcelRegister("cBMOE", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $4Us5Z = parcelRequire("4Us5Z");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$4Us5Z(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$4Us5Z(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$4Us5Z(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$4Us5Z(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("65sdk", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("2k1EH", function(module, exports) {
var $1b0ebbbf46784288$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $1b0ebbbf46784288$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("j3SKw", function(module, exports) {
'use strict';

var $2ZZjJ = parcelRequire("2ZZjJ");

var $f49xG = parcelRequire("f49xG");

var $29Vta = parcelRequire("29Vta");

var $7NEQF = parcelRequire("7NEQF");

var $9IOcn = parcelRequire("9IOcn");

var $aokPx = parcelRequire("aokPx");
var $de08c43c136e4a2e$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$de08c43c136e4a2e$var$$assign || (parcelRequire("60hL6"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $de08c43c136e4a2e$var$$assign({}, A)[S] != 7 || Object.keys($de08c43c136e4a2e$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $9IOcn(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $29Vta.f;
    var isEnum = $7NEQF.f;
    while(aLen > index){
        var S = $aokPx(arguments[index++]);
        var keys = getSymbols ? $f49xG(S).concat(getSymbols(S)) : $f49xG(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$2ZZjJ || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $de08c43c136e4a2e$var$$assign;

});
parcelRegister("f49xG", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $56isG = parcelRequire("56isG");

var $clOgA = parcelRequire("clOgA");
module.exports = Object.keys || function keys(O) {
    return $56isG(O, $clOgA);
};

});
parcelRegister("56isG", function(module, exports) {

var $2k1EH = parcelRequire("2k1EH");

var $kOF1h = parcelRequire("kOF1h");

var $3b6bd5665d9e9f5d$var$arrayIndexOf = (parcelRequire("fzEzO"))(false);

var $3b6bd5665d9e9f5d$var$IE_PROTO = (parcelRequire("dqUYm"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $kOF1h(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $3b6bd5665d9e9f5d$var$IE_PROTO) $2k1EH(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($2k1EH(O, key = names[i++])) ~$3b6bd5665d9e9f5d$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("kOF1h", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $aokPx = parcelRequire("aokPx");

var $iojCL = parcelRequire("iojCL");
module.exports = function(it) {
    return $aokPx($iojCL(it));
};

});
parcelRegister("aokPx", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $c4I03 = parcelRequire("c4I03");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $c4I03(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("c4I03", function(module, exports) {
var $0244c625fdfa1f38$var$toString = {}.toString;
module.exports = function(it) {
    return $0244c625fdfa1f38$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("iojCL", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("fzEzO", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $kOF1h = parcelRequire("kOF1h");

var $h9XHT = parcelRequire("h9XHT");

var $cEixM = parcelRequire("cEixM");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $kOF1h($this);
        var length = $h9XHT(O.length);
        var index = $cEixM(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("h9XHT", function(module, exports) {
// 7.1.15 ToLength

var $ltpLS = parcelRequire("ltpLS");
var $c7e1977b7e8c28f6$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $c7e1977b7e8c28f6$var$min($ltpLS(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("ltpLS", function(module, exports) {
// 7.1.4 ToInteger
var $fa204c08ab638536$var$ceil = Math.ceil;
var $fa204c08ab638536$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $fa204c08ab638536$var$floor : $fa204c08ab638536$var$ceil)(it);
};

});


parcelRegister("cEixM", function(module, exports) {

var $ltpLS = parcelRequire("ltpLS");
var $93579add973f9bea$var$max = Math.max;
var $93579add973f9bea$var$min = Math.min;
module.exports = function(index, length) {
    index = $ltpLS(index);
    return index < 0 ? $93579add973f9bea$var$max(index + length, 0) : $93579add973f9bea$var$min(index, length);
};

});


parcelRegister("dqUYm", function(module, exports) {

var $9c79e5a684320090$var$shared = (parcelRequire("he9HP"))('keys');

var $d07cI = parcelRequire("d07cI");
module.exports = function(key) {
    return $9c79e5a684320090$var$shared[key] || ($9c79e5a684320090$var$shared[key] = $d07cI(key));
};

});
parcelRegister("he9HP", function(module, exports) {

var $h9BqL = parcelRequire("h9BqL");

var $ea50F = parcelRequire("ea50F");
var $c8ab45da1606111a$var$SHARED = '__core-js_shared__';
var $c8ab45da1606111a$var$store = $ea50F[$c8ab45da1606111a$var$SHARED] || ($ea50F[$c8ab45da1606111a$var$SHARED] = {});

(module.exports = function(key, value) {
    return $c8ab45da1606111a$var$store[key] || ($c8ab45da1606111a$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $h9BqL.version,
    mode: (parcelRequire("336Nq")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("336Nq", function(module, exports) {
module.exports = true;

});


parcelRegister("d07cI", function(module, exports) {
var $9770dd0be1eab494$var$id = 0;
var $9770dd0be1eab494$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$9770dd0be1eab494$var$id + $9770dd0be1eab494$var$px).toString(36));
};

});



parcelRegister("clOgA", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});


parcelRegister("29Vta", function(module, exports) {

$parcel$export(module.exports, "f", () => $1929004539fa1d59$export$2d1720544b23b823, (v) => $1929004539fa1d59$export$2d1720544b23b823 = v);
var $1929004539fa1d59$export$2d1720544b23b823;
$1929004539fa1d59$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("7NEQF", function(module, exports) {

$parcel$export(module.exports, "f", () => $5adccbac77835174$export$2d1720544b23b823, (v) => $5adccbac77835174$export$2d1720544b23b823 = v);
var $5adccbac77835174$export$2d1720544b23b823;
$5adccbac77835174$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("9IOcn", function(module, exports) {
// 7.1.13 ToObject(argument)

var $iojCL = parcelRequire("iojCL");
module.exports = function(it) {
    return Object($iojCL(it));
};

});






parcelRegister("1nR2i", function(module, exports) {

module.exports = {
    "default": (parcelRequire("eU9F0")),
    __esModule: true
};

});
parcelRegister("eU9F0", function(module, exports) {
parcelRequire("kqxjQ");

module.exports = (parcelRequire("h9BqL")).Object.getPrototypeOf;

});
parcelRegister("kqxjQ", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $9IOcn = parcelRequire("9IOcn");

var $fuXB7 = parcelRequire("fuXB7");

(parcelRequire("6rscv"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $fuXB7($9IOcn(it));
    };
});

});
parcelRegister("fuXB7", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $2k1EH = parcelRequire("2k1EH");

var $9IOcn = parcelRequire("9IOcn");

var $b487e33d08476ef6$var$IE_PROTO = (parcelRequire("dqUYm"))('IE_PROTO');
var $b487e33d08476ef6$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $9IOcn(O);
    if ($2k1EH(O, $b487e33d08476ef6$var$IE_PROTO)) return O[$b487e33d08476ef6$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $b487e33d08476ef6$var$ObjectProto : null;
};

});

parcelRegister("6rscv", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $1VdgD = parcelRequire("1VdgD");

var $h9BqL = parcelRequire("h9BqL");

var $60hL6 = parcelRequire("60hL6");
module.exports = function(KEY, exec) {
    var fn = ($h9BqL.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $1VdgD($1VdgD.S + $1VdgD.F * $60hL6(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("jK0mf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $e5f2973ee8973115$export$1e511d4a378977f5, (v) => $e5f2973ee8973115$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $e5f2973ee8973115$export$2e2bcd8739ae039, (v) => $e5f2973ee8973115$export$2e2bcd8739ae039 = v);
var $e5f2973ee8973115$export$1e511d4a378977f5;
var $e5f2973ee8973115$export$2e2bcd8739ae039;
"use strict";
$e5f2973ee8973115$export$1e511d4a378977f5 = true;
$e5f2973ee8973115$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("7kKnu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $556e6054c02a9e52$export$1e511d4a378977f5, (v) => $556e6054c02a9e52$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $556e6054c02a9e52$export$2e2bcd8739ae039, (v) => $556e6054c02a9e52$export$2e2bcd8739ae039 = v);
var $556e6054c02a9e52$export$1e511d4a378977f5;
var $556e6054c02a9e52$export$2e2bcd8739ae039;
"use strict";
$556e6054c02a9e52$export$1e511d4a378977f5 = true;

var $dYGWP = parcelRequire("dYGWP");
var $556e6054c02a9e52$var$_defineProperty2 = $556e6054c02a9e52$var$_interopRequireDefault($dYGWP);
function $556e6054c02a9e52$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$556e6054c02a9e52$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $556e6054c02a9e52$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("dYGWP", function(module, exports) {

module.exports = {
    "default": (parcelRequire("8S65L")),
    __esModule: true
};

});
parcelRegister("8S65L", function(module, exports) {
parcelRequire("gXidU");

var $h9BqL = parcelRequire("h9BqL");
var $6758179be15c23ed$require$$Object = $h9BqL.Object;
module.exports = function defineProperty(it, key, desc) {
    return $6758179be15c23ed$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("gXidU", function(module, exports) {

var $1VdgD = parcelRequire("1VdgD");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$1VdgD($1VdgD.S + $1VdgD.F * !(parcelRequire("2ZZjJ")), 'Object', {
    defineProperty: (parcelRequire("6SgFA")).f
});

});




parcelRegister("dopow", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $9c013719b8ab6b7a$export$1e511d4a378977f5, (v) => $9c013719b8ab6b7a$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $9c013719b8ab6b7a$export$2e2bcd8739ae039, (v) => $9c013719b8ab6b7a$export$2e2bcd8739ae039 = v);
var $9c013719b8ab6b7a$export$1e511d4a378977f5;
var $9c013719b8ab6b7a$export$2e2bcd8739ae039;
"use strict";
$9c013719b8ab6b7a$export$1e511d4a378977f5 = true;

var $f3S2g = parcelRequire("f3S2g");
var $9c013719b8ab6b7a$var$_typeof3 = $9c013719b8ab6b7a$var$_interopRequireDefault($f3S2g);
function $9c013719b8ab6b7a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$9c013719b8ab6b7a$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $9c013719b8ab6b7a$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("f3S2g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $af710d29b99786ea$export$1e511d4a378977f5, (v) => $af710d29b99786ea$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $af710d29b99786ea$export$2e2bcd8739ae039, (v) => $af710d29b99786ea$export$2e2bcd8739ae039 = v);
var $af710d29b99786ea$export$1e511d4a378977f5;
var $af710d29b99786ea$export$2e2bcd8739ae039;
"use strict";
$af710d29b99786ea$export$1e511d4a378977f5 = true;

var $1wM3S = parcelRequire("1wM3S");
var $af710d29b99786ea$var$_iterator2 = $af710d29b99786ea$var$_interopRequireDefault($1wM3S);

var $8GP5W = parcelRequire("8GP5W");
var $af710d29b99786ea$var$_symbol2 = $af710d29b99786ea$var$_interopRequireDefault($8GP5W);
var $af710d29b99786ea$var$_typeof = typeof $af710d29b99786ea$var$_symbol2.default === "function" && typeof $af710d29b99786ea$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $af710d29b99786ea$var$_symbol2.default === "function" && obj.constructor === $af710d29b99786ea$var$_symbol2.default && obj !== $af710d29b99786ea$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $af710d29b99786ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$af710d29b99786ea$export$2e2bcd8739ae039 = typeof $af710d29b99786ea$var$_symbol2.default === "function" && $af710d29b99786ea$var$_typeof($af710d29b99786ea$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $af710d29b99786ea$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $af710d29b99786ea$var$_symbol2.default === "function" && obj.constructor === $af710d29b99786ea$var$_symbol2.default && obj !== $af710d29b99786ea$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $af710d29b99786ea$var$_typeof(obj);
};

});
parcelRegister("1wM3S", function(module, exports) {

module.exports = {
    "default": (parcelRequire("3QuHU")),
    __esModule: true
};

});
parcelRegister("3QuHU", function(module, exports) {
parcelRequire("b94Z9");
parcelRequire("1v3Fn");

module.exports = (parcelRequire("bdk15")).f('iterator');

});
parcelRegister("b94Z9", function(module, exports) {
'use strict';

var $81d466f73211b776$var$$at = (parcelRequire("jQqZW"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("f4Hks"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $81d466f73211b776$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("jQqZW", function(module, exports) {

var $ltpLS = parcelRequire("ltpLS");

var $iojCL = parcelRequire("iojCL");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($iojCL(that));
        var i = $ltpLS(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("f4Hks", function(module, exports) {
'use strict';

var $336Nq = parcelRequire("336Nq");

var $1VdgD = parcelRequire("1VdgD");

var $iNFG6 = parcelRequire("iNFG6");

var $2fICR = parcelRequire("2fICR");

var $jAn1n = parcelRequire("jAn1n");

var $aaTjp = parcelRequire("aaTjp");

var $3BGsZ = parcelRequire("3BGsZ");

var $fuXB7 = parcelRequire("fuXB7");

var $af98d6f99f059c0e$var$ITERATOR = (parcelRequire("jsTob"))('iterator');
var $af98d6f99f059c0e$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $af98d6f99f059c0e$var$FF_ITERATOR = '@@iterator';
var $af98d6f99f059c0e$var$KEYS = 'keys';
var $af98d6f99f059c0e$var$VALUES = 'values';
var $af98d6f99f059c0e$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $aaTjp(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$af98d6f99f059c0e$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $af98d6f99f059c0e$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $af98d6f99f059c0e$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $af98d6f99f059c0e$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$af98d6f99f059c0e$var$ITERATOR] || proto[$af98d6f99f059c0e$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $fuXB7($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $3BGsZ(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$336Nq && typeof IteratorPrototype[$af98d6f99f059c0e$var$ITERATOR] != 'function') $2fICR(IteratorPrototype, $af98d6f99f059c0e$var$ITERATOR, $af98d6f99f059c0e$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $af98d6f99f059c0e$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$336Nq || FORCED) && ($af98d6f99f059c0e$var$BUGGY || VALUES_BUG || !proto[$af98d6f99f059c0e$var$ITERATOR])) $2fICR(proto, $af98d6f99f059c0e$var$ITERATOR, $default);
    // Plug for library
    $jAn1n[NAME] = $default;
    $jAn1n[TAG] = $af98d6f99f059c0e$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($af98d6f99f059c0e$var$VALUES),
            keys: IS_SET ? $default : getMethod($af98d6f99f059c0e$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $iNFG6(proto, key, methods[key]);
        } else $1VdgD($1VdgD.P + $1VdgD.F * ($af98d6f99f059c0e$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("iNFG6", function(module, exports) {

module.exports = (parcelRequire("2fICR"));

});

parcelRegister("jAn1n", function(module, exports) {
module.exports = {};

});

parcelRegister("aaTjp", function(module, exports) {
'use strict';

var $eP7J8 = parcelRequire("eP7J8");

var $65sdk = parcelRequire("65sdk");

var $3BGsZ = parcelRequire("3BGsZ");
var $7685be5d46dbd3a6$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("2fICR"))($7685be5d46dbd3a6$var$IteratorPrototype, (parcelRequire("jsTob"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $eP7J8($7685be5d46dbd3a6$var$IteratorPrototype, {
        next: $65sdk(1, next)
    });
    $3BGsZ(Constructor, NAME + ' Iterator');
};

});
parcelRegister("eP7J8", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $gH7sg = parcelRequire("gH7sg");

var $iyYcd = parcelRequire("iyYcd");

var $clOgA = parcelRequire("clOgA");

var $acabd284dd3abc94$var$IE_PROTO = (parcelRequire("dqUYm"))('IE_PROTO');
var $acabd284dd3abc94$var$Empty = function() {};
var $acabd284dd3abc94$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $acabd284dd3abc94$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("1uU7O"))('iframe');
    var i = $clOgA.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("bsGy8")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $acabd284dd3abc94$var$createDict = iframeDocument.F;
    while(i--)delete $acabd284dd3abc94$var$createDict[$acabd284dd3abc94$var$PROTOTYPE][$clOgA[i]];
    return $acabd284dd3abc94$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $acabd284dd3abc94$var$Empty[$acabd284dd3abc94$var$PROTOTYPE] = $gH7sg(O);
        result = new $acabd284dd3abc94$var$Empty();
        $acabd284dd3abc94$var$Empty[$acabd284dd3abc94$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$acabd284dd3abc94$var$IE_PROTO] = O;
    } else result = $acabd284dd3abc94$var$createDict();
    return Properties === undefined ? result : $iyYcd(result, Properties);
};

});
parcelRegister("iyYcd", function(module, exports) {

var $6SgFA = parcelRequire("6SgFA");

var $gH7sg = parcelRequire("gH7sg");

var $f49xG = parcelRequire("f49xG");

module.exports = (parcelRequire("2ZZjJ")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $gH7sg(O);
    var keys = $f49xG(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$6SgFA.f(O, P = keys[i++], Properties[P]);
    return O;
};

});

parcelRegister("bsGy8", function(module, exports) {

var $ea50F = parcelRequire("ea50F");
var $858350b57c4e0418$require$document = $ea50F.document;
module.exports = $858350b57c4e0418$require$document && $858350b57c4e0418$require$document.documentElement;

});


parcelRegister("3BGsZ", function(module, exports) {

var $6SgFA = parcelRequire("6SgFA");
var $2a05c4c9f64965e8$require$def = $6SgFA.f;

var $2k1EH = parcelRequire("2k1EH");

var $2a05c4c9f64965e8$var$TAG = (parcelRequire("jsTob"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$2k1EH(it = stat ? it : it.prototype, $2a05c4c9f64965e8$var$TAG)) $2a05c4c9f64965e8$require$def(it, $2a05c4c9f64965e8$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("jsTob", function(module, exports) {

var $e2bb98fb5e1d7510$var$store = (parcelRequire("he9HP"))('wks');

var $d07cI = parcelRequire("d07cI");

var $ea50F = parcelRequire("ea50F");
var $e2bb98fb5e1d7510$require$Symbol = $ea50F.Symbol;
var $e2bb98fb5e1d7510$var$USE_SYMBOL = typeof $e2bb98fb5e1d7510$require$Symbol == 'function';
var $e2bb98fb5e1d7510$var$$exports = module.exports = function(name) {
    return $e2bb98fb5e1d7510$var$store[name] || ($e2bb98fb5e1d7510$var$store[name] = $e2bb98fb5e1d7510$var$USE_SYMBOL && $e2bb98fb5e1d7510$require$Symbol[name] || ($e2bb98fb5e1d7510$var$USE_SYMBOL ? $e2bb98fb5e1d7510$require$Symbol : $d07cI)('Symbol.' + name));
};
$e2bb98fb5e1d7510$var$$exports.store = $e2bb98fb5e1d7510$var$store;

});





parcelRegister("1v3Fn", function(module, exports) {
parcelRequire("fAKcX");

var $ea50F = parcelRequire("ea50F");

var $2fICR = parcelRequire("2fICR");

var $jAn1n = parcelRequire("jAn1n");

var $117b87c540a40693$var$TO_STRING_TAG = (parcelRequire("jsTob"))('toStringTag');
var $117b87c540a40693$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $117b87c540a40693$var$i = 0; $117b87c540a40693$var$i < $117b87c540a40693$var$DOMIterables.length; $117b87c540a40693$var$i++){
    var $117b87c540a40693$var$NAME = $117b87c540a40693$var$DOMIterables[$117b87c540a40693$var$i];
    var $117b87c540a40693$var$Collection = $ea50F[$117b87c540a40693$var$NAME];
    var $117b87c540a40693$var$proto = $117b87c540a40693$var$Collection && $117b87c540a40693$var$Collection.prototype;
    if ($117b87c540a40693$var$proto && !$117b87c540a40693$var$proto[$117b87c540a40693$var$TO_STRING_TAG]) $2fICR($117b87c540a40693$var$proto, $117b87c540a40693$var$TO_STRING_TAG, $117b87c540a40693$var$NAME);
    $jAn1n[$117b87c540a40693$var$NAME] = $jAn1n.Array;
}

});
parcelRegister("fAKcX", function(module, exports) {
'use strict';

var $6trQN = parcelRequire("6trQN");

var $38wsA = parcelRequire("38wsA");

var $jAn1n = parcelRequire("jAn1n");

var $kOF1h = parcelRequire("kOF1h");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("f4Hks"))(Array, 'Array', function(iterated, kind) {
    this._t = $kOF1h(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $38wsA(1);
    }
    if (kind == 'keys') return $38wsA(0, index);
    if (kind == 'values') return $38wsA(0, O[index]);
    return $38wsA(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$jAn1n.Arguments = $jAn1n.Array;
$6trQN('keys');
$6trQN('values');
$6trQN('entries');

});
parcelRegister("6trQN", function(module, exports) {
module.exports = function() {};

});

parcelRegister("38wsA", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("bdk15", function(module, exports) {

$parcel$export(module.exports, "f", () => $82a06f76b6697323$export$2d1720544b23b823, (v) => $82a06f76b6697323$export$2d1720544b23b823 = v);
var $82a06f76b6697323$export$2d1720544b23b823;

$82a06f76b6697323$export$2d1720544b23b823 = (parcelRequire("jsTob"));

});



parcelRegister("8GP5W", function(module, exports) {

module.exports = {
    "default": (parcelRequire("lvq29")),
    __esModule: true
};

});
parcelRegister("lvq29", function(module, exports) {
parcelRequire("bCjQA");
parcelRequire("aNa7C");
parcelRequire("ct4oh");
parcelRequire("kKlzg");

module.exports = (parcelRequire("h9BqL")).Symbol;

});
parcelRegister("bCjQA", function(module, exports) {
'use strict';

var $ea50F = parcelRequire("ea50F");

var $2k1EH = parcelRequire("2k1EH");

var $2ZZjJ = parcelRequire("2ZZjJ");

var $1VdgD = parcelRequire("1VdgD");

var $iNFG6 = parcelRequire("iNFG6");

var $QLuwN = parcelRequire("QLuwN");
var $8752a391aba63985$require$META = $QLuwN.KEY;

var $60hL6 = parcelRequire("60hL6");

var $he9HP = parcelRequire("he9HP");

var $3BGsZ = parcelRequire("3BGsZ");

var $d07cI = parcelRequire("d07cI");

var $jsTob = parcelRequire("jsTob");

var $bdk15 = parcelRequire("bdk15");

var $e2jN7 = parcelRequire("e2jN7");

var $9QjLo = parcelRequire("9QjLo");

var $kUUlR = parcelRequire("kUUlR");

var $gH7sg = parcelRequire("gH7sg");

var $4Us5Z = parcelRequire("4Us5Z");

var $9IOcn = parcelRequire("9IOcn");

var $kOF1h = parcelRequire("kOF1h");

var $cBMOE = parcelRequire("cBMOE");

var $65sdk = parcelRequire("65sdk");

var $eP7J8 = parcelRequire("eP7J8");

var $eR1K6 = parcelRequire("eR1K6");

var $2YAEc = parcelRequire("2YAEc");

var $29Vta = parcelRequire("29Vta");

var $6SgFA = parcelRequire("6SgFA");

var $f49xG = parcelRequire("f49xG");
var $8752a391aba63985$var$gOPD = $2YAEc.f;
var $8752a391aba63985$var$dP = $6SgFA.f;
var $8752a391aba63985$var$gOPN = $eR1K6.f;
var $8752a391aba63985$var$$Symbol = $ea50F.Symbol;
var $8752a391aba63985$var$$JSON = $ea50F.JSON;
var $8752a391aba63985$var$_stringify = $8752a391aba63985$var$$JSON && $8752a391aba63985$var$$JSON.stringify;
var $8752a391aba63985$var$PROTOTYPE = 'prototype';
var $8752a391aba63985$var$HIDDEN = $jsTob('_hidden');
var $8752a391aba63985$var$TO_PRIMITIVE = $jsTob('toPrimitive');
var $8752a391aba63985$var$isEnum = {}.propertyIsEnumerable;
var $8752a391aba63985$var$SymbolRegistry = $he9HP('symbol-registry');
var $8752a391aba63985$var$AllSymbols = $he9HP('symbols');
var $8752a391aba63985$var$OPSymbols = $he9HP('op-symbols');
var $8752a391aba63985$var$ObjectProto = Object[$8752a391aba63985$var$PROTOTYPE];
var $8752a391aba63985$var$USE_NATIVE = typeof $8752a391aba63985$var$$Symbol == 'function' && !!$29Vta.f;
var $8752a391aba63985$var$QObject = $ea50F.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $8752a391aba63985$var$setter = !$8752a391aba63985$var$QObject || !$8752a391aba63985$var$QObject[$8752a391aba63985$var$PROTOTYPE] || !$8752a391aba63985$var$QObject[$8752a391aba63985$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $8752a391aba63985$var$setSymbolDesc = $2ZZjJ && $60hL6(function() {
    return $eP7J8($8752a391aba63985$var$dP({}, 'a', {
        get: function() {
            return $8752a391aba63985$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $8752a391aba63985$var$gOPD($8752a391aba63985$var$ObjectProto, key);
    if (protoDesc) delete $8752a391aba63985$var$ObjectProto[key];
    $8752a391aba63985$var$dP(it, key, D);
    if (protoDesc && it !== $8752a391aba63985$var$ObjectProto) $8752a391aba63985$var$dP($8752a391aba63985$var$ObjectProto, key, protoDesc);
} : $8752a391aba63985$var$dP;
var $8752a391aba63985$var$wrap = function(tag) {
    var sym = $8752a391aba63985$var$AllSymbols[tag] = $eP7J8($8752a391aba63985$var$$Symbol[$8752a391aba63985$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $8752a391aba63985$var$isSymbol = $8752a391aba63985$var$USE_NATIVE && typeof $8752a391aba63985$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $8752a391aba63985$var$$Symbol;
};
var $8752a391aba63985$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $8752a391aba63985$var$ObjectProto) $8752a391aba63985$var$$defineProperty($8752a391aba63985$var$OPSymbols, key, D);
    $gH7sg(it);
    key = $cBMOE(key, true);
    $gH7sg(D);
    if ($2k1EH($8752a391aba63985$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$2k1EH(it, $8752a391aba63985$var$HIDDEN)) $8752a391aba63985$var$dP(it, $8752a391aba63985$var$HIDDEN, $65sdk(1, {}));
            it[$8752a391aba63985$var$HIDDEN][key] = true;
        } else {
            if ($2k1EH(it, $8752a391aba63985$var$HIDDEN) && it[$8752a391aba63985$var$HIDDEN][key]) it[$8752a391aba63985$var$HIDDEN][key] = false;
            D = $eP7J8(D, {
                enumerable: $65sdk(0, false)
            });
        }
        return $8752a391aba63985$var$setSymbolDesc(it, key, D);
    }
    return $8752a391aba63985$var$dP(it, key, D);
};
var $8752a391aba63985$var$$defineProperties = function defineProperties(it, P) {
    $gH7sg(it);
    var keys = $9QjLo(P = $kOF1h(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$8752a391aba63985$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $8752a391aba63985$var$$create = function create(it, P) {
    return P === undefined ? $eP7J8(it) : $8752a391aba63985$var$$defineProperties($eP7J8(it), P);
};
var $8752a391aba63985$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $8752a391aba63985$var$isEnum.call(this, key = $cBMOE(key, true));
    if (this === $8752a391aba63985$var$ObjectProto && $2k1EH($8752a391aba63985$var$AllSymbols, key) && !$2k1EH($8752a391aba63985$var$OPSymbols, key)) return false;
    return E || !$2k1EH(this, key) || !$2k1EH($8752a391aba63985$var$AllSymbols, key) || $2k1EH(this, $8752a391aba63985$var$HIDDEN) && this[$8752a391aba63985$var$HIDDEN][key] ? E : true;
};
var $8752a391aba63985$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $kOF1h(it);
    key = $cBMOE(key, true);
    if (it === $8752a391aba63985$var$ObjectProto && $2k1EH($8752a391aba63985$var$AllSymbols, key) && !$2k1EH($8752a391aba63985$var$OPSymbols, key)) return;
    var D = $8752a391aba63985$var$gOPD(it, key);
    if (D && $2k1EH($8752a391aba63985$var$AllSymbols, key) && !($2k1EH(it, $8752a391aba63985$var$HIDDEN) && it[$8752a391aba63985$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $8752a391aba63985$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $8752a391aba63985$var$gOPN($kOF1h(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$2k1EH($8752a391aba63985$var$AllSymbols, key = names[i++]) && key != $8752a391aba63985$var$HIDDEN && key != $8752a391aba63985$require$META) result.push(key);
    return result;
};
var $8752a391aba63985$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $8752a391aba63985$var$ObjectProto;
    var names = $8752a391aba63985$var$gOPN(IS_OP ? $8752a391aba63985$var$OPSymbols : $kOF1h(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($2k1EH($8752a391aba63985$var$AllSymbols, key = names[i++]) && (IS_OP ? $2k1EH($8752a391aba63985$var$ObjectProto, key) : true)) result.push($8752a391aba63985$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$8752a391aba63985$var$USE_NATIVE) {
    $8752a391aba63985$var$$Symbol = function Symbol() {
        if (this instanceof $8752a391aba63985$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $d07cI(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $8752a391aba63985$var$ObjectProto) $set.call($8752a391aba63985$var$OPSymbols, value);
            if ($2k1EH(this, $8752a391aba63985$var$HIDDEN) && $2k1EH(this[$8752a391aba63985$var$HIDDEN], tag)) this[$8752a391aba63985$var$HIDDEN][tag] = false;
            $8752a391aba63985$var$setSymbolDesc(this, tag, $65sdk(1, value));
        };
        if ($2ZZjJ && $8752a391aba63985$var$setter) $8752a391aba63985$var$setSymbolDesc($8752a391aba63985$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $8752a391aba63985$var$wrap(tag);
    };
    $iNFG6($8752a391aba63985$var$$Symbol[$8752a391aba63985$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $2YAEc.f = $8752a391aba63985$var$$getOwnPropertyDescriptor;
    $6SgFA.f = $8752a391aba63985$var$$defineProperty;
    (parcelRequire("7f2RC")).f = $eR1K6.f = $8752a391aba63985$var$$getOwnPropertyNames;
    (parcelRequire("7NEQF")).f = $8752a391aba63985$var$$propertyIsEnumerable;
    $29Vta.f = $8752a391aba63985$var$$getOwnPropertySymbols;
    if ($2ZZjJ && !(parcelRequire("336Nq"))) $iNFG6($8752a391aba63985$var$ObjectProto, 'propertyIsEnumerable', $8752a391aba63985$var$$propertyIsEnumerable, true);
    $bdk15.f = function(name) {
        return $8752a391aba63985$var$wrap($jsTob(name));
    };
}
$1VdgD($1VdgD.G + $1VdgD.W + $1VdgD.F * !$8752a391aba63985$var$USE_NATIVE, {
    Symbol: $8752a391aba63985$var$$Symbol
});
for(var $8752a391aba63985$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $8752a391aba63985$var$j = 0; $8752a391aba63985$var$es6Symbols.length > $8752a391aba63985$var$j;)$jsTob($8752a391aba63985$var$es6Symbols[$8752a391aba63985$var$j++]);
for(var $8752a391aba63985$var$wellKnownSymbols = $f49xG($jsTob.store), $8752a391aba63985$var$k = 0; $8752a391aba63985$var$wellKnownSymbols.length > $8752a391aba63985$var$k;)$e2jN7($8752a391aba63985$var$wellKnownSymbols[$8752a391aba63985$var$k++]);
$1VdgD($1VdgD.S + $1VdgD.F * !$8752a391aba63985$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $2k1EH($8752a391aba63985$var$SymbolRegistry, key += '') ? $8752a391aba63985$var$SymbolRegistry[key] : $8752a391aba63985$var$SymbolRegistry[key] = $8752a391aba63985$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$8752a391aba63985$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $8752a391aba63985$var$SymbolRegistry)if ($8752a391aba63985$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $8752a391aba63985$var$setter = true;
    },
    useSimple: function() {
        $8752a391aba63985$var$setter = false;
    }
});
$1VdgD($1VdgD.S + $1VdgD.F * !$8752a391aba63985$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $8752a391aba63985$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $8752a391aba63985$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $8752a391aba63985$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $8752a391aba63985$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $8752a391aba63985$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $8752a391aba63985$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $8752a391aba63985$var$FAILS_ON_PRIMITIVES = $60hL6(function() {
    $29Vta.f(1);
});
$1VdgD($1VdgD.S + $1VdgD.F * $8752a391aba63985$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $29Vta.f($9IOcn(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$8752a391aba63985$var$$JSON && $1VdgD($1VdgD.S + $1VdgD.F * (!$8752a391aba63985$var$USE_NATIVE || $60hL6(function() {
    var S = $8752a391aba63985$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $8752a391aba63985$var$_stringify([
        S
    ]) != '[null]' || $8752a391aba63985$var$_stringify({
        a: S
    }) != '{}' || $8752a391aba63985$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$4Us5Z(replacer) && it === undefined || $8752a391aba63985$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$kUUlR(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$8752a391aba63985$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $8752a391aba63985$var$_stringify.apply($8752a391aba63985$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$8752a391aba63985$var$$Symbol[$8752a391aba63985$var$PROTOTYPE][$8752a391aba63985$var$TO_PRIMITIVE] || (parcelRequire("2fICR"))($8752a391aba63985$var$$Symbol[$8752a391aba63985$var$PROTOTYPE], $8752a391aba63985$var$TO_PRIMITIVE, $8752a391aba63985$var$$Symbol[$8752a391aba63985$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$3BGsZ($8752a391aba63985$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$3BGsZ(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$3BGsZ($ea50F.JSON, 'JSON', true);

});
parcelRegister("QLuwN", function(module, exports) {

var $09e9b23e5ce26d0f$var$META = (parcelRequire("d07cI"))('meta');

var $4Us5Z = parcelRequire("4Us5Z");

var $2k1EH = parcelRequire("2k1EH");

var $6SgFA = parcelRequire("6SgFA");
var $09e9b23e5ce26d0f$require$setDesc = $6SgFA.f;
var $09e9b23e5ce26d0f$var$id = 0;
var $09e9b23e5ce26d0f$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $09e9b23e5ce26d0f$var$FREEZE = !(parcelRequire("60hL6"))(function() {
    return $09e9b23e5ce26d0f$var$isExtensible(Object.preventExtensions({}));
});
var $09e9b23e5ce26d0f$var$setMeta = function(it) {
    $09e9b23e5ce26d0f$require$setDesc(it, $09e9b23e5ce26d0f$var$META, {
        value: {
            i: 'O' + ++$09e9b23e5ce26d0f$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $09e9b23e5ce26d0f$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$4Us5Z(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$2k1EH(it, $09e9b23e5ce26d0f$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$09e9b23e5ce26d0f$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $09e9b23e5ce26d0f$var$setMeta(it);
    // return object ID
    }
    return it[$09e9b23e5ce26d0f$var$META].i;
};
var $09e9b23e5ce26d0f$var$getWeak = function(it, create) {
    if (!$2k1EH(it, $09e9b23e5ce26d0f$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$09e9b23e5ce26d0f$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $09e9b23e5ce26d0f$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$09e9b23e5ce26d0f$var$META].w;
};
// add metadata on freeze-family methods calling
var $09e9b23e5ce26d0f$var$onFreeze = function(it) {
    if ($09e9b23e5ce26d0f$var$FREEZE && $09e9b23e5ce26d0f$var$meta.NEED && $09e9b23e5ce26d0f$var$isExtensible(it) && !$2k1EH(it, $09e9b23e5ce26d0f$var$META)) $09e9b23e5ce26d0f$var$setMeta(it);
    return it;
};
var $09e9b23e5ce26d0f$var$meta = module.exports = {
    KEY: $09e9b23e5ce26d0f$var$META,
    NEED: false,
    fastKey: $09e9b23e5ce26d0f$var$fastKey,
    getWeak: $09e9b23e5ce26d0f$var$getWeak,
    onFreeze: $09e9b23e5ce26d0f$var$onFreeze
};

});

parcelRegister("e2jN7", function(module, exports) {

var $ea50F = parcelRequire("ea50F");

var $h9BqL = parcelRequire("h9BqL");

var $336Nq = parcelRequire("336Nq");

var $bdk15 = parcelRequire("bdk15");

var $6SgFA = parcelRequire("6SgFA");
var $a3809ab5a1f78be5$require$defineProperty = $6SgFA.f;
module.exports = function(name) {
    var $Symbol = $h9BqL.Symbol || ($h9BqL.Symbol = $336Nq ? {} : $ea50F.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $a3809ab5a1f78be5$require$defineProperty($Symbol, name, {
        value: $bdk15.f(name)
    });
};

});

parcelRegister("9QjLo", function(module, exports) {
// all enumerable object keys, includes symbols

var $f49xG = parcelRequire("f49xG");

var $29Vta = parcelRequire("29Vta");

var $7NEQF = parcelRequire("7NEQF");
module.exports = function(it) {
    var result = $f49xG(it);
    var getSymbols = $29Vta.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $7NEQF.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});

parcelRegister("kUUlR", function(module, exports) {
// 7.2.2 IsArray(argument)

var $c4I03 = parcelRequire("c4I03");
module.exports = Array.isArray || function isArray(arg) {
    return $c4I03(arg) == 'Array';
};

});

parcelRegister("eR1K6", function(module, exports) {

$parcel$export(module.exports, "f", () => $ad075df79e25c0cc$export$2d1720544b23b823, (v) => $ad075df79e25c0cc$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $ad075df79e25c0cc$export$2d1720544b23b823;

var $kOF1h = parcelRequire("kOF1h");

var $7f2RC = parcelRequire("7f2RC");
var $ad075df79e25c0cc$require$gOPN = $7f2RC.f;
var $ad075df79e25c0cc$var$toString = {}.toString;
var $ad075df79e25c0cc$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $ad075df79e25c0cc$var$getWindowNames = function(it) {
    try {
        return $ad075df79e25c0cc$require$gOPN(it);
    } catch (e) {
        return $ad075df79e25c0cc$var$windowNames.slice();
    }
};
$ad075df79e25c0cc$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $ad075df79e25c0cc$var$windowNames && $ad075df79e25c0cc$var$toString.call(it) == '[object Window]' ? $ad075df79e25c0cc$var$getWindowNames(it) : $ad075df79e25c0cc$require$gOPN($kOF1h(it));
};

});
parcelRegister("7f2RC", function(module, exports) {

$parcel$export(module.exports, "f", () => $545c27cb2d1e3586$export$2d1720544b23b823, (v) => $545c27cb2d1e3586$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $545c27cb2d1e3586$export$2d1720544b23b823;

var $56isG = parcelRequire("56isG");

var $545c27cb2d1e3586$var$hiddenKeys = (parcelRequire("clOgA")).concat('length', 'prototype');
$545c27cb2d1e3586$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $56isG(O, $545c27cb2d1e3586$var$hiddenKeys);
};

});


parcelRegister("2YAEc", function(module, exports) {

$parcel$export(module.exports, "f", () => $22ad9cc291bf8d00$export$2d1720544b23b823, (v) => $22ad9cc291bf8d00$export$2d1720544b23b823 = v);
var $22ad9cc291bf8d00$export$2d1720544b23b823;

var $7NEQF = parcelRequire("7NEQF");

var $65sdk = parcelRequire("65sdk");

var $kOF1h = parcelRequire("kOF1h");

var $cBMOE = parcelRequire("cBMOE");

var $2k1EH = parcelRequire("2k1EH");

var $d5nHr = parcelRequire("d5nHr");
var $22ad9cc291bf8d00$var$gOPD = Object.getOwnPropertyDescriptor;

$22ad9cc291bf8d00$export$2d1720544b23b823 = (parcelRequire("2ZZjJ")) ? $22ad9cc291bf8d00$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $kOF1h(O);
    P = $cBMOE(P, true);
    if ($d5nHr) try {
        return $22ad9cc291bf8d00$var$gOPD(O, P);
    } catch (e) {}
    if ($2k1EH(O, P)) return $65sdk(!$7NEQF.f.call(O, P), O[P]);
};

});


parcelRegister("aNa7C", function(module, exports) {

});

parcelRegister("ct4oh", function(module, exports) {

(parcelRequire("e2jN7"))('asyncIterator');

});

parcelRegister("kKlzg", function(module, exports) {

(parcelRequire("e2jN7"))('observable');

});





parcelRegister("2G5Ta", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $1f341269e45c3877$export$1e511d4a378977f5, (v) => $1f341269e45c3877$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $1f341269e45c3877$export$2e2bcd8739ae039, (v) => $1f341269e45c3877$export$2e2bcd8739ae039 = v);
var $1f341269e45c3877$export$1e511d4a378977f5;
var $1f341269e45c3877$export$2e2bcd8739ae039;
"use strict";
$1f341269e45c3877$export$1e511d4a378977f5 = true;

var $4tXXW = parcelRequire("4tXXW");
var $1f341269e45c3877$var$_setPrototypeOf2 = $1f341269e45c3877$var$_interopRequireDefault($4tXXW);

var $eaYGn = parcelRequire("eaYGn");
var $1f341269e45c3877$var$_create2 = $1f341269e45c3877$var$_interopRequireDefault($eaYGn);

var $f3S2g = parcelRequire("f3S2g");
var $1f341269e45c3877$var$_typeof3 = $1f341269e45c3877$var$_interopRequireDefault($f3S2g);
function $1f341269e45c3877$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$1f341269e45c3877$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $1f341269e45c3877$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $1f341269e45c3877$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1f341269e45c3877$var$_setPrototypeOf2.default ? (0, $1f341269e45c3877$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("4tXXW", function(module, exports) {

module.exports = {
    "default": (parcelRequire("hEveR")),
    __esModule: true
};

});
parcelRegister("hEveR", function(module, exports) {
parcelRequire("iNGqd");

module.exports = (parcelRequire("h9BqL")).Object.setPrototypeOf;

});
parcelRegister("iNGqd", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $1VdgD = parcelRequire("1VdgD");

$1VdgD($1VdgD.S, 'Object', {
    setPrototypeOf: (parcelRequire("6B4nF")).set
});

});
parcelRegister("6B4nF", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $4Us5Z = parcelRequire("4Us5Z");

var $gH7sg = parcelRequire("gH7sg");
var $4cd998ad50462ac3$var$check = function(O, proto) {
    $gH7sg(O);
    if (!$4Us5Z(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("hFYx0"))(Function.call, (parcelRequire("2YAEc")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $4cd998ad50462ac3$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $4cd998ad50462ac3$var$check
};

});




parcelRegister("eaYGn", function(module, exports) {

module.exports = {
    "default": (parcelRequire("d9SSJ")),
    __esModule: true
};

});
parcelRegister("d9SSJ", function(module, exports) {
parcelRequire("bDxet");

var $h9BqL = parcelRequire("h9BqL");
var $9946affdaea0a35f$require$$Object = $h9BqL.Object;
module.exports = function create(P, D) {
    return $9946affdaea0a35f$require$$Object.create(P, D);
};

});
parcelRegister("bDxet", function(module, exports) {

var $1VdgD = parcelRequire("1VdgD");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$1VdgD($1VdgD.S, 'Object', {
    create: (parcelRequire("eP7J8"))
});

});




parcelRegister("1MbhJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $14b3071638f015d3$var$createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/ function $14b3071638f015d3$var$createDetectElementResize(nonce, hostWindow) {
    // Check `document` and `window` in case of server-side rendering
    var _window;
    if (typeof hostWindow !== 'undefined') _window = hostWindow;
    else if (typeof window !== 'undefined') _window = window;
    else if (typeof self !== 'undefined') _window = self;
    else _window = $parcel$global;
    var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;
    if (!attachEvent) {
        var requestFrame = function() {
            var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function(fn) {
                return _window.setTimeout(fn, 20);
            };
            return function(fn) {
                return raf(fn);
            };
        }();
        var cancelFrame = function() {
            var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
            return function(id) {
                return cancel(id);
            };
        }();
        var resetTriggers = function resetTriggers(element) {
            var triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + 'px';
            expandChild.style.height = expand.offsetHeight + 1 + 'px';
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };
        var checkTriggers = function checkTriggers(element) {
            return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
        };
        var scrollListener = function scrollListener(e) {
            // Don't measure (which forces) reflow for scrolls that happen inside of children!
            if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) return;
            var element = this;
            resetTriggers(this);
            if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
            this.__resizeRAF__ = requestFrame(function() {
                if (checkTriggers(element)) {
                    element.__resizeLast__.width = element.offsetWidth;
                    element.__resizeLast__.height = element.offsetHeight;
                    element.__resizeListeners__.forEach(function(fn) {
                        fn.call(element, e);
                    });
                }
            });
        };
        /* Detect CSS Animations support to detect element display/re-attach */ var animation = false, keyframeprefix = '', animationstartevent = 'animationstart', domPrefixes = 'Webkit Moz O ms'.split(' '), startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '), pfx = '';
        var elm = _window.document.createElement('fakeelement');
        if (elm.style.animationName !== undefined) animation = true;
        if (animation === false) {
            for(var i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                pfx = domPrefixes[i];
                keyframeprefix = '-' + pfx.toLowerCase() + '-';
                animationstartevent = startEvents[i];
                animation = true;
                break;
            }
        }
        var animationName = 'resizeanim';
        var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
        var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
    }
    var createStyles = function createStyles(doc) {
        if (!doc.getElementById('detectElementResize')) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName('head')[0], style = doc.createElement('style');
            style.id = 'detectElementResize';
            style.type = 'text/css';
            if (nonce != null) style.setAttribute('nonce', nonce);
            if (style.styleSheet) style.styleSheet.cssText = css;
            else style.appendChild(doc.createTextNode(css));
            head.appendChild(style);
        }
    };
    var addResizeListener = function addResizeListener(element, fn) {
        if (attachEvent) element.attachEvent('onresize', fn);
        else {
            if (!element.__resizeTriggers__) {
                var doc = element.ownerDocument;
                var elementStyle = _window.getComputedStyle(element);
                if (elementStyle && elementStyle.position == 'static') element.style.position = 'relative';
                createStyles(doc);
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
                element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener('scroll', scrollListener, true);
                // Store reference to original instantiated scrollListener so it can be unbound later
                element.__scrollListener__ = scrollListener;
                /* Listen for a css animation to detect element display/re-attach */ if (animationstartevent) {
                    element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                        if (e.animationName == animationName) resetTriggers(element);
                    };
                    element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                }
            }
            element.__resizeListeners__.push(fn);
        }
    };
    var removeResizeListener = function removeResizeListener(element, fn) {
        if (attachEvent) element.detachEvent('onresize', fn);
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if (!element.__resizeListeners__.length) {
                if (element.__scrollListener__) element.removeEventListener('scroll', element.__scrollListener__, true);
                if (element.__resizeTriggers__.__animationListener__) {
                    element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                    element.__resizeTriggers__.__animationListener__ = null;
                }
                try {
                    element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                } catch (e) {
                // Preact compat; see developit/preact-compat/issues/228
                }
            }
        }
    };
    return {
        addResizeListener: addResizeListener,
        removeResizeListener: removeResizeListener
    };
}

});




parcelRegister("13uzg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d5efdf6e18e32b8$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $aKfba = parcelRequire("aKfba");

var $7jTnu = parcelRequire("7jTnu");

var $aIrSA = parcelRequire("aIrSA");

var $kcVGc = parcelRequire("kcVGc");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $02dWc = parcelRequire("02dWc");

var $5wAOx = parcelRequire("5wAOx");

var $e3Dho = parcelRequire("e3Dho");

var $ZcZOG = parcelRequire("ZcZOG");

var $e8ODd = parcelRequire("e8ODd");

var $iqRRD = parcelRequire("iqRRD");

var $HfKm7 = parcelRequire("HfKm7");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4d5efdf6e18e32b8$var$mapStateToPropsFactory = ()=>{
    const onTableChangeFactory = (0, $LFmXM.default)((containerWidth, tableHasHorizontalScrollbar, tableHasVerticalScrollbar)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (analyticsEvent)=>{
            (0, $aKfba.fireOperationalAnalytics)(analyticsEvent, {
                containerType: 'virtualTable',
                attributes: {
                    hasHorizontalScrollbar: tableHasHorizontalScrollbar,
                    hasVerticalScrollbar: tableHasVerticalScrollbar,
                    containerWidth: containerWidth
                }
            });
        });
    return (state)=>{
        const rowIds = (0, $02dWc.getFlattenedWithAddedRowIds)(state);
        const firstRowId = rowIds[0];
        const containerWidth = (0, $atQRE.getTableWidthWithoutScrollbarOffset)(state);
        const tableHasHorizontalScrollbar = (0, $fRJOe.hasHorizontalScrollbar)(state);
        const tableHasVerticalScrollbar = (0, $fRJOe.hasVerticalScrollbar)(state);
        return {
            rowIds: rowIds,
            width: (0, $fRJOe.getTableContentWidth)(state),
            containerWidth: containerWidth,
            hasHorizontalScrollbar: tableHasHorizontalScrollbar,
            hasVerticalScrollbar: tableHasVerticalScrollbar,
            hasLoadingRows: (0, $kcVGc.isRowLoading)(state, firstRowId),
            shouldUseCssForRendering: (0, $atQRE.getShouldUseCssForRendering)(state),
            ariaLabel: (0, $7jTnu.fg)('jsm_virtual_table_a11y') ? (0, $5wAOx.getAriaLabel)(state) : undefined,
            Header: $ZcZOG.default,
            Content: $e3Dho.default,
            ResizeColumnOverlay: $HfKm7.default,
            HorizontalScrollOverlay: $iqRRD.default,
            onTableChange: onTableChangeFactory(containerWidth, tableHasHorizontalScrollbar, tableHasVerticalScrollbar)
        };
    };
};
var $4d5efdf6e18e32b8$export$2e2bcd8739ae039 = (0, $aIrSA.connect)($4d5efdf6e18e32b8$var$mapStateToPropsFactory, {})((0, $e8ODd.default));

});
parcelRegister("e3Dho", function(module, exports) {

$parcel$export(module.exports, "default", () => $439a4aa47854d643$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $5wAOx = parcelRequire("5wAOx");

var $fRJOe = parcelRequire("fRJOe");

var $9RVNI = parcelRequire("9RVNI");
var $439a4aa47854d643$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        isHorizontalScrollVisible: (0, $fRJOe.hasHorizontalScrollbar)(state),
        isContentStale: (0, $5wAOx.isContentStale)(state),
        shouldHideLoadingIndicator: (0, $5wAOx.shouldHideLoadingIndicator)(state)
    }), {})((0, $9RVNI.default));

});
parcelRegister("9RVNI", function(module, exports) {

$parcel$export(module.exports, "default", () => $28bb2dd3d2598584$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $7jTnu = parcelRequire("7jTnu");

var $i1eKe = parcelRequire("i1eKe");

var $2YwGn = parcelRequire("2YwGn");

var $jFGS2 = parcelRequire("jFGS2");

var $169hq = parcelRequire("169hq");

var $1VxmX = parcelRequire("1VxmX");

var $aDJPf = parcelRequire("aDJPf");
function $28bb2dd3d2598584$var$Content(props) {
    const { isHorizontalScrollVisible: isHorizontalScrollVisible, isContentStale: isContentStale, shouldHideLoadingIndicator: shouldHideLoadingIndicator, theme: theme } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($28bb2dd3d2598584$var$Wrapper, null, false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _4t3i1vmz"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($28bb2dd3d2598584$export$f185744748c379a7, {
        theme: theme,
        ...(0, $7jTnu.fg)('jsm_virtual_table_a11y') && {
            role: 'rowgroup'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jFGS2.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aDJPf.default), null)), isContentStale && // @ts-expect-error - TS2322 - Type '{ shouldHideLoadingIndicator: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<Omit<DispatchProp<any>, "dispatch">, any, any>> & Readonly<...> & Readonly<...>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2YwGn.default), {
        shouldHideLoadingIndicator: shouldHideLoadingIndicator
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1VxmX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($28bb2dd3d2598584$export$f185744748c379a7, {
        theme: theme,
        ...(0, $7jTnu.fg)('jsm_virtual_table_a11y') && {
            role: 'rowgroup'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jFGS2.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aDJPf.default), null)), isContentStale && // @ts-expect-error - TS2322 - Type '{ shouldHideLoadingIndicator: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<Omit<DispatchProp<any>, "dispatch">, any, any>> & Readonly<...> & Readonly<...>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2YwGn.default), {
        shouldHideLoadingIndicator: shouldHideLoadingIndicator
    })), isHorizontalScrollVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($28bb2dd3d2598584$var$HorizontalScrollBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $169hq.default), null)));
}
$28bb2dd3d2598584$var$Content.defaultProps = {
    isContentStale: false,
    shouldHideLoadingIndicator: false
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $28bb2dd3d2598584$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.className
        ])
    });
});
const $28bb2dd3d2598584$var$hiddenScrollBarsStyles = null;
const $28bb2dd3d2598584$export$f185744748c379a7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_jveve7": (0, $awdRS.default)(__cmplp.theme.row.useCssHover ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : 'inherit')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_u5f3xy5q _tjnf1153",
            __cmplp.className
        ])
    });
});
const $28bb2dd3d2598584$var$HorizontalScrollBarWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyru2gc _19pkutpp _n3td1b66 _kqswh2mm",
            __cmplp.className
        ])
    });
});
var $28bb2dd3d2598584$export$2e2bcd8739ae039 = (0, $i1eKe.withTheme)($28bb2dd3d2598584$var$Content);

});
parcelRegister("2YwGn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f508cd7cbd302571$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $atQRE = parcelRequire("atQRE");

var $lwiUJ = parcelRequire("lwiUJ");
var // @ts-expect-error - Expected 2-4 arguments, but got 1.
$f508cd7cbd302571$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        scrollOffset: (0, $atQRE.getVerticalScrollOffset)(state),
        width: (0, $atQRE.getTableWidthWithoutScrollbarOffset)(state)
    }))((0, $lwiUJ.default));

});
parcelRegister("lwiUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd340dc90c9e1dfb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $a4krS = parcelRequire("a4krS");
const $bd340dc90c9e1dfb$var$SPINNER_DELAY = 500;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bd340dc90c9e1dfb$export$2e2bcd8739ae039 = ({ shouldHideLoadingIndicator: shouldHideLoadingIndicator, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a4krS.Blanket), props, shouldHideLoadingIndicator ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        delay: $bd340dc90c9e1dfb$var$SPINNER_DELAY,
        size: "large"
    }));

});
parcelRegister("a4krS", function(module, exports) {

$parcel$export(module.exports, "Blanket", () => $b287b55aceef17b6$export$5b927fc1ef8c468b);
/* styles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");
const $b287b55aceef17b6$var$baseStyle = null;
const $b287b55aceef17b6$export$5b927fc1ef8c468b = ({ scrollOffset: scrollOffset, width: width, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        style: {
            top: `${scrollOffset}px`,
            bottom: `${-scrollOffset}px`,
            width: (0, $7jTnu.fg)('css_support_for_virtual_table') ? `${width}px` : `${width}px !important`
        },
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _tzy4txnc _bfhkvuon _kqswstnw _1pbyouyt"
        ])
    }, children);

});



parcelRegister("jFGS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $50201162864bff11$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $dZqHT = parcelRequire("dZqHT");

var $3z7Cz = parcelRequire("3z7Cz");

var $5I3Lx = parcelRequire("5I3Lx");

var $5wAOx = parcelRequire("5wAOx");

var $9lqzG = parcelRequire("9lqzG");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $fLubS = parcelRequire("fLubS");

var $ff0G1 = parcelRequire("ff0G1");

var $c8xUP = parcelRequire("c8xUP");
var $50201162864bff11$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        isAutoHeight: (0, $5wAOx.isAutoHeight)(state),
        maxHorizontalScrollOffset: (0, $fRJOe.getMaxHorizontalScrollOffset)(state),
        onRowListFocusFunctionChanged: (0, $5wAOx.getOnRowListFocusFunctionChangedCallback)(state),
        onReactPortalContainerRefChanged: (0, $5wAOx.getOnReactPortalContainerRefChangedCallback)(state),
        horizontalScrollOffset: (0, $atQRE.getHorizontalScrollOffset)(state),
        navigationMode: (0, $5wAOx.getNavigationMode)(state),
        AutoHeightList: $fLubS.default,
        VirtualList: $c8xUP.default
    }), {
    setHorizontalScrollOffset: $3z7Cz.setHorizontal,
    setScrollbarSize: $5I3Lx.set,
    navigateToRow: $dZqHT.navigateToRow,
    clearActiveItem: $9lqzG.clearActiveItem
})((0, $ff0G1.default));

});
parcelRegister("dZqHT", function(module, exports) {

$parcel$export(module.exports, "NAVIGATE_TO_ROW", () => $ce3baf3a688c563c$export$4b025a6245795408);
$parcel$export(module.exports, "navigateToRow", () => $ce3baf3a688c563c$export$2b9abf839c94a6c4);
const $ce3baf3a688c563c$export$4b025a6245795408 = 'ops.rows.navigate.NAVIGATE_TO_ROW';
const $ce3baf3a688c563c$export$2b9abf839c94a6c4 = (payload)=>({
        type: $ce3baf3a688c563c$export$4b025a6245795408,
        payload: payload
    });

});

parcelRegister("5I3Lx", function(module, exports) {

$parcel$export(module.exports, "SET_SCROLLBAR_SIZE", () => $099d4cf2d142f76f$export$1343829730561bf3);
$parcel$export(module.exports, "set", () => $099d4cf2d142f76f$export$adaa4cf7ef1b65be);
const $099d4cf2d142f76f$export$1343829730561bf3 = 'ops.scrolling.size.SET_SCROLLBAR_SIZE';
const $099d4cf2d142f76f$export$adaa4cf7ef1b65be = (payload)=>({
        type: $099d4cf2d142f76f$export$1343829730561bf3,
        payload: payload
    });

});

parcelRegister("fLubS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce654ba9c1c08df8$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $02dWc = parcelRequire("02dWc");

var $0qCUH = parcelRequire("0qCUH");

var $gdGcD = parcelRequire("gdGcD");
var $ce654ba9c1c08df8$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        rowIds: (0, $02dWc.getFlattenedWithAddedRowIds)(state),
        List: $0qCUH.default
    }), {})((0, $gdGcD.default));

});
parcelRegister("0qCUH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d957d027c7f0740d$export$2e2bcd8739ae039);

var $ahm5r = parcelRequire("ahm5r");

var $cSmYj = parcelRequire("cSmYj");

var $12DRg = parcelRequire("12DRg");

var $dQ0E3 = parcelRequire("dQ0E3");

var $aKfba = parcelRequire("aKfba");

var $aIrSA = parcelRequire("aIrSA");

var $2Ctxl = parcelRequire("2Ctxl");

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $fRJOe = parcelRequire("fRJOe");

var $gDPC5 = parcelRequire("gDPC5");

var $7tX31 = parcelRequire("7tX31");
const $d957d027c7f0740d$var$ASSIGNEE_COLUMN = 'assignee';
const $d957d027c7f0740d$export$8c7854b27b9ed844 = (analyticsDataByColumns)=>{
    const groupedData = {
        minDisplayStart: Number.MAX_SAFE_INTEGER,
        maxDisplayEnd: 0,
        groups: {}
    };
    analyticsDataByColumns.forEach((analyticsData)=>{
        const { mountBeginTime: mountBeginTime, mountEndTime: mountEndTime, displayStart: displayStart, displayEnd: displayEnd } = analyticsData;
        const batchSize = analyticsDataByColumns.filter((v)=>v.displayStart === displayStart).length;
        groupedData.minDisplayStart = Math.min(displayStart, groupedData.minDisplayStart);
        groupedData.maxDisplayEnd = Math.max(displayEnd, groupedData.maxDisplayEnd);
        // group each data by the display boundary and calculate the avg time for each group
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
        if (!groupedData.groups[displayStart]) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
        groupedData.groups[displayStart] = {
            startTime: mountBeginTime,
            endTime: mountEndTime,
            meanMountTime: (mountEndTime - mountBeginTime) / batchSize
        };
        else {
            // Always take the earliest begin and end times
            const newStartTime = Math.min(mountBeginTime, // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            groupedData.groups[displayStart].startTime);
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            const newEndTime = Math.min(mountEndTime, groupedData.groups[displayStart].endTime);
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            groupedData.groups[displayStart].startTime = newStartTime;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            groupedData.groups[displayStart].endTime = newEndTime;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{}'.
            groupedData.groups[displayStart].meanMountTime = (newEndTime - newStartTime) / batchSize;
        }
    });
    return groupedData;
};
const $d957d027c7f0740d$export$432f698644f45d1 = (groupedData)=>{
    const sortedMountTimes = Object.values(groupedData.groups).map((v)=>v.meanMountTime).sort((a, b)=>a - b);
    const dataLength = sortedMountTimes.length;
    return {
        median: Math.round(sortedMountTimes[Math.floor(dataLength / 2)]),
        perc90: Math.round(sortedMountTimes[Math.floor(dataLength * 0.9)]),
        perc95: Math.round(sortedMountTimes[Math.floor(dataLength * 0.95)]),
        max: Math.round(sortedMountTimes[dataLength - 1])
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d957d027c7f0740d$var$fireRowMountAnalytics = (accumulatedRowAnalyticsData)=>{
    // if the user added/removed columns or switched to a different list that has different number of columns
    // fire the analytics separately for each of them
    const uniqueColumns = (0, (/*@__PURE__*/$parcel$interopDefault($dQ0E3)))(// @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
    accumulatedRowAnalyticsData.map((v)=>v.columns), (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj))));
    // Get the metrics for each batch grouped by no. of columns
    uniqueColumns.forEach((columnArray)=>{
        // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
        const analyticsDataByColumns = accumulatedRowAnalyticsData.filter((v)=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(v.columns, columnArray));
        const { columns: columns, numberOfColumns: numberOfColumns, numberOfRows: numberOfRows, analyticsEvent: analyticsEvent } = analyticsDataByColumns[0];
        const hasNewAssigneeField = columns.includes($d957d027c7f0740d$var$ASSIGNEE_COLUMN);
        const groupedData = $d957d027c7f0740d$export$8c7854b27b9ed844(analyticsDataByColumns);
        const { median: median, perc90: perc90, perc95: perc95, max: max } = $d957d027c7f0740d$export$432f698644f45d1(groupedData);
        (0, $aKfba.fireOperationalAnalytics)(analyticsEvent, {
            containerType: 'virtualTable',
            attributes: {
                totalNoOfRowsInTable: numberOfRows,
                columns: columns,
                numberOfColumns: numberOfColumns,
                numberOfRowsInEvent: analyticsDataByColumns.length,
                medianTimeTakenToMount: median,
                perc90TimeTakenToMount: perc90,
                perc95TimeTakenToMount: perc95,
                maxTimeTakenToMount: max,
                minDisplayStart: groupedData.minDisplayStart,
                maxDisplayEnd: groupedData.maxDisplayEnd,
                hasNewAssigneeField: hasNewAssigneeField
            }
        });
    });
};
const $d957d027c7f0740d$var$getVisibleCoreColumnIdsMemoized = ()=>(0, $ahm5r.createSelector)((state)=>[].concat(// @ts-expect-error - TS2769 - No overload matches this call.
        (0, $2Ctxl.getVisibleCoreColumnIds)(state), (0, $5wAOx.getVisibleAdditionalColumnIds)(state)), (res)=>res);
const $d957d027c7f0740d$var$mapStateToPropsFactory = ()=>{
    const getVisibleCoreColumnIdsInstance = $d957d027c7f0740d$var$getVisibleCoreColumnIdsMemoized();
    return (state)=>{
        const hasAutoHeight = (0, $5wAOx.isAutoHeight)(state);
        const onRowContentMount = // only when table is virtualised
        !hasAutoHeight && (0, $fRJOe.getShouldVirtualize)(state) ? $d957d027c7f0740d$var$fireRowMountAnalytics : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
        return {
            addBarOverflow: (0, $kcVGc.getAddBarOverflow)(state),
            temporaryAddedRow: (0, $kcVGc.getTemporaryAddedRow)(state),
            rowHeightMapping: (0, $kcVGc.getRowHeightMapping)(state),
            absoluteRowHeight: (0, $kcVGc.getAbsoluteRowHeight)(state),
            defaultRowHeight: (0, $kcVGc.getDefaultRowHeight)(state),
            lastRowHasAddBar: (0, $fRJOe.canLastRowAddSiblingOrChildren)(state),
            addLinkShown: (0, $fRJOe.isAddLinkShown)(state),
            visibleColumns: getVisibleCoreColumnIdsInstance(state),
            onRowContentMount: onRowContentMount,
            RowItem: $7tX31.default,
            rowsConfiguration: (0, $kcVGc.getRowsConfiguration)(state)
        };
    };
};
var $d957d027c7f0740d$export$2e2bcd8739ae039 = (0, $aIrSA.connect)($d957d027c7f0740d$var$mapStateToPropsFactory, {})((0, $gDPC5.default));

});
parcelRegister("dQ0E3", function(module, exports) {

var $1txRh = parcelRequire("1txRh");
/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */ function $a130a1c1c30b127c$var$uniqWith(array, comparator) {
    comparator = typeof comparator == 'function' ? comparator : undefined;
    return array && array.length ? $1txRh(array, undefined, comparator) : [];
}
module.exports = $a130a1c1c30b127c$var$uniqWith;

});

parcelRegister("gDPC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $29954eb155631f45$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $3s8bj = parcelRequire("3s8bj");

var $fwzaq = parcelRequire("fwzaq");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $6uWhG = parcelRequire("6uWhG");

var $bJscI = parcelRequire("bJscI");

var $i1eKe = parcelRequire("i1eKe");
const $29954eb155631f45$var$ANALYTICS_DEBOUNCE_TIME = 5000;
const $29954eb155631f45$var$INITIAL_RENDER_ROWS_LIMIT = 100;
const $29954eb155631f45$var$SEGMENT_KEY = 'virtual-table.table.content.virtual-table-row-list-portal.wrapper';
// eslint-disable-next-line jira/react/no-class-components
class $29954eb155631f45$var$RowListOld extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.fireRowMountAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            this.props.onRowContentMount(this.accumulatedRowAnalyticsData);
            this.accumulatedRowAnalyticsData = [];
        }, $29954eb155631f45$var$ANALYTICS_DEBOUNCE_TIME), this.gatherRowMountAnalyticsData = (mountBeginTime, mountEndTime, columns, numberOfColumns, analyticsEvent)=>{
            const { displayStart: displayStart, displayEnd: displayEnd } = this.props;
            if (!displayStart) return;
            this.accumulatedRowAnalyticsData.push({
                displayStart: displayStart,
                displayEnd: displayEnd,
                mountBeginTime: mountBeginTime,
                mountEndTime: mountEndTime,
                columns: columns.slice(0).sort(),
                numberOfColumns: numberOfColumns,
                numberOfRows: this.state.rowIds.length,
                analyticsEvent: analyticsEvent
            });
            this.fireRowMountAnalytics();
        };
        const { rowIds: rowIds, displayStart: displayStart, displayEnd: displayEnd, visibleColumns: visibleColumns } = props;
        this.state = {
            rowIds: rowIds
        };
        this.accumulatedRowAnalyticsData = [];
        // TODO: Remove this once we have sufficient numbers for performance profiling
        const rowsRendered = displayEnd - displayStart + 1;
        const columnsRendered = visibleColumns.length;
        (0, $6uWhG.setMark)(`virtualtable.rowlist.render.${rowsRendered * columnsRendered}.(${rowsRendered}x${columnsRendered}).cells.start`);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { rowIds: rowIds, displayStart: displayStart, displayEnd: displayEnd } = this.props;
        // if the incoming rows are different
        if (rowIds !== nextProps.rowIds || displayStart !== nextProps.displayStart || displayEnd !== nextProps.displayEnd) this.resetState(nextProps.rowIds);
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { displayStart: displayStart, displayEnd: displayEnd } = this.props;
        return displayStart !== nextProps.displayStart || displayEnd !== nextProps.displayEnd || this.state.rowIds !== nextState.rowIds;
    }
    resetState(rowIds) {
        this.setState({
            rowIds: rowIds
        });
    }
    renderRows() {
        const { displayStart: displayStart, displayEnd: displayEnd, temporaryAddedRow: temporaryAddedRow, RowItem: RowItem, absoluteRowHeight: absoluteRowHeight, rowHeightMapping: rowHeightMapping, onRowContentUpdate: onRowContentUpdate, onLoadingRowUnmount: onLoadingRowUnmount } = this.props;
        const { rowIds: rowIds } = this.state;
        const rows = [];
        const numberOfRows = rowIds.length - 1;
        const alwaysVisibleRows = {
            [rowIds[0]]: true,
            [rowIds[numberOfRows]]: true,
            ...temporaryAddedRow && {
                [temporaryAddedRow.temporaryId]: true
            }
        };
        let spacerHeight = 0;
        let spacerStartRow = null;
        for(let index = 0; index <= numberOfRows; index += 1){
            const isAlwaysVisible = alwaysVisibleRows[rowIds[index]];
            const isDisplay = index >= displayStart && index <= displayEnd;
            if (isAlwaysVisible || isDisplay) {
                if (spacerHeight > 0 && spacerStartRow) {
                    // by using a key which is virtual row range it represents,
                    // it can still be usefully reconciled (during dragging for example)
                    const spacerKey = `${spacerStartRow}${rowIds[index - 1]}`;
                    rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($29954eb155631f45$var$Spacer, {
                        "data-testId": `${$29954eb155631f45$var$SEGMENT_KEY}.spacer`,
                        key: spacerKey,
                        height: spacerHeight
                    }));
                    spacerHeight = 0;
                    spacerStartRow = null;
                }
                rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RowItem, {
                    key: rowIds[index],
                    id: rowIds[index],
                    rowIndex: index,
                    onRowContentMount: this.gatherRowMountAnalyticsData,
                    onRowContentUpdate: onRowContentUpdate,
                    onLoadingRowUnmount: onLoadingRowUnmount
                }));
            } else {
                spacerHeight += rowHeightMapping[rowIds[index]] || absoluteRowHeight;
                spacerStartRow = rowIds[index];
            }
        }
        return rows;
    }
    renderInitialRows() {
        const { RowItem: RowItem, defaultRowHeight: defaultRowHeight, onRowContentUpdate: onRowContentUpdate, onLoadingRowUnmount: onLoadingRowUnmount, rowsConfiguration: rowsConfiguration } = this.props;
        const { rowIds: rowIds } = this.state;
        const rows = [];
        let index = 0;
        for(index; index < rowIds.length; index += 1){
            // we want to render all available rows that are not in a loading state, but no more than 100
            if (index >= $29954eb155631f45$var$INITIAL_RENDER_ROWS_LIMIT || rowsConfiguration[rowIds[index]] && rowsConfiguration[rowIds[index]].isLoading) break;
            rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RowItem, {
                key: rowIds[index],
                id: rowIds[index],
                rowIndex: index,
                onRowContentMount: this.gatherRowMountAnalyticsData,
                onRowContentUpdate: onRowContentUpdate,
                onLoadingRowUnmount: onLoadingRowUnmount
            }));
        }
        const notRenderedRows = rowIds.length - index;
        if (notRenderedRows > 0) {
            const spacerKey = `${rowIds[index]}-${rowIds[rowIds.length - 1]}`;
            const spacerHeight = notRenderedRows * defaultRowHeight;
            rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($29954eb155631f45$var$Spacer, {
                "data-testId": `${$29954eb155631f45$var$SEGMENT_KEY}.spacer`,
                key: spacerKey,
                height: spacerHeight
            }));
        }
        return rows;
    }
    render() {
        const { displayStart: displayStart, addBarOverflow: addBarOverflow, lastRowHasAddBar: lastRowHasAddBar, addLinkShown: addLinkShown, theme: theme } = this.props;
        const rows = displayStart === 0 && (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? this.renderInitialRows() : this.renderRows();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($29954eb155631f45$var$Wrapper, {
            addPadding: lastRowHasAddBar || addLinkShown,
            addBarOverflow: addBarOverflow,
            theme: theme,
            "data-testId": (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? $29954eb155631f45$var$SEGMENT_KEY : undefined,
            "data-vc": (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? `${$29954eb155631f45$var$SEGMENT_KEY}${false ? '-ssr' : ''}` : undefined,
            "data-ssr-placeholder": false && (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? $29954eb155631f45$var$SEGMENT_KEY : undefined,
            "data-ssr-placeholder-replace": false || !(0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? undefined : $29954eb155631f45$var$SEGMENT_KEY
        }, rows);
    }
}
function $29954eb155631f45$var$RowList({ absoluteRowHeight: absoluteRowHeight, addBarOverflow: addBarOverflow, addLinkShown: addLinkShown, defaultRowHeight: defaultRowHeight, displayEnd: displayEnd, displayStart: displayStart, lastRowHasAddBar: lastRowHasAddBar, onLoadingRowUnmount: onLoadingRowUnmount, onRowContentMount: onRowContentMount, onRowContentUpdate: onRowContentUpdate, RowItem: RowItem, rowsConfiguration: rowsConfiguration, rowHeightMapping: rowHeightMapping, rowIds: rowIds, temporaryAddedRow: temporaryAddedRow, theme: theme, visibleColumns: visibleColumns }) {
    const { current: accumulatedRowAnalyticsData } = (0, $eJOHy.useRef)(new Set());
    const markRef = (0, $eJOHy.useRef)(false);
    const [fireRowMountAnalytics] = (0, $fwzaq.default)((analytics)=>{
        onRowContentMount(analytics);
        accumulatedRowAnalyticsData.clear();
    }, $29954eb155631f45$var$ANALYTICS_DEBOUNCE_TIME);
    const gatherRowMountAnalyticsData = (0, $eJOHy.useCallback)((mountBeginTime, mountEndTime, columns, numberOfColumns, analyticsEvent)=>{
        if (!displayStart) return;
        accumulatedRowAnalyticsData.add({
            displayStart: displayStart,
            displayEnd: displayEnd,
            mountBeginTime: mountBeginTime,
            mountEndTime: mountEndTime,
            columns: columns.slice(0).sort(),
            numberOfColumns: numberOfColumns,
            numberOfRows: rowIds.length,
            analyticsEvent: analyticsEvent
        });
        fireRowMountAnalytics(Array.from(accumulatedRowAnalyticsData));
    }, [
        accumulatedRowAnalyticsData,
        displayEnd,
        displayStart,
        fireRowMountAnalytics,
        rowIds.length
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (markRef.current) return;
        const rowsRendered = displayEnd - displayStart + 1;
        const columnsRendered = visibleColumns.length;
        (0, $6uWhG.setMark)(`virtualtable.rowlist.render.${rowsRendered * columnsRendered}.(${rowsRendered}x${columnsRendered}).cells.start`);
        markRef.current = true;
    }, [
        displayEnd,
        displayStart,
        visibleColumns.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($29954eb155631f45$var$Wrapper, {
        addPadding: lastRowHasAddBar || addLinkShown,
        addBarOverflow: addBarOverflow,
        theme: theme,
        "data-testId": (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? $29954eb155631f45$var$SEGMENT_KEY : undefined,
        "data-vc": (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? `${$29954eb155631f45$var$SEGMENT_KEY}${false ? '-ssr' : ''}` : undefined,
        "data-ssr-placeholder": false && (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? $29954eb155631f45$var$SEGMENT_KEY : undefined,
        "data-ssr-placeholder-replace": false || !(0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? undefined : $29954eb155631f45$var$SEGMENT_KEY
    }, (displayStart === 0 && (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? ()=>{
        const rows = [];
        let index = 0;
        for(index; index < rowIds.length; index += 1){
            // we want to render all available rows that are not in a loading state, but no more than 100
            if (index >= $29954eb155631f45$var$INITIAL_RENDER_ROWS_LIMIT || rowsConfiguration[rowIds[index]] && rowsConfiguration[rowIds[index]].isLoading) break;
            rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RowItem, {
                key: rowIds[index],
                id: rowIds[index],
                rowIndex: index,
                onRowContentMount: gatherRowMountAnalyticsData,
                onRowContentUpdate: onRowContentUpdate,
                onLoadingRowUnmount: onLoadingRowUnmount
            }));
        }
        const notRenderedRows = rowIds.length - index;
        if (notRenderedRows > 0) {
            const spacerKey = `${rowIds[index]}-${rowIds[rowIds.length - 1]}`;
            const spacerHeight = notRenderedRows * defaultRowHeight;
            rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($29954eb155631f45$var$Spacer, {
                "data-testId": `${$29954eb155631f45$var$SEGMENT_KEY}.spacer`,
                key: spacerKey,
                height: spacerHeight
            }));
        }
        return rows;
    } : ()=>{
        const rows = [];
        const numberOfRows = rowIds.length - 1;
        const alwaysVisibleRows = {
            [rowIds[0]]: true,
            [rowIds[numberOfRows]]: true,
            ...temporaryAddedRow && {
                [temporaryAddedRow.temporaryId]: true
            }
        };
        let spacerHeight = 0;
        let spacerStartRow = null;
        for(let index = 0; index <= numberOfRows; index += 1){
            const isAlwaysVisible = alwaysVisibleRows[rowIds[index]];
            const isDisplay = index >= displayStart && index <= displayEnd;
            if (isAlwaysVisible || isDisplay) {
                if (spacerHeight > 0 && spacerStartRow) {
                    // by using a key which is virtual row range it represents,
                    // it can still be usefully reconciled (during dragging for example)
                    const spacerKey = `${spacerStartRow}${rowIds[index - 1]}`;
                    rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($29954eb155631f45$var$Spacer, {
                        "data-testId": `${$29954eb155631f45$var$SEGMENT_KEY}.spacer`,
                        key: spacerKey,
                        height: spacerHeight
                    }));
                    spacerHeight = 0;
                    spacerStartRow = null;
                }
                rows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RowItem, {
                    key: rowIds[index],
                    id: rowIds[index],
                    rowIndex: index,
                    onRowContentMount: gatherRowMountAnalyticsData,
                    onRowContentUpdate: onRowContentUpdate,
                    onLoadingRowUnmount: onLoadingRowUnmount
                }));
            } else {
                spacerHeight += rowHeightMapping[rowIds[index]] || absoluteRowHeight;
                spacerStartRow = rowIds[index];
            }
        }
        return rows;
    })());
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $29954eb155631f45$var$Spacer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $29954eb155631f45$var$WrapperOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addPadding: addPadding, addBarOverflow: addBarOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_g2wqu5": (0, $awdRS.default)(__cmplp.addBarOverflow, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66",
            __cmplp.addPadding ? "_n3tdhkvd" : "_n3tdze3t",
            __cmplp.className
        ])
    });
});
const $29954eb155631f45$var$WrapperNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addPadding: addPadding, addBarOverflow: addBarOverflow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_g2wqu5": (0, $awdRS.default)(__cmplp.addBarOverflow, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66 _c71l1kxc",
            __cmplp.addPadding ? "_n3tdhkvd" : "_n3tdze3t",
            __cmplp.className
        ])
    });
});
const $29954eb155631f45$var$Wrapper = (0, $bJscI.componentWithFG)('further_improve_vc90_performence_of_queues_page', $29954eb155631f45$var$WrapperNew, $29954eb155631f45$var$WrapperOld);
var $29954eb155631f45$export$2e2bcd8739ae039 = (0, $i1eKe.withTheme)((0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-perf-jsm-queues-virtual-table-refactor'), $29954eb155631f45$var$RowList, $29954eb155631f45$var$RowListOld));

});
parcelRegister("fwzaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab2d121bc64be0a3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");
function $ab2d121bc64be0a3$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eJOHy.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eJOHy.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eJOHy.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eJOHy.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});


parcelRegister("7tX31", function(module, exports) {

$parcel$export(module.exports, "default", () => $d957e703c3cdde76$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $4Mvfe = parcelRequire("4Mvfe");

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $fRJOe = parcelRequire("fRJOe");

var $9qfgc = parcelRequire("9qfgc");

var $dgxyo = parcelRequire("dgxyo");

var $1trep = parcelRequire("1trep");
const $d957e703c3cdde76$var$mapStateToProps = (state, { id: id })=>{
    const { displayStart: displayStart } = (0, $fRJOe.getVirtualBoundaries)(state);
    return {
        delayRowRenderOnScroll: (0, $5wAOx.shouldDelayRowRenderingOnScroll)(state) && displayStart > 0,
        isInCreation: (0, $kcVGc.isRowBeingAdded)(state, id),
        isLoading: (0, $kcVGc.isRowLoading)(state, id),
        LoadingRow: (0, $5wAOx.getLoadingRowComponent)(state),
        isInRowNavigationMode: (0, $5wAOx.isInRowNavigationMode)(state),
        NewRow: $1trep.default,
        DefaultRow: $9qfgc.default
    };
};
var $d957e703c3cdde76$export$2e2bcd8739ae039 = (0, $aIrSA.connect)($d957e703c3cdde76$var$mapStateToProps, {
    // @ts-expect-error - TS7006 - Parameter 'newActiveRow' implicitly has an 'any' type.
    onSetActiveRow: (newActiveRow)=>(0, $4Mvfe.setActiveRow)(newActiveRow)
})((0, $dgxyo.default));

});
parcelRegister("4Mvfe", function(module, exports) {

$parcel$export(module.exports, "SET_ACTIVE_CELL", () => $c25f7429c302416c$export$53294753640e6bdd);
$parcel$export(module.exports, "SET_ACTIVE_ROW", () => $c25f7429c302416c$export$551e11108d45fd88);
$parcel$export(module.exports, "setActiveCell", () => $c25f7429c302416c$export$c1df6941ca12827f);
$parcel$export(module.exports, "setActiveRow", () => $c25f7429c302416c$export$94bb5fd7cd44d4b3);

const $c25f7429c302416c$export$53294753640e6bdd = 'ops.items.active.set.SET_ACTIVE_CELL';
const $c25f7429c302416c$export$551e11108d45fd88 = 'ops.items.active.set.SET_ACTIVE_ROW';
const $c25f7429c302416c$export$c1df6941ca12827f = (payload)=>({
        type: $c25f7429c302416c$export$53294753640e6bdd,
        payload: {
            type: (0, $1d080e9e60c37b43$export$4b3489234fd17200),
            ...payload
        }
    });
const $c25f7429c302416c$export$94bb5fd7cd44d4b3 = (payload)=>({
        type: $c25f7429c302416c$export$551e11108d45fd88,
        payload: {
            type: (0, $1d080e9e60c37b43$export$8a257aa81ef4a9e0),
            setFocusOnRow: false,
            ...payload
        }
    });

});

parcelRegister("9qfgc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5d6b88b25c8cbb$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $fRJOe = parcelRequire("fRJOe");

var $gFejx = parcelRequire("gFejx");

var $5A4xV = parcelRequire("5A4xV");

var $7jAlr = parcelRequire("7jAlr");
var $1e5d6b88b25c8cbb$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, { id: id })=>{
    const isActiveItem = (0, $fRJOe.isActiveRowItem)(state, id);
    const isRowHighlighted = isActiveItem && !(0, $5wAOx.isTreeTableFacade)(state) && !(0, $5wAOx.isContentStale)(state) && !(0, $5wAOx.disableRowHighlight)(state);
    const isRowLeftEdgeVisible = (0, $fRJOe.getOffsetFromLeft)(state) === 0;
    const isRowRightEdgeVisible = (0, $fRJOe.getOffsetFromRight)(state) === 0;
    return {
        isActiveItem: isActiveItem,
        isRowHighlighted: isRowHighlighted,
        isRowLeftEdgeVisible: isRowLeftEdgeVisible,
        isRowRightEdgeVisible: isRowRightEdgeVisible,
        isGlobalAddEnabled: (0, $fRJOe.isGlobalAddEnabled)(state),
        setFocusOnRow: (0, $fRJOe.getSetFocusOnRow)(state, id),
        isSelected: (0, $kcVGc.isRowSelected)(state, id),
        AddBar: $gFejx.default,
        Content: $5A4xV.default
    };
}, {})((0, $7jAlr.default));

});
parcelRegister("gFejx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3b8645ea4b0cf12$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $9vdSd = parcelRequire("9vdSd");
var $a3b8645ea4b0cf12$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, { rowId: rowId })=>({
        addPosition: (0, $kcVGc.getRowAddPosition)(state, rowId),
        isRowExpanded: (0, $kcVGc.isRowExpanded)(state, rowId),
        canAddSibling: (0, $kcVGc.getRowCanAddSibling)(state, rowId),
        canAddChildren: (0, $kcVGc.getRowCanAddChildren)(state, rowId),
        onRowAddRequested: (0, $5wAOx.getRowAddCallback)(state)
    }), {})((0, $9vdSd.default));

});
parcelRegister("9vdSd", function(module, exports) {

$parcel$export(module.exports, "default", () => $89474a54a1ab09cc$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $l4cPj = parcelRequire("l4cPj");

var $7qGN1 = parcelRequire("7qGN1");
var $6YFG2 = parcelRequire("6YFG2");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $89474a54a1ab09cc$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1ejb _1bsb1ejb _19pkxmi2 _18u01i6y",
            __cmplp.className
        ])
    });
});
const $89474a54a1ab09cc$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIndented: isIndented, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dov4vr _n7zlv4vr _vchhusvi _4t3i12x7 _bfhk1rsu _tzy4idpf _80omtlke _kqswh2mm _154iv77o _19pkr5cr _o7ks134x _16l4kb7n",
            __cmplp.isIndented ? "_2hwxmgjw" : "_2hwxxmi2",
            __cmplp.className
        ])
    });
});
const $89474a54a1ab09cc$var$messages = (0, $7qGN1.defineMessages)({
    addIcon: {
        "id": "virtual-table.table.content.rows.common.default-row.add-bar.add-icon",
        "defaultMessage": "Click to add row"
    }
});
class $89474a54a1ab09cc$export$3213cbaa523231e6 extends (0, $eJOHy.Component) {
    shouldComponentUpdate(nextProps) {
        const { rowId: rowId, isRowExpanded: isRowExpanded, canAddChildren: canAddChildren, canAddSibling: canAddSibling } = this.props;
        return rowId !== nextProps.rowId || canAddChildren !== nextProps.canAddChildren || canAddSibling !== nextProps.canAddSibling || isRowExpanded !== nextProps.isRowExpanded;
    }
    renderAddBar() {
        const { intl: { formatMessage: formatMessage }, isRowExpanded: isRowExpanded, rowId: rowId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89474a54a1ab09cc$var$Wrapper, {
            isIndented: isRowExpanded,
            onClick: this.onRowAddRequested,
            "data-test-id": `common.components.virtual-table.table.content.rows.common.default-row.add-bar.wrapper-${rowId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($89474a54a1ab09cc$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l4cPj))), {
            color: "var(--ds-icon-accent-green, #22A06B)",
            label: formatMessage($89474a54a1ab09cc$var$messages.addIcon)
        })));
    }
    render() {
        const { canAddChildren: canAddChildren, canAddSibling: canAddSibling, addPosition: addPosition } = this.props;
        const canAddAtPosition = addPosition === 'INSIDE' && canAddChildren || addPosition === 'AFTER' && canAddSibling;
        return canAddAtPosition ? this.renderAddBar() : null;
    }
    constructor(...args){
        super(...args), this.onRowAddRequested = ()=>{
            const { rowId: rowId, addPosition: addPosition, onRowAddRequested: onRowAddRequested } = this.props;
            onRowAddRequested && onRowAddRequested({
                anchorId: rowId,
                position: addPosition
            });
        };
    }
}
var $89474a54a1ab09cc$export$2e2bcd8739ae039 = (0, $6YFG2.default)($89474a54a1ab09cc$export$3213cbaa523231e6);

});
parcelRegister("l4cPj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9cc38bfe1b4312fadc16f386d4b77f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f563ebc61a3ca924$var$_react = $f563ebc61a3ca924$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f563ebc61a3ca924$var$_add = $f563ebc61a3ca924$var$_interopRequireDefault((parcelRequire("dcLzM")));

var $f563ebc61a3ca924$var$_addCircle = $f563ebc61a3ca924$var$_interopRequireDefault((parcelRequire("XNSav")));
function $f563ebc61a3ca924$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f563ebc61a3ca924$var$AddIcon = (props)=>/*#__PURE__*/ $f563ebc61a3ca924$var$_react.default.createElement($f563ebc61a3ca924$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $f563ebc61a3ca924$var$_addCircle.default
    }, props));
$f563ebc61a3ca924$var$AddIcon.Name = 'AddIconMigration';
var $f563ebc61a3ca924$var$_default = module.exports.default = $f563ebc61a3ca924$var$AddIcon;

});
parcelRegister("XNSav", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b3c327a92aef962$var$_react = $0b3c327a92aef962$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $0b3c327a92aef962$var$_add = $0b3c327a92aef962$var$_interopRequireDefault((parcelRequire("dcLzM")));
function $0b3c327a92aef962$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0b3c327a92aef962$var$AddCircleIcon = (props)=>/*#__PURE__*/ $0b3c327a92aef962$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M11.046 7.958v3.088H7.958a.954.954 0 1 0 0 1.908h3.088v3.088a.954.954 0 1 0 1.908 0v-3.088h3.088a.954.954 0 1 0 0-1.908h-3.088V7.958a.954.954 0 1 0-1.908 0"/></g></svg>`
    }, props, {
        newIcon: $0b3c327a92aef962$var$_add.default
    }));
$0b3c327a92aef962$var$AddCircleIcon.displayName = 'AddCircleIcon';
var $0b3c327a92aef962$var$_default = module.exports.default = $0b3c327a92aef962$var$AddCircleIcon;

});




parcelRegister("5A4xV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9333f2b56070fea$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $2Ctxl = parcelRequire("2Ctxl");

var $5wAOx = parcelRequire("5wAOx");

var $fRJOe = parcelRequire("fRJOe");

var $gsVjm = parcelRequire("gsVjm");

var $fHN3N = parcelRequire("fHN3N");

var $9WUCX = parcelRequire("9WUCX");

var $dDlFg = parcelRequire("dDlFg");

var $hEcpK = parcelRequire("hEcpK");
var $e9333f2b56070fea$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, { id: id })=>({
        isActive: (0, $fRJOe.isActiveRowId)(state, id),
        coreColumnIds: (0, $2Ctxl.getVisibleCoreColumnIds)(state),
        additionalColumnIds: (0, $5wAOx.getVisibleAdditionalColumnIds)(state),
        shouldRerenderRowOnHover: (0, $5wAOx.shouldRerenderRowOnHover)(state),
        AdditionalColumnsContainer: $gsVjm.default,
        CellWrapper: $fHN3N.default,
        RowChildOperationIndicator: $dDlFg.default,
        ConditionalErrorBoundary: $9WUCX.default
    }), {})((0, $hEcpK.default));

});
parcelRegister("gsVjm", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd851eced843e262$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $3z7Cz = parcelRequire("3z7Cz");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $02dWc = parcelRequire("02dWc");

var $a1MA2 = parcelRequire("a1MA2");
var $bd851eced843e262$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        scrollLeft: (0, $atQRE.getHorizontalScrollOffset)(state),
        /* This prop is not used by the component other than to force an update when the rows change.
		 * It has been done to fix the behaviour of row scroll being reset during table actions that
		 * would have previously only reconciled the elements, rather than reconstructing them.
		 * This behaviour is inherent to React and the browser, where React re-inserting nodes cause
		 * the browser to reset specific transient properties (such as scrolling or video play).
		 * Here we are forcing the re-rendering so the scroll position can be correctly
		 * inferred directly from the store.
		 * For more info see https://github.com/facebook/react/issues/13042 and the associated links.
		 */ rowIds: (0, $02dWc.getFlattenedWithAddedRowIds)(state),
        additionalColumnsWidth: (0, $fRJOe.getVisibleAdditionalColumnsWidth)(state)
    }), {
    setHorizontalScrollOffset: $3z7Cz.setHorizontal
})((0, $a1MA2.default));

});
parcelRegister("a1MA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b88045d977df3d$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lpMrC = parcelRequire("lpMrC");

var $7jTnu = parcelRequire("7jTnu");
const $c1b88045d977df3d$var$isWebkit = ()=>(0, $lpMrC.isChrome)() || (0, $lpMrC.isSafari)() || (0, $lpMrC.isEdge)();
const $c1b88045d977df3d$var$SEGMENT_KEY = 'virtual-table.table.header.scrollable-div.wrapper';
const $c1b88045d977df3d$var$wrapperStyles = {
    overflow: 'hidden',
    flex: '1 1 auto',
    marginBottom: 0
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c1b88045d977df3d$var$ScrollableDiv = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1fjgglyw _4pckglyw _1e0c1txw _n3tdidpf",
            $c1b88045d977df3d$var$isWebkit() && "_1cicglyw",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $c1b88045d977df3d$var$AdditionalColumnsContainer extends (0, $eJOHy.PureComponent) {
    componentDidMount() {
        const { scrollLeft: scrollLeft } = this.props;
        this.updateScrollLeft(scrollLeft);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.updateScrollLeft(nextProps.scrollLeft);
    }
    updateScrollLeft(scrollLeft) {
        const { scrollRef: scrollRef } = this;
        if (scrollRef && scrollRef.scrollLeft !== scrollLeft) {
            this.ignoreScrollEvent = true;
            scrollRef.scrollLeft = scrollLeft;
        }
    }
    render() {
        const { children: children, placeholderKey: placeholderKey } = this.props;
        const placeholderValue = `${$c1b88045d977df3d$var$SEGMENT_KEY}.${placeholderKey}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testId": (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? placeholderValue : undefined,
            "data-vc": (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? `${placeholderValue}${false ? '-ssr' : ''}` : undefined,
            "data-ssr-placeholder": false && (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? placeholderValue : undefined,
            "data-ssr-placeholder-replace": false || !(0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? undefined : placeholderValue,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $c1b88045d977df3d$var$wrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c1b88045d977df3d$var$ScrollableDiv, {
            ref: (div)=>{
                this.setScrollRef(div);
            },
            ...(0, $7jTnu.fg)('jsm_virtual_table_column_header_a11y_fix') && {
                tabIndex: 0
            },
            style: {
                overflowX: false ? 'hidden' : 'scroll'
            },
            onScroll: this.onScroll
        }, children));
    }
    constructor(...args){
        super(...args), this.onScroll = (event)=>{
            const { setHorizontalScrollOffset: setHorizontalScrollOffset } = this.props;
            const { scrollRef: scrollRef, ignoreScrollEvent: ignoreScrollEvent } = this;
            if (event.currentTarget === scrollRef && !ignoreScrollEvent) setHorizontalScrollOffset(event.currentTarget.scrollLeft);
            this.ignoreScrollEvent = false;
        }, this.setScrollRef = (ref)=>{
            this.scrollRef = ref;
        };
    }
}
var $c1b88045d977df3d$export$2e2bcd8739ae039 = $c1b88045d977df3d$var$AdditionalColumnsContainer;

});


parcelRegister("fHN3N", function(module, exports) {

$parcel$export(module.exports, "default", () => $c86cdc74031a3b58$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");

var $aIrSA = parcelRequire("aIrSA");

var $jr0Vm = parcelRequire("jr0Vm");

var $9Zs47 = parcelRequire("9Zs47");

var $4Mvfe = parcelRequire("4Mvfe");

var $2Ctxl = parcelRequire("2Ctxl");

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $iGnUE = parcelRequire("iGnUE");
var $c86cdc74031a3b58$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, { rowId: rowId, columnId: columnId, isRowHovered: isRowHovered, isRowKeyboardActive: isRowKeyboardActive })=>{
    const activeItem = (0, $atQRE.getActiveCell)(state);
    const isActive = (0, $fRJOe.isCellActive)(state, rowId, columnId);
    const activatedFrom = isActive && activeItem ? activeItem.activatedFrom : undefined;
    return {
        isInCellNavigationMode: (0, $5wAOx.isInCellNavigationMode)(state),
        shouldHydrateFully: (0, $fRJOe.shouldRowHydrateFully)(state, rowId),
        shouldUseCssForRendering: (0, $atQRE.getShouldUseCssForRendering)(state),
        width: (0, $fRJOe.getColumnWidth)(state, columnId),
        column: (0, $7jTnu.fg)('css_support_for_virtual_table') ? (0, $fRJOe.getColumn)(state, columnId) : undefined,
        depth: (0, $fRJOe.getRowDepth)(state, rowId),
        maxDepth: (0, $kcVGc.getMaxDepth)(state),
        isActive: isActive,
        activatedFrom: activatedFrom,
        isRowHovered: isRowHovered || false,
        isRowKeyboardActive: isRowKeyboardActive || false,
        activeItemChanged: (0, $5wAOx.getActiveItemChangedCallback)(state),
        CellComponent: (0, $2Ctxl.getCellComponent)(state, columnId),
        NonTemporaryCellWrapper: (0, $5wAOx.getNonTemporaryCellWrapper)(state),
        canBeMultiLine: (0, $2Ctxl.canCellBeMultiLine)(state, columnId),
        parentId: (0, $2Ctxl.getColumnParentId)(state, columnId),
        renderSidebarIcon: (0, $atQRE.getRenderSidebarIcon)(state)
    };
}, {
    setActiveCell: $4Mvfe.setActiveCell,
    clearActiveItem: $9Zs47.clear,
    navigateToCell: $jr0Vm.navigateToCell
})((0, $iGnUE.default));

});
parcelRegister("jr0Vm", function(module, exports) {

$parcel$export(module.exports, "NAVIGATE_TO_CELL", () => $b7674ce8ab0e9f69$export$d4980933cbdb75cc);
$parcel$export(module.exports, "navigateToCell", () => $b7674ce8ab0e9f69$export$4dc17e9d5bc2fa90);
const $b7674ce8ab0e9f69$export$d4980933cbdb75cc = 'ops.cells.navigate.NAVIGATE_TO_CELL';
const $b7674ce8ab0e9f69$export$4dc17e9d5bc2fa90 = (payload)=>({
        type: $b7674ce8ab0e9f69$export$d4980933cbdb75cc,
        payload: payload
    });

});

parcelRegister("9Zs47", function(module, exports) {

$parcel$export(module.exports, "CLEAR_ACTIVE_ITEM", () => $5891dfd1f11f2d3b$export$d63ae865b2dc3e7f);
$parcel$export(module.exports, "clear", () => $5891dfd1f11f2d3b$export$42ffd38884aecdac);
const $5891dfd1f11f2d3b$export$d63ae865b2dc3e7f = 'ops.items.active.clear.CLEAR_ACTIVE_ITEM';
const $5891dfd1f11f2d3b$export$42ffd38884aecdac = ()=>({
        type: $5891dfd1f11f2d3b$export$d63ae865b2dc3e7f,
        payload: undefined
    });

});

parcelRegister("iGnUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fc9cad907e19a20$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $12DRg = parcelRequire("12DRg");

var $6S4l2 = parcelRequire("6S4l2");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");



const $0fc9cad907e19a20$var$getWrapperStyles = (width)=>({
        flex: '0 0 auto',
        width: `${width}px`
    });
const $0fc9cad907e19a20$var$NAVIGATION_KEYS = {
    [(0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('up')]: (0, $7e33285e7fb1fa6b$export$b29f845fa4b57508),
    [(0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('right')]: (0, $7e33285e7fb1fa6b$export$1cac5500365a4eb4),
    [(0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('down')]: (0, $7e33285e7fb1fa6b$export$c7c029a231f98d34),
    [(0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('left')]: (0, $7e33285e7fb1fa6b$export$f981f70d61d1405a)
};
// eslint-disable-next-line jira/react/no-class-components
class $0fc9cad907e19a20$var$CellWrapper extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRowTemporary: false,
            isRowHovered: false,
            isRowKeyboardActive: false,
            confirmToNavigate: true
        };
    }
    shouldComponentUpdate(nextProps) {
        return this.props.rowId !== nextProps.rowId || this.props.columnId !== nextProps.columnId || this.props.width !== nextProps.width || this.props.depth !== nextProps.depth || this.props.maxDepth !== nextProps.maxDepth || this.props.activatedFrom !== nextProps.activatedFrom || this.props.isActive !== nextProps.isActive || this.props.shouldHydrateFully !== nextProps.shouldHydrateFully || this.props.isRowHovered !== nextProps.isRowHovered || this.props.isRowKeyboardActive !== nextProps.isRowKeyboardActive || this.props.confirmToNavigate !== nextProps.confirmToNavigate || this.props.activeItemChanged !== nextProps.activeItemChanged || this.props.renderSidebarIcon !== nextProps.renderSidebarIcon;
    }
    componentDidUpdate(prevProps) {
        const { rowId: rowId, columnId: columnId, isActive: isActive, activeItemChanged: activeItemChanged } = this.props;
        if (!prevProps.isActive && isActive) activeItemChanged({
            rowId: rowId,
            columnId: columnId
        });
    }
    render() {
        const { rowId: rowId, width: width, column: column, columnId: columnId, activatedFrom: activatedFrom, isActive: isActive, isRowTemporary: isRowTemporary, isRowHovered: isRowHovered, isRowKeyboardActive: isRowKeyboardActive, CellComponent: CellComponent, NonTemporaryCellWrapper: NonTemporaryCellWrapper, onCellMount: onCellMount, canBeMultiLine: canBeMultiLine, shouldHydrateFully: shouldHydrateFully, shouldUseCssForRendering: shouldUseCssForRendering, renderSidebarIcon: renderSidebarIcon } = this.props;
        const onMultiLineCellUpdated = canBeMultiLine ? onCellMount : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
        const commonProps = {
            rowId: rowId,
            width: width,
            columnId: columnId,
            activatedFrom: activatedFrom,
            isActive: isActive,
            isRowTemporary: isRowTemporary,
            isRowHovered: isRowHovered,
            isRowKeyboardActive: isRowKeyboardActive,
            onMount: onMultiLineCellUpdated,
            onUpdate: onMultiLineCellUpdated,
            canBeMultiLine: canBeMultiLine,
            shouldHydrateFully: shouldHydrateFully
        };
        /* We just use the wrapping element for bubbling */ if (renderSidebarIcon) {
            const colWidth = width;
            const renderCell = ()=>{
                if (columnId === (0, $53724ea925cf4e57$export$913055729e1380b2)) {
                    // Leave 60px space for icon summary cells
                    const colAdjust = 60;
                    if (column && shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0fc9cad907e19a20$var$CellWithIconIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                        xcss: [
                            $0fc9cad907e19a20$var$cellHoverStyles
                        ],
                        style: {
                            minWidth: column.minWidth - colAdjust,
                            maxWidth: column.maxWidth - colAdjust
                        }
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CellComponent, commonProps)), (isRowHovered || isRowKeyboardActive) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0fc9cad907e19a20$var$SidebarIcon, null, renderSidebarIcon(rowId)));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0fc9cad907e19a20$var$CellWithIconIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0fc9cad907e19a20$var$RestrictedWidthCell, {
                        width: colWidth - colAdjust
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CellComponent, commonProps)), (isRowHovered || isRowKeyboardActive) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0fc9cad907e19a20$var$SidebarIcon, null, renderSidebarIcon(rowId)));
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CellComponent, commonProps);
            };
            if (column && shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                ref: this.getTargetRef,
                style: {
                    minWidth: column.minWidth,
                    maxWidth: column.maxWidth
                },
                onFocus: this.onFocus,
                onBlur: this.onBlur,
                onKeyDown: this.onKeyDown,
                xcss: $0fc9cad907e19a20$var$cellStyles,
                testId: `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
                role: (0, $7jTnu.fg)('jsm_virtual_table_a11y') ? 'cell' : 'presentation'
            }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderCell()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NonTemporaryCellWrapper, {
                Cell: CellComponent,
                ...commonProps
            }));
            return (0, $7jTnu.fg)('jsm_virtual_table_a11y') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                ref: this.getTargetRef,
                style: {
                    width: `${width}px`
                },
                xcss: $0fc9cad907e19a20$var$cellWrapperStyles,
                onFocus: this.onFocus,
                onBlur: this.onBlur,
                onKeyDown: this.onKeyDown,
                testId: `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
                role: "cell"
            }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderCell()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NonTemporaryCellWrapper, {
                Cell: CellComponent,
                ...commonProps
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                ref: this.getTargetRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: $0fc9cad907e19a20$var$getWrapperStyles(width),
                onFocus: this.onFocus,
                onBlur: this.onBlur,
                onKeyDown: this.onKeyDown,
                "data-testid": `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
                role: "presentation"
            }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderCell()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NonTemporaryCellWrapper, {
                Cell: CellComponent,
                ...commonProps
            }));
        }
        if (column && shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            ref: this.getTargetRef,
            style: {
                minWidth: column.minWidth,
                maxWidth: column.maxWidth
            },
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onKeyDown: this.onKeyDown,
            xcss: $0fc9cad907e19a20$var$cellStyles,
            testId: `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
            role: (0, $7jTnu.fg)('jsm_virtual_table_a11y') ? 'cell' : 'presentation'
        }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CellComponent, commonProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NonTemporaryCellWrapper, {
            Cell: CellComponent,
            ...commonProps
        }));
        return (0, $7jTnu.fg)('jsm_virtual_table_a11y') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            ref: this.getTargetRef,
            style: {
                width: `${width}px`
            },
            xcss: $0fc9cad907e19a20$var$cellWrapperStyles,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onKeyDown: this.onKeyDown,
            testId: `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
            role: "cell"
        }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CellComponent, commonProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NonTemporaryCellWrapper, {
            Cell: CellComponent,
            ...commonProps
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            ref: this.getTargetRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $0fc9cad907e19a20$var$getWrapperStyles(width),
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onKeyDown: this.onKeyDown,
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": `common.components.virtual-table.table.content.rows.common.cell-wrapper-row${rowId}-${columnId}`,
            role: "presentation"
        }, isRowTemporary || NonTemporaryCellWrapper === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CellComponent, commonProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NonTemporaryCellWrapper, {
            Cell: CellComponent,
            ...commonProps
        }));
    }
    constructor(...args){
        super(...args), this.onFocus = ()=>{
            const { rowId: rowId, columnId: columnId, setActiveCell: setActiveCell, isInCellNavigationMode: isInCellNavigationMode } = this.props;
            if (isInCellNavigationMode) setActiveCell({
                type: (0, $1d080e9e60c37b43$export$4b3489234fd17200),
                rowId: rowId,
                columnId: columnId
            });
        }, this.onBlur = ()=>{
            const { clearActiveItem: clearActiveItem, isInCellNavigationMode: isInCellNavigationMode } = this.props;
            if (isInCellNavigationMode) clearActiveItem();
        }, this.onKeyDown = (event)=>{
            const { confirmToNavigate: confirmToNavigate, isInCellNavigationMode: isInCellNavigationMode, columnId: columnId } = this.props;
            let direction;
            if (!isInCellNavigationMode) return;
            /* Special handling for enter since it can be ignored */ if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter') && confirmToNavigate) direction = (0, $7e33285e7fb1fa6b$export$c7c029a231f98d34);
            else direction = $0fc9cad907e19a20$var$NAVIGATION_KEYS[event.keyCode];
            if (direction) {
                event.preventDefault();
                event.stopPropagation();
                const { rowId: rowId, navigateToCell: navigateToCell } = this.props;
                navigateToCell({
                    rowId: rowId,
                    columnId: columnId,
                    direction: direction
                });
            }
        }, this.getTargetRef = (div)=>{
            this.targetRef = div;
        };
    }
}
var $0fc9cad907e19a20$export$2e2bcd8739ae039 = $0fc9cad907e19a20$var$CellWrapper;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $0fc9cad907e19a20$var$SidebarIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $0fc9cad907e19a20$var$RestrictedWidthCell = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $awdRS.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1hdq",
            __cmplp.className
        ])
    });
});
const $0fc9cad907e19a20$var$CellWithIconIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $0fc9cad907e19a20$var$cellStyles = (0, $1DXK0.xcss)({
    width: '100%',
    flex: '1 1 auto'
});
const $0fc9cad907e19a20$var$cellWrapperStyles = (0, $1DXK0.xcss)({
    flex: '0 0 auto'
});
const $0fc9cad907e19a20$var$cellHoverStyles = (0, $1DXK0.xcss)({
    width: 'calc(100% - 60px)'
});

});
const $7e33285e7fb1fa6b$export$b29f845fa4b57508 = 'UP';
const $7e33285e7fb1fa6b$export$c7c029a231f98d34 = 'DOWN';
const $7e33285e7fb1fa6b$export$f981f70d61d1405a = 'LEFT';
const $7e33285e7fb1fa6b$export$1cac5500365a4eb4 = 'RIGHT';



parcelRegister("9WUCX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d30cca920dfdbf2b$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $9hIbo = parcelRequire("9hIbo");

var $2rsaE = parcelRequire("2rsaE");
var $d30cca920dfdbf2b$export$2e2bcd8739ae039 = (0, $aIrSA.connect)(()=>({
        ErrorInlineMessage: $9hIbo.default
    }), {})((0, $2rsaE.ConditionalErrorBoundary));

});
parcelRegister("9hIbo", function(module, exports) {

$parcel$export(module.exports, "default", () => $d589a9dd038072c9$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $2Ctxl = parcelRequire("2Ctxl");

var $9aIr6 = parcelRequire("9aIr6");
var $d589a9dd038072c9$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, { columnId: columnId })=>({
        columnWidth: (0, $2Ctxl.getColumnMinWidth)(state, columnId)
    }), {})((0, $9aIr6.ErrorInlineMessage));

});
parcelRegister("9aIr6", function(module, exports) {

$parcel$export(module.exports, "ErrorInlineMessage", () => $cb4e935d9b29a0fc$export$ffbab3d811b5160b);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $fAoiP = parcelRequire("fAoiP");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $qs1vt = parcelRequire("qs1vt");
const $cb4e935d9b29a0fc$export$ffbab3d811b5160b = ({ columnWidth: columnWidth })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const onClick = (0, $eJOHy.useCallback)(()=>window.location.reload(), []);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockStart: "space.100",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $1DXK0.xcss)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${columnWidth}px`
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fAoiP.default), {
        appearance: "error",
        iconLabel: formatMessage((0, $qs1vt.default).errorFlagText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingInlineStart: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $qs1vt.default).errorFlagText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $1DXK0.xcss)({
            color: 'color.text.accent.blue'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $qs1vt.default).errorFlagLinkText))))));
};

});
parcelRegister("fAoiP", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf8ea374b58ea243$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $cwZBT = parcelRequire("cwZBT");

var $6djmC = parcelRequire("6djmC");
var $3cMgR = parcelRequire("3cMgR");

var $1x0fM = parcelRequire("1x0fM");
const $bf8ea374b58ea243$var$rootStyles = null;
const $bf8ea374b58ea243$var$iconColor = {
    connectivity: "_x5v91r2e",
    confirmation: "_x5v91fgg",
    info: "_x5v913wx",
    warning: "_x5v9f6ss",
    error: "_x5v9k8x7"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $bf8ea374b58ea243$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const toggleDialog = (0, $eJOHy.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $eJOHy.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _p12f1osq _nt751r31 _49pcnqa1 _1hvwt94y _kvh018uv _38q98stv _1o0knqa1 _1yyu1kum",
            $bf8ea374b58ea243$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cwZBT.default), {
            onClose: onCloseDialog,
            content: children,
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--inline-dialog`,
            fallbackPlacements: fallbackPlacements,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                "data-ds--inline-message--button": true,
                appearance: "subtle-link",
                onClick: toggleDialog,
                spacing: "none",
                testId: testId && `${testId}--button`,
                "aria-expanded": isOpen,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    as: "span",
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1x0fM.default), {
                            isOpen: isOpen,
                            appearance: appearance,
                            label: iconLabel,
                            spacing: spacing
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                            as: "span",
                            space: "space.100",
                            children: [
                                title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                    weight: "medium",
                                    testId: testId && `${testId}--title`,
                                    children: title
                                }),
                                secondaryText && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                    weight: "medium",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    testId: testId && `${testId}--text`,
                                    children: secondaryText
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $bf8ea374b58ea243$export$2e2bcd8739ae039 = $bf8ea374b58ea243$var$InlineMessage;

});
parcelRegister("1x0fM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb94fc6b1082a95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $juHFo = parcelRequire("juHFo");
const $7cb94fc6b1082a95$var$iconColor = {
    connectivity: "_1b3i1c86",
    confirmation: "_1b3icdx1",
    info: "_1b3ige5s",
    warning: "_1b3i1n6p",
    error: "_1b3i1378"
};
const $7cb94fc6b1082a95$var$iconWrapperStyles = null;
const $7cb94fc6b1082a95$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $7cb94fc6b1082a95$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $juHFo.typesMapping);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v",
            isOpen && "_syaz1kum",
            $7cb94fc6b1082a95$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: spacing
        })
    });
};
var $7cb94fc6b1082a95$export$2e2bcd8739ae039 = $7cb94fc6b1082a95$var$SelectedIcon;

});
parcelRegister("juHFo", function(module, exports) {

$parcel$export(module.exports, "typesMapping", () => $2b5bcc4386586ca5$export$4d111645c0b39d5d);

var $d3cA1 = parcelRequire("d3cA1");

var $7kJQm = parcelRequire("7kJQm");

var $Hyi04 = parcelRequire("Hyi04");

var $3Isp2 = parcelRequire("3Isp2");
const $2b5bcc4386586ca5$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Isp2))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($Hyi04))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7kJQm))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Isp2))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d3cA1))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("qs1vt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c87509ca017306$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e8c87509ca017306$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorFlagText: {
        "id": "virtual-table.table.content.rows.common.conditional-error-boundary.error-inline-message.error-flag-text",
        "defaultMessage": "We're having trouble loading this data. Try again later or contact Atlassian support."
    },
    errorFlagLinkText: {
        "id": "virtual-table.table.content.rows.common.conditional-error-boundary.error-inline-message.error-flag-link-text",
        "defaultMessage": "Reload"
    }
});

});



parcelRegister("2rsaE", function(module, exports) {

$parcel$export(module.exports, "ConditionalErrorBoundary", () => $85bb5e0124c4f593$export$6465e24fd5df7a56);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");
const $85bb5e0124c4f593$export$6465e24fd5df7a56 = ({ children: children, columnId: columnId, ErrorInlineMessage: ErrorInlineMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "virtual-table-row-additional-column",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ErrorInlineMessage, {
                columnId: columnId
            })
    }, children);

});


parcelRegister("dDlFg", function(module, exports) {

$parcel$export(module.exports, "default", () => $483dedd6e376315d$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $fRJOe = parcelRequire("fRJOe");

var $7W15Z = parcelRequire("7W15Z");
var $483dedd6e376315d$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, { rowId: rowId })=>({
        maxDepth: (0, $kcVGc.getMaxDepth)(state),
        rowDepth: (0, $fRJOe.getRowDepth)(state, rowId),
        isRowExpanded: (0, $kcVGc.isRowExpanded)(state, rowId),
        rowHasChildren: (0, $kcVGc.getRowHasChildren)(state, rowId),
        isAddEnabled: (0, $fRJOe.isGlobalAddEnabled)(state) && (0, $kcVGc.getRowCanAddChildren)(state, rowId),
        onRowExpansionChangeRequested: (0, $5wAOx.getRowExpansionCallback)(state),
        onRowAddRequested: (0, $5wAOx.getRowAddCallback)(state)
    }), {})((0, $7W15Z.default));

});
parcelRegister("7W15Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $8513eaf6c22ebc47$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ 
var $eJOHy = parcelRequire("eJOHy");

var $dB1eP = parcelRequire("dB1eP");

var $5lAAn = parcelRequire("5lAAn");

var $jQjGM = parcelRequire("jQjGM");


var $7qGN1 = parcelRequire("7qGN1");
var $6YFG2 = parcelRequire("6YFG2");

var $i1eKe = parcelRequire("i1eKe");

var $8nFYk = parcelRequire("8nFYk");
const $8513eaf6c22ebc47$var$messages = (0, $7qGN1.defineMessages)({
    collapseIcon: {
        "id": "virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.collapse-icon",
        "defaultMessage": "Click to collapse row"
    },
    expandIcon: {
        "id": "virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.expand-icon",
        "defaultMessage": "Click to expand row"
    },
    addIcon: {
        "id": "virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.add-icon",
        "defaultMessage": "Click to add row"
    }
});
const $8513eaf6c22ebc47$var$baseIndicatorStyles = {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    color: (0, $7bb4c1736002a04a$exports).N70
};
const $8513eaf6c22ebc47$var$interactiveIndicatorStyles = {
    ...$8513eaf6c22ebc47$var$baseIndicatorStyles,
    width: `${(0, $8nFYk.childrenOperationIndicatorWidth)}px`,
    cursor: 'pointer'
};
const $8513eaf6c22ebc47$var$getDefaultIndicatorStyles = (isMaxDepth, theme)=>({
        ...$8513eaf6c22ebc47$var$baseIndicatorStyles,
        width: `${isMaxDepth ? theme.row.maxDepthChildrenOperationIndicatorWidth : (0, $8nFYk.childrenOperationIndicatorWidth)}px`
    });
const $8513eaf6c22ebc47$var$getAddIndicatorWrapperStyles = (isRowHovered)=>({
        height: '16px',
        width: '16px',
        visibility: isRowHovered ? 'visible' : 'hidden'
    });
class $8513eaf6c22ebc47$export$20869452acc58b2a extends (0, $eJOHy.Component) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { rowHasChildren: rowHasChildren, isRowExpanded: isRowExpanded } = this.props;
        /* A row that had children but now has none SHOULD NOT be expanded.
     * The general use case for this is cancelling an add operation, where the
     * temporary row was the only child. As cancelling can occur from internal or
     * external to the table, this is the only way to ensure this behaviour.
     */ if (rowHasChildren && !nextProps.rowHasChildren && isRowExpanded) this.onCollapse();
    }
    shouldComponentUpdate(nextProps) {
        const { rowId: rowId, rowDepth: rowDepth, maxDepth: maxDepth, isRowExpanded: isRowExpanded, isRowHovered: isRowHovered, isRowKeyboardActive: isRowKeyboardActive, rowHasChildren: rowHasChildren, isAddEnabled: isAddEnabled } = this.props;
        return rowId !== nextProps.rowId || rowDepth !== nextProps.rowDepth || maxDepth !== nextProps.maxDepth || isRowExpanded !== nextProps.isRowExpanded || isRowHovered !== nextProps.isRowHovered || isRowKeyboardActive !== nextProps.isRowKeyboardActive || rowHasChildren !== nextProps.rowHasChildren || isAddEnabled !== nextProps.isAddEnabled;
    }
    renderCollapseIndicator() {
        const { intl: { formatMessage: formatMessage }, rowId: rowId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            style: $8513eaf6c22ebc47$var$interactiveIndicatorStyles,
            onClick: this.onCollapse,
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": `common.components.virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.collapse-${rowId}`,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && this.onCollapse,
            role: "button",
            tabIndex: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            LEGACY_size: "small",
            spacing: "compact",
            label: formatMessage($8513eaf6c22ebc47$var$messages.collapseIcon),
            size: "small"
        }));
    }
    renderExpandIndicator() {
        const { intl: { formatMessage: formatMessage }, rowId: rowId } = this.props;
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            style: $8513eaf6c22ebc47$var$interactiveIndicatorStyles,
            onClick: this.onExpand,
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": `common.components.virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.expand-${rowId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dB1eP))), {
            LEGACY_size: "small",
            spacing: "compact",
            label: formatMessage($8513eaf6c22ebc47$var$messages.expandIcon),
            size: "small"
        })));
    }
    renderAddIndicator() {
        const { intl: { formatMessage: formatMessage }, isRowHovered: isRowHovered, rowId: rowId } = this.props;
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            style: $8513eaf6c22ebc47$var$interactiveIndicatorStyles,
            onClick: this.onRowAddRequested,
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": `common.components.virtual-table.table.content.rows.common.default-row.content.child-operation-indicator.add-${rowId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            style: $8513eaf6c22ebc47$var$getAddIndicatorWrapperStyles(isRowHovered)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQjGM))), {
            LEGACY_size: "small",
            label: formatMessage($8513eaf6c22ebc47$var$messages.addIcon)
        }))));
    }
    render() {
        const { maxDepth: maxDepth, rowDepth: rowDepth, rowHasChildren: rowHasChildren, isRowExpanded: isRowExpanded, isAddEnabled: isAddEnabled, theme: theme } = this.props;
        const isMaxDepth = rowDepth === maxDepth;
        if (!isMaxDepth) {
            if (rowHasChildren) {
                if (isRowExpanded) return this.renderCollapseIndicator();
                return this.renderExpandIndicator();
            }
            if (isAddEnabled) return this.renderAddIndicator();
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            style: $8513eaf6c22ebc47$var$getDefaultIndicatorStyles(isMaxDepth, theme)
        });
    }
    constructor(...args){
        super(...args), this.onExpand = ()=>{
            const { rowId: rowId, onRowExpansionChangeRequested: onRowExpansionChangeRequested } = this.props;
            onRowExpansionChangeRequested({
                rowId: rowId,
                shouldExpand: true
            });
        }, this.onCollapse = ()=>{
            const { rowId: rowId, onRowExpansionChangeRequested: onRowExpansionChangeRequested } = this.props;
            onRowExpansionChangeRequested({
                rowId: rowId,
                shouldExpand: false
            });
        }, this.onRowAddRequested = ()=>{
            const { rowId: rowId, onRowAddRequested: onRowAddRequested } = this.props;
            onRowAddRequested && onRowAddRequested({
                anchorId: rowId,
                position: 'INSIDE'
            });
        };
    }
}
var $8513eaf6c22ebc47$export$2e2bcd8739ae039 = (0, $6YFG2.default)((0, $i1eKe.withTheme)($8513eaf6c22ebc47$export$20869452acc58b2a));

});
parcelRegister("jQjGM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::739edc58ca910533dbcf168239dfad1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7222574ac205219$var$_react = $e7222574ac205219$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e7222574ac205219$var$_add = $e7222574ac205219$var$_interopRequireDefault((parcelRequire("dcLzM")));

var $e7222574ac205219$var$_add2 = $e7222574ac205219$var$_interopRequireDefault((parcelRequire("lnnie")));
function $e7222574ac205219$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7222574ac205219$var$AddIcon = (props)=>/*#__PURE__*/ $e7222574ac205219$var$_react.default.createElement($e7222574ac205219$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $e7222574ac205219$var$_add2.default
    }, props));
$e7222574ac205219$var$AddIcon.Name = 'AddIconMigration';
var $e7222574ac205219$var$_default = module.exports.default = $e7222574ac205219$var$AddIcon;

});
parcelRegister("lnnie", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8fdd0750f7e22cb$var$_react = $f8fdd0750f7e22cb$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $f8fdd0750f7e22cb$var$_add = $f8fdd0750f7e22cb$var$_interopRequireDefault((parcelRequire("dcLzM")));
function $f8fdd0750f7e22cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8fdd0750f7e22cb$var$AddIcon = (props)=>/*#__PURE__*/ $f8fdd0750f7e22cb$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $f8fdd0750f7e22cb$var$_add.default
    }));
$f8fdd0750f7e22cb$var$AddIcon.displayName = 'AddIcon';
var $f8fdd0750f7e22cb$var$_default = module.exports.default = $f8fdd0750f7e22cb$var$AddIcon;

});




parcelRegister("hEcpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb65ca7832d2c63e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


var $7jTnu = parcelRequire("7jTnu");

var $aBFKZ = parcelRequire("aBFKZ");

var $i1eKe = parcelRequire("i1eKe");
const $eb65ca7832d2c63e$var$getWrapperStyles = (backgroundColor, theme)=>{
    const style = {
        display: 'flex',
        boxSizing: 'border-box',
        borderTop: `${theme.row.borderWidth}px solid ${theme.row.borderColor}`,
        borderBottom: `${theme.row.borderWidth}px solid ${theme.row.borderColor}`,
        height: theme.row.height,
        minHeight: theme.row.minHeight,
        marginLeft: '0px',
        boxShadow: 'none'
    };
    if (theme.row.useCssHover) return style;
    return {
        ...style,
        backgroundColor: backgroundColor
    };
};
// eslint-disable-next-line jira/react/no-class-components
class $eb65ca7832d2c63e$var$RowContent extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.onMouseEnter = ()=>{
            if (!this.props.theme.row.useCssHover || (this.props.shouldRerenderRowOnHover ?? false)) this.setState({
                isHovered: true
            });
        }, this.onMouseLeave = ()=>{
            if (!this.props.theme.row.useCssHover || (this.props.shouldRerenderRowOnHover ?? false)) this.setState({
                isHovered: false
            });
        }, this.setRef = (el)=>{
            this.ref = el;
        }, this.recalculateHeight = ()=>{
            const { id: id, onRowContentUpdate: onRowContentUpdate } = this.props;
            if (this.ref && onRowContentUpdate) onRowContentUpdate(id, this.ref.getBoundingClientRect().height);
        };
        this.state = {
            isHovered: false,
            render: !props.coreColumnIds.length
        };
        this.beginTime = Date.now();
    }
    componentDidMount() {
        const { onRowContentMount: onRowContentMount, coreColumnIds: coreColumnIds, additionalColumnIds: additionalColumnIds } = this.props;
        if (!this.state.render) this.timeoutId = setTimeout(()=>this.setState({
                render: true
            }), 16);
        this.recalculateHeight();
        // @ts-expect-error - TS2769 - No overload matches this call.
        const allColumns = [].concat(coreColumnIds, additionalColumnIds);
        onRowContentMount && onRowContentMount(this.beginTime, Date.now(), allColumns, allColumns.length);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.state.render !== nextState.render || this.state.isHovered !== nextState.isHovered || this.props.id !== nextProps.id || this.props.isActive !== nextProps.isActive || this.props.coreColumnIds !== nextProps.coreColumnIds || this.props.additionalColumnIds !== nextProps.additionalColumnIds;
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }
    determineRowColor(isActive, isHovered) {
        if (isHovered) return this.props.theme.row.hoveredColor;
        if (isActive) return this.props.theme.row.activeColor;
        return (0, $7bb4c1736002a04a$exports).N0;
    }
    renderChildOperationIndicator() {
        const { id: id, RowChildOperationIndicator: RowChildOperationIndicator, isActive: isActive, ConditionalErrorBoundary: ConditionalErrorBoundary } = this.props;
        const { isHovered: isHovered } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConditionalErrorBoundary, {
            columnId: "child-operation-indicator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(RowChildOperationIndicator, {
            rowId: id,
            isRowHovered: isHovered,
            isRowKeyboardActive: isActive
        }));
    }
    renderCoreColumns() {
        const { id: id, coreColumnIds: coreColumnIds, CellWrapper: CellWrapper, isActive: isActive, ConditionalErrorBoundary: ConditionalErrorBoundary } = this.props;
        const { isHovered: isHovered } = this.state;
        return coreColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConditionalErrorBoundary, {
                key: `${columnId}-${id}`,
                columnId: columnId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CellWrapper, {
                key: columnId,
                rowId: id,
                columnId: columnId,
                isRowHovered: isHovered,
                isRowKeyboardActive: isActive,
                onCellMount: this.recalculateHeight
            })));
    }
    renderAdditionalColumns() {
        const { id: id, additionalColumnIds: additionalColumnIds, AdditionalColumnsContainer: AdditionalColumnsContainer, CellWrapper: CellWrapper, isActive: isActive, ConditionalErrorBoundary: ConditionalErrorBoundary } = this.props;
        const { isHovered: isHovered } = this.state;
        return additionalColumnIds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdditionalColumnsContainer, {
            placeholderKey: (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? 'rows.common.default-row' : undefined
        }, additionalColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConditionalErrorBoundary, {
                key: `${columnId}-${id}`,
                columnId: columnId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CellWrapper, {
                key: columnId,
                rowId: id,
                columnId: columnId,
                isRowHovered: isHovered,
                isRowKeyboardActive: isActive,
                onCellMount: this.recalculateHeight
            })))) : null;
    }
    render() {
        const { isActive: isActive, theme: theme } = this.props;
        const { isHovered: isHovered } = this.state;
        const color = this.determineRowColor(isActive, isHovered);
        return this.state.render ? // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "virtual-table-row",
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
            onFocus: undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            ref: this.setRef,
            // @ts-expect-error - TS2322 - Type '{ display: string; boxSizing: string; borderTop: string; borderBottom: string; height: string; minHeight: string; marginLeft: string; boxShadow: string; } | { backgroundColor: string; display: string; ... 6 more ...; boxShadow: string; }' is not assignable to type 'CSSProperties | undefined'.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $eb65ca7832d2c63e$var$getWrapperStyles(color, theme)
        }, this.renderChildOperationIndicator(), this.renderCoreColumns(), this.renderAdditionalColumns())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "virtual-table-row",
            // @ts-expect-error - TS2322 - Type '{ display: string; boxSizing: string; borderTop: string; borderBottom: string; height: string; minHeight: string; marginLeft: string; boxShadow: string; } | { backgroundColor: string; display: string; ... 6 more ...; boxShadow: string; }' is not assignable to type 'CSSProperties | undefined'.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $eb65ca7832d2c63e$var$getWrapperStyles(color, theme)
        }, this.renderChildOperationIndicator(), this.renderCoreColumns());
    }
}
var $eb65ca7832d2c63e$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('virtualTableRows', {
    onRowContentMount: 'mounted'
})((0, $i1eKe.withTheme)($eb65ca7832d2c63e$var$RowContent));

});


parcelRegister("7jAlr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2b80c9673f297b0$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $aBFKZ = parcelRequire("aBFKZ");

var $7jTnu = parcelRequire("7jTnu");

var $i1eKe = parcelRequire("i1eKe");

var $3Ogvp = parcelRequire("3Ogvp");
// regarding height & overflow:
// we set the height here to reduce positioning complexity.
// otherwise we need to consider the add bar and its' visibility
// while offsetting margins on the row
const $e2b80c9673f297b0$var$getOuterWrapperStyles = (isSelected)=>({
        ...isSelected ? {
            backgroundColor: "var(--ds-background-selected, #E9F2FF)"
        } : {},
        marginLeft: "var(--ds-space-0, 0px)",
        outline: 'none'
    });
const $e2b80c9673f297b0$var$getContentWrapperStyles = ()=>({
        height: 'auto',
        minHeight: "var(--ds-space-500, 40px)",
        overflow: 'hidden',
        marginTop: "var(--ds-space-0, 0px)",
        borderRadius: "var(--ds-space-050, 4px)",
        flexGrow: 1
    });
// The following styles create a faux absolute element with the height and width of its flex(direction row) parent.
// We cannot use position relative on OuterWrapper as elements in virtual-table-row-list-portal
// depend on a relative parent at the table level.
const $e2b80c9673f297b0$var$rowHighlightWrapperStylesOld = {
    position: 'relative',
    flexShrink: 0,
    width: '100%',
    marginLeft: '-100%',
    transform: 'translateX(100%)',
    pointerEvents: 'none'
};
// eslint-disable-next-line jira/react/no-class-components
class $e2b80c9673f297b0$var$DefaultRow extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.myRef = /*#__PURE__*/ (0, $eJOHy.createRef)();
        this.state = {
            render: false
        };
    }
    componentDidMount() {
        this.timeoutId = setTimeout(()=>this.setState({
                render: true
            }), 250); // we render the AddBar quite delayed as it will only be visible when hovered
        if (this.props.isActiveItem && this.myRef.current) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.focus();
        this.myRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.addEventListener('focusin', this.props.onFocusCallback);
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { id: id, isActiveItem: isActiveItem, isRowHighlighted: isRowHighlighted, isRowLeftEdgeVisible: isRowLeftEdgeVisible, isRowRightEdgeVisible: isRowRightEdgeVisible, isSelected: isSelected } = this.props;
        return id !== nextProps.id || this.state.render !== nextState.render || isActiveItem !== nextProps.isActiveItem || isRowHighlighted !== nextProps.isRowHighlighted || isRowLeftEdgeVisible !== nextProps.isRowLeftEdgeVisible || isRowRightEdgeVisible !== nextProps.isRowRightEdgeVisible || isSelected !== nextProps.isSelected;
    }
    componentDidUpdate(prevProps) {
        if (this.props.isActiveItem && !prevProps.isActiveItem && this.myRef.current && this.props.setFocusOnRow) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.focus();
    }
    componentWillUnmount() {
        clearTimeout(this.timeoutId);
        this.myRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.removeEventListener('focusin', this.props.onFocusCallback);
    }
    render() {
        const { id: id, isRowHighlighted: isRowHighlighted, isRowLeftEdgeVisible: isRowLeftEdgeVisible, isRowRightEdgeVisible: isRowRightEdgeVisible, isGlobalAddEnabled: isGlobalAddEnabled, AddBar: AddBar, Content: Content, theme: theme, onClick: onClick, onRowContentMount: onRowContentMount, onRowContentUpdate: onRowContentUpdate, isSelected: isSelected } = this.props;
        return (0, $7jTnu.fg)('jsm_virtual_table_a11y') ? // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            // @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
            ref: this.myRef,
            onClick: onClick,
            xcss: [
                $e2b80c9673f297b0$var$outerWrapperStyles,
                isSelected && $e2b80c9673f297b0$var$selectOuterWrapperStyles
            ],
            // tabIndex is needed to be able to focus / navigate through rows and scroll vertically while navigating through the rows that are offscreen
            tabIndex: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $e2b80c9673f297b0$var$innerWrapperStyles,
            role: "row"
        }, isRowHighlighted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                "_kqswh2mm _1o9zidpf _1bsb1osq _18u0pwvu _t9ecxwn4 _lcxvglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ogvp.RowHighlight), {
            theme: theme,
            isRowLeftEdgeVisible: isRowLeftEdgeVisible,
            isRowRightEdgeVisible: isRowRightEdgeVisible
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $e2b80c9673f297b0$var$contentWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, {
            id: id,
            onRowContentMount: onRowContentMount,
            onRowContentUpdate: onRowContentUpdate
        }))), isGlobalAddEnabled && this.state.render && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AddBar, {
            rowId: id
        })) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            // @ts-expect-error - TS2322 - Type 'RefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
            ref: this.myRef,
            onClick: onClick,
            role: "presentation",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $e2b80c9673f297b0$var$getOuterWrapperStyles(isSelected),
            tabIndex: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            style: {
                display: 'flex'
            }
        }, isRowHighlighted && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            style: $e2b80c9673f297b0$var$rowHighlightWrapperStylesOld
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ogvp.RowHighlight), {
            theme: theme,
            isRowLeftEdgeVisible: isRowLeftEdgeVisible,
            isRowRightEdgeVisible: isRowRightEdgeVisible
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            style: $e2b80c9673f297b0$var$getContentWrapperStyles()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, {
            id: id,
            onRowContentMount: onRowContentMount,
            onRowContentUpdate: onRowContentUpdate
        }))), isGlobalAddEnabled && this.state.render && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AddBar, {
            rowId: id
        }));
    }
}
var $e2b80c9673f297b0$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('rowItem', {
    onClick: 'clicked'
})((0, $i1eKe.withTheme)($e2b80c9673f297b0$var$DefaultRow));
const $e2b80c9673f297b0$var$outerWrapperStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.0',
    outline: 'none'
});
const $e2b80c9673f297b0$var$selectOuterWrapperStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.selected'
});
const $e2b80c9673f297b0$var$innerWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex'
});
const $e2b80c9673f297b0$var$rowHighlightWrapperStyles = null;
const $e2b80c9673f297b0$var$contentWrapperStyles = (0, $1DXK0.xcss)({
    height: 'auto',
    minHeight: 'space.500',
    overflow: 'hidden',
    marginTop: 'space.0',
    borderRadius: 'space.050',
    flexGrow: 1
});

});
parcelRegister("3Ogvp", function(module, exports) {

$parcel$export(module.exports, "getWidth", () => $aaba7d57f061d6d7$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "RowHighlight", () => $aaba7d57f061d6d7$export$c5433d3086f82ff8);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $8nFYk = parcelRequire("8nFYk");
const $aaba7d57f061d6d7$export$85ae013617b39492 = ({ width: width, isFirstColumn: isFirstColumn })=>`
    width: ${isFirstColumn ? width + (0, $8nFYk.levelIndentBaseline) : width}px;
`;
const $aaba7d57f061d6d7$export$3c49c185de0c2bfc = ({ width: width, isFirstColumn: isFirstColumn })=>`${isFirstColumn ? width + (0, $8nFYk.levelIndentBaseline) : width}px`;
const $aaba7d57f061d6d7$export$c5433d3086f82ff8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isRowRightEdgeVisible: isRowRightEdgeVisible, theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_pbz34m": (0, $awdRS.default)(__cmplp.isRowRightEdgeVisible ? 0 : "var(--ds-space-negative-100, -8px)"),
            "--_5kefb9": (0, $awdRS.default)(__cmplp.theme.row.borderRadius)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154ix0bf _1xi2idpf _94n5x0bf _1ltvidpf _lcxvglyw _14mj1rr2 _j9jr1w01 _39yqt94y _1tv3nqa1 _8l3mmuej _18postnw _15l2idpf _32rx14cd _1x88idpf _19doidpf _aetrb3bt _11fnglyw _1bqqkb7n",
            __cmplp.isRowRightEdgeVisible ? "_1reoewfl _18m9ewfl" : "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("dgxyo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e9749908aaf777d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $gCeeo = parcelRequire("gCeeo");

class $4e9749908aaf777d$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.onFocusCallback = ()=>{
            const { isInRowNavigationMode: isInRowNavigationMode, onSetActiveRow: onSetActiveRow, rowIndex: rowIndex } = this.props;
            if (isInRowNavigationMode) onSetActiveRow({
                rowIndex: rowIndex
            });
        }, this.onClick = (event, analyticsEvent)=>{
            this.props.onSetActiveRow({
                rowIndex: this.props.rowIndex
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'click', {
                rowIndex: this.props.rowIndex
            });
        };
        this.state = {
            delayRender: props.delayRowRenderOnScroll
        };
    }
    componentDidMount() {
        if (this.state.delayRender) setTimeout(()=>this.setState({
                delayRender: false
            }), 16);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.id !== nextProps.id || this.props.isInCreation !== nextProps.isInCreation || this.state.delayRender !== nextState.delayRender || this.props.rowIndex !== nextProps.rowIndex;
    }
    render() {
        const { id: id, isInCreation: isInCreation, isLoading: isLoading, rowIndex: rowIndex, onLoadingRowUnmount: onLoadingRowUnmount, NewRow: NewRow, LoadingRow: LoadingRow, onRowContentMount: onRowContentMount, onRowContentUpdate: onRowContentUpdate, DefaultRow: DefaultRow } = this.props;
        if (isInCreation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NewRow, {
            id: id
        });
        if (LoadingRow && (isLoading || this.state.delayRender)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(LoadingRow, {
            id: id,
            onClick: this.onClick,
            onUnmount: isLoading || this.state.delayRender ? onLoadingRowUnmount : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            reasonType: isLoading ? (0, $ff4c22136947deab$export$a63dec0667c2f97a) : (0, $ff4c22136947deab$export$456b4a90eb507580),
            rowIndex: rowIndex,
            onRowContentUpdate: onRowContentUpdate,
            onFocusCallback: this.onFocusCallback
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DefaultRow, {
            id: id,
            onClick: this.onClick,
            onRowContentMount: onRowContentMount,
            onRowContentUpdate: onRowContentUpdate,
            onFocusCallback: this.onFocusCallback
        });
    }
}

});

parcelRegister("1trep", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd4508b1c2b2843f$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");


var $9Zs47 = parcelRequire("9Zs47");

var $4Mvfe = parcelRequire("4Mvfe");

var $b5S8m = parcelRequire("b5S8m");

var $2Ctxl = parcelRequire("2Ctxl");

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $fRJOe = parcelRequire("fRJOe");

var $gsVjm = parcelRequire("gsVjm");

var $fHN3N = parcelRequire("fHN3N");

var $cnVHi = parcelRequire("cnVHi");
var $dd4508b1c2b2843f$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, { id: id })=>({
        depth: (0, $fRJOe.getRowDepth)(state, id),
        maxDepth: (0, $kcVGc.getMaxDepth)(state),
        status: (0, $kcVGc.getRowAddingStatus)(state, id),
        coreColumnIds: (0, $2Ctxl.getVisibleCoreColumnIds)(state),
        additionalColumnIds: (0, $5wAOx.getVisibleAdditionalColumnIds)(state),
        defaultAddColumnId: (0, $5wAOx.getDefaultAddColumnId)(state),
        isActive: (0, $fRJOe.isActiveRowId)(state, id),
        onPersistAddedRowRequested: (0, $5wAOx.getPersistAddedRowCallback)(state),
        onCancelAddedRowRequested: (0, $5wAOx.getCancelAddedRowCallback)(state),
        navigationMode: (0, $5wAOx.getNavigationMode)(state),
        AdditionalColumnsContainer: $gsVjm.default,
        CellWrapper: $fHN3N.default
    }), {
    setActiveCell: $4Mvfe.setActiveCell,
    clearActiveItem: $9Zs47.clear,
    setMultiAddAnchor: $b5S8m.set
}, // @ts-expect-error - TS7031 - Binding element 'defaultAddColumnId' implicitly has an 'any' type.
({ defaultAddColumnId: defaultAddColumnId, ...stateProps }, dispatchProps, ownProps)=>({
        ...ownProps,
        ...stateProps,
        setMultiAddAnchor: dispatchProps.setMultiAddAnchor,
        setActiveItem: ()=>{
            if (0, $1d080e9e60c37b43$export$9e9986b7abe95577) dispatchProps.setActiveCell({
                type: (0, $1d080e9e60c37b43$export$4b3489234fd17200),
                rowId: ownProps.id,
                columnId: defaultAddColumnId
            });
            else if (0, $1d080e9e60c37b43$export$a01cd8e028b3d34f) dispatchProps.setActiveRow({
                type: (0, $1d080e9e60c37b43$export$8a257aa81ef4a9e0),
                rowIndex: ownProps.rowIndex
            });
        },
        clearActiveItem: dispatchProps.clearActiveItem
    }))((0, $cnVHi.default));

});
parcelRegister("b5S8m", function(module, exports) {

$parcel$export(module.exports, "SET_MULTI_ADD_ANCHOR", () => $1d60e61a135b9c6a$export$45d5c36be62dcf8e);
$parcel$export(module.exports, "set", () => $1d60e61a135b9c6a$export$adaa4cf7ef1b65be);
const $1d60e61a135b9c6a$export$45d5c36be62dcf8e = 'ops.rows.add-anchor.set.SET_MULTI_ADD_ANCHOR';
const $1d60e61a135b9c6a$export$adaa4cf7ef1b65be = (rowId)=>({
        type: $1d60e61a135b9c6a$export$45d5c36be62dcf8e,
        payload: rowId
    });

});

parcelRegister("cnVHi", function(module, exports) {

$parcel$export(module.exports, "default", () => $367336e71aa9f1b6$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $6S4l2 = parcelRequire("6S4l2");


var $7jTnu = parcelRequire("7jTnu");

var $i1eKe = parcelRequire("i1eKe");

var $8nFYk = parcelRequire("8nFYk");
// eslint-disable-next-line jira/react/no-class-components
class $367336e71aa9f1b6$var$NewRow extends (0, $eJOHy.PureComponent) {
    componentDidMount() {
        const { status: status, setActiveItem: setActiveItem } = this.props;
        if (status === 'NEW') setActiveItem();
    }
    componentDidUpdate(prevProps) {
        const { id: id, status: status, isActive: isActive, onPersistAddedRowRequested: onPersistAddedRowRequested } = this.props;
        if (prevProps.isActive && !isActive && status === 'NEW') onPersistAddedRowRequested(id);
    }
    componentWillUnmount() {
        /* If we are navigating by Cell.
     * All cells in a new row will be unmounted with it, stopping the clear callback from occurring.
     * This means anyone subscribing to the currently active cell may still refer to the temporary cells id,
     * even when that temporary value has been resolved into a "real" one.
     * We would not want to do this in the cell wrapper, as the problem does not exist for other rows, and could
     * cause side-effects.
     */ this.props.clearActiveItem();
    }
    renderCoreColumns() {
        const { id: id, coreColumnIds: coreColumnIds, CellWrapper: CellWrapper } = this.props;
        return coreColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CellWrapper, {
                key: columnId,
                rowId: id,
                columnId: columnId,
                isRowTemporary: true,
                confirmToNavigate: false
            }));
    }
    renderAdditionalColumns() {
        const { id: id, additionalColumnIds: additionalColumnIds, AdditionalColumnsContainer: AdditionalColumnsContainer, CellWrapper: CellWrapper } = this.props;
        return additionalColumnIds.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdditionalColumnsContainer, {
            placeholderKey: (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? 'content.rows.row-list.common.base-list.row-item' : undefined
        }, additionalColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CellWrapper, {
                key: columnId,
                rowId: id,
                columnId: columnId,
                isRowTemporary: true,
                confirmToNavigate: false
            }))) : null;
    }
    render() {
        const { depth: depth, maxDepth: maxDepth, status: status, theme: theme } = this.props;
        const indent = (0, $8nFYk.levelIndentBaseline) + depth * (0, $8nFYk.levelIndentBaseline);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                background: status === 'PERSISTING' ? $367336e71aa9f1b6$var$persistingGradient : (0, $7bb4c1736002a04a$exports).G50,
                marginLeft: `${indent}px`
            },
            onKeyDown: this.onCellKeyDown,
            className: (0, $hcewu.default)([
                "_x3dooyrj _n7zloyrj _1e0c1txw _vchhusvi _4t3i1jfw _19pkze3t"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($367336e71aa9f1b6$var$FakeChildOperationIndicator, {
            isMaxDepth: depth === maxDepth,
            theme: theme
        }), this.renderCoreColumns(), this.renderAdditionalColumns());
    }
    constructor(...args){
        super(...args), this.onCellKeyDown = (event)=>{
            const { id: id, status: status, setMultiAddAnchor: setMultiAddAnchor, onPersistAddedRowRequested: onPersistAddedRowRequested, onCancelAddedRowRequested: onCancelAddedRowRequested } = this.props;
            if (status === 'NEW') switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter'):
                    event.stopPropagation();
                    setMultiAddAnchor(id);
                    onPersistAddedRowRequested(id);
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('escape'):
                    event.stopPropagation();
                    onCancelAddedRowRequested(id);
                    break;
                default:
                    break;
            }
        };
    }
}
var $367336e71aa9f1b6$export$2e2bcd8739ae039 = (0, $i1eKe.withTheme)($367336e71aa9f1b6$var$NewRow);
const $367336e71aa9f1b6$var$persistingGradient = `
    repeating-linear-gradient(
        315deg,
        rgba(0,0,0,0.1), rgba(0,0,0,0.1) 1px,
        ${(0, $7bb4c1736002a04a$exports).N0} 0, ${(0, $7bb4c1736002a04a$exports).N0} 5px
    )
`;
const $367336e71aa9f1b6$var$rowWrapperStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $367336e71aa9f1b6$var$FakeChildOperationIndicator = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMaxDepth: isMaxDepth, theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_eobblv": (0, $awdRS.default)(__cmplp.theme.row.maxDepthChildrenOperationIndicatorWidth, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi",
            __cmplp.isMaxDepth ? "_1bsb1fz4" : "_1bsbg21h",
            __cmplp.className
        ])
    });
});

});




parcelRegister("gdGcD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6c4b5851afd3e2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $7a6c4b5851afd3e2$export$2e2bcd8739ae039(props) {
    const { rowIds: rowIds, List: List } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(List, {
        rowIds: rowIds,
        displayStart: 0,
        displayEnd: rowIds.length
    });
}

});


parcelRegister("ff0G1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd09e29ba2de799d$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aCWQQ = parcelRequire("aCWQQ");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd09e29ba2de799d$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.className
        ])
    });
});
class $fd09e29ba2de799d$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        const { isAutoHeight: isAutoHeight, AutoHeightList: AutoHeightList, VirtualList: VirtualList } = this.props;
        const Content = // tabIndex is needed to be able to focus / navigate through rows and scroll vertically while navigating through the rows that are offscreen
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fd09e29ba2de799d$var$Wrapper, {
            tabIndex: -1,
            ref: this.onRefChanged
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            ref: this.onDivRefChanged,
            className: "virtual-table-row-list-portal"
        }), isAutoHeight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AutoHeightList, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(VirtualList, null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aCWQQ.default), null), Content);
    }
    constructor(...args){
        super(...args), this.onRefChanged = (el)=>{
            const { onRowListFocusFunctionChanged: onRowListFocusFunctionChanged } = this.props;
            if (!onRowListFocusFunctionChanged) return;
            if (el != null) onRowListFocusFunctionChanged(()=>{
                el && el.focus();
            });
            else onRowListFocusFunctionChanged(null);
        }, this.onDivRefChanged = (el)=>{
            const { onReactPortalContainerRefChanged: onReactPortalContainerRefChanged } = this.props;
            if (!onReactPortalContainerRefChanged) return;
            if (el != null) onReactPortalContainerRefChanged(el);
        };
    }
}

});
parcelRegister("aCWQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c6d23e1e38833d6$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $dZqHT = parcelRequire("dZqHT");

var $3z7Cz = parcelRequire("3z7Cz");

var $5wAOx = parcelRequire("5wAOx");

var $9lqzG = parcelRequire("9lqzG");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $UvZeO = parcelRequire("UvZeO");
const $3c6d23e1e38833d6$var$mapDispatchToProps = {
    navigateToRow: $dZqHT.navigateToRow,
    clearActiveItem: $9lqzG.clearActiveItem,
    setHorizontalScrollOffset: $3z7Cz.setHorizontal
};
var $3c6d23e1e38833d6$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        maxHorizontalScrollOffset: (0, $fRJOe.getMaxHorizontalScrollOffset)(state),
        horizontalScrollOffset: (0, $atQRE.getHorizontalScrollOffset)(state),
        navigationMode: (0, $5wAOx.getNavigationMode)(state),
        activeRowIndex: (0, $fRJOe.getActiveRowIndex)(state),
        isContentStale: (0, $5wAOx.isContentStale)(state)
    }), $3c6d23e1e38833d6$var$mapDispatchToProps)((0, $UvZeO.default));

});
parcelRegister("UvZeO", function(module, exports) {

$parcel$export(module.exports, "default", () => $240f1516f160ba19$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1rzja = parcelRequire("1rzja");

var $3IF6p = parcelRequire("3IF6p");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");


const $240f1516f160ba19$var$KeyboardShortcuts = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const HORIZONTAL_SCROLL_DISTANCE = 40;
    const SHIFT_TAB = 'shiftTab';
    const analyticsEvent = createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'rowItem'
    });
    const handleTabKey = (tabKey)=>{
        if (props.isContentStale || props.navigationMode !== (0, $1d080e9e60c37b43$export$a01cd8e028b3d34f)) return;
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, tabKey === SHIFT_TAB ? 'tabFieldLeft' : 'tabFieldRight', {
            rowIndex: props.activeRowIndex,
            keyPressed: tabKey
        });
    };
    const handleKeyUpOrDown = (direction, key, index)=>{
        if (props.isContentStale || props.navigationMode !== (0, $1d080e9e60c37b43$export$a01cd8e028b3d34f)) return;
        props.navigateToRow({
            direction: direction
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, `navigateRow${(0, (/*@__PURE__*/$parcel$interopDefault($1rzja)))(direction)}`, {
            keyPressed: key,
            rowIndex: index
        });
    };
    const handleKeyLeft = ()=>{
        if (props.isContentStale || props.navigationMode !== (0, $1d080e9e60c37b43$export$a01cd8e028b3d34f)) return;
        const newOffset = Math.max(0, props.horizontalScrollOffset - HORIZONTAL_SCROLL_DISTANCE);
        if (props.horizontalScrollOffset !== newOffset) props.setHorizontalScrollOffset(newOffset);
    };
    const handleKeyRight = ()=>{
        if (props.isContentStale || props.navigationMode !== (0, $1d080e9e60c37b43$export$a01cd8e028b3d34f)) return;
        const newOffset = Math.min(props.maxHorizontalScrollOffset, props.horizontalScrollOffset + HORIZONTAL_SCROLL_DISTANCE);
        if (props.horizontalScrollOffset !== newOffset) props.setHorizontalScrollOffset(newOffset);
    };
    const mapping = {
        tab: {
            callback: ()=>handleTabKey('tab')
        },
        'shift+tab': {
            callback: ()=>handleTabKey(SHIFT_TAB)
        },
        j: {
            callback: ()=>handleKeyUpOrDown((0, $7e33285e7fb1fa6b$export$c7c029a231f98d34), 'j', props.activeRowIndex)
        },
        arrowdown: {
            callback: ()=>handleKeyUpOrDown((0, $7e33285e7fb1fa6b$export$c7c029a231f98d34), 'arrowdown', props.activeRowIndex)
        },
        k: {
            callback: ()=>handleKeyUpOrDown((0, $7e33285e7fb1fa6b$export$b29f845fa4b57508), 'k', props.activeRowIndex)
        },
        arrowup: {
            callback: ()=>handleKeyUpOrDown((0, $7e33285e7fb1fa6b$export$b29f845fa4b57508), 'arrowup', props.activeRowIndex)
        },
        arrowleft: {
            callback: ()=>handleKeyLeft()
        },
        arrowright: {
            callback: ()=>handleKeyRight()
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IF6p.default), {
        keyMap: mapping
    });
};
$240f1516f160ba19$var$KeyboardShortcuts.defaultProps = {
    isContentStale: false
};
var $240f1516f160ba19$export$2e2bcd8739ae039 = $240f1516f160ba19$var$KeyboardShortcuts;

});
parcelRegister("3IF6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac4ee5f40705d91a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $kvNWh = parcelRequire("kvNWh");

var $676Hn = parcelRequire("676Hn");

var $b2ThO = parcelRequire("b2ThO");

var $dM9A7 = parcelRequire("dM9A7");

var $2ZGUP = parcelRequire("2ZGUP");

var $iUli2 = parcelRequire("iUli2");
let $ac4ee5f40705d91a$var$shortcutsCount = 0;
let $ac4ee5f40705d91a$var$subscription = null;
const $ac4ee5f40705d91a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eJOHy.useContext)((0, $2ZGUP.ShortcutRegistryContext)) || (0, $dM9A7.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const addKeyMap = (0, $eJOHy.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $iUli2.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $ac4ee5f40705d91a$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $ac4ee5f40705d91a$var$shortcutsCount -= 1;
            if ($ac4ee5f40705d91a$var$subscription && $ac4ee5f40705d91a$var$shortcutsCount === 0) {
                $ac4ee5f40705d91a$var$subscription.unsubscribe();
                $ac4ee5f40705d91a$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $ac4ee5f40705d91a$var$subscription = $ac4ee5f40705d91a$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $b2ThO.default)().subscribe((0, $676Hn.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ac4ee5f40705d91a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $kvNWh.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac4ee5f40705d91a$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("kvNWh", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $28efcafdf90afd66$export$a33a81f1fc5458ad);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $hWeHP = parcelRequire("hWeHP");

var $gCeeo = parcelRequire("gCeeo");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $28efcafdf90afd66$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $28efcafdf90afd66$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$28efcafdf90afd66$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $jGzN3.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $gYnSx.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $28efcafdf90afd66$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $hWeHP.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $28efcafdf90afd66$export$b62f67be35e65859
    }
});
const $28efcafdf90afd66$export$a33a81f1fc5458ad = (0, $iJq0l.createHook)($28efcafdf90afd66$var$Store);

});

parcelRegister("676Hn", function(module, exports) {

$parcel$export(module.exports, "default", () => $29a82f2f140805e4$export$2e2bcd8739ae039);

var $b2ThO = parcelRequire("b2ThO");

var $dM9A7 = parcelRequire("dM9A7");
const $29a82f2f140805e4$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$29a82f2f140805e4$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $dM9A7.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $b2ThO.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($29a82f2f140805e4$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $b2ThO.flush)();
    }
};

});
parcelRegister("b2ThO", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb63e776564d4094$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $bb63e776564d4094$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $7kixv = parcelRequire("7kixv");

var $6WhQS = parcelRequire("6WhQS");
parcelRequire("7SsGX");
parcelRequire("hnYRz");
parcelRequire("llumX");
parcelRequire("lVRem");
parcelRequire("1o2WJ");
parcelRequire("8rm0O");
parcelRequire("9Zsih");
parcelRequire("lf3vd");

var $aBrUN = parcelRequire("aBrUN");
const $bb63e776564d4094$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $bb63e776564d4094$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb63e776564d4094$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$bb63e776564d4094$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb63e776564d4094$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$bb63e776564d4094$var$isEditable(e.target) && !$bb63e776564d4094$var$ignoredKeys[e.key]);
const $bb63e776564d4094$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $bb63e776564d4094$var$key$;
const $bb63e776564d4094$var$flush$ = new (0, $6WhQS.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bb63e776564d4094$export$2e2bcd8739ae039 = ()=>{
    if (!$bb63e776564d4094$var$key$) {
        $bb63e776564d4094$var$key$ = false ? new (0, $6WhQS.Subject)() : (0, $7kixv.Observable).fromEvent(document, 'keydown').filter($bb63e776564d4094$var$isRelevantKeyEvent).filter($bb63e776564d4094$export$25d1b8252b4c49b7).map((0, $aBrUN.toKeyWithModifiers));
        const sequence$ = $bb63e776564d4094$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $bb63e776564d4094$var$key$ = $bb63e776564d4094$var$key$.debounceTime(1000).startWith(null).merge($bb63e776564d4094$var$flush$).switchMapTo(sequence$);
    }
    return $bb63e776564d4094$var$key$;
};
const $bb63e776564d4094$export$4909b86c8034bf73 = ()=>{
    $bb63e776564d4094$var$flush$.next();
};

});


parcelRegister("iUli2", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $0344ad6591542af9$export$77477772a9b904da);

var $eSnSE = parcelRequire("eSnSE");

var $gCeeo = parcelRequire("gCeeo");

var $7jTnu = parcelRequire("7jTnu");
const $0344ad6591542af9$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent && (0, $7jTnu.fg)('log-hotkey-analytics')) (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $0344ad6591542af9$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $0344ad6591542af9$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});





parcelRegister("c8xUP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7a6f7565e0e36b5$export$2e2bcd8739ae039);

var $hjf2q = parcelRequire("hjf2q");
var $gCeeo = parcelRequire("gCeeo");

var $aIrSA = parcelRequire("aIrSA");

var $4ped1 = parcelRequire("4ped1");

var $5EfBD = parcelRequire("5EfBD");

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $fRJOe = parcelRequire("fRJOe");

var $02dWc = parcelRequire("02dWc");

var $0qCUH = parcelRequire("0qCUH");

var $2bdxu = parcelRequire("2bdxu");
const $a7a6f7565e0e36b5$var$mapStateToProps = (state)=>({
        rowIds: (0, $02dWc.getFlattenedWithAddedRowIds)(state),
        contentHeight: (0, $fRJOe.getTableContentHeight)(state),
        isAutoRowHeight: (0, $kcVGc.isAutoRowHeight)(state),
        defaultRowHeight: (0, $kcVGc.getDefaultRowHeight)(state),
        virtualBoundaries: (0, $fRJOe.getVirtualBoundaries)(state),
        numberOfLoadingRows: (0, $fRJOe.getNumberOfLoadingRowsInDisplayBoundary)(state),
        isTableFacade: (0, $5wAOx.isTableFacade)(state),
        List: $0qCUH.default
    });
const $a7a6f7565e0e36b5$var$mapDispatchToProps = (dispatch)=>({
        batchUpdateRowHeightMapping: (rowIds, rowHeightMapping)=>dispatch((0, $5EfBD.batchUpdateRowHeightMapping)(rowIds, rowHeightMapping)),
        onDeferredBuffering: (rowsRendered, rowsDeferred, analyticsEvent)=>{
            (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'virtualList deferredBuffering', {
                rowsRendered: rowsRendered,
                rowsDeferred: rowsDeferred
            });
        },
        onLoadingRowUnmount: (numberOfLoadingRows, displayStart, rowId, timeVisibleFor, reasonType, analyticsEvent)=>displayStart === 0 ? undefined : dispatch((0, $4ped1.fireLoadingRowAnalytics)({
                rowId: rowId,
                timeVisibleFor: timeVisibleFor,
                numberOfLoadingRows: numberOfLoadingRows,
                reasonType: reasonType,
                analyticsEvent: analyticsEvent
            }))
    });
var $a7a6f7565e0e36b5$export$2e2bcd8739ae039 = (0, $aIrSA.connect)($a7a6f7565e0e36b5$var$mapStateToProps, $a7a6f7565e0e36b5$var$mapDispatchToProps)((0, $hjf2q.AnalyticsEventToProps)('virtualList', {
    onDeferredBuffering: 'deferredBuffering'
})((0, $2bdxu.default)));

});
parcelRegister("4ped1", function(module, exports) {

$parcel$export(module.exports, "FIRE_LOADING_ROW_ANALYTICS", () => $85f5a940b30dd856$export$73369b76089b13a6);
$parcel$export(module.exports, "fireLoadingRowAnalytics", () => $85f5a940b30dd856$export$d043bad71b13e219);
const $85f5a940b30dd856$export$73369b76089b13a6 = 'ops.rows.analytics.FIRE_LOADING_ROW_ANALYTICS';
const $85f5a940b30dd856$export$d043bad71b13e219 = (payload)=>({
        type: $85f5a940b30dd856$export$73369b76089b13a6,
        payload: payload
    });

});

parcelRegister("5EfBD", function(module, exports) {

$parcel$export(module.exports, "BATCH_UPDATE_ROW_HEIGHT_MAPPING", () => $458e1155b2b175bb$export$1e2cc4b1d7e85685);
$parcel$export(module.exports, "batchUpdateRowHeightMapping", () => $458e1155b2b175bb$export$6ad1445af83aec72);
const $458e1155b2b175bb$export$1e2cc4b1d7e85685 = 'ops.rows.row-height.BATCH_UPDATE_ROW_HEIGHT_MAPPING';
const $458e1155b2b175bb$export$6ad1445af83aec72 = (rowIds, rowHeightMapping)=>({
        type: $458e1155b2b175bb$export$1e2cc4b1d7e85685,
        payload: {
            rowIds: rowIds,
            rowHeightMapping: rowHeightMapping
        }
    });

});

parcelRegister("2bdxu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fb49323f74295c3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fwzaq = parcelRequire("fwzaq");

var $6d9QY = parcelRequire("6d9QY");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $hrKgE = parcelRequire("hrKgE");

var $8pnqM = parcelRequire("8pnqM");
const $2fb49323f74295c3$var$ANALYTICS_DEBOUNCE_TIME = 5000;
const $2fb49323f74295c3$var$stateToRenderState = (state)=>{
    const { visibleStart: visibleStart, visibleEnd: visibleEnd, displayStart: displayStart, displayEnd: displayEnd, rowIds: rowIds } = state;
    return {
        virtualBoundaries: {
            visibleStart: visibleStart,
            visibleEnd: visibleEnd,
            displayStart: displayStart,
            displayEnd: displayEnd
        },
        rowIds: rowIds
    };
};
// eslint-disable-next-line jira/react/no-class-components
class $2fb49323f74295c3$var$VirtualListOld extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.updateStateRowHeight = (rowId, rowHeight)=>{
            this.rowHeightUpdateBatch[rowId] = rowHeight;
        };
        this.state = {
            displayStart: 0,
            displayEnd: 0,
            visibleStart: 0,
            visibleEnd: 0,
            rowHeights: {},
            rowIds: props.rowIds
        };
        const { rowIds: rowIds } = props;
        this.rowIds = rowIds;
        this.rowHeightUpdateBatch = {};
        this.shouldUpdate = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { isTableFacade: isTableFacade, isAutoRowHeight: isAutoRowHeight, virtualBoundaries: virtualBoundaries, rowIds: rowIds } = nextProps;
        const { visibleStart: visibleStart, visibleEnd: visibleEnd } = virtualBoundaries;
        // 1) In case of TreeTable, update the list only when we scroll and
        // pass beyond the buffer rows, rather than for every scroll update
        //      1.1) make an inclusive equality comparison. we always want at least 1
        //      item beyond the viewport so we can keyboard navigate to it
        // 2) In case of Table, the list is updated when it's scrolled past even one row.
        // This is to address the weird experience where, when scrolling the table upwards,
        // with deferred row rendering, the rows render one-by-one downwards in batches of 5 (SHIELD-3990)
        if (isTableFacade && (visibleStart < this.state.visibleStart || visibleEnd > this.state.visibleEnd) || visibleStart <= this.state.displayStart || visibleEnd >= this.state.displayEnd) {
            this.shouldUpdate = true;
            if (isTableFacade && (0, $8pnqM.shouldDeferBuffering)($2fb49323f74295c3$var$stateToRenderState(this.state), nextProps)) {
                this.setState({
                    visibleEnd: visibleEnd,
                    visibleStart: visibleStart,
                    displayStart: visibleStart,
                    displayEnd: visibleEnd,
                    rowIds: rowIds
                });
                this.needsDisplayBufferRendered = true;
            } else {
                this.needsDisplayBufferRendered = false;
                this.cancelBuffering();
                this.setState({
                    ...virtualBoundaries,
                    rowIds: rowIds
                });
            }
        } else this.shouldUpdate = false;
        if (isAutoRowHeight) {
            const { batchUpdateRowHeightMapping: batchUpdateRowHeightMapping } = nextProps;
            if (this.batchUpdateTimeoutId == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            this.batchUpdateTimeoutId = window.setTimeout(()=>{
                this.batchUpdateTimeoutId = null;
                if (Object.keys(this.rowHeightUpdateBatch).length > 0) batchUpdateRowHeightMapping(rowIds, this.rowHeightUpdateBatch);
                this.rowHeightUpdateBatch = {};
            });
        }
    }
    shouldComponentUpdate(nextProps) {
        const { rowIds: rowIds, contentHeight: contentHeight } = this.props;
        // table has been resized or entirely new rows: we need to re-adjust - end of story.
        if (contentHeight !== nextProps.contentHeight || rowIds !== nextProps.rowIds) return true;
        // the buffer rows have been surpassed, render a new set of rows and buffers
        return this.shouldUpdate;
    }
    componentDidUpdate() {
        this.shouldUpdate = false;
        if (this.needsDisplayBufferRendered) {
            this.needsDisplayBufferRendered = false;
            const { displayStart: displayStart, displayEnd: displayEnd } = this.props.virtualBoundaries;
            this.scheduleBuffering(displayStart, displayEnd);
        }
    }
    componentWillUnmount() {
        this.cancelBuffering();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        this.batchUpdateTimeoutId && window.clearTimeout(this.batchUpdateTimeoutId);
    }
    afterAnimationFrame() {
        return new Promise((resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            this.cancelNextAnimationFrameHandlers = ()=>{
                this.cancelNextAnimationFrameHandlers = null;
                reject(new Error('Cancelled'));
            };
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.requestAnimationFrame(()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.setTimeout(()=>{
                    this.cancelNextAnimationFrameHandlers = null;
                    // @ts-expect-error - TS2794 - Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?
                    resolve();
                });
            });
        });
    }
    cancelBuffering() {
        this.cancelNextAnimationFrameHandlers && this.cancelNextAnimationFrameHandlers();
    }
    scheduleBuffering(displayStart, displayEnd) {
        this.cancelBuffering();
        this.afterAnimationFrame().then(()=>{
            this.shouldUpdate = true;
            const rowsRendered = this.state.displayEnd - this.state.displayStart;
            const rowsDeferred = this.state.displayStart - displayStart + (displayEnd - this.state.displayEnd);
            this.props.onDeferredBuffering(rowsRendered, rowsDeferred);
            this.setState({
                displayStart: displayStart,
                displayEnd: displayEnd
            });
        }).catch(()=>{
        // presumably due to being cancelled
        });
    }
    getBoundaries() {
        if (false) return this.props.virtualBoundaries;
        return this.state;
    }
    render() {
        const { rowIds: rowIds, contentHeight: contentHeight, onLoadingRowUnmount: onLoadingRowUnmount, List: List } = this.props;
        const { displayStart: displayStart, displayEnd: displayEnd } = this.getBoundaries();
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'string[]' and 'number' have no overlap.
        if (contentHeight === 0 || rowIds === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(List, {
            rowIds: rowIds,
            displayStart: displayStart,
            displayEnd: displayEnd,
            onRowContentUpdate: this.updateStateRowHeight,
            onLoadingRowUnmount: onLoadingRowUnmount
        });
    }
}
function $2fb49323f74295c3$var$VirtualList({ batchUpdateRowHeightMapping: batchUpdateRowHeightMapping, contentHeight: contentHeight, isAutoRowHeight: isAutoRowHeight, isTableFacade: isTableFacade, List: List, onDeferredBuffering: onDeferredBuffering, onLoadingRowUnmount: onLoadingRowUnmount, rowIds: rowIds, virtualBoundaries: maybeUnstableVirtualBoundaries }) {
    const { current: rowHeightUpdateMap } = (0, $eJOHy.useRef)(new Map());
    // FIXME: the virtualBoundaries prop should be stabilised instead; which seems like it will require changes to the visibleRowIds selector
    const virtualBoundaries = (0, $hrKgE.useShallowStableReference)(maybeUnstableVirtualBoundaries, (0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const previousVirtualBoundaries = (0, $6d9QY.usePrevious)(virtualBoundaries);
    const [debouncedRowHeightUpdate] = (0, $fwzaq.default)((0, $eJOHy.useCallback)(()=>{
        batchUpdateRowHeightMapping(rowIds, Object.fromEntries(rowHeightUpdateMap));
        rowHeightUpdateMap.clear();
    }, [
        batchUpdateRowHeightMapping,
        rowHeightUpdateMap,
        rowIds
    ]), $2fb49323f74295c3$var$ANALYTICS_DEBOUNCE_TIME);
    const handleRowContentUpdate = (0, $eJOHy.useCallback)((rowId, rowHeight)=>{
        rowHeightUpdateMap.set(rowId, rowHeight);
        debouncedRowHeightUpdate();
    }, [
        debouncedRowHeightUpdate,
        rowHeightUpdateMap
    ]);
    (0, $eJOHy.useEffect)(()=>{
        let timeoutId;
        if (!previousVirtualBoundaries) return;
        if (isTableFacade && (virtualBoundaries.visibleStart < previousVirtualBoundaries.visibleStart || virtualBoundaries.visibleEnd > previousVirtualBoundaries.visibleEnd) || virtualBoundaries.visibleStart <= previousVirtualBoundaries.displayStart || virtualBoundaries.visibleEnd >= previousVirtualBoundaries.displayEnd) {
            const deferBuffering = (0, $8pnqM.shouldDeferBuffering)({
                rowIds: rowIds,
                virtualBoundaries: previousVirtualBoundaries
            }, {
                rowIds: rowIds,
                virtualBoundaries: virtualBoundaries
            });
            if (deferBuffering) requestAnimationFrame(()=>{
                timeoutId = setTimeout(()=>{
                    const rowsRendered = virtualBoundaries.visibleEnd - virtualBoundaries.visibleStart;
                    const rowsDeferred = virtualBoundaries.visibleStart - virtualBoundaries.displayStart + virtualBoundaries.displayEnd - virtualBoundaries.visibleEnd;
                    onDeferredBuffering(rowsRendered, rowsDeferred);
                }, 0);
            });
        }
        return ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        isTableFacade,
        onDeferredBuffering,
        previousVirtualBoundaries,
        rowIds,
        virtualBoundaries
    ]);
    (0, $eJOHy.useEffect)(()=>{
        let timeoutId;
        if (isAutoRowHeight && rowHeightUpdateMap.size > 0) timeoutId = setTimeout(()=>{
            batchUpdateRowHeightMapping(rowIds, Object.fromEntries(rowHeightUpdateMap));
            rowHeightUpdateMap.clear();
        }, 0);
        return ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        batchUpdateRowHeightMapping,
        isAutoRowHeight,
        rowHeightUpdateMap,
        rowIds
    ]);
    const shouldShowList = contentHeight > 0 && rowIds.length > 0;
    return (0, $eJOHy.useMemo)(()=>shouldShowList ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(List, {
            rowIds: rowIds,
            displayStart: virtualBoundaries.displayStart,
            displayEnd: virtualBoundaries.displayEnd,
            onRowContentUpdate: handleRowContentUpdate,
            onLoadingRowUnmount: onLoadingRowUnmount
        }) : null, [
        List,
        handleRowContentUpdate,
        onLoadingRowUnmount,
        rowIds,
        shouldShowList,
        virtualBoundaries.displayEnd,
        virtualBoundaries.displayStart
    ]);
}
var $2fb49323f74295c3$export$2e2bcd8739ae039 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-perf-jsm-queues-virtual-table-refactor'), $2fb49323f74295c3$var$VirtualList, $2fb49323f74295c3$var$VirtualListOld);

});
parcelRegister("8pnqM", function(module, exports) {

$parcel$export(module.exports, "shouldDeferBuffering", () => $7157c02fbcd7c7f1$export$ae5c6ac06aadc69);
/**
 * Threshold for rows in the "buffered" region (i.e., difference of <display region> and <visible region>).
 *
 * Only the visible region will be rendered initially if more than `DEFERRED_BUFFERING_NEW_MOUNT_THRESHOLD`
 * of the "buffered" rows need to be mounted (because they were not previously rendered); rendering of the
 * buffer will be deferred.
 */ const $7157c02fbcd7c7f1$var$DEFERRED_BUFFERING_NEW_MOUNT_THRESHOLD = 0.3;
const $7157c02fbcd7c7f1$var$getRowsForBuffering = ({ virtualBoundaries: { displayStart: displayStart, visibleStart: visibleStart, visibleEnd: visibleEnd, displayEnd: displayEnd }, rowIds: rowIds })=>[
        ...rowIds.slice(displayStart, visibleStart),
        ...rowIds.slice(visibleEnd + 1, displayEnd + 1)
    ];
const $7157c02fbcd7c7f1$var$getPreviouslyRenderedRows = (prevRenderState)=>{
    const { rowIds: rowIds, virtualBoundaries: { displayStart: displayStart, displayEnd: displayEnd } } = prevRenderState;
    return rowIds.slice(displayStart, displayEnd + 1);
};
const $7157c02fbcd7c7f1$var$getBufferRowsNeedingMount = (nextRenderState, prevRenderState)=>{
    const previouslyRenderedRows = new Set($7157c02fbcd7c7f1$var$getPreviouslyRenderedRows(prevRenderState));
    return $7157c02fbcd7c7f1$var$getRowsForBuffering(nextRenderState).filter((row)=>!previouslyRenderedRows.has(row));
};
// Only allow deferred buffering when at the top of the row list for now.
const $7157c02fbcd7c7f1$var$canDeferBuffering = (nextRenderState)=>{
    const { virtualBoundaries: { visibleStart: visibleStart } } = nextRenderState;
    return visibleStart === 0;
};
const $7157c02fbcd7c7f1$export$ae5c6ac06aadc69 = (prevRenderState, nextRenderState)=>{
    if (!$7157c02fbcd7c7f1$var$canDeferBuffering(nextRenderState)) return false;
    const { visibleStart: visibleStart, displayStart: displayStart, visibleEnd: visibleEnd, displayEnd: displayEnd } = nextRenderState.virtualBoundaries;
    const requestedBufferSize = displayEnd - visibleEnd + (visibleStart - displayStart);
    if (requestedBufferSize === 0) return false;
    const rowsNeedingMount = $7157c02fbcd7c7f1$var$getBufferRowsNeedingMount(nextRenderState, prevRenderState).length;
    return rowsNeedingMount > requestedBufferSize * $7157c02fbcd7c7f1$var$DEFERRED_BUFFERING_NEW_MOUNT_THRESHOLD;
};

});




parcelRegister("169hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1b5f882bb24875$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $3z7Cz = parcelRequire("3z7Cz");

var $2Ctxl = parcelRequire("2Ctxl");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $3V1zr = parcelRequire("3V1zr");
var $ea1b5f882bb24875$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        left: (0, $2Ctxl.getVisibleCoreColumnsWidth)(state),
        viewportWidth: (0, $fRJOe.getHorizontalScrollWidth)(state),
        contentWidth: (0, $fRJOe.getVisibleAdditionalColumnsWidth)(state) + (0, $atQRE.getTableRowMargin)(state),
        scrollLeft: (0, $atQRE.getHorizontalScrollOffset)(state),
        shouldUseCssForRendering: (0, $atQRE.getShouldUseCssForRendering)(state)
    }), {
    setHorizontalScrollOffset: $3z7Cz.setHorizontal
})((0, $3V1zr.default));

});
parcelRegister("3V1zr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec700481342c07d5$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $7jTnu = parcelRequire("7jTnu");

var $i1eKe = parcelRequire("i1eKe");

var $gyOKd = parcelRequire("gyOKd");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec700481342c07d5$var$StyledScrollbar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $gyOKd.StyledScrollbars), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_t50dub": (0, $awdRS.default)(`${__cmplp.left}px`),
            "--_1iji1h5": (0, $awdRS.default)(__cmplp.theme.scrollbar.offset, "px"),
            "--_g4pqz5": (0, $awdRS.default)(__cmplp.width - __cmplp.theme.scrollbar.offset, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqsw7079 _1ltvdw55 _94n5idpf _4t3i2dgd _16mt19el",
            __cmplp.shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table') ? "_1bsbc11o" : "_1bsbby57",
            __cmplp.className
        ])
    });
});
const $ec700481342c07d5$var$FakeContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $awdRS.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1hdq _4t3it94y",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $ec700481342c07d5$var$HorizontalScrollbar extends (0, $eJOHy.PureComponent) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { scrollRef: scrollRef } = this;
        if (scrollRef) scrollRef.scrollLeft(nextProps.scrollLeft);
    }
    render() {
        const { viewportWidth: viewportWidth, contentWidth: contentWidth, left: left, theme: theme, shouldUseCssForRendering: shouldUseCssForRendering } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec700481342c07d5$var$StyledScrollbar, {
            ref: this.setScrollRef,
            width: viewportWidth,
            left: left,
            onScrollFrame: this.onHorizontalScroll,
            theme: theme,
            shouldUseCssForRendering: shouldUseCssForRendering
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ec700481342c07d5$var$FakeContent, {
            width: contentWidth
        }));
    }
    constructor(...args){
        super(...args), this.onHorizontalScroll = ({ scrollLeft: scrollLeft })=>{
            const { setHorizontalScrollOffset: setHorizontalScrollOffset } = this.props;
            setHorizontalScrollOffset(scrollLeft);
        }, this.setScrollRef = (ref)=>{
            this.scrollRef = ref;
        };
    }
}
var $ec700481342c07d5$export$2e2bcd8739ae039 = (0, $i1eKe.withTheme)($ec700481342c07d5$var$HorizontalScrollbar);

});
parcelRegister("gyOKd", function(module, exports) {

$parcel$export(module.exports, "StyledScrollbars", () => $ba583916eecda2ad$export$8c1e030d30c518f3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6iyDC = parcelRequire("6iyDC");
const $ba583916eecda2ad$export$8c1e030d30c518f3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, (/*@__PURE__*/$parcel$interopDefault($6iyDC))), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_nhmktnze _d39w1qh3 _ekl21fj3 _1o3o19el _iwvize3t _1dcdu2gc _1ijuu2gc _bh271c1a _145vtnze _2bk9gxqn _1t7ztlke _4bumh2mm _1a4htnze _1syn1m3d _1dni1fj3 _tqfr19el _e1uku2gc _bwqgze3t _i0vgu2gc _13411c1a _qb98tnze _1cldcdhy _8vvgtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6iyDC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Scrollbars = undefined;

var $e944t = parcelRequire("e944t");
var $495f4ae5fa5423c0$var$_Scrollbars2 = $495f4ae5fa5423c0$var$_interopRequireDefault($e944t);
function $495f4ae5fa5423c0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports["default"] = $495f4ae5fa5423c0$var$_Scrollbars2["default"];
module.exports.Scrollbars = $495f4ae5fa5423c0$var$_Scrollbars2["default"];

});
parcelRegister("e944t", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a4c5106450e12030$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a4c5106450e12030$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $ioJDR = parcelRequire("ioJDR");
var $a4c5106450e12030$var$_raf3 = $a4c5106450e12030$var$_interopRequireDefault($ioJDR);

var $j7l1V = parcelRequire("j7l1V");
var $a4c5106450e12030$var$_domCss2 = $a4c5106450e12030$var$_interopRequireDefault($j7l1V);

var $eJOHy = parcelRequire("eJOHy");

var $cT3Ey = parcelRequire("cT3Ey");
var $a4c5106450e12030$var$_propTypes2 = $a4c5106450e12030$var$_interopRequireDefault($cT3Ey);

var $iztan = parcelRequire("iztan");
var $a4c5106450e12030$var$_isString2 = $a4c5106450e12030$var$_interopRequireDefault($iztan);

var $g2aF6 = parcelRequire("g2aF6");
var $a4c5106450e12030$var$_getScrollbarWidth2 = $a4c5106450e12030$var$_interopRequireDefault($g2aF6);

var $65sdX = parcelRequire("65sdX");
var $a4c5106450e12030$var$_returnFalse2 = $a4c5106450e12030$var$_interopRequireDefault($65sdX);

var $ftfgV = parcelRequire("ftfgV");
var $a4c5106450e12030$var$_getInnerWidth2 = $a4c5106450e12030$var$_interopRequireDefault($ftfgV);

var $8BErF = parcelRequire("8BErF");
var $a4c5106450e12030$var$_getInnerHeight2 = $a4c5106450e12030$var$_interopRequireDefault($8BErF);

var $6R7OX = parcelRequire("6R7OX");

var $aAiFc = parcelRequire("aAiFc");
function $a4c5106450e12030$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a4c5106450e12030$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $a4c5106450e12030$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a4c5106450e12030$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a4c5106450e12030$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a4c5106450e12030$var$Scrollbars = function(_Component) {
    $a4c5106450e12030$var$_inherits(Scrollbars, _Component);
    function Scrollbars(props) {
        var _ref;
        $a4c5106450e12030$var$_classCallCheck(this, Scrollbars);
        for(var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        var _this = $a4c5106450e12030$var$_possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [
            this,
            props
        ].concat(rest)));
        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);
        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }
    $a4c5106450e12030$var$_createClass(Scrollbars, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.addListeners();
                this.update();
                this.componentDidMountUniversal();
            }
        },
        {
            key: 'componentDidMountUniversal',
            value: function componentDidMountUniversal() {
                // eslint-disable-line react/sort-comp
                var universal = this.props.universal;
                if (!universal) return;
                this.setState({
                    didMountUniversal: true
                });
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this.update();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.removeListeners();
                (0, $ioJDR.cancel)(this.requestFrame);
                clearTimeout(this.hideTracksTimeout);
                clearInterval(this.detectScrollingInterval);
            }
        },
        {
            key: 'getScrollLeft',
            value: function getScrollLeft() {
                if (!this.view) return 0;
                return this.view.scrollLeft;
            }
        },
        {
            key: 'getScrollTop',
            value: function getScrollTop() {
                if (!this.view) return 0;
                return this.view.scrollTop;
            }
        },
        {
            key: 'getScrollWidth',
            value: function getScrollWidth() {
                if (!this.view) return 0;
                return this.view.scrollWidth;
            }
        },
        {
            key: 'getScrollHeight',
            value: function getScrollHeight() {
                if (!this.view) return 0;
                return this.view.scrollHeight;
            }
        },
        {
            key: 'getClientWidth',
            value: function getClientWidth() {
                if (!this.view) return 0;
                return this.view.clientWidth;
            }
        },
        {
            key: 'getClientHeight',
            value: function getClientHeight() {
                if (!this.view) return 0;
                return this.view.clientHeight;
            }
        },
        {
            key: 'getValues',
            value: function getValues() {
                var _ref2 = this.view || {}, _ref2$scrollLeft = _ref2.scrollLeft, scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop, _ref2$scrollWidth = _ref2.scrollWidth, scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth, _ref2$scrollHeight = _ref2.scrollHeight, scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight, _ref2$clientWidth = _ref2.clientWidth, clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth, _ref2$clientHeight = _ref2.clientHeight, clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;
                return {
                    left: scrollLeft / (scrollWidth - clientWidth) || 0,
                    top: scrollTop / (scrollHeight - clientHeight) || 0,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollWidth: scrollWidth,
                    scrollHeight: scrollHeight,
                    clientWidth: clientWidth,
                    clientHeight: clientHeight
                };
            }
        },
        {
            key: 'getThumbHorizontalWidth',
            value: function getThumbHorizontalWidth() {
                var _props = this.props, thumbSize = _props.thumbSize, thumbMinSize = _props.thumbMinSize;
                var _view = this.view, scrollWidth = _view.scrollWidth, clientWidth = _view.clientWidth;
                var trackWidth = (0, $a4c5106450e12030$var$_getInnerWidth2["default"])(this.trackHorizontal);
                var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
                if (trackWidth === width) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(width, thumbMinSize);
            }
        },
        {
            key: 'getThumbVerticalHeight',
            value: function getThumbVerticalHeight() {
                var _props2 = this.props, thumbSize = _props2.thumbSize, thumbMinSize = _props2.thumbMinSize;
                var _view2 = this.view, scrollHeight = _view2.scrollHeight, clientHeight = _view2.clientHeight;
                var trackHeight = (0, $a4c5106450e12030$var$_getInnerHeight2["default"])(this.trackVertical);
                var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
                if (trackHeight === height) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(height, thumbMinSize);
            }
        },
        {
            key: 'getScrollLeftForOffset',
            value: function getScrollLeftForOffset(offset) {
                var _view3 = this.view, scrollWidth = _view3.scrollWidth, clientWidth = _view3.clientWidth;
                var trackWidth = (0, $a4c5106450e12030$var$_getInnerWidth2["default"])(this.trackHorizontal);
                var thumbWidth = this.getThumbHorizontalWidth();
                return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
            }
        },
        {
            key: 'getScrollTopForOffset',
            value: function getScrollTopForOffset(offset) {
                var _view4 = this.view, scrollHeight = _view4.scrollHeight, clientHeight = _view4.clientHeight;
                var trackHeight = (0, $a4c5106450e12030$var$_getInnerHeight2["default"])(this.trackVertical);
                var thumbHeight = this.getThumbVerticalHeight();
                return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
            }
        },
        {
            key: 'scrollLeft',
            value: function scrollLeft() {
                var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollLeft = left;
            }
        },
        {
            key: 'scrollTop',
            value: function scrollTop() {
                var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollTop = top;
            }
        },
        {
            key: 'scrollToLeft',
            value: function scrollToLeft() {
                if (!this.view) return;
                this.view.scrollLeft = 0;
            }
        },
        {
            key: 'scrollToTop',
            value: function scrollToTop() {
                if (!this.view) return;
                this.view.scrollTop = 0;
            }
        },
        {
            key: 'scrollToRight',
            value: function scrollToRight() {
                if (!this.view) return;
                this.view.scrollLeft = this.view.scrollWidth;
            }
        },
        {
            key: 'scrollToBottom',
            value: function scrollToBottom() {
                if (!this.view) return;
                this.view.scrollTop = this.view.scrollHeight;
            }
        },
        {
            key: 'addListeners',
            value: function addListeners() {
                /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.addEventListener('scroll', this.handleScroll);
                if (!(0, $a4c5106450e12030$var$_getScrollbarWidth2["default"])()) return;
                trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.addEventListener('resize', this.handleWindowResize);
            }
        },
        {
            key: 'removeListeners',
            value: function removeListeners() {
                /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.removeEventListener('scroll', this.handleScroll);
                if (!(0, $a4c5106450e12030$var$_getScrollbarWidth2["default"])()) return;
                trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.removeEventListener('resize', this.handleWindowResize);
                // Possibly setup by `handleDragStart`
                this.teardownDragging();
            }
        },
        {
            key: 'handleScroll',
            value: function handleScroll(event) {
                var _this2 = this;
                var _props3 = this.props, onScroll = _props3.onScroll, onScrollFrame = _props3.onScrollFrame;
                if (onScroll) onScroll(event);
                this.update(function(values) {
                    var scrollLeft = values.scrollLeft, scrollTop = values.scrollTop;
                    _this2.viewScrollLeft = scrollLeft;
                    _this2.viewScrollTop = scrollTop;
                    if (onScrollFrame) onScrollFrame(values);
                });
                this.detectScrolling();
            }
        },
        {
            key: 'handleScrollStart',
            value: function handleScrollStart() {
                var onScrollStart = this.props.onScrollStart;
                if (onScrollStart) onScrollStart();
                this.handleScrollStartAutoHide();
            }
        },
        {
            key: 'handleScrollStartAutoHide',
            value: function handleScrollStartAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: 'handleScrollStop',
            value: function handleScrollStop() {
                var onScrollStop = this.props.onScrollStop;
                if (onScrollStop) onScrollStop();
                this.handleScrollStopAutoHide();
            }
        },
        {
            key: 'handleScrollStopAutoHide',
            value: function handleScrollStopAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'handleWindowResize',
            value: function handleWindowResize() {
                this.update();
            }
        },
        {
            key: 'handleHorizontalTrackMouseDown',
            value: function handleHorizontalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientX = event.clientX;
                var _target$getBoundingCl = target.getBoundingClientRect(), targetLeft = _target$getBoundingCl.left;
                var thumbWidth = this.getThumbHorizontalWidth();
                var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
        },
        {
            key: 'handleVerticalTrackMouseDown',
            value: function handleVerticalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientY = event.clientY;
                var _target$getBoundingCl2 = target.getBoundingClientRect(), targetTop = _target$getBoundingCl2.top;
                var thumbHeight = this.getThumbVerticalHeight();
                var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
                this.view.scrollTop = this.getScrollTopForOffset(offset);
            }
        },
        {
            key: 'handleHorizontalThumbMouseDown',
            value: function handleHorizontalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientX = event.clientX;
                var offsetWidth = target.offsetWidth;
                var _target$getBoundingCl3 = target.getBoundingClientRect(), left = _target$getBoundingCl3.left;
                this.prevPageX = offsetWidth - (clientX - left);
            }
        },
        {
            key: 'handleVerticalThumbMouseDown',
            value: function handleVerticalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientY = event.clientY;
                var offsetHeight = target.offsetHeight;
                var _target$getBoundingCl4 = target.getBoundingClientRect(), top = _target$getBoundingCl4.top;
                this.prevPageY = offsetHeight - (clientY - top);
            }
        },
        {
            key: 'setupDragging',
            value: function setupDragging() {
                (0, $a4c5106450e12030$var$_domCss2["default"])(document.body, $6R7OX.disableSelectStyle);
                document.addEventListener('mousemove', this.handleDrag);
                document.addEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = $a4c5106450e12030$var$_returnFalse2["default"];
            }
        },
        {
            key: 'teardownDragging',
            value: function teardownDragging() {
                (0, $a4c5106450e12030$var$_domCss2["default"])(document.body, $6R7OX.disableSelectStyleReset);
                document.removeEventListener('mousemove', this.handleDrag);
                document.removeEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = undefined;
            }
        },
        {
            key: 'handleDragStart',
            value: function handleDragStart(event) {
                this.dragging = true;
                event.stopImmediatePropagation();
                this.setupDragging();
            }
        },
        {
            key: 'handleDrag',
            value: function handleDrag(event) {
                if (this.prevPageX) {
                    var clientX = event.clientX;
                    var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(), trackLeft = _trackHorizontal$getB.left;
                    var thumbWidth = this.getThumbHorizontalWidth();
                    var clickPosition = thumbWidth - this.prevPageX;
                    var offset = -trackLeft + clientX - clickPosition;
                    this.view.scrollLeft = this.getScrollLeftForOffset(offset);
                }
                if (this.prevPageY) {
                    var clientY = event.clientY;
                    var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(), trackTop = _trackVertical$getBou.top;
                    var thumbHeight = this.getThumbVerticalHeight();
                    var _clickPosition = thumbHeight - this.prevPageY;
                    var _offset = -trackTop + clientY - _clickPosition;
                    this.view.scrollTop = this.getScrollTopForOffset(_offset);
                }
                return false;
            }
        },
        {
            key: 'handleDragEnd',
            value: function handleDragEnd() {
                this.dragging = false;
                this.prevPageX = this.prevPageY = 0;
                this.teardownDragging();
                this.handleDragEndAutoHide();
            }
        },
        {
            key: 'handleDragEndAutoHide',
            value: function handleDragEndAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'handleTrackMouseEnter',
            value: function handleTrackMouseEnter() {
                this.trackMouseOver = true;
                this.handleTrackMouseEnterAutoHide();
            }
        },
        {
            key: 'handleTrackMouseEnterAutoHide',
            value: function handleTrackMouseEnterAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: 'handleTrackMouseLeave',
            value: function handleTrackMouseLeave() {
                this.trackMouseOver = false;
                this.handleTrackMouseLeaveAutoHide();
            }
        },
        {
            key: 'handleTrackMouseLeaveAutoHide',
            value: function handleTrackMouseLeaveAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'showTracks',
            value: function showTracks() {
                clearTimeout(this.hideTracksTimeout);
                (0, $a4c5106450e12030$var$_domCss2["default"])(this.trackHorizontal, {
                    opacity: 1
                });
                (0, $a4c5106450e12030$var$_domCss2["default"])(this.trackVertical, {
                    opacity: 1
                });
            }
        },
        {
            key: 'hideTracks',
            value: function hideTracks() {
                var _this3 = this;
                if (this.dragging) return;
                if (this.scrolling) return;
                if (this.trackMouseOver) return;
                var autoHideTimeout = this.props.autoHideTimeout;
                clearTimeout(this.hideTracksTimeout);
                this.hideTracksTimeout = setTimeout(function() {
                    (0, $a4c5106450e12030$var$_domCss2["default"])(_this3.trackHorizontal, {
                        opacity: 0
                    });
                    (0, $a4c5106450e12030$var$_domCss2["default"])(_this3.trackVertical, {
                        opacity: 0
                    });
                }, autoHideTimeout);
            }
        },
        {
            key: 'detectScrolling',
            value: function detectScrolling() {
                var _this4 = this;
                if (this.scrolling) return;
                this.scrolling = true;
                this.handleScrollStart();
                this.detectScrollingInterval = setInterval(function() {
                    if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                        clearInterval(_this4.detectScrollingInterval);
                        _this4.scrolling = false;
                        _this4.handleScrollStop();
                    }
                    _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                    _this4.lastViewScrollTop = _this4.viewScrollTop;
                }, 100);
            }
        },
        {
            key: 'raf',
            value: function raf(callback) {
                var _this5 = this;
                if (this.requestFrame) $a4c5106450e12030$var$_raf3["default"].cancel(this.requestFrame);
                this.requestFrame = (0, $a4c5106450e12030$var$_raf3["default"])(function() {
                    _this5.requestFrame = undefined;
                    callback();
                });
            }
        },
        {
            key: 'update',
            value: function update(callback) {
                var _this6 = this;
                this.raf(function() {
                    return _this6._update(callback);
                });
            }
        },
        {
            key: '_update',
            value: function _update(callback) {
                var _props4 = this.props, onUpdate = _props4.onUpdate, hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
                var values = this.getValues();
                if ((0, $a4c5106450e12030$var$_getScrollbarWidth2["default"])()) {
                    var scrollLeft = values.scrollLeft, clientWidth = values.clientWidth, scrollWidth = values.scrollWidth;
                    var trackHorizontalWidth = (0, $a4c5106450e12030$var$_getInnerWidth2["default"])(this.trackHorizontal);
                    var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                    var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                    var thumbHorizontalStyle = {
                        width: thumbHorizontalWidth,
                        transform: 'translateX(' + thumbHorizontalX + 'px)'
                    };
                    var scrollTop = values.scrollTop, clientHeight = values.clientHeight, scrollHeight = values.scrollHeight;
                    var trackVerticalHeight = (0, $a4c5106450e12030$var$_getInnerHeight2["default"])(this.trackVertical);
                    var thumbVerticalHeight = this.getThumbVerticalHeight();
                    var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                    var thumbVerticalStyle = {
                        height: thumbVerticalHeight,
                        transform: 'translateY(' + thumbVerticalY + 'px)'
                    };
                    if (hideTracksWhenNotNeeded) {
                        var trackHorizontalStyle = {
                            visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                        };
                        var trackVerticalStyle = {
                            visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                        };
                        (0, $a4c5106450e12030$var$_domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                        (0, $a4c5106450e12030$var$_domCss2["default"])(this.trackVertical, trackVerticalStyle);
                    }
                    (0, $a4c5106450e12030$var$_domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                    (0, $a4c5106450e12030$var$_domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
                }
                if (onUpdate) onUpdate(values);
                if (typeof callback !== 'function') return;
                callback(values);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this7 = this;
                var scrollbarWidth = (0, $a4c5106450e12030$var$_getScrollbarWidth2["default"])();
                /* eslint-disable no-unused-vars */ var _props5 = this.props, onScroll = _props5.onScroll, onScrollFrame = _props5.onScrollFrame, onScrollStart = _props5.onScrollStart, onScrollStop = _props5.onScrollStop, onUpdate = _props5.onUpdate, renderView = _props5.renderView, renderTrackHorizontal = _props5.renderTrackHorizontal, renderTrackVertical = _props5.renderTrackVertical, renderThumbHorizontal = _props5.renderThumbHorizontal, renderThumbVertical = _props5.renderThumbVertical, tagName = _props5.tagName, hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded, autoHide = _props5.autoHide, autoHideTimeout = _props5.autoHideTimeout, autoHideDuration = _props5.autoHideDuration, thumbSize = _props5.thumbSize, thumbMinSize = _props5.thumbMinSize, universal = _props5.universal, autoHeight = _props5.autoHeight, autoHeightMin = _props5.autoHeightMin, autoHeightMax = _props5.autoHeightMax, style = _props5.style, children = _props5.children, props = $a4c5106450e12030$var$_objectWithoutProperties(_props5, [
                    'onScroll',
                    'onScrollFrame',
                    'onScrollStart',
                    'onScrollStop',
                    'onUpdate',
                    'renderView',
                    'renderTrackHorizontal',
                    'renderTrackVertical',
                    'renderThumbHorizontal',
                    'renderThumbVertical',
                    'tagName',
                    'hideTracksWhenNotNeeded',
                    'autoHide',
                    'autoHideTimeout',
                    'autoHideDuration',
                    'thumbSize',
                    'thumbMinSize',
                    'universal',
                    'autoHeight',
                    'autoHeightMin',
                    'autoHeightMax',
                    'style',
                    'children'
                ]);
                /* eslint-enable no-unused-vars */ var didMountUniversal = this.state.didMountUniversal;
                var containerStyle = $a4c5106450e12030$var$_extends({}, $6R7OX.containerStyleDefault, autoHeight && $a4c5106450e12030$var$_extends({}, $6R7OX.containerStyleAutoHeight, {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }), style);
                var viewStyle = $a4c5106450e12030$var$_extends({}, $6R7OX.viewStyleDefault, {
                    // Hide scrollbars by setting a negative margin
                    marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                    marginBottom: scrollbarWidth ? -scrollbarWidth : 0
                }, autoHeight && $a4c5106450e12030$var$_extends({}, $6R7OX.viewStyleAutoHeight, {
                    // Add scrollbarWidth to autoHeight in order to compensate negative margins
                    minHeight: (0, $a4c5106450e12030$var$_isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                    maxHeight: (0, $a4c5106450e12030$var$_isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
                }), autoHeight && universal && !didMountUniversal && {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }, universal && !didMountUniversal && $6R7OX.viewStyleUniversalInitial);
                var trackAutoHeightStyle = {
                    transition: 'opacity ' + autoHideDuration + 'ms',
                    opacity: 0
                };
                var trackHorizontalStyle = $a4c5106450e12030$var$_extends({}, $6R7OX.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });
                var trackVerticalStyle = $a4c5106450e12030$var$_extends({}, $6R7OX.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });
                return (0, $eJOHy.createElement)(tagName, $a4c5106450e12030$var$_extends({}, props, {
                    style: containerStyle,
                    ref: function ref(_ref3) {
                        _this7.container = _ref3;
                    }
                }), [
                    (0, $eJOHy.cloneElement)(renderView({
                        style: viewStyle
                    }), {
                        key: 'view',
                        ref: function ref(_ref4) {
                            _this7.view = _ref4;
                        }
                    }, children),
                    (0, $eJOHy.cloneElement)(renderTrackHorizontal({
                        style: trackHorizontalStyle
                    }), {
                        key: 'trackHorizontal',
                        ref: function ref(_ref5) {
                            _this7.trackHorizontal = _ref5;
                        }
                    }, (0, $eJOHy.cloneElement)(renderThumbHorizontal({
                        style: $6R7OX.thumbHorizontalStyleDefault
                    }), {
                        ref: function ref(_ref6) {
                            _this7.thumbHorizontal = _ref6;
                        }
                    })),
                    (0, $eJOHy.cloneElement)(renderTrackVertical({
                        style: trackVerticalStyle
                    }), {
                        key: 'trackVertical',
                        ref: function ref(_ref7) {
                            _this7.trackVertical = _ref7;
                        }
                    }, (0, $eJOHy.cloneElement)(renderThumbVertical({
                        style: $6R7OX.thumbVerticalStyleDefault
                    }), {
                        ref: function ref(_ref8) {
                            _this7.thumbVertical = _ref8;
                        }
                    }))
                ]);
            }
        }
    ]);
    return Scrollbars;
}($eJOHy.Component);
module.exports["default"] = $a4c5106450e12030$var$Scrollbars;
$a4c5106450e12030$var$Scrollbars.propTypes = {
    onScroll: $a4c5106450e12030$var$_propTypes2["default"].func,
    onScrollFrame: $a4c5106450e12030$var$_propTypes2["default"].func,
    onScrollStart: $a4c5106450e12030$var$_propTypes2["default"].func,
    onScrollStop: $a4c5106450e12030$var$_propTypes2["default"].func,
    onUpdate: $a4c5106450e12030$var$_propTypes2["default"].func,
    renderView: $a4c5106450e12030$var$_propTypes2["default"].func,
    renderTrackHorizontal: $a4c5106450e12030$var$_propTypes2["default"].func,
    renderTrackVertical: $a4c5106450e12030$var$_propTypes2["default"].func,
    renderThumbHorizontal: $a4c5106450e12030$var$_propTypes2["default"].func,
    renderThumbVertical: $a4c5106450e12030$var$_propTypes2["default"].func,
    tagName: $a4c5106450e12030$var$_propTypes2["default"].string,
    thumbSize: $a4c5106450e12030$var$_propTypes2["default"].number,
    thumbMinSize: $a4c5106450e12030$var$_propTypes2["default"].number,
    hideTracksWhenNotNeeded: $a4c5106450e12030$var$_propTypes2["default"].bool,
    autoHide: $a4c5106450e12030$var$_propTypes2["default"].bool,
    autoHideTimeout: $a4c5106450e12030$var$_propTypes2["default"].number,
    autoHideDuration: $a4c5106450e12030$var$_propTypes2["default"].number,
    autoHeight: $a4c5106450e12030$var$_propTypes2["default"].bool,
    autoHeightMin: $a4c5106450e12030$var$_propTypes2["default"].oneOfType([
        $a4c5106450e12030$var$_propTypes2["default"].number,
        $a4c5106450e12030$var$_propTypes2["default"].string
    ]),
    autoHeightMax: $a4c5106450e12030$var$_propTypes2["default"].oneOfType([
        $a4c5106450e12030$var$_propTypes2["default"].number,
        $a4c5106450e12030$var$_propTypes2["default"].string
    ]),
    universal: $a4c5106450e12030$var$_propTypes2["default"].bool,
    style: $a4c5106450e12030$var$_propTypes2["default"].object,
    children: $a4c5106450e12030$var$_propTypes2["default"].node
};
$a4c5106450e12030$var$Scrollbars.defaultProps = {
    renderView: $aAiFc.renderViewDefault,
    renderTrackHorizontal: $aAiFc.renderTrackHorizontalDefault,
    renderTrackVertical: $aAiFc.renderTrackVerticalDefault,
    renderThumbHorizontal: $aAiFc.renderThumbHorizontalDefault,
    renderThumbVertical: $aAiFc.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};

});
parcelRegister("ioJDR", function(module, exports) {

var $86gNQ = parcelRequire("86gNQ");
var $d64ddf6f682b81d7$var$root = typeof window === 'undefined' ? $parcel$global : window, $d64ddf6f682b81d7$var$vendors = [
    'moz',
    'webkit'
], $d64ddf6f682b81d7$var$suffix = 'AnimationFrame', $d64ddf6f682b81d7$var$raf = $d64ddf6f682b81d7$var$root['request' + $d64ddf6f682b81d7$var$suffix], $d64ddf6f682b81d7$var$caf = $d64ddf6f682b81d7$var$root['cancel' + $d64ddf6f682b81d7$var$suffix] || $d64ddf6f682b81d7$var$root['cancelRequest' + $d64ddf6f682b81d7$var$suffix];
for(var $d64ddf6f682b81d7$var$i = 0; !$d64ddf6f682b81d7$var$raf && $d64ddf6f682b81d7$var$i < $d64ddf6f682b81d7$var$vendors.length; $d64ddf6f682b81d7$var$i++){
    $d64ddf6f682b81d7$var$raf = $d64ddf6f682b81d7$var$root[$d64ddf6f682b81d7$var$vendors[$d64ddf6f682b81d7$var$i] + 'Request' + $d64ddf6f682b81d7$var$suffix];
    $d64ddf6f682b81d7$var$caf = $d64ddf6f682b81d7$var$root[$d64ddf6f682b81d7$var$vendors[$d64ddf6f682b81d7$var$i] + 'Cancel' + $d64ddf6f682b81d7$var$suffix] || $d64ddf6f682b81d7$var$root[$d64ddf6f682b81d7$var$vendors[$d64ddf6f682b81d7$var$i] + 'CancelRequest' + $d64ddf6f682b81d7$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$d64ddf6f682b81d7$var$raf || !$d64ddf6f682b81d7$var$caf) {
    var $d64ddf6f682b81d7$var$last = 0, $d64ddf6f682b81d7$var$id = 0, $d64ddf6f682b81d7$var$queue = [], $d64ddf6f682b81d7$var$frameDuration = 1000 / 60;
    $d64ddf6f682b81d7$var$raf = function(callback) {
        if ($d64ddf6f682b81d7$var$queue.length === 0) {
            var _now = $86gNQ(), next = Math.max(0, $d64ddf6f682b81d7$var$frameDuration - (_now - $d64ddf6f682b81d7$var$last));
            $d64ddf6f682b81d7$var$last = next + _now;
            setTimeout(function() {
                var cp = $d64ddf6f682b81d7$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $d64ddf6f682b81d7$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($d64ddf6f682b81d7$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $d64ddf6f682b81d7$var$queue.push({
            handle: ++$d64ddf6f682b81d7$var$id,
            callback: callback,
            cancelled: false
        });
        return $d64ddf6f682b81d7$var$id;
    };
    $d64ddf6f682b81d7$var$caf = function(handle) {
        for(var i = 0; i < $d64ddf6f682b81d7$var$queue.length; i++)if ($d64ddf6f682b81d7$var$queue[i].handle === handle) $d64ddf6f682b81d7$var$queue[i].cancelled = true;
    };
}
module.exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $d64ddf6f682b81d7$var$raf.call($d64ddf6f682b81d7$var$root, fn);
};
module.exports.cancel = function() {
    $d64ddf6f682b81d7$var$caf.apply($d64ddf6f682b81d7$var$root, arguments);
};
module.exports.polyfill = function(object) {
    if (!object) object = $d64ddf6f682b81d7$var$root;
    object.requestAnimationFrame = $d64ddf6f682b81d7$var$raf;
    object.cancelAnimationFrame = $d64ddf6f682b81d7$var$caf;
};

});
parcelRegister("86gNQ", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof $igDjg !== "undefined" && $igDjg !== null && $igDjg.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = $igDjg.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = $igDjg.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(module.exports);

});


parcelRegister("j7l1V", function(module, exports) {

var $dRMHA = parcelRequire("dRMHA");

var $OiprC = parcelRequire("OiprC");
var $deaefbe06d5d7db4$var$cache = {
    'float': 'cssFloat'
};

var $ekCGn = parcelRequire("ekCGn");
function $deaefbe06d5d7db4$var$style(element, property, value) {
    var camel = $deaefbe06d5d7db4$var$cache[property];
    if (typeof camel === 'undefined') camel = $deaefbe06d5d7db4$var$detect(property);
    // may be false if CSS prop is unsupported
    if (camel) {
        if (value === undefined) return element.style[camel];
        element.style[camel] = $ekCGn(camel, value);
    }
}
function $deaefbe06d5d7db4$var$each(element, properties) {
    for(var k in properties)if (properties.hasOwnProperty(k)) $deaefbe06d5d7db4$var$style(element, k, properties[k]);
}
function $deaefbe06d5d7db4$var$detect(cssProp) {
    var camel = $OiprC(cssProp);
    var result = $dRMHA(camel);
    $deaefbe06d5d7db4$var$cache[camel] = $deaefbe06d5d7db4$var$cache[cssProp] = $deaefbe06d5d7db4$var$cache[result] = result;
    return result;
}
function $deaefbe06d5d7db4$var$set() {
    if (arguments.length === 2) {
        if (typeof arguments[1] === 'string') arguments[0].style.cssText = arguments[1];
        else $deaefbe06d5d7db4$var$each(arguments[0], arguments[1]);
    } else $deaefbe06d5d7db4$var$style(arguments[0], arguments[1], arguments[2]);
}
module.exports = $deaefbe06d5d7db4$var$set;
module.exports.set = $deaefbe06d5d7db4$var$set;
module.exports.get = function(element, properties) {
    if (Array.isArray(properties)) return properties.reduce(function(obj, prop) {
        obj[prop] = $deaefbe06d5d7db4$var$style(element, prop || '');
        return obj;
    }, {});
    else return $deaefbe06d5d7db4$var$style(element, properties || '');
};

});
parcelRegister("dRMHA", function(module, exports) {
var $a18600cf12a06aab$var$div = null;
var $a18600cf12a06aab$var$prefixes = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
module.exports = function prefixStyle(prop) {
    // re-use a dummy div
    if (!$a18600cf12a06aab$var$div) $a18600cf12a06aab$var$div = document.createElement('div');
    var style = $a18600cf12a06aab$var$div.style;
    // prop exists without prefix
    if (prop in style) return prop;
    // borderRadius -> BorderRadius
    var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1);
    // find the vendor-prefixed prop
    for(var i = $a18600cf12a06aab$var$prefixes.length; i >= 0; i--){
        var name = $a18600cf12a06aab$var$prefixes[i] + titleCase;
        // e.g. WebkitBorderRadius or webkitBorderRadius
        if (name in style) return name;
    }
    return false;
};

});

parcelRegister("OiprC", function(module, exports) {

var $eBaHw = parcelRequire("eBaHw");
/**
 * Export.
 */ module.exports = $0972f35955aaf2f9$var$toCamelCase;
/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */ function $0972f35955aaf2f9$var$toCamelCase(string) {
    return $eBaHw(string).replace(/\s(\w)/g, function(matches, letter) {
        return letter.toUpperCase();
    });
}

});
parcelRegister("eBaHw", function(module, exports) {

var $cD5GC = parcelRequire("cD5GC");
/**
 * Export.
 */ module.exports = $aa0cd26188da22bd$var$toSpaceCase;
/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */ function $aa0cd26188da22bd$var$toSpaceCase(string) {
    return $cD5GC(string).replace(/[\W_]+(.|$)/g, function(matches, match) {
        return match ? ' ' + match : '';
    }).trim();
}

});
parcelRegister("cD5GC", function(module, exports) {
/**
 * Export.
 */ module.exports = $931d89bed0ec1f43$var$toNoCase;
/**
 * Test whether a string is camel-case.
 */ var $931d89bed0ec1f43$var$hasSpace = /\s/;
var $931d89bed0ec1f43$var$hasSeparator = /(_|-|\.|:)/;
var $931d89bed0ec1f43$var$hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;
/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */ function $931d89bed0ec1f43$var$toNoCase(string) {
    if ($931d89bed0ec1f43$var$hasSpace.test(string)) return string.toLowerCase();
    if ($931d89bed0ec1f43$var$hasSeparator.test(string)) return ($931d89bed0ec1f43$var$unseparate(string) || string).toLowerCase();
    if ($931d89bed0ec1f43$var$hasCamel.test(string)) return $931d89bed0ec1f43$var$uncamelize(string).toLowerCase();
    return string.toLowerCase();
}
/**
 * Separator splitter.
 */ var $931d89bed0ec1f43$var$separatorSplitter = /[\W_]+(.|$)/g;
/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function $931d89bed0ec1f43$var$unseparate(string) {
    return string.replace($931d89bed0ec1f43$var$separatorSplitter, function(m, next) {
        return next ? ' ' + next : '';
    });
}
/**
 * Camelcase splitter.
 */ var $931d89bed0ec1f43$var$camelSplitter = /(.)([A-Z]+)/g;
/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function $931d89bed0ec1f43$var$uncamelize(string) {
    return string.replace($931d89bed0ec1f43$var$camelSplitter, function(m, previous, uppers) {
        return previous + ' ' + uppers.toLowerCase().split('').join(' ');
    });
}

});



parcelRegister("ekCGn", function(module, exports) {
/* The following list is defined in React's core */ var $a6f0f07f30d4e763$var$IS_UNITLESS = {
    animationIterationCount: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridColumn: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    stopOpacity: true,
    strokeDashoffset: true,
    strokeOpacity: true,
    strokeWidth: true
};
module.exports = function(name, value) {
    if (typeof value === 'number' && !$a6f0f07f30d4e763$var$IS_UNITLESS[name]) return value + 'px';
    else return value;
};

});


parcelRegister("iztan", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $d8521eb001289761$var$isString;
function $d8521eb001289761$var$isString(maybe) {
    return typeof maybe === 'string';
}

});

parcelRegister("g2aF6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $bac51a7a0154b475$var$getScrollbarWidth;

var $j7l1V = parcelRequire("j7l1V");
var $bac51a7a0154b475$var$_domCss2 = $bac51a7a0154b475$var$_interopRequireDefault($j7l1V);
function $bac51a7a0154b475$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $bac51a7a0154b475$var$scrollbarWidth = false;
function $bac51a7a0154b475$var$getScrollbarWidth() {
    if ($bac51a7a0154b475$var$scrollbarWidth !== false) return $bac51a7a0154b475$var$scrollbarWidth;
    /* istanbul ignore else */ if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, $bac51a7a0154b475$var$_domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        $bac51a7a0154b475$var$scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else $bac51a7a0154b475$var$scrollbarWidth = 0;
    return $bac51a7a0154b475$var$scrollbarWidth || 0;
}

});

parcelRegister("65sdX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $46e91a69f01ff86d$var$returnFalse;
function $46e91a69f01ff86d$var$returnFalse() {
    return false;
}

});

parcelRegister("ftfgV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $b435691f99572122$var$getInnerWidth;
function $b435691f99572122$var$getInnerWidth(el) {
    var clientWidth = el.clientWidth;
    var _getComputedStyle = getComputedStyle(el), paddingLeft = _getComputedStyle.paddingLeft, paddingRight = _getComputedStyle.paddingRight;
    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

});

parcelRegister("8BErF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $019df43e17950679$var$getInnerHeight;
function $019df43e17950679$var$getInnerHeight(el) {
    var clientHeight = el.clientHeight;
    var _getComputedStyle = getComputedStyle(el), paddingTop = _getComputedStyle.paddingTop, paddingBottom = _getComputedStyle.paddingBottom;
    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

});

parcelRegister("6R7OX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4fddc26602282e10$var$containerStyleDefault = module.exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};
// Overrides containerStyleDefault properties
var $4fddc26602282e10$var$containerStyleAutoHeight = module.exports.containerStyleAutoHeight = {
    height: 'auto'
};
var $4fddc26602282e10$var$viewStyleDefault = module.exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};
// Overrides viewStyleDefault properties
var $4fddc26602282e10$var$viewStyleAutoHeight = module.exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};
var $4fddc26602282e10$var$viewStyleUniversalInitial = module.exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};
var $4fddc26602282e10$var$trackHorizontalStyleDefault = module.exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};
var $4fddc26602282e10$var$trackVerticalStyleDefault = module.exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};
var $4fddc26602282e10$var$thumbHorizontalStyleDefault = module.exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};
var $4fddc26602282e10$var$thumbVerticalStyleDefault = module.exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};
var $4fddc26602282e10$var$disableSelectStyle = module.exports.disableSelectStyle = {
    userSelect: 'none'
};
var $4fddc26602282e10$var$disableSelectStyleReset = module.exports.disableSelectStyleReset = {
    userSelect: ''
};

});

parcelRegister("aAiFc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7b4bbe5e109bc6a3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports.renderViewDefault = $7b4bbe5e109bc6a3$var$renderViewDefault;
module.exports.renderTrackHorizontalDefault = $7b4bbe5e109bc6a3$var$renderTrackHorizontalDefault;
module.exports.renderTrackVerticalDefault = $7b4bbe5e109bc6a3$var$renderTrackVerticalDefault;
module.exports.renderThumbHorizontalDefault = $7b4bbe5e109bc6a3$var$renderThumbHorizontalDefault;
module.exports.renderThumbVerticalDefault = $7b4bbe5e109bc6a3$var$renderThumbVerticalDefault;

var $eJOHy = parcelRequire("eJOHy");
var $7b4bbe5e109bc6a3$var$_react2 = $7b4bbe5e109bc6a3$var$_interopRequireDefault($eJOHy);
function $7b4bbe5e109bc6a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7b4bbe5e109bc6a3$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/* eslint-disable react/prop-types */ function $7b4bbe5e109bc6a3$var$renderViewDefault(props) {
    return $7b4bbe5e109bc6a3$var$_react2["default"].createElement('div', props);
}
function $7b4bbe5e109bc6a3$var$renderTrackHorizontalDefault(_ref) {
    var style = _ref.style, props = $7b4bbe5e109bc6a3$var$_objectWithoutProperties(_ref, [
        'style'
    ]);
    var finalStyle = $7b4bbe5e109bc6a3$var$_extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return $7b4bbe5e109bc6a3$var$_react2["default"].createElement('div', $7b4bbe5e109bc6a3$var$_extends({
        style: finalStyle
    }, props));
}
function $7b4bbe5e109bc6a3$var$renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style, props = $7b4bbe5e109bc6a3$var$_objectWithoutProperties(_ref2, [
        'style'
    ]);
    var finalStyle = $7b4bbe5e109bc6a3$var$_extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return $7b4bbe5e109bc6a3$var$_react2["default"].createElement('div', $7b4bbe5e109bc6a3$var$_extends({
        style: finalStyle
    }, props));
}
function $7b4bbe5e109bc6a3$var$renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style, props = $7b4bbe5e109bc6a3$var$_objectWithoutProperties(_ref3, [
        'style'
    ]);
    var finalStyle = $7b4bbe5e109bc6a3$var$_extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return $7b4bbe5e109bc6a3$var$_react2["default"].createElement('div', $7b4bbe5e109bc6a3$var$_extends({
        style: finalStyle
    }, props));
}
function $7b4bbe5e109bc6a3$var$renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style, props = $7b4bbe5e109bc6a3$var$_objectWithoutProperties(_ref4, [
        'style'
    ]);
    var finalStyle = $7b4bbe5e109bc6a3$var$_extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return $7b4bbe5e109bc6a3$var$_react2["default"].createElement('div', $7b4bbe5e109bc6a3$var$_extends({
        style: finalStyle
    }, props));
}

});






parcelRegister("1VxmX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f10d2961180a16f$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $3z7Cz = parcelRequire("3z7Cz");

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $eiwTq = parcelRequire("eiwTq");
var $5f10d2961180a16f$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        visibleColumnCount: (0, $5wAOx.getVisibleColumnCount)(state),
        facade: (0, $5wAOx.getFacade)(state),
        isVirtualised: (0, $fRJOe.getShouldVirtualize)(state),
        virtualBoundaries: (0, $fRJOe.getVirtualBoundaries)(state),
        viewportHeight: (0, $fRJOe.getTableContentHeight)(state),
        scrollTop: (0, $atQRE.getVerticalScrollOffset)(state),
        defaultRowHeight: (0, $kcVGc.getDefaultRowHeight)(state),
        isHorizontalScrollVisible: (0, $fRJOe.hasHorizontalScrollbar)(state),
        shouldUseCssForRendering: (0, $atQRE.getShouldUseCssForRendering)(state)
    }), {
    setVerticalScrollOffset: $3z7Cz.setVertical
})((0, $eiwTq.default));

});
parcelRegister("eiwTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a00b9bc765348211$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $5zoTH = parcelRequire("5zoTH");

var $2y4Bk = parcelRequire("2y4Bk");

var $7jTnu = parcelRequire("7jTnu");

var $i1eKe = parcelRequire("i1eKe");

var $8nFYk = parcelRequire("8nFYk");

var $6qKp0 = parcelRequire("6qKp0");
// eslint-disable-next-line jira/react/no-class-components
class $a00b9bc765348211$var$VerticalScrollbar extends (0, $eJOHy.PureComponent) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { scrollRef: scrollRef } = this;
        // Changing scrollTop will prevent continuation of the scrolling
        // animation in some browsers, so make sure we're not already in a
        // scroll event before setting it.
        if (scrollRef && !this.isScrolling) scrollRef.scrollTop(nextProps.scrollTop);
    }
    render() {
        const { children: children, shouldUseCssForRendering: shouldUseCssForRendering } = this.props;
        const heightOffset = (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? "var(--ds-space-300, 24px)" : `${this.calculateSpaceTakenByHorizontalScrollbar()}px`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": "virtual-table.table.content.scrollbars.vertical.virtual-table-scrollbar-wrapper",
            ref: this.setTargetRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table') ? {
                height: `calc(100% - ${heightOffset})`
            } : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6qKp0.default), {
            onScrollbarsRef: this.setScrollRef,
            height: shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table') ? '100%' : this.calculateHeight(),
            onScrollStart: this.onScrollStart,
            onScrollStop: this.onScrollStop,
            onScrollFrame: this.onVerticalScroll,
            shouldUseCssForRendering: shouldUseCssForRendering
        }, children));
    }
    constructor(...args){
        super(...args), this.onVerticalScroll = ({ scrollTop: scrollTop })=>{
            const { setVerticalScrollOffset: setVerticalScrollOffset } = this.props;
            setVerticalScrollOffset(scrollTop);
        }, this.onScrollStart = ()=>{
            const { isVirtualised: isVirtualised, facade: facade, visibleColumnCount: visibleColumnCount, virtualBoundaries: { displayStart: displayStart, displayEnd: displayEnd } } = this.props;
            (0, $5zoTH.getLongTasksMetrics)('scroll').start('virtual-table', undefined, {
                isVirtualised: isVirtualised,
                visibleColumnCount: visibleColumnCount,
                facade: facade,
                displayedRows: displayEnd - displayStart
            });
            this.isScrolling = true;
        }, this.onScrollStop = ()=>{
            this.isScrolling = false;
            (0, $5zoTH.getLongTasksMetrics)('scroll').stop((0, $2y4Bk.virtualTableScrollReporter));
        }, this.setScrollRef = (ref)=>{
            this.scrollRef = ref;
        }, this.setTargetRef = (ref)=>{
            this.targetRef = ref;
        }, this.calculateSpaceTakenByHorizontalScrollbar = ()=>{
            const { isHorizontalScrollVisible: isHorizontalScrollVisible, theme: theme } = this.props;
            if (theme.scrollbar.computeHeight && isHorizontalScrollVisible) {
                const spaceTakenByHorizontalScrollbar = (0, $8nFYk.scrollbarWidth) + theme.scrollbar.marginTop + theme.scrollbar.marginBottom;
                return spaceTakenByHorizontalScrollbar;
            }
            return 0;
        }, this.calculateHeight = ()=>{
            const { viewportHeight: viewportHeight, isHorizontalScrollVisible: isHorizontalScrollVisible, theme: theme, shouldUseCssForRendering: shouldUseCssForRendering } = this.props;
            if (shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table')) return viewportHeight - this.calculateSpaceTakenByHorizontalScrollbar();
            if (theme.scrollbar.computeHeight && isHorizontalScrollVisible) {
                const spaceTakenByHorizontalScrollbar = (0, $8nFYk.scrollbarWidth) + theme.scrollbar.marginTop + theme.scrollbar.marginBottom;
                return viewportHeight - spaceTakenByHorizontalScrollbar;
            }
            return viewportHeight;
        };
    }
}
var $a00b9bc765348211$export$2e2bcd8739ae039 = (0, $i1eKe.withTheme)($a00b9bc765348211$var$VerticalScrollbar);

});
parcelRegister("5zoTH", function(module, exports) {

$parcel$export(module.exports, "getLongTasksMetrics", () => $7128094410e9d522$export$b092a8653a66aa5e);

var $5PQOA = parcelRequire("5PQOA");

var $6uWhG = parcelRequire("6uWhG");

var $gPCSe = parcelRequire("gPCSe");

var $6yvAl = parcelRequire("6yvAl");
let $7128094410e9d522$var$observer = null;
const $7128094410e9d522$var$stopObserver = ()=>{
    if ($7128094410e9d522$var$observer) {
        $7128094410e9d522$var$observer.disconnect();
        $7128094410e9d522$var$observer = null;
    }
};
const $7128094410e9d522$export$b092a8653a66aa5e = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((type)=>{
    const clearData = {
        type: type
    };
    let isStarted = false;
    let observationData = {
        ...clearData
    };
    const isDnd = /dnd$/.test(type.toLowerCase());
    return {
        start: (appName, startPerformanceMark, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.PerformanceObserver && !isStarted) try {
                const startTimestamp = (0, $gPCSe.default).now();
                observationData = {
                    type: observationData.type,
                    startTimestamp: startTimestamp,
                    dragStartEndTimestamp: startTimestamp,
                    eventStartPerformanceMark: startPerformanceMark,
                    events: [],
                    appName: appName,
                    extra: extra
                };
                isStarted = true;
                $7128094410e9d522$var$stopObserver();
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                $7128094410e9d522$var$observer = new window.PerformanceObserver((list)=>{
                    list.getEntries().forEach((entry)=>{
                        if (entry.entryType === 'longtask') {
                            if (!(0, $6yvAl.isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                            observationData.events.push({
                                timestamp: entry.startTime,
                                duration: entry.duration
                            });
                        } else if (entry.entryType === 'event' && entry.name === 'dragstart') /**
								 * Use the observed event to compute the "end" timestamp of the dragstart event,
								 * which will be used for splitting the long tasks for dragstart and dragmove.
								 */ observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                    });
                });
                $7128094410e9d522$var$observer.observe({
                    type: 'longtask'
                });
                if (isDnd) /**
						 * Observe events with >48ms duration.
						 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/observe
						 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                $7128094410e9d522$var$observer.observe({
                    type: 'event',
                    durationThreshold: 48
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
            } catch (e) {}
        },
        stop: (callback, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if ((0, $gPCSe.default).now && isStarted) {
                const stopTimestamp = (0, $gPCSe.default).now();
                setTimeout(()=>{
                    $7128094410e9d522$var$stopObserver();
                    callback({
                        ...observationData
                    }, extra, stopTimestamp);
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                });
            }
        },
        stopIfNoMark: (performanceMark)=>{
            if ($7128094410e9d522$var$observer && performanceMark) {
                const perfMark = (0, $6uWhG.getMark)(performanceMark);
                if (!perfMark) {
                    $7128094410e9d522$var$stopObserver();
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                }
            }
        }
    };
});

});
parcelRegister("6yvAl", function(module, exports) {

$parcel$export(module.exports, "isExpandedObservationData", () => $2af17b175656e7f2$export$3d38a87309e205a4);
const $2af17b175656e7f2$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;

});


parcelRegister("2y4Bk", function(module, exports) {

$parcel$export(module.exports, "virtualTableScrollReporter", () => $e6e71e240f59a1a1$export$4378f1933287fdc8);

var $bxh4x = parcelRequire("bxh4x");

var $6yvAl = parcelRequire("6yvAl");

var $hIGKw = parcelRequire("hIGKw");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e6e71e240f59a1a1$var$aggregatedDataTimeout = {};
const $e6e71e240f59a1a1$export$4378f1933287fdc8 = (observationData)=>{
    if (!(0, $6yvAl.isExpandedObservationData)(observationData)) return;
    const startTime = observationData.events.map((event)=>event.timestamp);
    const analyticsData = {
        ...(0, $hIGKw.generateLongTaskAnalyticsContinuousActionSummary)('virtualTableScroll', observationData.events),
        measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
    };
    const { appName: appName } = observationData;
    if ($e6e71e240f59a1a1$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`]) $e6e71e240f59a1a1$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`].data.push(analyticsData);
    else $e6e71e240f59a1a1$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`] = {
        data: [
            analyticsData
        ],
        extra: observationData.extra,
        timeout: setTimeout(()=>{
            const { data: data, extra: extraData } = $e6e71e240f59a1a1$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`];
            const triggerAppAnalytics = (0, $hIGKw.triggerAnalytics)(`common.${appName}`);
            triggerAppAnalytics('long-tasks-virtual-table-scroll', {
                ...(0, $hIGKw.getAverageResultsFromContinuousActions)('virtualTableScroll', data),
                ...extraData,
                avgScrollTimespan: (0, (/*@__PURE__*/$parcel$interopDefault($bxh4x)))(data, 'measureTimespan')
            });
            delete $e6e71e240f59a1a1$var$aggregatedDataTimeout[`common.${appName}.virtualTableScroll`];
        }, 7000)
    };
};

});
parcelRegister("bxh4x", function(module, exports) {

var $1lM9j = parcelRequire("1lM9j");

var $34ctL = parcelRequire("34ctL");
/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */ function $866004f815ccc1b3$var$meanBy(array, iteratee) {
    return $34ctL(array, $1lM9j(iteratee, 2));
}
module.exports = $866004f815ccc1b3$var$meanBy;

});
parcelRegister("34ctL", function(module, exports) {

var $2VN7o = parcelRequire("2VN7o");
/** Used as references for various `Number` constants. */ var $23bb6ce67be351ce$var$NAN = 0 / 0;
/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */ function $23bb6ce67be351ce$var$baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? $2VN7o(array, iteratee) / length : $23bb6ce67be351ce$var$NAN;
}
module.exports = $23bb6ce67be351ce$var$baseMean;

});
parcelRegister("2VN7o", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $2227017d5d5242a6$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $2227017d5d5242a6$var$baseSum;

});



parcelRegister("hIGKw", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $8fc307bd4b0bdcf5$export$2c57de8a70f64057);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummary", () => $8fc307bd4b0bdcf5$export$2be2635781d23aab);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", () => $8fc307bd4b0bdcf5$export$c674a20081e82c6a);
$parcel$export(module.exports, "getAverageResultsFromContinuousActions", () => $8fc307bd4b0bdcf5$export$c36fdc326d0c207c);
$parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", () => $8fc307bd4b0bdcf5$export$7e5f2df95eca342a);

var $bxh4x = parcelRequire("bxh4x");

var $a97Xf = parcelRequire("a97Xf");

var $3Igop = parcelRequire("3Igop");
const $8fc307bd4b0bdcf5$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $8fc307bd4b0bdcf5$export$2be2635781d23aab = (prefix, longTasks)=>{
    const durations = longTasks.map((task)=>task.duration);
    return {
        [`${prefix}LongTaskCount`]: longTasks.length,
        [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
        [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
    };
};
const $8fc307bd4b0bdcf5$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
    const summary = $8fc307bd4b0bdcf5$export$2be2635781d23aab(prefix, longTasks);
    if (!sloSettings) return summary;
    const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
    const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
    const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
    return {
        [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
        ...summary
    };
};
const $8fc307bd4b0bdcf5$export$c36fdc326d0c207c = (prefix, data)=>{
    // Do NOT inline this variable into its usage site below - it is here to mitigate an Atlaspack bug: https://product-fabric.atlassian.net/browse/AFB-1057 & https://atlassian.slack.com/archives/C0288U06PGC/p1736811949973719
    const avgLongTaskCountSum = (0, (/*@__PURE__*/$parcel$interopDefault($3Igop)))(data, `${prefix}ClusterAvgLongTaskCount`);
    return {
        [`${prefix}ClusterCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($3Igop)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterCountAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($bxh4x)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($bxh4x)))(data, `${prefix}ClusterAvg`) || 0,
        [`${prefix}ClusterDistanceAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($bxh4x)))(data, `${prefix}ClusterDistanceAvg`) || 0,
        [`${prefix}ClusterAvgLongTaskCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($bxh4x)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($a97Xf)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / avgLongTaskCountSum : 0,
        [`${prefix}Count`]: data.length
    };
};
const $8fc307bd4b0bdcf5$export$7e5f2df95eca342a = (prefix, longTasks)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clusters = longTasks.reduce((foundClusters, task)=>{
        if (foundClusters.length === 0) foundClusters.push({
            tasks: [],
            start: 0,
            stop: 0
        });
        const prevCluster = foundClusters[foundClusters.length - 1];
        const taskEnd = task.timestamp + task.duration;
        if (prevCluster.tasks.length === 0) {
            prevCluster.tasks.push(task);
            prevCluster.start = task.timestamp;
            prevCluster.stop = taskEnd;
        } else if (task.timestamp - prevCluster.stop < 100) {
            prevCluster.tasks.push(task);
            prevCluster.stop = taskEnd;
        } else foundClusters.push({
            tasks: [
                task
            ],
            start: task.timestamp,
            stop: taskEnd
        });
        return foundClusters;
    }, []);
    const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
    const tasksDurations = longTasks.map((task)=>task.duration);
    const gapsBetweenClusters = clusters.length > 1 ? clusters // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((gaps, cluster, i)=>{
        if (gaps.length === 0) {
            gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }
        // eslint-disable-next-line no-param-reassign
        gaps[gaps.length - 1].stop = cluster.start;
        if (i !== clusters.length - 1) gaps.push({
            start: cluster.stop,
            stop: null
        });
        return gaps;
    }, []).map((gap)=>gap.stop - gap.start) : [];
    return {
        [`${prefix}ClusterCount`]: clusters.length,
        [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
        [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
        [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
    };
};

});
parcelRegister("a97Xf", function(module, exports) {

var $2VN7o = parcelRequire("2VN7o");

var $d7YnM = parcelRequire("d7YnM");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $7630ea44eac67729$var$sum(array) {
    return array && array.length ? $2VN7o(array, $d7YnM) : 0;
}
module.exports = $7630ea44eac67729$var$sum;

});

parcelRegister("3Igop", function(module, exports) {

var $1lM9j = parcelRequire("1lM9j");

var $2VN7o = parcelRequire("2VN7o");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $2b42326a5df6a9df$var$sumBy(array, iteratee) {
    return array && array.length ? $2VN7o(array, $1lM9j(iteratee, 2)) : 0;
}
module.exports = $2b42326a5df6a9df$var$sumBy;

});



parcelRegister("6qKp0", function(module, exports) {

$parcel$export(module.exports, "default", () => $69ed70eba1d7a250$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $7jTnu = parcelRequire("7jTnu");

var $gyOKd = parcelRequire("gyOKd");
class $69ed70eba1d7a250$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            className: '',
            onScrollbarsRef: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onScrollFrame: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onScrollStart: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onScrollStop: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    render() {
        const { className: className, onScrollbarsRef: onScrollbarsRef, onScrollFrame: onScrollFrame, onScrollStart: onScrollStart, onScrollStop: onScrollStop, children: children, height: height, shouldUseCssForRendering: shouldUseCssForRendering } = this.props;
        const extraProps = false && shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table') ? {
            renderView: this.renderView
        } : {};
        /* className is passed down to enable styled component composition */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gyOKd.StyledScrollbars), {
            style: {
                height: // eslint-disable-next-line jira/ff/no-preconditioning
                shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table') && typeof height === 'string' ? height : `${height}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: onScrollbarsRef,
            onScrollFrame: onScrollFrame,
            onScrollStart: onScrollStart,
            onScrollStop: onScrollStop,
            renderTrackVertical: this.renderVerticalTrack,
            renderThumbVertical: this.renderVerticalThumb,
            renderTrackHorizontal: this.renderHorizontalTrack,
            renderThumbHorizontal: this.renderHorizontalThumb,
            hideTracksWhenNotNeeded: true,
            ...extraProps
        }, children);
    }
    constructor(...args){
        super(...args), this.renderVerticalTrack = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                ref: props.ref,
                style: props.style,
                className: "track-vertical"
            }), this.renderVerticalThumb = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                ref: props.ref,
                style: props.style,
                className: "thumb-vertical"
            }), this.renderHorizontalTrack = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                ref: props.ref,
                style: props.style,
                className: "track-horizontal"
            }), this.renderHorizontalThumb = (props)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                ref: props.ref,
                style: props.style,
                className: "thumb-horizontal"
            }), this.renderView = (props)=>{
            const finalProps = {
                ...props,
                style: {
                    ...props.style,
                    // this override is to only be used in false mode
                    // `react-custom-scrollbars` cannot calculate the width of scrollbars properly
                    // it's because typeof document !== 'undefined' there is false
                    // see https://github.com/malte-wessel/react-custom-scrollbars/blob/v4.2.1/src/utils/getScrollbarWidth.js#L7
                    marginRight: '-14px',
                    marginBottom: '-14px'
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", finalProps);
        };
    }
}

});



parcelRegister("aDJPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd24b2de2a2c21c7$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $2Ctxl = parcelRequire("2Ctxl");

var $39ive = parcelRequire("39ive");

var $3Boir = parcelRequire("3Boir");

var $etsh1 = parcelRequire("etsh1");
var $fd24b2de2a2c21c7$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        coreColumnsWidth: (0, $2Ctxl.getVisibleCoreColumnsWidth)(state),
        AddLink: $39ive.default,
        ScrollArea: $etsh1.default
    }), {})((0, $3Boir.default));

});
parcelRegister("39ive", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23b8fb8b8c8bc4f$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");


var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $289bg = parcelRequire("289bg");
var $c23b8fb8b8c8bc4f$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>{
    const sortedRowIds = (0, $atQRE.getSortedRowIdsHash)(state)[0, $ff4c22136947deab$export$59c500c4e33fdb0];
    return {
        addLinkCaption: (0, $kcVGc.getAddLinkCaption)(state),
        lastRowId: sortedRowIds && sortedRowIds[sortedRowIds.length - 1],
        isVisible: (0, $fRJOe.isAddLinkShown)(state),
        onRowAddRequested: (0, $5wAOx.getRowAddCallback)(state),
        addBarOverflow: (0, $kcVGc.getAddBarOverflow)(state)
    };
}, {})((0, $289bg.default));

});
parcelRegister("289bg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b409727744cf89ae$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $i1eKe = parcelRequire("i1eKe");

var $8nFYk = parcelRequire("8nFYk");
const $b409727744cf89ae$var$wrapperBaseStyle = null;
const $b409727744cf89ae$var$Wrapper = ({ addBarOverflow: addBarOverflow, theme: theme, padding: padding, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        style: {
            paddingRight: `${padding}px`,
            paddingTop: `${padding}px`,
            paddingBottom: `${padding}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingLeft: `${(0, $8nFYk.levelIndentBaseline)}px`,
            marginTop: `-${addBarOverflow + theme.row.borderWidth}px`
        },
        className: (0, $hcewu.default)([
            "_otyru2gc"
        ])
    }, children);
// eslint-disable-next-line jira/react/no-class-components
class $b409727744cf89ae$var$AddLink extends (0, $eJOHy.PureComponent) {
    renderAddLink() {
        const { addLinkCaption: addLinkCaption, addBarOverflow: addBarOverflow, theme: theme } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b409727744cf89ae$var$Wrapper, {
            addBarOverflow: addBarOverflow,
            theme: theme,
            padding: (theme.row.defaultHeight - (0, $8nFYk.akButtonHeight)) / 2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            onClick: this.onRowAddRequested,
            appearance: "subtle-link",
            testId: "virtual-table.table.content.utility-row.add-link.button"
        }, addLinkCaption));
    }
    render() {
        const { isVisible: isVisible } = this.props;
        return isVisible ? this.renderAddLink() : null;
    }
    constructor(...args){
        super(...args), this.onRowAddRequested = ()=>{
            const { lastRowId: lastRowId, onRowAddRequested: onRowAddRequested } = this.props;
            onRowAddRequested && onRowAddRequested({
                anchorId: lastRowId,
                position: lastRowId ? 'AFTER' : 'LAST'
            });
        };
    }
}
var $b409727744cf89ae$export$2e2bcd8739ae039 = (0, $i1eKe.withTheme)($b409727744cf89ae$var$AddLink);

});


parcelRegister("3Boir", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d98bc3cd94e85ad$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
function $0d98bc3cd94e85ad$export$2e2bcd8739ae039(props) {
    const { coreColumnsWidth: coreColumnsWidth, AddLink: AddLink, ScrollArea: ScrollArea } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0d98bc3cd94e85ad$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0d98bc3cd94e85ad$var$CoreWidthPlaceholder, {
        width: coreColumnsWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AddLink, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ScrollArea, null));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0d98bc3cd94e85ad$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $0d98bc3cd94e85ad$var$CoreWidthPlaceholder = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $awdRS.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsb1hdq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("etsh1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d38ebd63c424b082$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $kcVGc = parcelRequire("kcVGc");

var $fRJOe = parcelRequire("fRJOe");

var $gsVjm = parcelRequire("gsVjm");

var $gtbwu = parcelRequire("gtbwu");
var $d38ebd63c424b082$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        rowsHeight: (0, $fRJOe.getTableRowsHeight)(state),
        contentHeight: (0, $fRJOe.getTableContentHeight)(state),
        contentWidth: (0, $fRJOe.getVisibleAdditionalColumnsWidth)(state),
        isAddLinkShown: (0, $fRJOe.isAddLinkShown)(state),
        addBarOverflow: (0, $kcVGc.getAddBarOverflow)(state),
        AdditionalColumnsContainer: $gsVjm.default
    }), {})((0, $gtbwu.default));

});
parcelRegister("gtbwu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9de1f28a4cbde8$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $7jTnu = parcelRequire("7jTnu");

var $i1eKe = parcelRequire("i1eKe");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba9de1f28a4cbde8$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addBarOverflow: addBarOverflow, theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`),
            "--_j34cc7": (0, $awdRS.default)(`-${__cmplp.addBarOverflow + __cmplp.theme.row.borderWidth}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _4t3i2nrh _19pk1w53 _otyru2gc",
            __cmplp.className
        ])
    });
});
const $ba9de1f28a4cbde8$var$FakeContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $awdRS.default)(`${__cmplp.width}px`),
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsb1hdq _4t3i2nrh",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $ba9de1f28a4cbde8$var$ScrollArea extends (0, $eJOHy.PureComponent) {
    getAreaHeight() {
        const { rowsHeight: rowsHeight, contentHeight: contentHeight, isAddLinkShown: isAddLinkShown, theme: theme } = this.props;
        // we are reducing Scrollbar height in src/common/components/virtual-table/view/table/content/scrollbars/vertical
        // /index-dumb.js to accommodate stuff below table within the viewport.
        // Utility Row takes whatever height is left below rowList on the viewport hence need to reduce it here as well
        // else it is introducing vertical scroll even if we do not have enough rows to scroll.
        const spareContentSpace = contentHeight - rowsHeight - (theme.scrollbar.offset - theme.scrollbar.paddingTop);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { defaultHeight: defaultHeight } = theme.row;
        const addLinkSpace = isAddLinkShown ? defaultHeight : 0;
        return spareContentSpace > 0 ? spareContentSpace : addLinkSpace;
    }
    render() {
        const { contentWidth: contentWidth, AdditionalColumnsContainer: AdditionalColumnsContainer, addBarOverflow: addBarOverflow, theme: theme } = this.props;
        const areaHeight = this.getAreaHeight();
        // there is either
        // 1) no space required to be filled, or the add link is not visible
        // 2) no visible additional rows/details panel is open (as derived by no content width)
        if (areaHeight === 0 || contentWidth === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ba9de1f28a4cbde8$var$Wrapper, {
            height: areaHeight,
            addBarOverflow: addBarOverflow,
            theme: theme
        }, (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdditionalColumnsContainer, {
            placeholderKey: "utility-row.scroll-area"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ba9de1f28a4cbde8$var$FakeContent, {
            width: contentWidth,
            height: areaHeight
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdditionalColumnsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ba9de1f28a4cbde8$var$FakeContent, {
            width: contentWidth,
            height: areaHeight
        })));
    }
}
var $ba9de1f28a4cbde8$export$2e2bcd8739ae039 = (0, $i1eKe.withTheme)($ba9de1f28a4cbde8$var$ScrollArea);

});





parcelRegister("ZcZOG", function(module, exports) {

$parcel$export(module.exports, "default", () => $e75a813548a32727$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");

var $aIrSA = parcelRequire("aIrSA");

var $aRLtR = parcelRequire("aRLtR");

var $2Ctxl = parcelRequire("2Ctxl");

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $gsVjm = parcelRequire("gsVjm");

var $fmOxV = parcelRequire("fmOxV");

var $lRaYj = parcelRequire("lRaYj");

var $ajVRQ = parcelRequire("ajVRQ");
var $e75a813548a32727$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        coreColumnIds: (0, $2Ctxl.getVisibleCoreColumnIds)(state),
        additionalColumnIds: (0, $5wAOx.getVisibleAdditionalColumnIds)(state),
        isColumnConfigurationVisible: (0, $5wAOx.isColumnConfigurationVisible)(state),
        hasVerticallyScrolled: (0, $atQRE.hasVerticallyScrolled)(state),
        tableHasLeftShadow: (0, $fRJOe.isHorizontalScrollLeftShadowVisible)(state),
        tableHasRightShadow: (0, $fRJOe.isHorizontalScrollRightShadowVisible)(state),
        bottomShadowWidth: (0, $atQRE.getTableWidthWithoutScrollbarOffset)(state),
        isAutoRowHeight: (0, $kcVGc.isAutoRowHeight)(state),
        AdditionalColumnsContainer: $gsVjm.default,
        Column: $lRaYj.default,
        ColumnConfiguration: $fmOxV.default,
        ...(0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') ? {
            persistedStoreColumns: state.consumer.persistedStoreColumns
        } : {}
    }), {
    setHeaderHeight: $aRLtR.set
})((0, $ajVRQ.default));

});
parcelRegister("aRLtR", function(module, exports) {

$parcel$export(module.exports, "SET_HEADER_HEIGHT", () => $274d9842077dd8bb$export$e52e6a4be99a8322);
$parcel$export(module.exports, "set", () => $274d9842077dd8bb$export$adaa4cf7ef1b65be);
const $274d9842077dd8bb$export$e52e6a4be99a8322 = 'ops.header.size.SET_HEADER_HEIGHT';
const $274d9842077dd8bb$export$adaa4cf7ef1b65be = (height)=>({
        type: $274d9842077dd8bb$export$e52e6a4be99a8322,
        payload: height
    });

});

parcelRegister("fmOxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $263217bd5cf9bffa$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $2Ctxl = parcelRequire("2Ctxl");

var $5wAOx = parcelRequire("5wAOx");

var $atQRE = parcelRequire("atQRE");

var $a72Ic = parcelRequire("a72Ic");
var $263217bd5cf9bffa$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        columnConfiguration: (0, $2Ctxl.getColumnConfiguration)(state),
        headerHeight: (0, $atQRE.getHeaderHeight)(state),
        onChangeHiddenColumnsRequested: (0, $5wAOx.getChangeHiddenColumnsCallback)(state)
    }), {})((0, $a72Ic.default));

});
parcelRegister("a72Ic", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee3f4e510e3f42b6$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");

var $kkiGo = parcelRequire("kkiGo");

var $7qGN1 = parcelRequire("7qGN1");
var $6YFG2 = parcelRequire("6YFG2");

var $fGqmx = parcelRequire("fGqmx");
const $ee3f4e510e3f42b6$var$messages = (0, $7qGN1.defineMessages)({
    configureIcon: {
        "id": "virtual-table.table.header.column-configuration.configure-icon",
        "defaultMessage": "Click to expand column configuration"
    }
});
function $ee3f4e510e3f42b6$export$7b06a271790152c(props) {
    const { intl: { formatMessage: formatMessage }, columnConfiguration: columnConfiguration, headerHeight: headerHeight, onChangeHiddenColumnsRequested: onChangeHiddenColumnsRequested } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ee3f4e510e3f42b6$var$ConfigWrapper, {
        headerHeight: headerHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        trigger: ({ triggerRef: triggerRef, ...propsTrigger })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...propsTrigger,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkiGo))), {
                    spacing: "spacious",
                    label: formatMessage($ee3f4e510e3f42b6$var$messages.configureIcon)
                }),
                appearance: "subtle",
                ref: triggerRef
            }),
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fGqmx.default), {
        columnConfiguration: columnConfiguration,
        onChangeHiddenColumnsRequested: onChangeHiddenColumnsRequested
    })));
}
var $ee3f4e510e3f42b6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $6YFG2.default)($ee3f4e510e3f42b6$export$7b06a271790152c);
const $ee3f4e510e3f42b6$var$ConfigWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { headerHeight: headerHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_3ioxf9": (0, $awdRS.default)(`${__cmplp.headerHeight}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _1xi2idpf _4t3i5h89 _bfhku67f",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fGqmx", function(module, exports) {

$parcel$export(module.exports, "default", () => $84c93f078d59ee08$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $3zv7S = parcelRequire("3zv7S");

var $1GmOk = parcelRequire("1GmOk");

var $3l9kN = parcelRequire("3l9kN");

var $6pBGf = parcelRequire("6pBGf");

var $ghERV = parcelRequire("ghERV");

var $hZ2PG = parcelRequire("hZ2PG");
class $84c93f078d59ee08$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    onSelect() {
        const { columnConfiguration: columnConfiguration, onChangeHiddenColumnsRequested: onChangeHiddenColumnsRequested } = this.props;
        if (onChangeHiddenColumnsRequested === undefined) return 0, (/*@__PURE__*/$parcel$interopDefault($12DRg));
        const allHiddenColumns = (0, $hZ2PG.getAllHiddenColumns)(columnConfiguration);
        const columnsMap = (0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(columnConfiguration, (hash, item)=>({
                ...hash,
                [item.id]: {
                    isHidden: item.isHidden,
                    hiddenParentColumns: (0, $hZ2PG.getHiddenParentColumns)(item, columnConfiguration)
                }
            }), {});
        return (item)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
            const column = columnsMap[item.id];
            if (column.isHidden) {
                // show
                const columnsToShow = (0, (/*@__PURE__*/$parcel$interopDefault($1GmOk)))([
                    item.id
                ], column.hiddenParentColumns);
                onChangeHiddenColumnsRequested((0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(allHiddenColumns, ...columnsToShow));
            } else // hide
            onChangeHiddenColumnsRequested((0, (/*@__PURE__*/$parcel$interopDefault($1GmOk)))(allHiddenColumns, [
                item.id
            ]));
        };
    }
    transformColumnsToItems() {
        const { columnConfiguration: columnConfiguration } = this.props;
        const items = columnConfiguration.map((column)=>{
            const hiddenParentColumns = (0, $hZ2PG.getHiddenParentColumns)(column, columnConfiguration);
            return {
                id: column.id,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ghERV.default), {
                    key: column.id,
                    depth: column.depth,
                    title: column.title,
                    color: (0, $hZ2PG.determineItemColor)(column, hiddenParentColumns),
                    isDisabled: column.isDisabled,
                    isChecked: !column.isHidden
                }),
                isDisabled: column.isDisabled
            };
        });
        return [
            {
                items: items
            }
        ];
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6pBGf.default), {
            items: this.transformColumnsToItems(),
            onSelect: this.onSelect()
        });
    }
}

});
parcelRegister("1GmOk", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");

var $l76qh = parcelRequire("l76qh");

var $1txRh = parcelRequire("1txRh");

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $139b686d7d12ae9b$var$union = $l76qh(function(arrays) {
    return $1txRh($72Qfa(arrays, 1, $d1ShJ, true));
});
module.exports = $139b686d7d12ae9b$var$union;

});

parcelRegister("6pBGf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bcbdc2ad30a45fb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $iWqim = parcelRequire("iWqim");

var $3s8bj = parcelRequire("3s8bj");

var $dbfHE = parcelRequire("dbfHE");

var $gyBpf = parcelRequire("gyBpf");

var $l1N9H = parcelRequire("l1N9H");

var $12DRg = parcelRequire("12DRg");

var $6S4l2 = parcelRequire("6S4l2");

var $aXKmr = parcelRequire("aXKmr");

var $4VgGO = parcelRequire("4VgGO");

var $8Pd5g = parcelRequire("8Pd5g");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $6bcbdc2ad30a45fb$var$Explanation = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _syaznsd6 _ca0qu2gc _u5f3utpp _n3tdidpf _19bvutpp",
            __cmplp.className
        ])
    });
});
const $6bcbdc2ad30a45fb$var$ListWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxHeight: maxHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1upm8ip": (0, $awdRS.default)(__cmplp.maxHeight, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18m91wug",
            __cmplp.maxHeight && "_c71l1w9o",
            __cmplp.className
        ])
    });
});
const $6bcbdc2ad30a45fb$var$Menu = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1bsbko4j",
            __cmplp.className
        ])
    });
});
const $6bcbdc2ad30a45fb$var$canSelect = ({ type: type })=>type !== (0, $4VgGO.itemTypes).HEADING;
// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6bcbdc2ad30a45fb$var$getItemKey = (keyMap, item)=>{
    if (keyMap.has(item)) return keyMap.get(item);
    const newKey = (0, $aXKmr.v4)();
    keyMap.set(item, newKey);
    return newKey;
};
// eslint-disable-next-line jira/react/no-class-components
class $6bcbdc2ad30a45fb$var$MultiSelectList extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            items: [],
            type: (0, $4VgGO.itemTypes).DEFAULT,
            explanation: undefined,
            maxHeight: undefined,
            canSelectBySpaceKey: true,
            onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            autoFocus: true
        };
    }
    constructor(props){
        super(props), this.onKeydown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('down'):
                    this.navigateFocus({
                        isPrev: false
                    });
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('up'):
                    this.navigateFocus({
                        isPrev: true
                    });
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter'):
                    this.triggerOnSelect();
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('space'):
                    /* Searchable lists need the space key for typing in the input */ if (!this.props.canSelectBySpaceKey) return;
                    this.triggerOnSelect();
                    break;
                default:
                    return;
            }
            event.stopPropagation();
            event.preventDefault();
        }, this.navigateFocus = ({ isPrev: isPrev })=>{
            const { lastFocusedIndex: lastFocusedIndex, state: { items: items } } = this;
            let nextFocusIndex;
            if (lastFocusedIndex === undefined || lastFocusedIndex >= items.length) nextFocusIndex = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(items, $6bcbdc2ad30a45fb$var$canSelect);
            else if (isPrev) nextFocusIndex = (0, (/*@__PURE__*/$parcel$interopDefault($l1N9H)))(items, $6bcbdc2ad30a45fb$var$canSelect, Math.max(lastFocusedIndex - 1, 0));
            else nextFocusIndex = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(items, $6bcbdc2ad30a45fb$var$canSelect, lastFocusedIndex + 1);
            if (nextFocusIndex !== -1) {
                this.updateFocus(nextFocusIndex);
                // disable mouse move handler when use keyboard navigation
                this.shouldBypassMouseMove();
            }
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.navigateFocusTo = (nextFocusIndex, child)=>{
            if (!this.bypassMouseMove && $6bcbdc2ad30a45fb$var$canSelect(child)) this.updateFocus(nextFocusIndex);
        }, // should not enable mouse move focus if user keeping navigate by keyboard
        this.shouldNotByPassMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            this.bypassMouseMove = false;
        }, 300), /*
         when select changes potentially cause re-render,
         re-render will cause click event pass through the list and flyout close.
     */ this.triggerOnSelect = (0, (/*@__PURE__*/$parcel$interopDefault($dbfHE))).bind(this, ()=>{
            if (this.lastFocusedIndex !== undefined) this.props.onSelect(this.state.items[this.lastFocusedIndex].origin);
        });
        this.state = {
            items: []
        };
        this.keyMap = new WeakMap();
    }
    UNSAFE_componentWillMount() {
        this.transformItems(this.props);
    }
    componentDidMount() {
        const { autoFocus: autoFocus } = this.props;
        autoFocus && this.focus();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.items !== this.props.items || nextProps.type !== this.props.type) this.transformItems(nextProps);
    }
    focus() {
        this.menu && this.menu.focus();
    }
    transformItems(props) {
        const { items: items, type: type } = props;
        const { navigateFocusTo: navigateFocusTo, triggerOnSelect: triggerOnSelect } = this;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const transformedItems = items.reduce((retVal, item)=>{
            const heading = item.heading && {
                ...item.heading,
                type: (0, $4VgGO.itemTypes).HEADING,
                origin: item.heading
            };
            // @ts-expect-error - TS2365 - Operator '+' cannot be applied to types 'number' and 'boolean'.
            const index = retVal.length + !!heading;
            const children = item.items.map((child, i)=>({
                    ...child,
                    isFocused: false,
                    onHover: navigateFocusTo.bind(this, i + index, child),
                    onSelect: triggerOnSelect,
                    type: type,
                    origin: child
                }));
            if (heading) // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return [
                ...retVal,
                heading,
                ...children
            ];
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return [
                ...retVal,
                ...children
            ];
        }, []);
        this.setState({
            items: transformedItems
        }, ()=>{
            const { lastFocusedIndex: lastFocusedIndex } = this;
            if (lastFocusedIndex !== undefined && transformedItems[lastFocusedIndex] && $6bcbdc2ad30a45fb$var$canSelect(transformedItems[lastFocusedIndex])) // refocus
            this.updateFocus(lastFocusedIndex);
            else {
                // focus first selectable item
                this.lastFocusedIndex = undefined;
                this.navigateFocus({
                    isPrev: false
                });
            }
        });
    }
    shouldBypassMouseMove() {
        this.bypassMouseMove = true;
        this.shouldNotByPassMouseMove();
    }
    updateFocus(nextFocusIndex) {
        const { state: { items: items } } = this;
        if (!items[nextFocusIndex].isFocused) {
            this.lastFocusedIndex = nextFocusIndex;
            this.setState({
                items: items.map((item, index)=>(0, $iWqim.set)(item, 'isFocused', index === nextFocusIndex))
            }, ()=>{
                if (this.list) {
                    const focusedItem = this.list.children[nextFocusIndex];
                    const { offsetHeight: offsetHeight, scrollTop: scrollTop, offsetTop: offsetTop } = this.list;
                    const maxVisibleHeight = offsetHeight + scrollTop;
                    // @ts-expect-error - TS2339 - Property 'offsetTop' does not exist on type 'Element'.
                    const itemTop = focusedItem.offsetTop - offsetTop;
                    // @ts-expect-error - TS2339 - Property 'offsetHeight' does not exist on type 'Element'.
                    const itemBottom = focusedItem.offsetHeight + itemTop;
                    if (itemTop < scrollTop) // item is hide in the top
                    this.list.scrollTop = itemTop;
                    else if (maxVisibleHeight < itemBottom) // item is hide in the bottom
                    this.list.scrollTop = itemBottom - offsetHeight;
                }
            });
        }
    }
    renderContent() {
        const { explanation: explanation } = this.props;
        const { keyMap: keyMap, state: { items: items } } = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bcbdc2ad30a45fb$var$ListWrapper, {
            // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number'.
            maxHeight: this.props.maxHeight,
            ref: (el)=>{
                this.list = el;
            }
        }, items.map(({ origin: origin, ...itemProps })=>// @ts-expect-error HOC + injectIntl + defaultProps don't work well together. Please migrate to functional components
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Pd5g.default), {
                key: $6bcbdc2ad30a45fb$var$getItemKey(keyMap, origin),
                ...itemProps
            }))), explanation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bcbdc2ad30a45fb$var$Explanation, null, explanation));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6bcbdc2ad30a45fb$var$Menu, {
            ref: (el)=>{
                this.menu = el;
            },
            tabIndex: -1,
            onKeyDown: this.onKeydown,
            role: "menu",
            // eslint-disable-next-line jira/integration/enforce-data-testid-usage
            "data-test-id": "virtual-table.table.header.column-configuration.list.flyout.multi-select-list.list.menu"
        }, this.renderContent());
    }
}
var $6bcbdc2ad30a45fb$export$2e2bcd8739ae039 = $6bcbdc2ad30a45fb$var$MultiSelectList;

});
parcelRegister("dbfHE", function(module, exports) {

var $bc1aI = parcelRequire("bc1aI");

var $l76qh = parcelRequire("l76qh");
/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */ var $99887bc2e4446e4a$var$defer = $l76qh(function(func, args) {
    return $bc1aI(func, 1, args);
});
module.exports = $99887bc2e4446e4a$var$defer;

});
parcelRegister("bc1aI", function(module, exports) {
/** Error message constants. */ var $8261b96453dc89cb$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */ function $8261b96453dc89cb$var$baseDelay(func, wait, args) {
    if (typeof func != 'function') throw new TypeError($8261b96453dc89cb$var$FUNC_ERROR_TEXT);
    return setTimeout(function() {
        func.apply(undefined, args);
    }, wait);
}
module.exports = $8261b96453dc89cb$var$baseDelay;

});


parcelRegister("l1N9H", function(module, exports) {

var $9gUEB = parcelRequire("9gUEB");

var $1lM9j = parcelRequire("1lM9j");

var $c9FP3 = parcelRequire("c9FP3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f4efd23be3b4e43d$var$nativeMax = Math.max, $f4efd23be3b4e43d$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $f4efd23be3b4e43d$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $c9FP3(fromIndex);
        index = fromIndex < 0 ? $f4efd23be3b4e43d$var$nativeMax(length + index, 0) : $f4efd23be3b4e43d$var$nativeMin(index, length - 1);
    }
    return $9gUEB(array, $1lM9j(predicate, 3), index, true);
}
module.exports = $f4efd23be3b4e43d$var$findLastIndex;

});

parcelRegister("4VgGO", function(module, exports) {

$parcel$export(module.exports, "itemTypes", () => $c8b222e16aa1c496$export$d02ea220375e4aff);
const $c8b222e16aa1c496$export$d02ea220375e4aff = {
    HEADING: 'HEADING',
    RADIO: 'RADIO',
    CHECKBOX: 'CHECKBOX',
    DEFAULT: 'DEFAULT'
};

});

parcelRegister("8Pd5g", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6173d8802a3fb1d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $12DRg = parcelRequire("12DRg");

var $gQw6H = parcelRequire("gQw6H");

var $entZ3 = parcelRequire("entZ3");

var $dPMMf = parcelRequire("dPMMf");

var $7jTnu = parcelRequire("7jTnu");

var $7qGN1 = parcelRequire("7qGN1");
var $6YFG2 = parcelRequire("6YFG2");

var $4VgGO = parcelRequire("4VgGO");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a6173d8802a3fb1d$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldIndent: shouldIndent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _1bsb1osq _vchh131l",
            __cmplp.shouldIndent ? "_19bv1tcg" : "_19bvidpf",
            __cmplp.className
        ])
    });
});
const $a6173d8802a3fb1d$var$LozengeWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0u2gc _4t3i7vkz _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $a6173d8802a3fb1d$var$Title = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlkb7n _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $a6173d8802a3fb1d$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $a6173d8802a3fb1d$var$avatarSize = `${(0, $dPMMf.gridSize) * 2}px`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a6173d8802a3fb1d$var$Avatar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gqeyu4": (0, $awdRS.default)($a6173d8802a3fb1d$var$avatarSize)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _1o9zidpf _1bsbq5n1 _4t3iq5n1 _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $a6173d8802a3fb1d$var$CheckIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDefaultSelected: isDefaultSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1o9zidpf _4t3i7vkz _1bsb1tcg",
            __cmplp.isDefaultSelected ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a6173d8802a3fb1d$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasDivider: hasDivider, appearance: appearance, isDisabled: isDisabled, isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6w8y8c": (0, $awdRS.default)(__cmplp.appearance.color || // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (__cmplp.type === (0, $4VgGO.itemTypes).HEADING ? "var(--ds-text-subtle, #44546F)" : undefined))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_uiztglyw _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _syazvvkc",
            __cmplp.hasDivider && "_n7zlzgxb",
            __cmplp.type === (0, $4VgGO.itemTypes).HEADING && "_11c8dcr7",
            __cmplp.isDisabled ? "_80om13gf" : __cmplp.type === (0, $4VgGO.itemTypes).HEADING && "_80omtlke",
            __cmplp.isFocused && "_bfhk1hxd",
            __cmplp.className
        ])
    });
});
const $a6173d8802a3fb1d$var$shouldShowSelect = (type)=>[
        (0, $4VgGO.itemTypes).CHECKBOX,
        (0, $4VgGO.itemTypes).RADIO
    ].indexOf(type) !== -1;
const $a6173d8802a3fb1d$var$messages = (0, $7qGN1.defineMessages)({
    selected: {
        "id": "virtual-table.table.header.column-configuration.list.flyout.multi-select-list.list.item.selected",
        "defaultMessage": "Item selected"
    }
});
const $a6173d8802a3fb1d$var$getAriaRole = (type)=>{
    if (type === (0, $4VgGO.itemTypes).CHECKBOX) return 'menuitemcheckbox';
    if (type === (0, $4VgGO.itemTypes).RADIO) return 'menuitemradio';
    return 'menuitem';
};
const $a6173d8802a3fb1d$var$getAriaChecked = (isSelected, isDefaultSelected)=>isSelected || isDefaultSelected ? 'true' : 'false';
const $a6173d8802a3fb1d$var$getAriaProps = (type, isSelected, isDefaultSelected)=>({
        role: $a6173d8802a3fb1d$var$getAriaRole(type),
        tabIndex: 0,
        ...$a6173d8802a3fb1d$var$shouldShowSelect(type) && {
            'aria-checked': $a6173d8802a3fb1d$var$getAriaChecked(isSelected, isDefaultSelected)
        }
    });
class $a6173d8802a3fb1d$export$1c8ae823384d605f extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            type: (0, $4VgGO.itemTypes).DEFAULT,
            description: undefined,
            lozenge: undefined,
            avatarUrl: undefined,
            appearance: {},
            isFocused: false,
            isSelected: false,
            isDefaultSelected: false,
            isDisabled: false,
            hasDivider: false,
            onHover: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    renderContent() {
        const { avatarUrl: avatarUrl, content: content, lozenge: lozenge, type: type } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a6173d8802a3fb1d$var$Content, null, $a6173d8802a3fb1d$var$shouldShowSelect(type) && this.renderSelect(), avatarUrl && ((0, $7jTnu.fg)('jsm_queue_a11y_improvement') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a6173d8802a3fb1d$var$Avatar, {
            src: avatarUrl,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a6173d8802a3fb1d$var$Avatar, {
            src: avatarUrl
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a6173d8802a3fb1d$var$Title, null, content), lozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a6173d8802a3fb1d$var$LozengeWrapper, null, lozenge));
    }
    renderSelect() {
        const { type: type, isSelected: isSelected, isDefaultSelected: isDefaultSelected, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a6173d8802a3fb1d$var$CheckIconWrapper, {
            isDefaultSelected: isDefaultSelected
        }, (isSelected || isDefaultSelected) && (type === (0, $4VgGO.itemTypes).CHECKBOX ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($entZ3))), {
            LEGACY_size: "small",
            label: formatMessage($a6173d8802a3fb1d$var$messages.selected)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gQw6H))), {
            color: "currentColor",
            label: formatMessage($a6173d8802a3fb1d$var$messages.selected)
        })));
    }
    renderDescription() {
        const { avatarUrl: avatarUrl, description: description, type: type } = this.props;
        // @ts-expect-error - TS2365 - Operator '+' cannot be applied to types 'boolean' and 'boolean'.
        const shouldIndent = $a6173d8802a3fb1d$var$shouldShowSelect(type) + !!avatarUrl;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a6173d8802a3fb1d$var$Description, {
            shouldIndent: shouldIndent
        }, description);
    }
    render() {
        const { appearance: appearance, description: description, hasDivider: hasDivider, onHover: onHover, isFocused: isFocused, isDisabled: isDisabled, type: type, id: id, isSelected: isSelected, isDefaultSelected: isDefaultSelected } = this.props;
        const ariaProps = (0, $7jTnu.fg)('jsm_queue_a11y_improvement') ? $a6173d8802a3fb1d$var$getAriaProps(type, isSelected, isDefaultSelected) : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a6173d8802a3fb1d$var$Wrapper, {
            ...(0, $7jTnu.fg)('jsm_queue_a11y_improvement') && ariaProps,
            type: type,
            onClick: this.onClick,
            isFocused: isFocused,
            isDisabled: isDisabled,
            onMouseMove: onHover,
            hasDivider: hasDivider,
            appearance: appearance,
            "data-testid": `common.components.virtual-table.table.header.column-configuration.list.flyout.multi-select-list.list.item.wrapper-${id}`
        }, this.renderContent(), description && this.renderDescription());
    }
    constructor(...args){
        super(...args), this.onClick = ()=>{
            const { isDisabled: isDisabled, onSelect: onSelect } = this.props;
            if (!isDisabled) onSelect();
        };
    }
}
var $a6173d8802a3fb1d$export$2e2bcd8739ae039 = (0, $6YFG2.default)($a6173d8802a3fb1d$export$1c8ae823384d605f);

});
parcelRegister("gQw6H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4089746d7d5afa8185c4756217ca7179>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c43a68749f3c2f81$var$_react = $c43a68749f3c2f81$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c43a68749f3c2f81$var$_baseNew = $c43a68749f3c2f81$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c43a68749f3c2f81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Node".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a non-expandable item in a page tree.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c43a68749f3c2f81$var$NodeIcon = (props)=>/*#__PURE__*/ $c43a68749f3c2f81$var$_react.default.createElement($c43a68749f3c2f81$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0"/>`
    }, props));
$c43a68749f3c2f81$var$NodeIcon.displayName = 'NodeIcon';
var $c43a68749f3c2f81$var$_default = module.exports.default = $c43a68749f3c2f81$var$NodeIcon;

});

parcelRegister("entZ3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a77a78d359015cce$var$_react = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a77a78d359015cce$var$_checkMark = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("lwpci")));

var $a77a78d359015cce$var$_check = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("2kdvq")));
function $a77a78d359015cce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a77a78d359015cce$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a77a78d359015cce$var$_react.default.createElement($a77a78d359015cce$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $a77a78d359015cce$var$_check.default
    }, props));
$a77a78d359015cce$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $a77a78d359015cce$var$_default = module.exports.default = $a77a78d359015cce$var$CheckMarkIcon;

});
parcelRegister("lwpci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab021c59a8f6419$var$_react = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab021c59a8f6419$var$_baseNew = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab021c59a8f6419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab021c59a8f6419$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $fab021c59a8f6419$var$_react.default.createElement($fab021c59a8f6419$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$fab021c59a8f6419$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $fab021c59a8f6419$var$_default = module.exports.default = $fab021c59a8f6419$var$CheckMarkIcon;

});

parcelRegister("2kdvq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b17ecff78f4ff04$var$_react = $1b17ecff78f4ff04$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1b17ecff78f4ff04$var$_checkMark = $1b17ecff78f4ff04$var$_interopRequireDefault((parcelRequire("lwpci")));
function $1b17ecff78f4ff04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1b17ecff78f4ff04$var$CheckIcon = (props)=>/*#__PURE__*/ $1b17ecff78f4ff04$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $1b17ecff78f4ff04$var$_checkMark.default
    }));
$1b17ecff78f4ff04$var$CheckIcon.displayName = 'CheckIcon';
var $1b17ecff78f4ff04$var$_default = module.exports.default = $1b17ecff78f4ff04$var$CheckIcon;

});




parcelRegister("ghERV", function(module, exports) {

$parcel$export(module.exports, "default", () => $95c2e252e93f84fc$export$2e2bcd8739ae039);
/* item.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $dCU5j = parcelRequire("dCU5j");

var $entZ3 = parcelRequire("entZ3");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95c2e252e93f84fc$var$ItemWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { depth: depth, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $awdRS.default)(__cmplp.color),
            "--_13d8cnv": (0, $awdRS.default)(`${__cmplp.depth * 20}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _syaz1cj8 _18u01cdh _o5721q9c _1bto1l2s",
            __cmplp.isDisabled && "_80om13gf",
            __cmplp.className
        ])
    });
});
const $95c2e252e93f84fc$var$WidthPlaceholder = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbpxbi _2hwxu2gc",
            __cmplp.className
        ])
    });
});
class $95c2e252e93f84fc$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    renderCheckOrPlaceholder() {
        const { isChecked: isChecked } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($95c2e252e93f84fc$var$WidthPlaceholder, null, isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($entZ3))), {
            LEGACY_size: "small",
            label: ""
        }));
    }
    renderTitle() {
        const { title: title } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($dCU5j)))(title)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return title;
        const Title = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Title, null);
    }
    render() {
        const { depth: depth, color: color, isDisabled: isDisabled } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($95c2e252e93f84fc$var$ItemWrapper, {
            depth: depth,
            color: color,
            isDisabled: isDisabled
        }, this.renderCheckOrPlaceholder(), this.renderTitle());
    }
}

});

parcelRegister("hZ2PG", function(module, exports) {

$parcel$export(module.exports, "getHiddenParentColumns", () => $b458dbfca7b78572$export$1eb020b7a0c2885a);
$parcel$export(module.exports, "getAllHiddenColumns", () => $b458dbfca7b78572$export$be8e94436c3182a9);
$parcel$export(module.exports, "determineItemColor", () => $b458dbfca7b78572$export$d24b05f5766e3698);

var $6kS6u = parcelRequire("6kS6u");

var $8dH3d = parcelRequire("8dH3d");

var $3zv7S = parcelRequire("3zv7S");

var $1GmOk = parcelRequire("1GmOk");

const $b458dbfca7b78572$export$1eb020b7a0c2885a = (column, columnConfiguration)=>{
    if (!column.parentId) return [];
    // @ts-expect-error - TS2322 - Type 'ColumnConfiguration | undefined' is not assignable to type 'ColumnConfiguration'.
    const columnParent = (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(columnConfiguration, (configItem)=>configItem.id === column.parentId);
    const addToList = columnParent.isHidden ? [
        columnParent.id
    ] : [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($1GmOk)))(addToList, $b458dbfca7b78572$export$1eb020b7a0c2885a(columnParent, columnConfiguration));
};
const $b458dbfca7b78572$export$be8e94436c3182a9 = (columnConfigurations)=>(0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(columnConfigurations, // @ts-expect-error - TS2769 - No overload matches this call.
    (list, columnConfig)=>{
        if (columnConfig.isHidden) return [
            ...list,
            columnConfig.id
        ];
        return list;
    }, []);
const $b458dbfca7b78572$export$d24b05f5766e3698 = (column, hiddenParentColumns)=>{
    const { depth: depth, isHidden: isHidden, isDisabled: isDisabled } = column;
    const isActiveChild = depth > 0 && !isHidden;
    const hasInactiveParent = !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(hiddenParentColumns);
    return isActiveChild && hasInactiveParent || isDisabled ? (0, $7bb4c1736002a04a$exports).N80 : 'inherit';
};

});




parcelRegister("lRaYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8167299ca435e18$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $9Rbga = parcelRequire("9Rbga");

var $g0A8f = parcelRequire("g0A8f");
var $f8167299ca435e18$export$2e2bcd8739ae039 = (0, $aIrSA.connect)(()=>({
        DynamicColumnComponent: $9Rbga.default
    }), {})((0, $g0A8f.default));

});
parcelRegister("9Rbga", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a2e276db07ca820$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $bZlXS = parcelRequire("bZlXS");
function $4a2e276db07ca820$export$2e2bcd8739ae039(props) {
    const { id: id, sortOrder: sortOrder } = props;
    let sortOrderLable = 'none';
    if ((0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2')) switch(sortOrder){
        case 'ASC':
            sortOrderLable = 'ascending';
            break;
        case 'DESC':
            sortOrderLable = 'descending';
            break;
        default:
            sortOrderLable = 'none';
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bZlXS.default), {
        id: id,
        ...(0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') ? {
            sortOrder: sortOrderLable
        } : {}
    });
}

});
parcelRegister("bZlXS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c50280b64e4f3b9$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");

var $aIrSA = parcelRequire("aIrSA");

var $2Ctxl = parcelRequire("2Ctxl");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $5RSDC = parcelRequire("5RSDC");

var $8DoD0 = parcelRequire("8DoD0");
var $8c50280b64e4f3b9$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, { id: id })=>({
        width: (0, $fRJOe.getColumnWidth)(state, id),
        column: (0, $7jTnu.fg)('css_support_for_virtual_table') ? (0, $fRJOe.getColumn)(state, id) : undefined,
        isFirstColumn: (0, $2Ctxl.isFirstColumn)(state, id),
        DefaultColumn: $5RSDC.default,
        shouldUseCssForRendering: (0, $atQRE.getShouldUseCssForRendering)(state)
    }), {})((0, $8DoD0.default));

});
parcelRegister("5RSDC", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc92595d1ecfc5f2$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $2Ctxl = parcelRequire("2Ctxl");

var $89iji = parcelRequire("89iji");

var $isDVc = parcelRequire("isDVc");
var $bc92595d1ecfc5f2$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, { id: id })=>({
        title: (0, $2Ctxl.getColumnTitle)(state, id),
        HeaderComponent: (0, $2Ctxl.getColumnHeaderComponent)(state, id),
        tooltip: (0, $2Ctxl.getColumnTooltip)(state, id),
        isChild: (0, $2Ctxl.isChildColumn)(state, id),
        isParent: (0, $2Ctxl.isParentColumn)(state, id),
        parentId: (0, $2Ctxl.getParentId)(state, id),
        Column: $89iji.default
    }), {})((0, $isDVc.default));

});
parcelRegister("89iji", function(module, exports) {

$parcel$export(module.exports, "default", () => $5691a9ddbac88bc8$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $2Ctxl = parcelRequire("2Ctxl");

var $7LTWm = parcelRequire("7LTWm");

var $5xx3v = parcelRequire("5xx3v");

var $4H9tO = parcelRequire("4H9tO");

var $e9CMA = parcelRequire("e9CMA");
var $5691a9ddbac88bc8$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, props)=>({
        ChildBar: $7LTWm.default,
        ColumnChildOperationIndicator: $5xx3v.default,
        ColumnSortOperationIndicator: $4H9tO.default,
        isCoreColumn: (0, $2Ctxl.isVisibleCoreColumn)(state, props.id)
    }), {})((0, $e9CMA.default));

});
parcelRegister("7LTWm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7203a93976480fbc$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $2Ctxl = parcelRequire("2Ctxl");

var $869kr = parcelRequire("869kr");
var $7203a93976480fbc$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, { columnId: columnId })=>({
        backgroundColor: (0, $2Ctxl.getColumnColor)(state, columnId)
    }), {})((0, $869kr.default));

});
parcelRegister("869kr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc44600f9ef6aa8d$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
function $fc44600f9ef6aa8d$export$2e2bcd8739ae039(props) {
    const { backgroundColor: backgroundColor } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fc44600f9ef6aa8d$var$BarBackground, {
        backgroundColor: backgroundColor
    });
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fc44600f9ef6aa8d$var$BarBackground = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $awdRS.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1xi2idpf _1ltvidpf _4t3iyh40 _bfhk3qkl _tzy41v3n",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5xx3v", function(module, exports) {

$parcel$export(module.exports, "default", () => $9853c61448ff0b2b$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $2Ctxl = parcelRequire("2Ctxl");

var $5wAOx = parcelRequire("5wAOx");

var $chZwB = parcelRequire("chZwB");
var $9853c61448ff0b2b$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, { columnId: columnId })=>({
        isParentColumn: (0, $2Ctxl.isParentColumn)(state, columnId),
        isColumnExpanded: (0, $2Ctxl.isColumnExpanded)(state, columnId),
        columnHasChildren: (0, $2Ctxl.getColumnHasChildren)(state, columnId),
        color: (0, $2Ctxl.getColumnColor)(state, columnId),
        onColumnExpansionChangeRequested: (0, $5wAOx.getColumnExpandCallback)(state)
    }), {})((0, $chZwB.default));

});
parcelRegister("chZwB", function(module, exports) {

$parcel$export(module.exports, "default", () => $226364d6d3b7a473$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $friGH = parcelRequire("friGH");

var $dqYtf = parcelRequire("dqYtf");

var $4996r = parcelRequire("4996r");
const $226364d6d3b7a473$export$fd2a14967cd13576 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsbutpp _2hwx12x7 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $226364d6d3b7a473$export$ff0bdaf3b6126558 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { columnHasChildren: columnHasChildren, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbutpp _4t3iutpp _kqswh2mm _tzy41v3n _16l4kb7n",
            __cmplp.columnHasChildren ? "_80omtlke" : "_80om73ad",
            __cmplp.className
        ])
    });
});
const $226364d6d3b7a473$export$53c3957bbb0bab2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $awdRS.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf _bfhk1cj8",
            __cmplp.className
        ])
    });
});
const $226364d6d3b7a473$export$b6be64795e38ec8c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.className
        ])
    });
});
const $226364d6d3b7a473$export$bebc7a423c9a9514 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $226364d6d3b7a473$export$b6be64795e38ec8c, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_euc18": (0, $awdRS.default)((0, (/*@__PURE__*/$parcel$interopDefault($dqYtf))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1itknvb0",
            __cmplp.className
        ])
    });
});
const $226364d6d3b7a473$export$169f51fb2902d283 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $226364d6d3b7a473$export$b6be64795e38ec8c, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1oumqk1": (0, $awdRS.default)((0, (/*@__PURE__*/$parcel$interopDefault($4996r))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1itk1oyw",
            __cmplp.className
        ])
    });
});
const $226364d6d3b7a473$export$6cdf59eef5a3aef5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $226364d6d3b7a473$export$b6be64795e38ec8c, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1fpc7jq": (0, $awdRS.default)((0, (/*@__PURE__*/$parcel$interopDefault($friGH))), ")", "url(")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1itkplyw",
            __cmplp.className
        ])
    });
});
class $226364d6d3b7a473$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            columnHasChildren: undefined
        };
    }
    renderExpansionIndicator() {
        const { columnHasChildren: columnHasChildren, isColumnExpanded: isColumnExpanded } = this.props;
        if (columnHasChildren === true) {
            if (isColumnExpanded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($226364d6d3b7a473$export$6cdf59eef5a3aef5, null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($226364d6d3b7a473$export$169f51fb2902d283, null);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($226364d6d3b7a473$export$bebc7a423c9a9514, null);
    }
    renderExpansionIndicatorContainer() {
        const { color: color, columnHasChildren: columnHasChildren } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($226364d6d3b7a473$export$ff0bdaf3b6126558, {
            onClick: this.onColumnExpanded,
            columnHasChildren: columnHasChildren,
            role: "button",
            tabIndex: 0,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && this.onColumnExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($226364d6d3b7a473$export$53c3957bbb0bab2, {
            color: color
        }), this.renderExpansionIndicator());
    }
    render() {
        return this.props.isParentColumn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($226364d6d3b7a473$export$fd2a14967cd13576, null, this.renderExpansionIndicatorContainer());
    }
    constructor(...args){
        super(...args), this.onColumnExpanded = ()=>{
            const { columnId: columnId, isColumnExpanded: isColumnExpanded, columnHasChildren: columnHasChildren, onColumnExpansionChangeRequested: onColumnExpansionChangeRequested } = this.props;
            // neutral indicators should not be actionable
            if (columnHasChildren === true) onColumnExpansionChangeRequested({
                columnId: columnId,
                shouldExpand: !isColumnExpanded
            });
        };
    }
}

});
parcelRegister("friGH", function(module, exports) {
module.exports = new URL("minus-mask.a30c8bf5.svg", import.meta.url).toString();

});

parcelRegister("dqYtf", function(module, exports) {
module.exports = new URL("neutral-mask.7cced194.svg", import.meta.url).toString();

});

parcelRegister("4996r", function(module, exports) {
module.exports = new URL("plus-mask.26076cf9.svg", import.meta.url).toString();

});



parcelRegister("4H9tO", function(module, exports) {

$parcel$export(module.exports, "default", () => $163485e2ed74bf56$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $4YqNK = parcelRequire("4YqNK");

var $9StD7 = parcelRequire("9StD7");

var $2Ctxl = parcelRequire("2Ctxl");

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $fRJOe = parcelRequire("fRJOe");

var $9U5s2 = parcelRequire("9U5s2");
var $163485e2ed74bf56$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, { columnId: columnId })=>({
        sortOrder: (0, $fRJOe.getColumnSortOrder)(state, columnId),
        isColumnSortable: (0, $2Ctxl.isColumnSortable)(state, columnId),
        isSortEnabled: !(0, $kcVGc.isAnyRowBeingAdded)(state),
        isDefaultSortColumn: (0, $2Ctxl.getDefaultComparator)(state) === columnId,
        onClearAddedRowsRequested: (0, $5wAOx.getClearAddedRowsCallback)(state),
        onSortedColumnChanged: (0, $5wAOx.getSortedColumnChangedCallback)(state)
    }), {
    setColumnSortOrder: (0, $9StD7.set),
    clearColumnSortOrder: (0, $4YqNK.clear)
})((0, $9U5s2.default));

});
parcelRegister("4YqNK", function(module, exports) {

$parcel$export(module.exports, "CLEAR_COLUMN_SORT_ORDER", () => $70a579d1695176a4$export$875ad0918a4254f7);
$parcel$export(module.exports, "clear", () => $70a579d1695176a4$export$42ffd38884aecdac);
const $70a579d1695176a4$export$875ad0918a4254f7 = 'ops.columns.sorting.clear.CLEAR_COLUMN_SORT_ORDER';
const $70a579d1695176a4$export$42ffd38884aecdac = ()=>({
        type: $70a579d1695176a4$export$875ad0918a4254f7,
        payload: undefined
    });

});

parcelRegister("9StD7", function(module, exports) {

$parcel$export(module.exports, "SET_COLUMN_SORT_ORDER", () => $abf07fe997ba3916$export$d353d2412612deea);
$parcel$export(module.exports, "set", () => $abf07fe997ba3916$export$adaa4cf7ef1b65be);
const $abf07fe997ba3916$export$d353d2412612deea = 'ops.columns.sorting.set.SET_COLUMN_SORT_ORDER';
const $abf07fe997ba3916$export$adaa4cf7ef1b65be = (payload)=>({
        type: $abf07fe997ba3916$export$d353d2412612deea,
        payload: payload
    });

});

parcelRegister("9U5s2", function(module, exports) {

$parcel$export(module.exports, "default", () => $885daedd517c91a9$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $lmcio = parcelRequire("lmcio");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $885daedd517c91a9$var$SortIndicator = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { image: image, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_y0q4cp": (0, $awdRS.default)(__cmplp.image, ")", "url(")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _11q71izh _1bsbftgi _4t3i1osq _1itk1lpx _18u012x7 _80omtlke",
            __cmplp.className
        ])
    });
});
class $885daedd517c91a9$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            sortOrder: undefined
        };
    }
    setSortOrder(nextSortOrder) {
        return ()=>{
            const { columnId: columnId, setColumnSortOrder: setColumnSortOrder, onSortedColumnChanged: onSortedColumnChanged } = this.props;
            const payload = {
                columnId: columnId,
                sortOrder: nextSortOrder
            };
            setColumnSortOrder(payload);
            onSortedColumnChanged(payload);
        };
    }
    clearSortOrder() {
        return ()=>{
            const { clearColumnSortOrder: clearColumnSortOrder, onSortedColumnChanged: onSortedColumnChanged } = this.props;
            clearColumnSortOrder();
            onSortedColumnChanged(undefined);
        };
    }
    /* Along with sorting, any rows that were added since the last sort
   * and thus positioned "absolutely" should be discarded to allow for
   * explicit sorting once again.
   */ createClickAction(sortSpecificCallbacks) {
        return ()=>{
            const { onClearAddedRowsRequested: onClearAddedRowsRequested } = this.props;
            sortSpecificCallbacks();
            onClearAddedRowsRequested();
        };
    }
    renderSortOperationIndicator() {
        const { sortOrder: sortOrder, isDefaultSortColumn: isDefaultSortColumn } = this.props;
        const { nextSortOrder: nextSortOrder, image: image } = isDefaultSortColumn ? (0, $lmcio.DEFAULT_SORT_INDICATOR_METADATA)[sortOrder || 'DEFAULT'] : (0, $lmcio.INDICATOR_METADATA)[sortOrder || 'DEFAULT'];
        const clickAction = nextSortOrder === 'DEFAULT' ? this.createClickAction(this.clearSortOrder()) : this.createClickAction(this.setSortOrder(nextSortOrder));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($885daedd517c91a9$var$SortIndicator, {
            onClick: clickAction,
            image: image,
            role: "button",
            tabIndex: 0,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && clickAction
        });
    }
    render() {
        const { isColumnSortable: isColumnSortable, isSortEnabled: isSortEnabled } = this.props;
        return isColumnSortable && isSortEnabled ? this.renderSortOperationIndicator() : null;
    }
}

});
parcelRegister("lmcio", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SORT_INDICATOR_METADATA", () => $dd8e9b1f7fc43cd9$export$cc67c62619d38570);
$parcel$export(module.exports, "INDICATOR_METADATA", () => $dd8e9b1f7fc43cd9$export$319f25ddc8a4a7f2);


var $jkDiy = parcelRequire("jkDiy");

var $gNl4Q = parcelRequire("gNl4Q");

var $bMUBY = parcelRequire("bMUBY");
const $dd8e9b1f7fc43cd9$export$cc67c62619d38570 = {
    DESCENDING: {
        nextSortOrder: (0, $53724ea925cf4e57$export$6e386ac144cffab5),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($bMUBY)))
    },
    ASCENDING: {
        nextSortOrder: (0, $53724ea925cf4e57$export$f634ff5a7f1c8f3),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($gNl4Q)))
    },
    DEFAULT: {
        nextSortOrder: (0, $53724ea925cf4e57$export$6e386ac144cffab5),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($jkDiy)))
    }
};
const $dd8e9b1f7fc43cd9$export$319f25ddc8a4a7f2 = {
    DESCENDING: {
        nextSortOrder: 'DEFAULT',
        image: (0, (/*@__PURE__*/$parcel$interopDefault($bMUBY)))
    },
    ASCENDING: {
        nextSortOrder: (0, $53724ea925cf4e57$export$f634ff5a7f1c8f3),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($gNl4Q)))
    },
    DEFAULT: {
        nextSortOrder: (0, $53724ea925cf4e57$export$6e386ac144cffab5),
        image: (0, (/*@__PURE__*/$parcel$interopDefault($jkDiy)))
    }
};

});
parcelRegister("jkDiy", function(module, exports) {
module.exports = new URL("sortable-indicator.e7b63888.svg", import.meta.url).toString();

});

parcelRegister("gNl4Q", function(module, exports) {
module.exports = new URL("sorted-indicator-asc.99c81f7a.svg", import.meta.url).toString();

});

parcelRegister("bMUBY", function(module, exports) {
module.exports = new URL("sorted-indicator-desc.ee65fbfe.svg", import.meta.url).toString();

});




parcelRegister("e9CMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6db9d575c245cded$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $dCU5j = parcelRequire("dCU5j");

var $3Ogvp = parcelRequire("3Ogvp");
// we only show the coloured top border for child columns that themselves are no parents
// @ts-expect-error - TS7006 - Parameter 'isChild' implicitly has an 'any' type. | TS7006 - Parameter 'isParent' implicitly has an 'any' type.
const $6db9d575c245cded$var$hasChildColumnAppearance = (isChild, isParent)=>isChild && !isParent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6db9d575c245cded$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstColumn: isFirstColumn, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_14tplr7": (0, $awdRS.default)((0, $3Ogvp.getWidth)({
                width: __cmplp.width,
                isFirstColumn: __cmplp.isFirstColumn
            }))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsbssom _1e0c1txw _kqswh2mm _vchhusvi _ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc _irr34m1f",
            __cmplp.className
        ])
    });
});
const $6db9d575c245cded$var$Title = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isChild: isChild, isParent: isParent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _vwz41u1b _o5721q9c _1bto1l2s",
            $6db9d575c245cded$var$hasChildColumnAppearance(__cmplp.isChild, __cmplp.isParent) ? "_11c81vhk" : "_11c8140y",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $6db9d575c245cded$var$DumbColumn extends (0, $eJOHy.PureComponent) {
    renderChildOperationIndicator() {
        const { id: id, ColumnChildOperationIndicator: ColumnChildOperationIndicator } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ColumnChildOperationIndicator, {
            columnId: id
        });
    }
    renderSortingOperationIndicator() {
        const { id: id, ColumnSortOperationIndicator: ColumnSortOperationIndicator } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ColumnSortOperationIndicator, {
            columnId: id
        });
    }
    renderChildBar() {
        const { isChild: isChild, isParent: isParent, ChildBar: ChildBar, id: id } = this.props;
        if ($6db9d575c245cded$var$hasChildColumnAppearance(isChild, isParent)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ChildBar, {
            columnId: id
        });
        return null;
    }
    renderTitle() {
        const { title: title } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($dCU5j)))(title)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return title;
        const InnerTitle = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(InnerTitle, null);
    }
    render() {
        const { id: id, title: title, width: width, tooltip: tooltip, isChild: isChild, isParent: isParent, HeaderComponent: HeaderComponent, isFirstColumn: isFirstColumn } = this.props;
        return HeaderComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderComponent, {
            columnId: id,
            title: title,
            width: width
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6db9d575c245cded$var$Wrapper, {
            // @ts-expect-error - TS2322 - Type 'Optional<string | Element>' is not assignable to type 'string | undefined'.
            title: tooltip,
            width: width,
            isFirstColumn: isFirstColumn
        }, this.renderChildOperationIndicator(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6db9d575c245cded$var$Title, {
            isChild: isChild,
            isParent: isParent
        }, this.renderTitle()), this.renderSortingOperationIndicator(), this.renderChildBar());
    }
}
var $6db9d575c245cded$export$2e2bcd8739ae039 = $6db9d575c245cded$var$DumbColumn;

});


parcelRegister("isDVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9296a1aa1b167dd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $b9296a1aa1b167dd$export$2e2bcd8739ae039({ Column: Column, id: id, title: title, HeaderComponent: HeaderComponent, tooltip: tooltip, width: width, isChild: isChild, isParent: isParent, parentId: parentId, isFirstColumn: isFirstColumn }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Column, {
        id: id,
        title: title,
        HeaderComponent: HeaderComponent,
        tooltip: tooltip,
        width: width,
        isChild: isChild,
        isParent: isParent,
        parentId: parentId,
        isFirstColumn: isFirstColumn
    });
}

});


parcelRegister("8DoD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8904a2d17cd5362$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $3Ogvp = parcelRequire("3Ogvp");
class $c8904a2d17cd5362$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {};
    }
    render() {
        const { id: id, width: width, column: column, isFirstColumn: isFirstColumn, shouldUseCssForRendering: shouldUseCssForRendering, DefaultColumn: DefaultColumn, sortOrder: sortOrder } = this.props;
        if (shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8904a2d17cd5362$var$Wrapper, {
            column: column,
            width: width,
            isFirstColumn: isFirstColumn,
            shouldUseCssForRendering: shouldUseCssForRendering,
            ...(0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') ? {
                sortOrder: sortOrder
            } : {}
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DefaultColumn, {
            id: id,
            width: width,
            isFirstColumn: isFirstColumn
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8904a2d17cd5362$var$Wrapper, {
            width: width,
            isFirstColumn: isFirstColumn,
            ...(0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') ? {
                sortOrder: sortOrder
            } : {}
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DefaultColumn, {
            id: id,
            width: width,
            isFirstColumn: isFirstColumn
        }));
    }
}
const $c8904a2d17cd5362$var$wrapperMarginLeftStylesMap = {
    firstColumn: "_18u01ejb",
    otherColumn: "_18u0ze3t"
};
const $c8904a2d17cd5362$var$Wrapper = ({ isFirstColumn: isFirstColumn, shouldUseCssForRendering: shouldUseCssForRendering, width: width, column: column, children: children, sortOrder: sortOrder })=>{
    if (column && shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            minWidth: (0, $3Ogvp.getWidth)({
                width: column.minWidth,
                isFirstColumn: isFirstColumn
            }),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: (0, $3Ogvp.getWidth)({
                width: column.maxWidth,
                isFirstColumn: isFirstColumn
            })
        },
        xcss: [
            $c8904a2d17cd5362$var$wrapperStyles,
            ...isFirstColumn ? [
                $c8904a2d17cd5362$var$firstColumnStyles
            ] : [
                $c8904a2d17cd5362$var$otherColumnStyles
            ]
        ],
        ...(0, $7jTnu.fg)('jsm_virtual_table_a11y') && {
            role: 'columnheader'
        },
        ...(0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') && {
            'aria-sort': sortOrder
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            width: (0, $3Ogvp.getWidth)({
                width: width,
                isFirstColumn: isFirstColumn
            })
        },
        ...(0, $7jTnu.fg)('jsm_virtual_table_a11y') && {
            role: 'columnheader'
        },
        ...(0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') && {
            'aria-sort': sortOrder
        },
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _kqswh2mm",
            $c8904a2d17cd5362$var$wrapperMarginLeftStylesMap[isFirstColumn ? 'firstColumn' : 'otherColumn']
        ])
    }, children);
};
const $c8904a2d17cd5362$var$cssWrapperStyles = null;
const $c8904a2d17cd5362$var$wrapperStyles = (0, $1DXK0.xcss)({
    width: '100%',
    flex: '1 1 auto'
});
const $c8904a2d17cd5362$var$firstColumnStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.300'
});
const $c8904a2d17cd5362$var$otherColumnStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.0'
});

});



parcelRegister("g0A8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $42a25ab4877cdca7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");
function $42a25ab4877cdca7$export$2e2bcd8739ae039(props) {
    const { id: id, DynamicColumnComponent: DynamicColumnComponent, sortOrder: sortOrder } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DynamicColumnComponent, {
        id: id,
        ...(0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') ? {
            sortOrder: sortOrder
        } : {}
    });
}

});


parcelRegister("ajVRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e036c530541700f4$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $7jTnu = parcelRequire("7jTnu");

var $i1eKe = parcelRequire("i1eKe");
const $e036c530541700f4$var$SEGMENT_KEY = 'virtual-table.table.header.wrapper';
const $e036c530541700f4$var$getShadowWidth = ({ width: width, leftShadowVisible: leftShadowVisible, rightShadowVisible: rightShadowVisible })=>width + (leftShadowVisible ? 0 : 8) + (rightShadowVisible ? 0 : 8);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e036c530541700f4$var$HeaderShadow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ht14a7": (0, $awdRS.default)(`${$e036c530541700f4$var$getShadowWidth(__cmplp)}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154ix0bf _1xi2ze3t _94n5x0bf _1ltvze3t _4t3iutpp _1bsbcyjv",
            __cmplp.className
        ])
    });
});
const $e036c530541700f4$var$getMargin = (hasScrolled, isShadowVisible)=>8 * $e036c530541700f4$var$marginMultiplier(hasScrolled, isShadowVisible);
const $e036c530541700f4$var$marginMultiplier = (hasScrolled, isShadowVisible)=>{
    if (isShadowVisible) return 0;
    if (hasScrolled) return -1;
    return 1;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e036c530541700f4$var$InnerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasScrolled: hasScrolled, leftShadowVisible: leftShadowVisible, rightShadowVisible: rightShadowVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1koxo07": (0, $awdRS.default)(`${$e036c530541700f4$var$getMargin(__cmplp.hasScrolled, __cmplp.leftShadowVisible) * -1}px`),
            "--_1hyq4n0": (0, $awdRS.default)(`${$e036c530541700f4$var$getMargin(__cmplp.hasScrolled, __cmplp.rightShadowVisible) * -1}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1wug _1e0c1txw _18u0wdq9 _2hwxek4m _18m915vq",
            __cmplp.className
        ])
    });
});
const $e036c530541700f4$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasScrolled: hasScrolled, leftShadowVisible: leftShadowVisible, rightShadowVisible: rightShadowVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_150w5uv": (0, $awdRS.default)(`${$e036c530541700f4$var$getMargin(__cmplp.hasScrolled, __cmplp.leftShadowVisible)}px`),
            "--_oytggz": (0, $awdRS.default)(`${$e036c530541700f4$var$getMargin(__cmplp.hasScrolled, __cmplp.rightShadowVisible)}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zl176a _4t3i1wug _18u0t6e2 _2hwx1meq _n3td1b66 _ca0qu2gc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $e036c530541700f4$var$ShadowWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ht14a7": (0, $awdRS.default)(`${$e036c530541700f4$var$getShadowWidth(__cmplp)}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _kqswstnw _1xi2ze3t _94n5xmi2 _1ltvze3t _4t3iutpp _1bsbcyjv _1pbykb7n _lcxvglyw",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $e036c530541700f4$var$ColumnHeaders extends (0, $eJOHy.PureComponent) {
    componentDidMount() {
        if (this.props.isAutoRowHeight && this.ref) this.props.setHeaderHeight(Math.ceil(this.ref.getBoundingClientRect().height));
    }
    componentDidUpdate() {
        if (this.props.isAutoRowHeight && this.ref) this.props.setHeaderHeight(Math.ceil(this.ref.getBoundingClientRect().height));
    }
    renderCoreColumns() {
        const { coreColumnIds: coreColumnIds, Column: Column, persistedStoreColumns: persistedStoreColumns } = this.props;
        return (0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') ? coreColumnIds.map((columnId)=>{
            const getColumn = persistedStoreColumns && persistedStoreColumns.find((item)=>item.id === columnId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Column, {
                key: columnId,
                id: columnId,
                sortOrder: getColumn?.currentSorting ?? 'NONE'
            });
        }) : coreColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Column, {
                key: columnId,
                id: columnId
            }));
    }
    renderAdditionalColumns() {
        const { additionalColumnIds: additionalColumnIds, AdditionalColumnsContainer: AdditionalColumnsContainer, Column: Column, persistedStoreColumns: persistedStoreColumns } = this.props;
        return (0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdditionalColumnsContainer, {
            placeholderKey: (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? 'header' : undefined
        }, additionalColumnIds.map((columnId)=>{
            const getColumn = persistedStoreColumns && persistedStoreColumns.find((item)=>item.id === columnId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Column, {
                key: columnId,
                id: columnId,
                sortOrder: getColumn?.currentSorting ?? 'NONE'
            });
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdditionalColumnsContainer, {
            placeholderKey: (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? 'header' : undefined
        }, additionalColumnIds.map((columnId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Column, {
                key: columnId,
                id: columnId
            })));
    }
    render() {
        const { additionalColumnIds: additionalColumnIds, bottomShadowWidth: bottomShadowWidth, isColumnConfigurationVisible: isColumnConfigurationVisible, hasVerticallyScrolled: hasVerticallyScrolled, tableHasLeftShadow: tableHasLeftShadow, tableHasRightShadow: tableHasRightShadow, ColumnConfiguration: ColumnConfiguration, theme: theme } = this.props;
        const styledCompProps = {
            hasScrolled: hasVerticallyScrolled,
            leftShadowVisible: tableHasLeftShadow,
            rightShadowVisible: tableHasRightShadow,
            width: bottomShadowWidth
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e036c530541700f4$var$Wrapper, {
            ref: this.setRef,
            ...styledCompProps,
            theme: theme,
            ...(0, $7jTnu.fg)('jsm_virtual_table_a11y') && {
                role: 'row'
            },
            "data-testId": (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? $e036c530541700f4$var$SEGMENT_KEY : undefined,
            "data-vc": (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? `${$e036c530541700f4$var$SEGMENT_KEY}${false ? '-ssr' : ''}` : undefined,
            "data-ssr-placeholder": false && (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? $e036c530541700f4$var$SEGMENT_KEY : undefined,
            "data-ssr-placeholder-replace": false || !(0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page') ? undefined : $e036c530541700f4$var$SEGMENT_KEY
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e036c530541700f4$var$InnerWrapper, {
            ...styledCompProps,
            theme: theme
        }, this.renderCoreColumns(), additionalColumnIds.length > 0 && this.renderAdditionalColumns(), isColumnConfigurationVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ColumnConfiguration, null), theme.header.hasShadow && hasVerticallyScrolled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e036c530541700f4$var$ShadowWrapper, {
            ...styledCompProps,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e036c530541700f4$var$HeaderShadow, {
            ...styledCompProps,
            theme: theme
        }))));
    }
    constructor(...args){
        super(...args), this.setRef = (el)=>{
            this.ref = el;
        };
    }
}
var $e036c530541700f4$export$2e2bcd8739ae039 = (0, $i1eKe.withTheme)($e036c530541700f4$var$ColumnHeaders);

});


parcelRegister("e8ODd", function(module, exports) {

$parcel$export(module.exports, "default", () => $97aeca801d427ba2$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3s8bj = parcelRequire("3s8bj");

var $aBFKZ = parcelRequire("aBFKZ");

var $7jTnu = parcelRequire("7jTnu");

var $i1eKe = parcelRequire("i1eKe");
const $97aeca801d427ba2$var$ANALYTICS_DEBOUNCE_MILLIS = 1000;
// eslint-disable-next-line jira/react/no-class-components
class $97aeca801d427ba2$var$TableMain extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props);
        this.analyticsDebouncer = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(props.onTableChange, $97aeca801d427ba2$var$ANALYTICS_DEBOUNCE_MILLIS);
    }
    componentDidMount() {
        const { containerWidth: containerWidth, hasLoadingRows: hasLoadingRows, onTableChange: onTableChange } = this.props;
        if (containerWidth && !hasLoadingRows) onTableChange();
    }
    // @ts-expect-error - TS7006 - Parameter 'prevProps' implicitly has an 'any' type.
    componentDidUpdate(prevProps) {
        const { rowIds: rowIds, containerWidth: containerWidth, hasLoadingRows: hasLoadingRows, hasHorizontalScrollbar: hasHorizontalScrollbar, hasVerticalScrollbar: hasVerticalScrollbar } = this.props;
        if (!hasLoadingRows && (rowIds !== prevProps.rowIds || containerWidth !== prevProps.containerWidth || hasHorizontalScrollbar !== prevProps.hasHorizontalScrollbar || hasVerticalScrollbar !== prevProps.hasVerticalScrollbar)) /*
       * send analytics event if -
       * - the window was resized
       * - the scrollbar state changed (new rows added, rows expanded, columns added)
       * - table content updated (new table/queue, pagination, sorting, asyn updates)
       *    - but not 'loading' rows
       *
       * Do this over a 1 sec timer to avoid multiple events getting fired during window resize
       * since AutoSizer keeps updating this component during every resize
       */ this.analyticsDebouncer();
    }
    render() {
        const { width: width, shouldUseCssForRendering: shouldUseCssForRendering, Header: Header, Content: Content, ResizeColumnOverlay: ResizeColumnOverlay, HorizontalScrollOverlay: HorizontalScrollOverlay, ariaLabel: ariaLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            style: {
                width: shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table') ? '100%' : `${width}px`
            },
            "data-testid": "virtual-table.table.main",
            ...(0, $7jTnu.fg)('jsm_virtual_table_a11y') && {
                role: 'table'
            },
            "aria-label": ariaLabel,
            className: (0, $hcewu.default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _2lx21bp4"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($97aeca801d427ba2$var$HeaderWrapper, (0, $7jTnu.fg)('jsm_virtual_table_a11y') && {
            role: 'rowgroup'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Header, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($97aeca801d427ba2$var$ContentWrapper, {
            className: "virtual-table-content-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ResizeColumnOverlay, {
            shouldUseCssForRendering: shouldUseCssForRendering && (0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HorizontalScrollOverlay, null));
    }
}
var $97aeca801d427ba2$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('virtualTable', {
    onTableChange: 'updated'
})((0, $i1eKe.withTheme)($97aeca801d427ba2$var$TableMain));
const $97aeca801d427ba2$var$wrapperStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97aeca801d427ba2$var$HeaderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _u5f3xy5q",
            __cmplp.className
        ])
    });
});
const $97aeca801d427ba2$var$ContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _bfhkvuon",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iqRRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa2b92244e5a375f$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $2Ctxl = parcelRequire("2Ctxl");

var $5wAOx = parcelRequire("5wAOx");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $bxFrH = parcelRequire("bxFrH");
var $aa2b92244e5a375f$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        getOffsetFromBottom: (0, $fRJOe.getOffsetFromBottom)(state),
        isHorizontalScrollVisible: (0, $fRJOe.hasHorizontalScrollbar)(state),
        offset: (0, $2Ctxl.getVisibleCoreColumnsWidth)(state),
        showBottomDecal: (0, $5wAOx.showBottomDecal)(state),
        showLeftShadow: (0, $fRJOe.isHorizontalScrollLeftShadowVisible)(state),
        showRightShadow: (0, $fRJOe.isHorizontalScrollRightShadowVisible)(state),
        tableHeight: (0, $fRJOe.getTableHeight)(state),
        tableWidth: (0, $atQRE.getTableWidthWithoutScrollbarOffset)(state),
        shouldUseCssForRendering: (0, $atQRE.getShouldUseCssForRendering)(state)
    }), {})((0, $bxFrH.default));

});
parcelRegister("bxFrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $df519e3c180554a9$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $7jTnu = parcelRequire("7jTnu");

var $i1eKe = parcelRequire("i1eKe");

var $8nFYk = parcelRequire("8nFYk");
const $df519e3c180554a9$var$softShadow = {
    '@media screen and (-webkit-min-device-pixel-ratio: 0)': {
        boxShadow: "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"
    },
    '@media screen and (-webkit-transition)': {
        boxShadow: "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"
    },
    '@-moz-document url-prefix()': {
        boxShadow: "var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"
    }
};
const $df519e3c180554a9$export$1b2ba256944351ec = 20;
// eslint-disable-next-line jira/react/no-class-components
class $df519e3c180554a9$var$HorizontalScrollOverlay extends (0, $eJOHy.PureComponent) {
    render() {
        const { offset: offset, showLeftShadow: showLeftShadow, showRightShadow: showRightShadow, tableHeight: tableHeight, tableWidth: tableWidth, isHorizontalScrollVisible: isHorizontalScrollVisible, showBottomDecal: showBottomDecal, getOffsetFromBottom: getOffsetFromBottom, theme: theme, shouldUseCssForRendering: shouldUseCssForRendering } = this.props;
        const showBottomShadow = (isHorizontalScrollVisible || showBottomDecal) && getOffsetFromBottom > 0;
        const spaceTakenByHorizontalScrollbar = (0, $8nFYk.scrollbarWidth) + theme.scrollbar.marginTop + theme.scrollbar.marginBottom;
        const verticalShadowHeight = tableHeight - spaceTakenByHorizontalScrollbar;
        if (shouldUseCssForRendering && (0, $7jTnu.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !false && showLeftShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$LeftWrapper, {
            "data-testid": "virtual-table.table.overlays.horizontal-scroll.left-wrapper",
            offset: offset,
            height: verticalShadowHeight,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$LeftShadow, {
            theme: theme
        })), !false && showRightShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$RightWrapper, {
            "data-testid": "virtual-table.table.overlays.horizontal-scroll.right-wrapper",
            height: "100%",
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$RightShadow, null)), showBottomShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$BottomWrapper, {
            "data-testid": "virtual-table.table.overlays.horizontal-scroll.bottom-wrapper",
            height: $df519e3c180554a9$export$1b2ba256944351ec,
            tableWidth: tableWidth,
            topPositionForBottomShadow: this.calculateTopPositionForBottomShadow(spaceTakenByHorizontalScrollbar),
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$BottomShadow, null)));
        if ((0, $7jTnu.fg)('css_support_for_virtual_table')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showLeftShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$LeftWrapper, {
            offset: offset,
            height: verticalShadowHeight,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$LeftShadow, {
            theme: theme
        })), showRightShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$RightWrapper, {
            height: verticalShadowHeight,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$RightShadow, null)), showBottomShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$BottomWrapper, {
            height: $df519e3c180554a9$export$1b2ba256944351ec,
            tableWidth: tableWidth,
            topPositionForBottomShadow: this.calculateTopPositionForBottomShadow(spaceTakenByHorizontalScrollbar),
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$BottomShadow, null)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, showLeftShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$LeftWrapper, {
            offset: offset,
            height: verticalShadowHeight,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$LeftShadow, {
            theme: theme
        })), showRightShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$RightWrapperOld, {
            height: verticalShadowHeight,
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$RightShadow, null)), showBottomShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$BottomWrapper, {
            height: $df519e3c180554a9$export$1b2ba256944351ec,
            tableWidth: tableWidth,
            topPositionForBottomShadow: this.calculateTopPositionForBottomShadow(spaceTakenByHorizontalScrollbar),
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df519e3c180554a9$var$BottomShadow, null)));
    }
    constructor(...args){
        super(...args), this.calculateTopPositionForBottomShadow = (spaceTakenByHorizontalScrollbar)=>{
            const { isHorizontalScrollVisible: isHorizontalScrollVisible, tableHeight: tableHeight } = this.props;
            if (isHorizontalScrollVisible) return tableHeight - spaceTakenByHorizontalScrollbar - $df519e3c180554a9$export$1b2ba256944351ec;
            return tableHeight - $df519e3c180554a9$export$1b2ba256944351ec;
        };
    }
}
var $df519e3c180554a9$export$2e2bcd8739ae039 = (0, $i1eKe.withTheme)($df519e3c180554a9$var$HorizontalScrollOverlay);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $df519e3c180554a9$var$BottomShadow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _1ltvze3t _1bsb1osq _4t3i19bv _wxnd9g9j _16pl9g9j _5hft9g9j",
            __cmplp.className
        ])
    });
});
const $df519e3c180554a9$var$BottomWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { topPositionForBottomShadow: topPositionForBottomShadow, tableWidth: tableWidth, theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_iucfl6": (0, $awdRS.default)(`${__cmplp.topPositionForBottomShadow}px`),
            "--_1lfl5vu": (0, $awdRS.default)(`width: ${__cmplp.tableWidth}px`),
            "--_1lfsua2": (0, $awdRS.default)(__cmplp.theme.shadow.bottom.display),
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _kqswstnw _154i1lgz _1ltvze3t _1bsb1p8o _1e0ch4j2 _4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $df519e3c180554a9$var$RightShadow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154ix0bf _94n5x0bf _1ltvv47k _1bsb19bv _wxnd9g9j _16pl9g9j _5hft9g9j",
            __cmplp.className
        ])
    });
});
const $df519e3c180554a9$var$RightWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bke5hq": (0, $awdRS.default)(__cmplp.theme.shadow.right.display),
            "--_10ib6lf": (0, $awdRS.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _kqswstnw _154ize3t _1xi2xy5q _94n5ze3t _1bsbv47k _1e0c13s1",
            typeof __cmplp.height === 'string' ? "_4t3it1jn" : "_4t3it1jn",
            __cmplp.className
        ])
    });
});
const $df519e3c180554a9$var$RightWrapperOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bke5hq": (0, $awdRS.default)(__cmplp.theme.shadow.right.display),
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _kqswstnw _154ize3t _1xi2xy5q _94n5ze3t _1bsbv47k _1e0c13s1 _4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $df519e3c180554a9$var$LeftShadow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154ix0bf _94n5x0bf _1ltvx0bf _1bsb19bv _wxnd9g9j _16pl9g9j _5hft9g9j",
            __cmplp.className
        ])
    });
});
const $df519e3c180554a9$var$LeftWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { theme: theme, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1l2g1c7": (0, $awdRS.default)(`${__cmplp.theme.shadow.left.borderWidth}px solid ${__cmplp.theme.header.borderColor}`),
            "--_10ib6lf": (0, $awdRS.default)(__cmplp.height, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1kl71s3n _kqswstnw _154ize3t _94n5ze3t _1ltvze3t _1bsbv47k",
            __cmplp.theme.shadow.left.computeHeight ? "_4t3it1jn" : "_4t3i1kw7",
            __cmplp.className
        ])
    });
});

});


parcelRegister("HfKm7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bd267420c440896$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $jtL7O = parcelRequire("jtL7O");
var $3bd267420c440896$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state)=>({
        width: (0, $fRJOe.getTableContentWidth)(state),
        isVisible: !!(0, $atQRE.getResizingColumnId)(state)
    }), {})((0, $jtL7O.default));

});
parcelRegister("jtL7O", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa61f2ea0fa0bd42$export$2e2bcd8739ae039);
/* index-dumb.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $7jTnu = parcelRequire("7jTnu");
function $aa61f2ea0fa0bd42$export$2e2bcd8739ae039(props) {
    const { width: width, isVisible: isVisible, shouldUseCssForRendering: shouldUseCssForRendering } = props;
    if ((0, $7jTnu.fg)('further_improve_vc90_performence_of_queues_page')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testId": "virtual-table.table.main.resizeColumnOverlay",
        style: {
            width: shouldUseCssForRendering ? '100%' : `${width}px`
        },
        className: (0, $hcewu.default)([
            "_lcxvglyw _kqswstnw _154iidpf _94n5idpf _1ltvidpf _bfhk1bhr",
            isVisible ? "_v564mmrx _tzy4105o" : "_v564b45n _tzy4idpf"
        ])
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aa61f2ea0fa0bd42$var$Overlay, {
        width: width,
        isVisible: isVisible
    });
}
const $aa61f2ea0fa0bd42$var$styles = null;
const $aa61f2ea0fa0bd42$var$visibleStyles = null;
const $aa61f2ea0fa0bd42$var$invisibleStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa61f2ea0fa0bd42$var$Overlay = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $awdRS.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_lcxvglyw _kqswstnw _154iidpf _94n5idpf _1ltvidpf _1bsb1hdq _bfhk1bhr",
            __cmplp.isVisible ? "_tzy4105o" : "_tzy4idpf",
            __cmplp.isVisible ? "_v564mmrx" : "_v564b45n",
            __cmplp.className
        ])
    });
});

});




parcelRegister("gm7EY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd12373c26c290e$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $dFg4o = parcelRequire("dFg4o");

var $4tM8k = parcelRequire("4tM8k");

var $kqAfW = parcelRequire("kqAfW");

var $f914j = parcelRequire("f914j");

var $du5pn = parcelRequire("du5pn");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$4cd12373c26c290e$export$2e2bcd8739ae039 = (initialState)=>(0, $7HHI1.createStore)((0, $dFg4o.enableBatching)((0, $du5pn.default)), initialState, (0, $kqAfW.default)({
        name: 'Table'
    })((0, $7HHI1.applyMiddleware)((0, $4tM8k.createEpicMiddleware)((0, $f914j.default)))));

});
parcelRegister("f914j", function(module, exports) {

$parcel$export(module.exports, "default", () => $da6ffbe8cb9bd135$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $kpFTP = parcelRequire("kpFTP");

var $jBj3z = parcelRequire("jBj3z");

var $3ECq0 = parcelRequire("3ECq0");

var $dn0XZ = parcelRequire("dn0XZ");

var $dl96d = parcelRequire("dl96d");

var $cvOmV = parcelRequire("cvOmV");

var $cdOxK = parcelRequire("cdOxK");

var $cLn2f = parcelRequire("cLn2f");
var $da6ffbe8cb9bd135$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $kpFTP.default), (0, $dn0XZ.default), (0, $cLn2f.default), (0, $jBj3z.default), (0, $dl96d.default), (0, $cvOmV.default), (0, $cdOxK.default), (0, $3ECq0.default));

});
parcelRegister("kpFTP", function(module, exports) {

$parcel$export(module.exports, "default", () => $64c0418bf0fb6b15$export$2e2bcd8739ae039);


var $5wAOx = parcelRequire("5wAOx");

var $fRJOe = parcelRequire("fRJOe");

var $02dWc = parcelRequire("02dWc");

var $yZlVL = parcelRequire("yZlVL");

var $4Mvfe = parcelRequire("4Mvfe");

var $jr0Vm = parcelRequire("jr0Vm");

var $i90Fr = parcelRequire("i90Fr");
var $64c0418bf0fb6b15$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $jr0Vm.NAVIGATE_TO_CELL), (action, state)=>{
    const { direction: direction, columnId: columnId, rowId: rowId } = action.payload;
    const visibleColumnIds = (0, $5wAOx.getVisibleColumnIds)(state);
    const loadingRowIdsSet = new Set((0, $fRJOe.getVisibleLoadingRowIds)(state));
    const visibleRowIds = (0, $02dWc.getFlattenedWithAddedRowIds)(state);
    /* activatedFrom is the opposite of direction, as it is the
	 * relative orientation of the cell that navigated to it, and not
	 * the user interaction that caused the navigation.
	 */ switch(direction){
        case 0, $7e33285e7fb1fa6b$export$b29f845fa4b57508:
            return (0, $4Mvfe.setActiveCell)({
                columnId: columnId,
                rowId: (0, $i90Fr.navigateUp)(visibleRowIds, rowId, loadingRowIdsSet),
                activatedFrom: (0, $7e33285e7fb1fa6b$export$c7c029a231f98d34)
            });
        case 0, $7e33285e7fb1fa6b$export$c7c029a231f98d34:
            return (0, $4Mvfe.setActiveCell)({
                columnId: columnId,
                rowId: (0, $i90Fr.navigateDown)(visibleRowIds, rowId, loadingRowIdsSet),
                activatedFrom: (0, $7e33285e7fb1fa6b$export$b29f845fa4b57508)
            });
        case 0, $7e33285e7fb1fa6b$export$f981f70d61d1405a:
            return (0, $4Mvfe.setActiveCell)({
                columnId: (0, $i90Fr.navigateUp)(visibleColumnIds, columnId, new Set()),
                rowId: rowId,
                activatedFrom: (0, $7e33285e7fb1fa6b$export$1cac5500365a4eb4)
            });
        case 0, $7e33285e7fb1fa6b$export$1cac5500365a4eb4:
            return (0, $4Mvfe.setActiveCell)({
                columnId: (0, $i90Fr.navigateDown)(visibleColumnIds, columnId, new Set()),
                rowId: rowId,
                activatedFrom: (0, $7e33285e7fb1fa6b$export$f981f70d61d1405a)
            });
        default:
            throw new Error('illegal value of the direction property.');
    }
});

});
parcelRegister("yZlVL", function(module, exports) {

$parcel$export(module.exports, "defineTransaction", () => $a556c2c7ad7f42fb$export$c19bdc7dbe69198d);

var $dFg4o = parcelRequire("dFg4o");
parcelRequire("b0lv4");
parcelRequire("9BkTq");
parcelRequire("8yIb3");
parcelRequire("1o2WJ");
parcelRequire("6cJUr");
parcelRequire("c1D7V");

var $4tM8k = parcelRequire("4tM8k");

var $eI1yv = parcelRequire("eI1yv");

var $ZFqXT = parcelRequire("ZFqXT");

var $7kixv = parcelRequire("7kixv");

var $ij4ku = parcelRequire("ij4ku");
const $a556c2c7ad7f42fb$var$errorHandler = (0, $ij4ku.errorHandlerFactory)();
const $a556c2c7ad7f42fb$export$c19bdc7dbe69198d = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(type, callback)=>(action$, store)=>action$.ofType(type)// @ts-expect-error - TS7006 - Parameter 'payload' implicitly has an 'any' type.
        .flatMap((payload)=>{
            const callbackResult = callback ? callback(payload, store.getState()) : [];
            const flatTree = Array.isArray(callbackResult) ? (0, (/*@__PURE__*/$parcel$interopDefault($eI1yv)))(callbackResult) : [
                callbackResult
            ];
            const observables = [];
            flatTree.forEach((leaf)=>{
                if (leaf instanceof (0, $7kixv.Observable)) observables.push(leaf);
                else observables.push((0, $7kixv.Observable).of(leaf));
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ZFqXT)))(observables) === 1) return observables[0];
            return (0, $7kixv.Observable).zip(...observables, (...resolvedActions)=>// @ts-expect-error - TS2345 - Argument of type 'unknown[]' is not assignable to parameter of type 'Action[]'.
                (0, $dFg4o.batchActions)((0, (/*@__PURE__*/$parcel$interopDefault($eI1yv)))(resolvedActions)));
        }).catch($a556c2c7ad7f42fb$var$errorHandler);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a556c2c7ad7f42fb$var$defaultGeneratePayload = (action)=>action.payload;
const $a556c2c7ad7f42fb$export$aec11e7f84966a38 = (type, method, callback, generatePayload)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (action$, store)=>action$.ofType(type)// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
        .flatMap((action)=>{
            const observable = method(generatePayload === undefined ? $a556c2c7ad7f42fb$var$defaultGeneratePayload(action) : generatePayload(action, store.getState()));
            if (typeof callback !== 'undefined') return observable.map((response)=>{
                const actions = callback ? callback(response, store.getState()) : [];
                if (Array.isArray(actions)) return (0, $dFg4o.batchActions)(actions);
                return actions;
            });
            return observable.ignoreElements();
        }).catch($a556c2c7ad7f42fb$var$errorHandler);
const $a556c2c7ad7f42fb$export$cc1acdd68c249d8b = (type, before, method, after, generatePayload)=>{
    const optimisticTransaction = $a556c2c7ad7f42fb$export$c19bdc7dbe69198d(type, before);
    const apiTransaction = $a556c2c7ad7f42fb$export$aec11e7f84966a38(type, method, after, generatePayload);
    return (0, $4tM8k.combineEpics)(optimisticTransaction, apiTransaction);
};

});
parcelRegister("eI1yv", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");
/** Used as references for various `Number` constants. */ var $ab5661a8f66a4e74$var$INFINITY = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function $ab5661a8f66a4e74$var$flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? $72Qfa(array, $ab5661a8f66a4e74$var$INFINITY) : [];
}
module.exports = $ab5661a8f66a4e74$var$flattenDeep;

});

parcelRegister("ZFqXT", function(module, exports) {

var $jAnCu = parcelRequire("jAnCu");

var $PodIB = parcelRequire("PodIB");

var $7H30b = parcelRequire("7H30b");

var $l5Z0K = parcelRequire("l5Z0K");

var $esCHN = parcelRequire("esCHN");
/** `Object#toString` result references. */ var $0b95d68878817576$var$mapTag = '[object Map]', $0b95d68878817576$var$setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function $0b95d68878817576$var$size(collection) {
    if (collection == null) return 0;
    if ($7H30b(collection)) return $l5Z0K(collection) ? $esCHN(collection) : collection.length;
    var tag = $PodIB(collection);
    if (tag == $0b95d68878817576$var$mapTag || tag == $0b95d68878817576$var$setTag) return collection.size;
    return $jAnCu(collection).length;
}
module.exports = $0b95d68878817576$var$size;

});
parcelRegister("l5Z0K", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $4sprp = parcelRequire("4sprp");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $f5b964216372e7cd$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $f5b964216372e7cd$var$isString(value) {
    return typeof value == 'string' || !$4sprp(value) && $7gKgM(value) && $1O9y6(value) == $f5b964216372e7cd$var$stringTag;
}
module.exports = $f5b964216372e7cd$var$isString;

});

parcelRegister("esCHN", function(module, exports) {

var $cVaIZ = parcelRequire("cVaIZ");

var $beeZR = parcelRequire("beeZR");

var $dsEqJ = parcelRequire("dsEqJ");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $a871b4482705c524$var$stringSize(string) {
    return $beeZR(string) ? $dsEqJ(string) : $cVaIZ(string);
}
module.exports = $a871b4482705c524$var$stringSize;

});
parcelRegister("cVaIZ", function(module, exports) {

var $9U1Ux = parcelRequire("9U1Ux");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $9683209b72c5c382$var$asciiSize = $9U1Ux('length');
module.exports = $9683209b72c5c382$var$asciiSize;

});

parcelRegister("dsEqJ", function(module, exports) {
/** Used to compose unicode character classes. */ var $9ccd4073599dd88e$var$rsAstralRange = '\\ud800-\\udfff', $9ccd4073599dd88e$var$rsComboMarksRange = '\\u0300-\\u036f', $9ccd4073599dd88e$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $9ccd4073599dd88e$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $9ccd4073599dd88e$var$rsComboRange = $9ccd4073599dd88e$var$rsComboMarksRange + $9ccd4073599dd88e$var$reComboHalfMarksRange + $9ccd4073599dd88e$var$rsComboSymbolsRange, $9ccd4073599dd88e$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $9ccd4073599dd88e$var$rsAstral = '[' + $9ccd4073599dd88e$var$rsAstralRange + ']', $9ccd4073599dd88e$var$rsCombo = '[' + $9ccd4073599dd88e$var$rsComboRange + ']', $9ccd4073599dd88e$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $9ccd4073599dd88e$var$rsModifier = '(?:' + $9ccd4073599dd88e$var$rsCombo + '|' + $9ccd4073599dd88e$var$rsFitz + ')', $9ccd4073599dd88e$var$rsNonAstral = '[^' + $9ccd4073599dd88e$var$rsAstralRange + ']', $9ccd4073599dd88e$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $9ccd4073599dd88e$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $9ccd4073599dd88e$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $9ccd4073599dd88e$var$reOptMod = $9ccd4073599dd88e$var$rsModifier + '?', $9ccd4073599dd88e$var$rsOptVar = '[' + $9ccd4073599dd88e$var$rsVarRange + ']?', $9ccd4073599dd88e$var$rsOptJoin = '(?:' + $9ccd4073599dd88e$var$rsZWJ + '(?:' + [
    $9ccd4073599dd88e$var$rsNonAstral,
    $9ccd4073599dd88e$var$rsRegional,
    $9ccd4073599dd88e$var$rsSurrPair
].join('|') + ')' + $9ccd4073599dd88e$var$rsOptVar + $9ccd4073599dd88e$var$reOptMod + ')*', $9ccd4073599dd88e$var$rsSeq = $9ccd4073599dd88e$var$rsOptVar + $9ccd4073599dd88e$var$reOptMod + $9ccd4073599dd88e$var$rsOptJoin, $9ccd4073599dd88e$var$rsSymbol = '(?:' + [
    $9ccd4073599dd88e$var$rsNonAstral + $9ccd4073599dd88e$var$rsCombo + '?',
    $9ccd4073599dd88e$var$rsCombo,
    $9ccd4073599dd88e$var$rsRegional,
    $9ccd4073599dd88e$var$rsSurrPair,
    $9ccd4073599dd88e$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $9ccd4073599dd88e$var$reUnicode = RegExp($9ccd4073599dd88e$var$rsFitz + '(?=' + $9ccd4073599dd88e$var$rsFitz + ')|' + $9ccd4073599dd88e$var$rsSymbol + $9ccd4073599dd88e$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $9ccd4073599dd88e$var$unicodeSize(string) {
    var result = $9ccd4073599dd88e$var$reUnicode.lastIndex = 0;
    while($9ccd4073599dd88e$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $9ccd4073599dd88e$var$unicodeSize;

});



parcelRegister("ij4ku", function(module, exports) {

$parcel$export(module.exports, "errorHandlerFactory", () => $54b67219aee6dbfa$export$6a6f72199c8b8578);

var $7kixv = parcelRequire("7kixv");
parcelRequire("baP6E");
parcelRequire("9BkTq");

var $eSnSE = parcelRequire("eSnSE");

var $es5G8 = parcelRequire("es5G8");

var $3WqD0 = parcelRequire("3WqD0");

const $54b67219aee6dbfa$var$LOCATION = 'common.components.virtual-table.ops.common.errors';
const $54b67219aee6dbfa$var$translateJsError = (jsError)=>(0, $7kixv.Observable).of(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $3WqD0.error)({
        type: (0, $06523380e10b39db$export$78244dbb77cfa6b6),
        message: jsError.message,
        stack: jsError.stack
    }));
const $54b67219aee6dbfa$var$generateErrorAction = (thrownError)=>$54b67219aee6dbfa$var$translateJsError(thrownError);
const $54b67219aee6dbfa$export$6a6f72199c8b8578 = (additionalFailAction)=>(thrownError)=>{
        (0, $es5G8.captureException)($54b67219aee6dbfa$var$LOCATION, thrownError);
        (0, $eSnSE.default).safeErrorWithoutCustomerData($54b67219aee6dbfa$var$LOCATION, thrownError.message || 'Operations error', thrownError);
        const errorAction = $54b67219aee6dbfa$var$generateErrorAction(thrownError);
        if (additionalFailAction) return (0, $7kixv.Observable).concat(errorAction, (0, $7kixv.Observable).of(additionalFailAction()));
        return errorAction;
    };

});
parcelRegister("3WqD0", function(module, exports) {

$parcel$export(module.exports, "error", () => $b527c2d1ab287808$export$a3bc9b8ed74fc);
const $b527c2d1ab287808$export$103bedf43ba882db = 'ops.common.errors.ERROR';
const $b527c2d1ab287808$export$a3bc9b8ed74fc = (payload)=>({
        type: $b527c2d1ab287808$export$103bedf43ba882db,
        payload: payload
    });

});

// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $06523380e10b39db$var$HTTP = 'HTTP';
const $06523380e10b39db$export$78244dbb77cfa6b6 = 'UNKNOWN';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $06523380e10b39db$var$REDUX = 'REDUX';



parcelRegister("i90Fr", function(module, exports) {

$parcel$export(module.exports, "navigateUp", () => $238bcd5d927be780$export$565581085a0f36e2);
$parcel$export(module.exports, "navigateDown", () => $238bcd5d927be780$export$876f6f483a97d3b5);

var $gyBpf = parcelRequire("gyBpf");

var $l1N9H = parcelRequire("l1N9H");
const $238bcd5d927be780$var$navigateWithStrategy = (items, currentItemId, searchStrategy)=>{
    const selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(items, (item)=>item === currentItemId);
    // Selected item is not found; go to top
    if (selectedIndex === -1) return items[0];
    const nextIndex = searchStrategy(selectedIndex);
    if (nextIndex === -1) return items[0];
    return items[nextIndex];
};
const $238bcd5d927be780$var$buildSearchStrategy = (searchFn, fallbackFn)=>(selectedIndex)=>{
        const searchResult = searchFn(selectedIndex);
        if (searchResult === -1) return fallbackFn(selectedIndex);
        return searchResult;
    };
const $238bcd5d927be780$export$565581085a0f36e2 = (items, currentItemId, ineligibleItemsSet)=>$238bcd5d927be780$var$navigateWithStrategy(items, currentItemId, $238bcd5d927be780$var$buildSearchStrategy((selectedIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($l1N9H)))(items, (item)=>!ineligibleItemsSet.has(item), selectedIndex - 1), ()=>(0, (/*@__PURE__*/$parcel$interopDefault($l1N9H)))(items, (item)=>!ineligibleItemsSet.has(item), items.length - 1)));
const $238bcd5d927be780$export$876f6f483a97d3b5 = (items, currentItemId, ineligibleItemsSet)=>$238bcd5d927be780$var$navigateWithStrategy(items, currentItemId, $238bcd5d927be780$var$buildSearchStrategy((selectedIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(items, (item)=>!ineligibleItemsSet.has(item), selectedIndex + 1), ()=>(0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(items, (item)=>!ineligibleItemsSet.has(item), 0)));

});


parcelRegister("jBj3z", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e30da11b8df117$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $37NAC = parcelRequire("37NAC");

var $7cbdO = parcelRequire("7cbdO");
var $87e30da11b8df117$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $37NAC.default), (0, $7cbdO.default));

});
parcelRegister("37NAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef51904c99e9af8$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $5RQuv = parcelRequire("5RQuv");

var $ilgD5 = parcelRequire("ilgD5");
var $9ef51904c99e9af8$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $5RQuv.default), (0, $ilgD5.default));

});
parcelRegister("5RQuv", function(module, exports) {

$parcel$export(module.exports, "default", () => $12af455303df65b2$export$2e2bcd8739ae039);

var $9lqzG = parcelRequire("9lqzG");

var $yZlVL = parcelRequire("yZlVL");

var $lPiz2 = parcelRequire("lPiz2");
var $12af455303df65b2$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $lPiz2.CLEAR_RESIZING_COLUMN), ()=>(0, $9lqzG.setResizingColumn)(undefined));

});
parcelRegister("lPiz2", function(module, exports) {

$parcel$export(module.exports, "CLEAR_RESIZING_COLUMN", () => $1f0766e450a85b17$export$9939dee145f3882b);
const $1f0766e450a85b17$export$9939dee145f3882b = 'ops.columns.resizing.clear.CLEAR_RESIZING_COLUMN';
const $1f0766e450a85b17$export$42ffd38884aecdac = ()=>({
        type: $1f0766e450a85b17$export$9939dee145f3882b,
        payload: undefined
    });

});


parcelRegister("ilgD5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f16f2eb0a2181f$export$2e2bcd8739ae039);

var $9lqzG = parcelRequire("9lqzG");

var $yZlVL = parcelRequire("yZlVL");

var $2Umar = parcelRequire("2Umar");
var $c8f16f2eb0a2181f$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $2Umar.SET_RESIZING_COLUMN), (action)=>(0, $9lqzG.setResizingColumn)(action.payload));

});
parcelRegister("2Umar", function(module, exports) {

$parcel$export(module.exports, "SET_RESIZING_COLUMN", () => $e69f6aa0d1cf854c$export$9b07079645db68ce);
const $e69f6aa0d1cf854c$export$9b07079645db68ce = 'ops.columns.resizing.set.SET_RESIZING_COLUMN';
const $e69f6aa0d1cf854c$export$adaa4cf7ef1b65be = (payload)=>({
        type: $e69f6aa0d1cf854c$export$9b07079645db68ce,
        payload: payload
    });

});



parcelRegister("7cbdO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0adabca193ef69a6$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $8kOEo = parcelRequire("8kOEo");

var $er6cF = parcelRequire("er6cF");

var $b9XAO = parcelRequire("b9XAO");
var $0adabca193ef69a6$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $8kOEo.default), (0, $b9XAO.default), (0, $er6cF.default));

});
parcelRegister("8kOEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $41b0699b1bd49114$export$2e2bcd8739ae039);

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $9lqzG = parcelRequire("9lqzG");

var $atQRE = parcelRequire("atQRE");

var $a8YHd = parcelRequire("a8YHd");

var $yZlVL = parcelRequire("yZlVL");

var $4YqNK = parcelRequire("4YqNK");
var $41b0699b1bd49114$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $4YqNK.CLEAR_COLUMN_SORT_ORDER), (action, state)=>{
    const consumerState = (0, $5wAOx.getConsumerState)(state);
    const sortedRowIdsHash = (0, $a8YHd.default)((0, $kcVGc.getAddedRows)(state), (0, $kcVGc.getRowTree)(state), (0, $atQRE.getActiveSortedColumnConfiguration)(state), false, undefined, (0, $atQRE.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return [
        (0, $9lqzG.setColumnSortOrder)(undefined),
        (0, $9lqzG.setSortedRowIdsHash)(sortedRowIdsHash)
    ];
});

});
parcelRegister("a8YHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c4d500210376a41$export$2e2bcd8739ae039);

var $8dH3d = parcelRequire("8dH3d");

var $LFmXM = parcelRequire("LFmXM");

var $ejGPc = parcelRequire("ejGPc");

var $4sEy8 = parcelRequire("4sEy8");

var $7CkfO = parcelRequire("7CkfO");
var $3c4d500210376a41$export$2e2bcd8739ae039 = (0, $LFmXM.default)((lastAddedRows, lastRowTree, lastSortedColumnConfiguration, sortOverrideEnabled, activeSortedColumnConfiguration, lastSortedRowIdsHash, addedRows, rowTree, columnComparators, defaultComparator)=>{
    const newAddedRows = (0, $4sEy8.default)(lastAddedRows, addedRows);
    // bypass sorting if possible (no new added rows, rowTree didn't change, sortConfiguration didn't change)
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(newAddedRows) && lastRowTree === rowTree && lastSortedColumnConfiguration === activeSortedColumnConfiguration) return lastSortedRowIdsHash;
    return (0, $7CkfO.default)({
        rowTree: rowTree,
        columnComparators: columnComparators,
        defaultComparator: (0, $ejGPc.default)(defaultComparator, columnComparators),
        persistedAddedRows: newAddedRows,
        isSortOverrideEnabled: sortOverrideEnabled,
        activeSortedColumnConfiguration: activeSortedColumnConfiguration,
        sortedRowIdsHash: lastSortedRowIdsHash
    });
});

});
parcelRegister("4sEy8", function(module, exports) {

$parcel$export(module.exports, "default", () => $538d9fbbd73668f2$export$2e2bcd8739ae039);

var $5spib = parcelRequire("5spib");

var $LFmXM = parcelRequire("LFmXM");
var $538d9fbbd73668f2$export$2e2bcd8739ae039 = (0, $LFmXM.default)((addedRows, nextAddedRows)=>{
    if (nextAddedRows && nextAddedRows.persisted) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(nextAddedRows.persisted, (persistedRow, rowId)=>{
            if (addedRows === undefined || addedRows.persisted === undefined || addedRows.persisted[rowId] === undefined) result[rowId] = persistedRow;
        });
        return result;
    }
    return undefined;
});

});

parcelRegister("7CkfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8ec17d7e9bfdca$export$2e2bcd8739ae039);

var $75SEb = parcelRequire("75SEb");

var $5spib = parcelRequire("5spib");

var $2IQEX = parcelRequire("2IQEX");

var $5m7Wy = parcelRequire("5m7Wy");



var $9GKzm = parcelRequire("9GKzm");
const $9b8ec17d7e9bfdca$var$sort = (rowIds, sortOrder, comparator)=>[
        ...rowIds
    ].sort(comparator);
const $9b8ec17d7e9bfdca$var$sortRowIds = (rowIds, sortConfiguration, lastSortedRowIds)=>{
    if (rowIds.length === 0) return rowIds;
    const { consumerComparator: consumerComparator, sortOrder: sortOrder, isSortOverrideEnabled: isSortOverrideEnabled } = sortConfiguration;
    const sortAwareConsumerComparator = consumerComparator(sortOrder);
    // either this is the first time sorting, or the user has explicitly sorted the table
    // sort as expressed by the consumer
    if (!lastSortedRowIds || !isSortOverrideEnabled) return $9b8ec17d7e9bfdca$var$sort(rowIds, sortOrder, sortAwareConsumerComparator);
    // 2...Nth time sorting
    // any update that isn't an explicit sort we want to maintain order based on the previous
    const lastRowIdsHash = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))(lastSortedRowIds);
    const internalComparator = (rowId1, rowId2)=>{
        // both ids were already present, sort in their old older
        if (lastRowIdsHash[rowId1] !== undefined && lastRowIdsHash[rowId2] !== undefined) return Number(lastRowIdsHash[rowId1]) < Number(lastRowIdsHash[rowId2]) ? -1 : 1;
        // one of the ids is new, sort as expected by the consumer (including order)
        return sortAwareConsumerComparator(rowId1, rowId2);
    };
    return [
        ...rowIds
    ].sort(internalComparator);
};
const $9b8ec17d7e9bfdca$var$toLookupHash = (array)=>{
    if (!array) return {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hash = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))((0, (/*@__PURE__*/$parcel$interopDefault($75SEb)))(array, (element)=>!!element), // eslint-disable-next-line no-return-assign
    (element)=>hash[element] = true);
    return hash;
};
const $9b8ec17d7e9bfdca$var$getRowIdsWithoutAddedRows = (rowIds, sortConfiguration, persistedAddedRows, lastSortedRowIds)=>{
    if (sortConfiguration.isSortOverrideEnabled) {
        const lastSortedRowIdsHash = $9b8ec17d7e9bfdca$var$toLookupHash(lastSortedRowIds);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5m7Wy)))(rowIds, (rowId)=>persistedAddedRows !== undefined && persistedAddedRows[rowId] !== undefined && lastSortedRowIdsHash[rowId] === undefined);
    }
    return rowIds;
};
const $9b8ec17d7e9bfdca$var$traverseRows = (rowTree, parentRowId, rowIds, sortConfiguration, result, persistedAddedRows, sortedRowIdsHash)=>{
    if (rowIds === undefined || rowIds.length === 0) return;
    // filter out added-rows, as they shouldn't be sorted but just inserted afterwards according to their position/anchor
    const sortableRowIds = $9b8ec17d7e9bfdca$var$getRowIdsWithoutAddedRows(rowIds, sortConfiguration, persistedAddedRows, sortedRowIdsHash[parentRowId] || []);
    const sortedRowIds = $9b8ec17d7e9bfdca$var$sortRowIds(sortableRowIds, sortConfiguration, sortedRowIdsHash[parentRowId] || []);
    const reSortedRowIds = (0, $9GKzm.default)(parentRowId, sortedRowIds, rowTree, persistedAddedRows);
    // eslint-disable-next-line no-param-reassign
    result[parentRowId] = reSortedRowIds;
    reSortedRowIds.forEach((rowId)=>{
        const { childrenIds: childrenIds } = rowTree.rows[rowId];
        $9b8ec17d7e9bfdca$var$traverseRows(rowTree, rowId, childrenIds, sortConfiguration, result, persistedAddedRows, sortedRowIdsHash);
    });
};
const $9b8ec17d7e9bfdca$export$3da49b8141c52d70 = (rowTree, sortConfiguration, persistedAddedRows, sortedRowIdsHash)=>{
    const result = {};
    $9b8ec17d7e9bfdca$var$traverseRows(rowTree, (0, $ff4c22136947deab$export$59c500c4e33fdb0), rowTree.rootIds, sortConfiguration, result, persistedAddedRows, sortedRowIdsHash);
    return result;
};
const $9b8ec17d7e9bfdca$var$DEFAULT_SORT_ORDER_FOR_COMPARATORS = (0, $53724ea925cf4e57$export$6e386ac144cffab5);
const $9b8ec17d7e9bfdca$var$getSortConfiguration = (columnComparators, // @ts-expect-error - TS7006 - Parameter 'activeSortedColumnConfiguration' implicitly has an 'any' type.
activeSortedColumnConfiguration, defaultComparator, isSortOverrideEnabled)=>{
    // are we sorting by a particular comparator
    const activeSortedColumnComparator = activeSortedColumnConfiguration && columnComparators ? columnComparators[activeSortedColumnConfiguration.columnId] : undefined;
    // if we are not, use the default comparator
    const consumerComparator = activeSortedColumnComparator || defaultComparator;
    // which of the sort tri-state are we in
    // this is where the tri-state ASC/DESC/UNDEF is reduced to ASC/DESC to
    // keep the tri-state hidden from actual comparator implementations
    const sortOrder = activeSortedColumnConfiguration ? activeSortedColumnConfiguration.sortOrder : $9b8ec17d7e9bfdca$var$DEFAULT_SORT_ORDER_FOR_COMPARATORS;
    return {
        consumerComparator: consumerComparator,
        sortOrder: sortOrder,
        isSortOverrideEnabled: isSortOverrideEnabled
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9b8ec17d7e9bfdca$export$2e2bcd8739ae039 = ({ rowTree: rowTree, persistedAddedRows: persistedAddedRows, columnComparators: columnComparators, activeSortedColumnConfiguration: activeSortedColumnConfiguration, isSortOverrideEnabled: isSortOverrideEnabled, defaultComparator: defaultComparator, sortedRowIdsHash: sortedRowIdsHash })=>{
    if (!defaultComparator) return {
        [(0, $ff4c22136947deab$export$59c500c4e33fdb0)]: rowTree.rootIds
    };
    const sortConfiguration = $9b8ec17d7e9bfdca$var$getSortConfiguration(columnComparators, activeSortedColumnConfiguration, defaultComparator, isSortOverrideEnabled);
    return $9b8ec17d7e9bfdca$export$3da49b8141c52d70(rowTree, sortConfiguration, persistedAddedRows, sortedRowIdsHash);
};

});
parcelRegister("75SEb", function(module, exports) {

var $821Ou = parcelRequire("821Ou");

var $3PLp8 = parcelRequire("3PLp8");

var $1lM9j = parcelRequire("1lM9j");

var $4sprp = parcelRequire("4sprp");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $52a363cc76e51f60$var$filter(collection, predicate) {
    var func = $4sprp(collection) ? $821Ou : $3PLp8;
    return func(collection, $1lM9j(predicate, 3));
}
module.exports = $52a363cc76e51f60$var$filter;

});

parcelRegister("9GKzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1115462d349f3b5$export$2e2bcd8739ae039);

var $5spib = parcelRequire("5spib");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f1115462d349f3b5$export$2e2bcd8739ae039 = (parentRowId, baseRowIds, rowTree, anchoredRows)=>{
    if (!anchoredRows) return baseRowIds;
    const result = [
        ...baseRowIds
    ];
    // for each added row, insert based on the anchor
    (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(anchoredRows, (anchorRow, anchoredRowId)=>{
        const { anchorId: anchorId, position: position } = anchorRow;
        if (position === 'FIRST') result.unshift(anchoredRowId);
        else if (position === 'LAST') result.push(anchoredRowId);
        else if (anchorId) {
            const anchorRowLocation = result.indexOf(anchorId);
            // the anchor row may not be in the set of currently visible things
            if (anchorRowLocation !== -1) {
                if (position === 'BEFORE') result.splice(anchorRowLocation, 0, anchoredRowId);
                else if (position === 'AFTER') {
                    const spliceOffset = 1;
                    result.splice(anchorRowLocation + spliceOffset, 0, anchoredRowId);
                }
            }
            if (position === 'INSIDE' && anchorId === parentRowId) result.splice(anchorRowLocation + 1, 0, anchoredRowId);
        }
    });
    return result;
};

});




parcelRegister("er6cF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8612d2a5cdd21e35$export$2e2bcd8739ae039);

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $9lqzG = parcelRequire("9lqzG");

var $atQRE = parcelRequire("atQRE");

var $a8YHd = parcelRequire("a8YHd");

var $yZlVL = parcelRequire("yZlVL");

var $4ip2l = parcelRequire("4ip2l");
var $8612d2a5cdd21e35$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $4ip2l.RE_SORT), (action, state)=>{
    const consumerState = (0, $5wAOx.getConsumerState)(state);
    const sortedRowIdsHash = (0, $a8YHd.default)((0, $kcVGc.getAddedRows)(state), (0, $kcVGc.getRowTree)(state), undefined, false, (0, $atQRE.getActiveSortedColumnConfiguration)(state), (0, $atQRE.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return [
        (0, $9lqzG.setSortedRowIdsHash)(sortedRowIdsHash)
    ];
});

});
parcelRegister("4ip2l", function(module, exports) {

$parcel$export(module.exports, "RE_SORT", () => $23c9fe17463f0797$export$e43c6499ab033999);
const $23c9fe17463f0797$export$e43c6499ab033999 = 'ops.columns.sorting.re-sort.RE_SORT';
const $23c9fe17463f0797$export$8f208e436e07f92 = ()=>({
        type: $23c9fe17463f0797$export$e43c6499ab033999
    });

});


parcelRegister("b9XAO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c4121304cedbf8d$export$2e2bcd8739ae039);

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $9lqzG = parcelRequire("9lqzG");

var $atQRE = parcelRequire("atQRE");

var $a8YHd = parcelRequire("a8YHd");

var $yZlVL = parcelRequire("yZlVL");

var $9StD7 = parcelRequire("9StD7");
var $9c4121304cedbf8d$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $9StD7.SET_COLUMN_SORT_ORDER), (action, state)=>{
    const consumerState = (0, $5wAOx.getConsumerState)(state);
    const sortedRowIdsHash = (0, $a8YHd.default)((0, $kcVGc.getAddedRows)(state), (0, $kcVGc.getRowTree)(state), (0, $atQRE.getActiveSortedColumnConfiguration)(state), false, action.payload, (0, $atQRE.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return [
        (0, $9lqzG.setColumnSortOrder)(action.payload),
        (0, $9lqzG.setSortedRowIdsHash)(sortedRowIdsHash)
    ];
});

});



parcelRegister("3ECq0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd718ac610c25f0$export$2e2bcd8739ae039);
parcelRequire("1o2WJ");
parcelRequire("c1D7V");

var $9lqzG = parcelRequire("9lqzG");

var $gnn0l = parcelRequire("gnn0l");

var $ij4ku = parcelRequire("ij4ku");

var $aRLtR = parcelRequire("aRLtR");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$4cd718ac610c25f0$export$2e2bcd8739ae039 = (action$)=>{
    const errorHandler = (0, $ij4ku.errorHandlerFactory)();
    return (0, $gnn0l.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $aRLtR.SET_HEADER_HEIGHT))// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
    .map((action)=>(0, $9lqzG.setHeaderHeight)(action.payload)).catch(errorHandler);
};

});
parcelRegister("gnn0l", function(module, exports) {

$parcel$export(module.exports, "withUnpackedBatchActions", () => $8cc8314a83de6abb$export$25f000f90e13af6b);

var $dFg4o = parcelRequire("dFg4o");
parcelRequire("9BkTq");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");
const $8cc8314a83de6abb$export$25f000f90e13af6b = (action$)=>action$.mergeMap((action)=>{
        if (action.type === (0, $dFg4o.BATCH)) return (0, $7kixv.Observable).of(...action.payload);
        return (0, $7kixv.Observable).of(action);
    });

});


parcelRegister("dn0XZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a99b171bcc0f31ce$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $5W9rF = parcelRequire("5W9rF");

var $eXKhU = parcelRequire("eXKhU");
var $a99b171bcc0f31ce$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $5W9rF.default), (0, $eXKhU.default));

});
parcelRegister("5W9rF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6819472195ed2970$export$2e2bcd8739ae039);

var $gUIuO = parcelRequire("gUIuO");

var $kcVGc = parcelRequire("kcVGc");

var $9lqzG = parcelRequire("9lqzG");

var $atQRE = parcelRequire("atQRE");

var $a8YHd = parcelRequire("a8YHd");

var $yZlVL = parcelRequire("yZlVL");

var $aRLtR = parcelRequire("aRLtR");

var $2rAuq = parcelRequire("2rAuq");

var $4d9Fy = parcelRequire("4d9Fy");
const $6819472195ed2970$var$getScrollbarSize = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body) {
        const { body: body } = document;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const scrollbarContainer = document.createElement('div');
        scrollbarContainer.setAttribute('style', `position: absolute;
             width: 100px;
             height: 100px;
             overflow: scroll;
             top: -9999px;`);
        body.appendChild(scrollbarContainer);
        // Pick arbitrary axis, both should have the same bar size
        const scrollbarSize = scrollbarContainer.offsetWidth - scrollbarContainer.clientWidth;
        body.removeChild(scrollbarContainer);
        return scrollbarSize;
    }
    return 0;
};
var $6819472195ed2970$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $4d9Fy.SET_STATE_FROM_PROPS), (action, state)=>{
    const { apiState: apiState, theme: theme } = action.payload;
    const { defaultSortedColumn: defaultSortedColumn, ...consumerState } = apiState;
    const sortedRowIdsHash = (0, $a8YHd.default)((0, $kcVGc.getAddedRows)(state), (0, $kcVGc.getRowTree)(state), (0, $atQRE.getActiveSortedColumnConfiguration)(state), (0, $atQRE.getIsSortOverrideEnabled)(state), defaultSortedColumn, (0, $atQRE.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    const setActions = [
        (0, $gUIuO.setConsumerState)(consumerState),
        (0, $9lqzG.setSortedRowIdsHash)(sortedRowIdsHash),
        (0, $aRLtR.set)(theme.header.height),
        (0, $2rAuq.set)(theme.row.borderWidth)
    ];
    if (consumerState.autoRowHeight) // @ts-expect-error - TS2345 - Argument of type 'SetScrollbarSizeAction' is not assignable to parameter of type 'SetSortedRowIdsHashAction | SetHeaderHeightAction | SetConsumerStateAction | SetRowBorderWidthAction'.
    setActions.push((0, $9lqzG.setScrollbarSize)($6819472195ed2970$var$getScrollbarSize()));
    if (defaultSortedColumn) // @ts-expect-error - TS2345 - Argument of type 'SetColumnSortOrderAction' is not assignable to parameter of type 'SetSortedRowIdsHashAction | SetHeaderHeightAction | SetConsumerStateAction | SetRowBorderWidthAction'.
    setActions.push((0, $9lqzG.setColumnSortOrder)(defaultSortedColumn));
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return setActions;
});

});
parcelRegister("gUIuO", function(module, exports) {

$parcel$export(module.exports, "SET_CONSUMER_STATE", () => $e4e00565ca797df1$export$56c40290cf7dd948);
$parcel$export(module.exports, "setConsumerState", () => $e4e00565ca797df1$export$9444caca88c67753);
const $e4e00565ca797df1$export$56c40290cf7dd948 = 'state.consumer.SET_CONSUMER_STATE';
const $e4e00565ca797df1$export$9444caca88c67753 = (payload)=>({
        type: $e4e00565ca797df1$export$56c40290cf7dd948,
        payload: payload
    });

});

parcelRegister("2rAuq", function(module, exports) {

$parcel$export(module.exports, "SET_ROW_BORDER_WIDTH", () => $687d575b38527bfd$export$a347b798ae4b070c);
$parcel$export(module.exports, "set", () => $687d575b38527bfd$export$adaa4cf7ef1b65be);
const $687d575b38527bfd$export$a347b798ae4b070c = 'ops.rows.row-border.SET_ROW_BORDER_WIDTH';
const $687d575b38527bfd$export$adaa4cf7ef1b65be = (width)=>({
        type: $687d575b38527bfd$export$a347b798ae4b070c,
        payload: width
    });

});


parcelRegister("eXKhU", function(module, exports) {

$parcel$export(module.exports, "default", () => $626c1a32c667809e$export$2e2bcd8739ae039);

var $cSmYj = parcelRequire("cSmYj");

var $gUIuO = parcelRequire("gUIuO");

var $2Ctxl = parcelRequire("2Ctxl");

var $5wAOx = parcelRequire("5wAOx");

var $kcVGc = parcelRequire("kcVGc");

var $9lqzG = parcelRequire("9lqzG");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $a8YHd = parcelRequire("a8YHd");

var $yZlVL = parcelRequire("yZlVL");

var $4Mvfe = parcelRequire("4Mvfe");

var $3Smvh = parcelRequire("3Smvh");
const $626c1a32c667809e$var$getActiveRowSync = (state, consumerState)=>{
    if ((0, $5wAOx.isInRowNavigationMode)(state)) {
        const activeRowIndex = (0, $fRJOe.getActiveRowIndex)(state);
        const { rootIds: rootIds } = consumerState.rowTree;
        if (consumerState.contentKey !== state.consumer.contentKey) return [
            (0, $9lqzG.clearActiveItem)()
        ];
        if (activeRowIndex !== undefined) {
            if (!rootIds.length) return [
                (0, $9lqzG.clearActiveItem)()
            ];
            if (rootIds[activeRowIndex] === undefined) return [
                (0, $4Mvfe.setActiveRow)({
                    rowIndex: rootIds.length - 1
                })
            ];
            // Causes the row to refocus in the case that it is rerendered
            return [
                (0, $4Mvfe.setActiveRow)({
                    rowIndex: activeRowIndex,
                    setFocusOnRow: true
                })
            ];
        }
    }
    return [];
};
const $626c1a32c667809e$var$isSameColumnSet = (state, nextColumns)=>{
    const prevColumnIds = (0, $2Ctxl.getAllColumnIds)(state);
    const nextColumnIds = nextColumns.map((column)=>column.id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(new Set([
        prevColumnIds
    ]), new Set([
        nextColumnIds
    ]));
};
// Strictly speaking the property we care about is the that the width of
// multiline columns is unchanged, as this may in turn influence cell height
// if any multi-line column is present.
//
// Invalidating this isn't essential, but may save briefly underbuffering w/
// virtualisation.  Hence we use the same set of columns as a proxy for change
// to multiline column width.
const $626c1a32c667809e$var$isRowHeightMapStale = (state, nextColumns)=>!$626c1a32c667809e$var$isSameColumnSet(state, nextColumns) && (0, $2Ctxl.hasAnyMultiLineColumn)(state);
const $626c1a32c667809e$var$getRowHeightMappingInvalidation = (state, consumerState)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const nextColumns = Object.values(consumerState.columnTree.columns);
    if ($626c1a32c667809e$var$isRowHeightMapStale(state, nextColumns)) return [
        (0, $9lqzG.clearRowHeightMapping)()
    ];
    return [];
};
const $626c1a32c667809e$var$getConditionalActions = (state, consumerState)=>[
        ...$626c1a32c667809e$var$getActiveRowSync(state, consumerState),
        ...$626c1a32c667809e$var$getRowHeightMappingInvalidation(state, consumerState)
    ];
var $626c1a32c667809e$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $3Smvh.UPDATE_STATE_FROM_PROPS), (action, state)=>{
    const { defaultSortedColumn: defaultSortedColumn, ...consumerState } = action.payload;
    const sortedRowIdsHash = (0, $a8YHd.default)((0, $kcVGc.getAddedRows)(state), (0, $kcVGc.getRowTree)(state), (0, $atQRE.getActiveSortedColumnConfiguration)(state), true, (0, $atQRE.getActiveSortedColumnConfiguration)(state), (0, $atQRE.getSortedRowIdsHash)(state), consumerState.addedRows, consumerState.rowTree, consumerState.columnComparators, consumerState.defaultComparator);
    consumerState.callbacks.onSortedRowIdsChanged && consumerState.callbacks.onSortedRowIdsChanged(sortedRowIdsHash);
    return [
        (0, $gUIuO.setConsumerState)(consumerState),
        ...$626c1a32c667809e$var$getConditionalActions(state, action.payload),
        (0, $9lqzG.setSortOrderWithOverride)({
            isSortOverrideEnabled: true
        }),
        (0, $9lqzG.setSortedRowIdsHash)(sortedRowIdsHash)
    ];
});

});


parcelRegister("dl96d", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d49b0ef7785fed$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $gNv85 = parcelRequire("gNv85");
var $c8d49b0ef7785fed$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $gNv85.default));

});
parcelRegister("gNv85", function(module, exports) {

$parcel$export(module.exports, "default", () => $176802176362e064$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $3bOAW = parcelRequire("3bOAW");

var $jtsfx = parcelRequire("jtsfx");
var $176802176362e064$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $3bOAW.default), (0, $jtsfx.default));

});
parcelRegister("3bOAW", function(module, exports) {

$parcel$export(module.exports, "default", () => $67b2bc29830661d5$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");
parcelRequire("1h54Q");
parcelRequire("1o2WJ");
parcelRequire("hfuHK");
parcelRequire("d2zWP");

var $5wAOx = parcelRequire("5wAOx");

var $9lqzG = parcelRequire("9lqzG");

var $4Mvfe = parcelRequire("4Mvfe");

var $9Zs47 = parcelRequire("9Zs47");
var /* We don't want a cell to blur if we are only doing so to focus another cell. */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$67b2bc29830661d5$export$2e2bcd8739ae039 = (action, // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>action.ofType((0, $9Zs47.CLEAR_ACTIVE_ITEM)).switchMap(()=>(0, $7kixv.Observable).timer(50).map(()=>{
            (0, $5wAOx.getActiveItemChangedCallback)(store.getState())(undefined);
            const getActiveRowIdChanged = (0, $5wAOx.getActiveRowIdChangedCallback)(store.getState());
            if (getActiveRowIdChanged != null) getActiveRowIdChanged(undefined);
            return (0, $9lqzG.clearActiveItem)();
        }).takeUntil(action.ofType((0, $4Mvfe.SET_ACTIVE_CELL), (0, $4Mvfe.SET_ACTIVE_ROW))));

});

parcelRegister("jtsfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e90b1f7c2078298e$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("6cJUr");
parcelRequire("c1D7V");

var $4tM8k = parcelRequire("4tM8k");

var $7kixv = parcelRequire("7kixv");

var $5wAOx = parcelRequire("5wAOx");

var $9lqzG = parcelRequire("9lqzG");

var $fRJOe = parcelRequire("fRJOe");

var $gnn0l = parcelRequire("gnn0l");

var $ij4ku = parcelRequire("ij4ku");

var $yZlVL = parcelRequire("yZlVL");

var $4Mvfe = parcelRequire("4Mvfe");
const $e90b1f7c2078298e$export$4237cfdec709360b = (0, $yZlVL.defineTransaction)((0, $4Mvfe.SET_ACTIVE_CELL), (action)=>(0, $9lqzG.setActiveItem)(action.payload));
const $e90b1f7c2078298e$export$436fa03bfc3ce94c = (action$, store)=>{
    const errorHandler = (0, $ij4ku.errorHandlerFactory)();
    return (0, $gnn0l.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $4Mvfe.SET_ACTIVE_ROW))// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
    .mergeMap((action)=>{
        const state = store.getState();
        const activeRowIdChanged = (0, $5wAOx.getActiveRowIdChangedCallback)(state);
        if (activeRowIdChanged != null) {
            const activeRowId = (0, $fRJOe.rowIndexToRowId)(state, action.payload.rowIndex);
            activeRowIdChanged(activeRowId);
        }
        return (0, $7kixv.Observable).of((0, $9lqzG.setActiveItem)(action.payload));
    }).catch(errorHandler);
};
var $e90b1f7c2078298e$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)($e90b1f7c2078298e$export$4237cfdec709360b, $e90b1f7c2078298e$export$436fa03bfc3ce94c);

});



parcelRegister("cvOmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7caf9497362a9545$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $lpHQZ = parcelRequire("lpHQZ");

var $arGuZ = parcelRequire("arGuZ");

var $9tWjM = parcelRequire("9tWjM");

var $fYHN4 = parcelRequire("fYHN4");

var $20SvL = parcelRequire("20SvL");
var $7caf9497362a9545$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $lpHQZ.default), (0, $9tWjM.default), (0, $20SvL.default), (0, $fYHN4.default), (0, $arGuZ.default));

});
parcelRegister("lpHQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $73005ef75b0880b7$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $4dbGj = parcelRequire("4dbGj");

var $jBLrW = parcelRequire("jBLrW");
var $73005ef75b0880b7$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $jBLrW.default), (0, $4dbGj.default));

});
parcelRegister("4dbGj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dd353586372f159$export$2e2bcd8739ae039);

var $9lqzG = parcelRequire("9lqzG");

var $yZlVL = parcelRequire("yZlVL");

var $cV9Yw = parcelRequire("cV9Yw");
var $6dd353586372f159$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $cV9Yw.CLEAR_MULTI_ADD_ANCHOR), ()=>(0, $9lqzG.clearMultiAddAnchor)());

});
parcelRegister("cV9Yw", function(module, exports) {

$parcel$export(module.exports, "CLEAR_MULTI_ADD_ANCHOR", () => $85897db76f973ba3$export$28f3def567195a3c);
const $85897db76f973ba3$export$28f3def567195a3c = 'ops.rows.add-anchor.clear.CLEAR_MULTI_ADD_ANCHOR';
const $85897db76f973ba3$export$42ffd38884aecdac = ()=>({
        type: $85897db76f973ba3$export$28f3def567195a3c
    });

});


parcelRegister("jBLrW", function(module, exports) {

$parcel$export(module.exports, "default", () => $94f4a9facc9f36ee$export$2e2bcd8739ae039);

var $9lqzG = parcelRequire("9lqzG");

var $yZlVL = parcelRequire("yZlVL");

var $b5S8m = parcelRequire("b5S8m");
var $94f4a9facc9f36ee$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $b5S8m.SET_MULTI_ADD_ANCHOR), (action)=>(0, $9lqzG.setMultiAddAnchor)(action.payload));

});


parcelRegister("arGuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c28bcbfe5050bdc$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("lSGp8");
parcelRequire("7La6O");
parcelRequire("d2zWP");

var $7kixv = parcelRequire("7kixv");

var $aKfba = parcelRequire("aKfba");

var $kcVGc = parcelRequire("kcVGc");

var $fRJOe = parcelRequire("fRJOe");

var $4ped1 = parcelRequire("4ped1");
// Buffer all loading row analytics events for 15s and fire as one event
const $8c28bcbfe5050bdc$var$BUFFER_TIME = 15000;
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$8c28bcbfe5050bdc$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $4ped1.FIRE_LOADING_ROW_ANALYTICS)).bufferTime($8c28bcbfe5050bdc$var$BUFFER_TIME).do((actions)=>{
        const eventAttributes = [];
        let lastAnalyticsEvent;
        actions.forEach((action)=>{
            const { rowId: rowId, timeVisibleFor: timeVisibleFor, numberOfLoadingRows: numberOfLoadingRows, reasonType: reasonType, analyticsEvent: analyticsEvent } = action.payload;
            const state = store.getState();
            const { displayStart: displayStart, displayEnd: displayEnd } = (0, $fRJOe.getVirtualBoundaries)(state);
            // check if the rowId was removed from the tree due to row data update
            const rowStillExists = !!(0, $kcVGc.getRow)(state, rowId);
            // check if the row, if exists, is still in 'loading' state
            const isStillLoading = rowStillExists && (0, $kcVGc.isRowLoading)(state, rowId);
            // check if the row is in the display boundary
            const intRowId = parseInt(rowId, 10);
            const isInDisplayBoundary = intRowId >= 0 && intRowId >= displayStart && intRowId <= displayEnd;
            // gather all event attributes into one for all the events fired within BUFFER_TIME
            eventAttributes.push({
                displayStart: displayStart,
                displayEnd: displayEnd,
                numberOfLoadingRows: numberOfLoadingRows,
                reasonType: reasonType,
                timeVisibleFor: timeVisibleFor,
                rowIdStillExists: !!rowStillExists,
                isInDisplayBoundary: isInDisplayBoundary,
                gotFulfilled: !isStillLoading
            });
            lastAnalyticsEvent = analyticsEvent;
        });
        // fire the event
        lastAnalyticsEvent && (0, $aKfba.fireOperationalAnalytics)(lastAnalyticsEvent, {
            containerType: 'loadingRow',
            attributes: {
                eventAttributes: eventAttributes
            }
        });
    }).switchMap(()=>(0, $7kixv.Observable).empty());

});

parcelRegister("9tWjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbc3dd75182120d0$export$2e2bcd8739ae039);


var $fRJOe = parcelRequire("fRJOe");

var $yZlVL = parcelRequire("yZlVL");

var $4Mvfe = parcelRequire("4Mvfe");

var $dZqHT = parcelRequire("dZqHT");
const $cbc3dd75182120d0$var$getNextRowIndex = (state, direction)=>{
    switch(direction){
        case 0, $7e33285e7fb1fa6b$export$b29f845fa4b57508:
            return (0, $fRJOe.getPrevActiveRowIndex)(state);
        case 0, $7e33285e7fb1fa6b$export$c7c029a231f98d34:
            return (0, $fRJOe.getNextActiveRowIndex)(state);
        default:
            throw new Error('illegal value of the direction property.');
    }
};
var $cbc3dd75182120d0$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $dZqHT.NAVIGATE_TO_ROW), (action, state)=>(0, $4Mvfe.setActiveRow)({
        rowIndex: $cbc3dd75182120d0$var$getNextRowIndex(state, action.payload.direction),
        setFocusOnRow: true
    }));

});

parcelRegister("fYHN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8aa5fea587c9218$export$2e2bcd8739ae039);
parcelRequire("1o2WJ");
parcelRequire("c1D7V");

var $9lqzG = parcelRequire("9lqzG");

var $gnn0l = parcelRequire("gnn0l");

var $ij4ku = parcelRequire("ij4ku");

var $2rAuq = parcelRequire("2rAuq");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$a8aa5fea587c9218$export$2e2bcd8739ae039 = (action$)=>{
    const errorHandler = (0, $ij4ku.errorHandlerFactory)();
    return (0, $gnn0l.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $2rAuq.SET_ROW_BORDER_WIDTH))// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
    .map((action)=>(0, $9lqzG.setRowBorderWidth)(action.payload)).catch(errorHandler);
};

});

parcelRegister("20SvL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5477bd6b2dc3ab1$export$2e2bcd8739ae039);

var $9lqzG = parcelRequire("9lqzG");

var $yZlVL = parcelRequire("yZlVL");

var $5EfBD = parcelRequire("5EfBD");
const $b5477bd6b2dc3ab1$var$batchUpdateRowHeightMappingEpic = (0, $yZlVL.defineTransaction)((0, $5EfBD.BATCH_UPDATE_ROW_HEIGHT_MAPPING), (action)=>(0, $9lqzG.batchUpdateRowHeightMapping)(action.payload.rowIds, action.payload.rowHeightMapping));
var $b5477bd6b2dc3ab1$export$2e2bcd8739ae039 = $b5477bd6b2dc3ab1$var$batchUpdateRowHeightMappingEpic;

});


parcelRegister("cdOxK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b382fd5ef9e7092$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $6kXuH = parcelRequire("6kXuH");

var $4aGC3 = parcelRequire("4aGC3");

var $h5cnO = parcelRequire("h5cnO");

var $iiu67 = parcelRequire("iiu67");

var $5WFYr = parcelRequire("5WFYr");
var $0b382fd5ef9e7092$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $4aGC3.default), (0, $5WFYr.default), (0, $6kXuH.default), (0, $iiu67.default), (0, $h5cnO.default));

});
parcelRegister("6kXuH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b34e4415f33bf5a$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("hnYRz");
parcelRequire("6cJUr");
parcelRequire("c1D7V");

var $4tM8k = parcelRequire("4tM8k");

var $7kixv = parcelRequire("7kixv");

var $gUIuO = parcelRequire("gUIuO");

var $5wAOx = parcelRequire("5wAOx");

var $9lqzG = parcelRequire("9lqzG");

var $fRJOe = parcelRequire("fRJOe");

var $gnn0l = parcelRequire("gnn0l");

var $ij4ku = parcelRequire("ij4ku");
const $1b34e4415f33bf5a$var$DEBOUNCE_MILLIS = 100;
const $1b34e4415f33bf5a$var$handleOffsetChange = (store)=>{
    const state = store.getState();
    const onHorizontalScrollOffsetChanged = (0, $5wAOx.getHorizontalScrollOffsetChangedCallback)(state);
    if (onHorizontalScrollOffsetChanged) {
        const offsetFromLeft = (0, $fRJOe.getOffsetFromLeft)(state);
        const offsetFromRight = (0, $fRJOe.getOffsetFromRight)(state);
        onHorizontalScrollOffsetChanged({
            offsetFromLeft: offsetFromLeft,
            offsetFromRight: offsetFromRight
        });
    }
    return (0, $7kixv.Observable).empty();
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1b34e4415f33bf5a$var$debouncedEpic = (action$, store)=>{
    const errorHandler = (0, $ij4ku.errorHandlerFactory)();
    return (0, $gnn0l.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $9lqzG.SET_HORIZONTAL_SCROLL_OFFSET), (0, $9lqzG.SET_TABLE_SIZE)).debounceTime($1b34e4415f33bf5a$var$DEBOUNCE_MILLIS).mergeMap(()=>$1b34e4415f33bf5a$var$handleOffsetChange(store)).catch(errorHandler);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1b34e4415f33bf5a$var$consumerStateEpic = (action$, store)=>{
    const errorHandler = (0, $ij4ku.errorHandlerFactory)();
    return (0, $gnn0l.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $gUIuO.SET_CONSUMER_STATE)).mergeMap(()=>$1b34e4415f33bf5a$var$handleOffsetChange(store)).catch(errorHandler);
};
var $1b34e4415f33bf5a$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)($1b34e4415f33bf5a$var$debouncedEpic, $1b34e4415f33bf5a$var$consumerStateEpic);

});

parcelRegister("4aGC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d770503521ff956e$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");
parcelRequire("9BkTq");
parcelRequire("baP6E");
parcelRequire("6cJUr");
parcelRequire("c1D7V");

var $9lqzG = parcelRequire("9lqzG");

var $atQRE = parcelRequire("atQRE");

var $ij4ku = parcelRequire("ij4ku");

var $3z7Cz = parcelRequire("3z7Cz");
const $d770503521ff956e$var$errorHandler = (0, $ij4ku.errorHandlerFactory)();
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$d770503521ff956e$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $3z7Cz.SET_SCROLL_OFFSET))// @ts-expect-error - TS2345 - Argument of type '(action: SetScrollOffsetAction) => Observable<SetVerticalScrollOffsetAction | SetVerticalScrollDeltaAction> | Observable<...>' is not assignable to parameter of type '(value: SetScrollOffsetAction, index: number) => ObservableInput<SetVerticalScrollOffsetAction | SetVerticalScrollDeltaAction>'.
    .mergeMap((action)=>{
        if (action.payload.direction === 'VERTICAL') {
            const lastPos = (0, $atQRE.getVerticalScrollOffset)(store.getState());
            const delta = lastPos - action.payload.offset;
            return (0, $7kixv.Observable).concat((0, $7kixv.Observable).of((0, $9lqzG.setVerticalScrollOffset)(action.payload.offset)), (0, $7kixv.Observable).of((0, $9lqzG.setVerticalScrollDelta)(delta)));
        }
        if (action.payload.direction === 'HORIZONTAL') return (0, $7kixv.Observable).of((0, $9lqzG.setHorizontalScrollOffset)(action.payload.offset));
        throw new Error(`The direction property ${action.payload.direction} value is illegal.`);
    }).catch($d770503521ff956e$var$errorHandler);

});

parcelRegister("h5cnO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee026061c320bd83$export$2e2bcd8739ae039);

var $9lqzG = parcelRequire("9lqzG");

var $yZlVL = parcelRequire("yZlVL");

var $5I3Lx = parcelRequire("5I3Lx");
var $ee026061c320bd83$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $5I3Lx.SET_SCROLLBAR_SIZE), (action)=>(0, $9lqzG.setScrollbarSize)(action.payload));

});

parcelRegister("iiu67", function(module, exports) {

$parcel$export(module.exports, "default", () => $88ce1f4229c23a87$export$2e2bcd8739ae039);


var $2Ctxl = parcelRequire("2Ctxl");

var $9lqzG = parcelRequire("9lqzG");

var $fRJOe = parcelRequire("fRJOe");

var $02dWc = parcelRequire("02dWc");

var $yZlVL = parcelRequire("yZlVL");

var $kMKvn = parcelRequire("kMKvn");
var $88ce1f4229c23a87$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $kMKvn.SCROLL_TO_ROW), (action, state)=>{
    const rowIds = (0, $02dWc.getFlattenedWithAddedRowIds)(state);
    const rowIndex = rowIds.indexOf(action.payload);
    // if row is invalid/not visible then clear the active item
    if (rowIndex === -1) return (0, $9lqzG.clearActiveItem)();
    // A row is 36px high, including the 1px border. These borders
    // overlap leading to an offset height for scrolling as 36px - 1px
    return [
        (0, $9lqzG.setActiveItem)({
            type: (0, $1d080e9e60c37b43$export$4b3489234fd17200),
            rowId: action.payload,
            columnId: (0, $2Ctxl.getVisibleCoreColumnIds)(state)[0]
        }),
        (0, $9lqzG.setVerticalScrollOffset)((0, $fRJOe.getScrollOffsetForRowIndex)(state, rowIndex))
    ];
});

});

parcelRegister("5WFYr", function(module, exports) {

$parcel$export(module.exports, "default", () => $79a9a8ba43bf749a$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("hnYRz");
parcelRequire("6cJUr");
parcelRequire("c1D7V");

var $7kixv = parcelRequire("7kixv");

var $gUIuO = parcelRequire("gUIuO");

var $5wAOx = parcelRequire("5wAOx");

var $9lqzG = parcelRequire("9lqzG");

var $fRJOe = parcelRequire("fRJOe");

var $gnn0l = parcelRequire("gnn0l");

var $ij4ku = parcelRequire("ij4ku");
const $79a9a8ba43bf749a$var$DEBOUNCE_MILLIS = 16;
var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$79a9a8ba43bf749a$export$2e2bcd8739ae039 = (action$, store)=>{
    const errorHandler = (0, $ij4ku.errorHandlerFactory)();
    return (0, $gnn0l.withUnpackedBatchActions)(action$)// @ts-expect-error - TS2339 - Property 'ofType' does not exist on type 'Observable<any>'.
    .ofType((0, $9lqzG.SET_VERTICAL_SCROLL_OFFSET), (0, $9lqzG.SET_TABLE_SIZE), (0, $gUIuO.SET_CONSUMER_STATE)).debounceTime($79a9a8ba43bf749a$var$DEBOUNCE_MILLIS).mergeMap(()=>{
        const state = store.getState();
        const onVerticalScrollOffsetChanged = (0, $5wAOx.getVerticalScrollOffsetChangedCallback)(state);
        if (onVerticalScrollOffsetChanged) {
            const virtualBoundaries = (0, $fRJOe.getVirtualBoundaries)(state);
            onVerticalScrollOffsetChanged({
                ...virtualBoundaries,
                offsetFromTop: (0, $fRJOe.getOffsetFromTop)(state),
                offsetFromBottom: (0, $fRJOe.getOffsetFromBottom)(state)
            });
        }
        return (0, $7kixv.Observable).empty();
    }).catch(errorHandler);
};

});


parcelRegister("cLn2f", function(module, exports) {

$parcel$export(module.exports, "default", () => $42b976011fb38ab4$export$2e2bcd8739ae039);

var $9lqzG = parcelRequire("9lqzG");

var $yZlVL = parcelRequire("yZlVL");

var $3kmxb = parcelRequire("3kmxb");
var $42b976011fb38ab4$export$2e2bcd8739ae039 = (0, $yZlVL.defineTransaction)((0, $3kmxb.SET_TABLE_SIZE), (action)=>(0, $9lqzG.setTableSize)(action.payload));

});


parcelRegister("du5pn", function(module, exports) {

$parcel$export(module.exports, "default", () => $11fda144c47939e2$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $5HEhn = parcelRequire("5HEhn");

var $9vAxP = parcelRequire("9vAxP");
var $11fda144c47939e2$export$2e2bcd8739ae039 = (0, $7HHI1.combineReducers)({
    consumer: $5HEhn.default,
    internal: $9vAxP.default
});

});
parcelRegister("5HEhn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4de1f804f44a3067$export$2e2bcd8739ae039);


var $gUIuO = parcelRequire("gUIuO");
const $4de1f804f44a3067$var$initialState = {
    maxDepth: 0,
    addLinkCaption: undefined,
    DetailsPanelComponent: undefined,
    NonTemporaryCellWrapper: undefined,
    autoHeight: true,
    showShadowAtBottom: false,
    navigationMode: (0, $1d080e9e60c37b43$export$8ea4ff4da61b68e4),
    rowTree: {
        rows: {},
        rootIds: []
    },
    rowsConfiguration: {},
    addedRows: undefined,
    expandedRowIds: [],
    columnTree: {
        columns: {},
        rootCoreIds: [],
        rootAdditionalIds: []
    },
    expandedColumnIds: [],
    columnWidths: {},
    sortedColumnIds: undefined,
    draggableColumns: false,
    LoadingRowComponent: undefined,
    callbacks: {},
    ariaLabel: undefined
};
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$4de1f804f44a3067$export$2e2bcd8739ae039 = (state = $4de1f804f44a3067$var$initialState, action)=>{
    switch(action.type){
        case 0, $gUIuO.SET_CONSUMER_STATE:
            return action.payload;
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});



parcelRegister("aiVOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c7b69fb7c3fe65$export$2e2bcd8739ae039);

var $12DRg = parcelRequire("12DRg");

var $LFmXM = parcelRequire("LFmXM");

var $7jTnu = parcelRequire("7jTnu");



var $8l3H6 = parcelRequire("8l3H6");
const $67c7b69fb7c3fe65$var$getValueOrFallback = (value, fallback)=>value === undefined ? fallback : value;
const $67c7b69fb7c3fe65$var$traverseColumns = (columns, columnMap, parentChildrenIds)=>{
    columns.forEach((column)=>{
        let childrenIds;
        // eslint-disable-next-line no-param-reassign
        columnMap[column.id] = {
            id: column.id,
            title: column.title,
            HeaderComponent: column.HeaderComponent,
            tooltip: column.tooltip,
            defaultWidth: column.minWidth,
            minWidth: column.minWidth,
            maxWidth: column.maxWidth,
            // FSN-4987 Remove resize strategy related logic during cleanup
            resizeStrategy: (0, $53724ea925cf4e57$export$4670af9f718b9e66),
            isHideable: false,
            isDraggable: false,
            isMarkup: false,
            isDefaultAdd: false,
            color: undefined,
            childrenIds: childrenIds,
            parentId: undefined,
            canBeMultiLine: $67c7b69fb7c3fe65$var$getValueOrFallback(column.canBeMultiLine, false),
            CellComponent: column.CellComponent
        };
        parentChildrenIds.push(column.id);
    });
};
const $67c7b69fb7c3fe65$var$transformColumns = (0, $LFmXM.default)((columns)=>{
    const columnTree = {
        columns: {},
        rootCoreIds: [],
        rootAdditionalIds: []
    };
    $67c7b69fb7c3fe65$var$traverseColumns(columns, columnTree.columns, columnTree.rootAdditionalIds);
    return columnTree;
});
const $67c7b69fb7c3fe65$var$transformRows = (0, $LFmXM.default)((rowIds)=>{
    const rowTree = {
        rootIds: [],
        rows: {}
    };
    rowIds.forEach((id)=>{
        if (!rowTree.rows[id]) rowTree.rows[id] = {
            id: id,
            parentId: undefined,
            childrenIds: []
        };
        // we've reached the root, add ourselves to rootIds
        rowTree.rootIds.push(id);
    });
    return rowTree;
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$67c7b69fb7c3fe65$export$2e2bcd8739ae039 = (props)=>({
        // Table general
        facade: (0, $bce106de39319478$export$88a597d0c7ae97b),
        maxDepth: 0,
        DetailsPanelComponent: undefined,
        NonTemporaryCellWrapper: props.NonTemporaryCellWrapper,
        autoHeight: false,
        showDecalAtBottom: props.showDecalAtBottom,
        navigationMode: props.navigationMode,
        addLinkCaption: undefined,
        addedRows: undefined,
        isContentStale: props.isContentStale,
        shouldSkipVirtualization: props.shouldSkipVirtualization,
        shouldHideLoadingIndicator: props.shouldHideLoadingIndicator,
        shouldRerenderRowOnHover: props.shouldRerenderRowOnHover,
        contentKey: props.contentKey,
        ariaLabel: props.ariaLabel,
        // Rows
        rowTree: $67c7b69fb7c3fe65$var$transformRows(props.rowIds),
        rowsConfiguration: props.rowsConfiguration,
        rowHeight: props.defaultRowHeight,
        autoRowHeight: props.autoRowHeight,
        draggableRows: props.draggableRows,
        defaultComparator: undefined,
        expandedRowIds: [],
        // @ts-expect-error - TS2322 - Type 'ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }' is not assignable to type 'Optional<LoadingRowComponent>'.
        LoadingRowComponent: (0, $8l3H6.default),
        disableRowHighlight: props.disableRowHighlight,
        // Columns
        columnTree: $67c7b69fb7c3fe65$var$transformColumns(props.columns),
        expandedColumnIds: props.expandedColumnIds,
        columnWidths: props.columnWidths,
        hiddenColumnIds: [],
        minAdditionalColumnsWidth: 0,
        defaultSortedColumn: undefined,
        columnComparators: {},
        sortedColumnIds: undefined,
        draggableColumns: false,
        premiumSLAColumnIds: props.premiumSLAColumnIds,
        // Columns having currentSorting prop
        ...(0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') ? {
            persistedStoreColumns: props.persistedStoreColumns
        } : {},
        callbacks: {
            onActiveRowIdChanged: props.onActiveRowIdChanged,
            onActiveItemChanged: props.onActiveItemChanged,
            onDisplayedRowsChanged: props.onDisplayedRowsChanged,
            onVerticalScrollOffsetChanged: props.onVerticalScrollOffsetChanged,
            onHorizontalScrollOffsetChanged: props.onHorizontalScrollOffsetChanged,
            onRowListFocusFunctionChanged: props.onRowListFocusFunctionChanged,
            onReactPortalContainerRefChanged: props.onReactPortalContainerRefChanged,
            onRowExpansionChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onColumnExpansionChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onColumnMoveRequested: undefined,
            onChangeHiddenColumnsRequested: undefined,
            onRowAddRequested: undefined,
            onClearAddedRowsRequested: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onPersistAddedRowRequested: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onCancelAddedRowRequested: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onSortedColumnChanged: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onSortedRowIdsChanged: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }
    });

});
parcelRegister("8l3H6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ac531b27936bd26$export$2e2bcd8739ae039);

var $aIrSA = parcelRequire("aIrSA");

var $kcVGc = parcelRequire("kcVGc");

var $atQRE = parcelRequire("atQRE");

var $fRJOe = parcelRequire("fRJOe");

var $cSoMO = parcelRequire("cSoMO");
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 1.
$1ac531b27936bd26$export$2e2bcd8739ae039 = (0, $aIrSA.connect)((state, ownProps)=>({
        virtualBoundaries: (0, $fRJOe.getVirtualBoundaries)(state),
        numberOfLoadingRows: (0, $fRJOe.getNumberOfLoadingRowsInDisplayBoundary)(state),
        rowHeight: (0, $kcVGc.getRowHeight)(state, ownProps.id),
        tableWidth: (0, $atQRE.getTableWidth)(state),
        tableHasRightShadow: (0, $fRJOe.isHorizontalScrollRightShadowVisible)(state),
        isActiveItem: (0, $fRJOe.isActiveRowItem)(state, ownProps.id),
        isRowLeftEdgeVisible: (0, $fRJOe.getOffsetFromLeft)(state) === 0,
        isRowRightEdgeVisible: (0, $fRJOe.getOffsetFromRight)(state) === 0,
        renderSidebarIcon: ownProps.renderSidebarIcon
    }))((0, $cSoMO.default));

});
parcelRegister("cSoMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a661529b6bee325$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $6YFG2 = parcelRequire("6YFG2");

var $3Ogvp = parcelRequire("3Ogvp");

var $i1eKe = parcelRequire("i1eKe");

var $9r28u = parcelRequire("9r28u");
const $0a661529b6bee325$var$WIDE_SKELETON_WIDTH_PX = 616;
const $0a661529b6bee325$var$SHORT_SKELETON_WIDTH_PX = 408;
const $0a661529b6bee325$var$MIN_TABLE_WIDTH_FOR_FULL_SKELETONS = $0a661529b6bee325$var$WIDE_SKELETON_WIDTH_PX + 200;
const $0a661529b6bee325$var$SKELETON_HEIGHT = 20; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a661529b6bee325$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { rowHeight: rowHeight, noRightMargin: noRightMargin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1px358m": (0, $awdRS.default)(`${__cmplp.rowHeight}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1qdi _kqswh2mm _1e0c1txw _4cvr1h6o",
            __cmplp.noRightMargin ? "_2hwxze3t" : "_2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $0a661529b6bee325$var$shimmer = null;
const $0a661529b6bee325$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $awdRS.default)(`${__cmplp.height}px`),
            "--_6f8077": (0, $awdRS.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2rko1y44 _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhkh3tw _1itk14a4 _12vemgnk _4t3i2nrh _p12f1hdq",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line jira/react/no-class-components
class $0a661529b6bee325$var$LoadingRow extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { id: id, rowHeight: rowHeight, reasonType: reasonType, onRowContentUpdate: onRowContentUpdate } = this.props;
        onRowContentUpdate && onRowContentUpdate(id, rowHeight);
        this.timestampMounted = Date.now();
        this.initialReasonType = reasonType;
        if (this.props.isActiveItem && this.myRef.current) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.focus();
        this.myRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.addEventListener('focusin', this.props.onFocusCallback);
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isActiveItem && this.props.isActiveItem && this.myRef.current) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.focus();
    }
    componentWillUnmount() {
        const { id: id, onUnmount: onUnmount, numberOfLoadingRows: numberOfLoadingRows, virtualBoundaries: { displayStart: displayStart } } = this.props;
        const timeVisibleFor = Date.now() - this.timestampMounted;
        onUnmount && onUnmount(numberOfLoadingRows, displayStart, id, timeVisibleFor, // @ts-expect-error Argument of type 'string' is not assignable to parameter of type 'UIAnalyticsEvent'.
        this.initialReasonType);
        this.myRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.myRef.current.removeEventListener('focusin', this.props.onFocusCallback);
    }
    baseSkeletonWidth() {
        const { rowIndex: rowIndex } = this.props;
        return rowIndex % 2 ? $0a661529b6bee325$var$SHORT_SKELETON_WIDTH_PX : $0a661529b6bee325$var$WIDE_SKELETON_WIDTH_PX;
    }
    skeletonWidth() {
        const { tableWidth: tableWidth } = this.props;
        const baseWidth = this.baseSkeletonWidth();
        if (tableWidth < $0a661529b6bee325$var$MIN_TABLE_WIDTH_FOR_FULL_SKELETONS) {
            const scalingFactor = tableWidth / $0a661529b6bee325$var$MIN_TABLE_WIDTH_FOR_FULL_SKELETONS;
            return Math.ceil(baseWidth * scalingFactor);
        }
        return baseWidth;
    }
    render() {
        const { rowHeight: rowHeight, tableHasRightShadow: tableHasRightShadow, isActiveItem: isActiveItem, isRowLeftEdgeVisible: isRowLeftEdgeVisible, isRowRightEdgeVisible: isRowRightEdgeVisible, onClick: onClick, intl: { formatMessage: formatMessage }, theme: theme } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0a661529b6bee325$var$Wrapper // @ts-expect-error - TS2322 - The expected type comes from property onClick which is declared here on type IntrinsicAttributes & { rowHeight: number; noRightMargin: boolean; } & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
        , {
            onClick: onClick,
            rowHeight: rowHeight,
            noRightMargin: tableHasRightShadow,
            isActiveItem: isActiveItem,
            ref: this.myRef,
            tabIndex: 0,
            "aria-label": formatMessage((0, $9r28u.default).loadingRow),
            role: "button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0a661529b6bee325$export$8f31e4c4a37b8e9c, {
            width: this.skeletonWidth(),
            height: $0a661529b6bee325$var$SKELETON_HEIGHT
        }), isActiveItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ogvp.RowHighlight), {
            theme: theme,
            isRowLeftEdgeVisible: isRowLeftEdgeVisible,
            isRowRightEdgeVisible: isRowRightEdgeVisible
        }));
    }
    constructor(...args){
        super(...args), this.myRef = /*#__PURE__*/ (0, $eJOHy.createRef)() // @ts-expect-error - TS2564 - Property 'timestampMounted' has no initializer and is not definitely assigned in the constructor.
        ;
    }
}
var $0a661529b6bee325$export$2e2bcd8739ae039 = (0, $6YFG2.default)((0, $i1eKe.withTheme)($0a661529b6bee325$var$LoadingRow));

});
parcelRegister("9r28u", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebeb0dcdd010b251$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ebeb0dcdd010b251$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loadingRow: {
        "id": "virtual-table.app.table.loading-row.loading-row",
        "defaultMessage": "Loading row contents"
    }
});

});





parcelRegister("3Q3rN", function(module, exports) {

$parcel$export(module.exports, "createCellsCache", () => $ec6d873fcd89a07a$export$b8f5d4dcd5b8c653);

var $eJOHy = parcelRequire("eJOHy");

var $5PQOA = parcelRequire("5PQOA");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $6kau5 = parcelRequire("6kau5");

var $jSkWF = parcelRequire("jSkWF");

var $Me0VS = parcelRequire("Me0VS");
const $ec6d873fcd89a07a$var$LOCATION = 'issue-table.view.create-cell.view';
const $ec6d873fcd89a07a$export$4983e1eef8c41de4 = (arg)=>{
    const argSplitByHyphen = arg.split('-');
    return {
        containsHyphen: argSplitByHyphen.length > 1,
        numericalValue: parseInt(argSplitByHyphen[argSplitByHyphen.length - 1], 10),
        length: arg.length
    };
};
const $ec6d873fcd89a07a$var$cacheResolver = (jsonComponentArgs, mergedColumnProps)=>mergedColumnProps.fieldId;
const $ec6d873fcd89a07a$export$24c442202b6913f7 = (jsonComponentArgs, mergedColumnProps, FieldDataSelector)=>class Cell extends (0, $eJOHy.Component) {
        componentDidCatch(error) {
            const { fieldType: fieldType, fieldId: fieldId } = mergedColumnProps;
            const event = {
                fieldDescriptor: JSON.stringify({
                    fieldId: fieldId,
                    fieldType: fieldType
                }),
                privacySafeRowId: JSON.stringify($ec6d873fcd89a07a$export$4983e1eef8c41de4(this.props.rowId))
            };
            (0, $eSnSE.default).safeErrorWithoutCustomerData($ec6d873fcd89a07a$var$LOCATION, `create cell component failed to render: ${String(error)}`, event);
            (0, $gYnSx.default)({
                meta: {
                    id: 'createCell',
                    packageName: 'jiraIssueTable',
                    teamName: 'jsd-shield'
                },
                attributes: {
                    fieldDescriptor: JSON.stringify({
                        fieldId: fieldId,
                        fieldType: fieldType
                    }),
                    privacySafeRowId: JSON.stringify($ec6d873fcd89a07a$export$4983e1eef8c41de4(this.props.rowId))
                },
                // @ts-expect-error - TS2345 - Argument of type 'Error' is not assignable to parameter of type 'string'.
                error: new Error(error)
            });
            if (fieldType === 'com.atlassian.servicedesk:sd-sla-field') (0, $gYnSx.default)({
                meta: {
                    id: 'slaViewCell',
                    packageName: 'jiraIssueTable'
                },
                // @ts-expect-error - TS2345 - Argument of type 'Error' is not assignable to parameter of type 'string'.
                error: new Error(error)
            });
            this.setState({
                hasError: true
            });
        }
        render() {
            if (this.state.hasError === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Me0VS.CellWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6kau5.default), null));
            const { rowId: rowId, columnId: columnId, isActive: isActive, width: width, onMount: onMount, onUpdate: onUpdate, canBeMultiLine: canBeMultiLine, shouldHydrateFully: shouldHydrateFully } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jSkWF.default), {
                rowId: rowId,
                columnId: columnId,
                isActive: isActive,
                shouldHydrateFully: !!shouldHydrateFully,
                width: width,
                onMount: onMount,
                onUpdate: onUpdate,
                canBeMultiLine: canBeMultiLine,
                jsonComponentArgs: jsonComponentArgs,
                mergedColumnProps: mergedColumnProps,
                FieldDataSelector: FieldDataSelector
            });
        }
        constructor(...args){
            super(...args), this.state = {
                hasError: false
            };
        }
    };
const $ec6d873fcd89a07a$export$b8f5d4dcd5b8c653 = ()=>// @ts-expect-error - TS2345: Type '[jsonComponentArgs: JsonComponentArgs<T>, mergedColumnProps: MergedColumnProps<T>, FieldDataSelector: ComponentType<FieldDataSelectorProps>]' is not assignable to type '[jsonComponentArgs: JsonComponentArgs<keyof DataSelectorPropsMap>, mergedColumnProps: MergedColumnProps<keyof DataSelectorPropsMap>]'.
    (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($ec6d873fcd89a07a$export$24c442202b6913f7, $ec6d873fcd89a07a$var$cacheResolver);

});
parcelRegister("jSkWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4772a16ba1dde34f$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $l5htz = parcelRequire("l5htz");

var $j5V5L = parcelRequire("j5V5L");

var $cLGK3 = parcelRequire("cLGK3");

var $4RDBn = parcelRequire("4RDBn");

var $2f0m6 = parcelRequire("2f0m6");

var $b2ZJN = parcelRequire("b2ZJN");

var $dQRbF = parcelRequire("dQRbF");

var $8toaC = parcelRequire("8toaC");

var $iRw78 = parcelRequire("iRw78");

var $70ADR = parcelRequire("70ADR");

var $5gJrT = parcelRequire("5gJrT");

var $c6Tnq = parcelRequire("c6Tnq");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4772a16ba1dde34f$var$mapStateToProps = (state, ownProps)=>({
        TableStateConnector: $5gJrT.default,
        isCellValid: (0, $4RDBn.isCellValid)(state, ownProps.columnId, ownProps.rowId),
        rowListRef: (0, $b2ZJN.getRowListRef)(state),
        JsonCell: $70ADR.default,
        isUserPickerDisabled: (0, $dQRbF.isUserPickerDisabled)(state)
    });
const $4772a16ba1dde34f$var$mapDispatchToProps = {
    onEditStart: (0, $cLGK3.issueEditStartedAction)
};
var $4772a16ba1dde34f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $l5htz.default)({
    onClick: (fieldType)=>({
            name: fieldType
        })
}), (0, $8toaC.connect)($4772a16ba1dde34f$var$mapStateToProps, $4772a16ba1dde34f$var$mapDispatchToProps, null, {
    // @ts-expect-error - TS7006 - Parameter 'nextProps' implicitly has an 'any' type. | TS7006 - Parameter 'prevProps' implicitly has an 'any' type.
    areStatePropsEqual: (nextProps, prevProps)=>{
        // Stop rendering immediately if the cell isn't valid. This
        // should always be due to the virtual-table rendering the old
        // locations in the first reconciliation, before a second
        // reconciliation kicks in with the new row and column IDs.
        if (!nextProps.isCellValid) return true;
        return (0, $j5V5L.default)(nextProps, prevProps);
    }
}), (0, $iRw78.ReduxAnalyticsData)((state, ownProps)=>({
        attributes: {
            fieldType: ownProps.mergedColumnProps.fieldType,
            tableRowNumber: (0, $2f0m6.getIssueKeyPositionIndex)(state, ownProps.rowId) + 1
        }
    })))((0, $c6Tnq.default));

});
parcelRegister("4RDBn", function(module, exports) {

$parcel$export(module.exports, "isCellValid", () => $4a41208af6d30630$export$197f9971d7c5eea6);

var $blTcR = parcelRequire("blTcR");

var $2f0m6 = parcelRequire("2f0m6");
const $4a41208af6d30630$export$197f9971d7c5eea6 = (state, columnId, rowId)=>(0, $2f0m6.isIssueKnown)(state, rowId) && (0, $blTcR.isColumnKnown)(state, columnId);

});

parcelRegister("b2ZJN", function(module, exports) {

$parcel$export(module.exports, "getRowListRef", () => $f5666c718736fdbe$export$3fa6769a2044ea5a);

var $lhJwW = parcelRequire("lhJwW");
const $f5666c718736fdbe$export$3fa6769a2044ea5a = (state)=>(0, $lhJwW.getPersisted)(state).rowListRef;

});

parcelRegister("70ADR", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b3944d515c7cdc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $Me0VS = parcelRequire("Me0VS");

var $6kau5 = parcelRequire("6kau5");
class $25b3944d515c7cdc$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props) {
        if (props.tableInjectedProps.isTableDisabled) return {
            isEditable: false
        };
        return null;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.tableInjectedProps.isTableDisabled === true && this.props.tableInjectedProps.isTableDisabled === false) this.setState({
            // @ts-expect-error - TS2339 - Property 'isEditable' does not exist on type 'SlaDataSelectorProps | ServiceEntityDataSelectorProps | CmdbObjectDataSelectorProps | ... 13 more ... | MeatballMenuDataSelectorProps'.
            isEditable: this.props.fieldData.isEditable || false
        });
    }
    render() {
        const { FieldComponent: FieldComponent, fieldData: fieldData, tableInjectedProps: tableInjectedProps } = this.props;
        const { isEditable: isEditable } = this.state;
        if ((0, $7jTnu.fg)('handle-queues-column-exceptions')) {
            // @ts-expect-error - TS2339 - Property 'fieldRenderedValue' does not exist on type 'AnyDataSelectorJsonProps | DataSelectorHtmlProps'. | TS2339 - Property 'fieldCssClass' does not exist on type 'AnyDataSelectorJsonProps | DataSelectorHtmlProps'.
            if (fieldData.value != null && fieldData.value.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Me0VS.CellWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6kau5.default), null));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldComponent, {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            dataSelectorProps: {
                ...fieldData,
                isEditable: isEditable
            },
            tableInjectedProps: tableInjectedProps
        });
    }
    constructor(...args){
        super(...args), this.state = {
            // @ts-expect-error - TS2339 - Property 'isEditable' does not exist on type 'SlaDataSelectorProps | ServiceEntityDataSelectorProps | CmdbObjectDataSelectorProps | ... 13 more ... | MeatballMenuDataSelectorProps'.
            isEditable: this.props.fieldData.isEditable || false
        };
    }
}

});
parcelRegister("Me0VS", function(module, exports) {

$parcel$export(module.exports, "CellWrapper", () => $7f29f968f0cf15f7$export$4812fadef83edffe);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $7f29f968f0cf15f7$export$4812fadef83edffe = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1tke1ylp _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("5gJrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcf012240f56718b$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $j5V5L = parcelRequire("j5V5L");

var $987AO = parcelRequire("987AO");

var $cN0WI = parcelRequire("cN0WI");

var $4RDBn = parcelRequire("4RDBn");

var $blTcR = parcelRequire("blTcR");

var $coQbr = parcelRequire("coQbr");

var $2f0m6 = parcelRequire("2f0m6");

var $dQRbF = parcelRequire("dQRbF");

var $8toaC = parcelRequire("8toaC");

var $capBh = parcelRequire("capBh");
const $bcf012240f56718b$var$mapStateToPropsFactory = ()=>{
    const onIssueViewTransitionFactory = (0, $LFmXM.default)((state, issueKey)=>(0, $dQRbF.getOnIssueViewTransitionCallback)(state, issueKey));
    return (state, props)=>({
            isCellValid: (0, $4RDBn.isCellValid)(state, props.fieldDescriptor.fieldId, props.issueKey),
            isFieldLocked: (0, $coQbr.getIsFieldLocked)(state, props),
            isLastColumn: (0, $blTcR.isLastColumn)(state, props.fieldDescriptor.fieldId),
            positionIndex: (0, $2f0m6.getIssueKeyPositionIndex)(state, props.issueKey),
            fieldName: (0, $blTcR.getColumnTitle)(state, props.fieldDescriptor.fieldId),
            isTableDisabled: (0, $dQRbF.isTableDisabled)(state),
            onIssueViewTransition: onIssueViewTransitionFactory(state, props.issueKey)
        });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bcf012240f56718b$var$mapDispatchToProps = (dispatch, props)=>({
        onFieldLock: (positionIndex)=>dispatch((0, $987AO.lockFieldAction)(props.issueKey, props.fieldDescriptor.fieldId, positionIndex)),
        onFieldUnlock: ()=>dispatch((0, $987AO.unlockFieldAction)(props.issueKey, props.fieldDescriptor.fieldId)),
        onSetEditingFieldPosition: (horizontalOffset, verticalOffset, fieldWidth, tableWidth, tableHeight)=>dispatch((0, $cN0WI.setEditingFieldPositionAction)(horizontalOffset, verticalOffset, fieldWidth, tableWidth, tableHeight))
    });
const $bcf012240f56718b$var$issueFieldLockControlsFactory = (0, $LFmXM.default)((positionIndex, onFieldLock, onFieldUnlock)=>({
        onFieldUnlock: onFieldUnlock,
        onFieldLock: ()=>onFieldLock(positionIndex)
    }));
const $bcf012240f56718b$var$mergeProps = (stateProps, dispatchProps, ownProps)=>{
    const { positionIndex: positionIndex, isCellValid: _, ...componentStateProps } = stateProps;
    return {
        ...ownProps,
        ...componentStateProps,
        issueFieldLockControls: $bcf012240f56718b$var$issueFieldLockControlsFactory(stateProps.positionIndex, dispatchProps.onFieldLock, dispatchProps.onFieldUnlock),
        onSetEditingFieldPosition: dispatchProps.onSetEditingFieldPosition
    };
};
const $bcf012240f56718b$var$ConnectedTableStateConnector = (0, $8toaC.connect)($bcf012240f56718b$var$mapStateToPropsFactory, $bcf012240f56718b$var$mapDispatchToProps, $bcf012240f56718b$var$mergeProps, {
    // @ts-expect-error - TS7006 - Parameter 'nextProps' implicitly has an 'any' type. | TS7006 - Parameter 'prevProps' implicitly has an 'any' type.
    areStatePropsEqual: (nextProps, prevProps)=>{
        // Stop rendering immediately if the cell isn't valid.
        if (!nextProps.isCellValid) return true;
        return (0, $j5V5L.default)(nextProps, prevProps);
    }
})((0, $capBh.default));
var $bcf012240f56718b$export$2e2bcd8739ae039 = $bcf012240f56718b$var$ConnectedTableStateConnector;

});
parcelRegister("capBh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0801dc0ac7d9ac2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
class $b0801dc0ac7d9ac2$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props, prevState) {
        const { isFieldLocked: isFieldLocked, fieldData: fieldData } = props;
        if (!isFieldLocked && fieldData && prevState.cachedFieldData !== fieldData) return {
            cachedFieldData: fieldData
        };
        return null;
    }
    componentWillUnmount() {
        const { isFieldLocked: isFieldLocked, issueFieldLockControls: { onFieldUnlock: onFieldUnlock } } = this.props;
        // unlock, if locked, when unmounting
        isFieldLocked && onFieldUnlock && onFieldUnlock();
    }
    render() {
        const { children: children, issueFieldLockControls: issueFieldLockControls, isFieldLocked: isFieldLocked, fieldData: givenFieldData, isLastColumn: isLastColumn, fieldName: fieldName, onSetEditingFieldPosition: onSetEditingFieldPosition, isTableDisabled: isTableDisabled, onIssueViewTransition: onIssueViewTransition } = this.props;
        const { cachedFieldData: cachedFieldData } = this.state;
        const fieldData = !isFieldLocked && givenFieldData ? givenFieldData : cachedFieldData;
        return children({
            issueFieldLockControls: issueFieldLockControls,
            fieldData: fieldData,
            isLastColumn: isLastColumn,
            fieldName: fieldName,
            onSetEditingFieldPosition: onSetEditingFieldPosition,
            isFieldLocked: isFieldLocked,
            isTableDisabled: isTableDisabled,
            onIssueViewTransition: onIssueViewTransition
        });
    }
    constructor(...args){
        super(...args), this.state = {
            cachedFieldData: null
        };
    }
}

});


parcelRegister("c6Tnq", function(module, exports) {

$parcel$export(module.exports, "default", () => $75eca397aaddfce7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aBFKZ = parcelRequire("aBFKZ");

var $eSnSE = parcelRequire("eSnSE");

var $3RYOj = parcelRequire("3RYOj");

var $Me0VS = parcelRequire("Me0VS");
const $75eca397aaddfce7$var$LOCATION = 'issue-table.view.create-cell.view';
const $75eca397aaddfce7$export$4983e1eef8c41de4 = (arg)=>{
    const argSplitByHyphen = arg.split('-');
    return {
        containsHyphen: argSplitByHyphen.length > 1,
        numericalValue: parseInt(argSplitByHyphen[argSplitByHyphen.length - 1], 10),
        length: arg.length
    };
};
// eslint-disable-next-line jira/react/no-class-components
class $75eca397aaddfce7$var$Cell extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentDidUpdate() {
        const { onUpdate: onUpdate } = this.props;
        if (onUpdate) onUpdate();
    }
    getFieldDescriptor() {
        const { fieldId: fieldId, fieldType: fieldType } = this.props.mergedColumnProps;
        return {
            fieldId: fieldId,
            fieldType: fieldType
        };
    }
    render() {
        const { rowId: rowId, FieldDataSelector: FieldDataSelector } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Me0VS.CellWrapper), {
            onClick: this.onClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldDataSelector, {
            issueKey: rowId,
            fieldDescriptor: this.getFieldDescriptor()
        }, this.renderField));
    }
    constructor(...args){
        super(...args), this.onClick = ()=>{
            this.props.onClick(this.props.mergedColumnProps.fieldType);
        }, this.renderLockableField = ({ fieldData: fieldData, issueFieldLockControls: issueFieldLockControls, isLastColumn: isLastColumn, fieldName: fieldName, onSetEditingFieldPosition: onSetEditingFieldPosition, isFieldLocked: isFieldLocked, isTableDisabled: isTableDisabled, onIssueViewTransition: onIssueViewTransition })=>{
            const { jsonComponentArgs: jsonComponentArgs, mergedColumnProps: mergedColumnProps, isActive: isActive, shouldHydrateFully: shouldHydrateFully, width: width, rowId: rowId, rowListRef: rowListRef, onEditStart: onEditStart, isUserPickerDisabled: isUserPickerDisabled, JsonCell: JsonCell } = this.props;
            if (fieldData) {
                // @ts-expect-error - TS2339 - Property 'fieldRenderedValue' does not exist on type 'AnyDataSelectorJsonProps | DataSelectorHtmlProps'. | TS2339 - Property 'fieldCssClass' does not exist on type 'AnyDataSelectorJsonProps | DataSelectorHtmlProps'.
                if (fieldData.fieldRenderedValue != null || fieldData.fieldCssClass != null) {
                    const { canBeMultiLine: canBeMultiLine } = this.props;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3RYOj.default), {
                        canBeMultiLine: !!canBeMultiLine,
                        isLastColumn: isLastColumn,
                        doNotRenderTooltip: !!mergedColumnProps.doNotRenderTooltip,
                        ...fieldData
                    });
                }
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const fieldDataType = fieldData.fieldType;
                if (jsonComponentArgs && jsonComponentArgs.fieldType === fieldDataType) {
                    const { FieldComponent: FieldComponent } = jsonComponentArgs;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(JsonCell, {
                        FieldComponent: FieldComponent,
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        fieldData: fieldData,
                        tableInjectedProps: {
                            fieldId: mergedColumnProps.fieldId,
                            isActive: isActive,
                            issueFieldLockControls: issueFieldLockControls,
                            onEditStart: onEditStart,
                            width: width,
                            shouldHydrateFully: shouldHydrateFully,
                            isLastColumn: isLastColumn,
                            issueKey: rowId,
                            fieldName: fieldName,
                            rowListRef: rowListRef,
                            onSetEditingFieldPosition: onSetEditingFieldPosition,
                            isFieldLocked: isFieldLocked,
                            isUserPickerDisabled: isUserPickerDisabled,
                            isTableDisabled: isTableDisabled,
                            onIssueViewTransition: onIssueViewTransition
                        }
                    });
                }
            } else {
                (0, $eSnSE.default).safeWarnWithoutCustomerData($75eca397aaddfce7$var$LOCATION, `[FD-3358] Rendered an empty cell because a FieldDataSelector returned null without backup data. row-id details: "${JSON.stringify($75eca397aaddfce7$export$4983e1eef8c41de4(rowId))}", column-type: "${mergedColumnProps.fieldType}"`);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null);
            }
            throw new Error(`[FD-3358] Cannot render cell without either: prerendered html from the data selector OR field json data of the correct type for the current column. row-id details: "${JSON.stringify($75eca397aaddfce7$export$4983e1eef8c41de4(rowId))}", column-type: "${mergedColumnProps.fieldType}", data-field-type: "${// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            fieldData && fieldData.fieldType}", data-css-class: "${fieldData && fieldData.fieldCssClass}"`);
        }, this.renderField = (selectorFieldData)=>{
            const { TableStateConnector: TableStateConnector, rowId: rowId } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TableStateConnector, {
                issueKey: rowId,
                fieldDescriptor: this.getFieldDescriptor(),
                fieldData: selectorFieldData
            }, this.renderLockableField);
        };
    }
}
var $75eca397aaddfce7$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('field', {
    onClick: 'clicked',
    onEditStart: 'locked'
})($75eca397aaddfce7$var$Cell);

});
parcelRegister("3RYOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $548c446ee5888549$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/react/no-style-attribute */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k71qx = parcelRequire("k71qx");
// TODO: FREE-2849 : Revisit the list and add more as required
const $548c446ee5888549$var$BLOCK_ELEMENTS = 'div, p, h2';
class $548c446ee5888549$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.onSetRef = (div)=>{
            this.ref = div;
        }, this.onMouseOver = ()=>{
            if (this.props.doNotRenderTooltip) return;
            if (this.ref) {
                /*
       * If there is a 'block' child node, the width of the child is to be taken for the correct calculations.
       * Since we are rendering HTML blob, we need to find out if there are any 'block' child nodes
       */ const targetElement = this.ref.querySelector($548c446ee5888549$var$BLOCK_ELEMENTS) || this.ref;
                let tooltipText = '';
                // Check if the element has overflown. If yes, set the innerText in state for tooltip to display
                // @ts-expect-error - TS2339 - Property 'offsetWidth' does not exist on type 'Element'.
                if (targetElement && targetElement.scrollWidth > targetElement.offsetWidth) // @ts-expect-error - TS2339 - Property 'innerText' does not exist on type 'Element'.
                tooltipText = targetElement.innerText;
                if (this.state.tooltipText !== tooltipText) this.setState(()=>({
                        tooltipText: tooltipText
                    }));
            }
        };
        this.rawText = '';
        this.hasEllipsis = false;
        this.state = {
            tooltipText: ''
        };
    }
    getContent() {
        const { fieldRenderedValue: fieldRenderedValue, fieldCssClass: fieldCssClass, canBeMultiLine: canBeMultiLine, isLastColumn: isLastColumn } = this.props;
        const innerHtml = {
            __html: fieldRenderedValue
        };
        if (canBeMultiLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            // @ts-expect-error - TS2322 - Type '{ padding: string; overflowWrap: string; }' is not assignable to type 'Properties<string | number, string & {}>'.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isLastColumn ? $548c446ee5888549$var$LastColumnMultilineStyle : $548c446ee5888549$var$NonLastColumnMultilineStyle,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: fieldCssClass,
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: innerHtml
        });
        return isLastColumn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($548c446ee5888549$var$StyledWrapperLastColumn, {
            ref: this.onSetRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: fieldCssClass,
            dangerouslySetInnerHTML: innerHtml,
            onMouseOver: this.onMouseOver,
            onFocus: this.onMouseOver,
            role: "textbox",
            tabIndex: 0
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($548c446ee5888549$var$BaseStyledWrapper, {
            ref: this.onSetRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: fieldCssClass,
            dangerouslySetInnerHTML: innerHtml,
            onMouseOver: this.onMouseOver,
            onFocus: this.onMouseOver,
            role: "textbox",
            tabIndex: 0
        });
    }
    render() {
        const { tooltipText: tooltipText } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($548c446ee5888549$var$FieldRenderedValueContainer, null, tooltipText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            delay: 0,
            content: tooltipText
        }, this.getContent()) : this.getContent());
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $548c446ee5888549$var$FieldRenderedValueContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul9idpf",
            __cmplp.className
        ])
    });
});
const $548c446ee5888549$var$BaseStyledWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _ca0qu2gc _u5f31ejb _n3tdu2gc _19bvu2gc _1bto1l2s _o5721q9c _1bsb1osq _vchhusvi _bhp515vq _wrxl15vq _5i651l2s _pg4a1q9c",
            __cmplp.className
        ])
    });
});
const $548c446ee5888549$var$StyledWrapperLastColumn = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $548c446ee5888549$var$BaseStyledWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $548c446ee5888549$var$LastColumnMultilineStyle = {
    padding: `${"var(--ds-space-100, 8px)"}`,
    overflowWrap: 'break-word'
};
const $548c446ee5888549$var$NonLastColumnMultilineStyle = {
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
    overflowWrap: 'break-word'
};

});






parcelRegister("cgPFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2711f9d770b10fba$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $LFmXM = parcelRequire("LFmXM");

var $bmZ1f = parcelRequire("bmZ1f");

var $dPMMf = parcelRequire("dPMMf");

var $lQL5M = parcelRequire("lQL5M");

var $dtIm6 = parcelRequire("dtIm6");
const $2711f9d770b10fba$var$ANIMATION_TIMEOUT = 200;
const $2711f9d770b10fba$var$ASSIGNEE_HEIGHT = 40;
const $2711f9d770b10fba$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT = 300;
const $2711f9d770b10fba$var$OFFSET_PADDING = 4;
const $2711f9d770b10fba$var$BOTTOM_LEFT = 'BOTTOM_LEFT';
const $2711f9d770b10fba$var$BOTTOM_RIGHT = 'BOTTOM_RIGHT';
const $2711f9d770b10fba$var$TOP_LEFT = 'TOP_LEFT';
const $2711f9d770b10fba$var$TOP_RIGHT = 'TOP_RIGHT';
const $2711f9d770b10fba$var$DROPDOWN_WIDTH_MARGIN = 7 * (0, $dPMMf.gridSize);
const $2711f9d770b10fba$var$DROPDOWN_HEIGHT_MARGIN = 9 * (0, $dPMMf.gridSize);
const $2711f9d770b10fba$var$spaceAvailableRightOfField = (tableWidth, horizontalScrollOffset, horizontalOffset)=>tableWidth + horizontalScrollOffset - horizontalOffset > $2711f9d770b10fba$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT + $2711f9d770b10fba$var$DROPDOWN_WIDTH_MARGIN;
const $2711f9d770b10fba$var$spaceAvailableUnderField = (tableHeight, verticalScrollOffset, verticalOffset)=>tableHeight + verticalScrollOffset - verticalOffset > $2711f9d770b10fba$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT + $2711f9d770b10fba$var$DROPDOWN_HEIGHT_MARGIN;
const $2711f9d770b10fba$var$getPositionType = (horizontalOffset, horizontalScrollOffset, verticalOffset, verticalScrollOffset, tableWidth, tableHeight)=>{
    if ($2711f9d770b10fba$var$spaceAvailableUnderField(tableHeight, verticalScrollOffset, verticalOffset)) {
        if ($2711f9d770b10fba$var$spaceAvailableRightOfField(tableWidth, horizontalScrollOffset, horizontalOffset)) return $2711f9d770b10fba$var$BOTTOM_LEFT;
        return $2711f9d770b10fba$var$BOTTOM_RIGHT;
    }
    if ($2711f9d770b10fba$var$spaceAvailableRightOfField(tableWidth, horizontalScrollOffset, horizontalOffset)) return $2711f9d770b10fba$var$TOP_LEFT;
    return $2711f9d770b10fba$var$TOP_RIGHT;
};
const $2711f9d770b10fba$export$193f85369df210ff = (horizontalOffset, horizontalScrollOffset, verticalOffset, verticalScrollOffset, fieldWidth, tableWidth, tableHeight)=>{
    switch($2711f9d770b10fba$var$getPositionType(horizontalOffset, horizontalScrollOffset, verticalOffset, verticalScrollOffset, tableWidth, tableHeight)){
        case $2711f9d770b10fba$var$BOTTOM_LEFT:
            return {
                left: `${horizontalOffset - horizontalScrollOffset - $2711f9d770b10fba$var$OFFSET_PADDING}px`,
                top: `${verticalOffset + $2711f9d770b10fba$var$ASSIGNEE_HEIGHT}px`,
                bottom: undefined
            };
        case $2711f9d770b10fba$var$BOTTOM_RIGHT:
            return {
                left: `${horizontalOffset - horizontalScrollOffset + fieldWidth - $2711f9d770b10fba$var$OFFSET_PADDING - $2711f9d770b10fba$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT}px`,
                top: `${verticalOffset + $2711f9d770b10fba$var$ASSIGNEE_HEIGHT}px`,
                bottom: undefined
            };
        case $2711f9d770b10fba$var$TOP_LEFT:
            return {
                left: `${horizontalOffset - horizontalScrollOffset - $2711f9d770b10fba$var$OFFSET_PADDING}px`,
                top: 'auto',
                bottom: `${-verticalOffset - $2711f9d770b10fba$var$OFFSET_PADDING}px`
            };
        default:
            return {
                left: `${horizontalOffset - horizontalScrollOffset + fieldWidth - $2711f9d770b10fba$var$OFFSET_PADDING - $2711f9d770b10fba$var$ASSIGNEE_DROPDOWN_WIDTH_HEIGHT}px`,
                top: 'auto',
                bottom: `${-verticalOffset - $2711f9d770b10fba$var$OFFSET_PADDING}px`
            };
    }
};
class $2711f9d770b10fba$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = (0, $dtIm6.defaultProps);
    }
    render() {
        const { currentPage: currentPage, totalPages: totalPages, onPageChange: onPageChange } = this.props;
        const { Table: Table, showPagination: showPagination, Pagination: Pagination, editingFieldHorizontalOffset: editingFieldHorizontalOffset, editingFieldVerticalOffset: editingFieldVerticalOffset, editingFieldWidth: editingFieldWidth, horizontalScrollOffset: horizontalScrollOffset, verticalScrollOffset: verticalScrollOffset, tableWidth: tableWidth, tableHeight: tableHeight, onUpdateHorizontalScrollOffset: onUpdateHorizontalScrollOffset, onActiveRowIdChanged: onActiveRowIdChanged, ...otherProps } = this.props;
        const portalPosition = $2711f9d770b10fba$export$193f85369df210ff(editingFieldHorizontalOffset, horizontalScrollOffset, editingFieldVerticalOffset, verticalScrollOffset, editingFieldWidth, tableWidth, tableHeight);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2711f9d770b10fba$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2711f9d770b10fba$var$TableContainer, {
            animationTimeout: $2711f9d770b10fba$var$ANIMATION_TIMEOUT,
            hasPagination: showPagination,
            left: portalPosition.left,
            top: portalPosition.top,
            bottom: portalPosition.bottom
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lQL5M.IssueContextSubscriber), null, (__, { setIssueKeyContext: setIssueKeyContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Table, {
                ...otherProps,
                onActiveRowIdChanged: this.onSetIssueKeyContextCallback(setIssueKeyContext),
                onUpdateHorizontalScrollOffset: this.onUpdateHorizontalScrollOffset
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bmZ1f.default), {
            in: showPagination,
            classNames: "fade",
            timeout: $2711f9d770b10fba$var$ANIMATION_TIMEOUT,
            unmountOnExit: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2711f9d770b10fba$var$Animate, {
            timeout: $2711f9d770b10fba$var$ANIMATION_TIMEOUT
        }, showPagination && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Pagination, {
            currentPage: currentPage,
            totalPages: totalPages,
            onPageChange: onPageChange
        }))));
    }
    constructor(...args){
        super(...args), this.onUpdateHorizontalScrollOffset = (horizontalPositioning)=>{
            const { onHorizontalScrollOffsetChanged: onHorizontalScrollOffsetChanged, onUpdateHorizontalScrollOffset: onUpdateHorizontalScrollOffset } = this.props;
            onUpdateHorizontalScrollOffset(horizontalPositioning);
            onHorizontalScrollOffsetChanged && onHorizontalScrollOffsetChanged(horizontalPositioning);
        }, this.onSetIssueKeyContextCallback = (0, $LFmXM.default)((setIssueKeyContext)=>(rowId)=>{
                const isIssueDataLoaded = this.props.loadedIssueKeys.includes(rowId);
                if (isIssueDataLoaded) setIssueKeyContext(rowId);
                else setIssueKeyContext(undefined);
                this.props.onActiveRowIdChanged && this.props.onActiveRowIdChanged(rowId);
            });
    }
}
const $2711f9d770b10fba$var$APPROX_PAGINATION_HEIGHT = 48;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2711f9d770b10fba$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $2711f9d770b10fba$var$TableContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { animationTimeout: animationTimeout, hasPagination: hasPagination, left: left, top: top, bottom: bottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1pg9jf5": (0, $awdRS.default)(`all ${__cmplp.animationTimeout}ms ease-in`),
            "--_lr32lc": (0, $awdRS.default)(__cmplp.left),
            "--_1vj9tq": (0, $awdRS.default)(__cmplp.top),
            "--_14iunx0": (0, $awdRS.default)(__cmplp.bottom)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jl1406 _1o9zkb7n _i0dlf1ug _v5641gtb _4t3i1osq _15po1rza _1b1u1wug _jzhkstnw _rg151ter _3c8c1tn0",
            __cmplp.hasPagination && "_n3tdckbl",
            __cmplp.className
        ])
    });
});
const $2711f9d770b10fba$var$Animate = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { timeout: timeout, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_g2896q": (0, $awdRS.default)(`all ${__cmplp.timeout}ms ease-in`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqsw1n9t _94n5idpf _1xi2idpf _15og6od0 _la5rkb7n _a9jfckbl _11h16od0 _1urkidpf _w97pidpf _fgdaidpf _9xe0idpf _160ykb7n _prrmckbl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dtIm6", function(module, exports) {

$parcel$export(module.exports, "defaultProps", () => $dfe9d15a123a607c$export$9c21a3269931e1e6);

var $12DRg = parcelRequire("12DRg");
const $dfe9d15a123a607c$export$9c21a3269931e1e6 = {
    currentPage: 1,
    totalPages: 1,
    onPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};

});




parcelRegister("6I8xu", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkActionToolbar", () => $7f54d336d3737fd1$export$d53c287f3c6193b2);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7f54d336d3737fd1$var$AsyncBulkActionToolbarLazy = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("b8wrl")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/bulk-actions-toolbar/src/index.tsx"
});
const $7f54d336d3737fd1$export$d53c287f3c6193b2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "async.jira-servicedesk.bulk-actions.toolbar",
        packageName: "atlassian/jira-servicedesk-bulk-actions-toolbar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "servicedesk-bulk-actions-toolbar",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f54d336d3737fd1$var$AsyncBulkActionToolbarLazy, props)));

});
parcelRegister("b8wrl", function(module, exports) {

let $81b99af6a65cc34e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $81b99af6a65cc34e$var$load("76n7a"),
    $81b99af6a65cc34e$var$load("l253H"),
    $81b99af6a65cc34e$var$load("kifIe")
]).then(()=>parcelRequire('8cYfx'));

});


parcelRegister("6dk7W", function(module, exports) {

$parcel$export(module.exports, "getIssueTableAppProps", () => $670f92af54ffb350$export$b7be6dcc4ea236d0);

var $ahm5r = parcelRequire("ahm5r");

var $f20Bj = parcelRequire("f20Bj");
const $670f92af54ffb350$export$b7be6dcc4ea236d0 = (0, $ahm5r.createSelector)((0, $f20Bj.getCloudId), (0, $f20Bj.getFabricPfDirUrl), (0, $f20Bj.getAtlassianAccountId), (cloudId, fabricPfDirUrl, atlassianAccountId)=>({
        cloudId: cloudId,
        fabricPfDirUrl: fabricPfDirUrl,
        atlassianAccountId: atlassianAccountId
    }));

});

parcelRegister("1WNMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e6dc84f42cbbb2$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $dcH9w = parcelRequire("dcH9w");

var $jIeeH = parcelRequire("jIeeH");

var $1TuhT = parcelRequire("1TuhT");

var $lc49q = parcelRequire("lc49q");

var $6I1gv = parcelRequire("6I1gv");

var $1YZx8 = parcelRequire("1YZx8");
const $a9e6dc84f42cbbb2$var$mapStateToProps = (state, ownProps)=>{
    const { issueKey: issueKey, fieldDescriptor: { fieldId: fieldId } } = ownProps;
    const isCellFirstFieldInTable = (0, $1TuhT.isFirstFieldInTable)(state, issueKey, fieldId);
    const queueVisible = (0, $6I1gv.isQueueVisible)(state);
    return {
        queueId: (0, $lc49q.getQueueId)(state),
        onFieldDataSelection: (0, $1TuhT.getFieldPropsSelector)(state),
        isFirstFieldInTable: isCellFirstFieldInTable,
        isFieldToExperienceTrack: (0, $1TuhT.isFieldToExperienceTrack)(state, issueKey, fieldId),
        isQueueVisible: queueVisible,
        ReadyForUser: $jIeeH.ReadyForUser
    };
};
const $a9e6dc84f42cbbb2$var$FieldDataSelector = (0, $gnQAk.connect)($a9e6dc84f42cbbb2$var$mapStateToProps, {
    onFieldChange: (0, $dcH9w.changeIssueFieldValueAction)
})((0, $1YZx8.default));
var $a9e6dc84f42cbbb2$export$2e2bcd8739ae039 = $a9e6dc84f42cbbb2$var$FieldDataSelector;

});
parcelRegister("1YZx8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebfcc1e4278344b0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hya93 = parcelRequire("hya93");

var $6uWhG = parcelRequire("6uWhG");

var $dTqD3 = parcelRequire("dTqD3");

var $cfiRH = parcelRequire("cfiRH");
const $ebfcc1e4278344b0$var$renderWithExperienceTracker = (node, { isFieldToExperienceTrack: isFieldToExperienceTrack, fieldDescriptor: { fieldType: fieldType } })=>isFieldToExperienceTrack ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceSuccessTracker), {
        location: `queue-cell-${fieldType}`
    }, node) : node;
const $ebfcc1e4278344b0$var$renderWithReadyForUser = (node, { queueId: queueId, isQueueVisible: isQueueVisible, isFirstFieldInTable: isFirstFieldInTable })=>isQueueVisible && isFirstFieldInTable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cfiRH.AgentTableApdexSubmitter), null), node, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStatePageReadyOnUpdate), {
        comparer: [
            queueId
        ],
        updateKey: queueId
    })) : node;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ebfcc1e4278344b0$export$2e2bcd8739ae039 = (props)=>{
    const { onFieldChange: onFieldChange, onFieldDataSelection: onFieldDataSelection, fieldDescriptor: fieldDescriptor, issueKey: issueKey, children: children, isQueueVisible: isQueueVisible, isFirstFieldInTable: isFirstFieldInTable } = props;
    const dataSelectorCoordinates = {
        fieldDescriptor: fieldDescriptor,
        issueKey: issueKey
    };
    if (isQueueVisible && isFirstFieldInTable) (0, $6uWhG.setMark)('jsd.performance.profile.queues.firstfield.render');
    const childrenNode = children(onFieldDataSelection(dataSelectorCoordinates, onFieldChange));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, $ebfcc1e4278344b0$var$renderWithReadyForUser($ebfcc1e4278344b0$var$renderWithExperienceTracker(childrenNode, props), props));
};

});
parcelRegister("cfiRH", function(module, exports) {

$parcel$export(module.exports, "AgentTableApdexProvider", () => $5161b07570016ea3$export$28049b03af6e1521);
$parcel$export(module.exports, "AgentTableApdexSubmitter", () => $5161b07570016ea3$export$d36b2dc23ff59e3d);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $dLR8J = parcelRequire("dLR8J");

var $lYjMM = parcelRequire("lYjMM");

var $fLAsw = parcelRequire("fLAsw");

var $2IsS5 = parcelRequire("2IsS5");

var $7jTnu = parcelRequire("7jTnu");
const $5161b07570016ea3$var$context = /*#__PURE__*/ (0, $eJOHy.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
const $5161b07570016ea3$export$28049b03af6e1521 = ({ children: children, queueId: queueId, isLoading: isLoading, isVisible: isVisible, metricKey: metricKey, metric: metric, category: category, hasLoadedIssueDataFromCache: hasLoadedIssueDataFromCache })=>{
    const [finishedQueueId, setFinishedQueueId] = (0, $eJOHy.useState)(null);
    const updateFinishedQueueId = (0, $eJOHy.useCallback)(()=>{
        if (!isLoading) setFinishedQueueId(queueId);
    }, [
        queueId,
        isLoading
    ]);
    const loadingComponent = (0, $7jTnu.fg)('add_ufo_load_hold_to_custom_queue') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "agent-table-apdex-provider"
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5161b07570016ea3$var$context.Provider, {
        value: updateFinishedQueueId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children, // Do not mount initially (when queueId is null) or when switching queueIds (queueId in state mismatches props) or when table is hidden
    finishedQueueId && finishedQueueId === queueId && isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lYjMM.JsmPageInteractiveEvent), {
        key: queueId ? (0, $2IsS5.fromQueueIdString)(queueId) : undefined,
        metricKey: metricKey,
        withMarks: (0, $fLAsw.getAgentViewMarks)(),
        metric: metric,
        extra: {
            category: category || 'no-category',
            empty: false,
            hasLoadedIssueDataFromCache: hasLoadedIssueDataFromCache
        }
    })) : loadingComponent));
};
const $5161b07570016ea3$export$d36b2dc23ff59e3d = ()=>{
    const updateFinishedQueueId = (0, $eJOHy.useContext)($5161b07570016ea3$var$context);
    (0, $eJOHy.useEffect)(updateFinishedQueueId);
    return null;
};

});



parcelRegister("9HCVY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c7f50c225654b44$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $2MzoN = parcelRequire("2MzoN");

var $6I1gv = parcelRequire("6I1gv");

var $1nqMv = parcelRequire("1nqMv");
const $6c7f50c225654b44$var$mapDispatchToProps = {
    onOpenIssue: (0, $2MzoN.openIssueAction)
};
var $6c7f50c225654b44$export$2e2bcd8739ae039 = (0, $gnQAk.connect)((state)=>({
        // @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
        activeIssueKey: (0, $6I1gv.getIssueKeyContext)(state)
    }), $6c7f50c225654b44$var$mapDispatchToProps)((0, $1nqMv.default));

});
parcelRegister("1nqMv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b262f29a603e014b$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $hjf2q = parcelRequire("hjf2q");
var $gCeeo = parcelRequire("gCeeo");
const $b262f29a603e014b$var$AnalyticsWrapper = (0, $hjf2q.AnalyticsEventToProps)('issue', {
    onKeyDown: 'pressed'
})(({ children: children, onKeyDown: onKeyDown })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b262f29a603e014b$var$Wrapper, {
        role: "presentation",
        onKeyDown: onKeyDown
    }, children));
const $b262f29a603e014b$export$4983e1eef8c41de4 = (arg)=>{
    const argSplitByHyphen = arg.split('-');
    return {
        containsHyphen: argSplitByHyphen.length > 1,
        numericalValue: parseInt(argSplitByHyphen[argSplitByHyphen.length - 1], 10),
        length: arg.length
    };
};
class $b262f29a603e014b$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isDisabled: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b262f29a603e014b$var$AnalyticsWrapper, {
            onKeyDown: this.onKeyDown,
            role: "presentation"
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.onKeyDown = (event, analyticsEvent)=>{
            const { onOpenIssue: onOpenIssue, activeIssueKey: activeIssueKey, isDisabled: isDisabled } = this.props;
            if (!isDisabled && activeIssueKey != null) switch(event.key){
                case 'o':
                    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'openIssue', {
                        keyPressed: 'o',
                        issueKey: $b262f29a603e014b$export$4983e1eef8c41de4(activeIssueKey)
                    });
                    onOpenIssue();
                    event.preventDefault();
                    break;
                case 'Enter':
                    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'openIssue', {
                        keyPressed: 'enter',
                        issueKey: $b262f29a603e014b$export$4983e1eef8c41de4(activeIssueKey)
                    });
                    onOpenIssue();
                    event.preventDefault();
                    break;
                default:
                    break;
            }
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b262f29a603e014b$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("3V2vB", function(module, exports) {

$parcel$export(module.exports, "getColumnsForIssueTable", () => $dbd14750f632313e$export$7fd0c43240a64f42);

var $LFmXM = parcelRequire("LFmXM");


var $7WQX3 = parcelRequire("7WQX3");
const $dbd14750f632313e$var$getStylingOverrides = (fieldType)=>{
    if (fieldType === 'assignee' && !(0, $7WQX3.getFieldTypesEligibleForJsonDataAsSet)().has(fieldType)) return {
        minWidth: 100,
        maxWidth: 200,
        canBeMultiLine: true
    };
    if (fieldType === 'summary') return {
        minWidth: 262,
        maxWidth: 632,
        canBeMultiLine: true
    };
    return {};
};
const $dbd14750f632313e$export$7fd0c43240a64f42 = (0, $LFmXM.default)((columns, onSortOrderChanged)=>// @ts-expect-error - TS7006 - Parameter 'column' implicitly has an 'any' type.
    columns.map((column)=>{
        const { id: id, title: title, fieldType: fieldType, currentSorting: currentSorting = (0, $4ec7ec7f2cfbc873$export$c53d0f541b41b88e), sortable: sortable } = column;
        return {
            id: id,
            title: title,
            fieldType: fieldType,
            currentSorting: currentSorting,
            onSortOrderChanged: sortable ? onSortOrderChanged : undefined,
            ...$dbd14750f632313e$var$getStylingOverrides(column.fieldType)
        };
    }));
const $dbd14750f632313e$export$cd4e5573fbe2b576 = ()=>document.activeElement;

});

parcelRegister("dOXjW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e799e685d66b687a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $LFmXM = parcelRequire("LFmXM");

var $aBFKZ = parcelRequire("aBFKZ");

var $6uWhG = parcelRequire("6uWhG");

var $1KdDN = parcelRequire("1KdDN");

var $bi9FK = parcelRequire("bi9FK");

var $7jTnu = parcelRequire("7jTnu");

var $7j7HJ = parcelRequire("7j7HJ");

var $5SwkH = parcelRequire("5SwkH");

var $3I5Xj = parcelRequire("3I5Xj");

var $2IsS5 = parcelRequire("2IsS5");

var $anCpx = parcelRequire("anCpx");

var $ljej9 = parcelRequire("ljej9");


var $abeuj = parcelRequire("abeuj");

var $cfiRH = parcelRequire("cfiRH");
const $e799e685d66b687a$var$isEcClientEnabled = ()=>{
    const experiences = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $bi9FK.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-inline');
};
// min scroll offset before the offset changed callback is called
const $e799e685d66b687a$var$MIN_SCROLL_OFFSET_DELTA = 80;
const $e799e685d66b687a$var$hasQueueBecomeVisible = (prevProps, nextProps)=>!prevProps.isQueueVisible && nextProps.isQueueVisible;
const $e799e685d66b687a$var$hasQueueOrPageOrSortingChanged = (prevProps, nextProps)=>prevProps.queueId !== nextProps.queueId || prevProps.currentPage !== nextProps.currentPage || prevProps.isLoading !== nextProps.isLoading || prevProps.sortOrder !== nextProps.sortOrder || prevProps.sortedBy !== nextProps.sortedBy;
const $e799e685d66b687a$var$onIssueViewTransition = (0, $LFmXM.default)((queueId, projectKey, queueCategory, isQueueTransient, queuesPush, onSetIssueKey)=>{
    const push = (issueKey)=>{
        const path = isQueueTransient ? (0, $5SwkH.getIssueFragment)(issueKey) : `${(0, $5SwkH.getQueueFragment)((0, $2IsS5.fromQueueId)(queueId), queueCategory)}/${issueKey}`;
        queuesPush(path);
        onSetIssueKey(null);
    };
    return (0, $3I5Xj.getIssueTransitionOverride)(push);
});
// Init tenantContext for ECClient
const $e799e685d66b687a$var$SaveInlineMutations = ()=>{
    (0, $7j7HJ.useEcClient)();
    return null;
};
class $e799e685d66b687a$export$54ec01a60f47d33d extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.onIssueDataRequested = (startIndex)=>{
            const { onIssueDataRequested: onIssueDataRequested, isContentStale: isContentStale } = this.props;
            if (!this.isFirstUpdateAfterQueueChange && !isContentStale) onIssueDataRequested(startIndex);
            this.isFirstUpdateAfterQueueChange = false;
        }, this.onPageChange = (event, newPage, analyticsEvent)=>{
            this.props.onPageChange(event, newPage, analyticsEvent);
        }, this.onSetIssueTableRef = (ref)=>{
            this.issueTableRef = ref;
        }, this.onVerticalScrollOffsetChanged = (verticalPosition)=>{
            const { offsetFromTop: offsetFromTop } = verticalPosition;
            const { onVerticalScrollChanged: onVerticalScrollChanged } = this.props;
            let direction = (0, $f3fa5acbda0f3e0e$export$57022ca1771ad970);
            if (Math.abs(offsetFromTop - this.prevOffsetFromTop) > $e799e685d66b687a$var$MIN_SCROLL_OFFSET_DELTA) {
                // @ts-expect-error - TS2322 - Type '"UP" | "DOWN"' is not assignable to type '"UNCHANGED"'.
                direction = offsetFromTop > this.prevOffsetFromTop ? (0, $f3fa5acbda0f3e0e$export$28a694fb106a7f62) : (0, $f3fa5acbda0f3e0e$export$b5ad9376033e98b2);
                this.prevOffsetFromTop = offsetFromTop;
            }
            onVerticalScrollChanged && onVerticalScrollChanged({
                ...verticalPosition,
                direction: direction
            });
        }, this.isFirstUpdateAfterQueueChange = false;
        (0, $6uWhG.setMark)('jsd.performance.profile.queues.issuetable.mount');
        this.initECClientEnabled = $e799e685d66b687a$var$isEcClientEnabled();
    }
    componentDidMount() {
        if (this.props.canFocusTable) this.focusTable();
        this.props.onTableChange();
        this.prevOffsetFromTop = 0;
    }
    componentDidUpdate(prevProps) {
        if (this.props.canFocusTable && $e799e685d66b687a$var$hasQueueBecomeVisible(prevProps, this.props)) this.focusTable();
        if ($e799e685d66b687a$var$hasQueueOrPageOrSortingChanged(prevProps, this.props)) {
            this.isFirstUpdateAfterQueueChange = true;
            if (this.props.canFocusTable) this.focusTable();
            this.scrollToTop();
            this.props.onTableChange();
        }
    }
    scrollToTop() {
        const { issueTableRef: issueTableRef } = this;
        issueTableRef && issueTableRef.scrollToTop();
    }
    focusTable() {
        const { issueTableRef: issueTableRef } = this;
        issueTableRef && issueTableRef.focusContent();
    }
    render() {
        const { columns: columns, onActiveItemChanged: onActiveItemChanged, IssueTable: IssueTable, DemoDripFeed: DemoDripFeed, issueKeys: issueKeys, isContentStale: isContentStale, isLoading: isLoading, isQueueVisible: isQueueVisible, metricKey: metricKey, currentPage: currentPage, totalPages: totalPages, queueId: queueId, queueName: queueName, queueCategory: queueCategory, isQueueTransient: isQueueTransient, projectKey: projectKey, FieldDataSelector: FieldDataSelector, controlPolling: controlPolling, KeyboardShortcutListener: KeyboardShortcutListener, AsyncBulkActionToolbar: AsyncBulkActionToolbar, SelectedIssuesSubscriber: SelectedIssuesSubscriber, appProps: { cloudId: cloudId, fabricPfDirUrl: fabricPfDirUrl, atlassianAccountId: atlassianAccountId }, hasLoadedIssueDataFromCache: hasLoadedIssueDataFromCache, useJSMQueueDurationEvent: useJSMQueueDurationEvent, renderSidebarIcon: renderSidebarIcon, shouldRerenderRowOnHover: shouldRerenderRowOnHover, tableWidth: tableWidth, onSetSelectedIssueKeys: onSetSelectedIssueKeys, onRefreshSidebar: onRefreshSidebar, onSetIssueKey: onSetIssueKey, onNonPremiumSLAColumnError: onNonPremiumSLAColumnError } = this.props;
        const getIssueLinkOverride = (()=>{
            const queueUrl = (0, $5SwkH.getQueueUrl)({
                projectKey: (0, $ljej9.toProjectKey)(projectKey),
                category: queueCategory,
                queueId: Number(queueId)
            });
            return (issueKey)=>`${queueUrl}/${issueKey}`;
        })();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e799e685d66b687a$var$OuterContainer, {
            "data-testid": "servicedesk-queues-agent-view.layout.table.out"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e799e685d66b687a$var$Container, {
            "data-testid": "servicedesk-queues-agent-view.layout.table.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cfiRH.AgentTableApdexProvider), {
            queueId: queueId,
            isLoading: isLoading,
            isVisible: isQueueVisible,
            metricKey: metricKey,
            category: queueCategory,
            // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
            metric: (0, $abeuj.serviceViewPageLoad),
            hasLoadedIssueDataFromCache: hasLoadedIssueDataFromCache
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $anCpx.default), {
            projectKey: projectKey
        }, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e799e685d66b687a$var$IssueTableAnchor, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
                onError: onNonPremiumSLAColumnError,
                id: "queue-sidebar-bulk-edit-bug-fix",
                sendToPrivacyUnsafeSplunk: true,
                teamName: "jsd-shield",
                fallback: "unmount"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e799e685d66b687a$var$ToolbarPositioning, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AsyncBulkActionToolbar, {
                controlPolling: controlPolling,
                width: tableWidth
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SelectedIssuesSubscriber, null, ({ issueKeys: selectedIssueKeys })=>{
                onSetSelectedIssueKeys(selectedIssueKeys);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(KeyboardShortcutListener, {
                    isDisabled: isContentStale
                }, this.initECClientEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e799e685d66b687a$var$SaveInlineMutations, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssueTable, {
                    ref: this.onSetIssueTableRef,
                    isContentStale: isContentStale,
                    isDisabled: isContentStale,
                    columns: columns,
                    issueKeys: issueKeys,
                    selectedIssueKeys: selectedIssueKeys,
                    contentKey: String(queueId),
                    FieldDataSelector: FieldDataSelector,
                    onActiveItemChanged: onActiveItemChanged,
                    onIssueDataRequested: this.onIssueDataRequested,
                    onVerticalScrollOffsetChanged: this.onVerticalScrollOffsetChanged,
                    currentPage: currentPage,
                    onPageChange: this.onPageChange,
                    totalPages: totalPages,
                    appProps: {
                        cloudId: (0, $ljej9.toCloudId)(cloudId),
                        fabricPfDirUrl: fabricPfDirUrl,
                        atlassianAccountId: atlassianAccountId,
                        premiumSLAColumns: [
                            'issuekey',
                            'summary',
                            'reporter'
                        ]
                    },
                    shouldUseCssForRendering: (0, $7jTnu.fg)('css_support_for_virtual_table') ? true : undefined,
                    onIssueViewTransition: push ? $e799e685d66b687a$var$onIssueViewTransition(queueId, projectKey, queueCategory, isQueueTransient, push, onSetIssueKey) : undefined,
                    useJSMQueueDurationEvent: useJSMQueueDurationEvent,
                    renderSidebarIcon: renderSidebarIcon,
                    refreshSidebar: onRefreshSidebar,
                    shouldRerenderRowOnHover: shouldRerenderRowOnHover,
                    ariaLabel: queueName,
                    getIssueLinkOverride: getIssueLinkOverride
                }));
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DemoDripFeed, null)));
    }
}
var $e799e685d66b687a$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('queue', {
    onTableChange: 'viewed'
})($e799e685d66b687a$export$54ec01a60f47d33d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $e799e685d66b687a$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $e799e685d66b687a$var$OuterContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_bfhkvuon _1e0c1txw _16jlkb7n _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $e799e685d66b687a$var$ToolbarPositioning = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iu2gc _1ltvoahv _1pbyowjs",
            __cmplp.className
        ])
    });
});
const $e799e685d66b687a$var$IssueTableAnchor = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7j7HJ", function(module, exports) {

$parcel$export(module.exports, "useEcClient", () => $9d4e9f0dd4eb45da$export$9da409beb25e67da);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $lvKO5 = parcelRequire("lvKO5");

var $dklVu = parcelRequire("dklVu");
const $9d4e9f0dd4eb45da$export$9da409beb25e67da = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let tenantContext;
    try {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        tenantContext = (0, $lvKO5.useTenantContext)();
    } catch (e) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jsis-ec-client', `tenant context : ${e?.toString() || ''}`);
    }
    (0, $eJOHy.useEffect)(()=>{
        (0, $dklVu.EcClient).setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    }, [
        tenantContext
    ]);
    const saveIssueMutationToCache = (0, $eJOHy.useCallback)((issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $dklVu.default).saveIssueMutationToCache(issueMutation, key, analyticsFailureEventObj), []);
    const saveIssueMutationsToCache = (0, $eJOHy.useCallback)((issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $dklVu.default).saveIssueMutationsToCache(issueMutations, key, analyticsFailureEventObj), []);
    const searchAndReconcile = (0, $eJOHy.useCallback)((matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability)=>(0, $dklVu.default).searchAndReconcile(matchApiUrl, jqlMatchingKey, search, parseIssueData, capability), []);
    const getIssueMutationFromCache = (key)=>(0, $dklVu.default).getIssueMutationFromCache(key);
    return {
        saveIssueMutationToCache: saveIssueMutationToCache,
        saveIssueMutationsToCache: saveIssueMutationsToCache,
        searchAndReconcile: searchAndReconcile,
        getIssueMutationFromCache: getIssueMutationFromCache
    };
};

});

parcelRegister("3I5Xj", function(module, exports) {

$parcel$export(module.exports, "overrideTransitionsInCurrentTab", () => $c6e62181b5946288$export$d33e462dc45e1561);
$parcel$export(module.exports, "getIssueTransitionOverride", () => $c6e62181b5946288$export$e3b6c227a74390b8);
const $c6e62181b5946288$export$d33e462dc45e1561 = (push, event)=>{
    const { ctrlKey: ctrlKey, metaKey: metaKey } = event;
    // Let default browser behaviour occur when opening link in new tab/window
    // metaKey for macOS cmd. ctrKey for other OSes.
    if (ctrlKey || metaKey) return;
    event.preventDefault();
    push();
};
const $c6e62181b5946288$export$e3b6c227a74390b8 = (push)=>(issueKey, event)=>$c6e62181b5946288$export$d33e462dc45e1561(()=>push(issueKey), event);

});



parcelRegister("4nUR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $78bc6dbd94cb0074$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $4e0c9 = parcelRequire("4e0c9");
const $78bc6dbd94cb0074$var$LOCATION = 'servicedesk.queues.agent-view.view.layout.usage-sampler';
const $78bc6dbd94cb0074$var$INTERVAL = 300000;
class $78bc6dbd94cb0074$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        this.intervalId = window.setInterval(()=>this.forceUpdate(), $78bc6dbd94cb0074$var$INTERVAL);
    }
    componentDidCatch(error) {
        this.setState({
            hasError: true
        });
        (0, $gYnSx.default)({
            meta: {
                id: 'viewLayoutUsageSampling',
                packageName: 'jiraServicedeskQueuesAgentView',
                teamName: 'jsd-shield'
            },
            // @ts-expect-error - TS2345 - Argument of type 'Error' is not assignable to parameter of type 'string'.
            error: new Error(error)
        });
        (0, $eSnSE.default).safeErrorWithoutCustomerData($78bc6dbd94cb0074$var$LOCATION, `[FD-3358] Error while sampling usage: ${JSON.stringify(error && error.stack)}`);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        this.intervalId && window.clearInterval(this.intervalId);
    }
    render() {
        if (this.state.hasError) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4e0c9.default), null);
    }
}

});
parcelRegister("4e0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b16493c2856bc0e$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $aKfba = parcelRequire("aKfba");

var $gnQAk = parcelRequire("gnQAk");

var $2IsS5 = parcelRequire("2IsS5");

var $f20Bj = parcelRequire("f20Bj");

var $1TuhT = parcelRequire("1TuhT");

var $lc49q = parcelRequire("lc49q");

var $4LfWe = parcelRequire("4LfWe");

var $6I1gv = parcelRequire("6I1gv");

var $f2GC7 = parcelRequire("f2GC7");

var $g3HQC = parcelRequire("g3HQC");
const $3b16493c2856bc0e$var$mapStateToPropsFactory = ()=>{
    // @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    const onUpdateFactory = (0, $LFmXM.default)((queueId, state)=>(analyticsEvent)=>{
            (0, $aKfba.fireOperationalAnalytics)(analyticsEvent, {
                containerType: 'queue',
                containerId: `${(0, $2IsS5.fromQueueId)(queueId)}`,
                attributes: {
                    isAdmin: (0, $f20Bj.getIsAdmin)(state),
                    cachedIssueCount: (0, $1TuhT.getIssueCacheSize)(state),
                    availableIssueCount: (0, $1TuhT.getIssueCount)(state),
                    timeSinceIssueListInitialized: (0, $f2GC7.getTimeSinceIssueListInitialized)(state),
                    isQueueVisible: (0, $6I1gv.isQueueVisible)(state),
                    sortFieldType: (0, $4LfWe.getSortFieldType)(state),
                    sortOrder: (0, $4LfWe.getSortOrder)(state),
                    isDefaultSorting: !(0, $4LfWe.isManuallySorted)(state)
                }
            });
        });
    return (state)=>{
        const queueId = (0, $lc49q.getQueueId)(state);
        return {
            onUpdate: onUpdateFactory(queueId, state),
            state: // this is used to force re-renders on every state update due to use of `pure` option in react-redux v5
            state
        };
    };
};
var // @ts-expect-error - TS2769 - Argument of type 'null' is not assignable to parameter of type 'MergeProps<{ onUpdate: (analyticsEvent: any) => void; state: State; }, {}, {}, {}>'.
$3b16493c2856bc0e$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($3b16493c2856bc0e$var$mapStateToPropsFactory, {}, null, {
    // TODO: this option is deprecated react-redux v8
    pure: false,
    shouldHandleStateChanges: false
})((0, $g3HQC.default));

});
parcelRegister("f2GC7", function(module, exports) {

$parcel$export(module.exports, "getTimeSinceIssueListInitialized", () => $4415879d447c0ad8$export$4a764bf7fdeee8c4);

var $gPCSe = parcelRequire("gPCSe");

var $1TuhT = parcelRequire("1TuhT");
const $4415879d447c0ad8$export$4a764bf7fdeee8c4 = (state)=>Math.round((0, $gPCSe.default).now() - (0, $1TuhT.getTimeWhenLastInitialized)(state));

});

parcelRegister("g3HQC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6d752f8bba8921a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aBFKZ = parcelRequire("aBFKZ");
// eslint-disable-next-line jira/react/no-class-components
class $e6d752f8bba8921a$var$AnalyticsWrapper extends (0, $eJOHy.Component) {
    componentDidUpdate() {
        this.props.onUpdate();
    }
    render() {
        return null;
    }
}
var $e6d752f8bba8921a$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('UsageSampler', {
    onUpdate: 'sample'
})($e6d752f8bba8921a$var$AnalyticsWrapper);

});



parcelRegister("hbWqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1de2bc9958e33338$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cSmYj = parcelRequire("cSmYj");

var $6DCNy = parcelRequire("6DCNy");

var $6S4l2 = parcelRequire("6S4l2");

var $goZPP = parcelRequire("goZPP");

var $eIIrM = parcelRequire("eIIrM");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $gMRLG = parcelRequire("gMRLG");

var $dLR8J = parcelRequire("dLR8J");


var $bi9FK = parcelRequire("bi9FK");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $6gaEC = parcelRequire("6gaEC");

var $7j7HJ = parcelRequire("7j7HJ");

var $6pgof = parcelRequire("6pgof");

var $6zXPf = parcelRequire("6zXPf");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $ftN6c = parcelRequire("ftN6c");

var $1OHZM = parcelRequire("1OHZM");

var $hXSCp = parcelRequire("hXSCp");

var $kgX9J = parcelRequire("kgX9J");

var $foigc = parcelRequire("foigc");

var $jyorb = parcelRequire("jyorb");

var $epLTS = parcelRequire("epLTS");

var $2IsS5 = parcelRequire("2IsS5");

var $6J4Pv = parcelRequire("6J4Pv");

var $d6YIL = parcelRequire("d6YIL");

var $jlJsl = parcelRequire("jlJsl");

var $1KdDN = parcelRequire("1KdDN");

var $aiMPg = parcelRequire("aiMPg");

var $54C7g = parcelRequire("54C7g");

var $dhUMo = parcelRequire("dhUMo");

var $8tmyc = parcelRequire("8tmyc");

var $Y72S0 = parcelRequire("Y72S0");

var $e15rh = parcelRequire("e15rh");
const $1de2bc9958e33338$var$SEGMENT_KEY = 'queues-agent-view-layout-container-fallback';
const $1de2bc9958e33338$var$isEcClientEnabled = ()=>{
    const experiences = (0, $bi9FK.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
};
const $1de2bc9958e33338$var$JsmRepackagingBannerWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1de2bc9958e33338$var$jsmRepackagingBannerStyles
    }, children);
const $1de2bc9958e33338$var$SidebarIcon = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnKeyDown = (event)=>{
        if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter')) event.stopPropagation();
    };
    const onTooltipShow = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'queueSideBarIcon'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'sideBarIconShown');
    }; // TODO This should flip between sidebar/dialog message when that is implemented
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $dhUMo.default).openIssueInSidebarIssueTermRefresh : (0, $dhUMo.default).openIssueInSidebar),
        onShow: onTooltipShow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "aria-label": formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $dhUMo.default).openIssueInSidebarIssueTermRefresh : (0, $dhUMo.default).openIssueInSidebar),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eIIrM))), {
            spacing: "spacious",
            label: formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $dhUMo.default).openIssueInSidebarIssueTermRefresh : (0, $dhUMo.default).openIssueInSidebar)
        }),
        appearance: "subtle",
        spacing: "compact",
        onClick: props.onClickHandler,
        onKeyDown: handleOnKeyDown
    }));
};
const $1de2bc9958e33338$export$50ca98823369a55a = (props)=>{
    const { queue: queue, onQueueChanged: onQueueChanged } = props;
    const { id: id, completeJql: completeJql, isFavorite: isFavorite } = queue;
    const columns = JSON.stringify(queue.columns.map((column)=>column.id));
    (0, $eJOHy.useEffect)(()=>{
        // This is a state change during render, which is not ideal. See the comment around ServiceDeskAnalyticsContext#forceRenderWhileLoading:
        // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/src/packages/servicedesk/queues-agent-view/src/view/index.tsx#110
        onQueueChanged(queue); // `queue` and `onQueueChanged` are missing from below as refs change all the time, and we only want to call it once.
    // Below fields are enough to verify if queue changed.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id,
        completeJql,
        columns,
        isFavorite
    ]);
    return null;
};
const $1de2bc9958e33338$var$WINDOW_ACTIVE_EVENT = 'visibilitychange'; // eslint-disable-next-line jira/react/no-class-components
class $1de2bc9958e33338$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.state = {
            startTime: null
        };
        this.prevQueueId = this.props.queue.id;
    }
    componentDidMount() {
        const { queue: queue, issueCollection: issueCollection, issueCount: issueCount } = this.props;
        this.prevQueueId = queue.id;
        this.addNavigationEventListeners(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener($1de2bc9958e33338$var$WINDOW_ACTIVE_EVENT, this.props.onWindowFocus);
        this.triggerIssuesChange(issueCollection);
        this.triggerIssuesCountChange(issueCount);
        this.setStartTime();
    }
    componentDidUpdate(prevProps) {
        const { onboardingResolved: onboardingResolved, onOnboardingResolved: onOnboardingResolved, issueCount: issueCount, onAtLeastOneIssueLoaded: onAtLeastOneIssueLoaded, onWindowFocus: onWindowFocus, isQueueVisible: isQueueVisible, onPageVisibilityChanged: onPageVisibilityChanged, queue: queue, issueCollection: issueCollection } = this.props; // onAtLeastOneIssueLoaded() lets the monolith know that a issue has loaded (for onboarding purposes)
        if (!onboardingResolved && issueCount > 0) {
            onAtLeastOneIssueLoaded();
            onOnboardingResolved(true);
        }
        if (prevProps.onWindowFocus !== onWindowFocus) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener($1de2bc9958e33338$var$WINDOW_ACTIVE_EVENT, prevProps.onWindowFocus); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.addEventListener($1de2bc9958e33338$var$WINDOW_ACTIVE_EVENT, onWindowFocus);
        }
        if (prevProps.isQueueVisible !== isQueueVisible) onPageVisibilityChanged(isQueueVisible);
        prevProps.issueCollection !== issueCollection && this.triggerIssuesChange(issueCollection);
        prevProps.issueCount !== issueCount && this.triggerIssuesCountChange(issueCount);
        this.prevQueueId = queue.id;
    }
    componentWillUnmount() {
        this.removeNavigationEventListeners();
        this.props.onUnmount(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener($1de2bc9958e33338$var$WINDOW_ACTIVE_EVENT, this.props.onWindowFocus);
    }
    setStartTime() {
        const { startTime: startTime } = this.state;
        if (!startTime) this.setState({
            startTime: Date.now()
        });
    }
    getIsLoadingState() {
        const { isLoadingIssues: isLoadingIssues, queue: queue } = this.props;
        const { prevQueueId: prevQueueId } = this;
        if (prevQueueId !== queue.id) return true;
        return isLoadingIssues;
    }
    isLoadingQueues() {
        const { queue: queue } = this.props;
        const { prevQueueId: prevQueueId } = this;
        return prevQueueId !== queue.id;
    }
    addNavigationEventListeners() {
        const { onNavCollapseChange: onNavCollapseChange, sidebarApi: sidebarApi } = this.props;
        if (sidebarApi) {
            const { isCollapsed: isCollapsed, navActions: navActions } = sidebarApi;
            const { collapseStartAdd: collapseStartAdd, collapseStartClear: collapseStartClear, expandStartAdd: expandStartAdd, expandStartClear: expandStartClear } = navActions;
            onNavCollapseChange(isCollapsed);
            collapseStartAdd(()=>onNavCollapseChange(true));
            expandStartAdd(()=>onNavCollapseChange(false));
            this.removeNavListeners = ()=>{
                collapseStartClear();
                expandStartClear();
            };
        } else {
            const navigationApi = (0, $6J4Pv.createNavigationApi)();
            navigationApi.then((sidebar)=>{
                onNavCollapseChange(sidebar.isCollapsed());
                const removeCollapseListener = sidebar.onCollapseStart(()=>onNavCollapseChange(true));
                const removeExpandListener = sidebar.onExpandStart(()=>onNavCollapseChange(false));
                this.removeNavListeners = ()=>{
                    removeCollapseListener();
                    removeExpandListener();
                };
            }) // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(()=>{});
        }
    }
    removeNavigationEventListeners() {
        this.removeNavListeners && this.removeNavListeners();
    }
    triggerQueueChange() {
        const { queue: queue, onQueueChanged: onQueueChanged } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(this.prevQueue?.id, queue.id) || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(this.prevQueue?.completeJql, queue.completeJql) || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(this.prevQueue?.columns, queue.columns) || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(this.prevQueue?.isFavorite, queue.isFavorite)) onQueueChanged(queue);
    }
    triggerIssuesChange(issueCollection) {
        const { onIssuesChanged: onIssuesChanged } = this.props;
        onIssuesChanged && onIssuesChanged(issueCollection.map((issue)=>issue?.key));
    }
    triggerIssuesCountChange(issuesCount) {
        const { onIssuesCountChanged: onIssuesCountChanged } = this.props;
        onIssuesCountChanged?.(issuesCount);
    }
    renderView() {
        const { Table: Table, EmptyQueue: EmptyQueue, EmptyFilteredQueue: EmptyFilteredQueue, isQueueEmpty: isQueueEmpty, isCurrentDataFiltered: isCurrentDataFiltered, shouldShowBadFilterQueryError: shouldShowBadFilterQueryError, onFilterClear: onFilterClear, onIssueChange: onIssueChange, onSetIssueKey: onSetIssueKey, onNonPremiumSLAColumnError: onNonPremiumSLAColumnError, columns: columns, sidebarIssueKey: sidebarIssueKey, sidebarReactKey: sidebarReactKey } = this.props;
        if (this.isLoadingQueues()) // errorBoundary not necessary since core functionality is not visible
        return (0, $7jTnu.fg)('add_ufo_load_hold_to_custom_queue') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "table-with-issue-sidebar"
        }) : null;
        if (isCurrentDataFiltered && !this.getIsLoadingState() && shouldShowBadFilterQueryError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1de2bc9958e33338$var$EmptyStateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireTrackAnalytics), {
            eventName: "jsmQueueFiltering failed"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1de2bc9958e33338$var$EmptyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aiMPg.FilterQueryFailed), {
            onFilterClear: onFilterClear
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Table, null));
        if (isCurrentDataFiltered && isQueueEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1de2bc9958e33338$var$EmptyStateWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1de2bc9958e33338$var$EmptyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(EmptyFilteredQueue, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Table, null));
        if (isQueueEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(EmptyQueue, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1de2bc9958e33338$var$TableWithIssueSidebar, {
            Table: Table,
            onIssueChange: onIssueChange,
            onSetIssueKey: onSetIssueKey,
            columns: columns,
            issueKey: sidebarIssueKey,
            reactKey: sidebarReactKey,
            onError: onNonPremiumSLAColumnError
        });
    }
    renderWithoutSelectedIssuesContainer() {
        const { isInitialized: isInitialized, ErrorState: ErrorState, UsageSampler: UsageSampler, queue: { id: queueId }, NavUpdater: NavUpdater, showIssueFailureError: showIssueFailureError, isQueueVisible: isQueueVisible, ViewTracker: ViewTracker, QueuesBreadcrumb: QueuesBreadcrumb, IssueContextListener: IssueContextListener, ItsmContextListener: ItsmContextListener, projectKey: projectKey, category: category, onNonPremiumSLAColumnError: onNonPremiumSLAColumnError } = this.props;
        const isLoading = this.getIsLoadingState();
        if (!isInitialized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $foigc.default), null);
        if (showIssueFailureError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $epLTS.default), {
            projectKey: projectKey,
            category: category || (0, $jlJsl.NO_CATEGORY)
        }, (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Y72S0.default), {
                onDeleteComplete: actions.deleteItem
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d6YIL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8tmyc.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ErrorState, null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Y72S0.default), {
                onDeleteComplete: actions.deleteItem
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8tmyc.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ErrorState, null)))));
        const queueContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isQueueVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ViewTracker, {
            key: (0, $2IsS5.fromQueueIdString)(queueId),
            queueId: queueId
        }), (category === (0, $jlJsl.INCIDENTS) || category === (0, $jlJsl.POST_INCIDENT_REVIEWS)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jyorb.AsyncPostIncidentReviewBenefitModal), {
            queueCategory: category
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $epLTS.default), {
            projectKey: projectKey,
            category: category || (0, $jlJsl.NO_CATEGORY)
        }, (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
                onError: onNonPremiumSLAColumnError,
                id: "queue-nav-updater",
                sendToPrivacyUnsafeSplunk: true,
                teamName: "jsd-shield",
                fallback: "unmount"
            }, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NavUpdater, {
                queueId: queueId,
                onQueueIssueCountUpdated: actions.editItemIssueCount,
                onProjectStateHashUpdate: actions.refreshNavItems
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(UsageSampler, null)), !(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Y72S0.default), {
                onDeleteComplete: actions.deleteItem
            }))), (category === (0, $jlJsl.CHANGES) || category === (0, $jlJsl.INCIDENTS)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54C7g.JsmAssetsOnboarding), {
            category: category
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (category === (0, $jlJsl.CHANGES) || category === (0, $jlJsl.PROBLEMS)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6pgof.JsmRepackagingBanner), {
            workCategory: category,
            renderWrapper: $1de2bc9958e33338$var$JsmRepackagingBannerWrapper
        }), category === (0, $jlJsl.POST_INCIDENT_REVIEWS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6pgof.JsmRepackagingBanner), {
            workCategory: (0, $jlJsl.INCIDENTS),
            renderWrapper: $1de2bc9958e33338$var$JsmRepackagingBannerWrapper
        }), (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d6YIL.default), null, (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $1de2bc9958e33338$var$contentWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8tmyc.default), null), this.renderView()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8tmyc.default), null), this.renderView())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8tmyc.default), null), this.renderView())));
        if ((0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssueContextListener, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ItsmContextListener, {
            projectKey: projectKey
        }), false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: [
                (0, $6zXPf.getWillShowNav4)() ? $1de2bc9958e33338$var$layoutStyles : $1de2bc9958e33338$var$layoutStylesNav3,
                isQueueVisible ? $1de2bc9958e33338$var$visibleStyles : $1de2bc9958e33338$var$hiddenStyles
            ],
            testId: "servicedesk-queues-agent-view.layout.layout",
            "data-vc": `${$1de2bc9958e33338$var$SEGMENT_KEY}-ssr`,
            "data-ssr-placeholder": `${$1de2bc9958e33338$var$SEGMENT_KEY}-placeholder`
        }, queueContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: [
                (0, $6zXPf.getWillShowNav4)() ? $1de2bc9958e33338$var$layoutStyles : $1de2bc9958e33338$var$layoutStylesNav3,
                isQueueVisible ? $1de2bc9958e33338$var$visibleStyles : $1de2bc9958e33338$var$hiddenStyles
            ],
            testId: "servicedesk-queues-agent-view.layout.layout",
            "data-vc": $1de2bc9958e33338$var$SEGMENT_KEY,
            "data-ssr-placeholder-replace": `${$1de2bc9958e33338$var$SEGMENT_KEY}-placeholder`
        }, queueContent));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(QueuesBreadcrumb, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssueContextListener, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ItsmContextListener, {
            projectKey: projectKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1de2bc9958e33338$var$LayoutContainer, {
            visible: isQueueVisible,
            "data-testid": "servicedesk-queues-agent-view.layout.layout" // this is not a recommended format (above is preferred), but we need it for some Pollinator checks, fix with go/data-testid
            ,
            "data-test-id": "servicedesk-queues-agent-view.layout.layout",
            ...false && {
                'data-vc': `${$1de2bc9958e33338$var$SEGMENT_KEY}-ssr`,
                'data-ssr-placeholder': `${$1de2bc9958e33338$var$SEGMENT_KEY}-placeholder`
            },
            ...!false && {
                'data-vc': $1de2bc9958e33338$var$SEGMENT_KEY,
                'data-ssr-placeholder-replace': `${$1de2bc9958e33338$var$SEGMENT_KEY}-placeholder`
            }
        }, queueContent));
    }
    render() {
        const { queue: queue, itsmPractices: itsmPractices, issueCollection: issueCollection, issueCount: issueCount, projectKey: projectKey, projectId: projectId, columns: columns, jql: jql, onQueueChanged: onQueueChanged } = this.props;
        const { id: queueId } = queue;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
            attributes: {
                itsmPractices: itsmPractices
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6gaEC.SelectedIssuesContainer), {
            scope: `queue - ${(0, $2IsS5.fromQueueIdString)(queueId)}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hXSCp.LoadedIssuesContainer), {
            scope: `queue - ${(0, $2IsS5.fromQueueIdString)(queueId)}`,
            queueId: (0, $2IsS5.fromQueueIdString)(queueId),
            projectKey: projectKey,
            projectId: projectId,
            issueCollection: issueCollection,
            totalIssueCount: issueCount,
            columns: columns,
            jql: jql
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1de2bc9958e33338$export$50ca98823369a55a, {
            queue: queue,
            onQueueChanged: onQueueChanged
        }), this.renderWithoutSelectedIssuesContainer())));
    }
}
const { useResizeObserver: $1de2bc9958e33338$var$useResizeObserver } = (0, $1OHZM.createResizeObserverHook)({
    debouncePeriod: 50 // optional debouncing of resize notifications
});
const $1de2bc9958e33338$var$TableWithIssueSidebar = ({ Table: Table, onIssueChange: onIssueChange, onSetIssueKey: onSetIssueKey, onError: onError, issueKey: issueKey, reactKey: reactKey })=>{
    const [width, setWidth] = (0, $eJOHy.useState)(0);
    const [tableWidth, setTableWidth] = (0, $eJOHy.useState)(0);
    const [isResizing, setIsResizing] = (0, $eJOHy.useState)(false);
    const [startTime, setStartTime] = (0, $eJOHy.useState)(null);
    const throttledSetWidth = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(setWidth, 50), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)(); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let saveIssueMutationToCache;
    if ($1de2bc9958e33338$var$isEcClientEnabled()) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    saveIssueMutationToCache = (0, $7j7HJ.useEcClient)().saveIssueMutationToCache;
    const ref = (0, $eJOHy.useRef)(null);
    $1de2bc9958e33338$var$useResizeObserver({
        ref: ref,
        onResize () {
            setTableWidth(ref.current?.clientWidth ?? 0);
        }
    });
    const onChangeHandler = (event)=>{
        onIssueChange();
        (0, $kgX9J.saveIssueMutationAnalyticsToCache)(event, createAnalyticsEvent, saveIssueMutationToCache);
    };
    const renderSidebarIcon = (0, $eJOHy.useCallback)((selectedIssueKey)=>{
        const onClickHandler = ()=>{
            const sidebarIconClickEvent = createAnalyticsEvent({
                action: 'click',
                actionSubject: 'queueSideBarIcon'
            });
            (0, $gCeeo.fireTrackAnalytics)(sidebarIconClickEvent, 'sideBarIcon clicked');
            onSetIssueKey(selectedIssueKey);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1de2bc9958e33338$var$SidebarIcon, {
            onClickHandler: onClickHandler
        });
    }, [
        createAnalyticsEvent,
        onSetIssueKey
    ]);
    const onJSMQueueDurationEvent = (0, $eJOHy.useCallback)(()=>{
        if (startTime) {
            const duration = Date.now() - startTime;
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueIssue view', {
                duration: duration
            }); // Only fire after the first click
            setStartTime(null);
        }
    }, [
        createAnalyticsEvent,
        startTime
    ]);
    const onSidebarClose = (0, $eJOHy.useCallback)(()=>{
        onSetIssueKey(null);
    }, [
        onSetIssueKey
    ]);
    const onIssueDeleteSuccess = (0, $eJOHy.useCallback)(()=>{
        onSetIssueKey(null);
        onIssueChange();
    }, [
        onIssueChange,
        onSetIssueKey
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setStartTime(Date.now());
    }, [
        setStartTime
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1de2bc9958e33338$var$ViewWrapper, {
        "data-testid": "servicedesk-queues-agent-view.layout.tablecontainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1de2bc9958e33338$var$TableAndSidebarWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gMRLG.WidthObserver), {
        setWidth: throttledSetWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1de2bc9958e33338$var$TableWrapper, {
        "data-testid": "servicedesk-queues-agent-view.layout.table",
        isResizing: isResizing,
        withCssSupport: (0, $7jTnu.fg)('css_support_for_virtual_table'),
        ref: ref,
        shouldHideHorizontalBar: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Table, {
        renderSidebarIcon: renderSidebarIcon,
        shouldRerenderRowOnHover: true,
        useJSMQueueDurationEvent: onJSMQueueDurationEvent,
        width: width,
        tableWidth: tableWidth
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        onError: onError,
        id: "sidebar-issue-view",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jsd-shield",
        fallback: "unmount"
    }, issueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e15rh.SidebarIssueView), {
        key: reactKey,
        issueKey: issueKey,
        parentWidth: width,
        onClose: onSidebarClose,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        analyticsSource: (0, $d851676a1c983028$export$7063ee6d0035a982),
        setIsResizing: setIsResizing,
        onChange: onChangeHandler
    }))));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1de2bc9958e33338$var$LayoutContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visible: visible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2lx21bp4 _4t3i1i8v",
            __cmplp.visible ?? true ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1de2bc9958e33338$var$EmptyStateWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1c0ioahv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1de2bc9958e33338$var$EmptyWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _19pk9by0 _18u01ssb _t9ecg9dd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1de2bc9958e33338$var$ViewWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _kqswh2mm _1e0c1txw _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1de2bc9958e33338$var$TableWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withCssSupport: withCssSupport, shouldHideHorizontalBar: shouldHideHorizontalBar, isResizing: isResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jl11wp _p12f1osq",
            __cmplp.withCssSupport || __cmplp.shouldHideHorizontalBar ? "_1reo15vq _18m915vq" : "_1reo1wug _18m9ewfl",
            __cmplp.isResizing ? "_uiztglyw" : "_uizt1wug",
            __cmplp.className
        ])
    });
});
const $1de2bc9958e33338$var$TableAndSidebarWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    width: '100%'
});
const $1de2bc9958e33338$var$jsmRepackagingBannerStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.300'
});
const $1de2bc9958e33338$var$layoutStylesNav3 = (0, $1DXK0.xcss)({
    height: '100%',
    margin: 'space.0'
});
const $1de2bc9958e33338$var$layoutStyles = (0, $1DXK0.xcss)({
    height: '100%',
    margin: 'space.0',
    marginLeft: 'space.negative.300'
});
const $1de2bc9958e33338$var$hiddenStyles = (0, $1DXK0.xcss)({
    display: 'none'
});
const $1de2bc9958e33338$var$visibleStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
const $1de2bc9958e33338$var$contentWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 'space.300',
    paddingTop: 'space.100',
    height: '100%'
});

});
parcelRegister("eIIrM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8fa35c2d859c6465bf7d8e74ec194e5c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab77a706171fa497$var$_react = $ab77a706171fa497$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ab77a706171fa497$var$_panelRight = $ab77a706171fa497$var$_interopRequireDefault((parcelRequire("f4WMd")));

var $ab77a706171fa497$var$_detailView = $ab77a706171fa497$var$_interopRequireDefault((parcelRequire("H5mkF")));
function $ab77a706171fa497$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PanelRightIcon.
 * This component is PanelRightIcon, with `UNSAFE_fallbackIcon` set to "DetailViewIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab77a706171fa497$var$PanelRightIcon = (props)=>/*#__PURE__*/ $ab77a706171fa497$var$_react.default.createElement($ab77a706171fa497$var$_panelRight.default, Object.assign({
        LEGACY_fallbackIcon: $ab77a706171fa497$var$_detailView.default
    }, props));
$ab77a706171fa497$var$PanelRightIcon.Name = 'PanelRightIconMigration';
var $ab77a706171fa497$var$_default = module.exports.default = $ab77a706171fa497$var$PanelRightIcon;

});
parcelRegister("f4WMd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8b10c2aaa76d32294bc7ed1c0a1888df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afa4d2955554e918$var$_react = $afa4d2955554e918$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $afa4d2955554e918$var$_baseNew = $afa4d2955554e918$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $afa4d2955554e918$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PanelRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afa4d2955554e918$var$PanelRightIcon = (props)=>/*#__PURE__*/ $afa4d2955554e918$var$_react.default.createElement($afa4d2955554e918$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.5-.5H9.5v11H14a.5.5 0 0 0 .5-.5zM13 10v1.5h-2V10zm0-3v1.5h-2V7zm0-3v1.5h-2V4zM1.5 13a.5.5 0 0 0 .5.5h6v-11H2a.5.5 0 0 0-.5.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$afa4d2955554e918$var$PanelRightIcon.displayName = 'PanelRightIcon';
var $afa4d2955554e918$var$_default = module.exports.default = $afa4d2955554e918$var$PanelRightIcon;

});

parcelRegister("H5mkF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08182c7e1ed0b465$var$_react = $08182c7e1ed0b465$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $08182c7e1ed0b465$var$_panelRight = $08182c7e1ed0b465$var$_interopRequireDefault((parcelRequire("f4WMd")));
function $08182c7e1ed0b465$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $08182c7e1ed0b465$var$DetailViewIcon = (props)=>/*#__PURE__*/ $08182c7e1ed0b465$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14 17h6V7.01C20 7 14 7 14 7zM12 5h8c1.11 0 2 .9 2 2.01V17a2 2 0 0 1-2 2h-8zM2 7h8V5H3a1 1 0 0 0-1 1zm0 4h8V9H2zm0 7c0 .55.45 1 1 1h7v-2H2zm0-3h8v-2H2z"/></svg>`
    }, props, {
        newIcon: $08182c7e1ed0b465$var$_panelRight.default
    }));
$08182c7e1ed0b465$var$DetailViewIcon.displayName = 'DetailViewIcon';
var $08182c7e1ed0b465$var$_default = module.exports.default = $08182c7e1ed0b465$var$DetailViewIcon;

});


parcelRegister("gMRLG", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $fc07c79ce5b93db8$export$b2ad68b9bc407b80);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ghv3t = parcelRequire("ghv3t");
const $fc07c79ce5b93db8$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghv3t.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $fc07c79ce5b93db8$export$2e2bcd8739ae039 = $fc07c79ce5b93db8$export$b2ad68b9bc407b80;

});
parcelRegister("ghv3t", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $8fd70c84fe96dcaa$export$ff983d2a2b6112ea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1DXAa = parcelRequire("1DXAa");
const $8fd70c84fe96dcaa$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1DXAa.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("1DXAa", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $cca7bb4179e40d90$export$2f62ee6831462844);

var $eJOHy = parcelRequire("eJOHy");
function $cca7bb4179e40d90$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("6pgof", function(module, exports) {

$parcel$export(module.exports, "JsmRepackagingBanner", () => $90d482f0595f20bb$export$35e7cf278e8fd184);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $90d482f0595f20bb$var$AsyncJsmRepackagingBanner = (0, $bQWwW.lazy)(()=>(parcelRequire("jstUE")).then((module)=>module.JsmRepackagingBanner), {
    moduleId: "./src/packages/servicedesk/jsm-repackaging-banner/src/ui/index.tsx"
});
const $90d482f0595f20bb$export$35e7cf278e8fd184 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jsmRepackagingBanner",
        packageName: "jiraJsmRepackagingBanner",
        fallback: "unmount",
        teamName: "alexstrasza",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jsm-repackaging-banner",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($90d482f0595f20bb$var$AsyncJsmRepackagingBanner, props)));

});
parcelRegister("jstUE", function(module, exports) {

let $e2a7d5e1a2585388$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e2a7d5e1a2585388$var$load("l3lLS").then(()=>parcelRequire('1jeFe'));

});


parcelRegister("1OHZM", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $7c1c433db2df08f5$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $7c1c433db2df08f5$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $7c1c433db2df08f5$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $7c1c433db2df08f5$export$e58143dc89297272);

var $eJOHy = parcelRequire("eJOHy");

var $cOhmL = parcelRequire("cOhmL");
function $7c1c433db2df08f5$export$87a9d3e287304ae4(params) {
    const group = new (0, $cOhmL.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $eJOHy.useRef)(onResize);
        (0, $eJOHy.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $eJOHy.useCallback)(()=>onResizeRef.current(), []);
        (0, $eJOHy.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $7c1c433db2df08f5$export$683480f191c0e3ea, flushResizeObservers: $7c1c433db2df08f5$export$a181ef2a6d0a1bb6 } = $7c1c433db2df08f5$export$87a9d3e287304ae4();
function $7c1c433db2df08f5$export$e58143dc89297272({ ref: ref, useResizeObserverDI: // eslint-disable-next-line react-hooks/react-compiler
useResizeObserverDI = $7c1c433db2df08f5$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $eJOHy.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    // eslint-disable-next-line react-hooks/react-compiler
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("cOhmL", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $4b26b203cb8a861d$export$607798bbe2869c0);

var $aQK2r = parcelRequire("aQK2r");

var $3s8bj = parcelRequire("3s8bj");
class $4b26b203cb8a861d$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $aQK2r.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("hXSCp", function(module, exports) {

$parcel$export(module.exports, "LoadedIssuesContainer", () => $35630e5f04632e41$export$53928552b3ea6ee2);
$parcel$export(module.exports, "useLoadedIssues", () => $35630e5f04632e41$export$982ad9cb800a4cbf);

var $8dH3d = parcelRequire("8dH3d");

var $f0K4l = parcelRequire("f0K4l");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $35630e5f04632e41$var$getFieldIds = (columns)=>columns.map((col)=>col.id);
const $35630e5f04632e41$var$convertIssuesToKeyMap = (loadedIssues)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    loadedIssues.reduce((map, issue)=>{
        if (issue !== undefined && issue !== null) {
            const issueKeyToIdMap = map;
            issueKeyToIdMap[issue.key] = issue.id;
        }
        return map;
    }, {});
const $35630e5f04632e41$export$f23754098a438d57 = ()=>({ getState: getState, setState: setState }, { issueCollection: issueCollection, totalIssueCount: totalIssueCount, projectKey: projectKey, projectId: projectId, queueId: queueId, columns: columns, jql: jql })=>{
        const { issueKeyToIdMap: prevIssueKeyToIdMap, totalIssueCount: prevTotalIssueCount } = getState();
        if (!issueCollection || !totalIssueCount) return;
        const issueKeyToIdMap = $35630e5f04632e41$var$convertIssuesToKeyMap(issueCollection);
        if (totalIssueCount !== prevTotalIssueCount || !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))((0, (/*@__PURE__*/$parcel$interopDefault($f0K4l)))(Object.keys(issueKeyToIdMap), Object.keys(prevIssueKeyToIdMap)))) {
            const fieldIds = $35630e5f04632e41$var$getFieldIds(columns);
            const noUndefinedIssueCollection = issueCollection.filter((item)=>item);
            setState({
                issueKeyToIdMap: issueKeyToIdMap,
                totalIssueCount: totalIssueCount,
                fieldIds: fieldIds,
                issueCollection: noUndefinedIssueCollection,
                projectKey: projectKey,
                projectId: projectId,
                queueId: queueId,
                columns: columns,
                jql: jql
            });
        }
    };
const $35630e5f04632e41$var$smartActions = {
    setLoadedIssues: $35630e5f04632e41$export$f23754098a438d57
};
const $35630e5f04632e41$export$d4c72bab9d6cc13a = {
    issueKeyToIdMap: {},
    totalIssueCount: 0,
    fieldIds: [],
    issueCollection: [],
    queueId: '',
    projectKey: '',
    projectId: 0,
    columns: [],
    jql: ''
};
const $35630e5f04632e41$var$Store = (0, $GtRbT.createStore)({
    name: 'loaded-queue',
    initialState: $35630e5f04632e41$export$d4c72bab9d6cc13a,
    actions: $35630e5f04632e41$var$smartActions
});
const $35630e5f04632e41$export$53928552b3ea6ee2 = (0, $6E16M.createContainer)($35630e5f04632e41$var$Store, {
    onInit: $35630e5f04632e41$export$f23754098a438d57,
    onUpdate: $35630e5f04632e41$export$f23754098a438d57
});
const $35630e5f04632e41$export$b78ba1e2dbc48fb6 = (0, $ht3nQ.createSubscriber)($35630e5f04632e41$var$Store, {
    displayName: 'LoadedIssuesSubscriber'
});
const $35630e5f04632e41$export$982ad9cb800a4cbf = (0, $iJq0l.createHook)($35630e5f04632e41$var$Store);
var $35630e5f04632e41$export$2e2bcd8739ae039 = $35630e5f04632e41$var$Store;

});
parcelRegister("f0K4l", function(module, exports) {

var $821Ou = parcelRequire("821Ou");

var $l76qh = parcelRequire("l76qh");

var $hm1zt = parcelRequire("hm1zt");

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */ var $aeda977b669045b0$var$xor = $l76qh(function(arrays) {
    return $hm1zt($821Ou(arrays, $d1ShJ));
});
module.exports = $aeda977b669045b0$var$xor;

});
parcelRegister("hm1zt", function(module, exports) {

var $leN9Q = parcelRequire("leN9Q");

var $72Qfa = parcelRequire("72Qfa");

var $1txRh = parcelRequire("1txRh");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $ca25b5c1c14f707f$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $1txRh(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $leN9Q(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $1txRh($72Qfa(result, 1), iteratee, comparator);
}
module.exports = $ca25b5c1c14f707f$var$baseXor;

});



parcelRegister("kgX9J", function(module, exports) {

$parcel$export(module.exports, "saveIssueMutationAnalyticsToCache", () => $366750da19254242$export$75fba429fd9a065f);

var $bi9FK = parcelRequire("bi9FK");

var $87NxD = parcelRequire("87NxD");

var $hFgg4 = parcelRequire("hFgg4");

var $3VM8G = parcelRequire("3VM8G");
const $366750da19254242$var$isEcClientEnabled = ()=>{
    const experiences = (0, $bi9FK.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
};
const $366750da19254242$export$75fba429fd9a065f = (event, createAnalyticsEvent, /* saveIssueMutationToCache from useEcClient() */ saveIssueMutationToCache)=>{
    if ($366750da19254242$var$isEcClientEnabled() && event?.type === (0, $87NxD.ChangeEventTypes).FIELD_CHANGED) {
        const mutationFailedAnalyticsPayload = {
            errorMsg: 'FAILED_JSM_ISSUEVIEW',
            error: true
        };
        const analyticsEventObj = createAnalyticsEvent({});
        const analyticsDataKey = {
            analyticsEventObj: analyticsEventObj,
            analyticsMetadata: {
                scenario: 'jsm-issue-view',
                type: event.type
            }
        };
        saveIssueMutationToCache(new (0, $hFgg4.default)(event?.issueId, (0, $3VM8G.MutationSource).UPDATE), analyticsDataKey, mutationFailedAnalyticsPayload);
    }
};

});
parcelRegister("87NxD", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $bd046dbdd7555f37$export$8db21fc94823e1cc);
const $bd046dbdd7555f37$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $bd046dbdd7555f37$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $bd046dbdd7555f37$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $bd046dbdd7555f37$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $bd046dbdd7555f37$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $bd046dbdd7555f37$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $bd046dbdd7555f37$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $bd046dbdd7555f37$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $bd046dbdd7555f37$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $bd046dbdd7555f37$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $bd046dbdd7555f37$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $bd046dbdd7555f37$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $bd046dbdd7555f37$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $bd046dbdd7555f37$export$8db21fc94823e1cc = {
    [$bd046dbdd7555f37$var$FIELD_CHANGE_REQUESTED]: $bd046dbdd7555f37$var$FIELD_CHANGE_REQUESTED,
    [$bd046dbdd7555f37$var$FIELD_CHANGE_FAILED]: $bd046dbdd7555f37$var$FIELD_CHANGE_FAILED,
    [$bd046dbdd7555f37$var$FIELD_CHANGED]: $bd046dbdd7555f37$var$FIELD_CHANGED,
    [$bd046dbdd7555f37$var$ISSUE_TYPE_CHANGED]: $bd046dbdd7555f37$var$ISSUE_TYPE_CHANGED,
    [$bd046dbdd7555f37$var$ISSUE_RELATIONSHIP_UPDATED]: $bd046dbdd7555f37$var$ISSUE_RELATIONSHIP_UPDATED,
    [$bd046dbdd7555f37$var$ISSUE_LINKS_CREATED]: $bd046dbdd7555f37$var$ISSUE_LINKS_CREATED,
    [$bd046dbdd7555f37$var$ISSUE_LINK_DELETED]: $bd046dbdd7555f37$var$ISSUE_LINK_DELETED,
    [$bd046dbdd7555f37$var$CHILD_ISSUE_ADDED]: $bd046dbdd7555f37$var$CHILD_ISSUE_ADDED,
    [$bd046dbdd7555f37$var$SUBTASK_ADDED]: $bd046dbdd7555f37$var$SUBTASK_ADDED,
    [$bd046dbdd7555f37$var$ISSUE_CHILDREN_ORDER_CHANGED]: $bd046dbdd7555f37$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$bd046dbdd7555f37$var$CHILD_ISSUE_FIELD_UPDATED]: $bd046dbdd7555f37$var$CHILD_ISSUE_FIELD_UPDATED,
    [$bd046dbdd7555f37$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $bd046dbdd7555f37$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$bd046dbdd7555f37$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $bd046dbdd7555f37$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});


parcelRegister("jyorb", function(module, exports) {

$parcel$export(module.exports, "AsyncPostIncidentReviewBenefitModal", () => $43575ecf600c656f$export$1b5ddc821da26d04);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43575ecf600c656f$var$LazyPostIncidentReviewBenefitModal = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("7doHQ")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/post-incident-review-tour/src/ui/benefit-modal/index.tsx"
});
const $43575ecf600c656f$export$1b5ddc821da26d04 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "postIncidentReviewBenefitModalComponent",
        packageName: "jiraServiceDeskPostIncidentReviewTour",
        teamName: "itsm-agni",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "post-incident-review-benefit-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($43575ecf600c656f$var$LazyPostIncidentReviewBenefitModal, props)));

});
parcelRegister("7doHQ", function(module, exports) {

let $540ce96c810aa526$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $540ce96c810aa526$var$load("cll4u").then(()=>parcelRequire('kZicp'));

});


parcelRegister("6J4Pv", function(module, exports) {

$parcel$export(module.exports, "createNavigationApi", () => $3ccf40bdf306d3c7$export$b440baa5a08af532);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");
const $3ccf40bdf306d3c7$var$NAVIGATION_API_MODULE = 'servicedesk/jira/api';
// Try to require navigation api over 500ms, otherwise we'll fallback.
const $3ccf40bdf306d3c7$var$REQUIRE_TIMEOUT = 100;
const $3ccf40bdf306d3c7$var$REQUIRE_RETRIES = 5;
const $3ccf40bdf306d3c7$export$b440baa5a08af532 = ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $gjeS9.loadBridge)({
        name: $3ccf40bdf306d3c7$var$NAVIGATION_API_MODULE,
        timeout: $3ccf40bdf306d3c7$var$REQUIRE_TIMEOUT,
        tentatives: $3ccf40bdf306d3c7$var$REQUIRE_RETRIES,
        shouldLogError: false
    }).then((jiraApi)=>jiraApi.getNavigationApi());

});

parcelRegister("d6YIL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b98d1cc711e7c88$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $54CI2 = parcelRequire("54CI2");
var $guChT = parcelRequire("guChT");
var $d2s5v = parcelRequire("d2s5v");

var $8IeH1 = parcelRequire("8IeH1");

var $9zZj0 = parcelRequire("9zZj0");

var $lRq8t = parcelRequire("lRq8t");

var $4ARpn = parcelRequire("4ARpn");

var $1g6Je = parcelRequire("1g6Je");

var $6U97L = parcelRequire("6U97L");

var $k6qAI = parcelRequire("k6qAI");

var $9HHOs = parcelRequire("9HHOs");

var $2FqDG = parcelRequire("2FqDG");

var $2lG8T = parcelRequire("2lG8T");

var $7jTnu = parcelRequire("7jTnu");

var $bonwv = parcelRequire("bonwv");
const $8b98d1cc711e7c88$var$SPOTLIGHT_TARGET_ID = 'jsm-nav4-queues-popout';
const $8b98d1cc711e7c88$var$SPOTLIGHT_MESSAGE_ID = 'jsm-nav4-queues-popout-spotlight';
const $8b98d1cc711e7c88$var$QueuesPopoutSpotlight = ({ stop: stop, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        onDismiss?.();
        stop?.();
    }, [
        onDismiss,
        stop
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>[
            {
                onClick: onClick,
                text: formatMessage((0, $bonwv.default).spotlightDismissButtonLabel)
            }
        ], [
        onClick,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d2s5v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), {
        actions: actions,
        dialogPlacement: "right top",
        heading: formatMessage((0, $bonwv.default).spotlightHeading),
        key: $8b98d1cc711e7c88$var$SPOTLIGHT_TARGET_ID,
        target: $8b98d1cc711e7c88$var$SPOTLIGHT_TARGET_ID,
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        messageId: $8b98d1cc711e7c88$var$SPOTLIGHT_MESSAGE_ID,
        messageType: "engagement"
    }, formatMessage((0, $bonwv.default).spotlightMessage)));
};
const $8b98d1cc711e7c88$var$QueuesPopoutPanelNav4 = ({ children: children })=>{
    const [projectKeyFromPath] = (0, $2FqDG.usePathParam)('projectKey');
    const [practiceFromPath] = (0, $2FqDG.usePathParam)('practiceType');
    const categoryFromPath = (0, $k6qAI.toItsmPractice)(practiceFromPath);
    const [isSpotlightDismissed, setIsSpotlightDismissed] = (0, $eJOHy.useState)(false);
    const categoryStateKey = (0, $1g6Je.getCategoryStateKey)(projectKeyFromPath || '', categoryFromPath);
    const [isPoppedOut] = (0, $1g6Je.usePoppedOutState)(categoryStateKey);
    const popoutConfig = (0, $2lG8T.usePopoutConfig)(projectKeyFromPath || '', categoryFromPath);
    const onSpotlightDismiss = (0, $eJOHy.useCallback)(()=>{
        setIsSpotlightDismissed(true);
    }, [
        setIsSpotlightDismissed
    ]);
    const practiceQueues = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: $8b98d1cc711e7c88$var$SPOTLIGHT_TARGET_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6U97L.PracticeQueues), {
        key: categoryStateKey,
        projectKey: projectKeyFromPath || '',
        practice: categoryFromPath
    }))), isPoppedOut && !isSpotlightDismissed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9zZj0.default), {
        messageId: $8b98d1cc711e7c88$var$SPOTLIGHT_MESSAGE_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b98d1cc711e7c88$var$QueuesPopoutSpotlight, {
        onDismiss: onSpotlightDismiss
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ARpn.default), {
        isPoppedOut: (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? popoutConfig.isPoppedOut : isPoppedOut,
        popoutComponent: practiceQueues
    }, children);
};
var $8b98d1cc711e7c88$export$2e2bcd8739ae039 = $8b98d1cc711e7c88$var$QueuesPopoutPanelNav4;

});
parcelRegister("4ARpn", function(module, exports) {

$parcel$export(module.exports, "default", () => $787edcccc2577625$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $787edcccc2577625$var$PopoutPanelNav4 = ({ isPoppedOut: isPoppedOut, popoutComponent: popoutComponent, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $787edcccc2577625$var$rootContainerStyles
    }, isPoppedOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $787edcccc2577625$var$popoutPanelContainerStyles
    }, popoutComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $787edcccc2577625$var$mainContentContainerStyles
    }, children));
var $787edcccc2577625$export$2e2bcd8739ae039 = $787edcccc2577625$var$PopoutPanelNav4;
// Styles
const $787edcccc2577625$var$rootContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    height: '100%',
    width: '100%',
    overflow: 'hidden'
});
const $787edcccc2577625$var$popoutPanelContainerStyles = (0, $1DXK0.xcss)({
    borderRightWidth: "var(--ds-border-width, 1px)",
    borderRightColor: 'color.border',
    borderRightStyle: 'solid',
    paddingRight: 'space.150',
    marginRight: 'space.150',
    minWidth: '280px',
    width: '280px',
    overflowY: 'auto'
});
const $787edcccc2577625$var$mainContentContainerStyles = (0, $1DXK0.xcss)({
    flexDirection: 'column',
    display: 'flex',
    height: '100%',
    width: '100%',
    overflowX: 'hidden'
});

});

parcelRegister("1g6Je", function(module, exports) {

$parcel$export(module.exports, "getCategoryStateKey", () => $342cbf78f4b9021a$export$6075a80438f902e4);
$parcel$export(module.exports, "CategoryStateContainer", () => $342cbf78f4b9021a$export$d25429b1c35bc216);
$parcel$export(module.exports, "usePoppedOutState", () => $342cbf78f4b9021a$export$abcb35f5af9dd85b);
$parcel$export(module.exports, "useLastVisitedQueueId", () => $342cbf78f4b9021a$export$c2c81ffd0b8349b);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");

var $gYnSx = parcelRequire("gYnSx");

var $b0Tmn = parcelRequire("b0Tmn");

var $aEgVO = parcelRequire("aEgVO");
const $342cbf78f4b9021a$export$f08a5758b7b88593 = 50;
const $342cbf78f4b9021a$export$939aa9619c650220 = 2419200000; // 28 days in milliseconds
const $342cbf78f4b9021a$var$createUpdateAction = (projectKey, practice, stateKey, value)=>({ setState: setState, getState: getState }, { accountId: accountId })=>{
        const currentState = getState();
        const categoryKey = $342cbf78f4b9021a$export$6075a80438f902e4(projectKey, practice);
        const newState = {
            ...currentState,
            [categoryKey]: {
                ...currentState[categoryKey] || {},
                [stateKey]: value,
                latestUpdateTimestamp: Date.now()
            }
        };
        setState(newState);
        // Save an evicted state to local storage to prevent unbounded growth.
        const evictedState = (0, $b0Tmn.getEvictedState)(newState, $342cbf78f4b9021a$export$f08a5758b7b88593, $342cbf78f4b9021a$export$939aa9619c650220);
        if (accountId && (0, $7jTnu.fg)('jsm_queue_sidebar_category_state_migration_to_be')) (0, $aEgVO.updateQueueCategoryState)(evictedState, accountId);
        if (!accountId && (0, $7jTnu.fg)('jsm_queue_sidebar_category_state_migration_to_be')) (0, $gYnSx.default)({
            error: new Error('Missing accountId while updating queue nav4 sidebar category state.'),
            meta: {
                id: 'updateJsmQueueSidebarNav4CategoryStateMissingAccountIdError',
                packageName: 'jira-servicedesk-queues-nav4',
                teamName: 'jsm-flash'
            }
        });
        (0, $b0Tmn.setQueuesCategoryStateInLocalStorage)(evictedState);
    };
const $342cbf78f4b9021a$export$e324594224ef24da = {
    updatePoppedOutState: (projectKey, practice, isPoppedOut)=>$342cbf78f4b9021a$var$createUpdateAction(projectKey, practice, 'isPoppedOut', isPoppedOut),
    updateLastVisitedQueueId: (projectKey, practice, queueId)=>$342cbf78f4b9021a$var$createUpdateAction(projectKey, practice, 'lastVisitedQueueId', queueId),
    updateIsStarredExpanded: (projectKey, practice, isExpanded)=>$342cbf78f4b9021a$var$createUpdateAction(projectKey, practice, 'isStarredExpanded', isExpanded),
    updateExpandedGroups: (projectKey, practice, groups)=>$342cbf78f4b9021a$var$createUpdateAction(projectKey, practice, 'expandedGroups', groups),
    updateIsAllQueuesOpen: (projectKey, practice, isOpen)=>$342cbf78f4b9021a$var$createUpdateAction(projectKey, practice, 'isAllQueuesOpen', isOpen)
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $342cbf78f4b9021a$var$initialState = {};
const $342cbf78f4b9021a$var$Store = (0, $GtRbT.createStore)({
    name: 'jsm-queues-category-state-store',
    initialState: $342cbf78f4b9021a$var$initialState,
    actions: $342cbf78f4b9021a$export$e324594224ef24da
});
const $342cbf78f4b9021a$export$d25429b1c35bc216 = (0, $6E16M.createContainer)($342cbf78f4b9021a$var$Store, {
    onInit: ()=>({ setState: setState }, { initState: initState })=>{
            if (initState) {
                setState(initState);
                return;
            }
            const stateFromStorage = (0, $b0Tmn.getQueuesCategoryStateFromLocalStorage)();
            if (stateFromStorage) setState(stateFromStorage);
        }
});
const $342cbf78f4b9021a$export$abcb35f5af9dd85b = (0, $iJq0l.createHook)($342cbf78f4b9021a$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.isPoppedOut || false
});
const $342cbf78f4b9021a$export$c2c81ffd0b8349b = (0, $iJq0l.createHook)($342cbf78f4b9021a$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.lastVisitedQueueId || null
});
const $342cbf78f4b9021a$export$ef6285e9e3666377 = (0, $iJq0l.createHook)($342cbf78f4b9021a$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.isStarredExpanded || false
});
const $342cbf78f4b9021a$export$b68699ca40ca80b8 = (0, $iJq0l.createHook)($342cbf78f4b9021a$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.expandedGroups || []
});
const $342cbf78f4b9021a$export$6862a7823efdc851 = (0, $iJq0l.createHook)($342cbf78f4b9021a$var$Store, {
    selector: (state, categoryKey)=>state[categoryKey]?.isAllQueuesOpen || false
});
const $342cbf78f4b9021a$export$6075a80438f902e4 = (projectKey, practice)=>`${projectKey}-${practice}`;

});
parcelRegister("b0Tmn", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY_NAV_LOCATION", () => $697d02ae94efbdea$export$3c59a089fdd2614a);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_CATEGORY", () => $697d02ae94efbdea$export$9b99689db482a6bb);
$parcel$export(module.exports, "getQueueGroupsNavStateFromLocalStorage", () => $697d02ae94efbdea$export$4fd3d85560a2aca5);
$parcel$export(module.exports, "setQueueGroupsNavStateInLocalStorage", () => $697d02ae94efbdea$export$ea2ee3f5179c6fdf);
$parcel$export(module.exports, "getQueuesCategoryStateFromLocalStorage", () => $697d02ae94efbdea$export$8832e9ccc1e52b0d);
$parcel$export(module.exports, "setQueuesCategoryStateInLocalStorage", () => $697d02ae94efbdea$export$a5f3ae7965a4cde5);
$parcel$export(module.exports, "getEvictedState", () => $697d02ae94efbdea$export$9aa04626df46f655);

var $dnU6V = parcelRequire("dnU6V");
const $697d02ae94efbdea$export$3c59a089fdd2614a = 'queue-groups-nav-state';
const $697d02ae94efbdea$export$9b99689db482a6bb = 'queues-category-state';
const $697d02ae94efbdea$export$aa821bfb3308a1f5 = (0, $dnU6V.createLocalStorageProvider)('servicedesk_queues');
const $697d02ae94efbdea$export$4fd3d85560a2aca5 = ()=>{
    try {
        const item = $697d02ae94efbdea$export$aa821bfb3308a1f5.get($697d02ae94efbdea$export$3c59a089fdd2614a);
        return item || undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return undefined;
    }
};
const $697d02ae94efbdea$export$ea2ee3f5179c6fdf = (value)=>{
    try {
        $697d02ae94efbdea$export$aa821bfb3308a1f5.set($697d02ae94efbdea$export$3c59a089fdd2614a, value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* empty */ }
};
const $697d02ae94efbdea$export$8832e9ccc1e52b0d = ()=>{
    try {
        const item = $697d02ae94efbdea$export$aa821bfb3308a1f5.get($697d02ae94efbdea$export$9b99689db482a6bb);
        return item || undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return undefined;
    }
};
const $697d02ae94efbdea$export$a5f3ae7965a4cde5 = (value)=>{
    try {
        $697d02ae94efbdea$export$aa821bfb3308a1f5.set($697d02ae94efbdea$export$9b99689db482a6bb, value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* empty */ }
};
const $697d02ae94efbdea$export$9aa04626df46f655 = (state, maxCacheLength, maxCacheTime)=>{
    const stateEntries = Object.entries(state);
    const stateLen = stateEntries.length;
    const sortedDescStateEntries = stateEntries.sort((a, b)=>b[1].latestUpdateTimestamp - a[1].latestUpdateTimestamp);
    const numStateValuesToKeep = Math.min(stateLen, maxCacheLength);
    const stateValuesToKeep = sortedDescStateEntries.slice(0, numStateValuesToKeep);
    const oldestAllowedTimestamp = Date.now() - maxCacheTime;
    const newState = {};
    stateValuesToKeep.forEach(([key, value])=>{
        if (value.latestUpdateTimestamp >= oldestAllowedTimestamp) newState[key] = state[key];
    });
    return newState;
};

});

parcelRegister("aEgVO", function(module, exports) {

$parcel$export(module.exports, "updateQueueGroupsNavStateToUserProperty", () => $65b06c601da8c57c$export$1bfe5d7fffd97c75);
$parcel$export(module.exports, "updateQueueCategoryState", () => $65b06c601da8c57c$export$c60e63e314d1ad13);

var $FppkK = parcelRequire("FppkK");

var $b0Tmn = parcelRequire("b0Tmn");
const $65b06c601da8c57c$var$MISSING_ACCOUNT_ID_ERROR_MSG = 'accountId is missing.';
const $65b06c601da8c57c$export$1bfe5d7fffd97c75 = (navState, accountId)=>{
    if (!accountId) throw new Error($65b06c601da8c57c$var$MISSING_ACCOUNT_ID_ERROR_MSG);
    return (0, $FppkK.setUserProperties)(accountId, (0, $b0Tmn.LOCAL_STORAGE_KEY_NAV_LOCATION), JSON.stringify(navState));
};
const $65b06c601da8c57c$export$c60e63e314d1ad13 = (categoryState, accountId)=>{
    if (!accountId) throw new Error($65b06c601da8c57c$var$MISSING_ACCOUNT_ID_ERROR_MSG);
    return (0, $FppkK.setUserProperties)(accountId, (0, $b0Tmn.LOCAL_STORAGE_KEY_CATEGORY), JSON.stringify(categoryState));
};

});


parcelRegister("6U97L", function(module, exports) {

$parcel$export(module.exports, "PracticeQueues", () => $458a225037ec5691$export$9720502a768ac6d4);

var $eJOHy = parcelRequire("eJOHy");

var $5RKoQ = parcelRequire("5RKoQ");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $hya93 = parcelRequire("hya93");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $3qMzf = parcelRequire("3qMzf");



var $1M9bZ = parcelRequire("1M9bZ");

var $hvtB6 = parcelRequire("hvtB6");

var $b1IkX = parcelRequire("b1IkX");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");

var $dRr4h = parcelRequire("dRr4h");

var $fCuNJ = parcelRequire("fCuNJ");

var $3fKYX = parcelRequire("3fKYX");

var $jlJsl = parcelRequire("jlJsl");

var $k6qAI = parcelRequire("k6qAI");

var $2FqDG = parcelRequire("2FqDG");

var $59Vy3 = parcelRequire("59Vy3");

var $iVxQJ = parcelRequire("iVxQJ");

var $5h7v8 = parcelRequire("5h7v8");

var $1g6Je = parcelRequire("1g6Je");

var $71f18 = parcelRequire("71f18");

var $2lG8T = parcelRequire("2lG8T");

var $EqIKa = parcelRequire("EqIKa");

var $3KpGc = parcelRequire("3KpGc");

var $bK1c8 = parcelRequire("bK1c8");

var $is8TG = parcelRequire("is8TG");

var $fOHa9 = parcelRequire("fOHa9");
const $458a225037ec5691$var$PracticeQueuesError = ({ onRefresh: onRefresh })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        padding: "space.100"
    }, formatMessage((0, $3KpGc.messages).fetchQueuesError, {
        button: (buttonLabel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                spacing: "none",
                appearance: "link",
                onClick: onRefresh
            }, buttonLabel)
    }));
};
const $458a225037ec5691$var$connectItemAnalytics = {
    actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524),
    level: 4
};
const $458a225037ec5691$var$forgeItemAnalytics = {
    actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524),
    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
    level: 4
};
const $458a225037ec5691$var$PracticeQueuesInternal = ({ practice: practice, projectKey: projectKey })=>{
    const currentCategory = practice || (0, $jlJsl.NO_CATEGORY);
    const queueCustomContext = (0, $dRr4h.useQueueCustomRouterContext)(projectKey);
    const [, { updateLastVisitedQueueId: updateLastVisitedQueueId }] = (0, $1g6Je.useLastVisitedQueueId)((0, $1g6Je.getCategoryStateKey)(projectKey, currentCategory));
    const { data: queueConnectItems } = (0, $1M9bZ.useConnectAppNavigationData)(projectKey, (0, $3qMzf.staticJSMProjectConnectAddonsNavigationResource));
    const [queues, queuesLoading, queuesError, methods, refreshQueues] = (0, $3fKYX.useCategorizedNavItems)(projectKey, currentCategory, queueCustomContext);
    const popoutConfig = (0, $2lG8T.usePopoutConfig)(projectKey, currentCategory);
    const [projectKeyFromPath] = (0, $2FqDG.usePathParam)('projectKey');
    const [queueIdFromPath] = (0, $2FqDG.usePathParam)('queueId');
    const [practiceFromPath] = (0, $2FqDG.usePathParam)('practiceType');
    const categoryFromPath = (0, $k6qAI.toItsmPractice)(practiceFromPath);
    const queueFromPath = queues?.find((queue)=>queue.id === queueIdFromPath);
    const [selectedNavLocation, { updateSelectedNavLocation: updateSelectedNavLocation }] = (0, $5h7v8.useSelectedNavLocation)(queueIdFromPath || '');
    const [groups, groupsLoading, groupsFetchingError, refreshGroups] = (0, $fCuNJ.usePriorityGroups)(currentCategory, queueCustomContext);
    const [issueCountEnabledQueues, { updateIssueCountEnabledQueues: updateIssueCountEnabledQueues }] = (0, $iVxQJ.useIssueCountEnabledQueues)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $59Vy3.useOnFavoritesChanged)(projectKey, practice || (0, $jlJsl.NO_CATEGORY), queues, methods.editItemFavorite);
    const isInvalidNavLocation = (0, $eJOHy.useCallback)(()=>{
        if (queueIdFromPath) {
            if (!queueFromPath?.starred && selectedNavLocation.section === (0, $71f18.QueueListSection).STARRED) return true;
        }
        return false;
    }, [
        queueIdFromPath,
        queueFromPath,
        selectedNavLocation
    ]);
    const selectDefaultNavLocation = (0, $eJOHy.useCallback)(()=>{
        if (queueIdFromPath === undefined) return;
        // Queue is in starred section
        if (queueFromPath?.starred) {
            updateSelectedNavLocation(queueIdFromPath, (0, $71f18.QueueListSection).STARRED);
            return;
        }
        // Queue is in priority group
        const firstGroupWithQueue = groups.find((group)=>group.queues.includes(Number(queueIdFromPath)));
        if (firstGroupWithQueue) {
            updateSelectedNavLocation(queueIdFromPath, (0, $71f18.QueueListSection).PRIORITY_GROUP, firstGroupWithQueue.id);
            return;
        }
        // Queue is in all queues section
        updateSelectedNavLocation(queueIdFromPath, (0, $71f18.QueueListSection).ALL_QUEUES);
    }, [
        queueIdFromPath,
        queueFromPath,
        groups,
        updateSelectedNavLocation
    ]);
    const disableIssueCountRefreshForAllQueues = (0, $eJOHy.useCallback)(()=>{
        if (issueCountEnabledQueues.length > 0) {
            methods.enableIssueCountForSelectedQueues([]);
            updateIssueCountEnabledQueues([]);
        }
    }, [
        issueCountEnabledQueues,
        methods,
        updateIssueCountEnabledQueues
    ]);
    const enableIssueCountRefreshForSelectedQueues = (0, $eJOHy.useCallback)((newQueues)=>{
        if (!queues) return;
        // Enable issue-counts for starred queues as well
        const starredQueues = queues.filter((queue)=>queue.starred).map((queue)=>Number(queue.id));
        const queuesToRefresh = Array.from(new Set([
            ...newQueues,
            ...starredQueues
        ]));
        // If the queues to enable have not changed, do nothing
        if ((0, (/*@__PURE__*/$parcel$interopDefault($5RKoQ)))(queuesToRefresh, issueCountEnabledQueues)) return;
        // Refresh issue count for the newly visible queues in the selected group
        const newlyVisibleQueuesInSelectedGroup = queuesToRefresh.filter((queueId)=>!issueCountEnabledQueues.includes(queueId)).map((queueId)=>String(queueId));
        methods.refreshIssueCountForItems(newlyVisibleQueuesInSelectedGroup);
        updateIssueCountEnabledQueues(queuesToRefresh);
        // Enable issue count for the selected queues - group queues only
        methods.enableIssueCountForSelectedQueues(newQueues);
    }, [
        queues,
        methods,
        issueCountEnabledQueues,
        updateIssueCountEnabledQueues
    ]);
    // Enable issue-counts refresh for the correct queues for the current nav location
    (0, $eJOHy.useEffect)(()=>{
        if (!queueIdFromPath) {
            disableIssueCountRefreshForAllQueues();
            return;
        }
        const inSelectedProject = projectKey === projectKeyFromPath;
        const inSelectedCategory = currentCategory === categoryFromPath;
        const shouldUpdateIssueCounts = !inSelectedProject || !inSelectedCategory || groupsLoading || groupsFetchingError || queuesLoading || queuesError;
        if (shouldUpdateIssueCounts) return;
        // If the queue does not have a valid section, set a default location
        if (selectedNavLocation.section === undefined || isInvalidNavLocation()) {
            selectDefaultNavLocation();
            return;
        }
        // update the last visited queue for this category in local storage and user properties
        !(0, $7jTnu.fg)('sidebar_category_state_migration_step_2') && updateLastVisitedQueueId(projectKey, currentCategory, queueIdFromPath);
        // enable issue count refresh for the selected queues
        const selectedGroup = groups.find((group)=>group.id === selectedNavLocation.groupId);
        enableIssueCountRefreshForSelectedQueues(selectedGroup?.queues || []);
    }, [
        projectKey,
        projectKeyFromPath,
        queueIdFromPath,
        groups,
        groupsLoading,
        groupsFetchingError,
        selectedNavLocation,
        issueCountEnabledQueues,
        selectDefaultNavLocation,
        isInvalidNavLocation,
        disableIssueCountRefreshForAllQueues,
        enableIssueCountRefreshForSelectedQueues,
        updateLastVisitedQueueId,
        currentCategory,
        categoryFromPath,
        queuesLoading,
        queuesError
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // update the last visited queue for this category in local storage and user properties
        queueIdFromPath && (0, $7jTnu.fg)('sidebar_category_state_migration_step_2') && updateLastVisitedQueueId(projectKey, currentCategory, queueIdFromPath);
    }, [
        projectKey,
        currentCategory,
        queueIdFromPath,
        updateLastVisitedQueueId
    ]);
    // analytics
    (0, $eJOHy.useEffect)(()=>{
        if (!queues && !queuesLoading) return;
        if (queuesError) (0, $gYnSx.default)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: queuesError,
            meta: {
                id: 'jsmQueuesListError',
                packageName: 'jiraServicedeskQueuesNav4',
                teamName: 'jsd-shield'
            }
        });
        else (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'nav4PracticeQueueNavItemsWithQueueGroups rendered', {
            projectKey: projectKey,
            category: currentCategory,
            packageName: 'jiraServicedeskQueuesNav4',
            teamName: 'jsd-shield'
        });
    }, [
        createAnalyticsEvent,
        currentCategory,
        queues,
        queuesError,
        projectKey,
        queuesLoading
    ]);
    if (queuesError) {
        if (!(0, $7jTnu.fg)('update_viewqueuesnav_instrumentation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($458a225037ec5691$var$PracticeQueuesError, {
            onRefresh: refreshQueues
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceFailureTracker), {
            location: "failed-fetching-initial-data",
            failureEventAttributes: {
                errorName: queuesError.name,
                errorMessage: queuesError.message,
                errorStack: queuesError.stack
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($458a225037ec5691$var$PracticeQueuesError, {
            onRefresh: refreshQueues
        }));
    }
    if ((0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: popoutConfig.isPoppedOut ? $458a225037ec5691$var$poppedOutPadding : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fOHa9.StarredSection), {
        practice: currentCategory,
        projectKey: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $is8TG.QueueGroupsSection), {
        projectKey: projectKey,
        currentCategory: currentCategory,
        onGroupDataRefresh: refreshGroups
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EqIKa.AllQueuesSection), {
        practice: currentCategory,
        projectKey: projectKey
    }), (!practice || practice === (0, $jlJsl.NO_CATEGORY)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hvtB6.ConnectMenu), {
        items: queueConnectItems,
        showIcons: true,
        connectItemAnalytics: $458a225037ec5691$var$connectItemAnalytics
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b1IkX.ForgeServiceDeskQueueSection), {
        projectKey: projectKey,
        analytics: $458a225037ec5691$var$forgeItemAnalytics
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fOHa9.StarredSection), {
        practice: currentCategory,
        projectKey: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $is8TG.QueueGroupsSection), {
        projectKey: projectKey,
        currentCategory: currentCategory,
        onGroupDataRefresh: refreshGroups
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $EqIKa.AllQueuesSection), {
        practice: currentCategory,
        projectKey: projectKey
    }), (!practice || practice === (0, $jlJsl.NO_CATEGORY)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hvtB6.ConnectMenu), {
        items: queueConnectItems,
        showIcons: true,
        connectItemAnalytics: $458a225037ec5691$var$connectItemAnalytics
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b1IkX.ForgeServiceDeskQueueSection), {
        projectKey: projectKey,
        analytics: $458a225037ec5691$var$forgeItemAnalytics
    })));
};
const $458a225037ec5691$export$10907166f9acd1f7 = ({ practice: practice, projectKey: projectKey })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bK1c8.QueuesExperienceTracker), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($458a225037ec5691$var$PracticeQueuesInternal, {
        practice: practice,
        projectKey: projectKey
    }));
};
const $458a225037ec5691$export$9720502a768ac6d4 = (0, $bJscI.componentWithFG)('update_viewqueuesnav_instrumentation', $458a225037ec5691$export$10907166f9acd1f7, $458a225037ec5691$var$PracticeQueuesInternal);
const $458a225037ec5691$var$poppedOutPadding = (0, $1DXK0.xcss)({
    padding: 'space.300',
    paddingTop: 'space.250'
});

});
parcelRegister("5RKoQ", function(module, exports) {

var $dyMwB = parcelRequire("dyMwB");

var $4455e5022623bf0b$var$func = $dyMwB('isEqual', (parcelRequire("cSmYj")));

$4455e5022623bf0b$var$func.placeholder = (parcelRequire("k1T10"));
module.exports = $4455e5022623bf0b$var$func;

});

const $16a7021d28f78da7$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $16a7021d28f78da7$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';
const $16a7021d28f78da7$export$8ebfc84e07851700 = 'moreProjectsSearch';

const $493796f3bdee881c$export$4165a3d0da3bd147 = 'fixedItem';
const $493796f3bdee881c$export$95b0c331af13d819 = 'fixedItemButton';
const $493796f3bdee881c$export$74712b62056d422e = 'fixedItemAction';
const $493796f3bdee881c$export$3ac911b122986477 = 'customItem';
const $493796f3bdee881c$export$9bd6c21d500ae611 = 'customItemButton';
const $493796f3bdee881c$export$5374c2c2d3ece55e = 'customItemAction';
const $493796f3bdee881c$export$56981f28056f258e = 'customItemDropdownAction';
const $493796f3bdee881c$export$17bca95234dea43b = 'fixedItemDropdownAction';

parcelRegister("1M9bZ", function(module, exports) {

$parcel$export(module.exports, "useConnectAppNavigationData", () => $fc81095b6bc124b9$export$4e0e21a37979b45e);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $4J9V1 = parcelRequire("4J9V1");
const $fc81095b6bc124b9$export$4e0e21a37979b45e = (projectKey, resource)=>{
    const { data: data, ...rest } = (0, $bo7Z6.useResourceWithCustomRouterContext)(resource, {
        matchParams: {
            projectKey: projectKey
        }
    });
    const connectDataItems = (0, $eJOHy.useMemo)(()=>data?.map((0, $4J9V1.transformLinkV4))?.filter(Boolean) || null, [
        data
    ]);
    return {
        data: connectDataItems,
        ...rest
    };
};

});

parcelRegister("hvtB6", function(module, exports) {

$parcel$export(module.exports, "ConnectMenu", () => $a9203dbb56eb3417$export$19d0925d424b864a);

var $eJOHy = parcelRequire("eJOHy");

var $2FyzM = parcelRequire("2FyzM");

var $jvpZv = parcelRequire("jvpZv");
const $a9203dbb56eb3417$export$19d0925d424b864a = ({ items: items, showIcons: showIcons = false, shouldFilter: shouldFilter = true, connectItemAnalytics: connectItemAnalytics })=>{
    const filteredItems = (0, $2FyzM.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, filteredItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvpZv.ConnectItem), {
            key: item.id,
            item: item,
            showIcons: showIcons,
            analytics: connectItemAnalytics
        })));
};

});
parcelRegister("jvpZv", function(module, exports) {

$parcel$export(module.exports, "ConnectItem", () => $5c6098c65607d0d7$export$8bb4bcea44a3c9ea);

var $eJOHy = parcelRequire("eJOHy");

var $3Q6BV = parcelRequire("3Q6BV");

var $8n30H = parcelRequire("8n30H");
var $1Bb7G = parcelRequire("1Bb7G");
var $7Z9EK = parcelRequire("7Z9EK");

var $jUPZ1 = parcelRequire("jUPZ1");

var $8xDPn = parcelRequire("8xDPn");


var $lTN3C = parcelRequire("lTN3C");

var $bo95Y = parcelRequire("bo95Y");

var $4QtKR = parcelRequire("4QtKR");

var $jRu18 = parcelRequire("jRu18");

var $eYtNM = parcelRequire("eYtNM");
const $5c6098c65607d0d7$export$8bb4bcea44a3c9ea = ({ item: item, showIcons: showIcons, analytics: analytics, level: level = analytics.level, appId: appId = item.id })=>{
    const { addNew: addNew } = (0, $jUPZ1.useConnectItemClickHistory)();
    const icon = (0, $eJOHy.useMemo)(()=>{
        if (showIcons !== true) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QtKR.ForgeIcon), {
            url: item.iconUrl
        });
    }, [
        showIcons,
        item.iconUrl
    ]);
    const location = (0, $jRu18.useLocation)();
    const query = (0, $eYtNM.useQuery)();
    const getIsCurrentLocationMatchItemUrl = (0, $eJOHy.useCallback)((itemUrl)=>{
        if (!itemUrl) return false;
        // match pathname and query params
        // code adapted from src/packages/navigation-apps/sidebar/common/src/common/ui/menu-item/main.tsx
        const currentLocation = {
            ...location,
            query: query
        };
        const urlMatcher = (0, $8xDPn.matchUrlExact)();
        const itemLocation = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(itemUrl || '/', true);
        // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
        return urlMatcher(currentLocation, itemLocation);
    }, [
        location,
        query
    ]);
    const isItemSelected = (0, $eJOHy.useMemo)(()=>getIsCurrentLocationMatchItemUrl(item.url), [
        item.url,
        getIsCurrentLocationMatchItemUrl
    ]);
    const itemAnalytics = (0, $eJOHy.useMemo)(()=>{
        const initialLevel = analytics.level;
        const currentLevel = level;
        const isNestedItem = currentLevel - initialLevel > 0;
        return {
            ...analytics,
            componentType: (0, $493796f3bdee881c$export$3ac911b122986477),
            level: level,
            itemType: isNestedItem ? 'appSubpage' : 'app',
            itemId: item.id,
            parentItemType: isNestedItem ? 'app' : undefined,
            parentItemId: isNestedItem ? appId : undefined
        };
    }, [
        analytics,
        appId,
        level,
        item.id
    ]);
    const getIsChildSelected = (0, $eJOHy.useCallback)((parentItem)=>parentItem.items?.some((child)=>getIsCurrentLocationMatchItemUrl(child.url) || getIsChildSelected(child)) ?? false, [
        getIsCurrentLocationMatchItemUrl
    ]);
    const isChildSelected = (0, $eJOHy.useMemo)(()=>getIsChildSelected(item), [
        item,
        getIsChildSelected
    ]);
    const onItemClick = (0, $eJOHy.useCallback)(()=>{
        item.url != null && addNew(item.url);
    }, [
        addNew,
        item.url
    ]);
    const anchorElement = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        // inject style class names used by Connect app js to attach event listener to display modal dialog
        if (item.styleClass) {
            const classes = item.styleClass.split(' ').map((className)=>className.trim()).filter(Boolean).filter((className)=>anchorElement.current?.classList?.contains(className) === false);
            anchorElement.current?.classList?.add(...classes);
        }
    }, [
        item.styleClass
    ]);
    // nested menu items (for 1 App, or 1 menu item of an App)
    if (item.items && item.items.length > 0) {
        const childSections = item.items.filter((child)=>child.section);
        const isAllSectionsUnnamed = childSections.length > 0 && childSections.every((section)=>!section.name);
        const menuContent = item.items.map((child, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), {
                key: child.id
            }, isAllSectionsUnnamed && child.section && index > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8n30H.Divider), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5c6098c65607d0d7$export$8bb4bcea44a3c9ea, {
                item: child,
                showIcons: false,
                level: level ? level + 1 : undefined,
                appId: appId,
                analytics: analytics
            })));
        return item.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Bb7G.ExpandableMenuItem), {
            isDefaultExpanded: item.section || isChildSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTN3C.default), {
            elemBefore: icon,
            analytics: itemAnalytics
        }, item.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, menuContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, menuContent);
    }
    // if no nested menu items
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: itemAnalytics,
        elemBefore: icon,
        href: item.url ?? '',
        isSelected: isItemSelected,
        ref: anchorElement,
        onClick: onItemClick
    }, item.name);
};

});
parcelRegister("lTN3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8ba3a90889d5720$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fFq5m = parcelRequire("fFq5m");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $b8ba3a90889d5720$export$3776992222b2b40f = {
    EXPAND: 'expand',
    COLLAPSE: 'collapse'
};
const $b8ba3a90889d5720$var$ExpandableMenuItemTriggerWithAnalytics = ({ analytics: analytics, onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleClick = (event, analyticsEvent, { isExpanded: isExpanded })=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), actionSubjectId, {
            ...analyticsAttributes,
            expandAction: isExpanded ? $b8ba3a90889d5720$export$3776992222b2b40f.EXPAND : $b8ba3a90889d5720$export$3776992222b2b40f.COLLAPSE
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
};
var $b8ba3a90889d5720$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.forwardRef)($b8ba3a90889d5720$var$ExpandableMenuItemTriggerWithAnalytics);

});

parcelRegister("4QtKR", function(module, exports) {

$parcel$export(module.exports, "ForgeIcon", () => $8bcd31fd394b5754$export$fe0464db4dc93ab4);

var $eJOHy = parcelRequire("eJOHy");

var $kcLaf = parcelRequire("kcLaf");

var $6l5yN = parcelRequire("6l5yN");
const $8bcd31fd394b5754$export$fe0464db4dc93ab4 = ({ url: url })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6l5yN.ContainerAvatar), {
        src: url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kcLaf))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    });

});



parcelRegister("b1IkX", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $8064b7ec58737162$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgeServiceDeskQueueSection", () => $8064b7ec58737162$export$a133aa9cc8b5e080);

var $eJOHy = parcelRequire("eJOHy");

var $aeOhE = parcelRequire("aeOhE");

var $g9x9X = parcelRequire("g9x9X");

var $fohjD = parcelRequire("fohjD");

var $ePLco = parcelRequire("ePLco");

var $cIeoi = parcelRequire("cIeoi");

var $10vUC = parcelRequire("10vUC");

var $euVUL = parcelRequire("euVUL");
const $8064b7ec58737162$export$ed6342e0e28465a6 = (extension, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `/jira/servicedesk/projects/${projectKey}/queues/apps/${appId}/${envId}`;
};
const $8064b7ec58737162$export$a133aa9cc8b5e080 = ({ projectKey: projectKey, analytics: analytics })=>{
    const { data: data } = (0, $10vUC.useServiceDeskQueueForgeAppsNav4)(projectKey);
    if (!data?.length || !projectKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g9x9X.TriggerAnalyticsWrapper), null, data.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $euVUL.ForgeItem), {
            key: extension.id,
            id: extension.id,
            analytics: analytics,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $8064b7ec58737162$export$ed6342e0e28465a6(extension, projectKey),
            name: extension.properties.title,
            sections: (0, $cIeoi.toSections)(extension),
            iconUrl: extension.properties.icon,
            showIcon: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE)
        }
    }));
};

});
parcelRegister("g9x9X", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $6b8a739d74e689b8$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $6b8a739d74e689b8$export$e1a79e3d472c925a);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $aeOhE = parcelRequire("aeOhE");

var $9gq2c = parcelRequire("9gq2c");
const $6b8a739d74e689b8$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $6b8a739d74e689b8$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE),
        moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("10vUC", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskQueueForgeApps", () => $9094fe08f163a507$export$8a2bb837db423089);
$parcel$export(module.exports, "useServiceDeskQueueForgeAppsNav4", () => $9094fe08f163a507$export$52b0be0dcb122e71);

var $eJOHy = parcelRequire("eJOHy");

var $kU13U = parcelRequire("kU13U");

var $hHbzj = parcelRequire("hHbzj");

var $bo7Z6 = parcelRequire("bo7Z6");

var $f0kD3 = parcelRequire("f0kD3");
const $9094fe08f163a507$export$8a2bb837db423089 = (routeName, parentStack, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $hHbzj.forgeServiceDeskQueueModuleResource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const serviceDeskQueueData = (0, $eJOHy.useMemo)(()=>data?.filter?.((0, $kU13U.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $eJOHy.useMemo)(()=>data?.filter?.((0, $kU13U.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const stack = (0, $f0kD3.useForgeItemStack)(serviceDeskQueueData, routeName, parentStack);
    return (0, $eJOHy.useMemo)(()=>({
            data: serviceDeskQueueData,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        serviceDeskQueueData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $9094fe08f163a507$export$52b0be0dcb122e71 = (projectKey)=>$9094fe08f163a507$export$8a2bb837db423089(undefined, undefined, projectKey);

});
parcelRegister("kU13U", function(module, exports) {

$parcel$export(module.exports, "isExtensionVisible", () => $6d662423b598e6b2$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $6d662423b598e6b2$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $6d662423b598e6b2$export$5c38dfa9d1f96e61);
const $6d662423b598e6b2$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $6d662423b598e6b2$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $6d662423b598e6b2$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $6d662423b598e6b2$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});

parcelRegister("f0kD3", function(module, exports) {

$parcel$export(module.exports, "useForgeItemStack", () => $7c0ac0c2556405af$export$462f82a278743d46);

var $eJOHy = parcelRequire("eJOHy");

var $ew1wJ = parcelRequire("ew1wJ");

var $gCY1z = parcelRequire("gCY1z");

var $cIeoi = parcelRequire("cIeoi");
const $7c0ac0c2556405af$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
    const [{ match: match, route: route }] = (0, $gCY1z.useRouter)();
    const matchedExtension = (0, $ew1wJ.useMatchedExtension)({
        modules: modules,
        match: match
    });
    return (0, $eJOHy.useMemo)(()=>{
        if (route.name !== routeName) return null;
        // match nested navigation view
        if (matchedExtension && (0, $cIeoi.toSections)(matchedExtension).length) {
            const stackId = `${matchedExtension.id}-subpages`;
            return parentStack ? [
                ...parentStack,
                stackId
            ] : [
                stackId
            ];
        }
        // match a simple navigation item (a single top-level page is defined in the manifest)
        if (matchedExtension && parentStack) return parentStack;
        // skip
        return null;
    }, [
        matchedExtension,
        parentStack,
        route.name,
        routeName
    ]);
};

});


parcelRegister("euVUL", function(module, exports) {

$parcel$export(module.exports, "ForgeItem", () => $af531e8059fb799c$export$26a5287439a1d287);

var $eJOHy = parcelRequire("eJOHy");

var $1Bb7G = parcelRequire("1Bb7G");
var $7Z9EK = parcelRequire("7Z9EK");

var $iMZxW = parcelRequire("iMZxW");

var $lTN3C = parcelRequire("lTN3C");

var $jRu18 = parcelRequire("jRu18");

var $4QtKR = parcelRequire("4QtKR");

var $eaBoL = parcelRequire("eaBoL");

var $estpl = parcelRequire("estpl");
const $af531e8059fb799c$export$26a5287439a1d287 = (props)=>{
    const { id: itemId, url: url, showIcon: showIcon, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides, analytics: analytics } = props;
    const location = (0, $jRu18.useLocation)();
    const shouldExpandAsDefault = (0, $eJOHy.useMemo)(()=>location.pathname.includes(url), [
        url,
        location
    ]);
    const onNestedMenuItemClick = (0, $eJOHy.useCallback)((event)=>{
        if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event);
        return ()=>null;
    }, [
        overrides
    ]);
    const itemAnalytics = (0, $eJOHy.useMemo)(()=>{
        return {
            ...analytics,
            itemType: 'app',
            componentType: 'customItem',
            itemId: itemId
        };
    }, [
        analytics,
        itemId
    ]);
    const expandableItemAnalytics = (0, $eJOHy.useMemo)(()=>{
        return {
            ...itemAnalytics,
            level: 2,
            itemType: 'appSubpage',
            parentItemType: 'app'
        };
    }, [
        itemAnalytics
    ]);
    if (!sections?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $estpl.ForgeItemSimple), {
        ...props,
        analytics: itemAnalytics
    });
    if (overrides?.showSelectedAppMenuOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eaBoL.ForgeItemExpandable), {
        ...props,
        analytics: itemAnalytics
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Bb7G.ExpandableMenuItem), {
        isDefaultExpanded: shouldExpandAsDefault
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTN3C.default), {
        elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QtKR.ForgeIcon), {
            url: iconUrl
        }) : undefined,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMZxW.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        testId: `navigation-sidebar.project-menu.forge-app.${itemId}.expandable-menu-item-trigger.root`,
        analytics: itemAnalytics,
        onClick: onNestedMenuItemClick
    }, (0, $iMZxW.nameWithCustomEnvironment)(name, environmentType, environmentKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eaBoL.ForgeItemExpandable), {
        ...props,
        analytics: expandableItemAnalytics
    })));
};

});
parcelRegister("eaBoL", function(module, exports) {

$parcel$export(module.exports, "ForgeItemExpandable", () => $c598ae4d995c2c0a$export$532bd53ddb8882b3);

var $eJOHy = parcelRequire("eJOHy");

var $8n30H = parcelRequire("8n30H");
var $1Bb7G = parcelRequire("1Bb7G");
var $7Z9EK = parcelRequire("7Z9EK");
var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");

var $lHD3D = parcelRequire("lHD3D");

var $lTN3C = parcelRequire("lTN3C");

var $bo95Y = parcelRequire("bo95Y");

var $206hf = parcelRequire("206hf");

var $4QtKR = parcelRequire("4QtKR");
const $c598ae4d995c2c0a$var$createPageUrl = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
const $c598ae4d995c2c0a$var$ForgeItemExpandableWithHeader = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $206hf.useGetLinkProps)();
    const { id: itemId, url: url, section: section, analytics: analytics } = props;
    const subItemAnalytics = (0, $eJOHy.useMemo)(()=>analytics && {
            ...analytics,
            level: analytics && analytics.level + 1
        }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Bb7G.ExpandableMenuItem), {
        isDefaultExpanded: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTN3C.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QtKR.ForgeIcon), null),
        analytics: analytics
    }, section.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
            key: page.route,
            ...getLinkProps($c598ae4d995c2c0a$var$createPageUrl(url, page.route)),
            analytics: subItemAnalytics,
            onClick: ()=>{
                (0, $lHD3D.forgeModulesConcurrentLoadTime)(itemId).start({
                    startTime: performance.now()
                });
            }
        }, page.title)))));
};
const $c598ae4d995c2c0a$var$ForgeItemExpandableWithoutHeader = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $206hf.useGetLinkProps)();
    const { showIcon: showIcon, id: itemId, url: url, section: section, analytics: analytics } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
            key: page.route,
            elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QtKR.ForgeIcon), {
                url: page.icon
            }) : undefined,
            ...getLinkProps($c598ae4d995c2c0a$var$createPageUrl(url, page.route)),
            analytics: analytics,
            onClick: ()=>{
                (0, $lHD3D.forgeModulesConcurrentLoadTime)(itemId).start({
                    startTime: performance.now()
                });
            }
        }, page.title)));
};
const $c598ae4d995c2c0a$export$532bd53ddb8882b3 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, sections: sections, analytics: analytics } = props;
    const hasSectionsWithHeader = sections?.some((section)=>!!section.header);
    return sections?.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, typeof section.header === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c598ae4d995c2c0a$var$ForgeItemExpandableWithHeader, {
            id: itemId,
            section: section,
            url: url,
            showIcon: showIcon,
            analytics: analytics
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !hasSectionsWithHeader && index !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8n30H.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c598ae4d995c2c0a$var$ForgeItemExpandableWithoutHeader, {
            id: itemId,
            section: section,
            url: url,
            showIcon: showIcon,
            analytics: analytics
        })))));
};

});

parcelRegister("estpl", function(module, exports) {

$parcel$export(module.exports, "ForgeItemSimple", () => $a9e2f0e4cda36aae$export$df3259e43d89ee7b);

var $eJOHy = parcelRequire("eJOHy");

var $lHD3D = parcelRequire("lHD3D");

var $iMZxW = parcelRequire("iMZxW");

var $bo95Y = parcelRequire("bo95Y");

var $206hf = parcelRequire("206hf");

var $4QtKR = parcelRequire("4QtKR");
const $a9e2f0e4cda36aae$export$df3259e43d89ee7b = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $206hf.useGetLinkProps)();
    const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, overrides: overrides, analytics: analytics } = props;
    if (overrides?.showSelectedAppMenuOnly) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: analytics,
        elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QtKR.ForgeIcon), {
            url: iconUrl
        }) : undefined,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMZxW.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        ...getLinkProps(url, {
            shouldMatchExactPath: false
        }),
        onClick: ()=>{
            (0, $lHD3D.forgeModulesConcurrentLoadTime)(itemId).start({
                startTime: performance.now()
            });
        }
    }, (0, $iMZxW.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};

});



parcelRegister("dRr4h", function(module, exports) {

$parcel$export(module.exports, "useQueueCustomRouterContext", () => $5d55afc458842dd2$export$f7c5cd815dd083e4);

var $eJOHy = parcelRequire("eJOHy");

var $gCY1z = parcelRequire("gCY1z");
const $5d55afc458842dd2$export$f7c5cd815dd083e4 = (projectKey)=>{
    const [{ match: match }] = (0, $gCY1z.useRouter)();
    return (0, $eJOHy.useMemo)(()=>projectKey ? {
            matchParams: {
                ...match.params,
                projectKey: projectKey
            }
        } : undefined, [
        match.params,
        projectKey
    ]);
};

});

parcelRegister("fCuNJ", function(module, exports) {

$parcel$export(module.exports, "usePriorityGroupsActions", () => $5636402cfc7019b2$export$aceb895c0a1bdb9);
$parcel$export(module.exports, "usePriorityGroupData", () => $5636402cfc7019b2$export$e41417e5a9e40e44);
$parcel$export(module.exports, "usePriorityGroups", () => $5636402cfc7019b2$export$9ad7fd5c13dc6dbb);
$parcel$export(module.exports, "useCategorizedGroupsNavItems", () => $5636402cfc7019b2$export$7ddc2fd096cdc650);
$parcel$export(module.exports, "useNormalizedPriorityGroups", () => $5636402cfc7019b2$export$c2e9f9150500e785);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $2aY2d = parcelRequire("2aY2d");

var $bo7Z6 = parcelRequire("bo7Z6");

var $dZRaT = parcelRequire("dZRaT");

var $aGQ56 = parcelRequire("aGQ56");

var $kEUB1 = parcelRequire("kEUB1");

var $kfvK2 = parcelRequire("kfvK2");
var $2FqDG = parcelRequire("2FqDG");
var $eJrcF = parcelRequire("eJrcF");

var $jEt3L = parcelRequire("jEt3L");

var $3fKYX = parcelRequire("3fKYX");

var $6nQcV = parcelRequire("6nQcV");
// these routes use priority groups data and all have
// the project context listed as route resource which
// is a dependency resource for priorityGroupByProjectIdResourceSsr
const $5636402cfc7019b2$var$queueRouteNames = new Set([
    'servicedesk-queues-custom-view',
    'servicedesk-practice-custom-view',
    'servicedesk-queues-custom-issue-detail',
    'servicedesk-practice-custom-and-issue',
    'servicedesk-queues-manage-view',
    'servicedesk-practice-manage-view'
]);
const $5636402cfc7019b2$var$updateGroup = (updatedGroup, groups)=>groups.map((g)=>g.id === updatedGroup.id ? {
            ...g,
            name: updatedGroup.name,
            version: updatedGroup.version,
            queues: updatedGroup.queueIds
        } : g);
const $5636402cfc7019b2$var$deleteGroup = (id, groups)=>groups.filter((group)=>group.id !== id);
const $5636402cfc7019b2$var$updateQueueGroups = (updatedGroups, groups)=>groups.map((group)=>{
        const matchedGroup = updatedGroups?.find((updatedGroup)=>updatedGroup.group.id === group.id);
        if (matchedGroup === undefined) return group;
        return {
            ...group,
            id: matchedGroup.group.id,
            name: matchedGroup.group.name,
            queues: matchedGroup.group.queueIds,
            version: matchedGroup.group.version
        };
    });
const $5636402cfc7019b2$var$addQueueToGroupByGroupName = (queueId, updatedGroup, groups)=>groups.map((g)=>updatedGroup.includes(g.name) && !g.queues.includes(queueId) ? {
            ...g,
            queues: [
                ...g.queues,
                queueId
            ]
        } : g);
const $5636402cfc7019b2$var$removeQueueFromGroupsByGroupName = (queueId, updatedGroup, groups)=>groups.map((g)=>updatedGroup.includes(g.name) ? {
            ...g,
            queues: g.queues.filter((q)=>q !== queueId)
        } : g);
const $5636402cfc7019b2$var$createActions = (update, category, projectId, cloudId)=>({
        updateQueuesInGroup: (id, name, version, newQueues)=>(0, $6nQcV.updateGroup)({
                cloudId: cloudId,
                id: id,
                name: name,
                version: version,
                queueIds: newQueues
            }).then((updatedGroup)=>{
                update((data)=>({
                        ...data,
                        [category]: $5636402cfc7019b2$var$updateGroup(updatedGroup, data[category])
                    }));
            }),
        renameGroup: (id, newName, version, queues)=>(0, $6nQcV.updateGroup)({
                cloudId: cloudId,
                id: id,
                name: newName,
                version: version,
                queueIds: queues
            }).then((updatedGroup)=>{
                update((data)=>({
                        ...data,
                        [category]: $5636402cfc7019b2$var$updateGroup(updatedGroup, data[category])
                    }));
            }),
        createGroup: (name)=>(0, $6nQcV.createGroup)({
                name: name,
                category: category,
                projectId: projectId,
                cloudId: cloudId,
                queueIds: []
            }).then((createdGroup)=>{
                update((data)=>{
                    const groups = data[category] || [];
                    return {
                        ...data,
                        [category]: [
                            ...groups,
                            {
                                ...createdGroup,
                                queues: createdGroup.queueIds
                            }
                        ]
                    };
                });
            }),
        deleteGroup: (id)=>(0, $6nQcV.deleteGroup)({
                cloudId: cloudId,
                id: id
            }).then(()=>{
                update((data)=>({
                        ...data,
                        [category]: $5636402cfc7019b2$var$deleteGroup(id, data[category])
                    }));
            }),
        addQueueToGroupByGroupName: (queueId, toUpdateGroups)=>{
            if (toUpdateGroups.length === 0) return;
            update((data)=>({
                    ...data,
                    [category]: $5636402cfc7019b2$var$addQueueToGroupByGroupName(queueId, toUpdateGroups, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    data[category])
                }));
        },
        removeQueueFromGroupsByGroupName: (queueId, toUpdateGroups)=>{
            if (toUpdateGroups.length === 0) return;
            update((data)=>({
                    ...data,
                    [category]: $5636402cfc7019b2$var$removeQueueFromGroupsByGroupName(queueId, toUpdateGroups, data[category])
                }));
        },
        updateQueueGroupsByGroupId: (queueId, toUpdateGroups)=>(0, $6nQcV.updateQueueGroupsByGroupId)({
                cloudId: cloudId,
                projectId: projectId,
                category: category,
                queueId: queueId,
                groupIds: toUpdateGroups
            }).then((updatedGroups)=>{
                update((data)=>({
                        ...data,
                        [category]: $5636402cfc7019b2$var$updateQueueGroups(updatedGroups.results, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        data[category])
                    }));
            })
    });
// this only works for cross projects queue nav iten expansion.
// not when click a cross-project queue
const $5636402cfc7019b2$var$priorityGroupResource = (isActiveQueueRoute, shouldUseProjectId)=>{
    return isActiveQueueRoute && shouldUseProjectId ? (0, $aGQ56.priorityGroupByProjectIdResourceSsr) : (0, $aGQ56.priorityGroupResource);
};
const $5636402cfc7019b2$export$aceb895c0a1bdb9 = ()=>{
    const category = (0, $jEt3L.useCurrentCategory)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const update = (0, $eJrcF.useResource)($5636402cfc7019b2$var$priorityGroupResource((0, $kfvK2.useIsActiveRoute)($5636402cfc7019b2$var$queueRouteNames), false)).update;
    const projectId = projectContext?.projectId;
    return (0, $eJOHy.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>$5636402cfc7019b2$var$createActions(update, category, projectId?.toString(), cloudId), [
        category,
        cloudId,
        projectId,
        update
    ]);
};
const $5636402cfc7019b2$export$e41417e5a9e40e44 = (customContext)=>{
    const [projectKeyFromPath] = (0, $2FqDG.usePathParam)('projectKey');
    // if custom queue context was not passed, we want to fetch by project key
    const projectKey = customContext?.matchParams.projectKey || projectKeyFromPath;
    const [initialProjectKey] = (0, $eJOHy.useState)(projectKeyFromPath);
    const isActiveQueueRoute = (0, $kfvK2.useIsActiveRoute)($5636402cfc7019b2$var$queueRouteNames);
    const customProjectContextData = (0, $eJOHy.useMemo)(()=>projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined, [
        projectKey
    ]);
    const customContextData = customContext || customProjectContextData;
    const { data: projectCustomContextData, error: projectCustomContextError } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $dZRaT.projectContextResource), customContextData);
    const { data: projectContextData, error: projectContextError } = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    // This is used to fetch priority groups by project ID for cross-project queues and it follows the same logic where a dummy route is used with customContext in useResourceWithCustomRouterContext
    // In order to pass the project ID to priorityGroupCrossProjectResource, we need to add another parameter :projectId to the dummy route
    const crossProjectCustomContext = (0, $eJOHy.useMemo)(()=>{
        return projectKey && (0, $7jTnu.fg)('jsm_priority_group_api_cross_project_optimisation') && {
            matchParams: {
                projectKey: projectKey,
                projectId: projectCustomContextData?.projectId
            },
            route: {
                name: 'DUMMY_ROUTE_NAME',
                path: '/projects/:projectKey/:projectId/dummyroute'
            }
        };
    }, [
        projectKey,
        projectCustomContextData
    ]);
    // we want to fetch groups by project ID only for initial load at the moment
    // because transition to a queue from a different project enters into loading state, which causes skeleton to render
    const shouldUseProjectId = // project context fetched successfully
    !projectContextError && // project context has project ID we could use
    !!projectContextData?.projectId && // project context has project key matching initial one
    projectContextData?.projectKey === initialProjectKey && // queue belongs to a project matching initial one
    projectKey === initialProjectKey;
    const isCrossProject = !projectCustomContextError && projectKey && projectKey !== projectKeyFromPath && (0, $7jTnu.fg)('jsm_priority_group_api_cross_project_optimisation') && crossProjectCustomContext;
    return (0, $bo7Z6.useResourceWithCustomRouterContext)(isCrossProject ? (0, $aGQ56.priorityGroupCrossProjectResource) : $5636402cfc7019b2$var$priorityGroupResource(isActiveQueueRoute, shouldUseProjectId), isCrossProject ? crossProjectCustomContext : customContext);
};
const $5636402cfc7019b2$export$9ad7fd5c13dc6dbb = (category, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = $5636402cfc7019b2$export$e41417e5a9e40e44(customContext);
    const categorizedGroups = (0, $eJOHy.useMemo)(()=>(data && data[category]) ?? [], [
        category,
        data
    ]);
    return [
        categorizedGroups,
        loading,
        error,
        refresh
    ];
};
const $5636402cfc7019b2$export$7ddc2fd096cdc650 = (projectKey, category, customContext)=>{
    const [groups, groupLoading, groupError] = $5636402cfc7019b2$export$9ad7fd5c13dc6dbb(category, customContext);
    const [navItems, loading, queueError] = (0, $3fKYX.useCategorizedNavItems)(projectKey, category, customContext);
    return (0, $eJOHy.useMemo)(()=>{
        const isLoading = loading || groupLoading;
        if (isLoading || queueError || groupError) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return [
            [],
            isLoading,
            groupError,
            queueError
        ];
        const normalizedGroups = groups.map((group)=>({
                group: group,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                queues: group.queues.map((queueId)=>navItems?.find((item)=>Number.parseInt(item.id, 10) === queueId)).filter((item)=>!!item)
            }));
        return [
            normalizedGroups,
            isLoading,
            groupError,
            queueError
        ];
    }, [
        groupError,
        groupLoading,
        groups,
        loading,
        navItems,
        queueError
    ]);
};
const $5636402cfc7019b2$export$c2e9f9150500e785 = ()=>{
    const projectKey = (0, $jEt3L.useProjectKey)();
    const category = (0, $jEt3L.useCurrentCategory)();
    const [groups, groupLoading] = $5636402cfc7019b2$export$9ad7fd5c13dc6dbb(category);
    const [navItems, loading, error] = (0, $3fKYX.useCategorizedQueues)(projectKey, category);
    return (0, $eJOHy.useMemo)(()=>{
        const isLoading = loading || groupLoading;
        if (isLoading || error) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return [
            [],
            isLoading,
            error
        ];
        const normalizedGroups = groups.map((group)=>({
                group: group,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                queues: group.queues.map((queueId)=>navItems?.find((item)=>item.id === queueId)).filter((queue)=>!!queue)
            }));
        return [
            normalizedGroups,
            isLoading,
            error
        ];
    }, [
        error,
        groupLoading,
        groups,
        loading,
        navItems
    ]);
};

});
parcelRegister("6nQcV", function(module, exports) {

$parcel$export(module.exports, "createGroup", () => $0375a613202d1b66$export$856f728536d122cb);
$parcel$export(module.exports, "updateGroup", () => $0375a613202d1b66$export$7266cde9e95c4de8);
$parcel$export(module.exports, "deleteGroup", () => $0375a613202d1b66$export$ae2679b329fc10b6);
$parcel$export(module.exports, "updateQueueGroupsByGroupId", () => $0375a613202d1b66$export$bdf88b9d006a8a43);

var $jGzN3 = parcelRequire("jGzN3");
const $0375a613202d1b66$export$856f728536d122cb = ({ cloudId: cloudId, projectId: projectId, category: category, name: name, queueIds: queueIds })=>{
    const createGroupUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group`;
    const payload = {
        projectId: projectId,
        category: category,
        name: name,
        queueIds: queueIds
    };
    return (0, $jGzN3.performPostRequest)(createGroupUrl, {
        body: JSON.stringify(payload)
    });
};
const $0375a613202d1b66$export$7266cde9e95c4de8 = ({ cloudId: cloudId, id: id, version: version, name: name, queueIds: queueIds })=>{
    const updateGroupUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group/${id}`;
    const payload = {
        version: version,
        name: name,
        queueIds: queueIds
    };
    return (0, $jGzN3.performPutRequest)(updateGroupUrl, {
        body: JSON.stringify(payload)
    });
};
const $0375a613202d1b66$export$ae2679b329fc10b6 = ({ cloudId: cloudId, id: id })=>{
    const deleteGroupUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group/${id}`;
    return (0, $jGzN3.performDeleteRequest)(deleteGroupUrl);
};
const $0375a613202d1b66$export$bdf88b9d006a8a43 = ({ cloudId: cloudId, projectId: projectId, category: category, queueId: queueId, groupIds: groupIds })=>{
    const batchUpdateQueueGroupsUrl = `/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/group/batch/update-queue-groups/${projectId}/${category}`;
    const payload = {
        projectId: projectId,
        category: category,
        queueId: queueId,
        groupIds: groupIds
    };
    return (0, $jGzN3.performPutRequest)(batchUpdateQueueGroupsUrl, {
        body: JSON.stringify(payload)
    });
};

});


parcelRegister("59Vy3", function(module, exports) {

$parcel$export(module.exports, "useOnFavoritesChanged", () => $0feacfc97de58b1c$export$ddf44c597e03063d);

var $eJOHy = parcelRequire("eJOHy");

var $6kS6u = parcelRequire("6kS6u");

var $40zJW = parcelRequire("40zJW");

var $aMJA4 = parcelRequire("aMJA4");

var $beI5n = parcelRequire("beI5n");
const $0feacfc97de58b1c$var$updateQueueUsingCallback = (queues, queueItemChanges, editItemFavoriteCallback)=>{
    if (queues) {
        const itemsToRefresh = [];
        (0, (/*@__PURE__*/$parcel$interopDefault($40zJW)))(queueItemChanges).forEach(({ id: id, value: value })=>{
            const queue = (0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(queues, {
                id: id
            });
            if (queue && queue.starred !== value) {
                const isHiddenQueueStarred = queue.canBeHidden === true && value === true;
                editItemFavoriteCallback(id, value);
                if (isHiddenQueueStarred) itemsToRefresh.push(id);
            }
        });
    }
};
const $0feacfc97de58b1c$export$ddf44c597e03063d = (projectKey, category, queues, editItemFavoriteCallback)=>{
    const { items: items } = (0, $eJOHy.useContext)((0, $beI5n.FavoriteChangeContext));
    const queueItemChanges = items[0, $aMJA4.QUEUES_ITEM_TYPE];
    const previousChangesRef = (0, $eJOHy.useRef)({
        projectKey: projectKey,
        category: category,
        changedItems: undefined
    });
    const { current: previousChanges } = previousChangesRef;
    const hasPotentialChanges = previousChanges.projectKey !== projectKey || previousChanges.category !== category || previousChanges.changedItems !== queueItemChanges;
    if (hasPotentialChanges) {
        previousChangesRef.current = {
            projectKey: projectKey,
            category: category,
            changedItems: queueItemChanges
        };
        $0feacfc97de58b1c$var$updateQueueUsingCallback(queues, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        queueItemChanges, editItemFavoriteCallback);
    }
};

});

parcelRegister("iVxQJ", function(module, exports) {

$parcel$export(module.exports, "useIssueCountEnabledQueues", () => $d42fa7e17869d96d$export$99b90062d7e53784);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $d42fa7e17869d96d$export$e324594224ef24da = {
    updateIssueCountEnabledQueues: (queues)=>({ setState: setState })=>{
            setState({
                queues: queues
            });
        }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $d42fa7e17869d96d$var$initialState = {
    queues: []
};
const $d42fa7e17869d96d$var$Store = (0, $GtRbT.createStore)({
    name: 'jsm-queue-groups-issue-count-enabled-queues-store',
    initialState: $d42fa7e17869d96d$var$initialState,
    actions: $d42fa7e17869d96d$export$e324594224ef24da
});
const $d42fa7e17869d96d$export$99b90062d7e53784 = (0, $iJq0l.createHook)($d42fa7e17869d96d$var$Store, {
    selector: (state)=>state?.queues
});

});

parcelRegister("5h7v8", function(module, exports) {

$parcel$export(module.exports, "NavigationDetailsContainer", () => $68afac29bc3f5137$export$29eca0c9cd8a428b);
$parcel$export(module.exports, "useSelectedNavLocation", () => $68afac29bc3f5137$export$d2f02560e6f207a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $gYnSx = parcelRequire("gYnSx");

var $b0Tmn = parcelRequire("b0Tmn");

var $aEgVO = parcelRequire("aEgVO");
const $68afac29bc3f5137$export$dfef0225549f683d = 50;
const $68afac29bc3f5137$export$a0bac38ed2b058db = 2419200000; // 28 days in milliseconds
const $68afac29bc3f5137$export$e324594224ef24da = {
    updateSelectedNavLocation: (queueId, selectedSection, selectedGroupId)=>({ setState: setState, getState: getState }, { accountId: accountId })=>{
            const currentState = getState();
            const currentStateForQueueId = currentState[queueId] || {};
            const newState = {
                ...currentState,
                [queueId]: {
                    ...currentStateForQueueId,
                    selectedSection: selectedSection,
                    selectedGroupId: selectedGroupId,
                    latestUpdateTimestamp: Date.now()
                }
            };
            // setState is a merge operation - passing in an evicted state won't remove data for old queueIds
            setState(newState);
            // Save a evicted state to local storage to prevent unboounded growth.
            const evictedState = (0, $b0Tmn.getEvictedState)(newState, $68afac29bc3f5137$export$dfef0225549f683d, $68afac29bc3f5137$export$a0bac38ed2b058db);
            (0, $b0Tmn.setQueueGroupsNavStateInLocalStorage)(evictedState);
            if (accountId) (0, $aEgVO.updateQueueGroupsNavStateToUserProperty)(evictedState, accountId);
            else (0, $gYnSx.default)({
                error: new Error('Missing accountId while updating queue nav4 sidebar nav location state.'),
                meta: {
                    id: 'updateJsmQueueSidebarNav4NavLocationStateMissingAccountIdError',
                    packageName: 'jira-servicedesk-queues-nav4',
                    teamName: 'jsm-flash'
                }
            });
        }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $68afac29bc3f5137$var$initialState = {};
const $68afac29bc3f5137$var$Store = (0, $GtRbT.createStore)({
    name: 'jsm-queue-groups-nav-location-store',
    initialState: $68afac29bc3f5137$var$initialState,
    actions: $68afac29bc3f5137$export$e324594224ef24da
});
const $68afac29bc3f5137$export$29eca0c9cd8a428b = (0, $6E16M.createContainer)($68afac29bc3f5137$var$Store, {
    onInit: ()=>({ setState: setState }, { initState: initState })=>{
            if (initState) {
                setState(initState);
                return;
            }
            const state = (0, $b0Tmn.getQueueGroupsNavStateFromLocalStorage)();
            if (state) setState(state);
        }
});
const $68afac29bc3f5137$export$d2f02560e6f207a = (0, $iJq0l.createHook)($68afac29bc3f5137$var$Store, {
    selector: (state, queueId)=>({
            section: state[queueId]?.selectedSection,
            groupId: state[queueId]?.selectedGroupId
        })
});

});

parcelRegister("71f18", function(module, exports) {

$parcel$export(module.exports, "QueueListSection", () => $416235496d52ca4c$export$f9e39ac255344f7b);
var $416235496d52ca4c$export$f9e39ac255344f7b = /*#__PURE__*/ function(QueueListSection) {
    QueueListSection[QueueListSection["STARRED"] = 0] = "STARRED";
    QueueListSection[QueueListSection["PRIORITY_GROUP"] = 1] = "PRIORITY_GROUP";
    QueueListSection[QueueListSection["ALL_QUEUES"] = 2] = "ALL_QUEUES";
    return QueueListSection;
}({});

});

parcelRegister("2lG8T", function(module, exports) {

$parcel$export(module.exports, "usePopoutConfig", () => $49c1d26f96cd4a04$export$2cbd7df9320f5286);

var $eJOHy = parcelRequire("eJOHy");

var $dRr4h = parcelRequire("dRr4h");

var $fCuNJ = parcelRequire("fCuNJ");

var $3fKYX = parcelRequire("3fKYX");

var $2FqDG = parcelRequire("2FqDG");
var $gCY1z = parcelRequire("gCY1z");

var $1g6Je = parcelRequire("1g6Je");

var $71f18 = parcelRequire("71f18");

var $6ItnL = parcelRequire("6ItnL");
const $49c1d26f96cd4a04$var$getPopoutConfig = (isPoppedOut, queueSection)=>({
        isPoppedOut: isPoppedOut,
        highestAvailableSection: isPoppedOut ? queueSection : undefined
    });
const $49c1d26f96cd4a04$export$2cbd7df9320f5286 = (projectKey, practice)=>{
    const [{ location: location }] = (0, $gCY1z.useRouter)();
    const pathname = location.pathname;
    const queueCustomContext = (0, $dRr4h.useQueueCustomRouterContext)(projectKey);
    const [allQueues] = (0, $3fKYX.useCategorizedNavItems)(projectKey, practice, queueCustomContext);
    const [starredQueues] = (0, $3fKYX.useFavouriteNavItems)(projectKey, practice, queueCustomContext);
    const [isPoppedOut] = (0, $1g6Je.usePoppedOutState)((0, $1g6Je.getCategoryStateKey)(projectKey, practice));
    const [queueIdFromPath] = (0, $2FqDG.usePathParam)('queueId');
    const [boardIdFromPath] = (0, $2FqDG.usePathParam)('boardId');
    const [groups] = (0, $fCuNJ.useCategorizedGroupsNavItems)(projectKey, practice, queueCustomContext);
    const isCategorisedViewQueueUrl = (0, $6ItnL.isValidCategorisedViewQueueUrl)(projectKey, practice, queueIdFromPath, pathname, boardIdFromPath);
    const queueFoundInPractice = allQueues?.some((queue)=>queue.id === queueIdFromPath);
    return (0, $eJOHy.useMemo)(()=>{
        // First, determine if the popout is active according to the criteria below
        //  - The popout must be in the popped out state (i.e. the user has clicked the popout button)
        //  - The current URL must be showing a valid view queue page
        //  - The current queue must be part of the practice
        if (!isPoppedOut || !isCategorisedViewQueueUrl || !queueFoundInPractice) return $49c1d26f96cd4a04$var$getPopoutConfig(false);
        // Next, if the popout is active, determine the highest available queue section available in this popout
        const hasNonEmptyPriorityGroups = groups?.some((group)=>group.queues.length > 0);
        const hasStarredQueues = starredQueues && starredQueues.length > 0;
        if (hasStarredQueues) return $49c1d26f96cd4a04$var$getPopoutConfig(true, (0, $71f18.QueueListSection).STARRED);
        if (hasNonEmptyPriorityGroups) return $49c1d26f96cd4a04$var$getPopoutConfig(true, (0, $71f18.QueueListSection).PRIORITY_GROUP);
        return $49c1d26f96cd4a04$var$getPopoutConfig(true, (0, $71f18.QueueListSection).ALL_QUEUES);
    }, [
        isPoppedOut,
        isCategorisedViewQueueUrl,
        queueFoundInPractice,
        groups,
        starredQueues
    ]);
};

});
parcelRegister("6ItnL", function(module, exports) {

$parcel$export(module.exports, "isValidViewQueueUrl", () => $b0db7d308e33e59c$export$b1a2a8e908746b71);
$parcel$export(module.exports, "isValidQueuesUrl", () => $b0db7d308e33e59c$export$a13ce3a24252ba88);
$parcel$export(module.exports, "isValidViewIssueUrl", () => $b0db7d308e33e59c$export$45a8a51dd6371e57);
$parcel$export(module.exports, "isValidCategorisedViewQueueUrl", () => $b0db7d308e33e59c$export$329289338cdb3da1);
$parcel$export(module.exports, "isValidCategorisedQueuesUrl", () => $b0db7d308e33e59c$export$6d24a4cae21a7dbd);
$parcel$export(module.exports, "useHighestPriorityQueueUrl", () => $b0db7d308e33e59c$export$e82fb154e65954b9);

var $5SwkH = parcelRequire("5SwkH");

var $dRr4h = parcelRequire("dRr4h");

var $3fKYX = parcelRequire("3fKYX");

var $k6qAI = parcelRequire("k6qAI");

var $7jTnu = parcelRequire("7jTnu");

var $1g6Je = parcelRequire("1g6Je");

var $1F5u7 = parcelRequire("1F5u7");
const $b0db7d308e33e59c$var$getStrippedPathname = (pathname)=>{
    // strip url params and trailing slashes if they exist
    const pathnameWithoutParams = pathname.split('?')[0];
    const pathnameWithoutTrailingSlash = pathnameWithoutParams.endsWith('/') ? pathnameWithoutParams.slice(0, -1) : pathnameWithoutParams;
    return pathnameWithoutTrailingSlash;
};
const $b0db7d308e33e59c$export$b1a2a8e908746b71 = (projectKey, queueId, pathname, boardId)=>{
    if (!queueId) return false;
    const currentPath = $b0db7d308e33e59c$var$getStrippedPathname(pathname);
    const constructedPath = `${$b0db7d308e33e59c$export$96cc9136710988d8(projectKey)}/custom/${queueId}`;
    return (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? currentPath.endsWith(constructedPath) || currentPath.endsWith(`${constructedPath}/calendar/${boardId}`) || currentPath.endsWith(`${constructedPath}/board/${boardId}`) : currentPath.endsWith(constructedPath);
};
const $b0db7d308e33e59c$export$a13ce3a24252ba88 = (projectKey, pathname)=>pathname.includes($b0db7d308e33e59c$export$96cc9136710988d8(projectKey));
const $b0db7d308e33e59c$export$45a8a51dd6371e57 = (projectKey, queueId, pathname, issueKey)=>{
    if (!issueKey) return false;
    const currentPath = $b0db7d308e33e59c$var$getStrippedPathname(pathname);
    const constructedPath = `${$b0db7d308e33e59c$export$96cc9136710988d8(projectKey)}/custom/${queueId}/${issueKey}`;
    return currentPath.endsWith(constructedPath);
};
const $b0db7d308e33e59c$export$329289338cdb3da1 = (projectKey, category, queueId, pathname, boardId)=>{
    if (!queueId) return false;
    if (!category) return (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? $b0db7d308e33e59c$export$b1a2a8e908746b71(projectKey, queueId, pathname, boardId) : $b0db7d308e33e59c$export$b1a2a8e908746b71(projectKey, queueId, pathname);
    const currentPath = $b0db7d308e33e59c$var$getStrippedPathname(pathname);
    const constructedPath = `${$b0db7d308e33e59c$export$714ec44b3d657788(projectKey, category)}/custom/${queueId}`;
    return (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? currentPath.endsWith(constructedPath) || currentPath.endsWith(`${constructedPath}/calendar/${boardId}`) || currentPath.endsWith(`${constructedPath}/board/${boardId}`) : currentPath.endsWith(constructedPath);
};
const $b0db7d308e33e59c$export$6d24a4cae21a7dbd = (projectKey, category, pathname)=>{
    if (!category) return $b0db7d308e33e59c$export$a13ce3a24252ba88(projectKey, pathname);
    return pathname.includes($b0db7d308e33e59c$export$714ec44b3d657788(projectKey, category));
};
const $b0db7d308e33e59c$export$714ec44b3d657788 = (projectKey, category)=>{
    if (!category) return $b0db7d308e33e59c$export$96cc9136710988d8(projectKey);
    return `${$b0db7d308e33e59c$export$ebd25648349e3334(projectKey)}/${(0, $5SwkH.QUEUE_ROUTES)[category]}`;
};
const $b0db7d308e33e59c$export$96cc9136710988d8 = (projectKey)=>`${$b0db7d308e33e59c$export$ebd25648349e3334(projectKey)}/queues`;
const $b0db7d308e33e59c$export$ebd25648349e3334 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}`;
const $b0db7d308e33e59c$export$4f6fb26cc9e97438 = (projectKey, category)=>{
    // Need to get all data before returning to avoid hook errors
    const categoryStateKey = (0, $1g6Je.getCategoryStateKey)(projectKey, category);
    const [lastVisitedQueueId] = (0, $1g6Je.useLastVisitedQueueId)(categoryStateKey);
    const queueCustomContext = (0, $dRr4h.useQueueCustomRouterContext)(projectKey);
    const [starredQueues] = (0, $3fKYX.useFavouriteNavItems)(projectKey, category, queueCustomContext);
    const [allQueues] = (0, $3fKYX.useCategorizedNavItems)(projectKey, category, queueCustomContext);
    const [filteredGroups] = (0, $1F5u7.useFilteredCategorizedQueueGroups)(projectKey, (0, $k6qAI.toItsmPractice)(category));
    // Always use the last visited queue if it exists
    if (lastVisitedQueueId) return lastVisitedQueueId;
    // Next best option is to return a starred queue
    if (starredQueues?.length) return starredQueues[0].id;
    // Next best option is to return the first queue in the first group
    if (filteredGroups?.length && filteredGroups[0].queues?.length) return filteredGroups[0].queues[0].id;
    // Final option is to return the first queue in the all queues list
    if (allQueues?.length) return allQueues[0].id;
    return undefined;
};
const $b0db7d308e33e59c$export$e82fb154e65954b9 = (projectKey, category)=>{
    const queueId = $b0db7d308e33e59c$export$4f6fb26cc9e97438(projectKey, category);
    if (!queueId) return '';
    return `${$b0db7d308e33e59c$export$714ec44b3d657788(projectKey, category)}/custom/${queueId}`;
};

});
parcelRegister("1F5u7", function(module, exports) {

$parcel$export(module.exports, "useIsQueueSelected", () => $611de1e5febeec9f$export$5405660a1c6b0f63);
$parcel$export(module.exports, "useFilteredCategorizedQueueGroups", () => $611de1e5febeec9f$export$7689b1dc3aabf437);

var $eJOHy = parcelRequire("eJOHy");

var $dRr4h = parcelRequire("dRr4h");

var $9gPby = parcelRequire("9gPby");

var $fCuNJ = parcelRequire("fCuNJ");

var $jlJsl = parcelRequire("jlJsl");

var $2FqDG = parcelRequire("2FqDG");

var $5h7v8 = parcelRequire("5h7v8");
const $611de1e5febeec9f$export$9bdd97120118ee26 = (queue, priorityGroups, section, lastSelectedSection, lastSelectedGroupId, priorityGroupId)=>{
    const firstPriorityGroupWithQueue = priorityGroups.find((group)=>group.queues.includes(Number(queue.id)))?.id;
    const queueMissingValidHistory = lastSelectedSection === undefined || lastSelectedSection === (0, $9gPby.QueueListSection).PRIORITY_GROUP && !lastSelectedGroupId;
    const isQueueSelectedBasedOnPriority = {
        [(0, $9gPby.QueueListSection).STARRED]: queue.starred && !priorityGroupId,
        [(0, $9gPby.QueueListSection).PRIORITY_GROUP]: !queue.starred && priorityGroupId === firstPriorityGroupWithQueue,
        [(0, $9gPby.QueueListSection).ALL_QUEUES]: !queue.starred && !firstPriorityGroupWithQueue
    };
    const isQueueSelectedBasedOnHistory = {
        [(0, $9gPby.QueueListSection).STARRED]: true,
        [(0, $9gPby.QueueListSection).PRIORITY_GROUP]: lastSelectedGroupId === priorityGroupId,
        [(0, $9gPby.QueueListSection).ALL_QUEUES]: true
    };
    if (queueMissingValidHistory) return isQueueSelectedBasedOnPriority[section];
    if (section === lastSelectedSection) return isQueueSelectedBasedOnHistory[lastSelectedSection];
    return false;
};
const $611de1e5febeec9f$export$5405660a1c6b0f63 = (queue, section, priorityGroupId)=>{
    const [queueIdFromPath] = (0, $2FqDG.usePathParam)('queueId');
    const [selectedNavLocation] = (0, $5h7v8.useSelectedNavLocation)(queueIdFromPath || '');
    const [priorityGroups] = (0, $fCuNJ.usePriorityGroups)(queue?.category || (0, $jlJsl.NO_CATEGORY));
    return (0, $eJOHy.useMemo)(()=>queue !== undefined ? $611de1e5febeec9f$export$9bdd97120118ee26(queue, priorityGroups, section, selectedNavLocation.section, selectedNavLocation.groupId, priorityGroupId) : false, [
        priorityGroupId,
        priorityGroups,
        queue,
        section,
        selectedNavLocation.groupId,
        selectedNavLocation.section
    ]);
};
const $611de1e5febeec9f$export$7689b1dc3aabf437 = (projectKey, category)=>{
    const queueCustomContext = (0, $dRr4h.useQueueCustomRouterContext)(projectKey);
    const [groups, isLoading, groupError, queueError] = (0, $fCuNJ.useCategorizedGroupsNavItems)(projectKey, category, queueCustomContext);
    const filteredGroups = (0, $eJOHy.useMemo)(()=>groups.filter((group)=>group.queues.length > 0), [
        groups
    ]);
    return [
        filteredGroups,
        isLoading,
        groupError,
        queueError
    ];
};

});
parcelRegister("9gPby", function(module, exports) {

$parcel$export(module.exports, "QueueListSection", () => $dd0b56773a17cb78$export$f9e39ac255344f7b);
$parcel$export(module.exports, "NavigationCategoryContainer", () => $dd0b56773a17cb78$export$ea600ea09fe6bbd);
$parcel$export(module.exports, "useSelectedGroupIdByCategory", () => $dd0b56773a17cb78$export$9a1583f58d01a77c);
$parcel$export(module.exports, "useSelectedQueueSectionByCategory", () => $dd0b56773a17cb78$export$aca7e7401e11cffa);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7KiwK = parcelRequire("7KiwK");

var $ikNLQ = parcelRequire("ikNLQ");
var $dd0b56773a17cb78$export$f9e39ac255344f7b = /*#__PURE__*/ function(QueueListSection) {
    QueueListSection[QueueListSection["STARRED"] = 0] = "STARRED";
    QueueListSection[QueueListSection["PRIORITY_GROUP"] = 1] = "PRIORITY_GROUP";
    QueueListSection[QueueListSection["ALL_QUEUES"] = 2] = "ALL_QUEUES";
    return QueueListSection;
}({});
const $dd0b56773a17cb78$export$e324594224ef24da = {
    updateCurrentCategorySelectedGroup: (projectKey, practice, selectedGroupId)=>({ setState: setState, getState: getState }, { accountId: accountId })=>{
            setState({
                ...getState(),
                ...getState()[practice] ? {
                    [practice]: {
                        ...getState()[practice],
                        selectedGroupId: selectedGroupId
                    }
                } : {
                    [practice]: {
                        selectedGroupId: selectedGroupId
                    }
                }
            });
            (0, $ikNLQ.setQueueGroupsStateInLocalStorage)(projectKey, getState());
            if (accountId) (0, $7KiwK.setQueueGroupsStateInUserProperty)(projectKey, getState(), accountId);
        },
    updatePathCategorySelectedQueueSection: (projectKey, practice, selectedQueueSection)=>({ setState: setState, getState: getState }, { accountId: accountId })=>{
            setState({
                ...getState(),
                ...getState()[practice] ? {
                    [practice]: {
                        ...getState()[practice],
                        selectedQueueSection: selectedQueueSection
                    }
                } : {
                    [practice]: {
                        selectedQueueSection: selectedQueueSection
                    }
                }
            });
            (0, $ikNLQ.setQueueGroupsStateInLocalStorage)(projectKey, getState());
            if (accountId) (0, $7KiwK.setQueueGroupsStateInUserProperty)(projectKey, getState(), accountId);
        }
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $dd0b56773a17cb78$var$initialState = {};
const $dd0b56773a17cb78$var$Store = (0, $GtRbT.createStore)({
    name: 'jsm-navigation-categories-store',
    initialState: $dd0b56773a17cb78$var$initialState,
    actions: $dd0b56773a17cb78$export$e324594224ef24da
});
const $dd0b56773a17cb78$export$ea600ea09fe6bbd = (0, $6E16M.createContainer)($dd0b56773a17cb78$var$Store, {
    onInit: ()=>({ setState: setState }, { projectKey: projectKey, initialState: initialStateFromProps })=>{
            const stateFromStorage = initialStateFromProps || (0, $ikNLQ.getQueueGroupsStateFromLocalStorage)(projectKey);
            if (stateFromStorage) setState(stateFromStorage);
        }
});
const $dd0b56773a17cb78$export$6676162114f1489a = (0, $iJq0l.createHook)($dd0b56773a17cb78$var$Store);
const $dd0b56773a17cb78$export$9a1583f58d01a77c = (0, $iJq0l.createHook)($dd0b56773a17cb78$var$Store, {
    selector: (state, category)=>state[category]?.selectedGroupId
});
const $dd0b56773a17cb78$export$aca7e7401e11cffa = (0, $iJq0l.createHook)($dd0b56773a17cb78$var$Store, {
    selector: (state, category)=>state[category]?.selectedQueueSection
});

});
parcelRegister("ikNLQ", function(module, exports) {

$parcel$export(module.exports, "getQueueGroupsStateFromLocalStorage", () => $3667d14b602eebdd$export$69c85d62a3ce3c00);
$parcel$export(module.exports, "setQueueGroupsStateInLocalStorage", () => $3667d14b602eebdd$export$7475d3423fcf9a14);

var $dnU6V = parcelRequire("dnU6V");
const $3667d14b602eebdd$export$72f6692c81a0e6b3 = 'jsm-queue-groups-state';
const $3667d14b602eebdd$export$d8474cff104280f3 = 'selected-group-id';
const $3667d14b602eebdd$export$69c85d62a3ce3c00 = (projectKey)=>{
    const localStorageProvider = (0, $dnU6V.createLocalStorageProvider)($3667d14b602eebdd$export$72f6692c81a0e6b3);
    try {
        const state = localStorageProvider.get(`${$3667d14b602eebdd$export$d8474cff104280f3}-${projectKey}`);
        if (state) return JSON.parse(state);
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return undefined;
    }
};
const $3667d14b602eebdd$export$7475d3423fcf9a14 = (projectKey, value)=>{
    const localStorageProvider = (0, $dnU6V.createLocalStorageProvider)($3667d14b602eebdd$export$72f6692c81a0e6b3);
    try {
        localStorageProvider.set(`${$3667d14b602eebdd$export$d8474cff104280f3}-${projectKey}`, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* empty */ }
};

});





parcelRegister("EqIKa", function(module, exports) {

$parcel$export(module.exports, "AllQueuesSection", () => $a28f9c35108d9543$export$3db49d1e2b7c929f);

var $eJOHy = parcelRequire("eJOHy");

var $dRr4h = parcelRequire("dRr4h");

var $9gPby = parcelRequire("9gPby");

var $3fKYX = parcelRequire("3fKYX");

var $2FqDG = parcelRequire("2FqDG");

var $2lG8T = parcelRequire("2lG8T");

var $1F5u7 = parcelRequire("1F5u7");

var $hURB3 = parcelRequire("hURB3");

var $2qglJ = parcelRequire("2qglJ");

var $2QMGq = parcelRequire("2QMGq");
const $a28f9c35108d9543$export$3db49d1e2b7c929f = ({ projectKey: projectKey, practice: practice })=>{
    const queueCustomContext = (0, $dRr4h.useQueueCustomRouterContext)(projectKey);
    const [queueIdFromPath] = (0, $2FqDG.usePathParam)('queueId');
    const [allQueues] = (0, $3fKYX.useCategorizedNavItems)(projectKey, practice, queueCustomContext);
    const popoutConfig = (0, $2lG8T.usePopoutConfig)(projectKey, practice);
    const selectedQueue = (0, $eJOHy.useMemo)(()=>allQueues?.find((queue)=>queue.id === queueIdFromPath), [
        allQueues,
        queueIdFromPath
    ]);
    const isQueueSelected = (0, $1F5u7.useIsQueueSelected)(selectedQueue, (0, $9gPby.QueueListSection).ALL_QUEUES);
    const hasSelectedQueue = isQueueSelected && selectedQueue !== undefined;
    if (!allQueues || allQueues.length === 0) return null;
    if (popoutConfig.isPoppedOut) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2QMGq.AllQueuesPopOut), {
        projectKey: projectKey,
        practice: practice
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, hasSelectedQueue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hURB3.QueueItem), {
        queue: selectedQueue,
        section: (0, $9gPby.QueueListSection).ALL_QUEUES
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qglJ.AllQueuesFlyout), {
        projectKey: projectKey,
        practice: practice
    }));
};

});
parcelRegister("hURB3", function(module, exports) {

$parcel$export(module.exports, "QueueItem", () => $9665a34abc03c33b$export$1b63de307530e1bc);

var $eJOHy = parcelRequire("eJOHy");

var $lBtjB = parcelRequire("lBtjB");

var $fQnJZ = parcelRequire("fQnJZ");

var $7q9BG = parcelRequire("7q9BG");

var $bjI3S = parcelRequire("bjI3S");

var $k71qx = parcelRequire("k71qx");

var $2dvSy = parcelRequire("2dvSy");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $dO9h7 = parcelRequire("dO9h7");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $9gPby = parcelRequire("9gPby");

var $jlJsl = parcelRequire("jlJsl");

var $k6qAI = parcelRequire("k6qAI");

var $2cfd4 = parcelRequire("2cfd4");

var $kfvK2 = parcelRequire("kfvK2");
var $2FqDG = parcelRequire("2FqDG");

var $fAZgY = parcelRequire("fAZgY");

var $6ItnL = parcelRequire("6ItnL");

var $5h7v8 = parcelRequire("5h7v8");

var $1g6Je = parcelRequire("1g6Je");

var $1F5u7 = parcelRequire("1F5u7");

var $iY6EH = parcelRequire("iY6EH");

var $fGgPa = parcelRequire("fGgPa");

var $h6nif = parcelRequire("h6nif");
const $9665a34abc03c33b$var$MAX_BADGE_COUNT = 999;
const $9665a34abc03c33b$export$d243ff4c233d53f3 = (pathCategorySelectedSection, currentQueueInSection)=>(currentLocation, itemLocation)=>{
        const pathNameMatches = currentLocation.pathname === itemLocation.pathname || currentLocation.pathname.substring(0, currentLocation.pathname.lastIndexOf('/')) === itemLocation.pathname;
        const isSectionMatched = pathCategorySelectedSection === currentQueueInSection;
        return pathNameMatches && isSectionMatched;
    };
const $9665a34abc03c33b$export$1b63de307530e1bc = ({ Badge: Badge = (0, $7q9BG.default), queue: queue, section: section, projectKey: projectKey, priorityGroupId: priorityGroupId, isQueueInFlyOut: isQueueInFlyOut = false, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const locale = (0, $2cfd4.useLocale)();
    const { route: route, location: location } = (0, $kfvK2.createRouterSelector)((state)=>state)();
    const pathname = location.pathname;
    const [queueIdFromPath] = (0, $2FqDG.usePathParam)('queueId');
    const [boardIdFromPath] = (0, $2FqDG.usePathParam)('boardId');
    const [practiceFromPath] = (0, $2FqDG.usePathParam)('practiceType');
    const [projectKeyFromPath] = (0, $2FqDG.usePathParam)('projectKey');
    const [issueKeyFromPath] = (0, $2FqDG.usePathParam)('issueKey');
    const categoryFromPath = (0, $k6qAI.toItsmPractice)(practiceFromPath);
    const categoryFromQueue = queue.category || (0, $jlJsl.NO_CATEGORY);
    const [selectedNavLocation, { updateSelectedNavLocation: updateSelectedNavLocation }] = (0, $5h7v8.useSelectedNavLocation)(queueIdFromPath || '');
    const isViewQueueUrl = !(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $6ItnL.isValidCategorisedViewQueueUrl)(projectKey || '', categoryFromQueue, queueIdFromPath, pathname) : (0, $6ItnL.isValidCategorisedViewQueueUrl)(projectKey || '', categoryFromQueue, queueIdFromPath, pathname, boardIdFromPath);
    const isIssueUrl = (0, $6ItnL.isValidViewIssueUrl)(projectKey || '', queueIdFromPath, pathname, issueKeyFromPath);
    // Is queue selected logic
    const href = `/jira/servicedesk${queue.url}`;
    const queueMatchesRoute = route != null && queueIdFromPath === queue.id && location.pathname.startsWith(href);
    const isQueueSelected = (0, $1F5u7.useIsQueueSelected)(queue, section, priorityGroupId) && queueMatchesRoute;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isPoppedOut] = (0, $1g6Je.usePoppedOutState)(`${projectKey}-${categoryFromQueue}`);
    (0, $eJOHy.useEffect)(()=>{
        if (isQueueSelected) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'queueItemSelected rendered', {
            id: queue.id,
            name: queue.name,
            category: categoryFromQueue,
            section: section,
            priorityGroupId: priorityGroupId,
            isQueueInFlyOut: isQueueInFlyOut,
            isQueueInPopOutPanel: isPoppedOut
        });
    }, [
        categoryFromQueue,
        createAnalyticsEvent,
        isQueueInFlyOut,
        isQueueSelected,
        isPoppedOut,
        priorityGroupId,
        queue.category,
        queue.id,
        queue.name,
        section
    ]);
    // Internal methods
    const getFormattedRelativeLastRefreshedTime = (0, $eJOHy.useCallback)(()=>{
        if (queue.badgeCount === undefined) return formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $fGgPa.tooltipMessages).loadingIssueCountTooltipIssueTermRefresh : (0, $fGgPa.tooltipMessages).loadingIssueCountTooltip);
        const lastRefreshedTime = queue.lastRefreshedTime || Date.now();
        return formatMessage((0, $fGgPa.tooltipMessages).showLastRefreshedTimeTooltip, {
            lastUpdate: (0, $dO9h7.formatDistanceStrictWithLocale)(lastRefreshedTime, Date.now(), locale, true)
        });
    }, [
        formatMessage,
        locale,
        queue.badgeCount,
        queue.lastRefreshedTime
    ]);
    const onMenuItemClick = (0, $fAZgY.useCallbackWithCondition)(()=>{
        updateSelectedNavLocation(queue.id, section, priorityGroupId);
    }, [
        priorityGroupId,
        queue.id,
        section,
        updateSelectedNavLocation
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    // Should queue show issue count badge
    const inSelectedProject = projectKey === projectKeyFromPath;
    const inSelectedCategory = categoryFromQueue === categoryFromPath;
    const isValidLocation = (isViewQueueUrl || isIssueUrl) && inSelectedProject && inSelectedCategory;
    const shouldShowBadgeInSection = {
        [(0, $9gPby.QueueListSection).STARRED]: true,
        [(0, $9gPby.QueueListSection).PRIORITY_GROUP]: selectedNavLocation.groupId === priorityGroupId,
        [(0, $9gPby.QueueListSection).ALL_QUEUES]: isQueueSelected
    };
    const shouldShowBadge = isValidLocation && shouldShowBadgeInSection[section];
    const badgeDisplayValue = shouldShowBadge && ((0, (/*@__PURE__*/$parcel$interopDefault($lBtjB)))(queue.badgeCount) ? (0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(queue.badgeCount) : '-');
    const issueCountBadge = shouldShowBadge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: ()=>getFormattedRelativeLastRefreshedTime()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-is-queue-issue-count-badge": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Badge, {
        max: $9665a34abc03c33b$var$MAX_BADGE_COUNT
    }, badgeDisplayValue)));
    const starButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h6nif.StarButton), {
        isStarred: queue.starred,
        queueId: queue.id
    });
    // issue count errors
    const shouldShowIssueCountError = queue.shouldSkipIssueCountRefresh && shouldShowBadge;
    const issueCountIcon = shouldShowIssueCountError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iY6EH.default), {
        queue: queue
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, issueCountBadge);
    // TODO instrument MenuLinkItem analytics={{ itemId: `queue-${queue.id}`,}} set componentType: customItem, if it's a custom queue (see the spec)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        href: href,
        isSelected: isQueueSelected && !isQueueInFlyOut,
        onClick: onMenuItemClick,
        elemAfter: issueCountIcon,
        actionsOnHover: starButton,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bjI3S))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }),
        "aria-label": queue.name,
        ...rest
    }, queue.name);
};

});
parcelRegister("iY6EH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0447995f600e2561$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $88oIq = parcelRequire("88oIq");

var $8rAKL = parcelRequire("8rAKL");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $6joHJ = parcelRequire("6joHJ");

var $eWzpp = parcelRequire("eWzpp");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $3fKYX = parcelRequire("3fKYX");

var $gZTP9 = parcelRequire("gZTP9");

var $eZ1YE = parcelRequire("eZ1YE");
const $0447995f600e2561$export$9facd8d31b938a25 = ()=>{
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const projectContext = (0, $2aY2d.useProjectContext)();
    const isProjectAdmin = isAdmin || projectContext?.data?.isProjectAdmin || false;
    return {
        isProjectAdmin: isProjectAdmin
    };
};
const $0447995f600e2561$var$learnMoreUrl = 'https://community.atlassian.com/t5/Jira-Service-Management-articles/Managing-queues-at-scale-in-Jira-Service-Management/ba-p/2102021';
const $0447995f600e2561$export$ca8e59510a286136 = ({ queue: queue })=>{
    const [showDialog, setShowDialog] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { data: project } = (0, $eWzpp.useProject)();
    const [, , , methods] = (0, $3fKYX.useCategorizedNavItems)(project ? project.key : '', queue.category);
    const onReload = (0, $eJOHy.useCallback)((e)=>{
        // stopping the propagration and default behavior, otherwise the queue menu item will be clicked
        e.stopPropagation();
        e.preventDefault();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'ReloadBadQueueButton');
        methods.enableRefreshForQueues([
            queue.id
        ]);
        methods.refreshIssueCountForItems([
            queue.id
        ]);
    }, [
        methods,
        queue.id,
        createAnalyticsEvent
    ]);
    const onEditQueue = (0, $eJOHy.useCallback)((e)=>{
        // stopping the propagration and default behavior, otherwise the queue menu item will be clicked
        e.stopPropagation();
        e.preventDefault(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(`${queue.url}/edit`, '_blank');
        setShowDialog(false);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'EditQueueFromIssueCountErrorDialog'
        }), {
            meta: {
                id: 'ViewEditQueueFromIssueCountErrorDialog',
                packageName: 'jiraNavigationAppsSidebarServicedesk',
                teamName: 'jsd-shield'
            },
            canBeHidden: queue.canBeHidden,
            isStarred: queue.starred
        });
    }, [
        setShowDialog,
        queue.url,
        queue.canBeHidden,
        queue.starred,
        createAnalyticsEvent
    ]);
    const onLearnMoreClick = (0, $eJOHy.useCallback)((e)=>{
        // stopping the propagration and default behavior, otherwise the queue menu item will be clicked
        e.stopPropagation();
        e.preventDefault();
        setShowDialog(false);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'BadQueueLearnMoreButton'); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open($0447995f600e2561$var$learnMoreUrl, '_blank');
    }, [
        createAnalyticsEvent
    ]);
    const learnMoreButton = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "link",
            target: "_blank",
            onClick: onLearnMoreClick
        }, formatMessage((0, $eZ1YE.messages).learnMoreButtonLabel)), [
        formatMessage,
        onLearnMoreClick
    ]);
    const reloadButton = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "link",
            onClick: onReload
        }, formatMessage((0, $eZ1YE.messages).reloadButtonLabel)), [
        onReload,
        formatMessage
    ]);
    const editQueueButton = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "link",
            onClick: onEditQueue,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))), {
                label: "",
                LEGACY_size: "small"
            })
        }, formatMessage((0, $eZ1YE.messages).editQueueButtonLabel)), [
        onEditQueue,
        formatMessage
    ]);
    const { isProjectAdmin: isProjectAdmin } = $0447995f600e2561$export$9facd8d31b938a25();
    const userActionButton = isProjectAdmin ? editQueueButton : reloadButton;
    const agentMessage = queue.starred ? (0, $eZ1YE.messages).issueCountErrorMessageAgentStarred : (0, $eZ1YE.messages).issueCountErrorMessageAgentNotStarred;
    const contentMessage = isProjectAdmin ? (0, $eZ1YE.messages).issueCountErrorMessageAdmin : agentMessage;
    const content = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0447995f600e2561$var$InlineDialogContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0447995f600e2561$var$InlineDialogHeader, null, formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $eZ1YE.messages).issueCountErrorMessageHeaderIssueTermRefresh : (0, $eZ1YE.messages).issueCountErrorMessageHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage(contentMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0447995f600e2561$var$InlineDialogButtons, null, learnMoreButton, userActionButton)), [
        contentMessage,
        formatMessage,
        learnMoreButton,
        userActionButton
    ]);
    const onIssueCountErrorButtonClick = (0, $eJOHy.useCallback)(// @ts-expect-error - TS2315 - Type 'Mouse Event' is not generic.
    (e)=>{
        e.stopPropagation(); // prevent underlying queue button from being pressed
        e.preventDefault();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'IssueCountErrorButton');
        setShowDialog(!showDialog);
    }, [
        showDialog,
        setShowDialog,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
        onClose: ()=>{
            setShowDialog(false);
        },
        content: content,
        isOpen: showDialog,
        messageId: "servicedesk-queues-nav4.common.ui.practice-queues.queue-list.queue-item.issue-count-error-message.inline-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0447995f600e2561$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onIssueCountErrorButtonClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($88oIq))), {
            label: "",
            LEGACY_size: "small",
            color: "var(--ds-icon-subtle, #626F86)"
        }),
        ...(0, $7jTnu.fg)('core-cap-4092-a11y-fix') ? {
            'aria-label': formatMessage((0, $eZ1YE.messages).warningIconAriaLabel)
        } : {}
    })));
};
var $0447995f600e2561$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0447995f600e2561$export$ca8e59510a286136;
const $0447995f600e2561$var$InlineDialogContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _p12f3xl8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0447995f600e2561$var$InlineDialogHeader = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48pmoej",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0447995f600e2561$var$InlineDialogButtons = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0xmi2 _19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0447995f600e2561$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _14hp1tcg _jq8g1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0447995f600e2561$export$7ed12d2a5241e393 = {
    InlineDialogContainer: $0447995f600e2561$var$InlineDialogContainer,
    InlineDialogHeader: $0447995f600e2561$var$InlineDialogHeader,
    InlineDialogButtons: $0447995f600e2561$var$InlineDialogButtons,
    ButtonWrapper: $0447995f600e2561$var$ButtonWrapper
};

});
parcelRegister("88oIq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::468397db8b621d0b872ec4fdf86e27df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ec23e149a3635ad$var$_react = $5ec23e149a3635ad$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5ec23e149a3635ad$var$_statusWarning = $5ec23e149a3635ad$var$_interopRequireDefault((parcelRequire("d8UFE")));

var $5ec23e149a3635ad$var$_warning = $5ec23e149a3635ad$var$_interopRequireDefault((parcelRequire("78Hx3")));
function $5ec23e149a3635ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ec23e149a3635ad$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $5ec23e149a3635ad$var$_react.default.createElement($5ec23e149a3635ad$var$_statusWarning.default, Object.assign({
        LEGACY_fallbackIcon: $5ec23e149a3635ad$var$_warning.default
    }, props));
$5ec23e149a3635ad$var$StatusWarningIcon.Name = 'StatusWarningIconMigration';
var $5ec23e149a3635ad$var$_default = module.exports.default = $5ec23e149a3635ad$var$StatusWarningIcon;

});
parcelRegister("78Hx3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $532b0c56cbaaba87$var$_react = $532b0c56cbaaba87$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $532b0c56cbaaba87$var$_statusWarning = $532b0c56cbaaba87$var$_interopRequireDefault((parcelRequire("d8UFE")));
function $532b0c56cbaaba87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $532b0c56cbaaba87$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $532b0c56cbaaba87$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $532b0c56cbaaba87$var$_statusWarning.default
    }));
$532b0c56cbaaba87$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $532b0c56cbaaba87$var$_default = module.exports.default = $532b0c56cbaaba87$var$EditorWarningIcon;

});


parcelRegister("eZ1YE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $11ac819d4ffc88d5$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $11ac819d4ffc88d5$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    issueCountErrorMessageHeader: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-header",
        "defaultMessage": "We can't show the number of issues"
    },
    issueCountErrorMessageAdmin: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-admin",
        "defaultMessage": "There seems to be a problem with the queue's filters. Edit the queue and try again."
    },
    issueCountErrorMessageAgentStarred: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-agent-starred",
        "defaultMessage": "There seems to be a problem with the queue's filters. Contact your admins to edit this queue or remove it from Starred."
    },
    issueCountErrorMessageAgentNotStarred: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-agent-not-starred",
        "defaultMessage": "There seems to be a problem with the queue's filters. Contact your admins to edit this queue."
    },
    learnMoreButtonLabel: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.learn-more-button-label",
        "defaultMessage": "Learn more"
    },
    reloadButtonLabel: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.reload-button-label",
        "defaultMessage": "Reload"
    },
    editQueueButtonLabel: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.edit-queue-button-label",
        "defaultMessage": "Edit queue"
    },
    issueCountErrorMessageHeaderIssueTermRefresh: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.issue-count-error-message-header-issue-term-refresh",
        "defaultMessage": "We can't show the number of work items"
    },
    warningIconAriaLabel: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.issue-count-error-message.warning-icon-aria-label",
        "defaultMessage": "Warning"
    }
});

});


parcelRegister("fGgPa", function(module, exports) {

$parcel$export(module.exports, "tooltipMessages", () => $18428ea67c8684a4$export$4713da6aa4410043);

var $7qGN1 = parcelRequire("7qGN1");
const $18428ea67c8684a4$export$4713da6aa4410043 = (0, $7qGN1.defineMessages)({
    loadingIssueCountTooltip: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.loading-issue-count-tooltip",
        "defaultMessage": "Loading the number of issues"
    },
    showLastRefreshedTimeTooltip: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.show-last-refreshed-time-tooltip",
        "defaultMessage": "Last updated {lastUpdate}"
    },
    loadingIssueCountTooltipIssueTermRefresh: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-list.queue-item.loading-issue-count-tooltip-issue-term-refresh",
        "defaultMessage": "Loading the number of work items"
    }
});

});

parcelRegister("h6nif", function(module, exports) {

$parcel$export(module.exports, "StarButton", () => $c8f8fe9a13e5236b$export$b4b5678234ca6d4d);

var $eJOHy = parcelRequire("eJOHy");

var $fVPN0 = parcelRequire("fVPN0");

var $aMJA4 = parcelRequire("aMJA4");

var $beI5n = parcelRequire("beI5n");
const $c8f8fe9a13e5236b$export$b4b5678234ca6d4d = ({ isStarred: isStarred, queueId: queueId })=>{
    const { changeFavorite: changeFavorite } = (0, $eJOHy.useContext)((0, $beI5n.FavoriteChangeContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), {
        isFavorite: isStarred,
        pending: false,
        isSmall: true,
        onClick: (analyticsEvent)=>{
            changeFavorite({
                id: queueId,
                value: !isStarred,
                type: (0, $aMJA4.QUEUES_ITEM_TYPE)
            }, analyticsEvent);
        }
    });
};

});
parcelRegister("fVPN0", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $c7558d16e1b4ddea$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $c7558d16e1b4ddea$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eq3Hf = parcelRequire("eq3Hf");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $gGgaG = parcelRequire("gGgaG");

var $aaIe7 = parcelRequire("aaIe7");

var $2Cx9n = parcelRequire("2Cx9n");

var $91hUW = parcelRequire("91hUW");

var $dLR8J = parcelRequire("dLR8J");

var $k71qx = parcelRequire("k71qx");

var $l5htz = parcelRequire("l5htz");

var $f2JN3 = parcelRequire("f2JN3");

var $idGBm = parcelRequire("idGBm");

var $6XJko = parcelRequire("6XJko");

var $6urTU = parcelRequire("6urTU");
const $c7558d16e1b4ddea$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper'; // eslint-disable-next-line jira/react/no-class-components
class $c7558d16e1b4ddea$export$f8ad2acf0ec4860f extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $c7558d16e1b4ddea$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$db65185b5889c83, {
            "data-testid": $c7558d16e1b4ddea$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($91hUW))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aaIe7))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2Cx9n))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
            const StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))) : (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label,
                size: isSmall ? 'small' : 'medium'
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6urTU.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6urTU.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }, (0, $6XJko.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $c7558d16e1b4ddea$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $l5htz.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $idGBm.injectIntlV2))($c7558d16e1b4ddea$export$f8ad2acf0ec4860f);
const $c7558d16e1b4ddea$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBase = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew, $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $c7558d16e1b4ddea$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syaz1oju",
            __cmplp.isFavorite ? "_30l31vop" : "_30l3wdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$db65185b5889c83 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gGgaG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c24d1cda47746043$var$_react = $c24d1cda47746043$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c24d1cda47746043$var$_baseNew = $c24d1cda47746043$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c24d1cda47746043$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c24d1cda47746043$var$StarStarredIcon = (props)=>/*#__PURE__*/ $c24d1cda47746043$var$_react.default.createElement($c24d1cda47746043$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$c24d1cda47746043$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $c24d1cda47746043$var$_default = module.exports.default = $c24d1cda47746043$var$StarStarredIcon;

});

parcelRegister("2Cx9n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e88d859d9ad0102$var$_react = $1e88d859d9ad0102$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1e88d859d9ad0102$var$_starUnstarred = $1e88d859d9ad0102$var$_interopRequireDefault((parcelRequire("aaIe7")));
function $1e88d859d9ad0102$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e88d859d9ad0102$var$StarIcon = (props)=>/*#__PURE__*/ $1e88d859d9ad0102$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $1e88d859d9ad0102$var$_starUnstarred.default
    }));
$1e88d859d9ad0102$var$StarIcon.displayName = 'StarIcon';
var $1e88d859d9ad0102$var$_default = module.exports.default = $1e88d859d9ad0102$var$StarIcon;

});

parcelRegister("91hUW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69121b14e227da1b$var$_react = $69121b14e227da1b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $69121b14e227da1b$var$_starStarred = $69121b14e227da1b$var$_interopRequireDefault((parcelRequire("gGgaG")));
function $69121b14e227da1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $69121b14e227da1b$var$StarFilledIcon = (props)=>/*#__PURE__*/ $69121b14e227da1b$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $69121b14e227da1b$var$_starStarred.default
    }));
$69121b14e227da1b$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $69121b14e227da1b$var$_default = module.exports.default = $69121b14e227da1b$var$StarFilledIcon;

});

parcelRegister("6urTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $708ae8e1a771b9ca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $708ae8e1a771b9ca$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});




parcelRegister("2qglJ", function(module, exports) {

$parcel$export(module.exports, "AllQueuesFlyout", () => $b2f3d2c35ee51346$export$6e323880808677df);

var $eJOHy = parcelRequire("eJOHy");

var $bpdtz = parcelRequire("bpdtz");

var $gWy6a = parcelRequire("gWy6a");
var $duFAq = parcelRequire("duFAq");
var $yLgR2 = parcelRequire("yLgR2");

var $lRq8t = parcelRequire("lRq8t");

var $dRr4h = parcelRequire("dRr4h");

var $3fKYX = parcelRequire("3fKYX");

var $gIVAN = parcelRequire("gIVAN");

var $9H0yD = parcelRequire("9H0yD");
const $b2f3d2c35ee51346$export$6e323880808677df = ({ projectKey: projectKey, practice: practice })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const queueCustomContext = (0, $dRr4h.useQueueCustomRouterContext)(projectKey);
    const [allQueues] = (0, $3fKYX.useCategorizedNavItems)(projectKey, practice, queueCustomContext);
    if (!allQueues || allQueues.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWy6a.FlyoutMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yLgR2.FlyoutMenuItemTrigger), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        })
    }, formatMessage((0, $9H0yD.messages).viewAllQueues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $duFAq.FlyoutMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gIVAN.AllQueues), {
        projectKey: projectKey,
        practice: practice,
        isFlyOut: true
    })));
};

});
parcelRegister("gIVAN", function(module, exports) {

$parcel$export(module.exports, "AllQueues", () => $7305bdc0fa08f070$export$4c4b4d372f994d4e);

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $sY9BV = parcelRequire("sY9BV");

var $1ejND = parcelRequire("1ejND");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $dRr4h = parcelRequire("dRr4h");

var $9gPby = parcelRequire("9gPby");

var $3fKYX = parcelRequire("3fKYX");

var $7DS4g = parcelRequire("7DS4g");

var $9H0yD = parcelRequire("9H0yD");
const $7305bdc0fa08f070$export$4c4b4d372f994d4e = ({ projectKey: projectKey, practice: practice, isFlyOut: isFlyOut = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const queueCustomContext = (0, $dRr4h.useQueueCustomRouterContext)(projectKey);
    const [allQueues] = (0, $3fKYX.useCategorizedNavItems)(projectKey, practice, queueCustomContext);
    const [filter, setFilter] = (0, $eJOHy.useState)('');
    const searchResultQueues = (0, $eJOHy.useMemo)(()=>allQueues?.filter((queue)=>queue.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase())) ?? [], [
        allQueues,
        filter
    ]);
    const SearchIconMemo = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
            label: "",
            spacing: "spacious",
            color: "currentColor"
        }), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleChange = (0, $eJOHy.useCallback)((event)=>{
        setFilter(event.currentTarget.value);
    }, []);
    const onStopQueueSearch = (0, $eJOHy.useCallback)(()=>{
        const getViewAllQueueSearchEvent = createAnalyticsEvent({
            action: 'blurred',
            actionSubject: 'jsmViewAllQueueFlyoutSearch'
        });
        (0, $gCeeo.fireUIAnalytics)(getViewAllQueueSearchEvent, 'stopViewAllQueueSearch', {
            projectKey: projectKey,
            practice: practice
        });
    }, [
        createAnalyticsEvent,
        projectKey,
        practice
    ]);
    if (!allQueues || allQueues.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.050"
    }, isFlyOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, formatMessage((0, $9H0yD.messages).allQueues))), isFlyOut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7305bdc0fa08f070$var$filterContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        isCompact: true,
        value: filter,
        onChange: handleChange,
        "aria-label": formatMessage((0, $9H0yD.messages).searchYourQueue),
        placeholder: formatMessage((0, $9H0yD.messages).searchYourQueue),
        elemBeforeInput: SearchIconMemo,
        onBlur: onStopQueueSearch
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.050",
        xcss: $7305bdc0fa08f070$var$scrollBoxStyles
    }, searchResultQueues.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7DS4g.QueueList), {
        queues: searchResultQueues,
        section: (0, $9gPby.QueueListSection).ALL_QUEUES,
        isQueueListInFlyOut: isFlyOut
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlock: "space.100",
        xcss: $7305bdc0fa08f070$var$noSearchResultsFoundStyles
    }, formatMessage((0, $9H0yD.messages).noSearchResultsFound)))));
};
const $7305bdc0fa08f070$var$noSearchResultsFoundStyles = (0, $1DXK0.xcss)({
    fontStyle: 'italic'
});
const $7305bdc0fa08f070$var$scrollBoxStyles = (0, $1DXK0.xcss)({
    overflow: 'auto',
    scrollbarGutter: 'auto',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingRight: 'space.100'
});
const $7305bdc0fa08f070$var$filterContainerStyles = (0, $1DXK0.xcss)({
    minHeight: 'space.400',
    paddingRight: 'space.100'
});

});
parcelRegister("7DS4g", function(module, exports) {

$parcel$export(module.exports, "QueueList", () => $d32c2400f53aa725$export$6b278a59f65cf1eb);

var $eJOHy = parcelRequire("eJOHy");

var $hURB3 = parcelRequire("hURB3");
const $d32c2400f53aa725$export$6b278a59f65cf1eb = ({ QueueItem: QueueItem = (0, $hURB3.QueueItem), queues: queues, section: section, projectKey: projectKey, priorityGroupId: priorityGroupId, isQueueListInFlyOut: isQueueListInFlyOut = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, queues.map((queue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(QueueItem, {
            key: queue.id,
            queue: queue,
            section: section,
            projectKey: projectKey,
            priorityGroupId: priorityGroupId,
            isQueueInFlyOut: isQueueListInFlyOut
        })));
};

});

parcelRegister("9H0yD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cce1bda9e063337c$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $cce1bda9e063337c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    allQueues: {
        "id": "servicedesk-queues-nav4.common.practice-queues.all-queues-section.all-queues",
        "defaultMessage": "All queues"
    },
    viewAllQueues: {
        "id": "servicedesk-queues-nav4.common.practice-queues.all-queues-section.view-all-queues",
        "defaultMessage": "View all queues"
    },
    searchYourQueue: {
        "id": "servicedesk-queues-nav4.common.practice-queues.all-queues-section.search-your-queue",
        "defaultMessage": "Search your queue"
    },
    noSearchResultsFound: {
        "id": "servicedesk-queues-nav4.common.practice-queues.all-queues-section.no-search-results-found",
        "defaultMessage": "No search results found"
    }
});

});



parcelRegister("2QMGq", function(module, exports) {

$parcel$export(module.exports, "AllQueuesPopOut", () => $ef8370533b89f7e2$export$c9909bdf149a8c80);

var $eJOHy = parcelRequire("eJOHy");

var $1Bb7G = parcelRequire("1Bb7G");
var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");

var $lRq8t = parcelRequire("lRq8t");

var $dRr4h = parcelRequire("dRr4h");

var $3fKYX = parcelRequire("3fKYX");

var $2FqDG = parcelRequire("2FqDG");

var $5h7v8 = parcelRequire("5h7v8");

var $71f18 = parcelRequire("71f18");

var $gIVAN = parcelRequire("gIVAN");

var $9H0yD = parcelRequire("9H0yD");
const $ef8370533b89f7e2$export$c9909bdf149a8c80 = ({ projectKey: projectKey, practice: practice })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const queueCustomContext = (0, $dRr4h.useQueueCustomRouterContext)(projectKey);
    const [allQueues] = (0, $3fKYX.useCategorizedNavItems)(projectKey, practice, queueCustomContext);
    const [queueIdFromPath] = (0, $2FqDG.usePathParam)('queueId');
    const [selectedNavLocation] = (0, $5h7v8.useSelectedNavLocation)(queueIdFromPath || '');
    if (!allQueues || allQueues.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Bb7G.ExpandableMenuItem), {
        isDefaultExpanded: selectedNavLocation.section === (0, $71f18.QueueListSection).ALL_QUEUES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), null, formatMessage((0, $9H0yD.messages).allQueues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gIVAN.AllQueues), {
        projectKey: projectKey,
        practice: practice
    })));
};

});


parcelRegister("3KpGc", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aa124e6a005b4388$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $aa124e6a005b4388$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    fetchQueuesError: {
        "id": "servicedesk-queues-nav4.common.practice-queues.fetch-queues-error",
        "defaultMessage": "We're unable to load queues data, <button>try again.</button>"
    }
});

});

parcelRegister("bK1c8", function(module, exports) {

$parcel$export(module.exports, "QueuesExperienceTracker", () => $b09e4cb2215e612e$export$68c534d50bf4d3ae);

var $eJOHy = parcelRequire("eJOHy");

var $1cD2y = parcelRequire("1cD2y");

var $fakPW = parcelRequire("fakPW");

var $3NxIX = parcelRequire("3NxIX");

var $3aa9n = parcelRequire("3aa9n");

var $bRJAs = parcelRequire("bRJAs");

var $8vyDv = parcelRequire("8vyDv");
const $b09e4cb2215e612e$export$68c534d50bf4d3ae = ({ children: children })=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fakPW.ViewExperienceTrackingProvider), {
        application: (0, $bRJAs.JIRA_SERVICE_DESK),
        edition: appEditions.serviceDesk,
        // DESK-5408 replace "viewQueuesNav4" with "viewQueuesNav"
        experience: "viewQueuesNav4",
        analyticsSource: "queuesNav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cD2y.ExperienceTracker), {
        location: "queues-nav-render-error"
    }, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3NxIX.default), {
            handler: (error)=>{
                onExperienceFailure(undefined, {
                    errorMessage: error?.message,
                    errorName: error?.name
                });
            },
            isRethrowEnabled: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aa9n.default), {
            op: onExperienceSuccess
        })))));
};

});
parcelRegister("3NxIX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b945f0bc80c6f3d4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
class $b945f0bc80c6f3d4$var$OnCatch extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            arg: undefined,
            isRethrowEnabled: false
        };
    }
    componentDidCatch(error, errorInfo) {
        const { handler: handler, isRethrowEnabled: isRethrowEnabled, arg: arg } = this.props;
        handler(error, errorInfo, arg);
        if (isRethrowEnabled) throw error;
    }
    render() {
        return this.props.children;
    }
}
var $b945f0bc80c6f3d4$export$2e2bcd8739ae039 = $b945f0bc80c6f3d4$var$OnCatch;

});


parcelRegister("is8TG", function(module, exports) {

$parcel$export(module.exports, "QueueGroupsSection", () => $414ccbfe8659930e$export$95e0028b61fb2a1a);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $8IeH1 = parcelRequire("8IeH1");

var $dLR8J = parcelRequire("dLR8J");

var $1Bb7G = parcelRequire("1Bb7G");
var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");
var $1ejND = parcelRequire("1ejND");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $if69u = parcelRequire("if69u");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $9gPby = parcelRequire("9gPby");

var $2FqDG = parcelRequire("2FqDG");

var $7jTnu = parcelRequire("7jTnu");

var $5h7v8 = parcelRequire("5h7v8");

var $1F5u7 = parcelRequire("1F5u7");

var $7DS4g = parcelRequire("7DS4g");

var $gwLNq = parcelRequire("gwLNq");
const $414ccbfe8659930e$export$95e0028b61fb2a1a = ({ projectKey: projectKey, currentCategory: currentCategory, onGroupDataRefresh: onGroupDataRefresh })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [filteredGroups, isLoading, error] = (0, $1F5u7.useFilteredCategorizedQueueGroups)(projectKey, currentCategory);
    const [queueIdFromPath] = (0, $2FqDG.usePathParam)('queueId');
    const [selectedNavLocation] = (0, $5h7v8.useSelectedNavLocation)(queueIdFromPath || '');
    const isInvalidSelectedNavLocation = queueIdFromPath && selectedNavLocation.section === undefined;
    const ExpandableGroups = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, filteredGroups.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Bb7G.ExpandableMenuItem), {
                key: group.group.id,
                isDefaultExpanded: selectedNavLocation?.groupId === group.group.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), null, group.group.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7DS4g.QueueList), {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                queues: group.queues,
                section: (0, $9gPby.QueueListSection).PRIORITY_GROUP,
                projectKey: projectKey,
                priorityGroupId: group.group.id
            }))))), [
        filteredGroups,
        projectKey,
        selectedNavLocation?.groupId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (error) (0, $gYnSx.default)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            meta: {
                id: 'jsmQueueGroupsError',
                packageName: 'jiraServicedeskQueuesNav4',
                teamName: 'jsd-shield'
            }
        });
        else if (filteredGroups && !isLoading && filteredGroups.length > 0) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueGroups rendered', {
            projectKey: projectKey,
            groupSize: filteredGroups.length,
            category: currentCategory,
            packageName: 'jiraServicedeskQueuesNav4',
            teamName: 'jsd-shield'
        });
    }, [
        createAnalyticsEvent,
        currentCategory,
        error,
        filteredGroups,
        isLoading,
        projectKey
    ]);
    // Render loading state
    if (isLoading || isInvalidSelectedNavLocation) return (0, $7jTnu.fg)('jsm_flash_add_more_ufo_holds_to_nav') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "practice-queue-loading-priority-groups"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
        count: 2
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $if69u.SkeletonNavMenuItems), {
        count: 2
    });
    // Render error state
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        padding: "space.100"
    }, formatMessage((0, $gwLNq.messages).fetchPriorityGroupError, {
        button: (buttonLabel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                spacing: "none",
                appearance: "link",
                onClick: onGroupDataRefresh
            }, buttonLabel)
    })));
    return ExpandableGroups;
};

});
parcelRegister("gwLNq", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c568aadfa3bbf322$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c568aadfa3bbf322$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    fetchPriorityGroupError: {
        "id": "servicedesk-queues-nav4.common.practice-queues.queue-groups.fetch-priority-group-error",
        "defaultMessage": "We're unable to load data in the priority group, <button>try again.</button>"
    }
});

});


parcelRegister("fOHa9", function(module, exports) {

$parcel$export(module.exports, "StarredSection", () => $a00fbed8c3fc9cc4$export$e5f8d87968088916);

var $eJOHy = parcelRequire("eJOHy");

var $1Bb7G = parcelRequire("1Bb7G");
var $7Z9EK = parcelRequire("7Z9EK");
var $fFq5m = parcelRequire("fFq5m");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $lRq8t = parcelRequire("lRq8t");

var $dRr4h = parcelRequire("dRr4h");

var $9gPby = parcelRequire("9gPby");

var $3fKYX = parcelRequire("3fKYX");

var $2FqDG = parcelRequire("2FqDG");

var $2lG8T = parcelRequire("2lG8T");

var $5h7v8 = parcelRequire("5h7v8");

var $7DS4g = parcelRequire("7DS4g");

var $h1xlo = parcelRequire("h1xlo");
const $a00fbed8c3fc9cc4$export$e5f8d87968088916 = ({ practice: practice, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const queueCustomContext = (0, $dRr4h.useQueueCustomRouterContext)(projectKey);
    const popoutConfig = (0, $2lG8T.usePopoutConfig)(projectKey, practice);
    const [queues] = (0, $3fKYX.useFavouriteNavItems)(projectKey, practice, queueCustomContext);
    const [queueIdFromPath] = (0, $2FqDG.usePathParam)('queueId');
    const [selectedNavLocation] = (0, $5h7v8.useSelectedNavLocation)(queueIdFromPath || '');
    if (!queues || queues.length === 0) return null;
    if (popoutConfig.isPoppedOut) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Bb7G.ExpandableMenuItem), {
        isDefaultExpanded: selectedNavLocation.section === (0, $9gPby.QueueListSection).STARRED
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), null, formatMessage((0, $h1xlo.messages).starredHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7DS4g.QueueList), {
        queues: queues,
        section: (0, $9gPby.QueueListSection).STARRED,
        projectKey: projectKey
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $h1xlo.messages).starredHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7DS4g.QueueList), {
        queues: queues,
        section: (0, $9gPby.QueueListSection).STARRED,
        projectKey: projectKey
    }));
};

});
parcelRegister("h1xlo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1470a67c81407572$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1470a67c81407572$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    starredHeader: {
        "id": "servicedesk-queues-nav4.common.practice-queues.starred-section.starred-header",
        "defaultMessage": "Starred"
    }
});

});



parcelRegister("bonwv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f3801d9ce8ca635$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6f3801d9ce8ca635$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    spotlightHeading: {
        "id": "servicedesk-queues-popout-panel-nav4.spotlight-heading",
        "defaultMessage": "Work on queues your way"
    },
    spotlightMessage: {
        "id": "servicedesk-queues-popout-panel-nav4.spotlight-message",
        "defaultMessage": "Choose to work on queues from your main navigation, or pop out queues to keep focused."
    },
    spotlightDismissButtonLabel: {
        "id": "servicedesk-queues-popout-panel-nav4.spotlight-dismiss-button-label",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("aiMPg", function(module, exports) {

$parcel$export(module.exports, "FilterQueryFailed", () => $eb4c07d6b97b02e6$export$fd20e2768ee7eace);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $7jTnu = parcelRequire("7jTnu");

var $eliZS = parcelRequire("eliZS");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $8kRip = parcelRequire("8kRip");

var $gJKGo = parcelRequire("gJKGo");
const $eb4c07d6b97b02e6$export$fd20e2768ee7eace = ({ onFilterClear: onFilterClear })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const renderImage = ()=>(0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $eliZS.default))({
            imageWidth: 120,
            maxImageWidth: 120,
            maxImageHeight: 160
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eb4c07d6b97b02e6$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        testId: "servicedesk-queues-agent-view.layout.filter-query-failed.query-failed",
        imageUrl: (0, $7jTnu.fg)('jsm_queues_consolidate_jfe_assets') ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($8kRip))),
        renderImage: (0, $7jTnu.fg)('jsm_queues_consolidate_jfe_assets') ? renderImage : undefined,
        header: formatMessage((0, $gJKGo.default).errorHeader),
        description: formatMessage((0, $gJKGo.default).errorMessage),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "link",
            onClick: onFilterClear,
            testId: "servicedesk-queues-agent-view.layout.filter-query-failed.clear-search-button"
        }, formatMessage((0, $gJKGo.default).clearSearch))
    }));
};
const $eb4c07d6b97b02e6$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eliZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbff5551dc414320$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $hKd5B = parcelRequire("hKd5B");
const $cbff5551dc414320$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hKd5B)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hKd5B))
});
var $cbff5551dc414320$export$2e2bcd8739ae039 = $cbff5551dc414320$var$Illustration;
const $cbff5551dc414320$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("hKd5B", function(module, exports) {
module.exports = new URL("error-white.e2723ea8.svg", import.meta.url).toString();

});


parcelRegister("8kRip", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("gJKGo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f47106503114ccb2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f47106503114ccb2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorHeader: {
        "id": "servicedesk.queues.agent-view.layout.filter-query-failed.error-header",
        "defaultMessage": "We couldn't load your search results"
    },
    errorMessage: {
        "id": "servicedesk.queues.agent-view.layout.filter-query-failed.error-message",
        "defaultMessage": "Check for typos, or try another search term"
    },
    clearSearch: {
        "id": "servicedesk.queues.agent-view.layout.filter-query-failed.clear-search",
        "defaultMessage": "Clear search"
    }
});

});


parcelRegister("54C7g", function(module, exports) {

$parcel$export(module.exports, "JsmAssetsOnboarding", () => $67e353f0c87b71fe$export$2001064adb481776);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $iqAEB = parcelRequire("iqAEB");

var $9zZj0 = parcelRequire("9zZj0");

var $1KdDN = parcelRequire("1KdDN");

var $7jTnu = parcelRequire("7jTnu");

var $22c3C = parcelRequire("22c3C");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $iWhpv = parcelRequire("iWhpv");

var $jlJsl = parcelRequire("jlJsl");

var $gZTP9 = parcelRequire("gZTP9");

var $km1bo = parcelRequire("km1bo");

var $7O2rD = parcelRequire("7O2rD");
const $67e353f0c87b71fe$var$OnboardingTrigger = ({ stop: stop = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), category: category, messageId: messageId = 'servicedesk-queues-agent-view.layout.jsm-assets-onboarding.ak-flag', messageType: messageType = 'transactional' })=>{
    const flagId = (0, $eJOHy.useRef)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const { data: isItsmProject } = (0, $iWhpv.useIsItsmTemplateProject)();
    const shouldRender = isItsmProject && (projectContext?.isProjectAdmin || isAdmin);
    const flagMeta = (0, $eJOHy.useMemo)(()=>({
            [(0, $jlJsl.CHANGES)]: {
                title: (0, $7O2rD.default).changeManagementFlagTitle,
                description: (0, $7O2rD.default).changeManagementFlagDescription,
                action: (0, $7O2rD.default).changeManagementFlagActionText,
                actionUrl: `/jira/servicedesk/projects/${projectContext?.projectKey}/settings/change-management?tab=assets`
            },
            [(0, $jlJsl.INCIDENTS)]: {
                title: (0, $7O2rD.default).incidentManagementFlagTitle,
                description: (0, $7O2rD.default).incidentManagementFlagDescription,
                action: (0, $7O2rD.default).incidentManagementFlagActionText,
                actionUrl: `/jira/servicedesk/projects/${projectContext?.projectKey}/settings/incident-management`
            }
        })[category], [
        category,
        projectContext?.projectKey
    ]);
    (0, $eJOHy.useEffect)(()=>{
        stop?.();
    }, [
        stop
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldRender && flagId.current == null) {
            flagId.current = showFlag({
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $22c3C.default), {
                        ...props,
                        // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
                        id: flagId,
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iqAEB))), {
                            label: formatMessage(flagMeta.title),
                            color: "currentColor"
                        }),
                        title: formatMessage(flagMeta.title),
                        description: formatMessage(flagMeta.description),
                        // eslint-disable-next-line jira/react-no-inline-function-prop
                        onDismissed: ()=>{
                            if (flagId.current) dismissFlag(flagId.current);
                        },
                        actions: [
                            {
                                href: projectContext?.projectKey ? flagMeta.actionUrl : '/jira',
                                content: formatMessage(flagMeta.action)
                            }
                        ],
                        messageId: messageId,
                        messageType: messageType
                    })
            });
            // https://data-portal.internal.atlassian.com/analytics/registry/73694
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmAssetsOnboardingFlag rendered', {
                category: category
            });
        }
    }, [
        category,
        createAnalyticsEvent,
        dismissFlag,
        flagMeta,
        formatMessage,
        messageId,
        messageType,
        projectContext?.projectKey,
        shouldRender,
        showFlag
    ]);
    return null;
};
const $67e353f0c87b71fe$export$2001064adb481776 = ({ category: category })=>{
    const messageId = (0, $km1bo.EP_MESSAGES)[category];
    const messageType = 'engagement';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jsm-assets-onboarding",
        packageName: "jiraServicedeskAssetsOnboarding",
        teamName: "alexstrasza",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9zZj0.default), {
        fallback: null,
        messageId: messageId,
        messageType: messageType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($67e353f0c87b71fe$var$OnboardingTrigger, {
        category: category,
        messageId: (0, $7jTnu.fg)('choreographed_jsm_assets_onboarding') ? messageId : undefined,
        messageType: (0, $7jTnu.fg)('choreographed_jsm_assets_onboarding') ? messageType : undefined
    })));
};

});
parcelRegister("km1bo", function(module, exports) {

$parcel$export(module.exports, "EP_MESSAGES", () => $617a131feb13e264$export$80a3323af595e15b);

var $jlJsl = parcelRequire("jlJsl");
const $617a131feb13e264$export$80a3323af595e15b = {
    [(0, $jlJsl.CHANGES)]: 'affected-assets-in-jsm-cm',
    [(0, $jlJsl.INCIDENTS)]: 'affected-assets-in-jsm-im'
};

});

parcelRegister("7O2rD", function(module, exports) {

$parcel$export(module.exports, "default", () => $46617b5364015eba$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $46617b5364015eba$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    incidentManagementFlagTitle: {
        "id": "servicedesk.queues.agent-view.layout.jsm-assets-onboarding.incident-management-flag-title",
        "defaultMessage": "Add Assets objects to incidents"
    },
    incidentManagementFlagDescription: {
        "id": "servicedesk.queues.agent-view.layout.jsm-assets-onboarding.incident-management-flag-description",
        "defaultMessage": "Link Assets objects with incidents and gain better insight on your IT infrastructure."
    },
    incidentManagementFlagActionText: {
        "id": "servicedesk.queues.agent-view.layout.jsm-assets-onboarding.incident-management-flag-action-text",
        "defaultMessage": "View incident management settings "
    },
    changeManagementFlagTitle: {
        "id": "servicedesk.queues.agent-view.layout.jsm-assets-onboarding.change-management-flag-title",
        "defaultMessage": "Add Assets objects to changes"
    },
    changeManagementFlagDescription: {
        "id": "servicedesk.queues.agent-view.layout.jsm-assets-onboarding.change-management-flag-description",
        "defaultMessage": "Link Assets objects with changes and gain better insight on your IT infrastructure."
    },
    changeManagementFlagActionText: {
        "id": "servicedesk.queues.agent-view.layout.jsm-assets-onboarding.change-management-flag-action-text",
        "defaultMessage": "View change management settings "
    }
});

});


parcelRegister("dhUMo", function(module, exports) {

$parcel$export(module.exports, "default", () => $767855e84da4919d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $767855e84da4919d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    openIssueInSidebar: {
        "id": "servicedesk.queues.agent-view.layout.open-issue-in-sidebar",
        "defaultMessage": "Open issue in sidebar"
    },
    resizePanelButton: {
        "id": "servicedesk.queues.agent-view.layout.open-issue-in-sidebar-resize-panel",
        "defaultMessage": "Resize panel"
    },
    openIssueInSidebarIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.open-issue-in-sidebar-issue-term-refresh",
        "defaultMessage": "Open work item in sidebar"
    }
});

});

parcelRegister("8tmyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3898c06e343c4fd8$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $7jTnu = parcelRequire("7jTnu");

var $bKkYU = parcelRequire("bKkYU");

var $6I1gv = parcelRequire("6I1gv");

var $3fH4s = parcelRequire("3fH4s");

var $5WR8U = parcelRequire("5WR8U");

var $itsdR = parcelRequire("itsdR");

var $ht9L5 = parcelRequire("ht9L5");
const $3898c06e343c4fd8$var$mapStateToProps = (state)=>({
        IssueCount: (0, $7jTnu.fg)('jsm_a11y_improvements_for_queue_bactch_2') ? (0, $ht9L5.default) : (0, $3fH4s.default),
        IssueSearch: $5WR8U.default,
        isQueuesErrorHeaderDisplayed: (0, $6I1gv.isQueuesErrorHeaderDisplayed)(state)
    });
const $3898c06e343c4fd8$var$mapDispatchToProps = {
    renderDisplayError: (0, $bKkYU.displayQueuesErrorHeaderAction)
};
var $3898c06e343c4fd8$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($3898c06e343c4fd8$var$mapStateToProps, $3898c06e343c4fd8$var$mapDispatchToProps)((0, $itsdR.default));

});
parcelRegister("3fH4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $912c84e3c9fa0d12$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");


var $cpZzK = parcelRequire("cpZzK");

var $2MzoN = parcelRequire("2MzoN");

var $3MjJb = parcelRequire("3MjJb");

var $1TuhT = parcelRequire("1TuhT");

var $6I1gv = parcelRequire("6I1gv");

var $fiAOg = parcelRequire("fiAOg");
const $912c84e3c9fa0d12$var$mapDispatchToProps = (dispatch)=>({
        onFilterReloadClick: ()=>{
            dispatch((0, $cpZzK.isNewFilterQueryPendingAction)(true));
            dispatch((0, $2MzoN.loadIssuesAction)(0, (0, $f3fa5acbda0f3e0e$export$be4c1ea173a5271a)));
        }
    });
const $912c84e3c9fa0d12$var$mapStateToProps = (state)=>({
        issueCount: (0, $1TuhT.getIssueCount)(state),
        isCurrentDataFiltered: (0, $3MjJb.getIsCurrentDataFiltered)(state),
        isLoadingIssues: (0, $6I1gv.isLoadingIssues)(state)
    });
var $912c84e3c9fa0d12$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($912c84e3c9fa0d12$var$mapStateToProps, $912c84e3c9fa0d12$var$mapDispatchToProps)((0, $fiAOg.default));

});
parcelRegister("fiAOg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbbc74b906dda5fe$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $i78b1 = parcelRequire("i78b1");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $dLR8J = parcelRequire("dLR8J");

var $9A8Wt = parcelRequire("9A8Wt");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $f2JN3 = parcelRequire("f2JN3");

var $cAisc = parcelRequire("cAisc");
const $bbbc74b906dda5fe$export$542fba90cc9c1bd1 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { issueCount: issueCount, isCurrentDataFiltered: isCurrentDataFiltered, isLoadingIssues: isLoadingIssues, onFilterReloadClick: onFilterReloadClick } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleReloadClick = ()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering reloaded');
        onFilterReloadClick();
    };
    if (!isCurrentDataFiltered && issueCount !== 0 && !isLoadingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bbbc74b906dda5fe$var$Wrapper, null, formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $cAisc.default).numberOfIssuesIssueTermRefresh : (0, $cAisc.default).numberOfIssues, {
        issueCount: issueCount
    }));
    if (isCurrentDataFiltered && !isLoadingIssues) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bbbc74b906dda5fe$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bbbc74b906dda5fe$var$Layout, null, formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $cAisc.default).numberOfFilteredIssuesIssueTermRefresh : (0, $cAisc.default).numberOfFilteredIssues, {
        filteredIssueCount: issueCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $bbbc74b906dda5fe$var$spacerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "bottom",
        content: formatMessage((0, $cAisc.default).refreshResults)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "aria-label": formatMessage((0, $cAisc.default).refreshResults),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i78b1))), {
            label: formatMessage((0, $cAisc.default).refreshResults),
            LEGACY_size: "small"
        }),
        "data-testId": "servicedesk-queues-agent-view.layout.queues-details.issue-count.reload-button",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleReloadClick
    }))));
    const skeleton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.Skeleton), {
        height: "24px",
        width: "100px",
        "data-testid": "servicedesk-queues-agent-view.layout.queues-details.issue-count.skeleton"
    });
    if ((0, $7jTnu.fg)('add_ufo_load_hold_to_custom_queue')) return isLoadingIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bbbc74b906dda5fe$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "issue-count"
    }, skeleton)) : null;
    return isLoadingIssues ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bbbc74b906dda5fe$var$Wrapper, null, skeleton) : null;
};
var $bbbc74b906dda5fe$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $bbbc74b906dda5fe$export$542fba90cc9c1bd1;
const $bbbc74b906dda5fe$var$Layout = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $bbbc74b906dda5fe$var$spacerStyles = (0, $1DXK0.xcss)({
    width: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $bbbc74b906dda5fe$export$58177b930ead77be = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1gjq _19pkutpp _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $bbbc74b906dda5fe$var$Wrapper = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockEnd: "space.150",
        paddingBlockStart: (0, $7jTnu.fg)('corcap-2944-add-jqlbuilder-to-jsm-queues') ? 'space.0' : 'space.150',
        xcss: [
            $bbbc74b906dda5fe$var$wrapperStyles,
            (0, $7jTnu.fg)('corcap-2944-add-jqlbuilder-to-jsm-queues') && $bbbc74b906dda5fe$var$negativeMarginStyles
        ]
    }, children), $bbbc74b906dda5fe$export$58177b930ead77be);
const $bbbc74b906dda5fe$var$wrapperStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtle'
});
const $bbbc74b906dda5fe$var$negativeMarginStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.negative.050'
});

});
parcelRegister("i78b1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97b7deedaffb04632472c93b0c8f5452>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2ff392db1cfed64$var$_react = $d2ff392db1cfed64$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d2ff392db1cfed64$var$_refresh = $d2ff392db1cfed64$var$_interopRequireDefault((parcelRequire("yJU5w")));

var $d2ff392db1cfed64$var$_refresh2 = $d2ff392db1cfed64$var$_interopRequireDefault((parcelRequire("96otq")));
function $d2ff392db1cfed64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2ff392db1cfed64$var$RefreshIcon = (props)=>/*#__PURE__*/ $d2ff392db1cfed64$var$_react.default.createElement($d2ff392db1cfed64$var$_refresh.default, Object.assign({
        LEGACY_fallbackIcon: $d2ff392db1cfed64$var$_refresh2.default
    }, props));
$d2ff392db1cfed64$var$RefreshIcon.Name = 'RefreshIconMigration';
var $d2ff392db1cfed64$var$_default = module.exports.default = $d2ff392db1cfed64$var$RefreshIcon;

});
parcelRegister("yJU5w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0686c89929896566$var$_react = $0686c89929896566$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0686c89929896566$var$_baseNew = $0686c89929896566$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0686c89929896566$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0686c89929896566$var$RefreshIcon = (props)=>/*#__PURE__*/ $0686c89929896566$var$_react.default.createElement($0686c89929896566$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$0686c89929896566$var$RefreshIcon.displayName = 'RefreshIcon';
var $0686c89929896566$var$_default = module.exports.default = $0686c89929896566$var$RefreshIcon;

});

parcelRegister("96otq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a07a88e32d8e8bc$var$_react = $6a07a88e32d8e8bc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $6a07a88e32d8e8bc$var$_refresh = $6a07a88e32d8e8bc$var$_interopRequireDefault((parcelRequire("yJU5w")));
function $6a07a88e32d8e8bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6a07a88e32d8e8bc$var$RefreshIcon = (props)=>/*#__PURE__*/ $6a07a88e32d8e8bc$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $6a07a88e32d8e8bc$var$_refresh.default
    }));
$6a07a88e32d8e8bc$var$RefreshIcon.displayName = 'RefreshIcon';
var $6a07a88e32d8e8bc$var$_default = module.exports.default = $6a07a88e32d8e8bc$var$RefreshIcon;

});


parcelRegister("9A8Wt", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $72d4b536fea173c6$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "SkeletonCompiled", () => $72d4b536fea173c6$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $72d4b536fea173c6$export$e477bb7d17087f28);
$parcel$export(module.exports, "Skeleton", () => $72d4b536fea173c6$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $72d4b536fea173c6$export$d7a54cba636a8cd6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $cdbP5 = parcelRequire("cdbP5");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");
const $72d4b536fea173c6$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $cdbP5.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $72d4b536fea173c6$var$shimmer = $72d4b536fea173c6$export$b2b5e866b2fbf2ec();
const $72d4b536fea173c6$export$1d2144641222f3bd = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $72d4b536fea173c6$var$shimmer,
        animationTimingFunction: 'linear',
        backgroundColor: "var(--ds-skeleton, #091E420F)",
        backgroundImage: `linear-gradient( to right, ${"var(--ds-skeleton, #091E420F)"} 10%, ${"var(--ds-skeleton-subtle, #091E4208)"} 30%, ${"var(--ds-skeleton, #091E420F)"} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $72d4b536fea173c6$export$b1deee0d21f1be36 = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $72d4b536fea173c6$export$dc84d515085190e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height),
            "--_1gljcou": (0, $awdRS.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoyh40 _ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $72d4b536fea173c6$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});
const $72d4b536fea173c6$export$8f31e4c4a37b8e9c = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('enghealth-4756-migrate-complex-styled-component-v2'), $72d4b536fea173c6$export$dc84d515085190e, $72d4b536fea173c6$export$1d2144641222f3bd);
const $72d4b536fea173c6$export$d7a54cba636a8cd6 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('enghealth-4756-migrate-complex-styled-component-v2'), $72d4b536fea173c6$export$e477bb7d17087f28, $72d4b536fea173c6$export$b1deee0d21f1be36);

});

parcelRegister("cAisc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e7b488a9b588649$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6e7b488a9b588649$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    numberOfIssues: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-issues",
        "defaultMessage": "{issueCount, plural,\n            =1 {{issueCount, number} issue}\n            other {{issueCount, number} issues}\n            }"
    },
    numberOfFilteredIssues: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-filtered-issues",
        "defaultMessage": "{filteredIssueCount, plural,\n            =1 {{filteredIssueCount, number} issue found}\n            other {{filteredIssueCount, number} issues found}\n            }"
    },
    refreshResults: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.refresh-results",
        "defaultMessage": "Refresh results"
    },
    numberOfIssuesIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-issues-issue-term-refresh",
        "defaultMessage": "{issueCount, plural,\n            =1 {{issueCount, number} work item}\n            other {{issueCount, number} work items}\n            }"
    },
    numberOfFilteredIssuesIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-filtered-issues-issue-term-refresh",
        "defaultMessage": "{filteredIssueCount, plural,\n            =1 {{filteredIssueCount, number} work item found}\n            other {{filteredIssueCount, number} work items found}\n            }"
    }
});

});



parcelRegister("5WR8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cc1e345fbaf2ba$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $gnQAk = parcelRequire("gnQAk");

var $cpZzK = parcelRequire("cpZzK");

var $3MjJb = parcelRequire("3MjJb");

var $lc49q = parcelRequire("lc49q");

var $5qmjQ = parcelRequire("5qmjQ");
const $35cc1e345fbaf2ba$var$mapDispatchToProps = (dispatch)=>({
        onChange: (text)=>{
            dispatch((0, $cpZzK.filterQuerySubmittedAction)(text));
        },
        onChangedIsPendingSubmission: (loading)=>dispatch((0, $cpZzK.isNewFilterQueryPendingAction)(loading)),
        onFocusChange: (isFocused)=>dispatch((0, $cpZzK.isFilterFocusedAction)(isFocused))
    });
const $35cc1e345fbaf2ba$var$mapStateToProps = (state)=>({
        queueId: (0, $lc49q.getQueueId)(state),
        filterQuery: (0, $3MjJb.getCurrentFilterQuery)(state)
    });
var $35cc1e345fbaf2ba$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($35cc1e345fbaf2ba$var$mapStateToProps, $35cc1e345fbaf2ba$var$mapDispatchToProps)((0, $5qmjQ.default));

});
parcelRegister("5qmjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a862aae5efdc298e$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3s8bj = parcelRequire("3s8bj");

var $5pWSu = parcelRequire("5pWSu");

var $dqx2X = parcelRequire("dqx2X");

var $sY9BV = parcelRequire("sY9BV");

var $k71qx = parcelRequire("k71qx");

var $fAZgY = parcelRequire("fAZgY");

var $2aY2d = parcelRequire("2aY2d");

var $7jTnu = parcelRequire("7jTnu");

var $bJscI = parcelRequire("bJscI");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $c1Djs = parcelRequire("c1Djs");
var $56qWy = parcelRequire("56qWy");

var $k5M3z = parcelRequire("k5M3z");

var $2FqDG = parcelRequire("2FqDG");

var $2h5Yw = parcelRequire("2h5Yw");

var $bhwM6 = parcelRequire("bhwM6");
const $a862aae5efdc298e$var$TextFieldWidth = 240;
const $a862aae5efdc298e$var$createJQLClause = (text)=>`summary ~ "${text}*" OR description ~ "${text}*"`;
const $a862aae5efdc298e$var$wildcardJQLClause = (text)=>text.replace(/textfields ~ "(.+)"/g, 'textfields ~ "$1*"');
const $a862aae5efdc298e$var$excludedFields = [
    'project'
];
const $a862aae5efdc298e$var$SEARCH_MODES = [
    (0, $56qWy.SEARCH_MODE_BASIC)
];
const $a862aae5efdc298e$var$JQLBuilderIssueSearchView = ({ onChange: onChange, onChangedIsPendingSubmission: onChangedIsPendingSubmission, onFocusChange: onFocusChange })=>{
    const [queueId] = (0, $2FqDG.usePathParam)('queueId');
    const { data: data } = (0, $2aY2d.useProjectContext)();
    const projectType = data?.projectType;
    const projectKey = data?.projectKey;
    const irremovableFilters = (0, $2h5Yw.useQueuesFilters)({
        projectType: projectType,
        isSimplified: (0, $2aY2d.useIsSimplifiedProject)()
    });
    const hasIrremovableFilters = (irremovableFilters || []).length > 0;
    (0, $eJOHy.useEffect)(()=>()=>{
            onFocusChange(false);
        }, [
        onFocusChange
    ]);
    const debouncedSearch = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((query)=>{
            const filterJQL = query === '' ? null : $a862aae5efdc298e$var$wildcardJQLClause(query);
            onChange(filterJQL);
            onChangedIsPendingSubmission(true);
        }, 500), [
        onChange,
        onChangedIsPendingSubmission
    ]);
    const handleSearchChange = (0, $fAZgY.useCallbackWithCondition)((jql)=>{
        debouncedSearch(jql);
    }, [
        debouncedSearch
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const projectKeys = (0, $fAZgY.useMemoWithCondition)(()=>projectKey ? {
            projectKeys: [
                projectKey
            ]
        } : {}, [
        projectKey
    ], ()=>(0, $7jTnu.fg)('jfp_magma_jsm-perf-improvement-batch-1'));
    return (0, $7jTnu.fg)('jsm_queues_jql_builder_perf_improvement') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c1Djs.default), {
        query: "",
        userPreferencesData: null,
        analyticsSource: "servicedesk-queues",
        excludedFields: $a862aae5efdc298e$var$excludedFields,
        searchModes: $a862aae5efdc298e$var$SEARCH_MODES,
        onUpdate: handleSearchChange,
        ...hasIrremovableFilters ? {
            basicModeVisibleFields: irremovableFilters
        } : {},
        ...projectKeys,
        key: queueId,
        viewContext: (0, $7jTnu.fg)('jsm-journey-jql-builder-m1') ? 'JSM_QUEUE_PAGE' : undefined
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k5M3z.default), {
        query: "",
        userPreferencesData: null,
        analyticsSource: "servicedesk-queues",
        excludedFields: $a862aae5efdc298e$var$excludedFields,
        searchModes: $a862aae5efdc298e$var$SEARCH_MODES,
        onUpdate: handleSearchChange,
        ...hasIrremovableFilters ? {
            basicModeVisibleFields: irremovableFilters
        } : {},
        ...projectKeys,
        key: queueId,
        viewContext: (0, $7jTnu.fg)('jsm-journey-jql-builder-m1') ? 'JSM_QUEUE_PAGE' : undefined
    });
};
const $a862aae5efdc298e$var$JQLBuilderIssueSearchViewWithSsrCover = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a862aae5efdc298e$var$JQLBuilderIssueSearchView, props), false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "servicedesk-queues-agent-view.layout.queues-details.issue-search.ssr-cover",
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _tzy4idpf _1bsb1osq _4t3i1osq"
        ])
    }));
};
const $a862aae5efdc298e$var$OldIssueSearchView = ({ onChange: onChange, onChangedIsPendingSubmission: onChangedIsPendingSubmission, onFocusChange: onFocusChange, queueId: queueId, filterQuery: filterQuery })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { placeholder: placeholder, placeholderIssueTermRefresh: placeholderIssueTermRefresh } = (0, $bhwM6.default);
    const [value, setValue] = (0, $eJOHy.useState)('');
    const [isIconHovered, setHovered] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        setValue('');
    }, [
        queueId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (filterQuery === null) setValue('');
    }, [
        filterQuery
    ]);
    (0, $eJOHy.useEffect)(()=>()=>{
            onFocusChange(false);
        }, [
        onFocusChange
    ]);
    const debouncedSearch = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((query)=>{
            const filterJQL = query === '' ? null : $a862aae5efdc298e$var$createJQLClause(query);
            onChange(filterJQL);
            onChangedIsPendingSubmission(true);
        }, 2000), [
        onChange,
        onChangedIsPendingSubmission
    ]);
    const handleSearchChange = (0, $fAZgY.useCallbackWithCondition)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    (event)=>{
        setValue(event.target.value);
        debouncedSearch(event.target.value);
    }, [
        debouncedSearch
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const onFocusHandle = (0, $fAZgY.useCallbackWithCondition)(()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering clicked');
        onFocusChange(true);
    }, [
        createAnalyticsEvent,
        onFocusChange
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const onBlurHandle = (0, $fAZgY.useCallbackWithCondition)(()=>onFocusChange(false), [
        onFocusChange
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const onMouseEnterButton = (0, $eJOHy.useCallback)(()=>setHovered(true), []);
    const onMouseLeaveButton = (0, $eJOHy.useCallback)(()=>setHovered(false), []);
    const clearSearch = (0, $fAZgY.useCallbackWithCondition)(()=>{
        setValue('');
        onChange(null);
        onChangedIsPendingSubmission(true);
    }, [
        onChange,
        onChangedIsPendingSubmission
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a862aae5efdc298e$var$MinWidthWrapper, {
        isDisabled: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        isReadOnly: false,
        isCompact: true,
        width: $a862aae5efdc298e$var$TextFieldWidth,
        placeholder: (0, $7jTnu.fg)('itsm-issue-renaming') ? formatMessage(placeholderIssueTermRefresh) : formatMessage(placeholder),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dqx2X))), {
            spacing: "spacious",
            label: ""
        }),
        onChange: handleSearchChange,
        value: value,
        onFocus: onFocusHandle,
        onBlur: onBlurHandle,
        elemAfterInput: value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage((0, $bhwM6.default).clearSearch)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a862aae5efdc298e$var$ClearSearchWrapper, {
            onClick: clearSearch,
            onMouseEnter: onMouseEnterButton,
            onMouseLeave: onMouseLeaveButton,
            "data-testid": "servicedesk-queues-agent-view.layout.queues-details.issue-search.clear-search"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5pWSu))), {
            color: isIconHovered ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-disabled, #091E424F)",
            label: formatMessage((0, $bhwM6.default).clearSearch),
            spacing: "none"
        })))
    }));
};
var $a862aae5efdc298e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $bJscI.componentWithFG)('corcap-2944-add-jqlbuilder-to-jsm-queues', (0, $bJscI.componentWithFG)('disable_jql_builder_fields_in_queues_when_ssr', $a862aae5efdc298e$var$JQLBuilderIssueSearchViewWithSsrCover, $a862aae5efdc298e$var$JQLBuilderIssueSearchView), $a862aae5efdc298e$var$OldIssueSearchView);
const $a862aae5efdc298e$var$ClearSearchWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxu2gc _80omtlke _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); /*
     * these styles are used for accommodating smaller screen sizes with the introduction of the split filters
     *
     * the min-width is needed to prevent the text area from shrinking to 0 size
     * the flex-shrink is used to give width priority to the active issue types / portal groups filters
     * the text-overflow is used when the text input is shrunken
     */ 
const $a862aae5efdc298e$var$MinWidthWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbp3fh _1ul953f4 _1o9z15gg _509t1l2s",
            __cmplp.isDisabled ? "_80om13gf" : "_80om1wug",
            __cmplp.className
        ])
    });
});
const $a862aae5efdc298e$var$jqlBuilderWrapperStyles = null;
const $a862aae5efdc298e$var$jqlBuilderCoverStyles = null;

});
parcelRegister("c1Djs", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdea910db13502ff$export$2e2bcd8739ae039);

var $epxdu = parcelRequire("epxdu");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $jvwCK = parcelRequire("jvwCK");

var $j4oe4 = parcelRequire("j4oe4");

var $g8Az8 = parcelRequire("g8Az8");

var $5kYyR = parcelRequire("5kYyR");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $hHzDA = parcelRequire("hHzDA");

var $cWcbh = parcelRequire("cWcbh");

var $8KuTC = parcelRequire("8KuTC");

var $ch9En = parcelRequire("ch9En");

var $4xbv3 = parcelRequire("4xbv3");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $56qWy = parcelRequire("56qWy");

var $gQyru = parcelRequire("gQyru");

var $3JHgj = parcelRequire("3JHgj");

var $bAZUe = parcelRequire("bAZUe");

var $lw8qf = parcelRequire("lw8qf");
// Inline query when cleaning up nin_migrate_jql_builder_to_refetchable_query
/* eslint-disable @atlassian/relay/graphql-naming */ const $cdea910db13502ff$var$JQLBUILDER_FRAGMENT = (0, $epxdu.default);
const $cdea910db13502ff$var$JQLBuilderOld = ({ onPerformanceMark: onPerformanceMark, ...props })=>{
    const userPreferencesRef = (0, $j4oe4.useFragment)($cdea910db13502ff$var$JQLBUILDER_FRAGMENT, props.userPreferencesData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: "unhandled",
        packageName: "jiraJqlBuilder",
        teamName: "empanada",
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $g8Az8.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "jqlBuilder",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8KuTC.PerformanceContext).Provider, {
        value: onPerformanceMark || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bAZUe.JQLBuilderUIOld), {
        ...props,
        userPreferences: userPreferencesRef ?? null
    }))));
};
const $cdea910db13502ff$var$JQLBuilder = ({ query: query, viewContext: viewContext = null, scope: scope = null, projectKeys: projectKeys, searchModes: searchModes = [
    (0, $56qWy.SEARCH_MODE_ADVANCED),
    (0, $56qWy.SEARCH_MODE_BASIC)
], searchModeSwitcherLocation: searchModeSwitcherLocation = (0, $56qWy.SEARCH_MODE_SWITCHER_LEFT_LOCATION), showOrderByPicker: showOrderByPicker, hideTextSearchInput: hideTextSearchInput = false, onPerformanceMark: onPerformanceMark, maybeHydrationQueryReference: maybeHydrationQueryReference, ...props })=>{
    const { onLoad: onLoad } = props;
    // Persist mode used in loading state to send in analytics
    const loadingModeRef = (0, $eJOHy.useRef)();
    const onLoadingMode = (0, $eJOHy.useCallback)((mode)=>{
        loadingModeRef.current = mode;
        onLoad?.(mode);
    }, [
        onLoad
    ]);
    const userPreferencesRef = (0, $j4oe4.useFragment)($cdea910db13502ff$var$JQLBUILDER_FRAGMENT, props.userPreferencesData);
    const searchModeResponse = userPreferencesRef?.jqlBuilderSearchMode;
    const selectedSearchMode = (0, $gQyru.toSearchModeWithBasicModeFallback)(searchModeResponse);
    if (searchModes.length === 0) throw new Error('Search mode should be non empty');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const uniqueSearchModes = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(searchModes);
    const isSearchModeToggleEnabled = uniqueSearchModes ? uniqueSearchModes.length > 1 : true;
    const irremovableFields = (0, $hHzDA.useIrremovableFields)(props.basicModeVisibleFields ?? (0, $hHzDA.DEFAULT_IRREMOVABLE_FIELDS)());
    const accountId = (0, $8q7lT.useAccountId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const initialJql = (0, $eJOHy.useRef)(query);
    const initialContextJql = (0, $3JHgj.useContextJql)({
        jql: initialJql.current,
        projectKeys: projectKeys
    });
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lw8qf.JQLBuilderFallback), {
        query: query,
        searchModes: searchModes,
        onLoad: onLoadingMode,
        selectedSearchMode: selectedSearchMode,
        isSearchModeToggleEnabled: isSearchModeToggleEnabled,
        beforeControls: props.beforeControls,
        renderExtraControls: props.renderExtraControls,
        excludedFields: props.excludedFields,
        components: props.components,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: props.searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        showOrderByPicker: showOrderByPicker
    });
    const [initialQueryRef, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $cWcbh.HYDRATION_QUERY), (0, $7jTnu.fg)('nin_request_hydrate_query_earlier') ? maybeHydrationQueryReference : undefined);
    (0, $eJOHy.useEffect)(()=>{
        if (!initialQueryRef) loadQuery({
            accountId: accountId ?? '',
            cloudId: cloudId,
            includeUser: initialJql.current.length > 0 && !!accountId,
            includeJira: initialJql.current.length > 0,
            jql: initialContextJql,
            isFilter: false,
            filterAri: '',
            viewContext: viewContext,
            scope: scope,
            isPlanReleaseFeatureToggleEnabled: (0, $7jTnu.fg)('simple-plans-m2-release-feature-toggle')
        }, {
            fetchPolicy: 'store-or-network',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
    /* Here we only need to initialise the query reference so we fire for the client on mount.
       We allow useRefetchableFragment in JQLBuilderUI to handle the refetching. */ // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: "unhandled",
        packageName: "jiraJqlBuilder",
        teamName: "empanada",
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $g8Az8.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "jqlBuilder",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8KuTC.PerformanceContext).Provider, {
        value: onPerformanceMark || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jql-builder-main",
        fallback: fallback
    }, initialQueryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bAZUe.default), {
        query: query,
        searchModes: searchModes,
        selectedSearchMode: selectedSearchMode,
        isSearchModeToggleEnabled: isSearchModeToggleEnabled,
        beforeControls: props.beforeControls,
        renderExtraControls: props.renderExtraControls,
        excludedFields: props.excludedFields,
        components: props.components,
        irremovableFields: irremovableFields,
        uniqueSearchModes: uniqueSearchModes,
        hideTextSearchInput: hideTextSearchInput,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        showOrderByPicker: showOrderByPicker,
        viewContext: viewContext,
        scope: scope,
        projectKeys: projectKeys,
        userPreferences: userPreferencesRef ?? null,
        initialQueryRef: initialQueryRef,
        onLoadingMode: onLoadingMode,
        loadingModeRef: loadingModeRef,
        ...props
    }) : fallback))));
};
var $cdea910db13502ff$export$2e2bcd8739ae039 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('nin_migrate_jql_builder_to_refetchable_query'), /*#__PURE__*/ (0, $eJOHy.memo)($cdea910db13502ff$var$JQLBuilder), /*#__PURE__*/ (0, $eJOHy.memo)($cdea910db13502ff$var$JQLBuilderOld));

});
parcelRegister("epxdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa95694d357fe4c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab8189a4d60e37ca33c72cc50edbd6c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8fa95694d357fe4c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_jqlBuilder_JQLBuilder",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_jqlBuilder_JQLBuilderUI"
        },
        {
            "kind": "ScalarField",
            "name": "jqlBuilderSearchMode"
        }
    ],
    "type": "JiraUserPreferences"
};
$8fa95694d357fe4c$var$node.hash = "939f009c6569621eae121104d8e94579";
var $8fa95694d357fe4c$export$2e2bcd8739ae039 = $8fa95694d357fe4c$var$node;

});

parcelRegister("g8Az8", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $57d2792abb57212f$export$c7209ce2e0d060ea);

var $7Jk3f = parcelRequire("7Jk3f");
const $57d2792abb57212f$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $7Jk3f.isLoaderError)(error)
    });

});

parcelRegister("hHzDA", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IRREMOVABLE_FIELDS", () => $8dfb0535a129c1b9$export$10049973e0522c22);
$parcel$export(module.exports, "useIrremovableFields", () => $8dfb0535a129c1b9$export$28001ca0e14d9f37);
$parcel$export(module.exports, "useIrremovableFieldsAnalyticsAttributes", () => $8dfb0535a129c1b9$export$1b10c62780608464);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $dTJxm = parcelRequire("dTJxm");

var $81EFh = parcelRequire("81EFh");
const $8dfb0535a129c1b9$export$10049973e0522c22 = ()=>(0, $6XJko.isVisualRefreshEnabled)() ? [
        'project',
        'assignee',
        'type',
        'status'
    ] : [
        'project',
        'type',
        'status',
        'assignee'
    ];
/**
 * These are the built-in irremovable fields that, for convenience, can be referenced by key when
 * setting the `basicModeVisibleFields` prop. E.g.
 * ```
 * <JQLBuilder basicModeVisibleFields={['assignee']} />
 * ```
 *
 * **Any fields added here must have a unique jqlTerm across the Jira instance, usually system fields**
 *
 * TODO - Note Text is not considered an irremovable field, this will be addressed in:
 * https://jplat.jira.atlassian.cloud/browse/EM-7497
 */ const $8dfb0535a129c1b9$var$getBuiltInIrremovableFields = (formatMessage)=>(0, $6XJko.isVisualRefreshEnabled)() ? {
        [(0, $dTJxm.PROJECT_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.PROJECT),
            displayName: formatMessage((0, $81EFh.default).refinementProject)
        },
        [(0, $dTJxm.ASSIGNEE_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.ASSIGNEE),
            displayName: formatMessage((0, $81EFh.default).refinementAssignee)
        },
        [(0, $dTJxm.TYPE_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.TYPE),
            displayName: formatMessage((0, $81EFh.default).refinementType)
        },
        [(0, $dTJxm.STATUS_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.STATUS),
            displayName: formatMessage((0, $81EFh.default).refinementStatus)
        },
        [(0, $dTJxm.RESOLUTION_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.RESOLUTION),
            displayName: formatMessage((0, $81EFh.default).refinementResolution)
        },
        [(0, $dTJxm.LABELS_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.LABELS),
            displayName: formatMessage((0, $81EFh.default).refinementLabels)
        }
    } : {
        [(0, $dTJxm.PROJECT_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.PROJECT),
            displayName: formatMessage((0, $81EFh.default).refinementProject)
        },
        [(0, $dTJxm.TYPE_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.TYPE),
            displayName: formatMessage((0, $81EFh.default).refinementType)
        },
        [(0, $dTJxm.STATUS_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.STATUS),
            displayName: formatMessage((0, $81EFh.default).refinementStatus)
        },
        [(0, $dTJxm.ASSIGNEE_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.ASSIGNEE),
            displayName: formatMessage((0, $81EFh.default).refinementAssignee)
        },
        [(0, $dTJxm.RESOLUTION_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.RESOLUTION),
            displayName: formatMessage((0, $81EFh.default).refinementResolution)
        },
        [(0, $dTJxm.LABELS_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.LABELS),
            displayName: formatMessage((0, $81EFh.default).refinementLabels)
        }
    };
const $8dfb0535a129c1b9$var$getInvalidCustomFieldProperties = ({ displayName: displayName, jqlTerm: jqlTerm, fieldType: fieldType, searchTemplate: searchTemplate, operators: operators })=>{
    const invalidFieldProps = [];
    if (!displayName) invalidFieldProps.push('displayName');
    if (!jqlTerm) invalidFieldProps.push('jqlTerm');
    if (!fieldType) invalidFieldProps.push('fieldType');
    if (!searchTemplate) invalidFieldProps.push('searchTemplate');
    if (!operators || operators.length === 0) invalidFieldProps.push('operators');
    return invalidFieldProps;
};
const $8dfb0535a129c1b9$export$28001ca0e14d9f37 = (irremovableFieldsConfig)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const irremovableFields = (0, $eJOHy.useMemo)(()=>{
        const builtInFields = $8dfb0535a129c1b9$var$getBuiltInIrremovableFields(formatMessage);
        const entries = irremovableFieldsConfig.map((keyOrField)=>{
            /*
       * keyOrField is a string, map it to a built-in system field
       */ if (typeof keyOrField === 'string') {
                const builtInField = builtInFields[keyOrField];
                if (!builtInField) throw new Error(`useIrremovableFields hook received an unsupported key: ${keyOrField}`);
                return [
                    keyOrField,
                    builtInField
                ];
            }
            /*
       * keyOrField is an IrremovableField, perform some basic validaiton and add it to the Map
       */ const invalidFieldProps = $8dfb0535a129c1b9$var$getInvalidCustomFieldProperties(keyOrField);
            if (invalidFieldProps.length > 0) {
                (0, $gYnSx.default)({
                    event: createAnalyticsEvent({}),
                    // forces contextual attributes be included
                    meta: {
                        id: 'useIrremovableFields',
                        packageName: (0, $dTJxm.PACKAGE_NAME),
                        teamName: (0, $dTJxm.TEAM_NAME)
                    },
                    attributes: {
                        fieldType: keyOrField.fieldType,
                        searchTemplate: keyOrField.searchTemplate,
                        invalidFieldProps: invalidFieldProps.join(',')
                    }
                });
                throw new Error('useIrremovableFields hook received an unsupported field');
            }
            /*
       * everything in JQL Builder relies on jqlTerm being lower case, otherwise weird behaviour
       * will occur when comparing the JQL query with these fields while generating pickers
       */ const jqlTerm = keyOrField.jqlTerm.toLowerCase();
            const field = {
                ...keyOrField,
                jqlTerm: jqlTerm
            };
            return [
                jqlTerm,
                field
            ];
        });
        return new Map(entries);
    }, [
        createAnalyticsEvent,
        formatMessage,
        irremovableFieldsConfig
    ]);
    return irremovableFields;
};
const $8dfb0535a129c1b9$export$1b10c62780608464 = (irremovableFields)=>(0, $eJOHy.useMemo)(()=>{
        const irremovableFieldTypes = [
            ...irremovableFields.values()
        ].map(({ fieldType: fieldType })=>fieldType);
        const irremovableFieldCount = irremovableFields.size;
        const isDefaultIrremovableFields = (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(Array.from(irremovableFields.keys()), $8dfb0535a129c1b9$export$10049973e0522c22());
        return {
            irremovableFieldTypes: irremovableFieldTypes,
            irremovableFieldCount: irremovableFieldCount,
            isDefaultIrremovableFields: isDefaultIrremovableFields
        };
    }, [
        irremovableFields
    ]);

});
parcelRegister("dTJxm", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $6c46fe1fee573462$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $6c46fe1fee573462$export$d57b6b390e78d90f);
$parcel$export(module.exports, "jqlAnonymizerVisitor", () => $6c46fe1fee573462$export$8b46ceeb1d0f7a0f);
$parcel$export(module.exports, "PROJECT_FIELD_JQL_TERM", () => $6c46fe1fee573462$export$a94927c1053f515e);
$parcel$export(module.exports, "TYPE_FIELD_JQL_TERM", () => $6c46fe1fee573462$export$92a0328342946939);
$parcel$export(module.exports, "STATUS_FIELD_JQL_TERM", () => $6c46fe1fee573462$export$b9f8115d86beaf2e);
$parcel$export(module.exports, "ASSIGNEE_FIELD_JQL_TERM", () => $6c46fe1fee573462$export$fe13eb78c06cd416);
$parcel$export(module.exports, "RESOLUTION_FIELD_JQL_TERM", () => $6c46fe1fee573462$export$45a7314200effcd0);
$parcel$export(module.exports, "LABELS_FIELD_JQL_TERM", () => $6c46fe1fee573462$export$952c102639c1ed96);
$parcel$export(module.exports, "TEXT", () => $6c46fe1fee573462$export$d597759d33be802e);
$parcel$export(module.exports, "PROJECT", () => $6c46fe1fee573462$export$fe791c4fa892e400);
$parcel$export(module.exports, "TYPE", () => $6c46fe1fee573462$export$b87f371cbc396fcf);
$parcel$export(module.exports, "STATUS", () => $6c46fe1fee573462$export$e50006273435e7d4);
$parcel$export(module.exports, "ASSIGNEE", () => $6c46fe1fee573462$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "RESOLUTION", () => $6c46fe1fee573462$export$f1a6ce22cbb7eb32);
$parcel$export(module.exports, "LABELS", () => $6c46fe1fee573462$export$79b91d4669dcadcb);
$parcel$export(module.exports, "SPRINT", () => $6c46fe1fee573462$export$a316570a0dbfd2b0);
$parcel$export(module.exports, "AFFECTED_VERSION", () => $6c46fe1fee573462$export$d02178e10ccc3ea);
$parcel$export(module.exports, "FIX_VERSION", () => $6c46fe1fee573462$export$4c55d92eb3c27f18);
$parcel$export(module.exports, "PARENT", () => $6c46fe1fee573462$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "COMPONENT", () => $6c46fe1fee573462$export$af1e30ebbae9df3b);
$parcel$export(module.exports, "CREATOR", () => $6c46fe1fee573462$export$39a35fc5bd7af053);
$parcel$export(module.exports, "REPORTER", () => $6c46fe1fee573462$export$6d7021166edc895c);
$parcel$export(module.exports, "dateSearchTemplates", () => $6c46fe1fee573462$export$ffcdf2c6c4831acc);
$parcel$export(module.exports, "userFieldSearchTemplates", () => $6c46fe1fee573462$export$6616be37c70ab33f);
$parcel$export(module.exports, "EPIC_LINK", () => $6c46fe1fee573462$export$19f652d3d336f069);
$parcel$export(module.exports, "appearanceMap", () => $6c46fe1fee573462$export$c743cc8f0e853412);
$parcel$export(module.exports, "FunctionName", () => $6c46fe1fee573462$export$4b826ede0e88b93);
$parcel$export(module.exports, "KeywordName", () => $6c46fe1fee573462$export$84606816405f7142);
$parcel$export(module.exports, "OperandValues", () => $6c46fe1fee573462$export$1ab4f98e21fe0811);
$parcel$export(module.exports, "CASCADE_SELECT_FIELD_SEARCH_TEMPLATE", () => $6c46fe1fee573462$export$3e3df380922ad777);
$parcel$export(module.exports, "CASCADE_OPTION_FUNCTION_NAME", () => $6c46fe1fee573462$export$cd361098212837ad);
$parcel$export(module.exports, "NUMBER_RANGE_FIELD_SEARCH_TEMPLATE", () => $6c46fe1fee573462$export$4e0f2021e5a6dd20);
$parcel$export(module.exports, "NUMBER_RANGE_PICKER_ALLOWED_OPERATORS", () => $6c46fe1fee573462$export$787eee4b393220a3);
$parcel$export(module.exports, "CMDB_FIELD_SEARCH_TEMPLATE", () => $6c46fe1fee573462$export$51829c816d2b6247);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_SEARCH_TEMPLATE", () => $6c46fe1fee573462$export$33aa1485e40ffbb7);
$parcel$export(module.exports, "JSM_ORGANIZATIONS_SEARCH_TEMPLATE", () => $6c46fe1fee573462$export$b7429d5dab3b6ce5);
$parcel$export(module.exports, "JSM_WORK_CATEGORY_SEARCH_TEMPLATE", () => $6c46fe1fee573462$export$6f9d9c0166c7b52d);
$parcel$export(module.exports, "AQL_FUNCTION_NAME", () => $6c46fe1fee573462$export$ee8b282423818e0d);
$parcel$export(module.exports, "IQL_FUNCTION_NAME", () => $6c46fe1fee573462$export$c91c40035dea81da);
$parcel$export(module.exports, "ADD_FILTER_DROPDOWN", () => $6c46fe1fee573462$export$65639c30130233cb);
$parcel$export(module.exports, "ISSUE_KEY", () => $6c46fe1fee573462$export$5daa28d10e23592);
$parcel$export(module.exports, "getTextSearchInputField", () => $6c46fe1fee573462$export$3274f6964f86ac9b);

var $16mcg = parcelRequire("16mcg");
var $jPlb3 = parcelRequire("jPlb3");
const $6c46fe1fee573462$export$b8b9d90f9e5bd72b = 'jiraJqlBuilderBasic';
const $6c46fe1fee573462$export$d57b6b390e78d90f = 'empanada';
const $6c46fe1fee573462$export$8b46ceeb1d0f7a0f = new (0, $16mcg.JqlAnonymizerVisitor)();
const $6c46fe1fee573462$var$TEXT_FIELD_JQL_TERM = 'text';
const $6c46fe1fee573462$var$TEXT_FIELDS_FIELD_JQL_TERM = 'textfields';
const $6c46fe1fee573462$export$a94927c1053f515e = 'project';
const $6c46fe1fee573462$export$92a0328342946939 = 'type';
const $6c46fe1fee573462$export$b9f8115d86beaf2e = 'status';
const $6c46fe1fee573462$export$fe13eb78c06cd416 = 'assignee';
const $6c46fe1fee573462$export$45a7314200effcd0 = 'resolution';
const $6c46fe1fee573462$export$952c102639c1ed96 = 'labels';
const $6c46fe1fee573462$export$d597759d33be802e = {
    jqlTerm: $6c46fe1fee573462$var$TEXT_FIELD_JQL_TERM,
    searchTemplate: 'text',
    fieldType: 'text',
    operators: [
        (0, $jPlb3.OPERATOR_LIKE)
    ]
};
const $6c46fe1fee573462$export$fe791c4fa892e400 = {
    jqlTerm: $6c46fe1fee573462$export$a94927c1053f515e,
    searchTemplate: 'project',
    fieldType: 'project',
    operators: [
        (0, $jPlb3.OPERATOR_IN),
        (0, $jPlb3.OPERATOR_IS),
        (0, $jPlb3.OPERATOR_EQUALS),
        (0, $jPlb3.OPERATOR_IS_NOT),
        (0, $jPlb3.OPERATOR_NOT_IN),
        (0, $jPlb3.OPERATOR_NOT_EQUALS)
    ]
};
const $6c46fe1fee573462$export$b87f371cbc396fcf = {
    jqlTerm: $6c46fe1fee573462$export$92a0328342946939,
    searchTemplate: 'issuetype',
    fieldType: 'issuetype',
    operators: [
        (0, $jPlb3.OPERATOR_IN),
        (0, $jPlb3.OPERATOR_IS),
        (0, $jPlb3.OPERATOR_EQUALS),
        (0, $jPlb3.OPERATOR_IS_NOT),
        (0, $jPlb3.OPERATOR_NOT_IN),
        (0, $jPlb3.OPERATOR_NOT_EQUALS)
    ]
};
const $6c46fe1fee573462$export$e50006273435e7d4 = {
    jqlTerm: $6c46fe1fee573462$export$b9f8115d86beaf2e,
    searchTemplate: 'status',
    fieldType: 'status',
    operators: [
        (0, $jPlb3.OPERATOR_WAS_NOT_IN),
        (0, $jPlb3.OPERATOR_IS),
        (0, $jPlb3.OPERATOR_WAS_NOT),
        (0, $jPlb3.OPERATOR_IN),
        (0, $jPlb3.OPERATOR_NOT_EQUALS),
        (0, $jPlb3.OPERATOR_IS_NOT),
        (0, $jPlb3.OPERATOR_NOT_IN),
        (0, $jPlb3.OPERATOR_WAS_IN),
        (0, $jPlb3.OPERATOR_EQUALS),
        (0, $jPlb3.OPERATOR_WAS),
        (0, $jPlb3.OPERATOR_CHANGED)
    ]
};
const $6c46fe1fee573462$export$f8f7545d2bb78afb = {
    jqlTerm: $6c46fe1fee573462$export$fe13eb78c06cd416,
    searchTemplate: 'assignee',
    fieldType: 'assignee',
    operators: [
        (0, $jPlb3.OPERATOR_CHANGED),
        (0, $jPlb3.OPERATOR_EQUALS),
        (0, $jPlb3.OPERATOR_NOT_EQUALS),
        (0, $jPlb3.OPERATOR_WAS_NOT),
        (0, $jPlb3.OPERATOR_IS_NOT),
        (0, $jPlb3.OPERATOR_WAS),
        (0, $jPlb3.OPERATOR_WAS_NOT_IN),
        (0, $jPlb3.OPERATOR_IS),
        (0, $jPlb3.OPERATOR_IN),
        (0, $jPlb3.OPERATOR_WAS_IN),
        (0, $jPlb3.OPERATOR_NOT_IN)
    ]
};
const $6c46fe1fee573462$export$f1a6ce22cbb7eb32 = {
    jqlTerm: $6c46fe1fee573462$export$45a7314200effcd0,
    searchTemplate: 'resolution',
    fieldType: 'resolution',
    operators: [
        (0, $jPlb3.OPERATOR_WAS_NOT),
        (0, $jPlb3.OPERATOR_IS),
        (0, $jPlb3.OPERATOR_LT_EQUALS),
        (0, $jPlb3.OPERATOR_IN),
        (0, $jPlb3.OPERATOR_GT),
        (0, $jPlb3.OPERATOR_NOT_EQUALS),
        (0, $jPlb3.OPERATOR_GT_EQUALS),
        (0, $jPlb3.OPERATOR_WAS_NOT_IN),
        (0, $jPlb3.OPERATOR_NOT_IN),
        (0, $jPlb3.OPERATOR_WAS_IN),
        (0, $jPlb3.OPERATOR_WAS),
        (0, $jPlb3.OPERATOR_LT),
        (0, $jPlb3.OPERATOR_IS_NOT),
        (0, $jPlb3.OPERATOR_EQUALS),
        (0, $jPlb3.OPERATOR_CHANGED)
    ]
};
const $6c46fe1fee573462$export$79b91d4669dcadcb = {
    jqlTerm: $6c46fe1fee573462$export$952c102639c1ed96,
    searchTemplate: 'labels',
    fieldType: 'labels',
    operators: [
        (0, $jPlb3.OPERATOR_IS_NOT),
        (0, $jPlb3.OPERATOR_IS),
        (0, $jPlb3.OPERATOR_NOT_EQUALS),
        (0, $jPlb3.OPERATOR_IN),
        (0, $jPlb3.OPERATOR_NOT_IN),
        (0, $jPlb3.OPERATOR_EQUALS)
    ]
};
const $6c46fe1fee573462$export$a316570a0dbfd2b0 = {
    jqlTerm: 'sprint',
    searchTemplate: 'com.pyxis.greenhopper.jira:gh-sprint-searcher',
    fieldType: 'com.pyxis.greenhopper.jira:gh-sprint',
    operators: [
        (0, $jPlb3.OPERATOR_NOT_IN),
        (0, $jPlb3.OPERATOR_IS_NOT),
        (0, $jPlb3.OPERATOR_IS),
        (0, $jPlb3.OPERATOR_IN),
        (0, $jPlb3.OPERATOR_EQUALS),
        (0, $jPlb3.OPERATOR_NOT_EQUALS)
    ]
};
const $6c46fe1fee573462$export$d02178e10ccc3ea = {
    jqlTerm: 'affectedversion',
    searchTemplate: 'versions',
    fieldType: 'versions',
    operators: [
        (0, $jPlb3.OPERATOR_LT_EQUALS),
        (0, $jPlb3.OPERATOR_IS_NOT),
        (0, $jPlb3.OPERATOR_NOT_IN),
        (0, $jPlb3.OPERATOR_LT),
        (0, $jPlb3.OPERATOR_EQUALS),
        (0, $jPlb3.OPERATOR_GT_EQUALS),
        (0, $jPlb3.OPERATOR_NOT_EQUALS),
        (0, $jPlb3.OPERATOR_GT),
        (0, $jPlb3.OPERATOR_IS),
        (0, $jPlb3.OPERATOR_IN)
    ]
};
const $6c46fe1fee573462$export$4c55d92eb3c27f18 = {
    jqlTerm: 'fixversion',
    searchTemplate: 'fixVersions',
    fieldType: 'fixVersions',
    operators: [
        (0, $jPlb3.OPERATOR_LT_EQUALS),
        (0, $jPlb3.OPERATOR_IS_NOT),
        (0, $jPlb3.OPERATOR_NOT_IN),
        (0, $jPlb3.OPERATOR_LT),
        (0, $jPlb3.OPERATOR_EQUALS),
        (0, $jPlb3.OPERATOR_GT_EQUALS),
        (0, $jPlb3.OPERATOR_NOT_EQUALS),
        (0, $jPlb3.OPERATOR_GT),
        (0, $jPlb3.OPERATOR_IS),
        (0, $jPlb3.OPERATOR_IN)
    ]
};
const $6c46fe1fee573462$export$e0dfb65d1047c53c = {
    jqlTerm: 'parent',
    searchTemplate: 'parent',
    fieldType: 'parent',
    operators: [
        (0, $jPlb3.OPERATOR_NOT_IN),
        (0, $jPlb3.OPERATOR_EQUALS),
        (0, $jPlb3.OPERATOR_IN),
        (0, $jPlb3.OPERATOR_NOT_EQUALS),
        (0, $jPlb3.OPERATOR_IS),
        (0, $jPlb3.OPERATOR_IS_NOT)
    ]
};
const $6c46fe1fee573462$export$af1e30ebbae9df3b = {
    jqlTerm: 'component',
    searchTemplate: 'components',
    fieldType: 'components',
    operators: [
        (0, $jPlb3.OPERATOR_NOT_IN),
        (0, $jPlb3.OPERATOR_EQUALS),
        (0, $jPlb3.OPERATOR_IN),
        (0, $jPlb3.OPERATOR_NOT_EQUALS),
        (0, $jPlb3.OPERATOR_IS),
        (0, $jPlb3.OPERATOR_IS_NOT)
    ]
};
const $6c46fe1fee573462$export$39a35fc5bd7af053 = {
    jqlTerm: 'creator',
    searchTemplate: 'creator',
    fieldType: 'creator',
    operators: [
        (0, $jPlb3.OPERATOR_NOT_IN),
        (0, $jPlb3.OPERATOR_EQUALS),
        (0, $jPlb3.OPERATOR_IN),
        (0, $jPlb3.OPERATOR_NOT_EQUALS),
        (0, $jPlb3.OPERATOR_IS),
        (0, $jPlb3.OPERATOR_IS_NOT)
    ]
};
const $6c46fe1fee573462$export$6d7021166edc895c = {
    jqlTerm: 'reporter',
    searchTemplate: 'reporter',
    fieldType: 'reporter',
    operators: [
        (0, $jPlb3.OPERATOR_CHANGED),
        (0, $jPlb3.OPERATOR_EQUALS),
        (0, $jPlb3.OPERATOR_NOT_EQUALS),
        (0, $jPlb3.OPERATOR_WAS_NOT),
        (0, $jPlb3.OPERATOR_IS_NOT),
        (0, $jPlb3.OPERATOR_WAS),
        (0, $jPlb3.OPERATOR_WAS_NOT_IN),
        (0, $jPlb3.OPERATOR_IS),
        (0, $jPlb3.OPERATOR_IN),
        (0, $jPlb3.OPERATOR_WAS_IN),
        (0, $jPlb3.OPERATOR_NOT_IN)
    ]
};
const $6c46fe1fee573462$export$ffcdf2c6c4831acc = new Set([
    'updated',
    'created',
    'duedate',
    'resolutiondate',
    'com.atlassian.jira.plugin.system.customfieldtypes:datetimerange',
    'com.atlassian.jira.plugin.system.customfieldtypes:daterange',
    'statuscategorychangedate',
    'com.atlassian.jira.toolkit:LastCommentDateSearcher',
    'com.atlassian.jira.ext.charting:firstreponsedatesearcher',
    'com.atlassian.jpo:jpo-custom-field-baseline-start-searcher',
    'com.atlassian.jpo:jpo-custom-field-baseline-end-searcher',
    'com.atlassian.servicedesk:sd-request-feedback-date-searcher'
]);
const $6c46fe1fee573462$export$6616be37c70ab33f = new Set([
    'assignee',
    'reporter',
    'creator',
    'com.atlassian.jira.plugin.system.customfieldtypes:userpickergroupsearcher',
    'com.atlassian.jira.plugin.system.customfieldtypes:next-gen-people-searcher',
    'com.atlassian.jira.toolkit:participantsearcher',
    'com.atlassian.jira.toolkit:lastparticipantsearcher',
    'com.atlassian.servicedesk:sd-request-participants-searcher'
]);
const $6c46fe1fee573462$export$19f652d3d336f069 = {
    jqlTerm: 'epic link',
    searchTemplate: 'com.pyxis.greenhopper.jira:gh-epic-link-searcher'
};
const $6c46fe1fee573462$export$c743cc8f0e853412 = {
    BLUE_GRAY: 'default',
    MEDIUM_GRAY: 'default',
    BROWN: 'default',
    GREEN: 'success',
    YELLOW: 'inprogress',
    WARM_RED: 'removed'
};
const $6c46fe1fee573462$export$4b826ede0e88b93 = {
    currentUser: 'currentUser',
    standardIssueTypes: 'standardIssueTypes',
    subTaskIssueTypes: 'subTaskIssueTypes',
    membersOf: 'membersOf',
    releasedVersions: 'releasedVersions',
    unreleasedVersions: 'unreleasedVersions'
};
const $6c46fe1fee573462$export$84606816405f7142 = {
    empty: 'empty'
};
const $6c46fe1fee573462$export$1ab4f98e21fe0811 = {
    currentUser: {
        value: 'currentUser()',
        type: (0, $862dfd240457f00b$export$19c7c729db381f9d)
    },
    empty: {
        value: 'EMPTY',
        type: (0, $862dfd240457f00b$export$f6049126fd97001f)
    },
    standardIssueTypes: {
        value: 'standardIssueTypes()',
        isList: true,
        type: (0, $862dfd240457f00b$export$19c7c729db381f9d)
    },
    subTaskIssueTypes: {
        value: 'subTaskIssueTypes()',
        isList: true,
        type: (0, $862dfd240457f00b$export$19c7c729db381f9d)
    },
    membersOf: {
        value: 'membersOf',
        isList: true,
        hasArgs: true,
        template: 'membersOf("$1")',
        type: (0, $862dfd240457f00b$export$19c7c729db381f9d)
    },
    releasedVersions: {
        value: 'releasedVersions()',
        isList: true,
        type: (0, $862dfd240457f00b$export$19c7c729db381f9d)
    },
    unreleasedVersions: {
        value: 'unreleasedVersions()',
        isList: true,
        type: (0, $862dfd240457f00b$export$19c7c729db381f9d)
    }
};
const $6c46fe1fee573462$export$3e3df380922ad777 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselectsearcher';
const $6c46fe1fee573462$export$cd361098212837ad = 'cascadeOption';
const $6c46fe1fee573462$export$4e0f2021e5a6dd20 = 'com.atlassian.jira.plugin.system.customfieldtypes:numberrange';
const $6c46fe1fee573462$export$3e72793810b8a135 = 'jql-builder-basic-textarea.ui.text-area';
const $6c46fe1fee573462$export$796f418f6ff91516 = 'jql-builder-basic-textarea.ui.update-button';
const $6c46fe1fee573462$export$787eee4b393220a3 = [
    (0, $jPlb3.OPERATOR_LT_EQUALS),
    (0, $jPlb3.OPERATOR_GT_EQUALS)
];
const $6c46fe1fee573462$export$51829c816d2b6247 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-searcher';
const $6c46fe1fee573462$export$33aa1485e40ffbb7 = 'com.atlassian.servicedesk:vp-origin-searcher';
const $6c46fe1fee573462$export$b7429d5dab3b6ce5 = 'com.atlassian.servicedesk:sd-customer-organizations-searcher';
const $6c46fe1fee573462$export$6f9d9c0166c7b52d = 'com.atlassian.jira.plugins.work-category-field:work-category-field-searcher';
const $6c46fe1fee573462$export$ee8b282423818e0d = 'aqlFunction';
const $6c46fe1fee573462$export$c91c40035dea81da = 'iqlFunction';
const $6c46fe1fee573462$export$65639c30130233cb = 'ADD_FILTER_DROPDOWN';
const $6c46fe1fee573462$export$5daa28d10e23592 = 'issuekey';
const $6c46fe1fee573462$export$3274f6964f86ac9b = ()=>$6c46fe1fee573462$var$TEXT_FIELDS_FIELD_JQL_TERM;

});
parcelRegister("16mcg", function(module, exports) {

$parcel$export(module.exports, "JqlAnonymizerVisitor", () => $1b409d23fdd903cb$export$17681d1ffeaac612);

var $3xm7g = parcelRequire("3xm7g");
var $gniDX = parcelRequire("gniDX");

var $dlsVE = parcelRequire("dlsVE");

var $dl9fK = parcelRequire("dl9fK");
const $1b409d23fdd903cb$var$ANONYMIZED_FIELD = '"?"';
const $1b409d23fdd903cb$var$ANONYMIZED_VALUE = '"?"';
const $1b409d23fdd903cb$var$CUSTOM_FIELD_PATTERN = /^cf\[\d+]$/i;
const $1b409d23fdd903cb$var$privacySafeFields = new Set((0, $gniDX.PRIVACY_SAFE_FIELDS));
const $1b409d23fdd903cb$var$getPrivacySafeFieldName = (field)=>{
    // Privacy safe field name (Jira field)
    if ($1b409d23fdd903cb$var$privacySafeFields.has(field.value.toLowerCase())) return field.text;
    // Custom field identifier, e.g. cf[10001]
    if ($1b409d23fdd903cb$var$CUSTOM_FIELD_PATTERN.test(field.value)) return field.text;
    // Collapsed custom field
    const match = field.text.match((0, $3xm7g.COLLAPSED_CUSTOM_FIELD_PATTERN));
    if (match) return `"?[${match[1]}]"`;
    // Other field names that can potentially contain UGC
    return $1b409d23fdd903cb$var$ANONYMIZED_FIELD;
};
class $1b409d23fdd903cb$export$17681d1ffeaac612 extends (0, $dl9fK.AbstractJastVisitor) {
    defaultResult() {
        return '';
    }
    constructor(...args){
        super(...args), this.visitQuery = (query)=>{
            const where = query.where ? query.where.accept(this) : undefined;
            const orderBy = query.orderBy ? query.orderBy.accept(this) : undefined;
            return [
                where,
                orderBy
            ].filter((0, $dlsVE.notUndefined)).join(' ');
        }, this.visitField = (field)=>{
            const name = $1b409d23fdd903cb$var$getPrivacySafeFieldName(field);
            if (field.properties && field.properties.length) {
                const properties = field.properties.map((property)=>{
                    const key = property.key ? property.key.text : '';
                    const path = property.path ? property.path.map((arg)=>arg.text).join('') : '';
                    return `[${key}]${path}`;
                }).join('');
                return `${name}${properties}`;
            }
            return name;
        }, this.visitTerminalClause = (terminalClause)=>{
            const field = terminalClause.field.accept(this);
            const operator = terminalClause.operator ? terminalClause.operator.text : undefined;
            const operand = terminalClause.operand ? terminalClause.operand.accept(this) : undefined;
            const predicates = terminalClause.predicates.map((predicate)=>predicate.accept(this));
            return [
                field,
                operator,
                operand,
                ...predicates
            ].filter((0, $dlsVE.notUndefined)).join(' ');
        }, this.visitCompoundClause = (compoundClause)=>{
            const operator = compoundClause.operator.value;
            return compoundClause.clauses.map((clause)=>{
                // Nested compound clauses should be wrapped in parentheses
                return clause.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b) ? `(${clause.accept(this)})` : clause.accept(this);
            }).join(` ${operator} `);
        }, this.visitNotClause = (notClause)=>{
            // Nested compound clauses should be wrapped in parentheses
            const nestedClause = notClause.clause.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b) ? `(${notClause.clause.accept(this)})` : notClause.clause.accept(this);
            return `${notClause.operator.value} ${nestedClause}`;
        }, this.visitValueOperand = ()=>{
            return $1b409d23fdd903cb$var$ANONYMIZED_VALUE;
        }, this.visitListOperand = (listOperand)=>{
            return `(${listOperand.values.map((value)=>value.accept(this)).join(', ')})`;
        }, this.visitFunctionOperand = (functionOperand)=>{
            const functionName = functionOperand.function.text;
            const functionArguments = functionOperand.arguments.map(()=>$1b409d23fdd903cb$var$ANONYMIZED_VALUE).join(', ');
            return `${functionName}(${functionArguments})`;
        }, this.visitKeywordOperand = (keywordOperand)=>{
            return keywordOperand.value;
        }, this.visitPredicate = (predicate)=>{
            const operator = predicate.operator.text;
            const operand = predicate.operand ? predicate.operand.accept(this) : undefined;
            return [
                operator,
                operand
            ].filter((0, $dlsVE.notUndefined)).join(' ');
        }, this.visitOrderBy = (orderBy)=>{
            const orderByFields = orderBy.fields.map((orderByField)=>{
                const field = orderByField.field.accept(this);
                const direction = orderByField.direction ? orderByField.direction.value : undefined;
                return [
                    field,
                    direction
                ].filter((0, $dlsVE.notUndefined)).join(' ');
            });
            return `${0, $adec16a85d57f51f$export$ca51f5fd60a74517} ${orderByFields.join(', ')}`;
        };
    }
}

});
const $2a3824620e125bfd$export$7a58b23488ea076b = 'compound';
const $2a3824620e125bfd$export$ae56b4ef248a2b6a = 'terminal';
const $2a3824620e125bfd$export$e356b89f8c8d2fcb = 'not';

parcelRegister("3xm7g", function(module, exports) {

$parcel$export(module.exports, "TEAM_CUSTOM_FIELD_TYPE", () => $2d0bd590f2a114aa$export$7db5aa892c7d5359);
$parcel$export(module.exports, "COLLAPSED_CUSTOM_FIELD_PATTERN", () => $2d0bd590f2a114aa$export$72fbd4b3f260d743);
$parcel$export(module.exports, "COLLAPSED_CUSTOM_FIELD_PATTERN_NO_QUOTES", () => $2d0bd590f2a114aa$export$4b8ecf135de492a1);
// This is a list of field types expected as collapsed fields, e.g. of the form
// name[fieldtype]. The square brackets are retained to allow us to more easily
// differentiate these from regular fields.
// Currently these are being used in `jql-insights-listener.ts` to allow us to
// collect data about the usage of some custom field types.
// All field type names here must be in lower case
const $2d0bd590f2a114aa$export$7db5aa892c7d5359 = '[team]';
const $2d0bd590f2a114aa$export$72fbd4b3f260d743 = /^['"].+\[(\D+)]['"]$/i;
const $2d0bd590f2a114aa$export$4b8ecf135de492a1 = /^.+\[(\D+)]$/i;

});

const $adec16a85d57f51f$export$ca51f5fd60a74517 = 'ORDER BY';
const $adec16a85d57f51f$export$6d60017b9e092e73 = 'ASC';
const $adec16a85d57f51f$export$2ea27ea5f2121899 = 'DESC';

parcelRegister("gniDX", function(module, exports) {

$parcel$export(module.exports, "ASSIGNEE_FIELD", () => $5660d2f8e01b4076$export$f7a08bf17a7ac661);
$parcel$export(module.exports, "CREATED_FIELD", () => $5660d2f8e01b4076$export$9063bfeedbc1236f);
$parcel$export(module.exports, "DUE_DATE_FIELD", () => $5660d2f8e01b4076$export$f4a47f55547a932c);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD", () => $5660d2f8e01b4076$export$2d5a62a3515ad4c6);
$parcel$export(module.exports, "LAST_VIEWED_FIELD", () => $5660d2f8e01b4076$export$eac61537b9fdb3be);
$parcel$export(module.exports, "PRIORITY_FIELD", () => $5660d2f8e01b4076$export$de14210faa5f2099);
$parcel$export(module.exports, "PROJECT_FIELD", () => $5660d2f8e01b4076$export$aa5680ad8f8be9fc);
$parcel$export(module.exports, "REPORTER_FIELD", () => $5660d2f8e01b4076$export$d64150fd9c66969c);
$parcel$export(module.exports, "RESOLUTION_DATE_FIELD", () => $5660d2f8e01b4076$export$f603d3cf4c8489e8);
$parcel$export(module.exports, "STATUS_FIELD", () => $5660d2f8e01b4076$export$3068d6fae4de53c8);
$parcel$export(module.exports, "SUMMARY_FIELD", () => $5660d2f8e01b4076$export$9b9fe8882c3e0da3);
$parcel$export(module.exports, "TYPE_FIELD", () => $5660d2f8e01b4076$export$e53b76a613c435e0);
$parcel$export(module.exports, "UPDATED_FIELD", () => $5660d2f8e01b4076$export$7101642b50bf10bc);
$parcel$export(module.exports, "RESOLUTION_FIELD", () => $5660d2f8e01b4076$export$252fb981af0e2e4e);
$parcel$export(module.exports, "PRIVACY_SAFE_FIELDS", () => $5660d2f8e01b4076$export$49017cdca0837b83);
const $5660d2f8e01b4076$export$f7a08bf17a7ac661 = 'assignee';
const $5660d2f8e01b4076$export$9063bfeedbc1236f = 'created';
const $5660d2f8e01b4076$export$f4a47f55547a932c = 'duedate';
const $5660d2f8e01b4076$export$28d0e5e03b779eff = 'issuekey';
const $5660d2f8e01b4076$export$2d5a62a3515ad4c6 = 'issuetype';
const $5660d2f8e01b4076$export$eac61537b9fdb3be = 'lastviewed';
const $5660d2f8e01b4076$export$de14210faa5f2099 = 'priority';
const $5660d2f8e01b4076$export$aa5680ad8f8be9fc = 'project';
const $5660d2f8e01b4076$export$d64150fd9c66969c = 'reporter';
const $5660d2f8e01b4076$export$ad2fb2fa5ecb427a = 'resolved';
const $5660d2f8e01b4076$export$f603d3cf4c8489e8 = 'resolutiondate';
const $5660d2f8e01b4076$export$3068d6fae4de53c8 = 'status';
const $5660d2f8e01b4076$export$f4d2dc00d9b9c983 = 'statuscategory';
const $5660d2f8e01b4076$export$9b9fe8882c3e0da3 = 'summary';
const $5660d2f8e01b4076$export$23ca38ad884e35f1 = 'text';
const $5660d2f8e01b4076$export$b3e1b98671aae084 = 'textfields';
const $5660d2f8e01b4076$export$e53b76a613c435e0 = 'type';
const $5660d2f8e01b4076$export$7101642b50bf10bc = 'updated';
const $5660d2f8e01b4076$export$c7761054d987f9ab = 'affectedversion';
const $5660d2f8e01b4076$export$9ae86b690ef8ceed = 'approvals';
const $5660d2f8e01b4076$export$4b5a561405c5f211 = 'category';
const $5660d2f8e01b4076$export$a3ff506aee89f5de = 'component';
const $5660d2f8e01b4076$export$6a045eda3865d703 = 'description';
const $5660d2f8e01b4076$export$b6b1af0981f1891e = 'development';
const $5660d2f8e01b4076$export$39df30b837789c3 = 'environment';
const $5660d2f8e01b4076$export$8723b724f0b3ac65 = 'epic link';
const $5660d2f8e01b4076$export$4b5030dff66bb705 = 'filter';
const $5660d2f8e01b4076$export$3ec395376855802f = 'fixversion';
const $5660d2f8e01b4076$export$a8945db82fc2e785 = 'labels';
const $5660d2f8e01b4076$export$bf9df74e065af482 = 'parent';
const $5660d2f8e01b4076$export$252fb981af0e2e4e = 'resolution';
const $5660d2f8e01b4076$export$64238d76a1dc0703 = 'sprint';
const $5660d2f8e01b4076$export$62edbfa1bb10b91 = 'assignee.property';
const $5660d2f8e01b4076$export$5afd9733860db123 = 'creator.property';
const $5660d2f8e01b4076$export$3ccfe20fd4420801 = 'issue.property';
const $5660d2f8e01b4076$export$d955a5d923cc59e6 = 'project.property';
const $5660d2f8e01b4076$export$ed42e707855fc6a4 = 'reporter.property';
const $5660d2f8e01b4076$export$3b63269c1c533321 = 'voter.property';
const $5660d2f8e01b4076$export$bd7061bb445305dd = 'watcher.property';
const $5660d2f8e01b4076$export$49017cdca0837b83 = [
    $5660d2f8e01b4076$export$f7a08bf17a7ac661,
    $5660d2f8e01b4076$export$9063bfeedbc1236f,
    $5660d2f8e01b4076$export$f4a47f55547a932c,
    $5660d2f8e01b4076$export$28d0e5e03b779eff,
    $5660d2f8e01b4076$export$2d5a62a3515ad4c6,
    $5660d2f8e01b4076$export$eac61537b9fdb3be,
    $5660d2f8e01b4076$export$de14210faa5f2099,
    $5660d2f8e01b4076$export$aa5680ad8f8be9fc,
    $5660d2f8e01b4076$export$d64150fd9c66969c,
    $5660d2f8e01b4076$export$ad2fb2fa5ecb427a,
    $5660d2f8e01b4076$export$f603d3cf4c8489e8,
    $5660d2f8e01b4076$export$3068d6fae4de53c8,
    $5660d2f8e01b4076$export$f4d2dc00d9b9c983,
    $5660d2f8e01b4076$export$9b9fe8882c3e0da3,
    $5660d2f8e01b4076$export$23ca38ad884e35f1,
    $5660d2f8e01b4076$export$b3e1b98671aae084,
    $5660d2f8e01b4076$export$e53b76a613c435e0,
    $5660d2f8e01b4076$export$7101642b50bf10bc,
    $5660d2f8e01b4076$export$c7761054d987f9ab,
    $5660d2f8e01b4076$export$9ae86b690ef8ceed,
    $5660d2f8e01b4076$export$4b5a561405c5f211,
    $5660d2f8e01b4076$export$a3ff506aee89f5de,
    $5660d2f8e01b4076$export$6a045eda3865d703,
    $5660d2f8e01b4076$export$b6b1af0981f1891e,
    $5660d2f8e01b4076$export$39df30b837789c3,
    $5660d2f8e01b4076$export$8723b724f0b3ac65,
    $5660d2f8e01b4076$export$4b5030dff66bb705,
    $5660d2f8e01b4076$export$3ec395376855802f,
    $5660d2f8e01b4076$export$a8945db82fc2e785,
    $5660d2f8e01b4076$export$bf9df74e065af482,
    $5660d2f8e01b4076$export$252fb981af0e2e4e,
    $5660d2f8e01b4076$export$64238d76a1dc0703,
    // entity properties
    $5660d2f8e01b4076$export$62edbfa1bb10b91,
    $5660d2f8e01b4076$export$5afd9733860db123,
    $5660d2f8e01b4076$export$3ccfe20fd4420801,
    $5660d2f8e01b4076$export$d955a5d923cc59e6,
    $5660d2f8e01b4076$export$ed42e707855fc6a4,
    $5660d2f8e01b4076$export$3b63269c1c533321,
    $5660d2f8e01b4076$export$bd7061bb445305dd
];

});


const $862dfd240457f00b$export$38accfc5a5d1c113 = 'value';
const $862dfd240457f00b$export$f6049126fd97001f = 'keyword';
const $862dfd240457f00b$export$19c7c729db381f9d = 'function';
const $862dfd240457f00b$export$fabec4aebba3f4df = 'list';
const $862dfd240457f00b$export$1c46dca02aac24dd = 'empty';


parcelRegister("81EFh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c98bf047f4c36a4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3c98bf047f4c36a4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    refinementProject: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-project",
        "defaultMessage": "Project"
    },
    refinementStatus: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-status",
        "defaultMessage": "Status"
    },
    refinementStatusCategory: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-status-category",
        "defaultMessage": "Status category"
    },
    refinementSummary: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-summary",
        "defaultMessage": "Summary"
    },
    refinementAssignee: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-assignee",
        "defaultMessage": "Assignee"
    },
    refinementReporter: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-reporter",
        "defaultMessage": "Reporter"
    },
    refinementType: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-type",
        "defaultMessage": "Type"
    },
    refinementPriority: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-priority",
        "defaultMessage": "Priority"
    },
    refinementResolution: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-resolution",
        "defaultMessage": "Resolution"
    },
    refinementUpdated: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-updated",
        "defaultMessage": "Updated date"
    },
    refinementCreated: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-created",
        "defaultMessage": "Created date"
    },
    refinementDueDate: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-due-date",
        "defaultMessage": "Due date"
    },
    refinementResolutionDate: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-resolution-date",
        "defaultMessage": "Resolution date"
    },
    refinementComponent: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-component",
        "defaultMessage": "Component"
    },
    refinementParent: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-parent",
        "defaultMessage": "Parent"
    },
    refinementFixVersion: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-fix-version",
        "defaultMessage": "Fix version"
    },
    refinementAffectedVersion: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-affected-version",
        "defaultMessage": "Affects version"
    },
    refinementLabel: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-label",
        "defaultMessage": "Label"
    },
    refinementLabels: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-labels",
        "defaultMessage": "Labels"
    },
    refinementEpicLink: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-epic-link",
        "defaultMessage": "Epic link"
    },
    refinementSprint: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-sprint",
        "defaultMessage": "Sprint"
    },
    refinementCreator: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-creator",
        "defaultMessage": "Creator"
    },
    refinementDescription: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-description",
        "defaultMessage": "Description"
    },
    refinementEnvironment: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-environment",
        "defaultMessage": "Environment"
    },
    refinementNotFound: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-not-found",
        "defaultMessage": "Unknown Field"
    },
    refinementProjectGalaxia: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-project-galaxia",
        "defaultMessage": "Space"
    }
});

});


parcelRegister("cWcbh", function(module, exports) {

$parcel$export(module.exports, "HYDRATION_QUERY", () => $d5c7b8ce5b358373$export$988ee43373cb9bb2);
$parcel$export(module.exports, "useHydrationQueryLoader", () => $d5c7b8ce5b358373$export$b318e912f6cbc59b);

var $8jMVZ = parcelRequire("8jMVZ");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");
const $d5c7b8ce5b358373$export$988ee43373cb9bb2 = (0, $8jMVZ.default);
const $d5c7b8ce5b358373$export$9562d1ce91742cb1 = (variables)=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const [isFetching, setIsFetching] = (0, $eJOHy.useState)(false);
    // Variables for last completed prefetch (i.e. fetchQuery) operation
    const [prefetchedVariables, setPrefetchedVariables] = (0, $eJOHy.useState)(variables);
    const [fetchPolicy, setFetchPolicy] = (0, $eJOHy.useState)('store-or-network');
    // Variables used by in-flight request, used to deduplicate requests
    const inFlightRequest = (0, $eJOHy.useRef)();
    const inFlightVariables = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(variables, prefetchedVariables) && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(variables, inFlightVariables.current)) {
            // Cancel previous in-flight request to stop further processing (and prevent race conditions) if a new one comes in
            inFlightRequest.current?.unsubscribe();
            inFlightVariables.current = variables;
            setIsFetching(true);
            // Prefetch data, then update returned variables on complete
            inFlightRequest.current = (0, $j4oe4.fetchQuery)(environment, $d5c7b8ce5b358373$export$988ee43373cb9bb2, variables, {
                fetchPolicy: 'store-or-network',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                complete: ()=>{
                    setPrefetchedVariables(variables);
                    setFetchPolicy('store-only');
                    setIsFetching(false);
                    inFlightVariables.current = undefined;
                },
                error: (error)=>{
                    setIsFetching(false);
                    (0, $gYnSx.default)({
                        meta: {
                            id: 'hydrateJqlBuilderQuery',
                            packageName: 'jiraJqlBuilderCommon',
                            teamName: 'empanada'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        }
    }, [
        environment,
        prefetchedVariables,
        variables
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            variables: prefetchedVariables,
            fetchPolicy: fetchPolicy,
            isFetching: isFetching
        }), [
        prefetchedVariables,
        fetchPolicy,
        isFetching
    ]);
};
const $d5c7b8ce5b358373$export$b318e912f6cbc59b = (query, viewContext, scope = null)=>{
    const accountId = (0, $8q7lT.useAccountId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { variables: variables, fetchPolicy: fetchPolicy, isFetching: isFetching } = $d5c7b8ce5b358373$export$9562d1ce91742cb1({
        accountId: accountId ?? '',
        cloudId: cloudId,
        includeUser: query.length > 0 && !!accountId,
        includeJira: query.length > 0,
        jql: query,
        isFilter: false,
        filterAri: '',
        viewContext: viewContext,
        scope: scope,
        isPlanReleaseFeatureToggleEnabled: (0, $7jTnu.fg)('simple-plans-m2-release-feature-toggle')
    });
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)($d5c7b8ce5b358373$export$988ee43373cb9bb2);
    // @see https://hello.atlassian.net/wiki/spaces/~104598762/pages/2206935637/Why+do+we+need+to+re-hydrate+the+refinement+bar+on+every+change
    // Tl;DR – We refetch hydration data on every query change (instead of just fetching it on mount) for two reasons:
    // 1. There are external JQL changes that don't unmount the basic mode component and require hydration
    //    (e.g. changing filters in the sidebar, or clicking on the Reset button)
    // 2. We also rely on hydration API to render the invalid state when a particular field value is out of scope for
    //    the current query (e.g. if a selected status doesn't belong to one of the selected projects) – we could
    //    technically avoid rehydrating in this case if there isn't a change to scoping fields (like project or issue
    //    type), but it's probably not worth the extra complexity
    (0, $eJOHy.useEffect)(()=>{
        loadQuery(variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
    }, [
        fetchPolicy,
        loadQuery,
        variables
    ]);
    return [
        queryReference,
        isFetching
    ];
};

});

parcelRegister("8KuTC", function(module, exports) {

$parcel$export(module.exports, "PerformanceContext", () => $7cf4b0d12119b93a$export$39bcde15aa963086);
$parcel$export(module.exports, "usePerformanceContext", () => $7cf4b0d12119b93a$export$851a2d8ae957dc96);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

const $7cf4b0d12119b93a$export$39bcde15aa963086 = /*#__PURE__*/ (0, $eJOHy.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
const $7cf4b0d12119b93a$export$851a2d8ae957dc96 = ()=>(0, $eJOHy.useContext)($7cf4b0d12119b93a$export$39bcde15aa963086);

});

parcelRegister("56qWy", function(module, exports) {

$parcel$export(module.exports, "SEARCH_MODE_BASIC", () => $8645a6ff5f3a8efb$export$f963d14b266e4d2e);
$parcel$export(module.exports, "SEARCH_MODE_ADVANCED", () => $8645a6ff5f3a8efb$export$aad1d9eb9b751555);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_BASIC", () => $8645a6ff5f3a8efb$export$87c41a6b3123c00f);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_ADVANCED", () => $8645a6ff5f3a8efb$export$a7a000706ebc3ba8);
$parcel$export(module.exports, "DEFAULT_SEARCH_MODE", () => $8645a6ff5f3a8efb$export$e1eb2ddab803c5ec);
$parcel$export(module.exports, "mapSearchModeToAnalyticAtribute", () => $8645a6ff5f3a8efb$export$70c8f980e4a50682);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_LEFT_LOCATION", () => $8645a6ff5f3a8efb$export$4dab29e715a4e6fb);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_RIGHT_LOCATION", () => $8645a6ff5f3a8efb$export$59848395da0b4bcb);
$parcel$export(module.exports, "PACKAGE_NAME", () => $8645a6ff5f3a8efb$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $8645a6ff5f3a8efb$export$d57b6b390e78d90f);
const $8645a6ff5f3a8efb$export$f963d14b266e4d2e = 'basic';
const $8645a6ff5f3a8efb$export$aad1d9eb9b751555 = 'advanced';
const $8645a6ff5f3a8efb$export$87c41a6b3123c00f = 'BASIC';
const $8645a6ff5f3a8efb$export$a7a000706ebc3ba8 = 'ADVANCED';
const $8645a6ff5f3a8efb$export$e1eb2ddab803c5ec = $8645a6ff5f3a8efb$export$f963d14b266e4d2e;
const $8645a6ff5f3a8efb$export$70c8f980e4a50682 = {
    [$8645a6ff5f3a8efb$export$f963d14b266e4d2e]: $8645a6ff5f3a8efb$export$f963d14b266e4d2e,
    [$8645a6ff5f3a8efb$export$aad1d9eb9b751555]: 'JQL'
};
const $8645a6ff5f3a8efb$export$4dab29e715a4e6fb = 'Left';
const $8645a6ff5f3a8efb$export$59848395da0b4bcb = 'Right';
const $8645a6ff5f3a8efb$export$b8b9d90f9e5bd72b = 'jiraJqlBuilder';
const $8645a6ff5f3a8efb$export$d57b6b390e78d90f = 'empanada';

});

parcelRegister("gQyru", function(module, exports) {

$parcel$export(module.exports, "toSearchModeWithBasicModeFallback", () => $55476173f94cb033$export$7c0f55a4bd3730ea);
$parcel$export(module.exports, "toServerSearchMode", () => $55476173f94cb033$export$32a166cc1b3e6927);

var $56qWy = parcelRequire("56qWy");
function $55476173f94cb033$export$7c0f55a4bd3730ea(value) {
    switch(value){
        case 0, $56qWy.SERVER_SEARCH_MODE_ADVANCED:
            return 0, $56qWy.SEARCH_MODE_ADVANCED;
        default:
            return 0, $56qWy.DEFAULT_SEARCH_MODE;
    }
}
function $55476173f94cb033$export$32a166cc1b3e6927(mode) {
    switch(mode){
        case 0, $56qWy.SEARCH_MODE_ADVANCED:
            return 0, $56qWy.SERVER_SEARCH_MODE_ADVANCED;
        default:
            return 0, $56qWy.SERVER_SEARCH_MODE_BASIC;
    }
}

});

parcelRegister("3JHgj", function(module, exports) {

$parcel$export(module.exports, "useContextJql", () => $24965b3e406f3b24$export$68b4e7df5f221bf);

var $eJOHy = parcelRequire("eJOHy");

var $f26C8 = parcelRequire("f26C8");
var $9qsUT = parcelRequire("9qsUT");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $dTJxm = parcelRequire("dTJxm");
const $24965b3e406f3b24$var$isProjectKey = (projectKey)=>Boolean(projectKey);
const $24965b3e406f3b24$export$68b4e7df5f221bf = ({ jql: jql, projectKeys: projectKeys })=>{
    return (0, $eJOHy.useMemo)(()=>{
        /**
		 * context jql based on projectKeys
		 */ const sanitizedProjectKeys = projectKeys?.filter($24965b3e406f3b24$var$isProjectKey) ?? [];
        if (sanitizedProjectKeys.length === 0) return jql;
        const jast = new (0, $9qsUT.JastBuilder)().build(jql);
        jast.query?.appendClause((0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $dTJxm.PROJECT_FIELD_JQL_TERM)), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_IN)), (0, $f26C8.default).listOperand(sanitizedProjectKeys.map((0, $f26C8.default).valueOperand))), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
        return (0, $1jiqw.print)(jast, {
            operatorCase: 'upper'
        });
    }, [
        jql,
        projectKeys
    ]);
};

});
const $f6415dda43b7f459$export$6d6d48d210d3ca97 = 'and';
const $f6415dda43b7f459$export$7b8f0a728d79a753 = 'or';


parcelRegister("bAZUe", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderUIOld", () => $18b4aa5832501970$export$328ac4451491d9e0);
$parcel$export(module.exports, "default", () => $18b4aa5832501970$export$2e2bcd8739ae039);

var $lOB0a = parcelRequire("lOB0a");

var $1mWlF = parcelRequire("1mWlF");

var $eJOHy = parcelRequire("eJOHy");

var $jvwCK = parcelRequire("jvwCK");

var $j4oe4 = parcelRequire("j4oe4");

var $hHzDA = parcelRequire("hHzDA");

var $cWcbh = parcelRequire("cWcbh");

var $ch9En = parcelRequire("ch9En");

var $4Py7k = parcelRequire("4Py7k");

var $7jTnu = parcelRequire("7jTnu");

var $8FAu5 = parcelRequire("8FAu5");

var $70el7 = parcelRequire("70el7");

var $56qWy = parcelRequire("56qWy");

var $gQyru = parcelRequire("gQyru");

var $cX22j = parcelRequire("cX22j");

var $3JHgj = parcelRequire("3JHgj");

var $b2CbD = parcelRequire("b2CbD");

var $lw8qf = parcelRequire("lw8qf");

var $8ShlV = parcelRequire("8ShlV");
const $18b4aa5832501970$export$66ac472152813d8b = (0, $1mWlF.default);
/* eslint-enable @atlassian/relay/graphql-naming */ const $18b4aa5832501970$var$JQLBuilderUI = ({ userPreferences: userPreferences, searchModes: searchModes = [
    (0, $56qWy.SEARCH_MODE_ADVANCED),
    (0, $56qWy.SEARCH_MODE_BASIC)
], onUpdateSearchMode: onUpdateSearchMode, selectedSearchMode: selectedSearchMode, isSearchModeToggleEnabled: isSearchModeToggleEnabled, irremovableFields: irremovableFields, uniqueSearchModes: uniqueSearchModes, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode = false, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation, projectKeys: projectKeys, showOrderByPicker: showOrderByPicker, viewContext: viewContext = null, scope: scope = null, initialQueryRef: initialQueryRef, onLoadingMode: onLoadingMode, loadingModeRef: loadingModeRef, ...props })=>{
    const userPreferencesData = (0, $j4oe4.useFragment)($18b4aa5832501970$export$66ac472152813d8b, userPreferences);
    const saveSearchModePreference = (0, $b2CbD.useSearchModeMutation)(userPreferencesData ?? null);
    const contextJql = (0, $3JHgj.useContextJql)({
        jql: props.query,
        projectKeys: projectKeys
    });
    // eslint-disable-next-line @atlassian/relay/query-restriction
    const hydrationQueryData = (0, $j4oe4.usePreloadedQuery)((0, $cWcbh.HYDRATION_QUERY), initialQueryRef);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const [hydrationData, hydrationRefetch] = (0, $j4oe4.useRefetchableFragment)((0, $lOB0a.default), hydrationQueryData);
    /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ const hydratedJql = (0, $eJOHy.useMemo)(()=>{
        const hydrationResult = hydrationData?.jira?.jqlBuilder?.hydrateJqlQuery ?? hydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter;
        if (hydrationResult?.__typename === 'JiraJqlHydratedQuery') return hydrationResult.jql ?? undefined;
    }, [
        hydrationData?.jira?.jqlBuilder?.hydrateJqlQuery,
        hydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter
    ]);
    const onSearchModeChange = (0, $eJOHy.useCallback)((searchMode, reason)=>{
        // Update the search mode preference when the reason is matching the allowed list
        // Note: The reasons currently used below were chosen to match previous behaviour when the new reason "QueryUnsupported" was introduced
        if (reason === 'UserTriggered' || reason === 'ExternalTriggered') saveSearchModePreference(searchMode);
        onUpdateSearchMode?.(searchMode, reason);
    }, [
        onUpdateSearchMode,
        saveSearchModePreference
    ]);
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lw8qf.JQLBuilderFallback), {
        query: props.query,
        searchModes: searchModes,
        onLoad: onLoadingMode,
        selectedSearchMode: selectedSearchMode,
        isSearchModeToggleEnabled: isSearchModeToggleEnabled,
        beforeControls: props.beforeControls,
        renderExtraControls: props.renderExtraControls,
        excludedFields: props.excludedFields,
        components: props.components,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        showOrderByPicker: showOrderByPicker
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jql-builder-ui",
        fallback: fallback
    }, hydrationData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8FAu5.HydrationQueryProvider), {
        query: (0, $4Py7k.default),
        refetch: hydrationRefetch,
        contextJql: contextJql,
        hydratedJql: hydratedJql,
        ...(0, $7jTnu.fg)('jql_builder_add_view_context_to_hydration_query') && {
            viewContext: viewContext
        },
        scope: scope
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $70el7.QuerySupportedContainer), {
        query: props.query,
        excludedFields: props.excludedFields,
        jqlMessages: props.jqlMessages,
        hydrationData: hydrationData,
        simplifiedOperators: hideOperatorDropdownBasicMode,
        hideTextSearchInput: hideTextSearchInput,
        contextJql: contextJql
    }, uniqueSearchModes.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cX22j.SingleSearchModeContainer), {
        searchMode: uniqueSearchModes[0]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8ShlV.JQLBuilderUIImpl), {
        searchModes: uniqueSearchModes,
        hydrationData: hydrationData,
        selectedSearchMode: selectedSearchMode,
        onUpdateSearchMode: onUpdateSearchMode,
        hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        contextJql: contextJql,
        showOrderByPicker: showOrderByPicker,
        loadingModeRef: loadingModeRef,
        viewContext: viewContext,
        scope: scope,
        ...props
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cX22j.SelectedSearchModeContainer), {
        searchMode: selectedSearchMode,
        onSearchModeChange: onSearchModeChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8ShlV.JQLBuilderUIImpl), {
        searchModes: uniqueSearchModes,
        hydrationData: hydrationData,
        selectedSearchMode: selectedSearchMode,
        onUpdateSearchMode: onUpdateSearchMode,
        hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        contextJql: contextJql,
        showOrderByPicker: showOrderByPicker,
        loadingModeRef: loadingModeRef,
        viewContext: viewContext,
        scope: scope,
        ...props
    })))) : fallback);
};
const $18b4aa5832501970$export$328ac4451491d9e0 = ({ userPreferences: userPreferences, searchModes: searchModes = [
    (0, $56qWy.SEARCH_MODE_ADVANCED),
    (0, $56qWy.SEARCH_MODE_BASIC)
], onUpdateSearchMode: onUpdateSearchMode, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode = false, hideTextSearchInput: hideTextSearchInput = false, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation = (0, $56qWy.SEARCH_MODE_SWITCHER_LEFT_LOCATION), projectKeys: projectKeys, showOrderByPicker: showOrderByPicker, viewContext: viewContext = null, scope: scope = null, ...props })=>{
    const { onLoad: onLoad } = props;
    // Persist mode used in loading state to send in analytics
    const loadingModeRef = (0, $eJOHy.useRef)();
    const onLoadingMode = (0, $eJOHy.useCallback)((mode)=>{
        loadingModeRef.current = mode;
        onLoad?.(mode);
    }, [
        onLoad
    ]);
    const userPreferencesData = (0, $j4oe4.useFragment)($18b4aa5832501970$export$66ac472152813d8b, userPreferences);
    const searchModeResponse = userPreferencesData?.jqlBuilderSearchMode;
    const selectedSearchMode = (0, $gQyru.toSearchModeWithBasicModeFallback)(searchModeResponse);
    const saveSearchModePreference = (0, $b2CbD.useSearchModeMutation)(userPreferencesData ?? null);
    if (searchModes.length === 0) throw new Error('Search mode should be non empty');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const uniqueSearchModes = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(searchModes);
    const contextJql = (0, $3JHgj.useContextJql)({
        jql: props.query,
        projectKeys: projectKeys
    });
    const [hydrationQueryRef, isHydrating] = (0, $cWcbh.useHydrationQueryLoader)(contextJql, viewContext, scope);
    const isSearchModeToggleEnabled = uniqueSearchModes ? uniqueSearchModes.length > 1 : true;
    const onSearchModeChange = (0, $eJOHy.useCallback)((searchMode, reason)=>{
        // Update the search mode preference when the reason is matching the allowed list
        // Note: The reasons currently used below were chosen to match previous behaviour when the new reason "QueryUnsupported" was introduced
        if (reason === 'UserTriggered' || reason === 'ExternalTriggered') saveSearchModePreference(searchMode);
        onUpdateSearchMode?.(searchMode, reason);
    }, [
        onUpdateSearchMode,
        saveSearchModePreference
    ]);
    const irremovableFields = (0, $hHzDA.useIrremovableFields)(props.basicModeVisibleFields ?? (0, $hHzDA.DEFAULT_IRREMOVABLE_FIELDS)());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jql-builder-ui",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lw8qf.JQLBuilderFallback), {
            query: props.query,
            searchModes: searchModes,
            selectedSearchMode: selectedSearchMode,
            isSearchModeToggleEnabled: isSearchModeToggleEnabled,
            beforeControls: props.beforeControls,
            renderExtraControls: props.renderExtraControls,
            excludedFields: props.excludedFields,
            components: props.components,
            irremovableFields: irremovableFields,
            hideTextSearchInput: hideTextSearchInput,
            searchPlaceholder: searchPlaceholder,
            searchModeSwitcherLocation: searchModeSwitcherLocation,
            showOrderByPicker: showOrderByPicker
        })
    }, hydrationQueryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $70el7.QuerySupportedContainerOld), {
        query: props.query,
        excludedFields: props.excludedFields,
        jqlMessages: props.jqlMessages,
        hydrationQueryRef: hydrationQueryRef,
        isHydrating: isHydrating,
        simplifiedOperators: hideOperatorDropdownBasicMode,
        hideTextSearchInput: hideTextSearchInput,
        contextJql: contextJql
    }, uniqueSearchModes.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cX22j.SingleSearchModeContainer), {
        searchMode: uniqueSearchModes[0]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8ShlV.JQLBuilderUIImplOld), {
        searchModes: uniqueSearchModes,
        hydrationQueryRef: hydrationQueryRef,
        selectedSearchMode: selectedSearchMode,
        isHydrating: isHydrating,
        onUpdateSearchMode: onUpdateSearchMode,
        hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        contextJql: contextJql,
        showOrderByPicker: showOrderByPicker,
        loadingModeRef: loadingModeRef,
        viewContext: viewContext,
        scope: scope,
        ...props
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cX22j.SelectedSearchModeContainer), {
        searchMode: selectedSearchMode,
        onSearchModeChange: onSearchModeChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8ShlV.JQLBuilderUIImplOld), {
        searchModes: uniqueSearchModes,
        hydrationQueryRef: hydrationQueryRef,
        selectedSearchMode: selectedSearchMode,
        isHydrating: isHydrating,
        onUpdateSearchMode: onUpdateSearchMode,
        hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        contextJql: contextJql,
        showOrderByPicker: showOrderByPicker,
        loadingModeRef: loadingModeRef,
        viewContext: viewContext,
        scope: scope,
        ...props
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lw8qf.JQLBuilderFallback), {
        query: props.query,
        onLoad: onLoadingMode,
        searchModes: searchModes,
        selectedSearchMode: selectedSearchMode,
        isSearchModeToggleEnabled: isSearchModeToggleEnabled,
        beforeControls: props.beforeControls,
        renderExtraControls: props.renderExtraControls,
        excludedFields: props.excludedFields,
        components: props.components,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        showOrderByPicker: showOrderByPicker
    }));
};
var $18b4aa5832501970$export$2e2bcd8739ae039 = $18b4aa5832501970$var$JQLBuilderUI;

});
parcelRegister("lOB0a", function(module, exports) {

$parcel$export(module.exports, "default", () => $64ca526ef62eeae0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9039d7634b1fe022fca270dadf01420a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $4Py7k = parcelRequire("4Py7k");
const $64ca526ef62eeae0$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v1 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jql"
                }
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "accountId"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "includeUser"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "isPlanReleaseFeatureToggleEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $4Py7k.default)
            }
        },
        "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "useHydratedValues"
            },
            {
                "kind": "FragmentSpread",
                "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI"
            },
            {
                "kind": "FragmentSpread",
                "name": "useQuery"
            },
            {
                "kind": "FragmentSpread",
                "name": "useHydratedValues_cascadeSelectPicker"
            },
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v2 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v2 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$64ca526ef62eeae0$var$node.hash = "7e21dbd6ea1814b23402a1d8df10c1a7";
var $64ca526ef62eeae0$export$2e2bcd8739ae039 = $64ca526ef62eeae0$var$node;

});
parcelRegister("4Py7k", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dfb3821c0fd07ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f885247a7ec3fca4d37e7e1a12b679a1>>
 * @relayHash c5dcbe8f669c934018c8f20fbbc93b8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 16dfdce3bf40db2e81ecfeeb0047aa00e9b4f3bdcdaca17ad0b1ebbeef7ded36
const $8dfb3821c0fd07ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeJira"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeUser"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isFilter"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isPlanReleaseFeatureToggleEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scope"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewContext"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        v1 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v2 /*: any*/ 
    ], v4 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v5 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorName"
                },
                v2 /*: any*/ 
            ]
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v11 = [
        v1 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        },
                                        {
                                            "condition": "isPlanReleaseFeatureToggleEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "shouldExcludeInScope"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraFieldType",
                                            "kind": "LinkedField",
                                            "name": "fieldType",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v9 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v9 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "xsmall"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v3 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v1 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                v2 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "boardName"
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v10 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "error",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ],
            "type": "QueryError"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HydrationRefetchQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HydrationRefetchQuery",
            "selections": [
                {
                    "condition": "includeUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "accountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v3 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "query",
                                                            "variableName": "jql"
                                                        },
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v11 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "id",
                                                            "variableName": "filterAri"
                                                        },
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v11 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "16dfdce3bf40db2e81ecfeeb0047aa00e9b4f3bdcdaca17ad0b1ebbeef7ded36",
            "metadata": {},
            "name": "HydrationRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8dfb3821c0fd07ae$var$node.hash = "7e21dbd6ea1814b23402a1d8df10c1a7";
var $8dfb3821c0fd07ae$export$2e2bcd8739ae039 = $8dfb3821c0fd07ae$var$node;

});


parcelRegister("1mWlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5280866e2f2276c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2b5dbf7906b653869505f67a354896a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5280866e2f2276c4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_jqlBuilder_JQLBuilderUI",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "searchMode_useSearchMode_JQLBuilder"
        },
        {
            "kind": "ScalarField",
            "name": "jqlBuilderSearchMode"
        }
    ],
    "type": "JiraUserPreferences"
};
$5280866e2f2276c4$var$node.hash = "9fbe210abfde6a98b4eff53d65746395";
var $5280866e2f2276c4$export$2e2bcd8739ae039 = $5280866e2f2276c4$var$node;

});

parcelRegister("8FAu5", function(module, exports) {

$parcel$export(module.exports, "useHydrationQuery", () => $08132779e00b6aa2$export$9992ca387dbb4d57);
$parcel$export(module.exports, "HydrationQueryProvider", () => $08132779e00b6aa2$export$bb83aa31c9e87b59);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");
const $08132779e00b6aa2$var$HydrationQueryContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    hydrationQueryIsFetching: false,
    hydrationQueryContextJql: ''
});
$08132779e00b6aa2$var$HydrationQueryContext.displayName = 'HydrationQueryContext';
const $08132779e00b6aa2$export$9992ca387dbb4d57 = ()=>(0, $eJOHy.useContext)($08132779e00b6aa2$var$HydrationQueryContext);
const $08132779e00b6aa2$export$bb83aa31c9e87b59 = ({ refetch: refetch, query: query, contextJql: contextJql, hydratedJql: hydratedJql, children: children, viewContext: viewContext, scope: scope })=>{
    const [hydrationQueryIsFetching, setHydrationQueryIsFetching] = (0, $eJOHy.useState)(false);
    const cloudId = (0, $kEUB1.useCloudId)();
    const atlassianAccountId = (0, $8q7lT.useAccountId)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const inFlightRequest = (0, $eJOHy.useRef)();
    const inFlightContextJql = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        const shouldRefetch = contextJql !== hydratedJql && contextJql !== inFlightContextJql.current;
        if (shouldRefetch) {
            // Prevent race condition from multiple requests in progress
            // (ex. if user clicks quickly on different filters)
            inFlightRequest.current?.unsubscribe();
            inFlightContextJql.current = contextJql;
            // eslint-disable-next-line jira/ff/inline-usage
            const variables = {
                filterAri: '',
                includeFilter: false,
                jql: contextJql,
                accountId: atlassianAccountId ?? '',
                includeJira: true,
                includeUser: true,
                cloudId: cloudId,
                isFilter: false,
                ...(0, $7jTnu.fg)('jql_builder_add_view_context_to_hydration_query') && {
                    viewContext: viewContext
                },
                scope: scope,
                isPlanReleaseFeatureToggleEnabled: (0, $7jTnu.fg)('simple-plans-m2-release-feature-toggle')
            };
            setHydrationQueryIsFetching(true);
            // Prefetch data, then update returned variables on complete
            inFlightRequest.current = (0, $j4oe4.fetchQuery)(environment, query, variables, {
                fetchPolicy: 'store-or-network',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                complete: ()=>{
                    refetch(variables, {
                        fetchPolicy: 'store-only',
                        onComplete: ()=>{
                            setHydrationQueryIsFetching(false);
                            inFlightContextJql.current = undefined;
                        }
                    });
                },
                error: (error)=>{
                    setHydrationQueryIsFetching(false);
                    (0, $gYnSx.default)({
                        meta: {
                            id: 'hydrateJqlBuilderQuery',
                            packageName: 'jiraJqlBuilder',
                            teamName: 'empanada'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        }
    }, [
        atlassianAccountId,
        cloudId,
        contextJql,
        environment,
        hydratedJql,
        query,
        refetch,
        setHydrationQueryIsFetching,
        viewContext,
        scope
    ]);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            hydrationQueryIsFetching: hydrationQueryIsFetching,
            hydrationQueryContextJql: hydratedJql
        }), [
        hydrationQueryIsFetching,
        hydratedJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08132779e00b6aa2$var$HydrationQueryContext.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("70el7", function(module, exports) {

$parcel$export(module.exports, "QuerySupportedContainerOld", () => $92286b5c84adb411$export$f94eb234c660c8a5);
$parcel$export(module.exports, "QuerySupportedContainer", () => $92286b5c84adb411$export$34660422c2aeae3d);
$parcel$export(module.exports, "useIsQuerySupported", () => $92286b5c84adb411$export$8ce0898530622ab2);

var $76KWb = parcelRequire("76KWb");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9JtRn = parcelRequire("9JtRn");

var $22GDK = parcelRequire("22GDK");

var $cWcbh = parcelRequire("cWcbh");

var $5fhUb = parcelRequire("5fhUb");

var $8KuTC = parcelRequire("8KuTC");

var $8FAu5 = parcelRequire("8FAu5");
const $92286b5c84adb411$export$7b6dd859fbd6fe77 = (0, $76KWb.default);
/* eslint-enable @atlassian/relay/graphql-naming,  @atlassian/relay/unused-fields */ const $92286b5c84adb411$var$useQuerySupportedOld = ({ currentJql: currentJql, excludedFields: excludedFields = [], jqlErrors: jqlErrors, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, simplifiedOperators: simplifiedOperators, hideTextSearchInput: hideTextSearchInput, contextJql: contextJql })=>{
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    onPerformanceMark({
        mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_HYDRATE_START
    });
    /* eslint-disable @atlassian/relay/query-restriction */ const hydratedData = (0, $j4oe4.usePreloadedQuery)((0, $cWcbh.HYDRATION_QUERY), hydrationQueryRef);
    onPerformanceMark({
        mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_HYDRATE_END
    });
    const fieldsHydrationData = (0, $j4oe4.useFragment)($92286b5c84adb411$export$7b6dd859fbd6fe77, hydratedData);
    /* eslint-enable @atlassian/relay/query-restriction */ return (0, $eJOHy.useMemo)(()=>{
        const fieldsData = {};
        if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQuery.fields.forEach((field)=>{
            if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                jqlTerm: field.jqlTerm,
                searchTemplate: field.field.searchTemplate.key,
                operators: field.field.operators.map((0, $22GDK.mapOperators)),
                fieldType: field.field.type,
                hydratedValues: field.values
            };
        });
        else if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQueryForFilter.fields.forEach((field)=>{
            if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                jqlTerm: field.jqlTerm,
                searchTemplate: field.field.searchTemplate.key,
                operators: field.field.operators.map((0, $22GDK.mapOperators)),
                fieldType: field.field.type,
                hydratedValues: field.values
            };
        });
        const isLastHydrationQuery = contextJql !== hydrationQueryRef?.variables.jql;
        const querySupported = !jqlErrors?.length && /**
     * Relay run one render iteration with isHydrating false but with the old data,
     * so we check if the jql matches the current hydration query.
     */ (isHydrating || isLastHydrationQuery ? /**
    * If we are hydrating, we run a complexity check without checking operators.
    * This allow us to show advanced mode loading state if we already know the query is too complex.
    * For Example, when we have multiple compound clauses or have unsupported nodes
    */ !(0, $9JtRn.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            shouldValidateOperators: false,
            hideTextSearchInput: hideTextSearchInput
        }) : /**
    * Complete complexity check using hydrated data.
    */ !(0, $9JtRn.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            fieldsData: fieldsData,
            simplifiedOperators: simplifiedOperators,
            hideTextSearchInput: hideTextSearchInput
        }));
        return {
            querySupported: querySupported
        };
    }, [
        fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields,
        fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields,
        contextJql,
        hydrationQueryRef?.variables.jql,
        currentJql,
        isHydrating,
        excludedFields,
        hideTextSearchInput,
        simplifiedOperators,
        jqlErrors?.length
    ]);
};
const $92286b5c84adb411$export$f94eb234c660c8a5 = ({ query: query, excludedFields: excludedFields = [], jqlMessages: jqlMessages, children: children, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating = false, simplifiedOperators: simplifiedOperators = false, hideTextSearchInput: hideTextSearchInput = false, contextJql: contextJql })=>{
    const jqlErrors = (0, $eJOHy.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>(jqlMessages || []).filter((e)=>e.type === 'error'), [
        jqlMessages
    ]);
    const { querySupported: querySupported } = $92286b5c84adb411$var$useQuerySupportedOld({
        currentJql: query,
        excludedFields: excludedFields,
        jqlErrors: jqlErrors,
        hydrationQueryRef: hydrationQueryRef,
        isHydrating: isHydrating,
        simplifiedOperators: simplifiedOperators,
        hideTextSearchInput: hideTextSearchInput,
        contextJql: contextJql
    });
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            querySupported: querySupported
        }), [
        querySupported
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92286b5c84adb411$var$QuerySupportedContext.Provider, {
        value: contextValue
    }, children);
};
const $92286b5c84adb411$var$useQuerySupported = ({ currentJql: currentJql, excludedFields: excludedFields = [], jqlErrors: jqlErrors, hydrationData: hydrationData, simplifiedOperators: simplifiedOperators, hideTextSearchInput: hideTextSearchInput, contextJql: contextJql })=>{
    const fieldsHydrationData = (0, $j4oe4.useFragment)($92286b5c84adb411$export$7b6dd859fbd6fe77, hydrationData);
    const { hydrationQueryIsFetching: hydrationQueryIsFetching, hydrationQueryContextJql: hydrationQueryContextJql } = (0, $8FAu5.useHydrationQuery)();
    return (0, $eJOHy.useMemo)(()=>{
        const fieldsData = {};
        if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQuery.fields.forEach((field)=>{
            if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                jqlTerm: field.jqlTerm,
                searchTemplate: field.field.searchTemplate.key,
                operators: field.field.operators.map((0, $22GDK.mapOperators)),
                fieldType: field.field.type,
                hydratedValues: field.values
            };
        });
        else if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQueryForFilter.fields.forEach((field)=>{
            if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                jqlTerm: field.jqlTerm,
                searchTemplate: field.field.searchTemplate.key,
                operators: field.field.operators.map((0, $22GDK.mapOperators)),
                fieldType: field.field.type,
                hydratedValues: field.values
            };
        });
        const isLastHydrationQuery = contextJql !== hydrationQueryContextJql;
        const querySupported = !jqlErrors?.length && /**
     * Relay run one render iteration with isHydrating false but with the old data,
     * so we check if the jql matches the current hydration query.
     */ (hydrationQueryIsFetching || isLastHydrationQuery ? /**
    * If we are hydrating, we run a complexity check without checking operators.
    * This allow us to show advanced mode loading state if we already know the query is too complex.
    * For Example, when we have multiple compound clauses or have unsupported nodes
    */ !(0, $9JtRn.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            shouldValidateOperators: false,
            hideTextSearchInput: hideTextSearchInput
        }) : /**
    * Complete complexity check using hydrated data.
    */ !(0, $9JtRn.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            fieldsData: fieldsData,
            simplifiedOperators: simplifiedOperators,
            hideTextSearchInput: hideTextSearchInput
        }));
        return {
            querySupported: querySupported
        };
    }, [
        fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields,
        fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields,
        contextJql,
        hydrationQueryContextJql,
        hydrationQueryIsFetching,
        currentJql,
        excludedFields,
        hideTextSearchInput,
        simplifiedOperators,
        jqlErrors?.length
    ]);
};
const $92286b5c84adb411$var$QuerySupportedContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    querySupported: true
});
const $92286b5c84adb411$export$34660422c2aeae3d = ({ query: query, excludedFields: excludedFields = [], jqlMessages: jqlMessages, children: children, hydrationData: hydrationData, simplifiedOperators: simplifiedOperators = false, hideTextSearchInput: hideTextSearchInput = false, contextJql: contextJql })=>{
    const jqlErrors = (0, $eJOHy.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>(jqlMessages || []).filter((e)=>e.type === 'error'), [
        jqlMessages
    ]);
    const { querySupported: querySupported } = $92286b5c84adb411$var$useQuerySupported({
        currentJql: query,
        excludedFields: excludedFields,
        jqlErrors: jqlErrors,
        hydrationData: hydrationData,
        simplifiedOperators: simplifiedOperators,
        hideTextSearchInput: hideTextSearchInput,
        contextJql: contextJql
    });
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            querySupported: querySupported
        }), [
        querySupported
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92286b5c84adb411$var$QuerySupportedContext.Provider, {
        value: contextValue
    }, children);
};
const $92286b5c84adb411$export$8ce0898530622ab2 = ()=>(0, $eJOHy.useContext)($92286b5c84adb411$var$QuerySupportedContext);

});
parcelRegister("76KWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $498b3a5c03879a12$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cadfeece8c60fcae6af121a26753782b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $498b3a5c03879a12$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v1 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v2 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v6 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v2 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "name": "useQuery",
        "selections": [
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v6 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v6 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$498b3a5c03879a12$var$node.hash = "4d890a45a4dfda4ffe64d79e9bb649dd";
var $498b3a5c03879a12$export$2e2bcd8739ae039 = $498b3a5c03879a12$var$node;

});

parcelRegister("9JtRn", function(module, exports) {

$parcel$export(module.exports, "isQueryTooComplex", () => $12dab411be6d5dcb$export$4a510b220f67686c);

var $9qsUT = parcelRequire("9qsUT");

var $dTJxm = parcelRequire("dTJxm");

var $b06aK = parcelRequire("b06aK");

var $dFEPL = parcelRequire("dFEPL");

var $iA72F = parcelRequire("iA72F");

var $dHNhH = parcelRequire("dHNhH");

var $cugAS = parcelRequire("cugAS");
const $12dab411be6d5dcb$var$haveKnownUnsupportedOperators = (clauses)=>clauses.some((clause)=>clause.clauseType === (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a) && clause.operator && (0, $cugAS.getUnsupportedOperators)().includes(clause.operator.value));
const $12dab411be6d5dcb$var$isClauseTooComplex = ({ clauses: clauses, searchTemplate: searchTemplate, hydratedValues: hydratedValues })=>{
    // Date
    // Or if we don't know the value while not hydrated and can show basic picker
    if (!searchTemplate || (0, $dTJxm.dateSearchTemplates).has(searchTemplate)) return clauses.length > 2 || $12dab411be6d5dcb$var$haveKnownUnsupportedOperators(clauses);
    // Cascading Select
    if (searchTemplate === (0, $dTJxm.CASCADE_SELECT_FIELD_SEARCH_TEMPLATE)) {
        const unambiguousCascadeFieldValue = (0, $dFEPL.findUnambiguousCascadeFieldValue)({
            clause: clauses[0],
            hydratedValues: hydratedValues
        });
        return clauses.length !== 1 || unambiguousCascadeFieldValue === undefined;
    }
    // Number Range & Work Ratio
    if (searchTemplate === (0, $dTJxm.NUMBER_RANGE_FIELD_SEARCH_TEMPLATE) || searchTemplate === 'workratio') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const operatorValues = clauses.map((clause)=>clause?.operator?.value.toString());
        return clauses.length > 2 || clauses.length === 2 && !(0, $dTJxm.NUMBER_RANGE_PICKER_ALLOWED_OPERATORS).every((op)=>operatorValues.includes(op));
    }
    // CMDB/AQL
    if (searchTemplate === (0, $dTJxm.CMDB_FIELD_SEARCH_TEMPLATE)) return clauses.length !== 1 || (0, $iA72F.isCmdbClauseTooComplexForBasicMode)(clauses[0]);
    // Default
    return clauses.length > 1;
};
const $12dab411be6d5dcb$export$4a510b220f67686c = ({ jql: jql, excludedFields: excludedFields = [], fieldsData: fieldsData, shouldValidateOperators: shouldValidateOperators = true, simplifiedOperators: simplifiedOperators = false, hideTextSearchInput: hideTextSearchInput = false })=>{
    const jast = new (0, $9qsUT.JastBuilder)().build(jql);
    if (jast.errors.length) return true;
    try {
        const jqlClauseCollectingVisitor = new (0, $dHNhH.JqlClauseCollectingVisitor)(shouldValidateOperators, excludedFields, fieldsData, simplifiedOperators);
        const result = jast.query && jast.query.accept(jqlClauseCollectingVisitor);
        if (!result) return false;
        return(// Check if text search input clause is hidden
        result.textSearchInputClause && hideTextSearchInput || // Check if text search input clause is invalid
        !(0, $b06aK.default).validate(result.textSearchInputClause) || // Check if any clause is too complex
        Object.keys(result.clauseMap).some((key)=>{
            const clauses = result.clauseMap[key];
            const searchTemplate = fieldsData?.[key]?.searchTemplate;
            return $12dab411be6d5dcb$var$isClauseTooComplex({
                clauses: clauses,
                searchTemplate: searchTemplate,
                hydratedValues: fieldsData?.[key]?.hydratedValues
            });
        }));
    } catch (error) {
        return true;
    }
};

});
parcelRegister("b06aK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5570b954469d950$export$2e2bcd8739ae039);

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $i08rO = parcelRequire("i08rO");
/**
 * Check if search input clause is valid
 */ const $c5570b954469d950$var$validate = (compoundClause)=>{
    if (!compoundClause) return true;
    try {
        compoundClause.accept(new (0, $i08rO.TextSearchInputVisitor)());
        return true;
    } catch (e) {
        return false;
    }
};
/**
 * Return value of search input clause or undefined if it's invalid or empty
 */ const $c5570b954469d950$var$value = (textSearchClause)=>{
    if (!textSearchClause) return undefined;
    try {
        return textSearchClause.accept(new (0, $i08rO.TextSearchInputVisitor)());
    } catch (e) {
        return undefined;
    }
};
const $c5570b954469d950$var$createTextSearchInputClause = ({ quotedKeyword: quotedKeyword, isIssueKey: isIssueKey })=>{
    const textSearchInputClause = (0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $dTJxm.getTextSearchInputField)()), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_LIKE)), (0, $f26C8.default).byText.valueOperand(quotedKeyword));
    if (isIssueKey) {
        const issueKeyClause = (0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $dTJxm.ISSUE_KEY)), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).byText.valueOperand(quotedKeyword));
        return (0, $f26C8.default).compoundClause((0, $f26C8.default).compoundOperator((0, $f6415dda43b7f459$export$7b8f0a728d79a753)), [
            textSearchInputClause,
            issueKeyClause
        ]);
    }
    return textSearchInputClause;
};
/**
 * Update search input clause with new value
 */ const $c5570b954469d950$var$update = (ast, textSearchInputClause, val)=>{
    if (!$c5570b954469d950$var$validate(textSearchInputClause)) return ast.represents;
    if (val === undefined || val === null || val === '') {
        if (textSearchInputClause) textSearchInputClause.remove();
        else return ast.represents;
    } else {
        const isIssueKey = (0, $i08rO.isIssueKeyValue)(val);
        const quotedKeyword = (0, $eiIzV.wrapWithQuotes)((0, $eiIzV.escapeBackslashes)(val));
        const newTextSearchInputClause = $c5570b954469d950$var$createTextSearchInputClause({
            quotedKeyword: quotedKeyword,
            isIssueKey: isIssueKey
        });
        if (textSearchInputClause) textSearchInputClause.replace(newTextSearchInputClause);
        else ast.query?.appendClause(newTextSearchInputClause, (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
    }
    return (0, $1jiqw.print)(ast, {
        operatorCase: 'upper'
    });
};
const $c5570b954469d950$var$TextFieldType = {
    validate: $c5570b954469d950$var$validate,
    value: $c5570b954469d950$var$value,
    update: $c5570b954469d950$var$update
};
var $c5570b954469d950$export$2e2bcd8739ae039 = $c5570b954469d950$var$TextFieldType;

});
parcelRegister("eiIzV", function(module, exports) {

$parcel$export(module.exports, "generateOptions", () => $edcde80b412d6934$export$c21133b4499f5374);
$parcel$export(module.exports, "generateErrorOptions", () => $edcde80b412d6934$export$b1b163cf4487fb60);
$parcel$export(module.exports, "fireJqlBuilderBasicErrorAnalytics", () => $edcde80b412d6934$export$2704bef70095c059);
$parcel$export(module.exports, "wrapWithQuotes", () => $edcde80b412d6934$export$125e49598117a72);
$parcel$export(module.exports, "escapeBackslashes", () => $edcde80b412d6934$export$fbd15c27bb7e257c);
$parcel$export(module.exports, "isPickerPropType", () => $edcde80b412d6934$export$353a391606dc3779);
$parcel$export(module.exports, "isTextAreaPropType", () => $edcde80b412d6934$export$96188d366777c3f5);

var $gYnSx = parcelRequire("gYnSx");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");
const $edcde80b412d6934$export$c21133b4499f5374 = (options, totalCount, endCursor)=>({
        options: options,
        totalCount: totalCount === undefined ? null : totalCount,
        endCursor: endCursor
    });
const $edcde80b412d6934$export$b1b163cf4487fb60 = (error)=>$edcde80b412d6934$export$c21133b4499f5374([
        {
            optionType: 'error',
            error: error,
            onRetry: ()=>undefined
        }
    ]);
const $edcde80b412d6934$export$2704bef70095c059 = (id, searchTemplate, error)=>(0, $gYnSx.default)({
        meta: {
            id: id,
            packageName: (0, $dTJxm.PACKAGE_NAME),
            teamName: (0, $dTJxm.TEAM_NAME)
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            searchTemplate: searchTemplate
        }
    });
const $edcde80b412d6934$export$125e49598117a72 = (text)=>`"${text.replace(/"/g, '\\"')}"`;
const $edcde80b412d6934$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');
const $edcde80b412d6934$export$353a391606dc3779 = (propType)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.values((0, $eqSys.PickerPropTypes)).includes(propType);
const $edcde80b412d6934$export$96188d366777c3f5 = (propType)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.values((0, $eqSys.TextAreaPropTypes)).includes(propType);

});
parcelRegister("eqSys", function(module, exports) {

$parcel$export(module.exports, "PickerTypes", () => $2053dbea53d14225$export$823060bb41f9b9ce);
$parcel$export(module.exports, "PickerPropTypes", () => $2053dbea53d14225$export$8673a3795efdab32);
$parcel$export(module.exports, "TextAreaPropTypes", () => $2053dbea53d14225$export$84f313a0fe939ad2);
$parcel$export(module.exports, "GenericPropTypes", () => $2053dbea53d14225$export$39db718405e40735);
const $2053dbea53d14225$export$823060bb41f9b9ce = {
    CascadeSelect: 'CascadeSelect',
    DateTime: 'DateTime',
    DueDate: 'DueDate',
    DateTimeRange: 'DateTimeRange',
    NumberRange: 'NumberRange',
    Picker: 'Picker',
    Text: 'Text',
    TextArea: 'TextArea',
    BooleanType: 'BooleanType',
    Unsupported: 'Unsupported'
};
const $2053dbea53d14225$export$8673a3795efdab32 = {
    CommonWithEmpty: 'CommonWithEmpty',
    Common: 'Common',
    IssueType: 'IssueType',
    Project: 'Project',
    Sprint: 'Sprint',
    Version: 'Version',
    User: 'User',
    Group: 'Group'
};
const $2053dbea53d14225$export$84f313a0fe939ad2 = {
    Text: 'Text',
    Number: 'Number',
    Aql: 'Aql',
    ExactText: 'ExactText'
};
const $2053dbea53d14225$export$39db718405e40735 = {
    NoProp: 'NoProp'
};

});


parcelRegister("i08rO", function(module, exports) {

$parcel$export(module.exports, "isIssueKeyValue", () => $22b0d6b02a33df3c$export$ac7a009e7c9d6434);
$parcel$export(module.exports, "TextSearchInputVisitor", () => $22b0d6b02a33df3c$export$d5784d52b31adc66);

var $dl9fK = parcelRequire("dl9fK");
var $jPlb3 = parcelRequire("jPlb3");

var $dTJxm = parcelRequire("dTJxm");

var $1EcNA = parcelRequire("1EcNA");
const $22b0d6b02a33df3c$var$areTerminalClauses = (clauses)=>{
    for (const clause of clauses){
        if (clause.clauseType !== (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a)) return false;
    }
    return true;
};
const $22b0d6b02a33df3c$var$ISSUE_KEY_REGEXP = new RegExp('^[A-Z][A-Z0-9]+-[0-9]+$', 'i');
const $22b0d6b02a33df3c$export$ac7a009e7c9d6434 = (value)=>value !== undefined && value !== null && $22b0d6b02a33df3c$var$ISSUE_KEY_REGEXP.test(value);
class $22b0d6b02a33df3c$export$d5784d52b31adc66 extends (0, $dl9fK.AbstractJastVisitor) {
    defaultResult() {
        throw new (0, $1EcNA.InvalidTextSearchInputError)('Invalid search input clause');
    }
    constructor(...args){
        super(...args), this.visitCompoundClause = (compoundClause)=>{
            // Only allow one compound clause with 1 or 2 terminal clauses using OR operator
            if (compoundClause.clauses.length > 2 || compoundClause.clauses.length < 1 || compoundClause.operator.value !== (0, $f6415dda43b7f459$export$7b8f0a728d79a753) || !$22b0d6b02a33df3c$var$areTerminalClauses(compoundClause.clauses)) throw new (0, $1EcNA.InvalidTextSearchInputError)('Invalid search input clause');
            const valueMap = {};
            const value = compoundClause.clauses.reduce((result, terminalClause)=>{
                const clauseFieldName = terminalClause.field.value.toLowerCase();
                // Use same fieldName for key and issuekey (they are aliases)
                const fieldName = clauseFieldName === 'key' ? 'issuekey' : clauseFieldName;
                // Check if there are duplicated fields
                if (valueMap[fieldName]) throw new (0, $1EcNA.InvalidTextSearchInputError)(`Duplicated field ${fieldName}`);
                else valueMap[fieldName] = true;
                return this.aggregateResult(terminalClause.accept(this), result);
            }, undefined);
            // Check if all required fields are present
            if (!valueMap[(0, $dTJxm.getTextSearchInputField)()] || valueMap.issuekey !== undefined && !valueMap.issuekey) throw new (0, $1EcNA.InvalidTextSearchInputError)('Missing required field in search input');
            return value;
        }, this.visitTerminalClause = (terminalClause)=>{
            const fieldName = terminalClause.field.value.toLowerCase();
            // Only allow terminal clause with value operand
            if (terminalClause.operand?.operandType !== (0, $862dfd240457f00b$export$38accfc5a5d1c113)) throw new (0, $1EcNA.InvalidTextSearchInputError)(`Invalid operandType ${terminalClause.operand?.operandType}`);
            if (fieldName === (0, $dTJxm.getTextSearchInputField)()) {
                if (terminalClause.operator?.value !== (0, $jPlb3.OPERATOR_LIKE)) throw new (0, $1EcNA.InvalidTextSearchInputError)(`Invalid operator in ${fieldName}`);
                return terminalClause.operand.value;
            }
            // Issue key check
            if (fieldName === 'issuekey' || fieldName === 'key') {
                if (terminalClause.operator?.value !== (0, $jPlb3.OPERATOR_EQUALS)) throw new (0, $1EcNA.InvalidTextSearchInputError)(`Invalid operator in ${fieldName}`);
                if (!$22b0d6b02a33df3c$export$ac7a009e7c9d6434(terminalClause.operand.value)) throw new (0, $1EcNA.InvalidTextSearchInputError)(`Invalid value in ${fieldName}`);
                return terminalClause.operand.value;
            }
            throw new (0, $1EcNA.InvalidTextSearchInputError)(`Invalid field ${fieldName}`);
        }, this.aggregateResult = (aggregate, nextResult)=>{
            // We only allow using same value in all terminal clauses
            if (nextResult !== undefined && aggregate !== nextResult) throw new (0, $1EcNA.InvalidTextSearchInputError)('Mismatched values in search input');
            return aggregate;
        };
    }
}

});
parcelRegister("1EcNA", function(module, exports) {

$parcel$export(module.exports, "InvalidTextSearchInputError", () => $1db0525c379e013d$export$d6efcb4541a8aae7);
class $1db0525c379e013d$export$d6efcb4541a8aae7 extends Error {
}

});



parcelRegister("dFEPL", function(module, exports) {

$parcel$export(module.exports, "findUnambiguousCascadeFieldValue", () => $202a1712754808b7$export$b146240c7e4a7cf6);


var $dTJxm = parcelRequire("dTJxm");
const $202a1712754808b7$export$d6b4e2aa5cb86d59 = 'JiraJqlCascadingOptionFieldValue';
const $202a1712754808b7$var$isHydrationJqlValueOrError = (value)=>value?.__typename === 'JiraJqlQueryHydratedValue' || value?.__typename === 'JiraJqlQueryHydratedError';
const $202a1712754808b7$var$matchValueToClause = (hydratedValues, clauseValue)=>clauseValue ? hydratedValues?.find((fieldValue)=>$202a1712754808b7$var$isHydrationJqlValueOrError(fieldValue) && fieldValue?.jqlTerm?.toLowerCase() === clauseValue?.toLowerCase()) : undefined;
const $202a1712754808b7$var$isCascadingOptionFieldValue = (value)=>value?.__typename === 'JiraJqlCascadingOptionFieldValue';
/**
 * Returns the hydrated select option state (both parent and child) that the
 * cascading select picker accepts
 */ const $202a1712754808b7$var$getCascadingSelectStateFromFieldValue = (value)=>{
    if (!value?.optionId || !value?.displayName) return undefined;
    if (value.parentOption?.optionId && value.parentOption?.displayName) return {
        childOption: {
            label: value.displayName,
            value: value.optionId
        },
        parentOption: {
            label: value.parentOption.displayName,
            value: value.parentOption.optionId
        }
    };
    return {
        parentOption: {
            label: value.displayName,
            value: value.optionId
        }
    };
};
const $202a1712754808b7$var$getInvalidCascadingSelectOption = (valueOrError)=>({
        label: valueOrError.jqlTerm,
        value: valueOrError.jqlTerm,
        isInvalid: true
    });
/**
 * Handles determining the correct hydration to use for values from the `cascadeOption` function
 *
 * @param parent The JqlHydrationValue containing the possible parent options (or hydration error)
 * @param child  The JqlHydrationValue containing the possible child options (or hydration error)
 */ const $202a1712754808b7$var$getCascadingSelectStateForFunction = (parent, child)=>{
    // If there is no parent, then there cannot be a child either
    if (!parent) return undefined;
    // If the parent is invalid, then we can assume that the child is also invalid
    if (parent?.__typename === 'JiraJqlQueryHydratedError') return {
        parentOption: $202a1712754808b7$var$getInvalidCascadingSelectOption(parent),
        childOption: child ? $202a1712754808b7$var$getInvalidCascadingSelectOption(child) : undefined
    };
    // Find the parent option values. Parent options have parentOption set to null
    const parentValues = parent?.values?.filter($202a1712754808b7$var$isCascadingOptionFieldValue).filter((parentValue)=>!parentValue?.parentOption);
    // If there is no child, then we can return the parent option.
    if (!child && parentValues?.length === 1) return $202a1712754808b7$var$getCascadingSelectStateFromFieldValue(parentValues[0]);
    // If there were multiple possible parents and no children, then it is ambiguous and we will return none
    if (!child) return undefined;
    if (child?.__typename === 'JiraJqlQueryHydratedError') // If the child is invalid, we can at least attempt to salvage the parent
    return parentValues?.length === 1 ? {
        ...$202a1712754808b7$var$getCascadingSelectStateFromFieldValue(parentValues[0]),
        childOption: $202a1712754808b7$var$getInvalidCascadingSelectOption(child)
    } : {
        parentOption: $202a1712754808b7$var$getInvalidCascadingSelectOption(parent),
        childOption: $202a1712754808b7$var$getInvalidCascadingSelectOption(child)
    };
    // Find the child option values. Child options have parentOption set to a parent option. We can
    // use that to find the children that match a parent option found above
    const childValues = child?.values?.filter($202a1712754808b7$var$isCascadingOptionFieldValue).filter((childValue)=>parentValues?.some((parentValue)=>childValue?.parentOption && parentValue?.optionId === childValue?.parentOption.optionId));
    // If there is only one child value, we can return the parent and child option, otherwise the
    // clause is ambiguous
    if (childValues?.length === 1) return $202a1712754808b7$var$getCascadingSelectStateFromFieldValue(childValues[0]);
};
const $202a1712754808b7$export$b146240c7e4a7cf6 = ({ hydratedValues: hydratedValues, clause: clause })=>{
    if (clause?.clauseType !== (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a)) return;
    // Handle the case where clause is a list with mupltiple values
    if (clause?.operand?.operandType === (0, $862dfd240457f00b$export$fabec4aebba3f4df) && clause?.operand?.values?.length > 1) return;
    // Handle the case where clause is a cascadeOption function (with at most two arguments)
    if (clause?.operand?.operandType === (0, $862dfd240457f00b$export$19c7c729db381f9d) && clause?.operand?.function.value === (0, $dTJxm.CASCADE_OPTION_FUNCTION_NAME) && clause?.operand?.arguments && clause?.operand?.arguments.length <= 2) {
        const { operand: operand } = clause;
        return $202a1712754808b7$var$getCascadingSelectStateForFunction(// Find the field value that matches the first argument of the cascadeOption function (parent)
        $202a1712754808b7$var$matchValueToClause(hydratedValues, operand?.arguments[0]?.value), // Find the field value that matches the second argument of the cascadeOption function (child)
        $202a1712754808b7$var$matchValueToClause(hydratedValues, operand?.arguments[1]?.value));
    }
    // Handle the case where clause is a single value or a list with one value
    if (clause?.operand?.operandType !== (0, $862dfd240457f00b$export$f6049126fd97001f)) {
        let clauseValue = '';
        // Get the value of the clause depending on the operand type
        switch(clause?.operand?.operandType){
            case 0, $862dfd240457f00b$export$fabec4aebba3f4df:
                if (clause?.operand?.values?.[0]?.operandType !== (0, $862dfd240457f00b$export$38accfc5a5d1c113)) return;
                clauseValue = clause?.operand?.values?.[0]?.value;
                break;
            case 0, $862dfd240457f00b$export$38accfc5a5d1c113:
                clauseValue = clause?.operand?.value;
                break;
            default:
                return;
        }
        // Match the clause value to a field value
        const matchedValue = $202a1712754808b7$var$matchValueToClause(hydratedValues, clauseValue);
        if (matchedValue?.__typename === 'JiraJqlQueryHydratedError') // If there's a hydration error, the best we can do is assume it's the parent
        // This assumption resulsts in a better UX than kicking the user to advanced mode
        // with no further information.
        return {
            parentOption: $202a1712754808b7$var$getInvalidCascadingSelectOption(matchedValue)
        };
        // If there is more than one matched value, the clause is ambiguous, otherwise we can get
        // the parent and child option
        if (matchedValue?.values && matchedValue.values.length === 1 && $202a1712754808b7$var$isCascadingOptionFieldValue(matchedValue.values[0])) return $202a1712754808b7$var$getCascadingSelectStateFromFieldValue(matchedValue.values[0]);
    }
    return undefined;
};

});

parcelRegister("iA72F", function(module, exports) {

$parcel$export(module.exports, "isCmdbClauseTooComplexForBasicMode", () => $8b7cd1373c7f6adc$export$eed7916f3400f094);


var $dTJxm = parcelRequire("dTJxm");
const $8b7cd1373c7f6adc$export$eed7916f3400f094 = (clause)=>clause.clauseType !== (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a) || clause.operand?.operandType !== (0, $862dfd240457f00b$export$19c7c729db381f9d) || ![
        (0, $dTJxm.AQL_FUNCTION_NAME).toLowerCase(),
        (0, $dTJxm.IQL_FUNCTION_NAME).toLowerCase()
    ].includes(clause.operand?.function.value.toLowerCase()) || clause.operand?.arguments.length !== 1;

});

parcelRegister("dHNhH", function(module, exports) {

$parcel$export(module.exports, "JqlClauseCollectingVisitor", () => $ff2625dd751d7e4a$export$566c7abb4018442d);

var $16aVR = parcelRequire("16aVR");

var $dl9fK = parcelRequire("dl9fK");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");

var $4G98k = parcelRequire("4G98k");

var $bgVBN = parcelRequire("bgVBN");
class $ff2625dd751d7e4a$export$566c7abb4018442d extends (0, $dl9fK.AbstractJastVisitor) {
    /**
	 *
	 * @param shouldValidateOperators {boolean} - When true, when visiting a terminal clause, will
	 * compare the clause's operator to the allowed operators for the matching field in the
	 * `fieldsData` arg
	 * @param excludedFields
	 * @param fieldsData {FieldDataMap} - This is data transformed from the hydration query. We
	 * assume all of the fields are 1:1 with those in the AST since the same JQL query was used when
	 * calling hydration query
	 * @param simplifiedOperators
	 */ constructor(shouldValidateOperators = true, excludedFields = [], fieldsData, simplifiedOperators = false){
        super(), this.visitCompoundClause = (compoundClause)=>{
            const operator = compoundClause.operator.value;
            if (operator === (0, $f6415dda43b7f459$export$6d6d48d210d3ca97)) return compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), {
                clauseMap: {}
            });
            if (operator === (0, $f6415dda43b7f459$export$7b8f0a728d79a753)) // The only supported OR clause is for the text search refinement. Downstream validators are responsible for
            // checking if the compound clause is valid for text search.
            // If future refinements emerge that also use OR clauses then this logic would need to change to perform some
            // type of shape matching against the clause to find the correct refinement key.
            return {
                clauseMap: {},
                textSearchInputClause: compoundClause
            };
            throw new (0, $bgVBN.UnsupportedRefinementError)(`Compound clauses using the operator '${operator}' is not supported`);
        }, this.visitTerminalClause = (terminalClause)=>{
            const fieldName = terminalClause.field.value.toLowerCase();
            if (this.shouldValidateOperators) {
                if (this.excludedFields.includes(fieldName)) throw new (0, $bgVBN.UnsupportedRefinementError)(`Field with name '${fieldName}' of type ${terminalClause.clauseType} is not supported`);
                const operator = terminalClause.operator?.value ?? '';
                if (this.fieldsData) {
                    const fieldData = this.fieldsData[fieldName];
                    const { allowedOperators: allowedOperators, pickerType: pickerType } = (0, $4G98k.getPickerType)({
                        searchTemplate: fieldData.searchTemplate,
                        fieldType: fieldData.fieldType,
                        operators: fieldData.operators,
                        simplifiedOperators: this.simplifiedOperators
                    });
                    if (pickerType !== (0, $eqSys.PickerTypes).Unsupported && allowedOperators) {
                        const isAllowedOperator = allowedOperators.map((allowedOperator)=>allowedOperator.value.toLowerCase()).includes(operator.toLowerCase());
                        if (!isAllowedOperator) throw new (0, $bgVBN.UnsupportedRefinementError)(`Field with value '${fieldName}' and searchTemplate '${fieldData.searchTemplate}' of type ${terminalClause.clauseType} is using an unsupported operator [${operator}]`);
                    }
                } else throw new (0, $bgVBN.UnsupportedRefinementError)('Field data should be defined to validate operators');
            }
            if (fieldName === (0, $dTJxm.getTextSearchInputField)()) return {
                clauseMap: {},
                textSearchInputClause: terminalClause
            };
            return {
                clauseMap: {
                    [terminalClause.field.value.toLowerCase()]: [
                        terminalClause
                    ]
                }
            };
        };
        this.shouldValidateOperators = shouldValidateOperators;
        this.excludedFields = excludedFields;
        this.fieldsData = fieldsData;
        this.simplifiedOperators = simplifiedOperators;
    }
    visitNotClause() {
        throw new (0, $bgVBN.UnsupportedRefinementError)('JqlClauseCollectingVisitor visited an unsupported node while traversing the AST');
    }
    defaultResult() {
        return {
            clauseMap: {}
        };
    }
    /**
	 * @param aggregate new ClauseMap to add into nextResult
	 * @param nextResult ClauseMap with previous results
	 * @returns ClauseMap with the merged results adding the aggregate at the end
	 */ aggregateResult(aggregate, nextResult) {
        if (nextResult.textSearchInputClause && aggregate.textSearchInputClause) throw new (0, $bgVBN.UnsupportedRefinementError)('Too many text search input clause clauses');
        // First parameter is the object where we want to add the values and the second the new values to merge into the first object.
        return {
            clauseMap: (0, (/*@__PURE__*/$parcel$interopDefault($16aVR)))(nextResult.clauseMap, aggregate.clauseMap, (destValue, srcValue)=>srcValue.concat(destValue ?? [])),
            textSearchInputClause: aggregate.textSearchInputClause === undefined ? nextResult.textSearchInputClause : aggregate.textSearchInputClause
        };
    }
}

});
parcelRegister("4G98k", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedPickerType", () => $551a53a929efa123$export$fb7c01070886ad20);
$parcel$export(module.exports, "getPickerType", () => $551a53a929efa123$export$42840c00d43e8a94);

var $7jTnu = parcelRequire("7jTnu");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");

var $avTix = parcelRequire("avTix");
const $551a53a929efa123$export$fb7c01070886ad20 = ({ searchTemplate: searchTemplate, fieldType: fieldType })=>({
        searchTemplate: searchTemplate,
        fieldType: fieldType,
        pickerType: (0, $eqSys.PickerTypes).Unsupported,
        propType: (0, $eqSys.GenericPropTypes).NoProp
    });
const $551a53a929efa123$var$getPickerData = ({ searchTemplate: searchTemplate, fieldType: fieldType, pickerType: pickerType, propType: propType, fieldOperators: fieldOperators, simplifiedOperators: simplifiedOperators = false })=>({
        searchTemplate: searchTemplate,
        fieldType: fieldType,
        pickerType: pickerType,
        propType: propType,
        allowedOperators: (0, $avTix.getAllowedOperators)({
            pickerType: pickerType,
            fieldOperators: fieldOperators,
            propType: propType,
            simplifiedOperators: simplifiedOperators
        })
    });
const $551a53a929efa123$export$42840c00d43e8a94 = ({ searchTemplate: searchTemplate, fieldType: fieldType, operators: fieldOperators, simplifiedOperators: simplifiedOperators })=>{
    const commonAttributes = {
        searchTemplate: searchTemplate,
        fieldType: fieldType,
        fieldOperators: fieldOperators,
        simplifiedOperators: simplifiedOperators
    };
    switch(searchTemplate){
        case 'textFields':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Text,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'text':
        case 'summary':
        case 'description':
        case 'environment':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:textsearcher':
        case 'comment':
        case 'com.pyxis.greenhopper.jira:gh-epic-label-searcher':
        case 'jira.polaris:textsearcher':
        case 'com.atlassian.jira.ext.charting:textsearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).TextArea,
                propType: (0, $eqSys.TextAreaPropTypes).Text
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:exacttextsearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).TextArea,
                propType: (0, $eqSys.TextAreaPropTypes).ExactText
            });
        case 'created':
        case 'updated':
        case 'resolutiondate':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).DateTime,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:daterange':
        case 'statuscategorychangedate':
        case 'com.atlassian.jpo:jpo-custom-field-baseline-start-searcher':
        case 'com.atlassian.jpo:jpo-custom-field-baseline-end-searcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).DateTime,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'com.atlassian.jira.toolkit:LastCommentDateSearcher':
        case 'com.atlassian.jira.ext.charting:firstreponsedatesearcher':
        case 'com.atlassian.servicedesk:sd-request-feedback-date-searcher':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:datetimerange':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).DateTimeRange,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'duedate':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).DueDate,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'labels':
        case 'priority':
        case 'resolution':
        case 'status':
        case 'statusCategory':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:labelsearcher':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:multiselectsearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).Common
            });
        case 'journey':
            return (0, $7jTnu.fg)('jsm-journey-jql-builder-m1') ? $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).CommonWithEmpty
            }) : $551a53a929efa123$export$fb7c01070886ad20({
                searchTemplate: searchTemplate,
                fieldType: fieldType
            });
        case 'components':
        case 'parent':
        case 'com.pyxis.greenhopper.jira:gh-epic-link-searcher':
        case 'ticketCategory':
        case 'com.pyxis.greenhopper.jira:gh-epic-status-searcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).CommonWithEmpty
            });
        case 'versions':
        case 'fixVersions':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:versionsearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).Version
            });
        case 'assignee':
        case 'creator':
        case 'reporter':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).User
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:userpickergroupsearcher':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:next-gen-people-searcher':
        case 'com.atlassian.jira.toolkit:participantsearcher':
        case 'com.atlassian.jira.toolkit:lastparticipantsearcher':
        case 'com.atlassian.servicedesk:sd-request-participants-searcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).User
            });
        case 'issuetype':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).IssueType
            });
        case 'project':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:projectsearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).Project
            });
        case 'com.pyxis.greenhopper.jira:gh-sprint-searcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).Sprint
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:grouppickersearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).Group
            });
        case 0, $dTJxm.CASCADE_SELECT_FIELD_SEARCH_TEMPLATE:
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).CascadeSelect,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:exactnumber':
        case 'com.pyxis.greenhopper.jira:jsw-story-points-searcher':
        case 'jira.polaris:exact-number-searcher':
        case 'com.atlassian.servicedesk:sd-request-feedback-searcher':
        case 'com.atlassian.jira.toolkit:commentcountsearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).TextArea,
                propType: (0, $eqSys.TextAreaPropTypes).Number
            });
        case 'com.atlassian.jira.toolkit:lastcommentersearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).BooleanType,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'workratio':
        case 0, $dTJxm.NUMBER_RANGE_FIELD_SEARCH_TEMPLATE:
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).NumberRange,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 0, $dTJxm.CMDB_FIELD_SEARCH_TEMPLATE:
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).TextArea,
                propType: (0, $eqSys.TextAreaPropTypes).Aql
            });
        case 0, $dTJxm.JSM_REQUEST_TYPE_SEARCH_TEMPLATE:
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).CommonWithEmpty
            });
        case 0, $dTJxm.JSM_ORGANIZATIONS_SEARCH_TEMPLATE:
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).CommonWithEmpty
            });
        case 0, $dTJxm.JSM_WORK_CATEGORY_SEARCH_TEMPLATE:
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).CommonWithEmpty
            });
        default:
            return $551a53a929efa123$export$fb7c01070886ad20({
                searchTemplate: searchTemplate,
                fieldType: fieldType
            });
    }
};

});
parcelRegister("avTix", function(module, exports) {

$parcel$export(module.exports, "getAllowedOperators", () => $53df303d3ff15a5d$export$e56c61b51c1beb84);

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");

var $eiIzV = parcelRequire("eiIzV");
const $53df303d3ff15a5d$var$SIMPLIFIED_PICKER_ALLOWED_OPERATORS = [
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)),
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_IN))
];
const $53df303d3ff15a5d$var$PICKER_ALLOWED_OPERATORS = [
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)),
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_NOT_EQUALS)),
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_IN)),
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_NOT_IN)),
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_IS)),
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_IS_NOT))
];
const $53df303d3ff15a5d$var$TEXT_PICKER_ALLOWED_OPERATORS = [
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_LIKE))
];
const $53df303d3ff15a5d$export$362ce0c36f9a70b6 = (propType)=>{
    if (!(0, $eiIzV.isTextAreaPropType)(propType)) throw new Error(`Unsupported TextAreaPropType: ${propType}`);
    switch(propType){
        case (0, $eqSys.TextAreaPropTypes).Number:
        case (0, $eqSys.TextAreaPropTypes).ExactText:
            return [
                (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS))
            ];
        case (0, $eqSys.TextAreaPropTypes).Text:
            return [
                (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_LIKE))
            ];
        case (0, $eqSys.TextAreaPropTypes).Aql:
            return [
                (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_IN))
            ];
        default:
            throw new Error(`Unsupported TextAreaPropType: ${propType}`);
    }
};
const $53df303d3ff15a5d$var$DATE_PICKER_ALLOWED_OPERATORS = [
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_LT_EQUALS)),
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_GT_EQUALS))
];
const $53df303d3ff15a5d$var$CASCADE_SELECT_PICKER_ALLOWED_OPERATORS = [
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_IN)),
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS))
];
const $53df303d3ff15a5d$var$BOOLEAN_PICKER_ALLOWED_OPERATORS = [
    (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS))
];
const $53df303d3ff15a5d$var$getPickerOperators = (fieldOperators)=>$53df303d3ff15a5d$var$PICKER_ALLOWED_OPERATORS.filter((allowedOperator)=>fieldOperators.findIndex((fieldOperator)=>allowedOperator.value === fieldOperator) >= 0);
const $53df303d3ff15a5d$export$e56c61b51c1beb84 = ({ pickerType: pickerType, fieldOperators: fieldOperators = [], propType: propType = (0, $eqSys.GenericPropTypes).NoProp, simplifiedOperators: simplifiedOperators })=>{
    switch(pickerType){
        case (0, $eqSys.PickerTypes).Text:
            return $53df303d3ff15a5d$var$TEXT_PICKER_ALLOWED_OPERATORS;
        case (0, $eqSys.PickerTypes).TextArea:
            return $53df303d3ff15a5d$export$362ce0c36f9a70b6(propType);
        case (0, $eqSys.PickerTypes).DateTime:
        case (0, $eqSys.PickerTypes).DueDate:
        case (0, $eqSys.PickerTypes).DateTimeRange:
            return $53df303d3ff15a5d$var$DATE_PICKER_ALLOWED_OPERATORS;
        case (0, $eqSys.PickerTypes).Picker:
            return !simplifiedOperators ? $53df303d3ff15a5d$var$getPickerOperators(fieldOperators) : $53df303d3ff15a5d$var$SIMPLIFIED_PICKER_ALLOWED_OPERATORS;
        case (0, $eqSys.PickerTypes).CascadeSelect:
            return $53df303d3ff15a5d$var$CASCADE_SELECT_PICKER_ALLOWED_OPERATORS;
        case (0, $eqSys.PickerTypes).NumberRange:
            return (0, $dTJxm.NUMBER_RANGE_PICKER_ALLOWED_OPERATORS).map((op)=>(0, $f26C8.default).operator(op));
        case (0, $eqSys.PickerTypes).BooleanType:
            return $53df303d3ff15a5d$var$BOOLEAN_PICKER_ALLOWED_OPERATORS;
        default:
            return [];
    }
};

});


parcelRegister("bgVBN", function(module, exports) {

$parcel$export(module.exports, "UnsupportedRefinementError", () => $e453bb6cf708ace1$export$251a1c8599975384);
/**
 * This represents an error when trying to map a JQL AST to a collection of refinements supported by NIN. If the JAST
 * contains syntax or fields not supported by the refinement bar then this error will be thrown.
 */ class $e453bb6cf708ace1$export$251a1c8599975384 extends Error {
}

});


parcelRegister("cugAS", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedOperators", () => $81a39631283da7a2$export$4b9252b112620e15);

var $jPlb3 = parcelRequire("jPlb3");
const $81a39631283da7a2$var$UNSUPPORTED_OPERATORS = [
    ...(0, $jPlb3.CHANGED_OPERATORS),
    ...(0, $jPlb3.WAS_OPERATORS),
    ...(0, $jPlb3.WAS_IN_OPERATORS)
];
const $81a39631283da7a2$export$4b9252b112620e15 = ()=>$81a39631283da7a2$var$UNSUPPORTED_OPERATORS;

});


parcelRegister("22GDK", function(module, exports) {

$parcel$export(module.exports, "mapOperators", () => $f85bde50706c5a2f$export$ad17522432f44705);

var $jPlb3 = parcelRequire("jPlb3");
const $f85bde50706c5a2f$export$ad17522432f44705 = (jiraJqlOpeartor)=>{
    switch(jiraJqlOpeartor){
        case 'EQUALS':
            return 0, $jPlb3.OPERATOR_EQUALS;
        case 'NOT_EQUALS':
            return 0, $jPlb3.OPERATOR_NOT_EQUALS;
        case 'IS':
            return 0, $jPlb3.OPERATOR_IS;
        case 'IN':
            return 0, $jPlb3.OPERATOR_IN;
        case 'IS_NOT':
            return 0, $jPlb3.OPERATOR_IS_NOT;
        case 'NOT_IN':
            return 0, $jPlb3.OPERATOR_NOT_IN;
        case 'CONTAINS':
            return 0, $jPlb3.OPERATOR_LIKE;
        case 'DOES_NOT_CONTAIN':
            return 0, $jPlb3.OPERATOR_NOT_LIKE;
        case 'WAS_NOT_IN':
            return 0, $jPlb3.OPERATOR_WAS_NOT_IN;
        case 'WAS_NOT':
            return 0, $jPlb3.OPERATOR_WAS_NOT;
        case 'WAS_IN':
            return 0, $jPlb3.OPERATOR_WAS_IN;
        case 'WAS':
            return 0, $jPlb3.OPERATOR_WAS;
        case 'CHANGED':
            return 0, $jPlb3.OPERATOR_CHANGED;
        case 'GREATER_THAN':
            return 0, $jPlb3.OPERATOR_GT;
        case 'GREATER_THAN_OR_EQUAL':
            return 0, $jPlb3.OPERATOR_GT_EQUALS;
        case 'LESS_THAN':
            return 0, $jPlb3.OPERATOR_LT;
        case 'LESS_THAN_OR_EQUAL':
            return 0, $jPlb3.OPERATOR_LT_EQUALS;
        default:
            throw new Error(`Operator ${jiraJqlOpeartor} not supported`);
    }
};

});

parcelRegister("5fhUb", function(module, exports) {

$parcel$export(module.exports, "JQL_BUILDER_PERFORMANCE_MARKS", () => $f65791ff64431993$export$5fd6d8ece357700d);
// Performance marks
const $f65791ff64431993$var$JQL_BUILDER_START = 'JQL_BUILDER_START';
const $f65791ff64431993$var$JQL_BUILDER_END = 'JQL_BUILDER_END';
const $f65791ff64431993$var$JQL_BUILDER_HYDRATE_START = 'JQL_BUILDER_HYDRATE_START';
const $f65791ff64431993$var$JQL_BUILDER_HYDRATE_END = 'JQL_BUILDER_HYDRATE_END';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_START = 'JQL_BUILDER_BASIC_START';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_END = 'JQL_BUILDER_BASIC_END';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_START = 'JQL_BUILDER_BASIC_JS_START';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_END = 'JQL_BUILDER_BASIC_JS_END';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_START = 'JQL_BUILDER_ADVANCED_START';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_END = 'JQL_BUILDER_ADVANCED_END';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_START = 'JQL_BUILDER_ADVANCED_JS_START';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_END = 'JQL_BUILDER_ADVANCED_JS_END';
const $f65791ff64431993$export$5fd6d8ece357700d = {
    JQL_BUILDER_START: /**
	 * JQL_BUILDER
	 * Count how long it takes to load the JQL Builder,
	 * from first render of async component to ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_START,
    JQL_BUILDER_END: $f65791ff64431993$var$JQL_BUILDER_END,
    JQL_BUILDER_HYDRATE_START: /**
	 * JQL_BUILDER_HYDRATE
	 * Count how long it takes from first try to use hydrated data
	 * to the momento is actually ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_HYDRATE_START,
    JQL_BUILDER_HYDRATE_END: $f65791ff64431993$var$JQL_BUILDER_HYDRATE_END,
    JQL_BUILDER_BASIC_JS_START: /**
	 * JQL_BUILDER_BASIC_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Basic js package
	 */ $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_START,
    JQL_BUILDER_BASIC_JS_END: $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_END,
    JQL_BUILDER_BASIC_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Basic,
	 * from first render of async basic component to ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_BASIC_START,
    JQL_BUILDER_BASIC_END: $f65791ff64431993$var$JQL_BUILDER_BASIC_END,
    JQL_BUILDER_ADVANCED_JS_START: /**
	 * JQL_BUILDER_ADVANCED_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Advanced js package
	 */ $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_START,
    JQL_BUILDER_ADVANCED_JS_END: $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_END,
    JQL_BUILDER_ADVANCED_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Advnaced,
	 * from first render of async advanced component to ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_ADVANCED_START,
    JQL_BUILDER_ADVANCED_END: $f65791ff64431993$var$JQL_BUILDER_ADVANCED_END
};

});


parcelRegister("cX22j", function(module, exports) {

$parcel$export(module.exports, "SelectedSearchModeContainer", () => $86935b0bddd08828$export$d19caa48d475b9e3);
$parcel$export(module.exports, "SingleSearchModeContainer", () => $86935b0bddd08828$export$a70c1ee31d8bd058);
$parcel$export(module.exports, "useSelectedSearchMode", () => $86935b0bddd08828$export$af5effaed2abb303);

var $eJOHy = parcelRequire("eJOHy");

var $j9mbu = parcelRequire("j9mbu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $56qWy = parcelRequire("56qWy");

var $70el7 = parcelRequire("70el7");
const $86935b0bddd08828$var$getSafeSearchMode = (mode)=>{
    switch(mode){
        case 0, $56qWy.SEARCH_MODE_BASIC:
            return 0, $56qWy.SEARCH_MODE_BASIC;
        case 0, $56qWy.SEARCH_MODE_ADVANCED:
            return 0, $56qWy.SEARCH_MODE_ADVANCED;
        default:
            return undefined;
    }
};
const $86935b0bddd08828$var$SelectedSearchModeContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    searchMode: (0, $56qWy.DEFAULT_SEARCH_MODE),
    setSelectedSearchMode: ()=>null
});
const $86935b0bddd08828$var$getValidSelectedSearchMode = (searchMode, querySupported)=>{
    if (searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED)) return 0, $56qWy.SEARCH_MODE_ADVANCED;
    if (searchMode === (0, $56qWy.SEARCH_MODE_BASIC) && querySupported) return 0, $56qWy.SEARCH_MODE_BASIC;
    return 0, $56qWy.SEARCH_MODE_ADVANCED;
};
const $86935b0bddd08828$export$d19caa48d475b9e3 = ({ children: children, searchMode: searchMode, onSearchModeChange: onSearchModeChange })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { querySupported: querySupported } = (0, $70el7.useIsQuerySupported)();
    (0, $j9mbu.useRunOnce)(()=>{
        // Send analytics on inital load (like when you open a url with a query too complex)
        if (!querySupported && searchMode !== (0, $56qWy.SEARCH_MODE_ADVANCED)) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'queryTooComplex triggered', {
            searchMode: searchMode
        });
    });
    const [searchModeInternal, setSearchModeInternal] = (0, $eJOHy.useState)($86935b0bddd08828$var$getValidSelectedSearchMode(searchMode, querySupported));
    if (!querySupported && searchModeInternal !== (0, $56qWy.SEARCH_MODE_ADVANCED)) {
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'queryTooComplex triggered', {
            searchMode: searchModeInternal
        });
        setSearchModeInternal((0, $56qWy.SEARCH_MODE_ADVANCED));
    }
    (0, $eJOHy.useEffect)(()=>{
        if (!querySupported && searchMode === (0, $56qWy.SEARCH_MODE_BASIC) && searchModeInternal === (0, $56qWy.SEARCH_MODE_ADVANCED)) onSearchModeChange?.((0, $56qWy.SEARCH_MODE_ADVANCED), 'QueryUnsupported');
    }, [
        onSearchModeChange,
        querySupported,
        searchMode,
        searchModeInternal
    ]);
    const setSelectedSearchMode = (0, $eJOHy.useCallback)((newSearchMode, userTriggered)=>{
        const safeSearchMode = $86935b0bddd08828$var$getSafeSearchMode(newSearchMode);
        if (!safeSearchMode) return;
        setSearchModeInternal(safeSearchMode);
        onSearchModeChange?.(safeSearchMode, userTriggered ? 'UserTriggered' : 'ExternalTriggered');
        if (userTriggered) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'switchJQLEditor', {
            switchToEditor: (0, $56qWy.mapSearchModeToAnalyticAtribute)[safeSearchMode]
        });
    }, [
        createAnalyticsEvent,
        onSearchModeChange
    ]);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            searchMode: searchModeInternal,
            setSelectedSearchMode: setSelectedSearchMode
        }), [
        searchModeInternal,
        setSelectedSearchMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($86935b0bddd08828$var$SelectedSearchModeContext.Provider, {
        value: contextValue
    }, children);
};
const $86935b0bddd08828$export$a70c1ee31d8bd058 = ({ children: children, searchMode: searchMode })=>{
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            searchMode: searchMode,
            setSelectedSearchMode: ()=>null
        }), [
        searchMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($86935b0bddd08828$var$SelectedSearchModeContext.Provider, {
        value: contextValue
    }, children);
};
const $86935b0bddd08828$export$af5effaed2abb303 = ()=>(0, $eJOHy.useContext)($86935b0bddd08828$var$SelectedSearchModeContext);

});
parcelRegister("j9mbu", function(module, exports) {

$parcel$export(module.exports, "useRunOnce", () => $889f0a6dfaaee3b5$export$a3576ea6e6df583c);

var $eJOHy = parcelRequire("eJOHy");
const $889f0a6dfaaee3b5$export$a3576ea6e6df583c = (cb, identifier)=>{
    const ref = (0, $eJOHy.useRef)(true);
    const identifierRef = (0, $eJOHy.useRef)(identifier);
    if (identifierRef.current !== identifier) {
        ref.current = true;
        identifierRef.current = identifier;
    }
    if (ref.current) cb();
    ref.current = false;
};

});


parcelRegister("b2CbD", function(module, exports) {

$parcel$export(module.exports, "useSearchModeMutation", () => $ef4d773a3cb60086$export$f4f7ced39b30a5ad);

var $g3Cs9 = parcelRequire("g3Cs9");

var $ekTTy = parcelRequire("ekTTy");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $kEUB1 = parcelRequire("kEUB1");

var $cECwI = parcelRequire("cECwI");

var $56qWy = parcelRequire("56qWy");

var $gQyru = parcelRequire("gQyru");
const $ef4d773a3cb60086$var$SEARCH_MODE_KEY_IN_RELAY_STORE = 'jqlBuilderSearchMode';
/**
 * Simple updater util function for setting the user's preferred JQL Search mode
 * in the Relay store when a mutation was either successful or failed - we update the
 * store regardless so that the search mode does not spontaneously change when
 * switching between the AI container search modes.
 */ const $ef4d773a3cb60086$var$relayStoreUpdater = (store, userPreferencesData, searchMode)=>{
    if (typeof userPreferencesData?.__id === 'string') {
        const record = store.get(userPreferencesData.__id);
        record?.setValue(searchMode, $ef4d773a3cb60086$var$SEARCH_MODE_KEY_IN_RELAY_STORE);
    }
};
const $ef4d773a3cb60086$export$f4f7ced39b30a5ad = (userPreferences)=>{
    /*
   * TODO
   * Why is there a relay fragment in a hook?!
   * Right now, we manually update the `jqlBuilderSearchMode` record in relay store.
   * We update it manually because the field is not a Node type and hence Relay cannot
   * automatically manage the store state for us.
   * Instead, we need to manually grab the __id, find the record and update it with the
   * mutation value so that the two are kept in sync.
   * This is a temporary measure until the graphQL schema is updated.
   * The fragment is in the hook for convenience, this hook is only called from
   * one component: `src/packages/jql-builder/src/ui/index.tsx`
   * In fact we can probably move this hook back into a UI component potentially.
   */ const userPreferencesData = (0, $j4oe4.useFragment)((0, $ekTTy.default), userPreferences || null);
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $g3Cs9.default));
    return (0, $eJOHy.useCallback)((mode)=>{
        if (!isAnonymous) {
            const serverSearchMode = (0, $gQyru.toServerSearchMode)(mode);
            commitMutation({
                variables: {
                    cloudId: cloudId,
                    searchMode: (0, $gQyru.toServerSearchMode)(mode)
                },
                onError: (error)=>{
                    (0, $gYnSx.default)({
                        sendToPrivacyUnsafeSplunk: true,
                        error: error,
                        meta: {
                            id: 'mainSelectedJqlBuilderModeMutation',
                            packageName: (0, $56qWy.PACKAGE_NAME),
                            teamName: (0, $56qWy.TEAM_NAME)
                        }
                    });
                    (0, $j4oe4.commitLocalUpdate)(environment, (store)=>$ef4d773a3cb60086$var$relayStoreUpdater(store, userPreferencesData ?? null, serverSearchMode));
                },
                updater: (store)=>$ef4d773a3cb60086$var$relayStoreUpdater(store, userPreferencesData ?? null, serverSearchMode)
            });
        }
    }, [
        cloudId,
        commitMutation,
        environment,
        isAnonymous,
        userPreferencesData
    ]);
};

});
parcelRegister("g3Cs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $478a7af77749c321$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e7a4f9b2c7ea46621cd664591e142a2b>>
 * @relayHash 5d62b62066d2e4341b25445f5710faf6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea28f854d9d34cb357f7b0a2d32ddcfaabb301d65019ccde74b53cf76b1aeb39
const $478a7af77749c321$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchMode"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "searchMode",
                                    "variableName": "searchMode"
                                }
                            ],
                            "concreteType": "JiraJQLBuilderSearchModeMutationPayload",
                            "kind": "LinkedField",
                            "name": "setJQLBuilderSearchMode",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "userSearchMode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "searchModeJqlBuilder_updateJQLBuilderSearchModeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "searchModeJqlBuilder_updateJQLBuilderSearchModeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "ea28f854d9d34cb357f7b0a2d32ddcfaabb301d65019ccde74b53cf76b1aeb39",
            "metadata": {},
            "name": "searchModeJqlBuilder_updateJQLBuilderSearchModeMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$478a7af77749c321$var$node.hash = "92ba3afb837dca41d4ee89012d43ffd1";
var $478a7af77749c321$export$2e2bcd8739ae039 = $478a7af77749c321$var$node;

});

parcelRegister("ekTTy", function(module, exports) {

$parcel$export(module.exports, "default", () => $06e1b29d8bdd078d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c834bed95690edeb5b5d9f5778b02b05>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $06e1b29d8bdd078d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchMode_useSearchMode_JQLBuilder",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraUserPreferences"
};
$06e1b29d8bdd078d$var$node.hash = "b610d5310493b4f35efc509255a102c4";
var $06e1b29d8bdd078d$export$2e2bcd8739ae039 = $06e1b29d8bdd078d$var$node;

});


parcelRegister("lw8qf", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderFallback", () => $05cda189142557bf$export$61e39bbfd9e09552);

var $eJOHy = parcelRequire("eJOHy");

var $k8Hie = parcelRequire("k8Hie");
var $c5g9h = parcelRequire("c5g9h");

var $6MO8n = parcelRequire("6MO8n");

var $4GZBG = parcelRequire("4GZBG");

var $9JtRn = parcelRequire("9JtRn");

var $6zXPf = parcelRequire("6zXPf");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $56qWy = parcelRequire("56qWy");

var $6bDCV = parcelRequire("6bDCV");

var $9HnR3 = parcelRequire("9HnR3");

var $cOgRS = parcelRequire("cOgRS");

var $7bFFO = parcelRequire("7bFFO");

var $7ebli = parcelRequire("7ebli");

var $jn1oF = parcelRequire("jn1oF");
const $05cda189142557bf$export$61e39bbfd9e09552 = ({ selectedSearchMode: selectedSearchMode, searchModes: searchModes, query: query, onLoad: onLoad, isSearchModeToggleEnabled: isSearchModeToggleEnabled, renderExtraControls: renderExtraControls, beforeControls: beforeControls, excludedFields: excludedFields, components: components, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation = (0, $56qWy.SEARCH_MODE_SWITCHER_LEFT_LOCATION), showOrderByPicker: showOrderByPicker })=>{
    const onJqlBuilderBasicLoad = (0, $eJOHy.useCallback)(()=>{
        onLoad && onLoad((0, $56qWy.SEARCH_MODE_BASIC));
    }, [
        onLoad
    ]);
    const searchModeCandidate = (0, $eJOHy.useMemo)(()=>{
        if (selectedSearchMode === (0, $56qWy.SEARCH_MODE_ADVANCED)) return 0, $56qWy.SEARCH_MODE_ADVANCED;
        return (0, $9JtRn.isQueryTooComplex)({
            jql: query,
            excludedFields: excludedFields,
            shouldValidateOperators: false,
            hideTextSearchInput: hideTextSearchInput
        }) ? (0, $56qWy.SEARCH_MODE_ADVANCED) : (0, $56qWy.SEARCH_MODE_BASIC);
    }, [
        excludedFields,
        hideTextSearchInput,
        query,
        selectedSearchMode
    ]);
    /**
	 * ⚠️ This code contains architectural problems that now occur since JQL Builder being used in pages
	 * other than NIN. Since the introduction of `searchModes`, situations can arise where the
	 * computed searchMode may not exist in the available options set in `searchModes[]`. For example
	 * when `searchModes === ['basic']` but the computed search mode is set to `advanced` due to
	 * a query being too complex - LDR to do: https://hello.atlassian.net/l/cp/YrdVZ0fa
	 */ const searchMode = (0, $eJOHy.useMemo)(()=>{
        let resolvedSearchMode = searchModeCandidate;
        if (!searchModes?.length) resolvedSearchMode = searchModeCandidate;
        else resolvedSearchMode = searchModes.includes(searchModeCandidate) ? searchModeCandidate : searchModes[0];
        // Preload package depending on the resolved search mode
        if (resolvedSearchMode === (0, $56qWy.SEARCH_MODE_ADVANCED)) (0, $c5g9h.preloadJQLEditor)();
        else if (!(0, $7jTnu.fg)('render_jql_builder_in_ssr')) // @deprecated render_jql_builder_in_ssr will load JQL Builder basic mode sync
        (0, $6MO8n.preloadJqlBuilderBasic)();
        return resolvedSearchMode;
    }, [
        searchModes,
        searchModeCandidate
    ]);
    (0, $eJOHy.useEffect)(()=>{
        searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED) && onLoad && onLoad((0, $56qWy.SEARCH_MODE_ADVANCED));
    }, [
        onLoad,
        searchMode
    ]);
    const BeforeJqlBuilderContainerComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.BeforeJqlBuilderContainer) : (0, $7ebli.BeforeJqlBuilderContainerOld);
    const BeforeJqlBuilderListItemContainerComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.BeforeJqlBuilderListItemContainer) : (0, $7ebli.BeforeJqlBuilderListItemContainerOld);
    const AdvancedEditorWrapperComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.AdvancedEditorWrapper) : (0, $7ebli.AdvancedEditorWrapperOld);
    const jqlBuilderFallbackComponent = searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k8Hie.JQLEditorReadOnly), {
        isCompact: true,
        isSearch: true,
        query: query
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GZBG.JQLBuilderBasicFallback), {
        query: query,
        excludedFields: excludedFields,
        onLoad: onJqlBuilderBasicLoad,
        shouldUseListMarkup: true,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker
    });
    const { SearchModeSwitcher: SearchModeSwitcher = (0, $9HnR3.SearchModeSwitcher) } = components ?? {};
    const BeforeJqlBuilderWrapper = searchMode === (0, $56qWy.SEARCH_MODE_BASIC) ? BeforeJqlBuilderListItemContainerComponent : BeforeJqlBuilderContainerComponent;
    const isSearchModeSwitcherOnLeft = searchModeSwitcherLocation === (0, $56qWy.SEARCH_MODE_SWITCHER_LEFT_LOCATION) && (0, $6zXPf.getWillShowNav4)();
    const searchModeSwitcherComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7bFFO.SearchModeSwitcherContainer), {
        testId: "jql-builder.ui.jql-builder-fallback.toggle-container",
        isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SearchModeSwitcher, {
        searchMode: searchMode,
        isBasicModeDisabled: false,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onUpdateSearchMode: ()=>{}
    }));
    const editorContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, beforeControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BeforeJqlBuilderWrapper, null, beforeControls), isSearchModeToggleEnabled && isSearchModeSwitcherOnLeft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BeforeJqlBuilderWrapper, null, searchModeSwitcherComponent), jqlBuilderFallbackComponent, renderExtraControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jn1oF.default), {
        searchMode: searchMode,
        renderExtraControls: renderExtraControls,
        shouldUseListMarkup: searchMode === (0, $56qWy.SEARCH_MODE_BASIC)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.Container), {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "jql-builder",
        "data-vc": `jql-builder-fallback${false ? '-ssr' : ''}`,
        ...false && {
            'data-ssr-placeholder': 'jql-builder-fallback-placeholder'
        },
        ...!false && {
            'data-ssr-placeholder-replace': 'jql-builder-fallback-placeholder'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cOgRS.DefaultJqlBuilderContainer), {
        showAdvancedEditor: searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED)
    }, searchMode === (0, $56qWy.SEARCH_MODE_BASIC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.BasicEditorListContainer), {
        "data-testid": "jql-builder.ui.jql-builder-fallback.basic-editor-list-container"
    }, editorContent) : editorContent), isSearchModeToggleEnabled && !isSearchModeSwitcherOnLeft && searchModeSwitcherComponent);
};

});
parcelRegister("k8Hie", function(module, exports) {

$parcel$export(module.exports, "JQLEditorReadOnly", () => $bbee1dd6c095c056$export$96157d0351f40cdc);
$parcel$export(module.exports, "default", () => $bbee1dd6c095c056$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $lkATK = parcelRequire("lkATK");

var $eU8L7 = parcelRequire("eU8L7");

var $1eYfD = parcelRequire("1eYfD");

var $4GY8V = parcelRequire("4GY8V");
const $bbee1dd6c095c056$var$JQLEditorLayout = (props)=>{
    const { defaultMaxRows: defaultMaxRows, expandedRows: expandedRows, isSearch: isSearch, isCompact: isCompact } = (0, $lkATK.useEditorThemeContext)();
    const { editorViewHasFocus: editorViewHasFocus, EditorControlsContent: EditorControlsContent, EditorFooterContent: EditorFooterContent, editorViewIsInvalid: editorViewIsInvalid, lineNumbersVisible: lineNumbersVisible, mainId: mainId, onEditorMainRef: onEditorMainRef, onEditorViewContainerRef: onEditorViewContainerRef, onEditorViewContainerScroll: onEditorViewContainerScroll, onEditorViewRef: onEditorViewRef, onEditorViewBlur: onEditorViewBlur, onEditorViewFocus: onEditorViewFocus, onEditorViewTransitionEnd: onEditorViewTransitionEnd } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $4GY8V.EditorMain), {
        id: mainId,
        ref: onEditorMainRef,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $4GY8V.EditorViewContainer), {
                editorViewHasFocus: editorViewHasFocus,
                editorViewIsInvalid: editorViewIsInvalid,
                ref: onEditorViewContainerRef,
                onScroll: onEditorViewContainerScroll,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GY8V.LineNumberToolbar), {
                        lineNumbersVisible: lineNumbersVisible
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GY8V.EditorView), {
                        defaultMaxRows: defaultMaxRows,
                        expandedRows: expandedRows,
                        isCompact: isCompact,
                        lineNumbersVisible: lineNumbersVisible,
                        ref: onEditorViewRef,
                        onBlur: onEditorViewBlur,
                        onFocus: onEditorViewFocus,
                        onTransitionEnd: onEditorViewTransitionEnd
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GY8V.EditorControls), {
                        isSearch: isSearch,
                        isCompact: isCompact,
                        isVisualRefresh: (0, $eGOwo.fg)('platform-component-visual-refresh'),
                        children: EditorControlsContent
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GY8V.EditorFooter), {
                children: EditorFooterContent
            })
        ]
    });
};
/**
 * A read only version of the JQL Editor which mimics the layout of the complete component, suitable as an intermediary
 * state when rendering the editor asynchronously.
 * In order to minimise bundle size impact on consumers, it is critical that this component (and any child component)
 * only imports the bare minimum dependencies required to replicate the editor layout.
 */ const $bbee1dd6c095c056$var$JQLEditorReadOnlyWithoutTheme = ({ query: query })=>{
    const { defaultMaxRows: defaultMaxRows, expandedRows: expandedRows, isSearch: isSearch, isCompact: isCompact } = (0, $lkATK.useEditorThemeContext)();
    const blocks = (0, $eU8L7.splitTextByNewLine)(query);
    const lineNumbersVisible = blocks.length > 1;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $4GY8V.EditorMain), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $4GY8V.ReadOnlyEditorViewContainer), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GY8V.LineNumberToolbar), {
                        lineNumbersVisible: lineNumbersVisible
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GY8V.ReadOnlyEditorView), {
                        "data-testid": "jql-editor-read-only",
                        role: "combobox",
                        "aria-readonly": true,
                        defaultMaxRows: defaultMaxRows,
                        expandedRows: expandedRows,
                        lineNumbersVisible: lineNumbersVisible,
                        isCompact: isCompact,
                        // aria-expanded and aria-controls here are placeholders only. This is to avoid a11y violations.
                        // This component JQLEditorReadOnlyWithoutTheme is only a loading state
                        // Therefore the autocomplete combobox is never shown to the users
                        "aria-expanded": false,
                        "aria-controls": "dummy-jql-editor-auto-complete-id",
                        "aria-label": "JQL query",
                        children: blocks.map((block, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                                as: "p",
                                children: block
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GY8V.EditorControls), {
                        isSearch: isSearch,
                        isCompact: isCompact,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1eYfD.ReadOnlyControlsContent), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4GY8V.EditorFooter), {})
        ]
    });
};
const $bbee1dd6c095c056$export$96157d0351f40cdc = ({ isSearch: isSearch, isCompact: isCompact, ...props })=>{
    const editorTheme = (0, $lkATK.useEditorTheme)({
        isSearch: isSearch,
        isCompact: isCompact
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lkATK.EditorThemeContext).Provider, {
        value: editorTheme,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($bbee1dd6c095c056$var$JQLEditorReadOnlyWithoutTheme, {
            ...props
        })
    });
};
var $bbee1dd6c095c056$export$2e2bcd8739ae039 = $bbee1dd6c095c056$var$JQLEditorLayout;

});
parcelRegister("lkATK", function(module, exports) {

$parcel$export(module.exports, "EditorThemeContext", () => $8e9f080f7cd2aef6$export$fc25b324c910bbf4);
$parcel$export(module.exports, "useEditorTheme", () => $8e9f080f7cd2aef6$export$c119185e316114b3);
$parcel$export(module.exports, "useEditorThemeContext", () => $8e9f080f7cd2aef6$export$cf804716df5ed454);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $8e9f080f7cd2aef6$var$defaultMaxRows = 3;
const $8e9f080f7cd2aef6$var$expandedRows = 15;
const $8e9f080f7cd2aef6$var$defaultEditorTheme = {
    defaultMaxRows: $8e9f080f7cd2aef6$var$defaultMaxRows,
    expanded: false,
    expandedRows: $8e9f080f7cd2aef6$var$expandedRows,
    toggleExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    isSearch: false,
    isCompact: false
};
const $8e9f080f7cd2aef6$export$fc25b324c910bbf4 = (0, $eJOHy.createContext)($8e9f080f7cd2aef6$var$defaultEditorTheme);
const $8e9f080f7cd2aef6$export$c119185e316114b3 = ({ isSearch: isSearch = false, isCompact: isCompact = false })=>{
    const [expanded, setExpanded] = (0, $eJOHy.useState)(false);
    const toggleExpanded = (0, $eJOHy.useCallback)(()=>setExpanded((prevState)=>!prevState), []);
    return (0, $eJOHy.useMemo)(()=>({
            defaultMaxRows: $8e9f080f7cd2aef6$var$defaultMaxRows,
            expanded: expanded,
            expandedRows: $8e9f080f7cd2aef6$var$expandedRows,
            toggleExpanded: toggleExpanded,
            isSearch: isSearch,
            isCompact: isCompact
        }), [
        expanded,
        toggleExpanded,
        isSearch,
        isCompact
    ]);
};
const $8e9f080f7cd2aef6$export$cf804716df5ed454 = ()=>(0, $eJOHy.useContext)($8e9f080f7cd2aef6$export$fc25b324c910bbf4);

});

parcelRegister("eU8L7", function(module, exports) {

$parcel$export(module.exports, "splitTextByNewLine", () => $25da2ec5754fc6a0$export$ccd327fb940bd525);
/**
 * Splits the provided text by new line characters.
 */ const $25da2ec5754fc6a0$export$ccd327fb940bd525 = (text)=>text.split(/(?:\r\n?|\n)/);

});

parcelRegister("1eYfD", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyControlsContent", () => $523d0da7f63261f4$export$26cf64f30d6cc7f3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $lkATK = parcelRequire("lkATK");

var $liMX9 = parcelRequire("liMX9");

var $8VTHV = parcelRequire("8VTHV");

var $cqdbH = parcelRequire("cqdbH");
const $523d0da7f63261f4$export$26cf64f30d6cc7f3 = ()=>{
    const { isSearch: isSearch } = (0, $lkATK.useEditorThemeContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $liMX9.BaseExpandToggle), {
                // The label here is for avoiding a11y violations only
                // This component ReadOnlyControlsContent is only used as a fallback for a loading state
                label: 'Editor',
                editorId: '',
                expanded: false,
                onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                isDisabled: true
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cqdbH.BaseSyntaxHelp), {
                label: '',
                onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                isDisabled: true
            }),
            isSearch && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8VTHV.BaseSearch), {
                // The label here is for avoiding a11y violations only
                // This component ReadOnlyControlsContent is only used as a fallback for a loading state
                label: 'Search',
                onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                isDisabled: true
            })
        ]
    });
};

});
parcelRegister("liMX9", function(module, exports) {

$parcel$export(module.exports, "BaseExpandToggle", () => $81ae13f5c5dc220c$export$651ea466a727285d);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $Ay1uj = parcelRequire("Ay1uj");

var $XhTSt = parcelRequire("XhTSt");

var $idu5j = parcelRequire("idu5j");

var $2F5b6 = parcelRequire("2F5b6");

var $8lWE8 = parcelRequire("8lWE8");

var $eGOwo = parcelRequire("eGOwo");


var $2hsyM = parcelRequire("2hsyM");
// Atlaskit doesn't provide a circle variation of the expand/collapse icons so we have to implement our own
const $81ae13f5c5dc220c$var$ExpandCircleIcon = ({ isDisabled: isDisabled })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($XhTSt))), {
        label: '',
        LEGACY_size: 'small',
        color: isDisabled ? `var(--ds-icon-disabled, ${0, $7bb4c1736002a04a$export$8754fc7e6d8b3000})` : `var(--ds-icon, ${0, $7bb4c1736002a04a$export$c39c0fe0f26207ae})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2F5b6)))
    });
const $81ae13f5c5dc220c$var$CollapseCircleIcon = ({ isDisabled: isDisabled })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($idu5j))), {
        label: '',
        LEGACY_size: 'small',
        color: isDisabled ? `var(--ds-icon-disabled, ${0, $7bb4c1736002a04a$export$8754fc7e6d8b3000})` : `var(--ds-icon, ${0, $7bb4c1736002a04a$export$c39c0fe0f26207ae})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8lWE8)))
    });
const $81ae13f5c5dc220c$export$651ea466a727285d = ({ expanded: expanded, editorId: editorId, isDisabled: isDisabled, label: label, onClick: onClick })=>{
    let Icon;
    if (expanded) Icon = $81ae13f5c5dc220c$var$CollapseCircleIcon;
    else Icon = $81ae13f5c5dc220c$var$ExpandCircleIcon;
    return (0, $eGOwo.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
        appearance: 'subtle',
        spacing: "compact",
        "aria-expanded": expanded,
        "aria-controls": editorId,
        label: label,
        isDisabled: isDisabled,
        onClick: onClick,
        icon: expanded ? (0, (/*@__PURE__*/$parcel$interopDefault($idu5j))) : (0, (/*@__PURE__*/$parcel$interopDefault($XhTSt)))
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2hsyM.ExpandToggleContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
            appearance: 'subtle',
            "aria-expanded": expanded,
            "aria-controls": editorId,
            "aria-label": label,
            isDisabled: isDisabled,
            spacing: 'none',
            onClick: onClick,
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                isDisabled: isDisabled
            })
        })
    });
};

});
parcelRegister("XhTSt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fa3a459488ae98c9a4dea821f09e885>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b23656b9dea9ae5$var$_react = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0b23656b9dea9ae5$var$_baseNew = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0b23656b9dea9ae5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b23656b9dea9ae5$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0b23656b9dea9ae5$var$_react.default.createElement($0b23656b9dea9ae5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$0b23656b9dea9ae5$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $0b23656b9dea9ae5$var$_default = module.exports.default = $0b23656b9dea9ae5$var$GrowDiagonalIcon;

});

parcelRegister("idu5j", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5830a86fa64b71ea84cc4eb2a6e1075>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d430c71ad3f6d10b$var$_react = $d430c71ad3f6d10b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d430c71ad3f6d10b$var$_baseNew = $d430c71ad3f6d10b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d430c71ad3f6d10b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d430c71ad3f6d10b$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $d430c71ad3f6d10b$var$_react.default.createElement($d430c71ad3f6d10b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.72 6.22 13.97.97l1.06 1.06-5.25 5.25zM7.28 9.78l-5.25 5.25-1.06-1.06 5.25-5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M10 6V2H8.5v4.75c0 .414.336.75.75.75H14V6zM2 8.5h4.75a.75.75 0 0 1 .75.75V14H6v-4H2z" clip-rule="evenodd"/>`
    }, props));
$d430c71ad3f6d10b$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $d430c71ad3f6d10b$var$_default = module.exports.default = $d430c71ad3f6d10b$var$ShrinkDiagonalIcon;

});

parcelRegister("2F5b6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f036d580202d537$var$_react = $1f036d580202d537$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1f036d580202d537$var$_growDiagonal = $1f036d580202d537$var$_interopRequireDefault((parcelRequire("XhTSt")));
function $1f036d580202d537$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f036d580202d537$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $1f036d580202d537$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $1f036d580202d537$var$_growDiagonal.default
    }));
$1f036d580202d537$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $1f036d580202d537$var$_default = module.exports.default = $1f036d580202d537$var$MediaServicesActualSizeIcon;

});

parcelRegister("8lWE8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $614dc6da480803f7$var$_react = $614dc6da480803f7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $614dc6da480803f7$var$_shrinkDiagonal = $614dc6da480803f7$var$_interopRequireDefault((parcelRequire("idu5j")));
function $614dc6da480803f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $614dc6da480803f7$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $614dc6da480803f7$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
    }, props, {
        newIcon: $614dc6da480803f7$var$_shrinkDiagonal.default
    }));
$614dc6da480803f7$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $614dc6da480803f7$var$_default = module.exports.default = $614dc6da480803f7$var$MediaServicesFitToPageIcon;

});

parcelRegister("2hsyM", function(module, exports) {

$parcel$export(module.exports, "ExpandToggleContainer", () => $30377d302550d1cd$export$e6d67f4f78864edc);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $aWILV = parcelRequire("aWILV");
const $30377d302550d1cd$export$e6d67f4f78864edc = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1cnrddf0"
})({
    /* Override background styles for our button to match designs */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> button': {
        borderRadius: '100%',
        /* Fill the remaining vertical space for a single line in our editor and space between buttons */ margin: `${"var(--ds-space-050, 4px)"} 0`,
        '&:hover': {
            background: `var(--ds-background-neutral-subtle-hovered, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&:active, &[data-firefox-is-active='true']": {
            background: `var(--ds-background-neutral-subtle-pressed, ${(0, $7bb4c1736002a04a$export$8754fc7e6d8b3000)})`
        }
    }
});

});


parcelRegister("8VTHV", function(module, exports) {

$parcel$export(module.exports, "BaseSearch", () => $c17f795fc901b8fd$export$c3a2772f8bfd85f4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cA0Y2 = parcelRequire("cA0Y2");

var $Ay1uj = parcelRequire("Ay1uj");

var $dqx2X = parcelRequire("dqx2X");

var $eGOwo = parcelRequire("eGOwo");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $c17f795fc901b8fd$var$style = {
    // Fixes an issue where loading button makes the editor flicker with a scrollbar
    overflow: 'hidden'
};
// Fixes icon margin issus after new icon migration
const $c17f795fc901b8fd$var$iconStyle = (0, $1DXK0.xcss)({
    margin: 'space.050',
    display: 'flex'
});
// Fixes an issue where loading button makes the editor flicker with a scrollbar
const $c17f795fc901b8fd$var$buttonContainerStyle = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});
const $c17f795fc901b8fd$export$c3a2772f8bfd85f4 = ({ isDisabled: isDisabled, isSearching: isSearching, label: label, onSearch: onSearch })=>{
    // Prevent click events being repeatedly fired if the Enter key is held down.
    const preventRepeatClick = (0, $eJOHy.useCallback)((e)=>{
        if (e.key === 'Enter' && e.repeat) e.preventDefault();
    }, []);
    return (0, $eGOwo.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
            xcss: $c17f795fc901b8fd$var$buttonContainerStyle,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                label: label,
                isDisabled: isDisabled,
                testId: "jql-editor-search",
                appearance: "default",
                spacing: "compact",
                onClick: onSearch,
                onKeyDown: preventRepeatClick,
                isLoading: isSearching,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($dqx2X))),
                ...(0, $eGOwo.fg)('add_nin_press_interactions') && {
                    interactionName: 'jql-editor-base-search-button'
                }
            })
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cA0Y2.default), {
            "aria-label": label,
            isDisabled: isDisabled,
            testId: "jql-editor-search",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $c17f795fc901b8fd$var$style,
            appearance: 'primary',
            spacing: 'none',
            onClick: onSearch,
            onKeyDown: preventRepeatClick,
            isLoading: isSearching,
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $c17f795fc901b8fd$var$iconStyle,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqx2X))), {
                    color: "currentColor",
                    label: '',
                    LEGACY_size: 'medium',
                    LEGACY_margin: "-4px"
                })
            }),
            ...(0, $eGOwo.fg)('add_nin_press_interactions') && {
                interactionName: 'jql-editor-base-search-button'
            }
        })
    });
};

});

parcelRegister("cqdbH", function(module, exports) {

$parcel$export(module.exports, "BaseSyntaxHelp", () => $e07982f5df548692$export$7267128805e130a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6K3F5 = parcelRequire("6K3F5");

var $8mxGC = parcelRequire("8mxGC");

var $1UNF9 = parcelRequire("1UNF9");

var $eGOwo = parcelRequire("eGOwo");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");


var $bCN0h = parcelRequire("bCN0h");
// Fixes icon margin issus after new icon migration
const $e07982f5df548692$var$iconStyle = (0, $1DXK0.xcss)({
    margin: 'space.025',
    display: 'inline-flex'
});
const $e07982f5df548692$export$7267128805e130a = ({ describedby: describedby, isDisabled: isDisabled, label: label, onClick: onClick })=>{
    return (0, $eGOwo.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6K3F5.default), {
        "aria-describedby": describedby,
        label: label,
        isDisabled: isDisabled,
        appearance: "subtle",
        spacing: "compact",
        onClick: onClick,
        target: "blank",
        href: "https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Advanced+searching",
        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8mxGC))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #626F86)"
            })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bCN0h.SyntaxHelpContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
            "aria-describedby": describedby,
            "aria-label": label,
            isDisabled: isDisabled,
            appearance: 'subtle',
            spacing: 'none',
            target: 'blank',
            href: "https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Advanced+searching",
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $e07982f5df548692$var$iconStyle,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8mxGC))), {
                    label: '',
                    color: isDisabled ? `var(--ds-icon-disabled, ${0, $7bb4c1736002a04a$export$29a4f05edc054374})` : `var(--ds-icon-inverse, ${0, $7bb4c1736002a04a$export$29a4f05edc054374})`,
                    LEGACY_size: 'small',
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1UNF9))),
                    LEGACY_margin: "-2px"
                })
            }),
            onClick: onClick
        })
    });
};

});
parcelRegister("1UNF9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16518b614485f68e$var$_react = $16518b614485f68e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $16518b614485f68e$var$_questionCircle = $16518b614485f68e$var$_interopRequireDefault((parcelRequire("8mxGC")));
function $16518b614485f68e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $16518b614485f68e$var$QuestionIcon = (props)=>/*#__PURE__*/ $16518b614485f68e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18a1 1 0 0 1 0-2 1 1 0 0 1 0 2m-2-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path d="M15.89 8.048a3.97 3.97 0 0 0-2.951-2.94A4.005 4.005 0 0 0 8 9.087l.009.008 1.878.022.112-.116A2 2 0 0 1 12 7c1.103 0 2 .897 2 2s-.897 2-2 2h.008a1 1 0 0 0-.998.987v2.014a1 1 0 1 0 2 0v-.782c0-.217.145-.399.349-.472a3.99 3.99 0 0 0 2.53-4.699"/></g></svg>`
    }, props, {
        newIcon: $16518b614485f68e$var$_questionCircle.default
    }));
$16518b614485f68e$var$QuestionIcon.displayName = 'QuestionIcon';
var $16518b614485f68e$var$_default = module.exports.default = $16518b614485f68e$var$QuestionIcon;

});

parcelRegister("bCN0h", function(module, exports) {

$parcel$export(module.exports, "SyntaxHelpContainer", () => $dc7f1373da8fb4c4$export$4e1b8f789d662a1c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $aWILV = parcelRequire("aWILV");
const $dc7f1373da8fb4c4$export$4e1b8f789d662a1c = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1rcevfp0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> a': {
        background: `var(--ds-background-neutral-bold, ${(0, $7bb4c1736002a04a$export$5f71e19f3a7ad9de)})`,
        borderRadius: '100%',
        margin: "var(--ds-space-050, 4px)",
        '&:hover': {
            background: `var(--ds-background-neutral-bold-hovered, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
        },
        '&:focus': {
            background: `var(--ds-background-neutral-bold, ${(0, $7bb4c1736002a04a$export$5f71e19f3a7ad9de)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&:active, &[data-firefox-is-active='true']": {
            background: `var(--ds-background-neutral-bold-pressed, ${(0, $7bb4c1736002a04a$export$7090862dc3038a9f)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[disabled]': {
            background: `var(--ds-background-disabled, ${(0, $7bb4c1736002a04a$export$8754fc7e6d8b3000)})`
        }
    }
});

});



parcelRegister("4GY8V", function(module, exports) {

$parcel$export(module.exports, "EditorMain", () => $447a854c90cfc049$export$4a1fe064357e4803);
$parcel$export(module.exports, "EditorFooter", () => $447a854c90cfc049$export$6b199f86fb39c56e);
$parcel$export(module.exports, "EditorViewContainer", () => $447a854c90cfc049$export$e1a59ec983b6e626);
$parcel$export(module.exports, "ReadOnlyEditorViewContainer", () => $447a854c90cfc049$export$92dc95fac89d1410);
$parcel$export(module.exports, "LineNumberToolbar", () => $447a854c90cfc049$export$c7f458a6447d7077);
$parcel$export(module.exports, "EditorView", () => $447a854c90cfc049$export$eece2fccabbb77c5);
$parcel$export(module.exports, "ReadOnlyEditorView", () => $447a854c90cfc049$export$1eeaf339fa9196a5);
$parcel$export(module.exports, "EditorControls", () => $447a854c90cfc049$export$3ebfd5942f1290ac);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $IW7jS = parcelRequire("IW7jS");

var $7xEmd = parcelRequire("7xEmd");

var $aWILV = parcelRequire("aWILV");
function $447a854c90cfc049$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $447a854c90cfc049$var$fadeIn = (0, $1NIU8.keyframes)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
const $447a854c90cfc049$var$fadeOut = (0, $1NIU8.keyframes)({
    from: {
        visibility: 'visible',
        opacity: 1
    },
    to: {
        opacity: 0
    }
});
const $447a854c90cfc049$export$4a1fe064357e4803 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ezls2j67"
})("font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-size:14px;flex-grow:1;/* These styles and animations are derived from @atlaskit/tooltip */.", (0, $7xEmd.TOOLTIP_CLASSNAME), "{background-color:", `var(--ds-background-neutral-bold, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`, ";color:", `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`, ";border-radius:var(--ds-border-radius-100, 3px);box-sizing:border-box;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);line-height:1.3;max-width:240px;padding:var(--ds-space-025, 2px) var(--ds-space-075, 6px);word-wrap:break-word;overflow-wrap:break-word;z-index:", (0, $IW7jS.layers).tooltip(), ";pointer-events:none;position:absolute;visibility:hidden;transform:translate(-50%, calc(-100% - var(--ds-space-200, 16px)));&.", (0, $7xEmd.TOOLTIP_ENTER_CLASSNAME), "{animation:", $447a854c90cfc049$var$fadeIn, " 350ms cubic-bezier(0.15, 1, 0.3, 1);visibility:visible;}&.", (0, $7xEmd.TOOLTIP_EXIT_CLASSNAME), "{animation:", $447a854c90cfc049$var$fadeOut, " 350ms cubic-bezier(0.15, 1, 0.3, 1);}}");
const $447a854c90cfc049$export$6b199f86fb39c56e = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ezls2j66"
})({
    name: "y524xc",
    styles: "display:flex;justify-content:space-between;min-height:20px"
});
// Height (in px) for a single row in the editor
const $447a854c90cfc049$var$rowHeight = 22;
// Vertical padding for the editor input
const $447a854c90cfc049$var$getEditorInputVerticalPadding = (isCompact)=>isCompact ? 3 : 7;
const $447a854c90cfc049$var$editorInputHorizontalPadding = 6;
const $447a854c90cfc049$export$e1a59ec983b6e626 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ezls2j65"
})({
    backgroundColor: `var(--ds-background-input, ${(0, $7bb4c1736002a04a$export$e655ef011c4aa1a2)})`,
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    borderColor: `var(--ds-border-input, ${(0, $7bb4c1736002a04a$export$d6447c357493214f)})`,
    borderRadius: "var(--ds-border-radius-100, 3px)",
    padding: "var(--ds-border-width, 1px)",
    boxSizing: 'border-box',
    color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$fbda843f0a27fe96)})`,
    display: 'flex',
    overflow: 'auto',
    transition: 'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.editorViewIsInvalid && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $1NIU8.css)({
        borderColor: `var(--ds-border-danger, ${(0, $7bb4c1736002a04a$export$2010d0fb4295b346)})`,
        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${(0, $7bb4c1736002a04a$export$2010d0fb4295b346)})`}`
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.editorViewHasFocus ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $1NIU8.css)({
        backgroundColor: `var(--ds-surface, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$215b7063051591f1)})`,
        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$215b7063051591f1)})`}`
    }) : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $1NIU8.css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-input-hovered, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`
        }
    }));
const $447a854c90cfc049$export$92dc95fac89d1410 = /*#__PURE__*/ (0, $aWILV.default)($447a854c90cfc049$export$e1a59ec983b6e626, {
    target: "ezls2j64"
})({
    backgroundColor: `var(--ds-background-disabled, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`,
    color: `var(--ds-text-disabled, ${(0, $7bb4c1736002a04a$export$d6447c357493214f)})`,
    pointerEvents: 'none'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $447a854c90cfc049$var$_ref2 = {
    name: "eivff4",
    styles: "display:none"
};
const $447a854c90cfc049$export$c7f458a6447d7077 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ezls2j63"
})({
    backgroundColor: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`,
    flexShrink: 0,
    width: '30px',
    position: 'sticky',
    top: 0
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>!props.lineNumbersVisible && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    $447a854c90cfc049$var$_ref2);
/**
 * The main div which the Prosemirror editor will be rendered into.
 */ // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $447a854c90cfc049$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
const $447a854c90cfc049$export$eece2fccabbb77c5 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ezls2j62"
})("counter-reset:lineNumber;flex-grow:1;transition:height 250ms cubic-bezier(0.15, 1, 0.3, 1),max-height 250ms cubic-bezier(0.15, 1, 0.3, 1);max-height:", (props)=>$447a854c90cfc049$var$rowHeight * props.defaultMaxRows + $447a854c90cfc049$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;line-height:", $447a854c90cfc049$var$rowHeight / 14, ";font-family:var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace);word-break:break-word;overflow-wrap:anywhere;white-space:pre-wrap;&[data-expanded]{height:", (props)=>$447a854c90cfc049$var$rowHeight * props.expandedRows + $447a854c90cfc049$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;max-height:", (props)=>$447a854c90cfc049$var$rowHeight * props.expandedRows + $447a854c90cfc049$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;}.ProseMirror{color:", `var(--ds-text, ${(0, $7bb4c1736002a04a$export$ad0bacf983b7ddaa)})`, ";padding:", (props)=>$447a854c90cfc049$var$getEditorInputVerticalPadding(props.isCompact), "px ", $447a854c90cfc049$var$editorInputHorizontalPadding, "px;&:focus{outline:none;}.mark-token-keyword{color:", `var(--ds-text-accent-purple, ${(0, $7bb4c1736002a04a$export$c71e4279dd54a18d)})`, ";}.mark-token-field{color:", `var(--ds-text-accent-blue, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`, ";}.mark-token-operator{color:", `var(--ds-text-accent-green, ${(0, $7bb4c1736002a04a$export$6fa04827ac68a4fb)})`, ";}.mark-token-error{color:", `var(--ds-text-danger, ${(0, $7bb4c1736002a04a$export$2010d0fb4295b346)})`, ";text-decoration:wavy underline;text-decoration-thickness:1px;text-decoration-skip-ink:none;}}p{margin:0;counter-increment:lineNumber;position:relative;&::before{content:counter(lineNumber);color:", `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$d6447c357493214f)})`, ";font-size:10px;line-height:", $447a854c90cfc049$var$rowHeight / 10, ";padding:0 var(--ds-space-100, 8px) 0 var(--ds-space-025, 2px);position:absolute;box-sizing:border-box;transform:translateX(calc(-100% - var(--ds-space-100, 8px)));max-width:30px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;", (props)=>!props.lineNumbersVisible && // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    $447a854c90cfc049$var$_ref, ";}}");
const $447a854c90cfc049$export$1eeaf339fa9196a5 = /*#__PURE__*/ (0, $aWILV.default)($447a854c90cfc049$export$eece2fccabbb77c5, {
    target: "ezls2j61"
})("padding:", (props)=>$447a854c90cfc049$var$getEditorInputVerticalPadding(props.isCompact), "px ", $447a854c90cfc049$var$editorInputHorizontalPadding, "px;max-height:", (props)=>$447a854c90cfc049$var$rowHeight * props.defaultMaxRows, "px;>p{min-height:", $447a854c90cfc049$var$rowHeight, "px;}");
const $447a854c90cfc049$export$3ebfd5942f1290ac = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ezls2j60"
})((props)=>({
        alignItems: 'center',
        display: 'flex',
        flexShrink: 0,
        marginLeft: 'auto',
        marginRight: `${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.isSearch ? $447a854c90cfc049$var$getEditorInputVerticalPadding(props.isCompact) - 1 // the search button needs the same vertical & horizontal spacing
         : $447a854c90cfc049$var$editorInputHorizontalPadding - 3}px`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'normal',
        position: 'sticky',
        top: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$447a854c90cfc049$var$rowHeight + 2 * $447a854c90cfc049$var$getEditorInputVerticalPadding(props.isCompact)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gap: props.isVisualRefresh ? "var(--ds-space-025, 2px)" : 'unset'
    }));

});
parcelRegister("7xEmd", function(module, exports) {

$parcel$export(module.exports, "JQLValidationTooltipPluginKey", () => $af7b961269877a9e$export$9c08c6e09c037890);
$parcel$export(module.exports, "TOOLTIP_CLASSNAME", () => $af7b961269877a9e$export$a6e3ebd2348b0a1);
$parcel$export(module.exports, "TOOLTIP_ENTER_CLASSNAME", () => $af7b961269877a9e$export$c58b4cecb88a4d51);
$parcel$export(module.exports, "TOOLTIP_EXIT_CLASSNAME", () => $af7b961269877a9e$export$22dac80660f4fba2);

var $3lIcL = parcelRequire("3lIcL");
const $af7b961269877a9e$export$9c08c6e09c037890 = new (0, $3lIcL.PluginKey)('jql-validation-tooltip-plugin');
const $af7b961269877a9e$export$a6e3ebd2348b0a1 = 'jql-validation-tooltip';
const $af7b961269877a9e$export$c58b4cecb88a4d51 = 'jql-validation-tooltip-enter';
const $af7b961269877a9e$export$22dac80660f4fba2 = 'jql-validation-tooltip-exit';

});
parcelRegister("3lIcL", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $27059f7464a1d1f5$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $27059f7464a1d1f5$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $27059f7464a1d1f5$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $27059f7464a1d1f5$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $27059f7464a1d1f5$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $27059f7464a1d1f5$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $27059f7464a1d1f5$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $27059f7464a1d1f5$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $27059f7464a1d1f5$export$1692d8b0e89cecc3);

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
const $27059f7464a1d1f5$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $27059f7464a1d1f5$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $3xw6l.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $3xw6l.Slice).empty : content);
            if (i == 0) $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $27059f7464a1d1f5$export$c2b25f346d19bcbb($pos) : $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $27059f7464a1d1f5$var$findSelectionIn(doc, doc, 0, 0, 1) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $27059f7464a1d1f5$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $27059f7464a1d1f5$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $27059f7464a1d1f5$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $27059f7464a1d1f5$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $27059f7464a1d1f5$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $27059f7464a1d1f5$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $27059f7464a1d1f5$var$warnedAboutTextSelection = false;
function $27059f7464a1d1f5$var$checkTextSelection($pos) {
    if (!$27059f7464a1d1f5$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $27059f7464a1d1f5$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $27059f7464a1d1f5$export$c2b25f346d19bcbb extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $27059f7464a1d1f5$var$checkTextSelection($anchor);
        $27059f7464a1d1f5$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $27059f7464a1d1f5$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $3xw6l.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $3xw6l.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $27059f7464a1d1f5$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($head, bias, true) || $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $27059f7464a1d1f5$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($27059f7464a1d1f5$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("text", $27059f7464a1d1f5$export$c2b25f346d19bcbb);
class $27059f7464a1d1f5$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $27059f7464a1d1f5$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $27059f7464a1d1f5$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $27059f7464a1d1f5$export$e2940151ac854c0b extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $27059f7464a1d1f5$export$52baac22726c72bf.near($pos);
        return new $27059f7464a1d1f5$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $27059f7464a1d1f5$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $27059f7464a1d1f5$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $27059f7464a1d1f5$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$27059f7464a1d1f5$export$e2940151ac854c0b.prototype.visible = false;
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("node", $27059f7464a1d1f5$export$e2940151ac854c0b);
class $27059f7464a1d1f5$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $27059f7464a1d1f5$var$TextBookmark(pos, pos) : new $27059f7464a1d1f5$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $27059f7464a1d1f5$export$e2940151ac854c0b.isSelectable(node)) return new $27059f7464a1d1f5$export$e2940151ac854c0b($pos);
        return $27059f7464a1d1f5$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $27059f7464a1d1f5$export$c15d9ba76bdbcd95 extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $3xw6l.Slice).empty) {
        if (content == (0, $3xw6l.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $27059f7464a1d1f5$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $27059f7464a1d1f5$var$AllBookmark;
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("all", $27059f7464a1d1f5$export$c15d9ba76bdbcd95);
const $27059f7464a1d1f5$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $27059f7464a1d1f5$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $27059f7464a1d1f5$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $27059f7464a1d1f5$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $27059f7464a1d1f5$export$e2940151ac854c0b.isSelectable(child)) return $27059f7464a1d1f5$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $lzEKq.ReplaceStep) || step instanceof (0, $lzEKq.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($27059f7464a1d1f5$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $27059f7464a1d1f5$var$UPDATED_SEL = 1, $27059f7464a1d1f5$var$UPDATED_MARKS = 2, $27059f7464a1d1f5$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $27059f7464a1d1f5$export$febc5573c75cefb0 extends (0, $lzEKq.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $27059f7464a1d1f5$var$UPDATED_SEL) & ~$27059f7464a1d1f5$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $27059f7464a1d1f5$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $3xw6l.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$27059f7464a1d1f5$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $3xw6l.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($27059f7464a1d1f5$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $27059f7464a1d1f5$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_SCROLL) > 0;
    }
}
function $27059f7464a1d1f5$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $27059f7464a1d1f5$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $27059f7464a1d1f5$var$bind(desc.init, self);
        this.apply = $27059f7464a1d1f5$var$bind(desc.apply, self);
    }
}
const $27059f7464a1d1f5$var$baseFields = [
    new $27059f7464a1d1f5$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $27059f7464a1d1f5$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $27059f7464a1d1f5$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $27059f7464a1d1f5$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $27059f7464a1d1f5$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $27059f7464a1d1f5$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $27059f7464a1d1f5$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $27059f7464a1d1f5$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $27059f7464a1d1f5$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $27059f7464a1d1f5$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $27059f7464a1d1f5$var$Configuration(config.schema, config.plugins);
        let instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $3xw6l.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $27059f7464a1d1f5$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $27059f7464a1d1f5$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $27059f7464a1d1f5$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $27059f7464a1d1f5$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $27059f7464a1d1f5$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $27059f7464a1d1f5$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $27059f7464a1d1f5$var$keys = Object.create(null);
function $27059f7464a1d1f5$var$createKey(name) {
    if (name in $27059f7464a1d1f5$var$keys) return name + "$" + ++$27059f7464a1d1f5$var$keys[name];
    $27059f7464a1d1f5$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $27059f7464a1d1f5$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $27059f7464a1d1f5$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("3xw6l", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $293d5acde922b5fe$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $293d5acde922b5fe$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $293d5acde922b5fe$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $293d5acde922b5fe$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $293d5acde922b5fe$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $293d5acde922b5fe$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $293d5acde922b5fe$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $293d5acde922b5fe$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $293d5acde922b5fe$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $293d5acde922b5fe$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $293d5acde922b5fe$export$3476b78f8f5a8b72);

var $b22x6 = parcelRequire("b22x6");
function $293d5acde922b5fe$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $293d5acde922b5fe$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $293d5acde922b5fe$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $293d5acde922b5fe$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $293d5acde922b5fe$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $293d5acde922b5fe$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $293d5acde922b5fe$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $293d5acde922b5fe$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $293d5acde922b5fe$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $293d5acde922b5fe$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $293d5acde922b5fe$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $293d5acde922b5fe$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $293d5acde922b5fe$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $293d5acde922b5fe$var$retIndex(0, pos);
        if (pos == this.size) return $293d5acde922b5fe$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $293d5acde922b5fe$var$retIndex(i + 1, end);
                return $293d5acde922b5fe$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $293d5acde922b5fe$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $293d5acde922b5fe$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (nodes instanceof $293d5acde922b5fe$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $293d5acde922b5fe$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $293d5acde922b5fe$export$ffb0004e005737fa.empty = new $293d5acde922b5fe$export$ffb0004e005737fa([], 0);
const $293d5acde922b5fe$var$found = {
    index: 0,
    offset: 0
};
function $293d5acde922b5fe$var$retIndex(index, offset) {
    $293d5acde922b5fe$var$found.index = index;
    $293d5acde922b5fe$var$found.offset = offset;
    return $293d5acde922b5fe$var$found;
}
function $293d5acde922b5fe$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$293d5acde922b5fe$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$293d5acde922b5fe$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $293d5acde922b5fe$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $293d5acde922b5fe$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        if (marks instanceof $293d5acde922b5fe$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $293d5acde922b5fe$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $293d5acde922b5fe$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $293d5acde922b5fe$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $293d5acde922b5fe$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty = new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$export$ffb0004e005737fa.empty, 0, 0);
function $293d5acde922b5fe$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($293d5acde922b5fe$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $293d5acde922b5fe$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $293d5acde922b5fe$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $293d5acde922b5fe$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Inconsistent open depths");
    return $293d5acde922b5fe$var$replaceOuter($from, $to, slice, 0);
}
function $293d5acde922b5fe$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $293d5acde922b5fe$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $293d5acde922b5fe$var$close(node, $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $293d5acde922b5fe$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $293d5acde922b5fe$var$prepareSliceForReplace(slice, $from);
        return $293d5acde922b5fe$var$close(node, $293d5acde922b5fe$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $293d5acde922b5fe$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $293d5acde922b5fe$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $293d5acde922b5fe$var$checkJoin(node, $after.node(depth));
    return node;
}
function $293d5acde922b5fe$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $293d5acde922b5fe$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $293d5acde922b5fe$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$293d5acde922b5fe$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $293d5acde922b5fe$var$addNode($end.nodeBefore, target);
}
function $293d5acde922b5fe$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $293d5acde922b5fe$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $293d5acde922b5fe$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $293d5acde922b5fe$var$joinable($end, $to, depth + 1);
    let content = [];
    $293d5acde922b5fe$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $293d5acde922b5fe$var$checkJoin(openStart, openEnd);
        $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openStart, $293d5acde922b5fe$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openStart, $293d5acde922b5fe$var$replaceTwoWay($from, $start, depth + 1)), content);
        $293d5acde922b5fe$var$addRange($start, $end, depth, content);
        if (openEnd) $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openEnd, $293d5acde922b5fe$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $293d5acde922b5fe$var$addRange($to, null, depth, content);
    return new $293d5acde922b5fe$export$ffb0004e005737fa(content);
}
function $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $293d5acde922b5fe$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $293d5acde922b5fe$var$joinable($from, $to, depth + 1);
        $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(type, $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $293d5acde922b5fe$var$addRange($to, null, depth, content);
    return new $293d5acde922b5fe$export$ffb0004e005737fa(content);
}
function $293d5acde922b5fe$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($293d5acde922b5fe$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $293d5acde922b5fe$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $293d5acde922b5fe$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $293d5acde922b5fe$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $293d5acde922b5fe$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $293d5acde922b5fe$var$resolveCache.set(doc, cache = new $293d5acde922b5fe$var$ResolveCache);
        let result = cache.elts[cache.i] = $293d5acde922b5fe$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $293d5acde922b5fe$var$resolveCacheSize;
        return result;
    }
}
class $293d5acde922b5fe$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $293d5acde922b5fe$var$resolveCacheSize = 12, $293d5acde922b5fe$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $293d5acde922b5fe$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $293d5acde922b5fe$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $293d5acde922b5fe$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $293d5acde922b5fe$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $293d5acde922b5fe$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $293d5acde922b5fe$var$emptyAttrs) && $293d5acde922b5fe$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $293d5acde922b5fe$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $293d5acde922b5fe$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $293d5acde922b5fe$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $293d5acde922b5fe$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $293d5acde922b5fe$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $293d5acde922b5fe$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $293d5acde922b5fe$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$293d5acde922b5fe$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $293d5acde922b5fe$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$293d5acde922b5fe$export$85c928794f8d04d4.prototype.text = undefined;
class $293d5acde922b5fe$var$TextNode extends $293d5acde922b5fe$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $293d5acde922b5fe$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $293d5acde922b5fe$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $293d5acde922b5fe$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $293d5acde922b5fe$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $293d5acde922b5fe$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $293d5acde922b5fe$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $293d5acde922b5fe$export$364ed450558d7ec4.empty;
        let expr = $293d5acde922b5fe$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $293d5acde922b5fe$var$dfa($293d5acde922b5fe$var$nfa(expr));
        $293d5acde922b5fe$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $293d5acde922b5fe$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $293d5acde922b5fe$export$364ed450558d7ec4.empty = new $293d5acde922b5fe$export$364ed450558d7ec4(true);
class $293d5acde922b5fe$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $293d5acde922b5fe$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($293d5acde922b5fe$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $293d5acde922b5fe$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($293d5acde922b5fe$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $293d5acde922b5fe$var$parseExprSubscript(stream) {
    let expr = $293d5acde922b5fe$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $293d5acde922b5fe$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $293d5acde922b5fe$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $293d5acde922b5fe$var$parseExprRange(stream, expr) {
    let min = $293d5acde922b5fe$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $293d5acde922b5fe$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $293d5acde922b5fe$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $293d5acde922b5fe$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $293d5acde922b5fe$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $293d5acde922b5fe$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $293d5acde922b5fe$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $293d5acde922b5fe$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $293d5acde922b5fe$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($293d5acde922b5fe$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $293d5acde922b5fe$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($293d5acde922b5fe$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $293d5acde922b5fe$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $293d5acde922b5fe$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($293d5acde922b5fe$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $293d5acde922b5fe$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $293d5acde922b5fe$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $293d5acde922b5fe$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $293d5acde922b5fe$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $293d5acde922b5fe$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $293d5acde922b5fe$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $293d5acde922b5fe$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $293d5acde922b5fe$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $293d5acde922b5fe$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $293d5acde922b5fe$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $293d5acde922b5fe$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $293d5acde922b5fe$export$ffb0004e005737fa.from(content), $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $293d5acde922b5fe$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $293d5acde922b5fe$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, attrs, content.append(after), $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $293d5acde922b5fe$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $293d5acde922b5fe$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $293d5acde922b5fe$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $293d5acde922b5fe$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $293d5acde922b5fe$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $293d5acde922b5fe$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $293d5acde922b5fe$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $293d5acde922b5fe$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $293d5acde922b5fe$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $293d5acde922b5fe$export$c9d15bcfc6d42044(this, $293d5acde922b5fe$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $293d5acde922b5fe$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $293d5acde922b5fe$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $293d5acde922b5fe$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $b22x6.default).from(spec.nodes), instanceSpec.marks = (0, $b22x6.default).from(spec.marks || {}), this.nodes = $293d5acde922b5fe$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $293d5acde922b5fe$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $293d5acde922b5fe$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $293d5acde922b5fe$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $293d5acde922b5fe$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $293d5acde922b5fe$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $293d5acde922b5fe$var$TextNode(type, type.defaultAttrs, text, $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $293d5acde922b5fe$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $293d5acde922b5fe$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $293d5acde922b5fe$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $293d5acde922b5fe$var$isTagRule(rule) {
    return rule.tag != null;
}
function $293d5acde922b5fe$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $293d5acde922b5fe$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($293d5acde922b5fe$var$isTagRule(rule)) this.tags.push(rule);
            else if ($293d5acde922b5fe$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $293d5acde922b5fe$var$ParseContext(this, options, false);
        context.addAll(dom, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $293d5acde922b5fe$var$ParseContext(this, options, true);
        context.addAll(dom, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($293d5acde922b5fe$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $293d5acde922b5fe$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $293d5acde922b5fe$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $293d5acde922b5fe$export$1059c6e7d2ce5669(schema, $293d5acde922b5fe$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $293d5acde922b5fe$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $293d5acde922b5fe$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $293d5acde922b5fe$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $293d5acde922b5fe$var$OPT_PRESERVE_WS = 1, $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL = 2, $293d5acde922b5fe$var$OPT_OPEN_LEFT = 4;
function $293d5acde922b5fe$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $293d5acde922b5fe$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $293d5acde922b5fe$var$OPT_PRESERVE_WS | $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL : base & ~$293d5acde922b5fe$var$OPT_OPEN_LEFT;
}
class $293d5acde922b5fe$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $293d5acde922b5fe$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $293d5acde922b5fe$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$293d5acde922b5fe$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $293d5acde922b5fe$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $293d5acde922b5fe$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $293d5acde922b5fe$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $293d5acde922b5fe$var$NodeContext(topNode.type, topNode.attrs, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $293d5acde922b5fe$var$NodeContext(null, null, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $293d5acde922b5fe$var$NodeContext(parser.schema.topNodeType, null, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($293d5acde922b5fe$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $293d5acde922b5fe$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $293d5acde922b5fe$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($293d5acde922b5fe$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $293d5acde922b5fe$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $293d5acde922b5fe$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $293d5acde922b5fe$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $293d5acde922b5fe$var$OPT_OPEN_LEFT;
        let applyMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $293d5acde922b5fe$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $293d5acde922b5fe$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $293d5acde922b5fe$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $293d5acde922b5fe$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $293d5acde922b5fe$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $293d5acde922b5fe$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $293d5acde922b5fe$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $293d5acde922b5fe$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $293d5acde922b5fe$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $293d5acde922b5fe$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $293d5acde922b5fe$var$renderSpec($293d5acde922b5fe$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $293d5acde922b5fe$var$renderSpec($293d5acde922b5fe$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $293d5acde922b5fe$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $293d5acde922b5fe$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $293d5acde922b5fe$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $293d5acde922b5fe$var$gatherToDOM(schema.marks);
    }
}
function $293d5acde922b5fe$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $293d5acde922b5fe$var$doc(options) {
    return options.document || window.document;
}
const $293d5acde922b5fe$var$suspiciousAttributeCache = new WeakMap();
function $293d5acde922b5fe$var$suspiciousAttributes(attrs) {
    let value = $293d5acde922b5fe$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $293d5acde922b5fe$var$suspiciousAttributeCache.set(attrs, value = $293d5acde922b5fe$var$suspiciousAttributesInner(attrs));
    return value;
}
function $293d5acde922b5fe$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $293d5acde922b5fe$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $293d5acde922b5fe$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $293d5acde922b5fe$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("b22x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8081d8961ff8b83a$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $8081d8961ff8b83a$var$OrderedMap(content) {
    this.content = content;
}
$8081d8961ff8b83a$var$OrderedMap.prototype = {
    constructor: $8081d8961ff8b83a$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $8081d8961ff8b83a$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $8081d8961ff8b83a$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $8081d8961ff8b83a$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$8081d8961ff8b83a$var$OrderedMap.from = function(value) {
    if (value instanceof $8081d8961ff8b83a$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $8081d8961ff8b83a$var$OrderedMap(content);
};
var $8081d8961ff8b83a$export$2e2bcd8739ae039 = $8081d8961ff8b83a$var$OrderedMap;

});


parcelRegister("lzEKq", function(module, exports) {

$parcel$export(module.exports, "StepMap", () => $040d9edd1880ca83$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $040d9edd1880ca83$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $040d9edd1880ca83$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $040d9edd1880ca83$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $040d9edd1880ca83$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $040d9edd1880ca83$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $040d9edd1880ca83$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $040d9edd1880ca83$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $040d9edd1880ca83$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $040d9edd1880ca83$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $040d9edd1880ca83$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $040d9edd1880ca83$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $040d9edd1880ca83$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $040d9edd1880ca83$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $040d9edd1880ca83$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $040d9edd1880ca83$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $040d9edd1880ca83$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $040d9edd1880ca83$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $040d9edd1880ca83$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $040d9edd1880ca83$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $040d9edd1880ca83$export$563a914cafbdc389);

var $3xw6l = parcelRequire("3xw6l");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $040d9edd1880ca83$var$lower16 = 0xffff;
const $040d9edd1880ca83$var$factor16 = Math.pow(2, 16);
function $040d9edd1880ca83$var$makeRecover(index, offset) {
    return index + offset * $040d9edd1880ca83$var$factor16;
}
function $040d9edd1880ca83$var$recoverIndex(value) {
    return value & $040d9edd1880ca83$var$lower16;
}
function $040d9edd1880ca83$var$recoverOffset(value) {
    return (value - (value & $040d9edd1880ca83$var$lower16)) / $040d9edd1880ca83$var$factor16;
}
const $040d9edd1880ca83$var$DEL_BEFORE = 1, $040d9edd1880ca83$var$DEL_AFTER = 2, $040d9edd1880ca83$var$DEL_ACROSS = 4, $040d9edd1880ca83$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $040d9edd1880ca83$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $040d9edd1880ca83$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($040d9edd1880ca83$var$DEL_BEFORE | $040d9edd1880ca83$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($040d9edd1880ca83$var$DEL_AFTER | $040d9edd1880ca83$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $040d9edd1880ca83$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $040d9edd1880ca83$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $040d9edd1880ca83$export$c53d01c3ab9721b3.empty) return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $040d9edd1880ca83$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $040d9edd1880ca83$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $040d9edd1880ca83$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $040d9edd1880ca83$var$DEL_AFTER : pos == end ? $040d9edd1880ca83$var$DEL_BEFORE : $040d9edd1880ca83$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $040d9edd1880ca83$var$DEL_SIDE;
                return new $040d9edd1880ca83$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $040d9edd1880ca83$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $040d9edd1880ca83$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $040d9edd1880ca83$export$c53d01c3ab9721b3.empty : new $040d9edd1880ca83$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $040d9edd1880ca83$export$c53d01c3ab9721b3.empty = new $040d9edd1880ca83$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $040d9edd1880ca83$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $040d9edd1880ca83$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $040d9edd1880ca83$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $040d9edd1880ca83$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $040d9edd1880ca83$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $040d9edd1880ca83$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $040d9edd1880ca83$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $040d9edd1880ca83$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $040d9edd1880ca83$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $040d9edd1880ca83$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $040d9edd1880ca83$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $040d9edd1880ca83$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $040d9edd1880ca83$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $3xw6l.ReplaceError)) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $040d9edd1880ca83$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($040d9edd1880ca83$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $3xw6l.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $040d9edd1880ca83$export$d24ba56b0e3464a9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $040d9edd1880ca83$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $040d9edd1880ca83$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $040d9edd1880ca83$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("addMark", $040d9edd1880ca83$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $040d9edd1880ca83$export$94150db1311f67a9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $040d9edd1880ca83$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $040d9edd1880ca83$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $040d9edd1880ca83$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("removeMark", $040d9edd1880ca83$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $040d9edd1880ca83$export$adefd16c402fee4e extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $040d9edd1880ca83$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("addNodeMark", $040d9edd1880ca83$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $040d9edd1880ca83$export$fdf7d1dc10724da2 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("removeNodeMark", $040d9edd1880ca83$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $040d9edd1880ca83$export$5c860b2e74034756 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $040d9edd1880ca83$var$contentBetween(doc, this.from, this.to)) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $040d9edd1880ca83$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $040d9edd1880ca83$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $040d9edd1880ca83$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $040d9edd1880ca83$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $040d9edd1880ca83$export$5c860b2e74034756(json.from, json.to, (0, $3xw6l.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("replace", $040d9edd1880ca83$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $040d9edd1880ca83$export$444ba800d6024a98 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($040d9edd1880ca83$var$contentBetween(doc, this.from, this.gapFrom) || $040d9edd1880ca83$var$contentBetween(doc, this.gapTo, this.to))) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $040d9edd1880ca83$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $040d9edd1880ca83$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $040d9edd1880ca83$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $3xw6l.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("replaceAround", $040d9edd1880ca83$export$444ba800d6024a98);
function $040d9edd1880ca83$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $040d9edd1880ca83$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $040d9edd1880ca83$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $040d9edd1880ca83$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $040d9edd1880ca83$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $3xw6l.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $040d9edd1880ca83$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $040d9edd1880ca83$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $040d9edd1880ca83$export$5c860b2e74034756(cur, end, (0, $3xw6l.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $040d9edd1880ca83$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $040d9edd1880ca83$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $3xw6l.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $3xw6l.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $040d9edd1880ca83$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $040d9edd1880ca83$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$040d9edd1880ca83$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $040d9edd1880ca83$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $3xw6l.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $3xw6l.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $3xw6l.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $3xw6l.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $3xw6l.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $040d9edd1880ca83$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $040d9edd1880ca83$var$findWrappingOutside(range, nodeType);
    let inner = around && $040d9edd1880ca83$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($040d9edd1880ca83$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($040d9edd1880ca83$var$withAttrs));
}
function $040d9edd1880ca83$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $040d9edd1880ca83$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $040d9edd1880ca83$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $040d9edd1880ca83$var$wrap(tr, range, wrappers) {
    let content = (0, $3xw6l.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $3xw6l.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(start, end, start, end, new (0, $3xw6l.Slice)(content, 0, 0), wrappers.length, true));
}
function $040d9edd1880ca83$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $040d9edd1880ca83$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $040d9edd1880ca83$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $040d9edd1880ca83$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $040d9edd1880ca83$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $040d9edd1880ca83$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $040d9edd1880ca83$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $040d9edd1880ca83$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $040d9edd1880ca83$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $040d9edd1880ca83$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $040d9edd1880ca83$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $3xw6l.Fragment).empty, after = (0, $3xw6l.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $3xw6l.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $3xw6l.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(pos, pos, new (0, $3xw6l.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $040d9edd1880ca83$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $040d9edd1880ca83$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $040d9edd1880ca83$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $040d9edd1880ca83$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $040d9edd1880ca83$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $040d9edd1880ca83$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $040d9edd1880ca83$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $040d9edd1880ca83$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $040d9edd1880ca83$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $040d9edd1880ca83$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $3xw6l.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $040d9edd1880ca83$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $040d9edd1880ca83$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $040d9edd1880ca83$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $040d9edd1880ca83$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $3xw6l.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($040d9edd1880ca83$var$fitsTrivially($from, $to, slice)) return new $040d9edd1880ca83$export$5c860b2e74034756(from, to, slice);
    return new $040d9edd1880ca83$var$Fitter($from, $to, slice).fit();
}
function $040d9edd1880ca83$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $040d9edd1880ca83$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $3xw6l.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $3xw6l.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $3xw6l.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $040d9edd1880ca83$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $040d9edd1880ca83$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $040d9edd1880ca83$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $3xw6l.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $040d9edd1880ca83$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $3xw6l.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $040d9edd1880ca83$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($040d9edd1880ca83$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, frontierDepth, (0, $3xw6l.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$040d9edd1880ca83$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $040d9edd1880ca83$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $040d9edd1880ca83$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, this.depth, (0, $3xw6l.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $3xw6l.Fragment).empty, true);
        if (add.childCount) this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $040d9edd1880ca83$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($040d9edd1880ca83$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $040d9edd1880ca83$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($040d9edd1880ca83$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $040d9edd1880ca83$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $040d9edd1880ca83$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $040d9edd1880ca83$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $3xw6l.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $040d9edd1880ca83$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$040d9edd1880ca83$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $040d9edd1880ca83$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $040d9edd1880ca83$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $040d9edd1880ca83$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($040d9edd1880ca83$var$fitsTrivially($from, $to, slice)) return tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $040d9edd1880ca83$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $040d9edd1880ca83$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $3xw6l.Slice)($040d9edd1880ca83$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $040d9edd1880ca83$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($040d9edd1880ca83$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $3xw6l.Fragment).empty, true));
    }
    return fragment;
}
function $040d9edd1880ca83$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $040d9edd1880ca83$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(node), 0, 0));
}
function $040d9edd1880ca83$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $040d9edd1880ca83$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $040d9edd1880ca83$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $040d9edd1880ca83$export$626399c38172f669 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $040d9edd1880ca83$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("attr", $040d9edd1880ca83$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $040d9edd1880ca83$export$f50707b396300ac9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $040d9edd1880ca83$export$f50707b396300ac9(json.attr, json.value);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("docAttr", $040d9edd1880ca83$export$f50707b396300ac9);
/**
@internal
*/ let $040d9edd1880ca83$export$88cc3a1dfce48dd3 = class extends Error {
};
$040d9edd1880ca83$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype.constructor = $040d9edd1880ca83$export$88cc3a1dfce48dd3;
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $040d9edd1880ca83$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $040d9edd1880ca83$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $040d9edd1880ca83$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $3xw6l.Slice).empty) {
        let step = $040d9edd1880ca83$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $3xw6l.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $040d9edd1880ca83$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $040d9edd1880ca83$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $040d9edd1880ca83$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $040d9edd1880ca83$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $040d9edd1880ca83$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $040d9edd1880ca83$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $040d9edd1880ca83$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $040d9edd1880ca83$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $040d9edd1880ca83$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $040d9edd1880ca83$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $040d9edd1880ca83$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $3xw6l.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $040d9edd1880ca83$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $040d9edd1880ca83$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $040d9edd1880ca83$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $040d9edd1880ca83$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $040d9edd1880ca83$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});





parcelRegister("c5g9h", function(module, exports) {

$parcel$export(module.exports, "preloadJQLEditor", () => $556e0641a8989b76$export$d5d5e8328005e2ec);
$parcel$export(module.exports, "JQLEditorAsync", () => $556e0641a8989b76$export$ecdc147409ce705b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
parcelRequire("bn7wb");
var $aAuez = parcelRequire("aAuez");
var $7qz8r = parcelRequire("7qz8r");

var $1YXnw = parcelRequire("1YXnw");

var $33MBA = parcelRequire("33MBA");

var $k8Hie = parcelRequire("k8Hie");

const $556e0641a8989b76$var$JQLEditor = (0, $aAuez.lazyForPaint)(()=>(parcelRequire("dCyRY")).then(({ default: JQLEditorUI })=>JQLEditorUI), {
    ssr: false
});
const $556e0641a8989b76$export$d5d5e8328005e2ec = ()=>$556e0641a8989b76$var$JQLEditor.preload();
const $556e0641a8989b76$export$ecdc147409ce705b = (0, $33MBA.withIntlProvider)((0, $1YXnw.withErrorBoundary)((props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qz8r.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8Hie.JQLEditorReadOnly), {
            query: props.query,
            isSearch: !!props.onSearch,
            isCompact: props.isCompact
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($556e0641a8989b76$var$JQLEditor, {
            ...props
        })
    });
}));

});
parcelRegister("bn7wb", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("aAuez")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("aAuez")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("aAuez")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("7qz8r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("l7ep7")).useLazyPhase);
parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $MkKnc = parcelRequire("MkKnc");

var $aAuez = parcelRequire("aAuez");
parcelRequire("4XKbm");
var $7eb8v = parcelRequire("7eb8v");
var $esFTx = parcelRequire("esFTx");
parcelRequire("jv91R");
var $7qz8r = parcelRequire("7qz8r");
parcelRequire("1llka");
var $l7ep7 = parcelRequire("l7ep7");

var $hrq5I = parcelRequire("hrq5I");

});
parcelRegister("7veda", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $576673b9f1b70022$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $576673b9f1b70022$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("8V4xR")).MODE);

var $8V4xR = parcelRequire("8V4xR");
const $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN = undefined;
const $576673b9f1b70022$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $576673b9f1b70022$var$DEFAULT_MODE = (0, $8V4xR.MODE).HYDRATE;
const $576673b9f1b70022$var$DEFAULT_RETRY = 2;
const $576673b9f1b70022$var$config = {
    crossOrigin: $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN,
    manifest: $576673b9f1b70022$var$DEFAULT_MANIFEST,
    mode: $576673b9f1b70022$var$DEFAULT_MODE,
    retry: $576673b9f1b70022$var$DEFAULT_RETRY
};
const $576673b9f1b70022$export$44487a86467333c3 = ()=>$576673b9f1b70022$var$config;
const $576673b9f1b70022$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $576673b9f1b70022$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN;
    $576673b9f1b70022$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $576673b9f1b70022$var$DEFAULT_MANIFEST;
    $576673b9f1b70022$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $576673b9f1b70022$var$DEFAULT_MODE;
    $576673b9f1b70022$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $576673b9f1b70022$var$DEFAULT_RETRY;
};

});
parcelRegister("8V4xR", function(module, exports) {

$parcel$export(module.exports, "MODE", () => $67e72c25add85f29$export$e48589d9e4824227);
const $67e72c25add85f29$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("MkKnc", function(module, exports) {

var $8h7zW = parcelRequire("8h7zW");

var $7veda = parcelRequire("7veda");
parcelRequire("1llka");
var $eGDOl = parcelRequire("eGDOl");
var $l7ep7 = parcelRequire("l7ep7");

var $a1Dox = parcelRequire("a1Dox");
const $091493b8f27d5831$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $7veda.setConfig)(config);
        (0, $eGDOl.LISTENERS).length = 0;
        (0, $l7ep7.setCurrent)(0);
        if (!(0, $a1Dox.isNodeEnvironment)()) (0, $8h7zW.collect)();
    }
};

});
parcelRegister("8h7zW", function(module, exports) {

$parcel$export(module.exports, "collect", () => $6065ca3c1e226813$export$bb44f104e3c54dae);

var $7veda = parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $bzDJE = parcelRequire("bzDJE");

var $9WyUY = parcelRequire("9WyUY");

var $1NKbK = parcelRequire("1NKbK");
const $6065ca3c1e226813$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $7veda.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $8V4xR.MODE).RENDER ? (0, $9WyUY.cloneElements)(markers[i], lazyBegin) : (0, $1NKbK.refElements)(markers[i], lazyBegin);
        if ((0, $bzDJE.COLLECTED).has(lazyBegin)) (0, $bzDJE.COLLECTED).get(lazyBegin).push(value);
        else (0, $bzDJE.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("bzDJE", function(module, exports) {

$parcel$export(module.exports, "PHASE", () => $86d1c92cf7d83ac0$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $86d1c92cf7d83ac0$export$4831ef3968ea94ef);
const $86d1c92cf7d83ac0$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $86d1c92cf7d83ac0$export$4831ef3968ea94ef = new Map();

});

parcelRegister("9WyUY", function(module, exports) {

$parcel$export(module.exports, "cloneElements", () => $73d49dd0c38c2a1c$export$c42217d53a7ebafb);
const $73d49dd0c38c2a1c$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break; // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("1NKbK", function(module, exports) {

$parcel$export(module.exports, "refElements", () => $14fe3218cc4e45c4$export$c69443129766a7fc);
const $14fe3218cc4e45c4$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("1llka", function(module, exports) {

$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("l7ep7")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("l7ep7")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("l7ep7")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("eGDOl")).LISTENERS);

var $l7ep7 = parcelRequire("l7ep7");

var $eGDOl = parcelRequire("eGDOl");

var $7Peej = parcelRequire("7Peej");

});
parcelRegister("l7ep7", function(module, exports) {

$parcel$export(module.exports, "setCurrent", () => $f5f56cc3db1024b3$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $f5f56cc3db1024b3$export$5a25eca35e5debcb);
$parcel$export(module.exports, "useLazyPhase", () => $f5f56cc3db1024b3$export$1dc361b277327f88);

var $eJOHy = parcelRequire("eJOHy");

var $bzDJE = parcelRequire("bzDJE");

var $eGDOl = parcelRequire("eGDOl");

var $7Peej = parcelRequire("7Peej");
let $f5f56cc3db1024b3$var$CURRENT_PHASE = (0, $bzDJE.PHASE).PAINT;
const $f5f56cc3db1024b3$export$5f80f094fd31fffd = (phase)=>{
    $f5f56cc3db1024b3$var$CURRENT_PHASE = phase;
    (0, $eGDOl.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $f5f56cc3db1024b3$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: (0, $7Peej.createSubscribe)((0, $eGDOl.LISTENERS)),
    currentValue: ()=>$f5f56cc3db1024b3$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $f5f56cc3db1024b3$export$5f80f094fd31fffd((0, $bzDJE.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$f5f56cc3db1024b3$export$5f80f094fd31fffd((0, $bzDJE.PHASE).PAINT)
    }
});
const $f5f56cc3db1024b3$export$1dc361b277327f88 = ()=>{
    const v = (0, $eJOHy.useContext)($f5f56cc3db1024b3$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("eGDOl", function(module, exports) {

$parcel$export(module.exports, "LISTENERS", () => $ab13de8c68717d57$export$81b9c458a026d68f);
const $ab13de8c68717d57$export$81b9c458a026d68f = [];

});

parcelRegister("7Peej", function(module, exports) {

$parcel$export(module.exports, "createSubscribe", () => $5b2855963721e7ea$export$364097d812234b3f);
const $5b2855963721e7ea$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("a1Dox", function(module, exports) {

$parcel$export(module.exports, "getExport", () => $74c88e574846d6bd$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $74c88e574846d6bd$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $74c88e574846d6bd$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $74c88e574846d6bd$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("ed3y6")).default);

var $ed3y6 = parcelRequire("ed3y6");
const $74c88e574846d6bd$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $74c88e574846d6bd$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $74c88e574846d6bd$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $74c88e574846d6bd$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("ed3y6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5850857827bd3c9$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $a5850857827bd3c9$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("aAuez", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => $7b54b80385d7fc57$export$c952e5f94576010e);
$parcel$export(module.exports, "lazyAfterPaint", () => $7b54b80385d7fc57$export$291dd592399bdafa);
$parcel$export(module.exports, "lazy", () => $7b54b80385d7fc57$export$488013bae63b21da);

var $j5vcn = parcelRequire("j5vcn");

var $7veda = parcelRequire("7veda");

var $bzDJE = parcelRequire("bzDJE");

var $a1Dox = parcelRequire("a1Dox");
var $ed3y6 = parcelRequire("ed3y6");

var $b8XF0 = parcelRequire("b8XF0");

var $jA7rF = parcelRequire("jA7rF");

var $c7s3I = parcelRequire("c7s3I");

var $iFrYh = parcelRequire("iFrYh");

var $dcrQD = parcelRequire("dcrQD");

var $dcUz2 = parcelRequire("dcUz2");

var $2f83m = parcelRequire("2f83m");
function $7b54b80385d7fc57$var$_extends() {
    $7b54b80385d7fc57$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7b54b80385d7fc57$var$_extends.apply(this, arguments);
}
function $7b54b80385d7fc57$var$lazyProxy(_loader, { defer: defer = (0, $bzDJE.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $a1Dox.isNodeEnvironment)();
    const dataLazyId = (0, $ed3y6.default)(moduleId);
    const LazyInternal = isServer ? (0, $c7s3I.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $jA7rF.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $iFrYh.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $7veda.getConfig)();
                return (0, $dcUz2.retry)(_loader, {
                    delay: (0, $b8XF0.RETRY_DELAY),
                    factor: (0, $b8XF0.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $a1Dox.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $7veda.getConfig)();
        return (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $bzDJE.PHASE).PAINT ? (0, $b8XF0.PRIORITY).HIGH : (0, $b8XF0.PRIORITY).LOW;
        return (0, $dcrQD.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $7b54b80385d7fc57$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $bzDJE.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $bzDJE.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $bzDJE.PHASE).LAZY
    }
};
function $7b54b80385d7fc57$export$c952e5f94576010e(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $7b54b80385d7fc57$export$291dd592399bdafa(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $7b54b80385d7fc57$export$488013bae63b21da(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("j5vcn", function(module, exports) {

$parcel$export(module.exports, "getAssetUrlsFromId", () => $de56af5358c8f987$export$303f43e55cf1ef2f);
const $de56af5358c8f987$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("b8XF0", function(module, exports) {

$parcel$export(module.exports, "PRIORITY", () => $81ceb864b052c80d$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $81ceb864b052c80d$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $81ceb864b052c80d$export$ba64c908e55507fe);
const $81ceb864b052c80d$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $81ceb864b052c80d$export$a339266ad71b2447 = 300;
const $81ceb864b052c80d$export$ba64c908e55507fe = 1;

});

parcelRegister("jA7rF", function(module, exports) {

$parcel$export(module.exports, "createComponentClient", () => $e417279bde8da3e7$export$6898b5504b58699a);

var $eJOHy = parcelRequire("eJOHy");

var $7veda = parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $bzDJE = parcelRequire("bzDJE");
parcelRequire("4XKbm");
var $esFTx = parcelRequire("esFTx");
parcelRequire("1llka");
var $l7ep7 = parcelRequire("l7ep7");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");

var $2f83m = parcelRequire("2f83m");

var $bVeRl = parcelRequire("bVeRl");

var $7fZLe = parcelRequire("7fZLe");

var $hrq5I = parcelRequire("hrq5I");

var $9qVNk = parcelRequire("9qVNk");
function $e417279bde8da3e7$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $eJOHy.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $bzDJE.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $bzDJE.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $eJOHy.useContext)((0, $hrq5I.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $2f83m.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        }; // Subscribe to LazyWait context, triggering load when until is true
        (0, $9qVNk.useSubscription)({
            context: (0, $esFTx.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $bzDJE.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
        (0, $9qVNk.useSubscription)({
            context: (0, $l7ep7.LazyPhaseContext),
            load: load,
            onValue: (v)=>status.phase = v >= defer
        });
        const { setFallback: setFallback } = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
        (0, $eJOHy.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $bzDJE.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return; // override Suspense fallback with magic input wrappers
            const component = (0, $7veda.getConfig)().mode === (0, $8V4xR.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bVeRl.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fZLe.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("4XKbm", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => (parcelRequire("esFTx")).WaitContext);

var $esFTx = parcelRequire("esFTx");

var $7eb8v = parcelRequire("7eb8v");

});
parcelRegister("esFTx", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $a8742da03f685732$export$9ba3fe09d15de47b);

var $eJOHy = parcelRequire("eJOHy");

var $ddxDA = parcelRequire("ddxDA");
const $a8742da03f685732$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: ()=>(0, $ddxDA.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("ddxDA", function(module, exports) {

$parcel$export(module.exports, "noopCleanup", () => $99f694f5596397af$export$276c7dbda7675aec);
const $99f694f5596397af$export$276c7dbda7675aec = ()=>{};

});


parcelRegister("7eb8v", function(module, exports) {

var $eJOHy = parcelRequire("eJOHy");

var $esFTx = parcelRequire("esFTx");
const $54327a9f9e29fe04$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $eJOHy.useContext)((0, $esFTx.WaitContext));
    const value = (0, $eJOHy.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $eJOHy.useRef)(new Set());
    const api = (0, $eJOHy.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $eJOHy.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $esFTx.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("jv91R", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("7qz8r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("4XL9N")).LazySuspenseContext);

var $7qz8r = parcelRequire("7qz8r");

var $4XL9N = parcelRequire("4XL9N");

});
parcelRegister("7qz8r", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $56863736a86894e9$export$256c542058532d6f);

var $eJOHy = parcelRequire("eJOHy");

var $a1Dox = parcelRequire("a1Dox");

var $4XL9N = parcelRequire("4XL9N");
class $56863736a86894e9$export$256c542058532d6f extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback; // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            },
            name: this.props.name
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $eJOHy.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this; // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XL9N.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XL9N.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $a1Dox.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("4XL9N", function(module, exports) {

$parcel$export(module.exports, "LazySuspenseContext", () => $39d1408803878497$export$c33990e84065970c);

var $eJOHy = parcelRequire("eJOHy");
const $39d1408803878497$export$c33990e84065970c = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("2f83m", function(module, exports) {

$parcel$export(module.exports, "createLoaderError", () => $1a233ab151dd1ee2$export$c73a6a6f0bf7d425);
const $1a233ab151dd1ee2$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $1a233ab151dd1ee2$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') return Object.assign(error, {
        [$1a233ab151dd1ee2$export$6aa69c1258005366]: true
    });
    return error;
};
const $1a233ab151dd1ee2$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($1a233ab151dd1ee2$export$6aa69c1258005366);

});

parcelRegister("bVeRl", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackRender", () => $8ae08b5f412b712d$export$d55db778a3e1446b);

var $eJOHy = parcelRequire("eJOHy");

var $hrq5I = parcelRequire("hrq5I");
parcelRequire("4XKbm");
var $esFTx = parcelRequire("esFTx");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");
function $8ae08b5f412b712d$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $8ae08b5f412b712d$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $eJOHy.useRef)(null);
    const { current: ssrDomNodes } = (0, $eJOHy.useRef)(content || []);
    const profilerContext = (0, $eJOHy.useContext)((0, $hrq5I.ProfilerContext)).current;
    const waitContext = (0, $eJOHy.useContext)((0, $esFTx.WaitContext));
    const suspenseContext = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
    (0, $eJOHy.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext === null || profilerContext.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($8ae08b5f412b712d$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext === null || profilerContext.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        }; // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $8ae08b5f412b712d$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $8ae08b5f412b712d$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});
parcelRegister("hrq5I", function(module, exports) {

$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $cb29326da0127013$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $cb29326da0127013$export$8146ab57a3f7a7cb);

var $eJOHy = parcelRequire("eJOHy");
const $cb29326da0127013$export$e2d53c0cbedd2710 = {
    current: null
};
const $cb29326da0127013$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $eJOHy.createContext)($cb29326da0127013$export$e2d53c0cbedd2710);

});


parcelRegister("7fZLe", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $5489d785fce022f5$export$ca5b8fbc835d95e4);

var $eJOHy = parcelRequire("eJOHy");

var $a1Dox = parcelRequire("a1Dox");
function $5489d785fce022f5$var$_extends() {
    $5489d785fce022f5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5489d785fce022f5$var$_extends.apply(this, arguments);
}
const $5489d785fce022f5$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $a1Dox.attrToProp), {
            key: String(i)
        }); // text node
        if (!tagName) return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $eJOHy.Fragment), props, el.textContent); // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), props); // tag with content
        return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), $5489d785fce022f5$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("9qVNk", function(module, exports) {

$parcel$export(module.exports, "useSubscription", () => $6de35f980c3d94e0$export$368b4214baeb914c);

var $eJOHy = parcelRequire("eJOHy");
function $6de35f980c3d94e0$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $eJOHy.useContext)(context);
    (0, $eJOHy.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("c7s3I", function(module, exports) {

$parcel$export(module.exports, "createComponentServer", () => $8d2be766ecc6ab62$export$eb2e4b04351cdd9e);

var $j5vcn = parcelRequire("j5vcn");

var $eJOHy = parcelRequire("eJOHy");

var $7veda = parcelRequire("7veda");

var $bzDJE = parcelRequire("bzDJE");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");

var $a1Dox = parcelRequire("a1Dox");

var $2f83m = parcelRequire("2f83m");
function $8d2be766ecc6ab62$var$load(moduleId, loader) {
    try {
        return (0, $a1Dox.getExport)(loader());
    } catch (err) {
        throw (0, $2f83m.createLoaderError)(err);
    }
}
function $8d2be766ecc6ab62$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $8d2be766ecc6ab62$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $7veda.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $bzDJE.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("link", {
                key: url,
                rel: defer === (0, $bzDJE.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("iFrYh", function(module, exports) {

$parcel$export(module.exports, "createDeferred", () => $0381d5b0cf615548$export$e673efccd97e4223);
const $0381d5b0cf615548$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{});
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            } // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("dcrQD", function(module, exports) {

$parcel$export(module.exports, "preloadAsset", () => $99c1ff5e48fc9639$export$25bad4aa00c45355);

var $j5vcn = parcelRequire("j5vcn");

var $ddxDA = parcelRequire("ddxDA");

var $7veda = parcelRequire("7veda");

var $a1Dox = parcelRequire("a1Dox");

var $b8XF0 = parcelRequire("b8XF0");

var $dfXT0 = parcelRequire("dfXT0");

var $hrq5I = parcelRequire("hrq5I");
function $99c1ff5e48fc9639$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $7veda.getConfig)();
    const assets = (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $dfXT0.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $99c1ff5e48fc9639$var$fakePromise = {
    then: ()=>$99c1ff5e48fc9639$var$fakePromise,
    catch: ()=>$99c1ff5e48fc9639$var$fakePromise,
    finally: ()=>$99c1ff5e48fc9639$var$fakePromise
};
function $99c1ff5e48fc9639$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy'); // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $dfXT0.insertLinkTag)(href, rel));
        return $99c1ff5e48fc9639$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {} // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $99c1ff5e48fc9639$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $ddxDA.noopCleanup;
}
function $99c1ff5e48fc9639$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $a1Dox.isNodeEnvironment)()) return 0, $ddxDA.noopCleanup;
    (_GlobalReactLooselyLa = (0, $hrq5I.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $b8XF0.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $99c1ff5e48fc9639$export$3af04dbcb01bad4d,
        $99c1ff5e48fc9639$export$1046fd6a49d5e7a,
        $99c1ff5e48fc9639$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {}
    return 0, $ddxDA.noopCleanup;
}

});
parcelRegister("dfXT0", function(module, exports) {

$parcel$export(module.exports, "insertLinkTag", () => $9a6b213a2be2821b$export$6610512821c8a4ce);

var $hrq5I = parcelRequire("hrq5I");

var $ddxDA = parcelRequire("ddxDA");

var $7veda = parcelRequire("7veda");
function $9a6b213a2be2821b$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $ddxDA.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $7veda.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $hrq5I.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});


parcelRegister("dcUz2", function(module, exports) {

$parcel$export(module.exports, "retry", () => $99d845ced60c5b28$export$9369b12211e1fce4);
const $99d845ced60c5b28$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1; // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
     // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $99d845ced60c5b28$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $99d845ced60c5b28$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $99d845ced60c5b28$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $99d845ced60c5b28$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $99d845ced60c5b28$var$calculateDelay(context, policy);
        if (delay) await $99d845ced60c5b28$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("1YXnw", function(module, exports) {

$parcel$export(module.exports, "withErrorBoundary", () => $1a68a2ed7a24138e$export$f0c7a449e0cfaec7);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k8Hie = parcelRequire("k8Hie");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $1a68a2ed7a24138e$var$ErrorBoundary extends (0, $eJOHy.Component) {
    componentDidCatch(error) {
        this.setState({
            error: error
        });
        this.props.onError && this.props.onError(error);
    }
    render() {
        const { children: children, render: renderFallback } = this.props;
        const { error: error } = this.state;
        if (error === null) return children;
        return renderFallback({
            error: error
        });
    }
    constructor(...args){
        super(...args), this.state = {
            error: null
        };
    }
}
const $1a68a2ed7a24138e$export$f0c7a449e0cfaec7 = (WrappedComponent)=>{
    return (props)=>{
        const { query: query, onRenderError: onRenderError, onSearch: onSearch, isCompact: isCompact } = props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)($1a68a2ed7a24138e$var$ErrorBoundary, {
            onError: onRenderError,
            render: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8Hie.JQLEditorReadOnly), {
                    query: query,
                    isSearch: !!onSearch,
                    isCompact: isCompact
                }),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                ...props
            })
        });
    };
};

});

parcelRegister("33MBA", function(module, exports) {

$parcel$export(module.exports, "withIntlProvider", () => $b7b603d3260847b3$export$a5d940130f33be3f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
const $b7b603d3260847b3$export$a5d940130f33be3f = (WrappedComponent)=>{
    return (props)=>{
        const { locale: locale, ...rest } = props;
        if (locale) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
            locale: locale,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                ...rest
            })
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
            ...rest
        });
    };
};

});

parcelRegister("dCyRY", function(module, exports) {

let $9ea9df56b5ee6535$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $9ea9df56b5ee6535$var$load("ffQaD"),
    $9ea9df56b5ee6535$var$load("kvRbA"),
    $9ea9df56b5ee6535$var$load("fhJbz")
]).then(()=>parcelRequire('eWfwO'));

});


parcelRegister("6MO8n", function(module, exports) {

$parcel$export(module.exports, "preloadJqlBuilderBasic", () => $4d51ebe33ebf7e5d$export$680bac3b2d4b8db0);
$parcel$export(module.exports, "JQLBuilderBasicOldAsync", () => $4d51ebe33ebf7e5d$export$50e4159fe4baf68e);
$parcel$export(module.exports, "default", () => $4d51ebe33ebf7e5d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5fhUb = parcelRequire("5fhUb");

var $8KuTC = parcelRequire("8KuTC");

var $bQWwW = parcelRequire("bQWwW");

var $4GZBG = parcelRequire("4GZBG");



var $4GZBG = parcelRequire("4GZBG");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4d51ebe33ebf7e5d$var$AsyncJQLEditorUIOld = (0, $bQWwW.lazyForPaint)(()=>Promise.resolve((parcelRequire("lHTxM"))).then((module)=>module.JQLEditorUIWithErrorBoundaryOld), {
    ssr: false,
    moduleId: "./src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4d51ebe33ebf7e5d$var$AsyncJQLEditorUI = (0, $bQWwW.lazyForPaint)(()=>Promise.resolve((parcelRequire("lHTxM"))), {
    ssr: false,
    moduleId: "./src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx"
});
const $4d51ebe33ebf7e5d$export$680bac3b2d4b8db0 = ()=>$4d51ebe33ebf7e5d$var$AsyncJQLEditorUI.preload();
const $4d51ebe33ebf7e5d$export$50e4159fe4baf68e = (props)=>{
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_START
        });
    }, [
        onPerformanceMark
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GZBG.JQLBuilderBasicUIWithAnalyticsOld), {
        ...props,
        JQLEditor: $4d51ebe33ebf7e5d$var$AsyncJQLEditorUIOld
    });
};
const $4d51ebe33ebf7e5d$var$JQLBuilderBasicAsync = (props)=>{
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_START
        });
    }, [
        onPerformanceMark
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GZBG.default), {
        ...props,
        JQLEditor: $4d51ebe33ebf7e5d$var$AsyncJQLEditorUI
    });
};
var $4d51ebe33ebf7e5d$export$2e2bcd8739ae039 = $4d51ebe33ebf7e5d$var$JQLBuilderBasicAsync;

});
parcelRegister("4GZBG", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderBasicFallback", () => $5e1d54f8db67d585$export$c5a574f152d930c7);
$parcel$export(module.exports, "JQLBuilderBasicUIWithAnalyticsOld", () => $5e1d54f8db67d585$export$64a4e59c434c7d2d);
$parcel$export(module.exports, "default", () => $5e1d54f8db67d585$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $4xbv3 = parcelRequire("4xbv3");

var $lyPdT = parcelRequire("lyPdT");

var $fvO8D = parcelRequire("fvO8D");

var $elRNa = parcelRequire("elRNa");
const $5e1d54f8db67d585$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((onSearch, newJql)=>onSearch(newJql), 1000, {
    leading: false,
    trailing: true
});
const $5e1d54f8db67d585$var$JQLBuilderBasicUIOld = (props)=>{
    const { query: query, JQLEditor: JQLEditor, onSearch: triggerSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields, onReady: onReady, onLoad: onLoad, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, projectOptions: projectOptions, singleSelectFields: singleSelectFields, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker, contextJql: contextJql, viewContext: viewContext = null, scope: scope = null, suggestedUsersCount: suggestedUsersCount } = props;
    const [jql, setJql] = (0, $eJOHy.useState)(query);
    const onSearch = (0, $eJOHy.useCallback)((newJql)=>{
        setJql(newJql);
        triggerSearch && $5e1d54f8db67d585$var$debouncedSearch(triggerSearch, newJql);
    }, [
        triggerSearch
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setJql(query);
    }, [
        query,
        setJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lyPdT.ASTContainer), {
        jql: jql,
        onSwitchToJql: onSwitchToJql
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fvO8D.SearchStateContainer), {
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(JQLEditor, {
        NoOptionComponent: NoOptionComponent,
        query: jql,
        onSearch: onSearch,
        onSwitchToJql: onSwitchToJql,
        excludedFields: excludedFields,
        onReady: onReady,
        onLoad: onLoad,
        onJourneyStart: onJourneyStart,
        hydrationQueryRef: hydrationQueryRef,
        isHydrating: isHydrating,
        projectOptions: projectOptions,
        singleSelectFields: singleSelectFields,
        shouldUseListMarkup: shouldUseListMarkup,
        hideOperatorDropdown: hideOperatorDropdown,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        contextJql: contextJql,
        viewContext: viewContext,
        scope: scope,
        suggestedUsersCount: suggestedUsersCount
    })));
};
const $5e1d54f8db67d585$var$JQLBuilderBasicUI = (props)=>{
    const { query: query, JQLEditor: JQLEditor, onSearch: triggerSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields, onReady: onReady, onLoad: onLoad, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, AddFilterButtonComponent: AddFilterButtonComponent, projectOptions: projectOptions, singleSelectFields: singleSelectFields, hydrationData: hydrationData, isHydrating: isHydrating, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker, contextJql: contextJql, viewContext: viewContext = null, scope: scope = null, suggestedUsersCount: suggestedUsersCount } = props;
    const [jql, setJql] = (0, $eJOHy.useState)(query);
    const onSearch = (0, $eJOHy.useCallback)((newJql)=>{
        setJql(newJql);
        triggerSearch && $5e1d54f8db67d585$var$debouncedSearch(triggerSearch, newJql);
    }, [
        triggerSearch
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setJql(query);
    }, [
        query,
        setJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lyPdT.ASTContainer), {
        jql: jql,
        onSwitchToJql: onSwitchToJql
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fvO8D.SearchStateContainer), {
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(JQLEditor, {
        NoOptionComponent: NoOptionComponent,
        AddFilterButtonComponent: AddFilterButtonComponent,
        query: jql,
        onSearch: onSearch,
        onSwitchToJql: onSwitchToJql,
        excludedFields: excludedFields,
        onReady: onReady,
        onLoad: onLoad,
        onJourneyStart: onJourneyStart,
        hydrationData: hydrationData,
        isHydrating: isHydrating,
        projectOptions: projectOptions,
        singleSelectFields: singleSelectFields,
        shouldUseListMarkup: shouldUseListMarkup,
        hideOperatorDropdown: hideOperatorDropdown,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        contextJql: contextJql,
        viewContext: viewContext,
        scope: scope,
        suggestedUsersCount: suggestedUsersCount
    })));
};
const $5e1d54f8db67d585$export$c5a574f152d930c7 = ({ query: jql, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lyPdT.ASTContainer), {
        jql: jql
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fvO8D.SearchStateContainer), {
        excludedFields: props.excludedFields,
        irremovableFields: props.irremovableFields
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $elRNa.default), props)));
const $5e1d54f8db67d585$export$64a4e59c434c7d2d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "jqlBuilderBasic",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e1d54f8db67d585$var$JQLBuilderBasicUIOld, props));
const $5e1d54f8db67d585$var$JQLBuilderBasicUIWithAnalytics = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "jqlBuilderBasic",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e1d54f8db67d585$var$JQLBuilderBasicUI, props));
var $5e1d54f8db67d585$export$2e2bcd8739ae039 = $5e1d54f8db67d585$var$JQLBuilderBasicUIWithAnalytics;

});
parcelRegister("lyPdT", function(module, exports) {

$parcel$export(module.exports, "ASTContainer", () => $062c5160a50f826b$export$9046b5020ab1c824);
$parcel$export(module.exports, "useAST", () => $062c5160a50f826b$export$2d94ebd7e6bbb03c);
$parcel$export(module.exports, "useClauseMap", () => $062c5160a50f826b$export$32019dca04f1bace);
$parcel$export(module.exports, "useTextSearchInputClause", () => $062c5160a50f826b$export$53c45c55dec81810);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $ftN6c = parcelRequire("ftN6c");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $beYGy = parcelRequire("beYGy");
const $062c5160a50f826b$var$actions = Object.freeze({});
const $062c5160a50f826b$var$ASTContainerInternal = (0, $6E16M.createContainer)();
const $062c5160a50f826b$var$store = (0, $GtRbT.createStore)({
    containedBy: $062c5160a50f826b$var$ASTContainerInternal,
    initialState: {
        ast: {
            query: undefined,
            represents: '',
            errors: []
        },
        clauseMap: {},
        textSearchInputClause: undefined
    },
    actions: $062c5160a50f826b$var$actions,
    name: 'JQLBasic-ASTService',
    handlers: {
        onInit: ()=>({ setState: setState }, props)=>{
                setState((0, $beYGy.getASTAndClausesFromJQL)(props));
            },
        onContainerUpdate: (nextProps, prevProps)=>({ setState: setState })=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(nextProps, prevProps)) setState((0, $beYGy.getASTAndClausesFromJQL)(nextProps));
            }
    }
});
const $062c5160a50f826b$export$9046b5020ab1c824 = ({ jql: jql, children: children, onSwitchToJql: onSwitchToJql })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($062c5160a50f826b$var$ASTContainerInternal, {
        jql: jql,
        createAnalyticsEvent: createAnalyticsEvent,
        onSwitchToJql: onSwitchToJql
    }, children);
};
const $062c5160a50f826b$export$2d94ebd7e6bbb03c = (0, $iJq0l.createHook)($062c5160a50f826b$var$store, {
    selector: ({ ast: ast })=>ast
});
const $062c5160a50f826b$export$32019dca04f1bace = (0, $iJq0l.createHook)($062c5160a50f826b$var$store, {
    selector: ({ clauseMap: clauseMap })=>clauseMap
});
const $062c5160a50f826b$export$53c45c55dec81810 = (0, $iJq0l.createHook)($062c5160a50f826b$var$store, {
    selector: ({ textSearchInputClause: textSearchInputClause })=>textSearchInputClause
});

});
parcelRegister("beYGy", function(module, exports) {

$parcel$export(module.exports, "getASTAndClausesFromJQL", () => $14a4bd95a48ded6f$export$1029f331f2d8b0fd);

var $9qsUT = parcelRequire("9qsUT");

var $gYnSx = parcelRequire("gYnSx");

var $dTJxm = parcelRequire("dTJxm");

var $dHNhH = parcelRequire("dHNhH");

var $bgVBN = parcelRequire("bgVBN");
const $14a4bd95a48ded6f$export$1029f331f2d8b0fd = ({ jql: jql, createAnalyticsEvent: createAnalyticsEvent, onSwitchToJql: onSwitchToJql })=>{
    const ast = new (0, $9qsUT.JastBuilder)().build(jql);
    let clauseMap = {};
    let textSearchInputClause;
    if (ast.query) try {
        ({ clauseMap: clauseMap, textSearchInputClause: textSearchInputClause } = new (0, $dHNhH.JqlClauseCollectingVisitor)(false).visit(ast.query));
    } catch (error) {
        if (error instanceof (0, $bgVBN.UnsupportedRefinementError)) {
            (0, $gYnSx.default)({
                event: createAnalyticsEvent({}),
                error: error,
                meta: {
                    id: 'queryTooComplexInBasicMode',
                    packageName: (0, $dTJxm.PACKAGE_NAME),
                    teamName: (0, $dTJxm.TEAM_NAME)
                },
                attributes: {
                    anonymizedJql: ast.query ? ast.query.accept((0, $dTJxm.jqlAnonymizerVisitor)) : undefined
                }
            });
            onSwitchToJql && onSwitchToJql();
        } else throw error;
    }
    return {
        ast: ast,
        clauseMap: clauseMap,
        textSearchInputClause: textSearchInputClause
    };
};

});


parcelRegister("fvO8D", function(module, exports) {

$parcel$export(module.exports, "SearchStateContainer", () => $419ccffd8ef074b5$export$f57da8b87ed90917);
$parcel$export(module.exports, "useSearchState", () => $419ccffd8ef074b5$export$5fd14fa624074d55);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $lyPdT = parcelRequire("lyPdT");

var $7xNb8 = parcelRequire("7xNb8");
const $419ccffd8ef074b5$var$actions = Object.freeze({});
const $419ccffd8ef074b5$var$SearchStateContainerInternal = (0, $6E16M.createContainer)();
const $419ccffd8ef074b5$var$store = (0, $GtRbT.createStore)({
    containedBy: $419ccffd8ef074b5$var$SearchStateContainerInternal,
    initialState: {
        astClauseOrder: [],
        clausesByFieldId: {},
        secondaryClausesByFieldId: {}
    },
    actions: $419ccffd8ef074b5$var$actions,
    name: 'JQLBasic-SearchStateService',
    handlers: {
        onInit: ()=>({ setState: setState }, props)=>{
                setState((0, $7xNb8.getClausesData)(props));
            },
        onContainerUpdate: (nextProps, prevProps)=>({ setState: setState })=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(nextProps, prevProps)) setState((0, $7xNb8.getClausesData)(nextProps));
            }
    }
});
const $419ccffd8ef074b5$var$DEFAULT_EXCLUDED_FIELDS = [];
const $419ccffd8ef074b5$export$f57da8b87ed90917 = ({ excludedFields: excludedFields = $419ccffd8ef074b5$var$DEFAULT_EXCLUDED_FIELDS, irremovableFields: irremovableFields, children: children })=>{
    const [clauseMap] = (0, $lyPdT.useClauseMap)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($419ccffd8ef074b5$var$SearchStateContainerInternal, {
        clauseMap: clauseMap,
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    }, children);
};
const $419ccffd8ef074b5$export$5fd14fa624074d55 = (0, $iJq0l.createHook)($419ccffd8ef074b5$var$store);

});
parcelRegister("7xNb8", function(module, exports) {

$parcel$export(module.exports, "getClausesData", () => $61abbd26a97ab4cd$export$27e1563385d8bc4e);
const $61abbd26a97ab4cd$export$27e1563385d8bc4e = ({ clauseMap: clauseMap, excludedFields: excludedFields, irremovableFields: irremovableFields })=>{
    const clausesByFieldId = {};
    const secondaryClausesByFieldId = {};
    const astClauseOrder = [];
    Object.keys(clauseMap).forEach((fieldId)=>{
        const fieldIsNotIrremovable = !irremovableFields.has(fieldId);
        const fieldIsNotYetIncluded = !astClauseOrder.includes(fieldId);
        const isNotExcludedField = !excludedFields.includes(fieldId);
        if (fieldIsNotIrremovable && fieldIsNotYetIncluded && isNotExcludedField) astClauseOrder.push(fieldId);
        if (isNotExcludedField) {
            const clauses = clauseMap[fieldId];
            clausesByFieldId[fieldId] = clauses && clauses[0] ? clauses[0] : undefined;
            secondaryClausesByFieldId[fieldId] = clauses && clauses[1] ? clauses[1] : undefined;
        }
    });
    return {
        astClauseOrder: astClauseOrder,
        clausesByFieldId: clausesByFieldId,
        secondaryClausesByFieldId: secondaryClausesByFieldId
    };
};

});


parcelRegister("elRNa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b19f8a4834a8bb56$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $co0wp = parcelRequire("co0wp");

var $lyPdT = parcelRequire("lyPdT");

var $fvO8D = parcelRequire("fvO8D");

var $hoXMy = parcelRequire("hoXMy");

var $idYtD = parcelRequire("idYtD");
const $b19f8a4834a8bb56$export$407dcaf889e68e30 = ({ onLoad: onLoad, excludedFields: excludedFields, shouldUseListMarkup: shouldUseListMarkup, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker })=>{
    const intl = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    const [{ astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId }] = (0, $fvO8D.useSearchState)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onLoad && onLoad();
    }, [
        onLoad
    ]);
    const { fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount } = (0, $eJOHy.useMemo)(()=>(0, $hoXMy.gatherIrremovableFields)({
            excludedFields: excludedFields,
            intl: intl,
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        }), [
        astClauseOrder,
        clausesByFieldId,
        excludedFields,
        intl,
        irremovableFields,
        secondaryClausesByFieldId
    ]);
    const orderByFieldCount = (0, $eJOHy.useMemo)(()=>showOrderByPicker ? (0, $idYtD.getAstSortFields)(ast).length : undefined, [
        ast,
        showOrderByPicker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $co0wp.JQLEditorLoading), {
        fieldsToRender: fieldsToRender,
        optionalFieldsCount: optionalFieldsCount,
        shouldUseListMarkup: shouldUseListMarkup,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        orderByFieldsCount: orderByFieldCount
    });
};
var $b19f8a4834a8bb56$export$2e2bcd8739ae039 = $b19f8a4834a8bb56$export$407dcaf889e68e30;

});
parcelRegister("co0wp", function(module, exports) {

$parcel$export(module.exports, "JQLEditorLoading", () => $d41dad628cb17fdf$export$30c56a653ec47247);

var $eJOHy = parcelRequire("eJOHy");

var $dLR8J = parcelRequire("dLR8J");

var $7jTnu = parcelRequire("7jTnu");

var $6XJko = parcelRequire("6XJko");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");

var $bmSiK = parcelRequire("bmSiK");

var $bNtSK = parcelRequire("bNtSK");

var $jx3Cw = parcelRequire("jx3Cw");

var $1gVNb = parcelRequire("1gVNb");

var $97Pzw = parcelRequire("97Pzw");

var $ivFNg = parcelRequire("ivFNg");
const $d41dad628cb17fdf$export$30c56a653ec47247 = ({ fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount, orderByFieldsCount: orderByFieldsCount, shouldUseListMarkup: shouldUseListMarkup, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker })=>{
    const StyledListItemChildComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $bNtSK.default) : (0, $1gVNb.StyledListItemChild);
    const FieldWrapper = shouldUseListMarkup ? StyledListItemChildComponent : (0, $1gVNb.StyledChild);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $7jTnu.fg)('add_nin_press_interactions') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "jql-builder-basic-loading"
    }), !hideTextSearchInput && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, {
        key: (0, $dTJxm.getTextSearchInputField)(),
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "jql-builder-basic-refinement-fallback"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivFNg.TextSearchInputLoading), {
        placeholder: searchPlaceholder
    })), fieldsToRender.map((fieldToRender)=>{
        const { clause: clause, picker: picker, fieldId: fieldId, fieldLabel: fieldLabel, isIrremovable: isIrremovable } = fieldToRender;
        if (!isIrremovable) // Optional fields are not rendered in the loading state, instead the number of
        // optional fields is displayed as a badge on the More Dropdown button.
        // Only irremovable field picker trigger is rendered in the loading state.
        return null;
        switch(picker.pickerType){
            case (0, $eqSys.PickerTypes).Picker:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, {
                    key: fieldId,
                    // eslint-disable-next-line jira/integration/test-id-by-folder-structure
                    "data-testid": "jql-builder-basic-refinement-fallback"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jx3Cw.default), {
                    clause: clause,
                    fieldId: fieldId,
                    fieldDisplayName: fieldLabel,
                    fieldDescription: null,
                    isIrremovable: isIrremovable
                }));
            default:
                return null;
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bmSiK.default), {
        optionalFieldsCount: optionalFieldsCount
    })), showOrderByPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $97Pzw.default), {
        orderByFieldsCount: orderByFieldsCount ?? 0
    })));
};

});
parcelRegister("bmSiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e4d9e52c21fde51$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $1OQKp = parcelRequire("1OQKp");

var $7q9BG = parcelRequire("7q9BG");

var $goZPP = parcelRequire("goZPP");

var $jQjGM = parcelRequire("jQjGM");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $izTXQ = parcelRequire("izTXQ");

var $fpIOP = parcelRequire("fpIOP");

var $kkE8T = parcelRequire("kkE8T");
const $7e4d9e52c21fde51$var$AddFilterFallback = ({ optionalFieldsCount: optionalFieldsCount })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const moreLabel = (0, $6XJko.isVisualRefreshEnabled)() ? formatMessage((0, $izTXQ.default).moreButton) : formatMessage((0, $izTXQ.default).moreButtonOld);
    /**
   * We only show `More` button with loading state when there's more than 1
   * optional field with selected values underneath.
   * Otherwise we display the default `More` button
   */ if (optionalFieldsCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fpIOP.LoadingStateAnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "default",
        isSelected: true,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        label: "addButton",
        testId: "jql-builder-basic.common.ui.add-filter-fallback.loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkE8T.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkE8T.StyledLabel), null, moreLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkE8T.StyledBadge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        appearance: "primary"
    }, `+${optionalFieldsCount}`)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "default",
        iconAfter: (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
            label: "",
            color: "currentColor",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQjGM))), {
            label: "addIcon",
            LEGACY_size: "small"
        }),
        isSelected: false,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        label: "addButton",
        testId: "jql-builder-basic.common.ui.add-filter-fallback.loading"
    }, moreLabel);
};
var $7e4d9e52c21fde51$export$2e2bcd8739ae039 = $7e4d9e52c21fde51$var$AddFilterFallback;

});
parcelRegister("izTXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bb191f32cb760a0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1bb191f32cb760a0$var$messages = (0, $7qGN1.defineMessages)({
    moreButtonOld: {
        "id": "jql-builder-basic.common.more-button-old",
        "defaultMessage": "More"
    },
    moreButton: {
        "id": "jql-builder-basic.common.more-button",
        "defaultMessage": "More filters"
    },
    refinementSearch: {
        "id": "jql-builder-basic.jql-editor.refinement-search",
        "defaultMessage": "Search issues"
    },
    searchCurrentPage: {
        "id": "jql-builder-basic.common.search-current-page",
        "defaultMessage": "Search on current page"
    },
    refinementSearchIssueTermRefresh: {
        "id": "jql-builder-basic.common.refinement-search-issue-term-refresh",
        "defaultMessage": "Search work"
    },
    moreButtonLabel: {
        "id": "jql-builder-basic.common.more-button-label",
        "defaultMessage": "More filter options"
    },
    searchMoreFiltersPlaceholder: {
        "id": "jql-builder-basic-picker.common.search-more-filters-placeholder",
        "defaultMessage": "Search more filters"
    },
    accessibleDescription: {
        "id": "jql-builder-basic.common.accessible-description",
        "defaultMessage": "Typing letters in the search input updates the search results below."
    }
});
var $1bb191f32cb760a0$export$2e2bcd8739ae039 = $1bb191f32cb760a0$var$messages;

});

parcelRegister("fpIOP", function(module, exports) {

$parcel$export(module.exports, "LoadingStateAnimationWrapper", () => $798b0be264727846$export$c7a90a9f6120efb7);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $798b0be264727846$export$c7a90a9f6120efb7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y44vkmg5 _kqswh2mm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kkE8T", function(module, exports) {

$parcel$export(module.exports, "TriggerComponentNoOperator", () => $5d8410405ab62313$export$2d8feb52cd4e66ea);
$parcel$export(module.exports, "Container", () => $5d8410405ab62313$export$42a852a2b6b56249);
$parcel$export(module.exports, "LabelContainer", () => $5d8410405ab62313$export$f5ae33f1b01a6402);
$parcel$export(module.exports, "StyledLabel", () => $5d8410405ab62313$export$eea83358d9434634);
$parcel$export(module.exports, "StyledBadge", () => $5d8410405ab62313$export$1eb8c4092e3d2863);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7q9BG = parcelRequire("7q9BG");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $dPMMf = parcelRequire("dPMMf");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

const $5d8410405ab62313$export$96bdbc84526f3739 = (value)=>Array.isArray(value) ? value.length > 0 : typeof value === 'object' && value !== null;
const $5d8410405ab62313$export$2d8feb52cd4e66ea = ({ isInvalid: isInvalid = false, label: label = '', value: value, isSelected: isSelected })=>{
    if (!value || !$5d8410405ab62313$export$96bdbc84526f3739(value)) return (0, $6XJko.isVisualRefreshEnabled)() && (0, $7jTnu.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5d8410405ab62313$var$triggerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5d8410405ab62313$var$triggerStyles,
        testId: (0, $332899bfd23114ba$export$743be55d5cf4a20d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        weight: "medium",
        color: !isSelected ? 'color.text.subtle' : 'inherit'
    }, label))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5d8410405ab62313$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5d8410405ab62313$export$f5ae33f1b01a6402, {
        "data-testid": (0, $332899bfd23114ba$export$743be55d5cf4a20d)
    }, label));
    const valueMap = value.map((v)=>v.optionType !== 'error' && v.label !== undefined ? v.label : '');
    const valueLength = valueMap.length;
    const [firstValue, ...rest] = valueMap;
    const badgeAppearance = isInvalid ? 'important' : 'primary';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5d8410405ab62313$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5d8410405ab62313$export$f5ae33f1b01a6402, {
        "data-testid": (0, $332899bfd23114ba$export$743be55d5cf4a20d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5d8410405ab62313$export$eea83358d9434634, null, label, ":"), firstValue), valueLength > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5d8410405ab62313$export$1eb8c4092e3d2863, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        testId: (0, $332899bfd23114ba$export$fca2db27fe6c1305),
        appearance: badgeAppearance
    }, `+${rest.length}`)) : null);
};
const $5d8410405ab62313$var$triggerContainerStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $5d8410405ab62313$var$triggerStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${36 * (0, $dPMMf.gridSize)}px`,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $5d8410405ab62313$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $5d8410405ab62313$export$f5ae33f1b01a6402 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _p12fo812 _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $5d8410405ab62313$export$eea83358d9434634 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48pmoej _2hwx1b66",
            __cmplp.className
        ])
    });
});
const $5d8410405ab62313$export$1eb8c4092e3d2863 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o _18u01b66",
            __cmplp.className
        ])
    });
});

});
const $332899bfd23114ba$export$743be55d5cf4a20d = 'jql-builder-basic.common.ui.format-label.label-container';
const $332899bfd23114ba$export$fca2db27fe6c1305 = 'jql-builder-basic.common.ui.format-label.badge';



parcelRegister("bNtSK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9a301a8e69517c3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $f9a301a8e69517c3$var$ListItemChild = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: $f9a301a8e69517c3$var$listItemStyles,
        "data-vc": "jql-builder-basic-list-item-child",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "jql-builder-basic-refinement-fallback"
    }, children);
var $f9a301a8e69517c3$export$2e2bcd8739ae039 = $f9a301a8e69517c3$var$ListItemChild;
const $f9a301a8e69517c3$var$listItemStyles = (0, $1DXK0.xcss)({
    margin: 'space.050',
    minWidth: 'space.0',
    listStyle: 'none'
});

});

parcelRegister("jx3Cw", function(module, exports) {

$parcel$export(module.exports, "default", () => $147d97f5fead946e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $1xd19 = parcelRequire("1xd19");
const $147d97f5fead946e$export$15138d86eb9e97c3 = ({ label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147d97f5fead946e$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147d97f5fead946e$var$LabelContainer, null, label));
const $147d97f5fead946e$var$PickerFallback = ({ clause: clause, fieldId: fieldId, fieldDisplayName: fieldDisplayName, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
        isInvalid: false,
        isSelected: false,
        hasValues: !!clause,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
        isLoading: !!clause,
        fieldDescription: fieldDescription,
        isIrremovable: isIrremovable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147d97f5fead946e$export$15138d86eb9e97c3, {
        label: fieldDisplayName
    }));
var $147d97f5fead946e$export$2e2bcd8739ae039 = $147d97f5fead946e$var$PickerFallback;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $147d97f5fead946e$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $147d97f5fead946e$var$LabelContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c116y _4cvr1h6o _p12fo812 _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1xd19", function(module, exports) {

$parcel$export(module.exports, "default", () => $a27ca3e76f0378a8$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $5lAAn = parcelRequire("5lAAn");

var $goZPP = parcelRequire("goZPP");

var $jkYbX = parcelRequire("jkYbX");

var $3cMgR = parcelRequire("3cMgR");

var $k71qx = parcelRequire("k71qx");

var $7jTnu = parcelRequire("7jTnu");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $dTJxm = parcelRequire("dTJxm");

var $8kiQA = parcelRequire("8kiQA");

var $huMsw = parcelRequire("huMsw");

var $fpIOP = parcelRequire("fpIOP");

var $aIcwA = parcelRequire("aIcwA");
const $a27ca3e76f0378a8$var$Button = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _ju3gewfl _mt1tewfl",
            __cmplp.className
        ])
    });
});
const $a27ca3e76f0378a8$var$isKeyboardEvent = (event)=>event.key !== undefined;
const $a27ca3e76f0378a8$var$PickerTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isInvalid: isInvalid, isSelected: isSelected, isLoading: isLoading, hasValues: hasValues, onClick: onClick, onClear: onClear, testId: testId, searchTemplate: searchTemplate, fieldDescription: fieldDescription, isIrremovable: isIrremovable = false }, ref)=>{
    const intl = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnClear = (0, $eJOHy.useCallback)((e)=>{
        e.stopPropagation();
        const isKeyboard = $a27ca3e76f0378a8$var$isKeyboardEvent(e); // only clear on click, enter key or space key
        const shouldClear = isKeyboard && (e.key === 'Enter' || e.key === ' ') || !isKeyboard;
        onClear && shouldClear && onClear();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'removeFilter', {
            keyboard: isKeyboard
        });
    }, [
        createAnalyticsEvent,
        onClear
    ]);
    if (isLoading === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fpIOP.LoadingStateAnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        isSelected: true,
        testId: `${testId}.loading`,
        ...(0, $7jTnu.fg)('add_nin_press_interactions') && {
            interactionName: 'jql-builder-basic-picker-trigger'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$var$ButtonContent, null, children)));
    const Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$var$ButtonContent, null, searchTemplate === (0, $dTJxm.EPIC_LINK).searchTemplate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $aIcwA.default).deprecatedEpicLinkMessage,
            values: {
                // @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                        as: "strong",
                        color: "inherit",
                        size: "UNSAFE_small"
                    }, chunks)
            }
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$var$IconWrapperLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
        label: "",
        color: "var(--ds-icon-warning, #E56910)",
        LEGACY_size: "small"
    }))), children);
    const IconAfterContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$var$IconWrapper, {
        visualRefresh: (0, $6XJko.isVisualRefreshEnabled)()
    }, fieldDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $huMsw.FieldDescriptionPopup), {
        fieldDescription: fieldDescription,
        isParentPickerActive: hasValues || isSelected
    }), !isIrremovable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8kiQA.ClearButton), {
        onClick: handleOnClear,
        label: intl.formatMessage((0, $aIcwA.default).removeField)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
        label: "",
        color: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $6XJko.isVisualRefreshEnabled)() && (0, $7jTnu.fg)('visual-refresh-headers-buttons') && !(isSelected || hasValues) ? "var(--ds-icon-subtle, #626F86)" : 'currentColor',
        size: "small"
    }));
    return isInvalid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$export$332fba2134818c97, {
        isSelected: isSelected || hasValues,
        onClick: onClick,
        ref: ref,
        testId: testId,
        iconAfter: IconAfterContent
    }, Content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$var$Button, {
        isSelected: isSelected || hasValues,
        "aria-expanded": isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        iconAfter: IconAfterContent
    }, Content);
});
var $a27ca3e76f0378a8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a27ca3e76f0378a8$var$PickerTrigger;
const $a27ca3e76f0378a8$var$ButtonContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- To migrate as part of go/ui-styling-standard
const $a27ca3e76f0378a8$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_gg26t5": (0, $awdRS.default)(__cmplp.visualRefresh ? "var(--ds-space-0, 0px)" : "var(--ds-space-negative-075, -6px)")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o _2hwxyz14",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a27ca3e76f0378a8$var$IconWrapperLeft = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwx1b66 _18u01i6y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a27ca3e76f0378a8$export$332fba2134818c97 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$var$Button, {
        ...props,
        ref: ref,
        className: (0, $hcewu.default)([
            "_1w905u61 _16hgvb0f _zelm5u61 _1fh15u61 _18y1vb0f _u1mbvb0f"
        ])
    }));
const $a27ca3e76f0378a8$var$styles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a27ca3e76f0378a8$export$27305c69e65286e6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz14q2 _30l316c2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8kiQA", function(module, exports) {

$parcel$export(module.exports, "ClearButton", () => $12161862574e639b$export$13ec83e50bf04290);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5wxTT = parcelRequire("5wxTT");
const $12161862574e639b$export$13ec83e50bf04290 = ({ label: label, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($12161862574e639b$var$StyledClearButton, {
        // @ts-expect-error ts(2322) Type 'string' is not assignable to type 'number'.
        tabIndex: "0",
        role: "button",
        onClick: onClick,
        onKeyPress: onClick,
        "data-testid": "jql-editor-basic.common.ui.clear-button" // eslint-disable-line jira/integration/test-id-by-folder-structure
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5wxTT))), {
        color: "currentColor",
        label: label,
        size: "small"
    }));
var $12161862574e639b$export$2e2bcd8739ae039 = $12161862574e639b$export$13ec83e50bf04290;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $12161862574e639b$var$StyledClearButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _syaz131l _nt751r31 _49pcglyw _1hvw1o36 _vn891l7b _f8pj1fxt _7ehi1vm4 _30l31fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5wxTT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53b9d7f39d5a7786fd5c4592782d4f82>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $405a3cd7d6c6872a$var$_react = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $405a3cd7d6c6872a$var$_cross = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6zhpo")));

var $405a3cd7d6c6872a$var$_close = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6OLN4")));
function $405a3cd7d6c6872a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $405a3cd7d6c6872a$var$CrossIcon = (props)=>/*#__PURE__*/ $405a3cd7d6c6872a$var$_react.default.createElement($405a3cd7d6c6872a$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $405a3cd7d6c6872a$var$_close.default
    }, props));
$405a3cd7d6c6872a$var$CrossIcon.Name = 'CrossIconMigration';
var $405a3cd7d6c6872a$var$_default = module.exports.default = $405a3cd7d6c6872a$var$CrossIcon;

});


parcelRegister("huMsw", function(module, exports) {

$parcel$export(module.exports, "FieldDescriptionPopup", () => $8ae94e736131c065$export$8adaffb2a3e09bc3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6J86O = parcelRequire("6J86O");

var $k71qx = parcelRequire("k71qx");

var $2ZGUP = parcelRequire("2ZGUP");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $lRq8t = parcelRequire("lRq8t");

var $cNe2t = parcelRequire("cNe2t");

var $dTJxm = parcelRequire("dTJxm");


var $2OYJH = parcelRequire("2OYJH");

var $9i5BR = parcelRequire("9i5BR");

var $bT9la = parcelRequire("bT9la");
const $8ae94e736131c065$var$entryPointParams = {}; /**
                              * Render a Jira custom field description as rich text, within a popup
                              */ 
const $8ae94e736131c065$export$8adaffb2a3e09bc3 = ({ fieldDescription: fieldDescription, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false, isParentPickerActive: isParentPickerActive })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(shouldOpenOnFirstRender);
    const toggleOpenCloseState = (0, $eJOHy.useCallback)(()=>{
        setIsOpen((currentIsOpenValue)=>!currentIsOpenValue);
    }, []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $9i5BR.default), $8ae94e736131c065$var$entryPointParams);
    const buttonTrigger = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions); /**
                                                                        * lazily render the field description popup content (using entrypoints).
                                                                        * The content is a rich text description that is configured in the 'custom
                                                                        * fields' Jira settings.
                                                                        */ 
    const renderContent = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: (0, $78f96576dfb68c5f$export$723ee4d7411b97b4),
            packageName: (0, $dTJxm.PACKAGE_NAME),
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2OYJH.ContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2OYJH.ContentError), null)),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2OYJH.ContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2OYJH.ContentLoading), null)),
            runtimeProps: {
                fieldDescription: fieldDescription
            }
        }), [
        entryPointReferenceSubject,
        fieldDescription
    ]);
    /**
   * renders the icon that, when clicked, toggles open/close state of the
   * field description popup
   */ const renderTrigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage((0, $bT9la.default).showDescription),
            position: "top"
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ae94e736131c065$var$Trigger, {
                ...tooltipProps,
                ...triggerProps,
                ref: (element)=>{
                    /*
       * make sure the Trigger's ref is passed to all things
       * that need it, otherwise bugs will appear such as
       * tooltip/popup appearing in weird places
       */ buttonTrigger(element); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    tooltipProps.ref(element); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                },
                isOpen: isOpen,
                isParentPickerActive: isParentPickerActive,
                onClick: (e)=>{
                    e.stopPropagation();
                    toggleOpenCloseState();
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J86O))), {
                spacing: "spacious",
                label: isOpen ? formatMessage((0, $bT9la.default).hideDescription) : formatMessage((0, $bT9la.default).showDescription)
            }))), [
        buttonTrigger,
        formatMessage,
        isOpen,
        isParentPickerActive,
        toggleOpenCloseState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        messageId: "jql-builder-basic.common.ui.field-description-popup.popup",
        messageType: "transactional",
        content: renderContent,
        trigger: renderTrigger
    }), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null));
};
/**
 * Clickable element that will toggle the open / close state of the popup
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ae94e736131c065$var$Trigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, isParentPickerActive: isParentPickerActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk18uv _80omtlke _nt751r31 _49pcglyw _1hvw1o36 _vn891l7b _f8pj1fxt _7ehi1vm4 _30l31fxt",
            __cmplp.isOpen || __cmplp.isParentPickerActive ? "_syaz1qo3" : "_syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6J86O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4c08fce34755bd27ddd6baac981b869>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e5d3c47f79fd131$var$_react = $4e5d3c47f79fd131$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4e5d3c47f79fd131$var$_statusInformation = $4e5d3c47f79fd131$var$_interopRequireDefault((parcelRequire("2R0ne")));

var $4e5d3c47f79fd131$var$_panel = $4e5d3c47f79fd131$var$_interopRequireDefault((parcelRequire("1Sm4w")));
function $4e5d3c47f79fd131$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e5d3c47f79fd131$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $4e5d3c47f79fd131$var$_react.default.createElement($4e5d3c47f79fd131$var$_statusInformation.default, Object.assign({
        LEGACY_fallbackIcon: $4e5d3c47f79fd131$var$_panel.default
    }, props));
$4e5d3c47f79fd131$var$StatusInformationIcon.Name = 'StatusInformationIconMigration';
var $4e5d3c47f79fd131$var$_default = module.exports.default = $4e5d3c47f79fd131$var$StatusInformationIcon;

});
parcelRegister("1Sm4w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $15dbf4a3ad51a12e$var$_react = $15dbf4a3ad51a12e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $15dbf4a3ad51a12e$var$_statusInformation = $15dbf4a3ad51a12e$var$_interopRequireDefault((parcelRequire("2R0ne")));
function $15dbf4a3ad51a12e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $15dbf4a3ad51a12e$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $15dbf4a3ad51a12e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $15dbf4a3ad51a12e$var$_statusInformation.default
    }));
$15dbf4a3ad51a12e$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $15dbf4a3ad51a12e$var$_default = module.exports.default = $15dbf4a3ad51a12e$var$EditorPanelIcon;

});


const $78f96576dfb68c5f$export$723ee4d7411b97b4 = 'field-description-popup-content';

parcelRegister("2OYJH", function(module, exports) {

$parcel$export(module.exports, "ContentBox", () => $82839c47848ada0f$export$2966b8ec97c144ae);
$parcel$export(module.exports, "ContentError", () => $82839c47848ada0f$export$f2a1a543c1677898);
$parcel$export(module.exports, "ContentLoading", () => $82839c47848ada0f$export$199be3e6e7e83c08);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $d8UFE = parcelRequire("d8UFE");

var $78Hx3 = parcelRequire("78Hx3");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $bWrOQ = parcelRequire("bWrOQ");
const $82839c47848ada0f$export$2966b8ec97c144ae = ({ children: children })=>{
    /**
   * Because the field description button is nested within the picker button,
   * any click events in the field description popup would bubble up and trigger
   * the picker. This is an intrim solution to prevent that from happening. Wrap
   * the entire field description popup in a div that listens for clicks and traps
   * them so that they don't bubble further up to the picker button.
   *
   * TODO remove this when completing the followup ticket:
   * https://jplat.jira.atlassian.cloud/browse/EM-6510
   */ const propagationTrap = (e)=>e.stopPropagation();
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        padding: "space.150",
        xcss: $82839c47848ada0f$var$contentBoxStyles,
        onClick: propagationTrap,
        tabIndex: 0
    }, children));
};
const $82839c47848ada0f$export$f2a1a543c1677898 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        justifyContent: "center",
        alignItems: "center"
    }, !(0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82839c47848ada0f$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($78Hx3))),
        LEGACY_size: "xlarge",
        LEGACY_primaryColor: "color.text",
        color: "var(--ds-icon-warning, #E56910)",
        testId: "jql-builder-basic.common.ui.field-description-popup-common.editor-warning-icon"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82839c47848ada0f$var$FlexRow, null, (0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $82839c47848ada0f$var$warningIconStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($78Hx3))),
        LEGACY_size: "xlarge",
        LEGACY_primaryColor: "color.text",
        color: "var(--ds-icon-warning, #E56910)",
        testId: "jql-builder-basic.common.ui.field-description-popup-common.editor-warning-icon"
    })), formatMessage((0, $bWrOQ.default).error)));
};
const $82839c47848ada0f$export$199be3e6e7e83c08 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        testId: "jql-builder-basic.common.ui.field-description-popup-common.spinner",
        size: "small"
    });
const $82839c47848ada0f$var$contentBoxStyles = (0, $1DXK0.xcss)({
    maxWidth: '300px',
    maxHeight: '300px',
    overflow: 'auto',
    outline: 'none'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82839c47848ada0f$var$FlexRow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule _y3gn1h6o _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $82839c47848ada0f$var$warningIconStyle = (0, $1DXK0.xcss)({
    marginRight: 'space.100',
    display: 'inline'
});

});
parcelRegister("bWrOQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $472c84f011b76fc1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $472c84f011b76fc1$var$messages = (0, $7qGN1.defineMessages)({
    error: {
        "id": "jql-builder-basic.common.field-description-popup-common.error",
        "defaultMessage": "We cannot show the field description at this time. Please refresh to try again."
    }
});
var $472c84f011b76fc1$export$2e2bcd8739ae039 = $472c84f011b76fc1$var$messages;

});


parcelRegister("9i5BR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a28ccc0a64ec8f4$export$2e2bcd8739ae039);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $0a28ccc0a64ec8f4$var$FieldDescriptionContentEntryPoint = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jl2sL")), {
        moduleId: "91602efd",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $0a28ccc0a64ec8f4$export$2e2bcd8739ae039 = $0a28ccc0a64ec8f4$var$FieldDescriptionContentEntryPoint;

});
parcelRegister("jl2sL", function(module, exports) {

let $e141e39411e67b48$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e141e39411e67b48$var$load("ffQaD"),
    $e141e39411e67b48$var$load("kvRbA"),
    $e141e39411e67b48$var$load("76n7a"),
    $e141e39411e67b48$var$load("l253H"),
    $e141e39411e67b48$var$load("jdd0j")
]).then(()=>parcelRequire('dKBR7'));

});


parcelRegister("bT9la", function(module, exports) {

$parcel$export(module.exports, "default", () => $41dbe3960c87233a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $41dbe3960c87233a$var$messages = (0, $7qGN1.defineMessages)({
    showDescription: {
        "id": "jql-builder-basic.common.field-description-popup.show-description",
        "defaultMessage": "Show the description for this field"
    },
    hideDescription: {
        "id": "jql-builder-basic.common.field-description-popup.hide-description",
        "defaultMessage": "Hide the description for this field"
    }
});
var $41dbe3960c87233a$export$2e2bcd8739ae039 = $41dbe3960c87233a$var$messages;

});


parcelRegister("aIcwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $292ccc03ae0fcd70$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $292ccc03ae0fcd70$var$messages = (0, $7qGN1.defineMessages)({
    removeField: {
        "id": "jql-builder-basic.common.picker-trigger.remove-field",
        "defaultMessage": "Remove field"
    },
    deprecatedEpicLinkMessage: {
        "id": "jql-builder-basic.common.picker-trigger.deprecated-epic-link-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>."
    }
});
var $292ccc03ae0fcd70$export$2e2bcd8739ae039 = $292ccc03ae0fcd70$var$messages;

});



parcelRegister("1gVNb", function(module, exports) {

$parcel$export(module.exports, "StyledChild", () => $9becb14e4b35c771$export$8133811dea85f484);
$parcel$export(module.exports, "StyledListItemChild", () => $9becb14e4b35c771$export$b24abe39371fec57);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9becb14e4b35c771$export$8133811dea85f484 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkv77o _2hwx1b66 _otyrv77o _18u01b66 _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $9becb14e4b35c771$export$b24abe39371fec57 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_qtt8glyw _19pk1b66 _2hwxv77o _otyr1b66 _18u0v77o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $9becb14e4b35c771$export$999ca5bf223f627 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1mjv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("97Pzw", function(module, exports) {

$parcel$export(module.exports, "default", () => $13faf4701670b6d8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fpIOP = parcelRequire("fpIOP");

var $iRlQc = parcelRequire("iRlQc");
const $13faf4701670b6d8$var$ORDER_BY_LOADING_BUTTON_ID = 'jql-builder-basic-order-by-trigger-loading';
const $13faf4701670b6d8$var$OrderByPickerLoading = ({ orderByFieldsCount: orderByFieldsCount })=>orderByFieldsCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fpIOP.LoadingStateAnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iRlQc.default), {
        numberOfFields: orderByFieldsCount,
        buttonId: $13faf4701670b6d8$var$ORDER_BY_LOADING_BUTTON_ID,
        isSelected: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iRlQc.default), {
        numberOfFields: orderByFieldsCount,
        buttonId: $13faf4701670b6d8$var$ORDER_BY_LOADING_BUTTON_ID,
        isSelected: false
    });
var $13faf4701670b6d8$export$2e2bcd8739ae039 = $13faf4701670b6d8$var$OrderByPickerLoading;

});
parcelRegister("iRlQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $200a3c692ee5506a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7q9BG = parcelRequire("7q9BG");

var $5CSKW = parcelRequire("5CSKW");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $elIWt = parcelRequire("elIWt");

var $7yWes = parcelRequire("7yWes");
/**
 * Renders the button that triggers open/close of the Order By Picker. Also rendered in the basic mode
 * loading screen when the Order By Picker is enabled.
 */ const $200a3c692ee5506a$var$OrderByButton = ({ onClick: onClick, numberOfFields: numberOfFields, triggerProps: triggerProps, buttonId: buttonId, isSelected: isSelected })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const label = numberOfFields ? formatMessage((0, $elIWt.default).labelNameWithBadge, {
        fieldCount: numberOfFields
    }) : formatMessage((0, $elIWt.default).name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        ...triggerProps,
        id: buttonId,
        isSelected: Boolean(numberOfFields) || isSelected,
        onClick: onClick,
        iconAfter: (...iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $200a3c692ee5506a$var$iconContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7yWes.default), {
                ...iconProps,
                size: "small",
                label: ""
            })),
        "aria-label": label,
        testId: "jql-builder-basic.common.ui.order-by-trigger-button.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, formatMessage((0, $elIWt.default).name)), Boolean(numberOfFields) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        appearance: "primary"
    }, numberOfFields))));
};
var $200a3c692ee5506a$export$2e2bcd8739ae039 = $200a3c692ee5506a$var$OrderByButton;
const $200a3c692ee5506a$var$iconContainerStyles = (0, $1DXK0.xcss)({
    paddingRight: 'space.050',
    paddingTop: 'space.025'
});

});
parcelRegister("elIWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $75062d67003cd2cf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
'src/packages/jql-builder/basic/src/ui/jql-editor/order-by-picker/trigger-button/messages.tsx';
const $75062d67003cd2cf$var$messages = (0, $7qGN1.defineMessages)({
    name: {
        "id": "jql-builder-basic.common.order-by-trigger-button.name",
        "defaultMessage": "Order"
    },
    labelNameWithBadge: {
        "id": "jql-builder-basic.common.order-by-trigger-button.label-name-with-badge",
        "defaultMessage": "Order, currently {fieldCount, plural, other {# fields} one {# field}} selected"
    }
});
var $75062d67003cd2cf$export$2e2bcd8739ae039 = $75062d67003cd2cf$var$messages;

});

parcelRegister("7yWes", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aad666c06754cce$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $9aad666c06754cce$var$sortOrderGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "none",
        d: "M1.7749 3.25001L4.24978 0.775132L6.72465 3.25001M14.2251 10.75L11.7502 13.2249L9.27535 10.75M11.75 12.5V0.75M4.25 13.25L4.25 1.50001",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "square",
        strokeLinejoin: "round"
    }));
const $9aad666c06754cce$var$SortIcon = ({ label: label, size: size = 'medium' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $9aad666c06754cce$var$sortOrderGlyph,
        label: label,
        size: size
    });
var $9aad666c06754cce$export$2e2bcd8739ae039 = $9aad666c06754cce$var$SortIcon;

});



parcelRegister("ivFNg", function(module, exports) {

$parcel$export(module.exports, "TextSearchInputLoading", () => $97c7077f91ae1c75$export$d8de07f8c0b1e278);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $lyPdT = parcelRequire("lyPdT");

var $b06aK = parcelRequire("b06aK");

var $92k5z = parcelRequire("92k5z");

var $izTXQ = parcelRequire("izTXQ");

var $5jGSj = parcelRequire("5jGSj");
const $97c7077f91ae1c75$export$d8de07f8c0b1e278 = ({ placeholder: placeholder })=>{
    const intl = (0, $lRq8t.default)();
    const [textSearchInputClause] = (0, $lyPdT.useTextSearchInputClause)();
    const value = (0, $eJOHy.useMemo)(()=>(0, $92k5z.removeSurroundingQuotes)((0, $b06aK.default).value(textSearchInputClause) || ''), [
        textSearchInputClause
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5jGSj.default), {
        label: placeholder !== undefined && (0, $6XJko.isVisualRefreshEnabled)() ? placeholder : intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $izTXQ.default).refinementSearchIssueTermRefresh : (0, $izTXQ.default).refinementSearch),
        value: value,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        isDisabled: true
    });
};

});
parcelRegister("92k5z", function(module, exports) {

$parcel$export(module.exports, "removeSurroundingQuotes", () => $d05f5ddefe8149a6$export$8de447c869ac6d85);
const $d05f5ddefe8149a6$export$8de447c869ac6d85 = (maybeQuotedString)=>maybeQuotedString.replace(/^["']|["']$/g, '');

});

parcelRegister("5jGSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cbf21a7fc36e3e6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $6fs4r = parcelRequire("6fs4r");

var $dqc6Z = parcelRequire("dqc6Z");

var $6XJko = parcelRequire("6XJko");

var $lRq8t = parcelRequire("lRq8t");

var $izTXQ = parcelRequire("izTXQ");
const $5cbf21a7fc36e3e6$var$accessibleDescriptionId = 'text-field-accessible-description-id';
const $5cbf21a7fc36e3e6$var$debounceOnChange = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(({ onSendOptionAnalytics: onSendOptionAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onChange: onChange, targetValue: targetValue })=>{
    onChange(targetValue);
    onSendOptionAnalytics({
        searchStringLength: targetValue ? targetValue.length : 0
    });
}, 500, {
    leading: false,
    trailing: true
});
const $5cbf21a7fc36e3e6$var$TextField = ({ inputRef: inputRef, label: label, value: value, isDisabled: isDisabled = false, onChange: onChange, onFocus: onFocus, onSendOptionAnalytics: onSendOptionAnalytics })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleChange = (0, $eJOHy.useCallback)((targetValue)=>{
        $5cbf21a7fc36e3e6$var$debounceOnChange({
            onChange: onChange,
            targetValue: targetValue,
            onSendOptionAnalytics: onSendOptionAnalytics
        });
    }, [
        onChange,
        onSendOptionAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5cbf21a7fc36e3e6$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6fs4r.default), {
        id: $5cbf21a7fc36e3e6$var$accessibleDescriptionId
    }, formatMessage((0, $izTXQ.default).accessibleDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dqc6Z.SearchField), {
        onChange: handleChange,
        onFocus: onFocus,
        value: value,
        placeholder: label,
        placeholderAlwaysVisible: true,
        isCompact: true,
        isResponsive: true,
        inputRef: inputRef,
        testId: "jql-builder-basic.common.ui.text-field.search-field",
        isDisabled: isDisabled,
        showIconBeforeInput: (0, $6XJko.isVisualRefreshEnabled)(),
        describedById: $5cbf21a7fc36e3e6$var$accessibleDescriptionId
    }));
};
var $5cbf21a7fc36e3e6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5cbf21a7fc36e3e6$var$TextField;
const $5cbf21a7fc36e3e6$var$StyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dqc6Z", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $84caf67c6542222b$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $6S4l2 = parcelRequire("6S4l2");

var $ftN6c = parcelRequire("ftN6c");

var $sY9BV = parcelRequire("sY9BV");

var $k71qx = parcelRequire("k71qx");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $jd93d = parcelRequire("jd93d");

var $7jTnu = parcelRequire("7jTnu");

var $1uv7v = parcelRequire("1uv7v");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $7CY7m = parcelRequire("7CY7m");

var $4jrRd = parcelRequire("4jrRd");

var $ixnXK = parcelRequire("ixnXK");
function $84caf67c6542222b$export$41946885a418e1(object) {
    return 'ref' in object && 'data-test-id' in object;
}
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $84caf67c6542222b$var$className = 'ajs-dirty-warning-exempt';
const $84caf67c6542222b$var$SearchFieldContainer = ({ shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $kUoGK.useSoftwareProjectTheming)();
    return (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            shouldFitContainerWidth && $84caf67c6542222b$var$fitContainerStyles,
            (0, $6XJko.isVisualRefreshEnabled)() && reducedHeight && $84caf67c6542222b$var$reducedHeightStyles,
            isSoftwareFullTheming && $84caf67c6542222b$var$themedBgStyles
        ]
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        ...(0, $6XJko.isVisualRefreshEnabled)() ? {
            reducedHeight: reducedHeight
        } : {}
    }, children);
};
const $84caf67c6542222b$var$STABLE_EMPTY_OBJECT = {};
const $84caf67c6542222b$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = $84caf67c6542222b$var$STABLE_EMPTY_OBJECT, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false, renderTooltipContent: renderTooltipContent = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [value, setValue] = (0, $eJOHy.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const textInput = (0, $eJOHy.useRef)(null);
    const previousValueRef = (0, $eJOHy.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eJOHy.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = (0, $7jTnu.fg)('filter_refinement_search_field_tooltip') ? // condition is because of fg
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        return {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $84caf67c6542222b$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
    }, [
        ariaLabelText,
        autoFocus,
        describedById,
        formatMessage,
        handleKeyDown,
        handleOnBlur,
        handleOnChange,
        handleOnFocus,
        inputProps,
        inputRef,
        isAutocompleteDisabled,
        isCompact,
        isDisabled,
        maxLength,
        placeholder,
        testId,
        value
    ]) : {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        'data-test-id': 'searchfield',
        testId: testId ?? 'searchfield',
        name: 'search',
        className: $84caf67c6542222b$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $6XJko.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jrRd.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear)
    }) : undefined;
    if ($84caf67c6542222b$export$41946885a418e1(textFieldProps) && (0, $7jTnu.fg)('filter_refinement_search_field_tooltip')) {
        const { onFocus: onFocusTextField, ref: textFieldRef, 'aria-describedby': textfieldAriaDescription, onBlur: onBlurTextField, ...restTextFieldProps } = textFieldProps; // condition is just because of fg
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showTooltip = (0, $eJOHy.useMemo)(()=>{
            return renderTooltipContent !== null && renderTooltipContent !== undefined && value === '';
        }, [
            renderTooltipContent,
            value
        ]); // condition is because of fg - remove disabled eslint rule once fg is removed
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const useShowTooltip = (0, $eJOHy.useCallback)(()=>showTooltip, [
            showTooltip
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
            shouldFitContainerWidth: shouldFitContainerWidth,
            reducedHeight: reducedHeight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
            isExpanded: isExpanded,
            shouldFitContainerWidth: shouldFitContainerWidth,
            maxWidth: increasedWidth ? 328 : 184,
            placeholderAlwaysVisible: placeholderAlwaysVisible,
            isResponsive: isResponsive
        }, renderCustomSearchField !== undefined ? renderCustomSearchField({
            textFieldProps: textFieldProps,
            searchIcon: searchIconDynamic
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: renderTooltipContent,
            canAppear: useShowTooltip,
            position: "bottom-start",
            hideTooltipOnClick: true,
            ignoreTooltipPointerEvents: true
        }, ({ onFocus: onFocusTooltip, ref: tooltipRef, 'aria-describedby': tooltipAriaDescription, onBlur: onBlurTooltip, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
                ...tooltipProps,
                ...restTextFieldProps,
                elemBeforeInput: searchIcon,
                elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
                ...id !== undefined ? {
                    id: id
                } : {},
                // eslint-disable-next-line react-hooks/rules-of-hooks
                onFocus: (0, $eJOHy.useCallback)((event)=>{
                    onFocusTextField && onFocusTextField(event);
                    onFocusTooltip(event);
                }, [
                    onFocusTooltip
                ]),
                // eslint-disable-next-line react-hooks/rules-of-hooks
                onBlur: (0, $eJOHy.useCallback)((event)=>{
                    onBlurTextField && onBlurTextField(event);
                    onBlurTooltip(event);
                }, [
                    onBlurTooltip
                ]),
                ref: (0, $jd93d.mergeRefs)(textFieldRef, tooltipRef),
                "aria-describedby": tooltipAriaDescription || textfieldAriaDescription
            }))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        ...textFieldProps,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$84caf67c6542222b$var$SearchFieldUnmemoized.displayName = 'Search';
$84caf67c6542222b$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $84caf67c6542222b$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eJOHy.memo)($84caf67c6542222b$var$SearchFieldUnmemoized);
$84caf67c6542222b$export$b94867ecbd698f21.displayName = 'Search';
const $84caf67c6542222b$var$fitContainerStyles = (0, $1DXK0.xcss)({
    width: '100%'
});
const $84caf67c6542222b$var$reducedHeightStyles = (0, $1DXK0.xcss)({
    height: '32px'
});
const $84caf67c6542222b$var$themedBgStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error - Apply the dominant colour behind the search input for image background themes
    backgroundColor: (0, $1uv7v.Tokens).COLOR_ELEVATION_SURFACE /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ ,
    borderRadius: "var(--ds-border-radius, 4px)"
}); // Delete when cleaning up getIsSoftwareThemingM2Enabled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84caf67c6542222b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $84caf67c6542222b$var$InputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $awdRS.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $awdRS.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $awdRS.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _ffa416hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7CY7m", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1790c56385a948ce$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1790c56385a948ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("4jrRd", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $047d370cc11f69d8$export$84038b503874befa);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $1DXK0 = parcelRequire("1DXK0");
const $047d370cc11f69d8$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $047d370cc11f69d8$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo)))
    }));
const $047d370cc11f69d8$var$wrapperStylesCloseIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("ixnXK", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $fd1be89cde4ae981$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $fd1be89cde4ae981$export$8a82bff895521bd9);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6J9k6 = parcelRequire("6J9k6");

var $i0iAU = parcelRequire("i0iAU");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $1DXK0 = parcelRequire("1DXK0");
const $fd1be89cde4ae981$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i0iAU))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStyles,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $fd1be89cde4ae981$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStylesBefore,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
const $fd1be89cde4ae981$var$wrapperStyles = (0, $1DXK0.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $fd1be89cde4ae981$var$spacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $fd1be89cde4ae981$var$wrapperStylesBefore = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$spacingStylesBefore = (0, $1DXK0.xcss)({
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});
parcelRegister("6J9k6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40d49d14e43276e4147396a05e9540f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e5e2d758ad941bc$var$_react = $4e5e2d758ad941bc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4e5e2d758ad941bc$var$_cross = $4e5e2d758ad941bc$var$_interopRequireDefault((parcelRequire("6zhpo")));

var $4e5e2d758ad941bc$var$_cross2 = $4e5e2d758ad941bc$var$_interopRequireDefault((parcelRequire("laG04")));
function $4e5e2d758ad941bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4e5e2d758ad941bc$var$CrossIcon = (props)=>/*#__PURE__*/ $4e5e2d758ad941bc$var$_react.default.createElement($4e5e2d758ad941bc$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $4e5e2d758ad941bc$var$_cross2.default
    }, props));
$4e5e2d758ad941bc$var$CrossIcon.Name = 'CrossIconMigration';
var $4e5e2d758ad941bc$var$_default = module.exports.default = $4e5e2d758ad941bc$var$CrossIcon;

});






parcelRegister("hoXMy", function(module, exports) {

$parcel$export(module.exports, "gatherFields", () => $3f3cab4de8a849d2$export$af0604ea1b6b60ec);
$parcel$export(module.exports, "gatherIrremovableFields", () => $3f3cab4de8a849d2$export$2965c0f6ab2d5c39);

var $a6gy0 = parcelRequire("a6gy0");

var $80xRm = parcelRequire("80xRm");

var $7jTnu = parcelRequire("7jTnu");

var $4G98k = parcelRequire("4G98k");

var $22GDK = parcelRequire("22GDK");
/**
 * getDataFromHydratedData read the fieldsHydratedData to the data hashed by fieldId/jqlTerm
 */ const $3f3cab4de8a849d2$var$getDataFromHydratedData = ({ fieldsHydratedData: fieldsHydratedData })=>{
    const fieldsData = {};
    (fieldsHydratedData?.jira?.jqlBuilder?.hydrateJqlQuery ?? fieldsHydratedData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.forEach((hydratedField)=>{
        if (hydratedField.field && hydratedField.jqlTerm) {
            const { field: { displayName: displayName, searchTemplate: searchTemplate, type: type, description: description, operators: operators, fieldType: fieldType, shouldShowInContext: shouldShowInContext, shouldExcludeInScope: shouldExcludeInScope }, jqlTerm: jqlTerm } = hydratedField;
            // Searchable fields should always have a type & search template
            if (searchTemplate?.key == null || type == null) return;
            if (!fieldsData[jqlTerm.toLowerCase()]) fieldsData[jqlTerm.toLowerCase()] = {
                displayName: // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                displayName,
                searchTemplate: searchTemplate.key,
                fieldType: type,
                fieldDescription: description ?? null,
                fieldTypeDisplayName: fieldType?.displayName ?? null,
                operators: operators.map((0, $22GDK.mapOperators)),
                isDuplicated: false,
                shouldShowInContext: shouldShowInContext ?? true,
                shouldExcludeInScope: shouldExcludeInScope ?? false
            };
            else fieldsData[jqlTerm.toLowerCase()].isDuplicated = true;
        }
    });
    return fieldsData;
};
/**
 * getOptionalFieldsToRender takes data from the AST, selectedFields and hydrated data and generates Optional fields to render array
 */ const $3f3cab4de8a849d2$var$getOptionalFieldsToRender = ({ astClauseOrder: astClauseOrder, selectedFields: selectedFields, fieldsData: fieldsData, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId, excludedFields: excludedFields })=>{
    // First get an array of unique fields we want to add
    const allFields = [
        ...new Set([
            ...astClauseOrder,
            ...selectedFields.map((sf)=>sf.value.toLowerCase())
        ])
    ];
    // Create hash map with data of selected fields
    const selectedFieldsData = selectedFields.reduce((map, selectedField)=>{
        // eslint-disable-next-line no-param-reassign
        map[selectedField.value.toLowerCase()] = {
            displayName: selectedField.label,
            searchTemplate: selectedField.searchTemplate,
            fieldType: selectedField.fieldType,
            fieldDescription: selectedField.fieldDescription,
            operators: selectedField.operators,
            fieldTypeDisplayName: selectedField.fieldTypeDisplayName,
            isDuplicated: false,
            shouldShowInContext: true,
            shouldExcludeInScope: false
        };
        return map;
    }, {});
    const [fieldsWithHydration, fieldsMissingHydration] = (0, (/*@__PURE__*/$parcel$interopDefault($a6gy0)))(allFields, (fieldId)=>fieldsData[fieldId] ?? selectedFieldsData[fieldId]);
    // FG outside so it's not being evaluated for each field
    if ((0, $7jTnu.fg)('simple-plans-m2-release-feature-toggle')) {
        // Generate fields to render
        const optionalFieldsToRender = fieldsWithHydration.filter((fieldId)=>!excludedFields.includes(fieldId)).filter((fieldId)=>{
            if (fieldsData[fieldId]) return fieldsData[fieldId]?.shouldExcludeInScope !== true;
            if (selectedFieldsData[fieldId]) return selectedFieldsData[fieldId]?.shouldExcludeInScope !== true;
            // return true by default, including when field not found
            return true;
        }).map((fieldId)=>{
            const fieldData = fieldsData[fieldId] ?? selectedFieldsData[fieldId];
            const { isDuplicated: isDuplicated, searchTemplate: searchTemplate, fieldType: fieldType, displayName: displayName, fieldDescription: fieldDescription, operators: operators, fieldTypeDisplayName: fieldTypeDisplayName, shouldShowInContext: shouldShowInContext, shouldExcludeInScope: shouldExcludeInScope } = fieldData;
            const fieldToRender = {
                fieldId: fieldId,
                fieldLabel: displayName ?? undefined,
                fieldDescription: fieldDescription,
                fieldTypeDisplayName: fieldTypeDisplayName,
                shouldShowInContext: shouldShowInContext,
                shouldExcludeInScope: shouldExcludeInScope,
                // We want only to show non-duplicated fieldIds/jqlTerms
                ...isDuplicated ? {
                    picker: (0, $4G98k.getUnsupportedPickerType)({
                        searchTemplate: searchTemplate,
                        fieldType: fieldType
                    }),
                    clause: undefined,
                    secondaryClause: undefined
                } : {
                    picker: (0, $4G98k.getPickerType)({
                        searchTemplate: searchTemplate,
                        fieldType: fieldType,
                        operators: operators
                    }),
                    clause: clausesByFieldId[fieldId],
                    secondaryClause: secondaryClausesByFieldId[fieldId]
                }
            };
            return fieldToRender;
        });
        return {
            optionalFieldsToRender: optionalFieldsToRender,
            fieldsMissingHydration: fieldsMissingHydration
        };
    }
    // Generate fields to render
    const optionalFieldsToRender = fieldsWithHydration.filter((fieldId)=>!excludedFields.includes(fieldId)).map((fieldId)=>{
        const fieldData = fieldsData[fieldId] ?? selectedFieldsData[fieldId];
        const { isDuplicated: isDuplicated, searchTemplate: searchTemplate, fieldType: fieldType, displayName: displayName, fieldDescription: fieldDescription, operators: operators, fieldTypeDisplayName: fieldTypeDisplayName, shouldShowInContext: shouldShowInContext, shouldExcludeInScope: shouldExcludeInScope } = fieldData;
        const fieldToRender = {
            fieldId: fieldId,
            fieldLabel: displayName ?? undefined,
            fieldDescription: fieldDescription,
            fieldTypeDisplayName: fieldTypeDisplayName,
            shouldShowInContext: shouldShowInContext,
            shouldExcludeInScope: shouldExcludeInScope,
            // We want only to show non-duplicated fieldIds/jqlTerms
            ...isDuplicated ? {
                picker: (0, $4G98k.getUnsupportedPickerType)({
                    searchTemplate: searchTemplate,
                    fieldType: fieldType
                }),
                clause: undefined,
                secondaryClause: undefined
            } : {
                picker: (0, $4G98k.getPickerType)({
                    searchTemplate: searchTemplate,
                    fieldType: fieldType,
                    operators: operators
                }),
                clause: clausesByFieldId[fieldId],
                secondaryClause: secondaryClausesByFieldId[fieldId]
            }
        };
        return fieldToRender;
    });
    return {
        optionalFieldsToRender: optionalFieldsToRender,
        fieldsMissingHydration: fieldsMissingHydration
    };
};
/**
 * getIrremovableFieldsToRender
 */ const $3f3cab4de8a849d2$var$getIrremovableFieldsToRender = ({ clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId, excludedFields: excludedFields, irremovableFields: irremovableFields })=>{
    const irremovableFieldsToRender = [];
    irremovableFields.forEach((irremovableField)=>{
        const isIrremovableFieldConfiguredAsExcludedField = excludedFields.includes(irremovableField.jqlTerm);
        if (!isIrremovableFieldConfiguredAsExcludedField) irremovableFieldsToRender.push({
            isIrremovable: true,
            fieldId: irremovableField.jqlTerm,
            fieldLabel: irremovableField.displayName,
            picker: (0, $4G98k.getPickerType)({
                searchTemplate: irremovableField.searchTemplate,
                fieldType: irremovableField.fieldType,
                operators: irremovableField.operators
            }),
            fieldDescription: null,
            fieldTypeDisplayName: null,
            clause: clausesByFieldId[irremovableField.jqlTerm],
            secondaryClause: secondaryClausesByFieldId[irremovableField.jqlTerm]
        });
    });
    return irremovableFieldsToRender;
};
const $3f3cab4de8a849d2$export$af0604ea1b6b60ec = ({ selectedFields: selectedFields, excludedFields: excludedFields = [], intl: intl, fieldsHydratedData: fieldsHydratedData, previousFieldToRender: previousFieldToRender = [], irremovableFields: irremovableFields, astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId })=>{
    const { optionalFieldsToRender: optionalFieldsToRender, fieldsMissingHydration: fieldsMissingHydration } = $3f3cab4de8a849d2$var$getOptionalFieldsToRender({
        astClauseOrder: astClauseOrder,
        clausesByFieldId: clausesByFieldId,
        fieldsData: $3f3cab4de8a849d2$var$getDataFromHydratedData({
            fieldsHydratedData: fieldsHydratedData
        }),
        secondaryClausesByFieldId: secondaryClausesByFieldId,
        selectedFields: selectedFields,
        excludedFields: excludedFields
    });
    const fieldsToRender = $3f3cab4de8a849d2$var$getIrremovableFieldsToRender({
        clausesByFieldId: clausesByFieldId,
        secondaryClausesByFieldId: secondaryClausesByFieldId,
        excludedFields: excludedFields,
        intl: intl,
        irremovableFields: irremovableFields
    }).concat(optionalFieldsToRender);
    const missingHydration = fieldsMissingHydration.length > 0;
    /**
   * Keep order of fields in the more dropdown if order is provided
   * We use the order array to sort the fieldsToRender adding any new fields at the end
   * and then remove all the fields that doesn't exist anymore in the new fieldsToRender
   */ let sortedFieldsToRender = fieldsToRender;
    if (previousFieldToRender.length > 0) {
        const previousFieldToRendeFieldIds = previousFieldToRender.map((field)=>field.fieldId);
        sortedFieldsToRender = (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(fieldsToRender, (fieldToRender)=>{
            const index = previousFieldToRendeFieldIds.indexOf(fieldToRender.fieldId);
            return index === -1 ? previousFieldToRendeFieldIds.length : index;
        });
    }
    return {
        fieldsToRender: sortedFieldsToRender,
        optionalFieldsCount: astClauseOrder.length,
        missingHydration: missingHydration
    };
};
const $3f3cab4de8a849d2$export$2965c0f6ab2d5c39 = ({ excludedFields: excludedFields = [], intl: intl, irremovableFields: irremovableFields, astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId })=>{
    const fieldsToRender = $3f3cab4de8a849d2$var$getIrremovableFieldsToRender({
        clausesByFieldId: clausesByFieldId,
        secondaryClausesByFieldId: secondaryClausesByFieldId,
        excludedFields: excludedFields,
        intl: intl,
        irremovableFields: irremovableFields
    });
    return {
        fieldsToRender: fieldsToRender,
        optionalFieldsCount: astClauseOrder.length,
        missingHydration: true
    };
};

});

parcelRegister("idYtD", function(module, exports) {

$parcel$export(module.exports, "getAstSortFields", () => $d83676d08a0304e7$export$dcd0fae6e8b9823a);
const $d83676d08a0304e7$export$dcd0fae6e8b9823a = (ast)=>{
    if (ast && ast.query && ast.query.orderBy) return ast.query.orderBy.fields.map((orderByFieldFromAst)=>({
            jqlTerm: orderByFieldFromAst.field.value,
            direction: orderByFieldFromAst.direction ? orderByFieldFromAst.direction.value : undefined
        }));
    return [];
};

});



parcelRegister("lHTxM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "JQLEditorUIWithErrorBoundaryOld", () => $6aa7b8e93f45f0d1$export$92f0ecbbb0018d8e);
$parcel$export(module.exports, "default", () => $6aa7b8e93f45f0d1$export$2e2bcd8739ae039);

var $dnufc = parcelRequire("dnufc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $1KdDN = parcelRequire("1KdDN");

var $g8Az8 = parcelRequire("g8Az8");

var $lRq8t = parcelRequire("lRq8t");

var $gVAWF = parcelRequire("gVAWF");

var $cWcbh = parcelRequire("cWcbh");

var $5fhUb = parcelRequire("5fhUb");

var $8KuTC = parcelRequire("8KuTC");

var $4xbv3 = parcelRequire("4xbv3");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");

var $co0wp = parcelRequire("co0wp");

var $bNtSK = parcelRequire("bNtSK");

var $1gVNb = parcelRequire("1gVNb");

var $9dqYm = parcelRequire("9dqYm");

var $lyPdT = parcelRequire("lyPdT");

var $lzg2Z = parcelRequire("lzg2Z");

var $fvO8D = parcelRequire("fvO8D");

var $hoXMy = parcelRequire("hoXMy");

var $idYtD = parcelRequire("idYtD");

var $hxooo = parcelRequire("hxooo");

var $3XJDD = parcelRequire("3XJDD");

var $bYJeL = parcelRequire("bYJeL");

var $dlxet = parcelRequire("dlxet");

var $hC1P1 = parcelRequire("hC1P1");

var $8mM4q = parcelRequire("8mM4q");

var $4lOXU = parcelRequire("4lOXU");
/* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/graphql-naming  */ const $6aa7b8e93f45f0d1$var$JQL_EDITOR_HYDRATION_FRAGMENT = (0, $dnufc.default);
/* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/graphql-naming */ const $6aa7b8e93f45f0d1$var$JQLEditorUIOld = ({ query: query, onSearch: onSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields = [], onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, projectOptions: projectOptions, singleSelectFields: singleSelectFields, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown = false, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput = false, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker = false, contextJql: contextJql, viewContext: viewContext, scope: scope = null, suggestedUsersCount: suggestedUsersCount })=>{
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_END
        });
    }, [
        onPerformanceMark
    ]);
    // eslint-disable-next-line @atlassian/relay/query-restriction
    const hydratedData = (0, $j4oe4.usePreloadedQuery)((0, $cWcbh.HYDRATION_QUERY), hydrationQueryRef);
    const fieldsHydrationData = (0, $j4oe4.useFragment)($6aa7b8e93f45f0d1$var$JQL_EDITOR_HYDRATION_FRAGMENT, hydratedData);
    const loading = isHydrating ?? false;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (loading === false) onReady && onReady();
    }, [
        loading,
        onReady
    ]);
    const intl = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    const [textSearchInputClause] = (0, $lyPdT.useTextSearchInputClause)();
    const [{ astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId }] = (0, $fvO8D.useSearchState)();
    const { isShortcutsDialogIntegrationAvailable: isShortcutsDialogIntegrationAvailable } = (0, $lzg2Z.useIntegrateDotDialogContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { internalState: internalState, setInternalState: setInternalState } = (0, $4lOXU.useFieldsToRender)({
        query: query,
        loading: loading,
        fieldsHydrationData: fieldsHydrationData,
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    });
    const onSearchWrapper = (0, $eJOHy.useCallback)((jql)=>{
        if (onSearch) {
            setInternalState({
                internalJql: jql
            });
            onSearch(jql);
        }
    }, [
        onSearch,
        setInternalState
    ]);
    const onFieldsUpdate = (0, $eJOHy.useCallback)(({ fieldsToRender: fieldsToRender, selectedFields: selectedFields })=>{
        if (fieldsToRender !== undefined || selectedFields !== undefined) setInternalState({
            ...fieldsToRender !== undefined ? {
                fieldsToRender: fieldsToRender
            } : {},
            ...selectedFields !== undefined ? {
                selectedFields: selectedFields
            } : {}
        });
    }, [
        setInternalState
    ]);
    // Required fields are those that are never modified by the More dropdown (AddFilter component).
    // The More dropdown only manages optional fields.
    // Required fields:
    // - Cannot be added from the More dropdown
    // - Cannot be cleared from the More dropdown, if they are in the query, they remain in the query
    const requiredFields = (0, $eJOHy.useMemo)(()=>new Set([
            ...irremovableFields.keys(),
            ...excludedFields ?? []
        ]), [
        excludedFields,
        irremovableFields
    ]);
    const onClearAddFilterValues = (0, $eJOHy.useCallback)(()=>{
        const { fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount } = (0, $hoXMy.gatherFields)({
            selectedFields: [],
            excludedFields: excludedFields,
            intl: intl,
            fieldsHydratedData: fieldsHydrationData,
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        });
        setInternalState({
            selectedFields: [],
            fieldsToRender: fieldsToRender,
            optionalFieldsCount: optionalFieldsCount
        });
        onSearchWrapper((0, $hxooo.removeOptionalFieldsFromJql)(ast, requiredFields, textSearchInputClause));
    }, [
        ast,
        excludedFields,
        intl,
        fieldsHydrationData,
        irremovableFields,
        astClauseOrder,
        clausesByFieldId,
        secondaryClausesByFieldId,
        setInternalState,
        onSearchWrapper,
        requiredFields,
        textSearchInputClause
    ]);
    const { showLoadingState: showLoadingState, fieldsToRender: fieldsToRender, selectedFields: selectedFields, optionalFieldsCount: optionalFieldsCount } = internalState;
    const StyledListItemChildComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $bNtSK.default) : (0, $1gVNb.StyledListItemChild);
    const FieldWrapper = shouldUseListMarkup ? StyledListItemChildComponent : (0, $1gVNb.StyledChild);
    const orderByFieldCount = (0, $eJOHy.useMemo)(()=>showOrderByPicker ? (0, $idYtD.getAstSortFields)(ast).length : undefined, [
        ast,
        showOrderByPicker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showLoadingState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $co0wp.JQLEditorLoading), {
        fieldsToRender: fieldsToRender,
        optionalFieldsCount: optionalFieldsCount,
        shouldUseListMarkup: shouldUseListMarkup,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        orderByFieldsCount: orderByFieldCount
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9dqYm.ActivePopupKeyContainer), {
        createAnalyticsEvent: createAnalyticsEvent,
        onJourneyStart: onJourneyStart
    }, !hideTextSearchInput && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            fieldType: (0, $dTJxm.getTextSearchInputField)(),
            searchTemplate: (0, $dTJxm.getTextSearchInputField)(),
            refinementType: (0, $eqSys.PickerTypes).Text,
            propType: (0, $eqSys.GenericPropTypes).NoProp
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mM4q.TextSearchInput), {
        onSearchWrapper: onSearchWrapper,
        onJourneyStart: onJourneyStart,
        shouldUseListMarkup: shouldUseListMarkup,
        placeholder: searchPlaceholder
    })), fieldsToRender.map((fieldToRender)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
            key: fieldToRender.fieldId,
            attributes: {
                fieldType: fieldToRender.picker.fieldType,
                searchTemplate: fieldToRender.picker.searchTemplate,
                refinementType: fieldToRender.picker.pickerType,
                propType: fieldToRender.picker.propType
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYJeL.default), {
            key: fieldToRender.fieldId,
            fieldToRender: fieldToRender,
            onSearchWrapper: onSearchWrapper,
            onSwitchToJql: onSwitchToJql,
            fieldsToRender: fieldsToRender,
            selectedFields: selectedFields,
            onClearPicker: onFieldsUpdate,
            loading: loading,
            hydratedData: hydratedData,
            projectOptions: projectOptions,
            singleSelectFields: singleSelectFields,
            shouldUseListMarkup: shouldUseListMarkup,
            hideOperatorDropdown: hideOperatorDropdown,
            contextJql: contextJql,
            viewContext: viewContext,
            scope: scope,
            suggestedUsersCount: suggestedUsersCount
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3XJDD.AddFilter), {
        NoOptionComponent: NoOptionComponent,
        value: selectedFields,
        fieldsToRender: fieldsToRender,
        selectedFields: selectedFields,
        onSearchWrapper: onSearchWrapper,
        onClearValues: onClearAddFilterValues,
        onChange: onFieldsUpdate,
        excludeFields: requiredFields,
        contextJql: contextJql,
        viewContext: viewContext,
        scope: scope
    })), showOrderByPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dlxet.default), {
        ast: ast,
        onChange: onSearchWrapper,
        contextJql: contextJql,
        hydrationData: fieldsHydrationData,
        viewContext: viewContext,
        scope: scope
    })), isShortcutsDialogIntegrationAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hC1P1.AsyncRegisterSearchCriteriaToShortcutsDialog), {
        fieldsToRender: fieldsToRender,
        selectedFields: selectedFields,
        onChange: onFieldsUpdate
    })));
};
const $6aa7b8e93f45f0d1$export$92f0ecbbb0018d8e = (props)=>{
    const [ast] = (0, $lyPdT.useAST)();
    const getErrorAttributes = (0, $eJOHy.useCallback)((error)=>({
            ...(0, $g8Az8.isLoaderErrorAttributes)(error),
            anonymizedJql: ast.query ? ast.query.accept((0, $dTJxm.jqlAnonymizerVisitor)) : undefined
        }), [
        ast.query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "ui.jql-builder-basic.jql-editor.error-boundary",
        packageName: (0, $dTJxm.PACKAGE_NAME),
        teamName: (0, $dTJxm.TEAM_NAME),
        sendToPrivacyUnsafeSplunk: true,
        attributes: getErrorAttributes,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gVAWF.JQLBuilderErrorBoundryFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6aa7b8e93f45f0d1$var$JQLEditorUIOld, props));
};
const $6aa7b8e93f45f0d1$var$JQLEditorUI = ({ query: query, onSearch: onSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields = [], onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, AddFilterButtonComponent: AddFilterButtonComponent, hydrationData: hydrationData, isHydrating: isHydrating, projectOptions: projectOptions, singleSelectFields: singleSelectFields, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown = false, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput = false, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker = false, contextJql: contextJql, viewContext: viewContext, scope: scope = null, suggestedUsersCount: suggestedUsersCount })=>{
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_END
        });
    }, [
        onPerformanceMark
    ]);
    const fieldsHydrationData = (0, $j4oe4.useFragment)($6aa7b8e93f45f0d1$var$JQL_EDITOR_HYDRATION_FRAGMENT, hydrationData);
    const loading = isHydrating ?? false;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (loading === false) onReady && onReady();
    }, [
        loading,
        onReady
    ]);
    const intl = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    const [textSearchInputClause] = (0, $lyPdT.useTextSearchInputClause)();
    const [{ astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId }] = (0, $fvO8D.useSearchState)();
    const { isShortcutsDialogIntegrationAvailable: isShortcutsDialogIntegrationAvailable } = (0, $lzg2Z.useIntegrateDotDialogContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { internalState: internalState, setInternalState: setInternalState } = (0, $4lOXU.useFieldsToRender)({
        query: query,
        loading: loading,
        fieldsHydrationData: fieldsHydrationData,
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    });
    const onSearchWrapper = (0, $eJOHy.useCallback)((jql)=>{
        if (onSearch) {
            setInternalState({
                internalJql: jql
            });
            onSearch(jql);
        }
    }, [
        onSearch,
        setInternalState
    ]);
    const onFieldsUpdate = (0, $eJOHy.useCallback)(({ fieldsToRender: fieldsToRender, selectedFields: selectedFields })=>{
        if (fieldsToRender !== undefined || selectedFields !== undefined) setInternalState({
            ...fieldsToRender !== undefined ? {
                fieldsToRender: fieldsToRender
            } : {},
            ...selectedFields !== undefined ? {
                selectedFields: selectedFields
            } : {}
        });
    }, [
        setInternalState
    ]);
    // Required fields are those that are never modified by the More dropdown (AddFilter component).
    // The More dropdown only manages optional fields.
    // Required fields:
    // - Cannot be added from the More dropdown
    // - Cannot be cleared from the More dropdown, if they are in the query, they remain in the query
    const requiredFields = (0, $eJOHy.useMemo)(()=>new Set([
            ...irremovableFields.keys(),
            ...excludedFields ?? []
        ]), [
        excludedFields,
        irremovableFields
    ]);
    const onClearAddFilterValues = (0, $eJOHy.useCallback)(()=>{
        const { fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount } = (0, $hoXMy.gatherFields)({
            selectedFields: [],
            excludedFields: excludedFields,
            intl: intl,
            fieldsHydratedData: fieldsHydrationData,
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        });
        setInternalState({
            selectedFields: [],
            fieldsToRender: fieldsToRender,
            optionalFieldsCount: optionalFieldsCount
        });
        onSearchWrapper((0, $hxooo.removeOptionalFieldsFromJql)(ast, requiredFields, textSearchInputClause));
    }, [
        ast,
        excludedFields,
        intl,
        fieldsHydrationData,
        irremovableFields,
        astClauseOrder,
        clausesByFieldId,
        secondaryClausesByFieldId,
        setInternalState,
        onSearchWrapper,
        requiredFields,
        textSearchInputClause
    ]);
    const { showLoadingState: showLoadingState, fieldsToRender: fieldsToRender, selectedFields: selectedFields, optionalFieldsCount: optionalFieldsCount } = internalState;
    const StyledListItemChildComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $bNtSK.default) : (0, $1gVNb.StyledListItemChild);
    const FieldWrapper = shouldUseListMarkup ? StyledListItemChildComponent : (0, $1gVNb.StyledChild);
    const orderByFieldCount = (0, $eJOHy.useMemo)(()=>showOrderByPicker ? (0, $idYtD.getAstSortFields)(ast).length : undefined, [
        ast,
        showOrderByPicker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showLoadingState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $co0wp.JQLEditorLoading), {
        fieldsToRender: fieldsToRender,
        optionalFieldsCount: optionalFieldsCount,
        shouldUseListMarkup: shouldUseListMarkup,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        orderByFieldsCount: orderByFieldCount
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9dqYm.ActivePopupKeyContainer), {
        createAnalyticsEvent: createAnalyticsEvent,
        onJourneyStart: onJourneyStart
    }, !hideTextSearchInput && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            fieldType: (0, $dTJxm.getTextSearchInputField)(),
            searchTemplate: (0, $dTJxm.getTextSearchInputField)(),
            refinementType: (0, $eqSys.PickerTypes).Text,
            propType: (0, $eqSys.GenericPropTypes).NoProp
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mM4q.TextSearchInput), {
        onSearchWrapper: onSearchWrapper,
        onJourneyStart: onJourneyStart,
        shouldUseListMarkup: shouldUseListMarkup,
        placeholder: searchPlaceholder
    })), fieldsToRender.map((fieldToRender)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
            key: fieldToRender.fieldId,
            attributes: {
                fieldType: fieldToRender.picker.fieldType,
                searchTemplate: fieldToRender.picker.searchTemplate,
                refinementType: fieldToRender.picker.pickerType,
                propType: fieldToRender.picker.propType
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYJeL.default), {
            key: fieldToRender.fieldId,
            fieldToRender: fieldToRender,
            onSearchWrapper: onSearchWrapper,
            onSwitchToJql: onSwitchToJql,
            fieldsToRender: fieldsToRender,
            selectedFields: selectedFields,
            onClearPicker: onFieldsUpdate,
            loading: loading,
            hydratedData: hydrationData,
            projectOptions: projectOptions,
            singleSelectFields: singleSelectFields,
            shouldUseListMarkup: shouldUseListMarkup,
            hideOperatorDropdown: hideOperatorDropdown,
            contextJql: contextJql,
            viewContext: viewContext,
            scope: scope,
            suggestedUsersCount: suggestedUsersCount
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3XJDD.AddFilter), {
        NoOptionComponent: NoOptionComponent,
        ButtonComponent: AddFilterButtonComponent,
        value: selectedFields,
        fieldsToRender: fieldsToRender,
        selectedFields: selectedFields,
        onSearchWrapper: onSearchWrapper,
        onClearValues: onClearAddFilterValues,
        onChange: onFieldsUpdate,
        excludeFields: requiredFields,
        contextJql: contextJql,
        viewContext: viewContext,
        scope: scope
    })), showOrderByPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dlxet.default), {
        ast: ast,
        onChange: onSearchWrapper,
        contextJql: contextJql,
        hydrationData: fieldsHydrationData,
        viewContext: viewContext,
        scope: scope
    })), isShortcutsDialogIntegrationAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hC1P1.AsyncRegisterSearchCriteriaToShortcutsDialog), {
        fieldsToRender: fieldsToRender,
        selectedFields: selectedFields,
        onChange: onFieldsUpdate
    })));
};
const $6aa7b8e93f45f0d1$var$JQLEditorUIWithErrorBoundary = (props)=>{
    const [ast] = (0, $lyPdT.useAST)();
    const getErrorAttributes = (0, $eJOHy.useCallback)((error)=>({
            ...(0, $g8Az8.isLoaderErrorAttributes)(error),
            anonymizedJql: ast.query ? ast.query.accept((0, $dTJxm.jqlAnonymizerVisitor)) : undefined
        }), [
        ast.query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "ui.jql-builder-basic.jql-editor.error-boundary",
        packageName: (0, $dTJxm.PACKAGE_NAME),
        teamName: (0, $dTJxm.TEAM_NAME),
        sendToPrivacyUnsafeSplunk: true,
        attributes: getErrorAttributes,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gVAWF.JQLBuilderErrorBoundryFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6aa7b8e93f45f0d1$var$JQLEditorUI, props));
};
var $6aa7b8e93f45f0d1$export$2e2bcd8739ae039 = $6aa7b8e93f45f0d1$var$JQLEditorUIWithErrorBoundary;

});
parcelRegister("dnufc", function(module, exports) {

$parcel$export(module.exports, "default", () => $51101ccdaf4275fd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bd212cab142d3ad3dcabb80999462fd8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $51101ccdaf4275fd$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v1 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlTerm"
                                },
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        },
                                        {
                                            "condition": "isPlanReleaseFeatureToggleEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        v0 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "shouldExcludeInScope"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraFieldType",
                                            "kind": "LinkedField",
                                            "name": "fieldType",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "isPlanReleaseFeatureToggleEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI",
        "selections": [
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v3 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v3 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$51101ccdaf4275fd$var$node.hash = "2e5853cb23c29f7d40742951bd6a87bb";
var $51101ccdaf4275fd$export$2e2bcd8739ae039 = $51101ccdaf4275fd$var$node;

});

parcelRegister("gVAWF", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderErrorBoundryFallback", () => $753680c12bef645e$export$4c766016a5659721);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $iHPvF = parcelRequire("iHPvF");

var $lRq8t = parcelRequire("lRq8t");

var $hN3Oc = parcelRequire("hN3Oc");
const $753680c12bef645e$var$onRefresh = ()=>{
    if (typeof window !== 'undefined') window.location.reload();
};
const $753680c12bef645e$export$4c766016a5659721 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "error",
        testId: "jql-builder-common.ui.error-boundry-fallback.section-message"
    }, formatMessage((0, $hN3Oc.default).errorMessage, {
        link: (linkText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "link",
                spacing: "none",
                onClick: $753680c12bef645e$var$onRefresh
            }, linkText)
    }));
};

});
parcelRegister("hN3Oc", function(module, exports) {

$parcel$export(module.exports, "default", () => $26ab64dd92055a31$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $26ab64dd92055a31$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "jql-builder-common.error-boundry-fallback.error-message",
        "defaultMessage": "We couldn't load your search criteria. <link>Refresh the page</link> to try again."
    }
});

});


parcelRegister("9dqYm", function(module, exports) {

$parcel$export(module.exports, "ActivePopupKeyContainer", () => $0498275d6a05dd5d$export$a23bda26408a297f);
$parcel$export(module.exports, "useActivePopupKey", () => $0498275d6a05dd5d$export$f374a0a655a12cf3);

var $gCeeo = parcelRequire("gCeeo");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $dTJxm = parcelRequire("dTJxm");
const $0498275d6a05dd5d$var$store = (0, $GtRbT.createStore)({
    initialState: {
        activeKey: ''
    },
    actions: {
        openPopup: (key)=>({ setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, onJourneyStart: onJourneyStart })=>{
                setState({
                    activeKey: key
                });
                if (onJourneyStart) {
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'opened',
                        actionSubject: 'dropdown'
                    });
                    const attributes = onJourneyStart();
                    // Only checking if it matches the "More +" dropdown.
                    // Not sending the key name directly as it would result in UGC for custom fields
                    attributes.isMoreFilters = String(key === (0, $dTJxm.ADD_FILTER_DROPDOWN));
                    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'refinementBarBasicPicker', attributes);
                }
            },
        closePopup: (key)=>({ getState: getState, setState: setState })=>{
                const { activeKey: activeKey } = getState();
                if (key === activeKey) setState({
                    activeKey: ''
                });
            },
        closeAllPopups: ()=>({ setState: setState })=>{
                setState({
                    activeKey: ''
                });
            }
    },
    name: 'JQLBasic-ActivePopup'
});
const $0498275d6a05dd5d$export$a23bda26408a297f = (0, $6E16M.createContainer)($0498275d6a05dd5d$var$store, {});
const $0498275d6a05dd5d$export$f374a0a655a12cf3 = (0, $iJq0l.createHook)($0498275d6a05dd5d$var$store, {
    selector: ({ activeKey: activeKey })=>activeKey
});

});

parcelRegister("lzg2Z", function(module, exports) {

$parcel$export(module.exports, "useIntegrateDotDialogContext", () => $cc4956edece29853$export$705d46354f301b1c);
$parcel$export(module.exports, "ShortcutsDialogIntegrationProvider", () => $cc4956edece29853$export$97e3ca22c7078b46);

var $eJOHy = parcelRequire("eJOHy");
const $cc4956edece29853$var$PRESET_VALUE = {
    DEFAULT: {
        isShortcutsDialogIntegrationAvailable: false
    },
    INTEGRATED: {
        isShortcutsDialogIntegrationAvailable: true
    }
};
const $cc4956edece29853$var$IntegrateDotDialogContext = /*#__PURE__*/ (0, $eJOHy.createContext)($cc4956edece29853$var$PRESET_VALUE.DEFAULT);
const $cc4956edece29853$export$705d46354f301b1c = ()=>(0, $eJOHy.useContext)($cc4956edece29853$var$IntegrateDotDialogContext);
const $cc4956edece29853$export$97e3ca22c7078b46 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cc4956edece29853$var$IntegrateDotDialogContext.Provider, {
        value: $cc4956edece29853$var$PRESET_VALUE.INTEGRATED
    }, children);

});

parcelRegister("hxooo", function(module, exports) {

$parcel$export(module.exports, "removeOptionalFieldsFromJql", () => $aef13f8f878a4e55$export$b5bca93ddaa14d75);

var $1jiqw = parcelRequire("1jiqw");
var $41qTw = parcelRequire("41qTw");

var $jwox6 = parcelRequire("jwox6");
const $aef13f8f878a4e55$export$b5bca93ddaa14d75 = (ast, requiredFields, textSearchInputClause)=>{
    (0, $41qTw.walkAST)({
        enterTerminalClause (terminalClause) {
            const isTextSearchInput = textSearchInputClause && new (0, $jwox6.IsInCompoundClauseVisitor)(terminalClause).visit(textSearchInputClause);
            if (!requiredFields.has(terminalClause.field.value.toLowerCase()) && !isTextSearchInput) terminalClause.remove();
        }
    }, ast);
    return (0, $1jiqw.print)(ast, {
        operatorCase: 'upper'
    });
};

});
parcelRegister("41qTw", function(module, exports) {

$parcel$export(module.exports, "walkAST", () => $669df150c3d9c2ae$export$a8de6ce748deffac);
const $669df150c3d9c2ae$export$a8de6ce748deffac = (listener, jast)=>{
    jast.query && $669df150c3d9c2ae$var$walkNode(listener, jast.query);
};
const $669df150c3d9c2ae$var$walkNode = (listener, node)=>{
    listener.enterEveryNode && listener.enterEveryNode(node);
    node.enterNode(listener);
    node.getChildren().forEach((child)=>$669df150c3d9c2ae$var$walkNode(listener, child));
    node.exitNode(listener);
    listener.exitEveryNode && listener.exitEveryNode(node);
};

});

parcelRegister("jwox6", function(module, exports) {

$parcel$export(module.exports, "IsInCompoundClauseVisitor", () => $2eeee74e30a7e1d2$export$e2ad94bc9eac2e29);

var $dl9fK = parcelRequire("dl9fK");
class $2eeee74e30a7e1d2$export$e2ad94bc9eac2e29 extends (0, $dl9fK.AbstractJastVisitor) {
    constructor(terminalClause){
        super(), this.visitCompoundClause = (compoundClause)=>compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), false), this.visitTerminalClause = (terminalClause)=>terminalClause === this.terminalClause, this.aggregateResult = (aggregate, nextResult)=>aggregate || nextResult;
        this.terminalClause = terminalClause;
    }
    defaultResult() {
        return false;
    }
}

});


parcelRegister("3XJDD", function(module, exports) {

$parcel$export(module.exports, "AddFilter", () => $e3217184ed46e165$export$b317d04196c5962b);

var $eJOHy = parcelRequire("eJOHy");

var $1OQKp = parcelRequire("1OQKp");

var $goZPP = parcelRequire("goZPP");

var $jQjGM = parcelRequire("jQjGM");

var $3cMgR = parcelRequire("3cMgR");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $epTsa = parcelRequire("epTsa");

var $d9b92 = parcelRequire("d9b92");

var $jd93d = parcelRequire("jd93d");

var $ch9En = parcelRequire("ch9En");

var $iqtgH = parcelRequire("iqtgH");

var $6XJko = parcelRequire("6XJko");

var $bQWwW = parcelRequire("bQWwW");

var $ixh2S = parcelRequire("ixh2S");

var $izTXQ = parcelRequire("izTXQ");

var $9dqYm = parcelRequire("9dqYm");

var $lyPdT = parcelRequire("lyPdT");

var $4G98k = parcelRequire("4G98k");

var $2ftMY = parcelRequire("2ftMY");

var $3SxQz = parcelRequire("3SxQz");

var $ce3v0 = parcelRequire("ce3v0");

var $dTJxm = parcelRequire("dTJxm");

var $4kCrw = parcelRequire("4kCrw");

const $e3217184ed46e165$export$f5aa183e0b797cbf = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("Nqkfo")), {
    ssr: false,
    moduleId: "./src/packages/jql-builder/basic-picker/src/index.tsx"
});
const $e3217184ed46e165$var$TriggerButtonWithMergeRef = ({ triggerRef: triggerRef, popupRef: popupRef, ButtonComponent: ButtonComponent, ...props })=>{
    const ref = (0, $jd93d.default)(triggerRef, popupRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ButtonComponent, {
        ref: ref,
        ...props
    });
};
const $e3217184ed46e165$var$isKeyboardEvent = (event)=>Object.hasOwn(event, 'key');
const $e3217184ed46e165$export$b317d04196c5962b = ({ value: value, fieldsToRender: fieldsToRender, selectedFields: selectedFields, onSearchWrapper: onSearchWrapper, onClearValues: onClearValues, NoOptionComponent: NoOptionComponent, onChange: onChange, excludeFields: excludeFields, contextJql: contextJql, viewContext: viewContext, scope: scope, ButtonComponent: ButtonComponent = (0, $goZPP.default) })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [activePopupKey, { openPopup: openPopup, closePopup: closePopup }] = (0, $9dqYm.useActivePopupKey)();
    const onOpen = (0, $eJOHy.useCallback)(()=>{
        // Fire the experiment exposure
        (0, $epTsa.expVal)('efa_and_project_fields_page_for_tmp', 'isEnabled', false);
        return openPopup((0, $dTJxm.ADD_FILTER_DROPDOWN));
    }, [
        openPopup
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>closePopup((0, $dTJxm.ADD_FILTER_DROPDOWN)), [
        closePopup
    ]);
    const [ast] = (0, $lyPdT.useAST)();
    const [textSearchInputClause] = (0, $lyPdT.useTextSearchInputClause)();
    const excludedFields = (0, $eJOHy.useMemo)(()=>Array.from(excludeFields), [
        excludeFields
    ]);
    const onLoadOptions = (0, $2ftMY.useFields)({
        jql: contextJql,
        excludeFields: excludedFields,
        viewContext: viewContext,
        scope: scope
    });
    const isOpen = activePopupKey === (0, $dTJxm.ADD_FILTER_DROPDOWN);
    const sendAnalytics = (0, $ce3v0.useSendAnalytics)();
    const buttonRef = (0, $eJOHy.useRef)(null);
    const iconAfter = (0, $eJOHy.useMemo)(()=>(0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
            label: "",
            color: // eslint-disable-next-line no-nested-ternary
            (0, $7jTnu.fg)('visual-refresh-headers-buttons') ? !isOpen ? "var(--ds-icon-subtle, #626F86)" : 'currentColor' : 'currentColor',
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQjGM))), {
            label: "",
            LEGACY_size: "small"
        }), [
        isOpen
    ]);
    const buttonLabel = (0, $eJOHy.useMemo)(()=>{
        // eslint-disable-next-line no-nested-ternary
        return (0, $6XJko.isVisualRefreshEnabled)() ? (0, $7jTnu.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            weight: "medium",
            color: !isOpen ? 'color.text.subtle' : 'inherit'
        }, formatMessage((0, $izTXQ.default).moreButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $izTXQ.default).moreButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $izTXQ.default).moreButtonOld));
    }, [
        isOpen,
        formatMessage
    ]);
    const loadingMessages = (0, $eJOHy.useMemo)(()=>{
        return (0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix') ? {
            paginationStart: formatMessage((0, $4kCrw.default).loadingMessageStart),
            paginationEnd: formatMessage((0, $4kCrw.default).loadingMessageEnd)
        } : undefined;
    }, [
        formatMessage
    ]);
    const handleClose = (0, $eJOHy.useCallback)((event)=>{
        onClose();
        if ($e3217184ed46e165$var$isKeyboardEvent(event) && event.key === 'Escape') buttonRef.current?.focus();
    }, [
        onClose
    ]);
    const CustomNoOptionsMessage = (0, $eJOHy.useCallback)(()=>NoOptionComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NoOptionComponent, {
            onClickLink: onClose,
            sourceId: "moreFieldsPicker"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
            actionSubject: "unsupportedFieldsMessage",
            action: "viewed",
            actionSubjectId: "moreFieldsPicker"
        })) : undefined, [
        NoOptionComponent,
        onClose
    ]);
    const onTrigger = (0, $eJOHy.useCallback)(({ ref: ref })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3217184ed46e165$var$TriggerButtonWithMergeRef, {
            triggerRef: buttonRef,
            popupRef: ref,
            appearance: "default",
            iconAfter: iconAfter,
            isSelected: isOpen,
            "aria-expanded": isOpen,
            onClick: isOpen ? onClose : onOpen,
            label: formatMessage((0, $izTXQ.default).moreButtonLabel),
            "aria-label": formatMessage((0, $izTXQ.default).moreButtonLabel),
            testId: "jql-builder-basic.ui.jql-editor.add-filter.more-button",
            ButtonComponent: ButtonComponent
        }, buttonLabel);
    }, [
        iconAfter,
        isOpen,
        onClose,
        onOpen,
        formatMessage,
        ButtonComponent,
        buttonLabel
    ]);
    const handleChange = (0, $eJOHy.useCallback)((options, meta)=>{
        switch(meta.action){
            case (0, $d9b92.MetaActions).selectOption:
                if ('option' in meta && meta.option?.optionType === 'field') {
                    const newSelectedFields = [
                        ...selectedFields,
                        meta.option
                    ];
                    const picker = (0, $4G98k.getPickerType)({
                        fieldType: meta.option.fieldType,
                        searchTemplate: meta.option.searchTemplate,
                        operators: meta.option.operators
                    });
                    const newFieldsToRender = [
                        ...fieldsToRender,
                        {
                            fieldId: meta.option.value,
                            fieldLabel: meta.option.label,
                            picker: picker,
                            clause: undefined,
                            secondaryClause: undefined,
                            fieldDescription: meta.option.fieldDescription,
                            fieldTypeDisplayName: meta.option.fieldTypeDisplayName
                        }
                    ];
                    onChange({
                        selectedFields: newSelectedFields,
                        fieldsToRender: newFieldsToRender
                    });
                    openPopup(meta.option.value);
                    sendAnalytics({
                        actionSubjectId: 'addFilter',
                        attributes: {
                            fieldType: picker.fieldType,
                            searchTemplate: picker.searchTemplate,
                            refinementType: picker.pickerType,
                            propType: picker.propType
                        }
                    });
                }
                break;
            case (0, $d9b92.MetaActions).deselectOption:
                if ('option' in meta && meta.option?.optionType === 'field' && !meta.option.isDisabled) {
                    const newSelectedFields = selectedFields.filter((activeField)=>meta.option?.optionType === 'field' && meta.option.value !== activeField.value);
                    const newFieldsToRender = fieldsToRender.filter((fieldToRender)=>{
                        if (meta.option?.optionType === 'field' && meta.option?.value === fieldToRender.fieldId) {
                            onSearchWrapper && onSearchWrapper((0, $3SxQz.removeFieldsFromJql)(ast, new Set([
                                fieldToRender.fieldId
                            ]), textSearchInputClause));
                            return !!(fieldToRender.secondaryClause || fieldToRender.clause);
                        }
                        return true;
                    });
                    onChange({
                        selectedFields: newSelectedFields,
                        fieldsToRender: newFieldsToRender
                    });
                    const picker = (0, $4G98k.getPickerType)({
                        fieldType: meta.option.fieldType,
                        searchTemplate: meta.option.searchTemplate,
                        operators: meta.option.operators
                    });
                    sendAnalytics({
                        actionSubjectId: 'removeFilter',
                        attributes: {
                            fieldType: picker.fieldType,
                            searchTemplate: picker.searchTemplate,
                            refinementType: picker.pickerType,
                            propType: picker.propType,
                            isOnlyUnselectable: meta.option.isOnlyUnselectable ?? false
                        }
                    });
                }
                break;
            default:
        }
    }, [
        ast,
        fieldsToRender,
        onChange,
        onSearchWrapper,
        openPopup,
        textSearchInputClause,
        selectedFields,
        sendAnalytics
    ]);
    const TriggerButton = ButtonComponent ?? (0, $goZPP.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $7jTnu.fg)('render_jql_builder_in_ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixh2S.Picker), {
        isOpen: isOpen,
        onClose: handleClose,
        value: value,
        id: (0, $dTJxm.ADD_FILTER_DROPDOWN),
        onChange: handleChange,
        onLoadOptions: onLoadOptions,
        enableFullList: false,
        onTrigger: onTrigger,
        onClearValues: onClearValues,
        CustomNoOptionsMessage: CustomNoOptionsMessage,
        shouldRenderToParent: true,
        searchInputPlaceholder: formatMessage((0, $izTXQ.default).searchMoreFiltersPlaceholder),
        loadingMessages: loadingMessages
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "add-filter-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TriggerButton, {
            iconAfter: iconAfter
        }, buttonLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3217184ed46e165$export$f5aa183e0b797cbf, {
        isOpen: isOpen,
        onClose: handleClose,
        value: value,
        id: (0, $dTJxm.ADD_FILTER_DROPDOWN),
        onChange: handleChange,
        onLoadOptions: onLoadOptions,
        enableFullList: false,
        onTrigger: onTrigger,
        onClearValues: onClearValues,
        CustomNoOptionsMessage: CustomNoOptionsMessage,
        shouldRenderToParent: true,
        searchInputPlaceholder: formatMessage((0, $izTXQ.default).searchMoreFiltersPlaceholder),
        loadingMessages: loadingMessages
    })));
};
var $e3217184ed46e165$export$2e2bcd8739ae039 = $e3217184ed46e165$export$b317d04196c5962b;

});
parcelRegister("d9b92", function(module, exports) {

$parcel$export(module.exports, "MetaActions", () => $5ca44d217725f710$export$50531cf3046c5956);
const $5ca44d217725f710$export$50531cf3046c5956 = {
    setValue: 'set-value',
    inputChange: 'input-change',
    inputBlur: 'input-blur',
    menuClose: 'menu-close',
    selectOption: 'select-option',
    deselectOption: 'deselect-option',
    removeValue: 'remove-value',
    popValue: 'pop-value',
    clear: 'clear',
    createOption: 'create-option',
    clearOptions: 'clear-options',
    add: 'add',
    remove: 'remove',
    update: 'update'
};

});

parcelRegister("ixh2S", function(module, exports) {

$parcel$export(module.exports, "Picker", () => $e80b57c94adae16a$export$ba25329847403e11);

var $eJOHy = parcelRequire("eJOHy");

var $kJsb4 = parcelRequire("kJsb4");

var $8IeH1 = parcelRequire("8IeH1");

var $7jTnu = parcelRequire("7jTnu");

var $d0VAM = parcelRequire("d0VAM");

var $hEe9x = parcelRequire("hEe9x");

var $5LwVz = parcelRequire("5LwVz");
const $e80b57c94adae16a$export$ba25329847403e11 = ({ isOpen: isPickerOpen, value: value, onClose: onClose, onClearValues: onClearValues, onRestoreDefaults: onRestoreDefaults, id: id, invalidLabel: invalidLabel, onChange: onChange, onSortOptions: onSortOptions, formatOptionLabel: formatOptionLabel = (0, $hEe9x.default), onLoadOptions: onLoadOptions, enableFullList: enableFullList, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, PopupComponent: PopupComponent, onTrigger: onTrigger, placement: placement = 'bottom-start', zIndex: zIndex, CustomNoOptionsMessage: CustomNoOptionsMessage, pickerComponents: pickerComponents, fallbackPlacements: fallbackPlacements, showOperatorSelect: showOperatorSelect = false, onChangeOperator: onChangeOperator, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti, searchInputPlaceholder: searchInputPlaceholder, shouldRenderToParent: shouldRenderToParent = false, experienceAnalyticsAttributes: experienceAnalyticsAttributes, isLoading: isLoading = false, CustomFooter: CustomFooter, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled = false, loadingMessages: loadingMessages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        role: "presentation",
        onKeyDown: (event)=>{
            if (event.key === 'Escape') {
                // avoid closing a modal on closing a picker with esc key
                isPickerOpen && event.stopPropagation();
                onClose && onClose(event);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
        key: id,
        zIndex: zIndex,
        placement: placement,
        isOpen: isPickerOpen,
        onClose: onClose,
        popupComponent: PopupComponent ?? (0, $5LwVz.FixedWidthPopupComponent),
        trigger: onTrigger,
        autoFocus: false,
        fallbackPlacements: fallbackPlacements,
        testId: `jql-builder-basic-picker-${id}`,
        shouldRenderToParent: shouldRenderToParent,
        /* Our default popup component supports resizing to fit the viewport. */ shouldFitViewport: PopupComponent === undefined,
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d0VAM.default), {
                id: id,
                invalidLabel: invalidLabel,
                enableFullList: enableFullList,
                operandDisplayValues: operandDisplayValues,
                showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
                loadOptions: onLoadOptions,
                onChange: onChange,
                onSortOptions: onSortOptions,
                value: value,
                formatOptionLabel: formatOptionLabel,
                onClear: onClearValues,
                onRestoreDefaults: onRestoreDefaults,
                NoOptionsMessage: CustomNoOptionsMessage,
                components: pickerComponents,
                showOperatorSelect: showOperatorSelect,
                onChangeOperator: onChangeOperator,
                allowedOperators: allowedOperators,
                selectedOperator: selectedOperator,
                isMulti: isMulti,
                placeholder: searchInputPlaceholder,
                setInitialFocusRef: setInitialFocusRef,
                experienceAnalyticsAttributes: experienceAnalyticsAttributes,
                isLoading: isLoading,
                isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
                CustomFooter: (0, $7jTnu.fg)('jira_inline_field_config_gate') ? CustomFooter : undefined,
                loadingMessages: loadingMessages
            })
    }));
$e80b57c94adae16a$export$ba25329847403e11.whyDidYouRender = {
    customName: 'Picker'
};

});
parcelRegister("d0VAM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc6c8c7998de8b9$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gyBpf = parcelRequire("gyBpf");

var $cSmYj = parcelRequire("cSmYj");

var $2ZGUP = parcelRequire("2ZGUP");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $9cbmy = parcelRequire("9cbmy");

var $gMbEk = parcelRequire("gMbEk");

var $j8m5Z = parcelRequire("j8m5Z");

var $f3ko0 = parcelRequire("f3ko0");

var $f1iCr = parcelRequire("f1iCr");

var $1fUys = parcelRequire("1fUys");

var $5lNLi = parcelRequire("5lNLi");

var $j7wtI = parcelRequire("j7wtI");

var $fSowc = parcelRequire("fSowc");

var $icknm = parcelRequire("icknm");

var $bWslp = parcelRequire("bWslp");

var $7XraK = parcelRequire("7XraK");
const $8bc6c8c7998de8b9$var$MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568
const $8bc6c8c7998de8b9$var$selectStyles = {
    container: (baseStyles)=>({
            ...baseStyles,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        })
};
const $8bc6c8c7998de8b9$var$getLoadingMessage = ({ isLoadingPaginationStart: isLoadingPaginationStart, isLoadingPaginationEnd: isLoadingPaginationEnd, loadingMessages: loadingMessages, formatMessage: formatMessage })=>{
    if (isLoadingPaginationStart) return loadingMessages?.paginationStart || formatMessage((0, $7XraK.default).loadingStart);
    if (isLoadingPaginationEnd) return loadingMessages?.paginationEnd || formatMessage((0, $7XraK.default).loadingEnd);
    return undefined;
};
const $8bc6c8c7998de8b9$export$f2aa4c50966ce803 = ()=>(0, $eJOHy.useState)(false);
const $8bc6c8c7998de8b9$var$PaginatedAsyncSelectView = ({ id: id, onMenuScrollToBottom: onMenuScrollToBottom, onMenuScrollToTop: onMenuScrollToTop, placeholder: placeholder, invalidLabel: invalidLabel, enableFullList: enableFullListProp, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, loadOptions: loadOptions, onInputChange: onInputChange, value: value, onChange: onChange, onChangeOperator: onChangeOperator, onSortOptions: onSortOptions, onClear: onClear, onRestoreDefaults: onRestoreDefaults, components: customComponents, showOperatorSelect: showOperatorSelect, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti = true, setInitialFocusRef: setInitialFocusRef, isLoading: isLoadingExternal, CustomFooter: CustomFooter, onKeyDown: onKeyDown, loadingMessages: loadingMessages, ...restProps })=>{
    const prevValue = (0, $6d9QY.usePreviousWithInitial)(value);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const paginatedComponents = (0, $eJOHy.useMemo)(()=>({
            ...(0, $j7wtI.selectComponents),
            MenuList: $f3ko0.MenuList
        }), []);
    const paginatedSingleSelectComponents = (0, $eJOHy.useMemo)(()=>({
            ...(0, $j7wtI.singleSelectComponents),
            Option: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fSowc.default), {
                    ...props,
                    isMulti: false
                }),
            MenuList: $f3ko0.MenuList
        }), []);
    const [isLoadingInternal, setIsLoading] = (0, $eJOHy.useState)(true);
    const [isPaginationLoading, setIsPaginationLoading] = (0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix' // eslint-disable-next-line react-hooks/react-compiler
    ) // eslint-disable-next-line react-hooks/rules-of-hooks
     ? $8bc6c8c7998de8b9$export$f2aa4c50966ce803() : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useState)(false);
    const [inputValue, setInputValue] = (0, $eJOHy.useState)('');
    const [loadedOptions, setLoadedOptions] = (0, $eJOHy.useState)([]);
    const rollbackOptionsRef = (0, $eJOHy.useRef)(loadedOptions);
    const [enableFullList, setEnableFullList] = (0, $eJOHy.useState)(enableFullListProp || false);
    const [totalCount, setTotalCount] = (0, $eJOHy.useState)(null);
    const [endCursor, setEndCursor] = (0, $eJOHy.useState)(undefined);
    const loadingScreenMessage = (0, $eJOHy.useRef)(undefined);
    const [error, setError] = (0, $eJOHy.useState)({
        isError: false,
        error: null,
        onRetry: null
    });
    const isLoading = isLoadingInternal || isLoadingExternal;
    if ((0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const prevIsPaginationLoading = (0, $6d9QY.usePreviousWithInitial)(isPaginationLoading);
        const hasFinishedPaginationLoading = prevIsPaginationLoading && !isPaginationLoading;
        loadingScreenMessage.current = $8bc6c8c7998de8b9$var$getLoadingMessage({
            isLoadingPaginationStart: Boolean(isPaginationLoading && !prevIsPaginationLoading),
            isLoadingPaginationEnd: hasFinishedPaginationLoading,
            loadingMessages: loadingMessages,
            formatMessage: formatMessage
        });
    }
    const searchRef = (0, $eJOHy.useRef)('');
    const isColumnChangeInProgress = (0, $eJOHy.useRef)(false);
    const itemCount = (0, $eJOHy.useMemo)(()=>loadedOptions.flatMap((option)=>option.optionType === 'group' ? option.options : option).length, [
        loadedOptions
    ]);
    const getTotalCountWithFunctions = (0, $eJOHy.useCallback)((newTotalCount)=>{
        if (newTotalCount === null || !operandDisplayValues?.length) return newTotalCount;
        let newTotalCountWithKeywords;
        if (showOperandDisplayValuesInFullList === true) newTotalCountWithKeywords = newTotalCount + operandDisplayValues.length;
        else newTotalCountWithKeywords = newTotalCount + value.filter((option)=>(0, $gMbEk.isSingleValueOption)(option) && operandDisplayValues.includes(option.value)).length;
        return newTotalCountWithKeywords < $8bc6c8c7998de8b9$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $8bc6c8c7998de8b9$var$MAX_TOTAL_COUNT;
    }, [
        operandDisplayValues,
        showOperandDisplayValuesInFullList,
        value
    ]);
    const checkIfError = (0, $eJOHy.useCallback)((search, options, onRetry)=>{
        const errorOption = options.find((option)=>option.optionType === 'error' && option.error instanceof Error);
        if (errorOption && errorOption.optionType === 'error') {
            setError({
                isError: true,
                error: errorOption.error,
                onRetry: onRetry
            });
            setIsLoading(false);
            return true;
        }
        setError({
            isError: false,
            error: null,
            onRetry: null
        });
        return false;
    }, []);
    const handleLoadOptions = (0, $eJOHy.useCallback)((search, overridenValue, renderInitialValues = enableFullList)=>{
        if (!loadOptions) return;
        searchRef.current = search;
        setIsLoading(true);
        loadOptions(search, renderInitialValues, undefined, ({ options: options, totalCount: newTotalCount, endCursor: newEndCursor })=>{
            // Handle error
            if (checkIfError(search, options, ()=>{
                handleLoadOptions(search);
            })) return; // This is to prevent outdated options/results from overriding if a race condition occurs
            if (searchRef.current !== search) return;
            if (search) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(loadedOptions, options)) {
                    setLoadedOptions(options);
                    setTotalCount(newTotalCount);
                }
            } else {
                const newLoadedOptions = (0, $bWslp.generateOptions)([
                    ...overridenValue ?? value
                ], options, formatMessage);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(loadedOptions, newLoadedOptions)) {
                    setLoadedOptions(newLoadedOptions);
                    setTotalCount(getTotalCountWithFunctions(newTotalCount));
                }
            }
            setEndCursor(newEndCursor);
            setIsLoading(false);
        });
    }, [
        loadOptions,
        enableFullList,
        checkIfError,
        value,
        loadedOptions,
        getTotalCountWithFunctions,
        formatMessage
    ]);
    const handleShowMore = (0, $eJOHy.useCallback)((firstLoad = false, isRetry = false)=>{
        if (!loadOptions || !loadedOptions) return;
        let originalLoadedOptions;
        if (firstLoad) {
            originalLoadedOptions = [];
            setIsLoading(true);
        } else {
            originalLoadedOptions = loadedOptions;
            if (isRetry) setIsLoading(true);
            else setIsPaginationLoading(true);
        }
        loadOptions(inputValue, false, endCursor, ({ options: options, totalCount: newTotalCount, endCursor: newEndCursor })=>{
            if (checkIfError(inputValue, options, ()=>{
                handleShowMore(firstLoad, true);
            })) return;
            const newLoadedOptions = inputValue ? originalLoadedOptions.concat(options) : (0, $bWslp.generateOptions)(value, options, formatMessage, originalLoadedOptions, firstLoad);
            setEnableFullList(false);
            setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setLoadedOptions(newLoadedOptions);
            setIsPaginationLoading(false);
            setIsLoading(false);
            setEndCursor(newEndCursor);
        });
    }, [
        loadOptions,
        loadedOptions,
        inputValue,
        endCursor,
        checkIfError,
        value,
        getTotalCountWithFunctions,
        formatMessage,
        setIsPaginationLoading
    ]);
    const handleShowFullList = (0, $eJOHy.useCallback)(()=>{
        handleShowMore(true);
    }, [
        handleShowMore
    ]);
    const handleInputChange = (0, $eJOHy.useCallback)((newInputValue)=>{
        // on empty search: reset to default state for pickers where enableFullListProp==true
        if (newInputValue.length === 0 && enableFullListProp) {
            setEnableFullList(true);
            handleLoadOptions(newInputValue, undefined, true);
        } else {
            setEnableFullList(false);
            handleLoadOptions(newInputValue);
        }
        setInputValue(newInputValue);
        onInputChange && onInputChange();
    }, [
        enableFullListProp,
        handleLoadOptions,
        onInputChange
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)((options, meta)=>{
        if (!isColumnChangeInProgress.current && (0, $7jTnu.fg)('jira_inline_field_config_gate')) {
            isColumnChangeInProgress.current = true;
            rollbackOptionsRef.current = loadedOptions;
        }
        if ('option' in meta && meta.option) {
            const selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(loadedOptions, (option)=>(0, $gMbEk.isSingleValueOption)(option) && meta.option !== undefined && (0, $gMbEk.isSingleValueOption)(meta.option) && option.value === meta.option.value);
            onChange && onChange(options, meta, {
                selectedIndex: selectedIndex
            }, (0, $7jTnu.fg)('jira_inline_field_config_gate') ? ()=>{
                isColumnChangeInProgress.current = false;
            } : undefined, (0, $7jTnu.fg)('jira_inline_field_config_gate') ? ()=>{
                setLoadedOptions(rollbackOptionsRef.current);
                isColumnChangeInProgress.current = false;
            } : undefined);
        } else onChange && onChange(options, meta, undefined, (0, $7jTnu.fg)('jira_inline_field_config_gate') ? ()=>{
            isColumnChangeInProgress.current = false;
        } : undefined, (0, $7jTnu.fg)('jira_inline_field_config_gate') ? ()=>{
            setLoadedOptions(rollbackOptionsRef.current);
            isColumnChangeInProgress.current = false;
        } : undefined);
    }, [
        onChange,
        loadedOptions
    ]);
    const handleOnRestoreDefaults = (0, $eJOHy.useCallback)(()=>{
        if (typeof onRestoreDefaults === 'function') {
            const defaultOptions = onRestoreDefaults(); // Reset picker input and force update of options to go back to an initial-like state where selected options are on top
            setInputValue('');
            handleLoadOptions('', defaultOptions);
        }
    }, [
        handleLoadOptions,
        onRestoreDefaults
    ]); // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(()=>{
        handleLoadOptions(''); // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadedOptionsWithFullList = (0, $eJOHy.useMemo)(()=>{
        let newLoadedOptions = loadedOptions;
        if (value !== prevValue && searchRef.current === '' && (0, $7jTnu.fg)('jira_inline_field_config_gate')) newLoadedOptions = (0, $bWslp.generateOptions)(value, loadedOptions, formatMessage);
        if (onSortOptions && !(0, $7jTnu.fg)('jira_inline_field_config_gate') && (0, $7jTnu.fg)('jira_list_merged_column_gate')) newLoadedOptions = onSortOptions(newLoadedOptions);
        return (0, $bWslp.addFullListToOptions)(newLoadedOptions, !enableFullList, onSortOptions);
    }, [
        loadedOptions,
        value,
        prevValue,
        enableFullList,
        onSortOptions,
        formatMessage
    ]);
    const components = (0, $eJOHy.useMemo)(()=>isMulti ? {
            ...paginatedComponents,
            ...customComponents
        } : {
            ...paginatedSingleSelectComponents,
            ...customComponents
        }, [
        customComponents,
        isMulti,
        paginatedComponents,
        paginatedSingleSelectComponents
    ]);
    const selectedValue = (0, $eJOHy.useMemo)(/**
   * This method is to form the value from loadedOptionsWithFullList Array so that the 'Options' and 'Value' props of
   * select component will have same object references, This is a workaround to meet the below condition in the '@atlaskit/select'
   * component's ariaFocused method
   * var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));.
   * This condition must work to announce the state of selection.
   *
   * The below method can be removed if the above condition is improved to check just the value instead of reference.
   */ ()=>(0, $bWslp.getValueFromOptions)(loadedOptionsWithFullList, value), [
        loadedOptionsWithFullList,
        value
    ]);
    const showFooterType = (0, $eJOHy.useMemo)(()=>{
        const showFooter = !isLoading && loadedOptions && Boolean(loadedOptions.length) && !error.isError;
        if (showFooter && CustomFooter != null && (0, $7jTnu.fg)('jira_inline_field_config_gate')) return 'custom';
        if (showFooter) return 'default';
    }, [
        CustomFooter,
        error.isError,
        isLoading,
        loadedOptions
    ]);
    const handleOnKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (isPaginationLoading && event.key === 'ArrowUp' || isPaginationLoading && event.key === 'ArrowDown' || isLoading && event.key === 'ArrowUp' || isLoading && event.key === 'ArrowDown') {
            // prevent focusing first option when loading of more options
            event.preventDefault();
            return;
        }
        onKeyDown?.(event);
    }, [
        isLoading,
        isPaginationLoading,
        onKeyDown
    ]);
    if (value !== prevValue && (0, $7jTnu.fg)('jira_inline_field_config_gate')) {
        const newLoadedOptions = (0, $bWslp.generateOptions)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value, loadedOptions, formatMessage);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(loadedOptions, newLoadedOptions)) setLoadedOptions(newLoadedOptions);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showOperatorSelect && onChangeOperator && allowedOperators && Boolean(allowedOperators.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f1iCr.OperatorsSelect), {
        onChange: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j7wtI.BaseSelect), {
        components: components,
        inputValue: inputValue,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: onMenuScrollToBottom,
        onMenuScrollToTop: onMenuScrollToTop,
        placeholder: placeholder,
        id: id,
        invalidLabel: invalidLabel,
        options: loadedOptionsWithFullList,
        setInitialFocusRef: setInitialFocusRef,
        menuListProps: {
            error: error,
            handleShowMore: handleShowMore,
            isLoading: isLoading,
            isPaginationLoading: isPaginationLoading,
            isShowMoreEnabled: totalCount !== null && itemCount < totalCount
        },
        onChange: handleOnChange,
        value: selectedValue,
        styles: $8bc6c8c7998de8b9$var$selectStyles,
        ...restProps,
        isMulti: isMulti,
        totalCount: totalCount,
        onKeyDown: handleOnKeyDown
    }), showFooterType === 'default' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8bc6c8c7998de8b9$var$Footer, null, onRestoreDefaults !== undefined ? typeof onRestoreDefaults === 'function' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5lNLi.default), {
        onRestoreDefaults: handleOnRestoreDefaults
    }) : Boolean(value.length) && isMulti && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j8m5Z.default), {
        onClear: onClear
    }), (!value.length || !isMulti) && enableFullList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $icknm.default), {
        onShowFullList: handleShowFullList
    }), !enableFullList && totalCount !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1fUys.default), {
        itemsCount: itemCount,
        totalCount: totalCount
    })), showFooterType === 'custom' && CustomFooter, loadingScreenMessage.current && (0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
        role: "alert",
        "aria-live": "polite"
    }, loadingScreenMessage.current), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null));
};
var $8bc6c8c7998de8b9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $8bc6c8c7998de8b9$var$PaginatedAsyncSelectView;
const $8bc6c8c7998de8b9$var$Footer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dog0l8 _ca0q1b66 _n3td1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o _4t3i1ylp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gMbEk", function(module, exports) {

$parcel$export(module.exports, "isSingleValueOption", () => $282a6706fedd463a$export$35faed52a6bc243e);
const $282a6706fedd463a$export$35faed52a6bc243e = (option)=>option.optionType === 'option' || option.optionType === 'avatar' || option.optionType === 'lozenge' || option.optionType === 'field';

});

parcelRegister("j8m5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ce8dc8742c8663f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $aFyWG = parcelRequire("aFyWG");

var $6vNSg = parcelRequire("6vNSg");
const $4ce8dc8742c8663f$export$1d4b7cda9e589b53 = ({ onClear: onClear })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClearSelectedItems = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'filterSearchClearSelectedItems', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onClear && onClear();
    }, [
        onClear
    ]);
    const message = formatMessage((0, $6vNSg.default).clearAllSelectedItemsButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFyWG.LeftFooterButton), {
        message: message,
        onClick: onClearSelectedItems,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.clear-selection-button.clear-selected-items",
        hasTooltip: true
    });
};
var $4ce8dc8742c8663f$export$2e2bcd8739ae039 = $4ce8dc8742c8663f$export$1d4b7cda9e589b53;

});
parcelRegister("aFyWG", function(module, exports) {

$parcel$export(module.exports, "LeftFooterButton", () => $0affafe94b46ba2e$export$edc8e1365283b1f0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $6XJko = parcelRequire("6XJko");
const $0affafe94b46ba2e$export$edc8e1365283b1f0 = ({ message: message, onClick: onClick, testId: testId, appearance: appearance, hasTooltip: hasTooltip, label: label })=>{
    const shouldApplyVisualRefresh = (0, $6XJko.isVisualRefreshEnabled)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: appearance,
        onClick: onClick,
        testId: testId
    }, message);
    if (!hasTooltip) {
        if (shouldApplyVisualRefresh) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            padding: "space.050",
            xcss: $0affafe94b46ba2e$var$leftFooterButtonContainerStyles
        }, content);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0affafe94b46ba2e$var$LeftFooterButtonContainerOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: appearance,
            onClick: onClick,
            testId: testId
        }, message));
    }
    if (shouldApplyVisualRefresh) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        padding: "space.050",
        xcss: $0affafe94b46ba2e$var$leftFooterButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: message
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0affafe94b46ba2e$var$LeftFooterButtonContainerOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: appearance,
        onClick: onClick,
        testId: testId,
        ...label && {
            'aria-label': label
        }
    }, message)));
};
const $0affafe94b46ba2e$var$leftFooterButtonContainerStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    marginInlineStart: 'space.300'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0affafe94b46ba2e$var$LeftFooterButtonContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _ahbqu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6vNSg", function(module, exports) {

$parcel$export(module.exports, "default", () => $069e3a8465402294$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $069e3a8465402294$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    clearAllSelectedItemsButtonText: {
        "id": "jql-builder-basic-picker.async-select.clear-selection-button.clear-all-selected-items-button-text",
        "defaultMessage": "Clear selection"
    }
});

});


parcelRegister("f3ko0", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $810d101605fb454f$export$d4c4e98c5044dc8);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $6XEne = parcelRequire("6XEne");

var $gCeeo = parcelRequire("gCeeo");

var $4P0pd = parcelRequire("4P0pd");

var $9LD2u = parcelRequire("9LD2u");

var $lhCeH = parcelRequire("lhCeH");
const $810d101605fb454f$export$d4c4e98c5044dc8 = (props)=>{
    const { selectProps: { menuListProps: { error: { isError: isError, onRetry: onRetry }, handleShowMore: handleShowMore, isLoading: isLoading, isPaginationLoading: isPaginationLoading, isShowMoreEnabled: isShowMoreEnabled } } } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleOnShowMore = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'options',
            action: 'scrolled'
        }), 'filterSearchShowMore');
        handleShowMore();
    }, [
        handleShowMore,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, props, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LD2u.default), null), !isLoading && isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4P0pd.default), {
        onRetry: onRetry
    }), !isLoading && !isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children, isShowMoreEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lhCeH.default), {
        onShowMore: handleOnShowMore,
        isPaginationLoading: isPaginationLoading
    }))));
};
var $810d101605fb454f$export$2e2bcd8739ae039 = $810d101605fb454f$export$d4c4e98c5044dc8;

});
parcelRegister("4P0pd", function(module, exports) {

$parcel$export(module.exports, "default", () => $068e9aea02769269$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $1NG86 = parcelRequire("1NG86");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $cb8jR = parcelRequire("cb8jR");

var $ipK0z = parcelRequire("ipK0z");
const $068e9aea02769269$var$ErrorMessage = ({ onRetry: onRetry })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        onRetry?.();
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'refinementBarSelectRetry clicked');
    }, [
        onRetry,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 144,
        "data-testid": "jql-builder-basic-picker.ui.async-select.menu-list.error-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 72,
        iconSize: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledText), null, formatMessage((0, $ipK0z.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClick,
        appearance: "link",
        testId: "jql-builder-basic-picker.ui.async-select.menu-list.error-message.retry-button"
    }, formatMessage((0, $ipK0z.default).retryMessage)));
};
var $068e9aea02769269$export$2e2bcd8739ae039 = $068e9aea02769269$var$ErrorMessage;

});
parcelRegister("cb8jR", function(module, exports) {

$parcel$export(module.exports, "DropdownIndicatorWrapper", () => $965991b8073d69d7$export$30c615a45297e297);
$parcel$export(module.exports, "StyledBox", () => $965991b8073d69d7$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $965991b8073d69d7$export$31ea92f3997410dd);
$parcel$export(module.exports, "StyledControl", () => $965991b8073d69d7$export$5c7b7f0e517b89f8);
$parcel$export(module.exports, "CloseIconWrapper", () => $965991b8073d69d7$export$94756becb802e330);
$parcel$export(module.exports, "DisplayWrapper", () => $965991b8073d69d7$export$6833d6d22987ee7f);
$parcel$export(module.exports, "CustomOptionStyles", () => $965991b8073d69d7$export$fa3694617a82202b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $806LH = parcelRequire("806LH");
const $965991b8073d69d7$export$30c615a45297e297 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxv77o _y3gn1h6o _1bsbzwfg",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$d675f139b342d51a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1bah1h6o",
            __cmplp.height ? "_4t3it1jn" : "_4t3i1qr7",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($965991b8073d69d7$var$StyledTextComponent, props));
const $965991b8073d69d7$export$5c7b7f0e517b89f8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zl1pvm _1e0c1txw _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$94756becb802e330 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_80omtlke _30l31bsc",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$6833d6d22987ee7f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { displayFlag: displayFlag, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.displayFlag ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$fa3694617a82202b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasIconAfter: hasIconAfter, isSingleSelect: isSingleSelect, isFocused: isFocused, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kfm9xv": (0, $awdRS.default)(__cmplp.isFocused ? `inset 2px 0px 0px ${"var(--ds-border-focused, #388BFF)"}` : 'none'),
            "--_1p23kyf": (0, $awdRS.default)(__cmplp.isDisabled ? 'color.text.disabled' : 'color.text')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _dzc2v2br _m3zku2gc",
            __cmplp.hasIconAfter ? "_sktr1ejb" : "_sktrze3t",
            __cmplp.isSingleSelect && "_bp7o1fcu _ngc03plq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ipK0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0214a23e274561c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c0214a23e274561c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.error-message.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.error-message.retry-message",
        "defaultMessage": "Click to retry"
    }
});

});


parcelRegister("9LD2u", function(module, exports) {

$parcel$export(module.exports, "default", () => $da95119f1df2e865$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $kDaaB = parcelRequire("kDaaB");

var $cb8jR = parcelRequire("cb8jR");

var $dyWxb = parcelRequire("dyWxb");
const $da95119f1df2e865$export$e928a71d039d3102 = ()=>// eslint disabled because it is valid for options, see recommended https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/main/docs/rules/no-noninteractive-element-to-interactive-role.md
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: $da95119f1df2e865$var$listItemStyle,
        role: "option",
        "aria-selected": false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        "data-testid": "jql-builder-basic-picker.ui.async-select.menu-list.loading-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $dyWxb.default).loadingMessage))));
var $da95119f1df2e865$export$2e2bcd8739ae039 = $da95119f1df2e865$export$e928a71d039d3102;
const $da95119f1df2e865$var$listItemStyle = (0, $1DXK0.xcss)({
    listStyle: 'none'
});

});
parcelRegister("dyWxb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9012dc4eef88d2fd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9012dc4eef88d2fd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loadingMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.loading-message.loading-message",
        "defaultMessage": "Loading..."
    }
});

});


parcelRegister("lhCeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $553b58ca6b88f3b1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $lRq8t = parcelRequire("lRq8t");

var $1R4YX = parcelRequire("1R4YX");

var $7jTnu = parcelRequire("7jTnu");

var $aJkOP = parcelRequire("aJkOP");
const $553b58ca6b88f3b1$var$LoadMoreTrigger = ({ onShowMore: onShowMore, isPaginationLoading: isPaginationLoading })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const loadingRef = /*#__PURE__*/ (0, $eJOHy.createRef)();
    const loadMoreRef = (0, $1R4YX.useIntersectionObserver)({
        margin: (0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix') ? 0 : 10,
        onIntersection: ()=>{
            if (!isPaginationLoading) {
                (0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix') && loadingRef?.current?.scrollIntoView();
                onShowMore();
            }
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        role: "option",
        "aria-hidden": "true",
        "aria-selected": false,
        ref: loadingRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $553b58ca6b88f3b1$var$loadingContainerStyles,
        justifyContent: "center",
        alignItems: "center",
        ref: loadMoreRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        label: formatMessage((0, $aJkOP.default).loadingLabel)
    })));
};
const $553b58ca6b88f3b1$var$loadingContainerStyles = (0, $1DXK0.xcss)({
    height: '56px'
});
var $553b58ca6b88f3b1$export$2e2bcd8739ae039 = $553b58ca6b88f3b1$var$LoadMoreTrigger;

});
parcelRegister("1R4YX", function(module, exports) {

$parcel$export(module.exports, "useIntersectionObserver", () => $01379305a4b54492$export$a7395f9832c00176);

var $eJOHy = parcelRequire("eJOHy");
const $01379305a4b54492$export$a7395f9832c00176 = ({ margin: margin, threshold: threshold = 0, onIntersection: onIntersection })=>{
    const [observedElement, setObservedElement] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (observedElement === null || window.IntersectionObserver === undefined) return undefined;
        const observerCallback = (entries)=>entries.forEach(({ isIntersecting: isIntersecting, time: time })=>{
                if (isIntersecting) onIntersection(time);
            });
        const observer = new IntersectionObserver(observerCallback, {
            rootMargin: `${margin}px`,
            threshold: threshold
        });
        observer.observe(observedElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        observedElement,
        onIntersection,
        margin,
        threshold
    ]);
    return setObservedElement;
};

});

parcelRegister("aJkOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c10a5a4e92317e0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9c10a5a4e92317e0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loadingLabel: {
        "id": "jql-builder-basic-picker.async-select.menu-list.load-more-trigger.loading-label",
        "defaultMessage": "Loading"
    }
});

});



parcelRegister("f1iCr", function(module, exports) {

$parcel$export(module.exports, "OperatorsSelect", () => $45891c3f91875637$export$72ded8b112fe0b1);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $c4OV1 = parcelRequire("c4OV1");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $cO6Ov = parcelRequire("cO6Ov");
const $45891c3f91875637$var$selectStyles = {
    control: (baseStyles)=>({
            ...baseStyles,
            backgroundColor: "var(--ds-background-neutral, #091E420F)"
        })
};
const $45891c3f91875637$var$getOptionLabel = (option)=>option.ariaLabel;
const $45891c3f91875637$var$formatOptionLabel = (option)=>option.label;
const $45891c3f91875637$export$72ded8b112fe0b1 = ({ onChange: onChange, allowedOperators: allowedOperators, selectedOperator: selectedOperator })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChangeWithAnalytics = (0, $eJOHy.useCallback)((option)=>{
        onChange && onChange(option);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        option && (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            option: option.value,
            selectType: 'dropdown'
        });
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const onMenuOpenAnalytics = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            selectType: 'dropdown'
        });
    }, [
        createAnalyticsEvent
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((event)=>{
        event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $45891c3f91875637$var$operatorsSelectStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        "aria-label": formatMessage((0, $cO6Ov.default).operatorLabel),
        value: selectedOperator || allowedOperators[0],
        options: allowedOperators,
        onChange: onChangeWithAnalytics,
        spacing: "compact",
        appearance: "subtle",
        styles: $45891c3f91875637$var$selectStyles,
        onKeyDown: onKeyDown,
        onMenuOpen: onMenuOpenAnalytics,
        isSearchable: false,
        getOptionLabel: $45891c3f91875637$var$getOptionLabel,
        formatOptionLabel: $45891c3f91875637$var$formatOptionLabel
    }));
};
const $45891c3f91875637$var$operatorsSelectStyles = (0, $1DXK0.xcss)({
    padding: 'space.150',
    paddingTop: 'space.100',
    paddingBottom: 'space.050'
});

});
parcelRegister("cO6Ov", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c4c55cc3aef0b4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b1c4c55cc3aef0b4$var$messages = (0, $7qGN1.defineMessages)({
    operatorLabel: {
        "id": "jql-builder-basic-picker.async-select.operator-select.operator-label",
        "defaultMessage": "Operator dropdown"
    }
});
var $b1c4c55cc3aef0b4$export$2e2bcd8739ae039 = $b1c4c55cc3aef0b4$var$messages;

});


parcelRegister("1fUys", function(module, exports) {

$parcel$export(module.exports, "default", () => $60bd543addf3cb57$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $kCiis = parcelRequire("kCiis");
const $60bd543addf3cb57$export$33eb0288c0936a84 = ({ itemsCount: itemsCount, totalCount: totalCount })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($60bd543addf3cb57$var$PaginationDetailsStyled, {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "jql-builder-basic.ui.jql-editor.picker.async-select.pagination-details"
    }, formatMessage((0, $kCiis.default).ofTotalCount, {
        itemsCount: itemsCount,
        totalCount: totalCount
    }));
};
var $60bd543addf3cb57$export$2e2bcd8739ae039 = $60bd543addf3cb57$export$33eb0288c0936a84;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $60bd543addf3cb57$var$PaginationDetailsStyled = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _y3gnusic _syaz131l _16jlkb7n _1o9zidpf _i0dl1wug _19pkze3t _2hwxutpp _otyrze3t _18u0utpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kCiis", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ca9967a4a24ae17$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6ca9967a4a24ae17$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    ofTotalCount: {
        "id": "jql-builder-basic-picker.async-select.pagination-details.of-total-count",
        "defaultMessage": "{itemsCount} of {totalCount}"
    }
});

});


parcelRegister("5lNLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce6429fb8860ba26$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $aFyWG = parcelRequire("aFyWG");

var $5HR61 = parcelRequire("5HR61");
const $ce6429fb8860ba26$export$2543cc45221bf5bc = ({ onRestoreDefaults: onRestoreDefaults })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleRestoreDefaults = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'filterSearchRestoreDefaults', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onRestoreDefaults && onRestoreDefaults();
    }, [
        onRestoreDefaults
    ]);
    const message = formatMessage((0, $5HR61.default).restoreDefaultsButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFyWG.LeftFooterButton), {
        message: message,
        onClick: handleRestoreDefaults,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.restore-defaults-button",
        hasTooltip: true
    });
};
var $ce6429fb8860ba26$export$2e2bcd8739ae039 = $ce6429fb8860ba26$export$2543cc45221bf5bc;

});
parcelRegister("5HR61", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f7feca5c1b3e4c8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1f7feca5c1b3e4c8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    restoreDefaultsButtonText: {
        "id": "jql-builder-basic-picker.async-select.restore-defaults-button.restore-defaults-button-text",
        "defaultMessage": "Restore defaults"
    }
});

});


parcelRegister("j7wtI", function(module, exports) {

$parcel$export(module.exports, "selectComponents", () => $952582033f9b0a69$export$c34d65c0f5a1c617);
$parcel$export(module.exports, "singleSelectComponents", () => $952582033f9b0a69$export$6161e15c6859b0c9);
$parcel$export(module.exports, "BaseSelect", () => $952582033f9b0a69$export$dcee1aa94a106d27);

var $eJOHy = parcelRequire("eJOHy");

var $c4OV1 = parcelRequire("c4OV1");

var $mjinE = parcelRequire("mjinE");

var $8KUFq = parcelRequire("8KUFq");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $d9b92 = parcelRequire("d9b92");

var $gMbEk = parcelRequire("gMbEk");


var $gWVN2 = parcelRequire("gWVN2");

var $62EHB = parcelRequire("62EHB");

var $aeAJB = parcelRequire("aeAJB");

var $35vKc = parcelRequire("35vKc");

var $3UBK2 = parcelRequire("3UBK2");

var $fSowc = parcelRequire("fSowc");

var $j1sv5 = parcelRequire("j1sv5");
const $952582033f9b0a69$export$c34d65c0f5a1c617 = {
    Control: $gWVN2.default,
    DropdownIndicator: $62EHB.default,
    LoadingIndicator: ()=>null,
    Menu: $aeAJB.default,
    Option: $fSowc.default
};
const $952582033f9b0a69$export$6161e15c6859b0c9 = {
    Control: $gWVN2.default,
    DropdownIndicator: $62EHB.default,
    LoadingIndicator: undefined,
    Menu: $aeAJB.default
};
const $952582033f9b0a69$var$onIsOptionDisabled = (option, value)=>{
    if (option.optionType === 'error') return true;
    // if an option is only unselectable and currently selected, it should not be a disabled option
    if ('isOnlyUnselectable' in option && option.isOnlyUnselectable) {
        const isSelectedOption = (0, $gMbEk.isSingleValueOption)(option) && value.map((v)=>(0, $gMbEk.isSingleValueOption)(v) && v.value).includes(option.value);
        return !(isSelectedOption && option.isOnlyUnselectable);
    }
    if ('isDisabled' in option && option.isDisabled) return option.isDisabled;
    return false;
};
// Needed to disable filtering from react-select
const $952582033f9b0a69$var$noFilterOptions = ()=>true;
const $952582033f9b0a69$export$dcee1aa94a106d27 = ({ onReload: onReload, placeholder: placeholder, NoOptionsMessage: NoOptionsMessage = (0, $3UBK2.default), isMulti: isMulti = true, setInitialFocusRef: setInitialFocusRef, totalCount: totalCount, components: componentsSelect, options: options, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, ...restProps })=>{
    const { onInputChange: onInputChangeProp, inputValue: inputValueProp, id: id, menuListProps: { isLoading: isLoading, error: { isError: isError, error: error } }, experienceAnalyticsAttributes: experienceAnalyticsAttributes, value: value } = restProps;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectRef = /*#__PURE__*/ (0, $eJOHy.createRef)(); // use any type for react-select ref
    const [inputValue, setInputValue] = (0, $eJOHy.useState)(inputValueProp ?? '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        // only set once when the component mounted
        if (selectRef.current && setInitialFocusRef) setInitialFocusRef(selectRef.current.select.inputRef);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (options && !(isLoading ?? false)) {
            let errorType = 'unknown';
            if (error != null && (0, $8KUFq.isClientFetchError)(error)) errorType = 'networkError';
            const errorAttributes = error ? {
                errorType: errorType,
                message: error.message
            } : null;
            (0, $mjinE.default)({
                analyticsSource: 'refinement-bar-select',
                wasExperienceSuccesful: error == null,
                experience: 'showOptions',
                application: null,
                edition: null,
                additionalAttributes: {
                    filter: id ?? 'unknown',
                    ...experienceAnalyticsAttributes,
                    ...errorAttributes
                }
            });
        }
    }, [
        isError,
        error,
        isLoading,
        options,
        id,
        experienceAnalyticsAttributes
    ]);
    const hasEnabledOption = (0, $eJOHy.useMemo)(()=>options?.some((option)=>!$952582033f9b0a69$var$onIsOptionDisabled(option, value)), [
        options,
        value
    ]);
    const onInputChange = (0, $eJOHy.useCallback)((newInputValue, meta)=>{
        /**
     * Do not clear the filter input value when an input is selected or blured.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */ if (Array.from([
            (0, $d9b92.MetaActions).setValue,
            (0, $d9b92.MetaActions).inputBlur,
            (0, $d9b92.MetaActions).menuClose
        ]).includes(meta.action) && !newInputValue.length) return;
        // Reload defaultOptions in case of potential error by changing key on AsyncSelect
        if (meta.action === (0, $d9b92.MetaActions).inputChange && !newInputValue.length) onReload?.('');
        onInputChangeProp && onInputChangeProp(newInputValue, meta);
        setInputValue(newInputValue);
    }, [
        onInputChangeProp,
        onReload
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setInputValue(inputValueProp);
    }, [
        inputValueProp
    ]);
    const getOptionLabel = (0, $eJOHy.useCallback)((option)=>{
        if ((0, $gMbEk.isSingleValueOption)(option)) {
            if (typeof option.secondaryLabel === 'string') return `${option.label}, ${option.secondaryLabel}`;
            if (// remove !isValidElement(data.secondaryLabel) with cleanup with m7.3-mm2-custom-fields-with-existing-uis_vzhn7
            typeof option.secondaryLabel === 'object' && !/*#__PURE__*/ (0, $eJOHy.isValidElement)(option.secondaryLabel)) return `${option.label}, ${option.secondaryLabel.label}`;
            return option.label;
        }
        return option.optionType === 'group' ? option?.label ?? '' : '';
    }, []);
    // placeholder type is reactNode and aria-label won't allow, for safe side checking the type and empty value
    const ariaLabel = typeof placeholder === 'string' && placeholder ? placeholder : formatMessage((0, $35vKc.default).searchPlaceholder);
    const OriginalOptionComponent = componentsSelect?.Option || undefined;
    // Note: this is a workaround to not visually focus any option, when there are only disabled options in the list
    // react-select autofocuses the first option, see more here: https://github.com/JedWatson/react-select/pull/4080
    // tracked bug ticket: https://product-fabric.atlassian.net/browse/DSP-17138
    const OptionComponentExtended = (0, $eJOHy.useCallback)((props)=>OriginalOptionComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OriginalOptionComponent, {
            ...props,
            isFocused: hasEnabledOption ? props.isFocused : false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), [
        OriginalOptionComponent,
        hasEnabledOption
    ]);
    const unselectedOptions = (0, $eJOHy.useMemo)(()=>{
        if (!isInBetweenColumnPickerEnabled) return [];
        if (!inputValue) return (0, $7jTnu.fg)('jira_inline_field_config_gate') ? options?.filter((option)=>option.optionType === 'group' && option.id !== (0, $398aa02f7b594968$export$bfd1c05c2e5a5a01)) || [] : options?.filter((option)=>option.optionType === 'group') || [];
        const selectedOptions = new Set(value.map((v)=>(0, $gMbEk.isSingleValueOption)(v) ? v.value : ''));
        return options?.filter((option)=>(0, $gMbEk.isSingleValueOption)(option) && !selectedOptions.has(option.value)) || [];
    }, [
        isInBetweenColumnPickerEnabled,
        inputValue,
        options,
        value
    ]);
    const memoizedComponents = (0, $eJOHy.useMemo)(()=>{
        const totalCountOfUnselectedFields = totalCount ? totalCount - value.length : null;
        return {
            ...componentsSelect,
            ...(0, $7jTnu.fg)('jira_inline_field_config_gate') ? {
                GroupHeading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1sv5.GroupHeading), {
                        ...props,
                        totalCount: totalCountOfUnselectedFields
                    })
            } : {},
            ...OriginalOptionComponent !== undefined ? {
                Option: OptionComponentExtended
            } : {}
        };
    }, [
        componentsSelect,
        OriginalOptionComponent,
        OptionComponentExtended,
        totalCount,
        value.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        ...restProps,
        options: isInBetweenColumnPickerEnabled && (0, $7jTnu.fg)('jira_inline_field_config_gate') ? unselectedOptions : options,
        // Using classNamePrefix to identify the select component in cypress test, testId doesn't work (doc https://atlassian.design/components/select/testing)
        classNamePrefix: "jql-builder-basic-picker-atlaskit-select",
        components: memoizedComponents,
        cacheOptions: false,
        ref: selectRef,
        autoFocus: !setInitialFocusRef,
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        closeMenuOnSelect: false,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: isMulti,
        inputValue: inputValue,
        menuIsOpen: true,
        menuShouldScrollIntoView: false,
        tabSelectsValue: false,
        onInputChange: onInputChange,
        isOptionDisabled: $952582033f9b0a69$var$onIsOptionDisabled,
        reload: onReload,
        filterOption: $952582033f9b0a69$var$noFilterOptions,
        placeholder: placeholder ?? formatMessage((0, $35vKc.default).searchPlaceholder),
        label: ariaLabel,
        noOptionsMessage: NoOptionsMessage,
        getOptionLabel: getOptionLabel
    });
};

});
const $398aa02f7b594968$export$eb85a4c9b5d9ce7b = 'all-columns';
const $398aa02f7b594968$export$bfd1c05c2e5a5a01 = 'selected-columns';

parcelRegister("gWVN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c50f99a84b41b08$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $i0iAU = parcelRequire("i0iAU");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");

var $cb8jR = parcelRequire("cb8jR");
const $0c50f99a84b41b08$export$7a7fa4424cb20976 = ({ children: children, innerProps: innerProps, innerRef: innerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledControl), {
        ref: innerRef ?? undefined,
        ...innerProps
    }, (0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0c50f99a84b41b08$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i0iAU))), {
        LEGACY_size: "small",
        label: ""
    })), children);
const $0c50f99a84b41b08$var$wrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 'space.100'
});
var $0c50f99a84b41b08$export$2e2bcd8739ae039 = $0c50f99a84b41b08$export$7a7fa4424cb20976;

});

parcelRegister("62EHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $54055c12a318bc3b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kXEdL = parcelRequire("kXEdL");

var $i0iAU = parcelRequire("i0iAU");

var $6XEne = parcelRequire("6XEne");

var $6XJko = parcelRequire("6XJko");

var $cb8jR = parcelRequire("cb8jR");
const $54055c12a318bc3b$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).DropdownIndicator, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.DropdownIndicatorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.DisplayWrapper), {
        displayFlag: props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.CloseIconWrapper), {
        "data-testid": "jql-builder-basic-picker.ui.async-select.select.dropdown-indicator.dropdown-close-icon",
        onClick: (event)=>{
            event.preventDefault();
            props.selectProps.onInputChange && props.selectProps.onInputChange('', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kXEdL))), {
        LEGACY_size: "small",
        label: ""
    }))), !(0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.DisplayWrapper), {
        displayFlag: !props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i0iAU))), {
        LEGACY_size: "small",
        label: ""
    }))));
var $54055c12a318bc3b$export$2e2bcd8739ae039 = $54055c12a318bc3b$export$ec98719d3db7f2e4;

});

parcelRegister("aeAJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b7f34fee106459a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4b7f34fee106459a$var$Menu = ({ innerRef: innerRef, innerProps: innerProps, children: children })=>// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4b7f34fee106459a$var$MenuBox, {
        "data-testid": "refinement-bar.common.ui.select.menu",
        ref: innerRef,
        ...innerProps
    }, children);
var $4b7f34fee106459a$export$2e2bcd8739ae039 = $4b7f34fee106459a$var$Menu;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4b7f34fee106459a$var$MenuBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("35vKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6409cd14587ac6e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b6409cd14587ac6e$var$messages = (0, $7qGN1.defineMessages)({
    searchPlaceholder: {
        "id": "jql-builder-basic-picker.async-select.select.search-placeholder",
        "defaultMessage": "Search"
    }
});
var $b6409cd14587ac6e$export$2e2bcd8739ae039 = $b6409cd14587ac6e$var$messages;

});

parcelRegister("3UBK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba06491bbd0f20a1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $80DPg = parcelRequire("80DPg");

var $53vxQ = parcelRequire("53vxQ");

var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $kDaaB = parcelRequire("kDaaB");

var $iqtgH = parcelRequire("iqtgH");

var $6XJko = parcelRequire("6XJko");

var $cb8jR = parcelRequire("cb8jR");

var $lWJ0U = parcelRequire("lWJ0U");
const $ba06491bbd0f20a1$var$NoOptionsMessageContainer = ({ children: children })=>{
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.150",
        alignInline: "center"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $lWJ0U.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "small",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $lWJ0U.default).noOptionsSecondaryMessage)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 72
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $lWJ0U.default).noOptionsMessage)));
};
const $ba06491bbd0f20a1$export$d58b72b7d3c4072c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        "data-testid": "jql-builder-basic.ui.jql-editor.picker.async-select.select.no-options-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ba06491bbd0f20a1$var$NoOptionsMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($53vxQ))),
        LEGACY_size: "xlarge"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "noMatches"
    }));
var $ba06491bbd0f20a1$export$2e2bcd8739ae039 = $ba06491bbd0f20a1$export$d58b72b7d3c4072c;

});
parcelRegister("lWJ0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $43e390d646017ea1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $43e390d646017ea1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noOptionsMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-message",
        "defaultMessage": "No matches found"
    },
    noOptionsPrimaryMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});

});


parcelRegister("fSowc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c802979ef0e97e4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $80DPg = parcelRequire("80DPg");

var $6J86O = parcelRequire("6J86O");

var $9D9o8 = parcelRequire("9D9o8");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $jzkyh = parcelRequire("jzkyh");
var $6XEne = parcelRequire("6XEne");

var $k71qx = parcelRequire("k71qx");

var $8cv11 = parcelRequire("8cv11");

var $cb8jR = parcelRequire("cb8jR");

var $1MOGE = parcelRequire("1MOGE");
const $9c802979ef0e97e4$var$tooltipStyles = null;
const $9c802979ef0e97e4$var$ConditionalTooltip = ({ condition: condition, content: content, children: children })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: content
    }, children) : children;
const $9c802979ef0e97e4$export$36d18380658d5d20 = ({ isMulti: isMulti = true, ...props })=>{
    const iconRef = (0, $eJOHy.useRef)(null);
    const { isOnlyUnselectable: isOnlyUnselectable, disabledMessage: disabledMessage, invalid: invalid } = props.data?.optionType === 'option' || props.data?.optionType === 'avatar' || props.data?.optionType === 'lozenge' || props.data?.optionType === 'field' ? props.data : {
        isOnlyUnselectable: undefined,
        disabledMessage: undefined,
        invalid: undefined
    };
    // Only disable checkbox for an only unselectable option when it is not a selected option
    const optionState = (0, $1MOGE.getOptionState)(props.isDisabled, Boolean(isOnlyUnselectable), props.isSelected, Boolean(invalid));
    const hasIconAfter = ()=>{
        switch(optionState){
            case 'only-unselectable-unselected':
            case 'only-unselectable-selected':
            case 'disabled':
                return Boolean(disabledMessage);
            case 'invalid':
                return true;
            default:
                return undefined;
        }
    };
    const OptionInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $9c802979ef0e97e4$export$d318e19053d98641[optionState].xcss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.CustomOptionStyles), {
        hasIconAfter: hasIconAfter(),
        isFocused: props.isFocused,
        isDisabled: props.isDisabled,
        isSingleSelect: true
    }, isMulti ? /* @ts-expect-error - This component has stricter OptionType args which isn't compatible with ErrorOption in SelectOption. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jzkyh.CheckboxOption), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, {
        ...props,
        isMulti: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9c802979ef0e97e4$var$TooltipContainer, {
        ref: iconRef
    }, optionState !== 'invalid' && Boolean(disabledMessage) && // Show a tooltip for mouse users, since option.isFocused is not triggered for disabled options on mouse over
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9c802979ef0e97e4$var$ConditionalTooltip, {
        content: disabledMessage,
        condition: props.isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J86O))), {
        testId: "jql-builder-basic-picker.ui.async-select.select.option.info-icon",
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    })), optionState === 'invalid' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        testId: "jql-builder-basic-picker.ui.async-select.select.option.invalid-icon",
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9D9o8)))
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": $9c802979ef0e97e4$export$d318e19053d98641[optionState].testid
    }, optionState === 'only-unselectable-unselected' || optionState === 'disabled' || optionState === 'invalid' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9c802979ef0e97e4$var$UnsafeStyledCheckboxOption, null, OptionInner) : OptionInner), (disabledMessage || props.selectProps?.invalidLabel && optionState === 'invalid') && props.isFocused && iconRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        referenceElement: iconRef.current,
        placement: "bottom",
        messageType: "transactional",
        messageId: "jql-builder-basic-picker.ui.async-select.select.option.popper"
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            ref: ref,
            style: style,
            className: (0, $hcewu.default)([
                "_2rkoglpi _11c8dcr7 _vchhusvi _p12fp3fh _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna"
            ])
        }, optionState === 'invalid' ? props.selectProps?.invalidLabel : disabledMessage))));
};
var $9c802979ef0e97e4$export$2e2bcd8739ae039 = $9c802979ef0e97e4$export$36d18380658d5d20;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9c802979ef0e97e4$var$UnsafeStyledCheckboxOption = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_nrk9jdj5",
            __cmplp.className
        ])
    });
});
const $9c802979ef0e97e4$var$TooltipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _18u0p1rm _u5f3utpp _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $9c802979ef0e97e4$var$DisabledCheckboxOptionStyles = (0, $1DXK0.xcss)({
    color: 'color.text.disabled'
});
const $9c802979ef0e97e4$var$InvalidCheckboxOptionStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.danger'
});
const $9c802979ef0e97e4$export$d318e19053d98641 = {
    disabled: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.disabled-option',
        xcss: [
            $9c802979ef0e97e4$var$DisabledCheckboxOptionStyles
        ]
    },
    invalid: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.invalid-option',
        xcss: [
            $9c802979ef0e97e4$var$InvalidCheckboxOptionStyles
        ]
    },
    selected: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.selected-option',
        xcss: []
    },
    unselected: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option',
        xcss: []
    },
    'only-unselectable-unselected': {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.only-unselectable',
        xcss: [
            $9c802979ef0e97e4$var$DisabledCheckboxOptionStyles
        ]
    },
    'only-unselectable-selected': {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.selected-option.only-unselectable',
        xcss: []
    }
};

});
parcelRegister("9D9o8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $702f09e26d3492dd$var$_react = $702f09e26d3492dd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $702f09e26d3492dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $702f09e26d3492dd$var$JiraFailedBuildStatusIcon = (props)=>/*#__PURE__*/ $702f09e26d3492dd$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$702f09e26d3492dd$var$JiraFailedBuildStatusIcon.displayName = 'JiraFailedBuildStatusIcon';
var $702f09e26d3492dd$var$_default = module.exports.default = $702f09e26d3492dd$var$JiraFailedBuildStatusIcon;

});

parcelRegister("jzkyh", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $c59673c02b42adcb$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $c59673c02b42adcb$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dwm7g = parcelRequire("dwm7g");

var $279SN = parcelRequire("279SN");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
const $c59673c02b42adcb$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di61dty",
    focused: "_bfhk166n _16qsn8hf _112ej1ic",
    disabled: "_syaz15gi"
};
// the primary color represents the outer or background element
const $c59673c02b42adcb$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #091E4208)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #09326C)";
    else if (isActive) return "var(--ds-background-selected-pressed, #85B8FF)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #0055CC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #0C66E4)";
    return "var(--ds-background-neutral, #091E420F)";
};
// the secondary color represents the radio dot or checkmark
const $c59673c02b42adcb$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #091E424F)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $c59673c02b42adcb$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1elr _1gqp1elr"
};
const $c59673c02b42adcb$var$baseIconStyles = null;
const $c59673c02b42adcb$var$baseOptionStyles = null;
const $c59673c02b42adcb$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $eJOHy.useState)(false);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $eJOHy.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $eJOHy.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $c59673c02b42adcb$var$optionStyles.default,
            isFocused && $c59673c02b42adcb$var$optionStyles.focused,
            isDisabled && $c59673c02b42adcb$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $c59673c02b42adcb$var$iconStyles.inherit : $c59673c02b42adcb$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    label: "",
                    primaryColor: $c59673c02b42adcb$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $c59673c02b42adcb$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $c59673c02b42adcb$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $c59673c02b42adcb$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
const $c59673c02b42adcb$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($c59673c02b42adcb$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $eGOwo.fg)('platform-visual-refresh-icons') ? $c59673c02b42adcb$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($dwm7g))),
        ...props
    });
const $c59673c02b42adcb$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $gt9Am.jsx)($c59673c02b42adcb$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $eGOwo.fg)('platform-visual-refresh-icons') ? $c59673c02b42adcb$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($279SN))),
        ...props
    });

});
parcelRegister("dwm7g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7f6b5a4b54b43d$var$_react = $9d7f6b5a4b54b43d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $9d7f6b5a4b54b43d$var$_checkboxChecked = $9d7f6b5a4b54b43d$var$_interopRequireDefault((parcelRequire("hagIH")));
function $9d7f6b5a4b54b43d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d7f6b5a4b54b43d$var$CheckboxIcon = (props)=>/*#__PURE__*/ $9d7f6b5a4b54b43d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $9d7f6b5a4b54b43d$var$_checkboxChecked.default
    }));
$9d7f6b5a4b54b43d$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $9d7f6b5a4b54b43d$var$_default = module.exports.default = $9d7f6b5a4b54b43d$var$CheckboxIcon;

});
parcelRegister("hagIH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7f057169373f605$var$_react = $c7f057169373f605$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c7f057169373f605$var$_baseNew = $c7f057169373f605$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c7f057169373f605$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7f057169373f605$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $c7f057169373f605$var$_react.default.createElement($c7f057169373f605$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$c7f057169373f605$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $c7f057169373f605$var$_default = module.exports.default = $c7f057169373f605$var$CheckboxCheckedIcon;

});


parcelRegister("279SN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18a3e6b70b5fecb4$var$_react = $18a3e6b70b5fecb4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $18a3e6b70b5fecb4$var$_radioChecked = $18a3e6b70b5fecb4$var$_interopRequireDefault((parcelRequire("4bKh1")));
function $18a3e6b70b5fecb4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $18a3e6b70b5fecb4$var$RadioIcon = (props)=>/*#__PURE__*/ $18a3e6b70b5fecb4$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $18a3e6b70b5fecb4$var$_radioChecked.default
    }));
$18a3e6b70b5fecb4$var$RadioIcon.displayName = 'RadioIcon';
var $18a3e6b70b5fecb4$var$_default = module.exports.default = $18a3e6b70b5fecb4$var$RadioIcon;

});
parcelRegister("4bKh1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f37934c6709a990262261073c8d0052>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30cc157d45e3093e$var$_react = $30cc157d45e3093e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $30cc157d45e3093e$var$_baseNew = $30cc157d45e3093e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $30cc157d45e3093e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30cc157d45e3093e$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $30cc157d45e3093e$var$_react.default.createElement($30cc157d45e3093e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$30cc157d45e3093e$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $30cc157d45e3093e$var$_default = module.exports.default = $30cc157d45e3093e$var$RadioCheckedIcon;

});



parcelRegister("8cv11", function(module, exports) {

$parcel$export(module.exports, "JiraPopper", () => $7c774b4266762c6b$export$23789575ac361b5d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $8qmYl = parcelRequire("8qmYl");

var $SyPNn = parcelRequire("SyPNn");

var $k3Xbr = parcelRequire("k3Xbr");
const $7c774b4266762c6b$export$23789575ac361b5d = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k3Xbr.ChoreographerPopper), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8qmYl.Popper), rest);
};

});
parcelRegister("k3Xbr", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopper", () => $035f7c874f3f3baa$export$6077de4a190b560c);
// eslint-disable-next-line jira/restricted/react-component-props

var $8qmYl = parcelRequire("8qmYl");

var $1pkzT = parcelRequire("1pkzT");
const $035f7c874f3f3baa$export$6077de4a190b560c = (0, $1pkzT.withChoreographedRender)((0, $8qmYl.Popper));

});


parcelRegister("1MOGE", function(module, exports) {

$parcel$export(module.exports, "getOptionState", () => $af5121b5036d97d9$export$e651787bf17e8335);
const $af5121b5036d97d9$export$e651787bf17e8335 = (isDisabled, isOnlyUnselectable, isSelected, isInvalid)=>{
    if (isDisabled) return 'disabled';
    if (isOnlyUnselectable && !isSelected) return 'only-unselectable-unselected';
    if (isInvalid) return 'invalid';
    if (isOnlyUnselectable && isSelected) return 'only-unselectable-selected';
    if (isSelected) return 'selected';
    return 'unselected';
};

});


parcelRegister("j1sv5", function(module, exports) {

$parcel$export(module.exports, "GroupHeading", () => $f8d83750115807b5$export$85c8b41a3cd87edc);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $6XEne = parcelRequire("6XEne");

const $f8d83750115807b5$var$HeadingContent = ({ label: label, totalCount: totalCount })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f8d83750115807b5$var$groupHeadingStyles,
        paddingBlockEnd: "space.075",
        paddingInline: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "small",
        weight: "bold",
        color: "color.text.subtle"
    }, label?.toLocaleUpperCase()), totalCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "small",
        color: "color.text.subtle"
    }, totalCount));
};
const $f8d83750115807b5$export$85c8b41a3cd87edc = ({ data: data, totalCount: totalCount, ...restProps })=>{
    const { id: id, label: label } = data;
    switch(id){
        case 0, $398aa02f7b594968$export$bfd1c05c2e5a5a01:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8d83750115807b5$var$HeadingContent, {
                label: label
            });
        case 0, $398aa02f7b594968$export$eb85a4c9b5d9ce7b:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8d83750115807b5$var$HeadingContent, {
                label: label,
                totalCount: totalCount
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).GroupHeading, {
                ...restProps,
                data: data
            });
    }
};
const $f8d83750115807b5$var$groupHeadingStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
});

});


parcelRegister("icknm", function(module, exports) {

$parcel$export(module.exports, "default", () => $295f45065da2298c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $aFyWG = parcelRequire("aFyWG");

var $8quwH = parcelRequire("8quwH");
const $295f45065da2298c$export$bf0956d66cd7566b = ({ onShowFullList: onShowFullList })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleShowFullList = (0, $eJOHy.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: 'UI',
            action: 'expanded',
            actionSubject: 'filterSearch',
            actionSubjectId: 'refinementBarFilterSearch'
        });
        const attributes = {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: e.detail === 0
        };
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'refinementBarFilterSearch', attributes);
        onShowFullList();
    }, [
        createAnalyticsEvent,
        onShowFullList
    ]);
    const message = formatMessage((0, $8quwH.default).showFullListButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFyWG.LeftFooterButton), {
        message: message,
        onClick: handleShowFullList,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.show-full-list-button.show-full-list-button",
        hasTooltip: true
    });
};
var $295f45065da2298c$export$2e2bcd8739ae039 = $295f45065da2298c$export$bf0956d66cd7566b;

});
parcelRegister("8quwH", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa637fe2306205e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $aa637fe2306205e4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showFullListButtonText: {
        "id": "jql-builder-basic-picker.async-select.show-full-list-button.show-full-list-button-text",
        "defaultMessage": "Show full list"
    }
});

});


parcelRegister("bWslp", function(module, exports) {

$parcel$export(module.exports, "addFullListToOptions", () => $c7a0e88bf351185c$export$f3b09dca68236b3);
$parcel$export(module.exports, "generateOptions", () => $c7a0e88bf351185c$export$c21133b4499f5374);
$parcel$export(module.exports, "getValueFromOptions", () => $c7a0e88bf351185c$export$cc4ee748665ecf20);

var $7jTnu = parcelRequire("7jTnu");

var $gMbEk = parcelRequire("gMbEk");


var $7XraK = parcelRequire("7XraK");
const $c7a0e88bf351185c$export$17aec06b00a4043e = (keys, options, option)=>{
    if ((0, $gMbEk.isSingleValueOption)(option) && !keys.has(option.value)) {
        keys.add(option.value);
        options.push(option);
    }
    // If the option is a group, we either append to an existing group or add a new group
    if (option.optionType === 'group') {
        const foundDuplicateGroup = (0, $7jTnu.fg)('jira_inline_field_config_gate') ? options.some((o)=>'id' in o && o.id === option.id || 'label' in o && o.label === option.label) : options.some((o)=>'label' in o && o.label === option.label);
        if (foundDuplicateGroup) option.options.forEach((groupVal)=>{
            const existingGroup = options.find((o)=>'label' in o && o.label === option.label);
            if (existingGroup && existingGroup.optionType === 'group') {
                const newOptions = [
                    ...existingGroup?.options,
                    groupVal
                ];
                existingGroup.options = newOptions;
            }
        });
        else {
            if ((0, $7jTnu.fg)('jira_inline_field_config_gate')) option.options.forEach((groupVal)=>{
                if ((0, $gMbEk.isSingleValueOption)(groupVal)) keys.add(groupVal.value);
            });
            options.push(option);
        }
    }
};
const $c7a0e88bf351185c$export$f3b09dca68236b3 = (options, fullList, onSortOptions)=>options.map((option)=>{
        switch(option.optionType){
            case 'group':
                {
                    const newOptions = $c7a0e88bf351185c$export$f3b09dca68236b3(option.options, fullList, onSortOptions);
                    return {
                        ...option,
                        options: onSortOptions && (0, $7jTnu.fg)('jira_list_merged_column_gate') ? onSortOptions(newOptions) : newOptions
                    };
                }
            case 'avatar':
            case 'lozenge':
            case 'option':
                {
                    // keep same object reference to keep focus on same option on pagination
                    const optionRef = option;
                    optionRef.fullList = fullList;
                    return optionRef;
                }
            default:
                return option;
        }
    });
const $c7a0e88bf351185c$export$c21133b4499f5374 = (selected, data, formatMessage, previousData, addSelectedFirst = true)=>{
    // Handle currently selected
    const optionKeys = new Set();
    const options = [];
    if (addSelectedFirst) {
        if ((0, $7jTnu.fg)('jira_inline_field_config_gate')) $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, {
            id: (0, $398aa02f7b594968$export$bfd1c05c2e5a5a01),
            optionType: 'group',
            options: selected,
            label: formatMessage((0, $7XraK.default).selectedLabel)
        });
        else // add currently selected options
        selected && selected.forEach((val)=>{
            $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, val);
        });
    }
    if (previousData) // add previous loaded options
    previousData.forEach((val)=>{
        $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, val);
    });
    const deselectedValues = [];
    data && data.forEach((val)=>{
        // Add group options
        if (val && val.optionType === 'group') {
            const groupOptions = [];
            if ((0, $7jTnu.fg)('jira_inline_field_config_gate')) {
                let valOptions = val.options;
                if (val.id === (0, $398aa02f7b594968$export$bfd1c05c2e5a5a01)) {
                    const selectedKeys = selected.map((o)=>(0, $gMbEk.isSingleValueOption)(o) ? o.value : '');
                    valOptions = val.options.filter((o)=>{
                        if ((0, $gMbEk.isSingleValueOption)(o)) {
                            if (!selectedKeys.includes(o.value)) {
                                deselectedValues.push(o);
                                return false;
                            }
                            return true;
                        }
                        return false;
                    });
                } else valOptions = [
                    ...deselectedValues,
                    ...val.options
                ];
                valOptions.forEach((groupVal)=>{
                    // removing values from the group that are already in the options list (e.g. selected values, values from previousData)
                    $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, groupOptions, groupVal);
                });
            } else val.options.forEach((groupVal)=>{
                // removing values from the group that are already in the options list (e.g. selected values, values from previousData)
                $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, groupOptions, groupVal);
            });
            if (groupOptions.length > 0) $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, {
                ...val,
                options: groupOptions,
                optionType: 'group'
            });
            return;
        }
        // add individual options
        $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, val);
    });
    return options;
};
const $c7a0e88bf351185c$export$cc4ee748665ecf20 = (loadedOptionsWithFullList, value)=>{
    if (loadedOptionsWithFullList.length === 0) return value;
    const loadedOptionsWithFullListFlat = loadedOptionsWithFullList.flatMap((option)=>option.optionType === 'group' ? option.options : option);
    return value.map((selectedValue)=>loadedOptionsWithFullListFlat.find((option)=>(0, $gMbEk.isSingleValueOption)(option) && (0, $gMbEk.isSingleValueOption)(selectedValue) && selectedValue.value === option.value) || selectedValue);
};

});
parcelRegister("7XraK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6bbce5e4b9b1a0a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e6bbce5e4b9b1a0a$var$messages = (0, $7qGN1.defineMessages)({
    selectedLabel: {
        "id": "jql-builder-basic-picker.async-select.selected-label",
        "defaultMessage": "Selected"
    },
    loadingStart: {
        "id": "jql-builder-basic-picker.async-select.loading-start",
        "defaultMessage": "Loading more"
    },
    loadingEnd: {
        "id": "jql-builder-basic-picker.async-select.loading-end",
        "defaultMessage": "Finished loading"
    }
});
var $e6bbce5e4b9b1a0a$export$2e2bcd8739ae039 = $e6bbce5e4b9b1a0a$var$messages;

});



parcelRegister("hEe9x", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d51a2057bdff96c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $g5nWu = parcelRequire("g5nWu");

var $7PBuN = parcelRequire("7PBuN");

var $5xIBb = parcelRequire("5xIBb");
const $9d51a2057bdff96c$var$formatOptionLabel = (data)=>{
    switch(data.optionType){
        case 'avatar':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g5nWu.default), {
                data: data
            });
        case 'lozenge':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5xIBb.default), {
                data: data
            });
        case 'option':
        case 'field':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7PBuN.default), {
                data: data
            });
        default:
            return null;
    }
};
var $9d51a2057bdff96c$export$2e2bcd8739ae039 = $9d51a2057bdff96c$var$formatOptionLabel;

});
parcelRegister("g5nWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $53de91e06cefcdc0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $lG2jM = parcelRequire("lG2jM");

var $lRq8t = parcelRequire("lRq8t");

var $buJG5 = parcelRequire("buJG5");

var $9cbmy = parcelRequire("9cbmy");

var $jMiTg = parcelRequire("jMiTg");

var $lCwqw = parcelRequire("lCwqw");
const $53de91e06cefcdc0$export$fe00f602c942368a = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows,
        content: data.label,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabel), null, data.hideAvatar !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelIcon), null, data.isGroup === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StylesGroupIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), {
        LEGACY_size: "small",
        testId: "jql-builder-basic-picker.ui.format-option-label.avatar-option-label.group-icon",
        label: formatMessage((0, $lCwqw.default).groupIcon)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: typeof data.avatar !== 'string' ? undefined : data.avatar,
        size: "xsmall",
        testId: "jql-builder-basic-picker.ui.format-option-label.avatar-option-label.avatar",
        appearance: typeof data.square === 'boolean' && data.square === true ? 'square' : 'circle'
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelText), {
        ref: onLabelRef
    }, data.label)), data.disabledMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, data.disabledMessage)));
};
var $53de91e06cefcdc0$export$2e2bcd8739ae039 = $53de91e06cefcdc0$export$fe00f602c942368a;

});
parcelRegister("lG2jM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4ce7dd41e05f3ded01848e6f06d1f7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc7f518425e4bcf9$var$_react = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc7f518425e4bcf9$var$_peopleGroup = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hxN6p")));

var $fc7f518425e4bcf9$var$_peopleGroup2 = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hh8BY")));
function $fc7f518425e4bcf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc7f518425e4bcf9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $fc7f518425e4bcf9$var$_react.default.createElement($fc7f518425e4bcf9$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $fc7f518425e4bcf9$var$_peopleGroup2.default
    }, props));
$fc7f518425e4bcf9$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $fc7f518425e4bcf9$var$_default = module.exports.default = $fc7f518425e4bcf9$var$PeopleGroupIcon;

});
parcelRegister("hh8BY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c93ab4407be6cde9$var$_react = $c93ab4407be6cde9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $c93ab4407be6cde9$var$_peopleGroup = $c93ab4407be6cde9$var$_interopRequireDefault((parcelRequire("hxN6p")));
function $c93ab4407be6cde9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c93ab4407be6cde9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $c93ab4407be6cde9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props, {
        newIcon: $c93ab4407be6cde9$var$_peopleGroup.default
    }));
$c93ab4407be6cde9$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $c93ab4407be6cde9$var$_default = module.exports.default = $c93ab4407be6cde9$var$PeopleGroupIcon;

});


parcelRegister("buJG5", function(module, exports) {

$parcel$export(module.exports, "ConditionalTooltip", () => $f134232f4e230d4e$export$d8abb7a1cfbd4b6b);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");
const $f134232f4e230d4e$export$d8abb7a1cfbd4b6b = ({ condition: condition, children: children, ...rest })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), rest, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);

});

parcelRegister("jMiTg", function(module, exports) {

$parcel$export(module.exports, "PICKER_DROPDOWN_WIDTH", () => $53e13f8b42d31da6$export$ca493ca2aa631e47);
$parcel$export(module.exports, "StyledOption", () => $53e13f8b42d31da6$export$844bee7de236d7ec);
$parcel$export(module.exports, "StyledLabel", () => $53e13f8b42d31da6$export$eea83358d9434634);
$parcel$export(module.exports, "StyledLabelIcon", () => $53e13f8b42d31da6$export$282e0b7f297acea7);
$parcel$export(module.exports, "StyledIcon", () => $53e13f8b42d31da6$export$7c8f159da0dc916);
$parcel$export(module.exports, "StyledLabelText", () => $53e13f8b42d31da6$export$601dc5d21f1e8182);
$parcel$export(module.exports, "StyledLozenge", () => $53e13f8b42d31da6$export$fb418b53e6535057);
$parcel$export(module.exports, "StyledLozengeLabel", () => $53e13f8b42d31da6$export$cd2803f359bf9865);
$parcel$export(module.exports, "StyledSecondaryLabel", () => $53e13f8b42d31da6$export$385a11497793b305);
$parcel$export(module.exports, "StylesGroupIconContainer", () => $53e13f8b42d31da6$export$56cfb14c006d4229);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $53e13f8b42d31da6$export$ca493ca2aa631e47 = 300;
const $53e13f8b42d31da6$export$844bee7de236d7ec = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$eea83358d9434634 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$282e0b7f297acea7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _18u0v77o",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$7c8f159da0dc916 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1ssb _4t3i7vkz _1bsb7vkz _1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$601dc5d21f1e8182 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _18u01b66",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$fb418b53e6535057 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _18u01b66 _p12f1osq",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$cd2803f359bf9865 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _1bsb1osq _1bto1l2s _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$385a11497793b305 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _11c81o8v _zulpv77o _1bto1l2s _syaz131l _19pk1i6y _18u01b66 _4cvr1h6o _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$56cfb14c006d4229 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lCwqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dbf9dc996adfbbc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8dbf9dc996adfbbc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    groupIcon: {
        "id": "jql-builder-basic-picker.format-option-label.avatar-option-label.group-icon",
        "defaultMessage": "Group Icon"
    }
});

});


parcelRegister("7PBuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c0e2fe81e1bf76c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $buJG5 = parcelRequire("buJG5");

var $9cbmy = parcelRequire("9cbmy");

var $jMiTg = parcelRequire("jMiTg");
const $9c0e2fe81e1bf76c$export$914fa095fc1e0a45 = ({ data: data })=>{
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const [secondaryLabelOverflows, setSecondaryLabelOverflows] = (0, $eJOHy.useState)(false);
    const showSecondaryLabel = (input)=>typeof input.secondaryLabel === 'string' && input.secondaryLabel.length > 0 || // remove !isValidElement(data.secondaryLabel) with cleanup with m7.3-mm2-custom-fields-with-existing-uis_vzhn7
        typeof input.secondaryLabel === 'object' && !/*#__PURE__*/ (0, $eJOHy.isValidElement)(input.secondaryLabel) && /*#__PURE__*/ (0, $eJOHy.isValidElement)(input.secondaryLabel.element);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    const onSecondaryLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setSecondaryLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    const tooltipContent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, data.label), typeof data.secondaryLabel === 'string' && data.secondaryLabel.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, "(", data.secondaryLabel, ")")), [
        data
    ]);
    const getSecondaryLabelComponent = (option)=>{
        if (typeof option === 'object' && !/*#__PURE__*/ (0, $eJOHy.isValidElement)(option)) return option.element;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, option);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows || secondaryLabelOverflows,
        content: tooltipContent,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabel), null, data.icon != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledIcon), {
        src: data.icon,
        alt: data.label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelText), {
        ref: onLabelRef
    }, data.label)), showSecondaryLabel(data) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledSecondaryLabel), {
        ref: onSecondaryLabelRef,
        "data-testid": "jql-builder-basic-picker.ui.format-option-label.icon-option-label.secondary-label"
    }, data.secondaryLabel && getSecondaryLabelComponent(data.secondaryLabel))), data.disabledMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, data.disabledMessage));
};
var $9c0e2fe81e1bf76c$export$2e2bcd8739ae039 = $9c0e2fe81e1bf76c$export$914fa095fc1e0a45;

});

parcelRegister("5xIBb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba51567c14d8e757$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $dPMMf = parcelRequire("dPMMf");

var $buJG5 = parcelRequire("buJG5");

var $9cbmy = parcelRequire("9cbmy");

var $jMiTg = parcelRequire("jMiTg");
// Checkbox icon width = 3 * gridSize
// Margins and paddings around checkbox icon = 2 * gridSize
// Option right padding = (3 / 2) * gridSize
const $ba51567c14d8e757$var$DEFAULT_MAX_WIDTH = (0, $jMiTg.PICKER_DROPDOWN_WIDTH) - 3 * (0, $dPMMf.gridSize) - 2 * (0, $dPMMf.gridSize) - 1.5 * (0, $dPMMf.gridSize);
const $ba51567c14d8e757$export$5f70fe304106fcb1 = ({ data: data })=>{
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLozenge), {
        "data-testid": "jql-builder-basic-picker.ui.format-option-label.lozenge-option-label.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: data.appearance,
        isBold: data.isBold,
        maxWidth: data.maxWidth ?? $ba51567c14d8e757$var$DEFAULT_MAX_WIDTH
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows,
        content: data.label,
        position: "right",
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLozengeLabel), {
        ref: onLabelRef
    }, data.label))))), data.disabledMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, data.disabledMessage));
};
var $ba51567c14d8e757$export$2e2bcd8739ae039 = $ba51567c14d8e757$export$5f70fe304106fcb1;

});


parcelRegister("5LwVz", function(module, exports) {

$parcel$export(module.exports, "DefaultPopupComponent", () => $4e7f80d8c92d0b45$export$5038854ec49970e4);
$parcel$export(module.exports, "FixedWidthPopupComponent", () => $4e7f80d8c92d0b45$export$84690c88a5faffa0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $IW7jS = parcelRequire("IW7jS");

var $jMiTg = parcelRequire("jMiTg");
const $4e7f80d8c92d0b45$var$getPopupComponent = (width)=>/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4e7f80d8c92d0b45$var$PopupComponentContainer, {
            ...props,
            ref: ref,
            width: width
        }));
const $4e7f80d8c92d0b45$export$5038854ec49970e4 = $4e7f80d8c92d0b45$var$getPopupComponent();
const $4e7f80d8c92d0b45$export$84690c88a5faffa0 = $4e7f80d8c92d0b45$var$getPopupComponent((0, $jMiTg.PICKER_DROPDOWN_WIDTH));
// Workaround for https://github.com/atlassian-labs/compiled/issues/1200
const $4e7f80d8c92d0b45$var$layerValue = (0, $IW7jS.layers).layer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e7f80d8c92d0b45$var$PopupComponentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _bfhk1bhr _16qs1cd0 _vchhusvi _1e0c1txw _2lx21bp4 _1pby1nn1 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.width && "_1bsb1efm",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2ftMY", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $4970e401839ffb92$export$6df0712d20d2cc08);
$parcel$export(module.exports, "useFields", () => $4970e401839ffb92$export$d25cd19bd4b6c629);

var $bzKDb = parcelRequire("bzKDb");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");


var $3cMgR = parcelRequire("3cMgR");

var $gYnSx = parcelRequire("gYnSx");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $3Zpjn = parcelRequire("3Zpjn");

var $cjRWP = parcelRequire("cjRWP");

var $fexQV = parcelRequire("fexQV");

var $kEUB1 = parcelRequire("kEUB1");

var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $22GDK = parcelRequire("22GDK");

var $gX8pG = parcelRequire("gX8pG");
const $4970e401839ffb92$var$WHERE_CLAUSE = 'WHERE';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $4970e401839ffb92$var$ORDER_BY_CLAUSE = 'ORDER_BY';
const $4970e401839ffb92$export$6df0712d20d2cc08 = (node, itemType, intl)=>{
    const notInContextFieldMessageIssueTermRefreshGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $gX8pG.default).notInContextFieldMessageIssueTermRefreshGalaxia : (0, $gX8pG.default).notInContextFieldMessageIssueTermRefresh;
    if (!node) return undefined;
    const { displayName: displayName, jqlTerm: jqlTerm, searchTemplate: searchTemplate, type: type, operators: operators, description: description, fieldType: fieldType, shouldShowInContext: shouldShowInContext } = node;
    // Search template & type are required; description can be null but not undefined
    if (searchTemplate == null || searchTemplate.key == null || type == null || description === undefined) {
        (0, $gYnSx.default)({
            meta: {
                id: 'getOption',
                packageName: (0, $dTJxm.PACKAGE_NAME),
                teamName: (0, $dTJxm.TEAM_NAME)
            },
            error: new Error('Field node missing required data'),
            attributes: {
                searchTemplate: searchTemplate == null ? 'missing' : {
                    key: searchTemplate.key
                },
                fieldType: type == null ? 'missing' : type,
                description: description === undefined ? 'missing' : 'present'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return undefined;
    }
    const isDisabledEpicLinkField = searchTemplate?.key === (0, $dTJxm.EPIC_LINK).searchTemplate;
    const fieldTypeDisplayName = fieldType?.displayName ?? null;
    const icon = type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fexQV.FieldTypeIcon), {
        type: type,
        size: "small"
    }) : undefined;
    const fieldLabel = displayName != null ? displayName : jqlTerm;
    let isOnlyUnselectable = false;
    let disabledMessage = isDisabledEpicLinkField ? intl.formatMessage((0, $gX8pG.default).deprecatedEpicMessage, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "strong",
                color: "inherit",
                size: "UNSAFE_small"
            }, chunks)
    }) : undefined;
    if (shouldShowInContext === false) {
        isOnlyUnselectable = true;
        disabledMessage = intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? notInContextFieldMessageIssueTermRefreshGalaxia : (0, $gX8pG.default).notInContextFieldMessage);
    }
    if (isDisabledEpicLinkField) {
        isOnlyUnselectable = true;
        disabledMessage = intl.formatMessage((0, $gX8pG.default).deprecatedEpicMessage, {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    as: "strong",
                    color: "inherit",
                    size: "UNSAFE_small"
                }, chunks)
        });
    }
    return {
        optionType: 'field',
        label: fieldLabel,
        value: jqlTerm.toLowerCase(),
        searchTemplate: searchTemplate?.key,
        fieldType: type,
        fieldDescription: description,
        isOnlyUnselectable: isOnlyUnselectable,
        secondaryLabel: fieldTypeDisplayName && icon ? (0, $cjRWP.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
        fieldTypeDisplayName: fieldTypeDisplayName,
        itemType: itemType,
        disabledMessage: disabledMessage,
        operators: operators?.map((0, $22GDK.mapOperators))
    };
};
const $4970e401839ffb92$export$d25cd19bd4b6c629 = ({ jql: jql = '', excludeFields: excludeFields = [], forClause: forClause = $4970e401839ffb92$var$WHERE_CLAUSE, viewContext: viewContext = null, scope: scope = null })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const intl = (0, $lRq8t.default)();
    return (0, $eJOHy.useMemo)(()=>(0, $3Zpjn.createGenericDebouncableDataLoader)(async (search, renderInitialValues, endCursor)=>{
            try {
                const data = await (0, $j4oe4.fetchQuery)(environment, (0, $bzKDb.default), {
                    cloudId: cloudId,
                    first: 10,
                    searchString: search,
                    after: typeof endCursor === 'string' ? endCursor : undefined,
                    excludeFields: excludeFields,
                    forClause: forClause,
                    jqlContext: jql,
                    viewContext: viewContext,
                    scope: scope
                }, {
                    fetchPolicy: 'store-or-network'
                }).toPromise();
                if (data?.jira?.jqlBuilder?.fields?.__typename === 'JiraJqlFieldConnection') {
                    if (!data?.jira?.jqlBuilder?.fields?.edges) return (0, $eiIzV.generateOptions)([]);
                    const { edges: fields, totalCount: totalCount, pageInfo: { endCursor: newEndCursor } } = data.jira.jqlBuilder.fields;
                    return (0, $eiIzV.generateOptions)(fields.reduce((options, edge)=>{
                        const option = $4970e401839ffb92$export$6df0712d20d2cc08(edge?.node, (0, $862dfd240457f00b$export$38accfc5a5d1c113), intl);
                        if (option) options.push(option);
                        return options;
                    }, []), totalCount, newEndCursor || undefined);
                }
                return {
                    options: [],
                    totalCount: 0
                };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gYnSx.default)({
                    meta: {
                        id: 'fetchMoreFieldsOptions',
                        packageName: (0, $dTJxm.PACKAGE_NAME),
                        teamName: (0, $dTJxm.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                return {
                    options: [
                        {
                            optionType: 'error',
                            error: error,
                            onRetry: ()=>undefined
                        }
                    ],
                    totalCount: 0
                };
            }
        }), [
        cloudId,
        environment,
        excludeFields,
        forClause,
        intl,
        jql,
        viewContext,
        scope
    ]);
};

});
parcelRegister("bzKDb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed8902967b18900a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<25629de5cd6521c2c4d8ddbae307cfb6>>
 * @relayHash 9f3804059f817e66c9f5d118131a5d95
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 278d1d02ca9988a436ecd2ed0f40ed9bd2d6714d11a8385dc7bb75edb65af03b
const $ed8902967b18900a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeFields"
    }, v3 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "forClause"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlContext"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v9 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v10 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "excludeFields",
            "variableName": "excludeFields"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "forClause",
            "variableName": "forClause"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jqlContext"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v13 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "concreteType": "JiraJqlFieldEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraJqlField",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                    },
                    v14 /*: any*/ ,
                    {
                        "concreteType": "JiraJqlSearchTemplate",
                        "kind": "LinkedField",
                        "name": "searchTemplate",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "operators"
                    },
                    {
                        "concreteType": "JiraFieldType",
                        "kind": "LinkedField",
                        "name": "fieldType",
                        "plural": false,
                        "selections": [
                            v14 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "shouldShowInContext"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_IssueTypeJqlBuilderBasicFieldsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v9 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v10 /*: any*/ ,
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v11 /*: any*/ ,
                                                    v12 /*: any*/ ,
                                                    v13 /*: any*/ ,
                                                    v15 /*: any*/ 
                                                ],
                                                "type": "JiraJqlFieldConnection"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v11 /*: any*/ 
                                                ],
                                                "type": "QueryError"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_IssueTypeJqlBuilderBasicFieldsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ],
                                            "type": "JiraJqlFieldConnection"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "278d1d02ca9988a436ecd2ed0f40ed9bd2d6714d11a8385dc7bb75edb65af03b",
            "metadata": {},
            "name": "main_IssueTypeJqlBuilderBasicFieldsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ed8902967b18900a$var$node.hash = "744e35745d428b3b4fc4514e1a4087bc";
var $ed8902967b18900a$export$2e2bcd8739ae039 = $ed8902967b18900a$var$node;

});

parcelRegister("3Zpjn", function(module, exports) {

$parcel$export(module.exports, "createGenericDebouncableDataLoader", () => $515f3085be272897$export$ea63a11564958c9e);

var $3s8bj = parcelRequire("3s8bj");
const $515f3085be272897$export$ea63a11564958c9e = (dataLoader)=>{
    const debouncedDataLoader = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((search, enableFullList, endCursor, cb)=>dataLoader(search, enableFullList, endCursor).then((data)=>{
            cb(data);
            return data;
        }), 500);
    return (search, enableFullList, endCursor, cb)=>{
        // No need to debounce When no search string is provided.
        // We want the initial list displaying as quickly as possible when a user reopens the dropdown.
        // It will be cached by the GraphQL client and debouncing will show an unneccessary spinner.
        if (!search) {
            debouncedDataLoader.cancel();
            return dataLoader(search, enableFullList, endCursor).then((data)=>{
                cb(data);
                return data;
            });
        }
        return debouncedDataLoader(search, enableFullList, endCursor, cb);
    };
};
var $515f3085be272897$export$2e2bcd8739ae039 = $515f3085be272897$export$ea63a11564958c9e;

});

parcelRegister("cjRWP", function(module, exports) {

$parcel$export(module.exports, "getSecondaryLabelWithIcon", () => $fe2515622481ebd0$export$de24d837eb50c435);

var $eJOHy = parcelRequire("eJOHy");
const $fe2515622481ebd0$export$de24d837eb50c435 = (icon, fieldTypeDisplayName)=>({
        label: fieldTypeDisplayName,
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, icon, fieldTypeDisplayName)
    });

});

parcelRegister("fexQV", function(module, exports) {

$parcel$export(module.exports, "fieldTypesIcons", () => $a32db5a6d1618aac$export$67f993f3bbfb364d);
$parcel$export(module.exports, "panelIcons", () => $a32db5a6d1618aac$export$4641b622f6c36f58);
$parcel$export(module.exports, "allFieldTypeGlyphs", () => $a32db5a6d1618aac$export$14355977bfae6aaa);
$parcel$export(module.exports, "StrictFieldTypeIcon", () => $a32db5a6d1618aac$export$aaac7dbe01e6025d);
$parcel$export(module.exports, "FieldTypeIcon", () => $a32db5a6d1618aac$export$87c5289d8835f589);
$parcel$export(module.exports, "default", () => $a32db5a6d1618aac$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $9qes7 = parcelRequire("9qes7");

var $jlvUH = parcelRequire("jlvUH");

var $hMpZ8 = parcelRequire("hMpZ8");

var $76mtb = parcelRequire("76mtb");

var $fwfzA = parcelRequire("fwfzA");

var $7jTnu = parcelRequire("7jTnu");

var $bJscI = parcelRequire("bJscI");

var $814y1 = parcelRequire("814y1");

var $h7qTf = parcelRequire("h7qTf");

var $33mJg = parcelRequire("33mJg");
// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => ReactElement<any, string | JSXElementConstructor<any>>' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
const $a32db5a6d1618aac$var$ResizedIcon = ({ glyph: glyph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: glyph,
        size: "medium"
    });
const $a32db5a6d1618aac$var$TeamCfTypeIcon = (0, $bJscI.componentWithFG)('twcj-37_update_team_icons_and_avatars_in_jira', (0, (/*@__PURE__*/$parcel$interopDefault($fwfzA))), (0, (/*@__PURE__*/$parcel$interopDefault($hMpZ8))));
const $a32db5a6d1618aac$var$checkedFieldTypesIcons = {
    [(0, $814y1.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.numberGlyph)
    }),
    [(0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.numberGlyph)
    }),
    [(0, $814y1.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    [(0, $814y1.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    [(0, $814y1.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    [(0, $814y1.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.radioGlyph)
    }),
    [(0, $814y1.SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.MULTI_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.doubleDropdownGlyph)
    }),
    [(0, $814y1.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $h7qTf.USERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $h7qTf.MULTIUSERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.FLAGGED_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    [(0, $814y1.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    [(0, $814y1.TEAM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    // <ResizedIcon /> was introduced when SWIFT had a limited number of supported field types,
    // but it's no longer a scalable option. We should be using icons directly provided by @atlaskit,
    // and if it does not match our design constraints, then we'll need to investigate contributing to a new @atlaskit icon set.
    [(0, $814y1.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$TeamCfTypeIcon, {
        spacing: "spacious",
        label: ""
    }),
    [(0, $814y1.PARENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    [(0, $814y1.BASELINE_START_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    [(0, $814y1.BASELINE_END_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    [(0, $814y1.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.shipGlyph)
    }),
    [(0, $814y1.REQUEST_PARTICIPANTS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGroupGlyph)
    }),
    [(0, $814y1.ORGANIZATIONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.officeBuildingGlyph)
    }),
    [(0, $814y1.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.ATTACHMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.attachmentGlyph)
    }),
    [(0, $814y1.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    [(0, $814y1.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.priorityGlyph)
    }),
    [(0, $814y1.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    [(0, $814y1.TIME_ESTIMATE_CONFIG_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    [(0, $814y1.TIME_TRACKING_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeTrackingGlyph)
    }),
    [(0, $814y1.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.originalTimeEstimateGlyph)
    }),
    [(0, $814y1.ASSETS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.screenGlyph)
    }),
    [(0, $814y1.SERVICE_ENTITY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    [(0, $814y1.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.arrowRightGlyph)
    }),
    [(0, $814y1.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.shortTextGlyph)
    }),
    [(0, $h7qTf.DESCRIPTION_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.shortTextGlyph)
    }),
    [(0, $h7qTf.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.checkboxGlyph)
    }),
    [(0, $814y1.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    [(0, $h7qTf.ENVIRONMENT_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.commentGlyph)
    }),
    [(0, $814y1.APPROVERS_LIST_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.appAccessGlyph)
    }),
    [(0, $814y1.APPROVALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.appAccessGlyph)
    }),
    [(0, $814y1.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.folderGlyph)
    }),
    [(0, $814y1.MESSAGE_EDIT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.MESSAGE_VIEW_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.jwmCategoryGlyph)
    }),
    [(0, $814y1.ENTITLEMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.SENTIMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    [(0, $814y1.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }),
    [(0, $814y1.ORGANIZATION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    })
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$a32db5a6d1618aac$var$checkedFieldTypesIcons
});
const $a32db5a6d1618aac$export$67f993f3bbfb364d = $a32db5a6d1618aac$var$checkedFieldTypesIcons;
const $a32db5a6d1618aac$export$4641b622f6c36f58 = {
    development: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jlvUH))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    }),
    devSummary: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jlvUH))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    }),
    timetracking: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($76mtb))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    })
};
/**
 * @deprecated - consider using allFieldTypeGlyphs or FieldTypeIcon instead
 */ const $a32db5a6d1618aac$var$allIcons = {
    ...$a32db5a6d1618aac$export$67f993f3bbfb364d,
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    number: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.numberGlyph)
    }),
    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    datetime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    dropdown: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    addon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.addonGlyph)
    }),
    checkbox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.checkboxGlyph)
    }),
    user: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    radio: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.radioGlyph)
    }),
    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.commentGlyph)
    }),
    bulletList: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.bulletListGlyph)
    }),
    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    labelpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    close: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.closeGlyph)
    }),
    assetspicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.screenGlyph)
    }),
    select: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    multiselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    cascadingselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.doubleDropdownGlyph)
    }),
    multigrouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    grouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    multiversion: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    version: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    projectpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    customField: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    })
};
const $a32db5a6d1618aac$var$checkedFieldTypesGlyphs = {
    [(0, $814y1.NUMBER_CF_TYPE)]: (0, $33mJg.numberGlyph),
    [(0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $33mJg.numberGlyph),
    [(0, $814y1.LABELS_CF_TYPE)]: (0, $33mJg.labelGlyph),
    [(0, $814y1.DATE_CF_TYPE)]: (0, $33mJg.dateGlyph),
    [(0, $814y1.DATETIME_CF_TYPE)]: (0, $33mJg.timeStampGlyph),
    [(0, $814y1.RADIO_BUTTONS_CF_TYPE)]: (0, $33mJg.radioGlyph),
    [(0, $814y1.SELECT_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.MULTI_SELECT_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.CASCADING_SELECT_CF_TYPE)]: (0, $33mJg.doubleDropdownGlyph),
    [(0, $814y1.MULTI_VERSION_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.VERSION_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.GROUP_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.MULTI_GROUP_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.USER_CF_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $h7qTf.USERPICKER_FIELD_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.MULTI_USER_CF_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $h7qTf.MULTIUSERPICKER_FIELD_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.PEOPLE_CF_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.FLAGGED_CF_TYPE)]: (0, $33mJg.timeStampGlyph),
    [(0, $814y1.URL_CF_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $814y1.TEAM_CF_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $814y1.PARENT_CF_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $814y1.BASELINE_START_CF_TYPE)]: (0, $33mJg.dateGlyph),
    [(0, $814y1.BASELINE_END_CF_TYPE)]: (0, $33mJg.dateGlyph),
    [(0, $814y1.SPRINT_TYPE)]: (0, $33mJg.shipGlyph),
    [(0, $814y1.REQUEST_PARTICIPANTS_CF_TYPE)]: (0, $33mJg.peopleGroupGlyph),
    [(0, $814y1.ORGANIZATIONS_CF_TYPE)]: (0, $33mJg.officeBuildingGlyph),
    [(0, $814y1.REPORTER_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.ATTACHMENT_TYPE)]: (0, $33mJg.attachmentGlyph),
    [(0, $814y1.ASSIGNEE_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.LABELS_TYPE)]: (0, $33mJg.labelGlyph),
    [(0, $814y1.PRIORITY_TYPE)]: (0, $33mJg.priorityGlyph),
    [(0, $814y1.DUE_DATE_TYPE)]: (0, $33mJg.dateGlyph),
    [(0, $814y1.TIME_ESTIMATE_CONFIG_TYPE)]: (0, $33mJg.timeStampGlyph),
    [(0, $814y1.TIME_TRACKING_TYPE)]: (0, $33mJg.timeTrackingGlyph),
    [(0, $814y1.TIME_ESTIMATE_TYPE)]: (0, $33mJg.originalTimeEstimateGlyph),
    [(0, $814y1.ASSETS_CF_TYPE)]: (0, $33mJg.screenGlyph),
    [(0, $814y1.SERVICE_ENTITY_CF_TYPE)]: (0, $33mJg.labelGlyph),
    [(0, $814y1.STATUS_TYPE)]: (0, $33mJg.arrowRightGlyph),
    [(0, $814y1.SUMMARY_TYPE)]: (0, $33mJg.shortTextGlyph),
    [(0, $h7qTf.DESCRIPTION_FIELD_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.TEXT_CF_TYPE)]: (0, $33mJg.shortTextGlyph),
    [(0, $h7qTf.TEXT_AREA_CF_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.MULTI_CHECKBOXES_CF_TYPE)]: (0, $33mJg.checkboxGlyph),
    [(0, $814y1.ISSUE_LINKS_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $h7qTf.ENVIRONMENT_FIELD_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.FIX_VERSIONS_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.COMMENT_TYPE)]: (0, $33mJg.commentGlyph),
    [(0, $814y1.APPROVERS_LIST_CF_TYPE)]: (0, $33mJg.appAccessGlyph),
    [(0, $814y1.APPROVALS_CF_TYPE)]: (0, $33mJg.appAccessGlyph),
    [(0, $814y1.PROJECT_PICKER_CF_TYPE)]: (0, $33mJg.folderGlyph),
    [(0, $814y1.MESSAGE_EDIT_CF_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.MESSAGE_VIEW_CF_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.CATEGORY_TYPE)]: (0, $33mJg.jwmCategoryGlyph),
    [(0, $814y1.ENTITLEMENT_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.SENTIMENT_CF_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $814y1.ORGANIZATION_CF_TYPE)]: (0, $33mJg.customFieldGlyph)
};
const $a32db5a6d1618aac$export$14355977bfae6aaa = {
    ...$a32db5a6d1618aac$var$checkedFieldTypesGlyphs,
    text: (0, $33mJg.paragraphGlyph),
    number: (0, $33mJg.numberGlyph),
    date: (0, $33mJg.dateGlyph),
    datetime: (0, $33mJg.timeStampGlyph),
    dropdown: (0, $33mJg.dropdownGlyph),
    addon: (0, $33mJg.addonGlyph),
    checkbox: (0, $33mJg.checkboxGlyph),
    user: (0, $33mJg.peopleGlyph),
    radio: (0, $33mJg.radioGlyph),
    time: (0, $33mJg.timeStampGlyph),
    message: (0, $33mJg.commentGlyph),
    bulletList: (0, $33mJg.bulletListGlyph),
    label: (0, $33mJg.labelGlyph),
    labelpicker: (0, $33mJg.labelGlyph),
    close: (0, $33mJg.closeGlyph),
    assetspicker: (0, $33mJg.screenGlyph),
    select: (0, $33mJg.dropdownGlyph),
    multiselect: (0, $33mJg.dropdownGlyph),
    cascadingselect: (0, $33mJg.doubleDropdownGlyph),
    multigrouppicker: (0, $33mJg.dropdownGlyph),
    grouppicker: (0, $33mJg.dropdownGlyph),
    multiversion: (0, $33mJg.dropdownGlyph),
    version: (0, $33mJg.dropdownGlyph),
    projectpicker: (0, $33mJg.dropdownGlyph),
    customField: (0, $33mJg.customFieldGlyph)
};
const $a32db5a6d1618aac$export$aaac7dbe01e6025d = /*#__PURE__*/ (0, $eJOHy.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $814y1.TEAMS_PLATFORM_CF_TYPE)) return (0, $7jTnu.fg)('twcj-37_update_team_icons_and_avatars_in_jira') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fwfzA))), {
        label: "",
        size: size,
        spacing: "spacious",
        testId: testId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMpZ8))), {
        label: "",
        size: size,
        testId: testId
    });
    if (type === (0, $814y1.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: $a32db5a6d1618aac$var$checkedFieldTypesGlyphs[type] || $a32db5a6d1618aac$var$checkedFieldTypesGlyphs.customField,
        size: size,
        testId: testId
    });
});
const $a32db5a6d1618aac$export$87c5289d8835f589 = /*#__PURE__*/ (0, $eJOHy.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $814y1.TEAMS_PLATFORM_CF_TYPE)) {
        const iconSpacing = size === 'small' ? 'compact' : 'spacious';
        return (0, $7jTnu.fg)('twcj-37_update_team_icons_and_avatars_in_jira') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fwfzA))), {
            label: "",
            size: size,
            spacing: iconSpacing,
            testId: testId
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMpZ8))), {
            label: "",
            size: size,
            testId: testId
        });
    }
    if (type === (0, $814y1.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9qes7))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        label: "",
        glyph: $a32db5a6d1618aac$export$14355977bfae6aaa[type] || $a32db5a6d1618aac$export$14355977bfae6aaa.customField,
        size: size,
        testId: testId
    });
});
var /**
 * @deprecated - Use allFieldTypeGlyphs or FieldTypeIcon instead.
 */ $a32db5a6d1618aac$export$2e2bcd8739ae039 = $a32db5a6d1618aac$var$allIcons;

});
parcelRegister("jlvUH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf5f697d891cc6bba8e40c46639eb125>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e158bbdd28450239$var$_react = $e158bbdd28450239$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e158bbdd28450239$var$_branch = $e158bbdd28450239$var$_interopRequireDefault((parcelRequire("awZZu")));

var $e158bbdd28450239$var$_branches = $e158bbdd28450239$var$_interopRequireDefault((parcelRequire("1H8nC")));
function $e158bbdd28450239$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BranchIcon.
 * This component is BranchIcon, with `UNSAFE_fallbackIcon` set to "BitbucketBranchesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e158bbdd28450239$var$BranchIcon = (props)=>/*#__PURE__*/ $e158bbdd28450239$var$_react.default.createElement($e158bbdd28450239$var$_branch.default, Object.assign({
        LEGACY_fallbackIcon: $e158bbdd28450239$var$_branches.default
    }, props));
$e158bbdd28450239$var$BranchIcon.Name = 'BranchIconMigration';
var $e158bbdd28450239$var$_default = module.exports.default = $e158bbdd28450239$var$BranchIcon;

});
parcelRegister("awZZu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aacfa98324a1e60$var$_react = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7aacfa98324a1e60$var$_baseNew = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7aacfa98324a1e60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aacfa98324a1e60$var$BranchIcon = (props)=>/*#__PURE__*/ $7aacfa98324a1e60$var$_react.default.createElement($7aacfa98324a1e60$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$7aacfa98324a1e60$var$BranchIcon.displayName = 'BranchIcon';
var $7aacfa98324a1e60$var$_default = module.exports.default = $7aacfa98324a1e60$var$BranchIcon;

});

parcelRegister("1H8nC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13c04eaf2d4940c0$var$_react = $13c04eaf2d4940c0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $13c04eaf2d4940c0$var$_branch = $13c04eaf2d4940c0$var$_interopRequireDefault((parcelRequire("awZZu")));
function $13c04eaf2d4940c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $13c04eaf2d4940c0$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $13c04eaf2d4940c0$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $13c04eaf2d4940c0$var$_branch.default
    }));
$13c04eaf2d4940c0$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $13c04eaf2d4940c0$var$_default = module.exports.default = $13c04eaf2d4940c0$var$BitbucketBranchesIcon;

});


parcelRegister("76mtb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8fa98d5af7aa71848cf5218e04fd5c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52ba85f679c445d8$var$_react = $52ba85f679c445d8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $52ba85f679c445d8$var$_stopwatch = $52ba85f679c445d8$var$_interopRequireDefault((parcelRequire("1x1T9")));

var $52ba85f679c445d8$var$_stopwatch2 = $52ba85f679c445d8$var$_interopRequireDefault((parcelRequire("5NWMp")));
function $52ba85f679c445d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StopwatchIcon.
 * This component is StopwatchIcon, with `UNSAFE_fallbackIcon` set to "StopwatchIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $52ba85f679c445d8$var$StopwatchIcon = (props)=>/*#__PURE__*/ $52ba85f679c445d8$var$_react.default.createElement($52ba85f679c445d8$var$_stopwatch.default, Object.assign({
        LEGACY_fallbackIcon: $52ba85f679c445d8$var$_stopwatch2.default
    }, props));
$52ba85f679c445d8$var$StopwatchIcon.Name = 'StopwatchIconMigration';
var $52ba85f679c445d8$var$_default = module.exports.default = $52ba85f679c445d8$var$StopwatchIcon;

});
parcelRegister("1x1T9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da0501648aefebd7252ab6523b352986>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $11da568a8257a9ac$var$_react = $11da568a8257a9ac$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $11da568a8257a9ac$var$_baseNew = $11da568a8257a9ac$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $11da568a8257a9ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $11da568a8257a9ac$var$StopwatchIcon = (props)=>/*#__PURE__*/ $11da568a8257a9ac$var$_react.default.createElement($11da568a8257a9ac$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 0h6v1.5H8.75v1.543a6.47 6.47 0 0 1 3.06 1.19l1.137-1.24 1.106 1.014-1.137 1.24a6.5 6.5 0 1 1-9.832 0l-1.137-1.24 1.106-1.014 1.137 1.24a6.47 6.47 0 0 1 3.06-1.19V1.5H5zm3 4.5a4.98 4.98 0 0 0-3.378 1.314A5 5 0 1 0 8 4.5m2.842 3.01-2.541 2.75-1.102-1.02 2.542-2.75z" clip-rule="evenodd"/>`
    }, props));
$11da568a8257a9ac$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $11da568a8257a9ac$var$_default = module.exports.default = $11da568a8257a9ac$var$StopwatchIcon;

});

parcelRegister("5NWMp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $439f1fc60d1c82c5$var$_react = $439f1fc60d1c82c5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $439f1fc60d1c82c5$var$_stopwatch = $439f1fc60d1c82c5$var$_interopRequireDefault((parcelRequire("1x1T9")));
function $439f1fc60d1c82c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $439f1fc60d1c82c5$var$StopwatchIcon = (props)=>/*#__PURE__*/ $439f1fc60d1c82c5$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.587 6.988.626-.664c.203-.215.481-.324.76-.324.247 0 .496.086.694.262a.98.98 0 0 1 .063 1.414l-.565.6a7 7 0 1 1-10.33 0l-.564-.6a.98.98 0 0 1 .062-1.414A1.04 1.04 0 0 1 7.03 6c.278 0 .556.109.76.324l.624.664a7 7 0 0 1 2.582-.916L10.998 5H10.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.498l.001 1.071a7 7 0 0 1 2.584.917M12 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10m.368-4.232a.796.796 0 0 1-1.14-.018.834.834 0 0 1 .018-1.163l2.386-2.355a.796.796 0 0 1 1.14.018.834.834 0 0 1-.018 1.163z"/></svg>`
    }, props, {
        newIcon: $439f1fc60d1c82c5$var$_stopwatch.default
    }));
$439f1fc60d1c82c5$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $439f1fc60d1c82c5$var$_default = module.exports.default = $439f1fc60d1c82c5$var$StopwatchIcon;

});


parcelRegister("33mJg", function(module, exports) {

$parcel$export(module.exports, "numberGlyph", () => $845d6a4dfc3d7122$export$b368272069fe93ea);
$parcel$export(module.exports, "checkboxGlyph", () => $845d6a4dfc3d7122$export$747056db840f2e62);
$parcel$export(module.exports, "folderGlyph", () => $845d6a4dfc3d7122$export$fc939f15c0ac57d8);
$parcel$export(module.exports, "dateGlyph", () => $845d6a4dfc3d7122$export$54ae6633cc16eed1);
$parcel$export(module.exports, "dropdownGlyph", () => $845d6a4dfc3d7122$export$d298f123ec74117c);
$parcel$export(module.exports, "doubleDropdownGlyph", () => $845d6a4dfc3d7122$export$b3ea0fc10228ca3e);
$parcel$export(module.exports, "labelGlyph", () => $845d6a4dfc3d7122$export$fc64eea29ed0831d);
$parcel$export(module.exports, "paragraphGlyph", () => $845d6a4dfc3d7122$export$cbee9ded46569696);
$parcel$export(module.exports, "peopleGlyph", () => $845d6a4dfc3d7122$export$2ade78849d2113ea);
$parcel$export(module.exports, "shortTextGlyph", () => $845d6a4dfc3d7122$export$1c6cf19eb34bcc14);
$parcel$export(module.exports, "timeStampGlyph", () => $845d6a4dfc3d7122$export$98a4a461fe316fce);
$parcel$export(module.exports, "timeTrackingGlyph", () => $845d6a4dfc3d7122$export$637d50811e2b7176);
$parcel$export(module.exports, "originalTimeEstimateGlyph", () => $845d6a4dfc3d7122$export$bc2bb299bed9df91);
$parcel$export(module.exports, "arrowRightGlyph", () => $845d6a4dfc3d7122$export$3a9d3f1c52f4dab9);
$parcel$export(module.exports, "addonGlyph", () => $845d6a4dfc3d7122$export$a4cdad58220c405a);
$parcel$export(module.exports, "attachmentGlyph", () => $845d6a4dfc3d7122$export$e6e85f1bc2e23bd4);
$parcel$export(module.exports, "bulletListGlyph", () => $845d6a4dfc3d7122$export$a6a7f7b7c0399a2a);
$parcel$export(module.exports, "commentGlyph", () => $845d6a4dfc3d7122$export$835d228e2a9d6a93);
$parcel$export(module.exports, "officeBuildingGlyph", () => $845d6a4dfc3d7122$export$fdad804cb16a6544);
$parcel$export(module.exports, "peopleGroupGlyph", () => $845d6a4dfc3d7122$export$a20644de4b67f161);
$parcel$export(module.exports, "radioGlyph", () => $845d6a4dfc3d7122$export$ce87e45dceec205d);
$parcel$export(module.exports, "shipGlyph", () => $845d6a4dfc3d7122$export$d95e2215202c8556);
$parcel$export(module.exports, "priorityGlyph", () => $845d6a4dfc3d7122$export$3062e49c5521698d);
$parcel$export(module.exports, "screenGlyph", () => $845d6a4dfc3d7122$export$17d48fc8b753df77);
$parcel$export(module.exports, "closeGlyph", () => $845d6a4dfc3d7122$export$cbbe21ca62a58ed6);
$parcel$export(module.exports, "appAccessGlyph", () => $845d6a4dfc3d7122$export$8fd991b9da3a43e5);
$parcel$export(module.exports, "jwmCategoryGlyph", () => $845d6a4dfc3d7122$export$f21213fb7b480582);
$parcel$export(module.exports, "customFieldGlyph", () => $845d6a4dfc3d7122$export$88453606d7da6ff7);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");
const $845d6a4dfc3d7122$export$b368272069fe93ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$747056db840f2e62 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 5.994C4 4.893 4.895 4 5.994 4h12.012C19.107 4 20 4.895 20 5.994v12.012A1.995 1.995 0 0 1 18.006 20H5.994A1.995 1.995 0 0 1 4 18.006V5.994zm5.707 5.299a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$fc939f15c0ac57d8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19h16zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862L12.2 6z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$54ae6633cc16eed1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.667 6.167V7A.834.834 0 0 1 7 7V5.333a.834.834 0 0 1 1.667 0v.834zm6.666 0v-.834a.834.834 0 0 1 1.667 0V7a.834.834 0 0 1-1.667 0v-.833zm2.5 0h.005c.918 0 1.662.745 1.662 1.661v10.01c0 .918-.743 1.662-1.662 1.662H6.161A1.663 1.663 0 0 1 4.5 17.838V7.828c0-.917.743-1.661 1.662-1.661h.005V7c0 .927.746 1.667 1.666 1.667C8.76 8.667 9.5 7.92 9.5 7v-.833h5V7c0 .927.746 1.667 1.667 1.667.927 0 1.666-.747 1.666-1.667v-.833zm-10 6.667H9.5v-1.667H7.833v1.667zm0 3.334H9.5V14.5H7.833v1.668zm3.334-3.334h1.666v-1.667h-1.666v1.667zm0 3.334h1.666V14.5h-1.666v1.668zm3.333-3.334h1.667v-1.667H14.5v1.667zm0 3.334h1.667V14.5H14.5v1.668z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$d298f123ec74117c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.708 11.723L12.779 14.678C12.566 14.893 12.288 15 12.009 15C11.73 15 11.449 14.893 11.231 14.678L8.291 11.713C7.903 11.321 7.903 10.686 8.291 10.294C8.679 9.902 9.309 9.902 9.698 10.294L12.005 12.621L14.303 10.304C14.69 9.912 15.32 9.912 15.708 10.304C16.097 10.696 16.097 11.331 15.708 11.723Z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$b3ea0fc10228ca3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.0543 7.95865C9.72121 7.63948 9.17412 7.63199 8.83238 7.94192C8.49064 8.25184 8.48365 8.76182 8.81678 9.08099L11.3658 11.5232C11.5389 11.689 11.7698 11.7707 11.9997 11.7675C12.2295 11.7707 12.4604 11.689 12.6335 11.5232L15.1825 9.08099C15.5156 8.76182 15.5087 8.25184 15.1669 7.94192C14.8252 7.63199 14.2781 7.63948 13.945 7.95865L11.9997 9.82242L10.0543 7.95865ZM8.83238 12.3333C9.17412 12.0234 9.72121 12.0309 10.0543 12.35L11.9997 14.2138L13.945 12.35C14.2781 12.0309 14.8252 12.0234 15.1669 12.3333C15.5087 12.6432 15.5156 13.1532 15.1825 13.4724L12.6335 15.9146C12.4604 16.0804 12.2295 16.1621 11.9997 16.1588C11.7698 16.1621 11.5389 16.0804 11.3658 15.9146L8.81678 13.4724C8.48365 13.1532 8.49064 12.6432 8.83238 12.3333Z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$fc64eea29ed0831d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.433 5.428l-4.207.6a2 2 0 0 0-1.697 1.698l-.601 4.207a1 1 0 0 0 .283.849l6.894 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283zm-.647 5.858a1.667 1.667 0 1 1-2.357-2.357 1.667 1.667 0 0 1 2.357 2.357z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$cbee9ded46569696 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 7h11a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$2ade78849d2113ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.12 20.249a8.398 8.398 0 0 1-.39-.003A8.25 8.25 0 0 1 3.75 12 8.25 8.25 0 0 1 12 3.75 8.25 8.25 0 0 1 20.25 12a8.25 8.25 0 0 1-8.13 8.25v-.001zm4.463-3.762A6.396 6.396 0 0 0 18.417 12 6.424 6.424 0 0 0 12 5.583 6.424 6.424 0 0 0 5.583 12c0 1.745.7 3.33 1.834 4.487v-1.27a2.291 2.291 0 0 1 2.292-2.292h4.582a2.292 2.292 0 0 1 2.292 2.291v1.27zM12 12a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$1c6cf19eb34bcc14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.72 7.178l-2.93 8.627a.5.5 0 0 0 .473.661h.842a.75.75 0 0 0 .716-.53l.581-1.887h3.425l.58 1.887a.75.75 0 0 0 .717.53h.916a.5.5 0 0 0 .473-.66L9.578 7.177a1 1 0 0 0-.946-.678h-.966a1 1 0 0 0-.947.678zm1.37 1.228h.047l1.25 4.082H6.841l1.25-4.082zm10.187 1.872v-.23a.986.986 0 1 1 1.972 0v5.433a.986.986 0 0 1-1.972 0v-.217h-.08c-.36.802-1.13 1.32-2.217 1.32-1.81 0-2.952-1.479-2.952-3.834 0-2.334 1.149-3.805 2.952-3.805 1.075 0 1.858.546 2.216 1.333h.08zm-.04 2.486c0-1.347-.63-2.203-1.61-2.203-.978 0-1.58.843-1.58 2.203 0 1.368.602 2.196 1.58 2.196.988 0 1.61-.836 1.61-2.196z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$98a4a461fe316fce = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.787-7.674V8.944c0-.52-.402-.944-.893-.944-.492 0-.894.425-.894.944v3.777c0 .263.104.5.269.672l2.207 2.332a.862.862 0 0 0 1.263 0 .985.985 0 0 0 0-1.336l-1.952-2.063z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$637d50811e2b7176 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M17.476 9.067A6.552 6.552 0 0 1 19 13.263C19 16.983 15.866 20 12 20s-7-3.016-7-6.737c0-1.587.57-3.045 1.524-4.196l-.383-.402a.82.82 0 0 1 .054-1.19.9.9 0 0 1 1.237.052l.345.363a7.116 7.116 0 0 1 3.348-1.312v-.894h-.438a.43.43 0 0 1-.437-.42V4.42a.43.43 0 0 1 .438-.42h2.624a.43.43 0 0 1 .438.421v.842a.43.43 0 0 1-.438.421h-.437v.894a7.116 7.116 0 0 1 3.348 1.312l.345-.363a.9.9 0 0 1 1.237-.052.82.82 0 0 1 .054 1.19l-.383.402zM12 18.316c2.9 0 5.25-2.262 5.25-5.053 0-2.79-2.35-5.052-5.25-5.052s-5.25 2.262-5.25 5.052c0 2.79 2.35 5.053 5.25 5.053zm.645-4.562a.9.9 0 0 1-1.237-.02.82.82 0 0 1 .02-1.19l2.588-2.412a.9.9 0 0 1 1.238.02.82.82 0 0 1-.02 1.19l-2.589 2.412z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$bc2bb299bed9df91 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$3a9d3f1c52f4dab9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.268 4.934a.919.919 0 0 0 0 1.296l4.852 4.853H4.668A.92.92 0 0 0 3.75 12a.92.92 0 0 0 .917.917H17.12l-4.856 4.855a.917.917 0 0 0 1.296 1.296l6.416-6.415c.002 0 .003-.003.006-.004a.914.914 0 0 0 .267-.65.915.915 0 0 0-.274-.653l-6.412-6.412a.915.915 0 0 0-.648-.267.915.915 0 0 0-.648.267z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$a4cdad58220c405a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.928 6.917l4.81-2.846c.727-.429 1.8-.427 2.523 0l4.811 2.846c.726.43 1.261 1.382 1.261 2.238v5.69c0 .859-.537 1.81-1.26 2.238L13.26 19.93c-.726.429-1.799.427-2.522 0l-4.811-2.846c-.726-.43-1.261-1.382-1.261-2.238v-5.69c0-.859.537-1.81 1.26-2.238zm6.408-1.204c-.152-.09-.52-.09-.672 0L6.853 8.558c-.152.09-.336.416-.336.597v5.69c0 .18.183.507.336.597l4.81 2.845c.153.09.52.09.673 0l4.811-2.845c.152-.09.336-.416.336-.597v-5.69c0-.18-.183-.507-.336-.597l-4.81-2.845zM12 15.667a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334zm0-1.834a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$e6e85f1bc2e23bd4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.672 17.468c-1.402 1.37-3.68 1.37-5.08.004a3.458 3.458 0 0 1 .002-4.962l6.552-6.402a2.123 2.123 0 0 1 2.964-.003c.818.8.82 2.092.003 2.89L10.968 15a.599.599 0 0 1-.838-.008.568.568 0 0 1 0-.827l5.71-5.58a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.268 0l-5.71 5.58a2.294 2.294 0 0 0 0 3.307 2.423 2.423 0 0 0 3.375.008l6.145-6.005a3.735 3.735 0 0 0-.003-5.37 3.947 3.947 0 0 0-5.502.003L6.325 11.27a5.184 5.184 0 0 0-.001 7.442c2.1 2.052 5.514 2.051 7.617-.004l6.13-5.99a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.27 0l-6.129 5.99z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$a6a7f7b7c0399a2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.5 7.59a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.008v.152A1 1 0 0 1 6.659 8.75h-.152A1 1 0 0 1 5.5 7.743V7.59zm4.333 8.667a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.008h-6.678a.993.993 0 0 1-.995-1.008v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.008h-.152A1 1 0 0 1 5.5 16.409v-.152zm4.333-4.333a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.007h-.152A1 1 0 0 1 5.5 12.076v-.152zM9.833 7.59a.999.999 0 0 1 .995-1.008h6.678c.549 0 .994.439.994 1.008v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007V7.59z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$835d228e2a9d6a93 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 0 0 .164.033.515.515 0 0 0 .474-.716zM7 10c0-.552.456-1 .995-1h8.01c.55 0 .995.444.995 1 0 .552-.456 1-.995 1h-8.01A.995.995 0 0 1 7 10zm0 3c0-.552.444-1 1-1h3c.552 0 1 .444 1 1 0 .552-.444 1-1 1H8c-.552 0-1-.444-1-1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$fdad804cb16a6544 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.444 14.667V20H5.785C4.8 20 4 19.146 4 18.09V8.577c0-1.055.802-1.91 1.785-1.91h2.66v3.556H6.666V12h1.777v.889H6.667v1.778h1.777zm.89-8.894A1.78 1.78 0 0 1 11.119 4h7.096A1.78 1.78 0 0 1 20 5.773v12.454c0 .979-.802 1.773-1.785 1.773H9.333V5.773zM12 7.556v1.777h1.778V7.556H12zm0 2.666V12h1.778v-1.778H12zm0 2.667v1.778h1.778v-1.778H12zm1.778 2.667v2.666h1.778v-2.666h-1.778zm1.778-8v1.777h1.777V7.556h-1.777zm0 2.666V12h1.777v-1.778h-1.777zm0 2.667v1.778h1.777v-1.778h-1.777z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$a20644de4b67f161 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 12a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-3.228-1.667A3.333 3.333 0 0 0 9.795 12H9.5A2.501 2.501 0 0 0 7 14.497v2.469c-1.771-.147-3.333-.766-3.333-1.858V12c0-.92.74-1.667 1.666-1.667h3.439zm6.456 0h3.439c.92 0 1.666.738 1.666 1.667v3.108c0 1.092-1.562 1.711-3.333 1.858v-2.47A2.5 2.5 0 0 0 14.5 12h-.295a3.333 3.333 0 0 0 1.023-1.667zM10.306 6.63A3.332 3.332 0 0 0 8.67 9.357a2.5 2.5 0 1 1 1.636-2.728zm5.024 2.728a3.328 3.328 0 0 0-1.636-2.73 2.5 2.5 0 1 1 1.636 2.73zm-7.497 5.456c0-1.093.892-1.98 1.996-1.98h4.342a2 2 0 0 1 1.996 1.994v2.781c0 2.523-8.334 2.523-8.334 0v-2.795z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$ce87e45dceec205d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$d95e2215202c8556 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.5 12h7.333v-1.833H6.5V12zM4.667 9.242c0-.502.417-.909.919-.909h9.162c.507 0 .919.414.919.909v4.591h-11V9.242zm.458 7.341h12.828l.919-2.75H4.795l.33 2.75zm-2.287-3.677A.79.79 0 0 1 3.643 12h16.86c.504 0 .786.382.625.865l-1.565 4.686c-.16.478-.695.866-1.205.866H4.415c-.506 0-.964-.402-1.025-.906l-.552-4.605zM6.5 7.42c0-1.015.823-1.838 1.831-1.838h1.838c1.011 0 1.831.82 1.831 1.838v2.746H6.5V7.42zm3.667 0v-.004H8.331c.005 0 .002.002.002.004v.912h1.834V7.42z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$3062e49c5521698d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7.959 15.833V8.474l-2.868 2.868a.541.541 0 1 1-.766-.766l3.79-3.789.001-.004a.544.544 0 0 1 .77.003l3.791 3.792a.543.543 0 0 1 0 .766.543.543 0 0 1-.765 0l-2.87-2.87v7.36a.543.543 0 0 1-.541.541.543.543 0 0 1-.542-.542zm7-6.666v7.359l-2.868-2.868a.541.541 0 1 0-.766.766l3.79 3.789.001.004a.544.544 0 0 0 .77-.003l3.791-3.792a.543.543 0 0 0 0-.766.543.543 0 0 0-.765 0l-2.87 2.87v-7.36a.543.543 0 0 0-.541-.541.543.543 0 0 0-.542.542z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".5",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$17d48fc8b753df77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 6.772C4 5.793 4.793 5 5.773 5h12.454C19.206 5 20 5.796 20 6.772v7.044c0 .979-.793 1.772-1.773 1.772H5.773A1.774 1.774 0 0 1 4 13.816V6.772zm1.778 7.052h12.444v-7.06H5.778v7.06zm8 5.294h.452c.241 0 .437.204.437.44V20H9.333v-.441c0-.244.203-.441.437-.441h.452V16.47h3.556v2.647z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$cbbe21ca62a58ed6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16.244 6.244a.833.833 0 1 1 1.179 1.179l-4.412 4.41 4.412 4.411a.834.834 0 0 1 .074 1.093l-.074.086a.833.833 0 0 1-1.179 0l-4.411-4.412-4.41 4.412a.834.834 0 0 1-1.094.074l-.085-.074a.833.833 0 0 1 0-1.179l4.411-4.411-4.41-4.41a.834.834 0 0 1-.076-1.094l.075-.085a.833.833 0 0 1 1.179 0l4.41 4.411z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$8fd991b9da3a43e5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.682 12H5.01A2.006 2.006 0 0 0 3 14v4.446c0 2.162 4.836 2.951 8.368 2.368A5.975 5.975 0 0 1 10 17a5.994 5.994 0 0 1 2.682-5z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        fill: "currentColor",
        cx: "9",
        cy: "7",
        r: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        fill: "currentColor",
        cx: "16",
        cy: "17",
        r: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14.674 19.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3l1.406 1.405z",
        fill: "inherit"
    })));
const $845d6a4dfc3d7122$export$f21213fb7b480582 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$88453606d7da6ff7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        role: "presentation",
        focusable: "false",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H11C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6H3ZM4 16V12H20V16H4ZM2 12C2 10.8954 2.89543 10 4 10H20C21.1046 10 22 10.8954 22 12V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V12Z",
        fill: "currentColor"
    })));

});


parcelRegister("gX8pG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b4e37e5cc168504$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $2b4e37e5cc168504$var$messages = (0, $7qGN1.defineMessages)({
    deprecatedEpicMessage: {
        "id": "jql-builder-basic.services.use-fields.deprecated-epic-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    notInContextFieldMessage: {
        "id": "jql-builder-basic.services.use-fields.not-in-context-field-message",
        "defaultMessage": "This field is unavailable for the selected project and/or issue type."
    },
    notInContextFieldMessageIssueTermRefresh: {
        "id": "jql-builder-basic.services.use-fields.not-in-context-field-message-issue-term-refresh",
        "defaultMessage": "This field is unavailable for the selected project and/or work type."
    },
    notInContextFieldMessageIssueTermRefreshGalaxia: {
        "id": "jql-builder-basic.services.use-fields.not-in-context-field-message-issue-term-refresh-galaxia",
        "defaultMessage": "This field is unavailable for the selected space and/or work type."
    }
});
var $2b4e37e5cc168504$export$2e2bcd8739ae039 = $2b4e37e5cc168504$var$messages;

});


parcelRegister("3SxQz", function(module, exports) {

$parcel$export(module.exports, "removeFieldsFromJql", () => $25996a2cd844b33d$export$cc86b3e973172951);

var $1jiqw = parcelRequire("1jiqw");
var $41qTw = parcelRequire("41qTw");

var $jwox6 = parcelRequire("jwox6");
const $25996a2cd844b33d$export$cc86b3e973172951 = (ast, clausesToRemove, textSearchInputClause)=>{
    (0, $41qTw.walkAST)({
        enterTerminalClause (terminalClause) {
            const isTextSearchInput = textSearchInputClause && new (0, $jwox6.IsInCompoundClauseVisitor)(terminalClause).visit(textSearchInputClause);
            if (clausesToRemove.has(terminalClause.field.value.toLowerCase()) && !isTextSearchInput) terminalClause.remove();
        }
    }, ast);
    return (0, $1jiqw.print)(ast, {
        operatorCase: 'upper'
    });
};

});

parcelRegister("ce3v0", function(module, exports) {

$parcel$export(module.exports, "useSendAnalytics", () => $d1703ea48a3fd165$export$a8fd9767f372c6ec);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $d1703ea48a3fd165$export$a8fd9767f372c6ec = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const sendAnalytics = (0, $eJOHy.useCallback)(({ actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: 'UI',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
    }, [
        createAnalyticsEvent
    ]);
    return sendAnalytics;
};

});

parcelRegister("4kCrw", function(module, exports) {

$parcel$export(module.exports, "default", () => $edc966f003f68a2f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $edc966f003f68a2f$var$messages = (0, $7qGN1.defineMessages)({
    loadingMessageStart: {
        "id": "jql-builder-basic.jql-editor.add-filter.loading-message-start",
        "defaultMessage": "Loading more filters"
    },
    loadingMessageEnd: {
        "id": "jql-builder-basic.jql-editor.add-filter.loading-message-end",
        "defaultMessage": "Finished loading filters"
    }
});
var $edc966f003f68a2f$export$2e2bcd8739ae039 = $edc966f003f68a2f$var$messages;

});

parcelRegister("Nqkfo", function(module, exports) {

let $0948ff6d66a80a13$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0948ff6d66a80a13$var$load("1AE9k").then(()=>parcelRequire('1CR3k'));

});


parcelRegister("bYJeL", function(module, exports) {

$parcel$export(module.exports, "default", () => $33afa19ea889a8e3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $eqSys = parcelRequire("eqSys");

var $bNtSK = parcelRequire("bNtSK");

var $1gVNb = parcelRequire("1gVNb");

var $9dqYm = parcelRequire("9dqYm");

var $h9gPh = parcelRequire("h9gPh");

var $lYhmm = parcelRequire("lYhmm");

var $aAvty = parcelRequire("aAvty");

var $8b3Zt = parcelRequire("8b3Zt");

var $5maGz = parcelRequire("5maGz");

var $6CLhR = parcelRequire("6CLhR");

var $8M9FQ = parcelRequire("8M9FQ");

var $01FiY = parcelRequire("01FiY");
const $33afa19ea889a8e3$var$analyticsAttributes = {
    pickerType: 'field'
};
const $33afa19ea889a8e3$var$FieldWrapperNew = ({ children: children, useListElement: useListElement, handleKeyDown: handleKeyDown })=>{
    const StyledListItemChildComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $bNtSK.default) : (0, $1gVNb.StyledListItemChild);
    return useListElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StyledListItemChildComponent, {
        "data-vc": "jql-builder-basic-field-list-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "presentation",
        onKeyDown: handleKeyDown
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gVNb.StyledChild), {
        onKeyDown: handleKeyDown
    }, children);
};
const $33afa19ea889a8e3$export$a455218a85c89869 = ({ fieldToRender: fieldToRender, onSearchWrapper: onSearchWrapper, onSwitchToJql: onSwitchToJql, fieldsToRender: fieldsToRender, loading: loading, hydratedData: hydratedData, selectedFields: selectedFields, onClearPicker: onClearPicker, projectOptions: projectOptions, singleSelectFields: singleSelectFields = [], shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown, contextJql: contextJql, viewContext: viewContext, scope: scope, suggestedUsersCount: suggestedUsersCount })=>{
    const { clause: clause, secondaryClause: secondaryClause, fieldId: fieldId, fieldLabel: fieldLabel, picker: picker, fieldDescription: fieldDescription, isIrremovable: isIrremovable } = fieldToRender;
    const sendOptionAnalytics = (0, $h9gPh.useSendOptionAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { pickerType: pickerType, propType: propType, fieldType: fieldType } = picker;
    const [activePopupKey, { openPopup: openPopup, closePopup: closePopup, closeAllPopups: closeAllPopups }] = (0, $9dqYm.useActivePopupKey)();
    const onOpen = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdown'
        });
        const attributes = {
            actionType: 'open'
        };
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'refinementBarBasicPicker', attributes);
        return openPopup(fieldId);
    }, [
        createAnalyticsEvent,
        fieldId,
        openPopup
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdown'
        });
        const attributes = {
            actionType: 'close'
        };
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'refinementBarBasicPicker', attributes);
        return closePopup(fieldId);
    }, [
        closePopup,
        fieldId,
        createAnalyticsEvent
    ]);
    const onClearCallback = (0, $eJOHy.useCallback)((onClearJqlClause)=>{
        const newSelectedFields = selectedFields.filter((selectedField)=>selectedField.value.toLowerCase() !== fieldId.toLowerCase());
        if (onClearJqlClause !== undefined) {
            onClearPicker({
                selectedFields: newSelectedFields
            });
            onSearchWrapper && onSearchWrapper(onClearJqlClause);
        } else onClearPicker({
            selectedFields: newSelectedFields,
            fieldsToRender: fieldsToRender.filter((field)=>fieldId.toLowerCase() !== field.fieldId)
        });
    }, [
        fieldId,
        fieldsToRender,
        onClearPicker,
        onSearchWrapper,
        selectedFields
    ]);
    const handleOnKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // avoid closing a modal on closing a picker with esc key
            const isOpen = activePopupKey === fieldId;
            isOpen && event.stopPropagation();
            onClose();
        }
    };
    const UnsupportedFieldPicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
        useListElement: Boolean(shouldUseListMarkup),
        handleKeyDown: handleOnKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $01FiY.UnsupportedPickerWrapper), {
        activePopupKey: activePopupKey,
        clause: clause,
        fieldDescription: fieldDescription,
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        onClose: onClose,
        onOpen: onOpen,
        onClear: onClearCallback,
        onSwitchToJql: onSwitchToJql
    }));
    switch(pickerType){
        case (0, $eqSys.PickerTypes).Picker:
            if (clause && clause.clauseType !== (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a)) throw new Error(`Picker type ${pickerType} cannot be used with a non terminal clause`);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
                sourceName: "valueSearch",
                sourceType: (0, $466f60259c330878$export$cae2783c9279926),
                attributes: $33afa19ea889a8e3$var$analyticsAttributes
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6CLhR.PickerWrapper), {
                onSearchWrapper: onSearchWrapper,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                picker: picker,
                terminalClause: clause || undefined,
                activePopupKey: activePopupKey,
                onOpen: onOpen,
                onClose: onClose,
                onSendOptionAnalytics: sendOptionAnalytics,
                loading: loading,
                hydratedData: hydratedData,
                onClear: onClearCallback,
                projectOptions: projectOptions,
                isMulti: !singleSelectFields.includes(fieldId),
                fieldDescription: fieldDescription,
                onOpenOperatorPicker: closeAllPopups,
                hideOperatorDropdown: hideOperatorDropdown,
                isIrremovable: isIrremovable,
                contextJql: contextJql,
                viewContext: viewContext,
                scope: scope,
                suggestedUsersCount: suggestedUsersCount
            })));
        case (0, $eqSys.PickerTypes).TextArea:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8M9FQ.TextAreaPicker), {
                clause: clause,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                fieldType: fieldType,
                activePopupKey: activePopupKey,
                onSearchWrapper: onSearchWrapper,
                onClear: onClearCallback,
                onOpen: onOpen,
                onClose: onClose,
                fieldDescription: fieldDescription,
                propType: propType,
                isIrremovable: isIrremovable
            }));
        case (0, $eqSys.PickerTypes).DateTime:
        case (0, $eqSys.PickerTypes).DueDate:
        case (0, $eqSys.PickerTypes).DateTimeRange:
            if (clause && clause.clauseType !== (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a) || secondaryClause && secondaryClause.clauseType !== (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a)) throw new Error(`Picker type ${pickerType} cannot be used with a non terminal clause`);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aAvty.DatePickerWrapper), {
                clause: clause,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                pickerType: pickerType,
                activePopupKey: activePopupKey,
                onSearchWrapper: onSearchWrapper,
                onClear: onClearCallback,
                onOpen: onOpen,
                onClose: onClose,
                secondaryClause: secondaryClause,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }));
        case (0, $eqSys.PickerTypes).CascadeSelect:
            if (clause && clause.clauseType !== (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a)) throw new Error(`Picker type ${pickerType} cannot be used with a non terminal clause`);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lYhmm.CascadeSelectPicker), {
                activePopupKey: activePopupKey,
                clause: clause,
                fieldDescription: fieldDescription,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                hydratedData: hydratedData,
                onClose: onClose,
                onOpen: onOpen,
                onSearchWrapper: onSearchWrapper,
                onSendOptionAnalytics: sendOptionAnalytics,
                onClear: onClearCallback,
                isIrremovable: isIrremovable,
                contextJql: contextJql
            }));
        case (0, $eqSys.PickerTypes).NumberRange:
            if (clause && clause.clauseType !== (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a) || secondaryClause && secondaryClause.clauseType !== (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a)) throw new Error(`Picker type ${pickerType} cannot be used with a non terminal clause`);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5maGz.NumberRangePicker), {
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                activePopupKey: activePopupKey,
                clause: clause,
                secondaryClause: secondaryClause,
                onSearchWrapper: onSearchWrapper,
                onClear: onClearCallback,
                onOpen: onOpen,
                onClose: onClose,
                fieldDescription: fieldDescription,
                onSendOptionAnalytics: sendOptionAnalytics,
                isIrremovable: isIrremovable
            }));
        case (0, $eqSys.PickerTypes).BooleanType:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8b3Zt.LastUserCommentedPickerWrapper), {
                activePopupKey: activePopupKey,
                clause: clause,
                fieldDescription: fieldDescription,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                onClose: onClose,
                onOpen: onOpen,
                onSearchWrapper: onSearchWrapper,
                onClear: onClearCallback,
                isIrremovable: isIrremovable
            }));
        default:
            return UnsupportedFieldPicker;
    }
};
var $33afa19ea889a8e3$export$2e2bcd8739ae039 = $33afa19ea889a8e3$export$a455218a85c89869;

});
parcelRegister("h9gPh", function(module, exports) {

$parcel$export(module.exports, "useSendOptionAnalytics", () => $079b59d2717b0607$export$dd648d2c308aa842);

var $eJOHy = parcelRequire("eJOHy");

var $jFHCE = parcelRequire("jFHCE");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $079b59d2717b0607$export$dd648d2c308aa842 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((attributes)=>{
        const actionSubjectId = 'refinementBarFilterSearch';
        const analyticsEvent = createAnalyticsEvent({
            eventType: 'UI',
            action: 'changed',
            actionSubject: 'filterSearch',
            actionSubjectId: actionSubjectId
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, actionSubjectId, (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(attributes, 'fieldId'));
    }, [
        createAnalyticsEvent
    ]);
};

});

parcelRegister("lYhmm", function(module, exports) {

$parcel$export(module.exports, "CascadeSelectPicker", () => $f01cfe735bc99dd9$export$d469cbf777198f76);

var $eJOHy = parcelRequire("eJOHy");


var $boEdP = parcelRequire("boEdP");

var $1xd19 = parcelRequire("1xd19");

var $lyPdT = parcelRequire("lyPdT");

var $7PQ0T = parcelRequire("7PQ0T");

var $5gMlm = parcelRequire("5gMlm");

var $7hNmk = parcelRequire("7hNmk");

var $7Wv9B = parcelRequire("7Wv9B");

var $37ded = parcelRequire("37ded");
const $f01cfe735bc99dd9$export$d469cbf777198f76 = ({ activePopupKey: activePopupKey, clause: clause, fieldId: fieldId, fieldLabel: fieldLabel, fieldDescription: fieldDescription, hydratedData: hydratedData, onClose: onClose, onOpen: onOpen, onClear: onClear, onSearchWrapper: onSearchWrapper, onSendOptionAnalytics: onSendOptionAnalytics, isIrremovable: isIrremovable, contextJql: contextJql })=>{
    if (clause !== undefined && clause.clauseType !== (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a)) throw new Error('cascadeSelectPicker attempted to hydrate using a query that should have been handled by query-too-complex');
    // match the hydrated value to the option from the clause & handle optimistic updates
    const selectedOptionsFromHydration = (0, $7Wv9B.useHydratedValues)({
        fieldId: fieldId,
        clause: clause,
        hydratedData: hydratedData
    });
    const [selectedOption, setSelectedOption] = (0, $37ded.useSelectedValues)(hydratedData, selectedOptionsFromHydration);
    const [ast] = (0, $lyPdT.useAST)();
    /**
	 * fieldLabel comes from field displayName from the hydration data.
	 * It is defined in the fragment `jqlEditor_jqlBuilderBasic_JQLEditorUI` in
	 * `src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx`
	 * we never expect it to be undefined but since we are not using the @required
	 * directive in the fragment, this check is required.
	 */ const safeFieldLabel = fieldLabel ?? '';
    const triggerTextContent = {
        fieldLabel: safeFieldLabel,
        parentOption: selectedOption?.parentOption?.label,
        childOption: selectedOption?.childOption?.label
    };
    const triggerHasValues = Boolean(triggerTextContent.parentOption || triggerTextContent.childOption);
    const triggerHasInvalidValues = Boolean(selectedOption?.parentOption?.isInvalid || selectedOption?.childOption?.isInvalid);
    const isOpen = activePopupKey === fieldId;
    const onTriggerClick = (0, $eJOHy.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]);
    const triggerRenderer = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
            ...triggerProps,
            fieldDescription: fieldDescription,
            isInvalid: triggerHasInvalidValues,
            isSelected: isOpen,
            isLoading: false,
            hasValues: triggerHasValues,
            onClear: ()=>onClear(clause ? (0, $boEdP.default)(ast, clause) : undefined),
            onClick: onTriggerClick,
            testId: "jql-builder-basic.ui.jql-editor.field.cascade-select-picker.picker-trigger",
            isIrremovable: isIrremovable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gMlm.TriggerLabelContainer), {
            fieldLabel: triggerTextContent.fieldLabel,
            parentValue: triggerTextContent.parentOption,
            childValue: triggerTextContent.childOption
        })), [
        fieldDescription,
        triggerHasInvalidValues,
        isOpen,
        triggerHasValues,
        onTriggerClick,
        isIrremovable,
        triggerTextContent.fieldLabel,
        triggerTextContent.parentOption,
        triggerTextContent.childOption,
        onClear,
        clause,
        ast
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7PQ0T.CascadeSelectPickerPopup), {
        fieldId: fieldId,
        initialValue: selectedOption,
        isOpen: isOpen,
        onClose: onClose,
        onChange: (newValue)=>{
            setSelectedOption(newValue);
            onSendOptionAnalytics && onSendOptionAnalytics({
                hasParentOption: Boolean(newValue.parentOption),
                hasChildOption: Boolean(newValue.childOption)
            });
            onSearchWrapper && onSearchWrapper((0, $7hNmk.getUpdatedJql)(ast, clause, fieldId, newValue));
            onClose();
        },
        renderTrigger: triggerRenderer,
        contextJql: contextJql
    });
};

});
parcelRegister("boEdP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4952339e703518b2$export$2e2bcd8739ae039);


var $etRm8 = parcelRequire("etRm8");

var $9o0jj = parcelRequire("9o0jj");
const $4952339e703518b2$var$removeFieldClauseFromJql = (ast, clauseToRemove)=>{
    const jqlString = ast.represents;
    let previousClause;
    let nextClause;
    const where = ast.query?.where;
    if (where && where.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b)) for(let index = 0; index < where.clauses.length; index += 1){
        const clause = where.clauses[index];
        const clausePosition = clause.position;
        const clauseToRemovePosition = clauseToRemove.position;
        // Early exit if position data is unavailable for our clause
        if (!clausePosition || !clauseToRemovePosition) return jqlString;
        if (clausePosition[0] === clauseToRemovePosition[0] && clausePosition[1] === clauseToRemovePosition[1]) {
            previousClause = where.clauses[index - 1];
            nextClause = where.clauses[index + 1];
        }
    }
    const clauseToRemovePosition = (0, $9o0jj.getClausePosition)(jqlString, clauseToRemove);
    // Early exit if position data is unavailable for our clause
    if (!clauseToRemovePosition) return jqlString;
    const [clauseToRemoveStart, clauseToRemoveEnd] = clauseToRemovePosition;
    if (previousClause) {
        // preserve AND inbetween
        if (nextClause) {
            const nextClausePosition = (0, $9o0jj.getClausePosition)(jqlString, nextClause);
            // Early exit if position data is unavailable for our clause
            if (!nextClausePosition) return jqlString;
            return (0, $etRm8.substring)(jqlString, 0, clauseToRemoveStart) + (0, $etRm8.substring)(jqlString, nextClausePosition[0]);
        }
        const previousClausePosition = (0, $9o0jj.getClausePosition)(jqlString, previousClause);
        // Early exit if position data is unavailable for our clause
        if (!previousClausePosition) return jqlString;
        return (0, $etRm8.substring)(jqlString, 0, previousClausePosition[1]) + (0, $etRm8.substring)(jqlString, clauseToRemoveEnd);
    }
    if (!previousClause) {
        if (nextClause) {
            const nextClausePosition = (0, $9o0jj.getClausePosition)(jqlString, nextClause);
            // Early exit if position data is unavailable for our clause
            if (!nextClausePosition) return jqlString;
            return (0, $etRm8.substring)(jqlString, 0, clauseToRemoveStart) + (0, $etRm8.substring)(jqlString, nextClausePosition[0]);
        }
        return (0, $etRm8.substring)(jqlString, 0, clauseToRemoveStart) + (0, $etRm8.substring)(jqlString, clauseToRemoveEnd);
    }
    return jqlString;
};
var $4952339e703518b2$export$2e2bcd8739ae039 = $4952339e703518b2$var$removeFieldClauseFromJql;

});
parcelRegister("etRm8", function(module, exports) {

$parcel$export(module.exports, "substring", () => $a6ff7d96722f4e2e$export$662d3818631fba36);
/**
 * Returns the substring at the specified location within a String object while supporting Emojis.
 *
 * This method is to be used instead of String.substring. String.substring does not handle emojis correctly as they can be multi-char length.
 *
 * @param start — The zero-based index number indicating the beginning of the substring.
 * @param end Zero-based index number indicating the end of the substring. The substring includes the characters up to, but not including, the character indicated by end. If end is omitted, the characters from start through the end of the original string are returned.
 */ const $a6ff7d96722f4e2e$export$662d3818631fba36 = (str, start, end)=>[
        ...str
    ].slice(start, end).join('');

});

parcelRegister("9o0jj", function(module, exports) {

$parcel$export(module.exports, "getClausePosition", () => $5dfc7784089511a1$export$9a8cf65f444b696f);
const $5dfc7784089511a1$var$whiteSpaceRegex = /\s/;
const $5dfc7784089511a1$export$9a8cf65f444b696f = (jql, clause)=>{
    if (!clause.position) return null;
    let [start, end] = [
        undefined,
        undefined
    ];
    // Spreading the jql will account for multi-char unicode characters
    const jqlSymbols = [
        ...jql
    ];
    // Start
    for(let i = clause.position[0] - 1; i >= 0; i -= 1){
        const symbol = jqlSymbols[i];
        if (symbol === '(') {
            start = i;
            break;
        }
        // The use of continue here to check for
        if (!$5dfc7784089511a1$var$whiteSpaceRegex.test(symbol)) break;
    }
    // short circuit here if no '(' is found
    if (start === undefined) return clause.position;
    // End
    for(let i = clause.position[1]; i <= jqlSymbols.length; i += 1){
        const symbol = jqlSymbols[i];
        if (symbol === ')') {
            end = i + 1;
            break;
        }
        if (!$5dfc7784089511a1$var$whiteSpaceRegex.test(symbol)) break;
    }
    return start !== undefined && end !== undefined ? [
        start,
        end
    ] : clause.position;
};

});


parcelRegister("7PQ0T", function(module, exports) {

$parcel$export(module.exports, "CascadeSelectPickerPopup", () => $a8c12e4e24cc1d6b$export$f74bfb091b432a99);

var $eJOHy = parcelRequire("eJOHy");

var $iTysS = parcelRequire("iTysS");

var $5LwVz = parcelRequire("5LwVz");

var $cNe2t = parcelRequire("cNe2t");
const $a8c12e4e24cc1d6b$export$f74bfb091b432a99 = ({ fieldId: fieldId, initialValue: initialValue, isOpen: isOpen, onClose: onClose, onChange: onChange, renderTrigger: renderTrigger, contextJql: contextJql })=>{
    const renderContent = (0, $eJOHy.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iTysS.CascadingSelectView), {
            jqlTerm: fieldId,
            jqlContext: contextJql,
            initialValue: initialValue,
            onChange: onChange,
            setInitialFocusRef: setInitialFocusRef
        }), [
        fieldId,
        contextJql,
        initialValue,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        content: renderContent,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        messageId: "jql-builder-basic.ui.jql-editor.field.cascade-select-picker.popup",
        messageType: "transactional",
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        trigger: renderTrigger
    });
};

});
parcelRegister("iTysS", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectView", () => $cc3cbdcd717128e1$export$468e769561d652ac);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $cDJ0f = parcelRequire("cDJ0f");

var $fKXve = parcelRequire("fKXve");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $gWITR = parcelRequire("gWITR");

var $lRq8t = parcelRequire("lRq8t");

var $h6ll6 = parcelRequire("h6ll6");

var $5oTNo = parcelRequire("5oTNo");

var $4HZBL = parcelRequire("4HZBL");
const $cc3cbdcd717128e1$var$PARENT_INPUT_ID = 'jql-builder-cascading-select-parent-options-select';
const $cc3cbdcd717128e1$var$CHILD_INPUT_ID = 'jql-builder-cascading-select-child-options-select';
const $cc3cbdcd717128e1$export$468e769561d652ac = ({ jqlTerm: jqlTerm, jqlContext: jqlContext, initialValue: initialValue, onChange: onChange, setInitialFocusRef: setInitialFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // Parent data
    const [selectedParentOption, setSelectedParentOption] = (0, $eJOHy.useState)(initialValue?.parentOption);
    const { loadOptions: loadParentOptions } = (0, $h6ll6.useCascadingSelectValuesLoader)({
        jqlTerm: jqlTerm,
        optionType: 'PARENT',
        jqlContext: jqlContext
    });
    // Child data
    const [selectedChildOption, setSelectedChildOption] = (0, $eJOHy.useState)(initialValue?.childOption);
    const { loadOptions: loadChildOptions } = (0, $h6ll6.useCascadingSelectValuesLoader)({
        jqlTerm: jqlTerm,
        optionType: 'CHILD',
        jqlContext: jqlContext,
        parentOptionId: selectedParentOption?.value.toString() ?? undefined
    });
    const onSelectRef = (0, $eJOHy.useCallback)((ref)=>{
        if (ref?.select?.inputRef && setInitialFocusRef) setInitialFocusRef(ref.select.inputRef);
    }, [
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $cc3cbdcd717128e1$var$dropdownGroupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $cc3cbdcd717128e1$var$parentDropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
        htmlFor: $cc3cbdcd717128e1$var$PARENT_INPUT_ID
    }, formatMessage((0, $5oTNo.default).parentSelectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWITR.default), {
        ref: onSelectRef,
        inputId: $cc3cbdcd717128e1$var$PARENT_INPUT_ID,
        testId: "jql-builder-basic-cascading-select.ui.select-parent",
        formatOptionLabel: (0, $4HZBL.formatOptionLabel),
        placeholder: formatMessage((0, $5oTNo.default).parentSelectPlaceholder),
        noOptionsMessage: ()=>formatMessage((0, $5oTNo.default).noOptions),
        value: selectedParentOption,
        loadOptions: loadParentOptions,
        onChange: (newValue)=>{
            if (!newValue || newValue !== selectedParentOption) setSelectedChildOption(undefined);
            setSelectedParentOption(newValue ?? undefined);
        },
        defaultOptions: true,
        isClearable: true,
        isInvalid: selectedParentOption?.isInvalid
    }), selectedParentOption?.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, selectedParentOption?.invalidMessage ?? formatMessage((0, $5oTNo.default).invalidOptionMessage, {
        selectField: formatMessage((0, $5oTNo.default).parentSelectLabel)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $cc3cbdcd717128e1$var$childDropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
        htmlFor: $cc3cbdcd717128e1$var$CHILD_INPUT_ID
    }, formatMessage((0, $5oTNo.default).childSelectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWITR.default), {
        key: selectedParentOption?.value,
        inputId: $cc3cbdcd717128e1$var$CHILD_INPUT_ID,
        testId: "jql-builder-basic-cascading-select.ui.select-child",
        formatOptionLabel: (0, $4HZBL.formatOptionLabel),
        placeholder: formatMessage((0, $5oTNo.default).childSelectPlaceholder),
        noOptionsMessage: ()=>formatMessage((0, $5oTNo.default).noOptions),
        value: selectedChildOption,
        loadOptions: selectedParentOption ? loadChildOptions : undefined,
        onChange: (newValue)=>setSelectedChildOption(newValue ?? undefined),
        isDisabled: !selectedParentOption,
        defaultOptions: true,
        isClearable: true,
        isInvalid: selectedChildOption?.isInvalid
    }), selectedChildOption?.isInvalid && !selectedParentOption?.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, selectedParentOption?.invalidMessage ?? formatMessage((0, $5oTNo.default).invalidOptionMessage, {
        selectField: formatMessage((0, $5oTNo.default).parentSelectLabel)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cc3cbdcd717128e1$var$StyledButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        onClick: (e)=>{
            e.preventDefault();
            onChange({
                parentOption: selectedParentOption,
                childOption: selectedChildOption
            });
        },
        type: "submit",
        isDisabled: false,
        testId: "jql-builder-basic-cascading-select.ui.update-button"
    }, formatMessage((0, $5oTNo.default).updateButtonText))));
};
const $cc3cbdcd717128e1$var$dropdownGroupContainerStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $cc3cbdcd717128e1$var$parentDropdownContainerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $cc3cbdcd717128e1$var$childDropdownContainerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc3cbdcd717128e1$var$StyledButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dozgxb _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h6ll6", function(module, exports) {

$parcel$export(module.exports, "useCascadingSelectValuesLoader", () => $297dd5293a8e5958$export$34980bb479d0f067);

var $lMsOr = parcelRequire("lMsOr");

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $kEUB1 = parcelRequire("kEUB1");


var $2oJGZ = parcelRequire("2oJGZ");
const $297dd5293a8e5958$export$c52a35aaea869872 = async (environment, variables)=>{
    const result = await (0, $j4oe4.fetchQuery)(environment, (0, $lMsOr.default), variables, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!result) throw new Error('Unexpected empty result received from useCascadingSelectValuesLoaderQuery');
    const { pageInfo: pageInfo, edges: edges } = result.jira.jqlBuilder.cascadingSelectValues;
    const options = edges.map((edge)=>edge ? {
            label: edge.node.displayName,
            value: edge.node.optionId
        } : undefined).filter(Boolean);
    return pageInfo.hasNextPage && pageInfo.endCursor ? options.concat(await $297dd5293a8e5958$export$c52a35aaea869872(environment, {
        ...variables,
        after: pageInfo.endCursor
    })) : options;
};
const $297dd5293a8e5958$export$34980bb479d0f067 = ({ jqlTerm: jqlTerm, jqlContext: jqlContext, optionType: optionType, parentOptionId: parentOptionId })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $eJOHy.useMemo)(()=>({
            loadOptions: (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(// Must return void/undefined. AK select ignores the callback if a promise/async is returned.
            (searchString, cb)=>{
                $297dd5293a8e5958$export$c52a35aaea869872(environment, {
                    searchString: searchString,
                    cloudId: cloudId,
                    jqlTerm: jqlTerm,
                    jqlContext: jqlContext,
                    optionType: optionType,
                    parentOptionId: parentOptionId
                }).catch((error)=>{
                    (0, $gYnSx.default)({
                        error: error,
                        sendToPrivacyUnsafeSplunk: true,
                        meta: {
                            id: 'useCascadingSelectValuesLoaderError',
                            packageName: (0, $7275f557eeceb717$export$355546c9851d0c23),
                            teamName: 'empanada'
                        }
                    });
                    return [
                        {
                            label: formatMessage((0, $2oJGZ.default).fetchError),
                            value: '',
                            isDisabled: true
                        }
                    ];
                }).then(cb);
            }, 500)
        }), [
        cloudId,
        environment,
        formatMessage,
        jqlContext,
        jqlTerm,
        optionType,
        parentOptionId
    ]);
};

});
parcelRegister("lMsOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f774d595c016734e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f5a55b2db0d39bf05e1c7d776024275e>>
 * @relayHash c58b78e997cd2d1bf926e8e2e8d669a4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2e5ce2c8910f5a8665b5d15e181d1b534162ee1416e674e05e682caad7c9f62d
const $f774d595c016734e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlContext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "optionType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "parentOptionId"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "optionType",
                    "variableName": "optionType"
                },
                {
                    "kind": "Variable",
                    "name": "parentOptionId",
                    "variableName": "parentOptionId"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jqlContext"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        }
    ], v9 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v11 = {
        "kind": "ScalarField",
        "name": "optionId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCascadingSelectValuesLoaderQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v8 /*: any*/ ,
                                                "concreteType": "JiraJqlCascadingOptionFieldValueConnection",
                                                "kind": "LinkedField",
                                                "name": "cascadingSelectValues",
                                                "plural": false,
                                                "selections": [
                                                    v9 /*: any*/ ,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraJqlCascadingOptionFieldValueEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v10 /*: any*/ ,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v11 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jqlBuilder.cascadingSelectValues.edges.node.optionId"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.jqlBuilder.cascadingSelectValues.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.jqlBuilder.cascadingSelectValues.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jqlBuilder.cascadingSelectValues"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jqlBuilder"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCascadingSelectValuesLoaderQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlCascadingOptionFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "cascadingSelectValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlCascadingOptionFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2e5ce2c8910f5a8665b5d15e181d1b534162ee1416e674e05e682caad7c9f62d",
            "metadata": {},
            "name": "useCascadingSelectValuesLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f774d595c016734e$var$node.hash = "deb7ed0e1bb076edffe453408ba24625";
var $f774d595c016734e$export$2e2bcd8739ae039 = $f774d595c016734e$var$node;

});

const $7275f557eeceb717$export$355546c9851d0c23 = 'jira-jql-builder-basic-cascading-select';

parcelRegister("2oJGZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $54d3f2f988883e9c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $54d3f2f988883e9c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    fetchError: {
        "id": "jql-builder-basic-cascading-select.services.use-cascading-select-values-loader.fetch-error",
        "defaultMessage": "Something went wrong, please refresh and try again."
    }
});

});


parcelRegister("5oTNo", function(module, exports) {

$parcel$export(module.exports, "default", () => $536eecd9c3cdb700$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $536eecd9c3cdb700$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    updateButtonText: {
        "id": "jql-builder-basic-cascading-select.update-button-text",
        "defaultMessage": "Update"
    },
    parentSelectLabel: {
        "id": "jql-builder-basic-cascading-select.parent-select-label",
        "defaultMessage": "Parent option"
    },
    parentSelectPlaceholder: {
        "id": "jql-builder-basic-cascading-select.parent-select-placeholder",
        "defaultMessage": "Select parent option"
    },
    childSelectLabel: {
        "id": "jql-builder-basic-cascading-select.child-select-label",
        "defaultMessage": "Child option"
    },
    childSelectPlaceholder: {
        "id": "jql-builder-basic-cascading-select.child-select-placeholder",
        "defaultMessage": "Select child option"
    },
    noOptions: {
        "id": "jql-builder-basic-cascading-select.no-options",
        "defaultMessage": "No options available"
    },
    invalidOptionMessage: {
        "id": "jql-builder-basic-cascading-select.invalid-option-message",
        "defaultMessage": "\"{selectField}\" selection is not valid for the current project."
    }
});

});

parcelRegister("4HZBL", function(module, exports) {

$parcel$export(module.exports, "formatOptionLabel", () => $997890c413cb529c$export$322216d90ffb8d0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $80DPg = parcelRequire("80DPg");

var $9D9o8 = parcelRequire("9D9o8");
const $997890c413cb529c$export$322216d90ffb8d0e = ({ label: label, isInvalid: isInvalid, invalidMessage: invalidMessage })=>{
    if (isInvalid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($997890c413cb529c$var$InvalidOption, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($997890c413cb529c$var$InvalidOptionText, null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($997890c413cb529c$var$InvalidOptionIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: invalidMessage ?? '',
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9D9o8)))
    })));
    return label;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $997890c413cb529c$var$InvalidOption = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1tmw _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $997890c413cb529c$var$InvalidOptionText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1o9zkb7n _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $997890c413cb529c$var$InvalidOptionIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});

});



parcelRegister("5gMlm", function(module, exports) {

$parcel$export(module.exports, "TriggerLabelContainer", () => $98d99684c4964f5b$export$2c19d76757def6a5);

var $eJOHy = parcelRequire("eJOHy");

var $kkE8T = parcelRequire("kkE8T");
const $98d99684c4964f5b$export$2c19d76757def6a5 = ({ fieldLabel: fieldLabel, parentValue: parentValue, childValue: childValue })=>{
    const parentDisplay = parentValue ? `${parentValue}` : '';
    const childDisplay = parentValue && childValue ? ` - ${childValue}` : '';
    const displayValue = `${parentDisplay}${childDisplay}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkE8T.LabelContainer), {
        "data-testid": "jql-builder-basic.ui.jql-editor.field.cascade-select-picker.trigger-label-container.label-container"
    }, !parentValue && !childValue ? fieldLabel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkE8T.StyledLabel), null, fieldLabel, ": "), displayValue));
};

});

parcelRegister("7hNmk", function(module, exports) {

$parcel$export(module.exports, "getUpdatedJql", () => $35247e2bed88ed9f$export$1625bb7ada97d007);

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");
const $35247e2bed88ed9f$var$createTerminalClause = (fieldId, value)=>{
    const args = [];
    if (value.parentOption) // parent value first
    args.push(value.parentOption.value);
    if (value.childOption) // followed by child value
    args.push(value.childOption.value);
    return (0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $eiIzV.escapeBackslashes)(fieldId)), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_IN)), (0, $f26C8.default).functionOperand((0, $f26C8.default).functionString((0, $dTJxm.CASCADE_OPTION_FUNCTION_NAME)), args.map((argString)=>(0, $f26C8.default).argument(argString.toString()))));
};
const $35247e2bed88ed9f$export$1625bb7ada97d007 = (ast, clause, fieldId, value)=>{
    const hasValue = Boolean(value.parentOption || value.childOption);
    if (!clause) {
        if (!ast.query || !hasValue) return ast.represents;
        ast.query.appendClause($35247e2bed88ed9f$var$createTerminalClause(fieldId, value), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
    } else if (!hasValue) clause.remove();
    else clause.replace($35247e2bed88ed9f$var$createTerminalClause(fieldId, value));
    return (0, $1jiqw.print)(ast, {
        operatorCase: 'upper'
    });
};

});

parcelRegister("7Wv9B", function(module, exports) {

$parcel$export(module.exports, "useHydratedValues", () => $6e530d75c47b26bd$export$dc23a21ad032e5fa);

var $3RIir = parcelRequire("3RIir");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $dFEPL = parcelRequire("dFEPL");
const $6e530d75c47b26bd$export$dc23a21ad032e5fa = ({ fieldId: fieldId, clause: clause, hydratedData: hydratedData })=>{
    /* eslint-disable @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields */ const data = (0, $j4oe4.useFragment)((0, $3RIir.default), hydratedData);
    /* eslint-enable @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields */ return (0, $eJOHy.useMemo)(()=>{
        const hydratedValues = (data.jira?.jqlBuilder?.hydrateJqlQuery ?? data.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.find((field)=>field.jqlTerm?.toLowerCase() === fieldId)?.values;
        const unambiguousCascadeFieldValue = (0, $dFEPL.findUnambiguousCascadeFieldValue)({
            clause: clause,
            hydratedValues: hydratedValues
        });
        return unambiguousCascadeFieldValue;
    }, [
        clause,
        data.jira?.jqlBuilder?.hydrateJqlQuery,
        data.jira?.jqlBuilder?.hydrateJqlQueryForFilter,
        fieldId
    ]);
};

});
parcelRegister("3RIir", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e1c39e5e3c9f50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<03ac623fc1b9a207f6465549a3bccf93>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a5e1c39e5e3c9f50$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v1 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v2 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v6 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v2 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "name": "useHydratedValues_cascadeSelectPicker",
        "selections": [
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v6 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v6 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$a5e1c39e5e3c9f50$var$node.hash = "92d338efa13872bf45e89b5f9f1155af";
var $a5e1c39e5e3c9f50$export$2e2bcd8739ae039 = $a5e1c39e5e3c9f50$var$node;

});


parcelRegister("37ded", function(module, exports) {

$parcel$export(module.exports, "useSelectedValues", () => $f977cf65639d4968$export$e10928cdf9450649);

var $eJOHy = parcelRequire("eJOHy");
const $f977cf65639d4968$export$e10928cdf9450649 = (hydratedData, selectedOptionsFromHydration)=>{
    const prevHydrationData = (0, $eJOHy.useRef)(hydratedData);
    const [hydrated, setHydrated] = (0, $eJOHy.useState)(true);
    // Allow optimistic updates when a value is selected while hydration is taking place
    const [optimisticValues, setOptimisticValues] = (0, $eJOHy.useState)();
    // Only flag values as hydrated after a data change
    (0, $eJOHy.useEffect)(()=>{
        if (!hydrated && hydratedData !== prevHydrationData.current) setHydrated(true);
        prevHydrationData.current = hydratedData;
    }, [
        hydrated,
        hydratedData
    ]);
    const setSelectedValues = (0, $eJOHy.useCallback)((values)=>{
        setHydrated(false);
        setOptimisticValues(values);
    }, []);
    const selectedValues = !hydrated && optimisticValues ? optimisticValues : selectedOptionsFromHydration;
    return [
        selectedValues,
        setSelectedValues
    ];
};

});


parcelRegister("aAvty", function(module, exports) {

$parcel$export(module.exports, "DatePickerWrapper", () => $0363ad5eba43a3d3$export$a915f81916d25a71);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $e2kjR = parcelRequire("e2kjR");

var $4xwUT = parcelRequire("4xwUT");

var $5LwVz = parcelRequire("5LwVz");

var $buJG5 = parcelRequire("buJG5");

var $q3XlS = parcelRequire("q3XlS");

var $cNe2t = parcelRequire("cNe2t");

var $1xd19 = parcelRequire("1xd19");

var $lyPdT = parcelRequire("lyPdT");

var $h9gPh = parcelRequire("h9gPh");
const $0363ad5eba43a3d3$export$a915f81916d25a71 = ({ activePopupKey: activePopupKey, clause: clause, secondaryClause: secondaryClause, fieldId: fieldId, fieldLabel: fieldLabel, pickerType: pickerType, onOpen: onOpen, onClose: onClose, onClear: onClear, onSearchWrapper: onSearchWrapper, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const intl = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    const sendOptionAnalytics = (0, $h9gPh.useSendOptionAnalytics)();
    const variation = (0, $e2kjR.DateTimeVariations)[pickerType] || 'DateTime';
    const dateRefinementValueFromJql = (0, $4xwUT.getValueFromClauses)(variation, clause, secondaryClause);
    const tooltip = (0, $4xwUT.getTooltip)({
        intl: intl,
        label: fieldLabel || '',
        variation: variation,
        value: dateRefinementValueFromJql
    });
    const isOpen = activePopupKey === fieldId;
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        isOpen ? onClose() : onOpen();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        onClear && onClear(clause ? (0, $q3XlS.default)(fieldId, ast, undefined) : undefined);
    }, [
        onClear,
        clause,
        fieldId,
        ast
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $5LwVz.DefaultPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.date-picker-wrapper.popup",
        messageType: "transactional",
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
                condition: tooltip !== undefined,
                content: tooltip ?? null,
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
                isInvalid: false,
                isSelected: isOpen,
                hasValues: Boolean(clause || secondaryClause),
                onClick: handleOnClick,
                onClear: !isIrremovable ? handleOnClear : undefined,
                ref: ref,
                testId: `refinement-bar.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, (0, $4xwUT.formatLabel)({
                intl: intl,
                label: fieldLabel || '',
                variation: variation,
                value: dateRefinementValueFromJql
            }))),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xwUT.default), {
                fieldLabel: fieldLabel,
                variation: variation,
                value: dateRefinementValueFromJql,
                onSendOptionAnalytics: sendOptionAnalytics,
                onClosePopup: onClose,
                onChange: (value)=>onSearchWrapper && onSearchWrapper((0, $q3XlS.default)(fieldId, ast, (0, $4xwUT.getJqlInfo)(value, variation)))
            })
    });
};

});
parcelRegister("e2kjR", function(module, exports) {

$parcel$export(module.exports, "TimeUnits", () => $452c14429b146642$export$5d7753c8ad881494);
$parcel$export(module.exports, "NowOverdue", () => $452c14429b146642$export$28c868305da91826);
$parcel$export(module.exports, "BetweenComponent", () => $452c14429b146642$export$709f90f7ba10389);
$parcel$export(module.exports, "BetweenDateTimeComponent", () => $452c14429b146642$export$abb0f24cc549194b);
$parcel$export(module.exports, "InRangeComponent", () => $452c14429b146642$export$68448428cc911d39);
$parcel$export(module.exports, "TimeInputComponent", () => $452c14429b146642$export$1bc14371a5279585);
$parcel$export(module.exports, "IsNotSetComponent", () => $452c14429b146642$export$112000efafa8ead5);
$parcel$export(module.exports, "DateTimeVariations", () => $452c14429b146642$export$efd605d50e9e79ce);
const $452c14429b146642$export$5d7753c8ad881494 = {
    m: 'minutes',
    h: 'hours',
    d: 'days',
    w: 'weeks'
};
const $452c14429b146642$export$75843c31a96775e0 = 'within_the_last';
const $452c14429b146642$export$7d35a296ea2a6822 = 'more_than';
const $452c14429b146642$export$7df927301bd2f537 = 'between';
const $452c14429b146642$export$5ec4ea40f310605c = 'in_range';
const $452c14429b146642$export$28c868305da91826 = 'now_overdue';
const $452c14429b146642$export$7441c1214e39d97f = 'due_in_next';
const $452c14429b146642$export$de656838e950fdb9 = 'between_date_time';
const $452c14429b146642$export$709f90f7ba10389 = 'between';
const $452c14429b146642$export$abb0f24cc549194b = 'between_date_time';
const $452c14429b146642$export$68448428cc911d39 = 'in_range';
const $452c14429b146642$export$1bc14371a5279585 = 'time_input';
const $452c14429b146642$export$112000efafa8ead5 = 'is_not_set';
const $452c14429b146642$export$efd605d50e9e79ce = {
    DueDate: 'DueDate',
    DateTime: 'DateTime',
    DateTimeRange: 'DateTimeRange'
};

});

parcelRegister("4xwUT", function(module, exports) {

$parcel$export(module.exports, "default", () => $51379c83cbc8267c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatLabel", () => $51379c83cbc8267c$export$957d7daebd899f12);
$parcel$export(module.exports, "getTooltip", () => $51379c83cbc8267c$export$46455b4476d4b8e1);
$parcel$export(module.exports, "getJqlInfo", () => $51379c83cbc8267c$export$8299afa491becffd);
$parcel$export(module.exports, "getValueFromClauses", () => $51379c83cbc8267c$export$66bd7052943865c8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Xz6kS = parcelRequire("Xz6kS");

var $5CSKW = parcelRequire("5CSKW");

var $1NG86 = parcelRequire("1NG86");


var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $e2kjR = parcelRequire("e2kjR");

var $8wYmT = parcelRequire("8wYmT");

var $eUhKT = parcelRequire("eUhKT");

var $lRsB7 = parcelRequire("lRsB7");

var $cKrbS = parcelRequire("cKrbS");

var $kgmJM = parcelRequire("kgmJM");

var $fTjd1 = parcelRequire("fTjd1");

var $3QrSv = parcelRequire("3QrSv");

var $73DRj = parcelRequire("73DRj");
const $51379c83cbc8267c$var$hasValue = (dateTimePickerValue)=>{
    if (dateTimePickerValue) {
        const { type: type, value: value } = dateTimePickerValue;
        if (type === 'now_overdue') return {
            type: type,
            value: value
        };
        if (value === null) return false;
        switch(type){
            case 'more_than':
            case 'due_in_next':
            case 'within_the_last':
                return value !== undefined && Boolean(value.value1 && value.value2) ? {
                    value: value,
                    type: type
                } : false;
            case 'between':
            case 'between_date_time':
            case 'in_range':
                return value !== undefined && Boolean(value.value1 || value.value2) ? {
                    value: value,
                    type: type
                } : false;
            default:
                return false;
        }
    }
    return false;
};
const $51379c83cbc8267c$var$getFilterTypes = (name = '')=>{
    if (name === 'DueDate') return 0, $3QrSv.DueDateTypeConfig;
    if (name === 'DateTimeRange') return 0, $3QrSv.DateTimeTypeConfig;
    return 0, $3QrSv.DateTypeConfig;
};
const $51379c83cbc8267c$var$getDateInput = (componentType)=>{
    switch(componentType){
        case 0, $e2kjR.BetweenComponent:
            return 0, $lRsB7.default;
        case 0, $e2kjR.BetweenDateTimeComponent:
            return 0, $eUhKT.default;
        case 0, $e2kjR.InRangeComponent:
            return 0, $cKrbS.default;
        case 0, $e2kjR.TimeInputComponent:
            return 0, $fTjd1.default;
        default:
            return null;
    }
};
const $51379c83cbc8267c$var$DateTimeView = ({ fieldLabel: fieldLabel, value: valueProp, variation: variation, onChange: onChange, onClosePopup: onClosePopup, onSendOptionAnalytics: onSendOptionAnalytics })=>{
    const intl = (0, $lRq8t.default)();
    const [selectedTypeConfig, setSelectedTypeConfig] = (0, $eJOHy.useState)(valueProp !== undefined && valueProp.type ? $51379c83cbc8267c$var$getFilterTypes(variation).filter((filterType)=>valueProp && filterType.type === valueProp.type)[0] : undefined);
    const [value, setValue] = (0, $eJOHy.useState)({
        between: {
            value1: '',
            value2: ''
        },
        between_date_time: {
            value1: '',
            value2: ''
        },
        in_range: {
            value1: '',
            value2: ''
        },
        within_the_last: {
            value1: '',
            value2: ''
        },
        more_than: {
            value1: '',
            value2: ''
        },
        due_in_next: {
            value1: '',
            value2: '',
            excludeOverdue: true
        },
        ...valueProp && {
            [`${valueProp.type}`]: {
                ...valueProp.value
            }
        }
    });
    const onChangeCheckbox = (0, $eJOHy.useCallback)((event)=>{
        const type = event.currentTarget.value;
        const typeConfig = $51379c83cbc8267c$var$getFilterTypes(variation).find((t)=>t.type === type);
        setSelectedTypeConfig(typeConfig);
    }, [
        variation
    ]);
    const onChangeInput = (0, $eJOHy.useCallback)((val)=>{
        setValue((0, (/*@__PURE__*/$parcel$interopDefault($Xz6kS)))({}, value, selectedTypeConfig ? {
            [selectedTypeConfig.type]: val
        } : {}));
    }, [
        selectedTypeConfig,
        value
    ]);
    const errorMessage = (0, $eJOHy.useMemo)(()=>{
        let message;
        $51379c83cbc8267c$var$getFilterTypes(variation).forEach((m)=>{
            const isCurrent = selectedTypeConfig ? m.type === selectedTypeConfig.type : false;
            const currentValue = selectedTypeConfig && value[selectedTypeConfig.type];
            if (m.getErrorMessage && isCurrent) message = m.getErrorMessage(intl, currentValue);
        });
        return message;
    }, [
        intl,
        selectedTypeConfig,
        value,
        variation
    ]);
    const onUpdate = (0, $eJOHy.useCallback)(()=>{
        if (errorMessage !== undefined) return;
        const val = selectedTypeConfig && selectedTypeConfig.type !== (0, $e2kjR.NowOverdue) ? value[selectedTypeConfig.type] : undefined;
        const datePickerValue = selectedTypeConfig !== undefined ? {
            type: selectedTypeConfig.type,
            value: selectedTypeConfig.componentType !== (0, $e2kjR.IsNotSetComponent) ? val : undefined
        } : undefined;
        onChange(datePickerValue);
        if (typeof onClosePopup === 'function') onClosePopup();
        onSendOptionAnalytics && onSendOptionAnalytics({
            timeConstraints: datePickerValue?.type
        });
    }, [
        errorMessage,
        onChange,
        onClosePopup,
        onSendOptionAnalytics,
        selectedTypeConfig,
        value
    ]);
    const handleOnClick = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        onUpdate();
    }, [
        onUpdate
    ]);
    const handleOnKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter') {
            event.stopPropagation();
            event.preventDefault();
            onUpdate();
        }
    }, [
        onUpdate
    ]);
    const DateInputType = selectedTypeConfig ? $51379c83cbc8267c$var$getDateInput(selectedTypeConfig.componentType) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($51379c83cbc8267c$var$StyledDialogInner, {
        onKeyDown: handleOnKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "fieldset",
        xcss: $51379c83cbc8267c$var$fieldsetStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "legend",
        xcss: $51379c83cbc8267c$var$legendStyles
    }, intl.formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m4') ? (0, $73DRj.default).legendTextIssueTerminologyRefreshM4 : (0, $73DRj.default).legendText, {
        fieldLabel: fieldLabel
    })), $51379c83cbc8267c$var$getFilterTypes(variation).map((m)=>{
        const isCurrent = !!selectedTypeConfig && m.type === selectedTypeConfig.type;
        const currentValue = selectedTypeConfig && value[selectedTypeConfig.type];
        const messageDescriptor = (0, $73DRj.messageLookup)[m.label];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($51379c83cbc8267c$var$StyledOptionContainer, {
            key: m.type
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kgmJM.Radio), {
            checked: isCurrent,
            name: "mode",
            onChange: onChangeCheckbox,
            value: m.type,
            testId: `jql-builder-basic-datetime.ui.radio.${m.type}`
        }, messageDescriptor ? intl.formatMessage(messageDescriptor) : null), isCurrent && m.hasInput && currentValue && DateInputType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DateInputType, {
            isInvalid: isCurrent && errorMessage !== undefined,
            typeConfig: m,
            onChange: onChangeInput,
            value: currentValue
        }), isCurrent && errorMessage !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($51379c83cbc8267c$var$ErrorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
            LEGACY_size: "small",
            label: "",
            color: "var(--ds-icon-danger, #C9372C)"
        }), errorMessage));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $51379c83cbc8267c$var$buttonWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "primary",
        testId: "jql-builder-basic-datetime.ui.update-button",
        spacing: "default",
        isDisabled: errorMessage !== undefined,
        onClick: handleOnClick
    }, intl.formatMessage((0, $73DRj.default).updateButtonText))));
};
$51379c83cbc8267c$var$DateTimeView.whyDidYouRender = true;
var $51379c83cbc8267c$export$2e2bcd8739ae039 = $51379c83cbc8267c$var$DateTimeView;
const $51379c83cbc8267c$export$957d7daebd899f12 = ({ intl: intl, variation: variation, label: label, value: field })=>{
    const typeConfig = field ? $51379c83cbc8267c$var$getFilterTypes(variation).find((f)=>f.type === field.type) : undefined;
    if (typeConfig === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        weight: "medium",
        color: "inherit"
    }, label);
    const value = typeConfig.getFormattedValue(intl, field && field.value);
    return value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        weight: "medium",
        color: "inherit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "strong"
    }, label, ": "), typeConfig.getFormattedValue(intl, field && field.value)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        weight: "medium",
        color: "inherit"
    }, label);
};
const $51379c83cbc8267c$export$46455b4476d4b8e1 = ({ intl: intl, variation: variation, value: field })=>{
    const typeConfig = field ? $51379c83cbc8267c$var$getFilterTypes(variation).find((f)=>f.type === field.type) : undefined;
    if (typeConfig === undefined || !typeConfig.getTooltip) return undefined;
    return typeConfig.getTooltip(intl, field && field.value);
};
const $51379c83cbc8267c$export$8299afa491becffd = (dateTimePickerValue, variation)=>{
    if (dateTimePickerValue) {
        const { type: type, value: value } = dateTimePickerValue;
        const typeConfig = $51379c83cbc8267c$var$getFilterTypes(variation).find((f)=>f.type === type);
        const hasValuePresent = $51379c83cbc8267c$var$hasValue({
            type: type,
            value: value
        });
        if (!hasValuePresent) return undefined;
        if (typeConfig) {
            if (typeConfig.type === (0, $e2kjR.NowOverdue)) return typeConfig.getJqlData();
            if (value) return typeConfig.getJqlData(value);
        }
    }
    return undefined;
};
const $51379c83cbc8267c$export$f82c5f277c92418 = (variation, jqlData)=>{
    const possibleValues = $51379c83cbc8267c$var$getFilterTypes(variation).map((typeConfig)=>{
        const value = typeConfig.getValueFromJqlData(jqlData);
        if (value) return {
            type: typeConfig.type,
            value: value
        };
        return undefined;
    }).filter(Boolean);
    if (possibleValues.length > 0) return possibleValues[0];
    return undefined;
};
const $51379c83cbc8267c$export$82f46aa4e6535a45 = (intl, dateTimePickerValue, variation)=>{
    if (dateTimePickerValue) {
        const typeConfig = $51379c83cbc8267c$var$getFilterTypes(variation).filter((filterType)=>filterType.type === dateTimePickerValue.type)[0];
        if (dateTimePickerValue && typeConfig && typeConfig.getErrorMessage) return typeConfig.getErrorMessage(intl, dateTimePickerValue.value);
    }
    return undefined;
};
const $51379c83cbc8267c$export$66bd7052943865c8 = (variation, primaryClause, secondaryClause)=>{
    const jqlData = primaryClause === undefined && secondaryClause === undefined ? undefined : {
        primaryClause: primaryClause !== undefined && primaryClause.operator && primaryClause.operand && primaryClause.operand.operandType === (0, $862dfd240457f00b$export$38accfc5a5d1c113) ? {
            operator: primaryClause.operator.value,
            operand: (0, $8wYmT.removeSurroundingQuotes)(primaryClause.operand.text)
        } : undefined,
        secondaryClause: secondaryClause !== undefined && secondaryClause.operator && secondaryClause.operand && secondaryClause.operand.operandType === (0, $862dfd240457f00b$export$38accfc5a5d1c113) ? {
            operator: secondaryClause.operator.value,
            operand: (0, $8wYmT.removeSurroundingQuotes)(secondaryClause.operand.text)
        } : undefined
    };
    return $51379c83cbc8267c$export$f82c5f277c92418(variation, jqlData);
};
const $51379c83cbc8267c$var$fieldsetStyles = (0, $1DXK0.xcss)({
    border: 'none',
    margin: 'space.0',
    paddingBlockStart: 'space.200',
    paddingBlockEnd: 'space.100',
    paddingInlineStart: 'space.150',
    paddingInlineEnd: 'space.150'
});
const $51379c83cbc8267c$var$legendStyles = (0, $1DXK0.xcss)({
    width: '1px',
    height: '1px',
    padding: 'space.0',
    position: 'absolute',
    border: 'none',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $51379c83cbc8267c$var$buttonWrapperStyle = (0, $1DXK0.xcss)({
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    paddingInlineStart: 'space.150',
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $51379c83cbc8267c$var$StyledOptionContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyrpxbi _1tke1ou6 _dmhjze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $51379c83cbc8267c$var$ErrorContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _18u01ejb _19pk1b66 _syaz1tmw _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $51379c83cbc8267c$var$StyledDialogInner = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbxilx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8wYmT", function(module, exports) {

$parcel$export(module.exports, "removeSurroundingQuotes", () => $eef539967c694e7e$export$8de447c869ac6d85);

var $9qsUT = parcelRequire("9qsUT");
const $eef539967c694e7e$export$5378ca09aae39be8 = (jql, fieldIdentifier)=>{
    const ast = new (0, $9qsUT.JastBuilder)().build(jql);
    const fieldsToReturn = [];
    if (ast && ast.query && ast.query.where) {
        if (ast.query.where.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b)) ast.query.where.clauses.forEach((clause)=>{
            if (clause.clauseType === (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a)) {
                const fieldId = clause.field.value.toLowerCase();
                if (fieldIdentifier.toLowerCase() === fieldId) fieldsToReturn.push(clause);
            }
        });
        else if (ast.query.where.clauseType === (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a)) {
            const fieldId = ast.query.where.field.value.toLowerCase();
            if (fieldIdentifier.toLowerCase() === fieldId) {
                if (ast.query && ast.query.where) fieldsToReturn.push(ast.query.where);
            }
        }
    }
    return fieldsToReturn;
};
const $eef539967c694e7e$export$8de447c869ac6d85 = (maybeQuotedString)=>maybeQuotedString.replace(/^["']|["']$/g, '');

});

parcelRegister("eUhKT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8e02413cd1ced53$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");

var $cK9J2 = parcelRequire("cK9J2");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $iw2hI = parcelRequire("iw2hI");

var $2cfd4 = parcelRequire("2cfd4");

var $7jTnu = parcelRequire("7jTnu");

var $cVHnY = parcelRequire("cVHnY");

var $fWxQr = parcelRequire("fWxQr");
const $c8e02413cd1ced53$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $c8e02413cd1ced53$var$isDateValueInvalid = (value)=>!(0, $dBLX0.default)((0, $kQ82p.default)(value)) && value !== '';
const $c8e02413cd1ced53$var$BetweenDateTime = ({ value: { value1: value1, value2: value2 }, onChange: onChange })=>{
    const locale = (0, $2cfd4.useLocale)();
    const standardizedLocale = (0, $iw2hI.standardizeLocale)(locale);
    const [localizationProvider] = (0, $eJOHy.useState)((0, $cK9J2.createLocalizationProvider)(standardizedLocale));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChangeValue1Date = (0, $eJOHy.useCallback)((value)=>{
        onChange({
            value1: value,
            value2: value2
        });
    }, [
        onChange,
        value2
    ]);
    const onChangeValue2Date = (0, $eJOHy.useCallback)((value)=>{
        onChange({
            value1: value1,
            value2: value
        });
    }, [
        onChange,
        value1
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $7jTnu.fg)('add_shouldshowcalendarbutton_prop_to_date_picker') ? $c8e02413cd1ced53$var$wrapperStyles : $c8e02413cd1ced53$var$wrapperStylesOld,
        paddingBlockStart: "space.075",
        paddingInlineStart: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cVHnY.DateTimePicker), {
        locale: standardizedLocale,
        onChange: onChangeValue1Date,
        isInvalid: $c8e02413cd1ced53$var$isDateValueInvalid(value1),
        dateLabel: formatMessage((0, $fWxQr.default).startDateLabel),
        placeholder: localizationProvider.formatDate(new Date(new Date().getTime() - $c8e02413cd1ced53$var$ONE_DAY_IN_MILLISECONDS)),
        value: !$c8e02413cd1ced53$var$isDateValueInvalid(value1) ? value1 : '',
        testId: "jql-builder-basic-datetime.ui.between-date-time.value-1",
        timeLabel: formatMessage((0, $fWxQr.default).startTimeLabel),
        defaultTime: "00:00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, formatMessage((0, $fWxQr.default).and)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cVHnY.DateTimePicker), {
        locale: standardizedLocale,
        isInvalid: $c8e02413cd1ced53$var$isDateValueInvalid(value2),
        onChange: onChangeValue2Date,
        dateLabel: formatMessage((0, $fWxQr.default).endDateLabel),
        placeholder: localizationProvider.formatDate(new Date(new Date().getTime() + $c8e02413cd1ced53$var$ONE_DAY_IN_MILLISECONDS)),
        value: !$c8e02413cd1ced53$var$isDateValueInvalid(value2) ? value2 : '',
        testId: "jql-builder-basic-datetime.ui.between-date-time.value-2",
        timeLabel: formatMessage((0, $fWxQr.default).endTimeLabel),
        defaultTime: "23:59"
    })));
};
var $c8e02413cd1ced53$export$2e2bcd8739ae039 = $c8e02413cd1ced53$var$BetweenDateTime;
const $c8e02413cd1ced53$var$wrapperStylesOld = (0, $1DXK0.xcss)({
    width: '265px'
});
const $c8e02413cd1ced53$var$wrapperStyles = (0, $1DXK0.xcss)({
    width: '350px'
});

});
parcelRegister("cK9J2", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $2150f4a906bcb332$export$ea56ca58f08ffa52);

var $4ZGCx = parcelRequire("4ZGCx");

var $ktSIT = parcelRequire("ktSIT");

var $92aEh = parcelRequire("92aEh");
const $2150f4a906bcb332$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $ktSIT.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("4ZGCx", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $caa7b379de4e9e4d$export$dca0327c9b9c6498);
const $caa7b379de4e9e4d$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("ktSIT", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $f0407708fddca50b$export$cfa2ef2687faeda2);

var $4ZGCx = parcelRequire("4ZGCx");

var $61I7t = parcelRequire("61I7t");
const $f0407708fddca50b$var$INVALID_DATE = new Date(NaN);
const $f0407708fddca50b$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $f0407708fddca50b$var$INVARIANT_DATE = (0, $61I7t.toDate)($f0407708fddca50b$var$INVARIANT);
const $f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $f0407708fddca50b$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $f0407708fddca50b$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $f0407708fddca50b$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $f0407708fddca50b$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($f0407708fddca50b$var$INVARIANT_DATE);
    const shortDate = $f0407708fddca50b$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $f0407708fddca50b$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $f0407708fddca50b$var$stripExtras(date).match($f0407708fddca50b$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $f0407708fddca50b$var$INVALID_DATE;
        const dateParts = $f0407708fddca50b$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $61I7t.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $61I7t.isValid)(normalizedDate)) return $f0407708fddca50b$var$INVALID_DATE;
        return (0, $61I7t.toDate)(normalizedDate);
    };
};

});
parcelRegister("61I7t", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $862914b96a01ecbb$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $862914b96a01ecbb$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $862914b96a01ecbb$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $862914b96a01ecbb$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $862914b96a01ecbb$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $862914b96a01ecbb$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $862914b96a01ecbb$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $862914b96a01ecbb$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $862914b96a01ecbb$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $862914b96a01ecbb$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $862914b96a01ecbb$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $862914b96a01ecbb$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("92aEh", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $0bfc942d7a009811$export$9b7ca29af37c192);
const $0bfc942d7a009811$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("iw2hI", function(module, exports) {

$parcel$export(module.exports, "standardizeLocale", () => $07e147bc3d7cc59d$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $07e147bc3d7cc59d$export$93ff13646da25bd);

var $4qiFT = parcelRequire("4qiFT");

var $eSnSE = parcelRequire("eSnSE");
const $07e147bc3d7cc59d$export$95b7602913551865 = 'en-US';
const $07e147bc3d7cc59d$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$07e147bc3d7cc59d$export$95b7602913551865}.`);
        return $07e147bc3d7cc59d$export$95b7602913551865;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $4qiFT.default).includes(jiraLocale)) (0, $eSnSE.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $07e147bc3d7cc59d$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($07e147bc3d7cc59d$export$95b7602913551865, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});

parcelRegister("cVHnY", function(module, exports) {

$parcel$export(module.exports, "DateTimePicker", () => $ad34d83c53d353ed$export$ccdfd7928785632e);

var $eJOHy = parcelRequire("eJOHy");

var $iUa8i = parcelRequire("iUa8i");
var $fkh8F = parcelRequire("fkh8F");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $igoRN = parcelRequire("igoRN");

var $7jTnu = parcelRequire("7jTnu");

var $9jzsQ = parcelRequire("9jzsQ");
const $ad34d83c53d353ed$export$ccdfd7928785632e = ({ locale: locale, isInvalid: isInvalid = false, onChange: onChange, value: value, placeholder: placeholder, dateLabel: dateLabel, timeLabel: timeLabel, testId: testId, defaultTime: defaultTime = '00:00' })=>{
    const [internalDateValue, setInternalDateValue] = (0, $eJOHy.useState)(()=>value ? (0, $9jzsQ.parseDateValue)(value) : '');
    const [internalTimeValue, setInternalTimeValue] = (0, $eJOHy.useState)(()=>value ? (0, $9jzsQ.parseTimeValue)(value) : '');
    const handleOnDateChange = (0, $eJOHy.useCallback)((dateValue)=>{
        setInternalDateValue(dateValue);
        const parsedDateTime = dateValue ? (0, $9jzsQ.parseDateTimeToISO)(dateValue, internalTimeValue || defaultTime) : '';
        onChange(parsedDateTime);
    }, [
        defaultTime,
        internalTimeValue,
        onChange
    ]);
    const handleOnTimeChange = (0, $eJOHy.useCallback)((timeValue)=>{
        setInternalTimeValue(timeValue);
        if (internalDateValue) {
            const parsedDateTime = (0, $9jzsQ.parseDateTimeToISO)(internalDateValue, timeValue || defaultTime);
            onChange(parsedDateTime);
        }
    }, [
        defaultTime,
        internalDateValue,
        onChange
    ]);
    const timePlaceholder = (0, $eJOHy.useMemo)(()=>{
        return (0, $9jzsQ.getTimePlaceholder)(defaultTime, locale);
    }, [
        defaultTime,
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $ad34d83c53d353ed$var$baseContainerStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ad34d83c53d353ed$var$datePickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iUa8i.default), {
        locale: locale,
        isInvalid: isInvalid,
        onChange: handleOnDateChange,
        placeholder: placeholder,
        label: dateLabel,
        value: internalDateValue,
        ...(0, $7jTnu.fg)('add_shouldshowcalendarbutton_prop_to_date_picker') ? {
            shouldShowCalendarButton: true
        } : {
            spacing: 'compact'
        },
        testId: `${testId}--datepicker`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ad34d83c53d353ed$var$timePickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fkh8F.default), {
        locale: locale,
        isInvalid: isInvalid,
        onChange: handleOnTimeChange,
        label: timeLabel,
        value: internalTimeValue,
        ...!(0, $7jTnu.fg)('add_shouldshowcalendarbutton_prop_to_date_picker') && {
            spacing: 'compact'
        },
        timeIsEditable: true,
        times: (0, $igoRN.default),
        testId: `${testId}--timepicker`,
        placeholder: timePlaceholder
    })));
};
const $ad34d83c53d353ed$var$datePickerContainerStyles = (0, $1DXK0.xcss)({
    flexBasis: '50%',
    flexGrow: 1,
    flexShrink: 0
});
const $ad34d83c53d353ed$var$timePickerContainerStyles = (0, $1DXK0.xcss)({
    flexBasis: '50%',
    flexGrow: 1
});
const $ad34d83c53d353ed$var$baseContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    gap: 'space.050'
});

});
parcelRegister("iUa8i", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8d7b5e7995f81e7$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $1BRZx = parcelRequire("1BRZx");

var $lLHJE = parcelRequire("lLHJE");

var $k2Uo2 = parcelRequire("k2Uo2");
const $b8d7b5e7995f81e7$var$DatePicker = (0, $1BRZx.componentWithCondition)(()=>(0, $eGOwo.fg)('dst-date-picker-use-functional-component'), (0, $k2Uo2.default), (0, $lLHJE.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b8d7b5e7995f81e7$export$2e2bcd8739ae039 = $b8d7b5e7995f81e7$var$DatePicker;

});
parcelRegister("1BRZx", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $48de19f2c65a8561$export$6e8ea24b15199873);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $48de19f2c65a8561$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("lLHJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe32780a1f5c05c$export$2e2bcd8739ae039);
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $5fWw9 = parcelRequire("5fWw9");
var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $gl2vi = parcelRequire("gl2vi");

var $3GKOL = parcelRequire("3GKOL");

var $cK9J2 = parcelRequire("cK9J2");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $47or1 = parcelRequire("47or1");

var $hmV0i = parcelRequire("hmV0i");

var $gNwsY = parcelRequire("gNwsY");

var $1u9xN = parcelRequire("1u9xN");

var $7OE9J = parcelRequire("7OE9J");
const $2fe32780a1f5c05c$var$packageName = "platform-pkg";
const $2fe32780a1f5c05c$var$packageVersion = "0.0.0-use.local";
const $2fe32780a1f5c05c$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $2fe32780a1f5c05c$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $2fe32780a1f5c05c$export$df43d21f5faca9f7 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = $2fe32780a1f5c05c$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $47or1.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $47or1.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $1u9xN.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $47or1.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $1u9xN.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        } // This event handler is triggered from both keydown and click. It's weird.
        , this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $1u9xN.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        } // `unknown` is used because `value` is unused so it does not matter.
        , this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $1u9xN.getShortISOString)(new Date()),
            l10n: (0, $cK9J2.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $cK9J2.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $2fe32780a1f5c05c$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $7OE9J.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $RoXqn.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmV0i.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gNwsY.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $RoXqn.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $1u9xN.getShortISOString)((0, $kQ82p.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $47or1.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $hcewu.default)([
                $2fe32780a1f5c05c$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                    appearance: this.props.appearance,
                    "aria-describedby": ariaDescribedBy,
                    label: label || undefined,
                    autoFocus: autoFocus,
                    clearControlLabel: clearControlLabel,
                    closeMenuOnSelect: true,
                    enableAnimation: false,
                    inputId: id,
                    inputValue: actualSelectInputValue,
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    menuIsOpen: menuIsOpen,
                    onBlur: this.onSelectBlur,
                    onChange: this.onSelectChange,
                    onFocus: this.onSelectFocus,
                    onInputChange: this.handleSelectInputChange,
                    placeholder: (0, $47or1.getPlaceholder)({
                        placeholder: this.props.placeholder,
                        l10n: this.state.l10n
                    }),
                    styles: mergedStyles,
                    value: initialValue,
                    ...selectProps,
                    // up when you alter some of the properties in the `selectComponents`
                    // object. These errors are still present, and I suspect have always
                    // been present, without changing the unrelated code. Ignoring as the
                    // component still works as expected despite this error. And also
                    // because the select refresh team may solve it later.
                    components: selectComponents,
                    // selectProps or not and what wil be overwritten
                    isClearable: true,
                    isInvalid: isInvalid,
                    spacing: spacing,
                    testId: testId,
                    // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                    calendarContainerRef: calendarProps.calendarContainerRef,
                    calendarDisabled: calendarProps.calendarDisabled,
                    calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                    calendarLocale: calendarProps.calendarLocale,
                    calendarMaxDate: calendarProps.calendarMaxDate,
                    calendarMinDate: calendarProps.calendarMinDate,
                    calendarRef: calendarProps.calendarRef,
                    calendarValue: calendarProps.calendarValue,
                    calendarView: calendarProps.calendarView,
                    calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                    nextMonthLabel: nextMonthLabel,
                    onCalendarChange: calendarProps.onCalendarChange,
                    onCalendarSelect: calendarProps.onCalendarSelect,
                    previousMonthLabel: previousMonthLabel,
                    shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                    menuInnerWrapper: calendarProps.menuInnerWrapper
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gl2vi.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: (0, $6qaBj.cx)($2fe32780a1f5c05c$var$styles.iconContainerStyles, value && !hideIcon ? $2fe32780a1f5c05c$var$styles.iconSpacingWithClearButtonStyles : $2fe32780a1f5c05c$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #44546F)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
}
const $2fe32780a1f5c05c$var$DatePicker = (0, $dUaMU.default)({
    componentName: 'datePicker',
    packageName: $2fe32780a1f5c05c$var$packageName,
    packageVersion: $2fe32780a1f5c05c$var$packageVersion
})((0, $4J0ad.default)({
    onChange: (0, $5fWw9.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $2fe32780a1f5c05c$var$packageName,
            packageVersion: $2fe32780a1f5c05c$var$packageVersion
        }
    })
})($2fe32780a1f5c05c$export$df43d21f5faca9f7));
var $2fe32780a1f5c05c$export$2e2bcd8739ae039 = $2fe32780a1f5c05c$var$DatePicker;

});
parcelRegister("3GKOL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2af99c62070f9b2c$var$_react = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2af99c62070f9b2c$var$_calendar = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("btkTq")));

var $2af99c62070f9b2c$var$_calendar2 = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("76JV8")));
function $2af99c62070f9b2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2af99c62070f9b2c$var$CalendarIcon = (props)=>/*#__PURE__*/ $2af99c62070f9b2c$var$_react.default.createElement($2af99c62070f9b2c$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $2af99c62070f9b2c$var$_calendar2.default
    }, props));
$2af99c62070f9b2c$var$CalendarIcon.Name = 'CalendarIconMigration';
var $2af99c62070f9b2c$var$_default = module.exports.default = $2af99c62070f9b2c$var$CalendarIcon;

});
parcelRegister("btkTq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85a29c08b1b7d658$var$_react = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $85a29c08b1b7d658$var$_baseNew = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $85a29c08b1b7d658$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85a29c08b1b7d658$var$CalendarIcon = (props)=>/*#__PURE__*/ $85a29c08b1b7d658$var$_react.default.createElement($85a29c08b1b7d658$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$85a29c08b1b7d658$var$CalendarIcon.displayName = 'CalendarIcon';
var $85a29c08b1b7d658$var$_default = module.exports.default = $85a29c08b1b7d658$var$CalendarIcon;

});

parcelRegister("76JV8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52ccb6d3a2735d8d$var$_react = $52ccb6d3a2735d8d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $52ccb6d3a2735d8d$var$_calendar = $52ccb6d3a2735d8d$var$_interopRequireDefault((parcelRequire("btkTq")));
function $52ccb6d3a2735d8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $52ccb6d3a2735d8d$var$CalendarIcon = (props)=>/*#__PURE__*/ $52ccb6d3a2735d8d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $52ccb6d3a2735d8d$var$_calendar.default
    }));
$52ccb6d3a2735d8d$var$CalendarIcon.displayName = 'CalendarIcon';
var $52ccb6d3a2735d8d$var$_default = module.exports.default = $52ccb6d3a2735d8d$var$CalendarIcon;

});


parcelRegister("RoXqn", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $f314d4d8e1112a31$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $f314d4d8e1112a31$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $f314d4d8e1112a31$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $f314d4d8e1112a31$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $f314d4d8e1112a31$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $f314d4d8e1112a31$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $f314d4d8e1112a31$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $f314d4d8e1112a31$export$5e30e9a24d6c1203 = ()=>null;
const $f314d4d8e1112a31$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $f314d4d8e1112a31$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $f314d4d8e1112a31$export$9e6d8fcf62256b85 = 'h:mma';
const $f314d4d8e1112a31$export$75032c84f56650eb = 'YYYY/MM/DD';
function $f314d4d8e1112a31$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $f314d4d8e1112a31$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("47or1", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $0a9aca5af48d76f0$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $0a9aca5af48d76f0$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $0a9aca5af48d76f0$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $0a9aca5af48d76f0$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $0a9aca5af48d76f0$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $57raR = parcelRequire("57raR");
var $cBFyu = parcelRequire("cBFyu");
var $kQ82p = parcelRequire("kQ82p");

var $5PwWU = parcelRequire("5PwWU");

var $RoXqn = parcelRequire("RoXqn");
const $0a9aca5af48d76f0$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $0a9aca5af48d76f0$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $cBFyu.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $RoXqn.padToTwo)(parsedMonth)}-${(0, $RoXqn.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $RoXqn.padToTwo)(parsedMonth)}-${(0, $RoXqn.padToTwo)(parsedDate)}`;
    return newIso;
};
const $0a9aca5af48d76f0$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $RoXqn.defaultDateFormat));
    return l10n.parseDate(date);
};
const $0a9aca5af48d76f0$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $RoXqn.defaultDateFormat));
    const date = (0, $kQ82p.default)(value);
    return dateFormat ? (0, $57raR.default)(date, (0, $5PwWU.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $0a9aca5af48d76f0$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $RoXqn.placeholderDatetime));
};

});
parcelRegister("5PwWU", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $0e0ecc26a93a278c$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $0e0ecc26a93a278c$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $0e0ecc26a93a278c$var$v1tokens = Object.keys($0e0ecc26a93a278c$var$tokensMap).sort().reverse();
const $0e0ecc26a93a278c$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$0e0ecc26a93a278c$var$v1tokens.join('|') + '|.)', 'g');
function $0e0ecc26a93a278c$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($0e0ecc26a93a278c$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $0e0ecc26a93a278c$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("hmV0i", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $85a1248019ae74fb$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XEne = parcelRequire("6XEne");
const $85a1248019ae74fb$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
const $85a1248019ae74fb$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            showClearIndicator ? $85a1248019ae74fb$var$styles.calendarButtonInclusionStyles : $85a1248019ae74fb$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).IndicatorsContainer, {
            ...rest
        })
    });

});

parcelRegister("gNwsY", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $41b3b0700e22b1c1$export$d9b273488cd8ce6f);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $cSUzd = parcelRequire("cSUzd");

var $3rigy = parcelRequire("3rigy");

var $7G7nX = parcelRequire("7G7nX");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $41b3b0700e22b1c1$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $kQ82p.default)(iso);
        return (0, $dBLX0.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $41b3b0700e22b1c1$var$menuStyles = null;
const $41b3b0700e22b1c1$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $41b3b0700e22b1c1$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $eJOHy.Fragment);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rigy.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7G7nX.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $hcewu.default)([
                    "_2rkoglpi _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs1cd0"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cSUzd.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};

});
parcelRegister("cSUzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1db3bdfc4d701b2$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $hWhuM = parcelRequire("hWhuM");

var $jOHXZ = parcelRequire("jOHXZ");

var $1p4Fz = parcelRequire("1p4Fz");

var $h2Y6s = parcelRequire("h2Y6s");

var $7pqrO = parcelRequire("7pqrO");

var $8m7JM = parcelRequire("8m7JM");

var $5Pa93 = parcelRequire("5Pa93");

var $cM3gB = parcelRequire("cM3gB");

var $lPLOh = parcelRequire("lPLOh");

var $jtNxE = parcelRequire("jtNxE");
const $d1db3bdfc4d701b2$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $d1db3bdfc4d701b2$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $d1db3bdfc4d701b2$var$InnerCalendar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $h2Y6s.blankStringArray), defaultSelected: defaultSelected = (0, $h2Y6s.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $3Vuhz.default), onChange: onChange = (0, $3Vuhz.default), onFocus: onFocus = (0, $3Vuhz.default), onSelect: onSelect = (0, $3Vuhz.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $7pqrO.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eJOHy.useState)(false);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$d1db3bdfc4d701b2$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $cM3gB.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$d1db3bdfc4d701b2$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $lPLOh.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $8m7JM.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $jtNxE.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $5Pa93.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $gl2vi.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $d1db3bdfc4d701b2$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hWhuM.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1p4Fz.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jOHXZ.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    }));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $d1db3bdfc4d701b2$var$Calendar = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d1db3bdfc4d701b2$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$d1db3bdfc4d701b2$var$Calendar.displayName = 'Calendar';
var $d1db3bdfc4d701b2$export$2e2bcd8739ae039 = $d1db3bdfc4d701b2$var$Calendar;

});
parcelRegister("hWhuM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe58087a91a587c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $gl2vi = parcelRequire("gl2vi");

var $806LH = parcelRequire("806LH");

var $ld0cd = parcelRequire("ld0cd");

var $cqfIR = parcelRequire("cqfIR");

var $8PCRQ = parcelRequire("8PCRQ");

var $cQxBL = parcelRequire("cQxBL");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
const $8fe58087a91a587c$var$Header = /*#__PURE__*/ (0, $eJOHy.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $gl2vi.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $eJOHy.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld0cd))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8PCRQ))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cqfIR))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$8fe58087a91a587c$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8fe58087a91a587c$export$2e2bcd8739ae039 = $8fe58087a91a587c$var$Header;

});
parcelRegister("ld0cd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89a5ee1ee34f6c51127fc5be19fb8c41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f70af6cd1d0cef8e$var$_react = $f70af6cd1d0cef8e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f70af6cd1d0cef8e$var$_baseNew = $f70af6cd1d0cef8e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f70af6cd1d0cef8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $f70af6cd1d0cef8e$var$_react.default.createElement($f70af6cd1d0cef8e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $f70af6cd1d0cef8e$var$_default = module.exports.default = $f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon;

});

parcelRegister("cqfIR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a70faad39a1700c3cb50a44f6bcc1a4e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90b41be71667434a$var$_react = $90b41be71667434a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $90b41be71667434a$var$_baseNew = $90b41be71667434a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $90b41be71667434a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90b41be71667434a$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $90b41be71667434a$var$_react.default.createElement($90b41be71667434a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$90b41be71667434a$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $90b41be71667434a$var$_default = module.exports.default = $90b41be71667434a$var$ChevronDoubleRightIcon;

});

parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});


parcelRegister("jOHXZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7776188040914bac$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");

var $17gD3 = parcelRequire("17gD3");

var $48tPc = parcelRequire("48tPc");
const $7776188040914bac$var$WeekDays = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $48tPc.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $17gD3.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$7776188040914bac$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7776188040914bac$export$2e2bcd8739ae039 = $7776188040914bac$var$WeekDays;

});
parcelRegister("17gD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f55ebb7772d4c5d$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Vuhz = parcelRequire("3Vuhz");

var $hYvlq = parcelRequire("hYvlq");
const $7f55ebb7772d4c5d$var$dateCellSiblingStyle = null;
const $7f55ebb7772d4c5d$var$dateCellTodayStyle = null;
const $7f55ebb7772d4c5d$var$dateCellPrevSelectedStyle = null;
const $7f55ebb7772d4c5d$var$dateCellSelectedStyle = null;
const $7f55ebb7772d4c5d$var$dateCellDisabledStyle = null;
const $7f55ebb7772d4c5d$var$dateCellStyles = null;
const $7f55ebb7772d4c5d$var$Date = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $3Vuhz.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eJOHy.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $hcewu.default)([
                "_kkk2n7od _2rko1l7b _11c82smr _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$7f55ebb7772d4c5d$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7f55ebb7772d4c5d$export$2e2bcd8739ae039 = $7f55ebb7772d4c5d$var$Date;

});
parcelRegister("hYvlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e062987a137d87a$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3e062987a137d87a$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $3e062987a137d87a$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $3e062987a137d87a$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $3e062987a137d87a$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $3e062987a137d87a$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $3e062987a137d87a$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $3e062987a137d87a$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $3e062987a137d87a$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hcewu.default)([
            $3e062987a137d87a$var$baseStyles.root,
            gap && $3e062987a137d87a$var$columnGapMap[gap],
            columnGap && $3e062987a137d87a$var$columnGapMap[columnGap],
            gap && $3e062987a137d87a$var$rowGapMap[gap],
            rowGap && $3e062987a137d87a$var$rowGapMap[rowGap],
            alignItems && $3e062987a137d87a$var$alignItemsMap[alignItems],
            alignContent && $3e062987a137d87a$var$alignContentMap[alignContent],
            justifyContent && $3e062987a137d87a$var$justifyContentMap[justifyContent],
            autoFlow && $3e062987a137d87a$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$3e062987a137d87a$var$Grid.displayName = 'Grid';
var $3e062987a137d87a$export$2e2bcd8739ae039 = $3e062987a137d87a$var$Grid;

});


parcelRegister("48tPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f5de1de4465d4ec$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hYvlq = parcelRequire("hYvlq");
const $4f5de1de4465d4ec$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $4f5de1de4465d4ec$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
        testId: testId,
        xcss: $4f5de1de4465d4ec$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $4f5de1de4465d4ec$export$2e2bcd8739ae039 = $4f5de1de4465d4ec$var$WeekDayGrid;

});


parcelRegister("1p4Fz", function(module, exports) {

$parcel$export(module.exports, "default", () => $be65a37818b8364c$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $48tPc = parcelRequire("48tPc");
const $be65a37818b8364c$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $be65a37818b8364c$var$WeekHeader = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $48tPc.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                padding: "space.100",
                xcss: $be65a37818b8364c$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$be65a37818b8364c$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be65a37818b8364c$export$2e2bcd8739ae039 = $be65a37818b8364c$var$WeekHeader;

});

parcelRegister("h2Y6s", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $be18158d85881f31$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $be18158d85881f31$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $be18158d85881f31$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $be18158d85881f31$export$8fa20d70624f8b9d);
const $be18158d85881f31$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $be18158d85881f31$export$3ae905d9742bef55 = 7;
const $be18158d85881f31$export$c9b7c010035d60c6 = 12;
const $be18158d85881f31$export$8fa20d70624f8b9d = [];

});

parcelRegister("7pqrO", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0ab84481a095dc$export$2e2bcd8739ae039);

var $7O2l7 = parcelRequire("7O2l7");

var $3c3v8 = parcelRequire("3c3v8");

var $ediHA = parcelRequire("ediHA");
function $dd0ab84481a095dc$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $3c3v8.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $7O2l7.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $7O2l7.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $7O2l7.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $7O2l7.default)(today, ()=>today || `${thisYear}-${(0, $ediHA.default)(thisMonth)}-${(0, $ediHA.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $7O2l7.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $7O2l7.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("ediHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $50fecd0d0148fc4a$export$2e2bcd8739ae039);
function $50fecd0d0148fc4a$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("8m7JM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c971afa7669251e8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $c971afa7669251e8$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eJOHy.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("5Pa93", function(module, exports) {

$parcel$export(module.exports, "default", () => $6571678cf382b203$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");

var $cFI4x = parcelRequire("cFI4x");
function $6571678cf382b203$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eJOHy.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $h2Y6s.daysPerWeek) : 0;
            return (0, $cFI4x.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $h2Y6s.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $6571678cf382b203$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eJOHy.useMemo)(()=>(0, $cFI4x.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $6571678cf382b203$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $kQ82p.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $kQ82p.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eJOHy.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $fdbAT.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $kQ82p.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("fdbAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $33e505eaecca4d6d$export$2e2bcd8739ae039);

var $ediHA = parcelRequire("ediHA");
function $33e505eaecca4d6d$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $ediHA.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $ediHA.default)(date.day)}`;
}

});

parcelRegister("cFI4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc98c4c7dc36d65$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $h2Y6s = parcelRequire("h2Y6s");

var $d9oTA = parcelRequire("d9oTA");
function $5fc98c4c7dc36d65$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $h2Y6s.daysPerWeek) - weekStartDay + firstDay) % (0, $h2Y6s.daysPerWeek));
    const lastDate = (0, $d9oTA.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $h2Y6s.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $d9oTA.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $h2Y6s.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $h2Y6s.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $h2Y6s.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $h2Y6s.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $h2Y6s.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("d9oTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdb6610bba124d19$export$2e2bcd8739ae039);
function $bdb6610bba124d19$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("cM3gB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e11abbd67514b7e7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");

var $d9oTA = parcelRequire("d9oTA");
const $e11abbd67514b7e7$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $h2Y6s.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $e11abbd67514b7e7$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $h2Y6s.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $e11abbd67514b7e7$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $fdbAT.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eJOHy.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $h2Y6s.daysPerWeek);
            const daysInMonth = (0, $d9oTA.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $e11abbd67514b7e7$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $e11abbd67514b7e7$var$getPrevMonth(month, year);
                const prevDay = (0, $d9oTA.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $d9oTA.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $e11abbd67514b7e7$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $h2Y6s.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $e11abbd67514b7e7$var$getPrevMonth(month, year);
                const prevDay = (0, $d9oTA.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$e11abbd67514b7e7$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$e11abbd67514b7e7$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("lPLOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $395ce53b4353da25$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");
function $395ce53b4353da25$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $fdbAT.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eJOHy.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $h2Y6s.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("jtNxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $01a6b7d4c4da291b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cK9J2 = parcelRequire("cK9J2");
function $01a6b7d4c4da291b$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eJOHy.useMemo)(()=>(0, $cK9J2.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eJOHy.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eJOHy.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eJOHy.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("7G7nX", function(module, exports) {

$parcel$export(module.exports, "default", () => $68ce7a484b05c143$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $anoAR = parcelRequire("anoAR");

var $6G5P1 = parcelRequire("6G5P1");
var $8qmYl = parcelRequire("8qmYl");
var $azjc1 = parcelRequire("azjc1");
const $68ce7a484b05c143$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $68ce7a484b05c143$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $anoAR.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6G5P1.Manager), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $azjc1.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $hcewu.default)([
                                $68ce7a484b05c143$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8qmYl.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $hcewu.default)([
                                $68ce7a484b05c143$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $3Vuhz.default);
    }
}

});
parcelRegister("anoAR", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $19bef17192bf3a9c$export$c647cb0ee6e282fe);
const $19bef17192bf3a9c$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $19bef17192bf3a9c$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $19bef17192bf3a9c$export$62ad7b0c781000e9 = {
    small: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("1u9xN", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $a3c204a1b42604a4$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $a3c204a1b42604a4$export$ff525416014fb67d);

var $57raR = parcelRequire("57raR");

var $5PwWU = parcelRequire("5PwWU");
function $a3c204a1b42604a4$export$77d5bc49fed7ef14(date) {
    return (0, $57raR.default)(date, (0, $5PwWU.convertTokens)('YYYY-MM-DD'));
}
function $a3c204a1b42604a4$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $a3c204a1b42604a4$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("7OE9J", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $8e54d9aa121b2675$export$6e30bf8cb1347b56);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");
const $8e54d9aa121b2675$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("k2Uo2", function(module, exports) {

$parcel$export(module.exports, "default", () => $00683ba6c52d5435$export$2e2bcd8739ae039);
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $jrFnt = parcelRequire("jrFnt");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $gl2vi = parcelRequire("gl2vi");

var $3GKOL = parcelRequire("3GKOL");

var $cK9J2 = parcelRequire("cK9J2");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $47or1 = parcelRequire("47or1");

var $hmV0i = parcelRequire("hmV0i");

var $gNwsY = parcelRequire("gNwsY");

var $1u9xN = parcelRequire("1u9xN");

var $7OE9J = parcelRequire("7OE9J");
const $00683ba6c52d5435$var$packageName = "platform-pkg";
const $00683ba6c52d5435$var$packageVersion = "0.0.0-use.local";
const $00683ba6c52d5435$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $00683ba6c52d5435$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $00683ba6c52d5435$var$packageName,
    packageVersion: $00683ba6c52d5435$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $00683ba6c52d5435$var$DatePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const calendarRef = (0, $eJOHy.useRef)(null);
    const calendarButtonRef = (0, $eJOHy.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $eJOHy.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $eJOHy.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $eJOHy.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $eJOHy.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $eJOHy.useState)(propValue || defaultValue || (0, $1u9xN.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $eJOHy.useState)((0, $cK9J2.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $eJOHy.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $eJOHy.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $eJOHy.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $eJOHy.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$00683ba6c52d5435$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $cK9J2.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $eJOHy.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $47or1.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $47or1.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $1u9xN.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $47or1.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $1u9xN.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen((isOpen)=>{
            if (isOpen) {
                (0, $eGOwo.fg)('platform_dst_menuonclose_fix') && props.selectProps?.onMenuClose?.();
                return false;
            } else {
                (0, $eGOwo.fg)('platform_dst_menuonclose_fix') && props.selectProps?.onMenuOpen?.();
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $1u9xN.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $eJOHy.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $00683ba6c52d5435$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $7OE9J.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $RoXqn.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmV0i.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gNwsY.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $RoXqn.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $1u9xN.getShortISOString)((0, $kQ82p.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $47or1.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $gl2vi.useId)()}`;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $hcewu.default)([
            $00683ba6c52d5435$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $47or1.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // @ts-ignore -- Type 'OptionType' is not assignable to type '{ label: string; value: string; }'
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: (0, $6qaBj.cx)($00683ba6c52d5435$var$styles.iconContainerStyles, value && !hideIcon ? $00683ba6c52d5435$var$styles.iconSpacingWithClearButtonStyles : $00683ba6c52d5435$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
                            ...iconProps,
                            color: "var(--ds-icon, #44546F)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $00683ba6c52d5435$export$2e2bcd8739ae039 = $00683ba6c52d5435$var$DatePicker;

});


parcelRegister("fkh8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbd2b423b4bc9ae0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $57raR = parcelRequire("57raR");
var $dBLX0 = parcelRequire("dBLX0");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $cK9J2 = parcelRequire("cK9J2");

var $kVcjU = parcelRequire("kVcjU");
var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $icQS1 = parcelRequire("icQS1");

var $kdGko = parcelRequire("kdGko");

var $5PwWU = parcelRequire("5PwWU");

var $7OE9J = parcelRequire("7OE9J");
const $bbd2b423b4bc9ae0$var$packageName = "platform-pkg";
const $bbd2b423b4bc9ae0$var$packageVersion = "0.0.0-use.local";
const $bbd2b423b4bc9ae0$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $bbd2b423b4bc9ae0$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $bbd2b423b4bc9ae0$var$packageName,
    packageVersion: $bbd2b423b4bc9ae0$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $bbd2b423b4bc9ae0$var$TimePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $3Vuhz.default), onChange: providedOnChange = (0, $3Vuhz.default), onFocus: providedOnFocus = (0, $3Vuhz.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $kdGko.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $RoXqn.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $eJOHy.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $eJOHy.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const [value, setValue] = (0, $eJOHy.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$bbd2b423b4bc9ae0$var$analyticsAttributes
    });
    (0, $eJOHy.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $eJOHy.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $RoXqn.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $57raR.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $cK9J2.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $kVcjU.default) : (0, $c4OV1.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $RoXqn.defaultTimeFormat));
        const date = (0, $kdGko.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $dBLX0.default)(date)) return time;
        if (timeFormat) return (0, $57raR.default)(date, (0, $5PwWU.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $7OE9J.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $RoXqn.EmptyComponent),
        Menu: (0, $icQS1.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $RoXqn.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$bbd2b423b4bc9ae0$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $RoXqn.placeholderDatetime)),
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $bbd2b423b4bc9ae0$export$2e2bcd8739ae039 = $bbd2b423b4bc9ae0$var$TimePicker;

});
parcelRegister("icQS1", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $c710cd93a504ed53$export$982ad994195b4356);
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $7G7nX = parcelRequire("7G7nX");
const $c710cd93a504ed53$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7G7nX.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});

parcelRegister("kdGko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f14a3d51f762a0dc$export$2e2bcd8739ae039);
const $f14a3d51f762a0dc$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $f14a3d51f762a0dc$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $f14a3d51f762a0dc$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $f14a3d51f762a0dc$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $f14a3d51f762a0dc$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $f14a3d51f762a0dc$var$map24[hour];
    return hour;
}
function $f14a3d51f762a0dc$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $f14a3d51f762a0dc$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $f14a3d51f762a0dc$var$formatSemi24(timeArray[0].trim());
    const hour = $f14a3d51f762a0dc$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $f14a3d51f762a0dc$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $f14a3d51f762a0dc$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $f14a3d51f762a0dc$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $f14a3d51f762a0dc$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$f14a3d51f762a0dc$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $f14a3d51f762a0dc$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $f14a3d51f762a0dc$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $f14a3d51f762a0dc$var$assignToDate(time2);
}

});


parcelRegister("igoRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfac6f159c013af7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $cfac6f159c013af7$export$2e2bcd8739ae039 = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];

});

parcelRegister("9jzsQ", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeToISO", () => $580fa2fd07885202$export$c3b7bf9ddc221a4f);
$parcel$export(module.exports, "parseDateValue", () => $580fa2fd07885202$export$220ff045e4b830ec);
$parcel$export(module.exports, "parseTimeValue", () => $580fa2fd07885202$export$beddb17599b4a110);
$parcel$export(module.exports, "getTimePlaceholder", () => $580fa2fd07885202$export$c7659888e054d16a);

var $57raR = parcelRequire("57raR");

var $fTjQo = parcelRequire("fTjQo");

var $dBLX0 = parcelRequire("dBLX0");

var $cT05m = parcelRequire("cT05m");

var $kQ82p = parcelRequire("kQ82p");

var $cK9J2 = parcelRequire("cK9J2");
/**
 * Format used by atlaskit datepicker
 */ const $580fa2fd07885202$var$DATE_FORMAT = 'yyyy-MM-dd';
const $580fa2fd07885202$export$c4e1e4e065ff5bd8 = 'HH:mm';
const $580fa2fd07885202$export$c3b7bf9ddc221a4f = (date, time)=>{
    const parsedDate = (0, $cT05m.default)(`${date} ${time}`, `${$580fa2fd07885202$var$DATE_FORMAT} ${$580fa2fd07885202$export$c4e1e4e065ff5bd8}`, new Date());
    if (!(0, $dBLX0.default)(parsedDate)) return '';
    return (0, $fTjQo.default)(parsedDate);
};
const $580fa2fd07885202$export$220ff045e4b830ec = (date)=>{
    if (!(0, $dBLX0.default)((0, $kQ82p.default)(date))) return '';
    return (0, $57raR.default)(new Date(date), $580fa2fd07885202$var$DATE_FORMAT);
};
const $580fa2fd07885202$export$beddb17599b4a110 = (date)=>{
    if (!(0, $dBLX0.default)((0, $kQ82p.default)(date))) return '';
    return (0, $57raR.default)(new Date(date), $580fa2fd07885202$export$c4e1e4e065ff5bd8);
};
const $580fa2fd07885202$export$c7659888e054d16a = (time, locale)=>{
    const { formatTime: formatTime } = (0, $cK9J2.createLocalizationProvider)(locale);
    const parsedDate = (0, $cT05m.default)(time, `${$580fa2fd07885202$export$c4e1e4e065ff5bd8}`, new Date());
    if (!(0, $dBLX0.default)(parsedDate)) return time;
    return formatTime(parsedDate);
};

});


parcelRegister("fWxQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc63606e62f0b45$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9cc63606e62f0b45$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    and: {
        "id": "jql-builder-basic-datetime.between-date-time.and",
        "defaultMessage": "and"
    },
    startDateLabel: {
        "id": "jql-builder-basic-datetime.between-date-time.start-date-label",
        "defaultMessage": "Choose a start date"
    },
    endDateLabel: {
        "id": "jql-builder-basic-datetime.between-date-time.end-date-label",
        "defaultMessage": "Choose an end date"
    },
    startTimeLabel: {
        "id": "jql-builder-basic-datetime.between-date-time.start-time-label",
        "defaultMessage": "Choose a start time"
    },
    endTimeLabel: {
        "id": "jql-builder-basic-datetime.between-date-time.end-time-label",
        "defaultMessage": "Choose an end time"
    }
});

});


parcelRegister("lRsB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2518732b1b92a456$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");

var $iUa8i = parcelRequire("iUa8i");

var $cK9J2 = parcelRequire("cK9J2");

var $lRq8t = parcelRequire("lRq8t");

var $iw2hI = parcelRequire("iw2hI");

var $2cfd4 = parcelRequire("2cfd4");

var $bXrXb = parcelRequire("bXrXb");

var $daQnM = parcelRequire("daQnM");
const $2518732b1b92a456$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $2518732b1b92a456$var$isDateValueInvalid = (value)=>!(0, $dBLX0.default)((0, $kQ82p.default)(value)) && value !== '';
const $2518732b1b92a456$var$BetweenDates = ({ value: { value1: value1, value2: value2 }, onChange: onChange })=>{
    const locale = (0, $2cfd4.useLocale)();
    const standardizedLocale = (0, $iw2hI.standardizeLocale)(locale);
    const [localizationProvider] = (0, $eJOHy.useState)((0, $cK9J2.createLocalizationProvider)(standardizedLocale));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChangeValue1Date = (0, $eJOHy.useCallback)((value)=>{
        onChange({
            value1: value,
            value2: value2
        });
    }, [
        onChange,
        value2
    ]);
    const onChangeValue2Date = (0, $eJOHy.useCallback)((value)=>{
        onChange({
            value1: value1,
            value2: value
        });
    }, [
        onChange,
        value1
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.StyledRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.ChildWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iUa8i.default), {
        id: "value1",
        locale: standardizedLocale,
        onChange: onChangeValue1Date,
        isInvalid: $2518732b1b92a456$var$isDateValueInvalid(value1),
        value: !$2518732b1b92a456$var$isDateValueInvalid(value1) ? value1 : '',
        spacing: "compact",
        testId: "jql-builder-basic-datetime.ui.between-dates.value-1",
        label: formatMessage((0, $daQnM.default).startDateLabel),
        placeholder: localizationProvider.formatDate(new Date(new Date().getTime() - $2518732b1b92a456$var$ONE_DAY_IN_MILLISECONDS)),
        shouldShowCalendarButton: true,
        inputLabel: formatMessage((0, $daQnM.default).startDateLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.FixedChildWrapper), null, formatMessage((0, $daQnM.default).and)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.ChildWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iUa8i.default), {
        id: "value2",
        locale: standardizedLocale,
        isInvalid: $2518732b1b92a456$var$isDateValueInvalid(value2),
        onChange: onChangeValue2Date,
        value: !$2518732b1b92a456$var$isDateValueInvalid(value2) ? value2 : '',
        spacing: "compact",
        testId: "jql-builder-basic-datetime.ui.between-dates.value-2",
        label: formatMessage((0, $daQnM.default).endDateLabel),
        placeholder: localizationProvider.formatDate(new Date(new Date().getTime() + $2518732b1b92a456$var$ONE_DAY_IN_MILLISECONDS)),
        shouldShowCalendarButton: true,
        inputLabel: formatMessage((0, $daQnM.default).endDateLabel)
    })));
};
var $2518732b1b92a456$export$2e2bcd8739ae039 = $2518732b1b92a456$var$BetweenDates;

});
parcelRegister("bXrXb", function(module, exports) {

$parcel$export(module.exports, "StyledRow", () => $96f2d0560712ebd9$export$81761b52b04ea573);
$parcel$export(module.exports, "ChildWrapper", () => $96f2d0560712ebd9$export$87c2de9f2249ec47);
$parcel$export(module.exports, "FixedChildWrapper", () => $96f2d0560712ebd9$export$c11f358d1515ce8d);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $96f2d0560712ebd9$export$81761b52b04ea573 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _1e0c1txw _18u01ejb _19pk12x7 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $96f2d0560712ebd9$export$87c2de9f2249ec47 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $96f2d0560712ebd9$export$c11f358d1515ce8d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("daQnM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e42384888a6a453$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1e42384888a6a453$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    and: {
        "id": "jql-builder-basic-datetime.between-dates.and",
        "defaultMessage": "and"
    },
    startDateLabel: {
        "id": "jql-builder-basic-datetime.between-dates.start-date-label",
        "defaultMessage": "Choose a start date"
    },
    endDateLabel: {
        "id": "jql-builder-basic-datetime.between-dates.end-date-label",
        "defaultMessage": "Choose an end date"
    }
});

});


parcelRegister("cKrbS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6725246d07ad04a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $sY9BV = parcelRequire("sY9BV");

var $lRq8t = parcelRequire("lRq8t");

var $bXrXb = parcelRequire("bXrXb");

var $8keuW = parcelRequire("8keuW");
const $a6725246d07ad04a$var$InRangeOf = ({ value: { value1: value1 = '', value2: value2 = '' }, onChange: onChange, isInvalid: isInvalid })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChangeValue1Date = (0, $eJOHy.useCallback)((event)=>{
        onChange({
            value1: event.currentTarget.value,
            value2: value2
        });
    }, [
        onChange,
        value2
    ]);
    const onChangeValue2Date = (0, $eJOHy.useCallback)((event)=>{
        onChange({
            value1: value1,
            value2: event.currentTarget.value
        });
    }, [
        onChange,
        value1
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.StyledRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.ChildWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        isInvalid: isInvalid,
        name: "value1",
        onChange: onChangeValue1Date,
        value: value1,
        placeholder: "-3w 4d 12h 30m",
        isCompact: true,
        autoComplete: "off",
        testId: "jql-builder-basic-datetime.ui.in-range-of-time.input-1",
        "aria-label": formatMessage((0, $8keuW.default).startTimeRangeLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.FixedChildWrapper), null, formatMessage((0, $8keuW.default).to)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.ChildWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        isInvalid: isInvalid,
        name: "value2",
        onChange: onChangeValue2Date,
        value: value2,
        placeholder: "3w 4d 12h 30m",
        isCompact: true,
        autoComplete: "off",
        testId: "jql-builder-basic-datetime.ui.in-range-of-time.input-2",
        "aria-label": formatMessage((0, $8keuW.default).endTimeRangeLabel)
    })));
};
var $a6725246d07ad04a$export$2e2bcd8739ae039 = $a6725246d07ad04a$var$InRangeOf;

});
parcelRegister("8keuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $efb47076830e1c3d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $efb47076830e1c3d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    to: {
        "id": "jql-builder-basic-datetime.in-range-of-time.to",
        "defaultMessage": "to"
    },
    startTimeRangeLabel: {
        "id": "jql-builder-basic-datetime.in-range-of-time.start-time-range-label",
        "defaultMessage": "Enter start of the time range e.g weeks, days, hours and/or minutes"
    },
    endTimeRangeLabel: {
        "id": "jql-builder-basic-datetime.in-range-of-time.end-time-range-label",
        "defaultMessage": "Enter end of the time range"
    }
});

});


parcelRegister("kgmJM", function(module, exports) {

$parcel$export(module.exports, "Radio", () => $73c2433e8d2410fc$export$d7b12c4107be0d61);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $73c2433e8d2410fc$var$Label = ({ htmlFor: htmlFor, children: children, testId: testId, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73c2433e8d2410fc$export$eea83358d9434634, {
        htmlFor: htmlFor,
        "data-testid": testId,
        ...props
    }, children);
let $73c2433e8d2410fc$var$controlId = 0;
const $73c2433e8d2410fc$export$d7b12c4107be0d61 = ({ children: children, testId: testId, ...props })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    $73c2433e8d2410fc$var$controlId += 1;
    const id = `jql-builder-basic-datetime-dialog-radio-${$73c2433e8d2410fc$var$controlId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73c2433e8d2410fc$var$Label, {
        htmlFor: id,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73c2433e8d2410fc$export$a195049fd73b3fe2, {
        type: "radio",
        id: id,
        ...props
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, children));
};
const $73c2433e8d2410fc$export$eea83358d9434634 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _24rc1b66",
            __cmplp.className
        ])
    });
});
const $73c2433e8d2410fc$export$a195049fd73b3fe2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkze3t _2hwx1b66 _otyrze3t _18u01b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fTjd1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6600bfb42c2d20b7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $c4OV1 = parcelRequire("c4OV1");

var $sY9BV = parcelRequire("sY9BV");

var $lRq8t = parcelRequire("lRq8t");

var $e2kjR = parcelRequire("e2kjR");

var $34QWT = parcelRequire("34QWT");

var $bXrXb = parcelRequire("bXrXb");

var $9oqiU = parcelRequire("9oqiU");
const $6600bfb42c2d20b7$var$TimeInput = ({ value: { value1: value1, value2: value2, excludeOverdue: excludeOverdue }, onChange: onChange, typeConfig: { endLabel: endLabel, overduePicker: overduePicker }, isInvalid: isInvalid })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [overdueOptions] = (0, $eJOHy.useState)([
        {
            label: formatMessage((0, $9oqiU.default).labelOrIs),
            value: 'or-is'
        },
        {
            label: formatMessage((0, $9oqiU.default).labelAndNot),
            value: 'and-not'
        }
    ]);
    const [options] = (0, $eJOHy.useState)(Object.entries((0, $e2kjR.TimeUnits)).map(([value, timeUnit])=>{
        const messageDescriptor = (0, $9oqiU.messageLookup)[`${timeUnit}${endLabel || ''}`];
        return {
            label: messageDescriptor ? formatMessage(messageDescriptor) : '',
            value: value
        };
    }));
    (0, $eJOHy.useEffect)(()=>{
        if (value2 === '') {
            const value = {
                value1: value1,
                value2: Object.keys((0, $e2kjR.TimeUnits))[0]
            };
            if (overduePicker !== undefined && overduePicker === true) value.excludeOverdue = excludeOverdue;
            onChange(value);
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onChangeValue1 = (0, $eJOHy.useCallback)((event)=>{
        const value = {
            value1: event.currentTarget.value,
            value2: value2
        };
        if (overduePicker !== undefined && overduePicker === true) value.excludeOverdue = excludeOverdue;
        onChange(value);
    }, [
        value2,
        overduePicker,
        onChange,
        excludeOverdue
    ]);
    const onChangeValue2 = (0, $eJOHy.useCallback)((optionValue)=>{
        if (!optionValue) return;
        const value = {
            value1: value1,
            value2: optionValue.value
        };
        if (overduePicker !== undefined && overduePicker === true) value.excludeOverdue = excludeOverdue;
        onChange(value);
    }, [
        excludeOverdue,
        onChange,
        overduePicker,
        value1
    ]);
    const onChangeExcludeOverdue = (0, $eJOHy.useCallback)((value)=>{
        if (!value) return;
        onChange({
            value1: value1,
            value2: value2,
            excludeOverdue: value.value === overdueOptions[1].value
        });
    }, [
        onChange,
        overdueOptions,
        value1,
        value2
    ]);
    const optionValue2 = options.find((o)=>o.value === value2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.StyledRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6600bfb42c2d20b7$var$InputWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        isInvalid: isInvalid,
        name: "value1",
        onChange: onChangeValue1,
        value: value1,
        isCompact: true,
        autoComplete: "off",
        testId: "jql-builder-basic-datetime.ui.time-input.input",
        "aria-label": formatMessage((0, $9oqiU.default).timeInputLabel, {
            timeUnit: optionValue2?.label
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6600bfb42c2d20b7$var$ChildWrapper, {
        overduePicker: overduePicker
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        value: optionValue2,
        "aria-label": formatMessage((0, $9oqiU.default).labelTimeUnit),
        onChange: onChangeValue2,
        name: "value2",
        options: options,
        spacing: "compact",
        components: (0, $34QWT.default),
        styles: {
            singleValue: (base)=>({
                    ...base,
                    minWidth: 'fit-content'
                })
        },
        testId: "jql-builder-basic-datetime.ui.time-input.time-units-select"
    })), overduePicker !== undefined && overduePicker === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6600bfb42c2d20b7$var$ChildWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        value: excludeOverdue === true ? overdueOptions[1] : overdueOptions[0],
        onChange: onChangeExcludeOverdue,
        name: "excludeOverdue",
        options: overdueOptions,
        spacing: "compact",
        components: (0, $34QWT.default),
        styles: {
            singleValue: (base)=>({
                    ...base,
                    minWidth: 'fit-content'
                })
        },
        testId: "jql-builder-basic-datetime.ui.time-input.overdue-select",
        "aria-label": formatMessage((0, $9oqiU.default).labelTimeStatus)
    })));
};
var $6600bfb42c2d20b7$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
 = $6600bfb42c2d20b7$var$TimeInput;
const $6600bfb42c2d20b7$var$InputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug _1ul9t9kd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $6600bfb42c2d20b7$var$ChildWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { overduePicker: overduePicker, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug",
            __cmplp.overduePicker ? "_1ul916xz" : "_1ul91llu",
            __cmplp.className
        ])
    });
});

});
parcelRegister("34QWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7cb0b06df59e80$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");
const $7b7cb0b06df59e80$var$Control = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": `${rest.selectProps.testId}--control`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Control, rest, children));
const $7b7cb0b06df59e80$var$Option = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": `${rest.selectProps.testId}--option`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, rest, children));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b7cb0b06df59e80$export$2e2bcd8739ae039 = {
    Control: $7b7cb0b06df59e80$var$Control,
    Option: $7b7cb0b06df59e80$var$Option
};

});

parcelRegister("9oqiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $1daf1c57a51bef8b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "messageLookup", () => $1daf1c57a51bef8b$export$3a16bd55b6aaaf91);

var $7qGN1 = parcelRequire("7qGN1");
const $1daf1c57a51bef8b$var$messages = (0, $7qGN1.defineMessages)({
    minutes: {
        "id": "jql-builder-basic-datetime.time-input.minutes",
        "defaultMessage": "minutes"
    },
    hours: {
        "id": "jql-builder-basic-datetime.time-input.hours",
        "defaultMessage": "hours"
    },
    days: {
        "id": "jql-builder-basic-datetime.time-input.days",
        "defaultMessage": "days"
    },
    weeks: {
        "id": "jql-builder-basic-datetime.time-input.weeks",
        "defaultMessage": "weeks"
    },
    months: {
        "id": "jql-builder-basic-datetime.time-input.months",
        "defaultMessage": "months"
    },
    years: {
        "id": "jql-builder-basic-datetime.time-input.years",
        "defaultMessage": "years"
    },
    minutesAgo: {
        "id": "jql-builder-basic-datetime.time-input.minutes-ago",
        "defaultMessage": "minutes ago"
    },
    hoursAgo: {
        "id": "jql-builder-basic-datetime.time-input.hours-ago",
        "defaultMessage": "hours ago"
    },
    daysAgo: {
        "id": "jql-builder-basic-datetime.time-input.days-ago",
        "defaultMessage": "days ago"
    },
    weeksAgo: {
        "id": "jql-builder-basic-datetime.time-input.weeks-ago",
        "defaultMessage": "weeks ago"
    },
    monthsAgo: {
        "id": "jql-builder-basic-datetime.time-input.months-ago",
        "defaultMessage": "months ago"
    },
    yearsAgo: {
        "id": "jql-builder-basic-datetime.time-input.years-ago",
        "defaultMessage": "years ago"
    },
    minutesOverdue: {
        "id": "jql-builder-basic-datetime.time-input.minutes-overdue",
        "defaultMessage": "minutes overdue"
    },
    hoursOverdue: {
        "id": "jql-builder-basic-datetime.time-input.hours-overdue",
        "defaultMessage": "hours overdue"
    },
    daysOverdue: {
        "id": "jql-builder-basic-datetime.time-input.days-overdue",
        "defaultMessage": "days overdue"
    },
    weeksOverdue: {
        "id": "jql-builder-basic-datetime.time-input.weeks-overdue",
        "defaultMessage": "weeks overdue"
    },
    monthsOverdue: {
        "id": "jql-builder-basic-datetime.time-input.months-overdue",
        "defaultMessage": "months overdue"
    },
    yearsOverdue: {
        "id": "jql-builder-basic-datetime.time-input.years-overdue",
        "defaultMessage": "years overdue"
    },
    labelOrIs: {
        "id": "jql-builder-basic-datetime.time-input.label-or-is",
        "defaultMessage": "or is overdue"
    },
    labelAndNot: {
        "id": "jql-builder-basic-datetime.time-input.label-and-not",
        "defaultMessage": "and not overdue"
    },
    labelTimeUnit: {
        "id": "jql-builder-basic-datetime.time-input.label-time-unit",
        "defaultMessage": "Select unit of time"
    },
    labelTimeStatus: {
        "id": "jql-builder-basic-datetime.time-input.label-time-status",
        "defaultMessage": "Select status"
    },
    timeInputLabel: {
        "id": "jql-builder-basic-datetime.time-input.time-input-label",
        "defaultMessage": "Enter a number of {timeUnit}"
    }
});
var $1daf1c57a51bef8b$export$2e2bcd8739ae039 = $1daf1c57a51bef8b$var$messages;
const $1daf1c57a51bef8b$export$3a16bd55b6aaaf91 = $1daf1c57a51bef8b$var$messages;

});


parcelRegister("3QrSv", function(module, exports) {

$parcel$export(module.exports, "DueDateTypeConfig", () => $566d9bbc72d35ccb$export$e089c311056e8386);
$parcel$export(module.exports, "DateTypeConfig", () => $566d9bbc72d35ccb$export$6643317b16cfbee9);
$parcel$export(module.exports, "DateTimeTypeConfig", () => $566d9bbc72d35ccb$export$5ff2b2d5b16ed369);

var $5YOs6 = parcelRequire("5YOs6");

var $4iNk4 = parcelRequire("4iNk4");

var $TNurX = parcelRequire("TNurX");

var $jp05X = parcelRequire("jp05X");

var $hLFTi = parcelRequire("hLFTi");

var $bgS1B = parcelRequire("bgS1B");

var $fxONR = parcelRequire("fxONR");
const $566d9bbc72d35ccb$export$e089c311056e8386 = [
    (0, $bgS1B.NOW_OVERDUE_CONFIG),
    (0, $hLFTi.MORE_THAN_CONFIG),
    (0, $TNurX.DUE_IN_NEXT_CONFIG),
    (0, $5YOs6.BETWEEN_CONFIG),
    (0, $jp05X.IN_RANGE_CONFIG)
];
const $566d9bbc72d35ccb$export$6643317b16cfbee9 = [
    (0, $fxONR.WITHIN_THE_LAST_CONFIG),
    (0, $hLFTi.CONFIG_DATE_MORE_THAN),
    (0, $5YOs6.BETWEEN_CONFIG),
    (0, $jp05X.IN_RANGE_CONFIG)
];
const $566d9bbc72d35ccb$export$5ff2b2d5b16ed369 = [
    (0, $fxONR.WITHIN_THE_LAST_CONFIG),
    (0, $hLFTi.CONFIG_DATE_MORE_THAN),
    (0, $4iNk4.BETWEEN_DATE_TIME_CONFIG),
    (0, $jp05X.IN_RANGE_CONFIG)
];

});
parcelRegister("5YOs6", function(module, exports) {

$parcel$export(module.exports, "BETWEEN_CONFIG", () => $f10da1fb7b2d5710$export$76f00c4fd9a48d7b);

var $dBLX0 = parcelRequire("dBLX0");

var $jPlb3 = parcelRequire("jPlb3");

var $73DRj = parcelRequire("73DRj");

var $iE7P0 = parcelRequire("iE7P0");
const $f10da1fb7b2d5710$export$76f00c4fd9a48d7b = {
    type: 'between',
    componentType: 'between',
    label: 'labelBetween',
    hasInput: true,
    getErrorMessage: (intl, value)=>{
        if (value?.value1 && value?.value2 && new Date(value?.value1) > new Date(value?.value2)) return intl.formatMessage((0, $73DRj.default).validationMessageBeforeGreaterThanAfter);
        if (value && (value?.value1 !== '' && !(0, $dBLX0.default)(new Date(value?.value1)) || value?.value2 !== '' && !(0, $dBLX0.default)(new Date(value?.value2)))) return intl.formatMessage((0, $73DRj.default).validationMessageInvalidDateFormat);
        return undefined;
    },
    getFormattedValue: (intl, value)=>{
        // Format Date based on 'UTC' because `new Date()` uses UTC when no timezone present, and JQL dates never have a timezone
        // JRACLOUD-79698: Without this, users west of UTC will see the dates off-by-one in the UI
        const formatOptions = {
            timeZone: 'UTC'
        };
        if (value) {
            if (value.value1 && value.value2) {
                if ((0, $dBLX0.default)(new Date(value.value1)) && (0, $dBLX0.default)(new Date(value.value2))) return `${intl.formatDate(new Date(value.value1), formatOptions)} - ${intl.formatDate(new Date(value.value2), formatOptions)}`;
            } else if (value.value1 && (0, $dBLX0.default)(new Date(value.value1)) || value.value2 && (0, $dBLX0.default)(new Date(value.value2))) {
                const valueToformat = value.value1 || value.value2;
                return intl.formatDate(new Date(valueToformat), formatOptions);
            }
        }
        return '';
    },
    getJqlData: ({ value1: value1, value2: value2 } = {})=>({
            primaryClause: value1 ? {
                operator: (0, $jPlb3.OPERATOR_GT_EQUALS),
                operand: `${value1}`
            } : undefined,
            secondaryClause: value2 ? {
                operator: (0, $jPlb3.OPERATOR_LT_EQUALS),
                operand: `${value2}`
            } : undefined
        }),
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause === undefined && secondaryClause === undefined) // Do not match type if both clauses are not present
            return undefined;
            if (primaryClause !== undefined || secondaryClause !== undefined) {
                const returnValue = {
                    value1: '',
                    value2: ''
                };
                [
                    primaryClause,
                    secondaryClause
                ].forEach((clause)=>{
                    if (clause) {
                        const operatorValue = clause.operator ? clause.operator : '';
                        const value = clause.operand !== undefined ? clause.operand : '';
                        switch(operatorValue){
                            case 0, $jPlb3.OPERATOR_GT_EQUALS:
                                if (value.match((0, $iE7P0.IS_YYYY_MM_DD_REGEX))) returnValue.value1 = value;
                                break;
                            case 0, $jPlb3.OPERATOR_LT_EQUALS:
                                if (value.match((0, $iE7P0.IS_YYYY_MM_DD_REGEX))) returnValue.value2 = value;
                                break;
                            default:
                                break;
                        }
                    }
                });
                if (returnValue.value1 || returnValue.value2) return returnValue;
            }
            return undefined;
        }
        return undefined;
    }
};

});
parcelRegister("73DRj", function(module, exports) {

$parcel$export(module.exports, "default", () => $effee99c41ec7377$export$2e2bcd8739ae039);
$parcel$export(module.exports, "messageLookup", () => $effee99c41ec7377$export$3a16bd55b6aaaf91);

var $7qGN1 = parcelRequire("7qGN1");
const $effee99c41ec7377$var$messages = (0, $7qGN1.defineMessages)({
    updateButtonText: {
        "id": "jql-builder-basic-datetime.utils.update-button-text",
        "defaultMessage": "Update"
    },
    legendText: {
        "id": "jql-builder-basic-datetime.utils.legend-text",
        "defaultMessage": "{fieldLabel} issues by date and time"
    },
    labelNowOverdue: {
        "id": "jql-builder-basic-datetime.utils.label-now-overdue",
        "defaultMessage": "Now overdue"
    },
    valueNowOverdue: {
        "id": "jql-builder-basic-datetime.utils.value-now-overdue",
        "defaultMessage": "Now overdue"
    },
    labelMoreThan: {
        "id": "jql-builder-basic-datetime.utils.label-more-than",
        "defaultMessage": "More than"
    },
    valueMoreThanMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-more-than-minutes",
        "defaultMessage": "More than {dateNumber, plural, =0 {now} one {# minute ago} other {# minutes ago}}"
    },
    valueMoreThanHours: {
        "id": "jql-builder-basic-datetime.utils.value-more-than-hours",
        "defaultMessage": "More than {dateNumber, plural, =0 {now} one {# hour ago} other {# hours ago}}"
    },
    valueMoreThanDays: {
        "id": "jql-builder-basic-datetime.utils.value-more-than-days",
        "defaultMessage": "More than {dateNumber, plural, =0 {now} one {# day ago} other {# days ago}}"
    },
    valueMoreThanWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-more-than-weeks",
        "defaultMessage": "More than {dateNumber, plural, =0 {now} one {# week ago} other {# weeks ago}}"
    },
    labelDueInNext: {
        "id": "jql-builder-basic-datetime.utils.label-due-in-next",
        "defaultMessage": "Due in next"
    },
    valueDueInNextExcludeOverdueMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-minutes",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}}"
    },
    valueDueInNextExcludeOverdueHours: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-hours",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 hours} one {# hour} other {# hours}}"
    },
    valueDueInNextExcludeOverdueDays: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-days",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 days} one {# day} other {# days}}"
    },
    valueDueInNextExcludeOverdueWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-weeks",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 weeks} one {# week} other {# weeks}}"
    },
    valueDueInNextMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-minutes",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}} or is overdue"
    },
    valueDueInNextHours: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-hours",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 hours} one {# hour} other {# hours}} or is overdue"
    },
    valueDueInNextDays: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-days",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 days} one {# day} other {# days}} or is overdue"
    },
    valueDueInNextWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-weeks",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 weeks} one {# week} other {# weeks}} or is overdue"
    },
    labelBetween: {
        "id": "jql-builder-basic-datetime.utils.label-between",
        "defaultMessage": "Between"
    },
    labelInRange: {
        "id": "jql-builder-basic-datetime.utils.label-in-range",
        "defaultMessage": "In the range"
    },
    valueInRange: {
        "id": "jql-builder-basic-datetime.utils.value-in-range",
        "defaultMessage": "From {start} to {end}"
    },
    valueInRangeBeforeNowToAfterNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-before-now-to-after-now",
        "defaultMessage": "From {beforeTime} ago to {afterTime} from now"
    },
    valueInRangeBeforeNowToBeforeNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-before-now-to-before-now",
        "defaultMessage": "From {beforeTime} ago to {afterTime} ago"
    },
    valueInRangeAfterNowToAfterNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-after-now-to-after-now",
        "defaultMessage": "From {beforeTime} from now to {afterTime} from now"
    },
    valueInRangeBeforeNowToBlank: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-before-now-to-blank",
        "defaultMessage": "From {beforeTime} ago"
    },
    valueInRangeAfterNowToBlank: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-after-now-to-blank",
        "defaultMessage": "From {beforeTime} from now"
    },
    valueInRangeBlankToBeforeNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-blank-to-before-now",
        "defaultMessage": "Up to {afterTime} ago"
    },
    valueInRangeBlankToAfterNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-blank-to-after-now",
        "defaultMessage": "Up to {afterTime} from now"
    },
    labelIsNotSet: {
        "id": "jql-builder-basic-datetime.utils.label-is-not-set",
        "defaultMessage": "is empty"
    },
    labelWithinTheLast: {
        "id": "jql-builder-basic-datetime.utils.label-within-the-last",
        "defaultMessage": "Within the last"
    },
    valueWithinTheLastMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-within-the-last-minutes",
        "defaultMessage": "Within the last {dateNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}}"
    },
    valueWithinTheLastHours: {
        "id": "jql-builder-basic-datetime.utils.value-within-the-last-hours",
        "defaultMessage": "Within the last {dateNumber, plural, =0 {0 hours} one {# hour} other {# hours}}"
    },
    valueWithinTheLastDays: {
        "id": "jql-builder-basic-datetime.utils.value-within-the-last-days",
        "defaultMessage": "Within the last {dateNumber, plural, =0 {0 days} one {# day} other {# days}}"
    },
    valueWithinTheLastWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-within-the-last-weeks",
        "defaultMessage": "Within the last {dateNumber, plural, =0 {0 weeks} one {# week} other {# weeks}}"
    },
    valueTimeInWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-time-in-weeks",
        "defaultMessage": "{timeNumber, plural, =0 {0 weeks} one {# week} other {# weeks}}"
    },
    valueTimeInDays: {
        "id": "jql-builder-basic-datetime.utils.value-time-in-days",
        "defaultMessage": "{timeNumber, plural, =0 {0 days} one {# day} other {# days}}"
    },
    valueTimeInHours: {
        "id": "jql-builder-basic-datetime.utils.value-time-in-hours",
        "defaultMessage": "{timeNumber, plural, =0 {0 hours} one {# hour} other {# hours}}"
    },
    valueTimeInMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-time-in-minutes",
        "defaultMessage": "{timeNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}}"
    },
    validationMessageInvalidPeriodFormat: {
        "id": "jql-builder-basic-datetime.utils.validation-message-invalid-period-format",
        "defaultMessage": "Enter a valid number"
    },
    validationMessageBeforeGreaterThanAfter: {
        "id": "jql-builder-basic-datetime.utils.validation-message-before-greater-than-after",
        "defaultMessage": "'Before' field cannot be later than 'After' field."
    },
    validationMessageFromGreaterThanTo: {
        "id": "jql-builder-basic-datetime.utils.validation-message-from-greater-than-to",
        "defaultMessage": "'From' field cannot be later than 'To' field."
    },
    validationMessageInvalidDateFormat: {
        "id": "jql-builder-basic-datetime.utils.validation-message-invalid-date-format",
        "defaultMessage": "Invalid date format."
    },
    validationMessageInvalidPeriodFormatValue: {
        "id": "jql-builder-basic-datetime.utils.validation-message-invalid-period-format-value",
        "defaultMessage": "Invalid period format. Please enter the period in the format \"3w 4d 5h 6m\"."
    },
    legendTextIssueTerminologyRefreshM4: {
        "id": "jql-builder-basic-datetime.utils.legend-text-issue-terminology-refresh-m4",
        "defaultMessage": "{fieldLabel} work items by date and time"
    }
});
var $effee99c41ec7377$export$2e2bcd8739ae039 = $effee99c41ec7377$var$messages;
const $effee99c41ec7377$export$3a16bd55b6aaaf91 = $effee99c41ec7377$var$messages;

});

parcelRegister("iE7P0", function(module, exports) {

$parcel$export(module.exports, "IS_YYYY_MM_DD_REGEX", () => $daa50c52dd369c58$export$f1b1463eb20d9130);
$parcel$export(module.exports, "getTimeInfo", () => $daa50c52dd369c58$export$5c5047d260d2b2e4);
$parcel$export(module.exports, "getTimeString", () => $daa50c52dd369c58$export$da876ebe5870f49a);
$parcel$export(module.exports, "getTimeInMinutes", () => $daa50c52dd369c58$export$99ba9a356555dbdf);
$parcel$export(module.exports, "isValidTimePeriodFormat", () => $daa50c52dd369c58$export$2214112898027187);

var $73DRj = parcelRequire("73DRj");
const $daa50c52dd369c58$var$periodRegexp = /^(?!$)(?<sign>(^-))?((?<weeks>\d+)w)? ?((?<days>\d+)d)? ?((?<hours>\d+)h)? ?((?<minutes>\d+)m)*$/;
const $daa50c52dd369c58$export$f1b1463eb20d9130 = /[1-9][0-9]{3}([-][0-9]{2}){2}/;
const $daa50c52dd369c58$export$412dc06c06fbf003 = (timeString)=>{
    const weeksIndex = timeString.indexOf('w');
    const daysIndex = timeString.indexOf('d');
    const hoursIndex = timeString.indexOf('h');
    const minutesIndex = timeString.indexOf('m');
    if (weeksIndex > -1 && weeksIndex < timeString.length - 1 && timeString[weeksIndex + 1] !== ' ') return false;
    if (daysIndex > -1 && daysIndex < timeString.length - 1 && timeString[daysIndex + 1] !== ' ') return false;
    if (hoursIndex > -1 && hoursIndex < timeString.length - 1 && timeString[hoursIndex + 1] !== ' ') return false;
    if (minutesIndex > -1 && minutesIndex < timeString.length - 1 && timeString[minutesIndex + 1] !== ' ') return false;
    return true;
};
const $daa50c52dd369c58$export$5c5047d260d2b2e4 = (timeData)=>{
    if (timeData !== undefined) {
        const matches = timeData.match($daa50c52dd369c58$var$periodRegexp);
        if ($daa50c52dd369c58$var$periodRegexp.test(timeData) && $daa50c52dd369c58$export$412dc06c06fbf003(timeData) && matches && matches.groups) {
            const { sign: sign = '', weeks: weeks = '', days: days = '', hours: hours = '', minutes: minutes = '' } = matches.groups;
            const parsedWeeks = parseInt(weeks, 10);
            const parsedDays = parseInt(days, 10);
            const parsedHours = parseInt(hours, 10);
            const parsedMinute = parseInt(minutes, 10);
            return {
                isBeforeNow: sign === '-',
                minutes: Number.isNaN(parsedMinute) ? undefined : +parsedMinute,
                hours: Number.isNaN(parsedHours) ? undefined : +parsedHours,
                days: Number.isNaN(parsedDays) ? undefined : +parsedDays,
                weeks: Number.isNaN(parsedWeeks) ? undefined : +parsedWeeks,
                isValid: true
            };
        }
    }
    return {
        isBeforeNow: false,
        minutes: undefined,
        hours: undefined,
        days: undefined,
        weeks: undefined,
        isValid: false
    };
};
const $daa50c52dd369c58$export$da876ebe5870f49a = (intl, timeInfo)=>[
        timeInfo.weeks !== undefined ? intl.formatMessage((0, $73DRj.default).valueTimeInWeeks, {
            timeNumber: timeInfo.weeks
        }) : false,
        timeInfo.days !== undefined ? intl.formatMessage((0, $73DRj.default).valueTimeInDays, {
            timeNumber: timeInfo.days
        }) : false,
        timeInfo.hours !== undefined ? intl.formatMessage((0, $73DRj.default).valueTimeInHours, {
            timeNumber: timeInfo.hours
        }) : false,
        timeInfo.minutes !== undefined ? intl.formatMessage((0, $73DRj.default).valueTimeInMinutes, {
            timeNumber: timeInfo.minutes
        }) : false
    ].filter(Boolean).join(', ');
const $daa50c52dd369c58$export$99ba9a356555dbdf = (timeInfo)=>{
    if (timeInfo.isValid) return (timeInfo.isBeforeNow ? -1 : 1) * ((timeInfo.minutes !== undefined ? timeInfo.minutes : 0) + (timeInfo.hours !== undefined ? timeInfo.hours * 60 : 0) + (timeInfo.days !== undefined ? timeInfo.days * 1440 : 0) + (timeInfo.weeks !== undefined ? timeInfo.weeks * 10080 : 0));
    return 0;
};
const $daa50c52dd369c58$var$isNumeric = (value)=>/^\d+$/.test(value);
const $daa50c52dd369c58$export$2214112898027187 = (timeDigits, timeUnit)=>timeDigits === '' || timeDigits !== undefined && $daa50c52dd369c58$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && [
        'm',
        'h',
        'd',
        'w'
    ].includes(timeUnit ?? '');

});


parcelRegister("4iNk4", function(module, exports) {

$parcel$export(module.exports, "BETWEEN_DATE_TIME_CONFIG", () => $ea598d0e89b0c8ee$export$a553aad7ea821394);

var $57raR = parcelRequire("57raR");

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");

var $jPlb3 = parcelRequire("jPlb3");

var $73DRj = parcelRequire("73DRj");

var $iE7P0 = parcelRequire("iE7P0");
const $ea598d0e89b0c8ee$export$a553aad7ea821394 = {
    type: 'between_date_time',
    componentType: 'between_date_time',
    label: 'labelBetween',
    hasInput: true,
    getErrorMessage: (intl, value)=>{
        if (value?.value1 && value?.value2 && (0, $kQ82p.default)(value?.value1) > (0, $kQ82p.default)(value?.value2)) return intl.formatMessage((0, $73DRj.default).validationMessageBeforeGreaterThanAfter);
        if (value && (value?.value1 !== '' && !(0, $dBLX0.default)((0, $kQ82p.default)(value?.value1)) || value?.value2 !== '' && !(0, $dBLX0.default)((0, $kQ82p.default)(value?.value2)))) return intl.formatMessage((0, $73DRj.default).validationMessageInvalidDateFormat);
        return undefined;
    },
    getFormattedValue: (intl, value)=>{
        if (value) {
            if (value.value1 && value.value2) {
                const parsedValue1 = (0, $kQ82p.default)(value.value1);
                const parsedValue2 = (0, $kQ82p.default)(value.value2);
                if ((0, $dBLX0.default)(parsedValue1) && (0, $dBLX0.default)(parsedValue2)) return `${intl.formatDate(parsedValue1, {
                    dateStyle: 'short',
                    timeStyle: 'short'
                })} - ${intl.formatDate(parsedValue2, {
                    dateStyle: 'short',
                    timeStyle: 'short'
                })}`;
            } else if (value.value1 && (0, $dBLX0.default)((0, $kQ82p.default)(value.value1)) || value.value2 && (0, $dBLX0.default)((0, $kQ82p.default)(value.value2))) {
                const valueToformat = value.value1 || value.value2;
                return intl.formatDate((0, $kQ82p.default)(valueToformat), {
                    dateStyle: 'short',
                    timeStyle: 'short'
                });
            }
        }
        return '';
    },
    getJqlData: ({ value1: value1, value2: value2 } = {})=>{
        const formatValue = (value)=>{
            const parsedValue = (0, $kQ82p.default)(value);
            return (0, $dBLX0.default)(parsedValue) ? (0, $57raR.default)(parsedValue, 'yyyy-MM-dd HH:mm') : value;
        };
        return {
            primaryClause: value1 ? {
                operator: (0, $jPlb3.OPERATOR_GT_EQUALS),
                operand: formatValue(value1)
            } : undefined,
            secondaryClause: value2 ? {
                operator: (0, $jPlb3.OPERATOR_LT_EQUALS),
                operand: formatValue(value2)
            } : undefined
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause === undefined && secondaryClause === undefined) // Do not match type if both clauses are not present
            return undefined;
            if (primaryClause !== undefined || secondaryClause !== undefined) {
                const returnValue = {
                    value1: '',
                    value2: ''
                };
                [
                    primaryClause,
                    secondaryClause
                ].forEach((clause)=>{
                    if (clause) {
                        const operatorValue = clause.operator ? clause.operator : '';
                        const value = clause.operand !== undefined ? clause.operand : '';
                        switch(operatorValue){
                            case 0, $jPlb3.OPERATOR_GT_EQUALS:
                                if (value.match((0, $iE7P0.IS_YYYY_MM_DD_REGEX))) returnValue.value1 = value;
                                break;
                            case 0, $jPlb3.OPERATOR_LT_EQUALS:
                                if (value.match((0, $iE7P0.IS_YYYY_MM_DD_REGEX))) returnValue.value2 = value;
                                break;
                            default:
                                break;
                        }
                    }
                });
                if (returnValue.value1 || returnValue.value2) return returnValue;
            }
            return undefined;
        }
        return undefined;
    }
};

});

parcelRegister("TNurX", function(module, exports) {

$parcel$export(module.exports, "DUE_IN_NEXT_CONFIG", () => $59a3b15ec01e416d$export$f0be3f9139a88bf5);

var $jPlb3 = parcelRequire("jPlb3");

var $73DRj = parcelRequire("73DRj");

var $iE7P0 = parcelRequire("iE7P0");
const $59a3b15ec01e416d$export$f0be3f9139a88bf5 = {
    type: 'due_in_next',
    componentType: 'time_input',
    label: 'labelDueInNext',
    hasInput: true,
    getErrorMessage: (intl, value)=>(0, $iE7P0.isValidTimePeriodFormat)(value?.value1, value?.value2) ? undefined : intl.formatMessage((0, $73DRj.default).validationMessageInvalidPeriodFormat),
    getFormattedValue: (intl, value)=>{
        if (value !== undefined) {
            const { excludeOverdue: excludeOverdue = false } = value;
            switch(value.value2.toLowerCase()){
                case 'm':
                    return excludeOverdue ? intl.formatMessage((0, $73DRj.default).valueDueInNextExcludeOverdueMinutes, {
                        dateNumber: value.value1
                    }) : intl.formatMessage((0, $73DRj.default).valueDueInNextMinutes, {
                        dateNumber: value.value1
                    });
                case 'h':
                    return excludeOverdue ? intl.formatMessage((0, $73DRj.default).valueDueInNextExcludeOverdueHours, {
                        dateNumber: value.value1
                    }) : intl.formatMessage((0, $73DRj.default).valueDueInNextHours, {
                        dateNumber: value.value1
                    });
                case 'd':
                    return excludeOverdue ? intl.formatMessage((0, $73DRj.default).valueDueInNextExcludeOverdueDays, {
                        dateNumber: value.value1
                    }) : intl.formatMessage((0, $73DRj.default).valueDueInNextDays, {
                        dateNumber: value.value1
                    });
                case 'w':
                    return excludeOverdue ? intl.formatMessage((0, $73DRj.default).valueDueInNextExcludeOverdueWeeks, {
                        dateNumber: value.value1
                    }) : intl.formatMessage((0, $73DRj.default).valueDueInNextWeeks, {
                        dateNumber: value.value1
                    });
                default:
                    return value.value2;
            }
        }
        return '';
    },
    getJqlData: (dateTimeValue)=>{
        if (!dateTimeValue) return undefined;
        const { value1: value1, value2: value2, excludeOverdue: excludeOverdue } = dateTimeValue;
        return excludeOverdue === true ? {
            primaryClause: {
                operator: (0, $jPlb3.OPERATOR_GT_EQUALS),
                operand: '0'
            },
            secondaryClause: {
                operator: (0, $jPlb3.OPERATOR_LT_EQUALS),
                operand: `${value1}${value2}`
            }
        } : {
            primaryClause: {
                operator: (0, $jPlb3.OPERATOR_LT_EQUALS),
                operand: `${value1}${value2}`
            }
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            // if both clauses are present check value of operand if it's '0'
            if (primaryClause === undefined && secondaryClause === undefined) // Does not match type if more than one clause is present
            return undefined;
            if (primaryClause !== undefined && secondaryClause !== undefined) {
                const returnValue = {
                    value1: '',
                    value2: '',
                    excludeOverdue: false
                };
                [
                    primaryClause,
                    secondaryClause
                ].forEach((clause)=>{
                    const operatorValue = clause.operator ? clause.operator : '';
                    const value = clause.operand !== undefined ? clause.operand : '';
                    switch(operatorValue){
                        case 0, $jPlb3.OPERATOR_GT_EQUALS:
                            if (value === '0' || value === '"0"') returnValue.excludeOverdue = true;
                            break;
                        case 0, $jPlb3.OPERATOR_LT_EQUALS:
                            if (value) {
                                const matches = value.match(/^([0-9]*)([mhdw])$/);
                                if (matches?.length === 3) {
                                    const [, value1, value2] = matches;
                                    returnValue.value1 = value1;
                                    returnValue.value2 = value2;
                                }
                            }
                            break;
                        default:
                            break;
                    }
                });
                if (returnValue.value1 && returnValue.value2 && returnValue.excludeOverdue) return returnValue;
            }
            if (primaryClause === undefined && secondaryClause !== undefined || primaryClause !== undefined && secondaryClause === undefined) {
                const clause = primaryClause || secondaryClause;
                if (clause && clause.operator === (0, $jPlb3.OPERATOR_LT_EQUALS)) {
                    const value = clause.operand !== undefined ? clause.operand : '';
                    if (value !== undefined) {
                        const matches = value.match(/^([0-9]*)([mhdw])$/);
                        if (matches?.length === 3) return {
                            value1: matches[1],
                            value2: matches[2]
                        };
                    }
                }
            }
            return undefined;
        }
        return undefined;
    },
    overduePicker: true
};

});

parcelRegister("jp05X", function(module, exports) {

$parcel$export(module.exports, "IN_RANGE_CONFIG", () => $4b0a8471b77494aa$export$824796e3ed16a4e0);

var $jPlb3 = parcelRequire("jPlb3");

var $73DRj = parcelRequire("73DRj");

var $iE7P0 = parcelRequire("iE7P0");
const $4b0a8471b77494aa$export$824796e3ed16a4e0 = {
    type: 'in_range',
    componentType: 'in_range',
    label: 'labelInRange',
    hasInput: true,
    getErrorMessage: (intl, value)=>{
        if (value?.value1 && value.value2 && (0, $iE7P0.getTimeInMinutes)((0, $iE7P0.getTimeInfo)(value.value1)) > (0, $iE7P0.getTimeInMinutes)((0, $iE7P0.getTimeInfo)(value.value2))) return intl.formatMessage((0, $73DRj.default).validationMessageFromGreaterThanTo);
        if (value && (value.value1 !== '' && !(0, $iE7P0.getTimeInfo)(value.value1).isValid || value.value2 !== '' && !(0, $iE7P0.getTimeInfo)(value.value2).isValid)) return intl.formatMessage((0, $73DRj.default).validationMessageInvalidPeriodFormatValue);
        return undefined;
    },
    getTooltip: (intl, value)=>{
        const fromTimeInfo = (0, $iE7P0.getTimeInfo)(value?.value1);
        const toTimeInfo = (0, $iE7P0.getTimeInfo)(value?.value2);
        if (fromTimeInfo.isValid && toTimeInfo.isValid) {
            if (fromTimeInfo.isBeforeNow && toTimeInfo.isBeforeNow) return intl.formatMessage((0, $73DRj.default).valueInRangeBeforeNowToBeforeNow, {
                beforeTime: (0, $iE7P0.getTimeString)(intl, fromTimeInfo),
                afterTime: (0, $iE7P0.getTimeString)(intl, toTimeInfo)
            });
            if (fromTimeInfo.isBeforeNow && !toTimeInfo.isBeforeNow) return intl.formatMessage((0, $73DRj.default).valueInRangeBeforeNowToAfterNow, {
                beforeTime: (0, $iE7P0.getTimeString)(intl, fromTimeInfo),
                afterTime: (0, $iE7P0.getTimeString)(intl, toTimeInfo)
            });
            if (!fromTimeInfo.isBeforeNow && !toTimeInfo.isBeforeNow) return intl.formatMessage((0, $73DRj.default).valueInRangeAfterNowToAfterNow, {
                beforeTime: (0, $iE7P0.getTimeString)(intl, fromTimeInfo),
                afterTime: (0, $iE7P0.getTimeString)(intl, toTimeInfo)
            });
        }
        return undefined;
    },
    getFormattedValue: (intl, value)=>{
        const fromTimeInfo = (0, $iE7P0.getTimeInfo)(value?.value1);
        const toTimeInfo = (0, $iE7P0.getTimeInfo)(value?.value2);
        if (fromTimeInfo.isValid && toTimeInfo.isValid) return intl.formatMessage((0, $73DRj.default).valueInRange, {
            start: value?.value1,
            end: value?.value2
        });
        if (fromTimeInfo.isValid && value && value.value2 === '') return fromTimeInfo.isBeforeNow ? intl.formatMessage((0, $73DRj.default).valueInRangeBeforeNowToBlank, {
            beforeTime: (0, $iE7P0.getTimeString)(intl, fromTimeInfo)
        }) : intl.formatMessage((0, $73DRj.default).valueInRangeAfterNowToBlank, {
            beforeTime: (0, $iE7P0.getTimeString)(intl, fromTimeInfo)
        });
        if (toTimeInfo.isValid && value && value.value1 === '') return toTimeInfo.isBeforeNow ? intl.formatMessage((0, $73DRj.default).valueInRangeBlankToBeforeNow, {
            afterTime: (0, $iE7P0.getTimeString)(intl, toTimeInfo)
        }) : intl.formatMessage((0, $73DRj.default).valueInRangeBlankToAfterNow, {
            afterTime: (0, $iE7P0.getTimeString)(intl, toTimeInfo)
        });
        // TODO : This scenario shouldn't happen, retain this till invalid scenarios are handled
        return value ? intl.formatMessage((0, $73DRj.default).valueInRangeBeforeNowToAfterNow, {
            beforeTime: value.value1,
            afterTime: value.value2
        }) : '';
    },
    getJqlData: (dateTimeValue)=>{
        if (!dateTimeValue) return undefined;
        const { value1: value1, value2: value2 } = dateTimeValue;
        return {
            primaryClause: value1 ? {
                operator: (0, $jPlb3.OPERATOR_GT_EQUALS),
                operand: `${value1}`
            } : undefined,
            secondaryClause: value2 ? {
                operator: (0, $jPlb3.OPERATOR_LT_EQUALS),
                operand: `${value2}`
            } : undefined
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause === undefined && secondaryClause === undefined) // Do not match type if both clauses are not present
            return undefined;
            if (primaryClause !== undefined || secondaryClause !== undefined) {
                const returnValue = {
                    value1: '',
                    value2: ''
                };
                [
                    primaryClause,
                    secondaryClause
                ].forEach((clause)=>{
                    const operatorValue = clause && clause.operator ? clause.operator : '';
                    const value = clause && clause.operand !== undefined ? clause.operand : '';
                    switch(operatorValue){
                        case 0, $jPlb3.OPERATOR_GT_EQUALS:
                            if (value.match((0, $iE7P0.IS_YYYY_MM_DD_REGEX)) == null) returnValue.value1 = value;
                            break;
                        case 0, $jPlb3.OPERATOR_LT_EQUALS:
                            if (value.match((0, $iE7P0.IS_YYYY_MM_DD_REGEX)) == null) returnValue.value2 = value;
                            break;
                        default:
                            break;
                    }
                });
                if (returnValue.value1 || returnValue.value2) return returnValue;
            }
            return undefined;
        }
        return undefined;
    }
};

});

parcelRegister("hLFTi", function(module, exports) {

$parcel$export(module.exports, "MORE_THAN_CONFIG", () => $5b94708a8484f41d$export$d840a05dccc1ad98);
$parcel$export(module.exports, "CONFIG_DATE_MORE_THAN", () => $5b94708a8484f41d$export$3381ab6a0f70cfec);

var $jPlb3 = parcelRequire("jPlb3");

var $73DRj = parcelRequire("73DRj");

var $iE7P0 = parcelRequire("iE7P0");
const $5b94708a8484f41d$export$d840a05dccc1ad98 = {
    type: 'more_than',
    componentType: 'time_input',
    label: 'labelMoreThan',
    hasInput: true,
    getErrorMessage: (intl, value)=>(0, $iE7P0.isValidTimePeriodFormat)(value?.value1, value?.value2) ? undefined : intl.formatMessage((0, $73DRj.default).validationMessageInvalidPeriodFormat),
    getFormattedValue: (intl, value)=>{
        if (value !== undefined) switch(value.value2.toLowerCase()){
            case 'm':
                return intl.formatMessage((0, $73DRj.default).valueMoreThanMinutes, {
                    dateNumber: value.value1
                });
            case 'h':
                return intl.formatMessage((0, $73DRj.default).valueMoreThanHours, {
                    dateNumber: value.value1
                });
            case 'd':
                return intl.formatMessage((0, $73DRj.default).valueMoreThanDays, {
                    dateNumber: value.value1
                });
            case 'w':
                return intl.formatMessage((0, $73DRj.default).valueMoreThanWeeks, {
                    dateNumber: value.value1
                });
            default:
                return value.value2;
        }
        return '';
    },
    getJqlData: (dateTimeValue)=>{
        if (!dateTimeValue) return undefined;
        const { value1: value1, value2: value2 } = dateTimeValue;
        return {
            primaryClause: {
                operator: (0, $jPlb3.OPERATOR_LT_EQUALS),
                operand: `-${value1}${value2}`
            }
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause !== undefined && secondaryClause !== undefined) // Does not match type if more than one clause is present
            return undefined;
            const clause = primaryClause || secondaryClause;
            if (clause && clause.operator === (0, $jPlb3.OPERATOR_LT_EQUALS)) {
                const value = clause.operand !== undefined ? clause.operand : '';
                if (value) {
                    const matches = value.match(/^[-]([0-9]*)([mhdw])$/);
                    if (matches?.length === 3) return {
                        value1: matches[1],
                        value2: matches[2]
                    };
                }
            }
            return undefined;
        }
        return undefined;
    },
    endLabel: 'Overdue'
};
const $5b94708a8484f41d$export$3381ab6a0f70cfec = {
    ...$5b94708a8484f41d$export$d840a05dccc1ad98,
    endLabel: 'Ago'
};

});

parcelRegister("bgS1B", function(module, exports) {

$parcel$export(module.exports, "NOW_OVERDUE_CONFIG", () => $b5905e01b49267d0$export$10b9f2fe105831bd);

var $jPlb3 = parcelRequire("jPlb3");

var $73DRj = parcelRequire("73DRj");
const $b5905e01b49267d0$export$10b9f2fe105831bd = {
    type: 'now_overdue',
    componentType: 'is_not_set',
    label: 'labelNowOverdue',
    hasInput: false,
    getFormattedValue: (intl, value)=>value ? intl.formatMessage((0, $73DRj.default).valueNowOverdue) : '',
    getJqlData: ()=>({
            primaryClause: {
                operator: (0, $jPlb3.OPERATOR_LT_EQUALS),
                operand: '0'
            }
        }),
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause !== undefined && secondaryClause !== undefined) // Does not match type if more than one clause is present
            return undefined;
            const clause = primaryClause || secondaryClause;
            if (clause && clause.operator === (0, $jPlb3.OPERATOR_LT_EQUALS)) {
                const value = clause.operand;
                if (value && (value === '0' || value === '"0"')) return {
                    value1: '',
                    value2: ''
                };
            }
        }
        return undefined;
    }
};

});

parcelRegister("fxONR", function(module, exports) {

$parcel$export(module.exports, "WITHIN_THE_LAST_CONFIG", () => $1e697b480fd46006$export$8095f803ac0c0718);

var $jPlb3 = parcelRequire("jPlb3");

var $73DRj = parcelRequire("73DRj");

var $iE7P0 = parcelRequire("iE7P0");
const $1e697b480fd46006$export$8095f803ac0c0718 = {
    type: 'within_the_last',
    componentType: 'time_input',
    label: 'labelWithinTheLast',
    hasInput: true,
    getErrorMessage: (intl, value)=>(0, $iE7P0.isValidTimePeriodFormat)(value?.value1, value?.value2) ? undefined : intl.formatMessage((0, $73DRj.default).validationMessageInvalidPeriodFormat),
    getFormattedValue: (intl, value)=>{
        if (value !== undefined) switch(value.value2.toLowerCase()){
            case 'm':
                return intl.formatMessage((0, $73DRj.default).valueWithinTheLastMinutes, {
                    dateNumber: value.value1
                });
            case 'h':
                return intl.formatMessage((0, $73DRj.default).valueWithinTheLastHours, {
                    dateNumber: value.value1
                });
            case 'd':
                return intl.formatMessage((0, $73DRj.default).valueWithinTheLastDays, {
                    dateNumber: value.value1
                });
            case 'w':
                return intl.formatMessage((0, $73DRj.default).valueWithinTheLastWeeks, {
                    dateNumber: value.value1
                });
            default:
                return value.value2;
        }
        return '';
    },
    getJqlData: (dateTimeValue)=>{
        if (!dateTimeValue) return undefined;
        const { value1: value1, value2: value2 } = dateTimeValue;
        return {
            primaryClause: {
                operator: (0, $jPlb3.OPERATOR_GT_EQUALS),
                operand: `-${value1}${value2}`
            }
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause !== undefined && secondaryClause !== undefined) // Does not match type if more than one clause is present
            return undefined;
            const clause = primaryClause || secondaryClause;
            if (clause && clause.operator === (0, $jPlb3.OPERATOR_GT_EQUALS)) {
                const value = clause.operand !== undefined ? clause.operand : '';
                if (value) {
                    const matches = value.match(/^[-]([0-9]*)([mhdw])$/);
                    if (matches?.length === 3) return {
                        value1: matches[1],
                        value2: matches[2]
                    };
                }
            }
            return undefined;
        }
        return undefined;
    }
};

});



parcelRegister("q3XlS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc71c3438f9a300$export$2e2bcd8739ae039);

var $f26C8 = parcelRequire("f26C8");
var $1jiqw = parcelRequire("1jiqw");
const $ccc71c3438f9a300$var$singleDatePattern = /^(-)?[0-9]+(m|minute|minutes|h|hour|hours|d|day|days|w|week|weeks){1}$/;
const $ccc71c3438f9a300$var$isSingleDateValue = (str)=>$ccc71c3438f9a300$var$singleDatePattern.test(str.toLowerCase());
const $ccc71c3438f9a300$var$wrapWithQuotesIfNeeded = (text)=>$ccc71c3438f9a300$var$isSingleDateValue(text) ? text : `"${text.replace(/"/g, '\\"')}"`;
const $ccc71c3438f9a300$var$getClauses = (ast, fieldIdentifier)=>{
    const fieldsToReturn = [];
    const where = ast.query?.where;
    if (where) {
        if (where.clauseType === (0, $2a3824620e125bfd$export$7a58b23488ea076b) && where.clauses) where.clauses.forEach((clause)=>{
            if (clause.clauseType === (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a)) {
                const fieldId = clause.field.value.toLowerCase();
                if (fieldIdentifier.toLowerCase() === fieldId) fieldsToReturn.push(clause);
            }
        });
        else if (where.clauseType === (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a)) {
            const fieldId = where.field.value.toLowerCase();
            if (fieldIdentifier.toLowerCase() === fieldId) fieldsToReturn.push(where);
        }
    }
    return fieldsToReturn;
};
const $ccc71c3438f9a300$var$createTerminalClause = ({ fieldId: fieldId, operator: operator, value: value })=>(0, $f26C8.default).terminalClause((0, $f26C8.default).field(fieldId), (0, $f26C8.default).operator(operator), (0, $f26C8.default).byText.valueOperand($ccc71c3438f9a300$var$wrapWithQuotesIfNeeded(value)));
const $ccc71c3438f9a300$var$appendOrReplaceClause = ({ fieldId: fieldId, newClauseData: newClauseData, clauseToReplace: clauseToReplace, query: query })=>{
    const { operator: operator, operand: value } = newClauseData;
    if (clauseToReplace) clauseToReplace.replace($ccc71c3438f9a300$var$createTerminalClause({
        fieldId: fieldId,
        operator: operator,
        value: value
    }));
    else query.appendClause($ccc71c3438f9a300$var$createTerminalClause({
        fieldId: fieldId,
        operator: operator,
        value: value
    }), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
};
const $ccc71c3438f9a300$var$appendOrReplaceClauses = ({ fieldId: fieldId, jqlData: jqlData, fieldToRenderClause: fieldToRenderClause, fieldToRenderSecondaryClause: fieldToRenderSecondaryClause, query: query })=>{
    const { primaryClause: primaryClauseData, secondaryClause: secondaryClauseData } = jqlData;
    if (primaryClauseData) $ccc71c3438f9a300$var$appendOrReplaceClause({
        fieldId: fieldId,
        newClauseData: primaryClauseData,
        clauseToReplace: fieldToRenderClause || fieldToRenderSecondaryClause,
        query: query
    });
    if (secondaryClauseData) $ccc71c3438f9a300$var$appendOrReplaceClause({
        fieldId: fieldId,
        newClauseData: secondaryClauseData,
        clauseToReplace: primaryClauseData ? fieldToRenderSecondaryClause : fieldToRenderClause || fieldToRenderSecondaryClause,
        query: query
    });
};
const $ccc71c3438f9a300$var$deleteUnnecessaryClauses = ({ jqlData: jqlData, fieldToRenderClause: fieldToRenderClause, fieldToRenderSecondaryClause: fieldToRenderSecondaryClause })=>{
    if (!jqlData || !jqlData.primaryClause && !jqlData.secondaryClause) {
        fieldToRenderClause && fieldToRenderClause.remove();
        fieldToRenderSecondaryClause && fieldToRenderSecondaryClause.remove();
    }
    if (jqlData && (!jqlData.primaryClause || !jqlData.secondaryClause)) fieldToRenderSecondaryClause && fieldToRenderSecondaryClause.remove();
};
const $ccc71c3438f9a300$var$getNewJqlFromDoubleClausePickerJqlData = (fieldId, ast, jqlData)=>{
    if (!ast.query) return ast.represents;
    const [fieldToRenderClause, fieldToRenderSecondaryClause] = $ccc71c3438f9a300$var$getClauses(ast, fieldId);
    if (jqlData !== undefined) $ccc71c3438f9a300$var$appendOrReplaceClauses({
        fieldId: fieldId,
        jqlData: jqlData,
        fieldToRenderClause: fieldToRenderClause,
        fieldToRenderSecondaryClause: fieldToRenderSecondaryClause,
        query: ast.query
    });
    $ccc71c3438f9a300$var$deleteUnnecessaryClauses({
        jqlData: jqlData,
        fieldToRenderClause: fieldToRenderClause,
        fieldToRenderSecondaryClause: fieldToRenderSecondaryClause
    });
    return (0, $1jiqw.print)(ast, {
        operatorCase: 'upper'
    });
};
var $ccc71c3438f9a300$export$2e2bcd8739ae039 = $ccc71c3438f9a300$var$getNewJqlFromDoubleClausePickerJqlData;

});


parcelRegister("8b3Zt", function(module, exports) {

$parcel$export(module.exports, "LastUserCommentedPickerWrapper", () => $9ac07a7acbf1a93d$export$d03064b9074933a8);

var $eJOHy = parcelRequire("eJOHy");

var $86tBw = parcelRequire("86tBw");

var $cDJ0f = parcelRequire("cDJ0f");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $5LwVz = parcelRequire("5LwVz");

var $boEdP = parcelRequire("boEdP");

var $cNe2t = parcelRequire("cNe2t");


var $1xd19 = parcelRequire("1xd19");

var $lyPdT = parcelRequire("lyPdT");

var $dIHx6 = parcelRequire("dIHx6");

var $gZnpM = parcelRequire("gZnpM");
const $9ac07a7acbf1a93d$export$d03064b9074933a8 = ({ activePopupKey: activePopupKey, clause: clause, fieldId: fieldId, fieldLabel: fieldLabel, fieldDescription: fieldDescription, onClear: onClear, onClose: onClose, onOpen: onOpen, onSearchWrapper: onSearchWrapper, isIrremovable: isIrremovable })=>{
    const [isChecked, setIsChecked] = (0, $eJOHy.useState)((0, $gZnpM.getInitialState)(clause));
    const isOpen = activePopupKey === fieldId;
    const handleOnTriggerClick = (0, $eJOHy.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]);
    const [ast] = (0, $lyPdT.useAST)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.last-user-commented-picker-wrapper.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
                ...triggerProps,
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!clause,
                onClick: handleOnTriggerClick,
                onClear: ()=>onClear(clause ? (0, $boEdP.default)(ast, clause) : undefined),
                testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                color: "inherit",
                weight: "medium",
                testId: (0, $332899bfd23114ba$export$743be55d5cf4a20d)
            }, clause ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                as: "strong"
            }, `${fieldLabel}: `), isChecked ? formatMessage((0, $dIHx6.default).trueMessage) : formatMessage((0, $dIHx6.default).all)) : fieldLabel)),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $9ac07a7acbf1a93d$var$boxStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
                id: "last-user-commented-checkbox",
                onChange: (e)=>{
                    setIsChecked(e.target.checked);
                    onSearchWrapper && onSearchWrapper((0, $gZnpM.getUpdatedJql)(ast, clause, fieldId, e.target.checked));
                    onClose();
                },
                isChecked: isChecked,
                testId: "jql-builder-basic.ui.jql-editor.field.last-user-commented-picker-wrapper.checkbox"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
                htmlFor: "last-user-commented-checkbox"
            }, formatMessage((0, $dIHx6.default).checkBoxLabel)))
    });
};
var $9ac07a7acbf1a93d$export$2e2bcd8739ae039 = $9ac07a7acbf1a93d$export$d03064b9074933a8;
const $9ac07a7acbf1a93d$var$boxStyles = (0, $1DXK0.xcss)({
    padding: 'space.150'
});

});
parcelRegister("dIHx6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b628b450a5564035$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b628b450a5564035$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    checkBoxLabel: {
        "id": "jql-builder-basic.jql-editor.field.last-user-commented-picker-wrapper.check-box-label",
        "defaultMessage": "Restrict to last commented by non-developers"
    },
    all: {
        "id": "jql-builder-basic.jql-editor.field.last-user-commented-picker-wrapper.all",
        "defaultMessage": "All"
    },
    trueMessage: {
        "id": "jql-builder-basic.jql-editor.field.last-user-commented-picker-wrapper.true-message",
        "defaultMessage": "true"
    }
});

});

parcelRegister("gZnpM", function(module, exports) {

$parcel$export(module.exports, "getUpdatedJql", () => $f759b4c47f66e682$export$1625bb7ada97d007);
$parcel$export(module.exports, "getInitialState", () => $f759b4c47f66e682$export$53ac33307b5acee9);

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $boEdP = parcelRequire("boEdP");

var $eiIzV = parcelRequire("eiIzV");
const $f759b4c47f66e682$var$createTerminalClause = (fieldId, value)=>(0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $eiIzV.escapeBackslashes)(fieldId)), (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)), (0, $f26C8.default).byText.valueOperand(value ? '"true"' : '""'));
const $f759b4c47f66e682$export$1625bb7ada97d007 = (ast, clause, fieldId, value)=>{
    const hasValue = Boolean(value);
    if (!clause) {
        if (!ast.query || !hasValue) return ast.represents;
        if (value) ast.query.appendClause($f759b4c47f66e682$var$createTerminalClause(fieldId, value), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
    } else if (value) clause.replace($f759b4c47f66e682$var$createTerminalClause(fieldId, value));
    else return (0, $boEdP.default)(ast, clause);
    return (0, $1jiqw.print)(ast, {
        operatorCase: 'upper'
    });
};
const $f759b4c47f66e682$export$53ac33307b5acee9 = (clause)=>(clause && clause.clauseType === (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a) && clause.operand && clause.operand.operandType === (0, $862dfd240457f00b$export$38accfc5a5d1c113) && clause.operand.value) === 'true';

});


parcelRegister("5maGz", function(module, exports) {

$parcel$export(module.exports, "NumberRangePicker", () => $d17dc1ea6d66e4bc$export$1ad8a36b54765fad);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $q3XlS = parcelRequire("q3XlS");

var $1xd19 = parcelRequire("1xd19");

var $lyPdT = parcelRequire("lyPdT");

var $jhLWN = parcelRequire("jhLWN");

var $aM67A = parcelRequire("aM67A");
const $d17dc1ea6d66e4bc$export$1ad8a36b54765fad = ({ fieldId: fieldId, fieldLabel: fieldLabel, activePopupKey: activePopupKey, clause: clause, secondaryClause: secondaryClause, onSearchWrapper: onSearchWrapper, onSendOptionAnalytics: onSendOptionAnalytics, onClear: onClear, onOpen: onOpen, onClose: onClose, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    /**
   * fieldLabel comes from field displayName from the hydration data.
   * It is defined in the fragment `jqlEditor_jqlBuilderBasic_JQLEditorUI` in
   * `src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx`
   * we never expect it to be undefined but since we are not using the @required
   * directive in the fragment, this check is required.
   */ const safeFieldLabel = fieldLabel ?? '';
    const numberRangeValue = (0, $eJOHy.useMemo)(()=>(0, $aM67A.mapJqlDataToNumberRangeValue)((0, $aM67A.getJqlDataFromClauses)(clause, secondaryClause)), [
        clause,
        secondaryClause
    ]);
    const triggerValueMessageDescriptor = (0, $eJOHy.useMemo)(()=>(0, $aM67A.getTriggerValueMessageDescriptor)(numberRangeValue), [
        numberRangeValue
    ]);
    const isOpen = activePopupKey === fieldId;
    const handleOnChange = (0, $eJOHy.useCallback)((newValue)=>{
        onSearchWrapper && onSearchWrapper((0, $q3XlS.default)(fieldId, ast, (0, $aM67A.mapNumberRangeValueToJqlData)(newValue)));
        onClose();
        onSendOptionAnalytics && onSendOptionAnalytics({
            hasMinValue: newValue.min.length > 0,
            hasMaxValue: newValue.max.length > 0
        });
    }, [
        ast,
        fieldId,
        onClose,
        onSearchWrapper,
        onSendOptionAnalytics
    ]);
    const onTriggerClick = (0, $eJOHy.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]);
    const onTriggerClear = (0, $eJOHy.useCallback)(()=>onClear(clause ? (0, $q3XlS.default)(fieldId, ast, undefined) : undefined), [
        ast,
        clause,
        fieldId,
        onClear
    ]);
    const triggerRenderer = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
            ...triggerProps,
            isInvalid: false,
            isSelected: isOpen,
            isLoading: false,
            hasValues: !(0, $aM67A.isNumberRangeValueEmpty)(numberRangeValue),
            onClear: onTriggerClear,
            onClick: onTriggerClick,
            testId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.picker-trigger",
            fieldDescription: fieldDescription,
            isIrremovable: isIrremovable
        }, triggerValueMessageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            as: "span",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            as: "strong",
            color: "inherit"
        }, safeFieldLabel, ":\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $d17dc1ea6d66e4bc$var$valueContainerStyles,
            as: "span"
        }, formatMessage(triggerValueMessageDescriptor, numberRangeValue))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            as: "span"
        }, safeFieldLabel)), [
        isOpen,
        numberRangeValue,
        onTriggerClear,
        onTriggerClick,
        fieldDescription,
        isIrremovable,
        triggerValueMessageDescriptor,
        safeFieldLabel,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jhLWN.NumberRangePickerPopup), {
        isOpen: isOpen,
        onClose: onClose,
        onChange: handleOnChange,
        value: numberRangeValue,
        renderTrigger: triggerRenderer
    });
};
const $d17dc1ea6d66e4bc$var$valueContainerStyles = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px'
});

});
parcelRegister("jhLWN", function(module, exports) {

$parcel$export(module.exports, "NumberRangePickerPopup", () => $6343d6e76713afc8$export$7e88ff560d51764b);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $cDJ0f = parcelRequire("cDJ0f");

var $fKXve = parcelRequire("fKXve");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $sY9BV = parcelRequire("sY9BV");

var $lRq8t = parcelRequire("lRq8t");

var $5LwVz = parcelRequire("5LwVz");

var $cNe2t = parcelRequire("cNe2t");


var $gB01j = parcelRequire("gB01j");

var $aM67A = parcelRequire("aM67A");
const $6343d6e76713afc8$export$7e88ff560d51764b = ({ isOpen: isOpen, onClose: onClose, renderTrigger: renderTrigger, value: value, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [unsubmittedValue, setUnsubmittedValue] = (0, $eJOHy.useState)(value);
    const [errorStateMessages, setErrorStateMessages] = (0, $eJOHy.useState)(()=>(0, $aM67A.getNumberRangePickerErrorMessages)(value));
    const hasError = (0, $eJOHy.useMemo)(()=>(0, $aM67A.hasNumberRangeValueError)(errorStateMessages), [
        errorStateMessages
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)((index)=>({ currentTarget: { value: targetValue } })=>{
            const newUnsubmittedValue = {
                ...unsubmittedValue,
                [index]: targetValue
            };
            setUnsubmittedValue(newUnsubmittedValue);
            setErrorStateMessages((0, $aM67A.getNumberRangePickerErrorMessages)(newUnsubmittedValue, index));
        }, [
        unsubmittedValue
    ]);
    const handleOnSubmit = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        onChange(unsubmittedValue);
    }, [
        onChange,
        unsubmittedValue
    ]);
    const showErrorMessage = (0, $eJOHy.useCallback)((messageDescriptor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $6343d6e76713afc8$var$errorMessageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, messageDescriptor === (0, $gB01j.default).numberSizeLimitErrorMessage ? formatMessage(messageDescriptor, {
            maxSize: (0, $c6374ddcf66d0147$export$3aefefab9ae0beef).toLocaleString()
        }) : formatMessage(messageDescriptor))), [
        formatMessage
    ]);
    const renderContent = (0, $eJOHy.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $6343d6e76713afc8$var$textFieldGroupContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $6343d6e76713afc8$var$clauseDropdownContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
            htmlFor: "lower-clause-number-range-field"
        }, formatMessage((0, $gB01j.default).minimumClauseLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            ref: setInitialFocusRef,
            id: "lower-clause-number-range-field",
            onChange: handleOnChange('min'),
            value: unsubmittedValue.min,
            placeholder: formatMessage((0, $gB01j.default).numberRangePlaceholderMessage),
            isInvalid: hasError && errorStateMessages.min !== undefined,
            testId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.lower-clause-text-field"
        }), hasError && errorStateMessages.min !== undefined && showErrorMessage(errorStateMessages.min)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $6343d6e76713afc8$var$clauseDropdownContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
            htmlFor: "upper-clause-number-range-field"
        }, formatMessage((0, $gB01j.default).maximumClauseLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            id: "upper-clause-number-range-field",
            onChange: handleOnChange('max'),
            value: unsubmittedValue.max,
            placeholder: formatMessage((0, $gB01j.default).numberRangePlaceholderMessage),
            isInvalid: hasError && errorStateMessages.max !== undefined,
            testId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.upper-clause-text-field"
        }), hasError && errorStateMessages.max !== undefined && showErrorMessage(errorStateMessages.max))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $6343d6e76713afc8$var$buttonContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "primary",
            onClick: handleOnSubmit,
            type: "submit",
            isDisabled: hasError,
            testId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.update-button"
        }, formatMessage((0, $gB01j.default).updateButtonText)))), [
        errorStateMessages,
        formatMessage,
        handleOnChange,
        handleOnSubmit,
        hasError,
        showErrorMessage,
        unsubmittedValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        content: renderContent,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.popup",
        messageType: "transactional",
        trigger: renderTrigger
    });
};
const $6343d6e76713afc8$var$textFieldGroupContainerStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $6343d6e76713afc8$var$clauseDropdownContainerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $6343d6e76713afc8$var$buttonContainerStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width.0',
    borderTopWidth: 'border.width',
    paddingInline: 'space.150',
    paddingBlock: 'space.075'
});
const $6343d6e76713afc8$var$errorMessageContainerStyles = (0, $1DXK0.xcss)({
    margin: 'space.050'
});

});
const $c6374ddcf66d0147$export$3aefefab9ae0beef = 100000000000000;

parcelRegister("gB01j", function(module, exports) {

$parcel$export(module.exports, "default", () => $8286dc3ca17b5e18$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8286dc3ca17b5e18$var$messages = (0, $7qGN1.defineMessages)({
    numberRangePlaceholderMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.number-range-placeholder-message",
        "defaultMessage": "Enter a number"
    },
    minimumClauseLabel: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.minimum-clause-label",
        "defaultMessage": "Minimum"
    },
    maximumClauseLabel: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.maximum-clause-label",
        "defaultMessage": "Maximum"
    },
    triggerValueBothClauses: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.trigger-value-both-clauses",
        "defaultMessage": "From {min} to {max}"
    },
    triggerValueMinimumClause: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.trigger-value-minimum-clause",
        "defaultMessage": "From {min}"
    },
    triggerValueMaximumClause: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.trigger-value-maximum-clause",
        "defaultMessage": "Up to {max}"
    },
    validNumberErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.valid-number-error-message",
        "defaultMessage": "Please enter a valid number"
    },
    numberSizeLimitErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.number-size-limit-error-message",
        "defaultMessage": "Specify a number for the custom field (below {maxSize})"
    },
    numberRangeErrorMinimumClauseMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.number-range-error-minimum-clause-message",
        "defaultMessage": "The minimum must be less than the maximum"
    },
    numberRangeErrorMaximumClauseMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.number-range-error-maximum-clause-message",
        "defaultMessage": "The maximum must be greater than the minimum"
    },
    updateButtonText: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.update-button-text",
        "defaultMessage": "Update"
    }
});
var $8286dc3ca17b5e18$export$2e2bcd8739ae039 = $8286dc3ca17b5e18$var$messages;

});

parcelRegister("aM67A", function(module, exports) {

$parcel$export(module.exports, "isNumberRangeValueEmpty", () => $fb9b4692cb347d63$export$edfac072ec483f79);
$parcel$export(module.exports, "hasNumberRangeValueError", () => $fb9b4692cb347d63$export$dacc285ab5e4c500);
$parcel$export(module.exports, "getJqlDataFromClauses", () => $fb9b4692cb347d63$export$6e2488cf7796259d);
$parcel$export(module.exports, "mapJqlDataToNumberRangeValue", () => $fb9b4692cb347d63$export$37604c455ea22dda);
$parcel$export(module.exports, "mapNumberRangeValueToJqlData", () => $fb9b4692cb347d63$export$d2843f73b1f2a602);
$parcel$export(module.exports, "getTriggerValueMessageDescriptor", () => $fb9b4692cb347d63$export$9454d66b829ec1fe);
$parcel$export(module.exports, "getNumberRangePickerErrorMessages", () => $fb9b4692cb347d63$export$d22fc14cae6c7a09);

var $fQnJZ = parcelRequire("fQnJZ");

var $jPlb3 = parcelRequire("jPlb3");

var $19xe7 = parcelRequire("19xe7");

var $92k5z = parcelRequire("92k5z");

var $gB01j = parcelRequire("gB01j");
const $fb9b4692cb347d63$export$edfac072ec483f79 = (numberRangeValue)=>numberRangeValue.min === '' && numberRangeValue.max === '';
const $fb9b4692cb347d63$export$dacc285ab5e4c500 = (errorStateMessages)=>errorStateMessages.min !== undefined || errorStateMessages.max !== undefined;
const $fb9b4692cb347d63$export$6e2488cf7796259d = (primaryClause, secondaryClause)=>({
        ...primaryClause !== undefined && primaryClause.operator && primaryClause.operand && primaryClause.operand.operandType === (0, $862dfd240457f00b$export$38accfc5a5d1c113) && {
            primaryClause: {
                operator: primaryClause.operator.value,
                operand: (0, $92k5z.removeSurroundingQuotes)(primaryClause.operand.text)
            }
        },
        ...secondaryClause !== undefined && secondaryClause.operator && secondaryClause.operand && secondaryClause.operand.operandType === (0, $862dfd240457f00b$export$38accfc5a5d1c113) && {
            secondaryClause: {
                operator: secondaryClause.operator.value,
                operand: (0, $92k5z.removeSurroundingQuotes)(secondaryClause.operand.text)
            }
        }
    });
const $fb9b4692cb347d63$export$37604c455ea22dda = (jqlData)=>{
    const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
    const numberRangeValue = {
        min: '',
        max: ''
    };
    [
        primaryClause,
        secondaryClause
    ].forEach((clause)=>{
        switch(clause?.operator){
            case 0, $jPlb3.OPERATOR_GT_EQUALS:
                numberRangeValue.min = clause.operand;
                break;
            case 0, $jPlb3.OPERATOR_LT_EQUALS:
                numberRangeValue.max = clause.operand;
                break;
            default:
                break;
        }
    });
    return numberRangeValue;
};
const $fb9b4692cb347d63$export$d2843f73b1f2a602 = (numberRangeValue)=>({
        ...numberRangeValue.min !== '' && {
            primaryClause: {
                operator: (0, $jPlb3.OPERATOR_GT_EQUALS),
                operand: numberRangeValue.min
            }
        },
        ...numberRangeValue.max !== '' && {
            secondaryClause: {
                operator: (0, $jPlb3.OPERATOR_LT_EQUALS),
                operand: numberRangeValue.max
            }
        }
    });
const $fb9b4692cb347d63$export$9454d66b829ec1fe = (numberRangeValue)=>{
    const { min: min, max: max } = numberRangeValue;
    if (min !== '' && max !== '') return (0, $gB01j.default).triggerValueBothClauses;
    if (min !== '') return (0, $gB01j.default).triggerValueMinimumClause;
    if (max !== '') return (0, $gB01j.default).triggerValueMaximumClause;
};
const $fb9b4692cb347d63$export$e51ed4980accfbd3 = (inputValue, focusedIndex)=>{
    if (inputValue.min !== '' && inputValue.max !== '') {
        if (focusedIndex === 'min' && (0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(inputValue.min) > (inputValue.max !== '' ? (0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(inputValue.max) : Number.POSITIVE_INFINITY)) return true;
        if (focusedIndex === 'max' && (0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(inputValue.max) < (inputValue.min !== '' ? (0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(inputValue.min) : Number.NEGATIVE_INFINITY)) return true;
    }
    return false;
};
const $fb9b4692cb347d63$export$d22fc14cae6c7a09 = (inputValue, // default is used here to account for initial state, where focusedIndex is not provided
focusedIndex = 'max')=>{
    const errorMessages = {};
    if ($fb9b4692cb347d63$export$edfac072ec483f79(inputValue)) return errorMessages;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const index of [
        'min',
        'max'
    ]){
        if (focusedIndex === index && $fb9b4692cb347d63$export$e51ed4980accfbd3(inputValue, index)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        errorMessages[index] = focusedIndex === 'min' ? (0, $gB01j.default).numberRangeErrorMinimumClauseMessage : (0, $gB01j.default).numberRangeErrorMaximumClauseMessage;
        if ((0, $19xe7.isUnsubmittedValueNotANumber)(inputValue[index])) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        errorMessages[index] = (0, $gB01j.default).validNumberErrorMessage;
        // this assumes that value is a valid number
        if ((0, $19xe7.isUnsubmittedNumberTooLarge)((0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(inputValue[index]))) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        errorMessages[index] = (0, $gB01j.default).numberSizeLimitErrorMessage;
    }
    return errorMessages;
};

});
parcelRegister("19xe7", function(module, exports) {

$parcel$export(module.exports, "isUnsubmittedValueNotANumber", () => $fa9ed8cbfdb15b73$export$dc9f326e882569dd);
$parcel$export(module.exports, "isUnsubmittedNumberTooLarge", () => $fa9ed8cbfdb15b73$export$8716b9bb318bd57c);

var $fQnJZ = parcelRequire("fQnJZ");

const $fa9ed8cbfdb15b73$export$4e785eb5f6d441 = (value)=>/^-?(\d+(\.\d*)?|\.\d+)$|^$/.test(`${value}`);
const $fa9ed8cbfdb15b73$export$dc9f326e882569dd = (unsubmittedValue)=>!$fa9ed8cbfdb15b73$export$4e785eb5f6d441(unsubmittedValue);
const $fa9ed8cbfdb15b73$export$8716b9bb318bd57c = (unsubmittedValue)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(unsubmittedValue) > (0, $c6374ddcf66d0147$export$3aefefab9ae0beef);

});




parcelRegister("6CLhR", function(module, exports) {

$parcel$export(module.exports, "PickerWrapper", () => $328d245f9692afd1$export$9d776b739e5a282a);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $3Zpjn = parcelRequire("3Zpjn");

var $gMbEk = parcelRequire("gMbEk");

var $boEdP = parcelRequire("boEdP");

var $lvKO5 = parcelRequire("lvKO5");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $eqSys = parcelRequire("eqSys");

var $lyPdT = parcelRequire("lyPdT");

var $bPVeA = parcelRequire("bPVeA");

var $cPX6Y = parcelRequire("cPX6Y");

var $8i1DT = parcelRequire("8i1DT");

var $2lSRS = parcelRequire("2lSRS");

var $5atdb = parcelRequire("5atdb");

var $l2et3 = parcelRequire("l2et3");

var $8Hwfj = parcelRequire("8Hwfj");
const $328d245f9692afd1$export$9d776b739e5a282a = ({ fieldId: fieldId, fieldLabel: fieldDisplayName, terminalClause: terminalClause, activePopupKey: activePopupKey, onOpen: onOpen, onClose: onClose, onSearchWrapper: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSearchWrapper = ()=>{}, onSendOptionAnalytics: onSendOptionAnalytics, hydratedData: hydratedData, loading: isLoading, onClear: onClear, picker: picker, projectOptions: projectOptions, isMulti: isMulti, fieldDescription: fieldDescription, onOpenOperatorPicker: onOpenOperatorPicker, hideOperatorDropdown: hideOperatorDropdown, isIrremovable: isIrremovable, contextJql: contextJql, viewContext: viewContext, scope: scope, suggestedUsersCount: suggestedUsersCount })=>{
    const refinementInvalidProjectOptionMessageGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $8i1DT.default).refinementInvalidProjectOptionMessageGalaxia : (0, $8i1DT.default).refinementInvalidProjectOptionMessage;
    const refinementInvalidOptionMessageGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $8i1DT.default).refinementInvalidOptionMessageGalaxia : (0, $8i1DT.default).refinementInvalidOptionMessage;
    const isOpen = activePopupKey === fieldId;
    const isEmpty = !terminalClause;
    const intl = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const { cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    const { searchTemplate: searchTemplate } = picker;
    // FIXME: getPickerProps creates "unstable" results so we've wrapped it in a memo;
    // a better solution might be to make it a hook so we can be more granular on each individual callback etc
    const { loadOptions: loadOptionsCallback, enableFullList: enableFullList, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList } = (0, $fAZgY.useMemoWithCondition)(()=>(0, $5atdb.getPickerProps)({
            fieldId: fieldId,
            propType: picker.propType || (0, $eqSys.GenericPropTypes).NoProp,
            searchTemplate: searchTemplate,
            jql: contextJql,
            formatMessage: intl.formatMessage,
            environment: environment,
            cloudId: cloudId,
            projectOptions: projectOptions,
            viewContext: viewContext,
            scope: scope,
            suggestedUsersCount: suggestedUsersCount
        }), [
        cloudId,
        contextJql,
        environment,
        fieldId,
        intl.formatMessage,
        picker.propType,
        projectOptions,
        scope,
        searchTemplate,
        suggestedUsersCount,
        viewContext
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const loadOptions = (0, $eJOHy.useCallback)((0, $3Zpjn.createGenericDebouncableDataLoader)(loadOptionsCallback), [
        loadOptionsCallback
    ]);
    const [selectedValues, setSelectedValues] = (0, $8Hwfj.useSelectedValues)(terminalClause, hydratedData, fieldId, operandDisplayValues, searchTemplate);
    const { selectedOperator: selectedOperator, setSelectedOperator: setSelectedOperator, allowedOperators: allowedOperators, setDefaultOperator: setDefaultOperator } = (0, $l2et3.useSelectedOperator)({
        fieldDisplayName: fieldDisplayName ?? fieldId,
        terminalClause: terminalClause,
        allowedOperators: picker.allowedOperators
    });
    const onChangeOperator = (0, $eJOHy.useCallback)((operator)=>{
        if (!hideOperatorDropdown && operator !== null && operator.value !== selectedOperator?.value) {
            setSelectedOperator && setSelectedOperator(operator);
            if (terminalClause) onSearchWrapper((0, $bPVeA.changeOperator)(ast, terminalClause, operator.value));
        }
    }, [
        hideOperatorDropdown,
        selectedOperator?.value,
        setSelectedOperator,
        terminalClause,
        onSearchWrapper,
        ast
    ]);
    const isInvalid = (0, $eJOHy.useMemo)(()=>!isEmpty && selectedValues.length > 0 && selectedValues.some((selectedValue)=>selectedValue.optionType === 'error' || selectedValue.optionType !== 'group' && selectedValue.invalid), [
        selectedValues,
        isEmpty
    ]);
    const onChangeCallback = (0, $eJOHy.useCallback)((optionOrOptions, meta, selectData)=>{
        const options = Array.isArray(optionOrOptions) ? optionOrOptions : [
            optionOrOptions
        ];
        // Optimistically make the UI change, so we don't have to wait for hydration
        setSelectedValues(options);
        onSearchWrapper?.((0, $cPX6Y.updateSelectedValue)({
            ast: ast,
            fieldId: fieldId,
            options: options,
            terminalClause: terminalClause,
            operator: !hideOperatorDropdown ? selectedOperator : undefined
        }));
        if (!Array.isArray(optionOrOptions)) onClose?.();
        if (meta.option && (0, $gMbEk.isSingleValueOption)(meta.option)) onSendOptionAnalytics?.({
            selectedItemsCount: options.length,
            selectedItemIndex: selectData?.selectedIndex,
            selectedItemType: 'option' in meta ? meta.option?.itemType : undefined,
            isFullList: 'option' in meta ? meta.option?.fullList : undefined
        });
    }, [
        setSelectedValues,
        onSearchWrapper,
        ast,
        fieldId,
        terminalClause,
        hideOperatorDropdown,
        selectedOperator,
        onClose,
        onSendOptionAnalytics
    ]);
    const onClearValues = (0, $eJOHy.useCallback)(()=>{
        // Optimistically make the UI change so we don't have to wait for hydration
        setSelectedValues([]);
        terminalClause && onSearchWrapper && onSearchWrapper((0, $boEdP.default)(ast, terminalClause));
        if (!hideOperatorDropdown) setDefaultOperator();
    }, [
        setSelectedValues,
        terminalClause,
        onSearchWrapper,
        ast,
        hideOperatorDropdown,
        setDefaultOperator
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        onClear && onClear(terminalClause ? (0, $boEdP.default)(ast, terminalClause) : undefined);
    }, [
        ast,
        onClear,
        terminalClause
    ]);
    const refinement = fieldDisplayName?.toLowerCase() || fieldId;
    const invalidMessage = refinement === 'project' ? intl.formatMessage(refinementInvalidProjectOptionMessageGalaxia) : intl.formatMessage(refinementInvalidOptionMessageGalaxia, {
        refinement: refinement
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2lSRS.PickerLoader), {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        value: selectedValues,
        isLoading: isLoading,
        fieldId: fieldId,
        searchTemplate: searchTemplate,
        fieldInvalidLabel: isInvalid ? invalidMessage : undefined,
        onChange: onChangeCallback,
        onClearValues: terminalClause ? onClearValues : undefined,
        onLoadOptions: loadOptions,
        enableFullList: enableFullList,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
        clause: terminalClause,
        fieldDisplayName: fieldDisplayName,
        isInvalid: isInvalid,
        isEmpty: isEmpty,
        onClearPicker: handleOnClear,
        onChangeOperator: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator,
        hideOperatorDropdown: hideOperatorDropdown,
        isMulti: isMulti,
        fieldDescription: fieldDescription,
        onOpenOperatorPicker: onOpenOperatorPicker,
        isIrremovable: isIrremovable
    });
};

});
parcelRegister("bPVeA", function(module, exports) {

$parcel$export(module.exports, "changeOperator", () => $d252c396e97fb247$export$108a5188e4c8d65);

var $f26C8 = parcelRequire("f26C8");
var $1jiqw = parcelRequire("1jiqw");

var $5c1zW = parcelRequire("5c1zW");

var $9dwrV = parcelRequire("9dwrV");
const $d252c396e97fb247$export$108a5188e4c8d65 = (ast, clause, operatorValue)=>{
    let correctOperator = operatorValue;
    if (clause.operand) {
        correctOperator = (0, $9dwrV.resolveOperator)({
            operatorValue: operatorValue,
            isList: (0, $5c1zW.isListOperand)(clause.operand)
        });
        if (clause.operand.operandType === (0, $862dfd240457f00b$export$fabec4aebba3f4df) && clause.operand.values.length === 1) clause.setOperand(clause.operand.values[0]);
    }
    clause.setOperator((0, $f26C8.default).operator(correctOperator));
    return (0, $1jiqw.print)(ast, {
        operatorCase: 'upper'
    });
};

});
parcelRegister("5c1zW", function(module, exports) {

$parcel$export(module.exports, "isListOperand", () => $c835bd750ad04bac$export$1ad46a26ef4c01b7);


var $dTJxm = parcelRequire("dTJxm");
const $c835bd750ad04bac$export$1ad46a26ef4c01b7 = (operand)=>{
    if (operand.operandType === (0, $862dfd240457f00b$export$fabec4aebba3f4df)) {
        if (operand.values.length === 1) {
            if (operand.values[0].operandType === (0, $862dfd240457f00b$export$19c7c729db381f9d)) return Boolean((0, $dTJxm.OperandValues)[operand.values[0].function.value]?.isList);
            return false;
        }
        return true;
    }
    if (operand.operandType === (0, $862dfd240457f00b$export$19c7c729db381f9d)) return Boolean((0, $dTJxm.OperandValues)[operand.function.value]?.isList);
    return false;
};

});

parcelRegister("9dwrV", function(module, exports) {

$parcel$export(module.exports, "resolveOperator", () => $30705e25d12db1c7$export$1ba71b2d6ac9610b);

var $jPlb3 = parcelRequire("jPlb3");
const $30705e25d12db1c7$export$1ba71b2d6ac9610b = ({ operatorValue: operatorValue, isList: isList })=>{
    switch(operatorValue){
        case 0, $jPlb3.OPERATOR_EQUALS:
        case 0, $jPlb3.OPERATOR_IN:
        case 0, $jPlb3.OPERATOR_IS:
            return isList ? (0, $jPlb3.OPERATOR_IN) : (0, $jPlb3.OPERATOR_EQUALS);
        case 0, $jPlb3.OPERATOR_NOT_EQUALS:
        case 0, $jPlb3.OPERATOR_NOT_IN:
        case 0, $jPlb3.OPERATOR_IS_NOT:
            return isList ? (0, $jPlb3.OPERATOR_NOT_IN) : (0, $jPlb3.OPERATOR_NOT_EQUALS);
        case 0, $jPlb3.OPERATOR_WAS_NOT_IN:
        case 0, $jPlb3.OPERATOR_WAS_NOT:
            return isList ? (0, $jPlb3.OPERATOR_WAS_NOT_IN) : (0, $jPlb3.OPERATOR_WAS_NOT);
        case 0, $jPlb3.OPERATOR_WAS:
        case 0, $jPlb3.OPERATOR_WAS_IN:
            return isList ? (0, $jPlb3.OPERATOR_WAS_IN) : (0, $jPlb3.OPERATOR_WAS);
        default:
            return operatorValue;
    }
};

});


parcelRegister("cPX6Y", function(module, exports) {

$parcel$export(module.exports, "updateSelectedValue", () => $c87c020709ebcbec$export$e4207420b53e5463);

var $f26C8 = parcelRequire("f26C8");
var $jPlb3 = parcelRequire("jPlb3");
var $1jiqw = parcelRequire("1jiqw");

var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $9dwrV = parcelRequire("9dwrV");
const $c87c020709ebcbec$var$parseFunction = (func)=>{
    const [, functionName, args] = func.match(/(\w+)\((.*)\)/) ?? [];
    return functionName ? {
        functionName: functionName,
        arguments: args.split(',').map((arg)=>(0, $f26C8.default).byText.argument(arg.trim()))
    } : {
        functionName: func,
        arguments: []
    };
};
const $c87c020709ebcbec$var$getOperandValue = (option)=>{
    switch(option.itemType){
        case 0, $862dfd240457f00b$export$19c7c729db381f9d:
            {
                const parsedFunctionText = $c87c020709ebcbec$var$parseFunction(option.value);
                return (0, $f26C8.default).functionOperand((0, $f26C8.default).functionString(parsedFunctionText.functionName), parsedFunctionText.arguments);
            }
        case 0, $862dfd240457f00b$export$f6049126fd97001f:
            return (0, $f26C8.default).keywordOperand();
        default:
            return (0, $f26C8.default).byText.valueOperand(option.value);
    }
};
const $c87c020709ebcbec$var$getOperandValues = (options)=>{
    const operandValues = options.map((option)=>$c87c020709ebcbec$var$getOperandValue(option));
    return operandValues;
};
const $c87c020709ebcbec$var$isListOperator = (options)=>{
    if (options.length === 1) {
        const [option] = options;
        const keyword = Object.values((0, $dTJxm.OperandValues)).find((kw)=>kw.value === option.value || kw.hasArgs && option.value.startsWith(kw.value));
        return Boolean(keyword?.isList);
    }
    return true;
};
const $c87c020709ebcbec$var$createTerminalClause = ({ fieldId: fieldId, options: options, terminalClause: terminalClause, operator: operator = terminalClause?.operator || (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS)) })=>(0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $eiIzV.escapeBackslashes)(fieldId)), (0, $f26C8.default).operator((0, $9dwrV.resolveOperator)({
        operatorValue: operator.value,
        isList: $c87c020709ebcbec$var$isListOperator(options)
    })), options.length > 1 ? (0, $f26C8.default).listOperand($c87c020709ebcbec$var$getOperandValues(options)) : $c87c020709ebcbec$var$getOperandValue(options[0]));
const $c87c020709ebcbec$export$e4207420b53e5463 = ({ ast: ast, fieldId: fieldId, options: options, terminalClause: terminalClause, operator: operator })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const filteredOptions = options.filter((option)=>'value' in option);
    if (!terminalClause && filteredOptions.length) {
        const newClause = $c87c020709ebcbec$var$createTerminalClause({
            fieldId: fieldId,
            options: filteredOptions,
            terminalClause: terminalClause,
            operator: operator
        });
        ast.query?.appendClause(newClause, (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
    }
    if (terminalClause && !filteredOptions.length) terminalClause.remove();
    else terminalClause?.replace($c87c020709ebcbec$var$createTerminalClause({
        fieldId: fieldId,
        options: filteredOptions,
        terminalClause: terminalClause,
        operator: operator
    }));
    return (0, $1jiqw.print)(ast, {
        operatorCase: 'upper'
    });
};

});

parcelRegister("8i1DT", function(module, exports) {

$parcel$export(module.exports, "default", () => $17ee9a952bde9a16$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $17ee9a952bde9a16$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    refinementInvalidOptionMessage: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-option-message",
        "defaultMessage": "Your project and {refinement} selection is invalid."
    },
    refinementInvalidProjectOptionMessage: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-project-option-message",
        "defaultMessage": "Your project selection is invalid."
    },
    refinementInvalidOptionMessageGalaxia: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-option-message-galaxia",
        "defaultMessage": "Your space and {refinement} selection is invalid."
    },
    refinementInvalidProjectOptionMessageGalaxia: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-project-option-message-galaxia",
        "defaultMessage": "Your space selection is invalid."
    }
});

});

parcelRegister("2lSRS", function(module, exports) {

$parcel$export(module.exports, "PickerLoader", () => $93f4c0f3074b28dc$export$4b415d703a601d69);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $jd93d = parcelRequire("jd93d");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $ixh2S = parcelRequire("ixh2S");

var $jx3Cw = parcelRequire("jx3Cw");

var $1xd19 = parcelRequire("1xd19");

var $kkE8T = parcelRequire("kkE8T");

var $6yIId = parcelRequire("6yIId");

var $4qpfH = parcelRequire("4qpfH");

const $93f4c0f3074b28dc$export$f5aa183e0b797cbf = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("Nqkfo")), {
    ssr: false,
    moduleId: "./src/packages/jql-builder/basic-picker/src/index.tsx"
});
const $93f4c0f3074b28dc$var$isKeyboardEvent = (event)=>Object.hasOwn(event, 'key');
const $93f4c0f3074b28dc$var$TriggerButtonWrapper = ({ children: children, popupRef: popupRef, triggerRef: triggerRef, ...props })=>{
    const ref = (0, $jd93d.default)(popupRef, triggerRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
        ref: ref,
        ...props
    }, children);
};
const $93f4c0f3074b28dc$export$4b415d703a601d69 = ({ clause: clause, fieldId: fieldId, fieldDisplayName: fieldDisplayName, isLoading: isLoading, isOpen: isOpen, onOpen: onOpen, onClose: onClose, fieldInvalidLabel: fieldInvalidLabel, onChange: onChange, onClearValues: onClearValues, onLoadOptions: onLoadOptions, enableFullList: enableFullList, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, isInvalid: isInvalid, isEmpty: isEmpty, onClearPicker: onClearPicker, value: value, onChangeOperator: onChangeOperator, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti, searchTemplate: searchTemplate, fieldDescription: fieldDescription, onOpenOperatorPicker: onOpenOperatorPicker, hideOperatorDropdown: hideOperatorDropdown, isIrremovable: isIrremovable })=>{
    const buttonRef = (0, $eJOHy.useRef)(null);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onTrigger = (0, $eJOHy.useCallback)(({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($93f4c0f3074b28dc$var$TriggerButtonWrapper, {
            isInvalid: isInvalid,
            isSelected: isOpen,
            hasValues: !isEmpty,
            onClick: (event)=>{
                isOpen ? onClose(event) : onOpen();
            },
            onClear: onClearPicker,
            popupRef: ref,
            triggerRef: buttonRef,
            testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
            fieldDescription: fieldDescription,
            /**
   * We need to show loading state when:
   * 1) clause is defined (values are selected) and
   * 2) we are waiting for hydrtation to finish (isLoading === true)
   * 3) Picker is closed
   * 4) There are no hydrated values (new or old) for current clause
   */ isLoading: clause && isLoading && !isOpen && value.length === 0,
            searchTemplate: searchTemplate,
            isIrremovable: isIrremovable
        }, !hideOperatorDropdown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6yIId.default), {
            label: fieldDisplayName,
            value: value,
            isInvalid: isInvalid,
            onChangeOperator: onChangeOperator,
            selectedOperator: selectedOperator,
            allowedOperators: allowedOperators,
            isParentPickerOpen: isOpen,
            onOpenOperatorPicker: onOpenOperatorPicker,
            ...(0, $6XJko.isVisualRefreshEnabled)() && (0, $7jTnu.fg)('visual-refresh-headers-buttons') && {
                isSelected: isOpen
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkE8T.TriggerComponentNoOperator), {
            label: fieldDisplayName,
            value: value,
            isInvalid: isInvalid,
            ...(0, $6XJko.isVisualRefreshEnabled)() && (0, $7jTnu.fg)('visual-refresh-headers-buttons') && {
                isSelected: isOpen
            }
        })), [
        isInvalid,
        isOpen,
        isEmpty,
        fieldId,
        onClearPicker,
        fieldDescription,
        clause,
        isLoading,
        value,
        searchTemplate,
        isIrremovable,
        hideOperatorDropdown,
        allowedOperators,
        onOpenOperatorPicker,
        fieldDisplayName,
        onChangeOperator,
        selectedOperator,
        onClose,
        onOpen
    ]);
    const experienceAnalyticsAttributes = (0, $eJOHy.useMemo)(()=>searchTemplate ? {
            searchTemplate: searchTemplate
        } : {}, [
        searchTemplate
    ]);
    const loadingMessage = (0, $eJOHy.useMemo)(()=>{
        return fieldDisplayName && (0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix') ? {
            paginationStart: formatMessage((0, $4qpfH.default).loadingMessageStart, {
                fieldName: fieldDisplayName
            }),
            paginationEnd: formatMessage((0, $4qpfH.default).loadingMessageEnd, {
                fieldName: fieldDisplayName
            })
        } : undefined;
    }, [
        formatMessage,
        fieldDisplayName
    ]);
    const handleClose = (0, $eJOHy.useCallback)((event)=>{
        onClose(event);
        if ($93f4c0f3074b28dc$var$isKeyboardEvent(event) && event.key === 'Escape') buttonRef.current?.focus();
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $7jTnu.fg)('render_jql_builder_in_ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixh2S.Picker), {
        isOpen: isOpen,
        onClose: handleClose,
        value: value,
        id: fieldId,
        searchInputPlaceholder: formatMessage((0, $4qpfH.default).searchPlaceholder, {
            fieldName: fieldDisplayName
        }),
        invalidLabel: fieldInvalidLabel,
        onChange: onChange,
        onClearValues: onClearValues,
        onLoadOptions: onLoadOptions,
        enableFullList: enableFullList,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
        onTrigger: onTrigger,
        shouldRenderToParent: true,
        showOperatorSelect: !hideOperatorDropdown,
        onChangeOperator: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator,
        isMulti: isMulti,
        experienceAnalyticsAttributes: experienceAnalyticsAttributes,
        loadingMessages: loadingMessage
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "picker-loader-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jx3Cw.default), {
            clause: clause,
            fieldId: fieldId,
            fieldDisplayName: fieldDisplayName,
            fieldDescription: fieldDescription,
            isIrremovable: isIrremovable
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($93f4c0f3074b28dc$export$f5aa183e0b797cbf, {
        isOpen: isOpen,
        onClose: handleClose,
        value: value,
        id: fieldId,
        searchInputPlaceholder: formatMessage((0, $4qpfH.default).searchPlaceholder, {
            fieldName: fieldDisplayName
        }),
        invalidLabel: fieldInvalidLabel,
        onChange: onChange,
        onClearValues: onClearValues,
        onLoadOptions: onLoadOptions,
        enableFullList: enableFullList,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
        onTrigger: onTrigger,
        shouldRenderToParent: true,
        showOperatorSelect: !hideOperatorDropdown,
        onChangeOperator: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator,
        isMulti: isMulti,
        experienceAnalyticsAttributes: experienceAnalyticsAttributes,
        loadingMessages: loadingMessage
    })));
};
var $93f4c0f3074b28dc$export$2e2bcd8739ae039 = $93f4c0f3074b28dc$export$4b415d703a601d69;

});
parcelRegister("6yIId", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcf2b299f58666df$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7q9BG = parcelRequire("7q9BG");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $dPMMf = parcelRequire("dPMMf");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");


var $a7CU0 = parcelRequire("a7CU0");
const $bcf2b299f58666df$var$hasValue = (value)=>Array.isArray(value) ? value.length > 0 : typeof value === 'object' && value !== null;
const $bcf2b299f58666df$var$TriggerComponent = ({ isInvalid: isInvalid = false, label: label = '', value: value, allowedOperators: allowedOperators, onChangeOperator: onChangeOperator, selectedOperator: selectedOperator, isParentPickerOpen: isParentPickerOpen, onOpenOperatorPicker: onOpenOperatorPicker, isSelected: isSelected })=>{
    if (!value || !$bcf2b299f58666df$var$hasValue(value)) return (0, $6XJko.isVisualRefreshEnabled)() && (0, $7jTnu.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $bcf2b299f58666df$var$triggerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $bcf2b299f58666df$var$triggerStyles,
        testId: (0, $332899bfd23114ba$export$743be55d5cf4a20d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        weight: "medium",
        color: !isSelected ? 'color.text.subtle' : 'inherit'
    }, label))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$LabelContainer, {
        "data-testid": (0, $332899bfd23114ba$export$743be55d5cf4a20d)
    }, label));
    const valueMap = value.map((v)=>v.optionType !== 'error' && v.label !== undefined ? v.label : '');
    const valueLength = valueMap.length;
    const [firstValue, ...rest] = valueMap;
    const badgeAppearance = isInvalid ? 'important' : 'primary';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$Container, {
        "aria-label": `${selectedOperator?.ariaLabel} ${firstValue}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$LabelContainer, {
        "data-testid": (0, $332899bfd23114ba$export$743be55d5cf4a20d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$StyledLabel, null, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a7CU0.default), {
        isInvalid: isInvalid,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator,
        onChangeOperator: onChangeOperator,
        isParentPickerOpen: isParentPickerOpen,
        onOpenOperatorPicker: onOpenOperatorPicker
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$ValueContainer, null, firstValue), valueLength > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$StyledBadge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), {
        testId: (0, $332899bfd23114ba$export$fca2db27fe6c1305),
        appearance: badgeAppearance
    }, `+${rest.length}`)) : null);
};
const $bcf2b299f58666df$var$triggerContainerStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $bcf2b299f58666df$var$triggerStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${24 * (0, $dPMMf.gridSize)}px`,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bcf2b299f58666df$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $bcf2b299f58666df$var$LabelContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _p12fd36x _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $bcf2b299f58666df$var$ValueContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _p12fd36x _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $bcf2b299f58666df$var$StyledLabel = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48pmoej _2hwx1b66",
            __cmplp.className
        ])
    });
});
const $bcf2b299f58666df$var$StyledBadge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o _18u01b66",
            __cmplp.className
        ])
    });
});
var $bcf2b299f58666df$export$2e2bcd8739ae039 = $bcf2b299f58666df$var$TriggerComponent;

});
parcelRegister("a7CU0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd94239f4d8ef829$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $eJOHy = parcelRequire("eJOHy");

var $5lAAn = parcelRequire("5lAAn");

var $8IeH1 = parcelRequire("8IeH1");

var $6XEne = parcelRequire("6XEne");
var $c4OV1 = parcelRequire("c4OV1");

var $dPMMf = parcelRequire("dPMMf");

var $f2JN3 = parcelRequire("f2JN3");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $4onsb = parcelRequire("4onsb");
const $bd94239f4d8ef829$var$baseStyle = {
    alignSelf: 'center',
    margin: 0,
    padding: 0
};
const $bd94239f4d8ef829$var$indicatorsContainerStyle = {
    root: "_3lltze3t _1onpze3t _k4bfze3t _1vxpze3t"
};
const $bd94239f4d8ef829$var$getAdditionalStyles = (isInvalid)=>({
        control: (css, props)=>({
                ...css,
                height: `${"var(--ds-space-300, 24px)"}`,
                textAlign: 'left',
                // need to overwrite existing minHeight
                minHeight: 0,
                // substracting 5 so it's never on top of main dropdown
                zIndex: (0, $dPMMf.layers).navigation - 5,
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                ...props.isDisabled ? {
                    backgroundColor: 'none',
                    borderColor: "var(--ds-text-inverse, #FFFFFF)"
                } : {}
            }),
        input: (css)=>({
                ...css,
                ...$bd94239f4d8ef829$var$baseStyle,
                height: 'inherit'
            }),
        singleValue: (css)=>({
                ...css,
                ...$bd94239f4d8ef829$var$baseStyle,
                color: "var(--ds-text-selected, #0C66E4)",
                textAlign: 'left',
                ...isInvalid ? {
                    color: "var(--ds-text-danger, #AE2E24)"
                } : {}
            }),
        valueContainer: (css)=>({
                ...css,
                ...$bd94239f4d8ef829$var$baseStyle,
                // to align horizontally
                height: '100%',
                paddingLeft: `${"var(--ds-space-050, 4px)"}`,
                paddingRight: 0
            }),
        indicatorsContainer: (css)=>({
                ...css,
                ...$bd94239f4d8ef829$var$baseStyle,
                '> div': {
                    padding: '0'
                },
                // to align horizontally
                height: '100%'
            }),
        container: (css)=>({
                ...css,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '20px',
                textAlign: 'left'
            }),
        menu: (css)=>({
                ...css,
                // no space between dropdown and trigger button
                marginTop: 0,
                width: 'fit-content',
                // substracting 4 so it's never on top of main dropdown but if on top of the picker trigger of other operator dropdowns
                zIndex: (0, $dPMMf.layers).navigation - 4
            })
    });
const $bd94239f4d8ef829$var$TEST_ID_DROPDOWN = 'jql-builder-basic.common.ui.picker-trigger.dropdown-operator.dropdown-operator';
const $bd94239f4d8ef829$var$getOptionLabel = (option)=>option.ariaLabel;
const $bd94239f4d8ef829$var$formatOptionLabel = (option)=>option.shortLabel;
const $bd94239f4d8ef829$var$DropdownOperator = ({ allowedOperators: allowedOperators, selectedOperator: selectedOperator = allowedOperators[0], onChangeOperator: onChangeOperator, isParentPickerOpen: isParentPickerOpen, onOpenOperatorPicker: onOpenOperatorPicker, isInvalid: isInvalid })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChangeOperatorWithAnalytics = (0, $eJOHy.useCallback)((option)=>{
        onChangeOperator && onChangeOperator(option);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        option && (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            option: option.value,
            selectType: 'inline'
        });
    }, [
        createAnalyticsEvent,
        onChangeOperator
    ]);
    const SingleValue = (0, $eJOHy.useCallback)(({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).SingleValue, props, selectedOperator?.valueLabel), [
        selectedOperator?.valueLabel
    ]);
    const DropdownIndicator = (0, $eJOHy.useCallback)((props)=>{
        let primaryColor = "var(--ds-text-selected, #0C66E4)";
        if (props.isDisabled) primaryColor = "var(--ds-text-inverse, #FFFFFF)";
        else if (isInvalid) primaryColor = "var(--ds-text-danger, #AE2E24)";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).DropdownIndicator, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd94239f4d8ef829$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            testId: "jql-builder-basic.common.ui.picker-trigger.dropdown-operator.chevron-down-icon",
            label: "",
            color: primaryColor,
            LEGACY_primaryColor: primaryColor,
            size: "small"
        })));
    }, [
        isInvalid
    ]);
    const onMenuOpenAnalytics = (0, $eJOHy.useCallback)(()=>{
        onOpenOperatorPicker();
        const analyticsEvent = createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            selectType: 'inline'
        });
    }, [
        createAnalyticsEvent,
        onOpenOperatorPicker
    ]);
    const dropdownOperatorComponents = (0, $eJOHy.useMemo)(()=>({
            DropdownIndicator: DropdownIndicator,
            SingleValue: SingleValue,
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).IndicatorsContainer, {
                    ...props,
                    xcss: $bd94239f4d8ef829$var$indicatorsContainerStyle.root
                })
        }), [
        DropdownIndicator,
        SingleValue
    ]);
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingInlineStart: "space.025",
        paddingInlineEnd: "space.050",
        onClick: (event)=>{
            !isParentPickerOpen && event.stopPropagation();
        },
        role: "presentation",
        onKeyDown: (event)=>{
            // Prevent issue list from capturing arrow up and down keys, prevent closing a modal on escape key
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Escape') event.stopPropagation();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        "aria-label": formatMessage((0, $4onsb.default).operatorLabel),
        testId: $bd94239f4d8ef829$var$TEST_ID_DROPDOWN,
        components: dropdownOperatorComponents,
        spacing: "compact",
        appearance: "subtle",
        styles: $bd94239f4d8ef829$var$getAdditionalStyles(isInvalid),
        value: selectedOperator,
        options: allowedOperators,
        onChange: onChangeOperatorWithAnalytics,
        getOptionLabel: $bd94239f4d8ef829$var$getOptionLabel,
        formatOptionLabel: $bd94239f4d8ef829$var$formatOptionLabel,
        isDisabled: isParentPickerOpen,
        isInvalid: isInvalid,
        isSearchable: false,
        onMenuOpen: onMenuOpenAnalytics
    })));
};
var $bd94239f4d8ef829$export$2e2bcd8739ae039 = $bd94239f4d8ef829$var$DropdownOperator;
const $bd94239f4d8ef829$var$IconContainer = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingInline: "space.075"
    }, children), (0, $eJOHy.Fragment));

});
parcelRegister("4onsb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e1e72d7652d30e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f1e1e72d7652d30e$var$messages = (0, $7qGN1.defineMessages)({
    operatorLabel: {
        "id": "jql-builder-basic.common.picker-trigger.dropdown-operator.operator-label",
        "defaultMessage": "Operator dropdown"
    }
});
var $f1e1e72d7652d30e$export$2e2bcd8739ae039 = $f1e1e72d7652d30e$var$messages;

});



parcelRegister("4qpfH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0e3ee1393a7b533$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f0e3ee1393a7b533$var$messages = (0, $7qGN1.defineMessages)({
    searchPlaceholder: {
        "id": "jql-builder-basic.picker-loader.search-placeholder",
        "defaultMessage": "Search {fieldName}"
    },
    loadingMessageStart: {
        "id": "jql-builder-basic.picker-loader.loading-message-start",
        "defaultMessage": "{fieldName}: Loading more"
    },
    loadingMessageEnd: {
        "id": "jql-builder-basic.picker-loader.loading-message-end",
        "defaultMessage": "{fieldName}: Finished loading"
    }
});
var $f0e3ee1393a7b533$export$2e2bcd8739ae039 = $f0e3ee1393a7b533$var$messages;

});


parcelRegister("5atdb", function(module, exports) {

$parcel$export(module.exports, "getPickerProps", () => $0a786da442a7a73a$export$3dc4888d75a40889);

var $eqSys = parcelRequire("eqSys");

var $eiIzV = parcelRequire("eiIzV");

var $jZgio = parcelRequire("jZgio");

var $7porm = parcelRequire("7porm");

var $kPoTo = parcelRequire("kPoTo");

var $3q8Sy = parcelRequire("3q8Sy");

var $lVLIX = parcelRequire("lVLIX");

var $3bnsV = parcelRequire("3bnsV");

var $3Tke1 = parcelRequire("3Tke1");
const $0a786da442a7a73a$export$3dc4888d75a40889 = ({ fieldId: fieldId, propType: propType, searchTemplate: searchTemplate, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, projectOptions: projectOptions, viewContext: viewContext, scope: scope, suggestedUsersCount: suggestedUsersCount })=>{
    const commonProps = {
        fieldId: fieldId,
        searchTemplate: searchTemplate,
        propType: propType,
        formatMessage: formatMessage,
        jql: jql,
        environment: environment,
        cloudId: cloudId,
        operandDisplayValues: (0, $jZgio.getValidOperandDisplayValues)(propType),
        viewContext: viewContext,
        scope: scope,
        suggestedUsersCount: suggestedUsersCount
    };
    if (!(0, $eiIzV.isPickerPropType)(propType)) throw new Error(`Unsupported PickerPropType: ${propType}`);
    switch(propType){
        case (0, $eqSys.PickerPropTypes).IssueType:
            return (0, $3q8Sy.getIssueTypeProps)(commonProps);
        case (0, $eqSys.PickerPropTypes).User:
            return (0, $lVLIX.getPeopleProps)(commonProps);
        case (0, $eqSys.PickerPropTypes).Sprint:
            return (0, $3Tke1.getSprintProps)(commonProps);
        case (0, $eqSys.PickerPropTypes).Common:
            return (0, $7porm.getCommonProps)(commonProps);
        case (0, $eqSys.PickerPropTypes).CommonWithEmpty:
        case (0, $eqSys.PickerPropTypes).Version:
            return (0, $7porm.getCommonProps)({
                ...commonProps,
                showOperandDisplayValuesInFullList: true
            });
        case (0, $eqSys.PickerPropTypes).Project:
            return (0, $3bnsV.getProjectProps)({
                ...commonProps,
                projectOptions: projectOptions
            });
        case (0, $eqSys.PickerPropTypes).Group:
            return (0, $kPoTo.getGroupProps)(commonProps);
        default:
            throw new Error(`Unsupported PickerPropType: ${propType}`);
    }
};

});
parcelRegister("jZgio", function(module, exports) {

$parcel$export(module.exports, "getValidOperandNames", () => $8327937554fcf4bb$export$1917025b3a772e5);
$parcel$export(module.exports, "getValidOperandDisplayValues", () => $8327937554fcf4bb$export$7b0867b4bdc21cd8);

var $5PQOA = parcelRequire("5PQOA");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");
const $8327937554fcf4bb$export$1917025b3a772e5 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((propType)=>{
    switch(propType){
        case (0, $eqSys.PickerPropTypes).IssueType:
            return [
                (0, $dTJxm.FunctionName).standardIssueTypes,
                (0, $dTJxm.FunctionName).subTaskIssueTypes
            ];
        case (0, $eqSys.PickerPropTypes).User:
            return [
                (0, $dTJxm.FunctionName).currentUser,
                (0, $dTJxm.KeywordName).empty,
                (0, $dTJxm.FunctionName).membersOf
            ];
        case (0, $eqSys.PickerPropTypes).CommonWithEmpty:
        case (0, $eqSys.PickerPropTypes).Sprint:
            return [
                (0, $dTJxm.KeywordName).empty
            ];
        case (0, $eqSys.PickerPropTypes).Version:
            return [
                (0, $dTJxm.KeywordName).empty,
                (0, $dTJxm.FunctionName).releasedVersions,
                (0, $dTJxm.FunctionName).unreleasedVersions
            ];
        default:
    }
    return undefined;
});
const $8327937554fcf4bb$export$7b0867b4bdc21cd8 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((propType)=>$8327937554fcf4bb$export$1917025b3a772e5(propType)?.map((name)=>(0, $dTJxm.OperandValues)[name].value));

});

parcelRegister("7porm", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $03dac207aa852f1a$export$6df0712d20d2cc08);
$parcel$export(module.exports, "getCommonProps", () => $03dac207aa852f1a$export$fa723cfebd5684f9);

var $iiYNp = parcelRequire("iiYNp");

var $j4oe4 = parcelRequire("j4oe4");


var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $cb5xP = parcelRequire("cb5xP");

var $65vFU = parcelRequire("65vFU");

var $jZgio = parcelRequire("jZgio");

var $9fWxr = parcelRequire("9fWxr");
const $03dac207aa852f1a$export$6df0712d20d2cc08 = (node, itemType)=>{
    const { displayName: displayName, jqlTerm: jqlTerm, __typename: __typename } = node;
    const option = {
        label: displayName,
        value: jqlTerm,
        optionType: 'option',
        itemType: itemType
    };
    if (__typename === 'JiraJqlPriorityFieldValue' && node.priority && node.priority.iconUrl) return {
        ...option,
        icon: node.priority.iconUrl
    };
    if ((__typename === 'JiraJqlStatusFieldValue' || __typename === 'JiraJqlStatusCategoryFieldValue') && node.statusCategory) {
        const { colorName: colorName } = node.statusCategory;
        return {
            ...option,
            optionType: 'lozenge',
            appearance: (0, $9fWxr.getLozengeAppearance)(colorName)
        };
    }
    if (__typename === 'JiraJqlIssueFieldValue' && node.issue && node.issue.fields && node.issue.fields.edges && node.issue.fields.edges[0] && node.issue.fields.edges[0].node && node.issue.fields.edges[0].node.text !== undefined && node.issue.fields.edges[0].node.text !== null) return {
        ...option,
        label: node.issue.fields.edges[0].node.text,
        secondaryLabel: option.label
    };
    return option;
};
const $03dac207aa852f1a$export$fa723cfebd5684f9 = ({ fieldId: fieldId, propType: propType, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: false,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList || undefined,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            const after = endCursor;
            try {
                const data = await (0, $j4oe4.fetchQuery)(environment, (0, $iiYNp.default), {
                    cloudId: cloudId,
                    first: 10,
                    jqlTerm: fieldId.toLowerCase(),
                    jql: jql || '',
                    searchString: search,
                    after: after,
                    viewContext: viewContext
                }, {
                    fetchPolicy: 'store-or-network'
                }).toPromise();
                const operandOptions = showOperandDisplayValuesInFullList ? ((0, $jZgio.getValidOperandNames)(propType) ?? []).map((name)=>({
                        label: (0, $dTJxm.OperandValues)[name].type === (0, $862dfd240457f00b$export$f6049126fd97001f) ? (0, $cb5xP.getEmptyLabel)(searchTemplate ?? null, formatMessage) : (0, $65vFU.getFunctionLabel)(name, formatMessage),
                        value: (0, $dTJxm.OperandValues)[name].value,
                        optionType: 'option',
                        itemType: (0, $dTJxm.OperandValues)[name].type
                    })) : [];
                if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $eiIzV.generateOptions)([
                    ...operandOptions
                ]);
                const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
                return (0, $eiIzV.generateOptions)([
                    ...search.length === 0 && !endCursor ? operandOptions : [],
                    ...fieldValues.reduce((options, edges)=>{
                        if (!edges || !edges.node) return options;
                        const { node: node } = edges;
                        options.push($03dac207aa852f1a$export$6df0712d20d2cc08(node, (0, $862dfd240457f00b$export$38accfc5a5d1c113)));
                        return options;
                    }, [])
                ], totalCount, pageInfo?.endCursor || undefined);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eiIzV.fireJqlBuilderBasicErrorAnalytics)('commonJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $eiIzV.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("iiYNp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5135e7cff34ffb7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<95602755025a1134fb7a37aa1d85e952>>
 * @relayHash 8640e63348e5d925f93816e53f6c5b01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e831c84bdd8946040c19eb688135440ba952ad04b564b51cc4edbcd136cd7b02
const $a5135e7cff34ffb7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "ScalarField",
        "name": "colorName"
    }, v15 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                v14 /*: any*/ 
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                v14 /*: any*/ ,
                v18 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "commonJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v10 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11 /*: any*/ ,
                                                            v12 /*: any*/ ,
                                                            v13 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v15 /*: any*/ ,
                                                                "type": "JiraJqlStatusFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v16 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlPriorityFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v15 /*: any*/ ,
                                                                "type": "JiraJqlStatusCategoryFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "issue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "fields",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v17 /*: any*/ 
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "commonJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v19 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v19 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e831c84bdd8946040c19eb688135440ba952ad04b564b51cc4edbcd136cd7b02",
            "metadata": {},
            "name": "commonJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a5135e7cff34ffb7$var$node.hash = "287a2bf3ddbdda31cd84a0d1afbcfa31";
var $a5135e7cff34ffb7$export$2e2bcd8739ae039 = $a5135e7cff34ffb7$var$node;

});

parcelRegister("cb5xP", function(module, exports) {

$parcel$export(module.exports, "getEmptyLabel", () => $8b37b510820a2509$export$b77f75d3ab7bfc24);

var $dbAgy = parcelRequire("dbAgy");
const $8b37b510820a2509$export$b77f75d3ab7bfc24 = (searchTemplate, formatMessage)=>{
    const message = (0, $dbAgy.messageLookup)[searchTemplate];
    if (message) return formatMessage(message);
    return formatMessage((0, $dbAgy.messages).genericEmpty);
};

});
parcelRegister("dbAgy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $35ea1f857982d6fd$export$defe85febe8b728c);
$parcel$export(module.exports, "messageLookup", () => $35ea1f857982d6fd$export$3a16bd55b6aaaf91);

var $7qGN1 = parcelRequire("7qGN1");

var $dTJxm = parcelRequire("dTJxm");
const $35ea1f857982d6fd$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.ASSIGNEE).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.assignee",
        "defaultMessage": "Unassigned"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.REPORTER).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.reporter-new",
        "defaultMessage": "Anonymous"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.CREATOR).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.creator",
        "defaultMessage": "Anonymous"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.COMPONENT).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.components",
        "defaultMessage": "No component"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.PARENT).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.parent",
        "defaultMessage": "No parent"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.FIX_VERSION).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.fix-versions",
        "defaultMessage": "No version"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.AFFECTED_VERSION).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.versions",
        "defaultMessage": "No version"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    'com.atlassian.jira.plugin.system.customfieldtypes:versionsearcher': {
        "id": "jql-builder-basic.utils.get-empty-label.custom-versions",
        "defaultMessage": "No version"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.EPIC_LINK).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.epic-link-new",
        "defaultMessage": "No epic link"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.SPRINT).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.sprint-new",
        "defaultMessage": "No sprint"
    },
    genericEmpty: {
        "id": "jql-builder-basic.utils.get-empty-label.generic-empty",
        "defaultMessage": "Empty"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    'epic link': {
        "id": "jql-builder-basic.utils.get-empty-label.epic-link",
        "defaultMessage": "No epic link"
    },
    sprint: {
        "id": "jql-builder-basic.utils.get-empty-label.sprint",
        "defaultMessage": "No sprint"
    }
});
const $35ea1f857982d6fd$export$3a16bd55b6aaaf91 = $35ea1f857982d6fd$export$defe85febe8b728c;

});


parcelRegister("65vFU", function(module, exports) {

$parcel$export(module.exports, "getFunctionLabel", () => $cd851674220e71c5$export$2d3d5a019b7ffccf);

var $epTsa = parcelRequire("epTsa");

var $jUYSN = parcelRequire("jUYSN");
const $cd851674220e71c5$export$2d3d5a019b7ffccf = (name, formatMessage)=>{
    let messageKey = name.toLowerCase();
    if ((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) {
        const refreshedMessageKey = `${messageKey}IssueTermRefresh`;
        if (refreshedMessageKey in (0, $jUYSN.default)) messageKey = refreshedMessageKey;
    }
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ subtaskissuetypes: MessageDescriptorV2; standardissuetypes: MessageDescriptorV2; currentuser: MessageDescriptorV2; }'.
    const message = (0, $jUYSN.default)[messageKey];
    if (message) return formatMessage(message);
    return name;
};

});
parcelRegister("jUYSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8432e062247db1af$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8432e062247db1af$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    currentuser: {
        "id": "jql-builder-basic.utils.get-function-label.currentuser",
        "defaultMessage": "Current User"
    },
    standardissuetypes: {
        "id": "jql-builder-basic.utils.get-function-label.standardissuetypes",
        "defaultMessage": "All standard issue types"
    },
    subtaskissuetypes: {
        "id": "jql-builder-basic.utils.get-function-label.subtaskissuetypes",
        "defaultMessage": "All sub-task issue types"
    },
    releasedversions: {
        "id": "jql-builder-basic.utils.get-function-label.releasedversions",
        "defaultMessage": "All Released Versions"
    },
    unreleasedversions: {
        "id": "jql-builder-basic.utils.get-function-label.unreleasedversions",
        "defaultMessage": "All Unreleased Versions"
    },
    standardissuetypesIssueTermRefresh: {
        "id": "jql-builder-basic.utils.get-function-label.standardissuetypes-issue-term-refresh",
        "defaultMessage": "All standard work types"
    },
    subtaskissuetypesIssueTermRefresh: {
        "id": "jql-builder-basic.utils.get-function-label.subtaskissuetypes-issue-term-refresh",
        "defaultMessage": "All sub-tasks"
    }
});

});


parcelRegister("9fWxr", function(module, exports) {

$parcel$export(module.exports, "getLozengeAppearance", () => $172686d3950f7f7a$export$4d9e331cafeacb9d);

var $dTJxm = parcelRequire("dTJxm");
const $172686d3950f7f7a$export$4d9e331cafeacb9d = (colorName)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (colorName && Object.keys((0, $dTJxm.appearanceMap)).includes(colorName)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $dTJxm.appearanceMap)[colorName];
    return undefined;
};

});


parcelRegister("kPoTo", function(module, exports) {

$parcel$export(module.exports, "getGroupProps", () => $0aad662277c3e921$export$acaa9db88ea2a755);

var $04t3y = parcelRequire("04t3y");

var $kVjFI = parcelRequire("kVjFI");

var $j4oe4 = parcelRequire("j4oe4");


var $eiIzV = parcelRequire("eiIzV");

var $kldev = parcelRequire("kldev");
const $0aad662277c3e921$var$getSuggestedOptions = async ({ environment: environment, cloudId: cloudId, formatMessage: formatMessage })=>{
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $kVjFI.default), {
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.suggestedGroups?.edges) return (0, $eiIzV.generateOptions)([]);
    const groups = data?.jira?.jqlBuilder?.suggestedGroups?.edges?.reduce((options, edge)=>{
        if (!edge || !edge.node) return options;
        const { node: node } = edge;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            isGroup: true,
            itemType: (0, $862dfd240457f00b$export$38accfc5a5d1c113)
        });
        return options;
    }, []) || [];
    const options = [
        {
            label: formatMessage((0, $kldev.default).refinementOptionSuggestedGroups),
            optionType: 'group',
            options: groups
        }
    ];
    return (0, $eiIzV.generateOptions)(options);
};
const $0aad662277c3e921$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, lowerCaseFieldId: lowerCaseFieldId, jql: jql, search: search, endCursor: endCursor, viewContext: viewContext })=>{
    const after = endCursor;
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $04t3y.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: lowerCaseFieldId,
        jql: jql || '',
        searchString: search,
        after: after,
        viewContext: viewContext
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $eiIzV.generateOptions)([]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    return (0, $eiIzV.generateOptions)(fieldValues.reduce((options, edge)=>{
        if (!edge || !edge.node) return options;
        const { node: node } = edge;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            isGroup: true,
            itemType: (0, $862dfd240457f00b$export$38accfc5a5d1c113)
        });
        return options;
    }, []), totalCount, pageInfo?.endCursor || undefined);
};
const $0aad662277c3e921$export$acaa9db88ea2a755 = ({ fieldId: fieldId, operandDisplayValues: operandDisplayValues, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $0aad662277c3e921$var$getSuggestedOptions({
                    environment: environment,
                    cloudId: cloudId,
                    formatMessage: formatMessage
                });
                return await $0aad662277c3e921$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    lowerCaseFieldId: fieldId.toLowerCase(),
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eiIzV.fireJqlBuilderBasicErrorAnalytics)('groupJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $eiIzV.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("04t3y", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e401f50532df595$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<147dc64cb2bca6b7a230336a320aef2e>>
 * @relayHash 06c4d66e23835ebc572846a0efd865a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d4982c6eb0de3a1f0d61be5e83b4457823ceed6631a0abe4509a993a35a9c371
const $1e401f50532df595$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "groupJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v10 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11 /*: any*/ ,
                                                            v12 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "groupJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d4982c6eb0de3a1f0d61be5e83b4457823ceed6631a0abe4509a993a35a9c371",
            "metadata": {},
            "name": "groupJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1e401f50532df595$var$node.hash = "3750697c009021fb29b02b6b38567062";
var $1e401f50532df595$export$2e2bcd8739ae039 = $1e401f50532df595$var$node;

});

parcelRegister("kVjFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $007f48cf194fefb3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2cf28df69801d2e8d4ca1f516b897779>>
 * @relayHash 4242efb1e1867c214b21bde3f239c032
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d6bf7b889b129263d1bfecb23143f0126ab23fbd7882e0ce40044a8c0c3293d
const $007f48cf194fefb3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "context",
                                "value": "GROUP"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 10
                            }
                        ],
                        "concreteType": "JiraJqlGroupFieldValueConnection",
                        "kind": "LinkedField",
                        "name": "suggestedGroups",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraJqlGroupFieldValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraJqlGroupFieldValue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "jqlTerm"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "suggestedGroups(context:\"GROUP\",first:10)"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "groupJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "groupJqlBuilderBasicInitQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "5d6bf7b889b129263d1bfecb23143f0126ab23fbd7882e0ce40044a8c0c3293d",
            "metadata": {},
            "name": "groupJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$007f48cf194fefb3$var$node.hash = "89effe1db6e447cbb0e66d80074d1b0b";
var $007f48cf194fefb3$export$2e2bcd8739ae039 = $007f48cf194fefb3$var$node;

});

parcelRegister("kldev", function(module, exports) {

$parcel$export(module.exports, "default", () => $b677e4b43da380ad$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b677e4b43da380ad$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    refinementOptionSuggestedGroups: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.group.refinement-option-suggested-groups",
        "defaultMessage": "Suggested Groups"
    }
});

});


parcelRegister("3q8Sy", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $582df2399a38b329$export$6df0712d20d2cc08);
$parcel$export(module.exports, "getIssueTypeProps", () => $582df2399a38b329$export$912584a67029924);

var $2Es8K = parcelRequire("2Es8K");

var $eszwa = parcelRequire("eszwa");

var $j4oe4 = parcelRequire("j4oe4");


var $epTsa = parcelRequire("epTsa");

var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $65vFU = parcelRequire("65vFU");

var $iDtDh = parcelRequire("iDtDh");
const $582df2399a38b329$var$getFirstIssueTypeAvatar = (node)=>node.issueTypes?.find((issueType)=>typeof issueType.avatar?.xsmall === 'string' && issueType.avatar.xsmall.length > 0)?.avatar?.xsmall;
const $582df2399a38b329$export$6df0712d20d2cc08 = (node, itemType)=>{
    const { displayName: displayName, jqlTerm: jqlTerm } = node;
    const option = {
        label: displayName,
        value: jqlTerm,
        optionType: 'option',
        itemType: itemType
    };
    if (node.issueTypes) return {
        ...option,
        optionType: 'avatar',
        avatar: $582df2399a38b329$var$getFirstIssueTypeAvatar(node),
        square: true,
        itemType: itemType
    };
    return option;
};
const $582df2399a38b329$var$getInitialOptions = async ({ environment: environment, cloudId: cloudId, jql: jql, formatMessage: formatMessage })=>{
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $eszwa.default), {
        cloudId: cloudId,
        jql: jql || ''
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const issueTypes = data?.jira?.jqlBuilder?.issueTypes;
    if (!issueTypes) return (0, $eiIzV.generateOptions)([]);
    const aboveBaseLevelTypes = issueTypes?.aboveBaseLevel?.edges || [];
    const baseLevelTypes = issueTypes?.baseLevel?.edges || [];
    const belowBaseLevelTypes = issueTypes?.belowBaseLevel?.edges || [];
    const standardTypes = aboveBaseLevelTypes.concat(baseLevelTypes).reduce((options, edges)=>{
        if (edges?.node === undefined || edges?.node === null) return options;
        const { node: node } = edges;
        if (node !== undefined && node !== null) options.push($582df2399a38b329$export$6df0712d20d2cc08(node, (0, $862dfd240457f00b$export$38accfc5a5d1c113)));
        return options;
    }, []);
    const subtaskTypes = belowBaseLevelTypes.reduce((options, edges)=>{
        if (edges?.node === undefined || edges?.node === null) return options;
        const { node: node } = edges;
        if (node !== undefined && node !== null) options.push($582df2399a38b329$export$6df0712d20d2cc08(node, (0, $862dfd240457f00b$export$38accfc5a5d1c113)));
        return options;
    }, []);
    const standardGroupOption = [
        {
            label: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iDtDh.default).refinementSubtitleStandardIssueTypesIssueTermRefresh : (0, $iDtDh.default).refinementSubtitleStandardIssueTypes),
            optionType: 'group',
            options: standardTypes
        }
    ];
    const subtaskGroupOption = [
        {
            label: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iDtDh.default).refinementSubtitleSubTaskIssueTypesIssueTermRefresh : (0, $iDtDh.default).refinementSubtitleSubTaskIssueTypes),
            optionType: 'group',
            options: subtaskTypes
        }
    ];
    return (0, $eiIzV.generateOptions)([
        {
            label: (0, $65vFU.getFunctionLabel)('standardIssueTypes', formatMessage),
            value: (0, $dTJxm.OperandValues).standardIssueTypes.value,
            optionType: 'avatar',
            hideAvatar: true,
            itemType: (0, $862dfd240457f00b$export$19c7c729db381f9d)
        },
        {
            label: (0, $65vFU.getFunctionLabel)('subTaskIssueTypes', formatMessage),
            value: (0, $dTJxm.OperandValues).subTaskIssueTypes.value,
            optionType: 'avatar',
            hideAvatar: true,
            itemType: (0, $862dfd240457f00b$export$19c7c729db381f9d)
        },
        ...Array.isArray(standardTypes) && standardTypes.length > 0 ? standardGroupOption : [],
        ...Array.isArray(subtaskTypes) && subtaskTypes.length > 0 ? subtaskGroupOption : []
    ]);
};
const $582df2399a38b329$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, lowerCaseFieldId: lowerCaseFieldId, jql: jql, search: search, endCursor: endCursor, viewContext: viewContext, scope: scope = null })=>{
    const after = endCursor;
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $2Es8K.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: lowerCaseFieldId,
        jql: jql || '',
        searchString: search,
        after: after,
        viewContext: viewContext,
        scope: scope
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $eiIzV.generateOptions)([]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    return (0, $eiIzV.generateOptions)(fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        if (node !== undefined && node !== null) options.push($582df2399a38b329$export$6df0712d20d2cc08(node, (0, $862dfd240457f00b$export$38accfc5a5d1c113)));
        return options;
    }, []), totalCount, pageInfo.endCursor || undefined);
};
const $582df2399a38b329$export$912584a67029924 = ({ fieldId: fieldId, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $582df2399a38b329$var$getInitialOptions({
                    environment: environment,
                    cloudId: cloudId,
                    jql: jql,
                    formatMessage: formatMessage
                });
                return await $582df2399a38b329$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    lowerCaseFieldId: fieldId.toLowerCase(),
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eiIzV.fireJqlBuilderBasicErrorAnalytics)('issueTypeJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $eiIzV.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("2Es8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ac93a6a393332bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<83e8c97b8e436c40614c32510fbd2730>>
 * @relayHash 30538de95cec3c3cdff68eadc99f2abd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 656a65d09fbea171572af0068266d364b84a8e0e6face2f36475662ed790295c
const $0ac93a6a393332bf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTypeJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v8 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v9 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v10 /*: any*/ ,
                                            v11 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v12 /*: any*/ ,
                                                            v13 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueTypeFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueTypeJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "656a65d09fbea171572af0068266d364b84a8e0e6face2f36475662ed790295c",
            "metadata": {},
            "name": "issueTypeJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0ac93a6a393332bf$var$node.hash = "8a0afa1c6c431e628b55f9e4f56ffde8";
var $0ac93a6a393332bf$export$2e2bcd8739ae039 = $0ac93a6a393332bf$var$node;

});

parcelRegister("eszwa", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf7ecd8b0dad74a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6074d0f3e024b0012bb1972fe1478635>>
 * @relayHash acb29e4100939579dcd3416df9471194
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7a787d89ed618a815e9879150e4bc32d1810382544bfced47ff3503e5a3ee9d3
const $ccf7ecd8b0dad74a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v7 = [
        {
            "concreteType": "JiraJqlIssueTypeFieldValueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraJqlIssueTypeFieldValue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueTypes",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v8 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 3
        }
    ], v9 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 5
        }
    ], v10 = [
        {
            "concreteType": "JiraJqlIssueTypeFieldValueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraJqlIssueTypeFieldValue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueTypes",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueTypeJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "concreteType": "JiraJqlIssueTypes",
                                        "kind": "LinkedField",
                                        "name": "issueTypes",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": v3 /*: any*/ ,
                                                "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                                "kind": "LinkedField",
                                                "name": "aboveBaseLevel",
                                                "plural": false,
                                                "selections": v7 /*: any*/ ,
                                                "storageKey": "aboveBaseLevel(first:2)"
                                            },
                                            {
                                                "args": v8 /*: any*/ ,
                                                "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                                "kind": "LinkedField",
                                                "name": "baseLevel",
                                                "plural": false,
                                                "selections": v7 /*: any*/ ,
                                                "storageKey": "baseLevel(first:3)"
                                            },
                                            {
                                                "args": v9 /*: any*/ ,
                                                "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                                "kind": "LinkedField",
                                                "name": "belowBaseLevel",
                                                "plural": false,
                                                "selections": v7 /*: any*/ ,
                                                "storageKey": "belowBaseLevel(first:5)"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueTypeJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraJqlIssueTypes",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                            "kind": "LinkedField",
                                            "name": "aboveBaseLevel",
                                            "plural": false,
                                            "selections": v10 /*: any*/ ,
                                            "storageKey": "aboveBaseLevel(first:2)"
                                        },
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                            "kind": "LinkedField",
                                            "name": "baseLevel",
                                            "plural": false,
                                            "selections": v10 /*: any*/ ,
                                            "storageKey": "baseLevel(first:3)"
                                        },
                                        {
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                            "kind": "LinkedField",
                                            "name": "belowBaseLevel",
                                            "plural": false,
                                            "selections": v10 /*: any*/ ,
                                            "storageKey": "belowBaseLevel(first:5)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7a787d89ed618a815e9879150e4bc32d1810382544bfced47ff3503e5a3ee9d3",
            "metadata": {},
            "name": "issueTypeJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ccf7ecd8b0dad74a$var$node.hash = "b67b86d33998fb54b3dd5cfc1247f7e1";
var $ccf7ecd8b0dad74a$export$2e2bcd8739ae039 = $ccf7ecd8b0dad74a$var$node;

});

parcelRegister("iDtDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e43ded24d27d85bd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e43ded24d27d85bd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    refinementOptionAllStandardIssues: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-standard-issues",
        "defaultMessage": "All standard issue types"
    },
    refinementOptionAllSubTaskIssues: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-sub-task-issues",
        "defaultMessage": "All sub-task issue types"
    },
    refinementSubtitleStandardIssueTypes: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-standard-issue-types",
        "defaultMessage": "Standard issue types"
    },
    refinementSubtitleSubTaskIssueTypes: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-sub-task-issue-types",
        "defaultMessage": "Sub-task issue types"
    },
    refinementOptionAllStandardIssuesIssueTermRefresh: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-standard-issues-issue-term-refresh",
        "defaultMessage": "All standard work types"
    },
    refinementOptionAllSubTaskIssuesIssueTermRefresh: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-sub-task-issues-issue-term-refresh",
        "defaultMessage": "All sub-tasks"
    },
    refinementSubtitleStandardIssueTypesIssueTermRefresh: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-standard-issue-types-issue-term-refresh",
        "defaultMessage": "Standard work types"
    },
    refinementSubtitleSubTaskIssueTypesIssueTermRefresh: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-sub-task-issue-types-issue-term-refresh",
        "defaultMessage": "Subtasks"
    }
});

});


parcelRegister("lVLIX", function(module, exports) {

$parcel$export(module.exports, "getPeopleProps", () => $5cf45e06c061731f$export$c4faa1f798289cbf);

var $jI42G = parcelRequire("jI42G");

var $h5ChR = parcelRequire("h5ChR");

var $j4oe4 = parcelRequire("j4oe4");


var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $cb5xP = parcelRequire("cb5xP");

var $65vFU = parcelRequire("65vFU");

var $ilCyB = parcelRequire("ilCyB");
const $5cf45e06c061731f$var$getSuggestedOptions = async ({ environment: environment, cloudId: cloudId, searchTemplate: searchTemplate, formatMessage: formatMessage, suggestedUsersCount: suggestedUsersCount = 5 })=>{
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $h5ChR.default), {
        cloudId: cloudId,
        suggestedUsersCount: suggestedUsersCount
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.recentlyUsedUsers?.edges) return (0, $eiIzV.generateOptions)([]);
    const users = data?.jira?.jqlBuilder?.recentlyUsedUsers?.edges.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            avatar: node.user?.picture,
            itemType: (0, $862dfd240457f00b$export$38accfc5a5d1c113)
        });
        return options;
    }, []);
    const groups = data?.jira?.jqlBuilder?.suggestedGroups?.edges?.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            isGroup: true,
            itemType: (0, $862dfd240457f00b$export$19c7c729db381f9d)
        });
        return options;
    }, []) || [];
    const emptyLabel = (0, $cb5xP.getEmptyLabel)(searchTemplate ?? null, formatMessage);
    const options = [
        {
            label: (0, $65vFU.getFunctionLabel)('currentUser', formatMessage),
            value: (0, $dTJxm.OperandValues).currentUser.value,
            optionType: 'avatar',
            avatar: data?.me?.user?.picture,
            itemType: (0, $862dfd240457f00b$export$19c7c729db381f9d)
        },
        {
            label: emptyLabel,
            optionType: 'avatar',
            value: (0, $dTJxm.OperandValues).empty.value,
            itemType: (0, $862dfd240457f00b$export$f6049126fd97001f)
        },
        {
            label: formatMessage((0, $ilCyB.default).refinementOptionSuggestedUsers),
            optionType: 'group',
            options: users
        }
    ];
    options.push({
        label: formatMessage((0, $ilCyB.default).refinementOptionSuggestedGroups),
        optionType: 'group',
        options: groups
    });
    return (0, $eiIzV.generateOptions)(options);
};
const $5cf45e06c061731f$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, lowerCaseFieldId: lowerCaseFieldId, jql: jql, search: search, endCursor: endCursor, viewContext: viewContext })=>{
    const after = endCursor;
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $jI42G.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: lowerCaseFieldId,
        jql: jql || '',
        searchString: search,
        after: after,
        viewContext: viewContext
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $eiIzV.generateOptions)([]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    return (0, $eiIzV.generateOptions)(fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            avatar: node.user?.picture,
            ...node.__typename === 'JiraJqlGroupFieldValue' ? {
                isGroup: true,
                itemType: (0, $862dfd240457f00b$export$19c7c729db381f9d)
            } : {
                itemType: (0, $862dfd240457f00b$export$38accfc5a5d1c113)
            }
        });
        return options;
    }, []), totalCount, pageInfo?.endCursor || undefined);
};
const $5cf45e06c061731f$export$c4faa1f798289cbf = ({ fieldId: fieldId, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext, suggestedUsersCount: suggestedUsersCount })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $5cf45e06c061731f$var$getSuggestedOptions({
                    environment: environment,
                    cloudId: cloudId,
                    fieldId: fieldId,
                    searchTemplate: searchTemplate,
                    formatMessage: formatMessage,
                    suggestedUsersCount: suggestedUsersCount
                });
                return await $5cf45e06c061731f$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    lowerCaseFieldId: fieldId.toLowerCase(),
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eiIzV.fireJqlBuilderBasicErrorAnalytics)('peopleJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $eiIzV.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("jI42G", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7c303b3c9ecf207$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6967d117ea6f27382f145acf7656350d>>
 * @relayHash 12d33ba0d4f7005558a90b51b7f8972a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9a16b4ab65b19abc2908fd11e6e008e1ae9a5d76096455dab5aea9cc79f7f3fe
const $f7c303b3c9ecf207$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "peopleJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v10 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11 /*: any*/ ,
                                                            v12 /*: any*/ ,
                                                            v13 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlUserFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "peopleJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9a16b4ab65b19abc2908fd11e6e008e1ae9a5d76096455dab5aea9cc79f7f3fe",
            "metadata": {},
            "name": "peopleJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f7c303b3c9ecf207$var$node.hash = "58da705b88c7cc909a92b46593be279d";
var $f7c303b3c9ecf207$export$2e2bcd8739ae039 = $f7c303b3c9ecf207$var$node;

});

parcelRegister("h5ChR", function(module, exports) {

$parcel$export(module.exports, "default", () => $790ca30b1c43e45b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c5b2b2d7f16455667801cc7af16014d7>>
 * @relayHash 60854f32bffe29af2901e4add654f964
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f3dcddb111bd3a875a7fe72854ff370624a9ff146bf6085aa9856c22d9b59710
const $790ca30b1c43e45b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "suggestedUsersCount"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v2 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v1 /*: any*/ 
        ]
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "suggestedUsersCount"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 5
            }
        ],
        "concreteType": "JiraJqlGroupFieldValueConnection",
        "kind": "LinkedField",
        "name": "suggestedGroups",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraJqlGroupFieldValueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraJqlGroupFieldValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v5 /*: any*/ ,
                            v6 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "suggestedGroups(first:5)"
    }, v8 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "peopleJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v4 /*: any*/ ,
                                        "concreteType": "JiraJqlUserFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "recentlyUsedUsers",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraJqlUserFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraJqlUserFieldValue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v5 /*: any*/ ,
                                                            v6 /*: any*/ ,
                                                            v2 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v7 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "peopleJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraJqlUserFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "recentlyUsedUsers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlUserFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlUserFieldValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f3dcddb111bd3a875a7fe72854ff370624a9ff146bf6085aa9856c22d9b59710",
            "metadata": {},
            "name": "peopleJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$790ca30b1c43e45b$var$node.hash = "05b44957144740bb12a1e2842916fbf5";
var $790ca30b1c43e45b$export$2e2bcd8739ae039 = $790ca30b1c43e45b$var$node;

});

parcelRegister("ilCyB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2c5e782f889db04$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e2c5e782f889db04$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    refinementOptionCurrentUser: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-current-user",
        "defaultMessage": "Current User"
    },
    refinementOptionUnassigned: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-unassigned",
        "defaultMessage": "Unassigned"
    },
    refinementOptionSuggestedUsers: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-suggested-users",
        "defaultMessage": "Suggested Users"
    },
    refinementOptionSuggestedGroups: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-suggested-groups",
        "defaultMessage": "Suggested Groups"
    }
});

});


parcelRegister("3bnsV", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $7e64d26d8875364d$export$6df0712d20d2cc08);
$parcel$export(module.exports, "getProjectProps", () => $7e64d26d8875364d$export$2ba60b1cee4e2df8);

var $9zust = parcelRequire("9zust");

var $lTzVR = parcelRequire("lTzVR");

var $j4oe4 = parcelRequire("j4oe4");


var $epTsa = parcelRequire("epTsa");

var $eiIzV = parcelRequire("eiIzV");

var $b1bEi = parcelRequire("b1bEi");
const $7e64d26d8875364d$export$6df0712d20d2cc08 = (node, itemType)=>({
        label: node.displayName,
        value: node.jqlTerm,
        optionType: 'avatar',
        avatar: node.project?.avatar?.small,
        square: true,
        itemType: itemType
    });
const $7e64d26d8875364d$var$getSuggestedOptions = async ({ environment: environment, cloudId: cloudId, formatMessage: formatMessage, projectOptions: projectOptions })=>{
    const refinementOptionRecentProjectsGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $b1bEi.default).refinementOptionRecentProjectsGalaxia : (0, $b1bEi.default).refinementOptionRecentProjects;
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $lTzVR.default), {
        cloudId: cloudId,
        ...projectOptions && {
            projectOptions: projectOptions
        }
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira.jqlBuilder?.recentlyUsedProjects || !data?.jira.jqlBuilder?.recentlyUsedProjects.edges) return (0, $eiIzV.generateOptions)([]);
    const { edges: projectEdges } = data?.jira.jqlBuilder?.recentlyUsedProjects;
    return (0, $eiIzV.generateOptions)([
        {
            label: formatMessage(refinementOptionRecentProjectsGalaxia),
            optionType: 'group',
            options: projectEdges.reduce((options, edges)=>{
                if (!edges || !edges.node) return options;
                const { node: node } = edges;
                options.push($7e64d26d8875364d$export$6df0712d20d2cc08(node, (0, $862dfd240457f00b$export$38accfc5a5d1c113)));
                return options;
            }, [])
        }
    ]);
};
const $7e64d26d8875364d$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, lowerCaseFieldId: lowerCaseFieldId, jql: jql, search: search, endCursor: endCursor, projectOptions: projectOptions, viewContext: viewContext })=>{
    const after = endCursor;
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $9zust.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: lowerCaseFieldId,
        jql: jql || '',
        searchString: search,
        after: after,
        ...projectOptions && {
            projectOptions: projectOptions
        },
        viewContext: viewContext
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $eiIzV.generateOptions)([]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    return (0, $eiIzV.generateOptions)(fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push($7e64d26d8875364d$export$6df0712d20d2cc08(node, (0, $862dfd240457f00b$export$38accfc5a5d1c113)));
        return options;
    }, []), totalCount, pageInfo.endCursor || undefined);
};
const $7e64d26d8875364d$export$2ba60b1cee4e2df8 = ({ fieldId: fieldId, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, projectOptions: projectOptions, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $7e64d26d8875364d$var$getSuggestedOptions({
                    environment: environment,
                    cloudId: cloudId,
                    formatMessage: formatMessage,
                    projectOptions: projectOptions
                });
                return await $7e64d26d8875364d$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    lowerCaseFieldId: fieldId.toLowerCase(),
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    projectOptions: projectOptions,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eiIzV.fireJqlBuilderBasicErrorAnalytics)('projectJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $eiIzV.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("9zust", function(module, exports) {

$parcel$export(module.exports, "default", () => $248da6610d0f1a50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<95caf096268fefcfb77bddd415bb8857>>
 * @relayHash 3192fa5b6aa6a6075a38be5eb5f2aecb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 08d5f8ea6bbd314a0327191f720e0d7feda67a0f80b02f2c0149ab63f075c6ca
const $248da6610d0f1a50$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectOptions"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "projectOptions",
            "variableName": "projectOptions"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "projectJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v8 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v9 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v10 /*: any*/ ,
                                            v11 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v12 /*: any*/ ,
                                                            v13 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlProjectFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "projectJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "08d5f8ea6bbd314a0327191f720e0d7feda67a0f80b02f2c0149ab63f075c6ca",
            "metadata": {},
            "name": "projectJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$248da6610d0f1a50$var$node.hash = "7ae3b3a2998a3aacd96d184e4fa73d96";
var $248da6610d0f1a50$export$2e2bcd8739ae039 = $248da6610d0f1a50$var$node;

});

parcelRegister("lTzVR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e2209bb35edc632$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fd0ea0833b7ca298c76608f11bb00cb1>>
 * @relayHash 18fa54e2ca28ad2622498bf24b076364
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ece22d797eb7f498f6481931bc3a47afb02775056d1512d271738b91c214c2ad
const $2e2209bb35edc632$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectOptions"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "projectOptions",
            "variableName": "projectOptions"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "projectJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "concreteType": "JiraJqlProjectFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "recentlyUsedProjects",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraJqlProjectFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraJqlProjectFieldValue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ ,
                                                            v4 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                    v5 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "projectJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraJqlProjectFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "recentlyUsedProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlProjectFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlProjectFieldValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ece22d797eb7f498f6481931bc3a47afb02775056d1512d271738b91c214c2ad",
            "metadata": {},
            "name": "projectJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2e2209bb35edc632$var$node.hash = "fe20d750eadef8bafda1d590956fca21";
var $2e2209bb35edc632$export$2e2bcd8739ae039 = $2e2209bb35edc632$var$node;

});

parcelRegister("b1bEi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8dfb71dc22a922$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0e8dfb71dc22a922$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    refinementOptionRecentProjects: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.project.refinement-option-recent-projects",
        "defaultMessage": "Recent projects"
    },
    refinementOptionRecentProjectsGalaxia: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.project.refinement-option-recent-projects-galaxia",
        "defaultMessage": "Recent spaces"
    }
});

});


parcelRegister("3Tke1", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $1cc4c48b4ccddd45$export$6df0712d20d2cc08);
$parcel$export(module.exports, "getSprintProps", () => $1cc4c48b4ccddd45$export$85662d0553c985b4);

var $aSINI = parcelRequire("aSINI");

var $co0xU = parcelRequire("co0xU");

var $j4oe4 = parcelRequire("j4oe4");


var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $cb5xP = parcelRequire("cb5xP");

var $j2vE2 = parcelRequire("j2vE2");

var $7nojJ = parcelRequire("7nojJ");
const $1cc4c48b4ccddd45$export$6df0712d20d2cc08 = (node, formatMessage, itemType)=>{
    const { displayName: displayName, jqlTerm: jqlTerm } = node;
    const option = {
        label: displayName,
        value: jqlTerm,
        optionType: 'option',
        itemType: itemType
    };
    if (node.sprint) {
        const { state: state, boardName: boardName } = node.sprint;
        const i18nState = state ? (0, $7nojJ.getSprintState)(state, formatMessage) : undefined;
        const secondaryLabel = [
            i18nState,
            boardName
        ].filter((0, $7nojJ.hasValue)).join(" \u22C5 ");
        if (secondaryLabel !== '') return {
            ...option,
            secondaryLabel: secondaryLabel
        };
    }
    return option;
};
const $1cc4c48b4ccddd45$var$getSuggestedOptions = async ({ environment: environment, cloudId: cloudId, searchTemplate: searchTemplate, endCursor: endCursor, formatMessage: formatMessage })=>{
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $co0xU.default), {
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const emptyOption = [
        {
            label: (0, $cb5xP.getEmptyLabel)(searchTemplate ?? null, formatMessage),
            value: (0, $dTJxm.OperandValues).empty.value,
            optionType: 'option',
            itemType: (0, $862dfd240457f00b$export$f6049126fd97001f)
        }
    ];
    if (!data?.jira?.jqlBuilder?.recentlyUsedSprints?.edges) return (0, $eiIzV.generateOptions)(emptyOption);
    const { edges: fieldValues } = data.jira.jqlBuilder.recentlyUsedSprints;
    const sprints = fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push($1cc4c48b4ccddd45$export$6df0712d20d2cc08(node, formatMessage, (0, $862dfd240457f00b$export$38accfc5a5d1c113)));
        return options;
    }, []);
    return (0, $eiIzV.generateOptions)([
        ...!endCursor ? emptyOption : [],
        {
            label: formatMessage((0, $j2vE2.default).refinementOptionSuggestedSprints),
            optionType: 'group',
            options: sprints
        }
    ]);
};
const $1cc4c48b4ccddd45$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, fieldId: fieldId, searchTemplate: searchTemplate, jql: jql, search: search, endCursor: endCursor, formatMessage: formatMessage, viewContext: viewContext })=>{
    const after = endCursor;
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $aSINI.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: fieldId.toLowerCase(),
        jql: jql || '',
        searchString: search,
        after: after,
        viewContext: viewContext
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const emptyOption = {
        label: (0, $cb5xP.getEmptyLabel)(searchTemplate ?? null, formatMessage),
        value: (0, $dTJxm.OperandValues).empty.value,
        optionType: 'option',
        itemType: (0, $862dfd240457f00b$export$f6049126fd97001f)
    };
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $eiIzV.generateOptions)([
        emptyOption
    ]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    const sprints = fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push($1cc4c48b4ccddd45$export$6df0712d20d2cc08(node, formatMessage, (0, $862dfd240457f00b$export$38accfc5a5d1c113)));
        return options;
    }, []);
    return (0, $eiIzV.generateOptions)([
        ...search.length === 0 && !endCursor ? [
            emptyOption
        ] : [],
        ...sprints
    ], totalCount, pageInfo?.endCursor || undefined);
};
const $1cc4c48b4ccddd45$export$85662d0553c985b4 = ({ fieldId: fieldId, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: true,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $1cc4c48b4ccddd45$var$getSuggestedOptions({
                    environment: environment,
                    cloudId: cloudId,
                    fieldId: fieldId,
                    searchTemplate: searchTemplate,
                    endCursor: endCursor,
                    formatMessage: formatMessage
                });
                return await $1cc4c48b4ccddd45$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    fieldId: fieldId,
                    searchTemplate: searchTemplate,
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    formatMessage: formatMessage,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eiIzV.fireJqlBuilderBasicErrorAnalytics)('sprintJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $eiIzV.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("aSINI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8724a13f10f859$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<241c95051fbcdaa37867d9588c9652fc>>
 * @relayHash a753d2378b8a0e85d368b587cef149cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f49a61064524e802bb475f20e360b1e395edcd2bd05d487b7817a174f90c52df
const $ab8724a13f10f859$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "state"
    }, v14 = {
        "kind": "ScalarField",
        "name": "boardName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "sprintJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v10 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11 /*: any*/ ,
                                                            v12 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprint",
                                                                        "kind": "LinkedField",
                                                                        "name": "sprint",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v13 /*: any*/ ,
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlSprintFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "sprintJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f49a61064524e802bb475f20e360b1e395edcd2bd05d487b7817a174f90c52df",
            "metadata": {},
            "name": "sprintJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ab8724a13f10f859$var$node.hash = "2fca268b01a9949b7d6a9c7abb665ff1";
var $ab8724a13f10f859$export$2e2bcd8739ae039 = $ab8724a13f10f859$var$node;

});

parcelRegister("co0xU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d52de5785a57a3c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b82b9b38c96bf6b763bd8f21ed441feb>>
 * @relayHash 0f4f3c0dc3fbfd461b30b2edce7ff480
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bd147d7ddd3fe153f2faac37da072abad63284dd1e60a1ad50037b7db7059d8d
const $5d52de5785a57a3c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 5
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "state"
    }, v6 = {
        "kind": "ScalarField",
        "name": "boardName"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sprintJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "concreteType": "JiraJqlSprintFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "recentlyUsedSprints",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraJqlSprintFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraJqlSprintFieldValue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ ,
                                                            v4 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraSprint",
                                                                "kind": "LinkedField",
                                                                "name": "sprint",
                                                                "plural": false,
                                                                "selections": [
                                                                    v5 /*: any*/ ,
                                                                    v6 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "recentlyUsedSprints(first:5)"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sprintJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraJqlSprintFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "recentlyUsedSprints",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlSprintFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlSprintFieldValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSprint",
                                                            "kind": "LinkedField",
                                                            "name": "sprint",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "recentlyUsedSprints(first:5)"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bd147d7ddd3fe153f2faac37da072abad63284dd1e60a1ad50037b7db7059d8d",
            "metadata": {},
            "name": "sprintJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5d52de5785a57a3c$var$node.hash = "ea6849d517e657548891da01c0336d4f";
var $5d52de5785a57a3c$export$2e2bcd8739ae039 = $5d52de5785a57a3c$var$node;

});

parcelRegister("j2vE2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d12ef39052694cc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7d12ef39052694cc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    active: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.active",
        "defaultMessage": "Active"
    },
    future: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.future",
        "defaultMessage": "Future"
    },
    closed: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.closed",
        "defaultMessage": "Closed"
    },
    refinementOptionSuggestedSprints: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.refinement-option-suggested-sprints",
        "defaultMessage": "Suggested Sprints"
    }
});

});

parcelRegister("7nojJ", function(module, exports) {

$parcel$export(module.exports, "hasValue", () => $1728709a38bdfd7a$export$96bdbc84526f3739);
$parcel$export(module.exports, "getSprintState", () => $1728709a38bdfd7a$export$9cbf48c04feaac07);

var $j2vE2 = parcelRequire("j2vE2");
const $1728709a38bdfd7a$export$96bdbc84526f3739 = (text)=>typeof text === 'string' && text.length > 0;
const $1728709a38bdfd7a$export$9cbf48c04feaac07 = (state, formatMessage)=>{
    switch(state){
        case 'ACTIVE':
            return formatMessage((0, $j2vE2.default).active);
        case 'FUTURE':
            return formatMessage((0, $j2vE2.default).future);
        case 'CLOSED':
            return formatMessage((0, $j2vE2.default).closed);
        default:
            return undefined;
    }
};

});



parcelRegister("l2et3", function(module, exports) {

$parcel$export(module.exports, "useSelectedOperator", () => $d4ee52aa46843976$export$7efa7e0a027633a3);

var $eJOHy = parcelRequire("eJOHy");

var $f26C8 = parcelRequire("f26C8");
var $8okjU = parcelRequire("8okjU");
var $jPlb3 = parcelRequire("jPlb3");

var $lRq8t = parcelRequire("lRq8t");

var $5c1zW = parcelRequire("5c1zW");

var $hV50T = parcelRequire("hV50T");

var $9dwrV = parcelRequire("9dwrV");
const $d4ee52aa46843976$var$DEFAULT_OPERATOR = (0, $f26C8.default).operator((0, $jPlb3.OPERATOR_EQUALS));
const $d4ee52aa46843976$export$7efa7e0a027633a3 = ({ fieldDisplayName: fieldDisplayName, terminalClause: terminalClause, allowedOperators: allowedOperators = [] })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    /**
   * List of operators allowed for the field
   * We need to keep the object references to allow react select to know which is selected for screen readers
   * It uses the reference for this, not the value (https://github.com/JedWatson/react-select/blob/master/packages/react-select/src/components/LiveRegion.tsx#L118)
   */ const allowedOperatorsOptions = (0, $eJOHy.useMemo)(()=>({
            singleOperators: [
                ...new Set(allowedOperators.map((operator)=>(0, $9dwrV.resolveOperator)({
                        operatorValue: operator.value,
                        isList: false
                    })))
            ].map((operatorValue)=>(0, $hV50T.createOperatorOption)({
                    fieldDisplayName: fieldDisplayName,
                    operator: (0, $f26C8.default).operator(operatorValue),
                    formatMessage: formatMessage
                })),
            listOperators: [
                ...new Set(allowedOperators.map((o)=>(0, $9dwrV.resolveOperator)({
                        operatorValue: o.value,
                        isList: true
                    })))
            ].map((operatorValue)=>(0, $hV50T.createOperatorOption)({
                    fieldDisplayName: fieldDisplayName,
                    operator: (0, $f26C8.default).operator(operatorValue),
                    formatMessage: formatMessage
                }))
        }), // Operator don't change after bootup
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Select if we need to show list or single operators
    const allowedOperatorsOptionsFiltered = (0, $eJOHy.useMemo)(()=>allowedOperatorsOptions[terminalClause?.operand && (0, $5c1zW.isListOperand)(terminalClause.operand) ? 'listOperators' : 'singleOperators'], [
        allowedOperatorsOptions,
        terminalClause?.operand
    ]);
    // Selected operator for the field
    const [selectedOperator, setSelectedOperator] = (0, $eJOHy.useState)(()=>{
        let resolvedOperator = allowedOperatorsOptionsFiltered.find((operator)=>terminalClause?.operator?.value && operator.value === terminalClause.operator.value);
        if (!resolvedOperator) resolvedOperator = allowedOperatorsOptionsFiltered.find((operator)=>operator.value === $d4ee52aa46843976$var$DEFAULT_OPERATOR.value);
        return resolvedOperator !== undefined ? resolvedOperator : (0, $hV50T.createOperatorOption)({
            fieldDisplayName: fieldDisplayName,
            operator: $d4ee52aa46843976$var$DEFAULT_OPERATOR,
            formatMessage: formatMessage
        });
    });
    const setDefaultOperator = (0, $eJOHy.useCallback)(()=>{
        setSelectedOperator(()=>{
            const resolvedOperator = allowedOperatorsOptionsFiltered.find((operator)=>operator.value === $d4ee52aa46843976$var$DEFAULT_OPERATOR.value);
            return resolvedOperator !== undefined ? resolvedOperator : (0, $hV50T.createOperatorOption)({
                fieldDisplayName: fieldDisplayName,
                operator: $d4ee52aa46843976$var$DEFAULT_OPERATOR,
                formatMessage: formatMessage
            });
        });
    }, [
        allowedOperatorsOptionsFiltered,
        fieldDisplayName,
        formatMessage
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (terminalClause && terminalClause.operator?.value && (0, $8okjU.isOperator)(terminalClause.operator.value) && terminalClause.operator.value !== selectedOperator?.value) {
            const terminalOperator = terminalClause.operator;
            const resolvedOperator = allowedOperatorsOptionsFiltered.find((operator)=>operator.value === terminalOperator.value);
            setSelectedOperator(resolvedOperator !== undefined ? resolvedOperator : (0, $hV50T.createOperatorOption)({
                fieldDisplayName: fieldDisplayName,
                operator: terminalOperator,
                formatMessage: formatMessage
            }));
        }
    // Only update when change come from outside of the hook (terminalClause)
    // We already manage selectedOperator changes internally
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formatMessage,
        terminalClause
    ]);
    return {
        allowedOperators: allowedOperatorsOptionsFiltered,
        selectedOperator: selectedOperator,
        setSelectedOperator: setSelectedOperator,
        setDefaultOperator: setDefaultOperator
    };
};

});
parcelRegister("hV50T", function(module, exports) {

$parcel$export(module.exports, "createOperatorOption", () => $6a1887d158b16397$export$ed5b7e9422ae3ae4);

var $jPlb3 = parcelRequire("jPlb3");

var $8v8cy = parcelRequire("8v8cy");
const $6a1887d158b16397$var$getOperatorLabels = ({ operatorValue: operatorValue, fieldDisplayName: fieldDisplayName, formatMessage: formatMessage })=>{
    let messageKey;
    let resolvedOperatorValue;
    switch(operatorValue){
        case 0, $jPlb3.OPERATOR_EQUALS:
        case 0, $jPlb3.OPERATOR_IS:
        case 0, $jPlb3.OPERATOR_IN:
            messageKey = 'operatorEquals';
            resolvedOperatorValue = (0, $jPlb3.OPERATOR_EQUALS);
            break;
        case 0, $jPlb3.OPERATOR_NOT_EQUALS:
        case 0, $jPlb3.OPERATOR_IS_NOT:
        case 0, $jPlb3.OPERATOR_NOT_IN:
            messageKey = 'operatorNotEquals';
            resolvedOperatorValue = (0, $jPlb3.OPERATOR_NOT_EQUALS);
            break;
        case 0, $jPlb3.OPERATOR_WAS:
        case 0, $jPlb3.OPERATOR_WAS_IN:
            messageKey = 'operatorWas';
            resolvedOperatorValue = (0, $jPlb3.OPERATOR_WAS);
            break;
        case 0, $jPlb3.OPERATOR_WAS_NOT:
        case 0, $jPlb3.OPERATOR_WAS_NOT_IN:
            messageKey = 'operatorWasNot';
            resolvedOperatorValue = (0, $jPlb3.OPERATOR_WAS_NOT);
            break;
        case 0, $jPlb3.OPERATOR_CHANGED:
            messageKey = 'operatorChanged';
            resolvedOperatorValue = (0, $jPlb3.OPERATOR_CHANGED);
            break;
        case 0, $jPlb3.OPERATOR_LIKE:
            messageKey = 'operatorLike';
            resolvedOperatorValue = (0, $jPlb3.OPERATOR_LIKE);
            break;
        case 0, $jPlb3.OPERATOR_NOT_LIKE:
            messageKey = 'operatorNotLike';
            resolvedOperatorValue = (0, $jPlb3.OPERATOR_NOT_LIKE);
            break;
        case 0, $jPlb3.OPERATOR_GT:
            messageKey = 'operatorGt';
            resolvedOperatorValue = (0, $jPlb3.OPERATOR_GT);
            break;
        case 0, $jPlb3.OPERATOR_GT_EQUALS:
            messageKey = 'operatorGtEquals';
            resolvedOperatorValue = (0, $jPlb3.OPERATOR_GT_EQUALS);
            break;
        case 0, $jPlb3.OPERATOR_LT:
            messageKey = 'operatorLt';
            resolvedOperatorValue = (0, $jPlb3.OPERATOR_LT);
            break;
        case 0, $jPlb3.OPERATOR_LT_EQUALS:
            messageKey = 'operatorLtEquals';
            resolvedOperatorValue = (0, $jPlb3.OPERATOR_LT_EQUALS);
            break;
        default:
            throw new Error(`Operator value: ${operatorValue} not supported`);
    }
    return {
        label: formatMessage((0, $8v8cy.default)[messageKey], {
            fieldDisplayName: fieldDisplayName,
            operator: resolvedOperatorValue
        }),
        shortLabel: formatMessage((0, $8v8cy.default)[`${messageKey}Short`], {
            operator: resolvedOperatorValue
        }),
        ariaLabel: formatMessage((0, $8v8cy.default)[`${messageKey}AriaLabel`], {
            fieldDisplayName: fieldDisplayName
        }),
        valueLabel: resolvedOperatorValue
    };
};
const $6a1887d158b16397$export$ed5b7e9422ae3ae4 = ({ fieldDisplayName: fieldDisplayName, operator: operator, formatMessage: formatMessage })=>({
        ...operator,
        ...$6a1887d158b16397$var$getOperatorLabels({
            operatorValue: operator.value,
            fieldDisplayName: fieldDisplayName,
            formatMessage: formatMessage
        })
    });

});
parcelRegister("8v8cy", function(module, exports) {

$parcel$export(module.exports, "default", () => $df4b6f5023c858d7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $df4b6f5023c858d7$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    operatorEquals: {
        "id": "jql-builder-basic.utils.operators.operator-equals",
        "defaultMessage": "{fieldDisplayName} {operator} (equals)"
    },
    operatorNotEquals: {
        "id": "jql-builder-basic.utils.operators.operator-not-equals",
        "defaultMessage": "{fieldDisplayName} {operator} (not equals)"
    },
    operatorWas: {
        "id": "jql-builder-basic.utils.operators.operator-was",
        "defaultMessage": "{fieldDisplayName} {operator}"
    },
    operatorWasNot: {
        "id": "jql-builder-basic.utils.operators.operator-was-not",
        "defaultMessage": "{fieldDisplayName} {operator}"
    },
    operatorChanged: {
        "id": "jql-builder-basic.utils.operators.operator-changed",
        "defaultMessage": "{fieldDisplayName} {operator}"
    },
    operatorLike: {
        "id": "jql-builder-basic.utils.operators.operator-like",
        "defaultMessage": "{fieldDisplayName} {operator} (like)"
    },
    operatorNotLike: {
        "id": "jql-builder-basic.utils.operators.operator-not-like",
        "defaultMessage": "{fieldDisplayName} {operator} (not like)"
    },
    operatorGt: {
        "id": "jql-builder-basic.utils.operators.operator-gt",
        "defaultMessage": "{fieldDisplayName} {operator} (greater than)"
    },
    operatorGtEquals: {
        "id": "jql-builder-basic.utils.operators.operator-gt-equals",
        "defaultMessage": "{fieldDisplayName} {operator} (greater than or equals)"
    },
    operatorLt: {
        "id": "jql-builder-basic.utils.operators.operator-lt",
        "defaultMessage": "{fieldDisplayName} {operator} (less than)"
    },
    operatorLtEquals: {
        "id": "jql-builder-basic.utils.operators.operator-lt-equals",
        "defaultMessage": "{fieldDisplayName} {operator} (less than or equals)"
    },
    operatorEqualsShort: {
        "id": "jql-builder-basic.utils.operators.operator-equals-short",
        "defaultMessage": "{operator} (equals)"
    },
    operatorNotEqualsShort: {
        "id": "jql-builder-basic.utils.operators.operator-not-equals-short",
        "defaultMessage": "{operator} (not equals)"
    },
    operatorWasShort: {
        "id": "jql-builder-basic.utils.operators.operator-was-short",
        "defaultMessage": "{operator}"
    },
    operatorWasNotShort: {
        "id": "jql-builder-basic.utils.operators.operator-was-not-short",
        "defaultMessage": "{operator}"
    },
    operatorChangedShort: {
        "id": "jql-builder-basic.utils.operators.operator-changed-short",
        "defaultMessage": "{operator}"
    },
    operatorLikeShort: {
        "id": "jql-builder-basic.utils.operators.operator-like-short",
        "defaultMessage": "{operator} (like)"
    },
    operatorNotLikeShort: {
        "id": "jql-builder-basic.utils.operators.operator-not-like-short",
        "defaultMessage": "{operator} (not like)"
    },
    operatorGtShort: {
        "id": "jql-builder-basic.utils.operators.operator-gt-short",
        "defaultMessage": "{operator} (greater than)"
    },
    operatorGtEqualsShort: {
        "id": "jql-builder-basic.utils.operators.operator-gt-equals-short",
        "defaultMessage": "{operator} (greater than or equals)"
    },
    operatorLtShort: {
        "id": "jql-builder-basic.utils.operators.operator-lt-short",
        "defaultMessage": "{operator} (less than)"
    },
    operatorLtEqualsShort: {
        "id": "jql-builder-basic.utils.operators.operator-lt-equals-short",
        "defaultMessage": "{operator} (less than or equals)"
    },
    operatorEqualsAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-equals-aria-label",
        "defaultMessage": "{fieldDisplayName} equals"
    },
    operatorNotEqualsAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-not-equals-aria-label",
        "defaultMessage": "{fieldDisplayName} not equals"
    },
    operatorWasAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-was-aria-label",
        "defaultMessage": "{fieldDisplayName} was"
    },
    operatorWasNotAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-was-not-aria-label",
        "defaultMessage": "{fieldDisplayName} was not"
    },
    operatorChangedAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-changed-aria-label",
        "defaultMessage": "{fieldDisplayName} changed"
    },
    operatorLikeAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-like-aria-label",
        "defaultMessage": "{fieldDisplayName} like"
    },
    operatorNotLikeAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-not-like-aria-label",
        "defaultMessage": "{fieldDisplayName} not like"
    },
    operatorGtAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-gt-aria-label",
        "defaultMessage": "{fieldDisplayName} greater than"
    },
    operatorGtEqualsAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-gt-equals-aria-label",
        "defaultMessage": "{fieldDisplayName} greater than or equals"
    },
    operatorLtAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-lt-aria-label",
        "defaultMessage": "{fieldDisplayName} less than"
    },
    operatorLtEqualsAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-lt-equals-aria-label",
        "defaultMessage": "{fieldDisplayName} less than or equals"
    }
});
var $df4b6f5023c858d7$export$2e2bcd8739ae039 = $df4b6f5023c858d7$export$defe85febe8b728c;

});



parcelRegister("8Hwfj", function(module, exports) {

$parcel$export(module.exports, "useSelectedValues", () => $528f55de3c1dfdb1$export$e10928cdf9450649);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $dTJxm = parcelRequire("dTJxm");

var $7KNt5 = parcelRequire("7KNt5");
const $528f55de3c1dfdb1$var$isEmptyOption = (option)=>option.optionType === 'option' && option.value === (0, $dTJxm.OperandValues).empty.value;
const $528f55de3c1dfdb1$export$e10928cdf9450649 = (terminalClause, hydratedData, fieldId, operandDisplayValues, searchTemplate)=>{
    // Allow optimistic updates when a value is selected while hydration is taking place
    const [optimisticValues, setOptimisticValues] = (0, $eJOHy.useState)([]);
    const [hydrated, setHydrated] = (0, $eJOHy.useState)((0, $7jTnu.fg)('render_jql_builder_in_ssr') ? !!hydratedData : false);
    const prevHydratedData = (0, $eJOHy.useRef)((0, $7jTnu.fg)('render_jql_builder_in_ssr') ? hydratedData : undefined);
    const hydratedValues = (0, $7KNt5.useHydratedValues)(fieldId, hydratedData, searchTemplate, terminalClause, operandDisplayValues);
    // Only flag values as hydrated after a data change
    (0, $eJOHy.useEffect)(()=>{
        if (!hydrated && hydratedData !== prevHydratedData.current) setHydrated(true);
        prevHydratedData.current = hydratedData;
    }, [
        hydrated,
        hydratedData
    ]);
    const selectedValues = (0, $eJOHy.useMemo)(()=>{
        const values = hydrated ? hydratedValues : optimisticValues;
        const emptyIndex = values.findIndex($528f55de3c1dfdb1$var$isEmptyOption);
        if (emptyIndex !== -1) {
            const orderedValues = [
                ...values
            ];
            // Rearrange selected values to keep EMPTY at the end
            orderedValues.push(orderedValues.splice(emptyIndex, 1)[0]);
            return orderedValues;
        }
        return values;
    }, [
        hydrated,
        hydratedValues,
        optimisticValues
    ]);
    const setSelectedValues = (0, $eJOHy.useCallback)((values)=>{
        setHydrated(false);
        setOptimisticValues(values);
    }, []);
    return [
        selectedValues,
        setSelectedValues
    ];
};

});
parcelRegister("7KNt5", function(module, exports) {

$parcel$export(module.exports, "useHydratedValues", () => $4c8c764adfc4d727$export$dc23a21ad032e5fa);

var $7Inhe = parcelRequire("7Inhe");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $8eqAB = parcelRequire("8eqAB");
const $4c8c764adfc4d727$export$dc23a21ad032e5fa = (fieldId, hydratedData, searchTemplate, terminalClause, operandDisplayValues)=>{
    const intl = (0, $lRq8t.default)();
    /* eslint-disable @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields */ const data = (0, $j4oe4.useFragment)((0, $7Inhe.default), hydratedData);
    /* eslint-enable @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields */ return (0, $eJOHy.useMemo)(()=>{
        if (terminalClause && data) {
            const hydratedValuesFromClause = (0, $8eqAB.getValuesFromClause)(terminalClause, data, fieldId, operandDisplayValues, intl, searchTemplate);
            if (hydratedValuesFromClause !== undefined) return Array.isArray(hydratedValuesFromClause) ? hydratedValuesFromClause : [
                hydratedValuesFromClause
            ];
        }
        return [];
    }, [
        terminalClause,
        data,
        fieldId,
        intl,
        operandDisplayValues,
        searchTemplate
    ]);
};

});
parcelRegister("7Inhe", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ddb9b3b5922ab9a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5aa1f9f496fb483e2dd16633d7de899e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1ddb9b3b5922ab9a$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "picture"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v2 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v3 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorName"
                }
            ]
        }
    ], v8 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v7 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v7 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "xsmall"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v0 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "boardName"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "error",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ],
            "type": "QueryError"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "accountId"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "includeUser"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "name": "useHydratedValues",
        "selections": [
            {
                "condition": "includeUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "accountId",
                                "variableName": "accountId"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            },
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v1 /*: any*/ ,
                                                    v2 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v8 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v1 /*: any*/ ,
                                                    v2 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v8 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$1ddb9b3b5922ab9a$var$node.hash = "ca3de7c8645b6f4d9524497f325707e2";
var $1ddb9b3b5922ab9a$export$2e2bcd8739ae039 = $1ddb9b3b5922ab9a$var$node;

});

parcelRegister("8eqAB", function(module, exports) {

$parcel$export(module.exports, "getValuesFromClause", () => $6b0f40cc3b2b71af$export$703572bd21b6316);


var $eSnSE = parcelRequire("eSnSE");

var $al3nN = parcelRequire("al3nN");

var $39sKD = parcelRequire("39sKD");

var $idQ0v = parcelRequire("idQ0v");

var $8S3SG = parcelRequire("8S3SG");
const $6b0f40cc3b2b71af$export$703572bd21b6316 = (terminalClause, data, fieldJqlTerm, validOperandDisplayValues, intl, searchTemplate)=>{
    if (terminalClause.operand) switch(terminalClause.operand.operandType){
        case 0, $862dfd240457f00b$export$f6049126fd97001f:
            return (0, $39sKD.getKeywordValue)(terminalClause.operand.value, validOperandDisplayValues, intl, searchTemplate);
        case 0, $862dfd240457f00b$export$38accfc5a5d1c113:
            return (0, $8S3SG.getValue)(data, fieldJqlTerm, terminalClause.operand.value, intl);
        case 0, $862dfd240457f00b$export$19c7c729db381f9d:
            return (0, $al3nN.getFunctionValue)(data, terminalClause.operand.function.value, validOperandDisplayValues, intl, terminalClause.operand.arguments, fieldJqlTerm);
        case 0, $862dfd240457f00b$export$fabec4aebba3f4df:
            return (0, $idQ0v.getListValue)({
                listOperand: terminalClause.operand,
                data: data,
                fieldJqlTerm: fieldJqlTerm,
                validOperandDisplayValues: validOperandDisplayValues,
                intl: intl,
                searchTemplate: searchTemplate
            });
        default:
            throw new Error('Operand Type is not valid');
    }
    (0, $eSnSE.default).unsafeErrorWithCustomerData('jiraJqlBuilderBasic.getValuesFromClause', 'Terminal clause operand is undefined', {
        jql: (data?.jira?.jqlBuilder?.hydrateJqlQuery ?? data?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.jql,
        fieldJqlTerm: fieldJqlTerm,
        operator: terminalClause.operator?.value,
        searchTemplate: searchTemplate
    });
    throw new Error('Terminal clause operand is undefined');
};

});
parcelRegister("al3nN", function(module, exports) {

$parcel$export(module.exports, "getFunctionValue", () => $2bf1256e481171d9$export$f1c78020f9d2362b);


var $dTJxm = parcelRequire("dTJxm");

var $65vFU = parcelRequire("65vFU");
const $2bf1256e481171d9$export$f1c78020f9d2362b = (data, value, validOperandDisplayValues, intl, args, fieldJqlTerm)=>{
    const invalid = Boolean(!validOperandDisplayValues || !validOperandDisplayValues.includes((0, $dTJxm.OperandValues)[value]?.value || value));
    if (value === 'membersOf') {
        const matchingField = (data?.jira?.jqlBuilder?.hydrateJqlQuery ?? data?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.find((field)=>field.jqlTerm && field.jqlTerm.toLowerCase() === fieldJqlTerm.toLowerCase());
        const fieldData = matchingField?.values?.find((v)=>v?.jqlTerm && v.jqlTerm === args[0].value);
        if (fieldData?.values?.length) {
            const [hydratedFieldValue] = fieldData.values;
            if (hydratedFieldValue) return {
                label: hydratedFieldValue.displayName,
                value: hydratedFieldValue.jqlTerm,
                itemType: (0, $862dfd240457f00b$export$19c7c729db381f9d),
                optionType: 'avatar',
                isGroup: true,
                invalid: invalid
            };
        }
        return undefined;
    }
    const fieldValue = {
        label: (0, $65vFU.getFunctionLabel)(value, intl.formatMessage),
        value: (0, $dTJxm.OperandValues)[value]?.value || value,
        itemType: (0, $862dfd240457f00b$export$19c7c729db381f9d)
    };
    if (fieldValue.value === (0, $dTJxm.OperandValues).currentUser.value && !invalid) return {
        ...fieldValue,
        optionType: 'avatar',
        avatar: data?.user?.picture ?? '',
        invalid: invalid
    };
    return {
        ...fieldValue,
        optionType: 'avatar',
        hideAvatar: true,
        invalid: invalid
    };
};

});

parcelRegister("39sKD", function(module, exports) {

$parcel$export(module.exports, "getKeywordValue", () => $4bfa627004eedef8$export$2b5362d270091b71);


var $dTJxm = parcelRequire("dTJxm");

var $cb5xP = parcelRequire("cb5xP");
const $4bfa627004eedef8$export$2b5362d270091b71 = (value, validOperandDisplayValues, intl, searchTemplate)=>{
    // EMPTY is the only supported RHS keyword in JQL (AST returns EMPTY for both EMPTY and NULL)
    const label = (0, $cb5xP.getEmptyLabel)(searchTemplate ?? null, intl.formatMessage);
    const selectOptionValue = (0, $dTJxm.OperandValues).empty.value;
    const invalid = !validOperandDisplayValues || !validOperandDisplayValues.some((keyword)=>keyword.toLowerCase() === value.toLowerCase());
    if (searchTemplate && (0, $dTJxm.userFieldSearchTemplates).has(searchTemplate.toLowerCase())) return {
        label: label,
        optionType: 'avatar',
        value: selectOptionValue,
        invalid: invalid,
        itemType: (0, $862dfd240457f00b$export$f6049126fd97001f)
    };
    return {
        label: label,
        optionType: 'option',
        value: selectOptionValue,
        invalid: invalid,
        itemType: (0, $862dfd240457f00b$export$f6049126fd97001f)
    };
};

});

parcelRegister("idQ0v", function(module, exports) {

$parcel$export(module.exports, "getListValue", () => $0c1cb7ff80f05047$export$9cc74515108c9544);


var $al3nN = parcelRequire("al3nN");

var $39sKD = parcelRequire("39sKD");

var $8S3SG = parcelRequire("8S3SG");
// Returns a minimal `SelectOption` which contains only the value. This is used
// during creation of `rawSelectedValues` in `./main.js`, and is necessary so
// that we can perform comparisons on the selected values before updated data
// is returned from the server.
const $0c1cb7ff80f05047$var$getRawValue = (value)=>({
        optionType: 'option',
        label: '',
        value: value
    });
const $0c1cb7ff80f05047$export$9cc74515108c9544 = ({ listOperand: listOperand, data: data, fieldJqlTerm: fieldJqlTerm, validOperandDisplayValues: validOperandDisplayValues, intl: intl, searchTemplate: searchTemplate })=>listOperand.values.reduce((acum, value)=>{
        if (value.operandType === (0, $862dfd240457f00b$export$38accfc5a5d1c113)) {
            if (!data) {
                const rawValue = $0c1cb7ff80f05047$var$getRawValue(value.value);
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                return rawValue ? [
                    ...acum,
                    rawValue
                ] : acum;
            }
            const hydratedValue = (0, $8S3SG.getValue)(data, fieldJqlTerm, value.value, intl);
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return hydratedValue ? [
                ...acum,
                hydratedValue
            ] : acum;
        }
        if (value.operandType === (0, $862dfd240457f00b$export$19c7c729db381f9d)) {
            const hydratedValue = (0, $al3nN.getFunctionValue)(data, value.function.value, validOperandDisplayValues, intl, value.arguments, fieldJqlTerm);
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return hydratedValue ? [
                ...acum,
                hydratedValue
            ] : acum;
        }
        if (value.operandType === (0, $862dfd240457f00b$export$f6049126fd97001f)) return [
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acum,
            (0, $39sKD.getKeywordValue)(value.value, validOperandDisplayValues, intl, searchTemplate)
        ];
        if (value.operandType === (0, $862dfd240457f00b$export$fabec4aebba3f4df)) return [
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acum,
            ...$0c1cb7ff80f05047$export$9cc74515108c9544({
                listOperand: value,
                data: data,
                fieldJqlTerm: fieldJqlTerm,
                validOperandDisplayValues: validOperandDisplayValues,
                intl: intl,
                searchTemplate: searchTemplate
            })
        ];
        throw new Error('This is unexpected! Check if isQueryTooComplex is missing a check');
    }, []);

});
parcelRegister("8S3SG", function(module, exports) {

$parcel$export(module.exports, "getValue", () => $e191da333fbbf5dd$export$bf7199a9ebcb84a9);


var $92k5z = parcelRequire("92k5z");

var $7porm = parcelRequire("7porm");

var $3q8Sy = parcelRequire("3q8Sy");

var $3bnsV = parcelRequire("3bnsV");

var $3Tke1 = parcelRequire("3Tke1");
const $e191da333fbbf5dd$export$bf7199a9ebcb84a9 = (data, fieldJqlTerm, valueJqlTerm, intl)=>{
    const matchingField = (data?.jira?.jqlBuilder?.hydrateJqlQuery ?? data?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.find((field)=>field.jqlTerm && field.jqlTerm.toLowerCase() === fieldJqlTerm.toLowerCase());
    const fieldData = matchingField?.values?.find((value)=>value?.jqlTerm && (value.jqlTerm === valueJqlTerm || value.jqlTerm.toLowerCase() === (0, $92k5z.removeSurroundingQuotes)(valueJqlTerm).toLowerCase()));
    if (fieldData?.error) return {
        label: (0, $92k5z.removeSurroundingQuotes)(valueJqlTerm),
        optionType: 'option',
        value: valueJqlTerm,
        invalid: true,
        itemType: (0, $862dfd240457f00b$export$38accfc5a5d1c113)
    };
    if (fieldData?.values?.length) {
        const [hydratedFieldValue] = fieldData.values;
        if (hydratedFieldValue) switch(hydratedFieldValue.__typename){
            case 'JiraJqlUserFieldValue':
                return {
                    label: hydratedFieldValue.displayName,
                    value: hydratedFieldValue.jqlTerm,
                    optionType: 'avatar',
                    avatar: hydratedFieldValue.user?.picture,
                    itemType: (0, $862dfd240457f00b$export$38accfc5a5d1c113)
                };
            case 'JiraJqlGroupFieldValue':
                return {
                    label: hydratedFieldValue.displayName,
                    value: hydratedFieldValue.jqlTerm,
                    optionType: 'avatar',
                    itemType: (0, $862dfd240457f00b$export$38accfc5a5d1c113),
                    isGroup: true
                };
            case 'JiraJqlIssueTypeFieldValue':
                return (0, $3q8Sy.getOption)(hydratedFieldValue, (0, $862dfd240457f00b$export$38accfc5a5d1c113));
            case 'JiraJqlProjectFieldValue':
                return (0, $3bnsV.getOption)(hydratedFieldValue, (0, $862dfd240457f00b$export$38accfc5a5d1c113));
            case 'JiraJqlSprintFieldValue':
                return (0, $3Tke1.getOption)(hydratedFieldValue, intl.formatMessage, (0, $862dfd240457f00b$export$38accfc5a5d1c113));
            default:
                return (0, $7porm.getOption)(hydratedFieldValue, (0, $862dfd240457f00b$export$38accfc5a5d1c113));
        }
    }
    return undefined;
};

});






parcelRegister("8M9FQ", function(module, exports) {

$parcel$export(module.exports, "TextAreaPicker", () => $69e876a674f23fb1$export$2d0fad1d142f2f68);

var $eJOHy = parcelRequire("eJOHy");

var $jPlb3 = parcelRequire("jPlb3");

var $boEdP = parcelRequire("boEdP");

var $eqSys = parcelRequire("eqSys");

var $eiIzV = parcelRequire("eiIzV");

var $lyPdT = parcelRequire("lyPdT");

var $h9gPh = parcelRequire("h9gPh");

var $ediQO = parcelRequire("ediQO");

var $aEcQh = parcelRequire("aEcQh");

var $gWc6I = parcelRequire("gWc6I");

var $7moyo = parcelRequire("7moyo");
const $69e876a674f23fb1$var$isSingleValueOperand = (operand)=>operand.operandType === (0, $862dfd240457f00b$export$38accfc5a5d1c113) || operand.operandType === (0, $862dfd240457f00b$export$f6049126fd97001f);
const $69e876a674f23fb1$export$2d0fad1d142f2f68 = ({ clause: clause, fieldId: fieldId, fieldLabel: fieldLabel, fieldType: fieldType, activePopupKey: activePopupKey, onSearchWrapper: onSearchWrapper, onClear: onClear, onOpen: onOpen, onClose: onClose, fieldDescription: fieldDescription, propType: propType, isIrremovable: isIrremovable })=>{
    const [ast] = (0, $lyPdT.useAST)();
    const sendOptionAnalytics = (0, $h9gPh.useSendOptionAnalytics)();
    if (!(0, $eiIzV.isTextAreaPropType)(propType)) throw new Error(`Unsupported TextAreaPropType: ${propType}`);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        onClear && onClear(clause ? (0, $boEdP.default)(ast, clause) : undefined);
    }, [
        onClear,
        clause,
        ast
    ]);
    const commonProps = {
        fieldId: fieldId,
        fieldDisplayName: fieldLabel || '',
        fieldType: fieldType,
        propType: propType,
        isOpen: activePopupKey === fieldId,
        onOpen: onOpen,
        onClose: onClose,
        onClear: handleOnClear,
        value: clause && clause.clauseType === (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a) && clause.operand && $69e876a674f23fb1$var$isSingleValueOperand(clause.operand) && clause.operand.value || '',
        onSendOptionAnalytics: sendOptionAnalytics,
        fieldDescription: fieldDescription,
        isIrremovable: isIrremovable
    };
    switch(propType){
        case (0, $eqSys.TextAreaPropTypes).Number:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aEcQh.default), {
                ...commonProps,
                onChange: (newValue)=>{
                    onSearchWrapper && onSearchWrapper((0, $7moyo.getUpdatedJql)(ast, clause, fieldId, newValue, (0, $jPlb3.OPERATOR_EQUALS)));
                }
            });
        case (0, $eqSys.TextAreaPropTypes).Aql:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ediQO.default), {
                ...commonProps,
                value: (0, $7moyo.getAqlFromClause)(clause),
                onChange: (newValue)=>{
                    onSearchWrapper && onSearchWrapper((0, $7moyo.getUpdatedJqlWithAql)(ast, clause, fieldId, newValue, (0, $jPlb3.OPERATOR_IN)));
                }
            });
        case (0, $eqSys.TextAreaPropTypes).Text:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWc6I.default), {
                ...commonProps,
                onChange: (newValue)=>{
                    onSearchWrapper && onSearchWrapper((0, $7moyo.getUpdatedJql)(ast, clause, fieldId, newValue, (0, $jPlb3.OPERATOR_LIKE)));
                }
            });
        case (0, $eqSys.TextAreaPropTypes).ExactText:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWc6I.default), {
                ...commonProps,
                onChange: (newValue)=>{
                    onSearchWrapper && onSearchWrapper((0, $7moyo.getUpdatedJql)(ast, clause, fieldId, newValue, (0, $jPlb3.OPERATOR_EQUALS)));
                }
            });
        default:
            throw new Error(`Unsupported TextAreaPropType: ${propType}`);
    }
};

});
parcelRegister("ediQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $31cee9ad984fd584$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $6K3F5 = parcelRequire("6K3F5");

var $k9Gmz = parcelRequire("k9Gmz");

var $8vLL9 = parcelRequire("8vLL9");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $5LwVz = parcelRequire("5LwVz");

var $bQ4fi = parcelRequire("bQ4fi");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7cSYk = parcelRequire("7cSYk");

var $8XHsn = parcelRequire("8XHsn");

var $jopyG = parcelRequire("jopyG");

var $6cdzW = parcelRequire("6cdzW");

var $lvKO5 = parcelRequire("lvKO5");

var $dTJxm = parcelRequire("dTJxm");

var $1xd19 = parcelRequire("1xd19");

var $i10HP = parcelRequire("i10HP");
const $31cee9ad984fd584$var$formatLabel = (label, value)=>{
    if (value === null || value === undefined || !value.length) return label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "inherit",
        as: "strong"
    }, label), ":\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31cee9ad984fd584$var$ValueWrapper, null, value));
};
const $31cee9ad984fd584$var$shouldValidateAQL = (tenantContext)=>(0, $jopyG.isLicensedPremiumUser)(tenantContext) && (0, $7cSYk.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP);
const $31cee9ad984fd584$export$3ff8b265431bef98 = ({ fieldId: fieldId, fieldDisplayName: fieldDisplayName, isOpen: isOpen, onOpen: onOpen, onClose: onClose, onClear: onClear, onChange: onChange, onSendOptionAnalytics: onSendOptionAnalytics, value: value, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId } = (0, $8XHsn.useWorkspaceContext)();
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ unvalidatedIql: unvalidatedIql, validationResult: validationResult }, { onChange: onIqlChange }] = (0, $6cdzW.useIqlValidation)({
        workspaceId: workspaceId,
        initialIql: value ?? ''
    });
    let aqlValidationError;
    if (validationResult.type === 'invalid') aqlValidationError = validationResult.error;
    (0, $eJOHy.useEffect)(()=>{
        if (!workspaceId) fetchWorkspaceId();
    }, [
        fetchWorkspaceId,
        workspaceId
    ]);
    const handleOnValueChange = (0, $eJOHy.useCallback)((inputValue = '')=>{
        // Only check AQL if it is a premium user
        if ($31cee9ad984fd584$var$shouldValidateAQL(tenantContext)) onIqlChange(inputValue);
    }, [
        onIqlChange,
        tenantContext
    ]);
    const handleOnUpdate = (0, $eJOHy.useCallback)((inputValue)=>{
        onChange(inputValue);
        onClose();
        onSendOptionAnalytics && onSendOptionAnalytics({
            isAqlValidationEnabled: $31cee9ad984fd584$var$shouldValidateAQL(tenantContext),
            searchStringLength: inputValue.length
        });
    }, [
        onChange,
        onClose,
        onSendOptionAnalytics,
        tenantContext
    ]);
    const handleOnHelpClick = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const attributes = {
            actionType: 'close'
        };
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'aqlHelpLink', attributes);
    }, [
        createAnalyticsEvent
    ]);
    const handleOnTriggerClick = (0, $eJOHy.useCallback)(()=>{
        if (isOpen) onClose();
        else {
            onOpen();
            if ($31cee9ad984fd584$var$shouldValidateAQL(tenantContext)) onIqlChange(value || '');
        }
    }, [
        isOpen,
        onClose,
        onIqlChange,
        onOpen,
        tenantContext,
        value
    ]);
    const handleOnAQLValidationRetry = (0, $eJOHy.useCallback)((inputValue)=>()=>onIqlChange(inputValue), [
        onIqlChange
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ($31cee9ad984fd584$var$shouldValidateAQL(tenantContext) && aqlValidationError) {
            // We skip syntax errors from sentry and sent them to privacy unsafe splunk
            const isInvalidSyntaxError = aqlValidationError.includes('invalid syntax');
            (0, $gYnSx.default)({
                error: new Error(isInvalidSyntaxError ? 'invalid syntax' : 'unable to validate AQL query'),
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: isInvalidSyntaxError,
                meta: {
                    id: 'aql-validation-error',
                    packageName: (0, $dTJxm.PACKAGE_NAME),
                    teamName: (0, $dTJxm.TEAM_NAME)
                }
            });
        }
    }, [
        aqlValidationError,
        tenantContext
    ]);
    const getAqlPickerErrorMessage = (0, $eJOHy.useCallback)((inputValue)=>{
        if (!$31cee9ad984fd584$var$shouldValidateAQL(tenantContext)) return undefined;
        switch(validationResult.type){
            case 'valid':
                return unvalidatedIql !== inputValue ? formatMessage((0, $i10HP.default).aqlValidationInProgressMessage) : undefined;
            case 'invalid':
                return aqlValidationError !== 'Failed to fetch' ? formatMessage((0, $i10HP.default).inValidAqlErrorMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
                    alignInline: "center",
                    xcss: $31cee9ad984fd584$var$retryStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, formatMessage((0, $i10HP.default).unableToValidateAqlErrorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                    xcss: $31cee9ad984fd584$var$retryIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                    content: formatMessage((0, $i10HP.default).retry),
                    position: "top"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                    appearance: "link",
                    spacing: "none",
                    onClick: handleOnAQLValidationRetry(inputValue),
                    testId: "jql-builder-basic.ui.jql-editor.field.text-area-picker.aql-picker-popup.retry-button"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vLL9))), {
                    LEGACY_size: "small",
                    label: formatMessage((0, $i10HP.default).retry)
                })))));
            case 'loading':
                return formatMessage((0, $i10HP.default).aqlValidationInProgressMessage);
            default:
                return undefined;
        }
    }, [
        tenantContext,
        validationResult.type,
        unvalidatedIql,
        formatMessage,
        aqlValidationError,
        handleOnAQLValidationRetry
    ]);
    const InfoIconComponent = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9Gmz))), {
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)",
            label: ""
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.text-area-picker.aql-picker-popup.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
                ...triggerProps,
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!value,
                onClick: handleOnTriggerClick,
                onClear: onClear,
                testId: `jql-builder-basic.ui.jql-editor.aql.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, $31cee9ad984fd584$var$formatLabel(fieldDisplayName, value ? formatMessage((0, $i10HP.default).formatLabelMessage) : '')),
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQ4fi.default), {
                value: value ?? '',
                getErrorMessage: getAqlPickerErrorMessage,
                onChange: handleOnUpdate,
                onValueChange: handleOnValueChange,
                placeholderText: formatMessage((0, $i10HP.default).textAreaPlaceholder),
                setInitialFocusRef: setInitialFocusRef,
                footerIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                    xcss: $31cee9ad984fd584$var$helpStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                    content: formatMessage((0, $i10HP.default).aqlSyntaxHelpLinkLabel),
                    position: "top"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K3F5.default), {
                    href: "https://support.atlassian.com/jira-service-management-cloud/docs/use-assets-query-language-aql/",
                    shape: "circle",
                    onClick: handleOnHelpClick,
                    icon: InfoIconComponent,
                    appearance: "subtle",
                    spacing: "compact",
                    label: formatMessage((0, $i10HP.default).aqlSyntaxHelpLinkLabel)
                })))
            })
    });
};
var $31cee9ad984fd584$export$2e2bcd8739ae039 = $31cee9ad984fd584$export$3ff8b265431bef98;
const $31cee9ad984fd584$var$retryStyles = (0, $1DXK0.xcss)({
    height: "var(--ds-space-200, 16px)"
});
const $31cee9ad984fd584$var$helpStyles = (0, $1DXK0.xcss)({
    height: "var(--ds-space-300, 24px)"
});
const $31cee9ad984fd584$var$retryIconStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31cee9ad984fd584$var$ValueWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fuuw1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8vLL9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6523555332355b1d4aa6bddc8955e159>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6326440296d7b869$var$_react = $6326440296d7b869$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6326440296d7b869$var$_retry = $6326440296d7b869$var$_interopRequireDefault((parcelRequire("8pnTC")));

var $6326440296d7b869$var$_retry2 = $6326440296d7b869$var$_interopRequireDefault((parcelRequire("a8nB2")));
function $6326440296d7b869$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RetryIcon.
 * This component is RetryIcon, with `UNSAFE_fallbackIcon` set to "RetryIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6326440296d7b869$var$RetryIcon = (props)=>/*#__PURE__*/ $6326440296d7b869$var$_react.default.createElement($6326440296d7b869$var$_retry.default, Object.assign({
        LEGACY_fallbackIcon: $6326440296d7b869$var$_retry2.default
    }, props));
$6326440296d7b869$var$RetryIcon.Name = 'RetryIconMigration';
var $6326440296d7b869$var$_default = module.exports.default = $6326440296d7b869$var$RetryIcon;

});
parcelRegister("8pnTC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b87cc7d74b53f2f9074ecfc04ea4b65>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61f331c8b661ffec$var$_react = $61f331c8b661ffec$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $61f331c8b661ffec$var$_baseNew = $61f331c8b661ffec$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $61f331c8b661ffec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61f331c8b661ffec$var$RetryIcon = (props)=>/*#__PURE__*/ $61f331c8b661ffec$var$_react.default.createElement($61f331c8b661ffec$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 8a7 7 0 0 1 12.5-4.33V1H15v5a.75.75 0 0 1-.75.75H9.5v-1.5h3.264a5.5 5.5 0 1 0 .665 3.63l1.482.24A7.002 7.002 0 0 1 1 8" clip-rule="evenodd"/>`
    }, props));
$61f331c8b661ffec$var$RetryIcon.displayName = 'RetryIcon';
var $61f331c8b661ffec$var$_default = module.exports.default = $61f331c8b661ffec$var$RetryIcon;

});

parcelRegister("a8nB2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $760cf48101a310d4$var$_react = $760cf48101a310d4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $760cf48101a310d4$var$_retry = $760cf48101a310d4$var$_interopRequireDefault((parcelRequire("8pnTC")));
function $760cf48101a310d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $760cf48101a310d4$var$RetryIcon = (props)=>/*#__PURE__*/ $760cf48101a310d4$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 10h2.954a1 1 0 0 1 0 2H5.099A1.1 1.1 0 0 1 4 10.9V7a1 1 0 1 1 2 0z"/><path fill-rule="nonzero" d="M7.39 10.09H5.3a8 8 0 1 1 .818 6H7.84v-1.02a6 6 0 1 0-.45-4.98"/><circle cx="7" cy="15.61" r="1"/></g></svg>`
    }, props, {
        newIcon: $760cf48101a310d4$var$_retry.default
    }));
$760cf48101a310d4$var$RetryIcon.displayName = 'RetryIcon';
var $760cf48101a310d4$var$_default = module.exports.default = $760cf48101a310d4$var$RetryIcon;

});


parcelRegister("bQ4fi", function(module, exports) {

$parcel$export(module.exports, "default", () => $62773f6dae5fb220$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $fKXve = parcelRequire("fKXve");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $dQmi3 = parcelRequire("dQmi3");

var $dPMMf = parcelRequire("dPMMf");

var $lRq8t = parcelRequire("lRq8t");


var $4GEuJ = parcelRequire("4GEuJ");
const $62773f6dae5fb220$export$60ae88ee9ba520c0 = ({ value: value, getErrorMessage: getErrorMessage, onChange: onChange, onValueChange: onValueChange, placeholderText: placeholderText, setInitialFocusRef: setInitialFocusRef, multiline: multiline = true, footerIcon: footerIcon })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [unsubmittedValue, setUnsubmittedValue] = (0, $eJOHy.useState)(value ?? '');
    const textAreaRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (setInitialFocusRef) setInitialFocusRef(textAreaRef.current);
    }, [
        setInitialFocusRef
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(({ target: { value: targetValue } })=>{
        if (onValueChange) onValueChange(targetValue);
        setUnsubmittedValue(targetValue);
    }, [
        setUnsubmittedValue,
        onValueChange
    ]);
    const handleOnSubmit = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        onChange(unsubmittedValue);
    }, [
        unsubmittedValue,
        onChange
    ]);
    const hasError = (0, $eJOHy.useMemo)(()=>!!getErrorMessage?.(unsubmittedValue), [
        getErrorMessage,
        unsubmittedValue
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (!multiline && event.key === 'Enter') event.preventDefault();
    }, [
        multiline
    ]);
    const handleOnPaste = (0, $eJOHy.useCallback)((event)=>{
        if (!multiline) {
            const data = event.clipboardData.getData('text/plain');
            if (textAreaRef.current && data.includes('\n')) {
                // Replace newlines with spaces
                const paste = data.replace(/\n/g, ' ');
                setUnsubmittedValue(unsubmittedValue.slice(0, textAreaRef.current.selectionStart) + paste + unsubmittedValue.slice(textAreaRef.current.selectionEnd));
                event.preventDefault();
            }
        }
    }, [
        multiline,
        unsubmittedValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($62773f6dae5fb220$var$DialogInner, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($62773f6dae5fb220$var$TextAreaWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dQmi3.default), {
        ref: textAreaRef,
        onChange: handleOnChange,
        value: unsubmittedValue,
        onKeyDown: handleKeyDown,
        "aria-multiline": multiline,
        maxHeight: (0, $e382814c341184bc$export$5cdf10537498e072),
        onPaste: handleOnPaste,
        appearance: "none",
        minimumRows: 4,
        placeholder: placeholderText ?? formatMessage((0, $4GEuJ.default).textAreaPlaceholder),
        testId: "jql-builder-basic-textarea.ui.text-area"
    })), hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($62773f6dae5fb220$var$ErrorMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, getErrorMessage?.(unsubmittedValue))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        spread: "space-between",
        alignBlock: "center",
        grow: "fill",
        xcss: $62773f6dae5fb220$var$footerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($62773f6dae5fb220$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        onClick: handleOnSubmit,
        type: "submit",
        isDisabled: hasError,
        testId: "jql-builder-basic-textarea.ui.update-button"
    }, formatMessage((0, $4GEuJ.default).updateButtonText))), footerIcon));
};
var $62773f6dae5fb220$export$2e2bcd8739ae039 = $62773f6dae5fb220$export$60ae88ee9ba520c0;
const $62773f6dae5fb220$var$footerStyles = (0, $1DXK0.xcss)({
    paddingRight: 'space.150',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderTop: `${"var(--ds-border, #091E4224)"} solid ${(0, $dPMMf.gridSize) / 4}px`,
    paddingTop: 'space.075',
    paddingBottom: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62773f6dae5fb220$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkze3t _2hwxutpp _otyrze3t _18u0utpp _p12f1vmz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62773f6dae5fb220$var$TextAreaWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkv77o _otyr12x7 _18u012x7 _2hwx12x7 _c71l4d55",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62773f6dae5fb220$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1b66 _2hwxutpp _otyr1b66 _18u0utpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62773f6dae5fb220$var$DialogInner = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1mjv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dQmi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef995104f62942f4$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $eGOwo = parcelRequire("eGOwo");
const $ef995104f62942f4$var$packageName = "platform-pkg";
const $ef995104f62942f4$var$packageVersion = "0.0.0-use.local";
const $ef995104f62942f4$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $ef995104f62942f4$var$packageName,
    packageVersion: $ef995104f62942f4$var$packageVersion
};
const $ef995104f62942f4$var$lineHeightBase = 20;
const $ef995104f62942f4$var$lineHeightCompact = 16;
const $ef995104f62942f4$var$compactVerticalPadding = 2;
const $ef995104f62942f4$var$verticalPadding = 6;
const $ef995104f62942f4$var$transitionDuration = '0.2s';
const $ef995104f62942f4$var$borderWidth = 2;
const $ef995104f62942f4$var$baseStyles = null;
const $ef995104f62942f4$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $ef995104f62942f4$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $ef995104f62942f4$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $ef995104f62942f4$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $ef995104f62942f4$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $ef995104f62942f4$var$InnerTextArea = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const ourRef = (0, $eJOHy.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $eJOHy.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ef995104f62942f4$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ef995104f62942f4$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ef995104f62942f4$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eJOHy.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ef995104f62942f4$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $ef995104f62942f4$var$appearanceStyles[appearance],
            (0, $eGOwo.fg)('platform_design_system_team_safari_input_fix') && $ef995104f62942f4$var$fontStyles['large'],
            $ef995104f62942f4$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $ef995104f62942f4$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $awdRS.default)($ef995104f62942f4$var$lineHeightCompact * minimumRows + $ef995104f62942f4$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $awdRS.default)($ef995104f62942f4$var$lineHeightBase * minimumRows + $ef995104f62942f4$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $ef995104f62942f4$var$TextArea = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ef995104f62942f4$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$ef995104f62942f4$var$TextArea.displayName = 'TextArea';
var $ef995104f62942f4$export$2e2bcd8739ae039 = $ef995104f62942f4$var$TextArea;

});

const $e382814c341184bc$export$5cdf10537498e072 = '232px';

parcelRegister("4GEuJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a54d2e08763e74ff$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a54d2e08763e74ff$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    updateButtonText: {
        "id": "jql-builder-basic-textarea.update-button-text",
        "defaultMessage": "Update"
    },
    textAreaPlaceholder: {
        "id": "jql-builder-basic-textarea.text-area-placeholder",
        "defaultMessage": "Begin typing..."
    }
});

});


parcelRegister("6cdzW", function(module, exports) {

$parcel$export(module.exports, "useIqlValidation", () => $3855fabe06311dda$export$e39e6ad91e20e4a0);

var $eJOHy = parcelRequire("eJOHy");

var $1kTCl = parcelRequire("1kTCl");

var $51aj0 = parcelRequire("51aj0");

var $7GNC3 = parcelRequire("7GNC3");

var $2dx7O = parcelRequire("2dx7O");
const $3855fabe06311dda$var$IQL_VALIDATE_DELAY = 300;
const $3855fabe06311dda$var$getInitialStateForIql = (newUnvalidatedIql)=>({
        unvalidatedIql: newUnvalidatedIql,
        validationResult: newUnvalidatedIql === (0, $7GNC3.EMPTY_VALIDATED_IQL) ? {
            type: 'valid',
            validatedIql: (0, $7GNC3.EMPTY_VALIDATED_IQL)
        } : {
            type: 'loading'
        }
    });
const $3855fabe06311dda$export$e39e6ad91e20e4a0 = ({ workspaceId: workspaceId, initialIql: initialIql })=>{
    const [state, setState] = (0, $eJOHy.useState)({
        unvalidatedIql: String(initialIql),
        validationResult: {
            type: 'valid',
            validatedIql: initialIql
        }
    });
    // Debounce calls to prevent validation being requested on every key press
    const [debouncedValidate] = (0, $1kTCl.default)(async (newUnvalidatedIql)=>{
        let newValidationResult;
        try {
            if (!workspaceId) return;
            newValidationResult = await (0, $2dx7O.validateQlQuery)({
                workspaceId: workspaceId,
                unvalidatedIql: newUnvalidatedIql
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $51aj0.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'validateIql',
                    packageName: 'jiraServicedeskInsightIqlValidation',
                    teamName: 'aurum'
                }
            });
            newValidationResult = {
                type: 'invalid',
                error: error.message
            };
        }
        setState((prevState)=>{
            // If unvalidatedIql in the state has changed since this was called, this means the user has changed the IQL
            // making this current request invalid.
            if (prevState.unvalidatedIql !== newUnvalidatedIql) return prevState;
            return {
                unvalidatedIql: newUnvalidatedIql,
                validationResult: newValidationResult
            };
        });
    }, $3855fabe06311dda$var$IQL_VALIDATE_DELAY);
    const onChange = (0, $eJOHy.useCallback)((newUnvalidatedIql)=>{
        const newState = $3855fabe06311dda$var$getInitialStateForIql(newUnvalidatedIql);
        setState(newState);
        if (newState.validationResult.type === 'valid') return;
        debouncedValidate(newUnvalidatedIql);
    }, [
        debouncedValidate,
        setState
    ]);
    return [
        state,
        {
            onChange: onChange
        }
    ];
};

});
parcelRegister("7GNC3", function(module, exports) {

$parcel$export(module.exports, "EMPTY_VALIDATED_IQL", () => $2b8911246c28aaf6$export$f3e6582beacb59ad);

var $3VjNa = parcelRequire("3VjNa");
const $2b8911246c28aaf6$export$f3e6582beacb59ad = (0, $3VjNa.toValidatedIql)('');

});
parcelRegister("3VjNa", function(module, exports) {

$parcel$export(module.exports, "toValidatedIql", () => $f119345919c992e3$export$d2a6b8af2abc27c3);
const $f119345919c992e3$export$d2a6b8af2abc27c3 = (value)=>value;

});


parcelRegister("2dx7O", function(module, exports) {

$parcel$export(module.exports, "validateQlQuery", () => $c696c8cdc5303cfd$export$24689a54c49a777b);

var $u4YbY = parcelRequire("u4YbY");

var $aXuRT = parcelRequire("aXuRT");

var $3VjNa = parcelRequire("3VjNa");
const $c696c8cdc5303cfd$export$24689a54c49a777b = async ({ workspaceId: workspaceId, unvalidatedIql: unvalidatedIql })=>{
    const queryLanguageKey = 'qlQuery';
    const { isValid: isValid, errorMessages: errorMessages } = await (0, $u4YbY.performCmdbPostRequest)((0, $aXuRT.getCmdbQueryLanguageValidateUrl)(workspaceId), {
        body: JSON.stringify({
            context: 'ADVANCED_SEARCH',
            [queryLanguageKey]: unvalidatedIql
        })
    });
    if (isValid) return {
        type: 'valid',
        validatedIql: (0, $3VjNa.toValidatedIql)(unvalidatedIql)
    };
    return {
        type: 'invalid',
        error: errorMessages.join('')
    };
};

});
parcelRegister("aXuRT", function(module, exports) {

$parcel$export(module.exports, "getCmdbQueryLanguageValidateUrl", () => $d117fa7e71eb3fad$export$d8f39b0cf0b8673e);

var $1qZG3 = parcelRequire("1qZG3");
const $d117fa7e71eb3fad$var$getCmdbQueryLanguageUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/aql`;
const $d117fa7e71eb3fad$export$d8f39b0cf0b8673e = (workspaceId)=>`${$d117fa7e71eb3fad$var$getCmdbQueryLanguageUrl(workspaceId)}/validate`;

});



parcelRegister("i10HP", function(module, exports) {

$parcel$export(module.exports, "default", () => $31525b398377bd13$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $31525b398377bd13$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    formatLabelMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.format-label-message",
        "defaultMessage": "AQL Query"
    },
    textAreaPlaceholder: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.text-area-placeholder",
        "defaultMessage": "Enter AQL Search"
    },
    aqlValidationInProgressMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.aql-validation-in-progress-message",
        "defaultMessage": "Validating AQL..."
    },
    inValidAqlErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.in-valid-aql-error-message",
        "defaultMessage": "Please enter a valid AQL query"
    },
    aqlSyntaxHelpLinkLabel: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.aql-syntax-help-link-label",
        "defaultMessage": "Assets Query Language syntax help"
    },
    unableToValidateAqlErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.unable-to-validate-aql-error-message",
        "defaultMessage": "Unable to validate AQL query"
    },
    retry: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.retry",
        "defaultMessage": "Retry"
    }
});

});


parcelRegister("aEcQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8048fff7250ffb6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fQnJZ = parcelRequire("fQnJZ");

var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $5LwVz = parcelRequire("5LwVz");

var $bQ4fi = parcelRequire("bQ4fi");

var $cNe2t = parcelRequire("cNe2t");


var $1xd19 = parcelRequire("1xd19");

var $19xe7 = parcelRequire("19xe7");

var $leDB3 = parcelRequire("leDB3");
const $d8048fff7250ffb6$export$957d7daebd899f12 = (label, value)=>{
    if (value === null || value === undefined || !value.length) return label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "inherit",
        as: "strong"
    }, label), ":\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d8048fff7250ffb6$var$ValueWrapper, null, value));
};
const $d8048fff7250ffb6$export$8ca1a6c3a31e7665 = ({ fieldId: fieldId, fieldDisplayName: fieldDisplayName, isOpen: isOpen, onOpen: onOpen, onClose: onClose, onClear: onClear, onChange: onChange, onSendOptionAnalytics: onSendOptionAnalytics, value: value, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)(); /**
                  * Note - despite the name, this actually handles the onClick
                  * of the 'Update' button that appears in the footer of the picker content,
                  * it does not get called on a change event
                  */ 
    const handleOnChange = (0, $eJOHy.useCallback)((inputValue)=>{
        onChange(inputValue);
        onClose();
        onSendOptionAnalytics && onSendOptionAnalytics({
            searchStringLength: inputValue.length
        });
    }, [
        onChange,
        onClose,
        onSendOptionAnalytics
    ]);
    const handleOnTriggerClick = (0, $eJOHy.useCallback)(()=>{
        isOpen ? onClose() : onOpen();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const getNumberPickerErrorMessage = (0, $eJOHy.useCallback)((inputValue)=>{
        if ((0, $19xe7.isUnsubmittedValueNotANumber)(inputValue)) return formatMessage((0, $leDB3.default).validNumberErrorMessage);
         // this assumes that value is a valid number
        if ((0, $19xe7.isUnsubmittedNumberTooLarge)((0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(inputValue))) return formatMessage((0, $leDB3.default).numberSizeLimitErrorMessage, {
            maxSize: (0, $c6374ddcf66d0147$export$3aefefab9ae0beef).toLocaleString()
        });
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.text-area-picker.number-picker-popup.popup",
        messageType: "transactional",
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!value,
                onClick: handleOnTriggerClick,
                onClear: onClear,
                ref: ref,
                testId: `jql-builder-basic.ui.jql-editor.number.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, $d8048fff7250ffb6$export$957d7daebd899f12(fieldDisplayName, value)),
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQ4fi.default), {
                value: value || '',
                getErrorMessage: getNumberPickerErrorMessage,
                setInitialFocusRef: setInitialFocusRef,
                multiline: false,
                onChange: handleOnChange,
                placeholderText: formatMessage((0, $leDB3.default).numberPlaceholderMessage)
            })
    });
};
var $d8048fff7250ffb6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d8048fff7250ffb6$export$8ca1a6c3a31e7665;
const $d8048fff7250ffb6$var$ValueWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fuuw1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("leDB3", function(module, exports) {

$parcel$export(module.exports, "default", () => $eacf2101eadb05ce$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $eacf2101eadb05ce$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    numberPlaceholderMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.number-picker-popup.number-placeholder-message",
        "defaultMessage": "Enter a number"
    },
    validNumberErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.number-picker-popup.valid-number-error-message",
        "defaultMessage": "Please enter a valid number"
    },
    numberSizeLimitErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.number-picker-popup.number-size-limit-error-message",
        "defaultMessage": "Specify a number for the custom field (below {maxSize})"
    }
});

});


parcelRegister("gWc6I", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c9fabcea5d2ce2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $5LwVz = parcelRequire("5LwVz");

var $bQ4fi = parcelRequire("bQ4fi");

var $814y1 = parcelRequire("814y1");

var $cNe2t = parcelRequire("cNe2t");

var $eqSys = parcelRequire("eqSys");

var $1xd19 = parcelRequire("1xd19");


var $hsb9B = parcelRequire("hsb9B");

var $5d1TC = parcelRequire("5d1TC");
const $14c9fabcea5d2ce2$export$957d7daebd899f12 = (label, value)=>{
    if (value === null || value === undefined || !value.length) return label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "inherit",
        as: "strong"
    }, label), ': "', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($14c9fabcea5d2ce2$var$ValueWrapper, null, value), '"');
};
const $14c9fabcea5d2ce2$export$3f65fe93ad5d48a1 = ({ fieldId: fieldId, fieldDisplayName: fieldDisplayName, propType: propType, fieldType: fieldType, isOpen: isOpen, onOpen: onOpen, onClose: onClose, onClear: onClear, onChange: onChange, onSendOptionAnalytics: onSendOptionAnalytics, value: value, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)(); /**
                  * Note - despite the name, this actually handles the onClick
                  * of the 'Update' button that appears in the footer of the picker content,
                  * it does not get called on a change event
                  */ 
    const handleOnChange = (0, $eJOHy.useCallback)((inputValue)=>{
        onChange(inputValue);
        onClose();
        onSendOptionAnalytics && onSendOptionAnalytics({
            searchStringLength: inputValue.length
        });
    }, [
        onChange,
        onClose,
        onSendOptionAnalytics
    ]);
    const handleOnTriggerClick = (0, $eJOHy.useCallback)(()=>{
        isOpen ? onClose() : onOpen();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const getTextAreaPickerErrorMessage = (0, $eJOHy.useCallback)((inputValue)=>{
        if ((fieldType === (0, $814y1.TEXT_READONLY_CF_TYPE) || fieldType === (0, $814y1.TEXT_CF_TYPE) || propType === (0, $eqSys.TextAreaPropTypes).ExactText) && (0, $5d1TC.isUnsubmittedValueTooLong)(inputValue)) return formatMessage((0, $hsb9B.default).characterLimitErrorMessage, {
            maxChars: (0, $dac7ffb69b790f6c$export$bfd6231f3a02692b)
        });
        if (fieldType === (0, $814y1.URL_CF_TYPE) && !(0, $5d1TC.isValidUrl)(inputValue)) return formatMessage((0, $hsb9B.default).invalidUrlErrorMessage);
        return undefined;
    }, [
        fieldType,
        formatMessage,
        propType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.text-area-picker.text-area-picker-popup.popup",
        messageType: "transactional",
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!value,
                onClick: handleOnTriggerClick,
                onClear: onClear,
                ref: ref,
                testId: `jql-builder-basic.ui.jql-editor.text-area.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, $14c9fabcea5d2ce2$export$957d7daebd899f12(fieldDisplayName, value)),
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQ4fi.default), {
                setInitialFocusRef: setInitialFocusRef,
                value: value || '',
                getErrorMessage: getTextAreaPickerErrorMessage,
                onChange: handleOnChange,
                multiline: fieldType !== (0, $814y1.URL_CF_TYPE)
            })
    });
};
var $14c9fabcea5d2ce2$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $14c9fabcea5d2ce2$export$3f65fe93ad5d48a1;
const $14c9fabcea5d2ce2$var$ValueWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fuuw1",
            __cmplp.className
        ])
    });
});

});
const $dac7ffb69b790f6c$export$bfd6231f3a02692b = 255;

parcelRegister("hsb9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $daacf239d67a430a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $daacf239d67a430a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    characterLimitErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.text-area-picker-popup.character-limit-error-message",
        "defaultMessage": "You've reached the character limit ({maxChars})"
    },
    invalidUrlErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.text-area-picker-popup.invalid-url-error-message",
        "defaultMessage": "Please enter a valid URL."
    }
});

});

parcelRegister("5d1TC", function(module, exports) {

$parcel$export(module.exports, "isUnsubmittedValueTooLong", () => $a52a5cfa90a1389c$export$6db449563fc820c1);
$parcel$export(module.exports, "isValidUrl", () => $a52a5cfa90a1389c$export$bef94a5618bf18bf);

const $a52a5cfa90a1389c$export$6db449563fc820c1 = (unsubmittedValue)=>unsubmittedValue.length > (0, $dac7ffb69b790f6c$export$bfd6231f3a02692b);
const $a52a5cfa90a1389c$export$bef94a5618bf18bf = (url)=>{
    // empty string is valid
    if (url === '') return true;
    try {
        new URL(url);
        return true;
    } catch (e) {
        return false;
    }
};

});


parcelRegister("7moyo", function(module, exports) {

$parcel$export(module.exports, "getUpdatedJql", () => $09603702ff96638f$export$1625bb7ada97d007);
$parcel$export(module.exports, "getUpdatedJqlWithAql", () => $09603702ff96638f$export$bfbecae194e14c6f);
$parcel$export(module.exports, "getAqlFromClause", () => $09603702ff96638f$export$dfeec2a4cb0aae8b);

var $f26C8 = parcelRequire("f26C8");
var $1jiqw = parcelRequire("1jiqw");

var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");
const $09603702ff96638f$var$createTerminalClause = (fieldId, value, operator)=>// TODO: escapeBackslashes serves as a temporary patch to convert jqlTerm into a format suitable for creator API.
    // EM-6563 should resolve this by updating creator API to accept the semantic JQL value for jqlTerm currently returned by hydrateJqlQuery.
    (0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $eiIzV.escapeBackslashes)(fieldId)), (0, $f26C8.default).operator(operator), (0, $f26C8.default).byText.valueOperand((0, $eiIzV.wrapWithQuotes)((0, $eiIzV.escapeBackslashes)(value))));
const $09603702ff96638f$export$1625bb7ada97d007 = (ast, clause, fieldId, value, operator)=>{
    if (!clause) {
        if (!value || !ast.query) return ast.represents;
        ast.query.appendClause($09603702ff96638f$var$createTerminalClause(fieldId, value, operator), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
    } else if (!value) clause.remove();
    else {
        if (clause.clauseType === (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a) && clause.operand?.operandType === (0, $862dfd240457f00b$export$38accfc5a5d1c113) && clause.operand.value === value && clause.operator?.value === operator) // If the clause already exists and the value is the same, return the original JQL
        // without modifying the AST. This is to prevent the introduction of stale clause objects.
        return ast.represents;
        clause.replace($09603702ff96638f$var$createTerminalClause(fieldId, value, operator));
    }
    return (0, $1jiqw.print)(ast, {
        operatorCase: 'upper'
    });
};
const $09603702ff96638f$var$createAqlTerminalClause = (fieldId, value, operator)=>// TODO: escapeBackslashes serves as a temporary patch to convert jqlTerm into a format suitable for creator API.
    // EM-6563 should resolve this by updating creator API to accept the semantic JQL value for jqlTerm currently returned by hydrateJqlQuery.
    (0, $f26C8.default).terminalClause((0, $f26C8.default).field((0, $eiIzV.escapeBackslashes)(fieldId)), (0, $f26C8.default).operator(operator), // Confirmed with the team that they prefer to use aqlFunction instead of iqlFunction
    (0, $f26C8.default).byText.valueOperand(`${(0, $dTJxm.AQL_FUNCTION_NAME)}(${(0, $eiIzV.wrapWithQuotes)((0, $eiIzV.escapeBackslashes)(value))})`));
const $09603702ff96638f$export$bfbecae194e14c6f = (ast, clause, fieldId, value, operator)=>{
    if (!clause) {
        if (!value || !ast.query) return ast.represents;
        ast.query.appendClause($09603702ff96638f$var$createAqlTerminalClause(fieldId, value, operator), (0, $f6415dda43b7f459$export$6d6d48d210d3ca97));
    } else if (!value) clause.remove();
    else {
        if ($09603702ff96638f$export$dfeec2a4cb0aae8b(clause) === value && clause.operator?.value === operator) // If the clause already exists and the value is the same, return the original JQL
        // without modifying the AST. This is to prevent the introduction of stale clause objects.
        return ast.represents;
        clause.replace($09603702ff96638f$var$createAqlTerminalClause(fieldId, value, operator));
    }
    return (0, $1jiqw.print)(ast, {
        operatorCase: 'upper'
    });
};
const $09603702ff96638f$export$dfeec2a4cb0aae8b = (clause)=>clause && clause.clauseType === (0, $2a3824620e125bfd$export$ae56b4ef248a2b6a) && clause.operand && clause.operand.operandType === (0, $862dfd240457f00b$export$19c7c729db381f9d) && (clause.operand.function.value.toLowerCase() === (0, $dTJxm.AQL_FUNCTION_NAME).toLowerCase() || clause.operand.function.value.toLowerCase() === (0, $dTJxm.IQL_FUNCTION_NAME).toLowerCase()) && clause.operand.arguments[0].value || '';

});


parcelRegister("01FiY", function(module, exports) {

$parcel$export(module.exports, "UnsupportedPickerWrapper", () => $057edf7a7af93f5f$export$7b689f7721b0be1f);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $iHPvF = parcelRequire("iHPvF");
var $akOEX = parcelRequire("akOEX");

var $lRq8t = parcelRequire("lRq8t");

var $5LwVz = parcelRequire("5LwVz");

var $boEdP = parcelRequire("boEdP");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $1xd19 = parcelRequire("1xd19");

var $lyPdT = parcelRequire("lyPdT");

var $kDsTX = parcelRequire("kDsTX");
const $057edf7a7af93f5f$export$7b689f7721b0be1f = ({ activePopupKey: activePopupKey, clause: clause, fieldId: fieldId, fieldLabel: fieldLabel, fieldDescription: fieldDescription, onClose: onClose, onOpen: onOpen, onClear: onClear, onSwitchToJql: onSwitchToJql })=>{
    const isOpen = activePopupKey === fieldId;
    const handleOnTriggerClick = (0, $eJOHy.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]);
    const [ast] = (0, $lyPdT.useAST)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onSwitchToJqlWrapper = (0, $eJOHy.useCallback)(()=>{
        if (onSwitchToJql) {
            onSwitchToJql();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'jqlBuilderBasicUnsupportedField', {});
        }
    }, [
        createAnalyticsEvent,
        onSwitchToJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.unsupported-picker-wrapper.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
                ...triggerProps,
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!clause,
                onClick: handleOnTriggerClick,
                onClear: ()=>onClear(clause ? (0, $boEdP.default)(ast, clause) : undefined),
                testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
                fieldDescription: fieldDescription
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                color: "inherit",
                weight: "medium"
            }, clause ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "strong"
            }, fieldLabel) : fieldLabel)),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
                actions: onSwitchToJql ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akOEX.default), {
                    onClick: onSwitchToJqlWrapper
                }, formatMessage((0, $kDsTX.default).switchToJql)) : undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "p"
            }, formatMessage((0, $kDsTX.default).messageToCustomer, {
                fieldLabel: fieldLabel,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, chunks)
            })))
    });
};
var $057edf7a7af93f5f$export$2e2bcd8739ae039 = $057edf7a7af93f5f$export$7b689f7721b0be1f;

});
parcelRegister("kDsTX", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6b0a479a4e571bf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c6b0a479a4e571bf$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    all: {
        "id": "jql-builder-basic.jql-editor.field.unsupported-picker-wrapper.all",
        "defaultMessage": "All"
    },
    switchToJql: {
        "id": "jql-builder-basic.jql-editor.field.unsupported-picker-wrapper.switch-to-jql",
        "defaultMessage": "Switch to JQL"
    },
    messageToCustomer: {
        "id": "jql-builder-basic.jql-editor.field.unsupported-picker-wrapper.message-to-customer",
        "defaultMessage": "To search by <b>{fieldLabel}</b>."
    }
});

});



parcelRegister("dlxet", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef4c50b29ad2a050$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $o0Fzr = parcelRequire("o0Fzr");

var $f26C8 = parcelRequire("f26C8");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $8WkNi = parcelRequire("8WkNi");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $iRlQc = parcelRequire("iRlQc");

var $9dqYm = parcelRequire("9dqYm");

var $2ftMY = parcelRequire("2ftMY");

var $idYtD = parcelRequire("idYtD");

var $ixIfb = parcelRequire("ixIfb");

var $aBVhI = parcelRequire("aBVhI");
const $ef4c50b29ad2a050$export$d9f1e39ff1ffb511 = 'ORDER_BY_DROPDOWN';
/**
 * Replaces the default container element that wraps the picker content
 * so we can control its css properties
 */ const $ef4c50b29ad2a050$var$CustomPopupComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, 'data-testid': testId, xcss: _xcss, ...props }, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ef4c50b29ad2a050$var$containerStyle,
        testId: testId,
        ...props,
        ref: ref
    }, children));
const $ef4c50b29ad2a050$var$OrderByPicker = ({ ast: ast, onChange: onChange, contextJql: contextJql, hydrationData: hydrationData, viewContext: viewContext, scope: scope })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [internalSelectedFields, setInternalSelectedFields] = (0, $eJOHy.useState)(()=>(0, $aBVhI.getNextSelectedOrderByFields)({
            ast: ast,
            hydrationData: hydrationData,
            selectedOrderByFields: []
        }));
    const firePickerAnalytics = (0, $eJOHy.useCallback)((isOpen, orderByFieldCount)=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownMenu',
            actionSubjectId: 'orderByPicker',
            attributes: {
                isOpen: isOpen,
                orderByFieldCount: // So we can determine if the add field button needs to be
                // repositioned as long lists of fields mean it is needing to be
                // scrolled to
                orderByFieldCount
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const [activePopupKey, { openPopup: openPopup, closePopup: closePopup }] = (0, $9dqYm.useActivePopupKey)();
    const onOpen = (0, $eJOHy.useCallback)(()=>{
        openPopup($ef4c50b29ad2a050$export$d9f1e39ff1ffb511);
        firePickerAnalytics(true, internalSelectedFields.length);
    }, [
        firePickerAnalytics,
        internalSelectedFields.length,
        openPopup
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>{
        firePickerAnalytics(false, internalSelectedFields.length);
        closePopup($ef4c50b29ad2a050$export$d9f1e39ff1ffb511);
    }, [
        closePopup,
        firePickerAnalytics,
        internalSelectedFields.length
    ]);
    const isOpen = activePopupKey === $ef4c50b29ad2a050$export$d9f1e39ff1ffb511;
    const buttonId = (0, $o0Fzr.useUID)();
    /**
	 * Popup does not want to close when users click browser back / forward buttons so manually
	 * compare the AST fields to the fields in the internal state, if they differ, the JQL was changed
	 * by an external action, so close the picker.
	 */ (0, $eJOHy.useEffect)(()=>{
        const astSortFields = (0, $idYtD.getAstSortFields)(ast);
        const isInternalChange = (0, $aBVhI.compareSortFields)(astSortFields, internalSelectedFields);
        if (!isInternalChange) onClose();
    }, [
        ast,
        internalSelectedFields,
        onClose
    ]);
    /**
	 * Changes to sort fields can come from internal (user interacting with the picker) or external
	 * (jql is changed by other means such as clicking a filter or browser back button). This means
	 * the picker needs to handle both scenarios and update the UI accordingly. This is achieved by
	 * comparing the ast, hydration data and what is currently internally tracked and deciding which
	 * sort fields to set in the next state
	 */ (0, $eJOHy.useEffect)(()=>{
        setInternalSelectedFields((currentInternalSelectedFields)=>(0, $aBVhI.getNextSelectedOrderByFields)({
                ast: ast,
                hydrationData: hydrationData,
                selectedOrderByFields: currentInternalSelectedFields
            }));
    }, [
        ast,
        hydrationData
    ]);
    /**
	 * any currently selected field becomes an excluded field so that duplicates cannot be selected
	 * in the picker(s)
	 */ const excludedFields = internalSelectedFields.map((selctedOrderByField)=>selctedOrderByField.jqlTerm);
    /**
	 * each rendered basic-picker within OrderBySelect uses this to fetch the picker options
	 */ const onLoadOptions = (0, $2ftMY.useFields)({
        jql: contextJql,
        excludeFields: excludedFields,
        forClause: 'ORDER_BY',
        viewContext: viewContext,
        scope: scope
    });
    /**
	 * attaches to a container element that wraps the picker and will prevent Esc key presses
	 * bubbling outside of the picker.
	 * This is needed for times when the picker might be rendered in a modal and we want
	 * users to be able to press Esc to close the picker, without also closing the modal.
	 */ const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Escape') {
            isOpen && event.stopPropagation();
            onClose();
        }
    }, [
        isOpen,
        onClose
    ]);
    /**
	 * Called each time the OrderBySelect fields change, are added or removed.
	 * This handler will take the new fields object, use it to update the ast which is printed to a
	 * string and passed to the onChange callback to trigger a new search
	 */ const handleOnChange = (0, $eJOHy.useCallback)((fields)=>{
        // If users have clicked the same option from a picker, no need to trigger a whole new
        // search
        const shouldUpdate = !(0, $aBVhI.compareSortFields)(internalSelectedFields, fields);
        if (shouldUpdate) {
            // Set the internal state so changes a immediately visible (optimistic update)
            setInternalSelectedFields(fields);
            // Trigger a new search as a side effect this will then be handled in the useEffects
            if (ast.query) {
                ast.query.replaceOrderBy((0, $f26C8.default).orderBy(fields.map((f)=>(0, $f26C8.default).orderByField((0, $f26C8.default).field(f.jqlTerm), f.direction ? (0, $f26C8.default).orderByDirection(f.direction) : undefined))));
                onChange((0, $aBVhI.printJast)(ast));
            }
        }
    }, [
        ast,
        internalSelectedFields,
        onChange
    ]);
    const handleOnClearAllFields = (0, $eJOHy.useCallback)(()=>{
        setInternalSelectedFields([]);
        if (ast.query) {
            ast.query.removeOrderBy();
            onChange((0, $aBVhI.printJast)(ast));
        }
    }, [
        ast,
        onChange
    ]);
    const renderContent = (0, $eJOHy.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $ef4c50b29ad2a050$var$menuStyle,
            role: "presentation",
            ref: setInitialFocusRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8WkNi.default), {
            fields: internalSelectedFields,
            onLoadPickerOptions: onLoadOptions,
            onChange: handleOnChange
        })), Boolean(internalSelectedFields.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixIfb.default), {
            onClear: handleOnClearAllFields
        })), [
        internalSelectedFields,
        onLoadOptions,
        handleOnChange,
        handleOnClearAllFields
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        role: "dialog",
        titleId: buttonId,
        isOpen: isOpen,
        onClose: onClose,
        autoFocus: false,
        shouldRenderToParent: true,
        placement: "bottom-start",
        messageId: "jql-builder-basic.ui.jql-editor.order-by-picker.popup",
        messageType: "transactional",
        popupComponent: $ef4c50b29ad2a050$var$CustomPopupComponent,
        content: renderContent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iRlQc.default), {
                isSelected: isOpen,
                buttonId: buttonId,
                triggerProps: triggerProps,
                numberOfFields: internalSelectedFields.length,
                onClick: isOpen ? onClose : onOpen
            })
    }));
};
var $ef4c50b29ad2a050$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($ef4c50b29ad2a050$var$OrderByPicker);
const $ef4c50b29ad2a050$var$containerStyle = (0, $1DXK0.xcss)({
    zIndex: 'layer',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    width: '300px',
    borderRadius: 'border.radius'
});
const $ef4c50b29ad2a050$var$menuStyle = (0, $1DXK0.xcss)({
    maxHeight: '284px',
    padding: 'space.150',
    paddingLeft: 'space.150',
    overflow: 'auto'
});

});
parcelRegister("8WkNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c9d92c9bfbd312c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");

var $kKLn8 = parcelRequire("kKLn8");

var $9y4v7 = parcelRequire("9y4v7");
const $5c9d92c9bfbd312c$var$BasicOrderBySelect = ({ fields: fields, onLoadPickerOptions: onLoadPickerOptions, onChange: onChange })=>{
    const onChangeField = (0, $eJOHy.useCallback)((index, field)=>{
        const nextFields = fields.map((currentField, currentIndex)=>index === currentIndex ? {
                ...field
            } : currentField);
        onChange(nextFields);
    }, [
        fields,
        onChange
    ]);
    const onRemoveField = (0, $eJOHy.useCallback)((index)=>{
        const nextFields = fields.filter((currentField, currentIndex)=>index !== currentIndex);
        onChange(nextFields);
    }, [
        fields,
        onChange
    ]);
    const onAddnewField = (0, $eJOHy.useCallback)((field)=>{
        const nextFields = [
            ...fields,
            field
        ];
        onChange(nextFields);
    }, [
        fields,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        gap: "space.100",
        direction: "column"
    }, fields.map((field, fieldIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9y4v7.default), {
            key: fieldIndex,
            field: field,
            fieldIndex: fieldIndex,
            onChange: onChangeField,
            onLoadOptions: onLoadPickerOptions,
            onRemove: onRemoveField
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKLn8.default), {
        onLoadOptions: onLoadPickerOptions,
        onSelectField: onAddnewField
    }));
};
var $5c9d92c9bfbd312c$export$2e2bcd8739ae039 = $5c9d92c9bfbd312c$var$BasicOrderBySelect;

});
parcelRegister("kKLn8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cece478dfcf1a02e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


var $2sLVw = parcelRequire("2sLVw");

var $lRq8t = parcelRequire("lRq8t");

var $ixh2S = parcelRequire("ixh2S");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $cfy7S = parcelRequire("cfy7S");

var $7VqEq = parcelRequire("7VqEq");
const $cece478dfcf1a02e$var$FIELD_ID = 'add-order-by-field';
const $cece478dfcf1a02e$var$VALUE = [];
const $cece478dfcf1a02e$var$AddFieldPicker = ({ onLoadOptions: onLoadOptions, onSelectField: onSelectField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const handleTriggerClick = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen((currentisOpen)=>{
            const newOpenState = !currentisOpen;
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownMenu',
                actionSubjectId: 'addOrderByFieldPicker',
                attributes: {
                    isOpen: newOpenState
                }
            });
            return newOpenState;
        });
    }, [
        createAnalyticsEvent
    ]);
    const handlePickerCloseClick = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen(false);
    }, []);
    const handleFieldChanged = (0, $eJOHy.useCallback)((newValue, actionMeta)=>{
        // @ts-expect-error TS inference not working with the SelectedValue type
        // despite explicit checks it always still thinks it might be an array or null
        // not sure of the root cause whether type defs in
        // jira/src/packages/jql-builder/basic-picker/src/common/types.tsx or TS issue at
        // the platform level
        if (newValue === null || Array.isArray(newValue) || !newValue.value || !newValue.label) return null;
        if (actionMeta.action === 'select-option') {
            const updatedField = {
                // @ts-expect-error see above
                displayText: newValue.label,
                // @ts-expect-error see above
                jqlTerm: newValue.value,
                direction: (0, $adec16a85d57f51f$export$6d60017b9e092e73)
            };
            onSelectField(updatedField);
            setIsOpen(false);
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'selectOption'
            }), 'addOrderByFieldPicker');
        }
    }, [
        createAnalyticsEvent,
        onSelectField
    ]);
    const onPickerTrigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cfy7S.default), {
            ariaLabel: formatMessage((0, $7VqEq.default).addFieldDisplayText),
            triggerProps: triggerProps,
            displayText: formatMessage((0, $7VqEq.default).addFieldDisplayText),
            onClick: handleTriggerClick,
            isOpen: isOpen
        }), [
        formatMessage,
        handleTriggerClick,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixh2S.Picker), {
        isMulti: false,
        isOpen: isOpen,
        id: $cece478dfcf1a02e$var$FIELD_ID,
        value: $cece478dfcf1a02e$var$VALUE,
        onTrigger: onPickerTrigger,
        onClose: handlePickerCloseClick,
        onChange: handleFieldChanged,
        onLoadOptions: onLoadOptions,
        shouldRenderToParent: true
    }));
};
var $cece478dfcf1a02e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($cece478dfcf1a02e$var$AddFieldPicker);

});
parcelRegister("cfy7S", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c228f8d7f144dd9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5lAAn = parcelRequire("5lAAn");

var $goZPP = parcelRequire("goZPP");
const $4c228f8d7f144dd9$var$PickerTrigger = ({ triggerProps: triggerProps, displayText: displayText, onClick: onClick, isOpen: isOpen, shouldFitContainer: shouldFitContainer = false, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4c228f8d7f144dd9$var$StyledTriggerButton, {
        ...triggerProps,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            spacing: "spacious",
            label: "",
            size: "small"
        }),
        onClick: onClick,
        shouldFitContainer: shouldFitContainer,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        "aria-haspopup": "listbox"
    }, displayText);
var $4c228f8d7f144dd9$export$2e2bcd8739ae039 = $4c228f8d7f144dd9$var$PickerTrigger;
/*
 * Use of jira-jql-builder-basic-picker requires a trigger to be provided as a prop. In jql-builder,
 * atlaskit/button is used as a trigger. However our design spec is based on an atlaskit/select which
 * left aligns text on the trigger. This workaround is left aligning the text so that it looks more
 * like an atlaskit/select trigger.
 * This also restricts us to using legacy button as button/new does not work with `styled()`
 * TODO - https://jplat.jira.atlassian.cloud/browse/EM-7822
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-unsafe-style-overrides
const $4c228f8d7f144dd9$var$StyledTriggerButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1qpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7VqEq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f04ee46c66a4b22$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4f04ee46c66a4b22$var$messages = (0, $7qGN1.defineMessages)({
    addFieldDisplayText: {
        "id": "jql-builder-basic-order-by-select.add-field-picker.add-field-display-text",
        "defaultMessage": "Select field"
    }
});
var $4f04ee46c66a4b22$export$2e2bcd8739ae039 = $4f04ee46c66a4b22$var$messages;

});


parcelRegister("9y4v7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66657688c3812d3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $ihebN = parcelRequire("ihebN");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $ixh2S = parcelRequire("ixh2S");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $cfy7S = parcelRequire("cfy7S");

var $euVK2 = parcelRequire("euVK2");

var $8YP3j = parcelRequire("8YP3j");

var $8XUsM = parcelRequire("8XUsM");

var $lFjNR = parcelRequire("lFjNR");
const $f66657688c3812d3$var$OrderByPicker = ({ field: field, fieldIndex: fieldIndex, onChange: onChange, onRemove: onRemove, onLoadOptions: onLoadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const pickerValue = (0, $eJOHy.useMemo)(()=>[
            {
                optionType: 'option',
                value: field.jqlTerm,
                label: field.displayText
            }
        ], [
        field.displayText,
        field.jqlTerm
    ]);
    const handleRemoveFieldButtonClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        e.preventDefault();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'orderBySelectRemoveFieldClick');
        onRemove(fieldIndex);
    }, [
        fieldIndex,
        onRemove
    ]);
    const handleTriggerClick = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen((currentisOpen)=>{
            const newOpenState = !currentisOpen;
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownMenu',
                actionSubjectId: 'orderBySelectFieldPicker',
                attributes: {
                    isOpen: newOpenState
                }
            });
            return newOpenState;
        });
    }, [
        createAnalyticsEvent
    ]);
    const handlePickerCloseClick = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen(false);
    }, []);
    const handleSortDirectionClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        e.preventDefault();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'orderBySelectSortDirectionClick');
        /**
     * It is expected that some order by fields in JQL dont have an explicit direction,
     * E.g. `ORDER BY project` instead of `ORDER BY project ASC`
     * In these cases if the direction is toggled, we add an explicit direction
     */ const updatedField = {
            ...field,
            direction: field.direction ? (0, $8XUsM.toggleDirection)(field.direction) : (0, $8YP3j.FALLBACK_SORT_DIRECTION)
        };
        onChange(fieldIndex, updatedField);
    }, [
        field,
        fieldIndex,
        onChange
    ]);
    const handleFieldChanged = (0, $eJOHy.useCallback)((newValue, actionMeta)=>{
        // @ts-expect-error TS inference not working with the SelectedValue type
        // despite explicit checks it always still thinks it might be an array or null
        // not sure of the root cause whether type defs in
        // jira/src/packages/jql-builder/basic-picker/src/common/types.tsx or TS issue at
        // the platform level
        if (newValue === null || Array.isArray(newValue) || !newValue.value || !newValue.label) return null;
        if (actionMeta.action === 'select-option') {
            const updatedField = {
                // @ts-expect-error see above
                displayText: newValue.label,
                // @ts-expect-error see above
                jqlTerm: newValue.value,
                direction: field.direction
            };
            onChange(fieldIndex, updatedField);
            setIsOpen(false);
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'selectOption'
            }), 'orderByFieldPicker');
        }
    }, [
        createAnalyticsEvent,
        field.direction,
        fieldIndex,
        onChange
    ]);
    const onPickerTrigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cfy7S.default), {
            triggerProps: triggerProps,
            displayText: field.displayText,
            onClick: handleTriggerClick,
            isOpen: isOpen,
            ariaLabel: formatMessage((0, $lFjNR.default).pickerLabel, {
                field: field.displayText
            }),
            shouldFitContainer: true
        }), [
        field.displayText,
        formatMessage,
        handleTriggerClick,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f66657688c3812d3$var$pickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixh2S.Picker), {
        isMulti: false,
        isOpen: isOpen,
        id: `order-by-select-field-${fieldIndex}`,
        value: pickerValue,
        onTrigger: onPickerTrigger,
        onClose: handlePickerCloseClick,
        onChange: handleFieldChanged,
        onLoadOptions: onLoadOptions,
        shouldRenderToParent: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f66657688c3812d3$var$sortButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "bottom",
        content: formatMessage((0, $lFjNR.default).sortButtonTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            ...tooltipProps,
            onClick: handleSortDirectionClick,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $euVK2.SortDirectionIcon), {
                fieldDisplayText: field.displayText,
                fieldSortDirection: field.direction
            })
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f66657688c3812d3$var$clearButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "bottom",
        content: formatMessage((0, $lFjNR.default).clearButtonTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            ...tooltipProps,
            appearance: "subtle",
            onClick: handleRemoveFieldButtonClick,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                as: "span",
                xcss: [
                    $f66657688c3812d3$var$iconButtonStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ihebN))), {
                LEGACY_size: "small",
                label: formatMessage((0, $lFjNR.default).clearButtonLabel, {
                    field: field.displayText
                })
            }))
        }))));
};
var $f66657688c3812d3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($f66657688c3812d3$var$OrderByPicker);
const $f66657688c3812d3$var$sortButtonContainerStyles = (0, $1DXK0.xcss)({
    flex: 'none',
    marginLeft: 'space.075'
});
const $f66657688c3812d3$var$clearButtonContainerStyles = (0, $1DXK0.xcss)({
    flex: 'none',
    marginLeft: 'space.150'
});
/**
 * There is a bug with the new Atlaskit IconButton where occasionally the onClick handler is not
 * triggered, when wrapped by a tooltip - https://atlassian.slack.com/archives/CFJ9DU39U/p1718597982581429
 * Instead, using a legacy button but making it appear 32px wide so that it looks like the new icon
 * button. Any narrower and it becomes an a11y issue having such a small click target
 */ const $f66657688c3812d3$var$iconButtonStyles = (0, $1DXK0.xcss)({
    display: 'inline-block',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
const $f66657688c3812d3$var$pickerContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: '1',
    minWidth: '0'
});

});
parcelRegister("euVK2", function(module, exports) {

$parcel$export(module.exports, "SortDirectionIcon", () => $32511b2a80d3d997$export$a6df6c2e349e4183);

var $eJOHy = parcelRequire("eJOHy");

var $3ZjSN = parcelRequire("3ZjSN");

var $eHAfU = parcelRequire("eHAfU");


var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $duK9d = parcelRequire("duK9d");
const $32511b2a80d3d997$export$a6df6c2e349e4183 = ({ fieldDisplayText: fieldDisplayText, fieldSortDirection: fieldSortDirection })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: [
            fieldSortDirection === (0, $adec16a85d57f51f$export$6d60017b9e092e73) ? $32511b2a80d3d997$var$iconButtonStyles : $32511b2a80d3d997$var$displayNoneStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eHAfU))), {
        LEGACY_size: "small",
        label: formatMessage((0, $duK9d.default).sortButtonLabelAsc, {
            field: fieldDisplayText
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: [
            fieldSortDirection === (0, $adec16a85d57f51f$export$2ea27ea5f2121899) ? $32511b2a80d3d997$var$iconButtonStyles : $32511b2a80d3d997$var$displayNoneStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ZjSN))), {
        LEGACY_size: "small",
        label: formatMessage((0, $duK9d.default).sortButtonLabelDesc, {
            field: fieldDisplayText
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: [
            fieldSortDirection === undefined ? $32511b2a80d3d997$var$iconButtonStyles : $32511b2a80d3d997$var$displayNoneStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ZjSN))), {
        LEGACY_size: "small",
        label: formatMessage((0, $duK9d.default).sortButtonWithDefaultAscDirectionLabel, {
            field: fieldDisplayText
        })
    })));
};
/**
 * There is a bug with the new Atlaskit IconButton where occasionally the onClick handler is not
 * triggered, when wrapped by a tooltip - https://atlassian.slack.com/archives/CFJ9DU39U/p1718597982581429
 * Instead, using a legacy button but making it appear 32px wide so that it looks like the new icon
 * button. Any narrower and it becomes an a11y issue having such a small click target
 */ const $32511b2a80d3d997$var$iconButtonStyles = (0, $1DXK0.xcss)({
    display: 'inline-block',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
/**
 * Used to hide the icon that is not currently mapped to the fieldSortDirection using CSS instead of
 * React.
 *
 * For example:
 * If the fieldSortDirection is ASC, the <ArrowDown> will receive this style and be hidden.
 *
 * using CSS to show the correct icon keeps both icons in the DOM whereas conditionally rendering
 * based on `fieldSortDirection` will remove the unrelated icon from the DOM completely, on click.

 * This removal from the DOM interferes with onClick management in popper:
 * jira/platform/packages/design-system/popup/src/use-close-manager.tsx
 *
 * In the above file, if an element has gone missing from the DOM, the onClose functionality will
 * return early and leave any open pickers still open. Instead I want any open pickers to close if the
 * user clicks on a button elsewhere on the page (such as clicking on this icon when it is in a button)
 */ const $32511b2a80d3d997$var$displayNoneStyle = (0, $1DXK0.xcss)({
    display: 'none'
});

});
parcelRegister("3ZjSN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c41b8a7a2a0e885f53178dceb7a8d3e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e767de815953df7$var$_react = $2e767de815953df7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2e767de815953df7$var$_arrowDown = $2e767de815953df7$var$_interopRequireDefault((parcelRequire("8Gywp")));

var $2e767de815953df7$var$_arrowDown2 = $2e767de815953df7$var$_interopRequireDefault((parcelRequire("56U2f")));
function $2e767de815953df7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowDownIcon.
 * This component is ArrowDownIcon, with `UNSAFE_fallbackIcon` set to "ArrowDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e767de815953df7$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $2e767de815953df7$var$_react.default.createElement($2e767de815953df7$var$_arrowDown.default, Object.assign({
        LEGACY_fallbackIcon: $2e767de815953df7$var$_arrowDown2.default
    }, props));
$2e767de815953df7$var$ArrowDownIcon.Name = 'ArrowDownIconMigration';
var $2e767de815953df7$var$_default = module.exports.default = $2e767de815953df7$var$ArrowDownIcon;

});
parcelRegister("8Gywp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652d0645e24346a6$var$_react = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $652d0645e24346a6$var$_baseNew = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $652d0645e24346a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $652d0645e24346a6$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $652d0645e24346a6$var$_react.default.createElement($652d0645e24346a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$652d0645e24346a6$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $652d0645e24346a6$var$_default = module.exports.default = $652d0645e24346a6$var$ArrowDownIcon;

});

parcelRegister("56U2f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b88fabfb9049421$var$_react = $3b88fabfb9049421$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $3b88fabfb9049421$var$_arrowDown = $3b88fabfb9049421$var$_interopRequireDefault((parcelRequire("8Gywp")));
function $3b88fabfb9049421$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3b88fabfb9049421$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $3b88fabfb9049421$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props, {
        newIcon: $3b88fabfb9049421$var$_arrowDown.default
    }));
$3b88fabfb9049421$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $3b88fabfb9049421$var$_default = module.exports.default = $3b88fabfb9049421$var$ArrowDownIcon;

});


parcelRegister("eHAfU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ae9adc1e99d7e27810a205cdfaded7b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab41346fe023c175$var$_react = $ab41346fe023c175$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ab41346fe023c175$var$_arrowUp = $ab41346fe023c175$var$_interopRequireDefault((parcelRequire("aDbql")));

var $ab41346fe023c175$var$_arrowUp2 = $ab41346fe023c175$var$_interopRequireDefault((parcelRequire("iK3VB")));
function $ab41346fe023c175$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpIcon.
 * This component is ArrowUpIcon, with `UNSAFE_fallbackIcon` set to "ArrowUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab41346fe023c175$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $ab41346fe023c175$var$_react.default.createElement($ab41346fe023c175$var$_arrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $ab41346fe023c175$var$_arrowUp2.default
    }, props));
$ab41346fe023c175$var$ArrowUpIcon.Name = 'ArrowUpIconMigration';
var $ab41346fe023c175$var$_default = module.exports.default = $ab41346fe023c175$var$ArrowUpIcon;

});
parcelRegister("aDbql", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bd6687a611ada9e$var$_react = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7bd6687a611ada9e$var$_baseNew = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7bd6687a611ada9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bd6687a611ada9e$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $7bd6687a611ada9e$var$_react.default.createElement($7bd6687a611ada9e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$7bd6687a611ada9e$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $7bd6687a611ada9e$var$_default = module.exports.default = $7bd6687a611ada9e$var$ArrowUpIcon;

});

parcelRegister("iK3VB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da4f91e16fa5e625$var$_react = $da4f91e16fa5e625$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $da4f91e16fa5e625$var$_arrowUp = $da4f91e16fa5e625$var$_interopRequireDefault((parcelRequire("aDbql")));
function $da4f91e16fa5e625$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $da4f91e16fa5e625$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $da4f91e16fa5e625$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $da4f91e16fa5e625$var$_arrowUp.default
    }));
$da4f91e16fa5e625$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $da4f91e16fa5e625$var$_default = module.exports.default = $da4f91e16fa5e625$var$ArrowUpIcon;

});


parcelRegister("duK9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8a9935928166541$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f8a9935928166541$var$messages = (0, $7qGN1.defineMessages)({
    sortButtonLabelAsc: {
        "id": "jql-builder-basic-order-by-select.common.sort-direction-icon.sort-button-label-asc",
        "defaultMessage": "{field} ordered by ascending. Reverse order"
    },
    sortButtonLabelDesc: {
        "id": "jql-builder-basic-order-by-select.common.sort-direction-icon.sort-button-label-desc",
        "defaultMessage": "{field} ordered by descending. Reverse order"
    },
    sortButtonWithDefaultAscDirectionLabel: {
        "id": "jql-builder-basic-order-by-select.common.sort-direction-icon.sort-button-with-default-asc-direction-label",
        "defaultMessage": "{field} does not have a sort direction. Set the direction to ascending"
    }
});
var $f8a9935928166541$export$2e2bcd8739ae039 = $f8a9935928166541$var$messages;

});


parcelRegister("8YP3j", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_SORT_DIRECTION", () => $05b45ef94ee30373$export$252fa5d135c32113);

const $05b45ef94ee30373$export$252fa5d135c32113 = (0, $adec16a85d57f51f$export$6d60017b9e092e73);

});

parcelRegister("8XUsM", function(module, exports) {

$parcel$export(module.exports, "toggleDirection", () => $ae48da4b32a67b00$export$1af131c8fc2061e9);

const $ae48da4b32a67b00$export$1af131c8fc2061e9 = (previousDirection)=>previousDirection === (0, $adec16a85d57f51f$export$6d60017b9e092e73) ? (0, $adec16a85d57f51f$export$2ea27ea5f2121899) : (0, $adec16a85d57f51f$export$6d60017b9e092e73);

});

parcelRegister("lFjNR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b969e901663be05$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8b969e901663be05$var$messages = (0, $7qGN1.defineMessages)({
    sortButtonTooltip: {
        "id": "jql-builder-basic-order-by-select.order-by-field-picker.sort-button-tooltip",
        "defaultMessage": "Reverse order direction"
    },
    clearButtonTooltip: {
        "id": "jql-builder-basic-order-by-select.order-by-field-picker.clear-button-tooltip",
        "defaultMessage": "Remove field"
    },
    clearButtonLabel: {
        "id": "jql-builder-basic-order-by-select.order-by-field-picker.clear-button-label",
        "defaultMessage": "Remove {field}"
    },
    pickerLabel: {
        "id": "jql-builder-basic-order-by-select.order-by-field-picker.picker-label",
        "defaultMessage": "{field} selected"
    }
});
var $8b969e901663be05$export$2e2bcd8739ae039 = $8b969e901663be05$var$messages;

});



parcelRegister("ixIfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2721563b9887dcd7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $fAfwV = parcelRequire("fAfwV");
const $2721563b9887dcd7$var$FooterButton = ({ onClear: onClear })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleClick = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'orderByClearSelectedItems', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onClear && onClear();
    }, [
        onClear
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $2721563b9887dcd7$var$footerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $2721563b9887dcd7$var$buttonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        onClick: handleClick
    }, formatMessage((0, $fAfwV.default).buttonText))));
};
var $2721563b9887dcd7$export$2e2bcd8739ae039 = $2721563b9887dcd7$var$FooterButton;
const $2721563b9887dcd7$var$footerStyle = (0, $1DXK0.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    justifyContent: 'start',
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $2721563b9887dcd7$var$buttonStyle = (0, $1DXK0.xcss)({
    padding: 'space.050',
    alignSelf: 'center',
    // left padding + left margin should total to 12px to match other picker types.
    marginInlineStart: 'space.100'
});

});
parcelRegister("fAfwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3233e82309e890a0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3233e82309e890a0$var$messages = (0, $7qGN1.defineMessages)({
    buttonText: {
        "id": "jql-builder-basic.jql-editor.order-by-picker.footer.button-text",
        "defaultMessage": "Clear selection"
    }
});
var $3233e82309e890a0$export$2e2bcd8739ae039 = $3233e82309e890a0$var$messages;

});


parcelRegister("aBVhI", function(module, exports) {

$parcel$export(module.exports, "compareSortFields", () => $20a7cee1b2f4a4d0$export$d1fbc8ef95bdef46);
$parcel$export(module.exports, "getNextSelectedOrderByFields", () => $20a7cee1b2f4a4d0$export$d06db05a248b8bec);
$parcel$export(module.exports, "printJast", () => $20a7cee1b2f4a4d0$export$bfda6e07879dd093);

var $1jiqw = parcelRequire("1jiqw");

var $idYtD = parcelRequire("idYtD");
const $20a7cee1b2f4a4d0$export$d1fbc8ef95bdef46 = (sortFields1, sortFields2)=>{
    if (sortFields1.length !== sortFields2.length) return false;
    return sortFields1.every((sortField, index)=>sortField.jqlTerm === sortFields2[index].jqlTerm && sortField.direction === sortFields2[index].direction);
};
const $20a7cee1b2f4a4d0$var$getHydrationDisplayNameMap = (hydrationData)=>{
    const hydrationMap = new Map();
    (hydrationData?.jira?.jqlBuilder?.hydrateJqlQuery ?? hydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.map((field)=>field.field && field.jqlTerm && hydrationMap.set(field.jqlTerm.toLowerCase(), field.field.displayName ?? ''));
    return hydrationMap;
};
const $20a7cee1b2f4a4d0$export$d06db05a248b8bec = ({ ast: ast, hydrationData: hydrationData, selectedOrderByFields: selectedOrderByFields })=>{
    const astSortFields = (0, $idYtD.getAstSortFields)(ast);
    const hydrationDisplayNameMap = $20a7cee1b2f4a4d0$var$getHydrationDisplayNameMap(hydrationData);
    const nextSelectedOrderByFields = astSortFields.map((astSortField)=>{
        let displayText;
        const hydratedDisplayName = hydrationDisplayNameMap.get(astSortField.jqlTerm.toLowerCase());
        const existingField = selectedOrderByFields.find((selectedOrderByField)=>selectedOrderByField.jqlTerm === astSortField.jqlTerm);
        if (hydratedDisplayName !== undefined) displayText = hydratedDisplayName;
        else displayText = existingField?.displayText ?? '';
        const selectedOrderByField = {
            displayText: displayText,
            jqlTerm: astSortField.jqlTerm,
            direction: astSortField.direction
        };
        return selectedOrderByField;
    });
    return nextSelectedOrderByFields;
};
const $20a7cee1b2f4a4d0$export$bfda6e07879dd093 = (jast)=>(0, $1jiqw.print)(jast, {
        operatorCase: 'upper'
    });

});


parcelRegister("hC1P1", function(module, exports) {

$parcel$export(module.exports, "AsyncRegisterSearchCriteriaToShortcutsDialog", () => $639f0e4e8d1708f4$export$f2345c1eb3a17e65);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $bHRpp = parcelRequire("bHRpp");

var $bQWwW = parcelRequire("bQWwW");
var $fathc = parcelRequire("fathc");

var $lzg2Z = parcelRequire("lzg2Z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $639f0e4e8d1708f4$var$RegisterSearchCriteriaToShortcutsDialog = (0, $bQWwW.lazy)(()=>(parcelRequire("jjnBd")), {
    moduleId: "./src/packages/jql-builder/basic/src/ui/jql-editor/register-search-criteria-to-shortcuts-dialog/index.tsx"
});
const $639f0e4e8d1708f4$export$f2345c1eb3a17e65 = (props)=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }] = (0, $bHRpp.useShortcuts)();
    const { isShortcutsDialogIntegrationAvailable: isShortcutsDialogIntegrationAvailable } = (0, $lzg2Z.useIntegrateDotDialogContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue-navigatior-search-criteria-shortcuts-dialog",
        packageName: "jql-builder-basic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fathc.LazyWait), {
        until: isShortcutsDialogIntegrationAvailable && isShortcutsDialogVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-register-shortcut-dialog-actions",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($639f0e4e8d1708f4$var$RegisterSearchCriteriaToShortcutsDialog, props))));
};

});
parcelRegister("bHRpp", function(module, exports) {

$parcel$export(module.exports, "useShortcuts", () => $5ec870659f2b42dd$export$a1ca853c6e4bb6fb);
$parcel$export(module.exports, "useShortcutsActions", () => $5ec870659f2b42dd$export$b331ee6e87b9104c);

var $fgHZ8 = parcelRequire("fgHZ8");
const $5ec870659f2b42dd$export$a1ca853c6e4bb6fb = ()=>(0, $fgHZ8.useShortcutsStore)();
const $5ec870659f2b42dd$export$b331ee6e87b9104c = ()=>{
    const [, actions] = (0, $fgHZ8.useShortcutsActionsStore)();
    return [
        undefined,
        actions
    ];
};

});
parcelRegister("fgHZ8", function(module, exports) {

$parcel$export(module.exports, "useShortcutsStore", () => $1037d55a513c4cd3$export$a14646bfc7ba8d81);
$parcel$export(module.exports, "useShortcutsActionsStore", () => $1037d55a513c4cd3$export$1a29bfef7fa09838);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9rMca = parcelRequire("9rMca");
const $1037d55a513c4cd3$export$d4c72bab9d6cc13a = {
    shortcuts: {
        admin: {
            key: 'admin',
            label: 'ADMIN',
            options: [],
            isLoaded: false
        }
    },
    isShortcutsDialogVisible: false,
    isShortcutsLoading: false,
    hasError: false,
    isAdminLoading: false,
    selectedItemKey: null,
    header: null,
    title: undefined
};
const $1037d55a513c4cd3$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'shortcuts',
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly shortcuts: { readonly admin: { readonly key: "admin"; readonly label: "ADMIN"; readonly options: readonly []; readonly isLoaded: false; }; }; readonly isShortcutsDialogVisible: false; readonly isShortcutsLoading: false; ... 4 more ...; readonly title: undefined; }' is not assignable to type 'State'.
    $1037d55a513c4cd3$export$d4c72bab9d6cc13a,
    actions: $9rMca
});
const $1037d55a513c4cd3$export$a14646bfc7ba8d81 = (0, $iJq0l.createHook)($1037d55a513c4cd3$export$6f57813fe9f31bf9);
const $1037d55a513c4cd3$export$1a29bfef7fa09838 = (0, $iJq0l.createHook)($1037d55a513c4cd3$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("9rMca", function(module, exports) {

$parcel$export(module.exports, "registerShortcuts", () => $bd65986ef711b2b7$export$598ec0e6047cbdca);
$parcel$export(module.exports, "setShortcutsDialogVisibility", () => $bd65986ef711b2b7$export$80ab1e79e32c3021);
$parcel$export(module.exports, "setShortcutsLoading", () => $bd65986ef711b2b7$export$7ed2ac8328423043);
$parcel$export(module.exports, "setHasError", () => $bd65986ef711b2b7$export$645a7c7453685186);
$parcel$export(module.exports, "setHeader", () => $bd65986ef711b2b7$export$604ed74fb893f0e2);
$parcel$export(module.exports, "fetchAdminSections", () => $bd65986ef711b2b7$export$aec87c8c9bde62e6);
$parcel$export(module.exports, "setSelectedItemKey", () => $bd65986ef711b2b7$export$249c9d5b49cd9712);
$parcel$export(module.exports, "dropShortcutsByKeys", () => $bd65986ef711b2b7$export$9cf39adf0dec984);

var $2zs80 = parcelRequire("2zs80");

var $9FV9P = parcelRequire("9FV9P");

var $2TCxE = parcelRequire("2TCxE");
const $bd65986ef711b2b7$export$598ec0e6047cbdca = (shortcuts)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newShortcuts = shortcuts.reduce((acc, current)=>{
            acc[current.key] = current;
            return acc;
        }, {
            ...currentState.shortcuts
        });
        setState({
            ...currentState,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };
const $bd65986ef711b2b7$export$80ab1e79e32c3021 = (isVisible)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsDialogVisible: isVisible
        });
    };
const $bd65986ef711b2b7$export$7ed2ac8328423043 = (isLoading)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsLoading: isLoading
        });
    };
const $bd65986ef711b2b7$export$645a7c7453685186 = (hasError)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            hasError: hasError
        });
    };
const $bd65986ef711b2b7$export$604ed74fb893f0e2 = (header, title)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            header: header,
            title: title
        });
    };
const $bd65986ef711b2b7$export$aec87c8c9bde62e6 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isAdminLoading: true
        });
        const result = await (0, $9FV9P.default)();
        const shortcuts = result ? (0, $2TCxE.buildAdminSections)(result) : [];
        const newState = getState();
        setState({
            ...newState,
            shortcuts: {
                ...newState.shortcuts,
                admin: {
                    ...newState.shortcuts.admin,
                    key: 'admin',
                    options: shortcuts,
                    isLoaded: true
                }
            },
            hasError: currentState.hasError || !result,
            isAdminLoading: false
        });
    };
const $bd65986ef711b2b7$export$249c9d5b49cd9712 = (item)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            selectedItemKey: item
        });
    };
const $bd65986ef711b2b7$export$9cf39adf0dec984 = (keys)=>({ getState: getState, setState: setState })=>{
        if (!keys.length) return;
        const { shortcuts: shortcuts, ...rest } = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newShortcuts = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(Object.keys(shortcuts), keys).reduce((acc, key)=>{
            acc[key] = shortcuts[key];
            return acc;
        }, {});
        setState({
            ...rest,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };

});
parcelRegister("9FV9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9cd1634918b3cd3$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e9cd1634918b3cd3$export$2e2bcd8739ae039 = async ()=>{
    try {
        return await (0, $1Ozm9.default)('/rest/adminquicksearch/latest/links/default');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('shortcuts-dialog.fetch-admin-links', error.toString());
        return null;
    }
};

});

parcelRegister("2TCxE", function(module, exports) {

$parcel$export(module.exports, "buildAdminSections", () => $8b2ef73b57082485$export$5f8c94ecd4c9eb76);
const $8b2ef73b57082485$export$5f8c94ecd4c9eb76 = (parent, result = [])=>{
    if (parent.sections && parent.sections.length) parent.sections.forEach((s)=>$8b2ef73b57082485$export$5f8c94ecd4c9eb76(s, result));
    if (parent.items && parent.items.length) parent.items.forEach((i)=>result.push({
            key: i.key,
            label: i.label,
            // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(event?: Event | undefined) => Promise<undefined> | undefined'.
            onClick: ()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location.href = i.linkUrl;
            }
        }));
    return result;
};

});




parcelRegister("jjnBd", function(module, exports) {

let $e0f218fde0c3284e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e0f218fde0c3284e$var$load("74YvS").then(()=>parcelRequire('aAqp7'));

});


parcelRegister("8mM4q", function(module, exports) {

$parcel$export(module.exports, "TextSearchInput", () => $7f77d35c0ab62119$export$451fab4acd1fe94e);

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $gRw8I = parcelRequire("gRw8I");

var $DtmfJ = parcelRequire("DtmfJ");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $1Zcfy = parcelRequire("1Zcfy");

var $ii7Oz = parcelRequire("ii7Oz");

var $itdlt = parcelRequire("itdlt");

var $ezGpi = parcelRequire("ezGpi");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $izTXQ = parcelRequire("izTXQ");

var $bNtSK = parcelRequire("bNtSK");

var $1gVNb = parcelRequire("1gVNb");

var $5jGSj = parcelRequire("5jGSj");

var $lyPdT = parcelRequire("lyPdT");

var $b06aK = parcelRequire("b06aK");

var $h9gPh = parcelRequire("h9gPh");
const $7f77d35c0ab62119$export$451fab4acd1fe94e = ({ onSearchWrapper: onSearchWrapper, onJourneyStart: onJourneyStart, shouldUseListMarkup: shouldUseListMarkup, placeholder: placeholder })=>{
    (0, $gRw8I.di)(requestAnimationFrame);
    const intl = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    const [textSearchInputClause] = (0, $lyPdT.useTextSearchInputClause)();
    const sendOptionAnalytics = (0, $h9gPh.useSendOptionAnalytics)();
    const textSearchInputRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const value = (0, $eJOHy.useMemo)(()=>(0, $b06aK.default).value(textSearchInputClause) || '', [
        textSearchInputClause
    ]);
    const focusTextSearchInput = (0, $eJOHy.useCallback)(()=>{
        // This prevents the shortcut from being fed into the input
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(textSearchInputRef) && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(textSearchInputRef.current)) {
            // This is the same way the global search input prevents
            // the shortcut from being fed into the input
            // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
            requestAnimationFrame(()=>{
                textSearchInputRef.current?.focus();
            });
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'pressed',
                actionSubject: 'keyboardShortcut'
            }), 'jqlEditorBasicSearchInputKeyboardShortcut', {
                keyPressed: 'f',
                keyboardShortcut: true
            });
        }
    }, [
        createAnalyticsEvent
    ]);
    const onTextFocus = (0, $eJOHy.useCallback)(()=>{
        if (!onJourneyStart) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: 'input'
        });
        const attributes = onJourneyStart();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'refinementBarSearchInput', attributes);
    }, [
        createAnalyticsEvent,
        onJourneyStart
    ]);
    const { getKeywords: getKeywords } = (0, $itdlt.useCommandKeywords)();
    const StyledListItemChildComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $bNtSK.default) : (0, $1gVNb.StyledListItemChild);
    const FieldWrapper = shouldUseListMarkup ? StyledListItemChildComponent : (0, $1gVNb.StyledChild);
    const commandShortcuts = (0, $fAZgY.useMemoWithCondition)(()=>({
            f: {
                callback: focusTextSearchInput,
                registerInCommandPalette: {
                    id: 'jql-builder-basic-jql-editor-text-picker-wrapper-focus-search-input',
                    name: intl.formatMessage((0, $izTXQ.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))), {
                                label: intl.formatMessage((0, $izTXQ.default).searchCurrentPage),
                                color: "var(--ds-icon, #44546F)"
                            })
                    },
                    priority: (0, $ii7Oz.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickActions,
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        }), [
        focusTextSearchInput,
        getKeywords,
        intl
    ], ()=>(0, $7jTnu.fg)('jfp_magma_jsm-perf-improvement-batch-1'));
    const onChange = (0, $fAZgY.useCallbackWithCondition)((keyword)=>{
        onSearchWrapper && onSearchWrapper((0, $b06aK.default).update(ast, textSearchInputClause, keyword));
    }, [
        ast,
        onSearchWrapper,
        textSearchInputClause
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ezGpi.CommandShortcuts), {
        keyMap: commandShortcuts
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5jGSj.default), {
        label: placeholder !== undefined && (0, $6XJko.isVisualRefreshEnabled)() ? placeholder : intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $izTXQ.default).refinementSearchIssueTermRefresh : (0, $izTXQ.default).refinementSearch),
        value: value,
        onChange: onChange,
        onFocus: onJourneyStart ? onTextFocus : undefined,
        onSendOptionAnalytics: sendOptionAnalytics,
        inputRef: textSearchInputRef
    }));
};

});
parcelRegister("DtmfJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $076a6a80fa08401a$var$_react = $076a6a80fa08401a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $076a6a80fa08401a$var$_baseNew = $076a6a80fa08401a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $076a6a80fa08401a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $076a6a80fa08401a$var$PageIcon = (props)=>/*#__PURE__*/ $076a6a80fa08401a$var$_react.default.createElement($076a6a80fa08401a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$076a6a80fa08401a$var$PageIcon.displayName = 'PageIcon';
var $076a6a80fa08401a$var$_default = module.exports.default = $076a6a80fa08401a$var$PageIcon;

});

parcelRegister("ezGpi", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $1e305c509eaf0223$export$7ff7e4fe85a5960a);

var $eJOHy = parcelRequire("eJOHy");

var $fWwfy = parcelRequire("fWwfy");

var $73jrx = parcelRequire("73jrx");

var $hf4h9 = parcelRequire("hf4h9");

var $3IF6p = parcelRequire("3IF6p");
const $1e305c509eaf0223$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $eJOHy.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $hf4h9.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $hf4h9.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $eJOHy.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IF6p.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $73jrx.RegisterCommands), {
        registrationId: (0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("73jrx", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $54ccbd2a3c61da6a$export$cd555833c78729f1);

var $eJOHy = parcelRequire("eJOHy");

var $3DnU9 = parcelRequire("3DnU9");
const $54ccbd2a3c61da6a$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3DnU9.RegisterCommandsWithRegistry), props);

});
parcelRegister("3DnU9", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $c82e68fcec934ed3$export$b8955a01360d2876);

var $cQKVu = parcelRequire("cQKVu");
function $c82e68fcec934ed3$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $cQKVu.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});




parcelRegister("4lOXU", function(module, exports) {

$parcel$export(module.exports, "useFieldsToRender", () => $066f028a7c522302$export$4b20ffbea08469cb);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $fvO8D = parcelRequire("fvO8D");

var $hoXMy = parcelRequire("hoXMy");

var $6vt5P = parcelRequire("6vt5P");

var $byNye = parcelRequire("byNye");
const $066f028a7c522302$export$4b20ffbea08469cb = ({ query: query, loading: loading, fieldsHydrationData: fieldsHydrationData, excludedFields: excludedFields, irremovableFields: irremovableFields })=>{
    const intl = (0, $lRq8t.default)();
    const comparator = (0, $byNye.useLocaleCompare)();
    const [{ astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId }] = (0, $fvO8D.useSearchState)();
    const [internalState, setInternalState] = (0, $eJOHy.useReducer)((oldState, newState)=>({
            ...oldState,
            ...newState
        }), {
        internalJql: query,
        fieldsToRender: [],
        selectedFields: [],
        optionalFieldsCount: 0,
        showLoadingState: loading
    }, (initialState)=>{
        const { internalJql: internalJql, showLoadingState: showLoadingState } = initialState;
        const { fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount } = (0, $hoXMy.gatherFields)({
            selectedFields: [],
            excludedFields: excludedFields,
            intl: intl,
            fieldsHydratedData: fieldsHydrationData,
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        });
        const selectedFields = (0, $6vt5P.getSelectedFields)({
            fieldsToRender: fieldsToRender,
            intl: intl,
            comparator: comparator,
            irremovableFields: irremovableFields
        });
        return {
            internalJql: internalJql,
            fieldsToRender: fieldsToRender,
            selectedFields: selectedFields,
            optionalFieldsCount: optionalFieldsCount,
            showLoadingState: showLoadingState
        };
    });
    (0, $eJOHy.useEffect)(()=>{
        const { fieldsToRender: fieldsToRender, selectedFields: selectedFields, internalJql: internalJql } = internalState;
        const isExternalChange = internalJql !== query;
        const { fieldsToRender: newFieldsToRender, optionalFieldsCount: optionalFieldsCount, missingHydration: missingHydration } = (0, $hoXMy.gatherFields)({
            selectedFields: isExternalChange ? [] : selectedFields,
            excludedFields: excludedFields,
            intl: intl,
            fieldsHydratedData: fieldsHydrationData,
            previousFieldToRender: !isExternalChange ? fieldsToRender : [],
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        });
        const newSelectedFields = (0, $6vt5P.getSelectedFields)({
            fieldsToRender: newFieldsToRender,
            intl: intl,
            comparator: comparator,
            irremovableFields: irremovableFields
        });
        setInternalState({
            showLoadingState: missingHydration,
            fieldsToRender: newFieldsToRender,
            selectedFields: newSelectedFields,
            optionalFieldsCount: optionalFieldsCount,
            ...isExternalChange ? {
                internalJql: query
            } : {}
        });
    }, // When the query changes, we want to ensure fieldsToRender and selectedFields display as desired.
    // To prevent extraneous calls to useEffect, we leave out all dependencies besides query and fieldsHydrationData.
    // Where required, selectedFields state will be updated before query is.
    // We also assume that ast only changes when query also does.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        query,
        fieldsHydrationData
    ]);
    return {
        internalState: internalState,
        setInternalState: setInternalState
    };
};

});
parcelRegister("6vt5P", function(module, exports) {

$parcel$export(module.exports, "getSelectedFields", () => $cb1289546e9da883$export$3edef1dcbe28a0c6);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $epTsa = parcelRequire("epTsa");

var $cjRWP = parcelRequire("cjRWP");

var $fexQV = parcelRequire("fexQV");

var $dTJxm = parcelRequire("dTJxm");

var $kWaBc = parcelRequire("kWaBc");
const $cb1289546e9da883$export$3edef1dcbe28a0c6 = ({ fieldsToRender: fieldsToRender, comparator: comparator, intl: intl, irremovableFields: irremovableFields })=>fieldsToRender.filter(({ fieldId: fieldId })=>// should not be an irremovable field
        !irremovableFields.has(fieldId)).sort((a, b)=>comparator(a.fieldLabel || '', b.fieldLabel || '')).map(({ fieldId: fieldId, fieldLabel: fieldLabel, fieldDescription: fieldDescription, picker: picker, fieldTypeDisplayName: fieldTypeDisplayName, shouldShowInContext: shouldShowInContext })=>{
        const notInContextFieldMessageIssueTermRefreshGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $kWaBc.default).notInContextFieldMessageIssueTermRefreshGalaxia : (0, $kWaBc.default).notInContextFieldMessageIssueTermRefresh;
        const isDisabled = picker.searchTemplate === (0, $dTJxm.EPIC_LINK).searchTemplate;
        let isOnlyUnselectable = false;
        let disabledMessage = isDisabled ? intl.formatMessage((0, $kWaBc.default).deprecatedEpicMessage, {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    as: "strong",
                    color: "inherit",
                    size: "UNSAFE_small"
                }, chunks)
        }) : undefined;
        if (shouldShowInContext === false) {
            isOnlyUnselectable = true;
            disabledMessage = intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? notInContextFieldMessageIssueTermRefreshGalaxia : (0, $kWaBc.default).notInContextFieldMessage);
        }
        if (isDisabled) {
            isOnlyUnselectable = true;
            disabledMessage = intl.formatMessage((0, $kWaBc.default).deprecatedEpicMessage, {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                        as: "strong",
                        color: "inherit",
                        size: "UNSAFE_small"
                    }, chunks)
            });
        }
        const icon = picker.fieldType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fexQV.FieldTypeIcon), {
            type: picker.fieldType,
            size: "small"
        }) : undefined;
        const fieldOption = {
            optionType: 'field',
            label: fieldLabel || '',
            value: fieldId,
            isOnlyUnselectable: isOnlyUnselectable,
            disabledMessage: disabledMessage,
            searchTemplate: picker.searchTemplate,
            fieldType: picker.fieldType,
            secondaryLabel: fieldTypeDisplayName && icon ? (0, $cjRWP.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
            fieldTypeDisplayName: fieldTypeDisplayName,
            fieldDescription: fieldDescription,
            operators: picker.allowedOperators?.map((operator)=>operator.value)
        };
        return fieldOption;
    });

});
parcelRegister("kWaBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e25bd07c78b362c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4e25bd07c78b362c$var$messages = (0, $7qGN1.defineMessages)({
    deprecatedEpicMessage: {
        "id": "jql-builder-basic.utils.deprecated-epic-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    notInContextFieldMessage: {
        "id": "jql-builder-basic.utils.not-in-context-field-message",
        "defaultMessage": "This field is unavailable for the selected project and/or issue type."
    },
    notInContextFieldMessageIssueTermRefresh: {
        "id": "jql-builder-basic.utils.not-in-context-field-message-issue-term-refresh",
        "defaultMessage": "This field is unavailable for the selected project and/or work type."
    },
    notInContextFieldMessageIssueTermRefreshGalaxia: {
        "id": "jql-builder-basic.utils.not-in-context-field-message-issue-term-refresh-galaxia",
        "defaultMessage": "This field is unavailable for the selected space and/or work type."
    }
});
var $4e25bd07c78b362c$export$2e2bcd8739ae039 = $4e25bd07c78b362c$var$messages;

});


parcelRegister("byNye", function(module, exports) {

$parcel$export(module.exports, "useLocaleCompare", () => $2fa6f9970e06d7dd$export$b0592aef48e26713);

var $eJOHy = parcelRequire("eJOHy");

var $4qiFT = parcelRequire("4qiFT");

var $lvKO5 = parcelRequire("lvKO5");
const $2fa6f9970e06d7dd$export$b0592aef48e26713 = ()=>{
    const { locale: locale } = (0, $lvKO5.useTenantContext)();
    return (0, $eJOHy.useMemo)(()=>{
        const collator = new Intl.Collator((0, $4qiFT.standardizeLocale)(locale), {
            sensitivity: 'base'
        });
        return collator.compare;
    }, [
        locale
    ]);
};

});




parcelRegister("6bDCV", function(module, exports) {

$parcel$export(module.exports, "AdvancedEditorWrapper", () => $df780609925fddc7$export$500c96524dd0cfc7);
$parcel$export(module.exports, "BeforeJqlBuilderContainer", () => $df780609925fddc7$export$c139d55dec6a3c8a);
$parcel$export(module.exports, "BeforeJqlBuilderListItemContainer", () => $df780609925fddc7$export$4245b33623eb8df4);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");
const $df780609925fddc7$export$500c96524dd0cfc7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            $df780609925fddc7$var$negativeMarginOffsetStyles,
            $df780609925fddc7$var$advancedEditorWrapperStyles
        ]
    }, children);
const $df780609925fddc7$export$c139d55dec6a3c8a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $df780609925fddc7$var$negativeMarginOffsetStyles
    }, children);
const $df780609925fddc7$export$4245b33623eb8df4 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: [
            $df780609925fddc7$var$negativeMarginOffsetStyles,
            (0, $6XJko.isVisualRefreshEnabled)() ? $df780609925fddc7$var$beforeJqlBuilderListItemContainer : $df780609925fddc7$var$beforeJqlBuilderListItemContainerOld
        ]
    }, children);
const $df780609925fddc7$var$negativeMarginOffsetStyles = (0, $1DXK0.xcss)({
    marginBlock: 'space.050',
    marginLeft: 'space.0',
    marginRight: 'space.100'
});
const $df780609925fddc7$var$advancedEditorWrapperStyles = (0, $1DXK0.xcss)({
    flexGrow: 1
});
const $df780609925fddc7$var$beforeJqlBuilderListItemContainerOld = (0, $1DXK0.xcss)({
    listStyle: 'none',
    marginRight: 'space.050'
});
const $df780609925fddc7$var$beforeJqlBuilderListItemContainer = (0, $1DXK0.xcss)({
    listStyle: 'none',
    marginRight: 'space.050',
    marginLeft: 'space.050'
});

});

parcelRegister("9HnR3", function(module, exports) {

$parcel$export(module.exports, "SearchModeSwitcher", () => $a5ba1ce0559205da$export$639730063e548c7);
$parcel$export(module.exports, "SearchModeSwitcherWithTarget", () => $a5ba1ce0559205da$export$ed9a97307608e2d9);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $lHHP1 = parcelRequire("lHHP1");

var $dQ4Ik = parcelRequire("dQ4Ik");

var $6XJko = parcelRequire("6XJko");

var $56qWy = parcelRequire("56qWy");

var $2G5xc = parcelRequire("2G5xc");
const $a5ba1ce0559205da$export$639730063e548c7 = ({ isBasicModeDisabled: isBasicModeDisabled, onUpdateSearchMode: onUpdateSearchMode, searchMode: searchMode })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const testIdPrefix = 'issue-navigator.ui.refinement-bar.search-mode-switcher.toggle-button.';
    const basicModeLabel = (0, $eJOHy.useMemo)(()=>{
        if ((0, $6XJko.isVisualRefreshEnabled)()) return isBasicModeDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage((0, $2G5xc.messages).basicModeDisabledTooltip),
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            xcss: $a5ba1ce0559205da$var$labelStyles,
            color: "inherit"
        }, formatMessage((0, $2G5xc.messages).basicMode))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "span",
            xcss: $a5ba1ce0559205da$var$labelStyles,
            color: "inherit"
        }, formatMessage((0, $2G5xc.messages).basicMode));
        return isBasicModeDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage((0, $2G5xc.messages).basicModeDisabledTooltip),
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            size: "UNSAFE_small",
            weight: "semibold",
            color: "inherit"
        }, formatMessage((0, $2G5xc.messages).basicMode))) : formatMessage((0, $2G5xc.messages).basicMode);
    }, [
        formatMessage,
        isBasicModeDisabled
    ]);
    const options = [
        {
            id: (0, $56qWy.SEARCH_MODE_BASIC),
            label: basicModeLabel,
            isDisabled: isBasicModeDisabled,
            testId: `${testIdPrefix}${(0, $56qWy.SEARCH_MODE_BASIC)}`
        },
        {
            id: (0, $56qWy.SEARCH_MODE_ADVANCED),
            label: (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                as: "span",
                xcss: $a5ba1ce0559205da$var$labelStyles,
                color: "inherit"
            }, formatMessage((0, $2G5xc.messages).advancedMode)) : formatMessage((0, $2G5xc.messages).advancedMode),
            testId: `${testIdPrefix}${(0, $56qWy.SEARCH_MODE_ADVANCED)}`
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dQ4Ik.default), {
        label: formatMessage((0, $2G5xc.messages).label),
        options: options,
        selectedOption: searchMode,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange: (value)=>onUpdateSearchMode(value)
    });
};
const $a5ba1ce0559205da$export$ed9a97307608e2d9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
        engagementId: "nin.jql-builder.searchmode-switcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a5ba1ce0559205da$export$639730063e548c7, props));
const $a5ba1ce0559205da$var$labelStyles = (0, $1DXK0.xcss)({
    font: 'font.body'
});

});
parcelRegister("lHHP1", function(module, exports) {

$parcel$export(module.exports, "NinChangeboardingContext", () => $c026bf20b22e170d$export$b349f970aff316d8);
$parcel$export(module.exports, "EnableNinChangeboardingProvider", () => $c026bf20b22e170d$export$dd1deacfc61c978a);
$parcel$export(module.exports, "NinChangeboardingTourTarget", () => $c026bf20b22e170d$export$eb95770b90ecc1f3);
$parcel$export(module.exports, "NinChangeboardingTourCard", () => $c026bf20b22e170d$export$7c27d65549066b5);
$parcel$export(module.exports, "useGlobalScopeOptInFlag", () => $c026bf20b22e170d$export$9e9f507adee88e58);

var $eJOHy = parcelRequire("eJOHy");

var $epTsa = parcelRequire("epTsa");

var $bILK0 = parcelRequire("bILK0");

var $ecCxV = parcelRequire("ecCxV");

var $4elgJ = parcelRequire("4elgJ");

var $7jTnu = parcelRequire("7jTnu");

var $9ncIL = parcelRequire("9ncIL");

var $5Rrlj = parcelRequire("5Rrlj");

var $hqX3Z = parcelRequire("hqX3Z");

var $5gIAR = parcelRequire("5gIAR");
const $c026bf20b22e170d$var$sessionStorageProvider = (0, $4elgJ.createSessionStorageProvider)('', false);
const $c026bf20b22e170d$export$b349f970aff316d8 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $c026bf20b22e170d$export$dd1deacfc61c978a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c026bf20b22e170d$export$b349f970aff316d8.Provider, {
        value: true
    }, children);
const $c026bf20b22e170d$export$eb95770b90ecc1f3 = ({ children: children, engagementId: engagementId })=>{
    const isTourEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    if (!isTourEnabled) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqX3Z.default), {
        engagementId: engagementId
    }, children);
};
const $c026bf20b22e170d$export$7c27d65549066b5 = ({ mode: mode, view: view, hasIssueResults: hasIssueResults, isAiEnabled: isAiEnabled })=>{
    const isTourEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    if (!isTourEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Rrlj.AsyncSpotlightCard), {
        mode: mode,
        view: view,
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
const $c026bf20b22e170d$export$9e9f507adee88e58 = ()=>{
    const isFlagEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const onOpenInProductHelpArticle = (0, $ecCxV.useHelpPanelLink)();
    const onLearnMore = (0, $eJOHy.useCallback)(()=>{
        onOpenInProductHelpArticle((0, $9ncIL.LEARN_MORE_IPH_ARTICLE_ID));
    }, [
        onOpenInProductHelpArticle
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const shouldShowOptInFlag = (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $c026bf20b22e170d$var$sessionStorageProvider.get('showNinOptInFlag') : sessionStorage.getItem('showNinOptInFlag');
        if (isFlagEnabled && shouldShowOptInFlag === 'true') {
            showFlag({
                type: 'success',
                title: (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5gIAR.default).successOptInTitleIssueTermRefresh : (0, $5gIAR.default).successOptInTitle,
                description: (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5gIAR.default).successOptInDescIssueTermRefresh : (0, $5gIAR.default).successOptInDesc,
                messageId: 'issue-navigator-changeboarding.controllers.enable-nin-changeboarding.show-flag.success',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $5gIAR.default).successActionLearnMoreLink,
                        onClick: onLearnMore
                    }
                ],
                isAutoDismiss: false,
                testId: 'issue-navigator-changeboarding.optin-success-flag'
            });
            (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $c026bf20b22e170d$var$sessionStorageProvider.remove('showNinOptInFlag') : sessionStorage.removeItem('showNinOptInFlag');
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("9ncIL", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_SUPPORT_ARTICLE", () => $1b1bba2c09c1943d$export$ff66aa7a4971d979);
$parcel$export(module.exports, "LEARN_MORE_IPH_ARTICLE_ID", () => $1b1bba2c09c1943d$export$88d16e35389ab3c6);
$parcel$export(module.exports, "getEngagementPlatformlMessageId", () => $1b1bba2c09c1943d$export$91074f0ada4f4533);
$parcel$export(module.exports, "TOUR_MESSAGE_ID", () => $1b1bba2c09c1943d$export$4ac775bda929f47);
$parcel$export(module.exports, "views", () => $1b1bba2c09c1943d$export$d0079916fe6800ac);
const $1b1bba2c09c1943d$export$ff66aa7a4971d979 = 'https://support.atlassian.com/jira-software-cloud/docs/search-for-issues-in-jira/';
const $1b1bba2c09c1943d$export$88d16e35389ab3c6 = '3FGQv6n7fB93yWWTYqY0hq';
const $1b1bba2c09c1943d$export$91074f0ada4f4533 = (id)=>`${id}-march2024`;
const $1b1bba2c09c1943d$export$4ac775bda929f47 = 'nin-changeboarding-start';
const $1b1bba2c09c1943d$export$6c69c3d1b5f6fe55 = {
    basic: 'basic',
    advanced: 'advanced'
};
const $1b1bba2c09c1943d$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};

});

parcelRegister("5Rrlj", function(module, exports) {

$parcel$export(module.exports, "AsyncSpotlightCard", () => $09a720f6524e2b48$export$40e85aa59c198f98);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $09a720f6524e2b48$var$SpotlightCard = (0, $bQWwW.lazy)(// we want both these types of spotlights to be within the same webpack chunk
()=>(parcelRequire("g2jaq")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/common/ui/spotlight/spotlight-card/index.tsx"
});
const $09a720f6524e2b48$export$40e85aa59c198f98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-spotlight-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-spotlight-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09a720f6524e2b48$var$SpotlightCard, props)));

});
parcelRegister("g2jaq", function(module, exports) {

let $bacbb3759c5ada0a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bacbb3759c5ada0a$var$load("2ymnl").then(()=>parcelRequire('knqHM'));

});


parcelRegister("hqX3Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $a165742ed253731e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $guChT = parcelRequire("guChT");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a165742ed253731e$var$EngagementSpotlightAsync = (0, $bQWwW.lazy)(()=>(parcelRequire("9jsx4")).then(({ EngagementSpotlight: EngagementSpotlight })=>EngagementSpotlight), {
    ssr: false,
    moduleId: "../platform/packages/personalization/engagekit-ts/src/index.ts"
});
const $a165742ed253731e$var$SpotlightTourTarget = ({ children: children, engagementId: engagementId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: engagementId
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-engagement-spotlight",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-engagement-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a165742ed253731e$var$EngagementSpotlightAsync, {
        engagementId: engagementId
    }))));
var $a165742ed253731e$export$2e2bcd8739ae039 = $a165742ed253731e$var$SpotlightTourTarget;

});
parcelRegister("9jsx4", function(module, exports) {

let $6c7c055ad20d9394$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6c7c055ad20d9394$var$load("ffQaD"),
    $6c7c055ad20d9394$var$load("kvRbA"),
    $6c7c055ad20d9394$var$load("76n7a"),
    $6c7c055ad20d9394$var$load("l253H"),
    $6c7c055ad20d9394$var$load("66OvY")
]).then(()=>parcelRequire('cf0I9'));

});


parcelRegister("5gIAR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b48b63ba324164d9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b48b63ba324164d9$var$messages = (0, $7qGN1.defineMessages)({
    successOptInTitle: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title",
        "defaultMessage": "You've switched to the new issue search"
    },
    successOptInDesc: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for issues across Jira."
    },
    successActionLearnMoreLink: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-action-learn-more-link",
        "defaultMessage": "Learn more"
    },
    successOptInTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title-issue-term-refresh",
        "defaultMessage": "You've switched to the new search"
    },
    successOptInDescIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc-issue-term-refresh",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for work across Jira."
    }
});
var $b48b63ba324164d9$export$2e2bcd8739ae039 = $b48b63ba324164d9$var$messages;

});


parcelRegister("dQ4Ik", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e786e53309ddc04$export$2e2bcd8739ae039);

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $1JGvk = parcelRequire("1JGvk");

var $aCCNU = parcelRequire("aCCNU");
var $9e786e53309ddc04$export$2e2bcd8739ae039 = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), (0, $1JGvk.ToggleButtons), (0, $aCCNU.default));

});
parcelRegister("1JGvk", function(module, exports) {

$parcel$export(module.exports, "ToggleButtons", () => $40397b328aa6cd17$export$34301fadafd0cd9d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");
const $40397b328aa6cd17$export$34301fadafd0cd9d = ({ options: options, selectedOption: selectedOption, onChange: onChange, label: label, isCompact: isCompact, expDesignRefresh: expDesignRefresh })=>{
    const getButtonWithContext = (0, $eJOHy.useCallback)(({ option: option, isSelected: isSelected })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
            role: "radio",
            "aria-checked": isSelected,
            xcss: [
                expDesignRefresh ? $40397b328aa6cd17$var$baseStylesDesignRefresh : $40397b328aa6cd17$var$baseStyles,
                !isCompact && (expDesignRefresh ? $40397b328aa6cd17$var$wideStylesDesignRefresh : $40397b328aa6cd17$var$wideStyles),
                isSelected && (expDesignRefresh ? $40397b328aa6cd17$var$selectedStylesDesignRefresh : $40397b328aa6cd17$var$selectedStyles)
            ],
            onClick: (event, analyticsEvent)=>!isSelected && onChange(option.id, event, analyticsEvent),
            isDisabled: option.isDisabled,
            testId: option.testId,
            interactionName: option.interactionName,
            children: option.label
        }, option.id), [
        onChange,
        isCompact,
        expDesignRefresh
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        role: "radiogroup",
        xcss: expDesignRefresh ? $40397b328aa6cd17$var$containerStylesDesignRefresh : $40397b328aa6cd17$var$containerStyles,
        "aria-label": label,
        as: "fieldset",
        children: options.map((option)=>getButtonWithContext({
                option: option,
                isSelected: option.id === selectedOption
            }))
    });
};
const $40397b328aa6cd17$var$containerStyles = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    paddingInline: 'space.025',
    gap: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    height: '2rem'
});
const $40397b328aa6cd17$var$containerStylesDesignRefresh = (0, $1DXK0.xcss)({
    borderColor: 'color.border',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: "var(--ds-border-radius-100, 6px)",
    padding: 'space.050',
    gap: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    height: '2rem'
});
const $40397b328aa6cd17$var$baseStyles = (0, $1DXK0.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    border: '1px solid transparent',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    color: 'color.text.subtle',
    height: '26px',
    fontWeight: 'font.weight.medium',
    padding: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    },
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':disabled': {
        background: "var(--ds-background-disabled, #091E4208)",
        color: 'color.text.disabled'
    }
});
const $40397b328aa6cd17$var$baseStylesDesignRefresh = (0, $1DXK0.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    border: '1px solid transparent',
    borderRadius: "var(--ds-border-radius-050, 3px)",
    color: 'color.text.subtle',
    height: '24px',
    fontWeight: 'font.weight.medium',
    padding: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    },
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':disabled': {
        background: "var(--ds-background-disabled, #091E4208)",
        color: 'color.text.disabled'
    }
});
const $40397b328aa6cd17$var$selectedStyles = (0, $1DXK0.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
    color: 'color.text.selected',
    cursor: 'default',
    ':hover': {
        background: "var(--ds-background-selected, #E9F2FF)",
        color: 'color.text.selected'
    }
});
const $40397b328aa6cd17$var$selectedStylesDesignRefresh = (0, $1DXK0.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: 'color.text.selected',
    cursor: 'default',
    ':hover': {
        background: "var(--ds-background-selected, #E9F2FF)",
        color: 'color.text.selected'
    }
});
const $40397b328aa6cd17$var$wideStyles = (0, $1DXK0.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $40397b328aa6cd17$var$wideStylesDesignRefresh = (0, $1DXK0.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.100'
});

});

parcelRegister("aCCNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $df5f0ece3abdd2b7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $dPMMf = parcelRequire("dPMMf");

var $ucEZR = parcelRequire("ucEZR");

var $g60Pz = parcelRequire("g60Pz");
let $df5f0ece3abdd2b7$var$uniqueId = 0;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$df5f0ece3abdd2b7$export$2e2bcd8739ae039 = ({ label: label, options: options, selectedOption: selectedOption, onChange: onChange })=>{
    (0, $g60Pz.assertPrecondition)(()=>({
            precondition: options.length > 0,
            message: `ToggleButtons requires at least one option, but received ${options.length}`
        }));
    (0, $g60Pz.assertPrecondition)(()=>({
            precondition: (0, $g60Pz.findDuplicateIds)(options) === null,
            message: `ToggleButtons requires that every option has a unique ID, but received "${(0, $g60Pz.findDuplicateIds)(options)}" multiple times`
        }));
    (0, $g60Pz.assertPrecondition)(()=>({
            precondition: options.findIndex((option)=>option.id === selectedOption) !== -1,
            message: `ToggleButtons requires that the selectedOption matches the ID of one of the passed options, but "${selectedOption}" did not`
        }));
    const [id] = (0, $eJOHy.useState)(()=>`toggle-buttons-${$df5f0ece3abdd2b7$var$uniqueId++}`);
    const fieldsetRef = (0, $eJOHy.useRef)(null);
    const selectedOptionRef = (0, $eJOHy.useRef)();
    const [selectedOptionPosition, setSelectedOptionPosition] = (0, $eJOHy.useState)();
    (0, $eJOHy.useEffect)(()=>{
        const fieldset = fieldsetRef.current;
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function, jira/jira-ssr/no-unchecked-globals-usage
        if (!fieldset || !window.ResizeObserver) return ()=>{};
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resizeObserver = new window.ResizeObserver(()=>{
            const element = selectedOptionRef.current;
            if (element) setSelectedOptionPosition({
                left: element.offsetLeft,
                top: element.offsetTop,
                width: element.offsetWidth,
                height: element.offsetHeight
            });
        });
        resizeObserver.observe(fieldset);
        return ()=>{
            resizeObserver.unobserve(fieldset);
        };
    }, [
        selectedOption
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df5f0ece3abdd2b7$var$Fieldset, {
        ref: fieldsetRef,
        selectedOptionPosition: selectedOptionPosition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("legend", null, label), options.map((option)=>{
        const isChecked = selectedOption === option.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ucEZR.default), {
            key: option.id,
            name: id,
            value: option.id,
            isChecked: isChecked,
            isDisabled: !!option.isDisabled,
            onChange: onChange,
            // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown> | undefined' is not assignable to type 'Ref<OptionProps> | undefined'.
            ref: isChecked ? selectedOptionRef : undefined,
            testId: option.testId
        }, option.label);
    }));
};
// The !important rules are required so that we can use this mixin on selectors
// with arbitrary specificity
const $df5f0ece3abdd2b7$var$selectedOptionIndicator = {
    backgroundColor: `${"var(--ds-background-accent-gray-subtler, #DCDFE4)"} !important`,
    borderRadius: `${(0, $dPMMf.borderRadius)}px !important`
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df5f0ece3abdd2b7$var$Fieldset = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "fieldset", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedOptionPosition: selectedOptionPosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ozn9do": (0, $awdRS.default)(__cmplp.selectedOptionPosition?.left, "px"),
            "--_1ibdxcf": (0, $awdRS.default)(__cmplp.selectedOptionPosition?.top, "px"),
            "--_1ggrzjo": (0, $awdRS.default)(__cmplp.selectedOptionPosition?.width, "px"),
            "--_1797z6d": (0, $awdRS.default)(__cmplp.selectedOptionPosition?.height, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _11c8dcr7 _1e0c1txw _1n261g80 _1bsb1ris _p12f1osq _kqswh2mm _bfhkm7j4 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _k48p1pd9 _1p1dangw _syaz1fxt _1qiiidpf _12o6idpf _19mbidpf _1ob8idpf _1e1midpf _p8t715vq _b4u715vq _1se6t94y _soiet94y _1jhnstnw _1r9t7mnp _kj6f1q9c _10bvh2mm _1nvfze3t _1nei1b66 _rt2pze3t _bmksze3t _fhioidpf _1kt9b3bt _1cs8stnw _rfx31wa3 _1rusksj1 _qs2z1l1k _1cg61yx9 _mlfedkwg",
            __cmplp.selectedOptionPosition ? "_cfu11ule" : "_cfu1glyw",
            __cmplp.selectedOptionPosition?.left ? "_qnecejz7" : "_qnecidpf",
            __cmplp.selectedOptionPosition?.top ? "_1auk1nuc" : "_1aukidpf",
            __cmplp.selectedOptionPosition?.width ? "_1mp412nj" : "_1mp4idpf",
            __cmplp.selectedOptionPosition?.height ? "_kfgt1d85" : "_kfgtidpf",
            !__cmplp.selectedOptionPosition && "_1ph31wa3 _15e9ksj1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ucEZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1a484822ee0f4ba$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
var $f1a484822ee0f4ba$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ name: name, value: value, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, children: children, testId: testId }, ref)=>{
    const id = `${name}-${value}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1a484822ee0f4ba$var$Container, {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "radio",
        id: id,
        name: name,
        value: value,
        checked: isChecked,
        disabled: isDisabled,
        "data-testid": testId,
        onChange: (event)=>onChange(value, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("label", {
        htmlFor: id
    }, children));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1a484822ee0f4ba$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v69yidpf _ogxmidpf _1qtqidpf _n9z4idpf _scffidpf _1yzy15vq _bgrh15vq _5hv9t94y _pytkt94y _khufstnw _11127mnp _1ru31q9c _1ioh1l7b _15pj1ule _d7ff1b66 _1j8612x7 _1qrc1b66 _4yng12x7 _1vzltlke _1hhy73ad _1emz73ad _1efl1lh4 _7el91vm4 _15pqglyw _vrjh166n _c2fy18uv _ynfu18uv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("g60Pz", function(module, exports) {

$parcel$export(module.exports, "findDuplicateIds", () => $d27f41633e9b3601$export$e5f5e25214715ca1);
$parcel$export(module.exports, "assertPrecondition", () => $d27f41633e9b3601$export$5565eefbe4b468a0);
const $d27f41633e9b3601$export$e5f5e25214715ca1 = (options)=>{
    for(let i = 0; i < options.length - 1; ++i)for(let j = i + 1; j < options.length; ++j){
        if (options[i].id === options[j].id) return options[i].id;
    }
    return null;
};
const $d27f41633e9b3601$export$5565eefbe4b468a0 = (evaluatePrecondition)=>{};

});



parcelRegister("2G5xc", function(module, exports) {

$parcel$export(module.exports, "messages", () => $18b42aaff9bd3333$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $18b42aaff9bd3333$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        "id": "jql-builder.search-mode-switcher.label",
        "defaultMessage": "Select search mode"
    },
    basicModeDisabledTooltip: {
        "id": "jql-builder.search-mode-switcher.basic-mode-disabled-tooltip",
        "defaultMessage": "You can't switch to basic as the query is too complex or is invalid"
    },
    basicMode: {
        "id": "jql-builder.search-mode-switcher.basic-mode",
        "defaultMessage": "Basic"
    },
    advancedMode: {
        "id": "jql-builder.search-mode-switcher.advanced-mode",
        "defaultMessage": "JQL"
    }
});

});


parcelRegister("cOgRS", function(module, exports) {

$parcel$export(module.exports, "DefaultJqlBuilderContainer", () => $9c511170863b1d92$export$ef9307b2d2a6d612);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");
const $9c511170863b1d92$export$ef9307b2d2a6d612 = ({ showAdvancedEditor: showAdvancedEditor, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9c511170863b1d92$var$jqlBuilderContainerStyles,
            // eslint-disable-next-line no-nested-ternary
            showAdvancedEditor ? $9c511170863b1d92$var$jqlBuilderContainerAdvancedStyles : (0, $6XJko.isVisualRefreshEnabled)() ? $9c511170863b1d92$var$jqlBuilderContainerBasicStyles : $9c511170863b1d92$var$jqlBuilderContainerBasicStyleOld
        ]
    }, children);
const $9c511170863b1d92$var$jqlBuilderContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexGrow: 1
});
const $9c511170863b1d92$var$jqlBuilderContainerBasicStyleOld = (0, $1DXK0.xcss)({
    /* ExtraControls should wrap with refinements when we are NOT in advanced mode */ flexWrap: 'wrap',
    /* Advanced mode has a footer element with a min-height of 20px. When in basic mode, we need to
	  replicate this spacing (20px - negative margin from above) to ensure there is no layout jumping
	  when switching between search modes. */ marginTop: 'space.negative.025',
    marginRight: 'space.negative.050',
    marginBottom: 'space.200',
    marginLeft: 'space.negative.025'
});
const $9c511170863b1d92$var$jqlBuilderContainerBasicStyles = (0, $1DXK0.xcss)({
    /* ExtraControls should wrap with refinements when we are NOT in advanced mode */ flexWrap: 'wrap',
    /* Advanced mode has a footer element with a min-height of 20px. When in basic mode, we need to
      replicate this spacing (20px - negative margin from above) to ensure there is no layout jumping
      when switching between search modes. */ marginTop: 'space.negative.025',
    marginRight: 'space.negative.050',
    marginBottom: 'space.200',
    marginLeft: 'space.negative.050'
});
const $9c511170863b1d92$var$jqlBuilderContainerAdvancedStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.negative.025',
    marginRight: 'space.negative.050',
    marginBottom: 'space.negative.050',
    marginLeft: 'space.negative.025'
});

});

parcelRegister("7bFFO", function(module, exports) {

$parcel$export(module.exports, "SearchModeSwitcherContainer", () => $287e29c0bdf24804$export$c9785cf59aeeda5f);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6zXPf = parcelRequire("6zXPf");
const $287e29c0bdf24804$export$c9785cf59aeeda5f = ({ testId: testId, children: children, isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $287e29c0bdf24804$var$getContainerXcss(isSearchModeSwitcherOnLeft),
        testId: testId
    }, children);
const $287e29c0bdf24804$var$getContainerXcss = (isSearchModeSwitcherOnLeft)=>{
    if ((0, $6zXPf.getWillShowNav4)()) {
        if (isSearchModeSwitcherOnLeft) return [
            $287e29c0bdf24804$var$searchModeSwitcherBaseContainerStyle
        ];
        return [
            $287e29c0bdf24804$var$searchModeSwitcherBaseContainerStyle,
            $287e29c0bdf24804$var$searchModeSwitcherRightAlignedContainerStyle
        ];
    }
    return [
        $287e29c0bdf24804$var$searchModeSwitcherContainerStyle
    ];
};
const $287e29c0bdf24804$var$searchModeSwitcherBaseContainerStyle = (0, $1DXK0.xcss)({
    alignSelf: 'start',
    // The toggle container is inline aligned with the JQL editor, and needs to match the height to avoid any misalignment along the horizontal axis
    // However, prior to this change, it only matched the height because some of the content coincidentally matched the height of the left side elements
    // The following two styles will fix that height to match the JQL editor, and align the items to the vertical center
    minHeight: "var(--ds-space-400, 32px)",
    display: 'flex'
});
const $287e29c0bdf24804$var$searchModeSwitcherRightAlignedContainerStyle = (0, $1DXK0.xcss)({
    marginTop: 'space.025',
    marginLeft: 'space.100'
});
const $287e29c0bdf24804$var$searchModeSwitcherContainerStyle = (0, $1DXK0.xcss)({
    marginLeft: 'space.100',
    alignSelf: 'start',
    marginTop: 'space.025',
    // The toggle container is inline aligned with the JQL editor, and needs to match the height to avoid any misalignment along the horizontal axis
    // However, prior to this change, it only matched the height because some of the content coincidentally matched the height of the left side elements
    // The following two styles will fix that height to match the JQL editor, and align the items to the vertical center
    minHeight: "var(--ds-space-400, 32px)",
    display: 'flex'
});

});

parcelRegister("7ebli", function(module, exports) {

$parcel$export(module.exports, "Container", () => $cc291d339cbcb639$export$42a852a2b6b56249);
$parcel$export(module.exports, "BasicEditorListContainer", () => $cc291d339cbcb639$export$5937a18186f4570f);
$parcel$export(module.exports, "AdvancedEditorWrapperOld", () => $cc291d339cbcb639$export$806411edd2f9cae);
$parcel$export(module.exports, "Divider", () => $cc291d339cbcb639$export$2e0a83ec2e27ecbb);
$parcel$export(module.exports, "BeforeJqlBuilderContainerOld", () => $cc291d339cbcb639$export$73fdb9b5d8c2be74);
$parcel$export(module.exports, "BeforeJqlBuilderListItemContainerOld", () => $cc291d339cbcb639$export$8f3efeb4a3e584ee);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $cc291d339cbcb639$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $cc291d339cbcb639$export$5937a18186f4570f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _16jlkb7n _1n261g80 _rcujidpf _o81cidpf _1l6uidpf _149midpf",
            __cmplp.className
        ])
    });
});
const $cc291d339cbcb639$var$negativeMarginOffsetStyles = {
    /* Parent EditorContainer has a negative margin to offset the margin of refinement bar controls. So now we need to
     offset the parent container negative margin to ensure UI controls are aligned properly. */ margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
};
const $cc291d339cbcb639$export$806411edd2f9cae = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18s89ng6 _1e0c1txw _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $cc291d339cbcb639$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1kl7zgxb _1e0c1txw _4cvr1h6o _4t3izwfg _19pk1b66 _18u01b66 _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _vchhusvi",
            __cmplp.className
        ])
    });
});
const $cc291d339cbcb639$export$73fdb9b5d8c2be74 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18s89ng6",
            __cmplp.className
        ])
    });
});
const $cc291d339cbcb639$export$8f3efeb4a3e584ee = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18s89ng6 _qtt8glyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jn1oF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7e5efbb2c8bb629$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XJko = parcelRequire("6XJko");

var $7ebli = parcelRequire("7ebli");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c7e5efbb2c8bb629$var$StyledChild = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $c7e5efbb2c8bb629$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlidpf _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $c7e5efbb2c8bb629$var$ExtraControls = ({ searchMode: searchMode, renderExtraControls: renderExtraControls, shouldUseListMarkup: shouldUseListMarkup })=>{
    const extraControls = (0, $eJOHy.useMemo)(()=>renderExtraControls(), [
        renderExtraControls
    ]);
    const shouldApplyVisualRefreshChanges = (0, $6XJko.isVisualRefreshEnabled)();
    const content = shouldUseListMarkup ? extraControls.map((Component, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7e5efbb2c8bb629$var$StyledChild, {
            key: index
        }, index === 0 && !shouldApplyVisualRefreshChanges && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            searchMode: searchMode
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7e5efbb2c8bb629$var$Container, null, !shouldApplyVisualRefreshChanges && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.Divider), null), extraControls.map((Component, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            key: index,
            searchMode: searchMode
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, extraControls.length > 0 && content);
};
var $c7e5efbb2c8bb629$export$2e2bcd8739ae039 = $c7e5efbb2c8bb629$var$ExtraControls;

});


parcelRegister("8ShlV", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderUIImplOld", () => $ac45ac8f498fde35$export$8d394b0b8f88059a);
$parcel$export(module.exports, "JQLBuilderUIImpl", () => $ac45ac8f498fde35$export$d33754885f040153);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $gYnSx = parcelRequire("gYnSx");

var $lHHP1 = parcelRequire("lHHP1");

var $8t32G = parcelRequire("8t32G");

var $hrKgE = parcelRequire("hrKgE");

var $6MO8n = parcelRequire("6MO8n");
var $4GZBG = parcelRequire("4GZBG");

var $e1BYb = parcelRequire("e1BYb");

var $hHzDA = parcelRequire("hHzDA");

var $5fhUb = parcelRequire("5fhUb");

var $8KuTC = parcelRequire("8KuTC");

var $l5UaK = parcelRequire("l5UaK");

var $gr39h = parcelRequire("gr39h");

var $bUnif = parcelRequire("bUnif");

var $6zXPf = parcelRequire("6zXPf");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $ftN6c = parcelRequire("ftN6c");

var $4Oene = parcelRequire("4Oene");

var $6XJko = parcelRequire("6XJko");

var $epTsa = parcelRequire("epTsa");

var $8FAu5 = parcelRequire("8FAu5");

var $bJscI = parcelRequire("bJscI");

var $ch9En = parcelRequire("ch9En");

var $7jTnu = parcelRequire("7jTnu");

var $56qWy = parcelRequire("56qWy");

var $6bDCV = parcelRequire("6bDCV");

var $cOgRS = parcelRequire("cOgRS");

var $cX22j = parcelRequire("cX22j");

var $7ebli = parcelRequire("7ebli");

var $jn1oF = parcelRequire("jn1oF");

var $34Sgq = parcelRequire("34Sgq");
const $ac45ac8f498fde35$export$8d394b0b8f88059a = ({ analyticsSource: analyticsSource, query: query, onSearch: onSearchProp, onUpdate: onUpdate, beforeControls: beforeControls, renderExtraControls: renderExtraControls, isSearching: isSearching, onLoad: onLoad, onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, jqlMessages: jqlMessages, excludedFields: excludedFields, searchModes: searchModes, selectedSearchMode: selectedSearchMode, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, components: components, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation, showOrderByPicker: showOrderByPicker, contextJql: contextJql, loadingModeRef: loadingModeRef, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const jqlDebuggerStoreActions = (0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $bUnif.useJqlDebuggerStoreActions)() : undefined;
    const irremovableFieldsAnalyticsAttributes = (0, $hHzDA.useIrremovableFieldsAnalyticsAttributes)(irremovableFields);
    const { searchMode: searchMode, setSelectedSearchMode: setSelectedSearchMode } = (0, $cX22j.useSelectedSearchMode)();
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    const onSwitchToJql = (0, $eJOHy.useCallback)(()=>{
        setSelectedSearchMode((0, $56qWy.SEARCH_MODE_ADVANCED), true);
    }, [
        setSelectedSearchMode
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const jqlErrors = (jqlMessages || []).filter((e)=>e.type === 'error');
        if (jqlErrors?.length) {
            const errorAnalyticsEvent = createAnalyticsEvent({});
            (0, $gYnSx.default)({
                event: errorAnalyticsEvent,
                meta: {
                    id: 'jqlBuilderJqlInvalid',
                    packageName: 'jiraJqlBuilder',
                    teamName: 'empanada'
                },
                attributes: {
                    queryMode: searchMode
                }
            });
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onJqlBuilderAdvancedReady = (0, $eJOHy.useCallback)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_ADVANCED_JS_END
        });
        onReady && onReady((0, $56qWy.SEARCH_MODE_ADVANCED));
    }, [
        onPerformanceMark,
        onReady
    ]);
    const onJqlBuilderBasicReady = (0, $eJOHy.useCallback)(()=>{
        onReady && onReady((0, $56qWy.SEARCH_MODE_BASIC));
    }, [
        onReady
    ]);
    let onSearch = onSearchProp;
    // Keep onSearch undefined if onSearchProp is not provided, as a defined onSearch
    // will alter the behavior of the advanced JQL editor (e.g. rendering search button)
    if (onSearchProp) onSearch = (jql)=>{
        if ((0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) {
            if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) jqlDebuggerStoreActions?.resetStatus('ON_NEW_JQL_SEARCH', jql);
            else jqlDebuggerStoreActions?.resetStatus('ON_NEW_JQL_SEARCH');
        }
        onSearchProp(jql);
        const event = createAnalyticsEvent({
            action: 'submitted',
            actionSubject: 'search'
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'jqlBuilder', {
            searchMode: searchMode
        });
    };
    const { SearchModeSwitcher: SearchModeSwitcher, EditorContainer: CustomEditorContainer } = components ?? {};
    const isSearchModeToggleEnabled = searchModes ? searchModes.length > 1 : true;
    const isSearchModeSwitcherOnLeft = searchModeSwitcherLocation === (0, $56qWy.SEARCH_MODE_SWITCHER_LEFT_LOCATION) && (0, $6zXPf.getWillShowNav4)();
    const SearchModeSwitcherComponent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $34Sgq.SearchModeSwitcherRenderer), {
            isSearchModeToggleEnabled: isSearchModeToggleEnabled,
            SearchModeSwitcher: SearchModeSwitcher,
            isHydrating: isHydrating,
            isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
        }), [
        SearchModeSwitcher,
        isHydrating,
        isSearchModeSwitcherOnLeft,
        isSearchModeToggleEnabled
    ]);
    const BeforeJqlBuilderContainerComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.BeforeJqlBuilderContainer) : (0, $7ebli.BeforeJqlBuilderContainerOld);
    const BeforeJqlBuilderListItemContainerComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.BeforeJqlBuilderListItemContainer) : (0, $7ebli.BeforeJqlBuilderListItemContainerOld);
    const AdvancedEditorWrapperComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.AdvancedEditorWrapper) : (0, $7ebli.AdvancedEditorWrapperOld);
    // We need to memoize props before passing it into useMemo because an object splat is a new reference on every render
    const editorForwardedProps = (0, $hrKgE.useShallowStableReference)(props, (0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const Editor = (0, $eJOHy.useMemo)(()=>{
        let jqlBuilderComponent;
        switch(searchMode){
            case 0, $56qWy.SEARCH_MODE_BASIC:
                jqlBuilderComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
                    name: "jql-builder-basic"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MO8n.JQLBuilderBasicOldAsync), {
                    query: query,
                    // consumers can hide search feature from advanced jql editor by not passing onSearch Handler
                    // if no onSearch handler is passed, Basic JQL editor would fallback to onUpdate handler
                    onSearch: onSearch || onUpdate || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                    onSwitchToJql: onSwitchToJql,
                    excludedFields: excludedFields,
                    onReady: onJqlBuilderBasicReady,
                    onJourneyStart: onJourneyStart,
                    NoOptionComponent: NoOptionComponent,
                    hydrationQueryRef: hydrationQueryRef,
                    isHydrating: isHydrating,
                    shouldUseListMarkup: true,
                    hideOperatorDropdown: hideOperatorDropdownBasicMode,
                    irremovableFields: irremovableFields,
                    hideTextSearchInput: hideTextSearchInput,
                    searchPlaceholder: searchPlaceholder,
                    showOrderByPicker: showOrderByPicker,
                    contextJql: contextJql,
                    ...editorForwardedProps
                }));
                break;
            default:
                jqlBuilderComponent = (0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
                    name: "jql-builder-advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
                    engagementId: "nin.jql-builder.advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gr39h.JqlDebuggerJqlBuilderContextProvider), {
                    jqlMessages: jqlMessages,
                    query: query,
                    onSearch: onSearch
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8t32G.default), {
                    analyticsSource: analyticsSource,
                    onSearch: onSearch,
                    onUpdate: onUpdate,
                    query: query,
                    jqlMessages: jqlMessages,
                    isSearching: isSearching,
                    isCompact: true,
                    excludedAutocompleteFields: excludedFields,
                    onReady: onJqlBuilderAdvancedReady,
                    onJourneyStart: onJourneyStart,
                    customComponents: {
                        ErrorMessage: (0, $l5UaK.JQLDebuggerTriggerButton)
                    },
                    ...editorForwardedProps
                }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
                    name: "jql-builder-advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
                    engagementId: "nin.jql-builder.advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8t32G.default), {
                    analyticsSource: analyticsSource,
                    onSearch: onSearch,
                    onUpdate: onUpdate,
                    query: query,
                    jqlMessages: jqlMessages,
                    isSearching: isSearching,
                    isCompact: true,
                    excludedAutocompleteFields: excludedFields,
                    onReady: onJqlBuilderAdvancedReady,
                    onJourneyStart: onJourneyStart,
                    ...editorForwardedProps
                }))));
        }
        const BeforeJqlBuilderWrapper = searchMode === (0, $56qWy.SEARCH_MODE_BASIC) ? BeforeJqlBuilderListItemContainerComponent : BeforeJqlBuilderContainerComponent;
        const showSearchModeSwitcher = (0, $6XJko.isVisualRefreshEnabled)() ? isSearchModeToggleEnabled && isSearchModeSwitcherOnLeft : isSearchModeSwitcherOnLeft;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, beforeControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BeforeJqlBuilderWrapper, null, beforeControls), showSearchModeSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BeforeJqlBuilderWrapper, null, SearchModeSwitcherComponent), jqlBuilderComponent, renderExtraControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jn1oF.default), {
            searchMode: searchMode,
            renderExtraControls: renderExtraControls,
            shouldUseListMarkup: searchMode === (0, $56qWy.SEARCH_MODE_BASIC)
        }));
    }, [
        searchMode,
        BeforeJqlBuilderListItemContainerComponent,
        BeforeJqlBuilderContainerComponent,
        beforeControls,
        isSearchModeToggleEnabled,
        isSearchModeSwitcherOnLeft,
        SearchModeSwitcherComponent,
        renderExtraControls,
        query,
        onSearch,
        onUpdate,
        onSwitchToJql,
        excludedFields,
        onJqlBuilderBasicReady,
        onJourneyStart,
        NoOptionComponent,
        hydrationQueryRef,
        isHydrating,
        hideOperatorDropdownBasicMode,
        irremovableFields,
        hideTextSearchInput,
        searchPlaceholder,
        showOrderByPicker,
        contextJql,
        editorForwardedProps,
        AdvancedEditorWrapperComponent,
        analyticsSource,
        jqlMessages,
        isSearching,
        onJqlBuilderAdvancedReady
    ]);
    const EffectiveJqlBuilderContainer = CustomEditorContainer ?? (0, $cOgRS.DefaultJqlBuilderContainer);
    return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.Container), {
        "data-testid": "jql-builder",
        "data-vc": "jql-builder-ui-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(EffectiveJqlBuilderContainer, {
        showAdvancedEditor: searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED),
        "data-testid": "jql-builder.ui.effective-jql-builder-container"
    }, searchMode === (0, $56qWy.SEARCH_MODE_BASIC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.BasicEditorListContainer), {
        "data-vc": "jql-builder-basic-editor-container"
    }, Editor) : Editor), !isSearchModeSwitcherOnLeft && SearchModeSwitcherComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "jqlBuilder",
        attributes: {
            selectedSearchMode: selectedSearchMode,
            queryMode: (0, $56qWy.mapSearchModeToAnalyticAtribute)[searchMode],
            ...irremovableFieldsAnalyticsAttributes,
            loadingMode: loadingModeRef.current
        }
    })));
};
const $ac45ac8f498fde35$export$4eaa27e39ff4ae8c = (0, $bJscI.componentWithFG)('render_jql_builder_in_ssr', (0, $e1BYb.default), (0, $6MO8n.default));
const $ac45ac8f498fde35$export$d33754885f040153 = ({ analyticsSource: analyticsSource, query: query, onSearch: onSearchProp, onUpdate: onUpdate, beforeControls: beforeControls, renderExtraControls: renderExtraControls, isSearching: isSearching, onLoad: onLoad, onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, jqlMessages: jqlMessages, excludedFields: excludedFields, searchModes: searchModes, selectedSearchMode: selectedSearchMode, hydrationData: hydrationData, components: components, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation, showOrderByPicker: showOrderByPicker, contextJql: contextJql, loadingModeRef: loadingModeRef, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const jqlDebuggerStoreActions = (0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $bUnif.useJqlDebuggerStoreActions)() : undefined;
    const irremovableFieldsAnalyticsAttributes = (0, $hHzDA.useIrremovableFieldsAnalyticsAttributes)(irremovableFields);
    const { searchMode: searchMode, setSelectedSearchMode: setSelectedSearchMode } = (0, $cX22j.useSelectedSearchMode)();
    const { hydrationQueryIsFetching: hydrationQueryIsFetching } = (0, $8FAu5.useHydrationQuery)();
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    const onSwitchToJql = (0, $eJOHy.useCallback)(()=>{
        setSelectedSearchMode((0, $56qWy.SEARCH_MODE_ADVANCED), true);
    }, [
        setSelectedSearchMode
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const jqlErrors = (jqlMessages || []).filter((e)=>e.type === 'error');
        if (jqlErrors?.length) {
            const errorAnalyticsEvent = createAnalyticsEvent({});
            (0, $gYnSx.default)({
                event: errorAnalyticsEvent,
                meta: {
                    id: 'jqlBuilderJqlInvalid',
                    packageName: 'jiraJqlBuilder',
                    teamName: 'empanada'
                },
                attributes: {
                    queryMode: searchMode
                }
            });
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onJqlBuilderAdvancedReady = (0, $eJOHy.useCallback)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_ADVANCED_JS_END
        });
        onReady && onReady((0, $56qWy.SEARCH_MODE_ADVANCED));
    }, [
        onPerformanceMark,
        onReady
    ]);
    const onJqlBuilderBasicLoad = (0, $eJOHy.useCallback)(()=>{
        onLoad && onLoad((0, $56qWy.SEARCH_MODE_BASIC));
    }, [
        onLoad
    ]);
    const onJqlBuilderBasicReady = (0, $eJOHy.useCallback)(()=>{
        onReady && onReady((0, $56qWy.SEARCH_MODE_BASIC));
    }, [
        onReady
    ]);
    let onSearch = onSearchProp;
    // Keep onSearch undefined if onSearchProp is not provided, as a defined onSearch
    // will alter the behavior of the advanced JQL editor (e.g. rendering search button)
    if (onSearchProp) onSearch = (jql)=>{
        if ((0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) {
            if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) jqlDebuggerStoreActions?.resetStatus('ON_NEW_JQL_SEARCH', jql);
            else jqlDebuggerStoreActions?.resetStatus('ON_NEW_JQL_SEARCH');
        }
        onSearchProp(jql);
        const event = createAnalyticsEvent({
            action: 'submitted',
            actionSubject: 'search'
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'jqlBuilder', {
            searchMode: searchMode
        });
    };
    const { SearchModeSwitcher: SearchModeSwitcher, EditorContainer: CustomEditorContainer } = components ?? {};
    const isSearchModeToggleEnabled = searchModes ? searchModes.length > 1 : true;
    const isSearchModeSwitcherOnLeft = searchModeSwitcherLocation === (0, $56qWy.SEARCH_MODE_SWITCHER_LEFT_LOCATION) && (0, $6zXPf.getWillShowNav4)();
    const BeforeJqlBuilderContainerComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.BeforeJqlBuilderContainer) : (0, $7ebli.BeforeJqlBuilderContainerOld);
    const BeforeJqlBuilderListItemContainerComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.BeforeJqlBuilderListItemContainer) : (0, $7ebli.BeforeJqlBuilderListItemContainerOld);
    const AdvancedEditorWrapperComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.AdvancedEditorWrapper) : (0, $7ebli.AdvancedEditorWrapperOld);
    const SearchModeSwitcherComponent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $34Sgq.SearchModeSwitcherRenderer), {
            isSearchModeToggleEnabled: isSearchModeToggleEnabled,
            SearchModeSwitcher: SearchModeSwitcher,
            isHydrating: hydrationQueryIsFetching,
            isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
        }), [
        SearchModeSwitcher,
        hydrationQueryIsFetching,
        isSearchModeSwitcherOnLeft,
        isSearchModeToggleEnabled
    ]);
    // We need to memoize props before passing it into useMemo because an object splat is a new reference on every render
    const editorForwardedProps = (0, $hrKgE.useShallowStableReference)(props, (0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const Editor = (0, $eJOHy.useMemo)(()=>{
        let jqlBuilderComponent;
        switch(searchMode){
            case 0, $56qWy.SEARCH_MODE_BASIC:
                jqlBuilderComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
                    name: "jql-builder-basic"
                }, false && (0, $7jTnu.fg)('render_jql_builder_in_ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
                    name: "jql-builder-basic-fallback",
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GZBG.JQLBuilderBasicFallback), {
                        query: query,
                        excludedFields: excludedFields,
                        onLoad: onJqlBuilderBasicLoad,
                        shouldUseListMarkup: true,
                        irremovableFields: irremovableFields,
                        hideTextSearchInput: hideTextSearchInput,
                        searchPlaceholder: searchPlaceholder,
                        showOrderByPicker: showOrderByPicker
                    })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac45ac8f498fde35$export$4eaa27e39ff4ae8c, {
                    query: query,
                    // consumers can hide search feature from advanced jql editor by not passing onSearch Handler
                    // if no onSearch handler is passed, Basic JQL editor would fallback to onUpdate handler
                    onSearch: onSearch || onUpdate || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                    onSwitchToJql: onSwitchToJql,
                    excludedFields: excludedFields,
                    onReady: onJqlBuilderBasicReady,
                    onJourneyStart: onJourneyStart,
                    NoOptionComponent: NoOptionComponent,
                    AddFilterButtonComponent: components?.AddFilterButtonComponent,
                    hydrationData: hydrationData,
                    isHydrating: hydrationQueryIsFetching,
                    shouldUseListMarkup: true,
                    hideOperatorDropdown: hideOperatorDropdownBasicMode,
                    irremovableFields: irremovableFields,
                    hideTextSearchInput: hideTextSearchInput,
                    searchPlaceholder: searchPlaceholder,
                    showOrderByPicker: showOrderByPicker,
                    contextJql: contextJql,
                    ...editorForwardedProps
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac45ac8f498fde35$export$4eaa27e39ff4ae8c, {
                    query: query,
                    // consumers can hide search feature from advanced jql editor by not passing onSearch Handler
                    // if no onSearch handler is passed, Basic JQL editor would fallback to onUpdate handler
                    onSearch: onSearch || onUpdate || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                    onSwitchToJql: onSwitchToJql,
                    excludedFields: excludedFields,
                    onReady: onJqlBuilderBasicReady,
                    onJourneyStart: onJourneyStart,
                    NoOptionComponent: NoOptionComponent,
                    AddFilterButtonComponent: components?.AddFilterButtonComponent,
                    hydrationData: hydrationData,
                    isHydrating: hydrationQueryIsFetching,
                    shouldUseListMarkup: true,
                    hideOperatorDropdown: hideOperatorDropdownBasicMode,
                    irremovableFields: irremovableFields,
                    hideTextSearchInput: hideTextSearchInput,
                    searchPlaceholder: searchPlaceholder,
                    showOrderByPicker: showOrderByPicker,
                    contextJql: contextJql,
                    ...editorForwardedProps
                }));
                break;
            default:
                jqlBuilderComponent = (0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
                    name: "jql-builder-advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
                    engagementId: "nin.jql-builder.advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gr39h.JqlDebuggerJqlBuilderContextProvider), {
                    jqlMessages: jqlMessages,
                    query: query,
                    onSearch: onSearch
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8t32G.default), {
                    analyticsSource: analyticsSource,
                    onSearch: onSearch,
                    onUpdate: onUpdate,
                    query: query,
                    jqlMessages: jqlMessages,
                    isSearching: isSearching,
                    isCompact: true,
                    excludedAutocompleteFields: excludedFields,
                    onReady: onJqlBuilderAdvancedReady,
                    onJourneyStart: onJourneyStart,
                    customComponents: {
                        ErrorMessage: (0, $l5UaK.JQLDebuggerTriggerButton)
                    },
                    ...editorForwardedProps
                }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
                    name: "jql-builder-advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
                    engagementId: "nin.jql-builder.advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8t32G.default), {
                    analyticsSource: analyticsSource,
                    onSearch: onSearch,
                    onUpdate: onUpdate,
                    query: query,
                    jqlMessages: jqlMessages,
                    isSearching: isSearching,
                    isCompact: true,
                    excludedAutocompleteFields: excludedFields,
                    onReady: onJqlBuilderAdvancedReady,
                    onJourneyStart: onJourneyStart,
                    ...editorForwardedProps
                }))));
        }
        const BeforeJqlBuilderWrapper = searchMode === (0, $56qWy.SEARCH_MODE_BASIC) ? BeforeJqlBuilderListItemContainerComponent : BeforeJqlBuilderContainerComponent;
        const showSearchModeSwitcher = (0, $6XJko.isVisualRefreshEnabled)() ? isSearchModeToggleEnabled && isSearchModeSwitcherOnLeft : isSearchModeSwitcherOnLeft;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, beforeControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BeforeJqlBuilderWrapper, null, beforeControls), showSearchModeSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BeforeJqlBuilderWrapper, null, SearchModeSwitcherComponent), jqlBuilderComponent, renderExtraControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jn1oF.default), {
            searchMode: searchMode,
            renderExtraControls: renderExtraControls,
            shouldUseListMarkup: searchMode === (0, $56qWy.SEARCH_MODE_BASIC)
        }));
    }, [
        searchMode,
        BeforeJqlBuilderListItemContainerComponent,
        BeforeJqlBuilderContainerComponent,
        isSearchModeToggleEnabled,
        isSearchModeSwitcherOnLeft,
        beforeControls,
        SearchModeSwitcherComponent,
        renderExtraControls,
        query,
        onSearch,
        onUpdate,
        onSwitchToJql,
        excludedFields,
        onJqlBuilderBasicLoad,
        onJqlBuilderBasicReady,
        onJourneyStart,
        NoOptionComponent,
        components?.AddFilterButtonComponent,
        hydrationData,
        hydrationQueryIsFetching,
        hideOperatorDropdownBasicMode,
        irremovableFields,
        hideTextSearchInput,
        searchPlaceholder,
        showOrderByPicker,
        contextJql,
        editorForwardedProps,
        AdvancedEditorWrapperComponent,
        jqlMessages,
        analyticsSource,
        isSearching,
        onJqlBuilderAdvancedReady
    ]);
    const EffectiveJqlBuilderContainer = CustomEditorContainer ?? (0, $cOgRS.DefaultJqlBuilderContainer);
    return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.Container), {
        "data-testid": "jql-builder",
        "data-vc": "jql-builder-ui-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(EffectiveJqlBuilderContainer, {
        showAdvancedEditor: searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED),
        "data-testid": "jql-builder.ui.effective-jql-builder-container"
    }, searchMode === (0, $56qWy.SEARCH_MODE_BASIC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.BasicEditorListContainer), {
        "data-vc": "jql-builder-basic-editor-container"
    }, Editor) : Editor), !isSearchModeSwitcherOnLeft && SearchModeSwitcherComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "jqlBuilder",
        attributes: {
            selectedSearchMode: selectedSearchMode,
            queryMode: (0, $56qWy.mapSearchModeToAnalyticAtribute)[searchMode],
            ...irremovableFieldsAnalyticsAttributes,
            loadingMode: loadingModeRef.current
        }
    })));
};

});
parcelRegister("8t32G", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e3a3c86068ea6cb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $c5g9h = parcelRequire("c5g9h");

var $j6JBf = parcelRequire("j6JBf");
const $3e3a3c86068ea6cb$var$JQLBuilderAdvancedAsync = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j6JBf.default), {
        ...props,
        JQLEditor: (0, $c5g9h.JQLEditorAsync)
    });
var $3e3a3c86068ea6cb$export$2e2bcd8739ae039 = $3e3a3c86068ea6cb$var$JQLBuilderAdvancedAsync;

});
parcelRegister("j6JBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $70b05a2bfbaf0fa4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $cdYRp = parcelRequire("cdYRp");

var $ekzEX = parcelRequire("ekzEX");

var $jYt1v = parcelRequire("jYt1v");

var $1Zcfy = parcelRequire("1Zcfy");

var $ii7Oz = parcelRequire("ii7Oz");

var $itdlt = parcelRequire("itdlt");

var $ezGpi = parcelRequire("ezGpi");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $bILK0 = parcelRequire("bILK0");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $bUnif = parcelRequire("bUnif");

var $5fhUb = parcelRequire("5fhUb");

var $8KuTC = parcelRequire("8KuTC");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $5G60L = parcelRequire("5G60L");


var $0aNCs = parcelRequire("0aNCs");

var $kLjta = parcelRequire("kLjta");

var $3LacB = parcelRequire("3LacB");

var $bOvYj = parcelRequire("bOvYj");
const $70b05a2bfbaf0fa4$var$JQLBuilderAdvancedUI = (props)=>{
    (0, $gRw8I.di)(requestAnimationFrame);
    const { analyticsSource: analyticsSource, JQLEditor: JQLEditor, query: query, jqlMessages: jqlMessages, isCompact: isCompact, isSearching: isSearching, onUpdate: onUpdate, onReady: onReady, onSearch: onSearch, excludedAutocompleteFields: excludedAutocompleteFields, onJourneyStart: onJourneyStart, autoFocus: autoFocus, viewContext: viewContext = null, scope: scope = null, customComponents: customComponents, isFieldIncludedInAutocomplete: isFieldIncludedInAutocomplete } = props;
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_ADVANCED_JS_START
        });
    }, [
        onPerformanceMark
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onHydrate = (0, $bOvYj.useOnHydrate)(viewContext, scope);
    const getInitialData = (0, $kLjta.useAutocompleteInitialData)(excludedAutocompleteFields, isFieldIncludedInAutocomplete);
    const getSuggestions = (0, $3LacB.useAutocompleteSuggestions)();
    const autocompleteProvider = (0, $jYt1v.useAutocompleteProvider)(analyticsSource, getInitialData, getSuggestions);
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experienceId: undefined,
        experience: (0, $7b5dd06670889591$export$abc61f74b6bec12c),
        analyticsSource: analyticsSource
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $7b5dd06670889591$export$abc61f74b6bec12c)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $7b5dd06670889591$export$abc61f74b6bec12c)
    });
    const { setIsReadyForProactive: setIsReadyForProactive } = (0, $bUnif.useJqlDebuggerStoreActions)();
    const onError = (0, $eJOHy.useCallback)((error)=>{
        showFlag({
            type: 'error',
            title: (0, $0aNCs.default).errorFlagTitle,
            description: (0, $0aNCs.default).errorFlagDescription,
            messageId: 'jql-builder-advanced.ui.show-flag.error.error-flag',
            messageType: 'transactional'
        });
        // A success event may have already been fired on initial render. We need to start a new experience so we
        // can mark it as failed.
        onExperienceStart();
        onExperienceFail(analyticsSource, error);
        (0, $gYnSx.default)({
            meta: {
                id: (0, $7b5dd06670889591$export$abc61f74b6bec12c),
                packageName: (0, $7b5dd06670889591$export$b8b9d90f9e5bd72b),
                teamName: (0, $7b5dd06670889591$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        showFlag,
        onExperienceStart,
        onExperienceFail,
        analyticsSource
    ]);
    // Additional logging to debug unexpected (non-fatal) behaviour in the editor.
    const onDebugUnsafeMessage = (0, $eJOHy.useCallback)((message, event)=>{
        (0, $eSnSE.default).unsafeErrorWithCustomerData('jiraJqlBuilderAdvanced.onDebugUnsafeMessage', message, event);
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // Start the view experience on mount. This experience will be marked as successful by the JQLBuilderAdvancedUI
        // component upon render.
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    const searchInputRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const focusSearchInput = (0, $eJOHy.useCallback)(()=>{
        // This is the same way the global search input prevents
        // the shortcut from being fed into the input
        // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
        requestAnimationFrame(()=>{
            searchInputRef?.current?.focus();
        });
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut'
        }), 'jqlEditorAdvancedSearchInputKeyboardShortcut', {
            keyPressed: 'f',
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent
    ]);
    const onEditorMounted = (0, $eJOHy.useCallback)(()=>{
        onExperienceSuccess();
        if (autoFocus) focusSearchInput();
        onReady && onReady();
    }, [
        onExperienceSuccess,
        onReady,
        autoFocus,
        focusSearchInput
    ]);
    const { getKeywords: getKeywords } = (0, $itdlt.useCommandKeywords)();
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        if (!onJourneyStart) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: 'input'
        });
        const attributes = onJourneyStart();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'jqlEditorAdvancedSearchInput', attributes);
    }, [
        createAnalyticsEvent,
        onJourneyStart
    ]);
    const onEditorFocus = (0, $eJOHy.useCallback)(()=>{
        if (onJourneyStart) onFocus();
        setIsReadyForProactive(true);
    }, [
        onFocus,
        onJourneyStart,
        setIsReadyForProactive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ezGpi.CommandShortcuts), {
        keyMap: {
            f: {
                callback: focusSearchInput,
                registerInCommandPalette: {
                    id: 'jql-builder-advanced-focus-search-input',
                    name: formatMessage((0, $0aNCs.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cdYRp))), {
                                spacing: "spacious",
                                label: formatMessage((0, $0aNCs.default).searchCurrentPage)
                            })
                    },
                    priority: (0, $ii7Oz.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickActions,
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(JQLEditor, {
        inputRef: searchInputRef,
        analyticsSource: analyticsSource,
        query: query,
        messages: jqlMessages,
        isCompact: isCompact,
        isSearching: isSearching,
        onEditorMounted: onEditorMounted,
        onUpdate: onUpdate,
        onSearch: onSearch,
        onHydrate: onHydrate,
        onFocus: // eslint-disable-next-line no-nested-ternary
        (0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? onEditorFocus : onJourneyStart ? onFocus : undefined,
        autocompleteProvider: autocompleteProvider,
        onRenderError: onError,
        onDebugUnsafeMessage: onDebugUnsafeMessage,
        enableRichInlineNodes: true,
        customComponents: (0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? customComponents : undefined
    }));
};
const $70b05a2bfbaf0fa4$var$JQLBuilderAdvancedUIWithAnalytics = (props)=>{
    const clientWrapper = (0, $eJOHy.useRef)((0, $5G60L.getAnalyticsWebClient)());
    return /* @ts-expect-error - Property 'analyticsClient' does not exist on type 'AnalyticsWebClient'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ekzEX.default), {
        client: clientWrapper.current?.analyticsClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "jqlBuilderAdvanced",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($70b05a2bfbaf0fa4$var$JQLBuilderAdvancedUI, props)));
};
var $70b05a2bfbaf0fa4$export$2e2bcd8739ae039 = $70b05a2bfbaf0fa4$var$JQLBuilderAdvancedUIWithAnalytics;

});
parcelRegister("ekzEX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a4ada9c2041e802$export$2e2bcd8739ae039);
/**
 * Adapted from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/fabric/FabricEditorListener.tsx
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8QoO2 = parcelRequire("8QoO2");

var $6S5SS = parcelRequire("6S5SS");

var $fOBtZ = parcelRequire("fOBtZ");

var $6x7IT = parcelRequire("6x7IT");
class $1a4ada9c2041e802$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props), this.handleEventWrapper = (event)=>{
            (0, $fOBtZ.handleEvent)(event, this.logger, this.props.client);
        };
        this.logger = new (0, $6x7IT.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8QoO2.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $6S5SS.ANALYTICS_CHANNEL),
            children: this.props.children
        });
    }
}

});
parcelRegister("6S5SS", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $24684b03ee892706$export$85183a312807388d);
$parcel$export(module.exports, "EventType", () => $24684b03ee892706$export$3d7865934588d77e);
const $24684b03ee892706$export$85183a312807388d = 'jql-editor';
var $24684b03ee892706$export$3d7865934588d77e = /*#__PURE__*/ function(EventType) {
    EventType["OPERATIONAL"] = "operational";
    EventType["SCREEN"] = "screen";
    EventType["TRACK"] = "track";
    EventType["UI"] = "ui";
    return EventType;
}({});

});

parcelRegister("fOBtZ", function(module, exports) {

$parcel$export(module.exports, "handleEvent", () => $58a5fa39310b949b$export$d6e5ca10785815df);
/**
 * Adapted from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/fabric/handle-event.tsx
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ 
var $fpV8m = parcelRequire("fpV8m");

var $jpLWp = parcelRequire("jpLWp");
const $58a5fa39310b949b$export$d6e5ca10785815df = (event, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $jpLWp.processEventPayload)(event);
    (0, $fpV8m.sendEvent)(logger, client)(payload);
};

});
parcelRegister("fpV8m", function(module, exports) {

$parcel$export(module.exports, "sendEvent", () => $b00271829da1e389$export$7329bcdc3edcd90e);
/**
 * Copied from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/analytics-web-client-wrapper.ts
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ const $b00271829da1e389$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $b00271829da1e389$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const gasEvent = {
                ...event
            };
            /*
      Merging this ts-ignore is not going to affect the type definitions of the package
      there's a whole lot more wrong going on here than just this delete.
      All the send methods on the client take a GasPurePayload object which requires actionSubject
      actionSubject is missing on GasPayload | GasScreenEventPayload
    */ // @ts-ignore mergeable @fixme TypeScript 4.2.4 upgrade
            delete gasEvent.eventType;
            const withClient = (cb)=>{
                if ($b00271829da1e389$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});

parcelRegister("jpLWp", function(module, exports) {

$parcel$export(module.exports, "processEventPayload", () => $b4c41af70425b6f3$export$c37d638b7f2ca192);
/**
 * Adapted from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/fabric/process-event-payload.tsx
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ 
var $1O6Yz = parcelRequire("1O6Yz");

const $b4c41af70425b6f3$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, item), {});
const $b4c41af70425b6f3$var$fieldExtractor = ()=>$b4c41af70425b6f3$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId'
    ]);
const $b4c41af70425b6f3$var$updatePayloadWithContext = (event)=>{
    if (event.context.length === 0) return {
        source: (0, $d6f34b7bd34f6138$export$b055de0e665cb20c),
        ...event.payload
    };
    const fields = $b4c41af70425b6f3$var$fieldExtractor()(event.context);
    return {
        source: (0, $d6f34b7bd34f6138$export$b055de0e665cb20c),
        ...fields,
        ...event.payload
    };
};
const $b4c41af70425b6f3$export$c37d638b7f2ca192 = (event)=>{
    return $b4c41af70425b6f3$var$updatePayloadWithContext(event);
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $d6f34b7bd34f6138$export$a1562d08625f5d7e = 'ui';
const $d6f34b7bd34f6138$export$947dac6c72b26f81 = 'track';
const $d6f34b7bd34f6138$export$f1d537d508d2945a = 'screen';
const $d6f34b7bd34f6138$export$12346a674644c156 = 'operational';
const $d6f34b7bd34f6138$export$b055de0e665cb20c = 'unknown';



parcelRegister("6x7IT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9cb35c5b15456e8$export$2e2bcd8739ae039);
/**
 * Copied from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/helpers/logger.ts
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ const $b9cb35c5b15456e8$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $b9cb35c5b15456e8$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $b9cb35c5b15456e8$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $b9cb35c5b15456e8$export$ffe0c436e29512cf.DEBUG && logLevel <= $b9cb35c5b15456e8$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $b9cb35c5b15456e8$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) // eslint-disable-next-line no-console
        console[type](...args);
    }
    debug(...args) {
        this.logMessage($b9cb35c5b15456e8$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($b9cb35c5b15456e8$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($b9cb35c5b15456e8$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($b9cb35c5b15456e8$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});


parcelRegister("jYt1v", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteProvider", () => $362fcacbf11ef843$export$2ae605545144a62d);

var $eJOHy = parcelRequire("eJOHy");

var $jUKMF = parcelRequire("jUKMF");

var $31ow5 = parcelRequire("31ow5");

var $ixD5Q = parcelRequire("ixD5Q");

var $9xQSs = parcelRequire("9xQSs");

var $if50z = parcelRequire("if50z");

var $gbgyp = parcelRequire("gbgyp");
const $362fcacbf11ef843$export$2ae605545144a62d = (/**
	 * Page/experience where the hook is being rendered. Used to correlate JQL analytics events to a given consumer.
	 */ analyticsSource, /**
	 * Fetch initial autocomplete data for fields and functions using the [Get field reference data API](https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-jql/#api-rest-api-3-jql-autocompletedata-post).
	 * Consumers can implement this method to configure which JS API will be used to make the request, e.g. Connect apps may
	 * wish to use the [AP.request API](https://developer.atlassian.com/cloud/jira/software/jsapi/request/).
	 */ getInitialData, /**
	 * Fetch autocomplete suggestions for field values using the [Get field autocomplete suggestions API](https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-jql/#api-rest-api-3-jql-autocompletedata-suggestions-get).
	 * Consumers can implement this method to configure which JS API will be used to make the request, e.g. Connect apps may
	 * wish to use the [AP.request API](https://developer.atlassian.com/cloud/jira/software/jsapi/request/).
	 */ getSuggestions)=>{
    const { createAndFireAnalyticsEvent: createAndFireAnalyticsEvent } = (0, $jUKMF.useJqlEditorAutocompleteAnalytics)(analyticsSource);
    const [, { load: load }] = (0, $31ow5.useJqlAutocompleteActions)();
    const [jqlSearchableFields$] = (0, $31ow5.useJqlSearchableFieldsObservable)();
    const [jqlOrderableFields$] = (0, $31ow5.useJqlOrderableFieldsObservable)();
    const [jqlFunctions$] = (0, $31ow5.useJqlFunctionsObservable)();
    const onFields = (0, $ixD5Q.default)(jqlSearchableFields$, jqlOrderableFields$);
    const onOperators = (0, $if50z.default)(jqlSearchableFields$);
    const onFunctions = (0, $9xQSs.default)(jqlSearchableFields$, jqlFunctions$);
    const onValues = (0, $gbgyp.default)(jqlSearchableFields$, getSuggestions, createAndFireAnalyticsEvent);
    (0, $eJOHy.useEffect)(()=>{
        // Load autocomplete data on mount
        load(getInitialData, createAndFireAnalyticsEvent);
    }, [
        createAndFireAnalyticsEvent,
        getInitialData,
        load
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            onFields: onFields,
            onOperators: onOperators,
            onFunctions: onFunctions,
            onValues: onValues
        }), [
        onFields,
        onOperators,
        onFunctions,
        onValues
    ]);
};

});
parcelRegister("jUKMF", function(module, exports) {

$parcel$export(module.exports, "useJqlEditorAutocompleteAnalytics", () => $ee8fe5718c1be061$export$67ceee19d6563eac);

var $6S5SS = parcelRequire("6S5SS");
var $3U8bp = parcelRequire("3U8bp");

var $4Nomc = parcelRequire("4Nomc");
const $ee8fe5718c1be061$export$67ceee19d6563eac = (analyticsSource)=>{
    return (0, $3U8bp.useJqlPackageAnalytics)(analyticsSource, "platform-pkg", "0.0.0-use.local", (0, $6S5SS.ANALYTICS_CHANNEL));
};

});
parcelRegister("3U8bp", function(module, exports) {

$parcel$export(module.exports, "useJqlPackageAnalytics", () => $35a19633e7107644$export$62edc016e6670a97);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");
const $35a19633e7107644$export$62edc016e6670a97 = (analyticsSource, packageName, packageVersion, analyticsChannel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const createAndFireAnalyticsEvent = (0, $eJOHy.useCallback)((payload)=>{
        const event = createAnalyticsEvent({
            ...payload,
            attributes: {
                ...payload.attributes,
                analyticsSource: analyticsSource,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        event.fire(analyticsChannel);
    }, [
        createAnalyticsEvent,
        analyticsSource,
        packageName,
        packageVersion,
        analyticsChannel
    ]);
    return {
        createAndFireAnalyticsEvent: createAndFireAnalyticsEvent
    };
};

});

parcelRegister("4Nomc", function(module, exports) {

$parcel$export(module.exports, "Action", () => $e21ea14f75640e0b$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "ActionSubject", () => $e21ea14f75640e0b$export$7f97440769de1377);
var $e21ea14f75640e0b$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["FAILED"] = "failed";
    Action["SUCCESS"] = "success";
    return Action;
}({});
var $e21ea14f75640e0b$export$7f97440769de1377 = /*#__PURE__*/ function(ActionSubject) {
    ActionSubject["AUTOCOMPLETE_INITIAL_DATA"] = "autocompleteInitialData";
    ActionSubject["AUTOCOMPLETE_SUGGESTIONS"] = "autocompleteSuggestions";
    return ActionSubject;
}({});
var $e21ea14f75640e0b$export$cb7d54f314e067cb = /*#__PURE__*/ function(ActionSubjectId) {
    return ActionSubjectId;
}({});

});


parcelRegister("31ow5", function(module, exports) {

$parcel$export(module.exports, "useJqlAutocompleteActions", () => $14a136a3def68f0c$export$dfe74b189a0a3dd);
$parcel$export(module.exports, "useJqlSearchableFieldsObservable", () => $14a136a3def68f0c$export$e00ad85496518b08);
$parcel$export(module.exports, "useJqlOrderableFieldsObservable", () => $14a136a3def68f0c$export$ddac70d4fccb6121);
$parcel$export(module.exports, "useJqlFunctionsObservable", () => $14a136a3def68f0c$export$20ce426c77c6c794);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $2opa2 = parcelRequire("2opa2");

var $4pIMA = parcelRequire("4pIMA");

var $6S5SS = parcelRequire("6S5SS");

var $4Nomc = parcelRequire("4Nomc");
const $14a136a3def68f0c$var$initialData = {
    jqlSearchableFields: [],
    jqlOrderableFields: [],
    jqlFunctions: []
};
const $14a136a3def68f0c$var$initialState = {
    initialDataFetched: false,
    jqlSearchableFields$: (0, $2opa2.from)($14a136a3def68f0c$var$initialData.jqlSearchableFields),
    jqlOrderableFields$: (0, $2opa2.from)($14a136a3def68f0c$var$initialData.jqlOrderableFields),
    jqlFunctions$: (0, $2opa2.from)($14a136a3def68f0c$var$initialData.jqlFunctions)
};
const $14a136a3def68f0c$export$e324594224ef24da = {
    load: (getInitialData, createAndFireAnalyticsEvent)=>({ getState: getState, setState: setState })=>{
            const { initialDataFetched: initialDataFetched } = getState();
            if (initialDataFetched) return;
            const promise = getInitialData(`/rest/api/latest/jql/autocompletedata`).then((res)=>{
                const initialValue = {
                    jqlSearchableFields: [],
                    jqlOrderableFields: [],
                    jqlFunctions: res.jqlFunctions
                };
                const data = res.jqlFields.reduce((result, field)=>{
                    if (field.searchable === 'true') result.jqlSearchableFields.push(field);
                    if (field.orderable === 'true') result.jqlOrderableFields.push(field);
                    return result;
                }, initialValue);
                // Minor optimisation so consumers don't have to wait for the promise `then` function to be called
                // whenever we subscribe to the observable. (`then` runs async in the current thread loop)
                setState({
                    jqlSearchableFields$: (0, $2opa2.from)(data.jqlSearchableFields),
                    jqlOrderableFields$: (0, $2opa2.from)(data.jqlOrderableFields),
                    jqlFunctions$: (0, $2opa2.from)(data.jqlFunctions)
                });
                createAndFireAnalyticsEvent({
                    action: (0, $4Nomc.Action).SUCCESS,
                    actionSubject: (0, $4Nomc.ActionSubject).AUTOCOMPLETE_INITIAL_DATA,
                    eventType: (0, $6S5SS.EventType).OPERATIONAL
                });
                return data;
            }).catch(()=>{
                setState({
                    jqlSearchableFields$: $14a136a3def68f0c$var$initialState.jqlSearchableFields$,
                    jqlOrderableFields$: $14a136a3def68f0c$var$initialState.jqlOrderableFields$,
                    jqlFunctions$: $14a136a3def68f0c$var$initialState.jqlFunctions$
                });
                createAndFireAnalyticsEvent({
                    action: (0, $4Nomc.Action).FAILED,
                    actionSubject: (0, $4Nomc.ActionSubject).AUTOCOMPLETE_INITIAL_DATA,
                    eventType: (0, $6S5SS.EventType).OPERATIONAL
                });
                return $14a136a3def68f0c$var$initialData;
            });
            // Set the in-flight promise in state as an observable. This allows consumers to subscribe to our initial data
            // without worrying about race conditions with the API call.
            setState({
                initialDataFetched: true,
                jqlSearchableFields$: (0, $2opa2.from)(promise).pipe((0, $4pIMA.concatMap)(({ jqlSearchableFields: jqlSearchableFields })=>jqlSearchableFields)),
                jqlOrderableFields$: (0, $2opa2.from)(promise).pipe((0, $4pIMA.concatMap)(({ jqlOrderableFields: jqlOrderableFields })=>jqlOrderableFields)),
                jqlFunctions$: (0, $2opa2.from)(promise).pipe((0, $4pIMA.concatMap)(({ jqlFunctions: jqlFunctions })=>jqlFunctions))
            });
        }
};
const $14a136a3def68f0c$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    initialState: $14a136a3def68f0c$var$initialState,
    actions: $14a136a3def68f0c$export$e324594224ef24da
});
const $14a136a3def68f0c$export$96c8f4ecc88d96a5 = (0, $6E16M.createContainer)($14a136a3def68f0c$export$6f57813fe9f31bf9);
const $14a136a3def68f0c$export$dfe74b189a0a3dd = (0, $iJq0l.createHook)($14a136a3def68f0c$export$6f57813fe9f31bf9, {
    selector: null
});
const $14a136a3def68f0c$export$e00ad85496518b08 = (0, $iJq0l.createHook)($14a136a3def68f0c$export$6f57813fe9f31bf9, {
    selector: ({ jqlSearchableFields$: jqlSearchableFields$ })=>jqlSearchableFields$
});
const $14a136a3def68f0c$export$ddac70d4fccb6121 = (0, $iJq0l.createHook)($14a136a3def68f0c$export$6f57813fe9f31bf9, {
    selector: ({ jqlOrderableFields$: jqlOrderableFields$ })=>jqlOrderableFields$
});
const $14a136a3def68f0c$export$20ce426c77c6c794 = (0, $iJq0l.createHook)($14a136a3def68f0c$export$6f57813fe9f31bf9, {
    selector: ({ jqlFunctions$: jqlFunctions$ })=>jqlFunctions$
});

});

parcelRegister("ixD5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d572954c46105cb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $17H3E = parcelRequire("17H3E");

var $lB9jX = parcelRequire("lB9jX");

var $8RTYQ = parcelRequire("8RTYQ");

var $3PmNk = parcelRequire("3PmNk");

var $ez3K4 = parcelRequire("ez3K4");

var $dfP4l = parcelRequire("dfP4l");

var $6mqWj = parcelRequire("6mqWj");

var $c52XI = parcelRequire("c52XI");
const $6d572954c46105cb$export$df27029b4333540b = 20;
const $6d572954c46105cb$var$CF_ID_PATTERN = /^"?cf\[\d+]"?$/;
const $6d572954c46105cb$var$COLLAPSED_FIELD_PATTERN = /^"?.+\[(.+)]"?$/;
const $6d572954c46105cb$var$isCollapsedField = ({ value: value })=>$6d572954c46105cb$var$COLLAPSED_FIELD_PATTERN.test(value) && !$6d572954c46105cb$var$CF_ID_PATTERN.test(value);
const $6d572954c46105cb$export$b9089a6e41ed43aa = (field)=>{
    if (!$6d572954c46105cb$var$isCollapsedField(field)) return null;
    const matches = $6d572954c46105cb$var$COLLAPSED_FIELD_PATTERN.exec(field.value);
    if (!matches || matches.length < 2) return null;
    return matches[1];
};
const $6d572954c46105cb$var$useOnFields = (jqlSearchableFields$, jqlOrderableFields$)=>{
    // Returns an Observable of the fields to render for the provided query string
    return (0, $eJOHy.useCallback)((query, clause)=>{
        if (clause === undefined) return (0, $lB9jX.empty)();
        const jqlFields$ = clause === 'orderBy' ? jqlOrderableFields$ : jqlSearchableFields$;
        return jqlFields$.pipe((0, $8RTYQ.filter)((field)=>(0, $6mqWj.filterJqlValue)(field, query)), // Limit the result to MAX_VISIBLE_OPTIONS
        (0, $ez3K4.take)($6d572954c46105cb$export$df27029b4333540b), (0, $3PmNk.map)((field)=>{
            const fieldType = $6d572954c46105cb$export$b9089a6e41ed43aa(field);
            if (fieldType !== null) {
                const name = (0, (/*@__PURE__*/$parcel$interopDefault($17H3E)))(field.displayName).replace(` - ${(0, $c52XI.normalize)(field.value)}`, '');
                return {
                    name: name,
                    value: field.value,
                    fieldType: fieldType,
                    isDeprecated: field.deprecated === 'true',
                    deprecatedSearcherKey: field.deprecatedSearcherKey
                };
            }
            return {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($17H3E)))(field.displayName),
                value: field.value,
                isDeprecated: field.deprecated === 'true',
                deprecatedSearcherKey: field.deprecatedSearcherKey
            };
        }), (0, $dfP4l.toArray)(), // We can filter out empty arrays as there is nothing to consume
        (0, $8RTYQ.filter)((fields)=>fields.length > 0));
    }, [
        jqlSearchableFields$,
        jqlOrderableFields$
    ]);
};
var $6d572954c46105cb$export$2e2bcd8739ae039 = $6d572954c46105cb$var$useOnFields;

});
parcelRegister("17H3E", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");

var $gdVrJ = parcelRequire("gdVrJ");
/** Used to match HTML entities and HTML characters. */ var $0d17d84d14702012$var$reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, $0d17d84d14702012$var$reHasEscapedHtml = RegExp($0d17d84d14702012$var$reEscapedHtml.source);
/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */ function $0d17d84d14702012$var$unescape(string) {
    string = $cz1WF(string);
    return string && $0d17d84d14702012$var$reHasEscapedHtml.test(string) ? string.replace($0d17d84d14702012$var$reEscapedHtml, $gdVrJ) : string;
}
module.exports = $0d17d84d14702012$var$unescape;

});
parcelRegister("gdVrJ", function(module, exports) {

var $loEwo = parcelRequire("loEwo");
/** Used to map HTML entities to characters. */ var $bcfa6be5b1ea43a2$var$htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
};
/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */ var $bcfa6be5b1ea43a2$var$unescapeHtmlChar = $loEwo($bcfa6be5b1ea43a2$var$htmlUnescapes);
module.exports = $bcfa6be5b1ea43a2$var$unescapeHtmlChar;

});


parcelRegister("6mqWj", function(module, exports) {

$parcel$export(module.exports, "filterJqlValue", () => $4ad61e929ffda610$export$7a9ba8200d77b3fe);

var $c52XI = parcelRequire("c52XI");
const $4ad61e929ffda610$export$7a9ba8200d77b3fe = ({ displayName: displayName, value: value }, query)=>{
    if (typeof query !== 'string' || query === '') return true;
    const normalizedQuery = (0, $c52XI.normalize)(query);
    const normalizedDisplayName = (0, $c52XI.normalize)(displayName);
    const normalizedValue = (0, $c52XI.normalize)(value);
    // If query is quoted, then we only return exact matches with the JQL value
    if ((0, $c52XI.isQuoted)(query)) return (0, $c52XI.areStringsEquivalent)(normalizedQuery, normalizedValue);
    return (0, $c52XI.areStringsEquivalent)(normalizedQuery, normalizedDisplayName.substring(0, normalizedQuery.length)) || (0, $c52XI.areStringsEquivalent)(normalizedQuery, normalizedValue.substring(0, normalizedQuery.length));
};

});
parcelRegister("c52XI", function(module, exports) {

$parcel$export(module.exports, "isQuoted", () => $606b88fa6dae2b48$export$b86601123607fee5);
$parcel$export(module.exports, "normalize", () => $606b88fa6dae2b48$export$a3295358bff77e);
$parcel$export(module.exports, "areStringsEquivalent", () => $606b88fa6dae2b48$export$cef6d95c2df8ec7f);
const $606b88fa6dae2b48$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $606b88fa6dae2b48$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $606b88fa6dae2b48$export$b86601123607fee5 = (maybeQuotedString)=>$606b88fa6dae2b48$export$7a0b99b892e0dda8(maybeQuotedString) || $606b88fa6dae2b48$export$d5efd6512db694fd(maybeQuotedString);
const $606b88fa6dae2b48$export$a3295358bff77e = (maybeQuotedString)=>{
    if ($606b88fa6dae2b48$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};
const $606b88fa6dae2b48$var$collator = new Intl.Collator(undefined, {
    sensitivity: 'base'
});
const $606b88fa6dae2b48$export$cef6d95c2df8ec7f = (a, b)=>$606b88fa6dae2b48$var$collator.compare(a, b) === 0;

});



parcelRegister("9xQSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ca9a1731eb23a93$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6PCNA = parcelRequire("6PCNA");

var $lB9jX = parcelRequire("lB9jX");

var $4pIMA = parcelRequire("4pIMA");

var $8RTYQ = parcelRequire("8RTYQ");

var $3PmNk = parcelRequire("3PmNk");

var $dfP4l = parcelRequire("dfP4l");

var $3Rwc9 = parcelRequire("3Rwc9");
const $6ca9a1731eb23a93$var$useOnFunctions = (jqlSearchableFields$, jqlFunctions$)=>{
    return (0, $eJOHy.useCallback)((query, field, isListOperator)=>{
        if (typeof field !== 'string' || field === '') return (0, $lB9jX.empty)();
        const filterRegex = typeof query === 'string' && query !== '' ? new RegExp(`^${(0, (/*@__PURE__*/$parcel$interopDefault($6PCNA)))(query)}[^$]`, 'i') : undefined;
        const field$ = (0, $3Rwc9.default)(jqlSearchableFields$, field);
        // Find all functions that match our query with a type that intersects our field types
        return field$.pipe((0, $4pIMA.concatMap)((matchingField)=>jqlFunctions$.pipe((0, $8RTYQ.filter)((func)=>!filterRegex || func.displayName.match(filterRegex) !== null), (0, $8RTYQ.filter)((func)=>// Do not include functions that return a list unless we are using a list operator
                !!isListOperator || func.isList !== 'true'), (0, $8RTYQ.filter)((func)=>// Include functions with a type that intersects our field types
                func.types.filter((type)=>matchingField.types.includes(type)).length > 0), (0, $3PmNk.map)((func)=>({
                    name: func.displayName,
                    value: func.value,
                    isListFunction: func.isList === 'true' || func.supportsListAndSingleValueOperators === 'true'
                })), (0, $dfP4l.toArray)())), // We can filter out empty arrays as there is nothing to consume
        (0, $8RTYQ.filter)((operands)=>operands.length > 0));
    }, [
        jqlSearchableFields$,
        jqlFunctions$
    ]);
};
var $6ca9a1731eb23a93$export$2e2bcd8739ae039 = $6ca9a1731eb23a93$var$useOnFunctions;

});
parcelRegister("3Rwc9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5959a5a0d93858$export$2e2bcd8739ae039);

var $8RTYQ = parcelRequire("8RTYQ");

var $ez3K4 = parcelRequire("ez3K4");

var $c52XI = parcelRequire("c52XI");
/**
 * Returns an Observable of the first field matching the provided string, or an empty Observable if no matching field
 * could be found.
 */ const $6d5959a5a0d93858$var$findField$ = (jqlFields$, field)=>{
    return jqlFields$.pipe((0, $8RTYQ.filter)(({ value: value })=>{
        const normalizedField = (0, $c52XI.normalize)(field);
        const normalizedValue = (0, $c52XI.normalize)(value);
        return (0, $c52XI.areStringsEquivalent)(normalizedField, normalizedValue);
    }), (0, $ez3K4.take)(1));
};
var $6d5959a5a0d93858$export$2e2bcd8739ae039 = $6d5959a5a0d93858$var$findField$;

});


parcelRegister("if50z", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b154cb61073d01$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6PCNA = parcelRequire("6PCNA");

var $lB9jX = parcelRequire("lB9jX");

var $4pIMA = parcelRequire("4pIMA");

var $8RTYQ = parcelRequire("8RTYQ");

var $3PmNk = parcelRequire("3PmNk");

var $dfP4l = parcelRequire("dfP4l");

var $3Rwc9 = parcelRequire("3Rwc9");
const $c7b154cb61073d01$var$useOnOperators = (jqlSearchableFields$)=>{
    return (0, $eJOHy.useCallback)((query, field)=>{
        if (typeof field !== 'string' || field === '') return (0, $lB9jX.empty)();
        const filterRegex = typeof query === 'string' && query !== '' ? new RegExp(`^${(0, (/*@__PURE__*/$parcel$interopDefault($6PCNA)))(query)}[^$]`, 'i') : undefined;
        // Find operators for matching field
        return (0, $3Rwc9.default)(jqlSearchableFields$, field).pipe((0, $4pIMA.concatMap)(({ operators: operators })=>operators), // Filter operators that match query
        (0, $8RTYQ.filter)((operator)=>!filterRegex || operator.match(filterRegex) !== null), (0, $3PmNk.map)((operator)=>{
            const value = operator.toUpperCase();
            return {
                name: value,
                value: value
            };
        }), (0, $dfP4l.toArray)(), // We can filter out empty arrays as there is nothing to consume
        (0, $8RTYQ.filter)((operators)=>operators.length > 0));
    }, [
        jqlSearchableFields$
    ]);
};
var $c7b154cb61073d01$export$2e2bcd8739ae039 = $c7b154cb61073d01$var$useOnOperators;

});

parcelRegister("gbgyp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f2d0ca5c7dd15c1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $lB9jX = parcelRequire("lB9jX");

var $jjQ5U = parcelRequire("jjQ5U");

var $4pIMA = parcelRequire("4pIMA");

var $dHUXL = parcelRequire("dHUXL");

var $8RTYQ = parcelRequire("8RTYQ");

var $3Rwc9 = parcelRequire("3Rwc9");

var $c52XI = parcelRequire("c52XI");


var $kfmn4 = parcelRequire("kfmn4");
const $6f2d0ca5c7dd15c1$var$getValueType = (field)=>{
    if (field.types.includes((0, $54519be5d602d695$export$7cba791a20c35c0c))) return 'user';
    return undefined;
};
const $6f2d0ca5c7dd15c1$var$fieldValuesReducer = (state, action)=>{
    const { cacheKey: cacheKey, values: values } = action.payload;
    return {
        ...state,
        [cacheKey]: values
    };
};
const $6f2d0ca5c7dd15c1$var$initialState = {};
// Hard coded delay before making a fetch call for operands.
const $6f2d0ca5c7dd15c1$var$OPERANDS_DELAY_MS = 650;
// Used to remove emails from user display names in autocomplete values, which come in format: "Name - email".
// Pattern below is specific enough for this purpose and we should avoid writing a more complex email matcher.
const $6f2d0ca5c7dd15c1$var$BASIC_REMOVE_EMAIL_REGEX = /\s-\s\S+@\S+\.\S+$/;
const $6f2d0ca5c7dd15c1$var$useOnValues = (jqlSearchableFields$, getSuggestions, createAndFireAnalyticsEvent)=>{
    (0, $gRw8I.di)((0, $eJOHy.useReducer));
    const fetchFieldValues = (0, $kfmn4.useFetchFieldValues)(getSuggestions, createAndFireAnalyticsEvent);
    const [fieldValuesCache, dispatch] = (0, $eJOHy.useReducer)($6f2d0ca5c7dd15c1$var$fieldValuesReducer, $6f2d0ca5c7dd15c1$var$initialState);
    return (0, $eJOHy.useCallback)((query, field)=>{
        if (typeof field !== 'string' || field === '') return (0, $lB9jX.empty)();
        const field$ = (0, $3Rwc9.default)(jqlSearchableFields$, field);
        // API expects unquoted and unescaped values
        const normalizedField = (0, $c52XI.normalize)(field);
        const normalizedQuery = query !== undefined ? (0, $c52XI.normalize)(query) : '';
        // Cache values by field + query
        const cacheKey = `${normalizedField}:${normalizedQuery}`;
        const isCacheHit = Object.prototype.hasOwnProperty.call(fieldValuesCache, cacheKey);
        return field$.pipe((0, $8RTYQ.filter)((matchingField)=>matchingField.auto === 'true'), (0, $4pIMA.concatMap)((matchingField)=>{
            if (isCacheHit) return (0, $jjQ5U.of)(fieldValuesCache[cacheKey]);
            // If we have a cfid then use it to fetch autocomplete suggestions as results will always be unique.
            // Otherwise it's possible `normalizedField` will match against multiple fields in the API and thus
            // return no data.
            const fieldNameForFetch = matchingField.cfid ?? normalizedField;
            // We emit a single value using Observable.of(null) and delay that event before fetching field values so we
            // can mimic debounce behaviour.
            return (0, $jjQ5U.of)(null).pipe((0, $dHUXL.delay)($6f2d0ca5c7dd15c1$var$OPERANDS_DELAY_MS), (0, $4pIMA.concatMap)(()=>fetchFieldValues(fieldNameForFetch, normalizedQuery).then((values)=>{
                    const valueType = $6f2d0ca5c7dd15c1$var$getValueType(matchingField);
                    if (valueType === 'user') values.forEach((value)=>{
                        value.valueType = valueType;
                        // REST autocomplete API returns user display names with this format: "Name - email". To be
                        // consistent with hydration API, we want to remove email from this name for rich inline nodes.
                        value.nameOnRichInlineNode = value.name.replace($6f2d0ca5c7dd15c1$var$BASIC_REMOVE_EMAIL_REGEX, '');
                    });
                    // Save response to in-memory cache
                    dispatch({
                        type: 'update-cache',
                        payload: {
                            cacheKey: cacheKey,
                            values: values
                        }
                    });
                    return values;
                }).catch(()=>[])));
        }), // We can filter out empty arrays as there is nothing to consume
        (0, $8RTYQ.filter)((operands)=>operands.length > 0));
    }, [
        jqlSearchableFields$,
        fieldValuesCache,
        fetchFieldValues
    ]);
};
var $6f2d0ca5c7dd15c1$export$2e2bcd8739ae039 = $6f2d0ca5c7dd15c1$var$useOnValues;

});
const $54519be5d602d695$export$7cba791a20c35c0c = 'com.atlassian.jira.user.ApplicationUser';

parcelRegister("kfmn4", function(module, exports) {

$parcel$export(module.exports, "useFetchFieldValues", () => $4da65c5478abdefd$export$6cb851ed13e3949e);

var $eJOHy = parcelRequire("eJOHy");

var $6S5SS = parcelRequire("6S5SS");

var $4Nomc = parcelRequire("4Nomc");
const $4da65c5478abdefd$export$7bf3f44bca0a7a65 = (field, query)=>`/rest/api/latest/jql/autocompletedata/suggestions?fieldName=${field}&fieldValue=${query ?? ''}`;
const $4da65c5478abdefd$export$6cb851ed13e3949e = (getSuggestions, createAndFireAnalyticsEvent)=>{
    return (0, $eJOHy.useCallback)(async (field, query)=>{
        try {
            const data = await getSuggestions($4da65c5478abdefd$export$7bf3f44bca0a7a65(field, query));
            const div = document.createElement('div');
            const results = data.results.map((operand)=>{
                // The displayName from the API includes HTML tags to bold matching text e.g. `<b>o</b>pen`
                // We set this as innerHTML so we can get the raw textContent
                div.innerHTML = operand.displayName;
                return {
                    name: div.textContent ?? '',
                    value: operand.value
                };
            });
            createAndFireAnalyticsEvent({
                action: (0, $4Nomc.Action).SUCCESS,
                actionSubject: (0, $4Nomc.ActionSubject).AUTOCOMPLETE_SUGGESTIONS,
                eventType: (0, $6S5SS.EventType).OPERATIONAL
            });
            return results;
        } catch (error) {
            createAndFireAnalyticsEvent({
                action: (0, $4Nomc.Action).FAILED,
                actionSubject: (0, $4Nomc.ActionSubject).AUTOCOMPLETE_SUGGESTIONS,
                eventType: (0, $6S5SS.EventType).OPERATIONAL
            });
            throw error;
        }
    }, [
        createAndFireAnalyticsEvent,
        getSuggestions
    ]);
};

});



parcelRegister("bUnif", function(module, exports) {

$parcel$export(module.exports, "useJqlDebuggerStoreActions", () => $225b1cd3961a99bb$export$661ee98a2d30a450);
$parcel$export(module.exports, "useStoreData", () => $225b1cd3961a99bb$export$544efe5ac05fc17);
$parcel$export(module.exports, "useDebuggerStatus", () => $225b1cd3961a99bb$export$e4c2322c66a3dea5);
$parcel$export(module.exports, "useJqlErrors", () => $225b1cd3961a99bb$export$d959fd60596bfa67);
$parcel$export(module.exports, "useJqlEditorOnSearch", () => $225b1cd3961a99bb$export$ba3a4678e5df092c);
$parcel$export(module.exports, "useJqlQuery", () => $225b1cd3961a99bb$export$ec027c329b94fe67);
$parcel$export(module.exports, "useIsAiEnabled", () => $225b1cd3961a99bb$export$742ce7b41314d513);
$parcel$export(module.exports, "useErrorComponentTestId", () => $225b1cd3961a99bb$export$afd1b99522ddeae9);
$parcel$export(module.exports, "useErrorComponentValidationId", () => $225b1cd3961a99bb$export$9c84149290836e7);
$parcel$export(module.exports, "useIsReadyForProactive", () => $225b1cd3961a99bb$export$1da2ac60b06e42d1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");
const $225b1cd3961a99bb$var$initialState = {
    jqlQuery: '',
    userQueryError: [],
    onSearch: ()=>undefined,
    status: 'INIT',
    jqlDiffTokens: [],
    isAiEnabled: false,
    syntaxCorrectionAttemptErrors: [],
    singleInstrumentationID: '',
    errorSectionTestId: '',
    onAiInteractionDismissed () {
    // do nothing
    },
    exitNaturalLanguageMode () {
    // do nothing
    },
    onJsError () {
    // do nothing
    },
    jqlErrors: [],
    errorComponentValidationId: '',
    errorComponentTestId: '',
    isReadyForProactive: false
};
const $225b1cd3961a99bb$var$Store = (0, $GtRbT.createStore)({
    initialState: $225b1cd3961a99bb$var$initialState,
    // actions that trigger store mutation
    actions: {
        setJqlQuery: (jqlQuery)=>({ setState: setState })=>{
                setState({
                    jqlQuery: jqlQuery
                });
            },
        setOnSearch: (onSearch)=>({ setState: setState })=>{
                setState({
                    onSearch: onSearch
                });
            },
        setStatus: (status)=>({ setState: setState, getState: getState })=>{
                if (status === 'JS_ERROR') getState().onJsError();
                setState({
                    status: status
                });
            },
        setIssueNavigatorSearchMode: (issueNavigatorSearchMode)=>({ setState: setState })=>{
                setState({
                    issueNavigatorSearchMode: issueNavigatorSearchMode
                });
            },
        resetStatus: (source, newJqlQuery)=>({ setState: setState, getState: getState })=>{
                if (source === 'ON_ENTER_NL_MODE') setState({
                    issueNavigatorSearchMode: 'NL2JQL'
                });
                if (getState().status !== 'INIT') {
                    if ((0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button')) // AI modal gets dismissed when we accept a suggestion
                    // However, we don't want to fire the `aiInteraction Dismissed` event in that case
                    // We pass the status in as if we are viewing a result and close the panel, it should be a discarded event, not a dismissed event
                    {
                        if (source !== 'ACCEPT_FIX') {
                            if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) // On a new JQL search, we do not dismiss the AI interaction if the JQL query hasn't changed
                            {
                                if (!(source === 'ON_NEW_JQL_SEARCH' && getState().jqlQuery === newJqlQuery)) getState().onAiInteractionDismissed(source, getState().status);
                            } else getState().onAiInteractionDismissed(source, getState().status);
                        }
                    } else if (source !== 'ACCEPT_FIX') {
                        // AI modal gets dismissed when we accept a suggestion
                        // However, we don't want to fire the `aiInteraction Dismissed` event in that case
                        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) // On a new JQL search, we do not dismiss the AI interaction if the JQL query hasn't changed
                        {
                            if (!(source === 'ON_NEW_JQL_SEARCH' && getState().jqlQuery === newJqlQuery)) getState().onAiInteractionDismissed(source);
                        } else getState().onAiInteractionDismissed(source);
                    }
                    // Reset the status and aiInteractionDismissed handler so that duplicate events won't be fired
                    setState({
                        status: 'INIT',
                        onAiInteractionDismissed: $225b1cd3961a99bb$var$initialState.onAiInteractionDismissed
                    });
                }
            },
        setStateOnFeatureInvoke: (initialDataOnInvoke)=>({ setState: setState })=>{
                setState({
                    ...initialDataOnInvoke,
                    status: 'LOADING_RESULT'
                });
            },
        setJqlErorCorrectionData: (data)=>({ setState: setState })=>{
                setState({
                    ...data,
                    status: 'VIEW_RESULT'
                });
            },
        setIsAiEnabled: (isAiEnabled)=>({ setState: setState })=>{
                setState({
                    isAiEnabled: isAiEnabled
                });
            },
        setOnAiInteractionDismissed: (onAiInteractionDismissed)=>({ setState: setState })=>{
                setState({
                    onAiInteractionDismissed: onAiInteractionDismissed
                });
            },
        setOnJsError: (onJsError)=>({ setState: setState })=>{
                setState({
                    onJsError: onJsError
                });
            },
        exitNaturalLanguageMode: ()=>({ getState: getState })=>{
                getState().exitNaturalLanguageMode?.();
            },
        setExitNaturalLanguageMode: (exitNaturalLanguageMode)=>({ setState: setState })=>{
                setState({
                    exitNaturalLanguageMode: exitNaturalLanguageMode
                });
            },
        setJqlErrors: (jqlErrors)=>({ setState: setState })=>setState({
                    jqlErrors: jqlErrors
                }),
        setErrorComponentValidationId: (errorComponentValidationId)=>({ setState: setState })=>setState({
                    errorComponentValidationId: errorComponentValidationId
                }),
        setErrorComponentTestId: (errorComponentValidationId)=>({ setState: setState })=>setState({
                    errorComponentValidationId: errorComponentValidationId
                }),
        setIsReadyForProactive: (isReadyForProactive)=>({ setState: setState })=>{
                setState({
                    isReadyForProactive: isReadyForProactive
                });
            }
    }
});
const $225b1cd3961a99bb$export$661ee98a2d30a450 = (0, $iJq0l.createActionsHook)($225b1cd3961a99bb$var$Store);
const $225b1cd3961a99bb$export$544efe5ac05fc17 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store);
const $225b1cd3961a99bb$export$e4c2322c66a3dea5 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.status
});
const $225b1cd3961a99bb$export$d959fd60596bfa67 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.jqlErrors
});
const $225b1cd3961a99bb$export$ba3a4678e5df092c = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.onSearch
});
const $225b1cd3961a99bb$export$ec027c329b94fe67 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.jqlQuery
});
const $225b1cd3961a99bb$export$742ce7b41314d513 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.isAiEnabled
});
const $225b1cd3961a99bb$export$afd1b99522ddeae9 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.errorComponentTestId
});
const $225b1cd3961a99bb$export$9c84149290836e7 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.errorComponentValidationId
});
const $225b1cd3961a99bb$export$1da2ac60b06e42d1 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.isReadyForProactive && state.issueNavigatorSearchMode !== 'NL2JQL'
});
const $225b1cd3961a99bb$export$a416100e9df4f9b1 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.syntaxCorrectionAttemptErrors
});

});

const $7b5dd06670889591$export$abc61f74b6bec12c = 'viewJqlBuilderAdvanced';
const $7b5dd06670889591$export$b8b9d90f9e5bd72b = 'jiraJqlBuilderAdvanced';
const $7b5dd06670889591$export$d57b6b390e78d90f = 'empanada';

parcelRegister("0aNCs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7411d81cc67d251$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e7411d81cc67d251$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorFlagTitle: {
        "id": "jql-builder-advanced.error-flag-title",
        "defaultMessage": "We couldn't edit the query"
    },
    errorFlagDescription: {
        "id": "jql-builder-advanced.error-flag-description",
        "defaultMessage": "The JQL builder is unresponsive. Refresh the page to try again."
    },
    searchCurrentPage: {
        "id": "jql-builder-advanced.search-current-page",
        "defaultMessage": "Search on current page"
    }
});

});

parcelRegister("kLjta", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteInitialData", () => $3d3f5d3a050a2eed$export$21e39afbf909ee71);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");


var $fastT = parcelRequire("fastT");
const $3d3f5d3a050a2eed$export$21e39afbf909ee71 = (excludedAutocompleteFields = [], fieldsFilter)=>(0, $eJOHy.useCallback)((url)=>{
        const options = {
            method: 'POST',
            body: JSON.stringify({
                includeCollapsedFields: true
            })
        };
        return (0, $fastT.fetchWithRetry)(()=>(0, $1Ozm9.default)(url, options), 1).then((res)=>({
                jqlFields: excludedAutocompleteFields.length === 0 && !fieldsFilter ? res.visibleFieldNames : res.visibleFieldNames.filter((field)=>fieldsFilter?.(field.cfid || field.value) !== false && !excludedAutocompleteFields.includes(field.value)),
                jqlFunctions: res.visibleFunctionNames
            })).catch((error)=>{
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'getAutocompleteInitialData',
                    packageName: (0, $7b5dd06670889591$export$b8b9d90f9e5bd72b),
                    teamName: (0, $7b5dd06670889591$export$d57b6b390e78d90f)
                }
            });
            throw error;
        });
    }, [
        excludedAutocompleteFields,
        fieldsFilter
    ]);

});
parcelRegister("fastT", function(module, exports) {

$parcel$export(module.exports, "fetchWithRetry", () => $a4be334d36a5e60b$export$cffaac380b94df26);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a4be334d36a5e60b$export$cffaac380b94df26 = async (fetchCall, retryAttempts)=>{
    try {
        return await fetchCall();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (retryAttempts > 0) return $a4be334d36a5e60b$export$cffaac380b94df26(fetchCall, retryAttempts - 1);
        throw error;
    }
};

});


parcelRegister("3LacB", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteSuggestions", () => $5c28b34cfba0b2fb$export$b39a9f86c7843060);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");

const $5c28b34cfba0b2fb$export$b39a9f86c7843060 = ()=>{
    return (0, $eJOHy.useCallback)((url)=>(0, $1Ozm9.default)(url).catch((error)=>{
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'getAutocompleteSuggestions',
                    packageName: (0, $7b5dd06670889591$export$b8b9d90f9e5bd72b),
                    teamName: (0, $7b5dd06670889591$export$d57b6b390e78d90f)
                }
            });
            throw error;
        }), []);
};

});

parcelRegister("bOvYj", function(module, exports) {

$parcel$export(module.exports, "useOnHydrate", () => $fc289583ab3a26a9$export$6d016355519acd77);

var $5X5p4 = parcelRequire("5X5p4");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $lvKO5 = parcelRequire("lvKO5");


const $fc289583ab3a26a9$export$f2e498f301ac7cdf = (response)=>{
    if (!response?.jira?.jqlBuilder?.hydrateJqlQuery?.fields) return {};
    const hydratedValues = {};
    response.jira.jqlBuilder.hydrateJqlQuery.fields.forEach((field)=>{
        if (field.values) {
            const fieldValues = [];
            field.values.forEach((valueResult)=>{
                if (valueResult?.values) valueResult.values.forEach((value)=>{
                    if (value?.__typename === 'JiraJqlUserFieldValue') fieldValues.push({
                        type: 'user',
                        id: value.jqlTerm,
                        name: value.displayName,
                        avatarUrl: value.user?.picture ?? ''
                    });
                });
            });
            if (field.field && field.field.searchTemplate) {
                const fieldName = field.field.jqlTerm;
                if ((0, $622e67768f78f9c9$export$3df7f6b39477220a) === field.field.searchTemplate.key) fieldValues.push({
                    type: 'deprecated-field',
                    id: fieldName,
                    deprecatedSearcherKey: field.field.searchTemplate.key
                });
            }
            if (field.field && field.field.searchTemplate) {
                const fieldName = field.field.jqlTerm;
                if ((0, $622e67768f78f9c9$export$f8cba5bda41a61a0) === field.field.searchTemplate.key) fieldValues.push({
                    type: 'deprecated-field',
                    id: fieldName,
                    deprecatedSearcherKey: field.field.searchTemplate.key
                });
            }
            if (fieldValues.length > 0 && field.field) {
                const fieldName = field.field.jqlTerm;
                hydratedValues[fieldName] = fieldValues;
            }
        }
    });
    return hydratedValues;
};
const $fc289583ab3a26a9$export$6d016355519acd77 = (viewContext, scope)=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const { cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    return (0, $eJOHy.useCallback)(async (jql)=>{
        try {
            const data = await (0, $j4oe4.fetchQuery)(environment, (0, $5X5p4.default), {
                jql: jql,
                cloudId: cloudId,
                viewContext: viewContext,
                scope: scope
            }, {
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).toPromise();
            return $fc289583ab3a26a9$export$f2e498f301ac7cdf(data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'useOnHydrateRelay',
                    packageName: (0, $7b5dd06670889591$export$b8b9d90f9e5bd72b),
                    teamName: (0, $7b5dd06670889591$export$d57b6b390e78d90f)
                }
            });
            throw error;
        }
    }, [
        cloudId,
        environment,
        viewContext,
        scope
    ]);
};

});
parcelRegister("5X5p4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecc978805eb79c70$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92e906826477423a1fa87b5612ba3254>>
 * @relayHash 0b456e44a9397ce7756e643321eb4681
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d442b64928804cd27a695f19c4594036a888f67dbe22d5764db67e3820c7402
const $ecc978805eb79c70$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v7 = {
        "concreteType": "JiraJqlField",
        "kind": "LinkedField",
        "name": "field",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "concreteType": "JiraJqlSearchTemplate",
                "kind": "LinkedField",
                "name": "searchTemplate",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    }
                ]
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hydrationRelayJqlBuilderAdvancedQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        v9 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hydrationRelayJqlBuilderAdvancedQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        v9 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ ,
                                                                                                        v10 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "id"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5d442b64928804cd27a695f19c4594036a888f67dbe22d5764db67e3820c7402",
            "metadata": {},
            "name": "hydrationRelayJqlBuilderAdvancedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ecc978805eb79c70$var$node.hash = "73acc033ad6fdea5f965fc59c156d626";
var $ecc978805eb79c70$export$2e2bcd8739ae039 = $ecc978805eb79c70$var$node;

});

const $622e67768f78f9c9$export$3df7f6b39477220a = 'com.pyxis.greenhopper.jira:gh-epic-link-searcher';
const $622e67768f78f9c9$export$f8cba5bda41a61a0 = 'com.atlassian.jpo:jpo-custom-field-parent-searcher';




parcelRegister("e1BYb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f392cf099dd7d8fb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4GZBG = parcelRequire("4GZBG");

var $lHTxM = parcelRequire("lHTxM");
const $f392cf099dd7d8fb$export$791565817c56ef87 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GZBG.JQLBuilderBasicUIWithAnalyticsOld), {
        ...props,
        JQLEditor: (0, $lHTxM.JQLEditorUIWithErrorBoundaryOld)
    });
const $f392cf099dd7d8fb$var$JQLBuilderBasic = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GZBG.default), {
        ...props,
        JQLEditor: (0, $lHTxM.default)
    });
var $f392cf099dd7d8fb$export$2e2bcd8739ae039 = $f392cf099dd7d8fb$var$JQLBuilderBasic;

});

parcelRegister("l5UaK", function(module, exports) {

$parcel$export(module.exports, "JQLDebuggerTriggerButton", () => $68a041f25ac59326$export$a74ff97760ab288d);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $1NG86 = parcelRequire("1NG86");

var $kZSpL = parcelRequire("kZSpL");

var $bQWwW = parcelRequire("bQWwW");
var $eSXqs = parcelRequire("eSXqs");

var $lRq8t = parcelRequire("lRq8t");

var $1KdDN = parcelRequire("1KdDN");

var $bJscI = parcelRequire("bJscI");

var $bUnif = parcelRequire("bUnif");

var $13f5n = parcelRequire("13f5n");

var $hMoNE = parcelRequire("hMoNE");

var $kbhn6 = parcelRequire("kbhn6");

var $6Vq1r = parcelRequire("6Vq1r");

var $gr39h = parcelRequire("gr39h");

const $68a041f25ac59326$var$TriggerButtonWithLogic = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("h4mYu")), {
    moduleId: "./src/packages/jql-builder/jql-debugger/src/ui/trigger-button/trigger-button-content.tsx"
});
function $68a041f25ac59326$export$9504934576e2ed55(props) {
    const { children: children, testId: testId } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { jqlMessages: jqlMessages, onSearch: onSearch } = (0, $gr39h.useJqlDebuggerAdditionalContext)();
    const [debuggerState] = (0, $bUnif.useDebuggerStatus)();
    const [isAiEnabled] = (0, $bUnif.useIsAiEnabled)();
    // A jqlMessage can be error, warning or info
    // We only case about the error scenario
    // Here we map the jqlMessages object list to a list of plain strings
    const errors = (0, $eJOHy.useMemo)(()=>{
        return (0, $hMoNE.jqlMessagesToErrors)(jqlMessages);
    }, [
        jqlMessages
    ]);
    // Do not render the trigger button when:
    // 1. AI is not enabled
    // 2. onSearch callback is not available - i.e. we cannot apply the corrected jql to the editor
    // 3. No validation errors coming from the jql-editor - duuh
    //
    // Special note: Default render is `children` (and not `null`) coz we wanto keep showing the errors
    // For example when AI is not available, we still want to show the errors
    if (!isAiEnabled || !onSearch || !errors?.length) return children;
    if (debuggerState === 'JS_ERROR') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $68a041f25ac59326$var$errorBannerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kZSpL.JiraBanner), {
        messageId: "jql-debugger.ui.trigger-button.banner.error",
        messageType: "transactional",
        appearance: "error",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NG86))), {
            spacing: "spacious",
            label: formatMessage((0, $6Vq1r.default).errorIconLabelNonFinal),
            LEGACY_secondaryColor: "inherit"
        })
    }, formatMessage((0, $6Vq1r.default).jsErrorNonFinal))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $68a041f25ac59326$var$errorComponentStyles
    }, debuggerState === 'INIT' && children, debuggerState === 'INIT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eSXqs.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), null, formatMessage((0, $6Vq1r.default).fixErrorWithAiNonFinal))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($68a041f25ac59326$var$TriggerButtonWithLogic, {
        testId: testId
    })));
}
const $68a041f25ac59326$var$JQLDebuggerTriggerButtonOld = (props)=>{
    const ChildrenFallback = (0, $eJOHy.useCallback)(()=>props.children, [
        props.children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).TRIGGER_BUTTON,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: ChildrenFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($68a041f25ac59326$export$9504934576e2ed55, props));
};
const $68a041f25ac59326$export$a74ff97760ab288d = (0, $bJscI.componentWithFG)('gravityai-2283-jql-debugger-rll-to-entrypoints', (0, $kbhn6.JQLPanelRenderSlotForJQLEditor), $68a041f25ac59326$var$JQLDebuggerTriggerButtonOld);
const $68a041f25ac59326$var$errorComponentStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    rowGap: 'space.025',
    marginBottom: 'space.050'
});
const $68a041f25ac59326$var$errorBannerStyle = (0, $1DXK0.xcss)({
    marginTop: 'space.025',
    marginBottom: 'space.050'
});

});
parcelRegister("kZSpL", function(module, exports) {

$parcel$export(module.exports, "JiraBanner", () => $735e5a31d4bea264$export$23eaf79dd14ebe6e);

var $eJOHy = parcelRequire("eJOHy");

var $7mS2i = parcelRequire("7mS2i");

var $SyPNn = parcelRequire("SyPNn");

var $j2tD5 = parcelRequire("j2tD5");
const $735e5a31d4bea264$export$23eaf79dd14ebe6e = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j2tD5.ChoreographerBanner), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7mS2i.default), rest);
};

});
parcelRegister("j2tD5", function(module, exports) {

$parcel$export(module.exports, "ChoreographerBanner", () => $bc0a43425df5d870$export$d77caaec2153a90b);

var $7mS2i = parcelRequire("7mS2i");

var $1pkzT = parcelRequire("1pkzT");
const $bc0a43425df5d870$export$d77caaec2153a90b = (0, $1pkzT.withChoreographedRender)((0, $7mS2i.default));

});


parcelRegister("13f5n", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_JQL_DEBUGGER", () => $4d08bf51bcedf53e$export$efcb4634ee5c0cb9);
$parcel$export(module.exports, "TEAM_NAME", () => $4d08bf51bcedf53e$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ERROR_BOUNDARY_IDS", () => $4d08bf51bcedf53e$export$2d2d5df8a192a41a);
$parcel$export(module.exports, "CLOSED_AI_MODAL_ABORT_REASON_MESSAGE", () => $4d08bf51bcedf53e$export$8714ae84b437fe97);
$parcel$export(module.exports, "CLOSED_AI_MODAL_ABORT_REASON_NAME", () => $4d08bf51bcedf53e$export$1e71032fcb7b8730);
$parcel$export(module.exports, "JS_ERROR_ABORT_REASON_NAME", () => $4d08bf51bcedf53e$export$64c672172b01336);
$parcel$export(module.exports, "AI_RESULT_ERROR_CATEGORIES", () => $4d08bf51bcedf53e$export$ad3b2223714b1ed9);
const $4d08bf51bcedf53e$export$efcb4634ee5c0cb9 = 'jira-jql-debugger';
const $4d08bf51bcedf53e$export$d57b6b390e78d90f = 'jira-ai-gravity';
const $4d08bf51bcedf53e$export$2d2d5df8a192a41a = {
    TRIGGER_BUTTON: 'jira-jql-debugger-trigger-button',
    FIX_WITH_AI_MODAL: 'jira-jql-debugger-fix-with-ai-modal',
    COMMON_ENTRY_JQL_BUILDER: 'jira-jql-debugger-common-entry-jql-builder',
    COMMON_ENTRY_ISSUE_VIEW: 'jira-jql-debugger-common-entry-issue-view'
};
const $4d08bf51bcedf53e$export$8714ae84b437fe97 = 'AI Modal was closed before the fetch completed';
const $4d08bf51bcedf53e$export$1e71032fcb7b8730 = 'AI_MODAL_CLOSED';
const $4d08bf51bcedf53e$export$64c672172b01336 = 'JS_ERROR';
const $4d08bf51bcedf53e$export$ad3b2223714b1ed9 = {
    FIXED_JQL_HAS_ERRORS: 'fixed-jql-has-errors',
    SERVER_ERROR: 'server-error'
};

});

parcelRegister("hMoNE", function(module, exports) {

$parcel$export(module.exports, "jqlMessagesToErrors", () => $7a67109f6acf81f3$export$c96be9b8b5cbea61);
function $7a67109f6acf81f3$export$c96be9b8b5cbea61(jqlMessages) {
    return jqlMessages?.filter((message)=>message.type === 'error').map((message)=>message.message?.toString()).filter(Boolean);
}

});

parcelRegister("kbhn6", function(module, exports) {

$parcel$export(module.exports, "JQLPanelRenderSlotForJQLEditor", () => $30ee3d17c3a559f0$export$79179285687e80ca);
$parcel$export(module.exports, "JQLPanelRenderSlotForIssueView", () => $30ee3d17c3a559f0$export$1efeb13e93a829bf);

var $eJOHy = parcelRequire("eJOHy");

var $1DXK0 = parcelRequire("1DXK0");

var $880Uc = parcelRequire("880Uc");

var $fUDzs = parcelRequire("fUDzs");

var $1KdDN = parcelRequire("1KdDN");

var $bUnif = parcelRequire("bUnif");

var $lfAG2 = parcelRequire("lfAG2");

var $k0Jpn = parcelRequire("k0Jpn");

var $13f5n = parcelRequire("13f5n");

var $lg8UF = parcelRequire("lg8UF");
function $30ee3d17c3a559f0$var$JqlDebuggerLayoutSwitcher(props) {
    const layoutQuery = props.fullWidthLayout ? 'below.lg' : 'above.lg';
    const showProp = (0, $eJOHy.useMemo)(()=>props.fullWidthLayout ? {
            below: 'lg'
        } : {
            above: 'lg'
        }, [
        props.fullWidthLayout
    ]);
    const [matches, setMatches] = (0, $eJOHy.useState)(null);
    const mq = (0, $fUDzs.UNSAFE_useMediaQuery)(layoutQuery, (e)=>{
        setMatches(e.matches);
    });
    return matches ?? mq?.matches ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $880Uc.Show), {
        ...showProp,
        xcss: props.xcss ? [
            $30ee3d17c3a559f0$var$showContainerStyles,
            props.xcss
        ] : $30ee3d17c3a559f0$var$showContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k0Jpn.JQLDebuggerCommonEntry), null)) : null;
}
const $30ee3d17c3a559f0$export$793a24421ebe4e74 = (props)=>{
    const { errorMessages: errorMessages, testId: testId, validationId: validationId } = props;
    const jqlDebuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const [isReady] = (0, $lfAG2.useIsContextReady)();
    const renderSyncActions = (0, $lfAG2.useRenderSynchronizerStoreActions)();
    const [isAiEnabled] = (0, $bUnif.useIsAiEnabled)();
    const [status] = (0, $bUnif.useDebuggerStatus)();
    /**
	 * When the JQL Editor unmounts for whatever reason, we want to mark jql editor as not ready
	 * So that JQLPanelRenderSlotForIssueView doesn't try to accidentally render any error messages
	 *
	 * For example, this happens when we enter NL-to-JQL AI mode while the regular JQL editor has an error
	 */ (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            renderSyncActions.setJqlEditorReady(false);
        };
    }, [
        renderSyncActions
    ]);
    if (!errorMessages?.length || !isReady || !isAiEnabled || status === 'UNRECOVERABLE_ERROR') {
        renderSyncActions.setJqlEditorReady(false);
        return props.children;
    }
    jqlDebuggerStoreActions.setJqlErrors(errorMessages.map((0, $lg8UF.extractTextFromReactElement)));
    jqlDebuggerStoreActions.setErrorComponentTestId(testId);
    jqlDebuggerStoreActions.setErrorComponentValidationId(validationId);
    renderSyncActions.setJqlEditorReady(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($30ee3d17c3a559f0$var$JqlDebuggerLayoutSwitcher, {
        fullWidthLayout: false,
        xcss: $30ee3d17c3a559f0$var$jqlBuilderContainerStyles
    });
};
const $30ee3d17c3a559f0$export$79179285687e80ca = (props)=>{
    const { children: children } = props;
    const ChildrenFallback = (0, $eJOHy.useCallback)(()=>children, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).COMMON_ENTRY_JQL_BUILDER,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: ChildrenFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($30ee3d17c3a559f0$export$793a24421ebe4e74, props));
};
const $30ee3d17c3a559f0$export$1efeb13e93a829bf = ()=>{
    const [isReady] = (0, $lfAG2.useIsContextReady)();
    const [isJqlEditorReady] = (0, $lfAG2.useIsJqlEditorReady)();
    const storeActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    if (!isReady || !isJqlEditorReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).COMMON_ENTRY_ISSUE_VIEW,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: ()=>null,
        onError: ()=>{
            storeActions.setStatus('UNRECOVERABLE_ERROR');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($30ee3d17c3a559f0$var$JqlDebuggerLayoutSwitcher, {
        fullWidthLayout: true,
        xcss: $30ee3d17c3a559f0$var$issueViewContainerStyles
    }));
};
const $30ee3d17c3a559f0$var$jqlBuilderContainerStyles = (0, $1DXK0.xcss)({
    // When we are rendering in JQL builder, we want to add the space between the editor and panel
    // This space is already present in the issue view
    marginTop: 'space.100'
});
const $30ee3d17c3a559f0$var$issueViewContainerStyles = (0, $1DXK0.xcss)({
    // When we are rendering in JQL builder, we want to add the space between the editor and panel
    // This space is already present in the issue view
    marginTop: 'space.negative.100'
});
const $30ee3d17c3a559f0$var$showContainerStyles = (0, $1DXK0.xcss)({
    width: '100%',
    marginBottom: 'space.100'
});

});
parcelRegister("880Uc", function(module, exports) {

$parcel$export(module.exports, "Show", () => $f800bab042621a59$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $1DXK0 = parcelRequire("1DXK0");

var $j14qM = parcelRequire("j14qM");
function $f800bab042621a59$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f800bab042621a59$var$showAboveQueries = (0, $j14qM.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $f800bab042621a59$var$showBelowQueries = (0, $j14qM.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $f800bab042621a59$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $f800bab042621a59$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1DXK0.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $1NIU8.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $f800bab042621a59$var$defaultHiddenStyles,
            above && $f800bab042621a59$var$showAboveQueries[above],
            below && $f800bab042621a59$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("j14qM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $58139abb853d4481$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $58139abb853d4481$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $fvncH = parcelRequire("fvncH");

var $6efFi = parcelRequire("6efFi");
const $58139abb853d4481$export$918f8818cfbbeb2c = (input)=>{
    return (0, $fvncH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $6efFi.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $58139abb853d4481$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $fvncH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $6efFi.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("fvncH", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $5a3422a08c082ecc$export$2d293d9871c38e91);
const $5a3422a08c082ecc$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $5a3422a08c082ecc$export$2d293d9871c38e91 = Object.keys($5a3422a08c082ecc$export$e5ee4fe8b989fd09);
const $5a3422a08c082ecc$export$b7ed752a57b4177b = $5a3422a08c082ecc$export$2d293d9871c38e91[0];

});



parcelRegister("lfAG2", function(module, exports) {

$parcel$export(module.exports, "useRenderSynchronizerStoreActions", () => $7b22efe6dcaae164$export$60f8cec0dff6824c);
$parcel$export(module.exports, "useIsContextReady", () => $7b22efe6dcaae164$export$7668b8e8d8c22896);
$parcel$export(module.exports, "useIsJqlEditorReady", () => $7b22efe6dcaae164$export$7f34a2b12380537d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $7b22efe6dcaae164$var$initialState = {
    isContextReady: false,
    isJqlEditorReady: false
};
const $7b22efe6dcaae164$var$Store = (0, $GtRbT.createStore)({
    initialState: $7b22efe6dcaae164$var$initialState,
    actions: {
        setIsContextReady: (isContextReady)=>({ setState: setState })=>{
                setState({
                    isContextReady: isContextReady
                });
            },
        setJqlEditorReady: (isJqlEditorReady)=>({ setState: setState })=>{
                setState({
                    isJqlEditorReady: isJqlEditorReady
                });
            }
    }
});
const $7b22efe6dcaae164$export$60f8cec0dff6824c = (0, $iJq0l.createActionsHook)($7b22efe6dcaae164$var$Store);
const $7b22efe6dcaae164$export$7668b8e8d8c22896 = (0, $iJq0l.createHook)($7b22efe6dcaae164$var$Store, {
    selector: (state)=>state.isContextReady
});
const $7b22efe6dcaae164$export$7f34a2b12380537d = (0, $iJq0l.createHook)($7b22efe6dcaae164$var$Store, {
    selector: (state)=>state.isJqlEditorReady
});

});

parcelRegister("k0Jpn", function(module, exports) {

$parcel$export(module.exports, "JQLDebuggerCommonEntry", () => $182505dbe4321118$export$61b6653f41aa971b);

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $9skjA = parcelRequire("9skjA");

var $bbdV2 = parcelRequire("bbdV2");

var $cBavF = parcelRequire("cBavF");

var $ftN6c = parcelRequire("ftN6c");

var $epTsa = parcelRequire("epTsa");

var $bUnif = parcelRequire("bUnif");

var $bqGal = parcelRequire("bqGal");

var $iNmbB = parcelRequire("iNmbB");

var $13f5n = parcelRequire("13f5n");

var $awW5u = parcelRequire("awW5u");
function $182505dbe4321118$var$OnError() {
    const debuggerActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    (0, $eJOHy.useEffect)(()=>{
        // On error, set the feature state to be JS_ERROR, so that such scenarios can be handled without
        // interfering with the feature initial state nor with the AI event instrumentation
        debuggerActions.setStatus('JS_ERROR');
    }, [
        debuggerActions
    ]);
    return null;
}
const $182505dbe4321118$export$61b6653f41aa971b = ()=>{
    const [status] = (0, $bUnif.useDebuggerStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const debuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const [query] = (0, $bUnif.useJqlQuery)();
    const [jqlErrors] = (0, $bUnif.useJqlErrors)();
    const [onSearch] = (0, $bUnif.useJqlEditorOnSearch)();
    const [isReadyForProactive] = (0, $bUnif.useIsReadyForProactive)();
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $bbdV2.useEntryPoint)((0, $iNmbB.SuggestedFixContentEntrypoint), {});
    // For the proactive experience, we call the API through a useEffect for each applicable render
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) {
            if (status === 'INIT') {
                if (!isReadyForProactive) (0, $awW5u.preloadApiCall)(query, jqlErrors);
                else (0, $awW5u.onClick)({
                    testId: 'jql-debugger-common-entry',
                    createAnalyticsEvent: createAnalyticsEvent,
                    debuggerStoreActions: debuggerStoreActions,
                    query: query,
                    jqlErrors: jqlErrors,
                    onSearch: onSearch,
                    isReadyForProactive: isReadyForProactive
                });
            }
        }
    }, [
        isReadyForProactive,
        status,
        createAnalyticsEvent,
        debuggerStoreActions,
        jqlErrors,
        onSearch,
        query
    ]);
    /*
		We load the entrypoint conditionally here as the JQL debugger panel is rendered underneath the JQL builder for large screen sizes,
		and across the issue view for smaller screen sizes - their visibilty is controlled by a <Show>, but they are two separately
		rendered components. As a result, if we are switching from one screen size or issue view to another, the newly rendered version of the
		JQL debugger will not have a loaded entry point, so we load it here to ensure the content is still visible across different views.

		Example of behaviour without this conditional:
		https://www.loom.com/share/725438e2ea16481591bbe510815e9ca3?sid=b3dc286e-9c37-4cf9-a2c9-f55d3561a166
	*/ if (status !== 'INIT') entryPointActions?.load();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9skjA.default), {
        spacing: "none",
        hasNewBorderExperience: true,
        shouldFitContainer: true,
        isLoading: status === 'LOADING_RESULT'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        padding: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bqGal.ErrorSection), {
        entryPointActions: entryPointActions
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).FIX_WITH_AI_MODAL,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: null,
        errorFallback: $182505dbe4321118$var$OnError
    }));
};

});
parcelRegister("9skjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c22c6f11d6c3191$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $58yRG = parcelRequire("58yRG");

var $dPMMf = parcelRequire("dPMMf");

var $7jTnu = parcelRequire("7jTnu");
let $7c22c6f11d6c3191$var$namespaceUUID = 0;
const $7c22c6f11d6c3191$var$newPalette = {
    dark: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    },
    light: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    }
};
const $7c22c6f11d6c3191$var$AFTER_LOAD_DURATION = 3000;
const $7c22c6f11d6c3191$var$AnimatedSvgContainer = ({ isLoading: isLoading, isBlurred: isBlurred, isShadow: isShadow, isBorderGrey: isBorderGrey, hasNewBorderExperience: hasNewBorderExperience })=>{
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const svgRef = (0, $eJOHy.useRef)(null);
    const namespaceId = (0, $eJOHy.useRef)();
    const [showRainbowBorder, setShowRainbowBorder] = (0, $eJOHy.useState)(false);
    const paletteForTheme = colorMode === 'dark' ? $7c22c6f11d6c3191$var$newPalette.dark : $7c22c6f11d6c3191$var$newPalette.light;
    if (namespaceId.current === undefined) {
        namespaceId.current = $7c22c6f11d6c3191$var$namespaceUUID; // eslint-disable-next-line react-hooks/react-compiler
        $7c22c6f11d6c3191$var$namespaceUUID += 1;
    }
    (0, $eJOHy.useEffect)(()=>{
        if (isLoading) {
            const svg = svgRef.current;
            hasNewBorderExperience && setShowRainbowBorder(true); // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isLoading,
        hasNewBorderExperience
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // we keep the rainbow border without animations for at 3 seconds after load. After that we show the grey border
        if (hasNewBorderExperience && !isLoading && showRainbowBorder) {
            const timeoutId = setTimeout(()=>setShowRainbowBorder(false), $7c22c6f11d6c3191$var$AFTER_LOAD_DURATION);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        hasNewBorderExperience,
        showRainbowBorder,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c22c6f11d6c3191$var$SvgContainer, {
        isBlurred: isBlurred,
        isShadow: isShadow,
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), isBorderGrey || hasNewBorderExperience && !showRainbowBorder && !isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M0 0h24v24H0Z",
        vectorEffect: "non-scaling-stroke"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    }))));
};
const $7c22c6f11d6c3191$var$AIContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isLoading: isLoading, isShadow: isShadow = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', testId: testId, isBorderGrey: isBorderGrey, components: { ContainerComponent: ContainerComponent = $7c22c6f11d6c3191$var$Container, ContentComponent: ContentComponent = $7c22c6f11d6c3191$var$Content } = {}, hasNewBorderExperience: hasNewBorderExperience = false, borderless: borderless = false, zIndex: zIndex = (0, $dPMMf.layers).card }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContainerComponent, {
        "data-testid": testId,
        shouldFitContainer: shouldFitContainer,
        zIndex: zIndex
    }, (!(0, $7jTnu.fg)('similar_items_in_gic_ui_fixes') || !borderless) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c22c6f11d6c3191$var$AnimatedSvgContainer, {
        isShadow: isShadow,
        isLoading: isLoading,
        isBorderGrey: isBorderGrey,
        hasNewBorderExperience: hasNewBorderExperience
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c22c6f11d6c3191$var$AnimatedSvgContainer, {
        isLoading: isLoading,
        isBlurred: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContentComponent, {
        ref: ref,
        spacing: spacing
    }, children));
});
var $7c22c6f11d6c3191$export$2e2bcd8739ae039 = $7c22c6f11d6c3191$var$AIContainer;
$7c22c6f11d6c3191$var$AIContainer.displayName = 'AIContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainer: shouldFitContainer, zIndex: zIndex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w1vr8s": (0, $awdRS.default)(__cmplp.zIndex || (0, $dPMMf.layers).card)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1pbypt6a",
            __cmplp.shouldFitContainer ? "_1bsb1wug" : "_1bsb1ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w1vr8s": (0, $awdRS.default)(__cmplp.zIndex || (0, $dPMMf.layers).card)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoi2wt _bfhkvuon _16jlkb7n _1pbypt6a _1bsb1osq",
            __cmplp.spacing === 'default' && "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7c22c6f11d6c3191$export$71abc632aa29e6fe = {
    ContainerComponent: $7c22c6f11d6c3191$var$Container,
    ContentComponent: $7c22c6f11d6c3191$var$Content
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$SvgContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShadow: isShadow, isBlurred: isBlurred, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoftgi _kqswstnw",
            __cmplp.isShadow ? "_16qs9g9j" : "_16qsglyw",
            __cmplp.isBlurred ? "_1bsb5cnj _4t3i5cnj _154iu2gc _1ltvu2gc _kdam7b89" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bqGal", function(module, exports) {

$parcel$export(module.exports, "ErrorSection", () => $a9f0cd966e577c81$export$b0bceea2ea86179a);

var $eJOHy = parcelRequire("eJOHy");

var $6zhpo = parcelRequire("6zhpo");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $80DPg = parcelRequire("80DPg");

var $jdqdp = parcelRequire("jdqdp");

var $Ay1uj = parcelRequire("Ay1uj");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $9n5mq = parcelRequire("9n5mq");

var $f6eza = parcelRequire("f6eza");

var $bUnif = parcelRequire("bUnif");

var $kCNym = parcelRequire("kCNym");

var $fHqkT = parcelRequire("fHqkT");
function $a9f0cd966e577c81$export$b0bceea2ea86179a(props) {
    const { entryPointActions: entryPointActions } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [query] = (0, $bUnif.useJqlQuery)();
    const [status] = (0, $bUnif.useDebuggerStatus)();
    const [jqlErrors] = (0, $bUnif.useJqlErrors)();
    const [onSearch] = (0, $bUnif.useJqlEditorOnSearch)();
    const [errorComponentTestId] = (0, $bUnif.useErrorComponentTestId)();
    const [errorComponentValidationId] = (0, $bUnif.useErrorComponentValidationId)();
    const jqlDebuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const [{ syntaxCorrectionAttemptErrors: syntaxCorrectionAttemptErrors, singleInstrumentationID: singleInstrumentationID }] = (0, $bUnif.useStoreData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isReadyForProactive] = (0, $bUnif.useIsReadyForProactive)();
    const showDiscardButton = status === 'VIEW_RESULT' || status === 'RESULT_ERROR';
    // The Fix error button should be shown when:
    // The user has not invoked any action to make the experience ready for proactive, or
    // the user returns from dismissing a proactive AI result
    const showFixErrorButton = status === 'RESULT_DISCARDED' || status === 'INIT' && !isReadyForProactive;
    const onDiscardClick = ()=>{
        // The close button can be clicked from either a succesful result view, or an error view (server error or JQL couldn't be corrected)
        const closedFromSource = status === 'RESULT_ERROR' || status === 'VIEW_RESULT' && syntaxCorrectionAttemptErrors.length > 0 ? 'error_view' : 'result_view';
        // Fire `aiResult discarded` event when the close button is clicked in a successful result view
        // https://atlassian.slack.com/archives/C07B7SJR0CT/p1744736278862629?thread_ts=1744328109.644489&cid=C07B7SJR0CT
        if (status === 'VIEW_RESULT' && syntaxCorrectionAttemptErrors.length === 0) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult discarded', {
            ...(0, $9n5mq.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                    isReadyForProactive: isReadyForProactive
                } : {}
            })
        });
        // Fire an event for the close button being clicked in all cases
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'closeButton clicked', 'jqlDebugger', {
            closedFromSource: closedFromSource
        });
        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) jqlDebuggerStoreActions.setStatus('RESULT_DISCARDED');
        else jqlDebuggerStoreActions.setStatus('INIT');
    };
    if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200",
        xcss: $a9f0cd966e577c81$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "start",
        spread: "space-between",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "h5",
        xcss: $a9f0cd966e577c81$var$jqlErrorHeadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        color: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        weight: "bold"
    }, formatMessage(jqlErrors?.length > 1 ? (0, $fHqkT.default).jqlDebuggerHeadingPluralNonFinal : (0, $fHqkT.default).jqlDebuggerHeadingNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: errorComponentTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "alert",
        id: errorComponentValidationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "ul",
        xcss: $a9f0cd966e577c81$var$errorBoxStyles,
        testId: "jql-debugger.ui.error-section.error-list"
    }, jqlErrors.map((error)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "li",
            key: error,
            xcss: $a9f0cd966e577c81$var$listItemStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            color: "color.text.accent.red"
        }, error))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button') ? $a9f0cd966e577c81$var$headerEndStylesWithCross : $a9f0cd966e577c81$var$headerEndStyles
    }, status === 'VIEW_RESULT' && !(0, $7jTnu.fg)('gravityai-3165-jql-fixer-ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $fHqkT.default).betaLozenge)) : null, showFixErrorButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f6eza.FixErrorButton), {
        testId: "jql-debugger.ui.error-section.trigger-button",
        jqlErrors: jqlErrors,
        onSearch: onSearch,
        query: query,
        entryPointActions: entryPointActions
    }), (0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button') ? showDiscardButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        testId: "jql-debugger.ui.error-section.close-button",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $fHqkT.default).discardSuggestionNonFinal),
        onClick: onDiscardClick,
        isTooltipDisabled: false
    }) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200",
        xcss: $a9f0cd966e577c81$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "start",
        spread: "space-between",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "h5",
        xcss: $a9f0cd966e577c81$var$jqlErrorHeadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        color: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        weight: "bold"
    }, formatMessage(jqlErrors?.length > 1 ? (0, $fHqkT.default).jqlDebuggerHeadingPluralNonFinal : (0, $fHqkT.default).jqlDebuggerHeadingNonFinal))), status === 'LOADING_RESULT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kCNym.GeneratingAnimation), {
        alt: formatMessage((0, $fHqkT.default).jqlDebuggerLoadingNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), null, formatMessage((0, $fHqkT.default).jqlDebuggerLoadingNonFinal))) : // The wrappers around the ul element try to closely resemble the same structure as the default error message in the platform package
    // See: platform/packages/jql/jql-editor/src/ui/jql-editor-footer-content/jql-messages/errors/index.tsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: errorComponentTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "alert",
        id: errorComponentValidationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "ul",
        xcss: $a9f0cd966e577c81$var$errorBoxStyles,
        testId: "jql-debugger.ui.error-section.error-list"
    }, jqlErrors.map((error)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            as: "li",
            key: error,
            xcss: $a9f0cd966e577c81$var$listItemStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            color: "color.text.accent.red"
        }, error))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button') ? $a9f0cd966e577c81$var$headerEndStylesWithCross : $a9f0cd966e577c81$var$headerEndStyles
    }, status === 'VIEW_RESULT' && !(0, $7jTnu.fg)('gravityai-3165-jql-fixer-ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $fHqkT.default).betaLozenge)) : null, status === 'INIT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f6eza.FixErrorButton), {
        testId: "jql-debugger.ui.error-section.trigger-button",
        jqlErrors: jqlErrors,
        onSearch: onSearch,
        query: query,
        entryPointActions: entryPointActions
    }), (0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button') ? showDiscardButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        testId: "jql-debugger.ui.error-section.close-button",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $fHqkT.default).discardSuggestionNonFinal),
        onClick: onDiscardClick,
        isTooltipDisabled: false
    }) : null));
}
const $a9f0cd966e577c81$var$containerStyles = (0, $1DXK0.xcss)({
    minHeight: "var(--ds-space-400, 32px)"
});
const $a9f0cd966e577c81$var$errorBoxStyles = (0, $1DXK0.xcss)({
    flex: 1,
    marginBlockStart: '0',
    paddingInlineStart: 'space.025'
});
const $a9f0cd966e577c81$var$headerEndStyles = (0, $1DXK0.xcss)({
    alignSelf: 'flex-start'
});
const $a9f0cd966e577c81$var$headerEndStylesWithCross = (0, $1DXK0.xcss)({
    alignSelf: 'flex-start',
    display: 'flex',
    gap: 'space.075',
    alignItems: 'center'
});
const $a9f0cd966e577c81$var$listItemStyle = (0, $1DXK0.xcss)({
    listStyle: 'none'
});
const $a9f0cd966e577c81$var$jqlErrorHeadingStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    gap: 'space.075'
});

});
parcelRegister("9n5mq", function(module, exports) {

$parcel$export(module.exports, "getAiAttributes", () => $93c2edddc4531c15$export$1dc69577c8d8f632);
function $93c2edddc4531c15$export$1dc69577c8d8f632({ singleInstrumentationID: singleInstrumentationID, isReadyForProactive: isReadyForProactive = false }) {
    const userGeneratedAI = isReadyForProactive ? 0 : 1;
    const proactiveAIGenerated = isReadyForProactive ? 1 : 0;
    return {
        aiFeatureName: 'JQL_Debugger',
        userGeneratedAI: userGeneratedAI,
        proactiveAIGenerated: proactiveAIGenerated,
        isAIFeature: 1,
        singleInstrumentationID: singleInstrumentationID
    };
}

});

parcelRegister("f6eza", function(module, exports) {

$parcel$export(module.exports, "FixErrorButton", () => $048c101372748c1a$export$94f98890cd333316);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $gn1zL = parcelRequire("gn1zL");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bUnif = parcelRequire("bUnif");

var $29xoF = parcelRequire("29xoF");

function $048c101372748c1a$var$useImportOnClickHandler() {
    const importer = (0, $eJOHy.useCallback)(()=>{
        return Promise.resolve((parcelRequire("awW5u")));
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        importer();
    }, [
        importer
    ]);
    return importer;
}
function $048c101372748c1a$export$94f98890cd333316(props) {
    const { testId: testId, jqlErrors: jqlErrors, onSearch: onSearch, query: query, entryPointActions: entryPointActions } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const debuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const importer = $048c101372748c1a$var$useImportOnClickHandler();
    const [isReadyForProactive] = (0, $bUnif.useIsReadyForProactive)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fixWithAiButton viewed', {
            debuggerPanel: true
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gn1zL))),
        onMouseOver: ()=>{
            entryPointActions?.preload();
        },
        testId: "jql-debugger.ui.fix-error-button.button",
        onClick: async ()=>{
            entryPointActions?.load();
            const { onClick: onClick } = await importer();
            onClick({
                testId: testId,
                query: query || '',
                jqlErrors: jqlErrors,
                onSearch: onSearch,
                createAnalyticsEvent: createAnalyticsEvent,
                debuggerStoreActions: debuggerStoreActions,
                isReadyForProactive: isReadyForProactive
            });
        }
    }, formatMessage((0, $29xoF.default).fixErrorWithAiNonFinal));
}

});
parcelRegister("29xoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fbc607cb38fb1a6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4fbc607cb38fb1a6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    fixErrorWithAiNonFinal: {
        "id": "jql-debugger.trigger-button.fix-error-with-ai-non-final",
        "defaultMessage": "Fix error"
    },
    jsErrorNonFinal: {
        "id": "jql-debugger.trigger-button.js-error-non-final",
        "defaultMessage": "Something went wrong"
    },
    errorIconLabelNonFinal: {
        "id": "jql-debugger.trigger-button.error-icon-label-non-final",
        "defaultMessage": "Error Icon"
    }
});

});

parcelRegister("awW5u", function(module, exports) {

$parcel$export(module.exports, "endpoint", () => $bfd85cc389cc53db$export$125e2b775860041f);
$parcel$export(module.exports, "apiCache", () => $bfd85cc389cc53db$export$fd9779c86130d7b0);
$parcel$export(module.exports, "preloadApiCall", () => $bfd85cc389cc53db$export$2797ffd2e0fc155);
$parcel$export(module.exports, "onClick", () => $bfd85cc389cc53db$export$1d5a917feb871989);

var $aXKmr = parcelRequire("aXKmr");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $9n5mq = parcelRequire("9n5mq");

var $13f5n = parcelRequire("13f5n");

var $gPSc4 = parcelRequire("gPSc4");

var $gJUBb = parcelRequire("gJUBb");
const $bfd85cc389cc53db$export$125e2b775860041f = (0, $gPSc4.createConvoAiEndpoint)({
    url: '/gateway/api/assist/api/v1/plugin/execute',
    method: 'POST',
    experienceId: 'jira-nl-to-jql-errors',
    product: 'jira'
});
const $bfd85cc389cc53db$export$fd9779c86130d7b0 = (0, $gJUBb.LruCache)();
const $bfd85cc389cc53db$export$2797ffd2e0fc155 = (query, jqlErrors, abortController = new AbortController())=>{
    const promise = $bfd85cc389cc53db$export$fd9779c86130d7b0.get(query)?.value || $bfd85cc389cc53db$export$125e2b775860041f({
        name: 'jirajqldebug',
        schema: {
            type: 'jirajqldebug',
            userQuery: query,
            userQueryError: jqlErrors?.join('. \n') || ''
        }
    }, {
        abortControllerSignal: abortController.signal
    });
    $bfd85cc389cc53db$export$fd9779c86130d7b0.set(query, promise);
    return promise;
};
async function $bfd85cc389cc53db$export$1d5a917feb871989({ testId: testId, createAnalyticsEvent: createAnalyticsEvent, query: query, debuggerStoreActions: debuggerStoreActions, jqlErrors: jqlErrors, onSearch: onSearch, isReadyForProactive: isReadyForProactive = false }) {
    const singleInstrumentationID = (0, $aXKmr.v4)();
    try {
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction initiated', (0, $9n5mq.getAiAttributes)({
            singleInstrumentationID: singleInstrumentationID,
            ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                isReadyForProactive: isReadyForProactive
            } : {}
        }));
        const abortController = new AbortController();
        // When we trigger the JQL Debugger within NL-to-JQL, we want to exit the natural language mode
        // This is because two AI features cannot be nested within each other
        // Attempting to show two AI features at once also interferes with non functional aspects such as loading states, analytics and feedback collector
        debuggerStoreActions.exitNaturalLanguageMode();
        debuggerStoreActions.setStateOnFeatureInvoke({
            jqlQuery: query,
            singleInstrumentationID: singleInstrumentationID,
            errorSectionTestId: testId
        });
        // Register callback to be called when there is a javascript error
        // Currently all it does is aborting any pending API calls
        debuggerStoreActions.setOnJsError(()=>{
            abortController?.abort(new DOMException((0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_MESSAGE), (0, $13f5n.JS_ERROR_ABORT_REASON_NAME)));
        });
        // Register callback to be used when the AI modal is dismissed
        debuggerStoreActions.setOnAiInteractionDismissed((dismissReason, status)=>{
            // Abort any pending API calls
            abortController?.abort(new DOMException((0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_MESSAGE), (0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_NAME)));
            if ((0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button')) {
                // When a successful result is shown, the AI result is discarded, not dismissed by definition on
                // single instrumentation docs: https://hello.atlassian.net/wiki/x/gqTA4
                if (status === 'VIEW_RESULT') (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult discarded', {
                    ...(0, $9n5mq.getAiAttributes)({
                        singleInstrumentationID: singleInstrumentationID,
                        ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                            isReadyForProactive: isReadyForProactive
                        } : {}
                    })
                });
                else // Fire the singleInstrumentation event
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction dismissed', {
                    ...(0, $9n5mq.getAiAttributes)({
                        singleInstrumentationID: singleInstrumentationID,
                        ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                            isReadyForProactive: isReadyForProactive
                        } : {}
                    }),
                    dismissReason: dismissReason
                });
            } else // Fire the singleInstrumentation event
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction dismissed', {
                ...(0, $9n5mq.getAiAttributes)({
                    singleInstrumentationID: singleInstrumentationID,
                    ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                        isReadyForProactive: isReadyForProactive
                    } : {}
                }),
                dismissReason: dismissReason
            });
        });
        let response = null;
        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) {
            const promise = $bfd85cc389cc53db$export$2797ffd2e0fc155(query, jqlErrors, abortController);
            response = await promise;
        } else response = await $bfd85cc389cc53db$export$125e2b775860041f({
            name: 'jirajqldebug',
            schema: {
                type: 'jirajqldebug',
                userQuery: query,
                userQueryError: jqlErrors?.join('. \n') || ''
            }
        }, {
            abortControllerSignal: abortController?.signal
        });
        /**
		 * Set the API response data on the store, so that the data can be consumed by the JQLDebuggerRenderSlot
		 *
		 * This is because the trigger and the render slot are used in two different packages
		 *  - Trigger is rendered inside the JQL Builder
		 *  - Render slot is in Issue Navigator
		 *
		 * By keeping these two components loosely coupled, we can style them independent of each other
		 * Yet they are highly cohesive, so that one can be controlled by the other by updating data on the store
		 *
		 * This approach also allows us to minimise the javascript bundles loaded for each component in their specific circumstances
		 * For example, the render-slot chunk is not loaded until the users hover over the trigger button
		 * Similarly the trigger-button chunk is not loaded unless there are errors in the jql-editor
		 */ const syntaxCorrectionAttemptErrors = response?.metadata?.value?.errors || [];
        if (syntaxCorrectionAttemptErrors.length) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', {
            ...(0, $9n5mq.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                    isReadyForProactive: isReadyForProactive
                } : {}
            }),
            aiResultErrorCategory: (0, $13f5n.AI_RESULT_ERROR_CATEGORIES).FIXED_JQL_HAS_ERRORS
        });
        debuggerStoreActions.setJqlErorCorrectionData({
            userQueryError: jqlErrors || [],
            onSearch: onSearch || (()=>undefined),
            jqlDiffTokens: response?.metadata?.value?.diff || [],
            syntaxCorrectionAttemptErrors: syntaxCorrectionAttemptErrors
        });
    } catch (e) {
        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) $bfd85cc389cc53db$export$fd9779c86130d7b0.delete(query);
        const isNetworkCallAbort = e instanceof DOMException;
        (0, $gYnSx.default)({
            event: createAnalyticsEvent({}),
            meta: {
                id: 'JQL_Debugger',
                packageName: '@atlassian/jira-jql-debugger',
                teamName: 'gravity-ai'
            },
            attributes: {
                ...(0, $9n5mq.getAiAttributes)({
                    singleInstrumentationID: singleInstrumentationID,
                    ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                        isReadyForProactive: isReadyForProactive
                    } : {}
                }),
                isNetworkCallAbort: isNetworkCallAbort
            },
            error: e instanceof Error ? e : undefined,
            // When the network call is aborted due to dismissing the modal, then we don't want to send the error to Sentry as
            // it is not necessarily an error (e.g, a user could simply be searching for a different query)
            skipSentry: isNetworkCallAbort && e.name === (0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_NAME)
        });
        if (isNetworkCallAbort) {
            // When network call is aborted due to a javascript error, then don't change the feature state
            if (e.name === (0, $13f5n.JS_ERROR_ABORT_REASON_NAME)) return;
            // When network call is aborted due to dismissing the modal, then we reset the feature state to initial state
            if (e.name === (0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_NAME)) {
                debuggerStoreActions.resetStatus('NETWORK_CALL_ABORT');
                return;
            }
        }
        // Do not fire the unified ai anlytics event for aiResult error when the API call is aborted
        // i.e. the interaction was dismissed, but not necessarily resulted in an error
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', {
            ...(0, $9n5mq.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                    isReadyForProactive: isReadyForProactive
                } : {}
            }),
            aiResultErrorCategory: (0, $13f5n.AI_RESULT_ERROR_CATEGORIES).SERVER_ERROR
        });
        // Explicitly update the status to be RESULT_ERROR in the fallthrough case
        debuggerStoreActions.setStatus('RESULT_ERROR');
    }
}

});
parcelRegister("gPSc4", function(module, exports) {

$parcel$export(module.exports, "createConvoAiEndpoint", () => $78102f89db9e576c$export$f8ba6757167c2aba);
const $78102f89db9e576c$export$f8ba6757167c2aba = (initArgs)=>async (body, options)=>{
        const response = await fetch(initArgs.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': initArgs.product,
                'X-Experience-Id': initArgs.experienceId
            },
            body: JSON.stringify(body),
            signal: options.abortControllerSignal
        });
        if (!response.ok) throw new Error(`API call failed: ${response.status}`);
        const result = await response.json();
        return result;
    };

});

parcelRegister("gJUBb", function(module, exports) {

$parcel$export(module.exports, "LruCache", () => $3a4833cdaf1c1f06$export$ec63a4108685a0aa);
function $3a4833cdaf1c1f06$export$ec63a4108685a0aa(limit = 5) {
    const cache = new Map();
    return {
        get: (key)=>cache.get(key),
        set: (key, value)=>{
            cache.set(key, {
                lastAccessed: Date.now(),
                value: value
            });
            if (cache.size <= limit) return;
            // limit the cache size based on the oldest entry based on lastAccessed time
            let oldestKey = null;
            let oldestLastAccessed = null;
            for (const [key_, value_] of cache.entries())if (oldestLastAccessed === null || value_.lastAccessed < oldestLastAccessed) {
                oldestKey = key_;
                oldestLastAccessed = value_.lastAccessed;
            }
            if (oldestKey) cache.delete(oldestKey);
        },
        delete: (key)=>{
            cache.delete(key);
        },
        clear: ()=>{
            cache.clear();
        }
    };
}

});



parcelRegister("kCNym", function(module, exports) {

$parcel$export(module.exports, "GeneratingAnimation", () => $dc78dc961c2fbf63$export$483f53d5a0354a30);

var $eJOHy = parcelRequire("eJOHy");
const $dc78dc961c2fbf63$export$483f53d5a0354a30 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "20",
        viewBox: "0 2 24 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("title", null, props.alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));

});

parcelRegister("fHqkT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfe1ae393dfab8a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0dfe1ae393dfab8a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    jqlDebuggerHeadingNonFinal: {
        "id": "jql-debugger-panel.header.text-non-final",
        "defaultMessage": "JQL error"
    },
    jqlDebuggerHeadingPluralNonFinal: {
        "id": "jql-debugger-panel.header.plural-text-non-final",
        "defaultMessage": "JQL errors"
    },
    jqlDebuggerLoadingNonFinal: {
        "id": "jql-debugger-panel.header.loading-non-final",
        "defaultMessage": "Generating query fixes"
    },
    betaLozenge: {
        "id": "jql-debugger-panel.header.beta-lozenge",
        "defaultMessage": "Beta"
    },
    discardSuggestionNonFinal: {
        "id": "jql-debugger-panel.error-section.discard-suggestion-non-final",
        "defaultMessage": "Discard and close"
    }
});

});


parcelRegister("iNmbB", function(module, exports) {

$parcel$export(module.exports, "SuggestedFixContentEntrypoint", () => $5a5654ca917f495c$export$9b2c3d0b37e41ae9);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $5a5654ca917f495c$export$9b2c3d0b37e41ae9 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("gZYEk")), {
        moduleId: "2d263a55",
        priority: "interaction"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("gZYEk", function(module, exports) {

let $c601638c63ebb79e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c601638c63ebb79e$var$load("66nqw").then(()=>parcelRequire('d16oc'));

});



parcelRegister("lg8UF", function(module, exports) {

$parcel$export(module.exports, "extractTextFromReactElement", () => $91bb6ebc41ba1a5e$export$98ee087174ba8894);

var $eJOHy = parcelRequire("eJOHy");
function $91bb6ebc41ba1a5e$export$98ee087174ba8894(element) {
    let result = '';
    function traverse(node) {
        if (typeof node === 'string' || typeof node === 'number') result += node.toString();
        else if (/*#__PURE__*/ (0, $eJOHy.isValidElement)(node)) (0, $eJOHy.Children).forEach(node.props.children, (child)=>{
            traverse(child);
        });
    }
    traverse(element);
    return result;
}

});


parcelRegister("6Vq1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $f69b94536cc1a621$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f69b94536cc1a621$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    fixErrorWithAiNonFinal: {
        "id": "jql-debugger.trigger-button.fix-error-with-ai-non-final",
        "defaultMessage": "Fix with AI"
    },
    jsErrorNonFinal: {
        "id": "jql-debugger.trigger-button.js-error-non-final",
        "defaultMessage": "Something went wrong"
    },
    errorIconLabelNonFinal: {
        "id": "jql-debugger.trigger-button.error-icon-label-non-final",
        "defaultMessage": "Error Icon"
    }
});

});

parcelRegister("gr39h", function(module, exports) {

$parcel$export(module.exports, "JqlDebuggerJqlBuilderContextProvider", () => $f1561459319f3132$export$c2426bb4c28cc626);
$parcel$export(module.exports, "useJqlDebuggerAdditionalContext", () => $f1561459319f3132$export$3b2021865598576e);

var $eJOHy = parcelRequire("eJOHy");

var $bJscI = parcelRequire("bJscI");

var $fZD08 = parcelRequire("fZD08");
const $f1561459319f3132$var$jqlDebuggerContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    onSearch: ()=>undefined,
    query: '',
    jqlMessages: []
});
/**
 * Provide additional context about the JQL Builder context to the JQL Debugger
 *
 * This additional context exists primarily because we need to pass some props from JQL builder to the customComponent override of ErrorMessage
 * Since ErrorMessage component (jql-debugger trigger-button) is passed as a component, we cannot pass the additional props as regular props
 * Hence we wrap the parent with this provider and pass the props as context
 */ const $f1561459319f3132$var$JqlDebuggerJqlBuilderContextProviderOld = (props)=>{
    const { jqlMessages: jqlMessages, query: query, onSearch: onSearch } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1561459319f3132$var$jqlDebuggerContext.Provider, {
        value: {
            query: query,
            jqlMessages: jqlMessages,
            onSearch: onSearch
        }
    }, props.children);
};
const $f1561459319f3132$export$c2426bb4c28cc626 = (0, $bJscI.componentWithFG)('gravityai-2283-jql-debugger-rll-to-entrypoints', (0, $fZD08.JqlDebuggerJqlBuilderContextProvider), $f1561459319f3132$var$JqlDebuggerJqlBuilderContextProviderOld);
const $f1561459319f3132$export$3b2021865598576e = ()=>(0, $eJOHy.useContext)($f1561459319f3132$var$jqlDebuggerContext);

});
parcelRegister("fZD08", function(module, exports) {

$parcel$export(module.exports, "JqlDebuggerJqlBuilderContextProvider", () => $6a81d5ddf104d319$export$c2426bb4c28cc626);

var $bUnif = parcelRequire("bUnif");

var $lfAG2 = parcelRequire("lfAG2");
const $6a81d5ddf104d319$export$c2426bb4c28cc626 = (props)=>{
    const { query: query, onSearch: onSearch, children: children } = props;
    const jqlDebuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const renderSyncActions = (0, $lfAG2.useRenderSynchronizerStoreActions)();
    // JQL Debugger is not ready when:
    // 1. AI is not enabled
    // 2. onSearch callback is not available - i.e. we cannot apply the corrected jql to the editor
    //
    // In such cases, we want to keep the default error layout
    if (onSearch && query) {
        jqlDebuggerStoreActions.setOnSearch(onSearch);
        jqlDebuggerStoreActions.setJqlQuery(query);
        renderSyncActions.setIsContextReady(true);
    } else renderSyncActions.setIsContextReady(false);
    return children;
};

});


parcelRegister("h4mYu", function(module, exports) {

let $c6d4a1aae7f579c9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c6d4a1aae7f579c9$var$load("9Moru").then(()=>parcelRequire('alMOc'));

});


parcelRegister("34Sgq", function(module, exports) {

$parcel$export(module.exports, "SearchModeSwitcherRenderer", () => $c32c98d36df1a3c5$export$f054999725e0d47f);

var $eJOHy = parcelRequire("eJOHy");

var $56qWy = parcelRequire("56qWy");

var $9HnR3 = parcelRequire("9HnR3");

var $7bFFO = parcelRequire("7bFFO");

var $cX22j = parcelRequire("cX22j");

var $70el7 = parcelRequire("70el7");
const $c32c98d36df1a3c5$export$f054999725e0d47f = ({ isSearchModeToggleEnabled: isSearchModeToggleEnabled, SearchModeSwitcher: SearchModeSwitcher = (0, $9HnR3.SearchModeSwitcherWithTarget), isHydrating: isHydrating, isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft })=>{
    const { searchMode: selectedSearchMode, setSelectedSearchMode: setSelectedSearchMode } = (0, $cX22j.useSelectedSearchMode)();
    const { querySupported: querySupported } = (0, $70el7.useIsQuerySupported)();
    const onUpdateSearchMode = (0, $eJOHy.useCallback)((searchMode)=>{
        setSelectedSearchMode(searchMode, true);
    }, [
        setSelectedSearchMode
    ]);
    const isBasicModeDisabled = (0, $eJOHy.useMemo)(()=>// We disable basic mode if:
        // If query is not supported
        !querySupported || // Or if is supported but is also hydrating and we are not in basic mode
        isHydrating && selectedSearchMode !== (0, $56qWy.SEARCH_MODE_BASIC), [
        isHydrating,
        querySupported,
        selectedSearchMode
    ]);
    return isSearchModeToggleEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7bFFO.SearchModeSwitcherContainer), {
        testId: "jql-builder.ui.search-mode-switcher-renderer.toggle-container",
        isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SearchModeSwitcher, {
        searchMode: selectedSearchMode,
        isBasicModeDisabled: isBasicModeDisabled,
        onUpdateSearchMode: onUpdateSearchMode
    })) : null;
};

});




parcelRegister("k5M3z", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c77d4ea5443fa95$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $aF4Or = parcelRequire("aF4Or");

var $bQWwW = parcelRequire("bQWwW");

const $9c77d4ea5443fa95$var$JQLBuilderAsync = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("fXh0B")), {
    moduleId: "./src/packages/jql-builder/jql-builder/src/index.tsx"
});
const $9c77d4ea5443fa95$var$JQLEditorBasicUIAsync = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-jql-builder",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aF4Or.IssueNavigatorJQLBuilderSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9c77d4ea5443fa95$var$JQLBuilderAsync, props));
var $9c77d4ea5443fa95$export$2e2bcd8739ae039 = $9c77d4ea5443fa95$var$JQLEditorBasicUIAsync;

});
parcelRegister("aF4Or", function(module, exports) {

$parcel$export(module.exports, "IssueNavigatorJQLBuilderSkeleton", () => $8cf3c2e2df07d003$export$5be82223ddc28851);
/* jql-builder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hwuZ0 = parcelRequire("hwuZ0");

var $2uUhz = parcelRequire("2uUhz");
const $8cf3c2e2df07d003$var$customCssStyles = null;
const $8cf3c2e2df07d003$var$containerStyles = {
    height: '52px'
};
const $8cf3c2e2df07d003$export$5be82223ddc28851 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2uUhz))),
        containerStyles: $8cf3c2e2df07d003$var$containerStyles,
        className: (0, $hcewu.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("hwuZ0", function(module, exports) {

$parcel$export(module.exports, "AppSkeletonImage", () => $b5dd2f8be7f8eaf9$export$45b107c5dc7b51a5);
/* AppSkeletonImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");

var $ft2u5 = parcelRequire("ft2u5");


var $lRq8t = parcelRequire("lRq8t");

var $hkVH5 = parcelRequire("hkVH5");
const $b5dd2f8be7f8eaf9$var$skeletonImageStyles = null;
const $b5dd2f8be7f8eaf9$export$45b107c5dc7b51a5 = /*#__PURE__*/ (0, $eJOHy.memo)(({ src: src, className: className, containerStyles: containerStyles, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "app-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b5dd2f8be7f8eaf9$var$SkeletonWrapper // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: src,
        "data-testid": testId,
        alt: `${formatMessage((0, $hkVH5.default).loading)}...`,
        className: (0, $hcewu.default)([
            "_1dqonqa1 _1h6d3acm _1e0c1ule _vchhusvi _1bsb1osq _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
            className
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ft2u5.FallbackIndicator), null));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5dd2f8be7f8eaf9$var$SkeletonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ft2u5", function(module, exports) {

$parcel$export(module.exports, "FallbackIndicator", () => $4d192dc9d4a49414$export$e975518239643357);
/**
 * A declarative component that taints a given location as a "fallback"
 * used to detect SSR success rate and the completeness of the page.
 */ const $4d192dc9d4a49414$export$e975518239643357 = ()=>null;

});

parcelRegister("hkVH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e046a3f69fb3907$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9e046a3f69fb3907$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loading: {
        "id": "skeletons.common.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("2uUhz", function(module, exports) {
module.exports = new URL("issue-navigator-jql-builder-skeleton.tpl.20beba3c.svg", import.meta.url).toString();

});


parcelRegister("fXh0B", function(module, exports) {

let $b9d98f44b136bd20$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b9d98f44b136bd20$var$load("kcyyG").then(()=>parcelRequire('QPNUI'));

});


parcelRegister("2h5Yw", function(module, exports) {

$parcel$export(module.exports, "useQueuesFilters", () => $4b28ec3e264c8958$export$e744fcb332e8e0fc);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");

var $5FSZM = parcelRequire("5FSZM");

var $fAZgY = parcelRequire("fAZgY");

var $iPdm8 = parcelRequire("iPdm8");

var $dTJxm = parcelRequire("dTJxm");

var $lRq8t = parcelRequire("lRq8t");

var $bhwM6 = parcelRequire("bhwM6");
const $4b28ec3e264c8958$export$e744fcb332e8e0fc = ({ isSimplified: isSimplified, projectType: projectType })=>{
    const { data: classicProjectFilters } = (0, $5FSZM.useCalendarFilterResource)({
        isSimplified: isSimplified
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // Translate the request type filter, as resource doesnot allow for i18n
    const classicProjectFiltersI18n = (0, $fAZgY.useMemoWithCondition)(()=>classicProjectFilters?.map((item)=>{
            if (typeof item === 'object' && Object.values(item).includes((0, $iPdm8.TARGET_FILTER_TYPE))) return {
                ...item,
                displayName: formatMessage((0, $bhwM6.default).requestType)
            };
            return item;
        }), [
        classicProjectFilters,
        formatMessage
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const simplifiedProjectFilters = (0, $eJOHy.useMemo)(()=>[
            {
                ...(0, $dTJxm.TYPE),
                displayName: formatMessage((0, $bhwM6.default).requestType)
            },
            (0, $dTJxm.STATUS_FIELD_JQL_TERM),
            (0, $dTJxm.ASSIGNEE_FIELD_JQL_TERM)
        ], [
        formatMessage
    ]);
    const jcsProjectFilters = (0, $eJOHy.useMemo)(()=>[
            (0, $dTJxm.STATUS_FIELD_JQL_TERM),
            (0, $dTJxm.ASSIGNEE_FIELD_JQL_TERM)
        ], []);
    if (projectType === (0, $ln6Iy.CUSTOMER_SERVICE_PROJECT) && (0, $7jTnu.fg)('jcs_project_type_m3')) return jcsProjectFilters;
    if (isSimplified) return simplifiedProjectFilters;
    return classicProjectFiltersI18n;
};

});
parcelRegister("bhwM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $72626aa902a6a1ef$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $72626aa902a6a1ef$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-search.placeholder",
        "defaultMessage": "Search for issues"
    },
    clearSearch: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-search.clear-search",
        "defaultMessage": "Clear search"
    },
    placeholderIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-search.placeholder-issue-term-refresh",
        "defaultMessage": "Search for work items"
    },
    requestType: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-search.request-type",
        "defaultMessage": "Request type"
    }
});

});




parcelRegister("itsdR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe7a1aac3b778a7b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $iHPvF = parcelRequire("iHPvF");
var $akOEX = parcelRequire("akOEX");

var $7jTnu = parcelRequire("7jTnu");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $1KdDN = parcelRequire("1KdDN");

var $8xqSl = parcelRequire("8xqSl");

var $7VBgz = parcelRequire("7VBgz");

var $i51zh = parcelRequire("i51zh");
function $fe7a1aac3b778a7b$export$2e2bcd8739ae039(props) {
    const [addTopMargin, setAddTopMargin] = (0, $eJOHy.useState)(false);
    const { renderDisplayError: renderDisplayError, IssueCount: IssueCount, IssueSearch: IssueSearch, isQueuesErrorHeaderDisplayed: isQueuesErrorHeaderDisplayed } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleError = (location)=>{
        if (location === 'common.error-boundary.queues-details') setAddTopMargin(true);
        renderDisplayError();
    };
    const handleReload = ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    };
    const errorSectionDefaultStyles = (0, $1DXK0.xcss)({
        marginTop: 'space.0'
    });
    const errorMarginTopStyles = (0, $1DXK0.xcss)({
        marginTop: 'space.400'
    });
    const queueSearch = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        onError: renderDisplayError,
        id: "queue-issue-search",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jsd-shield",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssueSearch, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssueCount, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        onError: handleError,
        id: "queues-details-wrapper",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jsd-shield",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.400",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: [
            errorSectionDefaultStyles,
            addTopMargin && errorMarginTopStyles
        ]
    }, isQueuesErrorHeaderDisplayed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        title: formatMessage((0, $7VBgz.messages).errorSectionTitle),
        appearance: "error",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akOEX.default), {
            onClick: handleReload
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $7VBgz.messages).reloadPageLinkText))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $7VBgz.messages).errorSectionBody)), (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockStart: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "start",
        justifyContent: "space-between"
    }, queueSearch, (0, $7jTnu.fg)('jsm_agent_ai_triage_enhancements') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8xqSl.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fe7a1aac3b778a7b$var$fixedActionButtonWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i51zh.default), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $fe7a1aac3b778a7b$var$fixedActionButtonWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i51zh.default), null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $7jTnu.fg)('jsm_agent_ai_triage_enhancements') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        spread: "space-between"
    }, queueSearch, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockStart: "space.050",
        paddingInlineEnd: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8xqSl.default), null))) : queueSearch)));
}
const $fe7a1aac3b778a7b$var$fixedActionButtonWidthStyles = (0, $1DXK0.xcss)({
    flexShrink: 0
});

});
parcelRegister("8xqSl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ef1340756f32ffd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $bQWwW = parcelRequire("bQWwW");

var $ch9En = parcelRequire("ch9En");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $7ef1340756f32ffd$var$LazyTriageButton = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("5S9MU")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/queues-agent-view/src/view/layout/queues-details/triage-button/index.tsx"
});
const $7ef1340756f32ffd$export$f1a6927e499e6579 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "asyncTriageButton",
        fallback: "unmount",
        teamName: "JSM Agent AI"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "asyncTriageButton",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef1340756f32ffd$var$LazyTriageButton, null)));
var $7ef1340756f32ffd$export$2e2bcd8739ae039 = $7ef1340756f32ffd$export$f1a6927e499e6579;

});
parcelRegister("5S9MU", function(module, exports) {

let $4469968b1eebce16$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4469968b1eebce16$var$load("aP4zG").then(()=>parcelRequire('3NK4Q'));

});


parcelRegister("7VBgz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5c32b911fdc8b516$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $5c32b911fdc8b516$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    errorSectionTitle: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.error-section-title",
        "defaultMessage": "We currently have an outage"
    },
    errorSectionBody: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.error-section-body",
        "defaultMessage": "We're working hard to resolve temporary glitches with this page. But rest assured, the key functions on this page remain fully operational."
    },
    reloadPageLinkText: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.reload-page-link-text",
        "defaultMessage": "Reload the page"
    }
});

});

parcelRegister("i51zh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f7274a121f7b49f$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $4LfWe = parcelRequire("4LfWe");

var $6I1gv = parcelRequire("6I1gv");

var $2rdzP = parcelRequire("2rdzP");
const $0f7274a121f7b49f$var$mapStateToProps = (state)=>({
        isManuallySorted: (0, $4LfWe.isManuallySorted)(state),
        showIssueFailureError: (0, $6I1gv.showIssueFailureError)(state)
    });
var $0f7274a121f7b49f$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($0f7274a121f7b49f$var$mapStateToProps, {})((0, $2rdzP.default));

});
parcelRegister("2rdzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7225db0615553a3$export$2e2bcd8739ae039);
/* eslint-disable jira/react-no-inline-function-prop */ 
var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");

var $Ay1uj = parcelRequire("Ay1uj");

var $aMdh8 = parcelRequire("aMdh8");

var $kJsb4 = parcelRequire("kJsb4");

var $jUgeq = parcelRequire("jUgeq");

var $lRq8t = parcelRequire("lRq8t");

var $6zXPf = parcelRequire("6zXPf");

var $9hAQj = parcelRequire("9hAQj");

var $1HAcf = parcelRequire("1HAcf");

var $5ehXz = parcelRequire("5ehXz");
const $a7225db0615553a3$var$HeaderActions = ({ isManuallySorted: isManuallySorted, showIssueFailureError: showIssueFailureError })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const isSortable = !showIssueFailureError && isManuallySorted;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onToggle = (0, $eJOHy.useCallback)(()=>{
        setIsOpen((prev)=>!prev);
    }, [
        setIsOpen
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9hAQj.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: onClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), {
                minWidth: 0
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1HAcf.default), {
                isDisabled: !isSortable
            })),
        placement: "bottom-end",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))),
                label: formatMessage((0, $5ehXz.messages).actions),
                isSelected: isOpen,
                onClick: onToggle,
                ...(0, $6zXPf.getWillShowNav4)() ? {} : {
                    appearance: 'subtle',
                    spacing: 'compact'
                }
            })
    }));
};
var $a7225db0615553a3$export$2e2bcd8739ae039 = $a7225db0615553a3$var$HeaderActions;

});
parcelRegister("9hAQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6217aad1de48e19d$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $f20Bj = parcelRequire("f20Bj");

var $lc49q = parcelRequire("lc49q");

var $3kgzd = parcelRequire("3kgzd");
const $6217aad1de48e19d$var$mapStateToProps = (state)=>({
        projectKey: (0, $f20Bj.getProjectKey)(state),
        queueJql: (0, $lc49q.getCompleteJql)(state)
    });
var $6217aad1de48e19d$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($6217aad1de48e19d$var$mapStateToProps, {})((0, $3kgzd.OpenInIssueNavButton));

});
parcelRegister("3kgzd", function(module, exports) {

$parcel$export(module.exports, "OpenInIssueNavButton", () => $8f9b9ba027a73e3e$export$72e8ee1dd9380293);

var $eJOHy = parcelRequire("eJOHy");

var $8rAKL = parcelRequire("8rAKL");

var $6K3F5 = parcelRequire("6K3F5");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $gqTjx = parcelRequire("gqTjx");

var $7jTnu = parcelRequire("7jTnu");

var $6zXPf = parcelRequire("6zXPf");
const $8f9b9ba027a73e3e$var$getIssueNavUrl = (projectKey, queueJql)=>projectKey ? `/jira/servicedesk/projects/${projectKey}/issues/?jql=${encodeURIComponent(queueJql)}` : `/issues/?jql=${encodeURIComponent(queueJql)}`;
const $8f9b9ba027a73e3e$export$72e8ee1dd9380293 = (_props)=>{
    const { projectKey: projectKey, queueJql: queueJql } = _props;
    const issueNavUrl = $8f9b9ba027a73e3e$var$getIssueNavUrl(projectKey, queueJql);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'navigateToIssueNavFromQueues', {
            hasProjectKey: typeof projectKey === 'string'
        });
    }, [
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6K3F5.default), {
        href: issueNavUrl,
        target: "_blank",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))),
        onClick: onClick,
        label: formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $gqTjx.default).openWithIssueNavIssueTermRefresh : (0, $gqTjx.default).openWithIssueNav),
        isTooltipDisabled: false,
        ...(0, $6zXPf.getWillShowNav4)() ? {} : {
            appearance: 'subtle',
            spacing: 'compact'
        }
    });
};

});
parcelRegister("gqTjx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d94bb760131dcc2c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d94bb760131dcc2c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    deleteQueue: {
        "id": "servicedesk.queues.common.delete-queue",
        "defaultMessage": "Delete queue"
    },
    resetSorting: {
        "id": "servicedesk.queues.common.reset-sorting",
        "defaultMessage": "Reset sorting"
    },
    openWithIssueNav: {
        "id": "servicedesk.queues.common.open-with-issue-nav",
        "defaultMessage": "Open in issue navigator"
    },
    openWithIssueNavIssueTermRefresh: {
        "id": "servicedesk.queues.common.open-with-issue-nav-issue-term-refresh",
        "defaultMessage": "Go to filter view"
    }
});

});



parcelRegister("1HAcf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5afe1fc1e0a6bf57$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $gnQAk = parcelRequire("gnQAk");

var $iGYMr = parcelRequire("iGYMr");

var $g5CBY = parcelRequire("g5CBY");
var $5afe1fc1e0a6bf57$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $gnQAk.connect)(null, {
    onResetSorting: (0, $iGYMr.resetSortOrderAction)
}))((0, $g5CBY.default));

});
parcelRegister("g5CBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e4f60dc0047ed4c$export$2e2bcd8739ae039);
/* eslint-disable jira/react-no-inline-function-prop */ 
var $eJOHy = parcelRequire("eJOHy");

var $7saMl = parcelRequire("7saMl");

var $8IeH1 = parcelRequire("8IeH1");

var $yJU5w = parcelRequire("yJU5w");

var $kJsb4 = parcelRequire("kJsb4");

var $lRq8t = parcelRequire("lRq8t");

var $gqTjx = parcelRequire("gqTjx");

var $gL8cU = parcelRequire("gL8cU");
function $1e4f60dc0047ed4c$export$ce3eb8345b6d11e3({ onResetSorting: onResetSorting, isDisabled: isDisabled = false }) {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (!isDisabled) {
            onResetSorting();
            return;
        }
        setIsOpen((prev)=>!prev);
    }, [
        isDisabled,
        onResetSorting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJsb4.default), {
        isOpen: isOpen && isDisabled,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                padding: "space.200"
            }, formatMessage((0, $gL8cU.messages).resetSortingButtonDisabled)),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7saMl.default), {
                ...triggerProps,
                onClick: onClick,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($yJU5w))), {
                    label: ""
                })
            }, formatMessage((0, $gqTjx.default).resetSorting))
    });
}
var $1e4f60dc0047ed4c$export$2e2bcd8739ae039 = $1e4f60dc0047ed4c$export$ce3eb8345b6d11e3;

});
parcelRegister("gL8cU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $edbe9f4f44da1766$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $edbe9f4f44da1766$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    resetSortingButtonDisabled: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.actions.reset-sorting-button.reset-sroting-button-disabled",
        "defaultMessage": "No sorting to reset"
    }
});

});



parcelRegister("5ehXz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4d9b43fa15addc65$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $4d9b43fa15addc65$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    actions: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.actions.actions",
        "defaultMessage": "Actions"
    }
});

});




parcelRegister("ht9L5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9068459d266fb80e$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");


var $cpZzK = parcelRequire("cpZzK");

var $2MzoN = parcelRequire("2MzoN");

var $3MjJb = parcelRequire("3MjJb");

var $1TuhT = parcelRequire("1TuhT");

var $6I1gv = parcelRequire("6I1gv");

var $a7Azt = parcelRequire("a7Azt");
const $9068459d266fb80e$var$mapDispatchToProps = (dispatch)=>({
        onFilterReloadClick: ()=>{
            dispatch((0, $cpZzK.isNewFilterQueryPendingAction)(true));
            dispatch((0, $2MzoN.loadIssuesAction)(0, (0, $f3fa5acbda0f3e0e$export$be4c1ea173a5271a)));
        }
    });
const $9068459d266fb80e$var$mapStateToProps = (state)=>({
        issueCount: (0, $1TuhT.getIssueCount)(state),
        isCurrentDataFiltered: (0, $3MjJb.getIsCurrentDataFiltered)(state),
        isLoadingIssues: (0, $6I1gv.isLoadingIssues)(state)
    });
var $9068459d266fb80e$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($9068459d266fb80e$var$mapStateToProps, $9068459d266fb80e$var$mapDispatchToProps)((0, $a7Azt.default));

});
parcelRegister("a7Azt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8ebdf5ee47f0365$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $i78b1 = parcelRequire("i78b1");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $dLR8J = parcelRequire("dLR8J");

var $9A8Wt = parcelRequire("9A8Wt");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $lyj7L = parcelRequire("lyj7L");
const $f8ebdf5ee47f0365$export$3a97348fbd75d0cd = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { issueCount: issueCount, isCurrentDataFiltered: isCurrentDataFiltered, isLoadingIssues: isLoadingIssues, onFilterReloadClick: onFilterReloadClick } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleReloadClick = ()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'jsmQueueFiltering reloaded');
        onFilterReloadClick();
    };
    const skeleton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.Skeleton), {
        height: "24px",
        width: "100px",
        "data-testid": "servicedesk-queues-agent-view.layout.queues-details.issue-search-count.skeleton"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? [
            $f8ebdf5ee47f0365$var$wrapperBaseStyles,
            (0, $7jTnu.fg)('corcap-2944-add-jqlbuilder-to-jsm-queues') && $f8ebdf5ee47f0365$var$negativeMarginStyles,
            !(0, $7jTnu.fg)('corcap-2944-add-jqlbuilder-to-jsm-queues') && $f8ebdf5ee47f0365$var$wrapperPaddingstyles
        ] : [
            $f8ebdf5ee47f0365$var$wrapperOldStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        role: "region",
        xcss: $f8ebdf5ee47f0365$var$layoutStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "aria-live": "polite",
        "aria-atomic": true
    }, !isCurrentDataFiltered && issueCount !== 0 && !isLoadingIssues && formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $lyj7L.default).numberOfIssuesIssueTermRefresh : (0, $lyj7L.default).numberOfIssues, {
        issueCount: issueCount
    }), isCurrentDataFiltered && !isLoadingIssues && formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $lyj7L.default).numberOfFilteredIssuesIssueTermRefresh : (0, $lyj7L.default).numberOfFilteredIssues, {
        filteredIssueCount: issueCount
    })), isCurrentDataFiltered && !isLoadingIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f8ebdf5ee47f0365$var$spacerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "bottom",
        content: formatMessage((0, $lyj7L.default).refreshResults)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "aria-label": formatMessage((0, $lyj7L.default).refreshResults),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i78b1))), {
            label: formatMessage((0, $lyj7L.default).refreshResults),
            LEGACY_size: "small"
        }),
        "data-testId": "servicedesk-queues-agent-view.layout.queues-details.issue-count.reload-button",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleReloadClick
    }))), isLoadingIssues && (0, $7jTnu.fg)('add_ufo_load_hold_to_custom_queue') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "issue-count"
    }, skeleton), isLoadingIssues && skeleton));
};
var $f8ebdf5ee47f0365$export$2e2bcd8739ae039 = $f8ebdf5ee47f0365$export$3a97348fbd75d0cd;
const $f8ebdf5ee47f0365$var$layoutStyle = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $f8ebdf5ee47f0365$var$spacerStyles = (0, $1DXK0.xcss)({
    width: 'space.100'
});
const $f8ebdf5ee47f0365$var$wrapperBaseStyles = (0, $1DXK0.xcss)({
    paddingBlockEnd: 'space.150',
    color: 'color.text.subtle',
    paddingBlockStart: 'space.0'
});
const $f8ebdf5ee47f0365$var$wrapperPaddingstyles = (0, $1DXK0.xcss)({
    paddingBlockStart: 'space.150'
});
const $f8ebdf5ee47f0365$var$wrapperOldStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtle',
    marginTop: 'space.150',
    marginBottom: 'space.300'
});
const $f8ebdf5ee47f0365$var$negativeMarginStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.negative.050'
});

});
parcelRegister("lyj7L", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad234488ea8a33d8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ad234488ea8a33d8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    numberOfIssues: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-issues",
        "defaultMessage": "{issueCount, plural,\n            =1 {{issueCount, number} issue}\n            other {{issueCount, number} issues}\n            }"
    },
    numberOfFilteredIssues: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-filtered-issues",
        "defaultMessage": "{filteredIssueCount, plural,\n            =1 {{filteredIssueCount, number} issue found}\n            other {{filteredIssueCount, number} issues found}\n            }"
    },
    refreshResults: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.refresh-results",
        "defaultMessage": "Refresh results"
    },
    numberOfIssuesIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-issues-issue-term-refresh",
        "defaultMessage": "{issueCount, plural,\n            =1 {{issueCount, number} work item}\n            other {{issueCount, number} work items}\n            }"
    },
    numberOfFilteredIssuesIssueTermRefresh: {
        "id": "servicedesk.queues.agent-view.layout.queues-details.issue-count.number-of-filtered-issues-issue-term-refresh",
        "defaultMessage": "{filteredIssueCount, plural,\n            =1 {{filteredIssueCount, number} work item found}\n            other {{filteredIssueCount, number} work items found}\n            }"
    }
});

});




parcelRegister("Y72S0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c788d6a360f214e3$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $bKkYU = parcelRequire("bKkYU");

var $lc49q = parcelRequire("lc49q");

var $5uclO = parcelRequire("5uclO");

var $2RARS = parcelRequire("2RARS");
const $c788d6a360f214e3$var$mapStateToProps = (state)=>({
        Actions: $5uclO.default,
        queueName: (0, $lc49q.getQueueName)(state)
    });
const $c788d6a360f214e3$var$mapDispatchToProps = {
    renderDisplayError: (0, $bKkYU.displayQueuesErrorHeaderAction)
};
var $c788d6a360f214e3$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($c788d6a360f214e3$var$mapStateToProps, $c788d6a360f214e3$var$mapDispatchToProps)((0, $2RARS.default));

});
parcelRegister("5uclO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a9c1b6fa9afe5d7$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $lc49q = parcelRequire("lc49q");

var $4LfWe = parcelRequire("4LfWe");

var $6I1gv = parcelRequire("6I1gv");

var $7bdVj = parcelRequire("7bdVj");

var $jrfKu = parcelRequire("jrfKu");

var $k5IGm = parcelRequire("k5IGm");

var $g2i2t = parcelRequire("g2i2t");

var $eKMMf = parcelRequire("eKMMf");
const $1a9c1b6fa9afe5d7$var$mapStateToProps = (state)=>({
        ActionsMenu: $7bdVj.default,
        ResetSortingButton: $g2i2t.default,
        FavoriteButton: $jrfKu.default,
        OpenInIssueNavButton: $k5IGm.default,
        canManageQueue: (0, $lc49q.canManageQueue)(state),
        isManuallySorted: (0, $4LfWe.isManuallySorted)(state),
        isFavoriteEnabled: !(0, $lc49q.isQueueTransient)(state),
        showIssueFailureError: (0, $6I1gv.showIssueFailureError)(state)
    });
var $1a9c1b6fa9afe5d7$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($1a9c1b6fa9afe5d7$var$mapStateToProps, {})((0, $eKMMf.default));

});
parcelRegister("7bdVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c62f147c66ada1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $60c62f147c66ada1$var$LazyComponent = (0, $bQWwW.lazy)(()=>(parcelRequire("lUTxk")), {
    moduleId: "./src/packages/servicedesk/queues-agent-view/src/view/layout/queues-header/actions/async-actions-menu/actions-menu/index.tsx"
});
const $60c62f147c66ada1$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "queues-agent-view-actions-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($60c62f147c66ada1$var$LoadingComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($60c62f147c66ada1$var$LazyComponent, props));
var $60c62f147c66ada1$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $60c62f147c66ada1$var$Component;
const $60c62f147c66ada1$var$LoadingComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb14no _4t3i1tcg _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lUTxk", function(module, exports) {

let $ff49e85779d235ee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ff49e85779d235ee$var$load("dkZPH").then(()=>parcelRequire('kRcXQ'));

});


parcelRegister("jrfKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $eec1bdf3714841a1$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $9fn3D = parcelRequire("9fn3D");

var $gnQAk = parcelRequire("gnQAk");

var $2g4oI = parcelRequire("2g4oI");

var $lc49q = parcelRequire("lc49q");

var $fJ64k = parcelRequire("fJ64k");
const $eec1bdf3714841a1$var$mapStateToProps = (state)=>({
        isFavorite: (0, $2g4oI.isQueueFavorited)(state),
        queueId: (0, $lc49q.getQueueId)(state)
    });
var $eec1bdf3714841a1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $9fn3D.default)((state)=>({
        attributes: {
            queueId: (0, $lc49q.getQueueId)(state),
            isFavorite: !(0, $2g4oI.isQueueFavorited)(state)
        }
    })), (0, $gnQAk.connect)($eec1bdf3714841a1$var$mapStateToProps, {}))(// @ts-expect-error - Argument of type '({ isFavorite, queueId }: Props) => JSX.Element' is not assignable to parameter of type 'ComponentType<unknown>'.
(0, $fJ64k.default));

});
parcelRegister("2g4oI", function(module, exports) {

$parcel$export(module.exports, "isQueueFavorited", () => $eea1dc26329a5d91$export$a8538c0c3c892848);

var $6I1gv = parcelRequire("6I1gv");
const $eea1dc26329a5d91$export$a8538c0c3c892848 = (state)=>{
    const queue = (0, $6I1gv.getCurrentQueue)(state);
    return queue ? queue.isFavorite : false;
};

});

parcelRegister("fJ64k", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad8891a389a942e0$export$2e2bcd8739ae039);
/* eslint-disable jira/react-no-inline-function-prop */ 
var $eJOHy = parcelRequire("eJOHy");

var $fVPN0 = parcelRequire("fVPN0");

var $aMJA4 = parcelRequire("aMJA4");

var $beI5n = parcelRequire("beI5n");

var $lbm8E = parcelRequire("lbm8E");

var $2IsS5 = parcelRequire("2IsS5");
const $ad8891a389a942e0$var$FavoriteButton = ({ isFavorite: isFavorite, queueId: queueId })=>{
    const { changeFavorite: changeFavorite, items: items } = (0, $eJOHy.useContext)((0, $beI5n.FavoriteChangeContext));
    const getIsPending = ()=>{
        const queueItemChanges = items[0, $aMJA4.QUEUES_ITEM_TYPE];
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        const itemChanged = queueItemChanges[(0, $2IsS5.fromQueueIdString)(queueId)];
        return itemChanged ? itemChanged.pending : false;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lbm8E.AvailableQueuesConsumer), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), {
            isFavorite: isFavorite,
            pending: getIsPending(),
            onClick: (analyticsEvent)=>{
                changeFavorite({
                    id: (0, $2IsS5.fromQueueIdString)(queueId),
                    value: !isFavorite,
                    type: (0, $aMJA4.QUEUES_ITEM_TYPE)
                }, analyticsEvent);
            }
        }));
};
var $ad8891a389a942e0$export$2e2bcd8739ae039 = $ad8891a389a942e0$var$FavoriteButton;

});


parcelRegister("k5IGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f5d10b06c2d4312$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $f20Bj = parcelRequire("f20Bj");

var $lc49q = parcelRequire("lc49q");

var $b791c = parcelRequire("b791c");
const $1f5d10b06c2d4312$var$mapStateToProps = (state)=>({
        projectKey: (0, $f20Bj.getProjectKey)(state),
        queueJql: (0, $lc49q.getCompleteJql)(state)
    });
var $1f5d10b06c2d4312$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($1f5d10b06c2d4312$var$mapStateToProps, {})((0, $b791c.OpenInIssueNavButton));

});
parcelRegister("b791c", function(module, exports) {

$parcel$export(module.exports, "OpenInIssueNavButton", () => $4bac07b7b5c9805d$export$72e8ee1dd9380293);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $8rAKL = parcelRequire("8rAKL");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $gqTjx = parcelRequire("gqTjx");

var $7jTnu = parcelRequire("7jTnu");
const $4bac07b7b5c9805d$var$getIssueNavUrl = (projectKey, queueJql)=>projectKey ? `/jira/servicedesk/projects/${projectKey}/issues/?jql=${encodeURIComponent(queueJql)}` : `/issues/?jql=${encodeURIComponent(queueJql)}`;
const $4bac07b7b5c9805d$export$72e8ee1dd9380293 = (_props)=>{
    const { projectKey: projectKey, queueJql: queueJql } = _props;
    const issueNavUrl = $4bac07b7b5c9805d$var$getIssueNavUrl(projectKey, queueJql);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = (_, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'navigateToIssueNavFromQueues', {
            hasProjectKey: typeof projectKey === 'string'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $gqTjx.default).openWithIssueNavIssueTermRefresh : (0, $gqTjx.default).openWithIssueNav)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        testId: "servicedesk-queues-agent-view.layout.queues-header.actions.open-in-issue-nav-button.open-in-issue-nav-button",
        href: issueNavUrl,
        target: "_blank",
        onClick: onClick,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))), {
            label: "",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        appearance: "subtle"
    }));
};

});


parcelRegister("g2i2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $b166877470a6e897$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $9fn3D = parcelRequire("9fn3D");

var $l5htz = parcelRequire("l5htz");

var $gnQAk = parcelRequire("gnQAk");

var $iGYMr = parcelRequire("iGYMr");

var $4LfWe = parcelRequire("4LfWe");

var $dLXGg = parcelRequire("dLXGg");
var $b166877470a6e897$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $l5htz.default)({
    onResetSorting: 'resetSorting'
}), (0, $9fn3D.default)((state)=>({
        attributes: {
            fieldId: (0, $4LfWe.getSortedByColumn)(state),
            sortOrder: (0, $4LfWe.getSortOrder)(state)
        }
    })), (0, $gnQAk.connect)(null, {
    onResetSorting: (0, $iGYMr.resetSortOrderAction)
}))((0, $dLXGg.default));

});
parcelRegister("dLXGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $baf63e3decc1e39c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6YFG2 = parcelRequire("6YFG2");

var $gqTjx = parcelRequire("gqTjx");
function $baf63e3decc1e39c$export$ce3eb8345b6d11e3(props) {
    const { intl: { formatMessage: formatMessage }, onResetSorting: onResetSorting } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onResetSorting
    }, formatMessage((0, $gqTjx.default).resetSorting));
}
var $baf63e3decc1e39c$export$2e2bcd8739ae039 = (0, $6YFG2.default)($baf63e3decc1e39c$export$ce3eb8345b6d11e3);

});


parcelRegister("eKMMf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef434e25b4cfaf59$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $itojl = parcelRequire("itojl");

var $7mS63 = parcelRequire("7mS63");

var $7jTnu = parcelRequire("7jTnu");
function $ef434e25b4cfaf59$export$2e2bcd8739ae039({ canManageQueue: canManageQueue, isManuallySorted: isManuallySorted, isFavoriteEnabled: isFavoriteEnabled, onDeleteComplete: onDeleteComplete, showIssueFailureError: showIssueFailureError, ActionsMenu: ActionsMenu, FavoriteButton: FavoriteButton, ResetSortingButton: ResetSortingButton, OpenInIssueNavButton: OpenInIssueNavButton }) {
    const shouldShowResetSortingButton = !showIssueFailureError && !canManageQueue && isManuallySorted;
    const hasMultipleActions = isFavoriteEnabled && (canManageQueue || shouldShowResetSortingButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef434e25b4cfaf59$var$Wrapper, null, !false && /* eslint-disable-next-line jira/ff/no-preconditioning */ ((0, $7jTnu.fg)('jsm_queues_jql_builder_perf_improvement') && (0, $7jTnu.fg)('move_jsm_queue_automation_menu_to_sync') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7mS63.SyncQueuesAutomationMenu), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $itojl.AsyncQueuesAutomationMenu), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OpenInIssueNavButton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef434e25b4cfaf59$var$Spacer, null)), !false && isFavoriteEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FavoriteButton, null), !false && hasMultipleActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef434e25b4cfaf59$var$Spacer, null), !false && canManageQueue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ActionsMenu, {
        onDeleteComplete: onDeleteComplete
    }), !false && shouldShowResetSortingButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ResetSortingButton, null));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef434e25b4cfaf59$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ef434e25b4cfaf59$var$Spacer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("itojl", function(module, exports) {

$parcel$export(module.exports, "AsyncQueuesAutomationMenu", () => $b4a122491c29c928$export$a6b9948799694c4f);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");


var $4qsnb = parcelRequire("4qsnb");
const $b4a122491c29c928$var$runtimeProps = {};
const $b4a122491c29c928$var$entryPointParams = {};
const $b4a122491c29c928$export$a6b9948799694c4f = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $4qsnb.queuesAutomationMenuEntryPoint), $b4a122491c29c928$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jsm.queues.automation.menu",
        packageName: (0, $51ac28649bda1008$export$b8b9d90f9e5bd72b),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $b4a122491c29c928$var$runtimeProps,
        errorFallback: "flag"
    });
};

});
const $51ac28649bda1008$export$b8b9d90f9e5bd72b = 'jiraServicedeskQueuesAutomationMenu';
const $51ac28649bda1008$export$d57b6b390e78d90f = 'jsd-shield';

parcelRegister("4qsnb", function(module, exports) {

$parcel$export(module.exports, "queuesAutomationMenuEntryPoint", () => $c686fc5f7012b35c$export$3165d8c5913e99eb);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $c686fc5f7012b35c$export$3165d8c5913e99eb = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("ksRcV")), {
        moduleId: "2f0e15f7",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("ksRcV", function(module, exports) {

let $ee5fb211be7b1673$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ee5fb211be7b1673$var$load("1Jmry").then(()=>parcelRequire('7hUZa'));

});



parcelRegister("7mS63", function(module, exports) {

$parcel$export(module.exports, "QueuesAutomationMenu", () => $33926eb7c1ec50f9$export$578299f939d234e9);
$parcel$export(module.exports, "SyncQueuesAutomationMenu", () => $33926eb7c1ec50f9$export$74da9177782daf20);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $gPZN1 = parcelRequire("gPZN1");

var $1KdDN = parcelRequire("1KdDN");

var $7jTnu = parcelRequire("7jTnu");

var $cNe2t = parcelRequire("cNe2t");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $2wyE1 = parcelRequire("2wyE1");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $ciFJV = parcelRequire("ciFJV");


var $7hqYU = parcelRequire("7hqYU");

var $c3kL8 = parcelRequire("c3kL8");

var $iEYgr = parcelRequire("iEYgr");

var $aCS3H = parcelRequire("aCS3H");
const $33926eb7c1ec50f9$var$Menu = ()=>{
    const fetchState = (0, $7hqYU.useFetchState)();
    const isLoading = (0, $7hqYU.useIsLoading)();
    const hasError = (0, $7hqYU.useHasError)();
    const isVisible = (0, $7hqYU.useIsVisible)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [startTime, setStartTime] = (0, $eJOHy.useState)(Date.now());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fetchState();
    }, [
        fetchState
    ]);
    if (isLoading || hasError || !isVisible) return null;
    const fireDurationEvent = ()=>{
        const duration = Date.now() - startTime;
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'JSMHRAutomationMenuPopup View', {
            duration: duration
        });
    };
    const showPopup = (open)=>{
        if (open) setStartTime(Date.now());
        else fireDurationEvent();
        setIsOpen(open);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>showPopup(false),
        placement: "bottom-end",
        messageId: "servicedesk-queues-automation-menu.ui.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iEYgr.MenuContent), {
                onClick: ()=>showPopup(false)
            }),
        trigger: ({ ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? null : $33926eb7c1ec50f9$var$menuButtonWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPZN1.default), {
                ...triggerProps,
                onClick: ()=>showPopup(!isOpen),
                isSelected: isOpen
            }))
    }), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null));
};
const $33926eb7c1ec50f9$export$578299f939d234e9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "queuesAutomationMenu",
        packageName: (0, $51ac28649bda1008$export$b8b9d90f9e5bd72b),
        teamName: (0, $51ac28649bda1008$export$d57b6b390e78d90f),
        fallback: "unmount"
    }, (0, $7jTnu.fg)('automation-templates-team-types-refactor-m1_isj0e') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wyE1.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: "queuesAutomationMenuNew"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c3kL8.AutomationMenu), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2aY2d.ProjectContextProvider), null, (projectContext)=>projectContext.data?.projectId !== undefined && projectContext.data?.projectId !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wyE1.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
            sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
            sourceName: "queuesAutomationMenu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7hqYU.MenuStateContainer), {
            scope: `project-${projectContext.data.projectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33926eb7c1ec50f9$var$Menu, null)))) : null));
const $33926eb7c1ec50f9$export$9af4bba9b7fc0be7 = ()=>{
    const fetchState = (0, $7hqYU.useFetchState)();
    const isLoading = (0, $7hqYU.useIsLoading)();
    const hasError = (0, $7hqYU.useHasError)();
    const isVisible = (0, $7hqYU.useIsVisible)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [startTime, setStartTime] = (0, $eJOHy.useState)(Date.now());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({}), []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $aCS3H.menuContentEntryPoint), entryPointParams);
    const fireDurationEvent = (0, $eJOHy.useCallback)(()=>{
        const duration = Date.now() - startTime;
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'JSMHRAutomationMenuPopup View', {
            duration: duration
        });
    }, [
        createAnalyticsEvent,
        startTime
    ]);
    const showPopup = (0, $eJOHy.useCallback)((open)=>{
        if (open) setStartTime(Date.now());
        else fireDurationEvent();
        setIsOpen(open);
    }, [
        fireDurationEvent,
        setStartTime
    ]);
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            onClick: ()=>showPopup(false)
        }), [
        showPopup
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchState();
    }, [
        fetchState
    ]);
    if (isLoading || hasError || !isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>showPopup(false),
        placement: "bottom-end",
        messageId: "servicedesk-queues-automation-menu.ui.popup.new",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "queue-automation-content-menu",
                packageName: "@atlassian/jira-servicedesk-queues-automation-menu",
                errorFallback: "flag",
                runtimeProps: runtimeProps
            }),
        trigger: ({ ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') ? null : $33926eb7c1ec50f9$var$menuButtonWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPZN1.default), {
                ...triggerProps,
                ref: (element)=>{
                    triggerRef(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                },
                onClick: ()=>showPopup(!isOpen),
                isSelected: isOpen
            }))
    }), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null));
};
const $33926eb7c1ec50f9$export$74da9177782daf20 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "queuesAutomationMenu",
        packageName: (0, $51ac28649bda1008$export$b8b9d90f9e5bd72b),
        teamName: (0, $51ac28649bda1008$export$d57b6b390e78d90f),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2aY2d.ProjectContextProvider), null, (projectContext)=>projectContext.data?.projectId !== undefined && projectContext.data?.projectId !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wyE1.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
            sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
            sourceName: "queuesAutomationMenu"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7hqYU.MenuStateContainer), {
            scope: `project-${projectContext.data.projectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33926eb7c1ec50f9$export$9af4bba9b7fc0be7, null)))) : null));
const $33926eb7c1ec50f9$var$menuButtonWrapperStyles = (0, $1DXK0.xcss)({
    paddingRight: 'space.100'
});

});
parcelRegister("gPZN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $496834f22af921da$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $fL0In = parcelRequire("fL0In");

var $dtpha = parcelRequire("dtpha");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $6zXPf = parcelRequire("6zXPf");

var $gCeeo = parcelRequire("gCeeo");

var $cJEMq = parcelRequire("cJEMq");

var $6XJko = parcelRequire("6XJko");

var $c3rOS = parcelRequire("c3rOS");

var $cfUHE = parcelRequire("cfUHE");
const $496834f22af921da$var$MenuButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isSelected: isSelected, onClick: onClick }, ref)=>{
    const automationIconTestId = 'automation-menu.ui.button.icon';
    const onClickWithAnalytics = (0, $eJOHy.useCallback)((event, analytics)=>{
        (0, $gCeeo.fireUIAnalytics)(analytics, 'automationMenuButton');
        onClick();
    }, [
        onClick
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $cfUHE.default).menuButtonTooltip),
        position: "top",
        isScreenReaderAnnouncementDisabled: true
    }, (0, $6zXPf.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cJEMq.ThemedButton), {
        ref: ref,
        appearance: (0, $6XJko.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onClick: onClickWithAnalytics,
        isSelected: isSelected,
        testId: "automation-menu.ui.button.menu-button",
        id: "automation-menu.ui.popup",
        "data-vc": "automation-menu-button" // @ts-expect-error - externalId does not exist on Button types
        ,
        externalId: "automation-menu.ui.button.menu-button",
        "aria-label": formatMessage((0, $cfUHE.default).menuButtonTooltip),
        "aria-expanded": isSelected,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtpha))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            testId: automationIconTestId
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ref: ref,
        appearance: "subtle",
        spacing: "none",
        isSelected: isSelected,
        onClick: onClickWithAnalytics,
        testId: "automation-menu.ui.button.menu-button",
        id: "automation-menu.ui.popup" // @ts-expect-error - externalId does not exist on Button types
        ,
        externalId: "automation-menu.ui.button.menu-button",
        "aria-label": formatMessage((0, $cfUHE.default).menuButtonTooltip),
        "aria-expanded": isSelected,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($496834f22af921da$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
            size: "medium",
            glyph: (0, $c3rOS.AutomationGlyph),
            label: "",
            primaryColor: isSelected ? "var(--ds-icon-selected, #0C66E4)" : undefined,
            secondaryColor: "none",
            testId: automationIconTestId
        }))
    }));
});
var $496834f22af921da$export$2e2bcd8739ae039 = $496834f22af921da$var$MenuButton;
const $496834f22af921da$var$unselectedColor = "var(--ds-text-subtle, #44546F)";
const $496834f22af921da$var$unselectedHoverColor = "var(--ds-text-subtlest, #626F86)";
const $496834f22af921da$var$multiplier = 4; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $496834f22af921da$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _syaz1gjq _30l3131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dtpha", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cf1970ee03bcd13$var$_react = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9cf1970ee03bcd13$var$_baseNew = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9cf1970ee03bcd13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cf1970ee03bcd13$var$AutomationIcon = (props)=>/*#__PURE__*/ $9cf1970ee03bcd13$var$_react.default.createElement($9cf1970ee03bcd13$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$9cf1970ee03bcd13$var$AutomationIcon.displayName = 'AutomationIcon';
var $9cf1970ee03bcd13$var$_default = module.exports.default = $9cf1970ee03bcd13$var$AutomationIcon;

});

parcelRegister("c3rOS", function(module, exports) {

$parcel$export(module.exports, "AutomationGlyph", () => $ca1b0bbb2612bc73$export$3b6023946faff8bc);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");
const $ca1b0bbb2612bc73$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));

});

parcelRegister("cfUHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd89adf9379e4d41$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cd89adf9379e4d41$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    menuButtonTooltip: {
        "id": "automation-menu.button.menu-button-tooltip",
        "defaultMessage": "Automation"
    },
    automationsMenuButtonIcon: {
        "id": "automation-menu.button.automations-menu-button-icon",
        "defaultMessage": "automations-menu-button-icon"
    }
});

});


parcelRegister("7hqYU", function(module, exports) {

$parcel$export(module.exports, "MenuStateContainer", () => $4fa7039d023a3999$export$630fdeb4dc9bffd9);
$parcel$export(module.exports, "useFetchState", () => $4fa7039d023a3999$export$c9fde2f306573970);
$parcel$export(module.exports, "useIsLoading", () => $4fa7039d023a3999$export$4dface15d86304a4);
$parcel$export(module.exports, "useHasError", () => $4fa7039d023a3999$export$5c51ec65d403eca);
$parcel$export(module.exports, "useIsVisible", () => $4fa7039d023a3999$export$6f8d6e7261983be1);
$parcel$export(module.exports, "useTemplateIds", () => $4fa7039d023a3999$export$64d7932ea94c2846);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $ljej9 = parcelRequire("ljej9");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $fN8GJ = parcelRequire("fN8GJ");
const $4fa7039d023a3999$var$initialState = {
    isLoading: false,
    isVisible: false,
    templateIds: undefined,
    error: undefined
};
const $4fa7039d023a3999$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    initialState: $4fa7039d023a3999$var$initialState,
    actions: $fN8GJ.actions,
    name: 'queues-automation-menu-state'
});
const $4fa7039d023a3999$export$630fdeb4dc9bffd9 = (0, $6E16M.createContainer)($4fa7039d023a3999$export$6f57813fe9f31bf9);
const $4fa7039d023a3999$var$useStoreActions = (0, $iJq0l.createActionsHook)($4fa7039d023a3999$export$6f57813fe9f31bf9);
const $4fa7039d023a3999$var$useTransformedStoreActions = ()=>{
    const { fetchState: fetchState } = $4fa7039d023a3999$var$useStoreActions();
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const projectId = (0, $ljej9.toProjectId)(`${project?.projectId}`);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useMemo)(()=>{
        const actionProps = {
            createAnalyticsEvent: createAnalyticsEvent,
            projectId: projectId
        };
        return {
            fetchState: fetchState(actionProps)
        };
    }, [
        createAnalyticsEvent,
        fetchState,
        projectId
    ]);
};
const $4fa7039d023a3999$export$c9fde2f306573970 = ()=>$4fa7039d023a3999$var$useTransformedStoreActions().fetchState;
const $4fa7039d023a3999$export$4dface15d86304a4 = (0, $iJq0l.createStateHook)($4fa7039d023a3999$export$6f57813fe9f31bf9, {
    selector: ({ isLoading: isLoading })=>isLoading
});
const $4fa7039d023a3999$export$5c51ec65d403eca = (0, $iJq0l.createStateHook)($4fa7039d023a3999$export$6f57813fe9f31bf9, {
    selector: ({ error: error })=>!!error
});
const $4fa7039d023a3999$export$6f8d6e7261983be1 = (0, $iJq0l.createStateHook)($4fa7039d023a3999$export$6f57813fe9f31bf9, {
    selector: ({ isVisible: isVisible })=>isVisible
});
const $4fa7039d023a3999$export$64d7932ea94c2846 = (0, $iJq0l.createStateHook)($4fa7039d023a3999$export$6f57813fe9f31bf9, {
    selector: ({ templateIds: templateIds })=>templateIds ?? []
});

});
parcelRegister("fN8GJ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4e89b8aeb5785527$export$e324594224ef24da);

var $60hu4 = parcelRequire("60hu4");
const $4e89b8aeb5785527$export$e324594224ef24da = {
    fetchState: $60hu4.fetchState
};

});
parcelRegister("60hu4", function(module, exports) {

$parcel$export(module.exports, "fetchState", () => $e02df2a72f935156$export$f3df9013f2b58bce);

var $2QO3b = parcelRequire("2QO3b");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");

var $8KUFq = parcelRequire("8KUFq");

var $gCeeo = parcelRequire("gCeeo");

const $e02df2a72f935156$export$f3df9013f2b58bce = ({ projectId: projectId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async ()=>{
            const { isLoading: isLoading, templateIds: templateIds } = getState();
            if (isLoading || templateIds) return;
            try {
                const fetchStartTime = performance.now();
                const { showAutomation: showAutomation, genericTemplateIds: genericTemplateIds } = await (0, $1Ozm9.default)(`/rest/servicedesk/latest/automation/templates/${projectId}`);
                (0, $2QO3b.addSpanToAll)('fetch', 'rest/servicedesk/latest/automation/templates/projectId', [
                    {
                        name: 'network'
                    }
                ], fetchStartTime, performance.now());
                setState({
                    isVisible: showAutomation,
                    templateIds: genericTemplateIds
                });
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $51ac28649bda1008$export$b8b9d90f9e5bd72b)}.fetchState succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                !(0, $8KUFq.isClientFetchError)(error) && (0, $gYnSx.default)({
                    error: error,
                    meta: {
                        id: 'fetchState',
                        packageName: (0, $51ac28649bda1008$export$b8b9d90f9e5bd72b),
                        teamName: (0, $51ac28649bda1008$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});



parcelRegister("c3kL8", function(module, exports) {

$parcel$export(module.exports, "AutomationMenu", () => $3066f918106745d3$export$bf60e24e2fb3b05d);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $bgAK6 = parcelRequire("bgAK6");

var $jbPE2 = parcelRequire("jbPE2");

var $7jTnu = parcelRequire("7jTnu");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $3nRRD = parcelRequire("3nRRD");

var $76rlq = parcelRequire("76rlq");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $JHxCO = parcelRequire("JHxCO");

var $jlJsl = parcelRequire("jlJsl");

var $kEUB1 = parcelRequire("kEUB1");

var $g1NZW = parcelRequire("g1NZW");


var $7gKoi = parcelRequire("7gKoi");

var $1ZCdB = parcelRequire("1ZCdB");

var $fNWzi = parcelRequire("fNWzi");

var $evJAa = parcelRequire("evJAa");
const $3066f918106745d3$export$bf60e24e2fb3b05d = ()=>{
    const cloudID = (0, $kEUB1.useCloudId)();
    const environment = (0, $g1NZW.useEnvironment)();
    const { locale: locale } = (0, $lRq8t.default)();
    const enabledPractices = (0, $JHxCO.useWorkCategoriesAllSupported)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const projectContext = (0, $2aY2d.useProjectContext)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const automationEnabled = !!(0, $76rlq.useSettingFeatures)().data?.hasProjectAutomation;
    const onFetchFailedHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $51ac28649bda1008$export$b8b9d90f9e5bd72b)}.onFetch failed`);
    }, [
        createAnalyticsEvent
    ]);
    const onFetchSuccessHandler = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $51ac28649bda1008$export$b8b9d90f9e5bd72b)}.onFetch succeeded`);
    }, [
        createAnalyticsEvent
    ]);
    if (!automationEnabled) return null;
    if (!projectContext.data) {
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $51ac28649bda1008$export$b8b9d90f9e5bd72b)}.useProjectContext failed`);
        return null;
    }
    const { projectKey: projectKey, simplified: simplified, projectType: projectType, projectId: projectId } = projectContext.data;
    const automationBaseUrl = (0, $jbPE2.getBaseAutomationUrl)({
        projectKey: `${projectKey}`,
        isSimplified: simplified || false,
        projectType: projectType
    });
    // automationBaseUrl is needed, depends on projectContext.data
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onCreateFailureHandler = (0, $eJOHy.useCallback)((templateId)=>{
        const flagId = (0, $hrodw.toFlagId)((0, $aXKmr.v4)());
        showFlag({
            id: flagId,
            render: (flagProps)=>{
                const props = {
                    automationBaseUrl: automationBaseUrl,
                    flagKey: String(flagProps.key),
                    flagId: flagId,
                    templateId: templateId,
                    messageId: 'servicedesk-queues-automation-menu.ui.automation-menu.props.show-flag.error',
                    messageType: 'transactional'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ZCdB.FailureFlag), props);
            }
        });
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $51ac28649bda1008$export$b8b9d90f9e5bd72b)}.onCreate failed`);
    }, [
        automationBaseUrl,
        createAnalyticsEvent,
        showFlag
    ]);
    // automationBaseUrl is needed, depends on projectContext.data
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onCreateSuccessHandler = (0, $eJOHy.useCallback)((templateId, ruleId)=>{
        const flagId = (0, $hrodw.toFlagId)((0, $aXKmr.v4)());
        showFlag({
            id: flagId,
            render: (flagProps)=>{
                const props = {
                    automationBaseUrl: automationBaseUrl,
                    flagKey: String(flagProps.key),
                    flagId: flagId,
                    ruleId: ruleId,
                    messageId: 'servicedesk-queues-automation-menu.ui.automation-menu.props.show-flag.success',
                    messageType: 'transactional'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fNWzi.SuccessFlag), props);
            }
        });
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $51ac28649bda1008$export$b8b9d90f9e5bd72b)}.onCreate succeeded`);
    }, [
        automationBaseUrl,
        createAnalyticsEvent,
        showFlag
    ]);
    if (enabledPractices.loading) return null;
    if (enabledPractices.error) {
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $51ac28649bda1008$export$b8b9d90f9e5bd72b)}.useWorkCategoriesAllSupported failed`);
        return null;
    }
    const isChangeManagementPracticeEnabled = enabledPractices.data?.includes((0, $jlJsl.CHANGES)) || false;
    // projectId and isChangeManagementPracticeEnabled is needed, depends on projectContext.data and enabledPractices.data
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const templateCategories = (0, $evJAa.useTemplateCategories)(projectId, isChangeManagementPracticeEnabled);
    if (templateCategories.loading) return null;
    const mappedEnvironment = (0, $7gKoi.mapEnv)(environment, (0, $7jTnu.fg)('automation-dev-helper'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3066f918106745d3$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nRRD.IntlProvider), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bgAK6.TemplateDropdown), {
        env: mappedEnvironment,
        site: `ari:cloud:jira::site/${cloudID}`,
        query: {
            categories: templateCategories.data
        },
        baseAutomationUrl: automationBaseUrl,
        targetRuleHome: `ari:cloud:jira:${cloudID}:project/${projectId}`,
        onCreateFailure: onCreateFailureHandler,
        onCreateSuccess: onCreateSuccessHandler,
        onFetchFailed: onFetchFailedHandler,
        onFetchSuccess: onFetchSuccessHandler,
        dropdownMenuProps: {
            placement: 'bottom-end'
        }
    })));
};
const $3066f918106745d3$var$styles = (0, $1DXK0.xcss)({
    marginRight: 'space.100',
    whiteSpace: 'normal'
});

});
parcelRegister("bgAK6", function(module, exports) {

$parcel$export(module.exports, "TemplateDropdown", () => $5b91a03c3b1a8eb8$export$81df7d2113ca94c4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");

var $eJ9f5 = parcelRequire("eJ9f5");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $ftAob = parcelRequire("ftAob");

var $aUdi2 = parcelRequire("aUdi2");
var $5sYBz = parcelRequire("5sYBz");
var $38aOM = parcelRequire("38aOM");

var $3dADJ = parcelRequire("3dADJ");

var $dwEiw = parcelRequire("dwEiw");

var $ewuOV = parcelRequire("ewuOV");

var $9Ly7H = parcelRequire("9Ly7H");

var $kzuqP = parcelRequire("kzuqP");
const $5b91a03c3b1a8eb8$var$headerStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.25rem',
    paddingTop: 'space.250',
    paddingRight: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.250',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase'
});
const $5b91a03c3b1a8eb8$var$descriptionStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.25rem',
    paddingTop: 'space.0',
    paddingRight: 'space.250',
    paddingBottom: 'space.100',
    paddingLeft: 'space.250'
});
const $5b91a03c3b1a8eb8$var$linkStyles = (0, $1DXK0.xcss)({
    font: 'font.body',
    fontWeight: 'font.weight.regular',
    color: 'color.link',
    paddingTop: 'space.100',
    paddingRight: 'space.250',
    paddingBottom: 'space.200',
    paddingLeft: 'space.250'
});
const $5b91a03c3b1a8eb8$var$menuStyles = (0, $1DXK0.xcss)({
    width: '21.75rem'
});
const $5b91a03c3b1a8eb8$var$tooltipOptions = {
    position: 'top',
    hideTooltipOnClick: false
};
/**
 * TemplateSubMenu decides whether to display the empty state, or the list of templates based on the error and templates props.
 * @param templates - The list of templates (of type {@link Template}) to display.
 * @param ruleLibraryUrl - The URL to the rule library.
 * @param targetRuleHome - The scope which rules should be created under.
 * @param createRuleOrShowDialog - The function to call when a template is selected.
 * @param isDisabled - Boolean to determine if the dropdown is disabled (e.g. when the user clicks on the template to create a rule).
 * @param error - The error message to display.
 */ const $5b91a03c3b1a8eb8$var$TemplateSubMenu = ({ templates: templates, ruleLibraryUrl: ruleLibraryUrl, targetRuleHome: targetRuleHome, createRuleOrShowDialog: createRuleOrShowDialog, isDisabled: isDisabled, error: error })=>{
    const shouldShowEmptyState = error || !templates?.length;
    if (shouldShowEmptyState) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dwEiw.TemplateEmptyState), {
        ruleLibraryUrl: ruleLibraryUrl
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $5b91a03c3b1a8eb8$var$descriptionStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    color: "color.text.subtle",
                    weight: "regular",
                    size: "UNSAFE_small",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $kzuqP.messages).templateDropdownDescription
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewuOV.TemplateList), {
                templates: templates,
                onTemplateSelected: (templateId)=>createRuleOrShowDialog(templateId, targetRuleHome),
                isDisabled: isDisabled
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $5b91a03c3b1a8eb8$var$linkStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                    href: ruleLibraryUrl,
                    testId: "discover-templates-link",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $kzuqP.messages).discoverMoreTemplates
                    })
                })
            })
        ]
    });
};
const $5b91a03c3b1a8eb8$export$81df7d2113ca94c4 = ({ env: env, site: site, query: query, targetRuleHome: targetRuleHome, onCreateFailure: onCreateFailure, onCreateSuccess: onCreateSuccess, onFetchSuccess: onFetchSuccess, onFetchFailed: onFetchFailed, baseAutomationUrl: baseAutomationUrl, dropdownMenuProps: dropdownMenuProps })=>{
    (0, $gRw8I.di)((0, $ftAob.default));
    const ruleLibraryUrl = `${baseAutomationUrl}#/tab/rule-library`;
    const [didOpen, setDidOpen] = (0, $eJOHy.useState)(false);
    const handleOpen = async (fetchNext, isOpen)=>{
        if (didOpen || !isOpen) return;
        await fetchNext();
        setDidOpen(true);
    };
    return(// Note: The limit prop is set to 5, to allow displaying up to 5 templates in the dropdown, as per design guidelines.
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aUdi2.AutomationIntlMessagesProvider), {
        locales: (0, $3dADJ.locales),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ftAob.default), {
            env: env,
            site: site,
            query: query,
            limit: 5,
            onCreateSuccess: onCreateSuccess,
            onCreateFailure: onCreateFailure,
            onFetchSuccess: onFetchSuccess,
            onFetchFailed: onFetchFailed,
            children: ({ isLoading: isLoading, isDisabled: isDisabled, templates: templates, fetchNext: fetchNext, error: error, createRuleOrShowDialog: createRuleOrShowDialog })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
                    ...dropdownMenuProps,
                    trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            ...props,
                            label: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $kzuqP.messages).templateDropdownTooltipLabel
                            }),
                            isTooltipDisabled: false,
                            testId: "automation-button",
                            tooltip: $5b91a03c3b1a8eb8$var$tooltipOptions,
                            ref: triggerRef,
                            icon: (0, $9Ly7H.AutomationGlyph),
                            appearance: "subtle"
                        }),
                    isLoading: isLoading,
                    onOpenChange: (args)=>handleOpen(fetchNext, args.isOpen),
                    testId: "template-dropdown",
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                        grow: "hug",
                        testId: "template.dropdown",
                        xcss: $5b91a03c3b1a8eb8$var$menuStyles,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                                xcss: $5b91a03c3b1a8eb8$var$headerStyles,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                                    color: "color.text.subtle",
                                    weight: "semibold",
                                    size: "UNSAFE_small",
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                        ...(0, $kzuqP.messages).templateDropdownTitle
                                    })
                                })
                            }),
                            error ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5sYBz.default), {}) : /*#__PURE__*/ (0, $gt9Am.jsx)($5b91a03c3b1a8eb8$var$TemplateSubMenu, {
                                templates: templates,
                                ruleLibraryUrl: ruleLibraryUrl,
                                targetRuleHome: targetRuleHome,
                                createRuleOrShowDialog: createRuleOrShowDialog,
                                isDisabled: isDisabled,
                                error: error
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38aOM.default), {
                                baseAutomationUrl: baseAutomationUrl
                            })
                        ]
                    })
                })
        })
    }));
};

});
parcelRegister("ftAob", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c53551b4d2eed9d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $956it = parcelRequire("956it");

var $aUdi2 = parcelRequire("aUdi2");

var $63yBZ = parcelRequire("63yBZ");

var $iLgGc = parcelRequire("iLgGc");

var $esaMe = parcelRequire("esaMe");

var $hviHA = parcelRequire("hviHA");
/**
 * Higher-Order-Component for communicating with the Automation Public REST API's Templates domain. You can read more about this
 * API [here](https://developer.atlassian.com/cloud/automation/rest/api-group-rest/#api-rest-v1-template-search-get)
 */ const $6c53551b4d2eed9d$var$TemplatesContainer = ({ env: env, site: site, query: query, limit: limit, onCreateFailure: onCreateFailure, onCreateSuccess: onCreateSuccess, onFetchSuccess: onFetchSuccess, onFetchFailed: onFetchFailed, children: children })=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [isDisabled, setIsDisabled] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [lastResponse, setLastResponse] = (0, $eJOHy.useState)(null);
    const [atStartBoundary, setAtStartBoundary] = (0, $eJOHy.useState)(false);
    const [atEndBoundary, setAtEndBoundary] = (0, $eJOHy.useState)(false);
    // TODO likely combine these
    const [ruleCreation, setRuleCreation] = (0, $eJOHy.useState)(null);
    const templatesClient = (0, $eJOHy.useMemo)(()=>new (0, $esaMe.default)(env, site), [
        env,
        site
    ]);
    /**
	 * Perform a fetch to the API. This helper will handle the loading and error state. The fetcher
	 * argument will either be the initial search query, or a fetcher in a page direction.
	 */ const _handleFetch = async (fetcher)=>{
        setIsLoading(true);
        try {
            // Note safe cast here as we bail the try block if resolving the type ApiErrorResponse
            const result = await fetcher();
            // Once we've hit the last page (i.e. the client didn't bother with another request),
            // Don't update the result.
            if (result === null) return;
            // If the response from the client does contain a result (we didn't attempt to a
            // page that doesn't exist), then update the boundary flags according to the
            // presence of the previous and next links.
            setAtStartBoundary(false);
            setAtEndBoundary(false);
            if (!result.links.next) setAtEndBoundary(true);
            if (!result.links.prev) setAtStartBoundary(true);
            // Set the result only if there is a result.
            setLastResponse(result);
            onFetchSuccess?.(result.data);
        } catch (e) {
            setError(e.message);
            onFetchFailed?.(e.message);
        } finally{
            setIsLoading(false);
        }
    };
    const _handleCreate = async (templateId, ruleHome, parameters)=>{
        setIsDisabled(true);
        try {
            const response = await templatesClient.createRuleFromTemplate(templateId, ruleHome, parameters);
            onCreateSuccess?.(templateId, response.ruleId);
        } catch (e) {
            const errorMessage = e.message;
            onCreateFailure?.(templateId, errorMessage);
        } finally{
            setIsDisabled(false);
            setRuleCreation(null);
        }
    };
    /**
	 * When paging forwards, if no prior request has been made a consequently no links exist to follow,
	 * then perform the initial request. Otherwise, follow the next link (if present).
	 */ const fetchNext = async ()=>{
        if (atEndBoundary) return;
        if (!lastResponse) return _handleFetch(()=>templatesClient.searchTemplatesByFilters(query, limit));
        return _handleFetch(()=>templatesClient.getNextSearchPageResults(lastResponse, limit));
    };
    const fetchPrev = async ()=>{
        if (!lastResponse || atStartBoundary) return;
        return _handleFetch(()=>templatesClient.getPrevSearchPageResults(lastResponse, limit));
    };
    const fetchCurrent = async ()=>{
        if (!lastResponse) return;
        return _handleFetch(()=>templatesClient.getCurrentSearchPageResults(lastResponse, limit));
    };
    const createRuleOrShowDialog = async (templateId, ruleHome)=>{
        if (!lastResponse) return onCreateFailure?.(templateId, 'Cannot find template with id ' + templateId);
        const maybeTemplate = lastResponse.data.find((template)=>template.id === templateId);
        if (!maybeTemplate) return onCreateFailure?.(templateId, 'Cannot find template with id ' + templateId);
        try {
            (0, $63yBZ.ResourceIdentifier).parse(ruleHome);
        } catch (e) {
            return onCreateFailure?.(templateId, 'Provided ruleHome is not a valid ARI: ' + ruleHome);
        }
        // If the template has parameters, handle this with the form. If not, create a rule.
        if (maybeTemplate.parameters.length !== 0) {
            setRuleCreation({
                template: maybeTemplate,
                ruleHome: ruleHome
            });
            return;
        }
        return _handleCreate(templateId, ruleHome);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aUdi2.AutomationIntlMessagesProvider), {
        locales: (0, $iLgGc.locales),
        children: [
            children({
                isLoading: isLoading,
                isDisabled: isDisabled,
                atStartBoundary: atStartBoundary,
                atEndBoundary: atEndBoundary,
                error: error,
                // Normalise to null here as the templates variable is set but has no value
                templates: lastResponse?.data ?? null,
                fetchPrev: fetchPrev,
                fetchCurrent: fetchCurrent,
                fetchNext: fetchNext,
                createRuleOrShowDialog: createRuleOrShowDialog
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
                children: ruleCreation && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hviHA.default), {
                    targetRuleCreation: ruleCreation,
                    clearSelectedTemplate: ()=>setRuleCreation(null),
                    createRule: (parameters)=>_handleCreate(ruleCreation.template.id, ruleCreation.ruleHome, parameters)
                })
            })
        ]
    });
};
var $6c53551b4d2eed9d$export$2e2bcd8739ae039 = $6c53551b4d2eed9d$var$TemplatesContainer;

});
parcelRegister("aUdi2", function(module, exports) {

$parcel$export(module.exports, "locales", () => $e92ea5eaed775272$export$df1c34db1371eeed);
$parcel$export(module.exports, "AutomationIntlMessagesProvider", () => $e92ea5eaed775272$export$ddf313a17c78c281);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3JwXA = parcelRequire("3JwXA");

var $cLr92 = parcelRequire("cLr92");






















const $e92ea5eaed775272$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("eUXTW")),
    da: ()=>(parcelRequire("jcMmA")),
    de: ()=>(parcelRequire("llGYF")),
    en_GB: ()=>(parcelRequire("ctiru")),
    en_ZZ: ()=>(parcelRequire("7mgxj")),
    en: ()=>Promise.resolve((parcelRequire("cLr92"))),
    es: ()=>(parcelRequire("dUBBj")),
    fi: ()=>(parcelRequire("98rlq")),
    fr: ()=>(parcelRequire("bDtuN")),
    hu: ()=>(parcelRequire("6ji74")),
    it: ()=>(parcelRequire("kEOA1")),
    ja: ()=>(parcelRequire("akBqQ")),
    ko: ()=>(parcelRequire("1kO5J")),
    nb: ()=>(parcelRequire("6Htx9")),
    nl: ()=>(parcelRequire("beYBq")),
    pl: ()=>(parcelRequire("dE1au")),
    pt_BR: ()=>(parcelRequire("hmMuc")),
    ru: ()=>(parcelRequire("60xly")),
    sv: ()=>(parcelRequire("4tCOF")),
    tr: ()=>(parcelRequire("9Z6Uv")),
    zh_TW: ()=>(parcelRequire("kbtJM")),
    zh: ()=>(parcelRequire("i5MzE"))
};
const $e92ea5eaed775272$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $e92ea5eaed775272$var$fetchMessagesForLocale = async (locale, locales)=>{
    try {
        const targetLocale = ($e92ea5eaed775272$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in locales) {
            const messages = await locales[targetLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in locales) {
            const messages = await locales[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    // Set English as default.
    return 0, $cLr92.default;
};
const $e92ea5eaed775272$var$createLoaderFunction = (locales)=>{
    // Since loaderFn expects a single argument, we need this wrapper function to pass in the locales object to fetchMessagesForLocale.
    return async (locale)=>{
        return $e92ea5eaed775272$var$fetchMessagesForLocale(locale, locales);
    };
};
const $e92ea5eaed775272$export$ddf313a17c78c281 = ({ locales: locales, children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JwXA.default), {
        loaderFn: $e92ea5eaed775272$var$createLoaderFunction(locales),
        children: children
    });
};

});
parcelRegister("cLr92", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a7474533ef8565e4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $a7474533ef8565e4$export$2e2bcd8739ae039 = {
    'automation-platform.error.desc': "It's taking us longer than expected to show this content. It's probably a temporary problem. Try refreshing or navigating to another page.",
    'automation-platform.error.title': "We're having some trouble",
    'automation-platform.footer.audit-log-item': 'Audit log',
    'automation-platform.footer.create-automation-item': 'Create automation',
    'automation-platform.footer.manage-automations-item': 'Manage automations'
};

});

parcelRegister("eUXTW", function(module, exports) {

let $adc4c2cbbc60a53a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $adc4c2cbbc60a53a$var$load("aBfDn").then(()=>parcelRequire('6sSCB'));

});

parcelRegister("jcMmA", function(module, exports) {

let $dfb4a73d4fda8556$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dfb4a73d4fda8556$var$load("iCRZO").then(()=>parcelRequire('eGfmU'));

});

parcelRegister("llGYF", function(module, exports) {

let $f8ace5995f6e51b2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f8ace5995f6e51b2$var$load("gdvLA").then(()=>parcelRequire('Qdy3K'));

});

parcelRegister("ctiru", function(module, exports) {

let $91467fc35b3ddd0c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $91467fc35b3ddd0c$var$load("a7wst").then(()=>parcelRequire('fRkgs'));

});

parcelRegister("7mgxj", function(module, exports) {

let $55b76a41799a671e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $55b76a41799a671e$var$load("3H1xL").then(()=>parcelRequire('8skZo'));

});

parcelRegister("dUBBj", function(module, exports) {

let $a20dac1434f2f001$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a20dac1434f2f001$var$load("enKEH").then(()=>parcelRequire('fMm2x'));

});

parcelRegister("98rlq", function(module, exports) {

let $6a6a127a281b5cd8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6a6a127a281b5cd8$var$load("asJK9").then(()=>parcelRequire('eW2Qg'));

});

parcelRegister("bDtuN", function(module, exports) {

let $878a3770280d81a0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $878a3770280d81a0$var$load("4U9sj").then(()=>parcelRequire('kZgQO'));

});

parcelRegister("6ji74", function(module, exports) {

let $498291474b33eb43$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $498291474b33eb43$var$load("QHg8M").then(()=>parcelRequire('7Lwj2'));

});

parcelRegister("kEOA1", function(module, exports) {

let $f09ec735579dd3e6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f09ec735579dd3e6$var$load("eFRah").then(()=>parcelRequire('4bwjc'));

});

parcelRegister("akBqQ", function(module, exports) {

let $7858ced7a168c4b7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7858ced7a168c4b7$var$load("k3F0x").then(()=>parcelRequire('6oCsW'));

});

parcelRegister("1kO5J", function(module, exports) {

let $0f8e83ce4debd8f5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0f8e83ce4debd8f5$var$load("jSQIC").then(()=>parcelRequire('ge8ip'));

});

parcelRegister("6Htx9", function(module, exports) {

let $4e0dab049d8c96f5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4e0dab049d8c96f5$var$load("9mJ5n").then(()=>parcelRequire('01Spb'));

});

parcelRegister("beYBq", function(module, exports) {

let $82f002efba990fe6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $82f002efba990fe6$var$load("1lSFQ").then(()=>parcelRequire('1OvyW'));

});

parcelRegister("dE1au", function(module, exports) {

let $9eefeac3dc50c167$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9eefeac3dc50c167$var$load("3CJZ5").then(()=>parcelRequire('99Igx'));

});

parcelRegister("hmMuc", function(module, exports) {

let $ca4a1a181bcef83a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ca4a1a181bcef83a$var$load("bXaa4").then(()=>parcelRequire('5JaZU'));

});

parcelRegister("60xly", function(module, exports) {

let $45fc9c21c7d751f2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $45fc9c21c7d751f2$var$load("e5NQ2").then(()=>parcelRequire('iDHEU'));

});

parcelRegister("4tCOF", function(module, exports) {

let $3427faf7dfb49ddb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3427faf7dfb49ddb$var$load("lxxXj").then(()=>parcelRequire('767lq'));

});

parcelRegister("9Z6Uv", function(module, exports) {

let $744f2bd37e1ae7f5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $744f2bd37e1ae7f5$var$load("kMqQ0").then(()=>parcelRequire('2RsU7'));

});

parcelRegister("kbtJM", function(module, exports) {

let $eb1be6f739e8a201$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $eb1be6f739e8a201$var$load("h3ztO").then(()=>parcelRequire('kN4fc'));

});

parcelRegister("i5MzE", function(module, exports) {

let $d2be5f6481e53204$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d2be5f6481e53204$var$load("kFrP4").then(()=>parcelRequire('c7VDH'));

});


parcelRegister("63yBZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

var $ik6eF = parcelRequire("ik6eF");

$dnskZ.__exportStar((parcelRequire("jWqQq")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $468ddf0950beb311$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $468ddf0950beb311$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $468ddf0950beb311$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $468ddf0950beb311$var$InvalidAriError;
function $468ddf0950beb311$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $468ddf0950beb311$var$basicCharConstraint = $ik6eF.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $468ddf0950beb311$var$resourceTypeCharConstraints = $ik6eF.pattern(/^[a-z][a-z.-]*$/i);
const $468ddf0950beb311$var$resourceOwnerConstraints = [
    $ik6eF.lengthBetween(3, 255),
    $468ddf0950beb311$var$basicCharConstraint
];
const $468ddf0950beb311$var$resourceTypeConstraints = [
    $ik6eF.lengthBetween(3, 255),
    $468ddf0950beb311$var$resourceTypeCharConstraints
];
const $468ddf0950beb311$var$cloudIdConstraints = [
    $ik6eF.lengthBetween(3, 255)
];
const $468ddf0950beb311$var$siteResourceType = 'site';
const $468ddf0950beb311$var$resourceIdChars = /[\w-._~:@#]/.source;
const $468ddf0950beb311$var$resourceIdConstraints = [
    $ik6eF.pattern(new RegExp(`^${$468ddf0950beb311$var$resourceIdChars}+(/${$468ddf0950beb311$var$resourceIdChars}*)*(;v=${$468ddf0950beb311$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $468ddf0950beb311$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $468ddf0950beb311$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $468ddf0950beb311$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $468ddf0950beb311$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $468ddf0950beb311$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        return new $468ddf0950beb311$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $468ddf0950beb311$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $468ddf0950beb311$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $468ddf0950beb311$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $468ddf0950beb311$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $468ddf0950beb311$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $468ddf0950beb311$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $468ddf0950beb311$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $468ddf0950beb311$var$siteResourceType && !!other.resourceType || $468ddf0950beb311$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $468ddf0950beb311$var$siteResourceType && !!other.resourceType || $468ddf0950beb311$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $468ddf0950beb311$var$siteResourceType && !cloudId) return new $ik6eF.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $ik6eF.validateField(this, 'resourceOwner', $468ddf0950beb311$var$resourceOwnerConstraints),
            $ik6eF.validateField(this, 'resourceType', $468ddf0950beb311$var$resourceTypeConstraints),
            $ik6eF.validateField(this, 'resourceId', $468ddf0950beb311$var$resourceIdConstraints),
            $ik6eF.validateField(this, 'cloudId', $468ddf0950beb311$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $468ddf0950beb311$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $468ddf0950beb311$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $468ddf0950beb311$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $468ddf0950beb311$var$parse(ariString) {
    return $468ddf0950beb311$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $468ddf0950beb311$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $468ddf0950beb311$var$parseEncoded(encodedAriString) {
    return $468ddf0950beb311$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $468ddf0950beb311$var$parseEncoded;

});
parcelRegister("ik6eF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eDoz3 = parcelRequire("eDoz3");
class $d56eee7d06fcc64a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $d56eee7d06fcc64a$var$LengthConstraint;
class $d56eee7d06fcc64a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $d56eee7d06fcc64a$var$RegexConstraint;
class $d56eee7d06fcc64a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $d56eee7d06fcc64a$var$GeneralValidationError;
class $d56eee7d06fcc64a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $d56eee7d06fcc64a$var$ConstraintViolation;
function $d56eee7d06fcc64a$var$lengthBetween(min, max) {
    return new $d56eee7d06fcc64a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $d56eee7d06fcc64a$var$lengthBetween;
function $d56eee7d06fcc64a$var$pattern(regex) {
    return new $d56eee7d06fcc64a$var$RegexConstraint(regex);
}
module.exports.pattern = $d56eee7d06fcc64a$var$pattern;
function $d56eee7d06fcc64a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($eDoz3.isDefined);
    return violatedConstraints.length > 0 ? new $d56eee7d06fcc64a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $d56eee7d06fcc64a$var$validateField;

});
parcelRegister("eDoz3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $aa77c3314e9d9437$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $aa77c3314e9d9437$var$isPresent;
function $aa77c3314e9d9437$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $aa77c3314e9d9437$var$isDefined;
function $aa77c3314e9d9437$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $aa77c3314e9d9437$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $aa77c3314e9d9437$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $aa77c3314e9d9437$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $aa77c3314e9d9437$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $aa77c3314e9d9437$var$hasValueAtKey;

});


parcelRegister("jWqQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4ZFVe = parcelRequire("4ZFVe");
var $e84841da69f5e74e$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($e84841da69f5e74e$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $e84841da69f5e74e$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $e84841da69f5e74e$var$AppFamilyAriError;
class $e84841da69f5e74e$var$NotAppFamilyAriError extends $e84841da69f5e74e$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $e84841da69f5e74e$var$NotAppFamilyAriError;
class $e84841da69f5e74e$var$NotExpectedAppFamilyAriTypeError extends $e84841da69f5e74e$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $e84841da69f5e74e$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $e84841da69f5e74e$var$parseAppAri(ari) {
    return $4ZFVe.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $e84841da69f5e74e$var$parseAppAri;
function $e84841da69f5e74e$var$createAppAri(json) {
    return new $4ZFVe.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $e84841da69f5e74e$var$createAppAri;

});
parcelRegister("4ZFVe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jWqQq = parcelRequire("jWqQq");

var $63yBZ = parcelRequire("63yBZ");

var $ik6eF = parcelRequire("ik6eF");
const $3a2d60ca363a4626$var$versionPrefix = ';v=';
const $3a2d60ca363a4626$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $3a2d60ca363a4626$var$uuidConstraints = [
    $ik6eF.pattern(new RegExp(`^${$3a2d60ca363a4626$var$uuidRegExpString}$`, 'i'))
];
const $3a2d60ca363a4626$var$extensionGroupIdConstraints = [
    $ik6eF.pattern(new RegExp(`^(${$3a2d60ca363a4626$var$uuidRegExpString}|static)$`, 'i'))
];
class $3a2d60ca363a4626$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $jWqQq.AppFamilyAri.resourceOwner) throw new $jWqQq.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$jWqQq.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $jWqQq.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $jWqQq.NotAppFamilyAriError(ari, `resourceType must be one of ${$jWqQq.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $jWqQq.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($3a2d60ca363a4626$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($3a2d60ca363a4626$var$versionPrefix) > versionIndex) throw new $jWqQq.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($3a2d60ca363a4626$var$versionPrefix);
        const segments = mainResourceId.split('/').map($3a2d60ca363a4626$var$stripToUndefined);
        if (segments.length > 4) throw new $jWqQq.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $jWqQq.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $jWqQq.AppFamilyAri.extensionGroupResourceType || resourceType === $jWqQq.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $jWqQq.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$jWqQq.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$jWqQq.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$jWqQq.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$jWqQq.AppFamilyAri.environmentResourceType}`);
        return new $3a2d60ca363a4626$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $jWqQq.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $ik6eF.validateField(this, 'environmentId', $3a2d60ca363a4626$var$uuidConstraints),
            $ik6eF.validateField(this, 'appId', $3a2d60ca363a4626$var$uuidConstraints),
            $ik6eF.validateField(this, 'extensionGroupId', $3a2d60ca363a4626$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $63yBZ.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $jWqQq.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$3a2d60ca363a4626$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $3a2d60ca363a4626$var$AppFamilyAriImpl;
function $3a2d60ca363a4626$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});



parcelRegister("iLgGc", function(module, exports) {

$parcel$export(module.exports, "locales", () => $60a4ee96e89c688f$export$df1c34db1371eeed);






















const $60a4ee96e89c688f$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("k5kyH")),
    da: ()=>(parcelRequire("eKD9p")),
    de: ()=>(parcelRequire("4VZS6")),
    en_GB: ()=>(parcelRequire("hK4nY")),
    en_ZZ: ()=>(parcelRequire("dg68I")),
    en: ()=>(parcelRequire("xOOrN")),
    es: ()=>(parcelRequire("2Ll2Q")),
    fi: ()=>(parcelRequire("gew0m")),
    fr: ()=>(parcelRequire("ajobW")),
    hu: ()=>(parcelRequire("fEnCA")),
    it: ()=>(parcelRequire("ew6eT")),
    ja: ()=>(parcelRequire("3TJbO")),
    ko: ()=>(parcelRequire("dzGGG")),
    nb: ()=>(parcelRequire("k2oBe")),
    nl: ()=>(parcelRequire("8huze")),
    pl: ()=>(parcelRequire("7ptdM")),
    pt_BR: ()=>(parcelRequire("e7NqT")),
    ru: ()=>(parcelRequire("i8PfE")),
    sv: ()=>(parcelRequire("cCpUh")),
    tr: ()=>(parcelRequire("erWCe")),
    zh_TW: ()=>(parcelRequire("c3GNV")),
    zh: ()=>(parcelRequire("d5Fx7"))
};

});
parcelRegister("k5kyH", function(module, exports) {

let $e9f438cb8a4801a7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e9f438cb8a4801a7$var$load("lHtqD").then(()=>parcelRequire('cSmNm'));

});

parcelRegister("eKD9p", function(module, exports) {

let $abd3bb12da108c76$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $abd3bb12da108c76$var$load("9W5Gt").then(()=>parcelRequire('dQVYD'));

});

parcelRegister("4VZS6", function(module, exports) {

let $397c7ab7de48431d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $397c7ab7de48431d$var$load("7FkpQ").then(()=>parcelRequire('9SDOG'));

});

parcelRegister("hK4nY", function(module, exports) {

let $ceaa2275c3ae3086$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ceaa2275c3ae3086$var$load("x3B4N").then(()=>parcelRequire('2POxN'));

});

parcelRegister("dg68I", function(module, exports) {

let $9a718829fce57c8b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9a718829fce57c8b$var$load("7tyeZ").then(()=>parcelRequire('eEcEr'));

});

parcelRegister("xOOrN", function(module, exports) {

let $065a7f84e7945a28$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $065a7f84e7945a28$var$load("k7B8s").then(()=>parcelRequire('8AhOw'));

});

parcelRegister("2Ll2Q", function(module, exports) {

let $20304ba2c3c5e0ff$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $20304ba2c3c5e0ff$var$load("diAzz").then(()=>parcelRequire('lArds'));

});

parcelRegister("gew0m", function(module, exports) {

let $bd16c79ed1acf181$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bd16c79ed1acf181$var$load("iZK5Q").then(()=>parcelRequire('lmL3T'));

});

parcelRegister("ajobW", function(module, exports) {

let $781e71b2cb5cf9ca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $781e71b2cb5cf9ca$var$load("eP8qS").then(()=>parcelRequire('2fm6x'));

});

parcelRegister("fEnCA", function(module, exports) {

let $b64cea2d25d021aa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b64cea2d25d021aa$var$load("hjFwX").then(()=>parcelRequire('fktiI'));

});

parcelRegister("ew6eT", function(module, exports) {

let $a918e4d578f01614$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a918e4d578f01614$var$load("8Kuy8").then(()=>parcelRequire('nzpCE'));

});

parcelRegister("3TJbO", function(module, exports) {

let $2d698fdb53ffcc16$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2d698fdb53ffcc16$var$load("7wuIA").then(()=>parcelRequire('4p6Xf'));

});

parcelRegister("dzGGG", function(module, exports) {

let $9e1fa81a0ec7384a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9e1fa81a0ec7384a$var$load("8vn4Z").then(()=>parcelRequire('192Qf'));

});

parcelRegister("k2oBe", function(module, exports) {

let $e9671382151d2f0e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e9671382151d2f0e$var$load("66jf5").then(()=>parcelRequire('asWju'));

});

parcelRegister("8huze", function(module, exports) {

let $60779f4502a5e95a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $60779f4502a5e95a$var$load("iBp7u").then(()=>parcelRequire('jVRj8'));

});

parcelRegister("7ptdM", function(module, exports) {

let $565188eebfdfcc84$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $565188eebfdfcc84$var$load("fHlgX").then(()=>parcelRequire('9JyHK'));

});

parcelRegister("e7NqT", function(module, exports) {

let $a488106fce3541f3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a488106fce3541f3$var$load("5DH5g").then(()=>parcelRequire('5raev'));

});

parcelRegister("i8PfE", function(module, exports) {

let $d350bad665f476ce$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d350bad665f476ce$var$load("5nKRw").then(()=>parcelRequire('70QMF'));

});

parcelRegister("cCpUh", function(module, exports) {

let $92fd2132c621800f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $92fd2132c621800f$var$load("6qK3N").then(()=>parcelRequire('hY7Zb'));

});

parcelRegister("erWCe", function(module, exports) {

let $a8510e237aab9ac7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a8510e237aab9ac7$var$load("gqXsO").then(()=>parcelRequire('8Lljy'));

});

parcelRegister("c3GNV", function(module, exports) {

let $8c76f7e5dd11419c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8c76f7e5dd11419c$var$load("1WIPG").then(()=>parcelRequire('5bbjf'));

});

parcelRegister("d5Fx7", function(module, exports) {

let $987bf5a22a2f4dd1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $987bf5a22a2f4dd1$var$load("cwuIT").then(()=>parcelRequire('4Io4N'));

});


parcelRegister("esaMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9501f41c561b12d$export$2e2bcd8739ae039);

var $08G6A = parcelRequire("08G6A");
class $b9501f41c561b12d$export$2e2bcd8739ae039 extends (0, $08G6A.default) {
    static #BASE_PATH = '/template';
    static #SEARCH_PATH = $b9501f41c561b12d$export$2e2bcd8739ae039.#BASE_PATH + '/search';
    static #CREATE_PATH = $b9501f41c561b12d$export$2e2bcd8739ae039.#BASE_PATH + '/create';
    /**
	 * Create an instance of the {@link TemplatesClient}.
	 * @param env - The environment (of type {@link Environment}) you'd like the client to target
	 * @param site - The site you'd like the client to target. This should be a string in site ARI format.
	 */ constructor(env, site){
        super(env, site);
    }
    /**
	 * Return a single {@link Template} by it's template id.
	 * @param id - the template id you'd like to fetch
	 * @returns a Promise resolving the requested {@link Template} if there exists one, or a Promise rejection otherwise.
	 */ async getTemplateById(id) {
        const path = `${$b9501f41c561b12d$export$2e2bcd8739ae039.#BASE_PATH}/${id}`;
        return this.makeRequest(path, 'GET');
    }
    /**
	 * Perform a multi-value search for a set of templates, matching on a set of template ids. This is a paginated request,
	 * so overflow of results will provide paged results.
	 * @param templateIds - a list of template ids you'd like to return templates for. Duplicate ids will be ignored.
	 * @param limit - Optionally provide a limit for the request. If you do not provide a limit, the API will default to max 50 results per page.
	 * @returns A Promise resolving the paginated search results (of type {@link PaginatedApiResponse<Template>}) or a rejection in the event of
	 * a 4xx, 5xx response.
	 * @throws `Error` if the underlying {@link Response} failed
	 */ async searchTemplatesByIds(templateIds, limit) {
        const query = $b9501f41c561b12d$export$2e2bcd8739ae039.#buildQuery({
            templateIds: templateIds
        }, limit);
        return this.makePaginatedRequest($b9501f41c561b12d$export$2e2bcd8739ae039.#SEARCH_PATH, 'POST', query);
    }
    /**
	 * Perform a multi-value search for a set of templates, matching on a set of categories (category keys). This is a paginated request,
	 * so overflow of results will provide paged results.
	 * @param categories - a list of category keys you'd like to return templates for. Duplicate category keys will be ignored.
	 * @param limit - Optionally provide a limit for the request. If you do not provide a limit, the API will default to a max of 50 results per page.
	 * @returns A Promise resolving the paginated search results (of type {@link PaginatedApiResponse<Template>}), or a rejection in the event of
	 * a 4xx, 5xx response.
	 * @throws `Error` if the underlying {@link Response} failed
	 */ async searchTemplatesByCategories(categories, limit) {
        const query = $b9501f41c561b12d$export$2e2bcd8739ae039.#buildQuery({
            categories: categories
        }, limit);
        return this.makePaginatedRequest($b9501f41c561b12d$export$2e2bcd8739ae039.#SEARCH_PATH, 'POST', query);
    }
    /**
	 * Perform a search for a set of templates, matching contextually against a provided rule home. This is a contextual action, so providing a JPD Project rule home ARI,
	 * for instance, will return a different set of relevant templates as compared to providing a Confluence site as a rule home ARI.
	 * @param ruleHome - a ruleHome (in format of an ARI) that matches the "scope" in which the templates are being requested. You can use this method in
	 * conjunction with the site/space/project ARI that it's being called from to return templates that are relevant to the product surface.
	 * @param limit - Optionally provide a limit for the request. If you do not provide a limit, the API will default to a max of 50 results per page.
	 * @returns A Promise resolving the paginated search results (of type {@link PaginatedApiResponse<Template>}), or a rejection in the event of
	 * a 4xx, 5xx response.
	 * @throws `Error` if the underlying {@link Response} failed
	 */ async searchTemplatesByRuleHome(ruleHome, limit) {
        const query = $b9501f41c561b12d$export$2e2bcd8739ae039.#buildQuery({
            ruleHome: ruleHome
        }, limit);
        return this.makePaginatedRequest($b9501f41c561b12d$export$2e2bcd8739ae039.#SEARCH_PATH, 'POST', query);
    }
    /**
	 * Perform a multi-value search for a set of templates, matching across multiple search filters.
	 * @param filters Optionally contains an intersection of categories, template ids, and/or a rule home. The filter operation is:
	 * - ANY match within a given filter, e.g. given templateIds: ["1", "2"], match a template that has id 1 OR 2
	 * - ALL match across filters, e.g. given templateIds: ["1"], categories: ["jira"], match only a template with id 1 AND the jira category.
	 * @param limit - Optionally provide a limit for the request. If you do not provide a limit, the API will default to a max of 50 results per page.
	 * @returns A Promise resolving the paginated search results (of type {@link PaginatedApiResponse<Template>}), or a rejection in the event of
	 * a 4xx, 5xx response.
	 * @throws `Error` if the underlying {@link Response} failed
	 */ async searchTemplatesByFilters(filters, limit) {
        const query = $b9501f41c561b12d$export$2e2bcd8739ae039.#buildQuery(filters, limit);
        return this.makePaginatedRequest($b9501f41c561b12d$export$2e2bcd8739ae039.#SEARCH_PATH, 'POST', query);
    }
    /**
	 * Given any initial result of the search operations available in this {@link TemplatesClient} interface, page FORWARDS to
	 * the next page of results.
	 * @param previousResults - The response from the previous request.
	 * @param limit - Optionally provide a limit for the request. If you do not provide a limit, the API will default to a max of 50 results per page.
	 * @returns the next page of results if there was a next page, or an empty page otherwise.
	 * @throws `Error` if the underlying {@link Response} failed
	 */ async getNextSearchPageResults(previousResults, limit) {
        return this.pageForwards(previousResults, limit);
    }
    /**
	 * Given any initial result of the search operations available in this {@link TemplatesClient} interface, page BACKWARDS to
	 * the previous page of results.
	 * @param previousResults - The response from the previous request.
	 * @param limit - Optionally provide a limit for the request. If you do not provide a limit, the API will default to a max of 50 results per page.
	 * @returns the previous page of results if there was a next page, or an empty page otherwise.
	 * @throws `Error` if the underlying {@link Response} failed
	 */ async getPrevSearchPageResults(previousResults, limit) {
        return this.pageBackwards(previousResults, limit);
    }
    /**
	 * Given any initial result of the search operations available in this {@link TemplatesClient} interface, re-request the current page of results
	 * @param previousResults - The response from the previous request.
	 * @param limit - Optionally provide a limit for the request. If you do not provide a limit, the API will default to a max of 50 results per page.
	 * @returns the current page of results if there was a current page, or an empty page otherwise.
	 * @throws `Error` if the underlying {@link Response} failed
	 */ async getCurrentSearchPageResults(previousResults, limit) {
        return this.getSelf(previousResults, limit);
    }
    /**
	 * @param templateId - The corresponding template to create a rule from
	 * @param ruleHome - The location the rule will be created from
	 * @param parameters - The parameter configuration for the rule, if any
	 * @returns - the rule id of the created rule, if successfully created
	 * @throws `Error` if the underlying {@link Response} failed
	 */ async createRuleFromTemplate(templateId, ruleHome, parameters) {
        const payload = {
            templateId: templateId,
            ruleHome: ruleHome
        };
        if (parameters) payload.parameters = parameters;
        return this.makeRequest($b9501f41c561b12d$export$2e2bcd8739ae039.#CREATE_PATH, 'POST', payload);
    }
    /**
	 * Private helper to create a query given some filter args. If there is a cursor present, only attach cursor
	 * as cursor is mutally exlusive with additional filters. Apply limit if it exists.
	 */ static #buildQuery(filters, limit) {
        let query = {
            ...filters
        };
        if (limit) query.limit = limit;
        return query;
    }
}

});
parcelRegister("08G6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfe9a7134d3d1731$export$2e2bcd8739ae039);

var $5WJCM = parcelRequire("5WJCM");

var $ln6NE = parcelRequire("ln6NE");

var $bPCfu = parcelRequire("bPCfu");
class $dfe9a7134d3d1731$export$2e2bcd8739ae039 {
    static #API_VERSION = 'v1';
    #env;
    #site;
    #basePath;
    static #DEFAULT_HEADERS = {
        'Content-Type': 'application/json'
    };
    /**
	 * @param env - the target environment that the {@link AutomationClient} should use.
	 * @param site - the site, in the form of a site ARI as string, that the {@link AutomationClient} should use.
	 */ constructor(env, site){
        this.#basePath = null;
        // Resolve the base path, given a target environment and a target site ARI.
        // The stack name will be resolved (if necessary) via the local dev server,
        // or as a fallback, through local storage.
        // JS does not allow async constructors. As a consequence, we need to attempt resolve the base path on the first
        // request made. Subsequent requests should not call this method. We cannot achieve this through a static
        // async factory, either, as it would prevent inheritance from the AutomationClient class.
        this.#resolveBasePath = async ()=>{
            const { resourceOwner: product, cloudId: cloudId } = (0, $ln6NE.extractResourceOwnerAndCloudIdFromSiteAri)(this.#site);
            const basePath = await $dfe9a7134d3d1731$export$2e2bcd8739ae039.#buildBasePath(this.#env, cloudId, product);
            this.#basePath = basePath;
        };
        this.#env = env;
        this.#site = site;
    }
    /**
	 * Get basePath. Note that this will only be available after a request has been made, otherwise will be set as `null`.
	 */ get basePath() {
        return this.#basePath;
    }
    /**
	 * Issue request to the Automation Public REST API.
	 * Note that if no request has been made using the client yet, calling this method will first attempt to resolve the basepath
	 * (`async`).
	 * @param endpoint - the endpoint the request should be made to. This will be appended to the base path generated
	 * by the client
	 * @param method - Specify the HTTP method to use for the request
	 * @param body - Optionally supply JSON body to be serialised and attached as the request body
	 * @param headers - Optionally supply key value set to be attached as headers.
	 * @returns the awaited Promise that will resolve the JSON data from the API.
	 * @throws Error - if the underlying {@link Response} failed
	 */ async makeRequest(endpoint, method, body, headers) {
        if (!this.basePath) await this.#resolveBasePath();
        return this.#doFetch(this.#basePath + endpoint, method, body, headers);
    }
    /**
	 * Issue request with known pagination to the Automation Public REST API. This is particularly useful for search-like requests
	 * as the response payload is already known to be jsonAPI compliant
	 * @param endpoint - the endpoint the request should be made to. This will be appended to the base path generated
	 * by the client
	 * @param method - Specify the HTTP method to use for the request
	 * @param body - Optionally supply JSON body to be serialised and attached as the request body
	 * @param headers - Optionally supply key value set to be attached as headers.
	 * @returns the awaited Promise that will resolve the JSON data from the API.
	 * @throws Error - if the underlying {@link Response} failed
	 */ async makePaginatedRequest(endpoint, method, body, headers) {
        if (!this.basePath) await this.#resolveBasePath();
        return this.#doFetch(this.#basePath + endpoint, method, body, headers);
    }
    /**
	 * Attempt to page to next results page (GET), given a previous result.
	 * @param previousResult - the previously requested paginated response to attempt to follow forwards
	 * @param limit - an optional limit to size the next page of results
	 * @returns If the previous result contains no next link, return {@code null}. Else, return the next page of results.
	 * @throws Error - if the underlying {@link Response} failed
	 */ async pageForwards(previousResult, limit) {
        const nextCursor = previousResult.links.next;
        if (!nextCursor) return null;
        return this.#followCursor(nextCursor, limit);
    }
    /**
	 * Attempt to page to prev results page (GET), given a previous result.
	 * @param previousResult - the previously requested paginated response to attempt to follow backwards
	 * @param limit - an optional limit to size the previous page of results
	 * @returns If the previous result contains no prev link, return {@code null}. Else, return the prev page of results.
	 * @throws Error - if the underlying {@link Response} failed
	 */ async pageBackwards(previousResult, limit) {
        const prevCursor = previousResult.links.prev;
        if (!prevCursor) return null;
        return this.#followCursor(prevCursor, limit);
    }
    /**
	 * Attempt to page to current results page (GET), given a previous result.
	 * @param previousResult - the previously requested paginated response to attempt to follow self
	 * @param limit - an optional limit to size the current page of results
	 * @returns If the previous result contains no self link, return {@code null}. Else, return the current page of results.
	 * @throws Error - if the underlying {@link Response} failed
	 */ async getSelf(previousResult, limit) {
        const selfCursor = previousResult.links.self;
        if (!selfCursor) return null;
        return this.#followCursor(selfCursor, limit);
    }
    // this method performs a get request and ignores the resolved base path. Instead,
    // we simply perform a call to fetch with the whole cursor.
    async #followCursor(url, limit) {
        const urlWithOptionalLimit = limit ? `${url}?limit=${limit}` : url;
        return this.#doFetch(urlWithOptionalLimit, 'GET');
    }
    // Fetcher method. Attempts to resolve base path if base path has not been set for instance.
    async #doFetch(url, method, body, headers = $dfe9a7134d3d1731$export$2e2bcd8739ae039.#DEFAULT_HEADERS) {
        const requestConfig = {
            method: method
        };
        if (body) requestConfig.body = JSON.stringify(body);
        requestConfig.headers = {
            ...$dfe9a7134d3d1731$export$2e2bcd8739ae039.#DEFAULT_HEADERS,
            ...headers
        };
        const response = await fetch(url, requestConfig);
        if (!response.ok) throw await $dfe9a7134d3d1731$export$2e2bcd8739ae039.#normalizeErrorResponse(response);
        // Force base here as the fetch API doesn't provide us any generics to pass T to.
        return response.json();
    }
    #resolveBasePath;
    // Given url parts and a target environment and stack, construct the base path of the API.
    // This will return null in the event that the target environment is DEV, but no
    // stack name was specified.
    static #buildBasePath = async (env, cloudId, product)=>{
        return env !== (0, $5WJCM.Environment).PROD ? $dfe9a7134d3d1731$export$2e2bcd8739ae039.#getNonProdBasePath(env, cloudId, product) : $dfe9a7134d3d1731$export$2e2bcd8739ae039.#getProdBasePath(cloudId, product);
    };
    static #getNonProdBasePath = async (env, cloudId, product)=>{
        const stack = await (0, $bPCfu.getAutomationStack)(env, cloudId);
        return `/gateway/api/automation/internal-api/${product}/${cloudId}/${stack}/public/rest/${$dfe9a7134d3d1731$export$2e2bcd8739ae039.#API_VERSION}`;
    };
    static #getProdBasePath = (cloudId, product)=>`/gateway/api/automation/public/${product}/${cloudId}/rest/${$dfe9a7134d3d1731$export$2e2bcd8739ae039.#API_VERSION}`;
    static #normalizeErrorResponse = async (response)=>{
        try {
            const errorJson = await response.json();
            // Firstly attempt to parse API error if resolved
            if (errorJson.errors) return new Error(errorJson.errors[0].title);
            // Stringify whole JSON if not of known API error shape.
            throw new Error(JSON.stringify(errorJson));
        } catch (e) {
            // In the event of parse error etc, fallback.
            throw new Error(String(e));
        }
    };
}

});
parcelRegister("5WJCM", function(module, exports) {

$parcel$export(module.exports, "Environment", () => $e7a7875e331ccde4$export$7dc6752a22ab011a);
$parcel$export(module.exports, "Product", () => $e7a7875e331ccde4$export$264ad599d7cef668);
var $e7a7875e331ccde4$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["PRE_PROD"] = "pre-prod";
    Environment["PROD"] = "prod";
    Environment["STAGING"] = "staging";
    Environment["DEV"] = "dev";
    return Environment;
}({});
var $e7a7875e331ccde4$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["JIRA"] = "jira";
    Product["CONFLUENCE"] = "confluence";
    return Product;
}({});

});

parcelRegister("ln6NE", function(module, exports) {

$parcel$export(module.exports, "extractResourceOwnerAndCloudIdFromSiteAri", () => $5e9b78671ecb3654$export$9c6867382e22e4ef);

var $63yBZ = parcelRequire("63yBZ");

var $5WJCM = parcelRequire("5WJCM");
const $5e9b78671ecb3654$export$9c6867382e22e4ef = (site)=>{
    let cloudId;
    let resourceOwner;
    let resourceType;
    try {
        const ari = (0, $63yBZ.ResourceIdentifier).parse(site);
        cloudId = ari.cloudId;
        resourceOwner = ari.resourceOwner;
        resourceType = ari.resourceType;
        // Keep backwards compatibility for platform site ARIs
        if (resourceOwner === 'platform') resourceOwner = (0, $5WJCM.Product).JIRA;
    } catch (error) {
        throw new Error('Attempted to parse malformed ARI: ' + site);
    }
    if (resourceType !== 'site') throw new Error('The supplied ARI is not a site ARI: ' + site);
    if (cloudId === undefined) throw new Error('The supplied ARI did not include a cloudId: ' + site);
    const supportedResourceOwners = Object.values((0, $5WJCM.Product));
    if (!supportedResourceOwners.includes(resourceOwner)) throw new Error(`The supplied ARI is not supported by Automation: ${site}. (Supported resource owners: ${supportedResourceOwners})`);
    return {
        resourceOwner: resourceOwner,
        cloudId: cloudId
    };
};

});

parcelRegister("bPCfu", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $d7a104223a0300e2$export$6123178d3f5fb24d);

var $5WJCM = parcelRequire("5WJCM");
const $d7a104223a0300e2$export$63ac5095d13f530f = 'automationPlatform';
const $d7a104223a0300e2$export$a2391059d6ca8007 = 'automationStack';
const $d7a104223a0300e2$export$e8d94959cfb586c1 = 'https://localhost:8082/devStack.json';
const $d7a104223a0300e2$export$957a405458631016 = (cloudId)=>`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`;
const $d7a104223a0300e2$var$getLatestPreProdStack = async (cloudId)=>{
    try {
        const response = await fetch($d7a104223a0300e2$export$957a405458631016(cloudId));
        const stacksResponse = await response.json();
        const preProdStacks = stacksResponse.prod?.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack) ?? [];
        const [latestPreProdStack = null] = preProdStacks;
        return latestPreProdStack;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch pre-prod stack from ${$d7a104223a0300e2$export$957a405458631016(cloudId)} with error: ${e}`);
        return null;
    }
};
const $d7a104223a0300e2$var$_getAutomationKeyFromLocalStorage = (key)=>{
    return window.localStorage.getItem(`${$d7a104223a0300e2$export$63ac5095d13f530f}:${key}`);
};
const $d7a104223a0300e2$var$getAutomationDevStackFromLocalServer = async ()=>{
    try {
        const devStackResponse = await fetch($d7a104223a0300e2$export$e8d94959cfb586c1);
        const devStack = await devStackResponse.json();
        return devStack.name;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch dev stack from ${$d7a104223a0300e2$export$e8d94959cfb586c1} with error: ${e}`);
        return null;
    }
};
const $d7a104223a0300e2$export$48cdb3ba720a47f6 = ()=>$d7a104223a0300e2$var$_getAutomationKeyFromLocalStorage($d7a104223a0300e2$export$a2391059d6ca8007);
const $d7a104223a0300e2$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === (0, $5WJCM.Environment).PROD) return 'pro';
    if (env === (0, $5WJCM.Environment).PRE_PROD) {
        const stack = await $d7a104223a0300e2$var$getLatestPreProdStack(cloudId);
        return stack ?? 'pro';
    }
    if (env === (0, $5WJCM.Environment).STAGING) return 'staging';
    // We fetch the dev stack name from local server (barrel webpack dev server) if it's available.
    // However, this requires that devWatch is running locally.
    // To use manual triggers without running devWatch, set the local storage value to your stack name e.g. devltan3. The full key is: automationPlatform:automationStack
    const stackOverride = await $d7a104223a0300e2$var$getAutomationDevStackFromLocalServer() || $d7a104223a0300e2$export$48cdb3ba720a47f6();
    return stackOverride || 'staging';
};

});



parcelRegister("hviHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b163d38a64581c4b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5CSKW = parcelRequire("5CSKW");

var $3L3Os = parcelRequire("3L3Os");
var $fKXve = parcelRequire("fKXve");
var $bUGwX = parcelRequire("bUGwX");

var $fmSFT = parcelRequire("fmSFT");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $eGOwo = parcelRequire("eGOwo");

var $29wf0 = parcelRequire("29wf0");

var $10fAM = parcelRequire("10fAM");

var $ReAiT = parcelRequire("ReAiT");

var $bOfDP = parcelRequire("bOfDP");
const $b163d38a64581c4b$var$TemplateParameterForm = (props)=>{
    const { targetRuleCreation: targetRuleCreation, clearSelectedTemplate: clearSelectedTemplate, createRule: createRule, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed } = props;
    const handleSubmit = (data)=>{
        const parameters = _transformInputs(data);
        return createRule(parameters);
    };
    const _transformInputs = (data)=>{
        return Object.entries(data).reduce((prev, [key, value])=>{
            const parameter = targetRuleCreation.template.parameters.find((parameter)=>parameter.key === key);
            // If for some reason we didn't find a matching parameter (some odd entry into the form)
            // then ignore this key.
            if (!parameter) return prev;
            return {
                ...prev,
                [key]: {
                    type: parameter.type,
                    value: value
                }
            };
        }, {});
    };
    const handleOpen = ()=>{
        if (onInputsModalOpened) onInputsModalOpened();
    };
    const handleClose = ()=>{
        clearSelectedTemplate();
        if (onInputsModalClosed) onInputsModalClosed();
    };
    const generateForm = (parameter)=>{
        switch(parameter.type){
            case 'TEXT':
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bOfDP.default), {
                    name: parameter.key,
                    required: parameter.required
                }, parameter.key);
            case 'NUMBER':
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ReAiT.default), {
                    name: parameter.key,
                    required: parameter.required
                }, parameter.key);
            case 'BOOLEAN':
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $29wf0.default), {
                    name: parameter.key
                }, parameter.key);
            default:
                return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("br", {}),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $10fAM.messages).parameterModalErrorInvalidField
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("br", {})
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fmSFT.default), {
        "data-testid": "template-input-form",
        onClose: handleClose,
        onOpenComplete: handleOpen,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3L3Os.default), {
            onSubmit: handleSubmit,
            children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("form", {
                    ...formProps,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                            ...(0, $eGOwo.fg)('ux-3549-automation-api-fix-modal-close-buttons') ? {
                                hasCloseButton: true
                            } : {},
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                                children: targetRuleCreation.template.description
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $ik0CA.default), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                    ...(0, $10fAM.messages).parameterModalDescription
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bUGwX.default), {
                                    children: targetRuleCreation.template.parameters.map(generateForm)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kseeK.default), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                                    appearance: "subtle",
                                    onClick: handleClose,
                                    isDisabled: submitting,
                                    testId: "template-parameters-form-cancel",
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                        ...(0, $10fAM.messages).parameterModalCancel
                                    })
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isLoading: submitting,
                                    autoFocus: true,
                                    testId: "template-parameters-form-submit",
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                        ...(0, $10fAM.messages).parameterModalSubmit
                                    })
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
var $b163d38a64581c4b$export$2e2bcd8739ae039 = $b163d38a64581c4b$var$TemplateParameterForm;

});
parcelRegister("29wf0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0faebe79f52710cc$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $86tBw = parcelRequire("86tBw");

var $2yMqp = parcelRequire("2yMqp");
const $0faebe79f52710cc$var$BooleanParameterInput = ({ name: name })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2yMqp.default), {
        name: name,
        defaultIsChecked: false,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $86tBw.default), {
                ...fieldProps,
                label: name,
                testId: 'boolean-parameter-input-' + name
            })
    });
};
var $0faebe79f52710cc$export$2e2bcd8739ae039 = $0faebe79f52710cc$var$BooleanParameterInput;

});
parcelRegister("2yMqp", function(module, exports) {

$parcel$export(module.exports, "default", () => $636b62edc5d062fa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6svxr = parcelRequire("6svxr");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $636b62edc5d062fa$var$CheckboxField = ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value, ...rest })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $eJOHy.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        ...rest,
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
var $636b62edc5d062fa$export$2e2bcd8739ae039 = $636b62edc5d062fa$var$CheckboxField;

});


parcelRegister("10fAM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bd921274b8ebaa93$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $bd921274b8ebaa93$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    parameterModalDescription: {
        id: 'automation-platform.automation-templates.parameter-modal.description',
        defaultMessage: 'This template requires additional configuration before you can create a rule from it.',
        description: 'The description for the parameters modal dialog'
    },
    parameterModalCancel: {
        id: 'automation-platform.automation-templates.parameter-modal.cancel',
        defaultMessage: 'Cancel',
        description: 'The cancel button text'
    },
    parameterModalSubmit: {
        id: 'automation-platform.automation-templates.parameter-modal.submit',
        defaultMessage: 'Create rule',
        description: 'The submit button text'
    },
    parameterModalErrorInvalidField: {
        id: 'automation-platform.automation-templates.parameter-modal.error.invalid-field',
        defaultMessage: 'This template contains an unsupported parameter type',
        description: "The error text when a field from the template isn't supported"
    }
});

});

parcelRegister("ReAiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb8f9d3db989be16$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");

var $sY9BV = parcelRequire("sY9BV");

var $1GG1s = parcelRequire("1GG1s");
var $eb8f9d3db989be16$export$290ba6e10d6b5180 = /*#__PURE__*/ function(NumberParameterInputErrors) {
    NumberParameterInputErrors["EMPTY"] = "EMPTY";
    NumberParameterInputErrors["INVALID_NUMBER"] = "INVALID_NUMBER";
    return NumberParameterInputErrors;
}({});
const $eb8f9d3db989be16$export$c6cbc3bbef9e5a54 = (isRequired, value)=>{
    if (isRequired && !value) return "EMPTY";
    if (value && Number.isNaN(Number(value))) return "INVALID_NUMBER";
    return undefined;
};
const $eb8f9d3db989be16$var$NumberParameterInput = ({ name: name, required: required })=>{
    const generateErrorMessage = (error)=>{
        switch(error){
            case "EMPTY":
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                    testId: 'number-parameter-error-' + name,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $1GG1s.messages).parameterModalErrorEmptyNumber
                    })
                });
            case "INVALID_NUMBER":
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                    testId: 'number-parameter-error-' + name,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $1GG1s.messages).parameterModalErrorInvalidNumber
                    })
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        name: name,
        label: name,
        isRequired: required,
        validate: (value)=>$eb8f9d3db989be16$export$c6cbc3bbef9e5a54(required, value),
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $sY9BV.default), {
                        ...fieldProps,
                        testId: 'number-parameter-input-' + name
                    }),
                    generateErrorMessage(error)
                ]
            })
    });
};
var $eb8f9d3db989be16$export$2e2bcd8739ae039 = $eb8f9d3db989be16$var$NumberParameterInput;

});
parcelRegister("1GG1s", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3d739711562cbc18$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3d739711562cbc18$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    parameterModalErrorEmptyNumber: {
        id: 'automation-platform.automation-templates.number-parameter-modal.error.empty',
        defaultMessage: 'Please provide a number value for this parameter',
        description: 'The error text when a required number parameter is missing'
    },
    parameterModalErrorInvalidNumber: {
        id: 'automation-platform.automation-templates.number-parameter-modal.error.invalid-number',
        defaultMessage: 'Please provide a valid number value for this parameter',
        description: 'The error text when a number parameter has a non number value'
    }
});

});


parcelRegister("bOfDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6a438a0c0d261a8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");

var $sY9BV = parcelRequire("sY9BV");

var $QqRor = parcelRequire("QqRor");
var $d6a438a0c0d261a8$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($d6a438a0c0d261a8$var$Errors || {});
const $d6a438a0c0d261a8$var$TextParameterInput = ({ name: name, required: required })=>{
    const validate = (value)=>required && !value ? "EMPTY" : undefined;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        name: name,
        label: name,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $sY9BV.default), {
                        ...fieldProps,
                        testId: 'text-parameter-input-' + name
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fKXve.ErrorMessage), {
                        testId: 'text-parameter-error-' + name,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $QqRor.messages).parameterModalErrorEmptyText
                        })
                    })
                ]
            })
    });
};
var $d6a438a0c0d261a8$export$2e2bcd8739ae039 = $d6a438a0c0d261a8$var$TextParameterInput;

});
parcelRegister("QqRor", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6eb2b3ebad970175$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $6eb2b3ebad970175$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    parameterModalErrorEmptyText: {
        id: 'automation-platform.automation-templates.text-parameter-modal.error.empty',
        defaultMessage: 'Please provide a text value for this parameter',
        description: 'The error text when a required text parameter is missing'
    },
    parameterModalErrorInvalidText: {
        id: 'automation-platform.automation-templates.text-parameter-modal.error.invalid-text',
        defaultMessage: 'Please provide a valid text value for this parameter',
        description: 'The error text when a text parameter has a non text value'
    }
});

});




parcelRegister("5sYBz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5906d158fd4dfcce$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $8wyVH = parcelRequire("8wyVH");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $aUdi2 = parcelRequire("aUdi2");

var $2SVMK = parcelRequire("2SVMK");
const $5906d158fd4dfcce$var$src = 'https://jira-frontend-bifrost.stg-east.frontend.public.atl-paas.net/assets/error.4fa1b24b.svg';
const $5906d158fd4dfcce$var$containerStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%'
});
const $5906d158fd4dfcce$var$contentContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 'space.200',
    marginTop: 'space.200'
});
const $5906d158fd4dfcce$var$ErrorState = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $aUdi2.AutomationIntlMessagesProvider), {
        locales: (0, $aUdi2.locales),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
            testId: "templates-dropdown.error-state-container",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Wh6p.default), {
                    alignBlock: "center",
                    alignInline: "center",
                    xcss: $5906d158fd4dfcce$var$containerStyles,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wyVH.default), {
                        src: $5906d158fd4dfcce$var$src,
                        alt: "Error",
                        testId: "error.state.img",
                        width: "112",
                        height: "84"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
                    xcss: $5906d158fd4dfcce$var$contentContainerStyles,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                            size: "large",
                            weight: "semibold",
                            align: "center",
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $2SVMK.messages).errorTitle
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                            size: "medium",
                            align: "center",
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $2SVMK.messages).errorDescription
                            })
                        })
                    ]
                })
            ]
        })
    });
var $5906d158fd4dfcce$export$2e2bcd8739ae039 = $5906d158fd4dfcce$var$ErrorState;

});
parcelRegister("2SVMK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $476a3807a93331a9$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $476a3807a93331a9$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    errorTitle: {
        id: 'automation-platform.error.title',
        defaultMessage: "We're having some trouble",
        description: 'Title to display to the user when the error state is shown.'
    },
    errorDescription: {
        id: 'automation-platform.error.desc',
        defaultMessage: "It's taking us longer than expected to show this content. It's probably a temporary problem. Try refreshing or navigating to another page.",
        description: 'Description to display to the user when the error state is shown.'
    }
});

});


parcelRegister("38aOM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b238ba23422a75fb$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $fL0In = parcelRequire("fL0In");

var $dcLzM = parcelRequire("dcLzM");

var $gqEmK = parcelRequire("gqEmK");

var $9itkV = parcelRequire("9itkV");

var $f58rc = parcelRequire("f58rc");
var $6YEko = parcelRequire("6YEko");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $aUdi2 = parcelRequire("aUdi2");

var $chLEO = parcelRequire("chLEO");
const $b238ba23422a75fb$var$menuIconStyle = (0, $1DXK0.xcss)({
    width: 'size.300',
    height: 'size.300',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $b238ba23422a75fb$var$MenuIcon = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $b238ba23422a75fb$var$menuIconStyle,
        children: children
    });
const $b238ba23422a75fb$export$85ca00d4fc5d86c3 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
        label: "",
        ...props,
        color: "currentColor"
    });
const $b238ba23422a75fb$var$handleOptionalCallback = (optionalEvent)=>{
    if (optionalEvent) optionalEvent();
};
var $b238ba23422a75fb$export$2e2bcd8739ae039 = ({ baseAutomationUrl: baseAutomationUrl, createAutomationComponentFilter: createAutomationComponentFilter, onCreateAutomationFooterLinkClicked: onCreateAutomationFooterLinkClicked, onManageAutomationsFooterLinkClicked: onManageAutomationsFooterLinkClicked, onAuditLogFooterLinkClicked: onAuditLogFooterLinkClicked })=>{
    (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($gqEmK))), (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), (0, $fL0In.default), $b238ba23422a75fb$var$MenuIcon, (0, $6YEko.default));
    const componentFilter = createAutomationComponentFilter ? `?componentFilterCriteria=${createAutomationComponentFilter}` : '';
    const createNewRuleUrl = `${baseAutomationUrl}#/rule/new/__NEW__TRIGGER${componentFilter}`;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aUdi2.AutomationIntlMessagesProvider), {
        locales: (0, $aUdi2.locales),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6YEko.default), {
            hasSeparator: true,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f58rc.default), {
                    onClick: ()=>$b238ba23422a75fb$var$handleOptionalCallback(onCreateAutomationFooterLinkClicked),
                    href: createNewRuleUrl,
                    testId: "create-automation-link",
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($b238ba23422a75fb$var$MenuIcon, {
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                            label: "",
                            color: "currentColor",
                            size: "small"
                        })
                    }),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $chLEO.default).createAutomationItem
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f58rc.default), {
                    onClick: ()=>$b238ba23422a75fb$var$handleOptionalCallback(onManageAutomationsFooterLinkClicked),
                    href: baseAutomationUrl,
                    testId: "manage-automations-link",
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($b238ba23422a75fb$var$MenuIcon, {
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)($b238ba23422a75fb$export$85ca00d4fc5d86c3, {})
                    }),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $chLEO.default).manageAutomationsItem
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f58rc.default), {
                    onClick: ()=>{
                        $b238ba23422a75fb$var$handleOptionalCallback(onAuditLogFooterLinkClicked);
                    },
                    href: `${baseAutomationUrl}#tab/audit-log`,
                    testId: "audit-log-link",
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($b238ba23422a75fb$var$MenuIcon, {
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gqEmK))), {
                            label: "",
                            color: "currentColor",
                            size: "small"
                        })
                    }),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $chLEO.default).auditLogItem
                    })
                })
            ]
        })
    });
};

});
parcelRegister("chLEO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3177fcdf73bb664c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3177fcdf73bb664c$var$messages = (0, $7qGN1.defineMessages)({
    manageAutomationsItem: {
        id: 'automation-platform.footer.manage-automations-item',
        defaultMessage: 'Manage automations',
        description: 'Label for the manage automations item which is a link to project automation'
    },
    createAutomationItem: {
        id: 'automation-platform.footer.create-automation-item',
        defaultMessage: 'Create automation',
        description: 'Label for the create automation item which is a link to rule creation in project automation'
    },
    auditLogItem: {
        id: 'automation-platform.footer.audit-log-item',
        defaultMessage: 'Audit log',
        description: 'Label for the audit log item which is a link to audit log in project automation'
    }
});
var $3177fcdf73bb664c$export$2e2bcd8739ae039 = $3177fcdf73bb664c$var$messages;

});


parcelRegister("3dADJ", function(module, exports) {

$parcel$export(module.exports, "locales", () => $32e464577addb093$export$df1c34db1371eeed);






















const $32e464577addb093$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("16Dem")),
    da: ()=>(parcelRequire("32Vjm")),
    de: ()=>(parcelRequire("856yR")),
    en_GB: ()=>(parcelRequire("1fbAS")),
    en_ZZ: ()=>(parcelRequire("kP0gs")),
    en: ()=>(parcelRequire("fx2P4")),
    es: ()=>(parcelRequire("jvb7v")),
    fi: ()=>(parcelRequire("2VECk")),
    fr: ()=>(parcelRequire("lNCwB")),
    hu: ()=>(parcelRequire("8hxPm")),
    it: ()=>(parcelRequire("gddiG")),
    ja: ()=>(parcelRequire("1ov0q")),
    ko: ()=>(parcelRequire("1d3mC")),
    nb: ()=>(parcelRequire("4syAa")),
    nl: ()=>(parcelRequire("6IEeA")),
    pl: ()=>(parcelRequire("24wgu")),
    pt_BR: ()=>(parcelRequire("jno1g")),
    ru: ()=>(parcelRequire("iq0o0")),
    sv: ()=>(parcelRequire("dW6Js")),
    tr: ()=>(parcelRequire("4KzwS")),
    zh_TW: ()=>(parcelRequire("1FvLq")),
    zh: ()=>(parcelRequire("8zMIX"))
};

});
parcelRegister("16Dem", function(module, exports) {

let $0ce4c8645fef0f42$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0ce4c8645fef0f42$var$load("85tIM").then(()=>parcelRequire('hJMYv'));

});

parcelRegister("32Vjm", function(module, exports) {

let $237e03d19ce5dcf3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $237e03d19ce5dcf3$var$load("eq6bF").then(()=>parcelRequire('kII5a'));

});

parcelRegister("856yR", function(module, exports) {

let $5e23e144c1cdc21f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5e23e144c1cdc21f$var$load("jQVcv").then(()=>parcelRequire('kxwM2'));

});

parcelRegister("1fbAS", function(module, exports) {

let $0e802f6bd591aacc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0e802f6bd591aacc$var$load("4VOUa").then(()=>parcelRequire('b4exN'));

});

parcelRegister("kP0gs", function(module, exports) {

let $f288c694a80719b7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f288c694a80719b7$var$load("9j2mD").then(()=>parcelRequire('bzUcx'));

});

parcelRegister("fx2P4", function(module, exports) {

let $b4ec2097ab41eb74$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b4ec2097ab41eb74$var$load("dVtAy").then(()=>parcelRequire('j4M5b'));

});

parcelRegister("jvb7v", function(module, exports) {

let $e32989ce2adc76a8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e32989ce2adc76a8$var$load("eXYxk").then(()=>parcelRequire('kV9mQ'));

});

parcelRegister("2VECk", function(module, exports) {

let $2220695ceccb3296$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2220695ceccb3296$var$load("5r79W").then(()=>parcelRequire('3xj5v'));

});

parcelRegister("lNCwB", function(module, exports) {

let $fdec0ed432c1b6e9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fdec0ed432c1b6e9$var$load("2lGPJ").then(()=>parcelRequire('7aqJW'));

});

parcelRegister("8hxPm", function(module, exports) {

let $607a26afae9648b3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $607a26afae9648b3$var$load("kNveS").then(()=>parcelRequire('6VyST'));

});

parcelRegister("gddiG", function(module, exports) {

let $bcd82d65a86b9d5c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bcd82d65a86b9d5c$var$load("fe0YR").then(()=>parcelRequire('fPQ3L'));

});

parcelRegister("1ov0q", function(module, exports) {

let $10401579435e14db$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $10401579435e14db$var$load("jgifc").then(()=>parcelRequire('fldGO'));

});

parcelRegister("1d3mC", function(module, exports) {

let $0e199d5641f34f20$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0e199d5641f34f20$var$load("9BWvw").then(()=>parcelRequire('gMoZl'));

});

parcelRegister("4syAa", function(module, exports) {

let $33f49a474d2dcd11$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $33f49a474d2dcd11$var$load("9HXzI").then(()=>parcelRequire('edkEb'));

});

parcelRegister("6IEeA", function(module, exports) {

let $4e460fcfbd47e951$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4e460fcfbd47e951$var$load("l1MVo").then(()=>parcelRequire('dmytS'));

});

parcelRegister("24wgu", function(module, exports) {

let $1824fba230c9cf0d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1824fba230c9cf0d$var$load("k3dA5").then(()=>parcelRequire('3IgE9'));

});

parcelRegister("jno1g", function(module, exports) {

let $e1b2cc140f858686$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e1b2cc140f858686$var$load("fGATP").then(()=>parcelRequire('2dX0T'));

});

parcelRegister("iq0o0", function(module, exports) {

let $d68af46a7e3bac66$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d68af46a7e3bac66$var$load("9bPV9").then(()=>parcelRequire('6L6tI'));

});

parcelRegister("dW6Js", function(module, exports) {

let $a255ea0a22671346$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a255ea0a22671346$var$load("8vHju").then(()=>parcelRequire('YvMtE'));

});

parcelRegister("4KzwS", function(module, exports) {

let $375704ab9ad4977c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $375704ab9ad4977c$var$load("fKGVC").then(()=>parcelRequire('4B8PW'));

});

parcelRegister("1FvLq", function(module, exports) {

let $1372426a7e87014c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1372426a7e87014c$var$load("82bLF").then(()=>parcelRequire('3LWNX'));

});

parcelRegister("8zMIX", function(module, exports) {

let $63e76333d1b786f0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $63e76333d1b786f0$var$load("inPJP").then(()=>parcelRequire('aouuj'));

});


parcelRegister("dwEiw", function(module, exports) {

$parcel$export(module.exports, "TemplateEmptyState", () => $d55a64a12f2ae23e$export$43d2304557de3a89);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");


var $6AZJf = parcelRequire("6AZJf");

var $jbF4q = parcelRequire("jbF4q");
const $d55a64a12f2ae23e$var$emptyStateIconStyles = (0, $1DXK0.xcss)({
    height: `115px`,
    width: `192px`
});
const $d55a64a12f2ae23e$var$messageStyles = (0, $1DXK0.xcss)({
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.25rem',
    paddingTop: 'space.150',
    width: '17.75rem'
});
const $d55a64a12f2ae23e$var$emptyStateContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    paddingTop: 'space.100',
    paddingBottom: 'space.400'
});
const $d55a64a12f2ae23e$export$43d2304557de3a89 = ({ ruleLibraryUrl: ruleLibraryUrl })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
        xcss: $d55a64a12f2ae23e$var$emptyStateContainerStyles,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $d55a64a12f2ae23e$var$emptyStateIconStyles,
                testId: "empty-state-icon",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6AZJf.EmptyStateIcon), {})
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $d55a64a12f2ae23e$var$messageStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    weight: "regular",
                    align: "center",
                    size: "medium",
                    color: "color.text",
                    testId: "empty-state-message",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        id: (0, $jbF4q.messages).emptyStateMessage.id,
                        defaultMessage: (0, $jbF4q.messages).emptyStateMessage.defaultMessage,
                        description: (0, $jbF4q.messages).emptyStateMessage.description,
                        values: {
                            link: (text)=>// eslint-disable-next-line @atlaskit/design-system/no-html-anchor, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                                    href: ruleLibraryUrl,
                                    style: {
                                        color: `var(--ds-link, ${(0, $7bb4c1736002a04a$export$a6ee3d71bc067634)})`
                                    },
                                    children: text
                                })
                        }
                    })
                })
            })
        ]
    });
};

});
parcelRegister("6AZJf", function(module, exports) {

$parcel$export(module.exports, "EmptyStateIcon", () => $d3b1c80c8d4343db$export$27a9d66a0067424c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $58yRG = parcelRequire("58yRG");
const $d3b1c80c8d4343db$export$27a9d66a0067424c = ()=>{
    const theme = (0, $58yRG.default)();
    const strokeOpacity = theme === 'dark' ? 0.08 : 0.06;
    const outlineColor = "var(--ds-background-accent-gray-subtler-hovered, #091E42)";
    const rectangleFillColor = "var(--ds-background-input-pressed, white)";
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "192",
        height: "115",
        viewBox: "0 0 192 115",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M62 69H104.955C109.374 69 112.955 72.5817 112.955 77V95",
                stroke: outlineColor,
                strokeOpacity: strokeOpacity,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("mask", {
                id: "path-2-inside-1_1463_141307",
                fill: "white",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    d: "M121 103C121 107.418 117.418 111 113 111C108.582 111 105 107.418 105 103C105 98.5817 108.582 95 113 95C117.418 95 121 98.5817 121 103ZM113 96.7778C109.564 96.7778 106.778 99.5636 106.778 103C106.778 106.436 109.564 109.222 113 109.222C116.436 109.222 119.222 106.436 119.222 103C119.222 99.5636 116.436 96.7778 113 96.7778ZM113.882 100.374L113.889 100.486L113.889 102.111L115.514 102.111C116.005 102.111 116.403 102.509 116.403 103C116.403 103.453 116.064 103.827 115.626 103.882L115.514 103.889L113.889 103.889L113.889 105.514C113.889 106.005 113.491 106.403 113 106.403C112.547 106.403 112.173 106.064 112.118 105.626L112.111 105.514L112.111 103.889L110.486 103.889C109.995 103.889 109.597 103.491 109.597 103C109.597 102.547 109.936 102.173 110.374 102.118L110.486 102.111L112.111 102.111L112.111 100.486C112.111 99.9949 112.509 99.597 113 99.597C113.453 99.597 113.827 99.9361 113.882 100.374Z"
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M121 103H119H121ZM113 111V109V111ZM105 103H107H105ZM113.882 100.374L115.878 100.25L115.874 100.188L115.866 100.126L113.882 100.374ZM113.889 100.486L115.889 100.485L115.889 100.423L115.885 100.362L113.889 100.486ZM113.889 102.111L111.889 102.111L111.89 104.11L113.889 104.111L113.889 102.111ZM115.514 102.111L115.514 104.111H115.514V102.111ZM116.403 103H118.403H116.403ZM115.626 103.882L115.75 105.878L115.812 105.874L115.874 105.866L115.626 103.882ZM115.514 103.889L115.515 105.889L115.577 105.889L115.638 105.885L115.514 103.889ZM113.889 103.889L113.889 101.889L111.89 101.89L111.889 103.889L113.889 103.889ZM113.889 105.514L111.889 105.514V105.514H113.889ZM113 106.403V108.403V106.403ZM112.118 105.626L110.122 105.75L110.126 105.812L110.134 105.874L112.118 105.626ZM112.111 105.514L110.111 105.515L110.111 105.577L110.115 105.638L112.111 105.514ZM112.111 103.889L114.111 103.889L114.11 101.89L112.111 101.889L112.111 103.889ZM110.486 103.889L110.486 101.889H110.486V103.889ZM109.597 103H107.597H109.597ZM110.374 102.118L110.25 100.122L110.188 100.126L110.126 100.134L110.374 102.118ZM110.486 102.111L110.485 100.111L110.423 100.111L110.362 100.115L110.486 102.111ZM112.111 102.111L112.111 104.111L114.11 104.11L114.111 102.111L112.111 102.111ZM112.111 100.486L114.111 100.486V100.486H112.111ZM119 103C119 106.314 116.314 109 113 109V113C118.523 113 123 108.523 123 103H119ZM113 109C109.686 109 107 106.314 107 103H103C103 108.523 107.477 113 113 113V109ZM107 103C107 99.6863 109.686 97 113 97V93C107.477 93 103 97.4772 103 103H107ZM113 97C116.314 97 119 99.6863 119 103H123C123 97.4772 118.523 93 113 93V97ZM113 94.7778C108.459 94.7778 104.778 98.459 104.778 103H108.778C108.778 100.668 110.668 98.7778 113 98.7778V94.7778ZM104.778 103C104.778 107.541 108.459 111.222 113 111.222V107.222C110.668 107.222 108.778 105.332 108.778 103H104.778ZM113 111.222C117.541 111.222 121.222 107.541 121.222 103H117.222C117.222 105.332 115.332 107.222 113 107.222V111.222ZM121.222 103C121.222 98.459 117.541 94.7778 113 94.7778V98.7778C115.332 98.7778 117.222 100.668 117.222 103H121.222ZM111.886 100.498L111.893 100.61L115.885 100.362L115.878 100.25L111.886 100.498ZM111.889 100.486L111.889 102.111L115.889 102.11L115.889 100.485L111.889 100.486ZM113.889 104.111L115.514 104.111L115.515 100.111L113.89 100.111L113.889 104.111ZM115.514 104.111C114.901 104.111 114.403 103.614 114.403 103H118.403C118.403 101.405 117.11 100.111 115.514 100.111V104.111ZM114.403 103C114.403 102.432 114.827 101.966 115.377 101.897L115.874 105.866C117.3 105.688 118.403 104.474 118.403 103H114.403ZM115.502 101.886L115.39 101.893L115.638 105.885L115.75 105.878L115.502 101.886ZM115.514 101.889L113.889 101.889L113.89 105.889L115.515 105.889L115.514 101.889ZM111.889 103.889L111.889 105.514L115.889 105.515L115.889 103.89L111.889 103.889ZM111.889 105.514C111.889 104.901 112.386 104.403 113 104.403V108.403C114.595 108.403 115.889 107.11 115.889 105.514H111.889ZM113 104.403C113.568 104.403 114.034 104.827 114.103 105.377L110.134 105.874C110.312 107.3 111.526 108.403 113 108.403V104.403ZM114.114 105.502L114.107 105.39L110.115 105.638L110.122 105.75L114.114 105.502ZM114.111 105.514L114.111 103.889L110.111 103.89L110.111 105.515L114.111 105.514ZM112.111 101.889L110.486 101.889L110.485 105.889L112.11 105.889L112.111 101.889ZM110.486 101.889C111.099 101.889 111.597 102.386 111.597 103H107.597C107.597 104.595 108.89 105.889 110.486 105.889V101.889ZM111.597 103C111.597 103.568 111.173 104.034 110.623 104.103L110.126 100.134C108.7 100.312 107.597 101.526 107.597 103H111.597ZM110.498 104.114L110.61 104.107L110.362 100.115L110.25 100.122L110.498 104.114ZM110.486 104.111L112.111 104.111L112.11 100.111L110.485 100.111L110.486 104.111ZM114.111 102.111L114.111 100.486L110.111 100.485L110.111 102.11L114.111 102.111ZM114.111 100.486C114.111 101.099 113.614 101.597 113 101.597V97.597C111.405 97.597 110.111 98.8904 110.111 100.486H114.111ZM113 101.597C112.432 101.597 111.966 101.173 111.897 100.623L115.866 100.126C115.688 98.6995 114.474 97.597 113 97.597V101.597Z",
                fill: outlineColor,
                fillOpacity: strokeOpacity,
                mask: "url(#path-2-inside-1_1463_141307)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M32 18.353H74.9553C79.3736 18.353 82.9553 21.9348 82.9553 26.353V42.8236",
                stroke: outlineColor,
                strokeOpacity: strokeOpacity,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M45 48H87.9553C92.3736 48 95.9553 51.5817 95.9553 56V72.4706",
                stroke: outlineColor,
                strokeOpacity: strokeOpacity,
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "6",
                y: "4",
                width: "128",
                height: "24",
                rx: "4",
                fill: rectangleFillColor
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "6.5",
                y: "4.5",
                width: "127",
                height: "23",
                rx: "3.5",
                stroke: outlineColor,
                strokeOpacity: strokeOpacity
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "10",
                y: "8",
                width: "16",
                height: "16",
                rx: "2",
                fill: "var(--ds-background-accent-green-subtlest, #DFFCF0)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.4863 19.3434C15.8495 19.7176 15.333 19.4234 15.333 18.6847V13.3171C15.333 12.578 15.8477 12.2825 16.4863 12.6576L21.4121 15.5509C21.8348 15.7994 21.8379 16.1998 21.4121 16.45L16.4863 19.3434Z",
                fill: '#22A06B'
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "34",
                y: "11.5",
                width: "96",
                height: "9",
                rx: "2",
                fill: outlineColor,
                fillOpacity: strokeOpacity
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "28",
                y: "33",
                width: "128",
                height: "24",
                rx: "4",
                fill: rectangleFillColor
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "28.5",
                y: "33.5",
                width: "127",
                height: "23",
                rx: "3.5",
                stroke: outlineColor,
                strokeOpacity: strokeOpacity
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "32",
                y: "37",
                width: "16",
                height: "16",
                rx: "2",
                fill: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M37.778 45.4444H42.2225L42.6669 44.5555H37.3336L37.778 45.4444ZM36.4416 42.3333C36.198 42.3333 36.0905 42.5133 36.1989 42.731L36.4447 43.2221H43.5558L43.8016 42.731C43.9114 42.511 43.8025 42.3333 43.5589 42.3333H36.4416ZM39.4572 47.4693C39.4896 47.5271 39.5363 47.5756 39.5929 47.6102C39.6495 47.6447 39.714 47.6642 39.7803 47.6666H40.2203C40.3443 47.6666 40.4892 47.5777 40.5434 47.4693L40.8892 46.7777H39.1114L39.4572 47.4693Z",
                fill: "var(--ds-icon-accent-orange, #E56910)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "56",
                y: "40.5",
                width: "96",
                height: "9",
                rx: "2",
                fill: outlineColor,
                fillOpacity: strokeOpacity
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "45",
                y: "62",
                width: "128",
                height: "24",
                rx: "4",
                fill: rectangleFillColor
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "45.5",
                y: "62.5",
                width: "127",
                height: "23",
                rx: "3.5",
                stroke: outlineColor,
                strokeOpacity: strokeOpacity
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "49",
                y: "66",
                width: "16",
                height: "16",
                rx: "2",
                fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M57.8886 70.8889L56.1108 77.1111",
                stroke: "var(--ds-icon-accent-blue, #1D7AFC)",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M57.8889 70.8889L54.7778 74H59.2223L56.1112 77.1111",
                stroke: "var(--ds-icon-accent-blue, #1D7AFC)",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                x: "73",
                y: "69.5",
                width: "96",
                height: "9",
                rx: "2",
                fill: outlineColor,
                fillOpacity: strokeOpacity
            })
        ]
    });
};

});

parcelRegister("jbF4q", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bcaa47c5fe78537f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $bcaa47c5fe78537f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    emptyStateMessage: {
        id: 'automation-platform.automation-templates.template-dropdown.empty-state-message',
        defaultMessage: "Automate your team's manual tasks, so they can focus on the work that matters. <link>Explore templates</link> to get started.",
        description: 'The message to show when there are no automation templates to display in the dropdown menu'
    }
});

});


parcelRegister("ewuOV", function(module, exports) {

$parcel$export(module.exports, "TemplateList", () => $825650bd8c0095f8$export$c5a06aa0f041765d);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $iJBL3 = parcelRequire("iJBL3");

var $78OnL = parcelRequire("78OnL");

var $9wP5o = parcelRequire("9wP5o");

var $hb1kw = parcelRequire("hb1kw");

var $5sOoU = parcelRequire("5sOoU");
const $825650bd8c0095f8$export$c5a06aa0f041765d = ({ templates: templates, onTemplateSelected: onTemplateSelected, isDisabled: isDisabled })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
        children: templates.map(({ description: description, displayMetadata: { triggerIcons: triggerIcons, actionIcons: actionIcons }, id: id }, index)=>{
            const [triggerIcon] = triggerIcons;
            const [actionIcon] = actionIcons;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5sOoU.TemplateItem), {
                onClick: ()=>onTemplateSelected(id),
                triggerIcon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hb1kw.TemplateIcon), {
                    icon: triggerIcon ? (0, $9wP5o.getIconByDisplayMetadata)(triggerIcon) : (0, (/*@__PURE__*/$parcel$interopDefault($iJBL3))),
                    size: "small",
                    type: "trigger"
                }),
                actionIcon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hb1kw.TemplateIcon), {
                    icon: actionIcon ? (0, $9wP5o.getIconByDisplayMetadata)(actionIcon) : (0, (/*@__PURE__*/$parcel$interopDefault($iJBL3))),
                    size: "small",
                    type: "action"
                }),
                description: description,
                templateId: id,
                isDisabled: isDisabled
            }, index);
        })
    });
};

});
parcelRegister("iJBL3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa2c753ece5041b181498943e0fe8bd9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da39b7e93f6df1c6$var$_react = $da39b7e93f6df1c6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $da39b7e93f6df1c6$var$_dashboard = $da39b7e93f6df1c6$var$_interopRequireDefault((parcelRequire("5SdQs")));

var $da39b7e93f6df1c6$var$_activity = $da39b7e93f6df1c6$var$_interopRequireDefault((parcelRequire("975wj")));
function $da39b7e93f6df1c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DashboardIcon.
 * This component is DashboardIcon, with `UNSAFE_fallbackIcon` set to "ActivityIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $da39b7e93f6df1c6$var$DashboardIcon = (props)=>/*#__PURE__*/ $da39b7e93f6df1c6$var$_react.default.createElement($da39b7e93f6df1c6$var$_dashboard.default, Object.assign({
        LEGACY_fallbackIcon: $da39b7e93f6df1c6$var$_activity.default
    }, props));
$da39b7e93f6df1c6$var$DashboardIcon.Name = 'DashboardIconMigration';
var $da39b7e93f6df1c6$var$_default = module.exports.default = $da39b7e93f6df1c6$var$DashboardIcon;

});
parcelRegister("975wj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a290caf6b677b61$var$_react = $6a290caf6b677b61$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $6a290caf6b677b61$var$_dashboard = $6a290caf6b677b61$var$_interopRequireDefault((parcelRequire("5SdQs")));
function $6a290caf6b677b61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6a290caf6b677b61$var$ActivityIcon = (props)=>/*#__PURE__*/ $6a290caf6b677b61$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M19.004 17C19 17 19 7.006 19 7.006 19 7 4.996 7 4.996 7 5 7 5 16.994 5 16.994 5 17 19.004 17 19.004 17M3 7.006A2 2 0 0 1 4.995 5h14.01A2 2 0 0 1 21 7.006v9.988A2 2 0 0 1 19.005 19H4.995A2 2 0 0 1 3 16.994z"/><path d="M4 6h16v5H4zm5 2c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C9.455 7 9 7.448 9 8M5 8c0 .556.448 1 1 1 .556 0 1-.448 1-1 0-.556-.448-1-1-1-.556 0-1 .448-1 1"/></g></svg>`
    }, props, {
        newIcon: $6a290caf6b677b61$var$_dashboard.default
    }));
$6a290caf6b677b61$var$ActivityIcon.displayName = 'ActivityIcon';
var $6a290caf6b677b61$var$_default = module.exports.default = $6a290caf6b677b61$var$ActivityIcon;

});


parcelRegister("9wP5o", function(module, exports) {

$parcel$export(module.exports, "getIconByDisplayMetadata", () => $1f23ef206445f5c8$export$5333c3555c9749a2);
$parcel$export(module.exports, "isCrossProductIcon", () => $1f23ef206445f5c8$export$885d077e77bea0c7);

var $kMmrb = parcelRequire("kMmrb");

var $eKkOj = parcelRequire("eKkOj");

var $bcitO = parcelRequire("bcitO");

var $jlvUH = parcelRequire("jlvUH");

var $3GKOL = parcelRequire("3GKOL");

var $3C1GW = parcelRequire("3C1GW");

var $cAQ2R = parcelRequire("cAQ2R");

var $joRfR = parcelRequire("joRfR");

var $2PadD = parcelRequire("2PadD");

var $amxqt = parcelRequire("amxqt");

var $dlc8Q = parcelRequire("dlc8Q");

var $lyfmv = parcelRequire("lyfmv");

var $4TA31 = parcelRequire("4TA31");

var $ihebN = parcelRequire("ihebN");

var $lNdOF = parcelRequire("lNdOF");

var $dNLHm = parcelRequire("dNLHm");

var $6VVS2 = parcelRequire("6VVS2");

var $dtTJ9 = parcelRequire("dtTJ9");

var $kqRsv = parcelRequire("kqRsv");

var $kSre2 = parcelRequire("kSre2");

var $av9Of = parcelRequire("av9Of");

var $cRAIo = parcelRequire("cRAIo");

var $7icpf = parcelRequire("7icpf");

var $jZAJQ = parcelRequire("jZAJQ");

var $cdYRp = parcelRequire("cdYRp");

var $2qdn3 = parcelRequire("2qdn3");

var $58frP = parcelRequire("58frP");

var $arAT1 = parcelRequire("arAT1");

var $izhQH = parcelRequire("izhQH");

var $d0DRA = parcelRequire("d0DRA");

var $jVVB7 = parcelRequire("jVVB7");

var $dTYnh = parcelRequire("dTYnh");

var $6aKac = parcelRequire("6aKac");

var $i0iAU = parcelRequire("i0iAU");

var $hIRsw = parcelRequire("hIRsw");

var $fYw7A = parcelRequire("fYw7A");

var $3Y0kU = parcelRequire("3Y0kU");

var $3Isp2 = parcelRequire("3Isp2");

var $5Etd3 = parcelRequire("5Etd3");

var $cajrN = parcelRequire("cajrN");

var $8z7BJ = parcelRequire("8z7BJ");
var $29s68 = parcelRequire("29s68");
var $gbdsP = parcelRequire("gbdsP");

var $2AbqO = parcelRequire("2AbqO");
var $Ss5iS = parcelRequire("Ss5iS");
var $5u4Qo = parcelRequire("5u4Qo");
var $heQWt = parcelRequire("heQWt");
var $k3jlZ = parcelRequire("k3jlZ");
var $7c2el = parcelRequire("7c2el");
var $k3bMw = parcelRequire("k3bMw");
var $7wQau = parcelRequire("7wQau");
var $1zSeh = parcelRequire("1zSeh");
var $aex0Y = parcelRequire("aex0Y");
var $cgjnt = parcelRequire("cgjnt");
var $9RUC2 = parcelRequire("9RUC2");
var $i5aes = parcelRequire("i5aes");
var $2K44i = parcelRequire("2K44i");
var $gke8X = parcelRequire("gke8X");
var $7f40W = parcelRequire("7f40W");
var $jh58T = parcelRequire("jh58T");
var $kUSyg = parcelRequire("kUSyg");
// All icons in this package were firstly defined in the rule-library-icons.ts in the barrel repository.
// When adding a new icon, make sure to define it in the barrel file as well.
const $1f23ef206445f5c8$var$ruleLibraryIcons = {
    SoftwareIcon: (0, $9RUC2.JiraSoftwareIcon),
    ServiceDeskIcon: (0, $cgjnt.JSMBlueIcon),
    MediaServicesAddCommentIcon: (/*@__PURE__*/$parcel$interopDefault($dlc8Q)),
    MediaServicesAnnotateIcon: (0, $2AbqO.AnnotateIcon),
    MediaServicesDocumentIcon: (/*@__PURE__*/$parcel$interopDefault($2qdn3)),
    EditFilledIcon: (/*@__PURE__*/$parcel$interopDefault($lNdOF)),
    PersonCircleIcon: (/*@__PURE__*/$parcel$interopDefault($izhQH)),
    LinkIcon: (/*@__PURE__*/$parcel$interopDefault($av9Of)),
    TransitionIcon: $kUSyg.TransitionIcon,
    ConfluenceIcon: $k3jlZ.ConfluenceIcon,
    DocumentFilledIcon: (/*@__PURE__*/$parcel$interopDefault($kSre2)),
    LabelIcon: (/*@__PURE__*/$parcel$interopDefault($fYw7A)),
    ArchiveIcon: (/*@__PURE__*/$parcel$interopDefault($eKkOj)),
    IssueIcon: (/*@__PURE__*/$parcel$interopDefault($5Etd3)),
    EmailIcon: (/*@__PURE__*/$parcel$interopDefault($dNLHm)),
    QuoteIcon: (/*@__PURE__*/$parcel$interopDefault($dTYnh)),
    SlackIcon: $gbdsP.default,
    MsTeams: (0, $29s68.default),
    LaunchDarklyIcon: (0, $i5aes.LdCreateFeatureFlagIcon),
    GitLabIcon: $1zSeh.GitLabIcon,
    BitbucketIcon: $Ss5iS.BitbucketIcon,
    GitHubIcon: $7wQau.GitHubIcon,
    CheckCircleOutlineIcon: (/*@__PURE__*/$parcel$interopDefault($3C1GW)),
    TaskIcon: (/*@__PURE__*/$parcel$interopDefault($3Y0kU)),
    PageIcon: (/*@__PURE__*/$parcel$interopDefault($cdYRp)),
    WatchFilledIcon: (/*@__PURE__*/$parcel$interopDefault($kqRsv)),
    CalendarIcon: (/*@__PURE__*/$parcel$interopDefault($3GKOL)),
    IssueRaiseIcon: (/*@__PURE__*/$parcel$interopDefault($d0DRA)),
    SecurityIcon: $7f40W.SecurityIcon,
    NotificationIcon: (/*@__PURE__*/$parcel$interopDefault($jZAJQ)),
    AwsIcon: $8z7BJ.default,
    WarningIcon: (/*@__PURE__*/$parcel$interopDefault($3Isp2)),
    UploadIcon: (/*@__PURE__*/$parcel$interopDefault($2PadD)),
    ManualTriggerIcon: $2K44i.ManualTriggerIcon,
    LockIcon: (/*@__PURE__*/$parcel$interopDefault($7icpf)),
    EmojiFrequentIcon: (/*@__PURE__*/$parcel$interopDefault($joRfR)),
    ProductDiscoveryIcon: $gke8X.ProductDiscoveryIcon,
    EmojiAddIcon: (/*@__PURE__*/$parcel$interopDefault($6VVS2)),
    EditorAddIcon: (/*@__PURE__*/$parcel$interopDefault($kMmrb)),
    SmartValueIcon: $jh58T.SmartValueIcon,
    ChildIssuesIcon: (/*@__PURE__*/$parcel$interopDefault($cAQ2R)),
    MoveIcon: (/*@__PURE__*/$parcel$interopDefault($bcitO)),
    JiraBlueIcon: $aex0Y.JiraBlueIcon,
    PersonIcon: (/*@__PURE__*/$parcel$interopDefault($58frP)),
    CommentIcon: (/*@__PURE__*/$parcel$interopDefault($amxqt)),
    CopyIcon: (/*@__PURE__*/$parcel$interopDefault($4TA31)),
    WatchIcon: (/*@__PURE__*/$parcel$interopDefault($dtTJ9)),
    TrashIcon: (/*@__PURE__*/$parcel$interopDefault($ihebN)),
    BitbucketPullrequestsIcon: (/*@__PURE__*/$parcel$interopDefault($jVVB7)),
    ShipIcon: (/*@__PURE__*/$parcel$interopDefault($6aKac)),
    BitbucketBranchIcon: (/*@__PURE__*/$parcel$interopDefault($jlvUH)),
    BitbucketCompareIcon: (0, $5u4Qo.CompareIcon),
    CommitIcon: (/*@__PURE__*/$parcel$interopDefault($lyfmv)),
    SearchIcon: (/*@__PURE__*/$parcel$interopDefault($i0iAU)),
    IssuesIcon: (/*@__PURE__*/$parcel$interopDefault($cajrN)),
    BulletListIcon: (/*@__PURE__*/$parcel$interopDefault($cRAIo)),
    FieldValueChangedIcon: $7c2el.FieldValueChangedIcon,
    BitbucketForksIcon: (0, $k3bMw.ForkIcon),
    SprintIcon: (/*@__PURE__*/$parcel$interopDefault($hIRsw)),
    AppAccessIcon: (/*@__PURE__*/$parcel$interopDefault($arAT1)),
    CompassBlueIcon: $heQWt.CompassBlueIcon
};
const $1f23ef206445f5c8$var$crossProductIcons = new Set([
    $1f23ef206445f5c8$var$ruleLibraryIcons.SoftwareIcon,
    $1f23ef206445f5c8$var$ruleLibraryIcons.SlackIcon,
    $1f23ef206445f5c8$var$ruleLibraryIcons.GitHubIcon,
    $1f23ef206445f5c8$var$ruleLibraryIcons.GitLabIcon,
    $1f23ef206445f5c8$var$ruleLibraryIcons.LaunchDarklyIcon,
    $1f23ef206445f5c8$var$ruleLibraryIcons.ConfluenceIcon,
    $1f23ef206445f5c8$var$ruleLibraryIcons.AwsIcon,
    $1f23ef206445f5c8$var$ruleLibraryIcons.ServiceDeskIcon,
    $1f23ef206445f5c8$var$ruleLibraryIcons.JiraBlueIcon,
    $1f23ef206445f5c8$var$ruleLibraryIcons.CompassBlueIcon
]);
function $1f23ef206445f5c8$export$5333c3555c9749a2(iconId) {
    return $1f23ef206445f5c8$var$ruleLibraryIcons[iconId];
}
const $1f23ef206445f5c8$export$885d077e77bea0c7 = (icon)=>$1f23ef206445f5c8$var$crossProductIcons.has(icon);

});
parcelRegister("eKkOj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::542b8587e912458cb1fe6aa28ca83d10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abc581157a6c61c3$var$_react = $abc581157a6c61c3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $abc581157a6c61c3$var$_archiveBox = $abc581157a6c61c3$var$_interopRequireDefault((parcelRequire("6ozsI")));

var $abc581157a6c61c3$var$_archive = $abc581157a6c61c3$var$_interopRequireDefault((parcelRequire("gQLCs")));
function $abc581157a6c61c3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArchiveBoxIcon.
 * This component is ArchiveBoxIcon, with `UNSAFE_fallbackIcon` set to "ArchiveIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $abc581157a6c61c3$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $abc581157a6c61c3$var$_react.default.createElement($abc581157a6c61c3$var$_archiveBox.default, Object.assign({
        LEGACY_fallbackIcon: $abc581157a6c61c3$var$_archive.default
    }, props));
$abc581157a6c61c3$var$ArchiveBoxIcon.Name = 'ArchiveBoxIconMigration';
var $abc581157a6c61c3$var$_default = module.exports.default = $abc581157a6c61c3$var$ArchiveBoxIcon;

});
parcelRegister("6ozsI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a807e0481065374$var$_react = $4a807e0481065374$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4a807e0481065374$var$_baseNew = $4a807e0481065374$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $4a807e0481065374$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a807e0481065374$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $4a807e0481065374$var$_react.default.createElement($4a807e0481065374$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$4a807e0481065374$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $4a807e0481065374$var$_default = module.exports.default = $4a807e0481065374$var$ArchiveBoxIcon;

});

parcelRegister("gQLCs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c44670da38cfd7d6$var$_react = $c44670da38cfd7d6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $c44670da38cfd7d6$var$_archiveBox = $c44670da38cfd7d6$var$_interopRequireDefault((parcelRequire("6ozsI")));
function $c44670da38cfd7d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c44670da38cfd7d6$var$ArchiveIcon = (props)=>/*#__PURE__*/ $c44670da38cfd7d6$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 3H4.85A2 2 0 0 0 3 5v4h1v10.45A1.67 1.67 0 0 0 5.77 21h12.46A1.67 1.67 0 0 0 20 19.45V9h1V5a2 2 0 0 0-2-2m-1 16H6V9h12zm1-12H5V5h14zm-4 7H9v-2h6z" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $c44670da38cfd7d6$var$_archiveBox.default
    }));
$c44670da38cfd7d6$var$ArchiveIcon.displayName = 'ArchiveIcon';
var $c44670da38cfd7d6$var$_default = module.exports.default = $c44670da38cfd7d6$var$ArchiveIcon;

});


parcelRegister("bcitO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $826f266802ea1177$var$_react = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $826f266802ea1177$var$_arrowRight = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("ePxSL")));

var $826f266802ea1177$var$_arrowRight2 = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("WCqcH")));
function $826f266802ea1177$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $826f266802ea1177$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $826f266802ea1177$var$_react.default.createElement($826f266802ea1177$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $826f266802ea1177$var$_arrowRight2.default
    }, props));
$826f266802ea1177$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $826f266802ea1177$var$_default = module.exports.default = $826f266802ea1177$var$ArrowRightIcon;

});
parcelRegister("ePxSL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc01c6bd1fc51c7$var$_react = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $acc01c6bd1fc51c7$var$_baseNew = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $acc01c6bd1fc51c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc01c6bd1fc51c7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $acc01c6bd1fc51c7$var$_react.default.createElement($acc01c6bd1fc51c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$acc01c6bd1fc51c7$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $acc01c6bd1fc51c7$var$_default = module.exports.default = $acc01c6bd1fc51c7$var$ArrowRightIcon;

});

parcelRegister("WCqcH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b0338a1f0c13ece$var$_react = $0b0338a1f0c13ece$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $0b0338a1f0c13ece$var$_arrowRight = $0b0338a1f0c13ece$var$_interopRequireDefault((parcelRequire("ePxSL")));
function $0b0338a1f0c13ece$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0b0338a1f0c13ece$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $0b0338a1f0c13ece$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $0b0338a1f0c13ece$var$_arrowRight.default
    }));
$0b0338a1f0c13ece$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $0b0338a1f0c13ece$var$_default = module.exports.default = $0b0338a1f0c13ece$var$ArrowRightIcon;

});


parcelRegister("3C1GW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::569a9d4c43cf146ba3fe04b1751c4915>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a163b9c3cd47419$var$_react = $2a163b9c3cd47419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2a163b9c3cd47419$var$_checkCircle = $2a163b9c3cd47419$var$_interopRequireDefault((parcelRequire("gqEmK")));

var $2a163b9c3cd47419$var$_checkCircleOutline = $2a163b9c3cd47419$var$_interopRequireDefault((parcelRequire("aYKMq")));
function $2a163b9c3cd47419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckCircleIcon.
 * This component is CheckCircleIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleOutlineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a163b9c3cd47419$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $2a163b9c3cd47419$var$_react.default.createElement($2a163b9c3cd47419$var$_checkCircle.default, Object.assign({
        LEGACY_fallbackIcon: $2a163b9c3cd47419$var$_checkCircleOutline.default
    }, props));
$2a163b9c3cd47419$var$CheckCircleIcon.Name = 'CheckCircleIconMigration';
var $2a163b9c3cd47419$var$_default = module.exports.default = $2a163b9c3cd47419$var$CheckCircleIcon;

});
parcelRegister("aYKMq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7fe3cb8a08c9c712$var$_react = $7fe3cb8a08c9c712$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $7fe3cb8a08c9c712$var$_checkCircle = $7fe3cb8a08c9c712$var$_interopRequireDefault((parcelRequire("gqEmK")));
function $7fe3cb8a08c9c712$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7fe3cb8a08c9c712$var$CheckCircleOutlineIcon = (props)=>/*#__PURE__*/ $7fe3cb8a08c9c712$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $7fe3cb8a08c9c712$var$_checkCircle.default
    }));
$7fe3cb8a08c9c712$var$CheckCircleOutlineIcon.displayName = 'CheckCircleOutlineIcon';
var $7fe3cb8a08c9c712$var$_default = module.exports.default = $7fe3cb8a08c9c712$var$CheckCircleOutlineIcon;

});


parcelRegister("cAQ2R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1043cc02e149fc19165ba5b91793bff7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92b137e2440c53b9$var$_react = $92b137e2440c53b9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $92b137e2440c53b9$var$_childWorkItems = $92b137e2440c53b9$var$_interopRequireDefault((parcelRequire("4V9Yp")));

var $92b137e2440c53b9$var$_childIssues = $92b137e2440c53b9$var$_interopRequireDefault((parcelRequire("8NFT3")));
function $92b137e2440c53b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChildWorkItemsIcon.
 * This component is ChildWorkItemsIcon, with `UNSAFE_fallbackIcon` set to "ChildIssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for child work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92b137e2440c53b9$var$ChildWorkItemsIcon = (props)=>/*#__PURE__*/ $92b137e2440c53b9$var$_react.default.createElement($92b137e2440c53b9$var$_childWorkItems.default, Object.assign({
        LEGACY_fallbackIcon: $92b137e2440c53b9$var$_childIssues.default
    }, props));
$92b137e2440c53b9$var$ChildWorkItemsIcon.Name = 'ChildWorkItemsIconMigration';
var $92b137e2440c53b9$var$_default = module.exports.default = $92b137e2440c53b9$var$ChildWorkItemsIcon;

});
parcelRegister("4V9Yp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8059ae9af0ca9aea6d8a2945440623bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $395438d0d367a1e4$var$_react = $395438d0d367a1e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $395438d0d367a1e4$var$_baseNew = $395438d0d367a1e4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $395438d0d367a1e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChildWorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for child work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $395438d0d367a1e4$var$ChildWorkItemsIcon = (props)=>/*#__PURE__*/ $395438d0d367a1e4$var$_react.default.createElement($395438d0d367a1e4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.5 13.5h5V11h-5zm0-7h5V4h-5zm6.5.25C15 7.44 14.44 8 13.75 8h-5.5C7.56 8 7 7.44 7 6.75V6H2.5v5a.5.5 0 0 0 .5.5h4v-.75c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-5.5C7.56 15 7 14.44 7 13.75V13H3a2 2 0 0 1-2-2V1h1.5v3.5H7v-.75c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25z"/>`
    }, props));
$395438d0d367a1e4$var$ChildWorkItemsIcon.displayName = 'ChildWorkItemsIcon';
var $395438d0d367a1e4$var$_default = module.exports.default = $395438d0d367a1e4$var$ChildWorkItemsIcon;

});

parcelRegister("8NFT3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66836434d770f8d0$var$_react = $66836434d770f8d0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $66836434d770f8d0$var$_childWorkItems = $66836434d770f8d0$var$_interopRequireDefault((parcelRequire("4V9Yp")));
function $66836434d770f8d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $66836434d770f8d0$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $66836434d770f8d0$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $66836434d770f8d0$var$_childWorkItems.default
    }));
$66836434d770f8d0$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $66836434d770f8d0$var$_default = module.exports.default = $66836434d770f8d0$var$ChildIssuesIcon;

});


parcelRegister("joRfR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c9c914f8f7a3631a5a598f1ef46602e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1f99187a8872939$var$_react = $e1f99187a8872939$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e1f99187a8872939$var$_clock = $e1f99187a8872939$var$_interopRequireDefault((parcelRequire("i5stJ")));

var $e1f99187a8872939$var$_frequent = $e1f99187a8872939$var$_interopRequireDefault((parcelRequire("gTfIE")));
function $e1f99187a8872939$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ClockIcon.
 * This component is ClockIcon, with `UNSAFE_fallbackIcon` set to "EmojiFrequentIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e1f99187a8872939$var$ClockIcon = (props)=>/*#__PURE__*/ $e1f99187a8872939$var$_react.default.createElement($e1f99187a8872939$var$_clock.default, Object.assign({
        LEGACY_fallbackIcon: $e1f99187a8872939$var$_frequent.default
    }, props));
$e1f99187a8872939$var$ClockIcon.Name = 'ClockIconMigration';
var $e1f99187a8872939$var$_default = module.exports.default = $e1f99187a8872939$var$ClockIcon;

});
parcelRegister("gTfIE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4bdf9e893a4916c$var$_react = $c4bdf9e893a4916c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $c4bdf9e893a4916c$var$_clock = $c4bdf9e893a4916c$var$_interopRequireDefault((parcelRequire("i5stJ")));
function $c4bdf9e893a4916c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c4bdf9e893a4916c$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $c4bdf9e893a4916c$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $c4bdf9e893a4916c$var$_clock.default
    }));
$c4bdf9e893a4916c$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $c4bdf9e893a4916c$var$_default = module.exports.default = $c4bdf9e893a4916c$var$EmojiFrequentIcon;

});


parcelRegister("2PadD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da6815f1e303f26a4e473874c26eef5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20e8457987a4b96b$var$_react = $20e8457987a4b96b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $20e8457987a4b96b$var$_cloudArrowUp = $20e8457987a4b96b$var$_interopRequireDefault((parcelRequire("bzGVj")));

var $20e8457987a4b96b$var$_upload = $20e8457987a4b96b$var$_interopRequireDefault((parcelRequire("lmcPJ")));
function $20e8457987a4b96b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloudArrowUpIcon.
 * This component is CloudArrowUpIcon, with `UNSAFE_fallbackIcon` set to "UploadIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $20e8457987a4b96b$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $20e8457987a4b96b$var$_react.default.createElement($20e8457987a4b96b$var$_cloudArrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $20e8457987a4b96b$var$_upload.default
    }, props));
$20e8457987a4b96b$var$CloudArrowUpIcon.Name = 'CloudArrowUpIconMigration';
var $20e8457987a4b96b$var$_default = module.exports.default = $20e8457987a4b96b$var$CloudArrowUpIcon;

});
parcelRegister("bzGVj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86d44242ca1c7b8f$var$_react = $86d44242ca1c7b8f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $86d44242ca1c7b8f$var$_baseNew = $86d44242ca1c7b8f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $86d44242ca1c7b8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86d44242ca1c7b8f$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $86d44242ca1c7b8f$var$_react.default.createElement($86d44242ca1c7b8f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$86d44242ca1c7b8f$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $86d44242ca1c7b8f$var$_default = module.exports.default = $86d44242ca1c7b8f$var$CloudArrowUpIcon;

});

parcelRegister("lmcPJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8c59b79ccf43c2a$var$_react = $f8c59b79ccf43c2a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $f8c59b79ccf43c2a$var$_cloudArrowUp = $f8c59b79ccf43c2a$var$_interopRequireDefault((parcelRequire("bzGVj")));
function $f8c59b79ccf43c2a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8c59b79ccf43c2a$var$UploadIcon = (props)=>/*#__PURE__*/ $f8c59b79ccf43c2a$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $f8c59b79ccf43c2a$var$_cloudArrowUp.default
    }));
$f8c59b79ccf43c2a$var$UploadIcon.displayName = 'UploadIcon';
var $f8c59b79ccf43c2a$var$_default = module.exports.default = $f8c59b79ccf43c2a$var$UploadIcon;

});


parcelRegister("amxqt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfb8e24ad0aeafedb3c07855964a196e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78b5e325967a99e4$var$_react = $78b5e325967a99e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78b5e325967a99e4$var$_comment = $78b5e325967a99e4$var$_interopRequireDefault((parcelRequire("gDKBr")));

var $78b5e325967a99e4$var$_comment2 = $78b5e325967a99e4$var$_interopRequireDefault((parcelRequire("04OD1")));
function $78b5e325967a99e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CommentIcon.
 * This component is CommentIcon, with `UNSAFE_fallbackIcon` set to "CommentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78b5e325967a99e4$var$CommentIcon = (props)=>/*#__PURE__*/ $78b5e325967a99e4$var$_react.default.createElement($78b5e325967a99e4$var$_comment.default, Object.assign({
        LEGACY_fallbackIcon: $78b5e325967a99e4$var$_comment2.default
    }, props));
$78b5e325967a99e4$var$CommentIcon.Name = 'CommentIconMigration';
var $78b5e325967a99e4$var$_default = module.exports.default = $78b5e325967a99e4$var$CommentIcon;

});
parcelRegister("gDKBr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1d470387d991694$var$_react = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c1d470387d991694$var$_baseNew = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c1d470387d991694$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1d470387d991694$var$CommentIcon = (props)=>/*#__PURE__*/ $c1d470387d991694$var$_react.default.createElement($c1d470387d991694$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$c1d470387d991694$var$CommentIcon.displayName = 'CommentIcon';
var $c1d470387d991694$var$_default = module.exports.default = $c1d470387d991694$var$CommentIcon;

});

parcelRegister("04OD1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00e7a599837ddc3e$var$_react = $00e7a599837ddc3e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $00e7a599837ddc3e$var$_comment = $00e7a599837ddc3e$var$_interopRequireDefault((parcelRequire("gDKBr")));
function $00e7a599837ddc3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $00e7a599837ddc3e$var$CommentIcon = (props)=>/*#__PURE__*/ $00e7a599837ddc3e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $00e7a599837ddc3e$var$_comment.default
    }));
$00e7a599837ddc3e$var$CommentIcon.displayName = 'CommentIcon';
var $00e7a599837ddc3e$var$_default = module.exports.default = $00e7a599837ddc3e$var$CommentIcon;

});


parcelRegister("dlc8Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c17f81d56eb3fac7430f9eb7cb829a7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b66a79ed6de7fb9$var$_react = $9b66a79ed6de7fb9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9b66a79ed6de7fb9$var$_commentAdd = $9b66a79ed6de7fb9$var$_interopRequireDefault((parcelRequire("G1EII")));

var $9b66a79ed6de7fb9$var$_addComment = $9b66a79ed6de7fb9$var$_interopRequireDefault((parcelRequire("CwC9E")));
function $9b66a79ed6de7fb9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CommentAddIcon.
 * This component is CommentAddIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesAddCommentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a comment to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b66a79ed6de7fb9$var$CommentAddIcon = (props)=>/*#__PURE__*/ $9b66a79ed6de7fb9$var$_react.default.createElement($9b66a79ed6de7fb9$var$_commentAdd.default, Object.assign({
        LEGACY_fallbackIcon: $9b66a79ed6de7fb9$var$_addComment.default
    }, props));
$9b66a79ed6de7fb9$var$CommentAddIcon.Name = 'CommentAddIconMigration';
var $9b66a79ed6de7fb9$var$_default = module.exports.default = $9b66a79ed6de7fb9$var$CommentAddIcon;

});
parcelRegister("G1EII", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb2d0be06a266417135359c5b1e35598>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07e53529518cbc0e$var$_react = $07e53529518cbc0e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $07e53529518cbc0e$var$_baseNew = $07e53529518cbc0e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $07e53529518cbc0e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CommentAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a comment to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07e53529518cbc0e$var$CommentAddIcon = (props)=>/*#__PURE__*/ $07e53529518cbc0e$var$_react.default.createElement($07e53529518cbc0e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM7.25 6.5V4.25h1.5V6.5H11V8H8.75v2.25h-1.5V8H5V6.5z" clip-rule="evenodd"/>`
    }, props));
$07e53529518cbc0e$var$CommentAddIcon.displayName = 'CommentAddIcon';
var $07e53529518cbc0e$var$_default = module.exports.default = $07e53529518cbc0e$var$CommentAddIcon;

});

parcelRegister("CwC9E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $073cd943b2356ac4$var$_react = $073cd943b2356ac4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $073cd943b2356ac4$var$_commentAdd = $073cd943b2356ac4$var$_interopRequireDefault((parcelRequire("G1EII")));
function $073cd943b2356ac4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $073cd943b2356ac4$var$MediaServicesAddCommentIcon = (props)=>/*#__PURE__*/ $073cd943b2356ac4$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M14 4.187A10.7 10.7 0 0 0 12 4c-4.963 0-9 3.37-9 7.513s4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716v-.002s-1.563-2.26-.766-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513a6 6 0 0 0-.02-.513h-2.008q.03.254.03.513c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51S8.139 6.003 12 6.003c.695 0 1.366.08 2 .229z"/><rect width="2" height="6" x="17" y="4" rx="1"/><rect width="6" height="2" x="15" y="6" rx="1"/></g></svg>`
    }, props, {
        newIcon: $073cd943b2356ac4$var$_commentAdd.default
    }));
$073cd943b2356ac4$var$MediaServicesAddCommentIcon.displayName = 'MediaServicesAddCommentIcon';
var $073cd943b2356ac4$var$_default = module.exports.default = $073cd943b2356ac4$var$MediaServicesAddCommentIcon;

});


parcelRegister("lyfmv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1201ab50caa951687977050b2b11e97b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb08b087cb0550d7$var$_react = $fb08b087cb0550d7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fb08b087cb0550d7$var$_commit = $fb08b087cb0550d7$var$_interopRequireDefault((parcelRequire("7XCnf")));

var $fb08b087cb0550d7$var$_commits = $fb08b087cb0550d7$var$_interopRequireDefault((parcelRequire("bAoP2")));
function $fb08b087cb0550d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CommitIcon.
 * This component is CommitIcon, with `UNSAFE_fallbackIcon` set to "BitbucketCommitsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb08b087cb0550d7$var$CommitIcon = (props)=>/*#__PURE__*/ $fb08b087cb0550d7$var$_react.default.createElement($fb08b087cb0550d7$var$_commit.default, Object.assign({
        LEGACY_fallbackIcon: $fb08b087cb0550d7$var$_commits.default
    }, props));
$fb08b087cb0550d7$var$CommitIcon.Name = 'CommitIconMigration';
var $fb08b087cb0550d7$var$_default = module.exports.default = $fb08b087cb0550d7$var$CommitIcon;

});
parcelRegister("7XCnf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06952e599791aaa8e8e82dba5053d210>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cbbcf5690c6b367$var$_react = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5cbbcf5690c6b367$var$_baseNew = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5cbbcf5690c6b367$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cbbcf5690c6b367$var$CommitIcon = (props)=>/*#__PURE__*/ $5cbbcf5690c6b367$var$_react.default.createElement($5cbbcf5690c6b367$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$5cbbcf5690c6b367$var$CommitIcon.displayName = 'CommitIcon';
var $5cbbcf5690c6b367$var$_default = module.exports.default = $5cbbcf5690c6b367$var$CommitIcon;

});

parcelRegister("bAoP2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86f64fb1220f49f8$var$_react = $86f64fb1220f49f8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $86f64fb1220f49f8$var$_commit = $86f64fb1220f49f8$var$_interopRequireDefault((parcelRequire("7XCnf")));
function $86f64fb1220f49f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $86f64fb1220f49f8$var$BitbucketCommitsIcon = (props)=>/*#__PURE__*/ $86f64fb1220f49f8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9m-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"/></svg>`
    }, props, {
        newIcon: $86f64fb1220f49f8$var$_commit.default
    }));
$86f64fb1220f49f8$var$BitbucketCommitsIcon.displayName = 'BitbucketCommitsIcon';
var $86f64fb1220f49f8$var$_default = module.exports.default = $86f64fb1220f49f8$var$BitbucketCommitsIcon;

});


parcelRegister("lNdOF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d8183d86255e266d89dc1fd99bbc4dd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fdd8e4308e7da87e$var$_react = $fdd8e4308e7da87e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fdd8e4308e7da87e$var$_edit = $fdd8e4308e7da87e$var$_interopRequireDefault((parcelRequire("gTr6H")));

var $fdd8e4308e7da87e$var$_editFilled = $fdd8e4308e7da87e$var$_interopRequireDefault((parcelRequire("5InvN")));
function $fdd8e4308e7da87e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fdd8e4308e7da87e$var$EditIcon = (props)=>/*#__PURE__*/ $fdd8e4308e7da87e$var$_react.default.createElement($fdd8e4308e7da87e$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $fdd8e4308e7da87e$var$_editFilled.default
    }, props));
$fdd8e4308e7da87e$var$EditIcon.Name = 'EditIconMigration';
var $fdd8e4308e7da87e$var$_default = module.exports.default = $fdd8e4308e7da87e$var$EditIcon;

});
parcelRegister("gTr6H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4c6cf489c8bf4fc$var$_react = $c4c6cf489c8bf4fc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c4c6cf489c8bf4fc$var$_baseNew = $c4c6cf489c8bf4fc$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c4c6cf489c8bf4fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4c6cf489c8bf4fc$var$EditIcon = (props)=>/*#__PURE__*/ $c4c6cf489c8bf4fc$var$_react.default.createElement($c4c6cf489c8bf4fc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$c4c6cf489c8bf4fc$var$EditIcon.displayName = 'EditIcon';
var $c4c6cf489c8bf4fc$var$_default = module.exports.default = $c4c6cf489c8bf4fc$var$EditIcon;

});

parcelRegister("5InvN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42934ccb2fe03455$var$_react = $42934ccb2fe03455$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $42934ccb2fe03455$var$_edit = $42934ccb2fe03455$var$_interopRequireDefault((parcelRequire("gTr6H")));
function $42934ccb2fe03455$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $42934ccb2fe03455$var$EditFilledIcon = (props)=>/*#__PURE__*/ $42934ccb2fe03455$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $42934ccb2fe03455$var$_edit.default
    }));
$42934ccb2fe03455$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $42934ccb2fe03455$var$_default = module.exports.default = $42934ccb2fe03455$var$EditFilledIcon;

});


parcelRegister("6VVS2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73bb0e29c7f7a728c3573234fe0b4d23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50c4f4d96dc90123$var$_react = $50c4f4d96dc90123$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $50c4f4d96dc90123$var$_emojiAdd = $50c4f4d96dc90123$var$_interopRequireDefault((parcelRequire("gxQLu")));

var $50c4f4d96dc90123$var$_emojiAdd2 = $50c4f4d96dc90123$var$_interopRequireDefault((parcelRequire("fPVZ9")));
function $50c4f4d96dc90123$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EmojiAddIcon.
 * This component is EmojiAddIcon, with `UNSAFE_fallbackIcon` set to "EmojiAddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50c4f4d96dc90123$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $50c4f4d96dc90123$var$_react.default.createElement($50c4f4d96dc90123$var$_emojiAdd.default, Object.assign({
        LEGACY_fallbackIcon: $50c4f4d96dc90123$var$_emojiAdd2.default
    }, props));
$50c4f4d96dc90123$var$EmojiAddIcon.Name = 'EmojiAddIconMigration';
var $50c4f4d96dc90123$var$_default = module.exports.default = $50c4f4d96dc90123$var$EmojiAddIcon;

});
parcelRegister("gxQLu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd679256a7ffba837ffea22e1b814e43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c0b8a8745bb75027$var$_react = $c0b8a8745bb75027$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c0b8a8745bb75027$var$_baseNew = $c0b8a8745bb75027$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c0b8a8745bb75027$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding an emoji reaction.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c0b8a8745bb75027$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $c0b8a8745bb75027$var$_react.default.createElement($c0b8a8745bb75027$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 8a6.5 6.5 0 1 0 13 0H16a8 8 0 1 1-8-8v1.5A6.5 6.5 0 0 0 1.5 8m4.585 2.033c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513M5.75 7.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m4.5 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m2.25-4h-2V2h2V0H14v2h2v1.5h-2v2h-1.5z" clip-rule="evenodd"/>`
    }, props));
$c0b8a8745bb75027$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
var $c0b8a8745bb75027$var$_default = module.exports.default = $c0b8a8745bb75027$var$EmojiAddIcon;

});

parcelRegister("fPVZ9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b878991fa6e8234d$var$_react = $b878991fa6e8234d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $b878991fa6e8234d$var$_emojiAdd = $b878991fa6e8234d$var$_interopRequireDefault((parcelRequire("gxQLu")));
function $b878991fa6e8234d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b878991fa6e8234d$var$EmojiAddIcon = (props)=>/*#__PURE__*/ $b878991fa6e8234d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.049 14.197c-.166-.476.103-.991.602-1.15.5-.159 1.039.098 1.205.575.06.174.225.487.495.796.426.488.955.764 1.649.764.693 0 1.223-.276 1.65-.764.27-.31.433-.622.494-.796.166-.476.706-.734 1.204-.575.5.159.77.673.603 1.15-.13.371-.395.876-.839 1.385C14.348 16.458 13.306 17 12 17s-2.348-.542-3.112-1.418a4.4 4.4 0 0 1-.839-1.385M9.5 11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M19 5h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0V7h-1a1 1 0 0 1 0-2h1V4a1 1 0 0 1 2 0zm-5-1.777V5.29A7 7 0 1 0 18.71 10h2.067A9 9 0 1 1 14 3.223"/></svg>`
    }, props, {
        newIcon: $b878991fa6e8234d$var$_emojiAdd.default
    }));
$b878991fa6e8234d$var$EmojiAddIcon.displayName = 'EmojiAddIcon';
var $b878991fa6e8234d$var$_default = module.exports.default = $b878991fa6e8234d$var$EmojiAddIcon;

});


parcelRegister("dtTJ9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a052784e02c39e1ef8b9f184efeeb6e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d0936107c0d5f84$var$_react = $9d0936107c0d5f84$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9d0936107c0d5f84$var$_eyeOpen = $9d0936107c0d5f84$var$_interopRequireDefault((parcelRequire("bkdrw")));

var $9d0936107c0d5f84$var$_watch = $9d0936107c0d5f84$var$_interopRequireDefault((parcelRequire("ckYfT")));
function $9d0936107c0d5f84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EyeOpenIcon.
 * This component is EyeOpenIcon, with `UNSAFE_fallbackIcon` set to "WatchIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d0936107c0d5f84$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $9d0936107c0d5f84$var$_react.default.createElement($9d0936107c0d5f84$var$_eyeOpen.default, Object.assign({
        LEGACY_fallbackIcon: $9d0936107c0d5f84$var$_watch.default
    }, props));
$9d0936107c0d5f84$var$EyeOpenIcon.Name = 'EyeOpenIconMigration';
var $9d0936107c0d5f84$var$_default = module.exports.default = $9d0936107c0d5f84$var$EyeOpenIcon;

});
parcelRegister("bkdrw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83ebfd72793ed518$var$_react = $83ebfd72793ed518$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $83ebfd72793ed518$var$_baseNew = $83ebfd72793ed518$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $83ebfd72793ed518$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83ebfd72793ed518$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $83ebfd72793ed518$var$_react.default.createElement($83ebfd72793ed518$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$83ebfd72793ed518$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $83ebfd72793ed518$var$_default = module.exports.default = $83ebfd72793ed518$var$EyeOpenIcon;

});

parcelRegister("ckYfT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fb617c320567a2b$var$_react = $8fb617c320567a2b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $8fb617c320567a2b$var$_eyeOpen = $8fb617c320567a2b$var$_interopRequireDefault((parcelRequire("bkdrw")));
function $8fb617c320567a2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8fb617c320567a2b$var$WatchIcon = (props)=>/*#__PURE__*/ $8fb617c320567a2b$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.978 13.984c-1.104 0-2-.897-2-2s.896-2 2-2c1.103 0 2 .897 2 2s-.897 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.793 4 4 4 4-1.794 4-4-1.794-4-4-4"/></g></svg>`
    }, props, {
        newIcon: $8fb617c320567a2b$var$_eyeOpen.default
    }));
$8fb617c320567a2b$var$WatchIcon.displayName = 'WatchIcon';
var $8fb617c320567a2b$var$_default = module.exports.default = $8fb617c320567a2b$var$WatchIcon;

});


parcelRegister("kqRsv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc42c676c93bbd8ebbafcf12a5b740f7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edffb42c5006c491$var$_react = $edffb42c5006c491$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $edffb42c5006c491$var$_eyeOpenFilled = $edffb42c5006c491$var$_interopRequireDefault((parcelRequire("1VZsk")));

var $edffb42c5006c491$var$_watchFilled = $edffb42c5006c491$var$_interopRequireDefault((parcelRequire("jefpy")));
function $edffb42c5006c491$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EyeOpenFilledIcon.
 * This component is EyeOpenFilledIcon, with `UNSAFE_fallbackIcon` set to "WatchFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watched pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edffb42c5006c491$var$EyeOpenFilledIcon = (props)=>/*#__PURE__*/ $edffb42c5006c491$var$_react.default.createElement($edffb42c5006c491$var$_eyeOpenFilled.default, Object.assign({
        LEGACY_fallbackIcon: $edffb42c5006c491$var$_watchFilled.default
    }, props));
$edffb42c5006c491$var$EyeOpenFilledIcon.Name = 'EyeOpenFilledIconMigration';
var $edffb42c5006c491$var$_default = module.exports.default = $edffb42c5006c491$var$EyeOpenFilledIcon;

});
parcelRegister("1VZsk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::895be44c60961cd5e7ff3bf0ce94ca85>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $168ac92a3fd9b9e4$var$_react = $168ac92a3fd9b9e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $168ac92a3fd9b9e4$var$_baseNew = $168ac92a3fd9b9e4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $168ac92a3fd9b9e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watched pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $168ac92a3fd9b9e4$var$EyeOpenFilledIcon = (props)=>/*#__PURE__*/ $168ac92a3fd9b9e4$var$_react.default.createElement($168ac92a3fd9b9e4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 8a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M8 2C4.433 2 1.319 4.232.167 7.38c-.146.4-.146.84 0 1.24C1.32 11.768 4.433 14 8 14c3.566 0 6.681-2.232 7.833-5.38.146-.4.146-.84 0-1.24C14.68 4.232 11.566 2 8 2m0 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5" clip-rule="evenodd"/>`
    }, props));
$168ac92a3fd9b9e4$var$EyeOpenFilledIcon.displayName = 'EyeOpenFilledIcon';
var $168ac92a3fd9b9e4$var$_default = module.exports.default = $168ac92a3fd9b9e4$var$EyeOpenFilledIcon;

});

parcelRegister("jefpy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dffb477533b18cfa$var$_react = $dffb477533b18cfa$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $dffb477533b18cfa$var$_eyeOpenFilled = $dffb477533b18cfa$var$_interopRequireDefault((parcelRequire("1VZsk")));
function $dffb477533b18cfa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dffb477533b18cfa$var$WatchFilledIcon = (props)=>/*#__PURE__*/ $dffb477533b18cfa$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.983 15.984a4.005 4.005 0 0 1-4.002-4c0-2.206 1.795-4 4.002-4a4.005 4.005 0 0 1 4.002 4c0 2.206-1.795 4-4.002 4M12 4C6.48 4 2 8.84 2 12c0 3.086 4.577 8 10 8s10-4.914 10-8c0-3.16-4.481-8-10-8"/><circle cx="12" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $dffb477533b18cfa$var$_eyeOpenFilled.default
    }));
$dffb477533b18cfa$var$WatchFilledIcon.displayName = 'WatchFilledIcon';
var $dffb477533b18cfa$var$_default = module.exports.default = $dffb477533b18cfa$var$WatchFilledIcon;

});


parcelRegister("kSre2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c20e147606d139fd2bd9c488f6dfb0c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f32df82c412cc2b2$var$_react = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f32df82c412cc2b2$var$_file = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("jvbqF")));

var $f32df82c412cc2b2$var$_documentFilled = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("ePbAf")));
function $f32df82c412cc2b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f32df82c412cc2b2$var$FileIcon = (props)=>/*#__PURE__*/ $f32df82c412cc2b2$var$_react.default.createElement($f32df82c412cc2b2$var$_file.default, Object.assign({
        LEGACY_fallbackIcon: $f32df82c412cc2b2$var$_documentFilled.default
    }, props));
$f32df82c412cc2b2$var$FileIcon.Name = 'FileIconMigration';
var $f32df82c412cc2b2$var$_default = module.exports.default = $f32df82c412cc2b2$var$FileIcon;

});
parcelRegister("jvbqF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e329c724a11ab833$var$_react = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e329c724a11ab833$var$_baseNew = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e329c724a11ab833$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e329c724a11ab833$var$FileIcon = (props)=>/*#__PURE__*/ $e329c724a11ab833$var$_react.default.createElement($e329c724a11ab833$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e329c724a11ab833$var$FileIcon.displayName = 'FileIcon';
var $e329c724a11ab833$var$_default = module.exports.default = $e329c724a11ab833$var$FileIcon;

});

parcelRegister("ePbAf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acaed063c693be85$var$_react = $acaed063c693be85$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $acaed063c693be85$var$_file = $acaed063c693be85$var$_interopRequireDefault((parcelRequire("jvbqF")));
function $acaed063c693be85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $acaed063c693be85$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $acaed063c693be85$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props, {
        newIcon: $acaed063c693be85$var$_file.default
    }));
$acaed063c693be85$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $acaed063c693be85$var$_default = module.exports.default = $acaed063c693be85$var$DocumentFilledIcon;

});


parcelRegister("av9Of", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a54689236011148$var$_react = $7a54689236011148$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7a54689236011148$var$_link = $7a54689236011148$var$_interopRequireDefault((parcelRequire("cV8sz")));

var $7a54689236011148$var$_link2 = $7a54689236011148$var$_interopRequireDefault((parcelRequire("a2o1i")));
function $7a54689236011148$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a54689236011148$var$LinkIcon = (props)=>/*#__PURE__*/ $7a54689236011148$var$_react.default.createElement($7a54689236011148$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $7a54689236011148$var$_link2.default
    }, props));
$7a54689236011148$var$LinkIcon.Name = 'LinkIconMigration';
var $7a54689236011148$var$_default = module.exports.default = $7a54689236011148$var$LinkIcon;

});
parcelRegister("a2o1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74ecb925586ee899$var$_react = $74ecb925586ee899$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $74ecb925586ee899$var$_link = $74ecb925586ee899$var$_interopRequireDefault((parcelRequire("cV8sz")));
function $74ecb925586ee899$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $74ecb925586ee899$var$LinkIcon = (props)=>/*#__PURE__*/ $74ecb925586ee899$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $74ecb925586ee899$var$_link.default
    }));
$74ecb925586ee899$var$LinkIcon.displayName = 'LinkIcon';
var $74ecb925586ee899$var$_default = module.exports.default = $74ecb925586ee899$var$LinkIcon;

});


parcelRegister("7icpf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::766864a6ad12ee0b57d7ed41e0a75cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $54f3d671b23b5985$var$_react = $54f3d671b23b5985$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $54f3d671b23b5985$var$_lockLocked = $54f3d671b23b5985$var$_interopRequireDefault((parcelRequire("9QgTI")));

var $54f3d671b23b5985$var$_lock = $54f3d671b23b5985$var$_interopRequireDefault((parcelRequire("jFH1h")));
function $54f3d671b23b5985$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $54f3d671b23b5985$var$LockLockedIcon = (props)=>/*#__PURE__*/ $54f3d671b23b5985$var$_react.default.createElement($54f3d671b23b5985$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $54f3d671b23b5985$var$_lock.default
    }, props));
$54f3d671b23b5985$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $54f3d671b23b5985$var$_default = module.exports.default = $54f3d671b23b5985$var$LockLockedIcon;

});
parcelRegister("9QgTI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72a613e9f42e1e21$var$_react = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72a613e9f42e1e21$var$_baseNew = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72a613e9f42e1e21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72a613e9f42e1e21$var$LockLockedIcon = (props)=>/*#__PURE__*/ $72a613e9f42e1e21$var$_react.default.createElement($72a613e9f42e1e21$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$72a613e9f42e1e21$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $72a613e9f42e1e21$var$_default = module.exports.default = $72a613e9f42e1e21$var$LockLockedIcon;

});

parcelRegister("jFH1h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e523377710580c71$var$_react = $e523377710580c71$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $e523377710580c71$var$_lockLocked = $e523377710580c71$var$_interopRequireDefault((parcelRequire("9QgTI")));
function $e523377710580c71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e523377710580c71$var$LockIcon = (props)=>/*#__PURE__*/ $e523377710580c71$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $e523377710580c71$var$_lockLocked.default
    }));
$e523377710580c71$var$LockIcon.displayName = 'LockIcon';
var $e523377710580c71$var$_default = module.exports.default = $e523377710580c71$var$LockIcon;

});


parcelRegister("2qdn3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b31c44090aaef867aaef7692fca9a50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c3861a54953392f$var$_react = $1c3861a54953392f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1c3861a54953392f$var$_page = $1c3861a54953392f$var$_interopRequireDefault((parcelRequire("DtmfJ")));

var $1c3861a54953392f$var$_document = $1c3861a54953392f$var$_interopRequireDefault((parcelRequire("dpuyx")));
function $1c3861a54953392f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PageIcon.
 * This component is PageIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesDocumentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1c3861a54953392f$var$PageIcon = (props)=>/*#__PURE__*/ $1c3861a54953392f$var$_react.default.createElement($1c3861a54953392f$var$_page.default, Object.assign({
        LEGACY_fallbackIcon: $1c3861a54953392f$var$_document.default
    }, props));
$1c3861a54953392f$var$PageIcon.Name = 'PageIconMigration';
var $1c3861a54953392f$var$_default = module.exports.default = $1c3861a54953392f$var$PageIcon;

});
parcelRegister("dpuyx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c354ff53850243d$var$_react = $9c354ff53850243d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $9c354ff53850243d$var$_page = $9c354ff53850243d$var$_interopRequireDefault((parcelRequire("DtmfJ")));
function $9c354ff53850243d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9c354ff53850243d$var$MediaServicesDocumentIcon = (props)=>/*#__PURE__*/ $9c354ff53850243d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="16" height="16" x="4" y="4" fill="currentcolor" rx="2"/><rect width="10" height="2" x="7" y="8" fill="inherit" rx="1"/><rect width="10" height="2" x="7" y="11" fill="inherit" rx="1"/><rect width="5" height="2" x="7" y="14" fill="inherit" rx="1"/></g></svg>`
    }, props, {
        newIcon: $9c354ff53850243d$var$_page.default
    }));
$9c354ff53850243d$var$MediaServicesDocumentIcon.displayName = 'MediaServicesDocumentIcon';
var $9c354ff53850243d$var$_default = module.exports.default = $9c354ff53850243d$var$MediaServicesDocumentIcon;

});


parcelRegister("arAT1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc692e4fce6ce1bda1cb15645d39414e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79a909e245f69aa6$var$_react = $79a909e245f69aa6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $79a909e245f69aa6$var$_personAdded = $79a909e245f69aa6$var$_interopRequireDefault((parcelRequire("2qERs")));

var $79a909e245f69aa6$var$_appAccess = $79a909e245f69aa6$var$_interopRequireDefault((parcelRequire("cHJgY")));
function $79a909e245f69aa6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonAddedIcon.
 * This component is PersonAddedIcon, with `UNSAFE_fallbackIcon` set to "AppAccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $79a909e245f69aa6$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $79a909e245f69aa6$var$_react.default.createElement($79a909e245f69aa6$var$_personAdded.default, Object.assign({
        LEGACY_fallbackIcon: $79a909e245f69aa6$var$_appAccess.default
    }, props));
$79a909e245f69aa6$var$PersonAddedIcon.Name = 'PersonAddedIconMigration';
var $79a909e245f69aa6$var$_default = module.exports.default = $79a909e245f69aa6$var$PersonAddedIcon;

});
parcelRegister("2qERs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2b2be59784c9b52b8b3b5b23f53d5b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c4db4a83ea38937$var$_react = $1c4db4a83ea38937$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1c4db4a83ea38937$var$_baseNew = $1c4db4a83ea38937$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $1c4db4a83ea38937$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1c4db4a83ea38937$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $1c4db4a83ea38937$var$_react.default.createElement($1c4db4a83ea38937$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m14.877 2.03-4 4a.75.75 0 0 1-1.051.01L8.98 8.262l1.04-1.08 1.316 1.267 3.48-3.48zM3.75 10.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.52a3.75 3.75 0 0 1 3.75 3.75V15h-1.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$1c4db4a83ea38937$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $1c4db4a83ea38937$var$_default = module.exports.default = $1c4db4a83ea38937$var$PersonAddedIcon;

});

parcelRegister("cHJgY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93fc9e6d6989cfe7$var$_react = $93fc9e6d6989cfe7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $93fc9e6d6989cfe7$var$_personAdded = $93fc9e6d6989cfe7$var$_interopRequireDefault((parcelRequire("2qERs")));
function $93fc9e6d6989cfe7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93fc9e6d6989cfe7$var$AppAccessIcon = (props)=>/*#__PURE__*/ $93fc9e6d6989cfe7$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.682 12H5.01A2.006 2.006 0 0 0 3 14v4.446c0 2.162 4.836 2.951 8.368 2.368A5.98 5.98 0 0 1 10 17a6 6 0 0 1 2.682-5"/><circle cx="9" cy="7" r="4" fill="currentcolor"/><circle cx="16" cy="17" r="5" fill="currentcolor"/><path fill="inherit" d="M14.674 19.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $93fc9e6d6989cfe7$var$_personAdded.default
    }));
$93fc9e6d6989cfe7$var$AppAccessIcon.displayName = 'AppAccessIcon';
var $93fc9e6d6989cfe7$var$_default = module.exports.default = $93fc9e6d6989cfe7$var$AppAccessIcon;

});


parcelRegister("izhQH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c11af61bf1d5e1e60e3ad123179be896>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d84957568875cbc6$var$_react = $d84957568875cbc6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d84957568875cbc6$var$_personAvatar = $d84957568875cbc6$var$_interopRequireDefault((parcelRequire("gNUuP")));

var $d84957568875cbc6$var$_personCircle = $d84957568875cbc6$var$_interopRequireDefault((parcelRequire("e5XXZ")));
function $d84957568875cbc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonAvatarIcon.
 * This component is PersonAvatarIcon, with `UNSAFE_fallbackIcon` set to "PersonCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d84957568875cbc6$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $d84957568875cbc6$var$_react.default.createElement($d84957568875cbc6$var$_personAvatar.default, Object.assign({
        LEGACY_fallbackIcon: $d84957568875cbc6$var$_personCircle.default
    }, props));
$d84957568875cbc6$var$PersonAvatarIcon.Name = 'PersonAvatarIconMigration';
var $d84957568875cbc6$var$_default = module.exports.default = $d84957568875cbc6$var$PersonAvatarIcon;

});
parcelRegister("e5XXZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4300c6e0795dc3d$var$_react = $a4300c6e0795dc3d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $a4300c6e0795dc3d$var$_personAvatar = $a4300c6e0795dc3d$var$_interopRequireDefault((parcelRequire("gNUuP")));
function $a4300c6e0795dc3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a4300c6e0795dc3d$var$PersonCircleIcon = (props)=>/*#__PURE__*/ $a4300c6e0795dc3d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M14.5 13.009h-5c-1.38 0-2.5 1.12-2.5 2.503v3.978a8.95 8.95 0 0 0 5 1.519 8.95 8.95 0 0 0 5-1.519v-3.978a2.5 2.5 0 0 0-2.5-2.503"/><circle cx="12" cy="9" r="3"/><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></g></svg>`
    }, props, {
        newIcon: $a4300c6e0795dc3d$var$_personAvatar.default
    }));
$a4300c6e0795dc3d$var$PersonCircleIcon.displayName = 'PersonCircleIcon';
var $a4300c6e0795dc3d$var$_default = module.exports.default = $a4300c6e0795dc3d$var$PersonCircleIcon;

});


parcelRegister("d0DRA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0984af37204bd04db11ac437e644ac56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $978a3279ac45ca87$var$_react = $978a3279ac45ca87$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $978a3279ac45ca87$var$_plusSquare = $978a3279ac45ca87$var$_interopRequireDefault((parcelRequire("cf3Mk")));

var $978a3279ac45ca87$var$_issueRaise = $978a3279ac45ca87$var$_interopRequireDefault((parcelRequire("4idZl")));
function $978a3279ac45ca87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PlusSquareIcon.
 * This component is PlusSquareIcon, with `UNSAFE_fallbackIcon` set to "IssueRaiseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: 'New feature' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $978a3279ac45ca87$var$PlusSquareIcon = (props)=>/*#__PURE__*/ $978a3279ac45ca87$var$_react.default.createElement($978a3279ac45ca87$var$_plusSquare.default, Object.assign({
        LEGACY_fallbackIcon: $978a3279ac45ca87$var$_issueRaise.default
    }, props));
$978a3279ac45ca87$var$PlusSquareIcon.Name = 'PlusSquareIconMigration';
var $978a3279ac45ca87$var$_default = module.exports.default = $978a3279ac45ca87$var$PlusSquareIcon;

});
parcelRegister("cf3Mk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9e4860a70161d3c7420634011031e12a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e99d116f14c1b08$var$_react = $8e99d116f14c1b08$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8e99d116f14c1b08$var$_baseNew = $8e99d116f14c1b08$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8e99d116f14c1b08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlusSquare".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: 'New feature' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e99d116f14c1b08$var$PlusSquareIcon = (props)=>/*#__PURE__*/ $8e99d116f14c1b08$var$_react.default.createElement($8e99d116f14c1b08$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM8.75 4v3.25H12v1.5H8.75V12h-1.5V8.75H4v-1.5h3.25V4zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$8e99d116f14c1b08$var$PlusSquareIcon.displayName = 'PlusSquareIcon';
var $8e99d116f14c1b08$var$_default = module.exports.default = $8e99d116f14c1b08$var$PlusSquareIcon;

});

parcelRegister("4idZl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3203b1aaf7665ee0$var$_react = $3203b1aaf7665ee0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $3203b1aaf7665ee0$var$_plusSquare = $3203b1aaf7665ee0$var$_interopRequireDefault((parcelRequire("cf3Mk")));
function $3203b1aaf7665ee0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3203b1aaf7665ee0$var$IssueRaiseIcon = (props)=>/*#__PURE__*/ $3203b1aaf7665ee0$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="11" y="9" rx="1"/><path fill-rule="nonzero" d="M5 15.991c0 .007 14.005.009 14.005.009C18.999 16 19 8.009 19 8.009 19 8.002 4.995 8 4.995 8 5.001 8 5 15.991 5 15.991M3 8.01C3 6.899 3.893 6 4.995 6h14.01C20.107 6 21 6.902 21 8.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 15.991z"/><rect width="6" height="2" x="9" y="11" rx="1"/></g></svg>`
    }, props, {
        newIcon: $3203b1aaf7665ee0$var$_plusSquare.default
    }));
$3203b1aaf7665ee0$var$IssueRaiseIcon.displayName = 'IssueRaiseIcon';
var $3203b1aaf7665ee0$var$_default = module.exports.default = $3203b1aaf7665ee0$var$IssueRaiseIcon;

});


parcelRegister("jVVB7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0df86e9f58670341f0be02decae626a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e83004e3ba57a5e6$var$_react = $e83004e3ba57a5e6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e83004e3ba57a5e6$var$_pullRequest = $e83004e3ba57a5e6$var$_interopRequireDefault((parcelRequire("MUJuW")));

var $e83004e3ba57a5e6$var$_pullrequests = $e83004e3ba57a5e6$var$_interopRequireDefault((parcelRequire("goMQ6")));
function $e83004e3ba57a5e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PullRequestIcon.
 * This component is PullRequestIcon, with `UNSAFE_fallbackIcon` set to "BitbucketPullrequestsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e83004e3ba57a5e6$var$PullRequestIcon = (props)=>/*#__PURE__*/ $e83004e3ba57a5e6$var$_react.default.createElement($e83004e3ba57a5e6$var$_pullRequest.default, Object.assign({
        LEGACY_fallbackIcon: $e83004e3ba57a5e6$var$_pullrequests.default
    }, props));
$e83004e3ba57a5e6$var$PullRequestIcon.Name = 'PullRequestIconMigration';
var $e83004e3ba57a5e6$var$_default = module.exports.default = $e83004e3ba57a5e6$var$PullRequestIcon;

});
parcelRegister("MUJuW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a083285ccf5836110a489694f045affe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09307dc51f4f46f2$var$_react = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $09307dc51f4f46f2$var$_baseNew = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $09307dc51f4f46f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09307dc51f4f46f2$var$PullRequestIcon = (props)=>/*#__PURE__*/ $09307dc51f4f46f2$var$_react.default.createElement($09307dc51f4f46f2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$09307dc51f4f46f2$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $09307dc51f4f46f2$var$_default = module.exports.default = $09307dc51f4f46f2$var$PullRequestIcon;

});

parcelRegister("goMQ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf04c5bca4302271$var$_react = $bf04c5bca4302271$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $bf04c5bca4302271$var$_pullRequest = $bf04c5bca4302271$var$_interopRequireDefault((parcelRequire("MUJuW")));
function $bf04c5bca4302271$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bf04c5bca4302271$var$BitbucketPullrequestsIcon = (props)=>/*#__PURE__*/ $bf04c5bca4302271$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2q.3 0 .6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8M17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1M7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3m0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1"/></svg>`
    }, props, {
        newIcon: $bf04c5bca4302271$var$_pullRequest.default
    }));
$bf04c5bca4302271$var$BitbucketPullrequestsIcon.displayName = 'BitbucketPullrequestsIcon';
var $bf04c5bca4302271$var$_default = module.exports.default = $bf04c5bca4302271$var$BitbucketPullrequestsIcon;

});


parcelRegister("dTYnh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8b6bac237a0c461904e6a964e56f26f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1ef3e8971d3de67$var$_react = $a1ef3e8971d3de67$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a1ef3e8971d3de67$var$_quotationMark = $a1ef3e8971d3de67$var$_interopRequireDefault((parcelRequire("amerd")));

var $a1ef3e8971d3de67$var$_quote = $a1ef3e8971d3de67$var$_interopRequireDefault((parcelRequire("8KCrB")));
function $a1ef3e8971d3de67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuotationMarkIcon.
 * This component is QuotationMarkIcon, with `UNSAFE_fallbackIcon` set to "QuoteIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1ef3e8971d3de67$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $a1ef3e8971d3de67$var$_react.default.createElement($a1ef3e8971d3de67$var$_quotationMark.default, Object.assign({
        LEGACY_fallbackIcon: $a1ef3e8971d3de67$var$_quote.default
    }, props));
$a1ef3e8971d3de67$var$QuotationMarkIcon.Name = 'QuotationMarkIconMigration';
var $a1ef3e8971d3de67$var$_default = module.exports.default = $a1ef3e8971d3de67$var$QuotationMarkIcon;

});
parcelRegister("amerd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::295e96fa490818737b2d2c8ee4291bb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78a7288f6e3e8955$var$_react = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78a7288f6e3e8955$var$_baseNew = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78a7288f6e3e8955$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78a7288f6e3e8955$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $78a7288f6e3e8955$var$_react.default.createElement($78a7288f6e3e8955$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$78a7288f6e3e8955$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $78a7288f6e3e8955$var$_default = module.exports.default = $78a7288f6e3e8955$var$QuotationMarkIcon;

});

parcelRegister("8KCrB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65f070d23fa99443$var$_react = $65f070d23fa99443$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $65f070d23fa99443$var$_quotationMark = $65f070d23fa99443$var$_interopRequireDefault((parcelRequire("amerd")));
function $65f070d23fa99443$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $65f070d23fa99443$var$QuoteIcon = (props)=>/*#__PURE__*/ $65f070d23fa99443$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.051 6c-1.571 0-2.847 1.312-2.847 2.93 0 1.617 1.276 2.93 2.847 2.93 2.699 0 1.135 5.088-2.269 5.618a.68.68 0 0 0-.578.671c0 .416.372.745.784.682 6.187-.938 8.387-12.83 2.063-12.83M7.848 6C6.275 6 5 7.311 5 8.93c0 1.616 1.275 2.928 2.848 2.928 2.698 0 1.134 5.09-2.27 5.62a.68.68 0 0 0-.578.67c0 .416.372.745.783.682C11.972 17.892 14.172 6 7.848 6"/></svg>`
    }, props, {
        newIcon: $65f070d23fa99443$var$_quotationMark.default
    }));
$65f070d23fa99443$var$QuoteIcon.displayName = 'QuoteIcon';
var $65f070d23fa99443$var$_default = module.exports.default = $65f070d23fa99443$var$QuoteIcon;

});


parcelRegister("hIRsw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::305b05d245740b98a659dd24d0c99f12>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce700390cb4d4326$var$_react = $ce700390cb4d4326$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce700390cb4d4326$var$_sprint = $ce700390cb4d4326$var$_interopRequireDefault((parcelRequire("7Dz47")));

var $ce700390cb4d4326$var$_sprint2 = $ce700390cb4d4326$var$_interopRequireDefault((parcelRequire("1L428")));
function $ce700390cb4d4326$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SprintIcon.
 * This component is SprintIcon, with `UNSAFE_fallbackIcon` set to "SprintIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce700390cb4d4326$var$SprintIcon = (props)=>/*#__PURE__*/ $ce700390cb4d4326$var$_react.default.createElement($ce700390cb4d4326$var$_sprint.default, Object.assign({
        LEGACY_fallbackIcon: $ce700390cb4d4326$var$_sprint2.default
    }, props));
$ce700390cb4d4326$var$SprintIcon.Name = 'SprintIconMigration';
var $ce700390cb4d4326$var$_default = module.exports.default = $ce700390cb4d4326$var$SprintIcon;

});
parcelRegister("7Dz47", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3028194b67909de4178ae7b995e8e7b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58f760330ff3639b$var$_react = $58f760330ff3639b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $58f760330ff3639b$var$_baseNew = $58f760330ff3639b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $58f760330ff3639b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $58f760330ff3639b$var$SprintIcon = (props)=>/*#__PURE__*/ $58f760330ff3639b$var$_react.default.createElement($58f760330ff3639b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A4.75 4.75 0 0 0 8 11h5.44l-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H0V11h3.938A6.25 6.25 0 1 1 14.25 6.25h-1.5A4.75 4.75 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$58f760330ff3639b$var$SprintIcon.displayName = 'SprintIcon';
var $58f760330ff3639b$var$_default = module.exports.default = $58f760330ff3639b$var$SprintIcon;

});

parcelRegister("1L428", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $147d4f29a0b2b7cd$var$_react = $147d4f29a0b2b7cd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $147d4f29a0b2b7cd$var$_sprint = $147d4f29a0b2b7cd$var$_interopRequireDefault((parcelRequire("7Dz47")));
function $147d4f29a0b2b7cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $147d4f29a0b2b7cd$var$SprintIcon = (props)=>/*#__PURE__*/ $147d4f29a0b2b7cd$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
    }, props, {
        newIcon: $147d4f29a0b2b7cd$var$_sprint.default
    }));
$147d4f29a0b2b7cd$var$SprintIcon.displayName = 'SprintIcon';
var $147d4f29a0b2b7cd$var$_default = module.exports.default = $147d4f29a0b2b7cd$var$SprintIcon;

});


parcelRegister("3Y0kU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6235186728ffd6d81eb5818a45d0cd77>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e373c7db9d1b7c4$var$_react = $2e373c7db9d1b7c4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2e373c7db9d1b7c4$var$_task = $2e373c7db9d1b7c4$var$_interopRequireDefault((parcelRequire("bwM92")));

var $2e373c7db9d1b7c4$var$_task2 = $2e373c7db9d1b7c4$var$_interopRequireDefault((parcelRequire("jgKZU")));
function $2e373c7db9d1b7c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TaskIcon.
 * This component is TaskIcon, with `UNSAFE_fallbackIcon` set to "TaskIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e373c7db9d1b7c4$var$TaskIcon = (props)=>/*#__PURE__*/ $2e373c7db9d1b7c4$var$_react.default.createElement($2e373c7db9d1b7c4$var$_task.default, Object.assign({
        LEGACY_fallbackIcon: $2e373c7db9d1b7c4$var$_task2.default
    }, props));
$2e373c7db9d1b7c4$var$TaskIcon.Name = 'TaskIconMigration';
var $2e373c7db9d1b7c4$var$_default = module.exports.default = $2e373c7db9d1b7c4$var$TaskIcon;

});
parcelRegister("bwM92", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1fa22b134d342ddb8339c9dc89d7524>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8648076de2cded56$var$_react = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8648076de2cded56$var$_baseNew = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8648076de2cded56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8648076de2cded56$var$TaskIcon = (props)=>/*#__PURE__*/ $8648076de2cded56$var$_react.default.createElement($8648076de2cded56$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$8648076de2cded56$var$TaskIcon.displayName = 'TaskIcon';
var $8648076de2cded56$var$_default = module.exports.default = $8648076de2cded56$var$TaskIcon;

});

parcelRegister("jgKZU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e073f7ae4e46a909$var$_react = $e073f7ae4e46a909$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $e073f7ae4e46a909$var$_task = $e073f7ae4e46a909$var$_interopRequireDefault((parcelRequire("bwM92")));
function $e073f7ae4e46a909$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e073f7ae4e46a909$var$TaskIcon = (props)=>/*#__PURE__*/ $e073f7ae4e46a909$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.994.994 0 0 1 3 20.007zM5 5v14h14V5z"/><path fill-rule="nonzero" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $e073f7ae4e46a909$var$_task.default
    }));
$e073f7ae4e46a909$var$TaskIcon.displayName = 'TaskIcon';
var $e073f7ae4e46a909$var$_default = module.exports.default = $e073f7ae4e46a909$var$TaskIcon;

});


parcelRegister("5Etd3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dd889e80424019b64b57f46f523f0af4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41d75898ac326732$var$_react = $41d75898ac326732$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $41d75898ac326732$var$_workItem = $41d75898ac326732$var$_interopRequireDefault((parcelRequire("c59mr")));

var $41d75898ac326732$var$_issue = $41d75898ac326732$var$_interopRequireDefault((parcelRequire("7eZoy")));
function $41d75898ac326732$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WorkItemIcon.
 * This component is WorkItemIcon, with `UNSAFE_fallbackIcon` set to "IssueIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $41d75898ac326732$var$WorkItemIcon = (props)=>/*#__PURE__*/ $41d75898ac326732$var$_react.default.createElement($41d75898ac326732$var$_workItem.default, Object.assign({
        LEGACY_fallbackIcon: $41d75898ac326732$var$_issue.default
    }, props));
$41d75898ac326732$var$WorkItemIcon.Name = 'WorkItemIconMigration';
var $41d75898ac326732$var$_default = module.exports.default = $41d75898ac326732$var$WorkItemIcon;

});
parcelRegister("c59mr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16b1a013266ea85d8875a6b5e1d2412a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cbd368cf037dfb6$var$_react = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8cbd368cf037dfb6$var$_baseNew = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8cbd368cf037dfb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cbd368cf037dfb6$var$WorkItemIcon = (props)=>/*#__PURE__*/ $8cbd368cf037dfb6$var$_react.default.createElement($8cbd368cf037dfb6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$8cbd368cf037dfb6$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $8cbd368cf037dfb6$var$_default = module.exports.default = $8cbd368cf037dfb6$var$WorkItemIcon;

});

parcelRegister("7eZoy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $545976f7ed82b2d6$var$_react = $545976f7ed82b2d6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $545976f7ed82b2d6$var$_workItem = $545976f7ed82b2d6$var$_interopRequireDefault((parcelRequire("c59mr")));
function $545976f7ed82b2d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $545976f7ed82b2d6$var$IssueIcon = (props)=>/*#__PURE__*/ $545976f7ed82b2d6$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 15.991c0 .007 14.005.009 14.005.009C18.999 16 19 8.009 19 8.009 19 8.002 4.995 8 4.995 8 5.001 8 5 15.991 5 15.991M3 8.01C3 6.899 3.893 6 4.995 6h14.01C20.107 6 21 6.902 21 8.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 15.991z"/><path d="M10.674 14.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $545976f7ed82b2d6$var$_workItem.default
    }));
$545976f7ed82b2d6$var$IssueIcon.displayName = 'IssueIcon';
var $545976f7ed82b2d6$var$_default = module.exports.default = $545976f7ed82b2d6$var$IssueIcon;

});


parcelRegister("8z7BJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d00cfc241e43a907$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $58yRG = parcelRequire("58yRG");
const $d00cfc241e43a907$var$AwsIconGlyph = (props)=>{
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const AwsTextColor = colorMode === 'dark' ? '#FFFFFF' : '#252f3e';
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 333334 199332",
        shapeRendering: "geometricPrecision",
        textRendering: "geometricPrecision",
        imageRendering: "optimizeQuality",
        fillRule: "evenodd",
        clipRule: "evenodd",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M93937 72393c0 4102 443 7428 1219 9867 887 2439 1996 5100 3548 7982 554 887 776 1774 776 2550 0 1109-665 2217-2106 3326l-6985 4656c-998 665-1995 998-2882 998-1109 0-2217-554-3326-1552-1552-1663-2882-3437-3991-5211-1109-1885-2217-3991-3437-6541-8648 10200-19512 15299-32594 15299-9312 0-16740-2661-22172-7982-5432-5322-8204-12417-8204-21286 0-9424 3326-17073 10089-22838s15743-8647 27161-8647c3769 0 7650 332 11752 887 4102 554 8315 1441 12749 2439v-8093c0-8426-1774-14301-5211-17738-3548-3437-9534-5100-18071-5100-3880 0-7871 443-11973 1441s-8093 2217-11973 3769c-1774 776-3104 1219-3880 1441s-1330 332-1774 332c-1552 0-2328-1109-2328-3437v-5432c0-1774 222-3104 776-3880s1552-1552 3104-2328c3880-1996 8537-3659 13969-4989C43606 885 49370 220 55468 220c13193 0 22838 2993 29046 8980 6098 5987 9202 15077 9202 27272v35920h222zM48926 89244c3659 0 7428-665 11419-1995s7539-3769 10532-7095c1774-2106 3104-4435 3770-7095 665-2661 1108-5876 1108-9645v-4656c-3215-776-6652-1441-10199-1885-3548-443-6984-665-10421-665-7428 0-12860 1441-16519 4435-3659 2993-5432 7206-5432 12749 0 5211 1330 9091 4102 11751 2661 2772 6541 4102 11641 4102zm89023 11973c-1996 0-3326-332-4213-1109-887-665-1663-2217-2328-4324l-26053-85697c-665-2217-998-3658-998-4434 0-1774 887-2772 2661-2772h10865c2106 0 3548 333 4324 1109 887 665 1552 2217 2217 4324l18625 73391 17295-73391c554-2217 1219-3659 2106-4324s2439-1109 4435-1109h8869c2106 0 3548 333 4435 1109 887 665 1663 2217 2106 4324l17516 74278 19180-74278c665-2217 1441-3659 2217-4324 887-665 2328-1109 4324-1109h10310c1774 0 2772 887 2772 2772 0 554-111 1109-222 1774s-333 1552-776 2772l-26718 85697c-665 2217-1441 3658-2328 4324-887 665-2328 1109-4213 1109h-9534c-2107 0-3548-333-4435-1109s-1663-2217-2106-4435l-17184-71507-17073 71396c-554 2217-1220 3658-2107 4434s-2439 1109-4434 1109h-9534zm142459 2993c-5765 0-11530-665-17073-1995s-9867-2772-12749-4435c-1774-998-2993-2106-3437-3104-443-998-665-2106-665-3104v-5654c0-2328 887-3437 2550-3437 665 0 1330 111 1995 333s1663 665 2772 1109c3769 1663 7871 2993 12195 3880 4435 887 8758 1330 13193 1330 6984 0 12417-1220 16186-3659s5765-5987 5765-10532c0-3104-998-5654-2993-7760-1996-2107-5765-3991-11197-5765l-16075-4989c-8093-2550-14080-6319-17738-11308-3658-4878-5543-10310-5543-16075 0-4656 998-8758 2993-12306s4656-6652 7982-9091c3326-2550 7095-4434 11530-5765S279190-2 284068-2c2439 0 4989 111 7428 443 2550 333 4878 776 7206 1219 2217 554 4324 1109 6319 1774s3548 1330 4656 1996c1552 887 2661 1774 3326 2771 665 887 998 2107 998 3659v5211c0 2328-887 3548-2550 3548-887 0-2328-444-4213-1331-6319-2882-13415-4324-21286-4324-6319 0-11308 998-14745 3104s-5211 5321-5211 9867c0 3104 1109 5765 3326 7871s6319 4213 12195 6097l15743 4989c7982 2550 13747 6098 17184 10643s5100 9756 5100 15521c0 4767-998 9091-2882 12860-1996 3770-4656 7095-8093 9756-3437 2771-7539 4767-12306 6208-4989 1552-10199 2328-15854 2328z",
                        fill: AwsTextColor
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: "#FF9900",
                        d: "M301362 158091c-36474 26940-89467 41241-135031 41241-63858 0-121395-23614-164854-62859-3437-3104-332-7317 3770-4878 47006 27272 104988 43791 164964 43791 40465 0 84921-8426 125830-25721 6097-2772 11308 3991 5321 8426z"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: "#FF9900",
                        d: "M316550 140796c-4656-5987-30820-2883-42682-1441-3548 443-4102-2661-887-4989 20842-14634 55099-10421 59090-5543 3991 4989-1109 39246-20620 55653-2993 2550-5876 1220-4545-2106 4435-10976 14301-35698 9645-41574z"
                    })
                ]
            })
        })
    });
};
/**
 * __AwsIcon__
 */ const $d00cfc241e43a907$var$AwsIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $d00cfc241e43a907$var$AwsIconGlyph
    });
var $d00cfc241e43a907$export$2e2bcd8739ae039 = $d00cfc241e43a907$var$AwsIcon;

});

parcelRegister("29s68", function(module, exports) {

$parcel$export(module.exports, "default", () => $3132f657da9d1bfe$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $3132f657da9d1bfe$var$MsTeamsIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17 6C17 5.46957 17.2107 4.96086 17.5858 4.58579C17.9609 4.21071 18.4696 4 19 4C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6C21 6.53043 20.7893 7.03914 20.4142 7.41421C20.0391 7.78929 19.5304 8 19 8C18.4696 8 17.9609 7.78929 17.5858 7.41421C17.2107 7.03914 17 6.53043 17 6ZM19 5C18.7348 5 18.4804 5.10536 18.2929 5.29289C18.1054 5.48043 18 5.73478 18 6C18 6.26522 18.1054 6.51957 18.2929 6.70711C18.4804 6.89464 18.7348 7 19 7C19.2652 7 19.5196 6.89464 19.7071 6.70711C19.8946 6.51957 20 6.26522 20 6C20 5.73478 19.8946 5.48043 19.7071 5.29289C19.5196 5.10536 19.2652 5 19 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 7.82843C12.3182 7.94094 12.6561 8 13 8C13.7956 8 14.5587 7.68393 15.1213 7.12132C15.6839 6.55871 16 5.79565 16 5C16 4.20435 15.6839 3.44129 15.1213 2.87868C14.5587 2.31607 13.7956 2 13 2C12.2044 2 11.4413 2.31607 10.8787 2.87868C10.3161 3.44129 10 4.20435 10 5C10 5.34394 10.0591 5.6818 10.1716 6H2.833C2.373 6 2 6.373 2 6.833V15.167C2 15.3879 2.08776 15.5998 2.24398 15.756C2.4002 15.9122 2.61207 16 2.833 16H8C8 17.3261 8.52678 18.5979 9.46447 19.5355C10.4021 20.4732 11.6739 21 13 21C14.3261 21 15.5979 20.4732 16.5355 19.5355C17.0103 19.0608 17.3797 18.5003 17.6288 17.8906C17.9809 17.981 18.3463 18.0165 18.7119 17.9943C19.3013 17.9586 19.8721 17.7743 20.3711 17.4586C20.8702 17.1429 21.2812 16.706 21.566 16.1888C21.8508 15.6715 22.0001 15.0905 22 14.5V10C22 9.73478 21.8946 9.48043 21.7071 9.29289C21.5196 9.10536 21.2652 9 21 9H12V7.82843ZM13 3C12.4696 3 11.9609 3.21071 11.5858 3.58579C11.2107 3.96086 11 4.46957 11 5C11 5.35625 11.095 5.70269 11.2711 6.00543C11.3011 6.0092 11.3307 6.01489 11.3596 6.0224C11.6937 6.10151 11.95 6.38183 11.9935 6.72827C12.2965 6.90473 12.6433 7 13 7C13.5304 7 14.0391 6.78929 14.4142 6.41421C14.7893 6.03914 15 5.53043 15 5C15 4.46957 14.7893 3.96086 14.4142 3.58579C14.0391 3.21071 13.5304 3 13 3ZM18 10V16C18 16.3144 17.9704 16.6257 17.9127 16.9302C18.0184 16.9558 18.1259 16.9745 18.2347 16.9861C18.6826 17.034 19.1351 16.96 19.5443 16.7719C19.9536 16.5838 20.3044 16.2886 20.5598 15.9176C20.8151 15.5466 20.9655 15.1134 20.995 14.664L21 14.5V10H18ZM17 10H12V15.167C12 15.627 11.627 16 11.167 16H9C9 17.0609 9.42143 18.0783 10.1716 18.8284C10.9217 19.5786 11.9391 20 13 20C14.0609 20 15.0783 19.5786 15.8284 18.8284C16.5786 18.0783 17 17.0609 17 16V10ZM5 8H9V8.975H7.481V14H6.512V8.975H5V8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __MsTeamsIcon__
 */ const $3132f657da9d1bfe$var$MsTeamsIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $3132f657da9d1bfe$var$MsTeamsIconGlyph
    });
var $3132f657da9d1bfe$export$2e2bcd8739ae039 = $3132f657da9d1bfe$var$MsTeamsIcon;

});

parcelRegister("gbdsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d71ecc712029f81e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $d71ecc712029f81e$var$SlackIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m6.8322 14.352c0 1.0306-0.84194 1.8726-1.8726 1.8726-1.0306 0-1.8726-0.842-1.8726-1.8726 0-1.0307 0.84193-1.8726 1.8726-1.8726h1.8726v1.8726z",
                fill: "#E01E5A"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m7.7758 14.352c0-1.0307 0.84193-1.8726 1.8726-1.8726 1.0307 0 1.8726 0.8419 1.8726 1.8726v4.6887c0 1.0306-0.8419 1.8726-1.8726 1.8726-1.0306 0-1.8726-0.842-1.8726-1.8726v-4.6887z",
                fill: "#E01E5A"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m9.6483 6.8323c-1.0306 0-1.8726-0.84194-1.8726-1.8726 0-1.0306 0.84193-1.8726 1.8726-1.8726 1.0307 0 1.8726 0.84193 1.8726 1.8726v1.8726h-1.8726z",
                fill: "#36C5F0"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m9.6483 7.7758c1.0307 0 1.8726 0.84193 1.8726 1.8726 0 1.0306-0.8419 1.8726-1.8726 1.8726h-4.6887c-1.0306 0-1.8726-0.842-1.8726-1.8726 0-1.0306 0.84193-1.8726 1.8726-1.8726h4.6887z",
                fill: "#36C5F0"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m17.168 9.6484c0-1.0306 0.842-1.8726 1.8726-1.8726 1.0307 0 1.8726 0.84193 1.8726 1.8726 0 1.0306-0.8419 1.8726-1.8726 1.8726h-1.8726v-1.8726z",
                fill: "#2EB67D"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m16.224 9.6484c0 1.0306-0.842 1.8726-1.8726 1.8726-1.0307 0-1.8726-0.842-1.8726-1.8726v-4.6887c0-1.0306 0.8419-1.8726 1.8726-1.8726 1.0306 0 1.8726 0.84193 1.8726 1.8726v4.6887z",
                fill: "#2EB67D"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m14.352 17.168c1.0306 0 1.8726 0.842 1.8726 1.8726 0 1.0307-0.842 1.8726-1.8726 1.8726-1.0307 0-1.8726-0.8419-1.8726-1.8726v-1.8726h1.8726z",
                fill: "#ECB22E"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m14.352 16.224c-1.0307 0-1.8726-0.842-1.8726-1.8726 0-1.0307 0.8419-1.8726 1.8726-1.8726h4.6887c1.0306 0 1.8726 0.8419 1.8726 1.8726 0 1.0306-0.842 1.8726-1.8726 1.8726h-4.6887z",
                fill: "#ECB22E"
            })
        ]
    });
/**
 * __SlackIcon__
 */ const $d71ecc712029f81e$var$SlackIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $d71ecc712029f81e$var$SlackIconGlyph
    });
var $d71ecc712029f81e$export$2e2bcd8739ae039 = $d71ecc712029f81e$var$SlackIcon;

});

parcelRegister("2AbqO", function(module, exports) {

$parcel$export(module.exports, "AnnotateIcon", () => $27d4ad8d468c2318$export$d54f03f1bc4d91db);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8kvot = parcelRequire("8kvot");

var $8CnfC = parcelRequire("8CnfC");
const $27d4ad8d468c2318$export$d54f03f1bc4d91db = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8kvot))), {
        ...props,
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8CnfC)))
    });

});
parcelRegister("8kvot", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b782fa91208a5ce454d88e26c102b6d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61088b213bd78d95$var$_react = $61088b213bd78d95$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $61088b213bd78d95$var$_baseNew = $61088b213bd78d95$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $61088b213bd78d95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: 'Design task' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61088b213bd78d95$var$PenIcon = (props)=>/*#__PURE__*/ $61088b213bd78d95$var$_react.default.createElement($61088b213bd78d95$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.72.72a.75.75 0 0 1 .73-.194l9.167 2.522a2 2 0 0 1 1.461 1.739l.294 3.083a2 2 0 0 1 2.042.483L15.78 9.72a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0l-1.366-1.366a2 2 0 0 1-.484-2.042l-3.083-.294a2 2 0 0 1-1.74-1.46L.528 1.448A.75.75 0 0 1 .72.72m12.634 8.694a.5.5 0 0 0-.707 0l-3.233 3.232a.5.5 0 0 0 0 .707l.836.836 3.94-3.94zM6.636 5.575a1.624 1.624 0 0 1 2.114 1.55 1.625 1.625 0 1 1-3.175-.49l-2.85-2.85 1.77 6.435a.5.5 0 0 0 .435.365l4.04.384 1.999-2-.384-4.04a.5.5 0 0 0-.365-.435l-6.435-1.77z" clip-rule="evenodd"/>`
    }, props));
$61088b213bd78d95$var$PenIcon.displayName = 'PenIcon';
var $61088b213bd78d95$var$_default = module.exports.default = $61088b213bd78d95$var$PenIcon;

});

parcelRegister("8CnfC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6463e87fcf2f83f9$var$_react = $6463e87fcf2f83f9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $6463e87fcf2f83f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6463e87fcf2f83f9$var$MediaServicesAnnotateIcon = (props)=>/*#__PURE__*/ $6463e87fcf2f83f9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M9.864 10.736c.77-.746 1.893-.536 2.72.265.826.8 1.043 1.888.273 2.634-1.816 1.76-5.482 2.002-4.765 1.207 1.587-1.76.578-2.949 1.772-4.106M19.968 4.03c.402.378-3.1 4.732-4.427 5.98-.659.62-1.012.826-1.276 1.016-.115.082-.15-.027-.177-.076a3.7 3.7 0 0 0-.63-.801c-.236-.222-.607-.445-.867-.572-.053-.025-.169-.058-.08-.166.201-.249.421-.58 1.08-1.2 1.327-1.247 5.974-4.56 6.377-4.181M18.38 19.946a1 1 0 0 1-.332.054.95.95 0 0 1-.913-.628c-.343-.957-1.14-1.642-2.257-1.933-2.182-.568-3.22-.264-5.053.995l-.16.11a9 9 0 0 1-1.049.644c-1.477.755-2.632.825-3.482.419-.586-.28-.989-.794-1.1-1.407-.254-1.403.93-2.647 2.602-3.156a.906.906 0 0 1 1.155.601.92.92 0 0 1-.62 1.186c-.33.1-.717.311-.978.533-.195.165-.33.355-.306.434.042.138.088.185.16.214.155.063.445.029.818-.096q.247-.083.524-.21c.196-.088.348-.165.58-.287.076-.04.177-.11.445-.303 1.09-.784 1.802-1.198 2.845-1.52 1.562-.482 3.18-.39 4.802.272 1.399.57 2.399 1.589 2.883 2.94.174.483-.07.97-.564 1.138"/></svg>`
    }, props));
$6463e87fcf2f83f9$var$MediaServicesAnnotateIcon.displayName = 'MediaServicesAnnotateIcon';
var $6463e87fcf2f83f9$var$_default = module.exports.default = $6463e87fcf2f83f9$var$MediaServicesAnnotateIcon;

});


parcelRegister("Ss5iS", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $0eb5915ca6f76b86$export$5fc1066e677788d4);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kLpHK = parcelRequire("kLpHK");
// Because this is a logo it should be presented on white and design tokens are not used
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $0eb5915ca6f76b86$var$BitbucketGlyph = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                width: "32",
                height: "32",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M5.50533 6.18945C5.07406 6.18945 4.71467 6.57176 4.78655 6.98882L7.84135 24.8877C7.91323 25.3395 8.30856 25.6871 8.8117 25.6871H23.4388C23.7982 25.6871 24.0857 25.4438 24.1576 25.0962L27.2124 6.98882C27.2843 6.57176 26.9609 6.18945 26.4936 6.18945H5.50533ZM18.3715 19.1184H13.6994L12.4415 12.7234H19.5215L18.3715 19.1184Z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M26.2413 12.7236H19.4848L18.3707 19.1186H13.6987L8.16406 25.444C8.16406 25.444 8.41563 25.6873 8.81096 25.6873H23.4381C23.7975 25.6873 24.085 25.444 24.1569 25.0965L26.2413 12.7236Z",
                fill: "url(#paint0_linear_13_34916)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                    id: "paint0_linear_13_34916",
                    x1: "27.7908",
                    y1: "14.5201",
                    x2: "16.9275",
                    y2: "23.2887",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                            offset: "0.176",
                            stopColor: "#0052CC"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                            offset: "1",
                            stopColor: "#2684FF"
                        })
                    ]
                })
            })
        ]
    });
const $0eb5915ca6f76b86$export$5fc1066e677788d4 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kLpHK.CustomIcon), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($0eb5915ca6f76b86$var$BitbucketGlyph, {})
    });

});
parcelRegister("kLpHK", function(module, exports) {

$parcel$export(module.exports, "CustomIcon", () => $7a23bdd1e456d684$export$d69e54ca8782c876);
/* custom-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cdbP5 = parcelRequire("cdbP5");

var $anoAR = parcelRequire("anoAR");

var $eGOwo = parcelRequire("eGOwo");
const $7a23bdd1e456d684$var$sizeStyles = {
    small: "_4t3i7vkz _1bsb7vkz",
    medium: "_4t3i1tcg _1bsb1tcg",
    large: "_4t3izwfg _1bsbzwfg",
    xlarge: "_4t3ickbl _1bsbckbl"
};
const $7a23bdd1e456d684$var$getSize = ({ size: size })=>size ? `height: ${(0, $anoAR.sizes)[size]}; width: ${(0, $anoAR.sizes)[size]};` : null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $7a23bdd1e456d684$export$be58b4326e23250f = /*#__PURE__*/ (0, $cdbP5.default).span.withConfig({
    componentId: "sc-1y0r352-0"
})`${$7a23bdd1e456d684$var$getSize};color:${(p)=>p.primaryColor || 'currentColor'};display:inline-block;fill:${(p)=>p.secondaryColor || "var(--ds-surface, #FFFFFF)"};flex-shrink:0;line-height:1;> svg{${$7a23bdd1e456d684$var$getSize};max-height:100%;max-width:100%;overflow:hidden;pointer-events:none;vertical-align:bottom;}`;
const $7a23bdd1e456d684$var$baseStyles = null;
const $7a23bdd1e456d684$var$CompiledIconWrapper = ({ primaryColor: primaryColor, secondaryColor: secondaryColor, size: size = 'medium', ...props })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            color: primaryColor || 'currentColor',
            fill: secondaryColor || "var(--ds-surface, #FFFFFF)"
        },
        ...props,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _1o9zidpf _13ti15vq _15jv15vq _1azq1osq _1m8i1osq _n0baglyw _11ssyfq0",
            $7a23bdd1e456d684$var$sizeStyles[size]
        ])
    });
};
const $7a23bdd1e456d684$export$d69e54ca8782c876 = (props)=>{
    const isCompiledEnabled = (0, $eGOwo.fg)('ux-3487-replace-styled-component-with-compiled');
    const { glyph: Glyph, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId, label: label } = props;
    const glyphProps = {
        children: Glyph ? /*#__PURE__*/ (0, $gt9Am.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    return isCompiledEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)($7a23bdd1e456d684$var$CompiledIconWrapper, {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "data-testid": testId,
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        ...glyphProps
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($7a23bdd1e456d684$export$be58b4326e23250f, {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        "data-testid": testId,
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        ...glyphProps
    });
};

});


parcelRegister("5u4Qo", function(module, exports) {

$parcel$export(module.exports, "CompareIcon", () => $e9d16efd31cc519b$export$200af911a2197e19);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4aDUk = parcelRequire("4aDUk");

var $eylG6 = parcelRequire("eylG6");
const $e9d16efd31cc519b$export$200af911a2197e19 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4aDUk))), {
        ...props,
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($eylG6)))
    });

});
parcelRegister("4aDUk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30970d602f267700$var$_react = $30970d602f267700$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $30970d602f267700$var$_baseNew = $30970d602f267700$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $30970d602f267700$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30970d602f267700$var$ChangesIcon = (props)=>/*#__PURE__*/ $30970d602f267700$var$_react.default.createElement($30970d602f267700$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$30970d602f267700$var$ChangesIcon.displayName = 'ChangesIcon';
var $30970d602f267700$var$_default = module.exports.default = $30970d602f267700$var$ChangesIcon;

});

parcelRegister("eylG6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02bbf3d8b87af10d$var$_react = $02bbf3d8b87af10d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $02bbf3d8b87af10d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $02bbf3d8b87af10d$var$BitbucketCompareIcon = (props)=>/*#__PURE__*/ $02bbf3d8b87af10d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10.067 16.441c.334.918 1.306 1.6 2.28 1.6h6.167c.55 0 .996-.444.996-1a1 1 0 0 0-.996-1h-6.167c-.133 0-.355-.156-.401-.284l-.816-2.263zM7.94 10.547l-.816-2.263C7.08 8.16 6.851 8 6.722 8H3.998C3.456 8 3 7.552 3 7c0-.556.447-1 .998-1h2.724c.97 0 1.949.686 2.282 1.6z"/><path d="M19.51 7a1 1 0 0 0-.996-1h-6.167c-.976 0-1.95.684-2.283 1.605l-2.94 8.152c-.044.123-.273.284-.402.284H3.998a.996.996 0 0 0-.998 1c0 .552.456 1 .998 1h2.724c.972 0 1.953-.689 2.284-1.606l2.94-8.151c.046-.128.268-.284.401-.284h6.167c.55 0 .996-.444.996-1"/><path d="M17.29 8.29A1 1 0 1 0 18.7 9.7l2-2a1 1 0 0 0 0-1.42l-2-2a1 1 0 0 0-1.41 1.41L18.59 7zm0 10a1 1 0 0 0 1.41 1.41l2-2a1 1 0 0 0 0-1.42l-2-2a1 1 0 0 0-1.41 1.41l1.3 1.31z"/></g></svg>`
    }, props));
$02bbf3d8b87af10d$var$BitbucketCompareIcon.displayName = 'BitbucketCompareIcon';
var $02bbf3d8b87af10d$var$_default = module.exports.default = $02bbf3d8b87af10d$var$BitbucketCompareIcon;

});


parcelRegister("heQWt", function(module, exports) {

$parcel$export(module.exports, "CompassBlueIcon", () => $33b88522a072fd73$export$361fa218d2a465b3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");
const $33b88522a072fd73$export$361fa218d2a465b3 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.CompassIcon), {
        appearance: "brand",
        size: "small"
    });

});

parcelRegister("k3jlZ", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $2c62bcae95a1c716$export$68f3db7f6af48bcb);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kLpHK = parcelRequire("kLpHK");
// Because this is a logo it should be presented on white and design tokens are not used
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $2c62bcae95a1c716$var$ConfluenceGlyph = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        role: "presentation",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                width: "32",
                height: "32",
                transform: "translate(0.75)",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M6.29647 21.0344C6.0813 21.4137 5.79441 21.8275 5.57924 22.1723C5.36407 22.4827 5.47166 22.8965 5.83027 23.1034L10.4922 25.862C10.8508 26.0689 11.2812 25.9654 11.4963 25.6206C11.6757 25.3103 11.9267 24.931 12.1777 24.5172C14.0425 21.5861 15.8714 21.931 19.2424 23.4827L23.8685 25.5861C24.2271 25.7585 24.6574 25.5861 24.8367 25.2413L27.0601 20.4137C27.2036 20.0689 27.0601 19.6551 26.7015 19.5172C25.7333 19.0689 23.7968 18.2068 22.0396 17.3792C15.728 14.4827 10.3847 14.6551 6.29647 21.0344Z",
                fill: "url(#paint0_linear_634_156)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M27.2035 10.1034C27.4187 9.72411 27.7056 9.31032 27.9207 8.96549C28.1359 8.65514 28.0283 8.24135 27.6697 8.03445L23.0078 5.27583C22.6491 5.06894 22.2188 5.17239 22.0036 5.51721C21.8243 5.82756 21.5733 6.20687 21.3223 6.62066C19.4575 9.5517 17.6286 9.20687 14.2576 7.65514L9.66737 5.51721C9.30875 5.3448 8.87842 5.51721 8.69911 5.86204L6.47571 10.6896C6.33227 11.0345 6.47571 11.4482 6.83433 11.5862C7.80258 12.0345 9.73909 12.8965 11.4963 13.7241C17.772 16.6551 23.1153 16.4827 27.2035 10.1034Z",
                fill: "url(#paint1_linear_634_156)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear_634_156",
                        x1: "26.9105",
                        y1: "27.2939",
                        x2: "13.0857",
                        y2: "19.0322",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9182",
                                stopColor: "#2380FB"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint1_linear_634_156",
                        x1: "6.60851",
                        y1: "3.8409",
                        x2: "20.4333",
                        y2: "12.1025",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.9182",
                                stopColor: "#2380FB"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
const $2c62bcae95a1c716$export$68f3db7f6af48bcb = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kLpHK.CustomIcon), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($2c62bcae95a1c716$var$ConfluenceGlyph, {})
    });

});

parcelRegister("7c2el", function(module, exports) {

$parcel$export(module.exports, "FieldValueChangedIcon", () => $35361e85bb9ff4fb$export$e862496562dae5dc);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jEjtf = parcelRequire("jEjtf");
const $35361e85bb9ff4fb$export$e862496562dae5dc = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jEjtf))), {
        color: "currentColor",
        ...props
    });

});
parcelRegister("jEjtf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e57ac867bc3e8deccd83f10400719367>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4e0db369237237f$var$_react = $e4e0db369237237f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e4e0db369237237f$var$_baseNew = $e4e0db369237237f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e4e0db369237237f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldAlert".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Changed field values in Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e4e0db369237237f$var$FieldAlertIcon = (props)=>/*#__PURE__*/ $e4e0db369237237f$var$_react.default.createElement($e4e0db369237237f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 9.5V3h1.5v6.5zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h2.5v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h2.5V6zm12 0h-2.5V4.5H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.5V10H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6m-6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$e4e0db369237237f$var$FieldAlertIcon.displayName = 'FieldAlertIcon';
var $e4e0db369237237f$var$_default = module.exports.default = $e4e0db369237237f$var$FieldAlertIcon;

});


parcelRegister("k3bMw", function(module, exports) {

$parcel$export(module.exports, "ForkIcon", () => $df1092772251d154$export$f86fc55291585d1);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1lB1v = parcelRequire("1lB1v");

var $bis1j = parcelRequire("bis1j");
const $df1092772251d154$export$f86fc55291585d1 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1lB1v))), {
        ...props,
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bis1j)))
    });

});
parcelRegister("1lB1v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::421ff140e88a586c46f862a34a3b2f07>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0fb478a79722a0a6$var$_react = $0fb478a79722a0a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0fb478a79722a0a6$var$_baseNew = $0fb478a79722a0a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0fb478a79722a0a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "IfElse".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for If Else conditions
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0fb478a79722a0a6$var$IfElseIcon = (props)=>/*#__PURE__*/ $0fb478a79722a0a6$var$_react.default.createElement($0fb478a79722a0a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m12.28 1.22 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06L12.44 5H8.75v5.5a.5.5 0 0 0 .5.5h3.19l-1.22-1.22 1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H9.25a2 2 0 0 1-2-2V5H5.372a2.25 2.25 0 1 1 0-1.5h7.067l-1.22-1.22zM3.25 3.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$0fb478a79722a0a6$var$IfElseIcon.displayName = 'IfElseIcon';
var $0fb478a79722a0a6$var$_default = module.exports.default = $0fb478a79722a0a6$var$IfElseIcon;

});

parcelRegister("bis1j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83971c5bcf3fc4bf$var$_react = $83971c5bcf3fc4bf$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $83971c5bcf3fc4bf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $83971c5bcf3fc4bf$var$BitbucketForksIcon = (props)=>/*#__PURE__*/ $83971c5bcf3fc4bf$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 12c0-.552.446-1 .998-1H12v2H3.998A.996.996 0 0 1 3 12"/><path fill-rule="nonzero" d="M12 11V9c0-.55.45-1 1-1h6.4V6H13c-1.65 0-3 1.34-3 3v2zm-2 2v2c0 1.66 1.35 3 3 3h6.4v-2H13c-.55 0-1-.45-1-1v-2z"/><path fill-rule="nonzero" d="M17.29 8.29A1 1 0 1 0 18.7 9.7l2-2a1 1 0 0 0 0-1.42l-2-2a1 1 0 0 0-1.41 1.41L18.59 7zm0 10a1 1 0 0 0 1.41 1.41l2-2a1 1 0 0 0 0-1.42l-2-2a1 1 0 0 0-1.41 1.41l1.3 1.31z"/></g></svg>`
    }, props));
$83971c5bcf3fc4bf$var$BitbucketForksIcon.displayName = 'BitbucketForksIcon';
var $83971c5bcf3fc4bf$var$_default = module.exports.default = $83971c5bcf3fc4bf$var$BitbucketForksIcon;

});


parcelRegister("7wQau", function(module, exports) {

$parcel$export(module.exports, "GitHubIcon", () => $5eb8b4f7c01159c7$export$1e450c42b77127b1);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $58yRG = parcelRequire("58yRG");

var $kLpHK = parcelRequire("kLpHK");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $5eb8b4f7c01159c7$var$GitHubGlyph = ()=>{
    const theme = (0, $58yRG.default)();
    const iconColor = theme === 'dark' ? '#FFFFFF' : '#161514';
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.0001 0C5.3735 0 0 5.50847 0 12.3038C0 17.74 3.43839 22.3519 8.2064 23.9789C8.80613 24.0927 9.02631 23.7119 9.02631 23.387C9.02631 23.0936 9.01518 22.1244 9.01001 21.0963C5.67157 21.8405 4.96712 19.6446 4.96712 19.6446C4.42125 18.2224 3.63472 17.8443 3.63472 17.8443C2.54595 17.0806 3.71679 17.0963 3.71679 17.0963C4.92181 17.1831 5.55632 18.3642 5.55632 18.3642C6.6266 20.2452 8.36358 19.7014 9.04836 19.387C9.15607 18.5918 9.46706 18.049 9.81024 17.7418C7.14485 17.4307 4.34295 16.3757 4.34295 11.6612C4.34295 10.3179 4.81172 9.22032 5.57937 8.35868C5.45477 8.04878 5.04402 6.79737 5.69561 5.10261C5.69561 5.10261 6.7033 4.77193 8.99649 6.3638C9.95371 6.09119 10.9803 5.95447 12.0001 5.94979C13.0199 5.95447 14.0473 6.09119 15.0063 6.3638C17.2967 4.77193 18.303 5.10261 18.303 5.10261C18.9562 6.79737 18.5452 8.04878 18.4206 8.35868C19.1901 9.22032 19.6557 10.3179 19.6557 11.6612C19.6557 16.3869 16.8484 17.4274 14.1762 17.732C14.6067 18.1138 14.9902 18.8626 14.9902 20.0105C14.9902 21.6568 14.9763 22.9817 14.9763 23.387C14.9763 23.7144 15.1923 24.098 15.8006 23.9772C20.566 22.3485 24 17.7381 24 12.3038C24 5.50847 18.6273 0 12.0001 0Z",
            fill: iconColor
        })
    });
};
const $5eb8b4f7c01159c7$export$1e450c42b77127b1 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kLpHK.CustomIcon), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($5eb8b4f7c01159c7$var$GitHubGlyph, {})
    });

});

parcelRegister("1zSeh", function(module, exports) {

$parcel$export(module.exports, "GitLabIcon", () => $de72362fdf8dd442$export$28e008202e511484);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kLpHK = parcelRequire("kLpHK");
// Because this is a logo it should be presented on white and design tokens are not used
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $de72362fdf8dd442$var$GitLabGlyph = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_61_46)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M23.6005 9.14904L23.5668 9.06281L20.3002 0.537693C20.2337 0.370605 20.116 0.228863 19.964 0.132806C19.8119 0.0383803 19.6345 -0.0070981 19.4557 0.00251117C19.2769 0.0121205 19.1054 0.0763547 18.9643 0.186541C18.8248 0.299891 18.7235 0.453483 18.6744 0.626418L16.4688 7.37454H7.53749L5.33186 0.626418C5.28402 0.452541 5.18257 0.298179 5.04194 0.185291C4.90083 0.0751048 4.7293 0.0108705 4.55053 0.00126126C4.37175 -0.00834802 4.19433 0.0371304 4.04222 0.131556C3.89054 0.228001 3.77297 0.369619 3.70606 0.536443L0.433225 9.05782L0.400733 9.14404C-0.069507 10.3727 -0.127551 11.7209 0.235354 12.9855C0.598259 14.25 1.36244 15.3623 2.41267 16.1546L2.42392 16.1633L2.45391 16.1846L7.43002 19.911L9.89184 21.7743L11.3914 22.9065C11.5668 23.0396 11.781 23.1117 12.0012 23.1117C12.2215 23.1117 12.4357 23.0396 12.6111 22.9065L14.1107 21.7743L16.5725 19.911L21.5786 16.1621L21.5911 16.1521C22.639 15.3596 23.4014 14.2485 23.7637 12.9857C24.1261 11.7229 24.0688 10.3765 23.6005 9.14904V9.14904Z",
                        fill: "#E24329"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M23.6005 9.14904L23.5668 9.06282C21.9751 9.38953 20.4752 10.0637 19.1742 11.0373L12 16.462C14.4431 18.3102 16.57 19.916 16.57 19.916L21.5761 16.1671L21.5886 16.1571C22.638 15.3647 23.4015 14.2528 23.7644 12.9889C24.1272 11.725 24.0697 10.3774 23.6005 9.14904Z",
                        fill: "#FC6D26"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M7.43003 19.916L9.89185 21.7793L11.3914 22.9114C11.5668 23.0446 11.781 23.1167 12.0013 23.1167C12.2215 23.1167 12.4357 23.0446 12.6111 22.9114L14.1107 21.7793L16.5725 19.916C16.5725 19.916 14.4431 18.3052 12 16.462C9.55694 18.3052 7.43003 19.916 7.43003 19.916Z",
                        fill: "#FCA326"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M4.8245 11.0373C3.5246 10.0617 2.02503 9.38577 0.433225 9.05782L0.400734 9.14404C-0.0695071 10.3727 -0.127551 11.7209 0.235354 12.9855C0.598259 14.25 1.36244 15.3623 2.41267 16.1546L2.42392 16.1633L2.45391 16.1846L7.43002 19.911C7.43002 19.911 9.55443 18.3052 12 16.457L4.8245 11.0373Z",
                        fill: "#FC6D26"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                    id: "clip0_61_46",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $de72362fdf8dd442$export$28e008202e511484 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kLpHK.CustomIcon), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($de72362fdf8dd442$var$GitLabGlyph, {})
    });

});

parcelRegister("aex0Y", function(module, exports) {

$parcel$export(module.exports, "JiraBlueIcon", () => $19cdb32b6e92db62$export$f99b3723c007eff3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");
const $19cdb32b6e92db62$export$f99b3723c007eff3 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
        appearance: "brand",
        size: "small"
    });

});

parcelRegister("cgjnt", function(module, exports) {

$parcel$export(module.exports, "JSMBlueIcon", () => $e1abb49183817ac7$export$9cc1972b74635b84);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lgMTT = parcelRequire("lgMTT");
const $e1abb49183817ac7$export$9cc1972b74635b84 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraServiceManagementIcon), {
        appearance: "brand",
        size: "small"
    });

});

parcelRegister("9RUC2", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareIcon", () => $6748eca8439cc2ac$export$c3835feba2a66e67);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kLpHK = parcelRequire("kLpHK");
// Because this is a logo it should be presented on white and design tokens are not used
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $6748eca8439cc2ac$var$JiraSoftwareGlyph = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "32",
        fill: "none",
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "presentation",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                width: "32",
                height: "32"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m28.801 14.224-12.819-13.224-8.7725 9.0501-4.0103 4.1742c-0.42967 0.4432-0.42967 1.1451 0 1.5514l8.0206 8.2744 4.7622 4.913 8.7725-9.0502 0.1432-0.1477 3.9029-3.9895c0.4296-0.4432 0.4296-1.1451 0-1.5514zm-12.819 4.9129-4.0103-4.1372 4.0103-4.1372 4.0103 4.1372-4.0103 4.1372z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m15.982 10.863c-2.6139-2.6966-2.6497-7.0924-0.0358-9.8259l-8.7367 9.0501 4.7622 4.913 4.0103-4.1372z",
                fill: "url(#b)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m20.028 14.963-4.046 4.1741c2.6496 2.7335 2.6496 7.1293 0 9.8628l8.8083-9.087-4.7623-4.9499z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "b",
                        x1: "15.28",
                        x2: "9.5046",
                        y1: "6.6685",
                        y2: "12.267",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0052CC",
                                offset: ".176"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#2684FF",
                                offset: "1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "a",
                        x1: "16.762",
                        x2: "22.526",
                        y1: "23.267",
                        y2: "17.68",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0052CC",
                                offset: ".176"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#2684FF",
                                offset: "1"
                            })
                        ]
                    })
                ]
            })
        ]
    });
const $6748eca8439cc2ac$export$c3835feba2a66e67 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kLpHK.CustomIcon), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($6748eca8439cc2ac$var$JiraSoftwareGlyph, {})
    });

});

parcelRegister("i5aes", function(module, exports) {

$parcel$export(module.exports, "LdCreateFeatureFlagIcon", () => $66e3027b098c7559$export$488f295d9b876ed0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $58yRG = parcelRequire("58yRG");

var $kLpHK = parcelRequire("kLpHK");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $66e3027b098c7559$var$LdCreateFeatureFlagGlyph = ()=>{
    const theme = (0, $58yRG.default)();
    const iconColor = theme === 'dark' ? '#FFFFFF' : '#172b4d';
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 216 214.94",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M109.8,214.94a4.87,4.87,0,0,1-4.26-2.66,4.5,4.5,0,0,1,.44-4.82l50.49-69.53L68,174.11a4.61,4.61,0,0,1-1.9.41,4.77,4.77,0,0,1-4.52-3.4,4.57,4.57,0,0,1,2-5.21L141.33,120,4.41,112.13a4.69,4.69,0,0,1,0-9.36l137-7.87L63.61,49a4.56,4.56,0,0,1-1.94-5.2,4.74,4.74,0,0,1,4.51-3.4,4.6,4.6,0,0,1,1.9.4L156.5,77,106,7.48a4.56,4.56,0,0,1-.44-4.83A4.84,4.84,0,0,1,109.84,0a4.59,4.59,0,0,1,3.28,1.41L213.77,102.05a7.65,7.65,0,0,1,0,10.8L113.08,213.53A4.59,4.59,0,0,1,109.8,214.94Z",
            clipRule: "evenodd",
            fill: iconColor,
            fillRule: "evenodd"
        })
    });
};
const $66e3027b098c7559$export$488f295d9b876ed0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kLpHK.CustomIcon), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($66e3027b098c7559$var$LdCreateFeatureFlagGlyph, {})
    });

});

parcelRegister("2K44i", function(module, exports) {

$parcel$export(module.exports, "ManualTriggerIcon", () => $2925ac96536b3cae$export$1ba9c8c8d09e7b3f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4GqRf = parcelRequire("4GqRf");
const $2925ac96536b3cae$export$1ba9c8c8d09e7b3f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GqRf))), {
        color: "currentColor",
        ...props
    });

});
parcelRegister("4GqRf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8cbf4ab2d75c385e37fe01f50c4f5b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $368feb0d614db756$var$_react = $368feb0d614db756$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $368feb0d614db756$var$_baseNew = $368feb0d614db756$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $368feb0d614db756$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PresenterMode".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for presenter mode in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $368feb0d614db756$var$PresenterModeIcon = (props)=>/*#__PURE__*/ $368feb0d614db756$var$_react.default.createElement($368feb0d614db756$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.909 2.5a2.409 2.409 0 0 0-1.054 4.576l-.657 1.348a3.909 3.909 0 1 1 5.226-5.226l-1.348.657A2.41 2.41 0 0 0 4.909 2.5m-.19 2.22a.75.75 0 0 1 .786-.175l9 3.25a.75.75 0 0 1 .02 1.403l-3.822 1.505-1.505 3.822a.75.75 0 0 1-1.403-.02l-3.25-9a.75.75 0 0 1 .175-.785M6.5 6.498l2.032 5.629.896-2.277a.75.75 0 0 1 .423-.423l2.276-.896z" clip-rule="evenodd"/>`
    }, props));
$368feb0d614db756$var$PresenterModeIcon.displayName = 'PresenterModeIcon';
var $368feb0d614db756$var$_default = module.exports.default = $368feb0d614db756$var$PresenterModeIcon;

});


parcelRegister("gke8X", function(module, exports) {

$parcel$export(module.exports, "ProductDiscoveryIcon", () => $4ea685d69e319313$export$b4c03f372eac4c8e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kLpHK = parcelRequire("kLpHK");
// Because this is a logo it should be presented on white and design tokens are not used
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $4ea685d69e319313$var$ProductDiscoveryGlyph = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M18.9987 16.28C18.9987 16.28 19.018 16.66 19.018 17.1847C19.018 19.1394 17.4333 20.724 15.4787 20.724C13.524 20.724 11.9393 19.1394 11.9393 17.1847C11.9393 15.23 13.524 13.6454 15.4787 13.6454C16.0033 13.6454 16.3253 13.6647 16.3253 13.6647V6.74736C16.046 6.72469 15.764 6.71069 15.4787 6.71069C9.69201 6.71069 5.00067 11.402 5.00067 17.1887C5.00067 22.9754 9.69201 27.6667 15.4787 27.6667C21.2653 27.6667 25.9567 22.9754 25.9567 17.1887C25.9567 16.8554 25.9507 16.624 25.9233 16.2807H18.9987V16.28Z",
                fill: "url(#paint0_linear_1522_5711)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M17.9233 5.6767C20.8313 6.4627 23.7393 6.4627 26.6473 5.6767C26.8573 5.62003 27.046 5.8087 26.9893 6.0187C26.2033 8.9267 26.2033 11.8347 26.9893 14.7427C27.046 14.9527 26.8573 15.1414 26.6473 15.0847C23.7393 14.2987 20.8313 14.2987 17.9233 15.0847C17.7133 15.1414 17.5247 14.9527 17.5813 14.7427C18.3673 11.8347 18.3673 8.9267 17.5813 6.0187C17.5247 5.8087 17.7133 5.62003 17.9233 5.6767Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("defs", {
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                    id: "paint0_linear_1522_5711",
                    x1: "14.178",
                    y1: "18.4887",
                    x2: "21.4387",
                    y2: "11.228",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                            stopColor: "#1D7AFC"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                            offset: "1",
                            stopColor: "#0055CC"
                        })
                    ]
                })
            })
        ]
    });
const $4ea685d69e319313$export$b4c03f372eac4c8e = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kLpHK.CustomIcon), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($4ea685d69e319313$var$ProductDiscoveryGlyph, {})
    });

});

parcelRegister("7f40W", function(module, exports) {

$parcel$export(module.exports, "SecurityIcon", () => $c9a5c55cc6c46d0c$export$acd904f3704ffa43);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $akntA = parcelRequire("akntA");
const $c9a5c55cc6c46d0c$export$acd904f3704ffa43 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($akntA))), {
        color: "currentColor",
        ...props
    });

});
parcelRegister("akntA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0297da18dbbf01b4dbb4aa0ab03c6efe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $784dfb8aa46ec483$var$_react = $784dfb8aa46ec483$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $784dfb8aa46ec483$var$_baseNew = $784dfb8aa46ec483$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $784dfb8aa46ec483$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Vulnerability".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for security vulnerabilities.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $784dfb8aa46ec483$var$VulnerabilityIcon = (props)=>/*#__PURE__*/ $784dfb8aa46ec483$var$_react.default.createElement($784dfb8aa46ec483$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 2.5h3a.5.5 0 0 1 .5.5v3H15V3a2 2 0 0 0-2-2h-3zM2.5 3a.5.5 0 0 1 .5-.5h3V1H3a2 2 0 0 0-2 2v3h1.5zm4.75 1v4.5h1.5V4zM2.5 13v-3H1v3a2 2 0 0 0 2 2h3v-1.5H3a.5.5 0 0 1-.5-.5m11-3v3a.5.5 0 0 1-.5.5h-3V15h3a2 2 0 0 0 2-2v-3zM8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>`
    }, props));
$784dfb8aa46ec483$var$VulnerabilityIcon.displayName = 'VulnerabilityIcon';
var $784dfb8aa46ec483$var$_default = module.exports.default = $784dfb8aa46ec483$var$VulnerabilityIcon;

});


parcelRegister("jh58T", function(module, exports) {

$parcel$export(module.exports, "SmartValueIcon", () => $33df07faa234cb8a$export$4dfdf078eca62ff7);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $ahwW5 = parcelRequire("ahwW5");
const $33df07faa234cb8a$export$4dfdf078eca62ff7 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahwW5))), {
        color: "currentColor",
        ...props
    });

});
parcelRegister("ahwW5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee004962d658b68794fe80075fffba6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $77c50a50be517e78$var$_react = $77c50a50be517e78$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $77c50a50be517e78$var$_baseNew = $77c50a50be517e78$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $77c50a50be517e78$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CurlyBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents Smart values in Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $77c50a50be517e78$var$CurlyBracketsIcon = (props)=>/*#__PURE__*/ $77c50a50be517e78$var$_react.default.createElement($77c50a50be517e78$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10 1h2.5a2 2 0 0 1 2 2v4.25H16v1.5h-1.5V13a2 2 0 0 1-2 2H10v-1.5h2.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H10zM1.5 3a2 2 0 0 1 2-2H6v1.5H3.5A.5.5 0 0 0 3 3v10a.5.5 0 0 0 .5.5H6V15H3.5a2 2 0 0 1-2-2V8.75H0v-1.5h1.5z" clip-rule="evenodd"/>`
    }, props));
$77c50a50be517e78$var$CurlyBracketsIcon.displayName = 'CurlyBracketsIcon';
var $77c50a50be517e78$var$_default = module.exports.default = $77c50a50be517e78$var$CurlyBracketsIcon;

});


parcelRegister("kUSyg", function(module, exports) {

$parcel$export(module.exports, "TransitionIcon", () => $c9c121c43eb3ddd6$export$b707bc11dbc96bdf);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3ZKV6 = parcelRequire("3ZKV6");
const $c9c121c43eb3ddd6$export$b707bc11dbc96bdf = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3ZKV6))), {
        color: "currentColor",
        ...props
    });

});
parcelRegister("3ZKV6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b20915105f9f06f3ef89ee9497af0ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e8b76f1a9be126b$var$_react = $2e8b76f1a9be126b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2e8b76f1a9be126b$var$_baseNew = $2e8b76f1a9be126b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $2e8b76f1a9be126b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Transition".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for transitions in Analytics.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e8b76f1a9be126b$var$TransitionIcon = (props)=>/*#__PURE__*/ $2e8b76f1a9be126b$var$_react.default.createElement($2e8b76f1a9be126b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5h-.816c-.586 0-1.062.476-1.062 1.063v5.875A2.563 2.563 0 0 1 6.188 13.5h-.816a2.25 2.25 0 1 1 0-1.5h.816c.586 0 1.062-.476 1.062-1.062V5.062A2.56 2.56 0 0 1 9.813 2.5zM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$2e8b76f1a9be126b$var$TransitionIcon.displayName = 'TransitionIcon';
var $2e8b76f1a9be126b$var$_default = module.exports.default = $2e8b76f1a9be126b$var$TransitionIcon;

});



parcelRegister("hb1kw", function(module, exports) {

$parcel$export(module.exports, "TemplateIcon", () => $e67d4b7843944b87$export$17f8b5fdc0dde895);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5SdQs = parcelRequire("5SdQs");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");


var $9wP5o = parcelRequire("9wP5o");
const $e67d4b7843944b87$var$borderContainerStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface',
    borderRadius: 'border.radius.200',
    boxSizing: 'border-box',
    height: 'size.300',
    padding: 'space.025',
    width: 'size.300'
});
const $e67d4b7843944b87$var$baseStyles = (0, $1DXK0.xcss)({
    alignItems: 'center',
    padding: 'space.100',
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%'
});
const $e67d4b7843944b87$var$triggerStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.success',
    zIndex: 'card'
});
const $e67d4b7843944b87$var$actionStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.selected'
});
const $e67d4b7843944b87$var$crossProductStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral'
});
function $e67d4b7843944b87$var$getPrimaryColor(icon, type) {
    if ((0, $9wP5o.isCrossProductIcon)(icon)) return;
    switch(type){
        case 'trigger':
            return `var(--ds-icon-accent-green, ${(0, $7bb4c1736002a04a$exports).G500})`;
        case 'action':
            return `var(--ds-icon-accent-blue, ${(0, $7bb4c1736002a04a$exports).B500})`;
        default:
            return `var(--ds-icon, ${(0, $7bb4c1736002a04a$exports).N200})`;
    }
}
/**
 *
 * Component which creates a React Element rendering out a template symbol.
 *
 * @param props - icons, size, type
 */ const $e67d4b7843944b87$var$TemplateSymbol = ({ icon: icon, size: size, type: type })=>{
    const primaryColor = $e67d4b7843944b87$var$getPrimaryColor(icon, type);
    const templateIcon = (0, $eJOHy.useMemo)(()=>{
        try {
            const Icon = icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($5SdQs)));
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                label: "",
                size: size,
                color: primaryColor,
                spacing: "spacious"
            });
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('Failed to create icon element, using defaults.');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5SdQs))), {
                label: ''
            });
        }
    }, [
        icon,
        size,
        primaryColor
    ]);
    return templateIcon || null;
};
const $e67d4b7843944b87$export$17f8b5fdc0dde895 = ({ icon: icon, size: size, type: type })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $e67d4b7843944b87$var$borderContainerStyles,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
            xcss: [
                $e67d4b7843944b87$var$baseStyles,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $9wP5o.isCrossProductIcon)(icon) ? $e67d4b7843944b87$var$crossProductStyles : type === 'trigger' ? $e67d4b7843944b87$var$triggerStyles : $e67d4b7843944b87$var$actionStyles
            ],
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($e67d4b7843944b87$var$TemplateSymbol, {
                icon: icon,
                size: size,
                type: type
            })
        })
    });
};

});

parcelRegister("5sOoU", function(module, exports) {

$parcel$export(module.exports, "TemplateItem", () => $745f8b7eada24a79$export$67c95d00e574f6b6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7saMl = parcelRequire("7saMl");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $bTRiZ = parcelRequire("bTRiZ");
const $745f8b7eada24a79$var$triggerStyles = (0, $1DXK0.xcss)({
    zIndex: 'card'
});
const $745f8b7eada24a79$var$actionStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.negative.100'
});
const $745f8b7eada24a79$var$templateStyles = (0, $1DXK0.xcss)({
    alignItems: 'center',
    display: 'flex'
});
const $745f8b7eada24a79$export$67c95d00e574f6b6 = ({ onClick: onClick, isDisabled: isDisabled, triggerIcon: triggerIcon, actionIcon: actionIcon, description: description, templateId: templateId })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
        onClick: (event)=>!isDisabled && onClick(event),
        testId: 'template.item.' + templateId,
        isDisabled: isDisabled,
        shouldTitleWrap: true,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8nu6j.default), {
            xcss: $745f8b7eada24a79$var$templateStyles,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                    testId: 'template.item.trigger.icon.' + templateId,
                    xcss: $745f8b7eada24a79$var$triggerStyles,
                    children: triggerIcon
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                    testId: 'template.item.action.icon.' + templateId,
                    xcss: $745f8b7eada24a79$var$actionStyles,
                    children: actionIcon
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                    testId: 'template.item.desc.' + templateId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bTRiZ.TemplateDescription), {
                        text: description
                    })
                })
            ]
        })
    });
};

});
parcelRegister("bTRiZ", function(module, exports) {

$parcel$export(module.exports, "TemplateDescription", () => $79963bea658bc60d$export$809977f0794a1530);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");
const $79963bea658bc60d$var$descriptionStyles = (0, $1DXK0.xcss)({
    boxSizing: 'border-box',
    marginLeft: 'space.100'
});
const $79963bea658bc60d$export$809977f0794a1530 = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        ignoreTooltipPointerEvents: true,
        content: props.text,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $79963bea658bc60d$var$descriptionStyles,
                ...tooltipProps,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    size: "UNSAFE_small",
                    weight: "medium",
                    maxLines: 2,
                    children: props.text
                })
            })
    });
};

});



parcelRegister("9Ly7H", function(module, exports) {

$parcel$export(module.exports, "AutomationGlyph", () => $614b073e4bcee964$export$3b6023946faff8bc);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dtpha = parcelRequire("dtpha");
const $614b073e4bcee964$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dtpha))), {
        color: "currentColor",
        ...props
    });

});

parcelRegister("kzuqP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bb575c118831329e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $bb575c118831329e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    templateDropdownTooltipLabel: {
        id: 'automation-platform.automation-templates.template-dropdown-tooltip-label',
        defaultMessage: 'Automation',
        description: 'The label for the tooltip that appears when hovering over the automation button'
    },
    templateDropdownTitle: {
        id: 'automation-platform.automation-templates.template-dropdown-title',
        defaultMessage: 'Automation',
        description: 'The title for the dropdown menu that contains the automation templates'
    },
    templateDropdownDescription: {
        id: 'automation-platform.automation-templates.template-dropdown-description',
        defaultMessage: "Boost your team's efficiency by creating automations from these templates.",
        description: 'The description for the dropdown menu that contains the automation templates'
    },
    discoverMoreTemplates: {
        id: 'automation-platform.automation-templates.discover-more-templates',
        defaultMessage: 'Discover more templates',
        description: 'The description of the link to the page to see more automation templates'
    }
});

});


parcelRegister("jbPE2", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $192a6ea715d806e4$export$6123178d3f5fb24d);
$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $192a6ea715d806e4$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $192a6ea715d806e4$export$8e479e490e1e69bc);

var $dnU6V = parcelRequire("dnU6V");

var $7jTnu = parcelRequire("7jTnu");
const $192a6ea715d806e4$var$localStorage = (0, $dnU6V.createLocalStorageProvider)('automation-menu');
const $192a6ea715d806e4$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $192a6ea715d806e4$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $7jTnu.fg)('automation-platform-pre-prod-instance')) {
            const stack = await $192a6ea715d806e4$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $192a6ea715d806e4$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $192a6ea715d806e4$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $192a6ea715d806e4$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $192a6ea715d806e4$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $192a6ea715d806e4$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $192a6ea715d806e4$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if ((0, $7jTnu.fg)('jcs_project_type_m3')) switch(projectType){
        case 'customer_service':
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});

parcelRegister("76rlq", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $3b9afa2f396b3f55$export$4a39035bacc4ed76);
$parcel$export(module.exports, "useReportFeatures", () => $3b9afa2f396b3f55$export$4adaea9828b7ff13);
$parcel$export(module.exports, "useSettingFeatures", () => $3b9afa2f396b3f55$export$56022a3b83c8ed6a);
$parcel$export(module.exports, "useTMPSettingFeatures", () => $3b9afa2f396b3f55$export$e8540ab76a479132);

var $eJOHy = parcelRequire("eJOHy");

var $dPXBl = parcelRequire("dPXBl");

var $dSkLG = parcelRequire("dSkLG");

var $ehOgJ = parcelRequire("ehOgJ");

var $g1NZW = parcelRequire("g1NZW");

var $bq214 = parcelRequire("bq214");
const $3b9afa2f396b3f55$export$4a39035bacc4ed76 = (customContext)=>{
    const { data: data, ...rest } = (0, $dSkLG.useJiraServiceManagementProjectNavigation)(customContext);
    const extractedData = (0, $eJOHy.useMemo)(()=>data && (0, $bq214.extractData)(data), [
        data
    ]);
    return {
        data: extractedData,
        ...rest
    };
};
const $3b9afa2f396b3f55$export$4adaea9828b7ff13 = (customContext)=>{
    const { data: data, ...rest } = (0, $dPXBl.useJiraServiceManagementReportsNavigation)(customContext);
    const extractedData = (0, $eJOHy.useMemo)(()=>data && (0, $bq214.extractReportData)(data), [
        data
    ]);
    return {
        data: extractedData,
        ...rest
    };
};
const $3b9afa2f396b3f55$export$56022a3b83c8ed6a = (customContext)=>{
    const { data: data, ...rest } = (0, $dSkLG.useJiraServiceManagementProjectNavigation)(customContext);
    const hasActiveSoftwareAccess = (0, $ehOgJ.useHasActiveSoftwareAccess)();
    const environment = (0, $g1NZW.useEnvironment)();
    const extractedData = (0, $eJOHy.useMemo)(()=>data && (0, $bq214.extractSettingData)(data, {
            hasActiveSoftwareAccess: hasActiveSoftwareAccess,
            environment: environment
        }), [
        data,
        environment,
        hasActiveSoftwareAccess
    ]);
    return {
        data: extractedData,
        ...rest
    };
};
const $3b9afa2f396b3f55$export$e8540ab76a479132 = ()=>{
    const { data: data, ...rest } = (0, $dSkLG.useJiraServiceManagementProjectNavigation)();
    const extractedData = (0, $eJOHy.useMemo)(()=>data && (0, $bq214.extractTMPSettingData)(data), [
        data
    ]);
    return {
        data: extractedData,
        ...rest
    };
};

});
parcelRegister("dPXBl", function(module, exports) {

$parcel$export(module.exports, "useJiraServiceManagementReportsNavigation", () => $cd26b38f7939aee3$export$6d172fb6aa6b6b5b);

var $gq8OO = parcelRequire("gq8OO");

var $bo7Z6 = parcelRequire("bo7Z6");
const $cd26b38f7939aee3$export$6d172fb6aa6b6b5b = (customContext)=>(0, $bo7Z6.useResourceWithCustomRouterContext)((0, $gq8OO.staticSidebarJsmReportsResource), customContext);

});

parcelRegister("ehOgJ", function(module, exports) {

$parcel$export(module.exports, "useHasActiveSoftwareAccess", () => $d4e03d4b84e96009$export$895f9b38ce00671e);

var $8vyDv = parcelRequire("8vyDv");

var $iW0U8 = parcelRequire("iW0U8");
const $d4e03d4b84e96009$export$895f9b38ce00671e = ()=>{
    const { software: software } = (0, $8vyDv.useAppEditions)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $iW0U8.useApplicationPermissions)();
    return software !== 'UNLICENSED' && hasSoftwareAccess === true;
};

});

parcelRegister("bq214", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $fbbfb862b3eb64de$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractReportData", () => $fbbfb862b3eb64de$export$86f3b0e5fff6482e);
$parcel$export(module.exports, "extractSettingData", () => $fbbfb862b3eb64de$export$a1d86e289d0f43b7);
$parcel$export(module.exports, "extractTMPSettingData", () => $fbbfb862b3eb64de$export$d334c13580163a89);

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");
const $fbbfb862b3eb64de$export$9df5fa0a366163d2 = (navData)=>{
    const { project: project, permissionInfo: permissionInfo, isAgent: isAgent, hasCustomerChannels: hasCustomerChannels, knowledgeBaseInfo: knowledgeBaseInfo, raiseRequestInfo: raiseRequestInfo, opsGenieInfo: opsGenieInfo, projectSummaryInfo: projectSummaryInfo, boardInfo: boardInfo, calendarInfo: calendarInfo, hasNotificationLogs: hasNotificationLogs = true, hasHelpCenterSettings: hasHelpCenterSettings = false, hasArchivedIssues: hasArchivedIssues = false } = navData;
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
    const { isOnCallEnabled: isOnCallEnabled, isAlertEnabled: isAlertEnabled, opsGenieBaseUrl: opsGenieBaseUrl } = opsGenieInfo;
    const isProjectOrJiraAdmin = isAdmin || projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const { portalUrl: portalUrl } = raiseRequestInfo;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasQueues: isAgent,
        hasCustomers: isAgent,
        hasCustomerChannels: hasCustomerChannels,
        hasReports: isAgent,
        hasPIN: !isAgent,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        knowledge: {
            enabled: knowledgeBaseInfo.enabled,
            type: knowledgeBaseInfo.enabled ? knowledgeBaseInfo.knowledgeBaseType : null
        },
        raiseRequest: {
            enabled: raiseRequestInfo.enabled,
            url: raiseRequestInfo.enabled ? portalUrl : ''
        },
        opsgenieAlert: {
            enabled: isAlertEnabled,
            url: isAlertEnabled ? `${opsGenieBaseUrl}/alert/list` : ''
        },
        opsgenieOnCall: {
            enabled: isOnCallEnabled,
            url: isOnCallEnabled ? `${opsGenieBaseUrl}/schedule/whoIsOnCall` : ''
        },
        hasProjectSummary: !!projectSummaryInfo?.enabled,
        jsmBoard: {
            enabled: boardInfo.enabled,
            url: `/jira/servicedesk/projects/${project.key}/boards/${boardInfo.board.id}`
        },
        jsmCalendar: {
            enabled: calendarInfo?.enabled ?? false,
            url: `/jira/servicedesk/projects/${project.key}/boards/${boardInfo.board.id}/calendar`
        },
        hasNotificationLogs: (0, $7jTnu.fg)('jcs_master_flag') ? hasNotificationLogs : true,
        hasHelpCenterSettings: (0, $7jTnu.fg)('jcs_master_flag') ? isProjectOrJiraAdmin && hasHelpCenterSettings : false
    };
};
const $fbbfb862b3eb64de$export$86f3b0e5fff6482e = (data)=>({
        hasWorkload: true,
        hasSatisfaction: data.hasSatisfactionReport,
        hasRequestsDeflected: data.hasRequestsDeflectedReport,
        hasRequestsResolved: data.hasRequestsResolvedReport,
        hasNewReport: data.hasNewReport,
        hasManageReport: false
    });
const $fbbfb862b3eb64de$export$a1d86e289d0f43b7 = (navData, { hasActiveSoftwareAccess: hasActiveSoftwareAccess, environment: environment })=>{
    const { permissionInfo: permissionInfo, settingsInfo: settingsInfo } = navData;
    const { hasChangeManagement: hasChangeManagement = false, hasAddonInstaller: hasAddonInstaller = false, hasIncidentManagement: hasIncidentManagement = false, hasExternalLinks: hasExternalLinks = false, hasProjectAutomation: hasProjectAutomation = false, hasWidgetAddon: hasWidgetAddon = false, hasChat: hasChat = true, hasServices: hasServices = false, hasVersions: hasVersions = true, hasComponents: hasComponents = true, hasCustomerSupportManagement: hasCustomerSupportManagement = false, hasProductsAndEntitlements: hasProductsAndEntitlements = false, hasDeveloperEscalation: hasDeveloperEscalation = false, hasVirtualAgent: hasVirtualAgent = true, hasLanguageSupport: hasLanguageSupport = true, hasRequestTypes: hasRequestTypes = true, hasPortalSettings: hasPortalSettings = true, hasCustomerNotifications: hasCustomerNotifications = true, hasCustomerPermissions: hasCustomerPermissions = true, hasForms: hasForms = true, hasKnowledgeBase: hasKnowledgeBase = true, hasChannelsAndSelfService: hasChannelsAndSelfService = true, hasJourneyBuilder: hasJourneyBuilder = false } = settingsInfo;
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
    const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const isProjectOrJiraAdmin = isAdmin || isProjectAdmin;
    const hasIssueLayoutPermissions = permissionInfo.projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
    return {
        hasDetails: isProjectOrJiraAdmin,
        hasPeople: isProjectOrJiraAdmin,
        hasSummary: true,
        hasIssueLayout: isProjectOrJiraAdmin || hasIssueLayoutPermissions,
        hasIssueTypes: isProjectOrJiraAdmin,
        hasJsdChangeManagement: hasChangeManagement,
        hasRequestTypes: (0, $7jTnu.fg)('jcs_master_flag') ? hasRequestTypes : true,
        hasCustomerPermissions: (0, $7jTnu.fg)('jcs_master_flag') ? hasCustomerPermissions : true,
        hasPortalSettings: (0, $7jTnu.fg)('jcs_master_flag') ? hasPortalSettings : true,
        hasCustomerNotifications: (0, $7jTnu.fg)('jcs_master_flag') ? hasCustomerNotifications : true,
        hasAddonInstaller: hasAddonInstaller,
        hasWidgetAddon: hasWidgetAddon && environment === 'prod',
        hasWidgetAddonDev: hasWidgetAddon && environment !== 'prod',
        hasChat: hasChat,
        hasKnowledgeBase: (0, $7jTnu.fg)('jcs_master_flag') ? hasKnowledgeBase : true,
        hasSla: true,
        hasLegacyJSMAutomation: true,
        hasJsdAppDiscovery: true,
        hasJsdIncidentManagement: hasIncidentManagement,
        hasWorkflows: true,
        hasVersions: hasVersions,
        hasComponents: hasComponents,
        hasPermissions: true,
        hasIssueSecurity: true,
        hasNotifications: true,
        hasIssueCollectors: true,
        hasProjectAutomation: hasProjectAutomation,
        hasDevtools: hasActiveSoftwareAccess && isProjectAdmin,
        hasExternalLinks: hasExternalLinks,
        hasServices: hasServices,
        hasCustomerSupportManagement: hasCustomerSupportManagement,
        hasProductsAndEntitlements: hasProductsAndEntitlements,
        hasDeveloperEscalation: hasDeveloperEscalation,
        hasVirtualAgent: (0, $7jTnu.fg)('jcs_master_flag') ? hasVirtualAgent : true,
        hasLanguageSupport: (0, $7jTnu.fg)('jcs_master_flag') ? hasLanguageSupport : true,
        hasForms: (0, $7jTnu.fg)('jcs_master_flag') ? hasForms : true,
        hasFields: isProjectOrJiraAdmin,
        hasChannelsAndSelfService: (0, $7jTnu.fg)('jcs_master_flag') ? hasChannelsAndSelfService : true,
        hasJourneyBuilder: (0, $7jTnu.fg)('jsm-journey-builder__feature-toggle') ? hasJourneyBuilder : (0, $7jTnu.fg)('jsm-journey-builder')
    };
};
const $fbbfb862b3eb64de$export$d334c13580163a89 = (navData)=>{
    let hasFields = false;
    const [expConfig] = (0, $epTsa.UNSAFE_noExposureExp)('efa_and_project_fields_page_for_tmp');
    if (expConfig.get('isEnabled', false)) {
        const { permissionInfo: permissionInfo, hasExplicitFieldAssociationsEnabled: hasExplicitFieldAssociationsEnabled = false } = navData;
        const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
        const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
        const isProjectOrJiraAdmin = isAdmin || isProjectAdmin;
        hasFields = isProjectOrJiraAdmin && hasExplicitFieldAssociationsEnabled;
    }
    return {
        hasExternalLinks: navData?.settingsInfo?.hasExternalLinks,
        hasChat: navData?.settingsInfo?.hasChat,
        hasFields: hasFields,
        hasJourneyBuilder: (0, $7jTnu.fg)('jsm-journey-builder__feature-toggle') ? navData?.settingsInfo?.hasJourneyBuilder : (0, $7jTnu.fg)('jsm-journey-builder')
    };
};

});


parcelRegister("7gKoi", function(module, exports) {

$parcel$export(module.exports, "mapEnv", () => $1bc43f99cf40302f$export$2f2beb3dfc4bcd87);

var $5WJCM = parcelRequire("5WJCM");
const $1bc43f99cf40302f$export$2f2beb3dfc4bcd87 = (env, devHelperFFEnabled)=>{
    switch(env){
        case 'prod':
            return devHelperFFEnabled ? (0, $5WJCM.Environment).PRE_PROD : (0, $5WJCM.Environment).PROD;
        default:
            return (0, $5WJCM.Environment).DEV;
    }
};

});

parcelRegister("1ZCdB", function(module, exports) {

$parcel$export(module.exports, "FailureFlag", () => $e9f1e9cc958661ce$export$79fddc087d32ad);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $d8UFE = parcelRequire("d8UFE");

var $22c3C = parcelRequire("22c3C");
var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");


var $apwGU = parcelRequire("apwGU");
const $e9f1e9cc958661ce$export$79fddc087d32ad = ({ automationBaseUrl: automationBaseUrl, flagId: flagId, flagKey: flagKey, templateId: templateId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ $eJOHy.createElement((0, $22c3C.default), {
        testId: "servicedesk-queues-automation-menu.ui.automation-menu.failure-flag.failure-flag",
        icon: /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
            color: "var(--ds-icon-warning, #E56910)",
            label: ""
        }),
        id: (0, $hrodw.fromFlagId)(flagId),
        key: flagKey,
        title: formatMessage((0, $apwGU.default).failureFlagTitle),
        description: formatMessage((0, $apwGU.default).failureFlagDescription),
        messageId: "servicedesk-queues-automation-menu.ui.automation-menu.failure-flag.ak-flag",
        messageType: "transactional",
        actions: [
            {
                content: formatMessage((0, $apwGU.default).failureFlagAction),
                href: `${automationBaseUrl}#/rule/template?templateId=${templateId}`,
                onClick: ()=>{
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), `${(0, $51ac28649bda1008$export$b8b9d90f9e5bd72b)}.failureFlag.action clicked`);
                }
            }
        ],
        onDismissed: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), `${(0, $51ac28649bda1008$export$b8b9d90f9e5bd72b)}.failureFlag.dismiss clicked`);
            dismissFlag(flagId);
        }
    });
};

});
parcelRegister("apwGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6483afa30ff6ac7c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6483afa30ff6ac7c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    failureFlagTitle: {
        "id": "servicedesk-queues-automation-menu.automation-menu.failure-flag.failure-flag-title",
        "defaultMessage": "We couldn't create your automation rule"
    },
    failureFlagDescription: {
        "id": "servicedesk-queues-automation-menu.automation-menu.failure-flag.failure-flag-description",
        "defaultMessage": "Try again from the automation template."
    },
    failureFlagAction: {
        "id": "servicedesk-queues-automation-menu.automation-menu.failure-flag.failure-flag-action",
        "defaultMessage": "Go to automation template"
    }
});
var $6483afa30ff6ac7c$export$2e2bcd8739ae039 = $6483afa30ff6ac7c$export$defe85febe8b728c;

});


parcelRegister("fNWzi", function(module, exports) {

$parcel$export(module.exports, "SuccessFlag", () => $d88ff779f029fd8d$export$93bd4963a1d00fd5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $3wl9L = parcelRequire("3wl9L");

var $22c3C = parcelRequire("22c3C");
var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");


var $d2YLD = parcelRequire("d2YLD");
const $d88ff779f029fd8d$export$93bd4963a1d00fd5 = ({ automationBaseUrl: automationBaseUrl, flagId: flagId, flagKey: flagKey, ruleId: ruleId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ $eJOHy.createElement((0, $22c3C.default), {
        testId: "servicedesk-queues-automation-menu.ui.automation-menu.success-flag.success-flag",
        icon: /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3wl9L))), {
            color: "var(--ds-icon-success, #22A06B)",
            label: ""
        }),
        id: (0, $hrodw.fromFlagId)(flagId),
        key: flagKey,
        title: formatMessage((0, $d2YLD.default).successFlagTitle),
        messageId: "servicedesk-queues-automation-menu.ui.automation-menu.success-flag.ak-flag",
        messageType: "transactional",
        actions: [
            {
                content: formatMessage((0, $d2YLD.default).successFlagAction),
                href: `${automationBaseUrl}#/rule/${ruleId}`,
                onClick: ()=>{
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), `${(0, $51ac28649bda1008$export$b8b9d90f9e5bd72b)}.successFlag.action clicked`);
                }
            }
        ],
        onDismissed: ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), `${(0, $51ac28649bda1008$export$b8b9d90f9e5bd72b)}.successFlag.dismiss clicked`);
            dismissFlag(flagId);
        }
    });
};

});
parcelRegister("d2YLD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d357dbe9874e802$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5d357dbe9874e802$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    successFlagTitle: {
        "id": "servicedesk-queues-automation-menu.automation-menu.success-flag.success-flag-title",
        "defaultMessage": "Your automation rule has been created"
    },
    successFlagAction: {
        "id": "servicedesk-queues-automation-menu.automation-menu.success-flag.success-flag-action",
        "defaultMessage": "Go to automation rule"
    }
});
var $5d357dbe9874e802$export$2e2bcd8739ae039 = $5d357dbe9874e802$export$defe85febe8b728c;

});


parcelRegister("evJAa", function(module, exports) {

$parcel$export(module.exports, "useTemplateCategories", () => $3a877b1692222d14$export$8de6b089a4b91fde);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");

var $8KUFq = parcelRequire("8KUFq");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

const $3a877b1692222d14$var$getTemplateCategory = (teamType, isChangeManagementPracticeEnabled)=>{
    const map = {
        businessOperations: 'jsm.team-type.business',
        design: 'jsm.team-type.design',
        hr: 'jsm.team-type.human-resources',
        it: 'jsm.team-type.information-technology'
    };
    if (teamType && map[teamType]) return map[teamType];
    return isChangeManagementPracticeEnabled ? 'jira-service-management.change-management' : 'jsm.default';
};
const $3a877b1692222d14$export$8de6b089a4b91fde = (projectId, isChangeManagementPracticeEnabled)=>{
    const [state, setState] = (0, $eJOHy.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fetchTeamType = (0, $eJOHy.useCallback)(async ()=>{
        try {
            const { teamType: teamType } = await (0, $1Ozm9.default)(`/rest/servicedesk/latest/project/properties/${projectId}/teamType`);
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $51ac28649bda1008$export$b8b9d90f9e5bd72b)}.fetchTeamType succeeded`);
            setState({
                data: [
                    $3a877b1692222d14$var$getTemplateCategory(teamType, isChangeManagementPracticeEnabled)
                ],
                loading: false
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            !(0, $8KUFq.isClientFetchError)(error) && (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'fetchTeamType',
                    packageName: (0, $51ac28649bda1008$export$b8b9d90f9e5bd72b),
                    teamName: (0, $51ac28649bda1008$export$d57b6b390e78d90f)
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setState({
                data: [
                    $3a877b1692222d14$var$getTemplateCategory(undefined, isChangeManagementPracticeEnabled)
                ],
                loading: false
            });
        }
    }, [
        createAnalyticsEvent,
        isChangeManagementPracticeEnabled,
        projectId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchTeamType();
    }, [
        fetchTeamType
    ]);
    return state;
};

});


parcelRegister("iEYgr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "MenuContent", () => $98713df08748c29f$export$479f0f2f71193efe);
$parcel$export(module.exports, "default", () => $98713df08748c29f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");

var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $lRq8t = parcelRequire("lRq8t");

var $8GhkZ = parcelRequire("8GhkZ");

var $3mrwA = parcelRequire("3mrwA");

var $j12Fn = parcelRequire("j12Fn");
const $98713df08748c29f$export$479f0f2f71193efe = ({ onClick: onClick })=>{
    const intl = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($98713df08748c29f$var$MenuContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "small",
        as: "h5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($98713df08748c29f$var$MenuTitle, null, intl.formatMessage((0, $3mrwA.default).menuTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($98713df08748c29f$var$MenuSubTitle, null, intl.formatMessage((0, $3mrwA.default).menuSubTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j12Fn.TemplateRules), {
        onLinkClick: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6YEko.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8GhkZ.DeepLinks), {
        onLinkClick: onClick
    }))));
};
const $98713df08748c29f$var$MenuContentEntryPoint = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($98713df08748c29f$export$479f0f2f71193efe, props);
var $98713df08748c29f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $98713df08748c29f$var$MenuContentEntryPoint;
const $98713df08748c29f$var$MenuContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1kdj",
            __cmplp.className
        ])
    });
});
const $98713df08748c29f$var$MenuTitle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1ejb _u5f3idpf _n3tdu2gc _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $98713df08748c29f$var$MenuSubTitle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1yt41rml _syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8GhkZ", function(module, exports) {

$parcel$export(module.exports, "DeepLinks", () => $7bd2c0c31d7ce84b$export$542fc7e380d7fa06);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $kMmrb = parcelRequire("kMmrb");

var $joRfR = parcelRequire("joRfR");

var $f58rc = parcelRequire("f58rc");
var $jUgeq = parcelRequire("jUgeq");

var $c3rOS = parcelRequire("c3rOS");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $ljej9 = parcelRequire("ljej9");

var $8NBnF = parcelRequire("8NBnF");

var $l6Fz5 = parcelRequire("l6Fz5");
const $7bd2c0c31d7ce84b$export$542fc7e380d7fa06 = ({ onLinkClick: onLinkClick })=>{
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const projectKey = (0, $ljej9.toProjectKey)(`${project?.projectKey}`);
    const isSimplified = !!project?.simplified;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const linkOnClick = (eventName)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, eventName);
        onLinkClick();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        href: (0, $8NBnF.buildManageRulesAutomationUrl)({
            projectKey: projectKey,
            isSimplified: isSimplified
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
            glyph: (0, $c3rOS.AutomationGlyph),
            label: ""
        }),
        onClick: ()=>linkOnClick('manageRulesAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $l6Fz5.default).manageAutomationMenuItemLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        href: (0, $8NBnF.buildNewRuleAutomationUrl)({
            projectKey: projectKey,
            isSimplified: isSimplified
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMmrb))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: ()=>linkOnClick('newRuleAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $l6Fz5.default).createAutomationMenuItemLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
        href: (0, $8NBnF.buildAuditLogAutomationUrl)({
            projectKey: projectKey,
            isSimplified: isSimplified
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($joRfR))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: ()=>linkOnClick('auditLogAutomationLink'),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $l6Fz5.default).auditLogAutomationMenuItemLabel)));
};

});
parcelRegister("8NBnF", function(module, exports) {

$parcel$export(module.exports, "buildNewRuleAutomationUrl", () => $445642a0b487f446$export$d6be0a6034032add);
$parcel$export(module.exports, "buildManageRulesAutomationUrl", () => $445642a0b487f446$export$fb714f787469e8b0);
$parcel$export(module.exports, "buildAuditLogAutomationUrl", () => $445642a0b487f446$export$7d1590b2fb4dd741);
$parcel$export(module.exports, "buildDiscoverAutomationUrl", () => $445642a0b487f446$export$51ac1eeac37070f8);
$parcel$export(module.exports, "buildTemplateRuleAutomationUrl", () => $445642a0b487f446$export$82ce8540ef209720);

var $4ECjj = parcelRequire("4ECjj");

var $ln6Iy = parcelRequire("ln6Iy");
const $445642a0b487f446$export$d6be0a6034032add = ({ projectKey: projectKey, isSimplified: isSimplified })=>`${(0, $4ECjj.getBaseAutomationUrl)({
        projectKey: projectKey,
        isSimplified: isSimplified,
        projectType: (0, $ln6Iy.SERVICE_DESK_PROJECT)
    })}#rule/new?componentFilterCriteria=SERVICE_MANAGEMENT_TRIGGERS`;
const $445642a0b487f446$export$fb714f787469e8b0 = ({ projectKey: projectKey, isSimplified: isSimplified })=>`${(0, $4ECjj.getBaseAutomationUrl)({
        projectKey: projectKey,
        isSimplified: isSimplified,
        projectType: (0, $ln6Iy.SERVICE_DESK_PROJECT)
    })}#/rule-list`;
const $445642a0b487f446$export$7d1590b2fb4dd741 = ({ projectKey: projectKey, isSimplified: isSimplified })=>`${(0, $4ECjj.getBaseAutomationUrl)({
        projectKey: projectKey,
        isSimplified: isSimplified,
        projectType: (0, $ln6Iy.SERVICE_DESK_PROJECT)
    })}#tab/audit-log`;
const $445642a0b487f446$export$51ac1eeac37070f8 = ({ projectKey: projectKey, isSimplified: isSimplified })=>`${(0, $4ECjj.getBaseAutomationUrl)({
        projectKey: projectKey,
        isSimplified: isSimplified,
        projectType: (0, $ln6Iy.SERVICE_DESK_PROJECT)
    })}#/tab/rule-library`;
const $445642a0b487f446$export$82ce8540ef209720 = ({ projectKey: projectKey, isSimplified: isSimplified }, templateId)=>`${(0, $4ECjj.getBaseAutomationUrl)({
        projectKey: projectKey,
        isSimplified: isSimplified,
        projectType: (0, $ln6Iy.SERVICE_DESK_PROJECT)
    })}#/rule/template?templateId=${templateId}`;

});
parcelRegister("4ECjj", function(module, exports) {

$parcel$export(module.exports, "getBaseAutomationUrl", () => $b690f45aef8a790c$export$8e479e490e1e69bc);
const $b690f45aef8a790c$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'service_desk') return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    if (projectType === 'business') return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
};

});


parcelRegister("l6Fz5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c59a4e8141dc76c4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c59a4e8141dc76c4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    manageAutomationMenuItemLabel: {
        "id": "servicedesk-queues-automation-menu.menu-content.deep-links.manage-automation-menu-item-label",
        "defaultMessage": "Manage automation"
    },
    createAutomationMenuItemLabel: {
        "id": "servicedesk-queues-automation-menu.menu-content.deep-links.create-automation-menu-item-label",
        "defaultMessage": "Create automation"
    },
    auditLogAutomationMenuItemLabel: {
        "id": "servicedesk-queues-automation-menu.menu-content.deep-links.audit-log-automation-menu-item-label",
        "defaultMessage": "Audit log"
    }
});

});


parcelRegister("3mrwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc13b57e730783a8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fc13b57e730783a8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    menuTitle: {
        "id": "servicedesk-queues-automation-menu.menu-content.menu-title",
        "defaultMessage": "Automation"
    },
    menuSubTitle: {
        "id": "servicedesk-queues-automation-menu.menu-content.menu-sub-title",
        "defaultMessage": "Setup your queues automations from these templates, or create a new one of your own."
    }
});

});

parcelRegister("j12Fn", function(module, exports) {

$parcel$export(module.exports, "TemplateRules", () => $5c7c4421901b1716$export$25b6a3087f1b72b5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $f58rc = parcelRequire("f58rc");

var $fL0In = parcelRequire("fL0In");

var $bcitO = parcelRequire("bcitO");

var $dNLHm = parcelRequire("dNLHm");

var $joRfR = parcelRequire("joRfR");

var $7icpf = parcelRequire("7icpf");

var $izhQH = parcelRequire("izhQH");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $ljej9 = parcelRequire("ljej9");


var $8NBnF = parcelRequire("8NBnF");

var $7hqYU = parcelRequire("7hqYU");

var $7M19n = parcelRequire("7M19n");

var $eVLan = parcelRequire("eVLan");

var $fB3CS = parcelRequire("fB3CS");
const $5c7c4421901b1716$var$PersonIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izhQH))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
});
const $5c7c4421901b1716$var$ServiceDeskIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
    size: "medium",
    glyph: (0, $7M19n.ServiceDeskGlyph),
    label: ""
});
const $5c7c4421901b1716$var$Email = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNLHm))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
});
const $5c7c4421901b1716$var$Clock = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($joRfR))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
});
const $5c7c4421901b1716$var$Lock = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7icpf))), {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: ""
});
const $5c7c4421901b1716$var$ActionAndTriggerIcons = ({ action: action, trigger: trigger })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5c7c4421901b1716$var$IconShadow, null, action), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bcitO))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5c7c4421901b1716$var$IconShadow, null, trigger));
const $5c7c4421901b1716$export$25b6a3087f1b72b5 = ({ onLinkClick: onLinkClick })=>{
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const projectKey = (0, $ljej9.toProjectKey)(`${project?.projectKey}`);
    const isSimplified = !!project?.simplified;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const templateIds = (0, $7hqYU.useTemplateIds)();
    const renderDepsRef = (0, $eJOHy.useRef)();
    renderDepsRef.current = {
        onLinkClick: onLinkClick
    };
    return (0, $eJOHy.useMemo)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const DiscoverMoreLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5c7c4421901b1716$var$DiscoverAutomationLink, {
            key: "discover-more-link",
            href: (0, $8NBnF.buildDiscoverAutomationUrl)({
                projectKey: projectKey,
                isSimplified: isSimplified
            }),
            onClick: ()=>{
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'discoverAutomationLink');
                renderDepsRef.current?.onLinkClick();
            }
        }, formatMessage((0, $eVLan.default).discoverAutomationMenuItemLabel));
        const templatesMap = {
            [(0, $fB3CS.TemplateIds).GENERAL_TEMPLATE_1]: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5c7c4421901b1716$var$ActionAndTriggerIcons, {
                    action: $5c7c4421901b1716$var$Clock,
                    trigger: $5c7c4421901b1716$var$Email
                }),
                message: (0, $7jTnu.fg)('itsm-issue-renaming') ? (0, $eVLan.default).itsmTemplateOneIssueTermRefresh : (0, $eVLan.default).itsmTemplateOne
            },
            [(0, $fB3CS.TemplateIds).GENERAL_TEMPLATE_2]: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5c7c4421901b1716$var$ActionAndTriggerIcons, {
                    action: $5c7c4421901b1716$var$ServiceDeskIcon,
                    trigger: $5c7c4421901b1716$var$Lock
                }),
                message: (0, $eVLan.default).itsmTemplateTwo
            },
            [(0, $fB3CS.TemplateIds).GENERAL_TEMPLATE_3]: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5c7c4421901b1716$var$ActionAndTriggerIcons, {
                    action: $5c7c4421901b1716$var$ServiceDeskIcon,
                    trigger: $5c7c4421901b1716$var$PersonIcon
                }),
                message: (0, $eVLan.default).itsmTemplateThree
            },
            [(0, $fB3CS.TemplateIds).HR_TEMPLATE_1]: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5c7c4421901b1716$var$ActionAndTriggerIcons, {
                    action: $5c7c4421901b1716$var$Clock,
                    trigger: $5c7c4421901b1716$var$Email
                }),
                message: (0, $eVLan.default).hrTemplateOne
            },
            [(0, $fB3CS.TemplateIds).HR_TEMPLATE_2]: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5c7c4421901b1716$var$ActionAndTriggerIcons, {
                    action: $5c7c4421901b1716$var$ServiceDeskIcon,
                    trigger: $5c7c4421901b1716$var$Lock
                }),
                message: (0, $eVLan.default).hrTemplateTwo
            },
            [(0, $fB3CS.TemplateIds).HR_TEMPLATE_3]: {
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5c7c4421901b1716$var$ActionAndTriggerIcons, {
                    action: $5c7c4421901b1716$var$ServiceDeskIcon,
                    trigger: $5c7c4421901b1716$var$PersonIcon
                }),
                message: (0, $eVLan.default).hrTemplateThree
            }
        };
        const rules = templateIds.reduce((templates, templateId)=>{
            const template = templatesMap[templateId];
            if (!templateId || !template) {
                (0, $gYnSx.default)({
                    meta: {
                        id: 'templateRules',
                        packageName: (0, $51ac28649bda1008$export$b8b9d90f9e5bd72b),
                        teamName: (0, $51ac28649bda1008$export$d57b6b390e78d90f)
                    },
                    attributes: {
                        templateId: templateId
                    }
                });
                return templates;
            }
            const linkItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f58rc.default), {
                key: templateId,
                shouldTitleWrap: true,
                href: (0, $8NBnF.buildTemplateRuleAutomationUrl)({
                    projectKey: projectKey,
                    isSimplified: isSimplified
                }, templateId),
                iconBefore: template.icon,
                onClick: ()=>{
                    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'automationTemplateRulesClicked', {
                        templateId: templateId
                    });
                    renderDepsRef.current?.onLinkClick();
                },
                UNSAFE_shouldDisableRouterLink: true
            }, formatMessage(template.message));
            templates.push(linkItem);
            return templates;
        }, []);
        rules.push(DiscoverMoreLink);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, rules);
    }, [
        createAnalyticsEvent,
        templateIds,
        projectKey,
        isSimplified,
        formatMessage
    ]);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c7c4421901b1716$var$DiscoverAutomationLink = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qpxbi _u5f3idpf _n3tdpxbi _19bv1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5c7c4421901b1716$var$IconShadow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1y44 _4t3izwfg _1bsbzwfg _16qszucj _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7M19n", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskGlyph", () => $738de25d9f51249a$export$6871fe0bc3d92379);
/* service-desk-glyph.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $738de25d9f51249a$export$6871fe0bc3d92379 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "32",
        fill: "none",
        viewBox: "0 0 32 32",
        focusable: "false",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "32",
        height: "32"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "m18.066 12.045 7.4011 0.037c0.9341 0 1.473 1.1081 0.9341 1.8839l-10.922 15.034c-3.449-2.6227-4.1317-7.6465-1.5808-11.193l4.1675-5.7626z",
        fill: "url(#a)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "m13.898 17.807-7.3651-0.037c-0.93411 0-1.473-1.1081-0.93411-1.8839l10.85-14.886c3.449 2.6227 4.1316 7.6464 1.5808 11.193l-4.1317 5.6148z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: "a",
        x1: "17.786",
        x2: "21.058",
        y1: "13.178",
        y2: "22.799"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($738de25d9f51249a$var$ServiceDeskGradientStopLightBlue, {
        offset: "0%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($738de25d9f51249a$var$ServiceDeskGradientStopDarkBlue, {
        offset: "100%"
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $738de25d9f51249a$var$ServiceDeskGradientStopLightBlue = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "stop", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_5fw21pd3",
            __cmplp.className
        ])
    });
});
const $738de25d9f51249a$var$ServiceDeskGradientStopDarkBlue = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "stop", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_5fw21pbo",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eVLan", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58202f361b4f35e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a58202f361b4f35e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    discoverAutomationMenuItemLabel: {
        "id": "servicedesk-queues-automation-menu.menu-content.template-rules.discover-automation-menu-item-label",
        "defaultMessage": "Discover more automation"
    },
    itsmTemplateOne: {
        "id": "servicedesk-queues-automation-menu.menu-content.template-rules.itsm-template-one",
        "defaultMessage": "Notify assignee when the due date of an issue is approaching"
    },
    itsmTemplateTwo: {
        "id": "servicedesk-queues-automation-menu.menu-content.template-rules.itsm-template-two",
        "defaultMessage": "Set security level by request type"
    },
    itsmTemplateThree: {
        "id": "servicedesk-queues-automation-menu.menu-content.template-rules.itsm-template-three",
        "defaultMessage": "Assign approver based on request type"
    },
    hrTemplateOne: {
        "id": "servicedesk-queues-automation-menu.menu-content.template-rules.hr-template-one",
        "defaultMessage": "Onboarding or off-boarding employee: notify assignee when due date is approaching"
    },
    hrTemplateTwo: {
        "id": "servicedesk-queues-automation-menu.menu-content.template-rules.hr-template-two",
        "defaultMessage": "Change the security level for confidential HR cases"
    },
    hrTemplateThree: {
        "id": "servicedesk-queues-automation-menu.menu-content.template-rules.hr-template-three",
        "defaultMessage": "Assign approver for employee transfer requests"
    },
    itsmTemplateOneIssueTermRefresh: {
        "id": "servicedesk-queues-automation-menu.menu-content.template-rules.itsm-template-one-issue-term-refresh",
        "defaultMessage": "Notify assignee when the due date of a work item is approaching"
    }
});

});

parcelRegister("fB3CS", function(module, exports) {

$parcel$export(module.exports, "TemplateIds", () => $f73ce2d1069f340b$export$c874f4c61d725140);
const $f73ce2d1069f340b$export$c874f4c61d725140 = {
    GENERAL_TEMPLATE_1: 'general_jsm_template_1',
    GENERAL_TEMPLATE_2: 'general_jsm_template_2',
    GENERAL_TEMPLATE_3: 'general_jsm_template_3',
    HR_TEMPLATE_1: 'hr_template_1',
    HR_TEMPLATE_2: 'hr_template_2',
    HR_TEMPLATE_3: 'hr_template_3'
};

});



parcelRegister("aCS3H", function(module, exports) {

$parcel$export(module.exports, "menuContentEntryPoint", () => $3a4c7c47eff5705c$export$f577412164e6d553);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $3a4c7c47eff5705c$export$f577412164e6d553 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("iEYgr"))), {
        moduleId: "12105790",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});




parcelRegister("2RARS", function(module, exports) {

$parcel$export(module.exports, "default", () => $79e5bab884534858$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gfcvC = parcelRequire("gfcvC");

var $9LI76 = parcelRequire("9LI76");

var $1KdDN = parcelRequire("1KdDN");
function $79e5bab884534858$export$2e2bcd8739ae039(props) {
    const [, setAddTopMargin] = (0, $eJOHy.useState)(false);
    const { queueName: queueName, onDeleteComplete: onDeleteComplete, renderDisplayError: renderDisplayError, Actions: Actions } = props;
    const handleError = (location)=>{
        if (location === 'common.error-boundary.queue-page-header') setAddTopMargin(true);
        renderDisplayError();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        onError: handleError,
        id: "queue-page-header",
        sendToPrivacyUnsafeSplunk: true,
        teamName: "jsd-shield",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gfcvC.default), {
        truncateTitle: true,
        // hide icons before hydration to disable interactive actions
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Actions, {
            onDeleteComplete: onDeleteComplete
        }),
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LI76.default), null)
    }, queueName));
}

});
parcelRegister("9LI76", function(module, exports) {

$parcel$export(module.exports, "default", () => $37b89fad4fcec754$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h6slU = parcelRequire("h6slU");
const $37b89fad4fcec754$var$QueuesBreadcrumbRendererNew = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h6slU.default), null);
var $37b89fad4fcec754$export$2e2bcd8739ae039 = $37b89fad4fcec754$var$QueuesBreadcrumbRendererNew;

});



parcelRegister("e15rh", function(module, exports) {

$parcel$export(module.exports, "SidebarIssueView", () => $9af8cfbb023f47aa$export$ccdf533f42a8d6f8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9cXFN = parcelRequire("9cXFN");

var $ljej9 = parcelRequire("ljej9");

var $04oZl = parcelRequire("04oZl");

var $1pLdk = parcelRequire("1pLdk");

var $b7U6N = parcelRequire("b7U6N");
const $9af8cfbb023f47aa$var$callWhenIdle = (callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof window.requestIdleCallback === 'function') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.requestIdleCallback(callback);
    else setTimeout(callback, 3000);
};
const $9af8cfbb023f47aa$export$ccdf533f42a8d6f8 = /*#__PURE__*/ (0, $eJOHy.memo)(({ issueKey: issueKey, onClose: onClose, analyticsSource: analyticsSource, onChange: onChange, onIssueDeleteSuccess: onIssueDeleteSuccess, parentWidth: parentWidth, setIsResizing: setIsResizing })=>{
    (0, $eJOHy.useEffect)(()=>{
        // Preload IssueApp here, otherwise it'd be loaded when Sidebar opens up for the first time, which is a bit slow
        $9af8cfbb023f47aa$var$callWhenIdle(()=>{
            (0, $04oZl.default).preload();
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cXFN.JiraDetailPanel), null, (setDetailPanelWidth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b7U6N.default), {
            parentWidth: parentWidth,
            onResize: setDetailPanelWidth,
            setIsResizing: setIsResizing
        }, issueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9af8cfbb023f47aa$var$SidebarWrapper, {
            "data-testid": "servicedesk-queues-agent-view.layout.sidebar-issue-app.wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1pLdk.SidebarIssueApp), {
            issueKey: (0, $ljej9.toIssueKey)(issueKey),
            onClose: onClose,
            analyticsSource: analyticsSource,
            onChange: onChange,
            onIssueDeleteSuccess: onIssueDeleteSuccess
        }))));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9af8cfbb023f47aa$var$SidebarWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9cXFN", function(module, exports) {

$parcel$export(module.exports, "JiraDetailPanel", () => $4bcf2379268f6e3c$export$93acb63f4e179357);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $6DCNy = parcelRequire("6DCNy");

var $h47gY = parcelRequire("h47gY");

var $fZsy4 = parcelRequire("fZsy4");
const $4bcf2379268f6e3c$var$DetailPanel = ({ children: children, panelWidth: panelWidth })=>{
    const { setWidth: setWidth } = (0, $fZsy4.useDetailPanelActions)();
    (0, $eJOHy.useEffect)(()=>{
        if (panelWidth !== undefined) setWidth(panelWidth);
        return ()=>setWidth(0);
    }, [
        panelWidth,
        setWidth
    ]);
    const throttleSetWidth = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(setWidth, 50, {
            leading: true,
            trailing: true
        }), [
        setWidth
    ]);
    return typeof children === 'function' ? children(throttleSetWidth) : children;
};
const $4bcf2379268f6e3c$export$93acb63f4e179357 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "jira-detail-panel",
        packageName: "jira-bottom-right-corner-controller",
        render: ()=>typeof props.children === 'function' ? props.children((0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))) : props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4bcf2379268f6e3c$var$DetailPanel, props));

});

parcelRegister("04oZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b913c2f7c90508df$export$2e2bcd8739ae039);

var $bQWwW = parcelRequire("bQWwW");

var // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
$b913c2f7c90508df$export$2e2bcd8739ae039 = (0, $bQWwW.lazy)(()=>(parcelRequire("gbKcf")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});

});
parcelRegister("gbKcf", function(module, exports) {

let $bc91821d19c5f46d$var$load = (parcelRequire("gLHA4"))(4);




























module.exports = Promise.all([
    (parcelRequire("g81qY"))('thor_add_taskabort_events_for_core_experiences', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("dZIaf")
                ]);
            }),
            $bc91821d19c5f46d$var$load("gVlCg")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("116M9")
                ]);
            }, function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("dZIaf")
                ]);
            }),
            $bc91821d19c5f46d$var$load("c687B")
        ]);
    }),
    (parcelRequire("g81qY"))('memo_fix_issue_field_remounts_2', function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("dWro6")
        ]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("c4kut")
        ]);
    }),
    (parcelRequire("g81qY"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("lw2Bw")
        ]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("2lCLc")
        ]);
    }),
    (parcelRequire("g81qY"))('smart_access_unified_deadend', function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("116M9")
        ]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("dZIaf")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("2Bh8z"),
                    $bc91821d19c5f46d$var$load("kvRbA"),
                    $bc91821d19c5f46d$var$load("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("5ERkJ")
                ]);
            }),
            (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("w71gM"),
                    $bc91821d19c5f46d$var$load("kvRbA"),
                    $bc91821d19c5f46d$var$load("ffQaD"),
                    $bc91821d19c5f46d$var$load("l253H"),
                    $bc91821d19c5f46d$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("2EwqZ")
                ]);
            }),
            (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("6u1ax"),
                    $bc91821d19c5f46d$var$load("kvRbA"),
                    $bc91821d19c5f46d$var$load("ffQaD"),
                    $bc91821d19c5f46d$var$load("l253H"),
                    $bc91821d19c5f46d$var$load("76n7a"),
                    $bc91821d19c5f46d$var$load("kNFvF"),
                    $bc91821d19c5f46d$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("enrdU")
                ]);
            }),
            $bc91821d19c5f46d$var$load("fo1Iu")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("2Bh8z"),
                    $bc91821d19c5f46d$var$load("kvRbA"),
                    $bc91821d19c5f46d$var$load("ffQaD")
                ]);
            }, function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("5ERkJ")
                ]);
            }),
            (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("w71gM"),
                    $bc91821d19c5f46d$var$load("kvRbA"),
                    $bc91821d19c5f46d$var$load("ffQaD"),
                    $bc91821d19c5f46d$var$load("l253H"),
                    $bc91821d19c5f46d$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("2EwqZ")
                ]);
            }),
            (parcelRequire("g81qY"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("6u1ax"),
                    $bc91821d19c5f46d$var$load("kvRbA"),
                    $bc91821d19c5f46d$var$load("ffQaD"),
                    $bc91821d19c5f46d$var$load("l253H"),
                    $bc91821d19c5f46d$var$load("76n7a"),
                    $bc91821d19c5f46d$var$load("kNFvF"),
                    $bc91821d19c5f46d$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("enrdU")
                ]);
            }),
            $bc91821d19c5f46d$var$load("2tXQt")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_amplitude_sr', function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("5g4nt"),
            $bc91821d19c5f46d$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("j3b6X")
        ]);
    }),
    (parcelRequire("g81qY"))('jiv-20455-dev-panel-to-sync', function() {
        return Promise.all([
            (parcelRequire("g81qY"))('jiv-20508-remove-height-animation-dev-panel', function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("iQLT5")
                ]);
            }, function() {
                return Promise.all([]);
            }),
            (parcelRequire("g81qY"))('create-branch-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("uxIZU")
                ]);
            }, function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("hzpoZ")
                ]);
            }),
            (parcelRequire("g81qY"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("lOPFD")
                ]);
            }, function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("jjrrg")
                ]);
            }),
            (parcelRequire("g81qY"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("lOPFD")
                ]);
            }, function() {
                return Promise.all([
                    $bc91821d19c5f46d$var$load("jjrrg")
                ]);
            }),
            $bc91821d19c5f46d$var$load("d7W8O"),
            $bc91821d19c5f46d$var$load("kvRbA"),
            $bc91821d19c5f46d$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("7HlaD")
        ]);
    }),
    (parcelRequire("g81qY"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("9poB6")
        ]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("i4NG1")
        ]);
    }),
    (parcelRequire("g81qY"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("ltVCh")
        ]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("7BIsM")
        ]);
    }),
    (parcelRequire("g81qY"))('improve_issue_automation_button_iv_llc', function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("jteQo")
        ]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("6Ry6c"),
            $bc91821d19c5f46d$var$load("kvRbA"),
            $bc91821d19c5f46d$var$load("ffQaD")
        ]);
    }),
    (parcelRequire("g81qY"))('improve_issue_view_comment_ai', function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("8uOIl")
        ]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("eOwa8")
        ]);
    }),
    (parcelRequire("g81qY"))('jira_issue_next_best_actions_aa_fg', function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("9nhJS")
        ]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("asI48")
        ]);
    }),
    (parcelRequire("g81qY"))('issue_comment_reply_list_sync_import', function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("ej9s8")
        ]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("a3q1T")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("hb7LZ")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("hb7LZ")
        ]);
    }),
    (parcelRequire("g81qY"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $bc91821d19c5f46d$var$load("hb7LZ")
        ]);
    }),
    $bc91821d19c5f46d$var$load("isfJL"),
    $bc91821d19c5f46d$var$load("b3QiB"),
    $bc91821d19c5f46d$var$load("3yAl4"),
    $bc91821d19c5f46d$var$load("fliVL"),
    $bc91821d19c5f46d$var$load("7mIf9"),
    $bc91821d19c5f46d$var$load("jXweD"),
    $bc91821d19c5f46d$var$load("jbxE1"),
    $bc91821d19c5f46d$var$load("7imUH"),
    $bc91821d19c5f46d$var$load("ffQaD"),
    $bc91821d19c5f46d$var$load("kvRbA"),
    $bc91821d19c5f46d$var$load("kVX56"),
    $bc91821d19c5f46d$var$load("kNFvF"),
    $bc91821d19c5f46d$var$load("76n7a"),
    $bc91821d19c5f46d$var$load("l253H"),
    $bc91821d19c5f46d$var$load("lDuOD")
]).then(()=>parcelRequire('kq6nk'));

});


parcelRegister("1pLdk", function(module, exports) {

$parcel$export(module.exports, "SidebarIssueApp", () => $0186573994fd9b39$export$e402f7c18d4d7f37);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $d6KFY = parcelRequire("d6KFY");

var $ch9En = parcelRequire("ch9En");

var $4xbv3 = parcelRequire("4xbv3");

var $4FfIq = parcelRequire("4FfIq");

var $04oZl = parcelRequire("04oZl");
const $0186573994fd9b39$var$PACKAGE_NAME = 'jsmQueueAgentViewSidebar';
const $0186573994fd9b39$export$e402f7c18d4d7f37 = ({ analyticsSource: analyticsSource, issueKey: issueKey, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess, onChange: onChange })=>{
    const [currentIssueKey, setCurrentIssueKey] = (0, $eJOHy.useState)(issueKey);
    // @ts-expect-error - TS7031 - Binding element 'nextIssueKey' implicitly has an 'any' type.
    const onIssueKeyChange = (0, $eJOHy.useCallback)(({ toIssueKey: nextIssueKey })=>{
        setCurrentIssueKey(nextIssueKey);
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        setCurrentIssueKey(issueKey);
    }, [
        issueKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: $0186573994fd9b39$var$PACKAGE_NAME,
        attributes: {
            viewMode: 'SIDEBAR'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4FfIq.IssueViewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d6KFY.IssueBoundary), {
        packageName: $0186573994fd9b39$var$PACKAGE_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $04oZl.default), {
        viewModeOptions: {
            viewMode: 'SIDEBAR'
        },
        issueKey: currentIssueKey,
        analyticsSource: analyticsSource,
        shouldShowCloseButton: true,
        onClose: onClose,
        onIssueKeyChange: onIssueKeyChange,
        shouldSetInitialFocus: true,
        shouldShowRootProjectsBreadcrumb: true,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        isSpaEnabled: false,
        isLoadedWithPage: false,
        onChange: onChange
    }))));
};

});
parcelRegister("d6KFY", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $124bf401a6603e60$export$fbf48ede0cf52b5a);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $dBLLk = parcelRequire("dBLLk");

var $ch9En = parcelRequire("ch9En");

var $4FfIq = parcelRequire("4FfIq");
const $124bf401a6603e60$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4FfIq.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $124bf401a6603e60$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dBLLk.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4FfIq.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("dBLLk", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $499cc98a8c07c323$export$c3f500e812fb1bb3);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $1qbKn = parcelRequire("1qbKn");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");
const $499cc98a8c07c323$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eJOHy.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: id,
        fallback: fallback
    }, children));
};

});
parcelRegister("eK5AI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c5afae322a0f6fe$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6uWhG = parcelRequire("6uWhG");
const $7c5afae322a0f6fe$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
    const renderRef = (0, $eJOHy.useRef)(false);
    if (!renderRef.current) {
        renderRef.current = true;
        (0, $6uWhG.setMark)(metricKey);
        onSet && onSet();
    }
    return null;
};
var $7c5afae322a0f6fe$export$2e2bcd8739ae039 = $7c5afae322a0f6fe$var$PerformanceMark;

});


parcelRegister("4FfIq", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $68e48e1970e78876$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $biWZb = parcelRequire("biWZb");

var $hwuZ0 = parcelRequire("hwuZ0");

var $4h5lX = parcelRequire("4h5lX");
const $68e48e1970e78876$var$fullpageStyles = null;
const $68e48e1970e78876$var$modalStyles = null;
const $68e48e1970e78876$var$customSpacingStyles = null;
const $68e48e1970e78876$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        $68e48e1970e78876$var$customSpacingStyles,
        isEmbedView !== true && isModalView !== true ? $68e48e1970e78876$var$fullpageStyles : null,
        isModalView === true ? $68e48e1970e78876$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biWZb.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hwuZ0.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4h5lX))),
        className: (0, $hcewu.default)([
            "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("biWZb", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $b77d47f9e4eb67f9$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $b77d47f9e4eb67f9$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $b77d47f9e4eb67f9$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");


var $8BpnG = parcelRequire("8BpnG");

var $gCY1z = parcelRequire("gCY1z");

var $coXKe = parcelRequire("coXKe");

var $cZpx8 = parcelRequire("cZpx8");
const $b77d47f9e4eb67f9$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const { Provider: $b77d47f9e4eb67f9$var$Provider, Consumer: $b77d47f9e4eb67f9$var$Consumer } = $b77d47f9e4eb67f9$export$37eeac5cc5245b18;
const $b77d47f9e4eb67f9$export$55a90a8e865a39b5 = 700;
const $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$b77d47f9e4eb67f9$export$55a90a8e865a39b5}px)`;
const $b77d47f9e4eb67f9$export$ddd398a95f85cd75 = 850;
const $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL = `(max-width: ${$b77d47f9e4eb67f9$export$ddd398a95f85cd75}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $b77d47f9e4eb67f9$var$useRouteKey() {
    const [routeState] = (0, $gCY1z.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $b77d47f9e4eb67f9$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $b77d47f9e4eb67f9$var$useRouteKey();
    (0, $cZpx8.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $cZpx8.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $548198843509795c$export$ee15e0cd1efafcb4);
        (0, $cZpx8.setCachedIsCompactValue)(defaultState, key);
    }
    const { isInDiscussionLayoutExperiment: isInDiscussionLayoutExperiment } = (0, $coXKe.useUserPreferredWorkItemLayout)();
    const query = isInDiscussionLayoutExperiment ? $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL : $b77d47f9e4eb67f9$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY;
    const [isCompact, setIsCompact] = (0, $eJOHy.useState)(defaultState);
    const onChange = (0, $fAZgY.useCallbackWithCondition)((state)=>{
        (0, $cZpx8.setCachedIsCompactValue)(state, key);
        setIsCompact(state);
    }, [
        key
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b77d47f9e4eb67f9$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8BpnG.ContainerQueryObserver), {
        query: query,
        onChange: onChange,
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b77d47f9e4eb67f9$var$Provider, {
        value: isCompact
    }, children));
};
const $b77d47f9e4eb67f9$export$20feb77b5b617e44 = $b77d47f9e4eb67f9$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b77d47f9e4eb67f9$var$StyledWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $548198843509795c$export$ee15e0cd1efafcb4 = false;

parcelRegister("8BpnG", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $b45aeffccc0e4b84$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $b45aeffccc0e4b84$var$QueryContext = /*#__PURE__*/ (0, $eJOHy.createContext)(undefined);
let $b45aeffccc0e4b84$var$currentIdSeed = 0;
function $b45aeffccc0e4b84$var$generateAttributeValue() {
    return `indicator-span-${$b45aeffccc0e4b84$var$currentIdSeed++}`;
}
function $b45aeffccc0e4b84$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $548198843509795c$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $eJOHy.useState)(defaultState);
    const handleQueryStatusChange = (0, $eJOHy.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $b45aeffccc0e4b84$export$b66a67697973e01() {
    const currentState = (0, $eJOHy.useContext)($b45aeffccc0e4b84$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $b45aeffccc0e4b84$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $eJOHy.useMemo)(()=>$b45aeffccc0e4b84$var$generateAttributeValue(), []);
    const spanRef = (0, $eJOHy.useRef)(null);
    const containerRef = (0, $eJOHy.useRef)(null);
    const currentState = $b45aeffccc0e4b84$export$b66a67697973e01();
    (0, $eJOHy.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b45aeffccc0e4b84$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b45aeffccc0e4b84$var$ContainerToBeQueried = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("coXKe", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainers", () => $3b984a26137eed7b$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $3b984a26137eed7b$export$5f49a43487b268);
$parcel$export(module.exports, "useLayoutContainerByTypeMemoised", () => $3b984a26137eed7b$export$ef5966e43b13b4a9);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $3b984a26137eed7b$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $3b984a26137eed7b$export$5962da0433486667);
$parcel$export(module.exports, "useUserPreferredWorkItemLayout", () => $3b984a26137eed7b$export$9889eea62fdfa091);
$parcel$export(module.exports, "useIssueLayoutActions", () => $3b984a26137eed7b$export$1e5e9fc877a47cd9);

var $eJOHy = parcelRequire("eJOHy");

var $fAZgY = parcelRequire("fAZgY");

var $pz0Wh = parcelRequire("pz0Wh");

var $epTsa = parcelRequire("epTsa");

var $cs58I = parcelRequire("cs58I");

var $hbF3h = parcelRequire("hbF3h");

var $bmoS1 = parcelRequire("bmoS1");


var $bNexr = parcelRequire("bNexr");

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");

var $eSnSE = parcelRequire("eSnSE");

var $l7Alo = parcelRequire("l7Alo");

var $lpEwy = parcelRequire("lpEwy");

var $co62F = parcelRequire("co62F");
const $3b984a26137eed7b$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $3b984a26137eed7b$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
        ], [
        container?.items.nodes,
        fieldsHiddenByUim
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $3b984a26137eed7b$export$ef5966e43b13b4a9 = (issueKey, type)=>{
    const [containers] = (0, $lpEwy.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    const fieldsHiddenByUim = (0, $pz0Wh.useEnabledHiddenFields)();
    const filteredItems = (0, $eJOHy.useMemo)(()=>{
        return (0, $co62F.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim);
    }, [
        container,
        fieldsHiddenByUim
    ]);
    return [
        filteredItems
    ];
};
const $3b984a26137eed7b$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $lpEwy.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $3b984a26137eed7b$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $lpEwy.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $a85d9f0dd63c9b50$export$39aaf586c7ee5202));
    const isMobile = (0, $l7Alo.default)();
    try {
        if (!(0, $7jTnu.fg)('issue_view_layout_experiment_feature_gate')) {
            if ((0, $7jTnu.fg)('thor_layouts_splunk_logs_enable')) (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `useUserPreferredWorkItemLayout: Kill switch is off with flag values: ${JSON.stringify({
                isMobile: isMobile,
                isFullIssueView: isFullIssueView,
                projectType: projectType,
                isIssueKeyNull: issueKey === null,
                isProjectKeyNull: projectKey === null,
                isProjectTypeNull: projectType === null,
                isWideLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
                isDiscussionLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
            })}`);
            return {
                isInDiscussionLayoutExperiment: false,
                isInWideLayoutExperiment: false,
                isInLayoutExperiment: false,
                isActivityInVerticalSidePanel: false,
                userPreferredLayout: null
            };
        }
        const isSoftwareOrBusiness = projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        if (userLayoutType === null && ((0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false) || (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false)) && (0, $7jTnu.fg)('thor_layouts_splunk_logs_enable')) (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `useUserPreferredWorkItemLayout: User layout type parsing: ${JSON.stringify({
            userPreferredLayout: userPreferredLayout,
            userLayoutType: userLayoutType,
            isMobile: isMobile,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            isSoftwareOrBusiness: isSoftwareOrBusiness,
            isFullIssueView: isFullIssueView,
            isWideLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isDiscussionLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        let userSelectedLayout = userLayoutType;
        if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
        if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        if (userSelectedLayout === null && ((0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false) || (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false)) && (0, $7jTnu.fg)('thor_layouts_splunk_logs_enable')) (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `useUserPreferredWorkItemLayout: User selected layout parsing: ${JSON.stringify({
            userSelectedLayout: userSelectedLayout,
            isInLayoutExperiment: isInLayoutExperiment,
            isMobile: isMobile,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            isSoftwareOrBusiness: isSoftwareOrBusiness,
            isFullIssueView: isFullIssueView,
            isWideLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isDiscussionLayoutEnabled: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${JSON.stringify({
            error: error,
            isMobile: isMobile,
            isFullIssueView: isFullIssueView,
            isIssueKeyNull: issueKey === null,
            isProjectKeyNull: projectKey === null,
            isProjectTypeNull: projectType === null,
            isInWideLayoutExperiment: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false),
            isInDiscussionLayoutExperiment: (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false)
        })}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff = ()=>{
    try {
        if (!(0, $7jTnu.fg)('issue_view_layout_experiment_feature_gate')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        // eslint-disable-next-line react-hooks/react-compiler
        /* eslint-disable react-hooks/rules-of-hooks */ const issueKey = (0, $bmoS1.useIssueKey)();
        const projectKey = (0, $bNexr.useProjectKey)(issueKey);
        const projectType = (0, $bNexr.useProjectType)(projectKey);
        const isFullIssueView = (0, $bmoS1.useIsFullPageIssueView)();
        const [userPreferredLayout] = (0, $cs58I.useUserPreferencesValue)((0, $a85d9f0dd63c9b50$export$39aaf586c7ee5202));
        const isMobile = (0, $l7Alo.default)();
        const isSoftwareOrBusiness = projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isWideLayoutEnabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $epTsa.expVal)('issue_view_layout_experiment', 'isDiscussionLayoutEnabled', false);
        const isInLayoutExperiment = isInWideLayoutExperiment || isInDiscussionLayoutExperiment;
        const userLayoutType = isInLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        /* eslint-enable react-hooks/rules-of-hooks */ let userSelectedLayout = userLayoutType;
        if (isInLayoutExperiment && isInDiscussionLayoutExperiment && userLayoutType === 'WIDE') userSelectedLayout = 'STANDARD';
        if (isInLayoutExperiment && isInWideLayoutExperiment && userLayoutType === 'DISCUSSION') userSelectedLayout = 'STANDARD';
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && userSelectedLayout === 'DISCUSSION';
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            isInLayoutExperiment: Boolean(isInLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${error}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isInLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $3b984a26137eed7b$export$9889eea62fdfa091 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('issue_layout_rule_of_hook_fix'), $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOn, $3b984a26137eed7b$var$useUserPreferredWorkItemLayoutwithFFOff);
const $3b984a26137eed7b$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $lpEwy.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $eJOHy.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $eJOHy.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $eJOHy.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};

});
parcelRegister("pz0Wh", function(module, exports) {

$parcel$export(module.exports, "useEnabledHiddenFields", () => $437c493a8e065bc6$export$bb6c2b9159c3f32b);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $i7n3g = parcelRequire("i7n3g");

var $4Swsy = parcelRequire("4Swsy");
const $437c493a8e065bc6$export$bb6c2b9159c3f32b = ()=>{
    (0, $gRw8I.di)((0, $i7n3g.useAdjustmentsEnabled), (0, $4Swsy.useHiddenFields));
    const adjustmentsAreEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const hiddenFields = (0, $4Swsy.useHiddenFields)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("i7n3g", function(module, exports) {

$parcel$export(module.exports, "store", () => $35b1fa370eb6f514$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $35b1fa370eb6f514$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $35b1fa370eb6f514$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $35b1fa370eb6f514$export$5eb9c167b683d125);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $35b1fa370eb6f514$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $35b1fa370eb6f514$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($35b1fa370eb6f514$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $35b1fa370eb6f514$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-adjustments-context',
    initialState: $35b1fa370eb6f514$var$initialState,
    actions: $35b1fa370eb6f514$export$e324594224ef24da
});
const $35b1fa370eb6f514$export$a12f82a132dee079 = (0, $iJq0l.createHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$358ad850b2f6d6fe = (0, $iJq0l.createStateHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $35b1fa370eb6f514$export$4f2729981f4b81d2 = (0, $iJq0l.createActionsHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$5eb9c167b683d125 = (0, $6E16M.createContainer)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("4Swsy", function(module, exports) {

$parcel$export(module.exports, "useHiddenFields", () => $8e2f20b0b0e23b91$export$de6fdc67c945e596);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $ixrOr = parcelRequire("ixrOr");
const $8e2f20b0b0e23b91$var$selectHiddenFields = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8e2f20b0b0e23b91$export$de6fdc67c945e596 = (0, $iJq0l.createStateHook)((0, $ixrOr.store), {
    selector: $8e2f20b0b0e23b91$var$selectHiddenFields
});

});
parcelRegister("ixrOr", function(module, exports) {

$parcel$export(module.exports, "store", () => $3142574379bc5921$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $3142574379bc5921$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $3142574379bc5921$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $3142574379bc5921$export$677b3e34bd14c681);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4XahM = parcelRequire("4XahM");

var $4CM51 = parcelRequire("4CM51");

var $aub9z = parcelRequire("aub9z");

var $cJU1r = parcelRequire("cJU1r");

var $2A1rz = parcelRequire("2A1rz");

var $jfSsT = parcelRequire("jfSsT");

var $hUz0e = parcelRequire("hUz0e");

var $8ZmJu = parcelRequire("8ZmJu");

var $cXMA2 = parcelRequire("cXMA2");

var $5qpxn = parcelRequire("5qpxn");

var $9w3dh = parcelRequire("9w3dh");

var $fkUIk = parcelRequire("fkUIk");

var $bfBqP = parcelRequire("bfBqP");

var $fY47y = parcelRequire("fY47y");

var $dmz3j = parcelRequire("dmz3j");
const $3142574379bc5921$var$name = 'issue-adjustments';
const $3142574379bc5921$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $3142574379bc5921$var$triggerFieldInitializationKey, viewType: $3142574379bc5921$var$scopedViewType, numberOfSupportedFields: $3142574379bc5921$var$numberOfSupportedFields, ...$3142574379bc5921$var$stateForResetAllFields } = $3142574379bc5921$export$d4c72bab9d6cc13a;
const $3142574379bc5921$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $5qpxn.processChange,
    setFieldValue: $fkUIk.setFieldValue,
    initializeField: $jfSsT.initializeField,
    initializeFields: $jfSsT.initializeFields,
    startFieldsInitialisationTimeout: $2A1rz.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $2A1rz.successFieldsInitalisation,
    registerFields: $9w3dh.registerFields,
    unregisterFields: $9w3dh.unregisterFields,
    updateFields: $fY47y.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($3142574379bc5921$var$stateForResetAllFields);
        },
    setError: $cJU1r.setError,
    resetError: $cJU1r.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $4XahM.setAppErrors,
    resetAppErrors: $4XahM.resetAppErrors,
    addAppsErrors: $4XahM.addAppsErrors,
    initializeNoScreenTab: $hUz0e.initializeNoScreenTab,
    initializeScreenTabs: $8ZmJu.initializeScreenTabs,
    updateScreenTabs: $dmz3j.updateScreenTabs,
    updateActiveScreenTab: $bfBqP.updateActiveScreenTab,
    detectAppliedChangesConflicts: $4CM51.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $aub9z.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $aub9z.collectFieldsAppliedChangesHistory,
    setNotification: $cXMA2.setNotification,
    resetNotification: $cXMA2.resetNotification
};
const $3142574379bc5921$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: $3142574379bc5921$var$name,
    initialState: $3142574379bc5921$export$d4c72bab9d6cc13a,
    actions: $3142574379bc5921$export$e324594224ef24da
});
const $3142574379bc5921$export$37792a602e748c08 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$var$stableEmptyFieldFromIframe = {};
const $3142574379bc5921$export$c76e674a29843e21 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $3142574379bc5921$export$df4b0714e8177e0e = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $3142574379bc5921$var$stableEmptyFieldFromIframe
});
const $3142574379bc5921$export$cb9a014ec14556d8 = (0, $iJq0l.createActionsHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$export$677b3e34bd14c681 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("4XahM", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $5579267a84760bc0$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $5579267a84760bc0$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $5579267a84760bc0$export$24c821207687a907);
const $5579267a84760bc0$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $5579267a84760bc0$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $5579267a84760bc0$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("4CM51", function(module, exports) {

$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $8731ff5311f46f9c$export$90d94f20d157e756);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $4XahM = parcelRequire("4XahM");

var $cXMA2 = parcelRequire("cXMA2");

var $7Agw7 = parcelRequire("7Agw7");
const $8731ff5311f46f9c$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $8731ff5311f46f9c$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $8731ff5311f46f9c$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $e65702a72ab5ec3d$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $7Agw7.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $4XahM.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $cXMA2.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("jgvEH", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $cbc5413d6b6dbcfa$export$a1fb57756f0de62b);

var $5fWw9 = parcelRequire("5fWw9");


const $cbc5413d6b6dbcfa$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $5fWw9.default)((0, $0390845c0b61b1a1$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $e9db81972dce4ebc$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

const $0390845c0b61b1a1$export$8280e5c6104c5b40 = 'ui-modifications';


const $e65702a72ab5ec3d$export$415cc1afa6445f90 = 'onInitChangeId';
const $e65702a72ab5ec3d$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("cXMA2", function(module, exports) {

$parcel$export(module.exports, "setNotification", () => $c89e780a89ca3c37$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $c89e780a89ca3c37$export$caafa3945f199bc7);
const $c89e780a89ca3c37$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $c89e780a89ca3c37$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("7Agw7", function(module, exports) {

$parcel$export(module.exports, "collectConflicts", () => $6ecf22ae7e9f4956$export$a06103ec99e4e394);

var $jFHCE = parcelRequire("jFHCE");


var $5sAot = parcelRequire("5sAot");

const $6ecf22ae7e9f4956$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $6ecf22ae7e9f4956$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $702a64456849b1c0$export$f674b7a3bbd94b5)) return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $5sAot.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $6ecf22ae7e9f4956$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $6ecf22ae7e9f4956$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $585e8f7167f61808$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $585e8f7167f61808$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $585e8f7167f61808$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $585e8f7167f61808$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $585e8f7167f61808$export$e4ac32edd5da2ee7 = 'FIELD';
const $585e8f7167f61808$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("5sAot", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $2728f69de31c50a0$export$e1cc7da28a1c4bb7);
const $2728f69de31c50a0$var$SET_NAME_METHOD = 'setName';
const $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $2728f69de31c50a0$var$SET_VISIBLE_METHOD = 'setVisible';
const $2728f69de31c50a0$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $2728f69de31c50a0$var$SET_VALUE_METHOD = 'setValue';
const $2728f69de31c50a0$var$SET_REQUIRED_METHOD = 'setRequired';
const $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $2728f69de31c50a0$export$8325709d137b2606 = {
    fieldName: $2728f69de31c50a0$var$SET_NAME_METHOD,
    description: $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD,
    isVisible: $2728f69de31c50a0$var$SET_VISIBLE_METHOD,
    isReadOnly: $2728f69de31c50a0$var$SET_READ_ONLY_METHOD,
    value: $2728f69de31c50a0$var$SET_VALUE_METHOD,
    isRequired: $2728f69de31c50a0$var$SET_REQUIRED_METHOD,
    optionsVisibility: $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $2728f69de31c50a0$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $2728f69de31c50a0$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $702a64456849b1c0$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $702a64456849b1c0$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("aub9z", function(module, exports) {

$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $94bb1a042906c320$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $94bb1a042906c320$export$7d0f534e5b16dcc9);


var $gD9lZ = parcelRequire("gD9lZ");
const $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $94bb1a042906c320$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $702a64456849b1c0$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $94bb1a042906c320$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $gD9lZ.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("gD9lZ", function(module, exports) {

$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $b80c31bd414cd9d4$export$8a23b3e9a1749620);

const $b80c31bd414cd9d4$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $702a64456849b1c0$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $b80c31bd414cd9d4$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $b80c31bd414cd9d4$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("cJU1r", function(module, exports) {

$parcel$export(module.exports, "setError", () => $60a309f31f0bb435$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $60a309f31f0bb435$export$7e5930c6217b1d4e);
const $60a309f31f0bb435$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $60a309f31f0bb435$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("2A1rz", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $601c25cd313fe741$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $601c25cd313fe741$export$cf768a695e83eefa);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");

var $ieQ0v = parcelRequire("ieQ0v");

var $cJU1r = parcelRequire("cJU1r");
const $601c25cd313fe741$var$getTimeout = ()=>50000;
const $601c25cd313fe741$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $601c25cd313fe741$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $601c25cd313fe741$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($601c25cd313fe741$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $601c25cd313fe741$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $601c25cd313fe741$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status) || (0, $ieQ0v.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $cJU1r.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $601c25cd313fe741$var$getTimeout(),
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $601c25cd313fe741$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("ieQ0v", function(module, exports) {

$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $d3350efc4111ec81$export$4cadeedb8c3f31f7);

var $4MchI = parcelRequire("4MchI");
const $d3350efc4111ec81$export$4cadeedb8c3f31f7 = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("jfSsT", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $a40b94674a995fd7$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $a40b94674a995fd7$export$4a6b4707110b0552);

var $37MnT = parcelRequire("37MnT");
const $a40b94674a995fd7$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $a40b94674a995fd7$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("37MnT", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $cc8ab347810a3948$export$50806045b617d116);

var $gRw8I = parcelRequire("gRw8I");

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $cc8ab347810a3948$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gRw8I.di)((0, $1qarT.fireErrorAnalytics), (0, $82wKS.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $1qarT.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("1qarT", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $7486f28a569b9ec0$export$a27c21aa3ed8f0f1);

var $7U6OJ = parcelRequire("7U6OJ");

var $cMdIN = parcelRequire("cMdIN");
const $7486f28a569b9ec0$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $7486f28a569b9ec0$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $cMdIN.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $7U6OJ.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $7486f28a569b9ec0$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("cMdIN", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $c511a0dff3897a12$export$e19f9f08a6d79fd2);

var $l58EO = parcelRequire("l58EO");
const $c511a0dff3897a12$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $c511a0dff3897a12$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $c511a0dff3897a12$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $c511a0dff3897a12$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $c511a0dff3897a12$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $c511a0dff3897a12$export$89a175d4190df42e = 'Invoke value functions failed:';
const $c511a0dff3897a12$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $c511a0dff3897a12$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $c511a0dff3897a12$var$BAD_REQUEST = 400;
const $c511a0dff3897a12$var$REQUEST_TIMEOUT = 408;
const $c511a0dff3897a12$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $c511a0dff3897a12$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $c511a0dff3897a12$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($c511a0dff3897a12$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $c511a0dff3897a12$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($c511a0dff3897a12$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($c511a0dff3897a12$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($c511a0dff3897a12$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $l58EO.isClientFetchError)(error)) return $c511a0dff3897a12$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("l58EO", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $cd5265fc67dbb6eb$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cd5265fc67dbb6eb$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cd5265fc67dbb6eb$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cd5265fc67dbb6eb$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cd5265fc67dbb6eb$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cd5265fc67dbb6eb$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.cause.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("82wKS", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $0757a5b98ef450f3$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $0757a5b98ef450f3$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $0757a5b98ef450f3$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $0757a5b98ef450f3$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $0757a5b98ef450f3$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $0757a5b98ef450f3$export$ef45e4471aa21b27);

var $1qarT = parcelRequire("1qarT");

var $6beFf = parcelRequire("6beFf");
const $0757a5b98ef450f3$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $0757a5b98ef450f3$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $6beFf.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $0757a5b98ef450f3$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$0757a5b98ef450f3$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $1qarT.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $0757a5b98ef450f3$export$e4330d77fd93d1de = (viewType)=>$0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $0757a5b98ef450f3$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $0757a5b98ef450f3$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $0757a5b98ef450f3$export$20eabd2b3ada6bf3(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $0757a5b98ef450f3$export$b768d6a95f7a930(context) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $0757a5b98ef450f3$export$b0297573c90085aa(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $0757a5b98ef450f3$export$c0728caa743a409e(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $0757a5b98ef450f3$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $0757a5b98ef450f3$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("6beFf", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $9cd8cd98b7c2eeee$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");
const $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS = new Map();
const $9cd8cd98b7c2eeee$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.has(viewType)) $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $9cd8cd98b7c2eeee$export$176b6e68da08ffa2 = (viewType)=>$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.get(viewType);
const $9cd8cd98b7c2eeee$export$e8091eff40c4f16e = ()=>{
    $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.clear();
};
const $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gRw8I.di)($9cd8cd98b7c2eeee$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $eJOHy.useState)(()=>{
        $9cd8cd98b7c2eeee$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("hUz0e", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $7faac090c61abadc$export$93459ad9bfd6c380);
const $7faac090c61abadc$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("8ZmJu", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $5faefcecd8cba222$export$7f7be235f64f029b);
const $5faefcecd8cba222$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("5qpxn", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $bbbbfc09b273134e$export$352dfcce04d66748);

var $9UJzd = parcelRequire("9UJzd");

var $gRw8I = parcelRequire("gRw8I");

var $82wKS = parcelRequire("82wKS");

var $5ldku = parcelRequire("5ldku");
const $bbbbfc09b273134e$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($9UJzd))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($9UJzd)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("9UJzd", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/** Used to generate unique IDs. */ var $737cb0a939387270$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $737cb0a939387270$var$uniqueId(prefix) {
    var id = ++$737cb0a939387270$var$idCounter;
    return $cz1WF(prefix) + id;
}
module.exports = $737cb0a939387270$var$uniqueId;

});

parcelRegister("5ldku", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0);

var $cSmYj = parcelRequire("cSmYj");

var $37MnT = parcelRequire("37MnT");
const $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("9w3dh", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $60e092cfdd3e6be9$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $60e092cfdd3e6be9$export$1ca69a85bb7273de);

var $jFHCE = parcelRequire("jFHCE");

var $jvwCK = parcelRequire("jvwCK");
const $60e092cfdd3e6be9$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $60e092cfdd3e6be9$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("fkUIk", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $adb039aa861139a2$export$6556d46d2662453c);

var $5ldku = parcelRequire("5ldku");
const $adb039aa861139a2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("bfBqP", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $910f8611d1056e54$export$21363496760d39cd);
const $910f8611d1056e54$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("fY47y", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $e5c83e79d4f29b58$export$cceae62fd4d1ef0a);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $81O8J = parcelRequire("81O8J");

var $cfL5m = parcelRequire("cfL5m");

var $3JMvu = parcelRequire("3JMvu");

var $82idB = parcelRequire("82idB");

var $lKslV = parcelRequire("lKslV");

var $4XahM = parcelRequire("4XahM");

var $aub9z = parcelRequire("aub9z");

var $TiFiE = parcelRequire("TiFiE");
const $e5c83e79d4f29b58$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $aub9z.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $cfL5m.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $4XahM.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $7f80bdb4337734ff$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $7f80bdb4337734ff$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $TiFiE.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $lKslV.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $3JMvu.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(errorsByField)) throw new (0, $81O8J.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $82idB.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $aub9z.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $7f80bdb4337734ff$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $7f80bdb4337734ff$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $7f80bdb4337734ff$export$f5d5f6bb902f1027 = '-1';
const $7f80bdb4337734ff$export$106087dcfd4fb129 = 100;

parcelRegister("81O8J", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $b784ee4f71bce498$export$9e8b5e552e255163);

var $607Dw = parcelRequire("607Dw");
class $b784ee4f71bce498$export$9e8b5e552e255163 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("607Dw", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $8683b9e27ffb2718$export$6e8165c81a6a65df);
class $8683b9e27ffb2718$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("cfL5m", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegistered", () => $84902f345f4d9ec2$export$fbe9157c12cb4e7b);
const $84902f345f4d9ec2$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("3JMvu", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $7a07bba1139035a5$export$460820f27643954e);

var $82wKS = parcelRequire("82wKS");
const $7a07bba1139035a5$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("82idB", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $b396c3e05312c1f7$export$e1fce51bc5be90b7);
const $b396c3e05312c1f7$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("lKslV", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $fb1c6d2f11d8a679$export$aa453854f74fab);

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $fb1c6d2f11d8a679$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("TiFiE", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $0fdd9846971f3713$export$d14f85c01e334a1);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $6rtzq = parcelRequire("6rtzq");

var $82wKS = parcelRequire("82wKS");


var $5sAot = parcelRequire("5sAot");

var $gOp4r = parcelRequire("gOp4r");

var $i9dWk = parcelRequire("i9dWk");
const $0fdd9846971f3713$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gRw8I.di)((0, $82wKS.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $gOp4r.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $gOp4r.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $6rtzq.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $585e8f7167f61808$export$d1996cb46a690190),
                        method: (0, $5sAot.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $i9dWk.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $i9dWk.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("6rtzq", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a);
class $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("gOp4r", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $af0c126b48130091$export$ee79e3ab53b8db79);
const $af0c126b48130091$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("i9dWk", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $d76dab7db88ac392$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $d76dab7db88ac392$export$ddd005554aecd409);
const $d76dab7db88ac392$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $d76dab7db88ac392$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("dmz3j", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $d4a266f6d4506eb1$export$131c67fd312b8a11);

var $gRw8I = parcelRequire("gRw8I");

var $9WNAv = parcelRequire("9WNAv");

var $iGhbB = parcelRequire("iGhbB");

var $aub9z = parcelRequire("aub9z");

var $2TFQ7 = parcelRequire("2TFQ7");
const $d4a266f6d4506eb1$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gRw8I.di)((0, $aub9z.collectScreenTabsAppliedChangesHistory), (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $2TFQ7.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $2TFQ7.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $aub9z.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $9WNAv.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $iGhbB.toScreenTabsValidationError))
        });
    };

});
parcelRegister("9WNAv", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $5a1018b8bae0ac45$export$faf1f1824ee0a136);

var $607Dw = parcelRequire("607Dw");
class $5a1018b8bae0ac45$export$faf1f1824ee0a136 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("iGhbB", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $609355188438e567$export$b2675440ade984fb);

const $609355188438e567$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $585e8f7167f61808$export$fd26696d109785a0)
    });

});

parcelRegister("2TFQ7", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $e157d25468b560b0$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $e157d25468b560b0$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $e157d25468b560b0$export$62d63af83dac7315);
const $e157d25468b560b0$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $e157d25468b560b0$var$isValidScreenTabId = (internalScreenTabs, id)=>$e157d25468b560b0$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $e157d25468b560b0$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, id) && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && $e157d25468b560b0$var$isValidScreenTabIsActive(isActive);
const $e157d25468b560b0$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $e157d25468b560b0$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $e157d25468b560b0$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $e157d25468b560b0$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("cs58I", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesValue", () => $22623340bdbf14f6$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $22623340bdbf14f6$export$eefe4b2985e8203e);

var $eJOHy = parcelRequire("eJOHy");

var $jkWf0 = parcelRequire("jkWf0");

var $etbP7 = parcelRequire("etbP7");
const $22623340bdbf14f6$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $jkWf0.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $eJOHy.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, newValue);
    }, [
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $eJOHy.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
    }, [
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    const setUserPreferences = (0, $eJOHy.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue
        }), [
        setValue,
        deleteValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $22623340bdbf14f6$export$eefe4b2985e8203e = ()=>{
    const [, actions] = (0, $jkWf0.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $eJOHy.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $etbP7.saveUserPreferenceValue)(userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $etbP7.removeUserPreferenceValue)(userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("jkWf0", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $97758271cd46a4b8$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $97758271cd46a4b8$export$4d156074562bac9a);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $i64h0 = parcelRequire("i64h0");
const $97758271cd46a4b8$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $i64h0.actions
});
const $97758271cd46a4b8$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $97758271cd46a4b8$export$46e7eeb2fc34fab8 = (0, $iJq0l.createHook)($97758271cd46a4b8$export$6f57813fe9f31bf9, {
    selector: $97758271cd46a4b8$var$getUserPreference
});
const $97758271cd46a4b8$export$4d156074562bac9a = (0, $iJq0l.createHook)($97758271cd46a4b8$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("i64h0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $343d470acbc8bd87$export$e324594224ef24da);
const $343d470acbc8bd87$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $343d470acbc8bd87$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $343d470acbc8bd87$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $343d470acbc8bd87$export$df0a4f67b9888111 = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $343d470acbc8bd87$export$e324594224ef24da = {
    setUserPreferenceValue: $343d470acbc8bd87$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $343d470acbc8bd87$var$deleteUserPreferenceValue,
    setUserPreferences: $343d470acbc8bd87$var$setUserPreferences,
    getUserPreferenceValue: $343d470acbc8bd87$export$df0a4f67b9888111
};

});


parcelRegister("etbP7", function(module, exports) {

$parcel$export(module.exports, "saveUserPreferenceValue", () => $a9cf1c440643deff$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $a9cf1c440643deff$export$a60a810760d07867);

var $jGzN3 = parcelRequire("jGzN3");
const $a9cf1c440643deff$export$bebe1b9e9f4cbf16 = async (userPreferenceKey, value)=>(0, $jGzN3.performPutRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    });
const $a9cf1c440643deff$export$a60a810760d07867 = async (userPreferenceKey)=>(0, $jGzN3.performDeleteRequest)(`/rest/api/2/mypreferences?key=${userPreferenceKey}`);

});


const $a85d9f0dd63c9b50$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $a85d9f0dd63c9b50$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $a85d9f0dd63c9b50$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $a85d9f0dd63c9b50$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $a85d9f0dd63c9b50$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $a85d9f0dd63c9b50$export$39aaf586c7ee5202 = 'jira.user.issue.user-preferred-layouts';
const $a85d9f0dd63c9b50$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $a85d9f0dd63c9b50$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $a85d9f0dd63c9b50$export$1a08240e14f65aa = 'jira.user.issue.collapsible-sections-state';
const $a85d9f0dd63c9b50$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("lpEwy", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $e029db5d7fe89f63$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $e029db5d7fe89f63$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $e029db5d7fe89f63$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $e029db5d7fe89f63$export$5513f3c310d101f5);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $5TQFX = parcelRequire("5TQFX");
const $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY = [];
const $e029db5d7fe89f63$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || $e029db5d7fe89f63$var$STABLE_EMPTY_CONTAINER_ARRAY;
const $e029db5d7fe89f63$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
const $e029db5d7fe89f63$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $5TQFX
});
const $e029db5d7fe89f63$export$5c4a1f63cea7b5b3 = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContainers
});
const $e029db5d7fe89f63$export$769bbe2bda9a43ce = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutGlance
});
const $e029db5d7fe89f63$export$3aa9017e11451546 = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: $e029db5d7fe89f63$var$getIssueViewLayoutContextPanel
});
const $e029db5d7fe89f63$export$5513f3c310d101f5 = (0, $iJq0l.createHook)($e029db5d7fe89f63$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("5TQFX", function(module, exports) {

$parcel$export(module.exports, "setIssueViewContainersLayout", () => $1fee7e98aeef55ea$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $1fee7e98aeef55ea$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $1fee7e98aeef55ea$export$9a04e4b958ebc410);
const $1fee7e98aeef55ea$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $1fee7e98aeef55ea$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $1fee7e98aeef55ea$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("co62F", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $f780ca908cc08c0e$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $f780ca908cc08c0e$export$355607dae809ec65);

var $5OyZl = parcelRequire("5OyZl");
const $f780ca908cc08c0e$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $5OyZl.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $5OyZl.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $5OyZl.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $f780ca908cc08c0e$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($f780ca908cc08c0e$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $5OyZl.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $f780ca908cc08c0e$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("5OyZl", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $37dff345eecb4f05$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $37dff345eecb4f05$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $37dff345eecb4f05$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $37dff345eecb4f05$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $37dff345eecb4f05$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $37dff345eecb4f05$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $37dff345eecb4f05$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $37dff345eecb4f05$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $37dff345eecb4f05$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $37dff345eecb4f05$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $37dff345eecb4f05$export$ad3536b13febb432);
const $37dff345eecb4f05$export$99ad62164189f781 = 'ecosystemGlance';
const $37dff345eecb4f05$export$7719ef6e9283671 = 'forgeGlance';
const $37dff345eecb4f05$export$bfebea5ce2e1887a = 'ecosystemContext';
const $37dff345eecb4f05$export$be8e68fb1aed253e = 'forgeContext';
const $37dff345eecb4f05$export$7bf561e6ab380ea1 = 'context';
const $37dff345eecb4f05$export$f42c11634d75863e = 'content';
const $37dff345eecb4f05$export$b38842736b6dbc1d = 'content-request';
const $37dff345eecb4f05$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_TYPE = 'FORGE';
const $37dff345eecb4f05$export$605c43f1b33ab69 = 'SUMMARY';
const $37dff345eecb4f05$export$e655b77b9efe622f = 'CustomItem';
const $37dff345eecb4f05$export$5cf403de05e9bea = 'FieldSectionItem';
const $37dff345eecb4f05$export$30f7f9a86f182492 = 'TabLayout';
const $37dff345eecb4f05$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $37dff345eecb4f05$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $37dff345eecb4f05$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $37dff345eecb4f05$export$ad3536b13febb432 = (node)=>node.type === $37dff345eecb4f05$export$5507f31126c8b283.tab;

});



parcelRegister("cZpx8", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $ae6f6bc492f6f5be$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $ae6f6bc492f6f5be$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $ae6f6bc492f6f5be$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $ae6f6bc492f6f5be$var$cachedIsCompactValues = {};
let $ae6f6bc492f6f5be$var$previousRouteKey;
function $ae6f6bc492f6f5be$export$c47621d55d10906c(key) {
    return $ae6f6bc492f6f5be$var$cachedIsCompactValues[key];
}
function $ae6f6bc492f6f5be$export$568b2dd75c2027b4(isCompactValue, key) {
    $ae6f6bc492f6f5be$var$cachedIsCompactValues[key] = isCompactValue;
}
function $ae6f6bc492f6f5be$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $ae6f6bc492f6f5be$var$previousRouteKey) {
        $ae6f6bc492f6f5be$var$previousRouteKey = currentRouteKey;
        delete $ae6f6bc492f6f5be$var$cachedIsCompactValues[$ae6f6bc492f6f5be$var$previousRouteKey];
    }
}

});


parcelRegister("4h5lX", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});




parcelRegister("b7U6N", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a97b07e397e2d73$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $6MdKZ = parcelRequire("6MdKZ");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $dhUMo = parcelRequire("dhUMo");

var $fRd3J = parcelRequire("fRd3J");
const $1a97b07e397e2d73$var$IS_DRAGGING_CLASS_NAME = 'ak-dnd-is-dragging';
const $1a97b07e397e2d73$var$Resizer = ({ parentWidth: parentWidth, children: children, onResize: onResize, setIsResizing: setIsResizing })=>{
    const [width, setWidth] = (0, $eJOHy.useState)(0);
    const buttonRef = (0, $eJOHy.useRef)(null);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const startX = (0, $eJOHy.useRef)(0);
    const extraWidth = (0, $eJOHy.useRef)(0);
    const onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(()=>{
        const newWidth = Math.max(parentWidth * (0, $fRd3J.getDetailViewWidthRatio)(), (0, $fRd3J.MIN_DETAILS_WIDTH_ISSUE));
        if (newWidth !== width) setWidth(newWidth);
    }, (0, $fRd3J.WINDOW_RESIZE_THROTTLE));
    (0, $eJOHy.useEffect)(()=>{
        setWidth(Math.max(parentWidth * (0, $fRd3J.getDetailViewWidthRatio)(), (0, $fRd3J.MIN_DETAILS_WIDTH_ISSUE)));
    }, [
        parentWidth
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', onWindowResize);
        onResize?.(width);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', onWindowResize);
        };
    }, [
        onResize,
        onWindowResize,
        width
    ]);
    const onMouseDown = (0, $6MdKZ.useEvent)((e)=>{
        startX.current = e.clientX + (width - (0, $fRd3J.MIN_DETAILS_WIDTH_ISSUE)); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mousemove', onMouseMove); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mouseup', onMouseUp);
        setIsResizing(true); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.classList.add($1a97b07e397e2d73$var$IS_DRAGGING_CLASS_NAME);
    });
    const onMouseMove = (0, $6MdKZ.useEvent)((e)=>{
        extraWidth.current = Math.max(startX.current - e.clientX, 0);
        const newWidth = Math.min((0, $fRd3J.MIN_DETAILS_WIDTH_ISSUE) + extraWidth.current, parentWidth / 2);
        if (newWidth !== width) setWidth(newWidth);
    });
    const onMouseUp = (0, $6MdKZ.useEvent)(()=>{
        startX.current = 0; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mousemove', onMouseMove); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mouseup', onMouseUp); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.classList.remove($1a97b07e397e2d73$var$IS_DRAGGING_CLASS_NAME);
        const widthRatio = width === (0, $fRd3J.MIN_DETAILS_WIDTH_ISSUE) ? 0 : width / parentWidth;
        (0, $fRd3J.setDetailViewWidthRatio)(widthRatio);
        setIsResizing(false);
    });
    (0, $eJOHy.useEffect)(()=>{
        if (buttonRef && buttonRef.current) setTimeout(()=>{
            buttonRef?.current?.focus();
        }, 100);
    }, [
        width,
        buttonRef
    ]);
    const handleKeyDown = (0, $6MdKZ.useEvent)((e)=>{
        const STEP = 10;
        let newWidth = width;
        const isLeftMove = e.key === 'ArrowLeft' || e.ctrlKey && e.altKey && e.key === 'ArrowLeft';
        const isRightMove = e.key === 'ArrowRight' || e.ctrlKey && e.altKey && e.key === 'ArrowRight';
        if (isLeftMove) {
            e.preventDefault();
            newWidth = Math.min(width + STEP, parentWidth / 2);
            setWidth(newWidth);
        } else if (isRightMove) {
            e.preventDefault();
            newWidth = Math.max(width - STEP, (0, $fRd3J.MIN_DETAILS_WIDTH_ISSUE));
            setWidth(newWidth);
        } else if (e.key === 'Home') {
            e.preventDefault();
            newWidth = (0, $fRd3J.MIN_DETAILS_WIDTH_ISSUE);
            setWidth(newWidth);
        } else if (e.key === 'End') {
            e.preventDefault();
            newWidth = parentWidth / 2;
            setWidth(newWidth);
        }
    });
    const ResizeHandleWithButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
            ref: ref,
            ...props,
            className: (0, $hcewu.default)([
                "_19itglyw _1ul9ftgi _80omuf7j _kqswh2mm _1wpz1fhb _bfhk18uv _qc5othzt _aetrb3bt _z0aiv77o _1qdgv47k _15l21ssb _clh31i34 _19do1b66 _18postnw _1hfkmuej _gcm1b29m _4tpub29m _1gvg1osq _1kmz1osq _y2mvugt7 _1bg4v77o"
            ])
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1a97b07e397e2d73$var$Container, {
        minWidth: width
    }, (0, $7jTnu.fg)('jsm_queue_a11y_improvement_batch3') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ResizeHandleWithButton, {
        ref: buttonRef,
        onMouseDown: onMouseDown,
        onKeyDown: handleKeyDown,
        role: "separator",
        tabIndex: 0,
        "aria-label": formatMessage((0, $dhUMo.default).resizePanelButton),
        "aria-valuemin": (0, $fRd3J.MIN_DETAILS_WIDTH_ISSUE),
        "aria-valuenow": width,
        "aria-orientation": "vertical"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1a97b07e397e2d73$var$ResizeHandle, {
        onMouseDown: onMouseDown,
        role: "presentation"
    }), children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1a97b07e397e2d73$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_7ypm2r": (0, $awdRS.default)(`${__cmplp.minWidth || 400}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1kdj _1ul9152j _1tke1osq _c71l1osq _18m91wug _1reo15vq _1e0c1txw _2lx2vrvc _4cvr1y6m _bfhkvuon _1pbyb4wl _18u0u2gc _u5f3u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1a97b07e397e2d73$var$ResizeHandle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul9ftgi _80omuf7j _kqswh2mm _1wpz1fhb _qc5othzt _aetrb3bt _z0aiv77o _1qdgv47k _15l21ssb _clh31i34 _19do1b66 _18postnw _1hfkmuej _gcm1b29m _4tpub29m _1gvg1osq _1kmz1osq",
            __cmplp.className
        ])
    });
});
const $1a97b07e397e2d73$var$resizeHandleStyles = null;
var $1a97b07e397e2d73$export$2e2bcd8739ae039 = $1a97b07e397e2d73$var$Resizer;

});
parcelRegister("6MdKZ", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $4a0030ab181c9c8a$export$90fc3a17d93f704c);

var $eJOHy = parcelRequire("eJOHy");
const $4a0030ab181c9c8a$export$90fc3a17d93f704c = (callback)=>{
    const callbackRef = (0, $eJOHy.useRef)(callback);
    (0, $eJOHy.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    return (0, $eJOHy.useCallback)((...args)=>callbackRef.current(...args), []);
};

});

parcelRegister("fRd3J", function(module, exports) {

$parcel$export(module.exports, "MIN_DETAILS_WIDTH_ISSUE", () => $f5e8d473aefa54b1$export$b4e0432c87affda2);
$parcel$export(module.exports, "WINDOW_RESIZE_THROTTLE", () => $f5e8d473aefa54b1$export$db1057b88f0c8a04);
$parcel$export(module.exports, "getDetailViewWidthRatio", () => $f5e8d473aefa54b1$export$5a9c556da9744b1b);
$parcel$export(module.exports, "setDetailViewWidthRatio", () => $f5e8d473aefa54b1$export$d194f7c4bdc33538);

var $dnU6V = parcelRequire("dnU6V");
const $f5e8d473aefa54b1$export$b4e0432c87affda2 = 440;
const $f5e8d473aefa54b1$export$db1057b88f0c8a04 = 350;
const $f5e8d473aefa54b1$var$DETAIL_VIEW_WIDTH_RATIO = 'gh.detailViewWidth';
const $f5e8d473aefa54b1$var$localStorage = (0, $dnU6V.createLocalStorageProvider)('jsmqueueagentview');
const $f5e8d473aefa54b1$export$5a9c556da9744b1b = ()=>{
    const value = $f5e8d473aefa54b1$var$localStorage.get($f5e8d473aefa54b1$var$DETAIL_VIEW_WIDTH_RATIO);
    return value ? Number(value) : 0;
};
const $f5e8d473aefa54b1$export$d194f7c4bdc33538 = (ratio)=>$f5e8d473aefa54b1$var$localStorage.set($f5e8d473aefa54b1$var$DETAIL_VIEW_WIDTH_RATIO, ratio);

});





parcelRegister("f0fwB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7578fb98fc262ce$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bQWwW = parcelRequire("bQWwW");

var $ch9En = parcelRequire("ch9En");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d7578fb98fc262ce$var$ProjectSummaryOnboardingBase = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("ltODG")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/queues-agent-view/src/view/layout/project-summary-onboarding/index.tsx"
});
const $d7578fb98fc262ce$var$ProjectSummaryOnboardingAsync = ({ projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-project-summary-onboarding",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d7578fb98fc262ce$var$ProjectSummaryOnboardingBase, {
        projectKey: projectKey
    }));
var $d7578fb98fc262ce$export$2e2bcd8739ae039 = $d7578fb98fc262ce$var$ProjectSummaryOnboardingAsync;

});
parcelRegister("ltODG", function(module, exports) {

let $fa33963f9f5f42ad$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $fa33963f9f5f42ad$var$load("ffQaD"),
    $fa33963f9f5f42ad$var$load("kvRbA"),
    $fa33963f9f5f42ad$var$load("keW8c")
]).then(()=>parcelRequire('ksPG3'));

});



parcelRegister("9KGpI", function(module, exports) {

$parcel$export(module.exports, "PageStyle", () => $9013a186f81a864d$export$c59987a647e9a55);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $d129d = parcelRequire("d129d");
const $9013a186f81a864d$export$c59987a647e9a55 = ({ Page: Page = (0, $d129d.default), children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9013a186f81a864d$var$JSDSpaPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Page, null, children));
var $9013a186f81a864d$export$2e2bcd8739ae039 = $9013a186f81a864d$export$c59987a647e9a55;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9013a186f81a864d$var$JSDSpaPageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1jfw _otyridpf _18u01jfw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jiD6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fedb73a7c2a23b7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7mS2i = parcelRequire("7mS2i");

var $d8UFE = parcelRequire("d8UFE");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $1KdDN = parcelRequire("1KdDN");

var $ecCxV = parcelRequire("ecCxV");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $lUto7 = parcelRequire("lUto7");

var $k3iJc = parcelRequire("k3iJc");
function $1fedb73a7c2a23b7$var$CipherDeprecationBanner() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jiraQueueViewCipherDeprecationBanner",
        packageName: "jiraSpaAppsServicedeskQueuesAgentView",
        teamName: "jsd-shield"
    }, isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7mS2i.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1fedb73a7c2a23b7$var$bannerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8UFE))), {
        label: "Warning",
        color: "var(--ds-icon-warning-inverse, #172B4D)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, formatMessage((0, $k3iJc.default).cipherDeprecationMessage, {
        button: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ecCxV.HelpPanelLink), {
                articleId: "6bSBVhywj4oQDe7rCDr9tT",
                appearance: "subtle-link",
                spacing: "none",
                onClick: (e, analyticsEvent)=>(0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'learnMoreAboutLatestEmailCiphersLink')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $1fedb73a7c2a23b7$var$linkTextStyles
            }, chunks))
    })))));
}
const $1fedb73a7c2a23b7$var$bannerContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    columnGap: 'space.100'
});
const $1fedb73a7c2a23b7$var$linkTextStyles = (0, $1DXK0.xcss)({
    color: 'color.text.warning.inverse',
    textDecoration: 'underline'
});
var $1fedb73a7c2a23b7$export$2e2bcd8739ae039 = $1fedb73a7c2a23b7$var$CipherDeprecationBanner;

});
parcelRegister("k3iJc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6532ff32bb4679$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2c6532ff32bb4679$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    cipherDeprecationMessage: {
        "id": "spa-apps-servicedesk-queues-agent-view.content.cipher-deprecation-banner.cipher-deprecation-message",
        "defaultMessage": "Verify that your <button>email server uses the latest ciphers</button> to receive requests and comments from connected email accounts."
    }
});

});



parcelRegister("9MITi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f436ad61396218bb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5IZWP = parcelRequire("5IZWP");

var $16sa1 = parcelRequire("16sa1");
const $f436ad61396218bb$var$QueuesIssueViewContent = (props)=>{
    const { issueNavigatorData: issueNavigatorData } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "queues-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5IZWP.default), {
        issueNavigatorData: issueNavigatorData
    }));
};
var $f436ad61396218bb$export$2e2bcd8739ae039 = $f436ad61396218bb$var$QueuesIssueViewContent;

});
parcelRegister("5IZWP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6570a6b1d48f008b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");


var $dNyY6 = parcelRequire("dNyY6");

var $2QIiZ = parcelRequire("2QIiZ");

var $iU2cj = parcelRequire("iU2cj");

var $do0HX = parcelRequire("do0HX");

var $5SwkH = parcelRequire("5SwkH");

var $16sa1 = parcelRequire("16sa1");

var $iZ3n7 = parcelRequire("iZ3n7");
let $6570a6b1d48f008b$var$dispatchExternalAction;
const $6570a6b1d48f008b$var$getIssueKey = ()=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return (0, $2QIiZ.parseIssueKey)(window.location.href);
};
const $6570a6b1d48f008b$var$getPreviousUrl = ()=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const urlParts = window.location.href.split('/');
    return urlParts.slice(0, urlParts.length - 1).join('/');
};
const $6570a6b1d48f008b$var$queueRoutesPattern = Object.values((0, $5SwkH.QUEUE_ROUTES)).join('|').replace(/\//g, '\\/');
const $6570a6b1d48f008b$var$QUEUES_URL_REGEX = new RegExp(`.*\\/projects\\/[^/]+\\/(${$6570a6b1d48f008b$var$queueRoutesPattern})\\/custom\\/.*`);
const $6570a6b1d48f008b$var$isComingFromQueue = ()=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.location.pathname.match($6570a6b1d48f008b$var$QUEUES_URL_REGEX);
};
const $6570a6b1d48f008b$var$REPORTS_URL_REGEX = /.*\/projects\/[^/]+\/reports\/.*/;
const $6570a6b1d48f008b$var$isComingFromReport = ()=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.location.pathname.match($6570a6b1d48f008b$var$REPORTS_URL_REGEX);
};
const $6570a6b1d48f008b$var$isComingFromQueueOrReport = ()=>$6570a6b1d48f008b$var$isComingFromQueue() || $6570a6b1d48f008b$var$isComingFromReport();
const $6570a6b1d48f008b$var$redirectAfterSuccessfulDelete = ()=>()=>{
        (0, $gRw8I.di)(window);
        const issueKey = $6570a6b1d48f008b$var$getIssueKey();
        const projectKey = (0, $dNyY6.extractProjectKey)(issueKey);
        let url;
        if ($6570a6b1d48f008b$var$isComingFromQueueOrReport()) url = $6570a6b1d48f008b$var$getPreviousUrl();
        else url = `/projects/${projectKey}`;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(url);
    };
(0, $iU2cj.listenToExternalActionFromLegacy)(()=>({
        dispatchExternalAction: $6570a6b1d48f008b$var$dispatchExternalAction,
        modifiedIssueIssueKey: $6570a6b1d48f008b$var$getIssueKey()
    }));
const $6570a6b1d48f008b$var$onDispatchExternalActionRef = (ref)=>{
    if (ref) $6570a6b1d48f008b$var$dispatchExternalAction = ref;
};
const $6570a6b1d48f008b$var$getAnalyticsSourceFromUrl = ()=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    if (pathname.includes('section')) return 0, $d851676a1c983028$export$7063ee6d0035a982;
    if (pathname.includes('queues')) return 0, $d851676a1c983028$export$7063ee6d0035a982;
    return 0, $d851676a1c983028$export$5bd5011b6596a0e7;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6570a6b1d48f008b$export$2e2bcd8739ae039 = ({ issueNavigatorData: issueNavigatorData } = {})=>{
    (0, $do0HX.markFragmentReady)();
    const issueKey = $6570a6b1d48f008b$var$getIssueKey();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "jsm-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iZ3n7.default), {
        backButtonUrl: $6570a6b1d48f008b$var$isComingFromQueueOrReport() ? $6570a6b1d48f008b$var$getPreviousUrl() : undefined,
        issueNavigatorData: issueNavigatorData,
        analyticsSource: $6570a6b1d48f008b$var$getAnalyticsSourceFromUrl(),
        issueKey: issueKey,
        onIssueDeleteSuccess: $6570a6b1d48f008b$var$redirectAfterSuccessfulDelete(),
        onDispatchExternalActionRef: $6570a6b1d48f008b$var$onDispatchExternalActionRef
    }));
};

});
parcelRegister("dNyY6", function(module, exports) {

$parcel$export(module.exports, "extractProjectKey", () => $d2a27657f5b202f3$export$f1a2e4721b127828);

var $ljej9 = parcelRequire("ljej9");
const $d2a27657f5b202f3$export$f1a2e4721b127828 = (issueKey)=>(0, $ljej9.toProjectKey)(issueKey.split('-')[0]);

});

parcelRegister("2QIiZ", function(module, exports) {

$parcel$export(module.exports, "parseIssueKey", () => $24e28c964a2fad75$export$775cba7641fc60e9);

var $ljej9 = parcelRequire("ljej9");
const $24e28c964a2fad75$export$775cba7641fc60e9 = (href)=>{
    const path = href.split('/').pop();
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    return (0, $ljej9.toIssueKey)(path.split('?')[0].split('#')[0]);
};

});

parcelRegister("iU2cj", function(module, exports) {

$parcel$export(module.exports, "listenToExternalActionFromLegacy", () => $1e58df16090f0e10$export$60376d8e2c7d8037);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $gjeS9 = parcelRequire("gjeS9");
const $1e58df16090f0e10$var$isBindableEvents = (Events)=>{
    if (!Events) return false;
    return typeof Events === 'object' && 'bind' in Events && typeof Events.bind === 'function';
};
const $1e58df16090f0e10$export$60376d8e2c7d8037 = (getDispatcherAndModifiedIssue)=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $gjeS9.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        if ($1e58df16090f0e10$var$isBindableEvents(Events)) Events.bind('modify-issue-view-via-external-action', (e, payload)=>{
            const { issueKey: issueKey, externalAction: externalAction } = payload;
            const { dispatchExternalAction: dispatchExternalAction, modifiedIssueIssueKey: modifiedIssueIssueKey } = getDispatcherAndModifiedIssue();
            if (issueKey === modifiedIssueIssueKey && externalAction && dispatchExternalAction) dispatchExternalAction(externalAction);
        });
    });
};

});

parcelRegister("do0HX", function(module, exports) {

$parcel$export(module.exports, "markFragmentReady", () => $6dc49fb1f4fa27f5$export$f35671de67f03a2b);
$parcel$export(module.exports, "initialiseMetrics", () => $6dc49fb1f4fa27f5$export$1ac307e078c767d0);
$parcel$export(module.exports, "markIssueStartRendering", () => $6dc49fb1f4fa27f5$export$c039505b02c87616);
$parcel$export(module.exports, "markIssueRender", () => $6dc49fb1f4fa27f5$export$c16cf8a32075f588);
$parcel$export(module.exports, "markIssueLegacyInteractive", () => $6dc49fb1f4fa27f5$export$4d5d547fdbe28097);
$parcel$export(module.exports, "markSPAReadyEndOfCriticalPath", () => $6dc49fb1f4fa27f5$export$a45a77102d75517f);
$parcel$export(module.exports, "markIssueInteractive", () => $6dc49fb1f4fa27f5$export$e57956c4b76a36f);
$parcel$export(module.exports, "markIssueOnPageLoadEvent", () => $6dc49fb1f4fa27f5$export$c30d9392d27ab5a8);
$parcel$export(module.exports, "markStartIssue", () => $6dc49fb1f4fa27f5$export$71cdf78946f275c);
$parcel$export(module.exports, "markIssuePreviewRendered", () => $6dc49fb1f4fa27f5$export$7f5545008a1e5a18);
$parcel$export(module.exports, "setIsInitialRender", () => $6dc49fb1f4fa27f5$export$eedeaa0a5b3bd3d1);
$parcel$export(module.exports, "isFullIssueView", () => $6dc49fb1f4fa27f5$export$db2ef91f6ace96c7);

var $aXKmr = parcelRequire("aXKmr");

var $2gvG4 = parcelRequire("2gvG4");

var $6whQo = parcelRequire("6whQo");

var $4iJGP = parcelRequire("4iJGP");

var $2QO3b = parcelRequire("2QO3b");

var $cJAh3 = parcelRequire("cJAh3");

var $6uWhG = parcelRequire("6uWhG");

var $gPCSe = parcelRequire("gPCSe");

var $eSnSE = parcelRequire("eSnSE");

var $2HxHL = parcelRequire("2HxHL");


var $9pjkP = parcelRequire("9pjkP");

var $dW281 = parcelRequire("dW281");

var $1XQXR = parcelRequire("1XQXR");

var $5Kex0 = parcelRequire("5Kex0");

var $akiS9 = parcelRequire("akiS9");

var $dydef = parcelRequire("dydef");

var $9DwQv = parcelRequire("9DwQv");

var $jKYv7 = parcelRequire("jKYv7");

var $3KXZZ = parcelRequire("3KXZZ");

var $9rEed = parcelRequire("9rEed");

var $bnvw2 = parcelRequire("bnvw2");

var $875lj = parcelRequire("875lj");

var $16KLp = parcelRequire("16KLp");
const $6dc49fb1f4fa27f5$var$LOG_LOCATION = 'issue.metrics';
let $6dc49fb1f4fa27f5$var$state;
const $6dc49fb1f4fa27f5$var$getSsrMark = ()=>{
    const ssrMark = (0, $6uWhG.getMark)((0, $cJAh3.SPA_SSR_RENDERED_MARK));
    if (ssrMark != null) return Math.floor(ssrMark.startTime);
    return null;
};
const $6dc49fb1f4fa27f5$var$setMarkWithError = (markName)=>{
    try {
        (0, $6uWhG.setMark)(markName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData($6dc49fb1f4fa27f5$var$LOG_LOCATION, 'Setting performance mark failed', error);
    }
};
const $6dc49fb1f4fa27f5$export$f35671de67f03a2b = ()=>{
    $6dc49fb1f4fa27f5$var$setMarkWithError($edc3194f015d4646$export$625e4e4c6eb56930);
};
const $6dc49fb1f4fa27f5$export$1ac307e078c767d0 = (options)=>{
    try {
        const { issueContextActions: issueContextActions, isLoadedWithPage: isLoadedWithPage, isSPA: isSPA, isRecentIssue: isRecentIssue, recentIssuesCount: recentIssuesCount, dataProvider: dataProvider, analyticsSource: analyticsSource, store: store, route: route } = options;
        $6dc49fb1f4fa27f5$var$state = new (0, $875lj.default)({
            isLoadedWithPage: isLoadedWithPage,
            isSPA: isSPA,
            isRecentIssue: isRecentIssue,
            analyticsSource: analyticsSource,
            recentIssuesCount: recentIssuesCount,
            correlationId: (0, $aXKmr.v4)(),
            // @ts-expect-error - TS2322 - Type '{ analyticsKey: ApplicationKey | undefined; viewMode: any; issueId: string | undefined; }' is not assignable to type 'MetricsProps'.
            lazyMetricsProps: ()=>(0, $16KLp.metricsStateSelector)(store.getState()),
            timingDataReporter: ()=>({
                    ...(0, $1XQXR.serverTimingSelector)(store.getState()),
                    ...(0, $9pjkP.getFetchIssueNetworkTimes)()
                }),
            issueScaleabilityReporter: (0, $bnvw2.issueScaleabilityReporterFactory)(store, issueContextActions),
            dataProvider: dataProvider,
            route: route
        });
        // Marking init of bm3
        (0, $dW281.issueViewLoad).mark('metrics_init');
        (0, $dW281.issueViewOnPageLoad).mark('metrics_init');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData($6dc49fb1f4fa27f5$var$LOG_LOCATION, 'Failed to initialise issue metrics', error);
    }
};
const $6dc49fb1f4fa27f5$export$c039505b02c87616 = ()=>{
    $6dc49fb1f4fa27f5$var$setMarkWithError($edc3194f015d4646$export$10082883a7f4ea4d);
    (0, $dW281.issueViewLoad).mark($edc3194f015d4646$export$10082883a7f4ea4d);
};
const $6dc49fb1f4fa27f5$export$c16cf8a32075f588 = ()=>{
    $6dc49fb1f4fa27f5$var$setMarkWithError($edc3194f015d4646$export$7f7b606f70e669e6);
    (0, $dW281.issueViewOnPageLoad).mark($edc3194f015d4646$export$7f7b606f70e669e6);
};
const $6dc49fb1f4fa27f5$export$4d5d547fdbe28097 = ()=>{
    $6dc49fb1f4fa27f5$var$setMarkWithError($edc3194f015d4646$export$b292c195104c50d3);
    (0, $dW281.issueViewLoad).mark($edc3194f015d4646$export$b292c195104c50d3);
};
const $6dc49fb1f4fa27f5$export$8bc8bca4478fe6d7 = (markTime)=>{
    (0, $dW281.issueViewOnPageLoad).mark($edc3194f015d4646$export$4d1080224e02ef0b, markTime);
};
const $6dc49fb1f4fa27f5$export$a45a77102d75517f = ()=>{
    $6dc49fb1f4fa27f5$var$setMarkWithError($edc3194f015d4646$export$434b58ebadf14df2);
    (0, $dW281.issueViewLoad).mark($edc3194f015d4646$export$434b58ebadf14df2);
};
const $6dc49fb1f4fa27f5$var$getSharedCustomData = ()=>({
        ...$6dc49fb1f4fa27f5$var$state.getIssueScaleabilityReporter()(),
        ...(0, $9rEed.getBackendBlockingTime)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueViewLoad: (0, $dW281.issueViewLoad)
        }),
        isBentoRecentIssue: $6dc49fb1f4fa27f5$var$state.getIsRecentIssue(),
        bentoRecentIssuesCount: $6dc49fb1f4fa27f5$var$state.getRecentIssuesCount(),
        correlationId: $6dc49fb1f4fa27f5$var$state.getCorrelationId(),
        initialLoadFullPageBundleLoadCount: $6dc49fb1f4fa27f5$var$state.getIsInitial() ? (0, $gPCSe.default).getEntriesByType('resource').filter((x)=>x.name.includes('async-issue-app--full-page')).length : 0,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        serverTime: (0, $gPCSe.default).getEntriesByType('resource').find(({ name: name })=>name.includes((0, $3KXZZ.IssueViewFetchOperations).INITIAL_AGG))?.serverTiming.find(({ name: name })=>name === 'atl-edge')?.duration
    });
const $6dc49fb1f4fa27f5$export$e57956c4b76a36f = ({ lastTransitionTime: // TODO JIV-14563 Fixup or remove embeddedIssueTTI in BM3 metrics due to broken lastTransitionStartTime
// @ts-expect-error - this has never been wired up correctly, I only just discovered it by adding types for the data that is actually passed through.
lastTransitionTime })=>{
    const isFullIssue = $6dc49fb1f4fa27f5$var$state.getIsFullIssue();
    $6dc49fb1f4fa27f5$var$state.setInteractiveEnd((0, $gPCSe.default).now());
    if ($6dc49fb1f4fa27f5$var$state) {
        const startTime = lastTransitionTime || $6dc49fb1f4fa27f5$var$state.getStartTime();
        if ($6dc49fb1f4fa27f5$var$state.getIsFullIssue()) (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $akiS9.PRODUCT_START_MARK), true);
        const embeddedCustomData = !isFullIssue ? {
            embeddedIssueFMP: Math.floor($6dc49fb1f4fa27f5$var$state.getFMP()),
            embeddedIssueTTI: Math.floor($6dc49fb1f4fa27f5$var$state.getInteractiveEnd() - startTime),
            analyticsSource: $6dc49fb1f4fa27f5$var$state.getAnalyticsSource(),
            featureFlags: Object.fromEntries((0, $4iJGP.allFeatureFlagsAccessed))
        } : {};
        const perfConfig = {
            stopTime: $6dc49fb1f4fa27f5$var$state.getInteractiveEnd(),
            customData: {
                ...$6dc49fb1f4fa27f5$var$getSharedCustomData(),
                ...embeddedCustomData
            }
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $2gvG4.addUFOCustomData)(perfConfig.customData);
        const ufoMetricKey = isFullIssue ? 'issue-view' : 'issue-embed';
        (0, $2QO3b.addApdexToAll)({
            key: ufoMetricKey,
            startTime: isFullIssue ? undefined : (0, $dW281.embeddedIssueViewLoad).getData()?.start ?? undefined,
            stopTime: perfConfig.stopTime
        });
        if (isFullIssue) {
            (0, $6whQo.addBM3TimingsToUFO)((0, $dW281.issueViewLoad).getData()?.marks, (0, $dW281.issueViewLoad).getData()?.config.timings);
            (0, $5Kex0.afterPaintEmit)(()=>{
                // @ts-expect-error payload type mismatch with optional values
                (0, $dW281.issueViewLoad).stop(perfConfig);
            }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $dW281.issueViewLoad));
        } else // @ts-expect-error payload type mismatch with optional values
        (0, $dW281.issueViewLoad).stop(perfConfig);
        (0, $jKYv7.markUimTtiIssueViewLoaded)();
        if (!isFullIssue) // See markStartIssue for more information.
        {
            if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
        }
    }
};
const $6dc49fb1f4fa27f5$var$getBrowserNavigationMetrics = ()=>{
    const entries = (0, $gPCSe.default).getEntriesByType('navigation');
    if (entries.length === 0 || !(entries[0] instanceof PerformanceNavigationTiming)) return null;
    const navigation = entries[0];
    return {
        connectEnd: Math.round(navigation.connectEnd),
        connectStart: Math.round(navigation.connectStart),
        domComplete: Math.round(navigation.domComplete),
        domContentLoadedEventEnd: Math.round(navigation.domContentLoadedEventEnd),
        domContentLoadedEventStart: Math.round(navigation.domContentLoadedEventStart),
        domInteractive: Math.round(navigation.domInteractive),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        fetchStart: Math.round(navigation.fetchStart),
        loadEventStart: Math.round(navigation.loadEventStart),
        requestStart: Math.round(navigation.requestStart),
        responseEnd: Math.round(navigation.responseEnd),
        responseStart: Math.round(navigation.responseStart),
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        redirectCount: navigation.redirectCount,
        type: navigation.type
    };
};
const $6dc49fb1f4fa27f5$export$c30d9392d27ab5a8 = ()=>{
    const isFullIssue = $6dc49fb1f4fa27f5$var$state.getIsFullIssue();
    if (!isFullIssue) return;
    if ($6dc49fb1f4fa27f5$var$state) {
        try {
            new PerformanceObserver((entryList)=>{
                entryList.getEntries().forEach((entry)=>$6dc49fb1f4fa27f5$export$8bc8bca4478fe6d7(entry.startTime));
            }).observe({
                type: 'largest-contentful-paint',
                buffered: true
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
        // do nothing
        }
        const customData = {
            ...$6dc49fb1f4fa27f5$var$getSharedCustomData(),
            browserNavigationMetrics: $6dc49fb1f4fa27f5$var$getBrowserNavigationMetrics()
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $dW281.issueViewOnPageLoad).stop(customData);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $2gvG4.addUFOCustomData)(customData);
    }
};
const $6dc49fb1f4fa27f5$export$71cdf78946f275c = (isFullPage = false)=>{
    (0, $dW281.issueViewLoad).start();
    if (!isFullPage) {
        (0, $dW281.embeddedIssueViewLoad).start({
            startTime: (0, $gPCSe.default).now()
        });
        /**
		 * All SPA full page loads already start the event delay through the
		 * usePageLoadedSubscriber hook in @atlassian/jira-event-delay-controller.
		 * The embedded views need to start this critical section explicitly here because
		 * there is no equivalent hook that is generically applicable to all experiences.
		 *
		 * The only events that currently leverage the delay mechanism are the automatic
		 * exposure events, so we can avoid the overhead of starting this critical section
		 * if it won't be necessary.
		 */ if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.startLowPriorityEventDelay)();
    }
    if (isFullPage) (0, $dW281.issueViewOnPageLoad).start({
        startTime: 0
    });
    (0, $jKYv7.startUimTti)();
};
const $6dc49fb1f4fa27f5$export$7f5545008a1e5a18 = ({ isInitialRender: isInitialRender, lastTransitionStartTime: lastTransitionStartTime })=>{
    const ssrMark = $6dc49fb1f4fa27f5$var$getSsrMark();
    const previewTime = (0, $gPCSe.default).now();
    const startTime = $6dc49fb1f4fa27f5$var$state.getStartTime();
    let fmp = 0;
    if ($6dc49fb1f4fa27f5$var$state.getIsFullIssue()) {
        if (isInitialRender) // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
        fmp = ssrMark;
        else fmp = previewTime - (lastTransitionStartTime || startTime);
    } else fmp = previewTime - startTime;
    (0, $dW281.issueViewLoad).mark($edc3194f015d4646$export$62c04f0e896827e3);
    (0, $dW281.issueViewOnPageLoad).mark($edc3194f015d4646$export$62c04f0e896827e3);
    $6dc49fb1f4fa27f5$var$state.setFMP(fmp);
    $6dc49fb1f4fa27f5$var$state.setPreviewEnd(previewTime);
    $6dc49fb1f4fa27f5$var$setMarkWithError($edc3194f015d4646$export$62c04f0e896827e3);
};
const $6dc49fb1f4fa27f5$export$eedeaa0a5b3bd3d1 = (isInitialRender)=>{
    if ($6dc49fb1f4fa27f5$var$state) $6dc49fb1f4fa27f5$var$state.setIsLoadedWithPage(isInitialRender);
};
const $6dc49fb1f4fa27f5$export$db2ef91f6ace96c7 = ()=>$6dc49fb1f4fa27f5$var$state && $6dc49fb1f4fa27f5$var$state.getIsFullIssue();

});
const $edc3194f015d4646$export$625e4e4c6eb56930 = 'ISSUE_FRAGMENT_READY_MARK';
const $edc3194f015d4646$export$10082883a7f4ea4d = 'ISSUE_START_RENDERING_MARK';
const $edc3194f015d4646$export$62c04f0e896827e3 = 'ISSUE_PREVIEW_RENDERED';
const $edc3194f015d4646$export$5db08809a3f311ed = 'ISSUE_FETCHED_MARK';
const $edc3194f015d4646$export$c21b33196a19ec61 = 'ISSUE_START_FETCHING_DATA';
const $edc3194f015d4646$export$e64e32643802b552 = 'ISSUE_READY_FOR_DATA';
const $edc3194f015d4646$export$e52cc35f872875f7 = 'ISSUE_DATA_AVAILABLE';
const $edc3194f015d4646$export$91b5cb94c32a9b = 'ISSUE_CACHED_CONTENT_LOADED';
const $edc3194f015d4646$export$205779a1d31dbc62 = 'ssr.issue.rendered';
const $edc3194f015d4646$export$bfb91b09e6b87d3c = 'ISSUE_START_GIRA_FETCH';
const $edc3194f015d4646$export$beb8599162403c36 = 'ISSUE_FINISH_GIRA_FETCH';
const $edc3194f015d4646$export$3a9e4a905dec520d = 'ISSUE_MOUNTED';
const $edc3194f015d4646$export$7f7b606f70e669e6 = 'ISSUE_RENDERED';
const $edc3194f015d4646$export$b292c195104c50d3 = 'ISSUE_LEGACY_INTERACTIVE';
const $edc3194f015d4646$export$434b58ebadf14df2 = 'ISSUE_SPA_MARKED_READY_END_OF_CRITICAL_PATH';
const $edc3194f015d4646$export$4d1080224e02ef0b = 'LCP_CANDIDATE';
const $edc3194f015d4646$export$a98a3196940af8fa = 'issueViewCriticalData-agg-suspense';
const $edc3194f015d4646$export$7b35970640b1e1c0 = 'issueViewCriticalData-gira-suspense';
const $edc3194f015d4646$export$1ea0ab50283b82a8 = 'issueViewCriticalData-redux';

parcelRegister("9pjkP", function(module, exports) {

$parcel$export(module.exports, "clearFetchIssueNetworkTimes", () => $604c4e3efd7de6f7$export$8d777cefeb6b914e);
$parcel$export(module.exports, "getFetchIssueNetworkTimes", () => $604c4e3efd7de6f7$export$48cecd0d00931806);

var $g6grK = parcelRequire("g6grK");

var $gPCSe = parcelRequire("gPCSe");

var $hN6Bt = parcelRequire("hN6Bt");
const $604c4e3efd7de6f7$var$fetchIssueNetworkMarks = [
    (0, $hN6Bt.fetchUploadPerf),
    (0, $hN6Bt.fetchCommentsPerf),
    (0, $hN6Bt.fetchIssuePropertiesPerf),
    (0, $hN6Bt.fetchIssueLinkPerf),
    (0, $hN6Bt.fetchViewContextPerf),
    (0, $hN6Bt.fetchSubtaskTypesPerf),
    (0, $hN6Bt.fetchFieldDataPerf),
    (0, $hN6Bt.fetchUserAuthPerf)
];
// Data remains the same once called once (for the same issue), so we cache it
// here for future requests for this data due to the calculation wiping the
//  performance marks required to calculate.  It does however need to be reset
// in cases like subtask click throughs when we load a new issue.
let $604c4e3efd7de6f7$var$fetchIssueNetworkTimes;
const $604c4e3efd7de6f7$var$calculateFetchIssueNetworkTimes = ()=>{
    const issueNetworkTimes = $604c4e3efd7de6f7$var$fetchIssueNetworkMarks.reduce((obj, perf)=>{
        const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
        const endMarkName = `END_${perf.prefix}_${perf.key}`;
        const networkTime = (0, $g6grK.timeBetweenMarks)(beginMarkName, endMarkName);
        if (networkTime != null && networkTime > 0) {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            const aggregated = {
                ...obj,
                [`${perf.key}_NETWORK`]: networkTime
            };
            // This is vital to clear mark after use.  Or next call will failed to add the mark of same name.
            if ((0, $gPCSe.default).clearMarks) {
                (0, $gPCSe.default).clearMarks(beginMarkName);
                (0, $gPCSe.default).clearMarks(endMarkName);
            }
            return aggregated;
        }
        return obj;
    }, {});
    return issueNetworkTimes;
};
const $604c4e3efd7de6f7$export$8d777cefeb6b914e = ()=>{
    $604c4e3efd7de6f7$var$fetchIssueNetworkMarks.forEach((perf)=>{
        const beginMarkName = `BEGIN_${perf.prefix}_${perf.key}`;
        const endMarkName = `END_${perf.prefix}_${perf.key}`;
        if ((0, $gPCSe.default).clearMarks) {
            (0, $gPCSe.default).clearMarks(beginMarkName);
            (0, $gPCSe.default).clearMarks(endMarkName);
        }
    });
    $604c4e3efd7de6f7$var$fetchIssueNetworkTimes = null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.ISSUE_DATA_AVAILABLE = null;
};
const $604c4e3efd7de6f7$export$48cecd0d00931806 = ()=>{
    if (!$604c4e3efd7de6f7$var$fetchIssueNetworkTimes) $604c4e3efd7de6f7$var$fetchIssueNetworkTimes = $604c4e3efd7de6f7$var$calculateFetchIssueNetworkTimes();
    return $604c4e3efd7de6f7$var$fetchIssueNetworkTimes;
};

});
parcelRegister("g6grK", function(module, exports) {

$parcel$export(module.exports, "timeBetweenMarks", () => $715e2e09cc6bbfe9$export$9c25bf1893ba64c);

var $6uWhG = parcelRequire("6uWhG");
const $715e2e09cc6bbfe9$export$9c25bf1893ba64c = (startMarkName, endMarkName)=>{
    const startMark = (0, $6uWhG.getMark)(startMarkName);
    const endMark = (0, $6uWhG.getMark)(endMarkName);
    if (!startMark || !endMark || startMark.startTime > endMark.startTime) return null;
    return endMark.startTime - startMark.startTime;
};

});

parcelRegister("hN6Bt", function(module, exports) {

$parcel$export(module.exports, "fetchFieldDataPerf", () => $7aaea898e20ee16e$export$b97d963a8496fa2f);
$parcel$export(module.exports, "fetchCommentsPerf", () => $7aaea898e20ee16e$export$179836a99669cbe7);
$parcel$export(module.exports, "fetchIssueLinkPerf", () => $7aaea898e20ee16e$export$8d0984a0f9f31117);
$parcel$export(module.exports, "fetchSubtaskTypesPerf", () => $7aaea898e20ee16e$export$c1324bd586e9a53a);
$parcel$export(module.exports, "fetchUploadPerf", () => $7aaea898e20ee16e$export$72fcc6cb1cdc70e0);
$parcel$export(module.exports, "fetchUserAuthPerf", () => $7aaea898e20ee16e$export$4052b1eae3373c3b);
$parcel$export(module.exports, "fetchViewContextPerf", () => $7aaea898e20ee16e$export$b4e2588a18d8d980);
$parcel$export(module.exports, "fetchIssuePropertiesPerf", () => $7aaea898e20ee16e$export$2ee73dd298bdfe8a);
const $7aaea898e20ee16e$var$ISSUE_DETAILS_ANALYTICS_PREFIX = 'ISSUE_DETAILS';
const $7aaea898e20ee16e$var$FETCH_FIELD_DATA_REQUEST = 'FETCH_FIELD_DATA';
const $7aaea898e20ee16e$var$FETCH_INITIAL_COMMENTS_REQUEST = 'FETCH_INITIAL_COMMENTS';
const $7aaea898e20ee16e$var$FETCH_ISSUE_LINK_TYPES_REQUEST = 'FETCH_ISSUE_LINK_TYPES';
const $7aaea898e20ee16e$var$FETCH_SUBTASK_TYPES_REQUEST = 'FETCH_SUBTASK_TYPES';
const $7aaea898e20ee16e$var$FETCH_UPLOAD_CONTEXT_REQUEST = 'FETCH_LOAD_CONTEXT';
const $7aaea898e20ee16e$var$FETCH_USER_AUTH_REQUEST = 'FETCH_USER_AUTH';
const $7aaea898e20ee16e$var$FETCH_VIEW_CONTEXT_REQUEST = 'FETCH_VIEW_CONTEXT';
const $7aaea898e20ee16e$var$FETCH_ISSUE_PROPERTIES_REQUEST = 'FETCH_ISSUE_PROPERTIES';
const $7aaea898e20ee16e$export$b97d963a8496fa2f = {
    key: $7aaea898e20ee16e$var$FETCH_FIELD_DATA_REQUEST,
    prefix: $7aaea898e20ee16e$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $7aaea898e20ee16e$export$179836a99669cbe7 = {
    key: $7aaea898e20ee16e$var$FETCH_INITIAL_COMMENTS_REQUEST,
    prefix: $7aaea898e20ee16e$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $7aaea898e20ee16e$export$8d0984a0f9f31117 = {
    key: $7aaea898e20ee16e$var$FETCH_ISSUE_LINK_TYPES_REQUEST,
    prefix: $7aaea898e20ee16e$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $7aaea898e20ee16e$export$c1324bd586e9a53a = {
    key: $7aaea898e20ee16e$var$FETCH_SUBTASK_TYPES_REQUEST,
    prefix: $7aaea898e20ee16e$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $7aaea898e20ee16e$export$72fcc6cb1cdc70e0 = {
    key: $7aaea898e20ee16e$var$FETCH_UPLOAD_CONTEXT_REQUEST,
    prefix: $7aaea898e20ee16e$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $7aaea898e20ee16e$export$4052b1eae3373c3b = {
    key: $7aaea898e20ee16e$var$FETCH_USER_AUTH_REQUEST,
    prefix: $7aaea898e20ee16e$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $7aaea898e20ee16e$export$b4e2588a18d8d980 = {
    key: $7aaea898e20ee16e$var$FETCH_VIEW_CONTEXT_REQUEST,
    prefix: $7aaea898e20ee16e$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};
const $7aaea898e20ee16e$export$2ee73dd298bdfe8a = {
    key: $7aaea898e20ee16e$var$FETCH_ISSUE_PROPERTIES_REQUEST,
    prefix: $7aaea898e20ee16e$var$ISSUE_DETAILS_ANALYTICS_PREFIX
};

});


parcelRegister("dW281", function(module, exports) {

$parcel$export(module.exports, "issueViewLoad", () => $21e5f4d2911b9c2a$export$49371c2cc4aaa4f6);
$parcel$export(module.exports, "issueViewOnPageLoad", () => $21e5f4d2911b9c2a$export$2f6837d06b669285);
$parcel$export(module.exports, "embeddedIssueViewLoad", () => $21e5f4d2911b9c2a$export$9d773f01a8da623e);
$parcel$export(module.exports, "epicDropdownOpenInteraction", () => $21e5f4d2911b9c2a$export$8d33579ffe76aa5b);
$parcel$export(module.exports, "epicModalOpenInteraction", () => $21e5f4d2911b9c2a$export$8f0deabe791d5bb9);

var $hqYEY = parcelRequire("hqYEY");

const $21e5f4d2911b9c2a$export$49371c2cc4aaa4f6 = (0, $hqYEY.metrics).custom({
    key: 'issue-view-load',
    virtual: true,
    timings: [
        {
            key: 'legacy-tti-2021',
            startMark: 'metrics_init',
            endMark: $edc3194f015d4646$export$b292c195104c50d3
        },
        {
            key: 'timeBlockedOnBackend',
            startMark: $edc3194f015d4646$export$e64e32643802b552,
            endMark: $edc3194f015d4646$export$e52cc35f872875f7
        }
    ]
});
const $21e5f4d2911b9c2a$export$2f6837d06b669285 = (0, $hqYEY.metrics).custom({
    key: 'issue-view-on-page-load',
    timings: [
        {
            key: 'issue-mounted',
            endMark: $edc3194f015d4646$export$3a9e4a905dec520d
        },
        {
            key: 'latest-lcp',
            endMark: $edc3194f015d4646$export$4d1080224e02ef0b
        }
    ]
});
const $21e5f4d2911b9c2a$export$9d773f01a8da623e = (0, $hqYEY.metrics).custom({
    key: 'embedded-issue-view-load',
    until: $21e5f4d2911b9c2a$export$49371c2cc4aaa4f6,
    include: [
        $21e5f4d2911b9c2a$export$49371c2cc4aaa4f6
    ]
});
const $21e5f4d2911b9c2a$export$1e32b6c8e1e31a3d = (0, $hqYEY.metrics).pageLoad({
    key: 'service-management.queues.issue'
});
const $21e5f4d2911b9c2a$export$4be279014c4d8d39 = (0, $hqYEY.metrics).pageLoad({
    key: 'service-management.reports.issue'
});
const $21e5f4d2911b9c2a$export$8d33579ffe76aa5b = (0, $hqYEY.metrics).interaction({
    key: 'issue-epic-dropdown-menu-open'
});
const $21e5f4d2911b9c2a$export$8f0deabe791d5bb9 = (0, $hqYEY.metrics).interaction({
    key: 'issue-epic-modal-open'
});

});

parcelRegister("1XQXR", function(module, exports) {

$parcel$export(module.exports, "serverTimingSelector", () => $347f0a4999507f6c$export$a0b21c7e17057a47);

var $ahm5r = parcelRequire("ahm5r");

var $6az7p = parcelRequire("6az7p");
const $347f0a4999507f6c$export$8ef68fa2b28a6d0f = (state)=>state.timing;
const $347f0a4999507f6c$export$a0b21c7e17057a47 = (0, $ahm5r.createSelector)($347f0a4999507f6c$export$8ef68fa2b28a6d0f, (0, $6az7p.isLoadingSelector), (timing, isLoading)=>isLoading ? undefined : timing.server);

});
parcelRegister("6az7p", function(module, exports) {

$parcel$export(module.exports, "entitiesSelector", () => $0a42648be66bacce$export$ccebe5cc5854d0fa);
$parcel$export(module.exports, "projectSelector", () => $0a42648be66bacce$export$852a6c34ff1a2e77);
$parcel$export(module.exports, "uiSelector", () => $0a42648be66bacce$export$185c0864c82372e3);
$parcel$export(module.exports, "entitiesIssueSelector", () => $0a42648be66bacce$export$fa3ac1f794979805);
$parcel$export(module.exports, "entitiesIssueLinksSelector", () => $0a42648be66bacce$export$87f5d716429f733);
$parcel$export(module.exports, "entitiesRefreshedOnSelector", () => $0a42648be66bacce$export$c4ebdc93969b82cc);
$parcel$export(module.exports, "flagsSelector", () => $0a42648be66bacce$export$40cfdc5e96db7759);
$parcel$export(module.exports, "projectIdSelector", () => $0a42648be66bacce$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "projectIdsSelector", () => $0a42648be66bacce$export$9edb3f63d1bd8546);
$parcel$export(module.exports, "projectKeySelector", () => $0a42648be66bacce$export$404de5ac601b84bc);
$parcel$export(module.exports, "projectTypeSelector", () => $0a42648be66bacce$export$69316f88206ca90b);
$parcel$export(module.exports, "isSimplifiedProjectSelector", () => $0a42648be66bacce$export$d94d544d4b2e1310);
$parcel$export(module.exports, "loggedInUserDetailsSelector", () => $0a42648be66bacce$export$b5a68452fc64275d);
$parcel$export(module.exports, "loggedInUserAvatarUrlSelector", () => $0a42648be66bacce$export$e0efa9c12379be7a);
$parcel$export(module.exports, "loggedInUserDisplayNameSelector", () => $0a42648be66bacce$export$4f56a07246719eb0);
$parcel$export(module.exports, "parentIssueEntitySelector", () => $0a42648be66bacce$export$e10c57d263d23c49);
$parcel$export(module.exports, "loggedInUserTimeZoneSelector", () => $0a42648be66bacce$export$ac6f9fd801c94fff);
$parcel$export(module.exports, "idSelector", () => $0a42648be66bacce$export$66c501bed2fcd648);
$parcel$export(module.exports, "isClassicProjectSelector", () => $0a42648be66bacce$export$45347d9f8a67561b);
$parcel$export(module.exports, "isLoadingSelector", () => $0a42648be66bacce$export$c077f23183070903);
$parcel$export(module.exports, "doNotUseIsLoadingPromiseSelector", () => $0a42648be66bacce$export$2ca9575c7da6bf18);
$parcel$export(module.exports, "isPreviewSelector", () => $0a42648be66bacce$export$b33a1a8958a8d805);
$parcel$export(module.exports, "isCompletedLoadingSelector", () => $0a42648be66bacce$export$9b99fb9e23fc133);
$parcel$export(module.exports, "loadingStageSelector", () => $0a42648be66bacce$export$18bc980d36bf93d);
$parcel$export(module.exports, "isDeleteIssueModalOpenSelector", () => $0a42648be66bacce$export$7cfd3e0dd7059b87);
$parcel$export(module.exports, "isDeletingIssueSelector", () => $0a42648be66bacce$export$d414d8eddcb409e4);
$parcel$export(module.exports, "didIssueDeleteFailSelector", () => $0a42648be66bacce$export$834732624d2c73e1);
$parcel$export(module.exports, "errorSelector", () => $0a42648be66bacce$export$47aec13333381be0);
$parcel$export(module.exports, "errorMessageSelector", () => $0a42648be66bacce$export$9b1097e17c0e6dc2);
$parcel$export(module.exports, "getUserByIdSelector", () => $0a42648be66bacce$export$801a2f2bd4059665);
$parcel$export(module.exports, "parentLevelIssuesSelector", () => $0a42648be66bacce$export$aa8980c49aba4478);
$parcel$export(module.exports, "baseAriSelector", () => $0a42648be66bacce$export$fa12ae06e35ebd67);
$parcel$export(module.exports, "issueAriSelector", () => $0a42648be66bacce$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "isEpicSelector", () => $0a42648be66bacce$export$6e8ebe94ad8bb62b);
$parcel$export(module.exports, "isServiceDeskSelector", () => $0a42648be66bacce$export$43d733e4b7e8c7d0);
$parcel$export(module.exports, "isCustomerServiceSelector", () => $0a42648be66bacce$export$abb64932cd9b1784);

var $ahm5r = parcelRequire("ahm5r");

var $ln6Iy = parcelRequire("ln6Iy");


var $8oOr4 = parcelRequire("8oOr4");

var $ljej9 = parcelRequire("ljej9");

var $5EgB1 = parcelRequire("5EgB1");

var $6t0ps = parcelRequire("6t0ps");
const $0a42648be66bacce$export$ccebe5cc5854d0fa = (state)=>state.entities;
const $0a42648be66bacce$export$852a6c34ff1a2e77 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>entities ? entities.project : null);
const $0a42648be66bacce$export$185c0864c82372e3 = (state)=>state.ui;
const $0a42648be66bacce$export$27493ac3d8611290 = (state)=>state.agile;
const $0a42648be66bacce$export$fa3ac1f794979805 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>entities.issue);
const $0a42648be66bacce$export$87f5d716429f733 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>entities.issueLinks);
const $0a42648be66bacce$export$c4ebdc93969b82cc = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>entities.refreshedOn);
const $0a42648be66bacce$export$40cfdc5e96db7759 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.flags);
const $0a42648be66bacce$export$4c9d6034f65d22f4 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? project.projectId : null);
const $0a42648be66bacce$export$9edb3f63d1bd8546 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$852a6c34ff1a2e77, (project)=>project && project.projectId ? [
        project.projectId
    ] : []);
const $0a42648be66bacce$export$404de5ac601b84bc = (0, $ahm5r.createSelector)($0a42648be66bacce$export$852a6c34ff1a2e77, (project)=>project ? project.projectKey : null);
const $0a42648be66bacce$export$69316f88206ca90b = (0, $ahm5r.createSelector)($0a42648be66bacce$export$852a6c34ff1a2e77, (project)=>project && project.projectType ? project.projectType : null);
const $0a42648be66bacce$export$d94d544d4b2e1310 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$852a6c34ff1a2e77, (project)=>!!project && project.isSimplified);
const $0a42648be66bacce$export$b5a68452fc64275d = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (0, $5EgB1.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>loggedInAccountId ? entities.users[loggedInAccountId] : null);
const $0a42648be66bacce$export$e0efa9c12379be7a = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (0, $5EgB1.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.avatarUrl : null;
});
const $0a42648be66bacce$export$4f56a07246719eb0 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (0, $5EgB1.accountIdloggedInUserSelector), (entities, loggedInAccountId)=>{
    const loggedInUser = loggedInAccountId ? entities.users[loggedInAccountId] : null;
    return loggedInUser ? loggedInUser.displayName : null;
});
const $0a42648be66bacce$export$e10c57d263d23c49 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>entities.parentIssue);
const $0a42648be66bacce$export$ac6f9fd801c94fff = (0, $ahm5r.createSelector)($0a42648be66bacce$export$b5a68452fc64275d, (loggedInUser)=>loggedInUser ? loggedInUser.timeZone : undefined);
const $0a42648be66bacce$export$66c501bed2fcd648 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$fa3ac1f794979805, (issue)=>issue && (0, $ljej9.toIssueId)(issue.id));
const $0a42648be66bacce$export$45347d9f8a67561b = (0, $ahm5r.createSelector)($0a42648be66bacce$export$d94d544d4b2e1310, (isSimplified)=>!isSimplified);
const $0a42648be66bacce$export$c077f23183070903 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $ab6982cc941e6f7e$export$26d55645375ca9a));
const $0a42648be66bacce$export$2ca9575c7da6bf18 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.doNotUseIsLoadingPromise);
const $0a42648be66bacce$export$b33a1a8958a8d805 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $ab6982cc941e6f7e$export$1b56cc494043d9bf));
const $0a42648be66bacce$export$9b99fb9e23fc133 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.loadingStage === (0, $ab6982cc941e6f7e$export$1660a2d7c2fff354));
const $0a42648be66bacce$export$18bc980d36bf93d = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.loadingStage);
const $0a42648be66bacce$export$7cfd3e0dd7059b87 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>!!(ui.issueDeletion && ui.issueDeletion.isDeleteIssueModalOpen));
const $0a42648be66bacce$export$d414d8eddcb409e4 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.isDeletingIssue : false);
const $0a42648be66bacce$export$834732624d2c73e1 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.issueDeletion ? ui.issueDeletion.didIssueDeleteFail : false);
const $0a42648be66bacce$export$47aec13333381be0 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.error);
const $0a42648be66bacce$export$9b1097e17c0e6dc2 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$185c0864c82372e3, (ui)=>ui.errorMessage);
const $0a42648be66bacce$export$801a2f2bd4059665 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>(userId)=>userId ? entities.users[userId] : undefined);
const $0a42648be66bacce$export$aa8980c49aba4478 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$ccebe5cc5854d0fa, (entities)=>entities.parentLevelIssues);
const $0a42648be66bacce$export$a60a6c96db10acc4 = ()=>'jira';
const $0a42648be66bacce$export$57c6957997fb7f1d = (0, $ahm5r.createSelector)($0a42648be66bacce$export$69316f88206ca90b, (0, $ln6Iy.projectTypeToCanonicalId));
const $0a42648be66bacce$export$fa12ae06e35ebd67 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$a60a6c96db10acc4, (0, $5EgB1.cloudIdSelector), (resourceOwner, cloudId)=>cloudId ? `ari:cloud:${resourceOwner}:${cloudId}` : null);
const $0a42648be66bacce$export$a2cdbba2136e72d3 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$fa12ae06e35ebd67, $0a42648be66bacce$export$66c501bed2fcd648, (baseAri, issueId)=>{
    if (!baseAri || !issueId) return null;
    return `${baseAri}:issue/${issueId}`;
});
const $0a42648be66bacce$export$27abc48b8d528300 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$27493ac3d8611290, (agile)=>agile && agile.epic && agile.epic.key || null);
const $0a42648be66bacce$export$d062a59cf4fc9cec = (fields)=>({}).hasOwnProperty.call(fields, (0, $8oOr4.EPIC_ISSUES));
const $0a42648be66bacce$export$6e8ebe94ad8bb62b = (0, $ahm5r.createSelector)((0, $6t0ps.fieldsSelector), (fields)=>$0a42648be66bacce$export$d062a59cf4fc9cec(fields));
const $0a42648be66bacce$export$88630f3045704997 = (fields)=>{
    if (({}).hasOwnProperty.call(fields, 'hierarchy-level-same-level')) return fields['hierarchy-level-same-level'].value.name === 'Epic';
    return false;
};
const $0a42648be66bacce$export$460d8048474fa8a2 = (0, $ahm5r.createSelector)((0, $6t0ps.fieldsSelector), (fields)=>$0a42648be66bacce$export$88630f3045704997(fields));
const $0a42648be66bacce$export$697a560dc772eca6 = (fields)=>{
    if (({}).hasOwnProperty.call(fields, 'status')) return fields.status.value?.statusCategory?.id;
};
const $0a42648be66bacce$export$6395cbfb900cdf4e = (0, $ahm5r.createSelector)((0, $6t0ps.fieldsSelector), (fields)=>$0a42648be66bacce$export$697a560dc772eca6(fields));
const $0a42648be66bacce$export$57e1ff0824f418cd = (0, $ahm5r.createSelector)((0, $6t0ps.fieldsSelector), (fields)=>$0a42648be66bacce$export$7bead7bb2ab962ba(fields));
const $0a42648be66bacce$export$7bead7bb2ab962ba = (fields)=>{
    if (({}).hasOwnProperty.call(fields, 'summary')) return fields.summary.value;
};
const $0a42648be66bacce$export$43d733e4b7e8c7d0 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$69316f88206ca90b, (projectType)=>projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT));
const $0a42648be66bacce$export$abb64932cd9b1784 = (0, $ahm5r.createSelector)($0a42648be66bacce$export$69316f88206ca90b, (projectType)=>projectType === (0, $ln6Iy.CUSTOMER_SERVICE_PROJECT));

});
const $ab6982cc941e6f7e$export$26d55645375ca9a = 'LOADING';
const $ab6982cc941e6f7e$export$1b56cc494043d9bf = 'PREVIEW';
const $ab6982cc941e6f7e$export$1660a2d7c2fff354 = 'COMPLETE';

parcelRegister("8oOr4", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $78be9cd6dc1a4416$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $78be9cd6dc1a4416$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $78be9cd6dc1a4416$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $78be9cd6dc1a4416$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $78be9cd6dc1a4416$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $78be9cd6dc1a4416$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $78be9cd6dc1a4416$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $78be9cd6dc1a4416$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $78be9cd6dc1a4416$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $78be9cd6dc1a4416$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $78be9cd6dc1a4416$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $78be9cd6dc1a4416$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $78be9cd6dc1a4416$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $78be9cd6dc1a4416$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $78be9cd6dc1a4416$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $78be9cd6dc1a4416$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $78be9cd6dc1a4416$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $78be9cd6dc1a4416$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $78be9cd6dc1a4416$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $78be9cd6dc1a4416$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $78be9cd6dc1a4416$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $78be9cd6dc1a4416$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $78be9cd6dc1a4416$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $78be9cd6dc1a4416$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $78be9cd6dc1a4416$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $78be9cd6dc1a4416$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $78be9cd6dc1a4416$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $78be9cd6dc1a4416$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $78be9cd6dc1a4416$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $78be9cd6dc1a4416$export$aba22e09a66f6826);
$parcel$export(module.exports, "SELECT_CUSTOM_FIELD_TYPE", () => $78be9cd6dc1a4416$export$826d657005bbe54c);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $78be9cd6dc1a4416$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $78be9cd6dc1a4416$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $78be9cd6dc1a4416$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $78be9cd6dc1a4416$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $78be9cd6dc1a4416$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $78be9cd6dc1a4416$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $78be9cd6dc1a4416$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $78be9cd6dc1a4416$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $78be9cd6dc1a4416$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $78be9cd6dc1a4416$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $78be9cd6dc1a4416$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $78be9cd6dc1a4416$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $78be9cd6dc1a4416$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $78be9cd6dc1a4416$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $78be9cd6dc1a4416$export$902f6c5cc939598a);

var $kkiRT = parcelRequire("kkiRT");

var $ln6Iy = parcelRequire("ln6Iy");

var $814y1 = parcelRequire("814y1");
const $78be9cd6dc1a4416$export$ebb48b08205007c5 = 'issuetype';
const $78be9cd6dc1a4416$export$a464614f8f5fe986 = 'summary';
const $78be9cd6dc1a4416$export$a311a3c9b207604e = 'parent';
const $78be9cd6dc1a4416$export$2a4f270075a033de = 'parent-issue';
const $78be9cd6dc1a4416$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $78be9cd6dc1a4416$export$289917d9a7031e1d = 'watches';
const $78be9cd6dc1a4416$export$81614f6dc3be5b00 = 'votes';
const $78be9cd6dc1a4416$export$72a5630aa398d6b4 = 'security';
const $78be9cd6dc1a4416$export$caf1ff54fbdf44bf = 'issuerestriction';
const $78be9cd6dc1a4416$export$f8f7545d2bb78afb = 'assignee';
const $78be9cd6dc1a4416$export$6d7021166edc895c = 'reporter';
const $78be9cd6dc1a4416$export$cf7e173386d30cdd = 'duedate';
const $78be9cd6dc1a4416$export$bb34f3538ba26c7e = 'priority';
const $78be9cd6dc1a4416$export$79b91d4669dcadcb = 'labels';
const $78be9cd6dc1a4416$export$cbedbfe2cd0caec7 = 'components';
const $78be9cd6dc1a4416$export$950d47e775e208ee = 'devSummary';
const $78be9cd6dc1a4416$export$f91d2bb4cc99fa5e = 'releases';
const $78be9cd6dc1a4416$export$a316570a0dbfd2b0 = 'sprint';
const $78be9cd6dc1a4416$export$405b6d72f2d243a9 = 'storyPointsField';
const $78be9cd6dc1a4416$export$3cb4a99a332e4186 = 'epic';
const $78be9cd6dc1a4416$export$d7e18f5730074533 = 'fixVersions';
const $78be9cd6dc1a4416$export$c435f0000304e508 = 'versions';
const $78be9cd6dc1a4416$export$ee99ef6ee562a446 = 'timetracking';
const $78be9cd6dc1a4416$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $78be9cd6dc1a4416$export$e50006273435e7d4 = 'status';
const $78be9cd6dc1a4416$export$f1a6ce22cbb7eb32 = 'resolution';
const $78be9cd6dc1a4416$export$ff39ebd4bb12b718 = 'created';
const $78be9cd6dc1a4416$export$cd8e68094cb5c3cb = 'updated';
const $78be9cd6dc1a4416$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $78be9cd6dc1a4416$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $78be9cd6dc1a4416$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $78be9cd6dc1a4416$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $78be9cd6dc1a4416$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $78be9cd6dc1a4416$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $78be9cd6dc1a4416$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $78be9cd6dc1a4416$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $78be9cd6dc1a4416$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $78be9cd6dc1a4416$export$913055729e1380b2 = 'summary';
const $78be9cd6dc1a4416$export$d44826c816b5619b = 'description';
const $78be9cd6dc1a4416$export$a29989082612d0d9 = 'comment';
const $78be9cd6dc1a4416$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $78be9cd6dc1a4416$export$3b3d0889022c85b3 = 'children-issues';
const $78be9cd6dc1a4416$export$be46596bc6608f3b = 'environment';
const $78be9cd6dc1a4416$export$f528fadbfdb3c25e = 'subtasks';
const $78be9cd6dc1a4416$export$f10e53e8928b61bd = 'dataclassification';
const $78be9cd6dc1a4416$export$e0dfb65d1047c53c = (0, $814y1.PARENT_CF_TYPE);
const $78be9cd6dc1a4416$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $78be9cd6dc1a4416$export$826d657005bbe54c = (0, $814y1.SELECT_CF_TYPE);
const $78be9cd6dc1a4416$export$cdbd1eb3b05729e0 = 'flagActions';
const $78be9cd6dc1a4416$export$c161a774ec2e7e56 = 'cardCoverActions';
const $78be9cd6dc1a4416$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$78be9cd6dc1a4416$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$78be9cd6dc1a4416$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$78be9cd6dc1a4416$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $814y1.TEAM_CF_TYPE)]: (0, $814y1.TEAM_CF_TYPE),
        [(0, $814y1.PARENT_CF_TYPE)]: (0, $814y1.PARENT_CF_TYPE),
        [(0, $814y1.BASELINE_START_CF_TYPE)]: (0, $814y1.BASELINE_START_CF_TYPE),
        [(0, $814y1.BASELINE_END_CF_TYPE)]: (0, $814y1.BASELINE_END_CF_TYPE),
        [(0, $814y1.COLOR_CF_TYPE)]: (0, $814y1.COLOR_CF_TYPE),
        [(0, $814y1.EPIC_COLOR_TYPE)]: (0, $814y1.EPIC_COLOR_TYPE),
        [(0, $814y1.EPIC_NAME_TYPE)]: (0, $814y1.EPIC_NAME_TYPE)
    };
    return fields;
};
const $78be9cd6dc1a4416$export$87934b3672715c91 = [
    (0, $814y1.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $814y1.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $814y1.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $78be9cd6dc1a4416$var$serviceDeskCustomFields = [
    (0, $814y1.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $814y1.ORGANIZATIONS_CF_TYPE),
    (0, $814y1.REQUEST_LANGUAGE_CF_TYPE),
    (0, $814y1.REQUEST_FEEDBACK_CF_TYPE),
    (0, $814y1.APPROVALS_CF_TYPE),
    (0, $814y1.APPROVERS_LIST_CF_TYPE),
    (0, $814y1.REQUEST_TYPE_CF_TYPE),
    (0, $814y1.CMDB_OBJECT_CF_TYPE),
    (0, $814y1.RESPONDERS_CF_TYPE),
    (0, $814y1.MAJOR_INCIDENT_CF_TYPE),
    (0, $814y1.ENTITLEMENT_CF_TYPE),
    (0, $814y1.SENTIMENT_CF_TYPE),
    (0, $814y1.ORGANIZATION_CF_TYPE)
];
const $78be9cd6dc1a4416$export$efd443bccc4c01ed = ()=>[
        (0, $814y1.LABELS_CF_TYPE),
        (0, $814y1.TEXT_CF_TYPE),
        (0, $814y1.MULTI_USER_CF_TYPE),
        (0, $814y1.PARTICIPANTS_CF_TYPE),
        (0, $814y1.URL_CF_TYPE),
        (0, $814y1.NUMBER_CF_TYPE),
        (0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $814y1.SELECT_CF_TYPE),
        (0, $814y1.MULTI_SELECT_CF_TYPE),
        (0, $814y1.VERSION_CF_TYPE),
        (0, $814y1.TEXT_AREA_CF_TYPE),
        (0, $814y1.MULTI_VERSION_CF_TYPE),
        (0, $814y1.DATE_CF_TYPE),
        (0, $814y1.GROUP_CF_TYPE),
        (0, $814y1.MULTI_GROUP_CF_TYPE),
        (0, $814y1.USER_CF_TYPE),
        (0, $814y1.MULTI_CHECKBOXES_CF_TYPE),
        (0, $814y1.RADIO_BUTTONS_CF_TYPE),
        (0, $814y1.DATETIME_CF_TYPE),
        (0, $814y1.ASSETS_CF_TYPE),
        (0, $814y1.SERVICE_ENTITY_CF_TYPE),
        (0, $814y1.PEOPLE_CF_TYPE),
        (0, $814y1.CASCADING_SELECT_CF_TYPE),
        (0, $814y1.PROJECT_PICKER_CF_TYPE),
        (0, $814y1.TEAMS_PLATFORM_CF_TYPE),
        (0, $814y1.READ_ONLY_CF_TYPE),
        (0, $814y1.EPIC_STATUS_TYPE),
        (0, $814y1.MESSAGE_VIEW_CF_TYPE),
        (0, $814y1.MESSAGE_EDIT_CF_TYPE),
        (0, $814y1.CATEGORY_TYPE),
        (0, $814y1.GOALS_CF_TYPE),
        ...$78be9cd6dc1a4416$export$87934b3672715c91,
        ...$78be9cd6dc1a4416$var$serviceDeskCustomFields
    ];
const $78be9cd6dc1a4416$export$a18b3a656ee9c709 = {
    [(0, $ln6Iy.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $ln6Iy.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $ln6Iy.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $78be9cd6dc1a4416$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $78be9cd6dc1a4416$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $kkiRT.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $kkiRT.default).SOFTWARE_ISSUE,
        issueActions: [
            $78be9cd6dc1a4416$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $kkiRT.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $78be9cd6dc1a4416$export$cdbd1eb3b05729e0,
            $78be9cd6dc1a4416$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $kkiRT.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $78be9cd6dc1a4416$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $kkiRT.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $78be9cd6dc1a4416$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $kkiRT.default).MOBILE_ISSUE,
        issueActions: []
    });
const $78be9cd6dc1a4416$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $kkiRT.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $kkiRT.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78be9cd6dc1a4416$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            if (config.isSimplified) return $78be9cd6dc1a4416$export$aebf676dfa727a1c();
            return $78be9cd6dc1a4416$export$27e0678365e5dcff();
        case 0, $ln6Iy.CORE_PROJECT:
            return $78be9cd6dc1a4416$export$381ce08838c53afa();
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return $78be9cd6dc1a4416$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $78be9cd6dc1a4416$export$27e0678365e5dcff();
    }
    return $78be9cd6dc1a4416$export$27e0678365e5dcff();
};

});

parcelRegister("5EgB1", function(module, exports) {

$parcel$export(module.exports, "contextSelector", () => $8996f8462702b38d$export$c420c9f40402ab6d);
$parcel$export(module.exports, "accountIdloggedInUserSelector", () => $8996f8462702b38d$export$cb29341089829e17);
$parcel$export(module.exports, "orgIdSelector", () => $8996f8462702b38d$export$24984a39db14d8);
$parcel$export(module.exports, "loginRedirectUrlSelector", () => $8996f8462702b38d$export$767583fcce1653ec);
$parcel$export(module.exports, "issueKeySelector", () => $8996f8462702b38d$export$d22bc6271070f453);
$parcel$export(module.exports, "issueIdSelector", () => $8996f8462702b38d$export$31efbca30077ec1e);
$parcel$export(module.exports, "projectKeySelector", () => $8996f8462702b38d$export$404de5ac601b84bc);
$parcel$export(module.exports, "analyticsSourceSelector", () => $8996f8462702b38d$export$85a9d212d56669b4);
$parcel$export(module.exports, "cloudIdSelector", () => $8996f8462702b38d$export$b5a643cfff945455);
$parcel$export(module.exports, "issueAriSelector", () => $8996f8462702b38d$export$a2cdbba2136e72d3);
$parcel$export(module.exports, "commentAriSelector", () => $8996f8462702b38d$export$b600fd41c88f35c8);
$parcel$export(module.exports, "isAnonymousSelector", () => $8996f8462702b38d$export$a165ec261432d0b8);
$parcel$export(module.exports, "localeSelector", () => $8996f8462702b38d$export$f7b7935883444b11);
$parcel$export(module.exports, "issueActionsSelector", () => $8996f8462702b38d$export$b62cb5286b153905);
$parcel$export(module.exports, "applicationKeySelector", () => $8996f8462702b38d$export$6c7d07328f197de7);
$parcel$export(module.exports, "isMobileSelector", () => $8996f8462702b38d$export$4cbb8c74e98876a5);
$parcel$export(module.exports, "isBitbucketSelector", () => $8996f8462702b38d$export$245e5ba54167b84a);
$parcel$export(module.exports, "isServiceDeskSelector", () => $8996f8462702b38d$export$43d733e4b7e8c7d0);
$parcel$export(module.exports, "isEcosystemEnabledSelector", () => $8996f8462702b38d$export$9bffc1987c753bd9);
$parcel$export(module.exports, "rapidViewIdSelector", () => $8996f8462702b38d$export$718e830000b27a0e);
$parcel$export(module.exports, "boardTypeSelector", () => $8996f8462702b38d$export$5af08fd769c0f0);
$parcel$export(module.exports, "boardIdSelector", () => $8996f8462702b38d$export$955e7dbf76b61f80);
$parcel$export(module.exports, "siteAdminStatusSelector", () => $8996f8462702b38d$export$93badd2a066af8bd);
$parcel$export(module.exports, "appPermissionsSelector", () => $8996f8462702b38d$export$5b71e1eb43056b6c);
$parcel$export(module.exports, "isModalSelector", () => $8996f8462702b38d$export$5fa593caa6a15917);
$parcel$export(module.exports, "shouldRenderHeaderSelector", () => $8996f8462702b38d$export$631793d49dec78de);
$parcel$export(module.exports, "viewModeSelector", () => $8996f8462702b38d$export$1f11fe78e4f22d45);
$parcel$export(module.exports, "appEditionsSelector", () => $8996f8462702b38d$export$28ca74e18c8f4529);
$parcel$export(module.exports, "tenantHasActiveServiceDeskLicenseSelector", () => $8996f8462702b38d$export$96c87532aec3474a);
$parcel$export(module.exports, "tenantHasActiveProductDiscoveryLicenseSelector", () => $8996f8462702b38d$export$f049ad7141428191);
$parcel$export(module.exports, "hasActivatedConfluenceWithinFourteenDaysSelector", () => $8996f8462702b38d$export$2b8e6729c89e24f5);
$parcel$export(module.exports, "hasActivatedConfluenceWithinSixtythreeDaysSelector", () => $8996f8462702b38d$export$a7671b4425572dc1);
$parcel$export(module.exports, "hasActivatedConfluenceWithinThirtyDaysSelector", () => $8996f8462702b38d$export$2321d15582b8ce8a);

var $ahm5r = parcelRequire("ahm5r");

var $1xngw = parcelRequire("1xngw");
var $lR3AG = parcelRequire("lR3AG");
var $kQ82p = parcelRequire("kQ82p");
var $2InI0 = parcelRequire("2InI0");
var $iux1t = parcelRequire("iux1t");


var $aYncF = parcelRequire("aYncF");

var $dNyY6 = parcelRequire("dNyY6");

var $8oOr4 = parcelRequire("8oOr4");

var $ljej9 = parcelRequire("ljej9");

var $hmtVp = parcelRequire("hmtVp");

var $8oKDI = parcelRequire("8oKDI");
const $8996f8462702b38d$export$c420c9f40402ab6d = (state)=>state.context;
const $8996f8462702b38d$export$cb29341089829e17 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.atlassianAccountId);
const $8996f8462702b38d$export$24984a39db14d8 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context?.orgId || null);
const $8996f8462702b38d$export$767583fcce1653ec = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.loginRedirectUrl);
const $8996f8462702b38d$export$d22bc6271070f453 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>(0, $ljej9.toIssueKey)(context.issueKey));
const $8996f8462702b38d$export$31efbca30077ec1e = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.issueId);
const $8996f8462702b38d$export$404de5ac601b84bc = (0, $ahm5r.createSelector)($8996f8462702b38d$export$d22bc6271070f453, (issueKey)=>(0, $dNyY6.extractProjectKey)(issueKey));
const $8996f8462702b38d$export$85a9d212d56669b4 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.analyticsSource !== undefined ? context.analyticsSource : undefined);
const $8996f8462702b38d$export$b5a643cfff945455 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.cloudId || (0, $ljej9.toCloudId)(''));
const $8996f8462702b38d$export$a2cdbba2136e72d3 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$b5a643cfff945455, $8996f8462702b38d$export$31efbca30077ec1e, (cloudId, issueId)=>(0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    }));
const $8996f8462702b38d$export$b600fd41c88f35c8 = (commentId)=>(0, $ahm5r.createSelector)($8996f8462702b38d$export$b5a643cfff945455, $8996f8462702b38d$export$31efbca30077ec1e, (cloudId, issueId)=>`ari:cloud:jira:${cloudId}:issue-comment/${issueId ?? ''}/${commentId}`);
const $8996f8462702b38d$export$2335b963a9875096 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.activationId || (0, $ljej9.toActivationId)(''));
const $8996f8462702b38d$export$a165ec261432d0b8 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.isAnonymous);
const $8996f8462702b38d$export$f7b7935883444b11 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.locale);
const $8996f8462702b38d$export$b62cb5286b153905 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.issueActions || []);
const $8996f8462702b38d$export$6c7d07328f197de7 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.applicationKey);
const $8996f8462702b38d$export$4cbb8c74e98876a5 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$8996f8462702b38d$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $d851676a1c983028$export$ce88447986394f2d));
const $8996f8462702b38d$export$6fbe1dbaf5b67cc5 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $8oOr4.simpleSoftwareBoardConfiguration)().applicationKey || applicationKey === (0, $8oOr4.standardRoadmapConfiguration)().applicationKey);
const $8996f8462702b38d$export$7479ef2453efd3b4 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $8oOr4.softwareConfiguration)().applicationKey);
const $8996f8462702b38d$export$245e5ba54167b84a = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$8996f8462702b38d$export$85a9d212d56669b4, (analyticsSource)=>analyticsSource === (0, $d851676a1c983028$export$7552fe2669628499));
const $8996f8462702b38d$export$43d733e4b7e8c7d0 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$6c7d07328f197de7, (applicationKey)=>applicationKey === (0, $8oOr4.serviceDeskConfiguration)().applicationKey);
const $8996f8462702b38d$export$9bffc1987c753bd9 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>!!context.ecosystemEnabled);
const $8996f8462702b38d$export$718e830000b27a0e = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.rapidViewId);
const $8996f8462702b38d$export$8065de5fbcf23af5 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.estimationStatistic || null);
const $8996f8462702b38d$export$5af08fd769c0f0 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.boardType);
const $8996f8462702b38d$export$955e7dbf76b61f80 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.boardId);
const $8996f8462702b38d$export$93badd2a066af8bd = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.siteAdminStatus);
const $8996f8462702b38d$export$b468116a08f9183e = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.productCrossSellConfig);
const $8996f8462702b38d$export$f29192b357e6beca = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.licensedProducts);
const $8996f8462702b38d$export$5b71e1eb43056b6c = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.appPermissions);
const $8996f8462702b38d$export$5fa593caa6a15917 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.isModal);
const $8996f8462702b38d$export$631793d49dec78de = (0, $ahm5r.createSelector)($8996f8462702b38d$export$5fa593caa6a15917, $8996f8462702b38d$export$4cbb8c74e98876a5, (isModal, isMobile)=>!isModal && !isMobile);
const $8996f8462702b38d$export$1f11fe78e4f22d45 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.viewMode);
const $8996f8462702b38d$export$28ca74e18c8f4529 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.appEditions);
const $8996f8462702b38d$export$beea798086c18f0a = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.licenseStates);
const $8996f8462702b38d$export$40487a15195e570e = (0, $ahm5r.createSelector)($8996f8462702b38d$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.serviceDesk === (0, $hmtVp.LICENSE_STATE_ACTIVE));
const $8996f8462702b38d$export$96c87532aec3474a = (0, $ahm5r.createSelector)($8996f8462702b38d$export$f29192b357e6beca, $8996f8462702b38d$export$40487a15195e570e, (licensedProducts, isServiceDeskLicenseActive)=>licensedProducts && licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_SERVICEDESK] && isServiceDeskLicenseActive);
const $8996f8462702b38d$export$2fa17c0746682b0b = (0, $ahm5r.createSelector)($8996f8462702b38d$export$beea798086c18f0a, (licenseStates)=>licenseStates && licenseStates.productDiscovery === (0, $hmtVp.LICENSE_STATE_ACTIVE));
const $8996f8462702b38d$export$f049ad7141428191 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$f29192b357e6beca, $8996f8462702b38d$export$2fa17c0746682b0b, (licensedProducts, isProductDiscoveryLicenseActive)=>Boolean(licensedProducts && licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_PRODUCT_DISCOVERY] && isProductDiscoveryLicenseActive));
const $8996f8462702b38d$export$747a61878b414bda = (0, $ahm5r.createSelector)($8996f8462702b38d$export$c420c9f40402ab6d, (context)=>context.confluenceActivationDate);
const $8996f8462702b38d$export$2b8e6729c89e24f5 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $1xngw.default)(new Date());
        const fourteenDaysAgo = (0, $2InI0.default)((0, $iux1t.default)(today, 14));
        const dateToCheck = (0, $kQ82p.default)(confluenceActivationDate);
        return (0, $lR3AG.default)(dateToCheck, {
            start: fourteenDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});
const $8996f8462702b38d$export$a7671b4425572dc1 = (0, $ahm5r.createSelector)($8996f8462702b38d$export$747a61878b414bda, (confluenceActivationDate)=>{
    if (!confluenceActivationDate) return false;
    const today = (0, $1xngw.default)(new Date());
    const sixtythreeDaysAgo = (0, $2InI0.default)((0, $iux1t.default)(today, 63));
    const dateToCheck = (0, $kQ82p.default)(confluenceActivationDate);
    return (0, $lR3AG.default)(dateToCheck, {
        start: sixtythreeDaysAgo,
        end: today
    });
});
const $8996f8462702b38d$export$2321d15582b8ce8a = (0, $ahm5r.createSelector)($8996f8462702b38d$export$747a61878b414bda, (confluenceActivationDate)=>{
    try {
        if (!confluenceActivationDate) return false;
        const today = (0, $1xngw.default)(new Date());
        const thirtyDaysAgo = (0, $2InI0.default)((0, $iux1t.default)(today, 31)); // 31 days to account for the 30 day trial
        const dateToCheck = (0, $kQ82p.default)(confluenceActivationDate);
        return (0, $lR3AG.default)(dateToCheck, {
            start: thirtyDaysAgo,
            end: today
        });
    } catch (error) {
        return false;
    }
});

});
parcelRegister("8oKDI", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $250d353c2bab97a6$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $250d353c2bab97a6$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $250d353c2bab97a6$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $250d353c2bab97a6$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $250d353c2bab97a6$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $250d353c2bab97a6$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $250d353c2bab97a6$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $250d353c2bab97a6$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $250d353c2bab97a6$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $250d353c2bab97a6$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $250d353c2bab97a6$export$8e68286aef4c3a8b = (ari)=>$250d353c2bab97a6$var$ARI_REG_EXP.test(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_WORKSPACE.test(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_ACTIVATION.test(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $250d353c2bab97a6$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $250d353c2bab97a6$export$24b47820a324e614 = (ari)=>{
    if ($250d353c2bab97a6$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $250d353c2bab97a6$export$e2789192113e8b07 = (ari, defaultValue = '')=>$250d353c2bab97a6$export$24b47820a324e614(ari) ?? defaultValue;
const $250d353c2bab97a6$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($250d353c2bab97a6$export$8e68286aef4c3a8b(ari)) {
        const parts = $250d353c2bab97a6$var$ARI_REG_EXP.exec(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $250d353c2bab97a6$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $250d353c2bab97a6$export$3d8d7031a11613fd = (ari)=>{
    const config = $250d353c2bab97a6$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});


parcelRegister("6t0ps", function(module, exports) {

$parcel$export(module.exports, "fieldsSelector", () => $32ed8d2f1c11b95b$export$e1512647ca813bfa);
$parcel$export(module.exports, "fieldByCustomTypeSelector", () => $32ed8d2f1c11b95b$export$72dfc619a02c972c);
$parcel$export(module.exports, "customFieldIdSelector", () => $32ed8d2f1c11b95b$export$8ad8506b941e30dc);
$parcel$export(module.exports, "fieldSelector", () => $32ed8d2f1c11b95b$export$4ee5e7baedf94214);
$parcel$export(module.exports, "issueTypeIdSelector", () => $32ed8d2f1c11b95b$export$22410768c09b3a82);
$parcel$export(module.exports, "issueTypeNameSelector", () => $32ed8d2f1c11b95b$export$477df8db13e4dac3);
$parcel$export(module.exports, "hasSubtasksSelector", () => $32ed8d2f1c11b95b$export$f363078714850fd9);
$parcel$export(module.exports, "hasSubtasksValuesSelector", () => $32ed8d2f1c11b95b$export$689f8f96c9d81e1b);
$parcel$export(module.exports, "hasPortfolioChildIssuesSelector", () => $32ed8d2f1c11b95b$export$724b8972771ff092);
$parcel$export(module.exports, "hasPortfolioChildIssueValuesSelector", () => $32ed8d2f1c11b95b$export$c6d2d4f8e243ac37);
$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $32ed8d2f1c11b95b$export$29f34d4d7c528e9c);
$parcel$export(module.exports, "hasChildrenIssueValuesSelector", () => $32ed8d2f1c11b95b$export$9034aaa32d45814b);
$parcel$export(module.exports, "childIssuesLimitUrlSelector", () => $32ed8d2f1c11b95b$export$762e13908aaafb2d);
$parcel$export(module.exports, "availableFieldIdsSelector", () => $32ed8d2f1c11b95b$export$641248fa887fb9ea);
$parcel$export(module.exports, "fieldSchemaConfigurationSelector", () => $32ed8d2f1c11b95b$export$3c65874760e68948);
$parcel$export(module.exports, "isFieldEditableSelector", () => $32ed8d2f1c11b95b$export$76ece3d8c4244af2);
$parcel$export(module.exports, "fieldNameSelector", () => $32ed8d2f1c11b95b$export$2d1abc174b8a710e);
$parcel$export(module.exports, "fieldMetaKeySelector", () => $32ed8d2f1c11b95b$export$351970d5fcbd0b29);
$parcel$export(module.exports, "fieldARISelector", () => $32ed8d2f1c11b95b$export$f6363cecfaa3a9b0);
$parcel$export(module.exports, "fieldAutoCompleteUrlSelector", () => $32ed8d2f1c11b95b$export$d27105f13ab27906);
$parcel$export(module.exports, "fieldAllowedValuesSelector", () => $32ed8d2f1c11b95b$export$351dc1c32c2771ea);
$parcel$export(module.exports, "isFieldRequiredSelector", () => $32ed8d2f1c11b95b$export$4c5f76e28914074);
$parcel$export(module.exports, "fieldTypeSelector", () => $32ed8d2f1c11b95b$export$9e2f15437ff59992);
$parcel$export(module.exports, "fieldPersistedValueSelector", () => $32ed8d2f1c11b95b$export$ae4660b0b7ebeee9);
$parcel$export(module.exports, "fieldPendingValueSelector", () => $32ed8d2f1c11b95b$export$2ae929653dce6648);
$parcel$export(module.exports, "fieldDefaultValueSelector", () => $32ed8d2f1c11b95b$export$e648d6f58e9627eb);
$parcel$export(module.exports, "fieldEditingValueSelector", () => $32ed8d2f1c11b95b$export$487becf51bedcd03);
$parcel$export(module.exports, "fieldEditingAdfValueSelector", () => $32ed8d2f1c11b95b$export$31406f841bca5b75);
$parcel$export(module.exports, "fieldHtmlValueSelector", () => $32ed8d2f1c11b95b$export$e69c8171ecd8fde2);
$parcel$export(module.exports, "isFieldEditingSelector", () => $32ed8d2f1c11b95b$export$29e6b1cade110749);
$parcel$export(module.exports, "fieldEditSessionIdSelector", () => $32ed8d2f1c11b95b$export$c53ab145ef243c95);
$parcel$export(module.exports, "isFieldWaitingSelector", () => $32ed8d2f1c11b95b$export$30e972ebce44d9b8);
$parcel$export(module.exports, "fieldInvalidMessageSelector", () => $32ed8d2f1c11b95b$export$d323462f155519c3);
$parcel$export(module.exports, "fieldInvalidSelector", () => $32ed8d2f1c11b95b$export$e35f4d21d9739426);
$parcel$export(module.exports, "isRichTextFieldSelector", () => $32ed8d2f1c11b95b$export$120a4249e9b3c231);
$parcel$export(module.exports, "richTextFieldIdsSelector", () => $32ed8d2f1c11b95b$export$862745d3ab4003e5);
$parcel$export(module.exports, "isRichTextFieldEditingSelector", () => $32ed8d2f1c11b95b$export$df9b7004d8b93e46);
$parcel$export(module.exports, "isMultilineFieldSelector", () => $32ed8d2f1c11b95b$export$4d0b1fe809ae5e75);
$parcel$export(module.exports, "getEditingMultilineFieldIdsSelector", () => $32ed8d2f1c11b95b$export$2469330614f0dba9);

var $ahm5r = parcelRequire("ahm5r");

var $6kS6u = parcelRequire("6kS6u");

var $eSnSE = parcelRequire("eSnSE");


var $32zMs = parcelRequire("32zMs");

var $8oOr4 = parcelRequire("8oOr4");

var $814y1 = parcelRequire("814y1");


var $5EgB1 = parcelRequire("5EgB1");

var $enPW4 = parcelRequire("enPW4");

var $ljwVo = parcelRequire("ljwVo");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32ed8d2f1c11b95b$var$STABLE_EMPTY_ARRAY = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32ed8d2f1c11b95b$var$STABLE_EMPTY_OBJECT = {};
const $32ed8d2f1c11b95b$export$e1512647ca813bfa = (state)=>state.fields || $32ed8d2f1c11b95b$var$STABLE_EMPTY_OBJECT;
const $32ed8d2f1c11b95b$var$getFieldByCustomType = (customType, fields)=>(0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(fields, (field)=>(field.schema && field.schema.custom) === customType);
const $32ed8d2f1c11b95b$export$46dde968006cd8d4 = (fieldId, fields)=>{
    let field = fields[fieldId];
    const customSystemFields = (0, $8oOr4.specialFields)();
    if (!field && Object.keys(customSystemFields).includes(fieldId)) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        const customType = customSystemFields[fieldId];
        // @ts-expect-error - TS2322 - Type 'Field | undefined' is not assignable to type 'Field'.
        field = $32ed8d2f1c11b95b$var$getFieldByCustomType(customType, fields);
    }
    return field;
};
const $32ed8d2f1c11b95b$export$cb67eba45dd11f50 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>!!fields[fieldId]);
const $32ed8d2f1c11b95b$export$309344981947f228 = (fieldsState, fieldName)=>Array.isArray(fieldsState[fieldName]?.value) ? fieldsState[fieldName].value.length > 0 : fieldsState[fieldName]?.value != null;
const $32ed8d2f1c11b95b$export$72dfc619a02c972c = (customType)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>$32ed8d2f1c11b95b$var$getFieldByCustomType(customType, fields));
const $32ed8d2f1c11b95b$export$8ad8506b941e30dc = (customFieldType)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$72dfc619a02c972c(customFieldType), (customField)=>{
        const idCandidates = customField ? customField.key.match(/customfield_(\d+)$/i) : null;
        return idCandidates ? +idCandidates[1] : null;
    });
const $32ed8d2f1c11b95b$export$4ee5e7baedf94214 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>$32ed8d2f1c11b95b$export$46dde968006cd8d4(fieldId, fields));
const $32ed8d2f1c11b95b$var$issueTypeFieldSelector = $32ed8d2f1c11b95b$export$4ee5e7baedf94214((0, $8oOr4.ISSUE_TYPE));
const $32ed8d2f1c11b95b$export$22410768c09b3a82 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$var$issueTypeFieldSelector, (issueType)=>(issueType && issueType.value && issueType.value.id) ?? null);
const $32ed8d2f1c11b95b$export$477df8db13e4dac3 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$var$issueTypeFieldSelector, (issueType)=>(issueType && issueType.value && issueType.value.name) ?? null);
const $32ed8d2f1c11b95b$export$b8de62018cc85a18 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>$32ed8d2f1c11b95b$export$46dde968006cd8d4(fieldId, fields));
const $32ed8d2f1c11b95b$export$3c65f67962ca81cc = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $c78d361852e02509$export$a5fc282ab2bf9b89)));
const $32ed8d2f1c11b95b$export$f363078714850fd9 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes('subtasks'));
const $32ed8d2f1c11b95b$export$689f8f96c9d81e1b = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>$32ed8d2f1c11b95b$export$309344981947f228(fields, 'subtasks'));
const $32ed8d2f1c11b95b$export$724b8972771ff092 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $8oOr4.PORTFOLIO_CHILD_ISSUES)));
const $32ed8d2f1c11b95b$export$c6d2d4f8e243ac37 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>$32ed8d2f1c11b95b$export$309344981947f228(fields, (0, $8oOr4.PORTFOLIO_CHILD_ISSUES)));
const $32ed8d2f1c11b95b$export$29f34d4d7c528e9c = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>!!Object.keys(fields).includes((0, $8oOr4.CHILDREN_ISSUES)));
const $32ed8d2f1c11b95b$export$9034aaa32d45814b = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>$32ed8d2f1c11b95b$export$309344981947f228(fields, (0, $8oOr4.CHILDREN_ISSUES)));
const $32ed8d2f1c11b95b$export$762e13908aaafb2d = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>{
    const getChildIssueUrlSelector = (fieldId)=>fields?.[fieldId]?.issueLimitUrl || '';
    return getChildIssueUrlSelector;
});
const $32ed8d2f1c11b95b$export$9ee3b3f5d4ad4423 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>Object.keys(fields).map((fieldKey)=>$32ed8d2f1c11b95b$export$46dde968006cd8d4(fieldKey, fields)).filter(Boolean));
const $32ed8d2f1c11b95b$export$641248fa887fb9ea = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (fields)=>Object.keys(fields));
const $32ed8d2f1c11b95b$export$e50b5889a6b86caf = (field)=>field ? field.editable : false;
const $32ed8d2f1c11b95b$export$3c65874760e68948 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.configuration && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        field.schema.configuration.reduce((config, { key: key, value: value })=>({
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...config,
                [key]: value
            }), {}));
const $32ed8d2f1c11b95b$export$76ece3d8c4244af2 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>$32ed8d2f1c11b95b$export$e50b5889a6b86caf(field));
const $32ed8d2f1c11b95b$export$2d1abc174b8a710e = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>{
        if (field && field.title) return field.title;
        (0, $eSnSE.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
        return '';
    });
const $32ed8d2f1c11b95b$export$d20285fb6e3fb007 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$b8de62018cc85a18, (state, { fieldId: fieldId })=>fieldId, (field, fieldId)=>{
    if (field?.title) return field.title;
    (0, $eSnSE.default).safeWarnWithoutCustomerData('issue.field.selector', `${fieldId} does not have a field title`);
    return '';
});
const $32ed8d2f1c11b95b$export$351970d5fcbd0b29 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && field.key);
const $32ed8d2f1c11b95b$export$f6363cecfaa3a9b0 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.ari : undefined);
const $32ed8d2f1c11b95b$export$d27105f13ab27906 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && field.autoCompleteUrl);
const $32ed8d2f1c11b95b$export$351dc1c32c2771ea = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.allowedValues : $32ed8d2f1c11b95b$var$STABLE_EMPTY_ARRAY);
const $32ed8d2f1c11b95b$export$4c5f76e28914074 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.required : false);
const $32ed8d2f1c11b95b$export$9e2f15437ff59992 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $32zMs.getFieldType)(field));
const $32ed8d2f1c11b95b$export$ae4660b0b7ebeee9 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && field.value);
const $32ed8d2f1c11b95b$export$bf3f8fd2c145740 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$b8de62018cc85a18, (field)=>field?.value);
const $32ed8d2f1c11b95b$export$2ae929653dce6648 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $ljwVo.default)(field));
const $32ed8d2f1c11b95b$export$e648d6f58e9627eb = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field?.adfValue);
const $32ed8d2f1c11b95b$export$487becf51bedcd03 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && (0, $enPW4.default)(field));
const $32ed8d2f1c11b95b$export$31406f841bca5b75 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (field)=>field && (0, $enPW4.getEditingAdfValue)(field));
const $32ed8d2f1c11b95b$export$e69c8171ecd8fde2 = (fieldId)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && field.renderedValue);
const $32ed8d2f1c11b95b$export$4e96991314eba25 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$b8de62018cc85a18, (field)=>field?.renderedValue);
const $32ed8d2f1c11b95b$export$18ec1d851ee244b3 = (field)=>field ? field.editingValue !== undefined : false;
const $32ed8d2f1c11b95b$export$29e6b1cade110749 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>$32ed8d2f1c11b95b$export$18ec1d851ee244b3(field));
const $32ed8d2f1c11b95b$export$c53ab145ef243c95 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>(field ? field.fieldEditSessionId : null) || '');
const $32ed8d2f1c11b95b$export$30e972ebce44d9b8 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field ? field.pendingValue !== undefined : false);
const $32ed8d2f1c11b95b$export$d323462f155519c3 = (fieldId, fallbackInvalidMessage)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && (field.isInvalid ? field.invalidMessage || fallbackInvalidMessage : null));
const $32ed8d2f1c11b95b$export$e35f4d21d9739426 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>Boolean(field && field.isInvalid));
const $32ed8d2f1c11b95b$export$448aaad27e620666 = (fieldId)=>// @ts-expect-error - TS2322 - Type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, string | ... 1 mo...' is not assignable to type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => string | null'.
    (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214(fieldId), (field)=>field && field.schema && field.schema.renderer);
const $32ed8d2f1c11b95b$export$94cc87cea4e06b09 = (fieldType)=>fieldType === (0, $814y1.TEXT_AREA_CF_TYPE) || fieldType === (0, $8oOr4.ENVIRONMENT) || fieldType === (0, $8oOr4.DESCRIPTION);
const $32ed8d2f1c11b95b$export$120a4249e9b3c231 = (fieldId)=>(0, $ahm5r.createSelector)((0, $5EgB1.isServiceDeskSelector), $32ed8d2f1c11b95b$export$9e2f15437ff59992(fieldId), $32ed8d2f1c11b95b$export$448aaad27e620666(fieldId), (isServiceDesk, fieldType, fieldRenderer)=>{
        const isDescription = fieldId === (0, $8oOr4.DESCRIPTION);
        const isMultilineRichTextField = $32ed8d2f1c11b95b$export$94cc87cea4e06b09(fieldType) && fieldRenderer === (0, $6e3c8900fd92f5d7$export$89b8c5d86c10a68c);
        return isDescription || isMultilineRichTextField;
    });
const $32ed8d2f1c11b95b$export$862745d3ab4003e5 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$32ed8d2f1c11b95b$export$120a4249e9b3c231(fieldId)(state)));
const $32ed8d2f1c11b95b$export$df9b7004d8b93e46 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$862745d3ab4003e5, (state)=>state, (richTextFieldIds, state)=>richTextFieldIds.some((fieldId)=>$32ed8d2f1c11b95b$export$29e6b1cade110749(fieldId)(state)));
const $32ed8d2f1c11b95b$export$4d0b1fe809ae5e75 = (fieldId)=>(0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$9e2f15437ff59992(fieldId), (fieldType)=>$32ed8d2f1c11b95b$export$94cc87cea4e06b09(fieldType));
const $32ed8d2f1c11b95b$export$3263c202444b0e0 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$e1512647ca813bfa, (state)=>state, (fields, state)=>Object.keys(fields).filter((fieldId)=>$32ed8d2f1c11b95b$export$4d0b1fe809ae5e75(fieldId)(state)));
const $32ed8d2f1c11b95b$export$2469330614f0dba9 = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$3263c202444b0e0, (state)=>state, (multilineFieldsIds, state)=>multilineFieldsIds.filter((fieldId)=>$32ed8d2f1c11b95b$export$29e6b1cade110749(fieldId)(state)));
const $32ed8d2f1c11b95b$export$a2fc0905011957cb = (0, $ahm5r.createSelector)($32ed8d2f1c11b95b$export$4ee5e7baedf94214((0, $8oOr4.FIX_VERSIONS)), $32ed8d2f1c11b95b$export$4ee5e7baedf94214((0, $8oOr4.AFFECTS_VERSIONS)), (fixVersions, affectsVersions)=>{
    const ids = [];
    if (fixVersions) ids.push(fixVersions.key);
    if (affectsVersions) ids.push(affectsVersions.key);
    return ids;
});

});
parcelRegister("32zMs", function(module, exports) {

$parcel$export(module.exports, "getFieldType", () => $ebfa3e5ab70c9d21$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isRichTextSupported", () => $ebfa3e5ab70c9d21$export$24d1b07fa0e9f9f1);


var $8oOr4 = parcelRequire("8oOr4");

var $814y1 = parcelRequire("814y1");
const $ebfa3e5ab70c9d21$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $8oOr4.specialFields)();
    return [
        ...(0, $8oOr4.customFieldsToDisplay)().filter((cf)=>!(0, $8oOr4.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $814y1.FLAGGED_CF_TYPE)
    ];
};
const $ebfa3e5ab70c9d21$export$f521834fc2bfcd81 = (custom)=>$ebfa3e5ab70c9d21$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $ebfa3e5ab70c9d21$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $ebfa3e5ab70c9d21$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
const $ebfa3e5ab70c9d21$export$24d1b07fa0e9f9f1 = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? fieldSchema.type === (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $6e3c8900fd92f5d7$export$89b8c5d86c10a68c) || $ebfa3e5ab70c9d21$export$b9089a6e41ed43aa(field) === (0, $814y1.DESCRIPTION_TYPE) : false;
};

});

const $c78d361852e02509$export$e18419056f3d184a = 'assignee';
const $c78d361852e02509$export$45cafdfd629c3ca1 = 'reporter';
const $c78d361852e02509$export$d5bc879e3b748593 = 'description';
const $c78d361852e02509$export$a68dbc90211df1a8 = 'fixVersions';
const $c78d361852e02509$export$93605f2a09aa8d26 = 'labels';
const $c78d361852e02509$export$4420b7468f889692 = 'status';
const $c78d361852e02509$export$e7cf1830fe735d1f = 'summary';
const $c78d361852e02509$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $c78d361852e02509$export$3fb78a14b7a56ff9 = 'timeestimate';
const $c78d361852e02509$export$a5fc282ab2bf9b89 = 'issuelinks';
const $c78d361852e02509$export$b52547457d714bc0 = 'epic-issues';
const $c78d361852e02509$export$3cca6e37a5823d5a = 'children-issues';
const $c78d361852e02509$export$98a935eb30de54ab = 'components';
const $c78d361852e02509$export$f7a17147527dd688 = 'flag';

parcelRegister("enPW4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f35e2fdfbb3de59e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getEditingAdfValue", () => $f35e2fdfbb3de59e$export$a799cf637c5b7727);

var $ljwVo = parcelRequire("ljwVo");
var /**
 * Returns the first available value for a given field.
 * editingValue => pendingValue => value
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f35e2fdfbb3de59e$export$2e2bcd8739ae039 = (field)=>typeof field.editingValue !== 'undefined' ? field.editingValue : (0, $ljwVo.default)(field);
const $f35e2fdfbb3de59e$export$a799cf637c5b7727 = (field)=>field.editingValue || (0, $ljwVo.getPendingAdfValue)(field);

});
parcelRegister("ljwVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e909d5c8ae6a695a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getPendingAdfValue", () => $e909d5c8ae6a695a$export$5012210a9f91b010);
var /**
 * Returns the first available value for a given field, excluding editingValue
 * pendingValue => value
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$e909d5c8ae6a695a$export$2e2bcd8739ae039 = (field)=>typeof field.pendingValue !== 'undefined' ? field.pendingValue : field.value;
const $e909d5c8ae6a695a$export$5012210a9f91b010 = (field)=>field.pendingValue || field.adfValue || field.value;

});





parcelRegister("5Kex0", function(module, exports) {

$parcel$export(module.exports, "afterPaintEmit", () => $e551590a66b717ec$export$dc4c3408669b8f4e);

var $6uWhG = parcelRequire("6uWhG");

const $e551590a66b717ec$export$dc4c3408669b8f4e = (emitMetrics, metric)=>{
    const stopTime = performance.now();
    setTimeout(()=>{
        metric.mark((0, $2e47af044bce450a$export$99c08ec92759c71c));
        (0, $6uWhG.setMark)((0, $2e47af044bce450a$export$99c08ec92759c71c));
        setTimeout(()=>{
            emitMetrics(stopTime);
        }, 500);
    });
};

});

parcelRegister("jKYv7", function(module, exports) {

$parcel$export(module.exports, "startUimTti", () => $951f65fe976acb1e$export$1422384676f6de7a);
$parcel$export(module.exports, "markUimTtiIssueViewLoaded", () => $951f65fe976acb1e$export$5a9389b70d93def2);
$parcel$export(module.exports, "stopTTI", () => $951f65fe976acb1e$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $951f65fe976acb1e$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $951f65fe976acb1e$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $951f65fe976acb1e$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $951f65fe976acb1e$export$d86f4868694f2aa7);

var $hqYEY = parcelRequire("hqYEY");
const $951f65fe976acb1e$var$uimInIssueViewTTI = (0, $hqYEY.metrics).interaction({
    key: 'ui-modifications-in-issue-view',
    timings: [
        {
            key: 'issue-view-tti-delta',
            startMark: 'issue-view-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ]
});
const $951f65fe976acb1e$export$1422384676f6de7a = ()=>{
    $951f65fe976acb1e$var$uimInIssueViewTTI.start();
};
const $951f65fe976acb1e$export$5a9389b70d93def2 = ()=>{
    $951f65fe976acb1e$var$uimInIssueViewTTI.mark('issue-view-tti');
};
const $951f65fe976acb1e$export$30ca4c461fab486c = (customData)=>{
    $951f65fe976acb1e$var$uimInIssueViewTTI.stop({
        customData: customData
    });
};
const $951f65fe976acb1e$export$27f2445288b528c = ()=>{
    $951f65fe976acb1e$var$uimInIssueViewTTI.cancel();
};
const $951f65fe976acb1e$export$7a2709fc1e33401a = ()=>{
    $951f65fe976acb1e$var$uimInIssueViewTTI.mark('iframe-load');
};
const $951f65fe976acb1e$export$cf3893335c93e33b = ()=>{
    $951f65fe976acb1e$var$uimInIssueViewTTI.mark('fields-registered');
};
const $951f65fe976acb1e$export$d86f4868694f2aa7 = ()=>{
    $951f65fe976acb1e$var$uimInIssueViewTTI.mark('oninit-resolved');
};

});

parcelRegister("9rEed", function(module, exports) {

$parcel$export(module.exports, "blockedOnBackendEntryLog", () => $ace7dce784e7caee$export$dd1b3502b1e8ca97);
$parcel$export(module.exports, "getBackendBlockingTime", () => $ace7dce784e7caee$export$8720c1f879c7ca46);

var $6uWhG = parcelRequire("6uWhG");


var $h6gfk = parcelRequire("h6gfk");

var $2eF7w = parcelRequire("2eF7w");
const $ace7dce784e7caee$export$dd1b3502b1e8ca97 = (0, $h6gfk.createBlockedOnBackendEntryLog)();
function $ace7dce784e7caee$var$measureBlockingEntry(measureName, backendBlockingStart, backendBlockingEnd) {
    (0, $6uWhG.setMark)(`${measureName}Start`, {
        startTime: backendBlockingStart
    });
    (0, $6uWhG.setMark)(`${measureName}End`, {
        startTime: backendBlockingEnd
    });
    (0, $6uWhG.setMeasure)(`${measureName}`, `${measureName}Start`, `${measureName}End`);
}
const $ace7dce784e7caee$export$8720c1f879c7ca46 = (args)=>{
    const { blockingStart: blockingStartOrZero, totalBlockingDuration: totalBlockingDuration } = (0, $2eF7w.getSimplifiedBlockingTime)($ace7dce784e7caee$export$dd1b3502b1e8ca97);
    const backendBlockingStart = Math.max(args.issueViewLoad.startTime, blockingStartOrZero);
    // Add the marks to the issueViewLoad BM3 event
    const backendBlockingEnd = backendBlockingStart + totalBlockingDuration;
    args.issueViewLoad.mark($edc3194f015d4646$export$e52cc35f872875f7, backendBlockingEnd);
    args.issueViewLoad.mark($edc3194f015d4646$export$e64e32643802b552, backendBlockingStart);
    $ace7dce784e7caee$export$dd1b3502b1e8ca97.getBlockedOnBackendEntries().forEach(([blockingReason, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>$ace7dce784e7caee$var$measureBlockingEntry(`issueView_blockedOnBackend_${blockingReason}`, blockingStart, blockingEnd));
    return {
        issueDataAvailable: backendBlockingEnd,
        issueReadyForData: backendBlockingStart
    };
};

});
parcelRegister("h6gfk", function(module, exports) {

$parcel$export(module.exports, "createBlockedOnBackendEntryLog", () => $4432ee80974f8c65$export$44ddca89673a78bc);
const $4432ee80974f8c65$export$44ddca89673a78bc = ()=>{
    const blockedOnBackendState = {
        timestamps: {}
    };
    // Internal use, use initialiseBlockedOnBackendStateForUpdatedKey externally
    const clearBlockedOnBackendState = ()=>{
        blockedOnBackendState.timestamps = {};
        blockedOnBackendState.currentKey = undefined;
    };
    // Internal use, use markStartBackendBlockingTimestamp or markEndBackendBlockingTimestamp
    const getOrCreateTimestampsEntryForKey = (blockingReasonKey)=>{
        let blockingDurationTimestamps = blockedOnBackendState.timestamps[blockingReasonKey];
        if (!blockingDurationTimestamps) {
            blockingDurationTimestamps = {};
            blockedOnBackendState.timestamps[blockingReasonKey] = blockingDurationTimestamps;
        }
        return blockingDurationTimestamps;
    };
    /**
	 * Initialise the store for a given key string.
	 * Only resets the state the first if the key string updates from its initial undefined OR if the key updates from the last time this was called
	 */ const initialiseBlockedOnBackendStateForUpdatedKey = (key)=>{
        if (key !== blockedOnBackendState.currentKey) {
            clearBlockedOnBackendState();
            blockedOnBackendState.currentKey = key;
        }
    };
    /**
	 * Fire this to mark the start of being blocked on backend for a given reason.
	 * @param blockingReasonKey An identifier for the reason for blocking. Until state is re-initialised, this reason cannot be used again to start a blocking span. Overlapping reasons will not be double counted
	 * @param timestamp optional, defaults to current time
	 */ const markStartBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
        const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
        if (!blockingDurationTimestamps.blockingStart) blockingDurationTimestamps.blockingStart = timestamp;
    };
    /**
	 * Fire this to mark the end of being blocked on backend for a given reason
	 * @param blockingReasonKey
	 * @param timestamp optional, defaults to current time
	 */ const markEndBackendBlockingTimestamp = (blockingReasonKey, timestamp = performance.now())=>{
        const blockingDurationTimestamps = getOrCreateTimestampsEntryForKey(blockingReasonKey);
        if (!blockingDurationTimestamps.blockingEnd) blockingDurationTimestamps.blockingEnd = timestamp;
    };
    /**
	 * Return a list of the entries gathered so far
	 * @param sorted whether the returned results should be sorted based on their start time. true by default
	 */ const getBlockedOnBackendEntries = ({ sorted: sorted = true } = {})=>{
        let entries = Object.entries(blockedOnBackendState.timestamps).filter((entry)=>{
            const [, blockingTimestamps] = entry;
            return blockingTimestamps.blockingStart != null && blockingTimestamps.blockingEnd != null && blockingTimestamps.blockingStart <= blockingTimestamps.blockingEnd;
        });
        if (sorted) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        entries = entries.sort(([, { blockingStart: start1 }], [, { blockingStart: start2 }])=>start1 - start2);
        return entries;
    };
    return {
        initialiseBlockedOnBackendStateForUpdatedKey: initialiseBlockedOnBackendStateForUpdatedKey,
        markStartBackendBlockingTimestamp: markStartBackendBlockingTimestamp,
        markEndBackendBlockingTimestamp: markEndBackendBlockingTimestamp,
        getBlockedOnBackendEntries: getBlockedOnBackendEntries
    };
};

});

parcelRegister("2eF7w", function(module, exports) {

$parcel$export(module.exports, "getSimplifiedBlockingTime", () => $ee7599896cbe5e4a$export$580550d1d1ffca6c);

var $7Tef0 = parcelRequire("7Tef0");
const $ee7599896cbe5e4a$export$580550d1d1ffca6c = (entryLog)=>{
    const blockingTimestampEntries = entryLog.getBlockedOnBackendEntries({
        sorted: true
    });
    const blockingSpans = (0, $7Tef0.mergeOverlappingBlockingEntries)(blockingTimestampEntries);
    const blockingStartTimes = blockingSpans.map(({ blockingStart: blockingStart })=>blockingStart ?? 0);
    const blockingDurations = blockingSpans.map(({ blockingEnd: blockingEnd, blockingStart: blockingStart })=>blockingEnd - blockingStart);
    const blockingStart = Math.min(...blockingStartTimes.length ? blockingStartTimes : [
        0
    ]);
    const totalBlockingDuration = blockingDurations.reduce((a, b)=>a + b, 0);
    return {
        blockingStart: blockingStart,
        totalBlockingDuration: totalBlockingDuration
    };
};

});
parcelRegister("7Tef0", function(module, exports) {

$parcel$export(module.exports, "mergeOverlappingBlockingEntries", () => $813facaf3304c37e$export$e63ec487944afc72);
function $813facaf3304c37e$export$e63ec487944afc72(blockingTimestampEntriesSortedByStartTime) {
    return blockingTimestampEntriesSortedByStartTime.reduce((nonOverlappingSpans, [, { blockingStart: blockingStart, blockingEnd: blockingEnd }])=>{
        const lastSpan = nonOverlappingSpans[nonOverlappingSpans.length - 1];
        if (!lastSpan || blockingStart > lastSpan.blockingEnd) nonOverlappingSpans.push({
            blockingStart: blockingStart,
            blockingEnd: blockingEnd
        }); // add the span as-is to the known non-overlapping spans
        else if (lastSpan.blockingEnd < blockingEnd) lastSpan.blockingEnd = blockingEnd;
        return nonOverlappingSpans;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    []);
}

});



parcelRegister("bnvw2", function(module, exports) {

$parcel$export(module.exports, "issueScaleabilityReporterFactory", () => $3395dfcdf7730d9c$export$9f6c068bd6582299);

var $7jTnu = parcelRequire("7jTnu");


var $eXloW = parcelRequire("eXloW");

var $8oOr4 = parcelRequire("8oOr4");

var $94ufU = parcelRequire("94ufU");

var $afLoP = parcelRequire("afLoP");

var $5EgB1 = parcelRequire("5EgB1");

var $6t0ps = parcelRequire("6t0ps");

var $6az7p = parcelRequire("6az7p");

var $5zOQO = parcelRequire("5zOQO");

var $dLJHp = parcelRequire("dLJHp");

var $aRxHj = parcelRequire("aRxHj");

var $d54uD = parcelRequire("d54uD");

var $4372d = parcelRequire("4372d");

var $4DuXn = parcelRequire("4DuXn");

var $gRQyv = parcelRequire("gRQyv");

var $l7OhZ = parcelRequire("l7OhZ");

var $dzwJE = parcelRequire("dzwJE");

var $8mcrY = parcelRequire("8mcrY");

var $814y1 = parcelRequire("814y1");

var $i2dM3 = parcelRequire("i2dM3");

var $9c4a4 = parcelRequire("9c4a4");
const $3395dfcdf7730d9c$var$getCascadingSelectFields = (state)=>Object.values((0, $6t0ps.fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, $814y1.CASCADING_SELECT_CF_TYPE));
const $3395dfcdf7730d9c$var$getAtlassianTeamFields = (state)=>Object.values((0, $6t0ps.fieldsSelector)(state)).filter((fieldValues)=>fieldValues.schema.custom === (0, $814y1.TEAMS_PLATFORM_CF_TYPE));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3395dfcdf7730d9c$var$getCascadingSelectOptionChildrenCount = (cascadingSelectFieldValue)=>{
    if (cascadingSelectFieldValue.length === 0) return 0;
    return Object.values(cascadingSelectFieldValue).reduce((accumulatedCount, parentValue)=>accumulatedCount + (parentValue?.children?.length || 1), 0);
};
const $3395dfcdf7730d9c$var$getCascadingSelectOptionsTotalCount = (state)=>{
    const cascadingSelectFields = $3395dfcdf7730d9c$var$getCascadingSelectFields(state);
    if (cascadingSelectFields.length === 0) return 0;
    return cascadingSelectFields.reduce((accumulatedCount, cascadingSelectField)=>accumulatedCount + ($3395dfcdf7730d9c$var$getCascadingSelectOptionChildrenCount(cascadingSelectField.allowedValues) || 1), 0);
};
const $3395dfcdf7730d9c$export$ae327590f8230d00 = ({ projectKey: projectKey, ecosystem: ecosystem, forge: forge })=>{
    let open = 0;
    let closed = 0;
    if (projectKey !== undefined) {
        // The context groups store the state of open / closed inside local storage, so we need to get access to that
        // here. It's not held in redux which is why we look it up this way.
        const groupLocalStorageName = (0, $94ufU.getGroupLocalStorageName)(projectKey, 'context-group');
        try {
            // It's possible panels are uninstalled and not removed from localstorage, so we need to check they are installed
            // otherwise the analytics may be incorrectly advising how many panels are open
            const installedPanels = [
                ...ecosystem.map((item)=>`${groupLocalStorageName}-${(0, $afLoP.generateContextPanelId)(item)}`),
                ...forge.map((item)=>`${groupLocalStorageName}-${item.id}`)
            ];
            open = Object.values((0, $94ufU.getGroupsLocalStorage)(installedPanels, (0, $e2e3f134560cc64f$export$e1184c3be46bd7cb))).filter(Boolean).length;
            // Panels may not exist in localStorage but may be installed, in which case they are closed as this is the default state
            closed = installedPanels.length - open;
        } catch  {
        // No action required
        }
    }
    return {
        open: open,
        closed: closed
    };
};
const $3395dfcdf7730d9c$var$getForgeMetadata = (state)=>{
    if (!(0, $7jTnu.fg)('report_detailed_connect_forge_to_reactufo')) return null;
    const metadata = {
        'forge:context_panels': (0, $dLJHp.forgeContextPanelsSelector)(state).length,
        'forge:activities': (0, $dLJHp.forgeIssueActivitySelector)(state).length,
        'forge:actions': (0, $dLJHp.forgeIssueActionsSelector)(state).length,
        'forge:panels': (0, $dLJHp.forgePanelsSelector)(state).length,
        'forge:custom_fields': (0, $dLJHp.forgeCustomFieldsSelector)(state).length,
        'forge:bg_scripts': (0, $5zOQO.issueViewBackgroundScriptsSelector)(state).length,
        'forge:glances': (0, $dLJHp.forgeGlancesSelector)(state).length
    };
    return metadata;
};
const $3395dfcdf7730d9c$export$9f6c068bd6582299 = (store, issueContextActions)=>()=>{
        const state = store.getState();
        const { permalinkType: permalinkType } = (0, $9c4a4.getPermalinkTypeAndId)() || {};
        const childIssues = (0, $6t0ps.fieldSelector)((0, $814y1.CHILDREN_ISSUES))(state);
        const proformaHarmonisation = (0, $6t0ps.fieldSelector)((0, $814y1.PROFORMA_FORMS))(state);
        const ecosystemContextPanels = (0, $5zOQO.contextPanelEntitiesSelector)(state);
        const { open: contextPanelOpenCount, closed: contextPanelClosedCount } = $3395dfcdf7730d9c$export$ae327590f8230d00({
            projectKey: state?.entities?.project?.projectKey,
            ecosystem: ecosystemContextPanels,
            forge: (0, $dLJHp.forgeContextPanelsSelector)(state)
        });
        const subtaskCount = (0, $6t0ps.childIssuesLimitUrlSelector)(state)((0, $8oOr4.SUBTASKS)) && issueContextActions ? (0, $eXloW.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : (0, $8mcrY.subtaskEntitiesSelector)(state).length;
        const childIssuesCount = (0, $6t0ps.childIssuesLimitUrlSelector)(state)((0, $814y1.CHILDREN_ISSUES)) && issueContextActions ? (0, $eXloW.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : childIssues?.value.length ?? 0;
        // If a portfolio issue is over the limit we cannot tell because
        // only the subtasks panel is displayed. Once the portfolio issue
        // type hierarchy level is a value > 1 then we can set this to ">100".
        let portfolioChildIssueCount;
        let actualSubtaskCount;
        let actualChildIssueCount;
        let actualEpicIssueCount;
        let epicIssueCount;
        const subtasks = (0, $6t0ps.fieldSelector)((0, $8oOr4.SUBTASKS))(state);
        const epicIssues = (0, $6t0ps.fieldSelector)((0, $8oOr4.EPIC_ISSUES))(state);
        const portfolioChildIssues = (0, $6t0ps.fieldSelector)((0, $8oOr4.PORTFOLIO_CHILD_ISSUES))(state);
        const getChildIssuesLimitUrl = (0, $6t0ps.childIssuesLimitUrlSelector)(state);
        const isEpicIssuesOverLimit = Boolean(getChildIssuesLimitUrl((0, $8oOr4.EPIC_ISSUES)));
        const isOverLimit = Boolean(getChildIssuesLimitUrl((0, $8oOr4.SUBTASKS))) || Boolean(getChildIssuesLimitUrl((0, $814y1.CHILDREN_ISSUES))) || isEpicIssuesOverLimit;
        if (isOverLimit) {
            actualChildIssueCount = childIssues?.originalContentLength ?? 0;
            actualEpicIssueCount = epicIssues?.originalContentLength ?? 0;
            // If epic issue is over the limit, we exclude the subtasks field
            // from the store. So we need to grab the data from the epicIssues field.
            actualSubtaskCount = isEpicIssuesOverLimit ? epicIssues?.otherOriginalChildIssuesLength ?? 0 : subtasks?.originalContentLength ?? 0;
            epicIssueCount = isEpicIssuesOverLimit && issueContextActions ? (0, $eXloW.getChildIssuesLimitExceededAnalyticsCount)(issueContextActions.getChildIssuesLimit()) : epicIssues?.originalContentLength ?? 0;
            // If portfolio issue is over the limit, we exclude the portfolio-child-issues field
            // from the store. So we need to grab the data from the subtasks field.
            portfolioChildIssueCount = subtasks?.otherOriginalChildIssuesLength ?? 0;
        } else {
            actualChildIssueCount = childIssues?.value.length ?? 0;
            actualSubtaskCount = subtasks?.value.length ?? 0;
            actualEpicIssueCount = epicIssues?.value.length ?? 0;
            portfolioChildIssueCount = portfolioChildIssues?.value.length ?? 0;
            epicIssueCount = actualEpicIssueCount;
        }
        let iframeCount = null;
        // This is is to check if the document is undefined in SSR. See https://hello.atlassian.net/wiki/x/jnEv2w
        if (typeof document !== 'undefined') iframeCount = document?.querySelectorAll('iframe')?.length;
        const ecosystemGlances = (0, $5zOQO.glancesSelector)(state).length;
        const ecosystemContentPanels = (0, $5zOQO.allContentPanelsSelector)(state).length;
        const ecosystemActivityPanels = (0, $5zOQO.activityPanelsSelector)(state).length;
        const ecosystemCustomsFields = (0, $d54uD.ecosystemCustomFieldIdsSelector)(state).length;
        const ecosystemTeams = ecosystemContextPanels.some((panel)=>panel.appKey === 'com.atlassian.atlas.jira');
        const ecosystemAutomation = ecosystemContextPanels.some((panel)=>panel.appKey === 'com.codebarrel.addons.automation');
        const ecosystemMetadata = (0, $7jTnu.fg)('report_detailed_connect_forge_to_reactufo') && {
            'connect:glances': ecosystemGlances,
            'connect:panels': ecosystemContentPanels,
            'connect:activities': ecosystemActivityPanels,
            'connect:context_panels': ecosystemContextPanels.length,
            'connect:custom_fields': ecosystemCustomsFields,
            'connect:has_teams': ecosystemTeams,
            'connect:has_automation': ecosystemAutomation
        };
        // Properties added here show up in:
        // - jira.fe.custom.issue-view-on-page-load
        // - jira.fe.page-load.issue-view
        // - and jira.fe.custom.embedded-issue-view-load
        // Verify these in the BM3 tab of the Chrome Analytics extension.
        return {
            ecosystemGlances: ecosystemGlances,
            ecosystemContentPanels: ecosystemContentPanels,
            contextPanelOpenCount: contextPanelOpenCount,
            contextPanelClosedCount: contextPanelClosedCount,
            ecosystemActivityPanels: ecosystemActivityPanels,
            ...(0, $7jTnu.fg)('report_detailed_connect_forge_to_reactufo') ? ecosystemMetadata : {},
            ...(0, $7jTnu.fg)('report_detailed_connect_forge_to_reactufo') ? $3395dfcdf7730d9c$var$getForgeMetadata(state) : {},
            iframeCount: iframeCount,
            hasIframe: Boolean(iframeCount),
            ecosystemCustomsFields: ecosystemCustomsFields,
            childIssues: childIssuesCount,
            linkIssueCount: (0, $gRQyv.combinedLinkedIssueCountSelector)(state),
            subtaskCount: subtaskCount,
            actualChildIssueCount: actualChildIssueCount,
            actualSubtaskCount: actualSubtaskCount,
            /* This is here because we do not currently get exposures for the gate, but if we have it then we
			 can get more accurate expreiment perf results in splunk. clean up with issue_view_ssr_perf_m2 */ modernSSRRolloutFG: (0, $7jTnu.fg)('issue-view-ssr-perf-m2'),
            actualEpicIssueCount: actualEpicIssueCount,
            actualPortfolioChildIssueCount: portfolioChildIssueCount,
            epicIssueCount: epicIssueCount,
            portfolioChildIssueCount: portfolioChildIssueCount,
            issueId: (0, $5EgB1.issueIdSelector)(state),
            commentsTotalCount: (0, $4DuXn.totalCommentsSelector)(state),
            hasCommentPermalink: permalinkType === (0, $i2dM3.COMMENTS),
            cascadingSelectCount: $3395dfcdf7730d9c$var$getCascadingSelectFields(state).length,
            isAtlassianTeamFieldEnabled: $3395dfcdf7730d9c$var$getAtlassianTeamFields(state).length > 0,
            cascadingSelectOptionsTotalCount: $3395dfcdf7730d9c$var$getCascadingSelectOptionsTotalCount(state),
            proformaHarmonisationEnabled: proformaHarmonisation ? proformaHarmonisation.value.isHarmonisationEnabled : false,
            hasSubtasksTypes: (0, $dzwJE.isSubtaskTypesPresentSelector)(state),
            issueTypesCount: (0, $l7OhZ.issueTypesSelector)(state).length,
            issueTypeHierarchyLevel: !(0, $6az7p.isSimplifiedProjectSelector)(state) ? (0, $4372d.issueTypeHierarchyLevelSelector)(state) : (0, $aRxHj.hierarchyLevelSelector)(state)
        };
    };

});
const $e2e3f134560cc64f$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $e2e3f134560cc64f$export$2aca0ebce9a48d61 = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.visible-fields';
const $e2e3f134560cc64f$export$fc60a8d420264e7d = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.hidden-fields';
const $e2e3f134560cc64f$export$e1184c3be46bd7cb = false;
const $e2e3f134560cc64f$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $e2e3f134560cc64f$export$988f0f6f6457039a = 'status-and-approval-spotlight';

parcelRegister("eXloW", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimitExceededAnalyticsCount", () => $66ad0d9cb9d0e204$export$8cbe27041ec414b7);
const $66ad0d9cb9d0e204$export$1e3c128c36bad9a4 = 'CHILD_ISSUES_LIMIT_EXCEEDED';
const $66ad0d9cb9d0e204$export$8cbe27041ec414b7 = (childIssuesLimit)=>`>${childIssuesLimit}`;

});

parcelRegister("94ufU", function(module, exports) {

$parcel$export(module.exports, "getGroupLocalStorageName", () => $5301aa1cc74608bd$export$a3b190a19b138f2e);
$parcel$export(module.exports, "getGroupLocalStorage", () => $5301aa1cc74608bd$export$a7e7b7df48874d2c);
$parcel$export(module.exports, "isGroupPanelOpen", () => $5301aa1cc74608bd$export$e79995f22545fd3e);
$parcel$export(module.exports, "getGroupsLocalStorage", () => $5301aa1cc74608bd$export$d0a5ccc42f3bcd33);
$parcel$export(module.exports, "saveLocalStorage", () => $5301aa1cc74608bd$export$f3928fa528b0a11c);
$parcel$export(module.exports, "useGroupLocalStorage", () => $5301aa1cc74608bd$export$4e1a840a45fb467c);

var $eJOHy = parcelRequire("eJOHy");

var $dnU6V = parcelRequire("dnU6V");

var $7jTnu = parcelRequire("7jTnu");
const $5301aa1cc74608bd$var$localStorageProvider = (0, $dnU6V.createLocalStorageProvider)('', false);
const $5301aa1cc74608bd$export$a3b190a19b138f2e = (projectKey, id)=>`group.state.${projectKey}.${id}`;
const $5301aa1cc74608bd$export$a7e7b7df48874d2c = (keyName, defaultValue)=>{
    try {
        let item;
        if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) item = $5301aa1cc74608bd$var$localStorageProvider.get(keyName);
        else if (typeof window !== 'undefined') item = window.localStorage.getItem(keyName);
        if (item === 'true') return true;
        if (item === 'false') return false;
        throw Error('Invalid group state value');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (_) {
        return defaultValue;
    }
};
const $5301aa1cc74608bd$export$e79995f22545fd3e = (projectKey, group, panelId, defaultValue)=>{
    const groupLocalStorageName = $5301aa1cc74608bd$export$a3b190a19b138f2e(projectKey, group);
    return $5301aa1cc74608bd$export$a7e7b7df48874d2c(`${groupLocalStorageName}-${panelId}`, defaultValue);
};
const $5301aa1cc74608bd$export$d0a5ccc42f3bcd33 = (keyNames, initialOpened)=>{
    const items = {};
    keyNames.forEach((key)=>{
        items[key] = $5301aa1cc74608bd$export$a7e7b7df48874d2c(key, initialOpened);
    });
    return items;
};
const $5301aa1cc74608bd$export$f3928fa528b0a11c = (keyName, value)=>{
    if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) $5301aa1cc74608bd$var$localStorageProvider.set(keyName, String(value));
    else if (typeof window !== 'undefined') window.localStorage.setItem(keyName, String(value));
};
const $5301aa1cc74608bd$export$4e1a840a45fb467c = (projectKey, id, initialOpened)=>{
    const keyName = $5301aa1cc74608bd$export$a3b190a19b138f2e(projectKey, id);
    const [storedValue, setStoredValue] = (0, $eJOHy.useState)(()=>$5301aa1cc74608bd$export$a7e7b7df48874d2c(keyName, initialOpened));
    const setValue = (0, $eJOHy.useCallback)((value)=>{
        try {
            setStoredValue(value);
            $5301aa1cc74608bd$export$f3928fa528b0a11c(keyName, value);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (_) {
        // Not decided what we do when we reach here.
        }
    }, [
        keyName
    ]);
    return [
        storedValue,
        setValue
    ];
};

});

parcelRegister("afLoP", function(module, exports) {

$parcel$export(module.exports, "shouldHideNullUneditableField", () => $5414ae0d7d08730f$export$e7987ba89f8e2996);
$parcel$export(module.exports, "ecosystemGlancesToLayoutItem", () => $5414ae0d7d08730f$export$8dd9174e11169a13);
$parcel$export(module.exports, "ecosystemContextsToLayoutItem", () => $5414ae0d7d08730f$export$ff0381f8ed1f6cc7);
$parcel$export(module.exports, "useForgeGlancesAsLayoutItems", () => $5414ae0d7d08730f$export$969c8278a214a2d9);
$parcel$export(module.exports, "useForgeContextPanelsAsLayoutItems", () => $5414ae0d7d08730f$export$b4095ac407369aa0);
$parcel$export(module.exports, "addChangeboardingRefToFirstItem", () => $5414ae0d7d08730f$export$b7aff69af7ee8f70);
$parcel$export(module.exports, "getPinnedFieldItems", () => $5414ae0d7d08730f$export$7fc9f8048722ede9);
$parcel$export(module.exports, "generateContextPanelId", () => $5414ae0d7d08730f$export$c55ff2c236d30544);

var $6kS6u = parcelRequire("6kS6u");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $kU13U = parcelRequire("kU13U");

var $bmoS1 = parcelRequire("bmoS1");

var $eaTQ3 = parcelRequire("eaTQ3");

var $5OyZl = parcelRequire("5OyZl");

var $55JT4 = parcelRequire("55JT4");


var $7sdmL = parcelRequire("7sdmL");

var $8oOr4 = parcelRequire("8oOr4");

var $dcblE = parcelRequire("dcblE");


var $awbk6 = parcelRequire("awbk6");

var $814y1 = parcelRequire("814y1");

var $bNexr = parcelRequire("bNexr");

var $f5OzW = parcelRequire("f5OzW");
const $5414ae0d7d08730f$export$87af144309c7a3c5 = (canLogTime, isNativeJiraTimeTrackingEnabled)=>// Here we assume that if the time tracking field is an available field
    // but isNativeJiraTimeTrackingEnabled is false, a 3rd party time tracking app is installed.
    isNativeJiraTimeTrackingEnabled ? !canLogTime : false;
const $5414ae0d7d08730f$var$getFieldByCustomType = (customType, fieldsConfiguration)=>(0, (/*@__PURE__*/$parcel$interopDefault($6kS6u)))(fieldsConfiguration, (field)=>(field.schema && field.schema.custom) === customType);
const $5414ae0d7d08730f$var$getFieldConfiguration = (fieldId, fields)=>{
    const field = fields[fieldId];
    const customSystemFields = (0, $8oOr4.specialFields)();
    const condition = !field && Object.prototype.hasOwnProperty.call(customSystemFields, fieldId);
    if (condition) {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        const customType = customSystemFields[fieldId];
        return $5414ae0d7d08730f$var$getFieldByCustomType(customType, fields);
    }
    return field;
};
const $5414ae0d7d08730f$export$e7987ba89f8e2996 = (itemId, issueFieldsConfig, value, canLogTime, isNativeJiraTimeTrackingEnabled)=>{
    const fieldConfig = $5414ae0d7d08730f$var$getFieldConfiguration(itemId, issueFieldsConfig);
    const fieldType = (0, $awbk6.getFieldType)(fieldConfig);
    if ((0, $awbk6.getPanels)().includes(itemId)) return false;
    if (!fieldConfig || fieldType === undefined) return true;
    if ((0, $awbk6.isEmpty)(value) && !fieldConfig.isEditable) {
        if (itemId === (0, $814y1.ASSIGNEE_TYPE) || fieldType === (0, $814y1.REQUEST_TYPE_CF_TYPE) || fieldType === (0, $814y1.REQUEST_LANGUAGE_CF_TYPE)) return false;
        // ARKEN-40: Forge custom fields with readonly and an empty value must still be shown as primary or secondary items
        if ((0, $7sdmL.isForgeField)(fieldConfig)) return false;
        if (itemId === (0, $814y1.TIME_TRACKING_TYPE)) return $5414ae0d7d08730f$export$87af144309c7a3c5(canLogTime, isNativeJiraTimeTrackingEnabled);
        return true;
    }
    return false;
};
const $5414ae0d7d08730f$export$8dd9174e11169a13 = (ecosystemGlances)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = Object.keys(ecosystemGlances).reduce((acc, next)=>{
        const ecosystem = ecosystemGlances[next];
        const modules = Object.keys(ecosystem).map((moduleKey)=>ecosystem[moduleKey]);
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return [
            ...acc,
            ...modules
        ];
    }, []);
    return result.map((connectGlance)=>({
            id: `${0, $814y1.ECOSYSTEM_GLANCE_TYPE}__${connectGlance.appKey}__${connectGlance.moduleKey}`,
            type: (0, $814y1.ECOSYSTEM_GLANCE_TYPE),
            payload: {
                ...connectGlance,
                glanceType: (0, $55JT4.CONNECT_ENTITY_TYPE)
            }
        }));
};
const $5414ae0d7d08730f$export$ff0381f8ed1f6cc7 = (ecosystemContextPanels)=>{
    const contextPanels = [];
    Object.values(ecosystemContextPanels).forEach((contextPanelObject)=>{
        contextPanels.push(Object.values(contextPanelObject)[0]);
    });
    return contextPanels.map((connectContextPanel)=>({
            id: `${0, $814y1.ECOSYSTEM_CONTEXT_TYPE}__${connectContextPanel.appKey}__${connectContextPanel.moduleKey}`,
            type: (0, $814y1.ECOSYSTEM_CONTEXT_TYPE),
            payload: {
                ...connectContextPanel,
                contextPanelType: (0, $55JT4.CONNECT_ENTITY_TYPE)
            }
        }));
};
const $5414ae0d7d08730f$var$ISSUE_TYPE = 'issuetype';
const $5414ae0d7d08730f$export$ea6c3ae2bd3a5510 = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const issueId = (0, $bmoS1.useIssueId)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const [permissions] = (0, $f5OzW.useProjectPermissions)(projectKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const projectId = (0, $bNexr.useProjectId)(projectKey);
    const [issueType] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: $5414ae0d7d08730f$var$ISSUE_TYPE
    });
    return (0, $fAZgY.useMemoWithCondition)(()=>({
            issueId: issueId || null,
            issueKey: issueKey,
            issueType: issueType && issueType.name,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType || null,
            // Prop normalisation copied from original redux selector - Props names are exposed externally.
            canAddComments: permissions.canAddComments,
            canAdministerJira: permissions.canAdministerJira,
            canAdministerProjects: permissions.canAdministerProject,
            canAssignIssues: permissions.canAssignIssues,
            canBeAssignedToIssues: permissions.canBeAssignedToIssues,
            canCloneIssues: permissions.canCloneIssue,
            canCreateAttachments: permissions.canCreateAttachments,
            canCreateChildren: permissions.canCreateChildren,
            canCreateSubtasks: permissions.canCreateSubtask,
            canDeleteAllAttachments: permissions.canDeleteAllAttachments,
            canDeleteAllComments: permissions.canDeleteAllComments,
            canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
            canDeleteIssues: permissions.canDeleteIssue,
            canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
            canDeleteOwnComments: permissions.canDeleteOwnComments,
            canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
            canEditAllComments: permissions.canEditAllComments,
            canEditAllWorklogs: permissions.canEditAllWorklogs,
            canEditIssues: permissions.canEditIssues,
            canEditOwnComments: permissions.canEditOwnComments,
            canEditOwnWorklogs: permissions.canEditOwnWorklogs,
            canLinkIssues: permissions.canLinkIssues,
            canLogWork: permissions.canLogWork,
            canManageWatchers: permissions.canManageWatchers,
            canModifyReporters: permissions.canModifyReporter,
            canMoveIssues: permissions.canMoveIssue,
            canScheduleIssues: permissions.canScheduleIssues,
            canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
            canBrowseUsers: permissions.canBrowseUsers,
            canViewDevTools: permissions.canViewDevTools,
            canViewWatchers: permissions.canViewWatchers
        }), [
        issueId,
        issueKey,
        issueType,
        permissions,
        projectId,
        projectKey,
        projectType
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $5414ae0d7d08730f$export$969c8278a214a2d9 = ()=>{
    const [forgeGlances] = (0, $dcblE.useForgeGlances)();
    return (0, $fAZgY.useMemoWithCondition)(()=>forgeGlances.filter((extension)=>(0, $kU13U.isExtensionVisible)(extension)).map((forgeGlance)=>{
            const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = forgeGlance;
            return {
                id: id,
                type: (0, $814y1.FORGE_GLANCE_TYPE),
                payload: {
                    label: label,
                    title: title,
                    status: status,
                    icon: icon,
                    extension: forgeGlance,
                    glanceType: (0, $5321bdc7bfffda7d$export$6f3804b3f188f650),
                    moduleKey: id,
                    appKey: id
                }
            };
        }), [
        forgeGlances
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $5414ae0d7d08730f$export$b4095ac407369aa0 = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const { ecosystemEnabled: ecosystemEnabled } = (0, $bNexr.useProjectConfiguration)(projectKey);
    const [forgeContextPanels] = (0, $dcblE.useForgeContextPanels)();
    return (0, $fAZgY.useMemoWithCondition)(()=>{
        if (!ecosystemEnabled) return [];
        return forgeContextPanels.filter((extension)=>(0, $kU13U.isExtensionVisible)(extension)).map((contextPanels)=>{
            const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
            return {
                id: id,
                type: (0, $5OyZl.FORGE_CONTEXT_TYPE),
                payload: {
                    type: (0, $5OyZl.FORGE_CONTEXT_TYPE),
                    label: label,
                    name: title,
                    status: status || null,
                    icon: url ? {
                        url: url
                    } : null,
                    extension: contextPanels,
                    contextPanelType: (0, $5321bdc7bfffda7d$export$6f3804b3f188f650),
                    moduleKey: id,
                    appKey: id,
                    options: null
                }
            };
        });
    }, [
        ecosystemEnabled,
        forgeContextPanels
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $5414ae0d7d08730f$export$b7aff69af7ee8f70 = (items)=>{
    let wrapperAdded = false;
    const allowedTypes = [
        (0, $5OyZl.layoutContainerItemTypes).field,
        (0, $5OyZl.layoutContainerItemTypes).panel
    ];
    const disallowedIds = [
        (0, $814y1.ASSIGNEE_TYPE),
        (0, $814y1.SLA_PANEL_TYPE)
    ];
    return items.map((item)=>{
        const typename = item.type !== undefined ? item.type : '';
        // @ts-expect-error - TS2345 - Argument of type 'any' is not assignable to parameter of type 'never'.
        if (!wrapperAdded && !disallowedIds.includes(item.id) && allowedTypes.includes(typename)) {
            wrapperAdded = true;
            // if it was added to csat field and csat field to be removed later in servicedesk template, this effectively won't work
            return {
                ...item,
                globalRef: (0, $91131abe479a2d8b$export$95ff4d03075475e2)
            };
        }
        return item;
    });
};
const $5414ae0d7d08730f$export$7fc9f8048722ede9 = (dedupedItems, pinnedFields)=>pinnedFields.reduce((result, pinnedId)=>{
        const item = dedupedItems.find((dedupedItem)=>dedupedItem.type === (0, $5OyZl.layoutContainerItemTypes).field && dedupedItem.fieldItemId === pinnedId || dedupedItem.type === (0, $5OyZl.layoutContainerItemTypes).panel && dedupedItem.panelItemId === pinnedId);
        if (item !== undefined) result.push(item);
        return result;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, []);
const $5414ae0d7d08730f$export$c55ff2c236d30544 = ({ appKey: appKey, moduleKey: moduleKey })=>`${0, $814y1.ECOSYSTEM_CONTEXT_TYPE}__${appKey}__${moduleKey}`;

});
parcelRegister("55JT4", function(module, exports) {

$parcel$export(module.exports, "FORGE_ENTITY_TYPE", () => $bfc7ea9bd11ea39c$export$6f3804b3f188f650);
$parcel$export(module.exports, "CONNECT_ENTITY_TYPE", () => $bfc7ea9bd11ea39c$export$1b2059a011c9174d);
const $bfc7ea9bd11ea39c$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';
const $bfc7ea9bd11ea39c$export$1b2059a011c9174d = 'CONNECT_ENTITY_TYPE';
const $bfc7ea9bd11ea39c$export$38f0fc1cf1f24cba = [
    $bfc7ea9bd11ea39c$export$6f3804b3f188f650,
    $bfc7ea9bd11ea39c$export$1b2059a011c9174d
];

});

/**
 * Opt into the new issue view modal key. To be cleaned up with issue.details.opt-back-in
 * This key is stored in the API and should not be renamed.
 * @see https://hello.atlassian.net/wiki/spaces/JIE/pages/920124493/How+to+re-set+new+Bento+Change+Boarding#Re-set-Opt-In-Back-Modal
 */ const $91131abe479a2d8b$export$a3338d0a4845edfa = 'jira.details.opt-in-back.next-reminding-date';
const $91131abe479a2d8b$export$26de4b42c139644c = 'jira.user.issue.should.show.welcome.message';
const $91131abe479a2d8b$export$ece45f325779a5d5 = 'jira.user.issue.opt.in.back.modal.has.dismissed';
const $91131abe479a2d8b$export$4603581e6066a63f = 'jira.user.issue.opt.in.back.banner.has.dismissed';
const $91131abe479a2d8b$export$af60a7ae4202be66 = 'issue-details-changeboarding';
const $91131abe479a2d8b$export$7b98e5a33c854454 = 30;
const $91131abe479a2d8b$export$956fcd3a2e5c48a8 = 'SOFTWARE_ISSUE_STATUS';
const $91131abe479a2d8b$export$ebb7dcd60318cfac = 'SERVICEDESK_ISSUE_STATUS';
const $91131abe479a2d8b$export$a446d697df3d6b2c = 'SERVICEDESK_REQUEST_PANEL';
const $91131abe479a2d8b$export$d3dadb39db0c423 = 'SERVICEDESK_CREATE_COMMENT_ACTIONS';
const $91131abe479a2d8b$export$75867eab2abae162 = 'SERVICEDESK_PLACEHOLDER_CREATE_COMMENT_ACTIONS';
const $91131abe479a2d8b$export$483d9bcbbd8280a6 = 'status-spotlight';
const $91131abe479a2d8b$export$95f98990d7202b31 = 'SHOW_MORE';
const $91131abe479a2d8b$export$95ff4d03075475e2 = 'PIN_FIELD';
const $91131abe479a2d8b$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $91131abe479a2d8b$export$6f48b612d5c03f4d = 'PERMALINK';
const $91131abe479a2d8b$export$d84e7970e2d564af = 'BOARD_SIDEBAR';
const $91131abe479a2d8b$export$fa5ad81958817beb = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.details-group';
const $91131abe479a2d8b$export$1ba8bc5ff9e50d09 = 'QUICK_ADDS';
const $91131abe479a2d8b$export$f9baa44349b5d6b8 = 'JSW_ACTIVITY_FEED_BUTTONS';
const $91131abe479a2d8b$export$f49830a0e4ffb3f9 = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.context-group.container.sla-group';
const $91131abe479a2d8b$export$efb12103a5e32a1e = 'PIN_FIELD_PLACEHOLDER_BANNER';
const $91131abe479a2d8b$export$4288bce987c22af4 = 'PINNED_FIELDS_PANEL';
const $91131abe479a2d8b$export$ddb80c23a62a41e = 'jira.user.issue.has.seen.quick-actions.change-boarding.message';

parcelRegister("7sdmL", function(module, exports) {

$parcel$export(module.exports, "isForgeField", () => $f71ff05b2f2a481c$export$f4484ef180517e0e);
$parcel$export(module.exports, "getForgeFieldType", () => $f71ff05b2f2a481c$export$3f8bcfe7fea0362a);

var $exWdq = parcelRequire("exWdq");

var $jPROM = parcelRequire("jPROM");

var $814y1 = parcelRequire("814y1");
const $f71ff05b2f2a481c$export$f4484ef180517e0e = (field)=>field && (0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(field, 'schema.custom') && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(field.schema.custom) && field.schema.custom.includes('ari:cloud:ecosystem::extension');
const $f71ff05b2f2a481c$export$3f8bcfe7fea0362a = (field)=>{
    if (!$f71ff05b2f2a481c$export$f4484ef180517e0e(field)) return null;
    if (false) return field.schema.type;
    return 0, $814y1.FORGE_CUSTOM_FIELD_TYPE;
};

});

parcelRegister("dcblE", function(module, exports) {

$parcel$export(module.exports, "useForgeGlances", () => $80582c167e3ed8bc$export$dc79f3e7b8a6c3e1);
$parcel$export(module.exports, "useForgeContextPanels", () => $80582c167e3ed8bc$export$a1a589b738ca01b8);
$parcel$export(module.exports, "useForgeDataComplete", () => $80582c167e3ed8bc$export$db75d05b888b2963);
$parcel$export(module.exports, "useForgeCustomField", () => $80582c167e3ed8bc$export$2a006c08e9ab6fc3);
$parcel$export(module.exports, "useForgeActions", () => $80582c167e3ed8bc$export$4f3ebb446fd03f21);
$parcel$export(module.exports, "useForgeLoadingFailed", () => $80582c167e3ed8bc$export$25b2fc6a75c5447b);
$parcel$export(module.exports, "useHasBlockedExtensions", () => $80582c167e3ed8bc$export$955dca49c49bfb60);
$parcel$export(module.exports, "useBlockedExtensions", () => $80582c167e3ed8bc$export$61349d0d8e89be3);
$parcel$export(module.exports, "useIsForgeDataEmpty", () => $80582c167e3ed8bc$export$57f2fa4b04feb8c2);

var $eJOHy = parcelRequire("eJOHy");

var $jFHCE = parcelRequire("jFHCE");

var $5AOn6 = parcelRequire("5AOn6");

var $dPni9 = parcelRequire("dPni9");
const $80582c167e3ed8bc$export$dc79f3e7b8a6c3e1 = ()=>{
    const [forge] = (0, $dPni9.useForgeStore)();
    return [
        forge.issueGlance
    ];
};
const $80582c167e3ed8bc$export$a1a589b738ca01b8 = ()=>{
    const [forge] = (0, $dPni9.useForgeStore)();
    return [
        forge.issueContext
    ];
};
const $80582c167e3ed8bc$export$db75d05b888b2963 = ()=>{
    const [forge] = (0, $dPni9.useForgeStore)();
    return [
        forge.isForgeDataComplete
    ];
};
const $80582c167e3ed8bc$export$1a3a35919478733d = ()=>{
    const [forge] = (0, $dPni9.useForgeStore)();
    return [
        [
            ...forge.customField,
            ...forge.customFieldType
        ]
    ];
};
const $80582c167e3ed8bc$export$2a006c08e9ab6fc3 = (extensionId)=>{
    const [customFieldExtensions] = $80582c167e3ed8bc$export$1a3a35919478733d();
    return (0, $5AOn6.useMemoizedStateObject)((0, $eJOHy.useMemo)(()=>customFieldExtensions.find((ext)=>ext.id === extensionId), [
        customFieldExtensions,
        extensionId
    ]));
};
const $80582c167e3ed8bc$export$4f3ebb446fd03f21 = ()=>{
    const [, actions] = (0, $dPni9.useForgeActionsStore)();
    return [
        undefined,
        actions
    ];
};
const $80582c167e3ed8bc$export$25b2fc6a75c5447b = ()=>{
    const [forge] = (0, $dPni9.useForgeStore)();
    return forge.isForgeLoadingFailed;
};
const $80582c167e3ed8bc$export$955dca49c49bfb60 = ()=>{
    const [forge] = (0, $dPni9.useForgeStore)();
    return (0, $eJOHy.useMemo)(()=>{
        if (!forge.blockedExtensions) return false;
        const toOmit = [
            'issueViewBackgroundScript'
        ];
        return Object.values((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(forge.blockedExtensions, toOmit)).some((blockedExtensions)=>blockedExtensions.length > 0);
    }, [
        forge.blockedExtensions
    ]);
};
const $80582c167e3ed8bc$export$61349d0d8e89be3 = ()=>{
    const [forge] = (0, $dPni9.useForgeStore)();
    return forge.blockedExtensions;
};
const $80582c167e3ed8bc$export$57f2fa4b04feb8c2 = ()=>{
    const [forge] = (0, $dPni9.useForgeStore)();
    const isExtensionsEmpty = Object.keys(forge).every((key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        Array.isArray(forge[key]) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        forge[key].length === 0 : true);
    const isBlockedExtensionsEmpty = Object.keys(forge.blockedExtensions).every(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (key)=>forge.blockedExtensions[key].length === 0);
    return isExtensionsEmpty && isBlockedExtensionsEmpty;
};

});
parcelRegister("5AOn6", function(module, exports) {

$parcel$export(module.exports, "useMemoizedStateObject", () => $1aa834341420cd16$export$cc725e2aa41de44a);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");
const $1aa834341420cd16$export$cc725e2aa41de44a = (data, equalityCheck = (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj))))=>{
    const memoizedData = (0, $eJOHy.useRef)(data);
    return (0, $eJOHy.useMemo)(()=>{
        if (!equalityCheck(data, memoizedData.current)) {
            memoizedData.current = data;
            return data;
        }
        return memoizedData.current;
    }, [
        data,
        equalityCheck
    ]);
};

});

parcelRegister("dPni9", function(module, exports) {

$parcel$export(module.exports, "useForgeStore", () => $dfc896f24be48695$export$10f3118dc1498dfc);
$parcel$export(module.exports, "useForgeActionsStore", () => $dfc896f24be48695$export$7dd6be1114d73937);
$parcel$export(module.exports, "ForceStoreContainer", () => $dfc896f24be48695$export$540c057b33607be9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $eBaQ4 = parcelRequire("eBaQ4");
const $dfc896f24be48695$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-view-layout-forge-apps-service',
    initialState: {
        issueGlance: [],
        issueContext: [],
        issueAction: [],
        issuePanel: [],
        issueActivity: [],
        customField: [],
        issueViewBackgroundScript: [],
        customFieldType: [],
        activeAction: null,
        isForgeLoadingFailed: false,
        isForgeDataComplete: false,
        blockedExtensions: {
            issueGlance: [],
            issueContext: [],
            issueAction: [],
            issuePanel: [],
            issueActivity: [],
            customField: [],
            issueViewBackgroundScript: [],
            customFieldType: []
        },
        // Not rate limited
        forgeRateLimitedUntil: 0,
        failedEventsCount: 0
    },
    actions: $eBaQ4
});
const $dfc896f24be48695$export$10f3118dc1498dfc = (0, $iJq0l.createHook)($dfc896f24be48695$export$6f57813fe9f31bf9);
const $dfc896f24be48695$export$7dd6be1114d73937 = (0, $iJq0l.createHook)($dfc896f24be48695$export$6f57813fe9f31bf9, {
    selector: null
});
const $dfc896f24be48695$export$540c057b33607be9 = (0, $6E16M.createContainer)($dfc896f24be48695$export$6f57813fe9f31bf9);

});
parcelRegister("eBaQ4", function(module, exports) {

$parcel$export(module.exports, "setForge", () => $674206a2cc473819$export$8307a9da1b91b3b4);
$parcel$export(module.exports, "setForgeLoadingFailed", () => $674206a2cc473819$export$7ff580b28fd472d0);
const $674206a2cc473819$export$8307a9da1b91b3b4 = (forge)=>({ setState: setState })=>{
        setState(forge);
    };
const $674206a2cc473819$export$7ff580b28fd472d0 = ()=>({ setState: setState })=>{
        setState({
            isForgeLoadingFailed: true
        });
    };

});



const $5321bdc7bfffda7d$export$6f3804b3f188f650 = 'FORGE_ENTITY_TYPE';

parcelRegister("awbk6", function(module, exports) {

$parcel$export(module.exports, "getPanels", () => $293ca5da90e27ef3$export$be078297eeb6e8a2);
$parcel$export(module.exports, "isEmpty", () => $293ca5da90e27ef3$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "getAtlassianCustomFieldType", () => $293ca5da90e27ef3$export$f521834fc2bfcd81);
$parcel$export(module.exports, "fieldTypeHandler", () => $293ca5da90e27ef3$export$b2cc0ead6ce019e3);
$parcel$export(module.exports, "getFieldType", () => $293ca5da90e27ef3$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "addGlobalRefToLayoutContainerTemplateItems", () => $293ca5da90e27ef3$export$fa197d31f946730e);
$parcel$export(module.exports, "isUnsupportedItem", () => $293ca5da90e27ef3$export$3d38168d24278ebb);

var $4sprp = parcelRequire("4sprp");

var $jPROM = parcelRequire("jPROM");

var $dtLJW = parcelRequire("dtLJW");

var $LFmXM = parcelRequire("LFmXM");

var $lopBx = parcelRequire("lopBx");

var $7jTnu = parcelRequire("7jTnu");

var $5OyZl = parcelRequire("5OyZl");


var $7sdmL = parcelRequire("7sdmL");

var $8oOr4 = parcelRequire("8oOr4");

var $co62F = parcelRequire("co62F");

var $814y1 = parcelRequire("814y1");
const $293ca5da90e27ef3$export$be078297eeb6e8a2 = ()=>[
        (0, $814y1.ASSET_ONBOARDING_TYPE),
        (0, $814y1.DEV_SUMMARY_TYPE),
        (0, $814y1.KNOWLEDGE_BASE_TYPE),
        ...(0, $7jTnu.fg)('jsm-journey-builder-in-issue-view') ? [
            (0, $814y1.JOURNEY_PANEL_TYPE)
        ] : [],
        (0, $814y1.SENTIMENT_TYPE),
        (0, $814y1.SLA_PANEL_TYPE),
        (0, $814y1.LINKED_ALERTS_TYPE),
        ...(0, $lopBx.isFedRamp)() ? [] : [
            (0, $814y1.CHAT_CHANNEL_TYPE)
        ],
        ...(0, $lopBx.isFedRamp)() ? [] : [
            (0, $814y1.MSTEAMS_CHANNEL_TYPE)
        ],
        ...(0, $lopBx.isFedRamp)() ? [] : [
            (0, $814y1.ZOOM_MEETING_TYPE)
        ],
        (0, $814y1.MANAGE_STAKEHOLDERS_TYPE)
    ];
const $293ca5da90e27ef3$export$dd1bc94b04021eeb = (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value) || (0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(value) && value.length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($dtLJW)))(value) && Object.keys(value).length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($dtLJW)))(value) && value.type === 'doc' && value.content && Object.keys(value.content).length === 0;
const $293ca5da90e27ef3$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $8oOr4.specialFields)();
    return [
        ...(0, $8oOr4.customFieldsToDisplay)().filter((cf)=>!(0, $8oOr4.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $814y1.FLAGGED_CF_TYPE)
    ];
};
const $293ca5da90e27ef3$export$f521834fc2bfcd81 = (custom)=>$293ca5da90e27ef3$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $293ca5da90e27ef3$export$b2cc0ead6ce019e3 = (fieldConfig, layoutItem)=>{
    const id = (0, $co62F.getLayoutItemId)(layoutItem);
    const { type: type } = layoutItem;
    if (type === (0, $5OyZl.layoutContainerItemTypes).tab || type === (0, $814y1.ECOSYSTEM_GLANCE_TYPE) || type === (0, $814y1.FORGE_GLANCE_TYPE) || type === (0, $814y1.ECOSYSTEM_CONTEXT_TYPE) || type === (0, $5OyZl.FORGE_CONTEXT_TYPE)) return {
        type: type,
        id: id
    };
    if ($293ca5da90e27ef3$export$be078297eeb6e8a2().includes(id)) return {
        id: id,
        type: id
    };
    const forgeCustomField = (0, $7sdmL.getForgeFieldType)(fieldConfig);
    if (forgeCustomField !== null) return {
        type: forgeCustomField,
        id: id
    };
    const fieldSchema = fieldConfig?.schema || {};
    const systemType = fieldSchema.system !== null ? fieldSchema.system : '';
    return {
        type: $293ca5da90e27ef3$export$f521834fc2bfcd81(fieldSchema.custom) || systemType || fieldSchema.type,
        id: id
    };
};
const $293ca5da90e27ef3$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $293ca5da90e27ef3$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
/**
 * We can't directly identify `Affected services`, `Change risk` or `Impact`, but we can
 * minimise the number of extra targets by wrapping only 'select' type fields since the above
 * all fit that criteria. `Description` fortunately has a custom type to identify it
 */ const $293ca5da90e27ef3$var$fieldsWithGlobalTargets = [
    (0, $814y1.DESCRIPTION_TYPE),
    (0, $814y1.SELECT_CF_TYPE),
    (0, $814y1.SERVICE_ENTITY_CF_TYPE)
];
const $293ca5da90e27ef3$export$fa197d31f946730e = (// Use generic to constrain return type, e.g., passing ContextPanelItem should not return LayoutContainerTemplateItem
items, issueFieldsConfig)=>{
    if (!items || !issueFieldsConfig) return [];
    return items.map((item)=>{
        const { type: type, id: id } = $293ca5da90e27ef3$export$b2cc0ead6ce019e3(issueFieldsConfig[(0, $co62F.getLayoutItemId)(item)], item);
        if ($293ca5da90e27ef3$var$fieldsWithGlobalTargets.includes(type)) return {
            ...item,
            globalRef: `${0, $e2e3f134560cc64f$export$2028cf1423b28cf8}${id}`
        };
        return item;
    });
};
// This typing exists to ensure that we include fields here when adding new ones.
const $293ca5da90e27ef3$var$getBaseSupportedItems = (0, $LFmXM.default)(()=>{
    return {
        // @ts-expect-error - TS2322 - Type '{ ecosystemGlance: boolean; forgeGlance: boolean; "com.pyxis.greenhopper.jira:gh-epic-status": true; "com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect": true; assignee: true; ... 75 more ...; "com.pyxis.greenhopper.jira:gh-epic-label": true; }' is not assignable to type 'CheckFieldTypeDefinitions<CheckedLegacyFieldTypeDefinitions<boolean>, IgnoredFieldChecks<boolean>>'.
        [(0, $814y1.ECOSYSTEM_GLANCE_TYPE)]: true,
        [(0, $814y1.FORGE_GLANCE_TYPE)]: true,
        [(0, $5OyZl.FORGE_CONTEXT_TYPE)]: true,
        [(0, $814y1.ECOSYSTEM_CONTEXT_TYPE)]: true,
        [(0, $814y1.EPIC_STATUS_TYPE)]: true,
        [(0, $814y1.CASCADING_SELECT_CF_TYPE)]: true,
        [(0, $814y1.ASSIGNEE_TYPE)]: true,
        [(0, $814y1.REPORTER_TYPE)]: true,
        [(0, $814y1.DESCRIPTION_TYPE)]: true,
        [(0, $814y1.ENVIRONMENT_TYPE)]: true,
        [(0, $814y1.DUE_DATE_TYPE)]: true,
        [(0, $814y1.PRIORITY_TYPE)]: true,
        [(0, $814y1.LABELS_TYPE)]: true,
        [(0, $814y1.COMPONENTS_TYPE)]: true,
        [(0, $814y1.SPRINT_TYPE)]: true,
        [(0, $814y1.STORY_POINTS_TYPE)]: true,
        [(0, $814y1.EPIC_TYPE)]: true,
        [(0, $814y1.FIX_VERSIONS_TYPE)]: true,
        [(0, $814y1.AFFECTS_VERSIONS_TYPE)]: true,
        [(0, $814y1.TIME_TRACKING_TYPE)]: true,
        [(0, $814y1.TIME_ESTIMATE_TYPE)]: true,
        [(0, $814y1.LABELS_CF_TYPE)]: true,
        [(0, $814y1.TEXT_CF_TYPE)]: true,
        [(0, $814y1.MULTI_USER_CF_TYPE)]: true,
        [(0, $814y1.PARTICIPANTS_CF_TYPE)]: true,
        [(0, $814y1.URL_CF_TYPE)]: true,
        [(0, $814y1.NUMBER_CF_TYPE)]: true,
        [(0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE)]: true,
        [(0, $814y1.SELECT_CF_TYPE)]: true,
        [(0, $814y1.MULTI_SELECT_CF_TYPE)]: true,
        [(0, $814y1.VERSION_CF_TYPE)]: true,
        [(0, $814y1.TEXT_AREA_CF_TYPE)]: true,
        [(0, $814y1.MULTI_VERSION_CF_TYPE)]: true,
        [(0, $814y1.DATE_CF_TYPE)]: true,
        [(0, $814y1.GROUP_CF_TYPE)]: true,
        [(0, $814y1.MULTI_GROUP_CF_TYPE)]: true,
        [(0, $814y1.USER_CF_TYPE)]: true,
        [(0, $814y1.PEOPLE_CF_TYPE)]: true,
        [(0, $814y1.MULTI_CHECKBOXES_CF_TYPE)]: true,
        [(0, $814y1.RADIO_BUTTONS_CF_TYPE)]: true,
        [(0, $814y1.DATETIME_CF_TYPE)]: true,
        [(0, $814y1.TEAMS_PLATFORM_CF_TYPE)]: true,
        [(0, $814y1.TEAM_CF_TYPE)]: true,
        [(0, $814y1.PARENT_CF_TYPE)]: true,
        [(0, $814y1.PARENT_FIELD_TYPE)]: true,
        [(0, $814y1.BASELINE_START_CF_TYPE)]: true,
        [(0, $814y1.BASELINE_END_CF_TYPE)]: true,
        [(0, $814y1.COLOR_CF_TYPE)]: true,
        [(0, $814y1.REQUEST_TYPE_CF_TYPE)]: true,
        [(0, $814y1.APPROVALS_CF_TYPE)]: true,
        [(0, $814y1.REQUEST_LANGUAGE_CF_TYPE)]: true,
        [(0, $814y1.REQUEST_PARTICIPANTS_CF_TYPE)]: true,
        [(0, $814y1.ORGANIZATIONS_CF_TYPE)]: true,
        [(0, $814y1.ISSUE_FIELD_NUMBER_CF_TYPE)]: true,
        [(0, $814y1.ISSUE_FIELD_STRING_CF_TYPE)]: true,
        [(0, $814y1.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)]: true,
        [(0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)]: true,
        [(0, $814y1.ISSUE_FIELD_DATETIME_CF_TYPE)]: true,
        [(0, $814y1.ASSETS_CF_TYPE)]: true,
        [(0, $814y1.SERVICE_ENTITY_CF_TYPE)]: true,
        [(0, $814y1.APPROVERS_LIST_CF_TYPE)]: true,
        [(0, $814y1.CMDB_OBJECT_CF_TYPE)]: true,
        [(0, $814y1.REQUEST_FEEDBACK_CF_TYPE)]: true,
        [(0, $814y1.ISSUE_FIELD_USER_CF_TYPE)]: true,
        [(0, $814y1.ISSUE_FIELD_GROUPS_CF_TYPE)]: true,
        [(0, $814y1.ISSUE_FIELD_STRINGS_CF_TYPE)]: true,
        [(0, $814y1.READ_ONLY_CF_TYPE)]: true,
        [(0, $814y1.PROJECT_PICKER_CF_TYPE)]: true,
        [(0, $814y1.FORGE_CUSTOM_FIELD_TYPE)]: true,
        [(0, $814y1.KNOWLEDGE_BASE_TYPE)]: true,
        [(0, $814y1.JOURNEY_PANEL_TYPE)]: !false && (0, $7jTnu.fg)('jsm-journey-builder-in-issue-view'),
        [(0, $814y1.SLA_PANEL_TYPE)]: true,
        [(0, $814y1.SENTIMENT_TYPE)]: true,
        [(0, $814y1.DEV_SUMMARY_TYPE)]: true,
        [(0, $814y1.RELEASES_TYPE)]: true,
        [(0, $814y1.ASSET_ONBOARDING_TYPE)]: true,
        [(0, $814y1.LINKED_ALERTS_TYPE)]: true,
        [(0, $814y1.CHAT_CHANNEL_TYPE)]: !false && !(0, $lopBx.isFedRamp)(),
        [(0, $814y1.MSTEAMS_CHANNEL_TYPE)]: !false && !(0, $lopBx.isFedRamp)(),
        [(0, $814y1.ZOOM_MEETING_TYPE)]: !false && !(0, $lopBx.isFedRamp)(),
        [(0, $814y1.MANAGE_STAKEHOLDERS_TYPE)]: !false,
        [(0, $814y1.RESPONDERS_CF_TYPE)]: true,
        [(0, $814y1.MAJOR_INCIDENT_CF_TYPE)]: true,
        [(0, $814y1.MESSAGE_EDIT_CF_TYPE)]: true,
        [(0, $814y1.MESSAGE_VIEW_CF_TYPE)]: true,
        [(0, $814y1.EPIC_NAME_TYPE)]: true,
        [(0, $814y1.CATEGORY_TYPE)]: true,
        [(0, $814y1.ENTITLEMENT_CF_TYPE)]: true,
        [(0, $814y1.SENTIMENT_CF_TYPE)]: true,
        [(0, $814y1.GOALS_CF_TYPE)]: true,
        [(0, $814y1.ORGANIZATION_CF_TYPE)]: true
    };
});
const $293ca5da90e27ef3$export$3d38168d24278ebb = (type)=>!$293ca5da90e27ef3$var$getBaseSupportedItems()[type];

});

parcelRegister("f5OzW", function(module, exports) {

$parcel$export(module.exports, "useProjectPermissions", () => $9392c16d11e1d8d6$export$c6c6b35628cf47a8);
$parcel$export(module.exports, "useCanAdministerProject", () => $9392c16d11e1d8d6$export$f39ed5a161efa614);
$parcel$export(module.exports, "useCanAdministerJira", () => $9392c16d11e1d8d6$export$ec12ddafd19b95ac);
$parcel$export(module.exports, "useCanConfigureIssue", () => $9392c16d11e1d8d6$export$e7267b8a084eadb3);
$parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", () => $9392c16d11e1d8d6$export$756d7c97077a2f76);
$parcel$export(module.exports, "useCanUseCustomerServiceAgentFeatures", () => $9392c16d11e1d8d6$export$a9aa002e3fe96518);
$parcel$export(module.exports, "useCanDownloadAttachments", () => $9392c16d11e1d8d6$export$d47dad3a7e3265ea);
$parcel$export(module.exports, "useProjectPermissionsActions", () => $9392c16d11e1d8d6$export$86c656cdb87052cd);

var $eJOHy = parcelRequire("eJOHy");

var $lvKO5 = parcelRequire("lvKO5");

var $iW0U8 = parcelRequire("iW0U8");

var $cmy2V = parcelRequire("cmy2V");
const $9392c16d11e1d8d6$export$c6c6b35628cf47a8 = (projectKey)=>{
    const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        permissions,
        actions
    ];
};
const $9392c16d11e1d8d6$export$f39ed5a161efa614 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerProject;
};
const $9392c16d11e1d8d6$export$ec12ddafd19b95ac = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerJira;
};
const $9392c16d11e1d8d6$export$e7267b8a084eadb3 = (projectKey)=>{
    const canConfigureAdministerProject = $9392c16d11e1d8d6$export$f39ed5a161efa614(projectKey);
    const canAdministerJira = $9392c16d11e1d8d6$export$ec12ddafd19b95ac(projectKey);
    return canConfigureAdministerProject || canAdministerJira;
};
const $9392c16d11e1d8d6$export$756d7c97077a2f76 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { appPermissions: appPermissions } = (0, $lvKO5.useTenantContext)();
    return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
};
const $9392c16d11e1d8d6$export$a9aa002e3fe96518 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $iW0U8.useApplicationPermissions)();
    return permissions.canUseServiceDeskAgentFeatures && hasCustomerServiceAccess;
};
const $9392c16d11e1d8d6$export$d47dad3a7e3265ea = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canExportIssue;
};
const $9392c16d11e1d8d6$export$86c656cdb87052cd = ()=>{
    const [, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStoreActions)();
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("cmy2V", function(module, exports) {

$parcel$export(module.exports, "defaultPermissions", () => $872d4887d895f20d$export$ccfee65526b322ca);
$parcel$export(module.exports, "useProjectPermissionsStore", () => $872d4887d895f20d$export$4919fa09a3d81224);
$parcel$export(module.exports, "useProjectPermissionsStoreActions", () => $872d4887d895f20d$export$e8436ef485b33bdb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $g2Hwr = parcelRequire("g2Hwr");
const $872d4887d895f20d$export$ccfee65526b322ca = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteAllWorklogs: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canDeleteOwnWorklogs: false,
    canEditAllComments: false,
    canEditAllWorklogs: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canEditOwnWorklogs: false,
    canLinkIssues: false,
    canLogWork: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUseServiceDeskAgentFeatures: false,
    canBrowseUsers: false,
    canViewDevTools: false,
    canViewWatchers: false,
    canViewVoters: false,
    canCreateIssuesInClassicProjectEpic: false,
    canResolveIssues: false,
    canExportIssue: false,
    canArchiveIssue: false,
    canUnarchiveIssue: false
};
const $872d4887d895f20d$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'project-permissions',
    initialState: {},
    actions: $g2Hwr
});
const $872d4887d895f20d$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $872d4887d895f20d$export$ccfee65526b322ca;
const $872d4887d895f20d$export$4919fa09a3d81224 = (0, $iJq0l.createHook)($872d4887d895f20d$export$6f57813fe9f31bf9, {
    selector: $872d4887d895f20d$var$getProjectPermissionSelector
});
const $872d4887d895f20d$export$e8436ef485b33bdb = (0, $iJq0l.createHook)($872d4887d895f20d$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("g2Hwr", function(module, exports) {

$parcel$export(module.exports, "setProjectPermissions", () => $d904843c11c916e5$export$53f5cc27627e5fe3);
const $d904843c11c916e5$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [projectKey]: permissions
        });
    };

});




parcelRegister("5zOQO", function(module, exports) {

$parcel$export(module.exports, "issueViewBackgroundScriptsSelector", () => $861abb8f92e180ea$export$eef935056c1a5112);
$parcel$export(module.exports, "issueContentPanelsSelector", () => $861abb8f92e180ea$export$80fcdb58a34c02a8);
$parcel$export(module.exports, "isIssueContentPanelCustomisedSelector", () => $861abb8f92e180ea$export$7d77b0f1f3d84166);
$parcel$export(module.exports, "canInstallAddonsSelector", () => $861abb8f92e180ea$export$779e1275bbd7ba59);
$parcel$export(module.exports, "isIssueCreatedAfterEcosystemOnSelector", () => $861abb8f92e180ea$export$528e2c054f1a65f6);
$parcel$export(module.exports, "contextPanelEntitiesSelector", () => $861abb8f92e180ea$export$830512515d42357);
$parcel$export(module.exports, "glancesSelector", () => $861abb8f92e180ea$export$d73d3447fc053be);
$parcel$export(module.exports, "ecosystemGlancesSelector", () => $861abb8f92e180ea$export$df7140249f849373);
$parcel$export(module.exports, "glancePanelSelector", () => $861abb8f92e180ea$export$e8938da368c7c5c4);
$parcel$export(module.exports, "allContentPanelsSelector", () => $861abb8f92e180ea$export$7bc028a03185fc96);
$parcel$export(module.exports, "ecosystemAllPanelsSelector", () => $861abb8f92e180ea$export$47d3fa7df862ae6f);
$parcel$export(module.exports, "ecosystemAddedContentPanelsSelector", () => $861abb8f92e180ea$export$a48c28ad36cb708e);
$parcel$export(module.exports, "selectedContentPanelSelector", () => $861abb8f92e180ea$export$1a9c93efcb1ffec7);
$parcel$export(module.exports, "activityPanelsSelector", () => $861abb8f92e180ea$export$dd6c9850f9e61a72);
$parcel$export(module.exports, "ecosystemActivityPanelsSelector", () => $861abb8f92e180ea$export$9222e43f5478367f);

var $ahm5r = parcelRequire("ahm5r");

var $aX8Tx = parcelRequire("aX8Tx");

var $eGXqc = parcelRequire("eGXqc");

var $UwIK7 = parcelRequire("UwIK7");

var $kU13U = parcelRequire("kU13U");

var $55JT4 = parcelRequire("55JT4");

var $8tnLu = parcelRequire("8tnLu");

var $5EgB1 = parcelRequire("5EgB1");

var $6az7p = parcelRequire("6az7p");

var $GhTyR = parcelRequire("GhTyR");


var $4fVVF = parcelRequire("4fVVF");

var $dLJHp = parcelRequire("dLJHp");
const $861abb8f92e180ea$export$eef935056c1a5112 = (0, $ahm5r.createSelector)((0, $4fVVF.forgeEntitiesSelector), (forge)=>(forge.backgroundScripts || []).filter((0, $kU13U.isExtensionVisible)));
const $861abb8f92e180ea$export$80fcdb58a34c02a8 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.issueContentPanels || []);
const $861abb8f92e180ea$export$7d77b0f1f3d84166 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>!!entities.issueContentPanels && entities.issueContentPanels.includes((0, $5abb7859136f3cea$export$bdafa6b589be8b30)));
const $861abb8f92e180ea$export$779e1275bbd7ba59 = (0, $ahm5r.createSelector)((0, $GhTyR.canAdministerJiraPermissionsSelector), (canAdministerJira)=>canAdministerJira);
const $861abb8f92e180ea$export$528e2c054f1a65f6 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.ecosystem && !!entities.ecosystem.ecosystemOnDate && // @ts-expect-error - TS2345 - Argument of type 'AuthoredTimestamp | undefined' is not assignable to parameter of type 'string'.
    Date.parse(entities.createdDate) > entities.ecosystem.ecosystemOnDate);
const $861abb8f92e180ea$var$extractSecondLevelDeepValuesFromObject = (obj)=>Object.keys(obj || {}).flatMap((key)=>Object.values(obj ? obj[key] : {}));
const $861abb8f92e180ea$var$glanceEntitiesSelector = (0, $ahm5r.createSelector)((0, $4fVVF.ecosystemEntitiesSelector), (ecosystem)=>$861abb8f92e180ea$var$extractSecondLevelDeepValuesFromObject(ecosystem.glances || {}));
const $861abb8f92e180ea$export$830512515d42357 = (0, $ahm5r.createSelector)((0, $4fVVF.ecosystemEntitiesSelector), (ecosystem)=>$861abb8f92e180ea$var$extractSecondLevelDeepValuesFromObject(ecosystem.contextPanels));
const $861abb8f92e180ea$var$contentPanelsEntitiesSelector = (0, $ahm5r.createSelector)((0, $4fVVF.ecosystemEntitiesSelector), (ecosystem)=>$861abb8f92e180ea$var$extractSecondLevelDeepValuesFromObject(ecosystem.contentPanels));
const $861abb8f92e180ea$var$activityPanelsEntitiesSelector = (0, $ahm5r.createSelector)((0, $4fVVF.ecosystemEntitiesSelector), (ecosystem)=>$861abb8f92e180ea$var$extractSecondLevelDeepValuesFromObject(ecosystem.activityPanels));
const $861abb8f92e180ea$export$7fec16e3d5cd5f4e = (selector)=>(0, $ahm5r.createSelector)((0, $5EgB1.isEcosystemEnabledSelector), selector, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (ecosystemEnabled, otherSelector)=>ecosystemEnabled && otherSelector || []);
const $861abb8f92e180ea$export$d73d3447fc053be = $861abb8f92e180ea$export$7fec16e3d5cd5f4e((0, $ahm5r.createSelector)($861abb8f92e180ea$var$glanceEntitiesSelector, (glanceEntities)=>glanceEntities.map((entity)=>({
            appKey: entity.appKey,
            moduleKey: entity.moduleKey,
            name: entity.name,
            icon: entity.icon && entity.icon.url && {
                url: entity.icon.url
            },
            label: entity.label,
            status: entity.status,
            type: entity.type,
            glanceType: (0, $55JT4.CONNECT_ENTITY_TYPE)
        }))));
const $861abb8f92e180ea$export$df7140249f849373 = (0, $ahm5r.createSelector)([
    (0, $dLJHp.forgeGlancesSelector),
    $861abb8f92e180ea$export$d73d3447fc053be
], (forge, connect)=>[
        ...forge,
        ...connect
    ]);
const $861abb8f92e180ea$export$e8938da368c7c5c4 = (appKey, moduleKey)=>(0, $ahm5r.createSelector)((0, $4fVVF.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.glances && ecosystem.glances[appKey] && ecosystem.glances[appKey][moduleKey]);
const $861abb8f92e180ea$export$7bc028a03185fc96 = $861abb8f92e180ea$export$7fec16e3d5cd5f4e((0, $ahm5r.createSelector)($861abb8f92e180ea$var$contentPanelsEntitiesSelector, (contentPanelEntities)=>contentPanelEntities));
const $861abb8f92e180ea$export$47d3fa7df862ae6f = (0, $ahm5r.createSelector)([
    (0, $dLJHp.forgePanelsSelector),
    $861abb8f92e180ea$export$7bc028a03185fc96
], (forge, connect)=>[
        ...forge,
        ...connect
    ]);
const $861abb8f92e180ea$var$panelsComparator = (firstPanel, secondPanel)=>{
    // The sort order rule:
    // 1. Forge panels without quick add button (no dateAdded prop)
    // 2. Forge panels sorted by date added (oldest > newest)
    // 3. Connect panels, sorting criteria won't be changed
    if (firstPanel.type === (0, $55JT4.FORGE_ENTITY_TYPE)) {
        // @ts-expect-error - TS2339 - Property 'dateAdded' does not exist on type 'AddedPanel'.
        const firstValue = firstPanel.dateAdded || 1;
        if (secondPanel.type === (0, $55JT4.FORGE_ENTITY_TYPE)) {
            // @ts-expect-error - TS2339 - Property 'dateAdded' does not exist on type 'AddedPanel'.
            const secondValue = secondPanel.dateAdded || 1;
            return firstValue - secondValue;
        }
        return firstValue;
    }
    return Infinity;
};
const $861abb8f92e180ea$var$sortPanels = (allPanelsToAddedPanels)=>allPanelsToAddedPanels// @ts-expect-error - TS2769 - No overload matches this call.
    .map((panel)=>[].concat(panel)).sort((firstPanel, secondPanel)=>$861abb8f92e180ea$var$panelsComparator(firstPanel[0], secondPanel[0]));
const $861abb8f92e180ea$export$b2c15e41218fc96 = (firstActivity, secondActivity)=>{
    // The sort order rule:
    // 1. Forge activity ordered alphabetically.
    // 2. Connect panels, sorting criteria won't be changed
    if (firstActivity.type === (0, $55JT4.FORGE_ENTITY_TYPE)) {
        const firstValue = firstActivity.name.toLowerCase();
        if (secondActivity.type === (0, $55JT4.FORGE_ENTITY_TYPE)) {
            const secondValue = secondActivity.name.toLowerCase();
            if (firstValue < secondValue) return -Infinity;
            if (firstValue > secondValue) return Infinity;
            return 0;
        }
        return Infinity;
    }
    return Infinity;
};
const $861abb8f92e180ea$export$a48c28ad36cb708e = $861abb8f92e180ea$export$7fec16e3d5cd5f4e((0, $ahm5r.createSelector)($861abb8f92e180ea$export$80fcdb58a34c02a8, $861abb8f92e180ea$export$47d3fa7df862ae6f, $861abb8f92e180ea$export$7d77b0f1f3d84166, $861abb8f92e180ea$export$528e2c054f1a65f6, (0, $5EgB1.analyticsSourceSelector), (selectedPanels, allPanels, customised, newIssue, analyticsSource)=>{
    const allPanelsToAddedPanels = allPanels.map((panel)=>{
        // Forge-defined panels
        if (panel.type === (0, $55JT4.FORGE_ENTITY_TYPE)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const forgePanel = panel;
            // For a transition period we always render panels without a quick add button
            if (!forgePanel.iconUrl) return forgePanel;
            const prefix = `${forgePanel.appKey}/${forgePanel.moduleKey}-`;
            const filteredSelectedPanels = selectedPanels.filter((sPanel)=>(0, $UwIK7.isKeyMatchPrefix)(sPanel, prefix)).map((sPanel)=>{
                const panelProperties = (0, $8tnLu.parseForgeIssuePanel)(sPanel);
                if (panelProperties == null) (0, $eGXqc.fireOperationalFailedEvent)(analyticsSource, {
                    error: Error(`Panel key doesn't match regexp: ${sPanel}`)
                });
                return panelProperties && {
                    ...forgePanel,
                    dateAdded: panelProperties.added,
                    panelInstanceId: panelProperties.id
                };
            }).filter(Boolean);
            return filteredSelectedPanels.length > 0 && filteredSelectedPanels;
        }
        // Connect-defined panels
        if (!customised && !newIssue) return panel;
        const isSelected = selectedPanels.includes(`${panel.appKey}_${panel.moduleKey}`) || // BENTO-2491 SelectedPanels could be saved using keys without tailing digits
        selectedPanels.includes(`${panel.appKey}_${(0, $8tnLu.removeTimestamp)(panel.moduleKey, 10)}`) || panel.showByDefault;
        return isSelected && panel;
    });
    const addedPanels = (0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))($861abb8f92e180ea$var$sortPanels(allPanelsToAddedPanels.filter(Boolean)));
    return addedPanels;
}));
const $861abb8f92e180ea$export$9f3aeb87662f360b = (appKey, moduleKey)=>(0, $ahm5r.createSelector)((0, $4fVVF.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.contentPanels && ecosystem.contentPanels[appKey] && ecosystem.contentPanels[appKey][moduleKey]);
const $861abb8f92e180ea$export$1a9c93efcb1ffec7 = (appKey, moduleKey)=>(0, $ahm5r.createSelector)((0, $4fVVF.ecosystemEntitiesSelector), (ecosystem)=>Boolean(ecosystem && ecosystem.selectedContentPanel && (ecosystem.selectedContentPanel === `${appKey}_${moduleKey}` || ecosystem.selectedContentPanel === `${appKey}_${(0, $8tnLu.removeTimestamp)(moduleKey, 10)}`)));
const $861abb8f92e180ea$export$dd6c9850f9e61a72 = (0, $ahm5r.createSelector)((0, $5EgB1.isEcosystemEnabledSelector), $861abb8f92e180ea$var$activityPanelsEntitiesSelector, (isEcosystemEnabled, activityPanelEntities)=>isEcosystemEnabled ? activityPanelEntities.map((entity)=>({
            name: entity.name,
            appKey: entity.appKey,
            moduleKey: entity.moduleKey,
            options: entity.options,
            type: (0, $55JT4.CONNECT_ENTITY_TYPE)
        })) : []);
const $861abb8f92e180ea$export$9222e43f5478367f = (0, $ahm5r.createSelector)([
    (0, $dLJHp.forgeIssueActivitySelector),
    $861abb8f92e180ea$export$dd6c9850f9e61a72
], (forge, connect)=>[
        ...forge,
        ...connect
    ].sort($861abb8f92e180ea$export$b2c15e41218fc96));

});
parcelRegister("eGXqc", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $c418ad8ece482e34$export$add44f896fb31ba3);
$parcel$export(module.exports, "fireUiActionClickedEvent", () => $c418ad8ece482e34$export$a645c87ca2607d94);
$parcel$export(module.exports, "fireTrackActionSucceedEvent", () => $c418ad8ece482e34$export$435f030e21a120be);
$parcel$export(module.exports, "fireOperationalActionFailedEvent", () => $c418ad8ece482e34$export$828a66ad00e9a886);
$parcel$export(module.exports, "fireTrackSavedEvent", () => $c418ad8ece482e34$export$1dbf5d2537a38bd8);
$parcel$export(module.exports, "fireOperationalSaveFailedEvent", () => $c418ad8ece482e34$export$cda76554fa8eee1d);
$parcel$export(module.exports, "fireUiRemoveClickedEvent", () => $c418ad8ece482e34$export$2e4d409fc887e7e);
$parcel$export(module.exports, "fireTrackRemovedEvent", () => $c418ad8ece482e34$export$daf10221407e1b30);
$parcel$export(module.exports, "fireOperationalRemoveFailedEvent", () => $c418ad8ece482e34$export$d12e864ea545eb36);
$parcel$export(module.exports, "fireUiTriggerSelectedEvent", () => $c418ad8ece482e34$export$4d7a3fdb2dd15cbb);
$parcel$export(module.exports, "fireUiCollapseExpandClickedEvent", () => $c418ad8ece482e34$export$c157193e598947ac);
$parcel$export(module.exports, "fireUiPinUnpinActionClickedEvent", () => $c418ad8ece482e34$export$3505d5814fdb005d);
$parcel$export(module.exports, "fireTrackUpdateSucceedEvent", () => $c418ad8ece482e34$export$98e4a25792520246);
$parcel$export(module.exports, "fireOperationalUpdateFailedEvent", () => $c418ad8ece482e34$export$9ee09996d253231a);

var $fohjD = parcelRequire("fohjD");

var $1GZq2 = parcelRequire("1GZq2");

var $ibOCX = parcelRequire("ibOCX");

var $lHD3D = parcelRequire("lHD3D");

var $9gq2c = parcelRequire("9gq2c");

var $7jTnu = parcelRequire("7jTnu");
const $c418ad8ece482e34$var$moduleEventId = (0, $ibOCX.getEventIdOld)({
    module: (0, $fohjD.ISSUE_PANEL_MODULE),
    moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
});
const $c418ad8ece482e34$var$triggerEventId = (0, $ibOCX.getEventIdOld)({
    module: (0, $fohjD.ISSUE_PANEL_MODULE),
    moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER)
});
const $c418ad8ece482e34$export$add44f896fb31ba3 = (source, attributes)=>(0, $1GZq2.fireOperationalEvent)((0, $9gq2c.OPERATIONAL_ACTIONS).FAILED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
        }) : $c418ad8ece482e34$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $c418ad8ece482e34$export$a645c87ca2607d94 = (source, attributes)=>(0, $1GZq2.fireUiEvent)((0, $9gq2c.UI_ACTIONS).ACTION_CLICKED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
        }) : $c418ad8ece482e34$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $c418ad8ece482e34$export$435f030e21a120be = (source, attributes)=>(0, $1GZq2.fireTrackEvent)((0, $9gq2c.TRACK_ACTIONS).ACTION_SUCCEED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
        }) : $c418ad8ece482e34$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $c418ad8ece482e34$export$828a66ad00e9a886 = (source, attributes)=>(0, $1GZq2.fireOperationalEvent)((0, $9gq2c.OPERATIONAL_ACTIONS).ACTION_FAILED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
        }) : $c418ad8ece482e34$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $c418ad8ece482e34$export$1dbf5d2537a38bd8 = (source, attributes)=>(0, $1GZq2.fireTrackEvent)((0, $9gq2c.TRACK_ACTIONS).SAVED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
        }) : $c418ad8ece482e34$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $c418ad8ece482e34$export$cda76554fa8eee1d = (source, attributes)=>(0, $1GZq2.fireOperationalEvent)((0, $9gq2c.OPERATIONAL_ACTIONS).SAVE_FAILED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
        }) : $c418ad8ece482e34$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $c418ad8ece482e34$export$2e4d409fc887e7e = (source, attributes)=>(0, $1GZq2.fireUiEvent)((0, $9gq2c.UI_ACTIONS).REMOVE_CLICKED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
        }) : $c418ad8ece482e34$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $c418ad8ece482e34$export$daf10221407e1b30 = (source, attributes)=>(0, $1GZq2.fireTrackEvent)((0, $9gq2c.TRACK_ACTIONS).REMOVED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
        }) : $c418ad8ece482e34$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $c418ad8ece482e34$export$d12e864ea545eb36 = (source, attributes)=>(0, $1GZq2.fireOperationalEvent)((0, $9gq2c.OPERATIONAL_ACTIONS).REMOVE_FAILED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
        }) : $c418ad8ece482e34$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $c418ad8ece482e34$export$4d7a3fdb2dd15cbb = (extensionId, source, attributes)=>{
    (0, $lHD3D.forgeModulesConcurrentLoadTime)(extensionId).start({
        startTime: performance.now()
    });
    return (0, $1GZq2.fireUiEvent)((0, $9gq2c.UI_ACTIONS).SELECTED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER)
        }) : $c418ad8ece482e34$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $c418ad8ece482e34$export$c157193e598947ac = (source, attributes)=>(0, $1GZq2.fireUiEvent)((0, $9gq2c.UI_ACTIONS).COLLAPSE_EXPAND_CLICKED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
        }) : $c418ad8ece482e34$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $c418ad8ece482e34$export$3505d5814fdb005d = (source, attributes)=>(0, $1GZq2.fireUiEvent)((0, $9gq2c.UI_ACTIONS).PIN_UNPIN_CLICKED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
        }) : $c418ad8ece482e34$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $c418ad8ece482e34$export$98e4a25792520246 = (source, attributes)=>(0, $1GZq2.fireTrackEvent)((0, $9gq2c.TRACK_ACTIONS).UPDATE_SUCCEED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
        }) : $c418ad8ece482e34$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $c418ad8ece482e34$export$9ee09996d253231a = (source, attributes)=>(0, $1GZq2.fireOperationalEvent)((0, $9gq2c.OPERATIONAL_ACTIONS).UPDATE_FAILED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.ISSUE_PANEL_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION)
        }) : $c418ad8ece482e34$var$moduleEventId,
        source: source,
        attributes: attributes
    });

});
parcelRegister("ibOCX", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $0853041cadec7561$export$5639f6a927500d9);
$parcel$export(module.exports, "getEventIdOld", () => $0853041cadec7561$export$b2919e256f1e5dfc);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $0853041cadec7561$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getBrowserMetricsEventIdOld", () => $0853041cadec7561$export$66db5d4145894f38);
$parcel$export(module.exports, "getEventActionName", () => $0853041cadec7561$export$644ccb9a67b9a9c1);

var $fohjD = parcelRequire("fohjD");

var $5IiZP = parcelRequire("5IiZP");

var $9gq2c = parcelRequire("9gq2c");
const $0853041cadec7561$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $0853041cadec7561$var$prepareModuleMode = (entryPoint)=>`${$0853041cadec7561$var$capitalizeFirstLetter(entryPoint)}`;
const $0853041cadec7561$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $0853041cadec7561$var$prepareModuleName = (moduleName)=>(0, $fohjD.SUPPORTED_MODULES).includes(moduleName) ? $0853041cadec7561$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $0853041cadec7561$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $9gq2c.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${eventNamePostfix}`);
    return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${$0853041cadec7561$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $0853041cadec7561$export$b2919e256f1e5dfc = ({ module: module, moduleType: moduleType = (0, $9gq2c.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${$0853041cadec7561$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $0853041cadec7561$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}-${forgeUiType}`);
    return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${$0853041cadec7561$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $0853041cadec7561$export$66db5d4145894f38 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    return (0, $5IiZP.toEventId)(`${$0853041cadec7561$var$prepareModuleName(module)}${$0853041cadec7561$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $0853041cadec7561$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $9gq2c.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("UwIK7", function(module, exports) {

$parcel$export(module.exports, "toForgeKey", () => $b6d7626e287874ee$export$fef910e3c6a21573);
$parcel$export(module.exports, "toForgeKeyWithDate", () => $b6d7626e287874ee$export$4a8bc976ef8470fb);
$parcel$export(module.exports, "toForgeKeyFromExtensionId", () => $b6d7626e287874ee$export$72368b9e5ac31f04);
$parcel$export(module.exports, "toConnectKey", () => $b6d7626e287874ee$export$f1cde82a5f64810e);
$parcel$export(module.exports, "toEcosystemKeys", () => $b6d7626e287874ee$export$c9483bbc66b4fb20);
$parcel$export(module.exports, "isForgeExtension", () => $b6d7626e287874ee$export$b0ed77f2dd403096);
$parcel$export(module.exports, "isKeyMatchPrefix", () => $b6d7626e287874ee$export$75f2b72396a13fc0);

var $fohjD = parcelRequire("fohjD");
const $b6d7626e287874ee$export$fef910e3c6a21573 = (appKey, moduleKey)=>`${appKey}/${moduleKey}`;
const $b6d7626e287874ee$export$4a8bc976ef8470fb = (appKey, moduleKey, panelInstanceId, dateAdded)=>`${appKey}/${moduleKey}-${panelInstanceId}-${dateAdded}`;
const $b6d7626e287874ee$export$72368b9e5ac31f04 = (extensionId, panelInstanceId, dateAdded)=>panelInstanceId != null ? `${extensionId}-${panelInstanceId}-${dateAdded}` : `${extensionId}-${0, $fohjD.NONE_PANEL_INSTANCE_ID}-${dateAdded}`;
const $b6d7626e287874ee$export$f1cde82a5f64810e = (appKey, moduleKey)=>`${appKey}_${moduleKey}`;
const $b6d7626e287874ee$export$c9483bbc66b4fb20 = (extensionId)=>{
    const [prefix, appId, envId, ...rest] = extensionId.split('/');
    const appKey = [
        prefix,
        appId,
        envId
    ].join('/');
    const moduleKey = rest.join('/');
    return {
        appKey: appKey,
        moduleKey: moduleKey
    };
};
const $b6d7626e287874ee$export$b0ed77f2dd403096 = (appKey)=>appKey.startsWith((0, $fohjD.FORGE_FIELD_TYPE_PREFIX));
const $b6d7626e287874ee$export$75f2b72396a13fc0 = (key, prefix)=>key.startsWith(prefix) && /^\w+-\d+$/.test(key.slice(prefix.length));

});

parcelRegister("8tnLu", function(module, exports) {

$parcel$export(module.exports, "removeTimestamp", () => $eee175c39755c25a$export$8144a1156e1fc1b3);
$parcel$export(module.exports, "parseForgeIssuePanel", () => $eee175c39755c25a$export$a21b4e384e411f26);
// when input is like 'my-issue-content-panel-5794110541888792068', output is 'my-issue-content-panel'
const $eee175c39755c25a$export$8144a1156e1fc1b3 = (str, minDigitsLen = 0)=>{
    const indexOfHyphen = str.lastIndexOf('-');
    const tail = str.substr(indexOfHyphen + 1);
    if (/^\d+$/.test(tail) && tail.length >= minDigitsLen) return str.substr(0, indexOfHyphen);
    return str;
};
const $eee175c39755c25a$export$a21b4e384e411f26 = (panelKey)=>{
    const match = panelKey.match(/^(.*)-(\w+)-(\d+)$/);
    if (match == null) return null;
    const [, extensionId, id, timestamp] = match;
    const added = Number(timestamp);
    return {
        extensionId: extensionId,
        id: id,
        added: added
    };
};

});

parcelRegister("GhTyR", function(module, exports) {

$parcel$export(module.exports, "permissionsSelector", () => $db89709ba3523ed2$export$7a13e26fbaa74911);
$parcel$export(module.exports, "canBeAssignedToIssuesPermissionsSelector", () => $db89709ba3523ed2$export$6da6e9cc5af6cc92);
$parcel$export(module.exports, "canAdministerProjectPermissionsSelector", () => $db89709ba3523ed2$export$106fd3c30fc8b230);
$parcel$export(module.exports, "canAdministerJiraPermissionsSelector", () => $db89709ba3523ed2$export$adf4ccad5657586d);
$parcel$export(module.exports, "canModifyReporterPermissionsSelector", () => $db89709ba3523ed2$export$85a3c8518f632ff1);
$parcel$export(module.exports, "canAssignIssuesPermissionsSelector", () => $db89709ba3523ed2$export$f58a91878385514);
$parcel$export(module.exports, "canCreateChildrenPermissionsSelector", () => $db89709ba3523ed2$export$183d12154c212e2b);
$parcel$export(module.exports, "canExportIssueSelector", () => $db89709ba3523ed2$export$a409252beda5dd99);
$parcel$export(module.exports, "watchersPermissionsSelector", () => $db89709ba3523ed2$export$b3bd1cf4683807d8);
$parcel$export(module.exports, "canViewDevToolsPermissionsSelector", () => $db89709ba3523ed2$export$dfc7b576e23ac861);
$parcel$export(module.exports, "canUseServiceDeskAgentFeaturesSelector", () => $db89709ba3523ed2$export$1b79be16305d8111);

var $ahm5r = parcelRequire("ahm5r");

var $huH03 = parcelRequire("huH03");

var $ln6Iy = parcelRequire("ln6Iy");

var $5EgB1 = parcelRequire("5EgB1");

var $6az7p = parcelRequire("6az7p");
const $db89709ba3523ed2$var$internalPermissionsSelector = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.permissions || {});
const $db89709ba3523ed2$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm = new Set([
    // In the BE this is not technically a veto'd permission, however it simplifies the FE code to pretend that it is.
    'canUseServiceDeskAgentFeatures',
    // Normal veto'd permissions as per ServiceDeskCollaboratorPermissionOverrideStrategy in BE
    'canEditIssues',
    'canTransitionIssues',
    'canScheduleIssues',
    'canMoveIssue',
    'canAssignIssues',
    'canBeAssignedToIssues',
    'canDeleteIssue',
    'canManageWatchers',
    'canEditAllComments',
    'canDeleteAllComments',
    'canDeleteAllAttachments',
    'canLogWork',
    'canEditOwnWorklogs',
    'canEditAllWorklogs',
    'canDeleteOwnWorklogs',
    'canDeleteAllWorklogs',
    // These should be vetoed, but aren't requested by JFE yet
    'canResolveIssues',
    'canViewReadonlyWorkflow',
    'canCloseIssues',
    'canModifyReporter',
    'canSetIssueSecurity',
    'canArchiveIssue',
    'canUnarchiveIssue'
]);
const $db89709ba3523ed2$export$7a13e26fbaa74911 = (0, $ahm5r.createSelector)((0, $5EgB1.appPermissionsSelector), (0, $6az7p.projectTypeSelector), $db89709ba3523ed2$var$internalPermissionsSelector, (0, $5EgB1.tenantHasActiveServiceDeskLicenseSelector), (applicationPermissions, projectType, permissions, tenantHasActiveServiceDeskLicense)=>{
    if (projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT) && tenantHasActiveServiceDeskLicense) {
        const { canUseServiceDeskAgentFeatures: canUseServiceDeskAgentFeatures } = permissions;
        const hasJsdAppRole = applicationPermissions.hasServiceDeskAccess;
        return (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(permissions, (hasPermission, key)=>$db89709ba3523ed2$var$jsdPermissionsSetThatNeedApplicationRoleAndAgentPerm.has(key) ? hasPermission && hasJsdAppRole && canUseServiceDeskAgentFeatures : hasPermission);
    }
    return permissions;
});
const $db89709ba3523ed2$export$6da6e9cc5af6cc92 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>!!permissions.canBeAssignedToIssues);
const $db89709ba3523ed2$export$106fd3c30fc8b230 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerProject);
const $db89709ba3523ed2$export$adf4ccad5657586d = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>!!permissions.canAdministerJira);
const $db89709ba3523ed2$var$canViewWatchersPermissionsSelector = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canViewWatchers);
const $db89709ba3523ed2$var$canManageWatchersPermissionsSelector = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canManageWatchers);
const $db89709ba3523ed2$export$85a3c8518f632ff1 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canModifyReporter);
const $db89709ba3523ed2$export$f58a91878385514 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canAssignIssues);
const $db89709ba3523ed2$export$183d12154c212e2b = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>!!permissions.canCreateChildren);
const $db89709ba3523ed2$export$a409252beda5dd99 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canExportIssue);
const $db89709ba3523ed2$export$b3bd1cf4683807d8 = (0, $ahm5r.createSelector)($db89709ba3523ed2$var$canViewWatchersPermissionsSelector, $db89709ba3523ed2$var$canManageWatchersPermissionsSelector, (canViewWatchers, canManageWatchers)=>({
        canViewWatchers: canViewWatchers,
        canManageWatchers: canManageWatchers
    }));
const $db89709ba3523ed2$export$ca6b7f39a3de4ff9 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canBrowseUsers);
const $db89709ba3523ed2$export$dfc7b576e23ac861 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canViewDevTools);
const $db89709ba3523ed2$export$1b79be16305d8111 = (0, $ahm5r.createSelector)($db89709ba3523ed2$export$7a13e26fbaa74911, (permissions)=>permissions.canUseServiceDeskAgentFeatures);

});
parcelRegister("huH03", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $cbc697e9f663ba19$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $cbc697e9f663ba19$var$mapValues;

});


const $5abb7859136f3cea$export$bdafa6b589be8b30 = 'issue.content.panel.customised.flag';

parcelRegister("4fVVF", function(module, exports) {

$parcel$export(module.exports, "ecosystemEntitiesSelector", () => $5e08e45fe2993546$export$8db07a5bb000e56f);
$parcel$export(module.exports, "forgeEntitiesSelector", () => $5e08e45fe2993546$export$92b32d478f0e29fb);

var $ahm5r = parcelRequire("ahm5r");

var $6az7p = parcelRequire("6az7p");

var $cnihn = parcelRequire("cnihn");
const $5e08e45fe2993546$export$8db07a5bb000e56f = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.ecosystem || {});
const $5e08e45fe2993546$export$92b32d478f0e29fb = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.forge || (0, $cnihn.initialState));

});
parcelRegister("cnihn", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $385501577a708e32$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $385501577a708e32$export$2e2bcd8739ae039);

var $X1e6N = parcelRequire("X1e6N");

var $5mREs = parcelRequire("5mREs");

var $hXPXP = parcelRequire("hXPXP");
const $385501577a708e32$export$d4c72bab9d6cc13a = {
    actions: [],
    glances: [],
    issueContexts: [],
    panels: [],
    activities: [],
    customFields: [],
    customFieldTypes: [],
    backgroundScripts: [],
    activeAction: null,
    panelsKeys: {
        newPanels: [],
        collapsedPanels: []
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$385501577a708e32$export$2e2bcd8739ae039 = (state = $385501577a708e32$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $X1e6N.FETCH_FORGE_SUCCESS:
            return {
                ...state,
                actions: action.payload.issueAction,
                glances: action.payload.issueGlance,
                issueContexts: action.payload.issueContext,
                panels: action.payload.issuePanel,
                activities: action.payload.issueActivity,
                customFields: action.payload.customField,
                customFieldTypes: action.payload.customFieldType,
                backgroundScripts: action.payload.issueViewBackgroundScript,
                panelsKeys: {
                    ...state.panelsKeys
                }
            };
        case 0, $X1e6N.FORGE_ISSUE_ACTION_EXEC:
            return {
                ...state,
                activeAction: {
                    action: action.payload,
                    isLoading: true
                }
            };
        case 0, $X1e6N.FORGE_ISSUE_ACTION_RENDERED:
            return {
                ...state,
                // @ts-expect-error - TS2322 - Type '{ isLoading: false; action?: Action | undefined; }' is not assignable to type 'ActiveAction'.
                activeAction: {
                    ...state.activeAction,
                    isLoading: false
                }
            };
        case 0, $X1e6N.FORGE_ISSUE_ACTION_CLOSE:
            return {
                ...state,
                activeAction: null
            };
        case 0, $X1e6N.FORGE_ISSUE_PANEL_ADDED:
            return {
                ...state,
                panelsKeys: {
                    ...state.panelsKeys,
                    newPanels: [
                        ...state.panelsKeys.newPanels,
                        action.payload
                    ]
                }
            };
        case 0, $X1e6N.FORGE_NEW_ISSUE_PANEL_UNTRACK:
            {
                const removedPanelKey = action.payload;
                const { panelsKeys: panelsKeys } = state;
                return {
                    ...state,
                    panelsKeys: {
                        ...panelsKeys,
                        newPanels: panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                    }
                };
            }
        case 0, $X1e6N.FORGE_ISSUE_PANEL_REMOVED:
            {
                const removedPanelKey = action.payload;
                return {
                    ...state,
                    panelsKeys: {
                        newPanels: state.panelsKeys.newPanels.filter((panelKey)=>panelKey !== removedPanelKey),
                        collapsedPanels: state.panelsKeys.collapsedPanels.filter((panelKey)=>panelKey !== removedPanelKey)
                    }
                };
            }
        case 0, $X1e6N.FORGE_ISSUE_PANEL_UPDATED:
            {
                const { panelKey: panelKey, collapsed: collapsed } = action.payload;
                const updatedCollapsedPanels = collapsed ? Array.from(new Set([
                    ...state.panelsKeys.collapsedPanels,
                    panelKey
                ])) : state.panelsKeys.collapsedPanels.filter((key)=>key !== panelKey);
                return {
                    ...state,
                    panelsKeys: {
                        ...state.panelsKeys,
                        collapsedPanels: updatedCollapsedPanels
                    }
                };
            }
        case 0, $hXPXP.FETCH_ISSUE_SUCCESS:
        case 0, $hXPXP.REFRESH_ISSUE_SUCCESS:
        case 0, $5mREs.FETCH_ISSUE_REMOTE_DATA_SUCCESS:
            {
                const collapsedPanels = action.payload.forgeIssueProperties?.collapsedPanels || [];
                return {
                    ...state,
                    panelsKeys: {
                        ...state.panelsKeys,
                        collapsedPanels: Array.from(new Set([
                            ...state.panelsKeys.collapsedPanels,
                            ...collapsedPanels
                        ]))
                    }
                };
            }
        default:
            return state;
    }
};

});
parcelRegister("X1e6N", function(module, exports) {

$parcel$export(module.exports, "FETCH_FORGE_SUCCESS", () => $6e85e4fc1dade945$export$b40fce05e753d390);
$parcel$export(module.exports, "fetchForgeSuccess", () => $6e85e4fc1dade945$export$1b05a0184822bc74);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_EXEC", () => $6e85e4fc1dade945$export$8c062df60fb76839);
$parcel$export(module.exports, "forgeIssueActionExec", () => $6e85e4fc1dade945$export$3a189763780c504b);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_RENDERED", () => $6e85e4fc1dade945$export$dd307b8c5e0de67d);
$parcel$export(module.exports, "forgeIssueActionRendered", () => $6e85e4fc1dade945$export$2484a0b7a9a14f92);
$parcel$export(module.exports, "FORGE_ISSUE_ACTION_CLOSE", () => $6e85e4fc1dade945$export$d91b51ae909f8e95);
$parcel$export(module.exports, "forgeIssueActionClose", () => $6e85e4fc1dade945$export$335a03a463c5945a);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_ADDED", () => $6e85e4fc1dade945$export$7d7831d10e022e0);
$parcel$export(module.exports, "forgeIssuePanelAdded", () => $6e85e4fc1dade945$export$f24c609edeac582f);
$parcel$export(module.exports, "FORGE_NEW_ISSUE_PANEL_UNTRACK", () => $6e85e4fc1dade945$export$d36cecbf4e320d4a);
$parcel$export(module.exports, "forgeNewIssuePanelUntrack", () => $6e85e4fc1dade945$export$b93b979485d242c8);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_REMOVED", () => $6e85e4fc1dade945$export$798e467d6a4cb5c);
$parcel$export(module.exports, "forgeIssuePanelRemoved", () => $6e85e4fc1dade945$export$b584e6f1797702be);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATE_REQUEST", () => $6e85e4fc1dade945$export$bb2e005bc0498829);
$parcel$export(module.exports, "forgeIssuePanelUpdateRequest", () => $6e85e4fc1dade945$export$c67c4f64ec92ba7f);
$parcel$export(module.exports, "FORGE_ISSUE_PANEL_UPDATED", () => $6e85e4fc1dade945$export$2ce5fe154022894b);
$parcel$export(module.exports, "forgeIssuePanelUpdated", () => $6e85e4fc1dade945$export$e2eebb5b364492ce);
const $6e85e4fc1dade945$export$b40fce05e753d390 = 'FETCH_FORGE_SUCCESS';
const $6e85e4fc1dade945$export$1b05a0184822bc74 = (payload)=>({
        type: $6e85e4fc1dade945$export$b40fce05e753d390,
        payload: payload
    });
const $6e85e4fc1dade945$export$8c062df60fb76839 = 'FORGE_ISSUE_ACTION_EXEC';
const $6e85e4fc1dade945$export$3a189763780c504b = (action)=>({
        type: $6e85e4fc1dade945$export$8c062df60fb76839,
        payload: action
    });
const $6e85e4fc1dade945$export$dd307b8c5e0de67d = 'FORGE_ISSUE_ACTION_RENDERED';
const $6e85e4fc1dade945$export$2484a0b7a9a14f92 = ()=>({
        type: $6e85e4fc1dade945$export$dd307b8c5e0de67d
    });
const $6e85e4fc1dade945$export$d91b51ae909f8e95 = 'FORGE_ISSUE_ACTION_CLOSE';
const $6e85e4fc1dade945$export$335a03a463c5945a = ()=>({
        type: $6e85e4fc1dade945$export$d91b51ae909f8e95
    });
const $6e85e4fc1dade945$export$7d7831d10e022e0 = 'FORGE_ISSUE_PANEL_ADDED';
const $6e85e4fc1dade945$export$f24c609edeac582f = (issuePanelKey)=>({
        type: $6e85e4fc1dade945$export$7d7831d10e022e0,
        payload: issuePanelKey
    });
const $6e85e4fc1dade945$export$d36cecbf4e320d4a = 'FORGE_NEW_ISSUE_PANEL_UNTRACK';
const $6e85e4fc1dade945$export$b93b979485d242c8 = (issuePanelKey)=>({
        type: $6e85e4fc1dade945$export$d36cecbf4e320d4a,
        payload: issuePanelKey
    });
const $6e85e4fc1dade945$export$798e467d6a4cb5c = 'FORGE_ISSUE_PANEL_REMOVED';
const $6e85e4fc1dade945$export$b584e6f1797702be = (issuePanelKey)=>({
        type: $6e85e4fc1dade945$export$798e467d6a4cb5c,
        payload: issuePanelKey
    });
const $6e85e4fc1dade945$export$bb2e005bc0498829 = 'FORGE_ISSUE_PANEL_UPDATE_REQUEST';
const $6e85e4fc1dade945$export$c67c4f64ec92ba7f = (payload)=>({
        type: $6e85e4fc1dade945$export$bb2e005bc0498829,
        payload: payload
    });
const $6e85e4fc1dade945$export$2ce5fe154022894b = 'FORGE_ISSUE_PANEL_UPDATED';
const $6e85e4fc1dade945$export$e2eebb5b364492ce = (payload)=>({
        type: $6e85e4fc1dade945$export$2ce5fe154022894b,
        payload: payload
    });

});

parcelRegister("5mREs", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_REQUEST", () => $54ed1b66082cebd1$export$d8a6e69b46d6d184);
$parcel$export(module.exports, "fetchIssueRemoteDataRequest", () => $54ed1b66082cebd1$export$222125e4e0f166e4);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_REQUEST_LOADING_COMPLETE", () => $54ed1b66082cebd1$export$c511d3093cea9ec6);
$parcel$export(module.exports, "fetchIssueRemoteDataRequestLoadingComplete", () => $54ed1b66082cebd1$export$86a90761307d7be0);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_SUCCESS", () => $54ed1b66082cebd1$export$2cdd723fc40cdd47);
$parcel$export(module.exports, "fetchIssueRemoteDataSuccess", () => $54ed1b66082cebd1$export$615a2d29b149df95);
$parcel$export(module.exports, "FETCH_ISSUE_REMOTE_DATA_FAILURE", () => $54ed1b66082cebd1$export$396f0d977db541d9);
$parcel$export(module.exports, "fetchIssueRemoteDataFailure", () => $54ed1b66082cebd1$export$f7fd18472eaf2b77);
$parcel$export(module.exports, "FETCH_ALL_ISSUE_WHITEBOARDS_SUCCESS", () => $54ed1b66082cebd1$export$7067db2dbaa9931);
$parcel$export(module.exports, "fetchAllIssueWhiteboardsSuccess", () => $54ed1b66082cebd1$export$56e06a2cdd56648f);
const $54ed1b66082cebd1$export$d8a6e69b46d6d184 = 'FETCH_ISSUE_REMOTE_DATA_REQUEST';
const $54ed1b66082cebd1$export$222125e4e0f166e4 = (issueKey)=>({
        type: $54ed1b66082cebd1$export$d8a6e69b46d6d184,
        payload: issueKey
    });
const $54ed1b66082cebd1$export$c511d3093cea9ec6 = 'FETCH_ISSUE_REMOTE_DATA_REQUEST_LOADING_COMPLETE';
const $54ed1b66082cebd1$export$86a90761307d7be0 = ()=>({
        type: $54ed1b66082cebd1$export$c511d3093cea9ec6
    });
const $54ed1b66082cebd1$export$2cdd723fc40cdd47 = 'FETCH_ISSUE_REMOTE_DATA_SUCCESS';
const $54ed1b66082cebd1$export$615a2d29b149df95 = (entities)=>({
        type: $54ed1b66082cebd1$export$2cdd723fc40cdd47,
        payload: entities
    });
const $54ed1b66082cebd1$export$396f0d977db541d9 = 'FETCH_ISSUE_REMOTE_DATA_FAILURE';
const $54ed1b66082cebd1$export$f7fd18472eaf2b77 = ()=>({
        type: $54ed1b66082cebd1$export$396f0d977db541d9
    });
const $54ed1b66082cebd1$export$7067db2dbaa9931 = 'FETCH_ISSUE_WHITEBOARDS_SUCCESS';
const $54ed1b66082cebd1$export$56e06a2cdd56648f = (whiteboardData)=>({
        type: $54ed1b66082cebd1$export$7067db2dbaa9931,
        payload: whiteboardData
    });

});

parcelRegister("hXPXP", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REQUEST", () => $18397eaa666462a5$export$afc8565512ebbf99);
$parcel$export(module.exports, "fetchIssueRequest", () => $18397eaa666462a5$export$ff7cd1a46115d8ca);
$parcel$export(module.exports, "FETCH_ISSUE_SUCCESS", () => $18397eaa666462a5$export$c32d0e1f370b7914);
$parcel$export(module.exports, "fetchIssueSuccess", () => $18397eaa666462a5$export$1e39a30e3f37e9d1);
$parcel$export(module.exports, "FETCH_ISSUE_FAILURE", () => $18397eaa666462a5$export$700ca24f76d5bbe6);
$parcel$export(module.exports, "fetchIssueFailure", () => $18397eaa666462a5$export$625e6e61fad65793);
$parcel$export(module.exports, "REFRESH_ISSUE_REQUEST", () => $18397eaa666462a5$export$b48f53bf5b842d57);
$parcel$export(module.exports, "refreshIssueRequest", () => $18397eaa666462a5$export$ccd0db94940d9159);
$parcel$export(module.exports, "CANCEL_REFRESH_ISSUE_REQUEST", () => $18397eaa666462a5$export$6b6ca6acd76420d1);
$parcel$export(module.exports, "cancelRefreshIssueRequest", () => $18397eaa666462a5$export$a7629a657f902cbc);
$parcel$export(module.exports, "REFRESH_ISSUE_SUCCESS", () => $18397eaa666462a5$export$de11c913f06a7952);
$parcel$export(module.exports, "refreshIssueSuccess", () => $18397eaa666462a5$export$cbd1c08fb706639c);
$parcel$export(module.exports, "FETCH_FORGE_REQUEST", () => $18397eaa666462a5$export$36b76b7384d868f3);
$parcel$export(module.exports, "fetchForgeRequest", () => $18397eaa666462a5$export$6ce2430992033a55);
const $18397eaa666462a5$export$afc8565512ebbf99 = 'FETCH_ISSUE_REQUEST';
const $18397eaa666462a5$export$ff7cd1a46115d8ca = ()=>({
        type: $18397eaa666462a5$export$afc8565512ebbf99
    });
const $18397eaa666462a5$export$c32d0e1f370b7914 = 'FETCH_ISSUE_SUCCESS';
const $18397eaa666462a5$export$1e39a30e3f37e9d1 = (entities)=>({
        type: $18397eaa666462a5$export$c32d0e1f370b7914,
        payload: entities
    });
const $18397eaa666462a5$export$700ca24f76d5bbe6 = 'FETCH_ISSUE_FAILURE';
const $18397eaa666462a5$export$625e6e61fad65793 = (failureDescription)=>({
        type: $18397eaa666462a5$export$700ca24f76d5bbe6,
        payload: failureDescription
    });
const $18397eaa666462a5$export$b48f53bf5b842d57 = 'REFRESH_ISSUE_REQUEST';
const $18397eaa666462a5$export$ccd0db94940d9159 = (payload, meta)=>({
        type: $18397eaa666462a5$export$b48f53bf5b842d57,
        payload: payload,
        meta: meta
    });
const $18397eaa666462a5$export$6b6ca6acd76420d1 = 'CANCEL_REFRESH_ISSUE_REQUEST';
const $18397eaa666462a5$export$a7629a657f902cbc = ()=>({
        type: $18397eaa666462a5$export$6b6ca6acd76420d1
    });
const $18397eaa666462a5$export$de11c913f06a7952 = 'REFRESH_ISSUE_SUCCESS';
const $18397eaa666462a5$export$cbd1c08fb706639c = (entities)=>({
        type: $18397eaa666462a5$export$de11c913f06a7952,
        payload: entities
    });
const $18397eaa666462a5$export$36b76b7384d868f3 = 'FETCH_FORGE_REQUEST';
const $18397eaa666462a5$export$6ce2430992033a55 = ()=>({
        type: $18397eaa666462a5$export$36b76b7384d868f3
    });

});



parcelRegister("dLJHp", function(module, exports) {

$parcel$export(module.exports, "forgeContextPanelsSelector", () => $aac3275ed67e2c58$export$94c701814d50fed3);
$parcel$export(module.exports, "forgeGlancesSelector", () => $aac3275ed67e2c58$export$92747468cb57714e);
$parcel$export(module.exports, "forgeIssueActionsSelector", () => $aac3275ed67e2c58$export$9bcd40b01af57823);
$parcel$export(module.exports, "forgePanelsSelector", () => $aac3275ed67e2c58$export$ca115d43abfd7206);
$parcel$export(module.exports, "forgeUserCanSaveIssuePanelSelector", () => $aac3275ed67e2c58$export$ae25fce59e44b253);
$parcel$export(module.exports, "forgeJustAddedPanelSelector", () => $aac3275ed67e2c58$export$9c375a0b9a6e5017);
$parcel$export(module.exports, "forgeCustomFieldsSelector", () => $aac3275ed67e2c58$export$38dd8c9ba1d48d98);
$parcel$export(module.exports, "forgeActiveIssueActionSelector", () => $aac3275ed67e2c58$export$ccad5f28efcec42d);
$parcel$export(module.exports, "forgeIssueDataSelector", () => $aac3275ed67e2c58$export$d3cd515b7639ce61);
$parcel$export(module.exports, "forgeIssueActivitySelector", () => $aac3275ed67e2c58$export$18ce84b90b4920eb);
$parcel$export(module.exports, "isForgePanelNewToIssueSelector", () => $aac3275ed67e2c58$export$97dadedc102bebdf);
$parcel$export(module.exports, "getForgeIssuePanel", () => $aac3275ed67e2c58$export$b01f1fc9eba6d8cd);
$parcel$export(module.exports, "forgeIsCollapsedPanelSelector", () => $aac3275ed67e2c58$export$3d7856e5c65d2291);

var $ahm5r = parcelRequire("ahm5r");

var $jPROM = parcelRequire("jPROM");

var $UwIK7 = parcelRequire("UwIK7");

var $kU13U = parcelRequire("kU13U");

var $5OyZl = parcelRequire("5OyZl");

var $55JT4 = parcelRequire("55JT4");

var $8tnLu = parcelRequire("8tnLu");

var $ljej9 = parcelRequire("ljej9");

var $5EgB1 = parcelRequire("5EgB1");

var $6t0ps = parcelRequire("6t0ps");

var $6az7p = parcelRequire("6az7p");

var $GhTyR = parcelRequire("GhTyR");

var $4372d = parcelRequire("4372d");

var $4fVVF = parcelRequire("4fVVF");
const $aac3275ed67e2c58$var$filterExtensions = (list)=>{
    return list.filter((0, $kU13U.isExtensionVisible));
};
const $aac3275ed67e2c58$var$sortIssuePanels = (first, second)=>{
    if (first.name === second.name) return 0;
    return first.name > second.name ? 1 : -1;
};
const $aac3275ed67e2c58$export$b302c9df74ede99a = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (0, $5EgB1.issueIdSelector), (0, $5EgB1.issueKeySelector), (0, $4372d.issueTypeNameSelector), (0, $6az7p.projectIdSelector), (0, $5EgB1.projectKeySelector), (0, $6az7p.projectTypeSelector), (permissions, issueId, issueKey, issueType, projectId, projectKey, projectType)=>({
        issueId: issueId || null,
        issueKey: issueKey,
        issueType: issueType,
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType || null,
        // Instead of dumping permissions as is we'd like to normalize prop names a bit
        // as they are exposed externally and have to look respectable
        canAddComments: permissions.canAddComments,
        canAdministerJira: permissions.canAdministerJira,
        canAdministerProjects: permissions.canAdministerProject,
        canArchiveIssue: permissions.canArchiveIssue,
        canAssignIssues: permissions.canAssignIssues,
        canBeAssignedToIssues: permissions.canBeAssignedToIssues,
        canCloneIssues: permissions.canCloneIssue,
        canCreateAttachments: permissions.canCreateAttachments,
        canCreateChildren: permissions.canCreateChildren,
        canCreateSubtasks: permissions.canCreateSubtask,
        canDeleteAllAttachments: permissions.canDeleteAllAttachments,
        canDeleteAllComments: permissions.canDeleteAllComments,
        canDeleteAllWorklogs: permissions.canDeleteAllWorklogs,
        canDeleteIssues: permissions.canDeleteIssue,
        canDeleteOwnAttachments: permissions.canDeleteOwnAttachments,
        canDeleteOwnComments: permissions.canDeleteOwnComments,
        canDeleteOwnWorklogs: permissions.canDeleteOwnWorklogs,
        canEditAllComments: permissions.canEditAllComments,
        canEditAllWorklogs: permissions.canEditAllWorklogs,
        canEditIssues: permissions.canEditIssues,
        canEditOwnComments: permissions.canEditOwnComments,
        canEditOwnWorklogs: permissions.canEditOwnWorklogs,
        canLinkIssues: permissions.canLinkIssues,
        canLogWork: permissions.canLogWork,
        canManageWatchers: permissions.canManageWatchers,
        canModifyReporters: permissions.canModifyReporter,
        canMoveIssues: permissions.canMoveIssue,
        canScheduleIssues: permissions.canScheduleIssues,
        canUnarchiveIssue: permissions.canUnarchiveIssue,
        canUseServiceManagementAgentFeatures: permissions.canUseServiceDeskAgentFeatures,
        canBrowseUsers: permissions.canBrowseUsers,
        canViewDevTools: permissions.canViewDevTools,
        canViewWatchers: permissions.canViewWatchers,
        canExportIssue: permissions.canExportIssue
    }));
const $aac3275ed67e2c58$export$94c701814d50fed3 = (0, $ahm5r.createSelector)((0, $5EgB1.isEcosystemEnabledSelector), (0, $4fVVF.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.issueContexts)) return [];
    return forge.issueContexts.filter((extension)=>(0, $kU13U.isExtensionVisible)(extension)).map((contextPanels)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: url } } = contextPanels;
        return {
            id: id,
            type: (0, $5OyZl.FORGE_CONTEXT_TYPE),
            payload: {
                type: (0, $5OyZl.FORGE_CONTEXT_TYPE),
                label: label,
                name: title,
                status: status || null,
                icon: url ? {
                    url: url
                } : null,
                contextPanelType: (0, $55JT4.FORGE_ENTITY_TYPE),
                moduleKey: id,
                appKey: id,
                options: null
            }
        };
    });
});
const $aac3275ed67e2c58$export$92747468cb57714e = (0, $ahm5r.createSelector)((0, $5EgB1.isEcosystemEnabledSelector), (0, $4fVVF.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.glances)) return [];
    return $aac3275ed67e2c58$var$filterExtensions(forge.glances).map((extension)=>{
        const { id: id, properties: { title: title, label: label, status: status, icon: icon } } = extension;
        return {
            title: title,
            label: label,
            status: status,
            icon: icon,
            extension: extension,
            glanceType: (0, $55JT4.FORGE_ENTITY_TYPE),
            // Legacy props, too much refactoring needed in order to get rid of them
            moduleKey: id,
            appKey: id
        };
    });
});
const $aac3275ed67e2c58$export$9bcd40b01af57823 = (0, $ahm5r.createSelector)((0, $5EgB1.isEcosystemEnabledSelector), (0, $4fVVF.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
    return $aac3275ed67e2c58$var$filterExtensions(forge.actions).map((extension)=>{
        const { id: id, properties: { title: title } } = extension;
        return {
            id: id,
            title: title,
            extension: extension,
            type: (0, $55JT4.FORGE_ENTITY_TYPE)
        };
    });
});
const $aac3275ed67e2c58$export$ca115d43abfd7206 = (0, $ahm5r.createSelector)((0, $5EgB1.isEcosystemEnabledSelector), (0, $4fVVF.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.panels)) return [];
    return $aac3275ed67e2c58$var$filterExtensions(forge.panels).filter((extension)=>extension.properties.icon != null).map((extension)=>{
        const { id: id, properties: { title: title, icon: icon, allowMultiple: allowMultiple } } = extension;
        const { appKey: appKey, moduleKey: moduleKey } = (0, $UwIK7.toEcosystemKeys)(id);
        return {
            name: title,
            tooltip: title,
            iconUrl: icon,
            extension: extension,
            allowMultiple: !!allowMultiple,
            showByDefault: false,
            type: (0, $55JT4.FORGE_ENTITY_TYPE),
            moduleKey: moduleKey,
            appKey: appKey
        };
    }).sort($aac3275ed67e2c58$var$sortIssuePanels);
});
const $aac3275ed67e2c58$export$ae25fce59e44b253 = (0, $ahm5r.createSelector)((0, $5EgB1.isEcosystemEnabledSelector), $aac3275ed67e2c58$export$b302c9df74ede99a, (isEcosystemEnabled, issueViewStaticContext)=>isEcosystemEnabled && issueViewStaticContext.canEditIssues);
const $aac3275ed67e2c58$export$9c375a0b9a6e5017 = (panelKey)=>(0, $ahm5r.createSelector)((0, $4fVVF.ecosystemEntitiesSelector), (ecosystem)=>ecosystem && ecosystem.selectedContentPanel === panelKey);
const $aac3275ed67e2c58$export$38dd8c9ba1d48d98 = (0, $ahm5r.createSelector)((0, $5EgB1.isEcosystemEnabledSelector), (0, $4fVVF.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFields)) return [];
    return $aac3275ed67e2c58$var$filterExtensions(forge.customFields);
});
const $aac3275ed67e2c58$export$9cef69a20109a92c = (0, $ahm5r.createSelector)((0, $5EgB1.isEcosystemEnabledSelector), (0, $4fVVF.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.customFieldTypes)) return [];
    return $aac3275ed67e2c58$var$filterExtensions(forge.customFieldTypes);
});
const $aac3275ed67e2c58$export$2f1d736b0e7e1293 = (0, $ahm5r.createSelector)($aac3275ed67e2c58$export$38dd8c9ba1d48d98, (fields)=>fields.length > 0);
const $aac3275ed67e2c58$export$252a589d17b14921 = (0, $ahm5r.createSelector)($aac3275ed67e2c58$export$9cef69a20109a92c, (fieldsTypes)=>fieldsTypes.length > 0);
const $aac3275ed67e2c58$export$89b67d7e4e300f7d = (0, $ahm5r.createSelector)($aac3275ed67e2c58$export$2f1d736b0e7e1293, $aac3275ed67e2c58$export$252a589d17b14921, (hasCustomFields, hasCustomFieldTypes)=>hasCustomFields || hasCustomFieldTypes);
const $aac3275ed67e2c58$export$e824cf91ff446be9 = (0, $ahm5r.createSelector)($aac3275ed67e2c58$export$38dd8c9ba1d48d98, $aac3275ed67e2c58$export$9cef69a20109a92c, (customFields, customFieldTypes)=>[
        ...customFields,
        ...customFieldTypes
    ]);
const $aac3275ed67e2c58$export$ccad5f28efcec42d = (0, $ahm5r.createSelector)((0, $5EgB1.isEcosystemEnabledSelector), (0, $4fVVF.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled) return null;
    return forge.activeAction || null;
});
const $aac3275ed67e2c58$export$e04b25b621339356 = (0, $ahm5r.createSelector)((0, $6t0ps.fieldsSelector), (state, { fieldId: fieldId })=>fieldId, (fields, fieldId)=>fields[fieldId]?.schema.custom || '');
const $aac3275ed67e2c58$export$fbab82209930cdab = (0, $ahm5r.createSelector)($aac3275ed67e2c58$export$e824cf91ff446be9, $aac3275ed67e2c58$export$e04b25b621339356, (forgeFields, extensionId)=>{
    const extension = forgeFields.find((field)=>field.id === extensionId);
    return extension || null;
});
const $aac3275ed67e2c58$export$7640f867620fe598 = (0, $ahm5r.createSelector)($aac3275ed67e2c58$export$fbab82209930cdab, (extension)=>{
    if (!extension) return false;
    const hasRenderingFunction = !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(extension.properties.function);
    const hasFormatterDefined = 'formatter' in extension.properties && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(extension.properties.formatter);
    return !hasRenderingFunction && hasFormatterDefined;
});
const $aac3275ed67e2c58$export$d3cd515b7639ce61 = (0, $ahm5r.createSelector)((0, $5EgB1.issueKeySelector), (0, $5EgB1.issueIdSelector), (0, $4372d.issueTypeIdSelector), (0, $4372d.issueTypeNameSelector), (0, $5EgB1.projectKeySelector), (0, $6az7p.projectIdSelector), (0, $6az7p.projectTypeSelector), (issueKey, issueId, issueTypeId, issueType, projectKey, projectId, projectType)=>({
        issue: {
            key: issueKey,
            id: issueId,
            type: issueType,
            typeId: issueTypeId
        },
        project: {
            id: projectId !== null ? (0, $ljej9.toProjectId)(projectId.toString()) : projectId,
            key: projectKey,
            type: projectType
        }
    }));
const $aac3275ed67e2c58$export$18ce84b90b4920eb = (0, $ahm5r.createSelector)((0, $5EgB1.isEcosystemEnabledSelector), (0, $4fVVF.forgeEntitiesSelector), (isEcosystemEnabled, forge)=>{
    if (!isEcosystemEnabled || !Array.isArray(forge.actions)) return [];
    return $aac3275ed67e2c58$var$filterExtensions(forge.activities).map((extension)=>{
        const { id: id, properties: { title: title } } = extension;
        const { appKey: appKey, moduleKey: moduleKey } = (0, $UwIK7.toEcosystemKeys)(id);
        return {
            name: title,
            extension: extension,
            type: (0, $55JT4.FORGE_ENTITY_TYPE),
            moduleKey: moduleKey,
            appKey: appKey
        };
    });
});
const $aac3275ed67e2c58$export$97dadedc102bebdf = (0, $ahm5r.createSelector)((0, $4fVVF.forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.newPanels.includes(issuePanelKey));
const $aac3275ed67e2c58$export$b01f1fc9eba6d8cd = (forgePanelKey)=>(0, $ahm5r.createSelector)($aac3275ed67e2c58$export$ca115d43abfd7206, (panels)=>{
        const { extensionId: extensionId } = (0, $8tnLu.parseForgeIssuePanel)(forgePanelKey) || {};
        return panels.find((panel)=>extensionId === panel.extension.id);
    });
const $aac3275ed67e2c58$export$3d7856e5c65d2291 = (0, $ahm5r.createSelector)((0, $4fVVF.forgeEntitiesSelector), (_, issuePanelKey)=>issuePanelKey, (forge, issuePanelKey)=>forge.panelsKeys.collapsedPanels.includes(issuePanelKey));

});
parcelRegister("4372d", function(module, exports) {

$parcel$export(module.exports, "createFullIssueUrl", () => $4b8f37979127d2f5$export$f107e3172d0c8a79);
$parcel$export(module.exports, "issueTypeSelector", () => $4b8f37979127d2f5$export$c5a236f192993436);
$parcel$export(module.exports, "issueUrlSelector", () => $4b8f37979127d2f5$export$7855e152de23b9ca);
$parcel$export(module.exports, "fullIssueUrlSelector", () => $4b8f37979127d2f5$export$14eeb219bfe6649b);
$parcel$export(module.exports, "issueTypeNameSelector", () => $4b8f37979127d2f5$export$477df8db13e4dac3);
$parcel$export(module.exports, "issueTypeHierarchyLevelSelector", () => $4b8f37979127d2f5$export$2bcfec06e5c80ef6);
$parcel$export(module.exports, "issueTypeIdSelector", () => $4b8f37979127d2f5$export$22410768c09b3a82);
$parcel$export(module.exports, "issueTypeIconUrlSelector", () => $4b8f37979127d2f5$export$4cf7e4622f7b8aee);
$parcel$export(module.exports, "isIssueTypeFieldEditableSelector", () => $4b8f37979127d2f5$export$580b385a93b77724);
$parcel$export(module.exports, "getParentIssuesSelector", () => $4b8f37979127d2f5$export$1e6d1c8ba22c2162);

var $ahm5r = parcelRequire("ahm5r");

var $8oOr4 = parcelRequire("8oOr4");

var $5EgB1 = parcelRequire("5EgB1");

var $6t0ps = parcelRequire("6t0ps");

var $6az7p = parcelRequire("6az7p");
const $4b8f37979127d2f5$var$createRelativeIssueUrl = (issueKey)=>`/browse/${issueKey}`;
const $4b8f37979127d2f5$export$f107e3172d0c8a79 = (issueKey)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.protocol}//${window.location.host}${$4b8f37979127d2f5$var$createRelativeIssueUrl(issueKey)}`;
const $4b8f37979127d2f5$var$issueTypeFieldSelector = (0, $6t0ps.fieldSelector)((0, $8oOr4.ISSUE_TYPE));
const $4b8f37979127d2f5$var$subtaskIssueFieldSelector = (0, $6t0ps.fieldSelector)((0, $8oOr4.SUBTASK_PARENT));
const $4b8f37979127d2f5$var$portfolioParentFieldSelector = (0, $6t0ps.fieldSelector)((0, $8oOr4.PARENT));
const $4b8f37979127d2f5$export$c5a236f192993436 = (0, $ahm5r.createSelector)($4b8f37979127d2f5$var$issueTypeFieldSelector, (issueType)=>issueType && issueType.value);
const $4b8f37979127d2f5$export$7855e152de23b9ca = (0, $ahm5r.createSelector)((0, $5EgB1.issueKeySelector), $4b8f37979127d2f5$var$createRelativeIssueUrl);
const $4b8f37979127d2f5$export$14eeb219bfe6649b = (0, $ahm5r.createSelector)((0, $5EgB1.issueKeySelector), $4b8f37979127d2f5$export$f107e3172d0c8a79);
const $4b8f37979127d2f5$export$477df8db13e4dac3 = (0, $ahm5r.createSelector)($4b8f37979127d2f5$export$c5a236f192993436, (issueType)=>issueType && issueType.name);
const $4b8f37979127d2f5$export$2bcfec06e5c80ef6 = (0, $ahm5r.createSelector)($4b8f37979127d2f5$export$c5a236f192993436, (issueType)=>{
    if (!issueType) return null;
    return issueType && issueType.hierarchyLevel;
});
const $4b8f37979127d2f5$export$22410768c09b3a82 = (0, $ahm5r.createSelector)($4b8f37979127d2f5$export$c5a236f192993436, (issueType)=>issueType && issueType.id);
const $4b8f37979127d2f5$export$4cf7e4622f7b8aee = (0, $ahm5r.createSelector)($4b8f37979127d2f5$export$c5a236f192993436, (issueType)=>issueType && issueType.iconUrl);
const $4b8f37979127d2f5$export$580b385a93b77724 = (0, $ahm5r.createSelector)($4b8f37979127d2f5$var$issueTypeFieldSelector, (issueType)=>issueType && Boolean(issueType.editable));
const $4b8f37979127d2f5$var$transformParentIssue = (issue)=>issue ? {
        summary: issue.summary,
        key: issue.key,
        url: $4b8f37979127d2f5$var$createRelativeIssueUrl(issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type.
const $4b8f37979127d2f5$var$transformSubtaskParentIssue = (issue)=>issue ? {
        summary: issue.fields.summary,
        key: issue.key,
        url: $4b8f37979127d2f5$var$createRelativeIssueUrl(issue.key),
        issueTypeName: issue.issueTypeName || '',
        issueTypeIconUrl: issue.issueTypeIconUrl || ''
    } : null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4b8f37979127d2f5$var$transformPortfolioParentIssue = (value)=>value && value.data ? {
        summary: value.data.summary,
        key: value.data.key,
        url: $4b8f37979127d2f5$var$createRelativeIssueUrl(value.data.key),
        issueTypeName: value.data.issueTypeName || '',
        issueTypeIconUrl: value.data.issueTypeIconUrl || ''
    } : null;
const $4b8f37979127d2f5$export$77f9f02e63a0906f = (0, $ahm5r.createSelector)($4b8f37979127d2f5$var$portfolioParentFieldSelector, (portfolioParentIssue)=>$4b8f37979127d2f5$var$transformPortfolioParentIssue(portfolioParentIssue && portfolioParentIssue.value));
const $4b8f37979127d2f5$var$subtaskIssueParentSelector = (0, $ahm5r.createSelector)($4b8f37979127d2f5$var$subtaskIssueFieldSelector, (subtaskIssue)=>$4b8f37979127d2f5$var$transformSubtaskParentIssue(subtaskIssue && subtaskIssue.value));
const $4b8f37979127d2f5$var$parentIssueSelector = (0, $ahm5r.createSelector)((0, $6az7p.parentIssueEntitySelector), (parentIssue)=>$4b8f37979127d2f5$var$transformParentIssue(parentIssue));
const $4b8f37979127d2f5$export$dfeb83ef40558422 = (0, $ahm5r.createSelector)($4b8f37979127d2f5$var$parentIssueSelector, $4b8f37979127d2f5$var$subtaskIssueParentSelector, $4b8f37979127d2f5$export$77f9f02e63a0906f, (parentIssue, subtaskIssue, portfolioParentIssue)=>parentIssue || subtaskIssue || portfolioParentIssue);
const $4b8f37979127d2f5$export$1e6d1c8ba22c2162 = (0, $ahm5r.createSelector)($4b8f37979127d2f5$var$parentIssueSelector, (parentIssue)=>[
        parentIssue
    ].filter(Boolean));

});



parcelRegister("aRxHj", function(module, exports) {

$parcel$export(module.exports, "supportedChildIssueTypesEntitiesSelector", () => $6d296485956e827c$export$1e8043fccfcba3b9);
$parcel$export(module.exports, "supportsChildCreationSelector", () => $6d296485956e827c$export$1af32b549149f3d9);
$parcel$export(module.exports, "parentLevelIssueTypeIdsSelector", () => $6d296485956e827c$export$be50776e2ae27cf6);
$parcel$export(module.exports, "parentLevelIssueTypeNamesSelector", () => $6d296485956e827c$export$57b3549670d3627b);
$parcel$export(module.exports, "sameLevelIssueTypesIdsSelector", () => $6d296485956e827c$export$a81bfe971074142b);
$parcel$export(module.exports, "hierarchyLevelSelector", () => $6d296485956e827c$export$4f7eb1d272a8015);
$parcel$export(module.exports, "isIssueBaseLevel", () => $6d296485956e827c$export$d9c73da87a448c4);
$parcel$export(module.exports, "canLinkToParentSelector", () => $6d296485956e827c$export$5530450eb840ecb2);

var $ahm5r = parcelRequire("ahm5r");

var $eBWnc = parcelRequire("eBWnc");

var $814y1 = parcelRequire("814y1");

var $6t0ps = parcelRequire("6t0ps");

var $6az7p = parcelRequire("6az7p");

var $GhTyR = parcelRequire("GhTyR");

var $9B5nT = parcelRequire("9B5nT");
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6d296485956e827c$var$childLevelValueSelector = (0, $6t0ps.fieldPersistedValueSelector)((0, $814y1.HIERARCHY_LEVEL_BELOW)) || null;
const $6d296485956e827c$var$isChildLevelSubtaskLevelSelector = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$childLevelValueSelector, (childLevelFieldValue)=>{
    if (!childLevelFieldValue) return false;
    return (0, $eBWnc.isSubtaskHierarchyLevel)(childLevelFieldValue.level);
});
const $6d296485956e827c$export$7a45e255c239753 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$childLevelValueSelector, (childLevelValue)=>childLevelValue && childLevelValue.issueTypes || []);
const $6d296485956e827c$export$1e8043fccfcba3b9 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), $6d296485956e827c$export$7a45e255c239753, (entities, supportedIssueTypes)=>{
    const allIssueTypes = entities.issueTypes;
    const supportedIssueTypeIds = supportedIssueTypes.map((issueType)=>issueType.id);
    return allIssueTypes.filter(// @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
    (issueType)=>supportedIssueTypeIds.indexOf(issueType.id) !== -1);
});
const $6d296485956e827c$export$1af32b549149f3d9 = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), $6d296485956e827c$export$7a45e255c239753, $6d296485956e827c$var$isChildLevelSubtaskLevelSelector, (0, $6az7p.isSimplifiedProjectSelector), (permissions, supportedChildIssueTypes, isChildLevelSubtask, isSimplifiedProject)=>permissions.canCreateChildren && !!supportedChildIssueTypes.length && (isSimplifiedProject ? true : !isChildLevelSubtask));
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6d296485956e827c$var$parentLevelValueSelector = (0, $6t0ps.fieldPersistedValueSelector)((0, $814y1.HIERARCHY_LEVEL_ABOVE)) || null;
const $6d296485956e827c$export$55a6507420d37093 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && (parentLevelValue.name || null));
const $6d296485956e827c$export$be50776e2ae27cf6 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypeIds.map(String) || []);
const $6d296485956e827c$export$57b3549670d3627b = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$parentLevelValueSelector, (parentLevelValue)=>parentLevelValue && parentLevelValue.issueTypes.map((type)=>type.name).filter((name)=>name) || []);
const $6d296485956e827c$export$121e4a84c99db916 = (0, $ahm5r.createSelector)($6d296485956e827c$export$be50776e2ae27cf6, (parentLevelValue)=>parentLevelValue.length > 0);
// @ts-expect-error - TS2322 - Type '(arg1: Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>) => any' is not assignable to type 'OutputSelector<Readonly<{ agile: Agile; context: ContextState; entities: Readonly<{ applicationRoles?: ApplicationRole[] | undefined; cardCover: CardCover; childrenIssues: ChildrenIssuesState; ... 29 more ...; myPreferences?: Partial<...> | undefined; }>; ... 5 more ...; validators: Validators; }>, undefined, IssueT...'.
const $6d296485956e827c$var$sameLevelValueSelector = (0, $6t0ps.fieldPersistedValueSelector)((0, $814y1.HIERARCHY_LEVEL_SAME_LEVEL)) || null;
const $6d296485956e827c$export$26996c7f0f08c0d8 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$sameLevelValueSelector, (sameLevelFieldValue)=>{
    if (!sameLevelFieldValue) return false;
    return (0, $eBWnc.isSubtaskHierarchyLevel)(sameLevelFieldValue.level);
});
const $6d296485956e827c$export$a81bfe971074142b = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? sameLevelFieldValue.issueTypeIds.map(String) : []);
const $6d296485956e827c$export$4f7eb1d272a8015 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$6d296485956e827c$var$sameLevelValueSelector, (sameLevelFieldValue)=>sameLevelFieldValue ? (0, $eBWnc.toHierarchyLevel)(sameLevelFieldValue.level) : null);
const $6d296485956e827c$export$d9c73da87a448c4 = (0, $ahm5r.createSelector)($6d296485956e827c$export$4f7eb1d272a8015, (level)=>{
    if (level == null) // Some product types (JSM, Core, ...) do not support hierarchies at all and will not return this field.
    // For these, all issues are considered to be "Base" level.
    return true;
    return (0, $eBWnc.isBaseHierarchyLevel)(level);
});
const $6d296485956e827c$export$5530450eb840ecb2 = (0, $ahm5r.createSelector)($6d296485956e827c$export$55a6507420d37093, (0, $9B5nT.canEditIssuesSelector), $6d296485956e827c$export$121e4a84c99db916, (parentLevelName, shouldShowAddParent, hasParentIssueTypeId)=>Boolean(parentLevelName) && shouldShowAddParent && hasParentIssueTypeId);

});
parcelRegister("9B5nT", function(module, exports) {

$parcel$export(module.exports, "canEditIssuesSelector", () => $375191aa45dd52ba$export$cdd6892c8add3e54);
$parcel$export(module.exports, "canLinkIssuesSelector", () => $375191aa45dd52ba$export$50487d0d29271836);

var $ahm5r = parcelRequire("ahm5r");

var $GhTyR = parcelRequire("GhTyR");
const $375191aa45dd52ba$export$a7a483ca0afc4ab3 = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canCloneIssue);
const $375191aa45dd52ba$export$c1f4ef01259b4eb = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canDeleteIssue);
const $375191aa45dd52ba$export$2f9dd165cbf0c5ea = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canMoveIssue);
const $375191aa45dd52ba$export$cdd6892c8add3e54 = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canEditIssues);
const $375191aa45dd52ba$export$f48030c6644c0c4d = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canAdministerJira || permissions.canAdministerProject);
const $375191aa45dd52ba$export$4e8dac873f71d13e = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canAssignIssues);
const $375191aa45dd52ba$export$50487d0d29271836 = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canLinkIssues);

});


parcelRegister("d54uD", function(module, exports) {

$parcel$export(module.exports, "ecosystemCustomFieldIdsSelector", () => $abcae165672bdee4$export$c16e6010c2ccc7b2);

var $ahm5r = parcelRequire("ahm5r");

var $32zMs = parcelRequire("32zMs");

var $8oOr4 = parcelRequire("8oOr4");

var $6t0ps = parcelRequire("6t0ps");
const $abcae165672bdee4$export$1caf4359a6680b64 = (0, $ahm5r.createSelector)((0, $6t0ps.fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
        const type = (0, $32zMs.getFieldType)(fields[id]);
        return type && (0, $8oOr4.customFieldsToDisplay)().includes(type);
    }));
const $abcae165672bdee4$export$c16e6010c2ccc7b2 = (0, $ahm5r.createSelector)((0, $6t0ps.fieldsSelector), (fields)=>Object.keys(fields).filter((id)=>{
        const type = (0, $32zMs.getFieldType)(fields[id]);
        return type && (0, $8oOr4.ecosystemCustomFields).includes(type);
    }));

});

parcelRegister("4DuXn", function(module, exports) {

$parcel$export(module.exports, "entitiesCommentsSelector", () => $0a75d4a30ad8fb98$export$2bcb958351592bb9);
$parcel$export(module.exports, "totalCommentsSelector", () => $0a75d4a30ad8fb98$export$3873a5701cda7746);
$parcel$export(module.exports, "commentsPageInfoSelector", () => $0a75d4a30ad8fb98$export$bf7222a172daf33c);
$parcel$export(module.exports, "isLoadingMoreCommentsSelector", () => $0a75d4a30ad8fb98$export$5d4ebbdab84a3a1);
$parcel$export(module.exports, "hasScrolledPermalinkCommentSelector", () => $0a75d4a30ad8fb98$export$3190c124f9d4af8a);
$parcel$export(module.exports, "loadingMoreChildCommentsSelector", () => $0a75d4a30ad8fb98$export$59d9db30c7503d0f);
$parcel$export(module.exports, "loadingStageSelector", () => $0a75d4a30ad8fb98$export$18bc980d36bf93d);
$parcel$export(module.exports, "commentAuthorSelector", () => $0a75d4a30ad8fb98$export$6f6ac03c75ab3545);
$parcel$export(module.exports, "commentUpdateAuthorSelector", () => $0a75d4a30ad8fb98$export$7190d6fab16715b8);
$parcel$export(module.exports, "commentEditingBodySelector", () => $0a75d4a30ad8fb98$export$3e2634438f2a9b1a);
$parcel$export(module.exports, "commentEditingVisibilitySelector", () => $0a75d4a30ad8fb98$export$3c2f8c0a34054ef7);
$parcel$export(module.exports, "commentEditingOrViewBodyAdfSelector", () => $0a75d4a30ad8fb98$export$b0e0bc0c48cf00e6);
$parcel$export(module.exports, "commentOutsiderCommentSelector", () => $0a75d4a30ad8fb98$export$e7022c391905c53f);
$parcel$export(module.exports, "commentBodyHtmlSelector", () => $0a75d4a30ad8fb98$export$b9c6e85825c49cba);
$parcel$export(module.exports, "commentIsDeletedSelector", () => $0a75d4a30ad8fb98$export$e6360edf7c25f03d);
$parcel$export(module.exports, "commentRepliesSelector", () => $0a75d4a30ad8fb98$export$9fdd1ba68d7464f1);
$parcel$export(module.exports, "commentRepliesWithCollapseStateSelector", () => $0a75d4a30ad8fb98$export$5be063a4dca8530e);
$parcel$export(module.exports, "commentCollapseInfoSelector", () => $0a75d4a30ad8fb98$export$51285b44713b3fd0);
$parcel$export(module.exports, "childCommentsPageInfoSelector", () => $0a75d4a30ad8fb98$export$f8de4e824ff1662d);
$parcel$export(module.exports, "commentCreatedDateSelector", () => $0a75d4a30ad8fb98$export$b580f3d971b4e6fb);
$parcel$export(module.exports, "commentUpdatedDateSelector", () => $0a75d4a30ad8fb98$export$8b9935e49715b2d6);
$parcel$export(module.exports, "commentEditedSelector", () => $0a75d4a30ad8fb98$export$eff4fd551b2f55a1);
$parcel$export(module.exports, "pendingCommentSelector", () => $0a75d4a30ad8fb98$export$d63578bef1057cae);
$parcel$export(module.exports, "commentIsOptimisticSelector", () => $0a75d4a30ad8fb98$export$be047268481f07d8);
$parcel$export(module.exports, "commentSaveFailedSelector", () => $0a75d4a30ad8fb98$export$72075ae8ef4d6f6a);
$parcel$export(module.exports, "commentHasDeleteModalSelector", () => $0a75d4a30ad8fb98$export$c756ab72f25508bb);
$parcel$export(module.exports, "commentVisibilitySelector", () => $0a75d4a30ad8fb98$export$2cf9d22f626e5db0);
$parcel$export(module.exports, "commentEditingOrViewVisibilitySelector", () => $0a75d4a30ad8fb98$export$82fbf902093fe491);
$parcel$export(module.exports, "commentEditingEventOccurredAtSelector", () => $0a75d4a30ad8fb98$export$d820e1c3ac105e35);
$parcel$export(module.exports, "commentEventOccurredAtSelector", () => $0a75d4a30ad8fb98$export$9c8937d1bd8cf4a);
$parcel$export(module.exports, "commentJsdIncidentActivityViewHiddenSelector", () => $0a75d4a30ad8fb98$export$8c7be677b9a2cbf3);
$parcel$export(module.exports, "commentEditSessionContainsAttachmentsUsageSelector", () => $0a75d4a30ad8fb98$export$2a2670a8fb40391d);
$parcel$export(module.exports, "isInternalCommentSelector", () => $0a75d4a30ad8fb98$export$b99aa78c1374f9fe);
$parcel$export(module.exports, "isEditingInternalCommentSelector", () => $0a75d4a30ad8fb98$export$54205c8c886a2b43);
$parcel$export(module.exports, "canAddCommentsSelector", () => $0a75d4a30ad8fb98$export$a34c155854eb296b);
$parcel$export(module.exports, "pinnedCommentSelector", () => $0a75d4a30ad8fb98$export$9d589176711450fe);
$parcel$export(module.exports, "isThirdPartySyncOnCommentSelector", () => $0a75d4a30ad8fb98$export$e08d48d56b4a4dbc);
$parcel$export(module.exports, "isParentThirdPartySyncActiveCommentSelector", () => $0a75d4a30ad8fb98$export$e84c2138b6ab8db5);
$parcel$export(module.exports, "thirdPartyLinkCommentSelector", () => $0a75d4a30ad8fb98$export$878e2212b787ebd9);
$parcel$export(module.exports, "thirdPartyCommentSourceSelector", () => $0a75d4a30ad8fb98$export$b6b0feeacaab8c9f);
$parcel$export(module.exports, "pinnedCommentIdsSelector", () => $0a75d4a30ad8fb98$export$18c16eebbd24dabc);
$parcel$export(module.exports, "pinnedCommentBodyAdfSelector", () => $0a75d4a30ad8fb98$export$6c9215497123d8ba);
$parcel$export(module.exports, "canDeleteCommentSelector", () => $0a75d4a30ad8fb98$export$8cc876bb72dc09b7);
$parcel$export(module.exports, "canEditCommentSelector", () => $0a75d4a30ad8fb98$export$eb110f3a00a8432);
$parcel$export(module.exports, "visibleCommentIdsSelector", () => $0a75d4a30ad8fb98$export$3b3d01d442cb684a);
$parcel$export(module.exports, "isThreadedCommentsEnabledSelector", () => $0a75d4a30ad8fb98$export$f81b9f2c3f00b89b);
$parcel$export(module.exports, "sortedVisibleCommentIdsSelector", () => $0a75d4a30ad8fb98$export$81c523e14f04df2d);
$parcel$export(module.exports, "getPersistedLatestCommentTimeSelector", () => $0a75d4a30ad8fb98$export$219697701c39ce2b);
$parcel$export(module.exports, "getCommentsViewedEventTriggeredSelector", () => $0a75d4a30ad8fb98$export$434434d0e137800b);
$parcel$export(module.exports, "getUnreadCommentCountSelector", () => $0a75d4a30ad8fb98$export$567463de4ddebb27);
$parcel$export(module.exports, "getTopMostUnreadCommentIdSelector", () => $0a75d4a30ad8fb98$export$1332aaf4376530cf);
$parcel$export(module.exports, "getCommentScrollStatusForRealTimeUpdates", () => $0a75d4a30ad8fb98$export$f852f38f61c8471);
$parcel$export(module.exports, "isEditingCommentSelector", () => $0a75d4a30ad8fb98$export$6eba3f548a7f384e);
$parcel$export(module.exports, "commentSessionIdSelector", () => $0a75d4a30ad8fb98$export$239be48dfe5d80ba);
$parcel$export(module.exports, "getEditingCommentIdsSelector", () => $0a75d4a30ad8fb98$export$3a00787e516c672c);
$parcel$export(module.exports, "commentIdsSelector", () => $0a75d4a30ad8fb98$export$4c04cd370caea884);
$parcel$export(module.exports, "isEditingAnyCommentSelector", () => $0a75d4a30ad8fb98$export$2e24e984817b4c7b);
$parcel$export(module.exports, "isAddCommentEditorExpandedSelector", () => $0a75d4a30ad8fb98$export$5373a6bfd674797c);
$parcel$export(module.exports, "isAddCommentEditorExpandedFromKeyboardSelector", () => $0a75d4a30ad8fb98$export$ca625348abd5b1a1);
$parcel$export(module.exports, "addCommentEditorForceFocusSelector", () => $0a75d4a30ad8fb98$export$37aee7d1ec9d42d3);
$parcel$export(module.exports, "isCommentEditorOpenSelector", () => $0a75d4a30ad8fb98$export$6df0ef2ac2b35c13);
$parcel$export(module.exports, "isCommentAttachmentInProgressSelector", () => $0a75d4a30ad8fb98$export$f140c5c89826efc6);
$parcel$export(module.exports, "isCommentVisibilityRestrictionSupportedSelector", () => $0a75d4a30ad8fb98$export$2ce513eb85289331);
$parcel$export(module.exports, "isReplyingToCommentSelector", () => $0a75d4a30ad8fb98$export$ab64c511f5921cdf);
$parcel$export(module.exports, "isCommentReplyEditorOpenSelector", () => $0a75d4a30ad8fb98$export$d89d07d36d57d778);
$parcel$export(module.exports, "replyContentSelector", () => $0a75d4a30ad8fb98$export$bb44f1aa6771eeb6);
$parcel$export(module.exports, "replyingToAuthorSelector", () => $0a75d4a30ad8fb98$export$6fe69cb268473af1);
$parcel$export(module.exports, "commentParentIdSelector", () => $0a75d4a30ad8fb98$export$9f25935861e23f9b);
$parcel$export(module.exports, "hasAtLeastTwoPublicCommentsSelector", () => $0a75d4a30ad8fb98$export$63be80cb66fe1f22);
$parcel$export(module.exports, "isPinnedCommentsLimitReachedSelector", () => $0a75d4a30ad8fb98$export$28e3f84750bf2cc6);
$parcel$export(module.exports, "canPinCommentsSelector", () => $0a75d4a30ad8fb98$export$aa744d84abf91f0e);

var $ahm5r = parcelRequire("ahm5r");

var $40zJW = parcelRequire("40zJW");

var $7T5bQ = parcelRequire("7T5bQ");

var $bu2ug = parcelRequire("bu2ug");

var $ln6Iy = parcelRequire("ln6Iy");

var $hbF3h = parcelRequire("hbF3h");


var $l5RKy = parcelRequire("l5RKy");

var $7jTnu = parcelRequire("7jTnu");

var $5EgB1 = parcelRequire("5EgB1");

var $6az7p = parcelRequire("6az7p");

var $GhTyR = parcelRequire("GhTyR");

var $1DspS = parcelRequire("1DspS");

const $0a75d4a30ad8fb98$export$9832028921909a8f = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.pendingDeletedIds);
const $0a75d4a30ad8fb98$export$2bcb958351592bb9 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.comments);
const $0a75d4a30ad8fb98$export$3873a5701cda7746 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.totalComments);
const $0a75d4a30ad8fb98$export$bf7222a172daf33c = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.commentsPageInfo);
const $0a75d4a30ad8fb98$export$5d4ebbdab84a3a1 = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.isLoadingMoreComments);
const $0a75d4a30ad8fb98$export$3190c124f9d4af8a = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.hasScrolledPermalinkComment);
const $0a75d4a30ad8fb98$export$cb15fb58f04e4339 = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.pendingSavedValues);
const $0a75d4a30ad8fb98$var$deleteModalCommentIdSelector = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.deleteModalCommentId);
const $0a75d4a30ad8fb98$export$59d9db30c7503d0f = (commentId)=>(0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments?.childButtonLoadingState?.[commentId] ?? null);
const $0a75d4a30ad8fb98$export$18bc980d36bf93d = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.loadingStage);
const $0a75d4a30ad8fb98$export$f82d111da9150583 = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$2bcb958351592bb9, $0a75d4a30ad8fb98$export$cb15fb58f04e4339, (comments, optimisticComments)=>{
    const allComments = {
        ...comments
    };
    for(const key in optimisticComments)if (Object.prototype.hasOwnProperty.call(comments, key)) allComments[key] = {
        ...allComments[key],
        ...optimisticComments[key]
    };
    else allComments[key] = optimisticComments[key];
    return allComments;
});
const $0a75d4a30ad8fb98$var$commentSelector = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$f82d111da9150583, (comments)=>comments[commentId]);
const $0a75d4a30ad8fb98$var$persistedCommentSelector = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$2bcb958351592bb9, (comments)=>comments[commentId]);
// If the user is anonymous, then they are not considered comment author
const $0a75d4a30ad8fb98$var$isUserCommentAuthorSelector = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$commentSelector(commentId), (0, $5EgB1.accountIdloggedInUserSelector), (comment, loggedInUserId)=>loggedInUserId !== null && loggedInUserId === (comment && comment.authorId));
const $0a75d4a30ad8fb98$var$authorSelector = (commentId, authorIdPropertyName)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$commentSelector(commentId), (0, $6az7p.getUserByIdSelector), (comment, userByIdSelector)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'OptimisticComment | PersistedComment'.
        comment && comment[authorIdPropertyName] ? userByIdSelector(comment[authorIdPropertyName]) : null);
const $0a75d4a30ad8fb98$var$uiAllCommentsSelector = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui && ui.comments || null);
const $0a75d4a30ad8fb98$var$uiAllCommentEditorsSelector = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$uiAllCommentsSelector, (uiComments)=>uiComments && uiComments.commentEditors || null);
const $0a75d4a30ad8fb98$var$uiCommentEditorSelector = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$uiAllCommentEditorsSelector, (uiCommentEditors)=>uiCommentEditors && uiCommentEditors[commentId] || null);
const $0a75d4a30ad8fb98$export$6f6ac03c75ab3545 = (commentId)=>$0a75d4a30ad8fb98$var$authorSelector(commentId, 'authorId');
const $0a75d4a30ad8fb98$export$7190d6fab16715b8 = (commentId)=>$0a75d4a30ad8fb98$var$authorSelector(commentId, 'updateAuthorId');
const $0a75d4a30ad8fb98$export$3e2634438f2a9b1a = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.editingValue || null);
const $0a75d4a30ad8fb98$export$3c2f8c0a34054ef7 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.visibility || null);
const $0a75d4a30ad8fb98$export$b0e0bc0c48cf00e6 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$3e2634438f2a9b1a(commentId), $0a75d4a30ad8fb98$var$commentSelector(commentId), (editingComment, comment)=>editingComment || comment && comment.bodyAdf || null);
const $0a75d4a30ad8fb98$export$e7022c391905c53f = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$commentSelector(commentId), (comment)=>comment ? comment.jsdAuthorCanSeeRequest : null);
const $0a75d4a30ad8fb98$export$b9c6e85825c49cba = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$commentSelector(commentId), (comment)=>comment ? comment.bodyHtml : null);
const $0a75d4a30ad8fb98$export$e6360edf7c25f03d = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$commentSelector(commentId), (comment)=>comment ? comment.isDeleted : null);
const $0a75d4a30ad8fb98$export$9fdd1ba68d7464f1 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$persistedCommentSelector(commentId), $0a75d4a30ad8fb98$export$f82d111da9150583, $0a75d4a30ad8fb98$export$9832028921909a8f, (comment, allComments, deletedIds)=>{
        if (comment?.childCommentIds && comment.childCommentIds.size > 0) {
            const nonDeletedReplies = Array.from(comment.childCommentIds).filter((id)=>!deletedIds.includes(id) && allComments[id]);
            if (nonDeletedReplies.length > 0) return nonDeletedReplies.map($0a75d4a30ad8fb98$var$mapIdToCommentSortInfo(allComments)).sort($0a75d4a30ad8fb98$var$compareComments).map((sortedComment)=>sortedComment.id);
        }
        return null;
    });
const $0a75d4a30ad8fb98$export$5be063a4dca8530e = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$9fdd1ba68d7464f1(commentId), $0a75d4a30ad8fb98$export$51285b44713b3fd0(commentId), (replies, collapsedInfo)=>{
        if (!replies) return null;
        if (!collapsedInfo) return replies;
        const { collapseActionType: collapseActionType, currentTopMarker: currentTopMarker, currentBottomMarker: currentBottomMarker, originalTopMarker: originalTopMarker, originalBottomMarker: originalBottomMarker } = collapsedInfo;
        const getSliceIndices = ()=>{
            switch(collapseActionType){
                case (0, $l5RKy.CollapseActionType).SHOW_MORE_OLDER:
                    return {
                        start: 0,
                        end: replies.indexOf(currentBottomMarker) + 1
                    };
                case (0, $l5RKy.CollapseActionType).SHOW_LESS_OLDER:
                    return {
                        start: replies.indexOf(originalTopMarker),
                        end: replies.indexOf(currentBottomMarker) + 1
                    };
                case (0, $l5RKy.CollapseActionType).SHOW_MORE_NEWER:
                    return {
                        start: replies.indexOf(currentTopMarker),
                        end: replies.length
                    };
                case (0, $l5RKy.CollapseActionType).SHOW_LESS_NEWER:
                    return {
                        start: replies.indexOf(currentTopMarker),
                        end: replies.indexOf(originalBottomMarker) + 1
                    };
                default:
                    return null;
            }
        };
        const indices = getSliceIndices();
        return indices ? replies.slice(indices.start, indices.end) : replies;
    });
const $0a75d4a30ad8fb98$export$51285b44713b3fd0 = (commentId)=>(0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.collapsedInfo[commentId]);
const $0a75d4a30ad8fb98$export$f8de4e824ff1662d = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$persistedCommentSelector(commentId), (comment)=>comment?.childCommentsPageInfo ?? {
            hasNextPage: false,
            hasPreviousPage: false,
            startCursor: null,
            endCursor: null
        });
const $0a75d4a30ad8fb98$export$b580f3d971b4e6fb = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$commentSelector(commentId), (comment)=>comment ? comment.createdDate : null);
const $0a75d4a30ad8fb98$export$8b9935e49715b2d6 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$commentSelector(commentId), (comment)=>comment ? comment.updatedDate : null);
const $0a75d4a30ad8fb98$export$eff4fd551b2f55a1 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$commentSelector(commentId), (comment)=>comment ? comment.edited : null);
const $0a75d4a30ad8fb98$export$d63578bef1057cae = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$cb15fb58f04e4339, (pendingComments)=>pendingComments[commentId]);
const $0a75d4a30ad8fb98$export$be047268481f07d8 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$d63578bef1057cae(commentId), (pendingComment)=>!!pendingComment);
const $0a75d4a30ad8fb98$export$72075ae8ef4d6f6a = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$d63578bef1057cae(commentId), (pendingComment)=>!!(pendingComment && pendingComment.hasSaveFailed));
const $0a75d4a30ad8fb98$export$c756ab72f25508bb = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$deleteModalCommentIdSelector, (deleteModalCommentId)=>deleteModalCommentId === commentId);
const $0a75d4a30ad8fb98$export$2cf9d22f626e5db0 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$commentSelector(commentId), (comment)=>{
        return comment ? comment.visibility : (0, $l5RKy.COMMENT_VISIBILITY_PUBLIC);
    });
const $0a75d4a30ad8fb98$var$commentIsInternalSelector = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$commentSelector(commentId), (comment)=>comment ? comment.isInternal : false);
const $0a75d4a30ad8fb98$export$82fbf902093fe491 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$3c2f8c0a34054ef7(commentId), $0a75d4a30ad8fb98$export$2cf9d22f626e5db0(commentId), (editingVisibility, visibility)=>editingVisibility || visibility);
const $0a75d4a30ad8fb98$export$d820e1c3ac105e35 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$uiCommentEditorSelector(commentId), (comment)=>comment && comment.eventOccurredAt || null);
const $0a75d4a30ad8fb98$export$9c8937d1bd8cf4a = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$commentSelector(commentId), (comment)=>comment && comment.eventOccurredAt ? comment.eventOccurredAt : null);
const $0a75d4a30ad8fb98$export$9b5c22d8443e21d6 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$d820e1c3ac105e35(commentId), $0a75d4a30ad8fb98$export$9c8937d1bd8cf4a(commentId), (editingEventOccurredAt, eventOccurredAt)=>editingEventOccurredAt || eventOccurredAt);
const $0a75d4a30ad8fb98$export$8c7be677b9a2cbf3 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$commentSelector(commentId), (comment)=>comment && typeof comment.jsdIncidentActivityViewHidden === 'boolean' ? comment.jsdIncidentActivityViewHidden : null);
const $0a75d4a30ad8fb98$export$2a2670a8fb40391d = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$uiCommentEditorSelector(commentId), (comment)=>!!comment?.editSessionContainsAttachmentsUsage);
const $0a75d4a30ad8fb98$export$b99aa78c1374f9fe = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('jcs_project_type_m3'), (commentId)=>(0, $ahm5r.createSelector)((0, $5EgB1.isServiceDeskSelector), (0, $6az7p.isCustomerServiceSelector), $0a75d4a30ad8fb98$var$commentIsInternalSelector(commentId), (isServiceDeskComment, isCustomerServiceComment, isInternal)=>(isServiceDeskComment || isCustomerServiceComment) && isInternal), (commentId)=>(0, $ahm5r.createSelector)((0, $5EgB1.isServiceDeskSelector), $0a75d4a30ad8fb98$var$commentIsInternalSelector(commentId), (isServiceDeskComment, isInternal)=>isServiceDeskComment && isInternal));
const $0a75d4a30ad8fb98$export$54205c8c886a2b43 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$uiCommentEditorSelector(commentId), (commentEditor)=>commentEditor?.isInternal ?? true);
const $0a75d4a30ad8fb98$export$a34c155854eb296b = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canAddComments);
const $0a75d4a30ad8fb98$export$9d589176711450fe = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$persistedCommentSelector(commentId), (comment)=>comment ? comment?.pinned : null);
const $0a75d4a30ad8fb98$export$e08d48d56b4a4dbc = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$persistedCommentSelector(commentId), (comment)=>!!comment?.isThirdPartySyncOn);
const $0a75d4a30ad8fb98$export$e84c2138b6ab8db5 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$8f158a3cc48edde6(commentId), (parentComment)=>!!parentComment?.isThirdPartySyncOn && !!parentComment?.thirdPartyCommentSource);
const $0a75d4a30ad8fb98$export$878e2212b787ebd9 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$persistedCommentSelector(commentId), (comment)=>comment ? comment?.thirdPartyLink : null);
const $0a75d4a30ad8fb98$export$b6b0feeacaab8c9f = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$persistedCommentSelector(commentId), (comment)=>comment ? comment?.thirdPartyCommentSource : null);
const $0a75d4a30ad8fb98$export$18c16eebbd24dabc = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$2bcb958351592bb9, (comments)=>{
    return Object.keys(comments).filter((id)=>comments[id]?.pinned);
});
const $0a75d4a30ad8fb98$export$6c9215497123d8ba = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$persistedCommentSelector(commentId), (comment)=>comment ? comment.bodyAdf : null);
const $0a75d4a30ad8fb98$export$8cc876bb72dc09b7 = (commentId)=>(0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), $0a75d4a30ad8fb98$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canDeleteAllComments || permissions.canDeleteOwnComments && isUserCommentAuthor);
const $0a75d4a30ad8fb98$export$eb110f3a00a8432 = (commentId)=>(0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), $0a75d4a30ad8fb98$var$isUserCommentAuthorSelector(commentId), (permissions, isUserCommentAuthor)=>permissions.canEditAllComments || permissions.canEditOwnComments && isUserCommentAuthor);
const $0a75d4a30ad8fb98$var$mapIdToCommentSortInfo = (comments)=>(id)=>{
        const comment = comments[id];
        return {
            id: id,
            createdDate: new Date(comment.createdDate),
            eventOccurredAt: comment.eventOccurredAt ? new Date(comment.eventOccurredAt) : null,
            size: comment?.childCommentIds?.size ?? 0
        };
    };
const $0a75d4a30ad8fb98$var$compareComments = (a, b)=>{
    if (a.eventOccurredAt && b.eventOccurredAt && (0, $7T5bQ.default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return (0, $7T5bQ.default)(a.createdDate, b.createdDate);
    const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
    const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
    return (0, $7T5bQ.default)(dateForA, dateForB);
};
const $0a75d4a30ad8fb98$export$3b3d01d442cb684a = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$f82d111da9150583, $0a75d4a30ad8fb98$export$9832028921909a8f, (comments, deletedIds)=>{
    // filter out any comments currently pending deletion
    const nonDeletedCommentIds = Object.keys(comments).filter((id)=>!deletedIds.includes(id));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map($0a75d4a30ad8fb98$var$mapIdToCommentSortInfo(comments)).sort($0a75d4a30ad8fb98$var$compareComments).map((comment)=>comment.id);
    return sortedIds;
});
const $0a75d4a30ad8fb98$var$compareCommentsInclSortOrderType = (sortOrderType)=>(a, b)=>{
        if (a.eventOccurredAt && b.eventOccurredAt && (0, $7T5bQ.default)(a.eventOccurredAt, b.eventOccurredAt) === 0) return sortOrderType === (0, $d5c55f920daa1538$export$e86669f498228fff) ? (0, $7T5bQ.default)(a.createdDate, b.createdDate) : (0, $bu2ug.default)(a.createdDate, b.createdDate);
        const dateForA = a.eventOccurredAt ? a.eventOccurredAt : a.createdDate;
        const dateForB = b.eventOccurredAt ? b.eventOccurredAt : b.createdDate;
        return sortOrderType === (0, $d5c55f920daa1538$export$e86669f498228fff) ? (0, $7T5bQ.default)(dateForA, dateForB) : (0, $bu2ug.default)(dateForA, dateForB);
    };
const $0a75d4a30ad8fb98$export$f81b9f2c3f00b89b = (0, $ahm5r.createSelector)((0, $6az7p.projectTypeSelector), $0a75d4a30ad8fb98$export$f82d111da9150583, (projectType, allComments)=>(projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.CORE_PROJECT)) && allComments && Object.keys(allComments).length > 0);
const $0a75d4a30ad8fb98$export$81c523e14f04df2d = (0, $ahm5r.createSelector)((0, $1DspS.getSelectedActivitySortOrder), $0a75d4a30ad8fb98$export$f82d111da9150583, $0a75d4a30ad8fb98$export$9832028921909a8f, $0a75d4a30ad8fb98$export$f81b9f2c3f00b89b, (sortOrderType, comments, deletedIds, isThreadedCommentsEnabled)=>{
    // filter out any comments currently pending deletion and replies as well.
    //  Also filter out pinned comments which should not be visible in the comment feed.
    let nonDeletedCommentIds = [];
    if ((0, $7jTnu.fg)('work_item_create_from_comment_and_pin_comment_gate')) nonDeletedCommentIds = Object.keys(comments).filter((id)=>(deletedIds.includes(id) && comments[id]?.isDeleted && isThreadedCommentsEnabled || !deletedIds.includes(id)) && (isThreadedCommentsEnabled ? !comments[id].parentId : true)).filter((id)=>!comments[id]?.hideInCommentFeedSection);
    else nonDeletedCommentIds = Object.keys(comments).filter((id)=>(deletedIds.includes(id) && comments[id]?.isDeleted && isThreadedCommentsEnabled || !deletedIds.includes(id)) && (isThreadedCommentsEnabled ? !comments[id].parentId : true));
    // sort the remaining comment ids by their created date
    const sortedIds = nonDeletedCommentIds.map($0a75d4a30ad8fb98$var$mapIdToCommentSortInfo(comments)).sort($0a75d4a30ad8fb98$var$compareCommentsInclSortOrderType(sortOrderType)).map((comment)=>{
        // Both should be cleaned up together.
        return {
            id: comment.id,
            size: comment.size
        };
    });
    return sortedIds;
});
const $0a75d4a30ad8fb98$export$219697701c39ce2b = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.latestCommentViewInteractedTime);
const $0a75d4a30ad8fb98$export$434434d0e137800b = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.commentsViewedEventTriggered);
const $0a75d4a30ad8fb98$export$fc1a070fbadb4b5d = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.isRealTimeCommentUpdated);
const $0a75d4a30ad8fb98$export$c6165da2884619ed = (0, $ahm5r.createSelector)((0, $5EgB1.accountIdloggedInUserSelector), $0a75d4a30ad8fb98$export$219697701c39ce2b, $0a75d4a30ad8fb98$export$f82d111da9150583, $0a75d4a30ad8fb98$export$9832028921909a8f, (currentUserId, latestCommentTime, allComments, deletedIds)=>{
    if (!latestCommentTime) return [];
    return Object.keys(allComments).filter((commentId)=>{
        const { createdDate: createdDate, authorId: authorId } = allComments[commentId];
        // Exclude comments from current user and deleted comments in unread count
        if (currentUserId === authorId || deletedIds.includes(commentId) || allComments[commentId]?.isDeleted) return false;
        // Check if the comment is more recent than the latest comment time
        return new Date(createdDate) > new Date(latestCommentTime);
    });
});
const $0a75d4a30ad8fb98$export$567463de4ddebb27 = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$c6165da2884619ed, (unreadCommentIds)=>{
    return unreadCommentIds.length;
});
const $0a75d4a30ad8fb98$export$1332aaf4376530cf = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$f82d111da9150583, $0a75d4a30ad8fb98$export$81c523e14f04df2d, $0a75d4a30ad8fb98$export$c6165da2884619ed, (comments, visibleCommentIds, unreadCommentIds)=>{
    for (const comment of visibleCommentIds){
        const commentId = typeof comment === 'object' ? comment.id : comment;
        // Check if the parent comment itself is unread
        if (unreadCommentIds.includes(commentId)) return commentId;
        // Get child comment IDs for the current comment
        const childCommentIds = comments[commentId]?.childCommentIds;
        // If there are child comment IDs, check if any are unread
        if (childCommentIds instanceof Set) for (const childCommentId of childCommentIds){
            if (unreadCommentIds.includes(childCommentId)) return childCommentId;
        }
    }
    return null;
});
const $0a75d4a30ad8fb98$export$f852f38f61c8471 = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.commentScrollStatusForRealTimeUpdates);
const $0a75d4a30ad8fb98$export$6eba3f548a7f384e = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$uiCommentEditorSelector(commentId), (commentEditor)=>!!commentEditor && commentEditor.isEditing);
const $0a75d4a30ad8fb98$export$239be48dfe5d80ba = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$uiAllCommentsSelector, (uiComments)=>uiComments && uiComments.commentSessionId || null);
const $0a75d4a30ad8fb98$export$3a00787e516c672c = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$3b3d01d442cb684a, (state)=>state, (visibleCommentIds, state)=>visibleCommentIds.filter((commentId)=>$0a75d4a30ad8fb98$export$6eba3f548a7f384e(commentId)(state)));
const $0a75d4a30ad8fb98$export$4c04cd370caea884 = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$2bcb958351592bb9, (comments)=>comments ? Object.keys(comments).filter((key)=>typeof comments[key] === 'object') : []);
const $0a75d4a30ad8fb98$export$2e24e984817b4c7b = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$4c04cd370caea884, (state)=>state, (commentIds, state)=>commentIds.some((id)=>$0a75d4a30ad8fb98$export$6eba3f548a7f384e(id)(state)));
const $0a75d4a30ad8fb98$export$5373a6bfd674797c = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.addCommentEditorExpand || false);
const $0a75d4a30ad8fb98$export$ca625348abd5b1a1 = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.addCommentEditorExpandFromKeyboard || false);
const $0a75d4a30ad8fb98$export$37aee7d1ec9d42d3 = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.addCommentEditorForceFocus || 0);
const $0a75d4a30ad8fb98$export$6df0ef2ac2b35c13 = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$5373a6bfd674797c, $0a75d4a30ad8fb98$var$uiAllCommentEditorsSelector, (isAddCommentEditorExpanded, commentEditors)=>isAddCommentEditorExpanded || (commentEditors ? (0, (/*@__PURE__*/$parcel$interopDefault($40zJW)))(commentEditors).some((editor)=>editor.isEditing) : false));
const $0a75d4a30ad8fb98$export$f140c5c89826efc6 = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.isCommentAttachmentInProgress);
const $0a75d4a30ad8fb98$export$2ce513eb85289331 = (0, $ahm5r.createSelector)((0, $6az7p.isSimplifiedProjectSelector), (0, $6az7p.projectTypeSelector), (isSimplified, projectType)=>!isSimplified && (projectType === (0, $ln6Iy.CORE_PROJECT) || projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT) || projectType === (0, $ln6Iy.CUSTOMER_SERVICE_PROJECT) && (0, $7jTnu.fg)('jcs_project_type_m3')));
const $0a75d4a30ad8fb98$var$replyingToCommentIdSelector = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.replyingToCommentId);
const $0a75d4a30ad8fb98$export$ab64c511f5921cdf = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$replyingToCommentIdSelector, (replyingToCommentId)=>replyingToCommentId === commentId);
const $0a75d4a30ad8fb98$export$d89d07d36d57d778 = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$replyingToCommentIdSelector, (replyingToCommentId)=>!!replyingToCommentId);
const $0a75d4a30ad8fb98$export$bb44f1aa6771eeb6 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$3e2634438f2a9b1a(`${(0, $6311562061fda797$export$56251dcfec1ad08d)}-${commentId}`), (editingComment)=>editingComment || undefined);
const $0a75d4a30ad8fb98$var$replyingToAuthorIdSelector = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.replyingToAuthorId);
const $0a75d4a30ad8fb98$export$6fe69cb268473af1 = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$replyingToAuthorIdSelector, (0, $6az7p.getUserByIdSelector), (replyingToAuthorId, getUserById)=>getUserById(replyingToAuthorId));
const $0a75d4a30ad8fb98$export$9f25935861e23f9b = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$var$commentSelector(commentId), (comment)=>comment && comment.parentId);
const $0a75d4a30ad8fb98$export$8f158a3cc48edde6 = (commentId)=>(0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$f82d111da9150583, $0a75d4a30ad8fb98$export$9f25935861e23f9b(commentId), (comments, parentId)=>parentId ? comments[parentId] : undefined);
const $0a75d4a30ad8fb98$export$63be80cb66fe1f22 = (0, $ahm5r.createSelector)($0a75d4a30ad8fb98$export$f82d111da9150583, (comments)=>Object.values(comments).filter((comment)=>comment.isInternal === false).length >= 2);
const $0a75d4a30ad8fb98$export$28e3f84750bf2cc6 = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.comments.isPinnedCommentsLimitReached);
const $0a75d4a30ad8fb98$export$aa744d84abf91f0e = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), (permissions)=>permissions.canAddComments && permissions.canEditIssues);

});
// Activity sort order
const $d5c55f920daa1538$export$eda5fe8da1abb04c = 'NEWEST_FIRST';
const $d5c55f920daa1538$export$e86669f498228fff = 'OLDEST_FIRST';

parcelRegister("l5RKy", function(module, exports) {

$parcel$export(module.exports, "SAVE_COMMENT_LOADING", () => $559ed892a3f9b23a$export$ea56f55e95ac48c4);
$parcel$export(module.exports, "SAVE_CHILD_COMMENT_LOADING_PREFIX", () => $559ed892a3f9b23a$export$7feea57d9f7d329e);
$parcel$export(module.exports, "LOADING", () => $559ed892a3f9b23a$export$26d55645375ca9a);
$parcel$export(module.exports, "COMPLETE", () => $559ed892a3f9b23a$export$1660a2d7c2fff354);
$parcel$export(module.exports, "COMMENT_VISIBILITY_PUBLIC", () => $559ed892a3f9b23a$export$5dd24cf16d0bbf18);
$parcel$export(module.exports, "THIRD_PARTY_SOURCE_SLACK", () => $559ed892a3f9b23a$export$9b9d5d525cde759b);
$parcel$export(module.exports, "ActionButton", () => $559ed892a3f9b23a$export$cfc7921d29ef7b80);
$parcel$export(module.exports, "CollapseActionType", () => $559ed892a3f9b23a$export$7f6c512735b1e0ac);
$parcel$export(module.exports, "COMMENT_VISIBILITY_TYPE_PUBLIC", () => $208ed5c90e814614$export$a3863626f98a38c2);

const $559ed892a3f9b23a$export$34e5759f24cbaeac = (value)=>value;
const $559ed892a3f9b23a$export$ea56f55e95ac48c4 = 'SAVE_COMMENT_LOADING';
const $559ed892a3f9b23a$export$7feea57d9f7d329e = 'SAVE_CHILD_COMMENT_LOADING_';
const $559ed892a3f9b23a$export$26d55645375ca9a = 'LOADING';
const $559ed892a3f9b23a$export$1660a2d7c2fff354 = 'COMPLETE';
const $559ed892a3f9b23a$export$5dd24cf16d0bbf18 = {
    type: (0, $208ed5c90e814614$export$a3863626f98a38c2),
    value: ''
};
const $559ed892a3f9b23a$export$9b9d5d525cde759b = 'SLACK';
const $559ed892a3f9b23a$export$cfc7921d29ef7b80 = {
    PREVIOUS: 'PREVIOUS',
    NEXT: 'NEXT'
};
const $559ed892a3f9b23a$export$7f6c512735b1e0ac = {
    SHOW_MORE_NEWER: 'SHOW_MORE_NEWER',
    SHOW_LESS_NEWER: 'SHOW_LESS_NEWER',
    SHOW_MORE_OLDER: 'SHOW_MORE_OLDER',
    SHOW_LESS_OLDER: 'SHOW_LESS_OLDER',
    INITIAL: 'INITIAL'
};

});
const $208ed5c90e814614$export$537a061b2f9c8800 = 'group';
const $208ed5c90e814614$export$28a8bb936dce2def = 'role';
const $208ed5c90e814614$export$a3863626f98a38c2 = 'public';


parcelRegister("1DspS", function(module, exports) {

$parcel$export(module.exports, "getSelectedActivityItem", () => $3cb8570ad1f04aeb$export$49b8848afae8c381);
$parcel$export(module.exports, "getSelectedActivitySortOrder", () => $3cb8570ad1f04aeb$export$7091381d8f3bc5cc);
$parcel$export(module.exports, "getActivityFeedInViewPort", () => $3cb8570ad1f04aeb$export$50e1cbd5557ceae1);
$parcel$export(module.exports, "showDetailsInContextSelector", () => $3cb8570ad1f04aeb$export$70ad50ae2959f2ea);

var $ahm5r = parcelRequire("ahm5r");

var $6az7p = parcelRequire("6az7p");
const $3cb8570ad1f04aeb$var$getUiActivityFeed = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.activityFeed);
const $3cb8570ad1f04aeb$export$49b8848afae8c381 = (0, $ahm5r.createSelector)($3cb8570ad1f04aeb$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivityItem);
const $3cb8570ad1f04aeb$export$7091381d8f3bc5cc = (0, $ahm5r.createSelector)($3cb8570ad1f04aeb$var$getUiActivityFeed, (activityFeed)=>activityFeed.selectedActivitySortOrder);
const $3cb8570ad1f04aeb$export$50e1cbd5557ceae1 = (0, $ahm5r.createSelector)($3cb8570ad1f04aeb$var$getUiActivityFeed, (activityFeed)=>activityFeed.isActivityFeedInViewPort ?? true);
const $3cb8570ad1f04aeb$export$caebda0b6783fefb = (0, $ahm5r.createSelector)($3cb8570ad1f04aeb$var$getUiActivityFeed, (activityFeed)=>activityFeed?.selectedActivityFeedLayout ?? null);
const $3cb8570ad1f04aeb$export$70ad50ae2959f2ea = (0, $ahm5r.createSelector)($3cb8570ad1f04aeb$var$getUiActivityFeed, (activityFeed)=>activityFeed.showDetailsActivity);

});

const $6311562061fda797$export$c4134c813c47beb0 = 'NEW_OPTIMISTIC_COMMENT';
const $6311562061fda797$export$56251dcfec1ad08d = 'NEW_OPTIMISTIC_COMMENT_REPLY';


parcelRegister("gRQyv", function(module, exports) {

$parcel$export(module.exports, "isIssueLinksEnabledSelector", () => $2873248f5c677e12$export$a8cf8910b8314c1a);
$parcel$export(module.exports, "remoteIssuesSelector", () => $2873248f5c677e12$export$13978ee723866c4d);
$parcel$export(module.exports, "optimisticLinksDataSelector", () => $2873248f5c677e12$export$819781ef7e99d6c7);
$parcel$export(module.exports, "hasIssueLinksSelector", () => $2873248f5c677e12$export$3c65f67962ca81cc);
$parcel$export(module.exports, "hasCombinedIssueLinksSelector", () => $2873248f5c677e12$export$8b1b2dfb6701d22c);
$parcel$export(module.exports, "combinedLinkedIssueCountSelector", () => $2873248f5c677e12$export$7e10bfdc67ac9362);
$parcel$export(module.exports, "remoteLinkedIssueCountSelector", () => $2873248f5c677e12$export$240ac27cfdcb3e34);
$parcel$export(module.exports, "combinedLinksSelector", () => $2873248f5c677e12$export$a101eb6fc884a8a0);
$parcel$export(module.exports, "issueLinkSelector", () => $2873248f5c677e12$export$b82f4900195f5854);
$parcel$export(module.exports, "linkedIssueSelector", () => $2873248f5c677e12$export$f5f26ceb5c86ee0);
$parcel$export(module.exports, "quickAddClickedCountSelector", () => $2873248f5c677e12$export$d545d81c8e208408);
$parcel$export(module.exports, "isOpenedFromJsmSimilarIssuesSelector", () => $2873248f5c677e12$export$3bf48255064c85d5);
$parcel$export(module.exports, "quickAddClickedIssueSelector", () => $2873248f5c677e12$export$2c43c6abed5983de);
$parcel$export(module.exports, "shouldDisplayAddLinksSelector", () => $2873248f5c677e12$export$5757979a0baa9c47);
$parcel$export(module.exports, "triggeredViaHotKeySelector", () => $2873248f5c677e12$export$34364f7190cff8a8);
$parcel$export(module.exports, "shouldDisplayRelatedIssuePanelSelector", () => $2873248f5c677e12$export$eea0e617974abf06);
$parcel$export(module.exports, "canCreateLinkedIssueSelector", () => $2873248f5c677e12$export$99914e520087b170);
$parcel$export(module.exports, "refreshTimestampSelector", () => $2873248f5c677e12$export$652fb627bb2f46f3);
$parcel$export(module.exports, "addRelatedWorkItemTriggerSourceSelector", () => $2873248f5c677e12$export$cc6bc2a796dd3df5);

var $ahm5r = parcelRequire("ahm5r");

var $8dH3d = parcelRequire("8dH3d");

var $9pL9Y = parcelRequire("9pL9Y");

var $8z5Vk = parcelRequire("8z5Vk");

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");

var $hpZaA = parcelRequire("hpZaA");

var $6az7p = parcelRequire("6az7p");

var $8fG6P = parcelRequire("8fG6P");
/**
 * selectors for issue links
 *
 * issue links state looks like
 * issueLinks: {
 *  issueLinks: [
 *      link1,
 *      link2
 *  ],
 *  linkedIssueKeys: ['KEY-1', 'KEY-2'],
 *  linkedIssues: {
 *      'KEY-1': issue1,
 *      'KEY-2': issue2
 *  }
 * }
 */ const $2873248f5c677e12$var$issueLinksRootSelector = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities && entities.issueLinks);
const $2873248f5c677e12$export$a8cf8910b8314c1a = (0, $ahm5r.createSelector)($2873248f5c677e12$var$issueLinksRootSelector, (root)=>!!root);
const $2873248f5c677e12$var$linksDataSelector = (0, $ahm5r.createSelector)($2873248f5c677e12$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.issueLinks);
const $2873248f5c677e12$export$13978ee723866c4d = (state)=>state?.entities?.remoteIssueLinks?.remoteIssues || [];
const $2873248f5c677e12$export$819781ef7e99d6c7 = (0, $ahm5r.createSelector)($2873248f5c677e12$var$linksDataSelector, (issueLinks)=>issueLinks && (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(issueLinks, (link)=>link.isOptimistic));
const $2873248f5c677e12$var$linkedIssuesSelector = (0, $ahm5r.createSelector)($2873248f5c677e12$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.linkedIssues);
const $2873248f5c677e12$export$701dc165268e44de = (0, $ahm5r.createSelector)($2873248f5c677e12$var$issueLinksRootSelector, (issueLinks)=>issueLinks?.linkedIssueKeys || []);
const $2873248f5c677e12$export$3c65f67962ca81cc = (0, $ahm5r.createSelector)($2873248f5c677e12$var$linksDataSelector, (links)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(links));
const $2873248f5c677e12$export$8b1b2dfb6701d22c = (0, $ahm5r.createSelector)($2873248f5c677e12$var$linksDataSelector, $2873248f5c677e12$export$13978ee723866c4d, (links, remoteLinks)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(links) || !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(remoteLinks));
const $2873248f5c677e12$export$7e10bfdc67ac9362 = (0, $ahm5r.createSelector)($2873248f5c677e12$export$701dc165268e44de, $2873248f5c677e12$export$13978ee723866c4d, (links, remoteLinks)=>links.length + remoteLinks.length);
const $2873248f5c677e12$export$240ac27cfdcb3e34 = (0, $ahm5r.createSelector)($2873248f5c677e12$export$13978ee723866c4d, (remoteLinks)=>remoteLinks.length);
const $2873248f5c677e12$export$f9c1778e36ca60f9 = (0, $ahm5r.createSelector)($2873248f5c677e12$var$linksDataSelector, $2873248f5c677e12$var$linkedIssuesSelector, (0, $8fG6P.jpdDeliverLinkTypeIdSelector), (links, issues, jpdDeliverLinkTypeId)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(links)) return (0, (/*@__PURE__*/$parcel$interopDefault($8z5Vk)))(links).filter((link)=>!link.isDeleted && !!link.linkedIssueKey)// Filter out links with jpd delivery link typeId and direction === "OUTWARD" and they are displayed in separate Ideas section
    .filter($2873248f5c677e12$var$removeOutwardImplementsIdeaLinks(jpdDeliverLinkTypeId, issues)).map((link)=>({
            ...link,
            linkedIssue: issues[link.linkedIssueKey]
        })) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((linksMap, link)=>Object.assign(linksMap, {
            [link.typeName]: [
                ...linksMap[link.typeName] || [],
                link
            ]
        }), {});
    return null;
});
function $2873248f5c677e12$var$removeOutwardImplementsIdeaLinks(jpdDeliverLinkTypeId, issues) {
    return (link)=>{
        if (jpdDeliverLinkTypeId && (0, $7jTnu.fg)('jpd_idea_panel_in_issue_view')) {
            const isImplementsLink = link.typeId === jpdDeliverLinkTypeId;
            const isOutwardLink = link.direction === (0, $hpZaA.OUTWARD_LINK_DIRECTION);
            const isIdea = issues[link.linkedIssueKey]?.issueProjectType === (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT);
            if (isIdea && isImplementsLink && isOutwardLink) return false;
        }
        return true;
    };
}
const $2873248f5c677e12$export$a101eb6fc884a8a0 = (0, $ahm5r.createSelector)($2873248f5c677e12$export$f9c1778e36ca60f9, $2873248f5c677e12$export$13978ee723866c4d, (links, remoteIssues)=>{
    if (links == null && remoteIssues.length === 0) return null;
    const extractBasicIssueDetails = (remoteIssueLinkEntity)=>({
            id: remoteIssueLinkEntity.remoteIssueId,
            issueKey: remoteIssueLinkEntity.issueKey,
            issueLink: remoteIssueLinkEntity.issueLinkUrl,
            issueSummary: remoteIssueLinkEntity.summary,
            issueTypeIconUrl: remoteIssueLinkEntity.iconUrl
        });
    // FIXME: JIV-15410 - expected to return IssueLink[]
    return remoteIssues.reduce((combinedLinks, remoteIssue)=>{
        const { issueDetails: issueDetails, relationship: relationship, id: id, issueKey: issueKey, issueLinkUrl: issueLinkUrl, remoteIssueLinkError: remoteIssueLinkError, globalId: globalId, isSaved: isSaved, isLoading: isLoading, isOptimistic: isOptimistic, hasError: hasError, isDeleted: isDeleted } = remoteIssue;
        if (relationship != null && isDeleted !== true) return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...combinedLinks,
            [relationship]: [
                ...combinedLinks[relationship] || [],
                {
                    id: id.toString(),
                    direction: (0, $hpZaA.OUTWARD_LINK_DIRECTION),
                    typeName: relationship,
                    linkedIssueKey: issueKey,
                    linkedIssue: issueDetails || extractBasicIssueDetails(remoteIssue),
                    isRemote: true,
                    globalId: globalId,
                    remoteServerHostname: new URL(issueLinkUrl).hostname,
                    remoteIssueLinkError: remoteIssueLinkError,
                    isSaved: isSaved,
                    isLoading: isLoading,
                    isOptimistic: isOptimistic,
                    hasError: hasError
                }
            ]
        };
        return combinedLinks;
    }, {
        ...links
    });
});
const $2873248f5c677e12$export$b82f4900195f5854 = (issueLinkId)=>(0, $ahm5r.createSelector)($2873248f5c677e12$var$linksDataSelector, (links)=>links && links[issueLinkId] || null);
const $2873248f5c677e12$export$f5f26ceb5c86ee0 = (issueKey)=>(0, $ahm5r.createSelector)($2873248f5c677e12$var$linkedIssuesSelector, (linkedIssues)=>linkedIssues && linkedIssues[issueKey] || null);
const $2873248f5c677e12$export$d545d81c8e208408 = (0, $ahm5r.createSelector)($2873248f5c677e12$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClicked);
const $2873248f5c677e12$export$3bf48255064c85d5 = (0, $ahm5r.createSelector)($2873248f5c677e12$var$issueLinksRootSelector, (issueLinks)=>!!issueLinks?.isOpenedFromJsmSimilarIssues);
const $2873248f5c677e12$export$2c43c6abed5983de = (0, $ahm5r.createSelector)($2873248f5c677e12$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.quickAddClickedIssue);
const $2873248f5c677e12$export$5757979a0baa9c47 = (0, $ahm5r.createSelector)($2873248f5c677e12$export$d545d81c8e208408, (count)=>!!count);
const $2873248f5c677e12$export$34364f7190cff8a8 = (0, $ahm5r.createSelector)($2873248f5c677e12$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.triggeredViaHotKey);
const $2873248f5c677e12$export$eea0e617974abf06 = (0, $ahm5r.createSelector)($2873248f5c677e12$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.aiLinkedIssueSuggestion);
const $2873248f5c677e12$export$99914e520087b170 = (0, $ahm5r.createSelector)($2873248f5c677e12$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.canCreateLinkedIssue);
const $2873248f5c677e12$export$652fb627bb2f46f3 = (0, $ahm5r.createSelector)($2873248f5c677e12$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.refreshTimestamp);
const $2873248f5c677e12$export$cc6bc2a796dd3df5 = (0, $ahm5r.createSelector)($2873248f5c677e12$var$issueLinksRootSelector, (issueLinks)=>issueLinks && issueLinks.addRelatedWorkItemTriggerSource);

});
parcelRegister("8z5Vk", function(module, exports) {

var $g60Jt = parcelRequire("g60Jt");

var $k4ZVz = parcelRequire("k4ZVz");

var $PodIB = parcelRequire("PodIB");

var $7H30b = parcelRequire("7H30b");

var $l5Z0K = parcelRequire("l5Z0K");

var $1mlOE = parcelRequire("1mlOE");

var $fy1iF = parcelRequire("fy1iF");

var $dFsAP = parcelRequire("dFsAP");

var $gsm7J = parcelRequire("gsm7J");

var $40zJW = parcelRequire("40zJW");
/** `Object#toString` result references. */ var $63c62ff2f285be0d$var$mapTag = '[object Map]', $63c62ff2f285be0d$var$setTag = '[object Set]';
/** Built-in value references. */ var $63c62ff2f285be0d$var$symIterator = $g60Jt ? $g60Jt.iterator : undefined;
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $63c62ff2f285be0d$var$toArray(value) {
    if (!value) return [];
    if ($7H30b(value)) return $l5Z0K(value) ? $gsm7J(value) : $k4ZVz(value);
    if ($63c62ff2f285be0d$var$symIterator && value[$63c62ff2f285be0d$var$symIterator]) return $1mlOE(value[$63c62ff2f285be0d$var$symIterator]());
    var tag = $PodIB(value), func = tag == $63c62ff2f285be0d$var$mapTag ? $fy1iF : tag == $63c62ff2f285be0d$var$setTag ? $dFsAP : $40zJW;
    return func(value);
}
module.exports = $63c62ff2f285be0d$var$toArray;

});
parcelRegister("1mlOE", function(module, exports) {
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $0fd8c4bc0ad397b0$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
module.exports = $0fd8c4bc0ad397b0$var$iteratorToArray;

});


parcelRegister("hpZaA", function(module, exports) {

$parcel$export(module.exports, "INWARD_LINK_DIRECTION", () => $31b15a5efa4d3128$export$b5e2b68b0fa7f1c8);
$parcel$export(module.exports, "OUTWARD_LINK_DIRECTION", () => $31b15a5efa4d3128$export$5dec99d71ec794ba);
$parcel$export(module.exports, "BOTH_LINK_DIRECTION", () => $31b15a5efa4d3128$export$6cdcf74878b11d34);
$parcel$export(module.exports, "IssueLinkDirectionTypes", () => $31b15a5efa4d3128$export$4b7bcc27238c61b9);
const $31b15a5efa4d3128$export$b5e2b68b0fa7f1c8 = 'INWARD';
const $31b15a5efa4d3128$export$5dec99d71ec794ba = 'OUTWARD';
const $31b15a5efa4d3128$export$6cdcf74878b11d34 = 'BOTH';
const $31b15a5efa4d3128$export$4b7bcc27238c61b9 = {
    [$31b15a5efa4d3128$export$b5e2b68b0fa7f1c8]: $31b15a5efa4d3128$export$b5e2b68b0fa7f1c8,
    [$31b15a5efa4d3128$export$5dec99d71ec794ba]: $31b15a5efa4d3128$export$5dec99d71ec794ba,
    [$31b15a5efa4d3128$export$6cdcf74878b11d34]: $31b15a5efa4d3128$export$6cdcf74878b11d34
};

});

parcelRegister("8fG6P", function(module, exports) {

$parcel$export(module.exports, "jpdDeliverLinkTypeIdSelector", () => $1fdba796edaa2f24$export$c25a0be5d19458d3);

var $ahm5r = parcelRequire("ahm5r");

var $6az7p = parcelRequire("6az7p");
const $1fdba796edaa2f24$export$c25a0be5d19458d3 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.jpdDeliveryIssueLinkTypeId);

});


parcelRegister("l7OhZ", function(module, exports) {

$parcel$export(module.exports, "issueTypesSelector", () => $4ce8df68e83137cf$export$f5378064bf877b95);
$parcel$export(module.exports, "hasUnsupportedType", () => $4ce8df68e83137cf$export$1f59505fa2d77635);
$parcel$export(module.exports, "issueTypesForClassicProjectEpicSelector", () => $4ce8df68e83137cf$export$a0efcb09d3e23dc1);
$parcel$export(module.exports, "fetchIssueTypesStatusSelector", () => $4ce8df68e83137cf$export$bfbb65ccb13a16eb);

var $ahm5r = parcelRequire("ahm5r");

var $8dH3d = parcelRequire("8dH3d");

var $6az7p = parcelRequire("6az7p");

var $4372d = parcelRequire("4372d");
const $4ce8df68e83137cf$export$f5378064bf877b95 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.issueTypes);
// A collection of issue fields which are marked as `required`
// for the creation of an issue, but are considered as 'provided' since
// the data for these fields is supplied by JIRA.
const $4ce8df68e83137cf$var$providedRequiredFields = [
    'summary',
    'issuetype',
    'parent',
    'project'
];
const $4ce8df68e83137cf$var$isRequiredFieldProvided = (fieldName)=>$4ce8df68e83137cf$var$providedRequiredFields.find((providedFieldName)=>fieldName === providedFieldName);
// A field is considered 'unsupported' if not provided by JIRA,
// has no default value, and is a `required` field.
const $4ce8df68e83137cf$var$hasUnsupportedRequiredField = (fields)=>// @ts-expect-error - TS2769 - No overload matches this call.
    !!Object.keys(fields).find((fieldName)=>!$4ce8df68e83137cf$var$isRequiredFieldProvided(fieldName) && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        !fields[fieldName].hasDefaultValue && // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        fields[fieldName].required);
const $4ce8df68e83137cf$export$1f59505fa2d77635 = (issueType)=>(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(issueType.fields) || $4ce8df68e83137cf$var$hasUnsupportedRequiredField(issueType.fields);
const $4ce8df68e83137cf$export$a0efcb09d3e23dc1 = (0, $ahm5r.createSelector)($4ce8df68e83137cf$export$f5378064bf877b95, (0, $4372d.issueTypeSelector), (0, $6az7p.isEpicSelector), (issueTypes, currentIssueType, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isCurrentIssueAnEpic)=>{
    const epicIssueTypeId = isCurrentIssueAnEpic && currentIssueType && currentIssueType.id;
    return issueTypes.filter(// @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'number' and 'string | boolean | undefined' have no overlap.
    (issueType)=>!issueType.subtask && issueType.id !== epicIssueTypeId);
});
const $4ce8df68e83137cf$export$bfbb65ccb13a16eb = (0, $ahm5r.createSelector)((0, $6az7p.uiSelector), (ui)=>ui.fetchIssueTypesStatus);

});

parcelRegister("dzwJE", function(module, exports) {

$parcel$export(module.exports, "subtaskTypesSelector", () => $bbdf012e2b41060c$export$86a4f97fc27a0c44);
$parcel$export(module.exports, "isSubtaskTypesPresentSelector", () => $bbdf012e2b41060c$export$9a147dcac364dd81);
$parcel$export(module.exports, "hasUnsupportedTypeSelector", () => $bbdf012e2b41060c$export$3fbfbdcf57f34c2);

var $ahm5r = parcelRequire("ahm5r");

var $l7OhZ = parcelRequire("l7OhZ");
const $bbdf012e2b41060c$export$86a4f97fc27a0c44 = (0, $ahm5r.createSelector)((0, $l7OhZ.issueTypesSelector), (issueTypes)=>issueTypes.filter((type)=>type.subtask));
const $bbdf012e2b41060c$export$9a147dcac364dd81 = (0, $ahm5r.createSelector)($bbdf012e2b41060c$export$86a4f97fc27a0c44, (subtaskTypes)=>subtaskTypes.length >= 1);
const $bbdf012e2b41060c$export$3fbfbdcf57f34c2 = (0, $ahm5r.createSelector)($bbdf012e2b41060c$export$86a4f97fc27a0c44, (subtaskTypes)=>!!subtaskTypes.find((0, $l7OhZ.hasUnsupportedType)));

});

parcelRegister("8mcrY", function(module, exports) {

$parcel$export(module.exports, "isSubtaskSelector", () => $d35ae6625d4cba73$export$15fea4741156936);
$parcel$export(module.exports, "subtaskEntitiesSelector", () => $d35ae6625d4cba73$export$17e529874841c746);
$parcel$export(module.exports, "hasSubtasksSelector", () => $d35ae6625d4cba73$export$f363078714850fd9);
$parcel$export(module.exports, "canCreateSubtaskSelector", () => $d35ae6625d4cba73$export$151aaebeef1cfe63);

var $ahm5r = parcelRequire("ahm5r");

var $7jTnu = parcelRequire("7jTnu");


var $8oOr4 = parcelRequire("8oOr4");

var $5EgB1 = parcelRequire("5EgB1");

var $6t0ps = parcelRequire("6t0ps");

var $6az7p = parcelRequire("6az7p");

var $GhTyR = parcelRequire("GhTyR");

var $5v1zn = parcelRequire("5v1zn");

var $aRxHj = parcelRequire("aRxHj");

var $4372d = parcelRequire("4372d");

var $6Z7vV = parcelRequire("6Z7vV");

var $dzwJE = parcelRequire("dzwJE");
const $d35ae6625d4cba73$export$15fea4741156936 = (0, $ahm5r.createSelector)((0, $4372d.issueTypeSelector), (issueType)=>!!(issueType && issueType.subtask));
const $d35ae6625d4cba73$export$17e529874841c746 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.subtasks || []);
const $d35ae6625d4cba73$export$f363078714850fd9 = (0, $ahm5r.createSelector)($d35ae6625d4cba73$export$17e529874841c746, (0, $6t0ps.childIssuesLimitUrlSelector), (subtasks, getChildIssuesLimitUrl)=>subtasks.length > 0 || Boolean(getChildIssuesLimitUrl((0, $8oOr4.SUBTASKS))));
const $d35ae6625d4cba73$export$899afcd59181acbb = (0, $ahm5r.createSelector)((0, $6az7p.isSimplifiedProjectSelector), (0, $aRxHj.isIssueBaseLevel), (0, $5v1zn.hasChildrenIssuesSelector), $d35ae6625d4cba73$export$f363078714850fd9, (isSimplifiedProject, issueBaseLevel, hasChildrenIssues, hasSubtasks)=>isSimplifiedProject ? issueBaseLevel && hasChildrenIssues : hasSubtasks);
const $d35ae6625d4cba73$export$58b46fbc7ab224f6 = (0, $ahm5r.createSelector)((0, $dzwJE.hasUnsupportedTypeSelector), (0, $6Z7vV.projectHasSubtaskValidatorsSelector), (hasRequiredFields, hasSubtaskValidators)=>hasRequiredFields || hasSubtaskValidators);
const $d35ae6625d4cba73$export$94f22e5d109e9b04 = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), ({ jiraSettings: jiraSettings })=>jiraSettings?.subtasksConfiguration?.enabled);
const $d35ae6625d4cba73$export$151aaebeef1cfe63 = (0, $ahm5r.createSelector)((0, $GhTyR.permissionsSelector), $d35ae6625d4cba73$export$15fea4741156936, (0, $dzwJE.isSubtaskTypesPresentSelector), $d35ae6625d4cba73$export$58b46fbc7ab224f6, (0, $5EgB1.isMobileSelector), (0, $5EgB1.isBitbucketSelector), (0, $5EgB1.isServiceDeskSelector), (0, $6az7p.isSimplifiedProjectSelector), $d35ae6625d4cba73$export$94f22e5d109e9b04, (0, $6az7p.projectSelector), (0, $aRxHj.isIssueBaseLevel), ({ canCreateSubtask: canCreateSubtaskPermission }, isSubtask, typesPresent, shouldUseFallbackDialog, isMobile, isBitbucket, isServicedesk, isSimplified, subtasksEnabled, project, issueBaseLevel)=>{
    const canCreateSubtask = (0, $7jTnu.fg)('issue-jiv-20971-remove-subtask-quick-add') ? canCreateSubtaskPermission && issueBaseLevel : canCreateSubtaskPermission;
    const shouldHideForMobileOrBitbucket = shouldUseFallbackDialog ? isMobile || isBitbucket : false;
    const isProjectActive = (project?.projectStatus ?? (0, $9ac759e54cf0eba0$export$62113557945f790a)) === (0, $9ac759e54cf0eba0$export$62113557945f790a);
    const shouldShowSubtask = isServicedesk ? !isSimplified : true;
    return !!(canCreateSubtask && !isSubtask && typesPresent && !shouldHideForMobileOrBitbucket && shouldShowSubtask && subtasksEnabled && isProjectActive);
});

});
parcelRegister("5v1zn", function(module, exports) {

$parcel$export(module.exports, "hasChildrenIssuesSelector", () => $9a3e5c2d7cd31882$export$29f34d4d7c528e9c);

var $ahm5r = parcelRequire("ahm5r");

var $8dH3d = parcelRequire("8dH3d");

var $814y1 = parcelRequire("814y1");

var $6t0ps = parcelRequire("6t0ps");
const $9a3e5c2d7cd31882$var$childrenIssueSelector = (0, $6t0ps.fieldSelector)((0, $814y1.CHILDREN_ISSUES));
const $9a3e5c2d7cd31882$export$29f34d4d7c528e9c = (0, $ahm5r.createSelector)($9a3e5c2d7cd31882$var$childrenIssueSelector, (0, $6t0ps.childIssuesLimitUrlSelector), (childrenIssues, getChildIssuesLimitUrl)=>childrenIssues ? !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(childrenIssues.value) || Boolean(getChildIssuesLimitUrl((0, $814y1.CHILDREN_ISSUES))) : false);

});

parcelRegister("6Z7vV", function(module, exports) {

$parcel$export(module.exports, "projectHasSubtaskValidatorsSelector", () => $835beb127742780b$export$ecfed315b19a7565);

var $ahm5r = parcelRequire("ahm5r");

const $835beb127742780b$var$hasSubtaskValidators = (hasValidators)=>hasValidators.status === (0, $3cee3989e6e8e2be$export$4c02edeb1b5e410a) && hasValidators.value;
const $835beb127742780b$var$unknown = (hasValidators)=>hasValidators.status === (0, $3cee3989e6e8e2be$export$26d55645375ca9a) || hasValidators.status === (0, $3cee3989e6e8e2be$export$d71930f7f5807a72);
const $835beb127742780b$export$ecfed315b19a7565 = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.validators, (validators)=>{
    const val = validators.projectHasSubtaskValidators;
    return $835beb127742780b$var$hasSubtaskValidators(val) || $835beb127742780b$var$unknown(val);
});

});
const $3cee3989e6e8e2be$export$26d55645375ca9a = 'LOADING';
const $3cee3989e6e8e2be$export$d71930f7f5807a72 = 'FAILED';
const $3cee3989e6e8e2be$export$4c02edeb1b5e410a = 'LOADED';



parcelRegister("i2dM3", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $0bf8338bd3451c62$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $0bf8338bd3451c62$export$df36fc05622c402);
$parcel$export(module.exports, "PermalinkType", () => $0bf8338bd3451c62$export$b18d061fc042df1a);
const $0bf8338bd3451c62$export$4cab9dfa8fc858f4 = 'Comments';
const $0bf8338bd3451c62$export$df36fc05622c402 = 'Worklog';
const $0bf8338bd3451c62$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};

});

parcelRegister("9c4a4", function(module, exports) {

$parcel$export(module.exports, "getPermalinkTypeAndId", () => $336c03e190876947$export$f72cac1fa8a03e80);
$parcel$export(module.exports, "getPermalinkStatus", () => $336c03e190876947$export$f79ae8c396759c89);
$parcel$export(module.exports, "getUrlPermalinkParameter", () => $336c03e190876947$export$b66f3e03c722c21c);
$parcel$export(module.exports, "COMMENTS", () => (parcelRequire("i2dM3")).COMMENTS);
$parcel$export(module.exports, "PermalinkType", () => (parcelRequire("i2dM3")).PermalinkType);

var $LFmXM = parcelRequire("LFmXM");

var $b5RwB = parcelRequire("b5RwB");

var $gRw8I = parcelRequire("gRw8I");

var $i2dM3 = parcelRequire("i2dM3");
const $336c03e190876947$export$58d3deae755361f = (0, $LFmXM.default)((searchString)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parseUrl(searchString).query;
    if (params[(0, $i2dM3.PermalinkType).COMMENTS]) return {
        permalinkType: (0, $i2dM3.COMMENTS),
        permalinkId: params[(0, $i2dM3.PermalinkType).COMMENTS]
    };
    if (params[(0, $i2dM3.PermalinkType).WORKLOG]) return {
        permalinkType: (0, $i2dM3.WORKLOG),
        permalinkId: params[(0, $i2dM3.PermalinkType).WORKLOG]
    };
    return null;
});
const $336c03e190876947$export$f72cac1fa8a03e80 = ()=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return $336c03e190876947$export$58d3deae755361f(window.location.search);
};
const $336c03e190876947$export$f79ae8c396759c89 = (targetPermalinkType)=>{
    const { permalinkId: permalinkId, permalinkType: permalinkType } = $336c03e190876947$export$f72cac1fa8a03e80() || {};
    const hasPermalink = permalinkType === targetPermalinkType && permalinkId != null;
    return {
        hasPermalink: hasPermalink,
        permalinkId: hasPermalink ? permalinkId : ''
    };
};
const $336c03e190876947$export$b66f3e03c722c21c = (id, permalinkType)=>{
    (0, $gRw8I.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const pathName = window.location.pathname;
    let urlQueryParam = `?${permalinkType}=${id}`;
    // in backlogs/modal view, next-gen board view, or jsd queues view
    if (/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/.test(pathName) || /\/jira\/people\/.*\/boards\/.*/.test(pathName) || pathName === '/secure/RapidBoard.jspa' || pathName.startsWith('/jira/software/projects/') && pathName.split('/')[5] === 'boards' || pathName.startsWith('/jira/servicedesk/projects/') && pathName.split('/')[5] === 'queues') {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const url = new URL(window.location.href);
        // delete the opposite to avoid doubling up param in url
        url.searchParams.delete(permalinkType === (0, $i2dM3.PermalinkType).WORKLOG ? (0, $i2dM3.PermalinkType).COMMENTS : (0, $i2dM3.PermalinkType).WORKLOG);
        url.searchParams.set(permalinkType, id);
        urlQueryParam = url.search;
    }
    return urlQueryParam;
};

});


parcelRegister("875lj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1659875632871206$export$2e2bcd8739ae039);
class $1659875632871206$export$2e2bcd8739ae039 {
    constructor(state){
        this.hasLoadedEditor = false;
        this.startTime = Math.floor(performance.now()) // start time in origin relative  millis
        ;
        this.immutableState = state;
        this.isLoadedWithPage = state.isLoadedWithPage;
    }
    lazyMetricsProps() {
        return this.immutableState.lazyMetricsProps;
    }
    getDataProvider() {
        return this.immutableState.dataProvider;
    }
    getIsFullIssue() {
        return this.immutableState.analyticsSource === 'full-issue';
    }
    getIsLoadedWithPage() {
        return this.immutableState.isLoadedWithPage;
    }
    setIsLoadedWithPage(newValue) {
        this.isLoadedWithPage = newValue;
    }
    getIsSPA() {
        return this.immutableState.isSPA;
    }
    getIsRecentIssue() {
        return this.immutableState.isRecentIssue;
    }
    getRecentIssuesCount() {
        return this.immutableState.recentIssuesCount;
    }
    getAnalyticsSource() {
        return this.immutableState.analyticsSource;
    }
    getCorrelationId() {
        return this.immutableState.correlationId;
    }
    getIssueScaleabilityReporter() {
        return this.immutableState.issueScaleabilityReporter;
    }
    getStartTime() {
        return this.startTime;
    }
    setPreviewEnd(end) {
        this.previewEnd = end === null ? 0 : Math.floor(end);
    }
    getPreviewEnd() {
        return this.previewEnd;
    }
    setFMP(end) {
        this.fmp = end === null ? 0 : Math.floor(end);
    }
    getFMP() {
        return this.fmp;
    }
    setInteractiveEnd(millisSinceEpoch) {
        this.interactiveEnd = millisSinceEpoch;
    }
    getInteractiveEnd() {
        return this.interactiveEnd;
    }
    setTrueInteractiveEnd(millisSinceEpoch) {
        this.trueInteractiveEnd = Math.floor(millisSinceEpoch);
    }
    getTrueInteractiveEnd() {
        return Math.floor(this.trueInteractiveEnd);
    }
    getHasLoadedEditor() {
        return this.hasLoadedEditor;
    }
    getIsInitial() {
        return this.getIsFullIssue() && !this.getIsSPA();
    }
    getLocation() {
        const { route: route } = this.immutableState;
        const routeName = route?.name;
        return routeName || '';
    }
}

});

parcelRegister("16KLp", function(module, exports) {

$parcel$export(module.exports, "metricsStateSelector", () => $9f8fb20e3780a629$export$8cfb2e5f509cb762);

var $ahm5r = parcelRequire("ahm5r");

var $gt8Cn = parcelRequire("gt8Cn");

var $5EgB1 = parcelRequire("5EgB1");
const $9f8fb20e3780a629$export$8cfb2e5f509cb762 = (0, $ahm5r.createSelector)((0, $5EgB1.applicationKeySelector), (0, $5EgB1.viewModeSelector), (0, $5EgB1.issueIdSelector), (analyticsKey, viewMode, issueId)=>({
        analyticsKey: analyticsKey,
        viewMode: (0, $gt8Cn.getSafeViewMode)(viewMode),
        issueId: issueId
    }));

});
parcelRegister("gt8Cn", function(module, exports) {

$parcel$export(module.exports, "getSafeViewMode", () => $6888b58377aa1342$export$abc152b4d639d329);

var $dnU6V = parcelRequire("dnU6V");

var $7jTnu = parcelRequire("7jTnu");
const $6888b58377aa1342$var$localStorageProvider = (0, $dnU6V.createLocalStorageProvider)('', false);
const $6888b58377aa1342$var$getViewMode = ()=>{
    if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) return $6888b58377aa1342$var$localStorageProvider.get('gh.ghx-issue-fragment-view-mode') || 'default';
    if (typeof window !== 'undefined') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window?.localStorage?.getItem('gh.ghx-issue-fragment-view-mode') || 'default';
    return 'default';
};
const $6888b58377aa1342$var$mapPredefinedViewMode = (predefinedViewMode)=>{
    switch(predefinedViewMode){
        case 'MODAL':
            return 'modal';
        case 'SIDEBAR':
            return 'sidebar';
        default:
            return null;
    }
};
const $6888b58377aa1342$export$abc152b4d639d329 = (predefinedViewMode = null)=>$6888b58377aa1342$var$mapPredefinedViewMode(predefinedViewMode) || $6888b58377aa1342$var$getViewMode().replace(/"/g, '');

});



parcelRegister("iZ3n7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4eab800e8296ee9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $BwaQq = parcelRequire("BwaQq");

var $eSnSE = parcelRequire("eSnSE");

var $bi9FK = parcelRequire("bi9FK");

var $d6KFY = parcelRequire("d6KFY");

var $cAi7d = parcelRequire("cAi7d");

var $7j7HJ = parcelRequire("7j7HJ");

var $ftN6c = parcelRequire("ftN6c");

var $2wyE1 = parcelRequire("2wyE1");

var $kgX9J = parcelRequire("kgX9J");

var $iE9gv = parcelRequire("iE9gv");

var $ljej9 = parcelRequire("ljej9");

var $RJGWc = parcelRequire("RJGWc");

var $bQWwW = parcelRequire("bQWwW");

var $83DiZ = parcelRequire("83DiZ");
const $b4eab800e8296ee9$var$isEcClientEnabled = ()=>{
    const experiences = (0, $bi9FK.getFeatureFlagValue)('hela.ec.client.integration.jsm', '').split(',');
    return Array.isArray(experiences) && experiences.includes('jsm-issue-view');
};

const $b4eab800e8296ee9$export$8c70dcc4643464f8 = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("gbKcf")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $b4eab800e8296ee9$export$5aebed4b5cba826a = ({ backButtonUrl: backButtonUrl, issueNavigatorData: issueNavigatorData, issueKey: issueKey, onDispatchExternalActionRef: onDispatchExternalActionRef, onIssueDeleteSuccess: onIssueDeleteSuccess, analyticsSource: analyticsSource, ServiceDeskAnalyticsContext: ServiceDeskAnalyticsContext = (0, $2wyE1.ServiceDeskAnalyticsContext) })=>{
    const routerActions = (0, $83DiZ.useRouterActions)();
    const [selectedIssueKey, setIssueKey] = (0, $RJGWc.useQueryParam)('selectedIssue');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let saveIssueMutationToCache;
    if ($b4eab800e8296ee9$var$isEcClientEnabled()) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    saveIssueMutationToCache = (0, $7j7HJ.useEcClient)().saveIssueMutationToCache;
    const onIssueKeyChange = (data)=>{
        setIssueKey(data.toIssueKey);
        (0, $eSnSE.default).safeInfoWithoutCustomerData('jsm.issue.view.issue-key-change', 'Invalid issue key, redirecting to correct issue key');
        routerActions.push(`/browse/${data.toIssueKey}`);
    };
    const onChangeHandler = (event)=>{
        (0, $kgX9J.saveIssueMutationAnalyticsToCache)(event, createAnalyticsEvent, saveIssueMutationToCache);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iE9gv.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ServiceDeskAnalyticsContext, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d6KFY.IssueBoundary), {
        packageName: "servicedesk-issue-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b4eab800e8296ee9$export$8c70dcc4643464f8, {
        onClose: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        analyticsSource: analyticsSource,
        backButtonUrl: backButtonUrl,
        dispatchExternalActionRef: onDispatchExternalActionRef,
        shouldSetInitialFocus: true,
        isLoadedWithPage: true,
        issueKey: (0, $ljej9.toIssueKey)(selectedIssueKey) || issueKey,
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        onIssueKeyChange: onIssueKeyChange,
        issueMaxWidth: (0, $cAi7d.getIssueContainerIncreasedMaxWidth)(),
        onChange: onChangeHandler,
        issueNavigatorData: issueNavigatorData
    }))));
};
const $b4eab800e8296ee9$var$getAnalyticsSourceFromUrl = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    if (pathname.includes('reports')) return 'viewReportIssue';
    return 'viewQueueIssue';
};
const $b4eab800e8296ee9$var$WrappedIssueView = (0, $BwaQq.AnalyticsSource)($b4eab800e8296ee9$var$getAnalyticsSourceFromUrl(), (0, $466f60259c330878$export$f636b5b56f1d624a))($b4eab800e8296ee9$export$5aebed4b5cba826a);
const $b4eab800e8296ee9$var$IssueViewContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b4eab800e8296ee9$var$WrappedIssueView, props);
var $b4eab800e8296ee9$export$2e2bcd8739ae039 = $b4eab800e8296ee9$var$IssueViewContainer;

});
parcelRegister("cAi7d", function(module, exports) {

$parcel$export(module.exports, "defaultRatioRightColumn", () => $0da79e0203f5a4fb$export$7fec582ac43ca9da);
$parcel$export(module.exports, "largeScreenRatioRightColumn", () => $0da79e0203f5a4fb$export$28d7967aa38f2f87);
$parcel$export(module.exports, "activitySidePanelRatio", () => $0da79e0203f5a4fb$export$6695481d80b63521);
$parcel$export(module.exports, "getIssueContainerIncreasedMaxWidth", () => $0da79e0203f5a4fb$export$9d883719bd435511);
$parcel$export(module.exports, "ACTIVITY_SIDE_PANEL_MIN_WIDTH", () => $0da79e0203f5a4fb$export$dd2feff7666e1f68);
$parcel$export(module.exports, "FOUNDATION_CONTENT", () => $0da79e0203f5a4fb$export$7bcdea276f4ac481);
$parcel$export(module.exports, "FOUNDATION_CONTEXT", () => $0da79e0203f5a4fb$export$c38319160cd2937e);
$parcel$export(module.exports, "CONTEXT_ITEMS", () => $0da79e0203f5a4fb$export$7f5a9695169a6da5);
$parcel$export(module.exports, "CONTEXT_ITEMS_EXT_ID", () => $0da79e0203f5a4fb$export$68f17674e93281a4);
$parcel$export(module.exports, "META_CONTAINER", () => $0da79e0203f5a4fb$export$b43fa3c8b66b1c94);
$parcel$export(module.exports, "CONTENT_ITEMS", () => $0da79e0203f5a4fb$export$1ee33ca26b566d0e);
$parcel$export(module.exports, "FOOTNOTE_WRAPPER_KEY", () => $0da79e0203f5a4fb$export$4001e6a77d93abe8);
$parcel$export(module.exports, "ACTIVITY_FEED", () => $0da79e0203f5a4fb$export$712b9c1c9915e523);
$parcel$export(module.exports, "ACTIVITY_FEED_EXT_ID", () => $0da79e0203f5a4fb$export$1c0b3c6e6d8046ea);
$parcel$export(module.exports, "CONFIGURE_FIELDS", () => $0da79e0203f5a4fb$export$c26f2f0247dbba77);
const $0da79e0203f5a4fb$export$7fec582ac43ca9da = 0.35;
const $0da79e0203f5a4fb$export$28d7967aa38f2f87 = 0.4;
const $0da79e0203f5a4fb$export$6695481d80b63521 = 0.4;
const $0da79e0203f5a4fb$export$7fe9ac2b6449f553 = ()=>1680;
const $0da79e0203f5a4fb$export$9d883719bd435511 = ()=>1920;
const $0da79e0203f5a4fb$export$dd2feff7666e1f68 = 400;
const $0da79e0203f5a4fb$export$7bcdea276f4ac481 = 'FOUNDATION_CONTENT';
const $0da79e0203f5a4fb$export$c38319160cd2937e = 'FOUNDATION_CONTEXT';
const $0da79e0203f5a4fb$export$7f4af5d0ba6f3e18 = 'QUICK_ADD_ITEMS';
const $0da79e0203f5a4fb$export$7f5a9695169a6da5 = 'CONTEXT_ITEMS';
const $0da79e0203f5a4fb$export$68f17674e93281a4 = 'issue.context-items';
const $0da79e0203f5a4fb$export$b43fa3c8b66b1c94 = 'META_CONTAINER';
const $0da79e0203f5a4fb$export$1ee33ca26b566d0e = 'CONTENT_ITEMS';
const $0da79e0203f5a4fb$export$4001e6a77d93abe8 = 'FOOTNOTE_WRAPPER_KEY';
const $0da79e0203f5a4fb$export$712b9c1c9915e523 = 'ACTIVITY_FEED';
const $0da79e0203f5a4fb$export$1c0b3c6e6d8046ea = 'issue.activity-feed';
const $0da79e0203f5a4fb$export$c26f2f0247dbba77 = 'CONFIGURE_FIELDS';

});

parcelRegister("iE9gv", function(module, exports) {

$parcel$export(module.exports, "default", () => $270b3cda1344582e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7zg1G = parcelRequire("7zg1G");
const $270b3cda1344582e$export$e809a659e11e6855 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7zg1G.FullPageIssueContainer), null, props.children);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$270b3cda1344582e$export$2e2bcd8739ae039 = ({ ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($270b3cda1344582e$export$e809a659e11e6855, rest);

});
parcelRegister("7zg1G", function(module, exports) {

$parcel$export(module.exports, "FullPageIssueContainer", () => $1b6fd7b29ffbe005$export$f4550b4a355415eb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $1b6fd7b29ffbe005$export$f4550b4a355415eb = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("RJGWc", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $65c863447b82163c$export$ae316f0eeb712a36);

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $4lYQk = parcelRequire("4lYQk");

var $b5RwB = parcelRequire("b5RwB");

var $gCY1z = parcelRequire("gCY1z");
const $65c863447b82163c$export$ae316f0eeb712a36 = (queryParam)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $gCY1z.useRouter)();
    const queryParamValue = query[queryParam];
    const setQueryParam = (0, $eJOHy.useCallback)((newValue)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
            ...query,
            [queryParam]: newValue
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value));
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(parsedSearch);
        push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
    }, [
        pathname,
        push,
        query,
        queryParam
    ]);
    return [
        queryParamValue,
        setQueryParam
    ];
};

});




parcelRegister("17w9g", function(module, exports) {

$parcel$export(module.exports, "useIssueKeys", () => $06173e4c44ddd3c3$export$a5d72277eb099991);
$parcel$export(module.exports, "useIssueCount", () => $06173e4c44ddd3c3$export$46e5b5ae2bb3cba6);
$parcel$export(module.exports, "useSetIssueKeys", () => $06173e4c44ddd3c3$export$4c934a43e5a2e69f);
$parcel$export(module.exports, "useSetIssueCount", () => $06173e4c44ddd3c3$export$adb76aa457e20fd1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $06173e4c44ddd3c3$var$initialState = {
    issueKeys: [],
    issueCount: 0
};
const $06173e4c44ddd3c3$var$actions = {
    setIssueKeys: (issueKeys)=>({ setState: setState })=>{
            setState({
                issueKeys: issueKeys
            });
        },
    setIssueCount: (issueCount)=>({ setState: setState })=>{
            setState({
                issueCount: issueCount
            });
        }
};
const $06173e4c44ddd3c3$var$store = (0, $GtRbT.createStore)({
    initialState: $06173e4c44ddd3c3$var$initialState,
    actions: $06173e4c44ddd3c3$var$actions,
    name: 'queues-issuelist-store'
});
const $06173e4c44ddd3c3$export$a5d72277eb099991 = (0, $iJq0l.createStateHook)($06173e4c44ddd3c3$var$store, {
    selector: (state)=>state.issueKeys
});
const $06173e4c44ddd3c3$export$46e5b5ae2bb3cba6 = (0, $iJq0l.createStateHook)($06173e4c44ddd3c3$var$store, {
    selector: (state)=>state.issueCount
});
const $06173e4c44ddd3c3$var$useStoreActions = (0, $iJq0l.createActionsHook)($06173e4c44ddd3c3$var$store);
const $06173e4c44ddd3c3$export$4c934a43e5a2e69f = ()=>$06173e4c44ddd3c3$var$useStoreActions().setIssueKeys;
const $06173e4c44ddd3c3$export$adb76aa457e20fd1 = ()=>$06173e4c44ddd3c3$var$useStoreActions().setIssueCount;

});



//# sourceMappingURL=async-servicedesk-queues-agent-and-issue-view.43bdd52b.js.map
